(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2e79"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2e79"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4cMNx", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $30fe22aa5392ee8d$export$ffb0004e005737fa; }, function (v) { return $30fe22aa5392ee8d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $30fe22aa5392ee8d$export$34b9dba7ce09269b; }, function (v) { return $30fe22aa5392ee8d$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $30fe22aa5392ee8d$export$25062201e9e25d76; }, function (v) { return $30fe22aa5392ee8d$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $30fe22aa5392ee8d$export$ffb0004e005737fa;
var $30fe22aa5392ee8d$export$34b9dba7ce09269b;
var $30fe22aa5392ee8d$export$25062201e9e25d76;
"use strict";
var $30fe22aa5392ee8d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $30fe22aa5392ee8d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $30fe22aa5392ee8d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $30fe22aa5392ee8d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$30fe22aa5392ee8d$export$ffb0004e005737fa = $30fe22aa5392ee8d$var$REACT_FRAGMENT_TYPE;
$30fe22aa5392ee8d$export$34b9dba7ce09269b = $30fe22aa5392ee8d$var$jsxProd;
$30fe22aa5392ee8d$export$25062201e9e25d76 = $30fe22aa5392ee8d$var$jsxProd;

});

parcelRegister("5s1kH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2s3Oh"));

});
parcelRegister("2s3Oh", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $1c9126e4e799e7d9$export$9c16c1426311996d; }, function (v) { return $1c9126e4e799e7d9$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $1c9126e4e799e7d9$export$dca3b0875bd9a954; }, function (v) { return $1c9126e4e799e7d9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $1c9126e4e799e7d9$export$16fa2f45be04daa8; }, function (v) { return $1c9126e4e799e7d9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1c9126e4e799e7d9$export$ffb0004e005737fa; }, function (v) { return $1c9126e4e799e7d9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $1c9126e4e799e7d9$export$e2c29f18771995cb; }, function (v) { return $1c9126e4e799e7d9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $1c9126e4e799e7d9$export$221d75b3f55bb0bd; }, function (v) { return $1c9126e4e799e7d9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1c9126e4e799e7d9$export$5f8d39834fd61797; }, function (v) { return $1c9126e4e799e7d9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1c9126e4e799e7d9$export$74bf444e3cd11ea5; }, function (v) { return $1c9126e4e799e7d9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $1c9126e4e799e7d9$export$1ced07cd6b1985ce; }, function (v) { return $1c9126e4e799e7d9$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $1c9126e4e799e7d9$export$abd8e32b826d7ea7; }, function (v) { return $1c9126e4e799e7d9$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $1c9126e4e799e7d9$export$69a3209f1a06c04d; }, function (v) { return $1c9126e4e799e7d9$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $1c9126e4e799e7d9$export$8c538325882c7eec; }, function (v) { return $1c9126e4e799e7d9$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $1c9126e4e799e7d9$export$e530037191fcd5d7; }, function (v) { return $1c9126e4e799e7d9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $1c9126e4e799e7d9$export$fd42f52fd3ae1109; }, function (v) { return $1c9126e4e799e7d9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $1c9126e4e799e7d9$export$c8a8987d4410bf2d; }, function (v) { return $1c9126e4e799e7d9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $1c9126e4e799e7d9$export$7d1e3a5e95ceca43; }, function (v) { return $1c9126e4e799e7d9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $1c9126e4e799e7d9$export$257a8862b851cb5b; }, function (v) { return $1c9126e4e799e7d9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $1c9126e4e799e7d9$export$a8257692ac88316c; }, function (v) { return $1c9126e4e799e7d9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $1c9126e4e799e7d9$export$488013bae63b21da; }, function (v) { return $1c9126e4e799e7d9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $1c9126e4e799e7d9$export$7c73462e0d25e514; }, function (v) { return $1c9126e4e799e7d9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $1c9126e4e799e7d9$export$7568632d0d33d16d; }, function (v) { return $1c9126e4e799e7d9$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $1c9126e4e799e7d9$export$f93f40ac0ca7e3a8; }, function (v) { return $1c9126e4e799e7d9$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $1c9126e4e799e7d9$export$1f96ae73734a86cc; }, function (v) { return $1c9126e4e799e7d9$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $1c9126e4e799e7d9$export$9a47ced3238df325; }, function (v) { return $1c9126e4e799e7d9$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $1c9126e4e799e7d9$export$35808ee640e87ca7; }, function (v) { return $1c9126e4e799e7d9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $1c9126e4e799e7d9$export$fae74005e78b1a27; }, function (v) { return $1c9126e4e799e7d9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $1c9126e4e799e7d9$export$dc8fbce3eb94dc1e; }, function (v) { return $1c9126e4e799e7d9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $1c9126e4e799e7d9$export$6a7bc4e911dc01cf; }, function (v) { return $1c9126e4e799e7d9$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $1c9126e4e799e7d9$export$6d9c69b0de29b591; }, function (v) { return $1c9126e4e799e7d9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $1c9126e4e799e7d9$export$7f54fc3180508a52; }, function (v) { return $1c9126e4e799e7d9$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $1c9126e4e799e7d9$export$f680877a34711e37; }, function (v) { return $1c9126e4e799e7d9$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $1c9126e4e799e7d9$export$d5a552a76deda3c2; }, function (v) { return $1c9126e4e799e7d9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $1c9126e4e799e7d9$export$aaabe4eda9ed9969; }, function (v) { return $1c9126e4e799e7d9$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $1c9126e4e799e7d9$export$e5c5a5f917a5871c; }, function (v) { return $1c9126e4e799e7d9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $1c9126e4e799e7d9$export$1538c33de8887b59; }, function (v) { return $1c9126e4e799e7d9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $1c9126e4e799e7d9$export$fca7f784ae7a249a; }, function (v) { return $1c9126e4e799e7d9$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $1c9126e4e799e7d9$export$13e3392192263954; }, function (v) { return $1c9126e4e799e7d9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $1c9126e4e799e7d9$export$b8f5890fc79d6aca; }, function (v) { return $1c9126e4e799e7d9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $1c9126e4e799e7d9$export$60241385465d0a34; }, function (v) { return $1c9126e4e799e7d9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $1c9126e4e799e7d9$export$306c0aa65ff9ec16; }, function (v) { return $1c9126e4e799e7d9$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $1c9126e4e799e7d9$export$7b286972b8d8ccbf; }, function (v) { return $1c9126e4e799e7d9$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $1c9126e4e799e7d9$export$83d89fbfd8236492; }, function (v) { return $1c9126e4e799e7d9$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $03bAP = parcelRequire("03bAP");
var $1c9126e4e799e7d9$export$9c16c1426311996d;
var $1c9126e4e799e7d9$export$dca3b0875bd9a954;
var $1c9126e4e799e7d9$export$16fa2f45be04daa8;
var $1c9126e4e799e7d9$export$ffb0004e005737fa;
var $1c9126e4e799e7d9$export$e2c29f18771995cb;
var $1c9126e4e799e7d9$export$221d75b3f55bb0bd;
var $1c9126e4e799e7d9$export$5f8d39834fd61797;
var $1c9126e4e799e7d9$export$74bf444e3cd11ea5;
var $1c9126e4e799e7d9$export$1ced07cd6b1985ce;
var $1c9126e4e799e7d9$export$abd8e32b826d7ea7;
var $1c9126e4e799e7d9$export$69a3209f1a06c04d;
var $1c9126e4e799e7d9$export$8c538325882c7eec;
var $1c9126e4e799e7d9$export$e530037191fcd5d7;
var $1c9126e4e799e7d9$export$fd42f52fd3ae1109;
var $1c9126e4e799e7d9$export$c8a8987d4410bf2d;
var $1c9126e4e799e7d9$export$7d1e3a5e95ceca43;
var $1c9126e4e799e7d9$export$257a8862b851cb5b;
var $1c9126e4e799e7d9$export$a8257692ac88316c;
var $1c9126e4e799e7d9$export$488013bae63b21da;
var $1c9126e4e799e7d9$export$7c73462e0d25e514;
var $1c9126e4e799e7d9$export$7568632d0d33d16d;
var $1c9126e4e799e7d9$export$f93f40ac0ca7e3a8;
var $1c9126e4e799e7d9$export$1f96ae73734a86cc;
var $1c9126e4e799e7d9$export$9a47ced3238df325;
var $1c9126e4e799e7d9$export$35808ee640e87ca7;
var $1c9126e4e799e7d9$export$fae74005e78b1a27;
var $1c9126e4e799e7d9$export$dc8fbce3eb94dc1e;
var $1c9126e4e799e7d9$export$6a7bc4e911dc01cf;
var $1c9126e4e799e7d9$export$6d9c69b0de29b591;
var $1c9126e4e799e7d9$export$7f54fc3180508a52;
var $1c9126e4e799e7d9$export$f680877a34711e37;
var $1c9126e4e799e7d9$export$d5a552a76deda3c2;
var $1c9126e4e799e7d9$export$aaabe4eda9ed9969;
var $1c9126e4e799e7d9$export$e5c5a5f917a5871c;
var $1c9126e4e799e7d9$export$1538c33de8887b59;
var $1c9126e4e799e7d9$export$fca7f784ae7a249a;
var $1c9126e4e799e7d9$export$13e3392192263954;
var $1c9126e4e799e7d9$export$b8f5890fc79d6aca;
var $1c9126e4e799e7d9$export$60241385465d0a34;
var $1c9126e4e799e7d9$export$306c0aa65ff9ec16;
var $1c9126e4e799e7d9$export$7b286972b8d8ccbf;
var $1c9126e4e799e7d9$export$83d89fbfd8236492;
"use strict";
var $1c9126e4e799e7d9$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $1c9126e4e799e7d9$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $1c9126e4e799e7d9$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $1c9126e4e799e7d9$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $1c9126e4e799e7d9$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $1c9126e4e799e7d9$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $1c9126e4e799e7d9$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $1c9126e4e799e7d9$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $1c9126e4e799e7d9$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $1c9126e4e799e7d9$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $1c9126e4e799e7d9$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $1c9126e4e799e7d9$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $1c9126e4e799e7d9$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $1c9126e4e799e7d9$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $03bAP._)(maybeIterable))) return null;
    maybeIterable = $1c9126e4e799e7d9$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$1c9126e4e799e7d9$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $1c9126e4e799e7d9$var$ReactNoopUpdateQueue = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $1c9126e4e799e7d9$var$assign = Object.assign, $1c9126e4e799e7d9$var$emptyObject = {};
function $1c9126e4e799e7d9$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $1c9126e4e799e7d9$var$emptyObject;
    this.updater = updater || $1c9126e4e799e7d9$var$ReactNoopUpdateQueue;
}
$1c9126e4e799e7d9$var$Component.prototype.isReactComponent = {};
$1c9126e4e799e7d9$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== (typeof partialState === "undefined" ? "undefined" : (0, $03bAP._)(partialState)) && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$1c9126e4e799e7d9$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $1c9126e4e799e7d9$var$ComponentDummy() {}
$1c9126e4e799e7d9$var$ComponentDummy.prototype = $1c9126e4e799e7d9$var$Component.prototype;
function $1c9126e4e799e7d9$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $1c9126e4e799e7d9$var$emptyObject;
    this.updater = updater || $1c9126e4e799e7d9$var$ReactNoopUpdateQueue;
}
var $1c9126e4e799e7d9$var$pureComponentPrototype = $1c9126e4e799e7d9$var$PureComponent.prototype = new $1c9126e4e799e7d9$var$ComponentDummy();
$1c9126e4e799e7d9$var$pureComponentPrototype.constructor = $1c9126e4e799e7d9$var$PureComponent;
$1c9126e4e799e7d9$var$assign($1c9126e4e799e7d9$var$pureComponentPrototype, $1c9126e4e799e7d9$var$Component.prototype);
$1c9126e4e799e7d9$var$pureComponentPrototype.isPureReactComponent = !0;
var $1c9126e4e799e7d9$var$isArrayImpl = Array.isArray;
function $1c9126e4e799e7d9$var$noop() {}
var $1c9126e4e799e7d9$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $1c9126e4e799e7d9$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $1c9126e4e799e7d9$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $1c9126e4e799e7d9$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $1c9126e4e799e7d9$var$cloneAndReplaceKey(oldElement, newKey) {
    return $1c9126e4e799e7d9$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $1c9126e4e799e7d9$var$isValidElement(object) {
    return "object" === (typeof object === "undefined" ? "undefined" : (0, $03bAP._)(object)) && null !== object && object.$$typeof === $1c9126e4e799e7d9$var$REACT_ELEMENT_TYPE;
}
function $1c9126e4e799e7d9$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $1c9126e4e799e7d9$var$userProvidedKeyEscapeRegex = /\/+/g;
function $1c9126e4e799e7d9$var$getElementKey(element, index) {
    return "object" === (typeof element === "undefined" ? "undefined" : (0, $03bAP._)(element)) && null !== element && null != element.key ? $1c9126e4e799e7d9$var$escape("" + element.key) : index.toString(36);
}
function $1c9126e4e799e7d9$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($1c9126e4e799e7d9$var$noop, $1c9126e4e799e7d9$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $1c9126e4e799e7d9$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children === "undefined" ? "undefined" : (0, $03bAP._)(children);
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $1c9126e4e799e7d9$var$REACT_ELEMENT_TYPE:
                case $1c9126e4e799e7d9$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $1c9126e4e799e7d9$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $1c9126e4e799e7d9$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $1c9126e4e799e7d9$var$getElementKey(children, 0) : nameSoFar, $1c9126e4e799e7d9$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($1c9126e4e799e7d9$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $1c9126e4e799e7d9$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($1c9126e4e799e7d9$var$isValidElement(callback) && (callback = $1c9126e4e799e7d9$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($1c9126e4e799e7d9$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($1c9126e4e799e7d9$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $1c9126e4e799e7d9$var$getElementKey(nameSoFar, i), invokeCallback += $1c9126e4e799e7d9$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $1c9126e4e799e7d9$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $1c9126e4e799e7d9$var$getElementKey(nameSoFar, i++), invokeCallback += $1c9126e4e799e7d9$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $1c9126e4e799e7d9$var$mapIntoArray($1c9126e4e799e7d9$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $1c9126e4e799e7d9$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $1c9126e4e799e7d9$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $1c9126e4e799e7d9$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $1c9126e4e799e7d9$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $03bAP._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $03bAP._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $1c9126e4e799e7d9$var$Children = {
    map: $1c9126e4e799e7d9$var$mapChildren,
    forEach: function forEach(children, forEachFunc, forEachContext) {
        $1c9126e4e799e7d9$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function count(children) {
        var n = 0;
        $1c9126e4e799e7d9$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function toArray(children) {
        return $1c9126e4e799e7d9$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function only(children) {
        if (!$1c9126e4e799e7d9$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$1c9126e4e799e7d9$export$9c16c1426311996d = $1c9126e4e799e7d9$var$REACT_ACTIVITY_TYPE;
$1c9126e4e799e7d9$export$dca3b0875bd9a954 = $1c9126e4e799e7d9$var$Children;
$1c9126e4e799e7d9$export$16fa2f45be04daa8 = $1c9126e4e799e7d9$var$Component;
$1c9126e4e799e7d9$export$ffb0004e005737fa = $1c9126e4e799e7d9$var$REACT_FRAGMENT_TYPE;
$1c9126e4e799e7d9$export$e2c29f18771995cb = $1c9126e4e799e7d9$var$REACT_PROFILER_TYPE;
$1c9126e4e799e7d9$export$221d75b3f55bb0bd = $1c9126e4e799e7d9$var$PureComponent;
$1c9126e4e799e7d9$export$5f8d39834fd61797 = $1c9126e4e799e7d9$var$REACT_STRICT_MODE_TYPE;
$1c9126e4e799e7d9$export$74bf444e3cd11ea5 = $1c9126e4e799e7d9$var$REACT_SUSPENSE_TYPE;
$1c9126e4e799e7d9$export$1ced07cd6b1985ce = $1c9126e4e799e7d9$var$ReactSharedInternals;
$1c9126e4e799e7d9$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function c(size) {
        return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$1c9126e4e799e7d9$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$1c9126e4e799e7d9$export$8c538325882c7eec = function() {
    return null;
};
$1c9126e4e799e7d9$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $1c9126e4e799e7d9$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$1c9126e4e799e7d9$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $1c9126e4e799e7d9$var$ReactElement(element.type, key, props);
};
$1c9126e4e799e7d9$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $1c9126e4e799e7d9$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $1c9126e4e799e7d9$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$1c9126e4e799e7d9$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$1c9126e4e799e7d9$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $1c9126e4e799e7d9$var$ReactElement(type, key, props);
};
$1c9126e4e799e7d9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c9126e4e799e7d9$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $1c9126e4e799e7d9$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$1c9126e4e799e7d9$export$a8257692ac88316c = $1c9126e4e799e7d9$var$isValidElement;
$1c9126e4e799e7d9$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $1c9126e4e799e7d9$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $1c9126e4e799e7d9$var$lazyInitializer
    };
};
$1c9126e4e799e7d9$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $1c9126e4e799e7d9$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$1c9126e4e799e7d9$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $1c9126e4e799e7d9$var$ReactSharedInternals.T, currentTransition = {};
    $1c9126e4e799e7d9$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $1c9126e4e799e7d9$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $03bAP._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($1c9126e4e799e7d9$var$noop, $1c9126e4e799e7d9$var$reportGlobalError);
    } catch (error) {
        $1c9126e4e799e7d9$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $1c9126e4e799e7d9$var$ReactSharedInternals.T = prevTransition;
    }
};
$1c9126e4e799e7d9$export$f93f40ac0ca7e3a8 = function() {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useCacheRefresh();
};
$1c9126e4e799e7d9$export$1f96ae73734a86cc = function(usable) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.use(usable);
};
$1c9126e4e799e7d9$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$1c9126e4e799e7d9$export$35808ee640e87ca7 = function(callback, deps) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$1c9126e4e799e7d9$export$fae74005e78b1a27 = function(Context) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useContext(Context);
};
$1c9126e4e799e7d9$export$dc8fbce3eb94dc1e = function() {};
$1c9126e4e799e7d9$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$1c9126e4e799e7d9$export$6d9c69b0de29b591 = function(create, deps) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useEffect(create, deps);
};
$1c9126e4e799e7d9$export$7f54fc3180508a52 = function(callback) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$1c9126e4e799e7d9$export$f680877a34711e37 = function() {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useId();
};
$1c9126e4e799e7d9$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$1c9126e4e799e7d9$export$aaabe4eda9ed9969 = function(create, deps) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$1c9126e4e799e7d9$export$e5c5a5f917a5871c = function(create, deps) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$1c9126e4e799e7d9$export$1538c33de8887b59 = function(create, deps) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useMemo(create, deps);
};
$1c9126e4e799e7d9$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$1c9126e4e799e7d9$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$1c9126e4e799e7d9$export$b8f5890fc79d6aca = function(initialValue) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useRef(initialValue);
};
$1c9126e4e799e7d9$export$60241385465d0a34 = function(initialState) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useState(initialState);
};
$1c9126e4e799e7d9$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$1c9126e4e799e7d9$export$7b286972b8d8ccbf = function() {
    return $1c9126e4e799e7d9$var$ReactSharedInternals.H.useTransition();
};
$1c9126e4e799e7d9$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("03bAP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0099460daedd554a$export$71511d61b312f219; });
function $0099460daedd554a$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("917kP", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $6909e5993a213e12$export$882461b6382ed46c; }, function (v) { return $6909e5993a213e12$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $6909e5993a213e12$export$757ceba2d55c277e; }, function (v) { return $6909e5993a213e12$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $6909e5993a213e12$export$83d89fbfd8236492; }, function (v) { return $6909e5993a213e12$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $03bAP = parcelRequire("03bAP");
var $6909e5993a213e12$export$882461b6382ed46c;
var $6909e5993a213e12$export$757ceba2d55c277e;
var $6909e5993a213e12$export$83d89fbfd8236492;
"use strict";

var $4Q55w = parcelRequire("4Q55w");

var $5s1kH = parcelRequire("5s1kH");

var $eAxYl = parcelRequire("eAxYl");
function $6909e5993a213e12$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $6909e5993a213e12$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $6909e5993a213e12$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $6909e5993a213e12$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $6909e5993a213e12$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $6909e5993a213e12$var$assertIsMounted(fiber) {
    if ($6909e5993a213e12$var$getNearestMountedFiber(fiber) !== fiber) throw Error($6909e5993a213e12$var$formatProdErrorMessage(188));
}
function $6909e5993a213e12$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $6909e5993a213e12$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($6909e5993a213e12$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $6909e5993a213e12$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $6909e5993a213e12$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($6909e5993a213e12$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($6909e5993a213e12$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($6909e5993a213e12$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($6909e5993a213e12$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $6909e5993a213e12$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $6909e5993a213e12$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $6909e5993a213e12$var$assign = Object.assign, $6909e5993a213e12$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $6909e5993a213e12$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $6909e5993a213e12$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $6909e5993a213e12$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $6909e5993a213e12$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $6909e5993a213e12$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $6909e5993a213e12$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $6909e5993a213e12$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $6909e5993a213e12$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $6909e5993a213e12$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $6909e5993a213e12$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $6909e5993a213e12$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $6909e5993a213e12$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $6909e5993a213e12$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $6909e5993a213e12$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $6909e5993a213e12$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $6909e5993a213e12$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $03bAP._)(maybeIterable))) return null;
    maybeIterable = $6909e5993a213e12$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$6909e5993a213e12$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $6909e5993a213e12$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $6909e5993a213e12$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $6909e5993a213e12$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $6909e5993a213e12$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $6909e5993a213e12$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $6909e5993a213e12$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $6909e5993a213e12$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $6909e5993a213e12$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $6909e5993a213e12$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === (typeof type === "undefined" ? "undefined" : (0, $03bAP._)(type))) switch(type.$$typeof){
        case $6909e5993a213e12$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $6909e5993a213e12$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $6909e5993a213e12$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $6909e5993a213e12$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $6909e5993a213e12$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $6909e5993a213e12$var$getComponentNameFromType(type.type) || "Memo";
        case $6909e5993a213e12$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $6909e5993a213e12$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $6909e5993a213e12$var$isArrayImpl = Array.isArray, $6909e5993a213e12$var$ReactSharedInternals = $5s1kH.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $6909e5993a213e12$var$ReactDOMSharedInternals = $eAxYl.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $6909e5993a213e12$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $6909e5993a213e12$var$valueStack = [], $6909e5993a213e12$var$index = -1;
function $6909e5993a213e12$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $6909e5993a213e12$var$pop(cursor) {
    0 > $6909e5993a213e12$var$index || (cursor.current = $6909e5993a213e12$var$valueStack[$6909e5993a213e12$var$index], $6909e5993a213e12$var$valueStack[$6909e5993a213e12$var$index] = null, $6909e5993a213e12$var$index--);
}
function $6909e5993a213e12$var$push(cursor, value) {
    $6909e5993a213e12$var$index++;
    $6909e5993a213e12$var$valueStack[$6909e5993a213e12$var$index] = cursor.current;
    cursor.current = value;
}
var $6909e5993a213e12$var$contextStackCursor = $6909e5993a213e12$var$createCursor(null), $6909e5993a213e12$var$contextFiberStackCursor = $6909e5993a213e12$var$createCursor(null), $6909e5993a213e12$var$rootInstanceStackCursor = $6909e5993a213e12$var$createCursor(null), $6909e5993a213e12$var$hostTransitionProviderCursor = $6909e5993a213e12$var$createCursor(null);
function $6909e5993a213e12$var$pushHostContainer(fiber, nextRootInstance) {
    $6909e5993a213e12$var$push($6909e5993a213e12$var$rootInstanceStackCursor, nextRootInstance);
    $6909e5993a213e12$var$push($6909e5993a213e12$var$contextFiberStackCursor, fiber);
    $6909e5993a213e12$var$push($6909e5993a213e12$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $6909e5993a213e12$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $6909e5993a213e12$var$getOwnHostContext(nextRootInstance), fiber = $6909e5993a213e12$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $6909e5993a213e12$var$pop($6909e5993a213e12$var$contextStackCursor);
    $6909e5993a213e12$var$push($6909e5993a213e12$var$contextStackCursor, fiber);
}
function $6909e5993a213e12$var$popHostContainer() {
    $6909e5993a213e12$var$pop($6909e5993a213e12$var$contextStackCursor);
    $6909e5993a213e12$var$pop($6909e5993a213e12$var$contextFiberStackCursor);
    $6909e5993a213e12$var$pop($6909e5993a213e12$var$rootInstanceStackCursor);
}
function $6909e5993a213e12$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $6909e5993a213e12$var$push($6909e5993a213e12$var$hostTransitionProviderCursor, fiber);
    var context = $6909e5993a213e12$var$contextStackCursor.current;
    var JSCompiler_inline_result = $6909e5993a213e12$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($6909e5993a213e12$var$push($6909e5993a213e12$var$contextFiberStackCursor, fiber), $6909e5993a213e12$var$push($6909e5993a213e12$var$contextStackCursor, JSCompiler_inline_result));
}
function $6909e5993a213e12$var$popHostContext(fiber) {
    $6909e5993a213e12$var$contextFiberStackCursor.current === fiber && ($6909e5993a213e12$var$pop($6909e5993a213e12$var$contextStackCursor), $6909e5993a213e12$var$pop($6909e5993a213e12$var$contextFiberStackCursor));
    $6909e5993a213e12$var$hostTransitionProviderCursor.current === fiber && ($6909e5993a213e12$var$pop($6909e5993a213e12$var$hostTransitionProviderCursor), $6909e5993a213e12$var$HostTransitionContext._currentValue = $6909e5993a213e12$var$sharedNotPendingObject);
}
var $6909e5993a213e12$var$prefix, $6909e5993a213e12$var$suffix;
function $6909e5993a213e12$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $6909e5993a213e12$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $6909e5993a213e12$var$prefix = match && match[1] || "";
        $6909e5993a213e12$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $6909e5993a213e12$var$prefix + name + $6909e5993a213e12$var$suffix;
}
var $6909e5993a213e12$var$reentry = !1;
function $6909e5993a213e12$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $6909e5993a213e12$var$reentry) return "";
    $6909e5993a213e12$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function DetermineComponentFrameRoot() {
                try {
                    if (construct) {
                        var Fake = function Fake() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function set() {
                                throw Error();
                            }
                        });
                        if ("object" === (typeof Reflect === "undefined" ? "undefined" : (0, $03bAP._)(Reflect)) && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $6909e5993a213e12$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $6909e5993a213e12$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $6909e5993a213e12$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $6909e5993a213e12$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $6909e5993a213e12$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $6909e5993a213e12$var$describeBuiltInComponentFrame("Suspense Fallback") : $6909e5993a213e12$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $6909e5993a213e12$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $6909e5993a213e12$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $6909e5993a213e12$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $6909e5993a213e12$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $6909e5993a213e12$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $6909e5993a213e12$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $6909e5993a213e12$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $6909e5993a213e12$var$hasOwnProperty = Object.prototype.hasOwnProperty, $6909e5993a213e12$var$scheduleCallback$3 = $4Q55w.unstable_scheduleCallback, $6909e5993a213e12$var$cancelCallback$1 = $4Q55w.unstable_cancelCallback, $6909e5993a213e12$var$shouldYield = $4Q55w.unstable_shouldYield, $6909e5993a213e12$var$requestPaint = $4Q55w.unstable_requestPaint, $6909e5993a213e12$var$now = $4Q55w.unstable_now, $6909e5993a213e12$var$getCurrentPriorityLevel = $4Q55w.unstable_getCurrentPriorityLevel, $6909e5993a213e12$var$ImmediatePriority = $4Q55w.unstable_ImmediatePriority, $6909e5993a213e12$var$UserBlockingPriority = $4Q55w.unstable_UserBlockingPriority, $6909e5993a213e12$var$NormalPriority$1 = $4Q55w.unstable_NormalPriority, $6909e5993a213e12$var$LowPriority = $4Q55w.unstable_LowPriority, $6909e5993a213e12$var$IdlePriority = $4Q55w.unstable_IdlePriority, $6909e5993a213e12$var$log$1 = $4Q55w.log, $6909e5993a213e12$var$unstable_setDisableYieldValue = $4Q55w.unstable_setDisableYieldValue, $6909e5993a213e12$var$rendererID = null, $6909e5993a213e12$var$injectedHook = null;
function $6909e5993a213e12$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $6909e5993a213e12$var$log$1 && $6909e5993a213e12$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($6909e5993a213e12$var$injectedHook && "function" === typeof $6909e5993a213e12$var$injectedHook.setStrictMode) try {
        $6909e5993a213e12$var$injectedHook.setStrictMode($6909e5993a213e12$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $6909e5993a213e12$var$clz32 = Math.clz32 ? Math.clz32 : $6909e5993a213e12$var$clz32Fallback, $6909e5993a213e12$var$log = Math.log, $6909e5993a213e12$var$LN2 = Math.LN2;
function $6909e5993a213e12$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($6909e5993a213e12$var$log(x) / $6909e5993a213e12$var$LN2 | 0) | 0;
}
var $6909e5993a213e12$var$nextTransitionUpdateLane = 256, $6909e5993a213e12$var$nextTransitionDeferredLane = 262144, $6909e5993a213e12$var$nextRetryLane = 4194304;
function $6909e5993a213e12$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $6909e5993a213e12$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $6909e5993a213e12$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $6909e5993a213e12$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $6909e5993a213e12$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $6909e5993a213e12$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $6909e5993a213e12$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $6909e5993a213e12$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $6909e5993a213e12$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $6909e5993a213e12$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $6909e5993a213e12$var$claimNextRetryLane() {
    var lane = $6909e5993a213e12$var$nextRetryLane;
    $6909e5993a213e12$var$nextRetryLane <<= 1;
    0 === ($6909e5993a213e12$var$nextRetryLane & 62914560) && ($6909e5993a213e12$var$nextRetryLane = 4194304);
    return lane;
}
function $6909e5993a213e12$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $6909e5993a213e12$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $6909e5993a213e12$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $6909e5993a213e12$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $6909e5993a213e12$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $6909e5993a213e12$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $6909e5993a213e12$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $6909e5993a213e12$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $6909e5993a213e12$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $6909e5993a213e12$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $6909e5993a213e12$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $6909e5993a213e12$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $6909e5993a213e12$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $6909e5993a213e12$var$resolveUpdatePriority() {
    var updatePriority = $6909e5993a213e12$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $6909e5993a213e12$var$getEventPriority(updatePriority.type);
}
function $6909e5993a213e12$var$runWithPriority(priority, fn) {
    var previousPriority = $6909e5993a213e12$var$ReactDOMSharedInternals.p;
    try {
        return $6909e5993a213e12$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $6909e5993a213e12$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $6909e5993a213e12$var$randomKey = Math.random().toString(36).slice(2), $6909e5993a213e12$var$internalInstanceKey = "__reactFiber$" + $6909e5993a213e12$var$randomKey, $6909e5993a213e12$var$internalPropsKey = "__reactProps$" + $6909e5993a213e12$var$randomKey, $6909e5993a213e12$var$internalContainerInstanceKey = "__reactContainer$" + $6909e5993a213e12$var$randomKey, $6909e5993a213e12$var$internalEventHandlersKey = "__reactEvents$" + $6909e5993a213e12$var$randomKey, $6909e5993a213e12$var$internalEventHandlerListenersKey = "__reactListeners$" + $6909e5993a213e12$var$randomKey, $6909e5993a213e12$var$internalEventHandlesSetKey = "__reactHandles$" + $6909e5993a213e12$var$randomKey, $6909e5993a213e12$var$internalRootNodeResourcesKey = "__reactResources$" + $6909e5993a213e12$var$randomKey, $6909e5993a213e12$var$internalHoistableMarker = "__reactMarker$" + $6909e5993a213e12$var$randomKey;
function $6909e5993a213e12$var$detachDeletedInstance(node) {
    delete node[$6909e5993a213e12$var$internalInstanceKey];
    delete node[$6909e5993a213e12$var$internalPropsKey];
    delete node[$6909e5993a213e12$var$internalEventHandlersKey];
    delete node[$6909e5993a213e12$var$internalEventHandlerListenersKey];
    delete node[$6909e5993a213e12$var$internalEventHandlesSetKey];
}
function $6909e5993a213e12$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$6909e5993a213e12$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$6909e5993a213e12$var$internalContainerInstanceKey] || parentNode[$6909e5993a213e12$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $6909e5993a213e12$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$6909e5993a213e12$var$internalInstanceKey]) return parentNode;
                targetNode = $6909e5993a213e12$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $6909e5993a213e12$var$getInstanceFromNode(node) {
    if (node = node[$6909e5993a213e12$var$internalInstanceKey] || node[$6909e5993a213e12$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $6909e5993a213e12$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($6909e5993a213e12$var$formatProdErrorMessage(33));
}
function $6909e5993a213e12$var$getResourcesFromRoot(root) {
    var resources = root[$6909e5993a213e12$var$internalRootNodeResourcesKey];
    resources || (resources = root[$6909e5993a213e12$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $6909e5993a213e12$var$markNodeAsHoistable(node) {
    node[$6909e5993a213e12$var$internalHoistableMarker] = !0;
}
var $6909e5993a213e12$var$allNativeEvents = new Set(), $6909e5993a213e12$var$registrationNameDependencies = {};
function $6909e5993a213e12$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $6909e5993a213e12$var$registerDirectEvent(registrationName, dependencies);
    $6909e5993a213e12$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $6909e5993a213e12$var$registerDirectEvent(registrationName, dependencies) {
    $6909e5993a213e12$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$6909e5993a213e12$var$allNativeEvents.add(dependencies[registrationName]);
}
var $6909e5993a213e12$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $6909e5993a213e12$var$illegalAttributeNameCache = {}, $6909e5993a213e12$var$validatedAttributeNameCache = {};
function $6909e5993a213e12$var$isAttributeNameSafe(attributeName) {
    if ($6909e5993a213e12$var$hasOwnProperty.call($6909e5993a213e12$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($6909e5993a213e12$var$hasOwnProperty.call($6909e5993a213e12$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($6909e5993a213e12$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $6909e5993a213e12$var$validatedAttributeNameCache[attributeName] = !0;
    $6909e5993a213e12$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $6909e5993a213e12$var$setValueForAttribute(node, name, value) {
    if ($6909e5993a213e12$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $6909e5993a213e12$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $6909e5993a213e12$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $6909e5993a213e12$var$getToStringValue(value) {
    switch(typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $6909e5993a213e12$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $6909e5993a213e12$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function get1() {
                return get.call(this);
            },
            set: function set1(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function getValue() {
                return currentValue;
            },
            setValue: function setValue(value) {
                currentValue = "" + value;
            },
            stopTracking: function stopTracking() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $6909e5993a213e12$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $6909e5993a213e12$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $6909e5993a213e12$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $6909e5993a213e12$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $6909e5993a213e12$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $6909e5993a213e12$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $6909e5993a213e12$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $03bAP._)(type)) && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $6909e5993a213e12$var$getToStringValue(value);
        } else element.value !== "" + $6909e5993a213e12$var$getToStringValue(value) && (element.value = "" + $6909e5993a213e12$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $6909e5993a213e12$var$setDefaultValue(element, type, $6909e5993a213e12$var$getToStringValue(value)) : null != defaultValue ? $6909e5993a213e12$var$setDefaultValue(element, type, $6909e5993a213e12$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $03bAP._)(checked)));
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $03bAP._)(name)) && "boolean" !== typeof name ? element.name = "" + $6909e5993a213e12$var$getToStringValue(name) : element.removeAttribute("name");
}
function $6909e5993a213e12$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $03bAP._)(type)) && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $6909e5993a213e12$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $6909e5993a213e12$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $6909e5993a213e12$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $03bAP._)(checked)) && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $03bAP._)(name)) && "boolean" !== typeof name && (element.name = name);
    $6909e5993a213e12$var$track(element);
}
function $6909e5993a213e12$var$setDefaultValue(node, type, value) {
    "number" === type && $6909e5993a213e12$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $6909e5993a213e12$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $6909e5993a213e12$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $6909e5993a213e12$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $6909e5993a213e12$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $6909e5993a213e12$var$getToStringValue(defaultValue) : "";
}
function $6909e5993a213e12$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($6909e5993a213e12$var$formatProdErrorMessage(92));
            if ($6909e5993a213e12$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($6909e5993a213e12$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $6909e5993a213e12$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $6909e5993a213e12$var$track(element);
}
function $6909e5993a213e12$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $6909e5993a213e12$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $6909e5993a213e12$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $6909e5993a213e12$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $6909e5993a213e12$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== (typeof styles === "undefined" ? "undefined" : (0, $03bAP._)(styles))) throw Error($6909e5993a213e12$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $6909e5993a213e12$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $6909e5993a213e12$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $6909e5993a213e12$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $6909e5993a213e12$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $6909e5993a213e12$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $6909e5993a213e12$var$sanitizeURL(url) {
    return $6909e5993a213e12$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $6909e5993a213e12$var$noop$1() {}
var $6909e5993a213e12$var$currentReplayingEvent = null;
function $6909e5993a213e12$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $6909e5993a213e12$var$restoreTarget = null, $6909e5993a213e12$var$restoreQueue = null;
function $6909e5993a213e12$var$restoreStateOfTarget(target) {
    var internalInstance = $6909e5993a213e12$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$6909e5993a213e12$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $6909e5993a213e12$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$6909e5993a213e12$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($6909e5993a213e12$var$formatProdErrorMessage(90));
                            $6909e5993a213e12$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $6909e5993a213e12$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $6909e5993a213e12$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $6909e5993a213e12$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $6909e5993a213e12$var$isInsideEventHandler = !1;
function $6909e5993a213e12$var$batchedUpdates$1(fn, a, b) {
    if ($6909e5993a213e12$var$isInsideEventHandler) return fn(a, b);
    $6909e5993a213e12$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($6909e5993a213e12$var$isInsideEventHandler = !1, null !== $6909e5993a213e12$var$restoreTarget || null !== $6909e5993a213e12$var$restoreQueue) {
            if ($6909e5993a213e12$var$flushSyncWork$1(), $6909e5993a213e12$var$restoreTarget && (a = $6909e5993a213e12$var$restoreTarget, fn = $6909e5993a213e12$var$restoreQueue, $6909e5993a213e12$var$restoreQueue = $6909e5993a213e12$var$restoreTarget = null, $6909e5993a213e12$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$6909e5993a213e12$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $6909e5993a213e12$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$6909e5993a213e12$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($6909e5993a213e12$var$formatProdErrorMessage(231, registrationName, typeof stateNode === "undefined" ? "undefined" : (0, $03bAP._)(stateNode)));
    return stateNode;
}
var $6909e5993a213e12$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $6909e5993a213e12$var$passiveBrowserEventsSupported = !1;
if ($6909e5993a213e12$var$canUseDOM) try {
    var $6909e5993a213e12$var$options = {};
    Object.defineProperty($6909e5993a213e12$var$options, "passive", {
        get: function get() {
            $6909e5993a213e12$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $6909e5993a213e12$var$options, $6909e5993a213e12$var$options);
    window.removeEventListener("test", $6909e5993a213e12$var$options, $6909e5993a213e12$var$options);
} catch (e) {
    $6909e5993a213e12$var$passiveBrowserEventsSupported = !1;
}
var $6909e5993a213e12$var$root = null, $6909e5993a213e12$var$startText = null, $6909e5993a213e12$var$fallbackText = null;
function $6909e5993a213e12$var$getData() {
    if ($6909e5993a213e12$var$fallbackText) return $6909e5993a213e12$var$fallbackText;
    var start, startValue = $6909e5993a213e12$var$startText, startLength = startValue.length, end, endValue = "value" in $6909e5993a213e12$var$root ? $6909e5993a213e12$var$root.value : $6909e5993a213e12$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $6909e5993a213e12$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $6909e5993a213e12$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $6909e5993a213e12$var$functionThatReturnsTrue() {
    return !0;
}
function $6909e5993a213e12$var$functionThatReturnsFalse() {
    return !1;
}
function $6909e5993a213e12$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $6909e5993a213e12$var$functionThatReturnsTrue : $6909e5993a213e12$var$functionThatReturnsFalse;
        this.isPropagationStopped = $6909e5993a213e12$var$functionThatReturnsFalse;
        return this;
    }
    $6909e5993a213e12$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== (0, $03bAP._)(event.returnValue) && (event.returnValue = !1), this.isDefaultPrevented = $6909e5993a213e12$var$functionThatReturnsTrue);
        },
        stopPropagation: function stopPropagation() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== (0, $03bAP._)(event.cancelBubble) && (event.cancelBubble = !0), this.isPropagationStopped = $6909e5993a213e12$var$functionThatReturnsTrue);
        },
        persist: function persist() {},
        isPersistent: $6909e5993a213e12$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $6909e5993a213e12$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $6909e5993a213e12$var$SyntheticEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$EventInterface), $6909e5993a213e12$var$UIEventInterface = $6909e5993a213e12$var$assign({}, $6909e5993a213e12$var$EventInterface, {
    view: 0,
    detail: 0
}), $6909e5993a213e12$var$SyntheticUIEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$UIEventInterface), $6909e5993a213e12$var$lastMovementX, $6909e5993a213e12$var$lastMovementY, $6909e5993a213e12$var$lastMouseEvent, $6909e5993a213e12$var$MouseEventInterface = $6909e5993a213e12$var$assign({}, $6909e5993a213e12$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $6909e5993a213e12$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function movementX(event) {
        if ("movementX" in event) return event.movementX;
        event !== $6909e5993a213e12$var$lastMouseEvent && ($6909e5993a213e12$var$lastMouseEvent && "mousemove" === event.type ? ($6909e5993a213e12$var$lastMovementX = event.screenX - $6909e5993a213e12$var$lastMouseEvent.screenX, $6909e5993a213e12$var$lastMovementY = event.screenY - $6909e5993a213e12$var$lastMouseEvent.screenY) : $6909e5993a213e12$var$lastMovementY = $6909e5993a213e12$var$lastMovementX = 0, $6909e5993a213e12$var$lastMouseEvent = event);
        return $6909e5993a213e12$var$lastMovementX;
    },
    movementY: function movementY(event) {
        return "movementY" in event ? event.movementY : $6909e5993a213e12$var$lastMovementY;
    }
}), $6909e5993a213e12$var$SyntheticMouseEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$MouseEventInterface), $6909e5993a213e12$var$DragEventInterface = $6909e5993a213e12$var$assign({}, $6909e5993a213e12$var$MouseEventInterface, {
    dataTransfer: 0
}), $6909e5993a213e12$var$SyntheticDragEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$DragEventInterface), $6909e5993a213e12$var$FocusEventInterface = $6909e5993a213e12$var$assign({}, $6909e5993a213e12$var$UIEventInterface, {
    relatedTarget: 0
}), $6909e5993a213e12$var$SyntheticFocusEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$FocusEventInterface), $6909e5993a213e12$var$AnimationEventInterface = $6909e5993a213e12$var$assign({}, $6909e5993a213e12$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $6909e5993a213e12$var$SyntheticAnimationEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$AnimationEventInterface), $6909e5993a213e12$var$ClipboardEventInterface = $6909e5993a213e12$var$assign({}, $6909e5993a213e12$var$EventInterface, {
    clipboardData: function clipboardData(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $6909e5993a213e12$var$SyntheticClipboardEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$ClipboardEventInterface), $6909e5993a213e12$var$CompositionEventInterface = $6909e5993a213e12$var$assign({}, $6909e5993a213e12$var$EventInterface, {
    data: 0
}), $6909e5993a213e12$var$SyntheticCompositionEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$CompositionEventInterface), $6909e5993a213e12$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $6909e5993a213e12$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $6909e5993a213e12$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $6909e5993a213e12$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $6909e5993a213e12$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $6909e5993a213e12$var$getEventModifierState() {
    return $6909e5993a213e12$var$modifierStateGetter;
}
var $6909e5993a213e12$var$KeyboardEventInterface = $6909e5993a213e12$var$assign({}, $6909e5993a213e12$var$UIEventInterface, {
    key: function key(nativeEvent) {
        if (nativeEvent.key) {
            var key = $6909e5993a213e12$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $6909e5993a213e12$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $6909e5993a213e12$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $6909e5993a213e12$var$getEventModifierState,
    charCode: function charCode(event) {
        return "keypress" === event.type ? $6909e5993a213e12$var$getEventCharCode(event) : 0;
    },
    keyCode: function keyCode(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function which(event) {
        return "keypress" === event.type ? $6909e5993a213e12$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $6909e5993a213e12$var$SyntheticKeyboardEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$KeyboardEventInterface), $6909e5993a213e12$var$PointerEventInterface = $6909e5993a213e12$var$assign({}, $6909e5993a213e12$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $6909e5993a213e12$var$SyntheticPointerEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$PointerEventInterface), $6909e5993a213e12$var$TouchEventInterface = $6909e5993a213e12$var$assign({}, $6909e5993a213e12$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $6909e5993a213e12$var$getEventModifierState
}), $6909e5993a213e12$var$SyntheticTouchEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$TouchEventInterface), $6909e5993a213e12$var$TransitionEventInterface = $6909e5993a213e12$var$assign({}, $6909e5993a213e12$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $6909e5993a213e12$var$SyntheticTransitionEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$TransitionEventInterface), $6909e5993a213e12$var$WheelEventInterface = $6909e5993a213e12$var$assign({}, $6909e5993a213e12$var$MouseEventInterface, {
    deltaX: function deltaX(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function deltaY(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $6909e5993a213e12$var$SyntheticWheelEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$WheelEventInterface), $6909e5993a213e12$var$ToggleEventInterface = $6909e5993a213e12$var$assign({}, $6909e5993a213e12$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $6909e5993a213e12$var$SyntheticToggleEvent = $6909e5993a213e12$var$createSyntheticEvent($6909e5993a213e12$var$ToggleEventInterface), $6909e5993a213e12$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $6909e5993a213e12$var$canUseCompositionEvent = $6909e5993a213e12$var$canUseDOM && "CompositionEvent" in window, $6909e5993a213e12$var$documentMode = null;
$6909e5993a213e12$var$canUseDOM && "documentMode" in document && ($6909e5993a213e12$var$documentMode = document.documentMode);
var $6909e5993a213e12$var$canUseTextInputEvent = $6909e5993a213e12$var$canUseDOM && "TextEvent" in window && !$6909e5993a213e12$var$documentMode, $6909e5993a213e12$var$useFallbackCompositionData = $6909e5993a213e12$var$canUseDOM && (!$6909e5993a213e12$var$canUseCompositionEvent || $6909e5993a213e12$var$documentMode && 8 < $6909e5993a213e12$var$documentMode && 11 >= $6909e5993a213e12$var$documentMode), $6909e5993a213e12$var$SPACEBAR_CHAR = String.fromCharCode(32), $6909e5993a213e12$var$hasSpaceKeypress = !1;
function $6909e5993a213e12$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $6909e5993a213e12$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $6909e5993a213e12$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === (typeof nativeEvent === "undefined" ? "undefined" : (0, $03bAP._)(nativeEvent)) && "data" in nativeEvent ? nativeEvent.data : null;
}
var $6909e5993a213e12$var$isComposing = !1;
function $6909e5993a213e12$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $6909e5993a213e12$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $6909e5993a213e12$var$hasSpaceKeypress = !0;
            return $6909e5993a213e12$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $6909e5993a213e12$var$SPACEBAR_CHAR && $6909e5993a213e12$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $6909e5993a213e12$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($6909e5993a213e12$var$isComposing) return "compositionend" === domEventName || !$6909e5993a213e12$var$canUseCompositionEvent && $6909e5993a213e12$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $6909e5993a213e12$var$getData(), $6909e5993a213e12$var$fallbackText = $6909e5993a213e12$var$startText = $6909e5993a213e12$var$root = null, $6909e5993a213e12$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $6909e5993a213e12$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $6909e5993a213e12$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $6909e5993a213e12$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$6909e5993a213e12$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $6909e5993a213e12$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $6909e5993a213e12$var$restoreTarget ? $6909e5993a213e12$var$restoreQueue ? $6909e5993a213e12$var$restoreQueue.push(target) : $6909e5993a213e12$var$restoreQueue = [
        target
    ] : $6909e5993a213e12$var$restoreTarget = target;
    inst = $6909e5993a213e12$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $6909e5993a213e12$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $6909e5993a213e12$var$activeElement$1 = null, $6909e5993a213e12$var$activeElementInst$1 = null;
function $6909e5993a213e12$var$runEventInBatch(dispatchQueue) {
    $6909e5993a213e12$var$processDispatchQueue(dispatchQueue, 0);
}
function $6909e5993a213e12$var$getInstIfValueChanged(targetInst) {
    var targetNode = $6909e5993a213e12$var$getNodeFromInstance(targetInst);
    if ($6909e5993a213e12$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $6909e5993a213e12$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $6909e5993a213e12$var$isInputEventSupported = !1;
if ($6909e5993a213e12$var$canUseDOM) {
    var $6909e5993a213e12$var$JSCompiler_inline_result$jscomp$286;
    if ($6909e5993a213e12$var$canUseDOM) {
        var $6909e5993a213e12$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$6909e5993a213e12$var$isSupported$jscomp$inline_427) {
            var $6909e5993a213e12$var$element$jscomp$inline_428 = document.createElement("div");
            $6909e5993a213e12$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $6909e5993a213e12$var$isSupported$jscomp$inline_427 = "function" === typeof $6909e5993a213e12$var$element$jscomp$inline_428.oninput;
        }
        $6909e5993a213e12$var$JSCompiler_inline_result$jscomp$286 = $6909e5993a213e12$var$isSupported$jscomp$inline_427;
    } else $6909e5993a213e12$var$JSCompiler_inline_result$jscomp$286 = !1;
    $6909e5993a213e12$var$isInputEventSupported = $6909e5993a213e12$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $6909e5993a213e12$var$stopWatchingForValueChange() {
    $6909e5993a213e12$var$activeElement$1 && ($6909e5993a213e12$var$activeElement$1.detachEvent("onpropertychange", $6909e5993a213e12$var$handlePropertyChange), $6909e5993a213e12$var$activeElementInst$1 = $6909e5993a213e12$var$activeElement$1 = null);
}
function $6909e5993a213e12$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $6909e5993a213e12$var$getInstIfValueChanged($6909e5993a213e12$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $6909e5993a213e12$var$createAndAccumulateChangeEvent(dispatchQueue, $6909e5993a213e12$var$activeElementInst$1, nativeEvent, $6909e5993a213e12$var$getEventTarget(nativeEvent));
        $6909e5993a213e12$var$batchedUpdates$1($6909e5993a213e12$var$runEventInBatch, dispatchQueue);
    }
}
function $6909e5993a213e12$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($6909e5993a213e12$var$stopWatchingForValueChange(), $6909e5993a213e12$var$activeElement$1 = target, $6909e5993a213e12$var$activeElementInst$1 = targetInst, $6909e5993a213e12$var$activeElement$1.attachEvent("onpropertychange", $6909e5993a213e12$var$handlePropertyChange)) : "focusout" === domEventName && $6909e5993a213e12$var$stopWatchingForValueChange();
}
function $6909e5993a213e12$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $6909e5993a213e12$var$getInstIfValueChanged($6909e5993a213e12$var$activeElementInst$1);
}
function $6909e5993a213e12$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $6909e5993a213e12$var$getInstIfValueChanged(targetInst);
}
function $6909e5993a213e12$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $6909e5993a213e12$var$getInstIfValueChanged(targetInst);
}
function $6909e5993a213e12$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $6909e5993a213e12$var$objectIs = "function" === typeof Object.is ? Object.is : $6909e5993a213e12$var$is;
function $6909e5993a213e12$var$shallowEqual(objA, objB) {
    if ($6909e5993a213e12$var$objectIs(objA, objB)) return !0;
    if ("object" !== (typeof objA === "undefined" ? "undefined" : (0, $03bAP._)(objA)) || null === objA || "object" !== (typeof objB === "undefined" ? "undefined" : (0, $03bAP._)(objB)) || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$6909e5993a213e12$var$hasOwnProperty.call(objB, currentKey) || !$6909e5993a213e12$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $6909e5993a213e12$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $6909e5993a213e12$var$getNodeForCharacterOffset(root, offset) {
    var node = $6909e5993a213e12$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $6909e5993a213e12$var$getLeafNode(node);
    }
}
function $6909e5993a213e12$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $6909e5993a213e12$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $6909e5993a213e12$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $6909e5993a213e12$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $6909e5993a213e12$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $6909e5993a213e12$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $6909e5993a213e12$var$skipSelectionChangeEvent = $6909e5993a213e12$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $6909e5993a213e12$var$activeElement = null, $6909e5993a213e12$var$activeElementInst = null, $6909e5993a213e12$var$lastSelection = null, $6909e5993a213e12$var$mouseDown = !1;
function $6909e5993a213e12$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $6909e5993a213e12$var$mouseDown || null == $6909e5993a213e12$var$activeElement || $6909e5993a213e12$var$activeElement !== $6909e5993a213e12$var$getActiveElement(doc) || (doc = $6909e5993a213e12$var$activeElement, "selectionStart" in doc && $6909e5993a213e12$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $6909e5993a213e12$var$lastSelection && $6909e5993a213e12$var$shallowEqual($6909e5993a213e12$var$lastSelection, doc) || ($6909e5993a213e12$var$lastSelection = doc, doc = $6909e5993a213e12$var$accumulateTwoPhaseListeners($6909e5993a213e12$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $6909e5993a213e12$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $6909e5993a213e12$var$activeElement)));
}
function $6909e5993a213e12$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $6909e5993a213e12$var$vendorPrefixes = {
    animationend: $6909e5993a213e12$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $6909e5993a213e12$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $6909e5993a213e12$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $6909e5993a213e12$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $6909e5993a213e12$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $6909e5993a213e12$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $6909e5993a213e12$var$makePrefixMap("Transition", "TransitionEnd")
}, $6909e5993a213e12$var$prefixedEventNames = {}, $6909e5993a213e12$var$style = {};
$6909e5993a213e12$var$canUseDOM && ($6909e5993a213e12$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $6909e5993a213e12$var$vendorPrefixes.animationend.animation, delete $6909e5993a213e12$var$vendorPrefixes.animationiteration.animation, delete $6909e5993a213e12$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $6909e5993a213e12$var$vendorPrefixes.transitionend.transition);
function $6909e5993a213e12$var$getVendorPrefixedEventName(eventName) {
    if ($6909e5993a213e12$var$prefixedEventNames[eventName]) return $6909e5993a213e12$var$prefixedEventNames[eventName];
    if (!$6909e5993a213e12$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $6909e5993a213e12$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $6909e5993a213e12$var$style) return $6909e5993a213e12$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $6909e5993a213e12$var$ANIMATION_END = $6909e5993a213e12$var$getVendorPrefixedEventName("animationend"), $6909e5993a213e12$var$ANIMATION_ITERATION = $6909e5993a213e12$var$getVendorPrefixedEventName("animationiteration"), $6909e5993a213e12$var$ANIMATION_START = $6909e5993a213e12$var$getVendorPrefixedEventName("animationstart"), $6909e5993a213e12$var$TRANSITION_RUN = $6909e5993a213e12$var$getVendorPrefixedEventName("transitionrun"), $6909e5993a213e12$var$TRANSITION_START = $6909e5993a213e12$var$getVendorPrefixedEventName("transitionstart"), $6909e5993a213e12$var$TRANSITION_CANCEL = $6909e5993a213e12$var$getVendorPrefixedEventName("transitioncancel"), $6909e5993a213e12$var$TRANSITION_END = $6909e5993a213e12$var$getVendorPrefixedEventName("transitionend"), $6909e5993a213e12$var$topLevelEventsToReactNames = new Map(), $6909e5993a213e12$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$6909e5993a213e12$var$simpleEventPluginEvents.push("scrollEnd");
function $6909e5993a213e12$var$registerSimpleEvent(domEventName, reactName) {
    $6909e5993a213e12$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $6909e5993a213e12$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $6909e5993a213e12$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $03bAP._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $03bAP._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $6909e5993a213e12$var$concurrentQueues = [], $6909e5993a213e12$var$concurrentQueuesIndex = 0, $6909e5993a213e12$var$concurrentlyUpdatedLanes = 0;
function $6909e5993a213e12$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $6909e5993a213e12$var$concurrentQueuesIndex, i = $6909e5993a213e12$var$concurrentlyUpdatedLanes = $6909e5993a213e12$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $6909e5993a213e12$var$concurrentQueues[i];
        $6909e5993a213e12$var$concurrentQueues[i++] = null;
        var queue = $6909e5993a213e12$var$concurrentQueues[i];
        $6909e5993a213e12$var$concurrentQueues[i++] = null;
        var update = $6909e5993a213e12$var$concurrentQueues[i];
        $6909e5993a213e12$var$concurrentQueues[i++] = null;
        var lane = $6909e5993a213e12$var$concurrentQueues[i];
        $6909e5993a213e12$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $6909e5993a213e12$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $6909e5993a213e12$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $6909e5993a213e12$var$concurrentQueues[$6909e5993a213e12$var$concurrentQueuesIndex++] = fiber;
    $6909e5993a213e12$var$concurrentQueues[$6909e5993a213e12$var$concurrentQueuesIndex++] = queue;
    $6909e5993a213e12$var$concurrentQueues[$6909e5993a213e12$var$concurrentQueuesIndex++] = update;
    $6909e5993a213e12$var$concurrentQueues[$6909e5993a213e12$var$concurrentQueuesIndex++] = lane;
    $6909e5993a213e12$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $6909e5993a213e12$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $6909e5993a213e12$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $6909e5993a213e12$var$getRootForUpdatedFiber(fiber);
}
function $6909e5993a213e12$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $6909e5993a213e12$var$enqueueUpdate$1(fiber, null, null, lane);
    return $6909e5993a213e12$var$getRootForUpdatedFiber(fiber);
}
function $6909e5993a213e12$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $6909e5993a213e12$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $6909e5993a213e12$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $6909e5993a213e12$var$nestedUpdateCount) throw $6909e5993a213e12$var$nestedUpdateCount = 0, $6909e5993a213e12$var$rootWithNestedUpdates = null, Error($6909e5993a213e12$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $6909e5993a213e12$var$emptyContextObject = {};
function $6909e5993a213e12$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $6909e5993a213e12$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $6909e5993a213e12$var$FiberNode(tag, pendingProps, key, mode);
}
function $6909e5993a213e12$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $6909e5993a213e12$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $6909e5993a213e12$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $6909e5993a213e12$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $6909e5993a213e12$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $6909e5993a213e12$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $6909e5993a213e12$var$isHostHoistableType(type, pendingProps, $6909e5993a213e12$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $6909e5993a213e12$var$REACT_ACTIVITY_TYPE:
            return type = $6909e5993a213e12$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $6909e5993a213e12$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $6909e5993a213e12$var$REACT_FRAGMENT_TYPE:
            return $6909e5993a213e12$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $6909e5993a213e12$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $6909e5993a213e12$var$REACT_PROFILER_TYPE:
            return type = $6909e5993a213e12$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $6909e5993a213e12$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $6909e5993a213e12$var$REACT_SUSPENSE_TYPE:
            return type = $6909e5993a213e12$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $6909e5993a213e12$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $6909e5993a213e12$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $6909e5993a213e12$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $6909e5993a213e12$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === (typeof type === "undefined" ? "undefined" : (0, $03bAP._)(type)) && null !== type) switch(type.$$typeof){
                case $6909e5993a213e12$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $6909e5993a213e12$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $6909e5993a213e12$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $6909e5993a213e12$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $6909e5993a213e12$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($6909e5993a213e12$var$formatProdErrorMessage(130, null === type ? "null" : typeof type === "undefined" ? "undefined" : (0, $03bAP._)(type), ""));
            owner = null;
    }
    key = $6909e5993a213e12$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $6909e5993a213e12$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $6909e5993a213e12$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $6909e5993a213e12$var$createFiberFromText(content, mode, lanes) {
    content = $6909e5993a213e12$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $6909e5993a213e12$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $6909e5993a213e12$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $6909e5993a213e12$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $6909e5993a213e12$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $6909e5993a213e12$var$CapturedStacks = new WeakMap();
function $6909e5993a213e12$var$createCapturedValueAtFiber(value, source) {
    if ("object" === (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) && null !== value) {
        var existing = $6909e5993a213e12$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $6909e5993a213e12$var$getStackByFiberInDevAndProd(source)
        };
        $6909e5993a213e12$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $6909e5993a213e12$var$getStackByFiberInDevAndProd(source)
    };
}
var $6909e5993a213e12$var$forkStack = [], $6909e5993a213e12$var$forkStackIndex = 0, $6909e5993a213e12$var$treeForkProvider = null, $6909e5993a213e12$var$treeForkCount = 0, $6909e5993a213e12$var$idStack = [], $6909e5993a213e12$var$idStackIndex = 0, $6909e5993a213e12$var$treeContextProvider = null, $6909e5993a213e12$var$treeContextId = 1, $6909e5993a213e12$var$treeContextOverflow = "";
function $6909e5993a213e12$var$pushTreeFork(workInProgress, totalChildren) {
    $6909e5993a213e12$var$forkStack[$6909e5993a213e12$var$forkStackIndex++] = $6909e5993a213e12$var$treeForkCount;
    $6909e5993a213e12$var$forkStack[$6909e5993a213e12$var$forkStackIndex++] = $6909e5993a213e12$var$treeForkProvider;
    $6909e5993a213e12$var$treeForkProvider = workInProgress;
    $6909e5993a213e12$var$treeForkCount = totalChildren;
}
function $6909e5993a213e12$var$pushTreeId(workInProgress, totalChildren, index) {
    $6909e5993a213e12$var$idStack[$6909e5993a213e12$var$idStackIndex++] = $6909e5993a213e12$var$treeContextId;
    $6909e5993a213e12$var$idStack[$6909e5993a213e12$var$idStackIndex++] = $6909e5993a213e12$var$treeContextOverflow;
    $6909e5993a213e12$var$idStack[$6909e5993a213e12$var$idStackIndex++] = $6909e5993a213e12$var$treeContextProvider;
    $6909e5993a213e12$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $6909e5993a213e12$var$treeContextId;
    workInProgress = $6909e5993a213e12$var$treeContextOverflow;
    var baseLength = 32 - $6909e5993a213e12$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $6909e5993a213e12$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $6909e5993a213e12$var$treeContextId = 1 << 32 - $6909e5993a213e12$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $6909e5993a213e12$var$treeContextOverflow = length + workInProgress;
    } else $6909e5993a213e12$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $6909e5993a213e12$var$treeContextOverflow = workInProgress;
}
function $6909e5993a213e12$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($6909e5993a213e12$var$pushTreeFork(workInProgress, 1), $6909e5993a213e12$var$pushTreeId(workInProgress, 1, 0));
}
function $6909e5993a213e12$var$popTreeContext(workInProgress) {
    for(; workInProgress === $6909e5993a213e12$var$treeForkProvider;)$6909e5993a213e12$var$treeForkProvider = $6909e5993a213e12$var$forkStack[--$6909e5993a213e12$var$forkStackIndex], $6909e5993a213e12$var$forkStack[$6909e5993a213e12$var$forkStackIndex] = null, $6909e5993a213e12$var$treeForkCount = $6909e5993a213e12$var$forkStack[--$6909e5993a213e12$var$forkStackIndex], $6909e5993a213e12$var$forkStack[$6909e5993a213e12$var$forkStackIndex] = null;
    for(; workInProgress === $6909e5993a213e12$var$treeContextProvider;)$6909e5993a213e12$var$treeContextProvider = $6909e5993a213e12$var$idStack[--$6909e5993a213e12$var$idStackIndex], $6909e5993a213e12$var$idStack[$6909e5993a213e12$var$idStackIndex] = null, $6909e5993a213e12$var$treeContextOverflow = $6909e5993a213e12$var$idStack[--$6909e5993a213e12$var$idStackIndex], $6909e5993a213e12$var$idStack[$6909e5993a213e12$var$idStackIndex] = null, $6909e5993a213e12$var$treeContextId = $6909e5993a213e12$var$idStack[--$6909e5993a213e12$var$idStackIndex], $6909e5993a213e12$var$idStack[$6909e5993a213e12$var$idStackIndex] = null;
}
function $6909e5993a213e12$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $6909e5993a213e12$var$idStack[$6909e5993a213e12$var$idStackIndex++] = $6909e5993a213e12$var$treeContextId;
    $6909e5993a213e12$var$idStack[$6909e5993a213e12$var$idStackIndex++] = $6909e5993a213e12$var$treeContextOverflow;
    $6909e5993a213e12$var$idStack[$6909e5993a213e12$var$idStackIndex++] = $6909e5993a213e12$var$treeContextProvider;
    $6909e5993a213e12$var$treeContextId = suspendedContext.id;
    $6909e5993a213e12$var$treeContextOverflow = suspendedContext.overflow;
    $6909e5993a213e12$var$treeContextProvider = workInProgress;
}
var $6909e5993a213e12$var$hydrationParentFiber = null, $6909e5993a213e12$var$nextHydratableInstance = null, $6909e5993a213e12$var$isHydrating = !1, $6909e5993a213e12$var$hydrationErrors = null, $6909e5993a213e12$var$rootOrSingletonContext = !1, $6909e5993a213e12$var$HydrationMismatchException = Error($6909e5993a213e12$var$formatProdErrorMessage(519));
function $6909e5993a213e12$var$throwOnHydrationMismatch(fiber) {
    var error = Error($6909e5993a213e12$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $6909e5993a213e12$var$queueHydrationError($6909e5993a213e12$var$createCapturedValueAtFiber(error, fiber));
    throw $6909e5993a213e12$var$HydrationMismatchException;
}
function $6909e5993a213e12$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$6909e5993a213e12$var$internalInstanceKey] = fiber;
    instance[$6909e5993a213e12$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("cancel", instance);
            $6909e5993a213e12$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $6909e5993a213e12$var$mediaEventTypes.length; type++)$6909e5993a213e12$var$listenToNonDelegatedEvent($6909e5993a213e12$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("error", instance);
            $6909e5993a213e12$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("invalid", instance);
            $6909e5993a213e12$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("invalid", instance), $6909e5993a213e12$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== (typeof type === "undefined" ? "undefined" : (0, $03bAP._)(type)) || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $6909e5993a213e12$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($6909e5993a213e12$var$listenToNonDelegatedEvent("beforetoggle", instance), $6909e5993a213e12$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $6909e5993a213e12$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $6909e5993a213e12$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $6909e5993a213e12$var$noop$1), instance = !0) : instance = !1;
    instance || $6909e5993a213e12$var$throwOnHydrationMismatch(fiber, !0);
}
function $6909e5993a213e12$var$popToNextHostParent(fiber) {
    for($6909e5993a213e12$var$hydrationParentFiber = fiber.return; $6909e5993a213e12$var$hydrationParentFiber;)switch($6909e5993a213e12$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $6909e5993a213e12$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $6909e5993a213e12$var$rootOrSingletonContext = !0;
            return;
        default:
            $6909e5993a213e12$var$hydrationParentFiber = $6909e5993a213e12$var$hydrationParentFiber.return;
    }
}
function $6909e5993a213e12$var$popHydrationState(fiber) {
    if (fiber !== $6909e5993a213e12$var$hydrationParentFiber) return !1;
    if (!$6909e5993a213e12$var$isHydrating) return $6909e5993a213e12$var$popToNextHostParent(fiber), $6909e5993a213e12$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $6909e5993a213e12$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $6909e5993a213e12$var$nextHydratableInstance && $6909e5993a213e12$var$throwOnHydrationMismatch(fiber);
    $6909e5993a213e12$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($6909e5993a213e12$var$formatProdErrorMessage(317));
        $6909e5993a213e12$var$nextHydratableInstance = $6909e5993a213e12$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($6909e5993a213e12$var$formatProdErrorMessage(317));
        $6909e5993a213e12$var$nextHydratableInstance = $6909e5993a213e12$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $6909e5993a213e12$var$nextHydratableInstance, $6909e5993a213e12$var$isSingletonScope(fiber.type) ? (fiber = $6909e5993a213e12$var$previousHydratableOnEnteringScopedSingleton, $6909e5993a213e12$var$previousHydratableOnEnteringScopedSingleton = null, $6909e5993a213e12$var$nextHydratableInstance = fiber) : $6909e5993a213e12$var$nextHydratableInstance = tag) : $6909e5993a213e12$var$nextHydratableInstance = $6909e5993a213e12$var$hydrationParentFiber ? $6909e5993a213e12$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $6909e5993a213e12$var$resetHydrationState() {
    $6909e5993a213e12$var$nextHydratableInstance = $6909e5993a213e12$var$hydrationParentFiber = null;
    $6909e5993a213e12$var$isHydrating = !1;
}
function $6909e5993a213e12$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $6909e5993a213e12$var$hydrationErrors;
    null !== queuedErrors && (null === $6909e5993a213e12$var$workInProgressRootRecoverableErrors ? $6909e5993a213e12$var$workInProgressRootRecoverableErrors = queuedErrors : $6909e5993a213e12$var$workInProgressRootRecoverableErrors.push.apply($6909e5993a213e12$var$workInProgressRootRecoverableErrors, queuedErrors), $6909e5993a213e12$var$hydrationErrors = null);
    return queuedErrors;
}
function $6909e5993a213e12$var$queueHydrationError(error) {
    null === $6909e5993a213e12$var$hydrationErrors ? $6909e5993a213e12$var$hydrationErrors = [
        error
    ] : $6909e5993a213e12$var$hydrationErrors.push(error);
}
var $6909e5993a213e12$var$valueCursor = $6909e5993a213e12$var$createCursor(null), $6909e5993a213e12$var$currentlyRenderingFiber$1 = null, $6909e5993a213e12$var$lastContextDependency = null;
function $6909e5993a213e12$var$pushProvider(providerFiber, context, nextValue) {
    $6909e5993a213e12$var$push($6909e5993a213e12$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $6909e5993a213e12$var$popProvider(context) {
    context._currentValue = $6909e5993a213e12$var$valueCursor.current;
    $6909e5993a213e12$var$pop($6909e5993a213e12$var$valueCursor);
}
function $6909e5993a213e12$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $6909e5993a213e12$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $6909e5993a213e12$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($6909e5993a213e12$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $6909e5993a213e12$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $6909e5993a213e12$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($6909e5993a213e12$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $6909e5993a213e12$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $6909e5993a213e12$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($6909e5993a213e12$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($6909e5993a213e12$var$HostTransitionContext) : current = [
                $6909e5993a213e12$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $6909e5993a213e12$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $6909e5993a213e12$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$6909e5993a213e12$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $6909e5993a213e12$var$prepareToReadContext(workInProgress) {
    $6909e5993a213e12$var$currentlyRenderingFiber$1 = workInProgress;
    $6909e5993a213e12$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $6909e5993a213e12$var$readContext(context) {
    return $6909e5993a213e12$var$readContextForConsumer($6909e5993a213e12$var$currentlyRenderingFiber$1, context);
}
function $6909e5993a213e12$var$readContextDuringReconciliation(consumer, context) {
    null === $6909e5993a213e12$var$currentlyRenderingFiber$1 && $6909e5993a213e12$var$prepareToReadContext(consumer);
    return $6909e5993a213e12$var$readContextForConsumer(consumer, context);
}
function $6909e5993a213e12$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $6909e5993a213e12$var$lastContextDependency) {
        if (null === consumer) throw Error($6909e5993a213e12$var$formatProdErrorMessage(308));
        $6909e5993a213e12$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $6909e5993a213e12$var$lastContextDependency = $6909e5993a213e12$var$lastContextDependency.next = context;
    return value;
}
var $6909e5993a213e12$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function AbortControllerLocal() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function addEventListener(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $6909e5993a213e12$var$scheduleCallback$2 = $4Q55w.unstable_scheduleCallback, $6909e5993a213e12$var$NormalPriority = $4Q55w.unstable_NormalPriority, $6909e5993a213e12$var$CacheContext = {
    $$typeof: $6909e5993a213e12$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $6909e5993a213e12$var$createCache() {
    return {
        controller: new $6909e5993a213e12$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $6909e5993a213e12$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $6909e5993a213e12$var$scheduleCallback$2($6909e5993a213e12$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $6909e5993a213e12$var$currentEntangledListeners = null, $6909e5993a213e12$var$currentEntangledPendingCount = 0, $6909e5993a213e12$var$currentEntangledLane = 0, $6909e5993a213e12$var$currentEntangledActionThenable = null;
function $6909e5993a213e12$var$entangleAsyncAction(transition, thenable) {
    if (null === $6909e5993a213e12$var$currentEntangledListeners) {
        var entangledListeners = $6909e5993a213e12$var$currentEntangledListeners = [];
        $6909e5993a213e12$var$currentEntangledPendingCount = 0;
        $6909e5993a213e12$var$currentEntangledLane = $6909e5993a213e12$var$requestTransitionLane();
        $6909e5993a213e12$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function then(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $6909e5993a213e12$var$currentEntangledPendingCount++;
    thenable.then($6909e5993a213e12$var$pingEngtangledActionScope, $6909e5993a213e12$var$pingEngtangledActionScope);
    return thenable;
}
function $6909e5993a213e12$var$pingEngtangledActionScope() {
    if (0 === --$6909e5993a213e12$var$currentEntangledPendingCount && null !== $6909e5993a213e12$var$currentEntangledListeners) {
        null !== $6909e5993a213e12$var$currentEntangledActionThenable && ($6909e5993a213e12$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $6909e5993a213e12$var$currentEntangledListeners;
        $6909e5993a213e12$var$currentEntangledListeners = null;
        $6909e5993a213e12$var$currentEntangledLane = 0;
        $6909e5993a213e12$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $6909e5993a213e12$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function then(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $6909e5993a213e12$var$prevOnStartTransitionFinish = $6909e5993a213e12$var$ReactSharedInternals.S;
$6909e5993a213e12$var$ReactSharedInternals.S = function(transition, returnValue) {
    $6909e5993a213e12$var$globalMostRecentTransitionTime = $6909e5993a213e12$var$now();
    "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $03bAP._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && $6909e5993a213e12$var$entangleAsyncAction(transition, returnValue);
    null !== $6909e5993a213e12$var$prevOnStartTransitionFinish && $6909e5993a213e12$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $6909e5993a213e12$var$resumedCache = $6909e5993a213e12$var$createCursor(null);
function $6909e5993a213e12$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $6909e5993a213e12$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $6909e5993a213e12$var$workInProgressRoot.pooledCache;
}
function $6909e5993a213e12$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $6909e5993a213e12$var$push($6909e5993a213e12$var$resumedCache, $6909e5993a213e12$var$resumedCache.current) : $6909e5993a213e12$var$push($6909e5993a213e12$var$resumedCache, prevCachePool.pool);
}
function $6909e5993a213e12$var$getSuspendedCache() {
    var cacheFromPool = $6909e5993a213e12$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $6909e5993a213e12$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $6909e5993a213e12$var$SuspenseException = Error($6909e5993a213e12$var$formatProdErrorMessage(460)), $6909e5993a213e12$var$SuspenseyCommitException = Error($6909e5993a213e12$var$formatProdErrorMessage(474)), $6909e5993a213e12$var$SuspenseActionException = Error($6909e5993a213e12$var$formatProdErrorMessage(542)), $6909e5993a213e12$var$noopSuspenseyCommitThenable = {
    then: function then() {}
};
function $6909e5993a213e12$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $6909e5993a213e12$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($6909e5993a213e12$var$noop$1, $6909e5993a213e12$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $6909e5993a213e12$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($6909e5993a213e12$var$noop$1, $6909e5993a213e12$var$noop$1);
            else {
                thenableState = $6909e5993a213e12$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($6909e5993a213e12$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $6909e5993a213e12$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $6909e5993a213e12$var$suspendedThenable = thenable;
            throw $6909e5993a213e12$var$SuspenseException;
    }
}
function $6909e5993a213e12$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === (typeof x === "undefined" ? "undefined" : (0, $03bAP._)(x)) && "function" === typeof x.then) throw $6909e5993a213e12$var$suspendedThenable = x, $6909e5993a213e12$var$SuspenseException;
        throw x;
    }
}
var $6909e5993a213e12$var$suspendedThenable = null;
function $6909e5993a213e12$var$getSuspendedThenable() {
    if (null === $6909e5993a213e12$var$suspendedThenable) throw Error($6909e5993a213e12$var$formatProdErrorMessage(459));
    var thenable = $6909e5993a213e12$var$suspendedThenable;
    $6909e5993a213e12$var$suspendedThenable = null;
    return thenable;
}
function $6909e5993a213e12$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $6909e5993a213e12$var$SuspenseException || rejectedReason === $6909e5993a213e12$var$SuspenseActionException) throw Error($6909e5993a213e12$var$formatProdErrorMessage(483));
}
var $6909e5993a213e12$var$thenableState$1 = null, $6909e5993a213e12$var$thenableIndexCounter$1 = 0;
function $6909e5993a213e12$var$unwrapThenable(thenable) {
    var index = $6909e5993a213e12$var$thenableIndexCounter$1;
    $6909e5993a213e12$var$thenableIndexCounter$1 += 1;
    null === $6909e5993a213e12$var$thenableState$1 && ($6909e5993a213e12$var$thenableState$1 = []);
    return $6909e5993a213e12$var$trackUsedThenable($6909e5993a213e12$var$thenableState$1, thenable, index);
}
function $6909e5993a213e12$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $6909e5993a213e12$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $6909e5993a213e12$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($6909e5993a213e12$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($6909e5993a213e12$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $6909e5993a213e12$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $6909e5993a213e12$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $6909e5993a213e12$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $6909e5993a213e12$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === (typeof elementType === "undefined" ? "undefined" : (0, $03bAP._)(elementType)) && null !== elementType && elementType.$$typeof === $6909e5993a213e12$var$REACT_LAZY_TYPE && $6909e5993a213e12$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $6909e5993a213e12$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $6909e5993a213e12$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $6909e5993a213e12$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $6909e5993a213e12$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $6909e5993a213e12$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $03bAP._)(newChild))) return newChild = $6909e5993a213e12$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $03bAP._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $6909e5993a213e12$var$REACT_ELEMENT_TYPE:
                    return lanes = $6909e5993a213e12$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $6909e5993a213e12$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $6909e5993a213e12$var$REACT_PORTAL_TYPE:
                    return newChild = $6909e5993a213e12$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $6909e5993a213e12$var$REACT_LAZY_TYPE:
                    return newChild = $6909e5993a213e12$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($6909e5993a213e12$var$isArrayImpl(newChild) || $6909e5993a213e12$var$getIteratorFn(newChild)) return newChild = $6909e5993a213e12$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $6909e5993a213e12$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $6909e5993a213e12$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $6909e5993a213e12$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $6909e5993a213e12$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $03bAP._)(newChild))) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $03bAP._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $6909e5993a213e12$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $6909e5993a213e12$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $6909e5993a213e12$var$REACT_LAZY_TYPE:
                    return newChild = $6909e5993a213e12$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($6909e5993a213e12$var$isArrayImpl(newChild) || $6909e5993a213e12$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $6909e5993a213e12$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $6909e5993a213e12$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $6909e5993a213e12$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $6909e5993a213e12$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $03bAP._)(newChild))) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $03bAP._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $6909e5993a213e12$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $6909e5993a213e12$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $6909e5993a213e12$var$REACT_LAZY_TYPE:
                    return newChild = $6909e5993a213e12$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($6909e5993a213e12$var$isArrayImpl(newChild) || $6909e5993a213e12$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $6909e5993a213e12$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $6909e5993a213e12$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $6909e5993a213e12$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $6909e5993a213e12$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $6909e5993a213e12$var$isHydrating && $6909e5993a213e12$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $6909e5993a213e12$var$isHydrating && $6909e5993a213e12$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $6909e5993a213e12$var$isHydrating && $6909e5993a213e12$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($6909e5993a213e12$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $6909e5993a213e12$var$isHydrating && $6909e5993a213e12$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $6909e5993a213e12$var$isHydrating && $6909e5993a213e12$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $6909e5993a213e12$var$isHydrating && $6909e5993a213e12$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === (typeof newChild === "undefined" ? "undefined" : (0, $03bAP._)(newChild)) && null !== newChild && newChild.type === $6909e5993a213e12$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $03bAP._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $6909e5993a213e12$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $6909e5993a213e12$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === (typeof key === "undefined" ? "undefined" : (0, $03bAP._)(key)) && null !== key && key.$$typeof === $6909e5993a213e12$var$REACT_LAZY_TYPE && $6909e5993a213e12$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $6909e5993a213e12$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $6909e5993a213e12$var$REACT_FRAGMENT_TYPE ? (lanes = $6909e5993a213e12$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $6909e5993a213e12$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $6909e5993a213e12$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $6909e5993a213e12$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $6909e5993a213e12$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $6909e5993a213e12$var$REACT_LAZY_TYPE:
                    return newChild = $6909e5993a213e12$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($6909e5993a213e12$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($6909e5993a213e12$var$getIteratorFn(newChild)) {
                key = $6909e5993a213e12$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($6909e5993a213e12$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $6909e5993a213e12$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $6909e5993a213e12$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $6909e5993a213e12$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $6909e5993a213e12$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $03bAP._)(newChild)) ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $6909e5993a213e12$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $6909e5993a213e12$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $6909e5993a213e12$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $6909e5993a213e12$var$SuspenseException || x === $6909e5993a213e12$var$SuspenseActionException) throw x;
            var fiber = $6909e5993a213e12$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $6909e5993a213e12$var$reconcileChildFibers = $6909e5993a213e12$var$createChildReconciler(!0), $6909e5993a213e12$var$mountChildFibers = $6909e5993a213e12$var$createChildReconciler(!1), $6909e5993a213e12$var$hasForceUpdate = !1;
function $6909e5993a213e12$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $6909e5993a213e12$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $6909e5993a213e12$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $6909e5993a213e12$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($6909e5993a213e12$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $6909e5993a213e12$var$getRootForUpdatedFiber(fiber);
        $6909e5993a213e12$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $6909e5993a213e12$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $6909e5993a213e12$var$getRootForUpdatedFiber(fiber);
}
function $6909e5993a213e12$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $6909e5993a213e12$var$markRootEntangled(root, lane);
    }
}
function $6909e5993a213e12$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $6909e5993a213e12$var$didReadFromEntangledAsyncAction = !1;
function $6909e5993a213e12$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($6909e5993a213e12$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $6909e5993a213e12$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $6909e5993a213e12$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $6909e5993a213e12$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $6909e5993a213e12$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($6909e5993a213e12$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $6909e5993a213e12$var$currentEntangledLane && ($6909e5993a213e12$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $6909e5993a213e12$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $6909e5993a213e12$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $6909e5993a213e12$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $6909e5993a213e12$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($6909e5993a213e12$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $6909e5993a213e12$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$6909e5993a213e12$var$callCallback(callbacks[updateQueue], context);
}
var $6909e5993a213e12$var$currentTreeHiddenStackCursor = $6909e5993a213e12$var$createCursor(null), $6909e5993a213e12$var$prevEntangledRenderLanesCursor = $6909e5993a213e12$var$createCursor(0);
function $6909e5993a213e12$var$pushHiddenContext(fiber, context) {
    fiber = $6909e5993a213e12$var$entangledRenderLanes;
    $6909e5993a213e12$var$push($6909e5993a213e12$var$prevEntangledRenderLanesCursor, fiber);
    $6909e5993a213e12$var$push($6909e5993a213e12$var$currentTreeHiddenStackCursor, context);
    $6909e5993a213e12$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $6909e5993a213e12$var$reuseHiddenContextOnStack() {
    $6909e5993a213e12$var$push($6909e5993a213e12$var$prevEntangledRenderLanesCursor, $6909e5993a213e12$var$entangledRenderLanes);
    $6909e5993a213e12$var$push($6909e5993a213e12$var$currentTreeHiddenStackCursor, $6909e5993a213e12$var$currentTreeHiddenStackCursor.current);
}
function $6909e5993a213e12$var$popHiddenContext() {
    $6909e5993a213e12$var$entangledRenderLanes = $6909e5993a213e12$var$prevEntangledRenderLanesCursor.current;
    $6909e5993a213e12$var$pop($6909e5993a213e12$var$currentTreeHiddenStackCursor);
    $6909e5993a213e12$var$pop($6909e5993a213e12$var$prevEntangledRenderLanesCursor);
}
var $6909e5993a213e12$var$suspenseHandlerStackCursor = $6909e5993a213e12$var$createCursor(null), $6909e5993a213e12$var$shellBoundary = null;
function $6909e5993a213e12$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $6909e5993a213e12$var$push($6909e5993a213e12$var$suspenseStackCursor, $6909e5993a213e12$var$suspenseStackCursor.current & 1);
    $6909e5993a213e12$var$push($6909e5993a213e12$var$suspenseHandlerStackCursor, handler);
    null === $6909e5993a213e12$var$shellBoundary && (null === current || null !== $6909e5993a213e12$var$currentTreeHiddenStackCursor.current ? $6909e5993a213e12$var$shellBoundary = handler : null !== current.memoizedState && ($6909e5993a213e12$var$shellBoundary = handler));
}
function $6909e5993a213e12$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $6909e5993a213e12$var$push($6909e5993a213e12$var$suspenseStackCursor, $6909e5993a213e12$var$suspenseStackCursor.current);
    $6909e5993a213e12$var$push($6909e5993a213e12$var$suspenseHandlerStackCursor, fiber);
    null === $6909e5993a213e12$var$shellBoundary && ($6909e5993a213e12$var$shellBoundary = fiber);
}
function $6909e5993a213e12$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($6909e5993a213e12$var$push($6909e5993a213e12$var$suspenseStackCursor, $6909e5993a213e12$var$suspenseStackCursor.current), $6909e5993a213e12$var$push($6909e5993a213e12$var$suspenseHandlerStackCursor, fiber), null === $6909e5993a213e12$var$shellBoundary && ($6909e5993a213e12$var$shellBoundary = fiber)) : $6909e5993a213e12$var$reuseSuspenseHandlerOnStack(fiber);
}
function $6909e5993a213e12$var$reuseSuspenseHandlerOnStack() {
    $6909e5993a213e12$var$push($6909e5993a213e12$var$suspenseStackCursor, $6909e5993a213e12$var$suspenseStackCursor.current);
    $6909e5993a213e12$var$push($6909e5993a213e12$var$suspenseHandlerStackCursor, $6909e5993a213e12$var$suspenseHandlerStackCursor.current);
}
function $6909e5993a213e12$var$popSuspenseHandler(fiber) {
    $6909e5993a213e12$var$pop($6909e5993a213e12$var$suspenseHandlerStackCursor);
    $6909e5993a213e12$var$shellBoundary === fiber && ($6909e5993a213e12$var$shellBoundary = null);
    $6909e5993a213e12$var$pop($6909e5993a213e12$var$suspenseStackCursor);
}
var $6909e5993a213e12$var$suspenseStackCursor = $6909e5993a213e12$var$createCursor(0);
function $6909e5993a213e12$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $6909e5993a213e12$var$isSuspenseInstancePending(state) || $6909e5993a213e12$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $6909e5993a213e12$var$renderLanes = 0, $6909e5993a213e12$var$currentlyRenderingFiber = null, $6909e5993a213e12$var$currentHook = null, $6909e5993a213e12$var$workInProgressHook = null, $6909e5993a213e12$var$didScheduleRenderPhaseUpdate = !1, $6909e5993a213e12$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $6909e5993a213e12$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $6909e5993a213e12$var$localIdCounter = 0, $6909e5993a213e12$var$thenableIndexCounter = 0, $6909e5993a213e12$var$thenableState = null, $6909e5993a213e12$var$globalClientIdCounter = 0;
function $6909e5993a213e12$var$throwInvalidHookError() {
    throw Error($6909e5993a213e12$var$formatProdErrorMessage(321));
}
function $6909e5993a213e12$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$6909e5993a213e12$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $6909e5993a213e12$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $6909e5993a213e12$var$renderLanes = nextRenderLanes;
    $6909e5993a213e12$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $6909e5993a213e12$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $6909e5993a213e12$var$HooksDispatcherOnMount : $6909e5993a213e12$var$HooksDispatcherOnUpdate;
    $6909e5993a213e12$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $6909e5993a213e12$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $6909e5993a213e12$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $6909e5993a213e12$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $6909e5993a213e12$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $6909e5993a213e12$var$finishRenderingHooks(current) {
    $6909e5993a213e12$var$ReactSharedInternals.H = $6909e5993a213e12$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $6909e5993a213e12$var$currentHook && null !== $6909e5993a213e12$var$currentHook.next;
    $6909e5993a213e12$var$renderLanes = 0;
    $6909e5993a213e12$var$workInProgressHook = $6909e5993a213e12$var$currentHook = $6909e5993a213e12$var$currentlyRenderingFiber = null;
    $6909e5993a213e12$var$didScheduleRenderPhaseUpdate = !1;
    $6909e5993a213e12$var$thenableIndexCounter = 0;
    $6909e5993a213e12$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($6909e5993a213e12$var$formatProdErrorMessage(300));
    null === current || $6909e5993a213e12$var$didReceiveUpdate || (current = current.dependencies, null !== current && $6909e5993a213e12$var$checkIfContextChanged(current) && ($6909e5993a213e12$var$didReceiveUpdate = !0));
}
function $6909e5993a213e12$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $6909e5993a213e12$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $6909e5993a213e12$var$didScheduleRenderPhaseUpdateDuringThisPass && ($6909e5993a213e12$var$thenableState = null);
        $6909e5993a213e12$var$thenableIndexCounter = 0;
        $6909e5993a213e12$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($6909e5993a213e12$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $6909e5993a213e12$var$workInProgressHook = $6909e5993a213e12$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $6909e5993a213e12$var$ReactSharedInternals.H = $6909e5993a213e12$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($6909e5993a213e12$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $6909e5993a213e12$var$TransitionAwareHostComponent() {
    var dispatcher = $6909e5993a213e12$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $6909e5993a213e12$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $6909e5993a213e12$var$currentHook ? $6909e5993a213e12$var$currentHook.memoizedState : null) !== dispatcher && ($6909e5993a213e12$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $6909e5993a213e12$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $6909e5993a213e12$var$localIdCounter;
    $6909e5993a213e12$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $6909e5993a213e12$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $6909e5993a213e12$var$resetHooksOnUnwind(workInProgress) {
    if ($6909e5993a213e12$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $6909e5993a213e12$var$didScheduleRenderPhaseUpdate = !1;
    }
    $6909e5993a213e12$var$renderLanes = 0;
    $6909e5993a213e12$var$workInProgressHook = $6909e5993a213e12$var$currentHook = $6909e5993a213e12$var$currentlyRenderingFiber = null;
    $6909e5993a213e12$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $6909e5993a213e12$var$thenableIndexCounter = $6909e5993a213e12$var$localIdCounter = 0;
    $6909e5993a213e12$var$thenableState = null;
}
function $6909e5993a213e12$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $6909e5993a213e12$var$workInProgressHook ? $6909e5993a213e12$var$currentlyRenderingFiber.memoizedState = $6909e5993a213e12$var$workInProgressHook = hook : $6909e5993a213e12$var$workInProgressHook = $6909e5993a213e12$var$workInProgressHook.next = hook;
    return $6909e5993a213e12$var$workInProgressHook;
}
function $6909e5993a213e12$var$updateWorkInProgressHook() {
    if (null === $6909e5993a213e12$var$currentHook) {
        var nextCurrentHook = $6909e5993a213e12$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $6909e5993a213e12$var$currentHook.next;
    var nextWorkInProgressHook = null === $6909e5993a213e12$var$workInProgressHook ? $6909e5993a213e12$var$currentlyRenderingFiber.memoizedState : $6909e5993a213e12$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $6909e5993a213e12$var$workInProgressHook = nextWorkInProgressHook, $6909e5993a213e12$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $6909e5993a213e12$var$currentlyRenderingFiber.alternate) throw Error($6909e5993a213e12$var$formatProdErrorMessage(467));
            throw Error($6909e5993a213e12$var$formatProdErrorMessage(310));
        }
        $6909e5993a213e12$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $6909e5993a213e12$var$currentHook.memoizedState,
            baseState: $6909e5993a213e12$var$currentHook.baseState,
            baseQueue: $6909e5993a213e12$var$currentHook.baseQueue,
            queue: $6909e5993a213e12$var$currentHook.queue,
            next: null
        };
        null === $6909e5993a213e12$var$workInProgressHook ? $6909e5993a213e12$var$currentlyRenderingFiber.memoizedState = $6909e5993a213e12$var$workInProgressHook = nextCurrentHook : $6909e5993a213e12$var$workInProgressHook = $6909e5993a213e12$var$workInProgressHook.next = nextCurrentHook;
    }
    return $6909e5993a213e12$var$workInProgressHook;
}
function $6909e5993a213e12$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $6909e5993a213e12$var$useThenable(thenable) {
    var index = $6909e5993a213e12$var$thenableIndexCounter;
    $6909e5993a213e12$var$thenableIndexCounter += 1;
    null === $6909e5993a213e12$var$thenableState && ($6909e5993a213e12$var$thenableState = []);
    thenable = $6909e5993a213e12$var$trackUsedThenable($6909e5993a213e12$var$thenableState, thenable, index);
    index = $6909e5993a213e12$var$currentlyRenderingFiber;
    null === (null === $6909e5993a213e12$var$workInProgressHook ? index.memoizedState : $6909e5993a213e12$var$workInProgressHook.next) && (index = index.alternate, $6909e5993a213e12$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $6909e5993a213e12$var$HooksDispatcherOnMount : $6909e5993a213e12$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $6909e5993a213e12$var$use(usable) {
    if (null !== usable && "object" === (typeof usable === "undefined" ? "undefined" : (0, $03bAP._)(usable))) {
        if ("function" === typeof usable.then) return $6909e5993a213e12$var$useThenable(usable);
        if (usable.$$typeof === $6909e5993a213e12$var$REACT_CONTEXT_TYPE) return $6909e5993a213e12$var$readContext(usable);
    }
    throw Error($6909e5993a213e12$var$formatProdErrorMessage(438, String(usable)));
}
function $6909e5993a213e12$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $6909e5993a213e12$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $6909e5993a213e12$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $6909e5993a213e12$var$createFunctionComponentUpdateQueue(), $6909e5993a213e12$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $6909e5993a213e12$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $6909e5993a213e12$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $6909e5993a213e12$var$updateReducer(reducer) {
    var hook = $6909e5993a213e12$var$updateWorkInProgressHook();
    return $6909e5993a213e12$var$updateReducerImpl(hook, $6909e5993a213e12$var$currentHook, reducer);
}
function $6909e5993a213e12$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($6909e5993a213e12$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($6909e5993a213e12$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($6909e5993a213e12$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $6909e5993a213e12$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($6909e5993a213e12$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $6909e5993a213e12$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $6909e5993a213e12$var$currentlyRenderingFiber.lanes |= revertLane, $6909e5993a213e12$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $6909e5993a213e12$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $6909e5993a213e12$var$currentlyRenderingFiber.lanes |= updateLane, $6909e5993a213e12$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$6909e5993a213e12$var$objectIs(pendingQueue, hook.memoizedState) && ($6909e5993a213e12$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $6909e5993a213e12$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $6909e5993a213e12$var$rerenderReducer(reducer) {
    var hook = $6909e5993a213e12$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($6909e5993a213e12$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $6909e5993a213e12$var$objectIs(newState, hook.memoizedState) || ($6909e5993a213e12$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $6909e5993a213e12$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $6909e5993a213e12$var$currentlyRenderingFiber, hook = $6909e5993a213e12$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $6909e5993a213e12$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($6909e5993a213e12$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$6909e5993a213e12$var$objectIs(($6909e5993a213e12$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $6909e5993a213e12$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $6909e5993a213e12$var$updateEffect($6909e5993a213e12$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $6909e5993a213e12$var$workInProgressHook && $6909e5993a213e12$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $6909e5993a213e12$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $6909e5993a213e12$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $6909e5993a213e12$var$workInProgressRoot) throw Error($6909e5993a213e12$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($6909e5993a213e12$var$renderLanes & 127) || $6909e5993a213e12$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $6909e5993a213e12$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $6909e5993a213e12$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $6909e5993a213e12$var$createFunctionComponentUpdateQueue(), $6909e5993a213e12$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $6909e5993a213e12$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $6909e5993a213e12$var$checkIfSnapshotChanged(inst) && $6909e5993a213e12$var$forceStoreRerender(fiber);
}
function $6909e5993a213e12$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $6909e5993a213e12$var$checkIfSnapshotChanged(inst) && $6909e5993a213e12$var$forceStoreRerender(fiber);
    });
}
function $6909e5993a213e12$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$6909e5993a213e12$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $6909e5993a213e12$var$forceStoreRerender(fiber) {
    var root = $6909e5993a213e12$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $6909e5993a213e12$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $6909e5993a213e12$var$mountStateImpl(initialState) {
    var hook = $6909e5993a213e12$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($6909e5993a213e12$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $6909e5993a213e12$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $6909e5993a213e12$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $6909e5993a213e12$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $6909e5993a213e12$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $6909e5993a213e12$var$updateReducerImpl(hook, $6909e5993a213e12$var$currentHook, "function" === typeof reducer ? reducer : $6909e5993a213e12$var$basicStateReducer);
}
function $6909e5993a213e12$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($6909e5993a213e12$var$isRenderPhaseUpdate(fiber)) throw Error($6909e5993a213e12$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function then(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $6909e5993a213e12$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $6909e5993a213e12$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $6909e5993a213e12$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $6909e5993a213e12$var$ReactSharedInternals.T, currentTransition = {};
        $6909e5993a213e12$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $6909e5993a213e12$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $6909e5993a213e12$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $6909e5993a213e12$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $6909e5993a213e12$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $6909e5993a213e12$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $6909e5993a213e12$var$onActionError(actionQueue, node, error$66);
    }
}
function $6909e5993a213e12$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $03bAP._)(returnValue)) && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $6909e5993a213e12$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $6909e5993a213e12$var$onActionError(actionQueue, node, error);
    }) : $6909e5993a213e12$var$onActionSuccess(actionQueue, node, returnValue);
}
function $6909e5993a213e12$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $6909e5993a213e12$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $6909e5993a213e12$var$runActionStateAction(actionQueue, nextState)));
}
function $6909e5993a213e12$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $6909e5993a213e12$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $6909e5993a213e12$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $6909e5993a213e12$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $6909e5993a213e12$var$mountActionState(action, initialStateProp) {
    if ($6909e5993a213e12$var$isHydrating) {
        var ssrFormState = $6909e5993a213e12$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $6909e5993a213e12$var$currentlyRenderingFiber;
                if ($6909e5993a213e12$var$isHydrating) {
                    if ($6909e5993a213e12$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $6909e5993a213e12$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $6909e5993a213e12$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $6909e5993a213e12$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $6909e5993a213e12$var$nextHydratableInstance = $6909e5993a213e12$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $6909e5993a213e12$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $6909e5993a213e12$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $6909e5993a213e12$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $6909e5993a213e12$var$dispatchSetState.bind(null, $6909e5993a213e12$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $6909e5993a213e12$var$mountStateImpl(!1);
    inRootOrSingleton = $6909e5993a213e12$var$dispatchOptimisticSetState.bind(null, $6909e5993a213e12$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $6909e5993a213e12$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $6909e5993a213e12$var$dispatchActionState.bind(null, $6909e5993a213e12$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $6909e5993a213e12$var$updateActionState(action) {
    var stateHook = $6909e5993a213e12$var$updateWorkInProgressHook();
    return $6909e5993a213e12$var$updateActionStateImpl(stateHook, $6909e5993a213e12$var$currentHook, action);
}
function $6909e5993a213e12$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $6909e5993a213e12$var$updateReducerImpl(stateHook, currentStateHook, $6909e5993a213e12$var$actionStateReducer)[0];
    stateHook = $6909e5993a213e12$var$updateReducer($6909e5993a213e12$var$basicStateReducer)[0];
    if ("object" === (typeof currentStateHook === "undefined" ? "undefined" : (0, $03bAP._)(currentStateHook)) && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $6909e5993a213e12$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $6909e5993a213e12$var$SuspenseException) throw $6909e5993a213e12$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $6909e5993a213e12$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($6909e5993a213e12$var$currentlyRenderingFiber.flags |= 2048, $6909e5993a213e12$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $6909e5993a213e12$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $6909e5993a213e12$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $6909e5993a213e12$var$rerenderActionState(action) {
    var stateHook = $6909e5993a213e12$var$updateWorkInProgressHook(), currentStateHook = $6909e5993a213e12$var$currentHook;
    if (null !== currentStateHook) return $6909e5993a213e12$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $6909e5993a213e12$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $6909e5993a213e12$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $6909e5993a213e12$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $6909e5993a213e12$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $6909e5993a213e12$var$createFunctionComponentUpdateQueue(), $6909e5993a213e12$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $6909e5993a213e12$var$updateRef() {
    return $6909e5993a213e12$var$updateWorkInProgressHook().memoizedState;
}
function $6909e5993a213e12$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $6909e5993a213e12$var$mountWorkInProgressHook();
    $6909e5993a213e12$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $6909e5993a213e12$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $6909e5993a213e12$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $6909e5993a213e12$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $6909e5993a213e12$var$currentHook && null !== deps && $6909e5993a213e12$var$areHookInputsEqual(deps, $6909e5993a213e12$var$currentHook.memoizedState.deps) ? hook.memoizedState = $6909e5993a213e12$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($6909e5993a213e12$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $6909e5993a213e12$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $6909e5993a213e12$var$mountEffect(create, deps) {
    $6909e5993a213e12$var$mountEffectImpl(8390656, 8, create, deps);
}
function $6909e5993a213e12$var$updateEffect(create, deps) {
    $6909e5993a213e12$var$updateEffectImpl(2048, 8, create, deps);
}
function $6909e5993a213e12$var$useEffectEventImpl(payload) {
    $6909e5993a213e12$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $6909e5993a213e12$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $6909e5993a213e12$var$createFunctionComponentUpdateQueue(), $6909e5993a213e12$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $6909e5993a213e12$var$updateEvent(callback) {
    var ref = $6909e5993a213e12$var$updateWorkInProgressHook().memoizedState;
    $6909e5993a213e12$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($6909e5993a213e12$var$executionContext & 2)) throw Error($6909e5993a213e12$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $6909e5993a213e12$var$updateInsertionEffect(create, deps) {
    return $6909e5993a213e12$var$updateEffectImpl(4, 2, create, deps);
}
function $6909e5993a213e12$var$updateLayoutEffect(create, deps) {
    return $6909e5993a213e12$var$updateEffectImpl(4, 4, create, deps);
}
function $6909e5993a213e12$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $6909e5993a213e12$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $6909e5993a213e12$var$updateEffectImpl(4, 4, $6909e5993a213e12$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $6909e5993a213e12$var$mountDebugValue() {}
function $6909e5993a213e12$var$updateCallback(callback, deps) {
    var hook = $6909e5993a213e12$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $6909e5993a213e12$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $6909e5993a213e12$var$updateMemo(nextCreate, deps) {
    var hook = $6909e5993a213e12$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $6909e5993a213e12$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($6909e5993a213e12$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $6909e5993a213e12$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $6909e5993a213e12$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $6909e5993a213e12$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($6909e5993a213e12$var$renderLanes & 1073741824) && 0 === ($6909e5993a213e12$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $6909e5993a213e12$var$requestDeferredLane();
    $6909e5993a213e12$var$currentlyRenderingFiber.lanes |= hook;
    $6909e5993a213e12$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $6909e5993a213e12$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($6909e5993a213e12$var$objectIs(value, prevValue)) return value;
    if (null !== $6909e5993a213e12$var$currentTreeHiddenStackCursor.current) return hook = $6909e5993a213e12$var$mountDeferredValueImpl(hook, value, initialValue), $6909e5993a213e12$var$objectIs(hook, prevValue) || ($6909e5993a213e12$var$didReceiveUpdate = !0), hook;
    if (0 === ($6909e5993a213e12$var$renderLanes & 42) || 0 !== ($6909e5993a213e12$var$renderLanes & 1073741824) && 0 === ($6909e5993a213e12$var$workInProgressRootRenderLanes & 261930)) return $6909e5993a213e12$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $6909e5993a213e12$var$requestDeferredLane();
    $6909e5993a213e12$var$currentlyRenderingFiber.lanes |= hook;
    $6909e5993a213e12$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $6909e5993a213e12$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $6909e5993a213e12$var$ReactDOMSharedInternals.p;
    $6909e5993a213e12$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $6909e5993a213e12$var$ReactSharedInternals.T, currentTransition = {};
    $6909e5993a213e12$var$ReactSharedInternals.T = currentTransition;
    $6909e5993a213e12$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $6909e5993a213e12$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $03bAP._)(returnValue)) && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $6909e5993a213e12$var$chainThenableValue(returnValue, finishedState);
            $6909e5993a213e12$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $6909e5993a213e12$var$requestUpdateLane(fiber));
        } else $6909e5993a213e12$var$dispatchSetStateInternal(fiber, queue, finishedState, $6909e5993a213e12$var$requestUpdateLane(fiber));
    } catch (error) {
        $6909e5993a213e12$var$dispatchSetStateInternal(fiber, queue, {
            then: function then() {},
            status: "rejected",
            reason: error
        }, $6909e5993a213e12$var$requestUpdateLane());
    } finally{
        $6909e5993a213e12$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $6909e5993a213e12$var$ReactSharedInternals.T = prevTransition;
    }
}
function $6909e5993a213e12$var$noop() {}
function $6909e5993a213e12$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($6909e5993a213e12$var$formatProdErrorMessage(476));
    var queue = $6909e5993a213e12$var$ensureFormComponentIsStateful(formFiber).queue;
    $6909e5993a213e12$var$startTransition(formFiber, queue, pendingState, $6909e5993a213e12$var$sharedNotPendingObject, null === action ? $6909e5993a213e12$var$noop : function() {
        $6909e5993a213e12$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $6909e5993a213e12$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $6909e5993a213e12$var$sharedNotPendingObject,
        baseState: $6909e5993a213e12$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $6909e5993a213e12$var$basicStateReducer,
            lastRenderedState: $6909e5993a213e12$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $6909e5993a213e12$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $6909e5993a213e12$var$requestFormReset$1(formFiber) {
    var stateHook = $6909e5993a213e12$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $6909e5993a213e12$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $6909e5993a213e12$var$requestUpdateLane());
}
function $6909e5993a213e12$var$useHostTransitionStatus() {
    return $6909e5993a213e12$var$readContext($6909e5993a213e12$var$HostTransitionContext);
}
function $6909e5993a213e12$var$updateId() {
    return $6909e5993a213e12$var$updateWorkInProgressHook().memoizedState;
}
function $6909e5993a213e12$var$updateRefresh() {
    return $6909e5993a213e12$var$updateWorkInProgressHook().memoizedState;
}
function $6909e5993a213e12$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $6909e5993a213e12$var$requestUpdateLane();
                fiber = $6909e5993a213e12$var$createUpdate(lane);
                var root$69 = $6909e5993a213e12$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($6909e5993a213e12$var$scheduleUpdateOnFiber(root$69, provider, lane), $6909e5993a213e12$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $6909e5993a213e12$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $6909e5993a213e12$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $6909e5993a213e12$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $6909e5993a213e12$var$isRenderPhaseUpdate(fiber) ? $6909e5993a213e12$var$enqueueRenderPhaseUpdate(queue, action) : (action = $6909e5993a213e12$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($6909e5993a213e12$var$scheduleUpdateOnFiber(action, fiber, lane), $6909e5993a213e12$var$entangleTransitionUpdate(action, queue, lane)));
}
function $6909e5993a213e12$var$dispatchSetState(fiber, queue, action) {
    var lane = $6909e5993a213e12$var$requestUpdateLane();
    $6909e5993a213e12$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $6909e5993a213e12$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($6909e5993a213e12$var$isRenderPhaseUpdate(fiber)) $6909e5993a213e12$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($6909e5993a213e12$var$objectIs(eagerState, currentState)) return $6909e5993a213e12$var$enqueueUpdate$1(fiber, queue, update, 0), null === $6909e5993a213e12$var$workInProgressRoot && $6909e5993a213e12$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $6909e5993a213e12$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $6909e5993a213e12$var$scheduleUpdateOnFiber(action, fiber, lane), $6909e5993a213e12$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $6909e5993a213e12$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $6909e5993a213e12$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($6909e5993a213e12$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($6909e5993a213e12$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $6909e5993a213e12$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $6909e5993a213e12$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $6909e5993a213e12$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $6909e5993a213e12$var$currentlyRenderingFiber || null !== alternate && alternate === $6909e5993a213e12$var$currentlyRenderingFiber;
}
function $6909e5993a213e12$var$enqueueRenderPhaseUpdate(queue, update) {
    $6909e5993a213e12$var$didScheduleRenderPhaseUpdateDuringThisPass = $6909e5993a213e12$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $6909e5993a213e12$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $6909e5993a213e12$var$markRootEntangled(root, lane);
    }
}
var $6909e5993a213e12$var$ContextOnlyDispatcher = {
    readContext: $6909e5993a213e12$var$readContext,
    use: $6909e5993a213e12$var$use,
    useCallback: $6909e5993a213e12$var$throwInvalidHookError,
    useContext: $6909e5993a213e12$var$throwInvalidHookError,
    useEffect: $6909e5993a213e12$var$throwInvalidHookError,
    useImperativeHandle: $6909e5993a213e12$var$throwInvalidHookError,
    useLayoutEffect: $6909e5993a213e12$var$throwInvalidHookError,
    useInsertionEffect: $6909e5993a213e12$var$throwInvalidHookError,
    useMemo: $6909e5993a213e12$var$throwInvalidHookError,
    useReducer: $6909e5993a213e12$var$throwInvalidHookError,
    useRef: $6909e5993a213e12$var$throwInvalidHookError,
    useState: $6909e5993a213e12$var$throwInvalidHookError,
    useDebugValue: $6909e5993a213e12$var$throwInvalidHookError,
    useDeferredValue: $6909e5993a213e12$var$throwInvalidHookError,
    useTransition: $6909e5993a213e12$var$throwInvalidHookError,
    useSyncExternalStore: $6909e5993a213e12$var$throwInvalidHookError,
    useId: $6909e5993a213e12$var$throwInvalidHookError,
    useHostTransitionStatus: $6909e5993a213e12$var$throwInvalidHookError,
    useFormState: $6909e5993a213e12$var$throwInvalidHookError,
    useActionState: $6909e5993a213e12$var$throwInvalidHookError,
    useOptimistic: $6909e5993a213e12$var$throwInvalidHookError,
    useMemoCache: $6909e5993a213e12$var$throwInvalidHookError,
    useCacheRefresh: $6909e5993a213e12$var$throwInvalidHookError
};
$6909e5993a213e12$var$ContextOnlyDispatcher.useEffectEvent = $6909e5993a213e12$var$throwInvalidHookError;
var $6909e5993a213e12$var$HooksDispatcherOnMount = {
    readContext: $6909e5993a213e12$var$readContext,
    use: $6909e5993a213e12$var$use,
    useCallback: function useCallback(callback, deps) {
        $6909e5993a213e12$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $6909e5993a213e12$var$readContext,
    useEffect: $6909e5993a213e12$var$mountEffect,
    useImperativeHandle: function useImperativeHandle(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $6909e5993a213e12$var$mountEffectImpl(4194308, 4, $6909e5993a213e12$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function useLayoutEffect(create, deps) {
        return $6909e5993a213e12$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function useInsertionEffect(create, deps) {
        $6909e5993a213e12$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function useMemo(nextCreate, deps) {
        var hook = $6909e5993a213e12$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($6909e5993a213e12$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $6909e5993a213e12$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $6909e5993a213e12$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function useReducer(reducer, initialArg, init) {
        var hook = $6909e5993a213e12$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($6909e5993a213e12$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $6909e5993a213e12$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $6909e5993a213e12$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $6909e5993a213e12$var$dispatchReducerAction.bind(null, $6909e5993a213e12$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function useRef(initialValue) {
        var hook = $6909e5993a213e12$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function useState(initialState) {
        initialState = $6909e5993a213e12$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $6909e5993a213e12$var$dispatchSetState.bind(null, $6909e5993a213e12$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $6909e5993a213e12$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $6909e5993a213e12$var$mountWorkInProgressHook();
        return $6909e5993a213e12$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function useTransition() {
        var stateHook = $6909e5993a213e12$var$mountStateImpl(!1);
        stateHook = $6909e5993a213e12$var$startTransition.bind(null, $6909e5993a213e12$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $6909e5993a213e12$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $6909e5993a213e12$var$currentlyRenderingFiber, hook = $6909e5993a213e12$var$mountWorkInProgressHook();
        if ($6909e5993a213e12$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($6909e5993a213e12$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $6909e5993a213e12$var$workInProgressRoot) throw Error($6909e5993a213e12$var$formatProdErrorMessage(349));
            0 !== ($6909e5993a213e12$var$workInProgressRootRenderLanes & 127) || $6909e5993a213e12$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $6909e5993a213e12$var$mountEffect($6909e5993a213e12$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $6909e5993a213e12$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $6909e5993a213e12$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function useId() {
        var hook = $6909e5993a213e12$var$mountWorkInProgressHook(), identifierPrefix = $6909e5993a213e12$var$workInProgressRoot.identifierPrefix;
        if ($6909e5993a213e12$var$isHydrating) {
            var JSCompiler_inline_result = $6909e5993a213e12$var$treeContextOverflow;
            var idWithLeadingBit = $6909e5993a213e12$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $6909e5993a213e12$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $6909e5993a213e12$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $6909e5993a213e12$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $6909e5993a213e12$var$useHostTransitionStatus,
    useFormState: $6909e5993a213e12$var$mountActionState,
    useActionState: $6909e5993a213e12$var$mountActionState,
    useOptimistic: function useOptimistic(passthrough) {
        var hook = $6909e5993a213e12$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $6909e5993a213e12$var$dispatchOptimisticSetState.bind(null, $6909e5993a213e12$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $6909e5993a213e12$var$useMemoCache,
    useCacheRefresh: function useCacheRefresh() {
        return $6909e5993a213e12$var$mountWorkInProgressHook().memoizedState = $6909e5993a213e12$var$refreshCache.bind(null, $6909e5993a213e12$var$currentlyRenderingFiber);
    },
    useEffectEvent: function useEffectEvent(callback) {
        var hook = $6909e5993a213e12$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($6909e5993a213e12$var$executionContext & 2)) throw Error($6909e5993a213e12$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $6909e5993a213e12$var$HooksDispatcherOnUpdate = {
    readContext: $6909e5993a213e12$var$readContext,
    use: $6909e5993a213e12$var$use,
    useCallback: $6909e5993a213e12$var$updateCallback,
    useContext: $6909e5993a213e12$var$readContext,
    useEffect: $6909e5993a213e12$var$updateEffect,
    useImperativeHandle: $6909e5993a213e12$var$updateImperativeHandle,
    useInsertionEffect: $6909e5993a213e12$var$updateInsertionEffect,
    useLayoutEffect: $6909e5993a213e12$var$updateLayoutEffect,
    useMemo: $6909e5993a213e12$var$updateMemo,
    useReducer: $6909e5993a213e12$var$updateReducer,
    useRef: $6909e5993a213e12$var$updateRef,
    useState: function useState() {
        return $6909e5993a213e12$var$updateReducer($6909e5993a213e12$var$basicStateReducer);
    },
    useDebugValue: $6909e5993a213e12$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $6909e5993a213e12$var$updateWorkInProgressHook();
        return $6909e5993a213e12$var$updateDeferredValueImpl(hook, $6909e5993a213e12$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $6909e5993a213e12$var$updateReducer($6909e5993a213e12$var$basicStateReducer)[0], start = $6909e5993a213e12$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $6909e5993a213e12$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $6909e5993a213e12$var$updateSyncExternalStore,
    useId: $6909e5993a213e12$var$updateId,
    useHostTransitionStatus: $6909e5993a213e12$var$useHostTransitionStatus,
    useFormState: $6909e5993a213e12$var$updateActionState,
    useActionState: $6909e5993a213e12$var$updateActionState,
    useOptimistic: function useOptimistic(passthrough, reducer) {
        var hook = $6909e5993a213e12$var$updateWorkInProgressHook();
        return $6909e5993a213e12$var$updateOptimisticImpl(hook, $6909e5993a213e12$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $6909e5993a213e12$var$useMemoCache,
    useCacheRefresh: $6909e5993a213e12$var$updateRefresh
};
$6909e5993a213e12$var$HooksDispatcherOnUpdate.useEffectEvent = $6909e5993a213e12$var$updateEvent;
var $6909e5993a213e12$var$HooksDispatcherOnRerender = {
    readContext: $6909e5993a213e12$var$readContext,
    use: $6909e5993a213e12$var$use,
    useCallback: $6909e5993a213e12$var$updateCallback,
    useContext: $6909e5993a213e12$var$readContext,
    useEffect: $6909e5993a213e12$var$updateEffect,
    useImperativeHandle: $6909e5993a213e12$var$updateImperativeHandle,
    useInsertionEffect: $6909e5993a213e12$var$updateInsertionEffect,
    useLayoutEffect: $6909e5993a213e12$var$updateLayoutEffect,
    useMemo: $6909e5993a213e12$var$updateMemo,
    useReducer: $6909e5993a213e12$var$rerenderReducer,
    useRef: $6909e5993a213e12$var$updateRef,
    useState: function useState() {
        return $6909e5993a213e12$var$rerenderReducer($6909e5993a213e12$var$basicStateReducer);
    },
    useDebugValue: $6909e5993a213e12$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $6909e5993a213e12$var$updateWorkInProgressHook();
        return null === $6909e5993a213e12$var$currentHook ? $6909e5993a213e12$var$mountDeferredValueImpl(hook, value, initialValue) : $6909e5993a213e12$var$updateDeferredValueImpl(hook, $6909e5993a213e12$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $6909e5993a213e12$var$rerenderReducer($6909e5993a213e12$var$basicStateReducer)[0], start = $6909e5993a213e12$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $6909e5993a213e12$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $6909e5993a213e12$var$updateSyncExternalStore,
    useId: $6909e5993a213e12$var$updateId,
    useHostTransitionStatus: $6909e5993a213e12$var$useHostTransitionStatus,
    useFormState: $6909e5993a213e12$var$rerenderActionState,
    useActionState: $6909e5993a213e12$var$rerenderActionState,
    useOptimistic: function useOptimistic(passthrough, reducer) {
        var hook = $6909e5993a213e12$var$updateWorkInProgressHook();
        if (null !== $6909e5993a213e12$var$currentHook) return $6909e5993a213e12$var$updateOptimisticImpl(hook, $6909e5993a213e12$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $6909e5993a213e12$var$useMemoCache,
    useCacheRefresh: $6909e5993a213e12$var$updateRefresh
};
$6909e5993a213e12$var$HooksDispatcherOnRerender.useEffectEvent = $6909e5993a213e12$var$updateEvent;
function $6909e5993a213e12$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $6909e5993a213e12$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $6909e5993a213e12$var$classComponentUpdater = {
    enqueueSetState: function enqueueSetState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $6909e5993a213e12$var$requestUpdateLane(), update = $6909e5993a213e12$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $6909e5993a213e12$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($6909e5993a213e12$var$scheduleUpdateOnFiber(payload, inst, lane), $6909e5993a213e12$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $6909e5993a213e12$var$requestUpdateLane(), update = $6909e5993a213e12$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $6909e5993a213e12$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($6909e5993a213e12$var$scheduleUpdateOnFiber(payload, inst, lane), $6909e5993a213e12$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
        inst = inst._reactInternals;
        var lane = $6909e5993a213e12$var$requestUpdateLane(), update = $6909e5993a213e12$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $6909e5993a213e12$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($6909e5993a213e12$var$scheduleUpdateOnFiber(callback, inst, lane), $6909e5993a213e12$var$entangleTransitions(callback, inst, lane));
    }
};
function $6909e5993a213e12$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$6909e5993a213e12$var$shallowEqual(oldProps, newProps) || !$6909e5993a213e12$var$shallowEqual(oldState, newState) : !0;
}
function $6909e5993a213e12$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $6909e5993a213e12$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $6909e5993a213e12$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $6909e5993a213e12$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $6909e5993a213e12$var$defaultOnUncaughtError(error) {
    $6909e5993a213e12$var$reportGlobalError(error);
}
function $6909e5993a213e12$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $6909e5993a213e12$var$defaultOnRecoverableError(error) {
    $6909e5993a213e12$var$reportGlobalError(error);
}
function $6909e5993a213e12$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $6909e5993a213e12$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $6909e5993a213e12$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $6909e5993a213e12$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $6909e5993a213e12$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $6909e5993a213e12$var$createClassErrorUpdate(lane) {
    lane = $6909e5993a213e12$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $6909e5993a213e12$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $6909e5993a213e12$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $6909e5993a213e12$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $6909e5993a213e12$var$legacyErrorBoundariesThatAlreadyFailed ? $6909e5993a213e12$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $6909e5993a213e12$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $6909e5993a213e12$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $6909e5993a213e12$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $6909e5993a213e12$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $6909e5993a213e12$var$shellBoundary ? $6909e5993a213e12$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $6909e5993a213e12$var$workInProgressRootExitStatus && ($6909e5993a213e12$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $6909e5993a213e12$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $6909e5993a213e12$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $6909e5993a213e12$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $6909e5993a213e12$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($6909e5993a213e12$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $6909e5993a213e12$var$attachPingListener(root, value, rootRenderLanes);
        $6909e5993a213e12$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($6909e5993a213e12$var$isHydrating) return returnFiber = $6909e5993a213e12$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $6909e5993a213e12$var$HydrationMismatchException && (root = Error($6909e5993a213e12$var$formatProdErrorMessage(422), {
        cause: value
    }), $6909e5993a213e12$var$queueHydrationError($6909e5993a213e12$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $6909e5993a213e12$var$HydrationMismatchException && (returnFiber = Error($6909e5993a213e12$var$formatProdErrorMessage(423), {
        cause: value
    }), $6909e5993a213e12$var$queueHydrationError($6909e5993a213e12$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $6909e5993a213e12$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $6909e5993a213e12$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $6909e5993a213e12$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $6909e5993a213e12$var$workInProgressRootExitStatus && ($6909e5993a213e12$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($6909e5993a213e12$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $6909e5993a213e12$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $6909e5993a213e12$var$workInProgressRootConcurrentErrors ? $6909e5993a213e12$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $6909e5993a213e12$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $6909e5993a213e12$var$workInProgressRootExitStatus && ($6909e5993a213e12$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $6909e5993a213e12$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $6909e5993a213e12$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $6909e5993a213e12$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $6909e5993a213e12$var$legacyErrorBoundariesThatAlreadyFailed || !$6909e5993a213e12$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $6909e5993a213e12$var$createClassErrorUpdate(rootRenderLanes), $6909e5993a213e12$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $6909e5993a213e12$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $6909e5993a213e12$var$SelectiveHydrationException = Error($6909e5993a213e12$var$formatProdErrorMessage(461)), $6909e5993a213e12$var$didReceiveUpdate = !1;
function $6909e5993a213e12$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $6909e5993a213e12$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $6909e5993a213e12$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $6909e5993a213e12$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $6909e5993a213e12$var$prepareToReadContext(workInProgress);
    nextProps = $6909e5993a213e12$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $6909e5993a213e12$var$checkDidRenderIdHook();
    if (null !== current && !$6909e5993a213e12$var$didReceiveUpdate) return $6909e5993a213e12$var$bailoutHooks(current, workInProgress, renderLanes), $6909e5993a213e12$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $6909e5993a213e12$var$isHydrating && key && $6909e5993a213e12$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $6909e5993a213e12$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $6909e5993a213e12$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$6909e5993a213e12$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $6909e5993a213e12$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $6909e5993a213e12$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$6909e5993a213e12$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $6909e5993a213e12$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $6909e5993a213e12$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $6909e5993a213e12$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $6909e5993a213e12$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($6909e5993a213e12$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($6909e5993a213e12$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $6909e5993a213e12$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($6909e5993a213e12$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $6909e5993a213e12$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $6909e5993a213e12$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $6909e5993a213e12$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $6909e5993a213e12$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $6909e5993a213e12$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $6909e5993a213e12$var$pushHiddenContext(workInProgress, prevState) : $6909e5993a213e12$var$reuseHiddenContextOnStack(), $6909e5993a213e12$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $6909e5993a213e12$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($6909e5993a213e12$var$pushTransition(workInProgress, prevState.cachePool), $6909e5993a213e12$var$pushHiddenContext(workInProgress, prevState), $6909e5993a213e12$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $6909e5993a213e12$var$pushTransition(workInProgress, null), $6909e5993a213e12$var$reuseHiddenContextOnStack(), $6909e5993a213e12$var$reuseSuspenseHandlerOnStack(workInProgress));
    $6909e5993a213e12$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $6909e5993a213e12$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $6909e5993a213e12$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $6909e5993a213e12$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $6909e5993a213e12$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $6909e5993a213e12$var$pushTransition(workInProgress, null);
    $6909e5993a213e12$var$reuseHiddenContextOnStack();
    $6909e5993a213e12$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $6909e5993a213e12$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $6909e5993a213e12$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $6909e5993a213e12$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $6909e5993a213e12$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $6909e5993a213e12$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $6909e5993a213e12$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $6909e5993a213e12$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $6909e5993a213e12$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($6909e5993a213e12$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $6909e5993a213e12$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $6909e5993a213e12$var$bailoutOffscreenComponent(null, current);
            $6909e5993a213e12$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $6909e5993a213e12$var$nextHydratableInstance) ? (current = $6909e5993a213e12$var$canHydrateHydrationBoundary(current, $6909e5993a213e12$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $6909e5993a213e12$var$treeContextProvider ? {
                    id: $6909e5993a213e12$var$treeContextId,
                    overflow: $6909e5993a213e12$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $6909e5993a213e12$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $6909e5993a213e12$var$hydrationParentFiber = workInProgress, $6909e5993a213e12$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $6909e5993a213e12$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $6909e5993a213e12$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $6909e5993a213e12$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $6909e5993a213e12$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($6909e5993a213e12$var$formatProdErrorMessage(558));
        } else if ($6909e5993a213e12$var$didReceiveUpdate || $6909e5993a213e12$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $6909e5993a213e12$var$didReceiveUpdate || didSuspend) {
            nextProps = $6909e5993a213e12$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $6909e5993a213e12$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $6909e5993a213e12$var$enqueueConcurrentRenderForLane(current, dehydrated), $6909e5993a213e12$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $6909e5993a213e12$var$SelectiveHydrationException;
            $6909e5993a213e12$var$renderDidSuspendDelayIfPossible();
            workInProgress = $6909e5993a213e12$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $6909e5993a213e12$var$nextHydratableInstance = $6909e5993a213e12$var$getNextHydratable(dehydrated.nextSibling), $6909e5993a213e12$var$hydrationParentFiber = workInProgress, $6909e5993a213e12$var$isHydrating = !0, $6909e5993a213e12$var$hydrationErrors = null, $6909e5993a213e12$var$rootOrSingletonContext = !1, null !== current && $6909e5993a213e12$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $6909e5993a213e12$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $6909e5993a213e12$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $6909e5993a213e12$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== (typeof ref === "undefined" ? "undefined" : (0, $03bAP._)(ref))) throw Error($6909e5993a213e12$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $6909e5993a213e12$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $6909e5993a213e12$var$prepareToReadContext(workInProgress);
    Component = $6909e5993a213e12$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $6909e5993a213e12$var$checkDidRenderIdHook();
    if (null !== current && !$6909e5993a213e12$var$didReceiveUpdate) return $6909e5993a213e12$var$bailoutHooks(current, workInProgress, renderLanes), $6909e5993a213e12$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $6909e5993a213e12$var$isHydrating && nextProps && $6909e5993a213e12$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $6909e5993a213e12$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $6909e5993a213e12$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $6909e5993a213e12$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $6909e5993a213e12$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $6909e5993a213e12$var$finishRenderingHooks(current);
    Component = $6909e5993a213e12$var$checkDidRenderIdHook();
    if (null !== current && !$6909e5993a213e12$var$didReceiveUpdate) return $6909e5993a213e12$var$bailoutHooks(current, workInProgress, renderLanes), $6909e5993a213e12$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $6909e5993a213e12$var$isHydrating && Component && $6909e5993a213e12$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $6909e5993a213e12$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $6909e5993a213e12$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $6909e5993a213e12$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $6909e5993a213e12$var$emptyContextObject, contextType = Component.contextType;
        "object" === (typeof contextType === "undefined" ? "undefined" : (0, $03bAP._)(contextType)) && null !== contextType && (context = $6909e5993a213e12$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $6909e5993a213e12$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $6909e5993a213e12$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === (typeof contextType === "undefined" ? "undefined" : (0, $03bAP._)(contextType)) && null !== contextType ? $6909e5993a213e12$var$readContext(contextType) : $6909e5993a213e12$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($6909e5993a213e12$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $6909e5993a213e12$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $6909e5993a213e12$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $6909e5993a213e12$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $6909e5993a213e12$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $6909e5993a213e12$var$emptyContextObject;
        "object" === (typeof contextType$jscomp$0 === "undefined" ? "undefined" : (0, $03bAP._)(contextType$jscomp$0)) && null !== contextType$jscomp$0 && (contextType = $6909e5993a213e12$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $6909e5993a213e12$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $6909e5993a213e12$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $6909e5993a213e12$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $6909e5993a213e12$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $6909e5993a213e12$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($6909e5993a213e12$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $6909e5993a213e12$var$hasForceUpdate || $6909e5993a213e12$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $6909e5993a213e12$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $6909e5993a213e12$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $6909e5993a213e12$var$emptyContextObject;
        "object" === (typeof oldContext === "undefined" ? "undefined" : (0, $03bAP._)(oldContext)) && null !== oldContext && (oldProps = $6909e5993a213e12$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $6909e5993a213e12$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $6909e5993a213e12$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $6909e5993a213e12$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $6909e5993a213e12$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $6909e5993a213e12$var$hasForceUpdate || null !== current && null !== current.dependencies && $6909e5993a213e12$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($6909e5993a213e12$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $6909e5993a213e12$var$hasForceUpdate || $6909e5993a213e12$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $6909e5993a213e12$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $6909e5993a213e12$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $6909e5993a213e12$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $6909e5993a213e12$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $6909e5993a213e12$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $6909e5993a213e12$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $6909e5993a213e12$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $6909e5993a213e12$var$resetHydrationState();
    workInProgress.flags |= 256;
    $6909e5993a213e12$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $6909e5993a213e12$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $6909e5993a213e12$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $6909e5993a213e12$var$getSuspendedCache()
    };
}
function $6909e5993a213e12$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $6909e5993a213e12$var$workInProgressDeferredLane);
    return current;
}
function $6909e5993a213e12$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($6909e5993a213e12$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($6909e5993a213e12$var$isHydrating) {
            showFallback ? $6909e5993a213e12$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $6909e5993a213e12$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $6909e5993a213e12$var$nextHydratableInstance) ? (current = $6909e5993a213e12$var$canHydrateHydrationBoundary(current, $6909e5993a213e12$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $6909e5993a213e12$var$treeContextProvider ? {
                    id: $6909e5993a213e12$var$treeContextId,
                    overflow: $6909e5993a213e12$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $6909e5993a213e12$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $6909e5993a213e12$var$hydrationParentFiber = workInProgress, $6909e5993a213e12$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $6909e5993a213e12$var$throwOnHydrationMismatch(workInProgress);
            $6909e5993a213e12$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $6909e5993a213e12$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $6909e5993a213e12$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $6909e5993a213e12$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $6909e5993a213e12$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $6909e5993a213e12$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $6909e5993a213e12$var$SUSPENDED_MARKER, $6909e5993a213e12$var$bailoutOffscreenComponent(null, nextProps);
        $6909e5993a213e12$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $6909e5993a213e12$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($6909e5993a213e12$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $6909e5993a213e12$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($6909e5993a213e12$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($6909e5993a213e12$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $6909e5993a213e12$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $6909e5993a213e12$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $6909e5993a213e12$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $6909e5993a213e12$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $6909e5993a213e12$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $6909e5993a213e12$var$SUSPENDED_MARKER, workInProgress = $6909e5993a213e12$var$bailoutOffscreenComponent(null, nextProps));
        else if ($6909e5993a213e12$var$pushPrimaryTreeSuspenseHandler(workInProgress), $6909e5993a213e12$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($6909e5993a213e12$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $6909e5993a213e12$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $6909e5993a213e12$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($6909e5993a213e12$var$didReceiveUpdate || $6909e5993a213e12$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $6909e5993a213e12$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $6909e5993a213e12$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $6909e5993a213e12$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $6909e5993a213e12$var$enqueueConcurrentRenderForLane(current, nextProps), $6909e5993a213e12$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $6909e5993a213e12$var$SelectiveHydrationException;
            $6909e5993a213e12$var$isSuspenseInstancePending(nextPrimaryChildren) || $6909e5993a213e12$var$renderDidSuspendDelayIfPossible();
            workInProgress = $6909e5993a213e12$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $6909e5993a213e12$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $6909e5993a213e12$var$nextHydratableInstance = $6909e5993a213e12$var$getNextHydratable(nextPrimaryChildren.nextSibling), $6909e5993a213e12$var$hydrationParentFiber = workInProgress, $6909e5993a213e12$var$isHydrating = !0, $6909e5993a213e12$var$hydrationErrors = null, $6909e5993a213e12$var$rootOrSingletonContext = !1, null !== current && $6909e5993a213e12$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $6909e5993a213e12$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $6909e5993a213e12$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $6909e5993a213e12$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $6909e5993a213e12$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $6909e5993a213e12$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $6909e5993a213e12$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $6909e5993a213e12$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $6909e5993a213e12$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $6909e5993a213e12$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $6909e5993a213e12$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $6909e5993a213e12$var$SUSPENDED_MARKER, $6909e5993a213e12$var$bailoutOffscreenComponent(current.child, nextProps);
    $6909e5993a213e12$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $6909e5993a213e12$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $6909e5993a213e12$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $6909e5993a213e12$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $6909e5993a213e12$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $6909e5993a213e12$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $6909e5993a213e12$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $6909e5993a213e12$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $6909e5993a213e12$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $6909e5993a213e12$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $6909e5993a213e12$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $6909e5993a213e12$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $6909e5993a213e12$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $6909e5993a213e12$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $6909e5993a213e12$var$push($6909e5993a213e12$var$suspenseStackCursor, suspenseContext);
    $6909e5993a213e12$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $6909e5993a213e12$var$isHydrating ? $6909e5993a213e12$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $6909e5993a213e12$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $6909e5993a213e12$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $6909e5993a213e12$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $6909e5993a213e12$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $6909e5993a213e12$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $6909e5993a213e12$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $6909e5993a213e12$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $6909e5993a213e12$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $6909e5993a213e12$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($6909e5993a213e12$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($6909e5993a213e12$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $6909e5993a213e12$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $6909e5993a213e12$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $6909e5993a213e12$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $6909e5993a213e12$var$checkIfContextChanged(current) ? !0 : !1;
}
function $6909e5993a213e12$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $6909e5993a213e12$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $6909e5993a213e12$var$pushProvider(workInProgress, $6909e5993a213e12$var$CacheContext, current.memoizedState.cache);
            $6909e5993a213e12$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $6909e5993a213e12$var$pushHostContext(workInProgress);
            break;
        case 4:
            $6909e5993a213e12$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $6909e5993a213e12$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $6909e5993a213e12$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $6909e5993a213e12$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $6909e5993a213e12$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $6909e5993a213e12$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $6909e5993a213e12$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $6909e5993a213e12$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($6909e5993a213e12$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $6909e5993a213e12$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $6909e5993a213e12$var$push($6909e5993a213e12$var$suspenseStackCursor, $6909e5993a213e12$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $6909e5993a213e12$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $6909e5993a213e12$var$pushProvider(workInProgress, $6909e5993a213e12$var$CacheContext, current.memoizedState.cache);
    }
    return $6909e5993a213e12$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $6909e5993a213e12$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $6909e5993a213e12$var$didReceiveUpdate = !0;
        else {
            if (!$6909e5993a213e12$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $6909e5993a213e12$var$didReceiveUpdate = !1, $6909e5993a213e12$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $6909e5993a213e12$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $6909e5993a213e12$var$didReceiveUpdate = !1, $6909e5993a213e12$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $6909e5993a213e12$var$pushTreeId(workInProgress, $6909e5993a213e12$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $6909e5993a213e12$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $6909e5993a213e12$var$shouldConstruct(current) ? (props = $6909e5993a213e12$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $6909e5993a213e12$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $6909e5993a213e12$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $6909e5993a213e12$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $6909e5993a213e12$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $6909e5993a213e12$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $6909e5993a213e12$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $6909e5993a213e12$var$getComponentNameFromType(current) || current;
                    throw Error($6909e5993a213e12$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $6909e5993a213e12$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $6909e5993a213e12$var$resolveClassComponentProps(props, workInProgress.pendingProps), $6909e5993a213e12$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $6909e5993a213e12$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($6909e5993a213e12$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $6909e5993a213e12$var$cloneUpdateQueue(current, workInProgress);
                $6909e5993a213e12$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $6909e5993a213e12$var$pushProvider(workInProgress, $6909e5993a213e12$var$CacheContext, props);
                props !== prevState.cache && $6909e5993a213e12$var$propagateContextChanges(workInProgress, [
                    $6909e5993a213e12$var$CacheContext
                ], renderLanes, !0);
                $6909e5993a213e12$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $6909e5993a213e12$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $6909e5993a213e12$var$createCapturedValueAtFiber(Error($6909e5993a213e12$var$formatProdErrorMessage(424)), workInProgress);
                        $6909e5993a213e12$var$queueHydrationError($$typeof);
                        workInProgress = $6909e5993a213e12$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $6909e5993a213e12$var$nextHydratableInstance = $6909e5993a213e12$var$getNextHydratable(current.firstChild);
                        $6909e5993a213e12$var$hydrationParentFiber = workInProgress;
                        $6909e5993a213e12$var$isHydrating = !0;
                        $6909e5993a213e12$var$hydrationErrors = null;
                        $6909e5993a213e12$var$rootOrSingletonContext = !0;
                        renderLanes = $6909e5993a213e12$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $6909e5993a213e12$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $6909e5993a213e12$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $6909e5993a213e12$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $6909e5993a213e12$var$markRef(current, workInProgress), null === current ? (renderLanes = $6909e5993a213e12$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $6909e5993a213e12$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $6909e5993a213e12$var$getOwnerDocumentFromRootContainer($6909e5993a213e12$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$6909e5993a213e12$var$internalInstanceKey] = workInProgress, props[$6909e5993a213e12$var$internalPropsKey] = current, $6909e5993a213e12$var$setInitialProperties(props, renderLanes, current), $6909e5993a213e12$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $6909e5993a213e12$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $6909e5993a213e12$var$pushHostContext(workInProgress), null === current && $6909e5993a213e12$var$isHydrating && (props = workInProgress.stateNode = $6909e5993a213e12$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $6909e5993a213e12$var$rootInstanceStackCursor.current), $6909e5993a213e12$var$hydrationParentFiber = workInProgress, $6909e5993a213e12$var$rootOrSingletonContext = !0, $$typeof = $6909e5993a213e12$var$nextHydratableInstance, $6909e5993a213e12$var$isSingletonScope(workInProgress.type) ? ($6909e5993a213e12$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $6909e5993a213e12$var$nextHydratableInstance = $6909e5993a213e12$var$getNextHydratable(props.firstChild)) : $6909e5993a213e12$var$nextHydratableInstance = $$typeof), $6909e5993a213e12$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $6909e5993a213e12$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $6909e5993a213e12$var$isHydrating) {
                if ($$typeof = props = $6909e5993a213e12$var$nextHydratableInstance) props = $6909e5993a213e12$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $6909e5993a213e12$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $6909e5993a213e12$var$hydrationParentFiber = workInProgress, $6909e5993a213e12$var$nextHydratableInstance = $6909e5993a213e12$var$getNextHydratable(props.firstChild), $6909e5993a213e12$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $6909e5993a213e12$var$throwOnHydrationMismatch(workInProgress);
            }
            $6909e5993a213e12$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $6909e5993a213e12$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $6909e5993a213e12$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $6909e5993a213e12$var$renderWithHooks(current, workInProgress, $6909e5993a213e12$var$TransitionAwareHostComponent, null, null, renderLanes), $6909e5993a213e12$var$HostTransitionContext._currentValue = $$typeof);
            $6909e5993a213e12$var$markRef(current, workInProgress);
            $6909e5993a213e12$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $6909e5993a213e12$var$isHydrating) {
                if (current = renderLanes = $6909e5993a213e12$var$nextHydratableInstance) renderLanes = $6909e5993a213e12$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $6909e5993a213e12$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $6909e5993a213e12$var$hydrationParentFiber = workInProgress, $6909e5993a213e12$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $6909e5993a213e12$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $6909e5993a213e12$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $6909e5993a213e12$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $6909e5993a213e12$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $6909e5993a213e12$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $6909e5993a213e12$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $6909e5993a213e12$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $6909e5993a213e12$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $6909e5993a213e12$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $6909e5993a213e12$var$pushProvider(workInProgress, workInProgress.type, props.value), $6909e5993a213e12$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $6909e5993a213e12$var$prepareToReadContext(workInProgress), $$typeof = $6909e5993a213e12$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $6909e5993a213e12$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $6909e5993a213e12$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $6909e5993a213e12$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $6909e5993a213e12$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $6909e5993a213e12$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $6909e5993a213e12$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $6909e5993a213e12$var$prepareToReadContext(workInProgress), props = $6909e5993a213e12$var$readContext($6909e5993a213e12$var$CacheContext), null === current ? ($$typeof = $6909e5993a213e12$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $6909e5993a213e12$var$workInProgressRoot, prevState = $6909e5993a213e12$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $6909e5993a213e12$var$initializeUpdateQueue(workInProgress), $6909e5993a213e12$var$pushProvider(workInProgress, $6909e5993a213e12$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($6909e5993a213e12$var$cloneUpdateQueue(current, workInProgress), $6909e5993a213e12$var$processUpdateQueue(workInProgress, null, null, renderLanes), $6909e5993a213e12$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $6909e5993a213e12$var$pushProvider(workInProgress, $6909e5993a213e12$var$CacheContext, props)) : (props = prevState.cache, $6909e5993a213e12$var$pushProvider(workInProgress, $6909e5993a213e12$var$CacheContext, props), props !== $$typeof.cache && $6909e5993a213e12$var$propagateContextChanges(workInProgress, [
                $6909e5993a213e12$var$CacheContext
            ], renderLanes, !0))), $6909e5993a213e12$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($6909e5993a213e12$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $6909e5993a213e12$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $6909e5993a213e12$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($6909e5993a213e12$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $6909e5993a213e12$var$suspendedThenable = $6909e5993a213e12$var$noopSuspenseyCommitThenable, $6909e5993a213e12$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $6909e5993a213e12$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$6909e5993a213e12$var$preloadResource(resource)) {
        if ($6909e5993a213e12$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $6909e5993a213e12$var$suspendedThenable = $6909e5993a213e12$var$noopSuspenseyCommitThenable, $6909e5993a213e12$var$SuspenseyCommitException;
    }
}
function $6909e5993a213e12$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $6909e5993a213e12$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $6909e5993a213e12$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $6909e5993a213e12$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$6909e5993a213e12$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $6909e5993a213e12$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $6909e5993a213e12$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $6909e5993a213e12$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $6909e5993a213e12$var$bubbleProperties(workInProgress), null;
        case 1:
            return $6909e5993a213e12$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $6909e5993a213e12$var$popProvider($6909e5993a213e12$var$CacheContext);
            $6909e5993a213e12$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $6909e5993a213e12$var$popHydrationState(workInProgress) ? $6909e5993a213e12$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $6909e5993a213e12$var$upgradeHydrationErrorsToRecoverable());
            $6909e5993a213e12$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($6909e5993a213e12$var$markUpdate(workInProgress), null !== nextResource ? ($6909e5993a213e12$var$bubbleProperties(workInProgress), $6909e5993a213e12$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($6909e5993a213e12$var$bubbleProperties(workInProgress), $6909e5993a213e12$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($6909e5993a213e12$var$markUpdate(workInProgress), $6909e5993a213e12$var$bubbleProperties(workInProgress), $6909e5993a213e12$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($6909e5993a213e12$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $6909e5993a213e12$var$markUpdate(workInProgress), $6909e5993a213e12$var$bubbleProperties(workInProgress), $6909e5993a213e12$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $6909e5993a213e12$var$popHostContext(workInProgress);
            renderLanes = $6909e5993a213e12$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $6909e5993a213e12$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($6909e5993a213e12$var$formatProdErrorMessage(166));
                    $6909e5993a213e12$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $6909e5993a213e12$var$contextStackCursor.current;
                $6909e5993a213e12$var$popHydrationState(workInProgress) ? $6909e5993a213e12$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $6909e5993a213e12$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $6909e5993a213e12$var$markUpdate(workInProgress));
            }
            $6909e5993a213e12$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $6909e5993a213e12$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $6909e5993a213e12$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($6909e5993a213e12$var$formatProdErrorMessage(166));
                    $6909e5993a213e12$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $6909e5993a213e12$var$contextStackCursor.current;
                if ($6909e5993a213e12$var$popHydrationState(workInProgress)) $6909e5993a213e12$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $6909e5993a213e12$var$getOwnerDocumentFromRootContainer($6909e5993a213e12$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$6909e5993a213e12$var$internalInstanceKey] = workInProgress;
                    nextResource[$6909e5993a213e12$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($6909e5993a213e12$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $6909e5993a213e12$var$markUpdate(workInProgress);
                }
            }
            $6909e5993a213e12$var$bubbleProperties(workInProgress);
            $6909e5993a213e12$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $6909e5993a213e12$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($6909e5993a213e12$var$formatProdErrorMessage(166));
                current = $6909e5993a213e12$var$rootInstanceStackCursor.current;
                if ($6909e5993a213e12$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $6909e5993a213e12$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$6909e5993a213e12$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $6909e5993a213e12$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $6909e5993a213e12$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $6909e5993a213e12$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$6909e5993a213e12$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $6909e5993a213e12$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $6909e5993a213e12$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($6909e5993a213e12$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($6909e5993a213e12$var$formatProdErrorMessage(557));
                        current[$6909e5993a213e12$var$internalInstanceKey] = workInProgress;
                    } else $6909e5993a213e12$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $6909e5993a213e12$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $6909e5993a213e12$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $6909e5993a213e12$var$popSuspenseHandler(workInProgress), workInProgress;
                    $6909e5993a213e12$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($6909e5993a213e12$var$formatProdErrorMessage(558));
            }
            $6909e5993a213e12$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $6909e5993a213e12$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($6909e5993a213e12$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($6909e5993a213e12$var$formatProdErrorMessage(317));
                        type[$6909e5993a213e12$var$internalInstanceKey] = workInProgress;
                    } else $6909e5993a213e12$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $6909e5993a213e12$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $6909e5993a213e12$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $6909e5993a213e12$var$popSuspenseHandler(workInProgress), workInProgress;
                    $6909e5993a213e12$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $6909e5993a213e12$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $6909e5993a213e12$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $6909e5993a213e12$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $6909e5993a213e12$var$popHostContainer(), null === current && $6909e5993a213e12$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $6909e5993a213e12$var$bubbleProperties(workInProgress), null;
        case 10:
            return $6909e5993a213e12$var$popProvider(workInProgress.type), $6909e5993a213e12$var$bubbleProperties(workInProgress), null;
        case 19:
            $6909e5993a213e12$var$pop($6909e5993a213e12$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $6909e5993a213e12$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $6909e5993a213e12$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $6909e5993a213e12$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $6909e5993a213e12$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $6909e5993a213e12$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $6909e5993a213e12$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$6909e5993a213e12$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $6909e5993a213e12$var$push($6909e5993a213e12$var$suspenseStackCursor, $6909e5993a213e12$var$suspenseStackCursor.current & 1 | 2);
                            $6909e5993a213e12$var$isHydrating && $6909e5993a213e12$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $6909e5993a213e12$var$now() > $6909e5993a213e12$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $6909e5993a213e12$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $6909e5993a213e12$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $6909e5993a213e12$var$scheduleRetryEffect(workInProgress, current), $6909e5993a213e12$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$6909e5993a213e12$var$isHydrating) return $6909e5993a213e12$var$bubbleProperties(workInProgress), null;
                    } else 2 * $6909e5993a213e12$var$now() - newProps.renderingStartTime > $6909e5993a213e12$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $6909e5993a213e12$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $6909e5993a213e12$var$now(), current.sibling = null, renderLanes = $6909e5993a213e12$var$suspenseStackCursor.current, $6909e5993a213e12$var$push($6909e5993a213e12$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $6909e5993a213e12$var$isHydrating && $6909e5993a213e12$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $6909e5993a213e12$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $6909e5993a213e12$var$popSuspenseHandler(workInProgress), $6909e5993a213e12$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($6909e5993a213e12$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $6909e5993a213e12$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $6909e5993a213e12$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $6909e5993a213e12$var$pop($6909e5993a213e12$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $6909e5993a213e12$var$popProvider($6909e5993a213e12$var$CacheContext), $6909e5993a213e12$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($6909e5993a213e12$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $6909e5993a213e12$var$unwindWork(current, workInProgress) {
    $6909e5993a213e12$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $6909e5993a213e12$var$popProvider($6909e5993a213e12$var$CacheContext), $6909e5993a213e12$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $6909e5993a213e12$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $6909e5993a213e12$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($6909e5993a213e12$var$formatProdErrorMessage(340));
                $6909e5993a213e12$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $6909e5993a213e12$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($6909e5993a213e12$var$formatProdErrorMessage(340));
                $6909e5993a213e12$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $6909e5993a213e12$var$pop($6909e5993a213e12$var$suspenseStackCursor), null;
        case 4:
            return $6909e5993a213e12$var$popHostContainer(), null;
        case 10:
            return $6909e5993a213e12$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $6909e5993a213e12$var$popSuspenseHandler(workInProgress), $6909e5993a213e12$var$popHiddenContext(), null !== current && $6909e5993a213e12$var$pop($6909e5993a213e12$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $6909e5993a213e12$var$popProvider($6909e5993a213e12$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $6909e5993a213e12$var$unwindInterruptedWork(current, interruptedWork) {
    $6909e5993a213e12$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $6909e5993a213e12$var$popProvider($6909e5993a213e12$var$CacheContext);
            $6909e5993a213e12$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $6909e5993a213e12$var$popHostContext(interruptedWork);
            break;
        case 4:
            $6909e5993a213e12$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $6909e5993a213e12$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $6909e5993a213e12$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $6909e5993a213e12$var$pop($6909e5993a213e12$var$suspenseStackCursor);
            break;
        case 10:
            $6909e5993a213e12$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $6909e5993a213e12$var$popSuspenseHandler(interruptedWork);
            $6909e5993a213e12$var$popHiddenContext();
            null !== current && $6909e5993a213e12$var$pop($6909e5993a213e12$var$resumedCache);
            break;
        case 24:
            $6909e5993a213e12$var$popProvider($6909e5993a213e12$var$CacheContext);
    }
}
function $6909e5993a213e12$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $6909e5993a213e12$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $6909e5993a213e12$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $6909e5993a213e12$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $6909e5993a213e12$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $6909e5993a213e12$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $6909e5993a213e12$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $6909e5993a213e12$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $6909e5993a213e12$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $6909e5993a213e12$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $6909e5993a213e12$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $6909e5993a213e12$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $6909e5993a213e12$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $6909e5993a213e12$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $6909e5993a213e12$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $6909e5993a213e12$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$6909e5993a213e12$var$internalPropsKey] = newProps;
    } catch (error) {
        $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $6909e5993a213e12$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $6909e5993a213e12$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $6909e5993a213e12$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $6909e5993a213e12$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $6909e5993a213e12$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $6909e5993a213e12$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $6909e5993a213e12$var$noop$1));
    else if (4 !== tag && (27 === tag && $6909e5993a213e12$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($6909e5993a213e12$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$6909e5993a213e12$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $6909e5993a213e12$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $6909e5993a213e12$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($6909e5993a213e12$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$6909e5993a213e12$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $6909e5993a213e12$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $6909e5993a213e12$var$setInitialProperties(singleton, type, props);
        singleton[$6909e5993a213e12$var$internalInstanceKey] = finishedWork;
        singleton[$6909e5993a213e12$var$internalPropsKey] = props;
    } catch (error) {
        $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $6909e5993a213e12$var$offscreenSubtreeIsHidden = !1, $6909e5993a213e12$var$offscreenSubtreeWasHidden = !1, $6909e5993a213e12$var$needsFormReset = !1, $6909e5993a213e12$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $6909e5993a213e12$var$nextEffect = null;
function $6909e5993a213e12$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $6909e5993a213e12$var$eventsEnabled = $6909e5993a213e12$var$_enabled;
    root = $6909e5993a213e12$var$getActiveElementDeep(root);
    if ($6909e5993a213e12$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $6909e5993a213e12$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $6909e5993a213e12$var$_enabled = !1;
    for($6909e5993a213e12$var$nextEffect = firstChild; null !== $6909e5993a213e12$var$nextEffect;)if (firstChild = $6909e5993a213e12$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $6909e5993a213e12$var$nextEffect = root;
    else for(; null !== $6909e5993a213e12$var$nextEffect;){
        firstChild = $6909e5993a213e12$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $6909e5993a213e12$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $6909e5993a213e12$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $6909e5993a213e12$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $6909e5993a213e12$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($6909e5993a213e12$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $6909e5993a213e12$var$nextEffect = root;
            break;
        }
        $6909e5993a213e12$var$nextEffect = firstChild.return;
    }
}
function $6909e5993a213e12$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $6909e5993a213e12$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $6909e5993a213e12$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $6909e5993a213e12$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $6909e5993a213e12$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $6909e5993a213e12$var$commitClassCallbacks(finishedWork);
            flags & 512 && $6909e5993a213e12$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $6909e5993a213e12$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $6909e5993a213e12$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $6909e5993a213e12$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $6909e5993a213e12$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $6909e5993a213e12$var$commitHostMount(finishedWork);
            flags & 512 && $6909e5993a213e12$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $6909e5993a213e12$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $6909e5993a213e12$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $6909e5993a213e12$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $6909e5993a213e12$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $6909e5993a213e12$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $6909e5993a213e12$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $6909e5993a213e12$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $6909e5993a213e12$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $6909e5993a213e12$var$offscreenSubtreeWasHidden;
                prevProps = $6909e5993a213e12$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $6909e5993a213e12$var$offscreenSubtreeWasHidden;
                $6909e5993a213e12$var$offscreenSubtreeIsHidden = flags;
                ($6909e5993a213e12$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $6909e5993a213e12$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $6909e5993a213e12$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $6909e5993a213e12$var$offscreenSubtreeIsHidden = prevProps;
                $6909e5993a213e12$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $6909e5993a213e12$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $6909e5993a213e12$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $6909e5993a213e12$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $6909e5993a213e12$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $6909e5993a213e12$var$hostParent = null, $6909e5993a213e12$var$hostParentIsContainer = !1;
function $6909e5993a213e12$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$6909e5993a213e12$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $6909e5993a213e12$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($6909e5993a213e12$var$injectedHook && "function" === typeof $6909e5993a213e12$var$injectedHook.onCommitFiberUnmount) try {
        $6909e5993a213e12$var$injectedHook.onCommitFiberUnmount($6909e5993a213e12$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $6909e5993a213e12$var$offscreenSubtreeWasHidden || $6909e5993a213e12$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $6909e5993a213e12$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $6909e5993a213e12$var$offscreenSubtreeWasHidden || $6909e5993a213e12$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $6909e5993a213e12$var$hostParent, prevHostParentIsContainer = $6909e5993a213e12$var$hostParentIsContainer;
            $6909e5993a213e12$var$isSingletonScope(deletedFiber.type) && ($6909e5993a213e12$var$hostParent = deletedFiber.stateNode, $6909e5993a213e12$var$hostParentIsContainer = !1);
            $6909e5993a213e12$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $6909e5993a213e12$var$releaseSingletonInstance(deletedFiber.stateNode);
            $6909e5993a213e12$var$hostParent = prevHostParent;
            $6909e5993a213e12$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $6909e5993a213e12$var$offscreenSubtreeWasHidden || $6909e5993a213e12$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $6909e5993a213e12$var$hostParent;
            prevHostParentIsContainer = $6909e5993a213e12$var$hostParentIsContainer;
            $6909e5993a213e12$var$hostParent = null;
            $6909e5993a213e12$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $6909e5993a213e12$var$hostParent = prevHostParent;
            $6909e5993a213e12$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $6909e5993a213e12$var$hostParent) {
                if ($6909e5993a213e12$var$hostParentIsContainer) try {
                    (9 === $6909e5993a213e12$var$hostParent.nodeType ? $6909e5993a213e12$var$hostParent.body : "HTML" === $6909e5993a213e12$var$hostParent.nodeName ? $6909e5993a213e12$var$hostParent.ownerDocument.body : $6909e5993a213e12$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $6909e5993a213e12$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $6909e5993a213e12$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $6909e5993a213e12$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $6909e5993a213e12$var$hostParent && ($6909e5993a213e12$var$hostParentIsContainer ? (finishedRoot = $6909e5993a213e12$var$hostParent, $6909e5993a213e12$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $6909e5993a213e12$var$retryIfBlockedOn(finishedRoot)) : $6909e5993a213e12$var$clearHydrationBoundary($6909e5993a213e12$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $6909e5993a213e12$var$hostParent;
            prevHostParentIsContainer = $6909e5993a213e12$var$hostParentIsContainer;
            $6909e5993a213e12$var$hostParent = deletedFiber.stateNode.containerInfo;
            $6909e5993a213e12$var$hostParentIsContainer = !0;
            $6909e5993a213e12$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $6909e5993a213e12$var$hostParent = prevHostParent;
            $6909e5993a213e12$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $6909e5993a213e12$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $6909e5993a213e12$var$offscreenSubtreeWasHidden || $6909e5993a213e12$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $6909e5993a213e12$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $6909e5993a213e12$var$offscreenSubtreeWasHidden || ($6909e5993a213e12$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $6909e5993a213e12$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $6909e5993a213e12$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $6909e5993a213e12$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $6909e5993a213e12$var$offscreenSubtreeWasHidden = (prevHostParent = $6909e5993a213e12$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $6909e5993a213e12$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $6909e5993a213e12$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $6909e5993a213e12$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $6909e5993a213e12$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $6909e5993a213e12$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $6909e5993a213e12$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $6909e5993a213e12$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $6909e5993a213e12$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $6909e5993a213e12$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $6909e5993a213e12$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($6909e5993a213e12$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $6909e5993a213e12$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $6909e5993a213e12$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $6909e5993a213e12$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($6909e5993a213e12$var$isSingletonScope(parent.type)) {
                        $6909e5993a213e12$var$hostParent = parent.stateNode;
                        $6909e5993a213e12$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $6909e5993a213e12$var$hostParent = parent.stateNode;
                    $6909e5993a213e12$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $6909e5993a213e12$var$hostParent = parent.stateNode.containerInfo;
                    $6909e5993a213e12$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $6909e5993a213e12$var$hostParent) throw Error($6909e5993a213e12$var$formatProdErrorMessage(160));
        $6909e5993a213e12$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $6909e5993a213e12$var$hostParent = null;
        $6909e5993a213e12$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$6909e5993a213e12$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $6909e5993a213e12$var$currentHoistableRoot = null;
function $6909e5993a213e12$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($6909e5993a213e12$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $6909e5993a213e12$var$commitHookEffectListMount(3, finishedWork), $6909e5993a213e12$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($6909e5993a213e12$var$offscreenSubtreeWasHidden || null === current || $6909e5993a213e12$var$safelyDetachRef(current, current.return));
            flags & 64 && $6909e5993a213e12$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $6909e5993a213e12$var$currentHoistableRoot;
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($6909e5993a213e12$var$offscreenSubtreeWasHidden || null === current || $6909e5993a213e12$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$6909e5993a213e12$var$internalHoistableMarker] || currentResource[$6909e5993a213e12$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $6909e5993a213e12$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$6909e5993a213e12$var$internalInstanceKey] = finishedWork;
                                        $6909e5993a213e12$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $6909e5993a213e12$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $6909e5993a213e12$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $6909e5993a213e12$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $6909e5993a213e12$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($6909e5993a213e12$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$6909e5993a213e12$var$internalInstanceKey] = finishedWork;
                                $6909e5993a213e12$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $6909e5993a213e12$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $6909e5993a213e12$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $6909e5993a213e12$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $6909e5993a213e12$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $6909e5993a213e12$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($6909e5993a213e12$var$offscreenSubtreeWasHidden || null === current || $6909e5993a213e12$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $6909e5993a213e12$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($6909e5993a213e12$var$offscreenSubtreeWasHidden || null === current || $6909e5993a213e12$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $6909e5993a213e12$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $6909e5993a213e12$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($6909e5993a213e12$var$needsFormReset = !0);
            break;
        case 6:
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($6909e5993a213e12$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $6909e5993a213e12$var$tagCaches = null;
            hoistableRoot = $6909e5993a213e12$var$currentHoistableRoot;
            $6909e5993a213e12$var$currentHoistableRoot = $6909e5993a213e12$var$getHoistableRoot(root.containerInfo);
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6909e5993a213e12$var$currentHoistableRoot = hoistableRoot;
            $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $6909e5993a213e12$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $6909e5993a213e12$var$needsFormReset && ($6909e5993a213e12$var$needsFormReset = !1, $6909e5993a213e12$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $6909e5993a213e12$var$currentHoistableRoot;
            $6909e5993a213e12$var$currentHoistableRoot = $6909e5993a213e12$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
            $6909e5993a213e12$var$currentHoistableRoot = flags;
            break;
        case 12:
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $6909e5993a213e12$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($6909e5993a213e12$var$globalMostRecentFallbackTime = $6909e5993a213e12$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $6909e5993a213e12$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $6909e5993a213e12$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $6909e5993a213e12$var$offscreenSubtreeWasHidden;
            $6909e5993a213e12$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $6909e5993a213e12$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6909e5993a213e12$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $6909e5993a213e12$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $6909e5993a213e12$var$offscreenSubtreeIsHidden || $6909e5993a213e12$var$offscreenSubtreeWasHidden || $6909e5993a213e12$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $6909e5993a213e12$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $6909e5993a213e12$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $6909e5993a213e12$var$hideOrUnhideDehydratedBoundary(instance, !0) : $6909e5993a213e12$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $6909e5993a213e12$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $6909e5993a213e12$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $6909e5993a213e12$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $6909e5993a213e12$var$recursivelyTraverseMutationEffects(root, finishedWork), $6909e5993a213e12$var$commitReconciliationEffects(finishedWork);
    }
}
function $6909e5993a213e12$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($6909e5993a213e12$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($6909e5993a213e12$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $6909e5993a213e12$var$getHostSibling(finishedWork);
                    $6909e5993a213e12$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($6909e5993a213e12$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $6909e5993a213e12$var$getHostSibling(finishedWork);
                    $6909e5993a213e12$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $6909e5993a213e12$var$getHostSibling(finishedWork);
                    $6909e5993a213e12$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($6909e5993a213e12$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $6909e5993a213e12$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $6909e5993a213e12$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $6909e5993a213e12$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$6909e5993a213e12$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $6909e5993a213e12$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $6909e5993a213e12$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $6909e5993a213e12$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $6909e5993a213e12$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $6909e5993a213e12$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $6909e5993a213e12$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $6909e5993a213e12$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $6909e5993a213e12$var$safelyDetachRef(finishedWork, finishedWork.return);
                $6909e5993a213e12$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $6909e5993a213e12$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $6909e5993a213e12$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $6909e5993a213e12$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $6909e5993a213e12$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $6909e5993a213e12$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $6909e5993a213e12$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $6909e5993a213e12$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $6909e5993a213e12$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$6909e5993a213e12$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $6909e5993a213e12$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $6909e5993a213e12$var$commitClassCallbacks(finishedWork);
                $6909e5993a213e12$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $6909e5993a213e12$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $6909e5993a213e12$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $6909e5993a213e12$var$commitHostMount(finishedWork);
                $6909e5993a213e12$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $6909e5993a213e12$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $6909e5993a213e12$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $6909e5993a213e12$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $6909e5993a213e12$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $6909e5993a213e12$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $6909e5993a213e12$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $6909e5993a213e12$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $6909e5993a213e12$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $6909e5993a213e12$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $6909e5993a213e12$var$releaseCache(previousCache));
}
function $6909e5993a213e12$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $6909e5993a213e12$var$releaseCache(current));
}
function $6909e5993a213e12$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$6909e5993a213e12$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $6909e5993a213e12$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $6909e5993a213e12$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $6909e5993a213e12$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $6909e5993a213e12$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $6909e5993a213e12$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $6909e5993a213e12$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $6909e5993a213e12$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $6909e5993a213e12$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $6909e5993a213e12$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $6909e5993a213e12$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $6909e5993a213e12$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $6909e5993a213e12$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $6909e5993a213e12$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $6909e5993a213e12$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $6909e5993a213e12$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $6909e5993a213e12$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $6909e5993a213e12$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $6909e5993a213e12$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $6909e5993a213e12$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $6909e5993a213e12$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $6909e5993a213e12$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $6909e5993a213e12$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $6909e5993a213e12$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $6909e5993a213e12$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $6909e5993a213e12$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $6909e5993a213e12$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $6909e5993a213e12$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $6909e5993a213e12$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $6909e5993a213e12$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $6909e5993a213e12$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $6909e5993a213e12$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $6909e5993a213e12$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $6909e5993a213e12$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $6909e5993a213e12$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $6909e5993a213e12$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $6909e5993a213e12$var$suspenseyCommitFlag = 8192;
function $6909e5993a213e12$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $6909e5993a213e12$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$6909e5993a213e12$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $6909e5993a213e12$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $6909e5993a213e12$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $6909e5993a213e12$var$suspenseyCommitFlag && null !== fiber.memoizedState && $6909e5993a213e12$var$suspendResource(suspendedState, $6909e5993a213e12$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $6909e5993a213e12$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $6909e5993a213e12$var$currentHoistableRoot;
            $6909e5993a213e12$var$currentHoistableRoot = $6909e5993a213e12$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $6909e5993a213e12$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $6909e5993a213e12$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $6909e5993a213e12$var$suspenseyCommitFlag, $6909e5993a213e12$var$suspenseyCommitFlag = 16777216, $6909e5993a213e12$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $6909e5993a213e12$var$suspenseyCommitFlag = previousHoistableRoot) : $6909e5993a213e12$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $6909e5993a213e12$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $6909e5993a213e12$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $6909e5993a213e12$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $6909e5993a213e12$var$nextEffect = childToDelete;
            $6909e5993a213e12$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $6909e5993a213e12$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$6909e5993a213e12$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $6909e5993a213e12$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $6909e5993a213e12$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $6909e5993a213e12$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $6909e5993a213e12$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $6909e5993a213e12$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $6909e5993a213e12$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $6909e5993a213e12$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $6909e5993a213e12$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $6909e5993a213e12$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $6909e5993a213e12$var$nextEffect = childToDelete;
            $6909e5993a213e12$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $6909e5993a213e12$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $6909e5993a213e12$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $6909e5993a213e12$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $6909e5993a213e12$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $6909e5993a213e12$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $6909e5993a213e12$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $6909e5993a213e12$var$nextEffect;){
        var fiber = $6909e5993a213e12$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $6909e5993a213e12$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $6909e5993a213e12$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $6909e5993a213e12$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $6909e5993a213e12$var$nextEffect;){
            cache = $6909e5993a213e12$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $6909e5993a213e12$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $6909e5993a213e12$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $6909e5993a213e12$var$nextEffect = sibling;
                break a;
            }
            $6909e5993a213e12$var$nextEffect = returnFiber;
        }
    }
}
var $6909e5993a213e12$var$DefaultAsyncDispatcher = {
    getCacheForType: function getCacheForType(resourceType) {
        var cache = $6909e5993a213e12$var$readContext($6909e5993a213e12$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function cacheSignal() {
        return $6909e5993a213e12$var$readContext($6909e5993a213e12$var$CacheContext).controller.signal;
    }
}, $6909e5993a213e12$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $6909e5993a213e12$var$executionContext = 0, $6909e5993a213e12$var$workInProgressRoot = null, $6909e5993a213e12$var$workInProgress = null, $6909e5993a213e12$var$workInProgressRootRenderLanes = 0, $6909e5993a213e12$var$workInProgressSuspendedReason = 0, $6909e5993a213e12$var$workInProgressThrownValue = null, $6909e5993a213e12$var$workInProgressRootDidSkipSuspendedSiblings = !1, $6909e5993a213e12$var$workInProgressRootIsPrerendering = !1, $6909e5993a213e12$var$workInProgressRootDidAttachPingListener = !1, $6909e5993a213e12$var$entangledRenderLanes = 0, $6909e5993a213e12$var$workInProgressRootExitStatus = 0, $6909e5993a213e12$var$workInProgressRootSkippedLanes = 0, $6909e5993a213e12$var$workInProgressRootInterleavedUpdatedLanes = 0, $6909e5993a213e12$var$workInProgressRootPingedLanes = 0, $6909e5993a213e12$var$workInProgressDeferredLane = 0, $6909e5993a213e12$var$workInProgressSuspendedRetryLanes = 0, $6909e5993a213e12$var$workInProgressRootConcurrentErrors = null, $6909e5993a213e12$var$workInProgressRootRecoverableErrors = null, $6909e5993a213e12$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $6909e5993a213e12$var$globalMostRecentFallbackTime = 0, $6909e5993a213e12$var$globalMostRecentTransitionTime = 0, $6909e5993a213e12$var$workInProgressRootRenderTargetTime = Infinity, $6909e5993a213e12$var$workInProgressTransitions = null, $6909e5993a213e12$var$legacyErrorBoundariesThatAlreadyFailed = null, $6909e5993a213e12$var$pendingEffectsStatus = 0, $6909e5993a213e12$var$pendingEffectsRoot = null, $6909e5993a213e12$var$pendingFinishedWork = null, $6909e5993a213e12$var$pendingEffectsLanes = 0, $6909e5993a213e12$var$pendingEffectsRemainingLanes = 0, $6909e5993a213e12$var$pendingPassiveTransitions = null, $6909e5993a213e12$var$pendingRecoverableErrors = null, $6909e5993a213e12$var$nestedUpdateCount = 0, $6909e5993a213e12$var$rootWithNestedUpdates = null;
function $6909e5993a213e12$var$requestUpdateLane() {
    return 0 !== ($6909e5993a213e12$var$executionContext & 2) && 0 !== $6909e5993a213e12$var$workInProgressRootRenderLanes ? $6909e5993a213e12$var$workInProgressRootRenderLanes & -$6909e5993a213e12$var$workInProgressRootRenderLanes : null !== $6909e5993a213e12$var$ReactSharedInternals.T ? $6909e5993a213e12$var$requestTransitionLane() : $6909e5993a213e12$var$resolveUpdatePriority();
}
function $6909e5993a213e12$var$requestDeferredLane() {
    if (0 === $6909e5993a213e12$var$workInProgressDeferredLane) {
        if (0 === ($6909e5993a213e12$var$workInProgressRootRenderLanes & 536870912) || $6909e5993a213e12$var$isHydrating) {
            var lane = $6909e5993a213e12$var$nextTransitionDeferredLane;
            $6909e5993a213e12$var$nextTransitionDeferredLane <<= 1;
            0 === ($6909e5993a213e12$var$nextTransitionDeferredLane & 3932160) && ($6909e5993a213e12$var$nextTransitionDeferredLane = 262144);
            $6909e5993a213e12$var$workInProgressDeferredLane = lane;
        } else $6909e5993a213e12$var$workInProgressDeferredLane = 536870912;
    }
    lane = $6909e5993a213e12$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $6909e5993a213e12$var$workInProgressDeferredLane;
}
function $6909e5993a213e12$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $6909e5993a213e12$var$workInProgressRoot && (2 === $6909e5993a213e12$var$workInProgressSuspendedReason || 9 === $6909e5993a213e12$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $6909e5993a213e12$var$prepareFreshStack(root, 0), $6909e5993a213e12$var$markRootSuspended(root, $6909e5993a213e12$var$workInProgressRootRenderLanes, $6909e5993a213e12$var$workInProgressDeferredLane, !1);
    $6909e5993a213e12$var$markRootUpdated$1(root, lane);
    if (0 === ($6909e5993a213e12$var$executionContext & 2) || root !== $6909e5993a213e12$var$workInProgressRoot) root === $6909e5993a213e12$var$workInProgressRoot && (0 === ($6909e5993a213e12$var$executionContext & 2) && ($6909e5993a213e12$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $6909e5993a213e12$var$workInProgressRootExitStatus && $6909e5993a213e12$var$markRootSuspended(root, $6909e5993a213e12$var$workInProgressRootRenderLanes, $6909e5993a213e12$var$workInProgressDeferredLane, !1)), $6909e5993a213e12$var$ensureRootIsScheduled(root);
}
function $6909e5993a213e12$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($6909e5993a213e12$var$executionContext & 6)) throw Error($6909e5993a213e12$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $6909e5993a213e12$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $6909e5993a213e12$var$renderRootConcurrent(root$jscomp$0, lanes) : $6909e5993a213e12$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $6909e5993a213e12$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $6909e5993a213e12$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$6909e5993a213e12$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $6909e5993a213e12$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $6909e5993a213e12$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($6909e5993a213e12$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $6909e5993a213e12$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($6909e5993a213e12$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $6909e5993a213e12$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $6909e5993a213e12$var$workInProgressRootRecoverableErrors;
                            $6909e5993a213e12$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $6909e5993a213e12$var$workInProgressRootRecoverableErrors ? $6909e5993a213e12$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $6909e5993a213e12$var$workInProgressRootRecoverableErrors.push.apply($6909e5993a213e12$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $6909e5993a213e12$var$prepareFreshStack(root$jscomp$0, 0);
                $6909e5993a213e12$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($6909e5993a213e12$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $6909e5993a213e12$var$markRootSuspended(shouldTimeSlice, lanes, $6909e5993a213e12$var$workInProgressDeferredLane, !$6909e5993a213e12$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $6909e5993a213e12$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($6909e5993a213e12$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $6909e5993a213e12$var$globalMostRecentFallbackTime + 300 - $6909e5993a213e12$var$now(), 10 < exitStatus)) {
                    $6909e5993a213e12$var$markRootSuspended(shouldTimeSlice, lanes, $6909e5993a213e12$var$workInProgressDeferredLane, !$6909e5993a213e12$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $6909e5993a213e12$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $6909e5993a213e12$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $6909e5993a213e12$var$scheduleTimeout($6909e5993a213e12$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $6909e5993a213e12$var$workInProgressRootRecoverableErrors, $6909e5993a213e12$var$workInProgressTransitions, $6909e5993a213e12$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $6909e5993a213e12$var$workInProgressDeferredLane, $6909e5993a213e12$var$workInProgressRootInterleavedUpdatedLanes, $6909e5993a213e12$var$workInProgressSuspendedRetryLanes, $6909e5993a213e12$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $6909e5993a213e12$var$commitRootWhenReady(shouldTimeSlice, forceSync, $6909e5993a213e12$var$workInProgressRootRecoverableErrors, $6909e5993a213e12$var$workInProgressTransitions, $6909e5993a213e12$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $6909e5993a213e12$var$workInProgressDeferredLane, $6909e5993a213e12$var$workInProgressRootInterleavedUpdatedLanes, $6909e5993a213e12$var$workInProgressSuspendedRetryLanes, $6909e5993a213e12$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $6909e5993a213e12$var$ensureRootIsScheduled(root$jscomp$0);
}
function $6909e5993a213e12$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $6909e5993a213e12$var$noop$1
        };
        $6909e5993a213e12$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $6909e5993a213e12$var$globalMostRecentFallbackTime - $6909e5993a213e12$var$now() : (lanes & 4194048) === lanes ? $6909e5993a213e12$var$globalMostRecentTransitionTime - $6909e5993a213e12$var$now() : 0;
        timeoutOffset = $6909e5993a213e12$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $6909e5993a213e12$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($6909e5993a213e12$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $6909e5993a213e12$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $6909e5993a213e12$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $6909e5993a213e12$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$6909e5993a213e12$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $6909e5993a213e12$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$6909e5993a213e12$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$6909e5993a213e12$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $6909e5993a213e12$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $6909e5993a213e12$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $6909e5993a213e12$var$flushSyncWork$1() {
    return 0 === ($6909e5993a213e12$var$executionContext & 6) ? ($6909e5993a213e12$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $6909e5993a213e12$var$resetWorkInProgressStack() {
    if (null !== $6909e5993a213e12$var$workInProgress) {
        if (0 === $6909e5993a213e12$var$workInProgressSuspendedReason) var interruptedWork = $6909e5993a213e12$var$workInProgress.return;
        else interruptedWork = $6909e5993a213e12$var$workInProgress, $6909e5993a213e12$var$lastContextDependency = $6909e5993a213e12$var$currentlyRenderingFiber$1 = null, $6909e5993a213e12$var$resetHooksOnUnwind(interruptedWork), $6909e5993a213e12$var$thenableState$1 = null, $6909e5993a213e12$var$thenableIndexCounter$1 = 0, interruptedWork = $6909e5993a213e12$var$workInProgress;
        for(; null !== interruptedWork;)$6909e5993a213e12$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $6909e5993a213e12$var$workInProgress = null;
    }
}
function $6909e5993a213e12$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $6909e5993a213e12$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $6909e5993a213e12$var$pendingEffectsLanes = 0;
    $6909e5993a213e12$var$resetWorkInProgressStack();
    $6909e5993a213e12$var$workInProgressRoot = root;
    $6909e5993a213e12$var$workInProgress = timeoutHandle = $6909e5993a213e12$var$createWorkInProgress(root.current, null);
    $6909e5993a213e12$var$workInProgressRootRenderLanes = lanes;
    $6909e5993a213e12$var$workInProgressSuspendedReason = 0;
    $6909e5993a213e12$var$workInProgressThrownValue = null;
    $6909e5993a213e12$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $6909e5993a213e12$var$workInProgressRootIsPrerendering = $6909e5993a213e12$var$checkIfRootIsPrerendering(root, lanes);
    $6909e5993a213e12$var$workInProgressRootDidAttachPingListener = !1;
    $6909e5993a213e12$var$workInProgressSuspendedRetryLanes = $6909e5993a213e12$var$workInProgressDeferredLane = $6909e5993a213e12$var$workInProgressRootPingedLanes = $6909e5993a213e12$var$workInProgressRootInterleavedUpdatedLanes = $6909e5993a213e12$var$workInProgressRootSkippedLanes = $6909e5993a213e12$var$workInProgressRootExitStatus = 0;
    $6909e5993a213e12$var$workInProgressRootRecoverableErrors = $6909e5993a213e12$var$workInProgressRootConcurrentErrors = null;
    $6909e5993a213e12$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $6909e5993a213e12$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $6909e5993a213e12$var$entangledRenderLanes = lanes;
    $6909e5993a213e12$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $6909e5993a213e12$var$handleThrow(root, thrownValue) {
    $6909e5993a213e12$var$currentlyRenderingFiber = null;
    $6909e5993a213e12$var$ReactSharedInternals.H = $6909e5993a213e12$var$ContextOnlyDispatcher;
    thrownValue === $6909e5993a213e12$var$SuspenseException || thrownValue === $6909e5993a213e12$var$SuspenseActionException ? (thrownValue = $6909e5993a213e12$var$getSuspendedThenable(), $6909e5993a213e12$var$workInProgressSuspendedReason = 3) : thrownValue === $6909e5993a213e12$var$SuspenseyCommitException ? (thrownValue = $6909e5993a213e12$var$getSuspendedThenable(), $6909e5993a213e12$var$workInProgressSuspendedReason = 4) : $6909e5993a213e12$var$workInProgressSuspendedReason = thrownValue === $6909e5993a213e12$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === (typeof thrownValue === "undefined" ? "undefined" : (0, $03bAP._)(thrownValue)) && "function" === typeof thrownValue.then ? 6 : 1;
    $6909e5993a213e12$var$workInProgressThrownValue = thrownValue;
    null === $6909e5993a213e12$var$workInProgress && ($6909e5993a213e12$var$workInProgressRootExitStatus = 1, $6909e5993a213e12$var$logUncaughtError(root, $6909e5993a213e12$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $6909e5993a213e12$var$shouldRemainOnPreviousScreen() {
    var handler = $6909e5993a213e12$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($6909e5993a213e12$var$workInProgressRootRenderLanes & 4194048) === $6909e5993a213e12$var$workInProgressRootRenderLanes ? null === $6909e5993a213e12$var$shellBoundary ? !0 : !1 : ($6909e5993a213e12$var$workInProgressRootRenderLanes & 62914560) === $6909e5993a213e12$var$workInProgressRootRenderLanes || 0 !== ($6909e5993a213e12$var$workInProgressRootRenderLanes & 536870912) ? handler === $6909e5993a213e12$var$shellBoundary : !1;
}
function $6909e5993a213e12$var$pushDispatcher() {
    var prevDispatcher = $6909e5993a213e12$var$ReactSharedInternals.H;
    $6909e5993a213e12$var$ReactSharedInternals.H = $6909e5993a213e12$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $6909e5993a213e12$var$ContextOnlyDispatcher : prevDispatcher;
}
function $6909e5993a213e12$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $6909e5993a213e12$var$ReactSharedInternals.A;
    $6909e5993a213e12$var$ReactSharedInternals.A = $6909e5993a213e12$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $6909e5993a213e12$var$renderDidSuspendDelayIfPossible() {
    $6909e5993a213e12$var$workInProgressRootExitStatus = 4;
    $6909e5993a213e12$var$workInProgressRootDidSkipSuspendedSiblings || ($6909e5993a213e12$var$workInProgressRootRenderLanes & 4194048) !== $6909e5993a213e12$var$workInProgressRootRenderLanes && null !== $6909e5993a213e12$var$suspenseHandlerStackCursor.current || ($6909e5993a213e12$var$workInProgressRootIsPrerendering = !0);
    0 === ($6909e5993a213e12$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($6909e5993a213e12$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $6909e5993a213e12$var$workInProgressRoot || $6909e5993a213e12$var$markRootSuspended($6909e5993a213e12$var$workInProgressRoot, $6909e5993a213e12$var$workInProgressRootRenderLanes, $6909e5993a213e12$var$workInProgressDeferredLane, !1);
}
function $6909e5993a213e12$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $6909e5993a213e12$var$executionContext;
    $6909e5993a213e12$var$executionContext |= 2;
    var prevDispatcher = $6909e5993a213e12$var$pushDispatcher(), prevAsyncDispatcher = $6909e5993a213e12$var$pushAsyncDispatcher();
    if ($6909e5993a213e12$var$workInProgressRoot !== root || $6909e5993a213e12$var$workInProgressRootRenderLanes !== lanes) $6909e5993a213e12$var$workInProgressTransitions = null, $6909e5993a213e12$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $6909e5993a213e12$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $6909e5993a213e12$var$workInProgressSuspendedReason && null !== $6909e5993a213e12$var$workInProgress) {
            var unitOfWork = $6909e5993a213e12$var$workInProgress, thrownValue = $6909e5993a213e12$var$workInProgressThrownValue;
            switch($6909e5993a213e12$var$workInProgressSuspendedReason){
                case 8:
                    $6909e5993a213e12$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $6909e5993a213e12$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $6909e5993a213e12$var$workInProgressSuspendedReason;
                    $6909e5993a213e12$var$workInProgressSuspendedReason = 0;
                    $6909e5993a213e12$var$workInProgressThrownValue = null;
                    $6909e5993a213e12$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $6909e5993a213e12$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $6909e5993a213e12$var$workInProgressSuspendedReason, $6909e5993a213e12$var$workInProgressSuspendedReason = 0, $6909e5993a213e12$var$workInProgressThrownValue = null, $6909e5993a213e12$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $6909e5993a213e12$var$workLoopSync();
        exitStatus = $6909e5993a213e12$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $6909e5993a213e12$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $6909e5993a213e12$var$lastContextDependency = $6909e5993a213e12$var$currentlyRenderingFiber$1 = null;
    $6909e5993a213e12$var$executionContext = prevExecutionContext;
    $6909e5993a213e12$var$ReactSharedInternals.H = prevDispatcher;
    $6909e5993a213e12$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $6909e5993a213e12$var$workInProgress && ($6909e5993a213e12$var$workInProgressRoot = null, $6909e5993a213e12$var$workInProgressRootRenderLanes = 0, $6909e5993a213e12$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $6909e5993a213e12$var$workLoopSync() {
    for(; null !== $6909e5993a213e12$var$workInProgress;)$6909e5993a213e12$var$performUnitOfWork($6909e5993a213e12$var$workInProgress);
}
function $6909e5993a213e12$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $6909e5993a213e12$var$executionContext;
    $6909e5993a213e12$var$executionContext |= 2;
    var prevDispatcher = $6909e5993a213e12$var$pushDispatcher(), prevAsyncDispatcher = $6909e5993a213e12$var$pushAsyncDispatcher();
    $6909e5993a213e12$var$workInProgressRoot !== root || $6909e5993a213e12$var$workInProgressRootRenderLanes !== lanes ? ($6909e5993a213e12$var$workInProgressTransitions = null, $6909e5993a213e12$var$workInProgressRootRenderTargetTime = $6909e5993a213e12$var$now() + 500, $6909e5993a213e12$var$prepareFreshStack(root, lanes)) : $6909e5993a213e12$var$workInProgressRootIsPrerendering = $6909e5993a213e12$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $6909e5993a213e12$var$workInProgressSuspendedReason && null !== $6909e5993a213e12$var$workInProgress) {
            lanes = $6909e5993a213e12$var$workInProgress;
            var thrownValue = $6909e5993a213e12$var$workInProgressThrownValue;
            b: switch($6909e5993a213e12$var$workInProgressSuspendedReason){
                case 1:
                    $6909e5993a213e12$var$workInProgressSuspendedReason = 0;
                    $6909e5993a213e12$var$workInProgressThrownValue = null;
                    $6909e5993a213e12$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($6909e5993a213e12$var$isThenableResolved(thrownValue)) {
                        $6909e5993a213e12$var$workInProgressSuspendedReason = 0;
                        $6909e5993a213e12$var$workInProgressThrownValue = null;
                        $6909e5993a213e12$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function lanes() {
                        2 !== $6909e5993a213e12$var$workInProgressSuspendedReason && 9 !== $6909e5993a213e12$var$workInProgressSuspendedReason || $6909e5993a213e12$var$workInProgressRoot !== root || ($6909e5993a213e12$var$workInProgressSuspendedReason = 7);
                        $6909e5993a213e12$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $6909e5993a213e12$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $6909e5993a213e12$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $6909e5993a213e12$var$isThenableResolved(thrownValue) ? ($6909e5993a213e12$var$workInProgressSuspendedReason = 0, $6909e5993a213e12$var$workInProgressThrownValue = null, $6909e5993a213e12$var$replaySuspendedUnitOfWork(lanes)) : ($6909e5993a213e12$var$workInProgressSuspendedReason = 0, $6909e5993a213e12$var$workInProgressThrownValue = null, $6909e5993a213e12$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($6909e5993a213e12$var$workInProgress.tag){
                        case 26:
                            resource = $6909e5993a213e12$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $6909e5993a213e12$var$workInProgress;
                            if (resource ? $6909e5993a213e12$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $6909e5993a213e12$var$workInProgressSuspendedReason = 0;
                                $6909e5993a213e12$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $6909e5993a213e12$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($6909e5993a213e12$var$workInProgress = returnFiber, $6909e5993a213e12$var$completeUnitOfWork(returnFiber)) : $6909e5993a213e12$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $6909e5993a213e12$var$workInProgressSuspendedReason = 0;
                    $6909e5993a213e12$var$workInProgressThrownValue = null;
                    $6909e5993a213e12$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $6909e5993a213e12$var$workInProgressSuspendedReason = 0;
                    $6909e5993a213e12$var$workInProgressThrownValue = null;
                    $6909e5993a213e12$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $6909e5993a213e12$var$resetWorkInProgressStack();
                    $6909e5993a213e12$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($6909e5993a213e12$var$formatProdErrorMessage(462));
            }
        }
        $6909e5993a213e12$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $6909e5993a213e12$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $6909e5993a213e12$var$lastContextDependency = $6909e5993a213e12$var$currentlyRenderingFiber$1 = null;
    $6909e5993a213e12$var$ReactSharedInternals.H = prevDispatcher;
    $6909e5993a213e12$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $6909e5993a213e12$var$executionContext = prevExecutionContext;
    if (null !== $6909e5993a213e12$var$workInProgress) return 0;
    $6909e5993a213e12$var$workInProgressRoot = null;
    $6909e5993a213e12$var$workInProgressRootRenderLanes = 0;
    $6909e5993a213e12$var$finishQueueingConcurrentUpdates();
    return $6909e5993a213e12$var$workInProgressRootExitStatus;
}
function $6909e5993a213e12$var$workLoopConcurrentByScheduler() {
    for(; null !== $6909e5993a213e12$var$workInProgress && !$6909e5993a213e12$var$shouldYield();)$6909e5993a213e12$var$performUnitOfWork($6909e5993a213e12$var$workInProgress);
}
function $6909e5993a213e12$var$performUnitOfWork(unitOfWork) {
    var next = $6909e5993a213e12$var$beginWork(unitOfWork.alternate, unitOfWork, $6909e5993a213e12$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $6909e5993a213e12$var$completeUnitOfWork(unitOfWork) : $6909e5993a213e12$var$workInProgress = next;
}
function $6909e5993a213e12$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $6909e5993a213e12$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $6909e5993a213e12$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $6909e5993a213e12$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $6909e5993a213e12$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $6909e5993a213e12$var$resetHooksOnUnwind(next);
        default:
            $6909e5993a213e12$var$unwindInterruptedWork(current, next), next = $6909e5993a213e12$var$workInProgress = $6909e5993a213e12$var$resetWorkInProgress(next, $6909e5993a213e12$var$entangledRenderLanes), next = $6909e5993a213e12$var$beginWork(current, next, $6909e5993a213e12$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $6909e5993a213e12$var$completeUnitOfWork(unitOfWork) : $6909e5993a213e12$var$workInProgress = next;
}
function $6909e5993a213e12$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $6909e5993a213e12$var$lastContextDependency = $6909e5993a213e12$var$currentlyRenderingFiber$1 = null;
    $6909e5993a213e12$var$resetHooksOnUnwind(unitOfWork);
    $6909e5993a213e12$var$thenableState$1 = null;
    $6909e5993a213e12$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($6909e5993a213e12$var$throwException(root, returnFiber, unitOfWork, thrownValue, $6909e5993a213e12$var$workInProgressRootRenderLanes)) {
            $6909e5993a213e12$var$workInProgressRootExitStatus = 1;
            $6909e5993a213e12$var$logUncaughtError(root, $6909e5993a213e12$var$createCapturedValueAtFiber(thrownValue, root.current));
            $6909e5993a213e12$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $6909e5993a213e12$var$workInProgress = returnFiber, error;
        $6909e5993a213e12$var$workInProgressRootExitStatus = 1;
        $6909e5993a213e12$var$logUncaughtError(root, $6909e5993a213e12$var$createCapturedValueAtFiber(thrownValue, root.current));
        $6909e5993a213e12$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($6909e5993a213e12$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($6909e5993a213e12$var$workInProgressRootIsPrerendering || 0 !== ($6909e5993a213e12$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($6909e5993a213e12$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $6909e5993a213e12$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $6909e5993a213e12$var$unwindUnitOfWork(unitOfWork, root);
    } else $6909e5993a213e12$var$completeUnitOfWork(unitOfWork);
}
function $6909e5993a213e12$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $6909e5993a213e12$var$unwindUnitOfWork(completedWork, $6909e5993a213e12$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $6909e5993a213e12$var$completeWork(completedWork.alternate, completedWork, $6909e5993a213e12$var$entangledRenderLanes);
        if (null !== next) {
            $6909e5993a213e12$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $6909e5993a213e12$var$workInProgress = completedWork;
            return;
        }
        $6909e5993a213e12$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $6909e5993a213e12$var$workInProgressRootExitStatus && ($6909e5993a213e12$var$workInProgressRootExitStatus = 5);
}
function $6909e5993a213e12$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $6909e5993a213e12$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $6909e5993a213e12$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $6909e5993a213e12$var$workInProgress = unitOfWork;
            return;
        }
        $6909e5993a213e12$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $6909e5993a213e12$var$workInProgressRootExitStatus = 6;
    $6909e5993a213e12$var$workInProgress = null;
}
function $6909e5993a213e12$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $6909e5993a213e12$var$flushPendingEffects();
    while (0 !== $6909e5993a213e12$var$pendingEffectsStatus);
    if (0 !== ($6909e5993a213e12$var$executionContext & 6)) throw Error($6909e5993a213e12$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($6909e5993a213e12$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $6909e5993a213e12$var$concurrentlyUpdatedLanes;
        $6909e5993a213e12$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $6909e5993a213e12$var$workInProgressRoot && ($6909e5993a213e12$var$workInProgress = $6909e5993a213e12$var$workInProgressRoot = null, $6909e5993a213e12$var$workInProgressRootRenderLanes = 0);
        $6909e5993a213e12$var$pendingFinishedWork = finishedWork;
        $6909e5993a213e12$var$pendingEffectsRoot = root;
        $6909e5993a213e12$var$pendingEffectsLanes = lanes;
        $6909e5993a213e12$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $6909e5993a213e12$var$pendingPassiveTransitions = transitions;
        $6909e5993a213e12$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $6909e5993a213e12$var$scheduleCallback$1($6909e5993a213e12$var$NormalPriority$1, function() {
            $6909e5993a213e12$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $6909e5993a213e12$var$ReactSharedInternals.T;
            $6909e5993a213e12$var$ReactSharedInternals.T = null;
            transitions = $6909e5993a213e12$var$ReactDOMSharedInternals.p;
            $6909e5993a213e12$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $6909e5993a213e12$var$executionContext;
            $6909e5993a213e12$var$executionContext |= 4;
            try {
                $6909e5993a213e12$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $6909e5993a213e12$var$executionContext = spawnedLane, $6909e5993a213e12$var$ReactDOMSharedInternals.p = transitions, $6909e5993a213e12$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $6909e5993a213e12$var$pendingEffectsStatus = 1;
        $6909e5993a213e12$var$flushMutationEffects();
        $6909e5993a213e12$var$flushLayoutEffects();
        $6909e5993a213e12$var$flushSpawnedWork();
    }
}
function $6909e5993a213e12$var$flushMutationEffects() {
    if (1 === $6909e5993a213e12$var$pendingEffectsStatus) {
        $6909e5993a213e12$var$pendingEffectsStatus = 0;
        var root = $6909e5993a213e12$var$pendingEffectsRoot, finishedWork = $6909e5993a213e12$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $6909e5993a213e12$var$ReactSharedInternals.T;
            $6909e5993a213e12$var$ReactSharedInternals.T = null;
            var previousPriority = $6909e5993a213e12$var$ReactDOMSharedInternals.p;
            $6909e5993a213e12$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $6909e5993a213e12$var$executionContext;
            $6909e5993a213e12$var$executionContext |= 4;
            try {
                $6909e5993a213e12$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $6909e5993a213e12$var$selectionInformation, curFocusedElem = $6909e5993a213e12$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $6909e5993a213e12$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $6909e5993a213e12$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $6909e5993a213e12$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $6909e5993a213e12$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $6909e5993a213e12$var$_enabled = !!$6909e5993a213e12$var$eventsEnabled;
                $6909e5993a213e12$var$selectionInformation = $6909e5993a213e12$var$eventsEnabled = null;
            } finally{
                $6909e5993a213e12$var$executionContext = prevExecutionContext, $6909e5993a213e12$var$ReactDOMSharedInternals.p = previousPriority, $6909e5993a213e12$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $6909e5993a213e12$var$pendingEffectsStatus = 2;
    }
}
function $6909e5993a213e12$var$flushLayoutEffects() {
    if (2 === $6909e5993a213e12$var$pendingEffectsStatus) {
        $6909e5993a213e12$var$pendingEffectsStatus = 0;
        var root = $6909e5993a213e12$var$pendingEffectsRoot, finishedWork = $6909e5993a213e12$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $6909e5993a213e12$var$ReactSharedInternals.T;
            $6909e5993a213e12$var$ReactSharedInternals.T = null;
            var previousPriority = $6909e5993a213e12$var$ReactDOMSharedInternals.p;
            $6909e5993a213e12$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $6909e5993a213e12$var$executionContext;
            $6909e5993a213e12$var$executionContext |= 4;
            try {
                $6909e5993a213e12$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $6909e5993a213e12$var$executionContext = prevExecutionContext, $6909e5993a213e12$var$ReactDOMSharedInternals.p = previousPriority, $6909e5993a213e12$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $6909e5993a213e12$var$pendingEffectsStatus = 3;
    }
}
function $6909e5993a213e12$var$flushSpawnedWork() {
    if (4 === $6909e5993a213e12$var$pendingEffectsStatus || 3 === $6909e5993a213e12$var$pendingEffectsStatus) {
        $6909e5993a213e12$var$pendingEffectsStatus = 0;
        $6909e5993a213e12$var$requestPaint();
        var root = $6909e5993a213e12$var$pendingEffectsRoot, finishedWork = $6909e5993a213e12$var$pendingFinishedWork, lanes = $6909e5993a213e12$var$pendingEffectsLanes, recoverableErrors = $6909e5993a213e12$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $6909e5993a213e12$var$pendingEffectsStatus = 5 : ($6909e5993a213e12$var$pendingEffectsStatus = 0, $6909e5993a213e12$var$pendingFinishedWork = $6909e5993a213e12$var$pendingEffectsRoot = null, $6909e5993a213e12$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($6909e5993a213e12$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $6909e5993a213e12$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($6909e5993a213e12$var$injectedHook && "function" === typeof $6909e5993a213e12$var$injectedHook.onCommitFiberRoot) try {
            $6909e5993a213e12$var$injectedHook.onCommitFiberRoot($6909e5993a213e12$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $6909e5993a213e12$var$ReactSharedInternals.T;
            remainingLanes = $6909e5993a213e12$var$ReactDOMSharedInternals.p;
            $6909e5993a213e12$var$ReactDOMSharedInternals.p = 2;
            $6909e5993a213e12$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $6909e5993a213e12$var$ReactSharedInternals.T = finishedWork, $6909e5993a213e12$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($6909e5993a213e12$var$pendingEffectsLanes & 3) && $6909e5993a213e12$var$flushPendingEffects();
        $6909e5993a213e12$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $6909e5993a213e12$var$rootWithNestedUpdates ? $6909e5993a213e12$var$nestedUpdateCount++ : ($6909e5993a213e12$var$nestedUpdateCount = 0, $6909e5993a213e12$var$rootWithNestedUpdates = root) : $6909e5993a213e12$var$nestedUpdateCount = 0;
        $6909e5993a213e12$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $6909e5993a213e12$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $6909e5993a213e12$var$releaseCache(remainingLanes)));
}
function $6909e5993a213e12$var$flushPendingEffects() {
    $6909e5993a213e12$var$flushMutationEffects();
    $6909e5993a213e12$var$flushLayoutEffects();
    $6909e5993a213e12$var$flushSpawnedWork();
    return $6909e5993a213e12$var$flushPassiveEffects();
}
function $6909e5993a213e12$var$flushPassiveEffects() {
    if (5 !== $6909e5993a213e12$var$pendingEffectsStatus) return !1;
    var root = $6909e5993a213e12$var$pendingEffectsRoot, remainingLanes = $6909e5993a213e12$var$pendingEffectsRemainingLanes;
    $6909e5993a213e12$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $6909e5993a213e12$var$lanesToEventPriority($6909e5993a213e12$var$pendingEffectsLanes), prevTransition = $6909e5993a213e12$var$ReactSharedInternals.T, previousPriority = $6909e5993a213e12$var$ReactDOMSharedInternals.p;
    try {
        $6909e5993a213e12$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $6909e5993a213e12$var$ReactSharedInternals.T = null;
        renderPriority = $6909e5993a213e12$var$pendingPassiveTransitions;
        $6909e5993a213e12$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $6909e5993a213e12$var$pendingEffectsRoot, lanes = $6909e5993a213e12$var$pendingEffectsLanes;
        $6909e5993a213e12$var$pendingEffectsStatus = 0;
        $6909e5993a213e12$var$pendingFinishedWork = $6909e5993a213e12$var$pendingEffectsRoot = null;
        $6909e5993a213e12$var$pendingEffectsLanes = 0;
        if (0 !== ($6909e5993a213e12$var$executionContext & 6)) throw Error($6909e5993a213e12$var$formatProdErrorMessage(331));
        var prevExecutionContext = $6909e5993a213e12$var$executionContext;
        $6909e5993a213e12$var$executionContext |= 4;
        $6909e5993a213e12$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $6909e5993a213e12$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $6909e5993a213e12$var$executionContext = prevExecutionContext;
        $6909e5993a213e12$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($6909e5993a213e12$var$injectedHook && "function" === typeof $6909e5993a213e12$var$injectedHook.onPostCommitFiberRoot) try {
            $6909e5993a213e12$var$injectedHook.onPostCommitFiberRoot($6909e5993a213e12$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $6909e5993a213e12$var$ReactDOMSharedInternals.p = previousPriority, $6909e5993a213e12$var$ReactSharedInternals.T = prevTransition, $6909e5993a213e12$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $6909e5993a213e12$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $6909e5993a213e12$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $6909e5993a213e12$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $6909e5993a213e12$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($6909e5993a213e12$var$markRootUpdated$1(rootFiber, 2), $6909e5993a213e12$var$ensureRootIsScheduled(rootFiber));
}
function $6909e5993a213e12$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $6909e5993a213e12$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $6909e5993a213e12$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $6909e5993a213e12$var$legacyErrorBoundariesThatAlreadyFailed || !$6909e5993a213e12$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $6909e5993a213e12$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $6909e5993a213e12$var$createClassErrorUpdate(2);
                instance = $6909e5993a213e12$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($6909e5993a213e12$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $6909e5993a213e12$var$markRootUpdated$1(instance, 2), $6909e5993a213e12$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $6909e5993a213e12$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $6909e5993a213e12$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($6909e5993a213e12$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $6909e5993a213e12$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $6909e5993a213e12$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $6909e5993a213e12$var$workInProgressRoot === root && ($6909e5993a213e12$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $6909e5993a213e12$var$workInProgressRootExitStatus || 3 === $6909e5993a213e12$var$workInProgressRootExitStatus && ($6909e5993a213e12$var$workInProgressRootRenderLanes & 62914560) === $6909e5993a213e12$var$workInProgressRootRenderLanes && 300 > $6909e5993a213e12$var$now() - $6909e5993a213e12$var$globalMostRecentFallbackTime ? 0 === ($6909e5993a213e12$var$executionContext & 2) && $6909e5993a213e12$var$prepareFreshStack(root, 0) : $6909e5993a213e12$var$workInProgressRootPingedLanes |= pingedLanes, $6909e5993a213e12$var$workInProgressSuspendedRetryLanes === $6909e5993a213e12$var$workInProgressRootRenderLanes && ($6909e5993a213e12$var$workInProgressSuspendedRetryLanes = 0));
    $6909e5993a213e12$var$ensureRootIsScheduled(root);
}
function $6909e5993a213e12$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $6909e5993a213e12$var$claimNextRetryLane());
    boundaryFiber = $6909e5993a213e12$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($6909e5993a213e12$var$markRootUpdated$1(boundaryFiber, retryLane), $6909e5993a213e12$var$ensureRootIsScheduled(boundaryFiber));
}
function $6909e5993a213e12$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $6909e5993a213e12$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $6909e5993a213e12$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($6909e5993a213e12$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $6909e5993a213e12$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $6909e5993a213e12$var$scheduleCallback$1(priorityLevel, callback) {
    return $6909e5993a213e12$var$scheduleCallback$3(priorityLevel, callback);
}
var $6909e5993a213e12$var$firstScheduledRoot = null, $6909e5993a213e12$var$lastScheduledRoot = null, $6909e5993a213e12$var$didScheduleMicrotask = !1, $6909e5993a213e12$var$mightHavePendingSyncWork = !1, $6909e5993a213e12$var$isFlushingWork = !1, $6909e5993a213e12$var$currentEventTransitionLane = 0;
function $6909e5993a213e12$var$ensureRootIsScheduled(root) {
    root !== $6909e5993a213e12$var$lastScheduledRoot && null === root.next && (null === $6909e5993a213e12$var$lastScheduledRoot ? $6909e5993a213e12$var$firstScheduledRoot = $6909e5993a213e12$var$lastScheduledRoot = root : $6909e5993a213e12$var$lastScheduledRoot = $6909e5993a213e12$var$lastScheduledRoot.next = root);
    $6909e5993a213e12$var$mightHavePendingSyncWork = !0;
    $6909e5993a213e12$var$didScheduleMicrotask || ($6909e5993a213e12$var$didScheduleMicrotask = !0, $6909e5993a213e12$var$scheduleImmediateRootScheduleTask());
}
function $6909e5993a213e12$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$6909e5993a213e12$var$isFlushingWork && $6909e5993a213e12$var$mightHavePendingSyncWork) {
        $6909e5993a213e12$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $6909e5993a213e12$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $6909e5993a213e12$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $6909e5993a213e12$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $6909e5993a213e12$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $6909e5993a213e12$var$getNextLanes(root$170, root$170 === $6909e5993a213e12$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $6909e5993a213e12$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $6909e5993a213e12$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $6909e5993a213e12$var$isFlushingWork = !1;
    }
}
function $6909e5993a213e12$var$processRootScheduleInImmediateTask() {
    $6909e5993a213e12$var$processRootScheduleInMicrotask();
}
function $6909e5993a213e12$var$processRootScheduleInMicrotask() {
    $6909e5993a213e12$var$mightHavePendingSyncWork = $6909e5993a213e12$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $6909e5993a213e12$var$currentEventTransitionLane && $6909e5993a213e12$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $6909e5993a213e12$var$currentEventTransitionLane);
    for(var currentTime = $6909e5993a213e12$var$now(), prev = null, root = $6909e5993a213e12$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $6909e5993a213e12$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $6909e5993a213e12$var$firstScheduledRoot = next : prev.next = next, null === next && ($6909e5993a213e12$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $6909e5993a213e12$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $6909e5993a213e12$var$pendingEffectsStatus && 5 !== $6909e5993a213e12$var$pendingEffectsStatus || $6909e5993a213e12$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $6909e5993a213e12$var$currentEventTransitionLane && ($6909e5993a213e12$var$currentEventTransitionLane = 0);
}
function $6909e5993a213e12$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $6909e5993a213e12$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $6909e5993a213e12$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $6909e5993a213e12$var$workInProgressRoot;
    suspendedLanes = $6909e5993a213e12$var$workInProgressRootRenderLanes;
    suspendedLanes = $6909e5993a213e12$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $6909e5993a213e12$var$workInProgressSuspendedReason || 9 === $6909e5993a213e12$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $6909e5993a213e12$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $6909e5993a213e12$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $6909e5993a213e12$var$cancelCallback$1(pingedLanes);
        switch($6909e5993a213e12$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $6909e5993a213e12$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $6909e5993a213e12$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $6909e5993a213e12$var$IdlePriority;
                break;
            default:
                suspendedLanes = $6909e5993a213e12$var$NormalPriority$1;
        }
        pingedLanes = $6909e5993a213e12$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $6909e5993a213e12$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $6909e5993a213e12$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $6909e5993a213e12$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $6909e5993a213e12$var$pendingEffectsStatus && 5 !== $6909e5993a213e12$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($6909e5993a213e12$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $6909e5993a213e12$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $6909e5993a213e12$var$getNextLanes(root, root === $6909e5993a213e12$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $6909e5993a213e12$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $6909e5993a213e12$var$scheduleTaskForRootDuringMicrotask(root, $6909e5993a213e12$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $6909e5993a213e12$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $6909e5993a213e12$var$performSyncWorkOnRoot(root, lanes) {
    if ($6909e5993a213e12$var$flushPendingEffects()) return null;
    $6909e5993a213e12$var$performWorkOnRoot(root, lanes, !0);
}
function $6909e5993a213e12$var$scheduleImmediateRootScheduleTask() {
    $6909e5993a213e12$var$scheduleMicrotask(function() {
        0 !== ($6909e5993a213e12$var$executionContext & 6) ? $6909e5993a213e12$var$scheduleCallback$3($6909e5993a213e12$var$ImmediatePriority, $6909e5993a213e12$var$processRootScheduleInImmediateTask) : $6909e5993a213e12$var$processRootScheduleInMicrotask();
    });
}
function $6909e5993a213e12$var$requestTransitionLane() {
    if (0 === $6909e5993a213e12$var$currentEventTransitionLane) {
        var actionScopeLane = $6909e5993a213e12$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $6909e5993a213e12$var$nextTransitionUpdateLane, $6909e5993a213e12$var$nextTransitionUpdateLane <<= 1, 0 === ($6909e5993a213e12$var$nextTransitionUpdateLane & 261888) && ($6909e5993a213e12$var$nextTransitionUpdateLane = 256));
        $6909e5993a213e12$var$currentEventTransitionLane = actionScopeLane;
    }
    return $6909e5993a213e12$var$currentEventTransitionLane;
}
function $6909e5993a213e12$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === (typeof actionProp === "undefined" ? "undefined" : (0, $03bAP._)(actionProp)) || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $6909e5993a213e12$var$sanitizeURL("" + actionProp);
}
function $6909e5993a213e12$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $6909e5993a213e12$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $6909e5993a213e12$var$coerceFormActionProp((nativeEventTarget[$6909e5993a213e12$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$6909e5993a213e12$var$internalPropsKey] || null) ? $6909e5993a213e12$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $6909e5993a213e12$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function listener() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $6909e5993a213e12$var$currentEventTransitionLane) {
                                var formData = submitter ? $6909e5993a213e12$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $6909e5993a213e12$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $6909e5993a213e12$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $6909e5993a213e12$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $6909e5993a213e12$var$i$jscomp$inline_1577 = 0; $6909e5993a213e12$var$i$jscomp$inline_1577 < $6909e5993a213e12$var$simpleEventPluginEvents.length; $6909e5993a213e12$var$i$jscomp$inline_1577++){
    var $6909e5993a213e12$var$eventName$jscomp$inline_1578 = $6909e5993a213e12$var$simpleEventPluginEvents[$6909e5993a213e12$var$i$jscomp$inline_1577], $6909e5993a213e12$var$domEventName$jscomp$inline_1579 = $6909e5993a213e12$var$eventName$jscomp$inline_1578.toLowerCase(), $6909e5993a213e12$var$capitalizedEvent$jscomp$inline_1580 = $6909e5993a213e12$var$eventName$jscomp$inline_1578[0].toUpperCase() + $6909e5993a213e12$var$eventName$jscomp$inline_1578.slice(1);
    $6909e5993a213e12$var$registerSimpleEvent($6909e5993a213e12$var$domEventName$jscomp$inline_1579, "on" + $6909e5993a213e12$var$capitalizedEvent$jscomp$inline_1580);
}
$6909e5993a213e12$var$registerSimpleEvent($6909e5993a213e12$var$ANIMATION_END, "onAnimationEnd");
$6909e5993a213e12$var$registerSimpleEvent($6909e5993a213e12$var$ANIMATION_ITERATION, "onAnimationIteration");
$6909e5993a213e12$var$registerSimpleEvent($6909e5993a213e12$var$ANIMATION_START, "onAnimationStart");
$6909e5993a213e12$var$registerSimpleEvent("dblclick", "onDoubleClick");
$6909e5993a213e12$var$registerSimpleEvent("focusin", "onFocus");
$6909e5993a213e12$var$registerSimpleEvent("focusout", "onBlur");
$6909e5993a213e12$var$registerSimpleEvent($6909e5993a213e12$var$TRANSITION_RUN, "onTransitionRun");
$6909e5993a213e12$var$registerSimpleEvent($6909e5993a213e12$var$TRANSITION_START, "onTransitionStart");
$6909e5993a213e12$var$registerSimpleEvent($6909e5993a213e12$var$TRANSITION_CANCEL, "onTransitionCancel");
$6909e5993a213e12$var$registerSimpleEvent($6909e5993a213e12$var$TRANSITION_END, "onTransitionEnd");
$6909e5993a213e12$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$6909e5993a213e12$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$6909e5993a213e12$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$6909e5993a213e12$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$6909e5993a213e12$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$6909e5993a213e12$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$6909e5993a213e12$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$6909e5993a213e12$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$6909e5993a213e12$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$6909e5993a213e12$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $6909e5993a213e12$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $6909e5993a213e12$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($6909e5993a213e12$var$mediaEventTypes));
function $6909e5993a213e12$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $6909e5993a213e12$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $6909e5993a213e12$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $6909e5993a213e12$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$6909e5993a213e12$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$6909e5993a213e12$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($6909e5993a213e12$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $6909e5993a213e12$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $6909e5993a213e12$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $6909e5993a213e12$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $6909e5993a213e12$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$6909e5993a213e12$var$listeningMarker]) {
        rootContainerElement[$6909e5993a213e12$var$listeningMarker] = !0;
        $6909e5993a213e12$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($6909e5993a213e12$var$nonDelegatedEvents.has(domEventName) || $6909e5993a213e12$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $6909e5993a213e12$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$6909e5993a213e12$var$listeningMarker] || (ownerDocument[$6909e5993a213e12$var$listeningMarker] = !0, $6909e5993a213e12$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $6909e5993a213e12$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($6909e5993a213e12$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $6909e5993a213e12$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $6909e5993a213e12$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $6909e5993a213e12$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$6909e5993a213e12$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $6909e5993a213e12$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $6909e5993a213e12$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $6909e5993a213e12$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $6909e5993a213e12$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $6909e5993a213e12$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $6909e5993a213e12$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $6909e5993a213e12$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticTouchEvent;
                        break;
                    case $6909e5993a213e12$var$ANIMATION_END:
                    case $6909e5993a213e12$var$ANIMATION_ITERATION:
                    case $6909e5993a213e12$var$ANIMATION_START:
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticAnimationEvent;
                        break;
                    case $6909e5993a213e12$var$TRANSITION_END:
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $6909e5993a213e12$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $6909e5993a213e12$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($6909e5993a213e12$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $6909e5993a213e12$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($6909e5993a213e12$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$6909e5993a213e12$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $6909e5993a213e12$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $6909e5993a213e12$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $6909e5993a213e12$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $6909e5993a213e12$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $6909e5993a213e12$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $6909e5993a213e12$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $6909e5993a213e12$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $6909e5993a213e12$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $6909e5993a213e12$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $6909e5993a213e12$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $6909e5993a213e12$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $6909e5993a213e12$var$getTargetInstForChangeEvent;
                else if ($6909e5993a213e12$var$isTextInputElement(reactName)) {
                    if ($6909e5993a213e12$var$isInputEventSupported) getTargetInstFunc = $6909e5993a213e12$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $6909e5993a213e12$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $6909e5993a213e12$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $6909e5993a213e12$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $6909e5993a213e12$var$getTargetInstForChangeEvent) : getTargetInstFunc = $6909e5993a213e12$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $6909e5993a213e12$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $6909e5993a213e12$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $6909e5993a213e12$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($6909e5993a213e12$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $6909e5993a213e12$var$activeElement = handleEventFunc, $6909e5993a213e12$var$activeElementInst = targetInst, $6909e5993a213e12$var$lastSelection = null;
                    break;
                case "focusout":
                    $6909e5993a213e12$var$lastSelection = $6909e5993a213e12$var$activeElementInst = $6909e5993a213e12$var$activeElement = null;
                    break;
                case "mousedown":
                    $6909e5993a213e12$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $6909e5993a213e12$var$mouseDown = !1;
                    $6909e5993a213e12$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($6909e5993a213e12$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $6909e5993a213e12$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($6909e5993a213e12$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $6909e5993a213e12$var$isComposing ? $6909e5993a213e12$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($6909e5993a213e12$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($6909e5993a213e12$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $6909e5993a213e12$var$isComposing && (fallbackData = $6909e5993a213e12$var$getData()) : ($6909e5993a213e12$var$root = nativeEventTarget, $6909e5993a213e12$var$startText = "value" in $6909e5993a213e12$var$root ? $6909e5993a213e12$var$root.value : $6909e5993a213e12$var$root.textContent, $6909e5993a213e12$var$isComposing = !0)), handleEventFunc = $6909e5993a213e12$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $6909e5993a213e12$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $6909e5993a213e12$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $6909e5993a213e12$var$canUseTextInputEvent ? $6909e5993a213e12$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $6909e5993a213e12$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $6909e5993a213e12$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $6909e5993a213e12$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $6909e5993a213e12$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $6909e5993a213e12$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $6909e5993a213e12$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $6909e5993a213e12$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $6909e5993a213e12$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($6909e5993a213e12$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $6909e5993a213e12$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($6909e5993a213e12$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $6909e5993a213e12$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $6909e5993a213e12$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $6909e5993a213e12$var$getListener(target, registrationName), null != stateNode && listeners.unshift($6909e5993a213e12$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $6909e5993a213e12$var$getListener(target, registrationName), null != stateNode && listeners.push($6909e5993a213e12$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $6909e5993a213e12$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $6909e5993a213e12$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $6909e5993a213e12$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($6909e5993a213e12$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($6909e5993a213e12$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $6909e5993a213e12$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $6909e5993a213e12$var$normalizeMarkupForTextOrAttribute(clientText);
    return $6909e5993a213e12$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $6909e5993a213e12$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $6909e5993a213e12$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value))) && "body" !== tag && $6909e5993a213e12$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $6909e5993a213e12$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $6909e5993a213e12$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $6909e5993a213e12$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $6909e5993a213e12$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $6909e5993a213e12$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $6909e5993a213e12$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $6909e5993a213e12$var$setProp(domElement, tag, "name", props.name, props, null), $6909e5993a213e12$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $6909e5993a213e12$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $6909e5993a213e12$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($6909e5993a213e12$var$setProp(domElement, tag, "encType", props.encType, props, null), $6909e5993a213e12$var$setProp(domElement, tag, "method", props.method, props, null), $6909e5993a213e12$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $6909e5993a213e12$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $6909e5993a213e12$var$noop$1);
            break;
        case "onScroll":
            null != value && $6909e5993a213e12$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $6909e5993a213e12$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) || !("__html" in value)) throw Error($6909e5993a213e12$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($6909e5993a213e12$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value));
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value));
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value))) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $6909e5993a213e12$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $6909e5993a213e12$var$listenToNonDelegatedEvent("toggle", domElement);
            $6909e5993a213e12$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $6909e5993a213e12$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $6909e5993a213e12$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $6909e5993a213e12$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $6909e5993a213e12$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $6909e5993a213e12$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $6909e5993a213e12$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $6909e5993a213e12$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $6909e5993a213e12$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $6909e5993a213e12$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $6909e5993a213e12$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $6909e5993a213e12$var$aliases.get(key) || key, $6909e5993a213e12$var$setValueForAttribute(domElement, key, value);
    }
}
function $6909e5993a213e12$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $6909e5993a213e12$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) || !("__html" in value)) throw Error($6909e5993a213e12$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($6909e5993a213e12$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $6909e5993a213e12$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value))) && $6909e5993a213e12$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $6909e5993a213e12$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $6909e5993a213e12$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $6909e5993a213e12$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$6909e5993a213e12$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$6909e5993a213e12$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $6909e5993a213e12$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $6909e5993a213e12$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("error", domElement);
            $6909e5993a213e12$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($6909e5993a213e12$var$formatProdErrorMessage(137, tag));
                    default:
                        $6909e5993a213e12$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $6909e5993a213e12$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $6909e5993a213e12$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($6909e5993a213e12$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $6909e5993a213e12$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $6909e5993a213e12$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $6909e5993a213e12$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $6909e5993a213e12$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $6909e5993a213e12$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($6909e5993a213e12$var$formatProdErrorMessage(91));
                    break;
                default:
                    $6909e5993a213e12$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $6909e5993a213e12$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== (typeof hasSrc === "undefined" ? "undefined" : (0, $03bAP._)(hasSrc));
                    break;
                default:
                    $6909e5993a213e12$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $6909e5993a213e12$var$listenToNonDelegatedEvent("toggle", domElement);
            $6909e5993a213e12$var$listenToNonDelegatedEvent("cancel", domElement);
            $6909e5993a213e12$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $6909e5993a213e12$var$mediaEventTypes.length; hasSrc++)$6909e5993a213e12$var$listenToNonDelegatedEvent($6909e5993a213e12$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("error", domElement);
            $6909e5993a213e12$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $6909e5993a213e12$var$listenToNonDelegatedEvent("error", domElement), $6909e5993a213e12$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($6909e5993a213e12$var$formatProdErrorMessage(137, tag));
                default:
                    $6909e5993a213e12$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($6909e5993a213e12$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $6909e5993a213e12$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $6909e5993a213e12$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $6909e5993a213e12$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $6909e5993a213e12$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($6909e5993a213e12$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $6909e5993a213e12$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $6909e5993a213e12$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $6909e5993a213e12$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $6909e5993a213e12$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $6909e5993a213e12$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $6909e5993a213e12$var$updateOptions(domElement, !!lastProps, tag, !0) : $6909e5993a213e12$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $6909e5993a213e12$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($6909e5993a213e12$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $6909e5993a213e12$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $6909e5993a213e12$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $6909e5993a213e12$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== (typeof propKey$201 === "undefined" ? "undefined" : (0, $03bAP._)(propKey$201));
                    break;
                default:
                    $6909e5993a213e12$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $6909e5993a213e12$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($6909e5993a213e12$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $6909e5993a213e12$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($6909e5993a213e12$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $6909e5993a213e12$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $6909e5993a213e12$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $6909e5993a213e12$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $6909e5993a213e12$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $6909e5993a213e12$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $6909e5993a213e12$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $6909e5993a213e12$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $6909e5993a213e12$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $6909e5993a213e12$var$eventsEnabled = null, $6909e5993a213e12$var$selectionInformation = null;
function $6909e5993a213e12$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $6909e5993a213e12$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $6909e5993a213e12$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $6909e5993a213e12$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === (0, $03bAP._)(props.children) || "object" === (0, $03bAP._)(props.dangerouslySetInnerHTML) && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $6909e5993a213e12$var$currentPopstateTransitionEvent = null;
function $6909e5993a213e12$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $6909e5993a213e12$var$currentPopstateTransitionEvent) return !1;
        $6909e5993a213e12$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $6909e5993a213e12$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $6909e5993a213e12$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $6909e5993a213e12$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $6909e5993a213e12$var$localPromise = "function" === typeof Promise ? Promise : void 0, $6909e5993a213e12$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $6909e5993a213e12$var$localPromise ? function scheduleMicrotask(callback) {
    return $6909e5993a213e12$var$localPromise.resolve(null).then(callback).catch($6909e5993a213e12$var$handleErrorInNextTick);
} : $6909e5993a213e12$var$scheduleTimeout;
function $6909e5993a213e12$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $6909e5993a213e12$var$isSingletonScope(type) {
    return "head" === type;
}
function $6909e5993a213e12$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $6909e5993a213e12$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $6909e5993a213e12$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $6909e5993a213e12$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$6909e5993a213e12$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $6909e5993a213e12$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $6909e5993a213e12$var$retryIfBlockedOn(hydrationInstance);
}
function $6909e5993a213e12$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $6909e5993a213e12$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $6909e5993a213e12$var$clearContainerSparingly(node);
                $6909e5993a213e12$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $6909e5993a213e12$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$6909e5993a213e12$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $6909e5993a213e12$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $6909e5993a213e12$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $6909e5993a213e12$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $6909e5993a213e12$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $6909e5993a213e12$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $6909e5993a213e12$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $6909e5993a213e12$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $6909e5993a213e12$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function listener1() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $6909e5993a213e12$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $6909e5993a213e12$var$previousHydratableOnEnteringScopedSingleton = null;
function $6909e5993a213e12$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $6909e5993a213e12$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $6909e5993a213e12$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $6909e5993a213e12$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $6909e5993a213e12$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($6909e5993a213e12$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($6909e5993a213e12$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($6909e5993a213e12$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($6909e5993a213e12$var$formatProdErrorMessage(451));
    }
}
function $6909e5993a213e12$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $6909e5993a213e12$var$detachDeletedInstance(instance);
}
var $6909e5993a213e12$var$preloadPropsMap = new Map(), $6909e5993a213e12$var$preconnectsSet = new Set();
function $6909e5993a213e12$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $6909e5993a213e12$var$previousDispatcher = $6909e5993a213e12$var$ReactDOMSharedInternals.d;
$6909e5993a213e12$var$ReactDOMSharedInternals.d = {
    f: $6909e5993a213e12$var$flushSyncWork,
    r: $6909e5993a213e12$var$requestFormReset,
    D: $6909e5993a213e12$var$prefetchDNS,
    C: $6909e5993a213e12$var$preconnect,
    L: $6909e5993a213e12$var$preload,
    m: $6909e5993a213e12$var$preloadModule,
    X: $6909e5993a213e12$var$preinitScript,
    S: $6909e5993a213e12$var$preinitStyle,
    M: $6909e5993a213e12$var$preinitModuleScript
};
function $6909e5993a213e12$var$flushSyncWork() {
    var previousWasRendering = $6909e5993a213e12$var$previousDispatcher.f(), wasRendering = $6909e5993a213e12$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $6909e5993a213e12$var$requestFormReset(form) {
    var formInst = $6909e5993a213e12$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $6909e5993a213e12$var$requestFormReset$1(formInst) : $6909e5993a213e12$var$previousDispatcher.r(form);
}
var $6909e5993a213e12$var$globalDocument = "undefined" === typeof document ? null : document;
function $6909e5993a213e12$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $6909e5993a213e12$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $6909e5993a213e12$var$preconnectsSet.has(limitedEscapedHref) || ($6909e5993a213e12$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $6909e5993a213e12$var$setInitialProperties(href, "link", rel), $6909e5993a213e12$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $6909e5993a213e12$var$prefetchDNS(href) {
    $6909e5993a213e12$var$previousDispatcher.D(href);
    $6909e5993a213e12$var$preconnectAs("dns-prefetch", href, null);
}
function $6909e5993a213e12$var$preconnect(href, crossOrigin) {
    $6909e5993a213e12$var$previousDispatcher.C(href, crossOrigin);
    $6909e5993a213e12$var$preconnectAs("preconnect", href, crossOrigin);
}
function $6909e5993a213e12$var$preload(href, as, options) {
    $6909e5993a213e12$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $6909e5993a213e12$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $6909e5993a213e12$var$getStyleKey(href);
                break;
            case "script":
                key = $6909e5993a213e12$var$getScriptKey(href);
        }
        $6909e5993a213e12$var$preloadPropsMap.has(key) || (href = $6909e5993a213e12$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $6909e5993a213e12$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($6909e5993a213e12$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($6909e5993a213e12$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $6909e5993a213e12$var$setInitialProperties(as, "link", href), $6909e5993a213e12$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $6909e5993a213e12$var$preloadModule(href, options) {
    $6909e5993a213e12$var$previousDispatcher.m(href, options);
    var ownerDocument = $6909e5993a213e12$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $6909e5993a213e12$var$getScriptKey(href);
        }
        if (!$6909e5993a213e12$var$preloadPropsMap.has(key) && (href = $6909e5993a213e12$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $6909e5993a213e12$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($6909e5993a213e12$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $6909e5993a213e12$var$setInitialProperties(as, "link", href);
            $6909e5993a213e12$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $6909e5993a213e12$var$preinitStyle(href, precedence, options) {
    $6909e5993a213e12$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $6909e5993a213e12$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $6909e5993a213e12$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $6909e5993a213e12$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($6909e5993a213e12$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $6909e5993a213e12$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $6909e5993a213e12$var$preloadPropsMap.get(key)) && $6909e5993a213e12$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $6909e5993a213e12$var$markNodeAsHoistable(link);
                $6909e5993a213e12$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $6909e5993a213e12$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $6909e5993a213e12$var$preinitScript(src, options) {
    $6909e5993a213e12$var$previousDispatcher.X(src, options);
    var ownerDocument = $6909e5993a213e12$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $6909e5993a213e12$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $6909e5993a213e12$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($6909e5993a213e12$var$getScriptSelectorFromKey(key)), resource || (src = $6909e5993a213e12$var$assign({
            src: src,
            async: !0
        }, options), (options = $6909e5993a213e12$var$preloadPropsMap.get(key)) && $6909e5993a213e12$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $6909e5993a213e12$var$markNodeAsHoistable(resource), $6909e5993a213e12$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $6909e5993a213e12$var$preinitModuleScript(src, options) {
    $6909e5993a213e12$var$previousDispatcher.M(src, options);
    var ownerDocument = $6909e5993a213e12$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $6909e5993a213e12$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $6909e5993a213e12$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($6909e5993a213e12$var$getScriptSelectorFromKey(key)), resource || (src = $6909e5993a213e12$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $6909e5993a213e12$var$preloadPropsMap.get(key)) && $6909e5993a213e12$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $6909e5993a213e12$var$markNodeAsHoistable(resource), $6909e5993a213e12$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $6909e5993a213e12$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $6909e5993a213e12$var$rootInstanceStackCursor.current) ? $6909e5993a213e12$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($6909e5993a213e12$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $6909e5993a213e12$var$getStyleKey(pendingProps.href), pendingProps = $6909e5993a213e12$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $6909e5993a213e12$var$getStyleKey(pendingProps.href);
                var styles$243 = $6909e5993a213e12$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($6909e5993a213e12$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $6909e5993a213e12$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $6909e5993a213e12$var$preloadPropsMap.set(type, pendingProps), styles$243 || $6909e5993a213e12$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($6909e5993a213e12$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($6909e5993a213e12$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== (typeof currentProps === "undefined" ? "undefined" : (0, $03bAP._)(currentProps)) ? (currentProps = $6909e5993a213e12$var$getScriptKey(pendingProps), pendingProps = $6909e5993a213e12$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($6909e5993a213e12$var$formatProdErrorMessage(444, type));
    }
}
function $6909e5993a213e12$var$getStyleKey(href) {
    return 'href="' + $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $6909e5993a213e12$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $6909e5993a213e12$var$stylesheetPropsFromRawProps(rawProps) {
    return $6909e5993a213e12$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $6909e5993a213e12$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $6909e5993a213e12$var$setInitialProperties(key, "link", preloadProps), $6909e5993a213e12$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $6909e5993a213e12$var$getScriptKey(src) {
    return '[src="' + $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $6909e5993a213e12$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $6909e5993a213e12$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $6909e5993a213e12$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $6909e5993a213e12$var$markNodeAsHoistable(instance), instance;
            var styleProps = $6909e5993a213e12$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $6909e5993a213e12$var$markNodeAsHoistable(instance);
            $6909e5993a213e12$var$setInitialProperties(instance, "style", styleProps);
            $6909e5993a213e12$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $6909e5993a213e12$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($6909e5993a213e12$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $6909e5993a213e12$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $6909e5993a213e12$var$stylesheetPropsFromRawProps(props);
            (styleProps = $6909e5993a213e12$var$preloadPropsMap.get(styleProps)) && $6909e5993a213e12$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $6909e5993a213e12$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $6909e5993a213e12$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $6909e5993a213e12$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $6909e5993a213e12$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($6909e5993a213e12$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $6909e5993a213e12$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $6909e5993a213e12$var$preloadPropsMap.get(instance$249)) instance = $6909e5993a213e12$var$assign({}, props), $6909e5993a213e12$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $6909e5993a213e12$var$markNodeAsHoistable(styleProps);
            $6909e5993a213e12$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($6909e5993a213e12$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $6909e5993a213e12$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $6909e5993a213e12$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $6909e5993a213e12$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $6909e5993a213e12$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $6909e5993a213e12$var$tagCaches = null;
function $6909e5993a213e12$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $6909e5993a213e12$var$tagCaches) {
        var cache = new Map();
        var caches = $6909e5993a213e12$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $6909e5993a213e12$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$6909e5993a213e12$var$internalHoistableMarker] || node[$6909e5993a213e12$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $6909e5993a213e12$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $6909e5993a213e12$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== (0, $03bAP._)(props.async) && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $6909e5993a213e12$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $6909e5993a213e12$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $6909e5993a213e12$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($6909e5993a213e12$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === (typeof hoistableRoot === "undefined" ? "undefined" : (0, $03bAP._)(hoistableRoot)) && "function" === typeof hoistableRoot.then && (state.count++, state = $6909e5993a213e12$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $6909e5993a213e12$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $6909e5993a213e12$var$stylesheetPropsFromRawProps(props);
            (key = $6909e5993a213e12$var$preloadPropsMap.get(key)) && $6909e5993a213e12$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $6909e5993a213e12$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $6909e5993a213e12$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $6909e5993a213e12$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $6909e5993a213e12$var$estimatedBytesWithinLimit = 0;
function $6909e5993a213e12$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $6909e5993a213e12$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $6909e5993a213e12$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $6909e5993a213e12$var$estimatedBytesWithinLimit && ($6909e5993a213e12$var$estimatedBytesWithinLimit = 62500 * $6909e5993a213e12$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $6909e5993a213e12$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $6909e5993a213e12$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $6909e5993a213e12$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $6909e5993a213e12$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $6909e5993a213e12$var$precedencesByRoot = null;
function $6909e5993a213e12$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $6909e5993a213e12$var$precedencesByRoot = new Map(), resources.forEach($6909e5993a213e12$var$insertStylesheetIntoRoot, state), $6909e5993a213e12$var$precedencesByRoot = null, $6909e5993a213e12$var$onUnsuspend.call(state));
}
function $6909e5993a213e12$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $6909e5993a213e12$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $6909e5993a213e12$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $6909e5993a213e12$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $6909e5993a213e12$var$HostTransitionContext = {
    $$typeof: $6909e5993a213e12$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $6909e5993a213e12$var$sharedNotPendingObject,
    _currentValue2: $6909e5993a213e12$var$sharedNotPendingObject,
    _threadCount: 0
};
function $6909e5993a213e12$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $6909e5993a213e12$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $6909e5993a213e12$var$createLaneMap(0);
    this.hiddenUpdates = $6909e5993a213e12$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $6909e5993a213e12$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $6909e5993a213e12$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $6909e5993a213e12$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $6909e5993a213e12$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $6909e5993a213e12$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $6909e5993a213e12$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $6909e5993a213e12$var$emptyContextObject;
    parentComponent = $6909e5993a213e12$var$emptyContextObject;
    return parentComponent;
}
function $6909e5993a213e12$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $6909e5993a213e12$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $6909e5993a213e12$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $6909e5993a213e12$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($6909e5993a213e12$var$scheduleUpdateOnFiber(element, rootFiber, lane), $6909e5993a213e12$var$entangleTransitions(element, rootFiber, lane));
}
function $6909e5993a213e12$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $6909e5993a213e12$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $6909e5993a213e12$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $6909e5993a213e12$var$markRetryLaneImpl(fiber, retryLane);
}
function $6909e5993a213e12$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $6909e5993a213e12$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $6909e5993a213e12$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $6909e5993a213e12$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $6909e5993a213e12$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $6909e5993a213e12$var$requestUpdateLane();
        lane = $6909e5993a213e12$var$getBumpedLaneForHydrationByLane(lane);
        var root = $6909e5993a213e12$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $6909e5993a213e12$var$scheduleUpdateOnFiber(root, fiber, lane);
        $6909e5993a213e12$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $6909e5993a213e12$var$_enabled = !0;
function $6909e5993a213e12$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $6909e5993a213e12$var$ReactSharedInternals.T;
    $6909e5993a213e12$var$ReactSharedInternals.T = null;
    var previousPriority = $6909e5993a213e12$var$ReactDOMSharedInternals.p;
    try {
        $6909e5993a213e12$var$ReactDOMSharedInternals.p = 2, $6909e5993a213e12$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $6909e5993a213e12$var$ReactDOMSharedInternals.p = previousPriority, $6909e5993a213e12$var$ReactSharedInternals.T = prevTransition;
    }
}
function $6909e5993a213e12$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $6909e5993a213e12$var$ReactSharedInternals.T;
    $6909e5993a213e12$var$ReactSharedInternals.T = null;
    var previousPriority = $6909e5993a213e12$var$ReactDOMSharedInternals.p;
    try {
        $6909e5993a213e12$var$ReactDOMSharedInternals.p = 8, $6909e5993a213e12$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $6909e5993a213e12$var$ReactDOMSharedInternals.p = previousPriority, $6909e5993a213e12$var$ReactSharedInternals.T = prevTransition;
    }
}
function $6909e5993a213e12$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($6909e5993a213e12$var$_enabled) {
        var blockedOn = $6909e5993a213e12$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $6909e5993a213e12$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $6909e5993a213e12$var$return_targetInst, targetContainer), $6909e5993a213e12$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($6909e5993a213e12$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($6909e5993a213e12$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $6909e5993a213e12$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $6909e5993a213e12$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $6909e5993a213e12$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $6909e5993a213e12$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $6909e5993a213e12$var$ensureRootIsScheduled(fiber);
                                0 === ($6909e5993a213e12$var$executionContext & 6) && ($6909e5993a213e12$var$workInProgressRootRenderTargetTime = $6909e5993a213e12$var$now() + 500, $6909e5993a213e12$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $6909e5993a213e12$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $6909e5993a213e12$var$scheduleUpdateOnFiber(root, fiber, 2), $6909e5993a213e12$var$flushSyncWork$1(), $6909e5993a213e12$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $6909e5993a213e12$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $6909e5993a213e12$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $6909e5993a213e12$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $6909e5993a213e12$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $6909e5993a213e12$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $6909e5993a213e12$var$getEventTarget(nativeEvent);
    return $6909e5993a213e12$var$findInstanceBlockingTarget(nativeEvent);
}
var $6909e5993a213e12$var$return_targetInst = null;
function $6909e5993a213e12$var$findInstanceBlockingTarget(targetNode) {
    $6909e5993a213e12$var$return_targetInst = null;
    targetNode = $6909e5993a213e12$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $6909e5993a213e12$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $6909e5993a213e12$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $6909e5993a213e12$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $6909e5993a213e12$var$return_targetInst = targetNode;
    return null;
}
function $6909e5993a213e12$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($6909e5993a213e12$var$getCurrentPriorityLevel()){
                case $6909e5993a213e12$var$ImmediatePriority:
                    return 2;
                case $6909e5993a213e12$var$UserBlockingPriority:
                    return 8;
                case $6909e5993a213e12$var$NormalPriority$1:
                case $6909e5993a213e12$var$LowPriority:
                    return 32;
                case $6909e5993a213e12$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $6909e5993a213e12$var$hasScheduledReplayAttempt = !1, $6909e5993a213e12$var$queuedFocus = null, $6909e5993a213e12$var$queuedDrag = null, $6909e5993a213e12$var$queuedMouse = null, $6909e5993a213e12$var$queuedPointers = new Map(), $6909e5993a213e12$var$queuedPointerCaptures = new Map(), $6909e5993a213e12$var$queuedExplicitHydrationTargets = [], $6909e5993a213e12$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $6909e5993a213e12$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $6909e5993a213e12$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $6909e5993a213e12$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $6909e5993a213e12$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $6909e5993a213e12$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $6909e5993a213e12$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $6909e5993a213e12$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $6909e5993a213e12$var$getInstanceFromNode(blockedOn), null !== blockedOn && $6909e5993a213e12$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $6909e5993a213e12$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $6909e5993a213e12$var$queuedFocus = $6909e5993a213e12$var$accumulateOrCreateContinuousQueuedReplayableEvent($6909e5993a213e12$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $6909e5993a213e12$var$queuedDrag = $6909e5993a213e12$var$accumulateOrCreateContinuousQueuedReplayableEvent($6909e5993a213e12$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $6909e5993a213e12$var$queuedMouse = $6909e5993a213e12$var$accumulateOrCreateContinuousQueuedReplayableEvent($6909e5993a213e12$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $6909e5993a213e12$var$queuedPointers.set(pointerId, $6909e5993a213e12$var$accumulateOrCreateContinuousQueuedReplayableEvent($6909e5993a213e12$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $6909e5993a213e12$var$queuedPointerCaptures.set(pointerId, $6909e5993a213e12$var$accumulateOrCreateContinuousQueuedReplayableEvent($6909e5993a213e12$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $6909e5993a213e12$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $6909e5993a213e12$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $6909e5993a213e12$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $6909e5993a213e12$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $6909e5993a213e12$var$runWithPriority(queuedTarget.priority, function() {
                        $6909e5993a213e12$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $6909e5993a213e12$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $6909e5993a213e12$var$runWithPriority(queuedTarget.priority, function() {
                        $6909e5993a213e12$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $6909e5993a213e12$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $6909e5993a213e12$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $6909e5993a213e12$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $6909e5993a213e12$var$currentReplayingEvent = null;
        } else return targetContainers = $6909e5993a213e12$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $6909e5993a213e12$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $6909e5993a213e12$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $6909e5993a213e12$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $6909e5993a213e12$var$replayUnblockedEvents() {
    $6909e5993a213e12$var$hasScheduledReplayAttempt = !1;
    null !== $6909e5993a213e12$var$queuedFocus && $6909e5993a213e12$var$attemptReplayContinuousQueuedEvent($6909e5993a213e12$var$queuedFocus) && ($6909e5993a213e12$var$queuedFocus = null);
    null !== $6909e5993a213e12$var$queuedDrag && $6909e5993a213e12$var$attemptReplayContinuousQueuedEvent($6909e5993a213e12$var$queuedDrag) && ($6909e5993a213e12$var$queuedDrag = null);
    null !== $6909e5993a213e12$var$queuedMouse && $6909e5993a213e12$var$attemptReplayContinuousQueuedEvent($6909e5993a213e12$var$queuedMouse) && ($6909e5993a213e12$var$queuedMouse = null);
    $6909e5993a213e12$var$queuedPointers.forEach($6909e5993a213e12$var$attemptReplayContinuousQueuedEventInMap);
    $6909e5993a213e12$var$queuedPointerCaptures.forEach($6909e5993a213e12$var$attemptReplayContinuousQueuedEventInMap);
}
function $6909e5993a213e12$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $6909e5993a213e12$var$hasScheduledReplayAttempt || ($6909e5993a213e12$var$hasScheduledReplayAttempt = !0, $4Q55w.unstable_scheduleCallback($4Q55w.unstable_NormalPriority, $6909e5993a213e12$var$replayUnblockedEvents)));
}
var $6909e5993a213e12$var$lastScheduledReplayQueue = null;
function $6909e5993a213e12$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $6909e5993a213e12$var$lastScheduledReplayQueue !== formReplayingQueue && ($6909e5993a213e12$var$lastScheduledReplayQueue = formReplayingQueue, $4Q55w.unstable_scheduleCallback($4Q55w.unstable_NormalPriority, function() {
        $6909e5993a213e12$var$lastScheduledReplayQueue === formReplayingQueue && ($6909e5993a213e12$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $6909e5993a213e12$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $6909e5993a213e12$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $6909e5993a213e12$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $6909e5993a213e12$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $6909e5993a213e12$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $6909e5993a213e12$var$queuedFocus && $6909e5993a213e12$var$scheduleCallbackIfUnblocked($6909e5993a213e12$var$queuedFocus, unblocked);
    null !== $6909e5993a213e12$var$queuedDrag && $6909e5993a213e12$var$scheduleCallbackIfUnblocked($6909e5993a213e12$var$queuedDrag, unblocked);
    null !== $6909e5993a213e12$var$queuedMouse && $6909e5993a213e12$var$scheduleCallbackIfUnblocked($6909e5993a213e12$var$queuedMouse, unblocked);
    $6909e5993a213e12$var$queuedPointers.forEach(unblock);
    $6909e5993a213e12$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $6909e5993a213e12$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $6909e5993a213e12$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $6909e5993a213e12$var$queuedExplicitHydrationTargets.length && (i = $6909e5993a213e12$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$6909e5993a213e12$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $6909e5993a213e12$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$6909e5993a213e12$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $6909e5993a213e12$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$6909e5993a213e12$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $6909e5993a213e12$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $6909e5993a213e12$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $6909e5993a213e12$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function handler() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === (typeof navigation === "undefined" ? "undefined" : (0, $03bAP._)(navigation))) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $6909e5993a213e12$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$6909e5993a213e12$var$ReactDOMHydrationRoot.prototype.render = $6909e5993a213e12$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($6909e5993a213e12$var$formatProdErrorMessage(409));
    var current = root.current, lane = $6909e5993a213e12$var$requestUpdateLane();
    $6909e5993a213e12$var$updateContainerImpl(current, lane, children, root, null, null);
};
$6909e5993a213e12$var$ReactDOMHydrationRoot.prototype.unmount = $6909e5993a213e12$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $6909e5993a213e12$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $6909e5993a213e12$var$flushSyncWork$1();
        container[$6909e5993a213e12$var$internalContainerInstanceKey] = null;
    }
};
function $6909e5993a213e12$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$6909e5993a213e12$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $6909e5993a213e12$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $6909e5993a213e12$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $6909e5993a213e12$var$queuedExplicitHydrationTargets[i].priority; i++);
        $6909e5993a213e12$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $6909e5993a213e12$var$attemptExplicitHydrationTarget(target);
    }
};
var $6909e5993a213e12$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $5s1kH.version;
if ("19.2.8" !== $6909e5993a213e12$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($6909e5993a213e12$var$formatProdErrorMessage(527, $6909e5993a213e12$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$6909e5993a213e12$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($6909e5993a213e12$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($6909e5993a213e12$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $6909e5993a213e12$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $6909e5993a213e12$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $6909e5993a213e12$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $6909e5993a213e12$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $6909e5993a213e12$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$6909e5993a213e12$var$hook$jscomp$inline_2348.isDisabled && $6909e5993a213e12$var$hook$jscomp$inline_2348.supportsFiber) try {
        $6909e5993a213e12$var$rendererID = $6909e5993a213e12$var$hook$jscomp$inline_2348.inject($6909e5993a213e12$var$internals$jscomp$inline_2347), $6909e5993a213e12$var$injectedHook = $6909e5993a213e12$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$6909e5993a213e12$export$882461b6382ed46c = function(container, options) {
    if (!$6909e5993a213e12$var$isValidContainer(container)) throw Error($6909e5993a213e12$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $6909e5993a213e12$var$defaultOnUncaughtError, onCaughtError = $6909e5993a213e12$var$defaultOnCaughtError, onRecoverableError = $6909e5993a213e12$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $6909e5993a213e12$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $6909e5993a213e12$var$defaultOnDefaultTransitionIndicator);
    container[$6909e5993a213e12$var$internalContainerInstanceKey] = options.current;
    $6909e5993a213e12$var$listenToAllSupportedEvents(container);
    return new $6909e5993a213e12$var$ReactDOMRoot(options);
};
$6909e5993a213e12$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$6909e5993a213e12$var$isValidContainer(container)) throw Error($6909e5993a213e12$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $6909e5993a213e12$var$defaultOnUncaughtError, onCaughtError = $6909e5993a213e12$var$defaultOnCaughtError, onRecoverableError = $6909e5993a213e12$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $6909e5993a213e12$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $6909e5993a213e12$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $6909e5993a213e12$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $6909e5993a213e12$var$requestUpdateLane();
    isStrictMode = $6909e5993a213e12$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $6909e5993a213e12$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $6909e5993a213e12$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $6909e5993a213e12$var$markRootUpdated$1(initialChildren, options);
    $6909e5993a213e12$var$ensureRootIsScheduled(initialChildren);
    container[$6909e5993a213e12$var$internalContainerInstanceKey] = initialChildren.current;
    $6909e5993a213e12$var$listenToAllSupportedEvents(container);
    return new $6909e5993a213e12$var$ReactDOMHydrationRoot(initialChildren);
};
$6909e5993a213e12$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("4Q55w", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bLitF"));

});
parcelRegister("bLitF", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $89026abf26079381$export$c4744153514ff05d; }, function (v) { return $89026abf26079381$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $89026abf26079381$export$3e506c1ccc9cc1a7; }, function (v) { return $89026abf26079381$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $89026abf26079381$export$e26fe2ed2fa76875; }, function (v) { return $89026abf26079381$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $89026abf26079381$export$502329bbf4b505b1; }, function (v) { return $89026abf26079381$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $89026abf26079381$export$6e3807111c4874c4; }, function (v) { return $89026abf26079381$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $89026abf26079381$export$c27134553091fb3a; }, function (v) { return $89026abf26079381$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $89026abf26079381$export$33ee1acdc04fd2a2; }, function (v) { return $89026abf26079381$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $89026abf26079381$export$b00a404bbd5edef2; }, function (v) { return $89026abf26079381$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $89026abf26079381$export$d66a1c1c77bd778b; }, function (v) { return $89026abf26079381$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $89026abf26079381$export$d3dfb8e4810cb555; }, function (v) { return $89026abf26079381$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $89026abf26079381$export$72fdf0e06517287b; }, function (v) { return $89026abf26079381$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $89026abf26079381$export$816d2913ae6b83b1; }, function (v) { return $89026abf26079381$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $89026abf26079381$export$61bcfe829111a1d0; }, function (v) { return $89026abf26079381$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $89026abf26079381$export$7ee8c9beb337bc3f; }, function (v) { return $89026abf26079381$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $89026abf26079381$export$b5836b71941fa3ed; }, function (v) { return $89026abf26079381$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $89026abf26079381$export$cf845f2c119da08a; }, function (v) { return $89026abf26079381$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $03bAP = parcelRequire("03bAP");
var $89026abf26079381$export$c4744153514ff05d;
var $89026abf26079381$export$3e506c1ccc9cc1a7;
var $89026abf26079381$export$e26fe2ed2fa76875;
var $89026abf26079381$export$502329bbf4b505b1;
var $89026abf26079381$export$6e3807111c4874c4;
var $89026abf26079381$export$c27134553091fb3a;
var $89026abf26079381$export$33ee1acdc04fd2a2;
var $89026abf26079381$export$b00a404bbd5edef2;
var $89026abf26079381$export$d66a1c1c77bd778b;
var $89026abf26079381$export$d3dfb8e4810cb555;
var $89026abf26079381$export$72fdf0e06517287b;
var $89026abf26079381$export$816d2913ae6b83b1;
var $89026abf26079381$export$61bcfe829111a1d0;
var $89026abf26079381$export$7ee8c9beb337bc3f;
var $89026abf26079381$export$b5836b71941fa3ed;
var $89026abf26079381$export$cf845f2c119da08a;
"use strict";
function $89026abf26079381$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $89026abf26079381$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $89026abf26079381$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $89026abf26079381$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $89026abf26079381$var$compare(left, last)) rightIndex < length && 0 > $89026abf26079381$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $89026abf26079381$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $89026abf26079381$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$89026abf26079381$export$c4744153514ff05d = void 0;
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $03bAP._)(performance)) && "function" === typeof performance.now) {
    var $89026abf26079381$var$localPerformance = performance;
    $89026abf26079381$export$c4744153514ff05d = function() {
        return $89026abf26079381$var$localPerformance.now();
    };
} else {
    var $89026abf26079381$var$localDate = Date, $89026abf26079381$var$initialTime = $89026abf26079381$var$localDate.now();
    $89026abf26079381$export$c4744153514ff05d = function() {
        return $89026abf26079381$var$localDate.now() - $89026abf26079381$var$initialTime;
    };
}
var $89026abf26079381$var$taskQueue = [], $89026abf26079381$var$timerQueue = [], $89026abf26079381$var$taskIdCounter = 1, $89026abf26079381$var$currentTask = null, $89026abf26079381$var$currentPriorityLevel = 3, $89026abf26079381$var$isPerformingWork = !1, $89026abf26079381$var$isHostCallbackScheduled = !1, $89026abf26079381$var$isHostTimeoutScheduled = !1, $89026abf26079381$var$needsPaint = !1, $89026abf26079381$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $89026abf26079381$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $89026abf26079381$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $89026abf26079381$var$advanceTimers(currentTime) {
    for(var timer = $89026abf26079381$var$peek($89026abf26079381$var$timerQueue); null !== timer;){
        if (null === timer.callback) $89026abf26079381$var$pop($89026abf26079381$var$timerQueue);
        else if (timer.startTime <= currentTime) $89026abf26079381$var$pop($89026abf26079381$var$timerQueue), timer.sortIndex = timer.expirationTime, $89026abf26079381$var$push($89026abf26079381$var$taskQueue, timer);
        else break;
        timer = $89026abf26079381$var$peek($89026abf26079381$var$timerQueue);
    }
}
function $89026abf26079381$var$handleTimeout(currentTime) {
    $89026abf26079381$var$isHostTimeoutScheduled = !1;
    $89026abf26079381$var$advanceTimers(currentTime);
    if (!$89026abf26079381$var$isHostCallbackScheduled) {
        if (null !== $89026abf26079381$var$peek($89026abf26079381$var$taskQueue)) $89026abf26079381$var$isHostCallbackScheduled = !0, $89026abf26079381$var$isMessageLoopRunning || ($89026abf26079381$var$isMessageLoopRunning = !0, $89026abf26079381$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $89026abf26079381$var$peek($89026abf26079381$var$timerQueue);
            null !== firstTimer && $89026abf26079381$var$requestHostTimeout($89026abf26079381$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $89026abf26079381$var$isMessageLoopRunning = !1, $89026abf26079381$var$taskTimeoutID = -1, $89026abf26079381$var$frameInterval = 5, $89026abf26079381$var$startTime = -1;
function $89026abf26079381$var$shouldYieldToHost() {
    return $89026abf26079381$var$needsPaint ? !0 : $89026abf26079381$export$c4744153514ff05d() - $89026abf26079381$var$startTime < $89026abf26079381$var$frameInterval ? !1 : !0;
}
function $89026abf26079381$var$performWorkUntilDeadline() {
    $89026abf26079381$var$needsPaint = !1;
    if ($89026abf26079381$var$isMessageLoopRunning) {
        var currentTime = $89026abf26079381$export$c4744153514ff05d();
        $89026abf26079381$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $89026abf26079381$var$isHostCallbackScheduled = !1;
                $89026abf26079381$var$isHostTimeoutScheduled && ($89026abf26079381$var$isHostTimeoutScheduled = !1, $89026abf26079381$var$localClearTimeout($89026abf26079381$var$taskTimeoutID), $89026abf26079381$var$taskTimeoutID = -1);
                $89026abf26079381$var$isPerformingWork = !0;
                var previousPriorityLevel = $89026abf26079381$var$currentPriorityLevel;
                try {
                    b: {
                        $89026abf26079381$var$advanceTimers(currentTime);
                        for($89026abf26079381$var$currentTask = $89026abf26079381$var$peek($89026abf26079381$var$taskQueue); null !== $89026abf26079381$var$currentTask && !($89026abf26079381$var$currentTask.expirationTime > currentTime && $89026abf26079381$var$shouldYieldToHost());){
                            var callback = $89026abf26079381$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $89026abf26079381$var$currentTask.callback = null;
                                $89026abf26079381$var$currentPriorityLevel = $89026abf26079381$var$currentTask.priorityLevel;
                                var continuationCallback = callback($89026abf26079381$var$currentTask.expirationTime <= currentTime);
                                currentTime = $89026abf26079381$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $89026abf26079381$var$currentTask.callback = continuationCallback;
                                    $89026abf26079381$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $89026abf26079381$var$currentTask === $89026abf26079381$var$peek($89026abf26079381$var$taskQueue) && $89026abf26079381$var$pop($89026abf26079381$var$taskQueue);
                                $89026abf26079381$var$advanceTimers(currentTime);
                            } else $89026abf26079381$var$pop($89026abf26079381$var$taskQueue);
                            $89026abf26079381$var$currentTask = $89026abf26079381$var$peek($89026abf26079381$var$taskQueue);
                        }
                        if (null !== $89026abf26079381$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $89026abf26079381$var$peek($89026abf26079381$var$timerQueue);
                            null !== firstTimer && $89026abf26079381$var$requestHostTimeout($89026abf26079381$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $89026abf26079381$var$currentTask = null, $89026abf26079381$var$currentPriorityLevel = previousPriorityLevel, $89026abf26079381$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $89026abf26079381$var$schedulePerformWorkUntilDeadline() : $89026abf26079381$var$isMessageLoopRunning = !1;
        }
    }
}
var $89026abf26079381$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $89026abf26079381$var$localSetImmediate) $89026abf26079381$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $89026abf26079381$var$localSetImmediate($89026abf26079381$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $89026abf26079381$var$channel = new MessageChannel(), $89026abf26079381$var$port = $89026abf26079381$var$channel.port2;
    $89026abf26079381$var$channel.port1.onmessage = $89026abf26079381$var$performWorkUntilDeadline;
    $89026abf26079381$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
        $89026abf26079381$var$port.postMessage(null);
    };
} else $89026abf26079381$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $89026abf26079381$var$localSetTimeout($89026abf26079381$var$performWorkUntilDeadline, 0);
};
function $89026abf26079381$var$requestHostTimeout(callback, ms) {
    $89026abf26079381$var$taskTimeoutID = $89026abf26079381$var$localSetTimeout(function() {
        callback($89026abf26079381$export$c4744153514ff05d());
    }, ms);
}
$89026abf26079381$export$3e506c1ccc9cc1a7 = 5;
$89026abf26079381$export$e26fe2ed2fa76875 = 1;
$89026abf26079381$export$502329bbf4b505b1 = 4;
$89026abf26079381$export$6e3807111c4874c4 = 3;
$89026abf26079381$export$c27134553091fb3a = null;
$89026abf26079381$export$33ee1acdc04fd2a2 = 2;
$89026abf26079381$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$89026abf26079381$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $89026abf26079381$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$89026abf26079381$export$d3dfb8e4810cb555 = function() {
    return $89026abf26079381$var$currentPriorityLevel;
};
$89026abf26079381$export$72fdf0e06517287b = function(eventHandler) {
    switch($89026abf26079381$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $89026abf26079381$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $89026abf26079381$var$currentPriorityLevel;
    $89026abf26079381$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $89026abf26079381$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$89026abf26079381$export$816d2913ae6b83b1 = function() {
    $89026abf26079381$var$needsPaint = !0;
};
$89026abf26079381$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $89026abf26079381$var$currentPriorityLevel;
    $89026abf26079381$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $89026abf26079381$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$89026abf26079381$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $89026abf26079381$export$c4744153514ff05d();
    "object" === (typeof options === "undefined" ? "undefined" : (0, $03bAP._)(options)) && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $89026abf26079381$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $89026abf26079381$var$push($89026abf26079381$var$timerQueue, priorityLevel), null === $89026abf26079381$var$peek($89026abf26079381$var$taskQueue) && priorityLevel === $89026abf26079381$var$peek($89026abf26079381$var$timerQueue) && ($89026abf26079381$var$isHostTimeoutScheduled ? ($89026abf26079381$var$localClearTimeout($89026abf26079381$var$taskTimeoutID), $89026abf26079381$var$taskTimeoutID = -1) : $89026abf26079381$var$isHostTimeoutScheduled = !0, $89026abf26079381$var$requestHostTimeout($89026abf26079381$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $89026abf26079381$var$push($89026abf26079381$var$taskQueue, priorityLevel), $89026abf26079381$var$isHostCallbackScheduled || $89026abf26079381$var$isPerformingWork || ($89026abf26079381$var$isHostCallbackScheduled = !0, $89026abf26079381$var$isMessageLoopRunning || ($89026abf26079381$var$isMessageLoopRunning = !0, $89026abf26079381$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$89026abf26079381$export$b5836b71941fa3ed = $89026abf26079381$var$shouldYieldToHost;
$89026abf26079381$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $89026abf26079381$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $89026abf26079381$var$currentPriorityLevel;
        $89026abf26079381$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $89026abf26079381$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("eAxYl", function(module, exports) {
'use strict';
function $a9eec7afa4c8d3f1$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a9eec7afa4c8d3f1$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a9eec7afa4c8d3f1$var$checkDCE();

module.exports = (parcelRequire("cgnPI"));

});
parcelRegister("cgnPI", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $8ed977674c28a491$export$69ce8ef3fe5cead0; }, function (v) { return $8ed977674c28a491$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $8ed977674c28a491$export$d39a5bbd09211389; }, function (v) { return $8ed977674c28a491$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $8ed977674c28a491$export$cd75ccfd720a3cd4; }, function (v) { return $8ed977674c28a491$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $8ed977674c28a491$export$a0816fa17a9e79be; }, function (v) { return $8ed977674c28a491$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $8ed977674c28a491$export$7292efcadded39f3; }, function (v) { return $8ed977674c28a491$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $8ed977674c28a491$export$da407abadb9b8f86; }, function (v) { return $8ed977674c28a491$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $8ed977674c28a491$export$314cfea32580671c; }, function (v) { return $8ed977674c28a491$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $8ed977674c28a491$export$513ccb98c53b8039; }, function (v) { return $8ed977674c28a491$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $8ed977674c28a491$export$dbca993bc2d264a; }, function (v) { return $8ed977674c28a491$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $8ed977674c28a491$export$4797a8006f0655d0; }, function (v) { return $8ed977674c28a491$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $8ed977674c28a491$export$c78a37762a8d58e1; }, function (v) { return $8ed977674c28a491$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $8ed977674c28a491$export$606f11b2eb45ecc6; }, function (v) { return $8ed977674c28a491$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $8ed977674c28a491$export$f7e8a0bf92324b1e; }, function (v) { return $8ed977674c28a491$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $8ed977674c28a491$export$83d89fbfd8236492; }, function (v) { return $8ed977674c28a491$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $03bAP = parcelRequire("03bAP");
var $8ed977674c28a491$export$69ce8ef3fe5cead0;
var $8ed977674c28a491$export$d39a5bbd09211389;
var $8ed977674c28a491$export$cd75ccfd720a3cd4;
var $8ed977674c28a491$export$a0816fa17a9e79be;
var $8ed977674c28a491$export$7292efcadded39f3;
var $8ed977674c28a491$export$da407abadb9b8f86;
var $8ed977674c28a491$export$314cfea32580671c;
var $8ed977674c28a491$export$513ccb98c53b8039;
var $8ed977674c28a491$export$dbca993bc2d264a;
var $8ed977674c28a491$export$4797a8006f0655d0;
var $8ed977674c28a491$export$c78a37762a8d58e1;
var $8ed977674c28a491$export$606f11b2eb45ecc6;
var $8ed977674c28a491$export$f7e8a0bf92324b1e;
var $8ed977674c28a491$export$83d89fbfd8236492;
"use strict";

var $5s1kH = parcelRequire("5s1kH");
function $8ed977674c28a491$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $8ed977674c28a491$var$noop() {}
var $8ed977674c28a491$var$Internals = {
    d: {
        f: $8ed977674c28a491$var$noop,
        r: function r() {
            throw Error($8ed977674c28a491$var$formatProdErrorMessage(522));
        },
        D: $8ed977674c28a491$var$noop,
        C: $8ed977674c28a491$var$noop,
        L: $8ed977674c28a491$var$noop,
        m: $8ed977674c28a491$var$noop,
        X: $8ed977674c28a491$var$noop,
        S: $8ed977674c28a491$var$noop,
        M: $8ed977674c28a491$var$noop
    },
    p: 0,
    findDOMNode: null
}, $8ed977674c28a491$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $8ed977674c28a491$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $8ed977674c28a491$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $8ed977674c28a491$var$ReactSharedInternals = $5s1kH.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $8ed977674c28a491$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$8ed977674c28a491$export$69ce8ef3fe5cead0 = $8ed977674c28a491$var$Internals;
$8ed977674c28a491$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($8ed977674c28a491$var$formatProdErrorMessage(299));
    return $8ed977674c28a491$var$createPortal$1(children, container, null, key);
};
$8ed977674c28a491$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $8ed977674c28a491$var$ReactSharedInternals.T, previousUpdatePriority = $8ed977674c28a491$var$Internals.p;
    try {
        if ($8ed977674c28a491$var$ReactSharedInternals.T = null, $8ed977674c28a491$var$Internals.p = 2, fn) return fn();
    } finally{
        $8ed977674c28a491$var$ReactSharedInternals.T = previousTransition, $8ed977674c28a491$var$Internals.p = previousUpdatePriority, $8ed977674c28a491$var$Internals.d.f();
    }
};
$8ed977674c28a491$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $8ed977674c28a491$var$Internals.d.C(href, options));
};
$8ed977674c28a491$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $8ed977674c28a491$var$Internals.d.D(href);
};
$8ed977674c28a491$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $8ed977674c28a491$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $8ed977674c28a491$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $8ed977674c28a491$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$8ed977674c28a491$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === (typeof options === "undefined" ? "undefined" : (0, $03bAP._)(options)) && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $8ed977674c28a491$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $8ed977674c28a491$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $8ed977674c28a491$var$Internals.d.M(href);
    }
};
$8ed977674c28a491$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === (typeof options === "undefined" ? "undefined" : (0, $03bAP._)(options)) && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $8ed977674c28a491$var$getCrossOriginStringAs(as, options.crossOrigin);
        $8ed977674c28a491$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$8ed977674c28a491$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $8ed977674c28a491$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $8ed977674c28a491$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $8ed977674c28a491$var$Internals.d.m(href);
    }
};
$8ed977674c28a491$export$4797a8006f0655d0 = function(form) {
    $8ed977674c28a491$var$Internals.d.r(form);
};
$8ed977674c28a491$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$8ed977674c28a491$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $8ed977674c28a491$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$8ed977674c28a491$export$f7e8a0bf92324b1e = function() {
    return $8ed977674c28a491$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$8ed977674c28a491$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("bHX26", function(module, exports) {

$parcel$export(module.exports, "matchPath", function () { return matchPath; });
$parcel$export(module.exports, "generatePath", function () { return generatePath; });
$parcel$export(module.exports, "useLocation", function () { return useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return useNavigate; });
$parcel$export(module.exports, "useParams", function () { return useParams; });
$parcel$export(module.exports, "useBlocker", function () { return useBlocker; });
$parcel$export(module.exports, "RouterProvider", function () { return RouterProvider; });
$parcel$export(module.exports, "Outlet", function () { return Outlet; });
$parcel$export(module.exports, "createBrowserRouter", function () { return createBrowserRouter; });
$parcel$export(module.exports, "Link", function () { return Link; });
$parcel$export(module.exports, "useSearchParams", function () { return useSearchParams; });
/**
 * react-router v7.18.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lFIaz = parcelRequire("lFIaz");

var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $54Czb = parcelRequire("54Czb");

var $6iP9u = parcelRequire("6iP9u");

var $1SnSh = parcelRequire("1SnSh");

var $XnYkK = parcelRequire("XnYkK");

var $03bAP = parcelRequire("03bAP");

var $kW1tL = parcelRequire("kW1tL");

var $3SMYb = parcelRequire("3SMYb");

var $4WD8g = parcelRequire("4WD8g");

var $5s1kH = parcelRequire("5s1kH");
var $9a2fb184cf43fa82$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-62JRHF6Z.mjs"
});
var __typeError = function(msg) {
    throw TypeError(msg);
};
var __accessCheck = function(obj, member, msg) {
    return member.has(obj) || __typeError("Cannot " + msg);
};
var __privateGet = function(obj, member, getter) {
    return __accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = function(obj, member, value) {
    return member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = function(obj, member, value, setter) {
    return __accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value;
};
// lib/router/url.ts
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var PROTOCOL_RELATIVE_URL_REGEX = /^[\\/]{2}/;
function normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var Action = /* @__PURE__ */ function(Action2) {
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
}(Action || {});
var PopStateEventType = "popstate";
function isLocation(obj) {
    return (typeof obj === "undefined" ? "undefined" : (0, $03bAP._)(obj)) === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function createMemoryHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries;
    entries = initialEntries.map(function(entry, index2) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = "POP" /* Pop */ ;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to) {
        var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, key = arguments.length > 2 ? arguments[2] : void 0, mask = arguments.length > 3 ? arguments[3] : void 0;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: ".concat(JSON.stringify(to)));
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL: function(to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = "PUSH" /* Push */ ;
            var nextLocation = isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = "REPLACE" /* Replace */ ;
            var nextLocation = isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = "POP" /* Pop */ ;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
function createBrowserHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    function createBrowserLocation(window2, globalHistory) {
        var _globalHistory_state;
        var maskedLocation = (_globalHistory_state = globalHistory.state) === null || _globalHistory_state === void 0 ? void 0 : _globalHistory_state.masked;
        var _ref = maskedLocation || window2.location, pathname = _ref.pathname, search = _ref.search, hash = _ref.hash;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function createHashHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    function createHashLocation(window2, globalHistory) {
        var _parsePath = parsePath(window2.location.hash.substring(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        var base = window2.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window2.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(".concat(JSON.stringify(to), ")"));
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function createLocation(current, to) {
    var state = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, key = arguments.length > 3 ? arguments[3] : void 0, mask = arguments.length > 4 ? arguments[4] : void 0;
    var location = (0, $lf4fc._)((0, $hwO3w._)({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to), {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey(),
        mask: mask
    });
    return location;
}
function createPath(param) {
    var _param_pathname = param.pathname, pathname = _param_pathname === void 0 ? "/" : _param_pathname, _param_search = param.search, search = _param_search === void 0 ? "" : _param_search, _param_hash = param.hash, hash = _param_hash === void 0 ? "" : _param_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref2, validateLocation) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var tmp = options.window, window2 = tmp === void 0 ? document.defaultView : tmp, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window2.history;
    var action = "POP" /* Pop */ ;
    var listener = null;
    var index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $lf4fc._)((0, $hwO3w._)({}, globalHistory.state), {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        var location = isLocation(to) ? to : createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        var location = isLocation(to) ? to : createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return createBrowserURLImpl(window2, to);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window2.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function createBrowserURLImpl(windowImpl, to) {
    var isAbsolute = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    invariant(base, "No window.location.(origin|href) available to create URL");
    var href = typeof to === "string" ? to : createPath(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && PROTOCOL_RELATIVE_URL_REGEX.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function createContext(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var _map;
var RouterContextProvider = /*#__PURE__*/ function() {
    "use strict";
    function RouterContextProvider(init) {
        (0, $5Epmf._)(this, RouterContextProvider);
        __privateAdd(this, _map, /* @__PURE__ */ new Map());
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (init) try {
            for(var _iterator = init[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $6iP9u._)(_step.value, 2), context = _step_value[0], value = _step_value[1];
                this.set(context, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    (0, $9MqXK._)(RouterContextProvider, [
        {
            /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ key: "get",
            value: function get(context) {
                if (__privateGet(this, _map).has(context)) return __privateGet(this, _map).get(context);
                if (context.defaultValue !== void 0) return context.defaultValue;
                throw new Error("No value found for context");
            }
        },
        {
            /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ key: "set",
            value: function set(context, value) {
                __privateGet(this, _map).set(context, value);
            }
        }
    ]);
    return RouterContextProvider;
}();
_map = new WeakMap();
var unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isUnsupportedLazyRouteObjectKey(key) {
    return unsupportedLazyRouteObjectKeys.has(key);
}
var unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function isUnsupportedLazyRouteFunctionKey(key) {
    return unsupportedLazyRouteFunctionKeys.has(key);
}
function isIndexRoute(route) {
    return route.index === true;
}
function convertRoutesToDataRoutes(routes, mapRouteProperties2) {
    var parentPath = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], manifest = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, allowInPlaceMutations = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return routes.map(function(route, index) {
        var treePath = (0, $XnYkK._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(allowInPlaceMutations || !manifest[id], 'Found a route id collision on id "'.concat(id, "\".  Route id's must be globally unique within Data Router usages"));
        if (isIndexRoute(route)) {
            var indexRoute = (0, $lf4fc._)((0, $hwO3w._)({}, route), {
                id: id
            });
            manifest[id] = mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            var pathOrLayoutRoute = (0, $lf4fc._)((0, $hwO3w._)({}, route), {
                id: id,
                children: void 0
            });
            manifest[id] = mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function mergeRouteUpdates(route, updates) {
    return Object.assign(route, (0, $hwO3w._)({}, updates, (0, $03bAP._)(updates.lazy) === "object" && updates.lazy != null ? {
        lazy: (0, $hwO3w._)({}, route.lazy, updates.lazy)
    } : {}));
}
function matchRoutes(routes, locationArg) {
    var basename = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial, precomputedBranches) {
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = precomputedBranches !== null && precomputedBranches !== void 0 ? precomputedBranches : flattenAndRankRoutes(routes);
    var matches = null;
    var decoded = decodePath(pathname);
    for(var i = 0; matches == null && i < branches.length; ++i)matches = matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function flattenAndRankRoutes(routes) {
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    return branches;
}
function flattenRoutes(routes) {
    var branches = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], parentsMeta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], parentPath = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", _hasParentOptionalSegments = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var flattenRoute = function(route, index) {
        var hasParentOptionalSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _hasParentOptionalSegments, relativePath = arguments.length > 3 ? arguments[3] : void 0;
        var meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "'.concat(meta.relativePath, '" nested under path "').concat(parentPath, '" is not valid. An absolute child route path must start with the combined path of all its parent routes.'));
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, 'Index routes must not have child routes. Please remove all child routes from route path "'.concat(path, '".'));
            flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta.map(function(meta2, i) {
                var _compilePath = (0, $6iP9u._)(compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1), 2), matcher = _compilePath[0], params = _compilePath[1];
                return (0, $lf4fc._)((0, $hwO3w._)({}, meta2), {
                    matcher: matcher,
                    compiledParams: params
                });
            })
        });
    };
    routes.forEach(function(route, index) {
        var _route_path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (route.path === "" || !((_route_path = route.path) === null || _route_path === void 0 ? void 0 : _route_path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, true, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
function explodeOptionalSegments(path) {
    var _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $1SnSh._)(segments), first = _segments[0], rest = _segments.slice(1);
    var isOptional = first.endsWith("?");
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $XnYkK._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $XnYkK._)(restExploded));
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname) {
    var allowPartial = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        var match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : matchPath(pattern, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function generatePath(originalPath) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "'.concat(path, '" will be treated as if it were "').concat(path.replace(/\*$/, "/*"), '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "').concat(path.replace(/\*$/, "/*"), '".'));
        path = path.replace(/\*$/, "/*");
    }
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify2 = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        var keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            var _keyMatch = (0, $6iP9u._)(keyMatch, 4), key = _keyMatch[1], optional = _keyMatch[2], suffix = _keyMatch[3];
            var param = params[key];
            invariant(optional === "?" || param != null, 'Missing ":'.concat(key, '" param'));
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $6iP9u._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    return matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function matchPathImpl(pattern, pathname, matcher, compiledParams) {
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo2, param, index) {
        var paramName = param.paramName, isOptional = param.isOptional;
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path) {
    var caseSensitive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "'.concat(path, '" will be treated as if it were "').concat(path.replace(/\*$/, "/*"), '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "').concat(path.replace(/\*$/, "/*"), '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, function(match, paramName, isOptional, index, str) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            var nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        warning(false, 'The URL path "'.concat(value, '" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (').concat(error, ")."));
        return value;
    }
}
function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function prependBasename(param) {
    var basename = param.basename, pathname = param.pathname;
    return pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
}
var isAbsoluteUrl = function(url) {
    return ABSOLUTE_URL_REGEX.test(url);
};
function resolvePath(to) {
    var fromPathname = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname;
    if (toPathname) {
        toPathname = removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = resolvePathname(toPathname.substring(1), "/");
        else pathname = resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = removeTrailingSlash(fromPathname).split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '".concat(char, "' character in a manually specified `to.").concat(field, "` field [").concat(JSON.stringify(path), "].  Please separate it out to the `to.").concat(dest, '` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.');
}
function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
function getResolveToMatches(matches) {
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
}
function resolveTo(toArg, routePathnames, locationPathname) {
    var isPathRelative = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = (0, $hwO3w._)({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var removeDoubleSlashes = function(path) {
    return path.replace(/[\\/]{2,}/g, "/");
};
var joinPaths = function(paths) {
    return removeDoubleSlashes(paths.join("/"));
};
var removeTrailingSlash = function(path) {
    return path.replace(/\/+$/, "");
};
var normalizePathname = function(pathname) {
    return removeTrailingSlash(pathname).replace(/^\/*/, "/");
};
var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
var DataWithResponseInit = function DataWithResponseInit(data2, init) {
    "use strict";
    (0, $5Epmf._)(this, DataWithResponseInit);
    this.type = "DataWithResponseInit";
    this.data = data2;
    this.init = init || null;
};
function data(data2, init) {
    return new DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var redirect = function(url) {
    var init = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, (0, $lf4fc._)((0, $hwO3w._)({}, responseInit), {
        headers: headers
    }));
};
var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data2) {
    "use strict";
    var internal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    (0, $5Epmf._)(this, ErrorResponseImpl);
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data2 instanceof Error) {
        this.data = data2.toString();
        this.error = data2;
    } else this.data = data2;
};
function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function getRoutePattern(matches) {
    var parts = matches.map(function(m) {
        return m.route.path;
    }).filter(Boolean);
    return joinPaths(parts) || "/";
}
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function parseToInfo(_to, basename) {
    var to = _to;
    if (typeof to !== "string" || !ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    var absoluteURL = to;
    var isExternal = false;
    if (isBrowser) try {
        var currentUrl = new URL(window.location.href);
        var targetUrl = PROTOCOL_RELATIVE_URL_REGEX.test(to) ? new URL(normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        var path = stripBasename(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        warning(false, '<Link to="'.concat(to, '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.'));
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var UninstrumentedSymbol = Symbol("Uninstrumented");
function getRouteInstrumentationUpdates(fns, route) {
    var aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach(function(fn) {
        return fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument: function(i) {
                var keys = Object.keys(aggregated);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (i[key]) aggregated[key].push(i[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        });
    });
    var updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        var instrumented = wrapImpl(aggregated.lazy, route.lazy, function() {
            return void 0;
        });
        if (instrumented) updates.lazy = instrumented;
    }
    if ((0, $03bAP._)(route.lazy) === "object") {
        var lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach(function(key) {
            var lazyFn = lazyObject[key];
            var instrumentations = aggregated["lazy.".concat(key)];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                var instrumented = wrapImpl(instrumentations, lazyFn, function() {
                    return void 0;
                });
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, (0, $dUlz9._)({}, key, instrumented));
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach(function(key) {
        var handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            var _handler_UninstrumentedSymbol;
            var original = (_handler_UninstrumentedSymbol = handler[UninstrumentedSymbol]) !== null && _handler_UninstrumentedSymbol !== void 0 ? _handler_UninstrumentedSymbol : handler;
            var instrumented = wrapImpl(aggregated[key], original, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return getHandlerInfo(args[0]);
            });
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map(function(middleware) {
        var _middleware_UninstrumentedSymbol;
        var original = (_middleware_UninstrumentedSymbol = middleware[UninstrumentedSymbol]) !== null && _middleware_UninstrumentedSymbol !== void 0 ? _middleware_UninstrumentedSymbol : middleware;
        var instrumented = wrapImpl(aggregated.middleware, original, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return getHandlerInfo(args[0]);
        });
        if (instrumented) {
            instrumented[UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function instrumentClientSideRouter(router, fns) {
    var aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach(function(fn) {
        return fn({
            instrument: function(i) {
                var keys = Object.keys(i);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (i[key]) aggregated[key].push(i[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        });
    });
    if (aggregated.navigate.length > 0) {
        var _router_navigate_UninstrumentedSymbol;
        var navigate = (_router_navigate_UninstrumentedSymbol = router.navigate[UninstrumentedSymbol]) !== null && _router_navigate_UninstrumentedSymbol !== void 0 ? _router_navigate_UninstrumentedSymbol : router.navigate;
        var instrumentedNavigate = wrapImpl(aggregated.navigate, navigate, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _args = (0, $6iP9u._)(args, 2), to = _args[0], opts = _args[1];
            return (0, $hwO3w._)({
                to: typeof to === "number" || typeof to === "string" ? to : to ? createPath(to) : "."
            }, getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {}));
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        var _router_fetch_UninstrumentedSymbol;
        var fetch2 = (_router_fetch_UninstrumentedSymbol = router.fetch[UninstrumentedSymbol]) !== null && _router_fetch_UninstrumentedSymbol !== void 0 ? _router_fetch_UninstrumentedSymbol : router.fetch;
        var instrumentedFetch = wrapImpl(aggregated.fetch, fetch2, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _args = (0, $6iP9u._)(args, 4), key = _args[0], href = _args[2], opts = _args[3];
            return (0, $hwO3w._)({
                href: href !== null && href !== void 0 ? href : ".",
                fetcherKey: key
            }, getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {}));
        });
        if (instrumentedFetch) {
            instrumentedFetch[UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function instrumentHandler(handler, fns) {
    var aggregated = {
        request: []
    };
    fns.forEach(function(fn) {
        return fn({
            instrument: function(i) {
                var keys = Object.keys(i);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (i[key]) aggregated[key].push(i[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        });
    });
    var instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = wrapImpl(aggregated.request, handler, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _args = (0, $6iP9u._)(args, 2), request = _args[0], context = _args[1];
        return {
            request: getReadonlyRequest(request),
            context: context != null ? getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var result;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            recurseRight(impls, getInfo.apply(void 0, (0, $XnYkK._)(args)), function() {
                                return handler.apply(void 0, (0, $XnYkK._)(args));
                            }, impls.length - 1)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.type === "error") throw result.value;
                        return [
                            2,
                            result.value
                        ];
                }
            });
        })();
    };
}
function recurseRight(impls, info, handler, index) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var impl, result, value, e, handlerPromise, callHandler, e1;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    impl = impls[index];
                    if (!!impl) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        handler()
                    ];
                case 2:
                    value = _state.sent();
                    result = {
                        type: "success",
                        value: value
                    };
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    result = {
                        type: "error",
                        value: e
                    };
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        3,
                        13
                    ];
                case 5:
                    handlerPromise = void 0;
                    callHandler = function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                            return (0, $3SMYb._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
                                        else handlerPromise = recurseRight(impls, info, handler, index - 1);
                                        return [
                                            4,
                                            handlerPromise
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        invariant(result, "Expected a result");
                                        if (result.type === "error" && result.value instanceof Error) return [
                                            2,
                                            {
                                                status: "error",
                                                error: result.value
                                            }
                                        ];
                                        return [
                                            2,
                                            {
                                                status: "success",
                                                error: void 0
                                            }
                                        ];
                                }
                            });
                        })();
                    };
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        impl(callHandler, info)
                    ];
                case 7:
                    _state.sent();
                    return [
                        3,
                        9
                    ];
                case 8:
                    e1 = _state.sent();
                    console.error("An instrumentation function threw an error:", e1);
                    return [
                        3,
                        9
                    ];
                case 9:
                    if (!!handlerPromise) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        callHandler()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        4,
                        handlerPromise
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    if (result) return [
                        2,
                        result
                    ];
                    return [
                        2,
                        {
                            type: "error",
                            value: new Error("No result assigned in instrumentation chain.")
                        }
                    ];
            }
        });
    })();
}
function getHandlerInfo(args) {
    var request = args.request, context = args.context, params = args.params, pattern = args.pattern;
    return {
        request: getReadonlyRequest(request),
        params: (0, $hwO3w._)({}, params),
        pattern: pattern,
        context: getReadonlyContext(context)
    };
}
function getRouterInfo(router, opts) {
    return (0, $hwO3w._)({
        currentUrl: createPath(router.state.location)
    }, "formMethod" in opts ? {
        formMethod: opts.formMethod
    } : {}, "formEncType" in opts ? {
        formEncType: opts.formEncType
    } : {}, "formData" in opts ? {
        formData: opts.formData
    } : {}, "body" in opts ? {
        body: opts.body
    } : {});
}
function getReadonlyRequest(request) {
    var _request_headers;
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_request_headers = request.headers).get.apply(_request_headers, (0, $XnYkK._)(args));
            }
        }
    };
}
function getReadonlyContext(context) {
    if (isPlainObject(context)) {
        var frozen = (0, $hwO3w._)({}, context);
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: function(ctx) {
            return context.get(ctx);
        }
    };
}
var objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function isPlainObject(thing) {
    if (thing === null || (typeof thing === "undefined" ? "undefined" : (0, $03bAP._)(thing)) !== "object") return false;
    var proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === objectProtoNames;
}
// lib/router/router.ts
var validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "GET"
].concat((0, $XnYkK._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_FETCHER = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var _routes, _branches, _hmrRoutes, _hmrBranches;
var DataRoutes = /*#__PURE__*/ function() {
    "use strict";
    function DataRoutes(routes) {
        (0, $5Epmf._)(this, DataRoutes);
        __privateAdd(this, _routes);
        __privateAdd(this, _branches);
        __privateAdd(this, _hmrRoutes);
        __privateAdd(this, _hmrBranches);
        __privateSet(this, _routes, routes);
        __privateSet(this, _branches, flattenAndRankRoutes(routes));
    }
    (0, $9MqXK._)(DataRoutes, [
        {
            key: "stableRoutes",
            get: /** The stable route tree */ function get() {
                return __privateGet(this, _routes);
            }
        },
        {
            key: "activeRoutes",
            get: /** The in-flight route tree if one is active, otherwise the stable tree */ function get() {
                var __privateGet1;
                return (__privateGet1 = __privateGet(this, _hmrRoutes)) !== null && __privateGet1 !== void 0 ? __privateGet1 : __privateGet(this, _routes);
            }
        },
        {
            key: "branches",
            get: /** Pre-computed branches */ function get() {
                var __privateGet1;
                return (__privateGet1 = __privateGet(this, _hmrBranches)) !== null && __privateGet1 !== void 0 ? __privateGet1 : __privateGet(this, _branches);
            }
        },
        {
            key: "hasHMRRoutes",
            get: function get() {
                return __privateGet(this, _hmrRoutes) != null;
            }
        },
        {
            /** Replace the stable route tree and recompute its branches */ key: "setRoutes",
            value: function setRoutes(routes) {
                __privateSet(this, _routes, routes);
                __privateSet(this, _branches, flattenAndRankRoutes(routes));
            }
        },
        {
            /** Set a new in-flight route tree and recompute its branches */ key: "setHmrRoutes",
            value: function setHmrRoutes(routes) {
                __privateSet(this, _hmrRoutes, routes);
                __privateSet(this, _hmrBranches, flattenAndRankRoutes(routes));
            }
        },
        {
            /** Commit in-flight routes/branches to the stable slot and clear in-flight */ key: "commitHmrRoutes",
            value: function commitHmrRoutes() {
                if (__privateGet(this, _hmrRoutes)) {
                    __privateSet(this, _routes, __privateGet(this, _hmrRoutes));
                    __privateSet(this, _branches, __privateGet(this, _hmrBranches));
                    __privateSet(this, _hmrRoutes, void 0);
                    __privateSet(this, _hmrBranches, void 0);
                }
            }
        }
    ]);
    return DataRoutes;
}();
_routes = new WeakMap();
_branches = new WeakMap();
_hmrRoutes = new WeakMap();
_hmrBranches = new WeakMap();
function createRouter(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    var isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    var _mapRouteProperties = init.mapRouteProperties || defaultMapRouteProperties;
    var mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        var instrumentations = init.instrumentations;
        mapRouteProperties2 = function(route) {
            return (0, $hwO3w._)({}, _mapRouteProperties(route), getRouteInstrumentationUpdates(instrumentations.map(function(i) {
                return i.route;
            }).filter(Boolean), route));
        };
    }
    var manifest = {};
    var dataRoutes = new DataRoutes(convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest));
    var basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = "/".concat(basename);
    var dataStrategyImpl = init.dataStrategy || defaultDataStrategyWithMiddleware;
    var future = (0, $hwO3w._)({}, init.future);
    var unlistenHistory = null;
    var subscribers = /* @__PURE__ */ new Set();
    var bufferedInitialStateUpdate = null;
    var savedScrollPositions2 = null;
    var getScrollRestorationKey2 = null;
    var getScrollPosition = null;
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutesImpl(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    var initialMatchesIsFOW = false;
    var initialErrors = null;
    var initialized;
    var renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes.activeRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = (0, $dUlz9._)({}, route.id, error);
    } else {
        if (initialMatches && !init.hydrationData) {
            var fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            var fogOfWar1 = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar1.active && fogOfWar1.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar1.matches;
            }
        } else if (initialMatches.some(function(m) {
            return m.route.lazy;
        })) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some(function(m) {
            return routeHasLoaderOrMiddleware(m.route);
        })) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            var errors = init.hydrationData ? init.hydrationData.errors : null;
            var relevantMatches = initialMatches;
            if (errors) {
                var idx = initialMatches.findIndex(function(m) {
                    return errors[m.route.id] !== void 0;
                });
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach(function(m) {
                var status = getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    var pendingAction = "POP" /* Pop */ ;
    var pendingPopstateNavigationDfd = null;
    var pendingPreventScrollReset = false;
    var pendingNavigationController;
    var pendingViewTransitionEnabled = false;
    var appliedViewTransitions = /* @__PURE__ */ new Map();
    var removePageHideEventListener = null;
    var isUninterruptedRevalidation = false;
    var isRevalidationRequired = false;
    var cancelledFetcherLoads = /* @__PURE__ */ new Set();
    var fetchControllers = /* @__PURE__ */ new Map();
    var incrementingLoadId = 0;
    var pendingNavigationLoadId = -1;
    var fetchReloadIds = /* @__PURE__ */ new Map();
    var fetchRedirectIds = /* @__PURE__ */ new Set();
    var fetchLoadMatches = /* @__PURE__ */ new Map();
    var activeFetchers = /* @__PURE__ */ new Map();
    var fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    var blockerFunctions = /* @__PURE__ */ new Map();
    var unblockBlockerHistoryUpdate = void 0;
    var pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(function(param) {
            var historyAction = param.action, location = param.location, delta = param.delta;
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                var nextHistoryUpdatePromise = new Promise(function(resolve) {
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(function() {
                            return init.history.go(delta);
                        });
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(state.fetchers, key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            var newErrors = bufferedInitialStateUpdate.newErrors;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return function() {
            return subscribers.delete(fn);
        };
    }
    function updateState(newState) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (newState.matches) newState.matches = newState.matches.map(function(m) {
            var route = manifest[m.route.id];
            var matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return (0, $lf4fc._)((0, $hwO3w._)({}, m), {
                route: route
            });
            return m;
        });
        state = (0, $hwO3w._)({}, state, newState);
        var unmountedFetchers = [];
        var mountedFetchers = [];
        state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach(function(key) {
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        var _newState_errors;
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: (_newState_errors = newState.errors) !== null && _newState_errors !== void 0 ? _newState_errors : null
        };
        (0, $XnYkK._)(subscribers).forEach(function(subscriber) {
            var _newState_errors;
            return subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: (_newState_errors = newState.errors) !== null && _newState_errors !== void 0 ? _newState_errors : null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        unmountedFetchers.forEach(function(key) {
            return deleteFetcher(state.fetchers, key);
        });
        mountedFetchers.forEach(function(key) {
            return state.fetchers.delete(key);
        });
    }
    function completeNavigation(location, newState) {
        var flushSync = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).flushSync;
        var _location_state, _location_state1;
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, IDLE_BLOCKER);
            });
        }
        var restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1._isRedirect) !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        var viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState((0, $lf4fc._)((0, $hwO3w._)({}, newState), {
            // matches, errors, fetchers go through as-is
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd === null || pendingRevalidationDfd === void 0 ? void 0 : pendingRevalidationDfd.resolve();
        pendingRevalidationDfd = null;
    }
    function navigate(to, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var promise, normalizedPath, _normalizeNavigateOptions, path, submission, error, maskPath, partialPath, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                        pendingPopstateNavigationDfd = null;
                        if (typeof to === "number") {
                            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = createDeferred();
                            promise = pendingPopstateNavigationDfd.promise;
                            init.history.go(to);
                            return [
                                2,
                                promise
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, to, opts === null || opts === void 0 ? void 0 : opts.fromRouteId, opts === null || opts === void 0 ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        if (opts === null || opts === void 0 ? void 0 : opts.mask) {
                            partialPath = typeof opts.mask === "string" ? parsePath(opts.mask) : (0, $hwO3w._)({}, state.location.mask, opts.mask);
                            maskPath = (0, $hwO3w._)({
                                pathname: "",
                                search: "",
                                hash: ""
                            }, partialPath);
                        }
                        currentLocation = state.location;
                        nextLocation = createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
                        nextLocation = (0, $hwO3w._)({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : void 0;
                        historyAction = "PUSH" /* Push */ ;
                        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
                        flushSync = (opts && opts.flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: void 0,
                                        reset: void 0,
                                        location: nextLocation
                                    });
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, IDLE_BLOCKER);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.viewTransition,
                                flushSync: flushSync,
                                callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        var promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    function startNavigation(historyAction, location, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var routesToUse, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, loadingNavigation, request, scopedContext, _tmp, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors, workingFetchers;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = dataRoutes.activeRoutes;
                        matches = (opts === null || opts === void 0 ? void 0 : opts.initialHydration) && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
                        state.matches : matchRoutesImpl(routesToUse, location, basename, false, dataRoutes.branches);
                        flushSync = (opts && opts.flushSync) === true;
                        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $dUlz9._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        loadingNavigation = opts && opts.overrideNavigation ? (0, $lf4fc._)((0, $hwO3w._)({}, opts.overrideNavigation), {
                            matches: matches,
                            historyAction: historyAction
                        }) : void 0;
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!init.getContext) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            init.getContext()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = new RouterContextProvider();
                        _state.label = 3;
                    case 3:
                        scopedContext = _tmp;
                        if (!(opts && opts.pendingError)) return [
                            3,
                            4
                        ];
                        pendingActionResult = [
                            findNearestBoundary(matches).route.id,
                            {
                                type: "error" /* error */ ,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            6
                        ];
                    case 4:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 5:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $6iP9u._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $dUlz9._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = getLoadingNavigation(location, matches, historyAction, opts.submission);
                        flushSync = false;
                        fogOfWar.active = false;
                        request = createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 6;
                    case 6:
                        return [
                            4,
                            handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate)
                        ];
                    case 7:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors, workingFetchers = _ref.workingFetchers;
                        if (shortCircuited) return [
                            2
                        ];
                        pendingNavigationController = null;
                        completeNavigation(location, (0, $hwO3w._)((0, $lf4fc._)((0, $hwO3w._)({
                            matches: updatedMatches || matches
                        }, getActionDataForCommit(pendingActionResult)), {
                            loaderData: loaderData,
                            errors: errors
                        }), workingFetchers ? {
                            fetchers: workingFetchers
                        } : {}));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleAction(_0, _1, _2, _3, _4, _5, _6, _7) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration) {
            var opts, navigation, discoverResult, _getShortCircuitMatches, matches2, route, boundaryId, _handleNavigational404, notFoundMatches, error, route1, result, actionMatch, dsMatches, results, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, replace2, location2, boundaryMatch;
            var _arguments = arguments;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        opts = _arguments.length > 8 && _arguments[8] !== void 0 ? _arguments[8] : {};
                        interruptActiveLoads();
                        navigation = getSubmittingNavigation(location, matches, historyAction, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            if (discoverResult.partialMatches.length === 0) {
                                _getShortCircuitMatches = getShortCircuitMatches(dataRoutes.activeRoutes), matches2 = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                                return [
                                    2,
                                    {
                                        matches: matches2,
                                        pendingActionResult: [
                                            route.id,
                                            {
                                                type: "error" /* error */ ,
                                                error: discoverResult.error
                                            }
                                        ]
                                    }
                                ];
                            }
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: "error" /* error */ ,
                                            error: discoverResult.error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error = _handleNavigational404.error, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route1.id,
                                        {
                                            type: "error" /* error */ ,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: "error" /* error */ ,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
                        return [
                            4,
                            callDataStrategy(request, location, dsMatches, scopedContext, null)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (!result) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    match = _step.value;
                                    if (results[match.route.id]) {
                                        result = results[match.route.id];
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace2 = opts.replace;
                        else {
                            location2 = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                            replace2 = location2 === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, true, {
                                submission: submission,
                                replace: replace2
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if (isErrorResult(result)) {
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result,
                                        actionMatch.route.id
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, _getShortCircuitMatches, matches2, route, boundaryId, _handleNavigational404, error, notFoundMatches, route1, routesToUse, _getMatchesToLoad, dsMatches, revalidatingFetchers, workingFetchers2, didUpdateFetcherRedirects2, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect2, workingFetchers, _processLoaderData, loaderData, errors, didUpdateFetcherRedirects, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loadingNavigation = overrideNavigation || getLoadingNavigation(location, matches, historyAction, submission);
                        activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState((0, $hwO3w._)({
                                navigation: loadingNavigation
                            }, actionData !== void 0 ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            if (discoverResult.partialMatches.length === 0) {
                                _getShortCircuitMatches = getShortCircuitMatches(dataRoutes.activeRoutes), matches2 = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                                return [
                                    2,
                                    {
                                        matches: matches2,
                                        loaderData: {},
                                        errors: (0, $dUlz9._)({}, route.id, discoverResult.error)
                                    }
                                ];
                            }
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, $dUlz9._)({}, boundaryId, discoverResult.error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $dUlz9._)({}, route1.id, error)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = dataRoutes.activeRoutes;
                        _getMatchesToLoad = getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate), dsMatches = _getMatchesToLoad.dsMatches, revalidatingFetchers = _getMatchesToLoad.revalidatingFetchers;
                        pendingNavigationLoadId = ++incrementingLoadId;
                        if (!init.dataStrategy && !dsMatches.some(function(m) {
                            return m.shouldLoad;
                        }) && !dsMatches.some(function(m) {
                            return m.route.middleware && m.route.middleware.length > 0;
                        }) && revalidatingFetchers.length === 0) {
                            workingFetchers2 = new Map(state.fetchers);
                            didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
                            completeNavigation(location, (0, $hwO3w._)({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $dUlz9._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, getActionDataForCommit(pendingActionResult), didUpdateFetcherRedirects2 ? {
                                fetchers: workingFetchers2
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== void 0) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            abortFetcher(rf.key);
                            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        redirect2 = findRedirect(loaderResults);
                        if (!redirect2) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(request, redirect2.result, true, {
                                replace: replace2
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        redirect2 = findRedirect(fetcherResults);
                        if (!redirect2) return [
                            3,
                            7
                        ];
                        fetchRedirectIds.add(redirect2.key);
                        return [
                            4,
                            startRedirectNavigation(request, redirect2.result, true, {
                                replace: replace2
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        workingFetchers = new Map(state.fetchers);
                        _processLoaderData = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        if (initialHydration && state.errors) errors = (0, $hwO3w._)({}, state.errors, errors);
                        didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
                        shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            (0, $hwO3w._)({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                workingFetchers: workingFetchers
                            } : {})
                        ];
                }
            });
        })();
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) return (0, $dUlz9._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        var workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = workingFetchers.get(rf.key);
            var revalidatingFetcher = getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    function fetch2(key, routeId, href, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var flushSync, routesToUse, normalizedPath, matches, fogOfWar, _normalizeNavigateOptions, path, submission, error, scopedContext, _tmp, preventScrollReset;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        abortFetcher(key);
                        flushSync = (opts && opts.flushSync) === true;
                        routesToUse = dataRoutes.activeRoutes;
                        normalizedPath = normalizeTo(state.location, state.matches, basename, href, routeId, opts === null || opts === void 0 ? void 0 : opts.relative);
                        matches = matchRoutesImpl(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
                        fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        if (!matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: normalizedPath
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        _normalizeNavigateOptions = normalizeNavigateOptions(true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        if (error) {
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        if (!init.getContext) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            init.getContext()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = new RouterContextProvider();
                        _state.label = 3;
                    case 3:
                        scopedContext = _tmp;
                        preventScrollReset = (opts && opts.preventScrollReset) === true;
                        if (!(submission && isMutationMethod(submission.formMethod))) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        fetchLoadMatches.set(key, {
                            routeId: routeId,
                            path: path
                        });
                        return [
                            4,
                            handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission)
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var existingFetcher, abortController, fetchRequest, discoverResult, match, error, originatingLoadId, fetchMatches, actionResults, actionResult, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match2, nextLocation, revalidationRequest, routesToUse, matches, loadId, _getMatchesToLoad, dsMatches, revalidatingFetchers, loadFetcher, workingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, fetcherIsMounted, getRedirectStateWithDoneFetcher, redirect2, finalFetchers, _processLoaderData, loaderData, errors;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else requestMatches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        match = getTargetMatch(requestMatches, path);
                        if (!match.route.action && !match.route.lazy) {
                            error = getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        fetchMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
                        return [
                            4,
                            callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[match.route.id];
                        if (!actionResult) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = fetchMatches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    match2 = _step.value;
                                    if (actionResults[match2.route.id]) {
                                        actionResult = actionResults[match2.route.id];
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        if (fetchRequest.signal.aborted) {
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if (fetchersQueuedForDeletion.has(key)) {
                            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                                updateFetcherState(key, getDoneFetcher(void 0));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if (isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    updateFetcherState(key, getDoneFetcher(void 0));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, false, {
                                            fetcherSubmission: submission,
                                            preventScrollReset: preventScrollReset
                                        })
                                    ];
                                }
                            }
                            if (isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = dataRoutes.activeRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutesImpl(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        _getMatchesToLoad = getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
                            match.route.id,
                            actionResult
                        ], callSiteDefaultShouldRevalidate), dsMatches = _getMatchesToLoad.dsMatches, revalidatingFetchers = _getMatchesToLoad.revalidatingFetchers;
                        loadFetcher = getLoadingFetcher(submission, actionResult.data);
                        workingFetchers = new Map(state.fetchers);
                        workingFetchers.set(key, loadFetcher);
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher2 = workingFetchers.get(staleKey);
                            var revalidatingFetcher = getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
                            workingFetchers.set(staleKey, revalidatingFetcher);
                            abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: workingFetchers
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        fetcherIsMounted = state.fetchers.has(key);
                        getRedirectStateWithDoneFetcher = function(s) {
                            if (!fetcherIsMounted) return s;
                            var workingFetchers2 = new Map(s.fetchers);
                            workingFetchers2.set(key, getDoneFetcher(actionResult.data));
                            return (0, $lf4fc._)((0, $hwO3w._)({}, s), {
                                fetchers: workingFetchers2
                            });
                        };
                        redirect2 = findRedirect(loaderResults);
                        if (redirect2) {
                            state = getRedirectStateWithDoneFetcher(state);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        redirect2 = findRedirect(fetcherResults);
                        if (redirect2) {
                            fetchRedirectIds.add(redirect2.key);
                            state = getRedirectStateWithDoneFetcher(state);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        finalFetchers = new Map(state.fetchers);
                        if (fetcherIsMounted) finalFetchers.set(key, getDoneFetcher(actionResult.data));
                        _processLoaderData = processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        abortStaleFetchLoads(loadId, finalFetchers);
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: finalFetchers
                            });
                        } else {
                            updateState({
                                errors: errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: finalFetchers
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var existingFetcher, abortController, fetchRequest, discoverResult, match, originatingLoadId, dsMatches, results, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match2;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        match = getTargetMatch(matches, path);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
                        return [
                            4,
                            callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[match.route.id];
                        if (!result) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    match2 = _step.value;
                                    if (results[match2.route.id]) {
                                        result = results[match2.route.id];
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        if (fetchersQueuedForDeletion.has(key)) {
                            updateFetcherState(key, getDoneFetcher(void 0));
                            return [
                                2
                            ];
                        }
                        if (!isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        updateFetcherState(key, getDoneFetcher(void 0));
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        if (isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        updateFetcherState(key, getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function startRedirectNavigation(_0, _1, _2) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(request, redirect2, isNavigation) {
            var _ref, submission, fetcherSubmission, preventScrollReset, replace2, location, redirectLocation, isDocumentReload, url, redirectNavigationType, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            var _arguments = arguments;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, preventScrollReset = _ref.preventScrollReset, replace2 = _ref.replace;
                        if (!isNavigation) {
                            pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                            pendingPopstateNavigationDfd = null;
                        }
                        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect2.response.headers.get("Location");
                        invariant(location, "Expected a Location header on the redirect Response");
                        location = normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
                        redirectLocation = createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser3) {
                            isDocumentReload = false;
                            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
                            else if (isAbsoluteUrl(location)) {
                                url = createBrowserURLImpl(routerWindow, location, true);
                                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                stripBasename(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace2) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        pendingNavigationController = null;
                        redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
                        activeSubmission = submission || fetcherSubmission;
                        if (!(redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectNavigationType, redirectLocation, {
                                submission: (0, $lf4fc._)((0, $hwO3w._)({}, activeSubmission), {
                                    formAction: location
                                }),
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        overrideNavigation = getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
                        return [
                            4,
                            startNavigation(redirectNavigationType, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var results, dataResults, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, _results_match_route_id, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _step_value, routeId, result, response, err;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataResults = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false)
                        ];
                    case 2:
                        results = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        matches.filter(function(m) {
                            return m.shouldLoad;
                        }).forEach(function(m) {
                            dataResults[m.route.id] = {
                                type: "error" /* error */ ,
                                error: e
                            };
                        });
                        return [
                            2,
                            dataResults
                        ];
                    case 4:
                        if (request.signal.aborted) return [
                            2,
                            dataResults
                        ];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!isMutationMethod(request.method)) try {
                            for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                match = _step.value;
                                ;
                                if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.type) === "error" /* error */ ) break;
                                if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                                    type: "error" /* error */ ,
                                    result: new Error("No result returned from dataStrategy for route ".concat(match.route.id))
                                };
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            11,
                            12,
                            13
                        ]);
                        _iterator1 = Object.entries(results)[Symbol.iterator]();
                        _state.label = 6;
                    case 6:
                        if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                            3,
                            10
                        ];
                        _step_value = (0, $6iP9u._)(_step1.value, 2), routeId = _step_value[0], result = _step_value[1];
                        if (!isRedirectDataStrategyResult(result)) return [
                            3,
                            7
                        ];
                        response = result.result;
                        dataResults[routeId] = {
                            type: "redirect" /* redirect */ ,
                            response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
                        };
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            convertDataStrategyResultToDataResult(result)
                        ];
                    case 8:
                        dataResults[routeId] = _state.sent();
                        _state.label = 9;
                    case 9:
                        _iteratorNormalCompletion1 = true;
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            3,
                            13
                        ];
                    case 11:
                        err = _state.sent();
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                        return [
                            3,
                            13
                        ];
                    case 12:
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var loaderResultsPromise, fetcherResultsPromise, loaderResults, fetcherResults;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
                        fetcherResultsPromise = Promise.all(fetchersToLoad.map(function(f) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var results, result;
                                return (0, $3SMYb._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(f.matches && f.match && f.request && f.controller)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key)
                                            ];
                                        case 1:
                                            results = _state.sent();
                                            result = results[f.match.route.id];
                                            return [
                                                2,
                                                (0, $dUlz9._)({}, f.key, result)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.resolve((0, $dUlz9._)({}, f.key, {
                                                    type: "error" /* error */ ,
                                                    error: getInternalRouterError(404, {
                                                        pathname: f.path
                                                    })
                                                }))
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }));
                        return [
                            4,
                            loaderResultsPromise
                        ];
                    case 1:
                        loaderResults = _state.sent();
                        return [
                            4,
                            fetcherResultsPromise
                        ];
                    case 2:
                        fetcherResults = _state.sent().reduce(function(acc, r) {
                            return Object.assign(acc, r);
                        }, {});
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        })();
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error) {
        var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        var workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: (0, $dUlz9._)({}, boundaryMatch.route.id, error),
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts === null || opts === void 0 ? void 0 : opts.reason);
        updateFetcherState(key, getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        var fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        var count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        var controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = fetchers.get(key);
                invariant(fetcher, "Expected fetcher: ".concat(key));
                var doneFetcher = getDoneFetcher(fetcher.data);
                fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone(fetchers) {
        var doneKeys = [];
        var didUpdateFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = fetchers.get(key);
                invariant(fetcher, "Expected fetcher: ".concat(key));
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    didUpdateFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $6iP9u._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: ".concat(key));
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: ".concat(blocker.state, " -> ").concat(newBlocker.state));
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(param) {
        var currentLocation = param.currentLocation, nextLocation = param.nextLocation, historyAction = param.historyAction;
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $6iP9u._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = dataRoutes.activeRoutes;
        var _getShortCircuitMatches = getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            var key = getScrollRestorationKey2(location, matches.map(function(m) {
                return convertRouteMatchToUiMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            var activeBranches = dataRoutes.branches;
            if (!matches) {
                var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal, fetcherKey) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var _loop, partialMatches, _ret;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var localManifest, e, activeBranches, newMatches, newPartialMatches, matchedDeeper;
                            return (0, $3SMYb._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        localManifest = manifest;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            init.patchRoutesOnNavigation({
                                                signal: signal,
                                                path: pathname,
                                                matches: partialMatches,
                                                fetcherKey: fetcherKey,
                                                patch: function(routeId, children) {
                                                    if (signal.aborted) return;
                                                    patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                                                }
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        activeBranches = dataRoutes.branches;
                                        newMatches = matchRoutesImpl(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
                                        newPartialMatches = null;
                                        if (newMatches) {
                                            if (Object.keys(newMatches[0].params).length === 0) return [
                                                2,
                                                {
                                                    v: {
                                                        type: "success",
                                                        matches: newMatches
                                                    }
                                                }
                                            ];
                                            else {
                                                newPartialMatches = matchRoutesImpl(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                                                matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                                                if (!matchedDeeper) return [
                                                    2,
                                                    {
                                                        v: {
                                                            type: "success",
                                                            matches: newMatches
                                                        }
                                                    }
                                                ];
                                            }
                                        }
                                        if (!newPartialMatches) newPartialMatches = matchRoutesImpl(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                                        if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: null
                                                }
                                            }
                                        ];
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        if (!init.patchRoutesOnNavigation) return [
                            2,
                            {
                                type: "success",
                                matches: matches
                            }
                        ];
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, $4WD8g.__values)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, $03bAP._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every(function(m, i) {
            return m.route.id === b[i].route.id;
        });
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes(convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children) {
        var unstable_allowElementMutations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp: function(newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = instrumentClientSideRouter(router, init.instrumentations.map(function(i) {
        return i.router;
    }).filter(Boolean));
    return router;
}
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var _mapRouteProperties = (opts === null || opts === void 0 ? void 0 : opts.mapRouteProperties) || defaultMapRouteProperties;
    var mapRouteProperties2 = _mapRouteProperties;
    var future = (0, $hwO3w._)({}, opts === null || opts === void 0 ? void 0 : opts.future);
    if (opts === null || opts === void 0 ? void 0 : opts.instrumentations) {
        var instrumentations = opts.instrumentations;
        mapRouteProperties2 = function(route) {
            return (0, $hwO3w._)({}, _mapRouteProperties(route), getRouteInstrumentationUpdates(instrumentations.map(function(i) {
                return i.route;
            }).filter(Boolean), route));
        };
    }
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    var routeBranches = flattenAndRankRoutes(dataRoutes);
    function query(_0) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(request) {
            var _ref, requestContext, filterMatchesToLoad, skipLoaderErrorBubbling, skipRevalidation, dataStrategy, generateMiddlewareResponse, normalizePath, normalizePathImpl, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, staticContext, error1, _getShortCircuitMatches1, notFoundMatches, route1, staticContext1, renderedStaticContext, response, e, result;
            var _arguments = arguments;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, requestContext = _ref.requestContext, filterMatchesToLoad = _ref.filterMatchesToLoad, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, skipRevalidation = _ref.skipRevalidation, dataStrategy = _ref.dataStrategy, generateMiddlewareResponse = _ref.generateMiddlewareResponse, normalizePath = _ref.normalizePath;
                        normalizePathImpl = normalizePath || defaultNormalizePath;
                        method = request.method;
                        location = createLocation("", normalizePathImpl(request), null, "default");
                        matches = matchRoutesImpl(dataRoutes, location, basename, false, routeBranches);
                        requestContext = requestContext != null ? requestContext : new RouterContextProvider();
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            staticContext = {
                                basename: basename,
                                location: location,
                                matches: methodNotAllowedMatches,
                                loaderData: {},
                                actionData: null,
                                errors: (0, $dUlz9._)({}, route.id, error),
                                statusCode: error.status,
                                loaderHeaders: {},
                                actionHeaders: {}
                            };
                            return [
                                2,
                                generateMiddlewareResponse ? generateMiddlewareResponse(function() {
                                    return Promise.resolve(staticContext);
                                }) : staticContext
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            staticContext1 = {
                                basename: basename,
                                location: location,
                                matches: notFoundMatches,
                                loaderData: {},
                                actionData: null,
                                errors: (0, $dUlz9._)({}, route1.id, error1),
                                statusCode: error1.status,
                                loaderHeaders: {},
                                actionHeaders: {}
                            };
                            return [
                                2,
                                generateMiddlewareResponse ? generateMiddlewareResponse(function() {
                                    return Promise.resolve(staticContext1);
                                }) : staticContext1
                            ];
                        }
                        if (!generateMiddlewareResponse) return [
                            3,
                            5
                        ];
                        invariant(requestContext instanceof RouterContextProvider, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            runServerMiddlewarePipeline({
                                request: request,
                                url: createDataFunctionUrl(request, location),
                                pattern: getRoutePattern(matches),
                                matches: matches,
                                params: matches[0].params,
                                // If we're calling middleware then it must be enabled so we can cast
                                // this to the proper type knowing it's not an `AppLoadContext`
                                context: requestContext
                            }, function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                    var res;
                                    return (0, $3SMYb._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    generateMiddlewareResponse(function(revalidationRequest) {
                                                        var opts2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                                            var _opts2_filterMatchesToLoad, result2;
                                                            return (0, $3SMYb._)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? (_opts2_filterMatchesToLoad = opts2.filterMatchesToLoad) !== null && _opts2_filterMatchesToLoad !== void 0 ? _opts2_filterMatchesToLoad : null : filterMatchesToLoad !== null && filterMatchesToLoad !== void 0 ? filterMatchesToLoad : null, skipRevalidation === true)
                                                                        ];
                                                                    case 1:
                                                                        result2 = _state.sent();
                                                                        if (isResponse(result2)) return [
                                                                            2,
                                                                            result2
                                                                        ];
                                                                        renderedStaticContext = (0, $hwO3w._)({
                                                                            location: location,
                                                                            basename: basename
                                                                        }, result2);
                                                                        return [
                                                                            2,
                                                                            renderedStaticContext
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                res = _state.sent();
                                                return [
                                                    2,
                                                    res
                                                ];
                                        }
                                    });
                                })();
                            }, function(error, routeId) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                    var _, _tmp, e, staticContext, _matches_find, boundaryRouteId, staticContext1;
                                    return (0, $3SMYb._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (isRedirectResponse(error)) return [
                                                    2,
                                                    error
                                                ];
                                                if (!isResponse(error)) return [
                                                    3,
                                                    4
                                                ];
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                _ = ErrorResponseImpl.bind;
                                                _tmp = [
                                                    void 0,
                                                    error.status,
                                                    error.statusText
                                                ];
                                                return [
                                                    4,
                                                    parseResponseBody(error)
                                                ];
                                            case 2:
                                                error = new (_.apply(ErrorResponseImpl, _tmp.concat([
                                                    _state.sent()
                                                ])));
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                e = _state.sent();
                                                error = e;
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                if (isDataWithResponseInit(error)) error = dataWithResponseInitToErrorResponse(error);
                                                if (renderedStaticContext) {
                                                    if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                                                    staticContext = getStaticContextFromError(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : findNearestBoundary(matches, routeId).route.id);
                                                    return [
                                                        2,
                                                        generateMiddlewareResponse(function() {
                                                            return Promise.resolve(staticContext);
                                                        })
                                                    ];
                                                } else {
                                                    ;
                                                    boundaryRouteId = skipLoaderErrorBubbling ? routeId : findNearestBoundary(matches, ((_matches_find = matches.find(function(m) {
                                                        return m.route.id === routeId || m.route.loader;
                                                    })) === null || _matches_find === void 0 ? void 0 : _matches_find.route.id) || routeId).route.id;
                                                    staticContext1 = {
                                                        matches: matches,
                                                        location: location,
                                                        basename: basename,
                                                        loaderData: {},
                                                        actionData: null,
                                                        errors: (0, $dUlz9._)({}, boundaryRouteId, error),
                                                        statusCode: isRouteErrorResponse(error) ? error.status : 500,
                                                        actionHeaders: {},
                                                        loaderHeaders: {}
                                                    };
                                                    return [
                                                        2,
                                                        generateMiddlewareResponse(function() {
                                                            return Promise.resolve(staticContext1);
                                                        })
                                                    ];
                                                }
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            })
                        ];
                    case 3:
                        response = _state.sent();
                        invariant(isResponse(response), "Expected a response in query()");
                        return [
                            2,
                            response
                        ];
                    case 4:
                        e = _state.sent();
                        if (isResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 5:
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true)
                        ];
                    case 6:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        return [
                            2,
                            (0, $hwO3w._)({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function queryRoute(_0) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(request) {
            var _ref, routeId, requestContext, dataStrategy, generateMiddlewareResponse, normalizePath, normalizePathImpl, method, location, matches, match, response, result;
            var _arguments = arguments;
            function handleQueryResult(result2) {
                if (isResponse(result2)) return result2;
                var error = result2.errors ? Object.values(result2.errors)[0] : void 0;
                if (error !== void 0) throw error;
                if (result2.actionData) return Object.values(result2.actionData)[0];
                if (result2.loaderData) return Object.values(result2.loaderData)[0];
                return void 0;
            }
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, routeId = _ref.routeId, requestContext = _ref.requestContext, dataStrategy = _ref.dataStrategy, generateMiddlewareResponse = _ref.generateMiddlewareResponse, normalizePath = _ref.normalizePath;
                        normalizePathImpl = normalizePath || defaultNormalizePath;
                        method = request.method;
                        location = createLocation("", normalizePathImpl(request), null, "default");
                        matches = matchRoutesImpl(dataRoutes, location, basename, false, routeBranches);
                        requestContext = requestContext != null ? requestContext : new RouterContextProvider();
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        if (!generateMiddlewareResponse) return [
                            3,
                            3
                        ];
                        invariant(requestContext instanceof RouterContextProvider, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
                        return [
                            4,
                            loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            runServerMiddlewarePipeline({
                                request: request,
                                url: createDataFunctionUrl(request, location),
                                pattern: getRoutePattern(matches),
                                matches: matches,
                                params: matches[0].params,
                                // If we're calling middleware then it must be enabled so we can cast
                                // this to the proper type knowing it's not an `AppLoadContext`
                                context: requestContext
                            }, function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                    var res;
                                    return (0, $3SMYb._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    generateMiddlewareResponse(function(innerRequest) {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                                            var result2, processed;
                                                            return (0, $3SMYb._)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false)
                                                                        ];
                                                                    case 1:
                                                                        result2 = _state.sent();
                                                                        processed = handleQueryResult(result2);
                                                                        return [
                                                                            2,
                                                                            isResponse(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed)
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                res = _state.sent();
                                                return [
                                                    2,
                                                    res
                                                ];
                                        }
                                    });
                                })();
                            }, function(error) {
                                if (isDataWithResponseInit(error)) return Promise.resolve(dataWithResponseInitToResponse(error));
                                if (isResponse(error)) return Promise.resolve(error);
                                throw error;
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            2,
                            response
                        ];
                    case 3:
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false)
                        ];
                    case 4:
                        result = _state.sent();
                        return [
                            2,
                            handleQueryResult(result)
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var result2, result, e;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, location, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation)
                        ];
                    case 2:
                        result2 = _state.sent();
                        return [
                            2,
                            result2
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad)
                        ];
                    case 4:
                        result = _state.sent();
                        return [
                            2,
                            isResponse(result) ? result : (0, $lf4fc._)((0, $hwO3w._)({}, result), {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        if (isDataStrategyResult(e) && isResponse(e.result)) {
                            if (e.type === "error" /* error */ ) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var result, error, dsMatches, results, boundaryMatch, loaderRequest, boundaryMatch1, handlerContext2, handlerContext;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: "error" /* error */ ,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
                        return [
                            4,
                            callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isRouteRequest) {
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $dUlz9._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {}
                                }
                            ];
                        }
                        if (skipRevalidation) {
                            if (isErrorResult(result)) {
                                boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                                return [
                                    2,
                                    {
                                        statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                        actionData: null,
                                        actionHeaders: (0, $hwO3w._)({}, result.headers ? (0, $dUlz9._)({}, actionMatch.route.id, result.headers) : {}),
                                        matches: matches,
                                        loaderData: {},
                                        errors: (0, $dUlz9._)({}, boundaryMatch.route.id, result.error),
                                        loaderHeaders: {}
                                    }
                                ];
                            } else return [
                                2,
                                {
                                    actionData: (0, $dUlz9._)({}, actionMatch.route.id, result.data),
                                    actionHeaders: result.headers ? (0, $dUlz9._)({}, actionMatch.route.id, result.headers) : {},
                                    matches: matches,
                                    loaderData: {},
                                    errors: null,
                                    statusCode: result.statusCode || 200,
                                    loaderHeaders: {}
                                }
                            ];
                        }
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        boundaryMatch1 = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                                boundaryMatch1.route.id,
                                result
                            ])
                        ];
                    case 4:
                        handlerContext2 = _state.sent();
                        return [
                            2,
                            (0, $lf4fc._)((0, $hwO3w._)({}, handlerContext2), {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: (0, $hwO3w._)({}, result.headers ? (0, $dUlz9._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad)
                        ];
                    case 6:
                        handlerContext = _state.sent();
                        return [
                            2,
                            (0, $lf4fc._)((0, $hwO3w._)((0, $lf4fc._)((0, $hwO3w._)({}, handlerContext), {
                                actionData: (0, $dUlz9._)({}, actionMatch.route.id, result.data)
                            }), result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}), {
                                actionHeaders: result.headers ? (0, $dUlz9._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        })();
    }
    function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var isRouteRequest, dsMatches, maxIdx, pattern, results, handlerContext;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        if (isRouteRequest && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.loader) && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.id
                        });
                        if (routeMatch) dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
                        else {
                            maxIdx = pendingActionResult && isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
                            matches.findIndex(function(m) {
                                return m.route.id === pendingActionResult[0];
                            }) - 1 : void 0;
                            pattern = getRoutePattern(matches);
                            dsMatches = matches.map(function(match, index) {
                                if (maxIdx != null && index > maxIdx) return getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                                return getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
                            });
                        }
                        if (!dataStrategy && !dsMatches.some(function(m) {
                            return m.shouldLoad;
                        })) return [
                            2,
                            {
                                matches: matches,
                                loaderData: {},
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $dUlz9._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {}
                            }
                        ];
                        return [
                            4,
                            callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
                        handlerContext = processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
                        return [
                            2,
                            (0, $lf4fc._)((0, $hwO3w._)({}, handlerContext), {
                                matches: matches
                            })
                        ];
                }
            });
        })();
    }
    function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var results, dataResults;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            callDataStrategyImpl(dataStrategy || defaultDataStrategy, request, location, matches, null, requestContext, true)
                        ];
                    case 1:
                        results = _state.sent();
                        dataResults = {};
                        return [
                            4,
                            Promise.all(matches.map(function(match) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                    var result, response, _;
                                    return (0, $3SMYb._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(match.route.id in results)) return [
                                                    2
                                                ];
                                                result = results[match.route.id];
                                                if (isRedirectDataStrategyResult(result)) {
                                                    response = result.result;
                                                    throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
                                                }
                                                if (isRouteRequest) {
                                                    if (isResponse(result.result)) throw result;
                                                    else if (isDataWithResponseInit(result.result)) throw dataWithResponseInitToResponse(result.result);
                                                }
                                                _ = match.route.id;
                                                return [
                                                    4,
                                                    convertDataStrategyResultToDataResult(result)
                                                ];
                                            case 1:
                                                dataResults[_] = _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function getStaticContextFromError(routes, handlerContext, error, boundaryId) {
    var errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return (0, $lf4fc._)((0, $hwO3w._)({}, handlerContext), {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: (0, $dUlz9._)({}, errorBoundaryId, error)
    });
}
function throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error("".concat(method, "() call aborted without an `AbortSignal.reason`: ").concat(request.method, " ").concat(request.url));
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function defaultNormalizePath(request) {
    var url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        var nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            var params = new URLSearchParams(path.search);
            var indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?".concat(qs) : "";
        }
    }
    if (basename !== "/") path.pathname = prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return createPath(path);
}
function normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path: path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = rawFormMethod.toUpperCase();
    var formAction = stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, param) {
                var _param = (0, $6iP9u._)(param, 2), name = _param[0], value = _param[1];
                return "".concat(acc).concat(name, "=").concat(value, "\n");
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if (isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    var parsedPath = parsePath(path);
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?".concat(searchParams);
    return {
        path: createPath(parsedPath),
        submission: submission
    };
}
function getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    var _state_matches_;
    var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    var maxIdx;
    if (initialHydration && state.errors) {
        var boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
    } else if (pendingActionResult && isErrorResult(pendingActionResult[1])) {
        var boundaryId1 = pendingActionResult[0];
        maxIdx = matches.findIndex(function(m) {
            return m.route.id === boundaryId1;
        }) - 1;
    }
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    var shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    var baseShouldRevalidateArgs = (0, $lf4fc._)((0, $hwO3w._)({
        currentUrl: currentUrl,
        currentParams: ((_state_matches_ = state.matches[0]) === null || _state_matches_ === void 0 ? void 0 : _state_matches_.params) || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params
    }, submission), {
        actionResult: actionResult,
        actionStatus: actionStatus
    });
    var pattern = getRoutePattern(matches);
    var dsMatches = matches.map(function(match, index) {
        var route = match.route;
        var forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            var _getRouteHydrationStatus = getRouteHydrationStatus(route, state.loaderData, state.errors), shouldLoad2 = _getRouteHydrationStatus.shouldLoad;
            forceShouldLoad = shouldLoad2;
        } else if (isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        var defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if (isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        var shouldRevalidateArgs = (0, $lf4fc._)((0, $hwO3w._)({}, baseShouldRevalidateArgs), {
            defaultShouldRevalidate: defaultShouldRevalidate
        });
        var shouldLoad = shouldRevalidateLoader(match, shouldRevalidateArgs);
        return getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        if (initialHydration || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || fetchersQueuedForDeletion.has(key)) return;
        var fetcher = state.fetchers.get(key);
        var isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        var fetcherMatches = matchRoutesImpl(routesToUse, f.path, basename !== null && basename !== void 0 ? basename : "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        var fetchController = new AbortController();
        var fetchRequest = createClientSideRequest(history, f.path, fetchController.signal);
        var fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            var defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            var shouldRevalidateArgs = (0, $lf4fc._)((0, $hwO3w._)({}, baseShouldRevalidateArgs), {
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            if (shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    var hasData = loaderData != null && route.id in loaderData;
    var hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    var shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    var isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    var childrenToPatch;
    if (routeId) {
        var route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = ".concat(routeId));
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    var uniqueChildren = [];
    var existingChildren = [];
    children.forEach(function(newRoute) {
        var existingRoute = childrenToPatch.find(function(existingRoute2) {
            return isSameRoute(newRoute, existingRoute2);
        });
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        var _childrenToPatch;
        var newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String((childrenToPatch === null || childrenToPatch === void 0 ? void 0 : childrenToPatch.length) || "0")
        ], manifest);
        (_childrenToPatch = childrenToPatch).push.apply(_childrenToPatch, (0, $XnYkK._)(newRoutes));
    }
    if (allowElementMutations && existingChildren.length > 0) for(var i = 0; i < existingChildren.length; i++){
        var _existingChildren_i = existingChildren[i], existingRoute = _existingChildren_i.existingRoute, newRoute = _existingChildren_i.newRoute;
        var existingRouteTyped = existingRoute;
        var _convertRoutesToDataRoutes = (0, $6iP9u._)(convertRoutesToDataRoutes([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true), 1), newRouteTyped = _convertRoutesToDataRoutes[0];
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes((0, $XnYkK._)(dataRoutes.activeRoutes));
}
function isSameRoute(newRoute, existingRoute) {
    var _newRoute_children;
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    var _newRoute_children_every;
    return (_newRoute_children_every = (_newRoute_children = newRoute.children) === null || _newRoute_children === void 0 ? void 0 : _newRoute_children.every(function(aChild, i) {
        var _existingRoute_children;
        return (_existingRoute_children = existingRoute.children) === null || _existingRoute_children === void 0 ? void 0 : _existingRoute_children.some(function(bChild) {
            return isSameRoute(aChild, bChild);
        });
    })) !== null && _newRoute_children_every !== void 0 ? _newRoute_children_every : false;
}
var lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var loadLazyRouteProperty = function(param) {
    var key = param.key, route = param.route, manifest = param.manifest, mapRouteProperties2 = param.mapRouteProperties;
    var routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || (0, $03bAP._)(routeToUpdate.lazy) !== "object") return;
    var lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    var cache = lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    var cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    var propertyPromise = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var isUnsupported, staticRouteValue, isStaticallyDefined, value;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isUnsupported = isUnsupportedLazyRouteObjectKey(key);
                        staticRouteValue = routeToUpdate[key];
                        isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
                        if (!isUnsupported) return [
                            3,
                            1
                        ];
                        warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
                        cache[key] = Promise.resolve();
                        return [
                            3,
                            4
                        ];
                    case 1:
                        if (!isStaticallyDefined) return [
                            3,
                            2
                        ];
                        warning(false, 'Route "'.concat(routeToUpdate.id, '" has a static property "').concat(key, '" defined. The lazy property will be ignored.'));
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            lazyFn()
                        ];
                    case 3:
                        value = _state.sent();
                        if (value != null) {
                            Object.assign(routeToUpdate, (0, $dUlz9._)({}, key, value));
                            Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
                        }
                        _state.label = 4;
                    case 4:
                        if ((0, $03bAP._)(routeToUpdate.lazy) === "object") {
                            routeToUpdate.lazy[key] = void 0;
                            if (Object.values(routeToUpdate.lazy).every(function(value) {
                                return value === void 0;
                            })) routeToUpdate.lazy = void 0;
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    var routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        var cachedPromise = lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        var lazyRoutePromise2 = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var lazyRoute, routeUpdates, lazyRouteProperty, lazyValue, isUnsupported, staticRouteValue, isStaticallyDefined;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            invariant(typeof route.lazy === "function", "No lazy route function found");
                            return [
                                4,
                                route.lazy()
                            ];
                        case 1:
                            lazyRoute = _state.sent();
                            routeUpdates = {};
                            for(var lazyRouteProperty in lazyRoute){
                                lazyValue = lazyRoute[lazyRouteProperty];
                                if (lazyValue === void 0) continue;
                                isUnsupported = isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                                staticRouteValue = routeToUpdate[lazyRouteProperty];
                                isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                                // on the route updates
                                lazyRouteProperty !== "hasErrorBoundary";
                                if (isUnsupported) warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                                else if (isStaticallyDefined) warning(!isStaticallyDefined, 'Route "'.concat(routeToUpdate.id, '" has a static property "').concat(lazyRouteProperty, '" defined but its lazy function is also returning a value for this property. The lazy route property "').concat(lazyRouteProperty, '" will be ignored.'));
                                else routeUpdates[lazyRouteProperty] = lazyValue;
                            }
                            Object.assign(routeToUpdate, routeUpdates);
                            Object.assign(routeToUpdate, (0, $lf4fc._)((0, $hwO3w._)({}, mapRouteProperties2(routeToUpdate)), {
                                lazy: void 0
                            }));
                            return [
                                2
                            ];
                    }
                });
            })();
        }();
        lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(function() {});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    var lazyKeys = Object.keys(route.lazy);
    var lazyPropertyPromises = [];
    var lazyHandlerPromise = void 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = lazyKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
            var promise = loadLazyRouteProperty({
                key: key,
                route: route,
                manifest: manifest,
                mapRouteProperties: mapRouteProperties2
            });
            if (promise) {
                lazyPropertyPromises.push(promise);
                if (key === type) lazyHandlerPromise = promise;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(function() {}) : void 0;
    lazyRoutePromise === null || lazyRoutePromise === void 0 ? void 0 : lazyRoutePromise.catch(function() {});
    lazyHandlerPromise === null || lazyHandlerPromise === void 0 ? void 0 : lazyHandlerPromise.catch(function() {});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function isNonNullable(value) {
    return value !== void 0;
}
function loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    var promises = matches.map(function(param) {
        var route = param.route;
        if ((0, $03bAP._)(route.lazy) !== "object" || !route.lazy.middleware) return void 0;
        return loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter(isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
function defaultDataStrategy(args) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var matchesToLoad, keyedResults, results;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matchesToLoad = args.matches.filter(function(m) {
                        return m.shouldLoad;
                    });
                    keyedResults = {};
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve();
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    results.forEach(function(result, i) {
                        keyedResults[matchesToLoad[i].route.id] = result;
                    });
                    return [
                        2,
                        keyedResults
                    ];
            }
        });
    })();
}
function defaultDataStrategyWithMiddleware(args) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        return (0, $3SMYb._)(this, function(_state) {
            if (!args.matches.some(function(m) {
                return m.route.middleware;
            })) return [
                2,
                defaultDataStrategy(args)
            ];
            return [
                2,
                runClientMiddlewarePipeline(args, function() {
                    return defaultDataStrategy(args);
                })
            ];
        });
    })();
}
function runServerMiddlewarePipeline(args, handler, errorHandler) {
    return runMiddlewarePipeline(args, handler, processResult, isResponse, errorHandler);
    function processResult(result) {
        return isDataWithResponseInit(result) ? dataWithResponseInitToResponse(result) : result;
    }
}
function runClientMiddlewarePipeline(args, handler) {
    return runMiddlewarePipeline(args, handler, function(r) {
        if (isRedirectResponse(r)) throw r;
        return r;
    }, isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, (0, $dUlz9._)({}, routeId, {
            type: "error",
            result: error
        })));
        else {
            var matches = args.matches;
            var maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex(function(m) {
                return m.route.id === routeId;
            }), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex(function(m) {
                return m.shouldCallHandler();
            }), 0));
            var boundaryRouteId = findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve((0, $dUlz9._)({}, boundaryRouteId, {
                type: "error",
                result: error
            }));
        }
    }
}
function runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var matches, dataFnArgs, tuples, result;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matches = args.matches, dataFnArgs = (0, $54Czb._)(args, [
                        "matches"
                    ]);
                    tuples = matches.flatMap(function(m) {
                        return m.route.middleware ? m.route.middleware.map(function(fn) {
                            return [
                                m.route.id,
                                fn
                            ];
                        }) : [];
                    });
                    return [
                        4,
                        callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    })();
}
function callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler) {
    var idx = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var request, _request_signal_reason, tuple, result, _tuple, routeId, middleware, nextResult, next, value, result1, _tmp, error, response;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = args.request;
                    if (request.signal.aborted) throw (_request_signal_reason = request.signal.reason) !== null && _request_signal_reason !== void 0 ? _request_signal_reason : new Error("Request aborted: ".concat(request.method, " ").concat(request.url));
                    tuple = middlewares[idx];
                    if (!!tuple) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        handler()
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
                case 2:
                    _tuple = (0, $6iP9u._)(tuple, 2), routeId = _tuple[0], middleware = _tuple[1];
                    next = function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                            var result, error, _tmp;
                            return (0, $3SMYb._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (nextResult) throw new Error("You may only call `next()` once per middleware");
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            5
                                        ]);
                                        return [
                                            4,
                                            callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
                                        ];
                                    case 2:
                                        result = _state.sent();
                                        nextResult = {
                                            value: result
                                        };
                                        return [
                                            2,
                                            nextResult.value
                                        ];
                                    case 3:
                                        error = _state.sent();
                                        _tmp = {};
                                        return [
                                            4,
                                            errorHandler(error, routeId, nextResult)
                                        ];
                                    case 4:
                                        nextResult = (_tmp.value = _state.sent(), _tmp);
                                        return [
                                            2,
                                            nextResult.value
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    };
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        9,
                        ,
                        11
                    ]);
                    return [
                        4,
                        middleware(args, next)
                    ];
                case 4:
                    value = _state.sent();
                    result1 = value != null ? processResult(value) : void 0;
                    if (!isResult(result1)) return [
                        3,
                        5
                    ];
                    return [
                        2,
                        result1
                    ];
                case 5:
                    if (!nextResult) return [
                        3,
                        6
                    ];
                    return [
                        2,
                        result1 !== null && result1 !== void 0 ? result1 : nextResult.value
                    ];
                case 6:
                    _tmp = {};
                    return [
                        4,
                        next()
                    ];
                case 7:
                    nextResult = (_tmp.value = _state.sent(), _tmp);
                    return [
                        2,
                        nextResult.value
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    error = _state.sent();
                    return [
                        4,
                        errorHandler(error, routeId, nextResult)
                    ];
                case 10:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    })();
}
function getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    var lazyMiddlewarePromise = loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    var lazyRoutePromises = loadLazyRoute(match.route, isMutationMethod(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad) {
    var shouldRevalidateArgs = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : null, callSiteDefaultShouldRevalidate = arguments.length > 10 ? arguments[10] : void 0;
    var isUsingNewApi = false;
    var _lazyPromises = getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return (0, $lf4fc._)((0, $hwO3w._)({}, match), {
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler: function(defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return shouldRevalidateLoader(match, (0, $lf4fc._)((0, $hwO3w._)({}, shouldRevalidateArgs), {
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            }));
            if (typeof defaultShouldRevalidate === "boolean") return shouldRevalidateLoader(match, (0, $lf4fc._)((0, $hwO3w._)({}, shouldRevalidateArgs), {
                defaultShouldRevalidate: defaultShouldRevalidate
            }));
            return shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve: function(handlerOverride) {
            var _match_route = match.route, lazy = _match_route.lazy, loader = _match_route.loader, middleware = _match_route.middleware;
            var callHandler = isUsingNewApi || shouldLoad || handlerOverride && !isMutationMethod(request.method) && (lazy || loader);
            var isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && (isMutationMethod(request.method) || !isMiddlewareOnlyRoute)) return callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.handler,
                lazyRoutePromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    });
}
function getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext) {
    var shouldRevalidateArgs = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : null;
    return matches.map(function(match) {
        if (match.route.id !== targetMatch.route.id) return (0, $lf4fc._)((0, $hwO3w._)({}, match), {
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: function() {
                return false;
            },
            _lazyPromises: getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: function() {
                return Promise.resolve({
                    type: "data",
                    result: void 0
                });
            }
        });
        return getDataStrategyMatch(mapRouteProperties2, manifest, request, path, getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
function callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var dataStrategyArgs, runClientMiddleware, results, e;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!matches.some(function(m) {
                        var _m__lazyPromises;
                        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
                    })) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.all(matches.map(function(m) {
                            var _m__lazyPromises;
                            return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
                        }))
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    dataStrategyArgs = {
                        request: request,
                        url: createDataFunctionUrl(request, path),
                        pattern: getRoutePattern(matches),
                        params: matches[0].params,
                        context: scopedContext,
                        matches: matches
                    };
                    runClientMiddleware = isStaticHandler ? function() {
                        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
                    } : function(cb) {
                        var typedDataStrategyArgs = dataStrategyArgs;
                        return runClientMiddlewarePipeline(typedDataStrategyArgs, function() {
                            return cb((0, $lf4fc._)((0, $hwO3w._)({}, typedDataStrategyArgs), {
                                fetcherKey: fetcherKey,
                                runClientMiddleware: function() {
                                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                                }
                            }));
                        });
                    };
                    return [
                        4,
                        dataStrategyImpl((0, $lf4fc._)((0, $hwO3w._)({}, dataStrategyArgs), {
                            fetcherKey: fetcherKey,
                            runClientMiddleware: runClientMiddleware
                        }))
                    ];
                case 3:
                    results = _state.sent();
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        Promise.all(matches.flatMap(function(m) {
                            var _m__lazyPromises, _m__lazyPromises1;
                            return [
                                (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.handler,
                                (_m__lazyPromises1 = m._lazyPromises) === null || _m__lazyPromises1 === void 0 ? void 0 : _m__lazyPromises1.route
                            ];
                        }))
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    e = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function callLoaderOrAction(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(param) {
        var request, path, pattern, match, lazyHandlerPromise, lazyRoutePromise, handlerOverride, scopedContext, result, onReject, isAction, type, runHandler, handler, handlerError, _ref, value, handler2, ref, url, pathname, url1, pathname1, e;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = param.request, path = param.path, pattern = param.pattern, match = param.match, lazyHandlerPromise = param.lazyHandlerPromise, lazyRoutePromise = param.lazyRoutePromise, handlerOverride = param.handlerOverride, scopedContext = param.scopedContext;
                    isAction = isMutationMethod(request.method);
                    type = isAction ? "action" : "loader";
                    runHandler = function(handler) {
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error('You cannot call the handler for a route which defines a boolean "'.concat(type, '" [routeId: ').concat(match.route.id, "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    url: createDataFunctionUrl(request, path),
                                    pattern: pattern,
                                    params: match.params,
                                    context: scopedContext
                                }
                            ].concat((0, $XnYkK._)(ctx !== void 0 ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise = function() {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var val, e;
                                return (0, $3SMYb._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                handlerOverride ? handlerOverride(function(ctx) {
                                                    return actualHandler(ctx);
                                                }) : actualHandler()
                                            ];
                                        case 1:
                                            val = _state.sent();
                                            return [
                                                2,
                                                {
                                                    type: "data",
                                                    result: val
                                                }
                                            ];
                                        case 2:
                                            e = _state.sent();
                                            return [
                                                2,
                                                {
                                                    type: "error",
                                                    result: e
                                                }
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = isAction ? match.route.action : match.route.loader;
                    if (!(lazyHandlerPromise || lazyRoutePromise)) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            // Ensure all lazy route promises are resolved before continuing
                            lazyHandlerPromise,
                            lazyRoutePromise
                        ])
                    ];
                case 2:
                    _ref = (0, $6iP9u._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== void 0) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    return [
                        4,
                        lazyHandlerPromise
                    ];
                case 4:
                    _state.sent();
                    handler2 = isAction ? match.route.action : match.route.loader;
                    if (!handler2) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        Promise.all([
                            runHandler(handler2),
                            lazyRoutePromise
                        ])
                    ];
                case 5:
                    ref = (0, $6iP9u._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), result = ref[0], ref;
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else return [
                        2,
                        {
                            type: "data" /* data */ ,
                            result: void 0
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: "error" /* error */ ,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).apply(this, arguments);
}
function parseResponseBody(response) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var contentType;
        return (0, $3SMYb._)(this, function(_state) {
            contentType = response.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) return [
                2,
                response.body == null ? null : response.json()
            ];
            return [
                2,
                response.text()
            ];
        });
    })();
}
function convertDataStrategyResultToDataResult(dataStrategyResult) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _result_init, _result_init1, result, type, data2, e, _result_init2, _result_init3, _result_init4;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = dataStrategyResult.result, type = dataStrategyResult.type;
                    if (!isResponse(result)) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        parseResponseBody(result)
                    ];
                case 2:
                    data2 = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: "error" /* error */ ,
                            error: e
                        }
                    ];
                case 4:
                    if (type === "error" /* error */ ) return [
                        2,
                        {
                            type: "error" /* error */ ,
                            error: new ErrorResponseImpl(result.status, result.statusText, data2),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: data2,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 5:
                    if (type === "error" /* error */ ) {
                        if (isDataWithResponseInit(result)) {
                            ;
                            if (result.data instanceof Error) return [
                                2,
                                {
                                    type: "error" /* error */ ,
                                    error: result.data,
                                    statusCode: (_result_init2 = result.init) === null || _result_init2 === void 0 ? void 0 : _result_init2.status,
                                    headers: ((_result_init3 = result.init) === null || _result_init3 === void 0 ? void 0 : _result_init3.headers) ? new Headers(result.init.headers) : void 0
                                }
                            ];
                            return [
                                2,
                                {
                                    type: "error" /* error */ ,
                                    error: dataWithResponseInitToErrorResponse(result),
                                    statusCode: isRouteErrorResponse(result) ? result.status : void 0,
                                    headers: ((_result_init4 = result.init) === null || _result_init4 === void 0 ? void 0 : _result_init4.headers) ? new Headers(result.init.headers) : void 0
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                type: "error" /* error */ ,
                                error: result,
                                statusCode: isRouteErrorResponse(result) ? result.status : void 0
                            }
                        ];
                    }
                    if (isDataWithResponseInit(result)) return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: result.data,
                            statusCode: (_result_init = result.init) === null || _result_init === void 0 ? void 0 : _result_init.status,
                            headers: ((_result_init1 = result.init) === null || _result_init1 === void 0 ? void 0 : _result_init1.headers) ? new Headers(result.init.headers) : void 0
                        }
                    ];
                    return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: result
                        }
                    ];
            }
        });
    })();
}
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    var location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!isAbsoluteUrl(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function hasInvalidProtocol(location) {
    try {
        return invalidProtocols.includes(new URL(location).protocol);
    } catch (e) {
        return false;
    }
}
function normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if (isAbsoluteUrl(location)) {
        var normalizedLocation = location;
        var url = PROTOCOL_RELATIVE_URL_REGEX.test(normalizedLocation) ? new URL(normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if (hasInvalidProtocol(url.toString())) throw new Error("Invalid redirect location");
        var isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        var url1 = historyInstance.createURL(location);
        if (hasInvalidProtocol(url1.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function createDataFunctionUrl(request, path) {
    var url = new URL(request.url);
    var parsed = typeof path === "string" ? parsePath(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        var searchParams = new URLSearchParams(parsed.search);
        var indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = indexValues.filter(Boolean)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                searchParams.append("index", value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        url.search = searchParams.size ? "?".concat(searchParams.toString()) : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6iP9u._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6iP9u._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult) {
    var isStaticHandler = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, skipLoaderErrorBubbling = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach(function(match) {
        if (!(match.route.id in results)) return;
        var id = match.route.id;
        var result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            var error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                var boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = (0, $dUlz9._)({}, pendingActionResult[0], pendingError);
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    var _processRouteLoaderData = processRouteLoaderData(matches, results, pendingActionResult), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    revalidatingFetchers.filter(function(f) {
        return !f.matches || f.matches.some(function(m) {
            return m.shouldLoad;
        });
    }).forEach(function(rf) {
        var key = rf.key, match = rf.match, controller = rf.controller;
        if (controller && controller.signal.aborted) return;
        var result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match === null || match === void 0 ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = (0, $lf4fc._)((0, $hwO3w._)({}, errors), (0, $dUlz9._)({}, boundaryMatch.route.id, result.error));
            workingFetchers.delete(key);
        } else if (isRedirectResult(result)) invariant(false, "Unhandled fetcher revalidation redirect");
        else {
            var doneFetcher = getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = Object.entries(newLoaderData).filter(function(param) {
        var _param = (0, $6iP9u._)(param, 2), v = _param[1];
        return v !== ResetLoaderDataSymbol;
    }).reduce(function(merged, param) {
        var _param = (0, $6iP9u._)(param, 2), k = _param[0], v = _param[1];
        merged[k] = v;
        return merged;
    }, {});
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $dUlz9._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $XnYkK._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function getInternalRouterError(status) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a ".concat(method, ' request to "').concat(pathname, '" but did not provide a `loader` for route "').concat(routeId, '", so there is no way to handle the request.');
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "'.concat(routeId, '" does not match URL "').concat(pathname, '"');
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "'.concat(pathname, '"');
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a ".concat(method.toUpperCase(), ' request to "').concat(pathname, '" but did not provide an `action` for route "').concat(routeId, '", so there is no way to handle the request.');
        else if (method) errorMessage = 'Invalid request method "'.concat(method.toUpperCase(), '"');
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
function findRedirect(results) {
    var entries = Object.entries(results);
    for(var i = entries.length - 1; i >= 0; i--){
        var _entries_i = (0, $6iP9u._)(entries[i], 2), key = _entries_i[0], result = _entries_i[1];
        if (isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath((0, $lf4fc._)((0, $hwO3w._)({}, parsedPath), {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function dataWithResponseInitToResponse(data2) {
    var _data2_init;
    return Response.json(data2.data, (_data2_init = data2.init) !== null && _data2_init !== void 0 ? _data2_init : void 0);
}
function dataWithResponseInitToErrorResponse(data2) {
    var _data2_init, _data2_init1;
    var _data2_init_status, _data2_init_statusText;
    return new ErrorResponseImpl((_data2_init_status = (_data2_init = data2.init) === null || _data2_init === void 0 ? void 0 : _data2_init.status) !== null && _data2_init_status !== void 0 ? _data2_init_status : 500, (_data2_init_statusText = (_data2_init1 = data2.init) === null || _data2_init1 === void 0 ? void 0 : _data2_init1.statusText) !== null && _data2_init_statusText !== void 0 ? _data2_init_statusText : "Internal Server Error", data2.data);
}
function isDataStrategyResults(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $03bAP._)(result)) === "object" && Object.entries(result).every(function(param) {
        var _param = (0, $6iP9u._)(param, 2), key = _param[0], value = _param[1];
        return typeof key === "string" && isDataStrategyResult(value);
    });
}
function isDataStrategyResult(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $03bAP._)(result)) === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function isRedirectDataStrategyResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function isDataWithResponseInit(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && (0, $03bAP._)(value.headers) === "object" && typeof value.body !== "undefined";
}
function isRedirectStatusCode(statusCode) {
    return redirectStatusCodes.has(statusCode);
}
function isRedirectResponse(result) {
    return isResponse(result) && isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toUpperCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toUpperCase());
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation1;
    }
}
function getSubmittingNavigation(location, matches, historyAction, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data2) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher1;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function getDoneFetcher(data2) {
    var fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $6iP9u._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {}
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $6iP9u._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $XnYkK._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (".concat(error, ")."));
        }
    }
}
function createDeferred() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = function(val) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var e;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            res(val);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        reject = function(error) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var e;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rej(error);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
    });
    return {
        promise: promise,
        //@ts-ignore
        resolve: resolve,
        //@ts-ignore
        reject: reject
    };
}
var DataRouterContext = $5s1kH.createContext(null);
DataRouterContext.displayName = "DataRouter";
var DataRouterStateContext = $5s1kH.createContext(null);
DataRouterStateContext.displayName = "DataRouterState";
var RSCRouterContext = $5s1kH.createContext(false);
function useIsRSCRouterContext() {
    return $5s1kH.useContext(RSCRouterContext);
}
var ViewTransitionContext = $5s1kH.createContext({
    isTransitioning: false
});
ViewTransitionContext.displayName = "ViewTransition";
var FetchersContext = $5s1kH.createContext(/* @__PURE__ */ new Map());
FetchersContext.displayName = "Fetchers";
var AwaitContext = $5s1kH.createContext(null);
AwaitContext.displayName = "Await";
var AwaitContextProvider = function(props) {
    return $5s1kH.createElement(AwaitContext.Provider, props);
};
var NavigationContext = $5s1kH.createContext(null);
NavigationContext.displayName = "Navigation";
var LocationContext = $5s1kH.createContext(null);
LocationContext.displayName = "Location";
var RouteContext = $5s1kH.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
RouteContext.displayName = "Route";
var RouteErrorContext = $5s1kH.createContext(null);
RouteErrorContext.displayName = "RouteError";
var ENABLE_DEV_WARNINGS = true;
// lib/errors.ts
var ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var ERROR_DIGEST_REDIRECT = "REDIRECT";
var ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function decodeRedirectErrorDigest(digest) {
    if (digest.startsWith("".concat(ERROR_DIGEST_BASE, ":").concat(ERROR_DIGEST_REDIRECT, ":{"))) try {
        var parsed = JSON.parse(digest.slice(28));
        if ((typeof parsed === "undefined" ? "undefined" : (0, $03bAP._)(parsed)) === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch (e) {}
}
function decodeRouteErrorResponseDigest(digest) {
    if (digest.startsWith("".concat(ERROR_DIGEST_BASE, ":").concat(ERROR_DIGEST_ROUTE_ERROR_RESPONSE, ":{"))) try {
        var parsed = JSON.parse(digest.slice(40));
        if ((typeof parsed === "undefined" ? "undefined" : (0, $03bAP._)(parsed)) === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new ErrorResponseImpl(parsed.status, parsed.statusText, parsed.data);
    } catch (e) {}
}
// lib/hooks.tsx
function useHref(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    invariant(useInRouterContext(), "useHref() may be used only in the context of a <Router> component.");
    var _React2_useContext = $5s1kH.useContext(NavigationContext), basename = _React2_useContext.basename, navigator = _React2_useContext.navigator;
    var _useResolvedPath = useResolvedPath(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function useInRouterContext() {
    return $5s1kH.useContext(LocationContext) != null;
}
function useLocation() {
    invariant(useInRouterContext(), "useLocation() may be used only in the context of a <Router> component.");
    return $5s1kH.useContext(LocationContext).location;
}
function useNavigationType() {
    return $5s1kH.useContext(LocationContext).navigationType;
}
function useMatch(pattern) {
    invariant(useInRouterContext(), "useMatch() may be used only in the context of a <Router> component.");
    var pathname = useLocation().pathname;
    return $5s1kH.useMemo(function() {
        return matchPath(pattern, decodePath(pathname));
    }, [
        pathname,
        pattern
    ]);
}
var navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function useIsomorphicLayoutEffect(cb) {
    var isStatic = $5s1kH.useContext(NavigationContext).static;
    if (!isStatic) $5s1kH.useLayoutEffect(cb);
}
function useNavigate() {
    var isDataRoute = $5s1kH.useContext(RouteContext).isDataRoute;
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    invariant(useInRouterContext(), "useNavigate() may be used only in the context of a <Router> component.");
    var dataRouterContext = $5s1kH.useContext(DataRouterContext);
    var _React2_useContext = $5s1kH.useContext(NavigationContext), basename = _React2_useContext.basename, navigator = _React2_useContext.navigator;
    var matches = $5s1kH.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    var activeRef = $5s1kH.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $5s1kH.useCallback(function(to) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        warning(activeRef.current, navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var OutletContext = $5s1kH.createContext(null);
function useOutletContext() {
    return $5s1kH.useContext(OutletContext);
}
function useOutlet(context) {
    var outlet = $5s1kH.useContext(RouteContext).outlet;
    return $5s1kH.useMemo(function() {
        return outlet && /* @__PURE__ */ $5s1kH.createElement(OutletContext.Provider, {
            value: context
        }, outlet);
    }, [
        outlet,
        context
    ]);
}
function useParams() {
    var matches = $5s1kH.useContext(RouteContext).matches;
    var routeMatch = matches[matches.length - 1];
    var _routeMatch_params;
    return (_routeMatch_params = routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.params) !== null && _routeMatch_params !== void 0 ? _routeMatch_params : {};
}
function useResolvedPath(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var matches = $5s1kH.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    return $5s1kH.useMemo(function() {
        return resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
function useRoutesImpl(routes, locationArg, dataRouterOpts) {
    invariant(useInRouterContext(), "useRoutes() may be used only in the context of a <Router> component.");
    var navigator = $5s1kH.useContext(NavigationContext).navigator;
    var _React2_useContext = $5s1kH.useContext(RouteContext), parentMatches = _React2_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    if (ENABLE_DEV_WARNINGS) {
        var parentPath = parentRoute && parentRoute.path || "";
        warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), 'You rendered descendant <Routes> (or called `useRoutes()`) at "'.concat(parentPathname, '" (under <Route path="').concat(parentPath, '">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won\'t match anymore and therefore the child routes will never render.\n\nPlease change the parent <Route path="').concat(parentPath, '"> to <Route path="').concat(parentPath === "/" ? "*" : "".concat(parentPath, "/*"), '">.'));
    }
    var locationFromContext = useLocation();
    var location;
    if (locationArg) {
        var _parsedLocationArg_pathname;
        var parsedLocationArg = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
        invariant(parentPathnameBase === "/" || ((_parsedLocationArg_pathname = parsedLocationArg.pathname) === null || _parsedLocationArg_pathname === void 0 ? void 0 : _parsedLocationArg_pathname.startsWith(parentPathnameBase)), 'When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "'.concat(parentPathnameBase, '" but pathname "').concat(parsedLocationArg.pathname, '" was given in the `location` prop.'));
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map(function(m) {
        return Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        });
    }) : matchRoutes(routes, {
        pathname: remainingPathname
    });
    if (ENABLE_DEV_WARNINGS) {
        warning(parentRoute || matches != null, 'No routes matched location "'.concat(location.pathname).concat(location.search).concat(location.hash, '" '));
        warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, 'Matched leaf route at location "'.concat(location.pathname).concat(location.search).concat(location.hash, '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.'));
    }
    var renderedMatches = _renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $5s1kH.createElement(LocationContext.Provider, {
        value: {
            location: (0, $hwO3w._)({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0
            }, location),
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    var error = useRouteError();
    var message = isRouteErrorResponse(error) ? "".concat(error.status, " ").concat(error.statusText) : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    if (ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, /* @__PURE__ */ $5s1kH.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $5s1kH.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $5s1kH.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $5s1kH.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, /* @__PURE__ */ $5s1kH.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $5s1kH.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $5s1kH.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var defaultErrorElement = /* @__PURE__ */ $5s1kH.createElement(DefaultErrorComponent, null);
var RenderErrorBoundary = /*#__PURE__*/ function(_React2_Component) {
    "use strict";
    (0, $4QAx6._)(RenderErrorBoundary, _React2_Component);
    function RenderErrorBoundary(props) {
        (0, $5Epmf._)(this, RenderErrorBoundary);
        var _this;
        _this = (0, $48Z0s._)(this, RenderErrorBoundary, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $9MqXK._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                if (this.props.onError) this.props.onError(error, errorInfo);
                else console.error("React Router caught the following error during render", error);
            }
        },
        {
            key: "render",
            value: function render() {
                var error = this.state.error;
                if (this.context && (typeof error === "undefined" ? "undefined" : (0, $03bAP._)(error)) === "object" && error && "digest" in error && typeof error.digest === "string") {
                    var decoded = decodeRouteErrorResponseDigest(error.digest);
                    if (decoded) error = decoded;
                }
                var result = error !== void 0 ? /* @__PURE__ */ $5s1kH.createElement(RouteContext.Provider, {
                    value: this.props.routeContext
                }, /* @__PURE__ */ $5s1kH.createElement(RouteErrorContext.Provider, {
                    value: error,
                    children: this.props.component
                })) : this.props.children;
                if (this.context) return /* @__PURE__ */ $5s1kH.createElement(RSCErrorHandler, {
                    error: error
                }, result);
                return result;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                return {
                    error: props.error !== void 0 ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($5s1kH.Component);
RenderErrorBoundary.contextType = RSCRouterContext;
var errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function RSCErrorHandler(param) {
    var children = param.children, error = param.error;
    var basename = $5s1kH.useContext(NavigationContext).basename;
    if ((typeof error === "undefined" ? "undefined" : (0, $03bAP._)(error)) === "object" && error && "digest" in error && typeof error.digest === "string") {
        var redirect2 = decodeRedirectErrorDigest(error.digest);
        if (redirect2) {
            var existingRedirect = errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            var parsed = parseToInfo(redirect2.location, basename);
            var target = parsed.absoluteURL || parsed.to;
            if (hasInvalidProtocol(target)) throw new Error("Invalid redirect location");
            if (isBrowser && !errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    var redirectPromise = Promise.resolve().then(function() {
                        return window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        });
                    });
                    errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $5s1kH.createElement("meta", {
                httpEquiv: "refresh",
                content: "0;url=".concat(target)
            });
        }
    }
    return children;
}
function RenderedRoute(param) {
    var routeContext = param.routeContext, match = param.match, children = param.children;
    var dataRouterContext = $5s1kH.useContext(DataRouterContext);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $5s1kH.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches) {
    var parentMatches = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], dataRouterOpts = arguments.length > 2 ? arguments[2] : void 0;
    var dataRouterState = dataRouterOpts === null || dataRouterOpts === void 0 ? void 0 : dataRouterOpts.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    var errors = dataRouterState === null || dataRouterState === void 0 ? void 0 : dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors === null || errors === void 0 ? void 0 : errors[m.route.id]) !== void 0;
        });
        invariant(errorIndex >= 0, "Could not find a matching route for errors on route IDs: ".concat(Object.keys(errors).join(",")));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(var i = 0; i < renderedMatches.length; i++){
            var match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                var loaderData = dataRouterState.loaderData, errors2 = dataRouterState.errors;
                var needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    var onErrorHandler = dataRouterOpts === null || dataRouterOpts === void 0 ? void 0 : dataRouterOpts.onError;
    var onError = dataRouterState && onErrorHandler ? function(error, errorInfo) {
        var _dataRouterState_matches_, _dataRouterState_matches;
        var _dataRouterState_matches__params;
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: (_dataRouterState_matches__params = (_dataRouterState_matches = dataRouterState.matches) === null || _dataRouterState_matches === void 0 ? void 0 : (_dataRouterState_matches_ = _dataRouterState_matches[0]) === null || _dataRouterState_matches_ === void 0 ? void 0 : _dataRouterState_matches_.params) !== null && _dataRouterState_matches__params !== void 0 ? _dataRouterState_matches__params : {},
            pattern: getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $5s1kH.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $5s1kH.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $5s1kH.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function getDataRouterConsoleError(hookName) {
    return "".concat(hookName, " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.");
}
function useDataRouterContext(hookName) {
    var ctx = $5s1kH.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError(hookName));
    return ctx;
}
function useDataRouterState(hookName) {
    var state = $5s1kH.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError(hookName));
    return state;
}
function useRouteContext(hookName) {
    var route = $5s1kH.useContext(RouteContext);
    invariant(route, getDataRouterConsoleError(hookName));
    return route;
}
function useCurrentRouteId(hookName) {
    var route = useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    invariant(thisRoute.route.id, "".concat(hookName, ' can only be used on routes that contain a unique "id"'));
    return thisRoute.route.id;
}
function useRouteId() {
    return useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function useNavigation() {
    var state = useDataRouterState("useNavigation" /* UseNavigation */ );
    return $5s1kH.useMemo(function() {
        var _state_navigation = state.navigation, matches = _state_navigation.matches, historyAction = _state_navigation.historyAction, rest = (0, $54Czb._)(_state_navigation, [
            "matches",
            "historyAction"
        ]);
        return rest;
    }, [
        state.navigation
    ]);
}
function useRevalidator() {
    var dataRouterContext = useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    var state = useDataRouterState("useRevalidator" /* UseRevalidator */ );
    var revalidate = $5s1kH.useCallback(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dataRouterContext.router.revalidate()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        dataRouterContext.router
    ]);
    return $5s1kH.useMemo(function() {
        return {
            revalidate: revalidate,
            state: state.revalidation
        };
    }, [
        revalidate,
        state.revalidation
    ]);
}
function useMatches() {
    var _useDataRouterState = useDataRouterState("useMatches" /* UseMatches */ ), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $5s1kH.useMemo(function() {
        return matches.map(function(m) {
            return convertRouteMatchToUiMatch(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
function useLoaderData() {
    var state = useDataRouterState("useLoaderData" /* UseLoaderData */ );
    var routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function useRouteLoaderData(routeId) {
    var state = useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function useActionData() {
    var state = useDataRouterState("useActionData" /* UseActionData */ );
    var routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function useRouteError() {
    var _state_errors;
    var error = $5s1kH.useContext(RouteErrorContext);
    var state = useDataRouterState("useRouteError" /* UseRouteError */ );
    var routeId = useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return (_state_errors = state.errors) === null || _state_errors === void 0 ? void 0 : _state_errors[routeId];
}
function useAsyncValue() {
    var value = $5s1kH.useContext(AwaitContext);
    return value === null || value === void 0 ? void 0 : value._data;
}
function useAsyncError() {
    var value = $5s1kH.useContext(AwaitContext);
    return value === null || value === void 0 ? void 0 : value._error;
}
var blockerId = 0;
function useBlocker(shouldBlock) {
    var _useDataRouterContext = useDataRouterContext("useBlocker" /* UseBlocker */ ), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = useDataRouterState("useBlocker" /* UseBlocker */ );
    var _React2_useState = (0, $6iP9u._)($5s1kH.useState(""), 2), blockerKey = _React2_useState[0], setBlockerKey = _React2_useState[1];
    var blockerFunction = $5s1kH.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: (0, $lf4fc._)((0, $hwO3w._)({}, currentLocation), {
                pathname: stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: (0, $lf4fc._)((0, $hwO3w._)({}, nextLocation), {
                pathname: stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $5s1kH.useEffect(function() {
        var key = String(++blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    $5s1kH.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : IDLE_BLOCKER;
}
function useNavigateStable() {
    var router = useDataRouterContext("useNavigate" /* UseNavigateStable */ ).router;
    var id = useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    var activeRef = $5s1kH.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $5s1kH.useCallback(function(to) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        warning(activeRef.current, navigateEffectWarning);
                        if (!activeRef.current) return [
                            2
                        ];
                        if (!(typeof to === "number")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            router.navigate(to)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            router.navigate(to, (0, $hwO3w._)({
                                fromRouteId: id
                            }, options))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        router,
        id
    ]);
    return navigate;
}
var alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) {
        alreadyWarned[key] = true;
        warning(false, message);
    }
}
function useRoute() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _state_actionData;
    var currentRouteId = useCurrentRouteId("useRoute" /* UseRoute */ );
    var _args_;
    var id = (_args_ = args[0]) !== null && _args_ !== void 0 ? _args_ : currentRouteId;
    var state = useDataRouterState("useRoute" /* UseRoute */ );
    var route = state.matches.find(function(param) {
        var route2 = param.route;
        return route2.id === id;
    });
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: (_state_actionData = state.actionData) === null || _state_actionData === void 0 ? void 0 : _state_actionData[id]
    };
}
function toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function useRouterState() {
    var _useDataRouterState = useDataRouterState("unstable_useRouterState" /* UseRouterState */ ), location = _useDataRouterState.location, type = _useDataRouterState.historyAction, matches = _useDataRouterState.matches, navigation = _useDataRouterState.navigation;
    var active = $5s1kH.useMemo(function() {
        var _matches_;
        var _matches__params;
        return {
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: (_matches__params = (_matches_ = matches[matches.length - 1]) === null || _matches_ === void 0 ? void 0 : _matches_.params) !== null && _matches__params !== void 0 ? _matches__params : {},
            matches: matches.map(function(m) {
                return toRouterStateMatch(m);
            })
        };
    }, [
        location,
        matches,
        type
    ]);
    var pending = $5s1kH.useMemo(function() {
        var _navigation_matches_;
        if (navigation.state === "idle") return null;
        var _navigation_matches__params;
        var shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: (_navigation_matches__params = (_navigation_matches_ = navigation.matches[navigation.matches.length - 1]) === null || _navigation_matches_ === void 0 ? void 0 : _navigation_matches_.params) !== null && _navigation_matches__params !== void 0 ? _navigation_matches__params : {},
            matches: navigation.matches.map(function(m) {
                return toRouterStateMatch(m);
            })
        };
        return navigation.state === "loading" ? (0, $lf4fc._)((0, $hwO3w._)({}, shared), {
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        }) : (0, $lf4fc._)((0, $hwO3w._)({}, shared), {
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        });
    }, [
        navigation
    ]);
    return $5s1kH.useMemo(function() {
        return {
            active: active,
            pending: pending
        };
    }, [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var alreadyWarned2 = {};
function warnOnce(condition, message) {
    if (!condition && !alreadyWarned2[message]) {
        alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var USE_OPTIMISTIC = "useOptimistic";
var useOptimisticImpl = $5s1kH[USE_OPTIMISTIC];
var stableUseOptimisticSetter = function() {
    return void 0;
};
function useOptimisticSafe(val) {
    if (useOptimisticImpl) return useOptimisticImpl(val);
    else return [
        val,
        stableUseOptimisticSetter
    ];
}
function mapRouteProperties(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.element) warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $5s1kH.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.hydrateFallbackElement) warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $5s1kH.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.errorElement) warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $5s1kH.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var hydrationRouteProperties = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function createMemoryRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createMemoryHistory({
            initialEntries: opts === null || opts === void 0 ? void 0 : opts.initialEntries,
            initialIndex: opts === null || opts === void 0 ? void 0 : opts.initialIndex
        }),
        hydrationData: opts === null || opts === void 0 ? void 0 : opts.hydrationData,
        routes: routes,
        hydrationRouteProperties: hydrationRouteProperties,
        mapRouteProperties: mapRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
var Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $5Epmf._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
function RouterProvider(param) {
    var router = param.router, reactDomFlushSyncImpl = param.flushSync, onError = param.onError, useTransitions = param.useTransitions;
    var unstable_rsc = useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    var _React3_useState = (0, $6iP9u._)($5s1kH.useState(router.state), 2), _state = _React3_useState[0], setStateImpl = _React3_useState[1];
    var _useOptimisticSafe = (0, $6iP9u._)(useOptimisticSafe(_state), 2), state = _useOptimisticSafe[0], setOptimisticState = _useOptimisticSafe[1];
    var _React3_useState1 = (0, $6iP9u._)($5s1kH.useState(), 2), pendingState = _React3_useState1[0], setPendingState = _React3_useState1[1];
    var _React3_useState2 = (0, $6iP9u._)($5s1kH.useState({
        isTransitioning: false
    }), 2), vtContext = _React3_useState2[0], setVtContext = _React3_useState2[1];
    var _React3_useState3 = (0, $6iP9u._)($5s1kH.useState(), 2), renderDfd = _React3_useState3[0], setRenderDfd = _React3_useState3[1];
    var _React3_useState4 = (0, $6iP9u._)($5s1kH.useState(), 2), transition = _React3_useState4[0], setTransition = _React3_useState4[1];
    var _React3_useState5 = (0, $6iP9u._)($5s1kH.useState(), 2), interruption = _React3_useState5[0], setInterruption = _React3_useState5[1];
    var fetcherData = $5s1kH.useRef(/* @__PURE__ */ new Map());
    var setState = $5s1kH.useCallback(function(newState, param) {
        var deletedFetchers = param.deletedFetchers, newErrors = param.newErrors, flushSync = param.flushSync, viewTransitionOpts = param.viewTransitionOpts;
        if (newErrors && onError) Object.values(newErrors).forEach(function(error) {
            var _newState_matches_;
            var _newState_matches__params;
            return onError(error, {
                location: newState.location,
                params: (_newState_matches__params = (_newState_matches_ = newState.matches[0]) === null || _newState_matches_ === void 0 ? void 0 : _newState_matches_.params) !== null && _newState_matches__params !== void 0 ? _newState_matches__params : {},
                pattern: getRoutePattern(newState.matches)
            });
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        var isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(function() {
                return setStateImpl(newState);
            });
            else if (useTransitions === false) setStateImpl(newState);
            else $5s1kH.startTransition(function() {
                if (useTransitions === true) setOptimisticState(function(s) {
                    return getOptimisticRouterState(s, newState);
                });
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(function() {
                if (transition) {
                    renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            var t = router.window.document.startViewTransition(function() {
                reactDomFlushSyncImpl(function() {
                    return setStateImpl(newState);
                });
            });
            t.finished.finally(function() {
                reactDomFlushSyncImpl(function() {
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(function() {
                return setTransition(t);
            });
            return;
        }
        if (transition) {
            renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $5s1kH.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $5s1kH.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    $5s1kH.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition2 = router.window.document.startViewTransition(function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (useTransitions === false) setStateImpl(newState);
                                else $5s1kH.startTransition(function() {
                                    if (useTransitions === true) setOptimisticState(function(s) {
                                        return getOptimisticRouterState(s, newState);
                                    });
                                    setStateImpl(newState);
                                });
                                return [
                                    4,
                                    renderPromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            });
            transition2.finished.finally(function() {
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $5s1kH.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $5s1kH.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    var navigator = $5s1kH.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state2, opts) {
                return router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state2, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $5s1kH.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        };
    }, [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, /* @__PURE__ */ $5s1kH.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $5s1kH.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ $5s1kH.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $5s1kH.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $5s1kH.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $5s1kH.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function getOptimisticRouterState(currentState, newState) {
    return (0, $lf4fc._)((0, $hwO3w._)({}, currentState), {
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    });
}
var MemoizedDataRoutes = $5s1kH.memo(DataRoutes2);
function DataRoutes2(param) {
    var routes = param.routes, manifest = param.manifest, future = param.future, state = param.state, isStatic = param.isStatic, onError = param.onError;
    return useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function MemoryRouter(param) {
    var basename = param.basename, children = param.children, initialEntries = param.initialEntries, initialIndex = param.initialIndex, useTransitions = param.useTransitions;
    var historyRef = $5s1kH.useRef();
    if (historyRef.current == null) historyRef.current = createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React3_useState = (0, $6iP9u._)($5s1kH.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React3_useState[0], setStateImpl = _React3_useState[1];
    var setState = $5s1kH.useCallback(function(newState) {
        if (useTransitions === false) setStateImpl(newState);
        else $5s1kH.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        useTransitions
    ]);
    $5s1kH.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $5s1kH.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function Navigate(param) {
    var to = param.to, replace2 = param.replace, state = param.state, relative = param.relative;
    invariant(useInRouterContext(), "<Navigate> may be used only in the context of a <Router> component.");
    var _React3_useContext = $5s1kH.useContext(NavigationContext), isStatic = _React3_useContext.static;
    warning(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    var matches = $5s1kH.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var navigate = useNavigate();
    var path = resolveTo(to, getResolveToMatches(matches), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $5s1kH.useEffect(function() {
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function Outlet(props) {
    return useOutlet(props.context);
}
function Route(props) {
    invariant(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
function Router(param) {
    var tmp = param.basename, basenameProp = tmp === void 0 ? "/" : tmp, _param_children = param.children, children = _param_children === void 0 ? null : _param_children, locationProp = param.location, _param_navigationType = param.navigationType, navigationType = _param_navigationType === void 0 ? "POP" /* Pop */  : _param_navigationType, navigator = param.navigator, tmp1 = param.static, staticProp = tmp1 === void 0 ? false : tmp1, useTransitions = param.useTransitions;
    invariant(!useInRouterContext(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $5s1kH.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        };
    }, [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key, mask = locationProp.mask;
    var locationContext = $5s1kH.useMemo(function() {
        var trailingPathname = stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    warning(locationContext != null, '<Router basename="'.concat(basename, '"> is not able to match the URL "').concat(pathname).concat(search).concat(hash, "\" because it does not start with the basename, so the <Router> won't render anything."));
    if (locationContext == null) return null;
    return /* @__PURE__ */ $5s1kH.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $5s1kH.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
function Routes(param) {
    var children = param.children, location = param.location;
    return useRoutes(createRoutesFromChildren(children), location);
}
function Await(param) {
    var children = param.children, errorElement = param.errorElement, resolve = param.resolve;
    var dataRouterContext = $5s1kH.useContext(DataRouterContext);
    var dataRouterStateContext = $5s1kH.useContext(DataRouterStateContext);
    var onError = $5s1kH.useCallback(function(error, errorInfo) {
        var _dataRouterStateContext_matches_;
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: ((_dataRouterStateContext_matches_ = dataRouterStateContext.matches[0]) === null || _dataRouterStateContext_matches_ === void 0 ? void 0 : _dataRouterStateContext_matches_.params) || {},
            pattern: getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $5s1kH.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $5s1kH.createElement(ResolveAwait, null, children));
}
var AwaitErrorBoundary = /*#__PURE__*/ function(_React3_Component) {
    "use strict";
    (0, $4QAx6._)(AwaitErrorBoundary, _React3_Component);
    function AwaitErrorBoundary(props) {
        (0, $5Epmf._)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, $48Z0s._)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $9MqXK._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                if (this.props.onError) this.props.onError(error, errorInfo);
                else console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = 0 /* pending */ ;
                if (!(resolve instanceof Promise)) {
                    status = 1 /* success */ ;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    status = 2 /* error */ ;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {});
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    promise = resolve;
                    status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
                } else {
                    status = 0 /* pending */ ;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data2) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data2;
                            }
                        });
                    }, function(error) {
                        var _this_props_onError, _this_props;
                        (_this_props_onError = (_this_props = _this.props).onError) === null || _this_props_onError === void 0 ? void 0 : _this_props_onError.call(_this_props, error);
                        Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === 2 /* error */  && !errorElement) throw promise._error;
                if (status === 2 /* error */ ) return /* @__PURE__ */ $5s1kH.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === 1 /* success */ ) return /* @__PURE__ */ $5s1kH.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($5s1kH.Component);
function ResolveAwait(param) {
    var children = param.children;
    var data2 = useAsyncValue();
    var toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, toRender);
}
function createRoutesFromChildren(children) {
    var parentPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var routes = [];
    $5s1kH.Children.forEach(children, function(element, index) {
        if (!$5s1kH.isValidElement(element)) return;
        var treePath = (0, $XnYkK._)(parentPath).concat([
            index
        ]);
        if (element.type === $5s1kH.Fragment) {
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        invariant(element.type === Route, "[".concat(typeof element.type === "string" ? element.type : element.type.name, "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>"));
        invariant(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var createRoutesFromElements = createRoutesFromChildren;
function renderMatches(matches) {
    return _renderMatches(matches);
}
function useRouteComponentProps() {
    return {
        params: useParams(),
        loaderData: useLoaderData(),
        actionData: useActionData(),
        matches: useMatches()
    };
}
function WithComponentProps(param) {
    var children = param.children;
    var props = useRouteComponentProps();
    return $5s1kH.cloneElement(children, props);
}
function withComponentProps(Component4) {
    return function WithComponentProps2() {
        var props = useRouteComponentProps();
        return $5s1kH.createElement(Component4, props);
    };
}
function useHydrateFallbackProps() {
    return {
        params: useParams(),
        loaderData: useLoaderData(),
        actionData: useActionData()
    };
}
function WithHydrateFallbackProps(param) {
    var children = param.children;
    var props = useHydrateFallbackProps();
    return $5s1kH.cloneElement(children, props);
}
function withHydrateFallbackProps(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        var props = useHydrateFallbackProps();
        return $5s1kH.createElement(HydrateFallback, props);
    };
}
function useErrorBoundaryProps() {
    return {
        params: useParams(),
        loaderData: useLoaderData(),
        actionData: useActionData(),
        error: useRouteError()
    };
}
function WithErrorBoundaryProps(param) {
    var children = param.children;
    var props = useErrorBoundaryProps();
    return $5s1kH.cloneElement(children, props);
}
function withErrorBoundaryProps(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        var props = useErrorBoundaryProps();
        return $5s1kH.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var defaultMethod = "get";
var defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event);
}
function createSearchParams() {
    var init = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo2, key) {
        var value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
var supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) {
        warning(false, '"'.concat(encType, '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` and will default to "').concat(defaultEncType, '"'));
        return null;
    }
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if (isFormElement(target)) {
        var attr = target.getAttribute("action");
        action = attr ? stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? stripBasename(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(form, target);
        if (!isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? "".concat(name, ".") : "";
                formData.append("".concat(prefix, "x"), "0");
                formData.append("".concat(prefix, "y"), "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var HOLE = -1;
var NAN = -2;
var NEGATIVE_INFINITY = -3;
var NEGATIVE_ZERO = -4;
var NULL = -5;
var POSITIVE_INFINITY = -6;
var UNDEFINED = -7;
var TYPE_BIGINT = "B";
var TYPE_DATE = "D";
var TYPE_ERROR = "E";
var TYPE_MAP = "M";
var TYPE_NULL_OBJECT = "N";
var TYPE_PROMISE = "P";
var TYPE_REGEXP = "R";
var TYPE_SET = "S";
var TYPE_SYMBOL = "Y";
var TYPE_URL = "U";
var TYPE_PREVIOUS_RESOLVED = "Z";
var Deferred2 = function Deferred2() {
    "use strict";
    var _this = this;
    (0, $5Epmf._)(this, Deferred2);
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
    });
};
function createLineSplittingTransform() {
    var decoder = new TextDecoder();
    var leftover = "";
    return new TransformStream({
        transform: function(chunk, controller) {
            var str = decoder.decode(chunk, {
                stream: true
            });
            var parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var part = _step.value;
                    controller.enqueue(part);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        flush: function(controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var TIME_LIMIT_MS = 1;
var getNow = function() {
    return Date.now();
};
var yieldToMain = function() {
    return new Promise(function(resolve) {
        return setTimeout(resolve, 0);
    });
};
function flatten(input) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var indices, existing, index, stack;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    indices = this.indices;
                    existing = indices.get(input);
                    if (existing) return [
                        2,
                        [
                            existing
                        ]
                    ];
                    if (input === void 0) return [
                        2,
                        UNDEFINED
                    ];
                    if (input === null) return [
                        2,
                        NULL
                    ];
                    if (Number.isNaN(input)) return [
                        2,
                        NAN
                    ];
                    if (input === Number.POSITIVE_INFINITY) return [
                        2,
                        POSITIVE_INFINITY
                    ];
                    if (input === Number.NEGATIVE_INFINITY) return [
                        2,
                        NEGATIVE_INFINITY
                    ];
                    if (input === 0 && 1 / input < 0) return [
                        2,
                        NEGATIVE_ZERO
                    ];
                    index = this.index++;
                    indices.set(input, index);
                    stack = [
                        [
                            input,
                            index
                        ]
                    ];
                    return [
                        4,
                        stringify.call(this, stack)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        index
                    ];
            }
        });
    }).call(this);
}
function stringify(stack) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _this, _this1, deferred, indices, plugins, postPlugins, str, lastYieldTime, flattenValue, i, now, _stack_pop, input, index, partsForObj, error, keyFor, isArray, pluginHandled, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, plugin, pluginResult, _pluginResult, pluginIdentifier, rest, result, i2, dateTime, isArray1, pluginHandled1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, plugin1, pluginResult1, _pluginResult1, pluginIdentifier1, rest1, pluginHandled2, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, plugin2, pluginResult2, _pluginResult2, pluginIdentifier2, rest2;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this;
                    _this1 = this, deferred = _this1.deferred, indices = _this1.indices, plugins = _this1.plugins, postPlugins = _this1.postPlugins;
                    str = this.stringified;
                    lastYieldTime = getNow();
                    flattenValue = function(value) {
                        var existing = indices.get(value);
                        if (existing) return [
                            existing
                        ];
                        if (value === void 0) return UNDEFINED;
                        if (value === null) return NULL;
                        if (Number.isNaN(value)) return NAN;
                        if (value === Number.POSITIVE_INFINITY) return POSITIVE_INFINITY;
                        if (value === Number.NEGATIVE_INFINITY) return NEGATIVE_INFINITY;
                        if (value === 0 && 1 / value < 0) return NEGATIVE_ZERO;
                        var index = _this.index++;
                        indices.set(value, index);
                        stack.push([
                            value,
                            index
                        ]);
                        return index;
                    };
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(stack.length > 0)) return [
                        3,
                        4
                    ];
                    now = getNow();
                    if (!(++i % 6e3 === 0 && now - lastYieldTime >= TIME_LIMIT_MS)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        yieldToMain()
                    ];
                case 2:
                    _state.sent();
                    lastYieldTime = getNow();
                    _state.label = 3;
                case 3:
                    _stack_pop = (0, $6iP9u._)(stack.pop(), 2), input = _stack_pop[0], index = _stack_pop[1];
                    partsForObj = function(obj) {
                        return Object.keys(obj).map(function(k) {
                            return '"_'.concat(flattenValue(k), '":').concat(flattenValue(obj[k]));
                        }).join(",");
                    };
                    error = null;
                    switch(typeof input === "undefined" ? "undefined" : (0, $03bAP._)(input)){
                        case "boolean":
                        case "number":
                        case "string":
                            str[index] = JSON.stringify(input);
                            break;
                        case "bigint":
                            str[index] = '["'.concat(TYPE_BIGINT, '","').concat(input, '"]');
                            break;
                        case "symbol":
                            {
                                keyFor = Symbol.keyFor(input);
                                if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                                else str[index] = '["'.concat(TYPE_SYMBOL, '",').concat(JSON.stringify(keyFor), "]");
                                break;
                            }
                        case "object":
                            {
                                if (!input) {
                                    str[index] = "".concat(NULL);
                                    break;
                                }
                                isArray = Array.isArray(input);
                                pluginHandled = false;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!isArray && plugins) try {
                                    for(_iterator = plugins[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        plugin = _step.value;
                                        pluginResult = plugin(input);
                                        if (Array.isArray(pluginResult)) {
                                            pluginHandled = true;
                                            _pluginResult = (0, $1SnSh._)(pluginResult), pluginIdentifier = _pluginResult[0], rest = _pluginResult.slice(1);
                                            str[index] = "[".concat(JSON.stringify(pluginIdentifier));
                                            if (rest.length > 0) str[index] += ",".concat(rest.map(function(v) {
                                                return flattenValue(v);
                                            }).join(","));
                                            str[index] += "]";
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (!pluginHandled) {
                                    result = isArray ? "[" : "{";
                                    if (isArray) {
                                        for(i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : HOLE);
                                        str[index] = "".concat(result, "]");
                                    } else if (input instanceof Date) {
                                        dateTime = input.getTime();
                                        str[index] = '["'.concat(TYPE_DATE, '",').concat(Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime, "]");
                                    } else if (input instanceof URL) str[index] = '["'.concat(TYPE_URL, '",').concat(JSON.stringify(input.href), "]");
                                    else if (input instanceof RegExp) str[index] = '["'.concat(TYPE_REGEXP, '",').concat(JSON.stringify(input.source), ",").concat(JSON.stringify(input.flags), "]");
                                    else if (input instanceof Set) {
                                        if (input.size > 0) str[index] = '["'.concat(TYPE_SET, '",').concat((0, $XnYkK._)(input).map(function(val) {
                                            return flattenValue(val);
                                        }).join(","), "]");
                                        else str[index] = '["'.concat(TYPE_SET, '"]');
                                    } else if (input instanceof Map) {
                                        if (input.size > 0) str[index] = '["'.concat(TYPE_MAP, '",').concat((0, $XnYkK._)(input).flatMap(function(param) {
                                            var _param = (0, $6iP9u._)(param, 2), k = _param[0], v = _param[1];
                                            return [
                                                flattenValue(k),
                                                flattenValue(v)
                                            ];
                                        }).join(","), "]");
                                        else str[index] = '["'.concat(TYPE_MAP, '"]');
                                    } else if (input instanceof Promise) {
                                        str[index] = '["'.concat(TYPE_PROMISE, '",').concat(index, "]");
                                        deferred[index] = input;
                                    } else if (input instanceof Error) {
                                        str[index] = '["'.concat(TYPE_ERROR, '",').concat(JSON.stringify(input.message));
                                        if (input.name !== "Error") str[index] += ",".concat(JSON.stringify(input.name));
                                        str[index] += "]";
                                    } else if (Object.getPrototypeOf(input) === null) str[index] = '["'.concat(TYPE_NULL_OBJECT, '",{').concat(partsForObj(input), "}]");
                                    else if (isPlainObject2(input)) str[index] = "{".concat(partsForObj(input), "}");
                                    else error = new Error("Cannot encode object with prototype");
                                }
                                break;
                            }
                        default:
                            {
                                isArray1 = Array.isArray(input);
                                pluginHandled1 = false;
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                if (!isArray1 && plugins) try {
                                    for(_iterator1 = plugins[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        plugin1 = _step1.value;
                                        pluginResult1 = plugin1(input);
                                        if (Array.isArray(pluginResult1)) {
                                            pluginHandled1 = true;
                                            _pluginResult1 = (0, $1SnSh._)(pluginResult1), pluginIdentifier1 = _pluginResult1[0], rest1 = _pluginResult1.slice(1);
                                            str[index] = "[".concat(JSON.stringify(pluginIdentifier1));
                                            if (rest1.length > 0) str[index] += ",".concat(rest1.map(function(v) {
                                                return flattenValue(v);
                                            }).join(","));
                                            str[index] += "]";
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                if (!pluginHandled1) error = new Error("Cannot encode function or unexpected type");
                            }
                    }
                    if (error) {
                        pluginHandled2 = false;
                        _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        if (postPlugins) try {
                            for(_iterator2 = postPlugins[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                plugin2 = _step2.value;
                                pluginResult2 = plugin2(input);
                                if (Array.isArray(pluginResult2)) {
                                    pluginHandled2 = true;
                                    _pluginResult2 = (0, $1SnSh._)(pluginResult2), pluginIdentifier2 = _pluginResult2[0], rest2 = _pluginResult2.slice(1);
                                    str[index] = "[".concat(JSON.stringify(pluginIdentifier2));
                                    if (rest2.length > 0) str[index] += ",".concat(rest2.map(function(v) {
                                        return flattenValue(v);
                                    }).join(","));
                                    str[index] += "]";
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                        if (!pluginHandled2) throw error;
                    }
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
var objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function isPlainObject2(thing) {
    var proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function unflatten(parsed) {
    var _this = this, hydrated = _this.hydrated, values = _this.values;
    if (typeof parsed === "number") return hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    var startIndex = values.length;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parsed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            values.push(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    hydrated.length = values.length;
    return hydrate.call(this, startIndex);
}
function hydrate(index) {
    var _loop = function() {
        var _stack_pop = (0, $6iP9u._)(stack.pop(), 2), index2 = _stack_pop[0], set = _stack_pop[1];
        switch(index2){
            case UNDEFINED:
                set(void 0);
                return "continue";
            case NULL:
                set(null);
                return "continue";
            case NAN:
                set(NaN);
                return "continue";
            case POSITIVE_INFINITY:
                set(Infinity);
                return "continue";
            case NEGATIVE_INFINITY:
                set(-Infinity);
                return "continue";
            case NEGATIVE_ZERO:
                set(-0);
                return "continue";
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            return "continue";
        }
        var value = values[index2];
        if (!value || (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) !== "object") {
            hydrated[index2] = value;
            set(value);
            return "continue";
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                var _value = (0, $6iP9u._)(value, 3), type = _value[0], b = _value[1], c = _value[2];
                switch(type){
                    case TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        return "continue";
                    case TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        return "continue";
                    case TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        return "continue";
                    case TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        return "continue";
                    case TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        return "continue";
                    case TYPE_SET:
                        var newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(var i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            function(v) {
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        return "continue";
                    case TYPE_MAP:
                        var _loop = function(i1) {
                            var r = [];
                            stack.push([
                                value[i1 + 1],
                                function(v) {
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i1],
                                function(k) {
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(function() {
                                map.set(r[0], r[1]);
                            });
                        };
                        var map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(var i1 = value.length - 2; i1 > 0; i1 -= 2)_loop(i1);
                        set(map);
                        return "continue";
                    case TYPE_NULL_OBJECT:
                        var obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _loop1 = function() {
                                var key = _step.value;
                                var r = [];
                                stack.push([
                                    b[key],
                                    function(v) {
                                        r[1] = v;
                                    }
                                ]);
                                stack.push([
                                    Number(key.slice(1)),
                                    function(k) {
                                        r[0] = k;
                                    }
                                ]);
                                postRun.push(function() {
                                    obj[r[0]] = r[1];
                                });
                            };
                            for(var _iterator = Object.keys(b).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop1();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        set(obj);
                        return "continue";
                    case TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            var d = new Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        return "continue";
                    case TYPE_ERROR:
                        var _value1 = (0, $6iP9u._)(value, 3), message = _value1[1], errorType = _value1[2];
                        var error = errorType && globalObj && SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in globalObj && typeof globalObj[errorType] === "function" ? new globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        return "continue";
                    case TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        return "continue";
                    default:
                        if (Array.isArray(plugins)) {
                            var _loop2 = function(i2) {
                                var v = vals[i2];
                                stack.push([
                                    v,
                                    function(v2) {
                                        r[i2] = v2;
                                    }
                                ]);
                            };
                            var r = [];
                            var vals = value.slice(1);
                            for(var i2 = 0; i2 < vals.length; i2++)_loop2(i2);
                            postRun.push(function() {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var plugin = _step.value;
                                        var result2 = plugin.apply(void 0, [
                                            value[0]
                                        ].concat((0, $XnYkK._)(r)));
                                        if (result2) {
                                            set(hydrated[index2] = result2.value);
                                            return;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                throw new SyntaxError();
                            });
                            return "continue";
                        }
                        throw new SyntaxError();
                }
            } else {
                var _loop3 = function(i3) {
                    var n = value[i3];
                    if (n !== HOLE) stack.push([
                        n,
                        function(v) {
                            array[i3] = v;
                        }
                    ]);
                };
                var array = [];
                hydrated[index2] = array;
                for(var i3 = 0; i3 < value.length; i3++)_loop3(i3);
                set(array);
                return "continue";
            }
        } else {
            var object = {};
            hydrated[index2] = object;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                var _loop4 = function() {
                    var key = _step1.value;
                    var r = [];
                    stack.push([
                        value[key],
                        function(v) {
                            r[1] = v;
                        }
                    ]);
                    stack.push([
                        Number(key.slice(1)),
                        function(k) {
                            r[0] = k;
                        }
                    ]);
                    postRun.push(function() {
                        object[r[0]] = r[1];
                    });
                };
                for(var _iterator1 = Object.keys(value).reverse()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop4();
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            set(object);
            return "continue";
        }
    };
    var _this = this, hydrated = _this.hydrated, values = _this.values, deferred = _this.deferred, plugins = _this.plugins;
    var result;
    var stack = [
        [
            index,
            function(v) {
                result = v;
            }
        ]
    ];
    var postRun = [];
    while(stack.length > 0)_loop();
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
function decode(readable, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var plugins, done, reader, decoder, decoded, donePromise;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    plugins = (options !== null && options !== void 0 ? options : {}).plugins;
                    done = new Deferred2();
                    reader = readable.pipeThrough(createLineSplittingTransform()).getReader();
                    decoder = {
                        values: [],
                        hydrated: [],
                        deferred: {},
                        plugins: plugins
                    };
                    return [
                        4,
                        decodeInitial.call(decoder, reader)
                    ];
                case 1:
                    decoded = _state.sent();
                    donePromise = done.promise;
                    if (decoded.done) done.resolve();
                    else donePromise = decodeDeferred.call(decoder, reader).then(done.resolve).catch(function(reason) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.values(decoder.deferred)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var deferred = _step.value;
                                deferred.reject(reason);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        done.reject(reason);
                    });
                    return [
                        2,
                        {
                            done: donePromise.then(function() {
                                return reader.closed;
                            }),
                            value: decoded.value
                        }
                    ];
            }
        });
    })();
}
function decodeInitial(reader) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var read, line;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reader.read()
                    ];
                case 1:
                    read = _state.sent();
                    if (!read.value) throw new SyntaxError();
                    try {
                        line = JSON.parse(read.value);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    return [
                        2,
                        {
                            done: read.done,
                            value: unflatten.call(this, line)
                        }
                    ];
            }
        });
    }).call(this);
}
function decodeDeferred(reader) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var read, line, colonIndex, deferredId, deferred, lineData, jsonLine, value, colonIndex1, deferredId1, deferred1, lineData1, jsonLine1, value1;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reader.read()
                    ];
                case 1:
                    read = _state.sent();
                    _state.label = 2;
                case 2:
                    if (!!read.done) return [
                        3,
                        4
                    ];
                    if (!read.value) return [
                        3,
                        2
                    ];
                    line = read.value;
                    switch(line[0]){
                        case TYPE_PROMISE:
                            {
                                colonIndex = line.indexOf(":");
                                deferredId = Number(line.slice(1, colonIndex));
                                deferred = this.deferred[deferredId];
                                if (!deferred) throw new Error("Deferred ID ".concat(deferredId, " not found in stream"));
                                lineData = line.slice(colonIndex + 1);
                                jsonLine = void 0;
                                try {
                                    jsonLine = JSON.parse(lineData);
                                } catch (reason) {
                                    throw new SyntaxError();
                                }
                                value = unflatten.call(this, jsonLine);
                                deferred.resolve(value);
                                break;
                            }
                        case TYPE_ERROR:
                            {
                                colonIndex1 = line.indexOf(":");
                                deferredId1 = Number(line.slice(1, colonIndex1));
                                deferred1 = this.deferred[deferredId1];
                                if (!deferred1) throw new Error("Deferred ID ".concat(deferredId1, " not found in stream"));
                                lineData1 = line.slice(colonIndex1 + 1);
                                jsonLine1 = void 0;
                                try {
                                    jsonLine1 = JSON.parse(lineData1);
                                } catch (reason) {
                                    throw new SyntaxError();
                                }
                                value1 = unflatten.call(this, jsonLine1);
                                deferred1.reject(value1);
                                break;
                            }
                        default:
                            throw new SyntaxError();
                    }
                    return [
                        4,
                        reader.read()
                    ];
                case 3:
                    read = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function encode(input, options) {
    var _ref = options !== null && options !== void 0 ? options : {}, onComplete = _ref.onComplete, plugins = _ref.plugins, postPlugins = _ref.postPlugins, signal = _ref.signal;
    var encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    var textEncoder = new TextEncoder();
    var lastSentIndex = 0;
    var readable = new ReadableStream({
        start: function(controller) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var id, seenPromises, processingChain, raceDone, racePromise, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                flatten.call(encoder, input)
                            ];
                        case 1:
                            id = _state.sent();
                            if (Array.isArray(id)) throw new Error("This should never happen");
                            if (id < 0) controller.enqueue(textEncoder.encode("".concat(id, "\n")));
                            else {
                                controller.enqueue(textEncoder.encode("[".concat(encoder.stringified.join(","), "]\n")));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                            seenPromises = /* @__PURE__ */ new WeakSet();
                            processingChain = Promise.resolve();
                            if (!Object.keys(encoder.deferred).length) return [
                                3,
                                5
                            ];
                            racePromise = new Promise(function(resolve, reject) {
                                raceDone = resolve;
                                if (signal) {
                                    var rejectPromise = function() {
                                        return reject(signal.reason || new Error("Signal was aborted."));
                                    };
                                    if (signal.aborted) rejectPromise();
                                    else signal.addEventListener("abort", function(event) {
                                        rejectPromise();
                                    });
                                }
                            });
                            _state.label = 2;
                        case 2:
                            if (!(Object.keys(encoder.deferred).length > 0)) return [
                                3,
                                4
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                _loop = function() {
                                    var _step_value = (0, $6iP9u._)(_step.value, 2), deferredId = _step_value[0], deferred = _step_value[1];
                                    if (seenPromises.has(deferred)) return "continue";
                                    seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                    encoder.deferred[Number(deferredId)] = Promise.race([
                                        racePromise,
                                        deferred
                                    ]).then(function(resolved) {
                                        processingChain = processingChain.then(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                                var id2, values;
                                                return (0, $3SMYb._)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                flatten.call(encoder, resolved)
                                                            ];
                                                        case 1:
                                                            id2 = _state.sent();
                                                            if (Array.isArray(id2)) {
                                                                controller.enqueue(textEncoder.encode("".concat(TYPE_PROMISE).concat(deferredId, ':[["').concat(TYPE_PREVIOUS_RESOLVED, '",').concat(id2[0], "]]\n")));
                                                                encoder.index++;
                                                                lastSentIndex++;
                                                            } else if (id2 < 0) controller.enqueue(textEncoder.encode("".concat(TYPE_PROMISE).concat(deferredId, ":").concat(id2, "\n")));
                                                            else {
                                                                values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                                                controller.enqueue(textEncoder.encode("".concat(TYPE_PROMISE).concat(deferredId, ":[").concat(values, "]\n")));
                                                                lastSentIndex = encoder.stringified.length - 1;
                                                            }
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            })();
                                        });
                                        return processingChain;
                                    }, function(reason) {
                                        processingChain = processingChain.then(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                                var id2, values;
                                                return (0, $3SMYb._)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            if (!reason || (typeof reason === "undefined" ? "undefined" : (0, $03bAP._)(reason)) !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                                            return [
                                                                4,
                                                                flatten.call(encoder, reason)
                                                            ];
                                                        case 1:
                                                            id2 = _state.sent();
                                                            if (Array.isArray(id2)) {
                                                                controller.enqueue(textEncoder.encode("".concat(TYPE_ERROR).concat(deferredId, ':[["').concat(TYPE_PREVIOUS_RESOLVED, '",').concat(id2[0], "]]\n")));
                                                                encoder.index++;
                                                                lastSentIndex++;
                                                            } else if (id2 < 0) controller.enqueue(textEncoder.encode("".concat(TYPE_ERROR).concat(deferredId, ":").concat(id2, "\n")));
                                                            else {
                                                                values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                                                controller.enqueue(textEncoder.encode("".concat(TYPE_ERROR).concat(deferredId, ":[").concat(values, "]\n")));
                                                                lastSentIndex = encoder.stringified.length - 1;
                                                            }
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            })();
                                        });
                                        return processingChain;
                                    }).finally(function() {
                                        delete encoder.deferred[Number(deferredId)];
                                    }));
                                };
                                for(_iterator = Object.entries(encoder.deferred)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                4,
                                Promise.race(Object.values(encoder.deferred))
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                2
                            ];
                        case 4:
                            raceDone();
                            _state.label = 5;
                        case 5:
                            return [
                                4,
                                Promise.all(Object.values(encoder.deferred))
                            ];
                        case 6:
                            _state.sent();
                            return [
                                4,
                                processingChain
                            ];
                        case 7:
                            _state.sent();
                            controller.close();
                            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
function createRequestInit(request) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var init, contentType, _, _1;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    init = {
                        signal: request.signal
                    };
                    if (!(request.method !== "GET")) return [
                        3,
                        8
                    ];
                    init.method = request.method;
                    contentType = request.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        2
                    ];
                    init.headers = {
                        "Content-Type": contentType
                    };
                    _ = JSON.stringify;
                    return [
                        4,
                        request.json()
                    ];
                case 1:
                    init.body = _.apply(JSON, [
                        _state.sent()
                    ]);
                    return [
                        3,
                        8
                    ];
                case 2:
                    if (!(contentType && /\btext\/plain\b/.test(contentType))) return [
                        3,
                        4
                    ];
                    init.headers = {
                        "Content-Type": contentType
                    };
                    return [
                        4,
                        request.text()
                    ];
                case 3:
                    init.body = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!(contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType))) return [
                        3,
                        6
                    ];
                    _1 = URLSearchParams.bind;
                    return [
                        4,
                        request.text()
                    ];
                case 5:
                    init.body = new (_1.apply(URLSearchParams, [
                        void 0,
                        _state.sent()
                    ]));
                    return [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        request.formData()
                    ];
                case 7:
                    init.body = _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        init
                    ];
            }
        });
    })();
}
// lib/dom/ssr/markup.ts
var ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function escapeHtml(html) {
    return html.replace(ESCAPE_REGEX, function(match) {
        return ESCAPE_LOOKUP[match];
    });
}
// lib/dom/ssr/invariant.ts
function invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var SingleFetchRedirectSymbol = Symbol("SingleFetchRedirect");
var SingleFetchNoResultError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(SingleFetchNoResultError, Error1);
    function SingleFetchNoResultError() {
        (0, $5Epmf._)(this, SingleFetchNoResultError);
        return (0, $48Z0s._)(this, SingleFetchNoResultError, arguments);
    }
    return SingleFetchNoResultError;
}((0, $kW1tL._)(Error));
var SINGLE_FETCH_REDIRECT_STATUS = 202;
var NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function StreamTransfer(param) {
    var context = param.context, identifier = param.identifier, reader = param.reader, textDecoder = param.textDecoder, nonce = param.nonce;
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    var streamCache = context.renderMeta.streamCache;
    var promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then(function(result) {
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch(function(e) {
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    var _promise_result = promise.result, done = _promise_result.done, value = _promise_result.value;
    var scriptTag = value ? /* @__PURE__ */ $5s1kH.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: "window.__reactRouterContext.streamController.enqueue(".concat(escapeHtml(JSON.stringify(value)), ");")
        }
    }) : null;
    if (done) return /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, scriptTag, /* @__PURE__ */ $5s1kH.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: "window.__reactRouterContext.streamController.close();"
        }
    }));
    else return /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, scriptTag, /* @__PURE__ */ $5s1kH.createElement($5s1kH.Suspense, null, /* @__PURE__ */ $5s1kH.createElement(StreamTransfer, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function getTurboStreamSingleFetchDataStrategy(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    var dataStrategy = getSingleFetchDataStrategyImpl(getRouter, function(match) {
        var manifestRoute = manifest.routes[match.route.id];
        invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return function(args) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            return (0, $3SMYb._)(this, function(_state) {
                return [
                    2,
                    args.runClientMiddleware(dataStrategy)
                ];
            });
        })();
    };
}
function getSingleFetchDataStrategyImpl(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware) {
    var shouldAllowOptOut = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : function() {
        return true;
    };
    return function(args) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var request, matches, fetcherKey, router, foundRevalidatingServerLoader;
            return (0, $3SMYb._)(this, function(_state) {
                request = args.request, matches = args.matches, fetcherKey = args.fetcherKey;
                router = getRouter();
                if (request.method !== "GET") return [
                    2,
                    singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware)
                ];
                foundRevalidatingServerLoader = matches.some(function(m) {
                    var _getRouteInfo = getRouteInfo(m), hasLoader = _getRouteInfo.hasLoader, hasClientLoader = _getRouteInfo.hasClientLoader;
                    return m.shouldCallHandler() && hasLoader && !hasClientLoader;
                });
                if (!ssr && !foundRevalidatingServerLoader) return [
                    2,
                    nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware)
                ];
                if (fetcherKey) return [
                    2,
                    singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware)
                ];
                return [
                    2,
                    singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut)
                ];
            });
        })();
    };
}
function singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var actionMatch, actionStatus, result;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    actionMatch = args.matches.find(function(m) {
                        return m.shouldCallHandler();
                    });
                    invariant2(actionMatch, "No action match found");
                    actionStatus = void 0;
                    return [
                        4,
                        actionMatch.resolve(function(handler) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var result2;
                                return (0, $3SMYb._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                handler(function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                                        var _ref, data2, status;
                                                        return (0, $3SMYb._)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        fetchAndDecode(args, basename, trailingSlashAware, [
                                                                            actionMatch.route.id
                                                                        ])
                                                                    ];
                                                                case 1:
                                                                    _ref = _state.sent(), data2 = _ref.data, status = _ref.status;
                                                                    actionStatus = status;
                                                                    return [
                                                                        2,
                                                                        unwrapSingleFetchResult(data2, actionMatch.route.id)
                                                                    ];
                                                            }
                                                        });
                                                    })();
                                                })
                                            ];
                                        case 1:
                                            result2 = _state.sent();
                                            return [
                                                2,
                                                result2
                                            ];
                                    }
                                });
                            })();
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if (isResponse(result.result) || isRouteErrorResponse(result.result) || isDataWithResponseInit(result.result)) return [
                        2,
                        (0, $dUlz9._)({}, actionMatch.route.id, result)
                    ];
                    return [
                        2,
                        (0, $dUlz9._)({}, actionMatch.route.id, {
                            type: result.type,
                            result: data(result.result, actionStatus)
                        })
                    ];
            }
        });
    })();
}
function nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var matchesToLoad, results;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matchesToLoad = args.matches.filter(function(m) {
                        return m.shouldCallHandler();
                    });
                    results = {};
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve(function(handler) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                    var hasClientLoader, routeId, result, _tmp, e;
                                    return (0, $3SMYb._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _state.trys.push([
                                                    0,
                                                    5,
                                                    ,
                                                    6
                                                ]);
                                                hasClientLoader = getRouteInfo(m).hasClientLoader;
                                                routeId = m.route.id;
                                                if (!hasClientLoader) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    handler(function() {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                                            var _ref, data2;
                                                            return (0, $3SMYb._)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            fetchAndDecode(args, basename, trailingSlashAware, [
                                                                                routeId
                                                                            ])
                                                                        ];
                                                                    case 1:
                                                                        _ref = _state.sent(), data2 = _ref.data;
                                                                        return [
                                                                            2,
                                                                            unwrapSingleFetchResult(data2, routeId)
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                _tmp = _state.sent();
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    handler()
                                                ];
                                            case 3:
                                                _tmp = _state.sent();
                                                _state.label = 4;
                                            case 4:
                                                result = _tmp;
                                                results[m.route.id] = {
                                                    type: "data",
                                                    result: result
                                                };
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 5:
                                                e = _state.sent();
                                                results[m.route.id] = {
                                                    type: "error",
                                                    result: e
                                                };
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 6:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            });
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware) {
    var shouldAllowOptOut = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : function() {
        return true;
    };
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var routesParams, foundOptOutRoute, routeDfds, singleFetchDfd, results, resolvePromise, isInitialLoad, targetRoutes, data2, e;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routesParams = /* @__PURE__ */ new Set();
                    foundOptOutRoute = false;
                    routeDfds = args.matches.map(function() {
                        return createDeferred2();
                    });
                    singleFetchDfd = createDeferred2();
                    results = {};
                    resolvePromise = Promise.all(args.matches.map(function(m, i) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                            return (0, $3SMYb._)(this, function(_state) {
                                return [
                                    2,
                                    m.resolve(function(handler) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                            var routeId, _getRouteInfo, hasLoader, hasClientLoader, defaultShouldRevalidate, shouldCall, result, e, result1, e1;
                                            return (0, $3SMYb._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        routeDfds[i].resolve();
                                                        routeId = m.route.id;
                                                        _getRouteInfo = getRouteInfo(m), hasLoader = _getRouteInfo.hasLoader, hasClientLoader = _getRouteInfo.hasClientLoader;
                                                        defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
                                                        shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
                                                        if (!shouldCall) {
                                                            foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                                                            hasLoader);
                                                            return [
                                                                2
                                                            ];
                                                        }
                                                        if (!(shouldAllowOptOut(m) && hasClientLoader)) return [
                                                            3,
                                                            5
                                                        ];
                                                        if (hasLoader) foundOptOutRoute = true;
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            handler(function() {
                                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                                                    var _ref, data2;
                                                                    return (0, $3SMYb._)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    fetchAndDecode(args, basename, trailingSlashAware, [
                                                                                        routeId
                                                                                    ])
                                                                                ];
                                                                            case 1:
                                                                                _ref = _state.sent(), data2 = _ref.data;
                                                                                return [
                                                                                    2,
                                                                                    unwrapSingleFetchResult(data2, routeId)
                                                                                ];
                                                                        }
                                                                    });
                                                                })();
                                                            })
                                                        ];
                                                    case 2:
                                                        result = _state.sent();
                                                        results[routeId] = {
                                                            type: "data",
                                                            result: result
                                                        };
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        e = _state.sent();
                                                        results[routeId] = {
                                                            type: "error",
                                                            result: e
                                                        };
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                    case 5:
                                                        if (hasLoader) routesParams.add(routeId);
                                                        _state.label = 6;
                                                    case 6:
                                                        _state.trys.push([
                                                            6,
                                                            8,
                                                            ,
                                                            9
                                                        ]);
                                                        return [
                                                            4,
                                                            handler(function() {
                                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                                                    var data2;
                                                                    return (0, $3SMYb._)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    singleFetchDfd.promise
                                                                                ];
                                                                            case 1:
                                                                                data2 = _state.sent();
                                                                                return [
                                                                                    2,
                                                                                    unwrapSingleFetchResult(data2, routeId)
                                                                                ];
                                                                        }
                                                                    });
                                                                })();
                                                            })
                                                        ];
                                                    case 7:
                                                        result1 = _state.sent();
                                                        results[routeId] = {
                                                            type: "data",
                                                            result: result1
                                                        };
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 8:
                                                        e1 = _state.sent();
                                                        results[routeId] = {
                                                            type: "error",
                                                            result: e1
                                                        };
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 9:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        })();
                                    })
                                ];
                            });
                        })();
                    }));
                    return [
                        4,
                        Promise.all(routeDfds.map(function(d) {
                            return d.promise;
                        }))
                    ];
                case 1:
                    _state.sent();
                    isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
                    if (!((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive)) return [
                        3,
                        2
                    ];
                    singleFetchDfd.resolve({
                        routes: {}
                    });
                    return [
                        3,
                        6
                    ];
                case 2:
                    targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? (0, $XnYkK._)(routesParams.keys()) : void 0;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetchAndDecode(args, basename, trailingSlashAware, targetRoutes)
                    ];
                case 4:
                    data2 = _state.sent();
                    singleFetchDfd.resolve(data2.data);
                    return [
                        3,
                        6
                    ];
                case 5:
                    e = _state.sent();
                    singleFetchDfd.reject(e);
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        4,
                        resolvePromise
                    ];
                case 7:
                    _state.sent();
                    return [
                        4,
                        bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results)
                    ];
                case 8:
                    _state.sent();
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var middlewareError, fetchedData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, routeResult, _results_match_route_id, e;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        singleFetchPromise
                    ];
                case 1:
                    fetchedData = _state.sent();
                    if ("routes" in fetchedData) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                match = _step.value;
                                if (match.route.id in fetchedData.routes) {
                                    routeResult = fetchedData.routes[match.route.id];
                                    if ("error" in routeResult) {
                                        ;
                                        middlewareError = routeResult.error;
                                        if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.result) == null) results[match.route.id] = {
                                            type: "error",
                                            result: middlewareError
                                        };
                                        break;
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    if (middlewareError !== void 0) Array.from(routesParams.values()).forEach(function(routeId) {
                        if (results[routeId].result instanceof SingleFetchNoResultError) results[routeId].result = middlewareError;
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
function singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var fetcherMatch, routeId, result;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    fetcherMatch = args.matches.find(function(m) {
                        return m.shouldCallHandler();
                    });
                    invariant2(fetcherMatch, "No fetcher match found");
                    routeId = fetcherMatch.route.id;
                    return [
                        4,
                        fetcherMatch.resolve(function(handler) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                return (0, $3SMYb._)(this, function(_state) {
                                    return [
                                        2,
                                        handler(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                                var _ref, data2;
                                                return (0, $3SMYb._)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                fetchAndDecode(args, basename, trailingSlashAware, [
                                                                    routeId
                                                                ])
                                                            ];
                                                        case 1:
                                                            _ref = _state.sent(), data2 = _ref.data;
                                                            return [
                                                                2,
                                                                unwrapSingleFetchResult(data2, routeId)
                                                            ];
                                                    }
                                                });
                                            })();
                                        })
                                    ];
                                });
                            })();
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0, $dUlz9._)({}, fetcherMatch.route.id, result)
                    ];
            }
        });
    })();
}
function stripIndexParam(url) {
    var indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    var indexValuesToKeep = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = indexValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var indexValue = _step.value;
            if (indexValue) indexValuesToKeep.push(indexValue);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = indexValuesToKeep[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var toKeep = _step1.value;
            url.searchParams.append("index", toKeep);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return url;
}
function singleFetchUrl(reqUrl, basename, trailingSlashAware, extension) {
    var url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = "".concat(url.pathname, "_.").concat(extension);
        else url.pathname = "".concat(url.pathname, ".").concat(extension);
    } else {
        if (url.pathname === "/") url.pathname = "_root.".concat(extension);
        else if (basename && stripBasename(url.pathname, basename) === "/") url.pathname = "".concat(removeTrailingSlash(basename), "/_root.").concat(extension);
        else url.pathname = "".concat(removeTrailingSlash(url.pathname), ".").concat(extension);
    }
    return url;
}
function fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var request, url, res, _tmp, _, _tmp1, routes, decoded, data2, typed, typed1, routeId, e;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = args.request;
                    url = singleFetchUrl(request.url, basename, trailingSlashAware, "data");
                    if (request.method === "GET") {
                        url = stripIndexParam(url);
                        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
                    }
                    _tmp = [
                        url
                    ];
                    return [
                        4,
                        createRequestInit(request)
                    ];
                case 1:
                    return [
                        4,
                        fetch.apply(void 0, _tmp.concat([
                            _state.sent()
                        ]))
                    ];
                case 2:
                    res = _state.sent();
                    if (!(res.status >= 400 && !res.headers.has("X-Remix-Response"))) return [
                        3,
                        4
                    ];
                    _ = ErrorResponseImpl.bind;
                    _tmp1 = [
                        void 0,
                        res.status,
                        res.statusText
                    ];
                    return [
                        4,
                        res.text()
                    ];
                case 3:
                    throw new (_.apply(ErrorResponseImpl, _tmp1.concat([
                        _state.sent()
                    ])));
                case 4:
                    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return [
                        2,
                        {
                            status: SINGLE_FETCH_REDIRECT_STATUS,
                            data: {
                                redirect: {
                                    redirect: res.headers.get("X-Remix-Redirect"),
                                    status: Number(res.headers.get("X-Remix-Status") || "302"),
                                    revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                                    reload: res.headers.get("X-Remix-Reload-Document") === "true",
                                    replace: res.headers.get("X-Remix-Replace") === "true"
                                }
                            }
                        }
                    ];
                    if (NO_BODY_STATUS_CODES.has(res.status)) {
                        routes = {};
                        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
                            data: void 0
                        };
                        return [
                            2,
                            {
                                status: res.status,
                                data: {
                                    routes: routes
                                }
                            }
                        ];
                    }
                    invariant2(res.body, "No response body to decode");
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        8
                    ]);
                    return [
                        4,
                        decodeViaTurboStream(res.body, window)
                    ];
                case 6:
                    decoded = _state.sent();
                    if (request.method === "GET") {
                        typed = decoded.value;
                        if (SingleFetchRedirectSymbol in typed) data2 = {
                            redirect: typed[SingleFetchRedirectSymbol]
                        };
                        else data2 = {
                            routes: typed
                        };
                    } else {
                        typed1 = decoded.value;
                        routeId = targetRoutes === null || targetRoutes === void 0 ? void 0 : targetRoutes[0];
                        invariant2(routeId, "No routeId found for single fetch call decoding");
                        if ("redirect" in typed1) data2 = {
                            redirect: typed1
                        };
                        else data2 = {
                            routes: (0, $dUlz9._)({}, routeId, typed1)
                        };
                    }
                    return [
                        2,
                        {
                            status: res.status,
                            data: data2
                        }
                    ];
                case 7:
                    e = _state.sent();
                    throw new Error("Unable to decode turbo-stream response");
                case 8:
                    return [
                        2
                    ];
            }
        });
    })();
}
function decodeViaTurboStream(body, global) {
    return decode(body, {
        plugins: [
            function(type) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                if (type === "SanitizedError") {
                    var _rest = (0, $6iP9u._)(rest, 3), name = _rest[0], message = _rest[1], stack = _rest[2];
                    var Constructor = Error;
                    if (name && SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    var error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    var _rest1 = (0, $6iP9u._)(rest, 3), data2 = _rest1[0], status = _rest1[1], statusText = _rest1[2];
                    return {
                        value: new ErrorResponseImpl(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: (0, $dUlz9._)({}, SingleFetchRedirectSymbol, rest[0])
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        var _result_redirect = result.redirect, location = _result_redirect.redirect, revalidate = _result_redirect.revalidate, reload = _result_redirect.reload, replace2 = _result_redirect.replace, status = _result_redirect.status;
        throw redirect(location, {
            status: status,
            headers: (0, $hwO3w._)({}, revalidate ? {
                "X-Remix-Revalidate": "yes"
            } : null, reload ? {
                "X-Remix-Reload-Document": "yes"
            } : null, replace2 ? {
                "X-Remix-Replace": "yes"
            } : null)
        });
    }
    var routeResult = result.routes[routeId];
    if (routeResult == null) throw new SingleFetchNoResultError('No result found for routeId "'.concat(routeId, '"'));
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error('Invalid response found for routeId "'.concat(routeId, '"'));
}
function createDeferred2() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = function(val) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var e;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            res(val);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        reject = function(error) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var e;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rej(error);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
    });
    return {
        promise: promise,
        //@ts-ignore
        resolve: resolve,
        //@ts-ignore
        reject: reject
    };
}
// lib/dom/ssr/routeModules.ts
function loadRouteModule(route, routeModulesCache) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var routeModule, error;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (route.id in routeModulesCache) return [
                        2,
                        routeModulesCache[route.id]
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.module)
                    ];
                case 2:
                    routeModule = _state.sent();
                    routeModulesCache[route.id] = routeModule;
                    return [
                        2,
                        routeModule
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Error loading route module `".concat(route.module, "`, reloading page..."));
                    console.error(error);
                    if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
                    $9a2fb184cf43fa82$import_meta.hot) throw error;
                    window.location.reload();
                    return [
                        2,
                        new Promise(function() {})
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
// lib/dom/ssr/links.ts
function getKeyedLinksForMatches(matches, routeModules, manifest) {
    var descriptors = matches.map(function(match) {
        var _module_links;
        var module = routeModules[match.route.id];
        var route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map(function(href) {
                return {
                    rel: "stylesheet",
                    href: href
                };
            }) : [],
            (module === null || module === void 0 ? void 0 : (_module_links = module.links) === null || _module_links === void 0 ? void 0 : _module_links.call(module)) || []
        ];
    }).flat(2);
    var preloads = getModuleLinkHrefs(matches, manifest);
    return dedupeLinkDescriptors(descriptors, preloads);
}
function getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map(function(href) {
        return {
            rel: "stylesheet",
            href: href
        };
    });
}
function prefetchRouteCss(route) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var descriptors;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.css) return [
                        2
                    ];
                    descriptors = getRouteCssDescriptors(route);
                    return [
                        4,
                        Promise.all(descriptors.map(prefetchStyleLink))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function prefetchStyleLinks(route, routeModule) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _descriptors, _descriptors1, descriptors, styleLinks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, descriptor;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.css && !routeModule.links || !isPreloadSupported()) return [
                        2
                    ];
                    descriptors = [];
                    if (route.css) (_descriptors = descriptors).push.apply(_descriptors, (0, $XnYkK._)(getRouteCssDescriptors(route)));
                    if (routeModule.links) (_descriptors1 = descriptors).push.apply(_descriptors1, (0, $XnYkK._)(routeModule.links()));
                    if (descriptors.length === 0) return [
                        2
                    ];
                    styleLinks = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = descriptors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            descriptor = _step.value;
                            if (!isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push((0, $lf4fc._)((0, $hwO3w._)({}, descriptor), {
                                rel: "preload",
                                as: "style"
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        4,
                        Promise.all(styleLinks.map(prefetchStyleLink))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function prefetchStyleLink(descriptor) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        return (0, $3SMYb._)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector('link[rel="stylesheet"][href="'.concat(descriptor.href, '"]'))) return resolve();
                    var link = document.createElement("link");
                    Object.assign(link, descriptor);
                    function removeLink() {
                        if (document.head.contains(link)) document.head.removeChild(link);
                    }
                    link.onload = function() {
                        removeLink();
                        resolve();
                    };
                    link.onerror = function() {
                        removeLink();
                        resolve();
                    };
                    document.head.appendChild(link);
                })
            ];
        });
    })();
}
function isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
function getKeyedPrefetchLinks(matches, manifest, routeModules) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var links;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all(matches.map(function(match) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var route, mod;
                                return (0, $3SMYb._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            route = manifest.routes[match.route.id];
                                            if (!route) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                loadRouteModule(route, routeModules)
                                            ];
                                        case 1:
                                            mod = _state.sent();
                                            return [
                                                2,
                                                mod.links ? mod.links() : []
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                []
                                            ];
                                    }
                                });
                            })();
                        }))
                    ];
                case 1:
                    links = _state.sent();
                    return [
                        2,
                        dedupeLinkDescriptors(links.flat(1).filter(isHtmlLinkDescriptor).filter(function(link) {
                            return link.rel === "stylesheet" || link.rel === "preload";
                        }).map(function(link) {
                            return link.rel === "stylesheet" ? (0, $lf4fc._)((0, $hwO3w._)({}, link), {
                                rel: "prefetch",
                                as: "style"
                            }) : (0, $lf4fc._)((0, $hwO3w._)({}, link), {
                                rel: "prefetch"
                            });
                        }))
                    ];
            }
        });
    })();
}
function getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    var isNew = function(match, index) {
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    var matchPathChanged = function(match, index) {
        var // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        _currentMatches_index_route_path;
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || ((_currentMatches_index_route_path = currentMatches[index].route.path) === null || _currentMatches_index_route_path === void 0 ? void 0 : _currentMatches_index_route_path.endsWith("*")) && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter(function(match, index) {
        return isNew(match, index) || matchPathChanged(match, index);
    });
    if (mode === "data") return nextMatches.filter(function(match, index) {
        var manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            var _currentMatches_;
            var routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: ((_currentMatches_ = currentMatches[0]) === null || _currentMatches_ === void 0 ? void 0 : _currentMatches_.params) || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function getModuleLinkHrefs(matches, manifest) {
    var includeHydrateFallback = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).includeHydrateFallback;
    return dedupeHrefs(matches.map(function(match) {
        var route = manifest.routes[match.route.id];
        if (!route) return [];
        var hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function dedupeHrefs(hrefs) {
    return (0, $XnYkK._)(new Set(hrefs));
}
function sortKeys(obj) {
    var sorted = {};
    var keys = Object.keys(obj).sort();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            sorted[key] = obj[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return sorted;
}
function dedupeLinkDescriptors(descriptors, preloads) {
    var set = /* @__PURE__ */ new Set();
    var preloadsSet = new Set(preloads);
    return descriptors.reduce(function(deduped, descriptor) {
        var alreadyModulePreload = preloads && !isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        var key = JSON.stringify(sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var _isPreloadSupported;
function isPreloadSupported() {
    if (_isPreloadSupported !== void 0) return _isPreloadSupported;
    var el = document.createElement("link");
    _isPreloadSupported = el.relList.supports("preload");
    el = null;
    return _isPreloadSupported;
}
function RemixRootDefaultHydrateFallback() {
    var nonce = useFrameworkContext().nonce;
    return /* @__PURE__ */ $5s1kH.createElement(BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, ENABLE_DEV_WARNINGS ? /* @__PURE__ */ $5s1kH.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: '\n              console.log(\n                "\uD83D\uDCBF Hey developer \uD83D\uDC4B. You can provide a way better UX than this " +\n                "when your app is loading JS modules and/or running `clientLoader` " +\n                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +\n                "for more information."\n              );\n            '
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function groupRoutesByParentId(manifest) {
    var routes = {};
    Object.values(manifest).forEach(function(route) {
        if (route) {
            var parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function getRouteComponents(route, routeModule, isSpaMode) {
    var Component4 = getRouteModuleComponent(routeModule);
    var HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? RemixRootDefaultHydrateFallback : void 0;
    var ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? function() {
        return /* @__PURE__ */ $5s1kH.createElement(RemixRootDefaultErrorBoundary, {
            error: useRouteError()
        });
    } : void 0;
    if (route.id === "root" && routeModule.Layout) return (0, $hwO3w._)({}, Component4 ? {
        element: /* @__PURE__ */ $5s1kH.createElement(routeModule.Layout, null, /* @__PURE__ */ $5s1kH.createElement(Component4, null))
    } : {
        Component: Component4
    }, ErrorBoundary ? {
        errorElement: /* @__PURE__ */ $5s1kH.createElement(routeModule.Layout, null, /* @__PURE__ */ $5s1kH.createElement(ErrorBoundary, null))
    } : {
        ErrorBoundary: ErrorBoundary
    }, HydrateFallback ? {
        hydrateFallbackElement: /* @__PURE__ */ $5s1kH.createElement(routeModule.Layout, null, /* @__PURE__ */ $5s1kH.createElement(HydrateFallback, null))
    } : {
        HydrateFallback: HydrateFallback
    });
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function createServerRoutes(manifest, routeModules, future, isSpaMode) {
    var parentId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", routesByParentId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : groupRoutesByParentId(manifest), spaModeLazyPromise = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : Promise.resolve({
        Component: function() {
            return null;
        }
    });
    return (routesByParentId[parentId] || []).map(function(route) {
        var routeModule = routeModules[route.id];
        invariant2(routeModule, "No `routeModule` available to create server routes");
        var dataRoute = (0, $lf4fc._)((0, $hwO3w._)({}, getRouteComponents(route, routeModule, isSpaMode)), {
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? function() {
                return spaModeLazyPromise;
            } : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? function() {
                return null;
            } : void 0
        });
        var children = createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function createClientRoutesWithHMRRevalidationOptOut(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", groupRoutesByParentId(manifest), needsRevalidation);
}
function preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        var fn = type === "action" ? "serverAction()" : "serverLoader()";
        var msg = "You are trying to call ".concat(fn, " on a route that does not have a server ").concat(type, ' (routeId: "').concat(route.id, '")');
        console.error(msg);
        throw new ErrorResponseImpl(400, "Bad Request", new Error(msg), true);
    }
}
function noActionDefinedError(type, routeId) {
    var article = type === "clientAction" ? "a" : "an";
    var msg = 'Route "'.concat(routeId, '" does not have ').concat(article, " ").concat(type, ", but you are trying to submit to it. To fix this, please add ").concat(article, " `").concat(type, "` function to the route");
    console.error(msg);
    throw new ErrorResponseImpl(405, "Method Not Allowed", new Error(msg), true);
}
function createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    var parentId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", routesByParentId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : groupRoutesByParentId(manifest), needsRevalidation = arguments.length > 7 ? arguments[7] : void 0;
    return (routesByParentId[parentId] || []).map(function(route) {
        var routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        function prefetchStylesAndCallHandler(handler) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var cachedModule, linkPrefetchPromise;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cachedModule = routeModulesCache[route.id];
                            linkPrefetchPromise = cachedModule ? prefetchStyleLinks(route, cachedModule) : Promise.resolve();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                2,
                                4
                            ]);
                            return [
                                2,
                                handler()
                            ];
                        case 2:
                            return [
                                4,
                                linkPrefetchPromise
                            ];
                        case 3:
                            _state.sent();
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        var dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            var _initialState_loaderData, _initialState_errors, _routeModule_clientLoader;
            Object.assign(dataRoute, (0, $lf4fc._)((0, $hwO3w._)({}, dataRoute, getRouteComponents(route, routeModule, isSpaMode)), {
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            }));
            var hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            var initialData = hasInitialData ? initialState === null || initialState === void 0 ? void 0 : (_initialState_loaderData = initialState.loaderData) === null || _initialState_loaderData === void 0 ? void 0 : _initialState_loaderData[route.id] : void 0;
            var hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            var initialError = hasInitialError ? initialState === null || initialState === void 0 ? void 0 : (_initialState_errors = initialState.errors) === null || _initialState_errors === void 0 ? void 0 : _initialState_errors[route.id] : void 0;
            var isHydrationRequest = needsRevalidation == null && (((_routeModule_clientLoader = routeModule.clientLoader) === null || _routeModule_clientLoader === void 0 ? void 0 : _routeModule_clientLoader.hydrate) === true || !route.hasLoader);
            dataRoute.loader = function(param, singleFetch) {
                var request = param.request, params = param.params, context = param.context, pattern = param.pattern, url = param.url;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _isHydrationRequest, result;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _isHydrationRequest = isHydrationRequest;
                                isHydrationRequest = false;
                                return [
                                    4,
                                    prefetchStylesAndCallHandler(function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                            return (0, $3SMYb._)(this, function(_state) {
                                                invariant2(routeModule, "No `routeModule` available for critical-route loader");
                                                if (!routeModule.clientLoader) return [
                                                    2,
                                                    fetchServerLoader(singleFetch)
                                                ];
                                                return [
                                                    2,
                                                    routeModule.clientLoader({
                                                        request: request,
                                                        params: params,
                                                        context: context,
                                                        pattern: pattern,
                                                        url: url,
                                                        serverLoader: function() {
                                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                                                return (0, $3SMYb._)(this, function(_state) {
                                                                    preventInvalidServerHandlerCall("loader", route);
                                                                    if (_isHydrationRequest) {
                                                                        if (hasInitialData) return [
                                                                            2,
                                                                            initialData
                                                                        ];
                                                                        if (hasInitialError) throw initialError;
                                                                    }
                                                                    return [
                                                                        2,
                                                                        fetchServerLoader(singleFetch)
                                                                    ];
                                                                });
                                                            })();
                                                        }
                                                    })
                                                ];
                                            });
                                        })();
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            };
            dataRoute.loader.hydrate = shouldHydrateRouteLoader(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = function(param, singleFetch) {
                var request = param.request, params = param.params, context = param.context, pattern = param.pattern, url = param.url;
                return prefetchStylesAndCallHandler(function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        return (0, $3SMYb._)(this, function(_state) {
                            invariant2(routeModule, "No `routeModule` available for critical-route action");
                            if (!routeModule.clientAction) {
                                if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                                return [
                                    2,
                                    fetchServerAction(singleFetch)
                                ];
                            }
                            return [
                                2,
                                routeModule.clientAction({
                                    request: request,
                                    params: params,
                                    context: context,
                                    pattern: pattern,
                                    url: url,
                                    serverAction: function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                            return (0, $3SMYb._)(this, function(_state) {
                                                preventInvalidServerHandlerCall("action", route);
                                                return [
                                                    2,
                                                    fetchServerAction(singleFetch)
                                                ];
                                            });
                                        })();
                                    }
                                })
                            ];
                        });
                    })();
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = function(_, singleFetch) {
                return prefetchStylesAndCallHandler(function() {
                    return fetchServerLoader(singleFetch);
                });
            };
            if (!route.hasClientAction) dataRoute.action = function(_, singleFetch) {
                return prefetchStylesAndCallHandler(function() {
                    if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            };
            var lazyRoutePromise;
            function getLazyRoute() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!lazyRoutePromise) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    lazyRoutePromise
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                lazyRoutePromise = function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                        var routeModulePromise;
                                        return (0, $3SMYb._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!(route.clientLoaderModule || route.clientActionModule)) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        new Promise(function(resolve) {
                                                            return setTimeout(resolve, 0);
                                                        })
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    routeModulePromise = loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                                                    prefetchRouteModuleChunks(route);
                                                    return [
                                                        4,
                                                        routeModulePromise
                                                    ];
                                                case 3:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                            }
                                        });
                                    })();
                                }();
                                return [
                                    4,
                                    lazyRoutePromise
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        var clientLoader, _tmp;
                        return (0, $3SMYb._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!route.clientLoaderModule) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 3:
                                    _tmp = _state.sent();
                                    _state.label = 4;
                                case 4:
                                    clientLoader = _tmp.clientLoader;
                                    invariant2(clientLoader, "No `clientLoader` export found");
                                    return [
                                        2,
                                        function(args, singleFetch) {
                                            return clientLoader((0, $lf4fc._)((0, $hwO3w._)({}, args), {
                                                serverLoader: function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                                        return (0, $3SMYb._)(this, function(_state) {
                                                            preventInvalidServerHandlerCall("loader", route);
                                                            return [
                                                                2,
                                                                fetchServerLoader(singleFetch)
                                                            ];
                                                        });
                                                    })();
                                                }
                                            }));
                                        }
                                    ];
                            }
                        });
                    })();
                } : void 0,
                action: route.hasClientAction ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        var clientActionPromise, clientAction;
                        return (0, $3SMYb._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                                    prefetchRouteModuleChunks(route);
                                    return [
                                        4,
                                        clientActionPromise
                                    ];
                                case 1:
                                    clientAction = _state.sent().clientAction;
                                    invariant2(clientAction, "No `clientAction` export found");
                                    return [
                                        2,
                                        function(args, singleFetch) {
                                            return clientAction((0, $lf4fc._)((0, $hwO3w._)({}, args), {
                                                serverAction: function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                                        return (0, $3SMYb._)(this, function(_state) {
                                                            preventInvalidServerHandlerCall("action", route);
                                                            return [
                                                                2,
                                                                fetchServerAction(singleFetch)
                                                            ];
                                                        });
                                                    })();
                                                }
                                            }));
                                        }
                                    ];
                            }
                        });
                    })();
                } : void 0,
                middleware: route.hasClientMiddleware ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        var clientMiddleware, _tmp;
                        return (0, $3SMYb._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!route.clientMiddlewareModule) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 3:
                                    _tmp = _state.sent();
                                    _state.label = 4;
                                case 4:
                                    clientMiddleware = _tmp.clientMiddleware;
                                    invariant2(clientMiddleware, "No `clientMiddleware` export found");
                                    return [
                                        2,
                                        clientMiddleware
                                    ];
                            }
                        });
                    })();
                } : void 0,
                shouldRevalidate: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        var lazyRoute;
                        return (0, $3SMYb._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    lazyRoute = _state.sent();
                                    return [
                                        2,
                                        getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation)
                                    ];
                            }
                        });
                    })();
                },
                handle: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        return (0, $3SMYb._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().handle
                                    ];
                            }
                        });
                    })();
                },
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        return (0, $3SMYb._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().Component
                                    ];
                            }
                        });
                    })();
                },
                ErrorBoundary: route.hasErrorBoundary ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        return (0, $3SMYb._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().ErrorBoundary
                                    ];
                            }
                        });
                    })();
                } : void 0
            };
        }
        var children = createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        var myParams = path ? compilePath(path)[1].map(function(p) {
            return p.paramName;
        }) : [];
        var didParamsChange = function(opts) {
            return myParams.some(function(p) {
                return opts.currentParams[p] !== opts.nextParams[p];
            });
        };
        if (route.shouldRevalidate) {
            var fn = route.shouldRevalidate;
            return function(opts) {
                return fn((0, $lf4fc._)((0, $hwO3w._)({}, opts), {
                    defaultShouldRevalidate: didParamsChange(opts)
                }));
            };
        } else return function(opts) {
            return didParamsChange(opts);
        };
    }
    return route.shouldRevalidate;
}
function wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    var handledRevalidation = false;
    return function(arg) {
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
function loadRouteModuleWithBlockingLinks(route, routeModules) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var routeModulePromise, prefetchRouteCssPromise, routeModule;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routeModulePromise = loadRouteModule(route, routeModules);
                    prefetchRouteCssPromise = prefetchRouteCss(route);
                    return [
                        4,
                        routeModulePromise
                    ];
                case 1:
                    routeModule = _state.sent();
                    return [
                        4,
                        Promise.all([
                            prefetchRouteCssPromise,
                            prefetchStyleLinks(route, routeModule)
                        ])
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        {
                            Component: getRouteModuleComponent(routeModule),
                            ErrorBoundary: routeModule.ErrorBoundary,
                            clientMiddleware: routeModule.clientMiddleware,
                            clientAction: routeModule.clientAction,
                            clientLoader: routeModule.clientLoader,
                            handle: routeModule.handle,
                            links: routeModule.links,
                            meta: routeModule.meta,
                            shouldRevalidate: routeModule.shouldRevalidate
                        }
                    ];
            }
        });
    })();
}
function getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    var isEmptyObject = (0, $03bAP._)(routeModule.default) === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function shouldHydrateRouteLoader(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var nextPaths = /* @__PURE__ */ new Set();
var discoveredPathsMaxSize = 1e3;
var discoveredPaths = /* @__PURE__ */ new Set();
var URL_LIMIT = 7680;
function getPathsWithAncestors(paths) {
    var result = /* @__PURE__ */ new Set();
    paths.forEach(function(path) {
        if (!path.startsWith("/")) path = "/".concat(path);
        for(var i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function getPartialManifest(_param, router) {
    var sri = _param.sri, manifest = (0, $54Czb._)(_param, [
        "sri"
    ]);
    var routeIds = new Set(router.state.matches.map(function(m) {
        return m.route.id;
    }));
    var segments = router.state.location.pathname.split("/").filter(Boolean);
    var paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push("/".concat(segments.join("/")));
        segments.pop();
    }
    paths.forEach(function(path) {
        var matches = matchRoutesImpl(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach(function(m) {
            return routeIds.add(m.route.id);
        });
    });
    var initialRoutes = (0, $XnYkK._)(routeIds).reduce(function(acc, id) {
        return Object.assign(acc, (0, $dUlz9._)({}, id, manifest.routes[id]));
    }, {});
    return (0, $lf4fc._)((0, $hwO3w._)({}, manifest), {
        routes: initialRoutes,
        sri: sri ? true : void 0
    });
}
function getPatchRoutesOnNavigationFunction(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return function(param) {
        var path = param.path, patch = param.patch, signal = param.signal, fetcherKey = param.fetcherKey;
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var state;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (discoveredPaths.has(path)) return [
                            2
                        ];
                        state = getRouter().state;
                        return [
                            4,
                            fetchAndApplyManifestPatches([
                                path
                            ], // If we're patching for a fetcher call, reload the current location
                            // Otherwise prefer any ongoing navigation location
                            fetcherKey ? window.location.href : createPath(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
}
function useFogOFWarDiscovery(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $5s1kH.useEffect(function() {
        var // @ts-expect-error - TS doesn't know about this yet
        _window_navigator_connection, _window_navigator;
        if (!isFogOfWarEnabled(routeDiscovery, ssr) || ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_connection = _window_navigator.connection) === null || _window_navigator_connection === void 0 ? void 0 : _window_navigator_connection.saveData) === true) return;
        function registerElement(el) {
            var path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            var pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!discoveredPaths.has(pathname)) nextPaths.add(pathname);
        }
        function fetchPatches() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var lazyPaths, e;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
                            lazyPaths = Array.from(nextPaths.keys()).filter(function(path) {
                                if (discoveredPaths.has(path)) {
                                    nextPaths.delete(path);
                                    return false;
                                }
                                return true;
                            });
                            if (lazyPaths.length === 0) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            console.error("Failed to fetch manifest patches", e);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        var debouncedFetchPatches = debounce(fetchPatches, 100);
        fetchPatches();
        var observer = new MutationObserver(function() {
            return debouncedFetchPatches();
        });
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return function() {
            return observer.disconnect();
        };
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function getManifestPath(_manifestPath, basename) {
    var manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : joinPaths([
        basename,
        manifestPath
    ]);
}
var MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
function fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var searchParams, url, serverPatches, res, _, e, knownRoutes, patches, parentIds;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    paths = getPathsWithAncestors(paths);
                    searchParams = new URLSearchParams();
                    searchParams.set("paths", paths.sort().join(","));
                    searchParams.set("version", manifest.version);
                    url = new URL(getManifestPath(manifestPath, basename), window.location.origin);
                    url.search = searchParams.toString();
                    if (url.toString().length > URL_LIMIT) {
                        nextPaths.clear();
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        9,
                        ,
                        10
                    ]);
                    return [
                        4,
                        fetch(url, {
                            signal: signal
                        })
                    ];
                case 2:
                    res = _state.sent();
                    if (!!res.ok) return [
                        3,
                        3
                    ];
                    throw new Error("".concat(res.status, " ").concat(res.statusText));
                case 3:
                    if (!(res.status === 204 && res.headers.has("X-Remix-Reload-Document"))) return [
                        3,
                        5
                    ];
                    if (!errorReloadPath) {
                        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                        return [
                            2
                        ];
                    }
                    try {
                        if (sessionStorage.getItem(MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                            console.error("Unable to discover routes due to manifest version mismatch.");
                            return [
                                2
                            ];
                        }
                        sessionStorage.setItem(MANIFEST_VERSION_STORAGE_KEY, manifest.version);
                    } catch (e) {}
                    window.location.href = errorReloadPath;
                    console.warn("Detected manifest version mismatch, reloading...");
                    return [
                        4,
                        new Promise(function() {})
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 5:
                    if (!(res.status >= 400)) return [
                        3,
                        7
                    ];
                    _ = Error.bind;
                    return [
                        4,
                        res.text()
                    ];
                case 6:
                    throw new (_.apply(Error, [
                        void 0,
                        _state.sent()
                    ]));
                case 7:
                    try {
                        sessionStorage.removeItem(MANIFEST_VERSION_STORAGE_KEY);
                    } catch (e) {}
                    return [
                        4,
                        res.json()
                    ];
                case 8:
                    serverPatches = _state.sent();
                    return [
                        3,
                        10
                    ];
                case 9:
                    e = _state.sent();
                    if (signal === null || signal === void 0 ? void 0 : signal.aborted) return [
                        2
                    ];
                    throw e;
                case 10:
                    knownRoutes = new Set(Object.keys(manifest.routes));
                    patches = Object.values(serverPatches).reduce(function(acc, route) {
                        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
                        return acc;
                    }, {});
                    Object.assign(manifest.routes, patches);
                    paths.forEach(function(p) {
                        return addToFifoQueue(p, discoveredPaths);
                    });
                    parentIds = /* @__PURE__ */ new Set();
                    Object.values(patches).forEach(function(patch) {
                        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
                    });
                    parentIds.forEach(function(parentId) {
                        return patchRoutes(parentId || null, createClientRoutes(patches, routeModules, null, ssr, isSpaMode, parentId));
                    });
                    return [
                        2
                    ];
            }
        });
    })();
}
function addToFifoQueue(path, queue) {
    if (queue.size >= discoveredPathsMaxSize) {
        var first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function debounce(callback, wait) {
    var timeoutId;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(function() {
            return callback.apply(void 0, (0, $XnYkK._)(args));
        }, wait);
    };
}
// lib/dom/ssr/components.tsx
function useDataRouterContext2() {
    var context = $5s1kH.useContext(DataRouterContext);
    invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function useDataRouterStateContext() {
    var context = $5s1kH.useContext(DataRouterStateContext);
    invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var FrameworkContext = $5s1kH.createContext(void 0);
FrameworkContext.displayName = "FrameworkContext";
function useFrameworkContext() {
    var context = $5s1kH.useContext(FrameworkContext);
    invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function usePrefetchBehavior(prefetch, theirElementProps) {
    var frameworkContext = $5s1kH.useContext(FrameworkContext);
    var _React8_useState = (0, $6iP9u._)($5s1kH.useState(false), 2), maybePrefetch = _React8_useState[0], setMaybePrefetch = _React8_useState[1];
    var _React8_useState1 = (0, $6iP9u._)($5s1kH.useState(false), 2), shouldPrefetch = _React8_useState1[0], setShouldPrefetch = _React8_useState1[1];
    var onFocus = theirElementProps.onFocus, onBlur = theirElementProps.onBlur, onMouseEnter = theirElementProps.onMouseEnter, onMouseLeave = theirElementProps.onMouseLeave, onTouchStart = theirElementProps.onTouchStart;
    var ref = $5s1kH.useRef(null);
    $5s1kH.useEffect(function() {
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            var callback = function(entries) {
                entries.forEach(function(entry) {
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            var observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return function() {
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $5s1kH.useEffect(function() {
        if (maybePrefetch) {
            var id = setTimeout(function() {
                setShouldPrefetch(true);
            }, 100);
            return function() {
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    var setIntent = function() {
        setMaybePrefetch(true);
    };
    var cancelIntent = function() {
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: composeEventHandlers(onFocus, setIntent),
            onBlur: composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function composeEventHandlers(theirHandler, ourHandler) {
    return function(event) {
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !isHydrated) return [
        matches[0]
    ];
    if (errors) {
        var errorIdx = matches.findIndex(function(m) {
            return errors[m.route.id] !== void 0;
        });
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var CRITICAL_CSS_DATA_ATTRIBUTE = "data-react-router-critical-css";
function Links(param) {
    var nonce = param.nonce, crossOrigin = param.crossOrigin;
    var _useFrameworkContext = useFrameworkContext(), isSpaMode = _useFrameworkContext.isSpaMode, manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules, criticalCss = _useFrameworkContext.criticalCss, contextNonce = _useFrameworkContext.nonce;
    var _useDataRouterStateContext = useDataRouterStateContext(), errors = _useDataRouterStateContext.errors, routerMatches = _useDataRouterStateContext.matches;
    var matches = getActiveMatches(routerMatches, errors, isSpaMode);
    var keyedLinks = $5s1kH.useMemo(function() {
        return getKeyedLinksForMatches(matches, routeModules, manifest);
    }, [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    var _obj, _obj1;
    return /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $5s1kH.createElement("style", (_obj = {}, (0, $dUlz9._)(_obj, CRITICAL_CSS_DATA_ATTRIBUTE, ""), (0, $dUlz9._)(_obj, "nonce", nonce), (0, $dUlz9._)(_obj, "dangerouslySetInnerHTML", {
        __html: criticalCss
    }), _obj)) : null, (typeof criticalCss === "undefined" ? "undefined" : (0, $03bAP._)(criticalCss)) === "object" ? /* @__PURE__ */ $5s1kH.createElement("link", (_obj1 = {}, (0, $dUlz9._)(_obj1, CRITICAL_CSS_DATA_ATTRIBUTE, ""), (0, $dUlz9._)(_obj1, "rel", "stylesheet"), (0, $dUlz9._)(_obj1, "href", criticalCss.href), (0, $dUlz9._)(_obj1, "nonce", nonce), (0, $dUlz9._)(_obj1, "crossOrigin", crossOrigin), _obj1)) : null, keyedLinks.map(function(param) {
        var key = param.key, link = param.link;
        var _link_crossOrigin, _link_crossOrigin1;
        return isPageLinkDescriptor(link) ? /* @__PURE__ */ $5s1kH.createElement(PrefetchPageLinks, (0, $lf4fc._)((0, $hwO3w._)({
            key: key,
            nonce: nonce
        }, link), {
            crossOrigin: (_link_crossOrigin = link.crossOrigin) !== null && _link_crossOrigin !== void 0 ? _link_crossOrigin : crossOrigin
        })) : /* @__PURE__ */ $5s1kH.createElement("link", (0, $lf4fc._)((0, $hwO3w._)({
            key: key,
            nonce: nonce
        }, link), {
            crossOrigin: (_link_crossOrigin1 = link.crossOrigin) !== null && _link_crossOrigin1 !== void 0 ? _link_crossOrigin1 : crossOrigin
        }));
    }));
}
function PrefetchPageLinks(_param) {
    var page = _param.page, linkProps = (0, $54Czb._)(_param, [
        "page"
    ]);
    var rsc = useIsRSCRouterContext();
    var _useFrameworkContext = useFrameworkContext(), contextNonce = _useFrameworkContext.nonce;
    var router = useDataRouterContext2().router;
    var matches = $5s1kH.useMemo(function() {
        return matchRoutes(router.routes, page, router.basename);
    }, [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = (0, $lf4fc._)((0, $hwO3w._)({}, linkProps), {
        nonce: contextNonce
    });
    if (rsc) return /* @__PURE__ */ $5s1kH.createElement(RSCPrefetchPageLinksImpl, (0, $hwO3w._)({
        page: page,
        matches: matches
    }, linkProps));
    return /* @__PURE__ */ $5s1kH.createElement(PrefetchPageLinksImpl, (0, $hwO3w._)({
        page: page,
        matches: matches
    }, linkProps));
}
function useKeyedPrefetchLinks(matches) {
    var _useFrameworkContext = useFrameworkContext(), manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules;
    var _React8_useState = (0, $6iP9u._)($5s1kH.useState([]), 2), keyedPrefetchLinks = _React8_useState[0], setKeyedPrefetchLinks = _React8_useState[1];
    $5s1kH.useEffect(function() {
        var interrupted = false;
        getKeyedPrefetchLinks(matches, manifest, routeModules).then(function(links) {
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return function() {
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function RSCPrefetchPageLinksImpl(_param) {
    var page = _param.page, nextMatches = _param.matches, linkProps = (0, $54Czb._)(_param, [
        "page",
        "matches"
    ]);
    var location = useLocation();
    var future = useFrameworkContext().future;
    var basename = useDataRouterContext2().basename;
    var dataHrefs = $5s1kH.useMemo(function() {
        if (page === location.pathname + location.search + location.hash) return [];
        var url = singleFetchUrl(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        var hasSomeRoutesWithShouldRevalidate = false;
        var targetRoutes = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = nextMatches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
                else targetRoutes.push(match.route.id);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, dataHrefs.map(function(href) {
        return /* @__PURE__ */ $5s1kH.createElement("link", (0, $hwO3w._)({
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href
        }, linkProps));
    }));
}
function PrefetchPageLinksImpl(_param) {
    var page = _param.page, nextMatches = _param.matches, linkProps = (0, $54Czb._)(_param, [
        "page",
        "matches"
    ]);
    var location = useLocation();
    var _useFrameworkContext = useFrameworkContext(), future = _useFrameworkContext.future, manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules;
    var basename = useDataRouterContext2().basename;
    var _useDataRouterStateContext = useDataRouterStateContext(), loaderData = _useDataRouterStateContext.loaderData, matches = _useDataRouterStateContext.matches;
    var newMatchesForData = $5s1kH.useMemo(function() {
        return getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data");
    }, [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    var newMatchesForAssets = $5s1kH.useMemo(function() {
        return getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets");
    }, [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    var dataHrefs = $5s1kH.useMemo(function() {
        if (page === location.pathname + location.search + location.hash) return [];
        var routesParams = /* @__PURE__ */ new Set();
        var foundOptOutRoute = false;
        nextMatches.forEach(function(m) {
            var _routeModules_m_route_id;
            var manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some(function(m2) {
                return m2.route.id === m.route.id;
            }) && m.route.id in loaderData && ((_routeModules_m_route_id = routeModules[m.route.id]) === null || _routeModules_m_route_id === void 0 ? void 0 : _routeModules_m_route_id.shouldRevalidate)) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        var url = singleFetchUrl(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter(function(m) {
            return routesParams.has(m.route.id);
        }).map(function(m) {
            return m.route.id;
        }).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    var moduleHrefs = $5s1kH.useMemo(function() {
        return getModuleLinkHrefs(newMatchesForAssets, manifest);
    }, [
        newMatchesForAssets,
        manifest
    ]);
    var keyedPrefetchLinks = useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, dataHrefs.map(function(href) {
        return /* @__PURE__ */ $5s1kH.createElement("link", (0, $hwO3w._)({
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href
        }, linkProps));
    }), moduleHrefs.map(function(href) {
        return /* @__PURE__ */ $5s1kH.createElement("link", (0, $hwO3w._)({
            key: href,
            rel: "modulepreload",
            href: href
        }, linkProps));
    }), keyedPrefetchLinks.map(function(param) {
        var key = param.key, link = param.link;
        var _link_crossOrigin;
        return(// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $5s1kH.createElement("link", (0, $lf4fc._)((0, $hwO3w._)({
            key: key,
            nonce: linkProps.nonce
        }, link), {
            crossOrigin: (_link_crossOrigin = link.crossOrigin) !== null && _link_crossOrigin !== void 0 ? _link_crossOrigin : linkProps.crossOrigin
        })));
    }));
}
function Meta() {
    var _useFrameworkContext = useFrameworkContext(), isSpaMode = _useFrameworkContext.isSpaMode, routeModules = _useFrameworkContext.routeModules;
    var _useDataRouterStateContext = useDataRouterStateContext(), errors = _useDataRouterStateContext.errors, routerMatches = _useDataRouterStateContext.matches, loaderData = _useDataRouterStateContext.loaderData;
    var location = useLocation();
    var _matches = getActiveMatches(routerMatches, errors, isSpaMode);
    var error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    var meta = [];
    var leafMeta = null;
    var matches = [];
    for(var i = 0; i < _matches.length; i++){
        var _match = _matches[i];
        var routeId = _match.route.id;
        var data2 = loaderData[routeId];
        var params = _match.params;
        var routeModule = routeModules[routeId];
        var routeMeta = [];
        var match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule === null || routeModule === void 0 ? void 0 : routeModule.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? (0, $XnYkK._)(routeModule.meta) : routeModule.meta;
        else if (leafMeta) routeMeta = (0, $XnYkK._)(leafMeta);
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = (0, $XnYkK._)(routeMeta);
        leafMeta = meta;
    }
    return /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, meta.flat().map(function(metaProps) {
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            var tagName = metaProps.tagName, rest = (0, $54Czb._)(metaProps, [
                "tagName"
            ]);
            if (!isValidMetaTag(tagName)) {
                console.warn("A meta object uses an invalid tagName: ".concat(tagName, ". Expected either 'link' or 'meta'"));
                return null;
            }
            var Comp = tagName;
            return /* @__PURE__ */ $5s1kH.createElement(Comp, (0, $hwO3w._)({
                key: JSON.stringify(rest)
            }, rest));
        }
        if ("title" in metaProps) return /* @__PURE__ */ $5s1kH.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            var _metaProps_charSet;
            (_metaProps_charSet = metaProps.charSet) !== null && _metaProps_charSet !== void 0 ? _metaProps_charSet : metaProps.charSet = metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $5s1kH.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            var json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $5s1kH.createElement("script", {
                key: "script:ld+json:".concat(json),
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: escapeHtml(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $5s1kH.createElement("meta", (0, $hwO3w._)({
            key: JSON.stringify(metaProps)
        }, metaProps));
    }));
}
function isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var isHydrated = false;
function setIsHydrated() {
    isHydrated = true;
}
function Scripts(scriptProps) {
    var _useFrameworkContext = useFrameworkContext(), manifest = _useFrameworkContext.manifest, serverHandoffString = _useFrameworkContext.serverHandoffString, isSpaMode = _useFrameworkContext.isSpaMode, renderMeta = _useFrameworkContext.renderMeta, routeDiscovery = _useFrameworkContext.routeDiscovery, ssr = _useFrameworkContext.ssr, contextNonce = _useFrameworkContext.nonce;
    var _useDataRouterContext2 = useDataRouterContext2(), router = _useDataRouterContext2.router, isStatic = _useDataRouterContext2.static, staticContext = _useDataRouterContext2.staticContext;
    var _useDataRouterStateContext = useDataRouterStateContext(), routerMatches = _useDataRouterStateContext.matches;
    var isRSCRouterContext = useIsRSCRouterContext();
    var enableFogOfWar = isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = (0, $lf4fc._)((0, $hwO3w._)({}, scriptProps), {
        nonce: contextNonce
    });
    if (renderMeta) renderMeta.didRenderScripts = true;
    var matches = getActiveMatches(routerMatches, null, isSpaMode);
    $5s1kH.useEffect(function() {
        setIsHydrated();
    }, []);
    var initialScripts = $5s1kH.useMemo(function() {
        var _manifest_hmr;
        if (isRSCRouterContext) return null;
        var streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        var contextScript = staticContext ? "window.__reactRouterContext = ".concat(serverHandoffString, ";").concat(streamScript) : " ";
        var routeModulesScript = !isStatic ? " " : "".concat(((_manifest_hmr = manifest.hmr) === null || _manifest_hmr === void 0 ? void 0 : _manifest_hmr.runtime) ? "import ".concat(JSON.stringify(manifest.hmr.runtime), ";") : "").concat(!enableFogOfWar ? "import ".concat(JSON.stringify(manifest.url)) : "", ";\n").concat(matches.map(function(match, routeIndex) {
            var routeVarName = "route".concat(routeIndex);
            var manifestEntry = manifest.routes[match.route.id];
            invariant2(manifestEntry, "Route ".concat(match.route.id, " not found in manifest"));
            var clientActionModule = manifestEntry.clientActionModule, clientLoaderModule = manifestEntry.clientLoaderModule, clientMiddlewareModule = manifestEntry.clientMiddlewareModule, hydrateFallbackModule = manifestEntry.hydrateFallbackModule, module = manifestEntry.module;
            var chunks = (0, $XnYkK._)(clientActionModule ? [
                {
                    module: clientActionModule,
                    varName: "".concat(routeVarName, "_clientAction")
                }
            ] : []).concat((0, $XnYkK._)(clientLoaderModule ? [
                {
                    module: clientLoaderModule,
                    varName: "".concat(routeVarName, "_clientLoader")
                }
            ] : []), (0, $XnYkK._)(clientMiddlewareModule ? [
                {
                    module: clientMiddlewareModule,
                    varName: "".concat(routeVarName, "_clientMiddleware")
                }
            ] : []), (0, $XnYkK._)(hydrateFallbackModule ? [
                {
                    module: hydrateFallbackModule,
                    varName: "".concat(routeVarName, "_HydrateFallback")
                }
            ] : []), [
                {
                    module: module,
                    varName: "".concat(routeVarName, "_main")
                }
            ]);
            if (chunks.length === 1) return "import * as ".concat(routeVarName, " from ").concat(JSON.stringify(module), ";");
            var chunkImportsSnippet = chunks.map(function(chunk) {
                return "import * as ".concat(chunk.varName, ' from "').concat(chunk.module, '";');
            }).join("\n");
            var mergedChunksSnippet = "const ".concat(routeVarName, " = {").concat(chunks.map(function(chunk) {
                return "...".concat(chunk.varName);
            }).join(","), "};");
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n"), "\n  ").concat(enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        "window.__reactRouterManifest = ".concat(JSON.stringify(getPartialManifest(manifest, router), null, 2), ";") : "", "\n  window.__reactRouterRouteModules = {").concat(matches.map(function(match, index) {
            return "".concat(JSON.stringify(match.route.id), ":route").concat(index);
        }).join(","), "};\n\nimport(").concat(JSON.stringify(manifest.entry.module), ");");
        return /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, /* @__PURE__ */ $5s1kH.createElement("script", (0, $lf4fc._)((0, $hwO3w._)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        })), /* @__PURE__ */ $5s1kH.createElement("script", (0, $lf4fc._)((0, $hwO3w._)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        })));
    }, []);
    var preloads = isHydrated || isRSCRouterContext ? [] : // Dedupe through a Set
    (0, $XnYkK._)(new Set(manifest.entry.imports.concat(getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    }))));
    var sri = (0, $03bAP._)(manifest.sri) === "object" ? manifest.sri : {};
    warnOnce(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, (0, $03bAP._)(manifest.sri) === "object" ? /* @__PURE__ */ $5s1kH.createElement("script", (0, $lf4fc._)((0, $hwO3w._)({}, scriptProps), {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    })) : null, !enableFogOfWar ? /* @__PURE__ */ $5s1kH.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $5s1kH.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map(function(path) {
        return /* @__PURE__ */ $5s1kH.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        });
    }), initialScripts);
}
function mergeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var RemixErrorBoundary = /*#__PURE__*/ function(_React9_Component) {
    "use strict";
    (0, $4QAx6._)(RemixErrorBoundary, _React9_Component);
    function RemixErrorBoundary(props) {
        (0, $5Epmf._)(this, RemixErrorBoundary);
        var _this;
        _this = (0, $48Z0s._)(this, RemixErrorBoundary, [
            props
        ]);
        _this.state = {
            error: props.error || null,
            location: props.location
        };
        return _this;
    }
    (0, $9MqXK._)(RemixErrorBoundary, [
        {
            key: "render",
            value: function render() {
                if (this.state.error) return /* @__PURE__ */ $5s1kH.createElement(RemixRootDefaultErrorBoundary, {
                    error: this.state.error,
                    isOutsideRemixApp: true
                });
                else return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (state.location !== props.location) return {
                    error: props.error || null,
                    location: props.location
                };
                return {
                    error: props.error || state.error,
                    location: state.location
                };
            }
        }
    ]);
    return RemixErrorBoundary;
}($5s1kH.Component);
function RemixRootDefaultErrorBoundary(param) {
    var error = param.error, isOutsideRemixApp = param.isOutsideRemixApp;
    var nonce = useFrameworkContext().nonce;
    console.error(error);
    var heyDeveloper = /* @__PURE__ */ $5s1kH.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: '\n        console.log(\n          "\uD83D\uDCBF Hey developer \uD83D\uDC4B. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."\n        );\n      '
        }
    });
    if (isRouteErrorResponse(error)) return /* @__PURE__ */ $5s1kH.createElement(BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $5s1kH.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), ENABLE_DEV_WARNINGS ? heyDeveloper : null);
    var errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        var errorString = error == null ? "Unknown Error" : (typeof error === "undefined" ? "undefined" : (0, $03bAP._)(error)) === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $5s1kH.createElement(BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $5s1kH.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $5s1kH.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function BoundaryShell(param) {
    var title = param.title, renderScripts = param.renderScripts, isOutsideRemixApp = param.isOutsideRemixApp, children = param.children;
    var _routeModules_root;
    var routeModules = useFrameworkContext().routeModules;
    if (((_routeModules_root = routeModules.root) === null || _routeModules_root === void 0 ? void 0 : _routeModules_root.Layout) && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $5s1kH.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $5s1kH.createElement("head", null, /* @__PURE__ */ $5s1kH.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $5s1kH.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $5s1kH.createElement("title", null, title)), /* @__PURE__ */ $5s1kH.createElement("body", null, /* @__PURE__ */ $5s1kH.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $5s1kH.createElement(Scripts, null) : null)));
}
var isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if (isBrowser2) window.__reactRouterVersion = "7.18.2";
} catch (e) {}
function createBrowserRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createBrowserHistory({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: mapRouteProperties,
        hydrationRouteProperties: hydrationRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
function createHashRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createHashHistory({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: mapRouteProperties,
        hydrationRouteProperties: hydrationRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
function parseHydrationData() {
    var _window;
    var state = (_window = window) === null || _window === void 0 ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = (0, $lf4fc._)((0, $hwO3w._)({}, state), {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6iP9u._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new ErrorResponseImpl(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                if (typeof val.__subType === "string" && SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        var error = new ErrorConstructor(val.message);
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {}
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
function BrowserRouter(param) {
    var basename = param.basename, children = param.children, useTransitions = param.useTransitions, window2 = param.window;
    var historyRef = $5s1kH.useRef();
    if (historyRef.current == null) historyRef.current = createBrowserHistory({
        window: window2,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React10_useState = (0, $6iP9u._)($5s1kH.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $5s1kH.useCallback(function(newState) {
        if (useTransitions === false) setStateImpl(newState);
        else $5s1kH.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        useTransitions
    ]);
    $5s1kH.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $5s1kH.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function HashRouter(param) {
    var basename = param.basename, children = param.children, useTransitions = param.useTransitions, window2 = param.window;
    var historyRef = $5s1kH.useRef();
    if (historyRef.current == null) historyRef.current = createHashHistory({
        window: window2,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React10_useState = (0, $6iP9u._)($5s1kH.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $5s1kH.useCallback(function(newState) {
        if (useTransitions === false) setStateImpl(newState);
        else $5s1kH.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        useTransitions
    ]);
    $5s1kH.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $5s1kH.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function HistoryRouter(param) {
    var basename = param.basename, children = param.children, history = param.history, useTransitions = param.useTransitions;
    var _React10_useState = (0, $6iP9u._)($5s1kH.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $5s1kH.useCallback(function(newState) {
        if (useTransitions === false) setStateImpl(newState);
        else $5s1kH.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        useTransitions
    ]);
    $5s1kH.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $5s1kH.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
HistoryRouter.displayName = "unstable_HistoryRouter";
var Link = $5s1kH.forwardRef(function LinkWithRef(_param, forwardedRef) {
    var onClick = _param.onClick, _param_discover = _param.discover, discover = _param_discover === void 0 ? "render" : _param_discover, _param_prefetch = _param.prefetch, prefetch = _param_prefetch === void 0 ? "none" : _param_prefetch, relative = _param.relative, reloadDocument = _param.reloadDocument, replace2 = _param.replace, mask = _param.mask, state = _param.state, target = _param.target, to = _param.to, preventScrollReset = _param.preventScrollReset, viewTransition = _param.viewTransition, defaultShouldRevalidate = _param.defaultShouldRevalidate, rest = (0, $54Czb._)(_param, [
        "onClick",
        "discover",
        "prefetch",
        "relative",
        "reloadDocument",
        "replace",
        "mask",
        "state",
        "target",
        "to",
        "preventScrollReset",
        "viewTransition",
        "defaultShouldRevalidate"
    ]);
    var _React10_useContext = $5s1kH.useContext(NavigationContext), basename = _React10_useContext.basename, navigator = _React10_useContext.navigator, useTransitions = _React10_useContext.useTransitions;
    var isAbsolute = typeof to === "string" && ABSOLUTE_URL_REGEX.test(to);
    var parsed = parseToInfo(to, basename);
    to = parsed.to;
    var href = useHref(to, {
        relative: relative
    });
    var location = useLocation();
    var maskedHref = null;
    if (mask) {
        var resolved = resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    var _usePrefetchBehavior = (0, $6iP9u._)(usePrefetchBehavior(prefetch, rest), 3), shouldPrefetch = _usePrefetchBehavior[0], prefetchRef = _usePrefetchBehavior[1], prefetchHandlers = _usePrefetchBehavior[2];
    var internalOnClick = useLinkClickHandler(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    var isSpaLink = !(parsed.isExternal || reloadDocument);
    var link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $5s1kH.createElement("a", (0, $lf4fc._)((0, $hwO3w._)({}, rest, prefetchHandlers), {
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, link, /* @__PURE__ */ $5s1kH.createElement(PrefetchPageLinks, {
        page: href
    })) : link;
});
Link.displayName = "Link";
var NavLink = $5s1kH.forwardRef(function NavLinkWithRef(_param, ref) {
    var tmp = _param["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _param_caseSensitive = _param.caseSensitive, caseSensitive = _param_caseSensitive === void 0 ? false : _param_caseSensitive, tmp1 = _param.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _param_end = _param.end, end = _param_end === void 0 ? false : _param_end, styleProp = _param.style, to = _param.to, viewTransition = _param.viewTransition, children = _param.children, rest = (0, $54Czb._)(_param, [
        "aria-current",
        "caseSensitive",
        "className",
        "end",
        "style",
        "to",
        "viewTransition",
        "children"
    ]);
    var path = useResolvedPath(to, {
        relative: rest.relative
    });
    var location = useLocation();
    var routerState = $5s1kH.useContext(DataRouterStateContext);
    var _React10_useContext = $5s1kH.useContext(NavigationContext), navigator = _React10_useContext.navigator, basename = _React10_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : void 0;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $5s1kH.createElement(Link, (0, $lf4fc._)((0, $hwO3w._)({}, rest), {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
NavLink.displayName = "NavLink";
var Form = $5s1kH.forwardRef(function(_param, forwardedRef) {
    var _param_discover = _param.discover, discover = _param_discover === void 0 ? "render" : _param_discover, fetcherKey = _param.fetcherKey, navigate = _param.navigate, reloadDocument = _param.reloadDocument, replace2 = _param.replace, state = _param.state, _param_method = _param.method, method = _param_method === void 0 ? defaultMethod : _param_method, action = _param.action, onSubmit = _param.onSubmit, relative = _param.relative, preventScrollReset = _param.preventScrollReset, viewTransition = _param.viewTransition, defaultShouldRevalidate = _param.defaultShouldRevalidate, props = (0, $54Czb._)(_param, [
        "discover",
        "fetcherKey",
        "navigate",
        "reloadDocument",
        "replace",
        "state",
        "method",
        "action",
        "onSubmit",
        "relative",
        "preventScrollReset",
        "viewTransition",
        "defaultShouldRevalidate"
    ]);
    var useTransitions = $5s1kH.useContext(NavigationContext).useTransitions;
    var submit = useSubmit();
    var formAction = useFormAction(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var isAbsolute = typeof action === "string" && ABSOLUTE_URL_REGEX.test(action);
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || method;
        var doSubmit = function() {
            return submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        };
        if (useTransitions && navigate !== false) $5s1kH.startTransition(function() {
            return doSubmit();
        });
        else doSubmit();
    };
    return /* @__PURE__ */ $5s1kH.createElement("form", (0, $lf4fc._)((0, $hwO3w._)({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props), {
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
});
Form.displayName = "Form";
function ScrollRestoration(_param) {
    var getKey = _param.getKey, storageKey = _param.storageKey, props = (0, $54Czb._)(_param, [
        "getKey",
        "storageKey"
    ]);
    var remixContext = $5s1kH.useContext(FrameworkContext);
    var basename = $5s1kH.useContext(NavigationContext).basename;
    var location = useLocation();
    var matches = useMatches();
    useScrollRestoration({
        getKey: getKey,
        storageKey: storageKey
    });
    var ssrKey = $5s1kH.useMemo(function() {
        if (!remixContext || !getKey) return null;
        var userKey = getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    var restoreScroll = (function(storageKey2, restoreKey) {
        if (!window.history.state || !window.history.state.key) {
            var key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            var positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            var storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && (remixContext === null || remixContext === void 0 ? void 0 : remixContext.nonce)) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $5s1kH.createElement("script", (0, $lf4fc._)((0, $hwO3w._)({}, props), {
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: "(".concat(restoreScroll, ")(").concat(escapeHtml(JSON.stringify(storageKey || SCROLL_RESTORATION_STORAGE_KEY)), ", ").concat(escapeHtml(JSON.stringify(ssrKey)), ")")
        }
    }));
}
ScrollRestoration.displayName = "ScrollRestoration";
function getDataRouterConsoleError2(hookName) {
    return "".concat(hookName, " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.");
}
function useDataRouterContext3(hookName) {
    var ctx = $5s1kH.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError2(hookName));
    return ctx;
}
function useDataRouterState2(hookName) {
    var state = $5s1kH.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError2(hookName));
    return state;
}
function useLinkClickHandler(to) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, target = _ref.target, replaceProp = _ref.replace, mask = _ref.mask, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, viewTransition = _ref.viewTransition, defaultShouldRevalidate = _ref.defaultShouldRevalidate, useTransitions = _ref.useTransitions;
    var navigate = useNavigate();
    var location = useLocation();
    var path = useResolvedPath(to, {
        relative: relative
    });
    return $5s1kH.useCallback(function(event) {
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            var replace2 = replaceProp !== void 0 ? replaceProp : createPath(location) === createPath(path);
            var doNavigate = function() {
                return navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            };
            if (useTransitions) $5s1kH.startTransition(function() {
                return doNavigate();
            });
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function useSearchParams(defaultInit) {
    warning(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    var defaultSearchParamsRef = $5s1kH.useRef(createSearchParams(defaultInit));
    var hasSetSearchParamsRef = $5s1kH.useRef(false);
    var location = useLocation();
    var searchParams = $5s1kH.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = useNavigate();
    var setSearchParams = $5s1kH.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var fetcherId = 0;
var getUniqueFetcherId = function() {
    return "__".concat(String(++fetcherId), "__");
};
function useSubmit() {
    var router = useDataRouterContext3("useSubmit" /* UseSubmit */ ).router;
    var basename = $5s1kH.useContext(NavigationContext).basename;
    var currentRouteId = useRouteId();
    var routerFetch = router.fetch;
    var routerNavigate = router.navigate;
    return $5s1kH.useCallback(function(target) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var _getFormSubmissionInfo, action, method, encType, formData, body, key;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _getFormSubmissionInfo = getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
                        if (!(options.navigate === false)) return [
                            3,
                            2
                        ];
                        key = options.fetcherKey || getUniqueFetcherId();
                        return [
                            4,
                            routerFetch(key, currentRouteId, options.action || action, {
                                defaultShouldRevalidate: options.defaultShouldRevalidate,
                                preventScrollReset: options.preventScrollReset,
                                formData: formData,
                                body: body,
                                formMethod: options.method || method,
                                formEncType: options.encType || encType,
                                flushSync: options.flushSync
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            routerNavigate(options.action || action, {
                                defaultShouldRevalidate: options.defaultShouldRevalidate,
                                preventScrollReset: options.preventScrollReset,
                                formData: formData,
                                body: body,
                                formMethod: options.method || method,
                                formEncType: options.encType || encType,
                                replace: options.replace,
                                state: options.state,
                                fromRouteId: currentRouteId,
                                flushSync: options.flushSync,
                                viewTransition: options.viewTransition
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function useFormAction(action) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var basename = $5s1kH.useContext(NavigationContext).basename;
    var routeContext = $5s1kH.useContext(RouteContext);
    invariant(routeContext, "useFormAction must be used inside a RouteContext");
    var _routeContext_matches_slice = (0, $6iP9u._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    var path = (0, $hwO3w._)({}, useResolvedPath(action ? action : ".", {
        relative: relative
    }));
    var location = useLocation();
    if (action == null) {
        path.search = location.search;
        var params = new URLSearchParams(path.search);
        var indexValues = params.getAll("index");
        var hasNakedIndexParam = indexValues.some(function(v) {
            return v === "";
        });
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?".concat(qs) : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
function useFetcher() {
    var key = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).key;
    var _route_matches_;
    var router = useDataRouterContext3("useFetcher" /* UseFetcher */ ).router;
    var state = useDataRouterState2("useFetcher" /* UseFetcher */ );
    var fetcherData = $5s1kH.useContext(FetchersContext);
    var route = $5s1kH.useContext(RouteContext);
    var routeId = (_route_matches_ = route.matches[route.matches.length - 1]) === null || _route_matches_ === void 0 ? void 0 : _route_matches_.route.id;
    invariant(fetcherData, "useFetcher must be used inside a FetchersContext");
    invariant(route, "useFetcher must be used inside a RouteContext");
    invariant(routeId != null, 'useFetcher can only be used on routes that contain a unique "id"');
    var defaultKey = $5s1kH.useId();
    var _React10_useState = (0, $6iP9u._)($5s1kH.useState(key || defaultKey), 2), fetcherKey = _React10_useState[0], setFetcherKey = _React10_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    var deleteFetcher = router.deleteFetcher, getFetcher = router.getFetcher, resetFetcher = router.resetFetcher, routerFetch = router.fetch;
    $5s1kH.useEffect(function() {
        getFetcher(fetcherKey);
        return function() {
            return deleteFetcher(fetcherKey);
        };
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    var load = $5s1kH.useCallback(function(href, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(routeId, "No routeId available for fetcher.load()");
                        return [
                            4,
                            routerFetch(fetcherKey, routeId, href, opts)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    var submitImpl = useSubmit();
    var submit = $5s1kH.useCallback(function(target, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            submitImpl(target, (0, $lf4fc._)((0, $hwO3w._)({}, opts), {
                                navigate: false,
                                fetcherKey: fetcherKey
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        fetcherKey,
        submitImpl
    ]);
    var reset = $5s1kH.useCallback(function(opts) {
        return resetFetcher(fetcherKey, opts);
    }, [
        resetFetcher,
        fetcherKey
    ]);
    var FetcherForm = $5s1kH.useMemo(function() {
        var FetcherForm2 = $5s1kH.forwardRef(function(props, ref) {
            return /* @__PURE__ */ $5s1kH.createElement(Form, (0, $lf4fc._)((0, $hwO3w._)({}, props), {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    var fetcher = state.fetchers.get(fetcherKey) || IDLE_FETCHER;
    var data2 = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $5s1kH.useMemo(function() {
        return (0, $lf4fc._)((0, $hwO3w._)({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset
        }, fetcher), {
            data: data2
        });
    }, [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function useFetchers() {
    var state = useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $5s1kH.useMemo(function() {
        return Array.from(state.fetchers.entries()).map(function(param) {
            var _param = (0, $6iP9u._)(param, 2), key = _param[0], fetcher = _param[1];
            return (0, $lf4fc._)((0, $hwO3w._)({}, fetcher), {
                key: key
            });
        });
    }, [
        state.fetchers
    ]);
}
var SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var savedScrollPositions = {};
function getScrollRestorationKey(location, matches, basename, getKey) {
    var key = null;
    if (getKey) {
        if (basename !== "/") key = getKey((0, $lf4fc._)((0, $hwO3w._)({}, location), {
            pathname: stripBasename(location.pathname, basename) || location.pathname
        }), matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function useScrollRestoration() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ ).router;
    var _useDataRouterState2 = useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ ), restoreScrollPosition = _useDataRouterState2.restoreScrollPosition, preventScrollReset = _useDataRouterState2.preventScrollReset;
    var basename = $5s1kH.useContext(NavigationContext).basename;
    var location = useLocation();
    var matches = useMatches();
    var navigation = useNavigation();
    $5s1kH.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    usePageHide($5s1kH.useCallback(function() {
        if (navigation.state === "idle") {
            var key = getScrollRestorationKey(location, matches, basename, getKey);
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {
            warning(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (".concat(error, ")."));
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $5s1kH.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $5s1kH.useLayoutEffect(function() {
            var disableScrollRestoration = router === null || router === void 0 ? void 0 : router.enableScrollRestoration(savedScrollPositions, function() {
                return window.scrollY;
            }, getKey ? function(location2, matches2) {
                return getScrollRestorationKey(location2, matches2, basename, getKey);
            } : void 0);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        $5s1kH.useLayoutEffect(function() {
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch (e) {
                warning(false, '"'.concat(location.hash.slice(1), '" is not a decodable element ID. The view will not scroll to it.'));
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function useBeforeUnload(callback, options) {
    var capture = (options || {}).capture;
    $5s1kH.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $5s1kH.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePrompt(param) {
    var when = param.when, message = param.message;
    var blocker = useBlocker(when);
    $5s1kH.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $5s1kH.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function useViewTransitionState(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var vtContext = $5s1kH.useContext(ViewTransitionContext);
    invariant(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    var basename = useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ ).basename;
    var path = useResolvedPath(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return matchPath(path.pathname, nextPath) != null || matchPath(path.pathname, currentPath) != null;
}
function StaticRouter(param) {
    var basename = param.basename, children = param.children, tmp = param.location, locationProp = tmp === void 0 ? "/" : tmp;
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    var action = "POP" /* Pop */ ;
    var location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    var staticNavigator = getStatelessNavigator();
    return /* @__PURE__ */ $5s1kH.createElement(Router, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function StaticRouterProvider(param) {
    var context = param.context, router = param.router, tmp = param.hydrate, hydrate2 = tmp === void 0 ? true : tmp, nonce = param.nonce;
    invariant(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    var dataRouterContext = {
        router: router,
        navigator: getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    var fetchersContext = /* @__PURE__ */ new Map();
    var hydrateScript = "";
    if (hydrate2 !== false) {
        var data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: serializeErrors(context.errors)
        };
        var json = escapeHtml(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = "window.__staticRouterHydrationData = JSON.parse(".concat(json, ");");
    }
    var state = dataRouterContext.router.state;
    return /* @__PURE__ */ $5s1kH.createElement($5s1kH.Fragment, null, /* @__PURE__ */ $5s1kH.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $5s1kH.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ $5s1kH.createElement(FetchersContext.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $5s1kH.createElement(ViewTransitionContext.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $5s1kH.createElement(Router, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $5s1kH.createElement(DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $5s1kH.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function serializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6iP9u._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            if (isRouteErrorResponse(val)) serialized[key] = (0, $lf4fc._)((0, $hwO3w._)({}, val), {
                __type: "RouteErrorResponse"
            });
            else if (val instanceof Error) serialized[key] = (0, $hwO3w._)({
                message: val.message,
                __type: "Error"
            }, val.name !== "Error" ? {
                __subType: val.name
            } : {});
            else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
function getStatelessNavigator() {
    return {
        createHref: createHref,
        encodeLocation: encodeLocation,
        push: function(to) {
            throw new Error("You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(JSON.stringify(to), ")` somewhere in your app."));
        },
        replace: function(to) {
            throw new Error("You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(JSON.stringify(to), ", { replace: true })` somewhere in your app."));
        },
        go: function(delta) {
            throw new Error("You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(delta, ")` somewhere in your app."));
        },
        back: function() {
            throw new Error("You cannot use navigator.back() on the server because it is a stateless environment.");
        },
        forward: function() {
            throw new Error("You cannot use navigator.forward() on the server because it is a stateless environment.");
        }
    };
}
function createStaticHandler2(routes, opts) {
    return createStaticHandler(routes, (0, $lf4fc._)((0, $hwO3w._)({}, opts), {
        mapRouteProperties: mapRouteProperties
    }));
}
function createStaticRouter(routes, context) {
    var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var manifest = {};
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, void 0, manifest);
    var matches = context.matches.map(function(match) {
        var route = manifest[match.route.id] || match.route;
        return (0, $lf4fc._)((0, $hwO3w._)({}, match), {
            route: route
        });
    });
    var msg = function(method) {
        return "You cannot use router.".concat(method, "() on the server because it is a stateless environment");
    };
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return (0, $hwO3w._)({
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false
            }, opts === null || opts === void 0 ? void 0 : opts.future);
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: IDLE_NAVIGATION,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize: function() {
            throw msg("initialize");
        },
        subscribe: function() {
            throw msg("subscribe");
        },
        enableScrollRestoration: function() {
            throw msg("enableScrollRestoration");
        },
        navigate: function() {
            throw msg("navigate");
        },
        fetch: function() {
            throw msg("fetch");
        },
        revalidate: function() {
            throw msg("revalidate");
        },
        createHref: createHref,
        encodeLocation: encodeLocation,
        getFetcher: function() {
            return IDLE_FETCHER;
        },
        deleteFetcher: function() {
            throw msg("deleteFetcher");
        },
        resetFetcher: function() {
            throw msg("resetFetcher");
        },
        dispose: function() {
            throw msg("dispose");
        },
        getBlocker: function() {
            return IDLE_BLOCKER;
        },
        deleteBlocker: function() {
            throw msg("deleteBlocker");
        },
        patchRoutes: function() {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes: function() {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp: function() {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function createHref(to) {
    return typeof to === "string" ? to : createPath(to);
}
function encodeLocation(to) {
    var href = typeof to === "string" ? to : createPath(to);
    href = href.replace(/ $/, "%20");
    var encoded = ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}

});
parcelRegister("lFIaz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fc6fb07661a5da2d$export$71511d61b312f219; });
function $fc6fb07661a5da2d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $fc6fb07661a5da2d$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $fc6fb07661a5da2d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $fc6fb07661a5da2d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("48Z0s", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $30473b65f259d8de$export$71511d61b312f219; });

var $h50jA = parcelRequire("h50jA");

var $chVq9 = parcelRequire("chVq9");

var $5mEjN = parcelRequire("5mEjN");
function $30473b65f259d8de$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $h50jA._)(derived);
    return (0, $5mEjN._)(_this, (0, $chVq9._)() ? Reflect.construct(derived, args || [], (0, $h50jA._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("h50jA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c6f325d94eb0eb85$export$71511d61b312f219; });
function $c6f325d94eb0eb85$export$71511d61b312f219(o) {
    $c6f325d94eb0eb85$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c6f325d94eb0eb85$export$71511d61b312f219(o);
}

});

parcelRegister("chVq9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8f239d29c896f906$export$71511d61b312f219; });
function $8f239d29c896f906$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($8f239d29c896f906$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("5mEjN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3e7e482c5e75426b$export$71511d61b312f219; });

var $2EdVE = parcelRequire("2EdVE");

var $03bAP = parcelRequire("03bAP");
function $3e7e482c5e75426b$export$71511d61b312f219(self, call) {
    if (call && ((0, $03bAP._)(call) === "object" || typeof call === "function")) return call;
    return (0, $2EdVE._)(self);
}

});
parcelRegister("2EdVE", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1eda1f2f4ab94c84$export$71511d61b312f219; });
function $1eda1f2f4ab94c84$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("5Epmf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $41d45bbab0bf512f$export$71511d61b312f219; });
function $41d45bbab0bf512f$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("9MqXK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $71ed82fc37d6583a$export$71511d61b312f219; });
function $71ed82fc37d6583a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $71ed82fc37d6583a$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $71ed82fc37d6583a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $71ed82fc37d6583a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("dUlz9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a2013be224a9e061$export$71511d61b312f219; });
function $a2013be224a9e061$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("4QAx6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38785b71040674b1$export$71511d61b312f219; });

var $htSO5 = parcelRequire("htSO5");
function $38785b71040674b1$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $htSO5._)(subClass, superClass);
}

});
parcelRegister("htSO5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cb9fa89c658c7b25$export$71511d61b312f219; });
function $cb9fa89c658c7b25$export$71511d61b312f219(o, p) {
    $cb9fa89c658c7b25$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cb9fa89c658c7b25$export$71511d61b312f219(o, p);
}

});


parcelRegister("hwO3w", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cc2c40deea02e5e3$export$71511d61b312f219; });

var $dUlz9 = parcelRequire("dUlz9");
function $cc2c40deea02e5e3$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $dUlz9._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("lf4fc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f76e4a7b6f9c1082$export$71511d61b312f219; });
function $f76e4a7b6f9c1082$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f76e4a7b6f9c1082$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $f76e4a7b6f9c1082$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("54Czb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3b1b3dfd505285fb$export$71511d61b312f219; });

var $1jwIB = parcelRequire("1jwIB");
function $3b1b3dfd505285fb$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $1jwIB._)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("1jwIB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0f50f1fb1e5f70fc$export$71511d61b312f219; });
function $0f50f1fb1e5f70fc$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("6iP9u", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $496c1a3ae0396d37$export$71511d61b312f219; });

var $aemdc = parcelRequire("aemdc");

var $ks8ww = parcelRequire("ks8ww");

var $1F5bK = parcelRequire("1F5bK");

var $7xEKy = parcelRequire("7xEKy");
function $496c1a3ae0396d37$export$71511d61b312f219(arr, i) {
    return (0, $aemdc._)(arr) || (0, $ks8ww._)(arr, i) || (0, $7xEKy._)(arr, i) || (0, $1F5bK._)();
}

});
parcelRegister("aemdc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $772c70fc4032e730$export$71511d61b312f219; });
function $772c70fc4032e730$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("ks8ww", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ee3d08c8ba74331a$export$71511d61b312f219; });
function $ee3d08c8ba74331a$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("1F5bK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $135da520ff5b5c26$export$71511d61b312f219; });
function $135da520ff5b5c26$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("7xEKy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $57db398dbc0275bd$export$71511d61b312f219; });

var $7Wmcv = parcelRequire("7Wmcv");
function $57db398dbc0275bd$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7Wmcv._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7Wmcv._)(o, minLen);
}

});
parcelRegister("7Wmcv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5c7f2bcc050084a8$export$71511d61b312f219; });
function $5c7f2bcc050084a8$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("1SnSh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $15dd5a8bb4def4a4$export$71511d61b312f219; });

var $aemdc = parcelRequire("aemdc");

var $hWLtI = parcelRequire("hWLtI");

var $1F5bK = parcelRequire("1F5bK");

var $7xEKy = parcelRequire("7xEKy");
function $15dd5a8bb4def4a4$export$71511d61b312f219(arr) {
    return (0, $aemdc._)(arr) || (0, $hWLtI._)(arr) || (0, $7xEKy._)(arr) || (0, $1F5bK._)();
}

});
parcelRegister("hWLtI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d10caea79b20a860$export$71511d61b312f219; });
function $d10caea79b20a860$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});


parcelRegister("XnYkK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0b281b2ac994bfb7$export$71511d61b312f219; });

var $1pWfi = parcelRequire("1pWfi");

var $hWLtI = parcelRequire("hWLtI");

var $999XC = parcelRequire("999XC");

var $7xEKy = parcelRequire("7xEKy");
function $0b281b2ac994bfb7$export$71511d61b312f219(arr) {
    return (0, $1pWfi._)(arr) || (0, $hWLtI._)(arr) || (0, $7xEKy._)(arr) || (0, $999XC._)();
}

});
parcelRegister("1pWfi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $10854ea47de0c118$export$71511d61b312f219; });

var $7Wmcv = parcelRequire("7Wmcv");
function $10854ea47de0c118$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $7Wmcv._)(arr);
}

});

parcelRegister("999XC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6a8cae4be5a277c2$export$71511d61b312f219; });
function $6a8cae4be5a277c2$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("kW1tL", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f3da5f2947b88762$export$71511d61b312f219; });

var $wi0Hz = parcelRequire("wi0Hz");

var $h50jA = parcelRequire("h50jA");

var $Y8Q8d = parcelRequire("Y8Q8d");

var $htSO5 = parcelRequire("htSO5");
function $f3da5f2947b88762$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $f3da5f2947b88762$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $Y8Q8d._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $wi0Hz._)(Class, arguments, (0, $h50jA._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $htSO5._)(Wrapper, Class);
    };
    return $f3da5f2947b88762$export$71511d61b312f219(Class);
}

});
parcelRegister("wi0Hz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0610f5bf7ffe87d6$export$71511d61b312f219; });

var $chVq9 = parcelRequire("chVq9");

var $htSO5 = parcelRequire("htSO5");
function $0610f5bf7ffe87d6$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $chVq9._)()) $0610f5bf7ffe87d6$export$71511d61b312f219 = Reflect.construct;
    else $0610f5bf7ffe87d6$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $htSO5._)(instance, Class.prototype);
        return instance;
    };
    return $0610f5bf7ffe87d6$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("Y8Q8d", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0b4c761e01a13929$export$71511d61b312f219; });
function $0b4c761e01a13929$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("3SMYb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2d3c66a11f08abda$export$71511d61b312f219; });
function $2d3c66a11f08abda$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});

parcelRegister("4WD8g", function(module, exports) {

$parcel$export(module.exports, "__values", function () { return $b94e76e708679dc5$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $03bAP = parcelRequire("03bAP");
var $b94e76e708679dc5$var$extendStatics = function extendStatics1(d, b) {
    $b94e76e708679dc5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b94e76e708679dc5$var$extendStatics(d, b);
};
function $b94e76e708679dc5$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b94e76e708679dc5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b94e76e708679dc5$export$18ce0697a983be9b = function __assign1() {
    $b94e76e708679dc5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b94e76e708679dc5$export$18ce0697a983be9b.apply(this, arguments);
};
function $b94e76e708679dc5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b94e76e708679dc5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $03bAP._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b94e76e708679dc5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b94e76e708679dc5$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $03bAP._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $b94e76e708679dc5$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $b94e76e708679dc5$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $03bAP._)(x)) === "symbol" ? x : "".concat(x);
}
function $b94e76e708679dc5$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $03bAP._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $b94e76e708679dc5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $03bAP._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b94e76e708679dc5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b94e76e708679dc5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $b94e76e708679dc5$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $b94e76e708679dc5$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $b94e76e708679dc5$export$45d3717a4c69092e(o, m, p);
}
function $b94e76e708679dc5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b94e76e708679dc5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b94e76e708679dc5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b94e76e708679dc5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b94e76e708679dc5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b94e76e708679dc5$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $b94e76e708679dc5$export$10c90e4f7922046c(v) {
    return this instanceof $b94e76e708679dc5$export$10c90e4f7922046c ? (this.v = v, this) : new $b94e76e708679dc5$export$10c90e4f7922046c(v);
}
function $b94e76e708679dc5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b94e76e708679dc5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b94e76e708679dc5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b94e76e708679dc5$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $b94e76e708679dc5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b94e76e708679dc5$export$19a8beecd37a4c45 === "function" ? $b94e76e708679dc5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b94e76e708679dc5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $b94e76e708679dc5$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $b94e76e708679dc5$var$ownKeys = function ownKeys1(o) {
    $b94e76e708679dc5$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $b94e76e708679dc5$var$ownKeys(o);
};
function $b94e76e708679dc5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $b94e76e708679dc5$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $b94e76e708679dc5$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $b94e76e708679dc5$var$__setModuleDefault(result, mod);
    return result;
}
function $b94e76e708679dc5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b94e76e708679dc5$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $b94e76e708679dc5$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $b94e76e708679dc5$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $03bAP._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $b94e76e708679dc5$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $b94e76e708679dc5$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $b94e76e708679dc5$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $b94e76e708679dc5$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $b94e76e708679dc5$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $b94e76e708679dc5$export$2e2bcd8739ae039 = {
    __extends: $b94e76e708679dc5$export$a8ba968b8961cb8a,
    __assign: $b94e76e708679dc5$export$18ce0697a983be9b,
    __rest: $b94e76e708679dc5$export$3c9a16f847548506,
    __decorate: $b94e76e708679dc5$export$29e00dfd3077644b,
    __param: $b94e76e708679dc5$export$d5ad3fd78186038f,
    __esDecorate: $b94e76e708679dc5$export$3a84e1ae4e97e9b0,
    __runInitializers: $b94e76e708679dc5$export$d831c04e792af3d,
    __propKey: $b94e76e708679dc5$export$6a2a36740a146cb8,
    __setFunctionName: $b94e76e708679dc5$export$d1a06452d3489bc7,
    __metadata: $b94e76e708679dc5$export$f1db080c865becb9,
    __awaiter: $b94e76e708679dc5$export$1050f835b63b671e,
    __generator: $b94e76e708679dc5$export$67ebef60e6f28a6,
    __createBinding: $b94e76e708679dc5$export$45d3717a4c69092e,
    __exportStar: $b94e76e708679dc5$export$f33643c0debef087,
    __values: $b94e76e708679dc5$export$19a8beecd37a4c45,
    __read: $b94e76e708679dc5$export$8d051b38c9118094,
    __spread: $b94e76e708679dc5$export$afc72e2116322959,
    __spreadArrays: $b94e76e708679dc5$export$6388937ca91ccae8,
    __spreadArray: $b94e76e708679dc5$export$1216008129fb82ed,
    __await: $b94e76e708679dc5$export$10c90e4f7922046c,
    __asyncGenerator: $b94e76e708679dc5$export$e427f37a30a4de9b,
    __asyncDelegator: $b94e76e708679dc5$export$bbd80228419bb833,
    __asyncValues: $b94e76e708679dc5$export$e3b29a3d6162315f,
    __makeTemplateObject: $b94e76e708679dc5$export$4fb47efe1390b86f,
    __importStar: $b94e76e708679dc5$export$c21735bcef00d192,
    __importDefault: $b94e76e708679dc5$export$da59b14a69baef04,
    __classPrivateFieldGet: $b94e76e708679dc5$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $b94e76e708679dc5$export$d40a35129aaff81f,
    __classPrivateFieldIn: $b94e76e708679dc5$export$81fdc39f203e4e04,
    __addDisposableResource: $b94e76e708679dc5$export$88ac25d8e944e405,
    __disposeResources: $b94e76e708679dc5$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $b94e76e708679dc5$export$889dfb5d17574b0b
};

});


parcelRegister("9vYiD", function(module, exports) {
"use strict";
var $6ed5c88d95cc49d3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ed5c88d95cc49d3$var$StyleToObject;

var $6ed5c88d95cc49d3$var$inline_style_parser_1 = $6ed5c88d95cc49d3$var$__importDefault((parcelRequire("4Ls62")));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function $6ed5c88d95cc49d3$var$StyleToObject(style, iterator) {
    var styleObject = null;
    if (!style || typeof style !== 'string') return styleObject;
    var declarations = (0, $6ed5c88d95cc49d3$var$inline_style_parser_1.default)(style);
    var hasIterator = typeof iterator === 'function';
    declarations.forEach(function(declaration) {
        if (declaration.type !== 'declaration') return;
        var property = declaration.property, value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}

});
parcelRegister("4Ls62", function(module, exports) {
'use strict';
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $37815892a0b93849$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $37815892a0b93849$var$NEWLINE_REGEX = /\n/g;
var $37815892a0b93849$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $37815892a0b93849$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $37815892a0b93849$var$COLON_REGEX = /^:\s*/;
var $37815892a0b93849$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $37815892a0b93849$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $37815892a0b93849$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $37815892a0b93849$var$NEWLINE = '\n';
var $37815892a0b93849$var$FORWARD_SLASH = '/';
var $37815892a0b93849$var$ASTERISK = '*';
var $37815892a0b93849$var$EMPTY_STRING = '';
// types
var $37815892a0b93849$var$TYPE_COMMENT = 'comment';
var $37815892a0b93849$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ function $37815892a0b93849$var$index(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($37815892a0b93849$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($37815892a0b93849$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) ;
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($37815892a0b93849$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($37815892a0b93849$var$FORWARD_SLASH != style.charAt(0) || $37815892a0b93849$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($37815892a0b93849$var$EMPTY_STRING != style.charAt(i) && ($37815892a0b93849$var$ASTERISK != style.charAt(i) || $37815892a0b93849$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($37815892a0b93849$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $37815892a0b93849$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($37815892a0b93849$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($37815892a0b93849$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($37815892a0b93849$var$VALUE_REGEX);
        var ret = pos({
            type: $37815892a0b93849$var$TYPE_DECLARATION,
            property: $37815892a0b93849$var$trim(prop[0].replace($37815892a0b93849$var$COMMENT_REGEX, $37815892a0b93849$var$EMPTY_STRING)),
            value: val ? $37815892a0b93849$var$trim(val[0].replace($37815892a0b93849$var$COMMENT_REGEX, $37815892a0b93849$var$EMPTY_STRING)) : $37815892a0b93849$var$EMPTY_STRING
        });
        // ;
        match($37815892a0b93849$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
}
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $37815892a0b93849$var$trim(str) {
    return str ? str.replace($37815892a0b93849$var$TRIM_REGEX, $37815892a0b93849$var$EMPTY_STRING) : $37815892a0b93849$var$EMPTY_STRING;
}
module.exports = $37815892a0b93849$var$index;

});


parcelRegister("aTwoM", function(module, exports) {

$parcel$export(module.exports, "keyFromSelector", function () { return keysFromSelector; });
$parcel$export(module.exports, "default", function () { return instance; });
$parcel$export(module.exports, "createInstance", function () { return createInstance; });
$parcel$export(module.exports, "dir", function () { return dir; });
$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "loadResources", function () { return loadResources; });
$parcel$export(module.exports, "reloadResources", function () { return reloadResources; });
$parcel$export(module.exports, "use", function () { return use; });
$parcel$export(module.exports, "changeLanguage", function () { return changeLanguage; });
$parcel$export(module.exports, "getFixedT", function () { return getFixedT; });
$parcel$export(module.exports, "t", function () { return t; });
$parcel$export(module.exports, "exists", function () { return exists; });
$parcel$export(module.exports, "setDefaultNamespace", function () { return setDefaultNamespace; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return hasLoadedNamespace; });
$parcel$export(module.exports, "loadNamespaces", function () { return loadNamespaces; });
$parcel$export(module.exports, "loadLanguages", function () { return loadLanguages; });

var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $5mEjN = parcelRequire("5mEjN");

var $6iP9u = parcelRequire("6iP9u");

var $1SnSh = parcelRequire("1SnSh");

var $XnYkK = parcelRequire("XnYkK");

var $03bAP = parcelRequire("03bAP");
var isString = function(obj) {
    return typeof obj === 'string';
};
var defer = function() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
var makeString = function(object) {
    if (object == null) return '';
    return String(object);
};
var copy = function(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
};
var lastOfPathSeparatorRegExp = /###/g;
var cleanKey = function(key) {
    return key && key.includes('###') ? key.replace(lastOfPathSeparatorRegExp, '.') : key;
};
var canNotTraverseDeeper = function(object) {
    return !object || isString(object);
};
var getLastOfPath = function(object, path, Empty) {
    var stack = !isString(path) ? path : path.split('.');
    var stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if (canNotTraverseDeeper(object)) return {};
        var key = cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if (canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: cleanKey(stack[stackIndex])
    };
};
var setPath = function(object, path, newValue) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    var e = path[path.length - 1];
    var p = path.slice(0, path.length - 1);
    var last = getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = "".concat(p[p.length - 1], ".").concat(e);
        p = p.slice(0, p.length - 1);
        last = getLastOfPath(object, p, Object);
        if ((last === null || last === void 0 ? void 0 : last.obj) && typeof last.obj["".concat(last.k, ".").concat(e)] !== 'undefined') last.obj = undefined;
    }
    last.obj["".concat(last.k, ".").concat(e)] = newValue;
};
var pushPath = function(object, path, newValue, concat) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
var getPath = function(object, path) {
    var _getLastOfPath = getLastOfPath(object, path), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
var getPathWithDefaults = function(data, defaultData, key) {
    var value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
};
var deepExtend = function(target, source, overwrite) {
    for(var prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (Object.prototype.hasOwnProperty.call(target, prop)) {
            if (isString(target[prop]) || target[prop] instanceof String || isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
var regexEscape = function(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};
var _entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
var escape = function(data) {
    if (isString(data)) return data.replace(/[&<>"'\/]/g, function(s) {
        return _entityMap[s];
    });
    return data;
};
var RegExpCache = /*#__PURE__*/ function() {
    "use strict";
    function RegExpCache(capacity) {
        (0, $5Epmf._)(this, RegExpCache);
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    (0, $9MqXK._)(RegExpCache, [
        {
            key: "getRegExp",
            value: function getRegExp(pattern) {
                var regExpFromCache = this.regExpMap.get(pattern);
                if (regExpFromCache !== undefined) return regExpFromCache;
                var regExpNew = new RegExp(pattern);
                if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
                this.regExpMap.set(pattern, regExpNew);
                this.regExpQueue.push(pattern);
                return regExpNew;
            }
        }
    ]);
    return RegExpCache;
}();
var chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
var looksLikeObjectPathRegExpCache = new RegExpCache(20);
var looksLikeObjectPath = function(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    var possibleChars = chars.filter(function(c) {
        return !nsSeparator.includes(c) && !keySeparator.includes(c);
    });
    if (possibleChars.length === 0) return true;
    var r = looksLikeObjectPathRegExpCache.getRegExp("(".concat(possibleChars.map(function(c) {
        return c === '?' ? '\\?' : c;
    }).join('|'), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
var deepFind = function(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    var tokens = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < tokens.length;){
        if (!current || (typeof current === "undefined" ? "undefined" : (0, $03bAP._)(current)) !== 'object') return undefined;
        var next = void 0;
        var nextPath = '';
        for(var j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].includes(typeof next === "undefined" ? "undefined" : (0, $03bAP._)(next)) && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
var getCleanedCode = function(code) {
    return code === null || code === void 0 ? void 0 : code.replace(/_/g, '-');
};
var consoleLogger = {
    type: 'logger',
    log: function(args) {
        this.output('log', args);
    },
    warn: function(args) {
        this.output('warn', args);
    },
    error: function(args) {
        this.output('error', args);
    },
    output: function(type, args) {
        var _console_type_apply, _console_type, _console;
        (_console = console) === null || _console === void 0 ? void 0 : (_console_type = _console[type]) === null || _console_type === void 0 ? void 0 : (_console_type_apply = _console_type.apply) === null || _console_type_apply === void 0 ? void 0 : _console_type_apply.call(_console_type, console, args);
    }
};
var Logger = /*#__PURE__*/ function() {
    "use strict";
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $5Epmf._)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $9MqXK._)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.prefix = options.prefix || 'i18next:';
                this.logger = concreteLogger || consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return this.forward(args, 'log', '', true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return this.forward(args, 'warn', '', true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return this.forward(args, 'error', '');
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                args = args.map(function(a) {
                    return isString(a) ? a.replace(/[\r\n\x00-\x1F\x7F]/g, ' ') : a;
                });
                if (isString(args[0])) args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, (0, $hwO3w._)({
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }, this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = /*#__PURE__*/ function() {
    "use strict";
    function EventEmitter() {
        (0, $5Epmf._)(this, EventEmitter);
        this.observers = {};
    }
    (0, $9MqXK._)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(' ').forEach(function(event) {
                    if (!_this.observers[event]) _this.observers[event] = new Map();
                    var numListeners = _this.observers[event].get(listener) || 0;
                    _this.observers[event].set(listener, numListeners + 1);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event].delete(listener);
            }
        },
        {
            key: "once",
            value: function once(event, listener) {
                var _this = this;
                var wrapper = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    listener.apply(void 0, (0, $XnYkK._)(args));
                    _this.off(event, wrapper);
                };
                this.on(event, wrapper);
                return this;
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (this.observers[event]) {
                    var cloned = Array.from(this.observers[event].entries());
                    cloned.forEach(function(param) {
                        var _param = (0, $6iP9u._)(param, 2), observer = _param[0], numTimesAdded = _param[1];
                        for(var i = 0; i < numTimesAdded; i++)observer.apply(void 0, (0, $XnYkK._)(args));
                    });
                }
                if (this.observers['*']) {
                    var cloned1 = Array.from(this.observers['*'].entries());
                    cloned1.forEach(function(param) {
                        var _param = (0, $6iP9u._)(param, 2), observer = _param[0], numTimesAdded = _param[1];
                        for(var i = 0; i < numTimesAdded; i++)observer.apply(void 0, [
                            event
                        ].concat((0, $XnYkK._)(args)));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
var ResourceStore = /*#__PURE__*/ function(EventEmitter) {
    "use strict";
    (0, $4QAx6._)(ResourceStore, EventEmitter);
    function ResourceStore(data) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        (0, $5Epmf._)(this, ResourceStore);
        var _this;
        _this = (0, $48Z0s._)(this, ResourceStore);
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $9MqXK._)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (!this.options.ns.includes(ns)) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var _this_data_lng, _this_data;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path;
                if (lng.includes('.')) path = lng.split('.');
                else {
                    path = [
                        lng,
                        ns
                    ];
                    if (key) {
                        var _path, _path1;
                        if (Array.isArray(key)) (_path = path).push.apply(_path, (0, $XnYkK._)(key));
                        else if (isString(key) && keySeparator) (_path1 = path).push.apply(_path1, (0, $XnYkK._)(key.split(keySeparator)));
                        else path.push(key);
                    }
                }
                var result = getPath(this.data, path);
                if (!result && !ns && !key && lng.includes('.')) {
                    lng = path[0];
                    ns = path[1];
                    key = path.slice(2).join('.');
                }
                if (result || !ignoreJSONStructure || !isString(key)) return result;
                return deepFind((_this_data = this.data) === null || _this_data === void 0 ? void 0 : (_this_data_lng = _this_data[lng]) === null || _this_data_lng === void 0 ? void 0 : _this_data_lng[ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
                    silent: false
                };
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.includes('.')) {
                    path = lng.split('.');
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                setPath(this.data, path, value);
                if (!options.silent) this.emit('added', lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
                    silent: false,
                    skipCopy: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.includes('.')) {
                    path = lng.split('.');
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = getPath(this.data, path) || {};
                if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
                if (deep) deepExtend(pack, resources, overwrite);
                else pack = (0, $hwO3w._)({}, pack, resources);
                setPath(this.data, path, pack);
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit('removed', lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}(EventEmitter);
var postProcessor = {
    processors: {},
    addPostProcessor: function(module) {
        this.processors[module.name] = module;
    },
    handle: function(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            var _this_processors_processor;
            var _this_processors_processor_process;
            value = (_this_processors_processor_process = (_this_processors_processor = _this.processors[processor]) === null || _this_processors_processor === void 0 ? void 0 : _this_processors_processor.process(value, key, options, translator)) !== null && _this_processors_processor_process !== void 0 ? _this_processors_processor_process : value;
        });
        return value;
    }
};
var PATH_KEY = Symbol('i18next/PATH_KEY');
function createProxy() {
    var state = [];
    var handler = Object.create(null);
    var proxy;
    handler.get = function(target, key) {
        var _proxy_revoke;
        proxy === null || proxy === void 0 ? void 0 : (_proxy_revoke = proxy.revoke) === null || _proxy_revoke === void 0 ? void 0 : _proxy_revoke.call(proxy);
        if (key === PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function keysFromSelector(selector, opts) {
    var _selector = selector(createProxy()), path = _selector[PATH_KEY];
    var _opts_keySeparator;
    var keySeparator = (_opts_keySeparator = opts === null || opts === void 0 ? void 0 : opts.keySeparator) !== null && _opts_keySeparator !== void 0 ? _opts_keySeparator : '.';
    var _opts_nsSeparator;
    var nsSeparator = (_opts_nsSeparator = opts === null || opts === void 0 ? void 0 : opts.nsSeparator) !== null && _opts_nsSeparator !== void 0 ? _opts_nsSeparator : ':';
    var strict = (opts === null || opts === void 0 ? void 0 : opts.enableSelector) === 'strict';
    if (path.length > 1 && nsSeparator) {
        var ns = opts === null || opts === void 0 ? void 0 : opts.ns;
        var nsList = strict ? Array.isArray(ns) ? ns : ns ? [
            ns
        ] : null : Array.isArray(ns) ? ns : null;
        if (nsList) {
            var candidates = strict ? nsList : nsList.length > 1 ? nsList.slice(1) : [];
            if (candidates.includes(path[0])) return "".concat(path[0]).concat(nsSeparator).concat(path.slice(1).join(keySeparator));
        }
    }
    return path.join(keySeparator);
}
var shouldHandleAsObject = function(res) {
    return !isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
};
var Translator = /*#__PURE__*/ function(EventEmitter) {
    "use strict";
    (0, $4QAx6._)(Translator, EventEmitter);
    function Translator(services) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $5Epmf._)(this, Translator);
        var _this;
        _this = (0, $48Z0s._)(this, Translator);
        copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, _this);
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        _this.logger = baseLogger.create('translator');
        _this.checkedLoadedFor = {};
        return _this;
    }
    (0, $9MqXK._)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                    interpolation: {}
                };
                var opt = (0, $hwO3w._)({}, o);
                if (key == null) return false;
                var resolved = this.resolve(key, opt);
                if ((resolved === null || resolved === void 0 ? void 0 : resolved.res) === undefined) return false;
                var isObject = shouldHandleAsObject(resolved.res);
                if (opt.returnObjects === false && isObject) return false;
                return true;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, opt) {
                var nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ':';
                var keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
                var namespaces = opt.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.includes(nsSeparator);
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: isString(namespaces) ? [
                            namespaces
                        ] : namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.includes(parts[0])) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                return {
                    key: key,
                    namespaces: isString(namespaces) ? [
                        namespaces
                    ] : namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, o, lastKey) {
                var _this = this;
                var opt = (typeof o === "undefined" ? "undefined" : (0, $03bAP._)(o)) === 'object' ? (0, $hwO3w._)({}, o) : o;
                if ((typeof opt === "undefined" ? "undefined" : (0, $03bAP._)(opt)) !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
                if ((typeof opt === "undefined" ? "undefined" : (0, $03bAP._)(opt)) === 'object') opt = (0, $hwO3w._)({}, opt);
                if (!opt) opt = {};
                if (keys == null) return '';
                if (typeof keys === 'function') keys = keysFromSelector(keys, (0, $hwO3w._)({}, this.options, opt));
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                keys = keys.map(function(k) {
                    return typeof k === 'function' ? keysFromSelector(k, (0, $hwO3w._)({}, _this.options, opt)) : String(k);
                });
                var returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
                var keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
                var _this_extractFromKey = this.extractFromKey(keys[keys.length - 1], opt), key = _this_extractFromKey.key, namespaces = _this_extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ':';
                var lng = opt.lng || this.language;
                var appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if ((lng === null || lng === void 0 ? void 0 : lng.toLowerCase()) === 'cimode') {
                    if (appendNamespaceToCIMode) {
                        if (returnDetails) return {
                            res: "".concat(namespace).concat(nsSeparator).concat(key),
                            usedKey: key,
                            exactUsedKey: key,
                            usedLng: lng,
                            usedNS: namespace,
                            usedParams: this.getUsedParamsDetails(opt)
                        };
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) return {
                        res: key,
                        usedKey: key,
                        exactUsedKey: key,
                        usedLng: lng,
                        usedNS: namespace,
                        usedParams: this.getUsedParamsDetails(opt)
                    };
                    return key;
                }
                var resolved = this.resolve(keys, opt);
                var res = resolved === null || resolved === void 0 ? void 0 : resolved.res;
                var resUsedKey = (resolved === null || resolved === void 0 ? void 0 : resolved.usedKey) || key;
                var resExactUsedKey = (resolved === null || resolved === void 0 ? void 0 : resolved.exactUsedKey) || key;
                var noObject = [
                    '[object Number]',
                    '[object Function]',
                    '[object RegExp]'
                ];
                var joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var needsPluralHandling = opt.count !== undefined && !isString(opt.count);
                var hasDefaultValue = Translator.hasDefaultValue(opt);
                var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
                var defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
                    ordinal: false
                }) : '';
                var needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
                var defaultValue = needsZeroSuffixLookup && opt["defaultValue".concat(this.options.pluralSeparator, "zero")] || opt["defaultValue".concat(defaultValueSuffix)] || opt["defaultValue".concat(defaultValueSuffixOrdinalFallback)] || opt.defaultValue;
                var resForObjHndl = res;
                if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
                var handleAsObject = shouldHandleAsObject(resForObjHndl);
                var resType = Object.prototype.toString.apply(resForObjHndl);
                if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && !noObject.includes(resType) && !(isString(joinArrays) && Array.isArray(resForObjHndl))) {
                    if (!opt.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, (0, $lf4fc._)((0, $hwO3w._)({}, opt), {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            resolved.usedParams = this.getUsedParamsDetails(opt);
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = Array.isArray(resForObjHndl);
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, (0, $lf4fc._)((0, $hwO3w._)({}, opt), {
                                defaultValue: shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                                joinArrays: false,
                                ns: namespaces
                            }));
                            else copy[m] = this.translate(deepKey, (0, $lf4fc._)((0, $hwO3w._)({}, opt), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && isString(joinArrays) && Array.isArray(res)) {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, opt, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, needsPluralHandling && !updateMissing ? "".concat(key).concat(this.pluralResolver.getSuffix(lng, opt.count, opt)) : key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, (0, $lf4fc._)((0, $hwO3w._)({}, opt), {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                        else lngs.push(opt.lng || this.language);
                        var send = function(l, k, specificDefaultValue) {
                            var _this_backendConnector;
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this.options.missingKeyHandler) _this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                            else if ((_this_backendConnector = _this.backendConnector) === null || _this_backendConnector === void 0 ? void 0 : _this_backendConnector.saveMissing) _this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                            _this.emit('missingKey', l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                var suffixes = _this.pluralResolver.getSuffixes(language, opt);
                                if (needsZeroSuffixLookup && opt["defaultValue".concat(_this.options.pluralSeparator, "zero")] && !suffixes.includes("".concat(_this.options.pluralSeparator, "zero"))) suffixes.push("".concat(_this.options.pluralSeparator, "zero"));
                                suffixes.forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, opt["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, opt, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace).concat(nsSeparator).concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace).concat(nsSeparator).concat(key) : key, usedDefault ? res : undefined, opt);
                }
                if (returnDetails) {
                    resolved.res = res;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, opt, resolved, lastKey) {
                var _this_i18nFormat;
                if ((_this_i18nFormat = this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.parse) res = this.i18nFormat.parse(res, (0, $hwO3w._)({}, this.options.interpolation.defaultVariables, opt), opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!opt.skipInterpolation) {
                    var _this = this;
                    var _opt_interpolation;
                    if (opt.interpolation) this.interpolator.init((0, $lf4fc._)((0, $hwO3w._)({}, opt), {
                        interpolation: (0, $hwO3w._)({}, this.options.interpolation, opt.interpolation)
                    }));
                    var skipOnVariables = isString(res) && ((opt === null || opt === void 0 ? void 0 : (_opt_interpolation = opt.interpolation) === null || _opt_interpolation === void 0 ? void 0 : _opt_interpolation.skipOnVariables) !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = opt.replace && !isString(opt.replace) ? opt.replace : opt;
                    if (this.options.interpolation.defaultVariables) data = (0, $hwO3w._)({}, this.options.interpolation.defaultVariables, data);
                    res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) opt.nest = false;
                    }
                    if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
                    if (opt.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        if ((lastKey === null || lastKey === void 0 ? void 0 : lastKey[0]) === args[0] && !opt.context) {
                            _this.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this.translate.apply(_this, (0, $XnYkK._)(args).concat([
                            key
                        ]));
                    }, opt);
                    if (opt.interpolation) this.interpolator.reset();
                }
                var postProcess = opt.postProcess || this.options.postProcess;
                var postProcessorNames = isString(postProcess) ? [
                    postProcess
                ] : postProcess;
                if (res != null && (postProcessorNames === null || postProcessorNames === void 0 ? void 0 : postProcessorNames.length) && opt.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? (0, $hwO3w._)({
                    i18nResolved: (0, $lf4fc._)((0, $hwO3w._)({}, resolved), {
                        usedParams: this.getUsedParamsDetails(opt)
                    })
                }, opt) : opt, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this = this;
                var opt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (isString(keys)) keys = [
                    keys
                ];
                if (Array.isArray(keys)) keys = keys.map(function(k) {
                    return typeof k === 'function' ? keysFromSelector(k, (0, $hwO3w._)({}, _this.options, opt)) : k;
                });
                keys.forEach(function(k) {
                    if (_this.isValidLookup(found)) return;
                    var extracted = _this.extractFromKey(k, opt);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this.options.fallbackNS) namespaces = namespaces.concat(_this.options.fallbackNS);
                    var needsPluralHandling = opt.count !== undefined && !isString(opt.count);
                    var needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
                    var needsContextHandling = opt.context !== undefined && (isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
                    var codes = opt.lngs ? opt.lngs : _this.languageUtils.toResolveHierarchy(opt.lng || _this.language, opt.fallbackLng);
                    namespaces.forEach(function(ns) {
                        var _this_utils, _this_utils1;
                        if (_this.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!_this.checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && ((_this_utils = _this.utils) === null || _this_utils === void 0 ? void 0 : _this_utils.hasLoadedNamespace) && !((_this_utils1 = _this.utils) === null || _this_utils1 === void 0 ? void 0 : _this_utils1.hasLoadedNamespace(usedNS))) {
                            _this.checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(', '), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                        }
                        codes.forEach(function(code) {
                            var _this_i18nFormat;
                            if (_this.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if ((_this_i18nFormat = _this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.addLookupKeys) _this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this.pluralResolver.getSuffix(code, opt.count, opt);
                                var zeroSuffix = "".concat(_this.options.pluralSeparator, "zero");
                                var ordinalPrefix = "".concat(_this.options.pluralSeparator, "ordinal").concat(_this.options.pluralSeparator);
                                if (needsPluralHandling) {
                                    if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, _this.options.pluralSeparator));
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this.options.contextSeparator || '_').concat(opt.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, _this.options.pluralSeparator));
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this.getResource(code, ns, possibleKey, opt);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var _this_i18nFormat;
                if ((_this_i18nFormat = this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        },
        {
            key: "getUsedParamsDetails",
            value: function getUsedParamsDetails() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var optionsKeys = [
                    'defaultValue',
                    'ordinal',
                    'context',
                    'replace',
                    'lng',
                    'lngs',
                    'fallbackLng',
                    'ns',
                    'keySeparator',
                    'nsSeparator',
                    'returnObjects',
                    'returnDetails',
                    'joinArrays',
                    'postProcess',
                    'interpolation'
                ];
                var useOptionsReplaceForData = options.replace && !isString(options.replace);
                var data = useOptionsReplaceForData ? options.replace : options;
                if (useOptionsReplaceForData && typeof options.count !== 'undefined') data = (0, $lf4fc._)((0, $hwO3w._)({}, data), {
                    count: options.count
                });
                if (this.options.interpolation.defaultVariables) data = (0, $hwO3w._)({}, this.options.interpolation.defaultVariables, data);
                if (!useOptionsReplaceForData) {
                    data = (0, $hwO3w._)({}, data);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = optionsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            delete data[key];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return data;
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = 'defaultValue';
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && option.startsWith(prefix) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}(EventEmitter);
var LanguageUtil = /*#__PURE__*/ function() {
    "use strict";
    function LanguageUtil(options) {
        (0, $5Epmf._)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create('languageUtils');
        this.resolveHierarchyCache = {};
    }
    (0, $9MqXK._)(LanguageUtil, [
        {
            key: "clearCache",
            value: function clearCache() {
                this.resolveHierarchyCache = {};
            }
        },
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                code = getCleanedCode(code);
                if (!code || !code.includes('-')) return null;
                var p = code.split('-');
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === 'x') return null;
                return this.formatLanguageCode(p.join('-'));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                code = getCleanedCode(code);
                if (!code || !code.includes('-')) return code;
                var p = code.split('-');
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (isString(code) && code.includes('-')) {
                    var formattedCode;
                    try {
                        formattedCode = Intl.getCanonicalLocales(code)[0];
                    } catch (e) {}
                    if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
                    if (formattedCode) return formattedCode;
                    if (this.options.lowerCaseLng) return code.toLowerCase();
                    return code;
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.includes(code);
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngScOnly = _this.getScriptPartFromCode(code);
                    if (_this.isSupportedCode(lngScOnly)) return found = lngScOnly;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng === lngOnly) return true;
                        if (!supportedLng.includes('-') && !lngOnly.includes('-')) return false;
                        if (supportedLng.includes('-') && !lngOnly.includes('-') && supportedLng.slice(0, supportedLng.indexOf('-')) === lngOnly) return true;
                        if (supportedLng.startsWith(lngOnly) && lngOnly.length > 1) return true;
                        return false;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
                if (isString(fallbacks)) fallbacks = [
                    fallbacks
                ];
                if (Array.isArray(fallbacks)) return fallbacks;
                if (!code) return fallbacks.default || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks.default;
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this = this;
                var fallbackLng = this.options.fallbackLng;
                var fallbackLngKey = Array.isArray(fallbackLng) ? fallbackLng.join('|') : fallbackLng;
                if (fallbackLngKey !== this._cachedFallbackLng) {
                    this.resolveHierarchyCache = {};
                    this._cachedFallbackLng = fallbackLngKey;
                }
                var hasCacheableFallback = fallbackCode === undefined || fallbackCode === false || isString(fallbackCode);
                var usesUncacheableOptionsFallback = fallbackCode === undefined && typeof this.options.fallbackLng === 'function';
                var cacheable = isString(code) && hasCacheableFallback && !usesUncacheableOptionsFallback;
                var cacheKey = null;
                if (cacheable) {
                    var fallbackCacheKey;
                    if (fallbackCode === undefined) fallbackCacheKey = 'undefined';
                    else if (fallbackCode === false) fallbackCacheKey = 'boolean:false';
                    else fallbackCacheKey = "string:".concat(fallbackCode);
                    cacheKey = "".concat(code.length, ":").concat(code, "|").concat(fallbackCacheKey);
                }
                if (cacheKey !== null) {
                    var cached = this.resolveHierarchyCache[cacheKey];
                    if (cached !== undefined) return cached.slice();
                }
                var fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function(c) {
                    if (!c) return;
                    if (_this.isSupportedCode(c)) codes.push(c);
                    else _this.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (isString(code) && (code.includes('-') || code.includes('_'))) {
                    if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
                    if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
                } else if (isString(code)) addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (!codes.includes(fc)) addCode(_this.formatLanguageCode(fc));
                });
                if (cacheKey !== null) {
                    this.resolveHierarchyCache[cacheKey] = codes;
                    return codes.slice();
                }
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
var dummyRule = {
    select: function(count) {
        return count === 1 ? 'one' : 'other';
    },
    resolvedOptions: function() {
        return {
            pluralCategories: [
                'one',
                'other'
            ]
        };
    }
};
var PluralResolver = /*#__PURE__*/ function() {
    "use strict";
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $5Epmf._)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    (0, $9MqXK._)(PluralResolver, [
        {
            key: "clearCache",
            value: function clearCache() {
                this.pluralRulesCache = {};
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var cleanedCode = getCleanedCode(code === 'dev' ? 'en' : code);
                var type = options.ordinal ? 'ordinal' : 'cardinal';
                var cacheKey = JSON.stringify({
                    cleanedCode: cleanedCode,
                    type: type
                });
                if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
                var rule;
                try {
                    rule = new Intl.PluralRules(cleanedCode, {
                        type: type
                    });
                } catch (err) {
                    if (typeof Intl === 'undefined') {
                        this.logger.error('No Intl support, please use an Intl polyfill!');
                        return dummyRule;
                    }
                    if (!code.match(/-|_/)) return dummyRule;
                    var lngPart = this.languageUtils.getLanguagePartFromCode(code);
                    rule = this.getRule(lngPart, options);
                }
                this.pluralRulesCache[cacheKey] = rule;
                return rule;
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) rule = this.getRule('dev', options);
                return (rule === null || rule === void 0 ? void 0 : rule.resolvedOptions().pluralCategories.length) > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) rule = this.getRule('dev', options);
                if (!rule) return [];
                return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(options.ordinal ? "ordinal".concat(_this.options.prepend) : '').concat(pluralCategory);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) return "".concat(this.options.prepend).concat(options.ordinal ? "ordinal".concat(this.options.prepend) : '').concat(rule.select(count));
                this.logger.warn("no plural rule found for: ".concat(code));
                return this.getSuffix('dev', count, options);
            }
        }
    ]);
    return PluralResolver;
}();
var deepFindWithDefaults = function(data, defaultData, key) {
    var keySeparator = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '.', ignoreJSONStructure = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    var path = getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && isString(key)) {
        path = deepFind(data, key, keySeparator);
        if (path === undefined) path = deepFind(defaultData, key, keySeparator);
    }
    return path;
};
var regexSafe = function(val) {
    return val.replace(/\$/g, '$$$$');
};
var Interpolator = /*#__PURE__*/ function() {
    "use strict";
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $5Epmf._)(this, Interpolator);
        var _options_interpolation;
        this.logger = baseLogger.create('interpolator');
        this.options = options;
        this.format = (options === null || options === void 0 ? void 0 : (_options_interpolation = options.interpolation) === null || _options_interpolation === void 0 ? void 0 : _options_interpolation.format) || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $9MqXK._)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var _options_interpolation = options.interpolation, escape$1 = _options_interpolation.escape, escapeValue = _options_interpolation.escapeValue, useRawValueToEscape = _options_interpolation.useRawValueToEscape, prefix = _options_interpolation.prefix, prefixEscaped = _options_interpolation.prefixEscaped, suffix = _options_interpolation.suffix, suffixEscaped = _options_interpolation.suffixEscaped, formatSeparator = _options_interpolation.formatSeparator, unescapeSuffix = _options_interpolation.unescapeSuffix, unescapePrefix = _options_interpolation.unescapePrefix, nestingPrefix = _options_interpolation.nestingPrefix, nestingPrefixEscaped = _options_interpolation.nestingPrefixEscaped, nestingSuffix = _options_interpolation.nestingSuffix, nestingSuffixEscaped = _options_interpolation.nestingSuffixEscaped, nestingOptionsSeparator = _options_interpolation.nestingOptionsSeparator, maxReplaces = _options_interpolation.maxReplaces, alwaysFormat = _options_interpolation.alwaysFormat;
                this.escape = escape$1 !== undefined ? escape$1 : escape;
                this.escapeValue = escapeValue !== undefined ? escapeValue : true;
                this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
                this.prefix = prefix ? regexEscape(prefix) : prefixEscaped || '{{';
                this.suffix = suffix ? regexEscape(suffix) : suffixEscaped || '}}';
                this.formatSeparator = formatSeparator || ',';
                this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix ? regexEscape(unescapePrefix) : '-';
                this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix ? regexEscape(unescapeSuffix) : '';
                this.nestingPrefix = nestingPrefix ? regexEscape(nestingPrefix) : nestingPrefixEscaped || regexEscape('$t(');
                this.nestingSuffix = nestingSuffix ? regexEscape(nestingSuffix) : nestingSuffixEscaped || regexEscape(')');
                this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
                this.maxReplaces = maxReplaces || 1000;
                this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var getOrResetRegExp = function(existingRegExp, pattern) {
                    if ((existingRegExp === null || existingRegExp === void 0 ? void 0 : existingRegExp.source) === pattern) {
                        existingRegExp.lastIndex = 0;
                        return existingRegExp;
                    }
                    return new RegExp(pattern, 'g');
                };
                this.regexp = getOrResetRegExp(this.regexp, "".concat(this.prefix, "(.+?)").concat(this.suffix));
                this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix));
                this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, "".concat(this.nestingPrefix, "((?:[^()\"']+|\"[^\"]*\"|'[^']*'|\\((?:[^()]|\"[^\"]*\"|'[^']*')*\\))*?)").concat(this.nestingSuffix));
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var _options_interpolation;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                var handleFormat = function(key) {
                    if (!key.includes(_this.formatSeparator)) {
                        var path = deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, (0, $lf4fc._)((0, $hwO3w._)({}, options, data), {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format(deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, (0, $lf4fc._)((0, $hwO3w._)({}, options, data), {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                if (!this.escapeValue && typeof str === 'string' && /\$t\([^)]*\{[^}]*\{\{/.test(str)) this.logger.warn("nesting options string contains interpolated variables with escapeValue: false \u2014 if any of those values are attacker-controlled they can inject additional nesting options (e.g. redirect lng/ns). Sanitise untrusted input before passing it to t(), or keep escapeValue: true.");
                var missingInterpolationHandler = (options === null || options === void 0 ? void 0 : options.missingInterpolationHandler) || this.options.missingInterpolationHandler;
                var skipOnVariables = (options === null || options === void 0 ? void 0 : (_options_interpolation = options.interpolation) === null || _options_interpolation === void 0 ? void 0 : _options_interpolation.skipOnVariables) !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function(val) {
                            return val;
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function(val) {
                            return _this.escapeValue ? _this.escape(val) : val;
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === 'function') {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = isString(temp) ? temp : '';
                            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = '';
                            }
                        } else if (!isString(value) && !_this.useRawValueToEscape) value = makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], regexSafe(safeValue));
                        if (skipOnVariables) {
                            todo.regex.lastIndex += safeValue.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this = this;
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                var handleHasOptions = function(key, inheritedOptions) {
                    var sep = _this.nestingOptionsSeparator;
                    if (!key.includes(sep)) return key;
                    var c = key.split(new RegExp("".concat(regexEscape(sep), "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = _this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    var _matchedSingleQuotes_length, _matchedDoubleQuotes_length;
                    if (((_matchedSingleQuotes_length = matchedSingleQuotes === null || matchedSingleQuotes === void 0 ? void 0 : matchedSingleQuotes.length) !== null && _matchedSingleQuotes_length !== void 0 ? _matchedSingleQuotes_length : 0) % 2 === 0 && !matchedDoubleQuotes || ((_matchedDoubleQuotes_length = matchedDoubleQuotes === null || matchedDoubleQuotes === void 0 ? void 0 : matchedDoubleQuotes.length) !== null && _matchedDoubleQuotes_length !== void 0 ? _matchedDoubleQuotes_length : 0) % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = (0, $hwO3w._)({}, inheritedOptions, clonedOptions);
                    } catch (e) {
                        _this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    if (clonedOptions.defaultValue && clonedOptions.defaultValue.includes(_this.prefix)) delete clonedOptions.defaultValue;
                    return key;
                };
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = (0, $hwO3w._)({}, options);
                    clonedOptions = clonedOptions.replace && !isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var keyEndIndex = RegExp("{.*}", "s").test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
                    if (keyEndIndex !== -1) {
                        formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        }).filter(Boolean);
                        match[1] = match[1].slice(0, keyEndIndex);
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && !isString(value)) return value;
                    if (!isString(value)) value = makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = '';
                    }
                    if (formatters.length) value = formatters.reduce(function(v, f) {
                        return _this.format(v, f, options.lng, (0, $lf4fc._)((0, $hwO3w._)({}, options), {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
var parseFormatStr = function(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.includes('(')) {
        var p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].slice(0, -1);
        if (formatName === 'currency' && !optStr.includes(':')) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && !optStr.includes(':')) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(';');
            opts.forEach(function(opt) {
                if (opt) {
                    var _opt_split = (0, $1SnSh._)(opt.split(':')), key = _opt_split[0], rest = _opt_split.slice(1);
                    var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    var trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
var createCachedFormatter = function(fn) {
    var cache = {};
    return function(v, l, o) {
        var optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = (0, $lf4fc._)((0, $hwO3w._)({}, optForCache), (0, $dUlz9._)({}, o.interpolationkey, undefined));
        var key = l + JSON.stringify(optForCache);
        var frm = cache[key];
        if (!frm) {
            frm = fn(getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
var createNonCachedFormatter = function(fn) {
    return function(v, l, o) {
        return fn(getCleanedCode(l), o)(v);
    };
};
var Formatter = /*#__PURE__*/ function() {
    "use strict";
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $5Epmf._)(this, Formatter);
        this.logger = baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    (0, $9MqXK._)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                    interpolation: {}
                };
                this.formatSeparator = options.interpolation.formatSeparator || ',';
                var cf = options.cacheInBuiltFormats ? createCachedFormatter : createNonCachedFormatter;
                this.formats = {
                    number: cf(function(lng, opt) {
                        var formatter = new Intl.NumberFormat(lng, (0, $hwO3w._)({}, opt));
                        return function(val) {
                            return formatter.format(val);
                        };
                    }),
                    currency: cf(function(lng, opt) {
                        var formatter = new Intl.NumberFormat(lng, (0, $lf4fc._)((0, $hwO3w._)({}, opt), {
                            style: 'currency'
                        }));
                        return function(val) {
                            return formatter.format(val);
                        };
                    }),
                    datetime: cf(function(lng, opt) {
                        var formatter = new Intl.DateTimeFormat(lng, (0, $hwO3w._)({}, opt));
                        return function(val) {
                            return formatter.format(val);
                        };
                    }),
                    relativetime: cf(function(lng, opt) {
                        var formatter = new Intl.RelativeTimeFormat(lng, (0, $hwO3w._)({}, opt));
                        return function(val) {
                            return formatter.format(val, opt.range || 'day');
                        };
                    }),
                    list: cf(function(lng, opt) {
                        var formatter = new Intl.ListFormat(lng, (0, $hwO3w._)({}, opt));
                        return function(val) {
                            return formatter.format(val);
                        };
                    })
                };
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, format, lng) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                if (!format) return value;
                if (value == null) return value;
                var rawFormats = format.split(this.formatSeparator);
                var formats = [];
                for(var i = 0; i < rawFormats.length; i++){
                    var f = rawFormats[i];
                    while(f.indexOf('(') > -1 && !f.includes(')') && i + 1 < rawFormats.length)f = "".concat(f).concat(this.formatSeparator).concat(rawFormats[++i]);
                    formats.push(f);
                }
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var _options_formatParams;
                            var valOptions = (options === null || options === void 0 ? void 0 : (_options_formatParams = options.formatParams) === null || _options_formatParams === void 0 ? void 0 : _options_formatParams[options.interpolationkey]) || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, (0, $hwO3w._)({}, formatOptions, options, valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
var removePending = function(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
var Connector = /*#__PURE__*/ function(EventEmitter) {
    "use strict";
    (0, $4QAx6._)(Connector, EventEmitter);
    function Connector(backend, store, services) {
        var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        (0, $5Epmf._)(this, Connector);
        var _this;
        var _this_backend_init, _this_backend;
        _this = (0, $48Z0s._)(this, Connector);
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = baseLogger.create('backendConnector');
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        (_this_backend = _this.backend) === null || _this_backend === void 0 ? void 0 : (_this_backend_init = _this_backend.init) === null || _this_backend_init === void 0 ? void 0 : _this_backend_init.call(_this_backend, services, options.backend, options);
        return _this;
    }
    (0, $9MqXK._)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this.store.hasResourceBundle(lng, ns)) _this.state[name] = 2;
                        else if (_this.state[name] < 0) ;
                        else if (_this.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit('failedLoading', lng, ns, err);
                if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
                    skipCopy: true
                });
                this.state[name] = err ? -1 : 2;
                if (err && data) this.state[name] = 0;
                var loaded = {};
                this.queue.forEach(function(q) {
                    pushPath(q.loaded, [
                        lng
                    ], ns);
                    removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(n) {
                                if (loaded[l][n] === undefined) loaded[l][n] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit('loaded', loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this = this;
                var tried = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, wait = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, callback = arguments.length > 5 ? arguments[5] : void 0;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function(err, data) {
                    _this.readingCalls--;
                    if (_this.waitingReads.length > 0) {
                        var next = _this.waitingReads.shift();
                        _this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this.maxRetries) {
                        setTimeout(function() {
                            _this.read(lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === 'function') r.then(function(data) {
                            return resolver(null, data);
                        }).catch(resolver);
                        else resolver(null, r);
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this = this;
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, callback = arguments.length > 3 ? arguments[3] : void 0;
                if (!this.backend) {
                    this.logger.warn('No backend was added via i18next.use. Will not load resources.');
                    return callback && callback();
                }
                if (isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
                if (isString(namespaces)) namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this = this;
                var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, 'read', undefined, undefined, function(err, data) {
                    if (err) _this.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, clb = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : function() {};
                var _this_services_utils, _this_services, _this_services_utils1, _this_services1, _this_backend;
                if (((_this_services = this.services) === null || _this_services === void 0 ? void 0 : (_this_services_utils = _this_services.utils) === null || _this_services_utils === void 0 ? void 0 : _this_services_utils.hasLoadedNamespace) && !((_this_services1 = this.services) === null || _this_services1 === void 0 ? void 0 : (_this_services_utils1 = _this_services1.utils) === null || _this_services_utils1 === void 0 ? void 0 : _this_services_utils1.hasLoadedNamespace(namespace))) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                    return;
                }
                if (key === undefined || key === null || key === '') return;
                if ((_this_backend = this.backend) === null || _this_backend === void 0 ? void 0 : _this_backend.create) {
                    var opts = (0, $lf4fc._)((0, $hwO3w._)({}, options), {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) try {
                        var r;
                        if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                        else r = fc(languages, namespace, key, fallbackValue);
                        if (r && typeof r.then === 'function') r.then(function(data) {
                            return clb(null, data);
                        }).catch(clb);
                        else clb(null, r);
                    } catch (err) {
                        clb(err);
                    }
                    else fc(languages, namespace, key, fallbackValue, clb, opts);
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}(EventEmitter);
var get = function() {
    return {
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        enableSelector: false,
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function(args) {
            var ret = {};
            if ((0, $03bAP._)(args[1]) === 'object') ret = args[1];
            if (isString(args[1])) ret.defaultValue = args[1];
            if (isString(args[2])) ret.tDescription = args[2];
            if ((0, $03bAP._)(args[2]) === 'object' || (0, $03bAP._)(args[3]) === 'object') {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    };
};
var transformOptions = function(options) {
    if (isString(options.ns)) options.ns = [
        options.ns
    ];
    if (isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if (isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && !options.supportedLngs.includes('cimode')) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
var noop = function() {};
var bindMemberFunctions = function(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
var I18n = /*#__PURE__*/ function(EventEmitter) {
    "use strict";
    (0, $4QAx6._)(I18n, EventEmitter);
    function I18n() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, callback = arguments.length > 1 ? arguments[1] : void 0;
        (0, $5Epmf._)(this, I18n);
        var _this;
        _this = (0, $48Z0s._)(this, I18n);
        _this.options = transformOptions(options);
        _this.services = {};
        _this.logger = baseLogger;
        _this.modules = {
            external: []
        };
        bindMemberFunctions(_this);
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initAsync) {
                _this.init(options, callback);
                return (0, $5mEjN._)(_this, _this);
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $9MqXK._)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, callback = arguments.length > 1 ? arguments[1] : void 0;
                this.isInitializing = true;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (options.defaultNS == null && options.ns) {
                    if (isString(options.ns)) options.defaultNS = options.ns;
                    else if (!options.ns.includes('translation')) options.defaultNS = options.ns[0];
                }
                var defOpts = get();
                this.options = (0, $hwO3w._)({}, defOpts, this.options, transformOptions(options));
                this.options.interpolation = (0, $hwO3w._)({}, defOpts.interpolation, this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
                var createClassOnDemand = function(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === 'function') return new ClassOrObject();
                    return ClassOrObject;
                };
                if (!this.options.isClone) {
                    var _this1 = this;
                    if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else formatter = Formatter;
                    var lu = new LanguageUtil(this.options);
                    this.store = new ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new PluralResolver(lu, {
                        prepend: this.options.pluralSeparator
                    });
                    if (formatter) {
                        s.formatter = createClassOnDemand(formatter);
                        if (s.formatter.init) s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on('*', function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = arguments[_key];
                        }
                        _this1.emit.apply(_this1, [
                            event
                        ].concat((0, $XnYkK._)(args)));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new Translator(this.services, this.options);
                    this.translator.on('*', function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = arguments[_key];
                        }
                        _this1.emit.apply(_this1, [
                            event
                        ].concat((0, $XnYkK._)(args)));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
                var storeApi = [
                    'getResource',
                    'hasResourceBundle',
                    'getResourceBundle',
                    'getDataByLanguage'
                ];
                storeApi.forEach(function(fcName) {
                    var _this1 = _this;
                    var _this_store;
                    _this[fcName] = function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        return (_this_store = _this1.store)[fcName].apply(_this_store, (0, $XnYkK._)(args));
                    };
                });
                var storeApiChained = [
                    'addResource',
                    'addResources',
                    'addResourceBundle',
                    'removeResourceBundle'
                ];
                storeApiChained.forEach(function(fcName) {
                    var _this1 = _this;
                    _this[fcName] = function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var _this_store;
                        (_this_store = _this1.store)[fcName].apply(_this_store, (0, $XnYkK._)(args));
                        return _this1;
                    };
                });
                var deferred = defer();
                var load = function() {
                    var finish = function(err, t) {
                        _this.isInitializing = false;
                        if (_this.isInitialized && !_this.initializedStoreOnce) _this.logger.warn('init: i18next is already initialized. You should call init just once!');
                        _this.isInitialized = true;
                        if (!_this.options.isClone) _this.logger.log('initialized', _this.options);
                        _this.emit('initialized', _this.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if ((_this.languages || _this.isLanguageChangingTo) && !_this.isInitialized) return finish(null, _this.t.bind(_this));
                    _this.changeLanguage(_this.options.lng, finish);
                };
                if (this.options.resources || !this.options.initAsync) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this = this;
                var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
                var usedCallback = callback;
                var usedLng = isString(language) ? language : this.language;
                if (typeof language === 'function') usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    var _this_options_preload_forEach, _this_options_preload;
                    if ((usedLng === null || usedLng === void 0 ? void 0 : usedLng.toLowerCase()) === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
                    var toLoad = [];
                    var append = function(lng) {
                        if (!lng) return;
                        if (lng === 'cimode') return;
                        var lngs = _this.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (l === 'cimode') return;
                            if (!toLoad.includes(l)) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    (_this_options_preload = this.options.preload) === null || _this_options_preload === void 0 ? void 0 : (_this_options_preload_forEach = _this_options_preload.forEach) === null || _this_options_preload_forEach === void 0 ? void 0 : _this_options_preload_forEach.call(_this_options_preload, function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this.resolvedLanguage && _this.language) _this.setResolvedLanguage(_this.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = defer();
                if (typeof lngs === 'function') {
                    callback = lngs;
                    lngs = undefined;
                }
                if (typeof ns === 'function') {
                    callback = ns;
                    ns = undefined;
                }
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
                if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
                if (module.type === 'backend') this.modules.backend = module;
                if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === 'languageDetector') this.modules.languageDetector = module;
                if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
                if (module.type === 'postProcessor') postProcessor.addPostProcessor(module);
                if (module.type === 'formatter') this.modules.formatter = module;
                if (module.type === '3rdParty') this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    'cimode',
                    'dev'
                ].includes(l)) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        'cimode',
                        'dev'
                    ].includes(lngInLngs)) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
                if (!this.resolvedLanguage && !this.languages.includes(l) && this.store.hasLanguageSomeTranslations(l)) {
                    this.resolvedLanguage = l;
                    this.languages.unshift(l);
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this = this;
                this.isLanguageChangingTo = lng;
                var deferred = defer();
                this.emit('languageChanging', lng);
                var setLngProps = function(l) {
                    _this.language = l;
                    _this.languages = _this.services.languageUtils.toResolveHierarchy(l);
                    _this.resolvedLanguage = undefined;
                    _this.setResolvedLanguage(l);
                };
                var done = function(err, l) {
                    var _this1 = _this;
                    if (l) {
                        if (_this.isLanguageChangingTo === lng) {
                            setLngProps(l);
                            _this.translator.changeLanguage(l);
                            _this.isLanguageChangingTo = undefined;
                            _this.emit('languageChanged', l);
                            _this.logger.log('languageChanged', l);
                        }
                    } else _this.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        return _this1.t.apply(_this1, (0, $XnYkK._)(args));
                    });
                    if (callback) callback(err, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        return _this1.t.apply(_this1, (0, $XnYkK._)(args));
                    });
                };
                var setLng = function(lngs) {
                    if (!lng && !lngs && _this.services.languageDetector) lngs = [];
                    var fl = isString(lngs) ? lngs : lngs && lngs[0];
                    var l = _this.store.hasLanguageSomeTranslations(fl) ? fl : _this.services.languageUtils.getBestMatchFromCodes(isString(lngs) ? [
                        lngs
                    ] : lngs);
                    if (l) {
                        var _this_services_languageDetector_cacheUserLanguage, _this_services_languageDetector;
                        if (!_this.language) setLngProps(l);
                        if (!_this.translator.language) _this.translator.changeLanguage(l);
                        (_this_services_languageDetector = _this.services.languageDetector) === null || _this_services_languageDetector === void 0 ? void 0 : (_this_services_languageDetector_cacheUserLanguage = _this_services_languageDetector.cacheUserLanguage) === null || _this_services_languageDetector_cacheUserLanguage === void 0 ? void 0 : _this_services_languageDetector_cacheUserLanguage.call(_this_services_languageDetector, l);
                    }
                    _this.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
                    else this.services.languageDetector.detect(setLng);
                } else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix, fixedOpts) {
                var _this = this;
                var scopeNs = fixedOpts === null || fixedOpts === void 0 ? void 0 : fixedOpts.scopeNs;
                var fixedT = function(key, opts) {
                    for(var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                        rest[_key - 2] = arguments[_key];
                    }
                    var o;
                    if ((typeof opts === "undefined" ? "undefined" : (0, $03bAP._)(opts)) !== 'object') o = _this.options.overloadTranslationOptionHandler([
                        key,
                        opts
                    ].concat(rest));
                    else o = (0, $hwO3w._)({}, opts);
                    o.lng = o.lng || fixedT.lng;
                    o.lngs = o.lngs || fixedT.lngs;
                    var explicitCallNs = o.ns !== undefined && o.ns !== null;
                    o.ns = o.ns || fixedT.ns;
                    if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var selectorOpts = (0, $hwO3w._)({}, _this.options, o);
                    if (Array.isArray(scopeNs) && !explicitCallNs) selectorOpts.ns = scopeNs;
                    if (typeof o.keyPrefix === 'function') o.keyPrefix = keysFromSelector(o.keyPrefix, selectorOpts);
                    var keySeparator = _this.options.keySeparator || '.';
                    var resultKey;
                    if (o.keyPrefix && Array.isArray(key)) resultKey = key.map(function(k) {
                        if (typeof k === 'function') k = keysFromSelector(k, selectorOpts);
                        return "".concat(o.keyPrefix).concat(keySeparator).concat(k);
                    });
                    else {
                        if (typeof key === 'function') key = keysFromSelector(key, selectorOpts);
                        resultKey = o.keyPrefix ? "".concat(o.keyPrefix).concat(keySeparator).concat(key) : key;
                    }
                    return _this.t(resultKey, o);
                };
                if (isString(lng)) fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_translator;
                var _this_translator1;
                return (_this_translator1 = this.translator) === null || _this_translator1 === void 0 ? void 0 : (_this_translator = _this_translator1).translate.apply(_this_translator, (0, $XnYkK._)(args));
            }
        },
        {
            key: "exists",
            value: function exists() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_translator;
                var _this_translator1;
                return (_this_translator1 = this.translator) === null || _this_translator1 === void 0 ? void 0 : (_this_translator = _this_translator1).exists.apply(_this_translator, (0, $XnYkK._)(args));
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
                    return false;
                }
                var lng = options.lng || this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === 'cimode') return true;
                var loadNotPending = function(l, n) {
                    var loadState = _this.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 0 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this = this;
                var deferred = defer();
                if (!this.options.ns) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                if (isString(ns)) ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (!_this.options.ns.includes(n)) _this.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var _this = this;
                var deferred = defer();
                if (isString(lngs)) lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return !preloaded.includes(lng) && _this.services.languageUtils.isSupportedCode(lng);
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                var _this_languages, _this_services;
                if (!lng) lng = this.resolvedLanguage || (((_this_languages = this.languages) === null || _this_languages === void 0 ? void 0 : _this_languages.length) > 0 ? this.languages[0] : this.language);
                if (!lng) return 'rtl';
                try {
                    var l = new Intl.Locale(lng);
                    if (l && l.getTextInfo) {
                        var ti = l.getTextInfo();
                        if (ti && ti.direction) return ti.direction;
                    }
                } catch (e) {}
                var rtlLngs = [
                    'ar',
                    'shu',
                    'sqr',
                    'ssh',
                    'xaa',
                    'yhd',
                    'yud',
                    'aao',
                    'abh',
                    'abv',
                    'acm',
                    'acq',
                    'acw',
                    'acx',
                    'acy',
                    'adf',
                    'ads',
                    'aeb',
                    'aec',
                    'afb',
                    'ajp',
                    'apc',
                    'apd',
                    'arb',
                    'arq',
                    'ars',
                    'ary',
                    'arz',
                    'auz',
                    'avl',
                    'ayh',
                    'ayl',
                    'ayn',
                    'ayp',
                    'bbz',
                    'pga',
                    'he',
                    'iw',
                    'ps',
                    'pbt',
                    'pbu',
                    'pst',
                    'prp',
                    'prd',
                    'ug',
                    'ur',
                    'ydd',
                    'yds',
                    'yih',
                    'ji',
                    'yi',
                    'hbo',
                    'men',
                    'xmn',
                    'fa',
                    'jpr',
                    'peo',
                    'pes',
                    'prs',
                    'dv',
                    'sam',
                    'ckb'
                ];
                var languageUtils = ((_this_services = this.services) === null || _this_services === void 0 ? void 0 : _this_services.languageUtils) || new LanguageUtil(get());
                if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
                return rtlLngs.includes(languageUtils.getLanguagePartFromCode(lng)) || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this = this;
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
                var forkResourceStore = options.forkResourceStore;
                if (forkResourceStore) delete options.forkResourceStore;
                var mergedOptions = (0, $lf4fc._)((0, $hwO3w._)({}, this.options, options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    'store',
                    'services',
                    'language'
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this[m];
                });
                clone.services = (0, $hwO3w._)({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                if (forkResourceStore) {
                    var clonedData = Object.keys(this.store.data).reduce(function(prev, l) {
                        prev[l] = (0, $hwO3w._)({}, _this.store.data[l]);
                        prev[l] = Object.keys(prev[l]).reduce(function(acc, n) {
                            acc[n] = (0, $hwO3w._)({}, prev[l][n]);
                            return acc;
                        }, prev[l]);
                        return prev;
                    }, {});
                    clone.store = new ResourceStore(clonedData, mergedOptions);
                    clone.services.resourceStore = clone.store;
                }
                if (options.interpolation) {
                    var defOpts = get();
                    var mergedInterpolation = (0, $hwO3w._)({}, defOpts.interpolation, this.options.interpolation, options.interpolation);
                    var mergedForInterpolator = (0, $lf4fc._)((0, $hwO3w._)({}, mergedOptions), {
                        interpolation: mergedInterpolation
                    });
                    clone.services.interpolator = new Interpolator(mergedForInterpolator);
                }
                clone.translator = new Translator(clone.services, mergedOptions);
                clone.translator.on('*', function(event) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _clone;
                    (_clone = clone).emit.apply(_clone, [
                        event
                    ].concat((0, $XnYkK._)(args)));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = mergedOptions;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ], [
        {
            key: "createInstance",
            value: function createInstance() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, callback = arguments.length > 1 ? arguments[1] : void 0;
                var instance = new I18n(options, callback);
                instance.createInstance = I18n.createInstance;
                return instance;
            }
        }
    ]);
    return I18n;
}(EventEmitter);
var instance = I18n.createInstance();
var createInstance = instance.createInstance;
var dir = instance.dir;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

});

parcelRegister("3HOc9", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $2b2c52e9df1ed3f9$export$306c0aa65ff9ec16; }, function (v) { return $2b2c52e9df1ed3f9$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2b2c52e9df1ed3f9$export$306c0aa65ff9ec16;
"use strict";

var $5s1kH = parcelRequire("5s1kH");
function $2b2c52e9df1ed3f9$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $2b2c52e9df1ed3f9$var$objectIs = "function" === typeof Object.is ? Object.is : $2b2c52e9df1ed3f9$var$is, $2b2c52e9df1ed3f9$var$useState = $5s1kH.useState, $2b2c52e9df1ed3f9$var$useEffect = $5s1kH.useEffect, $2b2c52e9df1ed3f9$var$useLayoutEffect = $5s1kH.useLayoutEffect, $2b2c52e9df1ed3f9$var$useDebugValue = $5s1kH.useDebugValue;
function $2b2c52e9df1ed3f9$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $2b2c52e9df1ed3f9$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $2b2c52e9df1ed3f9$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $2b2c52e9df1ed3f9$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $2b2c52e9df1ed3f9$var$useEffect(function() {
        $2b2c52e9df1ed3f9$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $2b2c52e9df1ed3f9$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $2b2c52e9df1ed3f9$var$useDebugValue(value);
    return value;
}
function $2b2c52e9df1ed3f9$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$2b2c52e9df1ed3f9$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $2b2c52e9df1ed3f9$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $2b2c52e9df1ed3f9$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2b2c52e9df1ed3f9$var$useSyncExternalStore$1 : $2b2c52e9df1ed3f9$var$useSyncExternalStore$2;
$2b2c52e9df1ed3f9$export$306c0aa65ff9ec16 = void 0 !== $5s1kH.useSyncExternalStore ? $5s1kH.useSyncExternalStore : $2b2c52e9df1ed3f9$var$shim;

});

parcelRegister("ectF0", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $8cmAa = parcelRequire("8cmAa");
function isNodeEnv() {
    return !(0, $8cmAa.isBrowserBundle)() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName) {
    var existingModule = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : module;
    var mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch (e) {}
    if (!mod) try {
        var cwd = dynamicRequire(existingModule, "process").cwd;
        mod = dynamicRequire(existingModule, "".concat(cwd(), "/node_modules/").concat(moduleName));
    } catch (e) {}
    return mod;
}

});
parcelRegister("8cmAa", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $5f80f61ff05b8a04$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $5f80f61ff05b8a04$export$8ad33f488b1ab046; });
function $5f80f61ff05b8a04$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $5f80f61ff05b8a04$export$8ad33f488b1ab046() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}

});


parcelRegister("2B8EG", function(module, exports) {

var $03bAP = parcelRequire("03bAP");
/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined1) {
    "use strict";
    var LIBVERSION = "1.0.41", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HONOR = "Honor", HUAWEI = "Huawei", LENOVO = "Lenovo", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", NVIDIA = "Nvidia", ONEPLUS = "OnePlus", OPERA = "Opera", OPPO = "OPPO", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
    var extend = function extend(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function enumerize(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function has(str1, str2) {
        return (typeof str1 === "undefined" ? "undefined" : (0, $03bAP._)(str1)) === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function lowerize(str) {
        return str.toLowerCase();
    }, majorize = function majorize(version) {
        return (typeof version === "undefined" ? "undefined" : (0, $03bAP._)(version)) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined1;
    }, trim = function trim(str, len) {
        if ((typeof str === "undefined" ? "undefined" : (0, $03bAP._)(str)) === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return (typeof len === "undefined" ? "undefined" : (0, $03bAP._)(len)) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function rgxMapper(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if ((typeof q === "undefined" ? "undefined" : (0, $03bAP._)(q)) === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if ((0, $03bAP._)(q[1]) == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if ((0, $03bAP._)(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined1;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined1;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined1;
                    } else this[q] = match ? match : undefined1;
                }
            }
            i += 2;
        }
    }, strMapper = function strMapper(str, map) {
        for(var i in map){
            if ((0, $03bAP._)(map[i]) === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined1 : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined1 : i;
        }
        return map.hasOwnProperty("*") ? map["*"] : str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Maxthon"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Quark"
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI" + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "360"
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1Browser"
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1" + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /\b(links) \(([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((ppc|powerpc)(64)?)( mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                / sun4\w[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    strMapper,
                    {
                        OnePlus: [
                            "304",
                            "403",
                            "203"
                        ],
                        "*": OPPO
                    }
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LENOVO
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(nokia) (t[12][01])/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ],
                [
                    VENDOR,
                    "Nokia"
                ]
            ],
            [
                /(pixel (c|tablet))\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "TCL"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        tablet: [
                            "p10001l",
                            "w7001"
                        ],
                        "*": "mobile"
                    }
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Energizer"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Cat"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Smartfren"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nothing"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(infinix) (x1101b?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(shield \w+ tv)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation \w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(opwwe\d{3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(moto 360)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(smartwatch 3)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(g watch r)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(homepod).+mac os/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    NAME,
                    "LibWeb"
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Touch"
                ],
                VERSION
            ],
            [
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function UAParser1(ua, extensions) {
        if ((typeof ua === "undefined" ? "undefined" : (0, $03bAP._)(ua)) === OBJ_TYPE) {
            extensions = ua;
            ua = undefined1;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = (typeof window1 === "undefined" ? "undefined" : (0, $03bAP._)(window1)) !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined1;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined1;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined1;
            _browser[VERSION] = undefined1;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && (0, $03bAP._)(_navigator.brave.isBrave) == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined1;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined1;
            _device[MODEL] = undefined1;
            _device[TYPE] = undefined1;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && (0, $03bAP._)(_navigator.standalone) !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined1;
            _engine[VERSION] = undefined1;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined1;
            _os[VERSION] = undefined1;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = (typeof ua === "undefined" ? "undefined" : (0, $03bAP._)(ua)) === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if ((typeof define === "undefined" ? "undefined" : (0, $03bAP._)(define)) === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if ((typeof window1 === "undefined" ? "undefined" : (0, $03bAP._)(window1)) !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = (typeof window1 === "undefined" ? "undefined" : (0, $03bAP._)(window1)) !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})((typeof window === "undefined" ? "undefined" : (0, $03bAP._)(window)) === "object" ? window : undefined);

});

parcelRegister("4YVCt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3a0976104d65cb17$var$ReactIs, $3a0976104d65cb17$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("2Fc4V"))();

});
parcelRegister("2Fc4V", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $fBAr5 = parcelRequire("fBAr5");
function $1f08c7a86ab4525f$var$emptyFunction() {}
function $1f08c7a86ab4525f$var$emptyFunctionWithReset() {}
$1f08c7a86ab4525f$var$emptyFunctionWithReset.resetWarningCache = $1f08c7a86ab4525f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $fBAr5) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1f08c7a86ab4525f$var$emptyFunctionWithReset,
        resetWarningCache: $1f08c7a86ab4525f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("fBAr5", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $b5c6931ed11970b7$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $b5c6931ed11970b7$var$ReactPropTypesSecret;

});



parcelRegister("fRRA4", function(module, exports) {

var $GyYXy = parcelRequire("GyYXy");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $b8d55e49b972ee23$var$isEqual(value, other) {
    return $GyYXy(value, other);
}
module.exports = $b8d55e49b972ee23$var$isEqual;

});
parcelRegister("GyYXy", function(module, exports) {

var $jmVqA = parcelRequire("jmVqA");

var $7N4ni = parcelRequire("7N4ni");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $07ff0f194700b509$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$7N4ni(value) && !$7N4ni(other)) return value !== value && other !== other;
    return $jmVqA(value, other, bitmask, customizer, $07ff0f194700b509$var$baseIsEqual, stack);
}
module.exports = $07ff0f194700b509$var$baseIsEqual;

});
parcelRegister("jmVqA", function(module, exports) {

var $9E4Ag = parcelRequire("9E4Ag");

var $8ngLp = parcelRequire("8ngLp");

var $1KLOE = parcelRequire("1KLOE");

var $a1VJ4 = parcelRequire("a1VJ4");

var $d372L = parcelRequire("d372L");

var $gjQr4 = parcelRequire("gjQr4");

var $18svd = parcelRequire("18svd");

var $bXxa9 = parcelRequire("bXxa9");
/** Used to compose bitmasks for value comparisons. */ var $03a38ef0e900ea3d$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $03a38ef0e900ea3d$var$argsTag = '[object Arguments]', $03a38ef0e900ea3d$var$arrayTag = '[object Array]', $03a38ef0e900ea3d$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $03a38ef0e900ea3d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $03a38ef0e900ea3d$var$hasOwnProperty = $03a38ef0e900ea3d$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $03a38ef0e900ea3d$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $gjQr4(object), othIsArr = $gjQr4(other), objTag = objIsArr ? $03a38ef0e900ea3d$var$arrayTag : $d372L(object), othTag = othIsArr ? $03a38ef0e900ea3d$var$arrayTag : $d372L(other);
    objTag = objTag == $03a38ef0e900ea3d$var$argsTag ? $03a38ef0e900ea3d$var$objectTag : objTag;
    othTag = othTag == $03a38ef0e900ea3d$var$argsTag ? $03a38ef0e900ea3d$var$objectTag : othTag;
    var objIsObj = objTag == $03a38ef0e900ea3d$var$objectTag, othIsObj = othTag == $03a38ef0e900ea3d$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $18svd(object)) {
        if (!$18svd(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $9E4Ag);
        return objIsArr || $bXxa9(object) ? $8ngLp(object, other, bitmask, customizer, equalFunc, stack) : $1KLOE(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $03a38ef0e900ea3d$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $03a38ef0e900ea3d$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $03a38ef0e900ea3d$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $9E4Ag);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $9E4Ag);
    return $a1VJ4(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $03a38ef0e900ea3d$var$baseIsEqualDeep;

});
parcelRegister("9E4Ag", function(module, exports) {

var $7h5XJ = parcelRequire("7h5XJ");

var $eEE2r = parcelRequire("eEE2r");

var $hhOWg = parcelRequire("hhOWg");

var $aZflR = parcelRequire("aZflR");

var $8LNct = parcelRequire("8LNct");

var $601AJ = parcelRequire("601AJ");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $705b67bea63673cb$var$Stack(entries) {
    var data = this.__data__ = new $7h5XJ(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$705b67bea63673cb$var$Stack.prototype.clear = $eEE2r;
$705b67bea63673cb$var$Stack.prototype['delete'] = $hhOWg;
$705b67bea63673cb$var$Stack.prototype.get = $aZflR;
$705b67bea63673cb$var$Stack.prototype.has = $8LNct;
$705b67bea63673cb$var$Stack.prototype.set = $601AJ;
module.exports = $705b67bea63673cb$var$Stack;

});
parcelRegister("7h5XJ", function(module, exports) {

var $2GAyC = parcelRequire("2GAyC");

var $8VUsg = parcelRequire("8VUsg");

var $fjgRC = parcelRequire("fjgRC");

var $3Oyy0 = parcelRequire("3Oyy0");

var $fO6LW = parcelRequire("fO6LW");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $54bebeeee6905046$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$54bebeeee6905046$var$ListCache.prototype.clear = $2GAyC;
$54bebeeee6905046$var$ListCache.prototype['delete'] = $8VUsg;
$54bebeeee6905046$var$ListCache.prototype.get = $fjgRC;
$54bebeeee6905046$var$ListCache.prototype.has = $3Oyy0;
$54bebeeee6905046$var$ListCache.prototype.set = $fO6LW;
module.exports = $54bebeeee6905046$var$ListCache;

});
parcelRegister("2GAyC", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $1f4bdc8dc40d0d9f$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $1f4bdc8dc40d0d9f$var$listCacheClear;

});

parcelRegister("8VUsg", function(module, exports) {

var $dRcsP = parcelRequire("dRcsP");
/** Used for built-in method references. */ var $680f705a36baa90a$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $680f705a36baa90a$var$splice = $680f705a36baa90a$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $680f705a36baa90a$var$listCacheDelete(key) {
    var data = this.__data__, index = $dRcsP(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $680f705a36baa90a$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $680f705a36baa90a$var$listCacheDelete;

});
parcelRegister("dRcsP", function(module, exports) {

var $1g3Fq = parcelRequire("1g3Fq");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a169e4aac2a31e55$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($1g3Fq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $a169e4aac2a31e55$var$assocIndexOf;

});
parcelRegister("1g3Fq", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $0eaa214aa97512c1$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $0eaa214aa97512c1$var$eq;

});



parcelRegister("fjgRC", function(module, exports) {

var $dRcsP = parcelRequire("dRcsP");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b255b630d7e6b94b$var$listCacheGet(key) {
    var data = this.__data__, index = $dRcsP(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b255b630d7e6b94b$var$listCacheGet;

});

parcelRegister("3Oyy0", function(module, exports) {

var $dRcsP = parcelRequire("dRcsP");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2c70d705e2efe013$var$listCacheHas(key) {
    return $dRcsP(this.__data__, key) > -1;
}
module.exports = $2c70d705e2efe013$var$listCacheHas;

});

parcelRegister("fO6LW", function(module, exports) {

var $dRcsP = parcelRequire("dRcsP");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b820c75f606c60fc$var$listCacheSet(key, value) {
    var data = this.__data__, index = $dRcsP(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $b820c75f606c60fc$var$listCacheSet;

});


parcelRegister("eEE2r", function(module, exports) {

var $7h5XJ = parcelRequire("7h5XJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $aab3dbed0d019801$var$stackClear() {
    this.__data__ = new $7h5XJ;
    this.size = 0;
}
module.exports = $aab3dbed0d019801$var$stackClear;

});

parcelRegister("hhOWg", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c95b8992eb43d91d$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $c95b8992eb43d91d$var$stackDelete;

});

parcelRegister("aZflR", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7ffb826896c14dfe$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $7ffb826896c14dfe$var$stackGet;

});

parcelRegister("8LNct", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6628e0ab35aa37b1$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $6628e0ab35aa37b1$var$stackHas;

});

parcelRegister("601AJ", function(module, exports) {

var $7h5XJ = parcelRequire("7h5XJ");

var $6ok7H = parcelRequire("6ok7H");

var $9iMjJ = parcelRequire("9iMjJ");
/** Used as the size to enable large array optimizations. */ var $45e3fa322dd6dfab$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $45e3fa322dd6dfab$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $7h5XJ) {
        var pairs = data.__data__;
        if (!$6ok7H || pairs.length < $45e3fa322dd6dfab$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $9iMjJ(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $45e3fa322dd6dfab$var$stackSet;

});
parcelRegister("6ok7H", function(module, exports) {

var $kWWbB = parcelRequire("kWWbB");

var $6U3A3 = parcelRequire("6U3A3");
/* Built-in method references that are verified to be native. */ var $4a749803a5f21747$var$Map = $kWWbB($6U3A3, 'Map');
module.exports = $4a749803a5f21747$var$Map;

});
parcelRegister("kWWbB", function(module, exports) {

var $d5Sxh = parcelRequire("d5Sxh");

var $DLlxk = parcelRequire("DLlxk");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $f4065bfc8a69d7a7$var$getNative(object, key) {
    var value = $DLlxk(object, key);
    return $d5Sxh(value) ? value : undefined;
}
module.exports = $f4065bfc8a69d7a7$var$getNative;

});
parcelRegister("d5Sxh", function(module, exports) {

var $7mdb9 = parcelRequire("7mdb9");

var $3Jsdt = parcelRequire("3Jsdt");

var $gpxvq = parcelRequire("gpxvq");

var $lwwmM = parcelRequire("lwwmM");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $98860ba543dabc4b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $98860ba543dabc4b$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $98860ba543dabc4b$var$funcProto = Function.prototype, $98860ba543dabc4b$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $98860ba543dabc4b$var$funcToString = $98860ba543dabc4b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $98860ba543dabc4b$var$hasOwnProperty = $98860ba543dabc4b$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $98860ba543dabc4b$var$reIsNative = RegExp('^' + $98860ba543dabc4b$var$funcToString.call($98860ba543dabc4b$var$hasOwnProperty).replace($98860ba543dabc4b$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $98860ba543dabc4b$var$baseIsNative(value) {
    if (!$gpxvq(value) || $3Jsdt(value)) return false;
    var pattern = $7mdb9(value) ? $98860ba543dabc4b$var$reIsNative : $98860ba543dabc4b$var$reIsHostCtor;
    return pattern.test($lwwmM(value));
}
module.exports = $98860ba543dabc4b$var$baseIsNative;

});
parcelRegister("7mdb9", function(module, exports) {

var $anDuf = parcelRequire("anDuf");

var $gpxvq = parcelRequire("gpxvq");
/** `Object#toString` result references. */ var $55b4cf81757269c6$var$asyncTag = '[object AsyncFunction]', $55b4cf81757269c6$var$funcTag = '[object Function]', $55b4cf81757269c6$var$genTag = '[object GeneratorFunction]', $55b4cf81757269c6$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $55b4cf81757269c6$var$isFunction(value) {
    if (!$gpxvq(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $anDuf(value);
    return tag == $55b4cf81757269c6$var$funcTag || tag == $55b4cf81757269c6$var$genTag || tag == $55b4cf81757269c6$var$asyncTag || tag == $55b4cf81757269c6$var$proxyTag;
}
module.exports = $55b4cf81757269c6$var$isFunction;

});
parcelRegister("anDuf", function(module, exports) {

var $chLJV = parcelRequire("chLJV");

var $8BhY9 = parcelRequire("8BhY9");

var $leGfg = parcelRequire("leGfg");
/** `Object#toString` result references. */ var $78eaaea8e5fe97a1$var$nullTag = '[object Null]', $78eaaea8e5fe97a1$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $78eaaea8e5fe97a1$var$symToStringTag = $chLJV ? $chLJV.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $78eaaea8e5fe97a1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $78eaaea8e5fe97a1$var$undefinedTag : $78eaaea8e5fe97a1$var$nullTag;
    return $78eaaea8e5fe97a1$var$symToStringTag && $78eaaea8e5fe97a1$var$symToStringTag in Object(value) ? $8BhY9(value) : $leGfg(value);
}
module.exports = $78eaaea8e5fe97a1$var$baseGetTag;

});
parcelRegister("chLJV", function(module, exports) {

var $6U3A3 = parcelRequire("6U3A3");
/** Built-in value references. */ var $8f1c1aa954992b5b$var$Symbol = $6U3A3.Symbol;
module.exports = $8f1c1aa954992b5b$var$Symbol;

});
parcelRegister("6U3A3", function(module, exports) {

var $03bAP = parcelRequire("03bAP");

var $hJEtK = parcelRequire("hJEtK");
/** Detect free variable `self`. */ var $506ac00a2ba6ae50$var$freeSelf = (typeof self === "undefined" ? "undefined" : (0, $03bAP._)(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $506ac00a2ba6ae50$var$root = $hJEtK || $506ac00a2ba6ae50$var$freeSelf || Function('return this')();
module.exports = $506ac00a2ba6ae50$var$root;

});
parcelRegister("hJEtK", function(module, exports) {
/** Detect free variable `global` from Node.js. */ 
var $03bAP = parcelRequire("03bAP");
var $ce9609e0270940c3$var$freeGlobal = (typeof $parcel$global === "undefined" ? "undefined" : (0, $03bAP._)($parcel$global)) == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $ce9609e0270940c3$var$freeGlobal;

});



parcelRegister("8BhY9", function(module, exports) {

var $chLJV = parcelRequire("chLJV");
/** Used for built-in method references. */ var $642fb7bc7c15ff04$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $642fb7bc7c15ff04$var$hasOwnProperty = $642fb7bc7c15ff04$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $642fb7bc7c15ff04$var$nativeObjectToString = $642fb7bc7c15ff04$var$objectProto.toString;
/** Built-in value references. */ var $642fb7bc7c15ff04$var$symToStringTag = $chLJV ? $chLJV.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $642fb7bc7c15ff04$var$getRawTag(value) {
    var isOwn = $642fb7bc7c15ff04$var$hasOwnProperty.call(value, $642fb7bc7c15ff04$var$symToStringTag), tag = value[$642fb7bc7c15ff04$var$symToStringTag];
    try {
        value[$642fb7bc7c15ff04$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $642fb7bc7c15ff04$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$642fb7bc7c15ff04$var$symToStringTag] = tag;
        else delete value[$642fb7bc7c15ff04$var$symToStringTag];
    }
    return result;
}
module.exports = $642fb7bc7c15ff04$var$getRawTag;

});

parcelRegister("leGfg", function(module, exports) {
/** Used for built-in method references. */ var $f75bacc6780faae8$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f75bacc6780faae8$var$nativeObjectToString = $f75bacc6780faae8$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $f75bacc6780faae8$var$objectToString(value) {
    return $f75bacc6780faae8$var$nativeObjectToString.call(value);
}
module.exports = $f75bacc6780faae8$var$objectToString;

});


parcelRegister("gpxvq", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
var $03bAP = parcelRequire("03bAP");
function $bf28f8b11902b936$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value);
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $bf28f8b11902b936$var$isObject;

});


parcelRegister("3Jsdt", function(module, exports) {

var $hrW0I = parcelRequire("hrW0I");
/** Used to detect methods masquerading as native. */ var $2b7b76398fba89ef$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($hrW0I && $hrW0I.keys && $hrW0I.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $2b7b76398fba89ef$var$isMasked(func) {
    return !!$2b7b76398fba89ef$var$maskSrcKey && $2b7b76398fba89ef$var$maskSrcKey in func;
}
module.exports = $2b7b76398fba89ef$var$isMasked;

});
parcelRegister("hrW0I", function(module, exports) {

var $6U3A3 = parcelRequire("6U3A3");
/** Used to detect overreaching core-js shims. */ var $cb41f4f244ec1030$var$coreJsData = $6U3A3["__core-js_shared__"];
module.exports = $cb41f4f244ec1030$var$coreJsData;

});


parcelRegister("lwwmM", function(module, exports) {
/** Used for built-in method references. */ var $fab5b16e451db88c$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $fab5b16e451db88c$var$funcToString = $fab5b16e451db88c$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $fab5b16e451db88c$var$toSource(func) {
    if (func != null) {
        try {
            return $fab5b16e451db88c$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $fab5b16e451db88c$var$toSource;

});


parcelRegister("DLlxk", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $07785ea292288312$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $07785ea292288312$var$getValue;

});



parcelRegister("9iMjJ", function(module, exports) {

var $a1GiW = parcelRequire("a1GiW");

var $gjSDq = parcelRequire("gjSDq");

var $igPQG = parcelRequire("igPQG");

var $3c31F = parcelRequire("3c31F");

var $9GeBX = parcelRequire("9GeBX");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6c5b464dac5c3113$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$6c5b464dac5c3113$var$MapCache.prototype.clear = $a1GiW;
$6c5b464dac5c3113$var$MapCache.prototype['delete'] = $gjSDq;
$6c5b464dac5c3113$var$MapCache.prototype.get = $igPQG;
$6c5b464dac5c3113$var$MapCache.prototype.has = $3c31F;
$6c5b464dac5c3113$var$MapCache.prototype.set = $9GeBX;
module.exports = $6c5b464dac5c3113$var$MapCache;

});
parcelRegister("a1GiW", function(module, exports) {

var $awpUQ = parcelRequire("awpUQ");

var $7h5XJ = parcelRequire("7h5XJ");

var $6ok7H = parcelRequire("6ok7H");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $74cad03161fb0a04$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $awpUQ,
        'map': new ($6ok7H || $7h5XJ),
        'string': new $awpUQ
    };
}
module.exports = $74cad03161fb0a04$var$mapCacheClear;

});
parcelRegister("awpUQ", function(module, exports) {

var $24VUX = parcelRequire("24VUX");

var $aqwST = parcelRequire("aqwST");

var $gZnHZ = parcelRequire("gZnHZ");

var $3IHkg = parcelRequire("3IHkg");

var $hr0G6 = parcelRequire("hr0G6");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7a90fede5a51d5c6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$7a90fede5a51d5c6$var$Hash.prototype.clear = $24VUX;
$7a90fede5a51d5c6$var$Hash.prototype['delete'] = $aqwST;
$7a90fede5a51d5c6$var$Hash.prototype.get = $gZnHZ;
$7a90fede5a51d5c6$var$Hash.prototype.has = $3IHkg;
$7a90fede5a51d5c6$var$Hash.prototype.set = $hr0G6;
module.exports = $7a90fede5a51d5c6$var$Hash;

});
parcelRegister("24VUX", function(module, exports) {

var $e8Za0 = parcelRequire("e8Za0");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $1838e1b67027e009$var$hashClear() {
    this.__data__ = $e8Za0 ? $e8Za0(null) : {};
    this.size = 0;
}
module.exports = $1838e1b67027e009$var$hashClear;

});
parcelRegister("e8Za0", function(module, exports) {

var $kWWbB = parcelRequire("kWWbB");
/* Built-in method references that are verified to be native. */ var $a4c1413d5e471ff2$var$nativeCreate = $kWWbB(Object, 'create');
module.exports = $a4c1413d5e471ff2$var$nativeCreate;

});


parcelRegister("aqwST", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7975d73e18ed3675$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $7975d73e18ed3675$var$hashDelete;

});

parcelRegister("gZnHZ", function(module, exports) {

var $e8Za0 = parcelRequire("e8Za0");
/** Used to stand-in for `undefined` hash values. */ var $c5e4bbe332c61d05$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $c5e4bbe332c61d05$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c5e4bbe332c61d05$var$hasOwnProperty = $c5e4bbe332c61d05$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c5e4bbe332c61d05$var$hashGet(key) {
    var data = this.__data__;
    if ($e8Za0) {
        var result = data[key];
        return result === $c5e4bbe332c61d05$var$HASH_UNDEFINED ? undefined : result;
    }
    return $c5e4bbe332c61d05$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $c5e4bbe332c61d05$var$hashGet;

});

parcelRegister("3IHkg", function(module, exports) {

var $e8Za0 = parcelRequire("e8Za0");
/** Used for built-in method references. */ var $2b5716c109a9100e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2b5716c109a9100e$var$hasOwnProperty = $2b5716c109a9100e$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2b5716c109a9100e$var$hashHas(key) {
    var data = this.__data__;
    return $e8Za0 ? data[key] !== undefined : $2b5716c109a9100e$var$hasOwnProperty.call(data, key);
}
module.exports = $2b5716c109a9100e$var$hashHas;

});

parcelRegister("hr0G6", function(module, exports) {

var $e8Za0 = parcelRequire("e8Za0");
/** Used to stand-in for `undefined` hash values. */ var $cb157be95560d481$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $cb157be95560d481$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $e8Za0 && value === undefined ? $cb157be95560d481$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $cb157be95560d481$var$hashSet;

});



parcelRegister("gjSDq", function(module, exports) {

var $1hSl3 = parcelRequire("1hSl3");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $be18cd096d5759f7$var$mapCacheDelete(key) {
    var result = $1hSl3(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $be18cd096d5759f7$var$mapCacheDelete;

});
parcelRegister("1hSl3", function(module, exports) {

var $aZzTZ = parcelRequire("aZzTZ");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $0f01877de5a605de$var$getMapData(map, key) {
    var data = map.__data__;
    return $aZzTZ(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $0f01877de5a605de$var$getMapData;

});
parcelRegister("aZzTZ", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ 
var $03bAP = parcelRequire("03bAP");
function $800b7348fbfcb000$var$isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value);
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $800b7348fbfcb000$var$isKeyable;

});



parcelRegister("igPQG", function(module, exports) {

var $1hSl3 = parcelRequire("1hSl3");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d4d1f0ab8fb3289b$var$mapCacheGet(key) {
    return $1hSl3(this, key).get(key);
}
module.exports = $d4d1f0ab8fb3289b$var$mapCacheGet;

});

parcelRegister("3c31F", function(module, exports) {

var $1hSl3 = parcelRequire("1hSl3");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2534d6f73c3e224f$var$mapCacheHas(key) {
    return $1hSl3(this, key).has(key);
}
module.exports = $2534d6f73c3e224f$var$mapCacheHas;

});

parcelRegister("9GeBX", function(module, exports) {

var $1hSl3 = parcelRequire("1hSl3");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $70c35ecf39687c1f$var$mapCacheSet(key, value) {
    var data = $1hSl3(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $70c35ecf39687c1f$var$mapCacheSet;

});




parcelRegister("8ngLp", function(module, exports) {

var $hQTAG = parcelRequire("hQTAG");

var $7MfrB = parcelRequire("7MfrB");

var $2MyZQ = parcelRequire("2MyZQ");
/** Used to compose bitmasks for value comparisons. */ var $618d79a438f30b4b$var$COMPARE_PARTIAL_FLAG = 1, $618d79a438f30b4b$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $618d79a438f30b4b$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $618d79a438f30b4b$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $618d79a438f30b4b$var$COMPARE_UNORDERED_FLAG ? new $hQTAG : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$7MfrB(other, function(othValue, othIndex) {
                if (!$2MyZQ(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $618d79a438f30b4b$var$equalArrays;

});
parcelRegister("hQTAG", function(module, exports) {

var $9iMjJ = parcelRequire("9iMjJ");

var $76EKW = parcelRequire("76EKW");

var $kXNCy = parcelRequire("kXNCy");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $cff26a1fd1d1b764$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $9iMjJ;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$cff26a1fd1d1b764$var$SetCache.prototype.add = $cff26a1fd1d1b764$var$SetCache.prototype.push = $76EKW;
$cff26a1fd1d1b764$var$SetCache.prototype.has = $kXNCy;
module.exports = $cff26a1fd1d1b764$var$SetCache;

});
parcelRegister("76EKW", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $52c8b53d68e6a666$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $52c8b53d68e6a666$var$setCacheAdd(value) {
    this.__data__.set(value, $52c8b53d68e6a666$var$HASH_UNDEFINED);
    return this;
}
module.exports = $52c8b53d68e6a666$var$setCacheAdd;

});

parcelRegister("kXNCy", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $f42fcf00262bfee3$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $f42fcf00262bfee3$var$setCacheHas;

});


parcelRegister("7MfrB", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $5a98fefa9d26e20b$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $5a98fefa9d26e20b$var$arraySome;

});

parcelRegister("2MyZQ", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $206b3610e1b7bacd$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $206b3610e1b7bacd$var$cacheHas;

});


parcelRegister("1KLOE", function(module, exports) {

var $chLJV = parcelRequire("chLJV");

var $bj3BB = parcelRequire("bj3BB");

var $1g3Fq = parcelRequire("1g3Fq");

var $8ngLp = parcelRequire("8ngLp");

var $gqmzL = parcelRequire("gqmzL");

var $fQBZZ = parcelRequire("fQBZZ");
/** Used to compose bitmasks for value comparisons. */ var $146f2d91281a2b97$var$COMPARE_PARTIAL_FLAG = 1, $146f2d91281a2b97$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $146f2d91281a2b97$var$boolTag = '[object Boolean]', $146f2d91281a2b97$var$dateTag = '[object Date]', $146f2d91281a2b97$var$errorTag = '[object Error]', $146f2d91281a2b97$var$mapTag = '[object Map]', $146f2d91281a2b97$var$numberTag = '[object Number]', $146f2d91281a2b97$var$regexpTag = '[object RegExp]', $146f2d91281a2b97$var$setTag = '[object Set]', $146f2d91281a2b97$var$stringTag = '[object String]', $146f2d91281a2b97$var$symbolTag = '[object Symbol]';
var $146f2d91281a2b97$var$arrayBufferTag = '[object ArrayBuffer]', $146f2d91281a2b97$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $146f2d91281a2b97$var$symbolProto = $chLJV ? $chLJV.prototype : undefined, $146f2d91281a2b97$var$symbolValueOf = $146f2d91281a2b97$var$symbolProto ? $146f2d91281a2b97$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $146f2d91281a2b97$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $146f2d91281a2b97$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $146f2d91281a2b97$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $bj3BB(object), new $bj3BB(other))) return false;
            return true;
        case $146f2d91281a2b97$var$boolTag:
        case $146f2d91281a2b97$var$dateTag:
        case $146f2d91281a2b97$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $1g3Fq(+object, +other);
        case $146f2d91281a2b97$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $146f2d91281a2b97$var$regexpTag:
        case $146f2d91281a2b97$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $146f2d91281a2b97$var$mapTag:
            var convert = $gqmzL;
        case $146f2d91281a2b97$var$setTag:
            var isPartial = bitmask & $146f2d91281a2b97$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $fQBZZ);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $146f2d91281a2b97$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $8ngLp(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $146f2d91281a2b97$var$symbolTag:
            if ($146f2d91281a2b97$var$symbolValueOf) return $146f2d91281a2b97$var$symbolValueOf.call(object) == $146f2d91281a2b97$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $146f2d91281a2b97$var$equalByTag;

});
parcelRegister("bj3BB", function(module, exports) {

var $6U3A3 = parcelRequire("6U3A3");
/** Built-in value references. */ var $83b4440f01f96de5$var$Uint8Array = $6U3A3.Uint8Array;
module.exports = $83b4440f01f96de5$var$Uint8Array;

});

parcelRegister("gqmzL", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $bf50961dd7fdc601$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $bf50961dd7fdc601$var$mapToArray;

});

parcelRegister("fQBZZ", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $b89930201b109642$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $b89930201b109642$var$setToArray;

});


parcelRegister("a1VJ4", function(module, exports) {

var $8saWy = parcelRequire("8saWy");
/** Used to compose bitmasks for value comparisons. */ var $74d6c6886400438e$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $74d6c6886400438e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $74d6c6886400438e$var$hasOwnProperty = $74d6c6886400438e$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $74d6c6886400438e$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $74d6c6886400438e$var$COMPARE_PARTIAL_FLAG, objProps = $8saWy(object), objLength = objProps.length, othProps = $8saWy(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $74d6c6886400438e$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $74d6c6886400438e$var$equalObjects;

});
parcelRegister("8saWy", function(module, exports) {

var $2QD6E = parcelRequire("2QD6E");

var $6BN2m = parcelRequire("6BN2m");

var $10CyO = parcelRequire("10CyO");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $62796d68ac2eabf5$var$getAllKeys(object) {
    return $2QD6E(object, $10CyO, $6BN2m);
}
module.exports = $62796d68ac2eabf5$var$getAllKeys;

});
parcelRegister("2QD6E", function(module, exports) {

var $8YoPc = parcelRequire("8YoPc");

var $gjQr4 = parcelRequire("gjQr4");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $212ec5cd6351cd7a$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $gjQr4(object) ? result : $8YoPc(result, symbolsFunc(object));
}
module.exports = $212ec5cd6351cd7a$var$baseGetAllKeys;

});
parcelRegister("8YoPc", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $68872f04ec3830db$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $68872f04ec3830db$var$arrayPush;

});

parcelRegister("gjQr4", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $be17184957560598$var$isArray = Array.isArray;
module.exports = $be17184957560598$var$isArray;

});


parcelRegister("6BN2m", function(module, exports) {

var $3kGDP = parcelRequire("3kGDP");

var $ctJOG = parcelRequire("ctJOG");
/** Used for built-in method references. */ var $4cfc3c83ded97bf5$var$objectProto = Object.prototype;
/** Built-in value references. */ var $4cfc3c83ded97bf5$var$propertyIsEnumerable = $4cfc3c83ded97bf5$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4cfc3c83ded97bf5$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $4cfc3c83ded97bf5$var$getSymbols = !$4cfc3c83ded97bf5$var$nativeGetSymbols ? $ctJOG : function getSymbols(object) {
    if (object == null) return [];
    object = Object(object);
    return $3kGDP($4cfc3c83ded97bf5$var$nativeGetSymbols(object), function(symbol) {
        return $4cfc3c83ded97bf5$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $4cfc3c83ded97bf5$var$getSymbols;

});
parcelRegister("3kGDP", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $26d45109dea2b1e9$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $26d45109dea2b1e9$var$arrayFilter;

});

parcelRegister("ctJOG", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $915bbbab57c5cc04$var$stubArray() {
    return [];
}
module.exports = $915bbbab57c5cc04$var$stubArray;

});


parcelRegister("10CyO", function(module, exports) {

var $68gR9 = parcelRequire("68gR9");

var $chEPD = parcelRequire("chEPD");

var $13FKp = parcelRequire("13FKp");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0bc3b3dcd1b7ca7e$var$keys(object) {
    return $13FKp(object) ? $68gR9(object) : $chEPD(object);
}
module.exports = $0bc3b3dcd1b7ca7e$var$keys;

});
parcelRegister("68gR9", function(module, exports) {

var $1sTU2 = parcelRequire("1sTU2");

var $is21e = parcelRequire("is21e");

var $gjQr4 = parcelRequire("gjQr4");

var $18svd = parcelRequire("18svd");

var $4FriW = parcelRequire("4FriW");

var $bXxa9 = parcelRequire("bXxa9");
/** Used for built-in method references. */ var $477090bc81f72caf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $477090bc81f72caf$var$hasOwnProperty = $477090bc81f72caf$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $477090bc81f72caf$var$arrayLikeKeys(value, inherited) {
    var isArr = $gjQr4(value), isArg = !isArr && $is21e(value), isBuff = !isArr && !isArg && $18svd(value), isType = !isArr && !isArg && !isBuff && $bXxa9(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $1sTU2(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $477090bc81f72caf$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $4FriW(key, length)))) result.push(key);
    return result;
}
module.exports = $477090bc81f72caf$var$arrayLikeKeys;

});
parcelRegister("1sTU2", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $1113c51a16708baa$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $1113c51a16708baa$var$baseTimes;

});

parcelRegister("is21e", function(module, exports) {

var $b7Zsg = parcelRequire("b7Zsg");

var $7N4ni = parcelRequire("7N4ni");
/** Used for built-in method references. */ var $d6ec6866088ea1c4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d6ec6866088ea1c4$var$hasOwnProperty = $d6ec6866088ea1c4$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $d6ec6866088ea1c4$var$propertyIsEnumerable = $d6ec6866088ea1c4$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $d6ec6866088ea1c4$var$isArguments = $b7Zsg(function() {
    return arguments;
}()) ? $b7Zsg : function isArguments(value) {
    return $7N4ni(value) && $d6ec6866088ea1c4$var$hasOwnProperty.call(value, 'callee') && !$d6ec6866088ea1c4$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $d6ec6866088ea1c4$var$isArguments;

});
parcelRegister("b7Zsg", function(module, exports) {

var $anDuf = parcelRequire("anDuf");

var $7N4ni = parcelRequire("7N4ni");
/** `Object#toString` result references. */ var $81a004d09f5de9f5$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $81a004d09f5de9f5$var$baseIsArguments(value) {
    return $7N4ni(value) && $anDuf(value) == $81a004d09f5de9f5$var$argsTag;
}
module.exports = $81a004d09f5de9f5$var$baseIsArguments;

});
parcelRegister("7N4ni", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ 
var $03bAP = parcelRequire("03bAP");
function $5ac080c3bd8f3dce$var$isObjectLike(value) {
    return value != null && (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) == 'object';
}
module.exports = $5ac080c3bd8f3dce$var$isObjectLike;

});



parcelRegister("18svd", function(module, exports) {

var $6U3A3 = parcelRequire("6U3A3");

var $3MF1h = parcelRequire("3MF1h");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $6U3A3.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $3MF1h;
module.exports = isBuffer;

});
parcelRegister("3MF1h", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $2c15ac76f106720d$var$stubFalse() {
    return false;
}
module.exports = $2c15ac76f106720d$var$stubFalse;

});


parcelRegister("4FriW", function(module, exports) {
/** Used as references for various `Number` constants. */ 
var $03bAP = parcelRequire("03bAP");
var $36602bd7b246dae2$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $36602bd7b246dae2$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $36602bd7b246dae2$var$isIndex(value, length) {
    var type = typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value);
    length = length == null ? $36602bd7b246dae2$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $36602bd7b246dae2$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $36602bd7b246dae2$var$isIndex;

});

parcelRegister("bXxa9", function(module, exports) {

var $amyJ8 = parcelRequire("amyJ8");

var $dhi5l = parcelRequire("dhi5l");

var $51zJC = parcelRequire("51zJC");
/* Node.js helper references. */ var $8b4eedd3401e1a85$var$nodeIsTypedArray = $51zJC && $51zJC.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $8b4eedd3401e1a85$var$isTypedArray = $8b4eedd3401e1a85$var$nodeIsTypedArray ? $dhi5l($8b4eedd3401e1a85$var$nodeIsTypedArray) : $amyJ8;
module.exports = $8b4eedd3401e1a85$var$isTypedArray;

});
parcelRegister("amyJ8", function(module, exports) {

var $anDuf = parcelRequire("anDuf");

var $6kyUd = parcelRequire("6kyUd");

var $7N4ni = parcelRequire("7N4ni");
/** `Object#toString` result references. */ var $78b6e586d4f55b7f$var$argsTag = '[object Arguments]', $78b6e586d4f55b7f$var$arrayTag = '[object Array]', $78b6e586d4f55b7f$var$boolTag = '[object Boolean]', $78b6e586d4f55b7f$var$dateTag = '[object Date]', $78b6e586d4f55b7f$var$errorTag = '[object Error]', $78b6e586d4f55b7f$var$funcTag = '[object Function]', $78b6e586d4f55b7f$var$mapTag = '[object Map]', $78b6e586d4f55b7f$var$numberTag = '[object Number]', $78b6e586d4f55b7f$var$objectTag = '[object Object]', $78b6e586d4f55b7f$var$regexpTag = '[object RegExp]', $78b6e586d4f55b7f$var$setTag = '[object Set]', $78b6e586d4f55b7f$var$stringTag = '[object String]', $78b6e586d4f55b7f$var$weakMapTag = '[object WeakMap]';
var $78b6e586d4f55b7f$var$arrayBufferTag = '[object ArrayBuffer]', $78b6e586d4f55b7f$var$dataViewTag = '[object DataView]', $78b6e586d4f55b7f$var$float32Tag = '[object Float32Array]', $78b6e586d4f55b7f$var$float64Tag = '[object Float64Array]', $78b6e586d4f55b7f$var$int8Tag = '[object Int8Array]', $78b6e586d4f55b7f$var$int16Tag = '[object Int16Array]', $78b6e586d4f55b7f$var$int32Tag = '[object Int32Array]', $78b6e586d4f55b7f$var$uint8Tag = '[object Uint8Array]', $78b6e586d4f55b7f$var$uint8ClampedTag = '[object Uint8ClampedArray]', $78b6e586d4f55b7f$var$uint16Tag = '[object Uint16Array]', $78b6e586d4f55b7f$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $78b6e586d4f55b7f$var$typedArrayTags = {};
$78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$float32Tag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$float64Tag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$int8Tag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$int16Tag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$int32Tag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$uint8Tag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$uint8ClampedTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$uint16Tag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$uint32Tag] = true;
$78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$argsTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$arrayTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$arrayBufferTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$boolTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$dataViewTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$dateTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$errorTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$funcTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$mapTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$numberTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$objectTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$regexpTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$setTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$stringTag] = $78b6e586d4f55b7f$var$typedArrayTags[$78b6e586d4f55b7f$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $78b6e586d4f55b7f$var$baseIsTypedArray(value) {
    return $7N4ni(value) && $6kyUd(value.length) && !!$78b6e586d4f55b7f$var$typedArrayTags[$anDuf(value)];
}
module.exports = $78b6e586d4f55b7f$var$baseIsTypedArray;

});
parcelRegister("6kyUd", function(module, exports) {
/** Used as references for various `Number` constants. */ var $49bfafe21f5e792e$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $49bfafe21f5e792e$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $49bfafe21f5e792e$var$MAX_SAFE_INTEGER;
}
module.exports = $49bfafe21f5e792e$var$isLength;

});


parcelRegister("dhi5l", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $9aaae4395c25f5f8$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $9aaae4395c25f5f8$var$baseUnary;

});

parcelRegister("51zJC", function(module, exports) {

var $hJEtK = parcelRequire("hJEtK");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $hJEtK.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("chEPD", function(module, exports) {

var $brxeA = parcelRequire("brxeA");

var $gfrgp = parcelRequire("gfrgp");
/** Used for built-in method references. */ var $8f16beeb80861b09$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8f16beeb80861b09$var$hasOwnProperty = $8f16beeb80861b09$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8f16beeb80861b09$var$baseKeys(object) {
    if (!$brxeA(object)) return $gfrgp(object);
    var result = [];
    for(var key in Object(object))if ($8f16beeb80861b09$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $8f16beeb80861b09$var$baseKeys;

});
parcelRegister("brxeA", function(module, exports) {
/** Used for built-in method references. */ var $854bfef77ec4ddac$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $854bfef77ec4ddac$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $854bfef77ec4ddac$var$objectProto;
    return value === proto;
}
module.exports = $854bfef77ec4ddac$var$isPrototype;

});

parcelRegister("gfrgp", function(module, exports) {

var $bjp8J = parcelRequire("bjp8J");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bd43320c59f63f8e$var$nativeKeys = $bjp8J(Object.keys, Object);
module.exports = $bd43320c59f63f8e$var$nativeKeys;

});
parcelRegister("bjp8J", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $83c4f84c5b451ee2$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $83c4f84c5b451ee2$var$overArg;

});



parcelRegister("13FKp", function(module, exports) {

var $7mdb9 = parcelRequire("7mdb9");

var $6kyUd = parcelRequire("6kyUd");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $0c5674784d9803e4$var$isArrayLike(value) {
    return value != null && $6kyUd(value.length) && !$7mdb9(value);
}
module.exports = $0c5674784d9803e4$var$isArrayLike;

});




parcelRegister("d372L", function(module, exports) {

var $lTFt2 = parcelRequire("lTFt2");

var $6ok7H = parcelRequire("6ok7H");

var $dwXGS = parcelRequire("dwXGS");

var $kce7p = parcelRequire("kce7p");

var $7zLua = parcelRequire("7zLua");

var $anDuf = parcelRequire("anDuf");

var $lwwmM = parcelRequire("lwwmM");
/** `Object#toString` result references. */ var $980104e24d205075$var$mapTag = '[object Map]', $980104e24d205075$var$objectTag = '[object Object]', $980104e24d205075$var$promiseTag = '[object Promise]', $980104e24d205075$var$setTag = '[object Set]', $980104e24d205075$var$weakMapTag = '[object WeakMap]';
var $980104e24d205075$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $980104e24d205075$var$dataViewCtorString = $lwwmM($lTFt2), $980104e24d205075$var$mapCtorString = $lwwmM($6ok7H), $980104e24d205075$var$promiseCtorString = $lwwmM($dwXGS), $980104e24d205075$var$setCtorString = $lwwmM($kce7p), $980104e24d205075$var$weakMapCtorString = $lwwmM($7zLua);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $980104e24d205075$var$getTag = $anDuf;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($lTFt2 && $980104e24d205075$var$getTag(new $lTFt2(new ArrayBuffer(1))) != $980104e24d205075$var$dataViewTag || $6ok7H && $980104e24d205075$var$getTag(new $6ok7H) != $980104e24d205075$var$mapTag || $dwXGS && $980104e24d205075$var$getTag($dwXGS.resolve()) != $980104e24d205075$var$promiseTag || $kce7p && $980104e24d205075$var$getTag(new $kce7p) != $980104e24d205075$var$setTag || $7zLua && $980104e24d205075$var$getTag(new $7zLua) != $980104e24d205075$var$weakMapTag) $980104e24d205075$var$getTag = function getTag(value) {
    var result = $anDuf(value), Ctor = result == $980104e24d205075$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $lwwmM(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $980104e24d205075$var$dataViewCtorString:
            return $980104e24d205075$var$dataViewTag;
        case $980104e24d205075$var$mapCtorString:
            return $980104e24d205075$var$mapTag;
        case $980104e24d205075$var$promiseCtorString:
            return $980104e24d205075$var$promiseTag;
        case $980104e24d205075$var$setCtorString:
            return $980104e24d205075$var$setTag;
        case $980104e24d205075$var$weakMapCtorString:
            return $980104e24d205075$var$weakMapTag;
    }
    return result;
};
module.exports = $980104e24d205075$var$getTag;

});
parcelRegister("lTFt2", function(module, exports) {

var $kWWbB = parcelRequire("kWWbB");

var $6U3A3 = parcelRequire("6U3A3");
/* Built-in method references that are verified to be native. */ var $ff0ee695735cbf0b$var$DataView = $kWWbB($6U3A3, 'DataView');
module.exports = $ff0ee695735cbf0b$var$DataView;

});

parcelRegister("dwXGS", function(module, exports) {

var $kWWbB = parcelRequire("kWWbB");

var $6U3A3 = parcelRequire("6U3A3");
/* Built-in method references that are verified to be native. */ var $9d9c90d79eb26dfb$var$Promise = $kWWbB($6U3A3, 'Promise');
module.exports = $9d9c90d79eb26dfb$var$Promise;

});

parcelRegister("kce7p", function(module, exports) {

var $kWWbB = parcelRequire("kWWbB");

var $6U3A3 = parcelRequire("6U3A3");
/* Built-in method references that are verified to be native. */ var $eb3fe140997813f6$var$Set = $kWWbB($6U3A3, 'Set');
module.exports = $eb3fe140997813f6$var$Set;

});

parcelRegister("7zLua", function(module, exports) {

var $kWWbB = parcelRequire("kWWbB");

var $6U3A3 = parcelRequire("6U3A3");
/* Built-in method references that are verified to be native. */ var $5840a2f5211a17fd$var$WeakMap = $kWWbB($6U3A3, 'WeakMap');
module.exports = $5840a2f5211a17fd$var$WeakMap;

});





parcelRegister("kO46s", function(module, exports) {

var $sZt0R = parcelRequire("sZt0R");

var $4rBIZ = parcelRequire("4rBIZ");

var $3DIlv = parcelRequire("3DIlv");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f25ba8fbacd5f453$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $f25ba8fbacd5f453$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $3DIlv(fromIndex);
    if (index < 0) index = $f25ba8fbacd5f453$var$nativeMax(length + index, 0);
    return $sZt0R(array, $4rBIZ(predicate, 3), index);
}
module.exports = $f25ba8fbacd5f453$var$findIndex;

});
parcelRegister("sZt0R", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $05724bb217af92bc$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $05724bb217af92bc$var$baseFindIndex;

});

parcelRegister("4rBIZ", function(module, exports) {

var $03bAP = parcelRequire("03bAP");

var $i1cJk = parcelRequire("i1cJk");

var $3drHG = parcelRequire("3drHG");

var $236oS = parcelRequire("236oS");

var $gjQr4 = parcelRequire("gjQr4");

var $cEfSf = parcelRequire("cEfSf");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $33c6f25982c74670$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $236oS;
    if ((typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) == 'object') return $gjQr4(value) ? $3drHG(value[0], value[1]) : $i1cJk(value);
    return $cEfSf(value);
}
module.exports = $33c6f25982c74670$var$baseIteratee;

});
parcelRegister("i1cJk", function(module, exports) {

var $bnWIy = parcelRequire("bnWIy");

var $lwfl5 = parcelRequire("lwfl5");

var $fe00a = parcelRequire("fe00a");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $d1e231e7d880f826$var$baseMatches(source) {
    var matchData = $lwfl5(source);
    if (matchData.length == 1 && matchData[0][2]) return $fe00a(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $bnWIy(object, source, matchData);
    };
}
module.exports = $d1e231e7d880f826$var$baseMatches;

});
parcelRegister("bnWIy", function(module, exports) {

var $9E4Ag = parcelRequire("9E4Ag");

var $GyYXy = parcelRequire("GyYXy");
/** Used to compose bitmasks for value comparisons. */ var $849f63c306abef2f$var$COMPARE_PARTIAL_FLAG = 1, $849f63c306abef2f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $849f63c306abef2f$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $9E4Ag;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $GyYXy(srcValue, objValue, $849f63c306abef2f$var$COMPARE_PARTIAL_FLAG | $849f63c306abef2f$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $849f63c306abef2f$var$baseIsMatch;

});

parcelRegister("lwfl5", function(module, exports) {

var $5l8VF = parcelRequire("5l8VF");

var $10CyO = parcelRequire("10CyO");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $faa87c242a54337f$var$getMatchData(object) {
    var result = $10CyO(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $5l8VF(value)
        ];
    }
    return result;
}
module.exports = $faa87c242a54337f$var$getMatchData;

});
parcelRegister("5l8VF", function(module, exports) {

var $gpxvq = parcelRequire("gpxvq");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $3e35d70a7fce5baf$var$isStrictComparable(value) {
    return value === value && !$gpxvq(value);
}
module.exports = $3e35d70a7fce5baf$var$isStrictComparable;

});


parcelRegister("fe00a", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $b1582a250d00fe79$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $b1582a250d00fe79$var$matchesStrictComparable;

});


parcelRegister("3drHG", function(module, exports) {

var $GyYXy = parcelRequire("GyYXy");

var $gH1jF = parcelRequire("gH1jF");

var $2ANL6 = parcelRequire("2ANL6");

var $eEiWp = parcelRequire("eEiWp");

var $5l8VF = parcelRequire("5l8VF");

var $fe00a = parcelRequire("fe00a");

var $gaqpM = parcelRequire("gaqpM");
/** Used to compose bitmasks for value comparisons. */ var $2578135e2449657d$var$COMPARE_PARTIAL_FLAG = 1, $2578135e2449657d$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $2578135e2449657d$var$baseMatchesProperty(path, srcValue) {
    if ($eEiWp(path) && $5l8VF(srcValue)) return $fe00a($gaqpM(path), srcValue);
    return function(object) {
        var objValue = $gH1jF(object, path);
        return objValue === undefined && objValue === srcValue ? $2ANL6(object, path) : $GyYXy(srcValue, objValue, $2578135e2449657d$var$COMPARE_PARTIAL_FLAG | $2578135e2449657d$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $2578135e2449657d$var$baseMatchesProperty;

});
parcelRegister("gH1jF", function(module, exports) {

var $6ZSXD = parcelRequire("6ZSXD");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $c271aee028e89cc9$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $6ZSXD(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $c271aee028e89cc9$var$get;

});
parcelRegister("6ZSXD", function(module, exports) {

var $fWwJl = parcelRequire("fWwJl");

var $gaqpM = parcelRequire("gaqpM");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $518312a4aacdcf6a$var$baseGet(object, path) {
    path = $fWwJl(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$gaqpM(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $518312a4aacdcf6a$var$baseGet;

});
parcelRegister("fWwJl", function(module, exports) {

var $gjQr4 = parcelRequire("gjQr4");

var $eEiWp = parcelRequire("eEiWp");

var $j5zY1 = parcelRequire("j5zY1");

var $fXGUj = parcelRequire("fXGUj");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $b9b5a95d83747cf9$var$castPath(value, object) {
    if ($gjQr4(value)) return value;
    return $eEiWp(value, object) ? [
        value
    ] : $j5zY1($fXGUj(value));
}
module.exports = $b9b5a95d83747cf9$var$castPath;

});
parcelRegister("eEiWp", function(module, exports) {

var $03bAP = parcelRequire("03bAP");

var $gjQr4 = parcelRequire("gjQr4");

var $kRf9i = parcelRequire("kRf9i");
/** Used to match property names within property paths. */ var $aaa37e6c150f4a76$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $aaa37e6c150f4a76$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $aaa37e6c150f4a76$var$isKey(value, object) {
    if ($gjQr4(value)) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value);
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $kRf9i(value)) return true;
    return $aaa37e6c150f4a76$var$reIsPlainProp.test(value) || !$aaa37e6c150f4a76$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $aaa37e6c150f4a76$var$isKey;

});
parcelRegister("kRf9i", function(module, exports) {

var $03bAP = parcelRequire("03bAP");

var $anDuf = parcelRequire("anDuf");

var $7N4ni = parcelRequire("7N4ni");
/** `Object#toString` result references. */ var $f2f48225511a41d7$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $f2f48225511a41d7$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) == 'symbol' || $7N4ni(value) && $anDuf(value) == $f2f48225511a41d7$var$symbolTag;
}
module.exports = $f2f48225511a41d7$var$isSymbol;

});


parcelRegister("j5zY1", function(module, exports) {

var $8kFyw = parcelRequire("8kFyw");
/** Used to match property names within property paths. */ var $de5a623e361afa5a$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $de5a623e361afa5a$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $de5a623e361afa5a$var$stringToPath = $8kFyw(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($de5a623e361afa5a$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($de5a623e361afa5a$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $de5a623e361afa5a$var$stringToPath;

});
parcelRegister("8kFyw", function(module, exports) {

var $dELQy = parcelRequire("dELQy");
/** Used as the maximum memoize cache size. */ var $61106d1b8c079976$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $61106d1b8c079976$var$memoizeCapped(func) {
    var result = $dELQy(func, function(key) {
        if (cache.size === $61106d1b8c079976$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $61106d1b8c079976$var$memoizeCapped;

});
parcelRegister("dELQy", function(module, exports) {

var $9iMjJ = parcelRequire("9iMjJ");
/** Error message constants. */ var $9f1420280ada0995$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $9f1420280ada0995$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($9f1420280ada0995$var$FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($9f1420280ada0995$var$memoize.Cache || $9iMjJ);
    return memoized;
}
// Expose `MapCache`.
$9f1420280ada0995$var$memoize.Cache = $9iMjJ;
module.exports = $9f1420280ada0995$var$memoize;

});



parcelRegister("fXGUj", function(module, exports) {

var $fzX3V = parcelRequire("fzX3V");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $b9eda62d2b8d164c$var$toString(value) {
    return value == null ? '' : $fzX3V(value);
}
module.exports = $b9eda62d2b8d164c$var$toString;

});
parcelRegister("fzX3V", function(module, exports) {

var $chLJV = parcelRequire("chLJV");

var $cFzTG = parcelRequire("cFzTG");

var $gjQr4 = parcelRequire("gjQr4");

var $kRf9i = parcelRequire("kRf9i");
/** Used as references for various `Number` constants. */ var $b577f074dc20bf15$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $b577f074dc20bf15$var$symbolProto = $chLJV ? $chLJV.prototype : undefined, $b577f074dc20bf15$var$symbolToString = $b577f074dc20bf15$var$symbolProto ? $b577f074dc20bf15$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $b577f074dc20bf15$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($gjQr4(value)) // Recursively convert values (susceptible to call stack limits).
    return $cFzTG(value, $b577f074dc20bf15$var$baseToString) + '';
    if ($kRf9i(value)) return $b577f074dc20bf15$var$symbolToString ? $b577f074dc20bf15$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$b577f074dc20bf15$var$INFINITY ? '-0' : result;
}
module.exports = $b577f074dc20bf15$var$baseToString;

});
parcelRegister("cFzTG", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $939528caa85c5700$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $939528caa85c5700$var$arrayMap;

});




parcelRegister("gaqpM", function(module, exports) {

var $kRf9i = parcelRequire("kRf9i");
/** Used as references for various `Number` constants. */ var $bc5211f7f7392089$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $bc5211f7f7392089$var$toKey(value) {
    if (typeof value == 'string' || $kRf9i(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$bc5211f7f7392089$var$INFINITY ? '-0' : result;
}
module.exports = $bc5211f7f7392089$var$toKey;

});



parcelRegister("2ANL6", function(module, exports) {

var $ixo08 = parcelRequire("ixo08");

var $lD2A4 = parcelRequire("lD2A4");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $1e358aa1f76f48d9$var$hasIn(object, path) {
    return object != null && $lD2A4(object, path, $ixo08);
}
module.exports = $1e358aa1f76f48d9$var$hasIn;

});
parcelRegister("ixo08", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d7eded34dda31037$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $d7eded34dda31037$var$baseHasIn;

});

parcelRegister("lD2A4", function(module, exports) {

var $fWwJl = parcelRequire("fWwJl");

var $is21e = parcelRequire("is21e");

var $gjQr4 = parcelRequire("gjQr4");

var $4FriW = parcelRequire("4FriW");

var $6kyUd = parcelRequire("6kyUd");

var $gaqpM = parcelRequire("gaqpM");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $fbef3df8c7f4553f$var$hasPath(object, path, hasFunc) {
    path = $fWwJl(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $gaqpM(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $6kyUd(length) && $4FriW(key, length) && ($gjQr4(object) || $is21e(object));
}
module.exports = $fbef3df8c7f4553f$var$hasPath;

});



parcelRegister("236oS", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $17e0d38b1f007960$var$identity(value) {
    return value;
}
module.exports = $17e0d38b1f007960$var$identity;

});

parcelRegister("cEfSf", function(module, exports) {

var $d76G5 = parcelRequire("d76G5");

var $bvsVR = parcelRequire("bvsVR");

var $eEiWp = parcelRequire("eEiWp");

var $gaqpM = parcelRequire("gaqpM");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $935588b3baa103cf$var$property(path) {
    return $eEiWp(path) ? $d76G5($gaqpM(path)) : $bvsVR(path);
}
module.exports = $935588b3baa103cf$var$property;

});
parcelRegister("d76G5", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $98c11bde66aa73d4$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $98c11bde66aa73d4$var$baseProperty;

});

parcelRegister("bvsVR", function(module, exports) {

var $6ZSXD = parcelRequire("6ZSXD");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $8609084f1e8c1fdb$var$basePropertyDeep(path) {
    return function(object) {
        return $6ZSXD(object, path);
    };
}
module.exports = $8609084f1e8c1fdb$var$basePropertyDeep;

});



parcelRegister("3DIlv", function(module, exports) {

var $b9Xpq = parcelRequire("b9Xpq");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $2a6769c6c9429eae$var$toInteger(value) {
    var result = $b9Xpq(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $2a6769c6c9429eae$var$toInteger;

});
parcelRegister("b9Xpq", function(module, exports) {

var $f5svQ = parcelRequire("f5svQ");
/** Used as references for various `Number` constants. */ var $81fe9e5a98de8f0b$var$INFINITY = 1 / 0, $81fe9e5a98de8f0b$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $81fe9e5a98de8f0b$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $f5svQ(value);
    if (value === $81fe9e5a98de8f0b$var$INFINITY || value === -$81fe9e5a98de8f0b$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $81fe9e5a98de8f0b$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $81fe9e5a98de8f0b$var$toFinite;

});
parcelRegister("f5svQ", function(module, exports) {

var $iN9cE = parcelRequire("iN9cE");

var $gpxvq = parcelRequire("gpxvq");

var $kRf9i = parcelRequire("kRf9i");
/** Used as references for various `Number` constants. */ var $afbd70aacfa35e23$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $afbd70aacfa35e23$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $afbd70aacfa35e23$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $afbd70aacfa35e23$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $afbd70aacfa35e23$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $afbd70aacfa35e23$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($kRf9i(value)) return $afbd70aacfa35e23$var$NAN;
    if ($gpxvq(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $gpxvq(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $iN9cE(value);
    var isBinary = $afbd70aacfa35e23$var$reIsBinary.test(value);
    return isBinary || $afbd70aacfa35e23$var$reIsOctal.test(value) ? $afbd70aacfa35e23$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $afbd70aacfa35e23$var$reIsBadHex.test(value) ? $afbd70aacfa35e23$var$NAN : +value;
}
module.exports = $afbd70aacfa35e23$var$toNumber;

});
parcelRegister("iN9cE", function(module, exports) {

var $11A9a = parcelRequire("11A9a");
/** Used to match leading whitespace. */ var $dae3f1221645f022$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $dae3f1221645f022$var$baseTrim(string) {
    return string ? string.slice(0, $11A9a(string) + 1).replace($dae3f1221645f022$var$reTrimStart, '') : string;
}
module.exports = $dae3f1221645f022$var$baseTrim;

});
parcelRegister("11A9a", function(module, exports) {
/** Used to match a single whitespace character. */ var $0bf1ec6db1167c8e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $0bf1ec6db1167c8e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $0bf1ec6db1167c8e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $0bf1ec6db1167c8e$var$trimmedEndIndex;

});






parcelRegister("6Ri8i", function(module, exports) {

var $6U3A3 = parcelRequire("6U3A3");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $6U3A3.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("8Dew7", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $648d3a0771fdad4c$var$withDragAndDrop;

var $648d3a0771fdad4c$var$_extends2 = $jdupM((parcelRequire("hKIoA")));

var $648d3a0771fdad4c$var$_defineProperty2 = $jdupM((parcelRequire("8s7es")));

var $648d3a0771fdad4c$var$_objectWithoutProperties2 = $jdupM((parcelRequire("klbDn")));

var $648d3a0771fdad4c$var$_classCallCheck2 = $jdupM((parcelRequire("ioyax")));

var $648d3a0771fdad4c$var$_createClass2 = $jdupM((parcelRequire("3EnhW")));

var $648d3a0771fdad4c$var$_possibleConstructorReturn2 = $jdupM((parcelRequire("7o6yO")));

var $648d3a0771fdad4c$var$_getPrototypeOf2 = $jdupM((parcelRequire("lovB8")));

var $648d3a0771fdad4c$var$_inherits2 = $jdupM((parcelRequire("9rajK")));

var $648d3a0771fdad4c$var$_propTypes = $jdupM((parcelRequire("4YVCt")));

var $648d3a0771fdad4c$var$_react = $jdupM((parcelRequire("5s1kH")));

var $648d3a0771fdad4c$var$_clsx = $jdupM((parcelRequire("7btCe")));
parcelRequire("350Ey");

var $648d3a0771fdad4c$var$_EventWrapper = $jdupM((parcelRequire("3lOUe")));

var $648d3a0771fdad4c$var$_EventContainerWrapper = $jdupM((parcelRequire("c0Z2I")));

var $648d3a0771fdad4c$var$_WeekWrapper = $jdupM((parcelRequire("j8xtW")));

var $2JAPW = parcelRequire("2JAPW");

var $8F1Dg = parcelRequire("8F1Dg");
var $648d3a0771fdad4c$var$_excluded = [
    "selectable",
    "elementProps",
    "components"
];
function $648d3a0771fdad4c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $648d3a0771fdad4c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $648d3a0771fdad4c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $648d3a0771fdad4c$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $648d3a0771fdad4c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $648d3a0771fdad4c$var$_callSuper(t, o, e) {
    return o = (0, $648d3a0771fdad4c$var$_getPrototypeOf2.default)(o), (0, $648d3a0771fdad4c$var$_possibleConstructorReturn2.default)(t, $648d3a0771fdad4c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $648d3a0771fdad4c$var$_getPrototypeOf2.default)(t).constructor) : o.apply(t, e));
}
function $648d3a0771fdad4c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($648d3a0771fdad4c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $648d3a0771fdad4c$var$withDragAndDrop(Calendar) {
    var DragAndDropCalendar = /*#__PURE__*/ function(_React$Component) {
        function DragAndDropCalendar() {
            var _this;
            (0, $648d3a0771fdad4c$var$_classCallCheck2.default)(this, DragAndDropCalendar);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $648d3a0771fdad4c$var$_callSuper(this, DragAndDropCalendar, [].concat(args));
            _this.defaultOnDragOver = function(event) {
                event.preventDefault();
            };
            _this.handleBeginAction = function(event, action, direction) {
                _this.setState({
                    event: event,
                    action: action,
                    direction: direction
                });
                var onDragStart = _this.props.onDragStart;
                if (onDragStart) onDragStart({
                    event: event,
                    action: action,
                    direction: direction
                });
            };
            _this.handleInteractionStart = function() {
                if (_this.state.interacting === false) _this.setState({
                    interacting: true
                });
            };
            _this.handleInteractionEnd = function(interactionInfo) {
                var _this$state = _this.state, action = _this$state.action, event = _this$state.event;
                if (!action) return;
                _this.setState({
                    action: null,
                    event: null,
                    interacting: false,
                    direction: null
                });
                if (interactionInfo == null) return;
                interactionInfo.event = event;
                var _this$props = _this.props, onEventDrop = _this$props.onEventDrop, onEventResize = _this$props.onEventResize;
                if (action === 'move' && onEventDrop) onEventDrop(interactionInfo);
                if (action === 'resize' && onEventResize) onEventResize(interactionInfo);
            };
            _this.state = {
                interacting: false
            };
            return _this;
        }
        (0, $648d3a0771fdad4c$var$_inherits2.default)(DragAndDropCalendar, _React$Component);
        return (0, $648d3a0771fdad4c$var$_createClass2.default)(DragAndDropCalendar, [
            {
                key: "getDnDContextValue",
                value: function getDnDContextValue() {
                    return {
                        draggable: {
                            onStart: this.handleInteractionStart,
                            onEnd: this.handleInteractionEnd,
                            onBeginAction: this.handleBeginAction,
                            onDropFromOutside: this.props.onDropFromOutside,
                            dragFromOutsideItem: this.props.dragFromOutsideItem,
                            draggableAccessor: this.props.draggableAccessor,
                            resizableAccessor: this.props.resizableAccessor,
                            dragAndDropAction: this.state
                        }
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props2 = this.props, selectable = _this$props2.selectable, elementProps = _this$props2.elementProps, components = _this$props2.components, props = (0, $648d3a0771fdad4c$var$_objectWithoutProperties2.default)(_this$props2, $648d3a0771fdad4c$var$_excluded);
                    var interacting = this.state.interacting;
                    delete props.onEventDrop;
                    delete props.onEventResize;
                    props.selectable = selectable ? 'ignoreEvents' : false;
                    this.components = (0, $2JAPW.mergeComponents)(components, {
                        eventWrapper: $648d3a0771fdad4c$var$_EventWrapper.default,
                        eventContainerWrapper: $648d3a0771fdad4c$var$_EventContainerWrapper.default,
                        weekWrapper: $648d3a0771fdad4c$var$_WeekWrapper.default
                    });
                    var elementPropsWithDropFromOutside = this.props.onDropFromOutside ? $648d3a0771fdad4c$var$_objectSpread($648d3a0771fdad4c$var$_objectSpread({}, elementProps), {}, {
                        onDragOver: this.props.onDragOver || this.defaultOnDragOver
                    }) : elementProps;
                    props.className = (0, $648d3a0771fdad4c$var$_clsx.default)(props.className, 'rbc-addons-dnd', !!interacting && 'rbc-addons-dnd-is-dragging');
                    var context = this.getDnDContextValue();
                    return /*#__PURE__*/ $648d3a0771fdad4c$var$_react.default.createElement($8F1Dg.DnDContext.Provider, {
                        value: context
                    }, /*#__PURE__*/ $648d3a0771fdad4c$var$_react.default.createElement(Calendar, (0, $648d3a0771fdad4c$var$_extends2.default)({}, props, {
                        elementProps: elementPropsWithDropFromOutside,
                        components: this.components
                    })));
                }
            }
        ]);
    }($648d3a0771fdad4c$var$_react.default.Component);
    DragAndDropCalendar.defaultProps = $648d3a0771fdad4c$var$_objectSpread($648d3a0771fdad4c$var$_objectSpread({}, Calendar.defaultProps), {}, {
        draggableAccessor: null,
        resizableAccessor: null,
        resizable: true
    });
    DragAndDropCalendar.propTypes = {};
    return DragAndDropCalendar;
}

});
parcelRegister("jdupM", function(module, exports) {
function $dfd6d2f15b048a4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $dfd6d2f15b048a4e$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hKIoA", function(module, exports) {
function $cec92b8e275d5b5f$var$_extends() {
    return module.exports = $cec92b8e275d5b5f$var$_extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $cec92b8e275d5b5f$var$_extends.apply(null, arguments);
}
module.exports = $cec92b8e275d5b5f$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8s7es", function(module, exports) {

var $5DznZ = parcelRequire("5DznZ");
function $62768c67174fe2b8$var$_defineProperty(e, r, t) {
    return (r = $5DznZ(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $62768c67174fe2b8$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DznZ", function(module, exports) {

var $deONc = parcelRequire("deONc");
var $41ac0b3164c9358a$var$_typeof = $deONc.default;

var $1XIZA = parcelRequire("1XIZA");
function $41ac0b3164c9358a$var$toPropertyKey(t) {
    var i = $1XIZA(t, "string");
    return "symbol" == $41ac0b3164c9358a$var$_typeof(i) ? i : i + "";
}
module.exports = $41ac0b3164c9358a$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("deONc", function(module, exports) {
function $9a33fb7ccd05be93$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $9a33fb7ccd05be93$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9a33fb7ccd05be93$var$_typeof(o);
}
module.exports = $9a33fb7ccd05be93$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1XIZA", function(module, exports) {

var $deONc = parcelRequire("deONc");
var $16de33a84521030e$var$_typeof = $deONc.default;
function $16de33a84521030e$var$toPrimitive(t, r) {
    if ("object" != $16de33a84521030e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $16de33a84521030e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $16de33a84521030e$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("klbDn", function(module, exports) {

var $lAZJV = parcelRequire("lAZJV");
function $eceecb18a8376733$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $lAZJV(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $eceecb18a8376733$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lAZJV", function(module, exports) {
function $fb8cd9ff294327c7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $fb8cd9ff294327c7$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("ioyax", function(module, exports) {
function $d644f922025262e2$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $d644f922025262e2$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3EnhW", function(module, exports) {

var $5DznZ = parcelRequire("5DznZ");
function $2a872c21cc9f2813$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5DznZ(o.key), o);
    }
}
function $2a872c21cc9f2813$var$_createClass(e, r, t) {
    return r && $2a872c21cc9f2813$var$_defineProperties(e.prototype, r), t && $2a872c21cc9f2813$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $2a872c21cc9f2813$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7o6yO", function(module, exports) {

var $deONc = parcelRequire("deONc");
var $560fdd18bb503ef7$var$_typeof = $deONc.default;

var $kI9vu = parcelRequire("kI9vu");
function $560fdd18bb503ef7$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $560fdd18bb503ef7$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $kI9vu(t);
}
module.exports = $560fdd18bb503ef7$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kI9vu", function(module, exports) {
function $f13f4a95e63510b1$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $f13f4a95e63510b1$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lovB8", function(module, exports) {
function $f934598dd6d58e68$var$_getPrototypeOf(t) {
    return module.exports = $f934598dd6d58e68$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $f934598dd6d58e68$var$_getPrototypeOf(t);
}
module.exports = $f934598dd6d58e68$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9rajK", function(module, exports) {

var $iaKjk = parcelRequire("iaKjk");
function $6deea37f0ce99095$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $iaKjk(t, e);
}
module.exports = $6deea37f0ce99095$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iaKjk", function(module, exports) {
function $d3ad158a248d07f2$var$_setPrototypeOf(t, e) {
    return module.exports = $d3ad158a248d07f2$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d3ad158a248d07f2$var$_setPrototypeOf(t, e);
}
module.exports = $d3ad158a248d07f2$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7btCe", function(module, exports) {

var $03bAP = parcelRequire("03bAP");
function $53b0888c1bf0cc07$var$r(e) {
    var o, t, f = "";
    if ("string" == typeof e || "number" == typeof e) f += e;
    else if ("object" == (typeof e === "undefined" ? "undefined" : (0, $03bAP._)(e))) {
        if (Array.isArray(e)) {
            var n = e.length;
            for(o = 0; o < n; o++)e[o] && (t = $53b0888c1bf0cc07$var$r(e[o])) && (f && (f += " "), f += t);
        } else for(t in e)e[t] && (f && (f += " "), f += t);
    }
    return f;
}
function $53b0888c1bf0cc07$var$e() {
    for(var _$e, o, t = 0, f = "", n = arguments.length; t < n; t++)(_$e = arguments[t]) && (o = $53b0888c1bf0cc07$var$r(_$e)) && (f && (f += " "), f += o);
    return f;
}
module.exports = $53b0888c1bf0cc07$var$e, module.exports.clsx = $53b0888c1bf0cc07$var$e;

});

parcelRegister("350Ey", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.views = module.exports.dateRangeFormat = module.exports.dateFormat = module.exports.accessor = module.exports.DayLayoutAlgorithmPropType = void 0;

var $23e25866616f1b90$var$_propTypes = $jdupM((parcelRequire("4YVCt")));

var $2own8 = parcelRequire("2own8");
var $23e25866616f1b90$var$viewNames = Object.keys($2own8.views).map(function(k) {
    return $2own8.views[k];
});
var $23e25866616f1b90$var$accessor = module.exports.accessor = $23e25866616f1b90$var$_propTypes.default.oneOfType([
    $23e25866616f1b90$var$_propTypes.default.string,
    $23e25866616f1b90$var$_propTypes.default.func
]);
var $23e25866616f1b90$var$dateFormat = module.exports.dateFormat = $23e25866616f1b90$var$_propTypes.default.any;
var $23e25866616f1b90$var$dateRangeFormat = module.exports.dateRangeFormat = $23e25866616f1b90$var$_propTypes.default.func;
/**
 * accepts either an array of builtin view names:
 *
 * ```
 * views={['month', 'day', 'agenda']}
 * ```
 *
 * or an object hash of the view name and the component (or boolean for builtin)
 *
 * ```
 * views={{
 *   month: true,
 *   week: false,
 *   workweek: WorkWeekViewComponent,
 * }}
 * ```
 */ var $23e25866616f1b90$var$views = module.exports.views = $23e25866616f1b90$var$_propTypes.default.oneOfType([
    $23e25866616f1b90$var$_propTypes.default.arrayOf($23e25866616f1b90$var$_propTypes.default.oneOf($23e25866616f1b90$var$viewNames)),
    $23e25866616f1b90$var$_propTypes.default.objectOf(function(prop, key) {
        var isBuiltinView = $23e25866616f1b90$var$viewNames.indexOf(key) !== -1 && typeof prop[key] === 'boolean';
        if (isBuiltinView) return null;
        else {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return $23e25866616f1b90$var$_propTypes.default.elementType.apply($23e25866616f1b90$var$_propTypes.default, [
                prop,
                key
            ].concat(args));
        }
    })
]);
var $23e25866616f1b90$var$DayLayoutAlgorithmPropType = module.exports.DayLayoutAlgorithmPropType = $23e25866616f1b90$var$_propTypes.default.oneOfType([
    $23e25866616f1b90$var$_propTypes.default.oneOf([
        'overlap',
        'no-overlap'
    ]),
    $23e25866616f1b90$var$_propTypes.default.func
]);

});
parcelRegister("2own8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.views = module.exports.navigate = void 0;
var $1be6ef17dd942b01$var$navigate = module.exports.navigate = {
    PREVIOUS: 'PREV',
    NEXT: 'NEXT',
    TODAY: 'TODAY',
    DATE: 'DATE'
};
var $1be6ef17dd942b01$var$views = module.exports.views = {
    MONTH: 'month',
    WEEK: 'week',
    WORK_WEEK: 'work_week',
    DAY: 'day',
    AGENDA: 'agenda'
};

});


parcelRegister("3lOUe", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $270ad21f0f724a59$var$_defineProperty2 = $jdupM((parcelRequire("8s7es")));

var $270ad21f0f724a59$var$_classCallCheck2 = $jdupM((parcelRequire("ioyax")));

var $270ad21f0f724a59$var$_createClass2 = $jdupM((parcelRequire("3EnhW")));

var $270ad21f0f724a59$var$_possibleConstructorReturn2 = $jdupM((parcelRequire("7o6yO")));

var $270ad21f0f724a59$var$_getPrototypeOf2 = $jdupM((parcelRequire("lovB8")));

var $270ad21f0f724a59$var$_inherits2 = $jdupM((parcelRequire("9rajK")));

var $270ad21f0f724a59$var$_propTypes = $jdupM((parcelRequire("4YVCt")));

var $270ad21f0f724a59$var$_react = $jdupM((parcelRequire("5s1kH")));

var $270ad21f0f724a59$var$_clsx = $jdupM((parcelRequire("7btCe")));

var $eBxEd = parcelRequire("eBxEd");

var $8F1Dg = parcelRequire("8F1Dg");
function $270ad21f0f724a59$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $270ad21f0f724a59$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $270ad21f0f724a59$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $270ad21f0f724a59$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $270ad21f0f724a59$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $270ad21f0f724a59$var$_callSuper(t, o, e) {
    return o = (0, $270ad21f0f724a59$var$_getPrototypeOf2.default)(o), (0, $270ad21f0f724a59$var$_possibleConstructorReturn2.default)(t, $270ad21f0f724a59$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $270ad21f0f724a59$var$_getPrototypeOf2.default)(t).constructor) : o.apply(t, e));
}
function $270ad21f0f724a59$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($270ad21f0f724a59$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $270ad21f0f724a59$var$EventWrapper = /*#__PURE__*/ function(_React$Component) {
    function EventWrapper() {
        var _this;
        (0, $270ad21f0f724a59$var$_classCallCheck2.default)(this, EventWrapper);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $270ad21f0f724a59$var$_callSuper(this, EventWrapper, [].concat(args));
        _this.handleResizeUp = function(e) {
            if (e.button !== 0) return;
            _this.context.draggable.onBeginAction(_this.props.event, 'resize', 'UP');
        };
        _this.handleResizeDown = function(e) {
            if (e.button !== 0) return;
            _this.context.draggable.onBeginAction(_this.props.event, 'resize', 'DOWN');
        };
        _this.handleResizeLeft = function(e) {
            if (e.button !== 0) return;
            _this.context.draggable.onBeginAction(_this.props.event, 'resize', 'LEFT');
        };
        _this.handleResizeRight = function(e) {
            if (e.button !== 0) return;
            _this.context.draggable.onBeginAction(_this.props.event, 'resize', 'RIGHT');
        };
        _this.handleStartDragging = function(e) {
            var _e$target$getAttribut;
            if (e.button !== 0) return;
            // hack: because of the way the anchors are arranged in the DOM, resize
            // anchor events will bubble up to the move anchor listener. Don't start
            // move operations when we're on a resize anchor.
            var isResizeHandle = (_e$target$getAttribut = e.target.getAttribute('class')) === null || _e$target$getAttribut === void 0 ? void 0 : _e$target$getAttribut.includes('rbc-addons-dnd-resize');
            if (!isResizeHandle) {
                var extendedEvent = $270ad21f0f724a59$var$_objectSpread({}, _this.props.event);
                extendedEvent.sourceResource = _this.props.resource;
                _this.context.draggable.onBeginAction(_this.props.event, 'move');
            }
        };
        return _this;
    }
    (0, $270ad21f0f724a59$var$_inherits2.default)(EventWrapper, _React$Component);
    return (0, $270ad21f0f724a59$var$_createClass2.default)(EventWrapper, [
        {
            key: "renderAnchor",
            value: function renderAnchor(direction) {
                var cls = direction === 'Up' || direction === 'Down' ? 'ns' : 'ew';
                return /*#__PURE__*/ $270ad21f0f724a59$var$_react.default.createElement("div", {
                    className: "rbc-addons-dnd-resize-".concat(cls, "-anchor"),
                    onMouseDown: this["handleResize".concat(direction)]
                }, /*#__PURE__*/ $270ad21f0f724a59$var$_react.default.createElement("div", {
                    className: "rbc-addons-dnd-resize-".concat(cls, "-icon")
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, event = _this$props.event, type = _this$props.type, continuesPrior = _this$props.continuesPrior, continuesAfter = _this$props.continuesAfter, resizable = _this$props.resizable;
                var children = this.props.children;
                if (event.__isPreview) return /*#__PURE__*/ $270ad21f0f724a59$var$_react.default.cloneElement(children, {
                    className: (0, $270ad21f0f724a59$var$_clsx.default)(children.props.className, 'rbc-addons-dnd-drag-preview')
                });
                var draggable = this.context.draggable;
                var draggableAccessor = draggable.draggableAccessor, resizableAccessor = draggable.resizableAccessor;
                var isDraggable = draggableAccessor ? !!(0, $eBxEd.accessor)(event, draggableAccessor) : true;
                /* Event is not draggable, no need to wrap it */ if (!isDraggable) return children;
                /*
       * The resizability of events depends on whether they are
       * allDay events and how they are displayed.
       *
       * 1. If the event is being shown in an event row (because
       * it is an allDay event shown in the header row or because as
       * in month view the view is showing all events as rows) then we
       * allow east-west resizing.
       *
       * 2. Otherwise the event is being displayed
       * normally, we can drag it north-south to resize the times.
       *
       * See `DropWrappers` for handling of the drop of such events.
       *
       * Notwithstanding the above, we never show drag anchors for
       * events which continue beyond current component. This happens
       * in the middle of events when showMultiDay is true, and to
       * events at the edges of the calendar's min/max location.
       */ var isResizable = resizable && (resizableAccessor ? !!(0, $eBxEd.accessor)(event, resizableAccessor) : true);
                if (isResizable || isDraggable) {
                    /*
         * props.children is the singular <Event> component.
         * BigCalendar positions the Event abolutely and we
         * need the anchors to be part of that positioning.
         * So we insert the anchors inside the Event's children
         * rather than wrap the Event here as the latter approach
         * would lose the positioning.
         */ var newProps = {
                        onMouseDown: this.handleStartDragging,
                        onTouchStart: this.handleStartDragging
                    };
                    if (isResizable) {
                        // replace original event child with anchor-embellished child
                        var StartAnchor = null;
                        var EndAnchor = null;
                        if (type === 'date') {
                            StartAnchor = !continuesPrior && this.renderAnchor('Left');
                            EndAnchor = !continuesAfter && this.renderAnchor('Right');
                        } else {
                            StartAnchor = !continuesPrior && this.renderAnchor('Up');
                            EndAnchor = !continuesAfter && this.renderAnchor('Down');
                        }
                        newProps.children = /*#__PURE__*/ $270ad21f0f724a59$var$_react.default.createElement("div", {
                            className: "rbc-addons-dnd-resizable"
                        }, StartAnchor, children.props.children, EndAnchor);
                    }
                    if (draggable.dragAndDropAction.interacting && // if an event is being dragged right now
                    draggable.dragAndDropAction.event === event // and it's the current event
                    ) // add a new class to it
                    newProps.className = (0, $270ad21f0f724a59$var$_clsx.default)(children.props.className, 'rbc-addons-dnd-dragged-event');
                    children = /*#__PURE__*/ $270ad21f0f724a59$var$_react.default.cloneElement(children, newProps);
                }
                return children;
            }
        }
    ]);
}($270ad21f0f724a59$var$_react.default.Component);
$270ad21f0f724a59$var$EventWrapper.contextType = $8F1Dg.DnDContext;
$270ad21f0f724a59$var$EventWrapper.propTypes = {};
var $270ad21f0f724a59$var$_default = module.exports.default = $270ad21f0f724a59$var$EventWrapper;

});
parcelRegister("eBxEd", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.accessor = $aa1e9f1604bf6d93$var$accessor;
module.exports.wrapAccessor = void 0;

var $aa1e9f1604bf6d93$var$_typeof2 = $jdupM((parcelRequire("deONc")));
/**
 * Retrieve via an accessor-like property
 *
 *    accessor(obj, 'name')   // => retrieves obj['name']
 *    accessor(data, func)    // => retrieves func(data)
 *    ... otherwise null
 */ function $aa1e9f1604bf6d93$var$accessor(data, field) {
    var value = null;
    if (typeof field === 'function') value = field(data);
    else if (typeof field === 'string' && (0, $aa1e9f1604bf6d93$var$_typeof2.default)(data) === 'object' && data != null && field in data) value = data[field];
    return value;
}
var $aa1e9f1604bf6d93$var$wrapAccessor = module.exports.wrapAccessor = function wrapAccessor(acc) {
    return function(data) {
        return $aa1e9f1604bf6d93$var$accessor(data, acc);
    };
};

});

parcelRegister("8F1Dg", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DnDContext = void 0;

var $64e36b3246c0f49e$var$_react = $jdupM((parcelRequire("5s1kH")));
var $64e36b3246c0f49e$var$DnDContext = module.exports.DnDContext = /*#__PURE__*/ $64e36b3246c0f49e$var$_react.default.createContext();

});


parcelRegister("c0Z2I", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");

var $deONc = parcelRequire("deONc");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bf4d5f940122b1e$var$_defineProperty2 = $jdupM((parcelRequire("8s7es")));

var $8bf4d5f940122b1e$var$_classCallCheck2 = $jdupM((parcelRequire("ioyax")));

var $8bf4d5f940122b1e$var$_createClass2 = $jdupM((parcelRequire("3EnhW")));

var $8bf4d5f940122b1e$var$_possibleConstructorReturn2 = $jdupM((parcelRequire("7o6yO")));

var $8bf4d5f940122b1e$var$_getPrototypeOf2 = $jdupM((parcelRequire("lovB8")));

var $8bf4d5f940122b1e$var$_inherits2 = $jdupM((parcelRequire("9rajK")));

var $aiOMC = parcelRequire("aiOMC");

var $8bf4d5f940122b1e$var$_querySelectorAll = $jdupM((parcelRequire("5d0qC")));

var $8bf4d5f940122b1e$var$_propTypes = $jdupM((parcelRequire("4YVCt")));

var $8bf4d5f940122b1e$var$_react = $jdupM((parcelRequire("5s1kH")));

var $8F1Dg = parcelRequire("8F1Dg");

var $8bf4d5f940122b1e$var$_Selection = $8bf4d5f940122b1e$var$_interopRequireWildcard((parcelRequire("kmVGT")));

var $8bf4d5f940122b1e$var$_TimeGridEvent = $jdupM((parcelRequire("hiokX")));

var $2JAPW = parcelRequire("2JAPW");
function $8bf4d5f940122b1e$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($8bf4d5f940122b1e$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != $deONc(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $8bf4d5f940122b1e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8bf4d5f940122b1e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8bf4d5f940122b1e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $8bf4d5f940122b1e$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8bf4d5f940122b1e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8bf4d5f940122b1e$var$_callSuper(t, o, e) {
    return o = (0, $8bf4d5f940122b1e$var$_getPrototypeOf2.default)(o), (0, $8bf4d5f940122b1e$var$_possibleConstructorReturn2.default)(t, $8bf4d5f940122b1e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $8bf4d5f940122b1e$var$_getPrototypeOf2.default)(t).constructor) : o.apply(t, e));
}
function $8bf4d5f940122b1e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8bf4d5f940122b1e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $8bf4d5f940122b1e$var$EventContainerWrapper = /*#__PURE__*/ function(_React$Component) {
    function EventContainerWrapper() {
        var _this;
        (0, $8bf4d5f940122b1e$var$_classCallCheck2.default)(this, EventContainerWrapper);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $8bf4d5f940122b1e$var$_callSuper(this, EventContainerWrapper, [].concat(args));
        _this.handleMove = function(point, bounds) {
            if (!(0, $2JAPW.pointInColumn)(bounds, point)) return _this.reset();
            var event = _this.context.draggable.dragAndDropAction.event;
            var _this$props = _this.props, accessors = _this$props.accessors, slotMetrics = _this$props.slotMetrics;
            var newSlot = slotMetrics.closestSlotFromPoint({
                y: point.y - _this.eventOffsetTop,
                x: point.x
            }, bounds);
            var _eventTimes = (0, $2JAPW.eventTimes)(event, accessors, _this.props.localizer), duration = _eventTimes.duration;
            var newEnd = _this.props.localizer.add(newSlot, duration, 'milliseconds');
            _this.update(event, slotMetrics.getRange(newSlot, newEnd, false, true));
        };
        _this.handleDropFromOutside = function(point, boundaryBox) {
            var _this$props2 = _this.props, slotMetrics = _this$props2.slotMetrics, resource = _this$props2.resource;
            var start = slotMetrics.closestSlotFromPoint({
                y: point.y,
                x: point.x
            }, boundaryBox);
            var end = _this._calculateDnDEnd(start);
            _this.context.draggable.onDropFromOutside({
                start: start,
                end: end,
                allDay: false,
                resource: resource
            });
            // Cleanup after dropping from outside
            _this.reset();
        };
        _this.handleDragOverFromOutside = function(point, bounds) {
            var slotMetrics = _this.props.slotMetrics;
            var start = slotMetrics.closestSlotFromPoint({
                y: point.y,
                x: point.x
            }, bounds);
            var end = _this._calculateDnDEnd(start);
            var event = _this.context.draggable.dragFromOutsideItem();
            _this.update(event, slotMetrics.getRange(start, end, false, true));
        };
        _this._calculateDnDEnd = function(start) {
            var _this$props3 = _this.props, accessors = _this$props3.accessors, slotMetrics = _this$props3.slotMetrics, localizer = _this$props3.localizer;
            var event = _this.context.draggable.dragFromOutsideItem();
            var _eventTimes2 = (0, $2JAPW.eventTimes)(event, accessors, localizer), eventDuration = _eventTimes2.duration;
            var end = slotMetrics.nextSlot(start);
            var eventHasDuration = !isNaN(eventDuration);
            if (eventHasDuration) {
                var eventEndSlot = localizer.add(start, eventDuration, 'milliseconds');
                end = new Date(Math.max(eventEndSlot, end));
            }
            return end;
        };
        _this.updateParentScroll = function(parent, node) {
            setTimeout(function() {
                var draggedEl = (0, $8bf4d5f940122b1e$var$_querySelectorAll.default)(node, '.rbc-addons-dnd-drag-preview')[0];
                if (draggedEl) {
                    if (draggedEl.offsetTop < parent.scrollTop) (0, $aiOMC.scrollTop)(parent, Math.max(draggedEl.offsetTop, 0));
                    else if (draggedEl.offsetTop + draggedEl.offsetHeight > parent.scrollTop + parent.clientHeight) (0, $aiOMC.scrollTop)(parent, Math.min(draggedEl.offsetTop - parent.offsetHeight + draggedEl.offsetHeight, parent.scrollHeight));
                }
            });
        };
        _this._selectable = function() {
            var wrapper = _this.ref.current;
            var node = wrapper.children[0];
            var isBeingDragged = false;
            var selector = _this._selector = new $8bf4d5f940122b1e$var$_Selection.default(function() {
                return wrapper.closest('.rbc-time-view');
            });
            var parent = (0, $aiOMC.scrollParent)(wrapper);
            selector.on('beforeSelect', function(point) {
                var dragAndDropAction = _this.context.draggable.dragAndDropAction;
                if (!dragAndDropAction.action) return false;
                if (dragAndDropAction.action === 'resize') return (0, $2JAPW.pointInColumn)((0, $8bf4d5f940122b1e$var$_Selection.getBoundsForNode)(node), point);
                var eventNode = (0, $8bf4d5f940122b1e$var$_Selection.getEventNodeFromPoint)(node, point);
                if (!eventNode) return false;
                // eventOffsetTop is distance from the top of the event to the initial
                // mouseDown position. We need this later to compute the new top of the
                // event during move operations, since the final location is really a
                // delta from this point. note: if we want to DRY this with WeekWrapper,
                // probably better just to capture the mouseDown point here and do the
                // placement computation in handleMove()...
                _this.eventOffsetTop = point.y - (0, $8bf4d5f940122b1e$var$_Selection.getBoundsForNode)(eventNode).top;
            });
            selector.on('selecting', function(box) {
                var bounds = (0, $8bf4d5f940122b1e$var$_Selection.getBoundsForNode)(node);
                var dragAndDropAction = _this.context.draggable.dragAndDropAction;
                if (dragAndDropAction.action === 'move') {
                    _this.updateParentScroll(parent, node);
                    _this.handleMove(box, bounds);
                }
                if (dragAndDropAction.action === 'resize') {
                    _this.updateParentScroll(parent, node);
                    _this.handleResize(box, bounds);
                }
            });
            selector.on('dropFromOutside', function(point) {
                if (!_this.context.draggable.onDropFromOutside) return;
                var bounds = (0, $8bf4d5f940122b1e$var$_Selection.getBoundsForNode)(node);
                if (!(0, $2JAPW.pointInColumn)(bounds, point)) return;
                _this.handleDropFromOutside(point, bounds);
            });
            selector.on('dragOverFromOutside', function(point) {
                var item = _this.context.draggable.dragFromOutsideItem ? _this.context.draggable.dragFromOutsideItem() : null;
                if (!item) return;
                var bounds = (0, $8bf4d5f940122b1e$var$_Selection.getBoundsForNode)(node);
                if (!(0, $2JAPW.pointInColumn)(bounds, point)) return _this.reset();
                _this.handleDragOverFromOutside(point, bounds);
            });
            selector.on('selectStart', function() {
                isBeingDragged = true;
                _this.context.draggable.onStart();
            });
            selector.on('select', function(point) {
                var bounds = (0, $8bf4d5f940122b1e$var$_Selection.getBoundsForNode)(node);
                isBeingDragged = false;
                var dragAndDropAction = _this.context.draggable.dragAndDropAction;
                if (dragAndDropAction.action === 'resize') _this.handleInteractionEnd();
                else if (!_this.state.event || !(0, $2JAPW.pointInColumn)(bounds, point)) return;
                else _this.handleInteractionEnd();
            });
            selector.on('click', function() {
                if (isBeingDragged) _this.reset();
                _this.context.draggable.onEnd(null);
            });
            selector.on('reset', function() {
                _this.reset();
                _this.context.draggable.onEnd(null);
            });
        };
        _this.handleInteractionEnd = function() {
            var resource = _this.props.resource;
            var event = _this.state.event;
            _this.reset();
            _this.context.draggable.onEnd({
                start: event.start,
                end: event.end,
                resourceId: resource
            });
        };
        _this._teardownSelectable = function() {
            if (!_this._selector) return;
            _this._selector.teardown();
            _this._selector = null;
        };
        _this.state = {};
        _this.ref = /*#__PURE__*/ $8bf4d5f940122b1e$var$_react.default.createRef();
        return _this;
    }
    (0, $8bf4d5f940122b1e$var$_inherits2.default)(EventContainerWrapper, _React$Component);
    return (0, $8bf4d5f940122b1e$var$_createClass2.default)(EventContainerWrapper, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._selectable();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._teardownSelectable();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.state.event) this.setState({
                    event: null,
                    top: null,
                    height: null
                });
            }
        },
        {
            key: "update",
            value: function update(event, _ref) {
                var startDate = _ref.startDate, endDate = _ref.endDate, top = _ref.top, height = _ref.height;
                var lastEvent = this.state.event;
                if (lastEvent && startDate === lastEvent.start && endDate === lastEvent.end) return;
                this.setState({
                    top: top,
                    height: height,
                    event: $8bf4d5f940122b1e$var$_objectSpread($8bf4d5f940122b1e$var$_objectSpread({}, event), {}, {
                        start: startDate,
                        end: endDate
                    })
                });
            }
        },
        {
            key: "handleResize",
            value: function handleResize(point, bounds) {
                var _this$props4 = this.props, accessors = _this$props4.accessors, slotMetrics = _this$props4.slotMetrics, localizer = _this$props4.localizer;
                var _this$context$draggab = this.context.draggable.dragAndDropAction, event = _this$context$draggab.event, direction = _this$context$draggab.direction;
                var newTime = slotMetrics.closestSlotFromPoint(point, bounds);
                var _eventTimes3 = (0, $2JAPW.eventTimes)(event, accessors, localizer), start = _eventTimes3.start, end = _eventTimes3.end;
                var newRange;
                if (direction === 'UP') {
                    var newStart = localizer.min(newTime, slotMetrics.closestSlotFromDate(end, -1));
                    // Get the new range based on the new start
                    // but don't overwrite the end date as it could be outside this day boundary.
                    newRange = slotMetrics.getRange(newStart, end);
                    newRange = $8bf4d5f940122b1e$var$_objectSpread($8bf4d5f940122b1e$var$_objectSpread({}, newRange), {}, {
                        endDate: end
                    });
                } else if (direction === 'DOWN') {
                    // Get the new range based on the new end
                    // but don't overwrite the start date as it could be outside this day boundary.
                    var newEnd = localizer.max(newTime, slotMetrics.closestSlotFromDate(start));
                    newRange = slotMetrics.getRange(start, newEnd);
                    newRange = $8bf4d5f940122b1e$var$_objectSpread($8bf4d5f940122b1e$var$_objectSpread({}, newRange), {}, {
                        startDate: start
                    });
                }
                this.update(event, newRange);
            }
        },
        {
            key: "renderContent",
            value: function renderContent() {
                var _this$props5 = this.props, children = _this$props5.children, accessors = _this$props5.accessors, components = _this$props5.components, getters = _this$props5.getters, slotMetrics = _this$props5.slotMetrics, localizer = _this$props5.localizer;
                var _this$state = this.state, event = _this$state.event, top = _this$state.top, height = _this$state.height;
                if (!event) return children;
                var events = children.props.children;
                var start = event.start, end = event.end;
                var label;
                var format = 'eventTimeRangeFormat';
                var startsBeforeDay = slotMetrics.startsBeforeDay(start);
                var startsAfterDay = slotMetrics.startsAfterDay(end);
                if (startsBeforeDay) format = 'eventTimeRangeEndFormat';
                else if (startsAfterDay) format = 'eventTimeRangeStartFormat';
                if (startsBeforeDay && startsAfterDay) label = localizer.messages.allDay;
                else label = localizer.format({
                    start: start,
                    end: end
                }, format);
                return /*#__PURE__*/ $8bf4d5f940122b1e$var$_react.default.cloneElement(children, {
                    children: /*#__PURE__*/ $8bf4d5f940122b1e$var$_react.default.createElement($8bf4d5f940122b1e$var$_react.default.Fragment, null, events, event && /*#__PURE__*/ $8bf4d5f940122b1e$var$_react.default.createElement($8bf4d5f940122b1e$var$_TimeGridEvent.default, {
                        event: event,
                        label: label,
                        className: "rbc-addons-dnd-drag-preview",
                        style: {
                            top: top,
                            height: height,
                            width: 100
                        },
                        getters: getters,
                        components: components,
                        accessors: $8bf4d5f940122b1e$var$_objectSpread($8bf4d5f940122b1e$var$_objectSpread({}, accessors), $2JAPW.dragAccessors),
                        continuesPrior: startsBeforeDay,
                        continuesAfter: startsAfterDay
                    }))
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $8bf4d5f940122b1e$var$_react.default.createElement("div", {
                    ref: this.ref
                }, this.renderContent());
            }
        }
    ]);
}($8bf4d5f940122b1e$var$_react.default.Component);
$8bf4d5f940122b1e$var$EventContainerWrapper.contextType = $8F1Dg.DnDContext;
$8bf4d5f940122b1e$var$EventContainerWrapper.propTypes = {};
var $8bf4d5f940122b1e$var$_default = module.exports.default = $8bf4d5f940122b1e$var$EventContainerWrapper;

});
parcelRegister("aiOMC", function(module, exports) {

$parcel$export(module.exports, "scrollParent", function () { return $7802fa4cbb7e3d2f$export$d3a3c7d41c0b4647; }, function (v) { return $7802fa4cbb7e3d2f$export$d3a3c7d41c0b4647 = v; });
$parcel$export(module.exports, "scrollTop", function () { return $7802fa4cbb7e3d2f$export$3e0c8fa3b5e4b3b9; }, function (v) { return $7802fa4cbb7e3d2f$export$3e0c8fa3b5e4b3b9 = v; });
var $7802fa4cbb7e3d2f$export$1e511d4a378977f5;
var $7802fa4cbb7e3d2f$export$2e2bcd8739ae039;
var $7802fa4cbb7e3d2f$export$da980962bd2147a4;
var $7802fa4cbb7e3d2f$export$d2cf6cd1dc7067d3;
var $7802fa4cbb7e3d2f$export$3f65cefe8380dbea;
var $7802fa4cbb7e3d2f$export$e3607ec2d7a891c4;
var $7802fa4cbb7e3d2f$export$e00521de187a817a;
var $7802fa4cbb7e3d2f$export$6cb2c4c0a22909c0;
var $7802fa4cbb7e3d2f$export$af4b9a83f4b00434;
var $7802fa4cbb7e3d2f$export$4df2918ab5399a56;
var $7802fa4cbb7e3d2f$export$42ffd38884aecdac;
var $7802fa4cbb7e3d2f$export$ff7f7c97cdce86e;
var $7802fa4cbb7e3d2f$export$2344b14b097df817;
var $7802fa4cbb7e3d2f$export$c9fa23d9ff60a2d1;
var $7802fa4cbb7e3d2f$export$1d567c320f4763bc;
var $7802fa4cbb7e3d2f$export$3dea766d36a8935f;
var $7802fa4cbb7e3d2f$export$3735103072e4a80;
var $7802fa4cbb7e3d2f$export$4ea3d958472af68f;
var $7802fa4cbb7e3d2f$export$ac607276a8fe9f0a;
var $7802fa4cbb7e3d2f$export$c4f94c8b3850a5a9;
var $7802fa4cbb7e3d2f$export$495c8a5c4c240111;
var $7802fa4cbb7e3d2f$export$795910f5f15a9633;
var $7802fa4cbb7e3d2f$export$63174c828edd6ff8;
var $7802fa4cbb7e3d2f$export$de994efd351b291c;
var $7802fa4cbb7e3d2f$export$c2850259fcee1ef;
var $7802fa4cbb7e3d2f$export$cc800923e997bb8;
var $7802fa4cbb7e3d2f$export$759f2a42fd33dfde;
var $7802fa4cbb7e3d2f$export$512a1115db01100d;
var $7802fa4cbb7e3d2f$export$dd59a78a746d25b2;
var $7802fa4cbb7e3d2f$export$7901f6cd558b9a93;
var $7802fa4cbb7e3d2f$export$5880b8b5730aff45;
var $7802fa4cbb7e3d2f$export$68159836694e22c1;
var $7802fa4cbb7e3d2f$export$2e83b5c43fb7af7b;
var $7802fa4cbb7e3d2f$export$cd7f480d6b8286c3;
var $7802fa4cbb7e3d2f$export$c2255604a80b4506;
var $7802fa4cbb7e3d2f$export$8ff9f68337b520c0;
var $7802fa4cbb7e3d2f$export$fd2f38d8a289271e;
var $7802fa4cbb7e3d2f$export$6eddf9bc7f2b7d80;
var $7802fa4cbb7e3d2f$export$d3a3c7d41c0b4647;
var $7802fa4cbb7e3d2f$export$3f99968195accfaf;
var $7802fa4cbb7e3d2f$export$3e0c8fa3b5e4b3b9;
var $7802fa4cbb7e3d2f$export$9866dd70b0dcd4c3;
var $7802fa4cbb7e3d2f$export$6f093cfa640b7166;
var $7802fa4cbb7e3d2f$export$4a80062ca50b57c7;
var $7802fa4cbb7e3d2f$export$358dc01d65cad417;
var $7802fa4cbb7e3d2f$export$bf5e5f0a0e9ca89d;
var $7802fa4cbb7e3d2f$export$7e3df82ee760448c;
"use strict";

var $jdupM = parcelRequire("jdupM");
$7802fa4cbb7e3d2f$export$1e511d4a378977f5 = true;
$7802fa4cbb7e3d2f$export$2e2bcd8739ae039 = void 0;

var $7802fa4cbb7e3d2f$var$_activeElement = $jdupM((parcelRequire("gB20R")));
$7802fa4cbb7e3d2f$export$da980962bd2147a4 = $7802fa4cbb7e3d2f$var$_activeElement.default;

var $7802fa4cbb7e3d2f$var$_addClass = $jdupM((parcelRequire("c3zrj")));
$7802fa4cbb7e3d2f$export$d2cf6cd1dc7067d3 = $7802fa4cbb7e3d2f$var$_addClass.default;

var $7802fa4cbb7e3d2f$var$_addEventListener = $jdupM((parcelRequire("91Bvh")));
$7802fa4cbb7e3d2f$export$3f65cefe8380dbea = $7802fa4cbb7e3d2f$var$_addEventListener.default;

var $7802fa4cbb7e3d2f$var$_animate = $jdupM((parcelRequire("6RTEM")));
$7802fa4cbb7e3d2f$export$e3607ec2d7a891c4 = $7802fa4cbb7e3d2f$var$_animate.default;

var $1wlAs = parcelRequire("1wlAs");
$7802fa4cbb7e3d2f$export$e00521de187a817a = $1wlAs.cancel;
$7802fa4cbb7e3d2f$export$6cb2c4c0a22909c0 = $1wlAs.request;

var $7802fa4cbb7e3d2f$var$_attribute = $jdupM((parcelRequire("ahyuu")));
$7802fa4cbb7e3d2f$export$af4b9a83f4b00434 = $7802fa4cbb7e3d2f$var$_attribute.default;

var $7802fa4cbb7e3d2f$var$_childElements = $jdupM((parcelRequire("e4A8h")));
$7802fa4cbb7e3d2f$export$4df2918ab5399a56 = $7802fa4cbb7e3d2f$var$_childElements.default;

var $7802fa4cbb7e3d2f$var$_clear = $jdupM((parcelRequire("2TOD3")));
$7802fa4cbb7e3d2f$export$42ffd38884aecdac = $7802fa4cbb7e3d2f$var$_clear.default;

var $7802fa4cbb7e3d2f$var$_closest = $jdupM((parcelRequire("iuxD3")));
$7802fa4cbb7e3d2f$export$ff7f7c97cdce86e = $7802fa4cbb7e3d2f$var$_closest.default;

var $7802fa4cbb7e3d2f$var$_contains = $jdupM((parcelRequire("aAklW")));
$7802fa4cbb7e3d2f$export$2344b14b097df817 = $7802fa4cbb7e3d2f$var$_contains.default;

var $7802fa4cbb7e3d2f$var$_childNodes = $jdupM((parcelRequire("aa6Ko")));
$7802fa4cbb7e3d2f$export$c9fa23d9ff60a2d1 = $7802fa4cbb7e3d2f$var$_childNodes.default;

var $7802fa4cbb7e3d2f$var$_css = $jdupM((parcelRequire("j6v8a")));
$7802fa4cbb7e3d2f$export$1d567c320f4763bc = $7802fa4cbb7e3d2f$var$_css.default;

var $7802fa4cbb7e3d2f$var$_filterEventHandler = $jdupM((parcelRequire("1ulEB")));
$7802fa4cbb7e3d2f$export$3dea766d36a8935f = $7802fa4cbb7e3d2f$var$_filterEventHandler.default;

var $7802fa4cbb7e3d2f$var$_getComputedStyle = $jdupM((parcelRequire("5xg3S")));
$7802fa4cbb7e3d2f$export$3735103072e4a80 = $7802fa4cbb7e3d2f$var$_getComputedStyle.default;

var $7802fa4cbb7e3d2f$var$_hasClass = $jdupM((parcelRequire("kI242")));
$7802fa4cbb7e3d2f$export$4ea3d958472af68f = $7802fa4cbb7e3d2f$var$_hasClass.default;

var $7802fa4cbb7e3d2f$var$_height = $jdupM((parcelRequire("2pPTO")));
$7802fa4cbb7e3d2f$export$ac607276a8fe9f0a = $7802fa4cbb7e3d2f$var$_height.default;

var $7802fa4cbb7e3d2f$var$_insertAfter = $jdupM((parcelRequire("cDBWE")));
$7802fa4cbb7e3d2f$export$c4f94c8b3850a5a9 = $7802fa4cbb7e3d2f$var$_insertAfter.default;

var $7802fa4cbb7e3d2f$var$_isInput = $jdupM((parcelRequire("jKqzd")));
$7802fa4cbb7e3d2f$export$495c8a5c4c240111 = $7802fa4cbb7e3d2f$var$_isInput.default;

var $7802fa4cbb7e3d2f$var$_isVisible = $jdupM((parcelRequire("jhkG6")));
$7802fa4cbb7e3d2f$export$795910f5f15a9633 = $7802fa4cbb7e3d2f$var$_isVisible.default;

var $7802fa4cbb7e3d2f$var$_listen = $jdupM((parcelRequire("i0DVi")));
$7802fa4cbb7e3d2f$export$63174c828edd6ff8 = $7802fa4cbb7e3d2f$var$_listen.default;

var $7802fa4cbb7e3d2f$var$_matches = $jdupM((parcelRequire("cKNjA")));
$7802fa4cbb7e3d2f$export$de994efd351b291c = $7802fa4cbb7e3d2f$var$_matches.default;

var $7802fa4cbb7e3d2f$var$_nextUntil = $jdupM((parcelRequire("gDhp0")));
$7802fa4cbb7e3d2f$export$c2850259fcee1ef = $7802fa4cbb7e3d2f$var$_nextUntil.default;

var $7802fa4cbb7e3d2f$var$_offset = $jdupM((parcelRequire("bVrCw")));
$7802fa4cbb7e3d2f$export$cc800923e997bb8 = $7802fa4cbb7e3d2f$var$_offset.default;

var $7802fa4cbb7e3d2f$var$_offsetParent = $jdupM((parcelRequire("5lDOq")));
$7802fa4cbb7e3d2f$export$759f2a42fd33dfde = $7802fa4cbb7e3d2f$var$_offsetParent.default;

var $7802fa4cbb7e3d2f$var$_ownerDocument = $jdupM((parcelRequire("7g3FG")));
$7802fa4cbb7e3d2f$export$512a1115db01100d = $7802fa4cbb7e3d2f$var$_ownerDocument.default;

var $7802fa4cbb7e3d2f$var$_ownerWindow = $jdupM((parcelRequire("7QWKQ")));
$7802fa4cbb7e3d2f$export$dd59a78a746d25b2 = $7802fa4cbb7e3d2f$var$_ownerWindow.default;

var $7802fa4cbb7e3d2f$var$_parents = $jdupM((parcelRequire("3PFj0")));
$7802fa4cbb7e3d2f$export$7901f6cd558b9a93 = $7802fa4cbb7e3d2f$var$_parents.default;

var $7802fa4cbb7e3d2f$var$_position = $jdupM((parcelRequire("1L2R9")));
$7802fa4cbb7e3d2f$export$5880b8b5730aff45 = $7802fa4cbb7e3d2f$var$_position.default;

var $7802fa4cbb7e3d2f$var$_prepend = $jdupM((parcelRequire("242Pl")));
$7802fa4cbb7e3d2f$export$68159836694e22c1 = $7802fa4cbb7e3d2f$var$_prepend.default;

var $7802fa4cbb7e3d2f$var$_querySelectorAll = $jdupM((parcelRequire("5d0qC")));
$7802fa4cbb7e3d2f$export$2e83b5c43fb7af7b = $7802fa4cbb7e3d2f$var$_querySelectorAll.default;

var $7802fa4cbb7e3d2f$var$_remove = $jdupM((parcelRequire("9XZwM")));
$7802fa4cbb7e3d2f$export$cd7f480d6b8286c3 = $7802fa4cbb7e3d2f$var$_remove.default;

var $7802fa4cbb7e3d2f$var$_removeClass = $jdupM((parcelRequire("8q9Ag")));
$7802fa4cbb7e3d2f$export$c2255604a80b4506 = $7802fa4cbb7e3d2f$var$_removeClass.default;

var $7802fa4cbb7e3d2f$var$_removeEventListener = $jdupM((parcelRequire("93WCh")));
$7802fa4cbb7e3d2f$export$8ff9f68337b520c0 = $7802fa4cbb7e3d2f$var$_removeEventListener.default;

var $7802fa4cbb7e3d2f$var$_scrollbarSize = $jdupM((parcelRequire("4oNGL")));
$7802fa4cbb7e3d2f$export$fd2f38d8a289271e = $7802fa4cbb7e3d2f$var$_scrollbarSize.default;

var $7802fa4cbb7e3d2f$var$_scrollLeft = $jdupM((parcelRequire("6LekL")));
$7802fa4cbb7e3d2f$export$6eddf9bc7f2b7d80 = $7802fa4cbb7e3d2f$var$_scrollLeft.default;

var $7802fa4cbb7e3d2f$var$_scrollParent = $jdupM((parcelRequire("9pWNI")));
$7802fa4cbb7e3d2f$export$d3a3c7d41c0b4647 = $7802fa4cbb7e3d2f$var$_scrollParent.default;

var $7802fa4cbb7e3d2f$var$_scrollTo = $jdupM((parcelRequire("6CQfj")));
$7802fa4cbb7e3d2f$export$3f99968195accfaf = $7802fa4cbb7e3d2f$var$_scrollTo.default;

var $7802fa4cbb7e3d2f$var$_scrollTop = $jdupM((parcelRequire("il30Z")));
$7802fa4cbb7e3d2f$export$3e0c8fa3b5e4b3b9 = $7802fa4cbb7e3d2f$var$_scrollTop.default;

var $7802fa4cbb7e3d2f$var$_siblings = $jdupM((parcelRequire("j8gqD")));
$7802fa4cbb7e3d2f$export$9866dd70b0dcd4c3 = $7802fa4cbb7e3d2f$var$_siblings.default;

var $7802fa4cbb7e3d2f$var$_text = $jdupM((parcelRequire("04Qp1")));
$7802fa4cbb7e3d2f$export$6f093cfa640b7166 = $7802fa4cbb7e3d2f$var$_text.default;

var $7802fa4cbb7e3d2f$var$_toggleClass = $jdupM((parcelRequire("hbwb1")));
$7802fa4cbb7e3d2f$export$4a80062ca50b57c7 = $7802fa4cbb7e3d2f$var$_toggleClass.default;

var $7802fa4cbb7e3d2f$var$_transitionEnd = $jdupM((parcelRequire("1UF1a")));
$7802fa4cbb7e3d2f$export$358dc01d65cad417 = $7802fa4cbb7e3d2f$var$_transitionEnd.default;

var $7802fa4cbb7e3d2f$var$_triggerEvent = $jdupM((parcelRequire("2lyTl")));
$7802fa4cbb7e3d2f$export$bf5e5f0a0e9ca89d = $7802fa4cbb7e3d2f$var$_triggerEvent.default;

var $7802fa4cbb7e3d2f$var$_width = $jdupM((parcelRequire("1tFih")));
$7802fa4cbb7e3d2f$export$7e3df82ee760448c = $7802fa4cbb7e3d2f$var$_width.default;
var $7802fa4cbb7e3d2f$var$_default = $7802fa4cbb7e3d2f$export$2e2bcd8739ae039 = {
    addEventListener: $7802fa4cbb7e3d2f$var$_addEventListener.default,
    removeEventListener: $7802fa4cbb7e3d2f$var$_removeEventListener.default,
    triggerEvent: $7802fa4cbb7e3d2f$var$_triggerEvent.default,
    animate: $7802fa4cbb7e3d2f$var$_animate.default,
    filter: $7802fa4cbb7e3d2f$var$_filterEventHandler.default,
    listen: $7802fa4cbb7e3d2f$var$_listen.default,
    style: $7802fa4cbb7e3d2f$var$_css.default,
    getComputedStyle: $7802fa4cbb7e3d2f$var$_getComputedStyle.default,
    attribute: $7802fa4cbb7e3d2f$var$_attribute.default,
    activeElement: $7802fa4cbb7e3d2f$var$_activeElement.default,
    ownerDocument: $7802fa4cbb7e3d2f$var$_ownerDocument.default,
    ownerWindow: $7802fa4cbb7e3d2f$var$_ownerWindow.default,
    requestAnimationFrame: $1wlAs.request,
    cancelAnimationFrame: $1wlAs.cancel,
    matches: $7802fa4cbb7e3d2f$var$_matches.default,
    height: $7802fa4cbb7e3d2f$var$_height.default,
    width: $7802fa4cbb7e3d2f$var$_width.default,
    offset: $7802fa4cbb7e3d2f$var$_offset.default,
    offsetParent: $7802fa4cbb7e3d2f$var$_offsetParent.default,
    position: $7802fa4cbb7e3d2f$var$_position.default,
    contains: $7802fa4cbb7e3d2f$var$_contains.default,
    scrollbarSize: $7802fa4cbb7e3d2f$var$_scrollbarSize.default,
    scrollLeft: $7802fa4cbb7e3d2f$var$_scrollLeft.default,
    scrollParent: $7802fa4cbb7e3d2f$var$_scrollParent.default,
    scrollTo: $7802fa4cbb7e3d2f$var$_scrollTo.default,
    scrollTop: $7802fa4cbb7e3d2f$var$_scrollTop.default,
    querySelectorAll: $7802fa4cbb7e3d2f$var$_querySelectorAll.default,
    closest: $7802fa4cbb7e3d2f$var$_closest.default,
    addClass: $7802fa4cbb7e3d2f$var$_addClass.default,
    removeClass: $7802fa4cbb7e3d2f$var$_removeClass.default,
    hasClass: $7802fa4cbb7e3d2f$var$_hasClass.default,
    toggleClass: $7802fa4cbb7e3d2f$var$_toggleClass.default,
    transitionEnd: $7802fa4cbb7e3d2f$var$_transitionEnd.default,
    childNodes: $7802fa4cbb7e3d2f$var$_childNodes.default,
    childElements: $7802fa4cbb7e3d2f$var$_childElements.default,
    nextUntil: $7802fa4cbb7e3d2f$var$_nextUntil.default,
    parents: $7802fa4cbb7e3d2f$var$_parents.default,
    siblings: $7802fa4cbb7e3d2f$var$_siblings.default,
    clear: $7802fa4cbb7e3d2f$var$_clear.default,
    insertAfter: $7802fa4cbb7e3d2f$var$_insertAfter.default,
    isInput: $7802fa4cbb7e3d2f$var$_isInput.default,
    isVisible: $7802fa4cbb7e3d2f$var$_isVisible.default,
    prepend: $7802fa4cbb7e3d2f$var$_prepend.default,
    remove: $7802fa4cbb7e3d2f$var$_remove.default,
    text: $7802fa4cbb7e3d2f$var$_text.default
};

});
parcelRegister("gB20R", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $c151a9c2725a85e0$var$activeElement;

var $c151a9c2725a85e0$var$_ownerDocument = $jdupM((parcelRequire("7g3FG")));
/**
 * Returns the actively focused element safely.
 *
 * @param doc the document to check
 */ function $c151a9c2725a85e0$var$activeElement() {
    var doc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $c151a9c2725a85e0$var$_ownerDocument.default)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement;
        // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}
module.exports = module.exports.default;

});
parcelRegister("7g3FG", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $548ce00c81d730ae$var$ownerDocument;
/**
 * Returns the owner document of a given element.
 *
 * @param node the element
 */ function $548ce00c81d730ae$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}
module.exports = module.exports.default;

});


parcelRegister("c3zrj", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $8c7141679f2feadc$var$addClass;

var $8c7141679f2feadc$var$_hasClass = $jdupM((parcelRequire("kI242")));
/**
 * Adds a CSS class to a given element.
 *
 * @param element the element
 * @param className the CSS class name
 */ function $8c7141679f2feadc$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $8c7141679f2feadc$var$_hasClass.default)(element, className)) {
        if (typeof element.className === 'string') element.className = "".concat(element.className, " ").concat(className);
        else element.setAttribute('class', "".concat(element.className && element.className.baseVal || '', " ").concat(className));
    }
}
module.exports = module.exports.default;

});
parcelRegister("kI242", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $f139849b9ed1dbb6$var$hasClass;
/**
 * Checks if a given element has a CSS class.
 *
 * @param element the element
 * @param className the CSS class name
 */ function $f139849b9ed1dbb6$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return " ".concat(element.className.baseVal || element.className, " ").indexOf(" ".concat(className, " ")) !== -1;
}
module.exports = module.exports.default;

});


parcelRegister("91Bvh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $69214c76f37371c9$export$1e511d4a378977f5; }, function (v) { return $69214c76f37371c9$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "optionsSupported", function () { return $69214c76f37371c9$export$63fefd044b2bc624; }, function (v) { return $69214c76f37371c9$export$63fefd044b2bc624 = v; });
$parcel$export(module.exports, "onceSupported", function () { return $69214c76f37371c9$export$a614c6b395900f69; }, function (v) { return $69214c76f37371c9$export$a614c6b395900f69 = v; });
$parcel$export(module.exports, "default", function () { return $69214c76f37371c9$export$2e2bcd8739ae039; }, function (v) { return $69214c76f37371c9$export$2e2bcd8739ae039 = v; });
var $69214c76f37371c9$export$1e511d4a378977f5;
var $69214c76f37371c9$export$63fefd044b2bc624;
var $69214c76f37371c9$export$a614c6b395900f69;
var $69214c76f37371c9$export$2e2bcd8739ae039;
"use strict";

var $jdupM = parcelRequire("jdupM");
$69214c76f37371c9$export$1e511d4a378977f5 = true;
$69214c76f37371c9$export$63fefd044b2bc624 = $69214c76f37371c9$export$a614c6b395900f69 = $69214c76f37371c9$export$2e2bcd8739ae039 = void 0;

var $69214c76f37371c9$var$_canUseDOM = $jdupM((parcelRequire("aydSS")));
/* eslint-disable no-return-assign */ var $69214c76f37371c9$var$optionsSupported = $69214c76f37371c9$export$63fefd044b2bc624 = false;
var $69214c76f37371c9$var$onceSupported = $69214c76f37371c9$export$a614c6b395900f69 = false;
try {
    var $69214c76f37371c9$var$options = {
        get passive () {
            return $69214c76f37371c9$export$63fefd044b2bc624 = $69214c76f37371c9$var$optionsSupported = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $69214c76f37371c9$export$a614c6b395900f69 = $69214c76f37371c9$var$onceSupported = $69214c76f37371c9$export$63fefd044b2bc624 = $69214c76f37371c9$var$optionsSupported = true;
        }
    };
    if ($69214c76f37371c9$var$_canUseDOM.default) {
        window.addEventListener('test', $69214c76f37371c9$var$options, $69214c76f37371c9$var$options);
        window.removeEventListener('test', $69214c76f37371c9$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 *
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $69214c76f37371c9$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$69214c76f37371c9$var$onceSupported) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$69214c76f37371c9$var$onceSupported && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $69214c76f37371c9$var$optionsSupported ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $69214c76f37371c9$var$_default = $69214c76f37371c9$export$2e2bcd8739ae039 = $69214c76f37371c9$var$addEventListener;

});
parcelRegister("aydSS", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;
var $7ae7d96dde180de9$var$_default = module.exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = module.exports.default;

});


parcelRegister("6RTEM", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = void 0;

var $5002dd94aa8affb6$var$_css = $jdupM((parcelRequire("j6v8a")));

var $5002dd94aa8affb6$var$_hyphenate = $jdupM((parcelRequire("jaB2D")));

var $5002dd94aa8affb6$var$_isTransform = $jdupM((parcelRequire("byqMS")));

var $5002dd94aa8affb6$var$_transitionEnd = $jdupM((parcelRequire("1UF1a")));
var $5002dd94aa8affb6$var$reset = {
    transition: '',
    'transition-duration': '',
    'transition-delay': '',
    'transition-timing-function': ''
};
// super lean animate function for transitions
// doesn't support all translations to keep it matching the jquery API
/**
 * code in part from: Zepto 1.1.4 | zeptojs.com/license
 */ function $5002dd94aa8affb6$var$_animate(param) {
    var node = param.node, properties = param.properties, _param_duration = param.duration, duration = _param_duration === void 0 ? 200 : _param_duration, easing = param.easing, callback = param.callback;
    var cssProperties = [];
    var cssValues = {};
    var transforms = '';
    Object.keys(properties).forEach(function(key) {
        var value = properties[key];
        if ((0, $5002dd94aa8affb6$var$_isTransform.default)(key)) transforms += "".concat(key, "(").concat(value, ") ");
        else {
            cssValues[key] = value;
            cssProperties.push((0, $5002dd94aa8affb6$var$_hyphenate.default)(key));
        }
    });
    if (transforms) {
        cssValues.transform = transforms;
        cssProperties.push('transform');
    }
    function done(event) {
        if (event.target !== event.currentTarget) return;
        (0, $5002dd94aa8affb6$var$_css.default)(node, $5002dd94aa8affb6$var$reset);
        if (callback) callback.call(this, event);
    }
    if (duration > 0) {
        cssValues.transition = cssProperties.join(', ');
        cssValues['transition-duration'] = "".concat(duration / 1000, "s");
        cssValues['transition-delay'] = '0s';
        cssValues['transition-timing-function'] = easing || 'linear';
    }
    var removeListener = (0, $5002dd94aa8affb6$var$_transitionEnd.default)(node, done, duration);
    // eslint-disable-next-line no-unused-expressions
    node.clientLeft; // trigger page reflow
    (0, $5002dd94aa8affb6$var$_css.default)(node, cssValues);
    return {
        cancel: function() {
            removeListener();
            (0, $5002dd94aa8affb6$var$_css.default)(node, $5002dd94aa8affb6$var$reset);
        }
    };
}
function $5002dd94aa8affb6$var$animate(nodeOrOptions, properties, duration, easing, callback) {
    if (!('nodeType' in nodeOrOptions)) return $5002dd94aa8affb6$var$_animate(nodeOrOptions);
    if (!properties) throw new Error('must include properties to animate');
    if (typeof easing === 'function') {
        callback = easing;
        easing = '';
    }
    return $5002dd94aa8affb6$var$_animate({
        node: nodeOrOptions,
        properties: properties,
        duration: duration,
        easing: easing,
        callback: callback
    });
}
var $5002dd94aa8affb6$var$_default = module.exports.default = $5002dd94aa8affb6$var$animate;
module.exports = module.exports.default;

});
parcelRegister("j6v8a", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = void 0;

var $de86b9c258e8fc87$var$_getComputedStyle = $jdupM((parcelRequire("5xg3S")));

var $de86b9c258e8fc87$var$_hyphenateStyle = $jdupM((parcelRequire("adRLi")));

var $de86b9c258e8fc87$var$_isTransform = $jdupM((parcelRequire("byqMS")));
function $de86b9c258e8fc87$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $de86b9c258e8fc87$var$_hyphenateStyle.default)(property)) || (0, $de86b9c258e8fc87$var$_getComputedStyle.default)(node).getPropertyValue((0, $de86b9c258e8fc87$var$_hyphenateStyle.default)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $de86b9c258e8fc87$var$_hyphenateStyle.default)(key));
        else if ((0, $de86b9c258e8fc87$var$_isTransform.default)(key)) transforms += "".concat(key, "(").concat(value, ") ");
        else css += "".concat((0, $de86b9c258e8fc87$var$_hyphenateStyle.default)(key), ": ").concat(value, ";");
    });
    if (transforms) css += "transform: ".concat(transforms, ";");
    node.style.cssText += ";".concat(css);
}
var $de86b9c258e8fc87$var$_default = module.exports.default = $de86b9c258e8fc87$var$style;
module.exports = module.exports.default;

});
parcelRegister("5xg3S", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $407c7e486e88d199$var$getComputedStyle;

var $407c7e486e88d199$var$_ownerWindow = $jdupM((parcelRequire("7QWKQ")));
/**
 * Returns one or all computed style properties of an element.
 *
 * @param node the element
 * @param psuedoElement the style property
 */ function $407c7e486e88d199$var$getComputedStyle(node, psuedoElement) {
    return (0, $407c7e486e88d199$var$_ownerWindow.default)(node).getComputedStyle(node, psuedoElement);
}
module.exports = module.exports.default;

});
parcelRegister("7QWKQ", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $5b7af7274e3d07a5$var$ownerWindow;

var $5b7af7274e3d07a5$var$_ownerDocument = $jdupM((parcelRequire("7g3FG")));
/**
 * Returns the owner window of a given element.
 *
 * @param node the element
 */ function $5b7af7274e3d07a5$var$ownerWindow(node) {
    var doc = (0, $5b7af7274e3d07a5$var$_ownerDocument.default)(node);
    return doc && doc.defaultView || window;
}
module.exports = module.exports.default;

});


parcelRegister("adRLi", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $7714d243a2f4a17c$var$hyphenateStyleName;

var $7714d243a2f4a17c$var$_hyphenate = $jdupM((parcelRequire("jaB2D")));
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $7714d243a2f4a17c$var$msPattern = /^ms-/;
function $7714d243a2f4a17c$var$hyphenateStyleName(string) {
    return (0, $7714d243a2f4a17c$var$_hyphenate.default)(string).replace($7714d243a2f4a17c$var$msPattern, '-ms-');
}
module.exports = module.exports.default;

});
parcelRegister("jaB2D", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $df4baf2f9aad8d76$var$hyphenate;
var $df4baf2f9aad8d76$var$rUpper = /([A-Z])/g;
function $df4baf2f9aad8d76$var$hyphenate(string) {
    return string.replace($df4baf2f9aad8d76$var$rUpper, '-$1').toLowerCase();
}
module.exports = module.exports.default;

});


parcelRegister("byqMS", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $8697a6145d5144f1$var$isTransform;
var $8697a6145d5144f1$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $8697a6145d5144f1$var$isTransform(value) {
    return !!(value && $8697a6145d5144f1$var$supportedTransforms.test(value));
}
module.exports = module.exports.default;

});


parcelRegister("1UF1a", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $164ad6b63c4a1c49$var$transitionEnd;

var $164ad6b63c4a1c49$var$_css = $jdupM((parcelRequire("j6v8a")));

var $164ad6b63c4a1c49$var$_listen = $jdupM((parcelRequire("i0DVi")));

var $164ad6b63c4a1c49$var$_triggerEvent = $jdupM((parcelRequire("2lyTl")));
function $164ad6b63c4a1c49$var$parseDuration(node) {
    var str = (0, $164ad6b63c4a1c49$var$_css.default)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $164ad6b63c4a1c49$var$emulateTransitionEnd(element, duration) {
    var padding = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $164ad6b63c4a1c49$var$_triggerEvent.default)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $164ad6b63c4a1c49$var$_listen.default)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $164ad6b63c4a1c49$var$transitionEnd(element, handler, duration, padding) {
    if (duration == null) duration = $164ad6b63c4a1c49$var$parseDuration(element) || 0;
    var removeEmulate = $164ad6b63c4a1c49$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $164ad6b63c4a1c49$var$_listen.default)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}
module.exports = module.exports.default;

});
parcelRegister("i0DVi", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = void 0;

var $d1c731fc648c24e5$var$_addEventListener = $jdupM((parcelRequire("91Bvh")));

var $d1c731fc648c24e5$var$_removeEventListener = $jdupM((parcelRequire("93WCh")));
function $d1c731fc648c24e5$var$listen(node, eventName, handler, options) {
    (0, $d1c731fc648c24e5$var$_addEventListener.default)(node, eventName, handler, options);
    return function() {
        (0, $d1c731fc648c24e5$var$_removeEventListener.default)(node, eventName, handler, options);
    };
}
var $d1c731fc648c24e5$var$_default = module.exports.default = $d1c731fc648c24e5$var$listen;
module.exports = module.exports.default;

});
parcelRegister("93WCh", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;
/**
 * A `removeEventListener` ponyfill
 *
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $01b3e6a8ca811d23$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $01b3e6a8ca811d23$var$_default = module.exports.default = $01b3e6a8ca811d23$var$removeEventListener;
module.exports = module.exports.default;

});


parcelRegister("2lyTl", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $1b589bb1f38500ba$var$triggerEvent;
/**
 * Triggers an event on a given element.
 *
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $1b589bb1f38500ba$var$triggerEvent(node, eventName) {
    var bubbles = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, cancelable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}
module.exports = module.exports.default;

});



parcelRegister("1wlAs", function(module, exports) {

$parcel$export(module.exports, "request", function () { return $11b9864ff90e7454$export$b5fe3f66a567bec0; }, function (v) { return $11b9864ff90e7454$export$b5fe3f66a567bec0 = v; });
$parcel$export(module.exports, "cancel", function () { return $11b9864ff90e7454$export$70b61ad426ddbe54; }, function (v) { return $11b9864ff90e7454$export$70b61ad426ddbe54 = v; });
var $11b9864ff90e7454$export$1e511d4a378977f5;
var $11b9864ff90e7454$export$b5fe3f66a567bec0;
var $11b9864ff90e7454$export$70b61ad426ddbe54;
"use strict";

var $jdupM = parcelRequire("jdupM");
$11b9864ff90e7454$export$1e511d4a378977f5 = true;
$11b9864ff90e7454$export$b5fe3f66a567bec0 = $11b9864ff90e7454$export$70b61ad426ddbe54 = void 0;

var $11b9864ff90e7454$var$_canUseDOM = $jdupM((parcelRequire("aydSS")));
/* https://github.com/component/raf */ var $11b9864ff90e7454$var$prev = new Date().getTime();
function $11b9864ff90e7454$var$fallback(fn) {
    var curr = new Date().getTime();
    var ms = Math.max(0, 16 - (curr - $11b9864ff90e7454$var$prev));
    var handle = setTimeout(fn, ms);
    $11b9864ff90e7454$var$prev = curr;
    return handle;
}
var $11b9864ff90e7454$var$vendors = [
    '',
    'webkit',
    'moz',
    'o',
    'ms'
];
var $11b9864ff90e7454$var$cancelMethod = 'clearTimeout';
var $11b9864ff90e7454$var$rafImpl = $11b9864ff90e7454$var$fallback;
// eslint-disable-next-line import/no-mutable-exports
var $11b9864ff90e7454$var$getKey = function(vendor, k) {
    return "".concat(vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)), "AnimationFrame");
};
if ($11b9864ff90e7454$var$_canUseDOM.default) $11b9864ff90e7454$var$vendors.some(function(vendor) {
    var rafMethod = $11b9864ff90e7454$var$getKey(vendor, 'request');
    if (rafMethod in window) {
        $11b9864ff90e7454$var$cancelMethod = $11b9864ff90e7454$var$getKey(vendor, 'cancel');
        // @ts-ignore
        $11b9864ff90e7454$var$rafImpl = function(cb) {
            return window[rafMethod](cb);
        };
    }
    return !!$11b9864ff90e7454$var$rafImpl;
});
var $11b9864ff90e7454$var$cancel = function(id) {
    // @ts-ignore
    if (typeof window[$11b9864ff90e7454$var$cancelMethod] === 'function') window[$11b9864ff90e7454$var$cancelMethod](id);
};
$11b9864ff90e7454$export$70b61ad426ddbe54 = $11b9864ff90e7454$var$cancel;
var $11b9864ff90e7454$var$request = $11b9864ff90e7454$export$b5fe3f66a567bec0 = $11b9864ff90e7454$var$rafImpl;

});

parcelRegister("ahyuu", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $77c63f0a7033ebe0$var$attribute;
/**
 * Gets or sets an attribute of a given element.
 *
 * @param node the element
 * @param attr the attribute to get or set
 * @param val the attribute value
 */ function $77c63f0a7033ebe0$var$attribute(node, attr, val) {
    if (node) {
        if (typeof val === 'undefined') return node.getAttribute(attr);
        if (!val && val !== '') node.removeAttribute(attr);
        else node.setAttribute(attr, String(val));
    }
}
module.exports = module.exports.default;

});

parcelRegister("e4A8h", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $a3ed7795f5124e71$var$childElements;
/**
 * Collects all child elements of an element.
 *
 * @param node the element
 */ function $a3ed7795f5124e71$var$childElements(node) {
    return node ? Array.from(node.children) : [];
}
module.exports = module.exports.default;

});

parcelRegister("2TOD3", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $21c7fdaf94b1043c$var$clear;
/**
 * Removes all child nodes from a given node.
 *
 * @param node the node to clear
 */ function $21c7fdaf94b1043c$var$clear(node) {
    if (node) {
        while(node.firstChild)node.removeChild(node.firstChild);
        return node;
    }
    return null;
}
module.exports = module.exports.default;

});

parcelRegister("iuxD3", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $d7651d535cf434b8$var$closest;

var $d7651d535cf434b8$var$_matches = $jdupM((parcelRequire("cKNjA")));
/**
 * Returns the closest parent element that matches a given selector.
 *
 * @param node the reference element
 * @param selector the selector to match
 * @param stopAt stop traversing when this element is found
 */ function $d7651d535cf434b8$var$closest(node, selector, stopAt) {
    if (node.closest && !stopAt) node.closest(selector);
    var nextNode = node;
    do {
        if ((0, $d7651d535cf434b8$var$_matches.default)(nextNode, selector)) return nextNode;
        nextNode = nextNode.parentElement;
    }while (nextNode && nextNode !== stopAt && nextNode.nodeType === document.ELEMENT_NODE);
    return null;
}
module.exports = module.exports.default;

});
parcelRegister("cKNjA", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $949008d32f4fce84$var$matches;
var $949008d32f4fce84$var$matchesImpl;
/**
 * Checks if a given element matches a selector.
 *
 * @param node the element
 * @param selector the selector
 */ function $949008d32f4fce84$var$matches(node, selector) {
    if (!$949008d32f4fce84$var$matchesImpl) {
        var body = document.body;
        var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
        $949008d32f4fce84$var$matchesImpl = function(n, s) {
            return nativeMatch.call(n, s);
        };
    }
    return $949008d32f4fce84$var$matchesImpl(node, selector);
}
module.exports = module.exports.default;

});


parcelRegister("aAklW", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $7b4d0dd0d3274103$var$contains;
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 *
 * @param context the context element
 * @param node the element to check
 */ function $7b4d0dd0d3274103$var$contains(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}
module.exports = module.exports.default;

});

parcelRegister("aa6Ko", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $7660126c89c87633$var$childNodes;
var $7660126c89c87633$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Collects all child nodes of an element.
 *
 * @param node the node
 */ function $7660126c89c87633$var$childNodes(node) {
    return node ? $7660126c89c87633$var$toArray(node.childNodes) : [];
}
module.exports = module.exports.default;

});

parcelRegister("1ulEB", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $115963cf95b71fc6$var$filterEvents;

var $115963cf95b71fc6$var$_contains = $jdupM((parcelRequire("aAklW")));

var $115963cf95b71fc6$var$_querySelectorAll = $jdupM((parcelRequire("5d0qC")));
function $115963cf95b71fc6$var$filterEvents(selector, handler) {
    return function filterHandler(e) {
        var top = e.currentTarget;
        var target = e.target;
        var matches = (0, $115963cf95b71fc6$var$_querySelectorAll.default)(top, selector);
        if (matches.some(function(match) {
            return (0, $115963cf95b71fc6$var$_contains.default)(match, target);
        })) handler.call(this, e);
    };
}
module.exports = module.exports.default;

});
parcelRegister("5d0qC", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $3cae7fb3e766cc29$var$qsa;
var $3cae7fb3e766cc29$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Runs `querySelectorAll` on a given element.
 *
 * @param element the element
 * @param selector the selector
 */ function $3cae7fb3e766cc29$var$qsa(element, selector) {
    return $3cae7fb3e766cc29$var$toArray(element.querySelectorAll(selector));
}
module.exports = module.exports.default;

});


parcelRegister("2pPTO", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $1c262cab0e245a05$var$height;

var $1c262cab0e245a05$var$_isWindow = $jdupM((parcelRequire("13HGq")));

var $1c262cab0e245a05$var$_offset = $jdupM((parcelRequire("bVrCw")));
/**
 * Returns the height of a given element.
 *
 * @param node the element
 * @param client whether to use `clientHeight` if possible
 */ function $1c262cab0e245a05$var$height(node, client) {
    var win = (0, $1c262cab0e245a05$var$_isWindow.default)(node);
    return win ? win.innerHeight : client ? node.clientHeight : (0, $1c262cab0e245a05$var$_offset.default)(node).height;
}
module.exports = module.exports.default;

});
parcelRegister("13HGq", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $0c57f4d7c7f011f2$var$isWindow;

var $0c57f4d7c7f011f2$var$_isDocument = $jdupM((parcelRequire("gIjCT")));
function $0c57f4d7c7f011f2$var$isWindow(node) {
    if ('window' in node && node.window === node) return node;
    if ((0, $0c57f4d7c7f011f2$var$_isDocument.default)(node)) return node.defaultView || false;
    return false;
}
module.exports = module.exports.default;

});
parcelRegister("gIjCT", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $c2affacb6847b9e7$var$isDocument;
function $c2affacb6847b9e7$var$isDocument(element) {
    return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
}
module.exports = module.exports.default;

});


parcelRegister("bVrCw", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $8aea7164f95d953a$var$offset;

var $8aea7164f95d953a$var$_contains = $jdupM((parcelRequire("aAklW")));

var $8aea7164f95d953a$var$_ownerDocument = $jdupM((parcelRequire("7g3FG")));

var $8aea7164f95d953a$var$_scrollLeft = $jdupM((parcelRequire("6LekL")));

var $8aea7164f95d953a$var$_scrollTop = $jdupM((parcelRequire("il30Z")));
/**
 * Returns the offset of a given element, including top and left positions, width and height.
 *
 * @param node the element
 */ function $8aea7164f95d953a$var$offset(node) {
    var doc = (0, $8aea7164f95d953a$var$_ownerDocument.default)(node);
    var box = {
        top: 0,
        left: 0,
        height: 0,
        width: 0
    };
    var docElem = doc && doc.documentElement;
    // Make sure it's not a disconnected DOM node
    if (!docElem || !(0, $8aea7164f95d953a$var$_contains.default)(docElem, node)) return box;
    if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
    box = {
        top: box.top + (0, $8aea7164f95d953a$var$_scrollTop.default)(docElem) - (docElem.clientTop || 0),
        left: box.left + (0, $8aea7164f95d953a$var$_scrollLeft.default)(docElem) - (docElem.clientLeft || 0),
        width: box.width,
        height: box.height
    };
    return box;
}
module.exports = module.exports.default;

});
parcelRegister("6LekL", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = void 0;

var $4ec240424451a5e8$var$_getScrollAccessor = $jdupM((parcelRequire("5SR8q")));
/**
 * Gets or sets the scroll left position of a given element.
 *
 * @param node the element
 * @param val the position to set
 */ var $4ec240424451a5e8$var$_default = module.exports.default = (0, $4ec240424451a5e8$var$_getScrollAccessor.default)('pageXOffset');
module.exports = module.exports.default;

});
parcelRegister("5SR8q", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $448b36609d712ca0$var$getscrollAccessor;

var $448b36609d712ca0$var$_isWindow = $jdupM((parcelRequire("13HGq")));
function $448b36609d712ca0$var$getscrollAccessor(offset) {
    var prop = offset === 'pageXOffset' ? 'scrollLeft' : 'scrollTop';
    function scrollAccessor(node, val) {
        var win = (0, $448b36609d712ca0$var$_isWindow.default)(node);
        if (val === undefined) return win ? win[offset] : node[prop];
        if (win) win.scrollTo(win[offset], val);
        else node[prop] = val;
    }
    return scrollAccessor;
}
module.exports = module.exports.default;

});


parcelRegister("il30Z", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = void 0;

var $d59c86d8e46cbc55$var$_getScrollAccessor = $jdupM((parcelRequire("5SR8q")));
/**
 * Gets or sets the scroll top position of a given element.
 *
 * @param node the element
 * @param val the position to set
 */ var $d59c86d8e46cbc55$var$_default = module.exports.default = (0, $d59c86d8e46cbc55$var$_getScrollAccessor.default)('pageYOffset');
module.exports = module.exports.default;

});



parcelRegister("cDBWE", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $93368fa29392d68a$var$insertAfter;
/**
 * Inserts a node after a given reference node.
 *
 * @param node the node to insert
 * @param refNode the reference node
 */ function $93368fa29392d68a$var$insertAfter(node, refNode) {
    if (node && refNode && refNode.parentNode) {
        if (refNode.nextSibling) refNode.parentNode.insertBefore(node, refNode.nextSibling);
        else refNode.parentNode.appendChild(node);
        return node;
    }
    return null;
}
module.exports = module.exports.default;

});

parcelRegister("jKqzd", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $e606ebd7a2fabb38$var$isInput;
var $e606ebd7a2fabb38$var$regExpInputs = /^(?:input|select|textarea|button)$/i;
/**
 * Checks if a given element is an input (input, select, textarea or button).
 *
 * @param node the element to check
 */ function $e606ebd7a2fabb38$var$isInput(node) {
    return node ? $e606ebd7a2fabb38$var$regExpInputs.test(node.nodeName) : false;
}
module.exports = module.exports.default;

});

parcelRegister("jhkG6", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $e08fa51107d4741f$var$isVisible;
/**
 * Checks if a given element is currently visible.
 *
 * @param node the element to check
 */ function $e08fa51107d4741f$var$isVisible(node) {
    return node ? !!(node.offsetWidth || node.offsetHeight || node.getClientRects().length) : false;
}
module.exports = module.exports.default;

});

parcelRegister("gDhp0", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $c1bdc998e43dbe64$var$nextUntil;

var $c1bdc998e43dbe64$var$_collectSiblings = $jdupM((parcelRequire("05cxV")));
/**
 * Collects all next sibling elements of an element until a given selector is matched.
 *
 * @param node the referene node
 * @param selector the selector to match
 */ function $c1bdc998e43dbe64$var$nextUntil(node, selector) {
    return (0, $c1bdc998e43dbe64$var$_collectSiblings.default)(node, node, selector);
}
module.exports = module.exports.default;

});
parcelRegister("05cxV", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $00fa332b2c3be7a8$var$collectSiblings;

var $00fa332b2c3be7a8$var$_matches = $jdupM((parcelRequire("cKNjA")));
function $00fa332b2c3be7a8$var$collectSiblings(node) {
    var refNode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, selector = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var siblings = [];
    for(; node; node = node.nextElementSibling)if (node !== refNode) {
        if (selector && (0, $00fa332b2c3be7a8$var$_matches.default)(node, selector)) break;
        siblings.push(node);
    }
    return siblings;
}
module.exports = module.exports.default;

});


parcelRegister("5lDOq", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $3e4dcbcf793d7108$var$offsetParent;

var $3e4dcbcf793d7108$var$_css = $jdupM((parcelRequire("j6v8a")));

var $3e4dcbcf793d7108$var$_ownerDocument = $jdupM((parcelRequire("7g3FG")));
var $3e4dcbcf793d7108$var$isHTMLElement = function(e) {
    return !!e && 'offsetParent' in e;
};
function $3e4dcbcf793d7108$var$offsetParent(node) {
    var doc = (0, $3e4dcbcf793d7108$var$_ownerDocument.default)(node);
    var parent = node && node.offsetParent;
    while($3e4dcbcf793d7108$var$isHTMLElement(parent) && parent.nodeName !== 'HTML' && (0, $3e4dcbcf793d7108$var$_css.default)(parent, 'position') === 'static')parent = parent.offsetParent;
    return parent || doc.documentElement;
}
module.exports = module.exports.default;

});

parcelRegister("3PFj0", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $2ca62cec6107b6ea$var$parents;

var $2ca62cec6107b6ea$var$_collectElements = $jdupM((parcelRequire("kX3Vq")));
/**
 * Collects all parent elements of a given element.
 *
 * @param node the element
 */ function $2ca62cec6107b6ea$var$parents(node) {
    return (0, $2ca62cec6107b6ea$var$_collectElements.default)(node, 'parentElement');
}
module.exports = module.exports.default;

});
parcelRegister("kX3Vq", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $f40c5cd0e64e9657$var$collectElements;
function $f40c5cd0e64e9657$var$collectElements(node, direction) {
    var nextNode = null;
    var nodes = [];
    nextNode = node ? node[direction] : null;
    while(nextNode && nextNode.nodeType !== 9){
        nodes.push(nextNode);
        nextNode = nextNode[direction] || null;
    }
    return nodes;
}
module.exports = module.exports.default;

});


parcelRegister("1L2R9", function(module, exports) {

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $147c6568a7cc810a$var$position;

var $147c6568a7cc810a$var$_css = $jdupM((parcelRequire("j6v8a")));

var $147c6568a7cc810a$var$_offset = $jdupM((parcelRequire("bVrCw")));

var $147c6568a7cc810a$var$_offsetParent = $jdupM((parcelRequire("5lDOq")));

var $147c6568a7cc810a$var$_scrollLeft = $jdupM((parcelRequire("6LekL")));

var $147c6568a7cc810a$var$_scrollTop = $jdupM((parcelRequire("il30Z")));
var $147c6568a7cc810a$var$nodeName = function(node) {
    return node.nodeName && node.nodeName.toLowerCase();
};
/**
 * Returns the relative position of a given element.
 *
 * @param node the element
 * @param offsetParent the offset parent
 */ function $147c6568a7cc810a$var$position(node, offsetParent) {
    var parentOffset = {
        top: 0,
        left: 0
    };
    var offset;
    // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
    // because it is its only offset parent
    if ((0, $147c6568a7cc810a$var$_css.default)(node, 'position') === 'fixed') offset = node.getBoundingClientRect();
    else {
        var parent = offsetParent || (0, $147c6568a7cc810a$var$_offsetParent.default)(node);
        offset = (0, $147c6568a7cc810a$var$_offset.default)(node);
        if ($147c6568a7cc810a$var$nodeName(parent) !== 'html') parentOffset = (0, $147c6568a7cc810a$var$_offset.default)(parent);
        var borderTop = String((0, $147c6568a7cc810a$var$_css.default)(parent, 'borderTopWidth') || 0);
        parentOffset.top += parseInt(borderTop, 10) - (0, $147c6568a7cc810a$var$_scrollTop.default)(parent) || 0;
        var borderLeft = String((0, $147c6568a7cc810a$var$_css.default)(parent, 'borderLeftWidth') || 0);
        parentOffset.left += parseInt(borderLeft, 10) - (0, $147c6568a7cc810a$var$_scrollLeft.default)(parent) || 0;
    }
    var marginTop = String((0, $147c6568a7cc810a$var$_css.default)(node, 'marginTop') || 0);
    var marginLeft = String((0, $147c6568a7cc810a$var$_css.default)(node, 'marginLeft') || 0);
    // Subtract parent offsets and node margins
    return (0, $lf4fc._)((0, $hwO3w._)({}, offset), {
        top: offset.top - parentOffset.top - (parseInt(marginTop, 10) || 0),
        left: offset.left - parentOffset.left - (parseInt(marginLeft, 10) || 0)
    });
}
module.exports = module.exports.default;

});

parcelRegister("242Pl", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $180e25e20d9028de$var$prepend;
/**
 * Insert a given element as the first child of a parent element.
 *
 * @param node the element to prepend
 * @param parent the parent element
 */ function $180e25e20d9028de$var$prepend(node, parent) {
    if (node && parent) {
        if (parent.firstElementChild) parent.insertBefore(node, parent.firstElementChild);
        else parent.appendChild(node);
        return node;
    }
    return null;
}
module.exports = module.exports.default;

});

parcelRegister("9XZwM", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $741959e3588df4bd$var$remove;
/**
 * Removes a given node from the DOM.
 *
 * @param node the node to remove
 */ function $741959e3588df4bd$var$remove(node) {
    if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        return node;
    }
    return null;
}
module.exports = module.exports.default;

});

parcelRegister("8q9Ag", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $62182f970c2b6a9e$var$removeClass;
function $62182f970c2b6a9e$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)".concat(classToRemove, "(?:\\s|$)"), 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 *
 * @param element the element
 * @param className the CSS class name
 */ function $62182f970c2b6a9e$var$removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $62182f970c2b6a9e$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $62182f970c2b6a9e$var$replaceClassName(element.className && element.className.baseVal || '', className));
}
module.exports = module.exports.default;

});

parcelRegister("4oNGL", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $333ff2718657341c$var$scrollbarSize;

var $333ff2718657341c$var$_canUseDOM = $jdupM((parcelRequire("aydSS")));
var $333ff2718657341c$var$size;
function $333ff2718657341c$var$scrollbarSize(recalc) {
    if (!$333ff2718657341c$var$size && $333ff2718657341c$var$size !== 0 || recalc) {
        if ($333ff2718657341c$var$_canUseDOM.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $333ff2718657341c$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $333ff2718657341c$var$size;
}
module.exports = module.exports.default;

});

parcelRegister("9pWNI", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $6db40f7e2fe3a6c1$var$scrollParent;

var $6db40f7e2fe3a6c1$var$_css = $jdupM((parcelRequire("j6v8a")));

var $6db40f7e2fe3a6c1$var$_height = $jdupM((parcelRequire("2pPTO")));

var $6db40f7e2fe3a6c1$var$_isDocument = $jdupM((parcelRequire("gIjCT")));
/* eslint-disable no-cond-assign, no-continue */ /**
 * Find the first scrollable parent of an element.
 *
 * @param element Starting element
 * @param firstPossible Stop at the first scrollable parent, even if it's not currently scrollable
 */ function $6db40f7e2fe3a6c1$var$scrollParent(element, firstPossible) {
    var position = (0, $6db40f7e2fe3a6c1$var$_css.default)(element, 'position');
    var excludeStatic = position === 'absolute';
    var ownerDoc = element.ownerDocument;
    if (position === 'fixed') return ownerDoc || document;
    // @ts-ignore
    while((element = element.parentNode) && !(0, $6db40f7e2fe3a6c1$var$_isDocument.default)(element)){
        var isStatic = excludeStatic && (0, $6db40f7e2fe3a6c1$var$_css.default)(element, 'position') === 'static';
        var style = ((0, $6db40f7e2fe3a6c1$var$_css.default)(element, 'overflow') || '') + ((0, $6db40f7e2fe3a6c1$var$_css.default)(element, 'overflow-y') || '') + (0, $6db40f7e2fe3a6c1$var$_css.default)(element, 'overflow-x');
        if (isStatic) continue;
        if (/(auto|scroll)/.test(style) && (firstPossible || (0, $6db40f7e2fe3a6c1$var$_height.default)(element) < element.scrollHeight)) return element;
    }
    return ownerDoc || document;
}
module.exports = module.exports.default;

});

parcelRegister("6CQfj", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $4d2ed1a2986255ea$var$scrollTo;

var $1wlAs = parcelRequire("1wlAs");

var $4d2ed1a2986255ea$var$_height = $jdupM((parcelRequire("2pPTO")));

var $4d2ed1a2986255ea$var$_isWindow = $jdupM((parcelRequire("13HGq")));

var $4d2ed1a2986255ea$var$_offset = $jdupM((parcelRequire("bVrCw")));

var $4d2ed1a2986255ea$var$_scrollParent = $jdupM((parcelRequire("9pWNI")));

var $4d2ed1a2986255ea$var$_scrollTop = $jdupM((parcelRequire("il30Z")));
/* eslint-disable no-nested-ternary */ function $4d2ed1a2986255ea$var$scrollTo(selected, scrollParent) {
    var offset = (0, $4d2ed1a2986255ea$var$_offset.default)(selected);
    var poff = {
        top: 0,
        left: 0
    };
    if (!selected) return undefined;
    var list = scrollParent || (0, $4d2ed1a2986255ea$var$_scrollParent.default)(selected);
    var isWin = (0, $4d2ed1a2986255ea$var$_isWindow.default)(list);
    var listScrollTop = (0, $4d2ed1a2986255ea$var$_scrollTop.default)(list);
    var listHeight = (0, $4d2ed1a2986255ea$var$_height.default)(list, true);
    if (!isWin) poff = (0, $4d2ed1a2986255ea$var$_offset.default)(list);
    offset = {
        top: offset.top - poff.top,
        left: offset.left - poff.left,
        height: offset.height,
        width: offset.width
    };
    var selectedHeight = offset.height;
    var selectedTop = offset.top + (isWin ? 0 : listScrollTop);
    var bottom = selectedTop + selectedHeight;
    listScrollTop = listScrollTop > selectedTop ? selectedTop : bottom > listScrollTop + listHeight ? bottom - listHeight : listScrollTop;
    var id = (0, $1wlAs.request)(function() {
        return (0, $4d2ed1a2986255ea$var$_scrollTop.default)(list, listScrollTop);
    });
    return function() {
        return (0, $1wlAs.cancel)(id);
    };
}
module.exports = module.exports.default;

});

parcelRegister("j8gqD", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $dedb821269f6a619$var$siblings;

var $dedb821269f6a619$var$_collectSiblings = $jdupM((parcelRequire("05cxV")));
/**
 * Collects all previous and next sibling elements of a given element.
 *
 * @param node the element
 */ function $dedb821269f6a619$var$siblings(node) {
    return (0, $dedb821269f6a619$var$_collectSiblings.default)(node && node.parentElement ? node.parentElement.firstElementChild : null, node);
}
module.exports = module.exports.default;

});

parcelRegister("04Qp1", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $00e905e8d295bca5$var$text;
var $00e905e8d295bca5$var$regExpNbspEntity = /&nbsp;/gi;
var $00e905e8d295bca5$var$regExpNbspHex = /\xA0/g;
var $00e905e8d295bca5$var$regExpSpaces = /\s+([^\s])/gm;
/**
 * Collects the text content of a given element.
 *
 * @param node the element
 * @param trim whether to remove trailing whitespace chars
 * @param singleSpaces whether to convert multiple whitespace chars into a single space character
 */ function $00e905e8d295bca5$var$text(node) {
    var trim = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, singleSpaces = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var elementText = '';
    if (node) {
        elementText = (node.textContent || '').replace($00e905e8d295bca5$var$regExpNbspEntity, ' ').replace($00e905e8d295bca5$var$regExpNbspHex, ' ');
        if (trim) elementText = elementText.trim();
        if (singleSpaces) elementText = elementText.replace($00e905e8d295bca5$var$regExpSpaces, ' $1');
    }
    return elementText;
}
module.exports = module.exports.default;

});

parcelRegister("hbwb1", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $c82c6c5e617e83c1$var$toggleClass;

var $c82c6c5e617e83c1$var$_addClass = $jdupM((parcelRequire("c3zrj")));

var $c82c6c5e617e83c1$var$_hasClass = $jdupM((parcelRequire("kI242")));

var $c82c6c5e617e83c1$var$_removeClass = $jdupM((parcelRequire("8q9Ag")));
/**
 * Toggles a CSS class on a given element.
 *
 * @param element the element
 * @param className the CSS class name
 */ function $c82c6c5e617e83c1$var$toggleClass(element, className) {
    if (element.classList) element.classList.toggle(className);
    else if ((0, $c82c6c5e617e83c1$var$_hasClass.default)(element, className)) (0, $c82c6c5e617e83c1$var$_removeClass.default)(element, className);
    else (0, $c82c6c5e617e83c1$var$_addClass.default)(element, className);
}
module.exports = module.exports.default;

});

parcelRegister("1tFih", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
module.exports.__esModule = true;
module.exports.default = $113887f5f10add13$var$getWidth;

var $113887f5f10add13$var$_isWindow = $jdupM((parcelRequire("13HGq")));

var $113887f5f10add13$var$_offset = $jdupM((parcelRequire("bVrCw")));
/**
 * Returns the width of a given element.
 *
 * @param node the element
 * @param client whether to use `clientWidth` if possible
 */ function $113887f5f10add13$var$getWidth(node, client) {
    var win = (0, $113887f5f10add13$var$_isWindow.default)(node);
    return win ? win.innerWidth : client ? node.clientWidth : (0, $113887f5f10add13$var$_offset.default)(node).width;
}
module.exports = module.exports.default;

});


parcelRegister("kmVGT", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getBoundsForNode = $ed429ce525dc2e33$var$getBoundsForNode;
module.exports.getEventNodeFromPoint = $ed429ce525dc2e33$var$getEventNodeFromPoint;
module.exports.getShowMoreNodeFromPoint = $ed429ce525dc2e33$var$getShowMoreNodeFromPoint;
module.exports.isEvent = $ed429ce525dc2e33$var$isEvent;
module.exports.isShowMore = $ed429ce525dc2e33$var$isShowMore;
module.exports.objectsCollide = $ed429ce525dc2e33$var$objectsCollide;

var $ed429ce525dc2e33$var$_typeof2 = $jdupM((parcelRequire("deONc")));

var $ed429ce525dc2e33$var$_classCallCheck2 = $jdupM((parcelRequire("ioyax")));

var $ed429ce525dc2e33$var$_createClass2 = $jdupM((parcelRequire("3EnhW")));

var $ed429ce525dc2e33$var$_contains = $jdupM((parcelRequire("aAklW")));

var $ed429ce525dc2e33$var$_closest = $jdupM((parcelRequire("iuxD3")));

var $ed429ce525dc2e33$var$_listen = $jdupM((parcelRequire("i0DVi")));
function $ed429ce525dc2e33$var$addEventListener(type, handler) {
    var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
    return (0, $ed429ce525dc2e33$var$_listen.default)(target, type, handler, {
        passive: false
    });
}
function $ed429ce525dc2e33$var$isOverContainer(container, x, y) {
    return !container || (0, $ed429ce525dc2e33$var$_contains.default)(container, document.elementFromPoint(x, y));
}
function $ed429ce525dc2e33$var$getEventNodeFromPoint(node, _ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    var target = document.elementFromPoint(clientX, clientY);
    return (0, $ed429ce525dc2e33$var$_closest.default)(target, '.rbc-event', node);
}
function $ed429ce525dc2e33$var$getShowMoreNodeFromPoint(node, _ref2) {
    var clientX = _ref2.clientX, clientY = _ref2.clientY;
    var target = document.elementFromPoint(clientX, clientY);
    return (0, $ed429ce525dc2e33$var$_closest.default)(target, '.rbc-show-more', node);
}
function $ed429ce525dc2e33$var$isEvent(node, bounds) {
    return !!$ed429ce525dc2e33$var$getEventNodeFromPoint(node, bounds);
}
function $ed429ce525dc2e33$var$isShowMore(node, bounds) {
    return !!$ed429ce525dc2e33$var$getShowMoreNodeFromPoint(node, bounds);
}
function $ed429ce525dc2e33$var$getEventCoordinates(e) {
    var target = e;
    if (e.touches && e.touches.length) target = e.touches[0];
    return {
        clientX: target.clientX,
        clientY: target.clientY,
        pageX: target.pageX,
        pageY: target.pageY
    };
}
var $ed429ce525dc2e33$var$clickTolerance = 5;
var $ed429ce525dc2e33$var$clickInterval = 250;
var $ed429ce525dc2e33$var$Selection = /*#__PURE__*/ function() {
    function Selection(node) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref3$global = _ref3.global, global = _ref3$global === void 0 ? false : _ref3$global, _ref3$longPressThresh = _ref3.longPressThreshold, longPressThreshold = _ref3$longPressThresh === void 0 ? 250 : _ref3$longPressThresh, _ref3$validContainers = _ref3.validContainers, validContainers = _ref3$validContainers === void 0 ? [] : _ref3$validContainers;
        (0, $ed429ce525dc2e33$var$_classCallCheck2.default)(this, Selection);
        this._initialEvent = null;
        this.selecting = false;
        this.isDetached = false;
        this.container = node;
        this.globalMouse = !node || global;
        this.longPressThreshold = longPressThreshold;
        this.validContainers = validContainers;
        this._listeners = Object.create(null);
        this._handleInitialEvent = this._handleInitialEvent.bind(this);
        this._handleMoveEvent = this._handleMoveEvent.bind(this);
        this._handleTerminatingEvent = this._handleTerminatingEvent.bind(this);
        this._keyListener = this._keyListener.bind(this);
        this._dropFromOutsideListener = this._dropFromOutsideListener.bind(this);
        this._dragOverFromOutsideListener = this._dragOverFromOutsideListener.bind(this);
        // Fixes an iOS 10 bug where scrolling could not be prevented on the window.
        // https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
        this._removeTouchMoveWindowListener = $ed429ce525dc2e33$var$addEventListener('touchmove', function() {}, window);
        this._removeKeyDownListener = $ed429ce525dc2e33$var$addEventListener('keydown', this._keyListener);
        this._removeKeyUpListener = $ed429ce525dc2e33$var$addEventListener('keyup', this._keyListener);
        this._removeDropFromOutsideListener = $ed429ce525dc2e33$var$addEventListener('drop', this._dropFromOutsideListener);
        this._removeDragOverFromOutsideListener = $ed429ce525dc2e33$var$addEventListener('dragover', this._dragOverFromOutsideListener);
        this._addInitialEventListener();
    }
    return (0, $ed429ce525dc2e33$var$_createClass2.default)(Selection, [
        {
            key: "on",
            value: function on(type, handler) {
                var handlers = this._listeners[type] || (this._listeners[type] = []);
                handlers.push(handler);
                return {
                    remove: function remove() {
                        var idx = handlers.indexOf(handler);
                        if (idx !== -1) handlers.splice(idx, 1);
                    }
                };
            }
        },
        {
            key: "emit",
            value: function emit(type) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                var result;
                var handlers = this._listeners[type] || [];
                handlers.forEach(function(fn) {
                    if (result === undefined) result = fn.apply(void 0, args);
                });
                return result;
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                this._initialEvent = null;
                this._initialEventData = null;
                this._selectRect = null;
                this.selecting = false;
                this._lastClickData = null;
                this.isDetached = true;
                this._listeners = Object.create(null);
                this._removeTouchMoveWindowListener && this._removeTouchMoveWindowListener();
                this._removeInitialEventListener && this._removeInitialEventListener();
                this._removeEndListener && this._removeEndListener();
                this._onEscListener && this._onEscListener();
                this._removeMoveListener && this._removeMoveListener();
                this._removeKeyUpListener && this._removeKeyUpListener();
                this._removeKeyDownListener && this._removeKeyDownListener();
                this._removeDropFromOutsideListener && this._removeDropFromOutsideListener();
                this._removeDragOverFromOutsideListener && this._removeDragOverFromOutsideListener();
            }
        },
        {
            key: "isSelected",
            value: function isSelected(node) {
                var box = this._selectRect;
                if (!box || !this.selecting) return false;
                return $ed429ce525dc2e33$var$objectsCollide(box, $ed429ce525dc2e33$var$getBoundsForNode(node));
            }
        },
        {
            key: "filter",
            value: function filter(items) {
                var box = this._selectRect;
                //not selecting
                if (!box || !this.selecting) return [];
                return items.filter(this.isSelected, this);
            }
        },
        {
            key: "_addLongPressListener",
            value: function _addLongPressListener(handler, initialEvent) {
                var _this = this;
                var timer = null;
                var removeTouchMoveListener = null;
                var removeTouchEndListener = null;
                var handleTouchStart = function handleTouchStart(initialEvent) {
                    timer = setTimeout(function() {
                        cleanup();
                        handler(initialEvent);
                    }, _this.longPressThreshold);
                    removeTouchMoveListener = $ed429ce525dc2e33$var$addEventListener('touchmove', function() {
                        return cleanup();
                    });
                    removeTouchEndListener = $ed429ce525dc2e33$var$addEventListener('touchend', function() {
                        return cleanup();
                    });
                };
                var removeTouchStartListener = $ed429ce525dc2e33$var$addEventListener('touchstart', handleTouchStart);
                var cleanup = function cleanup() {
                    if (timer) clearTimeout(timer);
                    if (removeTouchMoveListener) removeTouchMoveListener();
                    if (removeTouchEndListener) removeTouchEndListener();
                    timer = null;
                    removeTouchMoveListener = null;
                    removeTouchEndListener = null;
                };
                if (initialEvent) handleTouchStart(initialEvent);
                return function() {
                    cleanup();
                    removeTouchStartListener();
                };
            }
        },
        {
            key: "_addInitialEventListener",
            value: function _addInitialEventListener() {
                var _this2 = this;
                var removeMouseDownListener = $ed429ce525dc2e33$var$addEventListener('mousedown', function(e) {
                    _this2._removeInitialEventListener();
                    _this2._handleInitialEvent(e);
                    _this2._removeInitialEventListener = $ed429ce525dc2e33$var$addEventListener('mousedown', _this2._handleInitialEvent);
                });
                var removeTouchStartListener = $ed429ce525dc2e33$var$addEventListener('touchstart', function(e) {
                    _this2._removeInitialEventListener();
                    _this2._removeInitialEventListener = _this2._addLongPressListener(_this2._handleInitialEvent, e);
                });
                this._removeInitialEventListener = function() {
                    removeMouseDownListener();
                    removeTouchStartListener();
                };
            }
        },
        {
            key: "_dropFromOutsideListener",
            value: function _dropFromOutsideListener(e) {
                var _getEventCoordinates = $ed429ce525dc2e33$var$getEventCoordinates(e), pageX = _getEventCoordinates.pageX, pageY = _getEventCoordinates.pageY, clientX = _getEventCoordinates.clientX, clientY = _getEventCoordinates.clientY;
                this.emit('dropFromOutside', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                e.preventDefault();
            }
        },
        {
            key: "_dragOverFromOutsideListener",
            value: function _dragOverFromOutsideListener(e) {
                var _getEventCoordinates2 = $ed429ce525dc2e33$var$getEventCoordinates(e), pageX = _getEventCoordinates2.pageX, pageY = _getEventCoordinates2.pageY, clientX = _getEventCoordinates2.clientX, clientY = _getEventCoordinates2.clientY;
                this.emit('dragOverFromOutside', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                e.preventDefault();
            }
        },
        {
            key: "_handleInitialEvent",
            value: function _handleInitialEvent(e) {
                this._initialEvent = e;
                if (this.isDetached) return;
                var _getEventCoordinates3 = $ed429ce525dc2e33$var$getEventCoordinates(e), clientX = _getEventCoordinates3.clientX, clientY = _getEventCoordinates3.clientY, pageX = _getEventCoordinates3.pageX, pageY = _getEventCoordinates3.pageY;
                var node = this.container(), collides, offsetData;
                // Right clicks
                if (e.which === 3 || e.button === 2 || !$ed429ce525dc2e33$var$isOverContainer(node, clientX, clientY)) return;
                if (!this.globalMouse && node && !(0, $ed429ce525dc2e33$var$_contains.default)(node, e.target)) {
                    var _normalizeDistance = $ed429ce525dc2e33$var$normalizeDistance(0), top = _normalizeDistance.top, left = _normalizeDistance.left, bottom = _normalizeDistance.bottom, right = _normalizeDistance.right;
                    offsetData = $ed429ce525dc2e33$var$getBoundsForNode(node);
                    collides = $ed429ce525dc2e33$var$objectsCollide({
                        top: offsetData.top - top,
                        left: offsetData.left - left,
                        bottom: offsetData.bottom + bottom,
                        right: offsetData.right + right
                    }, {
                        top: pageY,
                        left: pageX
                    });
                    if (!collides) return;
                }
                var result = this.emit('beforeSelect', this._initialEventData = {
                    isTouch: /^touch/.test(e.type),
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                if (result === false) return;
                switch(e.type){
                    case 'mousedown':
                        this._removeEndListener = $ed429ce525dc2e33$var$addEventListener('mouseup', this._handleTerminatingEvent);
                        this._onEscListener = $ed429ce525dc2e33$var$addEventListener('keydown', this._handleTerminatingEvent);
                        this._removeMoveListener = $ed429ce525dc2e33$var$addEventListener('mousemove', this._handleMoveEvent);
                        break;
                    case 'touchstart':
                        this._handleMoveEvent(e);
                        this._removeEndListener = $ed429ce525dc2e33$var$addEventListener('touchend', this._handleTerminatingEvent);
                        this._removeMoveListener = $ed429ce525dc2e33$var$addEventListener('touchmove', this._handleMoveEvent);
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "_isWithinValidContainer",
            value: function _isWithinValidContainer(e) {
                var eventTarget = e.target;
                var containers = this.validContainers;
                if (!containers || !containers.length || !eventTarget) return true;
                return containers.some(function(target) {
                    return !!eventTarget.closest(target);
                });
            }
        },
        {
            key: "_handleTerminatingEvent",
            value: function _handleTerminatingEvent(e) {
                var selecting = this.selecting;
                var bounds = this._selectRect;
                // If it's not in selecting state, it's a click event
                if (!selecting && e.type.includes('key')) e = this._initialEvent;
                this.selecting = false;
                this._removeEndListener && this._removeEndListener();
                this._removeMoveListener && this._removeMoveListener();
                this._selectRect = null;
                this._initialEvent = null;
                this._initialEventData = null;
                if (!e) return;
                var inRoot = !this.container || (0, $ed429ce525dc2e33$var$_contains.default)(this.container(), e.target);
                var isWithinValidContainer = this._isWithinValidContainer(e);
                if (e.key === 'Escape' || !isWithinValidContainer) return this.emit('reset');
                if (!selecting && inRoot) return this._handleClickEvent(e);
                // User drag-clicked in the Selectable area
                if (selecting) return this.emit('select', bounds);
                return this.emit('reset');
            }
        },
        {
            key: "_handleClickEvent",
            value: function _handleClickEvent(e) {
                var _getEventCoordinates4 = $ed429ce525dc2e33$var$getEventCoordinates(e), pageX = _getEventCoordinates4.pageX, pageY = _getEventCoordinates4.pageY, clientX = _getEventCoordinates4.clientX, clientY = _getEventCoordinates4.clientY;
                var now = new Date().getTime();
                if (this._lastClickData && now - this._lastClickData.timestamp < $ed429ce525dc2e33$var$clickInterval) {
                    // Double click event
                    this._lastClickData = null;
                    return this.emit('doubleClick', {
                        x: pageX,
                        y: pageY,
                        clientX: clientX,
                        clientY: clientY
                    });
                }
                // Click event
                this._lastClickData = {
                    timestamp: now
                };
                return this.emit('click', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
            }
        },
        {
            key: "_handleMoveEvent",
            value: function _handleMoveEvent(e) {
                if (this._initialEventData === null || this.isDetached) return;
                var _this$_initialEventDa = this._initialEventData, x = _this$_initialEventDa.x, y = _this$_initialEventDa.y;
                var _getEventCoordinates5 = $ed429ce525dc2e33$var$getEventCoordinates(e), pageX = _getEventCoordinates5.pageX, pageY = _getEventCoordinates5.pageY;
                var w = Math.abs(x - pageX);
                var h = Math.abs(y - pageY);
                var left = Math.min(pageX, x), top = Math.min(pageY, y), old = this.selecting;
                var click = this.isClick(pageX, pageY);
                // Prevent emitting selectStart event until mouse is moved.
                // in Chrome on Windows, mouseMove event may be fired just after mouseDown event.
                if (click && !old && !(w || h)) return;
                if (!old && !click) this.emit('selectStart', this._initialEventData);
                if (!click) {
                    this.selecting = true;
                    this._selectRect = {
                        top: top,
                        left: left,
                        x: pageX,
                        y: pageY,
                        right: left + w,
                        bottom: top + h
                    };
                    this.emit('selecting', this._selectRect);
                }
                e.preventDefault();
            }
        },
        {
            key: "_keyListener",
            value: function _keyListener(e) {
                this.ctrl = e.metaKey || e.ctrlKey;
            }
        },
        {
            key: "isClick",
            value: function isClick(pageX, pageY) {
                var _this$_initialEventDa2 = this._initialEventData, x = _this$_initialEventDa2.x, y = _this$_initialEventDa2.y, isTouch = _this$_initialEventDa2.isTouch;
                return !isTouch && Math.abs(pageX - x) <= $ed429ce525dc2e33$var$clickTolerance && Math.abs(pageY - y) <= $ed429ce525dc2e33$var$clickTolerance;
            }
        }
    ]);
}();
/**
 * Resolve the disance prop from either an Int or an Object
 * @return {Object}
 */ function $ed429ce525dc2e33$var$normalizeDistance() {
    var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if ((0, $ed429ce525dc2e33$var$_typeof2.default)(distance) !== 'object') distance = {
        top: distance,
        left: distance,
        right: distance,
        bottom: distance
    };
    return distance;
}
/**
 * Given two objects containing "top", "left", "offsetWidth" and "offsetHeight"
 * properties, determine if they collide.
 * @param  {Object|HTMLElement} a
 * @param  {Object|HTMLElement} b
 * @return {bool}
 */ function $ed429ce525dc2e33$var$objectsCollide(nodeA, nodeB) {
    var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var _getBoundsForNode = $ed429ce525dc2e33$var$getBoundsForNode(nodeA), aTop = _getBoundsForNode.top, aLeft = _getBoundsForNode.left, _getBoundsForNode$rig = _getBoundsForNode.right, aRight = _getBoundsForNode$rig === void 0 ? aLeft : _getBoundsForNode$rig, _getBoundsForNode$bot = _getBoundsForNode.bottom, aBottom = _getBoundsForNode$bot === void 0 ? aTop : _getBoundsForNode$bot;
    var _getBoundsForNode2 = $ed429ce525dc2e33$var$getBoundsForNode(nodeB), bTop = _getBoundsForNode2.top, bLeft = _getBoundsForNode2.left, _getBoundsForNode2$ri = _getBoundsForNode2.right, bRight = _getBoundsForNode2$ri === void 0 ? bLeft : _getBoundsForNode2$ri, _getBoundsForNode2$bo = _getBoundsForNode2.bottom, bBottom = _getBoundsForNode2$bo === void 0 ? bTop : _getBoundsForNode2$bo;
    return !// 'a' bottom doesn't touch 'b' top
    (aBottom - tolerance < bTop || // 'a' top doesn't touch 'b' bottom
    aTop + tolerance > bBottom || // 'a' right doesn't touch 'b' left
    aRight - tolerance < bLeft || // 'a' left doesn't touch 'b' right
    aLeft + tolerance > bRight);
}
/**
 * Given a node, get everything needed to calculate its boundaries
 * @param  {HTMLElement} node
 * @return {Object}
 */ function $ed429ce525dc2e33$var$getBoundsForNode(node) {
    if (!node.getBoundingClientRect) return node;
    var rect = node.getBoundingClientRect(), left = rect.left + $ed429ce525dc2e33$var$pageOffset('left'), top = rect.top + $ed429ce525dc2e33$var$pageOffset('top');
    return {
        top: top,
        left: left,
        right: (node.offsetWidth || 0) + left,
        bottom: (node.offsetHeight || 0) + top
    };
}
function $ed429ce525dc2e33$var$pageOffset(dir) {
    if (dir === 'left') return window.pageXOffset || document.body.scrollLeft || 0;
    if (dir === 'top') return window.pageYOffset || document.body.scrollTop || 0;
}
var $ed429ce525dc2e33$var$_default = module.exports.default = $ed429ce525dc2e33$var$Selection;

});

parcelRegister("hiokX", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c976feedb45d6287$var$_extends2 = $jdupM((parcelRequire("hKIoA")));

var $c976feedb45d6287$var$_defineProperty2 = $jdupM((parcelRequire("8s7es")));

var $c976feedb45d6287$var$_clsx = $jdupM((parcelRequire("7btCe")));

var $c976feedb45d6287$var$_react = $jdupM((parcelRequire("5s1kH")));
function $c976feedb45d6287$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c976feedb45d6287$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c976feedb45d6287$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c976feedb45d6287$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c976feedb45d6287$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c976feedb45d6287$var$stringifyPercent(v) {
    return typeof v === 'string' ? v : v + '%';
}
/* eslint-disable react/prop-types */ function $c976feedb45d6287$var$TimeGridEvent(props) {
    var style = props.style, className = props.className, event = props.event, accessors = props.accessors, rtl = props.rtl, selected = props.selected, label = props.label, continuesPrior = props.continuesPrior, continuesAfter = props.continuesAfter, getters = props.getters, onClick = props.onClick, onDoubleClick = props.onDoubleClick, isBackgroundEvent = props.isBackgroundEvent, onKeyPress = props.onKeyPress, _props$components = props.components, Event = _props$components.event, EventWrapper = _props$components.eventWrapper;
    var title = accessors.title(event);
    var tooltip = accessors.tooltip(event);
    var end = accessors.end(event);
    var start = accessors.start(event);
    var userProps = getters.eventProp(event, start, end, selected);
    var inner = [
        /*#__PURE__*/ $c976feedb45d6287$var$_react.default.createElement("div", {
            key: "1",
            className: "rbc-event-label"
        }, label),
        /*#__PURE__*/ $c976feedb45d6287$var$_react.default.createElement("div", {
            key: "2",
            className: "rbc-event-content"
        }, Event ? /*#__PURE__*/ $c976feedb45d6287$var$_react.default.createElement(Event, {
            event: event,
            title: title
        }) : title)
    ];
    var height = style.height, top = style.top, width = style.width, xOffset = style.xOffset;
    var eventStyle = $c976feedb45d6287$var$_objectSpread($c976feedb45d6287$var$_objectSpread({}, userProps.style), {}, (0, $c976feedb45d6287$var$_defineProperty2.default)({
        top: $c976feedb45d6287$var$stringifyPercent(top),
        height: $c976feedb45d6287$var$stringifyPercent(height),
        width: $c976feedb45d6287$var$stringifyPercent(width)
    }, rtl ? 'right' : 'left', $c976feedb45d6287$var$stringifyPercent(xOffset)));
    return /*#__PURE__*/ $c976feedb45d6287$var$_react.default.createElement(EventWrapper, (0, $c976feedb45d6287$var$_extends2.default)({
        type: "time"
    }, props), /*#__PURE__*/ $c976feedb45d6287$var$_react.default.createElement("div", {
        role: "button",
        tabIndex: 0,
        onClick: onClick,
        onDoubleClick: onDoubleClick,
        style: eventStyle,
        onKeyDown: onKeyPress,
        title: tooltip ? (typeof label === 'string' ? label + ': ' : '') + tooltip : undefined,
        className: (0, $c976feedb45d6287$var$_clsx.default)(isBackgroundEvent ? 'rbc-background-event' : 'rbc-event', className, userProps.className, {
            'rbc-selected': selected,
            'rbc-event-continues-earlier': continuesPrior,
            'rbc-event-continues-later': continuesAfter
        })
    }, inner));
}
var $c976feedb45d6287$var$_default = module.exports.default = $c976feedb45d6287$var$TimeGridEvent;

});

parcelRegister("2JAPW", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dragAccessors = void 0;
module.exports.eventTimes = $1fdc5bc044e69905$var$eventTimes;
module.exports.mergeComponents = $1fdc5bc044e69905$var$mergeComponents;
module.exports.pointInColumn = $1fdc5bc044e69905$var$pointInColumn;

var $1fdc5bc044e69905$var$_defineProperty2 = $jdupM((parcelRequire("8s7es")));

var $1fdc5bc044e69905$var$_objectWithoutProperties2 = $jdupM((parcelRequire("klbDn")));

var $eBxEd = parcelRequire("eBxEd");

var $5s1kH = parcelRequire("5s1kH");
var $1fdc5bc044e69905$var$_excluded = [
    "children"
];
function $1fdc5bc044e69905$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1fdc5bc044e69905$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1fdc5bc044e69905$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1fdc5bc044e69905$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1fdc5bc044e69905$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1fdc5bc044e69905$var$dragAccessors = module.exports.dragAccessors = {
    start: (0, $eBxEd.wrapAccessor)(function(e) {
        return e.start;
    }),
    end: (0, $eBxEd.wrapAccessor)(function(e) {
        return e.end;
    })
};
function $1fdc5bc044e69905$var$nest() {
    for(var _len = arguments.length, Components = new Array(_len), _key = 0; _key < _len; _key++)Components[_key] = arguments[_key];
    var Nest = function Nest(_ref) {
        var children = _ref.children, props = (0, $1fdc5bc044e69905$var$_objectWithoutProperties2.default)(_ref, $1fdc5bc044e69905$var$_excluded);
        return Components.filter(Boolean).reduceRight(function(child, Component) {
            return /*#__PURE__*/ (0, $5s1kH.createElement)(Component, props, child);
        }, children);
    };
    return Nest;
}
function $1fdc5bc044e69905$var$mergeComponents() {
    var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var addons = arguments.length > 1 ? arguments[1] : undefined;
    var keys = Object.keys(addons);
    var result = $1fdc5bc044e69905$var$_objectSpread({}, components);
    keys.forEach(function(key) {
        result[key] = components[key] ? $1fdc5bc044e69905$var$nest(components[key], addons[key]) : addons[key];
    });
    return result;
}
function $1fdc5bc044e69905$var$pointInColumn(bounds, point) {
    var left = bounds.left, right = bounds.right, top = bounds.top;
    var x = point.x, y = point.y;
    return x < right + 10 && x > left && y > top;
}
function $1fdc5bc044e69905$var$eventTimes(event, accessors, localizer) {
    var start = accessors.start(event);
    var end = accessors.end(event);
    var isZeroDuration = localizer.eq(start, end, 'minutes') && localizer.diff(start, end, 'minutes') === 0;
    // make zero duration midnight events at least one day long
    if (isZeroDuration) end = localizer.add(end, 1, 'day');
    var duration = localizer.diff(start, end, 'milliseconds');
    return {
        start: start,
        end: end,
        duration: duration
    };
}

});


parcelRegister("j8xtW", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");

var $deONc = parcelRequire("deONc");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dee8bc8286285b0e$var$_extends2 = $jdupM((parcelRequire("hKIoA")));

var $dee8bc8286285b0e$var$_defineProperty2 = $jdupM((parcelRequire("8s7es")));

var $dee8bc8286285b0e$var$_toConsumableArray2 = $jdupM((parcelRequire("i8sNA")));

var $dee8bc8286285b0e$var$_classCallCheck2 = $jdupM((parcelRequire("ioyax")));

var $dee8bc8286285b0e$var$_createClass2 = $jdupM((parcelRequire("3EnhW")));

var $dee8bc8286285b0e$var$_possibleConstructorReturn2 = $jdupM((parcelRequire("7o6yO")));

var $dee8bc8286285b0e$var$_getPrototypeOf2 = $jdupM((parcelRequire("lovB8")));

var $dee8bc8286285b0e$var$_inherits2 = $jdupM((parcelRequire("9rajK")));

var $dee8bc8286285b0e$var$_propTypes = $jdupM((parcelRequire("4YVCt")));

var $dee8bc8286285b0e$var$_react = $jdupM((parcelRequire("5s1kH")));

var $dee8bc8286285b0e$var$_EventRow = $jdupM((parcelRequire("1pmxY")));

var $dee8bc8286285b0e$var$_Selection = $dee8bc8286285b0e$var$_interopRequireWildcard((parcelRequire("kmVGT")));

var $02aqS = parcelRequire("02aqS");

var $8nbP0 = parcelRequire("8nbP0");

var $2JAPW = parcelRequire("2JAPW");

var $8F1Dg = parcelRequire("8F1Dg");
function $dee8bc8286285b0e$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($dee8bc8286285b0e$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != $deONc(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $dee8bc8286285b0e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dee8bc8286285b0e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dee8bc8286285b0e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dee8bc8286285b0e$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dee8bc8286285b0e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dee8bc8286285b0e$var$_callSuper(t, o, e) {
    return o = (0, $dee8bc8286285b0e$var$_getPrototypeOf2.default)(o), (0, $dee8bc8286285b0e$var$_possibleConstructorReturn2.default)(t, $dee8bc8286285b0e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $dee8bc8286285b0e$var$_getPrototypeOf2.default)(t).constructor) : o.apply(t, e));
}
function $dee8bc8286285b0e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dee8bc8286285b0e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dee8bc8286285b0e$var$WeekWrapper = /*#__PURE__*/ function(_React$Component) {
    function WeekWrapper() {
        var _this;
        (0, $dee8bc8286285b0e$var$_classCallCheck2.default)(this, WeekWrapper);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $dee8bc8286285b0e$var$_callSuper(this, WeekWrapper, [].concat(args));
        _this.handleMove = function(point, bounds, draggedEvent) {
            if (!(0, $8nbP0.pointInBox)(bounds, point)) return _this.reset();
            var event = _this.context.draggable.dragAndDropAction.event || draggedEvent;
            var _this$props = _this.props, accessors = _this$props.accessors, slotMetrics = _this$props.slotMetrics, rtl = _this$props.rtl, localizer = _this$props.localizer;
            var slot = (0, $8nbP0.getSlotAtX)(bounds, point.x, rtl, slotMetrics.slots);
            var date = slotMetrics.getDateForSlot(slot);
            // Adjust the dates, but maintain the times when moving
            var _eventTimes = (0, $2JAPW.eventTimes)(event, accessors, localizer), start = _eventTimes.start, duration = _eventTimes.duration;
            start = localizer.merge(date, start);
            var end = localizer.add(start, duration, 'milliseconds');
            // LATER: when dragging a multi-row event, only the first row is animating
            _this.update(event, start, end);
        };
        _this.handleDropFromOutside = function(point, bounds) {
            if (!_this.context.draggable.onDropFromOutside) return;
            var _this$props2 = _this.props, slotMetrics = _this$props2.slotMetrics, rtl = _this$props2.rtl, localizer = _this$props2.localizer;
            var slot = (0, $8nbP0.getSlotAtX)(bounds, point.x, rtl, slotMetrics.slots);
            var start = slotMetrics.getDateForSlot(slot);
            _this.context.draggable.onDropFromOutside({
                start: start,
                end: localizer.add(start, 1, 'day'),
                allDay: false
            });
        };
        _this.handleDragOverFromOutside = function(point, node) {
            var item = _this.context.draggable.dragFromOutsideItem ? _this.context.draggable.dragFromOutsideItem() : null;
            if (!item) return;
            _this.handleMove(point, node, item);
        };
        _this._selectable = function() {
            var node = _this.ref.current.closest('.rbc-month-row, .rbc-allday-cell');
            var container = node.closest('.rbc-month-view, .rbc-time-view');
            var isMonthRow = node.classList.contains('rbc-month-row');
            // Valid container check only necessary in TimeGrid views
            var selector = _this._selector = new $dee8bc8286285b0e$var$_Selection.default(function() {
                return container;
            }, {
                validContainers: (0, $dee8bc8286285b0e$var$_toConsumableArray2.default)(!isMonthRow ? [
                    '.rbc-day-slot',
                    '.rbc-allday-cell'
                ] : [])
            });
            selector.on('beforeSelect', function(point) {
                var isAllDay = _this.props.isAllDay;
                var action = _this.context.draggable.dragAndDropAction.action;
                var bounds = (0, $dee8bc8286285b0e$var$_Selection.getBoundsForNode)(node);
                var isInBox = (0, $8nbP0.pointInBox)(bounds, point);
                return action === 'move' || action === 'resize' && (!isAllDay || isInBox);
            });
            selector.on('selecting', function(box) {
                var bounds = (0, $dee8bc8286285b0e$var$_Selection.getBoundsForNode)(node);
                var dragAndDropAction = _this.context.draggable.dragAndDropAction;
                if (dragAndDropAction.action === 'move') _this.handleMove(box, bounds);
                if (dragAndDropAction.action === 'resize') _this.handleResize(box, bounds);
            });
            selector.on('selectStart', function() {
                return _this.context.draggable.onStart();
            });
            selector.on('select', function(point) {
                var bounds = (0, $dee8bc8286285b0e$var$_Selection.getBoundsForNode)(node);
                if (!_this.state.segment) return;
                if (!(0, $8nbP0.pointInBox)(bounds, point)) _this.reset();
                else _this.handleInteractionEnd();
            });
            selector.on('dropFromOutside', function(point) {
                if (!_this.context.draggable.onDropFromOutside) return;
                var bounds = (0, $dee8bc8286285b0e$var$_Selection.getBoundsForNode)(node);
                if (!(0, $8nbP0.pointInBox)(bounds, point)) return;
                _this.handleDropFromOutside(point, bounds);
            });
            selector.on('dragOverFromOutside', function(point) {
                if (!_this.context.draggable.dragFromOutsideItem) return;
                var bounds = (0, $dee8bc8286285b0e$var$_Selection.getBoundsForNode)(node);
                _this.handleDragOverFromOutside(point, bounds);
            });
            selector.on('click', function() {
                return _this.context.draggable.onEnd(null);
            });
            selector.on('reset', function() {
                _this.reset();
                _this.context.draggable.onEnd(null);
            });
        };
        _this.handleInteractionEnd = function() {
            var _this$props3 = _this.props, resourceId = _this$props3.resourceId, isAllDay = _this$props3.isAllDay;
            var event = _this.state.segment.event;
            _this.reset();
            _this.context.draggable.onEnd({
                start: event.start,
                end: event.end,
                resourceId: resourceId,
                isAllDay: isAllDay
            });
        };
        _this._teardownSelectable = function() {
            if (!_this._selector) return;
            _this._selector.teardown();
            _this._selector = null;
        };
        _this.state = {};
        _this.ref = /*#__PURE__*/ $dee8bc8286285b0e$var$_react.default.createRef();
        return _this;
    }
    (0, $dee8bc8286285b0e$var$_inherits2.default)(WeekWrapper, _React$Component);
    return (0, $dee8bc8286285b0e$var$_createClass2.default)(WeekWrapper, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._selectable();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._teardownSelectable();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.state.segment) this.setState({
                    segment: null
                });
            }
        },
        {
            key: "update",
            value: function update(event, start, end) {
                var segment = (0, $02aqS.eventSegments)($dee8bc8286285b0e$var$_objectSpread($dee8bc8286285b0e$var$_objectSpread({}, event), {}, {
                    end: end,
                    start: start,
                    __isPreview: true
                }), this.props.slotMetrics.range, $2JAPW.dragAccessors, this.props.localizer);
                var lastSegment = this.state.segment;
                if (lastSegment && segment.span === lastSegment.span && segment.left === lastSegment.left && segment.right === lastSegment.right) return;
                this.setState({
                    segment: segment
                });
            }
        },
        {
            key: "handleResize",
            value: function handleResize(point, bounds) {
                var _this$context$draggab = this.context.draggable.dragAndDropAction, event = _this$context$draggab.event, direction = _this$context$draggab.direction;
                var _this$props4 = this.props, accessors = _this$props4.accessors, slotMetrics = _this$props4.slotMetrics, rtl = _this$props4.rtl, localizer = _this$props4.localizer;
                var _eventTimes2 = (0, $2JAPW.eventTimes)(event, accessors, localizer), start = _eventTimes2.start, end = _eventTimes2.end;
                var slot = (0, $8nbP0.getSlotAtX)(bounds, point.x, rtl, slotMetrics.slots);
                var date = slotMetrics.getDateForSlot(slot);
                var cursorInRow = (0, $8nbP0.pointInBox)(bounds, point);
                if (direction === 'RIGHT') {
                    if (cursorInRow) {
                        if (slotMetrics.last < start) return this.reset();
                        if (localizer.eq(localizer.startOf(end, 'day'), end)) end = localizer.add(date, 1, 'day');
                        else end = date;
                    } else if (localizer.inRange(start, slotMetrics.first, slotMetrics.last) || bounds.bottom < point.y && +slotMetrics.first > +start) end = localizer.add(slotMetrics.last, 1, 'milliseconds');
                    else {
                        this.setState({
                            segment: null
                        });
                        return;
                    }
                    var originalEnd = accessors.end(event);
                    end = localizer.merge(end, originalEnd);
                    if (localizer.lt(end, start)) end = originalEnd;
                } else if (direction === 'LEFT') {
                    if (cursorInRow) {
                        if (slotMetrics.first > end) return this.reset();
                        start = date;
                    } else if (localizer.inRange(end, slotMetrics.first, slotMetrics.last) || bounds.top > point.y && localizer.lt(slotMetrics.last, end)) start = localizer.add(slotMetrics.first, -1, 'milliseconds');
                    else {
                        this.reset();
                        return;
                    }
                    var originalStart = accessors.start(event);
                    start = localizer.merge(start, originalStart);
                    if (localizer.gt(start, end)) start = originalStart;
                }
                this.update(event, start, end);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, children = _this$props5.children, accessors = _this$props5.accessors;
                var segment = this.state.segment;
                return /*#__PURE__*/ $dee8bc8286285b0e$var$_react.default.createElement("div", {
                    ref: this.ref,
                    className: "rbc-addons-dnd-row-body"
                }, children, segment && /*#__PURE__*/ $dee8bc8286285b0e$var$_react.default.createElement($dee8bc8286285b0e$var$_EventRow.default, (0, $dee8bc8286285b0e$var$_extends2.default)({}, this.props, {
                    selected: null,
                    className: "rbc-addons-dnd-drag-row",
                    segments: [
                        segment
                    ],
                    accessors: $dee8bc8286285b0e$var$_objectSpread($dee8bc8286285b0e$var$_objectSpread({}, accessors), $2JAPW.dragAccessors)
                })));
            }
        }
    ]);
}($dee8bc8286285b0e$var$_react.default.Component);
$dee8bc8286285b0e$var$WeekWrapper.contextType = $8F1Dg.DnDContext;
$dee8bc8286285b0e$var$WeekWrapper.propTypes = {};
var $dee8bc8286285b0e$var$_default = module.exports.default = $dee8bc8286285b0e$var$WeekWrapper;

});
parcelRegister("i8sNA", function(module, exports) {

var $9xqqx = parcelRequire("9xqqx");

var $4UUn8 = parcelRequire("4UUn8");

var $ejXGQ = parcelRequire("ejXGQ");

var $2nlQ6 = parcelRequire("2nlQ6");
function $d33f503351b0230b$var$_toConsumableArray(r) {
    return $9xqqx(r) || $4UUn8(r) || $ejXGQ(r) || $2nlQ6();
}
module.exports = $d33f503351b0230b$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9xqqx", function(module, exports) {

var $8GwlG = parcelRequire("8GwlG");
function $6f1bb200b8edf71a$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $8GwlG(r);
}
module.exports = $6f1bb200b8edf71a$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8GwlG", function(module, exports) {
function $652b56bebb876663$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $652b56bebb876663$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4UUn8", function(module, exports) {
function $39481eb5f6f57626$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $39481eb5f6f57626$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ejXGQ", function(module, exports) {

var $8GwlG = parcelRequire("8GwlG");
function $a6d124365739a5f2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8GwlG(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8GwlG(r, a) : void 0;
    }
}
module.exports = $a6d124365739a5f2$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2nlQ6", function(module, exports) {
function $1baeab926d9087d3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $1baeab926d9087d3$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1pmxY", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10699d984739ef20$var$_defineProperty2 = $jdupM((parcelRequire("8s7es")));

var $10699d984739ef20$var$_classCallCheck2 = $jdupM((parcelRequire("ioyax")));

var $10699d984739ef20$var$_createClass2 = $jdupM((parcelRequire("3EnhW")));

var $10699d984739ef20$var$_possibleConstructorReturn2 = $jdupM((parcelRequire("7o6yO")));

var $10699d984739ef20$var$_getPrototypeOf2 = $jdupM((parcelRequire("lovB8")));

var $10699d984739ef20$var$_inherits2 = $jdupM((parcelRequire("9rajK")));

var $10699d984739ef20$var$_propTypes = $jdupM((parcelRequire("4YVCt")));

var $10699d984739ef20$var$_clsx = $jdupM((parcelRequire("7btCe")));

var $10699d984739ef20$var$_react = $jdupM((parcelRequire("5s1kH")));

var $10699d984739ef20$var$_EventRowMixin = $jdupM((parcelRequire("kcrY0")));
function $10699d984739ef20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $10699d984739ef20$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $10699d984739ef20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $10699d984739ef20$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $10699d984739ef20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $10699d984739ef20$var$_callSuper(t, o, e) {
    return o = (0, $10699d984739ef20$var$_getPrototypeOf2.default)(o), (0, $10699d984739ef20$var$_possibleConstructorReturn2.default)(t, $10699d984739ef20$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $10699d984739ef20$var$_getPrototypeOf2.default)(t).constructor) : o.apply(t, e));
}
function $10699d984739ef20$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($10699d984739ef20$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $10699d984739ef20$var$EventRow = /*#__PURE__*/ function(_React$Component) {
    function EventRow() {
        (0, $10699d984739ef20$var$_classCallCheck2.default)(this, EventRow);
        return $10699d984739ef20$var$_callSuper(this, EventRow, arguments);
    }
    (0, $10699d984739ef20$var$_inherits2.default)(EventRow, _React$Component);
    return (0, $10699d984739ef20$var$_createClass2.default)(EventRow, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, segments = _this$props.segments, slots = _this$props.slotMetrics.slots, className = _this$props.className;
                var lastEnd = 1;
                return /*#__PURE__*/ $10699d984739ef20$var$_react.default.createElement("div", {
                    className: (0, $10699d984739ef20$var$_clsx.default)(className, 'rbc-row')
                }, segments.reduce(function(row, _ref, li) {
                    var event = _ref.event, left = _ref.left, right = _ref.right, span = _ref.span;
                    var key = '_lvl_' + li;
                    var gap = left - lastEnd;
                    var content = $10699d984739ef20$var$_EventRowMixin.default.renderEvent(_this.props, event);
                    if (gap) row.push($10699d984739ef20$var$_EventRowMixin.default.renderSpan(slots, gap, "".concat(key, "_gap")));
                    row.push($10699d984739ef20$var$_EventRowMixin.default.renderSpan(slots, span, key, content));
                    lastEnd = right + 1;
                    return row;
                }, []));
            }
        }
    ]);
}($10699d984739ef20$var$_react.default.Component);
$10699d984739ef20$var$EventRow.propTypes = {};
$10699d984739ef20$var$EventRow.defaultProps = $10699d984739ef20$var$_objectSpread({}, $10699d984739ef20$var$_EventRowMixin.default.defaultProps);
var $10699d984739ef20$var$_default = module.exports.default = $10699d984739ef20$var$EventRow;

});
parcelRegister("kcrY0", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb4a9f4148b665de$var$_propTypes = $jdupM((parcelRequire("4YVCt")));

var $eb4a9f4148b665de$var$_react = $jdupM((parcelRequire("5s1kH")));

var $eb4a9f4148b665de$var$_EventCell = $jdupM((parcelRequire("eVA3G")));

var $8nbP0 = parcelRequire("8nbP0");
/* eslint-disable react/prop-types */ var $eb4a9f4148b665de$var$_default = module.exports.default = {
    propTypes: {
        slotMetrics: $eb4a9f4148b665de$var$_propTypes.default.object.isRequired,
        selected: $eb4a9f4148b665de$var$_propTypes.default.object,
        isAllDay: $eb4a9f4148b665de$var$_propTypes.default.bool,
        accessors: $eb4a9f4148b665de$var$_propTypes.default.object.isRequired,
        localizer: $eb4a9f4148b665de$var$_propTypes.default.object.isRequired,
        components: $eb4a9f4148b665de$var$_propTypes.default.object.isRequired,
        getters: $eb4a9f4148b665de$var$_propTypes.default.object.isRequired,
        onSelect: $eb4a9f4148b665de$var$_propTypes.default.func,
        onDoubleClick: $eb4a9f4148b665de$var$_propTypes.default.func,
        onKeyPress: $eb4a9f4148b665de$var$_propTypes.default.func
    },
    defaultProps: {
        segments: [],
        selected: {}
    },
    renderEvent: function renderEvent(props, event) {
        var selected = props.selected, _ = props.isAllDay, accessors = props.accessors, getters = props.getters, onSelect = props.onSelect, onDoubleClick = props.onDoubleClick, onKeyPress = props.onKeyPress, localizer = props.localizer, slotMetrics = props.slotMetrics, components = props.components, resizable = props.resizable;
        var continuesPrior = slotMetrics.continuesPrior(event);
        var continuesAfter = slotMetrics.continuesAfter(event);
        return /*#__PURE__*/ $eb4a9f4148b665de$var$_react.default.createElement($eb4a9f4148b665de$var$_EventCell.default, {
            event: event,
            getters: getters,
            localizer: localizer,
            accessors: accessors,
            components: components,
            onSelect: onSelect,
            onDoubleClick: onDoubleClick,
            onKeyPress: onKeyPress,
            continuesPrior: continuesPrior,
            continuesAfter: continuesAfter,
            slotStart: slotMetrics.first,
            slotEnd: slotMetrics.last,
            selected: (0, $8nbP0.isSelected)(event, selected),
            resizable: resizable
        });
    },
    renderSpan: function renderSpan(slots, len, key) {
        var content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
        var per = Math.abs(len) / slots * 100 + '%';
        return /*#__PURE__*/ $eb4a9f4148b665de$var$_react.default.createElement("div", {
            key: key,
            className: "rbc-row-segment",
            style: {
                WebkitFlexBasis: per,
                flexBasis: per,
                maxWidth: per
            }
        }, content);
    }
};

});
parcelRegister("eVA3G", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ade25c01d0af3e17$var$_extends2 = $jdupM((parcelRequire("hKIoA")));

var $ade25c01d0af3e17$var$_defineProperty2 = $jdupM((parcelRequire("8s7es")));

var $ade25c01d0af3e17$var$_objectWithoutProperties2 = $jdupM((parcelRequire("klbDn")));

var $ade25c01d0af3e17$var$_classCallCheck2 = $jdupM((parcelRequire("ioyax")));

var $ade25c01d0af3e17$var$_createClass2 = $jdupM((parcelRequire("3EnhW")));

var $ade25c01d0af3e17$var$_possibleConstructorReturn2 = $jdupM((parcelRequire("7o6yO")));

var $ade25c01d0af3e17$var$_getPrototypeOf2 = $jdupM((parcelRequire("lovB8")));

var $ade25c01d0af3e17$var$_inherits2 = $jdupM((parcelRequire("9rajK")));

var $ade25c01d0af3e17$var$_propTypes = $jdupM((parcelRequire("4YVCt")));

var $ade25c01d0af3e17$var$_react = $jdupM((parcelRequire("5s1kH")));

var $ade25c01d0af3e17$var$_clsx = $jdupM((parcelRequire("7btCe")));
var $ade25c01d0af3e17$var$_excluded = [
    "style",
    "className",
    "event",
    "selected",
    "isAllDay",
    "onSelect",
    "onDoubleClick",
    "onKeyPress",
    "localizer",
    "continuesPrior",
    "continuesAfter",
    "accessors",
    "getters",
    "children",
    "components",
    "slotStart",
    "slotEnd"
];
function $ade25c01d0af3e17$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ade25c01d0af3e17$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ade25c01d0af3e17$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $ade25c01d0af3e17$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ade25c01d0af3e17$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ade25c01d0af3e17$var$_callSuper(t, o, e) {
    return o = (0, $ade25c01d0af3e17$var$_getPrototypeOf2.default)(o), (0, $ade25c01d0af3e17$var$_possibleConstructorReturn2.default)(t, $ade25c01d0af3e17$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $ade25c01d0af3e17$var$_getPrototypeOf2.default)(t).constructor) : o.apply(t, e));
}
function $ade25c01d0af3e17$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ade25c01d0af3e17$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ade25c01d0af3e17$var$EventCell = /*#__PURE__*/ function(_React$Component) {
    function EventCell() {
        (0, $ade25c01d0af3e17$var$_classCallCheck2.default)(this, EventCell);
        return $ade25c01d0af3e17$var$_callSuper(this, EventCell, arguments);
    }
    (0, $ade25c01d0af3e17$var$_inherits2.default)(EventCell, _React$Component);
    return (0, $ade25c01d0af3e17$var$_createClass2.default)(EventCell, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, style = _this$props.style, className = _this$props.className, event = _this$props.event, selected = _this$props.selected, isAllDay = _this$props.isAllDay, onSelect = _this$props.onSelect, _onDoubleClick = _this$props.onDoubleClick, onKeyPress = _this$props.onKeyPress, localizer = _this$props.localizer, continuesPrior = _this$props.continuesPrior, continuesAfter = _this$props.continuesAfter, accessors = _this$props.accessors, getters = _this$props.getters, children = _this$props.children, _this$props$component = _this$props.components, Event = _this$props$component.event, EventWrapper = _this$props$component.eventWrapper, slotStart = _this$props.slotStart, slotEnd = _this$props.slotEnd, props = (0, $ade25c01d0af3e17$var$_objectWithoutProperties2.default)(_this$props, $ade25c01d0af3e17$var$_excluded);
                delete props.resizable;
                var title = accessors.title(event);
                var tooltip = accessors.tooltip(event);
                var end = accessors.end(event);
                var start = accessors.start(event);
                var allDay = accessors.allDay(event);
                var showAsAllDay = isAllDay || allDay || localizer.diff(start, localizer.ceil(end, 'day'), 'day') > 1;
                var userProps = getters.eventProp(event, start, end, selected);
                var content = /*#__PURE__*/ $ade25c01d0af3e17$var$_react.default.createElement("div", {
                    className: "rbc-event-content",
                    title: tooltip || undefined
                }, Event ? /*#__PURE__*/ $ade25c01d0af3e17$var$_react.default.createElement(Event, {
                    event: event,
                    continuesPrior: continuesPrior,
                    continuesAfter: continuesAfter,
                    title: title,
                    isAllDay: allDay,
                    localizer: localizer,
                    slotStart: slotStart,
                    slotEnd: slotEnd
                }) : title);
                return /*#__PURE__*/ $ade25c01d0af3e17$var$_react.default.createElement(EventWrapper, (0, $ade25c01d0af3e17$var$_extends2.default)({}, this.props, {
                    type: "date"
                }), /*#__PURE__*/ $ade25c01d0af3e17$var$_react.default.createElement("div", (0, $ade25c01d0af3e17$var$_extends2.default)({}, props, {
                    style: $ade25c01d0af3e17$var$_objectSpread($ade25c01d0af3e17$var$_objectSpread({}, userProps.style), style),
                    className: (0, $ade25c01d0af3e17$var$_clsx.default)('rbc-event', className, userProps.className, {
                        'rbc-selected': selected,
                        'rbc-event-allday': showAsAllDay,
                        'rbc-event-continues-prior': continuesPrior,
                        'rbc-event-continues-after': continuesAfter
                    }),
                    onClick: function onClick(e) {
                        return onSelect && onSelect(event, e);
                    },
                    onDoubleClick: function onDoubleClick(e) {
                        return _onDoubleClick && _onDoubleClick(event, e);
                    },
                    onKeyDown: function onKeyDown(e) {
                        return onKeyPress && onKeyPress(event, e);
                    }
                }), typeof children === 'function' ? children(content) : content));
            }
        }
    ]);
}($ade25c01d0af3e17$var$_react.default.Component);
$ade25c01d0af3e17$var$EventCell.propTypes = {};
var $ade25c01d0af3e17$var$_default = module.exports.default = $ade25c01d0af3e17$var$EventCell;

});

parcelRegister("8nbP0", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dateCellSelection = $6189a44296ed56a0$var$dateCellSelection;
module.exports.getSlotAtX = $6189a44296ed56a0$var$getSlotAtX;
module.exports.isSelected = $6189a44296ed56a0$var$isSelected;
module.exports.pointInBox = $6189a44296ed56a0$var$pointInBox;
module.exports.slotWidth = $6189a44296ed56a0$var$slotWidth;

var $6189a44296ed56a0$var$_isEqual = $jdupM((parcelRequire("fRRA4")));
function $6189a44296ed56a0$var$isSelected(event, selected) {
    if (!event || selected == null) return false;
    return (0, $6189a44296ed56a0$var$_isEqual.default)(event, selected);
}
function $6189a44296ed56a0$var$slotWidth(rowBox, slots) {
    var rowWidth = rowBox.right - rowBox.left;
    var cellWidth = rowWidth / slots;
    return cellWidth;
}
function $6189a44296ed56a0$var$getSlotAtX(rowBox, x, rtl, slots) {
    var cellWidth = $6189a44296ed56a0$var$slotWidth(rowBox, slots);
    return rtl ? slots - 1 - Math.floor((x - rowBox.left) / cellWidth) : Math.floor((x - rowBox.left) / cellWidth);
}
function $6189a44296ed56a0$var$pointInBox(box, _ref) {
    var x = _ref.x, y = _ref.y;
    return y >= box.top && y <= box.bottom && x >= box.left && x <= box.right;
}
function $6189a44296ed56a0$var$dateCellSelection(start, rowBox, box, slots, rtl) {
    var startIdx = -1;
    var endIdx = -1;
    var lastSlotIdx = slots - 1;
    var cellWidth = $6189a44296ed56a0$var$slotWidth(rowBox, slots);
    // cell under the mouse
    var currentSlot = $6189a44296ed56a0$var$getSlotAtX(rowBox, box.x, rtl, slots);
    // Identify row as either the initial row
    // or the row under the current mouse point
    var isCurrentRow = rowBox.top < box.y && rowBox.bottom > box.y;
    var isStartRow = rowBox.top < start.y && rowBox.bottom > start.y;
    // this row's position relative to the start point
    var isAboveStart = start.y > rowBox.bottom;
    var isBelowStart = rowBox.top > start.y;
    var isBetween = box.top < rowBox.top && box.bottom > rowBox.bottom;
    // this row is between the current and start rows, so entirely selected
    if (isBetween) {
        startIdx = 0;
        endIdx = lastSlotIdx;
    }
    if (isCurrentRow) {
        if (isBelowStart) {
            startIdx = 0;
            endIdx = currentSlot;
        } else if (isAboveStart) {
            startIdx = currentSlot;
            endIdx = lastSlotIdx;
        }
    }
    if (isStartRow) {
        // select the cell under the initial point
        startIdx = endIdx = rtl ? lastSlotIdx - Math.floor((start.x - rowBox.left) / cellWidth) : Math.floor((start.x - rowBox.left) / cellWidth);
        if (isCurrentRow) {
            if (currentSlot < startIdx) startIdx = currentSlot;
            else endIdx = currentSlot; //select current range
        } else if (start.y < box.y) // the current row is below start row
        // select cells to the right of the start cell
        endIdx = lastSlotIdx;
        else // select cells to the left of the start cell
        startIdx = 0;
    }
    return {
        startIdx: startIdx,
        endIdx: endIdx
    };
}

});



parcelRegister("02aqS", function(module, exports) {
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.endOfRange = $006847b30bb8cc79$var$endOfRange;
module.exports.eventLevels = $006847b30bb8cc79$var$eventLevels;
module.exports.eventSegments = $006847b30bb8cc79$var$eventSegments;
module.exports.inRange = $006847b30bb8cc79$var$inRange;
module.exports.segsOverlap = $006847b30bb8cc79$var$segsOverlap;
module.exports.sortEvents = $006847b30bb8cc79$var$sortEvents;
module.exports.sortWeekEvents = $006847b30bb8cc79$var$sortWeekEvents;

var $006847b30bb8cc79$var$_toConsumableArray2 = $jdupM((parcelRequire("i8sNA")));

var $006847b30bb8cc79$var$_findIndex = $jdupM((parcelRequire("kO46s")));
function $006847b30bb8cc79$var$endOfRange(_ref) {
    var dateRange = _ref.dateRange, _ref$unit = _ref.unit, unit = _ref$unit === void 0 ? 'day' : _ref$unit, localizer = _ref.localizer;
    return {
        first: dateRange[0],
        last: localizer.add(dateRange[dateRange.length - 1], 1, unit)
    };
}
// properly calculating segments requires working with dates in
// the timezone we're working with, so we use the localizer
function $006847b30bb8cc79$var$eventSegments(event, range, accessors, localizer) {
    var _endOfRange = $006847b30bb8cc79$var$endOfRange({
        dateRange: range,
        localizer: localizer
    }), first = _endOfRange.first, last = _endOfRange.last;
    var slots = localizer.diff(first, last, 'day');
    var start = localizer.max(localizer.startOf(accessors.start(event), 'day'), first);
    var end = localizer.min(localizer.ceil(accessors.end(event), 'day'), last);
    var padding = (0, $006847b30bb8cc79$var$_findIndex.default)(range, function(x) {
        return localizer.isSameDate(x, start);
    });
    var span = localizer.diff(start, end, 'day');
    span = Math.min(span, slots);
    // The segmentOffset is necessary when adjusting for timezones
    // ahead of the browser timezone
    span = Math.max(span - localizer.segmentOffset, 1);
    return {
        event: event,
        span: span,
        left: padding + 1,
        right: Math.max(padding + span, 1)
    };
}
function $006847b30bb8cc79$var$eventLevels(rowSegments) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
    var i, j, seg, levels = [], extra = [];
    for(i = 0; i < rowSegments.length; i++){
        seg = rowSegments[i];
        for(j = 0; j < levels.length; j++)if (!$006847b30bb8cc79$var$segsOverlap(seg, levels[j])) break;
        if (j >= limit) extra.push(seg);
        else (levels[j] || (levels[j] = [])).push(seg);
    }
    for(i = 0; i < levels.length; i++)levels[i].sort(function(a, b) {
        return a.left - b.left;
    }); //eslint-disable-line
    return {
        levels: levels,
        extra: extra
    };
}
function $006847b30bb8cc79$var$inRange(e, start, end, accessors, localizer) {
    var event = {
        start: accessors.start(e),
        end: accessors.end(e)
    };
    var range = {
        start: start,
        end: end
    };
    return localizer.inEventRange({
        event: event,
        range: range
    });
}
function $006847b30bb8cc79$var$segsOverlap(seg, otherSegs) {
    return otherSegs.some(function(otherSeg) {
        return otherSeg.left <= seg.right && otherSeg.right >= seg.left;
    });
}
function $006847b30bb8cc79$var$sortWeekEvents(events, accessors, localizer) {
    var base = (0, $006847b30bb8cc79$var$_toConsumableArray2.default)(events);
    var multiDayEvents = [];
    var standardEvents = [];
    base.forEach(function(event) {
        var startCheck = accessors.start(event);
        var endCheck = accessors.end(event);
        if (localizer.daySpan(startCheck, endCheck) > 1) multiDayEvents.push(event);
        else standardEvents.push(event);
    });
    var multiSorted = multiDayEvents.sort(function(a, b) {
        return $006847b30bb8cc79$var$sortEvents(a, b, accessors, localizer);
    });
    var standardSorted = standardEvents.sort(function(a, b) {
        return $006847b30bb8cc79$var$sortEvents(a, b, accessors, localizer);
    });
    return [].concat((0, $006847b30bb8cc79$var$_toConsumableArray2.default)(multiSorted), (0, $006847b30bb8cc79$var$_toConsumableArray2.default)(standardSorted));
}
function $006847b30bb8cc79$var$sortEvents(eventA, eventB, accessors, localizer) {
    var evtA = {
        start: accessors.start(eventA),
        end: accessors.end(eventA),
        allDay: accessors.allDay(eventA)
    };
    var evtB = {
        start: accessors.start(eventB),
        end: accessors.end(eventB),
        allDay: accessors.allDay(eventB)
    };
    return localizer.sortEvents({
        evtA: evtA,
        evtB: evtB
    });
}

});



parcelRegister("cdPdj", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

var $03bAP = parcelRequire("03bAP");
(function(global, factory) {
    module.exports = factory();
})(undefined, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function some(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if ((0, $03bAP._)(arguments[i]) === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function keys(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function func() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var _$format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (_$format || !formatUpper) return _$format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var _$format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(_$format) ? _$format(output) : _$format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function func(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if ((typeof units === "undefined" ? "undefined" : (0, $03bAP._)(units)) === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function indexOf(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, _$locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                _$locale = loadLocale(split.slice(0, j).join('-'));
                if (_$locale) return _$locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var _$locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    _$locale = loadLocale(config.parentLocale);
                    if (_$locale != null) parentConfig = _$locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var _$locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                _$locale = new Locale(config);
                _$locale.parentLocale = locales[name];
                locales[name] = _$locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var _$locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            _$locale = loadLocale(key);
            if (_$locale) return _$locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, _$format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || _$format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(_$format)) configFromStringAndArray(config);
        else if (_$format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function now() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, _$weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + _$weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var _$offset = this.utcOffset(), sign = '+';
            if (_$offset < 0) {
                _$offset = -_$offset;
                sign = '-';
            }
            return sign + zeroFill(~~(_$offset / 60), 2) + separator + zeroFill(~~_$offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, _$diff;
        if (model._isUTC) {
            res = model.clone();
            _$diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + _$diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var _$offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (_$offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - _$offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? _$offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if ((typeof duration === "undefined" ? "undefined" : (0, $03bAP._)(duration)) === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var _$diff = myMoment.diff(now, 'days', true);
        return _$diff < -6 ? 'sameElse' : _$diff < -1 ? 'lastWeek' : _$diff < 0 ? 'lastDay' : _$diff < 1 ? 'sameDay' : _$diff < 2 ? 'nextDay' : _$diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), _$format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[_$format]) ? formats[_$format].call(this, now) : formats[_$format]);
        return this.format(output || this.localeData().calendar(_$format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch((0, $03bAP._)(eras[i].since)){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch((0, $03bAP._)(eras[i].until)){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var _$locale = getLocale(), utc = createUTC().set(setter, index);
        return _$locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var _$locale = getLocale(), shift = localeSorted ? _$locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), _$weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || _$weeks <= 1 && [
            'w'
        ] || _$weeks < thresholds.w && [
            'ww',
            _$weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, _$locale, output;
        if ((typeof argWithSuffix === "undefined" ? "undefined" : (0, $03bAP._)(argWithSuffix)) === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if ((typeof argThresholds === "undefined" ? "undefined" : (0, $03bAP._)(argThresholds)) === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        _$locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, _$locale);
        if (withSuffix) output = _$locale.pastFuture(+this, output);
        return _$locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

var $8f85bbd8c6e013bf$exports = {};
$parcel$extendImportMap({
    "8lzw1": "close.6636e45f.svg",
    "9sJnR": "dots-horizontal.5ca487b7.svg",
    "4gOpA": "dots-vertical.ab006311.svg",
    "lucjL": "checkmark.da5e6733.svg",
    "8L8su": "task.afac3c95.svg",
    "aNkfW": "calendar.85cab5b2.svg",
    "3gctF": "learning.90cc21e4.svg",
    "fiOLB": "ai.9f39809a.svg",
    "fJ8FY": "ai.ece65d2a.svg",
    "gJSLM": "badge-check-filled.90ee00d3.svg",
    "7H4gk": "checkmark.1bf770d4.svg",
    "Nole9": "pencil-bare.f8249fd4.svg",
    "lIjOX": "trash.f852212c.svg",
    "dS3NJ": "scale.b89b2d25.svg",
    "bCp47": "email_16x16.5cfdff47.svg",
    "lxTW5": "account.9fdb9988.svg",
    "8ZVwf": "clock.61c82d90.svg",
    "G0FKS": "email-open.e482d52f.svg",
    "gY8Cy": "calendar-x.4089d299.svg",
    "hBfdm": "information-circle.466be5cb.svg",
    "1gV2z": "profile.db054bc9.svg",
    "25RqU": "chevronRight.fb0b39af.svg",
    "6NY0Z": "chevronLeft.a471c3c9.svg",
    "18Y3C": "warning.e43376d4.svg",
    "2FnJV": "calendar-2.6536631a.svg",
    "8Bd8P": "activities.06d28f64.svg",
    "iQMOE": "plant.c1baf047.svg",
    "gTGEa": "plus.b8ea7107.svg",
    "5Bm0A": "plus.0d60ca45.svg",
    "ekXXs": "arrow-right.133d9e57.svg",
    "4EcBL": "arrow-right.900936cf.svg",
    "khsYt": "circle-rings.06abfddc.svg",
    "hklNS": "processing.d97dfe43.svg",
    "14SD2": "clock.2b9e0c95.svg",
    "lHE0T": "warning.f42c0b87.svg",
    "3gJ6J": "menu.75a8ba9d.svg",
    "3glw7": "zebrain.3c65e854.svg",
    "lG8u2": "logoText.f4f74a98.svg",
    "vQEa0": "logout.d55356a9.svg",
    "j5LW6": "support.b5c6c38d.svg",
    "8Gduo": "swedish.cabcac85.svg",
    "fDPc9": "english.831563fa.svg",
    "aKgPK": "circle-rings.7fa5db95.svg",
    "1FLw5": "team.1ca759f1.svg",
    "aiY8O": "team.7f885e4f.svg",
    "eEoDx": "video-camera.bb460362.svg",
    "dn3A4": "video-camera.60fb61d9.svg",
    "5su4n": "insights.d9b411d4.svg",
    "7gHqV": "insights.dd87c8bf.svg",
    "7KwfP": "calendar-2.e807af43.svg",
    "isz2k": "clients.044b6e73.svg",
    "5sAlU": "clients.4687cd31.svg",
    "a6GIT": "chat.f2f0078a.svg",
    "iWxsH": "chat.d2c3e08b.svg",
    "1viWo": "availability.b56f8b4d.svg",
    "hEP1W": "availability.2b969fe5.svg",
    "6W7Qo": "toast-created.b1ae6b02.svg",
    "7EkqR": "toast-completed.8d2827ca.svg",
    "741U8": "chevronRight.0a8b4061.svg",
    "36XmB": "plus.24074398.svg",
    "7ph86": "clock.4467759a.svg",
    "jPIgN": "alert.1884657a.svg",
    "2vnb7": "send.1fb6a89c.svg",
    "7EkSV": "camera-on.74a1ec93.svg",
    "nMzLV": "close.558de861.svg",
    "iWlrI": "information-circle.29652fcd.svg",
    "caAua": "chevronRight.0a8b4061.svg",
    "dLF6p": "pictureCircleBase.124fd4c7.svg",
    "a4YVE": "sparkles_animated_infinite.e0ccdc83.svg",
    "dlDUC": "chevronLeft.a471c3c9.svg",
    "1ToNe": "pencil.63492208.svg",
    "aRkz5": "badge-check.90ee00d3.svg",
    "h71sR": "info-filled.65ca6cf7.svg",
    "ccyCm": "mic-on.f79c0fa0.svg",
    "hL3K8": "mic-off.31b63cec.svg",
    "6osIC": "sound.2620eef5.svg",
    "a0BtY": "listening.e1b6c721.svg",
    "bEUpk": "paper-airplane.dd1becb0.svg",
    "68QJK": "microphone.b6a8f8fc.svg",
    "jHIp9": "check.e54c7689.svg",
    "br8x2": "faces.7d11dde8.svg",
    "6bpUD": "document.e8d69c88.svg",
    "bEf0y": "sparkles_animated_ending.3a84d1cf.svg",
    "5b4CI": "warning.f4f21d3f.svg",
    "hBK8v": "info-filled.8057034c.svg",
    "1K8oY": "tutorialModelB.6b795aab.svg",
    "70LUU": "tutorialModelC.1f9aee4a.svg",
    "lKReZ": "tutorialModelD.a723539e.svg",
    "ib0dn": "tutorialModelE.53fb56e2.svg",
    "fw2M9": "tutorialModelA.56b9d167.svg",
    "8KYnq": "visionStatement.ddb054f6.svg",
    "aXW1X": "minus.eed774b4.svg",
    "ar8Kc": "chart-Icon.257ac8b0.svg",
    "6sMeD": "arrow-left.9ad5828e.svg",
    "fm1Ze": "compass.5d766304.svg",
    "1Spux": "stress.50d9dae9.svg",
    "1G33i": "ai.0df326e2.svg",
    "jJ1uo": "badge-check.a088c292.svg",
    "7OaPI": "chatBubble.1a19b100.svg",
    "14gM6": "chevronDown.36ba4288.svg",
    "kvcEu": "star.ccdb2fe7.svg",
    "1ECe2": "star.bf1754d3.svg",
    "dUPPd": "minus.7b201511.svg",
    "bUxvD": "user-group.c529ff36.svg",
    "4xT58": "star-outline.b54b0ea3.svg",
    "9j4G5": "star-filled.4b429e75.svg",
    "7Dmfu": "check.2b15def8.svg",
    "esUtU": "calendar-x.7ca82910.svg",
    "iz9Ol": "picture-circle.7c9bf6bb.svg",
    "7iLn9": "google_calendar.a2bb04b8.svg",
    "fdZu1": "google.0d6cf5a8.svg",
    "joa5K": "microsoft_calendar.0d5a8ebe.svg",
    "ex8Dk": "flag.a3e9a52a.svg",
    "2zSZ8": "lock.881db04e.svg",
    "5pJjn": "arrow-bent.98281a42.svg",
    "gbsDT": "lightning.5bc20448.svg",
    "81x8M": "developmentPlan.df326b7e.svg",
    "5XsFF": "check-circle.7102ff2c.svg",
    "l4dyf": "check-circle.c94e17ff.svg",
    "fnlA3": "eye.5a498857.svg",
    "fm6nf": "notes.0f66ec57.svg",
    "fycp9": "notes.2e36354d.svg",
    "kFfmm": "flag.582b4e44.svg",
    "eZMsg": "puzzle.428c9487.svg",
    "gw7KT": "progress.64503caf.svg",
    "7qh7J": "hide-panel.aa76dde8.svg",
    "sHqFA": "ai.44e9660d.svg",
    "7rc1l": "star.cf4919fd.svg",
    "7tOng": "heart.78511c80.svg",
    "6gfMQ": "circle-question.ef67eb2a.svg",
    "lTOPf": "completed.d56de070.svg",
    "7Qy33": "arrow-left.41f59ade.svg"
});


var $6iP9u = parcelRequire("6iP9u");
var $b9b8d11a1c089252$exports = {};
'use strict';

$b9b8d11a1c089252$exports = (parcelRequire("4cMNx"));



var $5s1kH = parcelRequire("5s1kH");
var $83e5eb54a832d019$exports = {};
'use strict';
function $83e5eb54a832d019$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($83e5eb54a832d019$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$83e5eb54a832d019$var$checkDCE();

$83e5eb54a832d019$exports = (parcelRequire("917kP"));




var $lFIaz = parcelRequire("lFIaz");

var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");

var $XnYkK = parcelRequire("XnYkK");

var $03bAP = parcelRequire("03bAP");

var $kW1tL = parcelRequire("kW1tL");

var $3SMYb = parcelRequire("3SMYb");

var $5s1kH = parcelRequire("5s1kH");
'use client';
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $65283fdff51e8344$var$extendStatics = function extendStatics1(d, b) {
    $65283fdff51e8344$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $65283fdff51e8344$var$extendStatics(d, b);
};
function $65283fdff51e8344$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $65283fdff51e8344$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $65283fdff51e8344$var$__assign = function __assign1() {
    $65283fdff51e8344$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $65283fdff51e8344$var$__assign.apply(this, arguments);
};
function $65283fdff51e8344$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $65283fdff51e8344$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $65283fdff51e8344$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, _$g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return _$g.next = verb(0), _$g["throw"] = verb(1), _$g["return"] = verb(2), typeof Symbol === "function" && (_$g[Symbol.iterator] = function() {
        return this;
    }), _$g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_$g && (_$g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $65283fdff51e8344$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
function $65283fdff51e8344$var$e(e, t) {
    var n = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;
        for(o = Object.getOwnPropertySymbols(e); i < o.length; i++)t.indexOf(o[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[i]) && (n[o[i]] = e[o[i]]);
    }
    return n;
}
function $65283fdff51e8344$var$t(e, t, n, o) {
    if ("a" === n && !o) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === n ? o : "a" === n ? o.call(e) : o ? o.value : t.get(e);
}
function $65283fdff51e8344$var$n(e, t, n, o, i) {
    if ("m" === o) throw new TypeError("Private method is not writable");
    if ("a" === o && !i) throw new TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !i : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === o ? i.call(e, n) : i ? i.value = n : t.set(e, n), n;
}
function $65283fdff51e8344$var$o(e, t) {
    this.v = e, this.k = t;
}
function $65283fdff51e8344$var$i(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var n = 0, o = Array(t); n < t; n++)o[n] = e[n];
    return o;
}
function $65283fdff51e8344$var$r(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
function $65283fdff51e8344$var$a(e) {
    return new $65283fdff51e8344$var$o(e, 0);
}
function $65283fdff51e8344$var$s(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $65283fdff51e8344$var$c(e, t) {
    return e.get($65283fdff51e8344$var$r(e, t));
}
function $65283fdff51e8344$var$u(e, t, n) {
    $65283fdff51e8344$var$s(e, t), t.set(e, n);
}
function $65283fdff51e8344$var$l(e, t, n) {
    return e.set($65283fdff51e8344$var$r(e, t), n), n;
}
function $65283fdff51e8344$var$h(e, t) {
    $65283fdff51e8344$var$s(e, t), t.add(e);
}
function $65283fdff51e8344$var$d(e, t, n) {
    return (t = function(e) {
        var _$t = function(e, t) {
            if ("object" != (typeof e === "undefined" ? "undefined" : (0, $03bAP._)(e)) || !e) return e;
            var _$n = e[Symbol.toPrimitive];
            if (void 0 !== _$n) {
                var o = _$n.call(e, t || "default");
                if ("object" != (typeof o === "undefined" ? "undefined" : (0, $03bAP._)(o))) return o;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == (typeof _$t === "undefined" ? "undefined" : (0, $03bAP._)(_$t)) ? _$t : _$t + "";
    }(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $65283fdff51e8344$var$p(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t && (o = o.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, o);
    }
    return n;
}
function $65283fdff51e8344$var$f(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $65283fdff51e8344$var$p(Object(n), !0).forEach(function(t) {
            $65283fdff51e8344$var$d(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $65283fdff51e8344$var$p(Object(n)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
    }
    return e;
}
function $65283fdff51e8344$var$m(e, t) {
    if (null == e) return {};
    var n, o, i = function(e, t) {
        if (null == e) return {};
        var n = {};
        for(var o in e)if (({}).hasOwnProperty.call(e, o)) {
            if (-1 !== t.indexOf(o)) continue;
            n[o] = e[o];
        }
        return n;
    }(e, t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        for(o = 0; o < r.length; o++)n = r[o], -1 === t.indexOf(n) && ({}).propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
    }
    return i;
}
function $65283fdff51e8344$var$y(e, t) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != n) {
            var o, i, r, a, s = [], c = !0, u = !1;
            try {
                if (r = (n = n.call(e)).next, 0 === t) {
                    if (Object(n) !== n) return;
                    c = !1;
                } else for(; !(c = (o = r.call(n)).done) && (s.push(o.value), s.length !== t); c = !0);
            } catch (e) {
                u = !0, i = e;
            } finally{
                try {
                    if (!c && null != n.return && (a = n.return(), Object(a) !== a)) return;
                } finally{
                    if (u) throw i;
                }
            }
            return s;
        }
    }(e, t) || function(e, t) {
        if (e) {
            if ("string" == typeof e) return $65283fdff51e8344$var$i(e, t);
            var n = ({}).toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $65283fdff51e8344$var$i(e, t) : void 0;
        }
    }(e, t) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $65283fdff51e8344$var$w(e) {
    return function() {
        return new $65283fdff51e8344$var$g(e.apply(this, arguments));
    };
}
function $65283fdff51e8344$var$g(e) {
    var t, n;
    function i(t, n) {
        try {
            var a = e[t](n), s = a.value, c = s instanceof $65283fdff51e8344$var$o;
            Promise.resolve(c ? s.v : s).then(function(n) {
                if (c) {
                    var _$o = "return" === t && s.k ? t : "next";
                    if (!s.k || n.done) return i(_$o, n);
                    n = e[_$o](n).value;
                }
                r(!!a.done, n);
            }, function(e) {
                i("throw", e);
            });
        } catch (e) {
            r(2, e);
        }
    }
    function r(e, o) {
        2 === e ? t.reject(o) : t.resolve({
            value: o,
            done: e
        }), (t = t.next) ? i(t.key, t.arg) : n = null;
    }
    this._invoke = function(e, o) {
        return new Promise(function(r, a) {
            var s = {
                key: e,
                arg: o,
                resolve: r,
                reject: a,
                next: null
            };
            n ? n = n.next = s : (t = n = s, i(e, o));
        });
    }, "function" != typeof e.return && (this.return = void 0);
}
"function" == typeof SuppressedError && SuppressedError, $65283fdff51e8344$var$g.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
}, $65283fdff51e8344$var$g.prototype.next = function(e) {
    return this._invoke("next", e);
}, $65283fdff51e8344$var$g.prototype.throw = function(e) {
    return this._invoke("throw", e);
}, $65283fdff51e8344$var$g.prototype.return = function(e) {
    return this._invoke("return", e);
};
var $65283fdff51e8344$var$v = {
    timeoutInSeconds: 60
}, $65283fdff51e8344$var$b = 1e4, $65283fdff51e8344$var$k = "memory", $65283fdff51e8344$var$_ = "online_access", $65283fdff51e8344$var$S = {
    name: "auth0-spa-js",
    version: "2.24.1"
}, $65283fdff51e8344$var$T = function() {
    return Date.now();
}, $65283fdff51e8344$var$P = "default";
var $65283fdff51e8344$export$7d465be8efa67280 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(E, Error1);
    function E(e, t) {
        (0, $5Epmf._)(this, E);
        var _this;
        _this = (0, $48Z0s._)(this, E, [
            t
        ]), _this.error = e, _this.error_description = t, Object.setPrototypeOf(_this, E.prototype);
        return _this;
    }
    (0, $9MqXK._)(E, null, [
        {
            key: "fromPayload",
            value: function fromPayload(e) {
                var t = e.error, n = e.error_description;
                return new E(t, n);
            }
        }
    ]);
    return E;
}((0, $kW1tL._)(Error));
var $65283fdff51e8344$export$c2cad27df3e57d40 = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $4QAx6._)(A, E);
    function A(e, t) {
        (0, $5Epmf._)(this, A);
        var _this;
        _this = (0, $48Z0s._)(this, A, [
            "invalid_configuration",
            "".concat(e, " ").concat(t)
        ]), _this.suggestion = t, Object.setPrototypeOf(_this, A.prototype);
        return _this;
    }
    return A;
}($65283fdff51e8344$export$7d465be8efa67280);
var $65283fdff51e8344$export$cf0c46b07324e9c5 = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $4QAx6._)(I, E);
    function I(e, t, n) {
        (0, $5Epmf._)(this, I);
        var _this;
        var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
        _this = (0, $48Z0s._)(this, I, [
            e,
            t
        ]), _this.state = n, _this.appState = o, Object.setPrototypeOf(_this, I.prototype);
        return _this;
    }
    return I;
}($65283fdff51e8344$export$7d465be8efa67280);
var $65283fdff51e8344$export$aaa3fc6bdea78d4d = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $4QAx6._)(x, E);
    function x(e, t, n, o) {
        (0, $5Epmf._)(this, x);
        var _this;
        var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
        _this = (0, $48Z0s._)(this, x, [
            e,
            t
        ]), _this.connection = n, _this.state = o, _this.appState = i, Object.setPrototypeOf(_this, x.prototype);
        return _this;
    }
    return x;
}($65283fdff51e8344$export$7d465be8efa67280);
var $65283fdff51e8344$export$66d311bf29d5c89c = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $4QAx6._)(R, E);
    function R() {
        (0, $5Epmf._)(this, R);
        var _this;
        _this = (0, $48Z0s._)(this, R, [
            "timeout",
            "Timeout"
        ]), Object.setPrototypeOf(_this, R.prototype);
        return _this;
    }
    return R;
}($65283fdff51e8344$export$7d465be8efa67280);
var $65283fdff51e8344$export$ebbb83fe03f719a4 = /*#__PURE__*/ function(R) {
    "use strict";
    (0, $4QAx6._)(O, R);
    function O(e) {
        (0, $5Epmf._)(this, O);
        var _this;
        _this = (0, $48Z0s._)(this, O), _this.popup = e, Object.setPrototypeOf(_this, O.prototype);
        return _this;
    }
    return O;
}($65283fdff51e8344$export$66d311bf29d5c89c);
var $65283fdff51e8344$export$f1f681f0fb26bb55 = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $4QAx6._)(C, E);
    function C(e) {
        (0, $5Epmf._)(this, C);
        var _this;
        _this = (0, $48Z0s._)(this, C, [
            "cancelled",
            "Popup closed"
        ]), _this.popup = e, Object.setPrototypeOf(_this, C.prototype);
        return _this;
    }
    return C;
}($65283fdff51e8344$export$7d465be8efa67280);
var $65283fdff51e8344$export$d52312082b7f6392 = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $4QAx6._)(W, E);
    function W() {
        (0, $5Epmf._)(this, W);
        var _this;
        _this = (0, $48Z0s._)(this, W, [
            "popup_open",
            "Unable to open a popup for loginWithPopup - window.open returned `null`"
        ]), Object.setPrototypeOf(_this, W.prototype);
        return _this;
    }
    return W;
}($65283fdff51e8344$export$7d465be8efa67280);
var $65283fdff51e8344$export$c59494f4dae44ada = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $4QAx6._)(j, E);
    function j(e, t, n, o) {
        (0, $5Epmf._)(this, j);
        var _this;
        _this = (0, $48Z0s._)(this, j, [
            e,
            t
        ]), _this.mfa_token = n, _this.mfa_requirements = o, Object.setPrototypeOf(_this, j.prototype);
        return _this;
    }
    return j;
}($65283fdff51e8344$export$7d465be8efa67280);
var $65283fdff51e8344$export$ac1d2a00f8e0a046 = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $4QAx6._)(K, E);
    function K(e, t) {
        (0, $5Epmf._)(this, K);
        var _this;
        _this = (0, $48Z0s._)(this, K, [
            "missing_refresh_token",
            "Missing Refresh Token (audience: '".concat($65283fdff51e8344$var$L(e, [
                "default"
            ]), "', scope: '").concat($65283fdff51e8344$var$L(t), "')")
        ]), _this.audience = e, _this.scope = t, Object.setPrototypeOf(_this, K.prototype);
        return _this;
    }
    return K;
}($65283fdff51e8344$export$7d465be8efa67280);
var $65283fdff51e8344$export$1c27aeac682227b2 = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $4QAx6._)(U, E);
    function U(e, t) {
        (0, $5Epmf._)(this, U);
        var _this;
        _this = (0, $48Z0s._)(this, U, [
            "missing_scopes",
            "Missing requested scopes after refresh (audience: '".concat($65283fdff51e8344$var$L(e, [
                "default"
            ]), "', missing scope: '").concat($65283fdff51e8344$var$L(t), "')")
        ]), _this.audience = e, _this.scope = t, Object.setPrototypeOf(_this, U.prototype);
        return _this;
    }
    return U;
}($65283fdff51e8344$export$7d465be8efa67280);
var $65283fdff51e8344$export$ffb710231177fce3 = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $4QAx6._)(N, E);
    function N(e) {
        (0, $5Epmf._)(this, N);
        var _this;
        _this = (0, $48Z0s._)(this, N, [
            "use_dpop_nonce",
            "Server rejected DPoP proof: wrong nonce"
        ]), _this.newDpopNonce = e, Object.setPrototypeOf(_this, N.prototype);
        return _this;
    }
    return N;
}($65283fdff51e8344$export$7d465be8efa67280);
function $65283fdff51e8344$var$L(e) {
    return e && !(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : []).includes(e) ? e : "";
}
var $65283fdff51e8344$var$M = function() {
    return window.crypto;
}, $65283fdff51e8344$var$z = function() {
    var e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    var t = "";
    for(; t.length < 43;){
        var n = $65283fdff51e8344$var$M().getRandomValues(new Uint8Array(43 - t.length));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var o = _step.value;
                t.length < 43 && o < 198 && (t += e[o % 66]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return t;
}, $65283fdff51e8344$var$D = function(e) {
    return btoa(e);
}, $65283fdff51e8344$var$J = [
    {
        key: "name",
        type: [
            "string"
        ]
    },
    {
        key: "version",
        type: [
            "string",
            "number"
        ]
    },
    {
        key: "env",
        type: [
            "object"
        ]
    }
], $65283fdff51e8344$var$H = function H(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return Object.keys(e).reduce(function(n, o) {
        if (t && "env" === o) return n;
        var i = $65283fdff51e8344$var$J.find(function(e) {
            return e.key === o;
        });
        return i && i.type.includes((0, $03bAP._)(e[o])) && (n[o] = e[o]), n;
    }, {});
}, $65283fdff51e8344$var$Z = function(t) {
    var n = t.clientId, o = $65283fdff51e8344$var$e(t, [
        "clientId"
    ]);
    return new URLSearchParams(function(e) {
        return Object.keys(e).filter(function(t) {
            return void 0 !== e[t];
        }).reduce(function(t, n) {
            return Object.assign(Object.assign({}, t), (0, $dUlz9._)({}, n, e[n]));
        }, {});
    }(Object.assign({
        client_id: n
    }, o))).toString();
}, $65283fdff51e8344$var$F = function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var t;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    t = $65283fdff51e8344$var$M().subtle.digest({
                        name: "SHA-256"
                    }, (new TextEncoder).encode(e));
                    return [
                        4,
                        t
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}, $65283fdff51e8344$var$V = function(e) {
    return function(e) {
        return decodeURIComponent(atob(e).split("").map(function(e) {
            return "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
    }(e.replace(/_/g, "/").replace(/-/g, "+"));
}, $65283fdff51e8344$var$X = function(e) {
    var _String;
    var t = new Uint8Array(e);
    return function(e) {
        var t = {
            "+": "-",
            "/": "_",
            "=": ""
        };
        return e.replace(/[+/=]/g, function(e) {
            return t[e];
        });
    }(window.btoa((_String = String).fromCharCode.apply(_String, (0, $XnYkK._)(Array.from(t)))));
};
var $65283fdff51e8344$var$G = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {}, $65283fdff51e8344$var$Y = {}, $65283fdff51e8344$var$B = {};
Object.defineProperty($65283fdff51e8344$var$B, "__esModule", {
    value: !0
});
var $65283fdff51e8344$var$q = function() {
    function e() {
        var _$e = this;
        this.locked = new Map, this.addToLocked = function(t, n) {
            var o = _$e.locked.get(t);
            void 0 === o ? void 0 === n ? _$e.locked.set(t, []) : _$e.locked.set(t, [
                n
            ]) : void 0 !== n && (o.unshift(n), _$e.locked.set(t, o));
        }, this.isLocked = function(t) {
            return _$e.locked.has(t);
        }, this.lock = function(t) {
            return new Promise(function(n, o) {
                _$e.isLocked(t) ? _$e.addToLocked(t, n) : (_$e.addToLocked(t), n());
            });
        }, this.unlock = function(t) {
            var n = _$e.locked.get(t);
            if (void 0 !== n && 0 !== n.length) {
                var o = n.pop();
                _$e.locked.set(t, n), void 0 !== o && setTimeout(o, 0);
            } else _$e.locked.delete(t);
        };
    }
    return e.getInstance = function() {
        return void 0 === e.instance && (e.instance = new e), e.instance;
    }, e;
}();
$65283fdff51e8344$var$B.default = function() {
    return $65283fdff51e8344$var$q.getInstance();
};
var $65283fdff51e8344$var$Q = $65283fdff51e8344$var$G && $65283fdff51e8344$var$G.__awaiter || function(e, t, n, o) {
    return new (n || (n = Promise))(function(i, r) {
        function a(e) {
            try {
                c(o.next(e));
            } catch (e) {
                r(e);
            }
        }
        function s(e) {
            try {
                c(o.throw(e));
            } catch (e) {
                r(e);
            }
        }
        function c(e) {
            e.done ? i(e.value) : new n(function(t) {
                t(e.value);
            }).then(a, s);
        }
        c((o = o.apply(e, t || [])).next());
    });
}, $65283fdff51e8344$var$$ = $65283fdff51e8344$var$G && $65283fdff51e8344$var$G.__generator || function(e, t) {
    var n, o, i, r, a = {
        label: 0,
        sent: function sent() {
            if (1 & i[0]) throw i[1];
            return i[1];
        },
        trys: [],
        ops: []
    };
    return r = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (r[Symbol.iterator] = function() {
        return this;
    }), r;
    function s(r) {
        return function(s) {
            return function(r) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (n = 1, o && (i = 2 & r[0] ? o.return : r[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, r[1])).done) return i;
                    switch(o = 0, i && (r = [
                        2 & r[0],
                        i.value
                    ]), r[0]){
                        case 0:
                        case 1:
                            i = r;
                            break;
                        case 4:
                            return a.label++, {
                                value: r[1],
                                done: !1
                            };
                        case 5:
                            a.label++, o = r[1], r = [
                                0
                            ];
                            continue;
                        case 7:
                            r = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== r[0] && 2 !== r[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === r[0] && (!i || r[1] > i[0] && r[1] < i[3])) {
                                a.label = r[1];
                                break;
                            }
                            if (6 === r[0] && a.label < i[1]) {
                                a.label = i[1], i = r;
                                break;
                            }
                            if (i && a.label < i[2]) {
                                a.label = i[2], a.ops.push(r);
                                break;
                            }
                            i[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    r = t.call(e, a);
                } catch (e) {
                    r = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = i = 0;
                }
                if (5 & r[0]) throw r[1];
                return {
                    value: r[0] ? r[1] : void 0,
                    done: !0
                };
            }([
                r,
                s
            ]);
        };
    }
}, $65283fdff51e8344$var$ee = $65283fdff51e8344$var$G;
Object.defineProperty($65283fdff51e8344$var$Y, "__esModule", {
    value: !0
});
var $65283fdff51e8344$var$te = $65283fdff51e8344$var$B, $65283fdff51e8344$var$ne = "browser-tabs-lock-key", $65283fdff51e8344$var$oe = {
    key: function key(e) {
        return $65283fdff51e8344$var$Q($65283fdff51e8344$var$ee, void 0, void 0, function() {
            return $65283fdff51e8344$var$$(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    getItem: function getItem(e) {
        return $65283fdff51e8344$var$Q($65283fdff51e8344$var$ee, void 0, void 0, function() {
            return $65283fdff51e8344$var$$(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    clear: function clear() {
        return $65283fdff51e8344$var$Q($65283fdff51e8344$var$ee, void 0, void 0, function() {
            return $65283fdff51e8344$var$$(this, function(e) {
                return [
                    2,
                    window.localStorage.clear()
                ];
            });
        });
    },
    removeItem: function removeItem(e) {
        return $65283fdff51e8344$var$Q($65283fdff51e8344$var$ee, void 0, void 0, function() {
            return $65283fdff51e8344$var$$(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    setItem: function setItem(e, t) {
        return $65283fdff51e8344$var$Q($65283fdff51e8344$var$ee, void 0, void 0, function() {
            return $65283fdff51e8344$var$$(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    keySync: function keySync(e) {
        return window.localStorage.key(e);
    },
    getItemSync: function getItemSync(e) {
        return window.localStorage.getItem(e);
    },
    clearSync: function clearSync() {
        return window.localStorage.clear();
    },
    removeItemSync: function removeItemSync(e) {
        return window.localStorage.removeItem(e);
    },
    setItemSync: function setItemSync(e, t) {
        return window.localStorage.setItem(e, t);
    }
};
function $65283fdff51e8344$var$ie(e) {
    return new Promise(function(t) {
        return setTimeout(t, e);
    });
}
function $65283fdff51e8344$var$re(e) {
    for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", n = "", o = 0; o < e; o++)n += t[Math.floor(61 * Math.random())];
    return n;
}
var $65283fdff51e8344$var$ae = function() {
    function e(t) {
        this.acquiredIatSet = new Set, this.storageHandler = void 0, this.id = Date.now().toString() + $65283fdff51e8344$var$re(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
    }
    return e.prototype.acquireLock = function(t, n) {
        return void 0 === n && (n = 5e3), $65283fdff51e8344$var$Q(this, void 0, void 0, function() {
            var o, i, r, a, s, c, u;
            return $65283fdff51e8344$var$$(this, function(l) {
                switch(l.label){
                    case 0:
                        o = Date.now() + $65283fdff51e8344$var$re(4), i = Date.now() + n, r = $65283fdff51e8344$var$ne + "-" + t, a = void 0 === this.storageHandler ? $65283fdff51e8344$var$oe : this.storageHandler, l.label = 1;
                    case 1:
                        return Date.now() < i ? [
                            4,
                            $65283fdff51e8344$var$ie(30)
                        ] : [
                            3,
                            8
                        ];
                    case 2:
                        return l.sent(), null !== a.getItemSync(r) ? [
                            3,
                            5
                        ] : (s = this.id + "-" + t + "-" + o, [
                            4,
                            $65283fdff51e8344$var$ie(Math.floor(25 * Math.random()))
                        ]);
                    case 3:
                        return l.sent(), a.setItemSync(r, JSON.stringify({
                            id: this.id,
                            iat: o,
                            timeoutKey: s,
                            timeAcquired: Date.now(),
                            timeRefreshed: Date.now()
                        })), [
                            4,
                            $65283fdff51e8344$var$ie(30)
                        ];
                    case 4:
                        return l.sent(), null !== (c = a.getItemSync(r)) && (u = JSON.parse(c)).id === this.id && u.iat === o ? (this.acquiredIatSet.add(o), this.refreshLockWhileAcquired(r, o), [
                            2,
                            !0
                        ]) : [
                            3,
                            7
                        ];
                    case 5:
                        return e.lockCorrector(void 0 === this.storageHandler ? $65283fdff51e8344$var$oe : this.storageHandler), [
                            4,
                            this.waitForSomethingToChange(i)
                        ];
                    case 6:
                        l.sent(), l.label = 7;
                    case 7:
                        return o = Date.now() + $65283fdff51e8344$var$re(4), [
                            3,
                            1
                        ];
                    case 8:
                        return [
                            2,
                            !1
                        ];
                }
            });
        });
    }, e.prototype.refreshLockWhileAcquired = function(e, t) {
        return $65283fdff51e8344$var$Q(this, void 0, void 0, function() {
            var n = this;
            return $65283fdff51e8344$var$$(this, function(o) {
                return setTimeout(function() {
                    return $65283fdff51e8344$var$Q(n, void 0, void 0, function() {
                        var n, o, i;
                        return $65283fdff51e8344$var$$(this, function(r) {
                            switch(r.label){
                                case 0:
                                    return [
                                        4,
                                        $65283fdff51e8344$var$te.default().lock(t)
                                    ];
                                case 1:
                                    return r.sent(), this.acquiredIatSet.has(t) ? (n = void 0 === this.storageHandler ? $65283fdff51e8344$var$oe : this.storageHandler, null === (o = n.getItemSync(e)) ? ($65283fdff51e8344$var$te.default().unlock(t), [
                                        2
                                    ]) : ((i = JSON.parse(o)).timeRefreshed = Date.now(), n.setItemSync(e, JSON.stringify(i)), $65283fdff51e8344$var$te.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                        2
                                    ])) : ($65283fdff51e8344$var$te.default().unlock(t), [
                                        2
                                    ]);
                            }
                        });
                    });
                }, 1e3), [
                    2
                ];
            });
        });
    }, e.prototype.waitForSomethingToChange = function(t) {
        return $65283fdff51e8344$var$Q(this, void 0, void 0, function() {
            return $65283fdff51e8344$var$$(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(n) {
                                var o = !1, i = Date.now(), r = !1;
                                function a() {
                                    if (r || (window.removeEventListener("storage", a), e.removeFromWaiting(a), clearTimeout(s), r = !0), !o) {
                                        o = !0;
                                        var _$t = 50 - (Date.now() - i);
                                        _$t > 0 ? setTimeout(n, _$t) : n(null);
                                    }
                                }
                                window.addEventListener("storage", a), e.addToWaiting(a);
                                var s = setTimeout(a, Math.max(0, t - Date.now()));
                            })
                        ];
                    case 1:
                        return n.sent(), [
                            2
                        ];
                }
            });
        });
    }, e.addToWaiting = function(t) {
        this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
    }, e.removeFromWaiting = function(t) {
        void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
            return e !== t;
        }));
    }, e.notifyWaiters = function() {
        void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
            return e();
        });
    }, e.prototype.releaseLock = function(e) {
        return $65283fdff51e8344$var$Q(this, void 0, void 0, function() {
            return $65283fdff51e8344$var$$(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this.releaseLock__private__(e)
                        ];
                    case 1:
                        return [
                            2,
                            t.sent()
                        ];
                }
            });
        });
    }, e.prototype.releaseLock__private__ = function(t) {
        return $65283fdff51e8344$var$Q(this, void 0, void 0, function() {
            var n, o, i, r;
            return $65283fdff51e8344$var$$(this, function(a) {
                switch(a.label){
                    case 0:
                        return n = void 0 === this.storageHandler ? $65283fdff51e8344$var$oe : this.storageHandler, o = $65283fdff51e8344$var$ne + "-" + t, null === (i = n.getItemSync(o)) ? [
                            2
                        ] : (r = JSON.parse(i)).id !== this.id ? [
                            3,
                            2
                        ] : [
                            4,
                            $65283fdff51e8344$var$te.default().lock(r.iat)
                        ];
                    case 1:
                        a.sent(), this.acquiredIatSet.delete(r.iat), n.removeItemSync(o), $65283fdff51e8344$var$te.default().unlock(r.iat), e.notifyWaiters(), a.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.lockCorrector = function(t) {
        for(var n = Date.now() - 5e3, o = t, i = [], r = 0;;){
            var a = o.keySync(r);
            if (null === a) break;
            i.push(a), r++;
        }
        for(var s = !1, c = 0; c < i.length; c++){
            var u = i[c];
            if (u.includes($65283fdff51e8344$var$ne)) {
                var l = o.getItemSync(u);
                if (null !== l) {
                    var h = JSON.parse(l);
                    (void 0 === h.timeRefreshed && h.timeAcquired < n || void 0 !== h.timeRefreshed && h.timeRefreshed < n) && (o.removeItemSync(u), s = !0);
                }
            }
        }
        s && e.notifyWaiters();
    }, e.waiters = void 0, e;
}(), $65283fdff51e8344$var$se = $65283fdff51e8344$var$Y.default = $65283fdff51e8344$var$ae;
var $65283fdff51e8344$var$ce = /*#__PURE__*/ function() {
    "use strict";
    function ce() {
        (0, $5Epmf._)(this, ce);
    }
    (0, $9MqXK._)(ce, [
        {
            key: "runWithLock",
            value: function runWithLock(e, t, n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var o, i, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                o = new AbortController, i = setTimeout(function() {
                                    return o.abort();
                                }, t);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    navigator.locks.request(e, {
                                        mode: "exclusive",
                                        signal: o.signal
                                    }, function(e) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                            return (0, $3SMYb._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (clearTimeout(i), !e) throw new Error("Lock not available");
                                                        return [
                                                            4,
                                                            n()
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                }
                                            });
                                        })();
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                e1 = _state.sent();
                                if (clearTimeout(i), "AbortError" === (null == e1 ? void 0 : e1.name)) throw new $65283fdff51e8344$export$66d311bf29d5c89c;
                                throw e1;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ce;
}();
var $65283fdff51e8344$var$ue = /*#__PURE__*/ function() {
    "use strict";
    function ue() {
        var _this = this;
        (0, $5Epmf._)(this, ue);
        this.activeLocks = new Set, this.lock = new $65283fdff51e8344$var$se, this.pagehideHandler = function() {
            _this.activeLocks.forEach(function(e) {
                return _this.lock.releaseLock(e);
            }), _this.activeLocks.clear();
        };
    }
    (0, $9MqXK._)(ue, [
        {
            key: "runWithLock",
            value: function runWithLock(e, t, n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var o, _$n;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                o = !1;
                                _$n = 0;
                                _state.label = 1;
                            case 1:
                                if (!(_$n < 10 && !o)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.lock.acquireLock(e, t)
                                ];
                            case 2:
                                o = _state.sent();
                                _state.label = 3;
                            case 3:
                                _$n++;
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                if (!o) throw new $65283fdff51e8344$export$66d311bf29d5c89c;
                                this.activeLocks.add(e), 1 === this.activeLocks.size && "undefined" != typeof window && window.addEventListener("pagehide", this.pagehideHandler);
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    ,
                                    7,
                                    9
                                ]);
                                return [
                                    4,
                                    n()
                                ];
                            case 6:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 7:
                                this.activeLocks.delete(e);
                                return [
                                    4,
                                    this.lock.releaseLock(e)
                                ];
                            case 8:
                                _state.sent(), 0 === this.activeLocks.size && "undefined" != typeof window && window.removeEventListener("pagehide", this.pagehideHandler);
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return ue;
}();
function $65283fdff51e8344$var$le() {
    var e;
    return "undefined" != typeof navigator && "function" == typeof (null === (e = navigator.locks) || void 0 === e ? void 0 : e.request) ? new $65283fdff51e8344$var$ce : new $65283fdff51e8344$var$ue;
}
var $65283fdff51e8344$var$he = null;
var $65283fdff51e8344$var$de = new TextEncoder, $65283fdff51e8344$var$pe = new TextDecoder;
function $65283fdff51e8344$var$fe(e) {
    return "string" == typeof e ? $65283fdff51e8344$var$de.encode(e) : $65283fdff51e8344$var$pe.decode(e);
}
function $65283fdff51e8344$var$me(e) {
    if ("number" != typeof e.modulusLength || e.modulusLength < 2048) throw new $65283fdff51e8344$var$be("".concat(e.name, " modulusLength must be at least 2048 bits"));
}
function $65283fdff51e8344$var$ye(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var o, _, _1;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!1 === n.usages.includes("sign")) throw new TypeError('private CryptoKey instances used for signing assertions must include "sign" in their "usages"');
                    o = "".concat($65283fdff51e8344$var$ge($65283fdff51e8344$var$fe(JSON.stringify(e))), ".").concat($65283fdff51e8344$var$ge($65283fdff51e8344$var$fe(JSON.stringify(t))));
                    _1 = (_ = "".concat(o, ".")).concat;
                    return [
                        4,
                        crypto.subtle.sign(function(e) {
                            switch(e.algorithm.name){
                                case "ECDSA":
                                    return {
                                        name: e.algorithm.name,
                                        hash: "SHA-256"
                                    };
                                case "RSA-PSS":
                                    return $65283fdff51e8344$var$me(e.algorithm), {
                                        name: e.algorithm.name,
                                        saltLength: 32
                                    };
                                case "RSASSA-PKCS1-v1_5":
                                    return $65283fdff51e8344$var$me(e.algorithm), {
                                        name: e.algorithm.name
                                    };
                                case "Ed25519":
                                    return {
                                        name: e.algorithm.name
                                    };
                            }
                            throw new $65283fdff51e8344$var$ve;
                        }(n), n, $65283fdff51e8344$var$fe(o))
                    ];
                case 1:
                    return [
                        2,
                        _1.apply(_, [
                            $65283fdff51e8344$var$ge.apply(void 0, [
                                _state.sent()
                            ])
                        ])
                    ];
            }
        });
    })();
}
var $65283fdff51e8344$var$we;
if (Uint8Array.prototype.toBase64) $65283fdff51e8344$var$we = function(e) {
    return e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({
        alphabet: "base64url",
        omitPadding: !0
    });
};
else {
    var $65283fdff51e8344$var$e1 = 32768;
    $65283fdff51e8344$var$we = function(t) {
        t instanceof ArrayBuffer && (t = new Uint8Array(t));
        var n = [];
        for(var o = 0; o < t.byteLength; o += $65283fdff51e8344$var$e1)n.push(String.fromCharCode.apply(null, t.subarray(o, o + $65283fdff51e8344$var$e1)));
        return btoa(n.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
}
function $65283fdff51e8344$var$ge(e) {
    return $65283fdff51e8344$var$we(e);
}
var $65283fdff51e8344$var$ve = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(ve, Error1);
    function ve(e) {
        (0, $5Epmf._)(this, ve);
        var _this;
        var t;
        _this = (0, $48Z0s._)(this, ve, [
            null != e ? e : "operation not supported"
        ]), _this.name = _this.constructor.name, null === (t = Error.captureStackTrace) || void 0 === t || t.call(Error, _this, _this.constructor);
        return _this;
    }
    return ve;
}((0, $kW1tL._)(Error));
var $65283fdff51e8344$var$be = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(be, Error1);
    function be(e) {
        (0, $5Epmf._)(this, be);
        var _this;
        var t;
        _this = (0, $48Z0s._)(this, be, [
            e
        ]), _this.name = _this.constructor.name, null === (t = Error.captureStackTrace) || void 0 === t || t.call(Error, _this, _this.constructor);
        return _this;
    }
    return be;
}((0, $kW1tL._)(Error));
function $65283fdff51e8344$var$ke(e) {
    switch(e.algorithm.name){
        case "RSA-PSS":
            return function(e) {
                if ("SHA-256" === e.algorithm.hash.name) return "PS256";
                throw new $65283fdff51e8344$var$ve("unsupported RsaHashedKeyAlgorithm hash name");
            }(e);
        case "RSASSA-PKCS1-v1_5":
            return function(e) {
                if ("SHA-256" === e.algorithm.hash.name) return "RS256";
                throw new $65283fdff51e8344$var$ve("unsupported RsaHashedKeyAlgorithm hash name");
            }(e);
        case "ECDSA":
            return function(e) {
                if ("P-256" === e.algorithm.namedCurve) return "ES256";
                throw new $65283fdff51e8344$var$ve("unsupported EcKeyAlgorithm namedCurve");
            }(e);
        case "Ed25519":
            return "Ed25519";
        default:
            throw new $65283fdff51e8344$var$ve("unsupported CryptoKey algorithm name");
    }
}
function $65283fdff51e8344$var$_e(e) {
    return e instanceof CryptoKey;
}
function $65283fdff51e8344$var$Se(e) {
    return $65283fdff51e8344$var$_e(e) && "public" === e.type;
}
function $65283fdff51e8344$var$Te(e, t, n, o, i, r) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var a, s, c, _tmp, _tmp1, _, _tmp2, _tmp3, _tmp4;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    a = null == e ? void 0 : e.privateKey, s = null == e ? void 0 : e.publicKey;
                    if (!$65283fdff51e8344$var$_e(c = a) || "private" !== c.type) throw new TypeError('"keypair.privateKey" must be a private CryptoKey');
                    if (!$65283fdff51e8344$var$Se(s)) throw new TypeError('"keypair.publicKey" must be a public CryptoKey');
                    if (!0 !== s.extractable) throw new TypeError('"keypair.publicKey.extractable" must be true');
                    if ("string" != typeof t) throw new TypeError('"htu" must be a string');
                    if ("string" != typeof n) throw new TypeError('"htm" must be a string');
                    if (void 0 !== o && "string" != typeof o) throw new TypeError('"nonce" must be a string or undefined');
                    if (void 0 !== i && "string" != typeof i) throw new TypeError('"accessToken" must be a string or undefined');
                    if (void 0 !== r && ("object" != (typeof r === "undefined" ? "undefined" : (0, $03bAP._)(r)) || null === r || Array.isArray(r))) throw new TypeError('"additional" must be an object');
                    _tmp = {
                        alg: $65283fdff51e8344$var$ke(a),
                        typ: "dpop+jwt"
                    };
                    return [
                        4,
                        $65283fdff51e8344$var$Pe(s)
                    ];
                case 1:
                    _tmp1 = [
                        (_tmp.jwk = _state.sent(), _tmp)
                    ];
                    _ = Object.assign;
                    _tmp2 = [
                        Object.assign({}, r)
                    ];
                    _tmp3 = {
                        iat: Math.floor(Date.now() / 1e3),
                        jti: crypto.randomUUID(),
                        htm: n,
                        nonce: o,
                        htu: t
                    };
                    if (!i) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        crypto.subtle.digest("SHA-256", $65283fdff51e8344$var$fe(i))
                    ];
                case 2:
                    _tmp4 = $65283fdff51e8344$var$ge.apply(void 0, [
                        _state.sent()
                    ]);
                    return [
                        3,
                        4
                    ];
                case 3:
                    _tmp4 = void 0;
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        $65283fdff51e8344$var$ye.apply(void 0, _tmp1.concat([
                            _.apply(Object, _tmp2.concat([
                                (_tmp3.ath = _tmp4, _tmp3)
                            ])),
                            a
                        ]))
                    ];
            }
        });
    })();
}
function $65283fdff51e8344$var$Pe(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _ref, t, n, o, i, r, a;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        crypto.subtle.exportKey("jwk", e)
                    ];
                case 1:
                    _ref = _state.sent(), t = _ref.kty, n = _ref.e, o = _ref.n, i = _ref.x, r = _ref.y, a = _ref.crv;
                    return [
                        2,
                        {
                            kty: t,
                            crv: a,
                            e: n,
                            n: o,
                            x: i,
                            y: r
                        }
                    ];
            }
        });
    })();
}
var $65283fdff51e8344$var$Ee = "dpop-nonce", $65283fdff51e8344$var$Ae = [
    "authorization_code",
    "refresh_token",
    "urn:ietf:params:oauth:grant-type:token-exchange",
    "urn:okta:params:oauth:grant-type:webauthn",
    "http://auth0.com/oauth/grant-type/mfa-oob",
    "http://auth0.com/oauth/grant-type/mfa-otp",
    "http://auth0.com/oauth/grant-type/mfa-recovery-code"
];
function $65283fdff51e8344$var$Ie() {
    return function(e, t) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var n, o;
            return (0, $3SMYb._)(this, function(_state) {
                if ("string" != typeof e || 0 === e.length) throw new TypeError('"alg" must be a non-empty string');
                switch(e){
                    case "PS256":
                        o = {
                            name: "RSA-PSS",
                            hash: "SHA-256",
                            modulusLength: 2048,
                            publicExponent: new Uint8Array([
                                1,
                                0,
                                1
                            ])
                        };
                        break;
                    case "RS256":
                        o = {
                            name: "RSASSA-PKCS1-v1_5",
                            hash: "SHA-256",
                            modulusLength: 2048,
                            publicExponent: new Uint8Array([
                                1,
                                0,
                                1
                            ])
                        };
                        break;
                    case "ES256":
                        o = {
                            name: "ECDSA",
                            namedCurve: "P-256"
                        };
                        break;
                    case "Ed25519":
                        o = {
                            name: "Ed25519"
                        };
                        break;
                    default:
                        throw new $65283fdff51e8344$var$ve;
                }
                return [
                    2,
                    crypto.subtle.generateKey(o, null !== (n = null == t ? void 0 : t.extractable) && void 0 !== n && n, [
                        "sign",
                        "verify"
                    ])
                ];
            });
        })();
    }("ES256", {
        extractable: !1
    });
}
function $65283fdff51e8344$var$xe(e) {
    return function(e) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var t, n;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!$65283fdff51e8344$var$Se(e)) throw new TypeError('"publicKey" must be a public CryptoKey');
                        if (!0 !== e.extractable) throw new TypeError('"publicKey.extractable" must be true');
                        return [
                            4,
                            $65283fdff51e8344$var$Pe(e)
                        ];
                    case 1:
                        t = _state.sent();
                        switch(t.kty){
                            case "EC":
                                n = {
                                    crv: t.crv,
                                    kty: t.kty,
                                    x: t.x,
                                    y: t.y
                                };
                                break;
                            case "OKP":
                                n = {
                                    crv: t.crv,
                                    kty: t.kty,
                                    x: t.x
                                };
                                break;
                            case "RSA":
                                n = {
                                    e: t.e,
                                    kty: t.kty,
                                    n: t.n
                                };
                                break;
                            default:
                                throw new $65283fdff51e8344$var$ve("unsupported JWK kty");
                        }
                        return [
                            4,
                            crypto.subtle.digest({
                                name: "SHA-256"
                            }, $65283fdff51e8344$var$fe(JSON.stringify(n)))
                        ];
                    case 2:
                        return [
                            2,
                            $65283fdff51e8344$var$ge.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        })();
    }(e.publicKey);
}
function $65283fdff51e8344$var$Re(e) {
    var t = e.keyPair, n = e.url, o = e.method, i = e.nonce, r = e.accessToken;
    var a = function(e) {
        var t = new URL(e);
        return t.search = "", t.hash = "", t.href;
    }(n);
    return $65283fdff51e8344$var$Te(t, a, o, i, r);
}
var $65283fdff51e8344$var$Oe = function(e, t) {
    return new Promise(function(n, o) {
        var i = new MessageChannel;
        i.port1.onmessage = function(e) {
            e.data.error ? o(new Error(e.data.error)) : n(e.data), i.port1.close();
        }, t.postMessage(e, [
            i.port2
        ]);
    });
}, $65283fdff51e8344$var$Ce = function(e, t, n) {
    var o = new AbortController;
    var i;
    return t.signal = o.signal, Promise.race([
        fetch(e, t),
        new Promise(function(e, t) {
            i = setTimeout(function() {
                o.abort(), t(new Error("Timeout when executing 'fetch'"));
            }, n);
        })
    ]).finally(function() {
        clearTimeout(i);
    });
}, $65283fdff51e8344$var$We = function We(_0, _1, _2, _3, _4, _5) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(e, t, n, o, i, r) {
        var a;
        var _arguments = arguments;
        return (0, $3SMYb._)(this, function(_state) {
            a = _arguments.length > 6 && void 0 !== _arguments[6] ? _arguments[6] : $65283fdff51e8344$var$b;
            return [
                2,
                i ? function(e, t, n, o, i, r, a, s, c, u) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        return (0, $3SMYb._)(this, function(_state) {
                            return [
                                2,
                                $65283fdff51e8344$var$Oe({
                                    type: "refresh",
                                    auth: {
                                        audience: t,
                                        scope: n
                                    },
                                    timeout: i,
                                    fetchUrl: e,
                                    fetchOptions: o,
                                    useFormData: a,
                                    useMrrt: s,
                                    skipTokenStorage: c,
                                    preserveRefreshToken: u
                                }, r)
                            ];
                        });
                    })();
                }(e, t, n, o, a, i, r, _arguments.length > 7 ? _arguments[7] : void 0, _arguments.length > 8 ? _arguments[8] : void 0, _arguments.length > 9 ? _arguments[9] : void 0) : function(e, t, n) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        var _$o, _$i, _tmp;
                        return (0, $3SMYb._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        $65283fdff51e8344$var$Ce(e, t, n)
                                    ];
                                case 1:
                                    _$o = _state.sent();
                                    _tmp = {
                                        ok: _$o.ok
                                    };
                                    return [
                                        4,
                                        _$o.json()
                                    ];
                                case 2:
                                    return [
                                        2,
                                        (_tmp.json = _state.sent(), _tmp.headers = (_$i = _$o.headers, (0, $XnYkK._)(_$i).reduce(function(e, t) {
                                            var _$n = $65283fdff51e8344$var$y(t, 2), _$o = _$n[0], _$i = _$n[1];
                                            return e[_$o] = _$i, e;
                                        }, {})), _tmp)
                                    ];
                            }
                        });
                    })();
                }(e, o, a)
            ];
        });
    }).apply(this, arguments);
};
function $65283fdff51e8344$var$je(t, n, o, i, r, a, s, c, u, l, h, d) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _$e, _, _tmp, p, f, _$e1, e1, m, y, w, _$g, v, b, k, _1, _tmp1, _tmp2, _$e2;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!u) return [
                        3,
                        3
                    ];
                    _ = u.generateProof;
                    _tmp = {
                        url: t,
                        method: r.method || "GET"
                    };
                    return [
                        4,
                        u.getNonce()
                    ];
                case 1:
                    return [
                        4,
                        _.apply(u, [
                            (_tmp.nonce = _state.sent(), _tmp)
                        ])
                    ];
                case 2:
                    _$e = _state.sent();
                    r.headers = Object.assign(Object.assign({}, r.headers), {
                        dpop: _$e
                    });
                    _state.label = 3;
                case 3:
                    f = null;
                    _$e1 = 0;
                    _state.label = 4;
                case 4:
                    if (!(_$e1 < 3)) return [
                        3,
                        9
                    ];
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        8
                    ]);
                    return [
                        4,
                        $65283fdff51e8344$var$We(t, o, i, r, a, s, n, c, h, d)
                    ];
                case 6:
                    p = _state.sent(), f = null;
                    return [
                        3,
                        9
                    ];
                case 7:
                    e1 = _state.sent();
                    f = e1;
                    return [
                        3,
                        8
                    ];
                case 8:
                    _$e1++;
                    return [
                        3,
                        4
                    ];
                case 9:
                    if (f) throw f;
                    m = p.json, y = m.error, w = m.error_description, _$g = $65283fdff51e8344$var$e(m, [
                        "error",
                        "error_description"
                    ]), v = p, b = v.headers, k = v.ok;
                    _tmp1 = u;
                    if (!_tmp1) return [
                        3,
                        12
                    ];
                    _1 = b[$65283fdff51e8344$var$Ee];
                    _tmp2 = _1;
                    if (!_tmp2) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        u.setNonce(_1)
                    ];
                case 10:
                    _tmp2 = _state.sent();
                    _state.label = 11;
                case 11:
                    _tmp1 = _tmp2;
                    _state.label = 12;
                case 12:
                    if (_tmp1, !k) {
                        _$e2 = w || "HTTP error. Unable to fetch ".concat(t);
                        if ("mfa_required" === y) throw new $65283fdff51e8344$export$c59494f4dae44ada(y, _$e2, _$g.mfa_token, _$g.mfa_requirements);
                        if ("missing_refresh_token" === y) throw new $65283fdff51e8344$export$ac1d2a00f8e0a046(o, i);
                        if ("use_dpop_nonce" === y) {
                            if (!u || !_1 || l) throw new $65283fdff51e8344$export$ffb710231177fce3(_1);
                            return [
                                2,
                                $65283fdff51e8344$var$je(t, n, o, i, r, a, s, c, u, !0, h, d)
                            ];
                        }
                        throw new $65283fdff51e8344$export$7d465be8efa67280(y || "request_error", _$e2);
                    }
                    return [
                        2,
                        _$g
                    ];
            }
        });
    })();
}
function $65283fdff51e8344$var$Ke(t, n, o) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var i, r, a, s, c, u, l, h, _$d, p, f, m, y, w, _$g, v, b, k, _;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = t.baseUrl, r = t.timeout, a = t.audience, s = t.scope, c = t.auth0Client, u = t.useFormData, l = t.useMrrt, h = t.dpop, _$d = t.preserveRefreshToken, p = $65283fdff51e8344$var$e(t, [
                        "baseUrl",
                        "timeout",
                        "audience",
                        "scope",
                        "auth0Client",
                        "useFormData",
                        "useMrrt",
                        "dpop",
                        "preserveRefreshToken"
                    ]);
                    f = "urn:ietf:params:oauth:grant-type:token-exchange" === p.grant_type, m = "urn:okta:params:oauth:grant-type:webauthn" === p.grant_type, y = "refresh_token" === p.grant_type && l, w = f || m || y, _$g = Object.assign(Object.assign(Object.assign({}, p), w && a && {
                        audience: a
                    }), w && s && {
                        scope: s
                    }), v = m || !u, b = v ? JSON.stringify(_$g) : $65283fdff51e8344$var$Z(_$g), k = (_ = p.grant_type, $65283fdff51e8344$var$Ae.includes(_));
                    return [
                        4,
                        $65283fdff51e8344$var$je("".concat(i, "/oauth/token"), r, a || $65283fdff51e8344$var$P, s, {
                            method: "POST",
                            body: b,
                            headers: {
                                "Content-Type": v ? "application/json" : "application/x-www-form-urlencoded",
                                "Auth0-Client": btoa(JSON.stringify($65283fdff51e8344$var$H(c || $65283fdff51e8344$var$S)))
                            }
                        }, n, u, l, k ? h : void 0, void 0, o, _$d)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}
var $65283fdff51e8344$var$Ue = function Ue() {
    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
    var o;
    return (o = t.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(o))).join(" ");
}, $65283fdff51e8344$var$Ne = function(e, t, n) {
    var o;
    return n && (o = e[n]), o || (o = e[$65283fdff51e8344$var$P]), $65283fdff51e8344$var$Ue(o, t);
}, $65283fdff51e8344$var$Le = "@@auth0spajs@@", $65283fdff51e8344$var$Me = "@@user@@";
var $65283fdff51e8344$var$ze = /*#__PURE__*/ function() {
    "use strict";
    function ze(e) {
        (0, $5Epmf._)(this, ze);
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $65283fdff51e8344$var$Le, n = arguments.length > 2 ? arguments[2] : void 0;
        this.prefix = t, this.suffix = n, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
    }
    (0, $9MqXK._)(ze, [
        {
            key: "toKey",
            value: function toKey() {
                return [
                    this.prefix,
                    this.clientId,
                    this.audience,
                    this.scope,
                    this.suffix
                ].filter(Boolean).join("::");
            }
        }
    ], [
        {
            key: "fromKey",
            value: function fromKey(e) {
                var t = $65283fdff51e8344$var$y(e.split("::"), 4), n = t[0], o = t[1], i = t[2], r = t[3];
                return new ze({
                    clientId: o,
                    scope: r,
                    audience: i
                }, n);
            }
        },
        {
            key: "fromCacheEntry",
            value: function fromCacheEntry(e) {
                var t = e.scope, n = e.audience, o = e.client_id;
                return new ze({
                    scope: t,
                    audience: n,
                    clientId: o
                });
            }
        }
    ]);
    return ze;
}();
var $65283fdff51e8344$export$40ef2cb682e70737 = /*#__PURE__*/ function() {
    "use strict";
    function De() {
        (0, $5Epmf._)(this, De);
    }
    (0, $9MqXK._)(De, [
        {
            key: "set",
            value: function set(e, t) {
                localStorage.setItem(e, JSON.stringify(t));
            }
        },
        {
            key: "get",
            value: function get(e) {
                var t = window.localStorage.getItem(e);
                if (t) try {
                    return JSON.parse(t);
                } catch (e) {
                    return;
                }
            }
        },
        {
            key: "remove",
            value: function remove(e) {
                localStorage.removeItem(e);
            }
        },
        {
            key: "allKeys",
            value: function allKeys() {
                return Object.keys(window.localStorage).filter(function(e) {
                    return e.startsWith($65283fdff51e8344$var$Le);
                });
            }
        }
    ]);
    return De;
}();
var $65283fdff51e8344$export$467265324939f47f = function Je() {
    "use strict";
    (0, $5Epmf._)(this, Je);
    this.enclosedCache = function() {
        var e = {};
        return {
            set: function(t, n) {
                e[t] = n;
            },
            get: function(t) {
                var n = e[t];
                if (n) return n;
            },
            remove: function(t) {
                delete e[t];
            },
            allKeys: function() {
                return Object.keys(e);
            }
        };
    }();
};
var $65283fdff51e8344$var$He = /*#__PURE__*/ function() {
    "use strict";
    function He(e, t, n) {
        (0, $5Epmf._)(this, He);
        this.cache = e, this.keyManifest = t, this.nowProvider = n || $65283fdff51e8344$var$T;
    }
    (0, $9MqXK._)(He, [
        {
            key: "setIdToken",
            value: function setIdToken(e, t, n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var o, i;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                i = this.getIdTokenCacheKey(e);
                                return [
                                    4,
                                    this.cache.set(i, {
                                        id_token: t,
                                        decodedToken: n
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    null === (o = this.keyManifest) || void 0 === o ? void 0 : o.add(i)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getIdToken",
            value: function getIdToken(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, t1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.cache.get(this.getIdTokenCacheKey(e.clientId))
                                ];
                            case 1:
                                t = _state.sent();
                                if (!(!t && e.scope && e.audience)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this.get(e)
                                ];
                            case 2:
                                t1 = _state.sent();
                                if (!t1) return [
                                    2
                                ];
                                if (!t1.id_token || !t1.decodedToken) return [
                                    2
                                ];
                                return [
                                    2,
                                    {
                                        id_token: t1.id_token,
                                        decodedToken: t1.decodedToken
                                    }
                                ];
                            case 3:
                                if (t) return [
                                    2,
                                    {
                                        id_token: t.id_token,
                                        decodedToken: t.decodedToken
                                    }
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "get",
            value: function get(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(e) {
                    var t, n, o, i, r, a, t1, i1, _tmp, s, c, _tmp1, _tmp2;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = _arguments.length > 1 && void 0 !== _arguments[1] ? _arguments[1] : 0, n = _arguments.length > 2 && void 0 !== _arguments[2] && _arguments[2], o = _arguments.length > 3 ? _arguments[3] : void 0;
                                return [
                                    4,
                                    this.cache.get(e.toKey())
                                ];
                            case 1:
                                r = _state.sent(), a = e;
                                if (!!r) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    this.getCacheKeys()
                                ];
                            case 2:
                                t1 = _state.sent();
                                if (!t1) return [
                                    2
                                ];
                                i1 = this.matchExistingCacheKey(e, t1);
                                _tmp = i1;
                                if (!_tmp) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.cache.get(i1)
                                ];
                            case 3:
                                _tmp = (r = _state.sent(), a = $65283fdff51e8344$var$ze.fromKey(i1));
                                _state.label = 4;
                            case 4:
                                if (_tmp, !r && n && "cache-only" !== o) return [
                                    2,
                                    this.getEntryWithRefreshToken(e, t1)
                                ];
                                _state.label = 5;
                            case 5:
                                if (!r) return [
                                    2
                                ];
                                return [
                                    4,
                                    this.nowProvider()
                                ];
                            case 6:
                                s = _state.sent(), c = Math.floor(s / 1e3);
                                if (!(r.expiresAt - t < c)) return [
                                    3,
                                    11
                                ];
                                if (!r.body.refresh_token) return [
                                    3,
                                    7
                                ];
                                _tmp2 = this.modifiedCachedEntry(r, a);
                                return [
                                    3,
                                    10
                                ];
                            case 7:
                                return [
                                    4,
                                    this.cache.remove(a.toKey())
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    4,
                                    null === (i = this.keyManifest) || void 0 === i ? void 0 : i.remove(a.toKey())
                                ];
                            case 9:
                                _tmp2 = void _state.sent();
                                _state.label = 10;
                            case 10:
                                _tmp1 = _tmp2;
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                _tmp1 = r.body;
                                _state.label = 12;
                            case 12:
                                return [
                                    2,
                                    _tmp1
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "modifiedCachedEntry",
            value: function modifiedCachedEntry(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                n = {
                                    refresh_token: e.body.refresh_token,
                                    audience: e.body.audience,
                                    scope: e.body.scope
                                }, o = {
                                    body: n,
                                    expiresAt: e.expiresAt
                                };
                                return [
                                    4,
                                    this.cache.set(t.toKey(), o)
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), {
                                        refresh_token: n.refresh_token,
                                        audience: n.audience,
                                        scope: n.scope
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "set",
            value: function set(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                n = new $65283fdff51e8344$var$ze({
                                    clientId: e.client_id,
                                    scope: e.scope,
                                    audience: e.audience
                                });
                                return [
                                    4,
                                    this.wrapCacheEntry(e)
                                ];
                            case 1:
                                o = _state.sent();
                                return [
                                    4,
                                    this.cache.set(n.toKey(), o)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(n.toKey())
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "remove",
            value: function remove(e, t, n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var o;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                o = new $65283fdff51e8344$var$ze({
                                    clientId: e,
                                    scope: n,
                                    audience: t
                                });
                                return [
                                    4,
                                    this.cache.remove(o.toKey())
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "stripRefreshToken",
            value: function stripRefreshToken(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, o, n1, _tmp, err;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getCacheKeys()
                                ];
                            case 1:
                                n = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!n) return [
                                    3,
                                    11
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator = n[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    8
                                ];
                                o = _step.value;
                                return [
                                    4,
                                    this.cache.get(o)
                                ];
                            case 4:
                                n1 = _state.sent();
                                _tmp = (null === (t = null == n1 ? void 0 : n1.body) || void 0 === t ? void 0 : t.refresh_token) === e;
                                if (!_tmp) return [
                                    3,
                                    6
                                ];
                                delete n1.body.refresh_token;
                                return [
                                    4,
                                    this.cache.set(o, n1)
                                ];
                            case 5:
                                _tmp = _state.sent();
                                _state.label = 6;
                            case 6:
                                _tmp;
                                _state.label = 7;
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "clear",
            value: function clear(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _this, t, n, _tmp;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getCacheKeys()
                                ];
                            case 1:
                                n = _state.sent();
                                _tmp = n;
                                if (!_tmp) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    n.filter(function(t) {
                                        return !e || t.includes(e);
                                    }).reduce(function(e, t) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                            return (0, $3SMYb._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            e
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            4,
                                                            this.cache.remove(t)
                                                        ];
                                                    case 2:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    }, Promise.resolve())
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()
                                ];
                            case 3:
                                _tmp = _state.sent();
                                _state.label = 4;
                            case 4:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "wrapCacheEntry",
            value: function wrapCacheEntry(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.nowProvider()
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    2,
                                    {
                                        body: e,
                                        expiresAt: Math.floor(t / 1e3) + e.expires_in
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getCacheKeys",
            value: function getCacheKeys() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var e, _tmp, _;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.keyManifest) return [
                                    3,
                                    2
                                ];
                                _ = null;
                                return [
                                    4,
                                    this.keyManifest.get()
                                ];
                            case 1:
                                _tmp = _ === (e = _state.sent()) || void 0 === e ? void 0 : e.keys;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                _tmp = this.cache.allKeys ? this.cache.allKeys() : void 0;
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    _tmp
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getIdTokenCacheKey",
            value: function getIdTokenCacheKey(e) {
                return new $65283fdff51e8344$var$ze({
                    clientId: e
                }, $65283fdff51e8344$var$Le, $65283fdff51e8344$var$Me).toKey();
            }
        },
        {
            key: "matchExistingCacheKey",
            value: function matchExistingCacheKey(e, t) {
                return t.filter(function(t) {
                    var n;
                    var o = $65283fdff51e8344$var$ze.fromKey(t), i = new Set(o.scope && o.scope.split(" ")), r = (null === (n = e.scope) || void 0 === n ? void 0 : n.split(" ")) || [], a = o.scope && r.reduce(function(e, t) {
                        return e && i.has(t);
                    }, !0);
                    return o.prefix === $65283fdff51e8344$var$Le && o.clientId === e.clientId && o.audience === e.audience && a;
                })[0];
            }
        },
        {
            key: "getEntryWithRefreshToken",
            value: function getEntryWithRefreshToken(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, o, _$t, _$e, err;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = t[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                o = _step.value;
                                _$t = $65283fdff51e8344$var$ze.fromKey(o);
                                if (!(_$t.prefix === $65283fdff51e8344$var$Le && _$t.clientId === e.clientId)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.cache.get(o)
                                ];
                            case 3:
                                _$e = _state.sent();
                                if (null === (n = null == _$e ? void 0 : _$e.body) || void 0 === n ? void 0 : n.refresh_token) return [
                                    2,
                                    {
                                        refresh_token: _$e.body.refresh_token,
                                        audience: _$e.body.audience,
                                        scope: _$e.body.scope
                                    }
                                ];
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getRefreshTokensByAudience",
            value: function getRefreshTokensByAudience(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, r, o1, _$e, err;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getCacheKeys()
                                ];
                            case 1:
                                o = _state.sent();
                                if (!o) return [
                                    2,
                                    []
                                ];
                                i = new Set;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = o[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                r = _step.value;
                                o1 = $65283fdff51e8344$var$ze.fromKey(r);
                                if (!(o1.prefix === $65283fdff51e8344$var$Le && o1.clientId === t && o1.audience === e)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    this.cache.get(r)
                                ];
                            case 4:
                                _$e = _state.sent();
                                (null === (n = null == _$e ? void 0 : _$e.body) || void 0 === n ? void 0 : n.refresh_token) && i.add(_$e.body.refresh_token);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    Array.from(i)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "updateEntry",
            value: function updateEntry(_0, _1, _2) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(e, t, n) {
                    var o, i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, r, i1, a, _tmp, err;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                o = _arguments.length > 3 && void 0 !== _arguments[3] && _arguments[3];
                                return [
                                    4,
                                    this.getCacheKeys()
                                ];
                            case 1:
                                i = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!i) return [
                                    3,
                                    11
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator = i[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    8
                                ];
                                r = _step.value;
                                if ($65283fdff51e8344$var$ze.fromKey(r).clientId !== n) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    this.cache.get(r)
                                ];
                            case 4:
                                i1 = _state.sent();
                                if (!(null == i1 ? void 0 : i1.body)) return [
                                    3,
                                    7
                                ];
                                a = i1.body.refresh_token;
                                _tmp = a && (o || a === e);
                                if (!_tmp) return [
                                    3,
                                    6
                                ];
                                i1.body.refresh_token = t;
                                return [
                                    4,
                                    this.cache.set(r, i1)
                                ];
                            case 5:
                                _tmp = _state.sent();
                                _state.label = 6;
                            case 6:
                                _tmp;
                                _state.label = 7;
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return He;
}();
var $65283fdff51e8344$var$Ze = /*#__PURE__*/ function() {
    "use strict";
    function Ze(e, t, n) {
        (0, $5Epmf._)(this, Ze);
        this.storage = e, this.clientId = t, this.cookieDomain = n, this.storageKey = "".concat("a0.spajs.txs", ".").concat(this.clientId);
    }
    (0, $9MqXK._)(Ze, [
        {
            key: "create",
            value: function create(e) {
                this.storage.save(this.storageKey, e, {
                    daysUntilExpire: 1,
                    cookieDomain: this.cookieDomain
                });
            }
        },
        {
            key: "get",
            value: function get() {
                return this.storage.get(this.storageKey);
            }
        },
        {
            key: "remove",
            value: function remove() {
                this.storage.remove(this.storageKey, {
                    cookieDomain: this.cookieDomain
                });
            }
        }
    ]);
    return Ze;
}();
var $65283fdff51e8344$var$Fe = function(e) {
    return "number" == typeof e;
}, $65283fdff51e8344$var$Ve = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], $65283fdff51e8344$var$Xe = function(e) {
    if (!e.id_token) throw new Error("ID token is required but missing");
    var t = function(e) {
        var t = e.split("."), n = $65283fdff51e8344$var$y(t, 3), o = n[0], i = n[1], r = n[2];
        if (3 !== t.length || !o || !i || !r) throw new Error("ID token could not be decoded");
        var a = JSON.parse($65283fdff51e8344$var$V(i)), s = {
            __raw: e
        }, c = {};
        return Object.keys(a).forEach(function(e) {
            s[e] = a[e], $65283fdff51e8344$var$Ve.includes(e) || (c[e] = a[e]);
        }), {
            encoded: {
                header: o,
                payload: i,
                signature: r
            },
            header: JSON.parse($65283fdff51e8344$var$V(o)),
            claims: s,
            user: c
        };
    }(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error('Issuer (iss) claim mismatch in the ID token; expected "'.concat(e.iss, '", found "').concat(t.claims.iss, '"'));
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error('Signature algorithm of "'.concat(t.header.alg, '" is not supported. Expected the ID token to be signed with "RS256".'));
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but was not one of "').concat(t.claims.aud.join(", "), '"'));
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error('Authorized Party (azp) claim mismatch in the ID token; expected "'.concat(e.aud, '", found "').concat(t.claims.azp, '"'));
        }
    } else if (t.claims.aud !== e.aud) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but found "').concat(t.claims.aud, '"'));
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error('Nonce (nonce) claim mismatch in the ID token; expected "'.concat(e.nonce, '", found "').concat(t.claims.nonce, '"'));
    }
    if (e.max_age && !$65283fdff51e8344$var$Fe(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !$65283fdff51e8344$var$Fe(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!$65283fdff51e8344$var$Fe(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    var n = e.leeway || 60, o = new Date(e.now || Date.now()), i = new Date(0);
    if (i.setUTCSeconds(t.claims.exp + n), o > i) throw new Error("Expiration Time (exp) claim error in the ID token; current time (".concat(o, ") is after expiration time (").concat(i, ")"));
    if (null != t.claims.nbf && $65283fdff51e8344$var$Fe(t.claims.nbf)) {
        var _$e = new Date(0);
        if (_$e.setUTCSeconds(t.claims.nbf - n), o < _$e) throw new Error("Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (".concat(o, ") is before ").concat(_$e));
    }
    if (null != t.claims.auth_time && $65283fdff51e8344$var$Fe(t.claims.auth_time)) {
        var i1 = new Date(0);
        if (i1.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + n), o > i1) throw new Error("Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (".concat(o, ") is after last auth at ").concat(i1));
    }
    if (e.organization) {
        var n1 = e.organization.trim();
        if (n1.startsWith("org_")) {
            var _$e1 = n1;
            if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
            if (_$e1 !== t.claims.org_id) throw new Error('Organization ID (org_id) claim mismatch in the ID token; expected "'.concat(_$e1, '", found "').concat(t.claims.org_id, '"'));
        } else {
            var _$e2 = n1.toLowerCase();
            if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
            if (_$e2 !== t.claims.org_name) throw new Error('Organization Name (org_name) claim mismatch in the ID token; expected "'.concat(_$e2, '", found "').concat(t.claims.org_name, '"'));
        }
    }
    return t;
};
var $65283fdff51e8344$var$Ge = $65283fdff51e8344$var$G && $65283fdff51e8344$var$G.__assign || function() {
    return $65283fdff51e8344$var$Ge = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e;
    }, $65283fdff51e8344$var$Ge.apply(this, arguments);
};
function $65283fdff51e8344$var$Ye(e, t) {
    if (!t) return "";
    var n = "; " + e;
    return !0 === t ? n : n + "=" + t;
}
function $65283fdff51e8344$var$Be(e, t, n) {
    return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
        if ("number" == typeof e.expires) {
            var _$t = new Date;
            _$t.setMilliseconds(_$t.getMilliseconds() + 864e5 * e.expires), e.expires = _$t;
        }
        return $65283fdff51e8344$var$Ye("Expires", e.expires ? e.expires.toUTCString() : "") + $65283fdff51e8344$var$Ye("Domain", e.domain) + $65283fdff51e8344$var$Ye("Path", e.path) + $65283fdff51e8344$var$Ye("Secure", e.secure) + $65283fdff51e8344$var$Ye("SameSite", e.sameSite);
    }(n);
}
function $65283fdff51e8344$var$qe() {
    return function(e) {
        for(var t = {}, n = e ? e.split("; ") : [], o = /(%[\dA-F]{2})+/gi, i = 0; i < n.length; i++){
            var r = n[i].split("="), a = r.slice(1).join("=");
            '"' === a.charAt(0) && (a = a.slice(1, -1));
            try {
                t[r[0].replace(o, decodeURIComponent)] = a.replace(o, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }(document.cookie);
}
var $65283fdff51e8344$var$Qe = function Qe(e) {
    return $65283fdff51e8344$var$qe()[e];
};
function $65283fdff51e8344$var$$e(e, t, n) {
    document.cookie = $65283fdff51e8344$var$Be(e, t, $65283fdff51e8344$var$Ge({
        path: "/"
    }, n));
}
var $65283fdff51e8344$var$et = $65283fdff51e8344$var$$e;
var $65283fdff51e8344$var$tt = function tt(e, t) {
    $65283fdff51e8344$var$$e(e, "", $65283fdff51e8344$var$Ge($65283fdff51e8344$var$Ge({}, t), {
        expires: -1
    }));
};
var $65283fdff51e8344$var$nt = {
    get: function(e) {
        var t = $65283fdff51e8344$var$Qe(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save: function(e, t, n) {
        var o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0,
            sameSite: "none"
        }), (null == n ? void 0 : n.daysUntilExpire) && (o.expires = n.daysUntilExpire), (null == n ? void 0 : n.cookieDomain) && (o.domain = n.cookieDomain), $65283fdff51e8344$var$et(e, JSON.stringify(t), o);
    },
    remove: function(e, t) {
        var n = {};
        (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), $65283fdff51e8344$var$tt(e, n);
    }
}, $65283fdff51e8344$var$ot = "_legacy_", $65283fdff51e8344$var$it = {
    get: function(e) {
        var t = $65283fdff51e8344$var$nt.get(e);
        return t || $65283fdff51e8344$var$nt.get("".concat($65283fdff51e8344$var$ot).concat(e));
    },
    save: function(e, t, n) {
        var o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0
        }), (null == n ? void 0 : n.daysUntilExpire) && (o.expires = n.daysUntilExpire), (null == n ? void 0 : n.cookieDomain) && (o.domain = n.cookieDomain), $65283fdff51e8344$var$et("".concat($65283fdff51e8344$var$ot).concat(e), JSON.stringify(t), o), $65283fdff51e8344$var$nt.save(e, t, n);
    },
    remove: function(e, t) {
        var n = {};
        (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), $65283fdff51e8344$var$tt(e, n), $65283fdff51e8344$var$nt.remove(e, t), $65283fdff51e8344$var$nt.remove("".concat($65283fdff51e8344$var$ot).concat(e), t);
    }
}, $65283fdff51e8344$var$rt = {
    get: function(e) {
        if ("undefined" == typeof sessionStorage) return;
        var t = sessionStorage.getItem(e);
        return null != t ? JSON.parse(t) : void 0;
    },
    save: function(e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove: function(e) {
        sessionStorage.removeItem(e);
    }
}, $65283fdff51e8344$export$e25248c67d4c0e61 = {
    Offline: "offline",
    Online: "online"
};
var $65283fdff51e8344$export$7390b1e457b4cb6f;
!function(e) {
    e.Code = "code", e.ConnectCode = "connect_code";
}($65283fdff51e8344$export$7390b1e457b4cb6f || ($65283fdff51e8344$export$7390b1e457b4cb6f = {}));
var $65283fdff51e8344$export$1f44aaf2ec115b54 = function ct() {
    "use strict";
    (0, $5Epmf._)(this, ct);
};
function $65283fdff51e8344$var$ut(e, t, n) {
    var o = void 0 === t ? null : t, i = function(e, t) {
        var _$n = atob(e);
        if (t) {
            for(var o = new Uint8Array(_$n.length), i = 0, r = _$n.length; i < r; ++i)o[i] = _$n.charCodeAt(i);
            return String.fromCharCode.apply(null, new Uint16Array(o.buffer));
        }
        return _$n;
    }(e, void 0 !== n && n), r = i.indexOf("\n", 10) + 1, a = i.substring(r) + (o ? "//# sourceMappingURL=" + o : ""), s = new Blob([
        a
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(s);
}
var $65283fdff51e8344$var$lt, $65283fdff51e8344$var$ht, $65283fdff51e8344$var$dt, $65283fdff51e8344$var$pt, $65283fdff51e8344$var$ft = ($65283fdff51e8344$var$lt = "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", $65283fdff51e8344$var$ht = null, $65283fdff51e8344$var$dt = !1, function ft(e) {
    return $65283fdff51e8344$var$pt = $65283fdff51e8344$var$pt || $65283fdff51e8344$var$ut($65283fdff51e8344$var$lt, $65283fdff51e8344$var$ht, $65283fdff51e8344$var$dt), new Worker($65283fdff51e8344$var$pt, e);
});
var $65283fdff51e8344$var$mt = /*#__PURE__*/ function() {
    "use strict";
    function mt(e, t) {
        (0, $5Epmf._)(this, mt);
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
    (0, $9MqXK._)(mt, [
        {
            key: "add",
            value: function add(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, _, _1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = Set.bind;
                                _1 = null;
                                return [
                                    4,
                                    this.cache.get(this.manifestKey)
                                ];
                            case 1:
                                n = new (_.apply(Set, [
                                    void 0,
                                    (_1 === (t = _state.sent()) || void 0 === t ? void 0 : t.keys) || []
                                ]));
                                n.add(e);
                                return [
                                    4,
                                    this.cache.set(this.manifestKey, {
                                        keys: (0, $XnYkK._)(n)
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "remove",
            value: function remove(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, _tmp;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.cache.get(this.manifestKey)
                                ];
                            case 1:
                                t = _state.sent();
                                if (!t) return [
                                    3,
                                    6
                                ];
                                n = new Set(t.keys);
                                n.delete(e);
                                if (!(n.size > 0)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this.cache.set(this.manifestKey, {
                                        keys: (0, $XnYkK._)(n)
                                    })
                                ];
                            case 2:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    this.cache.remove(this.manifestKey)
                                ];
                            case 4:
                                _tmp = _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    _tmp
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "get",
            value: function get() {
                return this.cache.get(this.manifestKey);
            }
        },
        {
            key: "clear",
            value: function clear() {
                return this.cache.remove(this.manifestKey);
            }
        },
        {
            key: "createManifestKeyFrom",
            value: function createManifestKeyFrom(e) {
                return "".concat($65283fdff51e8344$var$Le, "::").concat(e);
            }
        }
    ]);
    return mt;
}();
var $65283fdff51e8344$var$yt = "auth0.is.authenticated", $65283fdff51e8344$var$wt = {
    memory: function() {
        return (new $65283fdff51e8344$export$467265324939f47f).enclosedCache;
    },
    localstorage: function() {
        return new $65283fdff51e8344$export$40ef2cb682e70737;
    }
}, $65283fdff51e8344$var$gt = function(e) {
    return $65283fdff51e8344$var$wt[e];
}, $65283fdff51e8344$var$vt = function(t) {
    var n = t.openUrl, o = t.onRedirect, i = $65283fdff51e8344$var$e(t, [
        "openUrl",
        "onRedirect"
    ]);
    return Object.assign(Object.assign({}, i), {
        openUrl: !1 === n || n ? n : o
    });
}, $65283fdff51e8344$var$bt = function(e, t, n) {
    var o = (null == e ? void 0 : e.split(" ")) || [], i = n ? o.filter(function(e) {
        return e !== $65283fdff51e8344$var$_;
    }) : o;
    var r = (null == t ? void 0 : t.split(" ")) || [];
    return i.filter(function(e) {
        return -1 == r.indexOf(e);
    }).join(",");
}, $65283fdff51e8344$var$kt = {
    NONCE: "nonce",
    KEYPAIR: "keypair"
};
var $65283fdff51e8344$var$_t = /*#__PURE__*/ function() {
    "use strict";
    function _t(e) {
        (0, $5Epmf._)(this, _t);
        this.clientId = e;
    }
    (0, $9MqXK._)(_t, [
        {
            key: "getVersion",
            value: function getVersion() {
                return 1;
            }
        },
        {
            key: "createDbHandle",
            value: function createDbHandle() {
                var e = window.indexedDB.open("auth0-spa-js", this.getVersion());
                return new Promise(function(t, n) {
                    e.onupgradeneeded = function() {
                        return Object.values($65283fdff51e8344$var$kt).forEach(function(t) {
                            return e.result.createObjectStore(t);
                        });
                    }, e.onerror = function() {
                        return n(e.error);
                    }, e.onsuccess = function() {
                        return t(e.result);
                    };
                });
            }
        },
        {
            key: "getDbHandle",
            value: function getDbHandle() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _tmp, _;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this.dbHandle;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                _ = this;
                                return [
                                    4,
                                    this.createDbHandle()
                                ];
                            case 1:
                                _tmp = _.dbHandle = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    (_tmp, this.dbHandle)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "executeDbRequest",
            value: function executeDbRequest(e, t, n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var o;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getDbHandle()
                                ];
                            case 1:
                                o = n.apply(void 0, [
                                    _state.sent().transaction(e, t).objectStore(e)
                                ]);
                                return [
                                    2,
                                    new Promise(function(e, t) {
                                        o.onsuccess = function() {
                                            return e(o.result);
                                        }, o.onerror = function() {
                                            return t(o.error);
                                        };
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "buildKey",
            value: function buildKey(e) {
                var t = e ? "_".concat(e) : "auth0";
                return "".concat(this.clientId, "::").concat(t);
            }
        },
        {
            key: "setNonce",
            value: function setNonce(e, t) {
                return this.save($65283fdff51e8344$var$kt.NONCE, this.buildKey(t), e);
            }
        },
        {
            key: "setKeyPair",
            value: function setKeyPair(e) {
                return this.save($65283fdff51e8344$var$kt.KEYPAIR, this.buildKey(), e);
            }
        },
        {
            key: "save",
            value: function save(e, t, n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.executeDbRequest(e, "readwrite", function(e) {
                                        return e.put(n, t);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "findNonce",
            value: function findNonce(e) {
                return this.find($65283fdff51e8344$var$kt.NONCE, this.buildKey(e));
            }
        },
        {
            key: "findKeyPair",
            value: function findKeyPair() {
                return this.find($65283fdff51e8344$var$kt.KEYPAIR, this.buildKey());
            }
        },
        {
            key: "find",
            value: function find(e, t) {
                return this.executeDbRequest(e, "readonly", function(e) {
                    return e.get(t);
                });
            }
        },
        {
            key: "deleteBy",
            value: function deleteBy(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _this, n;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.executeDbRequest(e, "readonly", function(e) {
                                        return e.getAllKeys();
                                    })
                                ];
                            case 1:
                                n = _state.sent();
                                return [
                                    4,
                                    Promise.all((null == n ? void 0 : n.filter(t).map(function(t) {
                                        return _this.executeDbRequest(e, "readwrite", function(e) {
                                            return e.delete(t);
                                        });
                                    })) || [])
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "deleteByClientId",
            value: function deleteByClientId(e, t) {
                return this.deleteBy(e, function(e) {
                    return "string" == typeof e && e.startsWith("".concat(t, "::"));
                });
            }
        },
        {
            key: "clearNonces",
            value: function clearNonces() {
                return this.deleteByClientId($65283fdff51e8344$var$kt.NONCE, this.clientId);
            }
        },
        {
            key: "clearKeyPairs",
            value: function clearKeyPairs() {
                return this.deleteByClientId($65283fdff51e8344$var$kt.KEYPAIR, this.clientId);
            }
        }
    ]);
    return _t;
}();
var $65283fdff51e8344$var$St = /*#__PURE__*/ function() {
    "use strict";
    function St(e) {
        (0, $5Epmf._)(this, St);
        this.storage = new $65283fdff51e8344$var$_t(e);
    }
    (0, $9MqXK._)(St, [
        {
            key: "getNonce",
            value: function getNonce(e) {
                return this.storage.findNonce(e);
            }
        },
        {
            key: "setNonce",
            value: function setNonce(e, t) {
                return this.storage.setNonce(e, t);
            }
        },
        {
            key: "getOrGenerateKeyPair",
            value: function getOrGenerateKeyPair() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var e, _tmp;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.storage.findKeyPair()
                                ];
                            case 1:
                                e = _state.sent();
                                _tmp = e;
                                if (_tmp) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    $65283fdff51e8344$var$Ie()
                                ];
                            case 2:
                                e = _state.sent();
                                return [
                                    4,
                                    this.storage.setKeyPair(e)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    (_tmp, e)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "generateProof",
            value: function generateProof(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getOrGenerateKeyPair()
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    2,
                                    $65283fdff51e8344$var$Re(Object.assign({
                                        keyPair: t
                                    }, e))
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "calculateThumbprint",
            value: function calculateThumbprint() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getOrGenerateKeyPair()
                                ];
                            case 1:
                                return [
                                    2,
                                    $65283fdff51e8344$var$xe.apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "clear",
            value: function clear() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all([
                                        this.storage.clearNonces(),
                                        this.storage.clearKeyPairs()
                                    ])
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return St;
}();
var $65283fdff51e8344$var$Tt;
!function(e) {
    e.Bearer = "Bearer", e.DPoP = "DPoP";
}($65283fdff51e8344$var$Tt || ($65283fdff51e8344$var$Tt = {}));
var $65283fdff51e8344$var$Pt = /*#__PURE__*/ function() {
    "use strict";
    function Pt(e, t) {
        (0, $5Epmf._)(this, Pt);
        this.hooks = t, this.config = Object.assign(Object.assign({}, e), {
            fetch: e.fetch || ("undefined" == typeof window ? fetch : window.fetch.bind(window))
        });
    }
    (0, $9MqXK._)(Pt, [
        {
            key: "isAbsoluteUrl",
            value: function isAbsoluteUrl(e) {
                return /^(https?:)?\/\//i.test(e);
            }
        },
        {
            key: "buildUrl",
            value: function buildUrl(e, t) {
                if (t) {
                    if (this.isAbsoluteUrl(t)) return t;
                    if (e) return "".concat(e.replace(/\/?\/$/, ""), "/").concat(t.replace(/^\/+/, ""));
                }
                throw new TypeError("`url` must be absolute or `baseUrl` non-empty.");
            }
        },
        {
            key: "getAccessToken",
            value: function getAccessToken(e) {
                return this.config.getAccessToken ? this.config.getAccessToken(e) : this.hooks.getAccessToken(e);
            }
        },
        {
            key: "extractUrl",
            value: function extractUrl(e) {
                return "string" == typeof e ? e : e instanceof URL ? e.href : e.url;
            }
        },
        {
            key: "buildBaseRequest",
            value: function buildBaseRequest(e, t) {
                if (!this.config.baseUrl) return new Request(e, t);
                var n = this.buildUrl(this.config.baseUrl, this.extractUrl(e)), o = e instanceof Request ? new Request(n, e) : n;
                return new Request(o, t);
            }
        },
        {
            key: "setAuthorizationHeader",
            value: function setAuthorizationHeader(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : $65283fdff51e8344$var$Tt.Bearer;
                e.headers.set("authorization", "".concat(n, " ").concat(t));
            }
        },
        {
            key: "setDpopProofHeader",
            value: function setDpopProofHeader(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.config.dpopNonceId) return [
                                    2
                                ];
                                return [
                                    4,
                                    this.hooks.getDpopNonce()
                                ];
                            case 1:
                                n = _state.sent();
                                return [
                                    4,
                                    this.hooks.generateDpopProof({
                                        accessToken: t,
                                        method: e.method,
                                        nonce: n,
                                        url: e.url
                                    })
                                ];
                            case 2:
                                o = _state.sent();
                                e.headers.set("dpop", o);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "prepareRequest",
            value: function prepareRequest(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, i, _tmp;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getAccessToken(t)
                                ];
                            case 1:
                                n = _state.sent();
                                "string" == typeof n ? (o = this.config.dpopNonceId ? $65283fdff51e8344$var$Tt.DPoP : $65283fdff51e8344$var$Tt.Bearer, i = n) : (o = n.token_type, i = n.access_token), this.setAuthorizationHeader(e, i, o);
                                _tmp = o === $65283fdff51e8344$var$Tt.DPoP;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this.setDpopProofHeader(e, i)
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getHeader",
            value: function getHeader(e, t) {
                return Array.isArray(e) ? new Headers(e).get(t) || "" : "function" == typeof e.get ? e.get(t) || "" : e[t] || "";
            }
        },
        {
            key: "hasUseDpopNonceError",
            value: function hasUseDpopNonceError(e) {
                if (401 !== e.status) return !1;
                var t = this.getHeader(e.headers, "www-authenticate");
                return t.includes("invalid_dpop_nonce") || t.includes("use_dpop_nonce");
            }
        },
        {
            key: "handleResponse",
            value: function handleResponse(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, _tmp;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                n = this.getHeader(e.headers, $65283fdff51e8344$var$Ee);
                                _tmp = n;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.hooks.setDpopNonce(n)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (_tmp, !this.hasUseDpopNonceError(e)) return [
                                    2,
                                    e
                                ];
                                if (!n || !t.onUseDpopNonceError) throw new $65283fdff51e8344$export$ffb710231177fce3(n);
                                return [
                                    2,
                                    t.onUseDpopNonceError()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "internalFetchWithAuth",
            value: function internalFetchWithAuth(e, t, n, o) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var i, r;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                i = this.buildBaseRequest(e, t);
                                return [
                                    4,
                                    this.prepareRequest(i, o)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this.config.fetch(i)
                                ];
                            case 2:
                                r = _state.sent();
                                return [
                                    2,
                                    this.handleResponse(r, n)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "fetchWithAuth",
            value: function fetchWithAuth(e, t, n) {
                var _this = this;
                var o = {
                    onUseDpopNonceError: function() {
                        return _this.internalFetchWithAuth(e, t, Object.assign(Object.assign({}, o), {
                            onUseDpopNonceError: void 0
                        }), n);
                    }
                };
                return this.internalFetchWithAuth(e, t, o, n);
            }
        }
    ]);
    return Pt;
}();
var $65283fdff51e8344$var$Et = /*#__PURE__*/ function() {
    "use strict";
    function Et(e, t) {
        (0, $5Epmf._)(this, Et);
        this.myAccountFetcher = e, this.apiBase = t;
    }
    (0, $9MqXK._)(Et, [
        {
            key: "connectAccount",
            value: function connectAccount(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/connected-accounts/connect"), {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(e)
                                    }, {
                                        scope: [
                                            "create:me:connected_accounts"
                                        ]
                                    })
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    2,
                                    this._handleResponse(t)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "completeAccount",
            value: function completeAccount(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/connected-accounts/complete"), {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(e)
                                    }, {
                                        scope: [
                                            "create:me:connected_accounts"
                                        ]
                                    })
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    2,
                                    this._handleResponse(t)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getFactors",
            value: function getFactors() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var e;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/factors"), {
                                        method: "GET"
                                    }, {
                                        scope: [
                                            "read:me:factors"
                                        ]
                                    })
                                ];
                            case 1:
                                e = _state.sent();
                                return [
                                    4,
                                    this._handleResponse(e)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent().factors
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getAuthenticationMethods",
            value: function getAuthenticationMethods(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = e ? "?".concat(new URLSearchParams({
                                    type: e
                                })) : "";
                                return [
                                    4,
                                    this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/authentication-methods").concat(t), {
                                        method: "GET"
                                    }, {
                                        scope: [
                                            "read:me:authentication_methods"
                                        ]
                                    })
                                ];
                            case 1:
                                n = _state.sent();
                                return [
                                    4,
                                    this._handleResponse(n)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent().authentication_methods
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getAuthenticationMethod",
            value: function getAuthenticationMethod(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/authentication-methods/").concat(encodeURIComponent(e)), {
                                        method: "GET"
                                    }, {
                                        scope: [
                                            "read:me:authentication_methods"
                                        ]
                                    })
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    2,
                                    this._handleResponse(t)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "deleteAuthenticationMethod",
            value: function deleteAuthenticationMethod(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, _tmp;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/authentication-methods/").concat(encodeURIComponent(e)), {
                                        method: "DELETE"
                                    }, {
                                        scope: [
                                            "delete:me:authentication_methods"
                                        ]
                                    })
                                ];
                            case 1:
                                t = _state.sent();
                                _tmp = t.ok;
                                if (_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._handleResponse(t)
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "updateAuthenticationMethod",
            value: function updateAuthenticationMethod(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/authentication-methods/").concat(encodeURIComponent(e)), {
                                        method: "PATCH",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(t)
                                    }, {
                                        scope: [
                                            "update:me:authentication_methods"
                                        ]
                                    })
                                ];
                            case 1:
                                n = _state.sent();
                                return [
                                    2,
                                    this._handleResponse(n)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "enrollmentChallenge",
            value: function enrollmentChallenge(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, r;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/authentication-methods"), {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(e)
                                    }, {
                                        scope: [
                                            "create:me:authentication_methods"
                                        ]
                                    })
                                ];
                            case 1:
                                n = _state.sent();
                                return [
                                    4,
                                    this._handleResponse(n)
                                ];
                            case 2:
                                o = _state.sent(), i = null !== (t = n.headers.get("location")) && void 0 !== t ? t : "", r = decodeURIComponent(i.split("/").pop() || "");
                                return [
                                    2,
                                    Object.assign(Object.assign({}, o), {
                                        id: r,
                                        location: i
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "enrollmentVerify",
            value: function enrollmentVerify(t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, i, r;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                n = t, o = n.location;
                                n.type;
                                i = $65283fdff51e8344$var$e(n, [
                                    "location",
                                    "type"
                                ]);
                                return [
                                    4,
                                    this.myAccountFetcher.fetchWithAuth("".concat(o, "/verify"), {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(i)
                                    }, {
                                        scope: [
                                            "create:me:authentication_methods"
                                        ]
                                    })
                                ];
                            case 1:
                                r = _state.sent();
                                return [
                                    2,
                                    this._handleResponse(r)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_handleResponse",
            value: function _handleResponse(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    e.text()
                                ];
                            case 1:
                                t = _state.sent(), t = JSON.parse(t);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                n = _state.sent();
                                throw new $65283fdff51e8344$export$2c8acf1355a80350({
                                    type: "invalid_json",
                                    status: e.status,
                                    title: "Invalid JSON response",
                                    detail: t || String(n)
                                });
                            case 3:
                                if (e.ok) return [
                                    2,
                                    t
                                ];
                                throw new $65283fdff51e8344$export$2c8acf1355a80350(t);
                        }
                    });
                })();
            }
        }
    ]);
    return Et;
}();
var $65283fdff51e8344$export$2c8acf1355a80350 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(At, Error1);
    function At(e) {
        (0, $5Epmf._)(this, At);
        var _this;
        var t = e.type, n = e.status, o = e.title, i = e.detail, r = e.validation_errors;
        _this = (0, $48Z0s._)(this, At, [
            i
        ]), _this.name = "MyAccountApiError", _this.type = t, _this.status = n, _this.title = o, _this.detail = i, _this.validation_errors = r, Object.setPrototypeOf(_this, At.prototype);
        return _this;
    }
    return At;
}((0, $kW1tL._)(Error));
var $65283fdff51e8344$var$It = {
    otp: {
        authenticatorTypes: [
            "otp"
        ]
    },
    sms: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "sms"
        ]
    },
    email: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "email"
        ]
    },
    push: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "auth0"
        ]
    },
    voice: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "voice"
        ]
    }
}, $65283fdff51e8344$var$xt = "http://auth0.com/oauth/grant-type/mfa-otp", $65283fdff51e8344$var$Rt = "http://auth0.com/oauth/grant-type/mfa-oob", $65283fdff51e8344$var$Ot = "http://auth0.com/oauth/grant-type/mfa-recovery-code";
var $65283fdff51e8344$var$Ct, $65283fdff51e8344$var$Wt;
var $65283fdff51e8344$var$jt;
if ("undefined" == typeof navigator || null === ($65283fdff51e8344$var$Ct = navigator.userAgent) || void 0 === $65283fdff51e8344$var$Ct || null === ($65283fdff51e8344$var$Wt = $65283fdff51e8344$var$Ct.startsWith) || void 0 === $65283fdff51e8344$var$Wt || !$65283fdff51e8344$var$Wt.call($65283fdff51e8344$var$Ct, "Mozilla/5.0 ")) {
    var $65283fdff51e8344$var$e2 = "v3.8.6";
    $65283fdff51e8344$var$jt = "".concat("oauth4webapi", "/").concat($65283fdff51e8344$var$e2);
}
function $65283fdff51e8344$var$Kt(e, t) {
    if (null == e) return !1;
    try {
        return e instanceof t || Object.getPrototypeOf(e)[Symbol.toStringTag] === t.prototype[Symbol.toStringTag];
    } catch (e) {
        return !1;
    }
}
var $65283fdff51e8344$var$Ut = "ERR_INVALID_ARG_VALUE", $65283fdff51e8344$var$Nt = "ERR_INVALID_ARG_TYPE";
function $65283fdff51e8344$var$Lt(e, t, n) {
    var o = new TypeError(e, {
        cause: n
    });
    return Object.assign(o, {
        code: t
    }), o;
}
var $65283fdff51e8344$var$Mt = Symbol(), $65283fdff51e8344$var$zt = Symbol(), $65283fdff51e8344$var$Dt = Symbol(), $65283fdff51e8344$var$Jt = Symbol(), $65283fdff51e8344$var$Ht = Symbol(), $65283fdff51e8344$var$Zt = Symbol(), $65283fdff51e8344$var$Ft = new TextEncoder, $65283fdff51e8344$var$Vt = new TextDecoder;
function $65283fdff51e8344$var$Xt(e) {
    return "string" == typeof e ? $65283fdff51e8344$var$Ft.encode(e) : $65283fdff51e8344$var$Vt.decode(e);
}
var $65283fdff51e8344$var$Gt, $65283fdff51e8344$var$Yt;
if (Uint8Array.prototype.toBase64) $65283fdff51e8344$var$Gt = function(e) {
    return e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({
        alphabet: "base64url",
        omitPadding: !0
    });
};
else {
    var $65283fdff51e8344$var$e3 = 32768;
    $65283fdff51e8344$var$Gt = function(t) {
        t instanceof ArrayBuffer && (t = new Uint8Array(t));
        var n = [];
        for(var o = 0; o < t.byteLength; o += $65283fdff51e8344$var$e3)n.push(String.fromCharCode.apply(null, t.subarray(o, o + $65283fdff51e8344$var$e3)));
        return btoa(n.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
}
function $65283fdff51e8344$var$Bt(e) {
    return "string" == typeof e ? $65283fdff51e8344$var$Yt(e) : $65283fdff51e8344$var$Gt(e);
}
$65283fdff51e8344$var$Yt = Uint8Array.fromBase64 ? function(e) {
    try {
        return Uint8Array.fromBase64(e, {
            alphabet: "base64url"
        });
    } catch (e) {
        throw $65283fdff51e8344$var$Lt("The input to be decoded is not correctly encoded.", $65283fdff51e8344$var$Ut, e);
    }
} : function(e) {
    try {
        var t = atob(e.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "")), n = new Uint8Array(t.length);
        for(var _$e = 0; _$e < t.length; _$e++)n[_$e] = t.charCodeAt(_$e);
        return n;
    } catch (e) {
        throw $65283fdff51e8344$var$Lt("The input to be decoded is not correctly encoded.", $65283fdff51e8344$var$Ut, e);
    }
};
var $65283fdff51e8344$var$qt = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(qt, Error1);
    function qt(e, t) {
        (0, $5Epmf._)(this, qt);
        var _this;
        var n;
        _this = (0, $48Z0s._)(this, qt, [
            e,
            t
        ]), $65283fdff51e8344$var$d(_this, "code", void 0), _this.name = _this.constructor.name, _this.code = $65283fdff51e8344$var$$n, null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, _this, _this.constructor);
        return _this;
    }
    return qt;
}((0, $kW1tL._)(Error));
var $65283fdff51e8344$var$Qt = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(Qt, Error1);
    function Qt(e, t) {
        (0, $5Epmf._)(this, Qt);
        var _this;
        var n;
        _this = (0, $48Z0s._)(this, Qt, [
            e,
            t
        ]), $65283fdff51e8344$var$d(_this, "code", void 0), _this.name = _this.constructor.name, null != t && t.code && (_this.code = null == t ? void 0 : t.code), null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, _this, _this.constructor);
        return _this;
    }
    return Qt;
}((0, $kW1tL._)(Error));
function $65283fdff51e8344$var$$t(e, t, n) {
    return new $65283fdff51e8344$var$Qt(e, {
        code: t,
        cause: n
    });
}
function $65283fdff51e8344$var$en(e, t) {
    if (function(e, t) {
        if (!(e instanceof CryptoKey)) throw $65283fdff51e8344$var$Lt("".concat(t, " must be a CryptoKey"), $65283fdff51e8344$var$Nt);
    }(e, t), "private" !== e.type) throw $65283fdff51e8344$var$Lt("".concat(t, " must be a private CryptoKey"), $65283fdff51e8344$var$Ut);
}
function $65283fdff51e8344$var$tn(e) {
    return null !== e && "object" == (typeof e === "undefined" ? "undefined" : (0, $03bAP._)(e)) && !Array.isArray(e);
}
function $65283fdff51e8344$var$nn(e) {
    $65283fdff51e8344$var$Kt(e, Headers) && (e = Object.fromEntries(e.entries()));
    var t = new Headers(null != e ? e : {});
    if ($65283fdff51e8344$var$jt && !t.has("user-agent") && t.set("user-agent", $65283fdff51e8344$var$jt), t.has("authorization")) throw $65283fdff51e8344$var$Lt('"options.headers" must not include the "authorization" header name', $65283fdff51e8344$var$Ut);
    return t;
}
function $65283fdff51e8344$var$on(e, t) {
    if (void 0 !== t) {
        if ("function" == typeof t && (t = t(e.href)), !(t instanceof AbortSignal)) throw $65283fdff51e8344$var$Lt('"options.signal" must return or be an instance of AbortSignal', $65283fdff51e8344$var$Nt);
        return t;
    }
}
function $65283fdff51e8344$var$rn(e) {
    return e.includes("//") ? e.replace("//", "/") : e;
}
function $65283fdff51e8344$var$an(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        return (0, $3SMYb._)(this, function(_state) {
            return [
                2,
                function(e, t, n, o) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        var i, r;
                        return (0, $3SMYb._)(this, function(_state) {
                            if (!(e instanceof URL)) throw $65283fdff51e8344$var$Lt('"'.concat(t, '" must be an instance of URL'), $65283fdff51e8344$var$Nt);
                            $65283fdff51e8344$var$bn(e, !0 !== (null == o ? void 0 : o[$65283fdff51e8344$var$Mt]));
                            i = n(new URL(e.href)), r = $65283fdff51e8344$var$nn(null == o ? void 0 : o.headers);
                            return [
                                2,
                                (r.set("accept", "application/json"), ((null == o ? void 0 : o[$65283fdff51e8344$var$Jt]) || fetch)(i.href, {
                                    body: void 0,
                                    headers: Object.fromEntries(r.entries()),
                                    method: "GET",
                                    redirect: "manual",
                                    signal: $65283fdff51e8344$var$on(i, null == o ? void 0 : o.signal)
                                }))
                            ];
                        });
                    })();
                }(e, "issuerIdentifier", function(e) {
                    switch(null == t ? void 0 : t.algorithm){
                        case void 0:
                        case "oidc":
                            !function(e, t) {
                                e.pathname = $65283fdff51e8344$var$rn("".concat(e.pathname, "/").concat(t));
                            }(e, ".well-known/openid-configuration");
                            break;
                        case "oauth2":
                            !function(e, t) {
                                var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                                "/" === e.pathname ? e.pathname = t : e.pathname = $65283fdff51e8344$var$rn("".concat(t, "/").concat(n ? e.pathname : e.pathname.replace(/(\/)$/, "")));
                            }(e, ".well-known/oauth-authorization-server");
                            break;
                        default:
                            throw $65283fdff51e8344$var$Lt('"options.algorithm" must be "oidc" (default), or "oauth2"', $65283fdff51e8344$var$Ut);
                    }
                    return e;
                }, t)
            ];
        });
    })();
}
function $65283fdff51e8344$var$sn(e, t, n, o, i) {
    try {
        if ("number" != typeof e || !Number.isFinite(e)) throw $65283fdff51e8344$var$Lt("".concat(n, " must be a number"), $65283fdff51e8344$var$Nt, i);
        if (e > 0) return;
        if (t) {
            if (0 !== e) throw $65283fdff51e8344$var$Lt("".concat(n, " must be a non-negative number"), $65283fdff51e8344$var$Ut, i);
            return;
        }
        throw $65283fdff51e8344$var$Lt("".concat(n, " must be a positive number"), $65283fdff51e8344$var$Ut, i);
    } catch (e) {
        if (o) throw $65283fdff51e8344$var$$t(e.message, o, i);
        throw e;
    }
}
function $65283fdff51e8344$var$cn(e, t, n, o) {
    try {
        if ("string" != typeof e) throw $65283fdff51e8344$var$Lt("".concat(t, " must be a string"), $65283fdff51e8344$var$Nt, o);
        if (0 === e.length) throw $65283fdff51e8344$var$Lt("".concat(t, " must not be empty"), $65283fdff51e8344$var$Ut, o);
    } catch (e) {
        if (n) throw $65283fdff51e8344$var$$t(e.message, n, o);
        throw e;
    }
}
function $65283fdff51e8344$var$un(e) {
    !function(e, t) {
        if ($65283fdff51e8344$var$Kn(e) !== t) throw function(e) {
            var _$t = '"response" content-type must be ';
            for(var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)o[i - 1] = arguments[i];
            if (o.length > 2) {
                var _$e = o.pop();
                _$t += "".concat(o.join(", "), ", or ").concat(_$e);
            } else 2 === o.length ? _$t += "".concat(o[0], " or ").concat(o[1]) : _$t += o[0];
            return $65283fdff51e8344$var$$t(_$t, $65283fdff51e8344$var$oo, e);
        }(e, t);
    }(e, "application/json");
}
function $65283fdff51e8344$var$ln() {
    return $65283fdff51e8344$var$Bt(crypto.getRandomValues(new Uint8Array(32)));
}
function $65283fdff51e8344$var$hn(e) {
    switch(e.algorithm.name){
        case "RSA-PSS":
            return function(e) {
                switch(e.algorithm.hash.name){
                    case "SHA-256":
                        return "PS256";
                    case "SHA-384":
                        return "PS384";
                    case "SHA-512":
                        return "PS512";
                    default:
                        throw new $65283fdff51e8344$var$qt("unsupported RsaHashedKeyAlgorithm hash name", {
                            cause: e
                        });
                }
            }(e);
        case "RSASSA-PKCS1-v1_5":
            return function(e) {
                switch(e.algorithm.hash.name){
                    case "SHA-256":
                        return "RS256";
                    case "SHA-384":
                        return "RS384";
                    case "SHA-512":
                        return "RS512";
                    default:
                        throw new $65283fdff51e8344$var$qt("unsupported RsaHashedKeyAlgorithm hash name", {
                            cause: e
                        });
                }
            }(e);
        case "ECDSA":
            return function(e) {
                switch(e.algorithm.namedCurve){
                    case "P-256":
                        return "ES256";
                    case "P-384":
                        return "ES384";
                    case "P-521":
                        return "ES512";
                    default:
                        throw new $65283fdff51e8344$var$qt("unsupported EcKeyAlgorithm namedCurve", {
                            cause: e
                        });
                }
            }(e);
        case "Ed25519":
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
            return e.algorithm.name;
        case "EdDSA":
            return "Ed25519";
        default:
            throw new $65283fdff51e8344$var$qt("unsupported CryptoKey algorithm name", {
                cause: e
            });
    }
}
function $65283fdff51e8344$var$dn(e) {
    var t = null == e ? void 0 : e[$65283fdff51e8344$var$zt];
    return "number" == typeof t && Number.isFinite(t) ? t : 0;
}
function $65283fdff51e8344$var$pn(e) {
    var t = null == e ? void 0 : e[$65283fdff51e8344$var$Dt];
    return "number" == typeof t && Number.isFinite(t) && -1 !== Math.sign(t) ? t : 30;
}
function $65283fdff51e8344$var$fn() {
    return Math.floor(Date.now() / 1e3);
}
function $65283fdff51e8344$var$mn(e) {
    if ("object" != (typeof e === "undefined" ? "undefined" : (0, $03bAP._)(e)) || null === e) throw $65283fdff51e8344$var$Lt('"as" must be an object', $65283fdff51e8344$var$Nt);
    $65283fdff51e8344$var$cn(e.issuer, '"as.issuer"');
}
function $65283fdff51e8344$var$yn(e) {
    if ("object" != (typeof e === "undefined" ? "undefined" : (0, $03bAP._)(e)) || null === e) throw $65283fdff51e8344$var$Lt('"client" must be an object', $65283fdff51e8344$var$Nt);
    $65283fdff51e8344$var$cn(e.client_id, '"client.client_id"');
}
function $65283fdff51e8344$var$wn(e) {
    return $65283fdff51e8344$var$cn(e, '"clientSecret"'), function(t, n, o, i) {
        o.set("client_id", n.client_id), o.set("client_secret", e);
    };
}
function $65283fdff51e8344$var$gn(e, t) {
    var n = (r = e) instanceof CryptoKey ? {
        key: r
    } : (null == r ? void 0 : r.key) instanceof CryptoKey ? (void 0 !== r.kid && $65283fdff51e8344$var$cn(r.kid, '"kid"'), {
        key: r.key,
        kid: r.kid
    }) : {}, o = n.key, i = n.kid;
    var r;
    return $65283fdff51e8344$var$en(o, '"clientPrivateKey.key"'), function(e, n, r, a) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var s, c, u, _, _tmp;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        c = {
                            alg: $65283fdff51e8344$var$hn(o),
                            kid: i
                        }, u = function(e, t) {
                            var _$n = $65283fdff51e8344$var$fn() + $65283fdff51e8344$var$dn(t);
                            return {
                                jti: $65283fdff51e8344$var$ln(),
                                aud: e.issuer,
                                exp: _$n + 60,
                                iat: _$n,
                                nbf: _$n,
                                iss: t.client_id,
                                sub: t.client_id
                            };
                        }(e, n);
                        null == t || null === (s = t[$65283fdff51e8344$var$Ht]) || void 0 === s || s.call(t, c, u), r.set("client_id", n.client_id), r.set("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                        _ = r.set;
                        _tmp = [
                            "client_assertion"
                        ];
                        return [
                            4,
                            function(e, t, n) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                    var o, i;
                                    return (0, $3SMYb._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!n.usages.includes("sign")) throw $65283fdff51e8344$var$Lt('CryptoKey instances used for signing assertions must include "sign" in their "usages"', $65283fdff51e8344$var$Ut);
                                                o = "".concat($65283fdff51e8344$var$Bt($65283fdff51e8344$var$Xt(JSON.stringify(e))), ".").concat($65283fdff51e8344$var$Bt($65283fdff51e8344$var$Xt(JSON.stringify(t))));
                                                return [
                                                    4,
                                                    crypto.subtle.sign(function(e) {
                                                        switch(e.algorithm.name){
                                                            case "ECDSA":
                                                                return {
                                                                    name: e.algorithm.name,
                                                                    hash: $65283fdff51e8344$var$yo(e)
                                                                };
                                                            case "RSA-PSS":
                                                                switch($65283fdff51e8344$var$mo(e), e.algorithm.hash.name){
                                                                    case "SHA-256":
                                                                    case "SHA-384":
                                                                    case "SHA-512":
                                                                        return {
                                                                            name: e.algorithm.name,
                                                                            saltLength: parseInt(e.algorithm.hash.name.slice(-3), 10) >> 3
                                                                        };
                                                                    default:
                                                                        throw new $65283fdff51e8344$var$qt("unsupported RSA-PSS hash name", {
                                                                            cause: e
                                                                        });
                                                                }
                                                            case "RSASSA-PKCS1-v1_5":
                                                                return $65283fdff51e8344$var$mo(e), e.algorithm.name;
                                                            case "ML-DSA-44":
                                                            case "ML-DSA-65":
                                                            case "ML-DSA-87":
                                                            case "Ed25519":
                                                                return e.algorithm.name;
                                                        }
                                                        throw new $65283fdff51e8344$var$qt("unsupported CryptoKey algorithm name", {
                                                            cause: e
                                                        });
                                                    }(n), n, $65283fdff51e8344$var$Xt(o))
                                                ];
                                            case 1:
                                                i = $65283fdff51e8344$var$Bt.apply(void 0, [
                                                    _state.sent()
                                                ]);
                                                return [
                                                    2,
                                                    "".concat(o, ".").concat(i)
                                                ];
                                        }
                                    });
                                })();
                            }(c, u, o)
                        ];
                    case 1:
                        _.apply(r, _tmp.concat([
                            _state.sent()
                        ]));
                        return [
                            2
                        ];
                }
            });
        })();
    };
}
var $65283fdff51e8344$var$vn = URL.parse ? function(e, t) {
    return URL.parse(e, t);
} : function(e, t) {
    try {
        return new URL(e, t);
    } catch (e) {
        return null;
    }
};
function $65283fdff51e8344$var$bn(e, t) {
    if (t && "https:" !== e.protocol) throw $65283fdff51e8344$var$$t("only requests to HTTPS are allowed", $65283fdff51e8344$var$ro, e);
    if ("https:" !== e.protocol && "http:" !== e.protocol) throw $65283fdff51e8344$var$$t("only HTTP and HTTPS requests are allowed", $65283fdff51e8344$var$ao, e);
}
function $65283fdff51e8344$var$kn(e, t, n, o) {
    var i;
    if ("string" != typeof e || !(i = $65283fdff51e8344$var$vn(e))) throw $65283fdff51e8344$var$$t("authorization server metadata does not contain a valid ".concat(n ? '"as.mtls_endpoint_aliases.'.concat(t, '"') : '"as.'.concat(t, '"')), void 0 === e ? $65283fdff51e8344$var$lo : $65283fdff51e8344$var$ho, {
        attribute: n ? "mtls_endpoint_aliases.".concat(t) : t
    });
    return $65283fdff51e8344$var$bn(i, o), i;
}
function $65283fdff51e8344$var$_n(e, t, n, o) {
    return n && e.mtls_endpoint_aliases && t in e.mtls_endpoint_aliases ? $65283fdff51e8344$var$kn(e.mtls_endpoint_aliases[t], t, n, o) : $65283fdff51e8344$var$kn(e[t], t, n, o);
}
var $65283fdff51e8344$var$Sn = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(Sn, Error1);
    function Sn(e, t) {
        (0, $5Epmf._)(this, Sn);
        var _this;
        var n;
        _this = (0, $48Z0s._)(this, Sn, [
            e,
            t
        ]), $65283fdff51e8344$var$d(_this, "cause", void 0), $65283fdff51e8344$var$d(_this, "code", void 0), $65283fdff51e8344$var$d(_this, "error", void 0), $65283fdff51e8344$var$d(_this, "status", void 0), $65283fdff51e8344$var$d(_this, "error_description", void 0), $65283fdff51e8344$var$d(_this, "response", void 0), _this.name = _this.constructor.name, _this.code = $65283fdff51e8344$var$Qn, _this.cause = t.cause, _this.error = t.cause.error, _this.status = t.response.status, _this.error_description = t.cause.error_description, Object.defineProperty(_this, "response", {
            enumerable: !1,
            value: t.response
        }), null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, _this, _this.constructor);
        return _this;
    }
    return Sn;
}((0, $kW1tL._)(Error));
var $65283fdff51e8344$var$Tn = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(Tn, Error1);
    function Tn(e, t) {
        (0, $5Epmf._)(this, Tn);
        var _this;
        var n, o;
        _this = (0, $48Z0s._)(this, Tn, [
            e,
            t
        ]), $65283fdff51e8344$var$d(_this, "cause", void 0), $65283fdff51e8344$var$d(_this, "code", void 0), $65283fdff51e8344$var$d(_this, "error", void 0), $65283fdff51e8344$var$d(_this, "error_description", void 0), _this.name = _this.constructor.name, _this.code = $65283fdff51e8344$var$eo, _this.cause = t.cause, _this.error = t.cause.get("error"), _this.error_description = null !== (n = t.cause.get("error_description")) && void 0 !== n ? n : void 0, null === (o = Error.captureStackTrace) || void 0 === o || o.call(Error, _this, _this.constructor);
        return _this;
    }
    return Tn;
}((0, $kW1tL._)(Error));
var $65283fdff51e8344$var$Pn = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(Pn, Error1);
    function Pn(e, t) {
        (0, $5Epmf._)(this, Pn);
        var _this;
        var n;
        _this = (0, $48Z0s._)(this, Pn, [
            e,
            t
        ]), $65283fdff51e8344$var$d(_this, "cause", void 0), $65283fdff51e8344$var$d(_this, "code", void 0), $65283fdff51e8344$var$d(_this, "response", void 0), $65283fdff51e8344$var$d(_this, "status", void 0), _this.name = _this.constructor.name, _this.code = $65283fdff51e8344$var$qn, _this.cause = t.cause, _this.status = t.response.status, _this.response = t.response, Object.defineProperty(_this, "response", {
            enumerable: !1
        }), null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, _this, _this.constructor);
        return _this;
    }
    return Pn;
}((0, $kW1tL._)(Error));
var $65283fdff51e8344$var$En = "[a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+", $65283fdff51e8344$var$An = "(" + $65283fdff51e8344$var$En + ')\\s*=\\s*"((?:[^"\\\\]|\\\\[\\s\\S])*)"', $65283fdff51e8344$var$In = "(" + $65283fdff51e8344$var$En + ")\\s*=\\s*(" + $65283fdff51e8344$var$En + ")", $65283fdff51e8344$var$xn = new RegExp("^[,\\s]*(" + $65283fdff51e8344$var$En + ")"), $65283fdff51e8344$var$Rn = new RegExp("^[,\\s]*" + $65283fdff51e8344$var$An + "[,\\s]*(.*)"), $65283fdff51e8344$var$On = new RegExp("^[,\\s]*" + $65283fdff51e8344$var$In + "[,\\s]*(.*)"), $65283fdff51e8344$var$Cn = new RegExp("^([a-zA-Z0-9\\-\\._\\~\\+\\/]+={0,2})(?:$|[,\\s])(.*)");
function $65283fdff51e8344$var$Wn(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _$t, o;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(e.status !== t)) return [
                        3,
                        4
                    ];
                    (function(e) {
                        var _$t;
                        if (_$t = function(e) {
                            if (!$65283fdff51e8344$var$Kt(e, Response)) throw $65283fdff51e8344$var$Lt('"response" must be an instance of Response', $65283fdff51e8344$var$Nt);
                            var _$t = e.headers.get("www-authenticate");
                            if (null === _$t) return;
                            var _$n = [];
                            var o = _$t;
                            for(; o;){
                                var i;
                                var _$e = o.match($65283fdff51e8344$var$xn);
                                var _$t1 = null === (i = _$e) || void 0 === i ? void 0 : i[1].toLowerCase();
                                if (!_$t1) return;
                                var c = o.substring(_$e[0].length);
                                if (c && !c.match(/^[\s,]/)) return;
                                var u = c.match(/^\s+(.*)$/), l = !!u;
                                o = u ? u[1] : void 0;
                                var h = {};
                                var _$d = void 0;
                                if (l) for(; o;){
                                    var _$t2 = void 0, _$n1 = void 0;
                                    if (_$e = o.match($65283fdff51e8344$var$Rn)) {
                                        var r = $65283fdff51e8344$var$y(_$e, 4);
                                        if (_$t2 = r[1], _$n1 = r[2], o = r[3], _$n1.includes("\\")) try {
                                            _$n1 = JSON.parse('"'.concat(_$n1, '"'));
                                        } catch (e) {}
                                        h[_$t2.toLowerCase()] = _$n1;
                                    } else {
                                        if (!(_$e = o.match($65283fdff51e8344$var$On))) {
                                            if (_$e = o.match($65283fdff51e8344$var$Cn)) {
                                                if (Object.keys(h).length) break;
                                                var a = $65283fdff51e8344$var$y(_$e, 3);
                                                _$d = a[1], o = a[2];
                                                break;
                                            }
                                            return;
                                        }
                                        var s = $65283fdff51e8344$var$y(_$e, 4);
                                        _$t2 = s[1], _$n1 = s[2], o = s[3], h[_$t2.toLowerCase()] = _$n1;
                                    }
                                }
                                else o = c || void 0;
                                var p = {
                                    scheme: _$t1,
                                    parameters: h
                                };
                                _$d && (p.token68 = _$d), _$n.push(p);
                            }
                            return _$n.length ? _$n : void 0;
                        }(e)) throw new $65283fdff51e8344$var$Pn("server responded with a challenge in the WWW-Authenticate HTTP Header", {
                            cause: _$t,
                            response: e
                        });
                    })(e);
                    return [
                        4,
                        function(e) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var _$t, e1;
                                return (0, $3SMYb._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(e.status > 399 && e.status < 500)) return [
                                                3,
                                                4
                                            ];
                                            $65283fdff51e8344$var$fo(e), $65283fdff51e8344$var$un(e);
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4,
                                                e.clone().json()
                                            ];
                                        case 2:
                                            _$t = _state.sent();
                                            if ($65283fdff51e8344$var$tn(_$t) && "string" == typeof _$t.error && _$t.error.length) return [
                                                2,
                                                _$t
                                            ];
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            e1 = _state.sent();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }(e)
                    ];
                case 1:
                    if (!(_$t = _state.sent())) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        null === (o = e.body) || void 0 === o ? void 0 : o.cancel()
                    ];
                case 2:
                    throw _state.sent(), new $65283fdff51e8344$var$Sn("server responded with an error in the response body", {
                        cause: _$t,
                        response: e
                    });
                case 3:
                    throw $65283fdff51e8344$var$$t('"response" is not a conform '.concat(n, " response (unexpected HTTP status code)"), $65283fdff51e8344$var$io, e);
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $65283fdff51e8344$var$jn(e) {
    if (!$65283fdff51e8344$var$Zn.has(e)) throw $65283fdff51e8344$var$Lt('"options.DPoP" is not a valid DPoPHandle', $65283fdff51e8344$var$Ut);
}
function $65283fdff51e8344$var$Kn(e) {
    var t;
    return null === (t = e.headers.get("content-type")) || void 0 === t ? void 0 : t.split(";")[0];
}
function $65283fdff51e8344$var$Un(e, t, n, o, i, r, a) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        n(e, t, i, r)
                    ];
                case 1:
                    return [
                        2,
                        (_state.sent(), r.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), ((null == a ? void 0 : a[$65283fdff51e8344$var$Jt]) || fetch)(o.href, {
                            body: i,
                            headers: Object.fromEntries(r.entries()),
                            method: "POST",
                            redirect: "manual",
                            signal: $65283fdff51e8344$var$on(o, null == a ? void 0 : a.signal)
                        }))
                    ];
            }
        });
    })();
}
function $65283fdff51e8344$var$Nn(e, t, n, o, i, r) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var a, s, c, _tmp, u;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    s = $65283fdff51e8344$var$_n(e, "token_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == r ? void 0 : r[$65283fdff51e8344$var$Mt]));
                    i.set("grant_type", o);
                    c = $65283fdff51e8344$var$nn(null == r ? void 0 : r.headers);
                    c.set("accept", "application/json");
                    _tmp = void 0 !== (null == r ? void 0 : r.DPoP);
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    $65283fdff51e8344$var$jn(r.DPoP);
                    return [
                        4,
                        r.DPoP.addProof(s, c, "POST")
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp;
                    return [
                        4,
                        $65283fdff51e8344$var$Un(e, t, n, s, i, c, r)
                    ];
                case 3:
                    u = _state.sent();
                    return [
                        2,
                        (null == r || null === (a = r.DPoP) || void 0 === a || a.cacheNonce(u, s), u)
                    ];
            }
        });
    })();
}
var $65283fdff51e8344$var$Ln = new WeakMap, $65283fdff51e8344$var$Mn = new WeakMap;
function $65283fdff51e8344$var$zn(e) {
    if (!e.id_token) return;
    var t = $65283fdff51e8344$var$Ln.get(e);
    if (!t) throw $65283fdff51e8344$var$Lt('"ref" was already garbage collected or did not resolve from the proper sources', $65283fdff51e8344$var$Ut);
    return t;
}
function $65283fdff51e8344$var$Dn(e, t, n, o, i, r) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var a, _$e, _r, _$r, s, c, u;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ($65283fdff51e8344$var$mn(e), $65283fdff51e8344$var$yn(t), !$65283fdff51e8344$var$Kt(n, Response)) throw $65283fdff51e8344$var$Lt('"response" must be an instance of Response', $65283fdff51e8344$var$Nt);
                    return [
                        4,
                        $65283fdff51e8344$var$Wn(n, 200, "Token Endpoint")
                    ];
                case 1:
                    _state.sent(), $65283fdff51e8344$var$fo(n);
                    return [
                        4,
                        $65283fdff51e8344$var$So(n)
                    ];
                case 2:
                    a = _state.sent();
                    if ($65283fdff51e8344$var$cn(a.access_token, '"response" body "access_token" property', $65283fdff51e8344$var$no, {
                        body: a
                    }), $65283fdff51e8344$var$cn(a.token_type, '"response" body "token_type" property', $65283fdff51e8344$var$no, {
                        body: a
                    }), a.token_type = a.token_type.toLowerCase(), void 0 !== a.expires_in) {
                        _$e = "number" != typeof a.expires_in ? parseFloat(a.expires_in) : a.expires_in;
                        $65283fdff51e8344$var$sn(_$e, !0, '"response" body "expires_in" property', $65283fdff51e8344$var$no, {
                            body: a
                        }), a.expires_in = _$e;
                    }
                    if (void 0 !== a.refresh_token && $65283fdff51e8344$var$cn(a.refresh_token, '"response" body "refresh_token" property', $65283fdff51e8344$var$no, {
                        body: a
                    }), void 0 !== a.scope && "string" != typeof a.scope) throw $65283fdff51e8344$var$$t('"response" body "scope" property must be a string', $65283fdff51e8344$var$no, {
                        body: a
                    });
                    if (!(void 0 !== a.id_token)) return [
                        3,
                        4
                    ];
                    $65283fdff51e8344$var$cn(a.id_token, '"response" body "id_token" property', $65283fdff51e8344$var$no, {
                        body: a
                    });
                    _$r = [
                        "aud",
                        "exp",
                        "iat",
                        "iss",
                        "sub"
                    ];
                    !0 === t.require_auth_time && _$r.push("auth_time"), void 0 !== t.default_max_age && ($65283fdff51e8344$var$sn(t.default_max_age, !0, '"client.default_max_age"'), _$r.push("auth_time")), null != o && o.length && (_r = _$r).push.apply(_r, (0, $XnYkK._)(o));
                    return [
                        4,
                        (function(e, t, n, o, i) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var _$r, a, s, c, u, l, h, _$d;
                                return (0, $3SMYb._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            s = e.split("."), c = s[0], u = s[1], l = s.length;
                                            if (!(5 === l)) return [
                                                3,
                                                2
                                            ];
                                            if (void 0 === i) throw new $65283fdff51e8344$var$qt("JWE decryption is not configured", {
                                                cause: e
                                            });
                                            return [
                                                4,
                                                i(e)
                                            ];
                                        case 1:
                                            h = (e = _state.sent()).split(".");
                                            c = h[0], u = h[1], l = h.length;
                                            _state.label = 2;
                                        case 2:
                                            if (3 !== l) throw $65283fdff51e8344$var$$t("Invalid JWT", $65283fdff51e8344$var$no, e);
                                            try {
                                                _$r = JSON.parse($65283fdff51e8344$var$Xt($65283fdff51e8344$var$Bt(c)));
                                            } catch (e) {
                                                throw $65283fdff51e8344$var$$t("failed to parse JWT Header body as base64url encoded JSON", $65283fdff51e8344$var$to, e);
                                            }
                                            if (!$65283fdff51e8344$var$tn(_$r)) throw $65283fdff51e8344$var$$t("JWT Header must be a top level object", $65283fdff51e8344$var$no, e);
                                            if (t(_$r), void 0 !== _$r.crit) throw new $65283fdff51e8344$var$qt('no JWT "crit" header parameter extensions are supported', {
                                                cause: {
                                                    header: _$r
                                                }
                                            });
                                            try {
                                                a = JSON.parse($65283fdff51e8344$var$Xt($65283fdff51e8344$var$Bt(u)));
                                            } catch (e) {
                                                throw $65283fdff51e8344$var$$t("failed to parse JWT Payload body as base64url encoded JSON", $65283fdff51e8344$var$to, e);
                                            }
                                            if (!$65283fdff51e8344$var$tn(a)) throw $65283fdff51e8344$var$$t("JWT Payload must be a top level object", $65283fdff51e8344$var$no, e);
                                            _$d = $65283fdff51e8344$var$fn() + n;
                                            if (void 0 !== a.exp) {
                                                if ("number" != typeof a.exp) throw $65283fdff51e8344$var$$t('unexpected JWT "exp" (expiration time) claim type', $65283fdff51e8344$var$no, {
                                                    claims: a
                                                });
                                                if (a.exp <= _$d - o) throw $65283fdff51e8344$var$$t('unexpected JWT "exp" (expiration time) claim value, expiration is past current timestamp', $65283fdff51e8344$var$so, {
                                                    claims: a,
                                                    now: _$d,
                                                    tolerance: o,
                                                    claim: "exp"
                                                });
                                            }
                                            if (void 0 !== a.iat && "number" != typeof a.iat) throw $65283fdff51e8344$var$$t('unexpected JWT "iat" (issued at) claim type', $65283fdff51e8344$var$no, {
                                                claims: a
                                            });
                                            if (void 0 !== a.iss && "string" != typeof a.iss) throw $65283fdff51e8344$var$$t('unexpected JWT "iss" (issuer) claim type', $65283fdff51e8344$var$no, {
                                                claims: a
                                            });
                                            if (void 0 !== a.nbf) {
                                                if ("number" != typeof a.nbf) throw $65283fdff51e8344$var$$t('unexpected JWT "nbf" (not before) claim type', $65283fdff51e8344$var$no, {
                                                    claims: a
                                                });
                                                if (a.nbf > _$d + o) throw $65283fdff51e8344$var$$t('unexpected JWT "nbf" (not before) claim value', $65283fdff51e8344$var$so, {
                                                    claims: a,
                                                    now: _$d,
                                                    tolerance: o,
                                                    claim: "nbf"
                                                });
                                            }
                                            if (void 0 !== a.aud && "string" != typeof a.aud && !Array.isArray(a.aud)) throw $65283fdff51e8344$var$$t('unexpected JWT "aud" (audience) claim type', $65283fdff51e8344$var$no, {
                                                claims: a
                                            });
                                            return [
                                                2,
                                                {
                                                    header: _$r,
                                                    claims: a,
                                                    jwt: e
                                                }
                                            ];
                                    }
                                });
                            })();
                        })(a.id_token, $65283fdff51e8344$var$go.bind(void 0, t.id_token_signed_response_alg, e.id_token_signing_alg_values_supported, "RS256"), $65283fdff51e8344$var$dn(t), $65283fdff51e8344$var$pn(t), i).then($65283fdff51e8344$var$Xn.bind(void 0, _$r)).then($65283fdff51e8344$var$Hn.bind(void 0, e)).then($65283fdff51e8344$var$Jn.bind(void 0, t.client_id))
                    ];
                case 3:
                    s = _state.sent(), c = s.claims, u = s.jwt;
                    if (Array.isArray(c.aud) && 1 !== c.aud.length) {
                        if (void 0 === c.azp) throw $65283fdff51e8344$var$$t('ID Token "aud" (audience) claim includes additional untrusted audiences', $65283fdff51e8344$var$co, {
                            claims: c,
                            claim: "aud"
                        });
                        if (c.azp !== t.client_id) throw $65283fdff51e8344$var$$t('unexpected ID Token "azp" (authorized party) claim value', $65283fdff51e8344$var$co, {
                            expected: t.client_id,
                            claims: c,
                            claim: "azp"
                        });
                    }
                    void 0 !== c.auth_time && $65283fdff51e8344$var$sn(c.auth_time, !0, 'ID Token "auth_time" (authentication time)', $65283fdff51e8344$var$no, {
                        claims: c
                    }), $65283fdff51e8344$var$Mn.set(n, u), $65283fdff51e8344$var$Ln.set(a, c);
                    _state.label = 4;
                case 4:
                    if (void 0 !== (null == r ? void 0 : r[a.token_type])) r[a.token_type](n, a);
                    else if ("dpop" !== a.token_type && "bearer" !== a.token_type) throw new $65283fdff51e8344$var$qt("unsupported `token_type` value", {
                        cause: {
                            body: a
                        }
                    });
                    return [
                        2,
                        a
                    ];
            }
        });
    })();
}
function $65283fdff51e8344$var$Jn(e, t) {
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e)) throw $65283fdff51e8344$var$$t('unexpected JWT "aud" (audience) claim value', $65283fdff51e8344$var$co, {
            expected: e,
            claims: t.claims,
            claim: "aud"
        });
    } else if (t.claims.aud !== e) throw $65283fdff51e8344$var$$t('unexpected JWT "aud" (audience) claim value', $65283fdff51e8344$var$co, {
        expected: e,
        claims: t.claims,
        claim: "aud"
    });
    return t;
}
function $65283fdff51e8344$var$Hn(e, t) {
    var n, o;
    var i = null !== (n = null === (o = e[$65283fdff51e8344$var$Po]) || void 0 === o ? void 0 : o.call(e, t)) && void 0 !== n ? n : e.issuer;
    if (t.claims.iss !== i) throw $65283fdff51e8344$var$$t('unexpected JWT "iss" (issuer) claim value', $65283fdff51e8344$var$co, {
        expected: i,
        claims: t.claims,
        claim: "iss"
    });
    return t;
}
var $65283fdff51e8344$var$Zn = new WeakSet;
var $65283fdff51e8344$var$Fn = Symbol();
var $65283fdff51e8344$var$Vn = {
    aud: "audience",
    c_hash: "code hash",
    client_id: "client id",
    exp: "expiration time",
    iat: "issued at",
    iss: "issuer",
    jti: "jwt id",
    nonce: "nonce",
    s_hash: "state hash",
    sub: "subject",
    ath: "access token hash",
    htm: "http method",
    htu: "http uri",
    cnf: "confirmation",
    auth_time: "authentication time"
};
function $65283fdff51e8344$var$Xn(e, t) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            if (void 0 === t.claims[n]) throw $65283fdff51e8344$var$$t('JWT "'.concat(n, '" (').concat($65283fdff51e8344$var$Vn[n], ") claim missing"), $65283fdff51e8344$var$no, {
                claims: t.claims
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return t;
}
var $65283fdff51e8344$var$Gn = Symbol(), $65283fdff51e8344$var$Yn = Symbol();
function $65283fdff51e8344$var$Bn(e, t, n, o) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        return (0, $3SMYb._)(this, function(_state) {
            return [
                2,
                "string" == typeof (null == o ? void 0 : o.expectedNonce) || "number" == typeof (null == o ? void 0 : o.maxAge) || null != o && o.requireIdToken ? function(e, t, n, o, i, r, a) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        var s, c, u, _$e, _$n;
                        return (0, $3SMYb._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    s = [];
                                    switch(o){
                                        case void 0:
                                            o = $65283fdff51e8344$var$Gn;
                                            break;
                                        case $65283fdff51e8344$var$Gn:
                                            break;
                                        default:
                                            $65283fdff51e8344$var$cn(o, '"expectedNonce" argument'), s.push("nonce");
                                    }
                                    switch(null != i || (i = t.default_max_age), i){
                                        case void 0:
                                            i = $65283fdff51e8344$var$Yn;
                                            break;
                                        case $65283fdff51e8344$var$Yn:
                                            break;
                                        default:
                                            $65283fdff51e8344$var$sn(i, !0, '"maxAge" argument'), s.push("auth_time");
                                    }
                                    return [
                                        4,
                                        $65283fdff51e8344$var$Dn(e, t, n, s, r, a)
                                    ];
                                case 1:
                                    c = _state.sent();
                                    $65283fdff51e8344$var$cn(c.id_token, '"response" body "id_token" property', $65283fdff51e8344$var$no, {
                                        body: c
                                    });
                                    u = $65283fdff51e8344$var$zn(c);
                                    if (i !== $65283fdff51e8344$var$Yn) {
                                        _$e = $65283fdff51e8344$var$fn() + $65283fdff51e8344$var$dn(t), _$n = $65283fdff51e8344$var$pn(t);
                                        if (u.auth_time + i < _$e - _$n) throw $65283fdff51e8344$var$$t("too much time has elapsed since the last End-User authentication", $65283fdff51e8344$var$so, {
                                            claims: u,
                                            now: _$e,
                                            tolerance: _$n,
                                            claim: "auth_time"
                                        });
                                    }
                                    if (o === $65283fdff51e8344$var$Gn) {
                                        if (void 0 !== u.nonce) throw $65283fdff51e8344$var$$t('unexpected ID Token "nonce" claim value', $65283fdff51e8344$var$co, {
                                            expected: void 0,
                                            claims: u,
                                            claim: "nonce"
                                        });
                                    } else if (u.nonce !== o) throw $65283fdff51e8344$var$$t('unexpected ID Token "nonce" claim value', $65283fdff51e8344$var$co, {
                                        expected: o,
                                        claims: u,
                                        claim: "nonce"
                                    });
                                    return [
                                        2,
                                        c
                                    ];
                            }
                        });
                    })();
                }(e, t, n, o.expectedNonce, o.maxAge, o[$65283fdff51e8344$var$Zt], o.recognizedTokenTypes) : function(e, t, n, o, i) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        var r, a, _$e, _$n;
                        return (0, $3SMYb._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        $65283fdff51e8344$var$Dn(e, t, n, void 0, o, i)
                                    ];
                                case 1:
                                    r = _state.sent(), a = $65283fdff51e8344$var$zn(r);
                                    if (a) {
                                        if (void 0 !== t.default_max_age) {
                                            $65283fdff51e8344$var$sn(t.default_max_age, !0, '"client.default_max_age"');
                                            _$e = $65283fdff51e8344$var$fn() + $65283fdff51e8344$var$dn(t), _$n = $65283fdff51e8344$var$pn(t);
                                            if (a.auth_time + t.default_max_age < _$e - _$n) throw $65283fdff51e8344$var$$t("too much time has elapsed since the last End-User authentication", $65283fdff51e8344$var$so, {
                                                claims: a,
                                                now: _$e,
                                                tolerance: _$n,
                                                claim: "auth_time"
                                            });
                                        }
                                        if (void 0 !== a.nonce) throw $65283fdff51e8344$var$$t('unexpected ID Token "nonce" claim value', $65283fdff51e8344$var$co, {
                                            expected: void 0,
                                            claims: a,
                                            claim: "nonce"
                                        });
                                    }
                                    return [
                                        2,
                                        r
                                    ];
                            }
                        });
                    })();
                }(e, t, n, null == o ? void 0 : o[$65283fdff51e8344$var$Zt], null == o ? void 0 : o.recognizedTokenTypes)
            ];
        });
    })();
}
var $65283fdff51e8344$var$qn = "OAUTH_WWW_AUTHENTICATE_CHALLENGE", $65283fdff51e8344$var$Qn = "OAUTH_RESPONSE_BODY_ERROR", $65283fdff51e8344$var$$n = "OAUTH_UNSUPPORTED_OPERATION", $65283fdff51e8344$var$eo = "OAUTH_AUTHORIZATION_RESPONSE_ERROR", $65283fdff51e8344$var$to = "OAUTH_PARSE_ERROR", $65283fdff51e8344$var$no = "OAUTH_INVALID_RESPONSE", $65283fdff51e8344$var$oo = "OAUTH_RESPONSE_IS_NOT_JSON", $65283fdff51e8344$var$io = "OAUTH_RESPONSE_IS_NOT_CONFORM", $65283fdff51e8344$var$ro = "OAUTH_HTTP_REQUEST_FORBIDDEN", $65283fdff51e8344$var$ao = "OAUTH_REQUEST_PROTOCOL_FORBIDDEN", $65283fdff51e8344$var$so = "OAUTH_JWT_TIMESTAMP_CHECK_FAILED", $65283fdff51e8344$var$co = "OAUTH_JWT_CLAIM_COMPARISON_FAILED", $65283fdff51e8344$var$uo = "OAUTH_JSON_ATTRIBUTE_COMPARISON_FAILED", $65283fdff51e8344$var$lo = "OAUTH_MISSING_SERVER_METADATA", $65283fdff51e8344$var$ho = "OAUTH_INVALID_SERVER_METADATA";
function $65283fdff51e8344$var$po(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$65283fdff51e8344$var$Kt(e, Response)) throw $65283fdff51e8344$var$Lt('"response" must be an instance of Response', $65283fdff51e8344$var$Nt);
                    return [
                        4,
                        $65283fdff51e8344$var$Wn(e, 200, "Revocation Endpoint")
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $65283fdff51e8344$var$fo(e) {
    if (e.bodyUsed) throw $65283fdff51e8344$var$Lt('"response" body has been used already', $65283fdff51e8344$var$Ut);
}
function $65283fdff51e8344$var$mo(e) {
    var t = e.algorithm;
    if ("number" != typeof t.modulusLength || t.modulusLength < 2048) throw new $65283fdff51e8344$var$qt("unsupported ".concat(t.name, " modulusLength"), {
        cause: e
    });
}
function $65283fdff51e8344$var$yo(e) {
    switch(e.algorithm.namedCurve){
        case "P-256":
            return "SHA-256";
        case "P-384":
            return "SHA-384";
        case "P-521":
            return "SHA-512";
        default:
            throw new $65283fdff51e8344$var$qt("unsupported ECDSA namedCurve", {
                cause: e
            });
    }
}
function $65283fdff51e8344$var$wo(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        return (0, $3SMYb._)(this, function(_state) {
            if ("POST" !== e.method) throw $65283fdff51e8344$var$Lt("form_post responses are expected to use the POST method", $65283fdff51e8344$var$Ut, {
                cause: e
            });
            if ("application/x-www-form-urlencoded" !== $65283fdff51e8344$var$Kn(e)) throw $65283fdff51e8344$var$Lt("form_post responses are expected to use the application/x-www-form-urlencoded content-type", $65283fdff51e8344$var$Ut, {
                cause: e
            });
            return [
                2,
                function(e) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        return (0, $3SMYb._)(this, function(_state) {
                            if (e.bodyUsed) throw $65283fdff51e8344$var$Lt("form_post Request instances must contain a readable body", $65283fdff51e8344$var$Ut, {
                                cause: e
                            });
                            return [
                                2,
                                e.text()
                            ];
                        });
                    })();
                }(e)
            ];
        });
    })();
}
function $65283fdff51e8344$var$go(e, t, n, o) {
    if (void 0 === e) {
        if (Array.isArray(t)) {
            if (!t.includes(o.alg)) throw $65283fdff51e8344$var$$t('unexpected JWT "alg" header parameter', $65283fdff51e8344$var$no, {
                header: o,
                expected: t,
                reason: "authorization server metadata"
            });
        } else {
            if (void 0 === n) throw $65283fdff51e8344$var$$t('missing client or server configuration to verify used JWT "alg" header parameter', void 0, {
                client: e,
                issuer: t,
                fallback: n
            });
            if ("string" == typeof n ? o.alg !== n : "function" == typeof n ? !n(o.alg) : !n.includes(o.alg)) throw $65283fdff51e8344$var$$t('unexpected JWT "alg" header parameter', $65283fdff51e8344$var$no, {
                header: o,
                expected: n,
                reason: "default value"
            });
        }
    } else if ("string" == typeof e ? o.alg !== e : !e.includes(o.alg)) throw $65283fdff51e8344$var$$t('unexpected JWT "alg" header parameter', $65283fdff51e8344$var$no, {
        header: o,
        expected: e,
        reason: "client configuration"
    });
}
function $65283fdff51e8344$var$vo(e, t) {
    var n = e.getAll(t), o = n[0];
    if (n.length > 1) throw $65283fdff51e8344$var$$t('"'.concat(t, '" parameter must be provided only once'), $65283fdff51e8344$var$no);
    return o;
}
var $65283fdff51e8344$var$bo = Symbol(), $65283fdff51e8344$var$ko = Symbol();
function $65283fdff51e8344$var$_o(e, t, n, o) {
    if ($65283fdff51e8344$var$mn(e), $65283fdff51e8344$var$yn(t), n instanceof URL && (n = n.searchParams), !(n instanceof URLSearchParams)) throw $65283fdff51e8344$var$Lt('"parameters" must be an instance of URLSearchParams, or URL', $65283fdff51e8344$var$Nt);
    if ($65283fdff51e8344$var$vo(n, "response")) throw $65283fdff51e8344$var$$t('"parameters" contains a JARM response, use validateJwtAuthResponse() instead of validateAuthResponse()', $65283fdff51e8344$var$no, {
        parameters: n
    });
    var i = $65283fdff51e8344$var$vo(n, "iss"), r = $65283fdff51e8344$var$vo(n, "state");
    if (!i && e.authorization_response_iss_parameter_supported) throw $65283fdff51e8344$var$$t('response parameter "iss" (issuer) missing', $65283fdff51e8344$var$no, {
        parameters: n
    });
    if (i && i !== e.issuer) throw $65283fdff51e8344$var$$t('unexpected "iss" (issuer) response parameter value', $65283fdff51e8344$var$no, {
        expected: e.issuer,
        parameters: n
    });
    switch(o){
        case void 0:
        case $65283fdff51e8344$var$ko:
            if (void 0 !== r) throw $65283fdff51e8344$var$$t('unexpected "state" response parameter encountered', $65283fdff51e8344$var$no, {
                expected: void 0,
                parameters: n
            });
            break;
        case $65283fdff51e8344$var$bo:
            break;
        default:
            if ($65283fdff51e8344$var$cn(o, '"expectedState" argument'), r !== o) throw $65283fdff51e8344$var$$t(void 0 === r ? 'response parameter "state" missing' : 'unexpected "state" response parameter value', $65283fdff51e8344$var$no, {
                expected: o,
                parameters: n
            });
    }
    if ($65283fdff51e8344$var$vo(n, "error")) throw new $65283fdff51e8344$var$Tn("authorization response from the server is an error", {
        cause: n
    });
    var a = $65283fdff51e8344$var$vo(n, "id_token"), s = $65283fdff51e8344$var$vo(n, "token");
    if (void 0 !== a || void 0 !== s) throw new $65283fdff51e8344$var$qt("implicit and hybrid flows are not supported");
    var c;
    return c = new URLSearchParams(n), $65283fdff51e8344$var$Zn.add(c), c;
}
function $65283fdff51e8344$var$So(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(e) {
        var _$t, n, t;
        var _arguments = arguments;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = _arguments.length > 1 && void 0 !== _arguments[1] ? _arguments[1] : $65283fdff51e8344$var$un;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        e.json()
                    ];
                case 2:
                    _$t = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    t = _state.sent();
                    throw n(e), $65283fdff51e8344$var$$t('failed to parse "response" body as JSON', $65283fdff51e8344$var$to, t);
                case 4:
                    if (!$65283fdff51e8344$var$tn(_$t)) throw $65283fdff51e8344$var$$t('"response" body must be a top level object', $65283fdff51e8344$var$no, {
                        body: _$t
                    });
                    return [
                        2,
                        _$t
                    ];
            }
        });
    }).apply(this, arguments);
}
var $65283fdff51e8344$var$To = Symbol(), $65283fdff51e8344$var$Po = Symbol(), $65283fdff51e8344$var$Eo = new TextEncoder, $65283fdff51e8344$var$Ao = new TextDecoder;
function $65283fdff51e8344$var$Io() {
    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
    var o = t.reduce(function(e, t) {
        return e + t.length;
    }, 0), i = new Uint8Array(o);
    var r = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var e1 = _step.value;
            i.set(e1, r), r += e1.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return i;
}
function $65283fdff51e8344$var$xo(e) {
    var t = new Uint8Array(e.length);
    for(var n = 0; n < e.length; n++){
        var o = e.charCodeAt(n);
        if (o > 127) throw new TypeError("non-ASCII string encountered in encode()");
        t[n] = o;
    }
    return t;
}
function $65283fdff51e8344$var$Ro(e) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64(e);
    var t = atob(e), n = new Uint8Array(t.length);
    for(var _$e = 0; _$e < t.length; _$e++)n[_$e] = t.charCodeAt(_$e);
    return n;
}
function $65283fdff51e8344$var$Oo(e) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64("string" == typeof e ? e : $65283fdff51e8344$var$Ao.decode(e), {
        alphabet: "base64url"
    });
    var t = e;
    t instanceof Uint8Array && (t = $65283fdff51e8344$var$Ao.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/");
    try {
        return $65283fdff51e8344$var$Ro(t);
    } catch (e) {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
}
function $65283fdff51e8344$var$Co(e) {
    var t = e;
    return "string" == typeof t && (t = $65283fdff51e8344$var$Eo.encode(t)), Uint8Array.prototype.toBase64 ? t.toBase64({
        alphabet: "base64url",
        omitPadding: !0
    }) : (function(e) {
        if (Uint8Array.prototype.toBase64) return e.toBase64();
        var t = [];
        for(var n = 0; n < e.length; n += 32768)t.push(String.fromCharCode.apply(null, e.subarray(n, n + 32768)));
        return btoa(t.join(""));
    })(t).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
var $65283fdff51e8344$var$Wo = function Wo(e) {
    return new TypeError("CryptoKey does not support this operation, its ".concat(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "algorithm.name", " must be ").concat(e));
}, $65283fdff51e8344$var$jo = function(e, t) {
    return e.name === t;
};
function $65283fdff51e8344$var$Ko(e, t) {
    var n;
    if ((n = e.hash, parseInt(n.name.slice(4), 10)) !== t) throw $65283fdff51e8344$var$Wo("SHA-".concat(t), "algorithm.hash");
}
function $65283fdff51e8344$var$Uo(e, t, n) {
    switch(t){
        case "HS256":
        case "HS384":
        case "HS512":
            if (!$65283fdff51e8344$var$jo(e.algorithm, "HMAC")) throw $65283fdff51e8344$var$Wo("HMAC");
            $65283fdff51e8344$var$Ko(e.algorithm, parseInt(t.slice(2), 10));
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            if (!$65283fdff51e8344$var$jo(e.algorithm, "RSASSA-PKCS1-v1_5")) throw $65283fdff51e8344$var$Wo("RSASSA-PKCS1-v1_5");
            $65283fdff51e8344$var$Ko(e.algorithm, parseInt(t.slice(2), 10));
            break;
        case "PS256":
        case "PS384":
        case "PS512":
            if (!$65283fdff51e8344$var$jo(e.algorithm, "RSA-PSS")) throw $65283fdff51e8344$var$Wo("RSA-PSS");
            $65283fdff51e8344$var$Ko(e.algorithm, parseInt(t.slice(2), 10));
            break;
        case "Ed25519":
        case "EdDSA":
            if (!$65283fdff51e8344$var$jo(e.algorithm, "Ed25519")) throw $65283fdff51e8344$var$Wo("Ed25519");
            break;
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
            if (!$65283fdff51e8344$var$jo(e.algorithm, t)) throw $65283fdff51e8344$var$Wo(t);
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!$65283fdff51e8344$var$jo(e.algorithm, "ECDSA")) throw $65283fdff51e8344$var$Wo("ECDSA");
                var _$n = function(e) {
                    switch(e){
                        case "ES256":
                            return "P-256";
                        case "ES384":
                            return "P-384";
                        case "ES512":
                            return "P-521";
                        default:
                            throw new Error("unreachable");
                    }
                }(t);
                if (e.algorithm.namedCurve !== _$n) throw $65283fdff51e8344$var$Wo(_$n, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    !function(e, t) {
        if (t && !e.usages.includes(t)) throw new TypeError("CryptoKey does not support this operation, its usages must include ".concat(t, "."));
    }(e, n);
}
function $65283fdff51e8344$var$No(e, t) {
    for(var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)o[i - 2] = arguments[i];
    if ((o = o.filter(Boolean)).length > 2) {
        var _$t = o.pop();
        e += "one of type ".concat(o.join(", "), ", or ").concat(_$t, ".");
    } else 2 === o.length ? e += "one of type ".concat(o[0], " or ").concat(o[1], ".") : e += "of type ".concat(o[0], ".");
    if (null == t) e += " Received ".concat(t);
    else if ("function" == typeof t && t.name) e += " Received function ".concat(t.name);
    else if ("object" == (typeof t === "undefined" ? "undefined" : (0, $03bAP._)(t)) && null != t) {
        var r;
        null !== (r = t.constructor) && void 0 !== r && r.name && (e += " Received an instance of ".concat(t.constructor.name));
    }
    return e;
}
var $65283fdff51e8344$var$Lo = function Lo(e, t) {
    for(var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)o[i - 2] = arguments[i];
    return $65283fdff51e8344$var$No.apply(void 0, [
        "Key for the ".concat(e, " algorithm must be "),
        t
    ].concat((0, $XnYkK._)(o)));
};
var $65283fdff51e8344$var$Mo = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(Mo, Error1);
    function Mo(e, t) {
        (0, $5Epmf._)(this, Mo);
        var _this;
        var n;
        _this = (0, $48Z0s._)(this, Mo, [
            e,
            t
        ]), $65283fdff51e8344$var$d(_this, "code", "ERR_JOSE_GENERIC"), _this.name = _this.constructor.name, null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, _this, _this.constructor);
        return _this;
    }
    return Mo;
}((0, $kW1tL._)(Error));
$65283fdff51e8344$var$d($65283fdff51e8344$var$Mo, "code", "ERR_JOSE_GENERIC");
var $65283fdff51e8344$var$zo = /*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(zo, Mo);
    function zo(e, t) {
        (0, $5Epmf._)(this, zo);
        var _this;
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "unspecified", o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unspecified";
        _this = (0, $48Z0s._)(this, zo, [
            e,
            {
                cause: {
                    claim: n,
                    reason: o,
                    payload: t
                }
            }
        ]), $65283fdff51e8344$var$d(_this, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED"), $65283fdff51e8344$var$d(_this, "claim", void 0), $65283fdff51e8344$var$d(_this, "reason", void 0), $65283fdff51e8344$var$d(_this, "payload", void 0), _this.claim = n, _this.reason = o, _this.payload = t;
        return _this;
    }
    return zo;
}($65283fdff51e8344$var$Mo);
$65283fdff51e8344$var$d($65283fdff51e8344$var$zo, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED");
var $65283fdff51e8344$var$Do = /*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(Do, Mo);
    function Do(e, t) {
        (0, $5Epmf._)(this, Do);
        var _this;
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "unspecified", o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unspecified";
        _this = (0, $48Z0s._)(this, Do, [
            e,
            {
                cause: {
                    claim: n,
                    reason: o,
                    payload: t
                }
            }
        ]), $65283fdff51e8344$var$d(_this, "code", "ERR_JWT_EXPIRED"), $65283fdff51e8344$var$d(_this, "claim", void 0), $65283fdff51e8344$var$d(_this, "reason", void 0), $65283fdff51e8344$var$d(_this, "payload", void 0), _this.claim = n, _this.reason = o, _this.payload = t;
        return _this;
    }
    return Do;
}($65283fdff51e8344$var$Mo);
$65283fdff51e8344$var$d($65283fdff51e8344$var$Do, "code", "ERR_JWT_EXPIRED");
var $65283fdff51e8344$var$Jo = /*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(Jo, Mo);
    function Jo() {
        (0, $5Epmf._)(this, Jo);
        var _this;
        _this = (0, $48Z0s._)(this, Jo, arguments), $65283fdff51e8344$var$d(_this, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
        return _this;
    }
    return Jo;
}($65283fdff51e8344$var$Mo);
$65283fdff51e8344$var$d($65283fdff51e8344$var$Jo, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
var $65283fdff51e8344$var$Ho = /*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(Ho, Mo);
    function Ho() {
        (0, $5Epmf._)(this, Ho);
        var _this;
        _this = (0, $48Z0s._)(this, Ho, arguments), $65283fdff51e8344$var$d(_this, "code", "ERR_JOSE_NOT_SUPPORTED");
        return _this;
    }
    return Ho;
}($65283fdff51e8344$var$Mo);
$65283fdff51e8344$var$d($65283fdff51e8344$var$Ho, "code", "ERR_JOSE_NOT_SUPPORTED");
$65283fdff51e8344$var$d(/*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(_class, Mo);
    function _class() {
        (0, $5Epmf._)(this, _class);
        var _this;
        _this = (0, $48Z0s._)(this, _class, [
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "decryption operation failed",
            arguments.length > 1 ? arguments[1] : void 0
        ]), $65283fdff51e8344$var$d(_this, "code", "ERR_JWE_DECRYPTION_FAILED");
        return _this;
    }
    return _class;
}($65283fdff51e8344$var$Mo), "code", "ERR_JWE_DECRYPTION_FAILED");
$65283fdff51e8344$var$d(/*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(_class, Mo);
    function _class() {
        (0, $5Epmf._)(this, _class);
        var _this;
        _this = (0, $48Z0s._)(this, _class, arguments), $65283fdff51e8344$var$d(_this, "code", "ERR_JWE_INVALID");
        return _this;
    }
    return _class;
}($65283fdff51e8344$var$Mo), "code", "ERR_JWE_INVALID");
var $65283fdff51e8344$var$Zo = /*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(Zo, Mo);
    function Zo() {
        (0, $5Epmf._)(this, Zo);
        var _this;
        _this = (0, $48Z0s._)(this, Zo, arguments), $65283fdff51e8344$var$d(_this, "code", "ERR_JWS_INVALID");
        return _this;
    }
    return Zo;
}($65283fdff51e8344$var$Mo);
$65283fdff51e8344$var$d($65283fdff51e8344$var$Zo, "code", "ERR_JWS_INVALID");
var $65283fdff51e8344$var$Fo = /*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(Fo, Mo);
    function Fo() {
        (0, $5Epmf._)(this, Fo);
        var _this;
        _this = (0, $48Z0s._)(this, Fo, arguments), $65283fdff51e8344$var$d(_this, "code", "ERR_JWT_INVALID");
        return _this;
    }
    return Fo;
}($65283fdff51e8344$var$Mo);
$65283fdff51e8344$var$d($65283fdff51e8344$var$Fo, "code", "ERR_JWT_INVALID");
$65283fdff51e8344$var$d(/*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(_class, Mo);
    function _class() {
        (0, $5Epmf._)(this, _class);
        var _this;
        _this = (0, $48Z0s._)(this, _class, arguments), $65283fdff51e8344$var$d(_this, "code", "ERR_JWK_INVALID");
        return _this;
    }
    return _class;
}($65283fdff51e8344$var$Mo), "code", "ERR_JWK_INVALID");
var $65283fdff51e8344$var$Vo = /*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(Vo, Mo);
    function Vo() {
        (0, $5Epmf._)(this, Vo);
        var _this;
        _this = (0, $48Z0s._)(this, Vo, arguments), $65283fdff51e8344$var$d(_this, "code", "ERR_JWKS_INVALID");
        return _this;
    }
    return Vo;
}($65283fdff51e8344$var$Mo);
$65283fdff51e8344$var$d($65283fdff51e8344$var$Vo, "code", "ERR_JWKS_INVALID");
var $65283fdff51e8344$var$Xo = /*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(Xo, Mo);
    function Xo() {
        (0, $5Epmf._)(this, Xo);
        var _this;
        _this = (0, $48Z0s._)(this, Xo, [
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "no applicable key found in the JSON Web Key Set",
            arguments.length > 1 ? arguments[1] : void 0
        ]), $65283fdff51e8344$var$d(_this, "code", "ERR_JWKS_NO_MATCHING_KEY");
        return _this;
    }
    return Xo;
}($65283fdff51e8344$var$Mo);
$65283fdff51e8344$var$d($65283fdff51e8344$var$Xo, "code", "ERR_JWKS_NO_MATCHING_KEY");
var $65283fdff51e8344$var$Go = /*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(Go, Mo);
    function Go() {
        (0, $5Epmf._)(this, Go);
        var _this;
        _this = (0, $48Z0s._)(this, Go, [
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "multiple matching keys found in the JSON Web Key Set",
            arguments.length > 1 ? arguments[1] : void 0
        ]), $65283fdff51e8344$var$d(_this, Symbol.asyncIterator, void 0), $65283fdff51e8344$var$d(_this, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
        return _this;
    }
    return Go;
}($65283fdff51e8344$var$Mo);
$65283fdff51e8344$var$d($65283fdff51e8344$var$Go, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
var $65283fdff51e8344$var$Yo = /*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(Yo, Mo);
    function Yo() {
        (0, $5Epmf._)(this, Yo);
        var _this;
        _this = (0, $48Z0s._)(this, Yo, [
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "request timed out",
            arguments.length > 1 ? arguments[1] : void 0
        ]), $65283fdff51e8344$var$d(_this, "code", "ERR_JWKS_TIMEOUT");
        return _this;
    }
    return Yo;
}($65283fdff51e8344$var$Mo);
$65283fdff51e8344$var$d($65283fdff51e8344$var$Yo, "code", "ERR_JWKS_TIMEOUT");
var $65283fdff51e8344$var$Bo = /*#__PURE__*/ function(Mo) {
    "use strict";
    (0, $4QAx6._)(Bo, Mo);
    function Bo() {
        (0, $5Epmf._)(this, Bo);
        var _this;
        _this = (0, $48Z0s._)(this, Bo, [
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "signature verification failed",
            arguments.length > 1 ? arguments[1] : void 0
        ]), $65283fdff51e8344$var$d(_this, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
        return _this;
    }
    return Bo;
}($65283fdff51e8344$var$Mo);
$65283fdff51e8344$var$d($65283fdff51e8344$var$Bo, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
var $65283fdff51e8344$var$qo = function(e) {
    if ("CryptoKey" === (null == e ? void 0 : e[Symbol.toStringTag])) return !0;
    try {
        return e instanceof CryptoKey;
    } catch (e) {
        return !1;
    }
}, $65283fdff51e8344$var$Qo = function(e) {
    return "KeyObject" === (null == e ? void 0 : e[Symbol.toStringTag]);
}, $65283fdff51e8344$var$$o = function(e) {
    return $65283fdff51e8344$var$qo(e) || $65283fdff51e8344$var$Qo(e);
};
function $65283fdff51e8344$var$ei(e, t) {
    if (e) throw new TypeError("".concat(t, " can only be called once"));
}
function $65283fdff51e8344$var$ti(e, t, n) {
    try {
        return $65283fdff51e8344$var$Oo(e);
    } catch (e) {
        throw new n("Failed to base64url decode the ".concat(t));
    }
}
function $65283fdff51e8344$var$ni(e) {
    if ("object" != (0, $03bAP._)(t = e) || null === t || "[object Object]" !== Object.prototype.toString.call(e)) return !1;
    var t;
    if (null === Object.getPrototypeOf(e)) return !0;
    var n = e;
    for(; null !== Object.getPrototypeOf(n);)n = Object.getPrototypeOf(n);
    return Object.getPrototypeOf(e) === n;
}
function $65283fdff51e8344$var$oi() {
    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
    var o = t.filter(Boolean);
    if (0 === o.length || 1 === o.length) return !0;
    var i;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var e1 = _step.value;
            var t1 = Object.keys(e1);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (i && 0 !== i.size) try {
                for(var _iterator1 = t1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var e2 = _step1.value;
                    if (i.has(e2)) return !1;
                    i.add(e2);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            else i = new Set(t1);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return !0;
}
var $65283fdff51e8344$var$ii = function(e) {
    return $65283fdff51e8344$var$ni(e) && "string" == typeof e.kty;
};
function $65283fdff51e8344$var$ri(e, t) {
    if (e.startsWith("RS") || e.startsWith("PS")) {
        var n = t.algorithm.modulusLength;
        if ("number" != typeof n || n < 2048) throw new TypeError("".concat(e, " requires key modulusLength to be 2048 bits or larger"));
    }
}
function $65283fdff51e8344$var$ai(e, t) {
    var n = "SHA-".concat(e.slice(-3));
    switch(e){
        case "HS256":
        case "HS384":
        case "HS512":
            return {
                hash: n,
                name: "HMAC"
            };
        case "PS256":
        case "PS384":
        case "PS512":
            return {
                hash: n,
                name: "RSA-PSS",
                saltLength: parseInt(e.slice(-3), 10) >> 3
            };
        case "RS256":
        case "RS384":
        case "RS512":
            return {
                hash: n,
                name: "RSASSA-PKCS1-v1_5"
            };
        case "ES256":
        case "ES384":
        case "ES512":
            return {
                hash: n,
                name: "ECDSA",
                namedCurve: t.namedCurve
            };
        case "Ed25519":
        case "EdDSA":
            return {
                name: "Ed25519"
            };
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
            return {
                name: e
            };
        default:
            throw new $65283fdff51e8344$var$Ho("alg ".concat(e, " is not supported either by JOSE or your javascript runtime"));
    }
}
function $65283fdff51e8344$var$si(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        return (0, $3SMYb._)(this, function(_state) {
            if (t instanceof Uint8Array) {
                if (!e.startsWith("HS")) throw new TypeError(function(e) {
                    for(var _$t = arguments.length, _$n = new Array(_$t > 1 ? _$t - 1 : 0), o = 1; o < _$t; o++)_$n[o - 1] = arguments[o];
                    return $65283fdff51e8344$var$No.apply(void 0, [
                        "Key must be ",
                        e
                    ].concat((0, $XnYkK._)(_$n)));
                }(t, "CryptoKey", "KeyObject", "JSON Web Key"));
                return [
                    2,
                    crypto.subtle.importKey("raw", t, {
                        hash: "SHA-".concat(e.slice(-3)),
                        name: "HMAC"
                    }, !1, [
                        n
                    ])
                ];
            }
            return [
                2,
                ($65283fdff51e8344$var$Uo(t, e, n), t)
            ];
        });
    })();
}
var $65283fdff51e8344$var$ci = 'Invalid or unsupported JWK "alg" (Algorithm) Parameter value';
function $65283fdff51e8344$var$ui(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var t, n, o, i, r, a;
        return (0, $3SMYb._)(this, function(_state) {
            if (!e.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
            o = function(e) {
                var t, n;
                switch(e.kty){
                    case "AKP":
                        switch(e.alg){
                            case "ML-DSA-44":
                            case "ML-DSA-65":
                            case "ML-DSA-87":
                                t = {
                                    name: e.alg
                                }, n = e.priv ? [
                                    "sign"
                                ] : [
                                    "verify"
                                ];
                                break;
                            default:
                                throw new $65283fdff51e8344$var$Ho($65283fdff51e8344$var$ci);
                        }
                        break;
                    case "RSA":
                        switch(e.alg){
                            case "PS256":
                            case "PS384":
                            case "PS512":
                                t = {
                                    name: "RSA-PSS",
                                    hash: "SHA-".concat(e.alg.slice(-3))
                                }, n = e.d ? [
                                    "sign"
                                ] : [
                                    "verify"
                                ];
                                break;
                            case "RS256":
                            case "RS384":
                            case "RS512":
                                t = {
                                    name: "RSASSA-PKCS1-v1_5",
                                    hash: "SHA-".concat(e.alg.slice(-3))
                                }, n = e.d ? [
                                    "sign"
                                ] : [
                                    "verify"
                                ];
                                break;
                            case "RSA-OAEP":
                            case "RSA-OAEP-256":
                            case "RSA-OAEP-384":
                            case "RSA-OAEP-512":
                                t = {
                                    name: "RSA-OAEP",
                                    hash: "SHA-".concat(parseInt(e.alg.slice(-3), 10) || 1)
                                }, n = e.d ? [
                                    "decrypt",
                                    "unwrapKey"
                                ] : [
                                    "encrypt",
                                    "wrapKey"
                                ];
                                break;
                            default:
                                throw new $65283fdff51e8344$var$Ho($65283fdff51e8344$var$ci);
                        }
                        break;
                    case "EC":
                        switch(e.alg){
                            case "ES256":
                            case "ES384":
                            case "ES512":
                                t = {
                                    name: "ECDSA",
                                    namedCurve: ({
                                        ES256: "P-256",
                                        ES384: "P-384",
                                        ES512: "P-521"
                                    })[e.alg]
                                }, n = e.d ? [
                                    "sign"
                                ] : [
                                    "verify"
                                ];
                                break;
                            case "ECDH-ES":
                            case "ECDH-ES+A128KW":
                            case "ECDH-ES+A192KW":
                            case "ECDH-ES+A256KW":
                                t = {
                                    name: "ECDH",
                                    namedCurve: e.crv
                                }, n = e.d ? [
                                    "deriveBits"
                                ] : [];
                                break;
                            default:
                                throw new $65283fdff51e8344$var$Ho($65283fdff51e8344$var$ci);
                        }
                        break;
                    case "OKP":
                        switch(e.alg){
                            case "Ed25519":
                            case "EdDSA":
                                t = {
                                    name: "Ed25519"
                                }, n = e.d ? [
                                    "sign"
                                ] : [
                                    "verify"
                                ];
                                break;
                            case "ECDH-ES":
                            case "ECDH-ES+A128KW":
                            case "ECDH-ES+A192KW":
                            case "ECDH-ES+A256KW":
                                t = {
                                    name: e.crv
                                }, n = e.d ? [
                                    "deriveBits"
                                ] : [];
                                break;
                            default:
                                throw new $65283fdff51e8344$var$Ho($65283fdff51e8344$var$ci);
                        }
                        break;
                    default:
                        throw new $65283fdff51e8344$var$Ho('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
                }
                return {
                    algorithm: t,
                    keyUsages: n
                };
            }(e), i = o.algorithm, r = o.keyUsages, a = $65283fdff51e8344$var$f({}, e);
            return [
                2,
                ("AKP" !== a.kty && delete a.alg, delete a.use, crypto.subtle.importKey("jwk", a, i, null !== (t = e.ext) && void 0 !== t ? t : !e.d && !e.priv, null !== (n = e.key_ops) && void 0 !== n ? n : r))
            ];
        });
    })();
}
var $65283fdff51e8344$var$li = "given KeyObject instance cannot be used for this algorithm";
var $65283fdff51e8344$var$hi;
var $65283fdff51e8344$var$di = function di(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(e, t, n) {
        var o, i, r;
        var _arguments = arguments;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    o = _arguments.length > 3 && void 0 !== _arguments[3] && _arguments[3];
                    $65283fdff51e8344$var$hi || ($65283fdff51e8344$var$hi = new WeakMap);
                    i = $65283fdff51e8344$var$hi.get(e);
                    if (null != i && i[n]) return [
                        2,
                        i[n]
                    ];
                    return [
                        4,
                        $65283fdff51e8344$var$ui($65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, t), {}, {
                            alg: n
                        }))
                    ];
                case 1:
                    r = _state.sent();
                    return [
                        2,
                        (o && Object.freeze(e), i ? i[n] = r : $65283fdff51e8344$var$hi.set(e, (0, $dUlz9._)({}, n, r)), r)
                    ];
            }
        });
    }).apply(this, arguments);
};
function $65283fdff51e8344$var$pi(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var n;
        return (0, $3SMYb._)(this, function(_state) {
            if (e instanceof Uint8Array) return [
                2,
                e
            ];
            if ($65283fdff51e8344$var$qo(e)) return [
                2,
                e
            ];
            if ($65283fdff51e8344$var$Qo(e)) {
                if ("secret" === e.type) return [
                    2,
                    e.export()
                ];
                if ("toCryptoKey" in e && "function" == typeof e.toCryptoKey) try {
                    return [
                        2,
                        function(e, t) {
                            $65283fdff51e8344$var$hi || ($65283fdff51e8344$var$hi = new WeakMap);
                            var n = $65283fdff51e8344$var$hi.get(e);
                            if (null != n && n[t]) return n[t];
                            var o = "public" === e.type, i = !!o;
                            var r;
                            if ("x25519" === e.asymmetricKeyType) {
                                switch(t){
                                    case "ECDH-ES":
                                    case "ECDH-ES+A128KW":
                                    case "ECDH-ES+A192KW":
                                    case "ECDH-ES+A256KW":
                                        break;
                                    default:
                                        throw new TypeError($65283fdff51e8344$var$li);
                                }
                                r = e.toCryptoKey(e.asymmetricKeyType, i, o ? [] : [
                                    "deriveBits"
                                ]);
                            }
                            if ("ed25519" === e.asymmetricKeyType) {
                                if ("EdDSA" !== t && "Ed25519" !== t) throw new TypeError($65283fdff51e8344$var$li);
                                r = e.toCryptoKey(e.asymmetricKeyType, i, [
                                    o ? "verify" : "sign"
                                ]);
                            }
                            switch(e.asymmetricKeyType){
                                case "ml-dsa-44":
                                case "ml-dsa-65":
                                case "ml-dsa-87":
                                    if (t !== e.asymmetricKeyType.toUpperCase()) throw new TypeError($65283fdff51e8344$var$li);
                                    r = e.toCryptoKey(e.asymmetricKeyType, i, [
                                        o ? "verify" : "sign"
                                    ]);
                            }
                            if ("rsa" === e.asymmetricKeyType) {
                                var n1;
                                switch(t){
                                    case "RSA-OAEP":
                                        n1 = "SHA-1";
                                        break;
                                    case "RS256":
                                    case "PS256":
                                    case "RSA-OAEP-256":
                                        n1 = "SHA-256";
                                        break;
                                    case "RS384":
                                    case "PS384":
                                    case "RSA-OAEP-384":
                                        n1 = "SHA-384";
                                        break;
                                    case "RS512":
                                    case "PS512":
                                    case "RSA-OAEP-512":
                                        n1 = "SHA-512";
                                        break;
                                    default:
                                        throw new TypeError($65283fdff51e8344$var$li);
                                }
                                if (t.startsWith("RSA-OAEP")) return e.toCryptoKey({
                                    name: "RSA-OAEP",
                                    hash: n1
                                }, i, o ? [
                                    "encrypt"
                                ] : [
                                    "decrypt"
                                ]);
                                r = e.toCryptoKey({
                                    name: t.startsWith("PS") ? "RSA-PSS" : "RSASSA-PKCS1-v1_5",
                                    hash: n1
                                }, i, [
                                    o ? "verify" : "sign"
                                ]);
                            }
                            if ("ec" === e.asymmetricKeyType) {
                                var a;
                                var n2 = new Map([
                                    [
                                        "prime256v1",
                                        "P-256"
                                    ],
                                    [
                                        "secp384r1",
                                        "P-384"
                                    ],
                                    [
                                        "secp521r1",
                                        "P-521"
                                    ]
                                ]).get(null === (a = e.asymmetricKeyDetails) || void 0 === a ? void 0 : a.namedCurve);
                                if (!n2) throw new TypeError($65283fdff51e8344$var$li);
                                var s = {
                                    ES256: "P-256",
                                    ES384: "P-384",
                                    ES512: "P-521"
                                };
                                s[t] && n2 === s[t] && (r = e.toCryptoKey({
                                    name: "ECDSA",
                                    namedCurve: n2
                                }, i, [
                                    o ? "verify" : "sign"
                                ])), t.startsWith("ECDH-ES") && (r = e.toCryptoKey({
                                    name: "ECDH",
                                    namedCurve: n2
                                }, i, o ? [] : [
                                    "deriveBits"
                                ]));
                            }
                            if (!r) throw new TypeError($65283fdff51e8344$var$li);
                            return n ? n[t] = r : $65283fdff51e8344$var$hi.set(e, (0, $dUlz9._)({}, t, r)), r;
                        }(e, t)
                    ];
                } catch (e) {
                    if (e instanceof TypeError) throw e;
                }
                n = e.export({
                    format: "jwk"
                });
                return [
                    2,
                    $65283fdff51e8344$var$di(e, n, t)
                ];
            }
            if ($65283fdff51e8344$var$ii(e)) return [
                2,
                e.k ? $65283fdff51e8344$var$Oo(e.k) : $65283fdff51e8344$var$di(e, e, t, !0)
            ];
            throw new Error("unreachable");
        });
    })();
}
var $65283fdff51e8344$var$fi = function(e, t) {
    if (e.byteLength !== t.length) return !1;
    for(var n = 0; n < e.byteLength; n++)if (e[n] !== t[n]) return !1;
    return !0;
}, $65283fdff51e8344$var$mi = function(e) {
    var t = e.data[e.pos++];
    if (128 & t) {
        var n = 127 & t;
        var o = 0;
        for(var t1 = 0; t1 < n; t1++)o = o << 8 | e.data[e.pos++];
        return o;
    }
    return t;
}, $65283fdff51e8344$var$yi = function(e, t, n) {
    if (e.data[e.pos++] !== t) throw new Error(n);
}, $65283fdff51e8344$var$wi = function(e, t) {
    var n = e.data.subarray(e.pos, e.pos + t);
    return e.pos += t, n;
};
var $65283fdff51e8344$var$gi = function(e) {
    var t = function(e) {
        $65283fdff51e8344$var$yi(e, 6, "Expected algorithm OID");
        var t = $65283fdff51e8344$var$mi(e);
        return $65283fdff51e8344$var$wi(e, t);
    }(e);
    if ($65283fdff51e8344$var$fi(t, [
        43,
        101,
        110
    ])) return "X25519";
    if (!$65283fdff51e8344$var$fi(t, [
        42,
        134,
        72,
        206,
        61,
        2,
        1
    ])) throw new Error("Unsupported key algorithm");
    $65283fdff51e8344$var$yi(e, 6, "Expected curve OID");
    var n = $65283fdff51e8344$var$mi(e), o = $65283fdff51e8344$var$wi(e, n);
    for(var _i = 0, _iter = [
        {
            name: "P-256",
            oid: [
                42,
                134,
                72,
                206,
                61,
                3,
                1,
                7
            ]
        },
        {
            name: "P-384",
            oid: [
                43,
                129,
                4,
                0,
                34
            ]
        },
        {
            name: "P-521",
            oid: [
                43,
                129,
                4,
                0,
                35
            ]
        }
    ]; _i < _iter.length; _i++){
        var _$e = _iter[_i];
        var t1 = _$e.name, n1 = _$e.oid;
        if ($65283fdff51e8344$var$fi(o, n1)) return t1;
    }
    throw new Error("Unsupported named curve");
}, $65283fdff51e8344$var$vi = function(e, t, n, o) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var i, r, a, s, c, _$e;
        return (0, $3SMYb._)(this, function(_state) {
            s = "spki" === e, c = function() {
                return s ? [
                    "verify"
                ] : [
                    "sign"
                ];
            };
            switch(n){
                case "PS256":
                case "PS384":
                case "PS512":
                    r = {
                        name: "RSA-PSS",
                        hash: "SHA-".concat(n.slice(-3))
                    }, a = c();
                    break;
                case "RS256":
                case "RS384":
                case "RS512":
                    r = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: "SHA-".concat(n.slice(-3))
                    }, a = c();
                    break;
                case "RSA-OAEP":
                case "RSA-OAEP-256":
                case "RSA-OAEP-384":
                case "RSA-OAEP-512":
                    r = {
                        name: "RSA-OAEP",
                        hash: "SHA-".concat(parseInt(n.slice(-3), 10) || 1)
                    }, a = s ? [
                        "encrypt",
                        "wrapKey"
                    ] : [
                        "decrypt",
                        "unwrapKey"
                    ];
                    break;
                case "ES256":
                case "ES384":
                case "ES512":
                    r = {
                        name: "ECDSA",
                        namedCurve: ({
                            ES256: "P-256",
                            ES384: "P-384",
                            ES512: "P-521"
                        })[n]
                    }, a = c();
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    try {
                        _$e = o.getNamedCurve(t);
                        r = "X25519" === _$e ? {
                            name: "X25519"
                        } : {
                            name: "ECDH",
                            namedCurve: _$e
                        };
                    } catch (e) {
                        throw new $65283fdff51e8344$var$Ho("Invalid or unsupported key format");
                    }
                    a = s ? [] : [
                        "deriveBits"
                    ];
                    break;
                case "Ed25519":
                case "EdDSA":
                    r = {
                        name: "Ed25519"
                    }, a = c();
                    break;
                case "ML-DSA-44":
                case "ML-DSA-65":
                case "ML-DSA-87":
                    r = {
                        name: n
                    }, a = c();
                    break;
                default:
                    throw new $65283fdff51e8344$var$Ho('Invalid or unsupported "alg" (Algorithm) value');
            }
            return [
                2,
                crypto.subtle.importKey(e, t, r, null !== (i = null == o ? void 0 : o.extractable) && void 0 !== i ? i : !!s, a)
            ];
        });
    })();
}, $65283fdff51e8344$var$bi = function(e, t, n) {
    var o;
    var i = function(e, t) {
        return $65283fdff51e8344$var$Ro(e.replace(t, ""));
    }(e, /(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g);
    var r = n;
    return null != t && null !== (o = t.startsWith) && void 0 !== o && o.call(t, "ECDH-ES") && (r || (r = {}), r.getNamedCurve = function(e) {
        var _$t = {
            data: e,
            pos: 0
        };
        return function(e) {
            $65283fdff51e8344$var$yi(e, 48, "Invalid PKCS#8 structure"), $65283fdff51e8344$var$mi(e), $65283fdff51e8344$var$yi(e, 2, "Expected version field");
            var _$t = $65283fdff51e8344$var$mi(e);
            e.pos += _$t, $65283fdff51e8344$var$yi(e, 48, "Expected algorithm identifier");
            $65283fdff51e8344$var$mi(e);
            e.pos;
        }(_$t), $65283fdff51e8344$var$gi(_$t);
    }), $65283fdff51e8344$var$vi("pkcs8", i, t, r);
};
function $65283fdff51e8344$var$ki(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        return (0, $3SMYb._)(this, function(_state) {
            if ("string" != typeof e || 0 !== e.indexOf("-----BEGIN PRIVATE KEY-----")) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
            return [
                2,
                $65283fdff51e8344$var$bi(e, t, n)
            ];
        });
    })();
}
function $65283fdff51e8344$var$_i(e, t, n, o, i) {
    if (void 0 !== i.crit && void 0 === (null == o ? void 0 : o.crit)) throw new e('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!o || void 0 === o.crit) return new Set;
    if (!Array.isArray(o.crit) || 0 === o.crit.length || o.crit.some(function(e) {
        return "string" != typeof e || 0 === e.length;
    })) throw new e('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    var r;
    r = void 0 !== n ? new Map((0, $XnYkK._)(Object.entries(n)).concat((0, $XnYkK._)(t.entries()))) : t;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = o.crit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$t = _step.value;
            if (!r.has(_$t)) throw new $65283fdff51e8344$var$Ho('Extension Header Parameter "'.concat(_$t, '" is not recognized'));
            if (void 0 === i[_$t]) throw new e('Extension Header Parameter "'.concat(_$t, '" is missing'));
            if (r.get(_$t) && void 0 === o[_$t]) throw new e('Extension Header Parameter "'.concat(_$t, '" MUST be integrity protected'));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return new Set(o.crit);
}
var $65283fdff51e8344$var$Si = function(e) {
    return null == e ? void 0 : e[Symbol.toStringTag];
}, $65283fdff51e8344$var$Ti = function(e, t, n) {
    if (void 0 !== t.use) {
        var _$e;
        switch(n){
            case "sign":
            case "verify":
                _$e = "sig";
                break;
            case "encrypt":
            case "decrypt":
                _$e = "enc";
        }
        if (t.use !== _$e) throw new TypeError('Invalid key for this operation, its "use" must be "'.concat(_$e, '" when present'));
    }
    if (void 0 !== t.alg && t.alg !== e) throw new TypeError('Invalid key for this operation, its "alg" must be "'.concat(e, '" when present'));
    if (Array.isArray(t.key_ops)) {
        var o, i;
        var r;
        switch(!0){
            case "sign" === n || "verify" === n:
            case "dir" === e:
            case e.includes("CBC-HS"):
                r = n;
                break;
            case e.startsWith("PBES2"):
                r = "deriveBits";
                break;
            case /^A\d{3}(?:GCM)?(?:KW)?$/.test(e):
                r = !e.includes("GCM") && e.endsWith("KW") ? "encrypt" === n ? "wrapKey" : "unwrapKey" : n;
                break;
            case "encrypt" === n && e.startsWith("RSA"):
                r = "wrapKey";
                break;
            case "decrypt" === n:
                r = e.startsWith("RSA") ? "unwrapKey" : "deriveBits";
        }
        if (r && !1 === (null === (o = t.key_ops) || void 0 === o || null === (i = o.includes) || void 0 === i ? void 0 : i.call(o, r))) throw new TypeError('Invalid key for this operation, its "key_ops" must include "'.concat(r, '" when present'));
    }
    return !0;
};
function $65283fdff51e8344$var$Pi(e, t, n) {
    switch(e.substring(0, 2)){
        case "A1":
        case "A2":
        case "di":
        case "HS":
        case "PB":
            (function(e, t, n) {
                if (!(t instanceof Uint8Array)) {
                    if ($65283fdff51e8344$var$ii(t)) {
                        if (function(e) {
                            return "oct" === e.kty && "string" == typeof e.k;
                        }(t) && $65283fdff51e8344$var$Ti(e, t, n)) return;
                        throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
                    }
                    if (!$65283fdff51e8344$var$$o(t)) throw new TypeError($65283fdff51e8344$var$Lo(e, t, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array"));
                    if ("secret" !== t.type) throw new TypeError("".concat($65283fdff51e8344$var$Si(t), ' instances for symmetric algorithms must be of type "secret"'));
                }
            })(e, t, n);
            break;
        default:
            (function(e, t, n) {
                if ($65283fdff51e8344$var$ii(t)) switch(n){
                    case "decrypt":
                    case "sign":
                        if (function(e) {
                            return "oct" !== e.kty && ("AKP" === e.kty && "string" == typeof e.priv || "string" == typeof e.d);
                        }(t) && $65283fdff51e8344$var$Ti(e, t, n)) return;
                        throw new TypeError("JSON Web Key for this operation must be a private JWK");
                    case "encrypt":
                    case "verify":
                        if (function(e) {
                            return "oct" !== e.kty && void 0 === e.d && void 0 === e.priv;
                        }(t) && $65283fdff51e8344$var$Ti(e, t, n)) return;
                        throw new TypeError("JSON Web Key for this operation must be a public JWK");
                }
                if (!$65283fdff51e8344$var$$o(t)) throw new TypeError($65283fdff51e8344$var$Lo(e, t, "CryptoKey", "KeyObject", "JSON Web Key"));
                if ("secret" === t.type) throw new TypeError("".concat($65283fdff51e8344$var$Si(t), ' instances for asymmetric algorithms must not be of type "secret"'));
                if ("public" === t.type) switch(n){
                    case "sign":
                        throw new TypeError("".concat($65283fdff51e8344$var$Si(t), ' instances for asymmetric algorithm signing must be of type "private"'));
                    case "decrypt":
                        throw new TypeError("".concat($65283fdff51e8344$var$Si(t), ' instances for asymmetric algorithm decryption must be of type "private"'));
                }
                if ("private" === t.type) switch(n){
                    case "verify":
                        throw new TypeError("".concat($65283fdff51e8344$var$Si(t), ' instances for asymmetric algorithm verifying must be of type "public"'));
                    case "encrypt":
                        throw new TypeError("".concat($65283fdff51e8344$var$Si(t), ' instances for asymmetric algorithm encryption must be of type "public"'));
                }
            })(e, t, n);
    }
}
var $65283fdff51e8344$var$Ei, $65283fdff51e8344$var$Ai;
var $65283fdff51e8344$var$Ii, $65283fdff51e8344$var$xi;
if ("undefined" == typeof navigator || null === ($65283fdff51e8344$var$Ei = navigator.userAgent) || void 0 === $65283fdff51e8344$var$Ei || null === ($65283fdff51e8344$var$Ai = $65283fdff51e8344$var$Ei.startsWith) || void 0 === $65283fdff51e8344$var$Ai || !$65283fdff51e8344$var$Ai.call($65283fdff51e8344$var$Ei, "Mozilla/5.0 ")) {
    var $65283fdff51e8344$var$e4 = "v6.8.4";
    $65283fdff51e8344$var$xi = "".concat("openid-client", "/").concat($65283fdff51e8344$var$e4), $65283fdff51e8344$var$Ii = {
        "user-agent": $65283fdff51e8344$var$xi
    };
}
var $65283fdff51e8344$var$Ri = function(e) {
    return $65283fdff51e8344$var$Oi.get(e);
};
var $65283fdff51e8344$var$Oi, $65283fdff51e8344$var$Ci;
function $65283fdff51e8344$var$Wi(e) {
    return void 0 !== e ? $65283fdff51e8344$var$wn(e) : ($65283fdff51e8344$var$Ci || ($65283fdff51e8344$var$Ci = new WeakMap), function(e, t, n, o) {
        var i;
        return (i = $65283fdff51e8344$var$Ci.get(t)) || (!function(e, t) {
            if ("string" != typeof e) throw $65283fdff51e8344$var$Ni("".concat(t, " must be a string"), $65283fdff51e8344$var$Ui);
            if (0 === e.length) throw $65283fdff51e8344$var$Ni("".concat(t, " must not be empty"), $65283fdff51e8344$var$Ki);
        }(t.client_secret, '"metadata.client_secret"'), i = $65283fdff51e8344$var$wn(t.client_secret), $65283fdff51e8344$var$Ci.set(t, i)), i(e, t, n, o);
    });
}
var $65283fdff51e8344$var$ji = $65283fdff51e8344$var$Jt, $65283fdff51e8344$var$Ki = "ERR_INVALID_ARG_VALUE", $65283fdff51e8344$var$Ui = "ERR_INVALID_ARG_TYPE";
function $65283fdff51e8344$var$Ni(e, t, n) {
    var o = new TypeError(e, {
        cause: n
    });
    return Object.assign(o, {
        code: t
    }), o;
}
function $65283fdff51e8344$var$Li(e) {
    return function(e) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $65283fdff51e8344$var$cn(e, "codeVerifier");
                        return [
                            4,
                            crypto.subtle.digest("SHA-256", $65283fdff51e8344$var$Xt(e))
                        ];
                    case 1:
                        return [
                            2,
                            $65283fdff51e8344$var$Bt.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        })();
    }(e);
}
function $65283fdff51e8344$var$Mi() {
    return $65283fdff51e8344$var$ln();
}
var $65283fdff51e8344$var$zi = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(zi, Error1);
    function zi(e, t) {
        (0, $5Epmf._)(this, zi);
        var _this;
        var n;
        _this = (0, $48Z0s._)(this, zi, [
            e,
            t
        ]), $65283fdff51e8344$var$d(_this, "code", void 0), _this.name = _this.constructor.name, _this.code = null == t ? void 0 : t.code, null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, _this, _this.constructor);
        return _this;
    }
    return zi;
}((0, $kW1tL._)(Error));
function $65283fdff51e8344$var$Di(e, t, n) {
    return new $65283fdff51e8344$var$zi(e, {
        cause: t,
        code: n
    });
}
function $65283fdff51e8344$var$Ji(e) {
    if (e instanceof TypeError || e instanceof $65283fdff51e8344$var$zi || e instanceof $65283fdff51e8344$var$Sn || e instanceof $65283fdff51e8344$var$Tn || e instanceof $65283fdff51e8344$var$Pn) throw e;
    if (e instanceof $65283fdff51e8344$var$Qt) switch(e.code){
        case $65283fdff51e8344$var$ro:
            throw $65283fdff51e8344$var$Di("only requests to HTTPS are allowed", e, e.code);
        case $65283fdff51e8344$var$ao:
            throw $65283fdff51e8344$var$Di("only requests to HTTP or HTTPS are allowed", e, e.code);
        case $65283fdff51e8344$var$io:
            throw $65283fdff51e8344$var$Di("unexpected HTTP response status code", e.cause, e.code);
        case $65283fdff51e8344$var$oo:
            throw $65283fdff51e8344$var$Di("unexpected response content-type", e.cause, e.code);
        case $65283fdff51e8344$var$to:
            throw $65283fdff51e8344$var$Di("parsing error occured", e, e.code);
        case $65283fdff51e8344$var$no:
            throw $65283fdff51e8344$var$Di("invalid response encountered", e, e.code);
        case $65283fdff51e8344$var$co:
            throw $65283fdff51e8344$var$Di("unexpected JWT claim value encountered", e, e.code);
        case $65283fdff51e8344$var$uo:
            throw $65283fdff51e8344$var$Di("unexpected JSON attribute value encountered", e, e.code);
        case $65283fdff51e8344$var$so:
            throw $65283fdff51e8344$var$Di("JWT timestamp claim value failed validation", e, e.code);
        default:
            throw $65283fdff51e8344$var$Di(e.message, e, e.code);
    }
    if (e instanceof $65283fdff51e8344$var$qt) throw $65283fdff51e8344$var$Di("unsupported operation", e, e.code);
    if (e instanceof DOMException) switch(e.name){
        case "OperationError":
            throw $65283fdff51e8344$var$Di("runtime operation error", e, $65283fdff51e8344$var$$n);
        case "NotSupportedError":
            throw $65283fdff51e8344$var$Di("runtime unsupported operation", e, $65283fdff51e8344$var$$n);
        case "TimeoutError":
            throw $65283fdff51e8344$var$Di("operation timed out", e, "OAUTH_TIMEOUT");
        case "AbortError":
            throw $65283fdff51e8344$var$Di("operation aborted", e, "OAUTH_ABORT");
    }
    throw new $65283fdff51e8344$var$zi("something went wrong", {
        cause: e
    });
}
function $65283fdff51e8344$var$Hi(e, t, n, o, i) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var r, a, s, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        function(e, t) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var _$n, _$o, _obj, _$i, r, a, s, c;
                                return (0, $3SMYb._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(e instanceof URL)) throw $65283fdff51e8344$var$Ni('"server" must be an instance of URL', $65283fdff51e8344$var$Ui);
                                            _$i = !e.href.includes("/.well-known/"), r = null !== (_$n = null == t ? void 0 : t.timeout) && void 0 !== _$n ? _$n : 30, a = AbortSignal.timeout(1e3 * r);
                                            return [
                                                4,
                                                (_$i ? $65283fdff51e8344$var$an(e, (_obj = {
                                                    algorithm: null == t ? void 0 : t.algorithm
                                                }, (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Jt, null == t ? void 0 : t[$65283fdff51e8344$var$ji]), (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Mt, null == t || null === (_$o = t.execute) || void 0 === _$o ? void 0 : _$o.includes($65283fdff51e8344$var$qi)), (0, $dUlz9._)(_obj, "signal", a), (0, $dUlz9._)(_obj, "headers", new Headers($65283fdff51e8344$var$Ii)), _obj)) : ((null == t ? void 0 : t[$65283fdff51e8344$var$ji]) || fetch)(($65283fdff51e8344$var$bn(e, null == t || null === (c = t.execute) || void 0 === c || !c.includes($65283fdff51e8344$var$qi)), e.href), {
                                                    headers: Object.fromEntries(new Headers($65283fdff51e8344$var$f({
                                                        accept: "application/json"
                                                    }, $65283fdff51e8344$var$Ii)).entries()),
                                                    body: void 0,
                                                    method: "GET",
                                                    redirect: "manual",
                                                    signal: a
                                                })).then(function(e) {
                                                    return function(e, t) {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                                            var _$n, _$o;
                                                            return (0, $3SMYb._)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        _$n = e;
                                                                        if (!(_$n instanceof URL) && _$n !== $65283fdff51e8344$var$To) throw $65283fdff51e8344$var$Lt('"expectedIssuerIdentifier" must be an instance of URL', $65283fdff51e8344$var$Nt);
                                                                        if (!$65283fdff51e8344$var$Kt(t, Response)) throw $65283fdff51e8344$var$Lt('"response" must be an instance of Response', $65283fdff51e8344$var$Nt);
                                                                        if (200 !== t.status) throw $65283fdff51e8344$var$$t('"response" is not a conform Authorization Server Metadata response (unexpected HTTP status code)', $65283fdff51e8344$var$io, t);
                                                                        $65283fdff51e8344$var$fo(t);
                                                                        return [
                                                                            4,
                                                                            $65283fdff51e8344$var$So(t)
                                                                        ];
                                                                    case 1:
                                                                        _$o = _state.sent();
                                                                        if ($65283fdff51e8344$var$cn(_$o.issuer, '"response" body "issuer" property', $65283fdff51e8344$var$no, {
                                                                            body: _$o
                                                                        }), _$n !== $65283fdff51e8344$var$To && new URL(_$o.issuer).href !== _$n.href) throw $65283fdff51e8344$var$$t('"response" body "issuer" property does not match the expected value', $65283fdff51e8344$var$uo, {
                                                                            expected: _$n.href,
                                                                            body: _$o,
                                                                            attribute: "issuer"
                                                                        });
                                                                        return [
                                                                            2,
                                                                            _$o
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    }($65283fdff51e8344$var$To, e);
                                                }).catch($65283fdff51e8344$var$Ji)
                                            ];
                                        case 1:
                                            s = _state.sent();
                                            _$i && new URL(s.issuer).href !== e.href && (function(e, t, n) {
                                                return !("https://login.microsoftonline.com" !== e.origin || null != n && n.algorithm && "oidc" !== n.algorithm || (t[$65283fdff51e8344$var$Zi] = !0, 0));
                                            }(e, s, t) || function(e, t) {
                                                return !(!e.hostname.endsWith(".b2clogin.com") || null != t && t.algorithm && "oidc" !== t.algorithm);
                                            }(e, t) || function() {
                                                throw new $65283fdff51e8344$var$zi("discovered metadata issuer does not match the expected issuer", {
                                                    code: $65283fdff51e8344$var$uo,
                                                    cause: {
                                                        expected: e.href,
                                                        body: s,
                                                        attribute: "issuer"
                                                    }
                                                });
                                            }());
                                            return [
                                                2,
                                                s
                                            ];
                                    }
                                });
                            })();
                        }(e, i)
                    ];
                case 1:
                    r = _state.sent(), a = new $65283fdff51e8344$var$Fi(r, t, n, o);
                    s = $65283fdff51e8344$var$Ri(a);
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (null != i && i[$65283fdff51e8344$var$ji] && (s.fetch = i[$65283fdff51e8344$var$ji]), null != i && i.timeout && (s.timeout = i.timeout), null != i && i.execute) try {
                        for(_iterator = i.execute[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _$e = _step.value;
                            _$e(a);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        2,
                        a
                    ];
            }
        });
    })();
}
new TextDecoder;
var $65283fdff51e8344$var$Zi = Symbol();
var $65283fdff51e8344$var$Fi = /*#__PURE__*/ function() {
    "use strict";
    function Fi(e, t, n, o) {
        (0, $5Epmf._)(this, Fi);
        var i, r, a, s, c;
        if ("string" != typeof t || !t.length) throw $65283fdff51e8344$var$Ni('"clientId" must be a non-empty string', $65283fdff51e8344$var$Ui);
        if ("string" == typeof n && (n = {
            client_secret: n
        }), void 0 !== (null === (i = n) || void 0 === i ? void 0 : i.client_id) && t !== n.client_id) throw $65283fdff51e8344$var$Ni('"clientId" and "metadata.client_id" must be the same', $65283fdff51e8344$var$Ki);
        var u = $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, structuredClone(n)), {}, {
            client_id: t
        });
        var l;
        u[$65283fdff51e8344$var$zt] = null !== (r = null === (a = n) || void 0 === a ? void 0 : a[$65283fdff51e8344$var$zt]) && void 0 !== r ? r : 0, u[$65283fdff51e8344$var$Dt] = null !== (s = null === (c = n) || void 0 === c ? void 0 : c[$65283fdff51e8344$var$Dt]) && void 0 !== s ? s : 30, l = o || ("string" == typeof u.client_secret && u.client_secret.length ? $65283fdff51e8344$var$Wi(u.client_secret) : function(e, t, n, o) {
            n.set("client_id", t.client_id);
        });
        var h = Object.freeze(u);
        var _$d = structuredClone(e);
        $65283fdff51e8344$var$Zi in e && (_$d[$65283fdff51e8344$var$Po] = function(t) {
            var _$n = t.claims.tid;
            return e.issuer.replace("{tenantid}", _$n);
        });
        var p = Object.freeze(_$d);
        $65283fdff51e8344$var$Oi || ($65283fdff51e8344$var$Oi = new WeakMap), $65283fdff51e8344$var$Oi.set(this, {
            __proto__: null,
            as: p,
            c: h,
            auth: l,
            tlsOnly: !0,
            jwksCache: {}
        });
    }
    (0, $9MqXK._)(Fi, [
        {
            key: "serverMetadata",
            value: function serverMetadata() {
                var e = structuredClone($65283fdff51e8344$var$Ri(this).as);
                return function(e) {
                    Object.defineProperties(e, function(e) {
                        return {
                            supportsPKCE: {
                                __proto__: null,
                                value: function() {
                                    var t;
                                    var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "S256";
                                    return !0 === (null === (t = e.code_challenge_methods_supported) || void 0 === t ? void 0 : t.includes(n));
                                }
                            }
                        };
                    }(e));
                }(e), e;
            }
        },
        {
            key: "clientMetadata",
            value: function clientMetadata() {
                return structuredClone($65283fdff51e8344$var$Ri(this).c);
            }
        },
        {
            key: "timeout",
            get: function get() {
                return $65283fdff51e8344$var$Ri(this).timeout;
            },
            set: function set(e) {
                $65283fdff51e8344$var$Ri(this).timeout = e;
            }
        },
        {
            key: $65283fdff51e8344$var$ji,
            get: function get() {
                return $65283fdff51e8344$var$Ri(this).fetch;
            }
        },
        {
            key: $65283fdff51e8344$var$ji,
            set: function set(e) {
                $65283fdff51e8344$var$Ri(this).fetch = e;
            }
        }
    ]);
    return Fi;
}();
function $65283fdff51e8344$var$Vi(e) {
    Object.defineProperties(e, function(e) {
        var t;
        if (void 0 !== e.expires_in) {
            var n = new Date;
            n.setSeconds(n.getSeconds() + e.expires_in), t = n.getTime();
        }
        return {
            expiresIn: {
                __proto__: null,
                value: function() {
                    if (t) {
                        var _$e = Date.now();
                        return t > _$e ? Math.floor((t - _$e) / 1e3) : 0;
                    }
                }
            },
            claims: {
                __proto__: null,
                value: function() {
                    try {
                        return $65283fdff51e8344$var$zn(this);
                    } catch (e) {
                        return;
                    }
                }
            }
        };
    }(e));
}
function $65283fdff51e8344$var$Xi(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(e, t, n) {
        var o, i, r, a, _$e, _$t, _$n, _tmp;
        var _arguments = arguments;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = _arguments.length > 3 && void 0 !== _arguments[3] && _arguments[3];
                    r = null === (o = e.headers.get("retry-after")) || void 0 === o ? void 0 : o.trim();
                    if (void 0 === r) return [
                        2
                    ];
                    if (/^\d+$/.test(r)) a = parseInt(r, 10);
                    else {
                        _$e = new Date(r);
                        if (Number.isFinite(_$e.getTime())) {
                            _$t = new Date, _$n = _$e.getTime() - _$t.getTime();
                            _$n > 0 && (a = Math.ceil(_$n / 1e3));
                        }
                    }
                    if (i && !Number.isFinite(a)) throw new $65283fdff51e8344$var$Qt("invalid Retry-After header value", {
                        cause: e
                    });
                    _tmp = a > t;
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $65283fdff51e8344$var$Gi(a - t, n)
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp;
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $65283fdff51e8344$var$Gi(e, t) {
    return new Promise(function(n, o) {
        var i = function(e) {
            try {
                t.throwIfAborted();
            } catch (e) {
                return void o(e);
            }
            if (e <= 0) return void n();
            var r = Math.min(e, 5);
            setTimeout(function() {
                return i(e - r);
            }, 1e3 * r);
        };
        i(e);
    });
}
function $65283fdff51e8344$var$Yi(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var n, o, i, r, a, s, c, _obj;
        return (0, $3SMYb._)(this, function(_state) {
            $65283fdff51e8344$var$or(e);
            n = $65283fdff51e8344$var$Ri(e), o = n.as, i = n.c, r = n.auth, a = n.fetch, s = n.tlsOnly, c = n.timeout;
            return [
                2,
                (function(e, t, n, o, i) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        var r, a, s;
                        return (0, $3SMYb._)(this, function(_state) {
                            $65283fdff51e8344$var$mn(e), $65283fdff51e8344$var$yn(t);
                            r = $65283fdff51e8344$var$_n(e, "backchannel_authentication_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == i ? void 0 : i[$65283fdff51e8344$var$Mt])), a = new URLSearchParams(o);
                            a.set("client_id", t.client_id);
                            s = $65283fdff51e8344$var$nn(null == i ? void 0 : i.headers);
                            return [
                                2,
                                (s.set("accept", "application/json"), $65283fdff51e8344$var$Un(e, t, n, r, a, s, i))
                            ];
                        });
                    })();
                })(o, i, r, t, (_obj = {}, (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Jt, a), (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Mt, !s), (0, $dUlz9._)(_obj, "headers", new Headers($65283fdff51e8344$var$Ii)), (0, $dUlz9._)(_obj, "signal", $65283fdff51e8344$var$ir(c)), _obj)).then(function(e) {
                    return function(e, t, n) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                            var o, i;
                            return (0, $3SMYb._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if ($65283fdff51e8344$var$mn(e), $65283fdff51e8344$var$yn(t), !$65283fdff51e8344$var$Kt(n, Response)) throw $65283fdff51e8344$var$Lt('"response" must be an instance of Response', $65283fdff51e8344$var$Nt);
                                        return [
                                            4,
                                            $65283fdff51e8344$var$Wn(n, 200, "Backchannel Authentication Endpoint")
                                        ];
                                    case 1:
                                        _state.sent(), $65283fdff51e8344$var$fo(n);
                                        return [
                                            4,
                                            $65283fdff51e8344$var$So(n)
                                        ];
                                    case 2:
                                        o = _state.sent();
                                        $65283fdff51e8344$var$cn(o.auth_req_id, '"response" body "auth_req_id" property', $65283fdff51e8344$var$no, {
                                            body: o
                                        });
                                        i = "number" != typeof o.expires_in ? parseFloat(o.expires_in) : o.expires_in;
                                        return [
                                            2,
                                            ($65283fdff51e8344$var$sn(i, !0, '"response" body "expires_in" property', $65283fdff51e8344$var$no, {
                                                body: o
                                            }), o.expires_in = i, void 0 !== o.interval && $65283fdff51e8344$var$sn(o.interval, !1, '"response" body "interval" property', $65283fdff51e8344$var$no, {
                                                body: o
                                            }), o)
                                        ];
                                }
                            });
                        })();
                    }(o, i, e);
                }).catch($65283fdff51e8344$var$Ji)
            ];
        });
    })();
}
function $65283fdff51e8344$var$Bi(e, t, n, o) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var i, r, a, s, e1, _obj, c, u, l, h, _$d, p, m, y, w, _$g, v, b, k, _, S, e2, _1, _tmp;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $65283fdff51e8344$var$or(e), n = new URLSearchParams(n);
                    a = null !== (i = t.interval) && void 0 !== i ? i : 5;
                    s = null !== (r = null == o ? void 0 : o.signal) && void 0 !== r ? r : AbortSignal.timeout(1e3 * t.expires_in);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $65283fdff51e8344$var$Gi(a, s)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e1 = _state.sent();
                    $65283fdff51e8344$var$Ji(e1);
                    return [
                        3,
                        4
                    ];
                case 4:
                    c = $65283fdff51e8344$var$Ri(e), u = c.as, l = c.c, h = c.auth, _$d = c.fetch, p = c.tlsOnly, m = c.nonRepudiation, y = c.timeout, w = c.decrypt, _$g = function(i, r) {
                        return $65283fdff51e8344$var$Bi(e, $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, t), {}, {
                            interval: i
                        }), n, $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, o), {}, {
                            signal: s,
                            flag: r
                        }));
                    }, v = function(e, t) {
                        var _$n = $65283fdff51e8344$var$ir(t);
                        if (!_$n) return {
                            signal: e,
                            cleanup: function() {}
                        };
                        var _$o = new AbortController, i = function(e) {
                            var _$t = e.target;
                            _$o.abort(_$t.reason);
                        };
                        return e.aborted ? _$o.abort(e.reason) : _$n.aborted ? _$o.abort(_$n.reason) : (e.addEventListener("abort", i, {
                            once: !0
                        }), _$n.addEventListener("abort", i, {
                            once: !0
                        })), {
                            signal: _$o.signal,
                            cleanup: function() {
                                e.removeEventListener("abort", i), _$n.removeEventListener("abort", i);
                            }
                        };
                    }(s, y);
                    return [
                        4,
                        (function(e, t, n, o, i) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var r;
                                return (0, $3SMYb._)(this, function(_state) {
                                    $65283fdff51e8344$var$mn(e), $65283fdff51e8344$var$yn(t), $65283fdff51e8344$var$cn(o, '"authReqId"');
                                    r = new URLSearchParams(null == i ? void 0 : i.additionalParameters);
                                    return [
                                        2,
                                        (r.set("auth_req_id", o), $65283fdff51e8344$var$Nn(e, t, n, "urn:openid:params:grant-type:ciba", r, i))
                                    ];
                                });
                            })();
                        })(u, l, h, t.auth_req_id, (_obj = {}, (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Jt, _$d), (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Mt, !p), (0, $dUlz9._)(_obj, "additionalParameters", n), (0, $dUlz9._)(_obj, "DPoP", null == o ? void 0 : o.DPoP), (0, $dUlz9._)(_obj, "headers", new Headers($65283fdff51e8344$var$Ii)), (0, $dUlz9._)(_obj, "signal", v.signal), _obj)).catch($65283fdff51e8344$var$Ji).finally(v.cleanup)
                    ];
                case 5:
                    b = _state.sent();
                    if (!(503 === b.status && b.headers.has("retry-after"))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        $65283fdff51e8344$var$Xi(b, a, s, !0)
                    ];
                case 6:
                    _state.sent();
                    return [
                        4,
                        null === (k = b.body) || void 0 === k ? void 0 : k.cancel()
                    ];
                case 7:
                    return [
                        2,
                        (_state.sent(), _$g(a))
                    ];
                case 8:
                    _ = function(e, t, n, o) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                            return (0, $3SMYb._)(this, function(_state) {
                                return [
                                    2,
                                    $65283fdff51e8344$var$Dn(e, t, n, void 0, null == o ? void 0 : o[$65283fdff51e8344$var$Zt], null == o ? void 0 : o.recognizedTokenTypes)
                                ];
                            });
                        })();
                    }(u, l, b, (0, $dUlz9._)({}, $65283fdff51e8344$var$Zt, w));
                    _state.label = 9;
                case 9:
                    _state.trys.push([
                        9,
                        11,
                        ,
                        16
                    ]);
                    return [
                        4,
                        _
                    ];
                case 10:
                    S = _state.sent();
                    return [
                        3,
                        16
                    ];
                case 11:
                    e2 = _state.sent();
                    if ($65283fdff51e8344$var$rr(e2, o)) return [
                        2,
                        _$g(a, $65283fdff51e8344$var$ar)
                    ];
                    if (!(e2 instanceof $65283fdff51e8344$var$Sn)) return [
                        3,
                        15
                    ];
                    _1 = e2.error;
                    switch(_1){
                        case "slow_down":
                            return [
                                3,
                                12
                            ];
                        case "authorization_pending":
                            return [
                                3,
                                13
                            ];
                    }
                    return [
                        3,
                        15
                    ];
                case 12:
                    a += 5;
                    _state.label = 13;
                case 13:
                    return [
                        4,
                        $65283fdff51e8344$var$Xi(e2.response, a, s)
                    ];
                case 14:
                    return [
                        2,
                        (_state.sent(), _$g(a))
                    ];
                case 15:
                    $65283fdff51e8344$var$Ji(e2);
                    return [
                        3,
                        16
                    ];
                case 16:
                    _tmp = S.id_token;
                    if (!_tmp) return [
                        3,
                        18
                    ];
                    return [
                        4,
                        null == m ? void 0 : m(b)
                    ];
                case 17:
                    _tmp = _state.sent();
                    _state.label = 18;
                case 18:
                    return [
                        2,
                        (_tmp, $65283fdff51e8344$var$Vi(S), S)
                    ];
            }
        });
    })();
}
function $65283fdff51e8344$var$qi(e) {
    $65283fdff51e8344$var$Ri(e).tlsOnly = !1;
}
function $65283fdff51e8344$var$Qi(e, t, n, o, i) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var r, a, s, c, u, l, h, _$d, p, m, w, _$g, v, b, _$e, _, _$n, _1, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e1, k, _$n1, _$o, _2, _obj, _3, S, T, t1, _tmp;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ($65283fdff51e8344$var$or(e), !((null == i ? void 0 : i.flag) === $65283fdff51e8344$var$ar || t instanceof URL || function(e, t) {
                        try {
                            return Object.getPrototypeOf(e)[Symbol.toStringTag] === t;
                        } catch (e) {
                            return !1;
                        }
                    }(t, "Request"))) throw $65283fdff51e8344$var$Ni('"currentUrl" must be an instance of URL, or Request', $65283fdff51e8344$var$Ui);
                    s = $65283fdff51e8344$var$Ri(e), c = s.as, u = s.c, l = s.auth, h = s.fetch, _$d = s.tlsOnly, p = s.jarm, m = s.hybrid, w = s.nonRepudiation, _$g = s.timeout, v = s.decrypt, b = s.implicit;
                    if (!((null == i ? void 0 : i.flag) === $65283fdff51e8344$var$ar)) return [
                        3,
                        1
                    ];
                    r = i.authResponse, a = i.redirectUri;
                    return [
                        3,
                        13
                    ];
                case 1:
                    if (!!(t instanceof URL)) return [
                        3,
                        6
                    ];
                    _$e = t;
                    _ = (t = new URL(t.url), _$e.method);
                    switch(_){
                        case "GET":
                            return [
                                3,
                                2
                            ];
                        case "POST":
                            return [
                                3,
                                3
                            ];
                    }
                    return [
                        3,
                        5
                    ];
                case 2:
                    return [
                        3,
                        6
                    ];
                case 3:
                    _1 = URLSearchParams.bind;
                    return [
                        4,
                        $65283fdff51e8344$var$wo(_$e)
                    ];
                case 4:
                    _$n = new (_1.apply(URLSearchParams, [
                        void 0,
                        _state.sent()
                    ]));
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (m) t.hash = _$n.toString();
                    else try {
                        for(_iterator = _$n.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _$e1 = _step.value;
                            k = $65283fdff51e8344$var$y(_$e1, 2);
                            _$n1 = k[0], _$o = k[1];
                            t.searchParams.append(_$n1, _$o);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        3,
                        6
                    ];
                case 5:
                    throw $65283fdff51e8344$var$Ni("unexpected Request HTTP method", $65283fdff51e8344$var$Ki);
                case 6:
                    _2 = (a = function(e) {
                        return (e = new URL(e)).search = "", e.hash = "", e.href;
                    }(t), !0);
                    switch(_2){
                        case !!p:
                            return [
                                3,
                                7
                            ];
                        case !!m:
                            return [
                                3,
                                9
                            ];
                        case !!b:
                            return [
                                3,
                                11
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 7:
                    return [
                        4,
                        p(t, null == n ? void 0 : n.expectedState)
                    ];
                case 8:
                    r = _state.sent();
                    return [
                        3,
                        13
                    ];
                case 9:
                    return [
                        4,
                        m(t, null == n ? void 0 : n.expectedNonce, null == n ? void 0 : n.expectedState, null == n ? void 0 : n.maxAge)
                    ];
                case 10:
                    r = _state.sent();
                    return [
                        3,
                        13
                    ];
                case 11:
                    throw new TypeError("authorizationCodeGrant() cannot be used by response_type=id_token clients");
                case 12:
                    try {
                        r = $65283fdff51e8344$var$_o(c, u, t.searchParams, null == n ? void 0 : n.expectedState);
                    } catch (e) {
                        $65283fdff51e8344$var$Ji(e);
                    }
                    _state.label = 13;
                case 13:
                    return [
                        4,
                        (function(e, t, n, o, i, r, a) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var s, c;
                                return (0, $3SMYb._)(this, function(_state) {
                                    if ($65283fdff51e8344$var$mn(e), $65283fdff51e8344$var$yn(t), !$65283fdff51e8344$var$Zn.has(o)) throw $65283fdff51e8344$var$Lt('"callbackParameters" must be an instance of URLSearchParams obtained from "validateAuthResponse()", or "validateJwtAuthResponse()', $65283fdff51e8344$var$Ut);
                                    $65283fdff51e8344$var$cn(i, '"redirectUri"');
                                    s = $65283fdff51e8344$var$vo(o, "code");
                                    if (!s) throw $65283fdff51e8344$var$$t('no authorization code in "callbackParameters"', $65283fdff51e8344$var$no);
                                    c = new URLSearchParams(null == a ? void 0 : a.additionalParameters);
                                    return [
                                        2,
                                        (c.set("redirect_uri", i), c.set("code", s), r !== $65283fdff51e8344$var$Fn && ($65283fdff51e8344$var$cn(r, '"codeVerifier"'), c.set("code_verifier", r)), $65283fdff51e8344$var$Nn(e, t, n, "authorization_code", c, a))
                                    ];
                                });
                            })();
                        })(c, u, l, r, a, (null == n ? void 0 : n.pkceCodeVerifier) || $65283fdff51e8344$var$Fn, (_obj = {
                            additionalParameters: o
                        }, (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Jt, h), (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Mt, !_$d), (0, $dUlz9._)(_obj, "DPoP", null == i ? void 0 : i.DPoP), (0, $dUlz9._)(_obj, "headers", new Headers($65283fdff51e8344$var$Ii)), (0, $dUlz9._)(_obj, "signal", $65283fdff51e8344$var$ir(_$g)), _obj)).catch($65283fdff51e8344$var$Ji)
                    ];
                case 14:
                    _3 = _state.sent();
                    "string" != typeof (null == n ? void 0 : n.expectedNonce) && "number" != typeof (null == n ? void 0 : n.maxAge) || (n.idTokenExpected = !0);
                    S = $65283fdff51e8344$var$Bn(c, u, _3, (0, $dUlz9._)({
                        expectedNonce: null == n ? void 0 : n.expectedNonce,
                        maxAge: null == n ? void 0 : n.maxAge,
                        requireIdToken: null == n ? void 0 : n.idTokenExpected
                    }, $65283fdff51e8344$var$Zt, v));
                    _state.label = 15;
                case 15:
                    _state.trys.push([
                        15,
                        17,
                        ,
                        18
                    ]);
                    return [
                        4,
                        S
                    ];
                case 16:
                    T = _state.sent();
                    return [
                        3,
                        18
                    ];
                case 17:
                    t1 = _state.sent();
                    if ($65283fdff51e8344$var$rr(t1, i)) return [
                        2,
                        $65283fdff51e8344$var$Qi(e, void 0, n, o, $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, i), {}, {
                            flag: $65283fdff51e8344$var$ar,
                            authResponse: r,
                            redirectUri: a
                        }))
                    ];
                    $65283fdff51e8344$var$Ji(t1);
                    return [
                        3,
                        18
                    ];
                case 18:
                    _tmp = T.id_token;
                    if (!_tmp) return [
                        3,
                        20
                    ];
                    return [
                        4,
                        null == w ? void 0 : w(_3)
                    ];
                case 19:
                    _tmp = _state.sent();
                    _state.label = 20;
                case 20:
                    return [
                        2,
                        (_tmp, $65283fdff51e8344$var$Vi(T), T)
                    ];
            }
        });
    })();
}
function $65283fdff51e8344$var$$i(e, t, n, o) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _obj, _$i, r, a, s, c, u, l, h, _$d, p, m, y, i, _tmp;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $65283fdff51e8344$var$or(e), n = new URLSearchParams(n);
                    _$i = $65283fdff51e8344$var$Ri(e), r = _$i.as, a = _$i.c, s = _$i.auth, c = _$i.fetch, u = _$i.tlsOnly, l = _$i.nonRepudiation, h = _$i.timeout, _$d = _$i.decrypt;
                    return [
                        4,
                        (function(e, t, n, o, i) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var r;
                                return (0, $3SMYb._)(this, function(_state) {
                                    $65283fdff51e8344$var$mn(e), $65283fdff51e8344$var$yn(t), $65283fdff51e8344$var$cn(o, '"refreshToken"');
                                    r = new URLSearchParams(null == i ? void 0 : i.additionalParameters);
                                    return [
                                        2,
                                        (r.set("refresh_token", o), $65283fdff51e8344$var$Nn(e, t, n, "refresh_token", r, i))
                                    ];
                                });
                            })();
                        })(r, a, s, t, (_obj = {}, (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Jt, c), (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Mt, !u), (0, $dUlz9._)(_obj, "additionalParameters", n), (0, $dUlz9._)(_obj, "DPoP", null == o ? void 0 : o.DPoP), (0, $dUlz9._)(_obj, "headers", new Headers($65283fdff51e8344$var$Ii)), (0, $dUlz9._)(_obj, "signal", $65283fdff51e8344$var$ir(h)), _obj)).catch($65283fdff51e8344$var$Ji)
                    ];
                case 1:
                    p = _state.sent(), m = function(e, t, n, o) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                            return (0, $3SMYb._)(this, function(_state) {
                                return [
                                    2,
                                    $65283fdff51e8344$var$Dn(e, t, n, void 0, null == o ? void 0 : o[$65283fdff51e8344$var$Zt], null == o ? void 0 : o.recognizedTokenTypes)
                                ];
                            });
                        })();
                    }(r, a, p, (0, $dUlz9._)({}, $65283fdff51e8344$var$Zt, _$d));
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        m
                    ];
                case 3:
                    y = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    i = _state.sent();
                    if ($65283fdff51e8344$var$rr(i, o)) return [
                        2,
                        $65283fdff51e8344$var$$i(e, t, n, $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, o), {}, {
                            flag: $65283fdff51e8344$var$ar
                        }))
                    ];
                    $65283fdff51e8344$var$Ji(i);
                    return [
                        3,
                        5
                    ];
                case 5:
                    _tmp = y.id_token;
                    if (!_tmp) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        null == l ? void 0 : l(p)
                    ];
                case 6:
                    _tmp = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        2,
                        (_tmp, $65283fdff51e8344$var$Vi(y), y)
                    ];
            }
        });
    })();
}
function $65283fdff51e8344$var$er(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _obj, _$o, i, r, a, s, c, u, l, h, _$d, o;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $65283fdff51e8344$var$or(e), t = new URLSearchParams(t);
                    _$o = $65283fdff51e8344$var$Ri(e), i = _$o.as, r = _$o.c, a = _$o.auth, s = _$o.fetch, c = _$o.tlsOnly, u = _$o.timeout;
                    return [
                        4,
                        (function(e, t, n, o, i) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                return (0, $3SMYb._)(this, function(_state) {
                                    return [
                                        2,
                                        ($65283fdff51e8344$var$mn(e), $65283fdff51e8344$var$yn(t), $65283fdff51e8344$var$Nn(e, t, n, "client_credentials", new URLSearchParams(o), i))
                                    ];
                                });
                            })();
                        })(i, r, a, t, (_obj = {}, (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Jt, s), (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Mt, !c), (0, $dUlz9._)(_obj, "DPoP", null == n ? void 0 : n.DPoP), (0, $dUlz9._)(_obj, "headers", new Headers($65283fdff51e8344$var$Ii)), (0, $dUlz9._)(_obj, "signal", $65283fdff51e8344$var$ir(u)), _obj)).catch($65283fdff51e8344$var$Ji)
                    ];
                case 1:
                    l = _state.sent(), h = function(e, t, n, o) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                            return (0, $3SMYb._)(this, function(_state) {
                                return [
                                    2,
                                    $65283fdff51e8344$var$Dn(e, t, n, void 0, null == o ? void 0 : o[$65283fdff51e8344$var$Zt], null == o ? void 0 : o.recognizedTokenTypes)
                                ];
                            });
                        })();
                    }(i, r, l);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        h
                    ];
                case 3:
                    _$d = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    o = _state.sent();
                    if ($65283fdff51e8344$var$rr(o, n)) return [
                        2,
                        $65283fdff51e8344$var$er(e, t, $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, n), {}, {
                            flag: $65283fdff51e8344$var$ar
                        }))
                    ];
                    $65283fdff51e8344$var$Ji(o);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        ($65283fdff51e8344$var$Vi(_$d), _$d)
                    ];
            }
        });
    })();
}
function $65283fdff51e8344$var$tr(e, t) {
    $65283fdff51e8344$var$or(e);
    var n = $65283fdff51e8344$var$Ri(e), o = n.as, i = n.c, r = n.tlsOnly, a = n.hybrid, s = n.jarm, c = n.implicit, u = $65283fdff51e8344$var$_n(o, "authorization_endpoint", !1, r);
    if ((t = new URLSearchParams(t)).has("client_id") || t.set("client_id", i.client_id), !t.has("request_uri") && !t.has("request")) {
        if (t.has("response_type") || t.set("response_type", a ? "code id_token" : c ? "id_token" : "code"), c && !t.has("nonce")) throw $65283fdff51e8344$var$Ni("response_type=id_token clients must provide a nonce parameter in their authorization request parameters", $65283fdff51e8344$var$Ki);
        s && t.set("response_mode", "jwt");
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = t.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$e = _step.value;
            var l = $65283fdff51e8344$var$y(_$e, 2);
            var _$t = l[0], n1 = l[1];
            u.searchParams.append(_$t, n1);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return u;
}
function $65283fdff51e8344$var$nr(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _obj, _$o, i, r, a, s, c, u, l, h, _$d, p, o;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $65283fdff51e8344$var$or(e);
                    _$o = $65283fdff51e8344$var$tr(e, t), i = $65283fdff51e8344$var$Ri(e), r = i.as, a = i.c, s = i.auth, c = i.fetch, u = i.tlsOnly, l = i.timeout;
                    return [
                        4,
                        (function(e, t, n, o, i) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var r, a, s, c, _tmp, u;
                                return (0, $3SMYb._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            $65283fdff51e8344$var$mn(e), $65283fdff51e8344$var$yn(t);
                                            a = $65283fdff51e8344$var$_n(e, "pushed_authorization_request_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == i ? void 0 : i[$65283fdff51e8344$var$Mt])), s = new URLSearchParams(o);
                                            s.set("client_id", t.client_id);
                                            c = $65283fdff51e8344$var$nn(null == i ? void 0 : i.headers);
                                            c.set("accept", "application/json");
                                            _tmp = void 0 !== (null == i ? void 0 : i.DPoP);
                                            if (!_tmp) return [
                                                3,
                                                2
                                            ];
                                            $65283fdff51e8344$var$jn(i.DPoP);
                                            return [
                                                4,
                                                i.DPoP.addProof(a, c, "POST")
                                            ];
                                        case 1:
                                            _tmp = _state.sent();
                                            _state.label = 2;
                                        case 2:
                                            _tmp;
                                            return [
                                                4,
                                                $65283fdff51e8344$var$Un(e, t, n, a, s, c, i)
                                            ];
                                        case 3:
                                            u = _state.sent();
                                            return [
                                                2,
                                                (null == i || null === (r = i.DPoP) || void 0 === r || r.cacheNonce(u, a), u)
                                            ];
                                    }
                                });
                            })();
                        })(r, a, s, _$o.searchParams, (_obj = {}, (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Jt, c), (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Mt, !u), (0, $dUlz9._)(_obj, "DPoP", null == n ? void 0 : n.DPoP), (0, $dUlz9._)(_obj, "headers", new Headers($65283fdff51e8344$var$Ii)), (0, $dUlz9._)(_obj, "signal", $65283fdff51e8344$var$ir(l)), _obj)).catch($65283fdff51e8344$var$Ji)
                    ];
                case 1:
                    h = _state.sent(), _$d = function(e, t, n) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                            var _$o, i;
                            return (0, $3SMYb._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if ($65283fdff51e8344$var$mn(e), $65283fdff51e8344$var$yn(t), !$65283fdff51e8344$var$Kt(n, Response)) throw $65283fdff51e8344$var$Lt('"response" must be an instance of Response', $65283fdff51e8344$var$Nt);
                                        return [
                                            4,
                                            $65283fdff51e8344$var$Wn(n, 201, "Pushed Authorization Request Endpoint")
                                        ];
                                    case 1:
                                        _state.sent(), $65283fdff51e8344$var$fo(n);
                                        return [
                                            4,
                                            $65283fdff51e8344$var$So(n)
                                        ];
                                    case 2:
                                        _$o = _state.sent();
                                        $65283fdff51e8344$var$cn(_$o.request_uri, '"response" body "request_uri" property', $65283fdff51e8344$var$no, {
                                            body: _$o
                                        });
                                        i = "number" != typeof _$o.expires_in ? parseFloat(_$o.expires_in) : _$o.expires_in;
                                        return [
                                            2,
                                            ($65283fdff51e8344$var$sn(i, !0, '"response" body "expires_in" property', $65283fdff51e8344$var$no, {
                                                body: _$o
                                            }), _$o.expires_in = i, _$o)
                                        ];
                                }
                            });
                        })();
                    }(r, a, h);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        _$d
                    ];
                case 3:
                    p = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    o = _state.sent();
                    if ($65283fdff51e8344$var$rr(o, n)) return [
                        2,
                        $65283fdff51e8344$var$nr(e, t, $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, n), {}, {
                            flag: $65283fdff51e8344$var$ar
                        }))
                    ];
                    $65283fdff51e8344$var$Ji(o);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        $65283fdff51e8344$var$tr(e, {
                            request_uri: p.request_uri
                        })
                    ];
            }
        });
    })();
}
function $65283fdff51e8344$var$or(e) {
    if (!(e instanceof $65283fdff51e8344$var$Fi)) throw $65283fdff51e8344$var$Ni('"config" must be an instance of Configuration', $65283fdff51e8344$var$Ui);
    if (Object.getPrototypeOf(e) !== $65283fdff51e8344$var$Fi.prototype) throw $65283fdff51e8344$var$Ni("subclassing Configuration is not allowed", $65283fdff51e8344$var$Ki);
}
function $65283fdff51e8344$var$ir(e) {
    return e ? AbortSignal.timeout(1e3 * e) : void 0;
}
function $65283fdff51e8344$var$rr(e, t) {
    return !(null == t || !t.DPoP || t.flag === $65283fdff51e8344$var$ar) && function(e) {
        if (e instanceof $65283fdff51e8344$var$Pn) {
            var _$t = e.cause, n = _$t[0];
            return 1 === _$t.length && "dpop" === n.scheme && "use_dpop_nonce" === n.parameters.error;
        }
        return e instanceof $65283fdff51e8344$var$Sn && "use_dpop_nonce" === e.error;
    }(e);
}
Object.freeze($65283fdff51e8344$var$Fi.prototype);
var $65283fdff51e8344$var$ar = Symbol();
function $65283fdff51e8344$var$sr(e, t, n, o) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _obj, _$i, r, a, s, c, u, l, h, _$d, p, m, _obj1, y, w, i, _tmp;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $65283fdff51e8344$var$or(e);
                    _$i = $65283fdff51e8344$var$Ri(e), r = _$i.as, a = _$i.c, s = _$i.auth, c = _$i.fetch, u = _$i.tlsOnly, l = _$i.timeout, h = _$i.decrypt, _$d = _$i.nonRepudiation;
                    return [
                        4,
                        (function(e, t, n, o, i, r) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                return (0, $3SMYb._)(this, function(_state) {
                                    return [
                                        2,
                                        ($65283fdff51e8344$var$mn(e), $65283fdff51e8344$var$yn(t), $65283fdff51e8344$var$cn(o, '"grantType"'), $65283fdff51e8344$var$Nn(e, t, n, o, new URLSearchParams(i), r))
                                    ];
                                });
                            })();
                        })(r, a, s, t, new URLSearchParams(n), (_obj = {}, (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Jt, c), (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Mt, !u), (0, $dUlz9._)(_obj, "DPoP", null == o ? void 0 : o.DPoP), (0, $dUlz9._)(_obj, "headers", new Headers($65283fdff51e8344$var$Ii)), (0, $dUlz9._)(_obj, "signal", $65283fdff51e8344$var$ir(l)), _obj)).catch($65283fdff51e8344$var$Ji)
                    ];
                case 1:
                    p = _state.sent();
                    "urn:ietf:params:oauth:grant-type:token-exchange" === t && (m = {
                        n_a: function() {}
                    });
                    y = function(e, t, n, o) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                            return (0, $3SMYb._)(this, function(_state) {
                                return [
                                    2,
                                    $65283fdff51e8344$var$Dn(e, t, n, void 0, null == o ? void 0 : o[$65283fdff51e8344$var$Zt], null == o ? void 0 : o.recognizedTokenTypes)
                                ];
                            });
                        })();
                    }(r, a, p, (_obj1 = {}, (0, $dUlz9._)(_obj1, $65283fdff51e8344$var$Zt, h), (0, $dUlz9._)(_obj1, "recognizedTokenTypes", m), _obj1));
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        y
                    ];
                case 3:
                    w = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    i = _state.sent();
                    if ($65283fdff51e8344$var$rr(i, o)) return [
                        2,
                        $65283fdff51e8344$var$sr(e, t, n, $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, o), {}, {
                            flag: $65283fdff51e8344$var$ar
                        }))
                    ];
                    $65283fdff51e8344$var$Ji(i);
                    return [
                        3,
                        5
                    ];
                case 5:
                    _tmp = w.id_token;
                    if (!_tmp) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        null == _$d ? void 0 : _$d(p)
                    ];
                case 6:
                    _tmp = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        2,
                        (_tmp, $65283fdff51e8344$var$Vi(w), w)
                    ];
            }
        });
    })();
}
function $65283fdff51e8344$var$cr(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var o, i, r, a, s, c, u, _obj;
        return (0, $3SMYb._)(this, function(_state) {
            $65283fdff51e8344$var$or(e);
            o = $65283fdff51e8344$var$Ri(e), i = o.as, r = o.c, a = o.auth, s = o.fetch, c = o.tlsOnly, u = o.timeout;
            return [
                2,
                (function(e, t, n, o, i) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        var r, a, s;
                        return (0, $3SMYb._)(this, function(_state) {
                            $65283fdff51e8344$var$mn(e), $65283fdff51e8344$var$yn(t), $65283fdff51e8344$var$cn(o, '"token"');
                            r = $65283fdff51e8344$var$_n(e, "revocation_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == i ? void 0 : i[$65283fdff51e8344$var$Mt])), a = new URLSearchParams(null == i ? void 0 : i.additionalParameters);
                            a.set("token", o);
                            s = $65283fdff51e8344$var$nn(null == i ? void 0 : i.headers);
                            return [
                                2,
                                (s.delete("accept"), $65283fdff51e8344$var$Un(e, t, n, r, a, s, i))
                            ];
                        });
                    })();
                })(i, r, a, t, (_obj = {}, (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Jt, s), (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Mt, !c), (0, $dUlz9._)(_obj, "additionalParameters", new URLSearchParams(n)), (0, $dUlz9._)(_obj, "headers", new Headers($65283fdff51e8344$var$Ii)), (0, $dUlz9._)(_obj, "signal", $65283fdff51e8344$var$ir(u)), _obj)).then($65283fdff51e8344$var$po).catch($65283fdff51e8344$var$Ji)
            ];
        });
    })();
}
function $65283fdff51e8344$var$ur(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var o, _$t, i, r, a, s, c, _tmp, u, l, h, _$d, p, m;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$65283fdff51e8344$var$ni(e)) throw new $65283fdff51e8344$var$Zo("Flattened JWS must be an object");
                    if (void 0 === e.protected && void 0 === e.header) throw new $65283fdff51e8344$var$Zo('Flattened JWS must have either of the "protected" or "header" members');
                    if (void 0 !== e.protected && "string" != typeof e.protected) throw new $65283fdff51e8344$var$Zo("JWS Protected Header incorrect type");
                    if (void 0 === e.payload) throw new $65283fdff51e8344$var$Zo("JWS Payload missing");
                    if ("string" != typeof e.signature) throw new $65283fdff51e8344$var$Zo("JWS Signature missing or incorrect type");
                    if (void 0 !== e.header && !$65283fdff51e8344$var$ni(e.header)) throw new $65283fdff51e8344$var$Zo("JWS Unprotected Header incorrect type");
                    o = {};
                    if (e.protected) try {
                        _$t = $65283fdff51e8344$var$Oo(e.protected);
                        o = JSON.parse($65283fdff51e8344$var$Ao.decode(_$t));
                    } catch (e) {
                        throw new $65283fdff51e8344$var$Zo("JWS Protected Header is invalid");
                    }
                    if (!$65283fdff51e8344$var$oi(o, e.header)) throw new $65283fdff51e8344$var$Zo("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
                    i = $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, o), e.header);
                    r = !0;
                    if ($65283fdff51e8344$var$_i($65283fdff51e8344$var$Zo, new Map([
                        [
                            "b64",
                            !0
                        ]
                    ]), null == n ? void 0 : n.crit, o, i).has("b64") && (r = o.b64, "boolean" != typeof r)) throw new $65283fdff51e8344$var$Zo('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
                    a = i.alg;
                    if ("string" != typeof a || !a) throw new $65283fdff51e8344$var$Zo('JWS "alg" (Algorithm) Header Parameter missing or invalid');
                    s = n && function(e, t) {
                        if (void 0 !== t && (!Array.isArray(t) || t.some(function(e) {
                            return "string" != typeof e;
                        }))) throw new TypeError('"'.concat(e, '" option must be an array of strings'));
                        if (t) return new Set(t);
                    }("algorithms", n.algorithms);
                    if (s && !s.has(a)) throw new $65283fdff51e8344$var$Jo('"alg" (Algorithm) Header Parameter value not allowed');
                    if (r) {
                        if ("string" != typeof e.payload) throw new $65283fdff51e8344$var$Zo("JWS Payload must be a string");
                    } else if ("string" != typeof e.payload && !(e.payload instanceof Uint8Array)) throw new $65283fdff51e8344$var$Zo("JWS Payload must be a string or an Uint8Array instance");
                    c = !1;
                    _tmp = "function" == typeof t;
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        t(o, e)
                    ];
                case 1:
                    _tmp = (t = _state.sent(), c = !0);
                    _state.label = 2;
                case 2:
                    _tmp, $65283fdff51e8344$var$Pi(a, t, "verify");
                    u = $65283fdff51e8344$var$Io(void 0 !== e.protected ? $65283fdff51e8344$var$xo(e.protected) : new Uint8Array, $65283fdff51e8344$var$xo("."), "string" == typeof e.payload ? r ? $65283fdff51e8344$var$xo(e.payload) : $65283fdff51e8344$var$Eo.encode(e.payload) : e.payload), l = $65283fdff51e8344$var$ti(e.signature, "signature", $65283fdff51e8344$var$Zo);
                    return [
                        4,
                        $65283fdff51e8344$var$pi(t, a)
                    ];
                case 3:
                    h = _state.sent();
                    return [
                        4,
                        function(e, t, n, o) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var i, r, e1;
                                return (0, $3SMYb._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                $65283fdff51e8344$var$si(e, t, "verify")
                                            ];
                                        case 1:
                                            i = _state.sent();
                                            $65283fdff51e8344$var$ri(e, i);
                                            r = $65283fdff51e8344$var$ai(e, i.algorithm);
                                            _state.label = 2;
                                        case 2:
                                            _state.trys.push([
                                                2,
                                                4,
                                                ,
                                                5
                                            ]);
                                            return [
                                                4,
                                                crypto.subtle.verify(r, i, n, o)
                                            ];
                                        case 3:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                        case 4:
                                            e1 = _state.sent();
                                            return [
                                                2,
                                                !1
                                            ];
                                        case 5:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }(a, h, l, u)
                    ];
                case 4:
                    _$d = _state.sent();
                    if (!_$d) throw new $65283fdff51e8344$var$Bo;
                    p = r ? $65283fdff51e8344$var$ti(e.payload, "payload", $65283fdff51e8344$var$Zo) : "string" == typeof e.payload ? $65283fdff51e8344$var$Eo.encode(e.payload) : e.payload;
                    m = {
                        payload: p
                    };
                    return [
                        2,
                        (void 0 !== e.protected && (m.protectedHeader = o), void 0 !== e.header && (m.unprotectedHeader = e.header), c ? $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, m), {}, {
                            key: h
                        }) : m)
                    ];
            }
        });
    })();
}
var $65283fdff51e8344$var$lr = function(e) {
    return Math.floor(e.getTime() / 1e3);
}, $65283fdff51e8344$var$hr = 86400, $65283fdff51e8344$var$dr = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
function $65283fdff51e8344$var$pr(e) {
    var t = $65283fdff51e8344$var$dr.exec(e);
    if (!t || t[4] && t[1]) throw new TypeError("Invalid time period format");
    var n = parseFloat(t[2]);
    var o;
    switch(t[3].toLowerCase()){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            o = Math.round(n);
            break;
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            o = Math.round(60 * n);
            break;
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            o = Math.round(3600 * n);
            break;
        case "day":
        case "days":
        case "d":
            o = Math.round(n * $65283fdff51e8344$var$hr);
            break;
        case "week":
        case "weeks":
        case "w":
            o = Math.round(604800 * n);
            break;
        default:
            o = Math.round(31557600 * n);
    }
    return "-" === t[1] || "ago" === t[4] ? -o : o;
}
function $65283fdff51e8344$var$fr(e, t) {
    if (!Number.isFinite(t)) throw new TypeError("Invalid ".concat(e, " input"));
    return t;
}
var $65283fdff51e8344$var$mr = function(e) {
    return e.includes("/") ? e.toLowerCase() : "application/".concat(e.toLowerCase());
};
function $65283fdff51e8344$var$yr(e, t) {
    var n, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    try {
        n = JSON.parse($65283fdff51e8344$var$Ao.decode(t));
    } catch (e) {}
    if (!$65283fdff51e8344$var$ni(n)) throw new $65283fdff51e8344$var$Fo("JWT Claims Set must be a top-level JSON object");
    var i = o.typ;
    if (i && ("string" != typeof e.typ || $65283fdff51e8344$var$mr(e.typ) !== $65283fdff51e8344$var$mr(i))) throw new $65283fdff51e8344$var$zo('unexpected "typ" JWT header value', n, "typ", "check_failed");
    var r = o.requiredClaims, a = void 0 === r ? [] : r, s = o.issuer, c = o.subject, u = o.audience, l = o.maxTokenAge, h = (0, $XnYkK._)(a);
    void 0 !== l && h.push("iat"), void 0 !== u && h.push("aud"), void 0 !== c && h.push("sub"), void 0 !== s && h.push("iss");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = new Set(h.reverse())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$e = _step.value;
            if (!(_$e in n)) throw new $65283fdff51e8344$var$zo('missing required "'.concat(_$e, '" claim'), n, _$e, "missing");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (s && !(Array.isArray(s) ? s : [
        s
    ]).includes(n.iss)) throw new $65283fdff51e8344$var$zo('unexpected "iss" claim value', n, "iss", "check_failed");
    if (c && n.sub !== c) throw new $65283fdff51e8344$var$zo('unexpected "sub" claim value', n, "sub", "check_failed");
    if (u && (_$d = n.aud, p = "string" == typeof u ? [
        u
    ] : u, !("string" == typeof _$d ? p.includes(_$d) : Array.isArray(_$d) && p.some(Set.prototype.has.bind(new Set(_$d)))))) throw new $65283fdff51e8344$var$zo('unexpected "aud" claim value', n, "aud", "check_failed");
    var _$d, p;
    var f;
    switch((0, $03bAP._)(o.clockTolerance)){
        case "string":
            f = $65283fdff51e8344$var$pr(o.clockTolerance);
            break;
        case "number":
            f = o.clockTolerance;
            break;
        case "undefined":
            f = 0;
            break;
        default:
            throw new TypeError("Invalid clockTolerance option type");
    }
    var m = o.currentDate, y = $65283fdff51e8344$var$lr(m || new Date);
    if ((void 0 !== n.iat || l) && "number" != typeof n.iat) throw new $65283fdff51e8344$var$zo('"iat" claim must be a number', n, "iat", "invalid");
    if (void 0 !== n.nbf) {
        if ("number" != typeof n.nbf) throw new $65283fdff51e8344$var$zo('"nbf" claim must be a number', n, "nbf", "invalid");
        if (n.nbf > y + f) throw new $65283fdff51e8344$var$zo('"nbf" claim timestamp check failed', n, "nbf", "check_failed");
    }
    if (void 0 !== n.exp) {
        if ("number" != typeof n.exp) throw new $65283fdff51e8344$var$zo('"exp" claim must be a number', n, "exp", "invalid");
        if (n.exp <= y - f) throw new $65283fdff51e8344$var$Do('"exp" claim timestamp check failed', n, "exp", "check_failed");
    }
    if (l) {
        var _$e1 = y - n.iat;
        if (_$e1 - f > ("number" == typeof l ? l : $65283fdff51e8344$var$pr(l))) throw new $65283fdff51e8344$var$Do('"iat" claim timestamp check failed (too far in the past)', n, "iat", "check_failed");
        if (_$e1 < 0 - f) throw new $65283fdff51e8344$var$zo('"iat" claim timestamp check failed (it should be in the past)', n, "iat", "check_failed");
    }
    return n;
}
var $65283fdff51e8344$var$wr = new WeakMap;
var $65283fdff51e8344$var$gr = /*#__PURE__*/ function() {
    "use strict";
    function gr(e) {
        (0, $5Epmf._)(this, gr);
        if ($65283fdff51e8344$var$u(this, $65283fdff51e8344$var$wr, void 0), !$65283fdff51e8344$var$ni(e)) throw new TypeError("JWT Claims Set MUST be an object");
        $65283fdff51e8344$var$l($65283fdff51e8344$var$wr, this, structuredClone(e));
    }
    (0, $9MqXK._)(gr, [
        {
            key: "data",
            value: function data() {
                return $65283fdff51e8344$var$Eo.encode(JSON.stringify($65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this)));
            }
        },
        {
            key: "iss",
            get: function get() {
                return $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).iss;
            },
            set: function set(e) {
                $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).iss = e;
            }
        },
        {
            key: "sub",
            get: function get() {
                return $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).sub;
            },
            set: function set(e) {
                $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).sub = e;
            }
        },
        {
            key: "aud",
            get: function get() {
                return $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).aud;
            },
            set: function set(e) {
                $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).aud = e;
            }
        },
        {
            key: "jti",
            set: function set(e) {
                $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).jti = e;
            }
        },
        {
            key: "nbf",
            set: function set(e) {
                "number" == typeof e ? $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).nbf = $65283fdff51e8344$var$fr("setNotBefore", e) : e instanceof Date ? $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).nbf = $65283fdff51e8344$var$fr("setNotBefore", $65283fdff51e8344$var$lr(e)) : $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).nbf = $65283fdff51e8344$var$lr(new Date) + $65283fdff51e8344$var$pr(e);
            }
        },
        {
            key: "exp",
            set: function set(e) {
                "number" == typeof e ? $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).exp = $65283fdff51e8344$var$fr("setExpirationTime", e) : e instanceof Date ? $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).exp = $65283fdff51e8344$var$fr("setExpirationTime", $65283fdff51e8344$var$lr(e)) : $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).exp = $65283fdff51e8344$var$lr(new Date) + $65283fdff51e8344$var$pr(e);
            }
        },
        {
            key: "iat",
            set: function set(e) {
                void 0 === e ? $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).iat = $65283fdff51e8344$var$lr(new Date) : e instanceof Date ? $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).iat = $65283fdff51e8344$var$fr("setIssuedAt", $65283fdff51e8344$var$lr(e)) : $65283fdff51e8344$var$c($65283fdff51e8344$var$wr, this).iat = $65283fdff51e8344$var$fr("setIssuedAt", "string" == typeof e ? $65283fdff51e8344$var$lr(new Date) + $65283fdff51e8344$var$pr(e) : e);
            }
        }
    ]);
    return gr;
}();
function $65283fdff51e8344$var$vr(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var o, i, r;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        function(e, t, n) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var o, i, r, a, s, c;
                                return (0, $3SMYb._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (e instanceof Uint8Array && (e = $65283fdff51e8344$var$Ao.decode(e)), "string" != typeof e) throw new $65283fdff51e8344$var$Zo("Compact JWS must be a string or Uint8Array");
                                            o = e.split("."), i = o[0], r = o[1], a = o[2];
                                            if (3 !== o.length) throw new $65283fdff51e8344$var$Zo("Invalid Compact JWS");
                                            return [
                                                4,
                                                $65283fdff51e8344$var$ur({
                                                    payload: r,
                                                    protected: i,
                                                    signature: a
                                                }, t, n)
                                            ];
                                        case 1:
                                            s = _state.sent(), c = {
                                                payload: s.payload,
                                                protectedHeader: s.protectedHeader
                                            };
                                            return [
                                                2,
                                                "function" == typeof t ? $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, c), {}, {
                                                    key: s.key
                                                }) : c
                                            ];
                                    }
                                });
                            })();
                        }(e, t, n)
                    ];
                case 1:
                    i = _state.sent();
                    if (null !== (o = i.protectedHeader.crit) && void 0 !== o && o.includes("b64") && !1 === i.protectedHeader.b64) throw new $65283fdff51e8344$var$Fo("JWTs MUST NOT use unencoded payload");
                    r = {
                        payload: $65283fdff51e8344$var$yr(i.protectedHeader, i.payload, n),
                        protectedHeader: i.protectedHeader
                    };
                    return [
                        2,
                        "function" == typeof t ? $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, r), {}, {
                            key: i.key
                        }) : r
                    ];
            }
        });
    })();
}
var $65283fdff51e8344$var$br = new WeakMap, $65283fdff51e8344$var$kr = new WeakMap, $65283fdff51e8344$var$_r = new WeakMap;
var $65283fdff51e8344$var$Sr = /*#__PURE__*/ function() {
    "use strict";
    function Sr(e) {
        (0, $5Epmf._)(this, Sr);
        if ($65283fdff51e8344$var$u(this, $65283fdff51e8344$var$br, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$kr, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$_r, void 0), !(e instanceof Uint8Array)) throw new TypeError("payload must be an instance of Uint8Array");
        $65283fdff51e8344$var$l($65283fdff51e8344$var$br, this, e);
    }
    (0, $9MqXK._)(Sr, [
        {
            key: "setProtectedHeader",
            value: function setProtectedHeader(e) {
                return $65283fdff51e8344$var$ei($65283fdff51e8344$var$c($65283fdff51e8344$var$kr, this), "setProtectedHeader"), $65283fdff51e8344$var$l($65283fdff51e8344$var$kr, this, e), this;
            }
        },
        {
            key: "setUnprotectedHeader",
            value: function setUnprotectedHeader(e) {
                return $65283fdff51e8344$var$ei($65283fdff51e8344$var$c($65283fdff51e8344$var$_r, this), "setUnprotectedHeader"), $65283fdff51e8344$var$l($65283fdff51e8344$var$_r, this, e), this;
            }
        },
        {
            key: "sign",
            value: function sign(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, i, r, a, s, u, l, h, _$d, p;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!$65283fdff51e8344$var$c($65283fdff51e8344$var$kr, this) && !$65283fdff51e8344$var$c($65283fdff51e8344$var$_r, this)) throw new $65283fdff51e8344$var$Zo("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
                                if (!$65283fdff51e8344$var$oi($65283fdff51e8344$var$c($65283fdff51e8344$var$kr, this), $65283fdff51e8344$var$c($65283fdff51e8344$var$_r, this))) throw new $65283fdff51e8344$var$Zo("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
                                n = $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, $65283fdff51e8344$var$c($65283fdff51e8344$var$kr, this)), $65283fdff51e8344$var$c($65283fdff51e8344$var$_r, this));
                                o = !0;
                                if ($65283fdff51e8344$var$_i($65283fdff51e8344$var$Zo, new Map([
                                    [
                                        "b64",
                                        !0
                                    ]
                                ]), null == t ? void 0 : t.crit, $65283fdff51e8344$var$c($65283fdff51e8344$var$kr, this), n).has("b64") && (o = $65283fdff51e8344$var$c($65283fdff51e8344$var$kr, this).b64, "boolean" != typeof o)) throw new $65283fdff51e8344$var$Zo('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
                                i = n.alg;
                                if ("string" != typeof i || !i) throw new $65283fdff51e8344$var$Zo('JWS "alg" (Algorithm) Header Parameter missing or invalid');
                                $65283fdff51e8344$var$Pi(i, e, "sign"), o ? (r = $65283fdff51e8344$var$Co($65283fdff51e8344$var$c($65283fdff51e8344$var$br, this)), a = $65283fdff51e8344$var$xo(r)) : (a = $65283fdff51e8344$var$c($65283fdff51e8344$var$br, this), r = ""), $65283fdff51e8344$var$c($65283fdff51e8344$var$kr, this) ? (s = $65283fdff51e8344$var$Co(JSON.stringify($65283fdff51e8344$var$c($65283fdff51e8344$var$kr, this))), u = $65283fdff51e8344$var$xo(s)) : (s = "", u = new Uint8Array);
                                l = $65283fdff51e8344$var$Io(u, $65283fdff51e8344$var$xo("."), a);
                                return [
                                    4,
                                    $65283fdff51e8344$var$pi(e, i)
                                ];
                            case 1:
                                h = _state.sent();
                                return [
                                    4,
                                    function(e, t, n) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                            var o, i;
                                            return (0, $3SMYb._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            $65283fdff51e8344$var$si(e, t, "sign")
                                                        ];
                                                    case 1:
                                                        o = _state.sent();
                                                        $65283fdff51e8344$var$ri(e, o);
                                                        return [
                                                            4,
                                                            crypto.subtle.sign($65283fdff51e8344$var$ai(e, o.algorithm), o, n)
                                                        ];
                                                    case 2:
                                                        i = _state.sent();
                                                        return [
                                                            2,
                                                            new Uint8Array(i)
                                                        ];
                                                }
                                            });
                                        })();
                                    }(i, h, l)
                                ];
                            case 2:
                                _$d = _state.sent(), p = {
                                    signature: $65283fdff51e8344$var$Co(_$d),
                                    payload: r
                                };
                                return [
                                    2,
                                    ($65283fdff51e8344$var$c($65283fdff51e8344$var$_r, this) && (p.header = $65283fdff51e8344$var$c($65283fdff51e8344$var$_r, this)), $65283fdff51e8344$var$c($65283fdff51e8344$var$kr, this) && (p.protected = s), p)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return Sr;
}();
var $65283fdff51e8344$var$Tr = new WeakMap;
var $65283fdff51e8344$var$Pr = /*#__PURE__*/ function() {
    "use strict";
    function Pr(e) {
        (0, $5Epmf._)(this, Pr);
        $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Tr, void 0), $65283fdff51e8344$var$l($65283fdff51e8344$var$Tr, this, new $65283fdff51e8344$var$Sr(e));
    }
    (0, $9MqXK._)(Pr, [
        {
            key: "setProtectedHeader",
            value: function setProtectedHeader(e) {
                return $65283fdff51e8344$var$c($65283fdff51e8344$var$Tr, this).setProtectedHeader(e), this;
            }
        },
        {
            key: "sign",
            value: function sign(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$c($65283fdff51e8344$var$Tr, this).sign(e, t)
                                ];
                            case 1:
                                n = _state.sent();
                                if (void 0 === n.payload) throw new TypeError("use the flattened module for creating JWS with b64: false");
                                return [
                                    2,
                                    "".concat(n.protected, ".").concat(n.payload, ".").concat(n.signature)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return Pr;
}();
var $65283fdff51e8344$var$Er = new WeakMap, $65283fdff51e8344$var$Ar = new WeakMap;
var $65283fdff51e8344$var$Ir = /*#__PURE__*/ function() {
    "use strict";
    function Ir() {
        (0, $5Epmf._)(this, Ir);
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Er, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Ar, void 0), $65283fdff51e8344$var$l($65283fdff51e8344$var$Ar, this, new $65283fdff51e8344$var$gr(e));
    }
    (0, $9MqXK._)(Ir, [
        {
            key: "setIssuer",
            value: function setIssuer(e) {
                return $65283fdff51e8344$var$c($65283fdff51e8344$var$Ar, this).iss = e, this;
            }
        },
        {
            key: "setSubject",
            value: function setSubject(e) {
                return $65283fdff51e8344$var$c($65283fdff51e8344$var$Ar, this).sub = e, this;
            }
        },
        {
            key: "setAudience",
            value: function setAudience(e) {
                return $65283fdff51e8344$var$c($65283fdff51e8344$var$Ar, this).aud = e, this;
            }
        },
        {
            key: "setJti",
            value: function setJti(e) {
                return $65283fdff51e8344$var$c($65283fdff51e8344$var$Ar, this).jti = e, this;
            }
        },
        {
            key: "setNotBefore",
            value: function setNotBefore(e) {
                return $65283fdff51e8344$var$c($65283fdff51e8344$var$Ar, this).nbf = e, this;
            }
        },
        {
            key: "setExpirationTime",
            value: function setExpirationTime(e) {
                return $65283fdff51e8344$var$c($65283fdff51e8344$var$Ar, this).exp = e, this;
            }
        },
        {
            key: "setIssuedAt",
            value: function setIssuedAt(e) {
                return $65283fdff51e8344$var$c($65283fdff51e8344$var$Ar, this).iat = e, this;
            }
        },
        {
            key: "setProtectedHeader",
            value: function setProtectedHeader(e) {
                return $65283fdff51e8344$var$l($65283fdff51e8344$var$Er, this, e), this;
            }
        },
        {
            key: "sign",
            value: function sign(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o;
                    return (0, $3SMYb._)(this, function(_state) {
                        o = new $65283fdff51e8344$var$Pr($65283fdff51e8344$var$c($65283fdff51e8344$var$Ar, this).data());
                        if (o.setProtectedHeader($65283fdff51e8344$var$c($65283fdff51e8344$var$Er, this)), Array.isArray(null === (n = $65283fdff51e8344$var$c($65283fdff51e8344$var$Er, this)) || void 0 === n ? void 0 : n.crit) && $65283fdff51e8344$var$c($65283fdff51e8344$var$Er, this).crit.includes("b64") && !1 === $65283fdff51e8344$var$c($65283fdff51e8344$var$Er, this).b64) throw new $65283fdff51e8344$var$Fo("JWTs MUST NOT use unencoded payload");
                        return [
                            2,
                            o.sign(e, t)
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return Ir;
}();
function $65283fdff51e8344$var$xr(e) {
    return $65283fdff51e8344$var$ni(e);
}
var $65283fdff51e8344$var$Rr, $65283fdff51e8344$var$Or, $65283fdff51e8344$var$Cr = new WeakMap, $65283fdff51e8344$var$Wr = new WeakMap;
var $65283fdff51e8344$var$jr = /*#__PURE__*/ function() {
    "use strict";
    function jr(e) {
        (0, $5Epmf._)(this, jr);
        if ($65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Cr, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Wr, new WeakMap), !function(e) {
            return e && "object" == (typeof e === "undefined" ? "undefined" : (0, $03bAP._)(e)) && Array.isArray(e.keys) && e.keys.every($65283fdff51e8344$var$xr);
        }(e)) throw new $65283fdff51e8344$var$Vo("JSON Web Key Set malformed");
        $65283fdff51e8344$var$l($65283fdff51e8344$var$Cr, this, structuredClone(e));
    }
    (0, $9MqXK._)(jr, [
        {
            key: "jwks",
            value: function jwks() {
                return $65283fdff51e8344$var$c($65283fdff51e8344$var$Cr, this);
            }
        },
        {
            key: "getKey",
            value: function getKey(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, i, r, s, u, l, _$e, _$t;
                    return (0, $3SMYb._)(this, function(_state) {
                        n = $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, e), null == t ? void 0 : t.header), o = n.alg, i = n.kid, r = function(e) {
                            switch("string" == typeof e && e.slice(0, 2)){
                                case "RS":
                                case "PS":
                                    return "RSA";
                                case "ES":
                                    return "EC";
                                case "Ed":
                                    return "OKP";
                                case "ML":
                                    return "AKP";
                                default:
                                    throw new $65283fdff51e8344$var$Ho('Unsupported "alg" value for a JSON Web Key Set');
                            }
                        }(o), s = $65283fdff51e8344$var$c($65283fdff51e8344$var$Cr, this).keys.filter(function(e) {
                            var _$t = r === e.kty;
                            if (_$t && "string" == typeof i && (_$t = i === e.kid), !_$t || "string" != typeof e.alg && "AKP" !== r || (_$t = o === e.alg), _$t && "string" == typeof e.use && (_$t = "sig" === e.use), _$t && Array.isArray(e.key_ops) && (_$t = e.key_ops.includes("verify")), _$t) switch(o){
                                case "ES256":
                                    _$t = "P-256" === e.crv;
                                    break;
                                case "ES384":
                                    _$t = "P-384" === e.crv;
                                    break;
                                case "ES512":
                                    _$t = "P-521" === e.crv;
                                    break;
                                case "Ed25519":
                                case "EdDSA":
                                    _$t = "Ed25519" === e.crv;
                            }
                            return _$t;
                        }), u = s[0], l = s.length;
                        if (0 === l) throw new $65283fdff51e8344$var$Xo;
                        if (1 !== l) {
                            _$e = new $65283fdff51e8344$var$Go, _$t = $65283fdff51e8344$var$c($65283fdff51e8344$var$Wr, this);
                            throw _$e[Symbol.asyncIterator] = $65283fdff51e8344$var$w(function() {
                                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e, e, err;
                                return (0, $3SMYb._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                9,
                                                10,
                                                11
                                            ]);
                                            _iterator = s[Symbol.iterator]();
                                            _state.label = 2;
                                        case 2:
                                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                                3,
                                                8
                                            ];
                                            _$e = _step.value;
                                            _state.label = 3;
                                        case 3:
                                            _state.trys.push([
                                                3,
                                                6,
                                                ,
                                                7
                                            ]);
                                            return [
                                                4,
                                                $65283fdff51e8344$var$a($65283fdff51e8344$var$Kr(_$t, _$e, o))
                                            ];
                                        case 4:
                                            return [
                                                4,
                                                _state.sent()
                                            ];
                                        case 5:
                                            _state.sent();
                                            return [
                                                3,
                                                7
                                            ];
                                        case 6:
                                            e = _state.sent();
                                            return [
                                                3,
                                                7
                                            ];
                                        case 7:
                                            _iteratorNormalCompletion = true;
                                            return [
                                                3,
                                                2
                                            ];
                                        case 8:
                                            return [
                                                3,
                                                11
                                            ];
                                        case 9:
                                            err = _state.sent();
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                            return [
                                                3,
                                                11
                                            ];
                                        case 10:
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                            return [
                                                7
                                            ];
                                        case 11:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }), _$e;
                        }
                        return [
                            2,
                            $65283fdff51e8344$var$Kr($65283fdff51e8344$var$c($65283fdff51e8344$var$Wr, this), u, o)
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return jr;
}();
function $65283fdff51e8344$var$Kr(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var o, _$e;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    o = e.get(t) || e.set(t, {}).get(t);
                    if (!(void 0 === o[n])) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        function(e, t, n) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var o, i;
                                return (0, $3SMYb._)(this, function(_state) {
                                    if (!$65283fdff51e8344$var$ni(e)) throw new TypeError("JWK must be an object");
                                    switch(null != t || (t = e.alg), null != i || (i = null !== (o = null == n ? void 0 : n.extractable) && void 0 !== o ? o : e.ext), e.kty){
                                        case "oct":
                                            if ("string" != typeof e.k || !e.k) throw new TypeError('missing "k" (Key Value) Parameter value');
                                            return [
                                                2,
                                                $65283fdff51e8344$var$Oo(e.k)
                                            ];
                                        case "RSA":
                                            if ("oth" in e && void 0 !== e.oth) throw new $65283fdff51e8344$var$Ho('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
                                            return [
                                                2,
                                                $65283fdff51e8344$var$ui($65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, e), {}, {
                                                    alg: t,
                                                    ext: i
                                                }))
                                            ];
                                        case "AKP":
                                            if ("string" != typeof e.alg || !e.alg) throw new TypeError('missing "alg" (Algorithm) Parameter value');
                                            if (void 0 !== t && t !== e.alg) throw new TypeError("JWK alg and alg option value mismatch");
                                            return [
                                                2,
                                                $65283fdff51e8344$var$ui($65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, e), {}, {
                                                    ext: i
                                                }))
                                            ];
                                        case "EC":
                                        case "OKP":
                                            return [
                                                2,
                                                $65283fdff51e8344$var$ui($65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, e), {}, {
                                                    alg: t,
                                                    ext: i
                                                }))
                                            ];
                                        default:
                                            throw new $65283fdff51e8344$var$Ho('Unsupported "kty" (Key Type) Parameter value');
                                    }
                                    return [
                                        2
                                    ];
                                });
                            })();
                        }($65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, t), {}, {
                            ext: !0
                        }), n)
                    ];
                case 1:
                    _$e = _state.sent();
                    if (_$e instanceof Uint8Array || "public" !== _$e.type) throw new $65283fdff51e8344$var$Vo("JSON Web Key Set members must be public keys");
                    o[n] = _$e;
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        o[n]
                    ];
            }
        });
    })();
}
function $65283fdff51e8344$var$Ur(e) {
    var t = new $65283fdff51e8344$var$jr(e), n = function(e, n) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            return (0, $3SMYb._)(this, function(_state) {
                return [
                    2,
                    t.getKey(e, n)
                ];
            });
        })();
    };
    return Object.defineProperties(n, {
        jwks: {
            value: function() {
                return structuredClone(t.jwks());
            },
            enumerable: !1,
            configurable: !1,
            writable: !1
        }
    }), n;
}
var $65283fdff51e8344$var$Nr;
if ("undefined" == typeof navigator || null === ($65283fdff51e8344$var$Rr = navigator.userAgent) || void 0 === $65283fdff51e8344$var$Rr || null === ($65283fdff51e8344$var$Or = $65283fdff51e8344$var$Rr.startsWith) || void 0 === $65283fdff51e8344$var$Or || !$65283fdff51e8344$var$Or.call($65283fdff51e8344$var$Rr, "Mozilla/5.0 ")) {
    var $65283fdff51e8344$var$e5 = "v6.2.3";
    $65283fdff51e8344$var$Nr = "".concat("jose", "/").concat($65283fdff51e8344$var$e5);
}
var $65283fdff51e8344$var$Lr = Symbol();
var $65283fdff51e8344$var$Mr = Symbol();
var $65283fdff51e8344$var$zr = new WeakMap, $65283fdff51e8344$var$Dr = new WeakMap, $65283fdff51e8344$var$Jr = new WeakMap, $65283fdff51e8344$var$Hr = new WeakMap, $65283fdff51e8344$var$Zr = new WeakMap, $65283fdff51e8344$var$Fr = new WeakMap, $65283fdff51e8344$var$Vr = new WeakMap, $65283fdff51e8344$var$Xr = new WeakMap, $65283fdff51e8344$var$Gr = new WeakMap, $65283fdff51e8344$var$Yr = new WeakMap;
var $65283fdff51e8344$var$Br = /*#__PURE__*/ function() {
    "use strict";
    function Br(e, t) {
        (0, $5Epmf._)(this, Br);
        if ($65283fdff51e8344$var$u(this, $65283fdff51e8344$var$zr, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Dr, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Jr, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Hr, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Zr, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Fr, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Vr, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Xr, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Gr, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Yr, void 0), !(e instanceof URL)) throw new TypeError("url must be an instance of URL");
        var n, o;
        $65283fdff51e8344$var$l($65283fdff51e8344$var$zr, this, new URL(e.href)), $65283fdff51e8344$var$l($65283fdff51e8344$var$Dr, this, "number" == typeof (null == t ? void 0 : t.timeoutDuration) ? null == t ? void 0 : t.timeoutDuration : 5e3), $65283fdff51e8344$var$l($65283fdff51e8344$var$Jr, this, "number" == typeof (null == t ? void 0 : t.cooldownDuration) ? null == t ? void 0 : t.cooldownDuration : 3e4), $65283fdff51e8344$var$l($65283fdff51e8344$var$Hr, this, "number" == typeof (null == t ? void 0 : t.cacheMaxAge) ? null == t ? void 0 : t.cacheMaxAge : 6e5), $65283fdff51e8344$var$l($65283fdff51e8344$var$Vr, this, new Headers(null == t ? void 0 : t.headers)), $65283fdff51e8344$var$Nr && !$65283fdff51e8344$var$c($65283fdff51e8344$var$Vr, this).has("User-Agent") && $65283fdff51e8344$var$c($65283fdff51e8344$var$Vr, this).set("User-Agent", $65283fdff51e8344$var$Nr), $65283fdff51e8344$var$c($65283fdff51e8344$var$Vr, this).has("accept") || ($65283fdff51e8344$var$c($65283fdff51e8344$var$Vr, this).set("accept", "application/json"), $65283fdff51e8344$var$c($65283fdff51e8344$var$Vr, this).append("accept", "application/jwk-set+json")), $65283fdff51e8344$var$l($65283fdff51e8344$var$Xr, this, null == t ? void 0 : t[$65283fdff51e8344$var$Lr]), void 0 !== (null == t ? void 0 : t[$65283fdff51e8344$var$Mr]) && ($65283fdff51e8344$var$l($65283fdff51e8344$var$Yr, this, null == t ? void 0 : t[$65283fdff51e8344$var$Mr]), n = null == t ? void 0 : t[$65283fdff51e8344$var$Mr], o = $65283fdff51e8344$var$c($65283fdff51e8344$var$Hr, this), "object" == (typeof n === "undefined" ? "undefined" : (0, $03bAP._)(n)) && null !== n && "uat" in n && "number" == typeof n.uat && !(Date.now() - n.uat >= o) && "jwks" in n && $65283fdff51e8344$var$ni(n.jwks) && Array.isArray(n.jwks.keys) && Array.prototype.every.call(n.jwks.keys, $65283fdff51e8344$var$ni) && ($65283fdff51e8344$var$l($65283fdff51e8344$var$Zr, this, $65283fdff51e8344$var$c($65283fdff51e8344$var$Yr, this).uat), $65283fdff51e8344$var$l($65283fdff51e8344$var$Gr, this, $65283fdff51e8344$var$Ur($65283fdff51e8344$var$c($65283fdff51e8344$var$Yr, this).jwks))));
    }
    (0, $9MqXK._)(Br, [
        {
            key: "pendingFetch",
            value: function pendingFetch() {
                return !!$65283fdff51e8344$var$c($65283fdff51e8344$var$Fr, this);
            }
        },
        {
            key: "coolingDown",
            value: function coolingDown() {
                return "number" == typeof $65283fdff51e8344$var$c($65283fdff51e8344$var$Zr, this) && Date.now() < $65283fdff51e8344$var$c($65283fdff51e8344$var$Zr, this) + $65283fdff51e8344$var$c($65283fdff51e8344$var$Jr, this);
            }
        },
        {
            key: "fresh",
            value: function fresh() {
                return "number" == typeof $65283fdff51e8344$var$c($65283fdff51e8344$var$Zr, this) && Date.now() < $65283fdff51e8344$var$c($65283fdff51e8344$var$Zr, this) + $65283fdff51e8344$var$c($65283fdff51e8344$var$Hr, this);
            }
        },
        {
            key: "jwks",
            value: function jwks() {
                var e;
                return null === (e = $65283fdff51e8344$var$c($65283fdff51e8344$var$Gr, this)) || void 0 === e ? void 0 : e.jwks();
            }
        },
        {
            key: "getKey",
            value: function getKey(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _tmp, n;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = $65283fdff51e8344$var$c($65283fdff51e8344$var$Gr, this) && this.fresh();
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.reload()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$c($65283fdff51e8344$var$Gr, this).call(this, e, t)
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                n = _state.sent();
                                if (!(n instanceof $65283fdff51e8344$var$Xo && !1 === this.coolingDown())) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    this.reload()
                                ];
                            case 6:
                                return [
                                    2,
                                    (_state.sent(), $65283fdff51e8344$var$c($65283fdff51e8344$var$Gr, this).call(this, e, t))
                                ];
                            case 7:
                                throw n;
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "reload",
            value: function reload() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _this;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                $65283fdff51e8344$var$c($65283fdff51e8344$var$Fr, this) && ("undefined" != typeof WebSocketPair || "undefined" != typeof navigator && "Cloudflare-Workers" === navigator.userAgent || "undefined" != typeof EdgeRuntime && "vercel" === EdgeRuntime) && $65283fdff51e8344$var$l($65283fdff51e8344$var$Fr, this, void 0), $65283fdff51e8344$var$c($65283fdff51e8344$var$Fr, this) || $65283fdff51e8344$var$l($65283fdff51e8344$var$Fr, this, (function(_0, _1, _2) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(e, t, n) {
                                        var o, i, e1;
                                        var _arguments = arguments;
                                        return (0, $3SMYb._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    o = _arguments.length > 3 && void 0 !== _arguments[3] ? _arguments[3] : fetch;
                                                    return [
                                                        4,
                                                        o(e, {
                                                            method: "GET",
                                                            signal: n,
                                                            redirect: "manual",
                                                            headers: t
                                                        }).catch(function(e) {
                                                            if ("TimeoutError" === e.name) throw new $65283fdff51e8344$var$Yo;
                                                            throw e;
                                                        })
                                                    ];
                                                case 1:
                                                    i = _state.sent();
                                                    if (200 !== i.status) throw new $65283fdff51e8344$var$Mo("Expected 200 OK from the JSON Web Key Set HTTP response");
                                                    _state.label = 2;
                                                case 2:
                                                    _state.trys.push([
                                                        2,
                                                        4,
                                                        ,
                                                        5
                                                    ]);
                                                    return [
                                                        4,
                                                        i.json()
                                                    ];
                                                case 3:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                                case 4:
                                                    e1 = _state.sent();
                                                    throw new $65283fdff51e8344$var$Mo("Failed to parse the JSON Web Key Set HTTP response as JSON");
                                                case 5:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }).apply(this, arguments);
                                })($65283fdff51e8344$var$c($65283fdff51e8344$var$zr, this).href, $65283fdff51e8344$var$c($65283fdff51e8344$var$Vr, this), AbortSignal.timeout($65283fdff51e8344$var$c($65283fdff51e8344$var$Dr, this)), $65283fdff51e8344$var$c($65283fdff51e8344$var$Xr, this)).then(function(e) {
                                    $65283fdff51e8344$var$l($65283fdff51e8344$var$Gr, _this, $65283fdff51e8344$var$Ur(e)), $65283fdff51e8344$var$c($65283fdff51e8344$var$Yr, _this) && ($65283fdff51e8344$var$c($65283fdff51e8344$var$Yr, _this).uat = Date.now(), $65283fdff51e8344$var$c($65283fdff51e8344$var$Yr, _this).jwks = e), $65283fdff51e8344$var$l($65283fdff51e8344$var$Zr, _this, Date.now()), $65283fdff51e8344$var$l($65283fdff51e8344$var$Fr, _this, void 0);
                                }).catch(function(e) {
                                    throw $65283fdff51e8344$var$l($65283fdff51e8344$var$Fr, _this, void 0), e;
                                }));
                                return [
                                    4,
                                    $65283fdff51e8344$var$c($65283fdff51e8344$var$Fr, this)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return Br;
}();
var $65283fdff51e8344$var$qr = [
    "mfaToken"
], $65283fdff51e8344$var$Qr = [
    "mfaToken"
];
var $65283fdff51e8344$var$$r, $65283fdff51e8344$var$ea, $65283fdff51e8344$var$ta, $65283fdff51e8344$var$na, $65283fdff51e8344$var$oa, $65283fdff51e8344$var$ia, $65283fdff51e8344$var$ra, $65283fdff51e8344$var$aa, $65283fdff51e8344$var$sa, $65283fdff51e8344$var$ca, $65283fdff51e8344$var$ua, $65283fdff51e8344$var$la, $65283fdff51e8344$var$ha, $65283fdff51e8344$var$da, $65283fdff51e8344$var$pa, $65283fdff51e8344$var$fa, $65283fdff51e8344$var$ma, $65283fdff51e8344$var$ya, $65283fdff51e8344$var$wa, $65283fdff51e8344$var$ga, $65283fdff51e8344$var$va, $65283fdff51e8344$var$ba, $65283fdff51e8344$var$ka, $65283fdff51e8344$var$_a, $65283fdff51e8344$var$Sa, $65283fdff51e8344$var$Ta, $65283fdff51e8344$var$Pa, $65283fdff51e8344$var$Ea, $65283fdff51e8344$var$Aa, $65283fdff51e8344$var$Ia, $65283fdff51e8344$var$xa, $65283fdff51e8344$var$Ra, $65283fdff51e8344$var$Oa, $65283fdff51e8344$var$Ca;
function $65283fdff51e8344$var$Wa(e) {
    var t, n;
    if ("object" != (typeof e === "undefined" ? "undefined" : (0, $03bAP._)(e)) || null === e) return {
        error: "unknown_error",
        error_description: String(e)
    };
    var o = e, i = {
        error: null !== (t = o.error) && void 0 !== t ? t : "",
        error_description: null !== (n = o.error_description) && void 0 !== n ? n : "",
        message: o.message
    };
    if ("mfa_required" === o.error && o.cause) {
        i.mfa_token = "string" == typeof o.cause.mfa_token ? o.cause.mfa_token : void 0;
        var _$e = o.cause.mfa_requirements;
        "object" == (typeof _$e === "undefined" ? "undefined" : (0, $03bAP._)(_$e)) && null !== _$e && (i.mfa_requirements = _$e);
    }
    return i;
}
var $65283fdff51e8344$var$ja = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(ja, Error1);
    function ja(e, t) {
        (0, $5Epmf._)(this, ja);
        var _this;
        _this = (0, $48Z0s._)(this, ja, [
            t
        ]), $65283fdff51e8344$var$d(_this, "code", void 0), _this.name = "NotSupportedError", _this.code = e;
        return _this;
    }
    return ja;
}((0, $kW1tL._)(Error)), $65283fdff51e8344$var$Ka = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(Ka, Error1);
    function Ka(e, t, n) {
        (0, $5Epmf._)(this, Ka);
        var _this;
        _this = (0, $48Z0s._)(this, Ka, [
            t
        ]), $65283fdff51e8344$var$d(_this, "cause", void 0), $65283fdff51e8344$var$d(_this, "code", void 0), _this.code = e, _this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message,
            mfa_token: n.mfa_token,
            mfa_requirements: n.mfa_requirements
        };
        return _this;
    }
    return Ka;
}((0, $kW1tL._)(Error)), $65283fdff51e8344$var$Ua = /*#__PURE__*/ function(Ka) {
    "use strict";
    (0, $4QAx6._)(Ua, Ka);
    function Ua(e, t) {
        (0, $5Epmf._)(this, Ua);
        var _this;
        _this = (0, $48Z0s._)(this, Ua, [
            "token_by_code_error",
            e,
            t
        ]), _this.name = "TokenByCodeError";
        return _this;
    }
    return Ua;
}($65283fdff51e8344$var$Ka), $65283fdff51e8344$var$Na = /*#__PURE__*/ function(Ka) {
    "use strict";
    (0, $4QAx6._)(Na, Ka);
    function Na(e, t) {
        (0, $5Epmf._)(this, Na);
        var _this;
        _this = (0, $48Z0s._)(this, Na, [
            "token_by_client_credentials_error",
            e,
            t
        ]), _this.name = "TokenByClientCredentialsError";
        return _this;
    }
    return Na;
}($65283fdff51e8344$var$Ka), $65283fdff51e8344$var$La = /*#__PURE__*/ function(Ka) {
    "use strict";
    (0, $4QAx6._)(La, Ka);
    function La(e, t) {
        (0, $5Epmf._)(this, La);
        var _this;
        _this = (0, $48Z0s._)(this, La, [
            "token_by_refresh_token_error",
            e,
            t
        ]), _this.name = "TokenByRefreshTokenError";
        return _this;
    }
    return La;
}($65283fdff51e8344$var$Ka), $65283fdff51e8344$var$Ma = /*#__PURE__*/ function(Ka) {
    "use strict";
    (0, $4QAx6._)(Ma, Ka);
    function Ma(e, t) {
        (0, $5Epmf._)(this, Ma);
        var _this;
        _this = (0, $48Z0s._)(this, Ma, [
            "token_by_password_error",
            e,
            t
        ]), _this.name = "TokenByPasswordError";
        return _this;
    }
    return Ma;
}($65283fdff51e8344$var$Ka), $65283fdff51e8344$var$za = /*#__PURE__*/ function(Ka) {
    "use strict";
    (0, $4QAx6._)(za, Ka);
    function za(e, t) {
        (0, $5Epmf._)(this, za);
        var _this;
        _this = (0, $48Z0s._)(this, za, [
            "token_for_connection_error",
            e,
            t
        ]), _this.name = "TokenForConnectionErrorCode";
        return _this;
    }
    return za;
}($65283fdff51e8344$var$Ka), $65283fdff51e8344$var$Da = /*#__PURE__*/ function(Ka) {
    "use strict";
    (0, $4QAx6._)(Da, Ka);
    function Da(e, t) {
        (0, $5Epmf._)(this, Da);
        var _this;
        _this = (0, $48Z0s._)(this, Da, [
            "token_exchange_error",
            e,
            t
        ]), _this.name = "TokenExchangeError";
        return _this;
    }
    return Da;
}($65283fdff51e8344$var$Ka), $65283fdff51e8344$var$Ja = /*#__PURE__*/ function(Ka) {
    "use strict";
    (0, $4QAx6._)(Ja, Ka);
    function Ja(e, t) {
        (0, $5Epmf._)(this, Ja);
        var _this;
        _this = (0, $48Z0s._)(this, Ja, [
            "token_revocation_error",
            e,
            t
        ]), _this.name = "TokenRevocationError";
        return _this;
    }
    return Ja;
}($65283fdff51e8344$var$Ka), $65283fdff51e8344$var$Ha = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(Ha, Error1);
    function Ha(e) {
        (0, $5Epmf._)(this, Ha);
        var _this;
        _this = (0, $48Z0s._)(this, Ha, [
            e
        ]), $65283fdff51e8344$var$d(_this, "code", "verify_logout_token_error"), _this.name = "VerifyLogoutTokenError";
        return _this;
    }
    return Ha;
}((0, $kW1tL._)(Error)), $65283fdff51e8344$var$Za = /*#__PURE__*/ function(Ka) {
    "use strict";
    (0, $4QAx6._)(Za, Ka);
    function Za(e) {
        (0, $5Epmf._)(this, Za);
        var _this;
        _this = (0, $48Z0s._)(this, Za, [
            "backchannel_authentication_error",
            "There was an error when trying to use Client-Initiated Backchannel Authentication.",
            e
        ]), $65283fdff51e8344$var$d(_this, "code", "backchannel_authentication_error"), _this.name = "BackchannelAuthenticationError";
        return _this;
    }
    return Za;
}($65283fdff51e8344$var$Ka), $65283fdff51e8344$var$Fa = /*#__PURE__*/ function(Ka) {
    "use strict";
    (0, $4QAx6._)(Fa, Ka);
    function Fa(e) {
        (0, $5Epmf._)(this, Fa);
        var _this;
        _this = (0, $48Z0s._)(this, Fa, [
            "build_authorization_url_error",
            "There was an error when trying to build the authorization URL.",
            e
        ]), _this.name = "BuildAuthorizationUrlError";
        return _this;
    }
    return Fa;
}($65283fdff51e8344$var$Ka), $65283fdff51e8344$var$Va = /*#__PURE__*/ function(Ka) {
    "use strict";
    (0, $4QAx6._)(Va, Ka);
    function Va(e) {
        (0, $5Epmf._)(this, Va);
        var _this;
        _this = (0, $48Z0s._)(this, Va, [
            "build_link_user_url_error",
            "There was an error when trying to build the Link User URL.",
            e
        ]), _this.name = "BuildLinkUserUrlError";
        return _this;
    }
    return Va;
}($65283fdff51e8344$var$Ka), $65283fdff51e8344$var$Xa = /*#__PURE__*/ function(Ka) {
    "use strict";
    (0, $4QAx6._)(Xa, Ka);
    function Xa(e) {
        (0, $5Epmf._)(this, Xa);
        var _this;
        _this = (0, $48Z0s._)(this, Xa, [
            "build_unlink_user_url_error",
            "There was an error when trying to build the Unlink User URL.",
            e
        ]), _this.name = "BuildUnlinkUserUrlError";
        return _this;
    }
    return Xa;
}($65283fdff51e8344$var$Ka), $65283fdff51e8344$var$Ga = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(Ga, Error1);
    function Ga() {
        (0, $5Epmf._)(this, Ga);
        var _this;
        _this = (0, $48Z0s._)(this, Ga, [
            "The client secret or client assertion signing key must be provided."
        ]), $65283fdff51e8344$var$d(_this, "code", "missing_client_auth_error"), _this.name = "MissingClientAuthError";
        return _this;
    }
    return Ga;
}((0, $kW1tL._)(Error)), $65283fdff51e8344$var$Ya = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(Ya, Error1);
    function Ya(e) {
        (0, $5Epmf._)(this, Ya);
        var _this;
        _this = (0, $48Z0s._)(this, Ya, [
            e
        ]), $65283fdff51e8344$var$d(_this, "code", "organization_validation_error"), _this.name = "OrganizationValidationError";
        return _this;
    }
    return Ya;
}((0, $kW1tL._)(Error));
function $65283fdff51e8344$var$Ba(e) {
    return Object.entries(e).filter(function(e) {
        return void 0 !== $65283fdff51e8344$var$y(e, 2)[1];
    }).reduce(function(e, t) {
        return $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, e), {}, (0, $dUlz9._)({}, t[0], t[1]));
    }, {});
}
function $65283fdff51e8344$var$qa(e) {
    if (!e.trim()) throw new $65283fdff51e8344$var$Ya("organization must not be blank");
}
function $65283fdff51e8344$var$Qa(e, t) {
    if (!e) return;
    var n = t.trim();
    if (n.startsWith("org_")) {
        var _$t = e.org_id;
        if ("string" != typeof _$t) throw new $65283fdff51e8344$var$Ya("Organization Id (org_id) claim must be a string present in the ID token");
        if (_$t !== n) throw new $65283fdff51e8344$var$Ya('Organization Id (org_id) claim value mismatch in the ID token; expected "'.concat(n, '", found "').concat(_$t, '"'));
    } else {
        var _$t1 = e.org_name;
        if ("string" != typeof _$t1) throw new $65283fdff51e8344$var$Ya("Organization Name (org_name) claim must be a string present in the ID token");
        if (_$t1.toLowerCase() !== n.toLowerCase()) throw new $65283fdff51e8344$var$Ya('Organization Name (org_name) claim value mismatch in the ID token; expected "'.concat(n, '", found "').concat(_$t1, '"'));
    }
}
var $65283fdff51e8344$var$$a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)($a, Error1);
    function $a(e, t, n) {
        (0, $5Epmf._)(this, $a);
        var _this;
        _this = (0, $48Z0s._)(this, $a, [
            t
        ]), $65283fdff51e8344$var$d(_this, "cause", void 0), $65283fdff51e8344$var$d(_this, "code", void 0), _this.code = e, _this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message
        };
        return _this;
    }
    return $a;
}((0, $kW1tL._)(Error)), $65283fdff51e8344$var$es = /*#__PURE__*/ function($a) {
    "use strict";
    (0, $4QAx6._)(es, $a);
    function es(e, t) {
        (0, $5Epmf._)(this, es);
        var _this;
        _this = (0, $48Z0s._)(this, es, [
            "mfa_list_authenticators_error",
            e,
            t
        ]), _this.name = "MfaListAuthenticatorsError";
        return _this;
    }
    return es;
}($65283fdff51e8344$var$$a), $65283fdff51e8344$var$ts = /*#__PURE__*/ function($a) {
    "use strict";
    (0, $4QAx6._)(ts, $a);
    function ts(e, t) {
        (0, $5Epmf._)(this, ts);
        var _this;
        _this = (0, $48Z0s._)(this, ts, [
            "mfa_enrollment_error",
            e,
            t
        ]), _this.name = "MfaEnrollmentError";
        return _this;
    }
    return ts;
}($65283fdff51e8344$var$$a), $65283fdff51e8344$var$ns = /*#__PURE__*/ function($a) {
    "use strict";
    (0, $4QAx6._)(ns, $a);
    function ns(e, t) {
        (0, $5Epmf._)(this, ns);
        var _this;
        _this = (0, $48Z0s._)(this, ns, [
            "mfa_delete_authenticator_error",
            e,
            t
        ]), _this.name = "MfaDeleteAuthenticatorError";
        return _this;
    }
    return ns;
}($65283fdff51e8344$var$$a), $65283fdff51e8344$var$os = /*#__PURE__*/ function($a) {
    "use strict";
    (0, $4QAx6._)(os, $a);
    function os(e, t) {
        (0, $5Epmf._)(this, os);
        var _this;
        _this = (0, $48Z0s._)(this, os, [
            "mfa_challenge_error",
            e,
            t
        ]), _this.name = "MfaChallengeError";
        return _this;
    }
    return os;
}($65283fdff51e8344$var$$a), $65283fdff51e8344$var$is = /*#__PURE__*/ function($a) {
    "use strict";
    (0, $4QAx6._)(is, $a);
    function is(e, t) {
        (0, $5Epmf._)(this, is);
        var _this;
        _this = (0, $48Z0s._)(this, is, [
            "mfa_verify_error",
            e,
            t
        ]), _this.name = "MfaVerifyError";
        return _this;
    }
    return is;
}($65283fdff51e8344$var$$a);
function $65283fdff51e8344$var$rs(e) {
    return {
        id: e.id,
        authenticatorType: e.authenticator_type,
        active: e.active,
        name: e.name,
        oobChannels: e.oob_channels,
        type: e.type
    };
}
var $65283fdff51e8344$var$as = /*#__PURE__*/ function() {
    "use strict";
    function e(e1, t, n, o, i, r, a) {
        (0, $5Epmf._)(this, e);
        $65283fdff51e8344$var$d(this, "accessToken", void 0), $65283fdff51e8344$var$d(this, "idToken", void 0), $65283fdff51e8344$var$d(this, "refreshToken", void 0), $65283fdff51e8344$var$d(this, "expiresAt", void 0), $65283fdff51e8344$var$d(this, "scope", void 0), $65283fdff51e8344$var$d(this, "claims", void 0), $65283fdff51e8344$var$d(this, "authorizationDetails", void 0), $65283fdff51e8344$var$d(this, "tokenType", void 0), $65283fdff51e8344$var$d(this, "issuedTokenType", void 0), $65283fdff51e8344$var$d(this, "recoveryCode", void 0), $65283fdff51e8344$var$d(this, "act", void 0), this.accessToken = e1, this.idToken = n, this.refreshToken = o, this.expiresAt = t, this.scope = i, this.claims = r, this.authorizationDetails = a;
    }
    (0, $9MqXK._)(e, null, [
        {
            key: "fromTokenEndpointResponse",
            value: function fromTokenEndpointResponse(t) {
                var n = t.id_token ? t.claims() : void 0, o = new e(t.access_token, Math.floor(Date.now() / 1e3) + Number(t.expires_in), t.id_token, t.refresh_token, t.scope, n, t.authorization_details);
                return o.tokenType = t.token_type, o.issuedTokenType = t.issued_token_type, o;
            }
        }
    ]);
    return e;
}(), $65283fdff51e8344$var$ss = {
    otp: "http://auth0.com/oauth/grant-type/mfa-otp",
    oob: "http://auth0.com/oauth/grant-type/mfa-oob",
    "recovery-code": "http://auth0.com/oauth/grant-type/mfa-recovery-code"
}, $65283fdff51e8344$var$cs = ($65283fdff51e8344$var$$r = new WeakMap, $65283fdff51e8344$var$ea = new WeakMap, $65283fdff51e8344$var$ta = new WeakMap, $65283fdff51e8344$var$na = new WeakMap, $65283fdff51e8344$var$oa = new WeakMap, /*#__PURE__*/ function() {
    "use strict";
    function _class(e) {
        (0, $5Epmf._)(this, _class);
        var t;
        $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$$r, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$ea, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$ta, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$na, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$oa, void 0), $65283fdff51e8344$var$l($65283fdff51e8344$var$$r, this, "https://".concat(e.domain)), $65283fdff51e8344$var$l($65283fdff51e8344$var$ea, this, e.clientId), $65283fdff51e8344$var$l($65283fdff51e8344$var$ta, this, e.clientSecret), $65283fdff51e8344$var$l($65283fdff51e8344$var$na, this, null !== (t = e.customFetch) && void 0 !== t ? t : function() {
            return fetch.apply(void 0, arguments);
        }), $65283fdff51e8344$var$l($65283fdff51e8344$var$oa, this, e.getConfiguration);
    }
    (0, $9MqXK._)(_class, [
        {
            key: "listAuthenticators",
            value: function listAuthenticators(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, _$e, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = "".concat($65283fdff51e8344$var$c($65283fdff51e8344$var$$r, this), "/mfa/authenticators"), n = e.mfaToken;
                                return [
                                    4,
                                    $65283fdff51e8344$var$c($65283fdff51e8344$var$na, this).call(this, t, {
                                        method: "GET",
                                        headers: {
                                            Authorization: "Bearer ".concat(n),
                                            "Content-Type": "application/json"
                                        }
                                    })
                                ];
                            case 1:
                                o = _state.sent();
                                if (!!o.ok) return [
                                    3,
                                    6
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    o.json()
                                ];
                            case 3:
                                _$e = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$es("Failed to list authenticators");
                            case 5:
                                throw new $65283fdff51e8344$var$es(_$e.error_description || "Failed to list authenticators", _$e);
                            case 6:
                                return [
                                    4,
                                    o.json()
                                ];
                            case 7:
                                return [
                                    2,
                                    _state.sent().map($65283fdff51e8344$var$rs)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "enrollAuthenticator",
            value: function enrollAuthenticator(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, r, _$e, e1, _;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = "".concat($65283fdff51e8344$var$c($65283fdff51e8344$var$$r, this), "/mfa/associate"), n = e.mfaToken, o = $65283fdff51e8344$var$m(e, $65283fdff51e8344$var$qr), i = {
                                    authenticator_types: o.authenticatorTypes
                                };
                                "oobChannels" in o && (i.oob_channels = o.oobChannels), "phoneNumber" in o && o.phoneNumber && (i.phone_number = o.phoneNumber), "email" in o && o.email && (i.email = o.email);
                                return [
                                    4,
                                    $65283fdff51e8344$var$c($65283fdff51e8344$var$na, this).call(this, t, {
                                        method: "POST",
                                        headers: {
                                            Authorization: "Bearer ".concat(n),
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(i)
                                    })
                                ];
                            case 1:
                                r = _state.sent();
                                if (!!r.ok) return [
                                    3,
                                    6
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    r.json()
                                ];
                            case 3:
                                _$e = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$ts("Failed to enroll authenticator");
                            case 5:
                                throw new $65283fdff51e8344$var$ts(_$e.error_description || "Failed to enroll authenticator", _$e);
                            case 6:
                                _ = function(e) {
                                    if ("otp" === e.authenticator_type) return {
                                        authenticatorType: "otp",
                                        secret: e.secret,
                                        barcodeUri: e.barcode_uri,
                                        recoveryCodes: e.recovery_codes,
                                        id: e.id
                                    };
                                    if ("oob" === e.authenticator_type) return {
                                        authenticatorType: "oob",
                                        oobChannel: e.oob_channel,
                                        oobCode: e.oob_code,
                                        bindingMethod: e.binding_method,
                                        id: e.id,
                                        barcodeUri: e.barcode_uri,
                                        recoveryCodes: e.recovery_codes
                                    };
                                    throw new Error("Unexpected authenticator type: ".concat(e.authenticator_type));
                                };
                                return [
                                    4,
                                    r.json()
                                ];
                            case 7:
                                return [
                                    2,
                                    _.apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "deleteAuthenticator",
            value: function deleteAuthenticator(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, _$e, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = e.authenticatorId, n = e.mfaToken, o = "".concat($65283fdff51e8344$var$c($65283fdff51e8344$var$$r, this), "/mfa/authenticators/").concat(encodeURIComponent(t));
                                return [
                                    4,
                                    $65283fdff51e8344$var$c($65283fdff51e8344$var$na, this).call(this, o, {
                                        method: "DELETE",
                                        headers: {
                                            Authorization: "Bearer ".concat(n),
                                            "Content-Type": "application/json"
                                        }
                                    })
                                ];
                            case 1:
                                i = _state.sent();
                                if (!!i.ok) return [
                                    3,
                                    6
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    i.json()
                                ];
                            case 3:
                                _$e = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$ns("Failed to delete authenticator");
                            case 5:
                                throw new $65283fdff51e8344$var$ns(_$e.error_description || "Failed to delete authenticator", _$e);
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "challengeAuthenticator",
            value: function challengeAuthenticator(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, r, _$e, e1, _;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = "".concat($65283fdff51e8344$var$c($65283fdff51e8344$var$$r, this), "/mfa/challenge"), n = e.mfaToken, o = $65283fdff51e8344$var$m(e, $65283fdff51e8344$var$Qr), i = {
                                    mfa_token: n,
                                    client_id: $65283fdff51e8344$var$c($65283fdff51e8344$var$ea, this),
                                    challenge_type: o.challengeType
                                };
                                $65283fdff51e8344$var$c($65283fdff51e8344$var$ta, this) && (i.client_secret = $65283fdff51e8344$var$c($65283fdff51e8344$var$ta, this)), o.authenticatorId && (i.authenticator_id = o.authenticatorId);
                                return [
                                    4,
                                    $65283fdff51e8344$var$c($65283fdff51e8344$var$na, this).call(this, t, {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(i)
                                    })
                                ];
                            case 1:
                                r = _state.sent();
                                if (!!r.ok) return [
                                    3,
                                    6
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    r.json()
                                ];
                            case 3:
                                _$e = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$os("Failed to challenge authenticator");
                            case 5:
                                throw new $65283fdff51e8344$var$os(_$e.error_description || "Failed to challenge authenticator", _$e);
                            case 6:
                                _ = function(e) {
                                    var t = {
                                        challengeType: e.challenge_type
                                    };
                                    return void 0 !== e.oob_code && (t.oobCode = e.oob_code), void 0 !== e.binding_method && (t.bindingMethod = e.binding_method), t;
                                };
                                return [
                                    4,
                                    r.json()
                                ];
                            case 7:
                                return [
                                    2,
                                    _.apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "verify",
            value: function verify(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, e1, o1, i1, r, t1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!$65283fdff51e8344$var$c($65283fdff51e8344$var$oa, this)) throw new Error("MFA verify requires a configuration provider (getConfiguration was not set)");
                                return [
                                    4,
                                    $65283fdff51e8344$var$c($65283fdff51e8344$var$oa, this).call(this)
                                ];
                            case 1:
                                t = _state.sent(), n = {
                                    mfa_token: e.mfaToken
                                };
                                e.audience && (n.audience = e.audience), "otp" === e.factorType ? n.otp = e.otp : "oob" === e.factorType ? (n.oob_code = e.oobCode, e.bindingCode && (n.binding_code = e.bindingCode)) : "recovery-code" === e.factorType && (n.recovery_code = e.recoveryCode);
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$sr(t, $65283fdff51e8344$var$ss[e.factorType], n)
                                ];
                            case 3:
                                o = _state.sent(), i = $65283fdff51e8344$var$as.fromTokenEndpointResponse(o);
                                return [
                                    2,
                                    (o.recovery_code && (i.recoveryCode = o.recovery_code), i)
                                ];
                            case 4:
                                e1 = _state.sent();
                                if (e1 instanceof $65283fdff51e8344$var$is) throw e1;
                                t1 = e1;
                                throw new $65283fdff51e8344$var$is(t1.error_description || t1.message || "Failed to verify MFA challenge", {
                                    error: null !== (o1 = t1.error) && void 0 !== o1 ? o1 : "mfa_verify_error",
                                    error_description: null !== (i1 = null !== (r = t1.error_description) && void 0 !== r ? r : t1.message) && void 0 !== i1 ? i1 : "Failed to verify MFA challenge"
                                });
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return _class;
}()), $65283fdff51e8344$var$us = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(us, Error1);
    function us(e, t, n) {
        (0, $5Epmf._)(this, us);
        var _this;
        _this = (0, $48Z0s._)(this, us, [
            t
        ]), $65283fdff51e8344$var$d(_this, "cause", void 0), $65283fdff51e8344$var$d(_this, "code", void 0), _this.code = e, _this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message
        };
        return _this;
    }
    return us;
}((0, $kW1tL._)(Error)), $65283fdff51e8344$export$7b8b872d0f02c2dc = /*#__PURE__*/ function(us) {
    "use strict";
    (0, $4QAx6._)(ls, us);
    function ls(e, t) {
        (0, $5Epmf._)(this, ls);
        var _this;
        _this = (0, $48Z0s._)(this, ls, [
            "passkey_register_error",
            e,
            t
        ]), _this.name = "PasskeyRegisterError";
        return _this;
    }
    return ls;
}($65283fdff51e8344$var$us), $65283fdff51e8344$export$4ad9cc2b4fdcd81f = /*#__PURE__*/ function(us) {
    "use strict";
    (0, $4QAx6._)(hs, us);
    function hs(e, t) {
        (0, $5Epmf._)(this, hs);
        var _this;
        _this = (0, $48Z0s._)(this, hs, [
            "passkey_challenge_error",
            e,
            t
        ]), _this.name = "PasskeyChallengeError";
        return _this;
    }
    return hs;
}($65283fdff51e8344$var$us), $65283fdff51e8344$export$96cfb719f753a8fe = /*#__PURE__*/ function(us) {
    "use strict";
    (0, $4QAx6._)(ds, us);
    function ds(e, t) {
        (0, $5Epmf._)(this, ds);
        var _this;
        _this = (0, $48Z0s._)(this, ds, [
            "passkey_get_token_error",
            e,
            t
        ]), _this.name = "PasskeyGetTokenError", _this.cause = t && {
            error: t.error,
            error_description: t.error_description,
            message: t.message,
            mfa_token: t.mfa_token,
            mfa_requirements: t.mfa_requirements
        };
        return _this;
    }
    return ds;
}($65283fdff51e8344$var$us);
var $65283fdff51e8344$var$ps = "urn:okta:params:oauth:grant-type:webauthn", $65283fdff51e8344$var$fs = ($65283fdff51e8344$var$ia = new WeakMap, $65283fdff51e8344$var$ra = new WeakMap, $65283fdff51e8344$var$aa = new WeakMap, $65283fdff51e8344$var$sa = new WeakMap, $65283fdff51e8344$var$ca = new WeakSet, /*#__PURE__*/ function() {
    "use strict";
    function _class(e) {
        (0, $5Epmf._)(this, _class);
        var t;
        $65283fdff51e8344$var$h(this, $65283fdff51e8344$var$ca), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$ia, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$ra, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$aa, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$sa, void 0), $65283fdff51e8344$var$l($65283fdff51e8344$var$ia, this, "https://".concat(e.domain)), $65283fdff51e8344$var$l($65283fdff51e8344$var$ra, this, e.clientId), $65283fdff51e8344$var$l($65283fdff51e8344$var$aa, this, null !== (t = e.customFetch) && void 0 !== t ? t : function() {
            return fetch.apply(void 0, arguments);
        }), $65283fdff51e8344$var$l($65283fdff51e8344$var$sa, this, e.grantRequest);
    }
    (0, $9MqXK._)(_class, [
        {
            key: "register",
            value: function register(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, _$e, a, s;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = "".concat($65283fdff51e8344$var$c($65283fdff51e8344$var$ia, this), "/passkey/register"), n = $65283fdff51e8344$var$f($65283fdff51e8344$var$f($65283fdff51e8344$var$f($65283fdff51e8344$var$f($65283fdff51e8344$var$f($65283fdff51e8344$var$f($65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, e.email && {
                                    email: e.email
                                }), e.name && {
                                    name: e.name
                                }), e.phoneNumber && {
                                    phone_number: e.phoneNumber
                                }), e.username && {
                                    username: e.username
                                }), e.givenName && {
                                    given_name: e.givenName
                                }), e.familyName && {
                                    family_name: e.familyName
                                }), e.nickname && {
                                    nickname: e.nickname
                                }), e.picture && {
                                    picture: e.picture
                                }), o = {
                                    client_id: $65283fdff51e8344$var$c($65283fdff51e8344$var$ra, this),
                                    user_profile: n
                                };
                                e.realm && (o.realm = e.realm), e.organization && (o.organization = e.organization), e.userMetadata && (o.user_metadata = e.userMetadata);
                                return [
                                    4,
                                    $65283fdff51e8344$var$c($65283fdff51e8344$var$aa, this).call(this, t, {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(o)
                                    })
                                ];
                            case 1:
                                i = _state.sent();
                                if (!!i.ok) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$ca, this, $65283fdff51e8344$var$ms).call(this, i)
                                ];
                            case 2:
                                _$e = _state.sent();
                                throw new $65283fdff51e8344$export$7b8b872d0f02c2dc(_$e.error_description || "Failed to request signup challenge", _$e);
                            case 3:
                                return [
                                    4,
                                    i.json()
                                ];
                            case 4:
                                a = _state.sent();
                                return [
                                    2,
                                    {
                                        authSession: (s = a).auth_session,
                                        authnParamsPublicKey: $65283fdff51e8344$var$f({}, s.authn_params_public_key)
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "challenge",
            value: function challenge(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, _$e, i, a;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = "".concat($65283fdff51e8344$var$c($65283fdff51e8344$var$ia, this), "/passkey/challenge"), n = {
                                    client_id: $65283fdff51e8344$var$c($65283fdff51e8344$var$ra, this)
                                };
                                null != e && e.realm && (n.realm = e.realm), null != e && e.organization && (n.organization = e.organization);
                                return [
                                    4,
                                    $65283fdff51e8344$var$c($65283fdff51e8344$var$aa, this).call(this, t, {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify(n)
                                    })
                                ];
                            case 1:
                                o = _state.sent();
                                if (!!o.ok) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$ca, this, $65283fdff51e8344$var$ms).call(this, o)
                                ];
                            case 2:
                                _$e = _state.sent();
                                throw new $65283fdff51e8344$export$4ad9cc2b4fdcd81f(_$e.error_description || "Failed to request login challenge", _$e);
                            case 3:
                                return [
                                    4,
                                    o.json()
                                ];
                            case 4:
                                i = _state.sent();
                                return [
                                    2,
                                    {
                                        authSession: (a = i).auth_session,
                                        authnParamsPublicKey: $65283fdff51e8344$var$f({}, a.authn_params_public_key)
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getTokenByPasskey",
            value: function getTokenByPasskey(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, e1, t1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                void 0 !== e.organization && $65283fdff51e8344$var$qa(e.organization);
                                t = new URLSearchParams({
                                    auth_session: e.authSession,
                                    authn_response: JSON.stringify(e.credential)
                                });
                                e.realm && t.append("realm", e.realm), e.scope && t.append("scope", e.scope), e.audience && t.append("audience", e.audience), e.organization && t.append("organization", e.organization);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$c($65283fdff51e8344$var$sa, this).call(this, $65283fdff51e8344$var$ps, t)
                                ];
                            case 2:
                                n = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e1 = _state.sent();
                                t1 = $65283fdff51e8344$var$Wa(e1);
                                throw new $65283fdff51e8344$export$96cfb719f753a8fe(t1.error_description || "Failed to exchange passkey credential for tokens.", t1);
                            case 4:
                                return [
                                    2,
                                    (e.organization && $65283fdff51e8344$var$Qa(n.claims, e.organization), n)
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return _class;
}());
function $65283fdff51e8344$var$ms(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var t;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        e.json()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    t = _state.sent();
                    return [
                        2,
                        {
                            error: "unknown_error",
                            error_description: "HTTP ".concat(e.status, " ").concat(e.statusText)
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
var $65283fdff51e8344$var$ys = /*#__PURE__*/ function _target(Error1) {
    "use strict";
    (0, $4QAx6._)(ys, Error1);
    function ys(e, t, n) {
        (0, $5Epmf._)(this, ys);
        var _this;
        _this = (0, $48Z0s._)(this, ys, [
            t
        ]), $65283fdff51e8344$var$d(_this, "cause", void 0), $65283fdff51e8344$var$d(_this, "code", void 0), Object.setPrototypeOf(_this, (this instanceof ys ? this.constructor : void 0).prototype), _this.code = e, _this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message,
            mfa_token: n.mfa_token,
            mfa_requirements: n.mfa_requirements
        };
        return _this;
    }
    return ys;
}((0, $kW1tL._)(Error)), $65283fdff51e8344$var$ws = /*#__PURE__*/ function(ys) {
    "use strict";
    (0, $4QAx6._)(ws, ys);
    function ws(e, t) {
        (0, $5Epmf._)(this, ws);
        var _this;
        _this = (0, $48Z0s._)(this, ws, [
            "passwordless_start_error",
            e,
            t
        ]), _this.name = "PasswordlessStartError";
        return _this;
    }
    return ws;
}($65283fdff51e8344$var$ys), $65283fdff51e8344$var$gs = /*#__PURE__*/ function(ys) {
    "use strict";
    (0, $4QAx6._)(gs, ys);
    function gs(e, t) {
        (0, $5Epmf._)(this, gs);
        var _this;
        _this = (0, $48Z0s._)(this, gs, [
            "passwordless_verify_error",
            e,
            t
        ]), _this.name = "PasswordlessVerifyError";
        return _this;
    }
    return gs;
}($65283fdff51e8344$var$ys), $65283fdff51e8344$var$vs = /*#__PURE__*/ function(ys) {
    "use strict";
    (0, $4QAx6._)(vs, ys);
    function vs(e, t) {
        (0, $5Epmf._)(this, vs);
        var _this;
        _this = (0, $48Z0s._)(this, vs, [
            "passwordless_db_get_token_error",
            e,
            t
        ]), _this.name = "PasswordlessDbGetTokenError";
        return _this;
    }
    return vs;
}($65283fdff51e8344$var$ys), $65283fdff51e8344$var$bs = /*#__PURE__*/ function(ys) {
    "use strict";
    (0, $4QAx6._)(bs, ys);
    function bs(e, t, n, o) {
        (0, $5Epmf._)(this, bs);
        var _this;
        _this = (0, $48Z0s._)(this, bs, [
            "passwordless_challenge_error",
            e,
            n
        ]), $65283fdff51e8344$var$d(_this, "statusCode", void 0), $65283fdff51e8344$var$d(_this, "validationErrors", void 0), _this.name = "PasswordlessChallengeError", _this.statusCode = t, _this.validationErrors = o;
        return _this;
    }
    return bs;
}($65283fdff51e8344$var$ys);
function $65283fdff51e8344$var$ks(e) {
    return /^\+[1-9]\d{1,14}$/.test(e);
}
function $65283fdff51e8344$var$_s(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var o, i, r, _tmp, _tmp1;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (e.useMtls) return [
                        2,
                        {}
                    ];
                    if (!e.clientAssertionSigningKey) return [
                        3,
                        5
                    ];
                    i = null !== (o = e.clientAssertionSigningAlg) && void 0 !== o ? o : "RS256";
                    if (!(e.clientAssertionSigningKey instanceof CryptoKey)) return [
                        3,
                        1
                    ];
                    _tmp = e.clientAssertionSigningKey;
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        $65283fdff51e8344$var$ki(e.clientAssertionSigningKey, i)
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    r = _tmp;
                    _tmp1 = {};
                    return [
                        4,
                        new $65283fdff51e8344$var$Ir({}).setProtectedHeader({
                            alg: i
                        }).setIssuer(t).setSubject(t).setAudience("https://".concat(n, "/")).setJti(crypto.randomUUID()).setIssuedAt().setExpirationTime("".concat(120, "s")).sign(r)
                    ];
                case 4:
                    return [
                        2,
                        (_tmp1.client_assertion = _state.sent(), _tmp1.client_assertion_type = "urn:ietf:params:oauth:client-assertion-type:jwt-bearer", _tmp1)
                    ];
                case 5:
                    if (e.clientSecret) return [
                        2,
                        {
                            client_secret: e.clientSecret
                        }
                    ];
                    throw new $65283fdff51e8344$var$Ga;
            }
        });
    })();
}
var $65283fdff51e8344$var$Ss = ($65283fdff51e8344$var$ua = new WeakMap, $65283fdff51e8344$var$la = new WeakMap, $65283fdff51e8344$var$ha = new WeakMap, $65283fdff51e8344$var$da = new WeakMap, $65283fdff51e8344$var$pa = new WeakMap, $65283fdff51e8344$var$fa = new WeakMap, $65283fdff51e8344$var$ma = new WeakSet, /*#__PURE__*/ function() {
    "use strict";
    function _class(e) {
        (0, $5Epmf._)(this, _class);
        var t;
        $65283fdff51e8344$var$h(this, $65283fdff51e8344$var$ma), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$ua, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$la, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$ha, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$da, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$pa, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$fa, void 0), $65283fdff51e8344$var$l($65283fdff51e8344$var$la, this, e.domain), $65283fdff51e8344$var$l($65283fdff51e8344$var$ua, this, "https://".concat(e.domain)), $65283fdff51e8344$var$l($65283fdff51e8344$var$ha, this, e.clientId), $65283fdff51e8344$var$l($65283fdff51e8344$var$da, this, null !== (t = e.customFetch) && void 0 !== t ? t : function() {
            return fetch.apply(void 0, arguments);
        }), $65283fdff51e8344$var$l($65283fdff51e8344$var$pa, this, {
            clientSecret: e.clientSecret,
            clientAssertionSigningKey: e.clientAssertionSigningKey,
            clientAssertionSigningAlg: e.clientAssertionSigningAlg,
            useMtls: e.useMtls
        }), $65283fdff51e8344$var$l($65283fdff51e8344$var$fa, this, e.grantRequest);
    }
    (0, $9MqXK._)(_class, [
        {
            key: "sendEmail",
            value: function sendEmail(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$ma, this, $65283fdff51e8344$var$Ts).call(this, function(e) {
                                        var t;
                                        var n = null !== (t = e.send) && void 0 !== t ? t : "code", o = {
                                            email: e.email,
                                            connection: "email",
                                            send: n
                                        };
                                        return "link" === n && e.authParams && (o.authParams = e.authParams), o;
                                    }(e), "Failed to send passwordless email", e.language)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "sendSms",
            value: function sendSms(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!$65283fdff51e8344$var$ks(e.phoneNumber)) throw new $65283fdff51e8344$var$ws("Phone number must be in E.164 format (e.g. +14155550100).");
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$ma, this, $65283fdff51e8344$var$Ts).call(this, function(e) {
                                        return {
                                            phone_number: e.phoneNumber,
                                            connection: "sms"
                                        };
                                    }(e), "Failed to send passwordless SMS", e.language)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "challengeWithEmail",
            value: function challengeWithEmail(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t;
                    return (0, $3SMYb._)(this, function(_state) {
                        t = function(e) {
                            var t;
                            return {
                                email: e.email,
                                connection: e.connection,
                                allow_signup: null !== (t = e.allowSignup) && void 0 !== t && t
                            };
                        }(e);
                        return [
                            2,
                            $65283fdff51e8344$var$r($65283fdff51e8344$var$ma, this, $65283fdff51e8344$var$Ps).call(this, t, "Failed to request email OTP challenge")
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "challengeWithPhoneNumber",
            value: function challengeWithPhoneNumber(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t;
                    return (0, $3SMYb._)(this, function(_state) {
                        if (!$65283fdff51e8344$var$ks(e.phoneNumber)) throw new $65283fdff51e8344$var$bs("Phone number must be in E.164 format (e.g. +14155550100).", 0, void 0, void 0);
                        t = function(e) {
                            var t;
                            var n = {
                                phone_number: e.phoneNumber,
                                connection: e.connection,
                                allow_signup: null !== (t = e.allowSignup) && void 0 !== t && t
                            };
                            return e.deliveryMethod && (n.delivery_method = e.deliveryMethod), n;
                        }(e);
                        return [
                            2,
                            $65283fdff51e8344$var$r($65283fdff51e8344$var$ma, this, $65283fdff51e8344$var$Ps).call(this, t, "Failed to request phone OTP challenge")
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getTokenByPasswordlessDbConnection",
            value: function getTokenByPasswordlessDbConnection(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = new URLSearchParams({
                                    auth_session: e.authSession,
                                    otp: e.otp
                                });
                                if (e.scope && t.append("scope", e.scope), e.audience && t.append("audience", e.audience), !$65283fdff51e8344$var$c($65283fdff51e8344$var$fa, this)) throw new $65283fdff51e8344$var$vs("Missing grant request delegate.", $65283fdff51e8344$var$Wa(new Error("missing grantRequest")));
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$c($65283fdff51e8344$var$fa, this).call(this, "http://auth0.com/oauth/grant-type/passwordless/otp", t)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$vs("There was an error while trying to request a token.", $65283fdff51e8344$var$Wa(e1));
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return _class;
}());
function $65283fdff51e8344$var$Ts(e, t, n) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var o, i, r, a, s, e1, e2;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65283fdff51e8344$var$_s($65283fdff51e8344$var$c($65283fdff51e8344$var$pa, this), $65283fdff51e8344$var$c($65283fdff51e8344$var$ha, this), $65283fdff51e8344$var$c($65283fdff51e8344$var$la, this))
                    ];
                case 1:
                    i = _state.sent(), r = $65283fdff51e8344$var$f($65283fdff51e8344$var$f({
                        client_id: $65283fdff51e8344$var$c($65283fdff51e8344$var$ha, this)
                    }, e), i);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $65283fdff51e8344$var$c($65283fdff51e8344$var$da, this).call(this, "".concat($65283fdff51e8344$var$c($65283fdff51e8344$var$ua, this), "/passwordless/start"), {
                            method: "POST",
                            headers: $65283fdff51e8344$var$f({
                                "Content-Type": "application/json"
                            }, n ? {
                                "x-request-language": n
                            } : {}),
                            body: JSON.stringify(r)
                        })
                    ];
                case 3:
                    a = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e1 = _state.sent();
                    throw new $65283fdff51e8344$var$ws("".concat(t, ": a network error occurred."));
                case 5:
                    if (!!a.ok) return [
                        3,
                        10
                    ];
                    if (!(204 !== a.status)) return [
                        3,
                        9
                    ];
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        a.json()
                    ];
                case 7:
                    s = _state.sent();
                    return [
                        3,
                        9
                    ];
                case 8:
                    e2 = _state.sent();
                    s = void 0;
                    return [
                        3,
                        9
                    ];
                case 9:
                    throw new $65283fdff51e8344$var$ws((null === (o = s) || void 0 === o ? void 0 : o.error_description) || t, s);
                case 10:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $65283fdff51e8344$var$Ps(e, t) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var n, o, i, r, a, s, e1, _$e, e2, e3;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65283fdff51e8344$var$_s($65283fdff51e8344$var$c($65283fdff51e8344$var$pa, this), $65283fdff51e8344$var$c($65283fdff51e8344$var$ha, this), $65283fdff51e8344$var$c($65283fdff51e8344$var$la, this))
                    ];
                case 1:
                    i = _state.sent(), r = $65283fdff51e8344$var$f($65283fdff51e8344$var$f({
                        client_id: $65283fdff51e8344$var$c($65283fdff51e8344$var$ha, this)
                    }, e), i);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $65283fdff51e8344$var$c($65283fdff51e8344$var$da, this).call(this, "".concat($65283fdff51e8344$var$c($65283fdff51e8344$var$ua, this), "/otp/challenge"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(r)
                        })
                    ];
                case 3:
                    a = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e1 = _state.sent();
                    throw new $65283fdff51e8344$var$bs("challenge error: a network error occurred.", 0, void 0, void 0);
                case 5:
                    if (!a.ok) return [
                        3,
                        10
                    ];
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        a.json()
                    ];
                case 7:
                    _$e = _state.sent();
                    return [
                        3,
                        9
                    ];
                case 8:
                    e2 = _state.sent();
                    throw new $65283fdff51e8344$var$bs("".concat(t, ": could not parse the response body."), a.status, void 0, void 0);
                case 9:
                    return [
                        2,
                        {
                            authSession: _$e.auth_session
                        }
                    ];
                case 10:
                    _state.trys.push([
                        10,
                        12,
                        ,
                        13
                    ]);
                    return [
                        4,
                        a.json()
                    ];
                case 11:
                    s = _state.sent();
                    return [
                        3,
                        13
                    ];
                case 12:
                    e3 = _state.sent();
                    s = void 0;
                    return [
                        3,
                        13
                    ];
                case 13:
                    throw new $65283fdff51e8344$var$bs((null === (n = s) || void 0 === n ? void 0 : n.error_description) || t, a.status, s, null === (o = s) || void 0 === o ? void 0 : o.validation_errors);
            }
        });
    }).call(this);
}
var $65283fdff51e8344$var$Es = /*#__PURE__*/ function _target(Error1) {
    "use strict";
    (0, $4QAx6._)(Es, Error1);
    function Es(e, t, n) {
        (0, $5Epmf._)(this, Es);
        var _this;
        _this = (0, $48Z0s._)(this, Es, [
            t
        ]), $65283fdff51e8344$var$d(_this, "cause", void 0), $65283fdff51e8344$var$d(_this, "code", void 0), Object.setPrototypeOf(_this, (this instanceof Es ? this.constructor : void 0).prototype), _this.code = e, _this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message
        };
        return _this;
    }
    return Es;
}((0, $kW1tL._)(Error)), $65283fdff51e8344$var$As = /*#__PURE__*/ function(Es) {
    "use strict";
    (0, $4QAx6._)(As, Es);
    function As(e, t) {
        (0, $5Epmf._)(this, As);
        var _this;
        _this = (0, $48Z0s._)(this, As, [
            "signup_error",
            e,
            t
        ]), _this.name = "SignUpError";
        return _this;
    }
    return As;
}($65283fdff51e8344$var$Es), $65283fdff51e8344$var$Is = /*#__PURE__*/ function(Es) {
    "use strict";
    (0, $4QAx6._)(Is, Es);
    function Is(e, t) {
        (0, $5Epmf._)(this, Is);
        var _this;
        _this = (0, $48Z0s._)(this, Is, [
            "change_password_error",
            e,
            t
        ]), _this.name = "ChangePasswordError";
        return _this;
    }
    return Is;
}($65283fdff51e8344$var$Es);
function $65283fdff51e8344$var$xs(e, t, n) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var o = _step.value;
            if (null === e[o] || void 0 === e[o] || "" === e[o]) throw new n('Required parameter "'.concat(String(o), '" was null, undefined, or empty.'));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var $65283fdff51e8344$var$Rs = ($65283fdff51e8344$var$ya = new WeakMap, $65283fdff51e8344$var$wa = new WeakMap, $65283fdff51e8344$var$ga = new WeakMap, $65283fdff51e8344$var$va = new WeakSet, /*#__PURE__*/ function() {
    "use strict";
    function _class(e) {
        (0, $5Epmf._)(this, _class);
        var t;
        $65283fdff51e8344$var$h(this, $65283fdff51e8344$var$va), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$ya, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$wa, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$ga, void 0), $65283fdff51e8344$var$l($65283fdff51e8344$var$ya, this, "https://".concat(e.domain)), $65283fdff51e8344$var$l($65283fdff51e8344$var$wa, this, e.clientId), $65283fdff51e8344$var$l($65283fdff51e8344$var$ga, this, null !== (t = e.customFetch) && void 0 !== t ? t : function() {
            return fetch.apply(void 0, arguments);
        });
    }
    (0, $9MqXK._)(_class, [
        {
            key: "signUp",
            value: function signUp(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, _;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $65283fdff51e8344$var$xs(e, [
                                    "email",
                                    "password",
                                    "connection"
                                ], $65283fdff51e8344$var$As);
                                n = $65283fdff51e8344$var$f({
                                    client_id: null !== (t = e.clientId) && void 0 !== t ? t : $65283fdff51e8344$var$c($65283fdff51e8344$var$wa, this)
                                }, function(e) {
                                    var t = {
                                        email: e.email,
                                        password: e.password,
                                        connection: e.connection
                                    };
                                    return void 0 !== e.username && (t.username = e.username), void 0 !== e.givenName && (t.given_name = e.givenName), void 0 !== e.familyName && (t.family_name = e.familyName), void 0 !== e.name && (t.name = e.name), void 0 !== e.nickname && (t.nickname = e.nickname), void 0 !== e.picture && (t.picture = e.picture), void 0 !== e.userMetadata && (t.user_metadata = e.userMetadata), t;
                                }(e));
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$va, this, $65283fdff51e8344$var$Os).call(this, "/dbconnections/signup", n, $65283fdff51e8344$var$As, "Failed to sign up")
                                ];
                            case 1:
                                o = _state.sent();
                                _ = function(e) {
                                    var t, n;
                                    return {
                                        id: null !== (t = null !== (n = e._id) && void 0 !== n ? n : e.user_id) && void 0 !== t ? t : e.id,
                                        email: "string" == typeof e.email ? e.email : "",
                                        emailVerified: Boolean(e.email_verified),
                                        username: e.username,
                                        givenName: e.given_name,
                                        familyName: e.family_name,
                                        name: e.name,
                                        nickname: e.nickname,
                                        picture: e.picture,
                                        userMetadata: e.user_metadata
                                    };
                                };
                                return [
                                    4,
                                    o.json()
                                ];
                            case 2:
                                return [
                                    2,
                                    _.apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "changePassword",
            value: function changePassword(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if ($65283fdff51e8344$var$xs(e, [
                                    "connection"
                                ], $65283fdff51e8344$var$Is), !e.email && !e.username) throw new $65283fdff51e8344$var$Is('Either "email" or "username" is required.');
                                n = $65283fdff51e8344$var$f({
                                    client_id: null !== (t = e.clientId) && void 0 !== t ? t : $65283fdff51e8344$var$c($65283fdff51e8344$var$wa, this)
                                }, function(e) {
                                    var t = {
                                        connection: e.connection
                                    };
                                    return void 0 !== e.email && (t.email = e.email), void 0 !== e.username && (t.username = e.username), void 0 !== e.organization && (t.organization = e.organization), t;
                                }(e));
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$va, this, $65283fdff51e8344$var$Os).call(this, "/dbconnections/change_password", n, $65283fdff51e8344$var$Is, "Failed to request a password change")
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().text()
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return _class;
}());
function $65283fdff51e8344$var$Os(e, t, n, o) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var i, e1, r;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $65283fdff51e8344$var$c($65283fdff51e8344$var$ga, this).call(this, "".concat($65283fdff51e8344$var$c($65283fdff51e8344$var$ya, this)).concat(e), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(t)
                        })
                    ];
                case 1:
                    i = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e1 = _state.sent();
                    throw new n("".concat(o, ": a network error occurred."));
                case 3:
                    if (i.ok) return [
                        2,
                        i
                    ];
                    return [
                        4,
                        function(e) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                var _$t, e1;
                                return (0, $3SMYb._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                e.json()
                                            ];
                                        case 1:
                                            _$t = _state.sent();
                                            return [
                                                3,
                                                3
                                            ];
                                        case 2:
                                            e1 = _state.sent();
                                            return [
                                                2
                                            ];
                                        case 3:
                                            return [
                                                2,
                                                "string" == typeof _$t.error ? _$t : "string" == typeof _$t.code ? {
                                                    error: _$t.code,
                                                    error_description: "string" == typeof _$t.description ? _$t.description : ""
                                                } : void 0
                                            ];
                                    }
                                });
                            })();
                        }(i)
                    ];
                case 4:
                    r = _state.sent();
                    throw new n((null == r ? void 0 : r.error_description) || o, r);
            }
        });
    }).call(this);
}
var $65283fdff51e8344$var$Cs = ($65283fdff51e8344$var$ba = new WeakMap, $65283fdff51e8344$var$ka = new WeakMap, $65283fdff51e8344$var$_a = new WeakMap, /*#__PURE__*/ function() {
    "use strict";
    function _class(e, t) {
        (0, $5Epmf._)(this, _class);
        $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$ba, new Map), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$ka, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$_a, void 0), $65283fdff51e8344$var$l($65283fdff51e8344$var$_a, this, Math.max(1, Math.floor(e))), $65283fdff51e8344$var$l($65283fdff51e8344$var$ka, this, Math.max(0, Math.floor(t)));
    }
    (0, $9MqXK._)(_class, [
        {
            key: "get",
            value: function get(e) {
                var t = $65283fdff51e8344$var$c($65283fdff51e8344$var$ba, this).get(e);
                if (t) {
                    if (!(Date.now() >= t.expiresAt)) return $65283fdff51e8344$var$c($65283fdff51e8344$var$ba, this).delete(e), $65283fdff51e8344$var$c($65283fdff51e8344$var$ba, this).set(e, t), t.value;
                    $65283fdff51e8344$var$c($65283fdff51e8344$var$ba, this).delete(e);
                }
            }
        },
        {
            key: "set",
            value: function set(e, t) {
                for($65283fdff51e8344$var$c($65283fdff51e8344$var$ba, this).has(e) && $65283fdff51e8344$var$c($65283fdff51e8344$var$ba, this).delete(e), $65283fdff51e8344$var$c($65283fdff51e8344$var$ba, this).set(e, {
                    value: t,
                    expiresAt: Date.now() + $65283fdff51e8344$var$c($65283fdff51e8344$var$ka, this)
                }); $65283fdff51e8344$var$c($65283fdff51e8344$var$ba, this).size > $65283fdff51e8344$var$c($65283fdff51e8344$var$_a, this);){
                    var _$e = $65283fdff51e8344$var$c($65283fdff51e8344$var$ba, this).keys().next().value;
                    if (void 0 === _$e) break;
                    $65283fdff51e8344$var$c($65283fdff51e8344$var$ba, this).delete(_$e);
                }
            }
        }
    ]);
    return _class;
}()), $65283fdff51e8344$var$Ws = new Map;
function $65283fdff51e8344$var$js(e) {
    return {
        ttlMs: 1e3 * ("number" == typeof (null == e ? void 0 : e.ttl) ? e.ttl : 600),
        maxEntries: "number" == typeof (null == e ? void 0 : e.maxEntries) && e.maxEntries > 0 ? e.maxEntries : 100
    };
}
var $65283fdff51e8344$var$Ks = /*#__PURE__*/ function() {
    "use strict";
    function Ks() {
        (0, $5Epmf._)(this, Ks);
    }
    (0, $9MqXK._)(Ks, null, [
        {
            key: "createDiscoveryCache",
            value: function createDiscoveryCache(e) {
                var t = (n = e.maxEntries, o = e.ttlMs, "".concat(n, ":").concat(o));
                var n, o;
                var i = (r = t, $65283fdff51e8344$var$Ws.get(r));
                var r;
                return i || (i = new $65283fdff51e8344$var$Cs(e.maxEntries, e.ttlMs), $65283fdff51e8344$var$Ws.set(t, i)), i;
            }
        },
        {
            key: "createJwksCache",
            value: function createJwksCache() {
                return {};
            }
        }
    ]);
    return Ks;
}(), $65283fdff51e8344$var$Us = "openid profile email offline_access", $65283fdff51e8344$var$Ns = Object.freeze(new Set([
    "grant_type",
    "client_id",
    "client_secret",
    "client_assertion",
    "client_assertion_type",
    "subject_token",
    "subject_token_type",
    "requested_token_type",
    "actor_token",
    "actor_token_type",
    "audience",
    "aud",
    "resource",
    "resources",
    "resource_indicator",
    "scope",
    "connection",
    "login_hint",
    "organization",
    "assertion"
]));
function $65283fdff51e8344$var$Ls(e) {
    if (null == e) throw new $65283fdff51e8344$var$Da("subject_token is required");
    if ("string" != typeof e) throw new $65283fdff51e8344$var$Da("subject_token must be a string");
    if (0 === e.trim().length) throw new $65283fdff51e8344$var$Da("subject_token cannot be blank or whitespace");
    if (e !== e.trim()) throw new $65283fdff51e8344$var$Da("subject_token must not include leading or trailing whitespace");
    if (/^bearer\s+/i.test(e)) throw new $65283fdff51e8344$var$Da("subject_token must not include the 'Bearer ' prefix");
}
function $65283fdff51e8344$var$Ms(e, t) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (t) try {
        var _loop = function() {
            var o = _step.value;
            var n = $65283fdff51e8344$var$y(o, 2);
            var _$t = n[0], i = n[1];
            if (!$65283fdff51e8344$var$Ns.has(_$t)) {
                if (Array.isArray(i)) {
                    if (i.length > 20) throw new $65283fdff51e8344$var$Da("Parameter '".concat(_$t, "' exceeds maximum array size of ").concat(20));
                    i.forEach(function(n) {
                        e.append(_$t, n);
                    });
                } else e.append(_$t, i);
            }
        };
        for(var _iterator = Object.entries(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var $65283fdff51e8344$var$zs = "urn:ietf:params:oauth:token-type:access_token";
var $65283fdff51e8344$var$Ds = ($65283fdff51e8344$var$Sa = new WeakMap, $65283fdff51e8344$var$Ta = new WeakMap, $65283fdff51e8344$var$Pa = new WeakMap, $65283fdff51e8344$var$Ea = new WeakMap, $65283fdff51e8344$var$Aa = new WeakMap, $65283fdff51e8344$var$Ia = new WeakMap, $65283fdff51e8344$var$xa = new WeakMap, $65283fdff51e8344$var$Ra = new WeakMap, $65283fdff51e8344$var$Oa = new WeakMap, $65283fdff51e8344$var$Ca = new WeakSet, /*#__PURE__*/ function() {
    "use strict";
    function _class(e) {
        var _this = this;
        (0, $5Epmf._)(this, _class);
        var t, n, o, i;
        if ($65283fdff51e8344$var$h(this, $65283fdff51e8344$var$Ca), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Sa, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Ta, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Pa, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Ea, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Aa, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Ia, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$xa, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Ra, void 0), $65283fdff51e8344$var$u(this, $65283fdff51e8344$var$Oa, void 0), $65283fdff51e8344$var$d(this, "mfa", void 0), $65283fdff51e8344$var$d(this, "passkey", void 0), $65283fdff51e8344$var$d(this, "passwordless", void 0), $65283fdff51e8344$var$d(this, "database", void 0), $65283fdff51e8344$var$l($65283fdff51e8344$var$Ea, this, e), e.useMtls && !e.customFetch) throw new $65283fdff51e8344$var$ja("mtls_without_custom_fetch_not_supported", "Using mTLS without a custom fetch implementation is not supported");
        $65283fdff51e8344$var$l($65283fdff51e8344$var$Aa, this, function(e, t) {
            if (!1 === t.enabled) return e;
            var n = {
                name: t.name,
                version: t.version
            }, o = btoa(JSON.stringify(n));
            return function(t, n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var i;
                    return (0, $3SMYb._)(this, function(_state) {
                        i = t instanceof Request ? new Headers(t.headers) : new Headers;
                        return [
                            2,
                            (null != n && n.headers && new Headers(n.headers).forEach(function(e, t) {
                                i.set(t, e);
                            }), i.set("Auth0-Client", o), e(t, $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, n), {}, {
                                headers: i
                            })))
                        ];
                    });
                })();
            };
        }(null !== (t = e.customFetch) && void 0 !== t ? t : function() {
            return fetch.apply(void 0, arguments);
        }, !1 === (null == (n = e.telemetry) ? void 0 : n.enabled) ? n : {
            enabled: !0,
            name: null !== (o = null == n ? void 0 : n.name) && void 0 !== o ? o : "@auth0/auth0-auth-js",
            version: null !== (i = null == n ? void 0 : n.version) && void 0 !== i ? i : "1.12.0"
        }));
        var a = $65283fdff51e8344$var$js(e.discoveryCache);
        $65283fdff51e8344$var$l($65283fdff51e8344$var$xa, this, $65283fdff51e8344$var$Ks.createDiscoveryCache(a)), $65283fdff51e8344$var$l($65283fdff51e8344$var$Ra, this, new Map), $65283fdff51e8344$var$l($65283fdff51e8344$var$Oa, this, $65283fdff51e8344$var$Ks.createJwksCache()), this.mfa = new $65283fdff51e8344$var$cs({
            domain: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).domain,
            clientId: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientId,
            clientSecret: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientSecret,
            customFetch: $65283fdff51e8344$var$c($65283fdff51e8344$var$Aa, this),
            getConfiguration: function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().configuration
                                ];
                        }
                    });
                }).call(_this);
            }
        }), this.passkey = new $65283fdff51e8344$var$fs({
            domain: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).domain,
            clientId: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientId,
            customFetch: $65283fdff51e8344$var$c($65283fdff51e8344$var$Aa, this),
            grantRequest: function(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, i;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                n = _state.sent().serverMetadata;
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Hs).call(this, n)
                                ];
                            case 2:
                                o = _state.sent();
                                o[$65283fdff51e8344$var$ji] = function(e, t) {
                                    return function(n, o) {
                                        var i = null == o ? void 0 : o.body;
                                        if (t !== $65283fdff51e8344$var$ps || !(i instanceof URLSearchParams)) return e(n, o);
                                        var _$r = {};
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var _$e = _step.value;
                                                var a = $65283fdff51e8344$var$y(_$e, 2);
                                                var _$t = a[0], _$n = a[1];
                                                _$r[_$t] = "authn_response" === _$t ? JSON.parse(_$n) : _$n;
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        var s = new Headers(null == o ? void 0 : o.headers);
                                        return s.set("Content-Type", "application/json"), e(n, $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, o), {}, {
                                            headers: s,
                                            body: JSON.stringify(_$r)
                                        }));
                                    };
                                }($65283fdff51e8344$var$c($65283fdff51e8344$var$Aa, this), e);
                                return [
                                    4,
                                    $65283fdff51e8344$var$sr(o, e, t)
                                ];
                            case 3:
                                i = _state.sent();
                                return [
                                    2,
                                    $65283fdff51e8344$var$as.fromTokenEndpointResponse(i)
                                ];
                        }
                    });
                }).call(_this);
            }
        }), this.passwordless = new $65283fdff51e8344$var$Ss({
            domain: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).domain,
            clientId: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientId,
            customFetch: $65283fdff51e8344$var$c($65283fdff51e8344$var$Aa, this),
            clientSecret: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientSecret,
            clientAssertionSigningKey: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientAssertionSigningKey,
            clientAssertionSigningAlg: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientAssertionSigningAlg,
            useMtls: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).useMtls,
            grantRequest: function(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                n = _state.sent().configuration;
                                return [
                                    4,
                                    $65283fdff51e8344$var$sr(n, e, t)
                                ];
                            case 2:
                                o = _state.sent();
                                return [
                                    2,
                                    $65283fdff51e8344$var$as.fromTokenEndpointResponse(o)
                                ];
                        }
                    });
                }).call(_this);
            }
        }), this.database = new $65283fdff51e8344$var$Rs({
            domain: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).domain,
            clientId: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientId,
            customFetch: $65283fdff51e8344$var$c($65283fdff51e8344$var$Aa, this)
        });
    }
    (0, $9MqXK._)(_class, [
        {
            key: "getServerMetadata",
            value: function getServerMetadata() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().serverMetadata
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "buildAuthorizationUrl",
            value: function buildAuthorizationUrl(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                t = _state.sent().serverMetadata;
                                if (null != e && e.pushedAuthorizationRequests && !t.pushed_authorization_request_endpoint) throw new $65283fdff51e8344$var$ja("par_not_supported_error", "The Auth0 tenant does not have pushed authorization requests enabled. Learn how to enable it here: https://auth0.com/docs/get-started/applications/configure-par");
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Ys).call(this, e)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$Fa(e1);
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "buildLinkUserUrl",
            value: function buildLinkUserUrl(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Ys).call(this, {
                                        authorizationParams: $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, e.authorizationParams), {}, {
                                            requested_connection: e.connection,
                                            requested_connection_scope: e.connectionScope,
                                            scope: "openid link_account offline_access",
                                            id_token_hint: e.idToken
                                        })
                                    })
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    2,
                                    {
                                        linkUserUrl: t.authorizationUrl,
                                        codeVerifier: t.codeVerifier
                                    }
                                ];
                            case 2:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$Va(e1);
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "buildUnlinkUserUrl",
            value: function buildUnlinkUserUrl(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Ys).call(this, {
                                        authorizationParams: $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, e.authorizationParams), {}, {
                                            requested_connection: e.connection,
                                            scope: "openid unlink_account",
                                            id_token_hint: e.idToken
                                        })
                                    })
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    2,
                                    {
                                        unlinkUserUrl: t.authorizationUrl,
                                        codeVerifier: t.codeVerifier
                                    }
                                ];
                            case 2:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$Xa(e1);
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "backchannelAuthentication",
            value: function backchannelAuthentication(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, a, _$e, t1, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                t = _state.sent(), n = t.configuration, o = t.serverMetadata, i = $65283fdff51e8344$var$Ba($65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).authorizationParams), null == e ? void 0 : e.authorizationParams)), a = new URLSearchParams($65283fdff51e8344$var$f($65283fdff51e8344$var$f({
                                    scope: $65283fdff51e8344$var$Us
                                }, i), {}, {
                                    client_id: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientId,
                                    binding_message: e.bindingMessage,
                                    login_hint: JSON.stringify({
                                        format: "iss_sub",
                                        iss: o.issuer,
                                        sub: e.loginHint.sub
                                    })
                                }));
                                e.requestedExpiry && a.append("requested_expiry", e.requestedExpiry.toString()), e.authorizationDetails && a.append("authorization_details", JSON.stringify(e.authorizationDetails));
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$Yi(n, a)
                                ];
                            case 3:
                                _$e = _state.sent();
                                return [
                                    4,
                                    $65283fdff51e8344$var$Bi(n, _$e)
                                ];
                            case 4:
                                t1 = _state.sent();
                                return [
                                    2,
                                    $65283fdff51e8344$var$as.fromTokenEndpointResponse(t1)
                                ];
                            case 5:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$Za(e1);
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "initiateBackchannelAuthentication",
            value: function initiateBackchannelAuthentication(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, a, _$e, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                t = _state.sent(), n = t.configuration, o = t.serverMetadata, i = $65283fdff51e8344$var$Ba($65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).authorizationParams), null == e ? void 0 : e.authorizationParams)), a = new URLSearchParams($65283fdff51e8344$var$f($65283fdff51e8344$var$f({
                                    scope: $65283fdff51e8344$var$Us
                                }, i), {}, {
                                    client_id: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientId,
                                    binding_message: e.bindingMessage,
                                    login_hint: JSON.stringify({
                                        format: "iss_sub",
                                        iss: o.issuer,
                                        sub: e.loginHint.sub
                                    })
                                }));
                                e.requestedExpiry && a.append("requested_expiry", e.requestedExpiry.toString()), e.authorizationDetails && a.append("authorization_details", JSON.stringify(e.authorizationDetails));
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$Yi(n, a)
                                ];
                            case 3:
                                _$e = _state.sent();
                                return [
                                    2,
                                    {
                                        authReqId: _$e.auth_req_id,
                                        expiresIn: _$e.expires_in,
                                        interval: _$e.interval
                                    }
                                ];
                            case 4:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$Za(e1);
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "backchannelAuthenticationGrant",
            value: function backchannelAuthenticationGrant(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, _$e, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = e.authReqId;
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                n = _state.sent().configuration, o = new URLSearchParams({
                                    auth_req_id: t
                                });
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$sr(n, "urn:openid:params:grant-type:ciba", o)
                                ];
                            case 3:
                                _$e = _state.sent();
                                return [
                                    2,
                                    $65283fdff51e8344$var$as.fromTokenEndpointResponse(_$e)
                                ];
                            case 4:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$Za(e1);
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getTokenForConnection",
            value: function getTokenForConnection(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (e.refreshToken && e.accessToken) throw new $65283fdff51e8344$var$za("Either a refresh or access token should be specified, but not both.");
                                n = null !== (t = e.accessToken) && void 0 !== t ? t : e.refreshToken;
                                if (!n) throw new $65283fdff51e8344$var$za("Either a refresh or access token must be specified.");
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.exchangeToken({
                                        connection: e.connection,
                                        subjectToken: n,
                                        subjectTokenType: e.accessToken ? $65283fdff51e8344$var$zs : "urn:ietf:params:oauth:token-type:refresh_token",
                                        loginHint: e.loginHint
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                e1 = _state.sent();
                                if (e1 instanceof $65283fdff51e8344$var$Da) throw new $65283fdff51e8344$var$za(e1.message, e1.cause);
                                throw e1;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "exchangeToken",
            value: function exchangeToken(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        return [
                            2,
                            "connection" in e ? $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Fs).call(this, e) : $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Vs).call(this, e)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getTokenByCode",
            value: function getTokenByCode(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, i, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                n = _state.sent().configuration;
                                void 0 !== t.organization && $65283fdff51e8344$var$qa(t.organization);
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$Qi(n, e, {
                                        pkceCodeVerifier: t.codeVerifier
                                    })
                                ];
                            case 3:
                                i = _state.sent();
                                o = $65283fdff51e8344$var$as.fromTokenEndpointResponse(i);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$Ua("There was an error while trying to request a token.", $65283fdff51e8344$var$Wa(e1));
                            case 5:
                                return [
                                    2,
                                    (t.organization && $65283fdff51e8344$var$Qa(o.claims, t.organization), o)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getTokenByMagicLinkCode",
            value: function getTokenByMagicLinkCode(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, e1, _$t;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                n = _state.sent().configuration;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$Qi(n, e, {
                                        expectedState: null == t ? void 0 : t.expectedState
                                    })
                                ];
                            case 3:
                                o = _state.sent();
                                return [
                                    2,
                                    $65283fdff51e8344$var$as.fromTokenEndpointResponse(o)
                                ];
                            case 4:
                                e1 = _state.sent();
                                _$t = e1 instanceof Error && e1.message ? e1.message : "There was an error while trying to request a token.";
                                throw new $65283fdff51e8344$var$Ua(_$t, e1);
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getTokenByRefreshToken",
            value: function getTokenByRefreshToken(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                t = _state.sent().configuration, n = new URLSearchParams;
                                e.audience && n.append("audience", e.audience), e.scope && n.append("scope", e.scope);
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$$i(t, e.refreshToken, n)
                                ];
                            case 3:
                                o = _state.sent();
                                return [
                                    2,
                                    $65283fdff51e8344$var$as.fromTokenEndpointResponse(o)
                                ];
                            case 4:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$La("The access token has expired and there was an error while trying to refresh it.", $65283fdff51e8344$var$Wa(e1));
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "revokeToken",
            value: function revokeToken(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                t = _state.sent().configuration, n = {};
                                e.tokenTypeHint && (n.token_type_hint = e.tokenTypeHint);
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$cr(t, e.token, n)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$Ja("An error occurred while trying to revoke the token.", $65283fdff51e8344$var$Wa(e1));
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getTokenByPassword",
            value: function getTokenByPassword(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _this, t, n, o, n1, _$e, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                t = _state.sent().configuration, n = new URLSearchParams({
                                    username: e.username,
                                    password: e.password
                                });
                                e.audience && n.append("audience", e.audience), e.scope && n.append("scope", e.scope), e.realm && n.append("realm", e.realm);
                                o = t;
                                if (!e.auth0ForwardedFor) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Gs).call(this)
                                ];
                            case 2:
                                n1 = _state.sent();
                                o = new $65283fdff51e8344$var$Fi(t.serverMetadata(), $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientId, $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientSecret, n1), o[$65283fdff51e8344$var$ji] = function(t, n) {
                                    return $65283fdff51e8344$var$c($65283fdff51e8344$var$Aa, _this).call(_this, t, $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, n), {}, {
                                        headers: $65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, n.headers), {}, {
                                            "auth0-forwarded-for": e.auth0ForwardedFor
                                        })
                                    }));
                                };
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$sr(o, "password", n)
                                ];
                            case 4:
                                _$e = _state.sent();
                                return [
                                    2,
                                    $65283fdff51e8344$var$as.fromTokenEndpointResponse(_$e)
                                ];
                            case 5:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$Ma("There was an error while trying to request a token.", $65283fdff51e8344$var$Wa(e1));
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getTokenByPasswordlessEmail",
            value: function getTokenByPasswordlessEmail(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t;
                    return (0, $3SMYb._)(this, function(_state) {
                        t = new URLSearchParams({
                            username: e.email,
                            otp: e.code,
                            realm: "email"
                        });
                        return [
                            2,
                            (e.audience && t.append("audience", e.audience), e.scope && t.append("scope", e.scope), $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Xs).call(this, t))
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getTokenByPasswordlessSms",
            value: function getTokenByPasswordlessSms(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t;
                    return (0, $3SMYb._)(this, function(_state) {
                        if (!$65283fdff51e8344$var$ks(e.phoneNumber)) throw new $65283fdff51e8344$var$gs("Phone number must be in E.164 format (e.g. +14155550100).");
                        t = new URLSearchParams({
                            username: e.phoneNumber,
                            otp: e.code,
                            realm: "sms"
                        });
                        return [
                            2,
                            (e.audience && t.append("audience", e.audience), e.scope && t.append("scope", e.scope), $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Xs).call(this, t))
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getTokenByClientCredentials",
            value: function getTokenByClientCredentials(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                t = _state.sent().configuration;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                n = new URLSearchParams({
                                    audience: e.audience
                                });
                                e.organization && n.append("organization", e.organization);
                                return [
                                    4,
                                    $65283fdff51e8344$var$er(t, n)
                                ];
                            case 3:
                                o = _state.sent();
                                return [
                                    2,
                                    $65283fdff51e8344$var$as.fromTokenEndpointResponse(o)
                                ];
                            case 4:
                                e1 = _state.sent();
                                throw new $65283fdff51e8344$var$Na("There was an error while trying to request a token.", $65283fdff51e8344$var$Wa(e1));
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "buildLogoutUrl",
            value: function buildLogoutUrl(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, t1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                t = _state.sent(), n = t.configuration;
                                if (!t.serverMetadata.end_session_endpoint) {
                                    t1 = new URL("https://".concat($65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).domain, "/v2/logout"));
                                    return [
                                        2,
                                        (t1.searchParams.set("returnTo", e.returnTo), t1.searchParams.set("client_id", $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientId), t1)
                                    ];
                                }
                                return [
                                    2,
                                    function(e, t) {
                                        $65283fdff51e8344$var$or(e);
                                        var n = $65283fdff51e8344$var$Ri(e), o = n.as, i = n.c, _$r = $65283fdff51e8344$var$_n(o, "end_session_endpoint", !1, n.tlsOnly);
                                        (t = new URLSearchParams(t)).has("client_id") || t.set("client_id", i.client_id);
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = t.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var _$e = _step.value;
                                                var a = $65283fdff51e8344$var$y(_$e, 2);
                                                var _$t = a[0], n1 = a[1];
                                                _$r.searchParams.append(_$t, n1);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        return _$r;
                                    }(n, {
                                        post_logout_redirect_uri: e.returnTo
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "verifyLogoutToken",
            value: function verifyLogoutToken(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, _obj, i;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                                ];
                            case 1:
                                t = _state.sent().serverMetadata, n = $65283fdff51e8344$var$js($65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).discoveryCache), o = t.jwks_uri;
                                $65283fdff51e8344$var$c($65283fdff51e8344$var$Ia, this) || $65283fdff51e8344$var$l($65283fdff51e8344$var$Ia, this, function(e, t) {
                                    var n = new $65283fdff51e8344$var$Br(e, t), o = function(e, t) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                            return (0, $3SMYb._)(this, function(_state) {
                                                return [
                                                    2,
                                                    n.getKey(e, t)
                                                ];
                                            });
                                        })();
                                    };
                                    return Object.defineProperties(o, {
                                        coolingDown: {
                                            get: function() {
                                                return n.coolingDown();
                                            },
                                            enumerable: !0,
                                            configurable: !1
                                        },
                                        fresh: {
                                            get: function() {
                                                return n.fresh();
                                            },
                                            enumerable: !0,
                                            configurable: !1
                                        },
                                        reload: {
                                            value: function() {
                                                return n.reload();
                                            },
                                            enumerable: !0,
                                            configurable: !1,
                                            writable: !1
                                        },
                                        reloading: {
                                            get: function() {
                                                return n.pendingFetch();
                                            },
                                            enumerable: !0,
                                            configurable: !1
                                        },
                                        jwks: {
                                            value: function() {
                                                return n.jwks();
                                            },
                                            enumerable: !0,
                                            configurable: !1,
                                            writable: !1
                                        }
                                    }), o;
                                }(new URL(o), (_obj = {
                                    cacheMaxAge: n.ttlMs
                                }, (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Lr, $65283fdff51e8344$var$c($65283fdff51e8344$var$Aa, this)), (0, $dUlz9._)(_obj, $65283fdff51e8344$var$Mr, $65283fdff51e8344$var$c($65283fdff51e8344$var$Oa, this)), _obj)));
                                return [
                                    4,
                                    $65283fdff51e8344$var$vr(e.logoutToken, $65283fdff51e8344$var$c($65283fdff51e8344$var$Ia, this), {
                                        issuer: t.issuer,
                                        audience: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientId,
                                        algorithms: [
                                            "RS256"
                                        ],
                                        requiredClaims: [
                                            "iat"
                                        ]
                                    })
                                ];
                            case 2:
                                i = _state.sent().payload;
                                if (!("sid" in i) && !("sub" in i)) throw new $65283fdff51e8344$var$Ha('either "sid" or "sub" (or both) claims must be present');
                                if ("sid" in i && "string" != typeof i.sid) throw new $65283fdff51e8344$var$Ha('"sid" claim must be a string');
                                if ("sub" in i && "string" != typeof i.sub) throw new $65283fdff51e8344$var$Ha('"sub" claim must be a string');
                                if ("nonce" in i) throw new $65283fdff51e8344$var$Ha('"nonce" claim is prohibited');
                                if (!("events" in i)) throw new $65283fdff51e8344$var$Ha('"events" claim is missing');
                                if ("object" != (0, $03bAP._)(i.events) || null === i.events) throw new $65283fdff51e8344$var$Ha('"events" claim must be an object');
                                if (!("http://schemas.openid.net/event/backchannel-logout" in i.events)) throw new $65283fdff51e8344$var$Ha('"http://schemas.openid.net/event/backchannel-logout" member is missing in the "events" claim');
                                if ("object" != (0, $03bAP._)(i.events["http://schemas.openid.net/event/backchannel-logout"])) throw new $65283fdff51e8344$var$Ha('"http://schemas.openid.net/event/backchannel-logout" member in the "events" claim must be an object');
                                return [
                                    2,
                                    {
                                        sid: i.sid,
                                        sub: i.sub
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return _class;
}());
function $65283fdff51e8344$var$Js() {
    var e = $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).domain.toLowerCase();
    return "".concat(e, "|mtls:").concat($65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).useMtls ? "1" : "0");
}
function $65283fdff51e8344$var$Hs(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var t, n;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Gs).call(this)
                    ];
                case 1:
                    t = _state.sent(), n = new $65283fdff51e8344$var$Fi(e, $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientId, $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientSecret, t);
                    return [
                        2,
                        (n[$65283fdff51e8344$var$ji] = $65283fdff51e8344$var$c($65283fdff51e8344$var$Aa, this), n)
                    ];
            }
        });
    }).call(this);
}
function $65283fdff51e8344$var$Zs() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _this, e, t, _tmp, n, e1, _tmp1, o, i, e2, t1, n1;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this;
                    if ($65283fdff51e8344$var$c($65283fdff51e8344$var$Sa, this) && $65283fdff51e8344$var$c($65283fdff51e8344$var$Ta, this)) return [
                        2,
                        {
                            configuration: $65283fdff51e8344$var$c($65283fdff51e8344$var$Sa, this),
                            serverMetadata: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ta, this)
                        }
                    ];
                    e = $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Js).call(this), t = $65283fdff51e8344$var$c($65283fdff51e8344$var$xa, this).get(e);
                    if (!t) return [
                        3,
                        2
                    ];
                    $65283fdff51e8344$var$l($65283fdff51e8344$var$Ta, this, t.serverMetadata);
                    _tmp = [
                        $65283fdff51e8344$var$Sa,
                        this
                    ];
                    return [
                        4,
                        $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Hs).call(this, t.serverMetadata)
                    ];
                case 1:
                    return [
                        2,
                        ($65283fdff51e8344$var$l.apply(void 0, _tmp.concat([
                            _state.sent()
                        ])), {
                            configuration: $65283fdff51e8344$var$c($65283fdff51e8344$var$Sa, this),
                            serverMetadata: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ta, this)
                        })
                    ];
                case 2:
                    n = $65283fdff51e8344$var$c($65283fdff51e8344$var$Ra, this).get(e);
                    if (!n) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        n
                    ];
                case 3:
                    e1 = _state.sent();
                    $65283fdff51e8344$var$l($65283fdff51e8344$var$Ta, this, e1.serverMetadata);
                    _tmp1 = [
                        $65283fdff51e8344$var$Sa,
                        this
                    ];
                    return [
                        4,
                        $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Hs).call(this, e1.serverMetadata)
                    ];
                case 4:
                    return [
                        2,
                        ($65283fdff51e8344$var$l.apply(void 0, _tmp1.concat([
                            _state.sent()
                        ])), {
                            configuration: $65283fdff51e8344$var$c($65283fdff51e8344$var$Sa, this),
                            serverMetadata: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ta, this)
                        })
                    ];
                case 5:
                    o = function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                            var t, n, o;
                            return (0, $3SMYb._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Gs).call(this)
                                        ];
                                    case 1:
                                        t = _state.sent();
                                        return [
                                            4,
                                            $65283fdff51e8344$var$Hi(new URL("https://".concat($65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).domain)), $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientId, {
                                                use_mtls_endpoint_aliases: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).useMtls
                                            }, t, (0, $dUlz9._)({}, $65283fdff51e8344$var$ji, $65283fdff51e8344$var$c($65283fdff51e8344$var$Aa, this)))
                                        ];
                                    case 2:
                                        n = _state.sent(), o = n.serverMetadata();
                                        return [
                                            2,
                                            ($65283fdff51e8344$var$c($65283fdff51e8344$var$xa, this).set(e, {
                                                serverMetadata: o
                                            }), {
                                                configuration: n,
                                                serverMetadata: o
                                            })
                                        ];
                                }
                            });
                        }).call(_this);
                    }(), i = o.then(function(e) {
                        return {
                            serverMetadata: e.serverMetadata
                        };
                    });
                    i.catch(function() {}), $65283fdff51e8344$var$c($65283fdff51e8344$var$Ra, this).set(e, i);
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        ,
                        8,
                        9
                    ]);
                    return [
                        4,
                        o
                    ];
                case 7:
                    e2 = _state.sent(), t1 = e2.configuration, n1 = e2.serverMetadata;
                    $65283fdff51e8344$var$l($65283fdff51e8344$var$Sa, this, t1), $65283fdff51e8344$var$l($65283fdff51e8344$var$Ta, this, n1), $65283fdff51e8344$var$c($65283fdff51e8344$var$Sa, this)[$65283fdff51e8344$var$ji] = $65283fdff51e8344$var$c($65283fdff51e8344$var$Aa, this);
                    return [
                        3,
                        9
                    ];
                case 8:
                    $65283fdff51e8344$var$c($65283fdff51e8344$var$Ra, this).delete(e);
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        {
                            configuration: $65283fdff51e8344$var$c($65283fdff51e8344$var$Sa, this),
                            serverMetadata: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ta, this)
                        }
                    ];
            }
        });
    }).call(this);
}
function $65283fdff51e8344$var$Fs(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _$t, n, o, i, _$e, t;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                    ];
                case 1:
                    o = _state.sent().configuration;
                    if ("audience" in e || "resource" in e) throw new $65283fdff51e8344$var$Da("audience and resource parameters are not supported for Token Vault exchanges");
                    $65283fdff51e8344$var$Ls(e.subjectToken);
                    i = new URLSearchParams({
                        connection: e.connection,
                        subject_token: e.subjectToken,
                        subject_token_type: null !== (_$t = e.subjectTokenType) && void 0 !== _$t ? _$t : $65283fdff51e8344$var$zs,
                        requested_token_type: null !== (n = e.requestedTokenType) && void 0 !== n ? n : "http://auth0.com/oauth/token-type/federated-connection-access-token"
                    });
                    e.loginHint && i.append("login_hint", e.loginHint), e.scope && i.append("scope", e.scope), $65283fdff51e8344$var$Ms(i, e.extra);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $65283fdff51e8344$var$sr(o, "urn:auth0:params:oauth:grant-type:token-exchange:federated-connection-access-token", i)
                    ];
                case 3:
                    _$e = _state.sent();
                    return [
                        2,
                        $65283fdff51e8344$var$as.fromTokenEndpointResponse(_$e)
                    ];
                case 4:
                    t = _state.sent();
                    throw new $65283fdff51e8344$var$Da("Failed to exchange token for connection '".concat(e.connection, "'."), $65283fdff51e8344$var$Wa(t));
                case 5:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $65283fdff51e8344$var$Vs(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _$t, n, o, i, t, a;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                    ];
                case 1:
                    _$t = _state.sent().configuration;
                    if ($65283fdff51e8344$var$Ls(e.subjectToken), void 0 !== e.organization && $65283fdff51e8344$var$qa(e.organization), void 0 !== e.actorToken && void 0 === e.actorTokenType) throw new $65283fdff51e8344$var$Da("actorTokenType is required when actorToken is provided");
                    n = new URLSearchParams({
                        subject_token_type: e.subjectTokenType,
                        subject_token: e.subjectToken
                    });
                    e.audience && n.append("audience", e.audience), e.scope && n.append("scope", e.scope), e.requestedTokenType && n.append("requested_token_type", e.requestedTokenType), e.organization && n.append("organization", e.organization), e.actorToken && n.append("actor_token", e.actorToken), e.actorTokenType && n.append("actor_token_type", e.actorTokenType), $65283fdff51e8344$var$Ms(n, e.extra);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $65283fdff51e8344$var$sr(_$t, "urn:ietf:params:oauth:grant-type:token-exchange", n)
                    ];
                case 3:
                    i = _state.sent(), o = $65283fdff51e8344$var$as.fromTokenEndpointResponse(i);
                    return [
                        3,
                        5
                    ];
                case 4:
                    t = _state.sent();
                    throw new $65283fdff51e8344$var$Da("Failed to exchange token of type '".concat(e.subjectTokenType, "'").concat(e.audience ? " for audience '".concat(e.audience, "'") : "", "."), $65283fdff51e8344$var$Wa(t));
                case 5:
                    if (e.organization && $65283fdff51e8344$var$Qa(o.claims, e.organization), e.actorToken) {
                        if (null !== (a = o.claims) && void 0 !== a && a.act) o.act = o.claims.act;
                        else try {
                            o.act = function(e) {
                                if ("string" != typeof e) throw new $65283fdff51e8344$var$Fo("JWTs must use Compact JWS serialization, JWT must be a string");
                                var _$t = e.split("."), n = _$t[1], o = _$t.length;
                                if (5 === o) throw new $65283fdff51e8344$var$Fo("Only JWTs using Compact JWS serialization can be decoded");
                                if (3 !== o) throw new $65283fdff51e8344$var$Fo("Invalid JWT");
                                if (!n) throw new $65283fdff51e8344$var$Fo("JWTs must contain a payload");
                                var i, _$r;
                                try {
                                    i = $65283fdff51e8344$var$Oo(n);
                                } catch (e) {
                                    throw new $65283fdff51e8344$var$Fo("Failed to base64url decode the payload");
                                }
                                try {
                                    _$r = JSON.parse($65283fdff51e8344$var$Ao.decode(i));
                                } catch (e) {
                                    throw new $65283fdff51e8344$var$Fo("Failed to parse the decoded payload as JSON");
                                }
                                if (!$65283fdff51e8344$var$ni(_$r)) throw new $65283fdff51e8344$var$Fo("Invalid JWT Claims Set");
                                return _$r;
                            }(i.access_token).act;
                        } catch (e) {}
                    }
                    return [
                        2,
                        o
                    ];
            }
        });
    }).call(this);
}
function $65283fdff51e8344$var$Xs(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var t, n, e1;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                    ];
                case 1:
                    t = _state.sent().configuration;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $65283fdff51e8344$var$sr(t, "http://auth0.com/oauth/grant-type/passwordless/otp", e)
                    ];
                case 3:
                    n = _state.sent();
                    return [
                        2,
                        $65283fdff51e8344$var$as.fromTokenEndpointResponse(n)
                    ];
                case 4:
                    e1 = _state.sent();
                    throw new $65283fdff51e8344$var$gs("There was an error while trying to request a token.", $65283fdff51e8344$var$Wa(e1));
                case 5:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $65283fdff51e8344$var$Gs() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _this;
        return (0, $3SMYb._)(this, function(_state) {
            _this = this;
            return [
                2,
                ($65283fdff51e8344$var$c($65283fdff51e8344$var$Pa, this) || $65283fdff51e8344$var$l($65283fdff51e8344$var$Pa, this, (function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                        var e, _tmp;
                        return (0, $3SMYb._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!$65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientSecret && !$65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientAssertionSigningKey && !$65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).useMtls) throw new $65283fdff51e8344$var$Ga;
                                    if ($65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).useMtls) return [
                                        2,
                                        function(e, t, n, o) {
                                            n.set("client_id", t.client_id);
                                        }
                                    ];
                                    e = $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientAssertionSigningKey;
                                    _tmp = !e || e instanceof CryptoKey;
                                    if (_tmp) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        $65283fdff51e8344$var$ki(e, $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientAssertionSigningAlg || "RS256")
                                    ];
                                case 1:
                                    _tmp = e = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2,
                                        (_tmp, e ? function(e, t) {
                                            return $65283fdff51e8344$var$gn(e, t);
                                        }(e) : $65283fdff51e8344$var$Wi($65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientSecret))
                                    ];
                            }
                        });
                    }).call(_this);
                })().catch(function(e) {
                    throw $65283fdff51e8344$var$l($65283fdff51e8344$var$Pa, _this, void 0), e;
                })), $65283fdff51e8344$var$c($65283fdff51e8344$var$Pa, this))
            ];
        });
    }).call(this);
}
function $65283fdff51e8344$var$Ys(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var t, n, o, i, a, _tmp, _tmp1;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $65283fdff51e8344$var$r($65283fdff51e8344$var$Ca, this, $65283fdff51e8344$var$Zs).call(this)
                    ];
                case 1:
                    t = _state.sent().configuration, n = $65283fdff51e8344$var$Mi();
                    return [
                        4,
                        $65283fdff51e8344$var$Li(n)
                    ];
                case 2:
                    o = _state.sent(), i = $65283fdff51e8344$var$Ba($65283fdff51e8344$var$f($65283fdff51e8344$var$f({}, $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).authorizationParams), null == e ? void 0 : e.authorizationParams)), a = new URLSearchParams($65283fdff51e8344$var$f($65283fdff51e8344$var$f({
                        scope: $65283fdff51e8344$var$Us
                    }, i), {}, {
                        client_id: $65283fdff51e8344$var$c($65283fdff51e8344$var$Ea, this).clientId,
                        code_challenge: o,
                        code_challenge_method: "S256"
                    }));
                    _tmp = {};
                    if (!(null != e && e.pushedAuthorizationRequests)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $65283fdff51e8344$var$nr(t, a)
                    ];
                case 3:
                    _tmp1 = _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    return [
                        4,
                        $65283fdff51e8344$var$tr(t, a)
                    ];
                case 5:
                    _tmp1 = _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        2,
                        (_tmp.authorizationUrl = _tmp1, _tmp.codeVerifier = n, _tmp)
                    ];
            }
        });
    }).call(this);
}
var $65283fdff51e8344$export$fd2d7253282cd781 = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $4QAx6._)(Bs, E);
    function Bs(e, t) {
        (0, $5Epmf._)(this, Bs);
        var _this;
        _this = (0, $48Z0s._)(this, Bs, [
            e,
            t
        ]), Object.setPrototypeOf(_this, Bs.prototype);
        return _this;
    }
    (0, $9MqXK._)(Bs, null, [
        {
            key: "fromPayload",
            value: function fromPayload(e) {
                var t = e.error, n = e.error_description;
                return new Bs(t, n);
            }
        }
    ]);
    return Bs;
}($65283fdff51e8344$export$7d465be8efa67280);
var $65283fdff51e8344$export$940c42743f432969 = /*#__PURE__*/ function(Bs) {
    "use strict";
    (0, $4QAx6._)(qs, Bs);
    function qs(e, t) {
        (0, $5Epmf._)(this, qs);
        var _this;
        _this = (0, $48Z0s._)(this, qs, [
            e,
            t
        ]), Object.setPrototypeOf(_this, qs.prototype);
        return _this;
    }
    return qs;
}($65283fdff51e8344$export$fd2d7253282cd781);
var $65283fdff51e8344$export$870742f9876ce7c1 = /*#__PURE__*/ function(Bs) {
    "use strict";
    (0, $4QAx6._)(Qs, Bs);
    function Qs(e, t) {
        (0, $5Epmf._)(this, Qs);
        var _this;
        _this = (0, $48Z0s._)(this, Qs, [
            e,
            t
        ]), Object.setPrototypeOf(_this, Qs.prototype);
        return _this;
    }
    return Qs;
}($65283fdff51e8344$export$fd2d7253282cd781);
var $65283fdff51e8344$export$5a994d9ede115726 = /*#__PURE__*/ function(Bs) {
    "use strict";
    (0, $4QAx6._)($s, Bs);
    function $s(e, t) {
        (0, $5Epmf._)(this, $s);
        var _this;
        _this = (0, $48Z0s._)(this, $s, [
            e,
            t
        ]), Object.setPrototypeOf(_this, $s.prototype);
        return _this;
    }
    return $s;
}($65283fdff51e8344$export$fd2d7253282cd781);
var $65283fdff51e8344$export$ed4d3fbc582ebfd8 = /*#__PURE__*/ function(Bs) {
    "use strict";
    (0, $4QAx6._)(ec, Bs);
    function ec(e, t) {
        (0, $5Epmf._)(this, ec);
        var _this;
        _this = (0, $48Z0s._)(this, ec, [
            e,
            t
        ]), Object.setPrototypeOf(_this, ec.prototype);
        return _this;
    }
    return ec;
}($65283fdff51e8344$export$fd2d7253282cd781);
var $65283fdff51e8344$export$702aa0eb54b4ab0a = /*#__PURE__*/ function(Bs) {
    "use strict";
    (0, $4QAx6._)(tc, Bs);
    function tc(e, t) {
        (0, $5Epmf._)(this, tc);
        var _this;
        _this = (0, $48Z0s._)(this, tc, [
            e,
            t
        ]), Object.setPrototypeOf(_this, tc.prototype);
        return _this;
    }
    return tc;
}($65283fdff51e8344$export$fd2d7253282cd781);
var $65283fdff51e8344$var$nc = /*#__PURE__*/ function() {
    "use strict";
    function nc() {
        (0, $5Epmf._)(this, nc);
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 6e5;
        this.contexts = new Map, this.ttlMs = e;
    }
    (0, $9MqXK._)(nc, [
        {
            key: "set",
            value: function set(e, t) {
                this.cleanup(), this.contexts.set(e, Object.assign(Object.assign({}, t), {
                    createdAt: Date.now()
                }));
            }
        },
        {
            key: "get",
            value: function get(e) {
                var t = this.contexts.get(e);
                if (t) {
                    if (!(Date.now() - t.createdAt > this.ttlMs)) return t;
                    this.contexts.delete(e);
                }
            }
        },
        {
            key: "remove",
            value: function remove(e) {
                this.contexts.delete(e);
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                var e = Date.now();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.contexts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var n = _step.value;
                        var t = $65283fdff51e8344$var$y(n, 2);
                        var o = t[0];
                        e - t[1].createdAt > this.ttlMs && this.contexts.delete(o);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "size",
            get: function get() {
                return this.contexts.size;
            }
        }
    ]);
    return nc;
}();
var $65283fdff51e8344$var$oc = /*#__PURE__*/ function() {
    "use strict";
    function oc(e, t) {
        (0, $5Epmf._)(this, oc);
        this.authJsMfaClient = e, this.auth0Client = t, this.contextManager = new $65283fdff51e8344$var$nc;
    }
    (0, $9MqXK._)(oc, [
        {
            key: "setMFAAuthDetails",
            value: function setMFAAuthDetails(e, t, n, o) {
                this.contextManager.set(e, {
                    scope: t,
                    audience: n,
                    mfaRequirements: o
                });
            }
        },
        {
            key: "getAuthenticators",
            value: function getAuthenticators(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, r, t1, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                i = this.contextManager.get(e);
                                if (!i) throw new $65283fdff51e8344$export$940c42743f432969("invalid_request", "MFA context not found for this MFA token");
                                r = null === (n = null === (t = i.mfaRequirements) || void 0 === t ? void 0 : t.challenge) || void 0 === n ? void 0 : n.map(function(e) {
                                    return e.type;
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.authJsMfaClient.listAuthenticators({
                                        mfaToken: e
                                    })
                                ];
                            case 2:
                                t1 = _state.sent();
                                return [
                                    2,
                                    r && 0 !== r.length ? t1.filter(function(e) {
                                        return !!e.type && r.includes(e.type);
                                    }) : t1
                                ];
                            case 3:
                                e1 = _state.sent();
                                if (e1 instanceof $65283fdff51e8344$var$es) throw new $65283fdff51e8344$export$940c42743f432969(null === (o = e1.cause) || void 0 === o ? void 0 : o.error, e1.message);
                                throw e1;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "enroll",
            value: function enroll(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                n = function(e) {
                                    var t = $65283fdff51e8344$var$It[e.factorType];
                                    return Object.assign(Object.assign(Object.assign({
                                        mfaToken: e.mfaToken,
                                        authenticatorTypes: t.authenticatorTypes
                                    }, t.oobChannels && {
                                        oobChannels: t.oobChannels
                                    }), "phoneNumber" in e && {
                                        phoneNumber: e.phoneNumber
                                    }), "email" in e && {
                                        email: e.email
                                    });
                                }(e);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.authJsMfaClient.enrollAuthenticator(n)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                e1 = _state.sent();
                                if (e1 instanceof $65283fdff51e8344$var$ts) throw new $65283fdff51e8344$export$870742f9876ce7c1(null === (t = e1.cause) || void 0 === t ? void 0 : t.error, e1.message);
                                throw e1;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "challenge",
            value: function challenge(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, t1, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                t1 = {
                                    challengeType: e.challengeType,
                                    mfaToken: e.mfaToken
                                };
                                e.authenticatorId && (t1.authenticatorId = e.authenticatorId);
                                return [
                                    4,
                                    this.authJsMfaClient.challengeAuthenticator(t1)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                e1 = _state.sent();
                                if (e1 instanceof $65283fdff51e8344$var$os) throw new $65283fdff51e8344$export$5a994d9ede115726(null === (t = e1.cause) || void 0 === t ? void 0 : t.error, e1.message);
                                throw e1;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getEnrollmentFactors",
            value: function getEnrollmentFactors(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t;
                    return (0, $3SMYb._)(this, function(_state) {
                        t = this.contextManager.get(e);
                        if (!t || !t.mfaRequirements) throw new $65283fdff51e8344$export$702aa0eb54b4ab0a("mfa_context_not_found", "MFA context not found for this MFA token. Please retry the original request to get a new MFA token.");
                        return [
                            2,
                            t.mfaRequirements.enroll && 0 !== t.mfaRequirements.enroll.length ? t.mfaRequirements.enroll : []
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "verify",
            value: function verify(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, t1, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = this.contextManager.get(e.mfaToken);
                                if (!t) throw new $65283fdff51e8344$export$ed4d3fbc582ebfd8("mfa_context_not_found", "MFA context not found for this MFA token. Please retry the original request to get a new MFA token.");
                                n = function(e) {
                                    return "otp" in e && e.otp ? $65283fdff51e8344$var$xt : "oobCode" in e && e.oobCode ? $65283fdff51e8344$var$Rt : "recoveryCode" in e && e.recoveryCode ? $65283fdff51e8344$var$Ot : void 0;
                                }(e);
                                if (!n) throw new $65283fdff51e8344$export$ed4d3fbc582ebfd8("invalid_request", "Unable to determine grant type. Provide one of: otp, oobCode, or recoveryCode.");
                                o = t.scope, i = t.audience;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.auth0Client._requestTokenForMfa({
                                        grant_type: n,
                                        mfaToken: e.mfaToken,
                                        scope: o,
                                        audience: i,
                                        otp: e.otp,
                                        oob_code: e.oobCode,
                                        binding_code: e.bindingCode,
                                        recovery_code: e.recoveryCode
                                    })
                                ];
                            case 2:
                                t1 = _state.sent();
                                return [
                                    2,
                                    (this.contextManager.remove(e.mfaToken), t1)
                                ];
                            case 3:
                                e1 = _state.sent();
                                if (e1 instanceof $65283fdff51e8344$export$ed4d3fbc582ebfd8) throw new $65283fdff51e8344$export$ed4d3fbc582ebfd8(e1.error, e1.error_description);
                                throw e1;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return oc;
}();
var $65283fdff51e8344$export$bf0fd5fd31fb5a90 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(ic, Error1);
    function ic(e, t, n) {
        (0, $5Epmf._)(this, ic);
        var _this;
        _this = (0, $48Z0s._)(this, ic, [
            t
        ]), _this.name = "PasskeyError", _this.code = e, _this.cause = n, Object.setPrototypeOf(_this, ic.prototype);
        return _this;
    }
    return ic;
}((0, $kW1tL._)(Error));
var $65283fdff51e8344$var$rc, $65283fdff51e8344$var$ac;
var $65283fdff51e8344$var$sc = /*#__PURE__*/ function() {
    "use strict";
    function sc(e, t) {
        (0, $5Epmf._)(this, sc);
        $65283fdff51e8344$var$rc.set(this, void 0), $65283fdff51e8344$var$ac.set(this, void 0), $65283fdff51e8344$var$n(this, $65283fdff51e8344$var$rc, e, "f"), $65283fdff51e8344$var$n(this, $65283fdff51e8344$var$ac, t, "f");
    }
    (0, $9MqXK._)(sc, [
        {
            key: "signup",
            value: function signup(n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var o, i, r, a, s, c, u;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!window.PublicKeyCredential) throw new $65283fdff51e8344$export$bf0fd5fd31fb5a90("passkey_not_supported", "WebAuthn is not supported in this browser.");
                                o = n.scope, i = n.audience, r = $65283fdff51e8344$var$e(n, [
                                    "scope",
                                    "audience"
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$t(this, $65283fdff51e8344$var$rc, "f").register(r)
                                ];
                            case 1:
                                a = _state.sent(), s = $65283fdff51e8344$var$lc(a.authnParamsPublicKey);
                                return [
                                    4,
                                    navigator.credentials.create({
                                        publicKey: s
                                    })
                                ];
                            case 2:
                                c = _state.sent();
                                if (!c) throw new $65283fdff51e8344$export$bf0fd5fd31fb5a90("passkey_cancelled", "Passkey creation was cancelled or no credential was returned.");
                                u = $65283fdff51e8344$var$dc(c);
                                return [
                                    2,
                                    $65283fdff51e8344$var$t(this, $65283fdff51e8344$var$ac, "f")._requestTokenForPasskey({
                                        authSession: a.authSession,
                                        credential: u,
                                        realm: r.realm,
                                        organization: r.organization,
                                        scope: o,
                                        audience: i
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "login",
            value: function login(n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var o, i, r, a, s, c, u, l;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!window.PublicKeyCredential) throw new $65283fdff51e8344$export$bf0fd5fd31fb5a90("passkey_not_supported", "WebAuthn is not supported in this browser.");
                                o = n || {}, i = o.scope, r = o.audience, a = $65283fdff51e8344$var$e(o, [
                                    "scope",
                                    "audience"
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$t(this, $65283fdff51e8344$var$rc, "f").challenge(Object.keys(a).length > 0 ? a : void 0)
                                ];
                            case 1:
                                s = _state.sent(), c = $65283fdff51e8344$var$hc(s.authnParamsPublicKey);
                                return [
                                    4,
                                    navigator.credentials.get({
                                        publicKey: c
                                    })
                                ];
                            case 2:
                                u = _state.sent();
                                if (!u) throw new $65283fdff51e8344$export$bf0fd5fd31fb5a90("passkey_cancelled", "Passkey authentication was cancelled or no credential was returned.");
                                l = $65283fdff51e8344$var$pc(u);
                                return [
                                    2,
                                    $65283fdff51e8344$var$t(this, $65283fdff51e8344$var$ac, "f")._requestTokenForPasskey({
                                        authSession: s.authSession,
                                        credential: l,
                                        realm: a.realm,
                                        organization: a.organization,
                                        scope: i,
                                        audience: r
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getSignupChallenge",
            value: function getSignupChallenge(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!window.PublicKeyCredential) throw new $65283fdff51e8344$export$bf0fd5fd31fb5a90("passkey_not_supported", "WebAuthn is not supported in this browser.");
                                return [
                                    4,
                                    $65283fdff51e8344$var$t(this, $65283fdff51e8344$var$rc, "f").register(e)
                                ];
                            case 1:
                                n = _state.sent();
                                return [
                                    2,
                                    {
                                        authSession: n.authSession,
                                        publicKey: $65283fdff51e8344$var$lc(n.authnParamsPublicKey)
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getLoginChallenge",
            value: function getLoginChallenge(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!window.PublicKeyCredential) throw new $65283fdff51e8344$export$bf0fd5fd31fb5a90("passkey_not_supported", "WebAuthn is not supported in this browser.");
                                return [
                                    4,
                                    $65283fdff51e8344$var$t(this, $65283fdff51e8344$var$rc, "f").challenge(e)
                                ];
                            case 1:
                                n = _state.sent();
                                return [
                                    2,
                                    {
                                        authSession: n.authSession,
                                        publicKey: $65283fdff51e8344$var$hc(n.authnParamsPublicKey)
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getTokenWithPasskey",
            value: function getTokenWithPasskey(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, i, r, a, s, c, u;
                    return (0, $3SMYb._)(this, function(_state) {
                        if (!window.PublicKeyCredential) throw new $65283fdff51e8344$export$bf0fd5fd31fb5a90("passkey_not_supported", "WebAuthn is not supported in this browser.");
                        n = e.authSession, o = e.credential, i = e.realm, r = e.organization, a = e.scope, s = e.audience, c = o.response;
                        if (c instanceof AuthenticatorAttestationResponse) u = $65283fdff51e8344$var$dc(o);
                        else {
                            if (!(c instanceof AuthenticatorAssertionResponse)) throw new $65283fdff51e8344$export$bf0fd5fd31fb5a90("passkey_invalid_credential", "The provided credential is not a valid attestation or assertion response.");
                            u = $65283fdff51e8344$var$pc(o);
                        }
                        return [
                            2,
                            $65283fdff51e8344$var$t(this, $65283fdff51e8344$var$ac, "f")._requestTokenForPasskey({
                                authSession: n,
                                credential: u,
                                realm: i,
                                organization: r,
                                scope: a,
                                audience: s
                            })
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return sc;
}();
function $65283fdff51e8344$var$cc(e) {
    var t = new Uint8Array(e), n = Array.from(t, function(e) {
        return String.fromCharCode(e);
    }).join("");
    return btoa(n).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function $65283fdff51e8344$var$uc(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/"), n = t + "=".repeat((4 - t.length % 4) % 4), o = atob(n), i = new Uint8Array(o.length);
    for(var _$e = 0; _$e < o.length; _$e++)i[_$e] = o.charCodeAt(_$e);
    return i.buffer;
}
function $65283fdff51e8344$var$lc(e) {
    return Object.assign(Object.assign({}, e), {
        challenge: $65283fdff51e8344$var$uc(e.challenge),
        user: Object.assign(Object.assign({}, e.user), {
            id: $65283fdff51e8344$var$uc(e.user.id)
        }),
        pubKeyCredParams: e.pubKeyCredParams,
        authenticatorSelection: e.authenticatorSelection
    });
}
function $65283fdff51e8344$var$hc(e) {
    return Object.assign(Object.assign({}, e), {
        challenge: $65283fdff51e8344$var$uc(e.challenge)
    });
}
function $65283fdff51e8344$var$dc(e) {
    var t;
    var n = e.response;
    return {
        id: e.id,
        rawId: $65283fdff51e8344$var$cc(e.rawId),
        type: e.type,
        authenticatorAttachment: null !== (t = e.authenticatorAttachment) && void 0 !== t ? t : void 0,
        response: {
            clientDataJSON: $65283fdff51e8344$var$cc(n.clientDataJSON),
            attestationObject: $65283fdff51e8344$var$cc(n.attestationObject)
        },
        clientExtensionResults: e.getClientExtensionResults()
    };
}
function $65283fdff51e8344$var$pc(e) {
    var t;
    var n = e.response;
    return {
        id: e.id,
        rawId: $65283fdff51e8344$var$cc(e.rawId),
        type: e.type,
        authenticatorAttachment: null !== (t = e.authenticatorAttachment) && void 0 !== t ? t : void 0,
        response: {
            clientDataJSON: $65283fdff51e8344$var$cc(n.clientDataJSON),
            authenticatorData: $65283fdff51e8344$var$cc(n.authenticatorData),
            signature: $65283fdff51e8344$var$cc(n.signature),
            userHandle: n.userHandle ? $65283fdff51e8344$var$cc(n.userHandle) : void 0
        },
        clientExtensionResults: e.getClientExtensionResults()
    };
}
$65283fdff51e8344$var$rc = new WeakMap, $65283fdff51e8344$var$ac = new WeakMap;
var $65283fdff51e8344$var$fc = /*#__PURE__*/ function() {
    "use strict";
    function fc(e) {
        var _this = this;
        (0, $5Epmf._)(this, fc);
        var t, n;
        if (this.userCache = (new $65283fdff51e8344$export$467265324939f47f).enclosedCache, this.defaultOptions = {
            authorizationParams: {
                scope: "openid profile email"
            },
            useRefreshTokensFallback: !1,
            useFormData: !0,
            refreshTokenMode: "offline"
        }, this.onlineAccess = this.resolveOnlineAccess(e), this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
            authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
        }), "undefined" != typeof window && function() {
            if (!$65283fdff51e8344$var$M()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === $65283fdff51e8344$var$M().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        }(), this.lockManager = ($65283fdff51e8344$var$he || ($65283fdff51e8344$var$he = $65283fdff51e8344$var$le()), $65283fdff51e8344$var$he), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) n = e.cache;
        else {
            if (t = e.cacheLocation || $65283fdff51e8344$var$k, !$65283fdff51e8344$var$gt(t)) throw new Error('Invalid cache location "'.concat(t, '"'));
            n = $65283fdff51e8344$var$gt(t)();
        }
        var o;
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : $65283fdff51e8344$var$b, this.cookieStorage = !1 === e.legacySameSiteCookie ? $65283fdff51e8344$var$nt : $65283fdff51e8344$var$it, this.orgHintCookieName = (o = this.options.clientId, "auth0.".concat(o, ".organization_hint")), this.isAuthenticatedCookieName = function(e) {
            return "auth0.".concat(e, ".is.authenticated");
        }(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        var i = e.useCookiesForTransactions ? this.cookieStorage : $65283fdff51e8344$var$rt;
        var r = "";
        var a;
        this.onlineAccess ? r = $65283fdff51e8344$var$_ : this.options.useRefreshTokens && (r = "offline_access"), this.scope = function(e, t) {
            for(var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)o[i - 2] = arguments[i];
            if ("object" != (typeof e === "undefined" ? "undefined" : (0, $03bAP._)(e))) return (0, $dUlz9._)({}, $65283fdff51e8344$var$P, $65283fdff51e8344$var$Ue.apply(void 0, [
                t,
                e
            ].concat((0, $XnYkK._)(o))));
            var r = (0, $dUlz9._)({}, $65283fdff51e8344$var$P, $65283fdff51e8344$var$Ue.apply(void 0, [
                t
            ].concat((0, $XnYkK._)(o))));
            return Object.keys(e).forEach(function(n) {
                var i = e[n];
                r[n] = $65283fdff51e8344$var$Ue.apply(void 0, [
                    t,
                    i
                ].concat((0, $XnYkK._)(o)));
            }), r;
        }(this.options.authorizationParams.scope, "openid", r), this.transactionManager = new $65283fdff51e8344$var$Ze(i, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || $65283fdff51e8344$var$T, this.cacheManager = new $65283fdff51e8344$var$He(n, n.allKeys ? void 0 : new $65283fdff51e8344$var$mt(n, this.options.clientId), this.nowProvider), this.dpop = this.options.useDpop ? new $65283fdff51e8344$var$St(this.options.clientId) : void 0, this.domainUrl = (a = this.options.domain, /^https?:\/\//.test(a) ? a : "https://".concat(a)), this.tokenIssuer = function(e, t) {
            return e ? e.startsWith("https://") ? e : "https://".concat(e, "/") : "".concat(t, "/");
        }(this.options.issuer, this.domainUrl);
        var s = "".concat(this.domainUrl, "/me/"), c = this.createFetcher(Object.assign(Object.assign({}, this.options.useDpop && {
            dpopNonceId: "__auth0_my_account_api__"
        }), {
            getAccessToken: function(e) {
                var t;
                return _this.getTokenSilently({
                    authorizationParams: {
                        scope: null === (t = null == e ? void 0 : e.scope) || void 0 === t ? void 0 : t.join(" "),
                        audience: s
                    },
                    detailedResponse: !0
                });
            }
        }));
        this.myAccount = new $65283fdff51e8344$var$Et(c, s), this.authJsClient = new $65283fdff51e8344$var$Ds({
            domain: this.options.domain,
            clientId: this.options.clientId
        }), this.mfa = new $65283fdff51e8344$var$oc(this.authJsClient.mfa, this), this.passkey = new $65283fdff51e8344$var$sc(this.authJsClient.passkey, this), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && t === $65283fdff51e8344$var$k && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new $65283fdff51e8344$var$ft, this.worker.postMessage({
            type: "init",
            allowedBaseUrl: this.domainUrl
        }));
    }
    (0, $9MqXK._)(fc, [
        {
            key: "resolveOnlineAccess",
            value: function resolveOnlineAccess(e) {
                if ("online" !== e.refreshTokenMode) return !1;
                if (!0 !== e.useRefreshTokens) throw new $65283fdff51e8344$export$c2cad27df3e57d40('`refreshTokenMode: "online"` requires the refresh-token grant.', "Set `useRefreshTokens: true`.");
                if (!0 !== e.useDpop) throw new $65283fdff51e8344$export$c2cad27df3e57d40('`refreshTokenMode: "online"` requires DPoP, which is missing or disabled.', "Set `useDpop: true` (DPoP is mandatory for online access).");
                return !0;
            }
        },
        {
            key: "getConfiguration",
            value: function getConfiguration() {
                return Object.freeze({
                    domain: this.options.domain,
                    clientId: this.options.clientId
                });
            }
        },
        {
            key: "_url",
            value: function _url(e) {
                var t = this.options.auth0Client || $65283fdff51e8344$var$S, n = $65283fdff51e8344$var$H(t, !0), o = encodeURIComponent(btoa(JSON.stringify(n)));
                return "".concat(this.domainUrl).concat(e, "&auth0Client=").concat(o);
            }
        },
        {
            key: "_authorizeUrl",
            value: function _authorizeUrl(e) {
                return this._url("/authorize?".concat($65283fdff51e8344$var$Z(e)));
            }
        },
        {
            key: "_verifyIdToken",
            value: function _verifyIdToken(e, t, n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var o, i;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.nowProvider()
                                ];
                            case 1:
                                o = _state.sent();
                                return [
                                    2,
                                    $65283fdff51e8344$var$Xe({
                                        iss: this.tokenIssuer,
                                        aud: this.options.clientId,
                                        id_token: e,
                                        nonce: t,
                                        organization: n,
                                        leeway: this.options.leeway,
                                        max_age: (i = this.options.authorizationParams.max_age, "string" != typeof i ? i : parseInt(i, 10) || void 0),
                                        now: o
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_processOrgHint",
            value: function _processOrgHint(e) {
                e ? this.cookieStorage.save(this.orgHintCookieName, e, {
                    daysUntilExpire: this.sessionCheckExpiryDays,
                    cookieDomain: this.options.cookieDomain
                }) : this.cookieStorage.remove(this.orgHintCookieName, {
                    cookieDomain: this.options.cookieDomain
                });
            }
        },
        {
            key: "_extractSessionTransferToken",
            value: function _extractSessionTransferToken(e) {
                return new URLSearchParams(window.location.search).get(e) || void 0;
            }
        },
        {
            key: "_clearSessionTransferTokenFromUrl",
            value: function _clearSessionTransferTokenFromUrl(e) {
                try {
                    var t = new URL(window.location.href);
                    t.searchParams.has(e) && (t.searchParams.delete(e), window.history.replaceState({}, "", t.toString()));
                } catch (e) {}
            }
        },
        {
            key: "_applySessionTransferToken",
            value: function _applySessionTransferToken(e) {
                var t = this.options.sessionTransferTokenQueryParamName;
                if (!t || e.session_transfer_token) return e;
                var n = this._extractSessionTransferToken(t);
                return n ? (this._clearSessionTransferTokenFromUrl(t), Object.assign(Object.assign({}, e), {
                    session_transfer_token: n
                })) : e;
            }
        },
        {
            key: "_prepareAuthorizeUrl",
            value: function _prepareAuthorizeUrl(e, t, n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var o, i, r, a, s, c, u, l, h;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                i = $65283fdff51e8344$var$D($65283fdff51e8344$var$z()), r = $65283fdff51e8344$var$D($65283fdff51e8344$var$z()), a = $65283fdff51e8344$var$z();
                                return [
                                    4,
                                    $65283fdff51e8344$var$F(a)
                                ];
                            case 1:
                                s = _state.sent(), c = $65283fdff51e8344$var$X(s);
                                return [
                                    4,
                                    null === (o = this.dpop) || void 0 === o ? void 0 : o.calculateThumbprint()
                                ];
                            case 2:
                                u = _state.sent(), l = function(e, t, n, o, i, r, a, s, c) {
                                    return Object.assign(Object.assign(Object.assign({
                                        client_id: e.clientId
                                    }, e.authorizationParams), n), {
                                        scope: $65283fdff51e8344$var$Ne(t, n.scope, n.audience),
                                        response_type: "code",
                                        response_mode: s || "query",
                                        state: o,
                                        nonce: i,
                                        redirect_uri: a || e.authorizationParams.redirect_uri,
                                        code_challenge: r,
                                        code_challenge_method: "S256",
                                        dpop_jkt: c
                                    });
                                }(this.options, this.scope, e, i, r, c, e.redirect_uri || this.options.authorizationParams.redirect_uri || n, null == t ? void 0 : t.response_mode, u), h = this._authorizeUrl(l);
                                return [
                                    2,
                                    {
                                        nonce: r,
                                        code_verifier: a,
                                        scope: l.scope,
                                        audience: l.audience || $65283fdff51e8344$var$P,
                                        redirect_uri: l.redirect_uri,
                                        state: i,
                                        url: h
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "loginWithPopup",
            value: function loginWithPopup(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, i, r, a;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (e = e || {}, !(t = t || {}).popup && (t.popup = function(e) {
                                    var _$t = window.screenX + (window.innerWidth - 400) / 2, n = window.screenY + (window.innerHeight - 600) / 2;
                                    return window.open(e, "auth0:authorize:popup", "left=".concat(_$t, ",top=").concat(n, ",width=").concat(400, ",height=").concat(600, ",resizable,scrollbars=yes,status=1"));
                                }(""), !t.popup)) throw new $65283fdff51e8344$export$d52312082b7f6392;
                                o = this._applySessionTransferToken(e.authorizationParams || {});
                                return [
                                    4,
                                    this._prepareAuthorizeUrl(o, {
                                        response_mode: "web_message"
                                    }, window.location.origin)
                                ];
                            case 1:
                                i = _state.sent();
                                t.popup.location.href = i.url;
                                return [
                                    4,
                                    function(e, t) {
                                        return new Promise(function(n, o) {
                                            var i;
                                            var r = setInterval(function() {
                                                e.popup && e.popup.closed && (clearInterval(r), clearTimeout(a), window.removeEventListener("message", i, !1), o(new $65283fdff51e8344$export$f1f681f0fb26bb55(e.popup)));
                                            }, 1e3), a = setTimeout(function() {
                                                clearInterval(r), o(new $65283fdff51e8344$export$ebbb83fe03f719a4(e.popup)), window.removeEventListener("message", i, !1);
                                            }, 1e3 * (e.timeoutInSeconds || 60));
                                            i = function(s) {
                                                if (s.origin === t && s.data && "authorization_response" === s.data.type) {
                                                    if (clearTimeout(a), clearInterval(r), window.removeEventListener("message", i, !1), !1 !== e.closePopup && e.popup.close(), s.data.response.error) return o($65283fdff51e8344$export$7d465be8efa67280.fromPayload(s.data.response));
                                                    n(s.data.response);
                                                }
                                            }, window.addEventListener("message", i);
                                        });
                                    }(Object.assign(Object.assign({}, t), {
                                        timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
                                    }), new URL(i.url).origin)
                                ];
                            case 2:
                                r = _state.sent();
                                if (i.state !== r.state) throw new $65283fdff51e8344$export$7d465be8efa67280("state_mismatch", "Invalid state");
                                a = (null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.organization) || this.options.authorizationParams.organization;
                                return [
                                    4,
                                    this._requestToken({
                                        audience: i.audience,
                                        scope: i.scope,
                                        code_verifier: i.code_verifier,
                                        grant_type: "authorization_code",
                                        code: r.code,
                                        redirect_uri: i.redirect_uri
                                    }, {
                                        nonceIn: i.nonce,
                                        organization: a
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getUser",
            value: function getUser() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var e, t;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._isSessionCeilingReached()
                                ];
                            case 1:
                                if (_state.sent()) return [
                                    2
                                ];
                                return [
                                    4,
                                    this._getIdTokenFromCache()
                                ];
                            case 2:
                                t = _state.sent();
                                return [
                                    2,
                                    null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getIdTokenClaims",
            value: function getIdTokenClaims() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var e, t;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._isSessionCeilingReached()
                                ];
                            case 1:
                                if (_state.sent()) return [
                                    2
                                ];
                                return [
                                    4,
                                    this._getIdTokenFromCache()
                                ];
                            case 2:
                                t = _state.sent();
                                return [
                                    2,
                                    null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "loginWithRedirect",
            value: function loginWithRedirect() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, r, a, s, c, u, l, h, _$d, _tmp;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                n = $65283fdff51e8344$var$vt(_arguments.length > 0 && void 0 !== _arguments[0] ? _arguments[0] : {}), o = n.openUrl, i = n.fragment, r = n.appState, a = $65283fdff51e8344$var$e(n, [
                                    "openUrl",
                                    "fragment",
                                    "appState"
                                ]), s = (null === (t = a.authorizationParams) || void 0 === t ? void 0 : t.organization) || this.options.authorizationParams.organization, c = this._applySessionTransferToken(a.authorizationParams || {});
                                return [
                                    4,
                                    this._prepareAuthorizeUrl(c)
                                ];
                            case 1:
                                u = _state.sent(), l = u.url, h = $65283fdff51e8344$var$e(u, [
                                    "url"
                                ]);
                                this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, h), {
                                    appState: r,
                                    response_type: $65283fdff51e8344$export$7390b1e457b4cb6f.Code
                                }), s && {
                                    organization: s
                                }));
                                _$d = i ? "".concat(l, "#").concat(i) : l;
                                if (!o) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    o(_$d)
                                ];
                            case 2:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _tmp = window.location.assign(_$d);
                                _state.label = 4;
                            case 4:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "handleRedirectCallback",
            value: function handleRedirectCallback() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var e, t, n;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        e = (_arguments.length > 0 && void 0 !== _arguments[0] ? _arguments[0] : window.location.href).split("?").slice(1);
                        if (0 === e.length) throw new Error("There are no query params available for parsing.");
                        t = this.transactionManager.get();
                        if (!t) throw new $65283fdff51e8344$export$7d465be8efa67280("missing_transaction", "Invalid state");
                        this.transactionManager.remove();
                        n = function(e) {
                            e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
                            var t = new URLSearchParams(e);
                            return {
                                state: t.get("state"),
                                code: t.get("code") || void 0,
                                connect_code: t.get("connect_code") || void 0,
                                error: t.get("error") || void 0,
                                error_description: t.get("error_description") || void 0
                            };
                        }(e.join(""));
                        return [
                            2,
                            t.response_type === $65283fdff51e8344$export$7390b1e457b4cb6f.ConnectCode ? this._handleConnectAccountRedirectCallback(n, t) : this._handleLoginRedirectCallback(n, t)
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "_handleLoginRedirectCallback",
            value: function _handleLoginRedirectCallback(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, i, r, a, s, c;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                n = e.code, o = e.state, i = e.error, r = e.error_description;
                                if (i) throw new $65283fdff51e8344$export$cf0c46b07324e9c5(i, r || i, o, t.appState);
                                if (!t.code_verifier || t.state && t.state !== o) throw new $65283fdff51e8344$export$7d465be8efa67280("state_mismatch", "Invalid state");
                                a = t.organization, s = t.nonce, c = t.redirect_uri;
                                return [
                                    4,
                                    this._requestToken(Object.assign({
                                        audience: t.audience,
                                        scope: t.scope,
                                        code_verifier: t.code_verifier,
                                        grant_type: "authorization_code",
                                        code: n
                                    }, c ? {
                                        redirect_uri: c
                                    } : {}), {
                                        nonceIn: s,
                                        organization: a
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), {
                                        appState: t.appState,
                                        response_type: $65283fdff51e8344$export$7390b1e457b4cb6f.Code
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_handleConnectAccountRedirectCallback",
            value: function _handleConnectAccountRedirectCallback(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, i, r, a;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                n = e.connect_code, o = e.state, i = e.error, r = e.error_description;
                                if (i) throw new $65283fdff51e8344$export$aaa3fc6bdea78d4d(i, r || i, t.connection, o, t.appState);
                                if (!n) throw new $65283fdff51e8344$export$7d465be8efa67280("missing_connect_code", "Missing connect code");
                                if (!(t.code_verifier && t.state && t.auth_session && t.redirect_uri && t.state === o)) throw new $65283fdff51e8344$export$7d465be8efa67280("state_mismatch", "Invalid state");
                                return [
                                    4,
                                    this.myAccount.completeAccount({
                                        auth_session: t.auth_session,
                                        connect_code: n,
                                        redirect_uri: t.redirect_uri,
                                        code_verifier: t.code_verifier
                                    })
                                ];
                            case 1:
                                a = _state.sent();
                                return [
                                    2,
                                    Object.assign(Object.assign({}, a), {
                                        appState: t.appState,
                                        response_type: $65283fdff51e8344$export$7390b1e457b4cb6f.ConnectCode
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "checkSession",
            value: function checkSession(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
                                    if (!this.cookieStorage.get($65283fdff51e8344$var$yt)) return [
                                        2
                                    ];
                                    this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                                        daysUntilExpire: this.sessionCheckExpiryDays,
                                        cookieDomain: this.options.cookieDomain
                                    }), this.cookieStorage.remove($65283fdff51e8344$var$yt);
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.getTokenSilently(e)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e1 = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getTokenSilently",
            value: function getTokenSilently() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var e, t, n, o, i;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = _arguments.length > 0 && void 0 !== _arguments[0] ? _arguments[0] : {};
                                o = Object.assign(Object.assign({
                                    cacheMode: "on"
                                }, e), {
                                    authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                                        scope: $65283fdff51e8344$var$Ne(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope, (null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.audience) || this.options.authorizationParams.audience)
                                    })
                                });
                                return [
                                    4,
                                    this._getTokenSilently(o)
                                ];
                            case 1:
                                i = _state.sent();
                                return [
                                    2,
                                    e.detailedResponse ? i : null == i ? void 0 : i.access_token
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "_getTokenSilently",
            value: function _getTokenSilently(t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _this, n, o, _$e, i, r, a, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                n = t.cacheMode, o = $65283fdff51e8344$var$e(t, [
                                    "cacheMode"
                                ]);
                                return [
                                    4,
                                    this._isSessionCeilingReached()
                                ];
                            case 1:
                                if (_state.sent()) return [
                                    2
                                ];
                                if (!("off" !== n)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._getEntryFromCache({
                                        scope: o.authorizationParams.scope,
                                        audience: o.authorizationParams.audience || $65283fdff51e8344$var$P,
                                        clientId: this.options.clientId,
                                        cacheMode: n
                                    })
                                ];
                            case 2:
                                _$e = _state.sent();
                                if (_$e) return [
                                    2,
                                    _$e
                                ];
                                _state.label = 3;
                            case 3:
                                if ("cache-only" === n) return [
                                    2
                                ];
                                i = (r = this.options.clientId, a = o.authorizationParams.audience || "default", "".concat("auth0.lock.getTokenSilently", ".").concat(r, ".").concat(a));
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    this.lockManager.runWithLock(i, 5e3, function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                            var _$e, _$e1, _$t, i, r, a, s, _tmp;
                                            return (0, $3SMYb._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (!("off" !== n)) return [
                                                            3,
                                                            2
                                                        ];
                                                        return [
                                                            4,
                                                            this._getEntryFromCache({
                                                                scope: o.authorizationParams.scope,
                                                                audience: o.authorizationParams.audience || $65283fdff51e8344$var$P,
                                                                clientId: this.options.clientId
                                                            })
                                                        ];
                                                    case 1:
                                                        _$e = _state.sent();
                                                        if (_$e) return [
                                                            2,
                                                            _$e
                                                        ];
                                                        _state.label = 2;
                                                    case 2:
                                                        if (!this.options.useRefreshTokens) return [
                                                            3,
                                                            4
                                                        ];
                                                        return [
                                                            4,
                                                            this._getTokenUsingRefreshToken(o)
                                                        ];
                                                    case 3:
                                                        _tmp = _state.sent();
                                                        return [
                                                            3,
                                                            6
                                                        ];
                                                    case 4:
                                                        return [
                                                            4,
                                                            this._getTokenFromIFrame(o)
                                                        ];
                                                    case 5:
                                                        _tmp = _state.sent();
                                                        _state.label = 6;
                                                    case 6:
                                                        _$e1 = _tmp, _$t = _$e1.id_token, i = _$e1.token_type, r = _$e1.access_token, a = _$e1.oauthTokenScope, s = _$e1.expires_in;
                                                        return [
                                                            2,
                                                            Object.assign(Object.assign({
                                                                id_token: _$t,
                                                                token_type: i,
                                                                access_token: r
                                                            }, a ? {
                                                                scope: a
                                                            } : null), {
                                                                expires_in: s
                                                            })
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    })
                                ];
                            case 5:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 6:
                                e1 = _state.sent();
                                if (!(this._isInteractiveError(e1) && "popup" === this.options.interactiveErrorHandler)) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    this._handleInteractiveErrorWithPopup(o)
                                ];
                            case 7:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 8:
                                throw e1;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_isInteractiveError",
            value: function _isInteractiveError(e) {
                return e instanceof $65283fdff51e8344$export$c59494f4dae44ada || e instanceof $65283fdff51e8344$export$7d465be8efa67280 && this._isIframeMfaError(e);
            }
        },
        {
            key: "_isIframeMfaError",
            value: function _isIframeMfaError(e) {
                return "login_required" === e.error && "Multifactor authentication required" === e.error_description;
            }
        },
        {
            key: "_handleInteractiveErrorWithPopup",
            value: function _handleInteractiveErrorWithPopup(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.loginWithPopup({
                                        authorizationParams: e.authorizationParams
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._getEntryFromCache({
                                        scope: e.authorizationParams.scope,
                                        audience: e.authorizationParams.audience || $65283fdff51e8344$var$P,
                                        clientId: this.options.clientId
                                    })
                                ];
                            case 2:
                                t = _state.sent();
                                if (!t) throw new $65283fdff51e8344$export$7d465be8efa67280("interactive_handler_cache_miss", "Token not found in cache after interactive authentication");
                                return [
                                    2,
                                    t
                                ];
                            case 3:
                                e1 = _state.sent();
                                throw e1;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getTokenWithPopup",
            value: function getTokenWithPopup() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var e, t, n, o, i;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = _arguments.length > 0 && void 0 !== _arguments[0] ? _arguments[0] : {}, t = _arguments.length > 1 && void 0 !== _arguments[1] ? _arguments[1] : {};
                                i = Object.assign(Object.assign({}, e), {
                                    authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                                        scope: $65283fdff51e8344$var$Ne(this.scope, null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.scope, (null === (o = e.authorizationParams) || void 0 === o ? void 0 : o.audience) || this.options.authorizationParams.audience)
                                    })
                                });
                                t = Object.assign(Object.assign({}, $65283fdff51e8344$var$v), t);
                                return [
                                    4,
                                    this.loginWithPopup(i, t)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this.cacheManager.get(new $65283fdff51e8344$var$ze({
                                        scope: i.authorizationParams.scope,
                                        audience: i.authorizationParams.audience || $65283fdff51e8344$var$P,
                                        clientId: this.options.clientId
                                    }), void 0, this.options.useMrrt)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent().access_token
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "isAuthenticated",
            value: function isAuthenticated() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getUser()
                                ];
                            case 1:
                                return [
                                    2,
                                    !!_state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_buildLogoutUrl",
            value: function _buildLogoutUrl(t) {
                null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
                var n = t.logoutParams || {}, o = n.federated, i = $65283fdff51e8344$var$e(n, [
                    "federated"
                ]), r = o ? "&federated" : "";
                return this._url("/v2/logout?".concat($65283fdff51e8344$var$Z(Object.assign({
                    clientId: t.clientId
                }, i)))) + r;
            }
        },
        {
            key: "revokeRefreshToken",
            value: function revokeRefreshToken() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _this, e, t, n, _tmp;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                e = _arguments.length > 0 && void 0 !== _arguments[0] ? _arguments[0] : {};
                                if (!this.options.useRefreshTokens) return [
                                    2
                                ];
                                t = e.audience || this.options.authorizationParams.audience || $65283fdff51e8344$var$P;
                                return [
                                    4,
                                    this.cacheManager.getRefreshTokensByAudience(t, this.options.clientId)
                                ];
                            case 1:
                                n = _state.sent();
                                return [
                                    4,
                                    function(e, t) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                            var n, o, i, r, a, s, c, u, l, h, _$d, p, _$e, n1, e1, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e1, _$t, n2, o1, _$e2, _$t1, f, _, e2, err;
                                            return (0, $3SMYb._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        n = e.baseUrl, o = e.timeout, i = e.auth0Client, r = e.useFormData, a = e.refreshTokens, s = e.audience, c = e.client_id, u = e.onRefreshTokenRevoked;
                                                        l = o || $65283fdff51e8344$var$b, h = "refresh_token", _$d = "".concat(n, "/oauth/revoke"), p = {
                                                            "Content-Type": r ? "application/x-www-form-urlencoded" : "application/json",
                                                            "Auth0-Client": btoa(JSON.stringify($65283fdff51e8344$var$H(i || $65283fdff51e8344$var$S)))
                                                        };
                                                        if (!t) return [
                                                            3,
                                                            4
                                                        ];
                                                        _$e = {
                                                            client_id: c,
                                                            token_type_hint: h
                                                        }, n1 = r ? $65283fdff51e8344$var$Z(_$e) : JSON.stringify(_$e);
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            $65283fdff51e8344$var$Oe({
                                                                type: "revoke",
                                                                timeout: l,
                                                                fetchUrl: _$d,
                                                                fetchOptions: {
                                                                    method: "POST",
                                                                    body: n1,
                                                                    headers: p
                                                                },
                                                                useFormData: r,
                                                                auth: {
                                                                    audience: null != s ? s : $65283fdff51e8344$var$P
                                                                }
                                                            }, t)
                                                        ];
                                                    case 2:
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                    case 3:
                                                        e1 = _state.sent();
                                                        throw new $65283fdff51e8344$export$7d465be8efa67280("revoke_error", e1.message);
                                                    case 4:
                                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                        _state.label = 5;
                                                    case 5:
                                                        _state.trys.push([
                                                            5,
                                                            16,
                                                            17,
                                                            18
                                                        ]);
                                                        _iterator = a[Symbol.iterator]();
                                                        _state.label = 6;
                                                    case 6:
                                                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                                            3,
                                                            15
                                                        ];
                                                        _$e1 = _step.value;
                                                        _$t = {
                                                            client_id: c,
                                                            token_type_hint: h,
                                                            token: _$e1
                                                        }, n2 = r ? $65283fdff51e8344$var$Z(_$t) : JSON.stringify(_$t);
                                                        return [
                                                            4,
                                                            $65283fdff51e8344$var$Ce(_$d, {
                                                                method: "POST",
                                                                body: n2,
                                                                headers: p
                                                            }, l)
                                                        ];
                                                    case 7:
                                                        o1 = _state.sent();
                                                        if (!!o1.ok) return [
                                                            3,
                                                            12
                                                        ];
                                                        _$e2 = void 0, _$t1 = void 0;
                                                        _state.label = 8;
                                                    case 8:
                                                        _state.trys.push([
                                                            8,
                                                            10,
                                                            ,
                                                            11
                                                        ]);
                                                        _ = JSON.parse;
                                                        return [
                                                            4,
                                                            o1.text()
                                                        ];
                                                    case 9:
                                                        f = _.apply(JSON, [
                                                            _state.sent()
                                                        ]);
                                                        _$e2 = f.error, _$t1 = f.error_description;
                                                        return [
                                                            3,
                                                            11
                                                        ];
                                                    case 10:
                                                        e2 = _state.sent();
                                                        return [
                                                            3,
                                                            11
                                                        ];
                                                    case 11:
                                                        throw new $65283fdff51e8344$export$7d465be8efa67280(_$e2 || "revoke_error", _$t1 || "HTTP error ".concat(o1.status));
                                                    case 12:
                                                        return [
                                                            4,
                                                            null == u ? void 0 : u(_$e1)
                                                        ];
                                                    case 13:
                                                        _state.sent();
                                                        _state.label = 14;
                                                    case 14:
                                                        _iteratorNormalCompletion = true;
                                                        return [
                                                            3,
                                                            6
                                                        ];
                                                    case 15:
                                                        return [
                                                            3,
                                                            18
                                                        ];
                                                    case 16:
                                                        err = _state.sent();
                                                        _didIteratorError = true;
                                                        _iteratorError = err;
                                                        return [
                                                            3,
                                                            18
                                                        ];
                                                    case 17:
                                                        try {
                                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                                _iterator.return();
                                                            }
                                                        } finally{
                                                            if (_didIteratorError) {
                                                                throw _iteratorError;
                                                            }
                                                        }
                                                        return [
                                                            7
                                                        ];
                                                    case 18:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        })();
                                    }({
                                        baseUrl: this.domainUrl,
                                        timeout: this.httpTimeoutMs,
                                        auth0Client: this.options.auth0Client,
                                        useFormData: this.options.useFormData,
                                        client_id: this.options.clientId,
                                        refreshTokens: n,
                                        audience: t,
                                        onRefreshTokenRevoked: function(e) {
                                            return _this.cacheManager.stripRefreshToken(e);
                                        }
                                    }, this.worker)
                                ];
                            case 2:
                                _state.sent();
                                _tmp = this.onlineAccess;
                                if (!_tmp) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this._clearLocalSession()
                                ];
                            case 3:
                                _tmp = _state.sent();
                                _state.label = 4;
                            case 4:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "logout",
            value: function logout() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, r, _tmp;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = _arguments.length > 0 && void 0 !== _arguments[0] ? _arguments[0] : {};
                                n = $65283fdff51e8344$var$vt(t), o = n.openUrl, i = $65283fdff51e8344$var$e(n, [
                                    "openUrl"
                                ]);
                                return [
                                    4,
                                    this._clearLocalSession(t.clientId)
                                ];
                            case 1:
                                _state.sent();
                                r = this._buildLogoutUrl(i);
                                if (!o) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    o(r)
                                ];
                            case 2:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _tmp = !1 !== o && window.location.assign(r);
                                _state.label = 4;
                            case 4:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "_getTokenFromIFrame",
            value: function _getTokenFromIFrame(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _this, t, n, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                t = (n = this.options.clientId, "".concat("auth0.lock.getTokenFromIFrame", ".").concat(n));
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.lockManager.runWithLock(t, 5e3, function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                            var t, n, o, i, r, a, s, c, u, l, h, _$d, p, f;
                                            return (0, $3SMYb._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        t = Object.assign(Object.assign({}, e.authorizationParams), {
                                                            prompt: "none"
                                                        }), n = this.cookieStorage.get(this.orgHintCookieName);
                                                        n && !t.organization && (t.organization = n);
                                                        return [
                                                            4,
                                                            this._prepareAuthorizeUrl(t, {
                                                                response_mode: "web_message"
                                                            }, window.location.origin)
                                                        ];
                                                    case 1:
                                                        o = _state.sent(), i = o.url, r = o.state, a = o.nonce, s = o.code_verifier, c = o.redirect_uri, u = o.scope, l = o.audience;
                                                        if (window.crossOriginIsolated) throw new $65283fdff51e8344$export$7d465be8efa67280("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
                                                        h = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds;
                                                        try {
                                                            _$d = new URL(this.domainUrl).origin;
                                                        } catch (e) {
                                                            _$d = this.domainUrl;
                                                        }
                                                        return [
                                                            4,
                                                            function(e, t) {
                                                                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 60;
                                                                return new Promise(function(o, i) {
                                                                    var r = window.document.createElement("iframe");
                                                                    r.setAttribute("width", "0"), r.setAttribute("height", "0"), r.style.display = "none";
                                                                    var a = function() {
                                                                        window.document.body.contains(r) && (window.document.body.removeChild(r), window.removeEventListener("message", s, !1));
                                                                    };
                                                                    var s;
                                                                    var c = setTimeout(function() {
                                                                        i(new $65283fdff51e8344$export$66d311bf29d5c89c), a();
                                                                    }, 1e3 * n);
                                                                    s = function(e) {
                                                                        if (e.origin != t) return;
                                                                        if (!e.data || "authorization_response" !== e.data.type) return;
                                                                        var n = e.source;
                                                                        n && n.close(), e.data.response.error ? i($65283fdff51e8344$export$7d465be8efa67280.fromPayload(e.data.response)) : o(e.data.response), clearTimeout(c), window.removeEventListener("message", s, !1), setTimeout(a, 2e3);
                                                                    }, window.addEventListener("message", s, !1), window.document.body.appendChild(r), r.setAttribute("src", e);
                                                                });
                                                            }(i, _$d, h)
                                                        ];
                                                    case 2:
                                                        p = _state.sent();
                                                        if (r !== p.state) throw new $65283fdff51e8344$export$7d465be8efa67280("state_mismatch", "Invalid state");
                                                        return [
                                                            4,
                                                            this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                                                                code_verifier: s,
                                                                code: p.code,
                                                                grant_type: "authorization_code",
                                                                redirect_uri: c,
                                                                timeout: e.authorizationParams.timeout || this.httpTimeoutMs
                                                            }), {
                                                                nonceIn: a,
                                                                organization: t.organization
                                                            })
                                                        ];
                                                    case 3:
                                                        f = _state.sent();
                                                        return [
                                                            2,
                                                            Object.assign(Object.assign({}, f), {
                                                                scope: u,
                                                                oauthTokenScope: f.scope,
                                                                audience: l
                                                            })
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                e1 = _state.sent();
                                if ("login_required" === e1.error) e1 instanceof $65283fdff51e8344$export$7d465be8efa67280 && this._isIframeMfaError(e1) && "popup" === this.options.interactiveErrorHandler || this.logout({
                                    openUrl: !1
                                });
                                throw e1;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_getTokenUsingRefreshToken",
            value: function _getTokenUsingRefreshToken(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _$t, n, o, i, u, _tmp, _$t1, t, r, a, s, c;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.cacheManager.get(new $65283fdff51e8344$var$ze({
                                        scope: e.authorizationParams.scope,
                                        audience: e.authorizationParams.audience || $65283fdff51e8344$var$P,
                                        clientId: this.options.clientId
                                    }), void 0, this.options.useMrrt)
                                ];
                            case 1:
                                _$t = _state.sent();
                                if (!!(_$t && _$t.refresh_token || this.worker)) return [
                                    3,
                                    4
                                ];
                                if (!this.options.useRefreshTokensFallback) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._getTokenFromIFrame(e)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                throw new $65283fdff51e8344$export$ac1d2a00f8e0a046(e.authorizationParams.audience || $65283fdff51e8344$var$P, e.authorizationParams.scope);
                            case 4:
                                n = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null, i = function(e, t, n, o) {
                                    var i;
                                    if (e && n && o) {
                                        if (t.audience !== n) return t.scope;
                                        var _$e = o.split(" "), r = (null === (i = t.scope) || void 0 === i ? void 0 : i.split(" ")) || [], a = r.every(function(t) {
                                            return _$e.includes(t);
                                        });
                                        return _$e.length >= r.length && a ? o : t.scope;
                                    }
                                    return t.scope;
                                }(this.options.useMrrt, e.authorizationParams, null == _$t ? void 0 : _$t.audience, null == _$t ? void 0 : _$t.scope);
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    13,
                                    ,
                                    18
                                ]);
                                return [
                                    4,
                                    this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                                        grant_type: "refresh_token",
                                        refresh_token: _$t && _$t.refresh_token,
                                        redirect_uri: n
                                    }), o && {
                                        timeout: o
                                    }), {
                                        scopesToRequest: i
                                    })
                                ];
                            case 6:
                                u = _state.sent();
                                _tmp = !this.onlineAccess && u.refresh_token && (null == _$t ? void 0 : _$t.refresh_token);
                                if (!_tmp) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    this.cacheManager.updateEntry(_$t.refresh_token, u.refresh_token, this.options.clientId, this.options.useMrrt)
                                ];
                            case 7:
                                _tmp = _state.sent();
                                _state.label = 8;
                            case 8:
                                if (!(_tmp, this.options.useMrrt)) return [
                                    3,
                                    12
                                ];
                                if (!(r = null == _$t ? void 0 : _$t.audience, a = null == _$t ? void 0 : _$t.scope, s = e.authorizationParams.audience, c = e.authorizationParams.scope, r !== s || !function(e, t) {
                                    var n = (null == t ? void 0 : t.split(" ")) || [];
                                    return ((null == e ? void 0 : e.split(" ")) || []).every(function(e) {
                                        return n.includes(e);
                                    });
                                }(c, a))) return [
                                    3,
                                    12
                                ];
                                _$t1 = $65283fdff51e8344$var$bt(i, u.scope, this.onlineAccess);
                                if (!_$t1) return [
                                    3,
                                    12
                                ];
                                if (!this.options.useRefreshTokensFallback) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    this._getTokenFromIFrame(e)
                                ];
                            case 9:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 10:
                                return [
                                    4,
                                    this.cacheManager.remove(this.options.clientId, e.authorizationParams.audience, e.authorizationParams.scope)
                                ];
                            case 11:
                                throw _state.sent(), new $65283fdff51e8344$export$1c27aeac682227b2(e.authorizationParams.audience || "default", _$t1);
                            case 12:
                                return [
                                    2,
                                    Object.assign(Object.assign({}, u), {
                                        scope: e.authorizationParams.scope,
                                        oauthTokenScope: u.scope,
                                        audience: e.authorizationParams.audience || $65283fdff51e8344$var$P
                                    })
                                ];
                            case 13:
                                t = _state.sent();
                                if (!t.message) return [
                                    3,
                                    17
                                ];
                                if (!t.message.includes("user is blocked")) return [
                                    3,
                                    15
                                ];
                                return [
                                    4,
                                    this.logout({
                                        openUrl: !1
                                    })
                                ];
                            case 14:
                                throw _state.sent(), t;
                            case 15:
                                if (!((t.message.includes("Missing Refresh Token") || t.message.includes("invalid refresh token")) && this.options.useRefreshTokensFallback)) return [
                                    3,
                                    17
                                ];
                                return [
                                    4,
                                    this._getTokenFromIFrame(e)
                                ];
                            case 16:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 17:
                                throw t;
                            case 18:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_saveEntryInCache",
            value: function _saveEntryInCache(t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, i, r, a, s;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                n = t.decodedToken.claims, o = n.session_expiry, i = n.iat;
                                if (void 0 !== o) {
                                    if ("number" != typeof o) throw new $65283fdff51e8344$export$7d465be8efa67280("invalid_token", "Invalid session_expiry: value must be a number.");
                                    if (o >= 1e10) throw new $65283fdff51e8344$export$7d465be8efa67280("invalid_token", "Invalid session_expiry: value appears to be in milliseconds; expected a Unix timestamp in seconds.");
                                    if (void 0 === i || o <= i) throw new $65283fdff51e8344$export$7d465be8efa67280("invalid_token", "Invalid session_expiry: session ceiling is before or at the token issue time.");
                                }
                                r = t.id_token, a = t.decodedToken, s = $65283fdff51e8344$var$e(t, [
                                    "id_token",
                                    "decodedToken"
                                ]);
                                this.userCache.set($65283fdff51e8344$var$Me, {
                                    id_token: r,
                                    decodedToken: a
                                });
                                return [
                                    4,
                                    this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this.cacheManager.set(s)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_clearLocalSession",
            value: function _clearLocalSession() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var e, t, _tmp, e1, e2;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = _arguments.length > 0 && void 0 !== _arguments[0] ? _arguments[0] : this.options.clientId;
                                if (!(null === e)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.cacheManager.clear()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    this.cacheManager.clear(e)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                _state.label = 4;
                            case 4:
                                _tmp, this.cookieStorage.remove(this.orgHintCookieName, {
                                    cookieDomain: this.options.cookieDomain
                                }), this.cookieStorage.remove(this.isAuthenticatedCookieName, {
                                    cookieDomain: this.options.cookieDomain
                                }), this.userCache.remove($65283fdff51e8344$var$Me);
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    null === (t = this.dpop) || void 0 === t ? void 0 : t.clear()
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                e1 = _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                if (!this.worker) return [
                                    3,
                                    12
                                ];
                                _state.label = 9;
                            case 9:
                                _state.trys.push([
                                    9,
                                    11,
                                    ,
                                    12
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$Oe({
                                        type: "clear"
                                    }, this.worker)
                                ];
                            case 10:
                                _state.sent();
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                e2 = _state.sent();
                                return [
                                    3,
                                    12
                                ];
                            case 12:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "_isSessionCeilingReached",
            value: function _isSessionCeilingReached() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var e, t, n, o, i, _tmp, r, _tmp1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                n = this.userCache.get($65283fdff51e8344$var$Me);
                                if (!(null != n)) return [
                                    3,
                                    1
                                ];
                                _tmp = n;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    this.cacheManager.getIdToken(new $65283fdff51e8344$var$ze({
                                        clientId: this.options.clientId
                                    }))
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                o = _tmp, i = null === (t = null === (e = null == o ? void 0 : o.decodedToken) || void 0 === e ? void 0 : e.claims) || void 0 === t ? void 0 : t.session_expiry;
                                if (void 0 === i) return [
                                    2,
                                    !1
                                ];
                                return [
                                    4,
                                    this.nowProvider()
                                ];
                            case 4:
                                r = _state.sent();
                                _tmp1 = Math.floor(r / 1e3) >= i - 30;
                                if (!_tmp1) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    this._clearLocalSession()
                                ];
                            case 5:
                                _tmp1 = (_state.sent(), !0);
                                _state.label = 6;
                            case 6:
                                return [
                                    2,
                                    _tmp1
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_getIdTokenFromCache",
            value: function _getIdTokenFromCache() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var e, t, n, o;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = this.options.authorizationParams.audience || $65283fdff51e8344$var$P, t = this.scope[e];
                                return [
                                    4,
                                    this.cacheManager.getIdToken(new $65283fdff51e8344$var$ze({
                                        clientId: this.options.clientId,
                                        audience: e,
                                        scope: t
                                    }))
                                ];
                            case 1:
                                n = _state.sent(), o = this.userCache.get($65283fdff51e8344$var$Me);
                                return [
                                    2,
                                    n && n.id_token === (null == o ? void 0 : o.id_token) ? o : (this.userCache.set($65283fdff51e8344$var$Me, n), n)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_getEntryFromCache",
            value: function _getEntryFromCache(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, r, _$e, t1, n1, o1, i1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = e.scope, n = e.audience, o = e.clientId, i = e.cacheMode;
                                return [
                                    4,
                                    this.cacheManager.get(new $65283fdff51e8344$var$ze({
                                        scope: t,
                                        audience: n,
                                        clientId: o
                                    }), 60, this.options.useMrrt, i)
                                ];
                            case 1:
                                r = _state.sent();
                                if (!(r && r.access_token)) return [
                                    3,
                                    3
                                ];
                                _$e = r.token_type, t1 = r.access_token, n1 = r.oauthTokenScope, o1 = r.expires_in;
                                return [
                                    4,
                                    this._getIdTokenFromCache()
                                ];
                            case 2:
                                i1 = _state.sent();
                                return [
                                    2,
                                    i1 && Object.assign(Object.assign({
                                        id_token: i1.id_token,
                                        token_type: _$e || "Bearer",
                                        access_token: t1
                                    }, n1 ? {
                                        scope: n1
                                    } : null), {
                                        expires_in: o1
                                    })
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_storeMfaContext",
            value: function _storeMfaContext(e, t, n) {
                e instanceof $65283fdff51e8344$export$c59494f4dae44ada && this.mfa.setMFAAuthDetails(e.mfa_token, t, n, e.mfa_requirements);
            }
        },
        {
            key: "_requestToken",
            value: function _requestToken(e, t) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var n, o, i, r, a, s, c, u, l, h, _$t, c1, _$e, _tmp, _$e1, _$t1, _tmp1, _tmp2, _, t1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                c = t || {}, u = c.nonceIn, l = c.organization, h = c.scopesToRequest;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    15,
                                    ,
                                    16
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$Ke(Object.assign(Object.assign({
                                        baseUrl: this.domainUrl,
                                        client_id: this.options.clientId,
                                        auth0Client: this.options.auth0Client,
                                        useFormData: this.options.useFormData,
                                        timeout: this.httpTimeoutMs,
                                        useMrrt: this.options.useMrrt,
                                        dpop: this.dpop,
                                        preserveRefreshToken: this.onlineAccess
                                    }, e), {
                                        scope: h || e.scope
                                    }), this.worker)
                                ];
                            case 2:
                                _$t = _state.sent();
                                return [
                                    4,
                                    this._verifyIdToken(_$t.id_token, u, l)
                                ];
                            case 3:
                                c1 = _state.sent();
                                if (!("authorization_code" === e.grant_type)) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    this._getIdTokenFromCache()
                                ];
                            case 4:
                                _$e = _state.sent();
                                _tmp = (null === (o = null === (n = null == _$e ? void 0 : _$e.decodedToken) || void 0 === n ? void 0 : n.claims) || void 0 === o ? void 0 : o.sub) && _$e.decodedToken.claims.sub !== c1.claims.sub;
                                if (!_tmp) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    this.cacheManager.clear(this.options.clientId)
                                ];
                            case 5:
                                _tmp = (_state.sent(), this.userCache.remove($65283fdff51e8344$var$Me));
                                _state.label = 6;
                            case 6:
                                _tmp;
                                _state.label = 7;
                            case 7:
                                if (!("authorization_code" !== e.grant_type)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    this._getIdTokenFromCache()
                                ];
                            case 8:
                                _$e1 = _state.sent(), _$t1 = null === (r = null === (i = null == _$e1 ? void 0 : _$e1.decodedToken) || void 0 === i ? void 0 : i.claims) || void 0 === r ? void 0 : r.session_expiry;
                                void 0 !== _$t1 && (c1 = Object.assign(Object.assign({}, c1), {
                                    claims: Object.assign(Object.assign({}, c1.claims), {
                                        session_expiry: _$t1
                                    })
                                }));
                                _state.label = 9;
                            case 9:
                                _tmp1 = !_$t.refresh_token && this.onlineAccess;
                                if (!_tmp1) return [
                                    3,
                                    13
                                ];
                                if (!(null !== (a = e.refresh_token) && void 0 !== a)) return [
                                    3,
                                    10
                                ];
                                _tmp2 = a;
                                return [
                                    3,
                                    12
                                ];
                            case 10:
                                _ = null;
                                return [
                                    4,
                                    this.cacheManager.get(new $65283fdff51e8344$var$ze({
                                        scope: h || e.scope,
                                        audience: e.audience || $65283fdff51e8344$var$P,
                                        clientId: this.options.clientId
                                    }), void 0, this.options.useMrrt)
                                ];
                            case 11:
                                _tmp2 = _ === (s = _state.sent()) || void 0 === s ? void 0 : s.refresh_token;
                                _state.label = 12;
                            case 12:
                                _tmp1 = _$t.refresh_token = _tmp2;
                                _state.label = 13;
                            case 13:
                                _tmp1;
                                return [
                                    4,
                                    this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, _$t), {
                                        decodedToken: c1,
                                        scope: e.scope,
                                        audience: e.audience || $65283fdff51e8344$var$P
                                    }), _$t.scope ? {
                                        oauthTokenScope: _$t.scope
                                    } : null), {
                                        client_id: this.options.clientId
                                    }))
                                ];
                            case 14:
                                return [
                                    2,
                                    (_state.sent(), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                                        daysUntilExpire: this.sessionCheckExpiryDays,
                                        cookieDomain: this.options.cookieDomain
                                    }), this._processOrgHint(l || c1.claims.org_id), Object.assign(Object.assign({}, _$t), {
                                        decodedToken: c1
                                    }))
                                ];
                            case 15:
                                t1 = _state.sent();
                                throw "authorization_code" !== e.grant_type && this._storeMfaContext(t1, h || e.scope, e.audience), t1;
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_buildTokenExchangeParams",
            value: function _buildTokenExchangeParams(e) {
                return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), {
                    grant_type: "urn:ietf:params:oauth:grant-type:token-exchange",
                    subject_token: e.subject_token,
                    subject_token_type: e.subject_token_type
                }), e.actor_token && {
                    actor_token: e.actor_token
                }), e.actor_token_type && {
                    actor_token_type: e.actor_token_type
                }), {
                    scope: $65283fdff51e8344$var$Ne(this.scope, e.scope, e.audience || this.options.authorizationParams.audience),
                    audience: e.audience || this.options.authorizationParams.audience,
                    organization: e.organization || this.options.authorizationParams.organization
                });
            }
        },
        {
            key: "loginWithCustomTokenExchange",
            value: function loginWithCustomTokenExchange(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        return [
                            2,
                            this._requestToken(this._buildTokenExchangeParams(e))
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "customTokenExchange",
            value: function customTokenExchange(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, _tmp, e1;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = this._buildTokenExchangeParams(e);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    $65283fdff51e8344$var$Ke(Object.assign(Object.assign({}, t), {
                                        baseUrl: this.domainUrl,
                                        client_id: this.options.clientId,
                                        auth0Client: this.options.auth0Client,
                                        useFormData: this.options.useFormData,
                                        timeout: this.httpTimeoutMs,
                                        dpop: this.dpop
                                    }), this.worker, !0)
                                ];
                            case 2:
                                n = _state.sent();
                                _tmp = n.id_token;
                                if (!_tmp) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this._verifyIdToken(n.id_token, void 0, e.organization)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    (_tmp, n)
                                ];
                            case 5:
                                e1 = _state.sent();
                                throw this._storeMfaContext(e1, t.scope, t.audience), e1;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "exchangeToken",
            value: function exchangeToken(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        return [
                            2,
                            this.loginWithCustomTokenExchange(e)
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "_assertDpop",
            value: function _assertDpop(e) {
                if (!e) throw new Error("`useDpop` option must be enabled before using DPoP.");
            }
        },
        {
            key: "getDpopNonce",
            value: function getDpopNonce(e) {
                return this._assertDpop(this.dpop), this.dpop.getNonce(e);
            }
        },
        {
            key: "setDpopNonce",
            value: function setDpopNonce(e, t) {
                return this._assertDpop(this.dpop), this.dpop.setNonce(e, t);
            }
        },
        {
            key: "generateDpopProof",
            value: function generateDpopProof(e) {
                return this._assertDpop(this.dpop), this.dpop.generateProof(e);
            }
        },
        {
            key: "createFetcher",
            value: function createFetcher() {
                var _this = this;
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return new $65283fdff51e8344$var$Pt(e, {
                    isDpopEnabled: function() {
                        return !!_this.options.useDpop;
                    },
                    getAccessToken: function(e) {
                        var t;
                        return _this.getTokenSilently({
                            authorizationParams: {
                                scope: null === (t = null == e ? void 0 : e.scope) || void 0 === t ? void 0 : t.join(" "),
                                audience: null == e ? void 0 : e.audience
                            },
                            detailedResponse: !0
                        });
                    },
                    getDpopNonce: function() {
                        return _this.getDpopNonce(e.dpopNonceId);
                    },
                    setDpopNonce: function(t) {
                        return _this.setDpopNonce(t, e.dpopNonceId);
                    },
                    generateDpopProof: function(e) {
                        return _this.generateDpopProof(e);
                    }
                });
            }
        },
        {
            key: "connectAccountWithRedirect",
            value: function connectAccountWithRedirect(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n, o, i, r, a, s, c, u, l, h, _$d, p, f, m, y, _tmp;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = e.openUrl, n = e.appState, o = e.connection, i = e.scopes, r = e.authorization_params, a = e.redirectUri, s = void 0 === a ? this.options.authorizationParams.redirect_uri || window.location.origin : a;
                                if (!o) throw new Error("connection is required");
                                c = $65283fdff51e8344$var$D($65283fdff51e8344$var$z()), u = $65283fdff51e8344$var$z();
                                return [
                                    4,
                                    $65283fdff51e8344$var$F(u)
                                ];
                            case 1:
                                l = _state.sent(), h = $65283fdff51e8344$var$X(l);
                                return [
                                    4,
                                    this.myAccount.connectAccount({
                                        connection: o,
                                        scopes: i,
                                        redirect_uri: s,
                                        state: c,
                                        code_challenge: h,
                                        code_challenge_method: "S256",
                                        authorization_params: r
                                    })
                                ];
                            case 2:
                                _$d = _state.sent(), p = _$d.connect_uri, f = _$d.connect_params, m = _$d.auth_session;
                                this.transactionManager.create({
                                    state: c,
                                    code_verifier: u,
                                    auth_session: m,
                                    redirect_uri: s,
                                    appState: n,
                                    connection: o,
                                    response_type: $65283fdff51e8344$export$7390b1e457b4cb6f.ConnectCode
                                });
                                y = new URL(p);
                                y.searchParams.set("ticket", f.ticket);
                                if (!t) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    t(y.toString())
                                ];
                            case 3:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _tmp = window.location.assign(y);
                                _state.label = 5;
                            case 5:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_requestTokenForPasskey",
            value: function _requestTokenForPasskey(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var t, n;
                    return (0, $3SMYb._)(this, function(_state) {
                        t = e.audience || this.options.authorizationParams.audience, n = e.organization || this.options.authorizationParams.organization;
                        return [
                            2,
                            this._requestToken(Object.assign(Object.assign(Object.assign({
                                grant_type: "urn:okta:params:oauth:grant-type:webauthn",
                                auth_session: e.authSession,
                                authn_response: e.credential
                            }, e.realm && {
                                realm: e.realm
                            }), n && {
                                organization: n
                            }), {
                                scope: $65283fdff51e8344$var$Ne(this.scope, e.scope, t),
                                audience: t
                            }))
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "_requestTokenForMfa",
            value: function _requestTokenForMfa(t, n) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var o, i;
                    return (0, $3SMYb._)(this, function(_state) {
                        o = t.mfaToken, i = $65283fdff51e8344$var$e(t, [
                            "mfaToken"
                        ]);
                        return [
                            2,
                            this._requestToken(Object.assign(Object.assign({}, i), {
                                mfa_token: o
                            }), n)
                        ];
                    });
                }).call(this);
            }
        }
    ]);
    return fc;
}();
/**
 * The initial auth state.
 */ var $65283fdff51e8344$var$initialAuthState = {
    isAuthenticated: false,
    isLoading: true,
    error: undefined,
    user: undefined
};
/**
 * @ignore
 */ var $65283fdff51e8344$var$stub = function stub() {
    throw new Error('You forgot to wrap your component in <Auth0Provider>.');
};
/**
 * @ignore
 */ var $65283fdff51e8344$export$1b5d8f0c33515521 = $65283fdff51e8344$var$__assign($65283fdff51e8344$var$__assign({}, $65283fdff51e8344$var$initialAuthState), {
    buildAuthorizeUrl: $65283fdff51e8344$var$stub,
    buildLogoutUrl: $65283fdff51e8344$var$stub,
    getAccessTokenSilently: $65283fdff51e8344$var$stub,
    getAccessTokenWithPopup: $65283fdff51e8344$var$stub,
    getIdTokenClaims: $65283fdff51e8344$var$stub,
    loginWithCustomTokenExchange: $65283fdff51e8344$var$stub,
    customTokenExchange: $65283fdff51e8344$var$stub,
    exchangeToken: $65283fdff51e8344$var$stub,
    loginWithRedirect: $65283fdff51e8344$var$stub,
    loginWithPopup: $65283fdff51e8344$var$stub,
    connectAccountWithRedirect: $65283fdff51e8344$var$stub,
    logout: $65283fdff51e8344$var$stub,
    revokeRefreshToken: $65283fdff51e8344$var$stub,
    handleRedirectCallback: $65283fdff51e8344$var$stub,
    getDpopNonce: $65283fdff51e8344$var$stub,
    setDpopNonce: $65283fdff51e8344$var$stub,
    generateDpopProof: $65283fdff51e8344$var$stub,
    createFetcher: $65283fdff51e8344$var$stub,
    getConfiguration: $65283fdff51e8344$var$stub,
    mfa: {
        getAuthenticators: $65283fdff51e8344$var$stub,
        enroll: $65283fdff51e8344$var$stub,
        challenge: $65283fdff51e8344$var$stub,
        verify: $65283fdff51e8344$var$stub,
        getEnrollmentFactors: $65283fdff51e8344$var$stub
    },
    passkey: {
        signup: $65283fdff51e8344$var$stub,
        login: $65283fdff51e8344$var$stub
    },
    myAccount: {
        getFactors: $65283fdff51e8344$var$stub,
        getAuthenticationMethods: $65283fdff51e8344$var$stub,
        getAuthenticationMethod: $65283fdff51e8344$var$stub,
        updateAuthenticationMethod: $65283fdff51e8344$var$stub,
        deleteAuthenticationMethod: $65283fdff51e8344$var$stub,
        enrollmentChallenge: $65283fdff51e8344$var$stub,
        enrollmentVerify: $65283fdff51e8344$var$stub
    }
});
/**
 * The Auth0 Context
 */ var $65283fdff51e8344$export$419e9d660c2a6030 = (0, $5s1kH.createContext)($65283fdff51e8344$export$1b5d8f0c33515521);
/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */ var $65283fdff51e8344$export$bdc0f363b754b88f = /** @class */ function(_super) {
    $65283fdff51e8344$var$__extends(OAuthError, _super);
    function OAuthError(error, error_description) {
        var _this = _super.call(this, error_description !== null && error_description !== void 0 ? error_description : error) || this;
        _this.error = error;
        _this.error_description = error_description;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, OAuthError.prototype);
        return _this;
    }
    return OAuthError;
}(Error);
var $65283fdff51e8344$var$CODE_RE = /[?&](?:connect_)?code=[^&]+/;
var $65283fdff51e8344$var$STATE_RE = /[?&]state=[^&]+/;
var $65283fdff51e8344$var$ERROR_RE = /[?&]error=[^&]+/;
var $65283fdff51e8344$var$hasAuthParams = function hasAuthParams(searchParams) {
    if (searchParams === void 0) searchParams = window.location.search;
    return ($65283fdff51e8344$var$CODE_RE.test(searchParams) || $65283fdff51e8344$var$ERROR_RE.test(searchParams)) && $65283fdff51e8344$var$STATE_RE.test(searchParams);
};
var $65283fdff51e8344$var$normalizeErrorFn = function normalizeErrorFn(fallbackMessage) {
    return function(error) {
        if (error instanceof Error) return error;
        // try to check errors of the following form: {error: string; error_description?: string}
        if (error !== null && (typeof error === "undefined" ? "undefined" : (0, $03bAP._)(error)) === 'object' && 'error' in error && typeof error.error === 'string') {
            if ('error_description' in error && typeof error.error_description === 'string') {
                var e_1 = error;
                return new $65283fdff51e8344$export$bdc0f363b754b88f(e_1.error, e_1.error_description);
            }
            var e = error;
            return new $65283fdff51e8344$export$bdc0f363b754b88f(e.error);
        }
        return new Error(fallbackMessage);
    };
};
var $65283fdff51e8344$var$loginError = $65283fdff51e8344$var$normalizeErrorFn('Login failed');
var $65283fdff51e8344$var$tokenError = $65283fdff51e8344$var$normalizeErrorFn('Get access token failed');
/**
 * @ignore
 * Helper function to map the v1 `redirectUri` option to the v2 `authorizationParams.redirect_uri`
 * and log a warning.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $65283fdff51e8344$var$deprecateRedirectUri = function deprecateRedirectUri(options) {
    var _a, _b;
    if (options === null || options === void 0 ? void 0 : options.redirectUri) {
        console.warn('Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version');
        options.authorizationParams = (_a = options.authorizationParams) !== null && _a !== void 0 ? _a : {};
        options.authorizationParams.redirect_uri = options.redirectUri;
        delete options.redirectUri;
    }
    if ((_b = options === null || options === void 0 ? void 0 : options.authorizationParams) === null || _b === void 0 ? void 0 : _b.redirectUri) {
        console.warn('Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version');
        options.authorizationParams.redirect_uri = options.authorizationParams.redirectUri;
        delete options.authorizationParams.redirectUri;
    }
};
/**
 * Handles how that state changes in the `useAuth0` hook.
 */ var $65283fdff51e8344$var$reducer = function reducer(state, action) {
    switch(action.type){
        case 'LOGIN_POPUP_STARTED':
            return $65283fdff51e8344$var$__assign($65283fdff51e8344$var$__assign({}, state), {
                isLoading: true
            });
        case 'LOGIN_POPUP_COMPLETE':
        case 'INITIALISED':
            return $65283fdff51e8344$var$__assign($65283fdff51e8344$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user,
                isLoading: false,
                error: undefined
            });
        case 'HANDLE_REDIRECT_COMPLETE':
        case 'GET_ACCESS_TOKEN_COMPLETE':
        case 'SYNC_USER':
            if (state.user === action.user) return state;
            return $65283fdff51e8344$var$__assign($65283fdff51e8344$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user
            });
        case 'LOGOUT':
            return $65283fdff51e8344$var$__assign($65283fdff51e8344$var$__assign({}, state), {
                isAuthenticated: false,
                user: undefined
            });
        case 'ERROR':
            return $65283fdff51e8344$var$__assign($65283fdff51e8344$var$__assign({}, state), {
                isLoading: false,
                error: action.error
            });
    }
};
/**
 * @ignore
 */ var $65283fdff51e8344$var$toAuth0ClientOptions = function toAuth0ClientOptions(opts) {
    $65283fdff51e8344$var$deprecateRedirectUri(opts);
    return $65283fdff51e8344$var$__assign($65283fdff51e8344$var$__assign({}, opts), {
        auth0Client: {
            name: 'auth0-react',
            version: '2.24.1'
        }
    });
};
/**
 * @ignore
 */ var $65283fdff51e8344$var$defaultOnRedirectCallback = function defaultOnRedirectCallback(appState) {
    var _a;
    window.history.replaceState({}, document.title, (_a = appState.returnTo) !== null && _a !== void 0 ? _a : window.location.pathname);
};
/**
 * @ignore
 */ var $65283fdff51e8344$var$createInitDeferred = function createInitDeferred() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = res;
        reject = rej;
    });
    // Avoid unhandled-rejection warnings when no one is consuming the promise
    // (i.e. useAuth0Suspense is not used). useAuth0Suspense attaches its own
    // handler via use().
    promise.catch(function() {
        return undefined;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};
/**
 * ```jsx
 * <Auth0Provider
 *   domain={domain}
 *   clientId={clientId}
 *   authorizationParams={{ redirect_uri: window.location.origin }}>
 *   <MyApp />
 * </Auth0Provider>
 * ```
 *
 * Provides the Auth0Context to its child components.
 *
 * The SDK is a client-only module (its published ESM and CommonJS bundles ship the
 * `'use client'` directive), so in a Next.js App Router app you can import and render
 * `Auth0Provider` directly from a Server Component such as `app/layout.tsx`.
 * Components that call hooks like `useAuth0` must still be Client Components.
 */ var $65283fdff51e8344$export$6aefaad9cc4faf3c = function Auth0Provider(opts) {
    var _a = opts, children = _a.children, skipRedirectCallback = _a.skipRedirectCallback, _b = _a.onRedirectCallback, onRedirectCallback = _b === void 0 ? $65283fdff51e8344$var$defaultOnRedirectCallback : _b, _c = _a.context, context = _c === void 0 ? $65283fdff51e8344$export$419e9d660c2a6030 : _c, providedClient = _a.client, clientOpts = $65283fdff51e8344$var$__rest(_a, [
        "children",
        "skipRedirectCallback",
        "onRedirectCallback",
        "context",
        "client"
    ]);
    if (providedClient && (clientOpts.domain || clientOpts.clientId)) console.warn("Auth0Provider: the `client` prop takes precedence over `domain`/`clientId` and other configuration options. Remove `domain`, `clientId`, and any other Auth0Client configuration props when using the `client` prop.");
    var client = (0, $5s1kH.useState)(function() {
        return providedClient !== null && providedClient !== void 0 ? providedClient : new $65283fdff51e8344$var$fc($65283fdff51e8344$var$toAuth0ClientOptions(clientOpts));
    })[0];
    var _d = (0, $5s1kH.useReducer)($65283fdff51e8344$var$reducer, $65283fdff51e8344$var$initialAuthState), state = _d[0], dispatch = _d[1];
    // In state so the init retry below can swap in a fresh, non-rejected promise.
    // Without that swap the first rejection would re-throw on every later render,
    // making Error Boundary retries useless.
    var _e = (0, $5s1kH.useState)($65283fdff51e8344$var$createInitDeferred), initDeferred = _e[0], setInitDeferred = _e[1];
    // Set only once initialization has genuinely rejected. State, not a ref, so
    // the retry effect re-evaluates when init fails *after* the app has become
    // authenticated by some other means.
    var _f = (0, $5s1kH.useState)(false), initFailed = _f[0], setInitFailed = _f[1];
    // Guards against retrying more than once: a retry that also fails would
    // otherwise re-trigger the effect for as long as the user stays signed in.
    var initRetried = (0, $5s1kH.useRef)(false);
    var didInitialise = (0, $5s1kH.useRef)(false);
    var handleError = (0, $5s1kH.useCallback)(function(error) {
        dispatch({
            type: 'ERROR',
            error: error
        });
        return error;
    }, []);
    // Settles `deferred` according to what initialization actually did, so
    // `_initPromise` never claims success that did not happen. `allowRedirect`
    // is false on a retry: the redirect callback is single-use, so a retry can
    // only re-verify the session.
    var runInit = (0, $5s1kH.useCallback)(function(deferred, allowRedirect) {
        return $65283fdff51e8344$var$__awaiter(void 0, void 0, void 0, function() {
            var user, _a, _b, appState, response_type, result, error_1, err;
            return $65283fdff51e8344$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            7,
                            ,
                            8
                        ]);
                        user = void 0;
                        if (!(allowRedirect && $65283fdff51e8344$var$hasAuthParams() && !skipRedirectCallback)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            client.handleRedirectCallback()
                        ];
                    case 1:
                        _a = _c.sent(), _b = _a.appState, appState = _b === void 0 ? {} : _b, response_type = _a.response_type, result = $65283fdff51e8344$var$__rest(_a, [
                            "appState",
                            "response_type"
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 2:
                        user = _c.sent();
                        appState.response_type = response_type;
                        if (response_type === $65283fdff51e8344$export$7390b1e457b4cb6f.ConnectCode) appState.connectedAccount = result;
                        onRedirectCallback(appState, user);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            client.checkSession()
                        ];
                    case 4:
                        _c.sent();
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 5:
                        user = _c.sent();
                        _c.label = 6;
                    case 6:
                        dispatch({
                            type: 'INITIALISED',
                            user: user
                        });
                        deferred.resolve();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        error_1 = _c.sent();
                        err = $65283fdff51e8344$var$loginError(error_1);
                        handleError(err);
                        setInitFailed(true);
                        deferred.reject(err);
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client,
        onRedirectCallback,
        skipRedirectCallback,
        handleError
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (didInitialise.current) return;
        didInitialise.current = true;
        // Always the first deferred: `didInitialise` means this only ever runs once,
        // so a later swap by the retry effect re-runs this effect but returns above.
        runInit(initDeferred, true);
    }, [
        runInit,
        initDeferred
    ]);
    // A rejected promise stays rejected forever, so React.use() would re-throw on
    // every later render and an Error Boundary retry could never recover. Once
    // init has failed but the app has since become authenticated by some other
    // means (loginWithPopup, a silent token, a passkey login), re-run the session
    // check against a fresh deferred. The promise then reflects a real
    // checkSession() outcome rather than an assumption that things are fine --
    // if the session is still bad it rejects again and the boundary keeps showing
    // the error.
    (0, $5s1kH.useEffect)(function() {
        if (!initFailed || initRetried.current || !state.isAuthenticated) return;
        initRetried.current = true;
        var retry = $65283fdff51e8344$var$createInitDeferred();
        setInitDeferred(retry);
        runInit(retry, false);
    }, [
        initFailed,
        state.isAuthenticated,
        runInit
    ]);
    var loginWithRedirect = (0, $5s1kH.useCallback)(function(opts) {
        $65283fdff51e8344$var$deprecateRedirectUri(opts);
        return client.loginWithRedirect(opts);
    }, [
        client
    ]);
    var loginWithPopup = (0, $5s1kH.useCallback)(function(options, config) {
        return $65283fdff51e8344$var$__awaiter(void 0, void 0, void 0, function() {
            var error_2, user;
            return $65283fdff51e8344$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dispatch({
                            type: 'LOGIN_POPUP_STARTED'
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.loginWithPopup(options, config)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        handleError($65283fdff51e8344$var$loginError(error_2));
                        return [
                            2 /*return*/ 
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 5:
                        user = _a.sent();
                        dispatch({
                            type: 'LOGIN_POPUP_COMPLETE',
                            user: user
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client,
        handleError
    ]);
    var logout = (0, $5s1kH.useCallback)(function() {
        var args_1 = [];
        for(var _i = 0; _i < arguments.length; _i++)args_1[_i] = arguments[_i];
        return $65283fdff51e8344$var$__awaiter(void 0, $65283fdff51e8344$var$__spreadArray([], args_1, true), void 0, function(opts) {
            if (opts === void 0) opts = {};
            return $65283fdff51e8344$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            client.logout(opts)
                        ];
                    case 1:
                        _a.sent();
                        if (opts.openUrl || opts.openUrl === false) dispatch({
                            type: 'LOGOUT'
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var revokeRefreshToken = (0, $5s1kH.useCallback)(function(opts) {
        return $65283fdff51e8344$var$__awaiter(void 0, void 0, void 0, function() {
            var _a;
            var _b;
            return $65283fdff51e8344$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            ,
                            2,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.revokeRefreshToken(opts)
                        ];
                    case 1:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        // Online mode clears the entire local session as part of revocation; offline
                        // mode leaves the cached access token/user untouched. Re-reading the user from
                        // the client after either case keeps isAuthenticated/user consistent with
                        // whatever the SDK actually did, without assuming which mode is active. If
                        // revocation fails, nothing was actually revoked, so this re-read simply
                        // reflects the unchanged cached user/session.
                        _a = dispatch;
                        _b = {
                            type: 'SYNC_USER'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 3:
                        // Online mode clears the entire local session as part of revocation; offline
                        // mode leaves the cached access token/user untouched. Re-reading the user from
                        // the client after either case keeps isAuthenticated/user consistent with
                        // whatever the SDK actually did, without assuming which mode is active. If
                        // revocation fails, nothing was actually revoked, so this re-read simply
                        // reflects the unchanged cached user/session.
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenSilently = (0, $5s1kH.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(opts) {
        return $65283fdff51e8344$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_3, _a;
            var _b;
            return $65283fdff51e8344$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenSilently(opts)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_3 = _c.sent();
                        throw $65283fdff51e8344$var$tokenError(error_3);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenWithPopup = (0, $5s1kH.useCallback)(function(opts, config) {
        return $65283fdff51e8344$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_4, _a;
            var _b;
            return $65283fdff51e8344$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenWithPopup(opts, config)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_4 = _c.sent();
                        throw $65283fdff51e8344$var$tokenError(error_4);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var connectAccountWithRedirect = (0, $5s1kH.useCallback)(function(options) {
        return client.connectAccountWithRedirect(options);
    }, [
        client
    ]);
    var getIdTokenClaims = (0, $5s1kH.useCallback)(function() {
        return client.getIdTokenClaims();
    }, [
        client
    ]);
    var loginWithCustomTokenExchange = (0, $5s1kH.useCallback)(function(options) {
        return $65283fdff51e8344$var$__awaiter(void 0, void 0, void 0, function() {
            var tokenResponse, error_5, _a;
            var _b;
            return $65283fdff51e8344$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.loginWithCustomTokenExchange(options)
                        ];
                    case 1:
                        tokenResponse = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_5 = _c.sent();
                        throw $65283fdff51e8344$var$tokenError(error_5);
                    case 3:
                        // We dispatch the standard GET_ACCESS_TOKEN_COMPLETE action here to maintain
                        // backward compatibility and consistency with the getAccessTokenSilently flow.
                        // This ensures the SDK's internal state lifecycle (loading/user updates) remains
                        // identical regardless of whether the token was retrieved via silent auth or CTE.
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        // We dispatch the standard GET_ACCESS_TOKEN_COMPLETE action here to maintain
                        // backward compatibility and consistency with the getAccessTokenSilently flow.
                        // This ensures the SDK's internal state lifecycle (loading/user updates) remains
                        // identical regardless of whether the token was retrieved via silent auth or CTE.
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            tokenResponse
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var customTokenExchange = (0, $5s1kH.useCallback)(function(options) {
        return client.customTokenExchange(options);
    }, [
        client
    ]);
    var exchangeToken = (0, $5s1kH.useCallback)(function(options) {
        return $65283fdff51e8344$var$__awaiter(void 0, void 0, void 0, function() {
            return $65283fdff51e8344$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    loginWithCustomTokenExchange(options)
                ];
            });
        });
    }, [
        loginWithCustomTokenExchange
    ]);
    var handleRedirectCallback = (0, $5s1kH.useCallback)(function(url) {
        return $65283fdff51e8344$var$__awaiter(void 0, void 0, void 0, function() {
            var error_6, _a;
            var _b;
            return $65283fdff51e8344$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.handleRedirectCallback(url)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 2:
                        error_6 = _c.sent();
                        throw $65283fdff51e8344$var$tokenError(error_6);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'HANDLE_REDIRECT_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getDpopNonce = (0, $5s1kH.useCallback)(function(id) {
        return client.getDpopNonce(id);
    }, [
        client
    ]);
    var setDpopNonce = (0, $5s1kH.useCallback)(function(nonce, id) {
        return client.setDpopNonce(nonce, id);
    }, [
        client
    ]);
    var generateDpopProof = (0, $5s1kH.useCallback)(function(params) {
        return client.generateDpopProof(params);
    }, [
        client
    ]);
    var createFetcher = (0, $5s1kH.useCallback)(function(config) {
        return client.createFetcher(config);
    }, [
        client
    ]);
    var getConfiguration = (0, $5s1kH.useCallback)(function() {
        return client.getConfiguration();
    }, [
        client
    ]);
    var mfa = (0, $5s1kH.useMemo)(function() {
        return client.mfa;
    }, [
        client
    ]);
    var myAccount = (0, $5s1kH.useMemo)(function() {
        return client.myAccount;
    }, [
        client
    ]);
    var passkeySignup = (0, $5s1kH.useCallback)(function(options) {
        return $65283fdff51e8344$var$__awaiter(void 0, void 0, void 0, function() {
            var tokenResponse, error_7, _a;
            var _b;
            return $65283fdff51e8344$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.passkey.signup(options)
                        ];
                    case 1:
                        tokenResponse = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_7 = _c.sent();
                        throw $65283fdff51e8344$var$tokenError(error_7);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            tokenResponse
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var passkeyLogin = (0, $5s1kH.useCallback)(function(options) {
        return $65283fdff51e8344$var$__awaiter(void 0, void 0, void 0, function() {
            var tokenResponse, error_8, _a;
            var _b;
            return $65283fdff51e8344$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.passkey.login(options)
                        ];
                    case 1:
                        tokenResponse = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_8 = _c.sent();
                        throw $65283fdff51e8344$var$tokenError(error_8);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            tokenResponse
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var passkey = (0, $5s1kH.useMemo)(function() {
        return {
            signup: passkeySignup,
            login: passkeyLogin
        };
    }, [
        passkeySignup,
        passkeyLogin
    ]);
    var contextValue = (0, $5s1kH.useMemo)(function() {
        return $65283fdff51e8344$var$__assign($65283fdff51e8344$var$__assign({}, state), {
            getAccessTokenSilently: getAccessTokenSilently,
            getAccessTokenWithPopup: getAccessTokenWithPopup,
            getIdTokenClaims: getIdTokenClaims,
            loginWithCustomTokenExchange: loginWithCustomTokenExchange,
            customTokenExchange: customTokenExchange,
            exchangeToken: exchangeToken,
            loginWithRedirect: loginWithRedirect,
            loginWithPopup: loginWithPopup,
            connectAccountWithRedirect: connectAccountWithRedirect,
            logout: logout,
            revokeRefreshToken: revokeRefreshToken,
            handleRedirectCallback: handleRedirectCallback,
            getDpopNonce: getDpopNonce,
            setDpopNonce: setDpopNonce,
            generateDpopProof: generateDpopProof,
            createFetcher: createFetcher,
            getConfiguration: getConfiguration,
            mfa: mfa,
            passkey: passkey,
            myAccount: myAccount,
            _initPromise: initDeferred.promise
        });
    }, [
        state,
        getAccessTokenSilently,
        getAccessTokenWithPopup,
        getIdTokenClaims,
        loginWithCustomTokenExchange,
        customTokenExchange,
        exchangeToken,
        loginWithRedirect,
        loginWithPopup,
        connectAccountWithRedirect,
        logout,
        revokeRefreshToken,
        handleRedirectCallback,
        getDpopNonce,
        setDpopNonce,
        generateDpopProof,
        createFetcher,
        getConfiguration,
        mfa,
        passkey,
        myAccount,
        initDeferred
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(context.Provider, {
        value: contextValue
    }, children);
};
/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getAccessTokenWithPopup,
 *   getIdTokenClaims,
 *   loginWithCustomTokenExchange,
 *   exchangeToken, // deprecated - use loginWithCustomTokenExchange
 *   loginWithRedirect,
 *   loginWithPopup,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */ var $65283fdff51e8344$export$f2b63d3ca66bb884 = function useAuth0(context) {
    if (context === void 0) context = $65283fdff51e8344$export$419e9d660c2a6030;
    return (0, $5s1kH.useContext)(context);
};
/**
 * ```jsx
 * <Suspense fallback={<Spinner />}>
 *   <Profile />
 * </Suspense>
 *
 * function Profile() {
 *   const { user, isAuthenticated } = useAuth0Suspense();
 *   return isAuthenticated ? <p>Hello {user.name}</p> : <p>Please log in</p>;
 * }
 * ```
 *
 * Suspense-enabled variant of `useAuth0`. Suspends the component until Auth0
 * initialization completes (letting the nearest `<Suspense>` fallback render),
 * and throws initialization errors so the nearest Error Boundary can handle
 * them. Requires React 19 or later.
 *
 * If initialization fails and the app later becomes authenticated by other
 * means, the session is re-checked once; retrying the Error Boundary then
 * renders if that check succeeded, or throws again if it did not.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */ var $65283fdff51e8344$export$b54a91a1d0e2f687 = function useAuth0Suspense(context) {
    if (context === void 0) context = $65283fdff51e8344$export$419e9d660c2a6030;
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).use !== 'function') throw new Error('useAuth0Suspense requires React 19 or later (React.use is unavailable).');
    var ctx = (0, $5s1kH.useContext)(context);
    if (!ctx._initPromise) throw new Error('useAuth0Suspense must be used within an <Auth0Provider>.');
    // Suspends until the init promise resolves; re-throws if it rejected.
    (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).use(ctx._initPromise);
    // Memoized so the returned object is referentially stable across renders,
    // matching useAuth0, which hands back the provider's memoized context.
    // Without this, `useEffect(..., [auth])` in a consumer re-runs every render.
    return (0, $5s1kH.useMemo)(function() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ctx.isLoading;
        ctx._initPromise;
        var rest = $65283fdff51e8344$var$__rest(ctx, [
            "isLoading",
            "_initPromise"
        ]);
        return rest;
    }, [
        ctx
    ]);
};
/**
 * ```jsx
 * class MyComponent extends Component {
 *   render() {
 *     // Access the auth context from the `auth0` prop
 *     const { user } = this.props.auth0;
 *     return <div>Hello {user.name}!</div>
 *   }
 * }
 * // Wrap your class component in withAuth0
 * export default withAuth0(MyComponent);
 * ```
 *
 * Wrap your class components in this Higher Order Component to give them access to the Auth0Context.
 *
 * Providing a context as the second argument allows you to configure the Auth0Provider the Auth0Context
 * should come from f you have multiple within your application.
 */ var $65283fdff51e8344$export$bf0b363fae22b33f = function withAuth0(Component, context) {
    if (context === void 0) context = $65283fdff51e8344$export$419e9d660c2a6030;
    return function WithAuth(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(context.Consumer, null, function(auth) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(Component, $65283fdff51e8344$var$__assign({}, props, {
                auth0: auth
            }));
        });
    };
};
/**
 * @ignore
 */ var $65283fdff51e8344$var$defaultOnRedirecting = function defaultOnRedirecting() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Fragment, null);
};
/**
* @ignore
*/ var $65283fdff51e8344$var$defaultOnBeforeAuthentication = function defaultOnBeforeAuthentication() {
    return $65283fdff51e8344$var$__awaiter(void 0, void 0, void 0, function() {
        return $65283fdff51e8344$var$__generator(this, function(_a) {
            return [
                2 /*return*/ 
            ];
        });
    });
};
/**
 * @ignore
 */ var $65283fdff51e8344$var$defaultReturnTo = function defaultReturnTo() {
    // Normalize the pathname to prevent protocol-relative open redirects.
    // A URL like https://app.example.com//evil.com produces a pathname of
    // //evil.com, which routers (react-router, next.js, gatsby) interpret as a
    // protocol-relative URL and redirect the user to an external host.
    var pathname = window.location.pathname.replace(/^\/\/+/, '/');
    return "".concat(pathname).concat(window.location.search);
};
/**
 * ```js
 * const MyProtectedComponent = withAuthenticationRequired(MyComponent);
 * ```
 *
 * When you wrap your components in this Higher Order Component and an anonymous user visits your component
 * they will be redirected to the login page; after login they will be returned to the page they were redirected from.
 */ var $65283fdff51e8344$export$2cfd0b285ff12c70 = function withAuthenticationRequired(Component, options) {
    if (options === void 0) options = {};
    return function WithAuthenticationRequired(props) {
        var _this = this;
        var _a = options.returnTo, returnTo = _a === void 0 ? $65283fdff51e8344$var$defaultReturnTo : _a, _b = options.onRedirecting, onRedirecting = _b === void 0 ? $65283fdff51e8344$var$defaultOnRedirecting : _b, _c = options.onBeforeAuthentication, onBeforeAuthentication = _c === void 0 ? $65283fdff51e8344$var$defaultOnBeforeAuthentication : _c, loginOptions = options.loginOptions, _d = options.context, context = _d === void 0 ? $65283fdff51e8344$export$419e9d660c2a6030 : _d;
        var _e = $65283fdff51e8344$export$f2b63d3ca66bb884(context), isAuthenticated = _e.isAuthenticated, isLoading = _e.isLoading, loginWithRedirect = _e.loginWithRedirect;
        (0, $5s1kH.useEffect)(function() {
            if (isLoading || isAuthenticated) return;
            var opts = $65283fdff51e8344$var$__assign($65283fdff51e8344$var$__assign({}, loginOptions), {
                appState: $65283fdff51e8344$var$__assign($65283fdff51e8344$var$__assign({}, loginOptions === null || loginOptions === void 0 ? void 0 : loginOptions.appState), {
                    returnTo: typeof returnTo === 'function' ? returnTo() : returnTo
                })
            });
            (function() {
                return $65283fdff51e8344$var$__awaiter(_this, void 0, void 0, function() {
                    return $65283fdff51e8344$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    onBeforeAuthentication()
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    loginWithRedirect(opts)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
        }, [
            isLoading,
            isAuthenticated,
            loginWithRedirect,
            onBeforeAuthentication,
            loginOptions,
            returnTo
        ]);
        return isAuthenticated ? (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(Component, $65283fdff51e8344$var$__assign({}, props)) : onRedirecting();
    };
};



var $6iP9u = parcelRequire("6iP9u");


var $bHX26 = parcelRequire("bHX26");

var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");
/**
 * @import {Element, Nodes, Parents, Root} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {ComponentType, JSX, ReactElement, ReactNode} from 'react'
 * @import {Options as RemarkRehypeOptions} from 'remark-rehype'
 * @import {BuildVisitor} from 'unist-util-visit'
 * @import {PluggableList, Processor} from 'unified'
 */ /**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 */ /**
 * @typedef ExtraProps
 *   Extra fields we pass.
 * @property {Element | undefined} [node]
 *   passed when `passNode` is on.
 */ /**
 * @typedef {{
 *   [Key in keyof JSX.IntrinsicElements]?: ComponentType<JSX.IntrinsicElements[Key] & ExtraProps> | keyof JSX.IntrinsicElements
 * }} Components
 *   Map tag names to components.
 */ /**
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 */ /**
 * @typedef HooksOptionsOnly
 *   Configuration specifically for {@linkcode MarkdownHooks}.
 * @property {ReactNode | null | undefined} [fallback]
 *   Content to render while the processor processing the markdown (optional).
 */ /**
 * @typedef {Options & HooksOptionsOnly} HooksOptions
 *   Configuration for {@linkcode MarkdownHooks};
 *   extends the regular {@linkcode Options} with a `fallback` prop.
 */ /**
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */ 
var $lFIaz = parcelRequire("lFIaz");

var $hwO3w = parcelRequire("hwO3w");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");

var $3SMYb = parcelRequire("3SMYb");
function $337acd4a17e06e51$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $337acd4a17e06e51$export$411ce8e5a71e3069() {}
function $337acd4a17e06e51$export$dcb8b3f0e2de7e49() {}
function $337acd4a17e06e51$export$565e9d9bd6b6e0d4() {}


/**
 * @import {Identifier, Literal, MemberExpression} from 'estree'
 * @import {Jsx, JsxDev, Options, Props} from 'hast-util-to-jsx-runtime'
 * @import {Element, Nodes, Parents, Root, Text} from 'hast'
 * @import {MdxFlowExpressionHast, MdxTextExpressionHast} from 'mdast-util-mdx-expression'
 * @import {MdxJsxFlowElementHast, MdxJsxTextElementHast} from 'mdast-util-mdx-jsx'
 * @import {MdxjsEsmHast} from 'mdast-util-mdxjs-esm'
 * @import {Position} from 'unist'
 * @import {Child, Create, Field, JsxElement, State, Style} from './types.js'
 */ 
var $6iP9u = parcelRequire("6iP9u");

var $03bAP = parcelRequire("03bAP");
/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ 
var $XnYkK = parcelRequire("XnYkK");
function $ad832704b9aa784d$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ var tokens = [];
    var input = String(value || '');
    var index = input.indexOf(',');
    var start = 0;
    /** @type {boolean} */ var end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        var token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $ad832704b9aa784d$export$fac44ee5b035f737(values, options) {
    var settings = options || {};
    // Ensure the last empty entry is seen.
    var input = values[values.length - 1] === '' ? (0, $XnYkK._)(values).concat([
        ''
    ]) : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}



/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [jsx=false]
 *   Support JSX identifiers (default: `false`).
 */ var $89a18ef316964ee8$var$startRe = RegExp("[$_\\p{ID_Start}]", "u");
var $89a18ef316964ee8$var$contRe = RegExp("[$_\\u{200C}\\u{200D}\\p{ID_Continue}]", "u");
var $89a18ef316964ee8$var$contReJsx = RegExp("[-$_\\u{200C}\\u{200D}\\p{ID_Continue}]", "u");
var $89a18ef316964ee8$var$nameRe = RegExp("^[$_\\p{ID_Start}][$_\\u{200C}\\u{200D}\\p{ID_Continue}]*$", "u");
var $89a18ef316964ee8$var$nameReJsx = RegExp("^[$_\\p{ID_Start}][-$_\\u{200C}\\u{200D}\\p{ID_Continue}]*$", "u");
/** @type {Options} */ var $89a18ef316964ee8$var$emptyOptions = {};
function $89a18ef316964ee8$export$b3571188c770cc5a(code) {
    return code ? $89a18ef316964ee8$var$startRe.test(String.fromCodePoint(code)) : false;
}
function $89a18ef316964ee8$export$10eb6dc47bf009dc(code, options) {
    var settings = options || $89a18ef316964ee8$var$emptyOptions;
    var re = settings.jsx ? $89a18ef316964ee8$var$contReJsx : $89a18ef316964ee8$var$contRe;
    return code ? re.test(String.fromCodePoint(code)) : false;
}
function $89a18ef316964ee8$export$a8ff84c12d48cfa6(name, options) {
    var settings = options || $89a18ef316964ee8$var$emptyOptions;
    var re = settings.jsx ? $89a18ef316964ee8$var$nameReJsx : $89a18ef316964ee8$var$nameRe;
    return re.test(name);
}


/**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.

var $03bAP = parcelRequire("03bAP");
var $950244851cb924f8$var$re = /[ \t\n\f\r]/g;
function $950244851cb924f8$export$7af1228ff777d175(thing) {
    return (typeof thing === "undefined" ? "undefined" : (0, $03bAP._)(thing)) === 'object' ? thing.type === 'text' ? $950244851cb924f8$var$empty(thing.value) : false : $950244851cb924f8$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $950244851cb924f8$var$empty(value) {
    return value.replace($950244851cb924f8$var$re, '') === '';
}


/**
 * @import {Schema} from 'property-information'
 */ /**
 * @import {Space} from 'property-information'
 */ 
var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $4QAx6 = parcelRequire("4QAx6");
/**
 * @import {Info as InfoType} from 'property-information'
 */ /** @type {InfoType} */ 
var $5Epmf = parcelRequire("5Epmf");
var $36afd10190ae99b1$export$c4868e4a24d48fad = function Info(property, attribute) {
    "use strict";
    (0, $5Epmf._)(this, Info);
    this.attribute = attribute;
    this.property = property;
};
$36afd10190ae99b1$export$c4868e4a24d48fad.prototype.attribute = '';
$36afd10190ae99b1$export$c4868e4a24d48fad.prototype.booleanish = false;
$36afd10190ae99b1$export$c4868e4a24d48fad.prototype.boolean = false;
$36afd10190ae99b1$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$36afd10190ae99b1$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$36afd10190ae99b1$export$c4868e4a24d48fad.prototype.defined = false;
$36afd10190ae99b1$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$36afd10190ae99b1$export$c4868e4a24d48fad.prototype.number = false;
$36afd10190ae99b1$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$36afd10190ae99b1$export$c4868e4a24d48fad.prototype.property = '';
$36afd10190ae99b1$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$36afd10190ae99b1$export$c4868e4a24d48fad.prototype.space = undefined;


var $0c54fe245f0ec39c$exports = {};

$parcel$export($0c54fe245f0ec39c$exports, "boolean", function () { return $0c54fe245f0ec39c$export$4a21f16c33752377; });
$parcel$export($0c54fe245f0ec39c$exports, "booleanish", function () { return $0c54fe245f0ec39c$export$55e9e1fbc638dc8f; });
$parcel$export($0c54fe245f0ec39c$exports, "overloadedBoolean", function () { return $0c54fe245f0ec39c$export$242ac3d3042558aa; });
$parcel$export($0c54fe245f0ec39c$exports, "number", function () { return $0c54fe245f0ec39c$export$98e628dec113755e; });
$parcel$export($0c54fe245f0ec39c$exports, "spaceSeparated", function () { return $0c54fe245f0ec39c$export$ab8645c862eb5a3e; });
$parcel$export($0c54fe245f0ec39c$exports, "commaSeparated", function () { return $0c54fe245f0ec39c$export$9c8d678629b3d3; });
$parcel$export($0c54fe245f0ec39c$exports, "commaOrSpaceSeparated", function () { return $0c54fe245f0ec39c$export$2ad25cfebf36cacd; });
var $0c54fe245f0ec39c$var$powers = 0;
var $0c54fe245f0ec39c$export$4a21f16c33752377 = $0c54fe245f0ec39c$var$increment();
var $0c54fe245f0ec39c$export$55e9e1fbc638dc8f = $0c54fe245f0ec39c$var$increment();
var $0c54fe245f0ec39c$export$242ac3d3042558aa = $0c54fe245f0ec39c$var$increment();
var $0c54fe245f0ec39c$export$98e628dec113755e = $0c54fe245f0ec39c$var$increment();
var $0c54fe245f0ec39c$export$ab8645c862eb5a3e = $0c54fe245f0ec39c$var$increment();
var $0c54fe245f0ec39c$export$9c8d678629b3d3 = $0c54fe245f0ec39c$var$increment();
var $0c54fe245f0ec39c$export$2ad25cfebf36cacd = $0c54fe245f0ec39c$var$increment();
function $0c54fe245f0ec39c$var$increment() {
    return Math.pow(2, ++$0c54fe245f0ec39c$var$powers);
}


var $b8f05b77e7a27dfd$var$checks = /** @type {ReadonlyArray<keyof typeof types>} */ Object.keys($0c54fe245f0ec39c$exports);
var $b8f05b77e7a27dfd$export$ea6b9f0064e88c9b = /*#__PURE__*/ function(Info) {
    "use strict";
    (0, $4QAx6._)(DefinedInfo, Info);
    function DefinedInfo(property, attribute, mask, space) {
        (0, $5Epmf._)(this, DefinedInfo);
        var _this;
        var index = -1;
        _this = (0, $48Z0s._)(this, DefinedInfo, [
            property,
            attribute
        ]);
        $b8f05b77e7a27dfd$var$mark(_this, 'space', space);
        if (typeof mask === 'number') while(++index < $b8f05b77e7a27dfd$var$checks.length){
            var check = $b8f05b77e7a27dfd$var$checks[index];
            $b8f05b77e7a27dfd$var$mark(_this, $b8f05b77e7a27dfd$var$checks[index], (mask & $0c54fe245f0ec39c$exports[check]) === $0c54fe245f0ec39c$exports[check]);
        }
        return _this;
    }
    return DefinedInfo;
}((0, $36afd10190ae99b1$export$c4868e4a24d48fad));
$b8f05b77e7a27dfd$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */ function $b8f05b77e7a27dfd$var$mark(values, key, value) {
    if (value) values[key] = value;
}



/**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */ function $c050e76183114b29$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


var $0f0aeb1e45bf3041$var$cap = /[A-Z]/g;
var $0f0aeb1e45bf3041$var$dash = /-[a-z]/g;
var $0f0aeb1e45bf3041$var$valid = /^data[-\w.:]+$/i;
function $0f0aeb1e45bf3041$export$71aa6c912b956294(schema, value) {
    var normal = (0, $c050e76183114b29$export$a3295358bff77e)(value);
    var property = value;
    var Type = (0, $36afd10190ae99b1$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $0f0aeb1e45bf3041$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            var rest = value.slice(5).replace($0f0aeb1e45bf3041$var$dash, $0f0aeb1e45bf3041$var$camelcase);
            property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            var rest1 = value.slice(4);
            if (!$0f0aeb1e45bf3041$var$dash.test(rest1)) {
                var dashes = rest1.replace($0f0aeb1e45bf3041$var$cap, $0f0aeb1e45bf3041$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $b8f05b77e7a27dfd$export$ea6b9f0064e88c9b);
    }
    return new Type(property, value);
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */ function $0f0aeb1e45bf3041$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */ function $0f0aeb1e45bf3041$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

/**
 * Special cases for React (`Record<string, string>`).
 *
 * `hast` is close to `React` but differs in a couple of cases.
 * To get a React property from a hast property,
 * check if it is in `hastToReact`.
 * If it is, use the corresponding value;
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ var $2bf51d23557d0fc5$export$d8abd7e5fb6871f9 = {
    classId: 'classID',
    dataType: 'datatype',
    itemId: 'itemID',
    strokeDashArray: 'strokeDasharray',
    strokeDashOffset: 'strokeDashoffset',
    strokeLineCap: 'strokeLinecap',
    strokeLineJoin: 'strokeLinejoin',
    strokeMiterLimit: 'strokeMiterlimit',
    typeOf: 'typeof',
    xLinkActuate: 'xlinkActuate',
    xLinkArcRole: 'xlinkArcrole',
    xLinkHref: 'xlinkHref',
    xLinkRole: 'xlinkRole',
    xLinkShow: 'xlinkShow',
    xLinkTitle: 'xlinkTitle',
    xLinkType: 'xlinkType',
    xmlnsXLink: 'xmlnsXlink'
};

// Note: types exposed from `index.d.ts`.
/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */ /** @type {SchemaType} */ 
var $5Epmf = parcelRequire("5Epmf");
var $c39440d7dcf199be$export$19342e026b58ebb7 = function Schema(property, normal, space) {
    "use strict";
    (0, $5Epmf._)(this, Schema);
    this.normal = normal;
    this.property = property;
    if (space) this.space = space;
};
$c39440d7dcf199be$export$19342e026b58ebb7.prototype.normal = {};
$c39440d7dcf199be$export$19342e026b58ebb7.prototype.property = {};
$c39440d7dcf199be$export$19342e026b58ebb7.prototype.space = undefined;


function $343b9ca4f4f14919$export$4950aa0f605343fb(definitions, space) {
    /** @type {Record<string, Info>} */ var property = {};
    /** @type {Record<string, string>} */ var normal = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = definitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var definition = _step.value;
            Object.assign(property, definition.property);
            Object.assign(normal, definition.normal);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return new (0, $c39440d7dcf199be$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @typedef Definition
 *   Definition of a schema.
 * @property {Record<string, string> | undefined} [attributes]
 *   Normalzed names to special attribute case.
 * @property {ReadonlyArray<string> | undefined} [mustUseProperty]
 *   Normalized names that must be set as properties.
 * @property {Record<string, number | null>} properties
 *   Property names to their types.
 * @property {Space | undefined} [space]
 *   Space.
 * @property {Transform} transform
 *   Transform a property name.
 */ /**
 * @callback Transform
 *   Transform.
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Attribute.
 */ 
var $6iP9u = parcelRequire("6iP9u");



function $86ee6f6475bc9e21$export$185802fd694ee1f5(definition) {
    /** @type {Record<string, Info>} */ var properties = {};
    /** @type {Record<string, string>} */ var normals = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(definition.properties)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6iP9u._)(_step.value, 2), property = _step_value[0], value = _step_value[1];
            var info = new (0, $b8f05b77e7a27dfd$export$ea6b9f0064e88c9b)(property, definition.transform(definition.attributes || {}, property), value, definition.space);
            if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) info.mustUseProperty = true;
            properties[property] = info;
            normals[(0, $c050e76183114b29$export$a3295358bff77e)(property)] = property;
            normals[(0, $c050e76183114b29$export$a3295358bff77e)(info.attribute)] = property;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return new (0, $c39440d7dcf199be$export$19342e026b58ebb7)(properties, normals, definition.space);
}



var $cdf2ec2feb79803e$export$4d2d26490572750a = (0, $86ee6f6475bc9e21$export$185802fd694ee1f5)({
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        ariaColIndex: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        ariaColSpan: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        ariaControls: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        ariaLevel: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        ariaPressed: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        ariaRowIndex: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        ariaRowSpan: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        ariaSelected: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        ariaValueMin: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        ariaValueNow: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    },
    transform: function(_, property) {
        return property === 'role' ? property : 'aria-' + property.slice(4).toLowerCase();
    }
});


/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */ function $4784d94d36757732$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $af37ad71c184dc16$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $4784d94d36757732$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}




var $18cf78d6cc25a1ed$export$c0bb0b647f701bb5 = (0, $86ee6f6475bc9e21$export$185802fd694ee1f5)({
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $0c54fe245f0ec39c$export$9c8d678629b3d3),
        acceptCharset: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        accessKey: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        allowPaymentRequest: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        allowUserMedia: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        alpha: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        autoFocus: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        autoPlay: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        blocking: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        cite: null,
        className: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        closedBy: null,
        colorSpace: null,
        cols: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        colSpan: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        command: null,
        commandFor: null,
        content: null,
        contentEditable: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        controls: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        controlsList: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        coords: (0, $0c54fe245f0ec39c$export$98e628dec113755e) | (0, $0c54fe245f0ec39c$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        defer: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        download: (0, $0c54fe245f0ec39c$export$242ac3d3042558aa),
        draggable: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        height: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        hidden: (0, $0c54fe245f0ec39c$export$242ac3d3042558aa),
        high: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        httpEquiv: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        itemRef: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        itemScope: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        itemType: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        low: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        multiple: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        muted: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        noValidate: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        optimum: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        pattern: null,
        ping: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        required: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        reversed: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        rows: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        rowSpan: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        sandbox: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        seamless: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        selected: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        shadowRootClonable: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        shadowRootCustomElementRegistry: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        shadowRootMode: null,
        shadowRootSerializable: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        shape: null,
        size: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        spellCheck: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        useMap: null,
        value: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        width: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        declare: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        leftMargin: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        marginWidth: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        noResize: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        noHref: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        noShade: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        noWrap: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $0c54fe245f0ec39c$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        credentialless: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        disablePictureInPicture: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        disableRemotePlayback: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        exportParts: (0, $0c54fe245f0ec39c$export$9c8d678629b3d3),
        part: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        prefix: null,
        property: null,
        results: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        security: null,
        unselectable: null
    },
    space: 'html',
    transform: (0, $af37ad71c184dc16$export$32b9e4cec9c208e1)
});





var $47e50eda62aba4ca$export$7ed1367e7fa1ad68 = (0, $86ee6f6475bc9e21$export$185802fd694ee1f5)({
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        maskType: 'mask-type',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    properties: {
        about: (0, $0c54fe245f0ec39c$export$2ad25cfebf36cacd),
        accentHeight: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        amplitude: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        className: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        diffuseConstant: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $0c54fe245f0ec39c$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $0c54fe245f0ec39c$export$9c8d678629b3d3),
        g2: (0, $0c54fe245f0ec39c$export$9c8d678629b3d3),
        glyphName: (0, $0c54fe245f0ec39c$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        horizOriginX: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        horizOriginY: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        id: null,
        ideographic: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        k: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        k1: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        k2: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        k3: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        k4: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        kernelMatrix: (0, $0c54fe245f0ec39c$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskType: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        overlineThickness: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $0c54fe245f0ec39c$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        pointsAtY: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        pointsAtZ: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $0c54fe245f0ec39c$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $0c54fe245f0ec39c$export$2ad25cfebf36cacd),
        rev: (0, $0c54fe245f0ec39c$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $0c54fe245f0ec39c$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $0c54fe245f0ec39c$export$2ad25cfebf36cacd),
        requiredFonts: (0, $0c54fe245f0ec39c$export$2ad25cfebf36cacd),
        requiredFormats: (0, $0c54fe245f0ec39c$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        specularExponent: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        strikethroughThickness: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $0c54fe245f0ec39c$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        strokeOpacity: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $0c54fe245f0ec39c$export$2ad25cfebf36cacd),
        tabIndex: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        targetY: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $0c54fe245f0ec39c$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        underlineThickness: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        vMathematical: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        vIdeographic: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        vertOriginX: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        vertOriginY: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $0c54fe245f0ec39c$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    },
    space: 'svg',
    transform: (0, $4784d94d36757732$export$5b10b3bc32d7efbc)
});



var $4eb52777ca72d003$export$2bd1230ec7600845 = (0, $86ee6f6475bc9e21$export$185802fd694ee1f5)({
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    },
    space: 'xlink',
    transform: function(_, property) {
        return 'xlink:' + property.slice(5).toLowerCase();
    }
});




var $69aabe6ee4cec7c3$export$e20c24a128671213 = (0, $86ee6f6475bc9e21$export$185802fd694ee1f5)({
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    properties: {
        xmlnsXLink: null,
        xmlns: null
    },
    space: 'xmlns',
    transform: (0, $af37ad71c184dc16$export$32b9e4cec9c208e1)
});



var $e2b451d418c8b32c$export$f2913fe8983302e = (0, $86ee6f6475bc9e21$export$185802fd694ee1f5)({
    properties: {
        xmlBase: null,
        xmlLang: null,
        xmlSpace: null
    },
    space: 'xml',
    transform: function(_, property) {
        return 'xml:' + property.slice(3).toLowerCase();
    }
});





var $426ddfef97d27e29$export$c0bb0b647f701bb5 = (0, $343b9ca4f4f14919$export$4950aa0f605343fb)([
    (0, $cdf2ec2feb79803e$export$4d2d26490572750a),
    (0, $18cf78d6cc25a1ed$export$c0bb0b647f701bb5),
    (0, $4eb52777ca72d003$export$2bd1230ec7600845),
    (0, $69aabe6ee4cec7c3$export$e20c24a128671213),
    (0, $e2b451d418c8b32c$export$f2913fe8983302e)
], 'html');
var $426ddfef97d27e29$export$7ed1367e7fa1ad68 = (0, $343b9ca4f4f14919$export$4950aa0f605343fb)([
    (0, $cdf2ec2feb79803e$export$4d2d26490572750a),
    (0, $47e50eda62aba4ca$export$7ed1367e7fa1ad68),
    (0, $4eb52777ca72d003$export$2bd1230ec7600845),
    (0, $69aabe6ee4cec7c3$export$e20c24a128671213),
    (0, $e2b451d418c8b32c$export$f2913fe8983302e)
], 'svg');


/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $751af5c3d109d5f4$export$98e6a39c04603d36(value) {
    var input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $751af5c3d109d5f4$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}


var $8b24a2fea3546f78$exports = {};
"use strict";
var $8b24a2fea3546f78$var$__importDefault = $8b24a2fea3546f78$exports && $8b24a2fea3546f78$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $8b24a2fea3546f78$var$style_to_object_1 = $8b24a2fea3546f78$var$__importDefault((parcelRequire("9vYiD")));
var $1314a5cfc574f384$exports = {};
"use strict";
Object.defineProperty($1314a5cfc574f384$exports, "__esModule", {
    value: true
});
$1314a5cfc574f384$exports.camelCase = void 0;
var $1314a5cfc574f384$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
var $1314a5cfc574f384$var$HYPHEN_REGEX = /-([a-z])/g;
var $1314a5cfc574f384$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $1314a5cfc574f384$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $1314a5cfc574f384$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
/**
 * Checks whether to skip camelCase.
 */ var $1314a5cfc574f384$var$skipCamelCase = function skipCamelCase(property) {
    return !property || $1314a5cfc574f384$var$NO_HYPHEN_REGEX.test(property) || $1314a5cfc574f384$var$CUSTOM_PROPERTY_REGEX.test(property);
};
/**
 * Replacer that capitalizes first character.
 */ var $1314a5cfc574f384$var$capitalize = function capitalize(match, character) {
    return character.toUpperCase();
};
/**
 * Replacer that removes beginning hyphen of vendor prefix property.
 */ var $1314a5cfc574f384$var$trimHyphen = function trimHyphen(match, prefix) {
    return "".concat(prefix, "-");
};
/**
 * CamelCases a CSS property.
 */ var $1314a5cfc574f384$var$camelCase = function camelCase(property, options) {
    if (options === void 0) options = {};
    if ($1314a5cfc574f384$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) // `-ms` vendor prefix should not be capitalized
    property = property.replace($1314a5cfc574f384$var$MS_VENDOR_PREFIX_REGEX, $1314a5cfc574f384$var$trimHyphen);
    else // for non-React, remove first hyphen so vendor prefix is not capitalized
    property = property.replace($1314a5cfc574f384$var$VENDOR_PREFIX_REGEX, $1314a5cfc574f384$var$trimHyphen);
    return property.replace($1314a5cfc574f384$var$HYPHEN_REGEX, $1314a5cfc574f384$var$capitalize);
};
$1314a5cfc574f384$exports.camelCase = $1314a5cfc574f384$var$camelCase;


/**
 * Parses CSS inline style to JavaScript object (camelCased).
 */ function $8b24a2fea3546f78$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') return output;
    (0, $8b24a2fea3546f78$var$style_to_object_1.default)(style, function(property, value) {
        // skip CSS comment
        if (property && value) output[(0, $1314a5cfc574f384$exports.camelCase)(property, options)] = value;
    });
    return output;
}
$8b24a2fea3546f78$var$StyleToJS.default = $8b24a2fea3546f78$var$StyleToJS;
$8b24a2fea3546f78$exports = $8b24a2fea3546f78$var$StyleToJS;


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ var $09ebe31a7b709c5f$export$da309cdce9dc2a25 = $09ebe31a7b709c5f$var$point('end');
var $09ebe31a7b709c5f$export$771bf3e4949bfbee = $09ebe31a7b709c5f$var$point('start');
/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $09ebe31a7b709c5f$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */ function point(node) {
        var _$point = node && node.position && node.position[type] || {};
        if (typeof _$point.line === 'number' && _$point.line > 0 && typeof _$point.column === 'number' && _$point.column > 0) return {
            line: _$point.line,
            column: _$point.column,
            offset: typeof _$point.offset === 'number' && _$point.offset > -1 ? _$point.offset : undefined
        };
    }
}
function $09ebe31a7b709c5f$export$5880b8b5730aff45(node) {
    var start = $09ebe31a7b709c5f$export$771bf3e4949bfbee(node);
    var end = $09ebe31a7b709c5f$export$da309cdce9dc2a25(node);
    if (start && end) return {
        start: start,
        end: end
    };
}


/**
 * @import {Node, Point, Position} from 'unist'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */ 
var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $4QAx6 = parcelRequire("4QAx6");

var $hwO3w = parcelRequire("hwO3w");

var $kW1tL = parcelRequire("kW1tL");
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ 
var $03bAP = parcelRequire("03bAP");
function $f5a8c660ec1fed12$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $f5a8c660ec1fed12$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $f5a8c660ec1fed12$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $f5a8c660ec1fed12$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $f5a8c660ec1fed12$var$point(point) {
    return $f5a8c660ec1fed12$var$index(point && point.line) + ':' + $f5a8c660ec1fed12$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $f5a8c660ec1fed12$var$position(pos) {
    return $f5a8c660ec1fed12$var$point(pos && pos.start) + '-' + $f5a8c660ec1fed12$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $f5a8c660ec1fed12$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


var $63893ec7bea23f87$export$752e5c445fe834ef = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(VFileMessage, Error1);
    function VFileMessage(causeOrReason, optionsOrParentOrPlace, origin) {
        (0, $5Epmf._)(this, VFileMessage);
        var _this;
        _this = (0, $48Z0s._)(this, VFileMessage);
        if (typeof optionsOrParentOrPlace === 'string') {
            origin = optionsOrParentOrPlace;
            optionsOrParentOrPlace = undefined;
        }
        /** @type {string} */ var reason = '';
        /** @type {Options} */ var options = {};
        var legacyCause = false;
        if (optionsOrParentOrPlace) {
            // Point.
            if ('line' in optionsOrParentOrPlace && 'column' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('start' in optionsOrParentOrPlace && 'end' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('type' in optionsOrParentOrPlace) options = {
                ancestors: [
                    optionsOrParentOrPlace
                ],
                place: optionsOrParentOrPlace.position
            };
            else options = (0, $hwO3w._)({}, optionsOrParentOrPlace);
        }
        if (typeof causeOrReason === 'string') reason = causeOrReason;
        else if (!options.cause && causeOrReason) {
            legacyCause = true;
            reason = causeOrReason.message;
            options.cause = causeOrReason;
        }
        if (!options.ruleId && !options.source && typeof origin === 'string') {
            var index = origin.indexOf(':');
            if (index === -1) options.ruleId = origin;
            else {
                options.source = origin.slice(0, index);
                options.ruleId = origin.slice(index + 1);
            }
        }
        if (!options.place && options.ancestors && options.ancestors) {
            var parent = options.ancestors[options.ancestors.length - 1];
            if (parent) options.place = parent.position;
        }
        var start = options.place && 'start' in options.place ? options.place.start : options.place;
        /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */ _this.ancestors = options.ancestors || undefined;
        /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */ _this.cause = options.cause || undefined;
        /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */ _this.column = start ? start.column : undefined;
        /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */ _this.fatal = undefined;
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */ _this.file = '';
        // Field from `Error`.
        /**
     * Reason for message.
     *
     * @type {string}
     */ _this.message = reason;
        /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */ _this.line = start ? start.line : undefined;
        // Field from `Error`.
        /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ _this.name = (0, $f5a8c660ec1fed12$export$c304dd45fe166145)(options.place) || '1:1';
        /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */ _this.place = options.place || undefined;
        /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */ _this.reason = _this.message;
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */ _this.ruleId = options.ruleId || undefined;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */ _this.source = options.source || undefined;
        // Field from `Error`.
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ _this.stack = legacyCause && options.cause && typeof options.cause.stack === 'string' ? options.cause.stack : '';
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */ _this.actual = undefined;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */ _this.expected = undefined;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */ _this.note = undefined;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */ _this.url = undefined;
        return _this;
    }
    return VFileMessage;
}((0, $kW1tL._)(Error));
$63893ec7bea23f87$export$752e5c445fe834ef.prototype.file = '';
$63893ec7bea23f87$export$752e5c445fe834ef.prototype.name = '';
$63893ec7bea23f87$export$752e5c445fe834ef.prototype.reason = '';
$63893ec7bea23f87$export$752e5c445fe834ef.prototype.message = '';
$63893ec7bea23f87$export$752e5c445fe834ef.prototype.stack = '';
$63893ec7bea23f87$export$752e5c445fe834ef.prototype.column = undefined;
$63893ec7bea23f87$export$752e5c445fe834ef.prototype.line = undefined;
$63893ec7bea23f87$export$752e5c445fe834ef.prototype.ancestors = undefined;
$63893ec7bea23f87$export$752e5c445fe834ef.prototype.cause = undefined;
$63893ec7bea23f87$export$752e5c445fe834ef.prototype.fatal = undefined;
$63893ec7bea23f87$export$752e5c445fe834ef.prototype.place = undefined;
$63893ec7bea23f87$export$752e5c445fe834ef.prototype.ruleId = undefined;
$63893ec7bea23f87$export$752e5c445fe834ef.prototype.source = undefined;


// To do: next major: `Object.hasOwn`.
var $e271038476068075$var$own = {}.hasOwnProperty;
/** @type {Map<string, number>} */ var $e271038476068075$var$emptyMap = new Map();
var $e271038476068075$var$cap = /[A-Z]/g;
// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.
// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
var $e271038476068075$var$tableElements = new Set([
    'table',
    'tbody',
    'thead',
    'tfoot',
    'tr'
]);
var $e271038476068075$var$tableCellElement = new Set([
    'td',
    'th'
]);
var $e271038476068075$var$docs = 'https://github.com/syntax-tree/hast-util-to-jsx-runtime';
function $e271038476068075$export$59c10052b2dee561(tree, options) {
    if (!options || options.Fragment === undefined) throw new TypeError('Expected `Fragment` in options');
    var filePath = options.filePath || undefined;
    /** @type {Create} */ var create;
    if (options.development) {
        if (typeof options.jsxDEV !== 'function') throw new TypeError('Expected `jsxDEV` in options when `development: true`');
        create = $e271038476068075$var$developmentCreate(filePath, options.jsxDEV);
    } else {
        if (typeof options.jsx !== 'function') throw new TypeError('Expected `jsx` in production options');
        if (typeof options.jsxs !== 'function') throw new TypeError('Expected `jsxs` in production options');
        create = $e271038476068075$var$productionCreate(filePath, options.jsx, options.jsxs);
    }
    /** @type {State} */ var state = {
        Fragment: options.Fragment,
        ancestors: [],
        components: options.components || {},
        create: create,
        elementAttributeNameCase: options.elementAttributeNameCase || 'react',
        evaluater: options.createEvaluater ? options.createEvaluater() : undefined,
        filePath: filePath,
        ignoreInvalidStyle: options.ignoreInvalidStyle || false,
        passKeys: options.passKeys !== false,
        passNode: options.passNode || false,
        schema: options.space === 'svg' ? (0, $426ddfef97d27e29$export$7ed1367e7fa1ad68) : (0, $426ddfef97d27e29$export$c0bb0b647f701bb5),
        stylePropertyNameCase: options.stylePropertyNameCase || 'dom',
        tableCellAlignToStyle: options.tableCellAlignToStyle !== false
    };
    var result = $e271038476068075$var$one(state, tree, undefined);
    // JSX element.
    if (result && typeof result !== 'string') return result;
    // Text node or something that turned into nothing.
    return state.create(tree, state.Fragment, {
        children: result || undefined
    }, undefined);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $e271038476068075$var$one(state, node, key) {
    if (node.type === 'element') return $e271038476068075$var$element(state, node, key);
    if (node.type === 'mdxFlowExpression' || node.type === 'mdxTextExpression') return $e271038476068075$var$mdxExpression(state, node);
    if (node.type === 'mdxJsxFlowElement' || node.type === 'mdxJsxTextElement') return $e271038476068075$var$mdxJsxElement(state, node, key);
    if (node.type === 'mdxjsEsm') return $e271038476068075$var$mdxEsm(state, node);
    if (node.type === 'root') return $e271038476068075$var$root(state, node, key);
    if (node.type === 'text') return $e271038476068075$var$text(state, node);
}
/**
 * Handle element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $e271038476068075$var$element(state, node, key) {
    var parentSchema = state.schema;
    var schema = parentSchema;
    if (node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') {
        schema = (0, $426ddfef97d27e29$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    var type = $e271038476068075$var$findComponentFromName(state, node.tagName, false);
    var props = $e271038476068075$var$createElementProps(state, node);
    var children = $e271038476068075$var$createChildren(state, node);
    if ($e271038476068075$var$tableElements.has(node.tagName)) children = children.filter(function(child) {
        return typeof child === 'string' ? !(0, $950244851cb924f8$export$7af1228ff777d175)(child) : true;
    });
    $e271038476068075$var$addNode(state, props, type, node);
    $e271038476068075$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle MDX expression.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxFlowExpressionHast | MdxTextExpressionHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $e271038476068075$var$mdxExpression(state, node) {
    if (node.data && node.data.estree && state.evaluater) {
        var program = node.data.estree;
        var expression = program.body[0];
        (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
        // Assume result is a child.
        return /** @type {Child | undefined} */ state.evaluater.evaluateExpression(expression.expression);
    }
    $e271038476068075$var$crashEstree(state, node.position);
}
/**
 * Handle MDX ESM.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxjsEsmHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $e271038476068075$var$mdxEsm(state, node) {
    if (node.data && node.data.estree && state.evaluater) // Assume result is a child.
    return /** @type {Child | undefined} */ state.evaluater.evaluateProgram(node.data.estree);
    $e271038476068075$var$crashEstree(state, node.position);
}
/**
 * Handle MDX JSX.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $e271038476068075$var$mdxJsxElement(state, node, key) {
    var parentSchema = state.schema;
    var schema = parentSchema;
    if (node.name === 'svg' && parentSchema.space === 'html') {
        schema = (0, $426ddfef97d27e29$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    var type = node.name === null ? state.Fragment : $e271038476068075$var$findComponentFromName(state, node.name, true);
    var props = $e271038476068075$var$createJsxElementProps(state, node);
    var children = $e271038476068075$var$createChildren(state, node);
    $e271038476068075$var$addNode(state, props, type, node);
    $e271038476068075$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Root} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $e271038476068075$var$root(state, node, key) {
    /** @type {Props} */ var props = {};
    $e271038476068075$var$addChildren(props, $e271038476068075$var$createChildren(state, node));
    return state.create(node, state.Fragment, props, key);
}
/**
 * Handle text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Text} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $e271038476068075$var$text(_, node) {
    return node.value;
}
/**
 * Add `node` to props.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Props} props
 *   Props.
 * @param {unknown} type
 *   Type.
 * @param {Element | MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Node.
 * @returns {undefined}
 *   Nothing.
 */ function $e271038476068075$var$addNode(state, props, type, node) {
    // If this is swapped out for a component:
    if (typeof type !== 'string' && type !== state.Fragment && state.passNode) props.node = node;
}
/**
 * Add children to props.
 *
 * @param {Props} props
 *   Props.
 * @param {Array<Child>} children
 *   Children.
 * @returns {undefined}
 *   Nothing.
 */ function $e271038476068075$var$addChildren(props, children) {
    if (children.length > 0) {
        var value = children.length > 1 ? children : children[0];
        if (value) props.children = value;
    }
}
/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */ function $e271038476068075$var$productionCreate(_, jsx, jsxs) {
    return create;
    /** @type {Create} */ function create(_, type, props, key) {
        // Only an array when there are 2 or more children.
        var isStaticChildren = Array.isArray(props.children);
        var fn = isStaticChildren ? jsxs : jsx;
        return key ? fn(type, props, key) : fn(type, props);
    }
}
/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */ function $e271038476068075$var$developmentCreate(filePath, jsxDEV) {
    return create;
    /** @type {Create} */ function create(node, type, props, key) {
        // Only an array when there are 2 or more children.
        var isStaticChildren = Array.isArray(props.children);
        var point = (0, $09ebe31a7b709c5f$export$771bf3e4949bfbee)(node);
        return jsxDEV(type, props, key, isStaticChildren, {
            columnNumber: point ? point.column - 1 : undefined,
            fileName: filePath,
            lineNumber: point ? point.line : undefined
        }, undefined);
    }
}
/**
 * Create props from an element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current element.
 * @returns {Props}
 *   Props.
 */ function $e271038476068075$var$createElementProps(state, node) {
    /** @type {Props} */ var props = {};
    /** @type {string | undefined} */ var alignValue;
    /** @type {string} */ var prop;
    for(prop in node.properties)if (prop !== 'children' && $e271038476068075$var$own.call(node.properties, prop)) {
        var result = $e271038476068075$var$createProperty(state, prop, node.properties[prop]);
        if (result) {
            var _result = (0, $6iP9u._)(result, 2), key = _result[0], value = _result[1];
            if (state.tableCellAlignToStyle && key === 'align' && typeof value === 'string' && $e271038476068075$var$tableCellElement.has(node.tagName)) alignValue = value;
            else props[key] = value;
        }
    }
    if (alignValue) {
        // Assume style is an object.
        var style = /** @type {Style} */ props.style || (props.style = {});
        style[state.stylePropertyNameCase === 'css' ? 'text-align' : 'textAlign'] = alignValue;
    }
    return props;
}
/**
 * Create props from a JSX element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current JSX element.
 * @returns {Props}
 *   Props.
 */ function $e271038476068075$var$createJsxElementProps(state, node) {
    /** @type {Props} */ var props = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = node.attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var attribute = _step.value;
            if (attribute.type === 'mdxJsxExpressionAttribute') {
                if (attribute.data && attribute.data.estree && state.evaluater) {
                    var program = attribute.data.estree;
                    var expression = program.body[0];
                    (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
                    var objectExpression = expression.expression;
                    (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(objectExpression.type === 'ObjectExpression');
                    var property = objectExpression.properties[0];
                    (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(property.type === 'SpreadElement');
                    Object.assign(props, state.evaluater.evaluateExpression(property.argument));
                } else $e271038476068075$var$crashEstree(state, node.position);
            } else {
                // For JSX, the author is responsible of passing in the correct values.
                var name = attribute.name;
                /** @type {unknown} */ var value = void 0;
                if (attribute.value && (0, $03bAP._)(attribute.value) === 'object') {
                    if (attribute.value.data && attribute.value.data.estree && state.evaluater) {
                        var program1 = attribute.value.data.estree;
                        var expression1 = program1.body[0];
                        (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(expression1.type === 'ExpressionStatement');
                        value = state.evaluater.evaluateExpression(expression1.expression);
                    } else $e271038476068075$var$crashEstree(state, node.position);
                } else value = attribute.value === null ? true : attribute.value;
                // Assume a prop.
                props[name] = /** @type {Props[keyof Props]} */ value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return props;
}
/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */ function $e271038476068075$var$createChildren(state, node) {
    /** @type {Array<Child>} */ var children = [];
    var index = -1;
    /** @type {Map<string, number>} */ // Note: test this when Solid doesn’t want to merge my upcoming PR.
    /* c8 ignore next */ var countsByName = state.passKeys ? new Map() : $e271038476068075$var$emptyMap;
    while(++index < node.children.length){
        var child = node.children[index];
        /** @type {string | undefined} */ var key = void 0;
        if (state.passKeys) {
            var name = child.type === 'element' ? child.tagName : child.type === 'mdxJsxFlowElement' || child.type === 'mdxJsxTextElement' ? child.name : undefined;
            if (name) {
                var count = countsByName.get(name) || 0;
                key = name + '-' + count;
                countsByName.set(name, count + 1);
            }
        }
        var result = $e271038476068075$var$one(state, child, key);
        if (result !== undefined) children.push(result);
    }
    return children;
}
/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */ function $e271038476068075$var$createProperty(state, prop, value) {
    var info = (0, $0f0aeb1e45bf3041$export$71aa6c912b956294)(state.schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === null || value === undefined || typeof value === 'number' && Number.isNaN(value)) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $ad832704b9aa784d$export$fac44ee5b035f737)(value) : (0, $751af5c3d109d5f4$export$fac44ee5b035f737)(value);
    // React only accepts `style` as object.
    if (info.property === 'style') {
        var styleObject = (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) === 'object' ? value : $e271038476068075$var$parseStyle(state, String(value));
        if (state.stylePropertyNameCase === 'css') styleObject = $e271038476068075$var$transformStylesToCssCasing(styleObject);
        return [
            'style',
            styleObject
        ];
    }
    return [
        state.elementAttributeNameCase === 'react' && info.space ? (0, $2bf51d23557d0fc5$export$d8abd7e5fb6871f9)[info.property] || info.property : info.attribute,
        value
    ];
}
/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */ function $e271038476068075$var$parseStyle(state, value) {
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8b24a2fea3546f78$exports)))(value, {
            reactCompat: true
        });
    } catch (error) {
        if (state.ignoreInvalidStyle) return {};
        var cause = /** @type {Error} */ error;
        var message = new (0, $63893ec7bea23f87$export$752e5c445fe834ef)('Cannot parse `style` attribute', {
            ancestors: state.ancestors,
            cause: cause,
            ruleId: 'style',
            source: 'hast-util-to-jsx-runtime'
        });
        message.file = state.filePath || undefined;
        message.url = $e271038476068075$var$docs + '#cannot-parse-style-attribute';
        throw message;
    }
}
/**
 * Create a JSX name from a string.
 *
 * @param {State} state
 *   To do.
 * @param {string} name
 *   Name.
 * @param {boolean} allowExpression
 *   Allow member expressions and identifiers.
 * @returns {unknown}
 *   To do.
 */ function $e271038476068075$var$findComponentFromName(state, name, allowExpression) {
    /** @type {Identifier | Literal | MemberExpression} */ var result;
    if (!allowExpression) result = {
        type: 'Literal',
        value: name
    };
    else if (name.includes('.')) {
        var identifiers = name.split('.');
        var index = -1;
        /** @type {Identifier | Literal | MemberExpression | undefined} */ var node;
        while(++index < identifiers.length){
            /** @type {Identifier | Literal} */ var prop = (0, $89a18ef316964ee8$export$a8ff84c12d48cfa6)(identifiers[index]) ? {
                type: 'Identifier',
                name: identifiers[index]
            } : {
                type: 'Literal',
                value: identifiers[index]
            };
            node = node ? {
                type: 'MemberExpression',
                object: node,
                property: prop,
                computed: Boolean(index && prop.type === 'Literal'),
                optional: false
            } : prop;
        }
        (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(node, 'always a result');
        result = node;
    } else result = (0, $89a18ef316964ee8$export$a8ff84c12d48cfa6)(name) && !/^[a-z]/.test(name) ? {
        type: 'Identifier',
        name: name
    } : {
        type: 'Literal',
        value: name
    };
    // Only literals can be passed in `components` currently.
    // No identifiers / member expressions.
    if (result.type === 'Literal') {
        var _$name = /** @type {string | number} */ result.value;
        return $e271038476068075$var$own.call(state.components, _$name) ? state.components[_$name] : _$name;
    }
    // Assume component.
    if (state.evaluater) return state.evaluater.evaluateExpression(result);
    $e271038476068075$var$crashEstree(state);
}
/**
 * @param {State} state
 * @param {Position | undefined} [place]
 * @returns {never}
 */ function $e271038476068075$var$crashEstree(state, place) {
    var message = new (0, $63893ec7bea23f87$export$752e5c445fe834ef)('Cannot handle MDX estrees without `createEvaluater`', {
        ancestors: state.ancestors,
        place: place,
        ruleId: 'mdx-estree',
        source: 'hast-util-to-jsx-runtime'
    });
    message.file = state.filePath || undefined;
    message.url = $e271038476068075$var$docs + '#cannot-handle-mdx-estrees-without-createevaluater';
    throw message;
}
/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */ function $e271038476068075$var$transformStylesToCssCasing(domCasing) {
    /** @type {Style} */ var cssCasing = {};
    /** @type {string} */ var from;
    for(from in domCasing)if ($e271038476068075$var$own.call(domCasing, from)) cssCasing[$e271038476068075$var$transformStyleToCssCasing(from)] = domCasing[from];
    return cssCasing;
}
/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */ function $e271038476068075$var$transformStyleToCssCasing(from) {
    var to = from.replace($e271038476068075$var$cap, $e271038476068075$var$toDash);
    // Handle `ms-xxx` -> `-ms-xxx`.
    if (to.slice(0, 3) === 'ms-') to = '-' + to;
    return to;
}
/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */ function $e271038476068075$var$toDash($0) {
    return '-' + $0.toLowerCase();
}


/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */ var $363482b2fb04a9bd$export$de3e062aedff083a = {
    action: [
        'form'
    ],
    cite: [
        'blockquote',
        'del',
        'ins',
        'q'
    ],
    data: [
        'object'
    ],
    formAction: [
        'button',
        'input'
    ],
    href: [
        'a',
        'area',
        'base',
        'link'
    ],
    icon: [
        'menuitem'
    ],
    itemId: null,
    manifest: [
        'html'
    ],
    ping: [
        'a',
        'area'
    ],
    poster: [
        'video'
    ],
    src: [
        'audio',
        'embed',
        'iframe',
        'img',
        'input',
        'script',
        'source',
        'track',
        'video'
    ]
};




var $5s1kH = parcelRequire("5s1kH");
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */ /**
 * @typedef {Omit<FromMarkdownOptions, 'extensions' | 'mdastExtensions'>} Options
 */ 
var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");
/**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */ 
var $XnYkK = parcelRequire("XnYkK");

var $03bAP = parcelRequire("03bAP");
/**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ 
var $03bAP = parcelRequire("03bAP");
var $b39838f337d55846$var$emptyOptions = {};
function $b39838f337d55846$export$f84e8e69fd4488a5(value, options) {
    var settings = options || $b39838f337d55846$var$emptyOptions;
    var includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    var includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $b39838f337d55846$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $b39838f337d55846$var$one(value, includeImageAlt, includeHtml) {
    if ($b39838f337d55846$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $b39838f337d55846$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $b39838f337d55846$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $b39838f337d55846$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ var result = [];
    var index = -1;
    while(++index < values.length)result[index] = $b39838f337d55846$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $b39838f337d55846$var$node(value) {
    return Boolean(value && (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) === 'object');
}


/**
 * @import {Encoding, Value} from 'micromark-util-types'
 */ /**
 * @typedef {import('micromark-util-types').Options} Options
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @import {
 *   CompileContext,
 *   CompileData,
 *   CompileOptions,
 *   Compile,
 *   Definition,
 *   Event,
 *   Handle,
 *   HtmlExtension,
 *   LineEnding,
 *   NormalizedHtmlExtension,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ 
var $hwO3w = parcelRequire("hwO3w");

var $XnYkK = parcelRequire("XnYkK");
/// <reference lib="dom" />
/* global document */ var $ce583e5222f7bcb3$var$element = document.createElement('i');
function $ce583e5222f7bcb3$export$289b6a6320f709b4(value) {
    var characterReference = '&' + value + ';';
    $ce583e5222f7bcb3$var$element.innerHTML = characterReference;
    var character = $ce583e5222f7bcb3$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    if (character.charCodeAt(character.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    return character === characterReference ? false : character;
}


/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ 
var $XnYkK = parcelRequire("XnYkK");
function $c39c196334f8c75e$export$869882364835d202(list, start, remove, items) {
    var end = list.length;
    var chunkStart = 0;
    /** @type {Array<unknown>} */ var parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        var // @ts-expect-error Hush, it’s fine.
        _list;
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        (_list = list).splice.apply(_list, (0, $XnYkK._)(parameters));
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            var // @ts-expect-error Hush, it’s fine.
            _list1;
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            (_list1 = list).splice.apply(_list1, (0, $XnYkK._)(parameters));
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $c39c196334f8c75e$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $c39c196334f8c75e$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */ 
var $a8b619d0d726651b$var$hasOwnProperty = {}.hasOwnProperty;
function $a8b619d0d726651b$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ var all = {};
    var index = -1;
    while(++index < extensions.length)$a8b619d0d726651b$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $a8b619d0d726651b$var$syntaxExtension(all, extension) {
    var _loop = function() {
        var maybe = $a8b619d0d726651b$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ var left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ var right = extension[hook];
        /** @type {string} */ var code = void 0;
        if (right) for(code in right){
            if (!$a8b619d0d726651b$var$hasOwnProperty.call(left, code)) left[code] = [];
            var value = right[code];
            $a8b619d0d726651b$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    };
    /** @type {keyof Extension} */ var hook;
    for(hook in extension)_loop();
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $a8b619d0d726651b$var$constructs(existing, list) {
    var index = -1;
    /** @type {Array<unknown>} */ var before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $c39c196334f8c75e$export$869882364835d202)(existing, 0, 0, before);
}
function $a8b619d0d726651b$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ var handlers = {};
    var index = -1;
    while(++index < htmlExtensions.length)$a8b619d0d726651b$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $a8b619d0d726651b$var$htmlExtension(all, extension) {
    var _loop = function() {
        var maybe = $a8b619d0d726651b$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        var left = maybe || (all[hook] = {});
        var right = extension[hook];
        /** @type {keyof Handles} */ var type = void 0;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    };
    /** @type {keyof HtmlExtension} */ var hook;
    for(hook in extension)_loop();
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $feafc29f35cd5b43$export$15a69557afac2c20(value, base) {
    var code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}


var $1b2ece42f0684cc9$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $1b2ece42f0684cc9$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   *   Value to replace.
   * @returns {string}
   *   Encoded value.
   */ function replace(value) {
        return '&' + $1b2ece42f0684cc9$var$characterReferences[/** @type {keyof typeof characterReferences} */ value] + ';';
    }
}


/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $daea560f96654179$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


/**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ var $4d05890350ae4444$export$d65d6b62c24d5436 = $4d05890350ae4444$var$regexCheck(/[A-Za-z]/);
var $4d05890350ae4444$export$75c76db11865a9f4 = $4d05890350ae4444$var$regexCheck(/[\dA-Za-z]/);
var $4d05890350ae4444$export$4397998b34fe597d = $4d05890350ae4444$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $4d05890350ae4444$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
var $4d05890350ae4444$export$ca8b5b1a6c320e6e = $4d05890350ae4444$var$regexCheck(/\d/);
var $4d05890350ae4444$export$eca2752363989806 = $4d05890350ae4444$var$regexCheck(/[\dA-Fa-f]/);
var $4d05890350ae4444$export$35794a7d1db99380 = $4d05890350ae4444$var$regexCheck(/[!-/:-@[-`{-~]/);
function $4d05890350ae4444$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $4d05890350ae4444$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $4d05890350ae4444$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
var $4d05890350ae4444$export$aa04114dd888a7a0 = $4d05890350ae4444$var$regexCheck(RegExp("\\p{P}|\\p{S}", "u"));
var $4d05890350ae4444$export$a0ff789c034ffdf4 = $4d05890350ae4444$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */ function $4d05890350ae4444$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}



function $9ec3f308f236101d$export$d130a2d684099e5a(url, protocol) {
    var value = (0, $1b2ece42f0684cc9$export$c564cdbbe6da493)($9ec3f308f236101d$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    var colon = value.indexOf(':');
    var questionMark = value.indexOf('?');
    var numberSign = value.indexOf('#');
    var slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $9ec3f308f236101d$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ var result = [];
    var index = -1;
    var start = 0;
    var skip = 0;
    while(++index < value.length){
        var code = value.charCodeAt(index);
        /** @type {string} */ var replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $4d05890350ae4444$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $4d05890350ae4444$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            var next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


var $7cad00caacad897c$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ var $7cad00caacad897c$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
var $7cad00caacad897c$var$protocolSource = /^https?$/i;
function $7cad00caacad897c$export$ef7acd7185315e22(options) {
    var settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ var tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ var definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ var buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ var mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ var tightStack = [];
    /** @type {HtmlExtension} */ var defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ var handlers = /** @type {NormalizedHtmlExtension} */ (0, $a8b619d0d726651b$export$eaf8c406dfb0a620)([
        defaultHandlers
    ].concat((0, $XnYkK._)(settings.htmlExtensions || [])));
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ var data = {
        definitions: definitions,
        tightStack: tightStack
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ var context = {
        buffer: buffer,
        encode: encode,
        getData: getData,
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        raw: raw,
        resume: resume,
        setData: setData,
        tag: tag
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ var lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {ReadonlyArray<Event>} events
   * @returns {string}
   */ function compile(events) {
        var index = -1;
        var start = 0;
        /** @type {Array<number>} */ var listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ var head = [];
        /** @type {Array<Event>} */ var body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) lineEndingStyle = /** @type {LineEnding} */ events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === 'enter') {
                    body = (0, $c39c196334f8c75e$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $c39c196334f8c75e$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $c39c196334f8c75e$export$4cbf152802aa238)(head, body);
        head = (0, $c39c196334f8c75e$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        var result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            var handles = handlers[result[index][0]];
            var kind = result[index][1].type;
            var handle = handles[kind];
            if ($7cad00caacad897c$var$hasOwnProperty.call(handles, kind) && handle) handle.call((0, $hwO3w._)({
                sliceSerialize: result[index][2].sliceSerialize
            }, context), result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {ReadonlyArray<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        var length = slice.length;
        var index = 0; // Skip open.
        var containerBalance = 0;
        var loose = false;
        /** @type {boolean | undefined} */ var atMarker;
        while(++index < length){
            var event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        var buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        var _$buffer = buffers[buffers.length - 1];
        var slice = _$buffer[_$buffer.length - 1];
        var previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $1b2ece42f0684cc9$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            var value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        var value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        var count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        var count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined; // Disallow tags.
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer(); // We can have line endings in the resource, ignore them.
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        var index = mediaStack.length - 1; // Skip current.
        var media = mediaStack[index];
        var id = media.referenceId || media.labelId;
        var context = media.destination === undefined ? definitions[(0, $daea560f96654179$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $9ec3f308f236101d$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $7cad00caacad897c$var$protocolSource) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $9ec3f308f236101d$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $7cad00caacad897c$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        var media = mediaStack[mediaStack.length - 1];
        var id = (0, $daea560f96654179$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$7cad00caacad897c$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        var value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        var value = this.sliceSerialize(token);
        var decoded = getData('characterReferenceType') ? (0, $feafc29f35cd5b43$export$15a69557afac2c20)(value, getData('characterReferenceType') === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $ce583e5222f7bcb3$export$289b6a6320f709b4)(value);
        // `decodeNamedCharacterReference` can return `false` for invalid named
        // character references,
        // but everything we’ve tokenized is valid.
        raw(encode(/** @type {string} */ decoded));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        var uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $9ec3f308f236101d$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $7cad00caacad897c$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        var uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $9ec3f308f236101d$export$d130a2d684099e5a)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}


/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */ 
var $XnYkK = parcelRequire("XnYkK");

/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $11d7e00f3fab1b8a$export$ae105c1eb063a0a2(effects, ok, type, max) {
    var limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    var size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



var $45160c7696e33c48$export$a7db06668cad9adb = {
    tokenize: $45160c7696e33c48$var$initializeContent
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */ function $45160c7696e33c48$var$initializeContent(effects) {
    var contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ var previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        var token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 *   Construct and its state.
 */ 
var $hwO3w = parcelRequire("hwO3w");



var $5cbb399fe3185e66$export$5a7bfc01df82fcd1 = {
    tokenize: $5cbb399fe3185e66$var$initializeDocument
};
/** @type {Construct} */ var $5cbb399fe3185e66$var$containerConstruct = {
    tokenize: $5cbb399fe3185e66$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $5cbb399fe3185e66$var$initializeDocument(effects) {
    var self = this;
    /** @type {Array<StackItem>} */ var stack = [];
    var continued = 0;
    /** @type {TokenizeContext | undefined} */ var childFlow;
    /** @type {Token | undefined} */ var childToken;
    /** @type {number} */ var lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            var item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            var indexBeforeExits = self.events.length;
            var indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ var point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            var index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = (0, $hwO3w._)({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $c39c196334f8c75e$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($5cbb399fe3185e66$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($5cbb399fe3185e66$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            _tokenizer: childFlow,
            contentType: "flow",
            previous: childToken
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */ function writeToChild(token, endOfFile) {
        var stream = self.sliceStream(token);
        if (endOfFile) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            var index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            var indexBeforeExits = self.events.length;
            var indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ var seen;
            /** @type {Point | undefined} */ var point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = (0, $hwO3w._)({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $c39c196334f8c75e$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */ function exitContainers(size) {
        var index = stack.length;
        // Exit open containers.
        while(index-- > size){
            var entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */ function $5cbb399fe3185e66$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ /**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

var $ba12a10e9e950846$export$d50d28ce3ab2a612 = {
    partial: true,
    tokenize: $ba12a10e9e950846$var$tokenizeBlankLine
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ba12a10e9e950846$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $4d05890350ae4444$export$2c6cf65c1127992a)(code) ? (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 

/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */ 
var $hwO3w = parcelRequire("hwO3w");

/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ 
var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $XnYkK = parcelRequire("XnYkK");
var $4da7ce53ee740c6e$export$bd596157370df26e = /*#__PURE__*/ function() {
    "use strict";
    function SpliceBuffer(initial) {
        (0, $5Epmf._)(this, SpliceBuffer);
        /** @type {Array<T>} */ this.left = initial ? (0, $XnYkK._)(initial) : [];
        /** @type {Array<T>} */ this.right = [];
    }
    (0, $9MqXK._)(SpliceBuffer, [
        {
            /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ key: "get",
            value: function get(index) {
                if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
                if (index < this.left.length) return this.left[index];
                return this.right[this.right.length - index + this.left.length - 1];
            }
        },
        {
            key: "length",
            get: /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ function get() {
                return this.left.length + this.right.length;
            }
        },
        {
            /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ key: "shift",
            value: function shift() {
                this.setCursor(0);
                return this.right.pop();
            }
        },
        {
            /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ key: "slice",
            value: function slice(start, end) {
                /** @type {number} */ var stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
                if (stop < this.left.length) return this.left.slice(start, stop);
                if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
                return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
            }
        },
        {
            /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ key: "splice",
            value: function splice(start, deleteCount, items) {
                /** @type {number} */ var count = deleteCount || 0;
                this.setCursor(Math.trunc(start));
                var removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
                if (items) $4da7ce53ee740c6e$var$chunkedPush(this.left, items);
                return removed.reverse();
            }
        },
        {
            /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ key: "pop",
            value: function pop() {
                this.setCursor(Number.POSITIVE_INFINITY);
                return this.left.pop();
            }
        },
        {
            /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ key: "push",
            value: function push(item) {
                this.setCursor(Number.POSITIVE_INFINITY);
                this.left.push(item);
            }
        },
        {
            /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ key: "pushMany",
            value: function pushMany(items) {
                this.setCursor(Number.POSITIVE_INFINITY);
                $4da7ce53ee740c6e$var$chunkedPush(this.left, items);
            }
        },
        {
            /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ key: "unshift",
            value: function unshift(item) {
                this.setCursor(0);
                this.right.push(item);
            }
        },
        {
            /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ key: "unshiftMany",
            value: function unshiftMany(items) {
                this.setCursor(0);
                $4da7ce53ee740c6e$var$chunkedPush(this.right, items.reverse());
            }
        },
        {
            /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ key: "setCursor",
            value: function setCursor(n) {
                if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
                if (n < this.left.length) {
                    // Move cursor to the this.left
                    var removed = this.left.splice(n, Number.POSITIVE_INFINITY);
                    $4da7ce53ee740c6e$var$chunkedPush(this.right, removed.reverse());
                } else {
                    // Move cursor to the this.right
                    var removed1 = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
                    $4da7ce53ee740c6e$var$chunkedPush(this.left, removed1.reverse());
                }
            }
        }
    ]);
    return SpliceBuffer;
}();
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $4da7ce53ee740c6e$var$chunkedPush(list, right) {
    var _list;
    /** @type {number} */ var chunkStart = 0;
    if (right.length < 10000) (_list = list).push.apply(_list, (0, $XnYkK._)(right));
    else while(chunkStart < right.length){
        var _list1;
        (_list1 = list).push.apply(_list1, (0, $XnYkK._)(right.slice(chunkStart, chunkStart + 10000)));
        chunkStart += 10000;
    }
}


function $afed179dce17b426$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ var jumps = {};
    var index = -1;
    /** @type {Event} */ var event;
    /** @type {number | undefined} */ var lineIndex;
    /** @type {number} */ var otherIndex;
    /** @type {Event} */ var otherEvent;
    /** @type {Array<Event>} */ var parameters;
    /** @type {Array<Event>} */ var subevents;
    /** @type {boolean | undefined} */ var more;
    var events = new (0, $4da7ce53ee740c6e$export$bd596157370df26e)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $afed179dce17b426$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
                else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = (0, $hwO3w._)({}, events.get(lineIndex)[1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $c39c196334f8c75e$export$869882364835d202)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */ function $afed179dce17b426$var$subcontent(events, eventIndex) {
    var token = events.get(eventIndex)[1];
    var context = events.get(eventIndex)[2];
    var startPosition = eventIndex - 1;
    /** @type {Array<number>} */ var startPositions = [];
    var tokenizer = token._tokenizer;
    if (!tokenizer) {
        tokenizer = context.parser[token.contentType](token.start);
        if (token._contentTypeTextTrailing) tokenizer._contentTypeTextTrailing = true;
    }
    var childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ var jumps = [];
    /** @type {Record<string, number>} */ var gaps = {};
    /** @type {Array<Chunk>} */ var stream;
    /** @type {Token | undefined} */ var previous;
    var index = -1;
    /** @type {Token | undefined} */ var current = token;
    var adjust = 0;
    var start = 0;
    var breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        var slice = childEvents.slice(breaks[index], breaks[index + 1]);
        var start1 = startPositions.pop();
        jumps.push([
            start1,
            start1 + slice.length - 1
        ]);
        events.splice(start1, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


var $135e6079326fd533$export$a7db06668cad9adb = {
    resolve: $135e6079326fd533$var$resolveContent,
    tokenize: $135e6079326fd533$var$tokenizeContent
};
/** @type {Construct} */ var $135e6079326fd533$var$continuationConstruct = {
    partial: true,
    tokenize: $135e6079326fd533$var$tokenizeContinuation
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $135e6079326fd533$var$resolveContent(events) {
    (0, $afed179dce17b426$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $135e6079326fd533$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ var previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) return effects.check($135e6079326fd533$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $135e6079326fd533$var$tokenizeContinuation(effects, ok, nok) {
    var self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        var tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




var $352a93200005805c$export$ccc7b0636abaffc3 = {
    tokenize: $352a93200005805c$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $352a93200005805c$var$initializeFlow(effects) {
    var self = this;
    var initial = effects.attempt(// Try to parse a blank line.
    (0, $ba12a10e9e950846$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $135e6079326fd533$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ 
var $hwO3w = parcelRequire("hwO3w");
var $f71e7012ddebb81f$export$50397835cbfdbc24 = {
    resolveAll: $f71e7012ddebb81f$var$createResolver()
};
var $f71e7012ddebb81f$export$22b082955e083ec3 = $f71e7012ddebb81f$var$initializeFactory('string');
var $f71e7012ddebb81f$export$6f093cfa640b7166 = $f71e7012ddebb81f$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */ function $f71e7012ddebb81f$var$initializeFactory(field) {
    return {
        resolveAll: $f71e7012ddebb81f$var$createResolver(field === 'text' ? $f71e7012ddebb81f$var$resolveAllLineSuffixes : undefined),
        tokenize: initializeText
    };
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */ function initializeText(effects) {
        var self = this;
        var constructs = this.parser.constructs[field];
        var text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */ function atBreak(code) {
            if (code === null) return true;
            var list = constructs[code];
            var index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                var item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */ function $f71e7012ddebb81f$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        var index = -1;
        /** @type {number | undefined} */ var enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $f71e7012ddebb81f$var$resolveAllLineSuffixes(events, context) {
    var eventIndex = 0; // Skip first.
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        var data = events[eventIndex - 1][1];
        var chunks = context.sliceStream(data);
        var index = chunks.length;
        var bufferIndex = -1;
        var size = 0;
        /** @type {boolean | undefined} */ var tabs = void 0;
        while(index--){
            var chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        // Allow final trailing whitespace.
        if (context._contentTypeTextTrailing && eventIndex === events.length) size = 0;
        if (size) {
            var token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
                    _index: data.start._index + index,
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size
                },
                end: (0, $hwO3w._)({}, data.end)
            };
            data.end = (0, $hwO3w._)({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


var $79595f8c1017a19b$exports = {};

$parcel$export($79595f8c1017a19b$exports, "document", function () { return $79595f8c1017a19b$export$5a7bfc01df82fcd1; });
$parcel$export($79595f8c1017a19b$exports, "contentInitial", function () { return $79595f8c1017a19b$export$5a2181fb44b58173; });
$parcel$export($79595f8c1017a19b$exports, "flowInitial", function () { return $79595f8c1017a19b$export$cf8bead395eff824; });
$parcel$export($79595f8c1017a19b$exports, "flow", function () { return $79595f8c1017a19b$export$ccc7b0636abaffc3; });
$parcel$export($79595f8c1017a19b$exports, "string", function () { return $79595f8c1017a19b$export$22b082955e083ec3; });
$parcel$export($79595f8c1017a19b$exports, "text", function () { return $79595f8c1017a19b$export$6f093cfa640b7166; });
$parcel$export($79595f8c1017a19b$exports, "insideSpan", function () { return $79595f8c1017a19b$export$d44f260a3f9b69f5; });
$parcel$export($79595f8c1017a19b$exports, "attentionMarkers", function () { return $79595f8c1017a19b$export$b9c0b60d74426aea; });
$parcel$export($79595f8c1017a19b$exports, "disable", function () { return $79595f8c1017a19b$export$e20fbacbb41798b; });
/**
 * @import {Extension} from 'micromark-util-types'
 */ 
var $dUlz9 = parcelRequire("dUlz9");
/**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
var $hwO3w = parcelRequire("hwO3w");

/**
 * @import {Code} from 'micromark-util-types'
 */ 
function $0a3461a0e64b4a88$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $4d05890350ae4444$export$a30284361b3814b7)(code) || (0, $4d05890350ae4444$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $4d05890350ae4444$export$aa04114dd888a7a0)(code)) return 2;
}


/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $73eb3c6139ed2caa$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ var called = [];
    var index = -1;
    while(++index < constructs.length){
        var resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


var $73c3bca16cd36ba0$export$45b92471da762af7 = {
    name: 'attention',
    resolveAll: $73c3bca16cd36ba0$var$resolveAllAttention,
    tokenize: $73c3bca16cd36ba0$var$tokenizeAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $73c3bca16cd36ba0$var$resolveAllAttention(events, context) {
    var index = -1;
    /** @type {number} */ var open;
    /** @type {Token} */ var group;
    /** @type {Token} */ var text;
    /** @type {Token} */ var openingSequence;
    /** @type {Token} */ var closingSequence;
    /** @type {number} */ var use;
    /** @type {Array<Event>} */ var nextEvents;
    /** @type {number} */ var offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            var start = (0, $hwO3w._)({}, events[open][1].end);
            var end = (0, $hwO3w._)({}, events[index][1].start);
            $73c3bca16cd36ba0$var$movePoint(start, -use);
            $73c3bca16cd36ba0$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: (0, $hwO3w._)({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: (0, $hwO3w._)({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: (0, $hwO3w._)({}, events[open][1].end),
                end: (0, $hwO3w._)({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: (0, $hwO3w._)({}, openingSequence.start),
                end: (0, $hwO3w._)({}, closingSequence.end)
            };
            events[open][1].end = (0, $hwO3w._)({}, openingSequence.start);
            events[index][1].start = (0, $hwO3w._)({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $c39c196334f8c75e$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $c39c196334f8c75e$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $c39c196334f8c75e$export$4cbf152802aa238)(nextEvents, (0, $73eb3c6139ed2caa$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $c39c196334f8c75e$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $c39c196334f8c75e$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $c39c196334f8c75e$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $73c3bca16cd36ba0$var$tokenizeAttention(effects, ok) {
    var attentionMarkers = this.parser.constructs.attentionMarkers.null;
    var previous = this.previous;
    var before = (0, $0a3461a0e64b4a88$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ var marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        var token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        var after = (0, $0a3461a0e64b4a88$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        var open = !after || after === 2 && before || attentionMarkers.includes(code);
        var close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */ function $73c3bca16cd36ba0$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $2e406a7687c4c7c8$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $2e406a7687c4c7c8$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2e406a7687c4c7c8$var$tokenizeAutolink(effects, ok, nok) {
    var size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $4d05890350ae4444$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $4d05890350ae4444$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $4d05890350ae4444$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $4d05890350ae4444$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $4d05890350ae4444$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $4d05890350ae4444$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $4d05890350ae4444$export$75c76db11865a9f4)(code)) && size++ < 63) {
            var next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

var $868018ebb073017a$export$200dcd0a5903c968 = {
    continuation: {
        tokenize: $868018ebb073017a$var$tokenizeBlockQuoteContinuation
    },
    exit: $868018ebb073017a$var$exit,
    name: 'blockQuote',
    tokenize: $868018ebb073017a$var$tokenizeBlockQuoteStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $868018ebb073017a$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    var self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            var state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $868018ebb073017a$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    var self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($868018ebb073017a$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $868018ebb073017a$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $2d5bce5badcc42a1$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $2d5bce5badcc42a1$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2d5bce5badcc42a1$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $4d05890350ae4444$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

var $428dd080625833bb$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $428dd080625833bb$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $428dd080625833bb$var$tokenizeCharacterReference(effects, ok, nok) {
    var self = this;
    var size = 0;
    /** @type {number} */ var max;
    /** @type {(code: Code) => boolean} */ var test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $4d05890350ae4444$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $4d05890350ae4444$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $4d05890350ae4444$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            var token = effects.exit("characterReferenceValue");
            if (test === (0, $4d05890350ae4444$export$75c76db11865a9f4) && !(0, $ce583e5222f7bcb3$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

/** @type {Construct} */ var $719964e22fa5d80f$var$nonLazyContinuation = {
    partial: true,
    tokenize: $719964e22fa5d80f$var$tokenizeNonLazyContinuation
};
var $719964e22fa5d80f$export$c23e4921f8d87e7c = {
    concrete: true,
    name: 'codeFenced',
    tokenize: $719964e22fa5d80f$var$tokenizeCodeFenced
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $719964e22fa5d80f$var$tokenizeCodeFenced(effects, ok, nok) {
    var self = this;
    /** @type {Construct} */ var closeStart = {
        partial: true,
        tokenize: tokenizeCloseStart
    };
    var initialPrefix = 0;
    var sizeOpen = 0;
    /** @type {NonNullable<Code>} */ var marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        var tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $4d05890350ae4444$export$2c6cf65c1127992a)(code) ? (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($719964e22fa5d80f$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $4d05890350ae4444$export$2c6cf65c1127992a)(code) ? (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) return effects.check($719964e22fa5d80f$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        var size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $4d05890350ae4444$export$2c6cf65c1127992a)(code) ? (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $4d05890350ae4444$export$2c6cf65c1127992a)(code) ? (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $719964e22fa5d80f$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    var self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

var $e4b686948fa382d3$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $e4b686948fa382d3$var$tokenizeCodeIndented
};
/** @type {Construct} */ var $e4b686948fa382d3$var$furtherStart = {
    partial: true,
    tokenize: $e4b686948fa382d3$var$tokenizeFurtherStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $e4b686948fa382d3$var$tokenizeCodeIndented(effects, ok, nok) {
    var self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        var tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) return effects.attempt($e4b686948fa382d3$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $e4b686948fa382d3$var$tokenizeFurtherStart(effects, ok, nok) {
    var self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        var tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $4d05890350ae4444$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
var $ffa0ef457db974ba$export$d24f93e715f9df88 = {
    name: 'codeText',
    previous: $ffa0ef457db974ba$var$previous,
    resolve: $ffa0ef457db974ba$var$resolveCodeText,
    tokenize: $ffa0ef457db974ba$var$tokenizeCodeText
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $ffa0ef457db974ba$var$resolveCodeText(events) {
    var tailExitIndex = events.length - 4;
    var headEnterIndex = 3;
    /** @type {number} */ var index;
    /** @type {number | undefined} */ var enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */ function $ffa0ef457db974ba$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ffa0ef457db974ba$var$tokenizeCodeText(effects, ok, nok) {
    var self = this;
    var sizeOpen = 0;
    /** @type {number} */ var size;
    /** @type {Token} */ var token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $8bed1a74bd77c0ff$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    var limit = max || Number.POSITIVE_INFINITY;
    var balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $4d05890350ae4444$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $4d05890350ae4444$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $4d05890350ae4444$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */ 
function $ee518dd96e1b6bc2$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    var self = this;
    var size = 0;
    /** @type {boolean} */ var seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $4d05890350ae4444$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */ 

function $f67077f4e43b27ce$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ var marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @import {Effects, State} from 'micromark-util-types'
 */ 

function $0860595013d3d7a7$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ var seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




var $6eb3a63712e66a2c$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $6eb3a63712e66a2c$var$tokenizeDefinition
};
/** @type {Construct} */ var $6eb3a63712e66a2c$var$titleBefore = {
    partial: true,
    tokenize: $6eb3a63712e66a2c$var$tokenizeTitleBefore
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $6eb3a63712e66a2c$var$tokenizeDefinition(effects, ok, nok) {
    var self = this;
    /** @type {string} */ var identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $ee518dd96e1b6bc2$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $daea560f96654179$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $4d05890350ae4444$export$a30284361b3814b7)(code) ? (0, $0860595013d3d7a7$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $8bed1a74bd77c0ff$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($6eb3a63712e66a2c$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $4d05890350ae4444$export$2c6cf65c1127992a)(code) ? (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $6eb3a63712e66a2c$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $4d05890350ae4444$export$a30284361b3814b7)(code) ? (0, $0860595013d3d7a7$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $f67077f4e43b27ce$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $4d05890350ae4444$export$2c6cf65c1127992a)(code) ? (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $60513aff062d2516$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $60513aff062d2516$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $60513aff062d2516$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 


var $28e5d8a4dc03b954$export$3871e9deb360695c = {
    name: 'headingAtx',
    resolve: $28e5d8a4dc03b954$var$resolveHeadingAtx,
    tokenize: $28e5d8a4dc03b954$var$tokenizeHeadingAtx
};
/** @type {Resolver} */ function $28e5d8a4dc03b954$var$resolveHeadingAtx(events, context) {
    var contentEnd = events.length - 2;
    var contentStart = 3;
    /** @type {Token} */ var content;
    /** @type {Token} */ var text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $c39c196334f8c75e$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $28e5d8a4dc03b954$var$tokenizeHeadingAtx(effects, ok, nok) {
    var size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $4d05890350ae4444$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $4d05890350ae4444$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ var $745c805441285b64$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
var $745c805441285b64$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



var $3956eaa9bf10730c$export$476ac411cb7d0d8f = {
    concrete: true,
    name: 'htmlFlow',
    resolveTo: $3956eaa9bf10730c$var$resolveToHtmlFlow,
    tokenize: $3956eaa9bf10730c$var$tokenizeHtmlFlow
};
/** @type {Construct} */ var $3956eaa9bf10730c$var$blankLineBefore = {
    partial: true,
    tokenize: $3956eaa9bf10730c$var$tokenizeBlankLineBefore
};
var $3956eaa9bf10730c$var$nonLazyContinuationStart = {
    partial: true,
    tokenize: $3956eaa9bf10730c$var$tokenizeNonLazyContinuationStart
};
/** @type {Resolver} */ function $3956eaa9bf10730c$var$resolveToHtmlFlow(events) {
    var index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3956eaa9bf10730c$var$tokenizeHtmlFlow(effects, ok, nok) {
    var self = this;
    /** @type {number} */ var marker;
    /** @type {boolean} */ var closingTag;
    /** @type {string} */ var buffer;
    /** @type {number} */ var index;
    /** @type {Code} */ var markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $4d05890350ae4444$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $4d05890350ae4444$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        var value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $4d05890350ae4444$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $4d05890350ae4444$export$a30284361b3814b7)(code)) {
            var slash = code === 47;
            var name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $745c805441285b64$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $745c805441285b64$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $4d05890350ae4444$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $4d05890350ae4444$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $4d05890350ae4444$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $4d05890350ae4444$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($3956eaa9bf10730c$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($3956eaa9bf10730c$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            var name = buffer.toLowerCase();
            if ((0, $745c805441285b64$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $4d05890350ae4444$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            // Always the case.
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3956eaa9bf10730c$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    var self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3956eaa9bf10730c$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $ba12a10e9e950846$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

var $64f8e4d4720b96f7$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $64f8e4d4720b96f7$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $64f8e4d4720b96f7$var$tokenizeHtmlText(effects, ok, nok) {
    var self = this;
    /** @type {NonNullable<Code> | undefined} */ var marker;
    /** @type {number} */ var index;
    /** @type {State} */ var returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $4d05890350ae4444$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $4d05890350ae4444$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        var value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $4d05890350ae4444$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $4d05890350ae4444$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $4d05890350ae4444$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $4d05890350ae4444$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $4d05890350ae4444$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $4d05890350ae4444$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $4d05890350ae4444$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $4d05890350ae4444$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $4d05890350ae4444$export$2c6cf65c1127992a)(code) ? (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
var $hwO3w = parcelRequire("hwO3w");








var $44b0056c0b792264$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    resolveAll: $44b0056c0b792264$var$resolveAllLabelEnd,
    resolveTo: $44b0056c0b792264$var$resolveToLabelEnd,
    tokenize: $44b0056c0b792264$var$tokenizeLabelEnd
};
/** @type {Construct} */ var $44b0056c0b792264$var$resourceConstruct = {
    tokenize: $44b0056c0b792264$var$tokenizeResource
};
/** @type {Construct} */ var $44b0056c0b792264$var$referenceFullConstruct = {
    tokenize: $44b0056c0b792264$var$tokenizeReferenceFull
};
/** @type {Construct} */ var $44b0056c0b792264$var$referenceCollapsedConstruct = {
    tokenize: $44b0056c0b792264$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $44b0056c0b792264$var$resolveAllLabelEnd(events) {
    var index = -1;
    /** @type {Array<Event>} */ var newEvents = [];
    while(++index < events.length){
        var token = events[index][1];
        newEvents.push(events[index]);
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            var offset = token.type === "labelImage" ? 4 : 2;
            token.type = "data";
            index += offset;
        }
    }
    // If the events are equal, we don't have to copy newEvents to events
    if (events.length !== newEvents.length) (0, $c39c196334f8c75e$export$869882364835d202)(events, 0, events.length, newEvents);
    return events;
}
/** @type {Resolver} */ function $44b0056c0b792264$var$resolveToLabelEnd(events, context) {
    var index = events.length;
    var offset = 0;
    /** @type {Token} */ var token;
    /** @type {number | undefined} */ var open;
    /** @type {number | undefined} */ var close;
    /** @type {Array<Event>} */ var media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    var group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: (0, $hwO3w._)({}, events[open][1].start),
        end: (0, $hwO3w._)({}, events[events.length - 1][1].end)
    };
    var label = {
        type: "label",
        start: (0, $hwO3w._)({}, events[open][1].start),
        end: (0, $hwO3w._)({}, events[close][1].end)
    };
    var text = {
        type: "labelText",
        start: (0, $hwO3w._)({}, events[open + offset + 2][1].end),
        end: (0, $hwO3w._)({}, events[close - 2][1].start)
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $c39c196334f8c75e$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $c39c196334f8c75e$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $c39c196334f8c75e$export$4cbf152802aa238)(media, (0, $73eb3c6139ed2caa$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $c39c196334f8c75e$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $c39c196334f8c75e$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $c39c196334f8c75e$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $c39c196334f8c75e$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $44b0056c0b792264$var$tokenizeLabelEnd(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    /** @type {Token} */ var labelStart;
    /** @type {boolean} */ var defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $daea560f96654179$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($44b0056c0b792264$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($44b0056c0b792264$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($44b0056c0b792264$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $44b0056c0b792264$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $4d05890350ae4444$export$a30284361b3814b7)(code) ? (0, $0860595013d3d7a7$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $8bed1a74bd77c0ff$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $4d05890350ae4444$export$a30284361b3814b7)(code) ? (0, $0860595013d3d7a7$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $f67077f4e43b27ce$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $4d05890350ae4444$export$a30284361b3814b7)(code) ? (0, $0860595013d3d7a7$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $44b0056c0b792264$var$tokenizeReferenceFull(effects, ok, nok) {
    var self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $ee518dd96e1b6bc2$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $daea560f96654179$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $44b0056c0b792264$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $b8265c54b3eb64df$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    resolveAll: (0, $44b0056c0b792264$export$470a5dafbbf62654).resolveAll,
    tokenize: $b8265c54b3eb64df$var$tokenizeLabelStartImage
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b8265c54b3eb64df$var$tokenizeLabelStartImage(effects, ok, nok) {
    var self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $9e0b8e65adb5e259$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    resolveAll: (0, $44b0056c0b792264$export$470a5dafbbf62654).resolveAll,
    tokenize: $9e0b8e65adb5e259$var$tokenizeLabelStartLink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9e0b8e65adb5e259$var$tokenizeLabelStartLink(effects, ok, nok) {
    var self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

var $0b8a6558fe108a16$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $0b8a6558fe108a16$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0b8a6558fe108a16$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

var $32ebce8db4303bce$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $32ebce8db4303bce$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $32ebce8db4303bce$var$tokenizeThematicBreak(effects, ok, nok) {
    var size = 0;
    /** @type {NonNullable<Code>} */ var marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $4d05890350ae4444$export$2c6cf65c1127992a)(code) ? (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


var $c86fe0601afba644$export$8837f4fc672e936d = {
    continuation: {
        tokenize: $c86fe0601afba644$var$tokenizeListContinuation
    },
    exit: $c86fe0601afba644$var$tokenizeListEnd,
    name: 'list',
    tokenize: $c86fe0601afba644$var$tokenizeListStart
};
/** @type {Construct} */ var $c86fe0601afba644$var$listItemPrefixWhitespaceConstruct = {
    partial: true,
    tokenize: $c86fe0601afba644$var$tokenizeListItemPrefixWhitespace
};
/** @type {Construct} */ var $c86fe0601afba644$var$indentConstruct = {
    partial: true,
    tokenize: $c86fe0601afba644$var$tokenizeIndent
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $c86fe0601afba644$var$tokenizeListStart(effects, ok, nok) {
    var self = this;
    var tail = self.events[self.events.length - 1];
    var initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    var size = 0;
    return start;
    /** @type {State} */ function start(code) {
        var kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $4d05890350ae4444$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $32ebce8db4303bce$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $4d05890350ae4444$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $ba12a10e9e950846$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($c86fe0601afba644$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $c86fe0601afba644$var$tokenizeListContinuation(effects, ok, nok) {
    var self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $ba12a10e9e950846$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($c86fe0601afba644$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, effects.attempt($c86fe0601afba644$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $c86fe0601afba644$var$tokenizeIndent(effects, ok, nok) {
    var self = this;
    return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        var tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */ function $c86fe0601afba644$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $c86fe0601afba644$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    var self = this;
    // Always populated by defaults.
    return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        var tail = self.events[self.events.length - 1];
        return !(0, $4d05890350ae4444$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $hwO3w = parcelRequire("hwO3w");


var $a075be994fc4e599$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    resolveTo: $a075be994fc4e599$var$resolveToSetextUnderline,
    tokenize: $a075be994fc4e599$var$tokenizeSetextUnderline
};
/** @type {Resolver} */ function $a075be994fc4e599$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    var index = events.length;
    /** @type {number | undefined} */ var content;
    /** @type {number | undefined} */ var text;
    /** @type {number | undefined} */ var definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    var heading = {
        type: "setextHeading",
        start: (0, $hwO3w._)({}, events[content][1].start),
        end: (0, $hwO3w._)({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = (0, $hwO3w._)({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $a075be994fc4e599$var$tokenizeSetextUnderline(effects, ok, nok) {
    var self = this;
    /** @type {NonNullable<Code>} */ var marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        var index = self.events.length;
        /** @type {boolean | undefined} */ var paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $4d05890350ae4444$export$2c6cf65c1127992a)(code) ? (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



var $79595f8c1017a19b$var$_obj;
var $79595f8c1017a19b$export$5a7bfc01df82fcd1 = ($79595f8c1017a19b$var$_obj = {}, (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 42, (0, $c86fe0601afba644$export$8837f4fc672e936d)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 43, (0, $c86fe0601afba644$export$8837f4fc672e936d)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 45, (0, $c86fe0601afba644$export$8837f4fc672e936d)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 48, (0, $c86fe0601afba644$export$8837f4fc672e936d)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 49, (0, $c86fe0601afba644$export$8837f4fc672e936d)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 50, (0, $c86fe0601afba644$export$8837f4fc672e936d)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 51, (0, $c86fe0601afba644$export$8837f4fc672e936d)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 52, (0, $c86fe0601afba644$export$8837f4fc672e936d)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 53, (0, $c86fe0601afba644$export$8837f4fc672e936d)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 54, (0, $c86fe0601afba644$export$8837f4fc672e936d)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 55, (0, $c86fe0601afba644$export$8837f4fc672e936d)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 56, (0, $c86fe0601afba644$export$8837f4fc672e936d)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 57, (0, $c86fe0601afba644$export$8837f4fc672e936d)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj, 62, (0, $868018ebb073017a$export$200dcd0a5903c968)), $79595f8c1017a19b$var$_obj);
var $79595f8c1017a19b$export$5a2181fb44b58173 = (0, $dUlz9._)({}, 91, (0, $6eb3a63712e66a2c$export$69f215ed977cdb73));
var $79595f8c1017a19b$var$_obj1;
var $79595f8c1017a19b$export$cf8bead395eff824 = ($79595f8c1017a19b$var$_obj1 = {}, (0, $dUlz9._)($79595f8c1017a19b$var$_obj1, -2, (0, $e4b686948fa382d3$export$47910b7ab28d1853)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj1, -1, (0, $e4b686948fa382d3$export$47910b7ab28d1853)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj1, 32, (0, $e4b686948fa382d3$export$47910b7ab28d1853)), $79595f8c1017a19b$var$_obj1);
var $79595f8c1017a19b$var$_obj2;
var $79595f8c1017a19b$export$ccc7b0636abaffc3 = ($79595f8c1017a19b$var$_obj2 = {}, (0, $dUlz9._)($79595f8c1017a19b$var$_obj2, 35, (0, $28e5d8a4dc03b954$export$3871e9deb360695c)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj2, 42, (0, $32ebce8db4303bce$export$ba7b13e047416c03)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj2, 45, [
    (0, $a075be994fc4e599$export$e104e2de391dfde9),
    (0, $32ebce8db4303bce$export$ba7b13e047416c03)
]), (0, $dUlz9._)($79595f8c1017a19b$var$_obj2, 60, (0, $3956eaa9bf10730c$export$476ac411cb7d0d8f)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj2, 61, (0, $a075be994fc4e599$export$e104e2de391dfde9)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj2, 95, (0, $32ebce8db4303bce$export$ba7b13e047416c03)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj2, 96, (0, $719964e22fa5d80f$export$c23e4921f8d87e7c)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj2, 126, (0, $719964e22fa5d80f$export$c23e4921f8d87e7c)), $79595f8c1017a19b$var$_obj2);
var $79595f8c1017a19b$var$_obj3;
var $79595f8c1017a19b$export$22b082955e083ec3 = ($79595f8c1017a19b$var$_obj3 = {}, (0, $dUlz9._)($79595f8c1017a19b$var$_obj3, 38, (0, $428dd080625833bb$export$e31905600aaf3d8e)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj3, 92, (0, $2d5bce5badcc42a1$export$2005478564e78d96)), $79595f8c1017a19b$var$_obj3);
var $79595f8c1017a19b$var$_obj4;
var $79595f8c1017a19b$export$6f093cfa640b7166 = ($79595f8c1017a19b$var$_obj4 = {}, (0, $dUlz9._)($79595f8c1017a19b$var$_obj4, -5, (0, $0b8a6558fe108a16$export$8e62e0ad51c97b2)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj4, -4, (0, $0b8a6558fe108a16$export$8e62e0ad51c97b2)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj4, -3, (0, $0b8a6558fe108a16$export$8e62e0ad51c97b2)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj4, 33, (0, $b8265c54b3eb64df$export$3d754936e25aa5f5)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj4, 38, (0, $428dd080625833bb$export$e31905600aaf3d8e)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj4, 42, (0, $73c3bca16cd36ba0$export$45b92471da762af7)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj4, 60, [
    (0, $2e406a7687c4c7c8$export$17ddf85e4c916ad6),
    (0, $64f8e4d4720b96f7$export$398af27f284914fe)
]), (0, $dUlz9._)($79595f8c1017a19b$var$_obj4, 91, (0, $9e0b8e65adb5e259$export$5c0cee0701a3b584)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj4, 92, [
    (0, $60513aff062d2516$export$86c573ab9e06f418),
    (0, $2d5bce5badcc42a1$export$2005478564e78d96)
]), (0, $dUlz9._)($79595f8c1017a19b$var$_obj4, 93, (0, $44b0056c0b792264$export$470a5dafbbf62654)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj4, 95, (0, $73c3bca16cd36ba0$export$45b92471da762af7)), (0, $dUlz9._)($79595f8c1017a19b$var$_obj4, 96, (0, $ffa0ef457db974ba$export$d24f93e715f9df88)), $79595f8c1017a19b$var$_obj4);
var $79595f8c1017a19b$export$d44f260a3f9b69f5 = {
    null: [
        (0, $73c3bca16cd36ba0$export$45b92471da762af7),
        (0, $f71e7012ddebb81f$export$50397835cbfdbc24)
    ]
};
var $79595f8c1017a19b$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
var $79595f8c1017a19b$export$e20fbacbb41798b = {
    null: []
};


/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @callback Restore
 *   Restore the state.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef Info
 *   Info.
 * @property {Restore} restore
 *   Restore.
 * @property {number} from
 *   From.
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 *   Construct.
 * @param {Info} info
 *   Info.
 * @returns {undefined}
 *   Nothing.
 */ 
var $XnYkK = parcelRequire("XnYkK");



function $c4130eb100b50d0b$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ var point = {
        _bufferIndex: -1,
        _index: 0,
        line: from && from.line || 1,
        column: from && from.column || 1,
        offset: from && from.offset || 0
    };
    /** @type {Record<string, number>} */ var columnStart = {};
    /** @type {Array<Construct>} */ var resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ var chunks = [];
    /** @type {Array<Token>} */ var stack = [];
    /** @type {boolean | undefined} */ var consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ var effects = {
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        consume: consume,
        enter: enter,
        exit: exit,
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ var context = {
        code: null,
        containerState: {},
        defineSkip: defineSkip,
        events: [],
        now: now,
        parser: parser,
        previous: null,
        sliceSerialize: sliceSerialize,
        sliceStream: sliceStream,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ var state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ var expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $c39c196334f8c75e$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $73eb3c6139ed2caa$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $c4130eb100b50d0b$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $c4130eb100b50d0b$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        var _bufferIndex = point._bufferIndex, _index = point._index, line = point.line, column = point.column, offset = point.offset;
        return {
            _bufferIndex: _bufferIndex,
            _index: _index,
            line: line,
            column: column,
            offset: offset
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */ function main() {
        /** @type {number} */ var chunkIndex;
        while(point._index < chunks.length){
            var chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            if (point._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
            // strings.
            /** @type {string} */ chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        var token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        var token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */ function hook(constructs, returnState, bogusState) {
            /** @type {ReadonlyArray<Construct>} */ var listOfConstructs;
            /** @type {number} */ var constructIndex;
            /** @type {Construct} */ var currentConstruct;
            /** @type {Info} */ var info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : 'tokenize' in constructs ? // Looks like a construct.
            handleListOfConstructs([
                /** @type {Construct} */ constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    var left = code !== null && map[code];
                    var all = code !== null && map.null;
                    var list = // To do: add more extension tests.
                    /* c8 ignore next 2 */ (0, $XnYkK._)(Array.isArray(left) ? left : left ? [
                        left
                    ] : []).concat((0, $XnYkK._)(Array.isArray(all) ? all : all ? [
                        all
                    ] : []));
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $c39c196334f8c75e$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */ function store() {
        var startPoint = now();
        var startPrevious = context.previous;
        var startCurrentConstruct = context.currentConstruct;
        var startEventsIndex = context.events.length;
        var startStack = Array.from(stack);
        return {
            from: startEventsIndex,
            restore: restore
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */ function $c4130eb100b50d0b$var$sliceChunks(chunks, token) {
    var startIndex = token.start._index;
    var startBufferIndex = token.start._bufferIndex;
    var endIndex = token.end._index;
    var endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ var view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            var head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */ function $c4130eb100b50d0b$var$serializeChunks(chunks, expandTabs) {
    var index = -1;
    /** @type {Array<string>} */ var result = [];
    /** @type {boolean | undefined} */ var atTab;
    while(++index < chunks.length){
        var chunk = chunks[index];
        /** @type {string} */ var value = void 0;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "\t";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


function $70bcd5a478c20272$export$98e6a39c04603d36(options) {
    var settings = options || {};
    var constructs = /** @type {FullNormalizedExtension} */ (0, $a8b619d0d726651b$export$86a865d89ef3c690)([
        $79595f8c1017a19b$exports
    ].concat((0, $XnYkK._)(settings.extensions || [])));
    /** @type {ParseContext} */ var parser = {
        constructs: constructs,
        content: create((0, $45160c7696e33c48$export$a7db06668cad9adb)),
        defined: [],
        document: create((0, $5cbb399fe3185e66$export$5a7bfc01df82fcd1)),
        flow: create((0, $352a93200005805c$export$ccc7b0636abaffc3)),
        lazy: {},
        string: create((0, $f71e7012ddebb81f$export$22b082955e083ec3)),
        text: create((0, $f71e7012ddebb81f$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $c4130eb100b50d0b$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @import {Event} from 'micromark-util-types'
 */ 
function $ff39a3a7eeb3f320$export$bd0e6e1378a871d7(events) {
    while(!(0, $afed179dce17b426$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */ /**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */ var $1e9629dba7922d49$var$search = /[\0\t\n\r]/g;
function $1e9629dba7922d49$export$fc37fe19dfda43ee() {
    var column = 1;
    var buffer = '';
    /** @type {boolean | undefined} */ var start = true;
    /** @type {boolean | undefined} */ var atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ var chunks = [];
        /** @type {RegExpMatchArray | null} */ var match;
        /** @type {number} */ var next;
        /** @type {number} */ var startPosition;
        /** @type {number} */ var endPosition;
        /** @type {Code} */ var code;
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $1e9629dba7922d49$var$search.lastIndex = startPosition;
            match = $1e9629dba7922d49$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $3dbc5e49818f965f$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $7cad00caacad897c$export$ef7acd7185315e22)(options)((0, $ff39a3a7eeb3f320$export$bd0e6e1378a871d7)((0, $70bcd5a478c20272$export$98e6a39c04603d36)(options).document().write((0, $1e9629dba7922d49$export$fc37fe19dfda43ee)()(value, encoding, true))));
}





var $ef2000c23ca42de8$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $ef2000c23ca42de8$export$a0fb664af7d0cc44(value) {
    return value.replace($ef2000c23ca42de8$var$characterEscapeOrReference, $ef2000c23ca42de8$var$decode);
}
/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */ function $ef2000c23ca42de8$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    var head = $2.charCodeAt(0);
    if (head === 35) {
        var head1 = $2.charCodeAt(1);
        var hex = head1 === 120 || head1 === 88;
        return (0, $feafc29f35cd5b43$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $ce583e5222f7bcb3$export$289b6a6320f709b4)($2) || $0;
}





var $2ba7d4852e318f60$var$own = {}.hasOwnProperty;
function $2ba7d4852e318f60$export$d744d789c09bfde6(value, encoding, options) {
    if (encoding && (typeof encoding === "undefined" ? "undefined" : (0, $03bAP._)(encoding)) === 'object') {
        options = encoding;
        encoding = undefined;
    }
    return $2ba7d4852e318f60$var$compiler(options)((0, $ff39a3a7eeb3f320$export$bd0e6e1378a871d7)((0, $70bcd5a478c20272$export$98e6a39c04603d36)(options).document().write((0, $1e9629dba7922d49$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $2ba7d4852e318f60$var$compiler(options) {
    /** @type {Config} */ var config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            characterReference: onexitcharacterreference,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $2ba7d4852e318f60$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ var data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ var tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ var context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ var listStack = [];
        var index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                var tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            var handler = config[events[index][0]];
            if ($2ba7d4852e318f60$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            var tail1 = context.tokenStack[context.tokenStack.length - 1];
            var handler1 = tail1[1] || $2ba7d4852e318f60$var$defaultOnError;
            handler1.call(context, undefined, tail1[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $2ba7d4852e318f60$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $2ba7d4852e318f60$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        var index = start - 1;
        var containerBalance = -1;
        var listSpread = false;
        /** @type {Token | undefined} */ var _$listItem;
        /** @type {number | undefined} */ var lineIndex;
        /** @type {number | undefined} */ var firstBlankLineIndex;
        /** @type {boolean | undefined} */ var atMarker;
        while(++index <= length){
            var event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter') {
                        if (_$listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (_$listItem) {
                    var tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        var tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) _$listItem._spread = true;
                    // Fix position.
                    _$listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        _$listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ var item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    _$listItem = item;
                    events.splice(index, 0, [
                        'enter',
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @type {CompileContext['buffer']}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @type {CompileContext['enter']}
   */ function enter(node, token, errorHandler) {
        var parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ var siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler || undefined
        ]);
        node.position = {
            start: $2ba7d4852e318f60$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @type {CompileContext['exit']}
   */ function exit(token, onExitError) {
        var node = this.stack.pop();
        var open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $f5a8c660ec1fed12$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                var handler = open[1] || $2ba7d4852e318f60$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $2ba7d4852e318f60$var$point(token.end);
    }
    /**
   * @type {CompileContext['resume']}
   */ function resume() {
        return (0, $b39838f337d55846$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            var ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        var data = this.resume();
        var node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        var data = this.resume();
        var node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        var data = this.resume();
        var node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        var data = this.resume();
        var node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        var label = this.resume();
        var node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $daea560f96654179$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        var data = this.resume();
        var node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        var data = this.resume();
        var node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        var node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            var depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        var node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        var node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ var siblings = node.children;
        var tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $2ba7d4852e318f60$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        var tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $2ba7d4852e318f60$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        var context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            var tail = context.children[context.children.length - 1];
            tail.position.end = $2ba7d4852e318f60$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        var data = this.resume();
        var node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        var data = this.resume();
        var node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        var data = this.resume();
        var node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        var node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ var referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        var node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ var referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        var string = this.sliceSerialize(token);
        var ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $ef2000c23ca42de8$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $daea560f96654179$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        var fragment = this.stack[this.stack.length - 1];
        var value = this.resume();
        var node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ var children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        var data = this.resume();
        var node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        var data = this.resume();
        var node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        var label = this.resume();
        var node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $daea560f96654179$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        var data = this.sliceSerialize(token);
        var type = this.data.characterReferenceType;
        /** @type {string} */ var value;
        if (type) {
            value = (0, $feafc29f35cd5b43$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            var result = (0, $ce583e5222f7bcb3$export$289b6a6320f709b4)(data);
            value = result;
        }
        var tail = this.stack[this.stack.length - 1];
        tail.value += value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreference(token) {
        var tail = this.stack.pop();
        tail.position.end = $2ba7d4852e318f60$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        var node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        var node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $2ba7d4852e318f60$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $2ba7d4852e318f60$var$configure(combined, extensions) {
    var index = -1;
    while(++index < extensions.length){
        var value = extensions[index];
        if (Array.isArray(value)) $2ba7d4852e318f60$var$configure(combined, value);
        else $2ba7d4852e318f60$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $2ba7d4852e318f60$var$extension(combined, extension) {
    /** @type {keyof Extension} */ var key;
    for(key in extension)if ($2ba7d4852e318f60$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                var _combined_key;
                var right = extension[key];
                if (right) (_combined_key = combined[key]).push.apply(_combined_key, (0, $XnYkK._)(right));
                break;
            }
        case 'transforms':
            {
                var _combined_key1;
                var right1 = extension[key];
                if (right1) (_combined_key1 = combined[key]).push.apply(_combined_key1, (0, $XnYkK._)(right1));
                break;
            }
        case 'enter':
        case 'exit':
            {
                var right2 = extension[key];
                if (right2) Object.assign(combined[key], right2);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $2ba7d4852e318f60$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $f5a8c660ec1fed12$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $f5a8c660ec1fed12$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $f5a8c660ec1fed12$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


function $a13f1c2dc3fe29d5$export$2e2bcd8739ae039(options) {
    /** @type {Processor} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    var self = this;
    self.parser = parser;
    /**
   * @type {Parser}
   */ function parser(doc) {
        return (0, $2ba7d4852e318f60$export$d744d789c09bfde6)(doc, (0, $lf4fc._)((0, $hwO3w._)({}, self.data('settings'), options), {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data('micromarkExtensions') || [],
            mdastExtensions: self.data('fromMarkdownExtensions') || []
        }));
    }
}


/**
 * @import {Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {Options as ToHastOptions} from 'mdast-util-to-hast'
 * @import {Processor} from 'unified'
 * @import {VFile} from 'vfile'
 */ /**
 * @typedef {Omit<ToHastOptions, 'file'>} Options
 *
 * @callback TransformBridge
 *   Bridge-mode.
 *
 *   Runs the destination with the new hast tree.
 *   Discards result.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {Promise<undefined>}
 *   Nothing.
 *
 * @callback TransformMutate
 *  Mutate-mode.
 *
 *  Further transformers run on the hast tree.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {HastRoot}
 *   Tree (hast).
 */ 
var $lFIaz = parcelRequire("lFIaz");

var $hwO3w = parcelRequire("hwO3w");

var $3SMYb = parcelRequire("3SMYb");
/**
 * @import {Nodes as HastNodes} from 'hast'
 * @import {Nodes as MdastNodes} from 'mdast'
 * @import {Options} from './state.js'
 */ 
/**
 * @import {ElementContent, Element} from 'hast'
 * @import {State} from './state.js'
 */ /**
 * @callback FootnoteBackContentTemplate
 *   Generate content for the backreference dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent> | ElementContent | string}
 *   Content for the backreference when linking back from definitions to their
 *   reference.
 *
 * @callback FootnoteBackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ 
var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $XnYkK = parcelRequire("XnYkK");

var $6iP9u = parcelRequire("6iP9u");

var $03bAP = parcelRequire("03bAP");
var $948da3bc9578e560$export$1cd1943b3a73bbe8 = -1;
var $948da3bc9578e560$export$a44b4f3d5b73db95 = 0;
var $948da3bc9578e560$export$b119f07080a207ba = 1;
var $948da3bc9578e560$export$8b8a958a7f6f130c = 2;
var $948da3bc9578e560$export$501a7fac1df67a49 = 3;
var $948da3bc9578e560$export$cd2b220b1ea851b2 = 4;
var $948da3bc9578e560$export$ce970371e0e850bc = 5;
var $948da3bc9578e560$export$5e8f180ef0142226 = 6;
var $948da3bc9578e560$export$103bedf43ba882db = 7;
var $948da3bc9578e560$export$9f2207c8fceeefa8 = 8; // export const SYMBOL = 9;


var $553a40bb50ffdf0f$var$env = (typeof self === "undefined" ? "undefined" : (0, $03bAP._)(self)) === 'object' ? self : globalThis;
var $553a40bb50ffdf0f$var$guard = function(name, init) {
    switch(name){
        case 'Function':
        case 'SharedWorker':
        case 'Worker':
        case 'eval':
        case 'setInterval':
        case 'setTimeout':
            throw new TypeError('unable to deserialize ' + name);
    }
    return new $553a40bb50ffdf0f$var$env[name](init);
};
var $553a40bb50ffdf0f$var$deserializer = function($, _) {
    var as = function(out, index) {
        $.set(index, out);
        return out;
    };
    var unpair = function(index) {
        if ($.has(index)) return $.get(index);
        var __index = (0, $6iP9u._)(_[index], 2), type = __index[0], value = __index[1];
        switch(type){
            case 0, $948da3bc9578e560$export$a44b4f3d5b73db95:
            case 0, $948da3bc9578e560$export$1cd1943b3a73bbe8:
                return as(value, index);
            case 0, $948da3bc9578e560$export$b119f07080a207ba:
                {
                    var arr = as([], index);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$index = _step.value;
                            arr.push(unpair(_$index));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return arr;
                }
            case 0, $948da3bc9578e560$export$8b8a958a7f6f130c:
                {
                    var object = as({}, index);
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = value[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _step_value = (0, $6iP9u._)(_step1.value, 2), key = _step_value[0], _$index1 = _step_value[1];
                            object[unpair(key)] = unpair(_$index1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return object;
                }
            case 0, $948da3bc9578e560$export$501a7fac1df67a49:
                return as(new Date(value), index);
            case 0, $948da3bc9578e560$export$cd2b220b1ea851b2:
                {
                    var source = value.source, flags = value.flags;
                    return as(new RegExp(source, flags), index);
                }
            case 0, $948da3bc9578e560$export$ce970371e0e850bc:
                {
                    var map = as(new Map, index);
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = value[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var _step_value1 = (0, $6iP9u._)(_step2.value, 2), key1 = _step_value1[0], _$index2 = _step_value1[1];
                            map.set(unpair(key1), unpair(_$index2));
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                    return map;
                }
            case 0, $948da3bc9578e560$export$5e8f180ef0142226:
                {
                    var set = as(new Set, index);
                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(var _iterator3 = value[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            var _$index3 = _step3.value;
                            set.add(unpair(_$index3));
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                    return set;
                }
            case 0, $948da3bc9578e560$export$103bedf43ba882db:
                {
                    var name = value.name, message = value.message;
                    return as(typeof $553a40bb50ffdf0f$var$env[name] === 'function' ? $553a40bb50ffdf0f$var$guard(name, message) : new Error(message), index);
                }
            case 0, $948da3bc9578e560$export$9f2207c8fceeefa8:
                return as(BigInt(value), index);
            case 'BigInt':
                return as(Object(BigInt(value)), index);
            case 'ArrayBuffer':
                return as(new Uint8Array(value).buffer, value);
            case 'DataView':
                {
                    var buffer = new Uint8Array(value).buffer;
                    return as(new DataView(buffer), value);
                }
        }
        return as($553a40bb50ffdf0f$var$guard(type, value), index);
    };
    return unpair;
};
var $553a40bb50ffdf0f$export$efcd34ab6248d3cd = function(serialized) {
    return $553a40bb50ffdf0f$var$deserializer(new Map, serialized)(0);
};



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");

var $03bAP = parcelRequire("03bAP");

var $07d5758d32088246$var$EMPTY = '';
var $07d5758d32088246$var$toString = {}.toString;
var $07d5758d32088246$var$keys = Object.keys;
var $07d5758d32088246$var$typeOf = function(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value);
    if (type !== 'object' || !value) return [
        (0, $948da3bc9578e560$export$a44b4f3d5b73db95),
        type
    ];
    var asString = $07d5758d32088246$var$toString.call(value).slice(8, -1);
    switch(asString){
        case 'Array':
            return [
                (0, $948da3bc9578e560$export$b119f07080a207ba),
                $07d5758d32088246$var$EMPTY
            ];
        case 'Object':
            return [
                (0, $948da3bc9578e560$export$8b8a958a7f6f130c),
                $07d5758d32088246$var$EMPTY
            ];
        case 'Date':
            return [
                (0, $948da3bc9578e560$export$501a7fac1df67a49),
                $07d5758d32088246$var$EMPTY
            ];
        case 'RegExp':
            return [
                (0, $948da3bc9578e560$export$cd2b220b1ea851b2),
                $07d5758d32088246$var$EMPTY
            ];
        case 'Map':
            return [
                (0, $948da3bc9578e560$export$ce970371e0e850bc),
                $07d5758d32088246$var$EMPTY
            ];
        case 'Set':
            return [
                (0, $948da3bc9578e560$export$5e8f180ef0142226),
                $07d5758d32088246$var$EMPTY
            ];
        case 'DataView':
            return [
                (0, $948da3bc9578e560$export$b119f07080a207ba),
                asString
            ];
    }
    if (asString.includes('Array')) return [
        (0, $948da3bc9578e560$export$b119f07080a207ba),
        asString
    ];
    if (value instanceof Error) return [
        (0, $948da3bc9578e560$export$103bedf43ba882db),
        value.name || 'Error'
    ];
    return [
        (0, $948da3bc9578e560$export$8b8a958a7f6f130c),
        asString
    ];
};
var $07d5758d32088246$var$shouldSkip = function(param) {
    var _param = (0, $6iP9u._)(param, 2), TYPE = _param[0], type = _param[1];
    return TYPE === (0, $948da3bc9578e560$export$a44b4f3d5b73db95) && (type === 'function' || type === 'symbol');
};
var $07d5758d32088246$var$serializer = function(strict, json, $, _) {
    var as = function(out, value) {
        var index = _.push(out) - 1;
        $.set(value, index);
        return index;
    };
    var pair = function(value) {
        if ($.has(value)) return $.get(value);
        var _typeOf = (0, $6iP9u._)($07d5758d32088246$var$typeOf(value), 2), TYPE = _typeOf[0], type = _typeOf[1];
        switch(TYPE){
            case 0, $948da3bc9578e560$export$a44b4f3d5b73db95:
                {
                    var entry = value;
                    switch(type){
                        case 'bigint':
                            TYPE = (0, $948da3bc9578e560$export$9f2207c8fceeefa8);
                            entry = value.toString();
                            break;
                        case 'function':
                        case 'symbol':
                            if (strict) throw new TypeError('unable to serialize ' + type);
                            entry = null;
                            break;
                        case 'undefined':
                            return as([
                                (0, $948da3bc9578e560$export$1cd1943b3a73bbe8)
                            ], value);
                    }
                    return as([
                        TYPE,
                        entry
                    ], value);
                }
            case 0, $948da3bc9578e560$export$b119f07080a207ba:
                {
                    if (type) {
                        var spread = value;
                        if (type === 'DataView') spread = new Uint8Array(value.buffer);
                        else if (type === 'ArrayBuffer') spread = new Uint8Array(value);
                        return as([
                            type,
                            (0, $XnYkK._)(spread)
                        ], value);
                    }
                    var arr = [];
                    var index = as([
                        TYPE,
                        arr
                    ], value);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry1 = _step.value;
                            arr.push(pair(entry1));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return index;
                }
            case 0, $948da3bc9578e560$export$8b8a958a7f6f130c:
                {
                    if (type) switch(type){
                        case 'BigInt':
                            return as([
                                type,
                                value.toString()
                            ], value);
                        case 'Boolean':
                        case 'Number':
                        case 'String':
                            return as([
                                type,
                                value.valueOf()
                            ], value);
                    }
                    if (json && 'toJSON' in value) return pair(value.toJSON());
                    var entries = [];
                    var index1 = as([
                        TYPE,
                        entries
                    ], value);
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = $07d5758d32088246$var$keys(value)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var key = _step1.value;
                            if (strict || !$07d5758d32088246$var$shouldSkip($07d5758d32088246$var$typeOf(value[key]))) entries.push([
                                pair(key),
                                pair(value[key])
                            ]);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return index1;
                }
            case 0, $948da3bc9578e560$export$501a7fac1df67a49:
                return as([
                    TYPE,
                    isNaN(value.getTime()) ? $07d5758d32088246$var$EMPTY : value.toISOString()
                ], value);
            case 0, $948da3bc9578e560$export$cd2b220b1ea851b2:
                {
                    var source = value.source, flags = value.flags;
                    return as([
                        TYPE,
                        {
                            source: source,
                            flags: flags
                        }
                    ], value);
                }
            case 0, $948da3bc9578e560$export$ce970371e0e850bc:
                {
                    var entries1 = [];
                    var index2 = as([
                        TYPE,
                        entries1
                    ], value);
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = value[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var _step_value = (0, $6iP9u._)(_step2.value, 2), key1 = _step_value[0], entry2 = _step_value[1];
                            if (strict || !($07d5758d32088246$var$shouldSkip($07d5758d32088246$var$typeOf(key1)) || $07d5758d32088246$var$shouldSkip($07d5758d32088246$var$typeOf(entry2)))) entries1.push([
                                pair(key1),
                                pair(entry2)
                            ]);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                    return index2;
                }
            case 0, $948da3bc9578e560$export$5e8f180ef0142226:
                {
                    var entries2 = [];
                    var index3 = as([
                        TYPE,
                        entries2
                    ], value);
                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(var _iterator3 = value[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            var entry3 = _step3.value;
                            if (strict || !$07d5758d32088246$var$shouldSkip($07d5758d32088246$var$typeOf(entry3))) entries2.push(pair(entry3));
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                    return index3;
                }
        }
        var message = value.message;
        return as([
            TYPE,
            {
                name: type,
                message: message
            }
        ], value);
    };
    return pair;
};
var $07d5758d32088246$export$dfdc1655ccc5b9cb = function(value) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, json = _ref.json, lossy = _ref.lossy;
    var _ = [];
    return $07d5758d32088246$var$serializer(!(json || lossy), !!json, new Map, _)(value), _;
};


var /**
 * @typedef {Array<string,any>} Record a type representation
 */ /**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */ $61b0a4bb3c8ce840$export$2e2bcd8739ae039 = typeof structuredClone === "function" ? /* c8 ignore start */ function(any, options) {
    return options && ('json' in options || 'lossy' in options) ? (0, $553a40bb50ffdf0f$export$efcd34ab6248d3cd)((0, $07d5758d32088246$export$dfdc1655ccc5b9cb)(any, options)) : structuredClone(any);
} : function(any, options) {
    return (0, $553a40bb50ffdf0f$export$efcd34ab6248d3cd)((0, $07d5758d32088246$export$dfdc1655ccc5b9cb)(any, options));
};



function $0d5cc8a7aeac4b3b$export$4a6e1c4b9e5bc5d1(_, rereferenceIndex) {
    /** @type {Array<ElementContent>} */ var result = [
        {
            type: 'text',
            value: "\u21A9"
        }
    ];
    if (rereferenceIndex > 1) result.push({
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            {
                type: 'text',
                value: String(rereferenceIndex)
            }
        ]
    });
    return result;
}
function $0d5cc8a7aeac4b3b$export$d83e66a407212d3b(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $0d5cc8a7aeac4b3b$export$adb608be33961c98(state) {
    var clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    var footnoteBackContent = state.options.footnoteBackContent || $0d5cc8a7aeac4b3b$export$4a6e1c4b9e5bc5d1;
    var footnoteBackLabel = state.options.footnoteBackLabel || $0d5cc8a7aeac4b3b$export$d83e66a407212d3b;
    var footnoteLabel = state.options.footnoteLabel || 'Footnotes';
    var footnoteLabelTagName = state.options.footnoteLabelTagName || 'h2';
    var footnoteLabelProperties = state.options.footnoteLabelProperties || {
        className: [
            'sr-only'
        ]
    };
    /** @type {Array<ElementContent>} */ var listItems = [];
    var referenceIndex = -1;
    while(++referenceIndex < state.footnoteOrder.length){
        var _content;
        var definition = state.footnoteById.get(state.footnoteOrder[referenceIndex]);
        if (!definition) continue;
        var content = state.all(definition);
        var id = String(definition.identifier).toUpperCase();
        var safeId = (0, $9ec3f308f236101d$export$e42a3e39590d28b5)(id.toLowerCase());
        var rereferenceIndex = 0;
        /** @type {Array<ElementContent>} */ var backReferences = [];
        var counts = state.footnoteCounts.get(id);
        // eslint-disable-next-line no-unmodified-loop-condition
        while(counts !== undefined && ++rereferenceIndex <= counts){
            if (backReferences.length > 0) backReferences.push({
                type: 'text',
                value: ' '
            });
            var children = typeof footnoteBackContent === 'string' ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
            if (typeof children === 'string') children = {
                type: 'text',
                value: children
            };
            backReferences.push({
                type: 'element',
                tagName: 'a',
                properties: {
                    href: '#' + clobberPrefix + 'fnref-' + safeId + (rereferenceIndex > 1 ? '-' + rereferenceIndex : ''),
                    dataFootnoteBackref: '',
                    ariaLabel: typeof footnoteBackLabel === 'string' ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
                    className: [
                        'data-footnote-backref'
                    ]
                },
                children: Array.isArray(children) ? children : [
                    children
                ]
            });
        }
        var tail = content[content.length - 1];
        if (tail && tail.type === 'element' && tail.tagName === 'p') {
            var _tail_children;
            var tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === 'text') tailTail.value += ' ';
            else tail.children.push({
                type: 'text',
                value: ' '
            });
            (_tail_children = tail.children).push.apply(_tail_children, (0, $XnYkK._)(backReferences));
        } else (_content = content).push.apply(_content, (0, $XnYkK._)(backReferences));
        /** @type {Element} */ var listItem = {
            type: 'element',
            tagName: 'li',
            properties: {
                id: clobberPrefix + 'fn-' + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(definition, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: 'element',
        tagName: 'section',
        properties: {
            dataFootnotes: true,
            className: [
                'footnotes'
            ]
        },
        children: [
            {
                type: 'element',
                tagName: footnoteLabelTagName,
                properties: (0, $lf4fc._)((0, $hwO3w._)({}, (0, $61b0a4bb3c8ce840$export$2e2bcd8739ae039)(footnoteLabelProperties)), {
                    id: 'footnote-label'
                }),
                children: [
                    {
                        type: 'text',
                        value: footnoteLabel
                    }
                ]
            },
            {
                type: 'text',
                value: '\n'
            },
            {
                type: 'element',
                tagName: 'ol',
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: 'text',
                value: '\n'
            }
        ]
    };
}


/**
 * @import {
 *   ElementContent as HastElementContent,
 *   Element as HastElement,
 *   Nodes as HastNodes,
 *   Properties as HastProperties,
 *   RootContent as HastRootContent,
 *   Text as HastText
 * } from 'hast'
 * @import {
 *   Definition as MdastDefinition,
 *   FootnoteDefinition as MdastFootnoteDefinition,
 *   Nodes as MdastNodes,
 *   Parents as MdastParents
 * } from 'mdast'
 * @import {VFile} from 'vfile'
 * @import {
 *   FootnoteBackContentTemplate,
 *   FootnoteBackLabelTemplate
 * } from './footer.js'
 */ /**
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | undefined} parent
 *   Parent of `node`.
 * @returns {Array<HastElementContent> | HastElementContent | undefined}
 *   hast node.
 *
 * @typedef {Partial<Record<MdastNodes['type'], Handler>>} Handlers
 *   Handle nodes.
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree (default:
 *   `false`).
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` property on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {VFile | null | undefined} [file]
 *   Corresponding virtual file representing the input document (optional).
 * @property {FootnoteBackContentTemplate | string | null | undefined} [footnoteBackContent]
 *   Content of the backreference back to references (default: `defaultFootnoteBackContent`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackContent(_, rereferenceIndex) {
 *     const result = [{type: 'text', value: '↩'}]
 *
 *     if (rereferenceIndex > 1) {
 *       result.push({
 *         type: 'element',
 *         tagName: 'sup',
 *         properties: {},
 *         children: [{type: 'text', value: String(rereferenceIndex)}]
 *       })
 *     }
 *
 *     return result
 *   }
 *   ```
 *
 *   This content is used in the `a` element of each backreference (the `↩`
 *   links).
 * @property {FootnoteBackLabelTemplate | string | null | undefined} [footnoteBackLabel]
 *   Label to describe the backreference back to references (default:
 *   `defaultFootnoteBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *   }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `ariaLabel` property on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (default: `{className:
 *   ['sr-only']}`).
 *
 *   Change it to show the label and add other properties.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different properties.
 *
 *   > **Note**: `id: 'footnote-label'` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes (optional).
 * @property {Array<MdastNodes['type']> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed)
 *   (optional).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes (optional).
 *
 * @typedef State
 *   Info passed around.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => HastElement | Type} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {Map<string, MdastDefinition>} definitionById
 *   Definitions by their identifier.
 * @property {Map<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Map<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {(node: MdastNodes, parent: MdastParents | undefined) => Array<HastElementContent> | HastElementContent | undefined} one
 *   Transform an mdast node to hast.
 * @property {Options} options
 *   Configuration.
 * @property {(from: MdastNodes, node: HastNodes) => undefined} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastRootContent>(nodes: Array<Type>, loose?: boolean | undefined) => Array<HastText | Type>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 */ 
var $hwO3w = parcelRequire("hwO3w");

var $54Czb = parcelRequire("54Czb");

var $XnYkK = parcelRequire("XnYkK");

/**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 * @import {VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<any>
 *   ? MatchesOne<Value, Check[number]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<infer T>
 *   ? MatchesOne<Value, T>
 *   : Check extends Array<infer T>
 *   ? MatchesOne<Value, T>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ 
var $03bAP = parcelRequire("03bAP");
/**
 * @import {Node, Parent} from 'unist'
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | ReadonlyArray<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ 
var $03bAP = parcelRequire("03bAP");
var $2be89ddeb615ec50$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends ReadonlyArray<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends Array<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is1(node, test, index, parent, context) {
    var check = $2be89ddeb615ec50$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$2be89ddeb615ec50$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $2be89ddeb615ec50$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
var $2be89ddeb615ec50$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function convert(test) {
    if (test === null || test === undefined) return $2be89ddeb615ec50$var$ok;
    if (typeof test === 'function') return $2be89ddeb615ec50$var$castFactory(test);
    if ((typeof test === "undefined" ? "undefined" : (0, $03bAP._)(test)) === 'object') return Array.isArray(test) ? $2be89ddeb615ec50$var$anyFactory(test) : // narrows to `Array`.
    $2be89ddeb615ec50$var$propertiesFactory(/** @type {Props} */ test);
    if (typeof test === 'string') return $2be89ddeb615ec50$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $2be89ddeb615ec50$var$anyFactory(tests) {
    /** @type {Array<Check>} */ var checks = [];
    var index = -1;
    while(++index < tests.length)checks[index] = $2be89ddeb615ec50$export$9c68d69a4c5bbcf9(tests[index]);
    return $2be89ddeb615ec50$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any() {
        for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++){
            parameters[_key] = arguments[_key];
        }
        var index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $2be89ddeb615ec50$var$propertiesFactory(check) {
    var checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $2be89ddeb615ec50$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        var nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ var key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $2be89ddeb615ec50$var$typeFactory(check) {
    return $2be89ddeb615ec50$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $2be89ddeb615ec50$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($2be89ddeb615ec50$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $2be89ddeb615ec50$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $2be89ddeb615ec50$var$looksLikeANode(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) === 'object' && 'type' in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $99e2642dc42b96f8$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ var $9ce2efd2fac4f13b$var$empty = [];
var $9ce2efd2fac4f13b$export$f4d8133c446fe484 = true;
var $9ce2efd2fac4f13b$export$7f100f842f565dc9 = false;
var $9ce2efd2fac4f13b$export$8773f85c2fb2c116 = 'skip';
function $9ce2efd2fac4f13b$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ var check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    var is = (0, $2be89ddeb615ec50$export$9c68d69a4c5bbcf9)(check);
    var step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        var value = /** @type {Record<string, unknown>} */ node && (typeof node === "undefined" ? "undefined" : (0, $03bAP._)(node)) === 'object' ? node : {};
        if (typeof value.type === 'string') {
            var name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $99e2642dc42b96f8$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ var result = $9ce2efd2fac4f13b$var$empty;
            /** @type {Readonly<ActionTuple>} */ var subresult;
            /** @type {number} */ var offset;
            /** @type {Array<UnistParent>} */ var grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $9ce2efd2fac4f13b$var$toResult(visitor(node, parents));
                if (result[0] === $9ce2efd2fac4f13b$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                var nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $9ce2efd2fac4f13b$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        var child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $9ce2efd2fac4f13b$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $9ce2efd2fac4f13b$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $9ce2efd2fac4f13b$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $9ce2efd2fac4f13b$var$empty : [
        value
    ];
}


function $dfcab761b4e96982$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ var reverse;
    /** @type {Test} */ var test;
    /** @type {Visitor} */ var visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $9ce2efd2fac4f13b$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



/**
 * @import {Handlers} from '../state.js'
 */ /**
 * @import {Element} from 'hast'
 * @import {Blockquote} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $cf122b6bdafeae0f$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'blockquote',
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Text} from 'hast'
 * @import {Break} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $af2c04f479787016$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'br',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: 'text',
            value: '\n'
        }
    ];
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Code} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $e5f4dd772d1ec96a$export$6565f9f03506010b(state, node) {
    var value = node.value ? node.value + '\n' : '';
    /** @type {Properties} */ var properties = {};
    // Someone can write `js&#x20;python&#x9;ruby`.
    var language = node.lang ? node.lang.split(/\s+/) : [];
    // GH/CM still drop the non-first languages.
    if (language.length > 0) properties.className = [
        'language-' + language[0]
    ];
    // Create `<code>`.
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'code',
        properties: properties,
        children: [
            {
                type: 'text',
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: 'element',
        tagName: 'pre',
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @import {Element} from 'hast'
 * @import {Delete} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $5df300b872c9f920$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'del',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Emphasis} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $7025b8e2490fa77e$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'em',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {FootnoteReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $f41b78071b17bf45$export$7f87ee744075c1ba(state, node) {
    var clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    var id = String(node.identifier).toUpperCase();
    var safeId = (0, $9ec3f308f236101d$export$e42a3e39590d28b5)(id.toLowerCase());
    var index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ var counter;
    var reuseCounter = state.footnoteCounts.get(id);
    if (reuseCounter === undefined) {
        reuseCounter = 0;
        state.footnoteOrder.push(id);
        counter = state.footnoteOrder.length;
    } else counter = index + 1;
    reuseCounter += 1;
    state.footnoteCounts.set(id, reuseCounter);
    /** @type {Element} */ var link = {
        type: 'element',
        tagName: 'a',
        properties: {
            href: '#' + clobberPrefix + 'fn-' + safeId,
            id: clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : ''),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                'footnote-label'
            ]
        },
        children: [
            {
                type: 'text',
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ var sup = {
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @import {Element} from 'hast'
 * @import {Heading} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $ed2926a718150cd0$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'h' + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Html} from 'mdast'
 * @import {State} from '../state.js'
 * @import {Raw} from '../../index.js'
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Element | Raw | undefined}
 *   hast node.
 */ function $8ec644eef1e1270f$export$c0bb0b647f701bb5(state, node) {
    if (state.options.allowDangerousHtml) {
        /** @type {Raw} */ var result = {
            type: 'raw',
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    return undefined;
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {ImageReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 
/**
 * @import {ElementContent} from 'hast'
 * @import {Reference, Nodes} from 'mdast'
 * @import {State} from './state.js'
 */ /**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Extract<Nodes, Reference>} node
 *   Reference node (image, link).
 * @returns {Array<ElementContent>}
 *   hast content.
 */ function $9d5ccf97b8044887$export$3fdd26f3d9e7dc78(state, node) {
    var subtype = node.referenceType;
    var suffix = ']';
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return [
        {
            type: 'text',
            value: '![' + node.alt + suffix
        }
    ];
    var contents = state.all(node);
    var head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift({
        type: 'text',
        value: '['
    });
    var tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push({
        type: 'text',
        value: suffix
    });
    return contents;
}


function $70b8e18855d0bdee$export$f281796f6bc3b8db(state, node) {
    var id = String(node.identifier).toUpperCase();
    var definition = state.definitionById.get(id);
    if (!definition) return (0, $9d5ccf97b8044887$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ var properties = {
        src: (0, $9ec3f308f236101d$export$e42a3e39590d28b5)(definition.url || ''),
        alt: node.alt
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Image} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $6f342c4d8a9ad5a7$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ var properties = {
        src: (0, $9ec3f308f236101d$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Text} from 'hast'
 * @import {InlineCode} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $048dea940623d2da$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ var text = {
        type: 'text',
        value: node.value.replace(/\r?\n|\r/g, ' ')
    };
    state.patch(node, text);
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'code',
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {LinkReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 

function $f46e43effbb05fab$export$e6c469b1b7b2bc6a(state, node) {
    var id = String(node.identifier).toUpperCase();
    var definition = state.definitionById.get(id);
    if (!definition) return (0, $9d5ccf97b8044887$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ var properties = {
        href: (0, $9ec3f308f236101d$export$e42a3e39590d28b5)(definition.url || '')
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Link} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $029d54909669ee0a$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ var properties = {
        href: (0, $9ec3f308f236101d$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {ListItem, Parents} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ 
var $XnYkK = parcelRequire("XnYkK");
function $0236844fa8ac881e$export$76c7e83ecc9cdf05(state, node, parent) {
    var results = state.all(node);
    var loose = parent ? $0236844fa8ac881e$var$listLoose(parent) : $0236844fa8ac881e$var$listItemLoose(node);
    /** @type {Properties} */ var properties = {};
    /** @type {Array<ElementContent>} */ var children = [];
    if (typeof node.checked === 'boolean') {
        var head = results[0];
        /** @type {Element} */ var paragraph;
        if (head && head.type === 'element' && head.tagName === 'p') paragraph = head;
        else {
            paragraph = {
                type: 'element',
                tagName: 'p',
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: 'text',
            value: ' '
        });
        paragraph.children.unshift({
            type: 'element',
            tagName: 'input',
            properties: {
                type: 'checkbox',
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            'task-list-item'
        ];
    }
    var index = -1;
    while(++index < results.length){
        var _children;
        var child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== 'element' || child.tagName !== 'p') children.push({
            type: 'text',
            value: '\n'
        });
        if (child.type === 'element' && child.tagName === 'p' && !loose) (_children = children).push.apply(_children, (0, $XnYkK._)(child.children));
        else children.push(child);
    }
    var tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) children.push({
        type: 'text',
        value: '\n'
    });
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'li',
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $0236844fa8ac881e$var$listLoose(node) {
    var loose = false;
    if (node.type === 'list') {
        loose = node.spread || false;
        var children = node.children;
        var index = -1;
        while(!loose && ++index < children.length)loose = $0236844fa8ac881e$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $0236844fa8ac881e$var$listItemLoose(node) {
    var spread = node.spread;
    return spread === null || spread === undefined ? node.children.length > 1 : spread;
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {List} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $3e37d2c6ac902884$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ var properties = {};
    var results = state.all(node);
    var index = -1;
    if (typeof node.start === 'number' && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        var child = results[index];
        if (child.type === 'element' && child.tagName === 'li' && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes('task-list-item')) {
            properties.className = [
                'contains-task-list'
            ];
            break;
        }
    }
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: node.ordered ? 'ol' : 'ul',
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Paragraph} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $7827b4da36c4bd8d$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'p',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Parents as HastParents, Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastParents}
 *   hast node.
 */ function $182e7d21ca99bd75$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ var result = {
        type: 'root',
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Strong} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $326384f27004c121$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'strong',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Table} from 'mdast'
 * @import {Element} from 'hast'
 * @import {State} from '../state.js'
 */ 
function $905bffecf0851441$export$9852986a3ec5f6a0(state, node) {
    var rows = state.all(node);
    var firstRow = rows.shift();
    /** @type {Array<Element>} */ var tableContent = [];
    if (firstRow) {
        /** @type {Element} */ var head = {
            type: 'element',
            tagName: 'thead',
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ var body = {
            type: 'element',
            tagName: 'tbody',
            properties: {},
            children: state.wrap(rows, true)
        };
        var start = (0, $09ebe31a7b709c5f$export$771bf3e4949bfbee)(node.children[1]);
        var end = (0, $09ebe31a7b709c5f$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start && end) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'table',
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, ElementContent, Properties} from 'hast'
 * @import {Parents, TableRow} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $8a79895190aa66b1$export$ce666bf02318c957(state, node, parent) {
    var siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    var rowIndex = siblings ? siblings.indexOf(node) : 1;
    var tagName = rowIndex === 0 ? 'th' : 'td';
    // To do: option to use `style`?
    var align = parent && parent.type === 'table' ? parent.align : undefined;
    var length = align ? align.length : node.children.length;
    var cellIndex = -1;
    /** @type {Array<ElementContent>} */ var cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        var cell = node.children[cellIndex];
        /** @type {Properties} */ var properties = {};
        var alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ var result = {
            type: 'element',
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(cell, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ var result1 = {
        type: 'element',
        tagName: 'tr',
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result1);
    return state.applyData(node, result1);
}


/**
 * @import {Element} from 'hast'
 * @import {TableCell} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $639976dd1ac8d0d0$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'td',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element as HastElement, Text as HastText} from 'hast'
 * @import {Text as MdastText} from 'mdast'
 * @import {State} from '../state.js'
 */ var $f0064d888b0f2590$var$tab = 9 /* `\t` */ ;
var $f0064d888b0f2590$var$space = 32 /* ` ` */ ;
function $f0064d888b0f2590$export$a771f20bdd13def9(value) {
    var source = String(value);
    var search = /\r?\n|\r/g;
    var match = search.exec(source);
    var last = 0;
    /** @type {Array<string>} */ var lines = [];
    while(match){
        lines.push($f0064d888b0f2590$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($f0064d888b0f2590$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $f0064d888b0f2590$var$trimLine(value, start, end) {
    var startIndex = 0;
    var endIndex = value.length;
    if (start) {
        var code = value.codePointAt(startIndex);
        while(code === $f0064d888b0f2590$var$tab || code === $f0064d888b0f2590$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        var code1 = value.codePointAt(endIndex - 1);
        while(code1 === $f0064d888b0f2590$var$tab || code1 === $f0064d888b0f2590$var$space){
            endIndex--;
            code1 = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}


function $d39be98162350a74$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ var result = {
        type: 'text',
        value: (0, $f0064d888b0f2590$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {ThematicBreak} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $040d159edff12248$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ var result = {
        type: 'element',
        tagName: 'hr',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


var $e71b6ea5997cff00$export$455ce229eb3d2472 = {
    blockquote: (0, $cf122b6bdafeae0f$export$67dc04e652a298ca),
    break: (0, $af2c04f479787016$export$371da9dd35aba193),
    code: (0, $e5f4dd772d1ec96a$export$6565f9f03506010b),
    delete: (0, $5df300b872c9f920$export$19426ff118fe8be),
    emphasis: (0, $7025b8e2490fa77e$export$bef81ba411953b51),
    footnoteReference: (0, $f41b78071b17bf45$export$7f87ee744075c1ba),
    heading: (0, $ed2926a718150cd0$export$46e4a324ac90507f),
    html: (0, $8ec644eef1e1270f$export$c0bb0b647f701bb5),
    imageReference: (0, $70b8e18855d0bdee$export$f281796f6bc3b8db),
    image: (0, $6f342c4d8a9ad5a7$export$5c452ff88e35e47d),
    inlineCode: (0, $048dea940623d2da$export$91b9bee19a0d8569),
    linkReference: (0, $f46e43effbb05fab$export$e6c469b1b7b2bc6a),
    link: (0, $029d54909669ee0a$export$9c30223ca0a664fb),
    listItem: (0, $0236844fa8ac881e$export$76c7e83ecc9cdf05),
    list: (0, $3e37d2c6ac902884$export$8837f4fc672e936d),
    paragraph: (0, $7827b4da36c4bd8d$export$9c206ddddb32a9b),
    // @ts-expect-error: root is different, but hard to type.
    root: (0, $182e7d21ca99bd75$export$e8e78c978b129247),
    strong: (0, $326384f27004c121$export$59ae2c325a998f89),
    table: (0, $905bffecf0851441$export$9852986a3ec5f6a0),
    tableCell: (0, $639976dd1ac8d0d0$export$e1e720e5f4603e6a),
    tableRow: (0, $8a79895190aa66b1$export$ce666bf02318c957),
    text: (0, $d39be98162350a74$export$6f093cfa640b7166),
    thematicBreak: (0, $040d159edff12248$export$ba7b13e047416c03),
    toml: $e71b6ea5997cff00$var$ignore,
    yaml: $e71b6ea5997cff00$var$ignore,
    definition: $e71b6ea5997cff00$var$ignore,
    footnoteDefinition: $e71b6ea5997cff00$var$ignore
};
// Return nothing for nodes that are ignored.
function $e71b6ea5997cff00$var$ignore() {
    return undefined;
}


var $fe61c63a4a6bdfd8$var$own = {}.hasOwnProperty;
/** @type {Options} */ var $fe61c63a4a6bdfd8$var$emptyOptions = {};
function $fe61c63a4a6bdfd8$export$e6a0daad8304de(tree, options) {
    var settings = options || $fe61c63a4a6bdfd8$var$emptyOptions;
    /** @type {Map<string, MdastDefinition>} */ var definitionById = new Map();
    /** @type {Map<string, MdastFootnoteDefinition>} */ var footnoteById = new Map();
    /** @type {Map<string, number>} */ var footnoteCounts = new Map();
    /** @type {Handlers} */ // @ts-expect-error: the root handler returns a root.
    // Hard to type.
    var handlers = (0, $hwO3w._)({}, (0, $e71b6ea5997cff00$export$455ce229eb3d2472), settings.handlers);
    /** @type {State} */ var state = {
        all: all,
        applyData: $fe61c63a4a6bdfd8$var$applyData,
        definitionById: definitionById,
        footnoteById: footnoteById,
        footnoteCounts: footnoteCounts,
        footnoteOrder: [],
        handlers: handlers,
        one: one,
        options: settings,
        patch: $fe61c63a4a6bdfd8$var$patch,
        wrap: $fe61c63a4a6bdfd8$export$4997ffc0176396a6
    };
    (0, $dfcab761b4e96982$export$bf638b60ea8b89b7)(tree, function(node) {
        if (node.type === 'definition' || node.type === 'footnoteDefinition') {
            var map = node.type === 'definition' ? definitionById : footnoteById;
            var id = String(node.identifier).toUpperCase();
            // Mimick CM behavior of link definitions.
            // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
            if (!map.has(id)) // @ts-expect-error: node type matches map.
            map.set(id, node);
        }
    });
    return state;
    /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */ function one(node, parent) {
        var type = node.type;
        var handle = state.handlers[type];
        if ($fe61c63a4a6bdfd8$var$own.call(state.handlers, type) && handle) return handle(state, node, parent);
        if (state.options.passThrough && state.options.passThrough.includes(type)) {
            if ('children' in node) {
                var children = node.children, shallow = (0, $54Czb._)(node, [
                    "children"
                ]);
                var result = (0, $61b0a4bb3c8ce840$export$2e2bcd8739ae039)(shallow);
                // @ts-expect-error: TS doesn’t understand…
                result.children = state.all(node);
                // @ts-expect-error: TS doesn’t understand…
                return result;
            }
            // @ts-expect-error: it’s custom.
            return (0, $61b0a4bb3c8ce840$export$2e2bcd8739ae039)(node);
        }
        var unknown = state.options.unknownHandler || $fe61c63a4a6bdfd8$var$defaultUnknownHandler;
        return unknown(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function all(parent) {
        /** @type {Array<HastElementContent>} */ var values = [];
        if ('children' in parent) {
            var nodes = parent.children;
            var index = -1;
            while(++index < nodes.length){
                var result = state.one(nodes[index], parent);
                // To do: see if we van clean this? Can we merge texts?
                if (result) {
                    var _values;
                    if (index && nodes[index - 1].type === 'break') {
                        if (!Array.isArray(result) && result.type === 'text') result.value = $fe61c63a4a6bdfd8$var$trimMarkdownSpaceStart(result.value);
                        if (!Array.isArray(result) && result.type === 'element') {
                            var head = result.children[0];
                            if (head && head.type === 'text') head.value = $fe61c63a4a6bdfd8$var$trimMarkdownSpaceStart(head.value);
                        }
                    }
                    if (Array.isArray(result)) (_values = values).push.apply(_values, (0, $XnYkK._)(result));
                    else values.push(result);
                }
            }
        }
        return values;
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */ function $fe61c63a4a6bdfd8$var$patch(from, to) {
    if (from.position) to.position = (0, $09ebe31a7b709c5f$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */ function $fe61c63a4a6bdfd8$var$applyData(from, to) {
    /** @type {HastElement | Type} */ var result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        var hName = from.data.hName;
        var hChildren = from.data.hChildren;
        var hProperties = from.data.hProperties;
        if (typeof hName === 'string') {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === 'element') result.tagName = hName;
            else {
                /** @type {Array<HastElementContent>} */ // @ts-expect-error: assume no doctypes in `root`.
                var children = 'children' in result ? result.children : [
                    result
                ];
                result = {
                    type: 'element',
                    tagName: hName,
                    properties: {},
                    children: children
                };
            }
        }
        if (result.type === 'element' && hProperties) Object.assign(result.properties, (0, $61b0a4bb3c8ce840$export$2e2bcd8739ae039)(hProperties));
        if ('children' in result && result.children && hChildren !== null && hChildren !== undefined) result.children = hChildren;
    }
    return result;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */ function $fe61c63a4a6bdfd8$var$defaultUnknownHandler(state, node) {
    var data = node.data || {};
    /** @type {HastElement | HastText} */ var result = 'value' in node && !($fe61c63a4a6bdfd8$var$own.call(data, 'hProperties') || $fe61c63a4a6bdfd8$var$own.call(data, 'hChildren')) ? {
        type: 'text',
        value: node.value
    } : {
        type: 'element',
        tagName: 'div',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $fe61c63a4a6bdfd8$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<HastText | Type>} */ var result = [];
    var index = -1;
    if (loose) result.push({
        type: 'text',
        value: '\n'
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: 'text',
            value: '\n'
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: 'text',
        value: '\n'
    });
    return result;
}
/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */ function $fe61c63a4a6bdfd8$var$trimMarkdownSpaceStart(value) {
    var index = 0;
    var code = value.charCodeAt(index);
    while(code === 9 || code === 32){
        index++;
        code = value.charCodeAt(index);
    }
    return value.slice(index);
}


function $b28dd35ceb920125$export$c0e4c5cf07538633(tree, options) {
    var state = (0, $fe61c63a4a6bdfd8$export$e6a0daad8304de)(tree, options);
    var node = state.one(tree, undefined);
    var foot = (0, $0d5cc8a7aeac4b3b$export$adb608be33961c98)(state);
    /** @type {HastNodes} */ var result = Array.isArray(node) ? {
        type: 'root',
        children: node
    } : node || {
        type: 'root',
        children: []
    };
    if (foot) {
        // If there’s a footer, there were definitions, meaning block
        // content.
        // So `result` is a parent node.
        (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)('children' in result);
        result.children.push({
            type: 'text',
            value: '\n'
        }, foot);
    }
    return result;
}


function $1006c88cc7bedd28$export$2e2bcd8739ae039(destination, options) {
    if (destination && 'run' in destination) /**
     * @type {TransformBridge}
     */ return function(tree, file) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var hastTree;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Cast because root in -> root out.
                        hastTree = /** @type {HastRoot} */ (0, $b28dd35ceb920125$export$c0e4c5cf07538633)(tree, (0, $hwO3w._)({
                            file: file
                        }, options));
                        return [
                            4,
                            destination.run(hastTree, file)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    /**
   * @type {TransformMutate}
   */ return function(tree, file) {
        // Cast because root in -> root out.
        // To do: in the future, disallow ` || options` fallback.
        // With `unified-engine`, `destination` can be `undefined` but
        // `options` will be the file set.
        // We should not pass that as `options`.
        return /** @type {HastRoot} */ (0, $b28dd35ceb920125$export$c0e4c5cf07538633)(tree, (0, $hwO3w._)({
            file: file
        }, destination || options));
    };
}


/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */ /**
 * @typedef {CompileResultMap[keyof CompileResultMap]} CompileResults
 *   Acceptable results from compilers.
 *
 *   To register custom results, add them to
 *   {@linkcode CompileResultMap}.
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the compiler receives (default: `Node`).
 * @template {CompileResults} [Result=CompileResults]
 *   The thing that the compiler yields (default: `CompileResults`).
 * @callback Compiler
 *   A **compiler** handles the compiling of a syntax tree to something else
 *   (in most cases, text) (TypeScript type).
 *
 *   It is used in the stringify phase and called with a {@linkcode Node}
 *   and {@linkcode VFile} representation of the document to compile.
 *   It should return the textual representation of the given tree (typically
 *   `string`).
 *
 *   > **Note**: unified typically compiles by serializing: most compilers
 *   > return `string` (or `Uint8Array`).
 *   > Some compilers, such as the one configured with
 *   > [`rehype-react`][rehype-react], return other values (in this case, a
 *   > React tree).
 *   > If you’re using a compiler that doesn’t serialize, expect different
 *   > result values.
 *   >
 *   > To register custom results in TypeScript, add them to
 *   > {@linkcode CompileResultMap}.
 *
 *   [rehype-react]: https://github.com/rehypejs/rehype-react
 * @param {Tree} tree
 *   Tree to compile.
 * @param {VFile} file
 *   File associated with `tree`.
 * @returns {Result}
 *   New content: compiled text (`string` or `Uint8Array`, for `file.value`) or
 *   something else (for `file.result`).
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the parser yields (default: `Node`)
 * @callback Parser
 *   A **parser** handles the parsing of text to a syntax tree.
 *
 *   It is used in the parse phase and is called with a `string` and
 *   {@linkcode VFile} of the document to parse.
 *   It must return the syntax tree representation of the given file
 *   ({@linkcode Node}).
 * @param {string} document
 *   Document to parse.
 * @param {VFile} file
 *   File associated with `document`.
 * @returns {Tree}
 *   Node representing the given file.
 */ /**
 * @typedef {(
 *   Plugin<Array<any>, any, any> |
 *   PluginTuple<Array<any>, any, any> |
 *   Preset
 * )} Pluggable
 *   Union of the different ways to add plugins and settings.
 */ /**
 * @typedef {Array<Pluggable>} PluggableList
 *   List of plugins and presets.
 */ // Note: we can’t use `callback` yet as it messes up `this`:
//  <https://github.com/microsoft/TypeScript/issues/55197>.
/**
 * @template {Array<unknown>} [PluginParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=Node]
 *   Value that is expected as input (default: `Node`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=Input]
 *   Value that is yielded as output (default: `Input`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   (this: Processor, ...parameters: PluginParameters) =>
 *     Input extends string ? // Parser.
 *        Output extends Node | undefined ? undefined | void : never :
 *     Output extends CompileResults ? // Compiler.
 *        Input extends Node | undefined ? undefined | void : never :
 *     Transformer<
 *       Input extends Node ? Input : Node,
 *       Output extends Node ? Output : Node
 *     > | undefined | void
 * )} Plugin
 *   Single plugin.
 *
 *   Plugins configure the processors they are applied on in the following
 *   ways:
 *
 *   *   they change the processor, such as the parser, the compiler, or by
 *       configuring data
 *   *   they specify how to handle trees and files
 *
 *   In practice, they are functions that can receive options and configure the
 *   processor (`this`).
 *
 *   > **Note**: plugins are called when the processor is *frozen*, not when
 *   > they are applied.
 */ /**
 * Tuple of a plugin and its configuration.
 *
 * The first item is a plugin, the rest are its parameters.
 *
 * @template {Array<unknown>} [TupleParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=undefined]
 *   Value that is expected as input (optional).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=undefined] (optional).
 *   Value that is yielded as output.
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   [
 *     plugin: Plugin<TupleParameters, Input, Output>,
 *     ...parameters: TupleParameters
 *   ]
 * )} PluginTuple
 */ /**
 * @typedef Preset
 *   Sharable configuration.
 *
 *   They can contain plugins and settings.
 * @property {PluggableList | undefined} [plugins]
 *   List of plugins and presets (optional).
 * @property {Settings | undefined} [settings]
 *   Shared settings for parsers and compilers (optional).
 */ /**
 * @template {VFile} [File=VFile]
 *   The file that the callback receives (default: `VFile`).
 * @callback ProcessCallback
 *   Callback called when the process is done.
 *
 *   Called with either an error or a result.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {File | undefined} [file]
 *   Processed file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Tree=Node]
 *   The tree that the callback receives (default: `Node`).
 * @callback RunCallback
 *   Callback called when transformers are done.
 *
 *   Called with either an error or results.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {Tree | undefined} [tree]
 *   Transformed tree (optional).
 * @param {VFile | undefined} [file]
 *   File (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Output=Node]
 *   Node type that the transformer yields (default: `Node`).
 * @callback TransformCallback
 *   Callback passed to transforms.
 *
 *   If the signature of a `transformer` accepts a third argument, the
 *   transformer may perform asynchronous operations, and must call it.
 * @param {Error | undefined} [error]
 *   Fatal error to stop the process (optional).
 * @param {Output | undefined} [tree]
 *   New, changed, tree (optional).
 * @param {VFile | undefined} [file]
 *   New, changed, file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Input=Node]
 *   Node type that the transformer expects (default: `Node`).
 * @template {Node} [Output=Input]
 *   Node type that the transformer yields (default: `Input`).
 * @callback Transformer
 *   Transformers handle syntax trees and files.
 *
 *   They are functions that are called each time a syntax tree and file are
 *   passed through the run phase.
 *   When an error occurs in them (either because it’s thrown, returned,
 *   rejected, or passed to `next`), the process stops.
 *
 *   The run phase is handled by [`trough`][trough], see its documentation for
 *   the exact semantics of these functions.
 *
 *   > **Note**: you should likely ignore `next`: don’t accept it.
 *   > it supports callback-style async work.
 *   > But promises are likely easier to reason about.
 *
 *   [trough]: https://github.com/wooorm/trough#function-fninput-next
 * @param {Input} tree
 *   Tree to handle.
 * @param {VFile} file
 *   File to handle.
 * @param {TransformCallback<Output>} next
 *   Callback.
 * @returns {(
 *   Promise<Output | undefined | void> |
 *   Promise<never> | // For some reason this is needed separately.
 *   Output |
 *   Error |
 *   undefined |
 *   void
 * )}
 *   If you accept `next`, nothing.
 *   Otherwise:
 *
 *   *   `Error` — fatal error to stop the process
 *   *   `Promise<undefined>` or `undefined` — the next transformer keeps using
 *       same tree
 *   *   `Promise<Node>` or `Node` — new, changed, tree
 */ /**
 * @template {Node | undefined} ParseTree
 *   Output of `parse`.
 * @template {Node | undefined} HeadTree
 *   Input for `run`.
 * @template {Node | undefined} TailTree
 *   Output for `run`.
 * @template {Node | undefined} CompileTree
 *   Input of `stringify`.
 * @template {CompileResults | undefined} CompileResult
 *   Output of `stringify`.
 * @template {Node | string | undefined} Input
 *   Input of plugin.
 * @template Output
 *   Output of plugin (optional).
 * @typedef {(
 *   Input extends string
 *     ? Output extends Node | undefined
 *       ? // Parser.
 *         Processor<
 *           Output extends undefined ? ParseTree : Output,
 *           HeadTree,
 *           TailTree,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Output extends CompileResults
 *     ? Input extends Node | undefined
 *       ? // Compiler.
 *         Processor<
 *           ParseTree,
 *           HeadTree,
 *           TailTree,
 *           Input extends undefined ? CompileTree : Input,
 *           Output extends undefined ? CompileResult : Output
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Input extends Node | undefined
 *     ? Output extends Node | undefined
 *       ? // Transform.
 *         Processor<
 *           ParseTree,
 *           HeadTree extends undefined ? Input : HeadTree,
 *           Output extends undefined ? TailTree : Output,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : // Unknown.
 *       Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 * )} UsePlugin
 *   Create a processor based on the input/output of a {@link Plugin plugin}.
 */ /**
 * @template {CompileResults | undefined} Result
 *   Node type that the transformer yields.
 * @typedef {(
 *   Result extends Value | undefined ?
 *     VFile :
 *     VFile & {result: Result}
 *   )} VFileWithOutput
 *   Type to generate a {@linkcode VFile} corresponding to a compiler result.
 *
 *   If a result that is not acceptable on a `VFile` is used, that will
 *   be stored on the `result` field of {@linkcode VFile}.
 */ 
var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $4QAx6 = parcelRequire("4QAx6");

var $1SnSh = parcelRequire("1SnSh");

var $XnYkK = parcelRequire("XnYkK");

var $03bAP = parcelRequire("03bAP");
/**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $c5c33cdda85dcf7f$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}


var $3aa0cb1cddac1326$exports = {};

var $03bAP = parcelRequire("03bAP");
'use strict';
var $3aa0cb1cddac1326$var$hasOwn = Object.prototype.hasOwnProperty;
var $3aa0cb1cddac1326$var$toStr = Object.prototype.toString;
var $3aa0cb1cddac1326$var$defineProperty = Object.defineProperty;
var $3aa0cb1cddac1326$var$gOPD = Object.getOwnPropertyDescriptor;
var $3aa0cb1cddac1326$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $3aa0cb1cddac1326$var$toStr.call(arr) === '[object Array]';
};
var $3aa0cb1cddac1326$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $3aa0cb1cddac1326$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $3aa0cb1cddac1326$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $3aa0cb1cddac1326$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $3aa0cb1cddac1326$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $3aa0cb1cddac1326$var$setProperty = function setProperty(target, options) {
    if ($3aa0cb1cddac1326$var$defineProperty && options.name === '__proto__') $3aa0cb1cddac1326$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $3aa0cb1cddac1326$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$3aa0cb1cddac1326$var$hasOwn.call(obj, name)) return void 0;
        else if ($3aa0cb1cddac1326$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $3aa0cb1cddac1326$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$3aa0cb1cddac1326$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || (typeof target === "undefined" ? "undefined" : (0, $03bAP._)(target)) !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $3aa0cb1cddac1326$var$getProperty(target, name);
            copy = $3aa0cb1cddac1326$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($3aa0cb1cddac1326$var$isPlainObject(copy) || (copyIsArray = $3aa0cb1cddac1326$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $3aa0cb1cddac1326$var$isArray(src) ? src : [];
                    } else clone = src && $3aa0cb1cddac1326$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $3aa0cb1cddac1326$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $3aa0cb1cddac1326$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};




var $03bAP = parcelRequire("03bAP");
function $15d643a836097afa$export$2e2bcd8739ae039(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) !== 'object' || value === null) return false;
    var prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ 
var $XnYkK = parcelRequire("XnYkK");
function $334ea82ca1ac8389$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ var fns = [];
    /** @type {Pipeline} */ var pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run() {
        for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++){
            values[_key] = arguments[_key];
        }
        var middlewareIndex = -1;
        /** @type {Callback} */ var callback = values.pop();
        if (typeof callback !== 'function') throw new TypeError('Expected function as last argument, not ' + callback);
        next.apply(void 0, [
            null
        ].concat((0, $XnYkK._)(values)));
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error) {
            for(var _len = arguments.length, output = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                output[_key - 1] = arguments[_key];
            }
            var fn = fns[++middlewareIndex];
            var index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $334ea82ca1ac8389$export$4997ffc0176396a6(fn, next).apply(this, (0, $XnYkK._)(output));
            else callback.apply(void 0, [
                null
            ].concat((0, $XnYkK._)(output)));
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== 'function') throw new TypeError('Expected `middelware` to be a function, not ' + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $334ea82ca1ac8389$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ var called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped() {
        for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++){
            parameters[_key] = arguments[_key];
        }
        var fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ var result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            var exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error) {
        for(var _len = arguments.length, output = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            output[_key - 1] = arguments[_key];
        }
        if (!called) {
            called = true;
            callback.apply(void 0, [
                error
            ].concat((0, $XnYkK._)(output)));
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}


/**
 * @import {Node, Point, Position} from 'unist'
 * @import {Options as MessageOptions} from 'vfile-message'
 * @import {Compatible, Data, Map, Options, Value} from 'vfile'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ 
var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $XnYkK = parcelRequire("XnYkK");

var $03bAP = parcelRequire("03bAP");

// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $2dd264a88e5a7b02$export$500c965389abde9c = {
    basename: $2dd264a88e5a7b02$var$basename,
    dirname: $2dd264a88e5a7b02$var$dirname,
    extname: $2dd264a88e5a7b02$var$extname,
    join: $2dd264a88e5a7b02$var$join,
    sep: '/'
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [extname]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $2dd264a88e5a7b02$var$basename(path, extname) {
    if (extname !== undefined && typeof extname !== 'string') throw new TypeError('"ext" argument must be a string');
    $2dd264a88e5a7b02$var$assertPath(path);
    var start = 0;
    var end = -1;
    var index = path.length;
    /** @type {boolean | undefined} */ var seenNonSlash;
    if (extname === undefined || extname.length === 0 || extname.length > path.length) {
        while(index--){
            if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (extname === path) return '';
    var firstNonSlashEnd = -1;
    var extnameIndex = extname.length - 1;
    while(index--){
        if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extnameIndex > -1) {
                // Try to match the explicit extension.
                if (path.codePointAt(index) === extname.codePointAt(extnameIndex--)) {
                    if (extnameIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extnameIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $2dd264a88e5a7b02$var$dirname(path) {
    $2dd264a88e5a7b02$var$assertPath(path);
    if (path.length === 0) return '.';
    var end = -1;
    var index = path.length;
    /** @type {boolean | undefined} */ var unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.codePointAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.codePointAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.codePointAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $2dd264a88e5a7b02$var$extname(path) {
    $2dd264a88e5a7b02$var$assertPath(path);
    var index = path.length;
    var end = -1;
    var startPart = 0;
    var startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    var preDotState = 0;
    /** @type {boolean | undefined} */ var unmatchedSlash;
    while(index--){
        var code = path.codePointAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $2dd264a88e5a7b02$var$join() {
    for(var _len = arguments.length, segments = new Array(_len), _key = 0; _key < _len; _key++){
        segments[_key] = arguments[_key];
    }
    var index = -1;
    /** @type {string | undefined} */ var joined;
    while(++index < segments.length){
        $2dd264a88e5a7b02$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + '/' + segments[index];
    }
    return joined === undefined ? '.' : $2dd264a88e5a7b02$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $2dd264a88e5a7b02$var$normalize(path) {
    $2dd264a88e5a7b02$var$assertPath(path);
    var absolute = path.codePointAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    var value = $2dd264a88e5a7b02$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = '.';
    if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $2dd264a88e5a7b02$var$normalizeString(path, allowAboveRoot) {
    var result = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var index = -1;
    /** @type {number | undefined} */ var code;
    /** @type {number} */ var lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.codePointAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.codePointAt(result.length - 1) !== 46 /* `.` */  || result.codePointAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $2dd264a88e5a7b02$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
var $68ccf2256d11f52e$export$77f0ef6e088922ec = {
    cwd: $68ccf2256d11f52e$var$cwd
};
function $68ccf2256d11f52e$var$cwd() {
    return '/';
}


/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>

var $03bAP = parcelRequire("03bAP");
function $64fc30b17bdbbcb5$export$8304a22d431f958(fileUrlOrPath) {
    return Boolean(fileUrlOrPath !== null && (typeof fileUrlOrPath === "undefined" ? "undefined" : (0, $03bAP._)(fileUrlOrPath)) === 'object' && 'href' in fileUrlOrPath && fileUrlOrPath.href && 'protocol' in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === undefined);
}


function $068d9512aff04080$export$9b2b676c902de799(path) {
    if (typeof path === 'string') path = new URL(path);
    else if (!(0, $64fc30b17bdbbcb5$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ var error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + '`');
        error.code = 'ERR_INVALID_ARG_TYPE';
        throw error;
    }
    if (path.protocol !== 'file:') {
        /** @type {NodeJS.ErrnoException} */ var error1 = new TypeError('The URL must be of scheme file');
        error1.code = 'ERR_INVALID_URL_SCHEME';
        throw error1;
    }
    return $068d9512aff04080$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $068d9512aff04080$var$getPathFromURLPosix(url) {
    if (url.hostname !== '') {
        /** @type {NodeJS.ErrnoException} */ var error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = 'ERR_INVALID_FILE_URL_HOST';
        throw error;
    }
    var pathname = url.pathname;
    var index = -1;
    while(++index < pathname.length)if (pathname.codePointAt(index) === 37 /* `%` */  && pathname.codePointAt(index + 1) === 50 /* `2` */ ) {
        var third = pathname.codePointAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ var error1 = new TypeError('File URL path must not include encoded / characters');
            error1.code = 'ERR_INVALID_FILE_URL_PATH';
            throw error1;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */ var $3590f52135780ccb$var$order = /** @type {const} */ [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
var $3590f52135780ccb$export$93dff69eb10dc7ce = /*#__PURE__*/ function() {
    "use strict";
    function VFile(value) {
        (0, $5Epmf._)(this, VFile);
        /** @type {Options | VFile} */ var options;
        if (!value) options = {};
        else if ((0, $64fc30b17bdbbcb5$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else if (typeof value === 'string' || $3590f52135780ccb$var$isUint8Array(value)) options = {
            value: value
        };
        else options = value;
        /* eslint-disable no-unused-expressions */ /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ // Prevent calling `cwd` (which could be expensive) if it’s not needed;
        // the empty string will be overridden in the next block.
        this.cwd = 'cwd' in options ? '' : (0, $68ccf2256d11f52e$export$77f0ef6e088922ec).cwd();
        /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        var index = -1;
        while(++index < $3590f52135780ccb$var$order.length){
            var field = $3590f52135780ccb$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (field in options && options[field] !== undefined && options[field] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[field] = field === 'history' ? (0, $XnYkK._)(options[field]) : options[field];
        }
        /** @type {string} */ var field1;
        // Set non-path related properties.
        for(field1 in options)// @ts-expect-error: fine to set other things.
        if (!$3590f52135780ccb$var$order.includes(field1)) // @ts-expect-error: fine to set other things.
        this[field1] = options[field1];
    }
    (0, $9MqXK._)(VFile, [
        {
            key: "basename",
            get: /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */ function get() {
                return typeof this.path === 'string' ? (0, $2dd264a88e5a7b02$export$500c965389abde9c).basename(this.path) : undefined;
            },
            set: /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */ function set(basename) {
                $3590f52135780ccb$var$assertNonEmpty(basename, 'basename');
                $3590f52135780ccb$var$assertPart(basename, 'basename');
                this.path = (0, $2dd264a88e5a7b02$export$500c965389abde9c).join(this.dirname || '', basename);
            }
        },
        {
            key: "dirname",
            get: /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */ function get() {
                return typeof this.path === 'string' ? (0, $2dd264a88e5a7b02$export$500c965389abde9c).dirname(this.path) : undefined;
            },
            set: /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */ function set(dirname) {
                $3590f52135780ccb$var$assertPath(this.basename, 'dirname');
                this.path = (0, $2dd264a88e5a7b02$export$500c965389abde9c).join(dirname || '', this.basename);
            }
        },
        {
            key: "extname",
            get: /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */ function get() {
                return typeof this.path === 'string' ? (0, $2dd264a88e5a7b02$export$500c965389abde9c).extname(this.path) : undefined;
            },
            set: /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */ function set(extname) {
                $3590f52135780ccb$var$assertPart(extname, 'extname');
                $3590f52135780ccb$var$assertPath(this.dirname, 'extname');
                if (extname) {
                    if (extname.codePointAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
                    if (extname.includes('.', 1)) throw new Error('`extname` cannot contain multiple dots');
                }
                this.path = (0, $2dd264a88e5a7b02$export$500c965389abde9c).join(this.dirname, this.stem + (extname || ''));
            }
        },
        {
            key: "path",
            get: /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */ function get() {
                return this.history[this.history.length - 1];
            },
            set: /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */ function set(path) {
                if ((0, $64fc30b17bdbbcb5$export$8304a22d431f958)(path)) path = (0, $068d9512aff04080$export$9b2b676c902de799)(path);
                $3590f52135780ccb$var$assertNonEmpty(path, 'path');
                if (this.path !== path) this.history.push(path);
            }
        },
        {
            key: "stem",
            get: /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */ function get() {
                return typeof this.path === 'string' ? (0, $2dd264a88e5a7b02$export$500c965389abde9c).basename(this.path, this.extname) : undefined;
            },
            set: /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */ function set(stem) {
                $3590f52135780ccb$var$assertNonEmpty(stem, 'stem');
                $3590f52135780ccb$var$assertPart(stem, 'stem');
                this.path = (0, $2dd264a88e5a7b02$export$500c965389abde9c).join(this.dirname || '', stem + (this.extname || ''));
            }
        },
        {
            // Normal prototypal methods.
            /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */ key: "fail",
            value: function fail(causeOrReason, optionsOrParentOrPlace, origin) {
                // @ts-expect-error: the overloads are fine.
                var message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
                message.fatal = true;
                throw message;
            }
        },
        {
            /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ key: "info",
            value: function info(causeOrReason, optionsOrParentOrPlace, origin) {
                // @ts-expect-error: the overloads are fine.
                var message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
                message.fatal = undefined;
                return message;
            }
        },
        {
            /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ key: "message",
            value: function message(causeOrReason, optionsOrParentOrPlace, origin) {
                var message = new (0, $63893ec7bea23f87$export$752e5c445fe834ef)(// @ts-expect-error: the overloads are fine.
                causeOrReason, optionsOrParentOrPlace, origin);
                if (this.path) {
                    message.name = this.path + ':' + message.name;
                    message.file = this.path;
                }
                message.fatal = false;
                this.messages.push(message);
                return message;
            }
        },
        {
            /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */ key: "toString",
            value: function toString(encoding) {
                if (this.value === undefined) return '';
                if (typeof this.value === 'string') return this.value;
                var decoder = new TextDecoder(encoding || undefined);
                return decoder.decode(this.value);
            }
        }
    ]);
    return VFile;
}();
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */ function $3590f52135780ccb$var$assertPart(part, name) {
    if (part && part.includes((0, $2dd264a88e5a7b02$export$500c965389abde9c).sep)) throw new Error('`' + name + '` cannot be a path: did not expect `' + (0, $2dd264a88e5a7b02$export$500c965389abde9c).sep + '`');
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $3590f52135780ccb$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $3590f52135780ccb$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $3590f52135780ccb$var$isUint8Array(value) {
    return Boolean(value && (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) === 'object' && 'byteLength' in value && 'byteOffset' in value);
}


var $cd4b774d604e2dd7$export$b7de1db558410812 = /** @type {unknown} */ /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */ function CallableInstance(property) {
    var self = this;
    var constr = self.constructor;
    var proto = /** @type {Record<string | symbol, Function>} */ // Prototypes do exist.
    // type-coverage:ignore-next-line
    constr.prototype;
    var value = proto[property];
    /** @type {(...parameters: Array<unknown>) => unknown} */ var apply = function apply1() {
        return value.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    // Not needed for us in `unified`: we only call this on the `copy`
    // function,
    // and we don't need to add its fields (`length`, `name`)
    // over.
    // See also: GH-246.
    // const names = Object.getOwnPropertyNames(value)
    //
    // for (const p of names) {
    //   const descriptor = Object.getOwnPropertyDescriptor(value, p)
    //   if (descriptor) Object.defineProperty(apply, p, descriptor)
    // }
    return apply;
};


// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.
// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.
var $40b35392fd41ed36$var$own = {}.hasOwnProperty;
var $40b35392fd41ed36$export$c30cd198d731db19 = /*#__PURE__*/ function(CallableInstance) {
    "use strict";
    (0, $4QAx6._)(Processor, CallableInstance);
    function Processor() {
        (0, $5Epmf._)(this, Processor);
        var _this;
        // If `Processor()` is called (w/o new), `copy` is called instead.
        _this = (0, $48Z0s._)(this, Processor, [
            'copy'
        ]);
        /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ _this.Compiler = undefined;
        /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ _this.Parser = undefined;
        // Note: the following fields are considered private.
        // However, they are needed for tests, and TSC generates an untyped
        // `private freezeIndex` field for, which trips `type-coverage` up.
        // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
        /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */ _this.attachers = [];
        /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ _this.compiler = undefined;
        /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */ _this.freezeIndex = -1;
        /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */ _this.frozen = undefined;
        /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */ _this.namespace = {};
        /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ _this.parser = undefined;
        /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */ _this.transformers = (0, $334ea82ca1ac8389$export$91b56f5ca106aa43)();
        return _this;
    }
    (0, $9MqXK._)(Processor, [
        {
            /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */ key: "copy",
            value: function copy() {
                // Cast as the type parameters will be the same after attaching.
                var destination = /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ new Processor();
                var index = -1;
                while(++index < this.attachers.length){
                    var _destination;
                    var attacher = this.attachers[index];
                    (_destination = destination).use.apply(_destination, (0, $XnYkK._)(attacher));
                }
                destination.data((0, (/*@__PURE__*/$parcel$interopDefault($3aa0cb1cddac1326$exports)))(true, {}, this.namespace));
                return destination;
            }
        },
        {
            /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */ key: "data",
            value: function data(key, value) {
                if (typeof key === 'string') {
                    // Set `key`.
                    if (arguments.length === 2) {
                        $40b35392fd41ed36$var$assertUnfrozen('data', this.frozen);
                        this.namespace[key] = value;
                        return this;
                    }
                    // Get `key`.
                    return $40b35392fd41ed36$var$own.call(this.namespace, key) && this.namespace[key] || undefined;
                }
                // Set space.
                if (key) {
                    $40b35392fd41ed36$var$assertUnfrozen('data', this.frozen);
                    this.namespace = key;
                    return this;
                }
                // Get space.
                return this.namespace;
            }
        },
        {
            /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */ key: "freeze",
            value: function freeze() {
                if (this.frozen) return this;
                // Cast so that we can type plugins easier.
                // Plugins are supposed to be usable on different processors, not just on
                // this exact processor.
                var self = /** @type {unknown} */ this;
                while(++this.freezeIndex < this.attachers.length){
                    var _attacher;
                    var _this_attachers_this_freezeIndex = (0, $1SnSh._)(this.attachers[this.freezeIndex]), attacher = _this_attachers_this_freezeIndex[0], options = _this_attachers_this_freezeIndex.slice(1);
                    if (options[0] === false) continue;
                    if (options[0] === true) options[0] = undefined;
                    var transformer = (_attacher = attacher).call.apply(_attacher, [
                        self
                    ].concat((0, $XnYkK._)(options)));
                    if (typeof transformer === 'function') this.transformers.use(transformer);
                }
                this.frozen = true;
                this.freezeIndex = Number.POSITIVE_INFINITY;
                return this;
            }
        },
        {
            /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */ key: "parse",
            value: function parse(file) {
                this.freeze();
                var realFile = $40b35392fd41ed36$var$vfile(file);
                var parser = this.parser || this.Parser;
                $40b35392fd41ed36$var$assertParser('parse', parser);
                return parser(String(realFile), realFile);
            }
        },
        {
            /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ key: "process",
            value: function process(file, done) {
                var self = this;
                this.freeze();
                $40b35392fd41ed36$var$assertParser('process', this.parser || this.Parser);
                $40b35392fd41ed36$var$assertCompiler('process', this.compiler || this.Compiler);
                return done ? executor(undefined, done) : new Promise(executor);
                // Note: `void`s needed for TS.
                /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
                    var realFile = $40b35392fd41ed36$var$vfile(file);
                    // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
                    // input of the first transform).
                    var parseTree = /** @type {unknown} */ self.parse(realFile);
                    self.run(parseTree, realFile, function(error, tree, file) {
                        if (error || !tree || !file) return realDone(error);
                        // Assume `TailTree` (the output of the last transform) matches
                        // `CompileTree` (the input of the compiler).
                        var compileTree = /** @type {unknown} */ tree;
                        var compileResult = self.stringify(compileTree, file);
                        if ($40b35392fd41ed36$var$looksLikeAValue(compileResult)) file.value = compileResult;
                        else file.result = compileResult;
                        realDone(error, /** @type {VFileWithOutput<CompileResult>} */ file);
                    });
                    /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */ function realDone(error, file) {
                        if (error || !file) reject(error);
                        else if (resolve) resolve(file);
                        else {
                            (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                            done(undefined, file);
                        }
                    }
                }
            }
        },
        {
            /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ key: "processSync",
            value: function processSync(file) {
                /** @type {boolean} */ var complete = false;
                /** @type {VFileWithOutput<CompileResult> | undefined} */ var result;
                this.freeze();
                $40b35392fd41ed36$var$assertParser('processSync', this.parser || this.Parser);
                $40b35392fd41ed36$var$assertCompiler('processSync', this.compiler || this.Compiler);
                this.process(file, realDone);
                $40b35392fd41ed36$var$assertDone('processSync', 'process', complete);
                (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
                return result;
                /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */ function realDone(error, file) {
                    complete = true;
                    (0, $c5c33cdda85dcf7f$export$dd911e13ecb11e05)(error);
                    result = file;
                }
            }
        },
        {
            /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */ key: "run",
            value: function run(tree, file, done) {
                $40b35392fd41ed36$var$assertNode(tree);
                this.freeze();
                var transformers = this.transformers;
                if (!done && typeof file === 'function') {
                    done = file;
                    file = undefined;
                }
                return done ? executor(undefined, done) : new Promise(executor);
                // Note: `void`s needed for TS.
                /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
                    (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(typeof file !== 'function', "`file` can\u2019t be a `done` anymore, we checked");
                    var realFile = $40b35392fd41ed36$var$vfile(file);
                    transformers.run(tree, realFile, realDone);
                    /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */ function realDone(error, outputTree, file) {
                        var resultingTree = /** @type {TailTree extends undefined ? Node : TailTree} */ outputTree || tree;
                        if (error) reject(error);
                        else if (resolve) resolve(resultingTree);
                        else {
                            (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                            done(undefined, resultingTree, file);
                        }
                    }
                }
            }
        },
        {
            /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */ key: "runSync",
            value: function runSync(tree, file) {
                /** @type {boolean} */ var complete = false;
                /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */ var result;
                this.run(tree, file, realDone);
                $40b35392fd41ed36$var$assertDone('runSync', 'run', complete);
                (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
                return result;
                /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */ function realDone(error, tree) {
                    (0, $c5c33cdda85dcf7f$export$dd911e13ecb11e05)(error);
                    result = tree;
                    complete = true;
                }
            }
        },
        {
            /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ key: "stringify",
            value: function stringify(tree, file) {
                this.freeze();
                var realFile = $40b35392fd41ed36$var$vfile(file);
                var compiler = this.compiler || this.Compiler;
                $40b35392fd41ed36$var$assertCompiler('stringify', compiler);
                $40b35392fd41ed36$var$assertNode(tree);
                return compiler(tree, realFile);
            }
        },
        {
            /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */ key: "use",
            value: function use(value) {
                for(var _len = arguments.length, parameters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    parameters[_key - 1] = arguments[_key];
                }
                var attachers = this.attachers;
                var namespace = this.namespace;
                $40b35392fd41ed36$var$assertUnfrozen('use', this.frozen);
                if (value === null || value === undefined) ;
                else if (typeof value === 'function') addPlugin(value, parameters);
                else if ((typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) === 'object') {
                    if (Array.isArray(value)) addList(value);
                    else addPreset(value);
                } else throw new TypeError('Expected usable value, not `' + value + '`');
                return this;
                /**
     * @param {Pluggable} value
     * @returns {undefined}
     */ function add(value) {
                    if (typeof value === 'function') addPlugin(value, []);
                    else if ((typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) === 'object') {
                        if (Array.isArray(value)) {
                            var /** @type {PluginTuple<Array<unknown>>} */ _value = (0, $1SnSh._)(value), plugin = _value[0], parameters = _value.slice(1);
                            addPlugin(plugin, parameters);
                        } else addPreset(value);
                    } else throw new TypeError('Expected usable value, not `' + value + '`');
                }
                /**
     * @param {Preset} result
     * @returns {undefined}
     */ function addPreset(result) {
                    if (!('plugins' in result) && !('settings' in result)) throw new Error('Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither');
                    addList(result.plugins);
                    if (result.settings) namespace.settings = (0, (/*@__PURE__*/$parcel$interopDefault($3aa0cb1cddac1326$exports)))(true, namespace.settings, result.settings);
                }
                /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */ function addList(plugins) {
                    var index = -1;
                    if (plugins === null || plugins === undefined) ;
                    else if (Array.isArray(plugins)) while(++index < plugins.length){
                        var thing = plugins[index];
                        add(thing);
                    }
                    else throw new TypeError('Expected a list of plugins, not `' + plugins + '`');
                }
                /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */ function addPlugin(plugin, parameters) {
                    var index = -1;
                    var entryIndex = -1;
                    while(++index < attachers.length)if (attachers[index][0] === plugin) {
                        entryIndex = index;
                        break;
                    }
                    if (entryIndex === -1) attachers.push([
                        plugin
                    ].concat((0, $XnYkK._)(parameters)));
                    else if (parameters.length > 0) {
                        var _parameters = (0, $1SnSh._)(parameters), primary = _parameters[0], rest = _parameters.slice(1);
                        var currentPrimary = attachers[entryIndex][1];
                        if ((0, $15d643a836097afa$export$2e2bcd8739ae039)(currentPrimary) && (0, $15d643a836097afa$export$2e2bcd8739ae039)(primary)) primary = (0, (/*@__PURE__*/$parcel$interopDefault($3aa0cb1cddac1326$exports)))(true, currentPrimary, primary);
                        attachers[entryIndex] = [
                            plugin,
                            primary
                        ].concat((0, $XnYkK._)(rest));
                    }
                }
            }
        }
    ]);
    return Processor;
}((0, $cd4b774d604e2dd7$export$b7de1db558410812));
var $40b35392fd41ed36$export$7cc1b2fe10c52bb = new $40b35392fd41ed36$export$c30cd198d731db19().freeze();
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $40b35392fd41ed36$var$assertParser(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `parser`');
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $40b35392fd41ed36$var$assertCompiler(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `compiler`');
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $40b35392fd41ed36$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot call `' + name + '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.');
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $40b35392fd41ed36$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $15d643a836097afa$export$2e2bcd8739ae039)(node) || typeof node.type !== 'string') throw new TypeError('Expected node, got `' + node + '`');
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $40b35392fd41ed36$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */ function $40b35392fd41ed36$var$vfile(value) {
    return $40b35392fd41ed36$var$looksLikeAVFile(value) ? value : new (0, $3590f52135780ccb$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */ function $40b35392fd41ed36$var$looksLikeAVFile(value) {
    return Boolean(value && (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) === 'object' && 'message' in value && 'messages' in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */ function $40b35392fd41ed36$var$looksLikeAValue(value) {
    return typeof value === 'string' || $40b35392fd41ed36$var$isUint8Array(value);
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $40b35392fd41ed36$var$isUint8Array(value) {
    return Boolean(value && (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) === 'object' && 'byteLength' in value && 'byteOffset' in value);
}




var $b0f0e35343cbf8ab$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/** @type {PluggableList} */ var $b0f0e35343cbf8ab$var$emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */ var $b0f0e35343cbf8ab$var$emptyRemarkRehypeOptions = {
    allowDangerousHtml: true
};
var $b0f0e35343cbf8ab$var$safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */ var $b0f0e35343cbf8ab$var$deprecations = [
    {
        from: 'astPlugins',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowDangerousHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowNode',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowElement'
    },
    {
        from: 'allowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowedElements'
    },
    {
        from: 'className',
        id: 'remove-classname'
    },
    {
        from: 'disallowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'disallowedElements'
    },
    {
        from: 'escapeHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'includeElementIndex',
        id: '#remove-includeelementindex'
    },
    {
        from: 'includeNodeIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    },
    {
        from: 'linkTarget',
        id: 'remove-linktarget'
    },
    {
        from: 'plugins',
        id: 'change-plugins-to-remarkplugins',
        to: 'remarkPlugins'
    },
    {
        from: 'rawSourcePos',
        id: '#remove-rawsourcepos'
    },
    {
        from: 'renderers',
        id: 'change-renderers-to-components',
        to: 'components'
    },
    {
        from: 'source',
        id: 'change-source-to-children',
        to: 'children'
    },
    {
        from: 'sourcePos',
        id: '#remove-sourcepos'
    },
    {
        from: 'transformImageUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    },
    {
        from: 'transformLinkUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    }
];
function $b0f0e35343cbf8ab$export$7460c8b7e4ce9582(options) {
    var processor = $b0f0e35343cbf8ab$var$createProcessor(options);
    var file = $b0f0e35343cbf8ab$var$createFile(options);
    return $b0f0e35343cbf8ab$var$post(processor.runSync(processor.parse(file), file), options);
}
function $b0f0e35343cbf8ab$export$445edbd7f2c65a8c(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var processor, file, tree;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    processor = $b0f0e35343cbf8ab$var$createProcessor(options);
                    file = $b0f0e35343cbf8ab$var$createFile(options);
                    return [
                        4,
                        processor.run(processor.parse(file), file)
                    ];
                case 1:
                    tree = _state.sent();
                    return [
                        2,
                        $b0f0e35343cbf8ab$var$post(tree, options)
                    ];
            }
        });
    })();
}
function $b0f0e35343cbf8ab$export$915021c692d253a2(options) {
    var processor = $b0f0e35343cbf8ab$var$createProcessor(options);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(/** @type {Error | undefined} */ undefined), 2), error = _useState[0], setError = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(/** @type {Root | undefined} */ undefined), 2), tree = _useState1[0], setTree = _useState1[1];
    (0, $5s1kH.useEffect)(function() {
        var cancelled = false;
        var file = $b0f0e35343cbf8ab$var$createFile(options);
        processor.run(processor.parse(file), file, function(error, tree) {
            if (!cancelled) {
                setError(error);
                setTree(tree);
            }
        });
        /**
       * @returns {undefined}
       *   Nothing.
       */ return function() {
            cancelled = true;
        };
    }, [
        options.children,
        options.rehypePlugins,
        options.remarkPlugins,
        options.remarkRehypeOptions
    ]);
    if (error) throw error;
    return tree ? $b0f0e35343cbf8ab$var$post(tree, options) : options.fallback;
}
/**
 * Set up the `unified` processor.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {Processor<MdastRoot, MdastRoot, Root, undefined, undefined>}
 *   Result.
 */ function $b0f0e35343cbf8ab$var$createProcessor(options) {
    var rehypePlugins = options.rehypePlugins || $b0f0e35343cbf8ab$var$emptyPlugins;
    var remarkPlugins = options.remarkPlugins || $b0f0e35343cbf8ab$var$emptyPlugins;
    var remarkRehypeOptions = options.remarkRehypeOptions ? (0, $hwO3w._)({}, options.remarkRehypeOptions, $b0f0e35343cbf8ab$var$emptyRemarkRehypeOptions) : $b0f0e35343cbf8ab$var$emptyRemarkRehypeOptions;
    var processor = (0, $40b35392fd41ed36$export$7cc1b2fe10c52bb)().use((0, $a13f1c2dc3fe29d5$export$2e2bcd8739ae039)).use(remarkPlugins).use((0, $1006c88cc7bedd28$export$2e2bcd8739ae039), remarkRehypeOptions).use(rehypePlugins);
    return processor;
}
/**
 * Set up the virtual file.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {VFile}
 *   Result.
 */ function $b0f0e35343cbf8ab$var$createFile(options) {
    var children = options.children || '';
    var file = new (0, $3590f52135780ccb$export$93dff69eb10dc7ce)();
    if (typeof children === 'string') file.value = children;
    else (0, $337acd4a17e06e51$export$565e9d9bd6b6e0d4)('Unexpected value `' + children + '` for `children` prop, expected `string`');
    return file;
}
/**
 * Process the result from unified some more.
 *
 * @param {Nodes} tree
 *   Tree.
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {ReactElement}
 *   React element.
 */ function $b0f0e35343cbf8ab$var$post(tree, options) {
    var allowedElements = options.allowedElements;
    var allowElement = options.allowElement;
    var components = options.components;
    var disallowedElements = options.disallowedElements;
    var skipHtml = options.skipHtml;
    var unwrapDisallowed = options.unwrapDisallowed;
    var urlTransform = options.urlTransform || $b0f0e35343cbf8ab$export$ca5e94754123e2f3;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $b0f0e35343cbf8ab$var$deprecations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var deprecation = _step.value;
            if (Object.hasOwn(options, deprecation.from)) (0, $337acd4a17e06e51$export$565e9d9bd6b6e0d4)('Unexpected `' + deprecation.from + '` prop, ' + (deprecation.to ? 'use `' + deprecation.to + '` instead' : 'remove it') + ' (see <' + $b0f0e35343cbf8ab$var$changelog + '#' + deprecation.id + '> for more info)');
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (allowedElements && disallowedElements) (0, $337acd4a17e06e51$export$565e9d9bd6b6e0d4)('Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other');
    (0, $dfcab761b4e96982$export$bf638b60ea8b89b7)(tree, transform);
    return (0, $e271038476068075$export$59c10052b2dee561)(tree, {
        Fragment: (0, $b9b8d11a1c089252$exports.Fragment),
        components: components,
        ignoreInvalidStyle: true,
        jsx: (0, $b9b8d11a1c089252$exports.jsx),
        jsxs: (0, $b9b8d11a1c089252$exports.jsxs),
        passKeys: true,
        passNode: true
    });
    /** @type {BuildVisitor<Root>} */ function transform(node, index, parent) {
        if (node.type === 'raw' && parent && typeof index === 'number') {
            if (skipHtml) parent.children.splice(index, 1);
            else parent.children[index] = {
                type: 'text',
                value: node.value
            };
            return index;
        }
        if (node.type === 'element') {
            /** @type {string} */ var key;
            for(key in 0, $363482b2fb04a9bd$export$de3e062aedff083a)if (Object.hasOwn((0, $363482b2fb04a9bd$export$de3e062aedff083a), key) && Object.hasOwn(node.properties, key)) {
                var value = node.properties[key];
                var test = (0, $363482b2fb04a9bd$export$de3e062aedff083a)[key];
                if (test === null || test.includes(node.tagName)) node.properties[key] = urlTransform(String(value || ''), key, node);
            }
        }
        if (node.type === 'element') {
            var remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
            if (!remove && allowElement && typeof index === 'number') remove = !allowElement(node, index, parent);
            if (remove && parent && typeof index === 'number') {
                var _parent_children;
                if (unwrapDisallowed && node.children) (_parent_children = parent.children).splice.apply(_parent_children, [
                    index,
                    1
                ].concat((0, $XnYkK._)(node.children)));
                else parent.children.splice(index, 1);
                return index;
            }
        }
    }
}
function $b0f0e35343cbf8ab$export$ca5e94754123e2f3(value) {
    // Same as:
    // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
    // But without the `encode` part.
    var colon = value.indexOf(':');
    var questionMark = value.indexOf('?');
    var numberSign = value.indexOf('#');
    var slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash !== -1 && colon > slash || questionMark !== -1 && colon > questionMark || numberSign !== -1 && colon > numberSign || // It is a protocol, it should be allowed.
    $b0f0e35343cbf8ab$var$safeProtocol.test(value.slice(0, colon))) return value;
    return '';
}



var $hwO3w = parcelRequire("hwO3w");

var $54Czb = parcelRequire("54Czb");

var $5s1kH = parcelRequire("5s1kH");

var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $54Czb = parcelRequire("54Czb");

var $XnYkK = parcelRequire("XnYkK");

var $5s1kH = parcelRequire("5s1kH");

var $aTwoM = parcelRequire("aTwoM");
// inlined from the former `void-elements` dependency, so the package has
// zero runtime dependencies. `!doctype`/`!DOCTYPE` are treated as void so a
// doctype parses as a childless node instead of swallowing the document.
var $8f6a9865b245e86e$var$voidElements = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
    '!doctype': true,
    '!DOCTYPE': true
};
var $8f6a9865b245e86e$var$attrRE = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;
function $8f6a9865b245e86e$var$parseTag(tag) {
    var res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };
    var tagMatch = tag.match(/<\/?([^\s]+?)[/\s>]/);
    if (tagMatch) {
        res.name = tagMatch[1];
        // void-element lookup stays case sensitive on purpose: react-i18next
        // relies on `<Br>` NOT being treated as a void `<br>` (see 1df0f9d)
        if ($8f6a9865b245e86e$var$voidElements[tagMatch[1]] || tag.charAt(tag.length - 2) === '/') res.voidElement = true;
        // handle comment tag
        if (res.name.startsWith('!--')) {
            var endIndex = tag.indexOf('-->');
            return {
                type: 'comment',
                comment: endIndex !== -1 ? tag.slice(4, endIndex) : ''
            };
        }
    }
    var reg = new RegExp($8f6a9865b245e86e$var$attrRE);
    var result = null;
    for(;;){
        result = reg.exec(tag);
        if (result === null) break;
        if (!result[0].trim()) continue;
        if (result[1]) {
            var attr = result[1].trim();
            // boolean attributes carry `null` so stringify can render them bare
            // (`<input disabled/>` instead of `<input disabled=""/>`)
            var arr = [
                attr,
                null
            ];
            var eq = attr.indexOf('=');
            if (eq > -1) // split at the first `=` only, so `data-x=a=b` keeps its full value
            arr = [
                attr.slice(0, eq),
                attr.slice(eq + 1)
            ];
            res.attrs[arr[0]] = arr[1];
            reg.lastIndex--;
        } else if (result[2]) res.attrs[result[2]] = result[3].trim().substring(1, result[3].length - 1);
    }
    return res;
}
// comments are matched as a whole (so `>` inside them is fine), everything
// else tag-shaped is matched by the second alternative
var $8f6a9865b245e86e$var$tagRE = /<!--[\s\S]*?-->|<[a-zA-Z0-9\-!/](?:"[^"]*"|'[^']*'|[^'">])*>/g;
var $8f6a9865b245e86e$var$tagNameRE = /<\/?([^\s]+?)[/\s>]/;
var $8f6a9865b245e86e$var$whitespaceRE = /^\s*$/;
// tags whose content is raw text: nothing inside them is markup
var $8f6a9865b245e86e$var$rawTextRE = /^(script|style)$/i;
// placeholder for `<` of tags rejected by options.allowedTags; restored to a
// literal `<` in text/attr/comment content after parsing (U+0000 cannot appear
// in sane input, and a collision would merely render as an extra `<`)
var $8f6a9865b245e86e$var$sentinel = '\u0000';
// re-used obj for quick lookups of components
var $8f6a9865b245e86e$var$empty = Object.create(null);
function $8f6a9865b245e86e$var$restoreSentinels(nodes) {
    nodes.forEach(function(node) {
        if (node.type === 'text') {
            node.content = node.content.split($8f6a9865b245e86e$var$sentinel).join('<');
            return;
        }
        if (node.type === 'comment') {
            node.comment = node.comment.split($8f6a9865b245e86e$var$sentinel).join('<');
            return;
        }
        for(var key in node.attrs){
            var value = node.attrs[key];
            if (typeof value === 'string' && value.indexOf($8f6a9865b245e86e$var$sentinel) > -1) node.attrs[key] = value.split($8f6a9865b245e86e$var$sentinel).join('<');
        }
        if (node.children.length) $8f6a9865b245e86e$var$restoreSentinels(node.children);
    });
}
function $8f6a9865b245e86e$export$98e6a39c04603d36(html, options) {
    var components = options && options.components || $8f6a9865b245e86e$var$empty;
    var allowedTags = options && options.allowedTags;
    var restoreNeeded = false;
    if (allowedTags) {
        var isAllowed = typeof allowedTags === 'function' ? allowedTags : function isAllowed(name) {
            return allowedTags.indexOf(name) > -1;
        };
        // neutralize tags whose name is not allowed, so they parse as text.
        // on a disallowed match only the leading `<` is escaped and scanning
        // resumes right after it, so a valid tag glued into the same match
        // (e.g. `<bold>` inside `<10, <20, and <bold>`) still gets recognized
        var out = '';
        var pos = 0;
        $8f6a9865b245e86e$var$tagRE.lastIndex = 0;
        var am;
        while(am = $8f6a9865b245e86e$var$tagRE.exec(html)){
            var tag = am[0];
            out += html.slice(pos, am.index);
            var nameMatch = tag.match($8f6a9865b245e86e$var$tagNameRE);
            if (tag.startsWith('<!--') || nameMatch && isAllowed(nameMatch[1])) {
                out += tag;
                pos = am.index + tag.length;
            } else {
                restoreNeeded = true;
                out += $8f6a9865b245e86e$var$sentinel;
                pos = am.index + 1;
                $8f6a9865b245e86e$var$tagRE.lastIndex = pos;
            }
        }
        html = out + html.slice(pos);
    }
    var result = [];
    var arr = [];
    var current;
    var level = -1;
    var inComponent = false;
    // while parsing raw-text content (script/style), tag-looking matches
    // before this index belong to the content and must be skipped
    var rawUntil = 0;
    // lazily created lowercase copy for case-insensitive raw-text close-tag search
    var htmlLower;
    // handle text at top level
    if (html.indexOf('<') !== 0) {
        var end = html.indexOf('<');
        result.push({
            type: 'text',
            content: end === -1 ? html : html.substring(0, end)
        });
    }
    // collect matches with an exec loop instead of matchAll to keep ES5 API compat
    var matches = [];
    var m;
    while(m = $8f6a9865b245e86e$var$tagRE.exec(html))matches.push(m);
    matches.forEach(function(match, i) {
        var tag = match[0];
        if (!tag) return;
        // comments match as a whole; their content must not trigger the
        // mismatched-bracket split below
        if (tag.startsWith('<!--')) return;
        // count brackets outside quoted attribute values, so `<` inside an
        // attribute (e.g. title="1 < 2") can't trigger a bogus split
        var lts = 0;
        var gts = 0;
        var secondLt = -1;
        var quote = null;
        for(var j = 0; j < tag.length; j++){
            var c = tag.charAt(j);
            if (quote) {
                if (c === quote) quote = null;
            } else if (c === '"' || c === "'") quote = c;
            else if (c === '<') {
                lts++;
                if (lts === 2) secondLt = j;
            } else if (c === '>') gts++;
        }
        // only split when the remainder is itself a valid tag start; otherwise
        // a fragment like `< <!-->` desyncs the string-level isComment check
        // from parseTag's name-based comment detection and crashes the walker
        var validSplit = secondLt > -1 && /[a-zA-Z0-9\-!/]/.test(tag.charAt(secondLt + 1));
        if (lts > gts && validSplit) {
            var firstPart = tag.substring(0, secondLt);
            var secondPart = tag.substring(firstPart.length);
            matches[i][0] = secondPart;
            matches[i].index += firstPart.length;
        }
    });
    matches.forEach(function(match, i) {
        var tag = match[0];
        if (!tag) return;
        var index = match.index;
        if (index < rawUntil) return;
        if (inComponent) {
            if (tag !== '</' + current.name + '>') return;
            else inComponent = false;
        }
        var isOpen = tag.charAt(1) !== '/';
        var isComment = tag.startsWith('<!--');
        var start = index + tag.length;
        var nextChar = html.charAt(start);
        var nextMatch = matches[i + 1];
        var isText;
        if (nextChar === '<' && nextMatch) {
            var nextTag = html.substring(start, nextMatch.index);
            isText = nextTag.split('<').length > nextTag.split('>').length;
        }
        var parent;
        if (isComment) {
            var comment = $8f6a9865b245e86e$var$parseTag(tag);
            // if we're at root, push new base node
            if (level < 0) {
                result.push(comment);
                return result;
            }
            parent = arr[level];
            parent.children.push(comment);
            var text = html.slice(start, nextMatch ? nextMatch.index : undefined);
            if (text.length > 0) parent.children.push({
                type: 'text',
                content: text
            });
            return result;
        }
        if (isOpen) {
            level++;
            current = $8f6a9865b245e86e$var$parseTag(tag);
            if (current.type === 'tag' && components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }
            var isRawText = false;
            if (!inComponent && !current.voidElement && $8f6a9865b245e86e$var$rawTextRE.test(current.name)) {
                // raw-text element: everything up to the matching close tag is one
                // text child, regardless of what it looks like
                isRawText = true;
                htmlLower || (htmlLower = html.toLowerCase());
                var closeIndex = htmlLower.indexOf('</' + current.name.toLowerCase() + '>', start);
                var contentEnd = closeIndex === -1 ? html.length : closeIndex;
                var content = html.slice(start, contentEnd);
                if (content) current.children.push({
                    type: 'text',
                    content: content
                });
                rawUntil = contentEnd;
            }
            if (!current.voidElement && !inComponent && !isRawText && nextChar && nextChar !== '<') // text content runs to the next actual tag match; stray `<`
            // characters in between are part of the text
            current.children.push({
                type: 'text',
                content: html.slice(start, nextMatch ? nextMatch.index : undefined)
            });
            // if we're at root, push new base node
            if (level === 0) result.push(current);
            parent = arr[level - 1];
            if (parent) parent.children.push(current);
            arr[level] = current;
        }
        if (!isOpen || current.voidElement) {
            if (level > -1 && (current.voidElement || current.name === tag.slice(2, -1))) {
                level--;
                // move current up a level to match the end tag
                current = level === -1 ? result : arr[level];
            }
            if (!inComponent && (nextChar !== '<' || isText) && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                // the text node runs to the next actual tag match; -1 means
                // there's no tag after it (trailing text)
                var end = nextMatch ? nextMatch.index : -1;
                var content1 = html.slice(start, end === -1 ? undefined : end);
                // if a node is nothing but whitespace, collapse it as the spec states:
                // https://www.w3.org/TR/html4/struct/text.html#h-9.1
                if ($8f6a9865b245e86e$var$whitespaceRE.test(content1)) content1 = ' ';
                // don't add whitespace-only text nodes if they would be trailing text nodes
                // or if they would be leading whitespace-only text nodes:
                //  * end > -1 indicates this is not a trailing text node
                //  * leading node is when level is -1 and parent has length 0
                if (end > -1 && level + parent.length >= 0 || content1 !== ' ') parent.push({
                    type: 'text',
                    content: content1
                });
            }
        }
    });
    if (restoreNeeded) $8f6a9865b245e86e$var$restoreSentinels(result);
    return result;
}
function $8f6a9865b245e86e$var$attrString(attrs) {
    var buff = [];
    for(var key in attrs)if (attrs[key] === null) // boolean attribute, render bare
    buff.push(key);
    else // escape double quotes so values parsed from single-quoted or
    // multiline attributes can't break out of the generated markup
    buff.push(key + '="' + String(attrs[key]).replace(/"/g, '&quot;') + '"');
    if (!buff.length) return '';
    return ' ' + buff.join(' ');
}
function $8f6a9865b245e86e$var$stringifyNode(buff, doc) {
    switch(doc.type){
        case 'text':
            return buff + doc.content;
        case 'tag':
            {
                // a doctype is void but must not self-close: `<!DOCTYPE html>` not `<!DOCTYPE html/>`
                var tagEnd = doc.voidElement && doc.name.toLowerCase() !== '!doctype' ? '/>' : '>';
                buff += '<' + doc.name + (doc.attrs ? $8f6a9865b245e86e$var$attrString(doc.attrs) : '') + tagEnd;
                if (doc.voidElement) return buff;
                return buff + doc.children.reduce($8f6a9865b245e86e$var$stringifyNode, '') + '</' + doc.name + '>';
            }
        case 'comment':
            buff += '<!--' + doc.comment + '-->';
            return buff;
    }
}
function $8f6a9865b245e86e$export$fac44ee5b035f737(doc) {
    return doc.reduce(function(token, rootEl) {
        return token + $8f6a9865b245e86e$var$stringifyNode('', rootEl);
    }, '');
}
var $8f6a9865b245e86e$export$2e2bcd8739ae039 = {
    parse: $8f6a9865b245e86e$export$98e6a39c04603d36,
    stringify: $8f6a9865b245e86e$export$fac44ee5b035f737
};



var $hwO3w = parcelRequire("hwO3w");

var $XnYkK = parcelRequire("XnYkK");

var $03bAP = parcelRequire("03bAP");
var $5786201d2d57a2a0$export$c106dd0671a0fc2d = function(i18n, code, msg, rest) {
    var _i18n_services_logger, _console;
    var _i18n_services_logger1, _i18n_services, _i18n_services_logger2, _i18n_services1, _console1;
    var args = [
        msg,
        (0, $hwO3w._)({
            code: code
        }, rest || {})
    ];
    if (i18n === null || i18n === void 0 ? void 0 : (_i18n_services = i18n.services) === null || _i18n_services === void 0 ? void 0 : (_i18n_services_logger1 = _i18n_services.logger) === null || _i18n_services_logger1 === void 0 ? void 0 : _i18n_services_logger1.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($5786201d2d57a2a0$export$844ec244b1367d54(args[0])) args[0] = "react-i18next:: ".concat(args[0]);
    if (i18n === null || i18n === void 0 ? void 0 : (_i18n_services1 = i18n.services) === null || _i18n_services1 === void 0 ? void 0 : (_i18n_services_logger2 = _i18n_services1.logger) === null || _i18n_services_logger2 === void 0 ? void 0 : _i18n_services_logger2.warn) (_i18n_services_logger = i18n.services.logger).warn.apply(_i18n_services_logger, (0, $XnYkK._)(args));
    else if ((_console1 = console) === null || _console1 === void 0 ? void 0 : _console1.warn) (_console = console).warn.apply(_console, (0, $XnYkK._)(args));
};
var $5786201d2d57a2a0$var$alreadyWarned = {};
var $5786201d2d57a2a0$export$5b28268982f175ba = function(i18n, code, msg, rest) {
    if ($5786201d2d57a2a0$export$844ec244b1367d54(msg) && $5786201d2d57a2a0$var$alreadyWarned[msg]) return;
    if ($5786201d2d57a2a0$export$844ec244b1367d54(msg)) $5786201d2d57a2a0$var$alreadyWarned[msg] = new Date();
    $5786201d2d57a2a0$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
var $5786201d2d57a2a0$var$loadedClb = function(i18n, cb) {
    return function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function() {
                setTimeout(function() {
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
};
var $5786201d2d57a2a0$export$83be934b53fff43b = function(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $5786201d2d57a2a0$var$loadedClb(i18n, cb));
};
var $5786201d2d57a2a0$export$8cd7e7a54fa865bc = function(i18n, lng, ns, cb) {
    if ($5786201d2d57a2a0$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $5786201d2d57a2a0$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach(function(n) {
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $5786201d2d57a2a0$var$loadedClb(i18n, cb));
};
var $5786201d2d57a2a0$export$93d9ee97c1ad3f31 = function(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $5786201d2d57a2a0$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: function(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
var $5786201d2d57a2a0$export$be63e0664592e141 = function(Component) {
    return Component.displayName || Component.name || ($5786201d2d57a2a0$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
};
var $5786201d2d57a2a0$export$844ec244b1367d54 = function(obj) {
    return typeof obj === 'string';
};
var $5786201d2d57a2a0$export$a6cdc56e425d0d0a = function(obj) {
    return (typeof obj === "undefined" ? "undefined" : (0, $03bAP._)(obj)) === 'object' && obj !== null;
};



var $hwO3w = parcelRequire("hwO3w");
var $de3c3cf80b6b7ee4$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $de3c3cf80b6b7ee4$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
var $de3c3cf80b6b7ee4$var$unescapeHtmlEntity = function(m) {
    return $de3c3cf80b6b7ee4$var$htmlEntities[m];
};
var $de3c3cf80b6b7ee4$export$e8bacd2802a88316 = function(text) {
    return text.replace($de3c3cf80b6b7ee4$var$matchHtmlEntity, $de3c3cf80b6b7ee4$var$unescapeHtmlEntity);
};


var $cb1810455e170ad8$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: (0, $de3c3cf80b6b7ee4$export$e8bacd2802a88316),
    transDefaultProps: undefined
};
var $cb1810455e170ad8$export$2e2366488d12e20d = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    $cb1810455e170ad8$var$defaultOptions = (0, $hwO3w._)({}, $cb1810455e170ad8$var$defaultOptions, options);
};
var $cb1810455e170ad8$export$212bb2fc580a90a8 = function() {
    return $cb1810455e170ad8$var$defaultOptions;
};


var $d2b83aedf9e08eb6$var$i18nInstance;
var $d2b83aedf9e08eb6$export$a039134f2fc7e0 = function(instance) {
    $d2b83aedf9e08eb6$var$i18nInstance = instance;
};
var $d2b83aedf9e08eb6$export$64af334f494c2f47 = function() {
    return $d2b83aedf9e08eb6$var$i18nInstance;
};



var $fb52ff2ebf6593d4$var$hasChildren = function(node, checkLength) {
    var _node_props;
    if (!node) return false;
    var _node_props_children;
    var base = (_node_props_children = (_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.children) !== null && _node_props_children !== void 0 ? _node_props_children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
var $fb52ff2ebf6593d4$var$getChildren = function(node) {
    var _node_props, _node_props1;
    if (!node) return [];
    var _node_props_children;
    var children = (_node_props_children = (_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.children) !== null && _node_props_children !== void 0 ? _node_props_children : node.children;
    return ((_node_props1 = node.props) === null || _node_props1 === void 0 ? void 0 : _node_props1.i18nIsDynamicList) ? $fb52ff2ebf6593d4$var$getAsArray(children) : children;
};
var $fb52ff2ebf6593d4$var$hasValidReactChildren = function(children) {
    return Array.isArray(children) && children.every((0, $5s1kH.isValidElement));
};
var $fb52ff2ebf6593d4$var$getAsArray = function(data) {
    return Array.isArray(data) ? data : [
        data
    ];
};
var $fb52ff2ebf6593d4$var$mergeProps = function(source, target) {
    var newTarget = (0, $hwO3w._)({}, target);
    newTarget.props = (0, $hwO3w._)({}, target.props, source.props);
    return newTarget;
};
var $fb52ff2ebf6593d4$var$getValuesFromChildren = function(children) {
    var values = {};
    if (!children) return values;
    var getData = function(childs) {
        var childrenArray = $fb52ff2ebf6593d4$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if ((0, $5786201d2d57a2a0$export$844ec244b1367d54)(child)) return;
            if ($fb52ff2ebf6593d4$var$hasChildren(child)) getData($fb52ff2ebf6593d4$var$getChildren(child));
            else if ((0, $5786201d2d57a2a0$export$a6cdc56e425d0d0a)(child) && !(0, $5s1kH.isValidElement)(child)) Object.assign(values, child);
        });
    };
    getData(children);
    return values;
};
var $fb52ff2ebf6593d4$export$4f7a36dd898f1267 = function(children, i18nOptions, i18n, i18nKey) {
    if (!children) return '';
    var stringNode = '';
    var childrenArray = $fb52ff2ebf6593d4$var$getAsArray(children);
    var _i18nOptions_transKeepBasicHtmlNodesFor;
    var keepArray = (i18nOptions === null || i18nOptions === void 0 ? void 0 : i18nOptions.transSupportBasicHtmlNodes) ? (_i18nOptions_transKeepBasicHtmlNodesFor = i18nOptions.transKeepBasicHtmlNodesFor) !== null && _i18nOptions_transKeepBasicHtmlNodesFor !== void 0 ? _i18nOptions_transKeepBasicHtmlNodesFor : [] : [];
    childrenArray.forEach(function(child, childIndex) {
        if ((0, $5786201d2d57a2a0$export$844ec244b1367d54)(child)) {
            stringNode += "".concat(child);
            return;
        }
        if ((0, $5s1kH.isValidElement)(child)) {
            var props = child.props, type = child.type;
            var childPropsCount = Object.keys(props).length;
            var shouldKeepChild = keepArray.indexOf(type) > -1;
            var childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += "<".concat(type, "/>");
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
                return;
            }
            if (shouldKeepChild && childPropsCount <= 1) {
                var cnt = (0, $5786201d2d57a2a0$export$844ec244b1367d54)(childChildren) ? childChildren : $fb52ff2ebf6593d4$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
                stringNode += "<".concat(type, ">").concat(cnt, "</").concat(type, ">");
                return;
            }
            var content = $fb52ff2ebf6593d4$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            return;
        }
        if (child === null) {
            (0, $5786201d2d57a2a0$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', "Passed in a null value as child", {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $5786201d2d57a2a0$export$a6cdc56e425d0d0a)(child)) {
            var format = child.format, clone = (0, $54Czb._)(child, [
                "format"
            ]);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
                return;
            }
            (0, $5786201d2d57a2a0$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', "Invalid child - Object should only have keys {{ value, format }} (format is optional).", {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $5786201d2d57a2a0$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', "Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.", {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
var $fb52ff2ebf6593d4$var$renderNodes = function(children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === '') return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map(function(keep) {
        return "<".concat(keep);
    }).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    var data = knownComponentsMap !== null && knownComponentsMap !== void 0 ? knownComponentsMap : {};
    var getData = function(childs) {
        var childrenArray = $fb52ff2ebf6593d4$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if ((0, $5786201d2d57a2a0$export$844ec244b1367d54)(child)) return;
            if ($fb52ff2ebf6593d4$var$hasChildren(child)) getData($fb52ff2ebf6593d4$var$getChildren(child));
            else if ((0, $5786201d2d57a2a0$export$a6cdc56e425d0d0a)(child) && !(0, $5s1kH.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    var knownNames = Object.keys(data);
    var allowedTags = function(name) {
        return /^\d+$/.test(name) || keepArray.indexOf(name) > -1 || knownNames.indexOf(name) > -1;
    };
    var ast = (0, $8f6a9865b245e86e$export$2e2bcd8739ae039).parse("<0>".concat(targetString, "</0>"), {
        allowedTags: allowedTags
    });
    var opts = (0, $hwO3w._)({}, data, combinedTOpts);
    var renderInner = function(child, node, rootReactNode) {
        var _child_props;
        var childs = $fb52ff2ebf6593d4$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $fb52ff2ebf6593d4$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || ((_child_props = child.props) === null || _child_props === void 0 ? void 0 : _child_props.i18nIsDynamicList) ? childs : mappedChildren;
    };
    var pushTranslatedJSX = function(child, inner, mem, i, isVoid) {
        var _mem;
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $5s1kH.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else (_mem = mem).push.apply(_mem, (0, $XnYkK._)((0, $5s1kH.Children).map([
            child
        ], function(c) {
            var _c_props;
            if (c.type === (0, $5s1kH.Fragment) || ((_c_props = c.props) === null || _c_props === void 0 ? void 0 : _c_props.i18nIsDynamicList) !== undefined) {
                var freshProps = {
                    key: i
                };
                if (c && c.props) Object.keys(c.props).forEach(function(k) {
                    if (k === 'children' || k === 'i18nIsDynamicList') return;
                    freshProps[k] = c.props[k];
                });
                return (0, $5s1kH.createElement)(c.type, freshProps, isVoid ? null : inner);
            }
            var override = {
                key: i
            };
            if (c && c.props) Object.keys(c.props).forEach(function(k) {
                if (k === 'ref' || k === 'children') return;
                override[k] = c.props[k];
            });
            return (0, $5s1kH.cloneElement)(c, override, isVoid ? null : inner);
        })));
    };
    var mapAST = function(reactNode, astNode, rootReactNode) {
        var reactNodes = $fb52ff2ebf6593d4$var$getAsArray(reactNode);
        var astNodes = $fb52ff2ebf6593d4$var$getAsArray(astNode);
        var keepTagOccurrence = {};
        return astNodes.reduce(function(mem, node, i) {
            var _node_children_, _node_children;
            var translationContent = ((_node_children = node.children) === null || _node_children === void 0 ? void 0 : (_node_children_ = _node_children[0]) === null || _node_children_ === void 0 ? void 0 : _node_children_.content) && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var props = (0, $hwO3w._)({}, node.attrs);
                if (shouldUnescape) Object.keys(props).forEach(function(p) {
                    var val = props[p];
                    if ((0, $5786201d2d57a2a0$export$844ec244b1367d54)(val)) props[p] = (0, $de3c3cf80b6b7ee4$export$e8bacd2802a88316)(val);
                });
                var child = Object.keys(props).length !== 0 ? $fb52ff2ebf6593d4$var$mergeProps({
                    props: props
                }, tmp) : tmp;
                var isElement = (0, $5s1kH.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $fb52ff2ebf6593d4$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $5786201d2d57a2a0$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                var isKnownComponent = (0, $5786201d2d57a2a0$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $5786201d2d57a2a0$export$844ec244b1367d54)(child)) {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($fb52ff2ebf6593d4$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var inner1 = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner1, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $5s1kH.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var occurrence = keepTagOccurrence[node.name] || 0;
                            keepTagOccurrence[node.name] = occurrence + 1;
                            var matched;
                            var seen = 0;
                            for(var r = 0; r < reactNodes.length; r += 1){
                                var rn = reactNodes[r];
                                if ((0, $5s1kH.isValidElement)(rn) && rn.type === node.name) {
                                    if (seen === occurrence) {
                                        matched = rn;
                                        break;
                                    }
                                    seen += 1;
                                }
                            }
                            var innerScope = matched ? $fb52ff2ebf6593d4$var$getAsArray($fb52ff2ebf6593d4$var$getChildren(matched)) : reactNodes;
                            var inner3 = mapAST(innerScope, node.children, rootReactNode);
                            mem.push((0, $5s1kH.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, $5786201d2d57a2a0$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var unescapeFn = typeof i18nOptions.unescape === 'function' ? i18nOptions.unescape : (0, $cb1810455e170ad8$export$212bb2fc580a90a8)().unescape;
                var content1 = shouldUnescape ? unescapeFn(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $5s1kH.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, content1));
                else mem.push(content1);
            }
            return mem;
        }, []);
    };
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $fb52ff2ebf6593d4$var$getAsArray(children || []));
    return $fb52ff2ebf6593d4$var$getChildren(result[0]);
};
var $fb52ff2ebf6593d4$var$fixComponentProps = function(component, index, translation) {
    var componentKey = component.key || index;
    var comp = (0, $5s1kH.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf("".concat(index, "/>")) < 0 && translation.indexOf("".concat(index, " />")) < 0) return comp;
    function Componentized() {
        return (0, $5s1kH.createElement)((0, $5s1kH.Fragment), null, comp);
    }
    return (0, $5s1kH.createElement)(Componentized, {
        key: componentKey
    });
};
var $fb52ff2ebf6593d4$var$generateArrayComponents = function(components, translation) {
    return components.map(function(c, index) {
        return $fb52ff2ebf6593d4$var$fixComponentProps(c, index, translation);
    });
};
var $fb52ff2ebf6593d4$var$generateObjectComponents = function(components, translation) {
    var componentMap = {};
    Object.keys(components).forEach(function(c) {
        Object.assign(componentMap, (0, $dUlz9._)({}, c, $fb52ff2ebf6593d4$var$fixComponentProps(components[c], c, translation)));
    });
    return componentMap;
};
var $fb52ff2ebf6593d4$var$generateComponents = function(components, translation, i18n, i18nKey) {
    if (!components) return null;
    if (Array.isArray(components)) return $fb52ff2ebf6593d4$var$generateArrayComponents(components, translation);
    if ((0, $5786201d2d57a2a0$export$a6cdc56e425d0d0a)(components)) return $fb52ff2ebf6593d4$var$generateObjectComponents(components, translation);
    (0, $5786201d2d57a2a0$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', '<Trans /> "components" prop expects an object or array', {
        i18nKey: i18nKey
    });
    return null;
};
var $fb52ff2ebf6593d4$var$isComponentsMap = function(object) {
    if (!(0, $5786201d2d57a2a0$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce(function(acc, key) {
        return acc && Number.isNaN(Number.parseFloat(key));
    }, true);
};
function $fb52ff2ebf6593d4$export$8d6a9236f2e3f2ce(_param) {
    var children = _param.children, count = _param.count, parent = _param.parent, i18nKey = _param.i18nKey, context = _param.context, _param_tOptions = _param.tOptions, tOptions = _param_tOptions === void 0 ? {} : _param_tOptions, values = _param.values, defaults = _param.defaults, components = _param.components, ns = _param.ns, i18nFromProps = _param.i18n, tFromProps = _param.t, shouldUnescape = _param.shouldUnescape, additionalProps = (0, $54Czb._)(_param, [
        "children",
        "count",
        "parent",
        "i18nKey",
        "context",
        "tOptions",
        "values",
        "defaults",
        "components",
        "ns",
        "i18n",
        "t",
        "shouldUnescape"
    ]);
    var _i18n_options, _i18n_options1, _i18n_options_interpolation, _i18n_options2, _i18n_options_interpolation1, _i18n_options3;
    var i18n = i18nFromProps || (0, $d2b83aedf9e08eb6$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $5786201d2d57a2a0$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', "Trans: You need to pass in an i18next instance using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.", {
            i18nKey: i18nKey
        });
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    var reactI18nextOptions = (0, $hwO3w._)({}, (0, $cb1810455e170ad8$export$212bb2fc580a90a8)(), (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.react);
    var namespaces = ns || t.ns || ((_i18n_options1 = i18n.options) === null || _i18n_options1 === void 0 ? void 0 : _i18n_options1.defaultNS);
    namespaces = (0, $5786201d2d57a2a0$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    var transDefaultProps = reactI18nextOptions.transDefaultProps;
    var mergedTOptions = (transDefaultProps === null || transDefaultProps === void 0 ? void 0 : transDefaultProps.tOptions) ? (0, $hwO3w._)({}, transDefaultProps.tOptions, tOptions) : tOptions;
    var mergedShouldUnescape = shouldUnescape !== null && shouldUnescape !== void 0 ? shouldUnescape : transDefaultProps === null || transDefaultProps === void 0 ? void 0 : transDefaultProps.shouldUnescape;
    var mergedValues = (transDefaultProps === null || transDefaultProps === void 0 ? void 0 : transDefaultProps.values) ? (0, $hwO3w._)({}, transDefaultProps.values, values) : values;
    var mergedComponents = (transDefaultProps === null || transDefaultProps === void 0 ? void 0 : transDefaultProps.components) ? (0, $hwO3w._)({}, transDefaultProps.components, components) : components;
    var nodeAsString = $fb52ff2ebf6593d4$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    var defaultValue = defaults || (mergedTOptions === null || mergedTOptions === void 0 ? void 0 : mergedTOptions.defaultValue) || nodeAsString || reactI18nextOptions.transEmptyNodeValue || (typeof i18nKey === 'function' ? (0, $aTwoM.keyFromSelector)(i18nKey) : i18nKey);
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if ((_i18n_options2 = i18n.options) === null || _i18n_options2 === void 0 ? void 0 : (_i18n_options_interpolation = _i18n_options2.interpolation) === null || _i18n_options_interpolation === void 0 ? void 0 : _i18n_options_interpolation.defaultVariables) values = mergedValues && Object.keys(mergedValues).length > 0 ? (0, $hwO3w._)({}, mergedValues, i18n.options.interpolation.defaultVariables) : (0, $hwO3w._)({}, i18n.options.interpolation.defaultVariables);
    else values = mergedValues;
    var valuesFromChildren = $fb52ff2ebf6593d4$var$getValuesFromChildren(children);
    if (valuesFromChildren && typeof valuesFromChildren.count === 'number' && count === undefined) count = valuesFromChildren.count;
    var interpolationOverride = values || count !== undefined && !((_i18n_options3 = i18n.options) === null || _i18n_options3 === void 0 ? void 0 : (_i18n_options_interpolation1 = _i18n_options3.interpolation) === null || _i18n_options_interpolation1 === void 0 ? void 0 : _i18n_options_interpolation1.alwaysFormat) || !children ? mergedTOptions.interpolation : {
        interpolation: (0, $lf4fc._)((0, $hwO3w._)({}, mergedTOptions.interpolation), {
            prefix: '#$?',
            suffix: '?$#'
        })
    };
    var combinedTOpts = (0, $lf4fc._)((0, $hwO3w._)((0, $lf4fc._)((0, $hwO3w._)({}, mergedTOptions), {
        context: context || mergedTOptions.context,
        count: count
    }), values, interpolationOverride), {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    if (translation === key && defaultValue) translation = defaultValue;
    var generatedComponents = $fb52ff2ebf6593d4$var$generateComponents(mergedComponents, translation, i18n, i18nKey);
    var indexedChildren = generatedComponents || children;
    var componentsMap = null;
    if ($fb52ff2ebf6593d4$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    var content = $fb52ff2ebf6593d4$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, mergedShouldUnescape);
    var useAsParent = parent !== null && parent !== void 0 ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $5s1kH.createElement)(useAsParent, additionalProps, content) : content;
}



var $lFIaz = parcelRequire("lFIaz");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $hwO3w = parcelRequire("hwO3w");

var $3SMYb = parcelRequire("3SMYb");

var $5s1kH = parcelRequire("5s1kH");




var $8ed410366b740601$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init: function(instance) {
        (0, $cb1810455e170ad8$export$2e2366488d12e20d)(instance.options.react);
        (0, $d2b83aedf9e08eb6$export$a039134f2fc7e0)(instance);
    }
};


var $f50c89ee23877b65$export$5603ab5ced17ce64 = (0, $5s1kH.createContext)();
var $f50c89ee23877b65$export$ea171b67e3820290 = /*#__PURE__*/ function() {
    "use strict";
    function ReportNamespaces() {
        (0, $5Epmf._)(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, $9MqXK._)(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
var $f50c89ee23877b65$export$30ff0342ccf735a = function(ForComponent) {
    return function(ctx) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var _ForComponent_getInitialProps, _ref, componentsInitialProps, i18nInitialProps;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (_ForComponent_getInitialProps = ForComponent.getInitialProps) === null || _ForComponent_getInitialProps === void 0 ? void 0 : _ForComponent_getInitialProps.call(ForComponent, ctx)
                        ];
                    case 1:
                        componentsInitialProps = (_ref = _state.sent()) !== null && _ref !== void 0 ? _ref : {};
                        i18nInitialProps = $f50c89ee23877b65$export$704200e5d0b9e8f();
                        return [
                            2,
                            (0, $hwO3w._)({}, componentsInitialProps, i18nInitialProps)
                        ];
                }
            });
        })();
    };
};
var $f50c89ee23877b65$export$704200e5d0b9e8f = function() {
    var _i18n_reportNamespaces;
    var i18n = (0, $d2b83aedf9e08eb6$export$64af334f494c2f47)();
    if (!i18n) {
        console.warn('react-i18next:: getInitialProps: You will need to pass in an i18next instance by using initReactI18next');
        return {};
    }
    var _i18n_reportNamespaces_getUsedNamespaces;
    var namespaces = (_i18n_reportNamespaces_getUsedNamespaces = (_i18n_reportNamespaces = i18n.reportNamespaces) === null || _i18n_reportNamespaces === void 0 ? void 0 : _i18n_reportNamespaces.getUsedNamespaces()) !== null && _i18n_reportNamespaces_getUsedNamespaces !== void 0 ? _i18n_reportNamespaces_getUsedNamespaces : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $18f804244ed3e353$export$8d6a9236f2e3f2ce(_param) {
    var children = _param.children, count = _param.count, parent = _param.parent, i18nKey = _param.i18nKey, context = _param.context, _param_tOptions = _param.tOptions, tOptions = _param_tOptions === void 0 ? {} : _param_tOptions, values = _param.values, defaults = _param.defaults, components = _param.components, ns = _param.ns, i18nFromProps = _param.i18n, tFromProps = _param.t, shouldUnescape = _param.shouldUnescape, additionalProps = (0, $54Czb._)(_param, [
        "children",
        "count",
        "parent",
        "i18nKey",
        "context",
        "tOptions",
        "values",
        "defaults",
        "components",
        "ns",
        "i18n",
        "t",
        "shouldUnescape"
    ]);
    var _i18n_options;
    var _ref = (0, $5s1kH.useContext)((0, $f50c89ee23877b65$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $d2b83aedf9e08eb6$export$64af334f494c2f47)();
    var t = tFromProps || (i18n === null || i18n === void 0 ? void 0 : i18n.t.bind(i18n));
    return (0, $fb52ff2ebf6593d4$export$8d6a9236f2e3f2ce)((0, $hwO3w._)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || (t === null || t === void 0 ? void 0 : t.ns) || defaultNSFromContext || (i18n === null || i18n === void 0 ? void 0 : (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.defaultNS),
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}




var $5s1kH = parcelRequire("5s1kH");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $XnYkK = parcelRequire("XnYkK");

var $5s1kH = parcelRequire("5s1kH");



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $4QAx6 = parcelRequire("4QAx6");

var $kW1tL = parcelRequire("kW1tL");
var $4e1b223feadb89c7$export$aa9e222d9ffc5d1b = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(TranslationParserError, Error1);
    function TranslationParserError(message, position, translationString) {
        (0, $5Epmf._)(this, TranslationParserError);
        var _this;
        _this = (0, $48Z0s._)(this, TranslationParserError, [
            message
        ]);
        _this.name = 'TranslationParserError';
        _this.position = position;
        _this.translationString = translationString;
        if (Error.captureStackTrace) Error.captureStackTrace(_this, TranslationParserError);
        return _this;
    }
    return TranslationParserError;
}((0, $kW1tL._)(Error));


var $f95b5587d910dea9$var$commonEntities = {
    '&nbsp;': '\u00A0',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&copy;': "\xa9",
    '&reg;': "\xae",
    '&trade;': "\u2122",
    '&hellip;': "\u2026",
    '&ndash;': "\u2013",
    '&mdash;': "\u2014",
    '&lsquo;': '\u2018',
    '&rsquo;': '\u2019',
    '&sbquo;': '\u201A',
    '&ldquo;': '\u201C',
    '&rdquo;': '\u201D',
    '&bdquo;': '\u201E',
    '&dagger;': "\u2020",
    '&Dagger;': "\u2021",
    '&bull;': "\u2022",
    '&prime;': "\u2032",
    '&Prime;': "\u2033",
    '&lsaquo;': "\u2039",
    '&rsaquo;': "\u203A",
    '&sect;': "\xa7",
    '&para;': "\xb6",
    '&middot;': "\xb7",
    '&ensp;': '\u2002',
    '&emsp;': '\u2003',
    '&thinsp;': '\u2009',
    '&euro;': "\u20AC",
    '&pound;': "\xa3",
    '&yen;': "\xa5",
    '&cent;': "\xa2",
    '&curren;': "\xa4",
    '&times;': "\xd7",
    '&divide;': "\xf7",
    '&minus;': "\u2212",
    '&plusmn;': "\xb1",
    '&ne;': "\u2260",
    '&le;': "\u2264",
    '&ge;': "\u2265",
    '&asymp;': "\u2248",
    '&equiv;': "\u2261",
    '&infin;': "\u221E",
    '&int;': "\u222B",
    '&sum;': "\u2211",
    '&prod;': "\u220F",
    '&radic;': "\u221A",
    '&part;': "\u2202",
    '&permil;': "\u2030",
    '&deg;': "\xb0",
    '&micro;': "\xb5",
    '&larr;': "\u2190",
    '&uarr;': "\u2191",
    '&rarr;': "\u2192",
    '&darr;': "\u2193",
    '&harr;': "\u2194",
    '&crarr;': "\u21B5",
    '&lArr;': "\u21D0",
    '&uArr;': "\u21D1",
    '&rArr;': "\u21D2",
    '&dArr;': "\u21D3",
    '&hArr;': "\u21D4",
    '&alpha;': "\u03B1",
    '&beta;': "\u03B2",
    '&gamma;': "\u03B3",
    '&delta;': "\u03B4",
    '&epsilon;': "\u03B5",
    '&zeta;': "\u03B6",
    '&eta;': "\u03B7",
    '&theta;': "\u03B8",
    '&iota;': "\u03B9",
    '&kappa;': "\u03BA",
    '&lambda;': "\u03BB",
    '&mu;': "\u03BC",
    '&nu;': "\u03BD",
    '&xi;': "\u03BE",
    '&omicron;': "\u03BF",
    '&pi;': "\u03C0",
    '&rho;': "\u03C1",
    '&sigma;': "\u03C3",
    '&tau;': "\u03C4",
    '&upsilon;': "\u03C5",
    '&phi;': "\u03C6",
    '&chi;': "\u03C7",
    '&psi;': "\u03C8",
    '&omega;': "\u03C9",
    '&Alpha;': "\u0391",
    '&Beta;': "\u0392",
    '&Gamma;': "\u0393",
    '&Delta;': "\u0394",
    '&Epsilon;': "\u0395",
    '&Zeta;': "\u0396",
    '&Eta;': "\u0397",
    '&Theta;': "\u0398",
    '&Iota;': "\u0399",
    '&Kappa;': "\u039A",
    '&Lambda;': "\u039B",
    '&Mu;': "\u039C",
    '&Nu;': "\u039D",
    '&Xi;': "\u039E",
    '&Omicron;': "\u039F",
    '&Pi;': "\u03A0",
    '&Rho;': "\u03A1",
    '&Sigma;': "\u03A3",
    '&Tau;': "\u03A4",
    '&Upsilon;': "\u03A5",
    '&Phi;': "\u03A6",
    '&Chi;': "\u03A7",
    '&Psi;': "\u03A8",
    '&Omega;': "\u03A9",
    '&Agrave;': "\xc0",
    '&Aacute;': "\xc1",
    '&Acirc;': "\xc2",
    '&Atilde;': "\xc3",
    '&Auml;': "\xc4",
    '&Aring;': "\xc5",
    '&AElig;': "\xc6",
    '&Ccedil;': "\xc7",
    '&Egrave;': "\xc8",
    '&Eacute;': "\xc9",
    '&Ecirc;': "\xca",
    '&Euml;': "\xcb",
    '&Igrave;': "\xcc",
    '&Iacute;': "\xcd",
    '&Icirc;': "\xce",
    '&Iuml;': "\xcf",
    '&ETH;': "\xd0",
    '&Ntilde;': "\xd1",
    '&Ograve;': "\xd2",
    '&Oacute;': "\xd3",
    '&Ocirc;': "\xd4",
    '&Otilde;': "\xd5",
    '&Ouml;': "\xd6",
    '&Oslash;': "\xd8",
    '&Ugrave;': "\xd9",
    '&Uacute;': "\xda",
    '&Ucirc;': "\xdb",
    '&Uuml;': "\xdc",
    '&Yacute;': "\xdd",
    '&THORN;': "\xde",
    '&szlig;': "\xdf",
    '&agrave;': "\xe0",
    '&aacute;': "\xe1",
    '&acirc;': "\xe2",
    '&atilde;': "\xe3",
    '&auml;': "\xe4",
    '&aring;': "\xe5",
    '&aelig;': "\xe6",
    '&ccedil;': "\xe7",
    '&egrave;': "\xe8",
    '&eacute;': "\xe9",
    '&ecirc;': "\xea",
    '&euml;': "\xeb",
    '&igrave;': "\xec",
    '&iacute;': "\xed",
    '&icirc;': "\xee",
    '&iuml;': "\xef",
    '&eth;': "\xf0",
    '&ntilde;': "\xf1",
    '&ograve;': "\xf2",
    '&oacute;': "\xf3",
    '&ocirc;': "\xf4",
    '&otilde;': "\xf5",
    '&ouml;': "\xf6",
    '&oslash;': "\xf8",
    '&ugrave;': "\xf9",
    '&uacute;': "\xfa",
    '&ucirc;': "\xfb",
    '&uuml;': "\xfc",
    '&yacute;': "\xfd",
    '&thorn;': "\xfe",
    '&yuml;': "\xff",
    '&iexcl;': "\xa1",
    '&iquest;': "\xbf",
    '&fnof;': "\u0192",
    '&circ;': "\u02C6",
    '&tilde;': "\u02DC",
    '&OElig;': "\u0152",
    '&oelig;': "\u0153",
    '&Scaron;': "\u0160",
    '&scaron;': "\u0161",
    '&Yuml;': "\u0178",
    '&ordf;': "\xaa",
    '&ordm;': "\xba",
    '&macr;': "\xaf",
    '&acute;': "\xb4",
    '&cedil;': "\xb8",
    '&sup1;': "\xb9",
    '&sup2;': "\xb2",
    '&sup3;': "\xb3",
    '&frac14;': "\xbc",
    '&frac12;': "\xbd",
    '&frac34;': "\xbe",
    '&spades;': "\u2660",
    '&clubs;': "\u2663",
    '&hearts;': "\u2665",
    '&diams;': "\u2666",
    '&loz;': "\u25CA",
    '&oline;': "\u203E",
    '&frasl;': "\u2044",
    '&weierp;': "\u2118",
    '&image;': "\u2111",
    '&real;': "\u211C",
    '&alefsym;': "\u2135"
};
var $f95b5587d910dea9$var$entityPattern = new RegExp(Object.keys($f95b5587d910dea9$var$commonEntities).map(function(entity) {
    return entity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}).join('|'), 'g');
var $f95b5587d910dea9$export$5cfeaa4af6841c8f = function(text) {
    return text.replace($f95b5587d910dea9$var$entityPattern, function(match) {
        return $f95b5587d910dea9$var$commonEntities[match];
    }).replace(/&#(\d+);/g, function(_, num) {
        return String.fromCharCode(parseInt(num, 10));
    }).replace(/&#x([0-9a-fA-F]+);/g, function(_, hex) {
        return String.fromCharCode(parseInt(hex, 16));
    });
};


var $85952fa4a5dbce7c$export$660b2ee2d4fb4eff = function(translation) {
    var tokens = [];
    var position = 0;
    var currentText = '';
    var flushText = function() {
        if (currentText) {
            tokens.push({
                type: 'Text',
                value: currentText,
                position: position - currentText.length
            });
            currentText = '';
        }
    };
    while(position < translation.length){
        var char = translation[position];
        if (char === '<') {
            var tagMatch = translation.slice(position).match(/^<(\d+)>/);
            if (tagMatch) {
                flushText();
                tokens.push({
                    type: 'TagOpen',
                    value: tagMatch[0],
                    position: position,
                    tagNumber: parseInt(tagMatch[1], 10)
                });
                position += tagMatch[0].length;
            } else {
                var closeTagMatch = translation.slice(position).match(/^<\/(\d+)>/);
                if (closeTagMatch) {
                    flushText();
                    tokens.push({
                        type: 'TagClose',
                        value: closeTagMatch[0],
                        position: position,
                        tagNumber: parseInt(closeTagMatch[1], 10)
                    });
                    position += closeTagMatch[0].length;
                } else {
                    currentText += char;
                    position += 1;
                }
            }
        } else {
            currentText += char;
            position += 1;
        }
    }
    flushText();
    return tokens;
};



var $54Czb = parcelRequire("54Czb");

var $XnYkK = parcelRequire("XnYkK");

var $5s1kH = parcelRequire("5s1kH");



var $d35b405b1eb3d8d6$var$renderDeclarationNode = function(declaration, children, childDeclarations) {
    var _React;
    var type = declaration.type, _declaration_props = declaration.props, props = _declaration_props === void 0 ? {} : _declaration_props;
    if (props.children && Array.isArray(props.children) && childDeclarations) {
        var _React1;
        var _childrenToRemove = props.children, propsWithoutChildren = (0, $54Czb._)(props, [
            "children"
        ]);
        return (_React1 = (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH)))).createElement.apply(_React1, [
            type,
            propsWithoutChildren
        ].concat((0, $XnYkK._)(children)));
    }
    if (children.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(type, props);
    if (children.length === 1) return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(type, props, children[0]);
    return (_React = (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH)))).createElement.apply(_React, [
        type,
        props
    ].concat((0, $XnYkK._)(children)));
};
var $d35b405b1eb3d8d6$export$1038df9fa5e5f35f = function(translation) {
    var declarations = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (!translation) return [];
    var tokens = (0, $85952fa4a5dbce7c$export$660b2ee2d4fb4eff)(translation);
    var result = [];
    var stack = [];
    var literalTagNumbers = new Set();
    var getCurrentDeclarations = function() {
        var _parentFrame_declaration_props;
        if (stack.length === 0) return declarations;
        var parentFrame = stack[stack.length - 1];
        if (((_parentFrame_declaration_props = parentFrame.declaration.props) === null || _parentFrame_declaration_props === void 0 ? void 0 : _parentFrame_declaration_props.children) && Array.isArray(parentFrame.declaration.props.children)) return parentFrame.declaration.props.children;
        return parentFrame.declarations;
    };
    tokens.forEach(function(token) {
        switch(token.type){
            case 'Text':
                {
                    var decoded = (0, $f95b5587d910dea9$export$5cfeaa4af6841c8f)(token.value);
                    var targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    targetArray.push(decoded);
                }
                break;
            case 'TagOpen':
                {
                    var tagNumber = token.tagNumber;
                    var currentDeclarations = getCurrentDeclarations();
                    var declaration = currentDeclarations[tagNumber];
                    if (!declaration) {
                        literalTagNumbers.add(tagNumber);
                        var literalText = "<".concat(tagNumber, ">");
                        var targetArray1 = stack.length > 0 ? stack[stack.length - 1].children : result;
                        targetArray1.push(literalText);
                        break;
                    }
                    stack.push({
                        tagNumber: tagNumber,
                        children: [],
                        position: token.position,
                        declaration: declaration,
                        declarations: currentDeclarations
                    });
                }
                break;
            case 'TagClose':
                {
                    var tagNumber1 = token.tagNumber;
                    if (literalTagNumbers.has(tagNumber1)) {
                        var literalText1 = "</".concat(tagNumber1, ">");
                        var literalTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        literalTargetArray.push(literalText1);
                        literalTagNumbers.delete(tagNumber1);
                        break;
                    }
                    if (stack.length === 0) throw new (0, $4e1b223feadb89c7$export$aa9e222d9ffc5d1b)("Unexpected closing tag </".concat(tagNumber1, "> at position ").concat(token.position), token.position, translation);
                    var frame = stack.pop();
                    if (frame.tagNumber !== tagNumber1) throw new (0, $4e1b223feadb89c7$export$aa9e222d9ffc5d1b)("Mismatched tags: expected </".concat(frame.tagNumber, "> but got </").concat(tagNumber1, "> at position ").concat(token.position), token.position, translation);
                    var element = $d35b405b1eb3d8d6$var$renderDeclarationNode(frame.declaration, frame.children, frame.declarations);
                    var elementTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    elementTargetArray.push(element);
                }
                break;
        }
    });
    if (stack.length > 0) {
        var unclosed = stack[stack.length - 1];
        throw new (0, $4e1b223feadb89c7$export$aa9e222d9ffc5d1b)("Unclosed tag <".concat(unclosed.tagNumber, "> at position ").concat(unclosed.position), unclosed.position, translation);
    }
    return result;
};




function $e1dbf2a2d55847f8$export$c70a6545d92ee1d4(param) {
    var i18nKey = param.i18nKey, defaultTranslation = param.defaultTranslation, content = param.content, ns = param.ns, _param_values = param.values, values = _param_values === void 0 ? {} : _param_values, i18nFromProps = param.i18n, tFromProps = param.t;
    var _i18n_t, _i18n_options, _i18n_options_interpolation, _i18n_options1;
    var i18n = i18nFromProps || (0, $d2b83aedf9e08eb6$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $5786201d2d57a2a0$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', "IcuTrans: You need to pass in an i18next instance using i18nextReactModule", {
            i18nKey: i18nKey
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Fragment, {}, defaultTranslation);
    }
    var t = tFromProps || ((_i18n_t = i18n.t) === null || _i18n_t === void 0 ? void 0 : _i18n_t.bind(i18n)) || function(k) {
        return k;
    };
    var namespaces = ns || t.ns || ((_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.defaultNS);
    namespaces = (0, $5786201d2d57a2a0$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    var mergedValues = values;
    if ((_i18n_options1 = i18n.options) === null || _i18n_options1 === void 0 ? void 0 : (_i18n_options_interpolation = _i18n_options1.interpolation) === null || _i18n_options_interpolation === void 0 ? void 0 : _i18n_options_interpolation.defaultVariables) mergedValues = values && Object.keys(values).length > 0 ? (0, $hwO3w._)({}, values, i18n.options.interpolation.defaultVariables) : (0, $hwO3w._)({}, i18n.options.interpolation.defaultVariables);
    var translation = t(i18nKey || defaultTranslation, (0, $lf4fc._)((0, $hwO3w._)({
        defaultValue: defaultTranslation
    }, mergedValues), {
        ns: namespaces
    }));
    try {
        var _React;
        var rendered = (0, $d35b405b1eb3d8d6$export$1038df9fa5e5f35f)(translation, content);
        return (_React = (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH)))).createElement.apply(_React, [
            (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Fragment,
            {}
        ].concat((0, $XnYkK._)(rendered)));
    } catch (error) {
        (0, $5786201d2d57a2a0$export$c106dd0671a0fc2d)(i18n, 'ICU_TRANS_RENDER_ERROR', 'IcuTrans component error for key "'.concat(i18nKey, '": ').concat(error.message), {
            i18nKey: i18nKey,
            error: error
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Fragment, {}, translation);
    }
}
$e1dbf2a2d55847f8$export$c70a6545d92ee1d4.displayName = 'IcuTransWithoutContext';



function $b2773c63bcf63f5e$export$c8b7e2ca8249a4be(param) {
    var i18nKey = param.i18nKey, defaultTranslation = param.defaultTranslation, content = param.content, ns = param.ns, _param_values = param.values, values = _param_values === void 0 ? {} : _param_values, i18nFromProps = param.i18n, tFromProps = param.t;
    var _i18n_options;
    var _ref = (0, $5s1kH.useContext)((0, $f50c89ee23877b65$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $d2b83aedf9e08eb6$export$64af334f494c2f47)();
    var t = tFromProps || (i18n === null || i18n === void 0 ? void 0 : i18n.t.bind(i18n));
    return (0, $e1dbf2a2d55847f8$export$c70a6545d92ee1d4)({
        i18nKey: i18nKey,
        defaultTranslation: defaultTranslation,
        content: content,
        ns: ns || (t === null || t === void 0 ? void 0 : t.ns) || defaultNSFromContext || (i18n === null || i18n === void 0 ? void 0 : (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.defaultNS),
        values: values,
        i18n: i18n,
        t: tFromProps
    });
}
$b2773c63bcf63f5e$export$c8b7e2ca8249a4be.displayName = 'IcuTrans';




var $hwO3w = parcelRequire("hwO3w");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");

var $5s1kH = parcelRequire("5s1kH");
var $205f54b84720f723$exports = {};
'use strict';

$205f54b84720f723$exports = (parcelRequire("3HOc9"));




var $341d5702266247e0$var$notReadyT = function(k, optsOrDefaultValue) {
    if ((0, $5786201d2d57a2a0$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $5786201d2d57a2a0$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $5786201d2d57a2a0$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    if (typeof k === 'function') return '';
    if (Array.isArray(k)) {
        var last = k[k.length - 1];
        return typeof last === 'function' ? '' : last;
    }
    return k;
};
var $341d5702266247e0$var$notReadySnapshot = {
    t: $341d5702266247e0$var$notReadyT,
    ready: false
};
var $341d5702266247e0$var$dummySubscribe = function() {
    return function() {};
};
var $341d5702266247e0$export$9fc83ad70ead8663 = function(ns) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _i18n_options, _i18n_reportNamespaces_addUsedNamespaces, _i18n_reportNamespaces;
    var i18nFromProps = props.i18n;
    var _ref = (0, $5s1kH.useContext)((0, $f50c89ee23877b65$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $d2b83aedf9e08eb6$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $f50c89ee23877b65$export$ea171b67e3820290)();
    if (!i18n) (0, $5786201d2d57a2a0$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
    var i18nOptions = (0, $5s1kH.useMemo)(function() {
        var _i18n_options;
        return (0, $hwO3w._)({}, (0, $cb1810455e170ad8$export$212bb2fc580a90a8)(), i18n === null || i18n === void 0 ? void 0 : (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.react, props);
    }, [
        i18n,
        props
    ]);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var nsOrContext = ns || defaultNSFromContext || (i18n === null || i18n === void 0 ? void 0 : (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.defaultNS);
    var unstableNamespaces = (0, $5786201d2d57a2a0$export$844ec244b1367d54)(nsOrContext) ? [
        nsOrContext
    ] : nsOrContext || [
        'translation'
    ];
    var namespaces = (0, $5s1kH.useMemo)(function() {
        return unstableNamespaces;
    }, unstableNamespaces);
    i18n === null || i18n === void 0 ? void 0 : (_i18n_reportNamespaces = i18n.reportNamespaces) === null || _i18n_reportNamespaces === void 0 ? void 0 : (_i18n_reportNamespaces_addUsedNamespaces = _i18n_reportNamespaces.addUsedNamespaces) === null || _i18n_reportNamespaces_addUsedNamespaces === void 0 ? void 0 : _i18n_reportNamespaces_addUsedNamespaces.call(_i18n_reportNamespaces, namespaces);
    var revisionRef = (0, $5s1kH.useRef)(0);
    var subscribe = (0, $5s1kH.useCallback)(function(callback) {
        if (!i18n) return $341d5702266247e0$var$dummySubscribe;
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        var wrappedCallback = function() {
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return function() {
            if (bindI18n) bindI18n.split(' ').forEach(function(e) {
                return i18n.off(e, wrappedCallback);
            });
            if (bindI18nStore) bindI18nStore.split(' ').forEach(function(e) {
                return i18n.store.off(e, wrappedCallback);
            });
        };
    }, [
        i18n,
        i18nOptions
    ]);
    var snapshotRef = (0, $5s1kH.useRef)();
    var getSnapshot = (0, $5s1kH.useCallback)(function() {
        if (!i18n) return $341d5702266247e0$var$notReadySnapshot;
        var calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
            return (0, $5786201d2d57a2a0$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
        });
        var currentLng = props.lng || i18n.language;
        var currentRevision = revisionRef.current;
        var lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.keyPrefix === keyPrefix && lastSnapshot.revision === currentRevision) return lastSnapshot;
        var calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix, {
            scopeNs: namespaces
        });
        var newSnapshot = {
            t: calculatedT,
            ready: calculatedReady,
            lng: currentLng,
            keyPrefix: keyPrefix,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), loadCount = _useState[0], setLoadCount = _useState[1];
    var _useSyncExternalStore = (0, $205f54b84720f723$exports.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot), t = _useSyncExternalStore.t, ready = _useSyncExternalStore.ready;
    (0, $5s1kH.useEffect)(function() {
        if (i18n && !ready && !useSuspense) {
            var onLoaded = function() {
                return setLoadCount(function(c) {
                    return c + 1;
                });
            };
            if (props.lng) (0, $5786201d2d57a2a0$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $5786201d2d57a2a0$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    var finalI18n = i18n || {};
    var wrapperRef = (0, $5s1kH.useRef)(null);
    var wrapperLangRef = (0, $5s1kH.useRef)();
    var createI18nWrapper = function(original) {
        var descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        var wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    var ret = (0, $5s1kH.useMemo)(function() {
        var original = finalI18n;
        var lang = original === null || original === void 0 ? void 0 : original.language;
        var i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        var effectiveT = !ready && !useSuspense ? function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $5786201d2d57a2a0$export$5b28268982f175ba)(i18n, 'USE_T_BEFORE_READY', 'useTranslation: t was called before ready. When using useSuspense: false, make sure to check the ready flag before using t.');
            return t.apply(void 0, (0, $XnYkK._)(args));
        } : t;
        var arr = [
            effectiveT,
            i18nWrapper,
            ready
        ];
        arr.t = effectiveT;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) {
        var inDevelopment = false;
        try {
            inDevelopment = false;
        } catch (e) {}
        if (inDevelopment) (0, $5786201d2d57a2a0$export$5b28268982f175ba)(i18n, 'SUSPENDED_WHILE_LOADING', 'useTranslation: suspended while translations are loading (useSuspense is true by default). Add a <Suspense> boundary above this component, or set react.useSuspense: false in the i18next init options. https://react.i18next.com/latest/usetranslation-hook');
        throw new Promise(function(resolve) {
            var onLoaded = function() {
                return resolve();
            };
            if (props.lng) (0, $5786201d2d57a2a0$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $5786201d2d57a2a0$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        });
    }
    return ret;
};



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $54Czb = parcelRequire("54Czb");

var $6iP9u = parcelRequire("6iP9u");

var $5s1kH = parcelRequire("5s1kH");


var $a0ecac704afa809b$export$2dcb0053efd21124 = function(ns) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_param) {
            var forwardedRef = _param.forwardedRef, rest = (0, $54Czb._)(_param, [
                "forwardedRef"
            ]);
            var _useTranslation = (0, $6iP9u._)((0, $341d5702266247e0$export$9fc83ad70ead8663)(ns, (0, $lf4fc._)((0, $hwO3w._)({}, rest), {
                keyPrefix: options.keyPrefix
            })), 3), t = _useTranslation[0], i18n = _useTranslation[1], ready = _useTranslation[2];
            var passDownProps = (0, $lf4fc._)((0, $hwO3w._)({}, rest), {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $5s1kH.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $5786201d2d57a2a0$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function(props, ref) {
            return (0, $5s1kH.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $5s1kH.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
};



var $54Czb = parcelRequire("54Czb");

var $6iP9u = parcelRequire("6iP9u");

var $fe961a083556d16a$export$b63289fbda65eed1 = function(_param) {
    var ns = _param.ns, children = _param.children, options = (0, $54Czb._)(_param, [
        "ns",
        "children"
    ]);
    var _useTranslation = (0, $6iP9u._)((0, $341d5702266247e0$export$9fc83ad70ead8663)(ns, options), 3), t = _useTranslation[0], i18n = _useTranslation[1], ready = _useTranslation[2];
    return children(t, {
        i18n: i18n,
        lng: i18n === null || i18n === void 0 ? void 0 : i18n.language
    }, ready);
};



var $5s1kH = parcelRequire("5s1kH");

function $5e255683b895cfa5$export$1325e8699caa160f(param) {
    var i18n = param.i18n, defaultNS = param.defaultNS, children = param.children;
    var value = (0, $5s1kH.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $5s1kH.createElement)((0, $f50c89ee23877b65$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $hwO3w = parcelRequire("hwO3w");

var $54Czb = parcelRequire("54Czb");

var $5s1kH = parcelRequire("5s1kH");

var $5s1kH = parcelRequire("5s1kH");


var $165d317a035c46af$export$3526fb65ade8d8b7 = function(initialI18nStore, initialLanguage) {
    var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _i18n_options;
    var i18nFromProps = props.i18n;
    var _ref = (0, $5s1kH.useContext)((0, $f50c89ee23877b65$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n;
    var i18n = i18nFromProps || i18nFromContext || (0, $d2b83aedf9e08eb6$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $5786201d2d57a2a0$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useSSR: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
        return;
    }
    if ((_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        var _i18n_services;
        if (!((_i18n_services = i18n.services) === null || _i18n_services === void 0 ? void 0 : _i18n_services.resourceStore)) {
            (0, $5786201d2d57a2a0$export$5b28268982f175ba)(i18n, 'I18N_NOT_INITIALIZED', "useSSR: i18n instance was found but not initialized (services.resourceStore is missing). Make sure you call i18next.init() before using useSSR \u2014 e.g. at module level, not only in getStaticProps/getServerSideProps.");
            return;
        }
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce(function(mem, lngResources) {
            Object.keys(lngResources).forEach(function(ns) {
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




var $f0652892fac41b50$export$80dfa519af1c8605 = function() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_param) {
            var initialI18nStore = _param.initialI18nStore, initialLanguage = _param.initialLanguage, rest = (0, $54Czb._)(_param, [
                "initialI18nStore",
                "initialLanguage"
            ]);
            (0, $165d317a035c46af$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $5s1kH.createElement)(WrappedComponent, (0, $hwO3w._)({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $f50c89ee23877b65$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, $5786201d2d57a2a0$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
};







var $3aa4ab583b29ab58$export$324d90190a8b822a = function() {
    return '';
};
var $3aa4ab583b29ab58$export$2da9be4cfdb689b1 = function() {
    return '';
};
var $3aa4ab583b29ab58$export$98e628dec113755e = function() {
    return '';
};
var $3aa4ab583b29ab58$export$2e6c959c16ff56b8 = function() {
    return '';
};
var $3aa4ab583b29ab58$export$4e35d5c922a95490 = function() {
    return '';
};
var $3aa4ab583b29ab58$export$720a3b9db04b7a0f = function() {
    return '';
};


// Modal.tsx

parcelRequire("5s1kH");
// ModalContext.ts

var $5s1kH = parcelRequire("5s1kH");
var $37793cea7f183eb2$export$78945e9f57940bb = /*#__PURE__*/ (0, $5s1kH.createContext)('neutral');


var $88386e905c2c4f47$var$Modal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, children = param.children, _param_variant = param.variant, variant = _param_variant === void 0 ? 'neutral' : _param_variant, _param_size = param.size, size = _param_size === void 0 ? 'normal' : _param_size, _param_ignoreOutsideClick = param.ignoreOutsideClick, ignoreOutsideClick = _param_ignoreOutsideClick === void 0 ? false : _param_ignoreOutsideClick;
    var variantClasses = {
        neutral: {
            background: 'bg-indigo-900'
        },
        warning: {
            background: 'bg-cherry-200'
        },
        dark: {
            background: 'bg-indigo-1000'
        }
    };
    var clickOutside = function() {
        if (!ignoreOutsideClick && onClose) onClose();
    };
    var sizeCls = "w-full max-w-lg mx-4";
    if (size === 'large') sizeCls = "z-modal-large";
    else if (size === "wide") sizeCls = "z-modal-wide";
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "fixed inset-0 z-50 ".concat(isOpen ? 'flex' : 'hidden', " items-center justify-center rounded-[16px]"),
        role: "dialog",
        "aria-modal": "true",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "fixed inset-0 z-40 bg-scrim/80 dark:bg-scrim/80",
                onClick: clickOutside
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $37793cea7f183eb2$export$78945e9f57940bb).Provider, {
                value: variant,
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "relative z-no-scrollbar ".concat(variantClasses[variant].background, " rounded-[16px] shadow-lg z-50 ").concat(sizeCls, " desktop:mx-0 "),
                    style: {
                        maxHeight: 'calc(100dvh - 16px)',
                        overflowY: 'scroll'
                    },
                    children: children
                })
            })
        ]
    });
};
var $88386e905c2c4f47$export$2e2bcd8739ae039 = $88386e905c2c4f47$var$Modal;


// ModalHeader.tsx


var $5s1kH = parcelRequire("5s1kH");

var $bf86ece098c957df$exports = {};
$bf86ece098c957df$exports = $parcel$resolve("8lzw1");


var $87983b584ed65f2f$var$ModalHeader = function(param) {
    var children = param.children, onClose = param.onClose;
    var variant = (0, $5s1kH.useContext)((0, $37793cea7f183eb2$export$78945e9f57940bb));
    var variantClasses = {
        neutral: {
            border: "border-indigo-700",
            text: "text-white",
            background: 'bg-indigo-900'
        },
        warning: {
            border: "border-cherry-400",
            text: "text-indigo-1000",
            background: 'bg-indigo-900'
        },
        dark: {
            border: "border-indigo-700",
            text: "text-white",
            background: 'bg-indigo-900'
        }
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "flex justify-between items-center py-3 px-4 border-b max-sm:sticky max-sm:top-0 z-10\n        ".concat(variantClasses[variant].border, " ").concat(variantClasses[variant].text, " ").concat(variantClasses[variant].background, " "),
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                style: {
                    fontSize: "18px",
                    lineHeight: "28px",
                    fontWeight: 500,
                    color: "var(--color-gray-100)"
                },
                className: "w-full items-center",
                children: children
            }),
            onClose && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                alt: "close",
                className: "h-10 w-10 rounded-full p-2 hover:bg-indigo-700 cursor-pointer",
                onClick: onClose
            })
        ]
    });
};
var $87983b584ed65f2f$export$2e2bcd8739ae039 = $87983b584ed65f2f$var$ModalHeader;


var $70ccbc54e3243003$export$2e2bcd8739ae039 = (0, $87983b584ed65f2f$export$2e2bcd8739ae039);


// ModalBody.tsx


var $5s1kH = parcelRequire("5s1kH");

var $9bf81f7437393e11$var$ModalBody = function(param) {
    var children = param.children, noPadding = param.noPadding;
    var variant = (0, $5s1kH.useContext)((0, $37793cea7f183eb2$export$78945e9f57940bb));
    var variantClasses = {
        neutral: {
            text: 'text-gray-300'
        },
        warning: {
            text: 'text-indigo-1000'
        },
        dark: {
            text: 'text-gray-300'
        }
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "".concat(noPadding ? '' : 'p-4', " overflow-y-auto ").concat(variantClasses[variant].text),
        children: children
    });
};
var $9bf81f7437393e11$export$2e2bcd8739ae039 = $9bf81f7437393e11$var$ModalBody;


var $26c7c4a825b0d416$export$2e2bcd8739ae039 = (0, $9bf81f7437393e11$export$2e2bcd8739ae039);


// ModalFooter.tsx


var $5s1kH = parcelRequire("5s1kH");

var $252a92c729eb72e9$var$ModalFooter = function(param) {
    var children = param.children;
    var variant = (0, $5s1kH.useContext)((0, $37793cea7f183eb2$export$78945e9f57940bb));
    var variantClasses = {
        neutral: {
            border: 'border-indigo-700',
            text: 'text-white',
            background: 'bg-indigo-900'
        },
        warning: {
            border: 'border-cherry-400',
            text: 'text-indigo-1000'
        }
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "flex justify-center items-center gap-x-2 py-3 px-4 border-t max-sm:sticky max-sm:bottom-0 ".concat(variantClasses[variant].border, " ").concat(variantClasses[variant].text, " ").concat(variantClasses[variant].background),
        children: children
    });
};
var $252a92c729eb72e9$export$2e2bcd8739ae039 = $252a92c729eb72e9$var$ModalFooter;


var $b5382f3541d67ab8$export$2e2bcd8739ae039 = (0, $252a92c729eb72e9$export$2e2bcd8739ae039);


var $397b941a88244231$export$2e2bcd8739ae039 = (0, $88386e905c2c4f47$export$2e2bcd8739ae039);



parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");
var $5f98ebfd719d2e22$var$colorClasses = {
    blue: 'bg-primary-500 text-indigo-1000 hover:bg-primary-400 active:bg-primary-400 disabled:opacity-40 dark:text-indigo-1000',
    'outline-white': 'bg-transparent border border-gray-500 text-white  hover:bg-indigo-800 disabled:opacity-40',
    neutral: 'bg-indigo-800 text-white hover:bg-indigo-700 active:bg-indigo-800 disabled:bg-indigo-700 disabled:opacity-40 disabled:text-indigo-1000',
    transparent: 'bg-transparent text-inherit hover:bg-indigo-700 active:bg-transparent disabled:opacity-40',
    red: 'bg-cherry-500 hover:bg-cherry-400 active:bg-cherry-500 disabled:opacity-40 text-indigo-1000',
    chip: 'bg-indigo-900 text-inherit hover:bg-transparent border border-indigo-700 active:bg-transparent disabled:opacity-40'
};
var $5f98ebfd719d2e22$var$regularSizeClasses = {
    sm: 'py-2 px-6 text-xs font-medium',
    md: 'py-3 px-6 text-sm font-medium',
    lg: 'py-3 px-6 text-base font-medium'
};
var $5f98ebfd719d2e22$var$roundSizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6'
};
var $5f98ebfd719d2e22$var$iconSizeClasses = {
    sm: 'items-center',
    md: 'h-6 w-6 items-center flex justify-center align-middle'
};
var $5f98ebfd719d2e22$var$buttonTypeClasses = {
    blueBase: $5f98ebfd719d2e22$var$colorClasses.blue,
    outlineWhiteBase: $5f98ebfd719d2e22$var$colorClasses['outline-white'],
    neutralBase: $5f98ebfd719d2e22$var$colorClasses.neutral,
    transparentBase: $5f98ebfd719d2e22$var$colorClasses.transparent,
    dangerBase: $5f98ebfd719d2e22$var$colorClasses.red,
    chipBase: $5f98ebfd719d2e22$var$colorClasses.chip
};
var $5f98ebfd719d2e22$var$CustomButton = function(param) {
    var _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, _param_buttonType = param.buttonType, buttonType = _param_buttonType === void 0 ? 'blueBase' : _param_buttonType, _param_size = param.size, size = _param_size === void 0 ? 'md' : _param_size, _param_isRound = param.isRound, isRound = _param_isRound === void 0 ? false : _param_isRound, onClick = param.onClick, leftIcon = param.leftIcon, rightIcon = param.rightIcon, children = param.children, style = param.style, to = param.to, target = param.target, rel = param.rel;
    // Determine size-related classes
    var sizeClass = isRound ? $5f98ebfd719d2e22$var$roundSizeClasses[size] : $5f98ebfd719d2e22$var$regularSizeClasses[size];
    // Fully rounded for any isRound scenario
    var roundedClass = 'rounded-full';
    // Width for non-round buttons
    var widthClass = isRound ? '' : 'w-full';
    // Determine icon size
    var iconClass = $5f98ebfd719d2e22$var$iconSizeClasses['sm'];
    if (isRound) iconClass = $5f98ebfd719d2e22$var$iconSizeClasses[size];
    // Combine all classes
    var classes = [
        $5f98ebfd719d2e22$var$buttonTypeClasses[buttonType],
        sizeClass,
        roundedClass,
        widthClass,
        'flex',
        'items-center',
        'justify-center',
        'cursor-pointer',
        isRound ? 'gap-0' : 'gap-x-2',
        'disabled:pointer-events-none',
        'transition-colors',
        'duration-200',
        className
    ].join(' ');
    // If `to` is provided and we're not disabled, render <Link> (from react-router-dom)
    if (to && !disabled) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bHX26.Link), {
        to: to,
        target: target,
        rel: rel,
        onClick: onClick,
        className: classes,
        style: style,
        children: isRound ? leftIcon || rightIcon ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
            className: iconClass,
            children: leftIcon || rightIcon
        }) : children : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                leftIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                    className: iconClass,
                    children: leftIcon
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                    children: children
                }),
                rightIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                    className: iconClass,
                    children: rightIcon
                })
            ]
        })
    });
    // Otherwise, render a regular <button>
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("button", {
        style: style,
        type: "button",
        className: classes,
        onClick: onClick,
        disabled: disabled,
        children: isRound ? leftIcon || rightIcon ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
            className: iconClass,
            children: leftIcon || rightIcon
        }) : children : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                leftIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                    className: iconClass,
                    children: leftIcon
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                    children: children
                }),
                rightIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                    className: iconClass,
                    children: rightIcon
                })
            ]
        })
    });
};
var $5f98ebfd719d2e22$export$2e2bcd8739ae039 = $5f98ebfd719d2e22$var$CustomButton;


var $62fb79d656788c69$export$2e2bcd8739ae039 = (0, $5f98ebfd719d2e22$export$2e2bcd8739ae039);



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");
var $dc1aabbe979c7a72$exports = {};
$dc1aabbe979c7a72$exports = $parcel$resolve("9sJnR");


var $557ae29a7e65a02f$exports = {};
$557ae29a7e65a02f$exports = $parcel$resolve("4gOpA");


// @ts-ignore
var $c3247f9fe2800c18$var$DotsPopup = function(param) {
    var items = param.items, close = param.close, noHover = param.noHover, isVerticalDots = param.isVerticalDots;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), open = _useState[0], setOpen = _useState[1];
    var containerRef = (0, $5s1kH.useRef)(null);
    var closeFunction = function() {
        setOpen(false);
    };
    (0, $5s1kH.useEffect)(function() {
        window.addEventListener("resize", closeFunction);
        return function() {
            window.removeEventListener("resize", closeFunction);
        };
    }, []);
    var calculateStyle = function() {
        var style = {
            position: "absolute",
            boxShadow: "3px 6px 6px 0px rgba(25, 25, 60, 0.70)",
            top: "unset",
            left: "unset",
            right: "unset",
            bottom: "unset"
        };
        var width = window.innerWidth;
        var height = window.innerHeight;
        if (containerRef.current) {
            var rect = containerRef.current.getBoundingClientRect();
            var clientHeight = rect.height;
            var clientWidth = rect.width;
            var fromLeft = rect.left;
            var fromTop = rect.top;
            var x;
            var y;
            if (width - fromLeft < 200) {
                // If element is to the left or has too little space to the right, align left
                x = width - fromLeft;
                style["right"] = x - clientWidth + "px";
            } else {
                x = fromLeft;
                style["left"] = x + "px";
            }
            if (height - fromTop < 200) {
                // If element is below middle or has too little space beneath, align from bottom
                y = height - fromTop - 2;
                style["bottom"] = y + "px";
            } else {
                y = fromTop + clientHeight - 2;
                style["top"] = y + "px";
            }
        }
        return style;
    };
    var style = {};
    if (open) style = calculateStyle();
    var itemClick = function(item) {
        if (item.click) item.click();
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "cursor-pointer relative gap-2",
        ref: containerRef,
        onClick: function(e) {
            return setOpen(!open);
        },
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "hover:bg-indigo-700 rounded-[20px] p-1",
                children: isVerticalDots ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    className: "icon",
                    alt: "Options",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($557ae29a7e65a02f$exports)))
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    className: "icon",
                    alt: "Options",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($dc1aabbe979c7a72$exports)))
                })
            }),
            open && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                style: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "calc(100vw - 1px)",
                    height: "100vh",
                    zIndex: 1001,
                    backgroundColor: "rgba(0, 0, 0, 0)"
                },
                onClick: closeFunction,
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "bg-indigo-800 rounded shadow-gray-600",
                    style: style,
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            children: [
                                index > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                    className: "border-indigo-700"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center px-4 py-2 text-gray-300 cursor-pointer hover:bg-indigo-600 hover:text-white hover:rounded",
                                    onClick: function() {
                                        return itemClick(item);
                                    },
                                    children: [
                                        item.img && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mr-2",
                                            children: item.img
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                            children: item.title
                                        })
                                    ]
                                })
                            ]
                        }, "item_" + index);
                    })
                })
            })
        ]
    });
};
var $c3247f9fe2800c18$export$2e2bcd8739ae039 = $c3247f9fe2800c18$var$DotsPopup;



var $9eebbdd2182bedc7$var$LoadingAnimation = function() {
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "flex items-center justify-center my-6",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "relative",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "w-24 h-24 rounded-full flex items-center justify-center bg-indigo-800",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex space-x-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "w-[8px] h-[8px] bg-primary-500 rounded-full animate-dot [animation-delay:0s]"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "w-[8px] h-[8px] bg-primary-500 rounded-full animate-dot [animation-delay:0.2s]"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "w-[8px] h-[8px] bg-primary-500 rounded-full animate-dot [animation-delay:0.4s]"
                        })
                    ]
                })
            })
        })
    });
};
var $9eebbdd2182bedc7$export$2e2bcd8739ae039 = $9eebbdd2182bedc7$var$LoadingAnimation;


var $acc426d061413a39$export$2e2bcd8739ae039 = (0, $9eebbdd2182bedc7$export$2e2bcd8739ae039);



parcelRequire("5s1kH");
var $e0bee690a85c3dea$var$colorClasses = {
    primary: {
        default: 'text-primary-500',
        hover: 'hover:text-primary-400',
        disabled: 'text-primary-500'
    },
    white: {
        default: 'text-white',
        hover: 'hover:text-gray-400',
        disabled: 'text-white'
    },
    whitePrimaryMix: {
        default: 'text-white',
        hover: 'hover:text-primary-400',
        disabled: 'text-white'
    }
};
var $e0bee690a85c3dea$var$sizeClasses = {
    xs: 'text-xs font-medium',
    sm: 'text-sm font-medium',
    base: 'text-base font-medium',
    lg: 'text-lg font-medium',
    xl: 'text-xl font-medium'
};
var $e0bee690a85c3dea$var$iconSizeClasses = {
    xs: 'h-4 w-4',
    sm: 'h-4 w-4',
    base: 'h-6 w-6',
    lg: 'h-6 w-6',
    xl: 'h-6 w-6'
};
var $e0bee690a85c3dea$var$TextLink = function(param) {
    var _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, _param_color = param.color, color = _param_color === void 0 ? 'primary' : _param_color, _param_size = param.size, size = _param_size === void 0 ? 'base' : _param_size, onClick = param.onClick, leftIcon = param.leftIcon, rightIcon = param.rightIcon, children = param.children, style = param.style, _param_text = param.text, text = _param_text === void 0 ? '' : _param_text;
    // Determine the text color + hover
    var colorClass = "".concat($e0bee690a85c3dea$var$colorClasses[color].default, " ").concat(disabled ? $e0bee690a85c3dea$var$colorClasses[color].disabled : $e0bee690a85c3dea$var$colorClasses[color].hover);
    var sizeClass = $e0bee690a85c3dea$var$sizeClasses[size];
    var iconClass = $e0bee690a85c3dea$var$iconSizeClasses[size];
    var classes = [
        colorClass,
        sizeClass,
        'inline-flex',
        'items-center',
        'gap-x-2',
        'disabled:pointer-events-none',
        'transition-colors',
        'duration-200',
        'w-full',
        'justify-center',
        'cursor-pointer',
        'group',
        className
    ].join(' ');
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("button", {
        style: style,
        type: "button",
        className: classes,
        onClick: onClick,
        disabled: disabled,
        children: [
            leftIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                className: iconClass,
                children: leftIcon
            }),
            text && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                children: text
            }),
            children && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                children: children
            }),
            rightIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                className: iconClass,
                children: rightIcon
            })
        ]
    });
};
var $e0bee690a85c3dea$export$2e2bcd8739ae039 = $e0bee690a85c3dea$var$TextLink;


var $65b37309f7d8dd2c$export$2e2bcd8739ae039 = (0, $e0bee690a85c3dea$export$2e2bcd8739ae039);



parcelRequire("5s1kH");
var $6c2ff88124776a4d$exports = {};
$6c2ff88124776a4d$exports = $parcel$resolve("lucjL");


var $496236f493c4c4fa$var$Checkbox = function(param) {
    var id = param.id, label = param.label, _param_checked = param.checked, checked = _param_checked === void 0 ? false : _param_checked, onChange = param.onChange, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_className = param.className, className = _param_className === void 0 ? "" : _param_className, _param_inputClassName = param.inputClassName, inputClassName = _param_inputClassName === void 0 ? "" : _param_inputClassName, _param_labelClassName = param.labelClassName, labelClassName = _param_labelClassName === void 0 ? "" : _param_labelClassName;
    var handleChange = function(e) {
        if (onChange) onChange(e.target.checked);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("label", {
        htmlFor: id,
        className: "flex items-center ".concat(disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer", " ").concat(className, " ").concat(labelClassName),
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                        type: "checkbox",
                        id: id,
                        checked: checked,
                        disabled: disabled,
                        onChange: handleChange,
                        className: "absolute h-6 w-6 opacity-0 cursor-pointer ".concat(inputClassName, " peer")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "h-6 w-6 rounded flex items-center justify-center cursor-pointer ".concat(checked ? "bg-primary-500" : "border border-gray-400 bg-transparent"),
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
                            alt: "Checked",
                            className: "w-5 h-5 ".concat(checked ? "block" : "hidden")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                className: "ms-2 text-white",
                children: label
            })
        ]
    });
};
var $496236f493c4c4fa$export$2e2bcd8739ae039 = $496236f493c4c4fa$var$Checkbox;


var $bdb26526e1aa8454$export$2e2bcd8739ae039 = (0, $496236f493c4c4fa$export$2e2bcd8739ae039);


var $0fe3991a360589a5$exports = {};
$0fe3991a360589a5$exports = $parcel$resolve("8L8su");


var $fd544cb172fd757a$exports = {};
$fd544cb172fd757a$exports = $parcel$resolve("aNkfW");


var $39fbe7786abdc679$exports = {};
$39fbe7786abdc679$exports = $parcel$resolve("3gctF");


var $cb70cc925ae09565$exports = {};
$cb70cc925ae09565$exports = $parcel$resolve("fiOLB");


var $4d32ec9694b3412e$exports = {};
$4d32ec9694b3412e$exports = $parcel$resolve("fJ8FY");


var $25e20653d8aa411d$exports = {};
$25e20653d8aa411d$exports = $parcel$resolve("gJSLM");


var $be3c5e2d6f294fc0$exports = {};
$be3c5e2d6f294fc0$exports = $parcel$resolve("7H4gk");



var $lFIaz = parcelRequire("lFIaz");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $3SMYb = parcelRequire("3SMYb");
// Production environment.
var $632c75b97b900307$var$api_endpoint = "https://api-dazzle.zebrain.se/api/";
var $632c75b97b900307$var$fast_api_endpoint = "https://api-dazzle.zebrain.se/fast_api/";
// let web_socket_endpoint = "ws://localhost:9003"
var $632c75b97b900307$var$web_socket_endpoint = "wss://backoffice.zebrain.se/wss";
var $632c75b97b900307$var$file_host = "https://platform.zebrain.se/";
var $632c75b97b900307$var$app_host = "https://platform.zebrain.se/";
var $632c75b97b900307$var$meeting_host = "https://meeting.zebrain.se/";
var $632c75b97b900307$var$system = "production";
var $632c75b97b900307$var$userType = "client";
if (window.location.hostname === "localhost") {
    $632c75b97b900307$var$api_endpoint = "http://localhost:8070/api/";
    $632c75b97b900307$var$fast_api_endpoint = "http://localhost:8000/fast_api/";
    // api_endpoint = "https://backoffice.zebrain.se/api/"
    $632c75b97b900307$var$file_host = "http://localhost/";
    if (window.location.port === "1235") {
        $632c75b97b900307$var$app_host = "http://localhost:1235/";
        $632c75b97b900307$var$userType = "coach";
    } else $632c75b97b900307$var$app_host = "http://localhost:1234/";
    $632c75b97b900307$var$meeting_host = "http://localhost:1236/";
    $632c75b97b900307$var$system = "development";
} else if (window.location.hostname === "platform-staging.zebrain.se") {
    $632c75b97b900307$var$api_endpoint = "https://backoffice.zebrain.se/api/";
    $632c75b97b900307$var$fast_api_endpoint = "https://backoffice.zebrain.se/fast_api/";
    $632c75b97b900307$var$file_host = "https://platform-staging.zebrain.se/";
    $632c75b97b900307$var$app_host = "https://platform-staging.zebrain.se/";
    $632c75b97b900307$var$system = "staging";
} else if (window.location.hostname === "coach-staging.zebrain.se") {
    $632c75b97b900307$var$api_endpoint = "https://backoffice.zebrain.se/api/";
    $632c75b97b900307$var$fast_api_endpoint = "https://backoffice.zebrain.se/fast_api/";
    $632c75b97b900307$var$file_host = "https://coach-staging.zebrain.se/";
    $632c75b97b900307$var$app_host = "https://coach-staging.zebrain.se/";
    $632c75b97b900307$var$system = "staging";
    $632c75b97b900307$var$userType = "coach";
} else if (window.location.hostname === "coach.zebrain.se") {
    $632c75b97b900307$var$file_host = "https://coach.zebrain.se/";
    $632c75b97b900307$var$app_host = "https://coach.zebrain.se/";
    $632c75b97b900307$var$userType = "coach";
}
var $632c75b97b900307$export$1630b5343357e8b5 = {
    TOKEN_NAME: "api_token",
    PERSON_TOKEN: "person_token",
    USERNAME_TOKEN: "username_token",
    API_ENDPOINT: $632c75b97b900307$var$api_endpoint,
    FAST_API_ENDPOINT: $632c75b97b900307$var$fast_api_endpoint,
    WEB_SOCKET_ENDPOINT: $632c75b97b900307$var$web_socket_endpoint,
    FILE_HOST: $632c75b97b900307$var$file_host,
    APP_HOST: $632c75b97b900307$var$app_host,
    MEETING_HOST: $632c75b97b900307$var$meeting_host,
    SYSTEM: $632c75b97b900307$var$system,
    AUTH0_CLIENT_ID: "Ec9P4CVtrm3cIVjUCNou3BMcXXJIPfjm",
    USER_TYPE: $632c75b97b900307$var$userType
};
var $632c75b97b900307$export$70b209735b7809eb = function(_userType) {
    if (_userType === "client") {
        if ($632c75b97b900307$var$system === "staging") window.location.href = "https://platform-staging.zebrain.se/";
        else if ($632c75b97b900307$var$system === "development") window.location.href = "http://localhost:1234/";
        else window.location.href = "https://platform.zebrain.se/";
    } else {
        if ($632c75b97b900307$var$system === "staging") window.location.href = "https://coach-staging.zebrain.se/";
        else if ($632c75b97b900307$var$system === "development") window.location.href = "http://localhost:1235/";
        else window.location.href = "https://coach.zebrain.se/";
    }
};


var $589abb406e7545d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Api(getAccessTokenSilently) {
        (0, $5Epmf._)(this, Api);
        this.baseUrl = (0, $632c75b97b900307$export$1630b5343357e8b5).API_ENDPOINT;
        this.baseUrlFast = (0, $632c75b97b900307$export$1630b5343357e8b5).FAST_API_ENDPOINT;
        if (getAccessTokenSilently) this.getAccessTokenSilently = getAccessTokenSilently;
    }
    (0, $9MqXK._)(Api, [
        {
            key: "get",
            value: function get(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(url) {
                    var _this, expectedErrors, anonymous, call;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                expectedErrors = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : [], anonymous = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                                if (!anonymous) return [
                                    3,
                                    1
                                ];
                                this.apiToken = 'anonymous';
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                if (this.getAccessTokenSilently === undefined) return [
                                    2,
                                    Promise.reject(new Error('getAccessTokenSilentlyNotAvailable'))
                                ];
                                return [
                                    4,
                                    this.getAccessTokenSilently().then(function(accessToken) {
                                        _this.apiToken = accessToken;
                                    }).catch(function(reason) {
                                        console.error(reason);
                                        return Promise.reject(401);
                                    })
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                call = this.getRaw(url);
                                return [
                                    2,
                                    this.makeCall(call, expectedErrors)
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "post",
            value: function post(_0, _1) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(url, data) {
                    var _this, expectedErrors, anonymous, skipJson, call;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                expectedErrors = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [], anonymous = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : false, skipJson = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : false;
                                if (!anonymous) return [
                                    3,
                                    1
                                ];
                                this.apiToken = 'anonymous';
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                if (this.getAccessTokenSilently === undefined) return [
                                    2,
                                    Promise.reject(new Error('getAccessTokenSilentlyNotAvailable'))
                                ];
                                return [
                                    4,
                                    this.getAccessTokenSilently().then(function(accessToken) {
                                        _this.apiToken = accessToken;
                                    }).catch(function(reason) {
                                        console.error(reason);
                                        return Promise.reject(401);
                                    })
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                call = this.postRaw(url, data);
                                return [
                                    2,
                                    this.makeCall(call, expectedErrors, skipJson)
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "formatUrl",
            value: function formatUrl(url) {
                if (url.startsWith('https')) return url;
                else if (url.startsWith('fast_api/')) // Hack - if url starts with fast_api/, remove that part from the url, since that part is in baseUrlFast
                return this.baseUrlFast + url.substring(9);
                else return this.baseUrl + url;
            }
        },
        {
            key: "formatHeaders",
            value: function formatHeaders() {
                if (this.apiToken === 'anonymous') return {
                    'Content-Type': 'application/json'
                };
                return {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer ".concat(this.apiToken)
                };
            }
        },
        {
            key: "getRaw",
            value: function getRaw(url) {
                var getUrl = url.startsWith("http") ? url : this.formatUrl(url);
                return fetch(getUrl, {
                    method: 'GET',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: this.formatHeaders(),
                    redirect: 'follow',
                    referrerPolicy: 'no-referrer'
                });
            }
        },
        {
            key: "postRaw",
            value: function postRaw(url, data) {
                var postUrl = this.formatUrl(url);
                return fetch(postUrl, {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: this.formatHeaders(),
                    redirect: 'follow',
                    referrerPolicy: 'no-referrer',
                    body: JSON.stringify(data) // body data type must match "Content-Type" header
                });
            }
        },
        {
            key: "makeCall",
            value: function makeCall(apiCall, expectedErrors) {
                var skipJson = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return new Promise(function(resolve, reject) {
                    apiCall// We got an http response
                    .then(function(response) {
                        var result = {
                            response: response,
                            isExpectedError: false
                        };
                        if (response.ok) {
                            if (skipJson) // If we want the response.body to remain unlocked we cannot run response.json()
                            resolve(result);
                            else // Call was successful (2XX status code)
                            response.json().then(function(json) {
                                // Uncomment to debug. Should be removed in production.
                                // console.log("----> ", json)
                                result.json = json;
                                resolve(result);
                            }).catch(function() {
                                // This is for status 204 which will have an empty body (ie no json)
                                resolve(result);
                            });
                        } else // We got an error (most likely 4XX or 5XX status code)
                        response.json().then(function(json) {
                            result.json = json;
                            result.errorName = result.json.name;
                            result.errorMessage = result.json.message;
                            result.isExpectedError = expectedErrors.includes(result.errorName);
                            if (!result.isExpectedError) {
                                if (response.status === 401) // User session has most likely expired server side
                                alert("Permission denied: 401");
                                else if (response.status === 503) alert("System is not able to respond now - please try again later.");
                                else alert('Error ' + response.status);
                            }
                            reject(result);
                        }).catch(function() {
                            // Response body is not json
                            var errMsg = "Error " + response.status;
                            if (response.status === 400) errMsg += " There is something wrong with the request. Contact support if problem persists.";
                            else if (response.status === 401) errMsg += " Unauthorized request.";
                            else if (response.status === 404) errMsg += " Could not find that resource.";
                            else if (response.status === 500) errMsg += " System error - we have received a report and will look into it.";
                            alert(errMsg);
                            reject(result);
                        });
                    })// We got no http response (eg due to timeout or network error)
                    .catch(function(reason) {
                        alert('Error 2: ' + reason);
                    });
                });
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance(getAccessTokenSilently) {
                if (Api.myInstance == null) {
                    if (getAccessTokenSilently) Api.myInstance = new Api(getAccessTokenSilently);
                    else Api.myInstance = new Api();
                }
                return this.myInstance;
            }
        }
    ]);
    return Api;
}();


var $c32e41a1c8ecb8c8$export$10937ee5ed6ee4d1 = {
    "en": "English",
    "sv": "Swedish",
    "da": "Danish",
    "fi": "Finnish",
    "no": "Norwegian",
    "de": "German",
    "fr": "French",
    "it": "Italian",
    "es": "Spanish"
};
var $c32e41a1c8ecb8c8$export$64783e31db14f0ba = function(language) {
    if (!language) return 'en';
    if (language.startsWith('sv')) return 'sv';
    return 'en';
};
var $c32e41a1c8ecb8c8$export$8f43a8af11ed514a = function(lang, txtSv, txtEn) {
    if (lang === "sv" && txtSv) return txtSv;
    else if (txtEn) return txtEn;
    else return "Missing description";
};


var $8872f0a5a4c34fff$export$c56d8f67a12422b1 = [
    "M\xe5ndag",
    'Tisdag',
    'Onsdag',
    'Torsdag',
    'Fredag',
    "L\xf6rdag",
    "S\xf6ndag"
];
var $8872f0a5a4c34fff$export$6b73857a58d7b12e = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];
var $8872f0a5a4c34fff$export$2bb3eb27682a776 = [
    'Januari',
    'Februari',
    'Mars',
    'April',
    'Maj',
    'Juni',
    'Juli',
    'Augusti',
    'September',
    'Oktober',
    'November',
    'December'
];
var $8872f0a5a4c34fff$export$22c5e7c8a0c84d30 = [
    'January',
    'February',
    'Mars',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
var $8872f0a5a4c34fff$export$b4b23bfab2f68498 = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Maj',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dec'
];
var $8872f0a5a4c34fff$export$af84e65568f81785 = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];


function $7d185b5883a21821$export$478c9c14b5784b92(monthNum, lang) {
    if (lang === 'en') return (0, $8872f0a5a4c34fff$export$af84e65568f81785)[monthNum];
    return (0, $8872f0a5a4c34fff$export$b4b23bfab2f68498)[monthNum];
}
function $7d185b5883a21821$export$5f885a9374f8e024(d) {
    return d.getHours() + ':' + $7d185b5883a21821$export$728c8e2d6789728(d.getMinutes());
}
function $7d185b5883a21821$export$2287e3d29250119e(d, minutes) {
    var newDate = new Date(d);
    newDate.setMinutes(newDate.getMinutes() + minutes);
    return newDate;
}
function $7d185b5883a21821$export$dd412b56f1e4d8aa(d, days) {
    var newDate = new Date(d);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
}
function $7d185b5883a21821$export$212a2e732fe26c47(start, l) {
    return new Date(start.getTime() + l * 60000);
}
function $7d185b5883a21821$export$83d04527fc498dec(d, lang) {
    var now = new Date();
    var midnight = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    var utcDate = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
    var dayDiff = Math.floor((utcDate - midnight) / 86400000);
    var ret;
    if (now.getFullYear() !== d.getFullYear()) ret = '' + d.getFullYear() + ' ' + d.getDate() + '/' + (d.getMonth() + 1);
    else if (dayDiff === 0) {
        if (lang === 'en') ret = 'Today';
        else ret = 'I dag';
    } else if (dayDiff === 1) {
        if (lang === 'en') ret = 'Tomorrow';
        else ret = 'I morgon';
    } else if (dayDiff === 2) {
        if (lang === 'en') ret = 'Day after tomorrow';
        else ret = "I \xf6vermorgon";
    } else if (dayDiff === -1) {
        if (lang === 'en') ret = 'Yesterday';
        else ret = "I g\xe5r";
    } else {
        var day = lang === 'en' ? (0, $8872f0a5a4c34fff$export$6b73857a58d7b12e) : (0, $8872f0a5a4c34fff$export$c56d8f67a12422b1);
        ret = day[$7d185b5883a21821$export$a24aefd2b69080a9(d)] + ' ' + d.getDate() + '/' + (d.getMonth() + 1);
    }
    ret += ' ' + d.getHours() + ':' + $7d185b5883a21821$export$728c8e2d6789728(d.getMinutes());
    return ret;
}
function $7d185b5883a21821$export$31bd54ef8fbd09b6(dateStr, lang) {
    var d = new Date(dateStr);
    return $7d185b5883a21821$export$83d04527fc498dec(d, lang);
}
function $7d185b5883a21821$export$a8b2a21161763694(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}
function $7d185b5883a21821$export$728c8e2d6789728(digit) {
    if (digit < 10) return "0" + digit;
    return "" + digit;
}
function $7d185b5883a21821$export$77b0033b88d4485c(thisWeekDate, orgDate) {
    // Convert week day so that Monday is 0
    var thisWeekDay = $7d185b5883a21821$export$2061056d06d7cdf7(thisWeekDate);
    var orgWeekDay = $7d185b5883a21821$export$2061056d06d7cdf7(orgDate);
    // If original day is Wednesday (2) and this day is Tuesday (1), add (2-1=1) day
    var addDays = orgWeekDay - thisWeekDay;
    return new Date(thisWeekDate.getFullYear(), thisWeekDate.getMonth(), thisWeekDate.getDate() + addDays, orgDate.getHours(), orgDate.getMinutes(), 0);
}
function $7d185b5883a21821$export$2061056d06d7cdf7(d) {
    var dayOfWeek = d.getDay() - 1;
    if (dayOfWeek < 0) dayOfWeek = 6;
    return dayOfWeek;
}
function $7d185b5883a21821$export$1c7501cd03a59e59(d, showTime, lang) {
    var day = lang === 'en' ? (0, $8872f0a5a4c34fff$export$6b73857a58d7b12e) : (0, $8872f0a5a4c34fff$export$c56d8f67a12422b1);
    var ret = day[$7d185b5883a21821$export$a24aefd2b69080a9(d)] + ' ' + d.getDate() + '/' + (d.getMonth() + 1);
    if (showTime) ret += ' ' + $7d185b5883a21821$export$728c8e2d6789728(d.getHours()) + ':' + $7d185b5883a21821$export$728c8e2d6789728(d.getMinutes());
    return ret;
}
function $7d185b5883a21821$export$3ae94a2503e890a1(dateStr, showTime, lang) {
    var d = new Date(dateStr);
    return $7d185b5883a21821$export$1c7501cd03a59e59(d, showTime, lang);
}
function $7d185b5883a21821$export$a24aefd2b69080a9(date) {
    if (date) {
        var dow = date.getDay();
        if (dow === 0) return 6;
        else return dow - 1;
    }
    return 0 // Actually an error, but should not happen
    ;
}
function $7d185b5883a21821$export$ce35f6b40b9b16f5(today) {
    if (!today) today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
}
function $7d185b5883a21821$export$9d50e68eb2ee0a21(date) {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0');
    var yyyy = date.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
}
function $7d185b5883a21821$export$5a252a405018366(dateStr) {
    var date = new Date(dateStr);
    return $7d185b5883a21821$export$9d50e68eb2ee0a21(date);
}
function $7d185b5883a21821$export$ff9a5f6f7fb9966b(d, lang) {
    var long = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var m = d.getMonth();
    var month = lang === 'sv' ? (0, $8872f0a5a4c34fff$export$b4b23bfab2f68498)[m].toLowerCase() + '.' : (0, $8872f0a5a4c34fff$export$af84e65568f81785)[m];
    var result = d.getDate() + ' ' + month;
    if (long) result += ' ' + d.getFullYear();
    return result;
}
function $7d185b5883a21821$export$9fb809e1ebb630fc(d, lang) {
    var long = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var m = d.getMonth();
    var month = lang === 'sv' ? (0, $8872f0a5a4c34fff$export$2bb3eb27682a776)[m] : (0, $8872f0a5a4c34fff$export$22c5e7c8a0c84d30)[m];
    var result = d.getDate() + ' ' + month;
    if (long) result += ' ' + d.getFullYear();
    return result;
}
function $7d185b5883a21821$export$9a827e9be85de527(totalMinutes) {
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    return hours + ':' + $7d185b5883a21821$export$728c8e2d6789728(minutes);
}
function $7d185b5883a21821$export$adf69d68d71478c0(d) {
    var dd = String(d.getDate()).padStart(2, '0');
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var yyyy = d.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
}


var $8a47c0bf566c4697$exports = {};
$8a47c0bf566c4697$exports = $parcel$resolve("Nole9");


var $95c80bab064dff3e$exports = {};
$95c80bab064dff3e$exports = $parcel$resolve("lIjOX");



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");
var $c8483606065062df$var$TabMenu = function(param) {
    var items = param.items, active = param.active;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(active ? active : 0), 2), activeTab = _useState[0], setActiveTab = _useState[1];
    (0, $5s1kH.useEffect)(function() {
        if (active !== undefined && active !== activeTab) setActiveTab(active);
    }, [
        active
    ]);
    var inactiveClasses = 'text-gray-400 whitespace-nowrap cursor-pointer hover:border-b hover:border-b-primary-400 hover:text-primary-400';
    // const activeClasses = 'underline underline-offset-8 text-primary-500'
    var activeClasses = 'border-b border-b-primary-500 text-primary-500';
    var click = function(item, index) {
        setActiveTab(index);
        item.callback();
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "flex border-b pb-2 border-b-indigo-800",
            children: items.map(function(item, index) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mr-4 h-6 flex items-center pb-2 " + (activeTab === index ? activeClasses : inactiveClasses),
                    onClick: function() {
                        return click(item, index);
                    },
                    style: {
                        marginBottom: "-8px"
                    },
                    children: [
                        item.iconUrl && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: item.iconUrl,
                            className: "h-4 mr-2",
                            alt: "icon"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "font-medium",
                            children: item.title
                        })
                    ]
                }, "tab_" + index);
            })
        })
    });
};
var $c8483606065062df$export$2e2bcd8739ae039 = $c8483606065062df$var$TabMenu;


function $1af830c9fe0316f4$export$a8d543f4b6260801() {
    var tabNr = 0;
    if (window.location.search) {
        var searchParams = new URLSearchParams(window.location.search);
        var tab = searchParams.get("tab");
        if (tab) tabNr = parseInt(tab, 10);
    }
    return tabNr;
}
function $1af830c9fe0316f4$export$a7d4a63c0f4094bf(tabNr) {
    if ('URLSearchParams' in window) {
        var url = new URL(window.location.href);
        url.searchParams.set("tab", "" + tabNr);
        history.pushState(null, '', url);
    }
}



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");



parcelRequire("5s1kH");
var $a26167e8bf49a279$var$ScoreBadge = function(props) {
    var baseClass = "font-medium flex items-center justify-center";
    // Decide between 'small' vs 'default' styles
    if (props.size === "small") // This sets a minimum width of ~3rem (48px), add px-2 for spacing
    baseClass += " text-xs h-4 min-w-[3rem] px-2 rounded-lg";
    else // This sets a minimum width of ~4rem (64px), add px-2 for spacing
    baseClass += " text-sm h-5 min-w-[4rem] px-2 rounded-xl";
    // Decide color variant based on `type` and `self`
    if (props.type === "task") {
        if (props.self) baseClass += " bg-royal-500 text-indigo-1000";
        else baseClass += " bg-royal-400 text-indigo-1000";
    } else if (props.type === "focus_area") {
        if (props.self) baseClass += " bg-peach-500 text-indigo-1000";
        else baseClass += " bg-peach-400 text-indigo-1000";
    }
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: baseClass,
        children: [
            props.txt && props.txt,
            props.score !== undefined && props.score.toFixed(1)
        ]
    });
};
var $a26167e8bf49a279$export$2e2bcd8739ae039 = $a26167e8bf49a279$var$ScoreBadge;






var $0895797b280ead2b$export$2fb15632c4c673d6 = function(props) {
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: props.modalOpen,
        onClose: function() {
            return props.setModalOpen(false);
        },
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: function() {
                    return props.setModalOpen(false);
                },
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title1",
                    children: props.t("how-it-works")
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: props.nrFeedbacks === 0 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "z-body1 text-gray-300",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: props.lang === "sv" ? "Att be om feedback \xe4r l\xe4tt!" : "Requesting feedback is easy!"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: props.lang === "sv" ? "G\xe5 igenom dessa tre steg:" : "You'll complete these 3 steps:"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("ol", {
                            className: "list-decimal list-inside space-y-1 pl-1 mt-4",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("li", {
                                    children: props.lang === "sv" ? "Skapa feedback-fr\xe5gor." : "Create feedback questions."
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("li", {
                                    children: props.lang === "sv" ? "V\xe4lj mottagare." : "Select recipients."
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("li", {
                                    children: props.lang === "sv" ? "Granska och skicka f\xf6rfr\xe5gan." : "Review and send the request."
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "z-body1 text-gray-300",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "mb-2",
                            children: props.lang === "sv" ? "F\xf6r att s\xe4kerst\xe4lla en korrekt uppf\xf6ljning av dina framsteg, l\xe5t de f\xf6rifyllda fr\xe5gorna och mottagarna fr\xe5n din ursprungliga f\xf6rfr\xe5gan vara of\xf6r\xe4ndrade. Granska och skicka f\xf6rfr\xe5gan." : "In order to ensure accurate progress tracking, please keep the pre-filled questions and recipients from your initial request unchanged. Review and send the request."
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "mb-2",
                            children: props.lang === "sv" ? "F\xf6lj dessa steg:" : "Follow these steps:"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("ol", {
                            className: "list-decimal list-inside space-y-1 mt-4 pl-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("li", {
                                    children: props.lang === "sv" ? "Granska sammanfattningen och skicka feedbackf\xf6rfr\xe5gan" : "Review the summary and send the request."
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("li", {
                                    children: props.lang === "sv" ? "G\xe5 igenom sj\xe4lvutv\xe4rderingen." : "Go through self-assessment."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    to: "/feedback/create/" + props.type + "/" + props.originId,
                    children: props.t("get-started")
                })
            })
        ]
    });
};


var $fc5a845596f1e4c9$exports = {};
$fc5a845596f1e4c9$exports = $parcel$resolve("dS3NJ");


var $eda3564600df02e0$exports = {};
$eda3564600df02e0$exports = $parcel$resolve("bCp47");




var $bf234ba9a155a985$exports = {};
$bf234ba9a155a985$exports = $parcel$resolve("lxTW5");


var $ac9ef737f3801a68$exports = {};
$ac9ef737f3801a68$exports = $parcel$resolve("8ZVwf");


var $dd0ccd8d6f00a586$exports = {};
$dd0ccd8d6f00a586$exports = $parcel$resolve("G0FKS");




parcelRequire("5s1kH");



parcelRequire("5s1kH");
var $cc4240a899060473$var$HalfCircleChart = function(param) {
    var value1 = param.value1, value2 = param.value2, maxValue = param.maxValue, type = param.type, circleNumbers = param.circleNumbers;
    var R_MAX = 50; // Maximum radius based on viewBox
    var cx = 50; // Center x-coordinate
    var cy = 50; // Center y-coordinate
    // Calculate radii based on area proportionality
    // const radius1 = R_MAX * Math.sqrt(value1 / maxValue);
    // const radius2 = R_MAX * Math.sqrt(value2 / maxValue);
    // Calculate radii based on radius proportionality
    // HD - use radius proportional with value to see difference clearer
    var radius1 = R_MAX * value1 / maxValue;
    var radius2 = R_MAX * value2 / maxValue;
    var leftFill = type && type === "task" ? "#5B6EF4" : "#FF9B8A";
    var rightFill = type && type === "task" ? "#8C99F7" : "#FFB9AD";
    // Left half-circle path
    var leftHalfCirclePath = function(radius) {
        return "\n      M ".concat(cx, ",").concat(cy, "\n      m 0,").concat(-radius, "\n      a ").concat(radius, ",").concat(radius, " 0 1,0 0,").concat(2 * radius, "\n      L ").concat(cx, ",").concat(cy, "\n      Z\n    ");
    };
    // Right half-circle path
    var rightHalfCirclePath = function(radius) {
        return "\n      M ".concat(cx, ",").concat(cy, "\n      m 0,").concat(-radius, "\n      a ").concat(radius, ",").concat(radius, " 0 1,1 0,").concat(2 * radius, "\n      L ").concat(cx, ",").concat(cy, "\n      Z\n    ");
    };
    // Minimum radius to display text (optional, for better visuals)
    var MIN_RADIUS_FOR_TEXT = 10;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            display: 'block'
        },
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("pattern", {
                    id: "stripedPattern",
                    patternUnits: "userSpaceOnUse",
                    width: "2",
                    height: "8",
                    patternTransform: "rotate(-45)",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("rect", {
                        width: "0.1",
                        height: "8",
                        fill: "#FFCDC4"
                    })
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("circle", {
                cx: cx,
                cy: cy,
                r: R_MAX,
                fill: "url(#stripedPattern)"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                d: leftHalfCirclePath(radius1),
                fill: leftFill
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                d: rightHalfCirclePath(radius2),
                fill: rightFill
            }),
            circleNumbers && radius1 > MIN_RADIUS_FOR_TEXT && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("text", {
                x: cx - radius1 / 2,
                y: cy,
                fill: "var(--indigo-1000, #000026)",
                fontFamily: '"TT Hoves"',
                fontSize: "9px",
                fontWeight: "500",
                textAnchor: "middle",
                alignmentBaseline: "middle",
                children: value1.toFixed(1)
            }),
            circleNumbers && radius2 > MIN_RADIUS_FOR_TEXT && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("text", {
                x: cx + radius2 / 2,
                y: cy,
                fill: "var(--indigo-1000, #000026)",
                fontFamily: '"TT Hoves"',
                fontSize: "9px",
                fontWeight: "500",
                textAnchor: "middle",
                alignmentBaseline: "middle",
                children: value2.toFixed(1)
            })
        ]
    });
};
var $cc4240a899060473$export$2e2bcd8739ae039 = $cc4240a899060473$var$HalfCircleChart;


var $529a09584460bde6$export$2e2bcd8739ae039 = (0, $cc4240a899060473$export$2e2bcd8739ae039);


var $3a94b90f0699d320$var$ScoreTable = function(props) {
    var t = (0, $341d5702266247e0$export$9fc83ad70ead8663)().t;
    var scoreSelf = props.question.selfScore;
    var scoreRespondents = props.question.average;
    var textCls = props.size && props.size === "small" ? "text-xs text-gray-400" : "text-gray-400";
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "w-32 h-32",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $529a09584460bde6$export$2e2bcd8739ae039), {
                    value1: scoreSelf,
                    value2: scoreRespondents,
                    circleNumbers: props.circleNumbers,
                    maxValue: 5,
                    type: props.type
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "ml-4 w-full",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: textCls,
                                children: [
                                    t("self-assessment"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a26167e8bf49a279$export$2e2bcd8739ae039), {
                                score: scoreSelf,
                                type: props.type,
                                size: props.size,
                                self: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-700 my-2"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: textCls,
                                children: [
                                    t("feedback-score"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a26167e8bf49a279$export$2e2bcd8739ae039), {
                                score: scoreRespondents,
                                type: props.type,
                                size: props.size,
                                self: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-700 my-2"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: textCls,
                                children: [
                                    t("perception-gap"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a26167e8bf49a279$export$2e2bcd8739ae039), {
                                score: Math.abs(props.question.gap),
                                size: props.size,
                                type: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-700 mt-2"
                    })
                ]
            })
        ]
    });
};
var $3a94b90f0699d320$export$2e2bcd8739ae039 = $3a94b90f0699d320$var$ScoreTable;


var $25414fbfb89997c7$export$2e2bcd8739ae039 = (0, $3a94b90f0699d320$export$2e2bcd8739ae039);


var $7e9b9c1a730c7955$exports = {};
$7e9b9c1a730c7955$exports = $parcel$resolve("gY8Cy");


var $a5555ba0531550ab$exports = {};
$a5555ba0531550ab$exports = $parcel$resolve("hBfdm");


var $c69e28b19a456287$exports = {};
$c69e28b19a456287$exports = $parcel$resolve("1gV2z");


var $d0129b8cfae32aec$var$PROMPTS_EN = [
    [
        "Help me resolve a team conflict",
        "Show me how to give better feedback",
        "Help me set boundaries with a colleague",
        "I want to improve how I communicate at work",
        "I want to build stronger trust in my team",
        "Help me navigate office politics",
        "Show me how to deal with a difficult colleague",
        "I want to improve my presentation skills",
        "Help me communicate more clearly in meetings",
        "I need help giving constructive criticism"
    ],
    [
        "Help me manage a tough conversation",
        "I want to support a struggling teammate",
        "Help me delegate more effectively",
        "I want to become a more inspiring leader",
        "Show me how to lead through change",
        "Help me run better team check-ins",
        "I\u2019m new to managing\u2014where should I start?",
        "How do I give feedback to a senior team member?"
    ],
    [
        "Help me set priorities for the week",
        "Show me how to stop procrastinating",
        "I want to build a daily focus habit",
        "Help me create a meeting agenda",
        "Help me beat decision fatigue",
        "Show me how to plan a focused workday",
        "I want to reduce distractions at work",
        "Help me set up a weekly review routine",
        "I need help breaking down a complex project",
        "I want to protect my time from too many meetings"
    ],
    [
        "I want to prepare for a promotion",
        "I want to increase my visibility at work",
        "What skills should I focus on this year?",
        "Help me build a personal development plan",
        "I want to switch roles \u2014 where do I begin?",
        "Help me grow in my current position",
        "How do I make the most of my 1:1s with my manager?"
    ],
    [
        "I want to reflect on a recent failure",
        "Help me prepare for a performance review",
        "Help me turn feedback into action",
        "Help me process feedback I don\u2019t agree with",
        "I want to learn from my last big mistake",
        "Show me how to ask for better feedback",
        "Help me reflect on my progress this quarter",
        "I want to prepare feedback for my manager"
    ],
    [
        "Help me manage stress at work",
        "I want to prevent burnout",
        "Show me how to balance work and life",
        "Help me stay calm under pressure",
        "I want to build more emotional resilience",
        "Show me how to create healthy work habits",
        "Help me recover after a stressful week",
        "I want to set better work-life boundaries",
        "Help me build a self-care routine that fits work",
        "I want to stop overcommitting myself"
    ],
    [
        "Show me how to work across time zones",
        "Help me make virtual meetings better",
        "I want to stay motivated working from home",
        "I want to feel more connected to my remote team",
        "Help me set communication norms with my team",
        "Show me how to collaborate async",
        "I want to avoid Zoom fatigue",
        "Help me manage hybrid team dynamics"
    ]
];
var $d0129b8cfae32aec$var$PROMPTS_SV = [
    [
        "Hj\xe4lp mig l\xf6sa en konflikt i teamet",
        "Visa mig hur jag kan ge b\xe4ttre feedback",
        "Hj\xe4lp mig s\xe4tta gr\xe4nser med en kollega",
        "Jag vill bli b\xe4ttre p\xe5 att kommunicera p\xe5 jobbet",
        "Jag vill bygga starkare f\xf6rtroende i mitt team",
        "Hj\xe4lp mig navigera kontorspolitik",
        "Visa mig hur jag hanterar en sv\xe5r kollega",
        "Jag vill f\xf6rb\xe4ttra mina presentationsf\xe4rdigheter",
        "Hj\xe4lp mig kommunicera tydligare p\xe5 m\xf6ten",
        "Jag beh\xf6ver hj\xe4lp med att ge konstruktiv kritik"
    ],
    [
        "Hj\xe4lp mig hantera ett sv\xe5rt samtal",
        "Jag vill st\xf6tta en kollega som k\xe4mpar",
        "Hj\xe4lp mig delegera mer effektivt",
        "Jag vill bli en mer inspirerande ledare",
        "Visa mig hur jag leder genom f\xf6r\xe4ndring",
        "Hj\xe4lp mig h\xe5lla b\xe4ttre teamm\xf6ten",
        "Jag \xe4r ny som chef \u2013 var ska jag b\xf6rja?",
        "Hur ger jag feedback till en mer senior teammedlem?"
    ],
    [
        "Hj\xe4lp mig s\xe4tta prioriteringar f\xf6r veckan",
        "Visa mig hur jag slutar skjuta upp saker",
        "Jag vill bygga en daglig fokusvana",
        "Hj\xe4lp mig skapa en m\xf6tesagenda",
        "Hj\xe4lp mig hantera beslutsutmattning",
        "Visa mig hur jag planerar en fokuserad arbetsdag",
        "Jag vill minska distraktioner p\xe5 jobbet",
        "Hj\xe4lp mig s\xe4tta upp en veckogenomg\xe5ng",
        "Jag beh\xf6ver hj\xe4lp med att bryta ner ett komplext projekt",
        "Jag vill skydda min tid fr\xe5n f\xf6r m\xe5nga m\xf6ten"
    ],
    [
        "Jag vill f\xf6rbereda mig f\xf6r en befordran",
        "Jag vill \xf6ka min synlighet p\xe5 jobbet",
        "Vilka f\xe4rdigheter b\xf6r jag fokusera p\xe5 i \xe5r?",
        "Hj\xe4lp mig skapa en personlig utvecklingsplan",
        "Jag vill byta roll \u2013 var b\xf6rjar jag?",
        "Hj\xe4lp mig v\xe4xa i min nuvarande roll",
        "Hur f\xe5r jag ut mest av mina 1:1:or med min chef?"
    ],
    [
        "Jag vill reflektera \xf6ver ett nyligt misslyckande",
        "Hj\xe4lp mig f\xf6rbereda mig f\xf6r ett utvecklingssamtal",
        "Hj\xe4lp mig omvandla feedback till handling",
        "Hj\xe4lp mig bearbeta feedback jag inte h\xe5ller med om",
        "Jag vill l\xe4ra mig av mitt senaste stora misstag",
        "Visa mig hur jag ber om b\xe4ttre feedback",
        "Hj\xe4lp mig reflektera \xf6ver mina framsteg det h\xe4r kvartalet",
        "Jag vill f\xf6rbereda feedback till min chef"
    ],
    [
        "Hj\xe4lp mig hantera stress p\xe5 jobbet",
        "Jag vill f\xf6rebygga utbr\xe4ndhet",
        "Visa mig hur jag balanserar arbete och fritid",
        "Hj\xe4lp mig h\xe5lla mig lugn under press",
        "Jag vill bygga mer k\xe4nslom\xe4ssig resiliens",
        "Visa mig hur jag skapar h\xe4lsosamma arbetsvanor",
        "Hj\xe4lp mig \xe5terh\xe4mta mig efter en stressig vecka",
        "Jag vill s\xe4tta b\xe4ttre gr\xe4nser mellan jobb och privatliv",
        "Hj\xe4lp mig skapa en sj\xe4lvv\xe5rdsrutin som passar jobbet",
        "Jag vill sluta ta p\xe5 mig f\xf6r mycket"
    ],
    [
        "Visa mig hur jag jobbar \xf6ver tidszoner",
        "Hj\xe4lp mig g\xf6ra virtuella m\xf6ten b\xe4ttre",
        "Jag vill h\xe5lla motivationen uppe n\xe4r jag jobbar hemifr\xe5n",
        "Jag vill k\xe4nna mig mer uppkopplad till mitt distansteam",
        "Hj\xe4lp mig s\xe4tta kommunikationsnormer i teamet",
        "Visa mig hur jag samarbetar asynkront",
        "Jag vill undvika Zoom-tr\xf6tthet",
        "Hj\xe4lp mig hantera dynamiken i ett hybridteam"
    ]
];
var $d0129b8cfae32aec$export$f0eb889d3170bfda = function(nr, lang) {
    var prompts;
    if (lang === 'sv') prompts = $d0129b8cfae32aec$var$PROMPTS_SV;
    else prompts = $d0129b8cfae32aec$var$PROMPTS_EN;
    var promptCategories = prompts.length;
    var categories = [];
    var suggestions = [];
    while(categories.length < nr){
        var category = Math.floor(Math.random() * (promptCategories - 1));
        if (categories.indexOf(category) === -1) categories.push(category);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = categories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category1 = _step.value;
            var rows = prompts[category1].length;
            var promptNr = Math.floor(Math.random() * (rows - 1));
            suggestions.push(prompts[category1][promptNr]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return suggestions;
};
function $d0129b8cfae32aec$export$f602d6403baa792d() {
    var aiThreadStartString = localStorage.getItem('ai_thread_start');
    if (!aiThreadStartString) return null;
    localStorage.removeItem('ai_thread_start');
    var aiThreadStart = JSON.parse(aiThreadStartString);
    var now = new Date();
    var startDate = new Date(aiThreadStart.date);
    if (now.getSeconds() - startDate.getSeconds() > 5) {
        console.log('aiThreadStart is too old: ' + startDate);
        return null;
    }
    return aiThreadStart;
}
function $d0129b8cfae32aec$export$f93b11ed7a4960f0(aiStyle, type) {
    var focusAreaId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, taskId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, threadId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, message = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, originName = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, originId = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, systemMessage = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : null;
    var aiThreadStart = {
        aiStyle: aiStyle,
        type: type,
        focusAreaId: focusAreaId,
        taskId: taskId,
        threadId: threadId,
        message: message,
        originId: originId,
        originName: originName,
        systemMessage: systemMessage,
        date: new Date().toISOString()
    };
    localStorage['ai_thread_start'] = JSON.stringify(aiThreadStart);
}





var $c180cd9307108dcb$export$e6b51c7c16ee49db = function(param) {
    var t = param.t, modalOpen = param.modalOpen, setModalOpen = param.setModalOpen, type = param.type, selfScore = param.selfScore, responsesScore = param.responsesScore, gap = param.gap;
    var createQuestion = function() {
        var question = {
            average: responsesScore,
            selfScore: selfScore,
            gap: gap,
            responses: [],
            question: ""
        };
        return question;
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: modalOpen,
        onClose: function() {
            return setModalOpen(false);
        },
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: function() {
                    return setModalOpen(false);
                },
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title1",
                    children: t("understanding-your-scores")
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                style: {
                    maxHeight: 'calc(100dvh - 90px)',
                    overflowY: 'auto'
                },
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $25414fbfb89997c7$export$2e2bcd8739ae039), {
                            question: createQuestion(),
                            type: type,
                            size: "small"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 text-white",
                            children: [
                                t("self-assessment"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-base text-gray-300",
                            children: t("average-of-your-answers")
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 text-white",
                            children: [
                                t("feedback-score"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-base text-gray-300",
                            children: t("average-feedback-colleagues")
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 text-white",
                            children: [
                                t("perception-gap"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "text-base text-gray-300",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    children: [
                                        t("difference-between-above"),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "mt-4",
                                    children: t("striped-areas-represents")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 text-white",
                            children: [
                                t("how-we-calculate-score"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-base text-gray-300",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                children: t("how-we-calculate-text")
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 text-white",
                            children: [
                                t("answer-score-correlation"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-1 text-base text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: t('strongly-agree')
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: "5.0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-1 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "text-base text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: t('agree')
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: "4.0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-1 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "text-base text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: t('neutral')
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: "3.0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-1 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "text-base text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: t('disagree')
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: "2.0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-1 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "text-base text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: t('strongly-disagree')
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: "1.0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-1 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "text-base text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: t('not-answered')
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: t('not-included')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-1 border-indigo-700"
                        })
                    ]
                })
            })
        ]
    });
};


function $c70252c420dfa719$export$2e2bcd8739ae039(param) {
    var task = param.task, feedbacks = param.feedbacks;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), feedbackNr = _useState[0], setFeedbackNr = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), selectedQuestion = _useState1[0], setSelectedQuestion = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), scoreInfo = _useState2[0], setScoreInfo = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), noAnswerInfo = _useState3[0], setNoAnswerInfo = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), requestFeedbackModalOpen = _useState4[0], setRequestFeedbackModalOpen = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), completedFeedbacks = _useState5[0], setCompletedFeedbacks = _useState5[1];
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var navigate = (0, $bHX26.useNavigate)();
    var now = new Date();
    var agreeOptions = [
        t("not-answered"),
        t("strongly-disagree"),
        t("disagree"),
        t("neutral"),
        t("agree"),
        t("strongly-agree")
    ];
    var scoreOptions = [
        5,
        4,
        3,
        2,
        1,
        0
    ];
    (0, $5s1kH.useEffect)(function() {
        var completed = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = feedbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var feedback = _step.value;
                var readyStatus = calculateReadyStatus(feedback);
                if (readyStatus === 0) completed++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setCompletedFeedbacks(completed);
    }, []);
    var createAiQuestion = function(feedback) {
        var question = feedback.questions[selectedQuestion];
        var result = t("help-me-analyze-feedback") + ":";
        result += "\nTask: " + task.name;
        result += "\nQuestion: " + question.text;
        var selfAssessment = question.selfAssessmentScore;
        result += "\nMy self-assessment answer was: " + agreeOptions[selfAssessment];
        result += "\nAnswers of feedback givers: ";
        for(var score = 0; score < question.responses.length; score++){
            var numAnswers = question.responses[score];
            result += "\n".concat(agreeOptions[score], " - [").concat(numAnswers, "]");
        }
        return result;
    };
    var toAiThread = function(feedback) {
        var helpMeAnalyze = createAiQuestion(feedback);
        (0, $d0129b8cfae32aec$export$f93b11ed7a4960f0)("coaching", "feedbackResult", null, task.id, null, helpMeAnalyze);
        navigate("/ai/0");
    };
    var renderQuestion = function(feedback) {
        var question = feedback.questions[selectedQuestion];
        var feedbackQuestion = {
            average: question.responsesScore,
            selfScore: question.selfAssessmentScore,
            gap: question.gap,
            question: question.text,
            responses: []
        };
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "p-4 bg-indigo-800 rounded-md mt-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "flex flex-wrap",
                        children: feedback.questions.map(function(question, index) {
                            var cls = "rounded-full border mb-2 mr-2 border-indigo-700 px-3 py-1 z-title3 cursor-pointer hover:bg-indigo-900 text-center";
                            if (index === selectedQuestion) cls += " bg-indigo-700";
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                onClick: function() {
                                    return setSelectedQuestion(index);
                                },
                                className: cls,
                                style: {
                                    minWidth: 92
                                },
                                children: [
                                    t("question"),
                                    " ",
                                    index + 1
                                ]
                            }, "q_" + index);
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-700 mt-2"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "text-gray-400 mt-2",
                        children: feedback.questions[selectedQuestion].text
                    }),
                    feedbackQuestion.selfScore > 0.0 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title1 text-white mt-4",
                                children: lang === "sv" ? "Fr\xe5gans resultat" : "Question result"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $25414fbfb89997c7$export$2e2bcd8739ae039), {
                                question: feedbackQuestion,
                                type: "task",
                                size: "small",
                                circleNumbers: false
                            })
                        ]
                    }) : // <h2 className="z-title1 text-white mt-4">
                    //   {lang === 'sv' ? 'Frågans resultat' : 'Question result'}: {feedbackQuestion.average.toFixed(1)}
                    // </h2>
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {}),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h2", {
                        className: "z-title1 text-white mt-4",
                        children: t("answers")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "w-full flex flex-col gap-4 mt-4",
                        children: scoreOptions.map(function(position, idx) {
                            var score = 5 - idx;
                            var responsesNr = question.responses[score];
                            var option = agreeOptions[position];
                            // Calculate percentage for this answer
                            var percentage = responsesNr > 0 ? responsesNr / feedback.numAnswers * 100 : 0;
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex justify-between items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                        className: "z-title3 text-gray-400",
                                                        children: option
                                                    }),
                                                    idx === 5 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                        className: "ml-2",
                                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                                            buttonType: "transparentBase",
                                                            size: "sm",
                                                            isRound: true,
                                                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                                                                alt: "info"
                                                            }),
                                                            onClick: function() {
                                                                return setNoAnswerInfo(true);
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    position === question.selfAssessmentScore && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                        className: "mr-2",
                                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a26167e8bf49a279$export$2e2bcd8739ae039), {
                                                            txt: t("you"),
                                                            type: "task",
                                                            size: "sm",
                                                            self: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c69e28b19a456287$exports))),
                                                        alt: "profile icon",
                                                        className: "w-4 h-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                        className: "ml-2 text-white font-medium",
                                                        children: responsesNr
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "w-full bg-indigo-700 rounded-full h-5 mt-1",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "bg-royal-400 h-5 rounded-full",
                                            style: {
                                                width: "".concat(percentage, "%")
                                            },
                                            children: percentage > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "flex justify-end items-center text-black z-title4 pr-1",
                                                children: [
                                                    percentage.toFixed(0),
                                                    "%"
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }, "answer-".concat(idx));
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        className: "mt-6",
                        buttonType: "outlineWhiteBase",
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cb70cc925ae09565$exports))),
                            alt: "ai"
                        }),
                        onClick: function() {
                            return toAiThread(feedback);
                        },
                        children: t("discuss-this-result")
                    })
                ]
            })
        });
    };
    var renderFeedbackData = function(feedback) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 z-title1",
                    children: lang === "sv" ? "Resultat" : "Result"
                }),
                renderQuestion(feedback),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                    isOpen: noAnswerInfo,
                    onClose: function() {
                        return setNoAnswerInfo(false);
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                            onClose: function() {
                                return setNoAnswerInfo(false);
                            },
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title1",
                                children: t("why-no-answer")
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "font-medium",
                                    children: t("why-no-answer-1")
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-1",
                                    children: t("why-no-answer-2")
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "font-medium mt-4",
                                    children: t("why-no-answer-3")
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-1",
                                    children: t("why-no-answer-4")
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "font-medium mt-4",
                                    children: t("why-no-answer-5")
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-1",
                                    children: t("why-no-answer-6")
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var calculateReadyStatus = function(feedback) {
        var deadline = new Date(feedback.deadline);
        var tooFewRespondents = feedback.numAnswers < 1;
        var deadlinePassed = deadline < now;
        if (deadlinePassed && tooFewRespondents) return 1;
        else if (!deadlinePassed && tooFewRespondents) return 3;
        return 0;
    };
    var renderFeedback = function(feedback) {
        var readyStatus = calculateReadyStatus(feedback);
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                readyStatus === 0 && renderFeedbackData(feedback),
                readyStatus === 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "border border-gray-500 rounded-md mt-4 p-4 bg-indigo-800 flex flex-col items-start gap-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    alt: "clock",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7e9b9c1a730c7955$exports))),
                                    className: "h-6"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-title2",
                                    children: t("not-enough-responses")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-body2 text-gray-200 ",
                            children: t("previous-feedback-failed-message")
                        }),
                        feedbackNr === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            className: "mt-0",
                            onClick: function() {
                                return setRequestFeedbackModalOpen(true);
                            },
                            children: t("request-new-feedback")
                        })
                    ]
                }),
                readyStatus > 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "border border-gray-500 rounded-md mt-4 p-4 bg-indigo-800 flex flex-col items-start gap-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    alt: "clock",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports))),
                                    className: "h-6"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "font-medium",
                                    children: lang === "sv" ? "V\xe4ntar p\xe5 resultat" : "Result pending"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-sm",
                            children: lang === "sv" ? "F\xf6rfr\xe5gan p\xe5g\xe5r. Vi skickar ett e-postmeddelande n\xe4r det f\xf6rsta svaret kommer in \u2013 och uppdaterar resultatet med ny feedback fram till tidsfristen." : "Request pending. We\u2019ll email you when the first reply comes in - and keep updating the result with new feedback until the deadline."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-title1",
                            children: t("details")
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center mt-4 gap-x-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($eda3564600df02e0$exports))),
                                    className: "w-4 h-4",
                                    alt: "sent"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "z-title3",
                                    children: [
                                        t("request-sent"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "text-sm text-gray-400",
                                    children: feedback.created.substring(0, 10)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-800"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center mt-2 gap-x-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                    className: "w-4 h-4",
                                    alt: "sent"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "z-title3",
                                    children: [
                                        t("result-created-at"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "text-sm text-gray-400",
                                    children: readyStatus === 0 ? feedback.lastFeedback.substring(0, 10) : readyStatus > 1 ? "Pending" : t("no-result")
                                })
                            ]
                        }),
                        readyStatus < 2 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                    className: "mt-2 border-indigo-800"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center mt-2 gap-x-1",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($dd0ccd8d6f00a586$exports))),
                                            className: "w-4 h-4",
                                            alt: "sent"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "z-title3",
                                            children: [
                                                t("received"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "text-sm text-gray-400",
                                            children: [
                                                feedback.numAnswers,
                                                " ",
                                                lang === "sv" ? "av" : "out of",
                                                " ",
                                                feedback.totalFeedbackUsers
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-800"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex mt-2 gap-x-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bf234ba9a155a985$exports))),
                                    className: "w-4 h-4 mt-1",
                                    alt: "sent"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                            className: "z-title3",
                                            children: [
                                                t("requested-from"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                            className: "text-sm text-gray-400 m-2",
                                            children: feedback.feedbackUsers.map(function(email, i) {
                                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                    children: [
                                                        i > 0 ? ", " : "",
                                                        email
                                                    ]
                                                }, "r_" + email);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                feedbackNr === 0 && completedFeedbacks === 0 && readyStatus !== 3 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-6 z-title1",
                            children: lang === "sv" ? "Skicka en ny feedback-f\xf6rfr\xe5gan" : "Send a new feedback request"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            className: "mt-2",
                            buttonType: "outlineWhiteBase",
                            onClick: function() {
                                return setRequestFeedbackModalOpen(true);
                            },
                            children: t("request-feedback")
                        })
                    ]
                })
            ]
        });
    };
    if (feedbacks.length === 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: task.completed ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fc5a845596f1e4c9$exports))),
                    alt: "feedback",
                    className: "w-6 h-6 mx-auto"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-400 text-center",
                    children: lang === "sv" ? "Att j\xe4mf\xf6ra din sj\xe4lvskattning med kollegors feedback skapar en grund f\xf6r utveckling och m\xf6jligg\xf6r m\xe4tning av framsteg." : "Comparing your self-assessment with colleague feedback provides a baseline for improvement and ensures progress can be effectively tracked."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    className: "mt-4",
                    buttonType: "blueBase",
                    onClick: function() {
                        return setRequestFeedbackModalOpen(true);
                    },
                    children: t("request-feedback")
                }),
                requestFeedbackModalOpen && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0895797b280ead2b$export$2fb15632c4c673d6), {
                    lang: lang,
                    t: t,
                    nrFeedbacks: feedbacks.length,
                    modalOpen: requestFeedbackModalOpen,
                    setModalOpen: setRequestFeedbackModalOpen,
                    type: "task",
                    originId: task.id
                })
            ]
        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fc5a845596f1e4c9$exports))),
                    alt: "feedback",
                    className: "w-6 h-6 mt-6 mx-auto"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-400 text-center",
                    children: lang === "sv" ? "Inget feedbackresultat \xe4nnu." : "No feedback result yet."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-1 text-gray-400 text-center",
                    children: lang === "sv" ? "Markera denna \xc5tg\xe4rd som slutf\xf6rd f\xf6rst f\xf6r att be om feedback." : "Mark this Action as completed first to request feedback."
                })
            ]
        })
    });
    var feedback = feedbacks[feedbackNr];
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            renderFeedback(feedback),
            scoreInfo && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c180cd9307108dcb$export$e6b51c7c16ee49db), {
                modalOpen: scoreInfo,
                setModalOpen: setScoreInfo,
                t: t,
                gap: 0,
                selfScore: 0,
                responsesScore: 0,
                type: "task"
            }),
            requestFeedbackModalOpen && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0895797b280ead2b$export$2fb15632c4c673d6), {
                lang: lang,
                t: t,
                nrFeedbacks: feedbacks.length,
                modalOpen: requestFeedbackModalOpen,
                setModalOpen: setRequestFeedbackModalOpen,
                type: "task",
                originId: task.id
            })
        ]
    });
}




parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");
var $46be5d84f14eb1ba$exports = {};
$46be5d84f14eb1ba$exports = $parcel$resolve("25RqU");


var $b831c536d594a009$exports = {};
$b831c536d594a009$exports = $parcel$resolve("6NY0Z");


var $0858ff7e9f730353$var$LocalBreadcrumbs = function(props) {
    var _props_crumbs_;
    var previousPage = (0, $bHX26.useNavigate)();
    var formatLink = function(crumb) {
        if (crumb.clickFunc) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "hover:text-primary-500 cursor-pointer",
            onClick: function() {
                return crumb.clickFunc ? crumb.clickFunc() : alert("Missing click");
            },
            children: crumb.name
        });
        else if (crumb.url) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bHX26.Link), {
            to: crumb.url,
            className: "hover:text-primary-500",
            children: crumb.name
        });
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "hover:text-primary-500",
            children: crumb.name
        });
    };
    var handleBackLink = function() {
        if (props.crumbs.length > 1) {
            var crumb = props.crumbs[props.crumbs.length - 2];
            if (crumb.clickFunc) crumb.clickFunc();
            else if (crumb.url) previousPage(crumb.url);
            else previousPage(-1);
        } else previousPage(-1);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("nav", {
        "aria-label": "breadcrumb",
        className: "mt-6",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex flex-col justify-start align-middle w-full desktop:w-151",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex items-center md:hidden",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b831c536d594a009$exports))),
                            onClick: function() {
                                return handleBackLink();
                            },
                            alt: "Back",
                            className: "w-4 h-4 mx-1.5 cursor-pointer"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                            className: "z-body3",
                            children: (_props_crumbs_ = props.crumbs[props.crumbs.length - 1]) === null || _props_crumbs_ === void 0 ? void 0 : _props_crumbs_.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("ol", {
                    className: "hidden md:flex flex-wrap items-center text-gray-400 text-xs",
                    children: props.crumbs.map(function(crumb, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("li", {
                            className: "flex items-center",
                            children: [
                                index > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($46be5d84f14eb1ba$exports))),
                                    alt: "Chevron Right",
                                    className: "w-4 h-4 mx-1.5"
                                }),
                                formatLink(crumb)
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
var $0858ff7e9f730353$export$2e2bcd8739ae039 = $0858ff7e9f730353$var$LocalBreadcrumbs;


/**
 * @import {Root} from 'mdast'
 * @import {Options} from 'remark-gfm'
 * @import {} from 'remark-parse'
 * @import {} from 'remark-stringify'
 * @import {Processor} from 'unified'
 */ /**
 * @import {Extension as FromMarkdownExtension} from 'mdast-util-from-markdown'
 * @import {Options} from 'mdast-util-gfm'
 * @import {Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 */ /**
 * @import {RegExpMatchObject, ReplaceFunction} from 'mdast-util-find-and-replace'
 * @import {CompileContext, Extension as FromMarkdownExtension, Handle as FromMarkdownHandle, Transform as FromMarkdownTransform} from 'mdast-util-from-markdown'
 * @import {ConstructName, Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 * @import {Link, PhrasingContent} from 'mdast'
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $7a579482a6b7b086$export$fa42eaa97a352e23(value, character) {
    var source = String(value);
    if (typeof character !== 'string') throw new TypeError('Expected character');
    var count = 0;
    var index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}




/**
 * @import {Nodes, Parents, PhrasingContent, Root, Text} from 'mdast'
 * @import {BuildVisitor, Test, VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[...Array<Parents>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @typedef {RegExp | string} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 *
 * @typedef {[Find, Replace?]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 *
 * @typedef {ReplaceFunction | string | null | undefined} Replace
 *   Thing to replace with.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | null | undefined}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 *
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore (optional).
 */ 
var $XnYkK = parcelRequire("XnYkK");
function $f6dfa69381c3727c$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}




function $846db0e7c8c97040$export$fb306ebf003fc574(tree, list, options) {
    var settings = options || {};
    var ignored = (0, $2be89ddeb615ec50$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    var pairs = $846db0e7c8c97040$var$toPairs(list);
    var pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $9ce2efd2fac4f13b$export$70008a21eb6de899)(tree, 'text', visitor);
    /** @type {BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        var index = -1;
        /** @type {Parents | undefined} */ var grandparent;
        while(++index < parents.length){
            var parent = parents[index];
            /** @type {Array<Nodes> | undefined} */ var siblings = grandparent ? grandparent.children : undefined;
            if (ignored(parent, siblings ? siblings.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
   * Handle a text node which is not in an ignored parent.
   *
   * @param {Text} node
   *   Text node.
   * @param {Array<Parents>} parents
   *   Parents.
   * @returns {VisitorResult}
   *   Result.
   */ function handler(node, parents) {
        var parent = parents[parents.length - 1];
        var find = pairs[pairIndex][0];
        var replace = pairs[pairIndex][1];
        var start = 0;
        /** @type {Array<Nodes>} */ var siblings = parent.children;
        var index = siblings.indexOf(node);
        var change = false;
        /** @type {Array<PhrasingContent>} */ var nodes = [];
        find.lastIndex = 0;
        var match = find.exec(node.value);
        while(match){
            var position = match.index;
            /** @type {RegExpMatchObject} */ var matchObject = {
                index: match.index,
                input: match.input,
                stack: (0, $XnYkK._)(parents).concat([
                    node
                ])
            };
            var value = replace.apply(void 0, (0, $XnYkK._)(match).concat([
                matchObject
            ]));
            if (typeof value === 'string') value = value.length > 0 ? {
                type: 'text',
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value === false) // False acts as if there was no match.
            // So we need to reset `lastIndex`, which currently being at the end of
            // the current match, to the beginning.
            find.lastIndex = position + 1;
            else {
                var _nodes;
                if (start !== position) nodes.push({
                    type: 'text',
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) (_nodes = nodes).push.apply(_nodes, (0, $XnYkK._)(value));
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            var _parent_children;
            if (start < node.value.length) nodes.push({
                type: 'text',
                value: node.value.slice(start)
            });
            (_parent_children = parent.children).splice.apply(_parent_children, [
                index,
                1
            ].concat((0, $XnYkK._)(nodes)));
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
}
/**
 * Turn a tuple or a list of tuples into pairs.
 *
 * @param {FindAndReplaceList | FindAndReplaceTuple} tupleOrList
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $846db0e7c8c97040$var$toPairs(tupleOrList) {
    /** @type {Pairs} */ var result = [];
    if (!Array.isArray(tupleOrList)) throw new TypeError('Expected find and replace tuple or list of tuples');
    /** @type {FindAndReplaceList} */ // @ts-expect-error: correct.
    var list = !tupleOrList[0] || Array.isArray(tupleOrList[0]) ? tupleOrList : [
        tupleOrList
    ];
    var index = -1;
    while(++index < list.length){
        var tuple = list[index];
        result.push([
            $846db0e7c8c97040$var$toExpression(tuple[0]),
            $846db0e7c8c97040$var$toFunction(tuple[1])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $846db0e7c8c97040$var$toExpression(find) {
    return typeof find === 'string' ? new RegExp((0, $f6dfa69381c3727c$export$2e2bcd8739ae039)(find), 'g') : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $846db0e7c8c97040$var$toFunction(replace) {
    return typeof replace === 'function' ? replace : function() {
        return replace;
    };
}


/** @type {ConstructName} */ var $74ccb453e77e066c$var$inConstruct = 'phrasing';
/** @type {Array<ConstructName>} */ var $74ccb453e77e066c$var$notInConstruct = [
    'autolink',
    'link',
    'image',
    'label'
];
function $74ccb453e77e066c$export$b6afdfff2163546f() {
    return {
        transforms: [
            $74ccb453e77e066c$var$transformGfmAutolinkLiterals
        ],
        enter: {
            literalAutolink: $74ccb453e77e066c$var$enterLiteralAutolink,
            literalAutolinkEmail: $74ccb453e77e066c$var$enterLiteralAutolinkValue,
            literalAutolinkHttp: $74ccb453e77e066c$var$enterLiteralAutolinkValue,
            literalAutolinkWww: $74ccb453e77e066c$var$enterLiteralAutolinkValue
        },
        exit: {
            literalAutolink: $74ccb453e77e066c$var$exitLiteralAutolink,
            literalAutolinkEmail: $74ccb453e77e066c$var$exitLiteralAutolinkEmail,
            literalAutolinkHttp: $74ccb453e77e066c$var$exitLiteralAutolinkHttp,
            literalAutolinkWww: $74ccb453e77e066c$var$exitLiteralAutolinkWww
        }
    };
}
function $74ccb453e77e066c$export$d3ace9096b01c39d() {
    return {
        unsafe: [
            {
                character: '@',
                before: '[+\\-.\\w]',
                after: '[\\-.\\w]',
                inConstruct: $74ccb453e77e066c$var$inConstruct,
                notInConstruct: $74ccb453e77e066c$var$notInConstruct
            },
            {
                character: '.',
                before: '[Ww]',
                after: '[\\-.\\w]',
                inConstruct: $74ccb453e77e066c$var$inConstruct,
                notInConstruct: $74ccb453e77e066c$var$notInConstruct
            },
            {
                character: ':',
                before: '[ps]',
                after: '\\/',
                inConstruct: $74ccb453e77e066c$var$inConstruct,
                notInConstruct: $74ccb453e77e066c$var$notInConstruct
            }
        ]
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $74ccb453e77e066c$var$enterLiteralAutolink(token) {
    this.enter({
        type: 'link',
        title: null,
        url: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $74ccb453e77e066c$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $74ccb453e77e066c$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $74ccb453e77e066c$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    var node = this.stack[this.stack.length - 1];
    (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(node.type === 'link');
    node.url = 'http://' + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $74ccb453e77e066c$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $74ccb453e77e066c$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $74ccb453e77e066c$var$transformGfmAutolinkLiterals(tree) {
    (0, $846db0e7c8c97040$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $74ccb453e77e066c$var$findUrl
        ],
        [
            RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"),
            $74ccb453e77e066c$var$findEmail
        ]
    ], {
        ignore: [
            'link',
            'linkReference'
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Array<PhrasingContent> | Link | false}
 */ // eslint-disable-next-line max-params
function $74ccb453e77e066c$var$findUrl(_, protocol, domain, path, match) {
    var prefix = '';
    // Not an expected previous character.
    if (!$74ccb453e77e066c$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = '';
        prefix = 'http://';
    }
    if (!$74ccb453e77e066c$var$isCorrectDomain(domain)) return false;
    var parts = $74ccb453e77e066c$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ var result = {
        type: 'link',
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: 'text',
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: 'text',
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $74ccb453e77e066c$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$74ccb453e77e066c$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: 'link',
        title: null,
        url: 'mailto:' + atext + '@' + label,
        children: [
            {
                type: 'text',
                value: atext + '@' + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $74ccb453e77e066c$var$isCorrectDomain(domain) {
    var parts = domain.split('.');
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $74ccb453e77e066c$var$splitUrl(url) {
    var trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    var trail = trailExec[0];
    var closingParenIndex = trail.indexOf(')');
    var openingParens = (0, $7a579482a6b7b086$export$fa42eaa97a352e23)(url, '(');
    var closingParens = (0, $7a579482a6b7b086$export$fa42eaa97a352e23)(url, ')');
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(')');
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $74ccb453e77e066c$var$previous(match, email) {
    var code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $4d05890350ae4444$export$a0ff789c034ffdf4)(code) || (0, $4d05890350ae4444$export$aa04114dd888a7a0)(code)) && // If it’s an email, the previous character should not be a slash.
    (!email || code !== 47);
}


/**
 * @import {
 *   CompileContext,
 *   Extension as FromMarkdownExtension,
 *   Handle as FromMarkdownHandle
 * } from 'mdast-util-from-markdown'
 * @import {ToMarkdownOptions} from 'mdast-util-gfm-footnote'
 * @import {
 *   Handle as ToMarkdownHandle,
 *   Map,
 *   Options as ToMarkdownExtension
 * } from 'mdast-util-to-markdown'
 * @import {FootnoteDefinition, FootnoteReference} from 'mdast'
 */ 

$678b7b32d09f3aa3$var$footnoteReference.peek = $678b7b32d09f3aa3$var$footnoteReferencePeek;
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $678b7b32d09f3aa3$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $678b7b32d09f3aa3$var$enterFootnoteCall(token) {
    this.enter({
        type: 'footnoteReference',
        identifier: '',
        label: ''
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $678b7b32d09f3aa3$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $678b7b32d09f3aa3$var$enterFootnoteDefinition(token) {
    this.enter({
        type: 'footnoteDefinition',
        identifier: '',
        label: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $678b7b32d09f3aa3$var$exitFootnoteCallString(token) {
    var label = this.resume();
    var node = this.stack[this.stack.length - 1];
    (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(node.type === 'footnoteReference');
    node.identifier = (0, $daea560f96654179$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    node.label = label;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $678b7b32d09f3aa3$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $678b7b32d09f3aa3$var$exitFootnoteDefinitionLabelString(token) {
    var label = this.resume();
    var node = this.stack[this.stack.length - 1];
    (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(node.type === 'footnoteDefinition');
    node.identifier = (0, $daea560f96654179$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    node.label = label;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $678b7b32d09f3aa3$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/** @type {ToMarkdownHandle} */ function $678b7b32d09f3aa3$var$footnoteReferencePeek() {
    return '[';
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $678b7b32d09f3aa3$var$footnoteReference(node, _, state, info) {
    var tracker = state.createTracker(info);
    var value = tracker.move('[^');
    var exit = state.enter('footnoteReference');
    var subexit = state.enter('reference');
    value += tracker.move(state.safe(state.associationId(node), {
        after: ']',
        before: value
    }));
    subexit();
    exit();
    value += tracker.move(']');
    return value;
}
function $678b7b32d09f3aa3$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteCallString: $678b7b32d09f3aa3$var$enterFootnoteCallString,
            gfmFootnoteCall: $678b7b32d09f3aa3$var$enterFootnoteCall,
            gfmFootnoteDefinitionLabelString: $678b7b32d09f3aa3$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteDefinition: $678b7b32d09f3aa3$var$enterFootnoteDefinition
        },
        exit: {
            gfmFootnoteCallString: $678b7b32d09f3aa3$var$exitFootnoteCallString,
            gfmFootnoteCall: $678b7b32d09f3aa3$var$exitFootnoteCall,
            gfmFootnoteDefinitionLabelString: $678b7b32d09f3aa3$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteDefinition: $678b7b32d09f3aa3$var$exitFootnoteDefinition
        }
    };
}
function $678b7b32d09f3aa3$export$3727766a73a6c09f(options) {
    // To do: next major: change default.
    var firstLineBlank = false;
    if (options && options.firstLineBlank) firstLineBlank = true;
    return {
        handlers: {
            footnoteDefinition: footnoteDefinition,
            footnoteReference: $678b7b32d09f3aa3$var$footnoteReference
        },
        // This is on by default already.
        unsafe: [
            {
                character: '[',
                inConstruct: [
                    'label',
                    'phrasing',
                    'reference'
                ]
            }
        ]
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {FootnoteDefinition} node
   */ function footnoteDefinition(node, _, state, info) {
        var tracker = state.createTracker(info);
        var value = tracker.move('[^');
        var exit = state.enter('footnoteDefinition');
        var subexit = state.enter('label');
        value += tracker.move(state.safe(state.associationId(node), {
            before: value,
            after: ']'
        }));
        subexit();
        value += tracker.move(']:');
        if (node.children && node.children.length > 0) {
            tracker.shift(4);
            value += tracker.move((firstLineBlank ? '\n' : ' ') + state.indentLines(state.containerFlow(node, tracker.current()), firstLineBlank ? $678b7b32d09f3aa3$var$mapAll : $678b7b32d09f3aa3$var$mapExceptFirst));
        }
        exit();
        return value;
    }
}
/** @type {Map} */ function $678b7b32d09f3aa3$var$mapExceptFirst(line, index, blank) {
    return index === 0 ? line : $678b7b32d09f3aa3$var$mapAll(line, index, blank);
}
/** @type {Map} */ function $678b7b32d09f3aa3$var$mapAll(line, index, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ 
var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");
var $76a6de47df6feb81$var$constructsWithoutStrikethrough = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
$76a6de47df6feb81$var$handleDelete.peek = $76a6de47df6feb81$var$peekDelete;
function $76a6de47df6feb81$export$34d64e709dd0b9bb() {
    return {
        canContainEols: [
            'delete'
        ],
        enter: {
            strikethrough: $76a6de47df6feb81$var$enterStrikethrough
        },
        exit: {
            strikethrough: $76a6de47df6feb81$var$exitStrikethrough
        }
    };
}
function $76a6de47df6feb81$export$1632835bd2c84956() {
    return {
        unsafe: [
            {
                character: '~',
                inConstruct: 'phrasing',
                notInConstruct: $76a6de47df6feb81$var$constructsWithoutStrikethrough
            }
        ],
        handlers: {
            delete: $76a6de47df6feb81$var$handleDelete
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $76a6de47df6feb81$var$enterStrikethrough(token) {
    this.enter({
        type: 'delete',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $76a6de47df6feb81$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $76a6de47df6feb81$var$handleDelete(node, _, state, info) {
    var tracker = state.createTracker(info);
    var exit = state.enter('strikethrough');
    var value = tracker.move('~~');
    value += state.containerPhrasing(node, (0, $lf4fc._)((0, $hwO3w._)({}, tracker.current()), {
        before: value,
        after: '~'
    }));
    value += tracker.move('~~');
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $76a6de47df6feb81$var$peekDelete() {
    return '~';
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells (default:
 *   `true`).
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters (default: `true`).
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells (optional).
 */ 
var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

// To do: next major: remove.
/**
 * @typedef {Options} MarkdownTableOptions
 *   Configuration.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [alignDelimiters=true]
 *   Whether to align the delimiters (default: `true`);
 *   they are aligned by default:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {ReadonlyArray<string | null | undefined> | string | null | undefined} [align]
 *   How to align columns (default: `''`);
 *   one style for all columns or styles for their respective columns;
 *   each style is either `'l'` (left), `'r'` (right), or `'c'` (center);
 *   other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left;
 *   *only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean | null | undefined} [delimiterEnd=true]
 *   Whether to end each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean | null | undefined} [delimiterStart=true]
 *   Whether to begin each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean | null | undefined} [padding=true]
 *   Whether to add a space of padding between delimiters and cells
 *   (default: `true`).
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {((value: string) => number) | null | undefined} [stringLength]
 *   Function to detect the length of table cell content (optional);
 *   this is used when aligning the delimiters (`|`) between table cells;
 *   full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source;
 *   to fix this, you can pass this function,
 *   which receives the cell content and returns its “visible” size;
 *   note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @param {string} value
 *   Cell value.
 * @returns {number}
 *   Cell size.
 */ 
var $03bAP = parcelRequire("03bAP");
function $2659009054b10d95$var$defaultStringLength(value) {
    return value.length;
}
function $2659009054b10d95$export$cdb7288612c4f3d6(table, options) {
    var settings = options || {};
    // To do: next major: change to spread.
    var align = (settings.align || []).concat();
    var stringLength = settings.stringLength || $2659009054b10d95$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ var alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ var cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ var sizeMatrix = [];
    /** @type {Array<number>} */ var longestCellByColumn = [];
    var mostCellsPerRow = 0;
    var rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ var row = [];
        /** @type {Array<number>} */ var sizes = [];
        var columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            var cell = $2659009054b10d95$var$serialize(table[rowIndex][columnIndex]);
            if (settings.alignDelimiters !== false) {
                var size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    var columnIndex1 = -1;
    if ((typeof align === "undefined" ? "undefined" : (0, $03bAP._)(align)) === 'object' && 'length' in align) while(++columnIndex1 < mostCellsPerRow)alignments[columnIndex1] = $2659009054b10d95$var$toAlignment(align[columnIndex1]);
    else {
        var code = $2659009054b10d95$var$toAlignment(align);
        while(++columnIndex1 < mostCellsPerRow)alignments[columnIndex1] = code;
    }
    // Inject the alignment row.
    columnIndex1 = -1;
    /** @type {Array<string>} */ var row1 = [];
    /** @type {Array<number>} */ var sizes1 = [];
    while(++columnIndex1 < mostCellsPerRow){
        var code1 = alignments[columnIndex1];
        var before = '';
        var after = '';
        if (code1 === 99 /* `c` */ ) {
            before = ':';
            after = ':';
        } else if (code1 === 108 /* `l` */ ) before = ':';
        else if (code1 === 114 /* `r` */ ) after = ':';
        // There *must* be at least one hyphen-minus in each alignment cell.
        var size1 = settings.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex1] - before.length - after.length);
        var cell1 = before + '-'.repeat(size1) + after;
        if (settings.alignDelimiters !== false) {
            size1 = before.length + size1 + after.length;
            if (size1 > longestCellByColumn[columnIndex1]) longestCellByColumn[columnIndex1] = size1;
            sizes1[columnIndex1] = size1;
        }
        row1[columnIndex1] = cell1;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row1);
    sizeMatrix.splice(1, 0, sizes1);
    rowIndex = -1;
    /** @type {Array<string>} */ var lines = [];
    while(++rowIndex < cellMatrix.length){
        var row2 = cellMatrix[rowIndex];
        var sizes2 = sizeMatrix[rowIndex];
        columnIndex1 = -1;
        /** @type {Array<string>} */ var line = [];
        while(++columnIndex1 < mostCellsPerRow){
            var cell2 = row2[columnIndex1] || '';
            var before1 = '';
            var after1 = '';
            if (settings.alignDelimiters !== false) {
                var size2 = longestCellByColumn[columnIndex1] - (sizes2[columnIndex1] || 0);
                var code2 = alignments[columnIndex1];
                if (code2 === 114 /* `r` */ ) before1 = ' '.repeat(size2);
                else if (code2 === 99 /* `c` */ ) {
                    if (size2 % 2) {
                        before1 = ' '.repeat(size2 / 2 + 0.5);
                        after1 = ' '.repeat(size2 / 2 - 0.5);
                    } else {
                        before1 = ' '.repeat(size2 / 2);
                        after1 = before1;
                    }
                } else after1 = ' '.repeat(size2);
            }
            if (settings.delimiterStart !== false && !columnIndex1) line.push('|');
            if (settings.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(settings.alignDelimiters === false && cell2 === '') && (settings.delimiterStart !== false || columnIndex1)) line.push(' ');
            if (settings.alignDelimiters !== false) line.push(before1);
            line.push(cell2);
            if (settings.alignDelimiters !== false) line.push(after1);
            if (settings.padding !== false) line.push(' ');
            if (settings.delimiterEnd !== false || columnIndex1 !== mostCellsPerRow - 1) line.push('|');
        }
        lines.push(settings.delimiterEnd === false ? line.join('').replace(/ +$/, '') : line.join(''));
    }
    return lines.join('\n');
}
/**
 * @param {string | null | undefined} [value]
 *   Value to serialize.
 * @returns {string}
 *   Result.
 */ function $2659009054b10d95$var$serialize(value) {
    return value === null || value === undefined ? '' : String(value);
}
/**
 * @param {string | null | undefined} value
 *   Value.
 * @returns {number}
 *   Alignment.
 */ function $2659009054b10d95$var$toAlignment(value) {
    var code = typeof value === 'string' ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


/**
 * @import {Blockquote, Parents} from 'mdast'
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {Blockquote} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $77634ff9e3605536$export$67dc04e652a298ca(node, _, state, info) {
    var exit = state.enter('blockquote');
    var tracker = state.createTracker(info);
    tracker.move('> ');
    tracker.shift(2);
    var value = state.indentLines(state.containerFlow(node, tracker.current()), $77634ff9e3605536$var$map);
    exit();
    return value;
}
/** @type {Map} */ function $77634ff9e3605536$var$map(line, _, blank) {
    return '>' + (blank ? '' : ' ') + line;
}


/**
 * @import {Break, Parents} from 'mdast'
 * @import {Info, State} from 'mdast-util-to-markdown'
 */ /**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $d6fbf116ac358f91$export$78221a09424368d(stack, pattern) {
    return $d6fbf116ac358f91$var$listInScope(stack, pattern.inConstruct, true) && !$d6fbf116ac358f91$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $d6fbf116ac358f91$var$listInScope(stack, list, none) {
    if (typeof list === 'string') list = [
        list
    ];
    if (!list || list.length === 0) return none;
    var index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $2dbc8be8834c277b$export$371da9dd35aba193(_, _1, state, info) {
    var index = -1;
    while(++index < state.unsafe.length){
        // If we can’t put eols in this construct (setext headings, tables), use a
        // space instead.
        if (state.unsafe[index].character === '\n' && (0, $d6fbf116ac358f91$export$78221a09424368d)(state.stack, state.unsafe[index])) return /[ \t]/.test(info.before) ? '' : ' ';
    }
    return '\\\n';
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {Code, Parents} from 'mdast'
 */ 
var $hwO3w = parcelRequire("hwO3w");
/**
 * Get the count of the longest repeating streak of `substring` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} substring
 *   Substring to look for, typically one character.
 * @returns {number}
 *   Count of most frequent adjacent `substring`s in `value`.
 */ function $8459495a657d6334$export$711675ff42d864f2(value, substring) {
    var source = String(value);
    var index = source.indexOf(substring);
    var expected = index;
    var count = 0;
    var max = 0;
    if (typeof substring !== 'string') throw new TypeError('Expected substring');
    while(index !== -1){
        if (index === expected) {
            if (++count > max) max = count;
        } else count = 1;
        expected = index + substring.length;
        index = source.indexOf(substring, expected);
    }
    return max;
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Code} from 'mdast'
 */ /**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */ function $d24e098116acd21a$export$8c0df78a8cad9f4b(node, state) {
    return Boolean(state.options.fences === false && node.value && // If there’s no info…
    !node.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value));
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */ function $ce3429f9003bb65d$export$7487ee7cbb2e2919(state) {
    var marker = state.options.fence || '`';
    if (marker !== '`' && marker !== '~') throw new Error('Cannot serialize code with `' + marker + '` for `options.fence`, expected `` ` `` or `~`');
    return marker;
}


function $50bb008cf6e67430$export$6565f9f03506010b(node, _, state, info) {
    var marker = (0, $ce3429f9003bb65d$export$7487ee7cbb2e2919)(state);
    var raw = node.value || '';
    var suffix = marker === '`' ? 'GraveAccent' : 'Tilde';
    if ((0, $d24e098116acd21a$export$8c0df78a8cad9f4b)(node, state)) {
        var exit = state.enter('codeIndented');
        var value = state.indentLines(raw, $50bb008cf6e67430$var$map);
        exit();
        return value;
    }
    var tracker = state.createTracker(info);
    var sequence = marker.repeat(Math.max((0, $8459495a657d6334$export$711675ff42d864f2)(raw, marker) + 1, 3));
    var exit1 = state.enter('codeFenced');
    var value1 = tracker.move(sequence);
    if (node.lang) {
        var subexit = state.enter("codeFencedLang".concat(suffix));
        value1 += tracker.move(state.safe(node.lang, (0, $hwO3w._)({
            before: value1,
            after: ' ',
            encode: [
                '`'
            ]
        }, tracker.current())));
        subexit();
    }
    if (node.lang && node.meta) {
        var subexit1 = state.enter("codeFencedMeta".concat(suffix));
        value1 += tracker.move(' ');
        value1 += tracker.move(state.safe(node.meta, (0, $hwO3w._)({
            before: value1,
            after: '\n',
            encode: [
                '`'
            ]
        }, tracker.current())));
        subexit1();
    }
    value1 += tracker.move('\n');
    if (raw) value1 += tracker.move(raw + '\n');
    value1 += tracker.move(sequence);
    exit1();
    return value1;
}
/** @type {Map} */ function $50bb008cf6e67430$var$map(line, _, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Definition, Parents} from 'mdast'
 */ 
var $hwO3w = parcelRequire("hwO3w");
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */ function $fc14570efaf2a0c7$export$7aeba63896b2719(state) {
    var marker = state.options.quote || '"';
    if (marker !== '"' && marker !== "'") throw new Error('Cannot serialize title with `' + marker + '` for `options.quote`, expected `"`, or `\'`');
    return marker;
}


function $5e4024082f814f81$export$69f215ed977cdb73(node, _, state, info) {
    var quote = (0, $fc14570efaf2a0c7$export$7aeba63896b2719)(state);
    var suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    var exit = state.enter('definition');
    var subexit = state.enter('label');
    var tracker = state.createTracker(info);
    var value = tracker.move('[');
    value += tracker.move(state.safe(state.associationId(node), (0, $hwO3w._)({
        before: value,
        after: ']'
    }, tracker.current())));
    value += tracker.move(']: ');
    subexit();
    if (// If there’s no url, or…
    !node.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, (0, $hwO3w._)({
            before: value,
            after: '>'
        }, tracker.current())));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, (0, $hwO3w._)({
            before: value,
            after: node.title ? ' ' : '\n'
        }, tracker.current())));
    }
    subexit();
    if (node.title) {
        subexit = state.enter("title".concat(suffix));
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, (0, $hwO3w._)({
            before: value,
            after: quote
        }, tracker.current())));
        value += tracker.move(quote);
        subexit();
    }
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Emphasis, Parents} from 'mdast'
 */ 
var $hwO3w = parcelRequire("hwO3w");
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */ function $57a74183fdbaf06c$export$f967eb786dea04e7(state) {
    var marker = state.options.emphasis || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize emphasis with `' + marker + '` for `options.emphasis`, expected `*`, or `_`');
    return marker;
}


/**
 * Encode a code point as a character reference.
 *
 * @param {number} code
 *   Code point to encode.
 * @returns {string}
 *   Encoded character reference.
 */ function $371542ca31f64987$export$5810cf1e579e9d5b(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


/**
 * @import {EncodeSides} from '../types.js'
 */ 
function $a7d6ec640ec4f583$export$b444be54825dd0b6(outside, inside, marker) {
    var outsideKind = (0, $0a3461a0e64b4a88$export$e3902bc0d835cad0)(outside);
    var insideKind = (0, $0a3461a0e64b4a88$export$e3902bc0d835cad0)(inside);
    // Letter outside:
    if (outsideKind === undefined) return insideKind === undefined ? // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    marker === '_' ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: true
    };
    // Whitespace outside:
    if (outsideKind === 1) return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    };
    // Punctuation outside:
    return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: false
    } : {
        inside: false,
        outside: false
    };
}


$fcd0960c66dbb0a2$export$bef81ba411953b51.peek = $fcd0960c66dbb0a2$var$emphasisPeek;
function $fcd0960c66dbb0a2$export$bef81ba411953b51(node, _, state, info) {
    var marker = (0, $57a74183fdbaf06c$export$f967eb786dea04e7)(state);
    var exit = state.enter('emphasis');
    var tracker = state.createTracker(info);
    var before = tracker.move(marker);
    var between = tracker.move(state.containerPhrasing(node, (0, $hwO3w._)({
        after: marker,
        before: before
    }, tracker.current())));
    var betweenHead = between.charCodeAt(0);
    var open = (0, $a7d6ec640ec4f583$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $371542ca31f64987$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    var betweenTail = between.charCodeAt(between.length - 1);
    var close = (0, $a7d6ec640ec4f583$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $371542ca31f64987$export$5810cf1e579e9d5b)(betweenTail);
    var after = tracker.move(marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Emphasis} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $fcd0960c66dbb0a2$var$emphasisPeek(_, _1, state) {
    return state.options.emphasis || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Heading, Parents} from 'mdast'
 */ 
var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Heading} from 'mdast'
 */ 

function $21dc3efe02d0a96f$export$78863676235adfbc(node, state) {
    var literalWithBreak = false;
    // Look for literals with a line break.
    // Note that this also
    (0, $dfcab761b4e96982$export$bf638b60ea8b89b7)(node, function(node) {
        if ('value' in node && /\r?\n|\r/.test(node.value) || node.type === 'break') {
            literalWithBreak = true;
            return 0, $9ce2efd2fac4f13b$export$7f100f842f565dc9;
        }
    });
    return Boolean((!node.depth || node.depth < 3) && (0, $b39838f337d55846$export$f84e8e69fd4488a5)(node) && (state.options.setext || literalWithBreak));
}


function $8005c72ae505894f$export$46e4a324ac90507f(node, _, state, info) {
    var rank = Math.max(Math.min(6, node.depth || 1), 1);
    var tracker = state.createTracker(info);
    if ((0, $21dc3efe02d0a96f$export$78863676235adfbc)(node, state)) {
        var exit = state.enter('headingSetext');
        var subexit = state.enter('phrasing');
        var value = state.containerPhrasing(node, (0, $lf4fc._)((0, $hwO3w._)({}, tracker.current()), {
            before: '\n',
            after: '\n'
        }));
        subexit();
        exit();
        return value + '\n' + (rank === 1 ? '=' : '-').repeat(// The whole size…
        value.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(value.lastIndexOf('\r'), value.lastIndexOf('\n')) + 1));
    }
    var sequence = '#'.repeat(rank);
    var exit1 = state.enter('headingAtx');
    var subexit1 = state.enter('phrasing');
    // Note: for proper tracking, we should reset the output positions when there
    // is no content returned, because then the space is not output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    tracker.move(sequence + ' ');
    var value1 = state.containerPhrasing(node, (0, $hwO3w._)({
        before: '# ',
        after: '\n'
    }, tracker.current()));
    if (/^[\t ]/.test(value1)) // To do: what effect has the character reference on tracking?
    value1 = (0, $371542ca31f64987$export$5810cf1e579e9d5b)(value1.charCodeAt(0)) + value1.slice(1);
    value1 = value1 ? sequence + ' ' + value1 : sequence;
    if (state.options.closeAtx) value1 += ' ' + sequence;
    subexit1();
    exit1();
    return value1;
}


/**
 * @import {Html} from 'mdast'
 */ $6c71c5995587dabc$export$c0bb0b647f701bb5.peek = $6c71c5995587dabc$var$htmlPeek;
function $6c71c5995587dabc$export$c0bb0b647f701bb5(node) {
    return node.value || '';
}
/**
 * @returns {string}
 */ function $6c71c5995587dabc$var$htmlPeek() {
    return '<';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Image, Parents} from 'mdast'
 */ 
var $hwO3w = parcelRequire("hwO3w");

$a8840a8737259661$export$5c452ff88e35e47d.peek = $a8840a8737259661$var$imagePeek;
function $a8840a8737259661$export$5c452ff88e35e47d(node, _, state, info) {
    var quote = (0, $fc14570efaf2a0c7$export$7aeba63896b2719)(state);
    var suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    var exit = state.enter('image');
    var subexit = state.enter('label');
    var tracker = state.createTracker(info);
    var value = tracker.move('![');
    value += tracker.move(state.safe(node.alt, (0, $hwO3w._)({
        before: value,
        after: ']'
    }, tracker.current())));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, (0, $hwO3w._)({
            before: value,
            after: '>'
        }, tracker.current())));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, (0, $hwO3w._)({
            before: value,
            after: node.title ? ' ' : ')'
        }, tracker.current())));
    }
    subexit();
    if (node.title) {
        subexit = state.enter("title".concat(suffix));
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, (0, $hwO3w._)({
            before: value,
            after: quote
        }, tracker.current())));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @returns {string}
 */ function $a8840a8737259661$var$imagePeek() {
    return '!';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {ImageReference, Parents} from 'mdast'
 */ 
var $hwO3w = parcelRequire("hwO3w");
$c1022649ca98421a$export$f281796f6bc3b8db.peek = $c1022649ca98421a$var$imageReferencePeek;
function $c1022649ca98421a$export$f281796f6bc3b8db(node, _, state, info) {
    var type = node.referenceType;
    var exit = state.enter('imageReference');
    var subexit = state.enter('label');
    var tracker = state.createTracker(info);
    var value = tracker.move('![');
    var alt = state.safe(node.alt, (0, $hwO3w._)({
        before: value,
        after: ']'
    }, tracker.current()));
    value += tracker.move(alt + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    var stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    var reference = state.safe(state.associationId(node), (0, $hwO3w._)({
        before: value,
        after: ']'
    }, tracker.current()));
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !alt || alt !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $c1022649ca98421a$var$imageReferencePeek() {
    return '!';
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {InlineCode, Parents} from 'mdast'
 */ $ecb77152b3effcc2$export$91b9bee19a0d8569.peek = $ecb77152b3effcc2$var$inlineCodePeek;
function $ecb77152b3effcc2$export$91b9bee19a0d8569(node, _, state) {
    var value = node.value || '';
    var sequence = '`';
    var index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value))sequence += '`';
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = ' ' + value + ' ';
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        var pattern = state.unsafe[index];
        var expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ var match = void 0;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            var position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $ecb77152b3effcc2$var$inlineCodePeek() {
    return '`';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Link, Parents} from 'mdast'
 * @import {Exit} from '../types.js'
 */ 
var $hwO3w = parcelRequire("hwO3w");

/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Link} from 'mdast'
 */ 
function $31434898f9c55cb3$export$74cae3045e3179ed(node, state) {
    var raw = (0, $b39838f337d55846$export$f84e8e69fd4488a5)(node);
    return Boolean(!state.options.resourceLink && // If there’s a url…
    node.url && // And there’s a no title…
    !node.title && // And the content of `node` is a single text node…
    node.children && node.children.length === 1 && node.children[0].type === 'text' && // And if the url is the same as the content…
    (raw === node.url || 'mailto:' + raw === node.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node.url));
}


$11cdbdf6a6d1fbdc$export$9c30223ca0a664fb.peek = $11cdbdf6a6d1fbdc$var$linkPeek;
function $11cdbdf6a6d1fbdc$export$9c30223ca0a664fb(node, _, state, info) {
    var quote = (0, $fc14570efaf2a0c7$export$7aeba63896b2719)(state);
    var suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    var tracker = state.createTracker(info);
    /** @type {Exit} */ var exit;
    /** @type {Exit} */ var subexit;
    if ((0, $31434898f9c55cb3$export$74cae3045e3179ed)(node, state)) {
        // Hide the fact that we’re in phrasing, because escapes don’t work.
        var stack = state.stack;
        state.stack = [];
        exit = state.enter('autolink');
        var value = tracker.move('<');
        value += tracker.move(state.containerPhrasing(node, (0, $hwO3w._)({
            before: value,
            after: '>'
        }, tracker.current())));
        value += tracker.move('>');
        exit();
        state.stack = stack;
        return value;
    }
    exit = state.enter('link');
    subexit = state.enter('label');
    var value1 = tracker.move('[');
    value1 += tracker.move(state.containerPhrasing(node, (0, $hwO3w._)({
        before: value1,
        after: ']('
    }, tracker.current())));
    value1 += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value1 += tracker.move('<');
        value1 += tracker.move(state.safe(node.url, (0, $hwO3w._)({
            before: value1,
            after: '>'
        }, tracker.current())));
        value1 += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value1 += tracker.move(state.safe(node.url, (0, $hwO3w._)({
            before: value1,
            after: node.title ? ' ' : ')'
        }, tracker.current())));
    }
    subexit();
    if (node.title) {
        subexit = state.enter("title".concat(suffix));
        value1 += tracker.move(' ' + quote);
        value1 += tracker.move(state.safe(node.title, (0, $hwO3w._)({
            before: value1,
            after: quote
        }, tracker.current())));
        value1 += tracker.move(quote);
        subexit();
    }
    value1 += tracker.move(')');
    exit();
    return value1;
}
/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */ function $11cdbdf6a6d1fbdc$var$linkPeek(node, _, state) {
    return (0, $31434898f9c55cb3$export$74cae3045e3179ed)(node, state) ? '<' : '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {LinkReference, Parents} from 'mdast'
 */ 
var $hwO3w = parcelRequire("hwO3w");
$fa441dc32f4c92c1$export$e6c469b1b7b2bc6a.peek = $fa441dc32f4c92c1$var$linkReferencePeek;
function $fa441dc32f4c92c1$export$e6c469b1b7b2bc6a(node, _, state, info) {
    var type = node.referenceType;
    var exit = state.enter('linkReference');
    var subexit = state.enter('label');
    var tracker = state.createTracker(info);
    var value = tracker.move('[');
    var text = state.containerPhrasing(node, (0, $hwO3w._)({
        before: value,
        after: ']'
    }, tracker.current()));
    value += tracker.move(text + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    var stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    var reference = state.safe(state.associationId(node), (0, $hwO3w._)({
        before: value,
        after: ']'
    }, tracker.current()));
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !text || text !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $fa441dc32f4c92c1$var$linkReferencePeek() {
    return '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {List, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $bc87e613b9b73b38$export$7425517207a4d0ae(state) {
    var marker = state.options.bullet || '*';
    if (marker !== '*' && marker !== '+' && marker !== '-') throw new Error('Cannot serialize items with `' + marker + '` for `options.bullet`, expected `*`, `+`, or `-`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ 
function $0c119e7daffd2527$export$e6803bf0889262a1(state) {
    var bullet = (0, $bc87e613b9b73b38$export$7425517207a4d0ae)(state);
    var bulletOther = state.options.bulletOther;
    if (!bulletOther) return bullet === '*' ? '-' : '*';
    if (bulletOther !== '*' && bulletOther !== '+' && bulletOther !== '-') throw new Error('Cannot serialize items with `' + bulletOther + '` for `options.bulletOther`, expected `*`, `+`, or `-`');
    if (bulletOther === bullet) throw new Error('Expected `bullet` (`' + bullet + '`) and `bulletOther` (`' + bulletOther + '`) to be different');
    return bulletOther;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */ function $34b2cfe75b67b5ba$export$98d522b78eddc19b(state) {
    var marker = state.options.bulletOrdered || '.';
    if (marker !== '.' && marker !== ')') throw new Error('Cannot serialize items with `' + marker + '` for `options.bulletOrdered`, expected `.` or `)`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */ function $b7d88f56c463a633$export$d8d533ef24dba866(state) {
    var marker = state.options.rule || '*';
    if (marker !== '*' && marker !== '-' && marker !== '_') throw new Error('Cannot serialize rules with `' + marker + '` for `options.rule`, expected `*`, `-`, or `_`');
    return marker;
}


function $efe8b70ab52eb938$export$8837f4fc672e936d(node, parent, state, info) {
    var exit = state.enter('list');
    var bulletCurrent = state.bulletCurrent;
    /** @type {string} */ var bullet = node.ordered ? (0, $34b2cfe75b67b5ba$export$98d522b78eddc19b)(state) : (0, $bc87e613b9b73b38$export$7425517207a4d0ae)(state);
    /** @type {string} */ var bulletOther = node.ordered ? bullet === '.' ? ')' : '.' : (0, $0c119e7daffd2527$export$e6803bf0889262a1)(state);
    var useDifferentMarker = parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;
    if (!node.ordered) {
        var firstListItem = node.children ? node.children[0] : undefined;
        // If there’s an empty first list item directly in two list items,
        // we have to use a different bullet:
        //
        // ```markdown
        // * - *
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if (// Bullet could be used as a thematic break marker:
        (bullet === '*' || bullet === '-') && // Empty first list item:
        firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
        state.stack[state.stack.length - 1] === 'list' && state.stack[state.stack.length - 2] === 'listItem' && state.stack[state.stack.length - 3] === 'list' && state.stack[state.stack.length - 4] === 'listItem' && // That are each the first child.
        state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0) useDifferentMarker = true;
        // If there’s a thematic break at the start of the first list item,
        // we have to use a different bullet:
        //
        // ```markdown
        // * ---
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if ((0, $b7d88f56c463a633$export$d8d533ef24dba866)(state) === bullet && firstListItem) {
            var index = -1;
            while(++index < node.children.length){
                var item = node.children[index];
                if (item && item.type === 'listItem' && item.children && item.children[0] && item.children[0].type === 'thematicBreak') {
                    useDifferentMarker = true;
                    break;
                }
            }
        }
    }
    if (useDifferentMarker) bullet = bulletOther;
    state.bulletCurrent = bullet;
    var value = state.containerFlow(node, info);
    state.bulletLastUsed = bullet;
    state.bulletCurrent = bulletCurrent;
    exit();
    return value;
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {ListItem, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $66cfa55660ba671d$export$2d5358b63da92261(state) {
    var style = state.options.listItemIndent || 'one';
    if (style !== 'tab' && style !== 'one' && style !== 'mixed') throw new Error('Cannot serialize items with `' + style + '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`');
    return style;
}


function $7c0626a82712935a$export$76c7e83ecc9cdf05(node, parent, state, info) {
    var listItemIndent = (0, $66cfa55660ba671d$export$2d5358b63da92261)(state);
    var bullet = state.bulletCurrent || (0, $bc87e613b9b73b38$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === 'list' && parent.ordered) bullet = (typeof parent.start === 'number' && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    var size = bullet.length + 1;
    if (listItemIndent === 'tab' || listItemIndent === 'mixed' && (parent && parent.type === 'list' && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    var tracker = state.createTracker(info);
    tracker.move(bullet + ' '.repeat(size - bullet.length));
    tracker.shift(size);
    var exit = state.enter('listItem');
    var value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? '' : ' '.repeat(size)) + line;
        return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line;
    }
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Paragraph, Parents} from 'mdast'
 */ /**
 * @param {Paragraph} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $c15b57f008dd6a83$export$9c206ddddb32a9b(node, _, state, info) {
    var exit = state.enter('paragraph');
    var subexit = state.enter('phrasing');
    var value = state.containerPhrasing(node, info);
    subexit();
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Root} from 'mdast'
 */ /**
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */ 
var $1e0eca217d9185f5$export$444c9dec66a6f08c = /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */ (0, $2be89ddeb615ec50$export$9c68d69a4c5bbcf9)([
    'break',
    'delete',
    'emphasis',
    // To do: next major: removed since footnotes were added to GFM.
    'footnote',
    'footnoteReference',
    'image',
    'imageReference',
    'inlineCode',
    // Enabled by `mdast-util-math`:
    'inlineMath',
    'link',
    'linkReference',
    // Enabled by `mdast-util-mdx`:
    'mdxJsxTextElement',
    // Enabled by `mdast-util-mdx`:
    'mdxTextExpression',
    'strong',
    'text',
    // Enabled by `mdast-util-directive`:
    'textDirective'
]);


function $e676916bf009cb80$export$e8e78c978b129247(node, _, state, info) {
    // Note: `html` nodes are ambiguous.
    var hasPhrasing = node.children.some(function(d) {
        return (0, $1e0eca217d9185f5$export$444c9dec66a6f08c)(d);
    });
    var container = hasPhrasing ? state.containerPhrasing : state.containerFlow;
    return container.call(state, node, info);
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Strong} from 'mdast'
 */ 
var $hwO3w = parcelRequire("hwO3w");
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */ function $3c4baf898a3c1a04$export$b7ce17905d66a6c3(state) {
    var marker = state.options.strong || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize strong with `' + marker + '` for `options.strong`, expected `*`, or `_`');
    return marker;
}




$bcdb3f2ddd54e84c$export$59ae2c325a998f89.peek = $bcdb3f2ddd54e84c$var$strongPeek;
function $bcdb3f2ddd54e84c$export$59ae2c325a998f89(node, _, state, info) {
    var marker = (0, $3c4baf898a3c1a04$export$b7ce17905d66a6c3)(state);
    var exit = state.enter('strong');
    var tracker = state.createTracker(info);
    var before = tracker.move(marker + marker);
    var between = tracker.move(state.containerPhrasing(node, (0, $hwO3w._)({
        after: marker,
        before: before
    }, tracker.current())));
    var betweenHead = between.charCodeAt(0);
    var open = (0, $a7d6ec640ec4f583$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $371542ca31f64987$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    var betweenTail = between.charCodeAt(between.length - 1);
    var close = (0, $a7d6ec640ec4f583$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $371542ca31f64987$export$5810cf1e579e9d5b)(betweenTail);
    var after = tracker.move(marker + marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Strong} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $bcdb3f2ddd54e84c$var$strongPeek(_, _1, state) {
    return state.options.strong || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Text} from 'mdast'
 */ /**
 * @param {Text} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $8d0214afd878b89e$export$6f093cfa640b7166(node, _, state, info) {
    return state.safe(node.value, info);
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Parents, ThematicBreak} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */ function $070247798f6b8038$export$72f02155834d89c4(state) {
    var repetition = state.options.ruleRepetition || 3;
    if (repetition < 3) throw new Error('Cannot serialize rules with repetition `' + repetition + '` for `options.ruleRepetition`, expected `3` or more');
    return repetition;
}



function $33488f830950b549$export$ba7b13e047416c03(_, _1, state) {
    var value = ((0, $b7d88f56c463a633$export$d8d533ef24dba866)(state) + (state.options.ruleSpaces ? ' ' : '')).repeat((0, $070247798f6b8038$export$72f02155834d89c4)(state));
    return state.options.ruleSpaces ? value.slice(0, -1) : value;
}


var $63757f1489ed37fd$export$8f34ce051745d39e = {
    blockquote: (0, $77634ff9e3605536$export$67dc04e652a298ca),
    break: (0, $2dbc8be8834c277b$export$371da9dd35aba193),
    code: (0, $50bb008cf6e67430$export$6565f9f03506010b),
    definition: (0, $5e4024082f814f81$export$69f215ed977cdb73),
    emphasis: (0, $fcd0960c66dbb0a2$export$bef81ba411953b51),
    hardBreak: (0, $2dbc8be8834c277b$export$371da9dd35aba193),
    heading: (0, $8005c72ae505894f$export$46e4a324ac90507f),
    html: (0, $6c71c5995587dabc$export$c0bb0b647f701bb5),
    image: (0, $a8840a8737259661$export$5c452ff88e35e47d),
    imageReference: (0, $c1022649ca98421a$export$f281796f6bc3b8db),
    inlineCode: (0, $ecb77152b3effcc2$export$91b9bee19a0d8569),
    link: (0, $11cdbdf6a6d1fbdc$export$9c30223ca0a664fb),
    linkReference: (0, $fa441dc32f4c92c1$export$e6c469b1b7b2bc6a),
    list: (0, $efe8b70ab52eb938$export$8837f4fc672e936d),
    listItem: (0, $7c0626a82712935a$export$76c7e83ecc9cdf05),
    paragraph: (0, $c15b57f008dd6a83$export$9c206ddddb32a9b),
    root: (0, $e676916bf009cb80$export$e8e78c978b129247),
    strong: (0, $bcdb3f2ddd54e84c$export$59ae2c325a998f89),
    text: (0, $8d0214afd878b89e$export$6f093cfa640b7166),
    thematicBreak: (0, $33488f830950b549$export$ba7b13e047416c03)
};


function $a4689a693a03a001$export$8bd0ec8ecf6adb7d() {
    return {
        enter: {
            table: $a4689a693a03a001$var$enterTable,
            tableData: $a4689a693a03a001$var$enterCell,
            tableHeader: $a4689a693a03a001$var$enterCell,
            tableRow: $a4689a693a03a001$var$enterRow
        },
        exit: {
            codeText: $a4689a693a03a001$var$exitCodeText,
            table: $a4689a693a03a001$var$exitTable,
            tableData: $a4689a693a03a001$var$exit,
            tableHeader: $a4689a693a03a001$var$exit,
            tableRow: $a4689a693a03a001$var$exit
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a4689a693a03a001$var$enterTable(token) {
    var align = token._align;
    (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(align, 'expected `_align` on table');
    this.enter({
        type: 'table',
        align: align.map(function(d) {
            return d === 'none' ? null : d;
        }),
        children: []
    }, token);
    this.data.inTable = true;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a4689a693a03a001$var$exitTable(token) {
    this.exit(token);
    this.data.inTable = undefined;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a4689a693a03a001$var$enterRow(token) {
    this.enter({
        type: 'tableRow',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a4689a693a03a001$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a4689a693a03a001$var$enterCell(token) {
    this.enter({
        type: 'tableCell',
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a4689a693a03a001$var$exitCodeText(token) {
    var value = this.resume();
    if (this.data.inTable) value = value.replace(/\\([\\|])/g, $a4689a693a03a001$var$replace);
    var node = this.stack[this.stack.length - 1];
    (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(node.type === 'inlineCode');
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $a4689a693a03a001$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}
function $a4689a693a03a001$export$dafcad76ea6e0045(options) {
    var settings = options || {};
    var padding = settings.tableCellPadding;
    var alignDelimiters = settings.tablePipeAlign;
    var stringLength = settings.stringLength;
    var around = padding ? ' ' : '|';
    return {
        unsafe: [
            {
                character: '\r',
                inConstruct: 'tableCell'
            },
            {
                character: '\n',
                inConstruct: 'tableCell'
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: '|',
                after: '[\t :-]'
            },
            // A pipe in a cell must be encoded.
            {
                character: '|',
                inConstruct: 'tableCell'
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ':',
                after: '-'
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            inlineCode: inlineCodeWithTable,
            table: handleTable,
            tableCell: handleTableCell,
            tableRow: handleTableRow
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, state, info) {
        return serializeData(handleTableAsData(node, state, info), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, state, info) {
        var row = handleTableRowAsData(node, state, info);
        var value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf('\n'));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, state, info) {
        var exit = state.enter('tableCell');
        var subexit = state.enter('phrasing');
        var value = state.containerPhrasing(node, (0, $lf4fc._)((0, $hwO3w._)({}, info), {
            before: around,
            after: around
        }));
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $2659009054b10d95$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters: alignDelimiters,
            // @ts-expect-error: `markdown-table` types should support `null`.
            padding: padding,
            // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength: stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableAsData(node, state, info) {
        var children = node.children;
        var index = -1;
        /** @type {Array<Array<string>>} */ var result = [];
        var subexit = state.enter('table');
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], state, info);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableRowAsData(node, state, info) {
        var children = node.children;
        var index = -1;
        /** @type {Array<string>} */ var result = [];
        var subexit = state.enter('tableRow');
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, state, info);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, state) {
        var value = (0, $63757f1489ed37fd$export$8f34ce051745d39e).inlineCode(node, parent, state);
        if (state.stack.includes('tableCell')) value = value.replace(/\|/g, '\\$&');
        return value;
    }
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 
var $hwO3w = parcelRequire("hwO3w");


function $a8a55ba945f7e5b9$export$a427a608608b215f() {
    return {
        exit: {
            taskListCheckValueChecked: $a8a55ba945f7e5b9$var$exitCheck,
            taskListCheckValueUnchecked: $a8a55ba945f7e5b9$var$exitCheck,
            paragraph: $a8a55ba945f7e5b9$var$exitParagraphWithTaskListItem
        }
    };
}
function $a8a55ba945f7e5b9$export$9975722e7e834b78() {
    return {
        unsafe: [
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            listItem: $a8a55ba945f7e5b9$var$listItemWithTaskListItem
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a8a55ba945f7e5b9$var$exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    var node = this.stack[this.stack.length - 2];
    (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(node.type === 'listItem');
    node.checked = token.type === 'taskListCheckValueChecked';
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a8a55ba945f7e5b9$var$exitParagraphWithTaskListItem(token) {
    var parent = this.stack[this.stack.length - 2];
    if (parent && parent.type === 'listItem' && typeof parent.checked === 'boolean') {
        var node = this.stack[this.stack.length - 1];
        (0, $337acd4a17e06e51$export$dcb8b3f0e2de7e49)(node.type === 'paragraph');
        var head = node.children[0];
        if (head && head.type === 'text') {
            var siblings = parent.children;
            var index = -1;
            /** @type {Paragraph | undefined} */ var firstParaghraph;
            while(++index < siblings.length){
                var sibling = siblings[index];
                if (sibling.type === 'paragraph') {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === 'number') {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $a8a55ba945f7e5b9$var$listItemWithTaskListItem(node, parent, state, info) {
    var head = node.children[0];
    var checkable = typeof node.checked === 'boolean' && head && head.type === 'paragraph';
    var checkbox = '[' + (node.checked ? 'x' : ' ') + '] ';
    var tracker = state.createTracker(info);
    if (checkable) tracker.move(checkbox);
    var value = (0, $63757f1489ed37fd$export$8f34ce051745d39e).listItem(node, parent, state, (0, $hwO3w._)({}, info, tracker.current()));
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


function $2752266c62d5ad29$export$95adae814eb7433e() {
    return [
        (0, $74ccb453e77e066c$export$b6afdfff2163546f)(),
        (0, $678b7b32d09f3aa3$export$c9d5ad4bdf6ff801)(),
        (0, $76a6de47df6feb81$export$34d64e709dd0b9bb)(),
        (0, $a4689a693a03a001$export$8bd0ec8ecf6adb7d)(),
        (0, $a8a55ba945f7e5b9$export$a427a608608b215f)()
    ];
}
function $2752266c62d5ad29$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $74ccb453e77e066c$export$d3ace9096b01c39d)(),
            (0, $678b7b32d09f3aa3$export$3727766a73a6c09f)(options),
            (0, $76a6de47df6feb81$export$1632835bd2c84956)(),
            (0, $a4689a693a03a001$export$dafcad76ea6e0045)(options),
            (0, $a8a55ba945f7e5b9$export$9975722e7e834b78)()
        ]
    };
}


/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ 
/**
 * @import {Code, ConstructRecord, Event, Extension, Previous, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 
var $697a8427cee08fa7$var$wwwPrefix = {
    tokenize: $697a8427cee08fa7$var$tokenizeWwwPrefix,
    partial: true
};
var $697a8427cee08fa7$var$domain = {
    tokenize: $697a8427cee08fa7$var$tokenizeDomain,
    partial: true
};
var $697a8427cee08fa7$var$path = {
    tokenize: $697a8427cee08fa7$var$tokenizePath,
    partial: true
};
var $697a8427cee08fa7$var$trail = {
    tokenize: $697a8427cee08fa7$var$tokenizeTrail,
    partial: true
};
var $697a8427cee08fa7$var$emailDomainDotTrail = {
    tokenize: $697a8427cee08fa7$var$tokenizeEmailDomainDotTrail,
    partial: true
};
var $697a8427cee08fa7$var$wwwAutolink = {
    name: 'wwwAutolink',
    tokenize: $697a8427cee08fa7$var$tokenizeWwwAutolink,
    previous: $697a8427cee08fa7$var$previousWww
};
var $697a8427cee08fa7$var$protocolAutolink = {
    name: 'protocolAutolink',
    tokenize: $697a8427cee08fa7$var$tokenizeProtocolAutolink,
    previous: $697a8427cee08fa7$var$previousProtocol
};
var $697a8427cee08fa7$var$emailAutolink = {
    name: 'emailAutolink',
    tokenize: $697a8427cee08fa7$var$tokenizeEmailAutolink,
    previous: $697a8427cee08fa7$var$previousEmail
};
/** @type {ConstructRecord} */ var $697a8427cee08fa7$var$text = {};
function $697a8427cee08fa7$export$608123d9b549151() {
    return {
        text: $697a8427cee08fa7$var$text
    };
}
/** @type {Code} */ var $697a8427cee08fa7$var$code = 48;
// Add alphanumerics.
while($697a8427cee08fa7$var$code < 123){
    $697a8427cee08fa7$var$text[$697a8427cee08fa7$var$code] = $697a8427cee08fa7$var$emailAutolink;
    $697a8427cee08fa7$var$code++;
    if ($697a8427cee08fa7$var$code === 58) $697a8427cee08fa7$var$code = 65;
    else if ($697a8427cee08fa7$var$code === 91) $697a8427cee08fa7$var$code = 97;
}
$697a8427cee08fa7$var$text[43] = $697a8427cee08fa7$var$emailAutolink;
$697a8427cee08fa7$var$text[45] = $697a8427cee08fa7$var$emailAutolink;
$697a8427cee08fa7$var$text[46] = $697a8427cee08fa7$var$emailAutolink;
$697a8427cee08fa7$var$text[95] = $697a8427cee08fa7$var$emailAutolink;
$697a8427cee08fa7$var$text[72] = [
    $697a8427cee08fa7$var$emailAutolink,
    $697a8427cee08fa7$var$protocolAutolink
];
$697a8427cee08fa7$var$text[104] = [
    $697a8427cee08fa7$var$emailAutolink,
    $697a8427cee08fa7$var$protocolAutolink
];
$697a8427cee08fa7$var$text[87] = [
    $697a8427cee08fa7$var$emailAutolink,
    $697a8427cee08fa7$var$wwwAutolink
];
$697a8427cee08fa7$var$text[119] = [
    $697a8427cee08fa7$var$emailAutolink,
    $697a8427cee08fa7$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $697a8427cee08fa7$var$tokenizeEmailAutolink(effects, ok, nok) {
    var self = this;
    /** @type {boolean | undefined} */ var dot;
    /** @type {boolean} */ var data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$697a8427cee08fa7$var$gfmAtext(code) || !$697a8427cee08fa7$var$previousEmail.call(self, self.previous) || $697a8427cee08fa7$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkEmail');
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($697a8427cee08fa7$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($697a8427cee08fa7$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $4d05890350ae4444$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $4d05890350ae4444$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit('literalAutolinkEmail');
            effects.exit('literalAutolink');
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $697a8427cee08fa7$var$tokenizeWwwAutolink(effects, ok, nok) {
    var self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$697a8427cee08fa7$var$previousWww.call(self, self.previous) || $697a8427cee08fa7$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkWww');
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($697a8427cee08fa7$var$wwwPrefix, effects.attempt($697a8427cee08fa7$var$domain, effects.attempt($697a8427cee08fa7$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit('literalAutolinkWww');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $697a8427cee08fa7$var$tokenizeProtocolAutolink(effects, ok, nok) {
    var self = this;
    var buffer = '';
    var seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $697a8427cee08fa7$var$previousProtocol.call(self, self.previous) && !$697a8427cee08fa7$var$previousUnbalanced(self.events)) {
            effects.enter('literalAutolink');
            effects.enter('literalAutolinkHttp');
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $4d05890350ae4444$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            var protocol = buffer.toLowerCase();
            if (protocol === 'http' || protocol === 'https') {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $4d05890350ae4444$export$67dbf494fc8394df)(code) || (0, $4d05890350ae4444$export$a30284361b3814b7)(code) || (0, $4d05890350ae4444$export$a0ff789c034ffdf4)(code) || (0, $4d05890350ae4444$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($697a8427cee08fa7$var$domain, effects.attempt($697a8427cee08fa7$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit('literalAutolinkHttp');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $697a8427cee08fa7$var$tokenizeWwwPrefix(effects, ok, nok) {
    var size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $697a8427cee08fa7$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ var underscoreInLastSegment;
    /** @type {boolean | undefined} */ var underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ var seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($697a8427cee08fa7$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $4d05890350ae4444$export$a30284361b3814b7)(code) || (0, $4d05890350ae4444$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $4d05890350ae4444$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $697a8427cee08fa7$var$tokenizePath(effects, ok) {
    var sizeOpen = 0;
    var sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($697a8427cee08fa7$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $4d05890350ae4444$export$a30284361b3814b7)(code) || (0, $4d05890350ae4444$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $697a8427cee08fa7$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharacterReferenceStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $4d05890350ae4444$export$a30284361b3814b7)(code) || (0, $4d05890350ae4444$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $4d05890350ae4444$export$a30284361b3814b7)(code) || (0, $4d05890350ae4444$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $4d05890350ae4444$export$d65d6b62c24d5436)(code) ? trailCharacterReferenceInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $4d05890350ae4444$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharacterReferenceInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $697a8427cee08fa7$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $4d05890350ae4444$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $697a8427cee08fa7$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $4d05890350ae4444$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $697a8427cee08fa7$var$previousProtocol(code) {
    return !(0, $4d05890350ae4444$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $697a8427cee08fa7$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $697a8427cee08fa7$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $697a8427cee08fa7$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $4d05890350ae4444$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $697a8427cee08fa7$var$previousUnbalanced(events) {
    var index = events.length;
    var result = false;
    while(index--){
        var token = events[index][1];
        if ((token.type === 'labelLink' || token.type === 'labelImage') && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @import {CompileContext, Handle, HtmlExtension, Token} from 'micromark-util-types'
 */ 
function $b7076e062304b9b0$export$999603f1f1c3d2f9() {
    return {
        exit: {
            literalAutolinkEmail: $b7076e062304b9b0$var$literalAutolinkEmail,
            literalAutolinkHttp: $b7076e062304b9b0$var$literalAutolinkHttp,
            literalAutolinkWww: $b7076e062304b9b0$var$literalAutolinkWww
        }
    };
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $b7076e062304b9b0$var$literalAutolinkWww(token) {
    $b7076e062304b9b0$var$anchorFromToken.call(this, token, 'http://');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $b7076e062304b9b0$var$literalAutolinkEmail(token) {
    $b7076e062304b9b0$var$anchorFromToken.call(this, token, 'mailto:');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $b7076e062304b9b0$var$literalAutolinkHttp(token) {
    $b7076e062304b9b0$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {undefined}
 */ function $b7076e062304b9b0$var$anchorFromToken(token, protocol) {
    var url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $9ec3f308f236101d$export$d130a2d684099e5a)((protocol || '') + url) + '">');
    this.raw(this.encode(url));
    this.tag('</a>');
}


/**
 * @import {Event, Exiter, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 
var $dUlz9 = parcelRequire("dUlz9");

var $XnYkK = parcelRequire("XnYkK");




var $67a3c407620ee84c$var$indent = {
    tokenize: $67a3c407620ee84c$var$tokenizeIndent,
    partial: true
};
function $67a3c407620ee84c$export$c82499b6656305df() {
    var _obj;
    /** @type {Extension} */ return {
        document: (0, $dUlz9._)({}, 91, {
            name: 'gfmFootnoteDefinition',
            tokenize: $67a3c407620ee84c$var$tokenizeDefinitionStart,
            continuation: {
                tokenize: $67a3c407620ee84c$var$tokenizeDefinitionContinuation
            },
            exit: $67a3c407620ee84c$var$gfmFootnoteDefinitionEnd
        }),
        text: (_obj = {}, (0, $dUlz9._)(_obj, 91, {
            name: 'gfmFootnoteCall',
            tokenize: $67a3c407620ee84c$var$tokenizeGfmFootnoteCall
        }), (0, $dUlz9._)(_obj, 93, {
            name: 'gfmPotentialFootnoteCall',
            add: 'after',
            tokenize: $67a3c407620ee84c$var$tokenizePotentialGfmFootnoteCall,
            resolveTo: $67a3c407620ee84c$var$resolveToPotentialGfmFootnoteCall
        }), _obj)
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $67a3c407620ee84c$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ var labelStart;
    // Find an opening.
    while(index--){
        var token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === 'gfmFootnoteCall' || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        var id = (0, $daea560f96654179$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $67a3c407620ee84c$var$resolveToPotentialGfmFootnoteCall(events, context) {
    var _events;
    var index = events.length;
    /** @type {Token | undefined} */ var labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === 'enter') {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = 'gfmFootnoteCallLabelMarker';
    // The whole (without `!`):
    /** @type {Token} */ var call = {
        type: 'gfmFootnoteCall',
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ var marker = {
        type: 'gfmFootnoteCallMarker',
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ var string = {
        type: 'gfmFootnoteCallString',
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ var chunk = {
        type: "chunkString",
        contentType: 'string',
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ var replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            'enter',
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            'enter',
            marker,
            context
        ],
        [
            'exit',
            marker,
            context
        ],
        // Everything in between.
        [
            'enter',
            string,
            context
        ],
        [
            'enter',
            chunk,
            context
        ],
        [
            'exit',
            chunk,
            context
        ],
        [
            'exit',
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            'exit',
            call,
            context
        ]
    ];
    (_events = events).splice.apply(_events, [
        index,
        events.length - index + 1
    ].concat((0, $XnYkK._)(replacement)));
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $67a3c407620ee84c$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    var self = this;
    var defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    var size = 0;
    /** @type {boolean} */ var data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteCall');
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter('gfmFootnoteCallMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallMarker');
        effects.enter('gfmFootnoteCallString');
        effects.enter('chunkString').contentType = 'string';
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $4d05890350ae4444$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            var token = effects.exit('gfmFootnoteCallString');
            if (!defined.includes((0, $daea560f96654179$export$806d55e226cfcd08)(self.sliceSerialize(token)))) return nok(code);
            effects.enter('gfmFootnoteCallLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteCallLabelMarker');
            effects.exit('gfmFootnoteCall');
            return ok;
        }
        if (!(0, $4d05890350ae4444$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $67a3c407620ee84c$var$tokenizeDefinitionStart(effects, ok, nok) {
    var self = this;
    var defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ var identifier;
    var size = 0;
    /** @type {boolean | undefined} */ var data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteDefinition')._container = true;
        effects.enter('gfmFootnoteDefinitionLabel');
        effects.enter('gfmFootnoteDefinitionLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteDefinitionLabelMarker');
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter('gfmFootnoteDefinitionMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionMarker');
            effects.enter('gfmFootnoteDefinitionLabelString');
            effects.enter('chunkString').contentType = 'string';
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $4d05890350ae4444$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            var token = effects.exit('gfmFootnoteDefinitionLabelString');
            identifier = (0, $daea560f96654179$export$806d55e226cfcd08)(self.sliceSerialize(token));
            effects.enter('gfmFootnoteDefinitionLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionLabelMarker');
            effects.exit('gfmFootnoteDefinitionLabel');
            return labelAfter;
        }
        if (!(0, $4d05890350ae4444$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker');
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, whitespaceAfter, 'gfmFootnoteDefinitionWhitespace');
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $67a3c407620ee84c$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $ba12a10e9e950846$export$d50d28ce3ab2a612), ok, effects.attempt($67a3c407620ee84c$var$indent, ok, nok));
}
/** @type {Exiter} */ function $67a3c407620ee84c$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit('gfmFootnoteDefinition');
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $67a3c407620ee84c$var$tokenizeIndent(effects, ok, nok) {
    var self = this;
    return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, afterPrefix, 'gfmFootnoteDefinitionIndent', 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        var tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'gfmFootnoteDefinitionIndent' && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

/**
 * @import {HtmlOptions as Options} from 'micromark-extension-gfm-footnote'
 * @import {HtmlExtension} from 'micromark-util-types'
 */ 

var $aa19c92ef760b6f9$var$own = {}.hasOwnProperty;
/** @type {Options} */ var $aa19c92ef760b6f9$var$emptyOptions = {};
function $aa19c92ef760b6f9$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $aa19c92ef760b6f9$export$a731a1f6cf81900c(options) {
    var config = options || $aa19c92ef760b6f9$var$emptyOptions;
    var label = config.label || 'Footnotes';
    var labelTagName = config.labelTagName || 'h2';
    var labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    var backLabel = config.backLabel || $aa19c92ef760b6f9$export$a18c77a47f4154b6;
    var clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? 'user-content-' : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition: function() {
                var stack = this.getData('tightStack');
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString: function() {
                this.buffer();
            },
            gfmFootnoteCallString: function() {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition: function() {
                var definitions = this.getData('gfmFootnoteDefinitions');
                var footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                var tightStack = this.getData('tightStack');
                var current = footnoteStack.pop();
                var value = this.resume();
                if (!definitions) this.setData('gfmFootnoteDefinitions', definitions = {});
                if (!$aa19c92ef760b6f9$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData('slurpOneLineEnding', true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData('lastWasTag');
            },
            gfmFootnoteDefinitionLabelString: function(token) {
                var footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                if (!footnoteStack) this.setData('gfmFootnoteDefinitionStack', footnoteStack = []);
                footnoteStack.push((0, $daea560f96654179$export$806d55e226cfcd08)(this.sliceSerialize(token)));
                this.resume(); // Drop the label.
                this.buffer(); // Get ready for a value.
            },
            gfmFootnoteCallString: function(token) {
                var calls = this.getData('gfmFootnoteCallOrder');
                var counts = this.getData('gfmFootnoteCallCounts');
                var id = (0, $daea560f96654179$export$806d55e226cfcd08)(this.sliceSerialize(token));
                /** @type {number} */ var counter;
                this.resume();
                if (!calls) this.setData('gfmFootnoteCallOrder', calls = []);
                if (!counts) this.setData('gfmFootnoteCallCounts', counts = {});
                var index = calls.indexOf(id);
                var safeId = (0, $9ec3f308f236101d$export$d130a2d684099e5a)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                var reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + 'fn-' + safeId + '" id="' + clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : '') + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + '</a></sup>');
            },
            null: function() {
                var _this, _loop = function() {
                    // Called definitions are always defined.
                    var id = calls[index];
                    var safeId = (0, $9ec3f308f236101d$export$d130a2d684099e5a)(id.toLowerCase());
                    var referenceIndex = 0;
                    /** @type {Array<string>} */ var references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + 'fnref-' + safeId + (referenceIndex > 1 ? '-' + referenceIndex : '') + '" data-footnote-backref="" aria-label="' + _this.encode(typeof backLabel === 'string' ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? '<sup>' + referenceIndex + '</sup>' : '') + '</a>');
                    var reference = references.join(' ');
                    var injected = false;
                    _this.lineEndingIfNeeded();
                    _this.tag('<li id="' + clobberPrefix + 'fn-' + safeId + '">');
                    _this.lineEndingIfNeeded();
                    _this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, function($0) {
                        injected = true;
                        return ' ' + reference + $0;
                    }));
                    if (!injected) {
                        _this.lineEndingIfNeeded();
                        _this.tag(reference);
                    }
                    _this.lineEndingIfNeeded();
                    _this.tag('</li>');
                };
                var calls = this.getData('gfmFootnoteCallOrder') || [];
                var counts = this.getData('gfmFootnoteCallCounts') || {};
                var definitions = this.getData('gfmFootnoteDefinitions') || {};
                var index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? ' ' + labelAttributes : '') + '>');
                    this.raw(this.encode(label));
                    this.tag('</' + labelTagName + '>');
                    this.lineEndingIfNeeded();
                    this.tag('<ol>');
                }
                while(++index < calls.length)_this = this, _loop();
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('</ol>');
                    this.lineEndingIfNeeded();
                    this.tag('</section>');
                }
            }
        }
    };
}


/**
 * @import {Options} from 'micromark-extension-gfm-strikethrough'
 * @import {Event, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 
var $dUlz9 = parcelRequire("dUlz9");



function $7ba65e994a930498$export$8bbec8ea1400a00e(options) {
    var options_ = options || {};
    var single = options_.singleTilde;
    var tokenizer = {
        name: 'strikethrough',
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: (0, $dUlz9._)({}, 126, tokenizer),
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        var index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === 'enter' && events[index][1].type === 'strikethroughSequenceTemporary' && events[index][1]._close) {
            var open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === 'exit' && events[open][1].type === 'strikethroughSequenceTemporary' && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = 'strikethroughSequence';
                events[open][1].type = 'strikethroughSequence';
                /** @type {Token} */ var strikethrough = {
                    type: 'strikethrough',
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ var text = {
                    type: 'strikethroughText',
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ var nextEvents = [
                    [
                        'enter',
                        strikethrough,
                        context
                    ],
                    [
                        'enter',
                        events[open][1],
                        context
                    ],
                    [
                        'exit',
                        events[open][1],
                        context
                    ],
                    [
                        'enter',
                        text,
                        context
                    ]
                ];
                var insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $c39c196334f8c75e$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $73eb3c6139ed2caa$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $c39c196334f8c75e$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        'exit',
                        text,
                        context
                    ],
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        strikethrough,
                        context
                    ]
                ]);
                (0, $c39c196334f8c75e$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === 'strikethroughSequenceTemporary') events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        var previous = this.previous;
        var events = this.events;
        var size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter('strikethroughSequenceTemporary');
            return more(code);
        }
        /** @type {State} */ function more(code) {
            var before = (0, $0a3461a0e64b4a88$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            var token = effects.exit('strikethroughSequenceTemporary');
            var after = (0, $0a3461a0e64b4a88$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM strikethrough when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions`, to
 *   support GFM strikethrough when serializing to HTML.
 */ function $b9fe03d8f6033fe1$export$58acedca46108820() {
    return {
        enter: {
            strikethrough: function() {
                this.tag('<del>');
            }
        },
        exit: {
            strikethrough: function() {
                this.tag('</del>');
            }
        }
    };
}


/**
 * @import {Event, Extension, Point, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @import {Event} from 'micromark-util-types'
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ 
var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $XnYkK = parcelRequire("XnYkK");
var $975801c33a93f495$export$9348908dd4518b4a = /*#__PURE__*/ function() {
    "use strict";
    function EditMap() {
        (0, $5Epmf._)(this, EditMap);
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
    (0, $9MqXK._)(EditMap, [
        {
            /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */ key: "add",
            value: function add(index, remove, _add) {
                $975801c33a93f495$var$addImplementation(this, index, remove, _add);
            }
        },
        {
            // To do: add this when moving to `micromark`.
            // /**
            //  * Create an edit: but insert `add` before existing additions.
            //  *
            //  * @param {number} index
            //  * @param {number} remove
            //  * @param {Array<Event>} add
            //  * @returns {undefined}
            //  */
            // addBefore(index, remove, add) {
            //   addImplementation(this, index, remove, add, true)
            // }
            /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */ key: "consume",
            value: function consume(events) {
                this.map.sort(function(a, b) {
                    return a[0] - b[0];
                });
                /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
                // To do: if links are added in events, like they are in `markdown-rs`,
                // this is needed.
                // // Calculate jumps: where items in the current list move to.
                // /** @type {Array<Jump>} */
                // const jumps = []
                // let index = 0
                // let addAcc = 0
                // let removeAcc = 0
                // while (index < this.map.length) {
                //   const [at, remove, add] = this.map[index]
                //   removeAcc += remove
                //   addAcc += add.length
                //   jumps.push([at, removeAcc, addAcc])
                //   index += 1
                // }
                //
                // . shiftLinks(events, jumps)
                var index = this.map.length;
                /** @type {Array<Array<Event>>} */ var vecs = [];
                while(index > 0){
                    index -= 1;
                    vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);
                    // Truncate rest.
                    events.length = this.map[index][0];
                }
                vecs.push(events.slice());
                events.length = 0;
                var slice = vecs.pop();
                while(slice){
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = slice[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            events.push(element);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    slice = vecs.pop();
                }
                // Truncate everything.
                this.map.length = 0;
            }
        }
    ]);
    return EditMap;
}();
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {undefined}
 */ function $975801c33a93f495$var$addImplementation(editMap, at, remove, add) {
    var index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            var // To do: before not used by tables, use when moving to micromark.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            _editMap_map_index_;
            editMap.map[index][1] += remove;
            (_editMap_map_index_ = editMap.map[index][2]).push.apply(_editMap_map_index_, (0, $XnYkK._)(add));
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @import {Event} from 'micromark-util-types'
 */ /**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */ function $4b43cd1f9ec51d35$export$bbf4fe2c547a4878(events, index) {
    var inDelimiterRow = false;
    /** @type {Array<Align>} */ var align = [];
    while(index < events.length){
        var event = events[index];
        if (inDelimiterRow) {
            if (event[0] === 'enter') // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === 'tableContent') align.push(events[index + 1][1].type === 'tableDelimiterMarker' ? 'left' : 'none');
            } else if (event[1].type === 'tableContent') {
                if (events[index - 1][1].type === 'tableDelimiterMarker') {
                    var alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right';
                }
            } else if (event[1].type === 'tableDelimiterRow') break;
        } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') inDelimiterRow = true;
        index += 1;
    }
    return align;
}


function $b7aa9ea60a7b9e31$export$e36cebda627bf2dd() {
    return {
        flow: {
            null: {
                name: 'table',
                tokenize: $b7aa9ea60a7b9e31$var$tokenizeTable,
                resolveAll: $b7aa9ea60a7b9e31$var$resolveTable
            }
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b7aa9ea60a7b9e31$var$tokenizeTable(effects, ok, nok) {
    var self = this;
    var size = 0;
    var sizeB = 0;
    /** @type {boolean | undefined} */ var seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        var index = self.events.length - 1;
        while(index > -1){
            var type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        var tail = index > -1 ? self.events[index][1].type : null;
        var next = tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter('tableHead');
        effects.enter('tableRow');
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit('tableRow');
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $4d05890350ae4444$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter('tableDelimiterRow');
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter('tableDelimiterFiller');
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit('tableDelimiterFiller');
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit('tableDelimiterFiller');
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit('tableDelimiterRow');
            effects.exit('tableHead');
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter('tableRow');
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return bodyRowBreak;
        }
        if (code === null || (0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) {
            effects.exit('tableRow');
            return ok(code);
        }
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $4d05890350ae4444$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ function $b7aa9ea60a7b9e31$var$resolveTable(events, context) {
    var index = -1;
    var inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ var rowKind = 0;
    /** @type {Range} */ var lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ var cell = [
        0,
        0,
        0,
        0
    ];
    var afterHeadAwaitingFirstBodyRow = false;
    var lastTableEnd = 0;
    /** @type {Token | undefined} */ var currentTable;
    /** @type {Token | undefined} */ var currentBody;
    /** @type {Token | undefined} */ var currentCell;
    var map = new (0, $975801c33a93f495$export$9348908dd4518b4a)();
    while(++index < events.length){
        var event = events[index];
        var token = event[1];
        if (event[0] === 'enter') {
            // Start of head.
            if (token.type === 'tableHead') {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $b7aa9ea60a7b9e31$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: 'table',
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        'enter',
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: 'tableBody',
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            'enter',
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $b7aa9ea60a7b9e31$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === 'tableCellDivider') {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $b7aa9ea60a7b9e31$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === 'tableHead') {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $b7aa9ea60a7b9e31$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $b7aa9ea60a7b9e31$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) cell[3] = index;
    }
    if (lastTableEnd !== 0) $b7aa9ea60a7b9e31$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        var event1 = context.events[index];
        if (event1[0] === 'enter' && event1[1].type === 'table') event1[1]._align = (0, $4b43cd1f9ec51d35$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/**
 * Generate a cell.
 *
 * @param {EditMap} map
 * @param {Readonly<TokenizeContext>} context
 * @param {Readonly<Range>} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $b7aa9ea60a7b9e31$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    var groupName = rowKind === 1 ? 'tableHeader' : rowKind === 2 ? 'tableDelimiter' : 'tableData';
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    var valueName = 'tableContent';
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $b7aa9ea60a7b9e31$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    var now = $b7aa9ea60a7b9e31$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            'enter',
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        var relatedStart = $b7aa9ea60a7b9e31$var$getPoint(context.events, range[2]);
        var relatedEnd = $b7aa9ea60a7b9e31$var$getPoint(context.events, range[3]);
        /** @type {Token} */ var valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                'enter',
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            var start = context.events[range[2]];
            var end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                var a = range[2] + 1;
                var b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                'exit',
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $b7aa9ea60a7b9e31$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 * @param {Readonly<TokenizeContext>} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $b7aa9ea60a7b9e31$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ var exits = [];
    var related = $b7aa9ea60a7b9e31$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            'exit',
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        'exit',
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Readonly<Array<Event>>} events
 * @param {number} index
 * @returns {Readonly<Point>}
 */ function $b7aa9ea60a7b9e31$var$getPoint(events, index) {
    var event = events[index];
    var side = event[0] === 'enter' ? 'start' : 'end';
    return event[1][side];
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ var $0c6d605dab3665ff$var$alignment = {
    none: '',
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
function $0c6d605dab3665ff$export$c64626c032567c7f() {
    return {
        enter: {
            table: function(token) {
                var tableAlign = token._align;
                this.lineEndingIfNeeded();
                this.tag('<table>');
                this.setData('tableAlign', tableAlign);
            },
            tableBody: function() {
                this.tag('<tbody>');
            },
            tableData: function() {
                var tableAlign = this.getData('tableAlign');
                var tableColumn = this.getData('tableColumn');
                var align = $0c6d605dab3665ff$var$alignment[tableAlign[tableColumn]];
                if (align === undefined) // Capture results to ignore them.
                this.buffer();
                else {
                    this.lineEndingIfNeeded();
                    this.tag('<td' + align + '>');
                }
            },
            tableHead: function() {
                this.lineEndingIfNeeded();
                this.tag('<thead>');
            },
            tableHeader: function() {
                var tableAlign = this.getData('tableAlign');
                var tableColumn = this.getData('tableColumn');
                var align = $0c6d605dab3665ff$var$alignment[tableAlign[tableColumn]];
                this.lineEndingIfNeeded();
                this.tag('<th' + align + '>');
            },
            tableRow: function() {
                this.setData('tableColumn', 0);
                this.lineEndingIfNeeded();
                this.tag('<tr>');
            }
        },
        exit: {
            // Overwrite the default code text data handler to unescape escaped pipes when
            // they are in tables.
            codeTextData: function(token) {
                var value = this.sliceSerialize(token);
                if (this.getData('tableAlign')) value = value.replace(/\\([\\|])/g, $0c6d605dab3665ff$var$replace);
                this.raw(this.encode(value));
            },
            table: function() {
                this.setData('tableAlign');
                // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
                // but we do need to reset it to match a funky newline GH generates for
                // list items combined with tables.
                this.setData('slurpAllLineEndings');
                this.lineEndingIfNeeded();
                this.tag('</table>');
            },
            tableBody: function() {
                this.lineEndingIfNeeded();
                this.tag('</tbody>');
            },
            tableData: function() {
                var tableAlign = this.getData('tableAlign');
                var tableColumn = this.getData('tableColumn');
                if (tableColumn in tableAlign) {
                    this.tag('</td>');
                    this.setData('tableColumn', tableColumn + 1);
                } else // Stop capturing.
                this.resume();
            },
            tableHead: function() {
                this.lineEndingIfNeeded();
                this.tag('</thead>');
            },
            tableHeader: function() {
                var tableColumn = this.getData('tableColumn');
                this.tag('</th>');
                this.setData('tableColumn', tableColumn + 1);
            },
            tableRow: function() {
                var tableAlign = this.getData('tableAlign');
                var tableColumn = this.getData('tableColumn');
                while(tableColumn < tableAlign.length){
                    this.lineEndingIfNeeded();
                    this.tag('<td' + $0c6d605dab3665ff$var$alignment[tableAlign[tableColumn]] + '></td>');
                    tableColumn++;
                }
                this.setData('tableColumn', tableColumn);
                this.lineEndingIfNeeded();
                this.tag('</tr>');
            }
        }
    };
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $0c6d605dab3665ff$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
var $242ac14caa0b7b4f$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
var $242ac14caa0b7b4f$var$reText = new RegExp('^' + $242ac14caa0b7b4f$var$reFlow.source, 'i');
function $242ac14caa0b7b4f$export$c9bf87ea36d00682() {
    return {
        exit: {
            htmlFlowData: function(token) {
                $242ac14caa0b7b4f$var$exitHtmlData.call(this, token, $242ac14caa0b7b4f$var$reFlow);
            },
            htmlTextData: function(token) {
                $242ac14caa0b7b4f$var$exitHtmlData.call(this, token, $242ac14caa0b7b4f$var$reText);
            }
        }
    };
}
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 * @returns {undefined}
 */ function $242ac14caa0b7b4f$var$exitHtmlData(token, filter) {
    var value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, '&lt;$1$2');
    this.raw(this.encode(value));
}


/**
 * @import {Extension, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 
var $dUlz9 = parcelRequire("dUlz9");


var $eee8901bd2d12989$var$tasklistCheck = {
    name: 'tasklistCheck',
    tokenize: $eee8901bd2d12989$var$tokenizeTasklistCheck
};
function $eee8901bd2d12989$export$2912e8b2802475ff() {
    return {
        text: (0, $dUlz9._)({}, 91, $eee8901bd2d12989$var$tasklistCheck)
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $eee8901bd2d12989$var$tokenizeTasklistCheck(effects, ok, nok) {
    var self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter('taskListCheck');
        effects.enter('taskListCheckMarker');
        effects.consume(code);
        effects.exit('taskListCheckMarker');
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $4d05890350ae4444$export$a30284361b3814b7)(code)) {
            effects.enter('taskListCheckValueUnchecked');
            effects.consume(code);
            effects.exit('taskListCheckValueUnchecked');
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter('taskListCheckValueChecked');
            effects.consume(code);
            effects.exit('taskListCheckValueChecked');
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter('taskListCheckMarker');
            effects.consume(code);
            effects.exit('taskListCheckMarker');
            effects.exit('taskListCheck');
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $4d05890350ae4444$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $4d05890350ae4444$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $eee8901bd2d12989$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $eee8901bd2d12989$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $11d7e00f3fab1b8a$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM task list items when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions` to
 *   support GFM task list items when serializing to HTML.
 */ function $bd927d7f2b2b5c79$export$4b6a13e2af1b08ed() {
    return {
        enter: {
            taskListCheck: function() {
                this.tag('<input type="checkbox" disabled="" ');
            }
        },
        exit: {
            taskListCheck: function() {
                this.tag('/>');
            },
            taskListCheckValueChecked: function() {
                this.tag('checked="" ');
            }
        }
    };
}


function $1429e6a5c622e40c$export$59ffe8c4d7a4aab2(options) {
    return (0, $a8b619d0d726651b$export$86a865d89ef3c690)([
        (0, $697a8427cee08fa7$export$608123d9b549151)(),
        (0, $67a3c407620ee84c$export$c82499b6656305df)(),
        (0, $7ba65e994a930498$export$8bbec8ea1400a00e)(options),
        (0, $b7aa9ea60a7b9e31$export$e36cebda627bf2dd)(),
        (0, $eee8901bd2d12989$export$2912e8b2802475ff)()
    ]);
}
function $1429e6a5c622e40c$export$6983b82e6105d62a(options) {
    return (0, $a8b619d0d726651b$export$eaf8c406dfb0a620)([
        (0, $b7076e062304b9b0$export$999603f1f1c3d2f9)(),
        (0, $aa19c92ef760b6f9$export$a731a1f6cf81900c)(options),
        (0, $b9fe03d8f6033fe1$export$58acedca46108820)(),
        (0, $0c6d605dab3665ff$export$c64626c032567c7f)(),
        (0, $242ac14caa0b7b4f$export$c9bf87ea36d00682)(),
        (0, $bd927d7f2b2b5c79$export$4b6a13e2af1b08ed)()
    ]);
}


/** @type {Options} */ var $37d5c81e71416b7d$var$emptyOptions = {};
function $37d5c81e71416b7d$export$2e2bcd8739ae039(options) {
    // @ts-expect-error: TS is wrong about `this`.
    // eslint-disable-next-line unicorn/no-this-assignment
    var self = /** @type {Processor<Root>} */ this;
    var settings = options || $37d5c81e71416b7d$var$emptyOptions;
    var data = self.data();
    var micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
    var fromMarkdownExtensions = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
    var toMarkdownExtensions = data.toMarkdownExtensions || (data.toMarkdownExtensions = []);
    micromarkExtensions.push((0, $1429e6a5c622e40c$export$59ffe8c4d7a4aab2)(settings));
    fromMarkdownExtensions.push((0, $2752266c62d5ad29$export$95adae814eb7433e)());
    toMarkdownExtensions.push((0, $2752266c62d5ad29$export$ea77de6901e7c72b)(settings));
}



parcelRequire("5s1kH");
var $907308db992f54bf$exports = {};
$907308db992f54bf$exports = $parcel$resolve("18Y3C");


var $2d0dc7b0173a4476$var$AttentionBox = function(props) {
    var clsMargin = props.margin ? props.margin : "mt-4";
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "border border-orange-500 p-4 flex items-center gap-x-2 rounded-md " + clsMargin,
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($907308db992f54bf$exports))),
                className: "h-6 w-6",
                alt: "attention"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "z-title3",
                children: props.message
            })
        ]
    });
};
var $2d0dc7b0173a4476$export$2e2bcd8739ae039 = $2d0dc7b0173a4476$var$AttentionBox;


var $db44299b4f245a2a$export$7ccfe9f56c40bcb7 = function(lang, type, fromChat) {
    if (type === "behavior") return lang === "sv" ? "Dags att f\xf6lja upp p\xe5 ditt beteende" : "Time to follow up on your behavior";
    else if (type === "task") return lang === "sv" ? "Dags att f\xf6lja upp p\xe5 din frist\xe5ende AI coaching" : "Time to follow up on your standalone AI coaching";
    else if (type === "activity") {
        if (fromChat) return lang === "sv" ? "Dags att f\xf6lja upp p\xe5 din AI coaching" : "Time to follow up on your AI coaching";
        else return lang === "sv" ? "Dags att f\xf6lja upp p\xe5 din aktivitet" : "Time to follow up on your activity";
    } else if (type === "subGoal") return lang === "sv" ? "Dags att f\xf6lja upp p\xe5 ditt delm\xe5l" : "Time to follow up on your sub-goal";
    else if (type === "action") return lang === "sv" ? "Dags att f\xf6lja upp p\xe5 din aktivitet" : "Time to follow up on your action";
    return "N/A for " + type;
};


function $4c5e094665fbeb24$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var taskId = (0, $bHX26.useParams)().taskId;
    var navigate = (0, $bHX26.useNavigate)();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), task = _useState[0], setTask = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), feedbacks = _useState1[0], setFeedbacks = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), categories = _useState2[0], setCategories = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState3[0], setLoaded = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), completed = _useState4[0], setCompleted = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showCompletedModal = _useState5[0], setShowCompletedModal = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), askDeleteTask = _useState6[0], setAskDeleteTask = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)((0, $1af830c9fe0316f4$export$a8d543f4b6260801)()), 2), tab = _useState7[0], setTab = _useState7[1];
    var now = new Date();
    (0, $5s1kH.useEffect)(function() {
        getTask();
    }, []);
    var getTask = function() {
        api.get("client/task/" + taskId + "?feedback=1").then(function(response) {
            setTask(response.json.task);
            setCompleted(response.json.task.completed);
            setFeedbacks(response.json.feedbacks);
            setCategories(response.json.categories);
            setLoaded(true);
        }).catch(function(error) {
            if (error.response && error.response.status === 404) setLoaded(true);
            else console.log(error);
        });
    };
    var changeTab = function(tab) {
        setTab(tab);
        (0, $1af830c9fe0316f4$export$a7d4a63c0f4094bf)(tab);
    };
    var deleteTask = function() {
        var data = {
            remove: true
        };
        api.post("client/tasks/" + taskId + "/edit", data).then(function(response) {
            navigate("/dev-plan");
        });
    };
    var changeCompletion = function() {
        var newCompleted = !completed;
        var data = {
            completed: newCompleted
        };
        api.post("client/tasks/" + (task === null || task === void 0 ? void 0 : task.id) + "/update", data).then(function(response) {
            setCompleted(newCompleted);
            setShowCompletedModal(newCompleted);
        });
    };
    var showCompletedOption = function() {
        if ((task === null || task === void 0 ? void 0 : task.completed) && task.feedback) return null;
        var label;
        if (completed) label = lang === "sv" ? "Avmarkera som klar" : "Undo completion";
        else label = lang === "sv" ? "Markera som klar" : "Mark as completed";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                    id: "1",
                    label: label,
                    checked: completed,
                    labelClassName: "z-title3",
                    onChange: function() {
                        return changeCompletion();
                    }
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "border-indigo-700 my-4"
                })
            ]
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "w-full h-full flex justify-center mt-4 desktop:mt-6",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "flex flex-col gap-2 justify-center align-middle w-full desktop:w-151 m-4 mt-0",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $acc426d061413a39$export$2e2bcd8739ae039), {})
        })
    });
    if (!task) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "main-one-col small",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "z-h2 mt-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0fe3991a360589a5$exports))),
                        alt: "task icon",
                        className: "w-6 h-6 desktop:w-10 desktop:h-10"
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "z-body1 text-center",
                    children: lang === 'sv' ? 'Hittade inte aktivitet med detta id.' : 'Could not find the activity with this id.'
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    className: "mt-8",
                    onClick: function() {
                        return navigate("/development-plan");
                    },
                    children: t("go-to-focus-area")
                })
            ]
        })
    });
    var popItems = [
        {
            title: lang === "sv" ? "\xc4ndra" : "Edit",
            click: function() {
                navigate("/tasks/" + (task === null || task === void 0 ? void 0 : task.id) + "/edit");
            },
            img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($8a47c0bf566c4697$exports))),
                alt: "edit",
                className: "h-4 w-4"
            })
        },
        {
            title: t("delete"),
            click: function() {
                return setAskDeleteTask(true);
            },
            img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                alt: "delete",
                className: "h-4 w-4"
            })
        }
    ];
    var renderContinueChat = function() {
        if (task.originalChatThreadId) {
            if (completed) {
                var msg = lang === "sv" ? "Jag vill reflektera \xf6ver den aktivitet jag avslutat: " + task.name : "I would like to reflect on the Action I completed: " + task.name;
                (0, $d0129b8cfae32aec$export$f93b11ed7a4960f0)("coaching", "action", null, task.id, task.originalChatThreadId, msg);
            }
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                buttonType: "outlineWhiteBase",
                className: "mt-2 flex items-center justify-center",
                leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cb70cc925ae09565$exports))),
                    alt: "AI",
                    className: "h-4 w-4 rounded-full"
                }),
                onClick: function() {
                    return navigate("/ai/" + task.originalChatThreadId);
                },
                children: completed ? lang === "sv" ? "Reflektera kring aktivitet" : "Reflect on Action" : lang === "sv" ? "Forts\xe4tt med coach-session" : "Continue with Coach session"
            });
        }
        return null;
    };
    var renderDetails = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                completed && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex items-center mt-6 border border-success-500 rounded-md p-4 bg-indigo-800",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($be3c5e2d6f294fc0$exports))),
                            alt: "check"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "ml-2 z-title3",
                            children: lang === "sv" ? "Aktivitet klar" : "Completed"
                        })
                    ]
                }),
                !completed && new Date(task.deadline) < now && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
                    message: (0, $db44299b4f245a2a$export$7ccfe9f56c40bcb7)(lang, 'task', false)
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "bg-indigo-900 rounded-md p-4 mt-4",
                    children: [
                        showCompletedOption(),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                    alt: "date"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "ml-2",
                                    children: [
                                        t("due-date"),
                                        ":\xa0",
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                            className: "text-gray-400",
                                            children: task.deadline ? (0, $7d185b5883a21821$export$5a252a405018366)(task.deadline) : "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        task.focusAreaId && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($39fbe7786abdc679$exports))),
                                    alt: "fa",
                                    className: "h-4 w-4"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "ml-2",
                                    children: [
                                        t("focus-area-nav-title"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "ml-2",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $65b37309f7d8dd2c$export$2e2bcd8739ae039), {
                                        onClick: function() {
                                            return navigate("/development-plan/focus-area/" + task.focusAreaId);
                                        },
                                        children: task.focusAreaName
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "my-4 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "markdown-content text-gray-300",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b0f0e35343cbf8ab$export$7460c8b7e4ce9582), {
                                remarkPlugins: [
                                    (0, $37d5c81e71416b7d$export$2e2bcd8739ae039)
                                ],
                                children: task.description
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "h-4",
                            children: "\xa0"
                        }),
                        renderContinueChat()
                    ]
                }),
                showCompletedModal && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                    isOpen: true,
                    onClose: function() {
                        return setShowCompletedModal(false);
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                            onClose: function() {
                                return setShowCompletedModal(false);
                            },
                            children: lang === "sv" ? "Aktivitet klar" : "Action completed"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($25e20653d8aa411d$exports))),
                                    alt: "check",
                                    className: "h-12 w-12 mx-auto mt-3"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-6",
                                    children: lang === "sv" ? "Bra jobbat! Du g\xf6r framsteg. Ta en stund och reflektera \xf6ver vad du har l\xe4rt dig och be om feedback f\xf6r att bekr\xe4fta dina framsteg." : "Great job! You\u2019re making progress. Take a moment to reflect on what you\u2019ve learned and request feedback to validate your achievement."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "w-full",
                                children: renderContinueChat()
                            })
                        })
                    ]
                }),
                askDeleteTask && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                    isOpen: true,
                    onClose: function() {
                        return setAskDeleteTask(false);
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                            onClose: function() {
                                return setAskDeleteTask(false);
                            },
                            children: lang === "sv" ? "Ta bort aktivitet?" : "Delete Action?"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                            children: [
                                lang === "sv" ? "Detta kommer permanent ta bort aktiviteten " : "This will permanently delete Action ",
                                task === null || task === void 0 ? void 0 : task.name
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: "outlineWhiteBase",
                                        onClick: function() {
                                            return setAskDeleteTask(false);
                                        },
                                        children: t("cancel")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: "dangerBase",
                                        className: "mt-2",
                                        onClick: function() {
                                            return deleteTask();
                                        },
                                        children: t("delete")
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    var renderTab = function() {
        if (tab === 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c70252c420dfa719$export$2e2bcd8739ae039), {
            task: task,
            feedbacks: feedbacks
        });
        return renderDetails();
    };
    var showCrumbs = function() {
        var taskName = lang === "sv" ? "Aktivitet" : "Action";
        if (categories > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
            crumbs: [
                {
                    name: t("long-term-goals"),
                    url: "/dev-plan"
                },
                {
                    name: taskName
                }
            ]
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
            crumbs: [
                {
                    name: lang === "sv" ? "Hem" : "Home",
                    url: "/"
                },
                {
                    name: lang === "sv" ? "Aktiviteter" : "Activities",
                    url: "/tasks"
                },
                {
                    name: taskName
                }
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            showCrumbs(),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex my-4 desktop:mt-6 justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "bg-peach-600 rounded-md h-12 w-12 flex items-center justify-center",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4d32ec9694b3412e$exports))),
                                    className: "h-6 w-6",
                                    alt: "ico"
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-sm text-medium text-peach-600",
                                        children: lang === "sv" ? "Frist\xe5ende AI coaching" : "Standalone AI coaching"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-heading2",
                                        children: task.name
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                        items: popItems,
                        noHover: true
                    })
                ]
            }),
            task.feedback && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c8483606065062df$export$2e2bcd8739ae039), {
                active: tab,
                items: [
                    {
                        title: t("description"),
                        callback: function() {
                            return changeTab(0);
                        }
                    },
                    {
                        title: t("feedback"),
                        callback: function() {
                            return changeTab(1);
                        }
                    }
                ]
            }),
            renderTab()
        ]
    });
}


var $5db114b8d496b2f1$export$2e2bcd8739ae039 = (0, $4c5e094665fbeb24$export$2e2bcd8739ae039);



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");



var $584664dac616447b$exports = {};
$584664dac616447b$exports = $parcel$resolve("2FnJV");


var $56a45d7fe590023a$exports = {};
$56a45d7fe590023a$exports = $parcel$resolve("8Bd8P");


var $8db086155ef696e2$exports = {};
$8db086155ef696e2$exports = $parcel$resolve("iQMOE");




var $8035c9bf788700b7$exports = {};
$8035c9bf788700b7$exports = $parcel$resolve("gTGEa");


var $da0736b1a8f82dc0$exports = {};
$da0736b1a8f82dc0$exports = $parcel$resolve("5Bm0A");


var $fb5fda9edf61a9ba$exports = {};
$fb5fda9edf61a9ba$exports = $parcel$resolve("ekXXs");


var $005104c16715d72c$exports = {};
$005104c16715d72c$exports = $parcel$resolve("4EcBL");


var $dee60dcbfbf05c09$exports = {};
$dee60dcbfbf05c09$exports = $parcel$resolve("khsYt");



var $bHX26 = parcelRequire("bHX26");


parcelRequire("5s1kH");
var $01b6e07abd83fc68$exports = {};
$01b6e07abd83fc68$exports = $parcel$resolve("hklNS");


var $8813c1da5764a13f$var$Loading = function(props) {
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "w-full h-full flex items-center justify-center",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mx-auto",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($01b6e07abd83fc68$exports))),
                    className: "mx-auto",
                    alt: "loading",
                    style: {
                        height: 16,
                        width: 114
                    }
                }),
                props.txt && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 text-center z-title2 mx-auto",
                    children: props.txt
                })
            ]
        })
    });
};
var $8813c1da5764a13f$export$2e2bcd8739ae039 = $8813c1da5764a13f$var$Loading;


var $2e55dd46423f9c03$export$2e2bcd8739ae039 = (0, $8813c1da5764a13f$export$2e2bcd8739ae039);




parcelRequire("5s1kH");
var $3d60ab5b0b00a842$var$PlainBadge = function(props) {
    var iconSize = 14;
    var cls = "rounded-full px-2 text-center flex items-center ";
    if (props.color === "gray") cls += "bg-gray-400 border-gray-1000 text-gray-1000 ";
    else if (props.color === "green") cls += "bg-aquamarine-500 border-aquamarine-1000 text-aquamarine-1000 ";
    else if (props.color === "orange") cls += "bg-orange-500 border-orange-1000 text-orange-1000 ";
    else if (props.color === "red") cls += "bg-cherry-500 border-cherry-1000 text-cherry-1000 ";
    else if (props.color === "primary") cls += "bg-primary-600 border-primary-1000 text-primary-1000 ";
    if (props.size === "small") iconSize = 12;
    else cls += "py-1 ";
    if (props.className) cls += props.className;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: cls,
        children: [
            props.iconLeft && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: props.iconLeft,
                style: {
                    width: iconSize,
                    height: iconSize,
                    marginRight: 4
                },
                alt: "icon"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "text-xs",
                children: props.text
            })
        ]
    });
};
var $3d60ab5b0b00a842$export$2e2bcd8739ae039 = $3d60ab5b0b00a842$var$PlainBadge;


var $dffa8b95bfc7c1d5$export$f269ae6352e55a31 = /*#__PURE__*/ function(VisionStatementStatus) {
    VisionStatementStatus[VisionStatementStatus["None"] = 0] = "None";
    VisionStatementStatus[VisionStatementStatus["Saved"] = 1] = "Saved";
    VisionStatementStatus[VisionStatementStatus["Created"] = 2] = "Created";
    return VisionStatementStatus;
}({});
var $dffa8b95bfc7c1d5$export$579eee0d55ead4be = /*#__PURE__*/ function(VisionStatementPartStatus) {
    VisionStatementPartStatus[VisionStatementPartStatus["None"] = 0] = "None";
    VisionStatementPartStatus[VisionStatementPartStatus["Done"] = 1] = "Done";
    return VisionStatementPartStatus;
}({});



parcelRequire("5s1kH");






var $bHX26 = parcelRequire("bHX26");




var $151a6a8159fc0a97$exports = {};
$151a6a8159fc0a97$exports = $parcel$resolve("14SD2");


var $b2bd2c8dfffedc0a$exports = {};
$b2bd2c8dfffedc0a$exports = $parcel$resolve("lHE0T");


var $b841e7314e3d419d$export$9874b5b4c45031c5 = function(onTrack, lang) {
    if (onTrack === 0) return null;
    var txt;
    var color;
    if (onTrack === 1) {
        txt = lang === "sv" ? "I fas" : "On track";
        color = "green";
    } else if (onTrack === 2) {
        txt = lang === "sv" ? "N\xe5got efter" : "At risk";
        color = "orange";
    } else {
        txt = lang === "sv" ? "Mycket efter" : "Off track";
        color = "red";
    }
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3d60ab5b0b00a842$export$2e2bcd8739ae039), {
        text: txt,
        color: color,
        size: "small"
    });
};
var $b841e7314e3d419d$export$31387e6762a6770a = function(status, lang) {
    if (status === "done") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3d60ab5b0b00a842$export$2e2bcd8739ae039), {
        text: lang === "sv" ? "Klar" : "Done",
        iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($151a6a8159fc0a97$exports))),
        color: "green",
        size: "small"
    });
    else if (status === "ok") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3d60ab5b0b00a842$export$2e2bcd8739ae039), {
        text: lang === "sv" ? "I fas" : "On track",
        iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($151a6a8159fc0a97$exports))),
        color: "green",
        size: "small"
    });
    else {
        var txt;
        if (status === "behind") txt = lang === "sv" ? "Ligger efter" : "Behind";
        else txt = lang === "sv" ? "F\xf6lj upp" : "Needs attention";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3d60ab5b0b00a842$export$2e2bcd8739ae039), {
            text: txt,
            iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($b2bd2c8dfffedc0a$exports))),
            color: "orange",
            size: "small"
        });
    }
};


var $e8ccb00b12433a14$var$VisionStatementSummary = function(props) {
    var _props_visionStatement_timeProgress;
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var renderBadge = function() {
        if (props.visionStatement.status === (0, $dffa8b95bfc7c1d5$export$f269ae6352e55a31).Saved) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3d60ab5b0b00a842$export$2e2bcd8739ae039), {
            text: lang === "sv" ? "Utkast" : "Draft",
            color: "gray",
            size: "small"
        });
        else if (props.visionStatement.progress === 100) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3d60ab5b0b00a842$export$2e2bcd8739ae039), {
            text: lang === "sv" ? "Klar" : "Completed",
            color: "green",
            size: "small"
        });
        else if (props.visionStatement.status === (0, $dffa8b95bfc7c1d5$export$f269ae6352e55a31).Created && props.visionStatement.attention) return (0, $b841e7314e3d419d$export$31387e6762a6770a)(props.visionStatement.attention, lang);
        return null;
    };
    var cls = "bg-indigo-900 mt-4 p-4 rounded-md border-indigo-800 border-1";
    if (props.visionStatement.status === 2) cls += " hover:bg-indigo-800 cursor-pointer";
    var clickVs = function() {
        if (props.visionStatement.status === 2) navigate("/dev-plan/long-term-goal/" + props.visionStatement.id);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: cls,
        onClick: function() {
            return clickVs();
        },
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-col md:flex-row md:justify-between md:items-center gap-y-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex flex-col md:flex-row md:justify-between gap-x-2 items-start md:items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-gray-100 z-title1",
                                children: props.visionStatement.title.length > 0 ? props.visionStatement.title : lang === "sv" ? "[Ingen titel \xe4n]" : "[No title yet]"
                            }),
                            renderBadge()
                        ]
                    }),
                    props.visionStatement.deadline && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                className: "z-title3 text-gray-100",
                                children: [
                                    t("due-date"),
                                    ":\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                className: "text-sm text-gray-400",
                                children: props.visionStatement.deadline.substring(0, 10)
                            })
                        ]
                    })
                ]
            }),
            props.visionStatement.status === (0, $dffa8b95bfc7c1d5$export$f269ae6352e55a31).Created && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex justify-between mt-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex gap-x-1 items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports))),
                                        alt: "time",
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-title3 text-gray-100!",
                                        children: lang === "sv" ? "Tidsplan" : "Timeline"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "z-body2 text-gray-400!",
                                children: [
                                    (_props_visionStatement_timeProgress = props.visionStatement.timeProgress) === null || _props_visionStatement_timeProgress === void 0 ? void 0 : _props_visionStatement_timeProgress.toFixed(0),
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-1 h-2 rounded-full bg-indigo-700 w-full",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "h-2 rounded-full bg-primary-500",
                            style: {
                                width: props.visionStatement.timeProgress + "%"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                className: "z-title3 text-gray-100",
                                children: [
                                    lang === "sv" ? "Delm\xe5l" : "Sub-goals",
                                    ":\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                className: "z-body2 text-gray-400!",
                                children: props.visionStatement.goals
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                className: "mx-2 z-body2 text-gray-100!",
                                children: "|"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                className: "z-title3 text-gray-100",
                                children: [
                                    lang === "sv" ? "Aktiviteter" : "Activities",
                                    ":\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                className: "z-body2 text-gray-400!",
                                children: props.visionStatement.activities
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                className: "mx-2 z-body2 text-gray-100!",
                                children: "|"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                className: "z-title3 text-gray-100",
                                children: [
                                    lang === "sv" ? "Beteenden" : "Behaviours",
                                    ":\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                className: "z-body2 text-gray-400!",
                                children: props.visionStatement.behaviors
                            })
                        ]
                    })
                ]
            }),
            props.visionStatement.status === (0, $dffa8b95bfc7c1d5$export$f269ae6352e55a31).Saved && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4 flex justify-end",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: props.mainButtons && props.mainButtons > 1 ? "outlineWhiteBase" : "blueBase",
                    style: {
                        width: "unset"
                    },
                    rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                        alt: "right",
                        className: "h-4 w-4"
                    }),
                    onClick: function() {
                        return navigate("/dev-plan/long-term-goal/" + props.visionStatement.id);
                    },
                    children: [
                        t("create"),
                        " ",
                        t("vision_statement")
                    ]
                })
            })
        ]
    }, "vs_" + props.visionStatement.id);
};
var $e8ccb00b12433a14$export$2e2bcd8739ae039 = $e8ccb00b12433a14$var$VisionStatementSummary;



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");





parcelRequire("5s1kH");
var $6d2f2828e551a790$var$RadioButton = function(param) {
    var id = param.id, name = param.name, value = param.value, checked = param.checked, onChange = param.onChange, onClick = param.onClick, label = param.label, _param_subtitle = param.subtitle, subtitle = _param_subtitle === void 0 ? '' : _param_subtitle, justify = param.justify;
    var click = function() {
        if (onClick) onClick(checked);
    };
    var clsName = "flex items-start gap-2 cursor-pointer " + (justify ? justify : "");
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("label", {
        htmlFor: id,
        className: clsName,
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                type: "radio",
                id: id,
                name: name,
                value: value,
                checked: checked,
                onClick: click,
                onChange: onChange,
                className: "hidden"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "\n          w-6 h-6\n          rounded-full\n          border\n          flex-shrink-0\n          relative\n          cursor-pointer\n          ".concat(checked ? 'border-primary-500 z-radio-checked' : 'border-gray-400', "\n        ")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-col text-left leading-snug",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                        className: "text-sm font-medium text-white",
                        children: label
                    }),
                    subtitle && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                        className: "text-sm text-gray-400",
                        children: subtitle
                    })
                ]
            })
        ]
    });
};
var $6d2f2828e551a790$export$2e2bcd8739ae039 = $6d2f2828e551a790$var$RadioButton;


var $103e1568d31368e1$export$2e2bcd8739ae039 = (0, $6d2f2828e551a790$export$2e2bcd8739ae039);



parcelRequire("5s1kH");
var $cc8331b32d7a20e7$var$SurveyBadge = function(props) {
    var cls = "z-badge zb-";
    var text;
    var colorVal;
    if (props.type === "score") {
        if (props.value > 0.88) {
            text = props.lang === "sv" ? "Mycket h\xf6g" : "Very high";
            colorVal = 4;
        } else if (props.value > 0.76) {
            text = props.lang === "sv" ? "H\xf6g" : "High";
            colorVal = 3;
        } else if (props.value > 0.6) {
            text = props.lang === "sv" ? "M\xe5ttlig" : "Moderate";
            colorVal = 2;
        } else {
            text = props.lang === "sv" ? "L\xe5g" : "Low";
            colorVal = 1;
        }
    } else if (props.type === "gap") {
        if (props.value > 1.2) {
            text = props.lang === "sv" ? "Stort" : "Large";
            colorVal = 1;
        } else if (props.value > 0.8) {
            text = props.lang === "sv" ? "Tydligt" : "Clear";
            colorVal = 2;
        } else if (props.value > 0.4) {
            text = props.lang === "sv" ? "M\xe4rkbar" : "Noticeable";
            colorVal = 3;
        } else {
            text = props.lang === "sv" ? "Litet" : "Small";
            colorVal = 4;
        }
    } else if (props.type === "feedback_alignment") {
        if (props.value > 0.75) {
            text = props.lang === "sv" ? "Mycket h\xf6g" : "Very high";
            colorVal = 4;
        } else if (props.value > 0.5) {
            text = props.lang === "sv" ? "H\xf6g" : "High";
            colorVal = 3;
        } else if (props.value > 0.25) {
            text = props.lang === "sv" ? "Blandad" : "Mixed";
            colorVal = 2;
        } else if (props.value >= 0) {
            text = props.lang === "sv" ? "L\xe5g" : "Low";
            colorVal = 1;
        } else {
            text = "N/A";
            colorVal = 1;
        }
    } else if (props.type === "validated" && props.value2) {
        var limit = 4;
        if (props.max) {
            if (props.max === 10) limit = 8;
            else if (props.max === 7) limit = 6;
            else if (props.max === 3) limit = 2;
        }
        if (props.value2 >= limit) {
            if (props.value >= limit) {
                text = props.lang === "sv" ? "Validerad styrka" : "Validated strength";
                colorVal = 4;
            } else {
                text = props.lang === "sv" ? "Dold styrka" : "Hidden strength";
                colorVal = 3;
            }
        } else if (props.value >= limit) {
            text = props.lang === "sv" ? "Blinda f\xe4lt" : "Blind spot";
            colorVal = 2;
        } else {
            text = props.lang === "sv" ? "Utvecklingsfokus" : "Growth priority";
            colorVal = 1;
        }
    } else if (props.type === "self_only") {
        var limit1 = 4;
        if (props.max) {
            if (props.max === 10) limit1 = 8;
            else if (props.max === 7) limit1 = 6;
            else if (props.max === 3) limit1 = 2;
        }
        if (props.value >= limit1) {
            text = props.lang === "sv" ? "Styrka" : "Strength";
            colorVal = 4;
        } else {
            text = props.lang === "sv" ? "Utvecklingsfokus" : "Growth priority";
            colorVal = 1;
        }
    } else {
        text = "Unknown";
        colorVal = 1;
    }
    cls += colorVal;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: cls,
        title: text,
        children: text
    });
};
var $cc8331b32d7a20e7$export$2e2bcd8739ae039 = $cc8331b32d7a20e7$var$SurveyBadge;



parcelRequire("5s1kH");
var $200b3872b8c265f8$var$TwoBars = function(props) {
    var min = props.min ? props.min : 0;
    var max = props.max ? props.max : 5;
    var percent1 = 100 * props.value1 / (max - min);
    var percent2 = 100 * props.value2 / (max - min);
    var barWidth1 = percent1 + "%";
    var barWidth2 = percent2 + "%";
    var hClass = props.size === "small" ? "h-4" : "h-8";
    var barClass = props.size === "small" ? "h-2" : "h-4";
    var extraClass = props.className ? " " + props.className : "";
    var resultsStyle = {};
    var containerStyle = {
        borderRadius: "16px"
    };
    var resultsClass = "text-xs text-indigo-900 mr-2";
    if (percent1 < 5) {
        var leftP = percent1 + 2 + "%";
        resultsStyle = {
            left: leftP
        };
        resultsClass = "text-xs text-white absolute";
    }
    if (props.size === "small") {
        resultsClass += " text-xs";
        containerStyle = {
            borderRadius: "8px"
        };
    }
    var borderRadius1 = "16px 8px 8px 0";
    var borderRadius2 = "0 8px 8px 16px";
    if (props.value2 === 0) {
        barClass = props.size === "small" ? "h-4" : "h-8";
        borderRadius1 = "16px";
    }
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "bg-indigo-700 w-full " + hClass + extraClass,
        style: containerStyle,
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "bg-peach-500 flex items-center justify-end " + barClass,
                style: {
                    width: barWidth1,
                    borderRadius: borderRadius1
                },
                children: props.results1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: resultsClass,
                    style: resultsStyle,
                    children: props.results1
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "bg-peach-300 flex items-center justify-end " + barClass,
                style: {
                    width: barWidth2,
                    borderRadius: borderRadius2
                },
                children: props.results2 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: resultsClass,
                    style: resultsStyle,
                    children: props.results2
                })
            })
        ]
    });
};
var $200b3872b8c265f8$export$2e2bcd8739ae039 = $200b3872b8c265f8$var$TwoBars;



parcelRequire("5s1kH");

var $634501c911927d99$var$CheckBox = function(props) {
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "z-checkbox cursor-pointer" + (props.checked ? " checked" : ""),
        children: props.checked && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
            alt: "checked"
        })
    });
};
var $634501c911927d99$export$2e2bcd8739ae039 = $634501c911927d99$var$CheckBox;



parcelRequire("5s1kH");
var $f630b025744d4f80$var$ButtonMenu = function(param) {
    var items = param.items, selected = param.selected, selectKey = param.selectKey;
    var inactiveClasses = 'cursor-pointer hover:text-primary-400 opacity-70';
    // const activeClasses = 'underline underline-offset-8 text-primary-500'
    var activeClasses = 'bg-indigo-800';
    var click = function(item) {
        selectKey(item.key);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "flex items-center justify-between bg-indigo-700 rounded-full text-gray-100",
            style: {
                padding: 2
            },
            children: items.map(function(item, index) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "flex p-2 rounded-full justify-center items-center w-full " + (item.key === selected ? activeClasses : inactiveClasses),
                    onClick: function() {
                        return click(item);
                    },
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            item.iconUrl && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: item.iconUrl,
                                className: "h-4 mr-2",
                                alt: "icon"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "font-medium",
                                children: item.title
                            })
                        ]
                    })
                }, "tab_" + index);
            })
        })
    });
};
var $f630b025744d4f80$export$2e2bcd8739ae039 = $f630b025744d4f80$var$ButtonMenu;



parcelRequire("5s1kH");
var $dc3eefe01a987faf$var$RadioBox = function(props) {
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "z-radiobox",
        children: props.checked && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "z-radiobox-selected"
        })
    });
};
var $dc3eefe01a987faf$export$2e2bcd8739ae039 = $dc3eefe01a987faf$var$RadioBox;


var $ec5eaece43dbbc30$export$df8e15f2f64a263d = function(name, language, languageMap) {
    if (languageMap[language]) return languageMap[language];
    return name;
};


var $dd1549c769d2d4bf$var$VisionStatementDrafts = function(props) {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), categoryName = _useState2[0], setCategoryName = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), questions = _useState3[0], setQuestions = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), sections = _useState4[0], setSections = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), selectedSection = _useState5[0], setSelectedSection = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)("suggestion"), 2), selectedView = _useState6[0], setSelectedView = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), selectedQuestions = _useState7[0], setSelectedQuestions = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(5), 2), answerOptions = _useState8[0], setAnswerOptions = _useState8[1];
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        setSelectedSection("");
        setSelectedQuestions([]);
    }, [
        selectedView
    ]);
    var getData = function() {
        api.get("client/vision_statement_drafts/" + props.surveyId).then(function(response) {
            if (response.json.status === "ok") {
                setCategoryName(response.json.categoryName);
                setQuestions(response.json.questions);
                setSections(response.json.sections);
                setAnswerOptions(response.json.answerOptions);
            } else if (response.json.error) setError(response.json.error);
            else setError("Unknown error");
            setLoading(false);
        });
    };
    var saveCustomGoal = function() {
        var data = {
            selectedQuestionIds: selectedQuestions
        };
        api.post("client/vision_statement_create_manual/" + props.surveyId, data).then(function(response) {
            if (response.json.status === "ok") navigate("/dev-plan/long-term-goal/" + response.json.visionStatementId);
        });
    };
    if (loading) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (error.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    var selectSection = function(section) {
        setSelectedSection(section.id);
        var _selectedQuestions = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = section.questions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var question = _step.value;
                _selectedQuestions.push(question.id);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setSelectedQuestions(_selectedQuestions);
    };
    var renderSections = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-body1 mt-4",
                    children: lang === "sv" ? "V\xe4lj ett omr\xe5de att utg\xe5 fr\xe5n n\xe4r du skapar ditt m\xe5l." : "Select an area to start building your goal around."
                }),
                sections.map(function(section, nr) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 bg-indigo-800 rounded-md p-4 border-indigo-700 border",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                                                id: "draft_" + nr,
                                                name: "a_" + nr,
                                                label: "",
                                                value: section.id,
                                                checked: section.id === selectedSection,
                                                onChange: function() {
                                                    return selectSection(section);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "z-title1 cursor-pointer",
                                                onClick: function() {
                                                    return selectSection(section);
                                                },
                                                children: (0, $ec5eaece43dbbc30$export$df8e15f2f64a263d)(section.name, lang, section.translationsName)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "z-body2",
                                        children: [
                                            "Feedback: ",
                                            section.scoreOther.toFixed(1)
                                        ]
                                    })
                                ]
                            }),
                            selectedSection === section.id && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "w-full",
                                children: section.questions.map(function(question, i) {
                                    return renderQuestion(question);
                                })
                            })
                        ]
                    }, "section_" + section.id);
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    onClick: function() {
                        return saveCustomGoal();
                    },
                    className: "mt-6",
                    disabled: selectedQuestions.length === 0,
                    children: t("continue")
                })
            ]
        });
    };
    var toggleSelectedQuestion = function(questionId) {
        if (selectedView === "manual") setSelectedQuestions([
            questionId
        ]);
        else {
            var found = selectedQuestions.indexOf(questionId) > -1;
            if (found) {
                var _selectedQuestions = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = selectedQuestions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _qId = _step.value;
                        if (_qId !== questionId) _selectedQuestions.push(_qId);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                setSelectedQuestions(_selectedQuestions);
            } else {
                if (selectedQuestions.length >= 5) {
                    alert("You cannot select more than 5 questions");
                    return;
                }
                setSelectedQuestions((0, $XnYkK._)(selectedQuestions).concat([
                    questionId
                ]));
            }
        }
    };
    var questionDisabled = function(questionId) {
        if (selectedQuestions.length < 5) return "";
        if (selectedQuestions.indexOf(questionId) > -1) return "";
        return "opacity-50 pointer-events-none";
    };
    var renderQuestion = function(question) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4 bg-indigo-800 rounded-md p-4 border-indigo-700 border",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex items-center gap-x-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            onClick: function(e) {
                                return toggleSelectedQuestion(question.id);
                            },
                            className: questionDisabled(question.id),
                            children: selectedView === "manual" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $dc3eefe01a987faf$export$2e2bcd8739ae039), {
                                checked: selectedQuestions.indexOf(question.id) > -1
                            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $634501c911927d99$export$2e2bcd8739ae039), {
                                checked: selectedQuestions.indexOf(question.id) > -1
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            lang: lang,
                            type: "validated",
                            value: question.scoreSelf,
                            value2: question.scoreOther,
                            max: answerOptions
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-badge transparent",
                            children: question.focusAreaName
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-wrap gap-2 mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-half",
                            children: (0, $ec5eaece43dbbc30$export$df8e15f2f64a263d)(question.name, lang, question.translationsName)
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "z-half",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $200b3872b8c265f8$export$2e2bcd8739ae039), {
                                    value1: question.scoreSelf,
                                    value2: question.scoreOther,
                                    size: "small",
                                    max: answerOptions
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "mt-2 flex",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "text-sm",
                                            children: [
                                                t("self-assessment"),
                                                ": ",
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                    className: "z-title2",
                                                    children: question.scoreSelf.toFixed(1)
                                                }),
                                                "/",
                                                answerOptions
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "ml-4 text-sm",
                                            children: [
                                                "Feedback: ",
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                    className: "z-title2",
                                                    children: question.scoreOther === 0 ? "-" : question.scoreOther.toFixed(1)
                                                }),
                                                "/",
                                                answerOptions
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "ml-4 text-sm",
                                            children: [
                                                "Gap: ",
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                    className: "z-title2",
                                                    children: question.scoreOther === 0 ? "-" : Math.abs(question.scoreOther - question.scoreSelf).toFixed(1)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }, "q_" + question.id);
    };
    var renderManual = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "overflow-y-scroll mt-2 pb-2",
                    style: {
                        maxHeight: "calc(100dvh - 300px)"
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-body1",
                            children: lang === "sv" ? "V\xe4lj en fr\xe5ga att utg\xe5 fr\xe5n n\xe4r du bygger ditt m\xe5l." : "Select a question to start building your goal around."
                        }),
                        questions.map(function(question, i) {
                            return renderQuestion(question);
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 bg-indigo-800 relative",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-gradientback-model"
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    onClick: function() {
                        return saveCustomGoal();
                    },
                    className: "mt-2",
                    disabled: selectedQuestions.length === 0,
                    children: t("continue")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $f630b025744d4f80$export$2e2bcd8739ae039), {
                items: [
                    {
                        title: lang === "sv" ? "V\xe4lj fr\xe5n omr\xe5de" : "Select from areas",
                        key: "suggestion"
                    },
                    {
                        title: lang === "sv" ? "V\xe4lj fr\xe5n fr\xe5gor" : "Select from questions",
                        key: "manual"
                    }
                ],
                selected: selectedView,
                selectKey: setSelectedView
            }),
            selectedView === "manual" ? renderManual() : renderSections()
        ]
    });
};
var $dd1549c769d2d4bf$export$2e2bcd8739ae039 = $dd1549c769d2d4bf$var$VisionStatementDrafts;




var $cc7b352045a2b5c1$var$DevelopmentPlan = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), customerCategories = _useState1[0], setCustomerCategories = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), selectDrafts = _useState2[0], setSelectDrafts = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), ongoingActivities = _useState3[0], setOngoingActivities = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), surveyStatus = _useState4[0], setSurveyStatus = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), showActiveStandalone = _useState5[0], setShowActiveStandalone = _useState5[1];
    var mainButtons = 0; // Enumerate the main buttons and make sure only the first is primary
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (customerCategories.length > 0 && window.location.hash) {
            var hashParts = window.location.hash.split('_');
            if (hashParts.length === 2) {
                var what = hashParts[0];
                var hashId = hashParts[1];
                if (what === "#drafts") openDrafts(hashId);
                history.pushState("", document.title, window.location.pathname);
            }
        }
    }, [
        customerCategories
    ]);
    var openDrafts = function(_surveyId) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = customerCategories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var category = _step.value;
                if (category.surveys.length > 0) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = category.surveys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var survey = _step1.value;
                            if (survey.id === _surveyId) {
                                setSelectDrafts(survey);
                                return;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var getData = function() {
        api.get("client/dev-plan").then(function(response) {
            setCustomerCategories(response.json.customerCategories);
            setOngoingActivities(response.json.ongoingActivities);
            setLoaded(true);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {});
    var renderCustomerCategorySurveys = function(customerCategory) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            children: customerCategory.surveys.map(function(survey) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    children: renderCustomerCategorySurvey(customerCategory, survey)
                }, "category_survey_" + survey.id);
            })
        }, "cat_" + customerCategory.id);
    };
    var renderCustomerCategorySurvey = function(customerCategory, survey) {
        var lastSurveyRequest = undefined;
        if (survey.surveyRequest) lastSurveyRequest = survey.surveyRequest;
        var showSelectDrafts = survey.visionStatements.length > 0;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex items-center justify-between flex-wrap",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "p-2 rounded-lg bg-indigo-900",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($584664dac616447b$exports))),
                                        alt: "ico",
                                        className: "h-6 w-6"
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    className: "z-h3 ml-2",
                                    children: [
                                        (0, $c32e41a1c8ecb8c8$export$8f43a8af11ed514a)(lang, customerCategory.name_sv, customerCategory.name),
                                        customerCategory.surveys.length > 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                            children: [
                                                ": ",
                                                survey.name
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex",
                            children: [
                                survey.lastReportId && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: "transparentBase",
                                        size: "sm",
                                        onClick: function() {
                                            return navigate("/dev-plan/survey/result/" + survey.lastReportId + "/summary");
                                        },
                                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($584664dac616447b$exports))),
                                            alt: "info",
                                            className: "h-4 w-4"
                                        }),
                                        style: {
                                            width: "unset"
                                        },
                                        children: lang === "sv" ? "Se insiktsrapport" : "See the insights report"
                                    })
                                }),
                                showSelectDrafts && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: "transparentBase",
                                        className: "mx-auto cursor-pointer",
                                        size: "sm",
                                        onClick: function() {
                                            return setSelectDrafts(survey);
                                        },
                                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8035c9bf788700b7$exports))),
                                            alt: "info",
                                            className: "h-4 w-4"
                                        }),
                                        style: {
                                            width: "unset"
                                        },
                                        children: lang === "sv" ? "L\xe4gg till m\xe5l" : "Add new goal"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c8483606065062df$export$2e2bcd8739ae039), {
                        active: surveyStatus.indexOf(survey.id) > -1 ? 1 : 0,
                        items: [
                            {
                                title: t("ongoing"),
                                callback: function() {
                                    return changeTab(survey.id, 0);
                                }
                            },
                            {
                                title: t("completed"),
                                callback: function() {
                                    return changeTab(survey.id, 1);
                                }
                            }
                        ]
                    })
                }),
                survey.visionStatements.length > 0 ? renderVisionStatements(survey) : renderSurveyRequest(survey, lastSurveyRequest)
            ]
        });
    };
    var changeTab = function(surveyId, nr) {
        if (nr > 0) setSurveyStatus((0, $XnYkK._)(surveyStatus).concat([
            surveyId
        ]));
        else {
            var _surveyStatus = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = surveyStatus[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sId = _step.value;
                    if (sId !== surveyId) _surveyStatus.push(sId);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            setSurveyStatus(_surveyStatus);
        }
    };
    var createVisionStatement = function(categoryId) {
        api.get("client/vision_statement_create/" + categoryId).then(function(response) {
            if (response.json.status === "ok") navigate("/dev-plan/long-term-goal/" + response.json.id);
        });
    };
    var renderCustomerCategoryNoSurvey = function(customerCategory) {
        var hasVisionStatements = customerCategory.visionStatements.length > 0;
        if (!hasVisionStatements) mainButtons++;
        var showOnGoing = surveyStatus.indexOf(customerCategory.id) < 0;
        var showVisionStatements = customerCategory.visionStatements.filter(function(a) {
            if (showOnGoing) return a.progress !== 100;
            else return a.progress === 100;
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "p-2 rounded-lg bg-indigo-900",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8db086155ef696e2$exports))),
                                        alt: "ico",
                                        className: "h-6 w-6"
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-h3 ml-2",
                                    children: (0, $c32e41a1c8ecb8c8$export$8f43a8af11ed514a)(lang, customerCategory.name_sv, customerCategory.name)
                                })
                            ]
                        }),
                        hasVisionStatements && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: "transparentBase",
                                className: "mt-4 mx-auto cursor-pointer",
                                size: "sm",
                                onClick: function() {
                                    return createVisionStatement(customerCategory.id);
                                },
                                leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8035c9bf788700b7$exports))),
                                    alt: "info",
                                    className: "h-4 w-4"
                                }),
                                style: {
                                    width: "unset"
                                },
                                children: lang === "sv" ? "L\xe4gg till m\xe5l" : "Add new goal"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c8483606065062df$export$2e2bcd8739ae039), {
                        active: showOnGoing ? 0 : 1,
                        items: [
                            {
                                title: t("ongoing"),
                                callback: function() {
                                    return changeTab(customerCategory.id, 0);
                                }
                            },
                            {
                                title: t("completed"),
                                callback: function() {
                                    return changeTab(customerCategory.id, 1);
                                }
                            }
                        ]
                    })
                }),
                showVisionStatements.length > 0 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: showVisionStatements.sort(function(a, b) {
                        return sortVisionStatements(a, b);
                    }).map(function(visionStatement) {
                        if (visionStatement.status === (0, $dffa8b95bfc7c1d5$export$f269ae6352e55a31).Saved) mainButtons++;
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e8ccb00b12433a14$export$2e2bcd8739ae039), {
                                visionStatement: visionStatement,
                                nr: 0,
                                mainButtons: mainButtons
                            })
                        }, "vs_a_" + visionStatement.id);
                    })
                }) : showOnGoing ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "rounded-md border border-indigo-700 border-dashed p-8 mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($dee60dcbfbf05c09$exports))),
                                alt: "rings",
                                className: "h-8 w-8 mx-auto"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "mt-4",
                                children: !hasVisionStatements ? lang === "sv" ? "B\xf6rja din utvecklinsresa" : "Start your development journey" : lang === "sv" ? "Inga p\xe5g\xe5ende m\xe5l" : "No ongoing goals"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: mainButtons > 1 ? "outlineWhiteBase" : "blueBase",
                                className: "mt-4 mx-auto",
                                style: {
                                    width: "unset"
                                },
                                onClick: function() {
                                    return createVisionStatement(customerCategory.id);
                                },
                                children: [
                                    t("create"),
                                    " ",
                                    t("vision_statement")
                                ]
                            })
                        ]
                    })
                }) : renderThingsWillAppear(lang === "sv" ? "m\xe5l" : "goals")
            ]
        }, "category_" + customerCategory.id);
    };
    var showSelectDrafts = function() {
        if (!selectDrafts) {
            alert("Error - missing survey");
            return null;
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: function() {
                return setSelectDrafts(null);
            },
            size: "wide",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return setSelectDrafts(null);
                    },
                    children: lang === "sv" ? "Nytt m\xe5l" : "New goal"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $dd1549c769d2d4bf$export$2e2bcd8739ae039), {
                        surveyId: selectDrafts.id,
                        update: function() {
                            getData();
                            setSelectDrafts(null);
                        }
                    })
                })
            ]
        });
    };
    var sortVisionStatements = function(a, b) {
        // Complex! Sort items without deadline last if completed, else first
        // Sort saved before created
        // Sort completed with oldest deadline last
        // Sort ongoing with oldest deadline first
        if (a.status !== b.status) return a.status > b.status ? -1 : 1;
        if (!a.deadline) return a.progress === 100 ? 1 : -1;
        if (!b.deadline) return -1;
        if (a.progress === 100 && b.progress !== 100) return 1;
        if (a.progress !== 100 && b.progress === 100) return -1;
        if (a.progress === 100 && b.progress === 100) return a.deadline > b.deadline ? -1 : 1;
        else return a.deadline > b.deadline ? 1 : -1;
    };
    var renderVisionStatements = function(survey) {
        var hasStarted = false;
        var showCompleted = surveyStatus.indexOf(survey.id) > -1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = survey.visionStatements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var visionStatement = _step.value;
                if (visionStatement.status !== (0, $dffa8b95bfc7c1d5$export$f269ae6352e55a31).None) {
                    hasStarted = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!hasStarted && surveyStatus.indexOf(survey.id) > -1) // Tab "completed"
        return renderThingsWillAppear(lang === "sv" ? "m\xe5l" : "goals");
        if (!hasStarted) {
            mainButtons++;
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "text-center  rounded-md border border-indigo-700 border-dashed p-8 mt-3",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dee60dcbfbf05c09$exports))),
                        alt: "star",
                        className: "h-8 w-8 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mt-4",
                        children: lang === "sv" ? "Skapa m\xe5l baserat p\xe5 ditt resultat" : "Create goal based on your result"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: mainButtons < 2 ? "blueBase" : "outlineWhiteBase",
                        className: "mt-4 mx-auto",
                        style: {
                            width: "unset"
                        },
                        onClick: function() {
                            return setSelectDrafts(survey);
                        },
                        children: lang === "sv" ? "L\xe4gg till m\xe5l" : "Add goal"
                    })
                ]
            });
        }
        var visionStatements = survey.visionStatements.filter(function(vs) {
            return vs.status !== (0, $dffa8b95bfc7c1d5$export$f269ae6352e55a31).None;
        }).filter(function(vs) {
            return showCompleted && vs.progress === 100 || !showCompleted && vs.progress !== 100;
        });
        if (visionStatements.length === 0) {
            if (showCompleted) return renderThingsWillAppear(lang === "sv" ? "m\xe5l" : "goals");
            else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "text-center my-8",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dee60dcbfbf05c09$exports))),
                        alt: "rings",
                        className: "h-8 w-8 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mt-4",
                        children: lang === "sv" ? "Inga p\xe5g\xe5ende m\xe5l" : "No ongoing goals"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: mainButtons < 2 ? "blueBase" : "outlineWhiteBase",
                        className: "mt-4 mx-auto",
                        style: {
                            width: "unset"
                        },
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($da0736b1a8f82dc0$exports))),
                            alt: "plus"
                        }),
                        onClick: function() {
                            return setSelectDrafts(survey);
                        },
                        children: lang === "sv" ? "L\xe4gg till m\xe5l" : "Add new goal"
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: visionStatements.sort(function(a, b) {
                return sortVisionStatements(a, b);
            }).map(function(visionStatement) {
                // Toggled by tab selection
                if (visionStatement.status === (0, $dffa8b95bfc7c1d5$export$f269ae6352e55a31).Saved) mainButtons++;
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e8ccb00b12433a14$export$2e2bcd8739ae039), {
                        visionStatement: visionStatement,
                        nr: 0,
                        mainButtons: mainButtons
                    })
                }, "vs_b_" + visionStatement.id);
            })
        });
    };
    var renderMainButton = function(txt, link) {
        mainButtons++;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
            buttonType: mainButtons < 2 ? "blueBase" : "outlineWhiteBase",
            className: "mt-4 mx-auto",
            style: {
                width: "unset"
            },
            rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: mainButtons < 2 ? (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($005104c16715d72c$exports))),
                alt: "right"
            }),
            onClick: function() {
                return navigate(link);
            },
            children: txt
        });
    };
    var renderThingsWillAppear = function(type) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "text-center rounded-md border border-indigo-700 border-dashed p-8 mt-3",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($56a45d7fe590023a$exports))),
                    alt: "star",
                    className: "h-6 w-6 mx-auto"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                    className: "mt-4",
                    children: [
                        lang === "sv" ? "Dina f\xe4rdiga" : "Your completed",
                        "\xa0",
                        type,
                        "\xa0",
                        lang === "sv" ? "kommer visas h\xe4r." : "will show up here."
                    ]
                })
            ]
        });
    };
    var renderSurveyRequest = function(survey, surveyRequest) {
        if (survey) {
            if (surveyStatus.indexOf(survey.id) > -1) return renderThingsWillAppear(lang === "sv" ? "m\xe5l" : "goals");
            else {
                if (surveyRequest && surveyRequest.completed) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "text-center rounded-md border border-indigo-700 border-dashed p-8 mt-3",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($dee60dcbfbf05c09$exports))),
                            alt: "star",
                            className: "h-8 w-8 mx-auto"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "mt-4",
                            children: lang === "sv" ? "Skapa m\xe5l baserat p\xe5 ditt resultat" : "Create goal based on your result"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: mainButtons < 2 ? "blueBase" : "outlineWhiteBase",
                            className: "mt-4 mx-auto",
                            style: {
                                width: "unset"
                            },
                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($da0736b1a8f82dc0$exports))),
                                alt: "plus"
                            }),
                            onClick: function() {
                                return setSelectDrafts(survey);
                            },
                            children: lang === "sv" ? "L\xe4gg till m\xe5l" : "Add goal"
                        })
                    ]
                });
                else if (!surveyRequest || survey.pendingResponseId || survey.canInvite || surveyRequest.status === "failed") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "text-center rounded-md border border-indigo-700 border-dashed p-8 mt-3",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fc5a845596f1e4c9$exports))),
                            alt: "star",
                            className: "h-8 w-8 mx-auto"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "mt-4",
                            children: lang === "sv" ? "Se var du st\xe5r - och var du kan utvecklas" : "See where you stand - and where to grow"
                        }),
                        renderMainButton(lang === "sv" ? "G\xe5 till m\xe4tningar" : "Go to Assessments", "/assessments")
                    ]
                });
                else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "text-center rounded-md border border-indigo-700 border-dashed p-8 mt-3",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fc5a845596f1e4c9$exports))),
                            alt: "star",
                            className: "h-8 w-8 mx-auto"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "mt-4",
                            children: lang === "sv" ? "Din insiktsrapport \xe4r snart redo." : "Your insights report is pending."
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            className: "mt-2",
                            children: [
                                lang === "sv" ? "Vi meddelar dig via e-post n\xe4r det \xe4r klart, troligen senast " : "We'll notify you by email when it's ready, likely by ",
                                surveyRequest.deadline.substring(0, 10)
                            ]
                        })
                    ]
                });
            }
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            children: "Nothing here!"
        });
    };
    var renderOngoing = function() {
        var todayDate = new Date();
        var showOngoingActivities = ongoingActivities.filter(function(a) {
            return showActiveStandalone ? !a.completed : a.completed;
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex items-center mt-6",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "p-2 rounded-lg bg-indigo-900",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cb70cc925ae09565$exports))),
                                alt: "ico",
                                className: "h-6 w-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "ml-2 z-h3",
                            children: lang === "sv" ? "Frist\xe5ende AI coaching" : "Standalone AI coaching"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c8483606065062df$export$2e2bcd8739ae039), {
                        active: showActiveStandalone ? 0 : 1,
                        items: [
                            {
                                title: t("ongoing"),
                                callback: function() {
                                    return setShowActiveStandalone(true);
                                }
                            },
                            {
                                title: t("completed"),
                                callback: function() {
                                    return setShowActiveStandalone(false);
                                }
                            }
                        ]
                    })
                }),
                showOngoingActivities.length === 0 ? showActiveStandalone ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "rounded-md border border-indigo-700 border-dashed p-8 mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cb70cc925ae09565$exports))),
                                alt: "ai",
                                className: "mt-4 h-6 w-6 mx-auto"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "mt-4",
                                children: ongoingActivities.length > 0 ? lang === "sv" ? "Inga p\xe5g\xe5ende aktiveter" : "No ongoing activities" : lang === "sv" ? "Aktivititeter skapade med Frist\xe5ende AI coaching visas h\xe4r" : "Activities created with Standalone AI coaching appear here"
                            })
                        ]
                    })
                }) : renderThingsWillAppear(lang === "sv" ? "aktiviteter" : "activities") : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: showOngoingActivities.sort(function(a, b) {
                        // Complex! Sort items without deadline last if completed, else first
                        // Sort completed with oldest deadline last
                        // Sort not ongoing with oldest deadline first
                        if (!a.deadline) return a.completed ? 1 : -1;
                        if (!b.deadline) return -1;
                        if (a.completed && !b.completed) return 1;
                        if (!a.completed && b.completed) return -1;
                        if (a.completed && b.completed) return a.deadline > b.deadline ? -1 : 1;
                        else return a.deadline > b.deadline ? 1 : -1;
                    }).map(function(ongoing) {
                        var isDue = false;
                        if (ongoing.deadline && !ongoing.completed) {
                            var deadline = new Date(ongoing.deadline);
                            if (deadline < todayDate) isDue = true;
                        }
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "bg-indigo-800 border-indigo-700 border p-4 pl-7 mt-2 rounded-md hover:bg-indigo-700 cursor-pointer relative",
                            onClick: function() {
                                return navigate("/tasks/" + ongoing.id);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-action-color bg-peach-600"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex justify-between text-gray-400 font-medium",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "text-gray-400 font-medium mr-2",
                                                    children: ongoing.title
                                                }),
                                                ongoing.completed && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3d60ab5b0b00a842$export$2e2bcd8739ae039), {
                                                    text: lang === "sv" ? "Klar" : "Completed",
                                                    color: "green",
                                                    size: "small"
                                                })
                                            ]
                                        }),
                                        ongoing.deadline && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "text-sm ml-4",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                    className: "text-gray-100",
                                                    children: [
                                                        t("due-date"),
                                                        ":\xa0"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                    className: "text-gray-400",
                                                    children: ongoing.deadline.substring(0, 10)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isDue && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
                                    message: lang === "sv" ? "Slutdatumet \xe4r h\xe4r - uppdatera din status" : "Due date is here - update progress"
                                })
                            ]
                        }, "ongoing_" + ongoing.id);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "z-h2 mt-6",
                children: t("long-term-goals")
            }),
            customerCategories.map(function(customerCategory) {
                if (customerCategory.surveys.length > 0) return renderCustomerCategorySurveys(customerCategory);
                else return renderCustomerCategoryNoSurvey(customerCategory);
            }),
            selectDrafts && showSelectDrafts(),
            renderOngoing(),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4",
                children: "\xa0"
            })
        ]
    });
};
var $cc7b352045a2b5c1$export$2e2bcd8739ae039 = $cc7b352045a2b5c1$var$DevelopmentPlan;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");

var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $54Czb = parcelRequire("54Czb");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");

var $5s1kH = parcelRequire("5s1kH");

var $03bAP = parcelRequire("03bAP");
function $2f0a3b5636e7a66d$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == (typeof e === "undefined" ? "undefined" : (0, $03bAP._)(e))) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $2f0a3b5636e7a66d$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $2f0a3b5636e7a66d$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $2f0a3b5636e7a66d$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $2f0a3b5636e7a66d$export$2e2bcd8739ae039 = $2f0a3b5636e7a66d$export$4f5d2d50c9deca37;


"use client";
var $69c96f0c9b63d8d4$var$L = function(t) {
    return typeof t == "number" && !isNaN(t);
}, $69c96f0c9b63d8d4$var$N = function(t) {
    return typeof t == "string";
}, $69c96f0c9b63d8d4$var$P = function(t) {
    return typeof t == "function";
}, $69c96f0c9b63d8d4$var$ut = function(t) {
    return $69c96f0c9b63d8d4$var$N(t) || $69c96f0c9b63d8d4$var$L(t);
}, $69c96f0c9b63d8d4$var$z = function(t) {
    return $69c96f0c9b63d8d4$var$N(t) || $69c96f0c9b63d8d4$var$P(t) ? t : null;
}, $69c96f0c9b63d8d4$var$yt = function(t, o) {
    return t === !1 || $69c96f0c9b63d8d4$var$L(t) && t > 0 ? t : o;
}, $69c96f0c9b63d8d4$var$F = function(t) {
    return (0, $5s1kH.isValidElement)(t) || $69c96f0c9b63d8d4$var$N(t) || $69c96f0c9b63d8d4$var$P(t) || $69c96f0c9b63d8d4$var$L(t);
};
function $69c96f0c9b63d8d4$export$184cca501f1aed7f(t, o) {
    var e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 300;
    var r = t.scrollHeight, a = t.style;
    requestAnimationFrame(function() {
        a.minHeight = "initial", a.height = r + "px", a.transition = "all ".concat(e, "ms"), requestAnimationFrame(function() {
            a.height = "0", a.padding = "0", a.margin = "0", setTimeout(o, e);
        });
    });
}
function $69c96f0c9b63d8d4$export$3ff7dc44d332d222(param) {
    var t = param.enter, o = param.exit, tmp = param.appendPosition, e = tmp === void 0 ? !1 : tmp, tmp1 = param.collapse, r = tmp1 === void 0 ? !0 : tmp1, tmp2 = param.collapseDuration, a = tmp2 === void 0 ? 300 : tmp2;
    return function(param) {
        var s = param.children, f = param.position, c = param.preventExitTransition, T = param.done, g = param.nodeRef, v = param.isIn, x = param.playToast;
        var C = e ? "".concat(t, "--").concat(f) : t, S = e ? "".concat(o, "--").concat(f) : o, E = (0, $5s1kH.useRef)(0);
        return (0, $5s1kH.useLayoutEffect)(function() {
            var _d_classList;
            var d = g.current, p = C.split(" "), b = function(n) {
                var _d_classList;
                n.target === g.current && (x(), d.removeEventListener("animationend", b), d.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && (_d_classList = d.classList).remove.apply(_d_classList, (0, $XnYkK._)(p)));
            };
            (_d_classList = d.classList).add.apply(_d_classList, (0, $XnYkK._)(p)), d.addEventListener("animationend", b), d.addEventListener("animationcancel", b);
        }, []), (0, $5s1kH.useEffect)(function() {
            var d = g.current, p = function() {
                d.removeEventListener("animationend", p), r ? $69c96f0c9b63d8d4$export$184cca501f1aed7f(d, T, a) : T();
            };
            v || (c ? p() : (E.current = 1, d.className += " ".concat(S), d.addEventListener("animationend", p)));
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Fragment, null, s);
    };
}
function $69c96f0c9b63d8d4$var$tt(t, o) {
    return {
        content: $69c96f0c9b63d8d4$var$ot(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $69c96f0c9b63d8d4$var$ot(t, o) {
    var e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    return (0, $5s1kH.isValidElement)(t) && !$69c96f0c9b63d8d4$var$N(t.type) ? (0, $5s1kH.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $69c96f0c9b63d8d4$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $69c96f0c9b63d8d4$var$gt(param) {
    var t = param.closeToast, o = param.theme, tmp = param.ariaLabel, e = tmp === void 0 ? "close" : tmp;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
        className: "Toastify__close-button Toastify__close-button--".concat(o),
        type: "button",
        onClick: function(r) {
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $69c96f0c9b63d8d4$var$bt(param) {
    var t = param.delay, o = param.isRunning, e = param.closeToast, tmp = param.type, r = tmp === void 0 ? "default" : tmp, a = param.hide, l = param.className, s = param.controlledProgress, f = param.progress, c = param.rtl, T = param.isIn, g = param.theme;
    var v = a || s && f === 0, x = {
        animationDuration: "".concat(t, "ms"),
        animationPlayState: o ? "running" : "paused"
    };
    s && (x.transform = "scaleX(".concat(f, ")"));
    var C = (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)("Toastify__progress-bar", s ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar-theme--".concat(g), "Toastify__progress-bar--".concat(r), (0, $dUlz9._)({}, "Toastify__progress-bar--rtl", c)), S = $69c96f0c9b63d8d4$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)(C, l), E = (0, $dUlz9._)({}, s && f >= 1 ? "onTransitionEnd" : "onAnimationEnd", s && f < 1 ? null : function() {
        T && e();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        className: "Toastify__progress-bar--bg Toastify__progress-bar-theme--".concat(g, " Toastify__progress-bar--").concat(r)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", (0, $hwO3w._)({
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        "aria-valuenow": s ? Math.round(f * 100) : void 0,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        className: S,
        style: x
    }, E)));
}
var $69c96f0c9b63d8d4$var$Qt = 1, $69c96f0c9b63d8d4$var$st = function() {
    return "".concat($69c96f0c9b63d8d4$var$Qt++);
};
function $69c96f0c9b63d8d4$var$vt(t, o, e) {
    var r = 1, a = 0, l = [], s = [], f = o, c = new Map, T = new Set, g = function(i) {
        return T.add(i), function() {
            return T.delete(i);
        };
    }, v = function() {
        s = Array.from(c.values()), T.forEach(function(i) {
            return i();
        });
    }, x = function(param) {
        var i = param.containerId, n = param.toastId, u = param.updateId;
        var h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = function(i, n) {
        c.forEach(function(u) {
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = function(i) {
        var n, u;
        i.isActive && ((u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1, e($69c96f0c9b63d8d4$var$tt(i, "removed")));
    }, E = function(i) {
        if (i == null) c.forEach(S);
        else {
            var n = c.get(i);
            n && S(n);
        }
        v();
    }, d = function() {
        a -= l.length, l = [];
    }, p = function(i) {
        var m, _;
        var _i_props = i.props, n = _i_props.toastId, u = _i_props.updateId, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($69c96f0c9b63d8d4$var$tt(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: f,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: d,
        buildToast: function(i, n) {
            if (x(n)) return;
            var u = n.toastId, h = n.updateId, m = n.data, _ = n.staleId, k = n.delay, D = h == null;
            D && a++;
            var A = (0, $lf4fc._)((0, $hwO3w._)((0, $lf4fc._)((0, $hwO3w._)({}, f), {
                style: f.toastStyle,
                key: r++
            }), Object.fromEntries(Object.entries(n).filter(function(param) {
                var _param = (0, $6iP9u._)(param, 2), M = _param[0], $ = _param[1];
                return $ != null;
            }))), {
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $69c96f0c9b63d8d4$var$z(n.className || f.toastClassName),
                progressClassName: $69c96f0c9b63d8d4$var$z(n.progressClassName || f.progressClassName),
                autoClose: n.isLoading ? !1 : $69c96f0c9b63d8d4$var$yt(n.autoClose, f.autoClose),
                closeToast: function(M) {
                    var $ = c.get(u);
                    $ && ($.removalReason = M, E(u));
                },
                deleteToast: function() {
                    if (c.get(u) != null) {
                        if (c.delete(u), a--, a < 0 && (a = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            });
            A.closeButton = f.closeButton, n.closeButton === !1 || $69c96f0c9b63d8d4$var$F(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $69c96f0c9b63d8d4$var$F(f.closeButton) ? f.closeButton : !0);
            var B = {
                content: i,
                props: A,
                staleId: _
            };
            f.limit && f.limit > 0 && a > f.limit && D ? l.push(B) : $69c96f0c9b63d8d4$var$L(k) ? setTimeout(function() {
                p(B);
            }, k) : p(B);
        },
        setProps: function(i) {
            f = i;
        },
        setToggle: function(i, n) {
            var u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: function(i) {
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: function() {
            return s;
        }
    };
}
var $69c96f0c9b63d8d4$var$I = new Map, $69c96f0c9b63d8d4$var$U = [], $69c96f0c9b63d8d4$var$rt = new Set, $69c96f0c9b63d8d4$var$Wt = function(t) {
    return $69c96f0c9b63d8d4$var$rt.forEach(function(o) {
        return o(t);
    });
}, $69c96f0c9b63d8d4$var$ht = function() {
    return $69c96f0c9b63d8d4$var$I.size > 0;
};
function $69c96f0c9b63d8d4$var$Gt() {
    $69c96f0c9b63d8d4$var$U.forEach(function(t) {
        return $69c96f0c9b63d8d4$var$nt(t.content, t.options);
    }), $69c96f0c9b63d8d4$var$U = [];
}
var $69c96f0c9b63d8d4$var$Ct = function(t, param) {
    var o = param.containerId;
    var e;
    return (e = $69c96f0c9b63d8d4$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $69c96f0c9b63d8d4$var$X(t, o) {
    var r;
    if (o) return !!((r = $69c96f0c9b63d8d4$var$I.get(o)) != null && r.isToastActive(t));
    var e = !1;
    return $69c96f0c9b63d8d4$var$I.forEach(function(a) {
        a.isToastActive(t) && (e = !0);
    }), e;
}
function $69c96f0c9b63d8d4$var$xt(t) {
    if (!$69c96f0c9b63d8d4$var$ht()) {
        $69c96f0c9b63d8d4$var$U = $69c96f0c9b63d8d4$var$U.filter(function(o) {
            return t != null && o.options.toastId !== t;
        });
        return;
    }
    if (t == null || $69c96f0c9b63d8d4$var$ut(t)) $69c96f0c9b63d8d4$var$I.forEach(function(o) {
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        var o = $69c96f0c9b63d8d4$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $69c96f0c9b63d8d4$var$I.forEach(function(e) {
            e.removeToast(t.id);
        });
    }
}
var $69c96f0c9b63d8d4$var$Et = function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    $69c96f0c9b63d8d4$var$I.forEach(function(o) {
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $69c96f0c9b63d8d4$var$nt(t, o) {
    $69c96f0c9b63d8d4$var$F(t) && ($69c96f0c9b63d8d4$var$ht() || $69c96f0c9b63d8d4$var$U.push({
        content: t,
        options: o
    }), $69c96f0c9b63d8d4$var$I.forEach(function(e) {
        e.buildToast(t, o);
    }));
}
function $69c96f0c9b63d8d4$var$Pt(t) {
    var o;
    (o = $69c96f0c9b63d8d4$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $69c96f0c9b63d8d4$var$it(t, o) {
    $69c96f0c9b63d8d4$var$I.forEach(function(e) {
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $69c96f0c9b63d8d4$var$It(t) {
    var o = t.containerId || 1;
    return {
        subscribe: function(e) {
            var r = $69c96f0c9b63d8d4$var$vt(o, t, $69c96f0c9b63d8d4$var$Wt);
            $69c96f0c9b63d8d4$var$I.set(o, r);
            var a = r.observe(e);
            return $69c96f0c9b63d8d4$var$Gt(), function() {
                a(), $69c96f0c9b63d8d4$var$I.delete(o);
            };
        },
        setProps: function(e) {
            var r;
            (r = $69c96f0c9b63d8d4$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot: function() {
            var e;
            return (e = $69c96f0c9b63d8d4$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $69c96f0c9b63d8d4$var$St(t) {
    return $69c96f0c9b63d8d4$var$rt.add(t), function() {
        $69c96f0c9b63d8d4$var$rt.delete(t);
    };
}
function $69c96f0c9b63d8d4$var$qt(t) {
    return t && ($69c96f0c9b63d8d4$var$N(t.toastId) || $69c96f0c9b63d8d4$var$L(t.toastId)) ? t.toastId : $69c96f0c9b63d8d4$var$st();
}
function $69c96f0c9b63d8d4$var$H(t, o) {
    return $69c96f0c9b63d8d4$var$nt(t, o), o.toastId;
}
function $69c96f0c9b63d8d4$var$Q(t, o) {
    return (0, $lf4fc._)((0, $hwO3w._)({}, o), {
        type: o && o.type || t,
        toastId: $69c96f0c9b63d8d4$var$qt(o)
    });
}
function $69c96f0c9b63d8d4$var$W(t) {
    return function(o, e) {
        return $69c96f0c9b63d8d4$var$H(o, $69c96f0c9b63d8d4$var$Q(t, e));
    };
}
function $69c96f0c9b63d8d4$export$b410431fab84fa58(t, o) {
    return $69c96f0c9b63d8d4$var$H(t, $69c96f0c9b63d8d4$var$Q("default", o));
}
$69c96f0c9b63d8d4$export$b410431fab84fa58.loading = function(t, o) {
    return $69c96f0c9b63d8d4$var$H(t, $69c96f0c9b63d8d4$var$Q("default", (0, $hwO3w._)({
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1
    }, o)));
};
function $69c96f0c9b63d8d4$var$Kt(t, param, a) {
    var o = param.pending, e = param.error, r = param.success;
    var l;
    o && (l = $69c96f0c9b63d8d4$var$N(o) ? $69c96f0c9b63d8d4$export$b410431fab84fa58.loading(o, a) : $69c96f0c9b63d8d4$export$b410431fab84fa58.loading(o.render, (0, $hwO3w._)({}, a, o)));
    var s = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, f = function(T, g, v) {
        if (g == null) {
            $69c96f0c9b63d8d4$export$b410431fab84fa58.dismiss(l);
            return;
        }
        var x = (0, $lf4fc._)((0, $hwO3w._)({
            type: T
        }, s, a), {
            data: v
        }), C = $69c96f0c9b63d8d4$var$N(g) ? {
            render: g
        } : g;
        return l ? $69c96f0c9b63d8d4$export$b410431fab84fa58.update(l, (0, $hwO3w._)({}, x, C)) : $69c96f0c9b63d8d4$export$b410431fab84fa58(C.render, (0, $hwO3w._)({}, x, C)), v;
    }, c = $69c96f0c9b63d8d4$var$P(t) ? t() : t;
    return c.then(function(T) {
        return f("success", r, T);
    }).catch(function(T) {
        return f("error", e, T);
    }), c;
}
$69c96f0c9b63d8d4$export$b410431fab84fa58.promise = $69c96f0c9b63d8d4$var$Kt;
$69c96f0c9b63d8d4$export$b410431fab84fa58.success = $69c96f0c9b63d8d4$var$W("success");
$69c96f0c9b63d8d4$export$b410431fab84fa58.info = $69c96f0c9b63d8d4$var$W("info");
$69c96f0c9b63d8d4$export$b410431fab84fa58.error = $69c96f0c9b63d8d4$var$W("error");
$69c96f0c9b63d8d4$export$b410431fab84fa58.warning = $69c96f0c9b63d8d4$var$W("warning");
$69c96f0c9b63d8d4$export$b410431fab84fa58.warn = $69c96f0c9b63d8d4$export$b410431fab84fa58.warning;
$69c96f0c9b63d8d4$export$b410431fab84fa58.dark = function(t, o) {
    return $69c96f0c9b63d8d4$var$H(t, $69c96f0c9b63d8d4$var$Q("default", (0, $hwO3w._)({
        theme: "dark"
    }, o)));
};
function $69c96f0c9b63d8d4$var$Yt(t) {
    $69c96f0c9b63d8d4$var$xt(t);
}
$69c96f0c9b63d8d4$export$b410431fab84fa58.dismiss = $69c96f0c9b63d8d4$var$Yt;
$69c96f0c9b63d8d4$export$b410431fab84fa58.clearWaitingQueue = $69c96f0c9b63d8d4$var$Et;
$69c96f0c9b63d8d4$export$b410431fab84fa58.isActive = $69c96f0c9b63d8d4$var$X;
$69c96f0c9b63d8d4$export$b410431fab84fa58.update = function(t) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var e = $69c96f0c9b63d8d4$var$Ct(t, o);
    if (e) {
        var r = e.props, a = e.content, l = (0, $lf4fc._)((0, $hwO3w._)({
            delay: 100
        }, r, o), {
            toastId: o.toastId || t,
            updateId: $69c96f0c9b63d8d4$var$st()
        });
        l.toastId !== t && (l.staleId = t);
        var s = l.render || a;
        delete l.render, $69c96f0c9b63d8d4$var$H(s, l);
    }
};
$69c96f0c9b63d8d4$export$b410431fab84fa58.done = function(t) {
    $69c96f0c9b63d8d4$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$69c96f0c9b63d8d4$export$b410431fab84fa58.onChange = $69c96f0c9b63d8d4$var$St;
$69c96f0c9b63d8d4$export$b410431fab84fa58.play = function(t) {
    return $69c96f0c9b63d8d4$var$it(!0, t);
};
$69c96f0c9b63d8d4$export$b410431fab84fa58.pause = function(t) {
    return $69c96f0c9b63d8d4$var$it(!1, t);
};
function $69c96f0c9b63d8d4$var$kt(t) {
    var s;
    var _jt_current = (0, $5s1kH.useRef)($69c96f0c9b63d8d4$var$It(t)).current, o = _jt_current.subscribe, e = _jt_current.getSnapshot, r = _jt_current.setProps;
    r(t);
    var a = (s = (0, $5s1kH.useSyncExternalStore)(o, e, e)) == null ? void 0 : s.slice();
    function l(f) {
        if (!a) return [];
        var c = new Map;
        return t.newestOnTop && a.reverse(), a.forEach(function(T) {
            var _T_props = T.props, g = _T_props.position;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, function(T) {
            return f(T[0], T[1]);
        });
    }
    return {
        getToastToRender: l,
        isToastActive: $69c96f0c9b63d8d4$var$X,
        count: a == null ? void 0 : a.length
    };
}
function $69c96f0c9b63d8d4$var$Nt(t) {
    var _Ot = (0, $6iP9u._)((0, $5s1kH.useState)(!1), 2), o = _Ot[0], e = _Ot[1], _Ot1 = (0, $6iP9u._)((0, $5s1kH.useState)(!1), 2), r = _Ot1[0], a = _Ot1[1], l = (0, $5s1kH.useRef)(null), s = (0, $5s1kH.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, f = t.autoClose, c = t.pauseOnHover, T = t.closeToast, g = t.onClick, v = t.closeOnClick;
    $69c96f0c9b63d8d4$var$Pt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $5s1kH.useEffect)(function() {
        if (t.pauseOnFocusLoss) return x(), function() {
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", d), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", d), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            var _ = l.current;
            s.canCloseOnClick = !0, s.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (s.start = m.clientX, s.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (s.start = m.clientY, s.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        var _l_current_getBoundingClientRect = l.current.getBoundingClientRect(), _ = _l_current_getBoundingClientRect.top, k = _l_current_getBoundingClientRect.bottom, D = _l_current_getBoundingClientRect.left, A = _l_current_getBoundingClientRect.right;
        m.pointerType === "mouse" && t.pauseOnHover && m.clientX >= D && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : d();
    }
    function d() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        s.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        var _ = l.current;
        if (s.canDrag && _) {
            s.didMove = !0, o && p(), t.draggableDirection === "x" ? s.delta = m.clientX - s.start : s.delta = m.clientY - s.start, s.start !== m.clientX && (s.canCloseOnClick = !1);
            var k = t.draggableDirection === "x" ? "".concat(s.delta, "px, var(--y)") : "0, calc(".concat(s.delta, "px + var(--y))");
            _.style.transform = "translate3d(".concat(k, ",0)"), _.style.opacity = "".concat(1 - Math.abs(s.delta / s.removalDistance));
        }
    }
    function u() {
        i();
        var m = l.current;
        if (s.canDrag && s.didMove && m) {
            if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) {
                a(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    var h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return f && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = d)), v && (h.onClick = function(m) {
        g && g(m), s.canCloseOnClick && T(!0);
    }), {
        playToast: d,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $69c96f0c9b63d8d4$var$G = typeof window != "undefined" ? (0, $5s1kH.useLayoutEffect) : (0, $5s1kH.useEffect);
var $69c96f0c9b63d8d4$var$K = function(_param) {
    var t = _param.theme, o = _param.type, e = _param.isLoading, r = (0, $54Czb._)(_param, [
        "theme",
        "type",
        "isLoading"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("svg", (0, $hwO3w._)({
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : "var(--toastify-icon-color-".concat(o, ")")
    }, r));
};
function $69c96f0c9b63d8d4$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($69c96f0c9b63d8d4$var$K, (0, $hwO3w._)({}, t), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $69c96f0c9b63d8d4$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($69c96f0c9b63d8d4$var$K, (0, $hwO3w._)({}, t), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $69c96f0c9b63d8d4$var$io(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($69c96f0c9b63d8d4$var$K, (0, $hwO3w._)({}, t), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $69c96f0c9b63d8d4$var$lo(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($69c96f0c9b63d8d4$var$K, (0, $hwO3w._)({}, t), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $69c96f0c9b63d8d4$var$fo() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $69c96f0c9b63d8d4$export$4f13f83fd8bb1dac = {
    info: $69c96f0c9b63d8d4$var$no,
    warning: $69c96f0c9b63d8d4$var$ro,
    success: $69c96f0c9b63d8d4$var$io,
    error: $69c96f0c9b63d8d4$var$lo,
    spinner: $69c96f0c9b63d8d4$var$fo
}, $69c96f0c9b63d8d4$var$co = function(t) {
    return t in $69c96f0c9b63d8d4$export$4f13f83fd8bb1dac;
};
function $69c96f0c9b63d8d4$var$wt(param) {
    var t = param.theme, o = param.type, e = param.isLoading, r = param.icon;
    var a = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($69c96f0c9b63d8d4$var$P(r) ? a = r((0, $lf4fc._)((0, $hwO3w._)({}, l), {
        isLoading: e
    })) : (0, $5s1kH.isValidElement)(r) ? a = (0, $5s1kH.cloneElement)(r, l) : e ? a = $69c96f0c9b63d8d4$export$4f13f83fd8bb1dac.spinner() : $69c96f0c9b63d8d4$var$co(o) && (a = $69c96f0c9b63d8d4$export$4f13f83fd8bb1dac[o](l))), a;
}
var $69c96f0c9b63d8d4$var$Dt = function(t) {
    var _Nt = $69c96f0c9b63d8d4$var$Nt(t), o = _Nt.isRunning, e = _Nt.preventExitTransition, r = _Nt.toastRef, a = _Nt.eventHandlers, l = _Nt.playToast, s = t.closeButton, f = t.children, c = t.autoClose, T = t.onClick, g = t.type, v = t.hideProgressBar, x = t.closeToast, C = t.transition, S = t.position, E = t.className, d = t.style, p = t.progressClassName, b = t.updateId, i = t.role, n = t.progress, u = t.rtl, h = t.toastId, m = t.deleteToast, _ = t.isIn, k = t.isLoading, D = t.closeOnClick, A = t.theme, B = t.ariaLabel, M = (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)("Toastify__toast", "Toastify__toast-theme--".concat(A), "Toastify__toast--".concat(g), (0, $dUlz9._)({}, "Toastify__toast--rtl", u), (0, $dUlz9._)({}, "Toastify__toast--close-on-click", D)), $ = $69c96f0c9b63d8d4$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: M
    }) : (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)(M, E), mt = $69c96f0c9b63d8d4$var$wt(t), pt = !!n || !c, Z = {
        closeToast: x,
        type: g,
        theme: A
    }, V = null;
    return s === !1 || ($69c96f0c9b63d8d4$var$P(s) ? V = s(Z) : (0, $5s1kH.isValidElement)(s) ? V = (0, $5s1kH.cloneElement)(s, Z) : V = $69c96f0c9b63d8d4$var$gt(Z)), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", (0, $hwO3w._)((0, $lf4fc._)((0, $hwO3w._)({
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: $
    }, a), {
        style: d,
        ref: r
    }), _ && {
        role: i,
        "aria-label": B
    }), mt != null && (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)("Toastify__toast-icon", (0, $dUlz9._)({}, "Toastify--animate-icon Toastify__zoom-enter", !k))
    }, mt), $69c96f0c9b63d8d4$var$ot(f, t, !o), V, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($69c96f0c9b63d8d4$var$bt, (0, $lf4fc._)((0, $hwO3w._)({}, b && !pt ? {
        key: "p-".concat(b)
    } : {}), {
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: pt,
        progress: n || 0
    }))));
};
var $69c96f0c9b63d8d4$var$j = function(t) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return {
        enter: "Toastify--animate Toastify__".concat(t, "-enter"),
        exit: "Toastify--animate Toastify__".concat(t, "-exit"),
        appendPosition: o
    };
}, $69c96f0c9b63d8d4$export$d20e79fdc3899e95 = $69c96f0c9b63d8d4$export$3ff7dc44d332d222($69c96f0c9b63d8d4$var$j("bounce", !0)), $69c96f0c9b63d8d4$export$d8dc01b5c85a37b9 = $69c96f0c9b63d8d4$export$3ff7dc44d332d222($69c96f0c9b63d8d4$var$j("slide", !0)), $69c96f0c9b63d8d4$export$65cfd44a2050f99 = $69c96f0c9b63d8d4$export$3ff7dc44d332d222($69c96f0c9b63d8d4$var$j("zoom")), $69c96f0c9b63d8d4$export$4d2fae537bd90431 = $69c96f0c9b63d8d4$export$3ff7dc44d332d222($69c96f0c9b63d8d4$var$j("flip"));
var $69c96f0c9b63d8d4$var$vo = {
    position: "top-right",
    transition: $69c96f0c9b63d8d4$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: function(t) {
        return t.altKey && t.code === "KeyT";
    }
};
function $69c96f0c9b63d8d4$var$dt(t) {
    var o = (0, $hwO3w._)({}, $69c96f0c9b63d8d4$var$vo, t), e = t.stacked, _bo = (0, $6iP9u._)((0, $5s1kH.useState)(!0), 2), r = _bo[0], a = _bo[1], l = (0, $5s1kH.useRef)(null), _kt = $69c96f0c9b63d8d4$var$kt(o), s = _kt.getToastToRender, f = _kt.isToastActive, c = _kt.count, T = o.className, g = o.style, v = o.rtl, x = o.containerId, C = o.hotKeys;
    function S(d) {
        var p = (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)("Toastify__toast-container", "Toastify__toast-container--".concat(d), (0, $dUlz9._)({}, "Toastify__toast-container--rtl", v));
        return $69c96f0c9b63d8d4$var$P(T) ? T({
            position: d,
            rtl: v,
            defaultClassName: p
        }) : (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)(p, $69c96f0c9b63d8d4$var$z(T));
    }
    function E() {
        e && (a(!0), $69c96f0c9b63d8d4$export$b410431fab84fa58.play());
    }
    return $69c96f0c9b63d8d4$var$G(function() {
        var d;
        if (e) {
            var p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (d = o.position) == null ? void 0 : d.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach(function(h, m) {
                var _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = "".concat(r)), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                var k = n * (r ? .2 : 1) + (r ? 0 : b * m), D = Math.max(.5, 1 - (r ? u : 0));
                _.style.setProperty("--y", "".concat(i ? k : k * -1, "px")), _.style.setProperty("--g", "".concat(b)), _.style.setProperty("--s", "".concat(D)), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $5s1kH.useEffect)(function() {
        function d(p) {
            var i;
            var b = l.current;
            C(p) && ((i = b == null ? void 0 : b.querySelector('[tabIndex="0"]')) == null || i.focus(), a(!1), $69c96f0c9b63d8d4$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (a(!0), $69c96f0c9b63d8d4$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", d), function() {
            document.removeEventListener("keydown", d);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: function() {
            e && (a(!1), $69c96f0c9b63d8d4$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, s(function(d, p) {
        var b = p.length ? (0, $hwO3w._)({}, g) : (0, $lf4fc._)((0, $hwO3w._)({}, g), {
            pointerEvents: "none"
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            tabIndex: -1,
            className: S(d),
            "data-stacked": e,
            style: b,
            key: "c-".concat(d)
        }, p.map(function(param) {
            var i = param.content, n = param.props;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($69c96f0c9b63d8d4$var$Dt, (0, $lf4fc._)((0, $hwO3w._)({}, n), {
                stacked: e,
                collapseAll: E,
                isIn: f(n.toastId, n.containerId),
                key: "t-".concat(n.key)
            }), i);
        }));
    }));
}
var $69c96f0c9b63d8d4$var$Mt = ":root {\n  --toastify-color-light: #fff;\n  --toastify-color-dark: #121212;\n  --toastify-color-info: #3498db;\n  --toastify-color-success: #07bc0c;\n  --toastify-color-warning: #f1c40f;\n  --toastify-color-error: hsl(6, 78%, 57%);\n  --toastify-color-transparent: rgba(255, 255, 255, 0.7);\n\n  --toastify-icon-color-info: var(--toastify-color-info);\n  --toastify-icon-color-success: var(--toastify-color-success);\n  --toastify-icon-color-warning: var(--toastify-color-warning);\n  --toastify-icon-color-error: var(--toastify-color-error);\n\n  --toastify-container-width: fit-content;\n  --toastify-toast-width: 320px;\n  --toastify-toast-offset: 16px;\n  --toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));\n  --toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));\n  --toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));\n  --toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));\n  --toastify-toast-background: #fff;\n  --toastify-toast-padding: 14px;\n  --toastify-toast-min-height: 64px;\n  --toastify-toast-max-height: 800px;\n  --toastify-toast-bd-radius: 6px;\n  --toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n  --toastify-font-family: sans-serif;\n  --toastify-z-index: 9999;\n  --toastify-text-color-light: #757575;\n  --toastify-text-color-dark: #fff;\n\n  /* Used only for colored theme */\n  --toastify-text-color-info: #fff;\n  --toastify-text-color-success: #fff;\n  --toastify-text-color-warning: #fff;\n  --toastify-text-color-error: #fff;\n\n  --toastify-spinner-color: #616161;\n  --toastify-spinner-color-empty-area: #e0e0e0;\n  --toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);\n  --toastify-color-progress-dark: #bb86fc;\n  --toastify-color-progress-info: var(--toastify-color-info);\n  --toastify-color-progress-success: var(--toastify-color-success);\n  --toastify-color-progress-warning: var(--toastify-color-warning);\n  --toastify-color-progress-error: var(--toastify-color-error);\n  /* used to control the opacity of the progress trail */\n  --toastify-color-progress-bgo: 0.2;\n}\n\n.Toastify__toast-container {\n  z-index: var(--toastify-z-index);\n  -webkit-transform: translate3d(0, 0, var(--toastify-z-index));\n  position: fixed;\n  width: var(--toastify-container-width);\n  box-sizing: border-box;\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n}\n\n.Toastify__toast-container--top-left {\n  top: var(--toastify-toast-top);\n  left: var(--toastify-toast-left);\n}\n.Toastify__toast-container--top-center {\n  top: var(--toastify-toast-top);\n  left: 50%;\n  transform: translateX(-50%);\n  align-items: center;\n}\n.Toastify__toast-container--top-right {\n  top: var(--toastify-toast-top);\n  right: var(--toastify-toast-right);\n  align-items: end;\n}\n.Toastify__toast-container--bottom-left {\n  bottom: var(--toastify-toast-bottom);\n  left: var(--toastify-toast-left);\n}\n.Toastify__toast-container--bottom-center {\n  bottom: var(--toastify-toast-bottom);\n  left: 50%;\n  transform: translateX(-50%);\n  align-items: center;\n}\n.Toastify__toast-container--bottom-right {\n  bottom: var(--toastify-toast-bottom);\n  right: var(--toastify-toast-right);\n  align-items: end;\n}\n\n.Toastify__toast {\n  --y: 0px;\n  position: relative;\n  touch-action: none;\n  width: var(--toastify-toast-width);\n  min-height: var(--toastify-toast-min-height);\n  box-sizing: border-box;\n  margin-bottom: 1rem;\n  padding: var(--toastify-toast-padding);\n  border-radius: var(--toastify-toast-bd-radius);\n  box-shadow: var(--toastify-toast-shadow);\n  max-height: var(--toastify-toast-max-height);\n  font-family: var(--toastify-font-family);\n  /* webkit only issue #791 */\n  z-index: 0;\n  /* inner swag */\n  display: flex;\n  flex: 1 auto;\n  align-items: center;\n  word-break: break-word;\n}\n\n@media only screen and (max-width: 480px) {\n  .Toastify__toast-container {\n    width: 100vw;\n    left: env(safe-area-inset-left);\n    margin: 0;\n  }\n  .Toastify__toast-container--top-left,\n  .Toastify__toast-container--top-center,\n  .Toastify__toast-container--top-right {\n    top: env(safe-area-inset-top);\n    transform: translateX(0);\n  }\n  .Toastify__toast-container--bottom-left,\n  .Toastify__toast-container--bottom-center,\n  .Toastify__toast-container--bottom-right {\n    bottom: env(safe-area-inset-bottom);\n    transform: translateX(0);\n  }\n  .Toastify__toast-container--rtl {\n    right: env(safe-area-inset-right);\n    left: initial;\n  }\n  .Toastify__toast {\n    --toastify-toast-width: 100%;\n    margin-bottom: 0;\n    border-radius: 0;\n  }\n}\n\n.Toastify__toast-container[data-stacked='true'] {\n  width: var(--toastify-toast-width);\n}\n\n@media only screen and (max-width: 480px) {\n  .Toastify__toast-container[data-stacked='true'] {\n    width: 100vw;\n  }\n}\n\n.Toastify__toast--stacked {\n  position: absolute;\n  width: 100%;\n  transform: translate3d(0, var(--y), 0) scale(var(--s));\n  transition: transform 0.3s;\n}\n\n.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,\n.Toastify__toast--stacked[data-collapsed] .Toastify__close-button {\n  transition: opacity 0.1s;\n}\n\n.Toastify__toast--stacked[data-collapsed='false'] {\n  overflow: visible;\n}\n\n.Toastify__toast--stacked[data-collapsed='true']:not(:last-child) > * {\n  opacity: 0;\n}\n\n.Toastify__toast--stacked:after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: calc(var(--g) * 1px);\n  bottom: 100%;\n}\n\n.Toastify__toast--stacked[data-pos='top'] {\n  top: 0;\n}\n\n.Toastify__toast--stacked[data-pos='bot'] {\n  bottom: 0;\n}\n\n.Toastify__toast--stacked[data-pos='bot'].Toastify__toast--stacked:before {\n  transform-origin: top;\n}\n\n.Toastify__toast--stacked[data-pos='top'].Toastify__toast--stacked:before {\n  transform-origin: bottom;\n}\n\n.Toastify__toast--stacked:before {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 100%;\n  transform: scaleY(3);\n  z-index: -1;\n}\n\n.Toastify__toast--rtl {\n  direction: rtl;\n}\n\n.Toastify__toast--close-on-click {\n  cursor: pointer;\n}\n\n.Toastify__toast-icon {\n  margin-inline-end: 10px;\n  width: 22px;\n  flex-shrink: 0;\n  display: flex;\n}\n\n.Toastify--animate {\n  animation-fill-mode: both;\n  animation-duration: 0.5s;\n}\n\n.Toastify--animate-icon {\n  animation-fill-mode: both;\n  animation-duration: 0.3s;\n}\n\n.Toastify__toast-theme--dark {\n  background: var(--toastify-color-dark);\n  color: var(--toastify-text-color-dark);\n}\n\n.Toastify__toast-theme--light {\n  background: var(--toastify-color-light);\n  color: var(--toastify-text-color-light);\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--default {\n  background: var(--toastify-color-light);\n  color: var(--toastify-text-color-light);\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--info {\n  color: var(--toastify-text-color-info);\n  background: var(--toastify-color-info);\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--success {\n  color: var(--toastify-text-color-success);\n  background: var(--toastify-color-success);\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--warning {\n  color: var(--toastify-text-color-warning);\n  background: var(--toastify-color-warning);\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--error {\n  color: var(--toastify-text-color-error);\n  background: var(--toastify-color-error);\n}\n\n.Toastify__progress-bar-theme--light {\n  background: var(--toastify-color-progress-light);\n}\n\n.Toastify__progress-bar-theme--dark {\n  background: var(--toastify-color-progress-dark);\n}\n\n.Toastify__progress-bar--info {\n  background: var(--toastify-color-progress-info);\n}\n\n.Toastify__progress-bar--success {\n  background: var(--toastify-color-progress-success);\n}\n\n.Toastify__progress-bar--warning {\n  background: var(--toastify-color-progress-warning);\n}\n\n.Toastify__progress-bar--error {\n  background: var(--toastify-color-progress-error);\n}\n\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {\n  background: var(--toastify-color-transparent);\n}\n\n.Toastify__close-button {\n  color: #fff;\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  background: transparent;\n  outline: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: 0.3s ease;\n  z-index: 1;\n}\n\n.Toastify__toast--rtl .Toastify__close-button {\n  left: 6px;\n  right: unset;\n}\n\n.Toastify__close-button--light {\n  color: #000;\n  opacity: 0.3;\n}\n\n.Toastify__close-button > svg {\n  fill: currentColor;\n  height: 16px;\n  width: 14px;\n}\n\n.Toastify__close-button:hover,\n.Toastify__close-button:focus {\n  opacity: 1;\n}\n\n@keyframes Toastify__trackProgress {\n  0% {\n    transform: scaleX(1);\n  }\n  100% {\n    transform: scaleX(0);\n  }\n}\n\n.Toastify__progress-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  opacity: 0.7;\n  transform-origin: left;\n}\n\n.Toastify__progress-bar--animated {\n  animation: Toastify__trackProgress linear 1 forwards;\n}\n\n.Toastify__progress-bar--controlled {\n  transition: transform 0.2s;\n}\n\n.Toastify__progress-bar--rtl {\n  right: 0;\n  left: initial;\n  transform-origin: right;\n  border-bottom-left-radius: initial;\n}\n\n.Toastify__progress-bar--wrp {\n  position: absolute;\n  overflow: hidden;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 5px;\n  border-bottom-left-radius: var(--toastify-toast-bd-radius);\n  border-bottom-right-radius: var(--toastify-toast-bd-radius);\n}\n\n.Toastify__progress-bar--wrp[data-hidden='true'] {\n  opacity: 0;\n}\n\n.Toastify__progress-bar--bg {\n  opacity: var(--toastify-color-progress-bgo);\n  width: 100%;\n  height: 100%;\n}\n\n.Toastify__spinner {\n  width: 20px;\n  height: 20px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: var(--toastify-spinner-color-empty-area);\n  border-right-color: var(--toastify-spinner-color);\n  animation: Toastify__spin 0.65s linear infinite;\n}\n\n@keyframes Toastify__bounceInRight {\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n\n@keyframes Toastify__bounceOutRight {\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, var(--y), 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, var(--y), 0);\n  }\n}\n\n@keyframes Toastify__bounceInLeft {\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n\n@keyframes Toastify__bounceOutLeft {\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, var(--y), 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, var(--y), 0);\n  }\n}\n\n@keyframes Toastify__bounceInUp {\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  75% {\n    transform: translate3d(0, 10px, 0);\n  }\n  90% {\n    transform: translate3d(0, -5px, 0);\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes Toastify__bounceOutUp {\n  20% {\n    transform: translate3d(0, calc(var(--y) - 10px), 0);\n  }\n  40%,\n  45% {\n    opacity: 1;\n    transform: translate3d(0, calc(var(--y) + 20px), 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n\n@keyframes Toastify__bounceInDown {\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n  75% {\n    transform: translate3d(0, -10px, 0);\n  }\n  90% {\n    transform: translate3d(0, 5px, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n\n@keyframes Toastify__bounceOutDown {\n  20% {\n    transform: translate3d(0, calc(var(--y) - 10px), 0);\n  }\n  40%,\n  45% {\n    opacity: 1;\n    transform: translate3d(0, calc(var(--y) + 20px), 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n\n.Toastify__bounce-enter--top-left,\n.Toastify__bounce-enter--bottom-left {\n  animation-name: Toastify__bounceInLeft;\n}\n\n.Toastify__bounce-enter--top-right,\n.Toastify__bounce-enter--bottom-right {\n  animation-name: Toastify__bounceInRight;\n}\n\n.Toastify__bounce-enter--top-center {\n  animation-name: Toastify__bounceInDown;\n}\n\n.Toastify__bounce-enter--bottom-center {\n  animation-name: Toastify__bounceInUp;\n}\n\n.Toastify__bounce-exit--top-left,\n.Toastify__bounce-exit--bottom-left {\n  animation-name: Toastify__bounceOutLeft;\n}\n\n.Toastify__bounce-exit--top-right,\n.Toastify__bounce-exit--bottom-right {\n  animation-name: Toastify__bounceOutRight;\n}\n\n.Toastify__bounce-exit--top-center {\n  animation-name: Toastify__bounceOutUp;\n}\n\n.Toastify__bounce-exit--bottom-center {\n  animation-name: Toastify__bounceOutDown;\n}\n\n@keyframes Toastify__zoomIn {\n  from {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes Toastify__zoomOut {\n  from {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n    transform: translate3d(0, var(--y), 0) scale3d(0.3, 0.3, 0.3);\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.Toastify__zoom-enter {\n  animation-name: Toastify__zoomIn;\n}\n\n.Toastify__zoom-exit {\n  animation-name: Toastify__zoomOut;\n}\n\n@keyframes Toastify__flipIn {\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    animation-timing-function: ease-in;\n  }\n  60% {\n    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    opacity: 1;\n  }\n  80% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n\n@keyframes Toastify__flipOut {\n  from {\n    transform: translate3d(0, var(--y), 0) perspective(400px);\n  }\n  30% {\n    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1;\n  }\n  to {\n    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0;\n  }\n}\n\n.Toastify__flip-enter {\n  animation-name: Toastify__flipIn;\n}\n\n.Toastify__flip-exit {\n  animation-name: Toastify__flipOut;\n}\n\n@keyframes Toastify__slideInRight {\n  from {\n    transform: translate3d(110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, var(--y), 0);\n  }\n}\n\n@keyframes Toastify__slideInLeft {\n  from {\n    transform: translate3d(-110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, var(--y), 0);\n  }\n}\n\n@keyframes Toastify__slideInUp {\n  from {\n    transform: translate3d(0, 110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, var(--y), 0);\n  }\n}\n\n@keyframes Toastify__slideInDown {\n  from {\n    transform: translate3d(0, -110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, var(--y), 0);\n  }\n}\n\n@keyframes Toastify__slideOutRight {\n  from {\n    transform: translate3d(0, var(--y), 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(110%, var(--y), 0);\n  }\n}\n\n@keyframes Toastify__slideOutLeft {\n  from {\n    transform: translate3d(0, var(--y), 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(-110%, var(--y), 0);\n  }\n}\n\n@keyframes Toastify__slideOutDown {\n  from {\n    transform: translate3d(0, var(--y), 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 500px, 0);\n  }\n}\n\n@keyframes Toastify__slideOutUp {\n  from {\n    transform: translate3d(0, var(--y), 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, -500px, 0);\n  }\n}\n\n.Toastify__slide-enter--top-left,\n.Toastify__slide-enter--bottom-left {\n  animation-name: Toastify__slideInLeft;\n}\n\n.Toastify__slide-enter--top-right,\n.Toastify__slide-enter--bottom-right {\n  animation-name: Toastify__slideInRight;\n}\n\n.Toastify__slide-enter--top-center {\n  animation-name: Toastify__slideInDown;\n}\n\n.Toastify__slide-enter--bottom-center {\n  animation-name: Toastify__slideInUp;\n}\n\n.Toastify__slide-exit--top-left,\n.Toastify__slide-exit--bottom-left {\n  animation-name: Toastify__slideOutLeft;\n  animation-timing-function: ease-in;\n  animation-duration: 0.3s;\n}\n\n.Toastify__slide-exit--top-right,\n.Toastify__slide-exit--bottom-right {\n  animation-name: Toastify__slideOutRight;\n  animation-timing-function: ease-in;\n  animation-duration: 0.3s;\n}\n\n.Toastify__slide-exit--top-center {\n  animation-name: Toastify__slideOutUp;\n  animation-timing-function: ease-in;\n  animation-duration: 0.3s;\n}\n\n.Toastify__slide-exit--bottom-center {\n  animation-name: Toastify__slideOutDown;\n  animation-timing-function: ease-in;\n  animation-duration: 0.3s;\n}\n\n@keyframes Toastify__spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n";
var $69c96f0c9b63d8d4$var$$t = new Map, $69c96f0c9b63d8d4$var$Rt = function(t, o) {
    $69c96f0c9b63d8d4$var$G(function() {
        if (!t || typeof document == "undefined") return;
        var e = document, r = $69c96f0c9b63d8d4$var$$t.get(e);
        if (r) {
            o && r.setAttribute("nonce", o);
            return;
        }
        var a = e.createElement("style");
        a.textContent = t, o && a.setAttribute("nonce", o), e.head.appendChild(a), $69c96f0c9b63d8d4$var$$t.set(e, a);
    }, [
        o
    ]);
};
function $69c96f0c9b63d8d4$export$f2815235e76a62b9(t) {
    return $69c96f0c9b63d8d4$var$Rt($69c96f0c9b63d8d4$var$Mt, t.nonce), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($69c96f0c9b63d8d4$var$dt, (0, $hwO3w._)({}, t));
}





var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");
var $b0730787261d6ae7$exports = {};
$b0730787261d6ae7$exports = $parcel$resolve("3gJ6J");



var $c03548fc9c3a7450$exports = {};
$c03548fc9c3a7450$exports = $parcel$resolve("3glw7");


var $6027242fe1d8334d$exports = {};
$6027242fe1d8334d$exports = $parcel$resolve("lG8u2");



var $6iP9u = parcelRequire("6iP9u");

parcelRequire("5s1kH");


var $bHX26 = parcelRequire("bHX26");


var $cb7edd55bc5ce05d$exports = {};
$cb7edd55bc5ce05d$exports = $parcel$resolve("vQEa0");



var $edde00260b2e011e$exports = {};
$edde00260b2e011e$exports = $parcel$resolve("j5LW6");



var $c2dcd914cb0438f4$exports = {};
$c2dcd914cb0438f4$exports = $parcel$resolve("8Gduo");


var $e7641a398e8dd1fb$exports = {};
$e7641a398e8dd1fb$exports = $parcel$resolve("fDPc9");



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");

var $5s1kH = parcelRequire("5s1kH");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");
var $c9acb133012436ec$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/jotai/esm/vanilla/internals.mjs"
});
var $c9acb133012436ec$var$_atom, $c9acb133012436ec$var$_atom1;
function $c9acb133012436ec$export$23808a6f53e55c3(atom) {
    return "init" in atom;
}
function $c9acb133012436ec$export$7c24d1ef3bea9769(atom) {
    return typeof atom.write === "function";
}
function $c9acb133012436ec$var$hasOnMount(atom) {
    return !!atom.onMount;
}
function $c9acb133012436ec$export$33f6e9f7330dc7e3(atomState) {
    return "v" in atomState || "e" in atomState;
}
function $c9acb133012436ec$export$696d075174b4543b(atomState) {
    if ("e" in atomState) throw atomState.e;
    if (($c9acb133012436ec$import_meta.env ? $c9acb133012436ec$import_meta.env.MODE : void 0) !== "production" && !("v" in atomState)) throw new Error("[Bug] atom state is not initialized");
    return atomState.v;
}
function $c9acb133012436ec$export$5ab0738ada359ec5(p) {
    return typeof (p == null ? void 0 : p.then) === "function";
}
function $c9acb133012436ec$export$488563b9c383d273(error) {
    if (!(error instanceof Error)) return false;
    var name = error.name;
    var message = error.message.toLowerCase();
    return (name === "RangeError" || name === "InternalError") && (message.includes("call stack") || message.includes("too much recursion") || message.includes("stack overflow"));
}
function $c9acb133012436ec$export$82a1790dbcdcfc9f(atom, promise, dependencyAtomState) {
    if (!dependencyAtomState.p.has(atom)) {
        dependencyAtomState.p.add(atom);
        var cleanup = function() {
            return dependencyAtomState.p.delete(atom);
        };
        promise.then(cleanup, cleanup);
    }
}
function $c9acb133012436ec$export$5454bef94246c3c(atom, atomState, mountedMap) {
    var mounted = mountedMap.get(atom);
    var mountedDependents = mounted == null ? void 0 : mounted.t;
    var pendingDependents = atomState.p;
    if (!(mountedDependents == null ? void 0 : mountedDependents.size)) return pendingDependents;
    if (!pendingDependents.size) return mountedDependents;
    var dependents = new Set(mountedDependents);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = pendingDependents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var a = _step.value;
            dependents.add(a);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return dependents;
}
var $c9acb133012436ec$var$createStoreHook = function() {
    var callbacks = /* @__PURE__ */ new Set();
    var notify = function() {
        return callbacks.forEach(function(fn) {
            return fn();
        });
    };
    notify.add = function(fn) {
        callbacks.add(fn);
        return function() {
            return callbacks.delete(fn);
        };
    };
    return notify;
};
var $c9acb133012436ec$var$createStoreHookForAtoms = function() {
    var all = {};
    var callbacks = /* @__PURE__ */ new WeakMap();
    var notify = function(atom) {
        var _a, _b;
        (_a = callbacks.get(all)) == null || _a.forEach(function(fn) {
            return fn(atom);
        });
        (_b = callbacks.get(atom)) == null || _b.forEach(function(fn) {
            return fn();
        });
    };
    notify.add = function(atom, fn) {
        var key = atom || all;
        var fns = callbacks.get(key);
        if (!fns) {
            fns = /* @__PURE__ */ new Set();
            callbacks.set(key, fns);
        }
        fns.add(fn);
        return function() {
            fns.delete(fn);
            if (!fns.size) callbacks.delete(key);
        };
    };
    return notify;
};
function $c9acb133012436ec$export$a044c555aa9c2601(storeHooks) {
    storeHooks.i || (storeHooks.i = $c9acb133012436ec$var$createStoreHookForAtoms());
    storeHooks.r || (storeHooks.r = $c9acb133012436ec$var$createStoreHookForAtoms());
    storeHooks.c || (storeHooks.c = $c9acb133012436ec$var$createStoreHookForAtoms());
    storeHooks.m || (storeHooks.m = $c9acb133012436ec$var$createStoreHookForAtoms());
    storeHooks.u || (storeHooks.u = $c9acb133012436ec$var$createStoreHookForAtoms());
    storeHooks.f || (storeHooks.f = $c9acb133012436ec$var$createStoreHook());
    return storeHooks;
}
function $c9acb133012436ec$var$hasOnInit(atom) {
    return !!atom.INTERNAL_onInit;
}
var $c9acb133012436ec$var$BUILDING_BLOCK_atomRead = function(_buildingBlocks, _store, atom) {
    for(var _len = arguments.length, params = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        params[_key - 3] = arguments[_key];
    }
    return ($c9acb133012436ec$var$_atom = atom).read.apply($c9acb133012436ec$var$_atom, (0, $XnYkK._)(params));
};
var $c9acb133012436ec$var$BUILDING_BLOCK_atomWrite = function(_buildingBlocks, _store, atom) {
    for(var _len = arguments.length, params = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        params[_key - 3] = arguments[_key];
    }
    return ($c9acb133012436ec$var$_atom1 = atom).write.apply($c9acb133012436ec$var$_atom1, (0, $XnYkK._)(params));
};
var $c9acb133012436ec$var$BUILDING_BLOCK_atomOnInit = function(_buildingBlocks, store, atom) {
    return atom.INTERNAL_onInit(store);
};
var $c9acb133012436ec$var$BUILDING_BLOCK_atomOnMount = function(_buildingBlocks, _store, atom, setAtom) {
    var _a;
    return (_a = atom.onMount) == null ? void 0 : _a.call(atom, setAtom);
};
var $c9acb133012436ec$var$BUILDING_BLOCK_ensureAtomState = function(buildingBlocks, store, atom) {
    var _a;
    var atomStateMap = buildingBlocks[0];
    var atomState = atomStateMap.get(atom);
    if (!atomState) {
        var storeHooks = buildingBlocks[6];
        var atomOnInit = buildingBlocks[9];
        atomState = {
            d: /* @__PURE__ */ new Map(),
            p: /* @__PURE__ */ new Set(),
            n: 0
        };
        atomStateMap.set(atom, atomState);
        (_a = storeHooks.i) == null || _a.call(storeHooks, atom);
        if ($c9acb133012436ec$var$hasOnInit(atom)) atomOnInit(buildingBlocks, store, atom);
    }
    return atomState;
};
var $c9acb133012436ec$var$BUILDING_BLOCK_flushCallbacks = function(buildingBlocks, store) {
    var _a;
    var mountedMap = buildingBlocks[1];
    var changedAtoms = buildingBlocks[3];
    var mountCallbacks = buildingBlocks[4];
    var unmountCallbacks = buildingBlocks[5];
    var storeHooks = buildingBlocks[6];
    var recomputeInvalidatedAtoms = buildingBlocks[13];
    if (!storeHooks.f && !changedAtoms.size && !mountCallbacks.size && !unmountCallbacks.size) return;
    var errors = [];
    var call = function(fn) {
        try {
            fn();
        } catch (e) {
            errors.push(e);
        }
    };
    do {
        if (storeHooks.f) call(storeHooks.f);
        var callbacks = /* @__PURE__ */ new Set();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = changedAtoms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var atom = _step.value;
                var listeners = (_a = mountedMap.get(atom)) == null ? void 0 : _a.l;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (listeners) try {
                    for(var _iterator1 = listeners[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var listener = _step1.value;
                        callbacks.add(listener);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        changedAtoms.clear();
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = unmountCallbacks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var fn = _step2.value;
                callbacks.add(fn);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        unmountCallbacks.clear();
        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
        try {
            for(var _iterator3 = mountCallbacks[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                var fn1 = _step3.value;
                callbacks.add(fn1);
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                    _iterator3.return();
                }
            } finally{
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
        mountCallbacks.clear();
        var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
        try {
            for(var _iterator4 = callbacks[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                var fn2 = _step4.value;
                call(fn2);
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                    _iterator4.return();
                }
            } finally{
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }
        if (changedAtoms.size) recomputeInvalidatedAtoms(buildingBlocks, store);
    }while (changedAtoms.size || unmountCallbacks.size || mountCallbacks.size);
    if (errors.length) throw new AggregateError(errors);
};
var $c9acb133012436ec$var$BUILDING_BLOCK_recomputeInvalidatedAtoms = function(buildingBlocks, store) {
    var mountedMap = buildingBlocks[1];
    var invalidatedAtoms = buildingBlocks[2];
    var changedAtoms = buildingBlocks[3];
    var ensureAtomState = buildingBlocks[11];
    var readAtomState = buildingBlocks[14];
    var mountDependencies = buildingBlocks[17];
    if (!changedAtoms.size) return;
    var sortedReversedAtoms = [];
    var sortedReversedStates = [];
    var visiting = /* @__PURE__ */ new WeakSet();
    var visited = /* @__PURE__ */ new WeakSet();
    var stackAtoms = [];
    var stackStates = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = changedAtoms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var atom = _step.value;
            stackAtoms.push(atom);
            stackStates.push(ensureAtomState(buildingBlocks, store, atom));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    while(stackAtoms.length){
        var top = stackAtoms.length - 1;
        var a = stackAtoms[top];
        var aState = stackStates[top];
        if (visited.has(a)) {
            stackAtoms.pop();
            stackStates.pop();
            continue;
        }
        if (visiting.has(a)) {
            if (invalidatedAtoms.get(a) === aState.n) {
                sortedReversedAtoms.push(a);
                sortedReversedStates.push(aState);
            } else if (($c9acb133012436ec$import_meta.env ? $c9acb133012436ec$import_meta.env.MODE : void 0) !== "production" && invalidatedAtoms.has(a)) throw new Error("[Bug] invalidated atom exists");
            visited.add(a);
            stackAtoms.pop();
            stackStates.pop();
            continue;
        }
        visiting.add(a);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = $c9acb133012436ec$export$5454bef94246c3c(a, aState, mountedMap)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var d = _step1.value;
                if (!visiting.has(d)) {
                    stackAtoms.push(d);
                    stackStates.push(ensureAtomState(buildingBlocks, store, d));
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    for(var i = sortedReversedAtoms.length - 1; i >= 0; --i){
        var a1 = sortedReversedAtoms[i];
        var aState1 = sortedReversedStates[i];
        var hasChangedDeps = false;
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = aState1.d.keys()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var dep = _step2.value;
                if (dep !== a1 && changedAtoms.has(dep)) {
                    hasChangedDeps = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        if (hasChangedDeps) {
            invalidatedAtoms.set(a1, aState1.n);
            readAtomState(buildingBlocks, store, a1);
            mountDependencies(buildingBlocks, store, a1);
        }
        invalidatedAtoms.delete(a1);
    }
};
var $c9acb133012436ec$var$storeMutationSet = /* @__PURE__ */ new WeakSet();
var $c9acb133012436ec$var$BUILDING_BLOCK_readAtomState = function(buildingBlocks, store, atom) {
    var _a, _b;
    var mountedMap = buildingBlocks[1];
    var invalidatedAtoms = buildingBlocks[2];
    var changedAtoms = buildingBlocks[3];
    var storeHooks = buildingBlocks[6];
    var atomRead = buildingBlocks[7];
    var ensureAtomState = buildingBlocks[11];
    var flushCallbacks = buildingBlocks[12];
    var recomputeInvalidatedAtoms = buildingBlocks[13];
    var readAtomState = buildingBlocks[14];
    var writeAtomState = buildingBlocks[16];
    var mountDependencies = buildingBlocks[17];
    var setAtomStateValueOrPromise = buildingBlocks[20];
    var registerAbortHandler = buildingBlocks[26];
    var storeEpochHolder = buildingBlocks[28];
    var atomState = ensureAtomState(buildingBlocks, store, atom);
    var storeEpochNumber = storeEpochHolder[0];
    if ($c9acb133012436ec$export$33f6e9f7330dc7e3(atomState)) {
        if (// If the atom is mounted, we can use cached atom state,
        // because it should have been updated by dependencies.
        // We can't use the cache if the atom is invalidated.
        mountedMap.has(atom) && invalidatedAtoms.get(atom) !== atomState.n || // If atom is not mounted, we can use cached atom state,
        // only if store hasn't been mutated.
        atomState.m === storeEpochNumber) {
            atomState.m = storeEpochNumber;
            return atomState;
        }
        var hasChangedDeps = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = atomState.d[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $6iP9u._)(_step.value, 2), a = _step_value[0], n = _step_value[1];
                if (readAtomState(buildingBlocks, store, a).n !== n) {
                    hasChangedDeps = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!hasChangedDeps) {
            atomState.m = storeEpochNumber;
            return atomState;
        }
    }
    var isSync = true;
    var prevDeps = new Set(atomState.d.keys());
    var pruneDependencies = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = prevDeps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var a = _step.value;
                atomState.d.delete(a);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var mountDependenciesIfAsync = function() {
        if (mountedMap.has(atom)) {
            var shouldRecompute = !changedAtoms.size;
            mountDependencies(buildingBlocks, store, atom);
            if (shouldRecompute) {
                recomputeInvalidatedAtoms(buildingBlocks, store);
                flushCallbacks(buildingBlocks, store);
            }
        }
    };
    var getter = function(a) {
        var _a2;
        if (a === atom) {
            var aState2 = ensureAtomState(buildingBlocks, store, a);
            if (!$c9acb133012436ec$export$33f6e9f7330dc7e3(aState2)) {
                if ($c9acb133012436ec$export$23808a6f53e55c3(a)) setAtomStateValueOrPromise(buildingBlocks, store, a, a.init);
                else throw new Error("no atom init");
            }
            return $c9acb133012436ec$export$696d075174b4543b(aState2);
        }
        var aState = readAtomState(buildingBlocks, store, a);
        try {
            return $c9acb133012436ec$export$696d075174b4543b(aState);
        } finally{
            prevDeps.delete(a);
            atomState.d.set(a, aState.n);
            if ($c9acb133012436ec$export$5ab0738ada359ec5(atomState.v)) $c9acb133012436ec$export$82a1790dbcdcfc9f(atom, atomState.v, aState);
            if (mountedMap.has(atom)) (_a2 = mountedMap.get(a)) == null || _a2.t.add(atom);
            if (!isSync) mountDependenciesIfAsync();
        }
    };
    var controller;
    var setSelf;
    var options = {
        get signal () {
            if (!controller) controller = new AbortController();
            return controller.signal;
        },
        get setSelf () {
            if (($c9acb133012436ec$import_meta.env ? $c9acb133012436ec$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] setSelf is deprecated and will be removed in v3.");
            if (($c9acb133012436ec$import_meta.env ? $c9acb133012436ec$import_meta.env.MODE : void 0) !== "production" && !$c9acb133012436ec$export$7c24d1ef3bea9769(atom)) console.warn("setSelf function cannot be used with read-only atom");
            if (!setSelf && $c9acb133012436ec$export$7c24d1ef3bea9769(atom)) setSelf = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                if (($c9acb133012436ec$import_meta.env ? $c9acb133012436ec$import_meta.env.MODE : void 0) !== "production" && isSync) console.warn("setSelf function cannot be called in sync");
                if (!isSync) try {
                    return writeAtomState(buildingBlocks, store, atom, args);
                } finally{
                    recomputeInvalidatedAtoms(buildingBlocks, store);
                    flushCallbacks(buildingBlocks, store);
                }
            };
            return setSelf;
        }
    };
    var prevEpochNumber = atomState.n;
    var prevInvalidated = invalidatedAtoms.get(atom) === prevEpochNumber;
    try {
        if (($c9acb133012436ec$import_meta.env ? $c9acb133012436ec$import_meta.env.MODE : void 0) !== "production") $c9acb133012436ec$var$storeMutationSet.delete(store);
        var valueOrPromise = atomRead(buildingBlocks, store, atom, getter, options);
        if (($c9acb133012436ec$import_meta.env ? $c9acb133012436ec$import_meta.env.MODE : void 0) !== "production" && $c9acb133012436ec$var$storeMutationSet.has(store)) console.warn("Detected store mutation during atom read. This is not supported.");
        setAtomStateValueOrPromise(buildingBlocks, store, atom, valueOrPromise);
        if ($c9acb133012436ec$export$5ab0738ada359ec5(valueOrPromise)) {
            registerAbortHandler(buildingBlocks, store, valueOrPromise, function() {
                return controller == null ? void 0 : controller.abort();
            });
            var settle = function() {
                pruneDependencies();
                mountDependenciesIfAsync();
            };
            valueOrPromise.then(settle, settle);
        } else pruneDependencies();
        (_a = storeHooks.r) == null || _a.call(storeHooks, atom);
        atomState.m = storeEpochNumber;
        return atomState;
    } catch (error) {
        if ($c9acb133012436ec$export$488563b9c383d273(error)) throw error;
        delete atomState.v;
        atomState.e = error;
        ++atomState.n;
        atomState.m = storeEpochNumber;
        return atomState;
    } finally{
        isSync = false;
        if (atomState.n !== prevEpochNumber && prevInvalidated) {
            invalidatedAtoms.set(atom, atomState.n);
            changedAtoms.add(atom);
            (_b = storeHooks.c) == null || _b.call(storeHooks, atom);
        }
    }
};
var $c9acb133012436ec$var$BUILDING_BLOCK_invalidateDependents = function(buildingBlocks, store, atom) {
    var mountedMap = buildingBlocks[1];
    var invalidatedAtoms = buildingBlocks[2];
    var ensureAtomState = buildingBlocks[11];
    var stack = [
        atom
    ];
    while(stack.length){
        var a = stack.pop();
        var aState = ensureAtomState(buildingBlocks, store, a);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $c9acb133012436ec$export$5454bef94246c3c(a, aState, mountedMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                var dState = ensureAtomState(buildingBlocks, store, d);
                if (invalidatedAtoms.get(d) !== dState.n) {
                    invalidatedAtoms.set(d, dState.n);
                    stack.push(d);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
};
var $c9acb133012436ec$var$BUILDING_BLOCK_writeAtomState = function(buildingBlocks, store, atom, args) {
    var changedAtoms = buildingBlocks[3];
    var storeHooks = buildingBlocks[6];
    var atomWrite = buildingBlocks[8];
    var ensureAtomState = buildingBlocks[11];
    var flushCallbacks = buildingBlocks[12];
    var recomputeInvalidatedAtoms = buildingBlocks[13];
    var readAtomState = buildingBlocks[14];
    var invalidateDependents = buildingBlocks[15];
    var writeAtomState = buildingBlocks[16];
    var mountDependencies = buildingBlocks[17];
    var setAtomStateValueOrPromise = buildingBlocks[20];
    var storeEpochHolder = buildingBlocks[28];
    var isSync = true;
    var getter = function(a) {
        return $c9acb133012436ec$export$696d075174b4543b(readAtomState(buildingBlocks, store, a));
    };
    var setter = function(a) {
        for(var _len = arguments.length, args2 = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args2[_key - 1] = arguments[_key];
        }
        var _a;
        var aState = ensureAtomState(buildingBlocks, store, a);
        try {
            if (a === atom) {
                if (!$c9acb133012436ec$export$23808a6f53e55c3(a)) throw new Error("atom not writable");
                if (($c9acb133012436ec$import_meta.env ? $c9acb133012436ec$import_meta.env.MODE : void 0) !== "production") $c9acb133012436ec$var$storeMutationSet.add(store);
                var prevEpochNumber = aState.n;
                var v = args2[0];
                setAtomStateValueOrPromise(buildingBlocks, store, a, v);
                mountDependencies(buildingBlocks, store, a);
                if (prevEpochNumber !== aState.n) {
                    ++storeEpochHolder[0];
                    changedAtoms.add(a);
                    invalidateDependents(buildingBlocks, store, a);
                    (_a = storeHooks.c) == null || _a.call(storeHooks, a);
                }
                return void 0;
            } else return writeAtomState(buildingBlocks, store, a, args2);
        } finally{
            if (!isSync) {
                recomputeInvalidatedAtoms(buildingBlocks, store);
                flushCallbacks(buildingBlocks, store);
            }
        }
    };
    try {
        return atomWrite.apply(void 0, [
            buildingBlocks,
            store,
            atom,
            getter,
            setter
        ].concat((0, $XnYkK._)(args)));
    } finally{
        isSync = false;
    }
};
var $c9acb133012436ec$var$BUILDING_BLOCK_mountDependencies = function(buildingBlocks, store, atom) {
    var _a;
    var mountedMap = buildingBlocks[1];
    var changedAtoms = buildingBlocks[3];
    var storeHooks = buildingBlocks[6];
    var ensureAtomState = buildingBlocks[11];
    var invalidateDependents = buildingBlocks[15];
    var mountAtom = buildingBlocks[18];
    var unmountAtom = buildingBlocks[19];
    var atomState = ensureAtomState(buildingBlocks, store, atom);
    var mounted = mountedMap.get(atom);
    if (mounted && atomState.d.size > 0) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = atomState.d[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $6iP9u._)(_step.value, 2), a = _step_value[0], n = _step_value[1];
                if (!mounted.d.has(a)) {
                    var aState = ensureAtomState(buildingBlocks, store, a);
                    var aMounted = mountAtom(buildingBlocks, store, a);
                    aMounted.t.add(atom);
                    mounted.d.add(a);
                    if (n !== aState.n) {
                        changedAtoms.add(a);
                        invalidateDependents(buildingBlocks, store, a);
                        (_a = storeHooks.c) == null || _a.call(storeHooks, a);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = mounted.d[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var a1 = _step1.value;
                if (!atomState.d.has(a1)) {
                    mounted.d.delete(a1);
                    var aMounted1 = unmountAtom(buildingBlocks, store, a1);
                    aMounted1 == null || aMounted1.t.delete(atom);
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
};
var $c9acb133012436ec$var$BUILDING_BLOCK_mountAtom = function(buildingBlocks, store, atom) {
    var _a;
    var mountedMap = buildingBlocks[1];
    var mountCallbacks = buildingBlocks[4];
    var storeHooks = buildingBlocks[6];
    var atomOnMount = buildingBlocks[10];
    var ensureAtomState = buildingBlocks[11];
    var flushCallbacks = buildingBlocks[12];
    var recomputeInvalidatedAtoms = buildingBlocks[13];
    var readAtomState = buildingBlocks[14];
    var writeAtomState = buildingBlocks[16];
    var mountAtom = buildingBlocks[18];
    var atomState = ensureAtomState(buildingBlocks, store, atom);
    var mounted = mountedMap.get(atom);
    if (!mounted) {
        readAtomState(buildingBlocks, store, atom);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = atomState.d.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var a = _step.value;
                var aMounted = mountAtom(buildingBlocks, store, a);
                aMounted.t.add(atom);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        mounted = {
            l: /* @__PURE__ */ new Set(),
            d: new Set(atomState.d.keys()),
            t: /* @__PURE__ */ new Set()
        };
        mountedMap.set(atom, mounted);
        if ($c9acb133012436ec$export$7c24d1ef3bea9769(atom) && $c9acb133012436ec$var$hasOnMount(atom)) {
            var processOnMount = function() {
                var isSync = true;
                var setAtom = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    try {
                        return writeAtomState(buildingBlocks, store, atom, args);
                    } finally{
                        if (!isSync) {
                            recomputeInvalidatedAtoms(buildingBlocks, store);
                            flushCallbacks(buildingBlocks, store);
                        }
                    }
                };
                try {
                    var onUnmount = atomOnMount(buildingBlocks, store, atom, setAtom);
                    if (onUnmount) mounted.u = function() {
                        isSync = true;
                        try {
                            onUnmount();
                        } finally{
                            isSync = false;
                        }
                    };
                } finally{
                    isSync = false;
                }
            };
            mountCallbacks.add(processOnMount);
        }
        (_a = storeHooks.m) == null || _a.call(storeHooks, atom);
    }
    return mounted;
};
var $c9acb133012436ec$var$BUILDING_BLOCK_unmountAtom = function(buildingBlocks, store, atom) {
    var _a, _b;
    var mountedMap = buildingBlocks[1];
    var unmountCallbacks = buildingBlocks[5];
    var storeHooks = buildingBlocks[6];
    var ensureAtomState = buildingBlocks[11];
    var unmountAtom = buildingBlocks[19];
    var atomState = ensureAtomState(buildingBlocks, store, atom);
    var mounted = mountedMap.get(atom);
    if (!mounted || mounted.l.size) return mounted;
    var isDependent = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = mounted.t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var a = _step.value;
            if ((_a = mountedMap.get(a)) == null ? void 0 : _a.d.has(atom)) {
                isDependent = true;
                break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!isDependent) {
        if (mounted.u) unmountCallbacks.add(mounted.u);
        mounted = void 0;
        mountedMap.delete(atom);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = atomState.d.keys()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var a1 = _step1.value;
                var aMounted = unmountAtom(buildingBlocks, store, a1);
                aMounted == null || aMounted.t.delete(atom);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        (_b = storeHooks.u) == null || _b.call(storeHooks, atom);
        return void 0;
    }
    return mounted;
};
var $c9acb133012436ec$var$BUILDING_BLOCK_setAtomStateValueOrPromise = function(buildingBlocks, store, atom, valueOrPromise) {
    var ensureAtomState = buildingBlocks[11];
    var abortPromise = buildingBlocks[27];
    var atomState = ensureAtomState(buildingBlocks, store, atom);
    var hasPrevValue = "v" in atomState;
    var prevValue = atomState.v;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($c9acb133012436ec$export$5ab0738ada359ec5(valueOrPromise)) try {
        for(var _iterator = atomState.d.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var a = _step.value;
            $c9acb133012436ec$export$82a1790dbcdcfc9f(atom, valueOrPromise, ensureAtomState(buildingBlocks, store, a));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    atomState.v = valueOrPromise;
    delete atomState.e;
    if (!hasPrevValue || !Object.is(prevValue, atomState.v)) {
        ++atomState.n;
        if ($c9acb133012436ec$export$5ab0738ada359ec5(prevValue)) abortPromise(buildingBlocks, store, prevValue);
    }
};
var $c9acb133012436ec$var$BUILDING_BLOCK_storeGet = function(buildingBlocks, store, atom) {
    var readAtomState = buildingBlocks[14];
    return $c9acb133012436ec$export$696d075174b4543b(readAtomState(buildingBlocks, store, atom));
};
var $c9acb133012436ec$var$BUILDING_BLOCK_storeSet = function(buildingBlocks, store, atom) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        args[_key - 3] = arguments[_key];
    }
    var changedAtoms = buildingBlocks[3];
    var flushCallbacks = buildingBlocks[12];
    var recomputeInvalidatedAtoms = buildingBlocks[13];
    var writeAtomState = buildingBlocks[16];
    var prevChangedAtomsSize = changedAtoms.size;
    try {
        return writeAtomState(buildingBlocks, store, atom, args);
    } finally{
        if (changedAtoms.size !== prevChangedAtomsSize) {
            recomputeInvalidatedAtoms(buildingBlocks, store);
            flushCallbacks(buildingBlocks, store);
        }
    }
};
var $c9acb133012436ec$var$BUILDING_BLOCK_storeSub = function(buildingBlocks, store, atom, listener) {
    var flushCallbacks = buildingBlocks[12];
    var recomputeInvalidatedAtoms = buildingBlocks[13];
    var mountAtom = buildingBlocks[18];
    var unmountAtom = buildingBlocks[19];
    var mounted = mountAtom(buildingBlocks, store, atom);
    var listeners = mounted.l;
    listeners.add(listener);
    recomputeInvalidatedAtoms(buildingBlocks, store);
    flushCallbacks(buildingBlocks, store);
    return function() {
        listeners.delete(listener);
        unmountAtom(buildingBlocks, store, atom);
        recomputeInvalidatedAtoms(buildingBlocks, store);
        flushCallbacks(buildingBlocks, store);
    };
};
var $c9acb133012436ec$var$BUILDING_BLOCK_registerAbortHandler = function(buildingBlocks, _store, promise, abortHandler) {
    var abortHandlersMap = buildingBlocks[25];
    var abortHandlers = abortHandlersMap.get(promise);
    if (!abortHandlers) {
        abortHandlers = /* @__PURE__ */ new Set();
        abortHandlersMap.set(promise, abortHandlers);
        var cleanup = function() {
            return abortHandlersMap.delete(promise);
        };
        promise.then(cleanup, cleanup);
    }
    abortHandlers.add(abortHandler);
};
var $c9acb133012436ec$var$BUILDING_BLOCK_abortPromise = function(buildingBlocks, _store, promise) {
    var abortHandlersMap = buildingBlocks[25];
    var abortHandlers = abortHandlersMap.get(promise);
    abortHandlers == null || abortHandlers.forEach(function(fn) {
        return fn();
    });
};
var $c9acb133012436ec$var$buildingBlockMap = /* @__PURE__ */ new WeakMap();
function $c9acb133012436ec$export$67edddd3275fb47c(store) {
    var buildingBlocks = $c9acb133012436ec$var$buildingBlockMap.get(store);
    if (($c9acb133012436ec$import_meta.env ? $c9acb133012436ec$import_meta.env.MODE : void 0) !== "production" && !buildingBlocks) throw new Error("Store must be created by buildStore to read its building blocks");
    var enhanceBuildingBlocks = buildingBlocks[24];
    if (enhanceBuildingBlocks) return enhanceBuildingBlocks(buildingBlocks, store);
    return buildingBlocks;
}
function $c9acb133012436ec$export$1b8bba60163162e5() {
    for(var _len = arguments.length, partialBuildingBlocks = new Array(_len), _key = 0; _key < _len; _key++){
        partialBuildingBlocks[_key] = arguments[_key];
    }
    var store = {
        get: function(atom) {
            return storeGet(buildingBlocks, store, atom);
        },
        set: function(atom) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return storeSet.apply(void 0, [
                buildingBlocks,
                store,
                atom
            ].concat((0, $XnYkK._)(args)));
        },
        sub: function(atom, listener) {
            return storeSub(buildingBlocks, store, atom, listener);
        }
    };
    var buildingBlocks = [
        // store state
        /* @__PURE__ */ new WeakMap(),
        // atomStateMap
        /* @__PURE__ */ new WeakMap(),
        // mountedMap
        /* @__PURE__ */ new WeakMap(),
        // invalidatedAtoms
        /* @__PURE__ */ new Set(),
        // changedAtoms
        /* @__PURE__ */ new Set(),
        // mountCallbacks
        /* @__PURE__ */ new Set(),
        // unmountCallbacks
        {},
        // storeHooks
        // atom interceptors
        $c9acb133012436ec$var$BUILDING_BLOCK_atomRead,
        $c9acb133012436ec$var$BUILDING_BLOCK_atomWrite,
        $c9acb133012436ec$var$BUILDING_BLOCK_atomOnInit,
        $c9acb133012436ec$var$BUILDING_BLOCK_atomOnMount,
        // building-block functions
        $c9acb133012436ec$var$BUILDING_BLOCK_ensureAtomState,
        $c9acb133012436ec$var$BUILDING_BLOCK_flushCallbacks,
        $c9acb133012436ec$var$BUILDING_BLOCK_recomputeInvalidatedAtoms,
        $c9acb133012436ec$var$BUILDING_BLOCK_readAtomState,
        $c9acb133012436ec$var$BUILDING_BLOCK_invalidateDependents,
        $c9acb133012436ec$var$BUILDING_BLOCK_writeAtomState,
        $c9acb133012436ec$var$BUILDING_BLOCK_mountDependencies,
        $c9acb133012436ec$var$BUILDING_BLOCK_mountAtom,
        $c9acb133012436ec$var$BUILDING_BLOCK_unmountAtom,
        $c9acb133012436ec$var$BUILDING_BLOCK_setAtomStateValueOrPromise,
        $c9acb133012436ec$var$BUILDING_BLOCK_storeGet,
        $c9acb133012436ec$var$BUILDING_BLOCK_storeSet,
        $c9acb133012436ec$var$BUILDING_BLOCK_storeSub,
        void 0,
        // enhanceBuildingBlocks
        // abortable promise support
        /* @__PURE__ */ new WeakMap(),
        // abortHandlersMap
        $c9acb133012436ec$var$BUILDING_BLOCK_registerAbortHandler,
        $c9acb133012436ec$var$BUILDING_BLOCK_abortPromise,
        // store epoch
        [
            0
        ]
    ].map(function(fn, i) {
        return partialBuildingBlocks[i] || fn;
    });
    $c9acb133012436ec$var$buildingBlockMap.set(store, Object.freeze(buildingBlocks));
    var storeGet = buildingBlocks[21];
    var storeSet = buildingBlocks[22];
    var storeSub = buildingBlocks[23];
    return store;
}


var $6b6b001ed046ba94$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/jotai/esm/vanilla.mjs"
});
var $6b6b001ed046ba94$var$keyCount = 0;
function $6b6b001ed046ba94$export$5fb5cc0d078610b(read, write) {
    var key = "atom".concat(++$6b6b001ed046ba94$var$keyCount);
    var config = {
        toString: function() {
            return ($6b6b001ed046ba94$import_meta.env ? $6b6b001ed046ba94$import_meta.env.MODE : void 0) !== "production" && this.debugLabel ? key + ":" + this.debugLabel : key;
        }
    };
    if (typeof read === "function") config.read = read;
    else {
        config.init = read;
        config.read = $6b6b001ed046ba94$var$defaultRead;
        config.write = $6b6b001ed046ba94$var$defaultWrite;
    }
    if (write) config.write = write;
    return config;
}
function $6b6b001ed046ba94$var$defaultRead(get) {
    return get(this);
}
function $6b6b001ed046ba94$var$defaultWrite(get, set, arg) {
    return set(this, typeof arg === "function" ? arg(get(this)) : arg);
}
var $6b6b001ed046ba94$var$overriddenCreateStore;
function $6b6b001ed046ba94$export$cfdd58e14a91411a(fn) {
    $6b6b001ed046ba94$var$overriddenCreateStore = fn($6b6b001ed046ba94$var$overriddenCreateStore);
}
function $6b6b001ed046ba94$export$f51a9068ac82ea43() {
    if ($6b6b001ed046ba94$var$overriddenCreateStore) return $6b6b001ed046ba94$var$overriddenCreateStore();
    return (0, $c9acb133012436ec$export$1b8bba60163162e5)();
}
var $6b6b001ed046ba94$var$defaultStore;
function $6b6b001ed046ba94$export$39b2e4393dfcb8aa() {
    if (!$6b6b001ed046ba94$var$defaultStore) {
        $6b6b001ed046ba94$var$defaultStore = $6b6b001ed046ba94$export$f51a9068ac82ea43();
        if (($6b6b001ed046ba94$import_meta.env ? $6b6b001ed046ba94$import_meta.env.MODE : void 0) !== "production") {
            globalThis.__JOTAI_DEFAULT_STORE__ || (globalThis.__JOTAI_DEFAULT_STORE__ = $6b6b001ed046ba94$var$defaultStore);
            if (globalThis.__JOTAI_DEFAULT_STORE__ !== $6b6b001ed046ba94$var$defaultStore) console.warn("Detected multiple Jotai instances. It may cause unexpected behavior with the default store. https://github.com/pmndrs/jotai/discussions/2044");
        }
    }
    return $6b6b001ed046ba94$var$defaultStore;
}



var $e2578e2a154a0e06$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/jotai/esm/react.mjs"
});
'use client';
var $e2578e2a154a0e06$var$StoreContext = (0, $5s1kH.createContext)(void 0);
function $e2578e2a154a0e06$export$6ccbb43953eebf8(options) {
    var store = (0, $5s1kH.useContext)($e2578e2a154a0e06$var$StoreContext);
    return (options == null ? void 0 : options.store) || store || (0, $6b6b001ed046ba94$export$39b2e4393dfcb8aa)();
}
function $e2578e2a154a0e06$export$2881499e37b75b9a(param) {
    var children = param.children, store = param.store;
    var storeRef = (0, $5s1kH.useRef)(null);
    if (store) return (0, $5s1kH.createElement)($e2578e2a154a0e06$var$StoreContext.Provider, {
        value: store
    }, children);
    if (storeRef.current === null) storeRef.current = (0, $6b6b001ed046ba94$export$f51a9068ac82ea43)();
    return (0, $5s1kH.createElement)($e2578e2a154a0e06$var$StoreContext.Provider, {
        // TODO: If this is not a false positive, consider using useState instead of useRef like https://github.com/pmndrs/jotai/pull/2771
        // eslint-disable-next-line react-hooks/refs
        value: storeRef.current
    }, children);
}
var $e2578e2a154a0e06$var$isPromiseLike = function(x) {
    return typeof (x == null ? void 0 : x.then) === "function";
};
var $e2578e2a154a0e06$var$attachPromiseStatus = function(promise) {
    if (!promise.status) {
        promise.status = "pending";
        promise.then(function(v) {
            promise.status = "fulfilled";
            promise.value = v;
        }, function(e) {
            promise.status = "rejected";
            promise.reason = e;
        });
    }
};
var $e2578e2a154a0e06$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).use || // A shim for older React versions
function(promise) {
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        $e2578e2a154a0e06$var$attachPromiseStatus(promise);
        throw promise;
    }
};
var $e2578e2a154a0e06$var$continuablePromiseMap = /* @__PURE__ */ new WeakMap();
var $e2578e2a154a0e06$var$createContinuablePromise = function(store, promise, getValue) {
    var buildingBlocks = (0, $c9acb133012436ec$export$67edddd3275fb47c)(store);
    var registerAbortHandler = buildingBlocks[26];
    var continuablePromise = $e2578e2a154a0e06$var$continuablePromiseMap.get(promise);
    if (!continuablePromise) {
        continuablePromise = new Promise(function(resolve, reject) {
            var curr = promise;
            var onFulfilled = function(me) {
                return function(v) {
                    if (curr === me) resolve(v);
                };
            };
            var onRejected = function(me) {
                return function(e) {
                    if (curr === me) reject(e);
                };
            };
            var onAbort = function() {
                try {
                    var nextValue = getValue();
                    if ($e2578e2a154a0e06$var$isPromiseLike(nextValue)) {
                        $e2578e2a154a0e06$var$continuablePromiseMap.set(nextValue, continuablePromise);
                        curr = nextValue;
                        nextValue.then(onFulfilled(nextValue), onRejected(nextValue));
                        registerAbortHandler(buildingBlocks, store, nextValue, onAbort);
                    } else resolve(nextValue);
                } catch (e) {
                    reject(e);
                }
            };
            promise.then(onFulfilled(promise), onRejected(promise));
            registerAbortHandler(buildingBlocks, store, promise, onAbort);
        });
        $e2578e2a154a0e06$var$continuablePromiseMap.set(promise, continuablePromise);
    }
    return continuablePromise;
};
function $e2578e2a154a0e06$export$89a40582f8c436cc(atom, options) {
    var _ref = options || {}, delay = _ref.delay, tmp = _ref.unstable_promiseStatus, promiseStatus = tmp === void 0 ? !(0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).use : tmp;
    var store = $e2578e2a154a0e06$export$6ccbb43953eebf8(options);
    var _useReducer = (0, $6iP9u._)((0, $5s1kH.useReducer)(function(prev) {
        var nextValue = store.get(atom);
        if (Object.is(prev[0], nextValue) && prev[1] === store && prev[2] === atom) return prev;
        return [
            nextValue,
            store,
            atom
        ];
    }, void 0, function() {
        return [
            store.get(atom),
            store,
            atom
        ];
    }), 2), _useReducer_ = (0, $6iP9u._)(_useReducer[0], 3), valueFromReducer = _useReducer_[0], storeFromReducer = _useReducer_[1], atomFromReducer = _useReducer_[2], rerender = _useReducer[1];
    var value = valueFromReducer;
    if (storeFromReducer !== store || atomFromReducer !== atom) {
        rerender();
        value = store.get(atom);
    }
    (0, $5s1kH.useEffect)(function() {
        var unsub = store.sub(atom, function() {
            if (promiseStatus) try {
                var value2 = store.get(atom);
                if ($e2578e2a154a0e06$var$isPromiseLike(value2)) $e2578e2a154a0e06$var$attachPromiseStatus($e2578e2a154a0e06$var$createContinuablePromise(store, value2, function() {
                    return store.get(atom);
                }));
            } catch (e) {}
            if (typeof delay === "number") {
                console.warn("[DEPRECATED] delay option is deprecated and will be removed in v3.\n\nMigration guide:\n\nCreate a custom hook like the following.\n\nfunction useAtomValueWithDelay<Value>(\n  atom: Atom<Value>,\n  options: { delay: number },\n): Value {\n  const { delay } = options\n  const store = useStore(options)\n  const [value, setValue] = useState(() => store.get(atom))\n  useEffect(() => {\n    const unsub = store.sub(atom, () => {\n      setTimeout(() => setValue(store.get(atom)), delay)\n    })\n    return unsub\n  }, [store, atom, delay])\n  return value\n}\n");
                setTimeout(rerender, delay);
                return;
            }
            rerender();
        });
        rerender();
        return unsub;
    }, [
        store,
        atom,
        delay,
        promiseStatus
    ]);
    (0, $5s1kH.useDebugValue)(value);
    if ($e2578e2a154a0e06$var$isPromiseLike(value)) {
        var promise = $e2578e2a154a0e06$var$createContinuablePromise(store, value, function() {
            return store.get(atom);
        });
        if (promiseStatus) $e2578e2a154a0e06$var$attachPromiseStatus(promise);
        return $e2578e2a154a0e06$var$use(promise);
    }
    return value;
}
function $e2578e2a154a0e06$export$a247c952d39ea7ea(atom, options) {
    var store = $e2578e2a154a0e06$export$6ccbb43953eebf8(options);
    var setAtom = (0, $5s1kH.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _store;
        if (($e2578e2a154a0e06$import_meta.env ? $e2578e2a154a0e06$import_meta.env.MODE : void 0) !== "production" && !("write" in atom)) throw new Error("not writable atom");
        return (_store = store).set.apply(_store, [
            atom
        ].concat((0, $XnYkK._)(args)));
    }, [
        store,
        atom
    ]);
    return setAtom;
}
function $e2578e2a154a0e06$export$83cf7ae8bb57e7ed(atom, options) {
    return [
        $e2578e2a154a0e06$export$89a40582f8c436cc(atom, options),
        // We do wrong type assertion here, which results in throwing an error.
        $e2578e2a154a0e06$export$a247c952d39ea7ea(atom, options)
    ];
}



var $89a4535aba887275$export$cde9a322e13eb845 = (0, $6b6b001ed046ba94$export$5fb5cc0d078610b)(0);
var $89a4535aba887275$export$6629aba53c1d79c3 = (0, $6b6b001ed046ba94$export$5fb5cc0d078610b)([]);
var $89a4535aba887275$export$27d71ceb0a5d4830 = (0, $6b6b001ed046ba94$export$5fb5cc0d078610b)([]);
var $89a4535aba887275$export$bcd68c06e4ab205 = (0, $6b6b001ed046ba94$export$5fb5cc0d078610b)([]);
var $89a4535aba887275$export$8089542cc82d07d0 = (0, $6b6b001ed046ba94$export$5fb5cc0d078610b)(0);
var $89a4535aba887275$export$f6340943ad252ff2 = (0, $6b6b001ed046ba94$export$5fb5cc0d078610b)(null);
var $89a4535aba887275$export$3e88fe72f2048427 = (0, $6b6b001ed046ba94$export$5fb5cc0d078610b)(localStorage.getItem('language') === 'sv' ? 'sv' : 'en');
var $89a4535aba887275$export$af51c67eaab3b0e9 = (0, $6b6b001ed046ba94$export$5fb5cc0d078610b)(null);
var $89a4535aba887275$export$e12ef450b148e207 = (0, $6b6b001ed046ba94$export$5fb5cc0d078610b)(0);
var $89a4535aba887275$export$8ded2467eceddfeb = (0, $6b6b001ed046ba94$export$5fb5cc0d078610b)([]);
var $89a4535aba887275$export$b8c60edfdda1ff8f = (0, $6b6b001ed046ba94$export$5fb5cc0d078610b)(false);
var $89a4535aba887275$export$12972e612ad7cf0 = (0, $6b6b001ed046ba94$export$5fb5cc0d078610b)(null);


var $c7f12a560df7b55e$var$NavMini = function(props) {
    var navigate = (0, $bHX26.useNavigate)();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t;
    var _useAtom = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$3e88fe72f2048427)), 1), lang = _useAtom[0];
    var logout = (0, $65283fdff51e8344$export$f2b63d3ca66bb884)().logout;
    var calculateMenuItems = function() {
        var items = [];
        items.push({
            id: 6,
            title: t("my-account"),
            onClick: function() {
                return navigate("/account");
            },
            icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($bf234ba9a155a985$exports))),
                alt: "account"
            })
        });
        items.push({
            id: 7,
            title: t("menu-support"),
            onClick: function() {
                return navigate("/support");
            },
            icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($edde00260b2e011e$exports))),
                alt: "support"
            }),
            divider: true
        });
        if (props.debug && (0, $632c75b97b900307$export$1630b5343357e8b5).SYSTEM !== "production" && (0, $632c75b97b900307$export$1630b5343357e8b5).USER_TYPE === "client") items.push({
            id: 8,
            title: "AI system (debug)",
            onClick: function() {
                return navigate("/ai_system");
            },
            icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($cb70cc925ae09565$exports))),
                alt: "AI"
            }),
            divider: true
        });
        items.push({
            id: 9,
            title: lang === "en" ? "SWE" : "ENG",
            onClick: props.changeLanguage,
            icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: lang === "en" ? (0, (/*@__PURE__*/$parcel$interopDefault($c2dcd914cb0438f4$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($e7641a398e8dd1fb$exports))),
                alt: "language"
            })
        });
        return items;
    };
    var combinedMenuItems = calculateMenuItems();
    var clientLogout = function() {
        logout({
            logoutParams: {
                clientId: (0, $632c75b97b900307$export$1630b5343357e8b5).AUTH0_CLIENT_ID,
                returnTo: (0, $632c75b97b900307$export$1630b5343357e8b5).APP_HOST
            }
        }).then();
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "bg-indigo-800 p-2 w-68 rounded-md",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "grid gap-y-2 w-full",
                children: combinedMenuItems.map(function(item) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex items-center gap-x-4 p-2 z-title2 hover:bg-indigo-700 text-white cursor-pointer rounded-md",
                                onClick: function() {
                                    item.onClick();
                                },
                                children: [
                                    item.icon,
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                        children: item.title
                                    }),
                                    item.badge && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "rounded-full bg-cherry-500 h-2 w-2"
                                    })
                                ]
                            }),
                            item.divider && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                className: "border-indigo-700 mt-2"
                            })
                        ]
                    }, item.id);
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-700 w-full my-2"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center gap-x-4 p-2 z-title2 hover:bg-indigo-700 text-white hover:text-white cursor-pointer w-full rounded-md",
                        onClick: function() {
                            return clientLogout();
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cb7edd55bc5ce05d$exports))),
                                alt: "logout"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                children: t("logout")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $c7f12a560df7b55e$export$2e2bcd8739ae039 = $c7f12a560df7b55e$var$NavMini;



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");

var $cf4f087e7dff53f9$exports = {};
$cf4f087e7dff53f9$exports = $parcel$resolve("aKgPK");



var $432e067a07c879a2$exports = {};
$432e067a07c879a2$exports = $parcel$resolve("1FLw5");


var $6347599e234591fd$exports = {};
$6347599e234591fd$exports = $parcel$resolve("aiY8O");


var $04ea003f37bd7a85$exports = {};
$04ea003f37bd7a85$exports = $parcel$resolve("eEoDx");


var $0a23199b5f09d5b9$exports = {};
$0a23199b5f09d5b9$exports = $parcel$resolve("dn3A4");


var $bca3803e97b2f8cf$exports = {};
$bca3803e97b2f8cf$exports = $parcel$resolve("5su4n");


var $a95f951aab95d2f0$exports = {};
$a95f951aab95d2f0$exports = $parcel$resolve("7gHqV");



var $6a8934e17fe6bbbb$exports = {};
$6a8934e17fe6bbbb$exports = $parcel$resolve("7KwfP");









var $66a09fc2f3d74e63$exports = {};
$66a09fc2f3d74e63$exports = $parcel$resolve("isz2k");


var $5ed9bce35a180ef3$exports = {};
$5ed9bce35a180ef3$exports = $parcel$resolve("5sAlU");


var $b12489d6f28ed582$exports = {};
$b12489d6f28ed582$exports = $parcel$resolve("a6GIT");


var $07ace4e0b313d326$exports = {};
$07ace4e0b313d326$exports = $parcel$resolve("iWxsH");


var $990e0e828cb73094$exports = {};
$990e0e828cb73094$exports = $parcel$resolve("1viWo");


var $472ec244e432c4a2$exports = {};
$472ec244e432c4a2$exports = $parcel$resolve("hEP1W");





var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $hwO3w = parcelRequire("hwO3w");

var $54Czb = parcelRequire("54Czb");


var $5s1kH = parcelRequire("5s1kH");

var $hwO3w = parcelRequire("hwO3w");
var $11c2f76dff20cf88$var$store = {
    data: {
        size: 24,
        strokeWidth: 2,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }
};
function $11c2f76dff20cf88$export$fa23577ed00dcf0e() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    $11c2f76dff20cf88$var$store.data = options.override ? data : (0, $hwO3w._)({}, $11c2f76dff20cf88$var$store.data, data);
}
function $11c2f76dff20cf88$export$6fec604aa7293d0c() {
    return (0, $hwO3w._)({}, $11c2f76dff20cf88$var$store.data);
}


var $55c03152d749d817$export$20931e2295160b07 = (0, $5s1kH.forwardRef)(function(props, ref) {
    var width = props.width, height = props.height, // custom
    size = props.size, otherProps = (0, $54Czb._)(props, [
        "width",
        "height",
        "size"
    ]);
    var theme = (0, $11c2f76dff20cf88$export$6fec604aa7293d0c)();
    var mergedProps = (0, $5s1kH.useMemo)(function() {
        var _props = (0, $hwO3w._)({}, otherProps);
        for(var _key in theme){
            var key = _key;
            if (key === "size") continue;
            var _props_key;
            _props[key] = (_props_key = _props[key]) !== null && _props_key !== void 0 ? _props_key : theme[key];
        }
        return _props;
    }, [
        otherProps,
        theme
    ]);
    var _ref, _ref1, _ref2, _ref3;
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("svg", (0, $hwO3w._)({
        ref: ref,
        width: (_ref1 = (_ref = width !== null && width !== void 0 ? width : size) !== null && _ref !== void 0 ? _ref : theme.width) !== null && _ref1 !== void 0 ? _ref1 : theme.size,
        height: (_ref3 = (_ref2 = height !== null && height !== void 0 ? height : size) !== null && _ref2 !== void 0 ? _ref2 : theme.height) !== null && _ref3 !== void 0 ? _ref3 : theme.size
    }, mergedProps));
});


var $02fde5f3ee8c239d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m19 9-7 7-7-7"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $da99fd9c7ed98d63$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m15 19-7-7 7-7"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $15fd01e2553ffce7$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m9 5 7 7-7 7"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $dc3602ab060f33ec$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m5 15 7-7 7 7"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $6c30b6ee57509466$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 15v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2m-8 1V4m0 12-4-4m4 4 4-4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $198945be8589b654$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 19V5m0 14-4-4m4 4 4-4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b9c4d2cad44b2075$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 12H4m12 0-4 4m4-4-4-4m3-4h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $7224227278737721$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 12h14M5 12l4-4m-4 4 4 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $e20322a343a9f31f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16.153 19 21 12l-4.847-7H3l4.848 7L3 19z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $827d66e4c28fd007$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $bc7f0dcb16dcf4fb$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19 12H5m14 0-4 4m4-4-4-4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $935b95b02f24feec$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 4v16M7 4l3 3M7 4 4 7m9-3h6l-6 6h6m-6.5 10 3.5-7 3.5 7M14 18h4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $9dc04617b1cf0843$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 20V7m0 13-4-4m4 4 4-4m4-12v13m0-13 4 4m-4-4-4 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $eeb62994ca00c1d5$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 15v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2M12 4v12m0-12 4 4m-4-4L8 8"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $5de6b34f1e91bacc$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 4h4m0 0v4m0-4-5 5M8 20H4m0 0v-4m0 4 5-5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c10b3296920bb1d2$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 6v13m0-13 4 4m-4-4-4 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $9d69c3cdfde25c59$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m16 4 3 3H5v3m3 10-3-3h14v-3m-9-2.5 2-1.5v4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $d2023431fe1773a4$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m16 10 3-3m0 0-3-3m3 3H5v3m3 4-3 3m0 0 3 3m-3-3h14v-3"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b2b0b44857e2e01d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7.119 8h9.762a1 1 0 0 1 .772 1.636l-4.881 5.927a1 1 0 0 1-1.544 0l-4.88-5.927A1 1 0 0 1 7.118 8Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $51f38b6795bd5133$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 16.881V7.119a1 1 0 0 0-1.636-.772l-5.927 4.881a1 1 0 0 0 0 1.544l5.927 4.88a1 1 0 0 0 1.636-.77Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $09a9270b93a7c65f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 16.881V7.119a1 1 0 0 1 1.636-.772l5.927 4.881a1 1 0 0 1 0 1.544l-5.927 4.88A1 1 0 0 1 8 16.882Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $877d2c3f32f8202a$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 10 4-6 4 6zm8 4-4 6-4-6z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $7c94a3f4e8e158b3$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16.881 16H7.119a1 1 0 0 1-.772-1.636l4.881-5.927a1 1 0 0 1 1.544 0l4.88 5.927a1 1 0 0 1-.77 1.636Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $5af2dffa2e7fd96e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 7 4 4 4-4m-8 6 4 4 4-4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $697335abe8b808d8$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m17 16-4-4 4-4m-6 8-4-4 4-4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1aa11b232556193f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m7 16 4-4-4-4m6 8 4-4-4-4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c5dab927877d10f3$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m16 17-4-4-4 4m8-6-4-4-4 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $067e712460e4f408$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 10 4 4 4-4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $149f50257f0476fb$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m14 8-4 4 4 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b0bfba7b8a5b9f71$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m10 16 4-4-4-4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $855b632b60015f0a$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 15 4 4 4-4m0-6-4-4-4 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $baeea56a84f6e287$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m16 14-4-4-4 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $9209adc4daef1068$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 8h4V4m12 4h-4V4M4 16h4v4m12-4h-4v4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $227f07e762357c1f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 4H4m0 0v4m0-4 5 5m7-5h4m0 0v4m0-4-5 5M8 20H4m0 0v-4m0 4 5-5m7 5h4m0 0v-4m0 4-5-5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3aaf0709c67255c7$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4.248 19C3.22 15.77 5.275 8.232 12.466 8.232V6.079a1.025 1.025 0 0 1 1.644-.862l5.479 4.307a1.108 1.108 0 0 1 0 1.723l-5.48 4.307a1.026 1.026 0 0 1-1.643-.861v-2.154C5.275 13.616 4.248 19 4.248 19"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4288d4b6e574f6a5$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 9h4m0 0V5m0 4L4 4m15 5h-4m0 0V5m0 4 5-5M5 15h4m0 0v4m0-4-5 5m15-5h-4m0 0v4m0-4 5 5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4824fef4f6d5e60e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M21 9H8a5 5 0 0 0 0 10h9m4-10-4-4m4 4-4 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4f9ba5e266934d4d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $ed75c7ff26e65d4b$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.757 6 3.24 10.95a1.05 1.05 0 0 0 0 1.549l5.611 5.088m5.73-3.214v1.615a.948.948 0 0 1-1.524.845l-5.108-4.251a1.1 1.1 0 0 1 0-1.646l5.108-4.251a.95.95 0 0 1 1.524.846v1.7c3.312 0 6 2.979 6 6.654v1.329a.7.7 0 0 1-1.345.353 5.17 5.17 0 0 0-4.652-3.191z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $33322a0e5d843d71$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14.5 8.046H11V6.119c0-.921-.9-1.446-1.524-.894l-5.108 4.49a1.2 1.2 0 0 0 0 1.739l5.108 4.49c.624.556 1.524.027 1.524-.893v-1.928h2a3.023 3.023 0 0 1 3 3.046V19a5.593 5.593 0 0 0-1.5-10.954"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4fe68d2157e6162c$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m15.141 6 5.518 4.95a1.05 1.05 0 0 1 0 1.549l-5.612 5.088m-6.154-3.214v1.615a.95.95 0 0 0 1.525.845l5.108-4.251a1.1 1.1 0 0 0 0-1.646l-5.108-4.251a.95.95 0 0 0-1.525.846v1.7c-3.312 0-6 2.979-6 6.654v1.329a.7.7 0 0 0 1.344.353 5.17 5.17 0 0 1 4.652-3.191z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4b9e6b0240f52be6$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 16h13M4 16l4-4m-4 4 4 4M20 8H7m13 0-4 4m4-4-4-4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $bfbf3198175d5f25$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 20V10m0 10-3-3m3 3 3-3m5-13v10m0-10 3 3m-3-3-3 3"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $bd3d3c002b77e526$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 9h13a5 5 0 0 1 0 10H7M3 9l4-4M3 9l4 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b93b578a82fc33b6$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 4h1.5L8 16m0 0h8m-8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m.75-3H7.5M11 7H6.312M17 4v6m-3-3h6"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $532e324c2c6e77f7$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 4h1.5L9 16m0 0h8m-8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-8.5-3h9.25L19 7h-1M8 7h-.688M13 5v4m-2-2h4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1d9a63177d22df11$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 4h1.5L9 16m0 0h8m-8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-8.5-3h9.25L19 7H7.312"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $6d4a6137879b7f0a$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 18h14M5 18v3h14v-3M5 18l1-9h12l1 9M16 6v3m-4-3v3m-2-6h8v3h-8zm-1 9h.01v.01H9zm3 0h.01v.01H12zm3 0h.01v.01H15zm-6 3h.01v.01H9zm3 0h.01v.01H12zm3 0h.01v.01H15z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $0d31067bfc8105e0$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M8 7V6a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1M3 18v-7a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm8-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $dc211f3c562d9498$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 14h2m3 0h4m2 2h2m0 0h2m-2 0v2m0-2v-2m-5 4H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v4M3 10h18"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3e19a50ee2ee3e0c$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "square",
            strokeLinejoin: "round",
            d: "M16.5 15v1.5m0 0V18m0-1.5H15m1.5 0H18M3 9V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3M3 9v6a1 1 0 0 0 1 1h5M3 9h16m0 0v1M6 12h3m12 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1d6789a15cd66921$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 10h18M6 14h2m3 0h5M3 7v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $9ca2d68aec44b691$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 17.345a4.76 4.76 0 0 0 2.558 1.618c2.274.589 4.512-.446 4.999-2.31.487-1.866-1.273-3.9-3.546-4.49S7.977 9.54 8.464 7.675s2.724-2.899 4.998-2.31c.982.236 1.87.793 2.538 1.592m-3.879 12.171V21m0-18v2.2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $519cae72fe41505f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 10h9.231M6 14h9.231M18 5.086A5.95 5.95 0 0 0 14.615 4c-3.738 0-6.769 3.582-6.769 8s3.031 8 6.769 8A5.94 5.94 0 0 0 18 18.916"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c5dbbfbd7f47afd8$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m11 18-.854-.854a.5.5 0 0 1-.146-.353v-4.417a1 1 0 0 0-.247-.659L4.45 5.66C3.886 5.012 4.345 4 5.204 4h13.55c.866 0 1.323 1.025.744 1.669L16.5 9M14 18.375c.335.362.782.614 1.279.72.477.158 1 .14 1.464-.05s.834-.54 1.036-.977c.246-.829-.637-1.734-1.774-1.995s-2.016-1.16-1.773-1.995a1.95 1.95 0 0 1 1.035-.977c.464-.19.987-.208 1.464-.05.491.105.935.352 1.27.707m-1.94 5.41V20m0-8v.977"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $911bcfe83733fcfe$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 8h6m-6 4h6m-6 4h6M6 3v18l2-2 2 2 2-2 2 2 2-2 2 2V3l-2 2-2-2-2 2-2-2-2 2z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b769fb0a0d913661$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.891 15.107 15.11 8.89m-5.183-.52h.01m3.089 7.254h.01M14.08 3.902a2.85 2.85 0 0 0 2.176.902 2.845 2.845 0 0 1 2.94 2.94 2.85 2.85 0 0 0 .901 2.176 2.847 2.847 0 0 1 0 4.16 2.85 2.85 0 0 0-.901 2.175 2.843 2.843 0 0 1-2.94 2.94 2.85 2.85 0 0 0-2.176.902 2.847 2.847 0 0 1-4.16 0 2.85 2.85 0 0 0-2.176-.902 2.845 2.845 0 0 1-2.94-2.94 2.85 2.85 0 0 0-.901-2.176 2.85 2.85 0 0 1 0-4.16 2.85 2.85 0 0 0 .901-2.176 2.845 2.845 0 0 1 2.941-2.94 2.85 2.85 0 0 0 2.176-.901 2.847 2.847 0 0 1 4.159 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $5a955552add6f8d5$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5.5 21h13M12 21V7m0 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2-1.8c3.073.661 2.467 2.8 5 2.8M5 8c3.359 0 2.192-2.115 5.012-2.793M7 9.556V7.75m0 1.806-1.95 4.393a.773.773 0 0 0 .37.962.8.8 0 0 0 .362.089h2.436a.79.79 0 0 0 .643-.335.78.78 0 0 0 .09-.716zm10 0V7.313m0 2.243-1.95 4.393a.773.773 0 0 0 .37.962.8.8 0 0 0 .362.089h2.436a.79.79 0 0 0 .643-.335.78.78 0 0 0 .09-.716z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $96f0cb61b048930b$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 10V6a3 3 0 0 1 3-3v0a3 3 0 0 1 3 3v4m3-2 .917 11.923A1 1 0 0 1 17.92 21H6.08a1 1 0 0 1-.997-1.077L6 8z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $d7ab98b6acee7315$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 12c.263 0 .524-.06.767-.175a2 2 0 0 0 .65-.491c.186-.21.333-.46.433-.734s.15-.568.15-.864a2.4 2.4 0 0 0 .586 1.591c.375.422.884.659 1.414.659s1.04-.237 1.414-.659A2.4 2.4 0 0 0 12 9.736a2.4 2.4 0 0 0 .586 1.591c.375.422.884.659 1.414.659s1.04-.237 1.414-.659A2.4 2.4 0 0 0 16 9.736c0 .295.052.588.152.861s.248.521.434.73a2 2 0 0 0 .649.488 1.8 1.8 0 0 0 1.53 0 2 2 0 0 0 .65-.488c.185-.209.332-.457.433-.73s.152-.566.152-.861c0-.974-1.108-3.85-1.618-5.121A.98.98 0 0 0 17.466 4H6.456a.99.99 0 0 0-.93.645C5.045 5.962 4 8.905 4 9.736c.023.59.241 1.148.611 1.567.37.418.865.667 1.389.697m0 0c.328 0 .651-.091.94-.266A2.1 2.1 0 0 0 7.66 11h.681a2.1 2.1 0 0 0 .718.734c.29.175.613.266.942.266s.651-.091.94-.266c.29-.174.537-.427.719-.734h.681a2.1 2.1 0 0 0 .719.734c.289.175.612.266.94.266.329 0 .652-.091.942-.266.29-.174.536-.427.718-.734h.681c.183.307.43.56.719.734.29.174.613.266.941.266a1.8 1.8 0 0 0 1.06-.351M6 12a1.77 1.77 0 0 1-1.163-.476M5 12v7a1 1 0 0 0 1 1h2v-5h3v5h7a1 1 0 0 0 1-1v-7m-5 3v2h2v-2z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $956446466ead2eeb$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15.583 8.445h.01M10.86 19.71l-6.573-6.63a.993.993 0 0 1 0-1.4l7.329-7.394A.98.98 0 0 1 12.31 4l5.734.007A1.97 1.97 0 0 1 20 5.983v5.5a1 1 0 0 1-.316.727l-7.44 7.5a.974.974 0 0 1-1.384.001Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $bfef5e8faf1e386c$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14.079 6.839a3 3 0 0 0-4.255.1M13 20h1.083A3.916 3.916 0 0 0 18 16.083V9A6 6 0 1 0 6 9v7m7 4v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1m-7-4v-6H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2zm12-6h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $444838de87fbf755$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17 8H5m12 0a1 1 0 0 1 1 1v2.6M17 8l-4-4M5 8a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.6M5 8l4-4 4 4m6 4h-4a2 2 0 1 0 0 4h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $5342e357f069c414$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M12.143 11v9m0-9c-2.506-.71-3.191-1.395-6.137-1.35a.864.864 0 0 0-.863.85v7.288c0 .483.414.869.916.862 2.775-.036 3.46.656 6.084 1.35m0-9c2.505-.71 3.107-1.395 6.052-1.35.48.008.948.388.948.85v7.288c0 .483-.499.869-1 .862-2.775-.036-3.376.656-6 1.35m2-14a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $635303b0e4bf5474$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14.714 15h4.268c.404 0 .732-.384.732-.857V3.857c0-.473-.328-.857-.732-.857H6.714a1 1 0 0 0-1 1v4m11 7v-3h3v3zm-3 6h-7a1 1 0 0 1-1-1 3 3 0 0 1 3-3h3a3 3 0 0 1 3 3 1 1 0 0 1-1 1m-1-9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $edcf38438594ab8a$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M20 14H4m6.5 3L8 20m5.5-3 2.5 3M4.889 17H19.11c.491 0 .889-.416.889-.929V4.93c0-.513-.398-.929-.889-.929H4.89C4.398 4 4 4.416 4 4.929V16.07c0 .513.398.929.889.929M13 14v-3h4v3z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $89c2e8d32455b9c4$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m3.786 9.5 9 4.5 9-4.5-9-4.5zm0 0V17m3-6v6.222c0 .348 2 1.778 6 1.778s6-1.374 6-1.778V11"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $f35ec40566d4301c$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5.357 16V5.786c0-.434.348-.786.778-.786h12.444c.43 0 .778.352.778.786V16m-14 0h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1m-14 0h14m-10-8 2.625 2.5L9.357 13m4 0h2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $930162ab79c00514$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19.286 7V5.786A.78.78 0 0 0 18.508 5H6.063a.78.78 0 0 0-.777.786V16m0 0h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h5m-4-3h4m7-6v3a1 1 0 0 1-1 1h-3m8-3v8a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-5.397a1 1 0 0 1 .27-.683l2.433-2.603a1 1 0 0 1 .73-.317h3.567a1 1 0 0 1 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $8e1bc6b0a32b0072$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5.643 21h14m-3.35-12a5.42 5.42 0 0 1 1.35 3.591c0 2.987-2.396 5.409-5.352 5.409a5.34 5.34 0 0 1-4.648-2.725m-2-.275h6m.437-4.437L10.643 12m5.809-5.767 2.155-2.155M17.53 3l2.155 2.155M10.643 18v3m4-3v3m.731-15.845-4.31 4.311 2.155 2.155 4.31-4.31z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $6eb89b3dc9c7101a$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.571 5h7v9h-7m-6-4-3 4.5m3-4.5v5m0-5h3m0 0h5m-5 0v5m-3 0h3m-3 0v5m3-5v5m6-6 2.5 6m-3-6-2.5 6m-3-14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3570ae410bc5cda9$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "m7.143 11 5-6 5 6m-10 0h-3v8h16v-8h-3m-10 0h-4l3-4h4.337zm10 0h4l-3-4h-4.338zm-3 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $baa9cf61f7b4ba9b$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m7.286 11 5-6 5 6m-10 0h-3v8h8m-5-8h-4l3-4h4.337zm10 0h3v1m-3-1h4l-3-4h-4.338zm-2 6 2 2 4-4m-7-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b7810dffac7dd84d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.143 20v-9l-4 1.125V20zm0 0V6.667m0 13.333h3m5-9V6.667m0 4.333 4 1.125V13m-4-2v3m2-6-6-4-6 4m5 1h2m-2 3h2m1 6 2 2 4-4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $41ee3a061f5287a1$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17.5 19h-13v-8h3m0 0 5-6 5 6m-10 0h-4l3-4h4.337zm13 8h.01m-.01-3v-3m-6.337-6H18.5l2 2.5m-6 3.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $e5519c676598ab72$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.071 20v-9l-4 1.125V20zm0 0h8m-8 0V6.667m8 13.333v-9l1.5.422M16.071 20h1m-1 0V6.667m2 1.333-6-4-6 4m5 1h2m-2 3h2m7 8h.01m-.01-3v-4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3dfa88d01ae23c53$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m7.429 11 5-6 5 6m-10 0h-3v8h16v-8h-3m-10 0h-4l3-4h4.337zm10 0V7.5m-3 5.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m3-8v3h4V5z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $fc22220c7bf18929$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 20v-9l-4 1.125V20zm0 0h8m-8 0V6.667M16 20v-9l4 1.125V20zm0 0V7m0 0V4h4v3zM6 8l6-4 4 2.667M11 9h2m-2 3h2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $14638320aa3c4c25$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m7.357 11 5-6 3.333 4m-8.333 2h-3v8h7m-4-8h-4l3-4h4.337zm8.331-2L14.02 7h4.337l1.5 2m-8.324 5.898a2 2 0 1 1 1.502-3.708M16.357 15v-2.5a1.5 1.5 0 0 1 3 0V15m-4 0h5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3aa0ca57e3d60ead$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.214 20v-9l-4 1.125V20zm0 0V6.667m0 13.333h2m6-11V6.667m2 1.333-6-4-6 4m5 1h2m-2 3h1m3 4v-2.5a1.5 1.5 0 0 1 3 0V16m-4 0h5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $bd8cc97ff4fea4b6$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m16.976 15.464 1.767 1.768m0 0L20.511 19m-1.768-1.768L16.976 19m1.767-1.768 1.768-1.768M7.214 11l5-6 5 6m-10 0h-3v8h9.08m-6.08-8h-4l3-4h4.338zm10 0h3v1.557m-3-1.557h4l-3-4h-4.337zm-3 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $42dbace3a4778d4a$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.071 20v-9l-4 1.125V20zm0 0V6.667m0 13.333h4m4-9V6.667m0 4.333 4 1.125V13m-4-2v2m2-5-6-4-6 4m5 1h2m-2 3h2m3.015 4.409 1.768 1.768m0 0 1.768 1.767m-1.768-1.767-1.768 1.767m1.768-1.767 1.768-1.768"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $ebc0bdd9d614578e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 20v-9l-4 1.125V20zm0 0h8m-8 0V6.667M16 20v-9l4 1.125V20zm0 0V6.667M18 8l-6-4-6 4m5 1h2m-2 3h2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $fb1fd711f83914de$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M4.071 14v6h6v-6zm4.5-4h7l-3.5-6zm8 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4bbb5b80898257b5$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m7.533 11.862.01-.003m5.581 7.143c-.5.515-.92.847-1.06.89-.48.145-5.43-1.28-6.238-3.33-.81-2.051-1.831-5.816-1.89-6.22-.06-.404 1.56-1.724 3.597-2.61m1.989 8.055c-.227.262-.39.56-.556.847M13.5 12c.5.5 1 1.049 2 1.049S17 12.5 17.5 12m-4-4h.01m3.99 0h.01M10.5 5.5c0-.29 2.5-1.5 5-1.5s5 1.136 5 1.5V12c0 1.966-4.291 5-5 5-.743 0-5-3.034-5-5z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4aadb6cb5c9bad9e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14.614 7.2c.348.49.6 1.154.6 1.8a3 3 0 1 1-5.4-1.8M6.214 6v4m0-4 6-3 6 3-6 2-2.4-.8M6.214 6l3.6 1.2M6.214 19.8V17.65c0-1.683 1.273-3.308 2.951-3.649l3.05 2.935 3-2.945c1.702.32 3 1.96 3 3.659V19.8c0 .631-.538 1.143-1.2 1.143h-9.6c-.663 0-1.2-.512-1.2-1.143"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $896c88163b2ad930$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                fill: "currentColor",
                d: "M12 17a2 2 0 0 1 2 2h-4a2 2 0 0 1 2-2"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M13.815 9H16.5a2 2 0 1 0-1.03-3.707A2 2 0 0 0 15.5 5 1.992 1.992 0 0 0 12 3.69 1.992 1.992 0 0 0 8.5 5q.003.147.03.293A2 2 0 1 0 7.5 9h3.388m2.927-.985v3.604M10.228 9v2.574M15 16h.01M9 16h.01m11.962-4.426a1.805 1.805 0 0 1-1.74 1.326 1.89 1.89 0 0 1-1.811-1.326 1.9 1.9 0 0 1-3.621 0 1.8 1.8 0 0 1-1.749 1.326 1.98 1.98 0 0 1-1.87-1.326A1.76 1.76 0 0 1 8.46 12.9a2.035 2.035 0 0 1-1.905-1.326A1.9 1.9 0 0 1 4.74 12.9 1.805 1.805 0 0 1 3 11.574V12a9 9 0 0 0 18 0z"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $27a771f2f15e2bb4$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M17 13c0 2.038-2.239 4.5-5 4.5S7 15.038 7 13c0 1.444 10 1.444 10 0"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                fill: "currentColor",
                d: "m9 6.811.618 1.253 1.382.2-1 .975.236 1.377L9 9.966l-1.236.65L8 9.239l-1-.975 1.382-.2zm6 0 .618 1.253 1.382.2-1 .975.236 1.377L15 9.966l-1.236.65L14 9.239l-1-.975 1.382-.2z"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "m9 6.811.618 1.253 1.382.2-1 .975.236 1.377L9 9.966l-1.236.65L8 9.239l-1-.975 1.382-.2zm6 0 .618 1.253 1.382.2-1 .975.236 1.377L15 9.966l-1.236.65L14 9.239l-1-.975 1.382-.2z"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $fd4b3b5c137b2bd2$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14.99 9H15M8.99 9H9m12 3a9 9 0 1 1-18 0 9 9 0 0 1 18 0M7 13c0 1 .507 2.397 1.494 3.216a5.5 5.5 0 0 0 7.022 0C16.503 15.397 17 14 17 13c0 0-1.99 1-4.995 1S7 13 7 13"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $bb9c893a1249f6b4$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 9h.01M8.99 9H9m12 3a9 9 0 1 1-18 0 9 9 0 0 1 18 0M6.6 13a5.5 5.5 0 0 0 10.81 0z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $cd93d329812e7888$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17 13c-.889.086-1.416.543-2.156 1.057a22.3 22.3 0 0 0-3.958 5.084 1.6 1.6 0 0 1-.582.628 1.55 1.55 0 0 1-1.466.087 1.6 1.6 0 0 1-.537-.406 1.67 1.67 0 0 1-.384-1.279l1.389-4.114M17 13h3V6.5A1.5 1.5 0 0 0 18.5 5v0A1.5 1.5 0 0 0 17 6.5zm-6.5 1H5.585c-.286 0-.372-.014-.626-.15a1.8 1.8 0 0 1-.637-.572 1.87 1.87 0 0 1-.215-1.673l2.098-6.4C6.462 4.48 6.632 4 7.88 4c2.302 0 4.79.943 6.67 1.475"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $f879ea7b80970e89$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 11c.889-.086 1.416-.543 2.156-1.057a22.3 22.3 0 0 0 3.958-5.084 1.6 1.6 0 0 1 .582-.628 1.55 1.55 0 0 1 1.466-.087c.205.095.388.233.537.406a1.64 1.64 0 0 1 .384 1.279l-1.388 4.114M7 11H4v6.5A1.5 1.5 0 0 0 5.5 19v0A1.5 1.5 0 0 0 7 17.5zm6.5-1h4.915c.286 0 .372.014.626.15s.472.332.637.572a1.87 1.87 0 0 1 .215 1.673l-2.098 6.4C17.538 19.52 17.368 20 16.12 20c-2.303 0-4.79-.943-6.67-1.475"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $9aee7510a40e9463$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 11v5m0 0 2-2m-2 2-2-2M3 6v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1m2 2v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $5b8a32a9617b5727$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-6 7 2 2 4-4m-5-9v4h4V3z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $15c11443169cccf7$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-5-4v4h4V3z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b8b6fa84f3dd0485$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-3 5h3m-6 0h.01M12 16h3m-6 0h.01M10 3v4h4V3z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $aae99c7a55f84653$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-6 5h6m-6 4h6M10 3v4h4V3z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $01c06341fc5bdd12$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m4 10v-2m3 2v-6m3 6v-3m4-11v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4d2178441d528a98$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m4 6 2 2 4-4m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $420b9d73ee517209$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 9V4a1 1 0 0 0-1-1H8.914a1 1 0 0 0-.707.293L4.293 7.207A1 1 0 0 0 4 7.914V20a1 1 0 0 0 1 1h4M9 3v4a1 1 0 0 1-1 1H4m11 6v4m-2-2h4m3 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $15f0abe10c1dba02$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M15 4v3a1 1 0 0 1-1 1h-3m2 10v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L6.7 8.35A1 1 0 0 1 7.46 8H9m-1 4H4m16-7v10a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V7.87a1 1 0 0 1 .24-.65l2.46-2.87a1 1 0 0 1 .76-.35H19a1 1 0 0 1 1 1Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $cae5e6704cbde377$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m5 4-2 2 2 2m4-4 2 2-2 2m5-12v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $f653ed8544847659$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M14 4v3a1 1 0 0 1-1 1h-3m4 10v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2m11-3v10a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V7.87a1 1 0 0 1 .24-.65l2.46-2.87a1 1 0 0 1 .76-.35H18a1 1 0 0 1 1 1Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3a095be40475de96$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M9 8v3a1 1 0 0 1-1 1H5m11 4h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1m4 3v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L7.7 8.35A1 1 0 0 1 8.46 8H13a1 1 0 0 1 1 1Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $41763ffa99827b93$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 10V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v6M5 19v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1M10 3v4a1 1 0 0 1-1 1H5m2.665 9H6.647A1.647 1.647 0 0 1 5 15.353v-1.706A1.647 1.647 0 0 1 6.647 12h1.018M16 12l1.443 4.773L19 12m-6.057-.152-.943-.02a1.34 1.34 0 0 0-1.359 1.22 1.32 1.32 0 0 0 1.172 1.421l.536.059a1.273 1.273 0 0 1 1.226 1.718c-.2.571-.636.754-1.337.754h-1.13"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $17328d6390bb5358$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 10V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v6M5 19v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1M10 3v4a1 1 0 0 1-1 1H5m14 9.006h-.335a1.647 1.647 0 0 1-1.647-1.647v-1.706a1.647 1.647 0 0 1 1.647-1.647L19 12M5 12v5h1.375A1.626 1.626 0 0 0 8 15.375v-1.75A1.626 1.626 0 0 0 6.375 12zm9 1.5v2a1.5 1.5 0 0 1-1.5 1.5v0a1.5 1.5 0 0 1-1.5-1.5v-2a1.5 1.5 0 0 1 1.5-1.5v0a1.5 1.5 0 0 1 1.5 1.5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $a49e044212d6e45e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19 10V4a1 1 0 0 0-1-1H9.914a1 1 0 0 0-.707.293L5.293 7.207A1 1 0 0 0 5 7.914V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2M10 3v4a1 1 0 0 1-1 1H5m5 6h9m0 0-2-2m2 2-2 2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $f5d2db9ce2a3fd23$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                fill: "currentColor",
                d: "M16 18H8l2.5-6 2 4 1.5-2zm-1-8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M10 3v4a1 1 0 0 1-1 1H5m14-4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1M8 18h8l-2-4-1.5 2-2-4zm7-8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b0d1d1fc13f9acc4$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 12V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4m5-13v4a1 1 0 0 1-1 1H5m0 6h9m0 0-2-2m2 2-2 2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $ea27f27941272734$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m8-2h3m-3 3h3m-4 3v6m4-3H8M19 4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1M8 12v6h8v-6z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $9df1f6494be7637a$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $7f89e4d1431fa020$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m8 7.5V8s3 1 3 4m3-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1m-6 12c0 1.105-1.12 2-2.5 2S8 17.105 8 16s1.12-2 2.5-2 2.5.895 2.5 2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $322009c947521b3f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 20H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2.429M7 8h3M8 8V4h4v2m4 0V5h-4m3 4v3a1 1 0 0 1-1 1h-3m9-3v9a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-6.397a1 1 0 0 1 .27-.683l2.434-2.603a1 1 0 0 1 .73-.317H19a1 1 0 0 1 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $292f5d11ccf36104$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 17v-5h1.5a1.5 1.5 0 1 1 0 3H5m12 2v-5h2m-2 3h2M5 10V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v6M5 19v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1M10 3v4a1 1 0 0 1-1 1H5m6 4v5h1.375A1.627 1.627 0 0 0 14 15.375v-1.75A1.627 1.627 0 0 0 12.375 12z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $526c6f15ba0e3f49$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 5V4a1 1 0 0 0-1-1H8.914a1 1 0 0 0-.707.293L4.293 7.207A1 1 0 0 0 4 7.914V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5M9 3v4a1 1 0 0 1-1 1H4m11.383.772 2.745 2.746m1.215-3.906a2.09 2.09 0 0 1 0 2.953l-6.65 6.646L9 17.95l.739-3.692 6.646-6.646a2.087 2.087 0 0 1 2.958 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $dcf5e20f438e2d1a$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 17v-5h1.5a1.5 1.5 0 1 1 0 3H5m6 2v-5h1.5a1.5 1.5 0 1 1 0 3H11m7-3v5m-1-5h2M5 10V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v6M5 19v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1M10 3v4a1 1 0 0 1-1 1H5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $0b9ff01aa7330976$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m8 7.5 2.5 2.5M19 4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1m-5 9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $48a4d790ddee8575$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 9V4a1 1 0 0 0-1-1H8.914a1 1 0 0 0-.707.293L4.293 7.207A1 1 0 0 0 4 7.914V20a1 1 0 0 0 1 1h6M9 3v4a1 1 0 0 1-1 1H4m11 13a11.4 11.4 0 0 1-3.637-3.99A11.14 11.14 0 0 1 10 11.833L15 10l5 1.833a11.14 11.14 0 0 1-1.363 5.176A11.4 11.4 0 0 1 15.001 21Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $d428235a8edebe8f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m14-4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1ZM9 12h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Zm5.697 2.395v-.733l1.269-1.219v2.984z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $bfbfc5b2a1c5a421$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m4 4 1 5 2-3.333L14 17l1-5m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c966dca097679339$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m14-4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Zm-4 1h.01v.01H15zm-2 2h.01v.01H13zm2 2h.01v.01H15zm-2 2h.01v.01H13zm2 2h.01v.01H15zm-2 2h.01v.01H13zm2 2h.01v.01H15zm-2 2h.01v.01H13z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4b31e014f9628bfd$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m14-4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $026d65529a47f658$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.5 8H4m4 6h8m0 0-2-2m2 2-2 2M4 6v13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-5.032a1 1 0 0 1-.768-.36l-1.9-2.28a1 1 0 0 0-.768-.36H5a1 1 0 0 0-1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $915d4894996837d8$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 11H4m15.5 5a.5.5 0 0 0 .5-.5V8a1 1 0 0 0-1-1h-3.75a1 1 0 0 1-.829-.44l-1.436-2.12a1 1 0 0 0-.828-.44H8a1 1 0 0 0-1 1M4 9v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-3.75a1 1 0 0 1-.829-.44L9.985 8.44A1 1 0 0 0 9.157 8H5a1 1 0 0 0-1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $36c02f76ac191edb$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 19V6a1 1 0 0 1 1-1h4.032a1 1 0 0 1 .768.36l1.9 2.28a1 1 0 0 0 .768.36H16a1 1 0 0 1 1 1v1M3 19l3-8h15l-3 8z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $23156eda969bc19b$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14 8H4m8 3.5v5M9.5 14h5M4 6v13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-5.032a1 1 0 0 1-.768-.36l-1.9-2.28a1 1 0 0 0-.768-.36H5a1 1 0 0 0-1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $50b5a6bc43cb637f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.5 8H4m0-2v13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-5.032a1 1 0 0 1-.768-.36l-1.9-2.28a1 1 0 0 0-.768-.36H5a1 1 0 0 0-1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4edf4656f6bead25$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 10.042c-1.39 0-1.393-1.125-4.206-1.037-1.731.054-3.156 2.23-2.712 5.308C5.359 16.238 6.986 21 8.992 21c2.005 0 2.073-.85 3.008-.85s.855.85 3.008.85 3.633-4.762 3.91-6.687c.444-3.078-.981-5.254-2.712-5.308-2.813-.088-2.816 1.037-4.206 1.037m2.36-4.213c-.878.749-1.861.72-2.722.72 0-.626.079-1.94.86-2.77.782-.828 2.128-.766 2.644-.766 0 .595.096 2.068-.782 2.816"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $ebd7d12bae64819c$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            d: "M7.426 18.244c1.317-2.202 2.533-1.524 3.85-3.726s.1-2.88 1.417-5.083c1.317-2.202 2.534-1.524 3.85-3.727m-5.696 14.444c1.317-2.203 2.534-1.524 3.85-3.727s.1-2.88 1.418-5.083c1.317-2.202 2.533-1.524 3.85-3.726L13.122 3.8c-1.317 2.203-2.533 1.524-3.85 3.727s-.1 2.88-1.417 5.083c-1.317 2.202-2.534 1.524-3.85 3.726z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $a6efad0696dd3df8$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16.125 6H20v3.86a4 4 0 0 1-1.781 3.328l-1.58 1.046M4.189 17h12.625M9 7v7m3-7v7M4.941 4.938l-.875 14A1 1 0 0 0 5.064 20h10.872a1 1 0 0 0 .998-1.062l-.875-14A1 1 0 0 0 15.06 4H5.939a1 1 0 0 0-.998.938"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $f42211f96ab01dc8$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            d: "M16.888 7.112c.179-.775-.12-1.669-.715-2.265-1.014-1.013-2.564-1.013-3.577 0s-1.013 2.563 0 3.576l-4.173 4.173c-1.013-1.013-2.563-1.013-3.576 0s-1.013 2.563 0 3.577c.596.596 1.49.894 2.265.715-.179.775.12 1.669.715 2.265 1.014 1.013 2.564 1.013 3.577 0s1.013-2.563 0-3.576l4.173-4.173c1.013 1.013 2.563 1.013 3.576 0s1.013-2.563 0-3.577c-.596-.596-1.49-.894-2.265-.715"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3910c1842cf98739$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18.011 13H20c-.367 2.555-2.32 4.683-4.977 5.616V20H8.977v-1.384C6.32 17.683 4.367 15.556 4 13zm0 0a2 2 0 0 0 .675-3.88M18.01 13H18m0-4c.24 0 .472.043.686.12m0 0c.836-1.033.753-2.67-.28-3.506a2.41 2.41 0 0 0-3.387.356c-.293-1.502-1.748-2.154-3.25-1.86a2.77 2.77 0 0 0-2.19 3.25c-.599-1.187-1.96-2.096-3.424-1.359C4.967 6.6 4.45 8.192 5.049 9.38m0 0C4.371 9.665 4 10.336 4 11.117 4 12.157 4.843 13 5.883 13m-.834-3.62c.287-.12 1.096-.4 2.045.342m5.275-.891a2 2 0 0 1 2.65.988"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3313e4606dc272b9$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17 10h.01M12 10h.01M7 10h.01M14 8h.01M10 8h.01M6.5 13C5.12 13 4 11.56 4 9.786c0-1.513.45-3.74 2.967-3.453 0-2.593 4.394-3.026 5.169-1.1.5-.644 1.546-1.207 2.54-1.097 1.26.139 2.05 1.034 2.21 2.197 1.768 0 3.335 1.317 3.114 3.453C20 11.56 18.88 13 17.5 13m-8.523 5.616V20h6.046v-1.384c2.657-.933 4.61-3.06 4.977-5.616H4c.367 2.555 2.32 4.683 4.977 5.616"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $e64001697e74cfdc$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 19v-9c-1.5 0-2-1.5-2-2.5s.5-2 2-2.5c2.364-.643 4.2-.976 6-.989 1.8.013 3.636.346 6 .989 1.5.5 2 1.5 2 2.5s-.5 2.5-2 2.5v9a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $9cc6c1ed129baaae$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m4 12 2.667-1 2.666 1L12 11l2.667 1 2.666-1L20 12m-1 5H5v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2zM5 9h14V8a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4zm13.5 5h-13a1.5 1.5 0 0 0 0 3h13a1.5 1.5 0 1 0 0-3"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $54ce92d0a866986c$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 17.43V15h4.333M5 17.43V21h14v-6h-4.333M5 17.43c.387.337.923.57 1.667.57 2.666 0 2.666-3 2.666-3m5.334 0H9.333m5.334 0s0 3-2.667 3-2.667-3-2.667-3m5.334 0s0 3 2.666 3c.744 0 1.28-.233 1.667-.57M12 8c.11 0 2-1.12 2-2.5S12.092 3 12 3s-2 1.12-2 2.5S11.895 8 12 8m0 0v3m-6 0v4h12v-4z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $8eb8bf281b964fd2$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 8c0-.828.5-2 2-2m-2 2v2.5a1.5 1.5 0 1 1-3 0v-3m3 .5-3-.5M12 6c1.5 0 2 1.172 2 2m-2-2V3M7 7.5C7 5.015 9.515 3 12 3m0 0c2.485 0 5 2.015 5 4.5v12a1.5 1.5 0 1 1-3 0V8m0 0h3m-3 4h3m-3 4h3"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $ebef6e20d75e9ff1$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            d: "M16 8c-1.629-1.629-3.9-1.915-6.066.25S2.822 18.03 4.451 19.659s9.241-3.318 11.407-5.484C17.95 12.081 17.629 9.63 16 8m0 0 3.26-3.151M16 8V4m0 4h4m-3.798 5.802-2.2-2.215m-5.7-1.376 2.072 2.042m-1.259 3.184 2.112 2.163"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $100e073057bdd1ba$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 15a3 3 0 0 0 3-3V6H4v6a3 3 0 0 0 3 3m0 0v5m-2 0h4M4 9h6m6.608 4.486a3 3 0 0 0 1.94-3.773L16.712 4 11 5.835l1.835 5.712a3 3 0 0 0 3.773 1.94m0 0 1.53 4.76m-1.905.612 3.808-1.223m-8.124-8.944 5.713-1.835"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $bea40b66df64a244$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m4 12 6.427-4.66a2.006 2.006 0 0 0 2.789.473c.896-.638 1.349-1.692.468-2.801C13.637 4.953 14.91 4 15 4c.09 0 5 1 5 8M4 12h16M4 12v8h16v-8M8 15h.01M12 17h.01M16 15h.01"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $f7fcad0d574e4bae$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17.333 14.653c.708 0 1.386-.21 1.886-.71s.781-1.25.781-1.957a2.667 2.667 0 0 0-2.667-2.667h-.022q.02-.221.022-.444A4.889 4.889 0 0 0 7.74 7.56c-.063-.003-.121-.018-.184-.018-.943 0-1.91.366-2.577 1.032-.667.667-.979 1.58-.979 2.523a3.555 3.555 0 0 0 2.667 3.443M12 14v3m0 0v3m0-3-2.121-2.121M12 17l2.121 2.121M12 17H9m3 0h3m-3 0-2.121 2.121M12 17l2.121-2.121M6 18h.01M18 18h.01"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b3402e925ab6fca1$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.657 9.415h.01M7.27 13h.01m7.677 1.916h.01M11 17h.01m3.178-10.907a2.254 2.254 0 0 1-3.173-1.755c-.058-.44-.02-.99.183-1.395a9 9 0 1 0 9.87 9.73c-.21.008-.672.022-.832.015a2.196 2.196 0 0 1-2.405-1.902c-.056-.43.015-.872.212-1.267a2.633 2.633 0 1 1-3.852-3.41"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $d3c59c456cdf2ff0$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 10.857 4 2.286m-4-2.286-4 2.286m4-2.286V6.286m4 6.857v4.571m0-4.571-4 2.286m4-2.286 4-2.286m-4 2.286V8.57m0 4.572 4 2.286m-4 2.285L8 20m4-2.286L16 20m-8 0-4-2.286v-4.571M8 20v-4.571m-4-2.286 4 2.285m8-9.142L12 4 8 6.286m8 0v4.571m0-4.571L12 8.57m4 2.286 4 2.286M8 6.286l4 2.285m8 4.572v4.571L16 20m4-6.857-4 2.286M16 20v-4.571"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $e082abefd49c6723$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 6v2.5C10 9 7 9.75 7 12v7c0 .938 0 2 2.143 2h5.714C17 21 17 19.938 17 19v-7c0-2.25-3-3-3-3.5V6m-4 0H9V3h6v3h-1m-4 0h4m0 10a2 2 0 1 1-4 0c0-1.5 1.787-4 2-4s2 2.5 2 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $850949431952876c$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 6h6m-5-3v6c-2 1.5-3 3.5-3 5.5V19a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-4.5c0-2-1-4-3-5.5V3zm4 13a2 2 0 1 1-4 0c0-1.105 1.885-4 2-4s2 2.895 2 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $bddf163a984fae0d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12.443 9.885 9.936 7.51c.814-.815.805-2.07-.02-2.895-.827-.827-2.081-.835-2.896-.021-.479.48-.715 1.201-.566 1.83-.628-.15-1.35.086-1.83.566-.814.814-.805 2.069.021 2.895s2.08.835 2.895.02l2.503 2.293m.806-1.38c1.83-1.83 5.124-1.222 7.193.846s2.319 4.623.297 6.645c-1.032 1.032-2.128 1.609-3.23 1.651.588-1.34.225-2.587-.813-3.28-.918-.614-2.18-.781-3.548.178-1.104-2.058-1.303-4.635.101-6.04"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $f04e03d6517de5bf$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 13c0-.888.402-2.383 1-3.272M18.05 14a6 6 0 1 1-12 0c0-3.314 2.686-10 6-10s6 6.686 6 10"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $71bbb6c7a1f37cb4$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 12c0 1.6 3.358 4 7.5 4s6.923-3.2 7.5-4c-.577-.8-3.358-4-7.5-4S6 10.4 6 12m0 0L3 9m3 3-3 3m12.987-3.372h.01m-2-3.613c-1.726 3.302-1.711 5.026-.001 7.97m-4.61-.796L7.7 17.4a1 1 0 0 0 .8 1.6H10c1 0 2.758-3.026 2.758-3.026M9 5l3.056 3.097"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $de3d1417c0ee1137$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 12c0 1.6 3.358 4 7.5 4s6.923-3.2 7.5-4c-.577-.8-3.358-4-7.5-4S6 10.4 6 12m0 0L3 9m3 3-3 3m12.987-3.372h.01M14 8c-1.726 3.302-1.71 5.056 0 8"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $2a50af55cfaaac52$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10.05 3v5c-2.719.934-5 3.24-5 6.2 0 3.756 3.134 6.8 7 6.8s7-3.044 7-6.8c0-2.96-2.281-5.266-5-6.2V3m-4 0h4m-4 0h-2m6 0h2M5.098 15h13.904"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $0b30c580c9632b4f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 17h10M6 3l1.076 16.133A2 2 0 0 0 9.07 21h5.858a2 2 0 0 0 1.995-1.867L18 3zm8 8a2 2 0 1 1-4 0c0-1.105 1.791-4 2-4s2 2.895 2 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $da3f9fcca31d789e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6.315 7c1.419 0 1.419 1.5 2.837 1.5S10.571 7 11.99 7s1.419 1.5 2.837 1.5S17.663 7 17.663 7M6 3l1.076 16.133A2 2 0 0 0 9.07 21h5.858a2 2 0 0 0 1.995-1.867L18 3z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $de189630bd57afc1$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m11.5 8 1-1m-1 5.5 1-1m-1 5.5 1-1M9 20V4h-.5A3.5 3.5 0 0 0 5 7.5v9A3.5 3.5 0 0 0 8.5 20zm6 0V4h.5A3.5 3.5 0 0 1 19 7.5v9a3.5 3.5 0 0 1-3.5 3.5zm0-2V6a3 3 0 1 0-6 0v12a3 3 0 1 0 6 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $6675f5607a1177e6$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 6a3 3 0 1 1 6 0M9 6c0 1.043.533 1.963 1.341 2.5M9 6a3 3 0 0 0 0 6m6.39 0a3 3 0 1 0-1.66-5.5M8 12h8l-4 9z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $0b0e16f9558e7d31$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 8v6a1 1 0 0 0 1 1h4M7 8a5 5 0 0 1 10 0v6a1 1 0 0 1-1 1h-4M7 8h2a2 2 0 0 1 2 2v.5a1.5 1.5 0 0 0 3 0A1.5 1.5 0 0 1 15.5 9H17m-5 6v6"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $fca390c0e7995cc6$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 6H8m8 0s3 2.5 3 5v8.002A3 3 0 0 1 16 22H8c-1.657 0-3-1.341-3-2.998V11c0-2.5 3-5 3-5m8 0V3H8v3m4 3v10M6 6h12m-4.834 9.745c-.324.257-.965 1.172-.926 1.228s1.045-.429 1.4-.638c.356-.21.928-1.195.9-1.23-.027-.036-1.076.404-1.374.64m0-3.972c-.324.257-.965 1.172-.926 1.228s1.045-.429 1.4-.638c.356-.21.928-1.195.9-1.23-.027-.036-1.076.404-1.374.64m-2.332 3.972c.324.257.965 1.172.926 1.228s-1.045-.429-1.4-.638c-.356-.21-.928-1.195-.9-1.23.027-.036 1.076.404 1.374.64m0-3.972c.324.257.965 1.172.926 1.228s-1.045-.429-1.4-.638c-.356-.21-.928-1.195-.9-1.23.027-.036 1.076.404 1.374.64"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $5b5ff2832edc5e2a$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 6H8m8 0s3 2.5 3 5m-3-5V3H8v3m0 0s-3 2.5-3 5v8.002A3 3 0 0 0 8 22h8c1.657 0 3-1.341 3-2.998V11m0 0h-8v7h8zM6 6h12"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4e4d1cde6c0bbfb5$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12.306 8.295C9.557 9.382 8.82 11.25 9.002 13.94m5.665-9.759-1.056.505c-.342.133-1.524.32-1.716.32-4.832.646-7.745 5.768-5.881 10.339l.45 1.105c.074.179.128.485.135.562l.098 1.181q0 0 0 0c.107 1.306 1.463 2.102 2.631 1.548l.01-.005c.071-.034.974-.472 1.052-.502.08-.032.357-.138.547-.164l1.168-.156c4.832-.647 7.745-5.769 5.881-10.34l-.45-1.104a1.9 1.9 0 0 1-.135-.563l-.097-1.18c-.108-1.308-1.468-2.105-2.637-1.546"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c3646aa74e9c7cf6$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m10 14 6-6H4zm0 0v6m-3 0h6m.035-12a3.5 3.5 0 1 1 1.015 2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $45d19545d902c036$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m12 12 7-8H5zm0 0v8m-3 0h6"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $66607b37921f0db6$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m12 12 7-8H5zm0 0v8m-3 0h6M8.55 8h6.95"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $afac7084f6bbaafe$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 13h2a2 2 0 1 1 0 4h-2.5M10 3c0 2.4-3 1.6-3 4m8-4c0 2.4-3 1.6-3 4m-7 4 .64 6.398A4 4 0 0 0 9.62 21h.76a4 4 0 0 0 3.98-3.602L15 11z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b91ac2be419ecd5f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 8h2a2 2 0 1 1 0 4h-2.5M5 19h11M5 6l.64 6.398A4 4 0 0 0 9.62 16h.76a4 4 0 0 0 3.98-3.602L15 6z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $18cf414f83c153ce$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 11c1.5-3.033 3.102-3.847 4.5-3.5s2.286.99 2.678 2.607c.463 2.116-1.743 4.977-5.838 8.208-1.206.913-3.494 2.017-5.05 2.7-.698.293-1.595.053-2.099-.632-.503-.684-.391-1.616.247-2.2.393-.445.753-.76 1.112-1.076C8.185 15.62 9.5 14.033 11 11m0 0h3v2h3m.158-5.485 1.259-2.135c.462-.7.156-1.607-.545-2.07-.7-.462-1.607-.156-2.07.545l-.08.047"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3d0347c55bc80bfa$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("g", {
                clipPath: "url(#pizza-slice_BaseIcon__a)",
                children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M10.415 10.762v.011m3.087 3.077v.01M8.917 15.35v.01m-.828-8.445-3.69 13 12.952-3.738m-.827-8.435a12.14 12.14 0 0 1 3.517 7.517c.067.741-.462 1.375-1.187 1.53-1.014.215-1.96-.582-2.092-1.616-.241-1.9-.944-3.572-2.52-5.148-1.578-1.578-3.318-2.346-5.253-2.62-1.022-.144-1.796-1.11-1.539-2.103.172-.667.768-1.142 1.458-1.085a12.14 12.14 0 0 1 7.616 3.525"
                })
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("defs", {
                children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("clipPath", {
                    id: "pizza-slice_BaseIcon__a",
                    children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $dbe3703a64ceb6cc$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 5h1m-1 6h1M3 8h4m8.5 0c-.102.11-1.538-1.157-1.796-1.482-.33-.415-.782-1.43-.698-1.506s1.116.68 1.374 1.006c.258.324 1.222 1.871 1.12 1.982m0 0c-.102-.11-1.538 1.157-1.796 1.482-.33.415-.782 1.43-.698 1.506s1.116-.68 1.374-1.005S15.602 8.11 15.5 8m4 0c-.102.11-1.538-1.157-1.796-1.482-.33-.415-.782-1.43-.698-1.506s1.116.68 1.374 1.006c.258.324 1.222 1.871 1.12 1.982m0 0c-.102-.11-1.538 1.157-1.796 1.482-.33.415-.782 1.43-.698 1.506s1.116-.68 1.374-1.005S19.602 8.11 19.5 8M11 8h10m-9.994 0c-.102.11-1.539-1.157-1.797-1.482-.33-.415-.781-1.43-.697-1.506s1.116.68 1.374 1.005S11.107 7.89 11.006 8m0 0c-.102-.11-1.539 1.157-1.797 1.482-.33.415-.781 1.43-.697 1.506s1.116-.68 1.374-1.005S11.107 8.11 11.006 8M8.599 18.012V19H15.4v-.988C18.39 17.345 20.587 15.825 21 14H3c.413 1.825 2.61 3.345 5.599 4.012"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $dc78f20a03b03f87$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9.839 12.454s1.25-3.088-.216-5.29-5.036-3.055-5.225-2.92c-.189.134-1.118 3.325.348 5.527s5.093 2.683 5.093 2.683m0 0C10.339 13.454 12 15 12 18v2c0-2-.43-3.419 2.07-5.919m0 0s-.49-2.789 1.12-4.358 4.49-1.547 4.67-1.284.432 2.844-1.08 4.318c-1.61 1.569-4.71 1.324-4.71 1.324"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $0f018d517e5f4abe$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.524 12.47H8a3 3 0 0 1-3-3V8h5m3.524 4.47a2.265 2.265 0 1 1 0 4.53H11a2 2 0 0 0-2 2v1h6.5m-1.976-7.53L15.5 7.764M10 8c1.846-1.251 3.077-1.408 5.5-.236M10 8v4.47L8 14m7.5-6.236c3.18-.245 5.556 2.362 4.754 5.45-.105.406-.224.84-.359 1.31.017.812-.006 1.488-.063 2.088C19.632 18.702 17.6 20 15.5 20m0 0-1.204-3.135M15.668 14h4.375M10 4H6a2 2 0 1 0 0 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $06e59473980bfffc$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M21 12a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9h-5m-4 9a9 9 0 0 1-9-9m9 9v-5m-9-4a9 9 0 0 1 9-9m-9 9h5m4-9v5M8 3.936V8m0 0v4m0-4H3.936M8 8h4m-4 4v4m0-4h4m-4 4v4.065M8 16H3.936M8 16h4m0-8v4m0-4h4m-4 4v4m0-4h4m-4 4h4m0-12.064V8m0 0v4m0-4h4.065M16 12v4m0 0v4.065M16 16h4.065"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $91ef0972a7907478$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 6v2s-3 1-3 3.25 1 2.25 1 3-1 1.125-1 2.25V19c0 .938 1 2 2.5 2s2-.937 2-.937.5.937 2 .937 2.5-1.062 2.5-2v-2.5c0-1.125-1-1.5-1-2.25s1-.75 1-3S14 8 14 8V6m-3 0h-1V3h5v3h-1m-3 0h3m-5.956 6h8.912M8 17h9"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $fe79a0c97bc23839$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.54 15.46c-.155.05-.83-1.917-.898-2.362-.088-.569.031-1.77.15-1.796.12-.027.687 1.24.756 1.686.07.444.147 2.421-.008 2.472m0 0c-.008-.163 2.067-.305 2.514-.257.572.062 1.701.488 1.696.61-.005.123-1.376.343-1.824.294-.447-.048-2.377-.484-2.386-.647m3.715-3.715L4 20m8.255-8.255 6.604-6.604m-6.604 6.604c-.155.05-.83-1.917-.898-2.362-.089-.569.03-1.77.15-1.796s.687 1.241.756 1.686c.07.445.147 2.422-.008 2.472m0 0c-.008-.163 2.066-.305 2.514-.256.572.062 1.701.488 1.696.61-.005.123-1.377.342-1.824.294s-2.378-.485-2.386-.648M20 8.953l-1.271 1.271M15.047 4l-1.271 1.271M19.99 20H20m-.01-3v-3M5.27 18.73c-.156.05-.83-1.917-.899-2.361-.088-.57.031-1.77.151-1.797s.687 1.242.756 1.686c.069.445.147 2.422-.008 2.472m0 0c-.009-.163 2.066-.304 2.513-.256.573.062 1.702.488 1.696.61-.005.123-1.376.343-1.824.294-.447-.048-2.377-.484-2.385-.647"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $bf77924dec5aa3d3$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.54 15.46c-.155.05-.83-1.917-.898-2.362-.088-.569.031-1.77.15-1.796.12-.027.687 1.24.756 1.686.07.444.147 2.421-.008 2.472m0 0c-.008-.163 2.067-.305 2.514-.257.572.062 1.701.488 1.696.61-.005.123-1.376.343-1.824.294-.447-.048-2.377-.484-2.386-.647m3.715-3.715L4 20m8.255-8.255 6.604-6.604m-6.604 6.604c-.155.05-.83-1.917-.898-2.362-.089-.569.03-1.77.15-1.796s.687 1.241.756 1.686c.07.445.147 2.422-.008 2.472m0 0c-.008-.163 2.066-.305 2.514-.256.572.062 1.701.488 1.696.61-.005.123-1.377.342-1.824.294s-2.378-.485-2.386-.648M20 8.953l-1.271 1.271M15.047 4l-1.271 1.271M5.27 18.731c-.156.05-.83-1.918-.899-2.362-.088-.57.031-1.77.151-1.797s.687 1.242.756 1.686c.069.445.147 2.422-.008 2.472m0 0c-.009-.164 2.066-.305 2.513-.257.573.062 1.702.488 1.696.61-.005.123-1.376.343-1.824.294-.447-.048-2.377-.484-2.385-.647"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $65b4f176ccc14eb8$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 14h10M6 7l.847 10.166A2 2 0 0 0 8.84 19h6.32a2 2 0 0 0 1.993-1.834L18 7z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $2c6bda331c42ca5b$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 8h4m-3-5a1 1 0 0 0-1 1v6c-2 1-2 2.5-2 4.5V20a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-5.5c0-2 0-3.5-2-4.5V4a1 1 0 0 0-1-1zm5 10h-4v5h4z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $0316e3c4dda8eeb8$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 14c2.761 0 5-2.668 5-5.43 0-1.385-1.12-4.507-1.5-5.57h-7C8.152 4.021 7 7.172 7 8.57 7 11.333 9.239 14 12 14m0 0v7m-3 0h6"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $025602d1461c44ae$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 14c2.761 0 5-2.668 5-5.43 0-1.385-1.12-4.507-1.5-5.57h-7C8.152 4.021 7 7.172 7 8.57 7 11.333 9.239 14 12 14m0 0v7m0 0H9m3 0h3M7 9h9"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c2eff29abd51bb23$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 5v14m8-7h-2m0 0h-2m2 0v2m0-2v-2M3 11h6m-6 4h6m11 4H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $acc5f8a8771d73c7$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 5v14m-8-7h2m0 0h2m-2 0v2m0-2v-2m12 1h-6m6 4h-6M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c85de0ce87ba5bd6$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M20 6H10m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4m16 6h-2m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4m16 6H10m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c21adf3f33d52a99$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M6 4v10m0 0a2 2 0 1 0 0 4m0-4a2 2 0 1 1 0 4m0 0v2m6-16v2m0 0a2 2 0 1 0 0 4m0-4a2 2 0 1 1 0 4m0 0v10m6-16v10m0 0a2 2 0 1 0 0 4m0-4a2 2 0 1 1 0 4m0 0v2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3b3c1136d115a562$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7.556 8.5h8m-8 3.5H12m7.111-7H4.89a.9.9 0 0 0-.629.256.87.87 0 0 0-.26.619v9.25c0 .232.094.455.26.619A.9.9 0 0 0 4.89 16H9l3 4 3-4h4.111a.9.9 0 0 0 .629-.256.87.87 0 0 0 .26-.619v-9.25a.87.87 0 0 0-.26-.619.9.9 0 0 0-.63-.256Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $030ff0b38f4d3fda$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                fill: "currentColor",
                d: "M6.943 11h-.852l.96-2.91h1.08L9.09 11h-.852l-.637-2.108H7.58zm-.159-1.148h1.602v.591H6.784zM9.371 11V8.09h1.256a1.2 1.2 0 0 1 .567.129.93.93 0 0 1 .377.36q.135.23.135.54 0 .314-.139.542a.9.9 0 0 1-.388.352 1.3 1.3 0 0 1-.58.123h-.75v-.613h.59a.5.5 0 0 0 .237-.049.35.35 0 0 0 .152-.14.4.4 0 0 0 .054-.215.4.4 0 0 0-.054-.213.34.34 0 0 0-.152-.136.5.5 0 0 0-.237-.048h-.278V11zm3.415-2.91V11h-.79V8.09z"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M8.318 2a1 1 0 0 0-1 1v.729l-.18.073-.553-.538a1 1 0 0 0-1.396 0L3.31 5.096a1 1 0 0 0 0 1.432l.529.515q-.03.067-.058.137H3a1 1 0 0 0-1 1v2.59a1 1 0 0 0 1 1h.78l.058.136-.529.515a1 1 0 0 0 0 1.433l1.88 1.83a1 1 0 0 0 1.396 0l.552-.537q.09.038.181.073v.73a1 1 0 0 0 1 1h2.66a1 1 0 0 0 1-1v-.73q.196-.076.388-.165l.543.261v.434a1 1 0 0 0 1 1H14v.063a1 1 0 0 0 1 1h.09v.062a1 1 0 0 0 1 1h.685l.495.482a3 3 0 0 0 4.187 0l.24-.234a1 1 0 0 0-.016-1.449l-6.216-5.784.05-.12h.78a1 1 0 0 0 1-1V8.18a1 1 0 0 0-1-1h-.78l-.057-.137.528-.515a1 1 0 0 0 0-1.432l-1.88-1.832a1 1 0 0 0-1.396 0l-.552.538q-.09-.038-.18-.073V3a1 1 0 0 0-1-1z"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $6ab375f9c737ea74$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M10 12v1h4v-1m4 7H6a1 1 0 0 1-1-1V9h14v9a1 1 0 0 1-1 1ZM4 5h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $ca0196ba6ab3141d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c96eb30e3b15baeb$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M8.737 8.737a21.5 21.5 0 0 1 3.308-2.724m0 0c3.063-2.026 5.99-2.641 7.331-1.3 1.827 1.828.026 6.591-4.023 10.64s-8.812 5.85-10.64 4.023c-1.33-1.33-.736-4.218 1.249-7.253m6.083-6.11c-3.063-2.026-5.99-2.641-7.331-1.3-1.827 1.828-.026 6.591 4.023 10.64m3.308-9.34a21.5 21.5 0 0 1 3.308 2.724m2.775 3.386c1.985 3.035 2.579 5.923 1.248 7.253-1.336 1.337-4.245.732-7.295-1.275M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $203cc4ec093a9939$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m7.171 12.906-2.153 6.411 2.672-.89 1.568 2.34 1.825-5.183m5.73-2.678 2.154 6.411-2.673-.89-1.568 2.34-1.825-5.183M9.165 4.3c.58.068 1.153-.17 1.515-.628a1.68 1.68 0 0 1 2.64 0 1.68 1.68 0 0 0 1.515.628 1.68 1.68 0 0 1 1.866 1.866c-.068.58.17 1.154.628 1.516a1.68 1.68 0 0 1 0 2.639 1.68 1.68 0 0 0-.628 1.515 1.68 1.68 0 0 1-1.866 1.866 1.68 1.68 0 0 0-1.516.628 1.68 1.68 0 0 1-2.639 0 1.68 1.68 0 0 0-1.515-.628 1.68 1.68 0 0 1-1.867-1.866 1.68 1.68 0 0 0-.627-1.515 1.68 1.68 0 0 1 0-2.64c.458-.361.696-.935.627-1.515A1.68 1.68 0 0 1 9.165 4.3M14 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $19573a15c3bcfc5c$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8.032 12 1.984 1.984 4.96-4.96m4.55 5.272.893-.893a1.984 1.984 0 0 0 0-2.806l-.893-.893a1.98 1.98 0 0 1-.581-1.403V7.04a1.984 1.984 0 0 0-1.984-1.984h-1.262a1.98 1.98 0 0 1-1.403-.581l-.893-.893a1.984 1.984 0 0 0-2.806 0l-.893.893a1.98 1.98 0 0 1-1.403.581H7.04A1.984 1.984 0 0 0 5.055 7.04v1.262c0 .527-.209 1.031-.581 1.403l-.893.893a1.984 1.984 0 0 0 0 2.806l.893.893c.372.372.581.876.581 1.403v1.262a1.984 1.984 0 0 0 1.984 1.984h1.262c.527 0 1.031.209 1.403.581l.893.893a1.984 1.984 0 0 0 2.806 0l.893-.893a1.99 1.99 0 0 1 1.403-.581h1.262a1.984 1.984 0 0 0 1.984-1.984V15.7c0-.527.209-1.031.581-1.403Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $8eb2545a0179c93c$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m6 6 12 12m3-6a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $ac9753fba325eb87$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                d: "M2.992 4.983v13.934m6.97-13.934v13.934m5.976-13.934v13.934m2.987-13.934v13.934"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                d: "M5.48 4.483v14.934M7.47 4.483v14.934M21.413 4.483v14.934M13.446 4.483v14.934"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $40a6027112479cfa$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M5 7h14M5 12h14M5 17h10"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $509e7bbdf9224464$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M5 7h14M5 12h14M5 17h14"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $fc21b9405ea10194$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M2.988 7.971a1 1 0 0 1 1-1h12.937a1 1 0 0 1 1 1v7.959a1 1 0 0 1-1 1H3.988a1 1 0 0 1-1-1zm17.925 4.97v-1.983a1 1 0 0 0-1-1h-.988a1 1 0 0 0-1 1v1.984a1 1 0 0 0 1 1h.988a1 1 0 0 0 1-1Z"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M5.975 9.959h8.963v3.983H5.975z"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $a97142adcf213339$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 17v2M12 5.5V10m-6 7v2m15-2v-4a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v4zm-2-7V8a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v2z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4681bbe9fe704c72$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 5.365V3m0 2.365a5.34 5.34 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175 0 .593 0 1.193-.538 1.193H5.538c-.538 0-.538-.6-.538-1.193 0-1.193 1.867-1.789 1.867-4.175v-1.8A5.34 5.34 0 0 1 12 5.365m-8.134 5.368a8.46 8.46 0 0 1 2.252-5.714m14.016 5.714a8.46 8.46 0 0 0-2.252-5.714M8.54 17.901a3.48 3.48 0 0 0 6.92 0z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $8246b7b469bdbad0$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m10.827 5.465-.435-2.324m.435 2.324a5.34 5.34 0 0 1 6.033 4.333l.331 1.769c.44 2.345 2.383 2.588 2.6 3.761.11.586.22 1.171-.31 1.271l-12.7 2.377c-.529.099-.639-.488-.749-1.074C5.813 16.73 7.538 15.8 7.1 13.455c-.219-1.169.218 1.162-.33-1.769a5.34 5.34 0 0 1 4.058-6.221Zm-7.046 4.41c.143-1.877.822-3.461 2.086-4.856m2.646 13.633a3.472 3.472 0 0 0 6.728-.777l.09-.5z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $36d7b52e5ad476e2$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 5.464V3.099m0 2.365a5.34 5.34 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175C19 17.4 19 18 18.462 18H5.538C5 18 5 17.4 5 16.807c0-1.193 1.867-1.789 1.867-4.175v-1.8A5.34 5.34 0 0 1 12 5.464M6 5 5 4M4 9H3m15-4 1-1m1 5h1M8.54 18a3.48 3.48 0 0 0 6.92 0z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b2d901e0ea42dd1c$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 5.365V3m0 2.365a5.34 5.34 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175 0 .593 0 1.292-.538 1.292H5.538C5 18 5 17.301 5 16.708c0-1.193 1.867-1.789 1.867-4.175v-1.8A5.34 5.34 0 0 1 12 5.365M8.733 18c.094.852.306 1.54.944 2.112a3.48 3.48 0 0 0 4.646 0c.638-.572 1.236-1.26 1.33-2.112z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $085ab887041fe8fb$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M20.283 8h-4.285m3.85 3h-3.85m4.061-6H11v11h8.27l1.715-9.847A.983.983 0 0 0 20.059 5M6.581 13.23h-.838A14 14 0 0 1 5.622 11q-.03-1.119.12-2.23h1.04c.252 0 .496-.088.683-.245a.93.93 0 0 0 .329-.61l.2-1.872a.9.9 0 0 0-.045-.39.9.9 0 0 0-.212-.34 1 1 0 0 0-.341-.231A1.1 1.1 0 0 0 6.983 5h-2.06a1.27 1.27 0 0 0-.699.204 1.14 1.14 0 0 0-.442.543A15.1 15.1 0 0 0 3.007 11a15.7 15.7 0 0 0 .795 5.229c.165.462 1.342.771 1.864.771h1.116c.142 0 .283-.028.413-.082q.197-.081.341-.23a.9.9 0 0 0 .212-.34.9.9 0 0 0 .046-.391l-.201-1.873a.93.93 0 0 0-.33-.609 1.06 1.06 0 0 0-.682-.245M10 18v1h10v-1a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $278144b50ce011e4$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 6.03v13m0-13c-2.819-.831-4.715-1.076-8.029-1.023A.99.99 0 0 0 3 6v11c0 .563.466 1.014 1.03 1.007 3.122-.043 5.018.212 7.97 1.023m0-13c2.819-.831 4.715-1.076 8.029-1.023A.99.99 0 0 1 21 6v11c0 .563-.466 1.014-1.03 1.007-3.122-.043-5.018.212-7.97 1.023"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $8b357ea4e29bdc7e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 19V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v13H7a2 2 0 0 0-2 2m0 0a2 2 0 0 0 2 2h12M9 3v14m7 0v4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1aedaf5e57998524$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m17 21-5-4-5 4V3.889a.92.92 0 0 1 .244-.629.8.8 0 0 1 .59-.26h8.333a.8.8 0 0 1 .589.26.92.92 0 0 1 .244.63z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b881b85b9f823913$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M5 5v14m14 0V8h2M3 8h6m0-2v8.586c0 .89 1.077 1.337 1.707.707l.586-.586a1 1 0 0 1 1.414 0l.586.586a1 1 0 0 0 1.414 0l.586-.586a1 1 0 0 1 1.414 0l.586.586c.63.63 1.707.184 1.707-.707V6a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1a8ddddab7d19754$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 18.5A2.493 2.493 0 0 1 7.51 20H7.5a2.468 2.468 0 0 1-2.4-3.154 2.98 2.98 0 0 1-.85-5.274 2.47 2.47 0 0 1 .92-3.182 2.477 2.477 0 0 1 1.876-3.344 2.5 2.5 0 0 1 3.41-1.856A2.5 2.5 0 0 1 12 5.5m0 13v-13m0 13a2.493 2.493 0 0 0 4.49 1.5h.01a2.468 2.468 0 0 0 2.403-3.154 2.98 2.98 0 0 0 .847-5.274 2.47 2.47 0 0 0-.921-3.182 2.477 2.477 0 0 0-1.875-3.344A2.5 2.5 0 0 0 14.5 3 2.5 2.5 0 0 0 12 5.5m-8 5a2.5 2.5 0 0 1 3.48-2.3m-.28 8.551a3 3 0 0 1-2.953-5.185M20 10.5a2.5 2.5 0 0 0-3.481-2.3m.28 8.551a3 3 0 0 0 2.954-5.185"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $5817cfe907824267$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 7H5a2 2 0 0 0-2 2v4m5-6h8M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m0 0h3a2 2 0 0 1 2 2v4m0 0v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6m18 0s-4 2-9 2-9-2-9-2m9-2h.01"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $f0c7009b5fc39e1d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 5 9 4V3m5 2 1-1V3m-3 6v11m0-11a5 5 0 0 1 5 5m-5-5a5 5 0 0 0-5 5m5-5a4.96 4.96 0 0 1 2.973 1H15V8a3 3 0 0 0-6 0v2h.027A4.96 4.96 0 0 1 12 9m-5 5H5m2 0v2a5 5 0 0 0 10 0v-2m2.025 0H17m-9.975 4H6a1 1 0 0 0-1 1v2m12-3h1.025a1 1 0 0 1 1 1v2M16 11h1a1 1 0 0 0 1-1V8m-9.975 3H7a1 1 0 0 1-1-1V8"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $8d6be0a6ffd34867$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 4h12M6 4v16M6 4H5m13 0v16m0-16h1m-1 16H6m12 0h1M6 20H5M9 7h1v1H9zm5 0h1v1h-1zm-5 4h1v1H9zm5 0h1v1h-1zm-3 4h2a1 1 0 0 1 1 1v4h-4v-4a1 1 0 0 1 1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $be3affd122c33072$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 9H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6m0-6v6m0-6 5.419-3.87A1 1 0 0 1 18 5.942v12.114a1 1 0 0 1-1.581.814L11 15m7 0a3 3 0 0 0 0-6M6 15h3v5H6z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $51b97be3b582bbb4$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m11.5 11.5 2.071 1.994M4 10h5m11 0h-1.5M12 7V4M7 7V4m10 3V4m-7 13H8v-2l5.227-5.292a1.46 1.46 0 0 1 2.065 2.065zm-5 3h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $21e2c94bcfc66fc5$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 10h16m-8-3V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1m3-7h.01v.01H8zm4 0h.01v.01H12zm4 0h.01v.01H16zm-8 4h.01v.01H8zm4 0h.01v.01H12zm4 0h.01v.01H16z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $41e4dba8fda01310$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            fill: "currentColor",
            d: "M4 9.05H3v2h1zm16 2h1v-2h-1zM10 14a1 1 0 1 0 0 2zm4 2a1 1 0 1 0 0-2zm-3 1a1 1 0 1 0 2 0zm2-4a1 1 0 1 0-2 0zm-2-5.95a1 1 0 1 0 2 0zm2-3a1 1 0 1 0-2 0zm-7 3a1 1 0 0 0 2 0zm2-3a1 1 0 1 0-2 0zm8 3a1 1 0 1 0 2 0zm2-3a1 1 0 1 0-2 0zm-13 3h14v-2H5zm14 0v12h2v-12zm0 12H5v2h14zm-14 0v-12H3v12zm0 0H3a2 2 0 0 0 2 2zm14 0v2a2 2 0 0 0 2-2zm0-12h2a2 2 0 0 0-2-2zm-14-2a2 2 0 0 0-2 2h2zm-1 6h16v-2H4zM10 16h4v-2h-4zm3 1v-4h-2v4zm0-9.95v-3h-2v3zm-5 0v-3H6v3zm10 0v-3h-2v3z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $69ae363392ee5cfb$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 10h16M8 14h8m-4-7V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $cd990f7ea57e74ee$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h8v-8m-9 4v-4m0 4h9m-9-4V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v4M3 11h11m6.25 5A2.25 2.25 0 0 1 18 18.25M20.25 16A2.25 2.25 0 0 0 18 13.75M20.25 16H21m-3 2.25A2.25 2.25 0 0 1 15.75 16M18 18.25V19m-2.25-3A2.25 2.25 0 0 1 18 13.75M15.75 16H15m3-2.25V13m-1.591 1.409-.53-.53m4.242 4.242-.53-.53m-3.182 0-.53.53m4.242-4.242-.53.53"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $13c9aab50622e9cb$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 4.5V19a1 1 0 0 0 1 1h15M7 10l4 4 4-4 5 5m0 0h-3.207M20 15v-3.207"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $6623fa6d76cf25e9$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 4.5V19a1 1 0 0 0 1 1h15M7 14l4-4 4 4 5-5m0 0h-3.207M20 9v3.207"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c9a33f6651abf86c$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.6 16.733c.234.269.548.456.895.534a1.4 1.4 0 0 0 1.75-.762c.172-.615-.446-1.287-1.242-1.481s-1.41-.861-1.241-1.481a1.4 1.4 0 0 1 1.75-.762c.343.077.654.26.888.524m-1.358 4.017v.617m0-5.939v.725M4 15v4m3-6v6M6 8.5 10.5 5 14 7.5 18 4m0 0h-3.5M18 4v3m2 8a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c508b9bd2082adcd$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v4m6-6v6m6-4v4m6-6v6M3 11l6-5 6 5 5.5-5.5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c182e26a362efd94$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M10 6.025A7.5 7.5 0 1 0 17.975 14H10z"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M13.5 3c-.169 0-.334.014-.5.025V11h7.975c.011-.166.025-.331.025-.5A7.5 7.5 0 0 0 13.5 3"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4fdd4d9b769e025f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 4v15a1 1 0 0 0 1 1h15M8 16l2.5-5.5 3 3L17.273 7 20 9.667"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $404707a6e849e6e5$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $d74416d06aebf1bf$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 21a9 9 0 1 1 0-18c1.052 0 2.062.18 3 .512M7 9.577l3.923 3.923 8.5-8.5M17 14v6m-3-3h6"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $d028846ac2b769eb$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 11.917 9.724 16.5 19 7.5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1b5169601aea427d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $429e1162d980c553$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 7.757v8.486M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $94e9de2a3d171d4e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 8v4l3 3M3.223 14A9 9 0 1 0 12 3a9 9 0 0 0-8.294 5.5M7 9H3V5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $e04c87d51d796f33$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c6c6babb83e55ce8$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m15 9-6 6m0-6 6 6m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $86d3f84432a3b578$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m9 10-2 2 2 2m3-9v14M5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3c3eb6f724ec90bc$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 10-2 2 2 2m3-9v14m-7 0h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1cad6e0326e78bed$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 18 17.94 6M18 18 6.06 6"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $a68902c4b02b661a$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 17h3a3 3 0 0 0 0-6h-.025a6 6 0 0 0 .025-.5A5.5 5.5 0 0 0 7.207 9.021C7.137 9.017 7.071 9 7 9a4 4 0 1 0 0 8h2.167M12 19v-9m0 0-2 2m2-2 2 2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $6c08d9324fd6f116$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 8v8m0-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 0a4 4 0 0 1-4 4h-1a3 3 0 0 0-3 3"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $37123322b03604a5$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 12v4m0 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4M8 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 0v2a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8m0 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3ed6079cdd89faaa$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 8v8m0-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m6-2a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 0h-1a5 5 0 0 1-5-5v-.5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $d0acd3af2341c93c$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 8v8m0-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 0V9a3 3 0 0 0-3-3h-3m1.5-2-2 2 2 2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $d488f8c67ce0729f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 8-4 4 4 4m8 0 4-4-4-4m-2-3-4 14"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1a54cd45dc32e734$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M21 13v-2a1 1 0 0 0-1-1h-.757l-.707-1.707.535-.536a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-.536.535L14 4.757V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.757l-1.707.707-.536-.535a1 1 0 0 0-1.414 0L4.929 6.343a1 1 0 0 0 0 1.414l.536.536L4.757 10H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.757l.707 1.707-.535.536a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l.536-.535 1.707.707V20a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.757l1.707-.708.536.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-.535-.536.707-1.707H20a1 1 0 0 0 1-1"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $2f0c6afe8276ee73$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 5v14M9 5v14M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3da90f0e42286212$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 8v8m0-8h8M8 8H6a2 2 0 1 1 2-2zm0 8h8m-8 0H6a2 2 0 1 0 2 2zm8 0V8m0 8h2a2 2 0 1 1-2 2zm0-8h2a2 2 0 1 0-2-2z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b860889bf638df14$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19 6c0 1.657-3.134 3-7 3S5 7.657 5 6m14 0c0-1.657-3.134-3-7-3S5 4.343 5 6m14 0v6M5 6v6m0 0c0 1.657 3.134 3 7 3s7-1.343 7-3M5 12v6c0 1.657 3.134 3 7 3s7-1.343 7-3v-6"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $a73f53141b404a91$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 5v14m-6-8h6m-6 4h6m4.506-1.494L15.012 12m0 0 1.506-1.506M15.012 12l1.506 1.506M15.012 12l-1.506-1.506M20 19H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $850b190b5882846e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3M3 15V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v9M3 15h18M8 15v4m4-4v4m4-4v4m-5.506-7.494L12 10m0 0 1.506-1.506M12 10l1.506 1.506M12 10l-1.506-1.506"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $553d1e33deb5d84a$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h10.5M3 15v-4m0 4h11M3 11V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v5M3 11h18m0 0v1M8 11v8m4-8v8m4-8v2m1.896 5.953 1.504-1.505m0 0 1.505-1.505M19.4 17.448l1.46 1.46m-1.46-1.46-1.46-1.46"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $0e707c38676e0063$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 15v5m-3 0h6M4 11h16M5 15h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $286d7690101d2c80$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15.041 13.862A5 5 0 0 1 17 17.831V21M7 3v3.169a5 5 0 0 0 1.891 3.916M17 3v3.169a5 5 0 0 1-2.428 4.288l-5.144 3.086A5 5 0 0 0 7 17.831V21M7 5h10M7.399 8h9.252M8 16h8.652M7 19h10"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c239fd781b409ff6$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M6 12h.01m6 0h.01m5.99 0h.01"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $05f1543c5746a717$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M12 6h.01M12 12h.01M12 18h.01"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $9ba33ef8c6c04007$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $79f36ee42a007c6b$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 6.5h2M11 18h2m-7-5v-2m12 2v-2M5 8h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1m0 12h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1m12 0h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1m0-12h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c1f21f19c6d903e9$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $308bfbf3b1afc963$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M21 8v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8m18 0-8.029-4.46a2 2 0 0 0-1.942 0L3 8m18 0-9 6.5L3 8"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $fb040ed905665346$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m3.5 5.5 7.893 6.036a1 1 0 0 0 1.214 0L20.5 5.5M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $d663990a29ff3276$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $60de167d7c57b535$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3.933 13.909A4.36 4.36 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.07 5.07 0 0 1 21 12c0 1-3 6-9 6q-.471 0-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1d80eec5cdd2865b$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                d: "M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6 4.03-6 9-6 9 4.8 9 6Z"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $7091a1880fe33caf$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M18.796 4H5.204a1 1 0 0 0-.753 1.659l5.302 6.058a1 1 0 0 1 .247.659v4.874a.5.5 0 0 0 .2.4l3 2.25a.5.5 0 0 0 .8-.4v-7.124a1 1 0 0 1 .247-.659l5.302-6.059c.566-.646.106-1.658-.753-1.658Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1b0cd1fce9234a06$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M21 12a28.1 28.1 0 0 1-1.091 9M7.231 4.37a8.994 8.994 0 0 1 12.88 3.73M2.958 15S3 14.577 3 12a8.95 8.95 0 0 1 1.735-5.307m12.84 3.088A6 6 0 0 1 18 12a30 30 0 0 1-.464 6.232M6 12a6 6 0 0 1 9.352-4.974M4 21a5.96 5.96 0 0 1 1.01-3.328 5.15 5.15 0 0 0 .786-1.926m8.66 2.486a14 14 0 0 1-.962 2.683M7.5 19.336C9 17.092 9 14.845 9 12a3 3 0 1 1 6 0c0 .749 0 1.521-.031 2.311M12 12c0 3 0 6-2 9"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $af305ed5c0393e2f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18.122 17.645a7.2 7.2 0 0 1-2.656 2.495 7.06 7.06 0 0 1-3.52.853 6.6 6.6 0 0 1-3.306-.718 6.73 6.73 0 0 1-2.54-2.266c-2.672-4.57.287-8.846.887-9.668A4.45 4.45 0 0 0 8.07 6.31 4.5 4.5 0 0 0 7.997 4c1.284.965 6.43 3.258 5.525 10.631 1.496-1.136 2.7-3.046 2.846-6.216 1.43 1.061 3.985 5.462 1.754 9.23"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $707cccf7196a9bbb$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h4v-4m-5 0v-4m0 4h5m-5-4V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v1.99M3 11h5v4m9.47 4.172-.869-1.439-2.816-.235-2.573-4.257 1.487-2.836 1.444 2.389a1.353 1.353 0 1 0 2.316-1.4l-1.444-2.39h3.136l2.61 4.278-1.072 2.585.87 1.438"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $a7ba6f1d0d4001f3$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 14v7M5 4.971v9.541c5.6-5.538 8.4 2.64 14-.086v-9.54C13.4 7.61 10.6-.568 5 4.97Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $18de913d2acd1a76$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M11 16h2m6.707-9.293-2.414-2.414A1 1 0 0 0 16.586 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7.414a1 1 0 0 0-.293-.707ZM16 20v-6a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6zM9 4h6v3a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $e5782a9c7b330a03$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M4 5a1 1 0 0 1 1-1h11.586a1 1 0 0 1 .707.293l2.414 2.414a1 1 0 0 1 .293.707V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M8 4h8v4H8zm7 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $08944ec5c244e984$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 21v-9m3-4H7.5a2.5 2.5 0 1 1 0-5c1.5 0 2.875 1.25 3.875 2.5M14 21v-9m-9 0h14v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zM4 8h16a1 1 0 0 1 1 1v3H3V9a1 1 0 0 1 1-1m12.155-5c-3 0-5.5 5-5.5 5h5.5a2.5 2.5 0 0 0 0-5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $146290efcc0024bf$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M4.37 7.657c2.063.528 2.396 2.806 3.202 3.87 1.07 1.413 2.075 1.228 3.192 2.644 1.805 2.289 1.312 5.705 1.312 6.705M20 15h-1a4 4 0 0 0-4 4v1M8.587 3.992c0 .822.112 1.886 1.515 2.58 1.402.693 2.918.351 2.918 2.334 0 .276 0 2.008 1.972 2.008 2.026.031 2.026-1.678 2.026-2.008 0-.65.527-.9 1.177-.9H20M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $28902549c04317ec$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h9.5M3 15v-4m0 4h9m-9-4V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v5zm5 0v8m4-8v8m7.1-1.1L21 16m0 0-1.9-1.9M21 16h-5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $85dc21d95a96722d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h9.5M3 15v-4m0 4h9m-9-4V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v5zm5 0v8m4-8v8m5.9-1.1L16 16m0 0 1.9-1.9M16 16h5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $2de15c616d7f61e0$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14 17h6m-3 3v-6M4.857 4h4.286c.473 0 .857.384.857.857v4.286a.857.857 0 0 1-.857.857H4.857A.857.857 0 0 1 4 9.143V4.857C4 4.384 4.384 4 4.857 4m10 0h4.286c.473 0 .857.384.857.857v4.286a.857.857 0 0 1-.857.857h-4.286A.857.857 0 0 1 14 9.143V4.857c0-.473.384-.857.857-.857m-10 10h4.286c.473 0 .857.384.857.857v4.286a.857.857 0 0 1-.857.857H4.857A.857.857 0 0 1 4 19.143v-4.286c0-.473.384-.857.857-.857"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b31774b43d701c93$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9.143 4H4.857A.857.857 0 0 0 4 4.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 10 9.143V4.857A.857.857 0 0 0 9.143 4m10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 20 9.143V4.857A.857.857 0 0 0 19.143 4m-10 10H4.857a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286a.857.857 0 0 0 .857-.857v-4.286A.857.857 0 0 0 9.143 14m10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286a.857.857 0 0 0 .857-.857v-4.286a.857.857 0 0 0-.857-.857"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $dcbba21e2da0329c$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "m20.953 11.763-2.052-2.052-2.052 2.052 2.052 2.053zm-1.368-2.736L15.48 4.922l-3.42 3.42 4.105 4.105zm-4.105 2.736-2.736-2.736-8.21 8.21 2.737 2.736z"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "m12.93 3.74 1.866 1.867-2.052 2.052-1.555-1.555c-.995-.995-3.234-.497-3.918.187l2.737-2.737c.684-.684 1.99-.746 2.923.187Z"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $2e5cdf08898c0fb9$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12.01 6.001C6.5 1 1 8 5.782 13.001L12.011 20l6.23-7C23 8 17.5 1 12.01 6.002Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $adbf0a38d5935ae1$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $ee7853acd957ddb3$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18.5 4h-13m13 16h-13M8 20v-3.333a2 2 0 0 1 .4-1.2L10 12.6a1 1 0 0 0 0-1.2L8.4 8.533a2 2 0 0 1-.4-1.2V4h8v3.333a2 2 0 0 1-.4 1.2L13.957 11.4a1 1 0 0 0 0 1.2l1.643 2.867a2 2 0 0 1 .4 1.2V20z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $60e0c749887c99f6$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m3 16 5-7 6 6.5m6.5 2.5L16 13l-4.286 6M14 10h.01M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $dce51857f786f53a$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 13h3.439a.99.99 0 0 1 .908.6 3.978 3.978 0 0 0 7.306 0 .99.99 0 0 1 .908-.6H20M4 13v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6M4 13l2-9h12l2 9M9 7h6m-7 3h8"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $48cc0aec999ae29b$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 13h3.439a.99.99 0 0 1 .908.6 3.978 3.978 0 0 0 7.306 0 .99.99 0 0 1 .908-.6H20M4 13v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6M4 13l2-9h12l2 9"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $536e24d2a4f59b14$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $d43cb9ed7676ca1e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 9V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3M3 9v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9M3 9h18M8 9V5m4 4V5m4 4V5m-6 9h2m0 0h2m-2 0v-2m0 2v2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4ee0f5c4048d81e8$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3M3 15V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v9M3 15h18M8 15v4m4-4v4m4-4v4m-6-9h2m0 0h2m-2 0v2m0-2V8"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $65296b946a40f1ee$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h10.5M3 15v-4m0 4h11M3 11V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v5M3 11h18m0 0v1M8 11v8m4-8v8m4-8v2m1 4h2m0 0h2m-2 0v2m0-2v-2"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $8652de8afa2e3593$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            d: "M3 11h18M3 15h18M8 10.792V19m4-8.208V19m4-8.208V19M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1d58dc07bd5faed7$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "square",
                d: "M8 15h7.01v.01H15z"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "square",
                d: "M20 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Z"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "square",
                d: "M6 9h.01v.01H6zm0 3h.01v.01H6zm0 3h.01v.01H6zm3-6h.01v.01H9zm0 3h.01v.01H9zm3-3h.01v.01H12zm0 3h.01v.01H12zm3 0h.01v.01H15zm3 0h.01v.01H18zm0 3h.01v.01H18zm-3-6h.01v.01H15zm3 0h.01v.01H18z"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $7cf531e8a7f2a8f7$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15.2 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11.2a1 1 0 0 0 .747-.334l4.46-5a1 1 0 0 0 0-1.332l-4.46-5A1 1 0 0 0 15.2 6"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $a26eef06e191201b$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M3 21h18M4 18h16M6 10v8m4-8v8m4-8v8m4-8v8M4 9.5v-.955a1 1 0 0 1 .458-.84l7-4.52a1 1 0 0 1 1.084 0l7 4.52a1 1 0 0 1 .458.84V9.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $781cebb3bab08cdc$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5.005 11.19V12l6.998 4.042L19 12v-.81M5 16.15v.81L11.997 21l6.998-4.042v-.81M12.003 3 5.005 7.042l6.998 4.042L19 7.042z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $09d15eaa1465d46e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m13.46 8.291 3.849-3.849a1.5 1.5 0 0 1 2.122 0l.127.127a1.5 1.5 0 0 1 0 2.122l-3.84 3.838a4 4 0 0 0-2.258-2.238m0 0a4 4 0 0 1 2.263 2.238l3.662-3.662a8.96 8.96 0 0 1 0 10.27l-3.676-3.676m-2.25-5.17 3.678-3.676a8.96 8.96 0 0 0-10.27 0l3.662 3.662a4 4 0 0 0-2.238 2.258L4.615 6.863a8.96 8.96 0 0 0 0 10.27l3.662-3.662a4 4 0 0 0 2.258 2.238l-3.672 3.676a8.96 8.96 0 0 0 10.27 0l-3.662-3.662a4 4 0 0 0 2.238-2.262m0 0 3.849 3.848a1.5 1.5 0 0 1 0 2.122l-.127.126a1.5 1.5 0 0 1-2.122 0l-3.838-3.838a4 4 0 0 0 2.238-2.258m.29-1.461a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-7.718 1.471-3.84 3.838a1.5 1.5 0 0 0 0 2.122l.128.126a1.5 1.5 0 0 0 2.122 0l3.848-3.848a4 4 0 0 1-2.258-2.238m2.248-5.19L6.69 4.442a1.5 1.5 0 0 0-2.122 0l-.127.127a1.5 1.5 0 0 0 0 2.122l3.849 3.848a4 4 0 0 1 2.238-2.258Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $816c4296188347e7$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 9a3 3 0 0 1 3-3m-2 15h4m0-3c0-4.1 4-4.9 4-9A6 6 0 1 0 6 9c0 4 4 5 4 9z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $0b5b898514ae544d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M13.213 9.787a3.39 3.39 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961M19.573 20l-1.787-1.786m0 0L16 16.427m1.786 1.787 1.787-1.787m-1.787 1.787L16 20"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $97a1318e7621239d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.213 9.787a3.39 3.39 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $937e7d468a5f33d0$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 14v3m4-6V7a3 3 0 1 1 6 0v4M5 11h10a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1c70fb01a3cd50dc$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9.5 11H5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h4.5M7 11V7a3 3 0 0 1 6 0v1.5m2.5 5.5v1.5l1 1m3.5-1a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4773f58bab022724$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 14v3m-3-6V7a3 3 0 1 1 6 0v4m-8 0h10a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $d551331772cdb8c7$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 16v-5.5A3.5 3.5 0 0 0 7.5 7m3.5 9H4v-5.5A3.5 3.5 0 0 1 7.5 7m3.5 9v4M7.5 7H14m0 0V4h2.5M14 7v3m-3.5 6H20v-6a3 3 0 0 0-3-3m-2 9v4m-8-6.5h1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $06fa9fea7cf027a2$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M17.8 13.938h-.011a7 7 0 1 0-11.464.144h-.016l.14.171q.15.19.3.371L12 21l5.13-6.248q.291-.314.54-.659z"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $eff02dff0c717903$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0 0v6M9.5 9A2.5 2.5 0 0 1 12 6.5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $93f03378a01cd296$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 18v2H4V4h6v2m4 12v2h6V4h-6v2m-6.495 8.495L10 12m0 0L7.505 9.505M10 12H4.052m12.502 2.554L14 12m0 0 2.554-2.554M14 12h5.832"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $98d17a8560523366$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18.505 14.495 21 12m0 0-2.495-2.495M21 12h-5.948m-9.498 2.554L3 12m0 0 2.554-2.554M3 12h5.832M9 19V5h6v14z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $debbc66a5101283e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 9h5m3 0h2M7 12h2m3 0h5M5 5h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-6.616a1 1 0 0 0-.67.257l-2.88 2.592A.5.5 0 0 1 8 18.477V17a1 1 0 0 0-1-1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $0c9d8331036efef4$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 10.5h.01m-4.01 0h.01M8 10.5h.01M5 5h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-6.6a1 1 0 0 0-.69.275l-2.866 2.723A.5.5 0 0 1 8 18.635V17a1 1 0 0 0-1-1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $2a09b9c49cc5afc4$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 17h6l3 3v-3h2V9h-2M4 4h11v8H9l-3 3v-3H4z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $0ddf8cac517562be$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 12h14"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $67887c522db58817$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 15h12M6 6h12m-6 12h.01M7 21h10a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c5b2ca220f1c8bcd$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19 7h1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h11.5M7 14h6m-6 3h6m0-10h.5m-.5 3h.5M7 7h3v3H7z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $cbfc0b07ed774b15$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M4 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm16 14a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1zM4 13a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm16-2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $00610e15ff6b663a$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 18V6h-5v12zm0 0h2M4 18h2.5m3.5-5.5V12M6 6l7-2v16l-7-2z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $2ee538b6d11d770b$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m7 10 2 2-2 2m5-9v14M5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4d3600b945cb5aba$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m6 10 2 2-2 2m5-9v14m-7 0h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $318f32719d474b07$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 7h.01m3.486 1.513h.01m-6.978 0h.01M6.99 12H7m9 4h2.706a1.96 1.96 0 0 0 1.883-1.325A9 9 0 1 0 3.043 12.89 9.1 9.1 0 0 0 8.2 20.1a8.6 8.6 0 0 0 3.769.9 2.013 2.013 0 0 0 2.03-2v-.857A2.036 2.036 0 0 1 16 16"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $0dc1351406040a00$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 8v8a5 5 0 1 0 10 0V6.5a3.5 3.5 0 1 0-7 0V15a2 2 0 0 0 4 0V8"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $caee8b5239685b10$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m12 18-7 3 7-18 7 18zm0 0v-5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $175a184dd9d4ee18$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m4.988 19.012 5.41-5.41m2.366-6.424 4.058 4.058-2.03 5.41L5.3 20 4 18.701l3.355-9.494 5.41-2.029Zm4.626 4.625L12.197 6.61 14.807 4 20 9.194z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $5fe910c580366ba6$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10.779 17.779 4.36 19.918 6.5 13.5m4.279 4.279 8.364-8.643a3.027 3.027 0 0 0-2.14-5.165 3.03 3.03 0 0 0-2.14.886L6.5 13.5m4.279 4.279L6.499 13.5m2.14 2.14 6.213-6.504M12.75 7.04 17 11.28"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $27779a4277411c00$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5.693 16.013H7.31a1.685 1.685 0 0 0 1.685-1.684v-.645A1.684 1.684 0 0 1 10.679 12h2.647a1.686 1.686 0 0 1 1.686 1.686v.646c0 .446.178.875.494 1.19.316.317.693.495 1.14.495h1.685a1.556 1.556 0 0 0 1.597-1.016c.078-.214.107-.776.088-1.002.014-4.415-3.571-6.003-8-6.004-4.427 0-8.014 1.585-8.01 5.996-.02.227.009.79.087 1.003a1.56 1.56 0 0 0 1.6 1.02Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $2f249a8b181d3533$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18.427 14.768 17.2 13.542a1.733 1.733 0 0 0-2.45 0l-.613.613a1.73 1.73 0 0 1-2.45 0l-1.838-1.84a1.735 1.735 0 0 1 0-2.452l.612-.613a1.735 1.735 0 0 0 0-2.452L9.237 5.572a1.6 1.6 0 0 0-2.45 0c-3.223 3.2-1.702 6.896 1.519 10.117s6.914 4.745 10.12 1.535a1.6 1.6 0 0 0 0-2.456Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $40577dbf7eb2837b$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 12h14m-7 7V5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $61a8eb7fec9bb4dc$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M16.444 18H19a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2.556M17 11V5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v6zM7 15h10v4a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $cf60500c2ac924b9$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M4 4h6v6H4zm10 10h6v6h-6zm0-10h6v6h-6zm-4 10h.01v.01H10zm0 4h.01v.01H10zm-3 2h.01v.01H7zm0-4h.01v.01H7zm-3 2h.01v.01H4zm0-4h.01v.01H4z"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M7 7h.01v.01H7zm10 10h.01v.01H17z"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $5a46277ff1695bbe$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9.529 9.988a2.502 2.502 0 1 1 5 .191A2.44 2.44 0 0 1 12 12.582V14m-.01 3.008H12M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $7d1fd724b31c8f3d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 11.5h13m-13 0V18a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6.5m-13 0V9a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2.5M9 5h11a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $7b41743a3c44e974$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m10.051 8.102-3.778.322-1.994 1.994a.94.94 0 0 0 .533 1.6l2.698.316m8.39 1.617-.322 3.78-1.994 1.994a.94.94 0 0 1-1.595-.533l-.4-2.652m8.166-11.174a1.37 1.37 0 0 0-1.12-1.12c-1.616-.279-4.906-.623-6.38.853-1.671 1.672-5.211 8.015-6.31 10.023a.93.93 0 0 0 .162 1.111l.828.835.833.832a.93.93 0 0 0 1.111.163c2.008-1.102 8.35-4.642 10.021-6.312 1.475-1.478 1.133-4.77.855-6.385m-2.961 3.722a1.88 1.88 0 1 1-3.76 0 1.88 1.88 0 0 1 3.76 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $34487b0925ea411b$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 7H7m2 3H7m2 3H7m4 2v2m3-2v2m3-2v2M4 5v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-9a1 1 0 0 1-1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $21ddbd3e363f5ef5$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $44375d3c4cc0f0cd$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1M5 12h14M5 12a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1m-2 3h.01M14 15h.01M17 9h.01M14 9h.01"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $ed6a115520edcae3$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M7.926 10.898 15 7.727m-7.074 5.39L15 16.29M8 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm12 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0-11a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c5b02aa15ae652c6$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9.5 11.5 11 13l4-3.5M12 20a16.4 16.4 0 0 1-5.092-5.804A16.7 16.7 0 0 1 5 6.666L12 4l7 2.667a16.7 16.7 0 0 1-1.908 7.529A16.4 16.4 0 0 1 12 20"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $5da043369ae0e611$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 20a16.4 16.4 0 0 1-5.092-5.804A16.7 16.7 0 0 1 5 6.666L12 4l7 2.667a16.7 16.7 0 0 1-1.908 7.529A16.4 16.4 0 0 1 12 20"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $10074d8c3d4f17a3$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 18v2h6V4H4v2m16 12v2h-6V4h6v2M6.495 14.495 4 12m0 0 2.495-2.495M4 12h5.948m7.498 2.554L20 12m0 0-2.554-2.554M20 12h-5.832"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1ee10d7efbe05779$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            d: "M12 4.392v14.832M8.476 9.38l-4.553.36c-.888.07-1.248 1.165-.572 1.737l3.47 2.934a.98.98 0 0 1 .322.98l-1.06 4.388c-.206.855.736 1.531 1.497 1.073l3.898-2.351c.32-.193.723-.193 1.044 0l3.898 2.351c.76.458 1.703-.218 1.497-1.073l-1.06-4.388a.98.98 0 0 1 .322-.98l3.47-2.934c.676-.572.316-1.667-.572-1.737l-4.553-.36a1 1 0 0 1-.845-.606l-1.754-4.165c-.342-.812-1.508-.812-1.85 0L9.321 8.774a1 1 0 0 1-.845.606Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3c133c1dcf72bca8$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            d: "m12.25 20.825 4.247-2.436a1 1 0 0 0 .503-.867V4.03c0-.405-2.062 3.38-2.8 4.747a1 1 0 0 1-.807.523l-4.87.367c-.903.068-1.258 1.208-.55 1.776l3.576 2.878a1 1 0 0 1 .343 1.025l-1.11 4.366c-.217.856.701 1.553 1.468 1.113Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $12cc23bd8788cf9d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            d: "M11.083 5.104c.35-.8 1.485-.8 1.834 0l1.752 4.022a1 1 0 0 0 .84.597l4.463.342c.9.069 1.255 1.2.556 1.771l-3.33 2.723a1 1 0 0 0-.337 1.016l1.03 4.119c.214.858-.71 1.552-1.474 1.106l-3.913-2.281a1 1 0 0 0-1.008 0L7.583 20.8c-.764.446-1.688-.248-1.474-1.106l1.03-4.119A1 1 0 0 0 6.8 14.56l-3.33-2.723c-.698-.571-.342-1.702.557-1.771l4.462-.342a1 1 0 0 0 .84-.597z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4fb08fdb744ccae5$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M7.111 20A3.11 3.11 0 0 1 4 16.889v-12C4 4.398 4.398 4 4.889 4h4.444a.89.89 0 0 1 .89.889v12A3.11 3.11 0 0 1 7.11 20Zm0 0h12a.89.89 0 0 0 .889-.889v-4.444a.89.89 0 0 0-.889-.89h-4.389a.9.9 0 0 0-.62.253l-3.767 3.665a1 1 0 0 0-.146.185c-.868 1.433-1.581 1.858-3.078 2.12Zm0-3.556h.009m7.933-10.927 3.143 3.143a.89.89 0 0 1 0 1.257l-7.974 7.974v-8.8l3.574-3.574a.89.89 0 0 1 1.257 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $fcbf2e7cf0de857e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M9 5h-.167a4 4 0 0 0-2.4.8L3.5 8l2 3.5L8 10v9h8v-9l2.5 1.5 2-3.5-2.933-2.2a4 4 0 0 0-2.4-.8H15M9 5c0 1.5 1.5 3 3 3s3-1.5 3-3M9 5h6"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $7afbf86cd621cb32$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            d: "M3 11h18m-9 0v8m-8 0h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $a56a17f5baa56152$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            d: "M3 11h18M3 15h18m-9-4v8m-8 0h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $2322c322ecb0649b$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 18h2M5.875 3h12.25c.483 0 .875.448.875 1v16c0 .552-.392 1-.875 1H5.875C5.392 21 5 20.552 5 20V4c0-.552.392-1 .875-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $a9f8c8c04c9e25b3$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7.5 15a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 0 1.677-4.17m6.698-3.827C17.012 7.003 18 6.105 18 5s-.922-2-2.059-2c-.896 0-1.685.743-1.968 1.52M8.127 6.995C7.002 6.995 6 6.105 6 5s.912-2 2.038-2c.934 0 1.706.678 1.947 1.52M14 18h-4m6-3-1.458-3.891m-6.635 2.879-.449.193a1.868 1.868 0 1 1-1.103-3.568L8.5 10m7.106 3.988.413.144a1.865 1.865 0 1 0 1.172-3.54l-1.746-.558M12 9.062v-.01m-1.378-1.554v-.01m3.034.01v-.01M16 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0m3 9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $114f558c46ac9445$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 9 3 3-3 3m5 0h3M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $e6bf8637ba4113af$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M12 20v-4M7 4h10M9 5v5c0 .552-.47 1.005-.948 1.279-1.435.822-2.602 3.245-2.257 4.365.078.254.354.356.62.356h11.17c.266 0 .542-.102.62-.356.345-1.12-.822-3.543-2.256-4.365-.48-.274-.949-.727-.949-1.279V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $8ff0ac1f824a4ea6$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18.5 12A2.5 2.5 0 0 1 21 9.5V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2.5a2.5 2.5 0 0 1 0 5V17a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2.5a2.5 2.5 0 0 1-2.5-2.5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $af78953c2b55b9c5$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h10M3 15v-4m0 4h9m-9-4V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3M3 11h11m-2-.208V19m3-4h1.99M21 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $dd50dab15d7ff25f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 5v14m6-8h-6m6 4h-6m-9-3h1.99M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1m8-7a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c80c8e91c30e9034$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3M3 15V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v9M3 15h18M8 15v4m4-4v4m4-4v4m-7-9h1.99M15 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $1a542a7554754056$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "m7.582 8.96 2.232 2.232-1.618 1.618a3.523 3.523 0 0 0-3.697 5.12 1 1 0 0 0 .936.53 1 1 0 0 0 .53.936 3.522 3.522 0 0 0 5.12-3.697l4.81-4.811a3.523 3.523 0 0 0 3.697-5.12 1 1 0 0 0-.935-.53 1 1 0 0 0-.531-.936 3.523 3.523 0 0 0-5.12 3.697l-1.778 1.778-2.232-2.231zm1.31-3.14a1 1 0 0 0-.536-.761L6.374 4.046a1 1 0 0 0-1.162.183l-.863.863a1 1 0 0 0-.183 1.162l1.013 1.982a1 1 0 0 0 .762.537l1.112.144a1 1 0 0 0 .836-.285l.863-.863a1 1 0 0 0 .285-.835zm10.553 10.585-3.119-3.119a2 2 0 0 0-2.828 0l-.172.173a2 2 0 0 0 0 2.828l3.118 3.119a2 2 0 0 0 2.829 0l.172-.172a2 2 0 0 0 0-2.829Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $63d7ab20944f9df3$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M5 19h4m6 0h4m-6.963-4.384V8.634L17 5.94m-4.93 2.662L7.042 5.94M12 2.997l5.033 2.906v5.812L12 14.62l-5.033-2.906V5.903zM14 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $ae561160262f7ed8$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1M6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $e13aaf7da9cb8b51$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13 7h6l2 4m-8-4v8H9m4-8V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9h2m14 0h2v-4m0 0h-5M8 8.667V10l1.5 1.5m10 5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-10 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $f0723071e704fa0f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13 7h6l2 4m-8-4v8m0-8V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9h2m8 0H9m4 0h2m4 0h2v-4m0 0h-5m3.5 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-10 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $132c592ef810aec3$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 5v9m-5 0H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2M8 9l4-5 4 5m1 8h.01"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $fda6b3b61d71bf3d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17.5 8.43A4.99 4.99 0 0 1 19 12a4.98 4.98 0 0 1-1.43 3.5M14 6.135v11.73a1 1 0 0 1-1.64.768L8 15H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2l4.36-3.633a1 1 0 0 1 1.64.768"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $feb73f5f5c8f6c61$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15.5 8.43A4.99 4.99 0 0 1 17 12a4.98 4.98 0 0 1-1.43 3.5m2.794 2.864A8.97 8.97 0 0 0 21 12a8.97 8.97 0 0 0-2.636-6.364M12 6.135v11.73a1 1 0 0 1-1.64.768L6 15H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2l4.36-3.633a1 1 0 0 1 1.64.768"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $8db3a016ce424203$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16.872 9.687 20 6.56 17.44 4 4 17.44 6.56 20 16.873 9.687Zm0 0-2.56-2.56M6 7v2m0 0v2m0-2H4m2 0h2m7 7v2m0 0v2m0-2h-2m2 0h2M8 4h.01v.01H8zm2 2h.01v.01H10zm2-2h.01v.01H12zm8 8h.01v.01H20zm-2 2h.01v.01H18zm2 2h.01v.01H20z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $8eba9fa77e9ae373$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 8h.01M9 8h.01M12 8h.01M4 11h16M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $2fa22afcb17e2b72$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m21 21-3.5-3.5M10 7v6m-3-3h6m4 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3d09e7ccbeb41487$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m21 21-3.5-3.5M7 10h6m4 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $92abf9492d0ff626$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 6v12m8-12v12l-8-6z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $753f81b082726037$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M4 18V8a1 1 0 0 1 1-1h1.5l1.707-1.707A1 1 0 0 1 8.914 5h6.172a1 1 0 0 1 .707.293L17.5 7H19a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Z"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $24c008c2cf83ec98$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10.855 14.322a2.475 2.475 0 1 1 .133-4.241m6.053 4.241a2.475 2.475 0 1 1 .133-4.241M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c712c64294ecd91f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 9v6m4-6v6m7-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $011c4e7b3a07a192$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m0 0-4 4m5 0H4m1 0 4-4m1 4 4-4m-4 7v6l4-3z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $35b84efde2bff0c3$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1M9 12H4m8 8V9h8v11zm0 0H9m8-4a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $4bdfe692354cd7bb$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 6v12M8 6v12l8-6z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $106343219553fd1f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M20 16v-4a8 8 0 1 0-16 0v4m16 0v2a2 2 0 0 1-2 2h-2v-6h2a2 2 0 0 1 2 2ZM4 16v2a2 2 0 0 0 2 2h2v-6H6a2 2 0 0 0-2 2Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c9fe873ecfe7aa8e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19.023 4 14 8.981m0 0h3.03m-3.03 0V6m4.233 8.515L17.09 13.37c-1.143-1.144-1.976-.37-2.839.457a1.684 1.684 0 0 1-2.382 0l-1.871-1.873c-.656-.656-.925-1.46 0-2.384.849-.868 1.684-1.612.493-2.804L9.3 5.575c-.905-.905-1.992-.383-2.619.237-3.132 3.111-1.72 6.77 1.41 9.901s6.788 4.547 9.906 1.426c.174-.147.55-.565.647-.772a1.56 1.56 0 0 0-.411-1.852"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $33389ee6f81ce0ca$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17 15.5V5s3 1 3 4m-7-3H4m9 4H4m4 4H4m13 2.4c0 1.326-1.343 2.4-3 2.4s-3-1.075-3-2.4 1.343-2.4 3-2.4 3 1.075 3 2.4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $9a6853eca3d124a7$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            fill: "currentColor",
            d: "M19.97 9.012a1 1 0 1 0-2 0zm-1 2.988 1 .001V12zm-8.962 4.98-.001 1h.001zm-3.52-1.46.708-.708zM5.029 12h-1v.001zm3.984 7.963a1 1 0 1 0 0 2zm5.975 2a1 1 0 0 0 0-2zM7.017 8.017a1 1 0 1 0 2 0zm6.641 4.862a1 1 0 1 0 .667 1.886zm-7.63-2.87a1 1 0 1 0-2 0zm9.953 5.435a1 1 0 1 0 1 1.731zM12 16.979h1a1 1 0 0 0-1-1zM5.736 4.322a1 1 0 0 0-1.414 1.414zm12.528 15.356a1 1 0 0 0 1.414-1.414zM17.97 9.012V12h2V9.012zm0 2.987a3.99 3.99 0 0 1-1.168 2.813l1.415 1.414a5.99 5.99 0 0 0 1.753-4.225zm-7.962 3.98a3.99 3.99 0 0 1-2.813-1.167l-1.414 1.414a5.99 5.99 0 0 0 4.225 1.753zm-2.813-1.167a3.99 3.99 0 0 1-1.167-2.813l-2 .002a5.99 5.99 0 0 0 1.753 4.225zm3.808-10.775h1.992v-2h-1.992zm1.992 0c1.097 0 1.987.89 1.987 1.988h2a3.99 3.99 0 0 0-3.987-3.988zm1.987 1.988v4.98h2v-4.98zm-5.967 0c0-1.098.89-1.988 1.988-1.988v-2a3.99 3.99 0 0 0-3.988 3.988zm-.004 15.938H12v-2H9.012v2Zm2.988 0h2.987v-2H12zM9.016 8.017V6.025h-2v1.992zm5.967 2.987a1.99 1.99 0 0 1-1.325 1.875l.667 1.886a3.99 3.99 0 0 0 2.658-3.76zM6.03 12v-1.992h-2V12zm10.774 2.812a4 4 0 0 1-.823.632l1.002 1.731a6 6 0 0 0 1.236-.949zM4.322 5.736l13.942 13.942 1.414-1.414L5.736 4.322zM12 15.98h-1.992v2H12zm-1 1v3.984h2V16.98z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c6caf393c617d528$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19 9v3a5.006 5.006 0 0 1-5 5h-4a5.006 5.006 0 0 1-5-5V9m7 9v3m-3 0h6M11 3h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c2ff2c513fcdbdc1$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m17.09 13.371 1.143 1.144a1.56 1.56 0 0 1 .41 1.852c-.095.207-.472.625-.646.771-3.118 3.122-6.774 1.706-9.905-1.425s-4.543-6.79-1.41-9.901c.626-.62 1.713-1.142 2.618-.237l1.19 1.192c1.192 1.192.357 1.936-.492 2.804-.925.925-.656 1.728 0 2.384l1.871 1.873a1.684 1.684 0 0 0 2.382 0c.863-.827 1.696-1.6 2.839-.457M14.874 8.98l2.135-2.135m0 0 2.16-1.907m-2.16 1.907 2.16 2.15m-2.16-2.15-2.135-1.907"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $03f357d7f3dd7a33$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 16.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m0 0V5c2.5 0 6 2.5 4.5 7"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $80e1f03a2ef2b4d2$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 0V6.333L18 4v11.667M8 10.333 18 8m0 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $e6de103196b8cff1$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m17.09 13.371 1.143 1.144a1.56 1.56 0 0 1 .41 1.852c-.095.207-.472.625-.646.771-3.118 3.122-6.774 1.706-9.905-1.425s-4.543-6.79-1.41-9.901c.626-.62 1.713-1.142 2.618-.237l1.19 1.192c1.192 1.192.357 1.936-.492 2.804-.925.925-.656 1.728 0 2.384l1.871 1.873a1.684 1.684 0 0 0 2.382 0c.863-.827 1.696-1.6 2.839-.457M14 8.981 19.023 4m0 0h-3.03m3.03 0v2.981"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $2094dccd582058fa$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 6H8a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1m7 0h-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $479642b7a7adc078$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 18V6l8 6z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $09f911cd1b5691c7$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 9h6m-6 3h6m-6 3h6M6.996 9h.01m-.01 3h.01m-.01 3h.01M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $7c5988adc07e1b33$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.484 9.166 15 7h5m0 0-3-3m3 3-3 3M4 17h4l1.577-2.253M4 7h4l7 10h5m0 0-3 3m3-3-3-3"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $33eae4a2c71de6c2$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("rect", {
            width: 12,
            height: 12,
            x: 6,
            y: 6,
            stroke: "currentColor",
            strokeLinejoin: "round",
            rx: 1
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $68242fedaa3d7b5d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1m7 11-6-2V9l6-2z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $6e0ce0a10a1bdd07$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15.5 8.43A4.99 4.99 0 0 1 17 12c0 1.126-.5 2.5-1.5 3.5m2.864-9.864A8.97 8.97 0 0 1 21 12c0 2.023-.5 4.5-2.5 6M7.8 7.5l2.56-2.133a1 1 0 0 1 1.64.768V12m0 4.5v1.365a1 1 0 0 1-1.64.768L6 15H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m1-4 14 14"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $fcf3b9be3c528b98$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 6h8M6 10h12M8 14h8M6 18h12"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $2abb2bd9f69f1f55$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 6H6m12 4H6m12 4H6m12 4H6"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c4ed4757b1454b1f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 6h8m-8 4h12M6 14h8m-8 4h12"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b106d1e244f20041$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 6h-8m8 4H6m12 4h-8m8 4H6"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $384f6e458ff932d1$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m6.082 15.982 1.573-4m-1.573 4h-1.1m1.1 0h1.65m-.077-4 2.725-6.93a.11.11 0 0 1 .204 0l2.725 6.93m-5.654 0h-.006m.006 0h5.654m0 0 .617 1.569m5.11 4.453c0 1.102-.854 1.996-1.908 1.996s-1.908-.894-1.908-1.996c0-1.103 1.908-4.128 1.908-4.128s1.908 3.025 1.908 4.128Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $ca4e803cd43aa7ae$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m10.579 19 4.297-10.93a.11.11 0 0 1 .205 0L19.378 19m-8.8 0h-1.1m1.1 0h1.65m7.15 0h-1.65m1.65 0h1.1m-7.7-3.985h4.4M3 16l1.567-3.985m0 0 2.73-6.945a.11.11 0 0 1 .205 0l2.504 6.945z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $5bbded28016337c3$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M9 20H5.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H18m-6-1 1.42 1.893a.1.1 0 0 0 .16 0L15 19m-7-6 3.907-9.768a.1.1 0 0 1 .186 0L16 13m-8 0H7m1 0h1.5m6.5 0h-1.5m1.5 0h1m-7-3h4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $dc0d5fe5455d5649$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsxs)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: [
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                d: "M5 12h14"
            }),
            /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                d: "M6 9.5h12m-12-2h12m-12-2h12m-12 13h12m-12-2h12m-12-2h12"
            })
        ]
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $d1db54d5e66c7500$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 6h12M6 18h12m-5-8h5m-5 4h5M6 9v6l3.5-3z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $16dd69461bfbc34e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m13 19 3.5-9 3.5 9m-6.125-2h5.25M3 7h7m0 0h2m-2 0c0 1.63-.793 3.926-2.239 5.655M7.5 6.818V5m.261 7.655C6.79 13.82 5.521 14.725 4 15m3.761-2.345L5 10m2.761 2.655L10.2 15"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $d4f6e2218096d978$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 5h4.5a3.5 3.5 0 1 1 0 7H8m0-7v7m0-7H6m2 7h6.5a3.5 3.5 0 1 1 0 7H8m0-7v7m0 0H6"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $efa8a4871c8a86e8$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8.874 19 6.143-14M6 19h6.33m-.66-14H18"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $622816fc049d6386$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M6 19h12M8 5v9a4 4 0 0 0 8 0V5M6 5h4m4 0h4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $ffddd6e12e6d2b36$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M9 8h10M9 12h10M9 16h10M4.99 8H5m-.02 4h.01m0 4H5"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $6ef220bd38db71e5$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 6h8m-8 6h8m-8 6h8M4 16a2 2 0 1 1 3.321 1.5L4 20h5M4 5l2-1v6m-2 0h4"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $89bf07d64f136c89$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 6h12M6 18h12m-5-8h5m-5 4h5M9.5 9v6L6 12z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $ed25447e0e2406da$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 5v7m0 7v-7m4-7v14m3-14H8.5A3.5 3.5 0 0 0 5 8.5v0A3.5 3.5 0 0 0 8.5 12H12"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $8e9131001e1f7b68$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 11V8a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1m0 0v2a4 4 0 0 1-4 4H5m14-6V8a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1m0 0v2a4 4 0 0 1-4 4h-1"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $e524159c096b6051$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M20 20h-4v-.5c1.099-1.033 3.75-2.5 3.75-3.5v-1a1 1 0 0 0-1-1H17a1 1 0 0 0-1 1M4 4l9.122 11.393m0-11.393L4 15.393"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $3b79939608436e0e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M20 10h-4v-.5C17.099 8.467 19.75 7 19.75 6V5a1 1 0 0 0-1-1H17a1 1 0 0 0-1 1M4 7.303l9.122 11.394m0-11.394L4 18.697"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $9b8df0bbad83193f$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 6.2V5h11v1.2M8 5v14m-3 0h6m2-6.8V11h8v1.2M17 11v8m-1.5 0h3"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $38113a440b064d50$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 6.2V5h12v1.2M7 19h6m.2-14-1.677 6.523M9.6 19l1.029-4M5 5l6.523 6.523M19 19l-7.477-7.477"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $06a8c81cf896f6ba$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M5 19h14M7.6 16l4.298-10.93a.11.11 0 0 1 .204 0L16.4 16m-8.8 0H6.5m1.1 0h1.65m7.15 0h-1.65m1.65 0h1.1m-8.333-4h5.66"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $fe72044a4937423e$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 6H5m2 3H5m2 3H5m2 3H5m2 3H5m11-1a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2M7 3h11a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m8 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $c53a5441fd9d74a4$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 9h3m-3 3h3m-3 3h3m-6 1c-.306-.613-.933-1-1.618-1H7.618c-.685 0-1.312.387-1.618 1M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $2bda95d641021d88$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 12h4m-2 2v-4M4 18v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1m8-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $caeaaf1dc87432d8$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0 0a8.95 8.95 0 0 0 4.951-1.488A3.987 3.987 0 0 0 13 16h-2a3.987 3.987 0 0 0-3.951 3.512A8.95 8.95 0 0 0 12 21m3-11a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $f9296fa9850901c9$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "square",
            strokeLinejoin: "round",
            d: "M7 19H5a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h1m4-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm7.441 1.559a1.907 1.907 0 0 1 0 2.698l-6.069 6.069L10 19l.674-3.372 6.07-6.07a1.907 1.907 0 0 1 2.697 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $41a802383ca98dbc$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 12h4M4 18v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1m8-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $49405ece07c2c485$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "square",
            strokeLinejoin: "round",
            d: "M10 19H5a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h2m10 1a3 3 0 0 1-3 3m3-3a3 3 0 0 0-3-3m3 3h1m-4 3a3 3 0 0 1-3-3m3 3v1m-3-4a3 3 0 0 1 3-3m-3 3h-1m4-3v-1m-2.121 1.879-.707-.707m5.656 5.656-.707-.707m-4.242 0-.707.707m5.656-5.656-.707.707M12 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $973d87f12373f8ed$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            d: "M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $bdc6e6c02819d6ce$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M4.5 17H4a1 1 0 0 1-1-1 3 3 0 0 1 3-3h1m0-3.05A2.5 2.5 0 1 1 9 5.5M19.5 17h.5a1 1 0 0 0 1-1 3 3 0 0 0-3-3h-1m0-3.05a2.5 2.5 0 1 0-2-4.45m.5 13.5h-7a1 1 0 0 1-1-1 3 3 0 0 1 3-3h3a3 3 0 0 1 3 3 1 1 0 0 1-1 1Zm-1-9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $91cb8a49b53a0b8d$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M16 19h4a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-2m-2.236-4a3 3 0 1 0 0-4M3 18v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm8-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $b9b48e6874f54436$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17 5v3m0 0v3m0-3h-3m3 0h3m-3.356 7.091c-1.638 0-2.58-.248-3.708-.957a6.77 6.77 0 0 1-2.563-2.909 6.5 6.5 0 0 1-.501-3.788A6.6 6.6 0 0 1 11.596 4a7.96 7.96 0 0 0-3.668 1.565 7.57 7.57 0 0 0-2.38 3.115 7.3 7.3 0 0 0-.469 3.845 7.4 7.4 0 0 0 1.569 3.563 7.8 7.8 0 0 0 3.192 2.343c1.256.5 2.627.675 3.975.507a8 8 0 0 0 3.712-1.463A7.6 7.6 0 0 0 20 14.427c-1.006.52-1.932.664-3.356.664"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $e331857b4c24c9ac$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 21a9 9 0 0 1-.5-17.986V3c-.354.966-.5 1.911-.5 3a9 9 0 0 0 9 9c.239 0 .254.018.488 0A9 9 0 0 1 12 21"
        })
    }));
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


var $5s1kH = parcelRequire("5s1kH");

var $02a121f8ca71b158$export$2e2bcd8739ae039 = (0, $5s1kH.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)((0, $55c03152d749d817$export$20931e2295160b07), (0, $lf4fc._)((0, $hwO3w._)({
        fill: "none",
        ref: ref
    }, props), {
        children: /* @__PURE__ */ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 5V3m0 18v-2M7.05 7.05 5.636 5.636m12.728 12.728L16.95 16.95M5 12H3m18 0h-2M7.05 16.95l-1.414 1.414M18.364 5.636 16.95 7.05M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
        })
    }));
});






var $68df94d610fdbee0$var$expandedMinWidth = 925;
var $68df94d610fdbee0$var$NavMenu = function(props) {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), showDeleteThread = _useState[0], setShowDeleteThread = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), showRenameThread = _useState1[0], setShowRenameThread = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), threadName = _useState2[0], setThreadName = _useState2[1];
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var midnight = new Date().setHours(23, 59, 59);
    var secondsPerDay = 86400;
    var _useAtom = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$27d71ceb0a5d4830)), 2), threads = _useAtom[0], setThreads = _useAtom[1];
    var _useAtom1 = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$bcd68c06e4ab205)), 1), customerCategories = _useAtom1[0];
    var _useAtom2 = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$cde9a322e13eb845)), 1), unreadChats = _useAtom2[0];
    var _useAtom3 = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$b8c60edfdda1ff8f)), 1), department = _useAtom3[0];
    var _useAtom4 = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$af51c67eaab3b0e9)), 1), onboarded = _useAtom4[0];
    var _useAtom5 = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$e12ef450b148e207)), 1), customerSurveys = _useAtom5[0];
    var scrollRef = (0, $5s1kH.useRef)(null);
    var userType = (0, $632c75b97b900307$export$1630b5343357e8b5).USER_TYPE;
    //  collapsed by default (w-16), overlay fixed
    //  on hover expand to w-64 and reveal labels + thread list
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(window.innerWidth < $68df94d610fdbee0$var$expandedMinWidth), 2), expanded = _useState3[0], setExpanded = _useState3[1];
    (0, $5s1kH.useEffect)(function() {
        var handleResize = function() {
            if (window.innerWidth < $68df94d610fdbee0$var$expandedMinWidth) setExpanded(true); // always expanded on mobile
            else setExpanded(false); // default collapsed on larger screens
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (props.showSidebar) {
            if (scrollRef.current) scrollRef.current.scrollTo(0, 0);
        }
    }, [
        props.showSidebar
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (!location.pathname.startsWith("/ai/")) {
            var _threads = (0, $XnYkK._)(threads);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _threads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _thread = _step.value;
                    _thread.selected = false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            setThreads(_threads);
        }
    }, [
        location.pathname
    ]);
    var goTo = function(link) {
        var _threads = (0, $XnYkK._)(threads);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _threads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _thread = _step.value;
                _thread.selected = false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (props.menuClick) props.menuClick();
        navigate(link);
    };
    var selectThread = function(threadId) {
        var _threads = (0, $XnYkK._)(threads);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _threads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _thread = _step.value;
                _thread.selected = _thread.id === threadId;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setThreads(_threads);
        if (props.menuClick) props.menuClick();
        navigate("/ai/" + threadId);
    };
    var calculateMenuItems = function() {
        var items = [];
        var p = window.location.pathname;
        var selected = false;
        if (userType === "coach") {
            selected = p === "/";
            items.push({
                title: t("start"),
                link: "/",
                icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $adbf0a38d5935ae1$export$2e2bcd8739ae039), {
                    style: {
                        color: selected ? "#ffffff" : ""
                    },
                    className: "h-6 w-6"
                }),
                selected: selected
            });
            if (onboarded) {
                selected = p === "/bookings";
                items.push({
                    title: t("my-bookings"),
                    link: "/bookings",
                    icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($6a8934e17fe6bbbb$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($584664dac616447b$exports))),
                        className: "h-6 w-6",
                        alt: "home"
                    }),
                    selected: selected
                });
                selected = p.startsWith("/clients");
                items.push({
                    title: t("my-clients"),
                    link: "/clients",
                    icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($5ed9bce35a180ef3$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($66a09fc2f3d74e63$exports))),
                        className: "h-6 w-6",
                        alt: "home"
                    }),
                    selected: selected
                });
                selected = p.startsWith("/chats");
                items.push({
                    title: t("chat"),
                    link: "/chats",
                    icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($07ace4e0b313d326$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($b12489d6f28ed582$exports))),
                        className: "h-6 w-6",
                        alt: "home"
                    }),
                    selected: selected
                });
                selected = p === "/availability";
                items.push({
                    title: t("availability"),
                    link: "/availability",
                    icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($472ec244e432c4a2$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($990e0e828cb73094$exports))),
                        className: "h-6 w-6",
                        alt: "home"
                    }),
                    selected: selected
                });
            }
        } else {
            selected = p === "/";
            items.push({
                title: t("start"),
                link: "/",
                icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $adbf0a38d5935ae1$export$2e2bcd8739ae039), {
                    style: {
                        color: selected ? "#ffffff" : ""
                    },
                    className: "h-6 w-6"
                }),
                selected: selected
            });
            if (customerCategories.length > 0) {
                selected = p.startsWith("/dev-plan") && !p.startsWith("/dev-plan/survey/result");
                items.push({
                    title: t("long-term-goals"),
                    link: "/dev-plan",
                    icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($dee60dcbfbf05c09$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($cf4f087e7dff53f9$exports))),
                        className: "h-6 w-6",
                        alt: "development plan"
                    }),
                    selected: selected
                });
                if (customerSurveys > 0) {
                    selected = p.startsWith("/assessments") || p.startsWith("/dev-plan/survey/result");
                    items.push({
                        title: t("assessments"),
                        link: "/assessments",
                        icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($bca3803e97b2f8cf$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($a95f951aab95d2f0$exports))),
                            className: "h-6 w-6",
                            alt: "Assessments"
                        }),
                        selected: selected
                    });
                }
            }
            selected = p.startsWith("/profile");
            items.push({
                title: lang === "sv" ? "Profil" : "Profile",
                link: "/profile",
                icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $1a8ddddab7d19754$export$2e2bcd8739ae039), {
                    style: {
                        color: selected ? "#ffffff" : ""
                    },
                    className: "h-6 w-6 " + (selected ? "text-neutral-100" : "")
                }),
                selected: selected
            });
            if (department) {
                selected = p.startsWith("/team");
                items.push({
                    title: "Team",
                    link: "/team",
                    icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($6347599e234591fd$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($432e067a07c879a2$exports))),
                        className: "h-6 w-6",
                        alt: "team"
                    }),
                    selected: selected
                });
            }
            selected = p.startsWith("/videocoach");
            items.push({
                title: t("video-coach-nav-title"),
                link: "/videocoach",
                icon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($0a23199b5f09d5b9$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($04ea003f37bd7a85$exports))),
                    className: "h-6 w-6",
                    alt: "videocoach"
                }),
                badge: unreadChats > 0,
                selected: selected
            });
        }
        return items;
    };
    var combinedMenuItems = calculateMenuItems();
    var getDateName = function(d) {
        var secondsToMidnight = (midnight - new Date(d).getTime()) / 1000;
        if (secondsToMidnight < secondsPerDay) return lang === "sv" ? "Idag" : "Today";
        else if (secondsToMidnight < 2 * secondsPerDay) return lang === "sv" ? "Ig\xe5r" : "Yesterday";
        else if (secondsToMidnight < 8 * secondsPerDay) return lang === "sv" ? "Senaste sju dagarna" : "Last seven days";
        else if (secondsToMidnight < 31 * secondsPerDay) return lang === "sv" ? "Senaste m\xe5naden" : "Last month";
        return lang === "sv" ? "\xc4ldre" : "Older";
    };
    var showThreadName = function(thread) {
        var name;
        if (thread.topic === "New topic") name = lang === "sv" ? "Nytt \xe4mne" : "New topic";
        else name = thread.topic;
        return name;
    };
    var renameThread = function() {
        var data = {
            name: threadName,
            threadId: showRenameThread
        };
        api.post("client/chat_thread_rename", data).then(function(response) {
            if (response.json.status === "ok") {
                var _threads = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = threads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _thread = _step.value;
                        if (_thread.id === showRenameThread) _thread.topic = threadName;
                        _threads.push(_thread);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                setShowRenameThread("");
                setThreads(_threads);
            }
        });
    };
    var deleteThread = function(_threadId) {
        api.get("client/chat_thread_remove/" + _threadId).then(function(response) {
            if (response.json.status === "ok") {
                setShowDeleteThread("");
                var _threads = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = threads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _thread = _step.value;
                        if (_thread.id !== _threadId) _threads.push(_thread);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                setThreads(_threads);
                if (location.pathname === "/ai/" + _threadId) navigate("/ai/0");
            }
        });
    };
    var getThreadName = function(_threadId) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = threads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var thread = _step.value;
                if (thread.id === _threadId) return thread.topic;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return "?";
    };
    var renderModals = function() {
        if (showDeleteThread !== "") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: function() {
                return setShowDeleteThread("");
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return setShowDeleteThread("");
                    },
                    children: lang === "sv" ? "Radera session?" : "Delete session?"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "text-gray-400",
                        children: [
                            lang === "sv" ? "Ta bort " : "This will delete ",
                            getThreadName(showDeleteThread)
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: "outlineWhiteBase",
                                onClick: function() {
                                    return setShowDeleteThread("");
                                },
                                children: t("cancel")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: "dangerBase",
                                className: "mt-2",
                                onClick: function() {
                                    return deleteThread(showDeleteThread);
                                },
                                children: t("delete")
                            })
                        ]
                    })
                })
            ]
        });
        else if (showRenameThread !== "") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: function() {
                return setShowRenameThread("");
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return setShowRenameThread("");
                    },
                    children: lang === "sv" ? "Byt namn p\xe5 session" : "Rename session"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                        type: "text",
                        value: threadName,
                        className: "z-input z-bg-unset",
                        onChange: function(e) {
                            return setThreadName(e.target.value);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: "outlineWhiteBase",
                                onClick: function() {
                                    return setShowRenameThread("");
                                },
                                children: t("cancel")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: "blueBase",
                                className: "mt-2",
                                onClick: function() {
                                    return renameThread();
                                },
                                children: t("save")
                            })
                        ]
                    })
                })
            ]
        });
        return null;
    };
    var renderThreadNames = function() {
        var previousDateName = "";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: threads.map(function(thread, index) {
                var dateName = getDateName(thread.updated);
                var _threadName = showThreadName(thread);
                var showName = "";
                if (dateName !== previousDateName) showName = dateName;
                previousDateName = dateName;
                var cls = "";
                if (thread.selected) cls = " bg-indigo-900";
                var popItems = [
                    {
                        title: lang === "sv" ? "Byt namn" : "Rename",
                        click: function() {
                            setShowRenameThread(thread.id);
                            setThreadName(_threadName);
                        },
                        img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8a47c0bf566c4697$exports))),
                            alt: "edit",
                            className: "h-6 w-6"
                        })
                    },
                    {
                        title: t("delete"),
                        click: function() {
                            return setShowDeleteThread(thread.id);
                        },
                        img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                            alt: "delete",
                            className: "h-6 w-6"
                        })
                    }
                ];
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    children: [
                        showName.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-6 mb-6 z-title4",
                            children: showName
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "group p-2 rounded-md flex items-center cursor-pointer hover:bg-indigo-800 justify-between" + cls,
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "font-medium cursor-pointer w-full",
                                    onClick: function() {
                                        return selectThread(thread.id);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-sm",
                                            title: thread.summary,
                                            children: _threadName
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-xs text-gray-400",
                                            children: thread.name ? thread.name : lang === "sv" ? "Eget \xe4mne" : "Own topic"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: thread.selected ? "" : "invisible group-hover:visible",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                                        items: popItems,
                                        noHover: true
                                    })
                                })
                            ]
                        }, "thread_" + index)
                    ]
                }, "thread_" + index);
            })
        });
    };
    // Render: collapsed overlay sidebar (w-16) and hover expansion -> w-64
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                onMouseEnter: function() {
                    if (window.innerWidth >= $68df94d610fdbee0$var$expandedMinWidth) setExpanded(true);
                },
                onMouseLeave: function() {
                    if (window.innerWidth >= $68df94d610fdbee0$var$expandedMinWidth) setExpanded(false);
                },
                className: "z-navmenu fixed gap-4 left-0 top-[82px] bg-indigo-1000 z-50 text-white flex flex-col",
                style: {
                    width: window.innerWidth > $68df94d610fdbee0$var$expandedMinWidth ? expanded ? "16rem" : "4rem" : "100%",
                    // height: window.innerWidth > expandedMinWidth ? "100%" : undefined,
                    height: "100%",
                    transition: "width 200ms ease",
                    backgroundColor: window.innerWidth < $68df94d610fdbee0$var$expandedMinWidth ? "#19193C" : undefined
                },
                "aria-expanded": expanded,
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    ref: scrollRef,
                    className: "flex flex-col py-3 overflow-y-auto",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex flex-col gap-2 px-3",
                            children: combinedMenuItems.map(function(item, i) {
                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    onClick: function() {
                                        return goTo(item.link);
                                    },
                                    // when collapsed provide title tooltip for accessibility
                                    title: !expanded ? item.title : undefined,
                                    className: "relative flex items-center gap-3 p-2 rounded-md cursor-pointer transition-colors duration-150 " + (item.selected ? "bg-indigo-900 text-white" : "text-gray-400 hover:bg-indigo-800"),
                                    "aria-label": item.title,
                                    role: "button",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "h-6 w-6 flex items-center justify-center shrink-0",
                                            children: item.icon
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "flex-1 overflow-hidden transition-all duration-200 ease-in-out " + (expanded ? "opacity-100 max-w-48" : "opacity-0 max-w-0"),
                                            style: {
                                                whiteSpace: "nowrap"
                                            },
                                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                className: "z-title2 select-none",
                                                children: item.title
                                            })
                                        }),
                                        item.badge && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "ml-auto rounded-full bg-cherry-500 h-2 w-2 transition-opacity duration-200",
                                            style: {
                                                position: "absolute",
                                                top: 10,
                                                left: 8
                                            }
                                        })
                                    ]
                                }, "item_" + i);
                            })
                        }),
                        userType === "client" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "border-t border-indigo-800 mt-4 mx-2 transition-opacity duration-200 " + (expanded ? "opacity-100" : "opacity-60")
                                }),
                                !expanded && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "flex items-center justify-center mt-4 px-3 py-2",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($557ae29a7e65a02f$exports))),
                                        alt: "dots vertical",
                                        className: "h-6 w-6 shrink-0",
                                        style: {
                                            height: "24px",
                                            width: "24px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "px-3 text-sm transition-opacity duration-200  " + (expanded ? "opacity-100" : "opacity-0 pointer-events-none"),
                                    style: {
                                        flex: 1
                                    },
                                    children: expanded ? renderThreadNames() : null
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: "\xa0"
                                })
                            ]
                        })
                    ]
                })
            }),
            renderModals()
        ]
    });
};
var $68df94d610fdbee0$export$2e2bcd8739ae039 = $68df94d610fdbee0$var$NavMenu;






var $b60aba707316503d$var$Navbar = function(param) {
    var _param_showMenu = param.showMenu, showMenu = _param_showMenu === void 0 ? true : _param_showMenu, i18n = param.i18n, badges = param.badges, loggedIn = param.loggedIn, debug = param.debug;
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showNavMini = _useState[0], setShowNavMini = _useState[1];
    var _useAtom = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$f6340943ad252ff2)), 1), picture = _useAtom[0];
    var _useAtom1 = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$3e88fe72f2048427)), 2), lang = _useAtom1[0], setLang = _useAtom1[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showSidebar = _useState1[0], setShowSidebar = _useState1[1];
    console.log('showMenu ' + showMenu + ' loggedIn ' + loggedIn);
    (0, $5s1kH.useEffect)(function() {
        if (i18n.language !== lang) {
            console.log("changing language to " + lang + " from " + i18n.language);
            localStorage.setItem("language", lang);
            i18n.changeLanguage(lang);
        } else console.log("keeping " + lang + " === " + i18n.language);
    }, [
        lang
    ]);
    var changeLanguage = function() {
        var newLang = lang === "en" ? "sv" : "en";
        api.get((0, $632c75b97b900307$export$1630b5343357e8b5).USER_TYPE + "/change_language/" + newLang).then(function() {
            setLang(newLang);
            localStorage.setItem("language", newLang);
            i18n.changeLanguage(newLang);
        });
    };
    var handleMenuItemClick = function() {
        return setShowSidebar(false);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("header", {
        className: "w-full bg-indigo-1000 text-sm relative",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex justify-between items-center flex-nowrap w-full p-4 desktop:p-6",
                children: [
                    loggedIn ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        onClick: function() {
                            return navigate("/");
                        },
                        className: "cursor-pointer h-6 w-6",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c03548fc9c3a7450$exports))),
                        alt: "logo"
                    }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("a", {
                        className: "flex flex-col justify-center",
                        href: "https://www.zebrain.se",
                        "aria-label": "Brand",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6027242fe1d8334d$exports))),
                            alt: "logo"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex",
                        children: [
                            loggedIn && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "h-8 w-8 bg-white rounded-full flex items-center justify-center cursor-pointer relative",
                                onClick: function() {
                                    return setShowNavMini(!showNavMini);
                                },
                                children: [
                                    picture ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: picture,
                                        alt: "menus",
                                        className: "h-8 w-8 rounded-full"
                                    }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bf234ba9a155a985$exports))),
                                        alt: "menus",
                                        className: "h-5 w-5"
                                    }),
                                    showNavMini && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "fixed z-40",
                                                style: {
                                                    top: 0,
                                                    left: 0,
                                                    width: "100vw",
                                                    height: "100vh"
                                                },
                                                onClick: function() {
                                                    return setShowNavMini(false);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "absolute z-50",
                                                style: {
                                                    right: 0,
                                                    top: 32
                                                },
                                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c7f12a560df7b55e$export$2e2bcd8739ae039), {
                                                    changeLanguage: changeLanguage,
                                                    debug: debug
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "ml-4 relative " + (showMenu ? "block" : "hidden"),
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("button", {
                                        type: "button",
                                        className: "text-gray-500 hover:text-gray-600 cursor-pointer",
                                        onClick: function() {
                                            return setShowSidebar(true);
                                        },
                                        "aria-label": "Toggle navigation",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: "Toggle Navigation"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b0730787261d6ae7$exports))),
                                                alt: "menu"
                                            })
                                        ]
                                    }),
                                    badges && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "h-2 w-2 rounded-full bg-cherry-500 absolute",
                                        style: {
                                            top: "1px",
                                            right: "2px"
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "\n          fixed inset-0 z-59\n          bg-indigo-1000 bg-opacity-80\n          transition-opacity duration-300\n          ".concat(showSidebar ? "opacity-80 pointer-events-auto" : "opacity-0 pointer-events-none", "\n        "),
                onClick: function() {
                    return setShowSidebar(false);
                },
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                id: "docs-sidebar",
                className: "\n          fixed top-0 right-0 bottom-0\n          w-96 max-desktop:w-full\n          z-60\n          bg-indigo-900\n          flex flex-col p-4 desktop:p-6\n          transform transition-transform duration-300 ease-in-out\n          ".concat(showSidebar ? "translate-x-0" : "translate-x-full", "\n          shadow-lg\n          overflow-y-auto\n          scrollbar-thin scrollbar-thumb-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-200\n          dark:[&::-webkit-scrollbar-track]:bg-indigo-800 dark:[&::-webkit-scrollbar-thumb]:bg-gray-500\n        "),
                role: "dialog",
                "aria-modal": "true",
                style: {
                    pointerEvents: showSidebar ? "auto" : "none"
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex justify-between items-center mb-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                onClick: function() {
                                    return navigate("/");
                                },
                                className: "cursor-pointer h-6 w-6",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($c03548fc9c3a7450$exports))),
                                alt: "logo"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("button", {
                                type: "button",
                                className: "text-white hover:text-white cursor-pointer",
                                onClick: function() {
                                    return setShowSidebar(false);
                                },
                                "aria-label": "Close navigation",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                        className: "sr-only",
                                        children: "Close Navigation"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "h-8 w-8",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M6 18L18 6M6 6l12 12"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("nav", {
                        className: "hs-accordion-group w-full flex flex-col justify-between grow",
                        "data-hs-accordion-always-open": "true",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $68df94d610fdbee0$export$2e2bcd8739ae039), {
                            menuClick: handleMenuItemClick,
                            showSidebar: showSidebar
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-indigo-800"
            })
        ]
    });
};
var $b60aba707316503d$export$2e2bcd8739ae039 = $b60aba707316503d$var$Navbar;


var $2d2052a650287066$export$2e2bcd8739ae039 = (0, $b60aba707316503d$export$2e2bcd8739ae039);



parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");


var $8799a989dfc10060$var$Breadcrumbs = function(param) {
    var breadcrumbConfig = param.breadcrumbConfig;
    var t = (0, $341d5702266247e0$export$9fc83ad70ead8663)().t;
    var location = (0, $bHX26.useLocation)();
    var params = (0, $bHX26.useParams)();
    var pathname = location.pathname;
    if (pathname.startsWith("/feedback/questionnaire/")) return null;
    var breadcrumbs = breadcrumbConfig.filter(function(param) {
        var path = param.path;
        return (0, $bHX26.matchPath)({
            path: path,
            end: false
        }, pathname);
    }).map(function(param) {
        var path = param.path, breadcrumbKey = param.breadcrumbKey;
        return {
            path: (0, $bHX26.generatePath)(path, params),
            breadcrumb: t(breadcrumbKey)
        };
    });
    if (breadcrumbs.length < 3) return null;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("nav", {
        "aria-label": "breadcrumb",
        className: "z-breadcrumbs",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "flex flex-col justify-start align-middle w-full mx-auto desktop:w-151",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("ol", {
                className: "flex flex-wrap items-center text-gray-400 text-xs",
                children: breadcrumbs.map(function(crumb, index) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("li", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bHX26.Link), {
                                to: crumb.path,
                                className: "hover:text-primary-500",
                                children: crumb.breadcrumb
                            }),
                            index < breadcrumbs.length - 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($46be5d84f14eb1ba$exports))),
                                alt: "Chevron Right",
                                className: "w-4 h-4 mx-1.5"
                            })
                        ]
                    }, index);
                })
            })
        })
    });
};
var $8799a989dfc10060$export$2e2bcd8739ae039 = $8799a989dfc10060$var$Breadcrumbs;


var $85aba988ba8043ef$export$2e2bcd8739ae039 = (0, $8799a989dfc10060$export$2e2bcd8739ae039);



var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $hwO3w = parcelRequire("hwO3w");

var $03bAP = parcelRequire("03bAP");
var $63491170aaadd711$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



var $XnYkK = parcelRequire("XnYkK");
var $b57ae22d2a5daa67$export$31499a9cd224b78c = "10.70.0";


var $6001140c9a325157$export$f1a6cdb1459e81d1 = globalThis;


function $8a2f538a13cfc001$export$19eade501500c6c1() {
    $8a2f538a13cfc001$export$c8bfa33e4e8ae492((0, $6001140c9a325157$export$f1a6cdb1459e81d1));
    return 0, $6001140c9a325157$export$f1a6cdb1459e81d1;
}
function $8a2f538a13cfc001$export$c8bfa33e4e8ae492(carrier) {
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $b57ae22d2a5daa67$export$31499a9cd224b78c);
    return __SENTRY__[0, $b57ae22d2a5daa67$export$31499a9cd224b78c] = __SENTRY__[0, $b57ae22d2a5daa67$export$31499a9cd224b78c] || {};
}
function $8a2f538a13cfc001$export$7e223ec222791509(name, creator) {
    var obj = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $6001140c9a325157$export$f1a6cdb1459e81d1);
    var __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    var carrier = __SENTRY__[0, $b57ae22d2a5daa67$export$31499a9cd224b78c] = __SENTRY__[0, $b57ae22d2a5daa67$export$31499a9cd224b78c] || {};
    return carrier[name] || (carrier[name] = creator());
}




var $739716ea0436a6d0$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
var $739716ea0436a6d0$var$PREFIX = "Sentry Logger ";
var $739716ea0436a6d0$export$77c4ce905194557b = {};
function $739716ea0436a6d0$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $6001140c9a325157$export$f1a6cdb1459e81d1))) return callback();
    var console = (0, $6001140c9a325157$export$f1a6cdb1459e81d1).console;
    var wrappedFuncs = {};
    var wrappedLevels = Object.keys($739716ea0436a6d0$export$77c4ce905194557b);
    wrappedLevels.forEach(function(level) {
        var originalConsoleMethod = $739716ea0436a6d0$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach(function(level) {
            console[level] = wrappedFuncs[level];
        });
    }
}
function $739716ea0436a6d0$var$enable() {
    $739716ea0436a6d0$var$_getLoggerSettings().enabled = true;
}
function $739716ea0436a6d0$var$disable() {
    $739716ea0436a6d0$var$_getLoggerSettings().enabled = false;
}
function $739716ea0436a6d0$var$isEnabled() {
    return $739716ea0436a6d0$var$_getLoggerSettings().enabled;
}
function $739716ea0436a6d0$var$log() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $739716ea0436a6d0$var$_maybeLog.apply(void 0, [
        "log"
    ].concat((0, $XnYkK._)(args)));
}
function $739716ea0436a6d0$var$warn() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $739716ea0436a6d0$var$_maybeLog.apply(void 0, [
        "warn"
    ].concat((0, $XnYkK._)(args)));
}
function $739716ea0436a6d0$var$error() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    $739716ea0436a6d0$var$_maybeLog.apply(void 0, [
        "error"
    ].concat((0, $XnYkK._)(args)));
}
function $739716ea0436a6d0$var$_maybeLog(level) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if (!(0, $63491170aaadd711$export$16a28057038b10ef)) return;
    if ($739716ea0436a6d0$var$isEnabled()) $739716ea0436a6d0$export$cda52e2a8927a2ca(function() {
        var _GLOBAL_OBJ_console;
        (_GLOBAL_OBJ_console = (0, $6001140c9a325157$export$f1a6cdb1459e81d1).console)[level].apply(_GLOBAL_OBJ_console, [
            "".concat($739716ea0436a6d0$var$PREFIX, "[").concat(level, "]:")
        ].concat((0, $XnYkK._)(args)));
    });
}
function $739716ea0436a6d0$var$_getLoggerSettings() {
    if (!(0, $63491170aaadd711$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $8a2f538a13cfc001$export$7e223ec222791509)("loggerSettings", function() {
        return {
            enabled: false
        };
    });
}
var $739716ea0436a6d0$export$1c9f709888824e05 = {
    /** Enable logging. */ enable: $739716ea0436a6d0$var$enable,
    /** Disable logging. */ disable: $739716ea0436a6d0$var$disable,
    /** Check if logging is enabled. */ isEnabled: $739716ea0436a6d0$var$isEnabled,
    /** Log a message. */ log: $739716ea0436a6d0$var$log,
    /** Log a warning. */ warn: $739716ea0436a6d0$var$warn,
    /** Log an error. */ error: $739716ea0436a6d0$var$error
};



var $03bAP = parcelRequire("03bAP");
var $6ea82c15e37d9720$var$objectToString = Object.prototype.toString;
function $6ea82c15e37d9720$export$e6127cc7fe7395c3(wat) {
    switch($6ea82c15e37d9720$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $6ea82c15e37d9720$export$49034edbe6b62415(wat, Error);
    }
}
function $6ea82c15e37d9720$var$isBuiltin(wat, className) {
    return $6ea82c15e37d9720$var$objectToString.call(wat) === "[object ".concat(className, "]");
}
function $6ea82c15e37d9720$export$9f9636d330b71954(wat) {
    return $6ea82c15e37d9720$var$isBuiltin(wat, "ErrorEvent");
}
function $6ea82c15e37d9720$export$ef9e2056653f0c8e(wat) {
    return $6ea82c15e37d9720$var$isBuiltin(wat, "DOMError");
}
function $6ea82c15e37d9720$export$12e869b2a583f783(wat) {
    return $6ea82c15e37d9720$var$isBuiltin(wat, "DOMException");
}
function $6ea82c15e37d9720$export$844ec244b1367d54(wat) {
    return $6ea82c15e37d9720$var$isBuiltin(wat, "String");
}
function $6ea82c15e37d9720$export$dbcbffa59149b824(wat) {
    return (typeof wat === "undefined" ? "undefined" : (0, $03bAP._)(wat)) === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $6ea82c15e37d9720$export$c3825b437cbdea5c(wat) {
    return wat === null || $6ea82c15e37d9720$export$dbcbffa59149b824(wat) || (typeof wat === "undefined" ? "undefined" : (0, $03bAP._)(wat)) !== "object" && typeof wat !== "function";
}
function $6ea82c15e37d9720$export$53b83ca8eaab0383(wat) {
    return $6ea82c15e37d9720$var$isBuiltin(wat, "Object");
}
function $6ea82c15e37d9720$export$c10d0b04eaa80a43(wat) {
    return (typeof wat === "undefined" ? "undefined" : (0, $03bAP._)(wat)) === "object" && wat !== null;
}
function $6ea82c15e37d9720$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $6ea82c15e37d9720$export$49034edbe6b62415(wat, Event);
}
function $6ea82c15e37d9720$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $6ea82c15e37d9720$export$49034edbe6b62415(wat, Element);
}
function $6ea82c15e37d9720$export$49841c62b9eff15(wat) {
    return $6ea82c15e37d9720$var$isBuiltin(wat, "RegExp");
}
function $6ea82c15e37d9720$export$f5b060c2914b97c8(wat) {
    return Boolean((wat === null || wat === void 0 ? void 0 : wat.then) && typeof wat.then === "function");
}
function $6ea82c15e37d9720$export$bc2894c7158efbac(wat) {
    return $6ea82c15e37d9720$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $6ea82c15e37d9720$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (e) {
        return false;
    }
}
function $6ea82c15e37d9720$export$7916fad0ebc23f48(wat) {
    return !!((typeof wat === "undefined" ? "undefined" : (0, $03bAP._)(wat)) === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $6ea82c15e37d9720$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $6ea82c15e37d9720$export$49034edbe6b62415(request, Request);
}


function $27958f6402fc5d96$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    if (typeof original !== "function") return;
    var wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $27958f6402fc5d96$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log('Failed to replace method "'.concat(name, '" in object'), source);
    }
}
function $27958f6402fc5d96$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (e) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log('Failed to add non-enumerable property "'.concat(String(name), '" to object'), obj);
    }
}
function $27958f6402fc5d96$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        var proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $27958f6402fc5d96$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (e) {}
}
function $27958f6402fc5d96$export$e00416b3cd122575(obj, field, wrapped) {
    var enumerable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var original = obj[field];
    if (typeof original !== "function") throw new Error("Cannot wrap method: ".concat(field, " is not a function"));
    if ($27958f6402fc5d96$export$e6cc1e135e2092e5(original)) throw new Error("Attempting to wrap method ".concat(field, " multiple times"));
    $27958f6402fc5d96$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $27958f6402fc5d96$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $27958f6402fc5d96$export$62ff257738bf57f5(value) {
    if ((0, $6ea82c15e37d9720$export$e6127cc7fe7395c3)(value)) return (0, $hwO3w._)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $27958f6402fc5d96$var$getOwnProperties(value));
    if ((0, $6ea82c15e37d9720$export$9671ea99bd126ace)(value)) {
        var type = value.type, target = value.target, currentTarget = value.currentTarget, detail = value.detail;
        return (0, $hwO3w._)({
            type: type,
            target: target,
            currentTarget: currentTarget
        }, detail ? {
            detail: detail
        } : {}, $27958f6402fc5d96$var$getOwnProperties(value));
    }
    return value;
}
function $27958f6402fc5d96$var$getOwnProperties(obj) {
    if ((0, $6ea82c15e37d9720$export$c10d0b04eaa80a43)(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $27958f6402fc5d96$export$b0244d5063c0b61b(exception) {
    var keys = Object.keys($27958f6402fc5d96$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $27958f6402fc5d96$export$d25f2688db1bb433(inputValue) {
    var memoizationMap = /* @__PURE__ */ new Map();
    return $27958f6402fc5d96$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $27958f6402fc5d96$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || (typeof inputValue === "undefined" ? "undefined" : (0, $03bAP._)(inputValue)) !== "object") return inputValue;
    var memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        var returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach(function(value) {
            returnValue.push($27958f6402fc5d96$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($27958f6402fc5d96$var$isPojo(inputValue)) {
        var returnValue1 = {};
        memoizationMap.set(inputValue, returnValue1);
        var keys = Object.keys(inputValue);
        keys.forEach(function(key) {
            var val = inputValue[key];
            if (val !== void 0) returnValue1[key] = $27958f6402fc5d96$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue1;
    }
    return inputValue;
}
function $27958f6402fc5d96$var$isPojo(input) {
    var constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $27958f6402fc5d96$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case (typeof wat === "undefined" ? "undefined" : (0, $03bAP._)(wat)) === "symbol" || (typeof wat === "undefined" ? "undefined" : (0, $03bAP._)(wat)) === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $6ea82c15e37d9720$export$c3825b437cbdea5c)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}


var $dd2c5f85fcbd9c64$var$RESOLVED_RUNNER;
function $dd2c5f85fcbd9c64$export$ff239213cb80e2da(cb) {
    if ($dd2c5f85fcbd9c64$var$RESOLVED_RUNNER !== void 0) return $dd2c5f85fcbd9c64$var$RESOLVED_RUNNER ? $dd2c5f85fcbd9c64$var$RESOLVED_RUNNER(cb) : cb();
    var sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    var globalWithSymbol = (0, $6001140c9a325157$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $dd2c5f85fcbd9c64$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $dd2c5f85fcbd9c64$var$RESOLVED_RUNNER(cb);
    }
    $dd2c5f85fcbd9c64$var$RESOLVED_RUNNER = null;
    return cb();
}
function $dd2c5f85fcbd9c64$export$9869d72de32a3917() {
    return $dd2c5f85fcbd9c64$export$ff239213cb80e2da(function() {
        return Math.random();
    });
}
function $dd2c5f85fcbd9c64$export$65b1bada40c91b34() {
    return $dd2c5f85fcbd9c64$export$ff239213cb80e2da(function() {
        return Date.now();
    });
}



var $7b1d57c4c7d6952d$var$ONE_SECOND_IN_MS = 1e3;
function $7b1d57c4c7d6952d$export$7740643b9eeaf0c4() {
    return (0, $dd2c5f85fcbd9c64$export$65b1bada40c91b34)() / $7b1d57c4c7d6952d$var$ONE_SECOND_IN_MS;
}
function $7b1d57c4c7d6952d$var$createUnixTimestampInSecondsFunc() {
    var performance = (0, $6001140c9a325157$export$f1a6cdb1459e81d1).performance;
    if (!(performance === null || performance === void 0 ? void 0 : performance.now) || !performance.timeOrigin) return $7b1d57c4c7d6952d$export$7740643b9eeaf0c4;
    var timeOrigin = performance.timeOrigin;
    return function() {
        return (timeOrigin + (0, $dd2c5f85fcbd9c64$export$ff239213cb80e2da)(function() {
            return performance.now();
        })) / $7b1d57c4c7d6952d$var$ONE_SECOND_IN_MS;
    };
}
var $7b1d57c4c7d6952d$var$_cachedTimestampInSeconds;
function $7b1d57c4c7d6952d$export$ee52dced521e3e18() {
    var func = $7b1d57c4c7d6952d$var$_cachedTimestampInSeconds !== null && $7b1d57c4c7d6952d$var$_cachedTimestampInSeconds !== void 0 ? $7b1d57c4c7d6952d$var$_cachedTimestampInSeconds : $7b1d57c4c7d6952d$var$_cachedTimestampInSeconds = $7b1d57c4c7d6952d$var$createUnixTimestampInSecondsFunc();
    return func();
}
var $7b1d57c4c7d6952d$var$cachedTimeOrigin = null;
function $7b1d57c4c7d6952d$var$getBrowserTimeOrigin() {
    var _performance_timing;
    var performance = (0, $6001140c9a325157$export$f1a6cdb1459e81d1).performance;
    if (!(performance === null || performance === void 0 ? void 0 : performance.now)) return void 0;
    var threshold = 3e5;
    var performanceNow = (0, $dd2c5f85fcbd9c64$export$ff239213cb80e2da)(function() {
        return performance.now();
    });
    var dateNow = (0, $dd2c5f85fcbd9c64$export$65b1bada40c91b34)();
    var timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        var timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    var navigationStart = (_performance_timing = performance.timing) === null || _performance_timing === void 0 ? void 0 : _performance_timing.navigationStart;
    if (typeof navigationStart === "number") {
        var navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $7b1d57c4c7d6952d$export$baf075a948ffc0bf() {
    if ($7b1d57c4c7d6952d$var$cachedTimeOrigin === null) $7b1d57c4c7d6952d$var$cachedTimeOrigin = $7b1d57c4c7d6952d$var$getBrowserTimeOrigin();
    return $7b1d57c4c7d6952d$var$cachedTimeOrigin;
}


var $hwO3w = parcelRequire("hwO3w");




var $6iP9u = parcelRequire("6iP9u");

var $03bAP = parcelRequire("03bAP");

var $db6fc97494d20182$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
var $db6fc97494d20182$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $db6fc97494d20182$export$280812de8e91ea53(obj) {
    (0, $27958f6402fc5d96$export$e73679ffaf56810e)(obj, $db6fc97494d20182$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $db6fc97494d20182$export$610d1422c4bdc4c1(obj, depth) {
    (0, $27958f6402fc5d96$export$e73679ffaf56810e)(obj, $db6fc97494d20182$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $db6fc97494d20182$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$db6fc97494d20182$var$SENTRY_SKIP_NORMALIZATION]);
}
function $db6fc97494d20182$export$fe95a19841c4b155(value) {
    var v = value[$db6fc97494d20182$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}




var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $XnYkK = parcelRequire("XnYkK");
var $6fde3090981c9aa7$var$STACKTRACE_FRAME_LIMIT = 50;
var $6fde3090981c9aa7$export$27c7e15d453fc0ac = "?";
var $6fde3090981c9aa7$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
var $6fde3090981c9aa7$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $6fde3090981c9aa7$export$a5739666fb2d03d4() {
    for(var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++){
        parsers[_key] = arguments[_key];
    }
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack) {
        var skipFirstLines = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, framesToPop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var frames = [];
        var lines = stack.split("\n");
        for(var i = skipFirstLines; i < lines.length; i++){
            var line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            var cleanedLine = $6fde3090981c9aa7$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($6fde3090981c9aa7$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = sortedParsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var parser = _step.value;
                    var frame = parser(cleanedLine);
                    if (frame) {
                        frames.push(frame);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (frames.length >= $6fde3090981c9aa7$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $6fde3090981c9aa7$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $6fde3090981c9aa7$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $6fde3090981c9aa7$export$a5739666fb2d03d4.apply(void 0, (0, $XnYkK._)(stackParser));
    return stackParser;
}
function $6fde3090981c9aa7$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = Array.from(stack);
    if (/sentryWrapped/.test($6fde3090981c9aa7$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($6fde3090981c9aa7$var$STRIP_FRAME_REGEXP.test($6fde3090981c9aa7$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($6fde3090981c9aa7$var$STRIP_FRAME_REGEXP.test($6fde3090981c9aa7$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $6fde3090981c9aa7$var$STACKTRACE_FRAME_LIMIT).map(function(frame) {
        return (0, $lf4fc._)((0, $hwO3w._)({}, frame), {
            filename: frame.filename || $6fde3090981c9aa7$var$getLastStackFrame(localStack).filename,
            function: frame.function || $6fde3090981c9aa7$export$27c7e15d453fc0ac
        });
    });
}
function $6fde3090981c9aa7$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
var $6fde3090981c9aa7$var$defaultFunctionName = "<anonymous>";
function $6fde3090981c9aa7$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $6fde3090981c9aa7$var$defaultFunctionName;
        return fn.name || $6fde3090981c9aa7$var$defaultFunctionName;
    } catch (e) {
        return $6fde3090981c9aa7$var$defaultFunctionName;
    }
}
function $6fde3090981c9aa7$export$91d8ca51bd9f6a47(event) {
    var exception = event.exception;
    if (exception) {
        var frames = [];
        try {
            exception.values.forEach(function(value) {
                var _frames;
                if (value.stacktrace.frames) (_frames = frames).push.apply(_frames, (0, $XnYkK._)(value.stacktrace.frames));
            });
            return frames;
        } catch (e) {
            return void 0;
        }
    }
    return void 0;
}
function $6fde3090981c9aa7$export$60c0d6c8e038267a(path) {
    var filename = (path === null || path === void 0 ? void 0 : path.startsWith("file://")) ? path.slice(7) : path;
    if (filename === null || filename === void 0 ? void 0 : filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


var $74542fb861c25274$var$stringifier;
function $74542fb861c25274$export$575c40989754ba4d(newStringifier) {
    $74542fb861c25274$var$stringifier = newStringifier;
}
function $74542fb861c25274$export$a3295358bff77e(input) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, maxProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
    try {
        return $74542fb861c25274$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (".concat(err, ")")
        };
    }
}
function $74542fb861c25274$export$23fbbb20bed71033(object) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, maxSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 102400;
    var normalized = $74542fb861c25274$export$a3295358bff77e(object, depth);
    if ($74542fb861c25274$var$jsonSize(normalized) > maxSize) return $74542fb861c25274$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $74542fb861c25274$var$visit(key, value) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, maxProperties = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity, memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $74542fb861c25274$var$memoBuilder();
    var _memo = (0, $6iP9u._)(memo, 2), memoize = _memo[0], unmemoize = _memo[1];
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) || typeof value === "number" && Number.isFinite(value)) return value;
    var stringified = $74542fb861c25274$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $db6fc97494d20182$export$c8d26b7b28f926c7)(value)) return value;
    var overrideDepth = (0, $db6fc97494d20182$export$fe95a19841c4b155)(value);
    var remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        var jsonValue = valueWithToJSON.toJSON();
        return $74542fb861c25274$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (e) {}
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    var visitable = (0, $27958f6402fc5d96$export$62ff257738bf57f5)(value);
    for(var visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $74542fb861c25274$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $74542fb861c25274$export$a110e5bc79f44a84(key, value) {
    try {
        if ($74542fb861c25274$var$stringifier) {
            var stringified = $74542fb861c25274$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return "[".concat(value, "]");
        if (typeof value === "function") return "[Function: ".concat((0, $6fde3090981c9aa7$export$aad197c7121a6651)(value), "]");
        if ((typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) === "symbol") return "[".concat(String(value), "]");
        if ((typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) === "bigint") return "[BigInt: ".concat(String(value), "]");
        var objName = $74542fb861c25274$var$getConstructorName(value);
        return "[object ".concat(objName, "]");
    } catch (err) {
        return "**non-serializable** (".concat(err, ")");
    }
}
function $74542fb861c25274$var$getConstructorName(value) {
    var prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === void 0 ? void 0 : prototype.constructor) ? prototype.constructor.name : "null prototype";
}
function $74542fb861c25274$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $74542fb861c25274$var$jsonSize(value) {
    return $74542fb861c25274$var$utf8Length(JSON.stringify(value));
}
function $74542fb861c25274$export$472b29734be05be3(url, basePath) {
    var escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    var newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (e) {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp("(file://)?/*".concat(escapedBase, "/*"), "ig"), "app:///");
}
function $74542fb861c25274$var$memoBuilder() {
    var inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}


function $45aea333cf5bef5d$export$fac44ee5b035f737(value) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "[unserializable]";
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch (e) {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $45aea333cf5bef5d$export$6a506b36fdea397d(str) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : "".concat(str.slice(0, max), "...");
}
function $45aea333cf5bef5d$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} ".concat(newLine);
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $45aea333cf5bef5d$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    var output = [];
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        if ((0, $6ea82c15e37d9720$export$c3825b437cbdea5c)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? "".concat(value.name, ": ").concat(value.message) : value.name);
        else output.push((0, $74542fb861c25274$export$a110e5bc79f44a84)(void 0, value));
    }
    return output.join(delimiter);
}
function $45aea333cf5bef5d$export$cdded5b28a5f8c6d(value, pattern) {
    var requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0, $6ea82c15e37d9720$export$844ec244b1367d54)(value)) return false;
    if ((0, $6ea82c15e37d9720$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $6ea82c15e37d9720$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $45aea333cf5bef5d$export$a7a5ec66062ea5d(testString) {
    var patterns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = patterns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var pattern = _step.value;
            if ($45aea333cf5bef5d$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}



function $30748c2972c04cd5$var$getCrypto() {
    var gbl = (0, $6001140c9a325157$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
var $30748c2972c04cd5$var$emptyUuid;
function $30748c2972c04cd5$var$getRandomByte() {
    return (0, $dd2c5f85fcbd9c64$export$9869d72de32a3917)() * 16;
}
function $30748c2972c04cd5$export$19f53698e68b2496() {
    var crypto = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $30748c2972c04cd5$var$getCrypto();
    try {
        if (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) return (0, $dd2c5f85fcbd9c64$export$ff239213cb80e2da)(function() {
            return crypto.randomUUID();
        }).replace(/-/g, "");
    } catch (e) {}
    if (!$30748c2972c04cd5$var$emptyUuid) $30748c2972c04cd5$var$emptyUuid = "10000000100040008000100000000000";
    return $30748c2972c04cd5$var$emptyUuid.replace(/[018]/g, function(c) {
        return(// eslint-disable-next-line no-bitwise
        (c ^ ($30748c2972c04cd5$var$getRandomByte() & 15) >> c / 4).toString(16));
    });
}
function $30748c2972c04cd5$var$getFirstException(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}
function $30748c2972c04cd5$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $30748c2972c04cd5$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return "".concat(firstException.type, ": ").concat(firstException.value);
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $30748c2972c04cd5$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $30748c2972c04cd5$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $30748c2972c04cd5$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: "generic",
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $hwO3w._)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && "data" in newMechanism) {
        var mergedData = (0, $hwO3w._)({}, currentMechanism === null || currentMechanism === void 0 ? void 0 : currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
var $30748c2972c04cd5$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $30748c2972c04cd5$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $30748c2972c04cd5$export$d364f2020ab30578(input) {
    var match = input.match($30748c2972c04cd5$var$SEMVER_REGEXP) || [];
    var major = $30748c2972c04cd5$var$_parseInt(match[1]);
    var minor = $30748c2972c04cd5$var$_parseInt(match[2]);
    var patch = $30748c2972c04cd5$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $30748c2972c04cd5$export$ec2291bfc64632f0(lines, frame) {
    var linesOfContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    if (frame.lineno === void 0) return;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $45aea333cf5bef5d$export$4215662d762d6f9d)(line, 0);
    });
    var lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $45aea333cf5bef5d$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $45aea333cf5bef5d$export$4215662d762d6f9d)(line, 0);
    });
}
function $30748c2972c04cd5$export$6de4ffac6a2f1098(exception) {
    if ($30748c2972c04cd5$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $27958f6402fc5d96$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (e) {}
    return false;
}
function $30748c2972c04cd5$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {}
}


function $1525c77c2ae4a4b0$export$dc6d7ea554bcce10() {
    return (0, $30748c2972c04cd5$export$19f53698e68b2496)();
}
function $1525c77c2ae4a4b0$export$295213bc4d0c54ad() {
    return (0, $30748c2972c04cd5$export$19f53698e68b2496)().substring(16);
}


var $6iP9u = parcelRequire("6iP9u");


var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");


var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $XnYkK = parcelRequire("XnYkK");



function $e5a8a7b6f15619c1$export$14a186326edbb264(context) {
    var startingTime = (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
    var session = {
        sid: (0, $30748c2972c04cd5$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: function() {
            return $e5a8a7b6f15619c1$var$sessionToJSON(session);
        }
    };
    if (context) $e5a8a7b6f15619c1$export$531818e825e774db(session, context);
    return session;
}
function $e5a8a7b6f15619c1$export$531818e825e774db(session) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : (0, $30748c2972c04cd5$export$19f53698e68b2496)();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = "".concat(context.did);
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        var duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $e5a8a7b6f15619c1$export$56521d9ba90f62ee(session, status) {
    var context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $e5a8a7b6f15619c1$export$531818e825e774db(session, context);
}
function $e5a8a7b6f15619c1$var$sessionToJSON(session) {
    return {
        sid: "".concat(session.sid),
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? "".concat(session.did) : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}





var $hwO3w = parcelRequire("hwO3w");

var $03bAP = parcelRequire("03bAP");
function $e561f8063ae23b8a$export$4950aa0f605343fb(initialObj, mergeObj) {
    var levels = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    if (!mergeObj || (typeof mergeObj === "undefined" ? "undefined" : (0, $03bAP._)(mergeObj)) !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    var output = (0, $hwO3w._)({}, initialObj);
    for(var key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $e561f8063ae23b8a$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}







var $03bAP = parcelRequire("03bAP");

function $261b84d5e2b85281$export$f0b98edec95fcb33(value) {
    try {
        var WeakRefImpl = (0, $6001140c9a325157$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch (e) {}
    return value;
}
function $261b84d5e2b85281$export$a0592ad8c3586cf(ref) {
    if (!ref) return void 0;
    if ((typeof ref === "undefined" ? "undefined" : (0, $03bAP._)(ref)) === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch (e) {
        return void 0;
    }
    return ref;
}


var $6102d52d892cc90c$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $6102d52d892cc90c$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $27958f6402fc5d96$export$e73679ffaf56810e)(scope, $6102d52d892cc90c$var$SCOPE_SPAN_FIELD, (0, $261b84d5e2b85281$export$f0b98edec95fcb33)(span));
    else delete scope[$6102d52d892cc90c$var$SCOPE_SPAN_FIELD];
}
function $6102d52d892cc90c$export$91f063ebb8eff307(scope) {
    return (0, $261b84d5e2b85281$export$a0592ad8c3586cf)(scope[$6102d52d892cc90c$var$SCOPE_SPAN_FIELD]);
}




var $846be57626444680$var$DEFAULT_MAX_BREADCRUMBS = 100;
var $846be57626444680$export$775b6bb06e53a214 = /*#__PURE__*/ function() {
    "use strict";
    function Scope() {
        (0, $5Epmf._)(this, Scope);
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $1525c77c2ae4a4b0$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $dd2c5f85fcbd9c64$export$9869d72de32a3917)()
        };
    }
    (0, $9MqXK._)(Scope, [
        {
            /**
   * Clone all data from this scope into a new scope.
   */ key: "clone",
            value: function clone() {
                var newScope = new Scope();
                newScope._breadcrumbs = (0, $XnYkK._)(this._breadcrumbs);
                newScope._tags = (0, $hwO3w._)({}, this._tags);
                newScope._attributes = (0, $hwO3w._)({}, this._attributes);
                newScope._extra = (0, $hwO3w._)({}, this._extra);
                newScope._contexts = (0, $hwO3w._)({}, this._contexts);
                if (this._contexts.flags) newScope._contexts.flags = {
                    values: (0, $XnYkK._)(this._contexts.flags.values)
                };
                newScope._user = this._user;
                newScope._level = this._level;
                newScope._session = this._session;
                newScope._transactionName = this._transactionName;
                newScope._fingerprint = this._fingerprint;
                newScope._eventProcessors = (0, $XnYkK._)(this._eventProcessors);
                newScope._attachments = (0, $XnYkK._)(this._attachments);
                newScope._sdkProcessingMetadata = (0, $hwO3w._)({}, this._sdkProcessingMetadata);
                newScope._propagationContext = (0, $hwO3w._)({}, this._propagationContext);
                newScope._client = this._client;
                newScope._lastEventId = this._lastEventId;
                newScope._conversationId = this._conversationId;
                (0, $6102d52d892cc90c$export$3f25fa50c18e20ca)(newScope, (0, $6102d52d892cc90c$export$91f063ebb8eff307)(this));
                return newScope;
            }
        },
        {
            /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ key: "setClient",
            value: function setClient(client) {
                this._client = client;
            }
        },
        {
            /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ key: "setLastEventId",
            value: function setLastEventId(lastEventId) {
                this._lastEventId = lastEventId;
            }
        },
        {
            /**
   * Get the client assigned to this scope.
   */ key: "getClient",
            value: function getClient() {
                return this._client;
            }
        },
        {
            /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ key: "lastEventId",
            value: function lastEventId() {
                return this._lastEventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addScopeListener",
            value: function addScopeListener(callback) {
                this._scopeListeners.push(callback);
            }
        },
        {
            /**
   * Add an event processor that will be called before an event is sent.
   */ key: "addEventProcessor",
            value: function addEventProcessor(callback) {
                this._eventProcessors.push(callback);
                return this;
            }
        },
        {
            /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ key: "setUser",
            value: function setUser(user) {
                this._user = user || {
                    email: void 0,
                    id: void 0,
                    ip_address: void 0,
                    username: void 0
                };
                if (this._session) (0, $e5a8a7b6f15619c1$export$531818e825e774db)(this._session, {
                    user: user
                });
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Get the user from this scope.
   */ key: "getUser",
            value: function getUser() {
                return this._user;
            }
        },
        {
            /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ key: "setConversationId",
            value: function setConversationId(conversationId) {
                this._conversationId = conversationId || void 0;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ key: "setTags",
            value: function setTags(tags) {
                this._tags = (0, $hwO3w._)({}, this._tags, tags);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Set a single tag that will be sent as tags data with the event.
   */ key: "setTag",
            value: function setTag(key, value) {
                return this.setTags((0, $dUlz9._)({}, key, value));
            }
        },
        {
            /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ key: "setAttributes",
            value: function setAttributes(newAttributes) {
                this._attributes = (0, $hwO3w._)({}, this._attributes, newAttributes);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setAttribute",
            value: function setAttribute(key, value) {
                return this.setAttributes((0, $dUlz9._)({}, key, value));
            }
        },
        {
            /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ key: "removeAttribute",
            value: function removeAttribute(key) {
                if (key in this._attributes) {
                    delete this._attributes[key];
                    this._notifyScopeListeners();
                }
                return this;
            }
        },
        {
            /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ key: "setExtras",
            value: function setExtras(extras) {
                this._extra = (0, $hwO3w._)({}, this._extra, extras);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this._extra = (0, $lf4fc._)((0, $hwO3w._)({}, this._extra), (0, $dUlz9._)({}, key, extra));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ key: "setFingerprint",
            value: function setFingerprint(fingerprint) {
                this._fingerprint = fingerprint;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the level on the scope for future events.
   */ key: "setLevel",
            value: function setLevel(level) {
                this._level = level;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ key: "setTransactionName",
            value: function setTransactionName(name) {
                this._transactionName = name;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) delete this._contexts[key];
                else this._contexts[key] = context;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Set the session for the scope.
   */ key: "setSession",
            value: function setSession(session) {
                if (!session) delete this._session;
                else this._session = session;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Get the session from the scope.
   */ key: "getSession",
            value: function getSession() {
                return this._session;
            }
        },
        {
            /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ key: "update",
            value: function update(captureContext) {
                if (!captureContext) return this;
                var scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
                var scopeInstance = scopeToMerge instanceof Scope ? scopeToMerge.getScopeData() : (0, $6ea82c15e37d9720$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : void 0;
                var _ref = scopeInstance || {}, tags = _ref.tags, attributes = _ref.attributes, extra = _ref.extra, user = _ref.user, contexts = _ref.contexts, level = _ref.level, _ref_fingerprint = _ref.fingerprint, fingerprint = _ref_fingerprint === void 0 ? [] : _ref_fingerprint, propagationContext = _ref.propagationContext, conversationId = _ref.conversationId;
                this._tags = (0, $hwO3w._)({}, this._tags, tags);
                this._attributes = (0, $hwO3w._)({}, this._attributes, attributes);
                this._extra = (0, $hwO3w._)({}, this._extra, extra);
                this._contexts = (0, $hwO3w._)({}, this._contexts, contexts);
                if (user && Object.keys(user).length) this._user = user;
                if (level) this._level = level;
                if (fingerprint.length) this._fingerprint = fingerprint;
                if (propagationContext) this._propagationContext = propagationContext;
                if (conversationId) this._conversationId = conversationId;
                return this;
            }
        },
        {
            /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ key: "clear",
            value: function clear() {
                this._breadcrumbs = [];
                this._tags = {};
                this._attributes = {};
                this._extra = {};
                this._user = {};
                this._contexts = {};
                this._level = void 0;
                this._transactionName = void 0;
                this._fingerprint = void 0;
                this._session = void 0;
                this._conversationId = void 0;
                (0, $6102d52d892cc90c$export$3f25fa50c18e20ca)(this, void 0);
                this._attachments = [];
                this.setPropagationContext({
                    traceId: (0, $1525c77c2ae4a4b0$export$dc6d7ea554bcce10)(),
                    sampleRand: (0, $dd2c5f85fcbd9c64$export$9869d72de32a3917)()
                });
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, maxBreadcrumbs) {
                var maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $846be57626444680$var$DEFAULT_MAX_BREADCRUMBS;
                if (maxCrumbs <= 0) return this;
                var mergedBreadcrumb = (0, $lf4fc._)((0, $hwO3w._)({
                    timestamp: (0, $7b1d57c4c7d6952d$export$7740643b9eeaf0c4)()
                }, breadcrumb), {
                    // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
                    message: breadcrumb.message ? (0, $45aea333cf5bef5d$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
                });
                this._breadcrumbs.push(mergedBreadcrumb);
                if (this._breadcrumbs.length > maxCrumbs) {
                    var _this__client;
                    this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
                    (_this__client = this._client) === null || _this__client === void 0 ? void 0 : _this__client.recordDroppedEvent("buffer_overflow", "log_item");
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Get the last breadcrumb of the scope.
   */ key: "getLastBreadcrumb",
            value: function getLastBreadcrumb() {
                return this._breadcrumbs[this._breadcrumbs.length - 1];
            }
        },
        {
            /**
   * Clear all breadcrumbs from the scope.
   */ key: "clearBreadcrumbs",
            value: function clearBreadcrumbs() {
                this._breadcrumbs = [];
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Add an attachment to the scope.
   */ key: "addAttachment",
            value: function addAttachment(attachment) {
                this._attachments.push(attachment);
                return this;
            }
        },
        {
            /**
   * Clear all attachments from the scope.
   */ key: "clearAttachments",
            value: function clearAttachments() {
                this._attachments = [];
                return this;
            }
        },
        {
            /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ key: "getScopeData",
            value: function getScopeData() {
                return {
                    breadcrumbs: this._breadcrumbs,
                    attachments: this._attachments,
                    contexts: this._contexts,
                    tags: this._tags,
                    attributes: this._attributes,
                    extra: this._extra,
                    user: this._user,
                    level: this._level,
                    fingerprint: this._fingerprint || [],
                    eventProcessors: this._eventProcessors,
                    propagationContext: this._propagationContext,
                    sdkProcessingMetadata: this._sdkProcessingMetadata,
                    transactionName: this._transactionName,
                    span: (0, $6102d52d892cc90c$export$91f063ebb8eff307)(this),
                    conversationId: this._conversationId
                };
            }
        },
        {
            /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ key: "setSDKProcessingMetadata",
            value: function setSDKProcessingMetadata(newData) {
                this._sdkProcessingMetadata = (0, $e561f8063ae23b8a$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
                return this;
            }
        },
        {
            /**
   * Add propagation context to the scope, used for distributed tracing
   */ key: "setPropagationContext",
            value: function setPropagationContext(context) {
                this._propagationContext = context;
                return this;
            }
        },
        {
            /**
   * Get propagation context from the scope, used for distributed tracing
   */ key: "getPropagationContext",
            value: function getPropagationContext() {
                return this._propagationContext;
            }
        },
        {
            /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $30748c2972c04cd5$export$19f53698e68b2496)();
                if (!this._client) {
                    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("No client configured on scope - will not capture exception!");
                    return eventId;
                }
                var syntheticException = new Error("Sentry syntheticException");
                this._client.captureException(exception, (0, $lf4fc._)((0, $hwO3w._)({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ key: "captureMessage",
            value: function captureMessage(message, level, hint) {
                var eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $30748c2972c04cd5$export$19f53698e68b2496)();
                if (!this._client) {
                    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("No client configured on scope - will not capture message!");
                    return eventId;
                }
                var _hint_syntheticException;
                var syntheticException = (_hint_syntheticException = hint === null || hint === void 0 ? void 0 : hint.syntheticException) !== null && _hint_syntheticException !== void 0 ? _hint_syntheticException : new Error(message);
                this._client.captureMessage(message, level, (0, $lf4fc._)((0, $hwO3w._)({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = event.event_id || (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $30748c2972c04cd5$export$19f53698e68b2496)();
                if (!this._client) {
                    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("No client configured on scope - will not capture event!");
                    return eventId;
                }
                this._client.captureEvent(event, (0, $lf4fc._)((0, $hwO3w._)({}, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * This will be called on every set call.
   */ key: "_notifyScopeListeners",
            value: function _notifyScopeListeners() {
                var _this = this;
                if (!this._notifyingListeners) {
                    this._notifyingListeners = true;
                    this._scopeListeners.forEach(function(callback) {
                        callback(_this);
                    });
                    this._notifyingListeners = false;
                }
            }
        }
    ]);
    return Scope;
}();


function $1d9bfcd79fe7bc31$export$6f1b9191db9c4d5() {
    return (0, $8a2f538a13cfc001$export$7e223ec222791509)("defaultCurrentScope", function() {
        return new (0, $846be57626444680$export$775b6bb06e53a214)();
    });
}
function $1d9bfcd79fe7bc31$export$de9862929b76bf57() {
    return (0, $8a2f538a13cfc001$export$7e223ec222791509)("defaultIsolationScope", function() {
        return new (0, $846be57626444680$export$775b6bb06e53a214)();
    });
}




var $dUlz9 = parcelRequire("dUlz9");
var $a5eeea8ef0ae5267$var$isActualPromise = function(p) {
    return p instanceof Promise && !p[$a5eeea8ef0ae5267$var$kChainedCopy];
};
var $a5eeea8ef0ae5267$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
var $a5eeea8ef0ae5267$export$64da0f40b0f924ba = function(original, onSuccess, onError) {
    var chained = original.then(function(value) {
        onSuccess(value);
        return value;
    }, function(err) {
        onError(err);
        throw err;
    });
    return $a5eeea8ef0ae5267$var$isActualPromise(chained) && $a5eeea8ef0ae5267$var$isActualPromise(original) ? chained : $a5eeea8ef0ae5267$var$copyProps(original, chained);
};
var $a5eeea8ef0ae5267$var$copyProps = function(original, chained) {
    var _loop = function(key) {
        if (key in chained) return "continue";
        mutated = true;
        var value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return value.apply(original, args);
            },
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    };
    if (!chained) return original;
    var mutated = false;
    for(var key in original)_loop(key);
    if (mutated) Object.assign(chained, (0, $dUlz9._)({}, $a5eeea8ef0ae5267$var$kChainedCopy, true));
    return chained;
};




var $a9a44006a05a6bc0$export$d36ec451f120cfba = /*#__PURE__*/ function() {
    "use strict";
    function AsyncContextStack(scope, isolationScope) {
        (0, $5Epmf._)(this, AsyncContextStack);
        var assignedScope;
        if (!scope) assignedScope = new (0, $846be57626444680$export$775b6bb06e53a214)();
        else assignedScope = scope;
        var assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $846be57626444680$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    (0, $9MqXK._)(AsyncContextStack, [
        {
            /**
   * Fork a scope for the stack.
   */ key: "withScope",
            value: function withScope(callback) {
                var _this = this;
                var scope = this._pushScope();
                var maybePromiseResult;
                try {
                    maybePromiseResult = callback(scope);
                } catch (e) {
                    this._popScope();
                    throw e;
                }
                if ((0, $6ea82c15e37d9720$export$f5b060c2914b97c8)(maybePromiseResult)) return (0, $a5eeea8ef0ae5267$export$64da0f40b0f924ba)(maybePromiseResult, function() {
                    return _this._popScope();
                }, function() {
                    return _this._popScope();
                });
                this._popScope();
                return maybePromiseResult;
            }
        },
        {
            /**
   * Get the client of the stack.
   */ key: "getClient",
            value: function getClient() {
                return this.getStackTop().client;
            }
        },
        {
            /**
   * Returns the scope of the top stack.
   */ key: "getScope",
            value: function getScope() {
                return this.getStackTop().scope;
            }
        },
        {
            /**
   * Get the isolation scope for the stack.
   */ key: "getIsolationScope",
            value: function getIsolationScope() {
                return this._isolationScope;
            }
        },
        {
            /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ key: "getStackTop",
            value: function getStackTop() {
                return this._stack[this._stack.length - 1];
            }
        },
        {
            /**
   * Push a scope to the stack.
   */ key: "_pushScope",
            value: function _pushScope() {
                var scope = this.getScope().clone();
                this._stack.push({
                    client: this.getClient(),
                    scope: scope
                });
                return scope;
            }
        },
        {
            /**
   * Pop a scope from the stack.
   */ key: "_popScope",
            value: function _popScope() {
                if (this._stack.length <= 1) return false;
                return !!this._stack.pop();
            }
        }
    ]);
    return AsyncContextStack;
}();
function $a9a44006a05a6bc0$var$getAsyncContextStack() {
    var registry = (0, $8a2f538a13cfc001$export$19eade501500c6c1)();
    var sentry = (0, $8a2f538a13cfc001$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $a9a44006a05a6bc0$export$d36ec451f120cfba((0, $1d9bfcd79fe7bc31$export$6f1b9191db9c4d5)(), (0, $1d9bfcd79fe7bc31$export$de9862929b76bf57)());
}
function $a9a44006a05a6bc0$var$withScope(callback) {
    return $a9a44006a05a6bc0$var$getAsyncContextStack().withScope(callback);
}
function $a9a44006a05a6bc0$var$withSetScope(scope, callback) {
    var stack = $a9a44006a05a6bc0$var$getAsyncContextStack();
    return stack.withScope(function() {
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $a9a44006a05a6bc0$var$withIsolationScope(callback) {
    return $a9a44006a05a6bc0$var$getAsyncContextStack().withScope(function() {
        return callback($a9a44006a05a6bc0$var$getAsyncContextStack().getIsolationScope());
    });
}
function $a9a44006a05a6bc0$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $a9a44006a05a6bc0$var$withIsolationScope,
        withScope: $a9a44006a05a6bc0$var$withScope,
        withSetScope: $a9a44006a05a6bc0$var$withSetScope,
        withSetIsolationScope: function(_isolationScope, callback) {
            return $a9a44006a05a6bc0$var$withIsolationScope(callback);
        },
        getCurrentScope: function() {
            return $a9a44006a05a6bc0$var$getAsyncContextStack().getScope();
        },
        getIsolationScope: function() {
            return $a9a44006a05a6bc0$var$getAsyncContextStack().getIsolationScope();
        }
    };
}


function $4e593e827d604273$export$774ae0e6b6e444ca(strategy) {
    var registry = (0, $8a2f538a13cfc001$export$19eade501500c6c1)();
    var sentry = (0, $8a2f538a13cfc001$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
function $4e593e827d604273$export$f639b0c2752203be(carrier) {
    var sentry = (0, $8a2f538a13cfc001$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    return (0, $a9a44006a05a6bc0$export$329d4d4d54e42710)();
}





var $945639585ea57ae0$var$_externalPropagationContextProvider;
function $945639585ea57ae0$export$b5defb3466e9689b(fn) {
    $945639585ea57ae0$var$_externalPropagationContextProvider = fn;
}
function $945639585ea57ae0$export$92547f779c920a71() {
    return $945639585ea57ae0$var$_externalPropagationContextProvider === null || $945639585ea57ae0$var$_externalPropagationContextProvider === void 0 ? void 0 : $945639585ea57ae0$var$_externalPropagationContextProvider();
}
function $945639585ea57ae0$export$53f0ae651a1c4298() {
    return $945639585ea57ae0$var$_externalPropagationContextProvider !== void 0;
}
function $945639585ea57ae0$export$c7be4b0125a10cba() {
    var carrier = (0, $8a2f538a13cfc001$export$19eade501500c6c1)();
    var acs = (0, $4e593e827d604273$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
function $945639585ea57ae0$export$68f3af03034c9e90() {
    var carrier = (0, $8a2f538a13cfc001$export$19eade501500c6c1)();
    var acs = (0, $4e593e827d604273$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
function $945639585ea57ae0$export$aa55d5ab8e05984f() {
    return (0, $8a2f538a13cfc001$export$7e223ec222791509)("globalScope", function() {
        return new (0, $846be57626444680$export$775b6bb06e53a214)();
    });
}
function $945639585ea57ae0$export$ec58d9285c204497() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    var carrier = (0, $8a2f538a13cfc001$export$19eade501500c6c1)();
    var acs = (0, $4e593e827d604273$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        var _rest = (0, $6iP9u._)(rest, 2), scope = _rest[0], callback = _rest[1];
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $945639585ea57ae0$export$9a4fed82c350c2bd() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    var carrier = (0, $8a2f538a13cfc001$export$19eade501500c6c1)();
    var acs = (0, $4e593e827d604273$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        var _rest = (0, $6iP9u._)(rest, 2), isolationScope = _rest[0], callback = _rest[1];
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $945639585ea57ae0$export$6bb76d6eba7e258c() {
    return $945639585ea57ae0$export$c7be4b0125a10cba().getClient();
}
function $945639585ea57ae0$export$1e83db7ee4876dc4(scope) {
    var externalContext = $945639585ea57ae0$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    var propagationContext = scope.getPropagationContext();
    var traceId = propagationContext.traceId, parentSpanId = propagationContext.parentSpanId, propagationSpanId = propagationContext.propagationSpanId;
    var traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $1525c77c2ae4a4b0$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}


var $hwO3w = parcelRequire("hwO3w");
var $9926372cdabb9b15$export$849dbeeeda01ae98 = "production";
var $9926372cdabb9b15$export$6829f580e78306fa = "development";



var $5d82adaea61c8fa9$export$d7a7d984b0791405 = "sentry.source";
var $5d82adaea61c8fa9$export$ccfe0a40627cc34b = "sentry.sample_rate";
var $5d82adaea61c8fa9$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
var $5d82adaea61c8fa9$export$1a413bd9a88fdb09 = "sentry.op";
var $5d82adaea61c8fa9$export$cca8dd30f57f805e = "sentry.origin";
var $5d82adaea61c8fa9$export$d9e02c0285078f88 = "sentry.status.message";
var $5d82adaea61c8fa9$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
var $5d82adaea61c8fa9$export$f5f95cff026507b5 = "sentry.measurement_unit";
var $5d82adaea61c8fa9$export$69cd5c610c7bb96a = "sentry.measurement_value";
var $5d82adaea61c8fa9$export$f5cefb258679b29e = "sentry.release";
var $5d82adaea61c8fa9$export$d1b1dbb47f5ba57c = "sentry.environment";
var $5d82adaea61c8fa9$export$4626f2be16112c1c = "sentry.segment.name";
var $5d82adaea61c8fa9$export$25fa4a1832d3736a = "sentry.segment.id";
var $5d82adaea61c8fa9$export$87a4807042e1f1bb = "sentry.sdk.name";
var $5d82adaea61c8fa9$export$301ebe936458e291 = "sentry.sdk.version";
var $5d82adaea61c8fa9$export$bd847b1cc92ae587 = "sentry.sdk.integrations";
var $5d82adaea61c8fa9$export$1f9cc1d34ea098a0 = "user.id";
var $5d82adaea61c8fa9$export$b7466609ef46c07e = "user.email";
var $5d82adaea61c8fa9$export$8d592bdaea63b930 = "user.ip_address";
var $5d82adaea61c8fa9$export$c05ee933d3f74b2b = "user.name";
var $5d82adaea61c8fa9$export$165ce9a229f6f050 = "sentry.custom_span_name";
var $5d82adaea61c8fa9$export$1efec95406bbe327 = "sentry.profile_id";
var $5d82adaea61c8fa9$export$fea48ba9f4550879 = "sentry.exclusive_time";
var $5d82adaea61c8fa9$export$b016f89ac1066ec = "cache.hit";
var $5d82adaea61c8fa9$export$3110e4c3f4386399 = "cache.key";
var $5d82adaea61c8fa9$export$86be76deee227ff2 = "cache.item_size";
var $5d82adaea61c8fa9$export$be7a251980e7e946 = "http.request.method";
var $5d82adaea61c8fa9$export$25dfd73e0e32c6e1 = "url.full";
var $5d82adaea61c8fa9$export$ff77b5fd5b2d627b = "sentry.link.type";
var $5d82adaea61c8fa9$export$71a4a707257f2774 = "gen_ai.conversation.id";



var $6iP9u = parcelRequire("6iP9u");



var $0885d9483190850a$export$6e69537d67fa20f = "sentry-";
var $0885d9483190850a$export$eb0401070c617ea5 = /^sentry-/;
var $0885d9483190850a$export$bdd844ddb2def819 = 8192;
function $0885d9483190850a$export$5b96ee2c8421f107(baggageHeader) {
    var baggageObject = $0885d9483190850a$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return void 0;
    var dynamicSamplingContext = Object.entries(baggageObject).reduce(function(acc, param) {
        var _param = (0, $6iP9u._)(param, 2), key = _param[0], value = _param[1];
        if (key.startsWith($0885d9483190850a$export$6e69537d67fa20f)) {
            var nonPrefixedKey = key.slice($0885d9483190850a$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $0885d9483190850a$export$56766feef403f365(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    var sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(function(acc, param) {
        var _param = (0, $6iP9u._)(param, 2), dscKey = _param[0], dscValue = _param[1];
        if (dscValue) acc["".concat($0885d9483190850a$export$6e69537d67fa20f).concat(dscKey)] = dscValue;
        return acc;
    }, {});
    return $0885d9483190850a$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
function $0885d9483190850a$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $6ea82c15e37d9720$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce(function(acc, curr) {
        var currBaggageObject = $0885d9483190850a$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(function(param) {
            var _param = (0, $6iP9u._)(param, 2), key = _param[0], value = _param[1];
            acc[key] = value;
        });
        return acc;
    }, {});
    return $0885d9483190850a$var$baggageHeaderToObject(baggageHeader);
}
function $0885d9483190850a$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map(function(baggageEntry) {
        var eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        var key = baggageEntry.slice(0, eqIdx);
        var value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map(function(keyOrValue) {
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch (e) {
                return;
            }
        });
    }).reduce(function(acc, param) {
        var _param = (0, $6iP9u._)(param, 2), key = _param[0], value = _param[1];
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $0885d9483190850a$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce(function(baggageHeader, param, currentIndex) {
        var _param = (0, $6iP9u._)(param, 2), objectKey = _param[0], objectValue = _param[1];
        var baggageEntry = "".concat(encodeURIComponent(objectKey), "=").concat(encodeURIComponent(objectValue));
        var newBaggageHeader = currentIndex === 0 ? baggageEntry : "".concat(baggageHeader, ",").concat(baggageEntry);
        if (newBaggageHeader.length > $0885d9483190850a$export$bdd844ddb2def819) {
            (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Not adding key: ".concat(objectKey, " with val: ").concat(objectValue, " to baggage header due to exceeding baggage size limits."));
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $0885d9483190850a$export$7b8640b7baaa3922(existing, incoming) {
    if (!existing) return incoming;
    var existingEntries = $0885d9483190850a$export$397de414d189db00(existing);
    var incomingEntries = $0885d9483190850a$export$397de414d189db00(incoming);
    if (!incomingEntries) return existing;
    var merged = {};
    var hasNewSentryEntries = false;
    var newSentryEntries = {};
    var newNonSentryEntries = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(incomingEntries)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6iP9u._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (key.startsWith($0885d9483190850a$export$6e69537d67fa20f)) {
                newSentryEntries[key] = value;
                hasNewSentryEntries = true;
            } else newNonSentryEntries[key] = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (existingEntries) {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = Object.entries(existingEntries)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value1 = (0, $6iP9u._)(_step1.value, 2), key1 = _step_value1[0], value1 = _step_value1[1];
                if (!hasNewSentryEntries || !key1.startsWith($0885d9483190850a$export$6e69537d67fa20f)) merged[key1] = value1;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    var _merged_key;
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = Object.entries(newNonSentryEntries)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _step_value2 = (0, $6iP9u._)(_step2.value, 2), key2 = _step_value2[0], value2 = _step_value2[1];
            (_merged_key = merged[key2]) !== null && _merged_key !== void 0 ? _merged_key : merged[key2] = value2;
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return $0885d9483190850a$export$12a7349a29a6e3c2(merged);
}



var $6iP9u = parcelRequire("6iP9u");


var $a77c6f8fcbd294ab$var$ORG_ID_REGEX = /^o(\d+)\./;
var $a77c6f8fcbd294ab$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $a77c6f8fcbd294ab$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $a77c6f8fcbd294ab$export$44d472fbb931a776(dsn) {
    var withPassword = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return "".concat(protocol, "://").concat(publicKey).concat(withPassword && pass ? ":".concat(pass) : "", "@").concat(host).concat(port ? ":".concat(port) : "", "/").concat(path ? "".concat(path, "/") : path).concat(projectId);
}
function $a77c6f8fcbd294ab$export$b892860177f70a30(str) {
    var match = $a77c6f8fcbd294ab$var$DSN_REGEX.exec(str);
    if (!match) {
        (0, $739716ea0436a6d0$export$cda52e2a8927a2ca)(function() {
            console.error("Invalid Sentry Dsn: ".concat(str));
        });
        return void 0;
    }
    var _match_slice = (0, $6iP9u._)(match.slice(1), 6), protocol = _match_slice[0], publicKey = _match_slice[1], tmp = _match_slice[2], pass = tmp === void 0 ? "" : tmp, tmp1 = _match_slice[3], host = tmp1 === void 0 ? "" : tmp1, tmp2 = _match_slice[4], port = tmp2 === void 0 ? "" : tmp2, tmp3 = _match_slice[5], lastPath = tmp3 === void 0 ? "" : tmp3;
    var path = "";
    var projectId = lastPath;
    var split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $a77c6f8fcbd294ab$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $a77c6f8fcbd294ab$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $a77c6f8fcbd294ab$var$validateDsn(dsn) {
    if (!(0, $63491170aaadd711$export$16a28057038b10ef)) return true;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    var hasMissingRequiredComponent = requiredComponents.find(function(component) {
        if (!dsn[component]) {
            (0, $739716ea0436a6d0$export$1c9f709888824e05).error("Invalid Sentry Dsn: ".concat(component, " missing"));
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $739716ea0436a6d0$export$1c9f709888824e05).error("Invalid Sentry Dsn: Invalid projectId ".concat(projectId));
        return false;
    }
    if (!$a77c6f8fcbd294ab$var$isValidProtocol(protocol)) {
        (0, $739716ea0436a6d0$export$1c9f709888824e05).error("Invalid Sentry Dsn: Invalid protocol ".concat(protocol));
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $739716ea0436a6d0$export$1c9f709888824e05).error("Invalid Sentry Dsn: Invalid port ".concat(port));
        return false;
    }
    return true;
}
function $a77c6f8fcbd294ab$export$5914f4e7748c29c9(host) {
    var match = host.match($a77c6f8fcbd294ab$var$ORG_ID_REGEX);
    return match === null || match === void 0 ? void 0 : match[1];
}
function $a77c6f8fcbd294ab$export$b7ac9b8efa4bb595(client) {
    var options = client.getOptions();
    var host = (client.getDsn() || {}).host;
    var org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $a77c6f8fcbd294ab$export$5914f4e7748c29c9(host);
    return org_id;
}
function $a77c6f8fcbd294ab$export$128827c3562ec0cb(from) {
    var components = typeof from === "string" ? $a77c6f8fcbd294ab$export$b892860177f70a30(from) : $a77c6f8fcbd294ab$var$dsnFromComponents(from);
    if (!components || !$a77c6f8fcbd294ab$var$validateDsn(components)) return void 0;
    return components;
}



function $ffb01f703f29801c$export$1f70765132c3c225(maybeOptions) {
    var _getClient;
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    var options = maybeOptions || ((_getClient = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)()) === null || _getClient === void 0 ? void 0 : _getClient.getOptions());
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}




var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $54Czb = parcelRequire("54Czb");


var $hwO3w = parcelRequire("hwO3w");

var $6iP9u = parcelRequire("6iP9u");

var $03bAP = parcelRequire("03bAP");

function $fa3ae50862f28851$export$f5706f332d297c38(maybeObj) {
    return (typeof maybeObj === "undefined" ? "undefined" : (0, $03bAP._)(maybeObj)) === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $fa3ae50862f28851$export$f18f8779fed6dfa(rawValue, useFallback) {
    var _ref = $fa3ae50862f28851$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    }, value = _ref.value, unit = _ref.unit;
    var attributeValue = $fa3ae50862f28851$var$getTypedAttributeValue(value);
    var checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return (0, $hwO3w._)({}, attributeValue, checkedUnit);
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    var stringValue = "";
    try {
        var _JSON_stringify;
        stringValue = (_JSON_stringify = JSON.stringify(value)) !== null && _JSON_stringify !== void 0 ? _JSON_stringify : "";
    } catch (e) {}
    return (0, $hwO3w._)({
        value: stringValue,
        type: "string"
    }, checkedUnit);
}
function $fa3ae50862f28851$export$4954cae66e755861(attributes) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var serializedAttributes = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(attributes !== null && attributes !== void 0 ? attributes : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6iP9u._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            var typedValue = $fa3ae50862f28851$export$f18f8779fed6dfa(value, fallback);
            if (typedValue) serializedAttributes[key] = typedValue;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serializedAttributes;
}
function $fa3ae50862f28851$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    var weight = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6iP9u._)(_step.value, 2), key = _step_value[0], attr = _step_value[1];
            var _attr_unit;
            weight += key.length * 2;
            weight += attr.type.length * 2;
            var _attr_unit_length;
            weight += ((_attr_unit_length = (_attr_unit = attr.unit) === null || _attr_unit === void 0 ? void 0 : _attr_unit.length) !== null && _attr_unit_length !== void 0 ? _attr_unit_length : 0) * 2;
            var val = attr.value;
            if (Array.isArray(val)) weight += $fa3ae50862f28851$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
            else if ((0, $6ea82c15e37d9720$export$c3825b437cbdea5c)(val)) weight += $fa3ae50862f28851$var$estimatePrimitiveSizeInBytes(val);
            else weight += 100;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return weight;
}
function $fa3ae50862f28851$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $fa3ae50862f28851$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    var primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}





var $6ec04d3e01c80cf6$export$136e25984ba4a383 = 0;
var $6ec04d3e01c80cf6$export$58f7963109c806fc = 1;
var $6ec04d3e01c80cf6$export$f966a0446ece71e = 2;
function $6ec04d3e01c80cf6$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $6ec04d3e01c80cf6$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $6ec04d3e01c80cf6$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $6ec04d3e01c80cf6$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $6ec04d3e01c80cf6$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $6ec04d3e01c80cf6$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $6ec04d3e01c80cf6$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $6ec04d3e01c80cf6$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $6ec04d3e01c80cf6$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $6ec04d3e01c80cf6$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $6ec04d3e01c80cf6$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $6ec04d3e01c80cf6$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $6ec04d3e01c80cf6$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $6ec04d3e01c80cf6$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $6ec04d3e01c80cf6$export$f966a0446ece71e,
        message: "internal_error"
    };
}
function $6ec04d3e01c80cf6$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    var spanStatus = $6ec04d3e01c80cf6$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}




var $4ef71f79add55d26$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
var $4ef71f79add55d26$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
var $4ef71f79add55d26$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
var $4ef71f79add55d26$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceExplicitlySet");
var $4ef71f79add55d26$var$TRACER_PROVIDER_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.tracerProviderSpan");
function $4ef71f79add55d26$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $27958f6402fc5d96$export$e73679ffaf56810e)(span, $4ef71f79add55d26$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $261b84d5e2b85281$export$f0b98edec95fcb33)(isolationScope));
        (0, $27958f6402fc5d96$export$e73679ffaf56810e)(span, $4ef71f79add55d26$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $4ef71f79add55d26$export$c08fbc656a245d03(span) {
    var spanWithScopes = span;
    return {
        scope: spanWithScopes[$4ef71f79add55d26$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $261b84d5e2b85281$export$a0592ad8c3586cf)(spanWithScopes[$4ef71f79add55d26$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $4ef71f79add55d26$export$d135494e80cbbcae(span) {
    (0, $27958f6402fc5d96$export$e73679ffaf56810e)(span, $4ef71f79add55d26$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $4ef71f79add55d26$export$2e69b79005fc86eb(span) {
    return span[$4ef71f79add55d26$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
function $4ef71f79add55d26$export$c45f16c039fb5033(span) {
    (0, $27958f6402fc5d96$export$e73679ffaf56810e)(span, $4ef71f79add55d26$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD, true);
}
function $4ef71f79add55d26$export$aceb4106f395d20e(span) {
    return span[$4ef71f79add55d26$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD] === true;
}
function $4ef71f79add55d26$export$6ba79447c0a2d852(span) {
    (0, $27958f6402fc5d96$export$e73679ffaf56810e)(span, $4ef71f79add55d26$var$TRACER_PROVIDER_SPAN_FIELD, true);
}
function $4ef71f79add55d26$export$a9ba2a501dbf6a56(span) {
    return span[$4ef71f79add55d26$var$TRACER_PROVIDER_SPAN_FIELD] === true;
}








function $bbaf31262ee9249c$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    var rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}




var $741db41d31a45a5e$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $741db41d31a45a5e$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return void 0;
    var matches = traceparent.match($741db41d31a45a5e$export$394a210812ba3012);
    if (!matches) return void 0;
    var parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $741db41d31a45a5e$export$261f383d16a93e39(sentryTrace, baggage) {
    var traceparentData = $741db41d31a45a5e$export$8e9a29865c0a1226(sentryTrace);
    var dynamicSamplingContext = (0, $0885d9483190850a$export$5b96ee2c8421f107)(baggage);
    if (!(traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.traceId)) return {
        traceId: (0, $1525c77c2ae4a4b0$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $dd2c5f85fcbd9c64$export$9869d72de32a3917)()
    };
    var sampleRand = $741db41d31a45a5e$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    var traceId = traceparentData.traceId, parentSpanId = traceparentData.parentSpanId, parentSampled = traceparentData.parentSampled;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand: sampleRand
    };
}
function $741db41d31a45a5e$export$f35d907436da45cf() {
    var traceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $1525c77c2ae4a4b0$export$dc6d7ea554bcce10)(), spanId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $1525c77c2ae4a4b0$export$295213bc4d0c54ad)(), sampled = arguments.length > 2 ? arguments[2] : void 0;
    var sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return "".concat(traceId, "-").concat(spanId).concat(sampledString);
}
function $741db41d31a45a5e$export$1aff3752542747dd() {
    var traceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $1525c77c2ae4a4b0$export$dc6d7ea554bcce10)(), spanId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $1525c77c2ae4a4b0$export$295213bc4d0c54ad)(), sampled = arguments.length > 2 ? arguments[2] : void 0;
    return "00-".concat(traceId, "-").concat(spanId, "-").concat(sampled ? "01" : "00");
}
function $741db41d31a45a5e$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    var parsedSampleRand = (0, $bbaf31262ee9249c$export$a5bd2d81656d9546)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    var parsedSampleRate = (0, $bbaf31262ee9249c$export$a5bd2d81656d9546)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rate);
    if (parsedSampleRate && (traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.parentSampled) !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    (0, $dd2c5f85fcbd9c64$export$9869d72de32a3917)() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + (0, $dd2c5f85fcbd9c64$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else return (0, $dd2c5f85fcbd9c64$export$9869d72de32a3917)();
}
function $741db41d31a45a5e$export$18811bc99eefceaa(client, baggageOrgId) {
    var clientOrgId = (0, $a77c6f8fcbd294ab$export$b7ac9b8efa4bb595)(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Won't continue trace because org IDs don't match (incoming baggage: ".concat(baggageOrgId, ", SDK options: ").concat(clientOrgId, ")"));
        return false;
    }
    var strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ".concat(baggageOrgId, ", Sentry client: ").concat(clientOrgId, ")"));
            return false;
        }
    }
    return true;
}




var $79515206909fddff$export$208d5b368507fb8b = 0;
var $79515206909fddff$export$eb571cd9b5d98de8 = 1;
var $79515206909fddff$var$hasShownSpanDropWarning = false;
function $79515206909fddff$export$4c3967a8a2f6bbd6(span) {
    var _span_spanContext = span.spanContext(), span_id = _span_spanContext.spanId, trace_id = _span_spanContext.traceId;
    var _spanToJSON = $79515206909fddff$export$92d8c23565496537(span), data = _spanToJSON.data, op = _spanToJSON.op, parent_span_id = _spanToJSON.parent_span_id, status = _spanToJSON.status, origin = _spanToJSON.origin, links = _spanToJSON.links;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $79515206909fddff$export$46c6fbd1d265ebf0(span) {
    var _span_spanContext = span.spanContext(), spanId = _span_spanContext.spanId, trace_id = _span_spanContext.traceId, isRemote = _span_spanContext.isRemote;
    var parent_span_id = isRemote ? spanId : $79515206909fddff$export$92d8c23565496537(span).parent_span_id;
    var scope = (0, $4ef71f79add55d26$export$c08fbc656a245d03)(span).scope;
    var span_id = isRemote ? (scope === null || scope === void 0 ? void 0 : scope.getPropagationContext().propagationSpanId) || (0, $1525c77c2ae4a4b0$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $79515206909fddff$export$7e9f8ae9e4a328ab(span) {
    var _span_spanContext = span.spanContext(), traceId = _span_spanContext.traceId, spanId = _span_spanContext.spanId;
    var sampled = $79515206909fddff$export$5caecac1caaf3a71(span);
    return (0, $741db41d31a45a5e$export$f35d907436da45cf)(traceId, spanId, sampled);
}
function $79515206909fddff$export$cda58d87bc594e9f(span) {
    var _span_spanContext = span.spanContext(), traceId = _span_spanContext.traceId, spanId = _span_spanContext.spanId;
    var sampled = $79515206909fddff$export$5caecac1caaf3a71(span);
    return (0, $741db41d31a45a5e$export$1aff3752542747dd)(traceId, spanId, sampled);
}
function $79515206909fddff$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(function(_param) {
        var _param_context = _param.context, spanId = _param_context.spanId, traceId = _param_context.traceId, traceFlags = _param_context.traceFlags, attributes = _param.attributes, restContext = (0, $54Czb._)(_param.context, [
            "spanId",
            "traceId",
            "traceFlags"
        ]);
        return (0, $hwO3w._)({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $79515206909fddff$export$eb571cd9b5d98de8,
            attributes: attributes
        }, restContext);
    });
    else return void 0;
}
function $79515206909fddff$export$9015adcf158ef3a5(links) {
    if (links === null || links === void 0 ? void 0 : links.length) return links.map(function(param) {
        var _param_context = param.context, spanId = _param_context.spanId, traceId = _param_context.traceId, traceFlags = _param_context.traceFlags, attributes = param.attributes;
        return {
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $79515206909fddff$export$eb571cd9b5d98de8,
            attributes: attributes
        };
    });
    else return void 0;
}
function $79515206909fddff$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $79515206909fddff$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $79515206909fddff$var$ensureTimestampInSeconds(input.getTime());
    return (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
}
function $79515206909fddff$var$ensureTimestampInSeconds(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $79515206909fddff$export$92d8c23565496537(span) {
    if ($79515206909fddff$export$50882270da12d911(span)) return span.getSpanJSON();
    var _span_spanContext = span.spanContext(), span_id = _span_spanContext.spanId, trace_id = _span_spanContext.traceId;
    if ($79515206909fddff$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        var attributes = span.attributes, startTime = span.startTime, name = span.name, endTime = span.endTime, status = span.status, links = span.links;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $79515206909fddff$var$getOtelParentSpanId(span),
            start_timestamp: $79515206909fddff$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $79515206909fddff$export$3f7581298f56c6d7(endTime) || void 0,
            status: $79515206909fddff$export$e238a77ea3a8cd66(status),
            op: attributes[0, $5d82adaea61c8fa9$export$1a413bd9a88fdb09],
            origin: attributes[0, $5d82adaea61c8fa9$export$cca8dd30f57f805e],
            links: $79515206909fddff$export$cb3e3a12e0eec16c(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $79515206909fddff$export$db0cad9e44f67af8(span) {
    if ($79515206909fddff$export$50882270da12d911(span)) return span.getStreamedSpanJSON();
    var _span_spanContext = span.spanContext(), span_id = _span_spanContext.spanId, trace_id = _span_spanContext.traceId;
    if ($79515206909fddff$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        var attributes = span.attributes, startTime = span.startTime, name = span.name, endTime = span.endTime, status = span.status, links = span.links;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $79515206909fddff$var$getOtelParentSpanId(span),
            start_timestamp: $79515206909fddff$export$3f7581298f56c6d7(startTime),
            end_timestamp: $79515206909fddff$export$3f7581298f56c6d7(endTime),
            is_segment: span === $79515206909fddff$export$7a3106f345d83bb6(span),
            status: $79515206909fddff$export$d3856a3187d34821(status),
            attributes: $79515206909fddff$export$1464a9cb828ba99f(attributes, status),
            links: $79515206909fddff$export$9015adcf158ef3a5(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $79515206909fddff$export$7a3106f345d83bb6(span)
    };
}
function $79515206909fddff$var$getOtelParentSpanId(span) {
    var _span_parentSpanContext;
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? (_span_parentSpanContext = span.parentSpanContext) === null || _span_parentSpanContext === void 0 ? void 0 : _span_parentSpanContext.spanId : void 0;
}
function $79515206909fddff$export$5402aa553bcf35f3(spanJson) {
    var _spanJson_links;
    return (0, $lf4fc._)((0, $hwO3w._)({}, spanJson), {
        attributes: (0, $fa3ae50862f28851$export$4954cae66e755861)(spanJson.attributes),
        links: (_spanJson_links = spanJson.links) === null || _spanJson_links === void 0 ? void 0 : _spanJson_links.map(function(link) {
            return (0, $lf4fc._)((0, $hwO3w._)({}, link), {
                attributes: (0, $fa3ae50862f28851$export$4954cae66e755861)(link.attributes)
            });
        })
    });
}
function $79515206909fddff$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    var castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $79515206909fddff$export$50882270da12d911(span) {
    return typeof span.getSpanJSON === "function";
}
function $79515206909fddff$export$5caecac1caaf3a71(span) {
    var traceFlags = span.spanContext().traceFlags;
    return traceFlags === $79515206909fddff$export$eb571cd9b5d98de8;
}
function $79515206909fddff$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $6ec04d3e01c80cf6$export$136e25984ba4a383)) return void 0;
    if (status.code === (0, $6ec04d3e01c80cf6$export$58f7963109c806fc)) return "ok";
    return status.message || "internal_error";
}
function $79515206909fddff$export$d3856a3187d34821(status) {
    return !status || status.code === (0, $6ec04d3e01c80cf6$export$58f7963109c806fc) || status.code === (0, $6ec04d3e01c80cf6$export$136e25984ba4a383) || status.message === "cancelled" ? "ok" : "error";
}
function $79515206909fddff$export$1464a9cb828ba99f(attributes, status) {
    var statusMessage = $79515206909fddff$export$d3856a3187d34821(status) === "error" ? status === null || status === void 0 ? void 0 : status.message : void 0;
    return (0, $hwO3w._)({}, statusMessage && (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$d9e02c0285078f88), statusMessage), attributes);
}
var $79515206909fddff$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
var $79515206909fddff$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $79515206909fddff$export$81397d924722cc65(span, childSpan) {
    var rootSpan = span[$79515206909fddff$var$ROOT_SPAN_FIELD] || span;
    (0, $27958f6402fc5d96$export$e73679ffaf56810e)(childSpan, $79515206909fddff$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$79515206909fddff$var$CHILD_SPANS_FIELD]) span[$79515206909fddff$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $27958f6402fc5d96$export$e73679ffaf56810e)(span, $79515206909fddff$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $79515206909fddff$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$79515206909fddff$var$CHILD_SPANS_FIELD]) span[$79515206909fddff$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $79515206909fddff$export$340c5c8a13ffc680(span) {
    var resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($79515206909fddff$export$5caecac1caaf3a71(span2)) {
            resultSet.add(span2);
            var childSpans = span2[$79515206909fddff$var$CHILD_SPANS_FIELD] ? Array.from(span2[$79515206909fddff$var$CHILD_SPANS_FIELD]) : [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = childSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var childSpan = _step.value;
                    addSpanChildren(childSpan);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
var $79515206909fddff$export$c4c6a79b1260ca1b = $79515206909fddff$export$7a3106f345d83bb6;
function $79515206909fddff$export$7a3106f345d83bb6(span) {
    return span[$79515206909fddff$var$ROOT_SPAN_FIELD] || span;
}
function $79515206909fddff$export$1be426a8e585c83e() {
    var carrier = (0, $8a2f538a13cfc001$export$19eade501500c6c1)();
    var acs = (0, $4e593e827d604273$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $6102d52d892cc90c$export$91f063ebb8eff307)((0, $945639585ea57ae0$export$c7be4b0125a10cba)());
}
function $79515206909fddff$export$d11691ff45a3e535() {
    if (!$79515206909fddff$var$hasShownSpanDropWarning) {
        (0, $739716ea0436a6d0$export$cda52e2a8927a2ca)(function() {
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $79515206909fddff$var$hasShownSpanDropWarning = true;
    }
}
function $79515206909fddff$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    var _obj;
    span.setAttributes((_obj = {}, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$d7a7d984b0791405), "custom"), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$165ce9a229f6f050), name), _obj));
}



var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");



var $110aa6964cb2c8bd$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
var $110aa6964cb2c8bd$export$d6636b700b76c516 = /*#__PURE__*/ function() {
    "use strict";
    function SentryNonRecordingSpan() {
        var spanContext = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $5Epmf._)(this, SentryNonRecordingSpan);
        this._traceId = spanContext.traceId || (0, $1525c77c2ae4a4b0$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $1525c77c2ae4a4b0$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
        (0, $27958f6402fc5d96$export$e73679ffaf56810e)(this, $110aa6964cb2c8bd$var$NON_RECORDING_SPAN_FIELD, true);
    }
    (0, $9MqXK._)(SentryNonRecordingSpan, [
        {
            /** @inheritdoc */ key: "spanContext",
            value: function spanContext() {
                return {
                    spanId: this._spanId,
                    traceId: this._traceId,
                    traceFlags: (0, $79515206909fddff$export$208d5b368507fb8b)
                };
            }
        },
        {
            /** @inheritdoc */ key: "end",
            value: function end(_timestamp) {}
        },
        {
            /** @inheritdoc */ key: "setAttribute",
            value: function setAttribute(_key, _value) {
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "setAttributes",
            value: function setAttributes(_values) {
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "setStatus",
            value: function setStatus(_status) {
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "updateName",
            value: function updateName(_name) {
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "isRecording",
            value: function isRecording() {
                return false;
            }
        },
        {
            /** @inheritdoc */ key: "addEvent",
            value: function addEvent(_name, _attributesOrStartTime, _startTime) {
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "addLink",
            value: function addLink(_link) {
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "addLinks",
            value: function addLinks(_links) {
                return this;
            }
        },
        {
            /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ key: "recordException",
            value: function recordException(_exception, _time) {}
        }
    ]);
    return SentryNonRecordingSpan;
}();
function $110aa6964cb2c8bd$export$61cc547d99783aa7(span) {
    return !!span && span[$110aa6964cb2c8bd$var$NON_RECORDING_SPAN_FIELD] === true;
}



var $0d1fd6101086a96b$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $0d1fd6101086a96b$export$7398c93e763ca9fd(span, dsc) {
    var spanWithMaybeDsc = span;
    (0, $27958f6402fc5d96$export$e73679ffaf56810e)(spanWithMaybeDsc, $0d1fd6101086a96b$var$FROZEN_DSC_FIELD, dsc);
}
function $0d1fd6101086a96b$export$366bad00d6815eed(trace_id, client) {
    var options = client.getOptions();
    var _ref = client.getDsn() || {}, public_key = _ref.publicKey;
    var dsc = {
        environment: options.environment || (0, $9926372cdabb9b15$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $a77c6f8fcbd294ab$export$b7ac9b8efa4bb595)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $0d1fd6101086a96b$export$89ef1736f08c6b2b(client, scope) {
    var propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $0d1fd6101086a96b$export$366bad00d6815eed(propagationContext.traceId, client);
}
function $0d1fd6101086a96b$export$a117f995597e25df(span) {
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    if (!client) return {};
    var rootSpan = (0, $79515206909fddff$export$c4c6a79b1260ca1b)(span);
    var rootSpanJson = (0, $79515206909fddff$export$92d8c23565496537)(rootSpan);
    var rootSpanAttributes = rootSpanJson.data;
    var traceState = rootSpan.spanContext().traceState;
    var _traceState_get, _ref;
    var rootSpanSampleRate = (_ref = (_traceState_get = traceState === null || traceState === void 0 ? void 0 : traceState.get("sentry.sample_rate")) !== null && _traceState_get !== void 0 ? _traceState_get : rootSpanAttributes[0, $5d82adaea61c8fa9$export$ccfe0a40627cc34b]) !== null && _ref !== void 0 ? _ref : rootSpanAttributes[0, $5d82adaea61c8fa9$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = "".concat(rootSpanSampleRate);
        return dsc2;
    }
    var frozenDsc = rootSpan[$0d1fd6101086a96b$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    var isNonRecordingRoot = (0, $110aa6964cb2c8bd$export$61cc547d99783aa7)(rootSpan);
    var isIgnoredRoot = isNonRecordingRoot && rootSpan.dropReason === "ignored";
    if (isNonRecordingRoot && (!(0, $ffb01f703f29801c$export$1f70765132c3c225)(client.getOptions()) || isIgnoredRoot)) {
        var capturedScope = (0, $4ef71f79add55d26$export$c08fbc656a245d03)(rootSpan).scope;
        if (capturedScope) {
            var dsc2 = (0, $hwO3w._)({}, $0d1fd6101086a96b$export$89ef1736f08c6b2b(client, capturedScope));
            if (isIgnoredRoot) dsc2.sampled = "false";
            return applyLocalSampleRateToDsc(dsc2);
        }
    }
    var traceStateDsc = traceState === null || traceState === void 0 ? void 0 : traceState.get("sentry.dsc");
    var dscOnTraceState = traceStateDsc && (0, $0885d9483190850a$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    var dsc = $0d1fd6101086a96b$export$366bad00d6815eed(span.spanContext().traceId, client);
    var _rootSpanAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
    var source = (_rootSpanAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = rootSpanAttributes[0, $5d82adaea61c8fa9$export$d7a7d984b0791405]) !== null && _rootSpanAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE !== void 0 ? _rootSpanAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE : rootSpanAttributes["sentry.segment.name.source"];
    var name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ((0, $ffb01f703f29801c$export$1f70765132c3c225)()) {
        var // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        _getCapturedScopesOnSpan_scope;
        dsc.sampled = String((0, $79515206909fddff$export$5caecac1caaf3a71)(rootSpan));
        var // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        _traceState_get1;
        dsc.sample_rand = (_traceState_get1 = traceState === null || traceState === void 0 ? void 0 : traceState.get("sentry.sample_rand")) !== null && _traceState_get1 !== void 0 ? _traceState_get1 : (_getCapturedScopesOnSpan_scope = (0, $4ef71f79add55d26$export$c08fbc656a245d03)(rootSpan).scope) === null || _getCapturedScopesOnSpan_scope === void 0 ? void 0 : _getCapturedScopesOnSpan_scope.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $0d1fd6101086a96b$export$95cf936fdacaff7b(span) {
    var dsc = $0d1fd6101086a96b$export$a117f995597e25df(span);
    return (0, $0885d9483190850a$export$56766feef403f365)(dsc);
}



var $a7a5fd8a48375ca8$var$WINDOW = (0, $6001140c9a325157$export$f1a6cdb1459e81d1);
var $a7a5fd8a48375ca8$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $a7a5fd8a48375ca8$export$5647df6b7814ac86(elem) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!elem) return "<unknown>";
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr;
        var keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        var maxStringLength = !Array.isArray(options) && options.maxStringLength || $a7a5fd8a48375ca8$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $a7a5fd8a48375ca8$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (e) {
        return "<unknown>";
    }
}
function $a7a5fd8a48375ca8$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    if (!(elem === null || elem === void 0 ? void 0 : elem.tagName)) return "";
    if ($a7a5fd8a48375ca8$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    var keyAttrPairs = (keyAttrs === null || keyAttrs === void 0 ? void 0 : keyAttrs.length) ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs === null || keyAttrPairs === void 0 ? void 0 : keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[".concat(keyAttrPair[0], '="').concat(keyAttrPair[1], '"]'));
    });
    else {
        if (elem.id) out.push("#".concat(elem.id));
        var className = elem.className;
        if (className && (0, $6ea82c15e37d9720$export$844ec244b1367d54)(className)) {
            var classes = className.split(/\s+/);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = classes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var c = _step.value;
                    out.push(".".concat(c));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    for(var _i = 0, _iter = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]; _i < _iter.length; _i++){
        var k = _iter[_i];
        var attr = elem.getAttribute(k);
        if (attr) out.push("[".concat(k, '="').concat(attr, '"]'));
    }
    return out.join("");
}
function $a7a5fd8a48375ca8$export$1cfafeee2987818b() {
    try {
        return $a7a5fd8a48375ca8$var$WINDOW.document.location.href;
    } catch (e) {
        return "";
    }
}
function $a7a5fd8a48375ca8$export$26727cfcc4d7e0fc(elem) {
    var maxTraverseHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    if (!$a7a5fd8a48375ca8$var$WINDOW.HTMLElement) return null;
    var currentElem = elem;
    for(var i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

function $a0e1c0749ad8282c$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === "stream";
}


var $dUlz9 = parcelRequire("dUlz9");
var $117bb525af114730$export$b60c5e9f9b7b58bd = "ai.citations", $117bb525af114730$export$cc06afd6de7f2c10 = "ai.completion_tokens.used", $117bb525af114730$export$ced6746028fe2cc = "ai.documents", $117bb525af114730$export$e6f4aa4f4fcb6da8 = "ai.finish_reason", $117bb525af114730$export$f02d892201cd8d36 = "ai.frequency_penalty", $117bb525af114730$export$f277a7ef9e273960 = "ai.function_call", $117bb525af114730$export$1a8c212c3becaa80 = "ai.generation_id", $117bb525af114730$export$721b137086c68a47 = "ai.input_messages", $117bb525af114730$export$6afde2bb69d9aa86 = "ai.is_search_required", $117bb525af114730$export$eadb4b562c974031 = "ai.metadata", $117bb525af114730$export$22a90f0ac1eee843 = "ai.model_id", $117bb525af114730$export$a727f215a0be1dad = "ai.model.provider", $117bb525af114730$export$536bc61b34d995e5 = "ai.pipeline.name", $117bb525af114730$export$c43ea6115b380e62 = "ai.preamble", $117bb525af114730$export$d2a16e26bada7cf1 = "ai.presence_penalty", $117bb525af114730$export$604eb1bd2278163b = "ai.prompt_tokens.used", $117bb525af114730$export$2f8568696c5aa352 = "ai.raw_prompting", $117bb525af114730$export$ccc8efd7dd31d3a9 = "ai.responses", $117bb525af114730$export$e176bf5dc45e40df = "ai.response_format", $117bb525af114730$export$c4ea01fd53f64e16 = "ai.search_queries", $117bb525af114730$export$bb5e6f2f31a15da9 = "ai.search_results", $117bb525af114730$export$1762c11b666b026a = "ai.seed", $117bb525af114730$export$14ddd4b729910100 = "ai.streaming", $117bb525af114730$export$5311d7c8e1f8eabb = "ai.tags", $117bb525af114730$export$2b748b9eca00828b = "ai.temperature", $117bb525af114730$export$5af25308c11addea = "ai.texts", $117bb525af114730$export$28f78b3b1663cb92 = "ai.tools", $117bb525af114730$export$a1d3f09f0f1f066f = "ai.tool_calls", $117bb525af114730$export$322bd4ea9f163663 = "ai.top_k", $117bb525af114730$export$95711b9e669edad8 = "ai.top_p", $117bb525af114730$export$5924d7d72384626a = "ai.total_cost", $117bb525af114730$export$db3b1b877a4ce4db = "ai.total_tokens.used", $117bb525af114730$export$a434a3e8afec2879 = "ai.warnings", $117bb525af114730$export$fe00bb20636d42af = "angular.version", $117bb525af114730$export$712aa698b7ee271e = "app.app_build", $117bb525af114730$export$1fac638b11ec16d9 = "app.app_identifier", $117bb525af114730$export$d132016ea64058e3 = "app.app_name", $117bb525af114730$export$53f2f47ec3b2f9ed = "app.app_start_time", $117bb525af114730$export$9f80c4b11053cef1 = "app.app_version", $117bb525af114730$export$5f7a08466d84e877 = "app.build", $117bb525af114730$export$2cea7f14750b8c19 = "app.identifier", $117bb525af114730$export$34c59270f032a6c6 = "app.in_foreground", $117bb525af114730$export$5b6c28c7dca07ad7 = "app.name", $117bb525af114730$export$1dc8ae58b58d6c50 = "app_start_cold", $117bb525af114730$export$ba267414e3c0d822 = "app.start_time", $117bb525af114730$export$71b176005902b99e = "app_start_type", $117bb525af114730$export$5c5b5a3c245a0079 = "app_start_warm", $117bb525af114730$export$8ee1df3c6367a60 = "app.version", $117bb525af114730$export$e8c7802ae95beccf = "app.vitals.frames.delay.value", $117bb525af114730$export$bb237734da4d464 = "app.vitals.frames.frozen.count", $117bb525af114730$export$cdaaf6d1fdcba0b6 = "app.vitals.frames.slow.count", $117bb525af114730$export$36223ebd4a30e9f5 = "app.vitals.frames.total.count", $117bb525af114730$export$8feaa177bb7941e2 = "app.vitals.start.cold.value", $117bb525af114730$export$e1ca25240db91d68 = "app.vitals.start.prewarmed", $117bb525af114730$export$404a223fd1ada08b = "app.vitals.start.reason", $117bb525af114730$export$53362079310c68 = "app.vitals.start.screen", $117bb525af114730$export$3efb5af0ac379f77 = "app.vitals.start.type", $117bb525af114730$export$2c10c1ca0612c46d = "app.vitals.start.warm.value", $117bb525af114730$export$bbb86ad4d6654da6 = "app.vitals.ttfd.value", $117bb525af114730$export$ad6896f00a2b1076 = "app.vitals.ttid.value", $117bb525af114730$export$300f39d8506a273d = "art.gc.blocking_count", $117bb525af114730$export$ecaa0e7f4773ddc7 = "art.gc.blocking_time", $117bb525af114730$export$74b78acb4c54c06b = "art.gc.pre_oome_count", $117bb525af114730$export$b15b2c133bc50e33 = "art.gc.total_count", $117bb525af114730$export$5f1381d9ae1b1c95 = "art.gc.total_time", $117bb525af114730$export$c170b7ff277132ea = "art.gc.waiting_time", $117bb525af114730$export$9459a5df93695e45 = "art.memory.free", $117bb525af114730$export$a7902bd57492ebe8 = "art.memory.free_until_gc", $117bb525af114730$export$d2ace0da59da09b7 = "art.memory.free_until_oome", $117bb525af114730$export$c15dd8d2461e0aeb = "art.memory.max", $117bb525af114730$export$5405b0a98e00e538 = "art.memory.total", $117bb525af114730$export$5d9f28f388f552d2 = "aws.cloudwatch.logs.log_group", $117bb525af114730$export$b3d2f68e0e769504 = "aws.cloudwatch.logs.log_stream", $117bb525af114730$export$2c98412ed43013e8 = "aws.cloudwatch.logs.url", $117bb525af114730$export$a7bd794d11c19f1b = "aws.dynamodb.attribute_definitions", $117bb525af114730$export$df4227832b83fdd0 = "aws.dynamodb.consistent_read", $117bb525af114730$export$f131a6d8fbc0534f = "aws.dynamodb.consumed_capacity", $117bb525af114730$export$9bdc66d4a70e7e3a = "aws.dynamodb.count", $117bb525af114730$export$bfbbc3cbcaa90e98 = "aws.dynamodb.exclusive_start_table", $117bb525af114730$export$3565fa72459aa4d6 = "aws.dynamodb.global_secondary_indexes", $117bb525af114730$export$bb67a834ae4bffdc = "aws.dynamodb.global_secondary_index_updates", $117bb525af114730$export$4a06c859a283f06 = "aws.dynamodb.index_name", $117bb525af114730$export$68324fac2038d0f2 = "aws.dynamodb.item_collection_metrics", $117bb525af114730$export$5e1bd62ffd2786fb = "aws.dynamodb.limit", $117bb525af114730$export$bfdf2261058f56b = "aws.dynamodb.local_secondary_indexes", $117bb525af114730$export$23bf57842d9d53df = "aws.dynamodb.projection", $117bb525af114730$export$bfbd7e060eeb4d35 = "aws.dynamodb.provisioned_read_capacity", $117bb525af114730$export$82eb6cccda27c3ff = "aws.dynamodb.provisioned_write_capacity", $117bb525af114730$export$8ea68734d455808f = "aws.dynamodb.scanned_count", $117bb525af114730$export$40050e29324d44ee = "aws.dynamodb.scan_forward", $117bb525af114730$export$5cd7541006d9f467 = "aws.dynamodb.segment", $117bb525af114730$export$81c017edd95d692e = "aws.dynamodb.select", $117bb525af114730$export$120b3897a58cf903 = "aws.dynamodb.table_count", $117bb525af114730$export$d4a9de43b4b1076c = "aws.dynamodb.table_names", $117bb525af114730$export$f37f4f9022f1ab17 = "aws.dynamodb.total_segments", $117bb525af114730$export$66ac18da14747cfb = "aws.extended_request_id", $117bb525af114730$export$9e49b833525ca49d = "aws.kinesis.stream_name", $117bb525af114730$export$247839c65766758 = "aws.kinesis.stream.name", $117bb525af114730$export$b084fea5b3097227 = "aws.lambda.aws_request_id", $117bb525af114730$export$e09cd8615652e8d0 = "aws.lambda.execution_duration_in_millis", $117bb525af114730$export$a43a60ec723a90ee = "aws.lambda.function_name", $117bb525af114730$export$34cc955357266287 = "aws.lambda.function_version", $117bb525af114730$export$d9dd218693ea9bba = "aws.lambda.invoked_arn", $117bb525af114730$export$c9649b7156282a2f = "aws.lambda.invoked_function_arn", $117bb525af114730$export$daa8ce1f8adc553e = "aws.lambda.remaining_time_in_millis", $117bb525af114730$export$cb93c7b05db202cf = "aws.log.group.names", $117bb525af114730$export$930f9bd3cc2e5b3d = "aws.log.stream.names", $117bb525af114730$export$48c6d4c44afdc0b = "aws.request.extended_id", $117bb525af114730$export$c78d41789fe4b1e4 = "aws.request_id", $117bb525af114730$export$f4d52b02df927d54 = "aws.request.id", $117bb525af114730$export$f462d9921f1f7332 = "aws.s3.bucket", $117bb525af114730$export$bc71f8df9a45e243 = "aws.secretsmanager.secret.arn", $117bb525af114730$export$ed840ec4a5f5d053 = "aws.sns.topic.arn", $117bb525af114730$export$c1a559a4f74a5e8e = "aws.step_functions.activity.arn", $117bb525af114730$export$d1c007424092e3f5 = "aws.step_functions.state_machine.arn", $117bb525af114730$export$9ebb466ce954c49c = "blocked_main_thread", $117bb525af114730$export$e9aafc7348984403 = "browser.name", $117bb525af114730$export$faaa46964f075237 = "browser.performance.navigation.activation_start", $117bb525af114730$export$d28c4b3cc4431a87 = "browser.performance.time_origin", $117bb525af114730$export$734b017b330c8fe6 = "browser.report.type", $117bb525af114730$export$683ebdc48ba3758d = "browser.script.invoker", $117bb525af114730$export$be0263971250ef44 = "browser.script.invoker_type", $117bb525af114730$export$36a0cbc35c405232 = "browser.script.source_char_position", $117bb525af114730$export$469f7765ba335497 = "browser.version", $117bb525af114730$export$fe6fe2b7af051610 = "browser.web_vital.cls.report_event", $117bb525af114730$export$8345821877c4dfad = "browser.web_vital.cls.source.<key>", $117bb525af114730$export$f6c188a7e02335cf = "browser.web_vital.cls.source", $117bb525af114730$export$aaf709a8971e825f = "browser.web_vital.cls.value", $117bb525af114730$export$def01b82f8c092f7 = "browser.web_vital.fcp.value", $117bb525af114730$export$23d4264c606a73a6 = "browser.web_vital.fp.value", $117bb525af114730$export$af9ece53bb92f66b = "browser.web_vital.inp.value", $117bb525af114730$export$25421625a565b69 = "browser.web_vital.lcp.element", $117bb525af114730$export$ab0c90d873e69ccb = "browser.web_vital.lcp.id", $117bb525af114730$export$538c05cc8cb2a2bb = "browser.web_vital.lcp.load_time", $117bb525af114730$export$f86df4de196e1a7c = "browser.web_vital.lcp.render_time", $117bb525af114730$export$51e8aa8c0d65e7b8 = "browser.web_vital.lcp.report_event", $117bb525af114730$export$99023486ecc470bd = "browser.web_vital.lcp.size", $117bb525af114730$export$2f6c85eaf382e81 = "browser.web_vital.lcp.url", $117bb525af114730$export$1158d57c0aed42be = "browser.web_vital.lcp.value", $117bb525af114730$export$d85c4f947ab776e3 = "browser.web_vital.ttfb.request_time", $117bb525af114730$export$813ef8386d874918 = "browser.web_vital.ttfb.value", $117bb525af114730$export$7c2f74ff9251f64 = "cache.hit", $117bb525af114730$export$993f84dab107b880 = "cache.item_size", $117bb525af114730$export$7b9c2315e94d8d2f = "cache.key", $117bb525af114730$export$f01e5cd42b9ec146 = "cache.operation", $117bb525af114730$export$987f6b4367434b55 = "cache.ttl", $117bb525af114730$export$d9d145585d5022bb = "cache.write", $117bb525af114730$export$44ffba16bd48dac6 = "channel", $117bb525af114730$export$3134892c5d2e251a = "client.address", $117bb525af114730$export$8495028d10296058 = "client.port", $117bb525af114730$export$d6d0e4fcf46d490c = "cloudflare.d1.duration", $117bb525af114730$export$658dced473c19301 = "cloudflare.d1.query_type", $117bb525af114730$export$97b0f9c3fbe64076 = "cloudflare.d1.rows_read", $117bb525af114730$export$cf2c95ed5efbe9eb = "cloudflare.d1.rows_written", $117bb525af114730$export$880007904f61a388 = "cloudflare.durable_object.query.bindings", $117bb525af114730$export$3e903b72d4d9e07d = "cloudflare.durable_object.response.rows_read", $117bb525af114730$export$34da07180e0e56af = "cloudflare.durable_object.response.rows_written", $117bb525af114730$export$c49aafdaeb061953 = "cloudflare.r2.bucket", $117bb525af114730$export$ceb762c61de2f17f = "cloudflare.r2.operation", $117bb525af114730$export$a5f54ccfb28c0caf = "cloudflare.r2.request.delimiter", $117bb525af114730$export$1c86a56857b024db = "cloudflare.r2.request.key", $117bb525af114730$export$7598f3464be47440 = "cloudflare.r2.request.part_number", $117bb525af114730$export$b673289c971fc0ae = "cloudflare.r2.request.prefix", $117bb525af114730$export$98b23f3e6f0c2a6f = "cloudflare.workflow.attempt", $117bb525af114730$export$6ddeaf0498614ebb = "cloudflare.workflow.retries.backoff", $117bb525af114730$export$97b78f78d64a7232 = "cloudflare.workflow.retries.delay", $117bb525af114730$export$5147715be870fff7 = "cloudflare.workflow.retries.limit", $117bb525af114730$export$5276bb46e6096fba = "cloudflare.workflow.timeout", $117bb525af114730$export$cbcbc1f67a937cf3 = "cloud.account.id", $117bb525af114730$export$226a2381b8f0cf78 = "cloud.availability_zone", $117bb525af114730$export$fd35512cae286064 = "cloud.platform", $117bb525af114730$export$de9bbf95ab1d81e = "cloud.provider", $117bb525af114730$export$47fb20e8d18d7d15 = "cloud.region", $117bb525af114730$export$9db7964e4b8cb849 = "cloud.resource_id", $117bb525af114730$export$7139adf9d3bace41 = "cls", $117bb525af114730$export$8ac3d09060e7f25d = "cls.source.<key>", $117bb525af114730$export$dad0e4778ea23971 = "cls.source", $117bb525af114730$export$c14d903ccf9385a8 = "code.filepath", $117bb525af114730$export$934cded0041affd7 = "code.file.path", $117bb525af114730$export$6386da1dcba88c9d = "code.function", $117bb525af114730$export$a3371797e606e2 = "code.function.name", $117bb525af114730$export$a5bbef0af83b23e5 = "code.lineno", $117bb525af114730$export$91ed1f55874222a6 = "code.line.number", $117bb525af114730$export$23de81068d2aed1b = "code.namespace", $117bb525af114730$export$d738320e1fba9e9d = "connectionType", $117bb525af114730$export$2eacdea75497e8a5 = "connection.rtt", $117bb525af114730$export$2bc3ea101f86c1d2 = "culture.calendar", $117bb525af114730$export$c54e27e8d90ee081 = "culture.display_name", $117bb525af114730$export$4943adcec371c2a6 = "culture.is_24_hour_format", $117bb525af114730$export$f000a5900d0480c2 = "culture.locale", $117bb525af114730$export$8f5234893868273b = "culture.timezone", $117bb525af114730$export$1a35518f6e81e8c7 = "db.collection.name", $117bb525af114730$export$a2d90911eaae60fc = "db.driver.name", $117bb525af114730$export$3c22ff8b64b8f565 = "db.name", $117bb525af114730$export$b8019c0e2a5b5f0f = "db.namespace", $117bb525af114730$export$8c11477e471467c8 = "db.operation", $117bb525af114730$export$92a96f6363488aee = "db.operation.batch.size", $117bb525af114730$export$f91beb6088f9ded9 = "db.operation.name", $117bb525af114730$export$78bc7224576bf289 = "db.query.parameter.<key>", $117bb525af114730$export$a8027e0ea0d93ca = "db.query.parameter", $117bb525af114730$export$5e59d3aea52e5037 = "db.query.summary", $117bb525af114730$export$47e408be0da7933f = "db.query.text", $117bb525af114730$export$d5772b934ca13e57 = "db.redis.connection", $117bb525af114730$export$36e47f6a5777561d = "db.redis.key", $117bb525af114730$export$e768cbc99cd68acf = "db.redis.parameters", $117bb525af114730$export$dfcc6c69df1343f2 = "db.response.status_code", $117bb525af114730$export$69b0a5d9226b5211 = "db.sql.bindings", $117bb525af114730$export$da010a4f4fc971ae = "db.statement", $117bb525af114730$export$5d515b35be0601a0 = "db.stored_procedure.name", $117bb525af114730$export$3e1b1037a315c5ca = "db.system", $117bb525af114730$export$847fdd494825f0fb = "db.system.name", $117bb525af114730$export$a9d76f26c6c730a9 = "db.user", $117bb525af114730$export$de03f86d1c9866ca = "deviceMemory", $117bb525af114730$export$65798ecab7eef8c = "device.archs", $117bb525af114730$export$22aa61f48b9c79a0 = "device.battery_level", $117bb525af114730$export$69f5fb98f5aed812 = "device.battery_temperature", $117bb525af114730$export$bdea5d1006fd280a = "device.boot_time", $117bb525af114730$export$f63a7230c5b1d609 = "device.brand", $117bb525af114730$export$6f25e59b05bb8e17 = "device.charging", $117bb525af114730$export$a56ad13c4afc7421 = "device.chipset", $117bb525af114730$export$d9ce89ce8912bf12 = "device.class", $117bb525af114730$export$17094e5f380e4162 = "device.connection_type", $117bb525af114730$export$28a0ffdf747973a0 = "device.cpu_description", $117bb525af114730$export$5480ae1ba5d50bb9 = "device.external_free_storage", $117bb525af114730$export$edc72ee4a17f5152 = "device.external_storage_size", $117bb525af114730$export$19e4df138d354f8b = "device.family", $117bb525af114730$export$92b0d20fa482b4b2 = "device.free_memory", $117bb525af114730$export$3f638a793d61933f = "device.free_storage", $117bb525af114730$export$3f511731cc3687d4 = "device.id", $117bb525af114730$export$692b08741d6b6265 = "device.locale", $117bb525af114730$export$cf67f8cb2324428e = "device.low_memory", $117bb525af114730$export$9d4197c1ffc5f359 = "device.low_power_mode", $117bb525af114730$export$509634fbff540e75 = "device.manufacturer", $117bb525af114730$export$ccbc4fdff4b5eff5 = "device.memory.estimated_capacity", $117bb525af114730$export$e0cb371ca548b1d6 = "device.memory_size", $117bb525af114730$export$3c39026d09026bc2 = "device.model", $117bb525af114730$export$bf9e8248cb72cf00 = "device.model_id", $117bb525af114730$export$1054f22a72121d0f = "device.name", $117bb525af114730$export$723b8a59dad2e467 = "device.online", $117bb525af114730$export$160081ff141bac8e = "device.orientation", $117bb525af114730$export$194f62c84d27310 = "device.processor_count", $117bb525af114730$export$7ed866d57b018d09 = "device.processor_frequency", $117bb525af114730$export$d50bae4562e03e5 = "device.screen_density", $117bb525af114730$export$649ea67a18fe8e8b = "device.screen_dpi", $117bb525af114730$export$136a5c1b43caaccd = "device.screen_height_pixels", $117bb525af114730$export$e33a28ea554b6ddc = "device.screen_width_pixels", $117bb525af114730$export$acbe2d25ac76ea64 = "device.simulator", $117bb525af114730$export$793c13e17d7e5e2b = "device.storage_size", $117bb525af114730$export$a5617e33b89fd956 = "device.thermal_state", $117bb525af114730$export$b51f82164fa31e07 = "device.timezone", $117bb525af114730$export$f2ef55183c04d202 = "device.usable_memory", $117bb525af114730$export$7c98fc0c48a16b1c = "dist", $117bb525af114730$export$f0511e328234ae83 = "effectiveConnectionType", $117bb525af114730$export$be46596bc6608f3b = "environment", $117bb525af114730$export$f215947b3d76a6b7 = "error.type", $117bb525af114730$export$89bbc91416db6670 = "event.id", $117bb525af114730$export$b4b5eff8a8712c89 = "event.name", $117bb525af114730$export$f455969a57ab8a03 = "exception.escaped", $117bb525af114730$export$13f2f8f42af49cec = "exception.message", $117bb525af114730$export$cd357afe2ffdd2c3 = "exception.stacktrace", $117bb525af114730$export$d9ca2a279a11be5e = "exception.type", $117bb525af114730$export$bbd59a8c7efad4c9 = "faas.coldstart", $117bb525af114730$export$8413282a17f1cda5 = "faas.cron", $117bb525af114730$export$30d19ddc7705e7e8 = "faas.duration_in_ms", $117bb525af114730$export$64a4f09e2444b3d = "faas.entry_point", $117bb525af114730$export$645b039fe163809e = "faas.execution", $117bb525af114730$export$b23ef8b8ffa607e1 = "faas.id", $117bb525af114730$export$8bf64516740c1369 = "faas.identity", $117bb525af114730$export$9a0dc8e612f3e10b = "faas.invocation_id", $117bb525af114730$export$abe90fedb3dddda2 = "faas.invoked_name", $117bb525af114730$export$4a19da9c85ed2ade = "faas.invoked_provider", $117bb525af114730$export$5e091479f094bdbc = "faas.invoked_region", $117bb525af114730$export$d70909b5aa96a79a = "faas.name", $117bb525af114730$export$651d142a8017d83d = "faas.time", $117bb525af114730$export$44382a010a9f7fcf = "faas.trigger", $117bb525af114730$export$807abfdc6b7b9338 = "faas.version", $117bb525af114730$export$31881d07f2569218 = "fcp", $117bb525af114730$export$e5bbf306deb709a6 = "flag.evaluation.<key>", $117bb525af114730$export$aa8721167c5c8d2d = "flag.evaluation", $117bb525af114730$export$757b93e5b3adc7cb = "fp", $117bb525af114730$export$f869eaa92db1dc9b = "frames.delay", $117bb525af114730$export$5d1d761e41c32d9e = "frames.frozen", $117bb525af114730$export$8aec72d9491f9399 = "frames_frozen_rate", $117bb525af114730$export$5562635d2be2ab25 = "frames.slow", $117bb525af114730$export$2dc31837ce6f7a3d = "frames_slow_rate", $117bb525af114730$export$b561df15f64d32e3 = "frames.total", $117bb525af114730$export$181f78b28f2ffa57 = "fs_error", $117bb525af114730$export$6c97c77b89571c75 = "gcp.function.context.event_id", $117bb525af114730$export$51e431eaf1f9bf58 = "gcp.function.context.event_type", $117bb525af114730$export$71429c7ef7cb7063 = "gcp.function.context.id", $117bb525af114730$export$99905d7583a6e8ac = "gcp.function.context.resource", $117bb525af114730$export$b6c4be74fd0c06bd = "gcp.function.context.source", $117bb525af114730$export$fd23e5b8d261a89 = "gcp.function.context.specversion", $117bb525af114730$export$25fabc9b3d1dd567 = "gcp.function.context.time", $117bb525af114730$export$41507f7b07dad151 = "gcp.function.context.timestamp", $117bb525af114730$export$1352f3699c35dd73 = "gcp.function.context.type", $117bb525af114730$export$fd6c9d5c74d943ac = "gcp.project.id", $117bb525af114730$export$c29634e3cf41e479 = "gen_ai.agent.name", $117bb525af114730$export$e6a60882cce7a085 = "gen_ai.context.utilization", $117bb525af114730$export$6773c9098ba5e194 = "gen_ai.context.window_size", $117bb525af114730$export$6ee6b62f50047686 = "gen_ai.conversation.id", $117bb525af114730$export$efac052bb3661242 = "gen_ai.cost.cache_creation.input_tokens", $117bb525af114730$export$7ccd63b9ca955862 = "gen_ai.cost.cache_read.input_tokens", $117bb525af114730$export$50921df5a58cb3ef = "gen_ai.cost.input_tokens", $117bb525af114730$export$8e48efc7acb57a97 = "gen_ai.cost.output_tokens", $117bb525af114730$export$cea9121727113f77 = "gen_ai.cost.reasoning.output_tokens", $117bb525af114730$export$bed35ff7f9af3aaa = "gen_ai.cost.total_tokens", $117bb525af114730$export$6b729e898b9067ce = "gen_ai.embeddings.input", $117bb525af114730$export$984fbab9b52f7e24 = "gen_ai.function_id", $117bb525af114730$export$9ea17906a87ada6f = "gen_ai.input.messages", $117bb525af114730$export$394b443aaff3ef92 = "gen_ai.operation.name", $117bb525af114730$export$6ddc374adbc06720 = "gen_ai.operation.type", $117bb525af114730$export$ab8c7ebc9add56b2 = "gen_ai.output.messages", $117bb525af114730$export$40ecc5bcd633d1ee = "gen_ai.pipeline.name", $117bb525af114730$export$86a8df7fff52fc69 = "gen_ai.prompt", $117bb525af114730$export$cf2115d46768f4c5 = "gen_ai.prompt.name", $117bb525af114730$export$3d7e036e195764db = "gen_ai.provider.name", $117bb525af114730$export$60c1d11221608cee = "gen_ai.request.available_tools", $117bb525af114730$export$bc3cef164abbc42c = "gen_ai.request.frequency_penalty", $117bb525af114730$export$43f9afb62cd79dec = "gen_ai.request.max_tokens", $117bb525af114730$export$a5ab4ffc4765f75f = "gen_ai.request.messages", $117bb525af114730$export$ccf46db9ab1743ec = "gen_ai.request.model", $117bb525af114730$export$76c1c247342d776 = "gen_ai.request.presence_penalty", $117bb525af114730$export$92f5944f0b02c9fb = "gen_ai.request.reasoning_effort", $117bb525af114730$export$867eeefcb1c95b27 = "gen_ai.request.seed", $117bb525af114730$export$5ada4697ae6aa17e = "gen_ai.request.stop_sequences", $117bb525af114730$export$427122300e8d54d0 = "gen_ai.request.temperature", $117bb525af114730$export$bcea8881375c352f = "gen_ai.request.top_k", $117bb525af114730$export$b867715f9a0c04e9 = "gen_ai.request.top_p", $117bb525af114730$export$69878a39cbdbe097 = "gen_ai.response.finish_reasons", $117bb525af114730$export$584c61a1b769552d = "gen_ai.response.id", $117bb525af114730$export$8169ebcb0b0331dd = "gen_ai.response.model", $117bb525af114730$export$2c9713b624877853 = "gen_ai.response.streaming", $117bb525af114730$export$45942692aeb454e0 = "gen_ai.response.text", $117bb525af114730$export$8e5efeaa031210cd = "gen_ai.response.time_to_first_chunk", $117bb525af114730$export$35a62769ee05a05a = "gen_ai.response.time_to_first_token", $117bb525af114730$export$8ea4f7e986ca4b06 = "gen_ai.response.tokens_per_second", $117bb525af114730$export$d2fd9ecaff0285a4 = "gen_ai.response.tool_calls", $117bb525af114730$export$a6c8e656a4f9bb67 = "gen_ai.system", $117bb525af114730$export$352a8075b163d53 = "gen_ai.system_instructions", $117bb525af114730$export$426d7b90ba5d79db = "gen_ai.system.message", $117bb525af114730$export$f5a1ee40934d19ce = "gen_ai.tool.call.arguments", $117bb525af114730$export$1ba812a9756622ce = "gen_ai.tool.call.result", $117bb525af114730$export$351120039c36e03 = "gen_ai.tool.definitions", $117bb525af114730$export$d42aa25ca09e17c4 = "gen_ai.tool.description", $117bb525af114730$export$d268db29b88a4286 = "gen_ai.tool.input", $117bb525af114730$export$c5deb6018f2d6251 = "gen_ai.tool.message", $117bb525af114730$export$e06baa3034409453 = "gen_ai.tool.name", $117bb525af114730$export$646fdb5910ce3931 = "gen_ai.tool.output", $117bb525af114730$export$662e3d2d4361e29b = "gen_ai.tool.type", $117bb525af114730$export$1de3962f221ba441 = "gen_ai.usage.cache_creation.input_tokens", $117bb525af114730$export$a4b3f0f5499c8738 = "gen_ai.usage.cache_read.input_tokens", $117bb525af114730$export$1aecdac6cecbdc5b = "gen_ai.usage.completion_tokens", $117bb525af114730$export$2eb2ab35b317a103 = "gen_ai.usage.input_tokens", $117bb525af114730$export$c7e14ea195ede241 = "gen_ai.usage.input_tokens.cached", $117bb525af114730$export$41ac034e7b9725a2 = "gen_ai.usage.input_tokens.cache_write", $117bb525af114730$export$9e521119d7751e37 = "gen_ai.usage.output_tokens", $117bb525af114730$export$cbac8f541a64a150 = "gen_ai.usage.output_tokens.reasoning", $117bb525af114730$export$93dd08efa94c9dd4 = "gen_ai.usage.prompt_tokens", $117bb525af114730$export$183e3523dac20bca = "gen_ai.usage.reasoning.output_tokens", $117bb525af114730$export$3867ca1d8381d4e3 = "gen_ai.usage.total_tokens", $117bb525af114730$export$11febcf9917c0057 = "graphql.document", $117bb525af114730$export$88ae1ee0c0a63398 = "graphql.operation.name", $117bb525af114730$export$d5bd986d1f283f29 = "graphql.operation.type", $117bb525af114730$export$fc4a2d238535d998 = "hardwareConcurrency", $117bb525af114730$export$57e53a60bf563f41 = "http.client_ip", $117bb525af114730$export$ffdb1464deb0eedb = "http.decoded_response_content_length", $117bb525af114730$export$b52670c950fd640 = "http.flavor", $117bb525af114730$export$c499fd8f1db3d18e = "http.fragment", $117bb525af114730$export$b2ee2242301eff05 = "http.host", $117bb525af114730$export$2ebf9f7586f16841 = "http.method", $117bb525af114730$export$6e9ffd608b3e828b = "http.query", $117bb525af114730$export$b960c5a73a722e6c = "http.request.body.data", $117bb525af114730$export$a7a850351369c77e = "http.request.connection_end", $117bb525af114730$export$b18bca78f4736a94 = "http.request.connect_start", $117bb525af114730$export$61a0059f562fb6c2 = "http.request.domain_lookup_end", $117bb525af114730$export$7dc0d5aefb816d91 = "http.request.domain_lookup_start", $117bb525af114730$export$58f6db56c841bef6 = "http.request.fetch_start", $117bb525af114730$export$97a3da679f509d5 = "http.request.header.<key>", $117bb525af114730$export$c387ec65fd1c2638 = "http.request.header", $117bb525af114730$export$4d9db82211f308a4 = "http.request.method", $117bb525af114730$export$df30ee8c5b5f1989 = "http.request_method", $117bb525af114730$export$ee4948a3be025123 = "http.request.redirect_end", $117bb525af114730$export$e0021eb2979cddaa = "http.request.redirect_start", $117bb525af114730$export$7c0ac0c19a45beac = "http.request.request_start", $117bb525af114730$export$6c32e9d84f534ee = "http.request.resend_count", $117bb525af114730$export$d1f9fbdb211dd29b = "http.request.response_end", $117bb525af114730$export$45e7eea99a17d6e4 = "http.request.response_start", $117bb525af114730$export$20ea34e16c0aa64f = "http.request.same_origin", $117bb525af114730$export$8365b0f03557fae9 = "http.request.secure_connection_start", $117bb525af114730$export$49ebbb9621675650 = "http.request.time_to_first_byte", $117bb525af114730$export$842be66a901f093 = "http.request.worker_start", $117bb525af114730$export$a9f5a6cb28adccb1 = "http.response.body.size", $117bb525af114730$export$57b055d4bc586d67 = "http.response_content_length", $117bb525af114730$export$3ddfd660caa7bf7a = "http.response.header.content-length", $117bb525af114730$export$fa7e1f5305153b3d = "http.response.header.<key>", $117bb525af114730$export$5674ce9d013eb7bd = "http.response.header", $117bb525af114730$export$6e8dc14cff6ccf72 = "http.response.size", $117bb525af114730$export$afd59480458e1b57 = "http.response.status_code", $117bb525af114730$export$48e61fb9bccccba9 = "http.response_transfer_size", $117bb525af114730$export$d3e674514dd3a3e1 = "http.route", $117bb525af114730$export$97ad02b50c60ef68 = "http.scheme", $117bb525af114730$export$61d053b1b63e82c4 = "http.server_name", $117bb525af114730$export$54256cce0d674dea = "http.server.request.time_in_queue", $117bb525af114730$export$8c01f0f407bcc5ca = "http.status_code", $117bb525af114730$export$be3f46982f6c7160 = "http.target", $117bb525af114730$export$778e4213e2788579 = "http.url", $117bb525af114730$export$8b48ca3594d2b172 = "http.user_agent", $117bb525af114730$export$8be180ec26319f9f = "id", $117bb525af114730$export$60eccaddefa8fc1c = "inp", $117bb525af114730$export$c99ce4fe37484d84 = "jsonrpc.protocol.version", $117bb525af114730$export$fdf432fcac7d8f37 = "jsonrpc.request.id", $117bb525af114730$export$4c21cc9cdf2f5dbd = "jvm.gc.action", $117bb525af114730$export$dcc1eab7f3f31816 = "jvm.gc.name", $117bb525af114730$export$dcb7f1379b2b8f86 = "jvm.memory.pool.name", $117bb525af114730$export$53416edeea4c2d74 = "jvm.memory.type", $117bb525af114730$export$69f7e5d2b74c5c9e = "jvm.thread.daemon", $117bb525af114730$export$8e104aed582a26bc = "jvm.thread.state", $117bb525af114730$export$577047501949be9 = "koa.name", $117bb525af114730$export$c4c45b599a2c15e = "koa.type", $117bb525af114730$export$361cb541700d648e = "lcp", $117bb525af114730$export$974f160e11f25731 = "lcp.element", $117bb525af114730$export$7162f5c702b95903 = "lcp.id", $117bb525af114730$export$a034d066a9090500 = "lcp.loadTime", $117bb525af114730$export$70938021e43e047c = "lcp.renderTime", $117bb525af114730$export$5f6ac460012a73bb = "lcp.size", $117bb525af114730$export$d8e498c1c670bcbf = "lcp.url", $117bb525af114730$export$cc1a78a24d947903 = "logger.name", $117bb525af114730$export$d29b927e0bb0ffea = "mcp.cancelled.reason", $117bb525af114730$export$b3999cacef245779 = "mcp.cancelled.request_id", $117bb525af114730$export$ff168b5f9cf9dcf6 = "mcp.client.name", $117bb525af114730$export$2ab876a45bd6e64 = "mcp.client.title", $117bb525af114730$export$cb8027e4395c6c0e = "mcp.client.version", $117bb525af114730$export$f5303d1bac3c2660 = "mcp.lifecycle.phase", $117bb525af114730$export$6c463c5f3b00f64 = "mcp.logging.data_type", $117bb525af114730$export$e25d553065457cab = "mcp.logging.level", $117bb525af114730$export$15d24c154ea8a56f = "mcp.logging.logger", $117bb525af114730$export$e5065789a6c415d0 = "mcp.logging.message", $117bb525af114730$export$62662c561d7c7835 = "mcp.method.name", $117bb525af114730$export$218f394557fb0a5a = "mcp.progress.current", $117bb525af114730$export$2a5ff6de5448ecdf = "mcp.progress.message", $117bb525af114730$export$9d23f3030ed2597e = "mcp.progress.percentage", $117bb525af114730$export$a26ff217a6124160 = "mcp.progress.token", $117bb525af114730$export$c8072f5fcfdb5b77 = "mcp.progress.total", $117bb525af114730$export$c4e4b74f1ccf3d96 = "mcp.prompt.name", $117bb525af114730$export$328519d02a26ac41 = "mcp.prompt.result.description", $117bb525af114730$export$d2061b291c43d045 = "mcp.prompt.result.message_content", $117bb525af114730$export$d1f04dfd3d695286 = "mcp.prompt.result.message_count", $117bb525af114730$export$234fbd86ea0f0bd8 = "mcp.prompt.result.message_role", $117bb525af114730$export$e795000978a75b12 = "mcp.protocol.ready", $117bb525af114730$export$9f4683b4d1018ace = "mcp.protocol.version", $117bb525af114730$export$e431b042fcdb1d63 = "mcp.request.argument.<key>", $117bb525af114730$export$a453239171ac9a23 = "mcp.request.argument", $117bb525af114730$export$3a7726a976c18d5f = "mcp.request.argument.name", $117bb525af114730$export$7eca7a6c06843b93 = "mcp.request.argument.uri", $117bb525af114730$export$f25c55f83e5b0672 = "mcp.request.id", $117bb525af114730$export$9562bfac4eb079cb = "mcp.resource.protocol", $117bb525af114730$export$c276d164ff91d2f7 = "mcp.resource.uri", $117bb525af114730$export$2f3e0574f1a99754 = "mcp.server.name", $117bb525af114730$export$15eecaab68167880 = "mcp.server.title", $117bb525af114730$export$513c47f6e194086a = "mcp.server.version", $117bb525af114730$export$a3f464c4d5cd9096 = "mcp.session.id", $117bb525af114730$export$ed366a03a2330b03 = "mcp.tool.name", $117bb525af114730$export$9b802c784f235e1d = "mcp.tool.result.content", $117bb525af114730$export$add0fc8b8c5726a4 = "mcp.tool.result.content_count", $117bb525af114730$export$e7f32463f5bfd554 = "mcp.tool.result.is_error", $117bb525af114730$export$f9346f394edf26a = "mcp.transport", $117bb525af114730$export$16b917774e73ef92 = "mdc.<key>", $117bb525af114730$export$15d2b60bf3b65454 = "mdc", $117bb525af114730$export$db55eca5af256142 = "messaging.batch.message_count", $117bb525af114730$export$967c74f8b1f3d35 = "messaging.destination", $117bb525af114730$export$7c33ae67962515d1 = "messaging.destination.connection", $117bb525af114730$export$9c69839b2d93489b = "messaging.destination.name", $117bb525af114730$export$be22d22d4b6cf5d8 = "messaging.message.body.size", $117bb525af114730$export$c529961b911626ac = "messaging.message.conversation_id", $117bb525af114730$export$e39c4b15d2881f5 = "messaging.message.envelope.size", $117bb525af114730$export$a8ca145161313e7 = "messaging.message.id", $117bb525af114730$export$3c1204d03918d076 = "messaging.message.receive.latency", $117bb525af114730$export$eaac3f141165e288 = "messaging.message.retry.count", $117bb525af114730$export$4c7e6934714150e6 = "messaging.operation.name", $117bb525af114730$export$6f71f9711d666eb4 = "messaging.operation.type", $117bb525af114730$export$2a3cd2bb71fb63a4 = "messaging.rabbitmq.destination.routing_key", $117bb525af114730$export$55478a0b7d2ae98f = "messaging.system", $117bb525af114730$export$bed10c4da9b8eb0a = "method", $117bb525af114730$export$a82607b6424c06c8 = "middleware.name", $117bb525af114730$export$6b081f3484c7f4e5 = "navigation.origin", $117bb525af114730$export$b7754d85fd39406c = "navigation.route.id", $117bb525af114730$export$492856c046eb4728 = "navigation.type", $117bb525af114730$export$c1678a2059fbe906 = "nel.elapsed_time", $117bb525af114730$export$6d384a0bc1011c34 = "nel.phase", $117bb525af114730$export$1499a7dbfc01e7d4 = "nel.referrer", $117bb525af114730$export$cfcbff40019f0ff1 = "nel.sampling_function", $117bb525af114730$export$27157b5f68e583af = "nel.type", $117bb525af114730$export$54bf5ed61532925d = "network.connection.effective_type", $117bb525af114730$export$60ed0786292ace08 = "network.connection.rtt", $117bb525af114730$export$d770bfb8345e146 = "network.connection.type", $117bb525af114730$export$bb73817f1290ad28 = "network.local.address", $117bb525af114730$export$f201c980f2b75802 = "network.local.port", $117bb525af114730$export$b40e970572afd0ee = "network.peer.address", $117bb525af114730$export$8850630a3d343488 = "network.peer.port", $117bb525af114730$export$fd0a39a918d6516f = "network.protocol.name", $117bb525af114730$export$e68ef41f8e0335bf = "network.protocol.version", $117bb525af114730$export$5bff09650e762829 = "network.transport", $117bb525af114730$export$21c1adce0e067f37 = "network.type", $117bb525af114730$export$fed6ce86f48c84bc = "net.host.ip", $117bb525af114730$export$500c2675137ac16e = "net.host.name", $117bb525af114730$export$402c7728623fd8df = "net.host.port", $117bb525af114730$export$15417259f4c0fe6b = "net.peer.ip", $117bb525af114730$export$2b3b7f579a727f45 = "net.peer.name", $117bb525af114730$export$514832a0b029734b = "net.peer.port", $117bb525af114730$export$b0522e6a14dec1a4 = "net.protocol.name", $117bb525af114730$export$659ea19f71a7ee0b = "net.protocol.version", $117bb525af114730$export$1b61d972db315e73 = "net.sock.family", $117bb525af114730$export$fb2970ee11a479ee = "net.sock.host.addr", $117bb525af114730$export$920aceb2a8fad77e = "net.sock.host.port", $117bb525af114730$export$48f8f6fbc999d187 = "net.sock.peer.addr", $117bb525af114730$export$eed590fa00a8223b = "net.sock.peer.name", $117bb525af114730$export$f2e5bb5cd4a130da = "net.sock.peer.port", $117bb525af114730$export$779ef03d633a9086 = "net.transport", $117bb525af114730$export$d98b87c8d53d0dbc = "os.build", $117bb525af114730$export$ca719aa57653a0a7 = "os.build_id", $117bb525af114730$export$74b19c5f48270c05 = "os.description", $117bb525af114730$export$c351affe7e8098cb = "os.kernel_version", $117bb525af114730$export$be7cd6b3ae3ae765 = "os.name", $117bb525af114730$export$ec182524c4c57275 = "os.raw_description", $117bb525af114730$export$9e45758246a85b07 = "os.rooted", $117bb525af114730$export$9fa5d5f0144954cb = "os.theme", $117bb525af114730$export$e66ba5bc4b978023 = "os.type", $117bb525af114730$export$2306e23cc611a36d = "os.version", $117bb525af114730$export$144f8c1fe01428db = "otel.kind", $117bb525af114730$export$f303b2744d52121c = "otel.scope.name", $117bb525af114730$export$866b2dbc7bf18ce6 = "otel.scope.version", $117bb525af114730$export$b4c85774878b4841 = "otel.status_code", $117bb525af114730$export$1c967a71bc9a3077 = "otel.status_description", $117bb525af114730$export$5e3884a35a19eb90 = "params.<key>", $117bb525af114730$export$6e7ff99bb3259573 = "params", $117bb525af114730$export$7c932cba2d9e7a7 = "performance.activationStart", $117bb525af114730$export$94091942edce0667 = "performance.timeOrigin", $117bb525af114730$export$3671a8a524706a9d = "previous_route", $117bb525af114730$export$c288888dc82d233f = "process.command_args", $117bb525af114730$export$8ff188536cebc35 = "process.executable.name", $117bb525af114730$export$6407d78968c0eabe = "process.pid", $117bb525af114730$export$43e9fb9ec28d9743 = "process.runtime.description", $117bb525af114730$export$26f31d5c5c201739 = "process.runtime.engine.name", $117bb525af114730$export$bff85124d2d35b93 = "process.runtime.engine.version", $117bb525af114730$export$495c671ed5a6408c = "process.runtime.name", $117bb525af114730$export$54b3d4d5548c35c3 = "process.runtime.version", $117bb525af114730$export$2954db6444fe1fa8 = "query.<key>", $117bb525af114730$export$15c1c974d16dd678 = "query", $117bb525af114730$export$9be2ae89a1eac217 = "react.version", $117bb525af114730$export$5c698591c0e586a2 = "release", $117bb525af114730$export$b711f2bb9c9a848a = "remix.action_form_data.<key>", $117bb525af114730$export$1d3a8501efd30213 = "remix.action_form_data", $117bb525af114730$export$cebaf684ced5a2c9 = "replay_id", $117bb525af114730$export$d4c658ecdcb7c78c = "resource.deployment.environment", $117bb525af114730$export$b1b162b01baeb044 = "resource.deployment.environment.name", $117bb525af114730$export$8be2d593d7f88ed8 = "resource.render_blocking_status", $117bb525af114730$export$dbd0a3528a97ccc0 = "route", $117bb525af114730$export$66581dc6d3d083d1 = "rpc.grpc.status_code", $117bb525af114730$export$e545f99e7abcc499 = "rpc.method", $117bb525af114730$export$7e1af5787f8c4aaa = "rpc.response.status_code", $117bb525af114730$export$186c94c351c54768 = "rpc.service", $117bb525af114730$export$2e3fd8dfcb16fe0c = "rpc.system", $117bb525af114730$export$7eeeceaa1dbd7cd5 = "rpc.system.name", $117bb525af114730$export$9d5bffdff936d554 = "runtime.build", $117bb525af114730$export$dc3a801c9a2c5b79 = "runtime.name", $117bb525af114730$export$27933a9557f87e98 = "runtime.raw_description", $117bb525af114730$export$eefa737b40a0d535 = "runtime.version", $117bb525af114730$export$92740ffbcb02553b = "score.<key>", $117bb525af114730$export$500e89753f9f1008 = "score", $117bb525af114730$export$d91a18e47fdddefd = "score.ratio.<key>", $117bb525af114730$export$eccbe6f20884ea7f = "score.ratio", $117bb525af114730$export$9e24f11d79141afb = "score.total", $117bb525af114730$export$f0b96ad9586f8887 = "score.weight.<key>", $117bb525af114730$export$8a92ed5d436a85c6 = "score.weight", $117bb525af114730$export$edd59acdf7e86a71 = "sentry.action", $117bb525af114730$export$ae81a1ae71952d50 = "sentry.browser.name", $117bb525af114730$export$6101470cd57eac1b = "sentry.browser.version", $117bb525af114730$export$452c0aee9673fe67 = "sentry.cancellation_reason", $117bb525af114730$export$773dddd1e8667756 = "sentry.category", $117bb525af114730$export$98815f8579a64a90 = "sentry.client_sample_rate", $117bb525af114730$export$7bc4e27428665019 = "sentry.description", $117bb525af114730$export$e7d7477fa9057ee2 = "sentry.dist", $117bb525af114730$export$1f4267a3fc018448 = "sentry.domain", $117bb525af114730$export$c171cae150389952 = "sentry.dsc.environment", $117bb525af114730$export$d9bb35e957b22c72 = "sentry.dsc.project_id", $117bb525af114730$export$b3508a2c95f74e3d = "sentry.dsc.public_key", $117bb525af114730$export$20bb272f4d21532d = "sentry.dsc.release", $117bb525af114730$export$d7e64fbd0102ce90 = "sentry.dsc.sampled", $117bb525af114730$export$c17eae7e86dbba3c = "sentry.dsc.sample_rate", $117bb525af114730$export$349603c0a9165744 = "sentry.dsc.trace_id", $117bb525af114730$export$4dadf693741f0283 = "sentry.dsc.transaction", $117bb525af114730$export$6377864d12f7eeb3 = "sentry.environment", $117bb525af114730$export$ba081af9585ed4 = "sentry.exclusive_time", $117bb525af114730$export$7841dacb241485d0 = "sentry.graphql.operation", $117bb525af114730$export$52c7044cf6301362 = "sentry.group", $117bb525af114730$export$56ea1c9e44590e20 = "sentry.http.prefetch", $117bb525af114730$export$7626e389d05f4c36 = "sentry.idle_span_finish_reason", $117bb525af114730$export$5e0a48187329b2e7 = "sentry.is_remote", $117bb525af114730$export$c322b150d7667841 = "sentry.kind", $117bb525af114730$export$4a4797d3c962f753 = "sentry.main_thread", $117bb525af114730$export$767524d5e72e2645 = "sentry.message.parameter.<key>", $117bb525af114730$export$497354ca7b0ee666 = "sentry.message.template", $117bb525af114730$export$cbdc4ad11118116a = "sentry.metric.source", $117bb525af114730$export$5b890de778c4c2fe = "sentry.mobile", $117bb525af114730$export$a78d9803b5e0a83e = "sentry.module.<key>", $117bb525af114730$export$df1b536467b3992a = "sentry.module", $117bb525af114730$export$73104a329e205998 = "sentry.nextjs.ssr.function.route", $117bb525af114730$export$5740e3da55330b0a = "sentry.nextjs.ssr.function.type", $117bb525af114730$export$8dcc2d92ff6d65da = "sentry.normalized_db_query", $117bb525af114730$export$e5f1321e53e24810 = "sentry.normalized_db_query.hash", $117bb525af114730$export$56dd3098cbca7c8a = "sentry.normalized_description", $117bb525af114730$export$aa7aff70e4380665 = "sentry.observed_timestamp_nanos", $117bb525af114730$export$dacb7d452aa6bcaf = "sentry.op", $117bb525af114730$export$15dfc6c5e8f9baf6 = "sentry.origin", $117bb525af114730$export$91ad03bba7909fb5 = "sentry.platform", $117bb525af114730$export$86128e6c0ab71d64 = "sentry.profiler_id", $117bb525af114730$export$745b60c4819aec1d = "sentry.profile_id", $117bb525af114730$export$d2c893bfac1da9a1 = "sentry.release", $117bb525af114730$export$1c14ad02f9534b19 = "sentry.replay_id", $117bb525af114730$export$db3cb63e0594d014 = "sentry.replay_is_buffering", $117bb525af114730$export$a65c9a0eba2c222d = "sentry.report_event", $117bb525af114730$export$68dbcca9c0e339ec = "sentry.sdk.integrations", $117bb525af114730$export$d59b669d4bb3f006 = "sentry.sdk.name", $117bb525af114730$export$4d88d347aa9667fc = "sentry.sdk.version", $117bb525af114730$export$9943ffdcaa4bc506 = "sentry.segment.id", $117bb525af114730$export$268a117c860fca6d = "sentry.segment_id", $117bb525af114730$export$d4f25b923533dbba = "sentry.segment.name", $117bb525af114730$export$35f3396a1cdeea45 = "sentry.server_sample_rate", $117bb525af114730$export$80e399da474bc98d = "sentry.source", $117bb525af114730$export$e01809e2dbceac35 = "sentry.span.source", $117bb525af114730$export$41900d5c4e8a9c68 = "sentry.status", $117bb525af114730$export$362bb1cb0bb5ca03 = "sentry.status_code", $117bb525af114730$export$6803ac54f919d9cc = "sentry.status.message", $117bb525af114730$export$72f5b47540331169 = "sentry.sveltekit.navigation.from", $117bb525af114730$export$6c61a8c9aa5305cb = "sentry.sveltekit.navigation.to", $117bb525af114730$export$6b5244c457b68e65 = "sentry.sveltekit.navigation.type", $117bb525af114730$export$b7bd0c9a886f3414 = "sentry.thread.id", $117bb525af114730$export$6b77f2bacac7c93d = "sentry.timestamp.sequence", $117bb525af114730$export$ddbc15c0e8e8a7ea = "sentry.trace_lifecycle", $117bb525af114730$export$feb4fe753df28a82 = "sentry.trace.parent_span_id", $117bb525af114730$export$d6267756132e2175 = "sentry.trace.status", $117bb525af114730$export$570ac5a3fd7e6cc6 = "sentry.transaction", $117bb525af114730$export$5b9a0015e1c530ed = "sentry.user.email", $117bb525af114730$export$8bbff71c84508218 = "sentry.user.geo.city", $117bb525af114730$export$b55aa07a514a2430 = "sentry.user.geo.country_code", $117bb525af114730$export$9927ad09f7c084dc = "sentry.user.geo.region", $117bb525af114730$export$52a07a35ff8ec6b6 = "sentry.user.geo.subdivision", $117bb525af114730$export$a10d277c42e6cae3 = "sentry.user.id", $117bb525af114730$export$cdc0ce5c66182801 = "sentry.user.ip", $117bb525af114730$export$2504d4bd698dd962 = "sentry.user.username", $117bb525af114730$export$9dc86f3b876e96ef = "server.address", $117bb525af114730$export$70ff7865f52549ae = "server_name", $117bb525af114730$export$f77b53a42be6e6fd = "server.port", $117bb525af114730$export$818eb7ab11414506 = "service.name", $117bb525af114730$export$829ef6b2e59d984d = "service.version", $117bb525af114730$export$b30f4cb52c088a26 = "session.id", $117bb525af114730$export$335eace0ff1771cd = "stall_percentage", $117bb525af114730$export$374d88a2025416ac = "stall_total_time", $117bb525af114730$export$bb7a91303551eb37 = "state.type", $117bb525af114730$export$f132ea291a7db56b = "thread.id", $117bb525af114730$export$f0abd4170bbd2468 = "thread.name", $117bb525af114730$export$50d00a157dc08581 = "timber.tag", $117bb525af114730$export$484576567a98833f = "time_to_full_display", $117bb525af114730$export$ec9e491e475d0c97 = "time_to_initial_display", $117bb525af114730$export$a86c59c10992220f = "transaction", $117bb525af114730$export$e12f06597e992fde = "trpc.procedure_path", $117bb525af114730$export$7ec54678ba28ea59 = "trpc.procedure_type", $117bb525af114730$export$433ba14c16717110 = "ttfb", $117bb525af114730$export$309ee349b8a537f = "ttfb.requestTime", $117bb525af114730$export$b87f371cbc396fcf = "type", $117bb525af114730$export$60050fc49fe0e7e2 = "ui.component_name", $117bb525af114730$export$348c8e2b37f276cd = "ui.contributes_to_ttfd", $117bb525af114730$export$7f47e8a8b2d97cb2 = "ui.contributes_to_ttid", $117bb525af114730$export$50d5adc4b543ce95 = "ui.element.height", $117bb525af114730$export$9221f1d2c934d9f = "ui.element.id", $117bb525af114730$export$3a56578b3ae09a02 = "ui.element.identifier", $117bb525af114730$export$e47b8dab9466c895 = "ui.element.load_time", $117bb525af114730$export$4ca52f75cf4889c5 = "ui.element.paint_type", $117bb525af114730$export$7343d7d72195067f = "ui.element.render_time", $117bb525af114730$export$f334f32f8d4d8063 = "ui.element.type", $117bb525af114730$export$c7bf2089e89a217c = "ui.element.url", $117bb525af114730$export$f514f97553a434b2 = "ui.element.width", $117bb525af114730$export$61abde59b50deb8e = "url", $117bb525af114730$export$5a5ce44f9fb51f93 = "url.domain", $117bb525af114730$export$7044ea8d89b6f59d = "url.fragment", $117bb525af114730$export$40eacf1a072c9dbd = "url.full", $117bb525af114730$export$4c1fa0ac0eff2ac = "url.path", $117bb525af114730$export$5bee9450fe31dde1 = "url.path.parameter.<key>", $117bb525af114730$export$d0b571fb4406d953 = "url.path.parameter", $117bb525af114730$export$258b370e6c2b85d5 = "url.port", $117bb525af114730$export$dc5e5523da291a4b = "url.query", $117bb525af114730$export$fd5a8904ab5abfe0 = "url.same_origin", $117bb525af114730$export$1350d8937b0f26fb = "url.scheme", $117bb525af114730$export$2a045f777fb349a8 = "url.template", $117bb525af114730$export$8bb874585539a88f = "user_agent.original", $117bb525af114730$export$17d3a50785727199 = "user.email", $117bb525af114730$export$2931c570009689e = "user.full_name", $117bb525af114730$export$199cbcedee735a43 = "user.geo.city", $117bb525af114730$export$4ba5bf9d4e3ed862 = "user.geo.country_code", $117bb525af114730$export$674c01ec2f0b89c3 = "user.geo.region", $117bb525af114730$export$bda1686739fd61c7 = "user.geo.subdivision", $117bb525af114730$export$8d804148f485d54c = "user.hash", $117bb525af114730$export$212a8f1ea37518bd = "user.id", $117bb525af114730$export$c9ac0fee28245883 = "user.ip_address", $117bb525af114730$export$77078610759fe5f6 = "user.name", $117bb525af114730$export$7c6317deeec7a6c1 = "user.roles", $117bb525af114730$export$877ebf2e4ad81f03 = "vercel.branch", $117bb525af114730$export$70b2343945496e1f = "vercel.build_id", $117bb525af114730$export$8415b56d2c6d2b1d = "vercel.deployment_id", $117bb525af114730$export$cc81114a03caab18 = "vercel.destination", $117bb525af114730$export$bc14eb892daceb23 = "vercel.edge_type", $117bb525af114730$export$3c973217450c3e9d = "vercel.entrypoint", $117bb525af114730$export$582c0b730ff1ddb9 = "vercel.execution_region", $117bb525af114730$export$b3edfb545b65f1c5 = "vercel.id", $117bb525af114730$export$2593317d8731841c = "vercel.ja3_digest", $117bb525af114730$export$8bb5bc1732aa41f = "vercel.ja4_digest", $117bb525af114730$export$74a79c98b110b5b9 = "vercel.log_type", $117bb525af114730$export$26461b03281b4db4 = "vercel.path", $117bb525af114730$export$eaea590d6d3dd93c = "vercel.project_id", $117bb525af114730$export$af45365f70099379 = "vercel.project_name", $117bb525af114730$export$a49e732d34d5ba9b = "vercel.proxy.cache_id", $117bb525af114730$export$7c147fe246bc8bd3 = "vercel.proxy.client_ip", $117bb525af114730$export$e5111b6070e1ee9e = "vercel.proxy.host", $117bb525af114730$export$591cbfd403f8c8d = "vercel.proxy.lambda_region", $117bb525af114730$export$b1388db955bbb885 = "vercel.proxy.method", $117bb525af114730$export$e898d0e9e211abd9 = "vercel.proxy.path", $117bb525af114730$export$ab6fee0e8a6ee069 = "vercel.proxy.path_type", $117bb525af114730$export$9786ad94c199ffbb = "vercel.proxy.path_type_variant", $117bb525af114730$export$269890524eed693b = "vercel.proxy.referer", $117bb525af114730$export$2ec623a8212d6b64 = "vercel.proxy.region", $117bb525af114730$export$30e7673b01ff994e = "vercel.proxy.response_byte_size", $117bb525af114730$export$9ea93477840812bf = "vercel.proxy.scheme", $117bb525af114730$export$a6da0c365670c430 = "vercel.proxy.status_code", $117bb525af114730$export$7986b22da43f2885 = "vercel.proxy.timestamp", $117bb525af114730$export$a9f943c7ceb3b42f = "vercel.proxy.user_agent", $117bb525af114730$export$dfe49501efcdffce = "vercel.proxy.vercel_cache", $117bb525af114730$export$be465f50c92eb01d = "vercel.proxy.vercel_id", $117bb525af114730$export$c138d1796bb34999 = "vercel.proxy.waf_action", $117bb525af114730$export$85a0016690a0ccf2 = "vercel.proxy.waf_rule_id", $117bb525af114730$export$883acab36ede4bfa = "vercel.request_id", $117bb525af114730$export$9cfc88d203f9cdf1 = "vercel.source", $117bb525af114730$export$b3c6c599110d7bab = "vercel.status_code", $117bb525af114730$export$96f586f8837b86ae = {
    "ai.citations": "string[]",
    "ai.completion_tokens.used": "integer",
    "ai.documents": "string[]",
    "ai.finish_reason": "string",
    "ai.frequency_penalty": "double",
    "ai.function_call": "string",
    "ai.generation_id": "string",
    "ai.input_messages": "string",
    "ai.is_search_required": "boolean",
    "ai.metadata": "string",
    "ai.model_id": "string",
    "ai.model.provider": "string",
    "ai.pipeline.name": "string",
    "ai.preamble": "string",
    "ai.presence_penalty": "double",
    "ai.prompt_tokens.used": "integer",
    "ai.raw_prompting": "boolean",
    "ai.responses": "string[]",
    "ai.response_format": "string",
    "ai.search_queries": "string[]",
    "ai.search_results": "string[]",
    "ai.seed": "string",
    "ai.streaming": "boolean",
    "ai.tags": "string",
    "ai.temperature": "double",
    "ai.texts": "string[]",
    "ai.tools": "string[]",
    "ai.tool_calls": "string[]",
    "ai.top_k": "integer",
    "ai.top_p": "double",
    "ai.total_cost": "double",
    "ai.total_tokens.used": "integer",
    "ai.warnings": "string[]",
    "angular.version": "string",
    "app.app_build": "string",
    "app.app_identifier": "string",
    "app.app_name": "string",
    "app.app_start_time": "string",
    "app.app_version": "string",
    "app.build": "string",
    "app.identifier": "string",
    "app.in_foreground": "boolean",
    "app.name": "string",
    app_start_cold: "double",
    "app.start_time": "string",
    app_start_type: "string",
    app_start_warm: "double",
    "app.version": "string",
    "app.vitals.frames.delay.value": "integer",
    "app.vitals.frames.frozen.count": "integer",
    "app.vitals.frames.slow.count": "integer",
    "app.vitals.frames.total.count": "integer",
    "app.vitals.start.cold.value": "double",
    "app.vitals.start.prewarmed": "boolean",
    "app.vitals.start.reason": "string",
    "app.vitals.start.screen": "string",
    "app.vitals.start.type": "string",
    "app.vitals.start.warm.value": "double",
    "app.vitals.ttfd.value": "double",
    "app.vitals.ttid.value": "double",
    "art.gc.blocking_count": "integer",
    "art.gc.blocking_time": "double",
    "art.gc.pre_oome_count": "integer",
    "art.gc.total_count": "integer",
    "art.gc.total_time": "double",
    "art.gc.waiting_time": "double",
    "art.memory.free": "integer",
    "art.memory.free_until_gc": "integer",
    "art.memory.free_until_oome": "integer",
    "art.memory.max": "integer",
    "art.memory.total": "integer",
    "aws.cloudwatch.logs.log_group": "string",
    "aws.cloudwatch.logs.log_stream": "string",
    "aws.cloudwatch.logs.url": "string",
    "aws.dynamodb.attribute_definitions": "string[]",
    "aws.dynamodb.consistent_read": "boolean",
    "aws.dynamodb.consumed_capacity": "string[]",
    "aws.dynamodb.count": "integer",
    "aws.dynamodb.exclusive_start_table": "string",
    "aws.dynamodb.global_secondary_indexes": "string[]",
    "aws.dynamodb.global_secondary_index_updates": "string[]",
    "aws.dynamodb.index_name": "string",
    "aws.dynamodb.item_collection_metrics": "string",
    "aws.dynamodb.limit": "integer",
    "aws.dynamodb.local_secondary_indexes": "string[]",
    "aws.dynamodb.projection": "string",
    "aws.dynamodb.provisioned_read_capacity": "double",
    "aws.dynamodb.provisioned_write_capacity": "double",
    "aws.dynamodb.scanned_count": "integer",
    "aws.dynamodb.scan_forward": "boolean",
    "aws.dynamodb.segment": "integer",
    "aws.dynamodb.select": "string",
    "aws.dynamodb.table_count": "integer",
    "aws.dynamodb.table_names": "string[]",
    "aws.dynamodb.total_segments": "integer",
    "aws.extended_request_id": "string",
    "aws.kinesis.stream_name": "string",
    "aws.kinesis.stream.name": "string",
    "aws.lambda.aws_request_id": "string",
    "aws.lambda.execution_duration_in_millis": "double",
    "aws.lambda.function_name": "string",
    "aws.lambda.function_version": "string",
    "aws.lambda.invoked_arn": "string",
    "aws.lambda.invoked_function_arn": "string",
    "aws.lambda.remaining_time_in_millis": "double",
    "aws.log.group.names": "string[]",
    "aws.log.stream.names": "string[]",
    "aws.request.extended_id": "string",
    "aws.request_id": "string",
    "aws.request.id": "string",
    "aws.s3.bucket": "string",
    "aws.secretsmanager.secret.arn": "string",
    "aws.sns.topic.arn": "string",
    "aws.step_functions.activity.arn": "string",
    "aws.step_functions.state_machine.arn": "string",
    blocked_main_thread: "boolean",
    "browser.name": "string",
    "browser.performance.navigation.activation_start": "double",
    "browser.performance.time_origin": "double",
    "browser.report.type": "string",
    "browser.script.invoker": "string",
    "browser.script.invoker_type": "string",
    "browser.script.source_char_position": "integer",
    "browser.version": "string",
    "browser.web_vital.cls.report_event": "string",
    "browser.web_vital.cls.source.<key>": "string",
    "browser.web_vital.cls.value": "double",
    "browser.web_vital.fcp.value": "double",
    "browser.web_vital.fp.value": "double",
    "browser.web_vital.inp.value": "double",
    "browser.web_vital.lcp.element": "string",
    "browser.web_vital.lcp.id": "string",
    "browser.web_vital.lcp.load_time": "integer",
    "browser.web_vital.lcp.render_time": "integer",
    "browser.web_vital.lcp.report_event": "string",
    "browser.web_vital.lcp.size": "integer",
    "browser.web_vital.lcp.url": "string",
    "browser.web_vital.lcp.value": "double",
    "browser.web_vital.ttfb.request_time": "double",
    "browser.web_vital.ttfb.value": "double",
    "cache.hit": "boolean",
    "cache.item_size": "integer",
    "cache.key": "string[]",
    "cache.operation": "string",
    "cache.ttl": "integer",
    "cache.write": "boolean",
    channel: "string",
    "client.address": "string",
    "client.port": "integer",
    "cloudflare.d1.duration": "integer",
    "cloudflare.d1.query_type": "string",
    "cloudflare.d1.rows_read": "integer",
    "cloudflare.d1.rows_written": "integer",
    "cloudflare.durable_object.query.bindings": "integer",
    "cloudflare.durable_object.response.rows_read": "integer",
    "cloudflare.durable_object.response.rows_written": "integer",
    "cloudflare.r2.bucket": "string",
    "cloudflare.r2.operation": "string",
    "cloudflare.r2.request.delimiter": "string",
    "cloudflare.r2.request.key": "string",
    "cloudflare.r2.request.part_number": "integer",
    "cloudflare.r2.request.prefix": "string",
    "cloudflare.workflow.attempt": "integer",
    "cloudflare.workflow.retries.backoff": "string",
    "cloudflare.workflow.retries.delay": "string",
    "cloudflare.workflow.retries.limit": "integer",
    "cloudflare.workflow.timeout": "string",
    "cloud.account.id": "string",
    "cloud.availability_zone": "string",
    "cloud.platform": "string",
    "cloud.provider": "string",
    "cloud.region": "string",
    "cloud.resource_id": "string",
    cls: "double",
    "cls.source.<key>": "string",
    "code.filepath": "string",
    "code.file.path": "string",
    "code.function": "string",
    "code.function.name": "string",
    "code.lineno": "integer",
    "code.line.number": "integer",
    "code.namespace": "string",
    connectionType: "string",
    "connection.rtt": "integer",
    "culture.calendar": "string",
    "culture.display_name": "string",
    "culture.is_24_hour_format": "boolean",
    "culture.locale": "string",
    "culture.timezone": "string",
    "db.collection.name": "string",
    "db.driver.name": "string",
    "db.name": "string",
    "db.namespace": "string",
    "db.operation": "string",
    "db.operation.batch.size": "integer",
    "db.operation.name": "string",
    "db.query.parameter.<key>": "string",
    "db.query.summary": "string",
    "db.query.text": "string",
    "db.redis.connection": "string",
    "db.redis.key": "string",
    "db.redis.parameters": "string[]",
    "db.response.status_code": "string",
    "db.sql.bindings": "string[]",
    "db.statement": "string",
    "db.stored_procedure.name": "string",
    "db.system": "string",
    "db.system.name": "string",
    "db.user": "string",
    deviceMemory: "string",
    "device.archs": "string[]",
    "device.battery_level": "double",
    "device.battery_temperature": "double",
    "device.boot_time": "string",
    "device.brand": "string",
    "device.charging": "boolean",
    "device.chipset": "string",
    "device.class": "string",
    "device.connection_type": "string",
    "device.cpu_description": "string",
    "device.external_free_storage": "integer",
    "device.external_storage_size": "integer",
    "device.family": "string",
    "device.free_memory": "integer",
    "device.free_storage": "integer",
    "device.id": "string",
    "device.locale": "string",
    "device.low_memory": "boolean",
    "device.low_power_mode": "boolean",
    "device.manufacturer": "string",
    "device.memory.estimated_capacity": "integer",
    "device.memory_size": "integer",
    "device.model": "string",
    "device.model_id": "string",
    "device.name": "string",
    "device.online": "boolean",
    "device.orientation": "string",
    "device.processor_count": "integer",
    "device.processor_frequency": "double",
    "device.screen_density": "double",
    "device.screen_dpi": "integer",
    "device.screen_height_pixels": "integer",
    "device.screen_width_pixels": "integer",
    "device.simulator": "boolean",
    "device.storage_size": "integer",
    "device.thermal_state": "string",
    "device.timezone": "string",
    "device.usable_memory": "integer",
    dist: "string",
    effectiveConnectionType: "string",
    environment: "string",
    "error.type": "string",
    "event.id": "integer",
    "event.name": "string",
    "exception.escaped": "boolean",
    "exception.message": "string",
    "exception.stacktrace": "string",
    "exception.type": "string",
    "faas.coldstart": "boolean",
    "faas.cron": "string",
    "faas.duration_in_ms": "integer",
    "faas.entry_point": "string",
    "faas.execution": "string",
    "faas.id": "string",
    "faas.identity": "string",
    "faas.invocation_id": "string",
    "faas.invoked_name": "string",
    "faas.invoked_provider": "string",
    "faas.invoked_region": "string",
    "faas.name": "string",
    "faas.time": "string",
    "faas.trigger": "string",
    "faas.version": "string",
    fcp: "double",
    "flag.evaluation.<key>": "boolean",
    fp: "double",
    "frames.delay": "integer",
    "frames.frozen": "integer",
    frames_frozen_rate: "double",
    "frames.slow": "integer",
    frames_slow_rate: "double",
    "frames.total": "integer",
    fs_error: "string",
    "gcp.function.context.event_id": "string",
    "gcp.function.context.event_type": "string",
    "gcp.function.context.id": "string",
    "gcp.function.context.resource": "string",
    "gcp.function.context.source": "string",
    "gcp.function.context.specversion": "string",
    "gcp.function.context.time": "string",
    "gcp.function.context.timestamp": "string",
    "gcp.function.context.type": "string",
    "gcp.project.id": "string",
    "gen_ai.agent.name": "string",
    "gen_ai.context.utilization": "double",
    "gen_ai.context.window_size": "integer",
    "gen_ai.conversation.id": "string",
    "gen_ai.cost.cache_creation.input_tokens": "double",
    "gen_ai.cost.cache_read.input_tokens": "double",
    "gen_ai.cost.input_tokens": "double",
    "gen_ai.cost.output_tokens": "double",
    "gen_ai.cost.reasoning.output_tokens": "double",
    "gen_ai.cost.total_tokens": "double",
    "gen_ai.embeddings.input": "string",
    "gen_ai.function_id": "string",
    "gen_ai.input.messages": "string",
    "gen_ai.operation.name": "string",
    "gen_ai.operation.type": "string",
    "gen_ai.output.messages": "string",
    "gen_ai.pipeline.name": "string",
    "gen_ai.prompt": "string",
    "gen_ai.prompt.name": "string",
    "gen_ai.provider.name": "string",
    "gen_ai.request.available_tools": "string",
    "gen_ai.request.frequency_penalty": "double",
    "gen_ai.request.max_tokens": "integer",
    "gen_ai.request.messages": "string",
    "gen_ai.request.model": "string",
    "gen_ai.request.presence_penalty": "double",
    "gen_ai.request.reasoning_effort": "string",
    "gen_ai.request.seed": "string",
    "gen_ai.request.stop_sequences": "string[]",
    "gen_ai.request.temperature": "double",
    "gen_ai.request.top_k": "integer",
    "gen_ai.request.top_p": "double",
    "gen_ai.response.finish_reasons": "string",
    "gen_ai.response.id": "string",
    "gen_ai.response.model": "string",
    "gen_ai.response.streaming": "boolean",
    "gen_ai.response.text": "string",
    "gen_ai.response.time_to_first_chunk": "double",
    "gen_ai.response.time_to_first_token": "double",
    "gen_ai.response.tokens_per_second": "double",
    "gen_ai.response.tool_calls": "string",
    "gen_ai.system": "string",
    "gen_ai.system_instructions": "string",
    "gen_ai.system.message": "string",
    "gen_ai.tool.call.arguments": "string",
    "gen_ai.tool.call.result": "string",
    "gen_ai.tool.definitions": "string",
    "gen_ai.tool.description": "string",
    "gen_ai.tool.input": "string",
    "gen_ai.tool.message": "string",
    "gen_ai.tool.name": "string",
    "gen_ai.tool.output": "string",
    "gen_ai.tool.type": "string",
    "gen_ai.usage.cache_creation.input_tokens": "integer",
    "gen_ai.usage.cache_read.input_tokens": "integer",
    "gen_ai.usage.completion_tokens": "integer",
    "gen_ai.usage.input_tokens": "integer",
    "gen_ai.usage.input_tokens.cached": "integer",
    "gen_ai.usage.input_tokens.cache_write": "integer",
    "gen_ai.usage.output_tokens": "integer",
    "gen_ai.usage.output_tokens.reasoning": "integer",
    "gen_ai.usage.prompt_tokens": "integer",
    "gen_ai.usage.reasoning.output_tokens": "integer",
    "gen_ai.usage.total_tokens": "integer",
    "graphql.document": "string",
    "graphql.operation.name": "string",
    "graphql.operation.type": "string",
    hardwareConcurrency: "string",
    "http.client_ip": "string",
    "http.decoded_response_content_length": "integer",
    "http.flavor": "string",
    "http.fragment": "string",
    "http.host": "string",
    "http.method": "string",
    "http.query": "string",
    "http.request.body.data": "string",
    "http.request.connection_end": "double",
    "http.request.connect_start": "double",
    "http.request.domain_lookup_end": "double",
    "http.request.domain_lookup_start": "double",
    "http.request.fetch_start": "double",
    "http.request.header.<key>": "string[]",
    "http.request.method": "string",
    "http.request_method": "string",
    "http.request.redirect_end": "double",
    "http.request.redirect_start": "double",
    "http.request.request_start": "double",
    "http.request.resend_count": "integer",
    "http.request.response_end": "double",
    "http.request.response_start": "double",
    "http.request.same_origin": "boolean",
    "http.request.secure_connection_start": "double",
    "http.request.time_to_first_byte": "double",
    "http.request.worker_start": "double",
    "http.response.body.size": "integer",
    "http.response_content_length": "integer",
    "http.response.header.content-length": "string",
    "http.response.header.<key>": "string[]",
    "http.response.size": "integer",
    "http.response.status_code": "integer",
    "http.response_transfer_size": "integer",
    "http.route": "string",
    "http.scheme": "string",
    "http.server_name": "string",
    "http.server.request.time_in_queue": "double",
    "http.status_code": "integer",
    "http.target": "string",
    "http.url": "string",
    "http.user_agent": "string",
    id: "string",
    inp: "double",
    "jsonrpc.protocol.version": "string",
    "jsonrpc.request.id": "string",
    "jvm.gc.action": "string",
    "jvm.gc.name": "string",
    "jvm.memory.pool.name": "string",
    "jvm.memory.type": "string",
    "jvm.thread.daemon": "boolean",
    "jvm.thread.state": "string",
    "koa.name": "string",
    "koa.type": "string",
    lcp: "double",
    "lcp.element": "string",
    "lcp.id": "string",
    "lcp.loadTime": "integer",
    "lcp.renderTime": "integer",
    "lcp.size": "integer",
    "lcp.url": "string",
    "logger.name": "string",
    "mcp.cancelled.reason": "string",
    "mcp.cancelled.request_id": "string",
    "mcp.client.name": "string",
    "mcp.client.title": "string",
    "mcp.client.version": "string",
    "mcp.lifecycle.phase": "string",
    "mcp.logging.data_type": "string",
    "mcp.logging.level": "string",
    "mcp.logging.logger": "string",
    "mcp.logging.message": "string",
    "mcp.method.name": "string",
    "mcp.progress.current": "integer",
    "mcp.progress.message": "string",
    "mcp.progress.percentage": "double",
    "mcp.progress.token": "string",
    "mcp.progress.total": "integer",
    "mcp.prompt.name": "string",
    "mcp.prompt.result.description": "string",
    "mcp.prompt.result.message_content": "string",
    "mcp.prompt.result.message_count": "integer",
    "mcp.prompt.result.message_role": "string",
    "mcp.protocol.ready": "integer",
    "mcp.protocol.version": "string",
    "mcp.request.argument.<key>": "string",
    "mcp.request.argument.name": "string",
    "mcp.request.argument.uri": "string",
    "mcp.request.id": "string",
    "mcp.resource.protocol": "string",
    "mcp.resource.uri": "string",
    "mcp.server.name": "string",
    "mcp.server.title": "string",
    "mcp.server.version": "string",
    "mcp.session.id": "string",
    "mcp.tool.name": "string",
    "mcp.tool.result.content": "string",
    "mcp.tool.result.content_count": "integer",
    "mcp.tool.result.is_error": "boolean",
    "mcp.transport": "string",
    "mdc.<key>": "string",
    "messaging.batch.message_count": "integer",
    "messaging.destination": "string",
    "messaging.destination.connection": "string",
    "messaging.destination.name": "string",
    "messaging.message.body.size": "integer",
    "messaging.message.conversation_id": "string",
    "messaging.message.envelope.size": "integer",
    "messaging.message.id": "string",
    "messaging.message.receive.latency": "integer",
    "messaging.message.retry.count": "integer",
    "messaging.operation.name": "string",
    "messaging.operation.type": "string",
    "messaging.rabbitmq.destination.routing_key": "string",
    "messaging.system": "string",
    method: "string",
    "middleware.name": "string",
    "navigation.origin": "string",
    "navigation.route.id": "string",
    "navigation.type": "string",
    "nel.elapsed_time": "integer",
    "nel.phase": "string",
    "nel.referrer": "string",
    "nel.sampling_function": "double",
    "nel.type": "string",
    "network.connection.effective_type": "string",
    "network.connection.rtt": "integer",
    "network.connection.type": "string",
    "network.local.address": "string",
    "network.local.port": "integer",
    "network.peer.address": "string",
    "network.peer.port": "integer",
    "network.protocol.name": "string",
    "network.protocol.version": "string",
    "network.transport": "string",
    "network.type": "string",
    "net.host.ip": "string",
    "net.host.name": "string",
    "net.host.port": "integer",
    "net.peer.ip": "string",
    "net.peer.name": "string",
    "net.peer.port": "integer",
    "net.protocol.name": "string",
    "net.protocol.version": "string",
    "net.sock.family": "string",
    "net.sock.host.addr": "string",
    "net.sock.host.port": "integer",
    "net.sock.peer.addr": "string",
    "net.sock.peer.name": "string",
    "net.sock.peer.port": "integer",
    "net.transport": "string",
    "os.build": "string",
    "os.build_id": "string",
    "os.description": "string",
    "os.kernel_version": "string",
    "os.name": "string",
    "os.raw_description": "string",
    "os.rooted": "boolean",
    "os.theme": "string",
    "os.type": "string",
    "os.version": "string",
    "otel.kind": "string",
    "otel.scope.name": "string",
    "otel.scope.version": "string",
    "otel.status_code": "string",
    "otel.status_description": "string",
    "params.<key>": "string",
    "performance.activationStart": "double",
    "performance.timeOrigin": "double",
    previous_route: "string",
    "process.command_args": "string[]",
    "process.executable.name": "string",
    "process.pid": "integer",
    "process.runtime.description": "string",
    "process.runtime.engine.name": "string",
    "process.runtime.engine.version": "string",
    "process.runtime.name": "string",
    "process.runtime.version": "string",
    "query.<key>": "string",
    "react.version": "string",
    release: "string",
    "remix.action_form_data.<key>": "string",
    replay_id: "string",
    "resource.deployment.environment": "string",
    "resource.deployment.environment.name": "string",
    "resource.render_blocking_status": "string",
    route: "string",
    "rpc.grpc.status_code": "integer",
    "rpc.method": "string",
    "rpc.response.status_code": "string",
    "rpc.service": "string",
    "rpc.system": "string",
    "rpc.system.name": "string",
    "runtime.build": "string",
    "runtime.name": "string",
    "runtime.raw_description": "string",
    "runtime.version": "string",
    "score.<key>": "double",
    "score.ratio.<key>": "double",
    "score.total": "double",
    "score.weight.<key>": "double",
    "sentry.action": "string",
    "sentry.browser.name": "string",
    "sentry.browser.version": "string",
    "sentry.cancellation_reason": "string",
    "sentry.category": "string",
    "sentry.client_sample_rate": "double",
    "sentry.description": "string",
    "sentry.dist": "string",
    "sentry.domain": "string",
    "sentry.dsc.environment": "string",
    "sentry.dsc.project_id": "string",
    "sentry.dsc.public_key": "string",
    "sentry.dsc.release": "string",
    "sentry.dsc.sampled": "boolean",
    "sentry.dsc.sample_rate": "string",
    "sentry.dsc.trace_id": "string",
    "sentry.dsc.transaction": "string",
    "sentry.environment": "string",
    "sentry.exclusive_time": "double",
    "sentry.graphql.operation": "string",
    "sentry.group": "string",
    "sentry.http.prefetch": "boolean",
    "sentry.idle_span_finish_reason": "string",
    "sentry.is_remote": "boolean",
    "sentry.kind": "string",
    "sentry.main_thread": "boolean",
    "sentry.message.parameter.<key>": "string",
    "sentry.message.template": "string",
    "sentry.metric.source": "string",
    "sentry.mobile": "boolean",
    "sentry.module.<key>": "string",
    "sentry.nextjs.ssr.function.route": "string",
    "sentry.nextjs.ssr.function.type": "string",
    "sentry.normalized_db_query": "string",
    "sentry.normalized_db_query.hash": "string",
    "sentry.normalized_description": "string",
    "sentry.observed_timestamp_nanos": "string",
    "sentry.op": "string",
    "sentry.origin": "string",
    "sentry.platform": "string",
    "sentry.profiler_id": "string",
    "sentry.profile_id": "string",
    "sentry.release": "string",
    "sentry.replay_id": "string",
    "sentry.replay_is_buffering": "boolean",
    "sentry.report_event": "string",
    "sentry.sdk.integrations": "string[]",
    "sentry.sdk.name": "string",
    "sentry.sdk.version": "string",
    "sentry.segment.id": "string",
    "sentry.segment_id": "string",
    "sentry.segment.name": "string",
    "sentry.server_sample_rate": "double",
    "sentry.source": "string",
    "sentry.span.source": "string",
    "sentry.status": "string",
    "sentry.status_code": "integer",
    "sentry.status.message": "string",
    "sentry.sveltekit.navigation.from": "string",
    "sentry.sveltekit.navigation.to": "string",
    "sentry.sveltekit.navigation.type": "string",
    "sentry.thread.id": "integer",
    "sentry.timestamp.sequence": "integer",
    "sentry.trace_lifecycle": "string",
    "sentry.trace.parent_span_id": "string",
    "sentry.trace.status": "string",
    "sentry.transaction": "string",
    "sentry.user.email": "string",
    "sentry.user.geo.city": "string",
    "sentry.user.geo.country_code": "string",
    "sentry.user.geo.region": "string",
    "sentry.user.geo.subdivision": "string",
    "sentry.user.id": "string",
    "sentry.user.ip": "string",
    "sentry.user.username": "string",
    "server.address": "string",
    server_name: "string",
    "server.port": "integer",
    "service.name": "string",
    "service.version": "string",
    "session.id": "string",
    stall_percentage: "double",
    stall_total_time: "double",
    "state.type": "string",
    "thread.id": "integer",
    "thread.name": "string",
    "timber.tag": "string",
    time_to_full_display: "double",
    time_to_initial_display: "double",
    transaction: "string",
    "trpc.procedure_path": "string",
    "trpc.procedure_type": "string",
    ttfb: "double",
    "ttfb.requestTime": "double",
    type: "string",
    "ui.component_name": "string",
    "ui.contributes_to_ttfd": "boolean",
    "ui.contributes_to_ttid": "boolean",
    "ui.element.height": "integer",
    "ui.element.id": "string",
    "ui.element.identifier": "string",
    "ui.element.load_time": "double",
    "ui.element.paint_type": "string",
    "ui.element.render_time": "double",
    "ui.element.type": "string",
    "ui.element.url": "string",
    "ui.element.width": "integer",
    url: "string",
    "url.domain": "string",
    "url.fragment": "string",
    "url.full": "string",
    "url.path": "string",
    "url.path.parameter.<key>": "string",
    "url.port": "integer",
    "url.query": "string",
    "url.same_origin": "boolean",
    "url.scheme": "string",
    "url.template": "string",
    "user_agent.original": "string",
    "user.email": "string",
    "user.full_name": "string",
    "user.geo.city": "string",
    "user.geo.country_code": "string",
    "user.geo.region": "string",
    "user.geo.subdivision": "string",
    "user.hash": "string",
    "user.id": "string",
    "user.ip_address": "string",
    "user.name": "string",
    "user.roles": "string[]",
    "vercel.branch": "string",
    "vercel.build_id": "string",
    "vercel.deployment_id": "string",
    "vercel.destination": "string",
    "vercel.edge_type": "string",
    "vercel.entrypoint": "string",
    "vercel.execution_region": "string",
    "vercel.id": "string",
    "vercel.ja3_digest": "string",
    "vercel.ja4_digest": "string",
    "vercel.log_type": "string",
    "vercel.path": "string",
    "vercel.project_id": "string",
    "vercel.project_name": "string",
    "vercel.proxy.cache_id": "string",
    "vercel.proxy.client_ip": "string",
    "vercel.proxy.host": "string",
    "vercel.proxy.lambda_region": "string",
    "vercel.proxy.method": "string",
    "vercel.proxy.path": "string",
    "vercel.proxy.path_type": "string",
    "vercel.proxy.path_type_variant": "string",
    "vercel.proxy.referer": "string",
    "vercel.proxy.region": "string",
    "vercel.proxy.response_byte_size": "integer",
    "vercel.proxy.scheme": "string",
    "vercel.proxy.status_code": "integer",
    "vercel.proxy.timestamp": "integer",
    "vercel.proxy.user_agent": "string[]",
    "vercel.proxy.vercel_cache": "string",
    "vercel.proxy.vercel_id": "string",
    "vercel.proxy.waf_action": "string",
    "vercel.proxy.waf_rule_id": "string",
    "vercel.request_id": "string",
    "vercel.source": "string",
    "vercel.status_code": "integer"
}, $117bb525af114730$export$bd393bbb84b309d3 = {
    "ai.citations": {
        brief: "References or sources cited by the AI model in its response.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Citation 1",
            "Citation 2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.completion_tokens.used": {
        brief: "The number of tokens used to respond to the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "gen_ai.usage.output_tokens",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.documents": {
        brief: "Documents or content chunks used as context for the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "document1.txt",
            "document2.pdf"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.finish_reason": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "COMPLETE",
        deprecation: {
            replacement: "gen_ai.response.finish_reasons"
        },
        aliases: [
            "gen_ai.response.finish_reasons"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.frequency_penalty"
        },
        aliases: [
            "gen_ai.request.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.function_call": {
        brief: "For an AI model call, the function that was called. This is deprecated for OpenAI, and replaced by tool_calls",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "function_name",
        deprecation: {
            replacement: "gen_ai.tool.name"
        },
        aliases: [
            "gen_ai.tool.name",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.generation_id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gen_123abc",
        deprecation: {
            replacement: "gen_ai.response.id"
        },
        aliases: [
            "gen_ai.response.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.input_messages": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.request.messages"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.is_search_required": {
        brief: "Boolean indicating if the model needs to perform a search.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.metadata": {
        brief: "Extra metadata passed to an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"user_id": 123, "session_id": "abc123"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.model_id": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gpt-4",
        deprecation: {
            replacement: "gen_ai.response.model"
        },
        aliases: [
            "gen_ai.response.model"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.model.provider": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "gen_ai.provider.name",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.pipeline.name": {
        brief: "The name of the AI pipeline.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        deprecation: {
            replacement: "gen_ai.pipeline.name"
        },
        aliases: [
            "gen_ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    53,
                    76,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.preamble": {
        brief: "For an AI model call, the preamble parameter. Preambles are a part of the prompt used to adjust the model's overall behavior and conversation style.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are now a clown.",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        aliases: [
            "gen_ai.system_instructions"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.presence_penalty"
        },
        aliases: [
            "gen_ai.request.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.prompt_tokens.used": {
        brief: "The number of tokens used to process just the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "gen_ai.usage.prompt_tokens",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.raw_prompting": {
        brief: "When enabled, the user\u2019s prompt will be sent to the model without any pre-processing.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.responses": {
        brief: "The response messages sent back by the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "hello",
            "world"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.response_format": {
        brief: "For an AI model call, the format of the response",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "json_object",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.search_queries": {
        brief: "Queries used to search for relevant context or documents.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "climate change effects",
            "renewable energy"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.search_results": {
        brief: "Results returned from search queries for context.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "search_result_1, search_result_2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "gen_ai.request.seed"
        },
        aliases: [
            "gen_ai.request.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.streaming": {
        brief: "Whether the request was streamed back.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "gen_ai.response.streaming"
        },
        aliases: [
            "gen_ai.response.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.tags": {
        brief: "Tags that describe an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"executed_function": "add_integers"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .1,
        deprecation: {
            replacement: "gen_ai.request.temperature"
        },
        aliases: [
            "gen_ai.request.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.texts": {
        brief: "Raw text inputs provided to the model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Hello, how are you?",
            "What is the capital of France?"
        ],
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.input.messages"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.tools": {
        brief: "For an AI model call, the functions that are available",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "function_1",
            "function_2"
        ],
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65,
                    127
                ]
            }
        ]
    },
    "ai.tool_calls": {
        brief: "For an AI model call, the tool calls that were made.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "tool_call_1",
            "tool_call_2"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65
                ]
            }
        ]
    },
    "ai.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 35,
        deprecation: {
            replacement: "gen_ai.request.top_k"
        },
        aliases: [
            "gen_ai.request.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .7,
        deprecation: {
            replacement: "gen_ai.request.top_p"
        },
        aliases: [
            "gen_ai.request.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.total_cost": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        deprecation: {
            replacement: "gen_ai.cost.total_tokens"
        },
        aliases: [
            "gen_ai.cost.total_tokens"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    53
                ]
            }
        ]
    },
    "ai.total_tokens.used": {
        brief: "The total number of tokens used to process the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 30,
        deprecation: {
            replacement: "gen_ai.usage.total_tokens"
        },
        aliases: [
            "gen_ai.usage.total_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.warnings": {
        brief: "Warning messages generated during model execution.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Token limit exceeded"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "angular.version": {
        brief: "The version of the Angular framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "17.1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    367
                ],
                description: "Added angular.version attribute"
            }
        ]
    },
    "app.app_build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "app.build",
            reason: "Deprecated in favor of app.build"
        },
        aliases: [
            "app.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_build in favor of app.build"
            }
        ]
    },
    "app.app_identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        deprecation: {
            replacement: "app.identifier",
            reason: "Deprecated in favor of app.identifier"
        },
        aliases: [
            "app.identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_identifier in favor of app.identifier"
            }
        ]
    },
    "app.app_name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        deprecation: {
            replacement: "app.name",
            reason: "Deprecated in favor of app.name"
        },
        aliases: [
            "app.name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_name in favor of app.name"
            }
        ]
    },
    "app.app_start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        deprecation: {
            replacement: "app.start_time",
            reason: "Deprecated in favor of app.start_time"
        },
        aliases: [
            "app.start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_start_time in favor of app.start_time"
            }
        ]
    },
    "app.app_version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        deprecation: {
            replacement: "app.version",
            reason: "Deprecated in favor of app.version"
        },
        aliases: [
            "app.version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_version in favor of app.version"
            }
        ]
    },
    "app.build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        aliases: [
            "app.app_build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.build attribute"
            }
        ]
    },
    "app.identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        aliases: [
            "app.app_identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.identifier attribute"
            }
        ]
    },
    "app.in_foreground": {
        brief: "Whether the application is currently in the foreground.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.in_foreground attribute"
            }
        ]
    },
    "app.name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        aliases: [
            "app.app_name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.name attribute"
            }
        ]
    },
    app_start_cold: {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.cold.value",
            reason: "Replaced by app.vitals.start.cold.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.cold.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.cold.value"
            }
        ]
    },
    "app.start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        aliases: [
            "app.app_start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.start_time attribute"
            }
        ]
    },
    app_start_type: {
        brief: "Mobile app start variant. Either cold or warm.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        deprecation: {
            replacement: "app.vitals.start.type",
            reason: "Replaced by app.vitals.start.type to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.start.type"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    app_start_warm: {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.warm.value",
            reason: "Replaced by app.vitals.start.warm.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.warm.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.warm.value"
            }
        ]
    },
    "app.version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        aliases: [
            "app.app_version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.version attribute"
            }
        ]
    },
    "app.vitals.frames.delay.value": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        aliases: [
            "frames.delay"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.delay.value to replace frames.delay"
            }
        ]
    },
    "app.vitals.frames.frozen.count": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        aliases: [
            "frames.frozen"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.frozen.count to replace frames.frozen"
            }
        ]
    },
    "app.vitals.frames.slow.count": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        aliases: [
            "frames.slow"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.slow.count to replace frames.slow"
            }
        ]
    },
    "app.vitals.frames.total.count": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        aliases: [
            "frames.total"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.total.count to replace frames.total"
            }
        ]
    },
    "app.vitals.start.cold.value": {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_cold"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.cold.value attribute"
            }
        ]
    },
    "app.vitals.start.prewarmed": {
        brief: "Whether the app start was prewarmed.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    379
                ],
                description: "Added app.vitals.start.prewarmed attribute"
            }
        ]
    },
    "app.vitals.start.reason": {
        brief: "The reason that triggered the app start.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "push",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.reason attribute"
            }
        ]
    },
    "app.vitals.start.screen": {
        brief: "The screen that is rendered when the app start is complete. This is the screen the user first sees and can interact with after launch. The absence of this attribute on the app start span indicates a background app start where no UI was rendered.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MainActivity",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.screen attribute"
            }
        ]
    },
    "app.vitals.start.type": {
        brief: "The type of app start, for example `cold` or `warm`",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        aliases: [
            "app_start_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.type attribute"
            }
        ]
    },
    "app.vitals.start.warm.value": {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_warm"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.warm.value attribute"
            }
        ]
    },
    "app.vitals.ttfd.value": {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_full_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttfd.value attribute"
            }
        ]
    },
    "app.vitals.ttid.value": {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_initial_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttid.value attribute"
            }
        ]
    },
    "art.gc.blocking_count": {
        brief: "Total number of blocking (stop-the-world) garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_count attribute"
            }
        ]
    },
    "art.gc.blocking_time": {
        brief: "Total time spent in blocking (stop-the-world) garbage collections by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.873,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_time attribute"
            }
        ]
    },
    "art.gc.pre_oome_count": {
        brief: "Total number of garbage collections triggered as a last resort before an OutOfMemoryError by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.pre_oome_count attribute"
            }
        ]
    },
    "art.gc.total_count": {
        brief: "Total number of garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_count attribute"
            }
        ]
    },
    "art.gc.total_time": {
        brief: "Total time spent in garbage collection by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.807,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_time attribute"
            }
        ]
    },
    "art.gc.waiting_time": {
        brief: "Total time threads spent waiting for garbage collection to complete in the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8.054,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.waiting_time attribute"
            }
        ]
    },
    "art.memory.free": {
        brief: "Free memory available to the process as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free attribute"
            }
        ]
    },
    "art.memory.free_until_gc": {
        brief: "Free memory available before a garbage collection would be triggered by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_gc attribute"
            }
        ]
    },
    "art.memory.free_until_oome": {
        brief: "Free memory available before an OutOfMemoryError would be thrown by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 196083712,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_oome attribute"
            }
        ]
    },
    "art.memory.max": {
        brief: "Maximum memory the process is allowed to use as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 201326592,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.max attribute"
            }
        ]
    },
    "art.memory.total": {
        brief: "Total memory currently allocated to the process by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 7774208,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.total attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_group": {
        brief: "The name of the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/aws/lambda/my-function",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_group attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_stream": {
        brief: "The name of the CloudWatch Logs log stream",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024/01/01/[$LATEST]abcdef1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_stream attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.url": {
        brief: "The URL to the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logsV2:log-groups/log-group/my-log-group",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.url attribute"
            }
        ]
    },
    "aws.dynamodb.attribute_definitions": {
        brief: "The JSON-serialized value of each item in the `AttributeDefinitions` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "AttributeName": "string", "AttributeType": "string" }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.attribute_definitions attribute"
            }
        ]
    },
    "aws.dynamodb.consistent_read": {
        brief: "The value of the `ConsistentRead` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consistent_read attribute"
            }
        ]
    },
    "aws.dynamodb.consumed_capacity": {
        brief: "The JSON-serialized value of each item in the `ConsumedCapacity` response field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "CapacityUnits": number, "GlobalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "LocalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "ReadCapacityUnits": number, "Table": { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number }, "TableName": "string", "WriteCapacityUnits": number }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consumed_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.count": {
        brief: "The value of the `Count` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.count attribute"
            }
        ]
    },
    "aws.dynamodb.exclusive_start_table": {
        brief: "The value of the `ExclusiveStartTableName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Users",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.exclusive_start_table attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `GlobalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_index_updates": {
        brief: "The JSON-serialized value of each item in the `GlobalSecondaryIndexUpdates` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "Create": { "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_index_updates attribute"
            }
        ]
    },
    "aws.dynamodb.index_name": {
        brief: "The value of the `IndexName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "name_to_group",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.index_name attribute"
            }
        ]
    },
    "aws.dynamodb.item_collection_metrics": {
        brief: "The JSON-serialized value of the `ItemCollectionMetrics` response field.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{ "string" : [ { "ItemCollectionKey": { "string" : { "B": blob, "BOOL": boolean, "BS": [ blob ], "L": [ "AttributeValue" ], "M": { "string" : "AttributeValue" }, "N": "string", "NS": [ "string" ], "NULL": boolean, "S": "string", "SS": [ "string" ] } }, "SizeEstimateRangeGB": [ number ] } ] }',
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.item_collection_metrics attribute"
            }
        ]
    },
    "aws.dynamodb.limit": {
        brief: "The value of the `Limit` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.limit attribute"
            }
        ]
    },
    "aws.dynamodb.local_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `LocalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexArn": "string", "IndexName": "string", "IndexSizeBytes": number, "ItemCount": number, "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.local_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.projection": {
        brief: "The value of the `ProjectionExpression` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Title, Price, Color",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.projection attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_read_capacity": {
        brief: "The value of the `ProvisionedThroughput.ReadCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_read_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_write_capacity": {
        brief: "The value of the `ProvisionedThroughput.WriteCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_write_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.scanned_count": {
        brief: "The value of the `ScannedCount` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scanned_count attribute"
            }
        ]
    },
    "aws.dynamodb.scan_forward": {
        brief: "The value of the `ScanIndexForward` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scan_forward attribute"
            }
        ]
    },
    "aws.dynamodb.segment": {
        brief: "The value of the `Segment` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.segment attribute"
            }
        ]
    },
    "aws.dynamodb.select": {
        brief: "The value of the `Select` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ALL_ATTRIBUTES",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.select attribute"
            }
        ]
    },
    "aws.dynamodb.table_count": {
        brief: "The number of items in the `TableNames` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_count attribute"
            }
        ]
    },
    "aws.dynamodb.table_names": {
        brief: "The keys in the `RequestItems` object field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "Users",
            "Cats"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_names attribute"
            }
        ]
    },
    "aws.dynamodb.total_segments": {
        brief: "The value of the `TotalSegments` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.total_segments attribute"
            }
        ]
    },
    "aws.extended_request_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        aliases: [
            "aws.request.extended_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.extended_request_id attribute"
            }
        ]
    },
    "aws.kinesis.stream_name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "some-stream-name",
        aliases: [
            "aws.kinesis.stream.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream_name attribute"
            }
        ]
    },
    "aws.kinesis.stream.name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "some-stream-name",
        deprecation: {
            replacement: "aws.kinesis.stream_name",
            reason: "This attribute is being deprecated in favor of aws.kinesis.stream_name, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.kinesis.stream_name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream.name attribute, deprecated in favor of aws.kinesis.stream_name"
            }
        ]
    },
    "aws.lambda.aws_request_id": {
        brief: "The AWS request ID as received by the Lambda function runtime",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8476a536-e9f4-11e8-9739-2dfe598c3fcd",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id"
        },
        aliases: [
            "faas.invocation_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.aws_request_id in favor of faas.invocation_id"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.aws_request_id attribute"
            }
        ]
    },
    "aws.lambda.execution_duration_in_millis": {
        brief: "The execution duration of the Lambda function invocation in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.execution_duration_in_millis attribute"
            }
        ]
    },
    "aws.lambda.function_name": {
        brief: "The name of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-function",
        deprecation: {
            replacement: "faas.name",
            reason: "Use the OTel-aligned faas.name attribute instead"
        },
        aliases: [
            "faas.name"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.function_name in favor of faas.name"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_name attribute"
            }
        ]
    },
    "aws.lambda.function_version": {
        brief: "The version of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "$LATEST",
        deprecation: {
            replacement: "faas.version",
            reason: "Use the OTel-aligned faas.version attribute instead"
        },
        aliases: [
            "faas.version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.function_version in favor of faas.version"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_version attribute"
            }
        ]
    },
    "aws.lambda.invoked_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        aliases: [
            "aws.lambda.invoked_function_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.lambda.invoked_function_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        deprecation: {
            replacement: "aws.lambda.invoked_arn",
            reason: "This attribute is being deprecated in favor of aws.lambda.invoked_arn"
        },
        aliases: [
            "aws.lambda.invoked_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.invoked_function_arn in favor of aws.lambda.invoked_arn"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.invoked_function_arn attribute"
            }
        ]
    },
    "aws.lambda.remaining_time_in_millis": {
        brief: "The remaining time in milliseconds before the Lambda function times out",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5e3,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.remaining_time_in_millis attribute"
            }
        ]
    },
    "aws.log.group.names": {
        brief: "The name(s) of the AWS log group(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "/aws/lambda/my-function",
            "opentelemetry-service"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.log.stream.names": {
        brief: "The name(s) of the AWS log stream(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "logs/main/10838bed-421f-43ef-870a-f43feacbbb5b"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.request.extended_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        deprecation: {
            replacement: "aws.extended_request_id",
            reason: "This attribute is being deprecated in favor of aws.extended_request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.extended_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.extended_id attribute, deprecated in favor of aws.extended_request_id"
            }
        ]
    },
    "aws.request_id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        aliases: [
            "aws.request.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request_id attribute"
            }
        ]
    },
    "aws.request.id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        deprecation: {
            replacement: "aws.request_id",
            reason: "This attribute is being deprecated in favor of aws.request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.id attribute, deprecated in favor of aws.request_id"
            }
        ]
    },
    "aws.s3.bucket": {
        brief: "The S3 bucket name the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ot-demo-test",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.s3.bucket attribute"
            }
        ]
    },
    "aws.secretsmanager.secret.arn": {
        brief: "The ARN of the Secret stored in Secrets Manager.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:secretsmanager:us-east-1:123456789012:secret:SecretName-6RandomCharacters",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.secretsmanager.secret.arn attribute"
            }
        ]
    },
    "aws.sns.topic.arn": {
        brief: "The ARN of the AWS SNS Topic. An Amazon SNS topic is a logical access point that acts as a communication channel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:sns:us-east-1:123456789012:mystack-mytopic-NZJ5JSMVGFIE",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.sns.topic.arn attribute"
            }
        ]
    },
    "aws.step_functions.activity.arn": {
        brief: "The ARN of the AWS Step Functions Activity.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:activity:get-greeting",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.activity.arn attribute"
            }
        ]
    },
    "aws.step_functions.state_machine.arn": {
        brief: "The ARN of the AWS Step Functions State Machine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:stateMachine:myStateMachine:1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.state_machine.arn attribute"
            }
        ]
    },
    blocked_main_thread: {
        brief: "Whether the main thread was blocked by the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        aliases: [
            "sentry.browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127,
                    139
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.performance.navigation.activation_start": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        aliases: [
            "performance.activationStart"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.navigation.activation_start attribute"
            }
        ]
    },
    "browser.performance.time_origin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        aliases: [
            "performance.timeOrigin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.time_origin attribute attribute"
            }
        ]
    },
    "browser.report.type": {
        brief: "A browser report sent via reporting API..",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "network-error",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "browser.script.invoker": {
        brief: "How a script was called in the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Window.requestAnimationFrame",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.invoker_type": {
        brief: "Browser script entry point type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "event-listener",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.source_char_position": {
        brief: "A number representing the script character position of the script.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 678,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        aliases: [
            "sentry.browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    59,
                    127,
                    139
                ]
            }
        ]
    },
    "browser.web_vital.cls.report_event": {
        brief: "The event that caused the SDK to report CLS (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "navigation",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.cls.report_event attribute"
            }
        ]
    },
    "browser.web_vital.cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        aliases: [
            "cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "browser.web_vital.cls.value": {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        aliases: [
            "cls"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.cls.value attribute"
            }
        ]
    },
    "browser.web_vital.fcp.value": {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        aliases: [
            "fcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.fp.value": {
        brief: "The time in milliseconds it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        aliases: [
            "fp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.inp.value": {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        aliases: [
            "inp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.inp.value attribute"
            }
        ]
    },
    "browser.web_vital.lcp.element": {
        brief: "The HTML element selector or component name for which LCP was reported",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "body > div#app > div#container > div",
        aliases: [
            "lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#gero",
        aliases: [
            "lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.load_time": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        aliases: [
            "lcp.loadTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.render_time": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        aliases: [
            "lcp.renderTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.report_event": {
        brief: "The event that caused the SDK to report LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.lcp.report_event attribute"
            }
        ]
    },
    "browser.web_vital.lcp.size": {
        brief: "The size of the largest contentful paint element",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        aliases: [
            "lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/static/img.png",
        aliases: [
            "lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.value": {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        aliases: [
            "lcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.lcp.value attribute"
            }
        ]
    },
    "browser.web_vital.ttfb.request_time": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        aliases: [
            "ttfb.requestTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.ttfb.value": {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in Milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194.3322,
        aliases: [
            "ttfb"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "cache.hit": {
        brief: "If the cache was hit during this span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.item_size": {
        brief: "The size of the requested item in the cache. In bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 58,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.key": {
        brief: "The key of the cache accessed.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "my-cache-key",
            "my-other-cache-key"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.operation": {
        brief: "The operation being performed on the cache.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "get",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.ttl": {
        brief: "The ttl of the cache in seconds",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.write": {
        brief: "If the cache operation resulted in a write to the cache.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    channel: {
        brief: "The channel name that is being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mail",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.address": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.client_ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.port": {
        brief: "Client port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 5432,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.duration": {
        brief: "The duration of a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 543,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.query_type": {
        brief: "The type of query executed in a Cloudflare D1 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "run",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "db.operation"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.d1.query_type attribute"
            }
        ]
    },
    "cloudflare.d1.rows_read": {
        brief: "The number of rows read in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.rows_written": {
        brief: "The number of rows written in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.durable_object.query.bindings": {
        brief: "The number of bound parameters passed to the SQL exec call.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.query.bindings attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_read": {
        brief: "The number of rows read by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_read attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_written": {
        brief: "The number of rows written by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_written attribute"
            }
        ]
    },
    "cloudflare.r2.bucket": {
        brief: "The name of the Cloudflare R2 bucket binding",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MY_BUCKET",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.bucket attribute"
            }
        ]
    },
    "cloudflare.r2.operation": {
        brief: "The R2 API operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GetObject",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.operation attribute"
            }
        ]
    },
    "cloudflare.r2.request.delimiter": {
        brief: "The delimiter used to group objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.delimiter attribute"
            }
        ]
    },
    "cloudflare.r2.request.key": {
        brief: "The object key used in the R2 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-file.txt",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.key attribute"
            }
        ]
    },
    "cloudflare.r2.request.part_number": {
        brief: "The part number in a multipart upload operation",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.part_number attribute"
            }
        ]
    },
    "cloudflare.r2.request.prefix": {
        brief: "The prefix used to filter objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "images/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.prefix attribute"
            }
        ]
    },
    "cloudflare.workflow.attempt": {
        brief: "The current attempt number for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.attempt attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.backoff": {
        brief: "The backoff strategy for Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "exponential",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.backoff attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.delay": {
        brief: "The delay between Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "5 seconds",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.delay attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.limit": {
        brief: "The maximum number of retries for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.limit attribute"
            }
        ]
    },
    "cloudflare.workflow.timeout": {
        brief: "The timeout duration for a Cloudflare Workflow step",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1 minute",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.timeout attribute"
            }
        ]
    },
    "cloud.account.id": {
        brief: "The cloud account ID the resource is assigned to",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "123456789012",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.account.id attribute"
            }
        ]
    },
    "cloud.availability_zone": {
        brief: "Cloud regions often have multiple, isolated locations known as zones to increase availability",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1c",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.availability_zone attribute"
            }
        ]
    },
    "cloud.platform": {
        brief: "The cloud platform in use",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws_lambda",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.platform attribute"
            }
        ]
    },
    "cloud.provider": {
        brief: "Name of the cloud provider",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.provider attribute"
            }
        ]
    },
    "cloud.region": {
        brief: "The geographical region the resource is running",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.region attribute"
            }
        ]
    },
    "cloud.resource_id": {
        brief: "Cloud provider-specific native identifier of the monitored cloud resource",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        aliases: [
            "faas.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ],
        additionalContext: [
            "This can be an identifier for a resource in AWS, GCP, or Azure. There may be some overlap in values found here with other attributes. For instance, an AWS lambda ARN may be found here as well as in `aws.lambda.invoked_arn`. OTEL recommends setting them alongside each other."
        ]
    },
    cls: {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        deprecation: {
            replacement: "browser.web_vital.cls.value",
            reason: "The CLS web vital is now recorded as a browser.web_vital.cls.value attribute."
        },
        aliases: [
            "browser.web_vital.cls.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        deprecation: {
            replacement: "browser.web_vital.cls.source.<key>",
            reason: "The CLS source is now recorded as a browser.web_vital.cls.source.<key> attribute."
        },
        aliases: [
            "browser.web_vital.cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "code.filepath": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        deprecation: {
            replacement: "code.file.path"
        },
        aliases: [
            "code.file.path"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.file.path": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        aliases: [
            "code.filepath"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function": {
        brief: "The method or function name, or equivalent (usually rightmost part of the code unit's name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function.name": {
        brief: "The method or function fully-qualified name without arguments.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.lineno": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        deprecation: {
            replacement: "code.line.number"
        },
        aliases: [
            "code.line.number"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.line.number": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        aliases: [
            "code.lineno"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.namespace": {
        brief: "The 'namespace' within which code.function is defined. Usually the qualified class or module name, such that code.namespace + some separator + code.function form a unique identifier for the code unit.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.handler",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    connectionType: {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.type for span-first future"
        },
        aliases: [
            "network.connection.type",
            "device.connection_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "network.connection.rtt",
            reason: "Old attribute name (no official namespace), to be replaced with network.connection.rtt for span-first future"
        },
        aliases: [
            "network.connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "culture.calendar": {
        brief: "The calendar system used by the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GregorianCalendar",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.display_name": {
        brief: "Human readable name of the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "English (United States)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.is_24_hour_format": {
        brief: "Whether the culture uses 24-hour time format.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.locale": {
        brief: "The locale identifier following RFC 4646.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.timezone": {
        brief: "The timezone of the culture, as a geographic timezone identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "db.collection.name": {
        brief: "The name of a collection (table, container) within the database.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "users",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.driver.name": {
        brief: "The name of the driver used for the database connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "psycopg2",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    297
                ],
                description: "Added db.driver.name attribute"
            }
        ]
    },
    "db.name": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        deprecation: {
            replacement: "db.namespace"
        },
        aliases: [
            "db.namespace"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.namespace": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        aliases: [
            "db.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation.batch.size": {
        brief: "The number of queries included in a batch operation. Operations are only considered batches when they contain two or more operations, and so db.operation.batch.size SHOULD never be 1.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    407
                ],
                description: "Added db.operation.batch.size attribute"
            }
        ]
    },
    "db.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        aliases: [
            "db.operation",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.parameter.<key>": {
        brief: "A query parameter used in db.query.text, with <key> being the parameter name, and the attribute value being a string representation of the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "db.query.parameter.foo='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103,
                    127
                ]
            }
        ]
    },
    "db.query.summary": {
        brief: "A shortened representation of operation(s) in the full query. This attribute must be low-cardinality and should only contain the operation table names.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT users",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.text": {
        brief: "The database parameterized query being executed. Any parameter values (filters, insertion values, etc) should be replaced with parameter placeholders. If applicable, use `db.query.parameter.<key>` to add the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users WHERE id = $1",
        aliases: [
            "db.statement"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.connection": {
        brief: "The redis connection name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-redis-instance",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.key": {
        brief: "The key the Redis command is operating on.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user:2047:city",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    326
                ],
                description: "Added db.redis.key attribute"
            }
        ]
    },
    "db.redis.parameters": {
        brief: "The array of command parameters given to a redis command.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "test",
            "*"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "db.response.status_code": {
        brief: "Database response status code. The status code returned by the database. Usually it represents an error code, but may also represent partial success, warning, or differentiate between various types of successful outcomes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ORA-17002",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    462
                ],
                description: "Added db.response.status_code attribute"
            }
        ]
    },
    "db.sql.bindings": {
        brief: "The array of query bindings.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "1",
            "foo"
        ],
        deprecation: {
            replacement: "db.query.parameter.<key>",
            reason: "Instead of adding every binding in the db.sql.bindings attribute, add them as individual entires with db.query.parameter.<key>."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.statement": {
        brief: "The database statement being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users",
        deprecation: {
            replacement: "db.query.text"
        },
        aliases: [
            "db.query.text"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.stored_procedure.name": {
        brief: "The name of a stored procedure being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GetUserById",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    398
                ]
            }
        ]
    },
    "db.system": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        deprecation: {
            replacement: "db.system.name"
        },
        aliases: [
            "db.system.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199,
                    224
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.system.name": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        aliases: [
            "db.system"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.user": {
        brief: "The database user.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "fancy_user",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    deviceMemory: {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8 GB",
        deprecation: {
            replacement: "device.memory.estimated_capacity",
            reason: "Old namespace-less attribute, to be replaced with device.memory.estimated_capacity for span-first future"
        },
        aliases: [
            "device.memory.estimated_capacity"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "device.archs": {
        brief: "The CPU architectures of the device.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "arm64-v8a",
            "armeabi-v7a",
            "armeabi"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.archs attribute"
            }
        ]
    },
    "device.battery_level": {
        brief: "The battery level of the device as a percentage (0-100).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_level attribute"
            }
        ]
    },
    "device.battery_temperature": {
        brief: "The battery temperature of the device in Celsius.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 25,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_temperature attribute"
            }
        ]
    },
    "device.boot_time": {
        brief: "A formatted UTC timestamp when the system was booted.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2018-02-08T12:52:12Z",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.boot_time attribute"
            }
        ]
    },
    "device.brand": {
        brief: "The brand of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Apple",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.charging": {
        brief: "Whether the device was charging or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.charging attribute"
            }
        ]
    },
    "device.chipset": {
        brief: "The chipset of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Qualcomm SM8550",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.chipset attribute"
            }
        ]
    },
    "device.class": {
        brief: "The classification of the device. For example, `low`, `medium`, or `high`. Typically inferred by Relay - SDKs generally do not need to set this directly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "medium",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.class attribute"
            }
        ]
    },
    "device.connection_type": {
        brief: "The internet connection type currently being used by the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "This attribute is being deprecated in favor of network.connection.type"
        },
        aliases: [
            "network.connection.type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added and deprecated device.connection_type in favor of network.connection.type"
            }
        ]
    },
    "device.cpu_description": {
        brief: "A description of the CPU of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Intel(R) Core(TM)2 Quad CPU Q6600 @ 2.40GHz",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.cpu_description attribute"
            }
        ]
    },
    "device.external_free_storage": {
        brief: "External storage free size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 67108864e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_free_storage attribute"
            }
        ]
    },
    "device.external_storage_size": {
        brief: "External storage total size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 134217728e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_storage_size attribute"
            }
        ]
    },
    "device.family": {
        brief: "The family of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.free_memory": {
        brief: "Free system memory in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.free_memory attribute"
            }
        ]
    },
    "device.free_storage": {
        brief: "Free device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 107374182400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.free_storage attribute"
            }
        ]
    },
    "device.id": {
        brief: "Unique device identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.id attribute"
            }
        ]
    },
    "device.locale": {
        brief: "The locale of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.locale attribute"
            }
        ]
    },
    "device.low_memory": {
        brief: "Whether the device was low on memory.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.low_memory attribute"
            }
        ]
    },
    "device.low_power_mode": {
        brief: "Whether the device is in Low Power Mode.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    314
                ],
                description: "Added device.low_power_mode attribute"
            }
        ]
    },
    "device.manufacturer": {
        brief: "The manufacturer of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Google",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.manufacturer attribute"
            }
        ]
    },
    "device.memory.estimated_capacity": {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes. Browsers report estimations in buckets of powers of 2, mostly capped at 8 GB",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "deviceMemory"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added attribute device.memory.estimated_capacity to be used instead of deviceMemory"
            }
        ]
    },
    "device.memory_size": {
        brief: "Total system memory available in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17179869184,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.memory_size attribute"
            }
        ]
    },
    "device.model": {
        brief: "The model of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone 15 Pro Max",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.model_id": {
        brief: "An internal hardware revision to identify the device exactly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "N861AP",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.model_id attribute"
            }
        ]
    },
    "device.name": {
        brief: "The name of the device. On mobile, this is the user-assigned device name. On servers and desktops, this is typically the hostname.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "localhost",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.name attribute"
            }
        ]
    },
    "device.online": {
        brief: "Whether the device was online or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.online attribute"
            }
        ]
    },
    "device.orientation": {
        brief: 'The orientation of the device, either "portrait" or "landscape".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "portrait",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.orientation attribute"
            }
        ]
    },
    "device.processor_count": {
        brief: 'Number of "logical processors".',
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "hardwareConcurrency"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added and deprecated attribute device.processor_count in favor of device.cpu.logical_core_count"
            }
        ]
    },
    "device.processor_frequency": {
        brief: "Processor frequency in MHz.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.processor_frequency attribute"
            }
        ]
    },
    "device.screen_density": {
        brief: "The screen density of the device.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2.625,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_density attribute"
            }
        ]
    },
    "device.screen_dpi": {
        brief: "The screen density in dots-per-inch (DPI) of the device.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 420,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_dpi attribute"
            }
        ]
    },
    "device.screen_height_pixels": {
        brief: "The height of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_height_pixels attribute"
            }
        ]
    },
    "device.screen_width_pixels": {
        brief: "The width of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1080,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_width_pixels attribute"
            }
        ]
    },
    "device.simulator": {
        brief: "Whether the device is a simulator or an actual device.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.simulator attribute"
            }
        ]
    },
    "device.storage_size": {
        brief: "Total device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 274877906944,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.storage_size attribute"
            }
        ]
    },
    "device.thermal_state": {
        brief: "The thermal state of the device. Based on Apple's `ProcessInfo.ThermalState` enum: `nominal`, `fair`, `serious`, or `critical`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "nominal",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.thermal_state attribute"
            }
        ]
    },
    "device.timezone": {
        brief: "The timezone of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.timezone attribute"
            }
        ]
    },
    "device.usable_memory": {
        brief: "Memory usable for the app in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.usable_memory attribute"
            }
        ]
    },
    dist: {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        deprecation: {
            replacement: "sentry.dist",
            reason: "This attribute is being deprecated in favor of sentry.dist."
        },
        aliases: [
            "sentry.dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist attribute"
            }
        ]
    },
    effectiveConnectionType: {
        brief: "Specifies the estimated effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        deprecation: {
            replacement: "network.connection.effective_type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.effective_type for span-first future"
        },
        aliases: [
            "network.connection.effective_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    environment: {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        aliases: [
            "sentry.environment"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "error.type": {
        brief: "Describes a class of error the operation ended with.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timeout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "event.id": {
        brief: "The unique identifier for this event (log record)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234567890,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101
                ]
            }
        ]
    },
    "event.name": {
        brief: "The name that uniquely identifies this event (log record)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Process Payload",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101,
                    127
                ]
            }
        ]
    },
    "exception.escaped": {
        brief: "SHOULD be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.message": {
        brief: "The error message.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.stacktrace": {
        brief: "A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: 'Exception in thread "main" java.lang.RuntimeException: Test exception\n at com.example.GenerateTrace.methodB(GenerateTrace.java:13)\n at com.example.GenerateTrace.methodA(GenerateTrace.java:9)\n at com.example.GenerateTrace.main(GenerateTrace.java:5)',
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.type": {
        brief: "The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OSError",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.coldstart": {
        brief: "A boolean that is true if the serverless function is executed for the first time (aka cold-start).",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.cron": {
        brief: "A string containing the schedule period as Cron Expression.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "0/5 * * * ? *",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.duration_in_ms": {
        brief: "The duration a function took to run, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.entry_point": {
        brief: "The code that's run when the cloud provider invokes your function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my_main_function",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.execution": {
        brief: "The execution ID of the current function execution.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "faas.invocation_id",
            "aws.lambda.aws_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution attribute, deprecated in favor of faas.invocation_id"
            }
        ]
    },
    "faas.id": {
        brief: "The unique ID of the single function that this runtime instance executes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        deprecation: {
            replacement: "cloud.resource_id",
            reason: "This attribute is being deprecated in favor of cloud.resource_id, which is the OTel-aligned replacement (renamed in OTel semantic conventions v1.19.0)."
        },
        aliases: [
            "cloud.resource_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id attribute, deprecated in favor of cloud.resource_id"
            }
        ]
    },
    "faas.identity": {
        brief: "The Service Account (GCP), IAM Execution Role (AWS), or Managed Identity (Azure) used by the serverless function when interacting with other cloud services",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "name@project.iam.gserviceaccount.com (GCP), arn:aws:iam::123456789012:role/role-name (AWS), 00000000-0000-0000-0000-000000000000 (Azure)",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.invocation_id": {
        brief: "The invocation ID of the current function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        aliases: [
            "aws.lambda.aws_request_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    "faas.invoked_name": {
        brief: "The name of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my-function",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_name attribute"
            }
        ]
    },
    "faas.invoked_provider": {
        brief: "The cloud provider of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_provider attribute"
            }
        ]
    },
    "faas.invoked_region": {
        brief: "The cloud region of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "eu-central-1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_region attribute"
            }
        ]
    },
    "faas.name": {
        brief: "The name of the serverless function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my_function",
        aliases: [
            "aws.lambda.function_name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.time": {
        brief: "A string containing the function invocation time in the ISO 8601 format expressed in UTC.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2020-01-23T13:47:06Z",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.trigger": {
        brief: "Type of the trigger which caused this function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timer",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.version": {
        brief: "The version of the function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "$LATEST",
        aliases: [
            "aws.lambda.function_version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    fcp: {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        deprecation: {
            replacement: "browser.web_vital.fcp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fcp.value"
        },
        aliases: [
            "browser.web_vital.fcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "flag.evaluation.<key>": {
        brief: "An instance of a feature flag evaluation. The value of this attribute is the boolean representing the evaluation result. The <key> suffix is the name of the feature flag.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "flag.evaluation.is_new_ui=true",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    fp: {
        brief: "The time it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        deprecation: {
            replacement: "browser.web_vital.fp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fp.value"
        },
        aliases: [
            "browser.web_vital.fp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "frames.delay": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        deprecation: {
            replacement: "app.vitals.frames.delay.value",
            reason: "Replaced by app.vitals.frames.delay.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.delay.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.delay.value"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "frames.frozen": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        deprecation: {
            replacement: "app.vitals.frames.frozen.count",
            reason: "Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.frozen.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.frozen.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_frozen_rate: {
        brief: "The rate of frozen frames, or `app_vitals.frames.frozen.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_frozen_rate attribute"
            }
        ]
    },
    "frames.slow": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        deprecation: {
            replacement: "app.vitals.frames.slow.count",
            reason: "Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.slow.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.slow.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_slow_rate: {
        brief: "The rate of slow frames, or `app_vitals.frames.slow.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_slow_rate attribute"
            }
        ]
    },
    "frames.total": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        deprecation: {
            replacement: "app.vitals.frames.total.count",
            reason: "Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.total.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.total.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    fs_error: {
        brief: "The error message of a file system error.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        deprecation: {
            replacement: "error.type",
            reason: "This attribute is not part of the OpenTelemetry specification and error.type fits much better."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gcp.function.context.event_id": {
        brief: "The event ID from the legacy GCP Cloud Function context (1st gen)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_id attribute"
            }
        ]
    },
    "gcp.function.context.event_type": {
        brief: "The type of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "google.pubsub.topic.publish",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_type attribute"
            }
        ]
    },
    "gcp.function.context.id": {
        brief: "The unique event ID from the GCP CloudEvents context (2nd gen Cloud Functions)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.id attribute"
            }
        ]
    },
    "gcp.function.context.resource": {
        brief: "The resource that triggered the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.resource attribute"
            }
        ]
    },
    "gcp.function.context.source": {
        brief: "The source of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "//pubsub.googleapis.com/projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.source attribute"
            }
        ]
    },
    "gcp.function.context.specversion": {
        brief: "The CloudEvents specification version of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.specversion attribute"
            }
        ]
    },
    "gcp.function.context.time": {
        brief: "The timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.time attribute"
            }
        ]
    },
    "gcp.function.context.timestamp": {
        brief: "The legacy timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.timestamp attribute"
            }
        ]
    },
    "gcp.function.context.type": {
        brief: "The type of the GCP Cloud Function event context",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cloud_functions.context",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.type attribute"
            }
        ]
    },
    "gcp.project.id": {
        brief: "The ID of the project in GCP that this resource is associated with",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-project-123",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "gen_ai.agent.name": {
        brief: "The name of the agent being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ResearchAssistant",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.context.utilization": {
        brief: "The fraction of the model context window utilized by this generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .75,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.utilization attribute"
            }
        ]
    },
    "gen_ai.context.window_size": {
        brief: "The maximum context window size supported by the model for this generation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 128e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.window_size attribute"
            }
        ]
    },
    "gen_ai.conversation.id": {
        brief: "The unique identifier for a conversation (session, thread), used to store and correlate messages within this conversation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "conv_5j66UpCpwteGg4YSxUnt7lPY",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    250
                ]
            }
        ]
    },
    "gen_ai.cost.cache_creation.input_tokens": {
        brief: "The cost of input tokens written to cache in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_creation.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_creation.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.cache_read.input_tokens": {
        brief: "The cost of cached input tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_read.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_read.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.input_tokens": {
        brief: "The total cost of all input tokens in USD (includes cached and cache creation tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.input_tokens.",
            "This is the total cost of all input tokens, including cached and cache creation tokens at their respective rates. For the cached portion, see gen_ai.cost.cache_read.input_tokens. For the cache creation portion, see gen_ai.cost.cache_creation.input_tokens."
        ]
    },
    "gen_ai.cost.output_tokens": {
        brief: "The total cost of all output tokens in USD (includes reasoning tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.output_tokens.",
            "This is the total cost of all output tokens, including reasoning tokens at their respective rate. For the reasoning portion, see gen_ai.cost.reasoning.output_tokens."
        ]
    },
    "gen_ai.cost.reasoning.output_tokens": {
        brief: "The cost of reasoning output tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.reasoning.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.reasoning.output_tokens.",
            "This is a subset of gen_ai.cost.output_tokens, not an independent cost. Do not sum this with gen_ai.cost.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.total_tokens": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        aliases: [
            "ai.total_cost"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    126
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.total_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.total_tokens."
        ]
    },
    "gen_ai.embeddings.input": {
        brief: "The input to the embeddings model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "What's the weather in Paris?",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    195
                ]
            }
        ]
    },
    "gen_ai.function_id": {
        brief: "Framework-specific tracing label for the execution of a function or other unit of execution in a generative AI system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-awesome-function",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    308
                ],
                description: "Added gen_ai.function_id attribute"
            }
        ]
    },
    "gen_ai.input.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "parts": [{"type": "text", "content": "Weather in Paris?"}]}, {"role": "assistant", "parts": [{"type": "tool_call", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "name": "get_weather", "arguments": {"location": "Paris"}}]}, {"role": "tool", "parts": [{"type": "tool_call_response", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "result": "rainy, 57\xB0F"}]}]',
        aliases: [
            "ai.texts"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.operation.name": {
        brief: "The name of the operation being performed. It has the following list of well-known values: 'chat', 'create_agent', 'embeddings', 'execute_tool', 'generate_content', 'invoke_agent', 'text_completion'. If one of them applies, then that value MUST be used. Otherwise a custom value MAY be used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "chat",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    225
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.operation.type": {
        brief: "The type of AI operation. Must be one of 'agent' (invoke_agent and create_agent spans), 'ai_client' (any LLM call), 'tool' (execute_tool spans), 'handoff' (handoff spans), 'other' (input and output processors, skill loading, guardrails etc.) . Added during ingestion based on span.op and gen_ai.operation.type. Used to filter and aggregate data in the UI",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "tool",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    257
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    113,
                    127
                ]
            }
        ]
    },
    "gen_ai.output.messages": {
        brief: "The model's response messages. It has to be a stringified version of an array of message objects, which can include text responses and tool calls.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "assistant", "parts": [{"type": "text", "content": "The weather in Paris is currently rainy with a temperature of 57\xB0F."}], "finish_reason": "stop"}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.pipeline.name": {
        brief: "Name of the AI pipeline or chain being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        aliases: [
            "ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    127
                ]
            }
        ]
    },
    "gen_ai.prompt": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            reason: "Deprecated from OTEL, use gen_ai.input.messages with the new format instead."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74,
                    108,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.prompt.name": {
        brief: "The name of the prompt that uniquely identifies it.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !0,
        visibility: "public",
        example: "summarize_text",
        aliases: [
            "mcp.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added gen_ai.prompt.name attribute"
            }
        ]
    },
    "gen_ai.provider.name": {
        brief: "The Generative AI provider as identified by the client or server instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        aliases: [
            "ai.model.provider",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            }
        ]
    },
    "gen_ai.request.available_tools": {
        brief: "The available tools for the model. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "description": "Get the weather for a given location"}, {"name": "get_news", "description": "Get the news for a given topic"}]',
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.max_tokens": {
        brief: "The maximum number of tokens to generate in the response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2048,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.request.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "system", "content": "Generate a random number."}, {"role": "user", "content": [{"text": "Generate a random number between 0 and 10.", "type": "text"}]}, {"role": "tool", "content": {"toolCallId": "1", "toolName": "Weather", "output": "rainy"}}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "ai.input_messages"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74,
                    108,
                    119,
                    122
                ]
            }
        ]
    },
    "gen_ai.request.model": {
        brief: "The model identifier being used for the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4-turbo-preview",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.reasoning_effort": {
        brief: "Constrains the effort on reasoning for reasoning models. Supported values vary by provider.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "high",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    334
                ],
                description: "Added gen_ai.request.reasoning_effort attribute"
            }
        ]
    },
    "gen_ai.request.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "ai.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.stop_sequences": {
        brief: "List of sequences that the model will use to stop generating further tokens.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "forest",
            "lived"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added gen_ai.request.stop_sequences attribute"
            }
        ]
    },
    "gen_ai.request.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .1,
        aliases: [
            "ai.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 35,
        aliases: [
            "ai.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .7,
        aliases: [
            "ai.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.response.finish_reasons": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "COMPLETE",
        aliases: [
            "ai.finish_reason"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gen_123abc",
        aliases: [
            "ai.generation_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.model": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4",
        aliases: [
            "ai.model_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.response.streaming": {
        brief: "Whether or not the AI model call's response was streamed back asynchronously",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "ai.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76
                ]
            }
        ]
    },
    "gen_ai.response.text": {
        brief: "The model's response text messages. It has to be a stringified version of an array of response text messages.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '["The weather in Paris is rainy and overcast, with temperatures around 57\xB0F", "The weather in London is sunny and warm, with temperatures around 65\xB0F"]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.response.time_to_first_chunk": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .6853435,
        aliases: [
            "gen_ai.response.time_to_first_token"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.response.time_to_first_chunk attribute"
            }
        ]
    },
    "gen_ai.response.time_to_first_token": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .6853435,
        deprecation: {
            replacement: "gen_ai.response.time_to_first_chunk"
        },
        aliases: [
            "gen_ai.response.time_to_first_chunk"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.response.time_to_first_chunk"
            },
            {
                version: "0.4.0",
                prs: [
                    227
                ]
            }
        ]
    },
    "gen_ai.response.tokens_per_second": {
        brief: "The total output tokens per seconds throughput",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12345.67,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    66
                ]
            }
        ]
    },
    "gen_ai.response.tool_calls": {
        brief: "The tool calls in the model's response. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "arguments": {"location": "Paris"}}]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.system": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "ai.model.provider",
            "gen_ai.provider.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.system_instructions": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "You are a helpful assistant",
        aliases: [
            "ai.preamble"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.system.message": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are a helpful assistant",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.call.arguments": {
        brief: "The arguments of the tool call. It has to be a stringified version of the arguments to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{"location": "Paris"}',
        aliases: [
            "gen_ai.tool.input"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.call.result": {
        brief: "The result of the tool call. It has to be a stringified version of the result of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "rainy, 57\xB0F",
        aliases: [
            "gen_ai.tool.output",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.definitions": {
        brief: "The list of source system tool definitions available to the GenAI agent or model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"type": "function", "name": "get_current_weather", "description": "Get the current weather in a given location", "parameters": {"type": "object", "properties": {"location": {"type": "string", "description": "The city and state, e.g. San Francisco, CA"}, "unit": {"type": "string", "enum": ["celsius", "fahrenheit"]}}, "required": ["location", "unit"]}}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.description": {
        brief: "The description of the tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Searches the web for current information about a topic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.input": {
        brief: "The input of the tool being used. It has to be a stringified version of the input to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"location": "Paris"}',
        deprecation: {
            replacement: "gen_ai.tool.call.arguments"
        },
        aliases: [
            "gen_ai.tool.call.arguments"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.message": {
        brief: "The response from a tool or function call passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.name": {
        brief: "Name of the tool utilized by the agent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Flights",
        aliases: [
            "ai.function_call",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.output": {
        brief: "The output of the tool being used. It has to be a stringified version of the output of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.type": {
        brief: "The type of tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "function",
        deprecation: {
            reason: "The gen_ai.tool.type attribute is deprecated and should no longer be set."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.usage.cache_creation.input_tokens": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        aliases: [
            "gen_ai.usage.input_tokens.cache_write"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.cache_read.input_tokens": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        aliases: [
            "gen_ai.usage.input_tokens.cached"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.completion_tokens": {
        brief: "The number of tokens used in the GenAI response (completion).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.output_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.input_tokens": {
        brief: "The number of tokens used to process the AI input (prompt) including cached input tokens.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.prompt_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes cached input tokens. gen_ai.usage.cache_read.input_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.input_tokens.cached": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        deprecation: {
            replacement: "gen_ai.usage.cache_read.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_read.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.input_tokens.cache_write": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "gen_ai.usage.cache_creation.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_creation.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_creation.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    217,
                    228
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.output_tokens": {
        brief: "The number of tokens used for creating the AI output (including reasoning tokens).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes reasoning tokens. gen_ai.usage.reasoning.output_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.output_tokens.reasoning": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 75,
        deprecation: {
            replacement: "gen_ai.usage.reasoning.output_tokens"
        },
        aliases: [
            "gen_ai.usage.reasoning.output_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.prompt_tokens": {
        brief: "The number of tokens used in the GenAI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.reasoning.output_tokens": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 75,
        aliases: [
            "gen_ai.usage.output_tokens.reasoning"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.total_tokens": {
        brief: "The total number of tokens used to process the prompt. (input tokens plus output todkens)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        aliases: [
            "ai.total_tokens.used"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is the sum of gen_ai.usage.input_tokens and gen_ai.usage.output_tokens. Do not sum this with either of them \u2014 they are already included."
        ]
    },
    "graphql.document": {
        brief: "The GraphQL document being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "The document may contain sensitive information in arguments or variables. Instrumentation should redact sensitive information when possible."
        },
        isInOtel: !0,
        visibility: "public",
        example: "query findBookById { bookById(id: ?) { name } }",
        changelog: [
            {
                version: "0.7.0",
                description: "Adds the `graphql.document` attribute to track the GraphQL document being executed."
            }
        ]
    },
    "graphql.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "findBookById",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "graphql.operation.type": {
        brief: "The type of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    hardwareConcurrency: {
        brief: "The number of logical CPU cores available.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "14",
        deprecation: {
            replacement: "device.processor_count",
            reason: "Old namespace-less attribute, to be replaced with device.processor_count for span-first future"
        },
        aliases: [
            "device.processor_count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281,
                    300
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "http.client_ip": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "client.address"
        },
        aliases: [
            "client.address"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.decoded_response_content_length": {
        brief: "The decoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.flavor": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.fragment": {
        brief: "The fragments present in the URI. Note that this contains the leading # character, while the `url.fragment` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.host": {
        brief: "The domain name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use one of `server.address` or `client.address`, depending on the usage"
        },
        aliases: [
            "server.address",
            "client.address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.query": {
        brief: "The query string present in the URL. Note that this contains the leading ? character, while the `url.query` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !1,
        visibility: "public",
        example: "?foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.body.data": {
        brief: "HTTP request body data. Can be given as string or structural data of any format.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added http.request.body.data attribute"
            }
        ]
    },
    "http.request.connection_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes establishing the connection to the server to retrieve the resource. The timestamp value includes the time interval to establish the transport connection, as well as other time intervals such as TLS handshake and SOCKS authentication.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955515e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.connect_start": {
        brief: "The UNIX timestamp representing the time immediately before the user agent starts establishing the connection to the server to retrieve the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555111e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes the domain-name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555201e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the domain name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555322e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.fetch_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts to fetch the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555389e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.header.<key>": {
        brief: "HTTP request headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.request.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.request.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        aliases: [
            "method",
            "http.method",
            "http.request_method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request_method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "method",
            "http.method",
            "http.request.method"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    343
                ],
                description: "Added http.request_method attribute"
            }
        ]
    },
    "http.request.redirect_end": {
        brief: "The UNIX timestamp representing the timestamp immediately after receiving the last byte of the response of the last redirect",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829558502e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.request.redirect_start": {
        brief: "The UNIX timestamp representing the start time of the fetch which that initiates the redirect.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555495e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.request_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955551e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.resend_count": {
        brief: "The ordinal number of request resending attempt (for any reason, including redirects).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser receives the last byte of the resource or immediately before the transport connection is closed, whichever comes first.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955589e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17328295557e-1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "url.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added http.request.same_origin attribute"
            }
        ]
    },
    "http.request.secure_connection_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the handshake process to secure the current connection. If a secure connection is not used, the property returns zero.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955573e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.time_to_first_byte": {
        brief: "The time in seconds from the browser's timeorigin to when the first byte of the request's response was received. See https://web.dev/articles/ttfb#measure-resource-requests",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.032,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    131
                ]
            }
        ]
    },
    "http.request.worker_start": {
        brief: "The UNIX timestamp representing the timestamp immediately before dispatching the FetchEvent if a Service Worker thread is already running, or immediately before starting the Service Worker thread if it is not already running.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955368e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.response.body.size": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        aliases: [
            "http.response_content_length",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_content_length": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        deprecation: {
            replacement: "http.response.body.size"
        },
        aliases: [
            "http.response.body.size",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.content-length": {
        brief: "The size of the message body sent to the recipient (in bytes)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.response.header.custom-header=['foo', 'bar']",
        aliases: [
            "http.response_content_length",
            "http.response.body.size"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.<key>": {
        brief: "HTTP response headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.response.size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 456,
        aliases: [
            "http.response_transfer_size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        aliases: [
            "http.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_transfer_size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        deprecation: {
            replacement: "http.response.size"
        },
        aliases: [
            "http.response.size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.route": {
        brief: "The matched route, that is, the path template in the format used by the respective server framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "url.template"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        deprecation: {
            replacement: "url.scheme"
        },
        aliases: [
            "url.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server_name": {
        brief: "The server domain name",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server.request.time_in_queue": {
        brief: "The time in milliseconds the request spent in the server queue before processing began. Measured from the X-Request-Start header set by reverse proxies (e.g., Nginx, HAProxy, Heroku) to when the application started handling the request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    267
                ]
            }
        ]
    },
    "http.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        deprecation: {
            replacement: "http.response.status_code"
        },
        aliases: [
            "http.response.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.target": {
        brief: "The pathname and query string of the URL.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.path",
            reason: "This attribute is being deprecated in favor of url.path and url.query"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.url": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.user_agent": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        deprecation: {
            replacement: "user_agent.original"
        },
        aliases: [
            "user_agent.original"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    id: {
        brief: "A unique identifier for the span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    inp: {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        deprecation: {
            replacement: "browser.web_vital.inp.value",
            reason: "The INP web vital is now recorded as a browser.web_vital.inp.value attribute."
        },
        aliases: [
            "browser.web_vital.inp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "jsonrpc.protocol.version": {
        brief: "The version of the JSON-RPC protocol used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.0",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.protocol.version attribute"
            }
        ]
    },
    "jsonrpc.request.id": {
        brief: "The JSON-RPC request identifier. Unique within the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1",
        aliases: [
            "mcp.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.request.id attribute"
            }
        ]
    },
    "jvm.gc.action": {
        brief: "Name of the garbage collector action.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "end of minor GC",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.gc.name": {
        brief: "Name of the garbage collector.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Young Generation",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.pool.name": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.type": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.daemon": {
        brief: "Whether the thread is daemon or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.state": {
        brief: "State of the thread.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "blocked",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "koa.name": {
        brief: "The name of the Koa middleware or matched route that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "No single replacement. SDKs should use http.route for router layers and code.function.name for middleware layers instead."
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    490
                ],
                description: "Added koa.name attribute as deprecated"
            }
        ]
    },
    "koa.type": {
        brief: "The type of the Koa layer that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    471
                ],
                description: "Added koa.type attribute"
            }
        ]
    },
    lcp: {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        deprecation: {
            replacement: "browser.web_vital.lcp.value",
            reason: "The LCP web vital is now recorded as a browser.web_vital.lcp.value attribute."
        },
        aliases: [
            "browser.web_vital.lcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "lcp.element": {
        brief: "The dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        deprecation: {
            replacement: "browser.web_vital.lcp.element",
            reason: "The LCP element is now recorded as a browser.web_vital.lcp.element attribute."
        },
        aliases: [
            "browser.web_vital.lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#hero",
        deprecation: {
            replacement: "browser.web_vital.lcp.id",
            reason: "The LCP id is now recorded as a browser.web_vital.lcp.id attribute."
        },
        aliases: [
            "browser.web_vital.lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.loadTime": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        deprecation: {
            replacement: "browser.web_vital.lcp.load_time",
            reason: "The LCP load time is now recorded as a browser.web_vital.lcp.load_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.load_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.renderTime": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        deprecation: {
            replacement: "browser.web_vital.lcp.render_time",
            reason: "The LCP render time is now recorded as a browser.web_vital.lcp.render_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.render_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.size": {
        brief: "The size of the largest contentful paint element.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        deprecation: {
            replacement: "browser.web_vital.lcp.size",
            reason: "The LCP size is now recorded as a browser.web_vital.lcp.size attribute."
        },
        aliases: [
            "browser.web_vital.lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com",
        deprecation: {
            replacement: "browser.web_vital.lcp.url",
            reason: "The LCP url is now recorded as a browser.web_vital.lcp.url attribute."
        },
        aliases: [
            "browser.web_vital.lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "logger.name": {
        brief: "The name of the logger that generated this event.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "myLogger",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "mcp.cancelled.reason": {
        brief: "Reason for the cancellation of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Cancellation reasons may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "User cancelled the request",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.cancelled.request_id": {
        brief: "Request ID of the cancelled MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.name": {
        brief: "Name of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "claude-desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.title": {
        brief: "Display title of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Client titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Claude Desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.version": {
        brief: "Version of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.lifecycle.phase": {
        brief: "Lifecycle phase indicator for MCP operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "initialization_complete",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.data_type": {
        brief: "Data type of the logged message content.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "string",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.level": {
        brief: "Log level for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "info",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.logger": {
        brief: "Logger name for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Logger names may be user-defined and could contain sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mcp_server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.message": {
        brief: "Log message content from MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Log messages can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Tool execution completed successfully",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.method.name": {
        brief: "The name of the MCP request or notification method being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tools/call",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.current": {
        brief: "Current progress value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.message": {
        brief: "Progress message describing the current state of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Progress messages may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Processing 50 of 100 items",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.percentage": {
        brief: "Calculated progress percentage of an MCP operation. Computed from current/total * 100.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.token": {
        brief: "Token for tracking progress of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "progress-token-123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.total": {
        brief: "Total progress target value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.name": {
        brief: "Name of the MCP prompt template being used.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        deprecation: {
            replacement: "gen_ai.prompt.name",
            reason: "OTel uses gen_ai.prompt.name for MCP prompt names"
        },
        aliases: [
            "gen_ai.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.prompt.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.description": {
        brief: "Description of the prompt result.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "A summary of the requested information",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_content": {
        brief: "Content of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Please provide a summary of the document",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_count": {
        brief: "Number of messages in the prompt result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_role": {
        brief: "Role of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.ready": {
        brief: "Protocol readiness indicator for MCP session. Non-zero value indicates the protocol is ready.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.version": {
        brief: "MCP protocol version used in the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2024-11-05",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.<key>": {
        brief: "MCP request argument with dynamic key suffix. The <key> is replaced with the actual argument name. The value is a JSON-stringified representation of the argument value.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Arguments contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mcp.request.argument.query='weather in Paris'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "mcp.request.argument.name": {
        brief: "Name argument from prompts/get MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Prompt names can contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.uri": {
        brief: "URI argument from resources/read MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain user file paths"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file:///path/to/resource",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.id": {
        brief: "JSON-RPC request identifier for the MCP request. Unique within the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "jsonrpc.request.id",
            reason: "OTel models MCP as JSON-RPC, uses jsonrpc.request.id"
        },
        aliases: [
            "jsonrpc.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of jsonrpc.request.id"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.protocol": {
        brief: "Protocol of the resource URI being accessed, extracted from the URI.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file",
        deprecation: {
            replacement: "network.protocol.name",
            reason: "OTel uses the generic network.protocol.name attribute"
        },
        aliases: [
            "network.protocol.name",
            "net.protocol.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.protocol.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.uri": {
        brief: "The resource URI being accessed in an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain sensitive file paths"
        },
        isInOtel: !0,
        visibility: "public",
        example: "file:///path/to/file.txt",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.name": {
        brief: "Name of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry-mcp-server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.title": {
        brief: "Display title of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Server titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Sentry MCP Server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.version": {
        brief: "Version of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "0.1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.session.id": {
        brief: "Identifier for the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "550e8400-e29b-41d4-a716-446655440000",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.name": {
        brief: "Name of the MCP tool being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "calculator",
        deprecation: {
            replacement: "gen_ai.tool.name",
            reason: "OTel uses gen_ai.tool.name for MCP tool names"
        },
        aliases: [
            "gen_ai.tool.name",
            "ai.function_call"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.content": {
        brief: "The content of the tool result.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Tool results can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"output": "rainy", "toolCallId": "1"}',
        deprecation: {
            replacement: "gen_ai.tool.call.result",
            reason: "OTel uses gen_ai.tool.call.result for MCP tool results"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.call.result"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    164
                ]
            }
        ]
    },
    "mcp.tool.result.content_count": {
        brief: "Number of content items in the tool result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.is_error": {
        brief: "Whether a tool execution resulted in an error.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {
            replacement: "error.type",
            reason: "OTel uses error.type set to 'tool_error' when isError is true. Cannot be automatically backfilled due to type mismatch (boolean vs string)."
        },
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of error.type"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.transport": {
        brief: "Transport method used for MCP communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdio",
        deprecation: {
            replacement: "network.transport",
            reason: "OTel uses the generic network.transport attribute"
        },
        aliases: [
            "network.transport",
            "net.transport"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.transport"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mdc.<key>": {
        brief: "Attributes from the Mapped Diagnostic Context (MDC) present at the moment the log record was created. The MDC is supported by all the most popular logging solutions in the Java ecosystem, and it's usually implemented as a thread-local map that stores context for e.g. a specific request.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mdc.some_key='some_value'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "messaging.batch.message_count": {
        brief: "The number of messages sent, received, or processed in the scope of the batching operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    341
                ],
                description: "Added messaging.batch.message_count attribute"
            }
        ]
    },
    "messaging.destination": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        deprecation: {
            replacement: "messaging.destination.name",
            reason: "This attribute is being deprecated in favor of messaging.destination.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "messaging.destination.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination attribute, deprecated in favor of messaging.destination.name"
            }
        ]
    },
    "messaging.destination.connection": {
        brief: "The message destination connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.destination.name": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "BestTopic",
        aliases: [
            "messaging.destination"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.body.size": {
        brief: "The size of the message body in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 839,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.conversation_id": {
        brief: 'The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "MyConversationId",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.message.conversation_id attribute"
            }
        ]
    },
    "messaging.message.envelope.size": {
        brief: "The size of the message body and metadata in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1045,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.id": {
        brief: "A value used by the messaging system as an identifier for the message, represented as a string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.receive.latency": {
        brief: "The latency between when the message was published and received.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732847252,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.retry.count": {
        brief: "The amount of attempts to send the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.operation.name": {
        brief: "The name of the messaging operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "send",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added messaging.operation.name attribute"
            }
        ]
    },
    "messaging.operation.type": {
        brief: "A string identifying the type of the messaging operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "create",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    51,
                    127
                ]
            }
        ]
    },
    "messaging.rabbitmq.destination.routing_key": {
        brief: "RabbitMQ message routing key.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myKey",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.rabbitmq.destination.routing_key attribute"
            }
        ]
    },
    "messaging.system": {
        brief: "The messaging system as identified by the client instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "activemq",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    method: {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "http.method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "middleware.name": {
        brief: "The name of the middleware.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added middleware.name attribute"
            }
        ]
    },
    "navigation.origin": {
        brief: "The origin of the navigation (usually client side router navigations). Should preferrably parameterized template (like url.template) or a URL path otherwise.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "sentry.sveltekit.navigation.from"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added navigation.origin attribute"
            }
        ]
    },
    "navigation.route.id": {
        brief: "The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AboutView",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added navigation.route.id attribute"
            }
        ]
    },
    "navigation.type": {
        brief: "The type of navigation done by a client-side router.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router.push",
        aliases: [
            "sentry.sveltekit.navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added new deprecated alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "nel.elapsed_time": {
        brief: "The elapsed number of milliseconds between the start of the resource fetch and when it was completed or aborted by the user agent.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.phase": {
        brief: 'If request failed, the phase of its network error. If request succeeded, "application".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "application",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.referrer": {
        brief: "request's referrer, as determined by the referrer policy associated with its client.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/foo?bar=baz",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.sampling_function": {
        brief: "The sampling function used to determine if the request should be sampled.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.type": {
        brief: 'If request failed, the type of its network error. If request succeeded, "ok".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dns.unreachable",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "network.connection.effective_type": {
        brief: "Specifies the effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        aliases: [
            "effectiveConnectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.effective_type to be used instead of effectiveConnectionType"
            }
        ]
    },
    "network.connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        aliases: [
            "connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.rtt to be used instead of connection.rtt"
            }
        ]
    },
    "network.connection.type": {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wifi",
        aliases: [
            "device.connection_type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.type to be used instead of connectionType"
            }
        ]
    },
    "network.local.address": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.host.ip",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.local.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        aliases: [
            "net.sock.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.address": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.peer.ip",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        aliases: [
            "net.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        aliases: [
            "http.flavor",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        aliases: [
            "net.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.type": {
        brief: "OSI network layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ipv4",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.ip": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "http.server_name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port"
        },
        aliases: [
            "server.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.ip": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use server.address on client spans and client.address on server spans."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.port": {
        brief: "Peer port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port",
            reason: "Deprecated, use server.port on client spans and client.port on server spans."
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        deprecation: {
            replacement: "network.protocol.name"
        },
        aliases: [
            "network.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "http.flavor"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.family": {
        brief: "OSI transport and network layer",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "inet",
        deprecation: {
            replacement: "network.transport",
            reason: "Deprecated, use network.transport and network.type."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.addr": {
        brief: "Local address of the network connection mapping to Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.host.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.local.port"
        },
        aliases: [
            "network.local.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.addr": {
        brief: "Peer address of the network connection - IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.peer.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.name": {
        brief: "Peer address of the network connection - Unix domain socket name",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            reason: "Deprecated from OTEL, no replacement at this time"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    119,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.peer.port"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        deprecation: {
            replacement: "network.transport"
        },
        aliases: [
            "network.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.build": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "os.build_id"
        },
        aliases: [
            "os.build_id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build attribute, deprecated in favor of os.build_id"
            }
        ]
    },
    "os.build_id": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "os.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build as alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.description": {
        brief: "Human readable (not intended to be parsed) OS version information, like e.g. reported by ver or lsb_release -a commands.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu 18.04.1 LTS",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.kernel_version": {
        brief: "An independent kernel version string. Typically the entire output of the `uname` syscall.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "20.2.0",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.kernel_version attribute"
            }
        ]
    },
    "os.name": {
        brief: "Human readable operating system name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.raw_description": {
        brief: "An unprocessed description string obtained by the operating system. For some well-known runtimes, Sentry will attempt to parse `name` and `version` from this string, if they are not explicitly given.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ubuntu 22.04.4 LTS (Jammy Jellyfish)",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.raw_description attribute"
            }
        ]
    },
    "os.rooted": {
        brief: "Whether the operating system has been jailbroken or rooted.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.rooted attribute"
            }
        ]
    },
    "os.theme": {
        brief: "Whether the OS runs in dark mode or light mode.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dark",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.theme attribute"
            }
        ]
    },
    "os.type": {
        brief: "The operating system type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "linux",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.version": {
        brief: "The version of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.kind": {
        brief: "The span kind (https://opentelemetry.io/docs/concepts/signals/traces/#span-kind). Deprecated, use `sentry.kind` instead.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SERVER",
        deprecation: {
            replacement: "sentry.kind",
            reason: "Deprecated in favor of sentry.kind"
        },
        aliases: [
            "sentry.kind"
        ],
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    440
                ],
                description: "Added otel.kind attribute"
            }
        ]
    },
    "otel.scope.name": {
        brief: "The name of the instrumentation scope - (InstrumentationScope.Name in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "io.opentelemetry.contrib.mongodb",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.scope.version": {
        brief: "The version of the instrumentation scope - (InstrumentationScope.Version in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.4.5",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_code": {
        brief: "Name of the code, either \u201COK\u201D or \u201CERROR\u201D. MUST NOT be set if the status code is UNSET.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OK",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_description": {
        brief: "Description of the Status if it has a value, otherwise not set.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "resource not found",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "params.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "params.id='123'",
        aliases: [
            "url.path.parameter.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "performance.activationStart": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        deprecation: {
            replacement: "browser.performance.navigation.activation_start",
            reason: "The activationStart is now recorded as the browser.performance.navigation.activation_start attribute."
        },
        aliases: [
            "browser.performance.navigation.activation_start"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.activationStart attribute"
            }
        ]
    },
    "performance.timeOrigin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        deprecation: {
            replacement: "browser.performance.time_origin",
            reason: "The timeOrigin is now recorded as the browser.performance.time_origin attribute."
        },
        aliases: [
            "browser.performance.time_origin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.timeOrigin attribute"
            }
        ]
    },
    previous_route: {
        brief: "Also used by mobile SDKs to indicate the previous route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeScreen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.command_args": {
        brief: "All the command arguments (including the command/executable itself) as received by the process.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "cmd/otecol",
            "--config=config.yaml"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    327
                ],
                description: "Added process.command_args attribute"
            }
        ]
    },
    "process.executable.name": {
        brief: "The name of the executable that started the process.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "getsentry",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.pid": {
        brief: "The process ID of the running process.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 12345,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.description": {
        brief: "An additional description about the runtime of the process, for example a specific vendor customization of the runtime environment. Equivalent to `raw_description` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        aliases: [
            "runtime.raw_description"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.name": {
        brief: "The name of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "v8",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.version": {
        brief: "The version of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "12.9.202.13-rusty",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.name": {
        brief: "The name of the runtime. Equivalent to `name` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "node",
        aliases: [
            "runtime.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.version": {
        brief: "The version of the runtime of this process, as returned by the runtime without modification. Equivalent to `version` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        aliases: [
            "runtime.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "query.<key>": {
        brief: "An item in a query string. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "query.id='123'",
        deprecation: {
            replacement: "url.query",
            reason: "Instead of sending items individually in query.<key>, they should be sent all together with url.query."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "react.version": {
        brief: "The version of the React framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.2.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    368
                ],
                description: "Added react.version attribute"
            }
        ]
    },
    release: {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.release"
        },
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "remix.action_form_data.<key>": {
        brief: "Remix form data, <key> being the form data key, the value being the form data value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.text='test'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    replay_id: {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        deprecation: {
            replacement: "sentry.replay_id"
        },
        aliases: [
            "sentry.replay_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "resource.deployment.environment": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    266
                ]
            }
        ]
    },
    "resource.deployment.environment.name": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    196
                ]
            }
        ]
    },
    "resource.render_blocking_status": {
        brief: "The render blocking status of the resource.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "non-blocking",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    route: {
        brief: "The matched route, that is, the path template in the format used by the respective server framework. Also used by mobile SDKs to indicate the current route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "App\\Controller::indexAction",
        deprecation: {
            replacement: "http.route"
        },
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.grpc.status_code": {
        brief: "The numeric status code of the gRPC request.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.method": {
        brief: "The fully-qualified logical name of the method from the RPC interface perspective.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "com.example.ExampleService/exampleMethod",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    351
                ],
                description: "Added rpc.method attribute"
            }
        ]
    },
    "rpc.response.status_code": {
        brief: "Status code of the RPC returned by the RPC server or generated by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "DEADLINE_EXCEEDED",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    352
                ],
                description: "Added rpc.response.status_code attribute"
            }
        ]
    },
    "rpc.service": {
        brief: "The full (logical) name of the service being called, including its package name, if applicable.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myService.BestService",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.system": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        deprecation: {
            replacement: "rpc.system.name",
            reason: "This attribute is being deprecated in favor of rpc.system.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "rpc.system.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system attribute, deprecated in favor of rpc.system.name"
            }
        ]
    },
    "rpc.system.name": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        aliases: [
            "rpc.system"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system.name attribute"
            }
        ]
    },
    "runtime.build": {
        brief: "The application build string, when it is separate from the version.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stable",
        deprecation: {
            reason: "The runtime.* namespace is deprecated in favor of process.runtime.*. No direct OTel equivalent exists for this attribute."
        },
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.build attribute"
            }
        ]
    },
    "runtime.name": {
        brief: "The name of the runtime. For example node, CPython, or rustc.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "node",
        deprecation: {
            replacement: "process.runtime.name",
            reason: "Prefer OTel-aligned process.runtime.name"
        },
        aliases: [
            "process.runtime.name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.name attribute in favor of process.runtime.name"
            }
        ]
    },
    "runtime.raw_description": {
        brief: "Unprocessed description string as obtained from the runtime. Used to extract name and version for well-known runtimes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        deprecation: {
            replacement: "process.runtime.description",
            reason: "Prefer OTel-aligned process.runtime.description"
        },
        aliases: [
            "process.runtime.description"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.raw_description attribute in favor of process.runtime.description"
            }
        ]
    },
    "runtime.version": {
        brief: "The version of the runtime.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.04.2",
        deprecation: {
            replacement: "process.runtime.version",
            reason: "Prefer OTel-aligned process.runtime.version"
        },
        aliases: [
            "process.runtime.version"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.version attribute in favor of process.runtime.version"
            }
        ]
    },
    "score.<key>": {
        brief: "The weighted performance score for a web vital. This is defined as `score.weight.<key>` * `score.ratio.<key>`.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.cls=0.1723",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.<key> attribute"
            }
        ]
    },
    "score.ratio.<key>": {
        brief: "The score for a web vital, normalized to a number between 0 and 1.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.ratio.inp=0.7748",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.ratio.<key> attribute"
            }
        ]
    },
    "score.total": {
        brief: "The total performance score of a span. This is the sum of individual weighted web vital scores (see `score.<key>`).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.total attribute"
            }
        ]
    },
    "score.weight.<key>": {
        brief: "The relative weight of a web vital in a span's performance score.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.weight.fcp=0.25",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.weight.<key> attribute"
            }
        ]
    },
    "sentry.action": {
        brief: "Used as a generic attribute representing the action depending on the type of span. For instance, this is the database query operation for DB spans, and the request method for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        deprecation: {
            replacement: "browser.name"
        },
        aliases: [
            "browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        deprecation: {
            replacement: "browser.version"
        },
        aliases: [
            "browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.cancellation_reason": {
        brief: "The reason why a span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "document.hidden",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.category": {
        brief: "The high-level category of a span, derived from the span operation or span attributes. This categorizes spans by their general purpose (e.g., database, HTTP, UI). Known values include: 'ai', 'ai.pipeline', 'app', 'browser', 'cache', 'console', 'db', 'event', 'file', 'function.aws', 'function.azure', 'function.gcp', 'function.nextjs', 'function.remix', 'graphql', 'grpc', 'http', 'measure', 'middleware', 'navigation', 'pageload', 'queue', 'resource', 'rpc', 'serialize', 'subprocess', 'template', 'topic', 'ui', 'ui.angular', 'ui.ember', 'ui.react', 'ui.svelte', 'ui.vue', 'view', 'websocket'.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "db",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    218
                ]
            }
        ]
    },
    "sentry.client_sample_rate": {
        brief: "Rate at which a span was sampled in the SDK.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.description": {
        brief: "The human-readable description of a span.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "index view query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    135
                ]
            }
        ]
    },
    "sentry.dist": {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        aliases: [
            "dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist as an alias"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.domain": {
        brief: "Used as a generic attribute representing the domain depending on the type of span. For instance, this is the collection/table name for database spans, and the server address for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.dsc.environment": {
        brief: "The environment from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "prod",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.project_id": {
        brief: "The ID of the project where the trace originated (i.e. the project of the SDK that started the trace). Propagated through the dynamic sampling context and set by Relay during ingestion.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "12345",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    358
                ],
                description: "Add sentry.dsc.project_id as an attribute"
            }
        ]
    },
    "sentry.dsc.public_key": {
        brief: "The public key from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "c51734c603c4430eb57cb0a5728a479d",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.release": {
        brief: "The release identifier from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "frontend@e8211be71b214afab5b85de4b4c54be3714952bb",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sampled": {
        brief: "Whether the event was sampled according to the dynamic sampling context.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sample_rate": {
        brief: "The sample rate from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.trace_id": {
        brief: "The trace ID from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "047372980460430cbc78d9779df33a46",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.transaction": {
        brief: "The transaction name from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "/issues/errors-outages/",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.environment": {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        aliases: [
            "environment"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.exclusive_time": {
        brief: "The exclusive time duration of the span in milliseconds.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    160
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.graphql.operation": {
        brief: "Indicates the type of graphql operation, emitted by the Javascript SDK.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "getUserById",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.group": {
        brief: "Stores the hash of `sentry.normalized_description`. This is primarily used for grouping spans in the product end.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.http.prefetch": {
        brief: "If an http request was a prefetch request.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.idle_span_finish_reason": {
        brief: "The reason why an idle span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "idleTimeout",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.is_remote": {
        brief: "Indicates whether a span's parent is remote.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.kind": {
        brief: "Used to clarify the relationship between parents and children, or to distinguish between spans, e.g. a `server` and `client` span with the same name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "server",
        aliases: [
            "otel.kind"
        ],
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.main_thread": {
        brief: "Whether the span or event occurred on the main thread. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.message.parameter.<key>": {
        brief: "A parameter used in the message template. <key> can either be the number that represent the parameter's position in the template string (sentry.message.parameter.0, sentry.message.parameter.1, etc) or the parameter's name (sentry.message.parameter.item_id, sentry.message.parameter.user_id, etc)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry.message.parameter.0='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.message.template": {
        brief: "The parameterized template string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Hello, {name}!",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.metric.source": {
        brief: "The provenance of a metric.  For example, this can be set to indicate if a metric was generated by Relay from a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "span",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    476
                ],
                description: "Added sentry.metric.source attribute"
            }
        ]
    },
    "sentry.mobile": {
        brief: "Whether the application is using a mobile SDK. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.module.<key>": {
        brief: "A module that was loaded in the process. The key is the name of the module.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "sentry.module.brianium/paratest='v7.7.0'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.route": {
        brief: "A parameterized route for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions when the file location of the function is known.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/posts/[id]/layout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.type": {
        brief: "A descriptor for a for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "generateMetadata",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.normalized_db_query": {
        brief: "The normalized version of `db.query.text`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    194
                ]
            }
        ]
    },
    "sentry.normalized_db_query.hash": {
        brief: "The hash of `sentry.normalized_db_query`.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    200
                ]
            }
        ]
    },
    "sentry.normalized_description": {
        brief: "Used as a generic attribute representing the normalized `sentry.description`. This refers to the legacy use case of `sentry.description` where it holds relevant data depending on the type of span (e.g. database query, resource url, http request description, etc).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.observed_timestamp_nanos": {
        brief: "The timestamp at which an envelope was received by Relay, in nanoseconds.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1544712660300000000",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    174
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    137
                ]
            }
        ]
    },
    "sentry.op": {
        brief: "The operation of a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "http.client",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.origin": {
        brief: "The origin of the instrumentation (e.g. span, log, etc.)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "auto.http.otel.fastify",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.platform": {
        brief: "The sdk platform that generated the event.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "php",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.profiler_id": {
        brief: "The id of the currently running profiler (continuous profiling)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18779b64dd35d1a538e7ce2dd2d3fad3",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    242
                ]
            }
        ]
    },
    "sentry.profile_id": {
        brief: "The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    344
                ],
                description: "Added sentry.profile_id attribute"
            }
        ]
    },
    "sentry.release": {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        aliases: [
            "service.version",
            "release"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_id": {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        aliases: [
            "replay_id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_is_buffering": {
        brief: "A sentinel attribute on log events indicating whether the current Session Replay is being buffered (onErrorSampleRate).",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.report_event": {
        brief: "(Deprecated) The event that caused the SDK to report CLS or LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        deprecation: {
            reason: "The report event is now recorded as a browser.web_vital.lcp.report_event or browser.web_vital.cls.report_event attribute. No backfill required."
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    320
                ],
                description: "Added sentry.report_event attribute"
            }
        ]
    },
    "sentry.sdk.integrations": {
        brief: "A list of names identifying enabled integrations. The list shouldhave all enabled integrations, including default integrations. Defaultintegrations are included because different SDK releases may contain differentdefault integrations.",
        type: "string[]",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "InboundFilters",
            "FunctionToString",
            "BrowserApiErrors",
            "Breadcrumbs"
        ],
        changelog: [
            {
                version: "0.0.0",
                prs: [
                    42
                ]
            }
        ]
    },
    "sentry.sdk.name": {
        brief: "The sentry sdk name.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "@sentry/react",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.sdk.version": {
        brief: "The sentry sdk version.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.segment.id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        aliases: [
            "sentry.segment_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    107,
                    124
                ]
            }
        ]
    },
    "sentry.segment_id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        deprecation: {
            replacement: "sentry.segment.id"
        },
        aliases: [
            "sentry.segment.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    124
                ]
            }
        ]
    },
    "sentry.segment.name": {
        brief: "The segment name of a span",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /user",
        aliases: [
            "sentry.transaction",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Added sentry.transaction and transaction aliases"
            },
            {
                version: "0.1.0",
                prs: [
                    104
                ]
            }
        ]
    },
    "sentry.server_sample_rate": {
        brief: "Rate at which a span was sampled in Relay.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        deprecation: {
            replacement: "sentry.span.source",
            reason: "This attribute is being deprecated in favor of sentry.span.source"
        },
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.span.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    214
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.status": {
        brief: 'The span\'s status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.',
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.status_code": {
        brief: "The HTTP status code used in Sentry Insights. Typically set by Sentry during ingestion, rather than by clients.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    223,
                    228
                ]
            }
        ]
    },
    "sentry.status.message": {
        brief: "The from OTLP extracted status message.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "foobar",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.sveltekit.navigation.from": {
        brief: "the navigation origin (sveltekit router)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/home",
        deprecation: {
            replacement: "navigation.origin",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.from attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.to": {
        brief: "the navigation destination",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "the navigation destination is already covered by url.* attributes"
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.to attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.type": {
        brief: "The type of navigation event emitted from the sveltekit client router",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "link",
        deprecation: {
            replacement: "navigation.type",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.type attribute"
            }
        ]
    },
    "sentry.thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 56,
        deprecation: {
            replacement: "thread.id",
            reason: "This attribute is being deprecated in favor of the OTel-standard thread.id"
        },
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    451
                ]
            }
        ]
    },
    "sentry.timestamp.sequence": {
        brief: "A sequencing counter for deterministic ordering of logs or metrics when timestamps share the same integer millisecond. Starts at 0 on SDK initialization, increments by 1 for each captured item, and resets to 0 when the integer millisecond of the current item differs from the previous one.",
        type: "integer",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    262
                ]
            }
        ]
    },
    "sentry.trace_lifecycle": {
        brief: "Indicates the chosen trace lifecycle mode of the SDK (stream or static)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stream",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    442
                ],
                description: "Added sentry.trace_lifecycle attribute"
            }
        ]
    },
    "sentry.trace.parent_span_id": {
        brief: "The span id of the span that was active when the log was collected. This should not be set if there was no active span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "b0e6f15b45c36b12",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    287
                ],
                description: "Deprecate `sentry.trace.parent_span_id`"
            },
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.trace.status": {
        brief: 'The segment\'s status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.',
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.transaction": {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name",
            reason: "This attribute is being deprecated in favor of sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Deprecated sentry.transaction in favor of sentry.segment.name"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.email"
        },
        aliases: [
            "user.email"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.city"
        },
        aliases: [
            "user.geo.city"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.country_code"
        },
        aliases: [
            "user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.region"
        },
        aliases: [
            "user.geo.region"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.subdivision"
        },
        aliases: [
            "user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.id"
        },
        aliases: [
            "user.id"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.ip": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.ip_address"
        },
        aliases: [
            "user.ip_address"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.username": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.name"
        },
        aliases: [
            "user.name"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "server.address": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.server_name",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    server_name: {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "This attribute is being deprecated in favor of server.address, which is the OTel-aligned replacement."
        },
        aliases: [
            "server.address",
            "http.server_name",
            "net.host.name",
            "http.host"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    477
                ],
                description: "Added server_name attribute, deprecated in favor of server.address"
            }
        ]
    },
    "server.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        aliases: [
            "net.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.name": {
        brief: "Logical name of the service.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "omegastar",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.version": {
        brief: "The version string of the service API or implementation. The format is not defined by these conventions.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "5.0.0",
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "session.id": {
        brief: "A unique id identifying the active session at the time of setting this attribute",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "00112233-4455-6677-8899-aabbccddeeff",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    412
                ],
                description: "Added session.id attribute"
            }
        ]
    },
    stall_percentage: {
        brief: "The fraction of time the app was stalled. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_percentage attribute"
            }
        ]
    },
    stall_total_time: {
        brief: "The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_total_time attribute"
            }
        ]
    },
    "state.type": {
        brief: "The type of state management library",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "redux",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    365
                ],
                description: "Added state.type attribute"
            }
        ]
    },
    "thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 56,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "thread.name": {
        brief: "Current thread name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "timber.tag": {
        brief: "The log tag provided by the timber logging framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MyTag",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    183
                ]
            }
        ]
    },
    time_to_full_display: {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttfd.value",
            reason: "Replaced by app.vitals.ttfd.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttfd.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttfd.value"
            }
        ]
    },
    time_to_initial_display: {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttid.value",
            reason: "Replaced by app.vitals.ttid.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttid.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttid.value"
            }
        ]
    },
    transaction: {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "sentry.transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Updated transaction deprecation replacement to sentry.segment.name"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "trpc.procedure_path": {
        brief: "The path of the tRPC procedure being called",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user.getById",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_path attribute"
            }
        ]
    },
    "trpc.procedure_type": {
        brief: "The type of the tRPC procedure",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_type attribute"
            }
        ]
    },
    ttfb: {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194,
        deprecation: {
            replacement: "browser.web_vital.ttfb.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.value"
        },
        aliases: [
            "browser.web_vital.ttfb.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "ttfb.requestTime": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        deprecation: {
            replacement: "browser.web_vital.ttfb.request_time",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.request_time"
        },
        aliases: [
            "browser.web_vital.ttfb.request_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    type: {
        brief: "More granular type of the operation happening.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "fetch",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.component_name": {
        brief: "The name of the associated component.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeButton",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttfd": {
        brief: "Whether the span execution contributed to the TTFD (time to fully drawn) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttid": {
        brief: "Whether the span execution contributed to the TTID (time to initial display) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.element.height": {
        brief: "The height of the UI element (for Html in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 256,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.height attribute"
            }
        ]
    },
    "ui.element.id": {
        brief: "The id of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "btn-login",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.id attribute"
            }
        ]
    },
    "ui.element.identifier": {
        brief: "The identifier used to measure the UI element timing",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "heroImage",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.identifier attribute"
            }
        ]
    },
    "ui.element.load_time": {
        brief: "The loading time of a UI element (from time origin to finished loading)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 998.2234,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.load_time attribute"
            }
        ]
    },
    "ui.element.paint_type": {
        brief: "The type of element paint. Can either be 'image-paint' or 'text-paint'",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "image-paint",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.paint_type attribute"
            }
        ]
    },
    "ui.element.render_time": {
        brief: "The rendering time of the UI element (from time origin to finished rendering)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1023.1124,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.render_time attribute"
            }
        ]
    },
    "ui.element.type": {
        brief: "type of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.type attribute"
            }
        ]
    },
    "ui.element.url": {
        brief: "The URL of the UI element (e.g. an img src)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://assets.myapp.com/hero.png",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.url attribute"
            }
        ]
    },
    "ui.element.width": {
        brief: "The width of the UI element (for HTML in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 512,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.width attribute"
            }
        ]
    },
    url: {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "http.url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.domain": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.fragment": {
        brief: "The fragments present in the URI. Note that this does not contain the leading # character, while the `http.fragment` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.full": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        aliases: [
            "http.url",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path": {
        brief: "The URI path component.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/foo",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path.parameter.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "url.path.parameter.id='123'",
        aliases: [
            "params.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "url.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.query": {
        brief: "The query string present in the URL. Note that this does not contain the leading ? character, while the `http.query` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !0,
        visibility: "public",
        example: "foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "http.request.same_origin",
            reason: "This attribute is being deprecated in favor of http.request.same_origin."
        },
        aliases: [
            "http.request.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added url.same_origin attribute, deprecated in favor of http.request.same_origin"
            }
        ]
    },
    "url.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        aliases: [
            "http.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.template": {
        brief: "The low-cardinality template of an absolute path reference.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user_agent.original": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        aliases: [
            "http.user_agent"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "test@example.com",
        aliases: [
            "sentry.user.email"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.full_name": {
        brief: "User's full name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "John Smith",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Toronto",
        aliases: [
            "sentry.user.geo.city"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "CA",
        aliases: [
            "sentry.user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Canada",
        aliases: [
            "sentry.user.geo.region"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ontario",
        aliases: [
            "sentry.user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.hash": {
        brief: "Unique user hash to correlate information for a user in anonymized form.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "8ae4c2993e0f4f3b8b2d1b1f3b5e8f4d",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "S-1-5-21-202424912787-2692429404-2351956786-1000",
        aliases: [
            "sentry.user.id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.ip_address": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "192.168.1.1",
        aliases: [
            "sentry.user.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    75
                ]
            }
        ]
    },
    "user.name": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "j.smith",
        aliases: [
            "sentry.user.username"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.roles": {
        brief: "Array of user roles at the time of the event.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "admin",
            "editor"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "vercel.branch": {
        brief: "Git branch name for Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.build_id": {
        brief: "Identifier for the Vercel build (only present on build logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "bld_cotnkcr76",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.deployment_id": {
        brief: "Identifier for the Vercel deployment",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dpl_233NRGRjVZX1caZrXWtz5g1TAksD",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.destination": {
        brief: "Origin of the external content in Vercel (only on external logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://vitals.vercel-insights.com/v1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.edge_type": {
        brief: "Type of edge runtime in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "edge-function",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.entrypoint": {
        brief: "Entrypoint for the request in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api/index.js",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.execution_region": {
        brief: "Region where the request is executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.id": {
        brief: "Unique identifier for the log entry in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1573817187330377061717300000",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja3_digest": {
        brief: "JA3 fingerprint digest of Vercel request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "769,47-53-5-10-49161-49162-49171-49172-50-56-19-4,0-10-11,23-24-25,0",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja4_digest": {
        brief: "JA4 fingerprint digest",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "t13d1516h2_8daaf6152771_02713d6af862",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.log_type": {
        brief: "Vercel log output type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdout",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.path": {
        brief: "Function or dynamic path of the request in Vercel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/[route].json",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    349
                ],
                description: "Added vercel.path attribute"
            }
        ]
    },
    "vercel.project_id": {
        brief: "Identifier for the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gdufoJxB6b9b1fEqr1jUtFkyavUU",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.project_name": {
        brief: "Name of the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.cache_id": {
        brief: "Original request ID when request is served from cache",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pdx1::v8g4b-1744143786684-93dafbc0f70d",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.client_ip": {
        brief: "Client IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.75.16.101",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.host": {
        brief: "Hostname of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "test.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.lambda_region": {
        brief: "Region where lambda function executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.method": {
        brief: "HTTP method of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path": {
        brief: "Request path with query parameters",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/some-value.json?route=some-value",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type": {
        brief: "How the request was served based on its path and project configuration",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "func",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type_variant": {
        brief: "Variant of the path type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.referer": {
        brief: "Referer of the request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "*.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.region": {
        brief: "Region where the request is processed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.response_byte_size": {
        brief: "Size of the response in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.scheme": {
        brief: "Protocol of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.status_code": {
        brief: "HTTP status code of the proxy request",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.timestamp": {
        brief: "Unix timestamp when the proxy request was made",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1573817250172,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.user_agent": {
        brief: "User agent strings of the request",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Mozilla/5.0..."
        ],
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_cache": {
        brief: "Cache status sent to the browser",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "REVALIDATED",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_id": {
        brief: "Vercel-specific identifier",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1::abc123",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_action": {
        brief: "Action taken by firewall rules",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "deny",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_rule_id": {
        brief: "ID of the firewall rule that matched",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rule_gAHz8jtSB1Gy",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.request_id": {
        brief: "Identifier of the Vercel request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "643af4e3-975a-4cc7-9e7a-1eda11539d90",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.source": {
        brief: "Origin of the Vercel log (build, edge, lambda, static, external, or firewall)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "build",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.status_code": {
        brief: "HTTP status code of the request (-1 means no response returned and the lambda crashed)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    }
};



var $82aed6a67a552ecb$var$DEFAULT_BASE_URL = "thismessage:/";
function $82aed6a67a552ecb$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
function $82aed6a67a552ecb$export$2004d912a9ead694(url, urlBase) {
    var isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    var base = urlBase !== null && urlBase !== void 0 ? urlBase : isRelative ? $82aed6a67a552ecb$var$DEFAULT_BASE_URL : void 0;
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        var fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch (e) {}
    return void 0;
}
function $82aed6a67a552ecb$export$5339fcdc8e2a427c(url) {
    if ($82aed6a67a552ecb$export$e258e13805402ba7(url)) return url.pathname;
    var newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $82aed6a67a552ecb$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    var _request_method;
    var _request_method_toUpperCase;
    var method = (_request_method_toUpperCase = request === null || request === void 0 ? void 0 : (_request_method = request.method) === null || _request_method === void 0 ? void 0 : _request_method.toUpperCase()) !== null && _request_method_toUpperCase !== void 0 ? _request_method_toUpperCase : "GET";
    var route = routeName ? routeName : urlObject ? kind === "client" ? $82aed6a67a552ecb$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return "".concat(method, " ").concat(route);
}
function $82aed6a67a552ecb$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    var _obj;
    var attributes = (_obj = {}, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), spanOrigin), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$d7a7d984b0791405), "url"), _obj);
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $5d82adaea61c8fa9$export$d7a7d984b0791405] = "route";
    }
    if (request === null || request === void 0 ? void 0 : request.method) attributes[0, $5d82adaea61c8fa9$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $5d82adaea61c8fa9$export$d7a7d984b0791405] = "route";
        }
        if (!$82aed6a67a552ecb$export$e258e13805402ba7(urlObject)) {
            attributes[0, $117bb525af114730$export$40eacf1a072c9dbd] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $82aed6a67a552ecb$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $82aed6a67a552ecb$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $82aed6a67a552ecb$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $82aed6a67a552ecb$export$e0ba26c9e23e1fe0(url) {
    var protocol = url.protocol, host = url.host, path = url.path;
    var filteredHost = (host === null || host === void 0 ? void 0 : host.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "")) || "";
    return "".concat(protocol ? "".concat(protocol, "://") : "").concat(filteredHost).concat(path);
}
function $82aed6a67a552ecb$export$8abd806fcaf234fa(url) {
    var includeDataPrefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (url.startsWith("data:")) {
        var match = url.match(/^data:([^;,]+)/);
        var mimeType = match ? match[1] : "text/plain";
        var isBase64 = url.includes(";base64,");
        var dataStart = url.indexOf(",");
        var dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            var data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? "".concat(data.slice(0, 10), "... [truncated]") : data;
        }
        return "data:".concat(mimeType).concat(isBase64 ? ",base64" : "").concat(dataPrefix ? ",".concat(dataPrefix) : "");
    }
    return url;
}






var $50b9444442511a8d$var$handlers = {};
var $50b9444442511a8d$var$instrumented = {};
function $50b9444442511a8d$export$a4e09611e30da72e(type, handler) {
    $50b9444442511a8d$var$handlers[type] = $50b9444442511a8d$var$handlers[type] || [];
    $50b9444442511a8d$var$handlers[type].push(handler);
    return function() {
        var typeHandlers = $50b9444442511a8d$var$handlers[type];
        if (typeHandlers) {
            var index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $50b9444442511a8d$export$b17eab759a1cb5fe() {
    Object.keys($50b9444442511a8d$var$handlers).forEach(function(key) {
        $50b9444442511a8d$var$handlers[key] = void 0;
    });
}
function $50b9444442511a8d$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$50b9444442511a8d$var$instrumented[type]) {
        $50b9444442511a8d$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).error("Error while instrumenting ".concat(type), e);
        }
    }
}
function $50b9444442511a8d$export$b18c893e424d3127(type, data) {
    var typeHandlers = type && $50b9444442511a8d$var$handlers[type];
    if (!typeHandlers) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat((0, $6fde3090981c9aa7$export$aad197c7121a6651)(handler), "\nError:"), e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}


var $69a3078823a49f97$var$_oldOnErrorHandler = null;
function $69a3078823a49f97$export$55b5c3ba2194f0c6(handler) {
    var type = "error";
    (0, $50b9444442511a8d$export$a4e09611e30da72e)(type, handler);
    (0, $50b9444442511a8d$export$e18d6c5462c01368)(type, $69a3078823a49f97$var$instrumentError);
}
function $69a3078823a49f97$var$instrumentError() {
    $69a3078823a49f97$var$_oldOnErrorHandler = (0, $6001140c9a325157$export$f1a6cdb1459e81d1).onerror;
    (0, $6001140c9a325157$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        var handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $50b9444442511a8d$export$b18c893e424d3127)("error", handlerData);
        if ($69a3078823a49f97$var$_oldOnErrorHandler) return $69a3078823a49f97$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $6001140c9a325157$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}




var $c1b0d5acd6fef93f$var$_oldOnUnhandledRejectionHandler = null;
function $c1b0d5acd6fef93f$export$8bf4fc6858821a4e(handler) {
    var type = "unhandledrejection";
    (0, $50b9444442511a8d$export$a4e09611e30da72e)(type, handler);
    (0, $50b9444442511a8d$export$e18d6c5462c01368)(type, $c1b0d5acd6fef93f$var$instrumentUnhandledRejection);
}
function $c1b0d5acd6fef93f$var$instrumentUnhandledRejection() {
    $c1b0d5acd6fef93f$var$_oldOnUnhandledRejectionHandler = (0, $6001140c9a325157$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $6001140c9a325157$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        var handlerData = e;
        (0, $50b9444442511a8d$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($c1b0d5acd6fef93f$var$_oldOnUnhandledRejectionHandler) return $c1b0d5acd6fef93f$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $6001140c9a325157$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





var $a22d054c95b6a8db$var$errorsInstrumented = false;
function $a22d054c95b6a8db$export$b0914730ee1f6c80() {
    if ($a22d054c95b6a8db$var$errorsInstrumented) return;
    function errorCallback() {
        var activeSpan = (0, $79515206909fddff$export$1be426a8e585c83e)();
        var rootSpan = activeSpan && (0, $79515206909fddff$export$c4c6a79b1260ca1b)(activeSpan);
        if (rootSpan) {
            var message = "internal_error";
            (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Tracing] Root span: ".concat(message, " -> Global error occurred"));
            rootSpan.setStatus({
                code: (0, $6ec04d3e01c80cf6$export$f966a0446ece71e),
                message: message
            });
        }
    }
    $a22d054c95b6a8db$var$errorsInstrumented = true;
    (0, $69a3078823a49f97$export$55b5c3ba2194f0c6)(errorCallback);
    (0, $c1b0d5acd6fef93f$export$8bf4fc6858821a4e)(errorCallback);
}


var $1SnSh = parcelRequire("1SnSh");

var $XnYkK = parcelRequire("XnYkK");






var $6iP9u = parcelRequire("6iP9u");



function $9fb6aa6e5a686ce5$var$logIgnoredSpan(droppedSpan) {
    (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Ignoring span ".concat(droppedSpan.op, " - ").concat(droppedSpan.description, " because it matches `ignoreSpans`."));
}
function $9fb6aa6e5a686ce5$export$5d569ac97c389400(span, ignoreSpans) {
    if (!(ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ignoreSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var pattern = _step.value;
            if ($9fb6aa6e5a686ce5$var$isStringOrRegExp(pattern)) {
                if (span.description && (0, $45aea333cf5bef5d$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                    (0, $63491170aaadd711$export$16a28057038b10ef) && $9fb6aa6e5a686ce5$var$logIgnoredSpan(span);
                    return true;
                }
                continue;
            }
            var hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
            if (!pattern.name && !pattern.op && !hasAttributes) continue;
            var nameMatches = pattern.name ? span.description && (0, $45aea333cf5bef5d$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
            var opMatches = pattern.op ? span.op && (0, $45aea333cf5bef5d$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
            var attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(function(param) {
                var _param = (0, $6iP9u._)(param, 2), key = _param[0], valuePattern = _param[1];
                var _span_attributes;
                return $9fb6aa6e5a686ce5$var$_matchesAttributeValue((_span_attributes = span.attributes) === null || _span_attributes === void 0 ? void 0 : _span_attributes[key], valuePattern);
            }) : true;
            if (nameMatches && opMatches && attrsMatch) {
                (0, $63491170aaadd711$export$16a28057038b10ef) && $9fb6aa6e5a686ce5$var$logIgnoredSpan(span);
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $9fb6aa6e5a686ce5$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, $45aea333cf5bef5d$export$cdded5b28a5f8c6d)(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every(function(v, i) {
        return v === pat[i];
    });
    return actual === pat;
}
function $9fb6aa6e5a686ce5$export$ddf57376e818b444(spans, dropSpan) {
    var droppedSpanParentId = dropSpan.parent_span_id;
    var droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = spans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var span = _step.value;
            if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $9fb6aa6e5a686ce5$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}







var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $XnYkK = parcelRequire("XnYkK");



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $XnYkK = parcelRequire("XnYkK");


function $3a2af6feab215f7b$export$d3f49b33a1f44720(callback) {
    (0, $27958f6402fc5d96$export$e73679ffaf56810e)(callback, "_streamed", true);
    return callback;
}
function $3a2af6feab215f7b$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}




var $hwO3w = parcelRequire("hwO3w");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");





function $c4622bb7cd663145$export$f93f7f385160c44e(headers) {
    var items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return [
        headers,
        items
    ];
}
function $c4622bb7cd663145$export$d650323442802f6f(envelope, newItem) {
    var _envelope = (0, $6iP9u._)(envelope, 2), headers = _envelope[0], items = _envelope[1];
    return [
        headers,
        (0, $XnYkK._)(items).concat([
            newItem
        ])
    ];
}
function $c4622bb7cd663145$export$c56c55acf0136fd3(envelope, callback) {
    var envelopeItems = envelope[1];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = envelopeItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var envelopeItem = _step.value;
            var envelopeItemType = envelopeItem[0].type;
            var result = callback(envelopeItem, envelopeItemType);
            if (result) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $c4622bb7cd663145$export$604a45d95a155e2b(envelope, types) {
    return $c4622bb7cd663145$export$c56c55acf0136fd3(envelope, function(_, type) {
        return types.includes(type);
    });
}
function $c4622bb7cd663145$var$encodeUTF8(input) {
    var carrier = (0, $8a2f538a13cfc001$export$c8bfa33e4e8ae492)((0, $6001140c9a325157$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $c4622bb7cd663145$var$decodeUTF8(input) {
    var carrier = (0, $8a2f538a13cfc001$export$c8bfa33e4e8ae492)((0, $6001140c9a325157$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $c4622bb7cd663145$export$32f9b428425aac85(envelope) {
    var _envelope = (0, $6iP9u._)(envelope, 2), envHeaders = _envelope[0], items = _envelope[1];
    var parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $c4622bb7cd663145$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $c4622bb7cd663145$var$encodeUTF8(next) : next);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _item = (0, $6iP9u._)(item, 2), itemHeaders = _item[0], payload = _item[1];
            append("\n".concat(JSON.stringify(itemHeaders), "\n"));
            if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
            else {
                var stringifiedPayload = void 0;
                try {
                    stringifiedPayload = JSON.stringify(payload);
                } catch (e) {
                    stringifiedPayload = JSON.stringify((0, $74542fb861c25274$export$a3295358bff77e)(payload));
                }
                append(stringifiedPayload);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return typeof parts === "string" ? parts : $c4622bb7cd663145$var$concatBuffers(parts);
}
function $c4622bb7cd663145$var$concatBuffers(buffers) {
    var totalLength = buffers.reduce(function(acc, buf) {
        return acc + buf.length;
    }, 0);
    var merged = new Uint8Array(totalLength);
    var offset = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var buffer = _step.value;
            merged.set(buffer, offset);
            offset += buffer.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return merged;
}
function $c4622bb7cd663145$export$3338d0c7b6e17a2b(env) {
    var buffer = typeof env === "string" ? $c4622bb7cd663145$var$encodeUTF8(env) : env;
    function readBinary(length) {
        var bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        var i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($c4622bb7cd663145$var$decodeUTF8(readBinary(i)));
    }
    var envelopeHeader = readJson();
    var items = [];
    while(buffer.length){
        var itemHeader = readJson();
        var binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $c4622bb7cd663145$export$655cf139bc8b8afd(spanJson) {
    var spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $c4622bb7cd663145$export$d8fc80952cc31fa4(attachment) {
    var buffer = typeof attachment.data === "string" ? $c4622bb7cd663145$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
var $c4622bb7cd663145$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $c4622bb7cd663145$var$_isOverriddenType(type) {
    return type in $c4622bb7cd663145$var$DATA_CATEGORY_OVERRIDES;
}
function $c4622bb7cd663145$export$b11169581eeaf237(type) {
    return $c4622bb7cd663145$var$_isOverriddenType(type) ? $c4622bb7cd663145$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $c4622bb7cd663145$export$d369f3b2758f6743(metadataOrEvent) {
    if (!(metadataOrEvent === null || metadataOrEvent === void 0 ? void 0 : metadataOrEvent.sdk)) return;
    var _metadataOrEvent_sdk = metadataOrEvent.sdk, name = _metadataOrEvent_sdk.name, version = _metadataOrEvent_sdk.version;
    return {
        name: name,
        version: version
    };
}
function $c4622bb7cd663145$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    var _event_sdkProcessingMetadata;
    var dynamicSamplingContext = (_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.dynamicSamplingContext;
    return (0, $hwO3w._)({
        event_id: event.event_id,
        sent_at: new Date((0, $dd2c5f85fcbd9c64$export$65b1bada40c91b34)()).toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $a77c6f8fcbd294ab$export$44d472fbb931a776)(dsn)
    }, dynamicSamplingContext && {
        trace: dynamicSamplingContext
    });
}





function $1fb0c290380959ae$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    var _event_sdk, _event_sdk1, _event_sdk2, _event_sdk3;
    if (!newSdkInfo) return event;
    var eventSdkInfo = event.sdk || {};
    event.sdk = (0, $lf4fc._)((0, $hwO3w._)({}, eventSdkInfo), {
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: (0, $XnYkK._)(((_event_sdk = event.sdk) === null || _event_sdk === void 0 ? void 0 : _event_sdk.integrations) || []).concat((0, $XnYkK._)(newSdkInfo.integrations || [])),
        packages: (0, $XnYkK._)(((_event_sdk1 = event.sdk) === null || _event_sdk1 === void 0 ? void 0 : _event_sdk1.packages) || []).concat((0, $XnYkK._)(newSdkInfo.packages || [])),
        settings: ((_event_sdk2 = event.sdk) === null || _event_sdk2 === void 0 ? void 0 : _event_sdk2.settings) || newSdkInfo.settings ? (0, $hwO3w._)({}, (_event_sdk3 = event.sdk) === null || _event_sdk3 === void 0 ? void 0 : _event_sdk3.settings, newSdkInfo.settings) : void 0
    });
    return event;
}
function $1fb0c290380959ae$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    var sdkInfo = (0, $c4622bb7cd663145$export$d369f3b2758f6743)(metadata);
    var envelopeHeaders = (0, $hwO3w._)({
        sent_at: new Date((0, $dd2c5f85fcbd9c64$export$65b1bada40c91b34)()).toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $a77c6f8fcbd294ab$export$44d472fbb931a776)(dsn)
    });
    var envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $c4622bb7cd663145$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
function $1fb0c290380959ae$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    var sdkInfo = (0, $c4622bb7cd663145$export$d369f3b2758f6743)(metadata);
    var eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $1fb0c290380959ae$export$8a6cdb6116a9fd2b(event, metadata === null || metadata === void 0 ? void 0 : metadata.sdk);
    var envelopeHeaders = (0, $c4622bb7cd663145$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    var eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $c4622bb7cd663145$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
function $1fb0c290380959ae$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    var dsc = (0, $0d1fd6101086a96b$export$a117f995597e25df)(spans[0]);
    var dsn = client === null || client === void 0 ? void 0 : client.getDsn();
    var tunnel = client === null || client === void 0 ? void 0 : client.getOptions().tunnel;
    var headers = (0, $hwO3w._)({
        sent_at: new Date((0, $dd2c5f85fcbd9c64$export$65b1bada40c91b34)()).toISOString()
    }, dscHasRequiredProps(dsc) && {
        trace: dsc
    }, !!tunnel && dsn && {
        dsn: (0, $a77c6f8fcbd294ab$export$44d472fbb931a776)(dsn)
    });
    var _ref = (client === null || client === void 0 ? void 0 : client.getOptions()) || {}, beforeSendSpan = _ref.beforeSendSpan, ignoreSpans = _ref.ignoreSpans;
    var filteredSpans = (ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) ? spans.filter(function(span) {
        var json = (0, $79515206909fddff$export$92d8c23565496537)(span);
        return !(0, $9fb6aa6e5a686ce5$export$5d569ac97c389400)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    var droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client === null || client === void 0 ? void 0 : client.recordDroppedEvent("before_send", "span", droppedSpans);
    var convertToSpanJSON = beforeSendSpan ? function(span) {
        var spanJson = (0, $79515206909fddff$export$92d8c23565496537)(span);
        var processedSpan = !(0, $3a2af6feab215f7b$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $79515206909fddff$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $79515206909fddff$export$92d8c23565496537);
    var items = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = filteredSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var span = _step.value;
            var spanJson = convertToSpanJSON(span);
            if (spanJson) items.push((0, $c4622bb7cd663145$export$655cf139bc8b8afd)(spanJson));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, $c4622bb7cd663145$export$f93f7f385160c44e)(headers, items);
}











function $ac49fc821818ee9c$export$2f3d84e767c9592b(span) {
    if (!(0, $63491170aaadd711$export$16a28057038b10ef)) return;
    var _spanToJSON = (0, $79515206909fddff$export$92d8c23565496537)(span), _spanToJSON_description = _spanToJSON.description, description = _spanToJSON_description === void 0 ? "< unknown name >" : _spanToJSON_description, _spanToJSON_op = _spanToJSON.op, op = _spanToJSON_op === void 0 ? "< unknown op >" : _spanToJSON_op, parentSpanId = _spanToJSON.parent_span_id;
    var spanId = span.spanContext().spanId;
    var sampled = (0, $79515206909fddff$export$5caecac1caaf3a71)(span);
    var rootSpan = (0, $79515206909fddff$export$c4c6a79b1260ca1b)(span);
    var isRootSpan = rootSpan === span;
    var header = "[Tracing] Starting ".concat(sampled ? "sampled" : "unsampled", " ").concat(isRootSpan ? "root " : "", "span");
    var infoParts = [
        "op: ".concat(op),
        "name: ".concat(description),
        "ID: ".concat(spanId)
    ];
    if (parentSpanId) infoParts.push("parent ID: ".concat(parentSpanId));
    if (!isRootSpan) {
        var _spanToJSON1 = (0, $79515206909fddff$export$92d8c23565496537)(rootSpan), op2 = _spanToJSON1.op, description2 = _spanToJSON1.description;
        infoParts.push("root ID: ".concat(rootSpan.spanContext().spanId));
        if (op2) infoParts.push("root op: ".concat(op2));
        if (description2) infoParts.push("root description: ".concat(description2));
    }
    (0, $739716ea0436a6d0$export$1c9f709888824e05).log("".concat(header, "\n  ").concat(infoParts.join("\n  ")));
}
function $ac49fc821818ee9c$export$b77c830667a4d630(span) {
    if (!(0, $63491170aaadd711$export$16a28057038b10ef)) return;
    var _spanToJSON = (0, $79515206909fddff$export$92d8c23565496537)(span), _spanToJSON_description = _spanToJSON.description, description = _spanToJSON_description === void 0 ? "< unknown name >" : _spanToJSON_description, _spanToJSON_op = _spanToJSON.op, op = _spanToJSON_op === void 0 ? "< unknown op >" : _spanToJSON_op;
    var spanId = span.spanContext().spanId;
    var rootSpan = (0, $79515206909fddff$export$c4c6a79b1260ca1b)(span);
    var isRootSpan = rootSpan === span;
    var msg = '[Tracing] Finishing "'.concat(op, '" ').concat(isRootSpan ? "root " : "", 'span "').concat(description, '" with ID ').concat(spanId);
    (0, $739716ea0436a6d0$export$1c9f709888824e05).log(msg);
}



var $dUlz9 = parcelRequire("dUlz9");




function $1c2df2d65cfd46f9$export$7cc31b475d33a706(name, value, unit) {
    var activeSpan = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0, $79515206909fddff$export$1be426a8e585c83e)();
    var rootSpan = activeSpan && (0, $79515206909fddff$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Measurement] Setting measurement on root span: ".concat(name, " = ").concat(value, " ").concat(unit));
        var _obj;
        rootSpan.addEvent(name, (_obj = {}, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$69cd5c610c7bb96a), value), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$f5f95cff026507b5), unit), _obj));
    }
}
function $1c2df2d65cfd46f9$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return void 0;
    var measurements = {};
    events.forEach(function(event) {
        var attributes = event.attributes || {};
        var unit = attributes[0, $5d82adaea61c8fa9$export$f5f95cff026507b5];
        var value = attributes[0, $5d82adaea61c8fa9$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



function $68e9920622535f7f$export$39f842ff1b89e918(strategy) {
    (0, $8a2f538a13cfc001$export$c8bfa33e4e8ae492)((0, $8a2f538a13cfc001$export$19eade501500c6c1)()).segmentSpanCaptureStrategy = strategy;
}
function $68e9920622535f7f$export$ccd123f3ffd8eb3() {
    return (0, $8a2f538a13cfc001$export$c8bfa33e4e8ae492)((0, $8a2f538a13cfc001$export$19eade501500c6c1)()).segmentSpanCaptureStrategy;
}




var $14e4814b96c40035$var$MAX_SPAN_COUNT = 1e3;
var $14e4814b96c40035$export$a92149b045260d9f = /*#__PURE__*/ function() {
    "use strict";
    function SentrySpan() {
        var spanContext = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $5Epmf._)(this, SentrySpan);
        this._traceId = spanContext.traceId || (0, $1525c77c2ae4a4b0$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $1525c77c2ae4a4b0$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        var _obj;
        this.setAttributes((0, $hwO3w._)((_obj = {}, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "manual"), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$1a413bd9a88fdb09), spanContext.op), _obj), spanContext.attributes));
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    (0, $9MqXK._)(SentrySpan, [
        {
            /** @inheritDoc */ key: "addLink",
            value: function addLink(link) {
                if (this._frozen) return this;
                if (this._links) this._links.push(link);
                else this._links = [
                    link
                ];
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "addLinks",
            value: function addLinks(links) {
                var _this__links;
                if (this._frozen) return this;
                if (this._links) (_this__links = this._links).push.apply(_this__links, (0, $XnYkK._)(links));
                else this._links = links;
                return this;
            }
        },
        {
            /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ key: "recordException",
            value: function recordException(_exception, _time) {}
        },
        {
            /** @inheritdoc */ key: "spanContext",
            value: function spanContext() {
                var _this = this, spanId = _this._spanId, traceId = _this._traceId, sampled = _this._sampled;
                return {
                    spanId: spanId,
                    traceId: traceId,
                    traceFlags: sampled ? (0, $79515206909fddff$export$eb571cd9b5d98de8) : (0, $79515206909fddff$export$208d5b368507fb8b)
                };
            }
        },
        {
            /** @inheritdoc */ key: "setAttribute",
            value: function setAttribute(key, value) {
                if (this._frozen) return this;
                if (value === void 0) delete this._attributes[key];
                else this._attributes[key] = value;
                if (key === (0, $5d82adaea61c8fa9$export$d7a7d984b0791405) && value !== void 0 && (0, $4ef71f79add55d26$export$2e69b79005fc86eb)(this)) (0, $4ef71f79add55d26$export$c45f16c039fb5033)(this);
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "setAttributes",
            value: function setAttributes(attributes) {
                var _this = this;
                Object.keys(attributes).forEach(function(key) {
                    return _this.setAttribute(key, attributes[key]);
                });
                return this;
            }
        },
        {
            /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ key: "updateStartTime",
            value: function updateStartTime(timeInput) {
                if (this._frozen) return;
                this._startTime = (0, $79515206909fddff$export$3f7581298f56c6d7)(timeInput);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setStatus",
            value: function setStatus(value) {
                if (this._frozen) return this;
                this._status = value;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "updateName",
            value: function updateName(name) {
                if (this._frozen) return this;
                this._name = name;
                if (!(0, $4ef71f79add55d26$export$2e69b79005fc86eb)(this)) this.setAttribute((0, $5d82adaea61c8fa9$export$d7a7d984b0791405), "custom");
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "end",
            value: function end(endTimestamp) {
                if (this._endTime) {
                    this._frozen = (0, $4ef71f79add55d26$export$a9ba2a501dbf6a56)(this);
                    return;
                }
                this._endTime = (0, $79515206909fddff$export$3f7581298f56c6d7)(endTimestamp);
                (0, $ac49fc821818ee9c$export$b77c830667a4d630)(this);
                this._onSpanEnded();
                this._frozen = (0, $4ef71f79add55d26$export$a9ba2a501dbf6a56)(this);
            }
        },
        {
            /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ key: "getSpanJSON",
            value: function getSpanJSON() {
                return {
                    data: this._attributes,
                    description: this._name,
                    op: this._attributes[0, $5d82adaea61c8fa9$export$1a413bd9a88fdb09],
                    parent_span_id: this._parentSpanId,
                    span_id: this._spanId,
                    start_timestamp: this._startTime,
                    status: (0, $79515206909fddff$export$e238a77ea3a8cd66)(this._status),
                    timestamp: this._endTime,
                    trace_id: this._traceId,
                    origin: this._attributes[0, $5d82adaea61c8fa9$export$cca8dd30f57f805e],
                    profile_id: this._attributes[0, $5d82adaea61c8fa9$export$1efec95406bbe327],
                    exclusive_time: this._attributes[0, $5d82adaea61c8fa9$export$fea48ba9f4550879],
                    measurements: (0, $1c2df2d65cfd46f9$export$487db6fcdf36893e)(this._events),
                    is_segment: this._isStandaloneSpan && (0, $79515206909fddff$export$c4c6a79b1260ca1b)(this) === this || void 0,
                    segment_id: this._isStandaloneSpan ? (0, $79515206909fddff$export$c4c6a79b1260ca1b)(this).spanContext().spanId : void 0,
                    links: (0, $79515206909fddff$export$cb3e3a12e0eec16c)(this._links)
                };
            }
        },
        {
            /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ key: "getStreamedSpanJSON",
            value: function getStreamedSpanJSON() {
                var _this__name, _this__endTime;
                return {
                    name: (_this__name = this._name) !== null && _this__name !== void 0 ? _this__name : "",
                    span_id: this._spanId,
                    trace_id: this._traceId,
                    parent_span_id: this._parentSpanId,
                    start_timestamp: this._startTime,
                    // just in case _endTime is not set, we use the start time (i.e. duration 0)
                    end_timestamp: (_this__endTime = this._endTime) !== null && _this__endTime !== void 0 ? _this__endTime : this._startTime,
                    is_segment: this._isStandaloneSpan || this === (0, $79515206909fddff$export$c4c6a79b1260ca1b)(this),
                    status: (0, $79515206909fddff$export$d3856a3187d34821)(this._status),
                    attributes: (0, $79515206909fddff$export$1464a9cb828ba99f)(this._attributes, this._status),
                    links: (0, $79515206909fddff$export$9015adcf158ef3a5)(this._links)
                };
            }
        },
        {
            /** @inheritdoc */ key: "isRecording",
            value: function isRecording() {
                return !this._endTime && !!this._sampled;
            }
        },
        {
            /**
   * @inheritdoc
   */ key: "addEvent",
            value: function addEvent(name, attributesOrStartTime, startTime) {
                if (this._frozen) return this;
                (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Tracing] Adding an event to span:", name);
                var time = $14e4814b96c40035$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
                var attributes = $14e4814b96c40035$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
                var event = {
                    name: name,
                    time: (0, $79515206909fddff$export$3f7581298f56c6d7)(time),
                    attributes: attributes
                };
                this._events.push(event);
                return this;
            }
        },
        {
            /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ key: "isStandaloneSpan",
            value: function isStandaloneSpan() {
                return !!this._isStandaloneSpan;
            }
        },
        {
            /** Emit `spanEnd` when the span is ended. */ key: "_onSpanEnded",
            value: function _onSpanEnded() {
                var _this = this;
                var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
                if (client) {
                    client.emit("spanEnd", this);
                    if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
                }
                var rootSpan = (0, $79515206909fddff$export$c4c6a79b1260ca1b)(this);
                var isSegmentSpan = this._isStandaloneSpan || this === rootSpan;
                if (this._isStandaloneSpan) {
                    if (this._sampled) $14e4814b96c40035$var$sendSpanEnvelope((0, $1fb0c290380959ae$export$19a0081d4b39d77)([
                        this
                    ], client));
                    else {
                        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                        if (client) client.recordDroppedEvent("sample_rate", "span");
                    }
                    return;
                }
                if (!isSegmentSpan) {
                    var strategy2 = (0, $68e9920622535f7f$export$ccd123f3ffd8eb3)();
                    if (strategy2) {
                        var scope2 = (0, $4ef71f79add55d26$export$c08fbc656a245d03)(this).scope || (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
                        strategy2.onChildSpanEnded(this, rootSpan, function(options) {
                            return _this._convertSpanToTransaction(options);
                        }, scope2);
                    }
                    return;
                }
                if (client && (0, $a0e1c0749ad8282c$export$6ea47215d699c04a)(client)) {
                    client.emit("afterSegmentSpanEnd", this);
                    return;
                }
                var scope = (0, $4ef71f79add55d26$export$c08fbc656a245d03)(this).scope || (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
                var strategy = (0, $68e9920622535f7f$export$ccd123f3ffd8eb3)();
                if (strategy) strategy.onSegmentSpanEnded(function(options) {
                    return _this._convertSpanToTransaction(options);
                }, scope);
                else {
                    var transactionEvent = this._convertSpanToTransaction();
                    if (transactionEvent) scope.captureEvent(transactionEvent);
                }
            }
        },
        {
            /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ key: "_convertSpanToTransaction",
            value: function _convertSpanToTransaction() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _capturedSpanScope_getScopeData_sdkProcessingMetadata, _options_onSpanCaptured;
                if (!$14e4814b96c40035$var$isFullFinishedSpan((0, $79515206909fddff$export$92d8c23565496537)(this))) return void 0;
                if (!this._name) {
                    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
                    this._name = "<unlabeled transaction>";
                }
                var _getCapturedScopesOnSpan = (0, $4ef71f79add55d26$export$c08fbc656a245d03)(this), capturedSpanScope = _getCapturedScopesOnSpan.scope, capturedSpanIsolationScope = _getCapturedScopesOnSpan.isolationScope;
                var normalizedRequest = capturedSpanScope === null || capturedSpanScope === void 0 ? void 0 : (_capturedSpanScope_getScopeData_sdkProcessingMetadata = capturedSpanScope.getScopeData().sdkProcessingMetadata) === null || _capturedSpanScope_getScopeData_sdkProcessingMetadata === void 0 ? void 0 : _capturedSpanScope_getScopeData_sdkProcessingMetadata.normalizedRequest;
                if (this._sampled !== true) return void 0;
                (_options_onSpanCaptured = options.onSpanCaptured) === null || _options_onSpanCaptured === void 0 ? void 0 : _options_onSpanCaptured.call(options, this);
                var spans = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (0, $79515206909fddff$export$340c5c8a13ffc680)(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var descendant = _step.value;
                        var _options_isSpanAlreadyCaptured, _options_onSpanCaptured1;
                        if (descendant === this || $14e4814b96c40035$var$isStandaloneSpan(descendant) || ((_options_isSpanAlreadyCaptured = options.isSpanAlreadyCaptured) === null || _options_isSpanAlreadyCaptured === void 0 ? void 0 : _options_isSpanAlreadyCaptured.call(options, descendant))) continue;
                        var spanJSON = (0, $79515206909fddff$export$92d8c23565496537)(descendant);
                        if (!$14e4814b96c40035$var$isFullFinishedSpan(spanJSON)) continue;
                        (_options_onSpanCaptured1 = options.onSpanCaptured) === null || _options_onSpanCaptured1 === void 0 ? void 0 : _options_onSpanCaptured1.call(options, descendant);
                        spans.push(spanJSON);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var source = this._attributes[0, $5d82adaea61c8fa9$export$d7a7d984b0791405];
                delete this._attributes[0, $5d82adaea61c8fa9$export$165ce9a229f6f050];
                var hasGenAiSpans = false;
                spans.forEach(function(span) {
                    var _span_op;
                    delete span.data[0, $5d82adaea61c8fa9$export$165ce9a229f6f050];
                    if ((_span_op = span.op) === null || _span_op === void 0 ? void 0 : _span_op.startsWith("gen_ai.")) hasGenAiSpans = true;
                });
                var transaction = (0, $hwO3w._)({
                    contexts: {
                        trace: (0, $79515206909fddff$export$4c3967a8a2f6bbd6)(this)
                    },
                    spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
                    // we do not use spans anymore after this point
                    spans.length > $14e4814b96c40035$var$MAX_SPAN_COUNT ? spans.sort(function(a, b) {
                        return a.start_timestamp - b.start_timestamp;
                    }).slice(0, $14e4814b96c40035$var$MAX_SPAN_COUNT) : spans,
                    start_timestamp: this._startTime,
                    timestamp: this._endTime,
                    transaction: this._name,
                    type: "transaction",
                    sdkProcessingMetadata: {
                        capturedSpanScope: capturedSpanScope,
                        capturedSpanIsolationScope: capturedSpanIsolationScope,
                        dynamicSamplingContext: (0, $0d1fd6101086a96b$export$a117f995597e25df)(this),
                        hasGenAiSpans: hasGenAiSpans
                    },
                    request: normalizedRequest
                }, source && {
                    transaction_info: {
                        source: source
                    }
                });
                var measurements = (0, $1c2df2d65cfd46f9$export$487db6fcdf36893e)(this._events);
                var hasMeasurements = measurements && Object.keys(measurements).length;
                if (hasMeasurements) {
                    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
                    transaction.measurements = measurements;
                }
                return transaction;
            }
        }
    ]);
    return SentrySpan;
}();
function $14e4814b96c40035$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $14e4814b96c40035$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $14e4814b96c40035$var$isStandaloneSpan(span) {
    return span instanceof $14e4814b96c40035$export$a92149b045260d9f && span.isStandaloneSpan();
}
function $14e4814b96c40035$var$sendSpanEnvelope(envelope) {
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    if (!client) return;
    var spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}




var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");









function $1870b040cc4c50c3$export$18ce21a8b7efd7e9(fn, onError) {
    var onFinally = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {}, onSuccess = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {};
    var maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $1870b040cc4c50c3$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $1870b040cc4c50c3$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $6ea82c15e37d9720$export$f5b060c2914b97c8)(value)) return (0, $a5eeea8ef0ae5267$export$64da0f40b0f924ba)(value, function(result) {
        onFinally();
        onSuccess(result);
    }, function(err) {
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}














var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $03bAP = parcelRequire("03bAP");




function $733422902ee91075$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    if (!(0, $ffb01f703f29801c$export$1f70765132c3c225)(options)) return [
        false
    ];
    var localSampleRateWasApplied = void 0;
    var sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler((0, $lf4fc._)((0, $hwO3w._)({}, samplingContext), {
            inheritOrSampleWith: function(fallbackSampleRate) {
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        }));
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    var parsedSampleRate = (0, $bbaf31262ee9249c$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === void 0) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ".concat(JSON.stringify(sampleRate), " of type ").concat(JSON.stringify(typeof sampleRate === "undefined" ? "undefined" : (0, $03bAP._)(sampleRate)), "."));
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Tracing] Discarding transaction because ".concat(typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"));
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    var shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ".concat(Number(sampleRate), ")"));
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}






var $79c462813a8928a4$export$61ab4e30f2201736 = "__SENTRY_SUPPRESS_TRACING__";
function $79c462813a8928a4$export$a1bd95187356f372(options, callback) {
    var acs = $79c462813a8928a4$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    var spanArguments = $79c462813a8928a4$var$parseSentrySpanArguments(options);
    var forceTransaction = options.forceTransaction, customParentSpan = options.parentSpan, customScope = options.scope;
    var customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return (0, $945639585ea57ae0$export$ec58d9285c204497)(customForkedScope, function() {
        var wrapper = $79c462813a8928a4$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(function() {
            var scope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
            var parentSpan = $79c462813a8928a4$var$getParentSpan(scope, customParentSpan);
            var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
            var missingRequiredParent = options.onlyIfParent && !parentSpan;
            var activeSpan = missingRequiredParent ? $79c462813a8928a4$var$startMissingRequiredParentSpan(scope, client) : $79c462813a8928a4$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$79c462813a8928a4$export$b0b1bd7d4bdbd54e(activeSpan) || !parentSpan) (0, $6102d52d892cc90c$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $1870b040cc4c50c3$export$18ce21a8b7efd7e9)(function() {
                return callback(activeSpan);
            }, function() {
                var status = (0, $79515206909fddff$export$92d8c23565496537)(activeSpan).status;
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $6ec04d3e01c80cf6$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, function() {
                activeSpan.end();
            });
        });
    });
}
function $79c462813a8928a4$export$c10292ad04b92aea(options, callback) {
    var acs = $79c462813a8928a4$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    var spanArguments = $79c462813a8928a4$var$parseSentrySpanArguments(options);
    var forceTransaction = options.forceTransaction, customParentSpan = options.parentSpan, customScope = options.scope;
    var customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return (0, $945639585ea57ae0$export$ec58d9285c204497)(customForkedScope, function() {
        var wrapper = $79c462813a8928a4$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(function() {
            var scope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
            var parentSpan = $79c462813a8928a4$var$getParentSpan(scope, customParentSpan);
            var missingRequiredParent = options.onlyIfParent && !parentSpan;
            var activeSpan = missingRequiredParent ? $79c462813a8928a4$var$startMissingRequiredParentSpan(scope, (0, $945639585ea57ae0$export$6bb76d6eba7e258c)()) : $79c462813a8928a4$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$79c462813a8928a4$export$b0b1bd7d4bdbd54e(activeSpan) || !parentSpan) (0, $6102d52d892cc90c$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $1870b040cc4c50c3$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            function() {
                return callback(activeSpan, function() {
                    return activeSpan.end();
                });
            }, function() {
                var status = (0, $79515206909fddff$export$92d8c23565496537)(activeSpan).status;
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $6ec04d3e01c80cf6$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
function $79c462813a8928a4$export$63dbba021a6b4047(options) {
    var acs = $79c462813a8928a4$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    return $79c462813a8928a4$var$_startInactiveSpanImpl(options);
}
function $79c462813a8928a4$export$8672cc6c19af377a(options) {
    return $79c462813a8928a4$var$_startInactiveSpanImpl(options);
}
function $79c462813a8928a4$var$_startInactiveSpanImpl(options) {
    var spanArguments = $79c462813a8928a4$var$parseSentrySpanArguments(options);
    var forceTransaction = options.forceTransaction, customParentSpan = options.parentSpan;
    var wrapper = options.scope ? function(callback) {
        return (0, $945639585ea57ae0$export$ec58d9285c204497)(options.scope, callback);
    } : customParentSpan !== void 0 ? function(callback) {
        return $79c462813a8928a4$export$e57ac09b143d92a2(customParentSpan, callback);
    } : function(callback) {
        return callback();
    };
    return wrapper(function() {
        var scope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
        var parentSpan = $79c462813a8928a4$var$getParentSpan(scope, customParentSpan);
        var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
        var missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $79c462813a8928a4$var$startMissingRequiredParentSpan(scope, client);
        return $79c462813a8928a4$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
var $79c462813a8928a4$export$d2ee9b39b25437b3 = function(options, callback) {
    var carrier = (0, $8a2f538a13cfc001$export$19eade501500c6c1)();
    var acs = (0, $4e593e827d604273$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    var sentryTrace = options.sentryTrace, baggage = options.baggage;
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    var incomingDsc = (0, $0885d9483190850a$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $741db41d31a45a5e$export$18811bc99eefceaa)(client, incomingDsc === null || incomingDsc === void 0 ? void 0 : incomingDsc.org_id)) return $79c462813a8928a4$export$f90b03291402f553(callback);
    return (0, $945639585ea57ae0$export$ec58d9285c204497)(function(scope) {
        var propagationContext = (0, $741db41d31a45a5e$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $6102d52d892cc90c$export$3f25fa50c18e20ca)(scope, void 0);
        return callback();
    });
};
function $79c462813a8928a4$export$e57ac09b143d92a2(span, callback) {
    var acs = $79c462813a8928a4$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $945639585ea57ae0$export$ec58d9285c204497)(function(scope) {
        (0, $6102d52d892cc90c$export$3f25fa50c18e20ca)(scope, span || void 0);
        return callback(scope);
    });
}
function $79c462813a8928a4$export$869298f9835abc68(callback) {
    var acs = $79c462813a8928a4$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $945639585ea57ae0$export$ec58d9285c204497)(function(scope) {
        scope.setSDKProcessingMetadata((0, $dUlz9._)({}, $79c462813a8928a4$export$61ab4e30f2201736, true));
        var res = callback();
        scope.setSDKProcessingMetadata((0, $dUlz9._)({}, $79c462813a8928a4$export$61ab4e30f2201736, void 0));
        return res;
    });
}
function $79c462813a8928a4$export$7d5f2376f7cf513() {
    var scope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
    var acs = $79c462813a8928a4$var$getAcs();
    if (acs.isTracingSuppressed) return acs.isTracingSuppressed(scope);
    return scope.getScopeData().sdkProcessingMetadata[$79c462813a8928a4$export$61ab4e30f2201736] === true;
}
function $79c462813a8928a4$export$f90b03291402f553(callback) {
    var acs = $79c462813a8928a4$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $945639585ea57ae0$export$ec58d9285c204497)(function(scope) {
        scope.setPropagationContext({
            traceId: (0, $1525c77c2ae4a4b0$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $dd2c5f85fcbd9c64$export$9869d72de32a3917)()
        });
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Starting a new trace with id ".concat(scope.getPropagationContext().traceId));
        return $79c462813a8928a4$export$e57ac09b143d92a2(null, callback);
    });
}
function $79c462813a8928a4$var$startMissingRequiredParentSpan(scope, client) {
    client === null || client === void 0 ? void 0 : client.recordDroppedEvent("no_parent_span", "span");
    var span = new (0, $110aa6964cb2c8bd$export$d6636b700b76c516)({
        traceId: scope.getPropagationContext().traceId
    });
    (0, $4ef71f79add55d26$export$cddb4027e3b0dd66)(span, scope, (0, $945639585ea57ae0$export$68f3af03034c9e90)());
    return span;
}
function $79c462813a8928a4$var$createChildOrRootSpan(param) {
    var parentSpan = param.parentSpan, spanArguments = param.spanArguments, forceTransaction = param.forceTransaction, scope = param.scope;
    var isolationScope = (0, $945639585ea57ae0$export$68f3af03034c9e90)();
    if (!(0, $ffb01f703f29801c$export$1f70765132c3c225)()) {
        var scopePropagationContext = (0, $hwO3w._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext());
        var traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        var span2 = new (0, $110aa6964cb2c8bd$export$d6636b700b76c516)({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) (0, $79515206909fddff$export$81397d924722cc65)(parentSpan, span2);
        (0, $4ef71f79add55d26$export$cddb4027e3b0dd66)(span2, scope, isolationScope);
        return span2;
    }
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    if ($79c462813a8928a4$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$79c462813a8928a4$export$7d5f2376f7cf513(scope)) client === null || client === void 0 ? void 0 : client.recordDroppedEvent("ignored", "span");
        var _parentSpan_spanContext_traceId;
        var ignoredSpan = new (0, $110aa6964cb2c8bd$export$d6636b700b76c516)({
            dropReason: "ignored",
            traceId: (_parentSpan_spanContext_traceId = parentSpan === null || parentSpan === void 0 ? void 0 : parentSpan.spanContext().traceId) !== null && _parentSpan_spanContext_traceId !== void 0 ? _parentSpan_spanContext_traceId : scope.getPropagationContext().traceId
        });
        if (parentSpan && !forceTransaction) (0, $79515206909fddff$export$81397d924722cc65)(parentSpan, ignoredSpan);
        (0, $4ef71f79add55d26$export$cddb4027e3b0dd66)(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    var span;
    if (parentSpan && !forceTransaction) {
        span = $79c462813a8928a4$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        (0, $79515206909fddff$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        var dsc = (0, $0d1fd6101086a96b$export$a117f995597e25df)(parentSpan);
        var _parentSpan_spanContext = parentSpan.spanContext(), traceId1 = _parentSpan_spanContext.traceId, parentSpanId = _parentSpan_spanContext.spanId;
        var parentSampled = (0, $79515206909fddff$export$5caecac1caaf3a71)(parentSpan);
        span = $79c462813a8928a4$var$_startRootSpan((0, $hwO3w._)({
            traceId: traceId1,
            parentSpanId: parentSpanId
        }, spanArguments), scope, isolationScope, parentSampled);
        (0, $0d1fd6101086a96b$export$7398c93e763ca9fd)(span, dsc);
    } else {
        var _$_object_spread = (0, $hwO3w._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId2 = _$_object_spread.traceId, dsc1 = _$_object_spread.dsc, parentSpanId1 = _$_object_spread.parentSpanId, parentSampled1 = _$_object_spread.sampled;
        span = $79c462813a8928a4$var$_startRootSpan((0, $hwO3w._)({
            traceId: traceId2,
            parentSpanId: parentSpanId1
        }, spanArguments), scope, isolationScope, parentSampled1);
        if (dsc1) (0, $0d1fd6101086a96b$export$7398c93e763ca9fd)(span, dsc1);
    }
    (0, $ac49fc821818ee9c$export$2f3d84e767c9592b)(span);
    return span;
}
function $79c462813a8928a4$var$parseSentrySpanArguments(options) {
    var exp = options.experimental || {};
    var initialCtx = (0, $hwO3w._)({
        isStandalone: exp.standalone
    }, options);
    if (options.startTime) {
        var ctx = (0, $hwO3w._)({}, initialCtx);
        ctx.startTimestamp = (0, $79515206909fddff$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $79c462813a8928a4$var$getAcs() {
    var carrier = (0, $8a2f538a13cfc001$export$19eade501500c6c1)();
    return (0, $4e593e827d604273$export$f639b0c2752203be)(carrier);
}
function $79c462813a8928a4$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    var _currentPropagationContext_dsc;
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    var options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {};
    var _spanArguments_name = spanArguments.name, name = _spanArguments_name === void 0 ? "" : _spanArguments_name;
    var mutableSpanSamplingData = {
        spanAttributes: (0, $hwO3w._)({}, spanArguments.attributes),
        spanName: name,
        parentSampled: parentSampled
    };
    client === null || client === void 0 ? void 0 : client.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    var _mutableSpanSamplingData_parentSampled;
    var finalParentSampled = (_mutableSpanSamplingData_parentSampled = mutableSpanSamplingData.parentSampled) !== null && _mutableSpanSamplingData_parentSampled !== void 0 ? _mutableSpanSamplingData_parentSampled : parentSampled;
    var finalAttributes = mutableSpanSamplingData.spanAttributes;
    var currentPropagationContext = scope.getPropagationContext();
    var _isTracingSuppressed = $79c462813a8928a4$export$7d5f2376f7cf513(scope);
    var _ref = (0, $6iP9u._)(_isTracingSuppressed ? [
        false
    ] : (0, $733422902ee91075$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
        parentSampleRate: (0, $bbaf31262ee9249c$export$a5bd2d81656d9546)((_currentPropagationContext_dsc = currentPropagationContext.dsc) === null || _currentPropagationContext_dsc === void 0 ? void 0 : _currentPropagationContext_dsc.sample_rate)
    }, currentPropagationContext.sampleRand), 3), sampled = _ref[0], sampleRate = _ref[1], localSampleRateWasApplied = _ref[2];
    var _obj;
    var rootSpan = new (0, $14e4814b96c40035$export$a92149b045260d9f)((0, $lf4fc._)((0, $hwO3w._)({}, spanArguments), {
        attributes: (0, $hwO3w._)((_obj = {}, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$d7a7d984b0791405), "custom"), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$ccfe0a40627cc34b), sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0), _obj), finalAttributes),
        sampled: sampled
    }));
    if (!sampled && client && !_isTracingSuppressed) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", (0, $a0e1c0749ad8282c$export$6ea47215d699c04a)(client) ? "span" : "transaction");
    }
    (0, $4ef71f79add55d26$export$cddb4027e3b0dd66)(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $79c462813a8928a4$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    var _parentSpan_spanContext = parentSpan.spanContext(), spanId = _parentSpan_spanContext.spanId, traceId = _parentSpan_spanContext.traceId;
    var _isTracingSuppressed = $79c462813a8928a4$export$7d5f2376f7cf513(scope);
    var sampled = _isTracingSuppressed ? false : (0, $79515206909fddff$export$5caecac1caaf3a71)(parentSpan);
    var childSpan = sampled ? new (0, $14e4814b96c40035$export$a92149b045260d9f)((0, $lf4fc._)((0, $hwO3w._)({}, spanArguments), {
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    })) : new (0, $110aa6964cb2c8bd$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $79515206909fddff$export$81397d924722cc65)(parentSpan, childSpan);
    (0, $4ef71f79add55d26$export$cddb4027e3b0dd66)(childSpan, scope, isolationScope);
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    if (!client) return childSpan;
    if ((0, $a0e1c0749ad8282c$export$6ea47215d699c04a)(client) && (0, $110aa6964cb2c8bd$export$61cc547d99783aa7)(childSpan)) {
        if ((0, $110aa6964cb2c8bd$export$61cc547d99783aa7)(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!_isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $79c462813a8928a4$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    var span = (0, $6102d52d892cc90c$export$91f063ebb8eff307)(scope);
    if (!span) return void 0;
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    var options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $79515206909fddff$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $79c462813a8928a4$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? function(callback) {
        return $79c462813a8928a4$export$e57ac09b143d92a2(parentSpan, callback);
    } : function(callback) {
        return callback();
    };
}
function $79c462813a8928a4$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    var _spanArguments_attributes;
    var ignoreSpans = client === null || client === void 0 ? void 0 : client.getOptions().ignoreSpans;
    if (!client || !(0, $a0e1c0749ad8282c$export$6ea47215d699c04a)(client) || !(ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length)) return false;
    return (0, $9fb6aa6e5a686ce5$export$5d569ac97c389400)({
        description: spanArguments.name || "",
        op: ((_spanArguments_attributes = spanArguments.attributes) === null || _spanArguments_attributes === void 0 ? void 0 : _spanArguments_attributes[0, $5d82adaea61c8fa9$export$1a413bd9a88fdb09]) || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $79c462813a8928a4$export$b0b1bd7d4bdbd54e(span) {
    return (0, $110aa6964cb2c8bd$export$61cc547d99783aa7)(span) && span.dropReason === "ignored";
}



var $650373597f8b6576$export$809a2b7987fd5306 = {
    idleTimeout: 1e3,
    finalTimeout: 3e4,
    childSpanTimeout: 15e3
};
var $650373597f8b6576$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
var $650373597f8b6576$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
var $650373597f8b6576$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
var $650373597f8b6576$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
function $650373597f8b6576$export$901bffd97bd52797(startSpanOptions) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var activities = /* @__PURE__ */ new Map();
    var _finished = false;
    var _idleTimeoutID;
    var _finishReason = $650373597f8b6576$var$FINISH_REASON_EXTERNAL_FINISH;
    var _autoFinishAllowed = !options.disableAutoFinish;
    var _cleanupHooks = [];
    var _options_idleTimeout = options.idleTimeout, idleTimeout = _options_idleTimeout === void 0 ? $650373597f8b6576$export$809a2b7987fd5306.idleTimeout : _options_idleTimeout, _options_finalTimeout = options.finalTimeout, finalTimeout = _options_finalTimeout === void 0 ? $650373597f8b6576$export$809a2b7987fd5306.finalTimeout : _options_finalTimeout, _options_childSpanTimeout = options.childSpanTimeout, childSpanTimeout = _options_childSpanTimeout === void 0 ? $650373597f8b6576$export$809a2b7987fd5306.childSpanTimeout : _options_childSpanTimeout, beforeSpanEnd = options.beforeSpanEnd, _options_trimIdleSpanEndTimestamp = options.trimIdleSpanEndTimestamp, trimIdleSpanEndTimestamp = _options_trimIdleSpanEndTimestamp === void 0 ? true : _options_trimIdleSpanEndTimestamp;
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    var scope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
    if (!client || !(0, $ffb01f703f29801c$export$1f70765132c3c225)()) {
        var span2 = new (0, $110aa6964cb2c8bd$export$d6636b700b76c516)({
            traceId: scope.getPropagationContext().traceId
        });
        (0, $4ef71f79add55d26$export$cddb4027e3b0dd66)(span2, scope, (0, $945639585ea57ae0$export$68f3af03034c9e90)());
        return span2;
    }
    var previousActiveSpan = (0, $79515206909fddff$export$1be426a8e585c83e)();
    var span = $650373597f8b6576$var$_startIdleSpan(startSpanOptions);
    span.end = new Proxy(span.end, {
        apply: function(target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            if ((0, $110aa6964cb2c8bd$export$61cc547d99783aa7)(thisArg)) return;
            var _args = (0, $1SnSh._)(args), definedEndTimestamp = _args[0], rest = _args.slice(1);
            var timestamp = definedEndTimestamp || (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
            var spanEndTimestamp = (0, $79515206909fddff$export$3f7581298f56c6d7)(timestamp);
            var spans = (0, $79515206909fddff$export$340c5c8a13ffc680)(span).filter(function(child) {
                return child !== span;
            });
            var spanJson = (0, $79515206909fddff$export$92d8c23565496537)(span);
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp
                ].concat((0, $XnYkK._)(rest)));
            }
            var ignoreSpans = client.getOptions().ignoreSpans;
            var latestSpanEndTimestamp = spans === null || spans === void 0 ? void 0 : spans.reduce(function(acc, current) {
                var currentSpanJson = (0, $79515206909fddff$export$92d8c23565496537)(current);
                if (!currentSpanJson.timestamp) return acc;
                if (ignoreSpans && (0, $9fb6aa6e5a686ce5$export$5d569ac97c389400)({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, void 0);
            var spanStartTimestamp = spanJson.start_timestamp;
            var endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp
            ].concat((0, $XnYkK._)(rest)));
        }
    });
    function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = void 0;
        }
    }
    function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(function() {
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $650373597f8b6576$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(function() {
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $650373597f8b6576$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        var endTimestamp = (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
    }
    function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            var endTimestamp = (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
            _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach(function(cleanup) {
            return cleanup();
        });
        (0, $6102d52d892cc90c$export$3f25fa50c18e20ca)(scope, previousActiveSpan);
        var spanJSON = (0, $79515206909fddff$export$92d8c23565496537)(span);
        var startTimestamp = spanJSON.start_timestamp;
        if (!startTimestamp) return;
        var attributes = spanJSON.data;
        if (!attributes[0, $5d82adaea61c8fa9$export$ba73f34502b7a3b3]) span.setAttribute((0, $5d82adaea61c8fa9$export$ba73f34502b7a3b3), _finishReason);
        var currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === "unknown") span.setStatus({
            code: (0, $6ec04d3e01c80cf6$export$58f7963109c806fc)
        });
        (0, $739716ea0436a6d0$export$1c9f709888824e05).log('[Tracing] Idle span "'.concat(spanJSON.op, '" finished'));
        var childSpans = (0, $79515206909fddff$export$340c5c8a13ffc680)(span).filter(function(child) {
            return child !== span;
        });
        var discardedSpans = 0;
        childSpans.forEach(function(childSpan) {
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $6ec04d3e01c80cf6$export$f966a0446ece71e),
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
            }
            var childSpanJSON = (0, $79515206909fddff$export$92d8c23565496537)(childSpan);
            var tmp = childSpanJSON.timestamp, childEndTimestamp = tmp === void 0 ? 0 : tmp, tmp1 = childSpanJSON.start_timestamp, childStartTimestamp = tmp1 === void 0 ? 0 : tmp1;
            var spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            var timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
            var spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $63491170aaadd711$export$16a28057038b10ef) {
                var stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $79515206909fddff$export$c2a0c9438bb89d91)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", function(startedSpan) {
        if (_finished || startedSpan === span || !!(0, $79515206909fddff$export$92d8c23565496537)(startedSpan).timestamp || startedSpan instanceof (0, $14e4814b96c40035$export$a92149b045260d9f) && startedSpan.isStandaloneSpan()) return;
        var allSpans = (0, $79515206909fddff$export$340c5c8a13ffc680)(span);
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", function(endedSpan) {
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", function(spanToAllowAutoFinish) {
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(function() {
        if (!_finished) {
            span.setStatus({
                code: (0, $6ec04d3e01c80cf6$export$f966a0446ece71e),
                message: "deadline_exceeded"
            });
            _finishReason = $650373597f8b6576$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $650373597f8b6576$var$_startIdleSpan(options) {
    var span = (0, $79c462813a8928a4$export$63dbba021a6b4047)(options);
    (0, $6102d52d892cc90c$export$3f25fa50c18e20ca)((0, $945639585ea57ae0$export$c7be4b0125a10cba)(), span);
    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Tracing] Started span is an idle span");
    return span;
}





var $4a1dfae2c7f98a76$var$WINDOW = (0, $6001140c9a325157$export$f1a6cdb1459e81d1);
function $4a1dfae2c7f98a76$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
function $4a1dfae2c7f98a76$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
function $4a1dfae2c7f98a76$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
function $4a1dfae2c7f98a76$export$67fc34576016d6ec() {
    return "history" in $4a1dfae2c7f98a76$var$WINDOW && !!$4a1dfae2c7f98a76$var$WINDOW.history;
}
var $4a1dfae2c7f98a76$export$edf3cb81fd7d2a3e = $4a1dfae2c7f98a76$var$_isFetchSupported;
function $4a1dfae2c7f98a76$var$_isFetchSupported() {
    if (!("fetch" in $4a1dfae2c7f98a76$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $4a1dfae2c7f98a76$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $4a1dfae2c7f98a76$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$4a1dfae2c7f98a76$var$_isFetchSupported()) return false;
    if ($4a1dfae2c7f98a76$export$d5f608b368e73f38($4a1dfae2c7f98a76$var$WINDOW.fetch)) return true;
    var result = false;
    var doc = $4a1dfae2c7f98a76$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        var _sandbox_contentWindow;
        var sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if ((_sandbox_contentWindow = sandbox.contentWindow) === null || _sandbox_contentWindow === void 0 ? void 0 : _sandbox_contentWindow.fetch) result = $4a1dfae2c7f98a76$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $4a1dfae2c7f98a76$export$531055a6c684a70a() {
    return "ReportingObserver" in $4a1dfae2c7f98a76$var$WINDOW;
}
function $4a1dfae2c7f98a76$export$2d308b428295192f() {
    if (!$4a1dfae2c7f98a76$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}



var $e171b0a71a8711b0$export$56d8a8a25bd48b81 = (0, $6001140c9a325157$export$f1a6cdb1459e81d1);


var $276dfa3d97c764b4$var$lastHref;
function $276dfa3d97c764b4$export$3f18c56c58114e75(handler) {
    var type = "history";
    (0, $50b9444442511a8d$export$a4e09611e30da72e)(type, handler);
    (0, $50b9444442511a8d$export$e18d6c5462c01368)(type, $276dfa3d97c764b4$export$d9b613a6254a184e);
}
function $276dfa3d97c764b4$export$d9b613a6254a184e() {
    (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).addEventListener("popstate", function() {
        var to = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).location.href;
        var from = $276dfa3d97c764b4$var$lastHref;
        $276dfa3d97c764b4$var$lastHref = to;
        if (from === to) return;
        var handlerData = {
            from: from,
            to: to
        };
        (0, $50b9444442511a8d$export$b18c893e424d3127)("history", handlerData);
    });
    if (!(0, $4a1dfae2c7f98a76$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var url = args.length > 2 ? args[2] : void 0;
            if (url) {
                var from = $276dfa3d97c764b4$var$lastHref;
                var to = $276dfa3d97c764b4$var$getAbsoluteUrl(String(url));
                $276dfa3d97c764b4$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                var handlerData = {
                    from: from,
                    to: to
                };
                (0, $50b9444442511a8d$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $27958f6402fc5d96$export$9563e054e6f787fb)((0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $27958f6402fc5d96$export$9563e054e6f787fb)((0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $276dfa3d97c764b4$var$getAbsoluteUrl(urlOrPath) {
    try {
        var url = new URL(urlOrPath, (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch (e) {
        return urlOrPath;
    }
}


var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $6iP9u = parcelRequire("6iP9u");

var $03bAP = parcelRequire("03bAP");


var $bf34547bb00b7a11$var$DEFAULT_MAX_STRING_LENGTH = 80;
var $bf34547bb00b7a11$var$accessors = {};
try {
    if (typeof Node !== "undefined") $bf34547bb00b7a11$var$accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
    if (typeof Element !== "undefined") {
        $bf34547bb00b7a11$var$accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
        $bf34547bb00b7a11$var$accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
        $bf34547bb00b7a11$var$accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
        $bf34547bb00b7a11$var$accessors.getAttribute = Element.prototype.getAttribute;
    }
    if (typeof HTMLElement !== "undefined") $bf34547bb00b7a11$var$accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
} catch (e) {}
function $bf34547bb00b7a11$var$_safeRead(el, prop, arg) {
    var fn = $bf34547bb00b7a11$var$accessors[prop];
    if (fn) try {
        return fn.call(el, arg);
    } catch (e) {}
    var val = el[prop];
    return typeof val === "function" ? val.call(el, arg) : val;
}
function $bf34547bb00b7a11$export$5647df6b7814ac86(elem) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!elem) return "<unknown>";
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr;
        var keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        var maxStringLength = !Array.isArray(options) && options.maxStringLength || $bf34547bb00b7a11$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $bf34547bb00b7a11$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = $bf34547bb00b7a11$var$_safeRead(currentElem, "parentNode");
        }
        return out.reverse().join(separator);
    } catch (e) {
        return "<unknown>";
    }
}
function $bf34547bb00b7a11$var$_htmlElementAsString(el, keyAttrs) {
    var out = [];
    var tagName = $bf34547bb00b7a11$var$_safeRead(el, "tagName");
    if (!tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (el instanceof HTMLElement) {
            var dataset = $bf34547bb00b7a11$var$_safeRead(el, "dataset");
            if (dataset) {
                if (dataset["sentryComponent"]) return dataset["sentryComponent"];
                if (dataset["sentryElement"]) return dataset["sentryElement"];
            }
        }
    }
    out.push(tagName.toLowerCase());
    var keyAttrPairs = (keyAttrs === null || keyAttrs === void 0 ? void 0 : keyAttrs.length) ? keyAttrs.filter(function(keyAttr) {
        return $bf34547bb00b7a11$var$_safeRead(el, "getAttribute", keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            $bf34547bb00b7a11$var$_safeRead(el, "getAttribute", keyAttr)
        ];
    }) : null;
    if (keyAttrPairs === null || keyAttrPairs === void 0 ? void 0 : keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[".concat(keyAttrPair[0], '="').concat(keyAttrPair[1], '"]'));
    });
    else {
        var id = $bf34547bb00b7a11$var$_safeRead(el, "id");
        if (id) out.push("#".concat(id));
        var className = $bf34547bb00b7a11$var$_safeRead(el, "className");
        if (className && (0, $6ea82c15e37d9720$export$844ec244b1367d54)(className)) {
            var classes = className.split(/\s+/);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = classes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var c = _step.value;
                    out.push(".".concat(c));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    for(var _i = 0, _iter = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]; _i < _iter.length; _i++){
        var k = _iter[_i];
        var attr = $bf34547bb00b7a11$var$_safeRead(el, "getAttribute", k);
        if (attr) out.push("[".concat(k, '="').concat(attr, '"]'));
    }
    return out.join("");
}




var $dUlz9 = parcelRequire("dUlz9");

var $f4443e0779e1b74f$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






var $dcda52682c8ced9c$var$getRating = function(value, thresholds) {
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
var $dcda52682c8ced9c$export$17679dccdd551979 = function(callback, metric, thresholds, reportAllChanges) {
    var prevValue;
    var delta;
    return function(forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue !== null && prevValue !== void 0 ? prevValue : 0);
                if (delta || prevValue === void 0) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $dcda52682c8ced9c$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};




var $701cc8f6384abb4e$export$6431553786c94949 = function() {
    var checkResponseStart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var _WINDOW_performance_getEntriesByType, _WINDOW_performance;
    var navigationEntry = (_WINDOW_performance = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).performance) === null || _WINDOW_performance === void 0 ? void 0 : (_WINDOW_performance_getEntriesByType = _WINDOW_performance.getEntriesByType) === null || _WINDOW_performance_getEntriesByType === void 0 ? void 0 : _WINDOW_performance_getEntriesByType.call(_WINDOW_performance, "navigation")[0];
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


var $c8ec31433c6b8286$export$d3e828b3c7b5b845 = function() {
    var navEntry = (0, $701cc8f6384abb4e$export$6431553786c94949)();
    var _navEntry_activationStart;
    return (_navEntry_activationStart = navEntry === null || navEntry === void 0 ? void 0 : navEntry.activationStart) !== null && _navEntry_activationStart !== void 0 ? _navEntry_activationStart : 0;
};



function $82ae62ed1b418678$export$26d3d892edc56833(type, listener, options) {
    if ((0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document) (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
function $82ae62ed1b418678$export$324d7b4b46528191(type, listener, options) {
    if ((0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document) (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


var $3d756adfb479789c$var$firstHiddenTime = -1;
var $3d756adfb479789c$var$onHiddenFunctions = /* @__PURE__ */ new Set();
var $3d756adfb479789c$var$initHiddenTime = function() {
    var _WINDOW_document, _WINDOW_document1;
    return ((_WINDOW_document = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === "hidden" && !((_WINDOW_document1 = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document) === null || _WINDOW_document1 === void 0 ? void 0 : _WINDOW_document1.prerendering) ? 0 : Infinity;
};
var $3d756adfb479789c$var$onVisibilityUpdate = function(event) {
    if ($3d756adfb479789c$var$isPageHidden(event) && $3d756adfb479789c$var$firstHiddenTime > -1) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (event.type === "visibilitychange" || event.type === "pagehide") try {
            for(var _iterator = $3d756adfb479789c$var$onHiddenFunctions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var onHiddenFunction = _step.value;
                onHiddenFunction();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!isFinite($3d756adfb479789c$var$firstHiddenTime)) {
            $3d756adfb479789c$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
            (0, $82ae62ed1b418678$export$324d7b4b46528191)("prerenderingchange", $3d756adfb479789c$var$onVisibilityUpdate, true);
        }
    }
};
var $3d756adfb479789c$export$443f86b2c77012c4 = function() {
    if ((0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document && $3d756adfb479789c$var$firstHiddenTime < 0) {
        var _globalThis_performance_getEntriesByType_filter_;
        var activationStart = (0, $c8ec31433c6b8286$export$d3e828b3c7b5b845)();
        var firstVisibilityStateHiddenTime = !(0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document.prerendering ? (_globalThis_performance_getEntriesByType_filter_ = globalThis.performance.getEntriesByType("visibility-state").filter(function(e) {
            return e.name === "hidden" && e.startTime > activationStart;
        })[0]) === null || _globalThis_performance_getEntriesByType_filter_ === void 0 ? void 0 : _globalThis_performance_getEntriesByType_filter_.startTime : void 0;
        $3d756adfb479789c$var$firstHiddenTime = firstVisibilityStateHiddenTime !== null && firstVisibilityStateHiddenTime !== void 0 ? firstVisibilityStateHiddenTime : $3d756adfb479789c$var$initHiddenTime();
        (0, $82ae62ed1b418678$export$26d3d892edc56833)("visibilitychange", $3d756adfb479789c$var$onVisibilityUpdate, true);
        (0, $82ae62ed1b418678$export$26d3d892edc56833)("pagehide", $3d756adfb479789c$var$onVisibilityUpdate, true);
        (0, $82ae62ed1b418678$export$26d3d892edc56833)("prerenderingchange", $3d756adfb479789c$var$onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return $3d756adfb479789c$var$firstHiddenTime;
        },
        onHidden: function(cb) {
            $3d756adfb479789c$var$onHiddenFunctions.add(cb);
        }
    };
};
function $3d756adfb479789c$var$isPageHidden(event) {
    var _WINDOW_document;
    return event.type === "pagehide" || ((_WINDOW_document = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === "hidden";
}



var $63bf6106aa327ff2$export$407ea409d1f3b539 = function() {
    return "v5-".concat(Date.now(), "-").concat(Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};




var $c4d935bdc026afa4$export$3c29b44508a0612b = function(name) {
    var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
    var navEntry = (0, $701cc8f6384abb4e$export$6431553786c94949)();
    var navigationType = "navigate";
    if (navEntry) {
        var _WINDOW_document, _WINDOW_document1;
        if (((_WINDOW_document = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.prerendering) || (0, $c8ec31433c6b8286$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((_WINDOW_document1 = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document) === null || _WINDOW_document1 === void 0 ? void 0 : _WINDOW_document1.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    var entries = [];
    return {
        name: name,
        value: value,
        rating: "good",
        // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
        delta: 0,
        entries: entries,
        id: (0, $63bf6106aa327ff2$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


var $05b8714450f64093$var$instanceMap = /* @__PURE__ */ new WeakMap();
function $05b8714450f64093$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    try {
        if (!$05b8714450f64093$var$instanceMap.get(identityObj)) $05b8714450f64093$var$instanceMap.set(identityObj, new ClassObj());
        return $05b8714450f64093$var$instanceMap.get(identityObj);
    } catch (_e) {
        return new ClassObj();
    }
}



var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");
var $370e3391f0727777$export$4050f7f955e19aa0 = /*#__PURE__*/ function() {
    "use strict";
    function LayoutShiftManager() {
        (0, $5Epmf._)(this, LayoutShiftManager);
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionValue = 0;
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionEntries = [];
    }
    (0, $9MqXK._)(LayoutShiftManager, [
        {
            // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
            key: "_processEntry",
            value: function _processEntry(entry) {
                var _this__onAfterProcessingUnexpectedShift, _this;
                if (entry.hadRecentInput) return;
                var firstSessionEntry = this._sessionEntries[0];
                var lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
                if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1e3 && entry.startTime - firstSessionEntry.startTime < 5e3) {
                    this._sessionValue += entry.value;
                    this._sessionEntries.push(entry);
                } else {
                    this._sessionValue = entry.value;
                    this._sessionEntries = [
                        entry
                    ];
                }
                (_this__onAfterProcessingUnexpectedShift = (_this = this)._onAfterProcessingUnexpectedShift) === null || _this__onAfterProcessingUnexpectedShift === void 0 ? void 0 : _this__onAfterProcessingUnexpectedShift.call(_this, entry);
            }
        }
    ]);
    return LayoutShiftManager;
}();



var $hwO3w = parcelRequire("hwO3w");
var $bcbc8c4b44bc4393$export$d1203567a167490e = function(type, callback) {
    var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            var po = new PerformanceObserver(function(list) {
                Promise.resolve().then(function() {
                    callback(list.getEntries());
                });
            });
            po.observe((0, $hwO3w._)({
                type: type,
                buffered: true
            }, opts));
            return po;
        }
    } catch (e) {}
    return;
};


var $239bd6ab64da28b3$export$b841d51e31c12bab = function(cb) {
    var called = false;
    return function() {
        if (!called) {
            cb();
            called = true;
        }
    };
};








var $5cbe8c641a94c902$export$8bdb38a5671b594e = function(callback) {
    var _WINDOW_document;
    if ((_WINDOW_document = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.prerendering) addEventListener("prerenderingchange", function() {
        return callback();
    }, true);
    else callback();
};


var $8139ab51a965652e$export$e610c735b5510cec = [
    1800,
    3e3
];
var $8139ab51a965652e$export$fe3c86b74e15d5de = function(onReport) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, $5cbe8c641a94c902$export$8bdb38a5671b594e)(function() {
        var visibilityWatcher = (0, $3d756adfb479789c$export$443f86b2c77012c4)();
        var metric = (0, $c4d935bdc026afa4$export$3c29b44508a0612b)("FCP");
        var report;
        var handleEntries = function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    if (entry.name === "first-contentful-paint") {
                        po.disconnect();
                        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                            metric.value = Math.max(entry.startTime - (0, $c8ec31433c6b8286$export$d3e828b3c7b5b845)(), 0);
                            metric.entries.push(entry);
                            report(true);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        var po = (0, $bcbc8c4b44bc4393$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $dcda52682c8ced9c$export$17679dccdd551979)(onReport, metric, $8139ab51a965652e$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


var $0da3776617c6d1be$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
var $0da3776617c6d1be$export$a7873055838e5ad8 = function(onReport) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, $8139ab51a965652e$export$fe3c86b74e15d5de)((0, $239bd6ab64da28b3$export$b841d51e31c12bab)(function() {
        var metric = (0, $c4d935bdc026afa4$export$3c29b44508a0612b)("CLS", 0);
        var report;
        var visibilityWatcher = (0, $3d756adfb479789c$export$443f86b2c77012c4)();
        var layoutShiftManager = (0, $05b8714450f64093$export$7c74c9b2462ddb3c)(opts, (0, $370e3391f0727777$export$4050f7f955e19aa0));
        var handleEntries = function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    layoutShiftManager._processEntry(entry);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        var po = (0, $bcbc8c4b44bc4393$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            var _WINDOW_setTimeout;
            report = (0, $dcda52682c8ced9c$export$17679dccdd551979)(onReport, metric, $0da3776617c6d1be$export$3f20d8e089ac35b2, opts.reportAllChanges);
            visibilityWatcher.onHidden(function() {
                handleEntries(po.takeRecords());
                report(true);
            });
            (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81) === null || (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81) === void 0 ? void 0 : (_WINDOW_setTimeout = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).setTimeout) === null || _WINDOW_setTimeout === void 0 ? void 0 : _WINDOW_setTimeout.call((0, $e171b0a71a8711b0$export$56d8a8a25bd48b81), report);
        }
    }));
};







var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $9b80357a8101edc2$var$interactionCountEstimate = 0;
var $9b80357a8101edc2$var$minKnownInteractionId = Infinity;
var $9b80357a8101edc2$var$maxKnownInteractionId = 0;
var $9b80357a8101edc2$var$updateEstimate = function(entries) {
    entries.forEach(function(e) {
        if (e.interactionId) {
            $9b80357a8101edc2$var$minKnownInteractionId = Math.min($9b80357a8101edc2$var$minKnownInteractionId, e.interactionId);
            $9b80357a8101edc2$var$maxKnownInteractionId = Math.max($9b80357a8101edc2$var$maxKnownInteractionId, e.interactionId);
            $9b80357a8101edc2$var$interactionCountEstimate = $9b80357a8101edc2$var$maxKnownInteractionId ? ($9b80357a8101edc2$var$maxKnownInteractionId - $9b80357a8101edc2$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
var $9b80357a8101edc2$var$po;
var $9b80357a8101edc2$export$8a962f2683a476d1 = function() {
    return $9b80357a8101edc2$var$po ? $9b80357a8101edc2$var$interactionCountEstimate : performance.interactionCount || 0;
};
var $9b80357a8101edc2$export$67d90cda6b78a2eb = function() {
    if ("interactionCount" in performance || $9b80357a8101edc2$var$po) return;
    $9b80357a8101edc2$var$po = (0, $bcbc8c4b44bc4393$export$d1203567a167490e)("event", $9b80357a8101edc2$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


var $9b9cc1b1529a1b80$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
var $9b9cc1b1529a1b80$var$prevInteractionCount = 0;
var $9b9cc1b1529a1b80$var$getInteractionCountForNavigation = function() {
    return (0, $9b80357a8101edc2$export$8a962f2683a476d1)() - $9b9cc1b1529a1b80$var$prevInteractionCount;
};
var $9b9cc1b1529a1b80$export$aaa80641d584351c = /*#__PURE__*/ function() {
    "use strict";
    function InteractionManager() {
        (0, $5Epmf._)(this, InteractionManager);
        /**
     * A list of longest interactions on the page (by latency) sorted so the
     * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
     * long.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionList = [];
        /**
     * A mapping of longest interactions by their interaction ID.
     * This is used for faster lookup.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionMap = /* @__PURE__ */ new Map();
    }
    (0, $9MqXK._)(InteractionManager, [
        {
            // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
            key: "_resetInteractions",
            value: function _resetInteractions() {
                $9b9cc1b1529a1b80$var$prevInteractionCount = (0, $9b80357a8101edc2$export$8a962f2683a476d1)();
                this._longestInteractionList.length = 0;
                this._longestInteractionMap.clear();
            }
        },
        {
            /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
            key: "_estimateP98LongestInteraction",
            value: function _estimateP98LongestInteraction() {
                var candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($9b9cc1b1529a1b80$var$getInteractionCountForNavigation() / 50));
                return this._longestInteractionList[candidateInteractionIndex];
            }
        },
        {
            /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
            key: "_processEntry",
            value: function _processEntry(entry) {
                var _this__onBeforeProcessingEntry, _this;
                (_this__onBeforeProcessingEntry = (_this = this)._onBeforeProcessingEntry) === null || _this__onBeforeProcessingEntry === void 0 ? void 0 : _this__onBeforeProcessingEntry.call(_this, entry);
                if (!(entry.interactionId || entry.entryType === "first-input")) return;
                var minLongestInteraction = this._longestInteractionList.at(-1);
                var interaction = this._longestInteractionMap.get(entry.interactionId);
                if (interaction || this._longestInteractionList.length < $9b9cc1b1529a1b80$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
                entry.duration > minLongestInteraction._latency) {
                    var _this__onAfterProcessingINPCandidate, _this1;
                    if (interaction) {
                        if (entry.duration > interaction._latency) {
                            interaction.entries = [
                                entry
                            ];
                            interaction._latency = entry.duration;
                        } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
                    } else {
                        interaction = {
                            id: entry.interactionId,
                            entries: [
                                entry
                            ],
                            _latency: entry.duration
                        };
                        this._longestInteractionMap.set(interaction.id, interaction);
                        this._longestInteractionList.push(interaction);
                    }
                    this._longestInteractionList.sort(function(a, b) {
                        return b._latency - a._latency;
                    });
                    if (this._longestInteractionList.length > $9b9cc1b1529a1b80$var$MAX_INTERACTIONS_TO_CONSIDER) {
                        var removedInteractions = this._longestInteractionList.splice($9b9cc1b1529a1b80$var$MAX_INTERACTIONS_TO_CONSIDER);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = removedInteractions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var interaction2 = _step.value;
                                this._longestInteractionMap.delete(interaction2.id);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    (_this__onAfterProcessingINPCandidate = (_this1 = this)._onAfterProcessingINPCandidate) === null || _this__onAfterProcessingINPCandidate === void 0 ? void 0 : _this__onAfterProcessingINPCandidate.call(_this1, interaction);
                }
            }
        }
    ]);
    return InteractionManager;
}();








var $748685fa29e2d24c$export$d3314d5863fc1fef = function(cb) {
    var _WINDOW_document;
    var rIC = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).requestIdleCallback || (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).setTimeout;
    if (((_WINDOW_document = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === "hidden") cb();
    else {
        cb = (0, $239bd6ab64da28b3$export$b841d51e31c12bab)(cb);
        (0, $82ae62ed1b418678$export$26d3d892edc56833)("visibilitychange", cb, {
            once: true,
            capture: true
        });
        (0, $82ae62ed1b418678$export$26d3d892edc56833)("pagehide", cb, {
            once: true,
            capture: true
        });
        rIC(function() {
            cb();
            (0, $82ae62ed1b418678$export$324d7b4b46528191)("visibilitychange", cb, {
                capture: true
            });
            (0, $82ae62ed1b418678$export$324d7b4b46528191)("pagehide", cb, {
                capture: true
            });
        });
    }
};


var $72bf059a1e4429c9$export$7f4cb060ded9173c = [
    200,
    500
];
var $72bf059a1e4429c9$var$DEFAULT_DURATION_THRESHOLD = 40;
var $72bf059a1e4429c9$export$7df4b36ecaed99e1 = function(onReport) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)) return;
    var visibilityWatcher = (0, $3d756adfb479789c$export$443f86b2c77012c4)();
    (0, $5cbe8c641a94c902$export$8bdb38a5671b594e)(function() {
        (0, $9b80357a8101edc2$export$67d90cda6b78a2eb)();
        var metric = (0, $c4d935bdc026afa4$export$3c29b44508a0612b)("INP");
        var report;
        var interactionManager = (0, $05b8714450f64093$export$7c74c9b2462ddb3c)(opts, (0, $9b9cc1b1529a1b80$export$aaa80641d584351c));
        var handleEntries = function(entries) {
            (0, $748685fa29e2d24c$export$d3314d5863fc1fef)(function() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        interactionManager._processEntry(entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        var _opts_durationThreshold;
        var po = (0, $bcbc8c4b44bc4393$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: (_opts_durationThreshold = opts.durationThreshold) !== null && _opts_durationThreshold !== void 0 ? _opts_durationThreshold : $72bf059a1e4429c9$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $dcda52682c8ced9c$export$17679dccdd551979)(onReport, metric, $72bf059a1e4429c9$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            po.observe({
                type: "first-input",
                buffered: true
            });
            visibilityWatcher.onHidden(function() {
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};









var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");
var $da52c256ef43d499$export$6a641ef2a067ec62 = /*#__PURE__*/ function() {
    "use strict";
    function LCPEntryManager() {
        (0, $5Epmf._)(this, LCPEntryManager);
    }
    (0, $9MqXK._)(LCPEntryManager, [
        {
            // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
            key: "_processEntry",
            value: function _processEntry(entry) {
                var _this__onBeforeProcessingEntry, _this;
                (_this__onBeforeProcessingEntry = (_this = this)._onBeforeProcessingEntry) === null || _this__onBeforeProcessingEntry === void 0 ? void 0 : _this__onBeforeProcessingEntry.call(_this, entry);
            }
        }
    ]);
    return LCPEntryManager;
}();






var $f3edfc9b05f9bc80$export$948521ca5b0e1b17 = [
    2500,
    4e3
];
var $f3edfc9b05f9bc80$export$947b1626ab8d5632 = function(onReport) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, $5cbe8c641a94c902$export$8bdb38a5671b594e)(function() {
        var visibilityWatcher = (0, $3d756adfb479789c$export$443f86b2c77012c4)();
        var metric = (0, $c4d935bdc026afa4$export$3c29b44508a0612b)("LCP");
        var report;
        var lcpEntryManager = (0, $05b8714450f64093$export$7c74c9b2462ddb3c)(opts, (0, $da52c256ef43d499$export$6a641ef2a067ec62));
        var handleEntries = function(entries) {
            if (!opts.reportAllChanges) entries = entries.slice(-1);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    lcpEntryManager._processEntry(entry);
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        metric.value = Math.max(entry.startTime - (0, $c8ec31433c6b8286$export$d3e828b3c7b5b845)(), 0);
                        metric.entries = [
                            entry
                        ];
                        report();
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        var po = (0, $bcbc8c4b44bc4393$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $dcda52682c8ced9c$export$17679dccdd551979)(onReport, metric, $f3edfc9b05f9bc80$export$948521ca5b0e1b17, opts.reportAllChanges);
            var stopListening = (0, $239bd6ab64da28b3$export$b841d51e31c12bab)(function() {
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            var stopListeningWrapper = function(event) {
                if (event.isTrusted) {
                    (0, $748685fa29e2d24c$export$d3314d5863fc1fef)(stopListening);
                    (0, $82ae62ed1b418678$export$324d7b4b46528191)(event.type, stopListeningWrapper, {
                        capture: true
                    });
                }
            };
            for(var _i = 0, _iter = [
                "keydown",
                "click",
                "visibilitychange"
            ]; _i < _iter.length; _i++){
                var type = _iter[_i];
                (0, $82ae62ed1b418678$export$26d3d892edc56833)(type, stopListeningWrapper, {
                    capture: true
                });
            }
        }
    });
};









var $3c2b3991068449f9$export$65c59ea8064668fc = [
    800,
    1800
];
var $3c2b3991068449f9$var$whenReady = function(callback) {
    var _WINDOW_document, _WINDOW_document1;
    if ((_WINDOW_document = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.prerendering) (0, $5cbe8c641a94c902$export$8bdb38a5671b594e)(function() {
        return $3c2b3991068449f9$var$whenReady(callback);
    });
    else if (((_WINDOW_document1 = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document) === null || _WINDOW_document1 === void 0 ? void 0 : _WINDOW_document1.readyState) !== "complete") addEventListener("load", function() {
        return $3c2b3991068449f9$var$whenReady(callback);
    }, true);
    else setTimeout(callback);
};
var $3c2b3991068449f9$export$33a01e6c5f2c7e33 = function(onReport) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var metric = (0, $c4d935bdc026afa4$export$3c29b44508a0612b)("TTFB");
    var report = (0, $dcda52682c8ced9c$export$17679dccdd551979)(onReport, metric, $3c2b3991068449f9$export$65c59ea8064668fc, opts.reportAllChanges);
    $3c2b3991068449f9$var$whenReady(function() {
        var navigationEntry = (0, $701cc8f6384abb4e$export$6431553786c94949)();
        if (navigationEntry) {
            metric.value = Math.max(navigationEntry.responseStart - (0, $c8ec31433c6b8286$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


var $f7bcc4b265d50461$var$handlers = {};
var $f7bcc4b265d50461$var$instrumented = {};
var $f7bcc4b265d50461$var$_previousCls;
var $f7bcc4b265d50461$var$_previousLcp;
var $f7bcc4b265d50461$var$_previousTtfb;
var $f7bcc4b265d50461$var$_previousInp;
function $f7bcc4b265d50461$export$861b82818b37ba5b(callback) {
    var stopOnCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return $f7bcc4b265d50461$var$addMetricObserver("cls", callback, $f7bcc4b265d50461$var$instrumentCls, $f7bcc4b265d50461$var$_previousCls, stopOnCallback);
}
function $f7bcc4b265d50461$export$3fd4b53331200102(callback) {
    var stopOnCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return $f7bcc4b265d50461$var$addMetricObserver("lcp", callback, $f7bcc4b265d50461$var$instrumentLcp, $f7bcc4b265d50461$var$_previousLcp, stopOnCallback);
}
function $f7bcc4b265d50461$export$699d9529c099a797(callback) {
    return $f7bcc4b265d50461$var$addMetricObserver("ttfb", callback, $f7bcc4b265d50461$var$instrumentTtfb, $f7bcc4b265d50461$var$_previousTtfb);
}
function $f7bcc4b265d50461$export$da3b76aa2022cbd7(callback) {
    return $f7bcc4b265d50461$var$addMetricObserver("inp", callback, $f7bcc4b265d50461$var$instrumentInp, $f7bcc4b265d50461$var$_previousInp);
}
function $f7bcc4b265d50461$export$69816c1a049f8db6(type, callback) {
    $f7bcc4b265d50461$var$addHandler(type, callback);
    if (!$f7bcc4b265d50461$var$instrumented[type]) {
        $f7bcc4b265d50461$var$instrumentPerformanceObserver(type);
        $f7bcc4b265d50461$var$instrumented[type] = true;
    }
    return $f7bcc4b265d50461$var$getCleanupCallback(type, callback);
}
function $f7bcc4b265d50461$var$triggerHandlers(type, data) {
    var typeHandlers = $f7bcc4b265d50461$var$handlers[type];
    if (!(typeHandlers === null || typeHandlers === void 0 ? void 0 : typeHandlers.length)) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                (0, $f4443e0779e1b74f$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat((0, $6fde3090981c9aa7$export$aad197c7121a6651)(handler), "\nError:"), e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $f7bcc4b265d50461$var$instrumentCls() {
    return (0, $0da3776617c6d1be$export$a7873055838e5ad8)(function(metric) {
        $f7bcc4b265d50461$var$triggerHandlers("cls", {
            metric: metric
        });
        $f7bcc4b265d50461$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $f7bcc4b265d50461$var$instrumentLcp() {
    return (0, $f3edfc9b05f9bc80$export$947b1626ab8d5632)(function(metric) {
        $f7bcc4b265d50461$var$triggerHandlers("lcp", {
            metric: metric
        });
        $f7bcc4b265d50461$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $f7bcc4b265d50461$var$instrumentTtfb() {
    return (0, $3c2b3991068449f9$export$33a01e6c5f2c7e33)(function(metric) {
        $f7bcc4b265d50461$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $f7bcc4b265d50461$var$_previousTtfb = metric;
    });
}
function $f7bcc4b265d50461$var$instrumentInp() {
    return (0, $72bf059a1e4429c9$export$7df4b36ecaed99e1)(function(metric) {
        $f7bcc4b265d50461$var$triggerHandlers("inp", {
            metric: metric
        });
        $f7bcc4b265d50461$var$_previousInp = metric;
    });
}
function $f7bcc4b265d50461$var$addMetricObserver(type, callback, instrumentFn, previousValue) {
    var stopOnCallback = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    $f7bcc4b265d50461$var$addHandler(type, callback);
    var stopListening;
    if (!$f7bcc4b265d50461$var$instrumented[type]) {
        stopListening = instrumentFn();
        $f7bcc4b265d50461$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $f7bcc4b265d50461$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : void 0);
}
function $f7bcc4b265d50461$var$instrumentPerformanceObserver(type) {
    var options = {};
    if (type === "event") options.durationThreshold = 0;
    (0, $bcbc8c4b44bc4393$export$d1203567a167490e)(type, function(entries) {
        $f7bcc4b265d50461$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $f7bcc4b265d50461$var$addHandler(type, handler) {
    $f7bcc4b265d50461$var$handlers[type] = $f7bcc4b265d50461$var$handlers[type] || [];
    $f7bcc4b265d50461$var$handlers[type].push(handler);
}
function $f7bcc4b265d50461$var$getCleanupCallback(type, callback, stopListening) {
    return function() {
        if (stopListening) stopListening();
        var typeHandlers = $f7bcc4b265d50461$var$handlers[type];
        if (!typeHandlers) return;
        var index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
function $f7bcc4b265d50461$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}


function $8104b276cc04bd3a$export$71511d61b312f219() {
    $8104b276cc04bd3a$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8104b276cc04bd3a$export$71511d61b312f219.apply(this, arguments);
}


function $bf5d1f503a26a943$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}



var $hwO3w = parcelRequire("hwO3w");

var $6iP9u = parcelRequire("6iP9u");




var $dfbb5f033f0c3182$export$91ec2be6fdd8f1b4 = function(cb) {
    var onHiddenOrPageHide = function(event) {
        var _WINDOW_document;
        if (event.type === "pagehide" || ((_WINDOW_document = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === "hidden") cb(event);
    };
    (0, $82ae62ed1b418678$export$26d3d892edc56833)("visibilitychange", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
    (0, $82ae62ed1b418678$export$26d3d892edc56833)("pagehide", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
};


function $f3d6701b01476aa0$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
function $f3d6701b01476aa0$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, _param) {
    var ctx = (0, $8104b276cc04bd3a$export$71511d61b312f219)({}, (0, $bf5d1f503a26a943$export$71511d61b312f219)(_param));
    var parentStartTime = (0, $79515206909fddff$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    return (0, $79c462813a8928a4$export$e57ac09b143d92a2)(parentSpan, function() {
        var span = (0, $79c462813a8928a4$export$63dbba021a6b4047)((0, $hwO3w._)({
            startTime: startTimeInSeconds
        }, ctx));
        if (span) span.end(endTime);
        return span;
    });
}
function $f3d6701b01476aa0$export$b71b9c7b60c5a4aa(options) {
    var _WINDOW_navigator;
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    if (!client) return;
    var name = options.name, transaction = options.transaction, passedAttributes = options.attributes, startTime = options.startTime;
    var _client_getOptions = client.getOptions(), release = _client_getOptions.release, environment = _client_getOptions.environment;
    var userInfo = client.getDataCollectionOptions().userInfo;
    var replay = client.getIntegrationByName("Replay");
    var replayId = replay === null || replay === void 0 ? void 0 : replay.getReplayId();
    var scope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
    var user = scope.getUser();
    var userDisplay = user !== void 0 ? user.email || user.id || user.ip_address : void 0;
    var profileId;
    try {
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch (e) {}
    var attributes = (0, $hwO3w._)({
        release: release,
        environment: environment,
        user: userDisplay || void 0,
        profile_id: profileId || void 0,
        replay_id: replayId || void 0,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (_WINDOW_navigator = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).navigator) === null || _WINDOW_navigator === void 0 ? void 0 : _WINDOW_navigator.userAgent,
        // This tells Sentry to infer the IP address from the request
        "client.address": userInfo ? "{{auto}}" : void 0
    }, passedAttributes);
    return (0, $79c462813a8928a4$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
function $f3d6701b01476aa0$export$f72a13c439a30cab() {
    return (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).addEventListener && (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).performance;
}
function $f3d6701b01476aa0$export$b4785dbd4a81b33f(time) {
    return time / 1e3;
}
function $f3d6701b01476aa0$export$57c6f824442f9fe1(nextHopProtocol) {
    var name = "unknown";
    var version = "unknown";
    var _name = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nextHopProtocol[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            if (char === "/") {
                var ref;
                ref = (0, $6iP9u._)(nextHopProtocol.split("/"), 2), name = ref[0], version = ref[1], ref;
                break;
            }
            if (!isNaN(Number(char))) {
                name = _name === "h" ? "http" : _name;
                version = nextHopProtocol.split(_name)[1];
                break;
            }
            _name += char;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (_name === nextHopProtocol) name = _name;
    return {
        name: name,
        version: version
    };
}
function $f3d6701b01476aa0$export$c7533a7b4a9f2e94(entryType) {
    try {
        return PerformanceObserver.supportedEntryTypes.includes(entryType);
    } catch (e) {
        return false;
    }
}
function $f3d6701b01476aa0$export$382ad360b45665ab(client, collectorCallback) {
    var pageloadSpan;
    var collected = false;
    function _runCollectorCallbackOnce(event) {
        if (!collected && pageloadSpan) collectorCallback(event, pageloadSpan.spanContext().spanId, pageloadSpan);
        collected = true;
    }
    (0, $dfbb5f033f0c3182$export$91ec2be6fdd8f1b4)(function() {
        _runCollectorCallbackOnce("pagehide");
    });
    var unsubscribeStartNavigation = client.on("beforeStartNavigationSpan", function(_, options) {
        if (!(options === null || options === void 0 ? void 0 : options.isRedirect)) {
            _runCollectorCallbackOnce("navigation");
            unsubscribeStartNavigation();
            unsubscribeAfterStartPageLoadSpan();
        }
    });
    var unsubscribeAfterStartPageLoadSpan = client.on("afterStartPageLoadSpan", function(span) {
        pageloadSpan = span;
        unsubscribeAfterStartPageLoadSpan();
    });
}


function $3c771ee8ad1679ed$export$585bab03c6c18c45(client) {
    var standaloneCLsValue = 0;
    var standaloneClsEntry;
    if (!(0, $f3d6701b01476aa0$export$c7533a7b4a9f2e94)("layout-shift")) return;
    var cleanupClsHandler = (0, $f7bcc4b265d50461$export$861b82818b37ba5b)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    (0, $f3d6701b01476aa0$export$382ad360b45665ab)(client, function(reportEvent, pageloadSpanId) {
        $3c771ee8ad1679ed$export$910bd4e865129f07(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
        cleanupClsHandler();
    });
}
function $3c771ee8ad1679ed$export$910bd4e865129f07(clsValue, entry, pageloadSpanId, reportEvent) {
    var _entry_sources_;
    (0, $f4443e0779e1b74f$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Sending CLS span (".concat(clsValue, ")"));
    var startTime = entry ? (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(((0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
    var routeName = (0, $945639585ea57ae0$export$c7be4b0125a10cba)().getScopeData().transactionName;
    var name = entry ? (0, $bf34547bb00b7a11$export$5647df6b7814ac86)((_entry_sources_ = entry.sources[0]) === null || _entry_sources_ === void 0 ? void 0 : _entry_sources_.node) : "Layout shift";
    var _obj;
    var attributes = (_obj = {}, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.http.browser.cls"), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$1a413bd9a88fdb09), "ui.webvital.cls"), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$fea48ba9f4550879), 0), // attach the pageload span id to the CLS span so that we can link them in the UI
    (0, $dUlz9._)(_obj, "sentry.pageload.span_id", pageloadSpanId), // describes what triggered the web vital to be reported
    (0, $dUlz9._)(_obj, "sentry.report_event", reportEvent), _obj);
    if (entry === null || entry === void 0 ? void 0 : entry.sources) entry.sources.forEach(function(source, index) {
        attributes["cls.source.".concat(index + 1)] = (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(source.node);
    });
    var span = (0, $f3d6701b01476aa0$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        var _obj1;
        span.addEvent("cls", (_obj1 = {}, (0, $dUlz9._)(_obj1, (0, $5d82adaea61c8fa9$export$f5f95cff026507b5), ""), (0, $dUlz9._)(_obj1, (0, $5d82adaea61c8fa9$export$69cd5c610c7bb96a), clsValue), _obj1));
        span.end(startTime);
    }
}




var $dUlz9 = parcelRequire("dUlz9");





var $513c7b4e9d87bd26$export$ccce4d286bdc973b = 6e4;
function $513c7b4e9d87bd26$export$e59775b7d17699ba(lcpValue) {
    return lcpValue != null && lcpValue > 0 && lcpValue <= $513c7b4e9d87bd26$export$ccce4d286bdc973b;
}
function $513c7b4e9d87bd26$export$485112b2cb5f79dc(client) {
    var standaloneLcpValue = 0;
    var standaloneLcpEntry;
    if (!(0, $f3d6701b01476aa0$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    var cleanupLcpHandler = (0, $f7bcc4b265d50461$export$3fd4b53331200102)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry || !$513c7b4e9d87bd26$export$e59775b7d17699ba(metric.value)) return;
        standaloneLcpValue = metric.value;
        standaloneLcpEntry = entry;
    }, true);
    (0, $f3d6701b01476aa0$export$382ad360b45665ab)(client, function(reportEvent, pageloadSpanId) {
        $513c7b4e9d87bd26$export$1c28dab7ad4ec937(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
        cleanupLcpHandler();
    });
}
function $513c7b4e9d87bd26$export$1c28dab7ad4ec937(lcpValue, entry, pageloadSpanId, reportEvent) {
    if (!$513c7b4e9d87bd26$export$e59775b7d17699ba(lcpValue)) return;
    (0, $f4443e0779e1b74f$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Sending LCP span (".concat(lcpValue, ")"));
    var startTime = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(((0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)() || 0) + ((entry === null || entry === void 0 ? void 0 : entry.startTime) || 0));
    var routeName = (0, $945639585ea57ae0$export$c7be4b0125a10cba)().getScopeData().transactionName;
    var name = entry ? (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    var _obj;
    var attributes = (_obj = {}, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.http.browser.lcp"), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$1a413bd9a88fdb09), "ui.webvital.lcp"), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$fea48ba9f4550879), 0), // LCP is a point-in-time metric
    // attach the pageload span id to the LCP span so that we can link them in the UI
    (0, $dUlz9._)(_obj, "sentry.pageload.span_id", pageloadSpanId), // describes what triggered the web vital to be reported
    (0, $dUlz9._)(_obj, "sentry.report_event", reportEvent), _obj);
    if (entry) {
        entry.element && (attributes["lcp.element"] = (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(entry.element));
        entry.id && (attributes["lcp.id"] = entry.id);
        entry.url && (attributes["lcp.url"] = entry.url);
        entry.loadTime != null && (attributes["lcp.loadTime"] = entry.loadTime);
        entry.renderTime != null && (attributes["lcp.renderTime"] = entry.renderTime);
        entry.size != null && (attributes["lcp.size"] = entry.size);
    }
    var span = (0, $f3d6701b01476aa0$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        var _obj1;
        span.addEvent("lcp", (_obj1 = {}, (0, $dUlz9._)(_obj1, (0, $5d82adaea61c8fa9$export$f5f95cff026507b5), "millisecond"), (0, $dUlz9._)(_obj1, (0, $5d82adaea61c8fa9$export$69cd5c610c7bb96a), lcpValue), _obj1));
        span.end(startTime);
    }
}



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");


function $c80e23816eb2b464$var$getAbsoluteTime(time) {
    return time ? (((0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)() || performance.timeOrigin) + time) / 1e3 : time;
}
function $c80e23816eb2b464$export$ec50b091612e7e00(resourceTiming) {
    var _getBrowserPerformanceAPI;
    var timingSpanData = {};
    if (resourceTiming.nextHopProtocol != void 0) {
        var _extractNetworkProtocol = (0, $f3d6701b01476aa0$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol), name = _extractNetworkProtocol.name, version = _extractNetworkProtocol.version;
        timingSpanData["network.protocol.version"] = version;
        timingSpanData["network.protocol.name"] = name;
    }
    if (!((0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)() || ((_getBrowserPerformanceAPI = (0, $f3d6701b01476aa0$export$f72a13c439a30cab)()) === null || _getBrowserPerformanceAPI === void 0 ? void 0 : _getBrowserPerformanceAPI.timeOrigin))) return timingSpanData;
    return $c80e23816eb2b464$var$dropUndefinedKeysFromObject((0, $lf4fc._)((0, $hwO3w._)({}, timingSpanData), {
        "http.request.redirect_start": $c80e23816eb2b464$var$getAbsoluteTime(resourceTiming.redirectStart),
        "http.request.redirect_end": $c80e23816eb2b464$var$getAbsoluteTime(resourceTiming.redirectEnd),
        "http.request.worker_start": $c80e23816eb2b464$var$getAbsoluteTime(resourceTiming.workerStart),
        "http.request.fetch_start": $c80e23816eb2b464$var$getAbsoluteTime(resourceTiming.fetchStart),
        "http.request.domain_lookup_start": $c80e23816eb2b464$var$getAbsoluteTime(resourceTiming.domainLookupStart),
        "http.request.domain_lookup_end": $c80e23816eb2b464$var$getAbsoluteTime(resourceTiming.domainLookupEnd),
        "http.request.connect_start": $c80e23816eb2b464$var$getAbsoluteTime(resourceTiming.connectStart),
        "http.request.secure_connection_start": $c80e23816eb2b464$var$getAbsoluteTime(resourceTiming.secureConnectionStart),
        "http.request.connection_end": $c80e23816eb2b464$var$getAbsoluteTime(resourceTiming.connectEnd),
        "http.request.request_start": $c80e23816eb2b464$var$getAbsoluteTime(resourceTiming.requestStart),
        "http.request.response_start": $c80e23816eb2b464$var$getAbsoluteTime(resourceTiming.responseStart),
        "http.request.response_end": $c80e23816eb2b464$var$getAbsoluteTime(resourceTiming.responseEnd),
        // For TTFB we actually want the relative time from timeOrigin to responseStart
        // This way, TTFB always measures the "first page load" experience.
        // see: https://web.dev/articles/ttfb#measure-resource-requests
        "http.request.time_to_first_byte": resourceTiming.responseStart != null ? resourceTiming.responseStart / 1e3 : void 0
    }));
}
function $c80e23816eb2b464$var$dropUndefinedKeysFromObject(attrs) {
    return Object.fromEntries(Object.entries(attrs).filter(function(param) {
        var _param = (0, $6iP9u._)(param, 2), value = _param[1];
        return value != null;
    }));
}








var $5d0a1b62516c4ec6$var$MAX_INT_AS_BYTES = 2147483647;
var $5d0a1b62516c4ec6$var$_performanceCursor = 0;
var $5d0a1b62516c4ec6$var$_measurements = {};
var $5d0a1b62516c4ec6$var$_lcpEntry;
var $5d0a1b62516c4ec6$var$_clsEntry;
function $5d0a1b62516c4ec6$export$7c69f0412d101b88(param) {
    var recordClsStandaloneSpans = param.recordClsStandaloneSpans, recordLcpStandaloneSpans = param.recordLcpStandaloneSpans, client = param.client;
    var performance = (0, $f3d6701b01476aa0$export$f72a13c439a30cab)();
    if (performance && (0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)()) {
        if (performance.mark) (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        var lcpCleanupCallback = recordLcpStandaloneSpans ? (0, $513c7b4e9d87bd26$export$485112b2cb5f79dc)(client) : recordLcpStandaloneSpans === false ? $5d0a1b62516c4ec6$var$_trackLCP() : void 0;
        var clsCleanupCallback = recordClsStandaloneSpans ? (0, $3c771ee8ad1679ed$export$585bab03c6c18c45)(client) : recordClsStandaloneSpans === false ? $5d0a1b62516c4ec6$var$_trackCLS() : void 0;
        var ttfbCleanupCallback = $5d0a1b62516c4ec6$var$_trackTtfb();
        var fpFcpCleanupCallback = $5d0a1b62516c4ec6$var$_trackFpFcp();
        return function() {
            ttfbCleanupCallback();
            fpFcpCleanupCallback();
            lcpCleanupCallback === null || lcpCleanupCallback === void 0 ? void 0 : lcpCleanupCallback();
            clsCleanupCallback === null || clsCleanupCallback === void 0 ? void 0 : clsCleanupCallback();
        };
    }
    return function() {
        return void 0;
    };
}
function $5d0a1b62516c4ec6$export$f396d19077034ad2() {
    (0, $f7bcc4b265d50461$export$69816c1a049f8db6)("longtask", function(param) {
        var entries = param.entries;
        var parent = (0, $79515206909fddff$export$1be426a8e585c83e)();
        if (!parent) return;
        var _spanToJSON = (0, $79515206909fddff$export$92d8c23565496537)(parent), parentOp = _spanToJSON.op, parentStartTimestamp = _spanToJSON.start_timestamp;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                var startTime = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)((0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)() + entry.startTime);
                var duration = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(entry.duration);
                if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
                (0, $f3d6701b01476aa0$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                    name: "Main UI thread blocked",
                    op: "ui.long-task",
                    attributes: (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.ui.browser.metrics")
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
function $5d0a1b62516c4ec6$export$5b823ab2ccbc801d() {
    var observer = new PerformanceObserver(function(list) {
        var parent = (0, $79515206909fddff$export$1be426a8e585c83e)();
        if (!parent) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = list.getEntries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                if (!entry.scripts[0]) continue;
                var startTime = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)((0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)() + entry.startTime);
                var _spanToJSON = (0, $79515206909fddff$export$92d8c23565496537)(parent), parentStartTimestamp = _spanToJSON.start_timestamp, parentOp = _spanToJSON.op;
                if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
                var duration = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(entry.duration);
                var attributes = (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.ui.browser.metrics");
                var initialScript = entry.scripts[0];
                var invoker = initialScript.invoker, invokerType = initialScript.invokerType, sourceURL = initialScript.sourceURL, sourceFunctionName = initialScript.sourceFunctionName, sourceCharPosition = initialScript.sourceCharPosition;
                attributes["browser.script.invoker"] = invoker;
                attributes["browser.script.invoker_type"] = invokerType;
                if (sourceURL) attributes["code.filepath"] = sourceURL;
                if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
                if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
                (0, $f3d6701b01476aa0$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                    name: "Main UI thread blocked",
                    op: "ui.long-animation-frame",
                    attributes: attributes
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
function $5d0a1b62516c4ec6$export$e27543e0976315e4() {
    (0, $f7bcc4b265d50461$export$69816c1a049f8db6)("event", function(param) {
        var entries = param.entries;
        var parent = (0, $79515206909fddff$export$1be426a8e585c83e)();
        if (!parent) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                if (entry.name === "click") {
                    var startTime = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)((0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)() + entry.startTime);
                    var duration = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(entry.duration);
                    var spanOptions = {
                        name: (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(entry.target),
                        op: "ui.interaction.".concat(entry.name),
                        startTime: startTime,
                        attributes: (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.ui.browser.metrics")
                    };
                    var componentName = (0, $a7a5fd8a48375ca8$export$26727cfcc4d7e0fc)(entry.target);
                    if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
                    (0, $f3d6701b01476aa0$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
function $5d0a1b62516c4ec6$var$_trackCLS() {
    return (0, $f7bcc4b265d50461$export$861b82818b37ba5b)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $5d0a1b62516c4ec6$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $5d0a1b62516c4ec6$var$_clsEntry = entry;
    }, true);
}
function $5d0a1b62516c4ec6$var$_trackLCP() {
    return (0, $f7bcc4b265d50461$export$3fd4b53331200102)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $513c7b4e9d87bd26$export$e59775b7d17699ba)(metric.value)) return;
        $5d0a1b62516c4ec6$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $5d0a1b62516c4ec6$var$_lcpEntry = entry;
    }, true);
}
function $5d0a1b62516c4ec6$var$_trackTtfb() {
    return (0, $f7bcc4b265d50461$export$699d9529c099a797)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $5d0a1b62516c4ec6$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
function $5d0a1b62516c4ec6$var$_trackFpFcp() {
    return (0, $f7bcc4b265d50461$export$69816c1a049f8db6)("paint", function(param) {
        var entries = param.entries;
        var firstHidden = (0, $3d756adfb479789c$export$443f86b2c77012c4)();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                if (entry.name === "first-paint" && shouldRecord) $5d0a1b62516c4ec6$var$_measurements["fp"] = {
                    value: entry.startTime,
                    unit: "millisecond"
                };
                if (entry.name === "first-contentful-paint" && shouldRecord) $5d0a1b62516c4ec6$var$_measurements["fcp"] = {
                    value: entry.startTime,
                    unit: "millisecond"
                };
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
function $5d0a1b62516c4ec6$export$5f8fa6b3467a7443(span, options) {
    var performance = (0, $f3d6701b01476aa0$export$f72a13c439a30cab)();
    var origin = (0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)();
    if (!(performance === null || performance === void 0 ? void 0 : performance.getEntries) || !origin) return;
    var spanStreamingEnabled = options.spanStreamingEnabled, ignorePerformanceApiSpans = options.ignorePerformanceApiSpans, ignoreResourceSpans = options.ignoreResourceSpans;
    var timeOrigin = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(origin);
    var performanceEntries = performance.getEntries();
    var _spanToJSON = (0, $79515206909fddff$export$92d8c23565496537)(span), op = _spanToJSON.op, transactionStartTime = _spanToJSON.start_timestamp;
    performanceEntries.slice($5d0a1b62516c4ec6$var$_performanceCursor).forEach(function(entry) {
        var startTime = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(entry.startTime);
        var duration = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $5d0a1b62516c4ec6$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                $5d0a1b62516c4ec6$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans);
                break;
            case "resource":
                $5d0a1b62516c4ec6$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, ignoreResourceSpans);
                break;
        }
    });
    $5d0a1b62516c4ec6$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $5d0a1b62516c4ec6$var$_trackNavigator(span, spanStreamingEnabled);
}
function $5d0a1b62516c4ec6$export$d14e394b690acc17(span, options) {
    var _getBrowserPerformanceAPI;
    var origin = (0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)();
    if (!((_getBrowserPerformanceAPI = (0, $f3d6701b01476aa0$export$f72a13c439a30cab)()) === null || _getBrowserPerformanceAPI === void 0 ? void 0 : _getBrowserPerformanceAPI.getEntries) || !origin) {
        $5d0a1b62516c4ec6$var$resetWebVitalState();
        return;
    }
    var spanStreamingEnabled = options.spanStreamingEnabled, recordClsOnPageloadSpan = options.recordClsOnPageloadSpan, recordLcpOnPageloadSpan = options.recordLcpOnPageloadSpan;
    var timeOrigin = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(origin);
    if ((0, $79515206909fddff$export$92d8c23565496537)(span).op === "pageload") {
        $5d0a1b62516c4ec6$var$_addTtfbRequestTimeToMeasurements($5d0a1b62516c4ec6$var$_measurements);
        if (spanStreamingEnabled) {
            var setAttr = function(shortWebVitalName, value, customAttrName) {
                var attrKey = customAttrName !== null && customAttrName !== void 0 ? customAttrName : "browser.web_vital.".concat(shortWebVitalName, ".value");
                span.setAttribute(attrKey, value);
                (0, $f4443e0779e1b74f$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Setting web vital attribute", (0, $dUlz9._)({}, attrKey, value), "on pageload span");
            };
            [
                "ttfb",
                "fp",
                "fcp"
            ].forEach(function(measurementName) {
                if ($5d0a1b62516c4ec6$var$_measurements[measurementName]) setAttr(measurementName, $5d0a1b62516c4ec6$var$_measurements[measurementName].value);
            });
            if ($5d0a1b62516c4ec6$var$_measurements["ttfb.requestTime"]) setAttr("ttfb.requestTime", $5d0a1b62516c4ec6$var$_measurements["ttfb.requestTime"].value, "browser.web_vital.ttfb.request_time");
        } else {
            if (!recordClsOnPageloadSpan) delete $5d0a1b62516c4ec6$var$_measurements.cls;
            if (!recordLcpOnPageloadSpan) delete $5d0a1b62516c4ec6$var$_measurements.lcp;
            Object.entries($5d0a1b62516c4ec6$var$_measurements).forEach(function(param) {
                var _param = (0, $6iP9u._)(param, 2), measurementName = _param[0], measurement = _param[1];
                (0, $1c2df2d65cfd46f9$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit, span);
            });
            $5d0a1b62516c4ec6$var$_setWebVitalAttributes(span, options);
        }
        span.setAttribute(spanStreamingEnabled ? "browser.performance.time_origin" : "performance.timeOrigin", timeOrigin);
        span.setAttribute(spanStreamingEnabled ? "browser.performance.navigation.activation_start" : "performance.activationStart", (0, $c8ec31433c6b8286$export$d3e828b3c7b5b845)());
    }
    $5d0a1b62516c4ec6$var$resetWebVitalState();
}
function $5d0a1b62516c4ec6$var$resetWebVitalState() {
    $5d0a1b62516c4ec6$var$_lcpEntry = void 0;
    $5d0a1b62516c4ec6$var$_clsEntry = void 0;
    $5d0a1b62516c4ec6$var$_measurements = {};
}
function $5d0a1b62516c4ec6$var$isReact19MeasureEntry(entry) {
    if ((entry === null || entry === void 0 ? void 0 : entry.entryType) !== "measure") return;
    try {
        return entry.detail.devtools.track === "Components \u269B";
    } catch (e) {
        return;
    }
}
function $5d0a1b62516c4ec6$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ($5d0a1b62516c4ec6$var$isReact19MeasureEntry(entry)) return;
    if ([
        "mark",
        "measure"
    ].includes(entry.entryType) && (0, $45aea333cf5bef5d$export$a7a5ec66062ea5d)(entry.name, ignorePerformanceApiSpans)) return;
    var navEntry = (0, $701cc8f6384abb4e$export$6431553786c94949)(false);
    var requestTime = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    var measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    var startTimeStamp = timeOrigin + startTime;
    var measureEndTimestamp = startTimeStamp + duration;
    var attributes = (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.resource.browser.metrics");
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    $5d0a1b62516c4ec6$var$_addDetailToSpanAttributes(attributes, entry);
    if (measureStartTimestamp <= measureEndTimestamp) (0, $f3d6701b01476aa0$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function $5d0a1b62516c4ec6$var$_addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        var detail = performanceMeasure.detail;
        if (!detail) return;
        if ((typeof detail === "undefined" ? "undefined" : (0, $03bAP._)(detail)) === "object") {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(detail)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $6iP9u._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    if (value && (0, $6ea82c15e37d9720$export$c3825b437cbdea5c)(value)) attributes["sentry.browser.measure.detail.".concat(key)] = value;
                    else if (value !== void 0) try {
                        attributes["sentry.browser.measure.detail.".concat(key)] = JSON.stringify(value);
                    } catch (e) {}
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return;
        }
        if ((0, $6ea82c15e37d9720$export$c3825b437cbdea5c)(detail)) {
            attributes["sentry.browser.measure.detail"] = detail;
            return;
        }
        try {
            attributes["sentry.browser.measure.detail"] = JSON.stringify(detail);
        } catch (e) {}
    } catch (e) {}
}
function $5d0a1b62516c4ec6$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach(function(event) {
        $5d0a1b62516c4ec6$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $5d0a1b62516c4ec6$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
    $5d0a1b62516c4ec6$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
    $5d0a1b62516c4ec6$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $5d0a1b62516c4ec6$var$_addRequest(span, entry, timeOrigin);
}
function $5d0a1b62516c4ec6$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin) {
    var name = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : event;
    var eventEnd = $5d0a1b62516c4ec6$var$_getEndPropertyNameForNavigationTiming(event);
    var end = entry[eventEnd];
    var start = entry["".concat(event, "Start")];
    if (!start || !end) return;
    (0, $f3d6701b01476aa0$export$7567a67bdb69a23d)(span, timeOrigin + (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(end), {
        op: "browser.".concat(name),
        name: entry.name,
        attributes: (0, $hwO3w._)((0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.ui.browser.metrics"), event === "redirect" && entry.redirectCount != null ? {
            "http.redirect_count": entry.redirectCount
        } : {})
    });
}
function $5d0a1b62516c4ec6$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === "secureConnection") return "connectEnd";
    if (event === "fetch") return "domainLookupStart";
    return "".concat(event, "End");
}
function $5d0a1b62516c4ec6$var$_addRequest(span, entry, timeOrigin) {
    var requestStartTimestamp = timeOrigin + (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(entry.requestStart);
    var responseEndTimestamp = timeOrigin + (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(entry.responseEnd);
    var responseStartTimestamp = timeOrigin + (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        (0, $f3d6701b01476aa0$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser.request",
            name: entry.name,
            attributes: (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.ui.browser.metrics")
        });
        (0, $f3d6701b01476aa0$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser.response",
            name: entry.name,
            attributes: (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.ui.browser.metrics")
        });
    }
}
function $5d0a1b62516c4ec6$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    var op = entry.initiatorType ? "resource.".concat(entry.initiatorType) : "resource.other";
    if (ignoredResourceSpanOps === null || ignoredResourceSpanOps === void 0 ? void 0 : ignoredResourceSpanOps.includes(op)) return;
    var attributes = (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.resource.browser.metrics");
    var parsedUrl = (0, $82aed6a67a552ecb$export$7a5253c0f62e0150)(resourceUrl);
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop();
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).location.origin);
    attributes[0, $117bb525af114730$export$40eacf1a072c9dbd] = resourceUrl;
    $5d0a1b62516c4ec6$export$6ce741ceee01ab2f(entry, attributes, [
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
        [
            "responseStatus",
            "http.response.status_code"
        ],
        [
            "transferSize",
            "http.response_transfer_size"
        ],
        [
            "encodedBodySize",
            "http.response_content_length"
        ],
        [
            "decodedBodySize",
            "http.decoded_response_content_length"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
        [
            "renderBlockingStatus",
            "resource.render_blocking_status"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
        [
            "deliveryType",
            "http.response_delivery_type"
        ]
    ]);
    var attributesWithResourceTiming = (0, $hwO3w._)({}, attributes, (0, $c80e23816eb2b464$export$ec50b091612e7e00)(entry));
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    (0, $f3d6701b01476aa0$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).location.origin, ""),
        op: op,
        attributes: attributesWithResourceTiming
    });
}
function $5d0a1b62516c4ec6$var$_trackNavigator(span, spanStreamingEnabled) {
    var navigator = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    var connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute(spanStreamingEnabled ? "network.connection.effective_type" : "effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute(spanStreamingEnabled ? "network.connection.type" : "connectionType", connection.type);
        if ((0, $f3d6701b01476aa0$export$27169ccae1b439e3)(connection.rtt)) {
            if (spanStreamingEnabled) span.setAttribute("network.connection.rtt", connection.rtt);
            else if ((0, $79515206909fddff$export$92d8c23565496537)(span).op === "pageload") (0, $1c2df2d65cfd46f9$export$7cc31b475d33a706)("connection.rtt", connection.rtt, "millisecond");
        }
    }
    if ((0, $f3d6701b01476aa0$export$27169ccae1b439e3)(navigator.deviceMemory)) {
        if (spanStreamingEnabled) span.setAttribute("device.memory.estimated_capacity", navigator.deviceMemory);
        else span.setAttribute("deviceMemory", "".concat(navigator.deviceMemory, " GB"));
    }
    if ((0, $f3d6701b01476aa0$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) {
        if (spanStreamingEnabled) span.setAttribute("device.processor_count", navigator.hardwareConcurrency);
        else span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
    }
}
function $5d0a1b62516c4ec6$var$_setWebVitalAttributes(span, options) {
    if ($5d0a1b62516c4ec6$var$_lcpEntry && options.recordLcpOnPageloadSpan) {
        if ($5d0a1b62516c4ec6$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $bf34547bb00b7a11$export$5647df6b7814ac86)($5d0a1b62516c4ec6$var$_lcpEntry.element));
        if ($5d0a1b62516c4ec6$var$_lcpEntry.id) span.setAttribute("lcp.id", $5d0a1b62516c4ec6$var$_lcpEntry.id);
        if ($5d0a1b62516c4ec6$var$_lcpEntry.url) span.setAttribute("lcp.url", $5d0a1b62516c4ec6$var$_lcpEntry.url.trim().slice(0, 200));
        if ($5d0a1b62516c4ec6$var$_lcpEntry.loadTime != null) span.setAttribute("lcp.loadTime", $5d0a1b62516c4ec6$var$_lcpEntry.loadTime);
        if ($5d0a1b62516c4ec6$var$_lcpEntry.renderTime != null) span.setAttribute("lcp.renderTime", $5d0a1b62516c4ec6$var$_lcpEntry.renderTime);
        span.setAttribute("lcp.size", $5d0a1b62516c4ec6$var$_lcpEntry.size);
    }
    if (($5d0a1b62516c4ec6$var$_clsEntry === null || $5d0a1b62516c4ec6$var$_clsEntry === void 0 ? void 0 : $5d0a1b62516c4ec6$var$_clsEntry.sources) && options.recordClsOnPageloadSpan) $5d0a1b62516c4ec6$var$_clsEntry.sources.forEach(function(source, index) {
        return span.setAttribute("cls.source.".concat(index + 1), (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(source.node));
    });
}
function $5d0a1b62516c4ec6$export$6ce741ceee01ab2f(entry, attributes, properties) {
    properties.forEach(function(param) {
        var _param = (0, $6iP9u._)(param, 2), entryKey = _param[0], attributeKey = _param[1];
        var entryVal = entry[entryKey];
        if (entryVal != null && (typeof entryVal === "number" && entryVal < $5d0a1b62516c4ec6$var$MAX_INT_AS_BYTES || typeof entryVal === "string")) attributes[attributeKey] = entryVal;
    });
}
function $5d0a1b62516c4ec6$var$_addTtfbRequestTimeToMeasurements(_measurements2) {
    var navEntry = (0, $701cc8f6384abb4e$export$6431553786c94949)(false);
    if (!navEntry) return;
    var responseStart = navEntry.responseStart, requestStart = navEntry.requestStart;
    if (requestStart <= responseStart) _measurements2["ttfb.requestTime"] = {
        value: responseStart - requestStart,
        unit: "millisecond"
    };
}


var $be1ea91a107a1f2d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $lFIaz = parcelRequire("lFIaz");

var $hwO3w = parcelRequire("hwO3w");

var $3SMYb = parcelRequire("3SMYb");








var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $hwO3w = parcelRequire("hwO3w");




var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $6fb471c4cc1a8a7b$var$STATE_PENDING = 0;
var $6fb471c4cc1a8a7b$var$STATE_RESOLVED = 1;
var $6fb471c4cc1a8a7b$var$STATE_REJECTED = 2;
function $6fb471c4cc1a8a7b$export$1fda8aa4d135f8aa(value) {
    return new $6fb471c4cc1a8a7b$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $6fb471c4cc1a8a7b$export$78e43115b553f358(reason) {
    return new $6fb471c4cc1a8a7b$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
var $6fb471c4cc1a8a7b$export$6f292d4960313241 = /*#__PURE__*/ function() {
    "use strict";
    function SyncPromise(executor) {
        (0, $5Epmf._)(this, SyncPromise);
        this._state = $6fb471c4cc1a8a7b$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    (0, $9MqXK._)(SyncPromise, [
        {
            /** @inheritdoc */ key: "then",
            value: function then(onfulfilled, onrejected) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    _this._handlers.push([
                        false,
                        function(result) {
                            if (!onfulfilled) resolve(result);
                            else try {
                                resolve(onfulfilled(result));
                            } catch (e) {
                                reject(e);
                            }
                        },
                        function(reason) {
                            if (!onrejected) reject(reason);
                            else try {
                                resolve(onrejected(reason));
                            } catch (e) {
                                reject(e);
                            }
                        }
                    ]);
                    _this._executeHandlers();
                });
            }
        },
        {
            /** @inheritdoc */ key: "catch",
            value: function _catch(onrejected) {
                return this.then(function(val) {
                    return val;
                }, onrejected);
            }
        },
        {
            /** @inheritdoc */ key: "finally",
            value: function _finally(onfinally) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    var val;
                    var isRejected;
                    return _this.then(function(value) {
                        isRejected = false;
                        val = value;
                        if (onfinally) onfinally();
                    }, function(reason) {
                        isRejected = true;
                        val = reason;
                        if (onfinally) onfinally();
                    }).then(function() {
                        if (isRejected) {
                            reject(val);
                            return;
                        }
                        resolve(val);
                    });
                });
            }
        },
        {
            /** Excute the resolve/reject handlers. */ key: "_executeHandlers",
            value: function _executeHandlers() {
                var _this = this;
                if (this._state === $6fb471c4cc1a8a7b$var$STATE_PENDING) return;
                var cachedHandlers = this._handlers.slice();
                this._handlers = [];
                cachedHandlers.forEach(function(handler) {
                    if (handler[0]) return;
                    if (_this._state === $6fb471c4cc1a8a7b$var$STATE_RESOLVED) handler[1](_this._value);
                    if (_this._state === $6fb471c4cc1a8a7b$var$STATE_REJECTED) handler[2](_this._value);
                    handler[0] = true;
                });
            }
        },
        {
            /** Run the executor for the SyncPromise. */ key: "_runExecutor",
            value: function _runExecutor(executor) {
                var _this = this;
                var setResult = function(state, value) {
                    if (_this._state !== $6fb471c4cc1a8a7b$var$STATE_PENDING) return;
                    if ((0, $6ea82c15e37d9720$export$f5b060c2914b97c8)(value)) {
                        value.then(resolve, reject);
                        return;
                    }
                    _this._state = state;
                    _this._value = value;
                    _this._executeHandlers();
                };
                var resolve = function(value) {
                    setResult($6fb471c4cc1a8a7b$var$STATE_RESOLVED, value);
                };
                var reject = function(reason) {
                    setResult($6fb471c4cc1a8a7b$var$STATE_REJECTED, reason);
                };
                try {
                    executor(resolve, reject);
                } catch (e) {
                    reject(e);
                }
            }
        }
    ]);
    return SyncPromise;
}();


function $df3b0438cfd5ffc8$export$bf2a096c3e883e79(processors, event, hint) {
    var index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    try {
        var result = $df3b0438cfd5ffc8$var$_notifyEventProcessors(event, hint, processors, index);
        return (0, $6ea82c15e37d9720$export$f5b060c2914b97c8)(result) ? result : (0, $6fb471c4cc1a8a7b$export$1fda8aa4d135f8aa)(result);
    } catch (error) {
        return (0, $6fb471c4cc1a8a7b$export$78e43115b553f358)(error);
    }
}
function $df3b0438cfd5ffc8$var$_notifyEventProcessors(event, hint, processors, index) {
    var processor = processors[index];
    if (!event || !processor) return event;
    var result = processor((0, $hwO3w._)({}, event), hint);
    (0, $63491170aaadd711$export$16a28057038b10ef) && result === null && (0, $739716ea0436a6d0$export$1c9f709888824e05).log('Event processor "'.concat(processor.id || "?", '" dropped event'));
    if ((0, $6ea82c15e37d9720$export$f5b060c2914b97c8)(result)) return result.then(function(final) {
        return $df3b0438cfd5ffc8$var$_notifyEventProcessors(final, hint, processors, index + 1);
    });
    return $df3b0438cfd5ffc8$var$_notifyEventProcessors(result, hint, processors, index + 1);
}





var $9a182d5c8e178f25$var$parsedStackResults;
var $9a182d5c8e178f25$var$lastSentryKeysCount;
var $9a182d5c8e178f25$var$lastNativeKeysCount;
var $9a182d5c8e178f25$var$cachedFilenameDebugIds;
function $9a182d5c8e178f25$export$e069fee9c632ed00(stackParser) {
    var sentryDebugIdMap = (0, $6001140c9a325157$export$f1a6cdb1459e81d1)._sentryDebugIds;
    var nativeDebugIdMap = (0, $6001140c9a325157$export$f1a6cdb1459e81d1)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    var sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    var nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($9a182d5c8e178f25$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $9a182d5c8e178f25$var$lastSentryKeysCount && nativeDebugIdKeys.length === $9a182d5c8e178f25$var$lastNativeKeysCount) return $9a182d5c8e178f25$var$cachedFilenameDebugIds;
    $9a182d5c8e178f25$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $9a182d5c8e178f25$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $9a182d5c8e178f25$var$cachedFilenameDebugIds = {};
    if (!$9a182d5c8e178f25$var$parsedStackResults) $9a182d5c8e178f25$var$parsedStackResults = {};
    var processDebugIds = function(debugIdKeys, debugIdMap) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = debugIdKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var debugId = debugIdMap[key];
                var result = $9a182d5c8e178f25$var$parsedStackResults === null || $9a182d5c8e178f25$var$parsedStackResults === void 0 ? void 0 : $9a182d5c8e178f25$var$parsedStackResults[key];
                if (result && $9a182d5c8e178f25$var$cachedFilenameDebugIds && debugId) {
                    $9a182d5c8e178f25$var$cachedFilenameDebugIds[result[0]] = debugId;
                    if ($9a182d5c8e178f25$var$parsedStackResults) $9a182d5c8e178f25$var$parsedStackResults[key] = [
                        result[0],
                        debugId
                    ];
                } else if (debugId) {
                    var parsedStack = stackParser(key);
                    for(var i = parsedStack.length - 1; i >= 0; i--){
                        var stackFrame = parsedStack[i];
                        var filename = stackFrame === null || stackFrame === void 0 ? void 0 : stackFrame.filename;
                        if (filename && $9a182d5c8e178f25$var$cachedFilenameDebugIds && $9a182d5c8e178f25$var$parsedStackResults) {
                            $9a182d5c8e178f25$var$cachedFilenameDebugIds[filename] = debugId;
                            $9a182d5c8e178f25$var$parsedStackResults[key] = [
                                filename,
                                debugId
                            ];
                            break;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $9a182d5c8e178f25$var$cachedFilenameDebugIds;
}
function $9a182d5c8e178f25$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    var filenameDebugIdMap = $9a182d5c8e178f25$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    var images = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = resource_paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var path = _step.value;
            var normalizedPath = (0, $6fde3090981c9aa7$export$60c0d6c8e038267a)(path);
            if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
                type: "sourcemap",
                code_file: path,
                debug_id: filenameDebugIdMap[normalizedPath]
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return images;
}





var $hwO3w = parcelRequire("hwO3w");

var $XnYkK = parcelRequire("XnYkK");




function $511829945c640daa$export$43988bc651a80216(event, data) {
    var fingerprint = data.fingerprint, span = data.span, breadcrumbs = data.breadcrumbs, sdkProcessingMetadata = data.sdkProcessingMetadata;
    $511829945c640daa$var$applyDataToEvent(event, data);
    if (span) $511829945c640daa$var$applySpanToEvent(event, span);
    $511829945c640daa$var$applyFingerprintToEvent(event, fingerprint);
    $511829945c640daa$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $511829945c640daa$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $511829945c640daa$export$25ac7e259a513db4(data, mergeData) {
    var extra = mergeData.extra, tags = mergeData.tags, attributes = mergeData.attributes, user = mergeData.user, contexts = mergeData.contexts, level = mergeData.level, sdkProcessingMetadata = mergeData.sdkProcessingMetadata, breadcrumbs = mergeData.breadcrumbs, fingerprint = mergeData.fingerprint, eventProcessors = mergeData.eventProcessors, attachments = mergeData.attachments, propagationContext = mergeData.propagationContext, transactionName = mergeData.transactionName, span = mergeData.span;
    $511829945c640daa$export$b1a120a2871faa46(data, "extra", extra);
    $511829945c640daa$export$b1a120a2871faa46(data, "tags", tags);
    $511829945c640daa$export$b1a120a2871faa46(data, "attributes", attributes);
    $511829945c640daa$export$b1a120a2871faa46(data, "user", user);
    $511829945c640daa$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $e561f8063ae23b8a$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = (0, $XnYkK._)(data.breadcrumbs).concat((0, $XnYkK._)(breadcrumbs));
    if (fingerprint.length) data.fingerprint = (0, $XnYkK._)(data.fingerprint).concat((0, $XnYkK._)(fingerprint));
    if (eventProcessors.length) data.eventProcessors = (0, $XnYkK._)(data.eventProcessors).concat((0, $XnYkK._)(eventProcessors));
    if (attachments.length) data.attachments = (0, $XnYkK._)(data.attachments).concat((0, $XnYkK._)(attachments));
    data.propagationContext = (0, $hwO3w._)({}, data.propagationContext, propagationContext);
}
function $511829945c640daa$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $e561f8063ae23b8a$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $511829945c640daa$export$cc422922fcbb91c6(isolationScope, currentScope) {
    var scopeData = (0, $945639585ea57ae0$export$aa55d5ab8e05984f)().getScopeData();
    isolationScope && $511829945c640daa$export$25ac7e259a513db4(scopeData, isolationScope.getScopeData());
    currentScope && $511829945c640daa$export$25ac7e259a513db4(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $511829945c640daa$var$applyDataToEvent(event, data) {
    var extra = data.extra, tags = data.tags, user = data.user, contexts = data.contexts, level = data.level, transactionName = data.transactionName;
    if (Object.keys(extra).length) event.extra = (0, $hwO3w._)({}, extra, event.extra);
    if (Object.keys(tags).length) event.tags = (0, $hwO3w._)({}, tags, event.tags);
    if (Object.keys(user).length) event.user = (0, $hwO3w._)({}, user, event.user);
    if (Object.keys(contexts).length) event.contexts = (0, $hwO3w._)({}, contexts, event.contexts);
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $511829945c640daa$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    var mergedBreadcrumbs = (0, $XnYkK._)(event.breadcrumbs || []).concat((0, $XnYkK._)(breadcrumbs));
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $511829945c640daa$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = (0, $hwO3w._)({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function $511829945c640daa$var$applySpanToEvent(event, span) {
    event.contexts = (0, $hwO3w._)({
        trace: (0, $79515206909fddff$export$46c6fbd1d265ebf0)(span)
    }, event.contexts);
    event.sdkProcessingMetadata = (0, $hwO3w._)({
        dynamicSamplingContext: (0, $0d1fd6101086a96b$export$a117f995597e25df)(span)
    }, event.sdkProcessingMetadata);
    var rootSpan = (0, $79515206909fddff$export$c4c6a79b1260ca1b)(span);
    var transactionName = (0, $79515206909fddff$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $511829945c640daa$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}





function $1c7a86869cfa8695$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    var _options_normalizeDepth = options.normalizeDepth, normalizeDepth = _options_normalizeDepth === void 0 ? 3 : _options_normalizeDepth, _options_normalizeMaxBreadth = options.normalizeMaxBreadth, normalizeMaxBreadth = _options_normalizeMaxBreadth === void 0 ? 1e3 : _options_normalizeMaxBreadth;
    var prepared = (0, $lf4fc._)((0, $hwO3w._)({}, event), {
        event_id: event.event_id || hint.event_id || (0, $30748c2972c04cd5$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $7b1d57c4c7d6952d$export$7740643b9eeaf0c4)()
    });
    var integrations = hint.integrations || options.integrations.map(function(i) {
        return i.name;
    });
    $1c7a86869cfa8695$export$d7e04067a6fbc882(prepared, options);
    $1c7a86869cfa8695$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $1c7a86869cfa8695$export$63042efc86f043e7(prepared, options.stackParser);
    var finalScope = $1c7a86869cfa8695$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $30748c2972c04cd5$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    var clientEventProcessors = client ? client.getEventProcessors() : [];
    var data = (0, $511829945c640daa$export$cc422922fcbb91c6)(isolationScope, finalScope);
    var attachments = (0, $XnYkK._)(hint.attachments || []).concat((0, $XnYkK._)(data.attachments));
    if (attachments.length) hint.attachments = attachments;
    (0, $511829945c640daa$export$43988bc651a80216)(prepared, data);
    var eventProcessors = (0, $XnYkK._)(clientEventProcessors).concat(// Run scope event processors _after_ all other processors
    (0, $XnYkK._)(data.eventProcessors));
    var isInternalException = hint.data && hint.data.__sentry__ === true;
    var result = isInternalException ? (0, $6fb471c4cc1a8a7b$export$1fda8aa4d135f8aa)(prepared) : (0, $df3b0438cfd5ffc8$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then(function(evt) {
        if (evt) $1c7a86869cfa8695$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $1c7a86869cfa8695$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $1c7a86869cfa8695$export$d7e04067a6fbc882(event, options) {
    var _event_exception_values, _event_exception;
    var environment = options.environment, release = options.release, dist = options.dist, maxValueLength = options.maxValueLength;
    event.environment = event.environment || environment || (0, $9926372cdabb9b15$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    var request = event.request;
    if ((request === null || request === void 0 ? void 0 : request.url) && maxValueLength) request.url = (0, $45aea333cf5bef5d$export$6a506b36fdea397d)(request.url, maxValueLength);
    if (maxValueLength) (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach(function(exception) {
        if (exception.value) exception.value = (0, $45aea333cf5bef5d$export$6a506b36fdea397d)(exception.value, maxValueLength);
    });
}
function $1c7a86869cfa8695$export$63042efc86f043e7(event, stackParser) {
    var _event_exception_values, _event_exception;
    var filenameDebugIdMap = (0, $9a182d5c8e178f25$export$e069fee9c632ed00)(stackParser);
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach(function(exception) {
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach(function(frame) {
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $1c7a86869cfa8695$export$1be657ba8ef44ff0(event) {
    var _event_exception_values, _event_exception;
    var filenameDebugIdMap = {};
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach(function(exception) {
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach(function(frame) {
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    var images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(function(param) {
        var _param = (0, $6iP9u._)(param, 2), filename = _param[0], debug_id = _param[1];
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $1c7a86869cfa8695$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = (0, $XnYkK._)(event.sdk.integrations || []).concat((0, $XnYkK._)(integrationNames));
    }
}
function $1c7a86869cfa8695$var$normalizeEvent(event, depth, maxBreadth) {
    var _event_contexts, _event_contexts1;
    if (!event) return null;
    var normalized = (0, $hwO3w._)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(function(b) {
            return (0, $hwO3w._)({}, b, b.data && {
                data: (0, $74542fb861c25274$export$a3295358bff77e)(b.data, depth, maxBreadth)
            });
        })
    }, event.user && {
        user: (0, $74542fb861c25274$export$a3295358bff77e)(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: (0, $74542fb861c25274$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: (0, $74542fb861c25274$export$a3295358bff77e)(event.extra, depth, maxBreadth)
    });
    if (((_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $74542fb861c25274$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map(function(span) {
        return (0, $hwO3w._)({}, span, span.data && {
            data: (0, $74542fb861c25274$export$a3295358bff77e)(span.data, depth, maxBreadth)
        });
    });
    if (((_event_contexts1 = event.contexts) === null || _event_contexts1 === void 0 ? void 0 : _event_contexts1.flags) && normalized.contexts) normalized.contexts.flags = (0, $74542fb861c25274$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $1c7a86869cfa8695$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    var finalScope = scope ? scope.clone() : new (0, $846be57626444680$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
function $1c7a86869cfa8695$export$76b5f966996d1653(hint) {
    if (!hint) return void 0;
    if ($1c7a86869cfa8695$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($1c7a86869cfa8695$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $1c7a86869cfa8695$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $846be57626444680$export$775b6bb06e53a214) || typeof hint === "function";
}
var $1c7a86869cfa8695$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $1c7a86869cfa8695$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some(function(key) {
        return $1c7a86869cfa8695$var$captureContextKeys.includes(key);
    });
}





function $13be2508cc312e06$export$f5282963edea4a68(exception, hint) {
    return (0, $945639585ea57ae0$export$c7be4b0125a10cba)().captureException(exception, (0, $1c7a86869cfa8695$export$76b5f966996d1653)(hint));
}
function $13be2508cc312e06$export$45654777c133ae80(message, captureContext) {
    var level = typeof captureContext === "string" ? captureContext : void 0;
    var hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return (0, $945639585ea57ae0$export$c7be4b0125a10cba)().captureMessage(message, level, hint);
}
function $13be2508cc312e06$export$1462b974fdcf6ba2(event, hint) {
    return (0, $945639585ea57ae0$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
function $13be2508cc312e06$export$2f04de43fe27971a(name, context) {
    (0, $945639585ea57ae0$export$68f3af03034c9e90)().setContext(name, context);
}
function $13be2508cc312e06$export$bb4922da0dd51b92(extras) {
    (0, $945639585ea57ae0$export$68f3af03034c9e90)().setExtras(extras);
}
function $13be2508cc312e06$export$8e8e7789d42ed61d(key, extra) {
    (0, $945639585ea57ae0$export$68f3af03034c9e90)().setExtra(key, extra);
}
function $13be2508cc312e06$export$74a8fb34822092e6(tags) {
    (0, $945639585ea57ae0$export$68f3af03034c9e90)().setTags(tags);
}
function $13be2508cc312e06$export$a37d07ee78eb4569(key, value) {
    (0, $945639585ea57ae0$export$68f3af03034c9e90)().setTag(key, value);
}
function $13be2508cc312e06$export$74da2cba014bdc09(attributes) {
    (0, $945639585ea57ae0$export$68f3af03034c9e90)().setAttributes(attributes);
}
function $13be2508cc312e06$export$9fec4d97f1922e0b(key, value) {
    (0, $945639585ea57ae0$export$68f3af03034c9e90)().setAttribute(key, value);
}
function $13be2508cc312e06$export$8b6bb3dd62a01be2(user) {
    (0, $945639585ea57ae0$export$68f3af03034c9e90)().setUser(user);
}
function $13be2508cc312e06$export$58213391a19e392(conversationId) {
    (0, $945639585ea57ae0$export$68f3af03034c9e90)().setConversationId(conversationId);
}
function $13be2508cc312e06$export$5d4e9fd7fac8e617() {
    return (0, $945639585ea57ae0$export$68f3af03034c9e90)().lastEventId();
}
function $13be2508cc312e06$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    var scope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    if (!client) (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $30748c2972c04cd5$export$19f53698e68b2496)();
}
function $13be2508cc312e06$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        var checkInId = $13be2508cc312e06$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        var now = (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
        function finishCheckIn(status) {
            $13be2508cc312e06$export$413528111fbc67c({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)() - now
            });
        }
        var maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $6ea82c15e37d9720$export$f5b060c2914b97c8)(maybePromiseResult)) return maybePromiseResult.then(function(r) {
            finishCheckIn("ok");
            return r;
        }, function(e) {
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    return (0, $945639585ea57ae0$export$9a4fed82c350c2bd)(function() {
        return (upsertMonitorConfig === null || upsertMonitorConfig === void 0 ? void 0 : upsertMonitorConfig.isolateTrace) ? (0, $79c462813a8928a4$export$f90b03291402f553)(runCallback) : runCallback();
    });
}
function $13be2508cc312e06$export$4909b86c8034bf73(timeout) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var client;
        return (0, $3SMYb._)(this, function(_state) {
            client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
            if (client) return [
                2,
                client.flush(timeout)
            ];
            (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Cannot flush events. No client defined.");
            return [
                2,
                Promise.resolve(false)
            ];
        });
    })();
}
function $13be2508cc312e06$export$8360e631d277ea4d(timeout) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var client;
        return (0, $3SMYb._)(this, function(_state) {
            client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
            if (client) return [
                2,
                client.close(timeout)
            ];
            (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Cannot flush events and disable SDK. No client defined.");
            return [
                2,
                Promise.resolve(false)
            ];
        });
    })();
}
function $13be2508cc312e06$export$3f95c6f800b78024() {
    return !!(0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
}
function $13be2508cc312e06$export$3b029eb57ac4d562() {
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    return (client === null || client === void 0 ? void 0 : client.getOptions().enabled) !== false && !!(client === null || client === void 0 ? void 0 : client.getTransport());
}
function $13be2508cc312e06$export$9aac0b9f77928fbf(callback) {
    (0, $945639585ea57ae0$export$68f3af03034c9e90)().addEventProcessor(callback);
}
function $13be2508cc312e06$export$c0d84948cecf78d8(context) {
    var isolationScope = (0, $945639585ea57ae0$export$68f3af03034c9e90)();
    var user = (0, $511829945c640daa$export$cc422922fcbb91c6)(isolationScope, (0, $945639585ea57ae0$export$c7be4b0125a10cba)()).user;
    var userAgent = ((0, $6001140c9a325157$export$f1a6cdb1459e81d1).navigator || {}).userAgent;
    var session = (0, $e5a8a7b6f15619c1$export$14a186326edbb264)((0, $hwO3w._)({
        user: user
    }, userAgent && {
        userAgent: userAgent
    }, context));
    var currentSession = isolationScope.getSession();
    if ((currentSession === null || currentSession === void 0 ? void 0 : currentSession.status) === "ok") (0, $e5a8a7b6f15619c1$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $13be2508cc312e06$export$17a5be43989a0bc1();
    isolationScope.setSession(session);
    return session;
}
function $13be2508cc312e06$export$17a5be43989a0bc1() {
    var isolationScope = (0, $945639585ea57ae0$export$68f3af03034c9e90)();
    var currentScope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
    var session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $e5a8a7b6f15619c1$export$56521d9ba90f62ee)(session);
    $13be2508cc312e06$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $13be2508cc312e06$var$_sendSessionUpdate() {
    var isolationScope = (0, $945639585ea57ae0$export$68f3af03034c9e90)();
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    var session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $13be2508cc312e06$export$667e7b4d445d566b() {
    var end = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (end) {
        $13be2508cc312e06$export$17a5be43989a0bc1();
        return;
    }
    $13be2508cc312e06$var$_sendSessionUpdate();
}


var $1cd11d0052bf6dc0$export$56d8a8a25bd48b81 = (0, $6001140c9a325157$export$f1a6cdb1459e81d1);
var $1cd11d0052bf6dc0$var$ignoreOnError = 0;
function $1cd11d0052bf6dc0$export$b79738ab10c590b2() {
    return $1cd11d0052bf6dc0$var$ignoreOnError > 0;
}
function $1cd11d0052bf6dc0$export$1265a142ff5ba165() {
    $1cd11d0052bf6dc0$var$ignoreOnError++;
    setTimeout(function() {
        $1cd11d0052bf6dc0$var$ignoreOnError--;
    });
}
function $1cd11d0052bf6dc0$export$4997ffc0176396a6(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        var hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
        if (hasOwnWrapper) {
            var wrapper = fn.__sentry_wrapped__;
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $27958f6402fc5d96$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        return fn;
    }
    var sentryWrapped = function sentryWrapped() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $6001140c9a325157$export$f1a6cdb1459e81d1)._sentryWrappedDepth = ((0, $6001140c9a325157$export$f1a6cdb1459e81d1)._sentryWrappedDepth || 0) + 1;
        try {
            var wrappedArguments = args.map(function(arg) {
                return $1cd11d0052bf6dc0$export$4997ffc0176396a6(arg, options);
            });
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $1cd11d0052bf6dc0$export$1265a142ff5ba165();
            (0, $945639585ea57ae0$export$ec58d9285c204497)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $30748c2972c04cd5$export$f26508487bf83ee7)(event, void 0, void 0);
                        (0, $30748c2972c04cd5$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = (0, $lf4fc._)((0, $hwO3w._)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $13be2508cc312e06$export$f5282963edea4a68)(ex);
            });
            throw ex;
        } finally{
            (0, $6001140c9a325157$export$f1a6cdb1459e81d1)._sentryWrappedDepth = ((0, $6001140c9a325157$export$f1a6cdb1459e81d1)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e) {}
    (0, $27958f6402fc5d96$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $27958f6402fc5d96$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get: function() {
                return fn.name;
            }
        });
    } catch (e) {}
    return sentryWrapped;
}
function $1cd11d0052bf6dc0$export$a3c4a8453e8936f0() {
    var url = (0, $a7a5fd8a48375ca8$export$1cfafeee2987818b)();
    var referrer = ($1cd11d0052bf6dc0$export$56d8a8a25bd48b81.document || {}).referrer;
    var userAgent = ($1cd11d0052bf6dc0$export$56d8a8a25bd48b81.navigator || {}).userAgent;
    var headers = (0, $hwO3w._)({}, referrer && {
        Referer: referrer
    }, userAgent && {
        "User-Agent": userAgent
    });
    var request = {
        url: url,
        headers: headers
    };
    return request;
}



var $dUlz9 = parcelRequire("dUlz9");

var $lFIaz = parcelRequire("lFIaz");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");

var $03bAP = parcelRequire("03bAP");

var $3SMYb = parcelRequire("3SMYb");







function $f6ba95453bfd82e7$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    var type = "fetch";
    var removeHandler = (0, $50b9444442511a8d$export$a4e09611e30da72e)(type, handler);
    (0, $50b9444442511a8d$export$e18d6c5462c01368)(type, function() {
        return $f6ba95453bfd82e7$var$instrumentFetch(void 0, skipNativeFetchCheck);
    });
    return removeHandler;
}
function $f6ba95453bfd82e7$export$1a79663eb318fe6a(handler) {
    var type = "fetch-body-resolved";
    var removeHandler = (0, $50b9444442511a8d$export$a4e09611e30da72e)(type, handler);
    (0, $50b9444442511a8d$export$e18d6c5462c01368)(type, function() {
        return $f6ba95453bfd82e7$var$instrumentFetch($f6ba95453bfd82e7$var$streamHandler);
    });
    return removeHandler;
}
function $f6ba95453bfd82e7$var$instrumentFetch(onFetchResolved) {
    var skipNativeFetchCheck = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (skipNativeFetchCheck && !(0, $4a1dfae2c7f98a76$export$c82d238e23c40b21)()) return;
    (0, $27958f6402fc5d96$export$9563e054e6f787fb)((0, $6001140c9a325157$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var virtualError = new Error();
            var _parseFetchArgs = $f6ba95453bfd82e7$export$f7a71163cc309d9a(args), method = _parseFetchArgs.method, url = _parseFetchArgs.url;
            var handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)() * 1e3,
                // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError: virtualError,
                headers: $f6ba95453bfd82e7$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) (0, $50b9444442511a8d$export$b18c893e424d3127)("fetch", (0, $hwO3w._)({}, handlerData));
            return originalFetch.apply((0, $6001140c9a325157$export$f1a6cdb1459e81d1), args).then(function(response) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        if (onFetchResolved) onFetchResolved(response);
                        else (0, $50b9444442511a8d$export$b18c893e424d3127)("fetch", (0, $lf4fc._)((0, $hwO3w._)({}, handlerData), {
                            endTimestamp: (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)() * 1e3,
                            response: response
                        }));
                        return [
                            2,
                            response
                        ];
                    });
                })();
            }, function(error) {
                (0, $50b9444442511a8d$export$b18c893e424d3127)("fetch", (0, $lf4fc._)((0, $hwO3w._)({}, handlerData), {
                    endTimestamp: (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)() * 1e3,
                    error: error
                }));
                if ((0, $6ea82c15e37d9720$export$e6127cc7fe7395c3)(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    (0, $27958f6402fc5d96$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
                var _client_getOptions_enhanceFetchErrorMessages;
                var enhanceOption = (_client_getOptions_enhanceFetchErrorMessages = client === null || client === void 0 ? void 0 : client.getOptions().enhanceFetchErrorMessages) !== null && _client_getOptions_enhanceFetchErrorMessages !== void 0 ? _client_getOptions_enhanceFetchErrorMessages : "always";
                var shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && (0, $6ea82c15e37d9720$export$e6127cc7fe7395c3)(error) && error.name === "TypeError" && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    var url2 = new URL(handlerData.fetchData.url);
                    var hostname = url2.host;
                    if (enhanceOption === "always") error.message = "".concat(error.message, " (").concat(hostname, ")");
                    else (0, $27958f6402fc5d96$export$e73679ffaf56810e)(error, "__sentry_fetch_url_host__", hostname);
                } catch (e) {}
                throw error;
            });
        };
    });
}
function $f6ba95453bfd82e7$var$resolveResponse(res, onFinishedResolving) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var body, responseReader, maxFetchDurationTimeout, readingActive, chunkTimeout, done, e;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(res === null || res === void 0 ? void 0 : res.body)) return [
                        3,
                        8
                    ];
                    body = res.body;
                    responseReader = body.getReader();
                    maxFetchDurationTimeout = setTimeout(function() {
                        body.cancel().then(null, function() {});
                    }, 90000);
                    readingActive = true;
                    _state.label = 1;
                case 1:
                    if (!readingActive) return [
                        3,
                        7
                    ];
                    chunkTimeout = void 0;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        5,
                        6
                    ]);
                    chunkTimeout = setTimeout(function() {
                        body.cancel().then(null, function() {});
                    }, 5e3);
                    return [
                        4,
                        responseReader.read()
                    ];
                case 3:
                    done = _state.sent().done;
                    clearTimeout(chunkTimeout);
                    if (done) {
                        onFinishedResolving();
                        readingActive = false;
                    }
                    return [
                        3,
                        6
                    ];
                case 4:
                    e = _state.sent();
                    readingActive = false;
                    return [
                        3,
                        6
                    ];
                case 5:
                    clearTimeout(chunkTimeout);
                    return [
                        7
                    ];
                case 6:
                    return [
                        3,
                        1
                    ];
                case 7:
                    clearTimeout(maxFetchDurationTimeout);
                    responseReader.releaseLock();
                    body.cancel().then(null, function() {});
                    _state.label = 8;
                case 8:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $f6ba95453bfd82e7$var$streamHandler(response) {
    var clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    $f6ba95453bfd82e7$var$resolveResponse(clonedResponseForResolving, function() {
        (0, $50b9444442511a8d$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)() * 1e3,
            response: response
        });
    });
}
function $f6ba95453bfd82e7$var$hasProp(obj, prop) {
    return (0, $6ea82c15e37d9720$export$c10d0b04eaa80a43)(obj) && !!obj[prop];
}
function $f6ba95453bfd82e7$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($f6ba95453bfd82e7$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $f6ba95453bfd82e7$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        var _fetchArgs = (0, $6iP9u._)(fetchArgs, 2), resource = _fetchArgs[0], options = _fetchArgs[1];
        return {
            url: $f6ba95453bfd82e7$var$getUrlFromResource(resource),
            method: $f6ba95453bfd82e7$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            (0, $6ea82c15e37d9720$export$6d3d1f317d7cda57)(resource) && $f6ba95453bfd82e7$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    var arg = fetchArgs[0];
    return {
        url: $f6ba95453bfd82e7$var$getUrlFromResource(arg),
        method: $f6ba95453bfd82e7$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $f6ba95453bfd82e7$var$getHeadersFromFetchArgs(fetchArgs) {
    var _fetchArgs = (0, $6iP9u._)(fetchArgs, 2), requestArgument = _fetchArgs[0], optionsArgument = _fetchArgs[1];
    try {
        if ((typeof optionsArgument === "undefined" ? "undefined" : (0, $03bAP._)(optionsArgument)) === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $6ea82c15e37d9720$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch (e) {}
    return;
}


var $hwO3w = parcelRequire("hwO3w");

var $XnYkK = parcelRequire("XnYkK");



var $ae9d79ccde098562$export$b14a8888f80a0b3e = [];
function $ae9d79ccde098562$var$filterDuplicates(integrations) {
    var integrationsByName = {};
    integrations.forEach(function(currentInstance) {
        var name = currentInstance.name;
        var existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $ae9d79ccde098562$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations || [];
    var userIntegrations = options.integrations;
    defaultIntegrations.forEach(function(integration) {
        integration.isDefaultInstance = true;
    });
    var integrations;
    if (Array.isArray(userIntegrations)) integrations = (0, $XnYkK._)(defaultIntegrations).concat((0, $XnYkK._)(userIntegrations));
    else if (typeof userIntegrations === "function") {
        var resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $ae9d79ccde098562$var$filterDuplicates(integrations);
}
function $ae9d79ccde098562$export$51abed9797baa598(client, integrations) {
    var integrationIndex = {};
    integrations.forEach(function(integration) {
        if (integration === null || integration === void 0 ? void 0 : integration.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach(function(integration) {
        if (integration) $ae9d79ccde098562$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $ae9d79ccde098562$export$35abcfd71227c6ca(client, integrations) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = integrations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var integration = _step.value;
            if (integration === null || integration === void 0 ? void 0 : integration.afterAllSetup) integration.afterAllSetup(client);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $ae9d79ccde098562$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Integration skipped because it was already installed: ".concat(integration.name));
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$ae9d79ccde098562$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $ae9d79ccde098562$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        var callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", function(event, hint) {
            return callback(event, hint, client);
        });
    }
    if (typeof integration.processEvent === "function") {
        var callback1 = integration.processEvent.bind(integration);
        var processor = Object.assign(function(event, hint) {
            return callback1(event, hint, client);
        }, {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach(function(hook) {
        var callback = integration[hook];
        if (typeof callback === "function") client.on(hook, function(span) {
            return callback.call(integration, span, client);
        });
    });
    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Integration installed: ".concat(integration.name));
}
function $ae9d79ccde098562$export$2d8f5188773bcddd(integration) {
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn('Cannot add integration "'.concat(integration.name, '" because no SDK Client is available.'));
        return;
    }
    client.addIntegration(integration);
}
function $ae9d79ccde098562$export$2323046b9414659f(fn) {
    return fn;
}
function $ae9d79ccde098562$export$92d0786473d2c0a1(integration, extendedIntegration) {
    var _loop = function(key) {
        var baseValue = integration[key];
        var extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            var wrappedFunction = new Proxy(baseValue, {
                apply: function(target, thisArg, args) {
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    };
    var wrappedIntegration = (0, $hwO3w._)({}, integration, extendedIntegration);
    for(var key in extendedIntegration)_loop(key);
    return wrappedIntegration;
}


var $3dd9fb89a582f4e2$var$responseToStreamSpan = /* @__PURE__ */ new WeakMap();
var $3dd9fb89a582f4e2$var$responseToFallbackTimeout = /* @__PURE__ */ new WeakMap();
var $3dd9fb89a582f4e2$var$STREAM_RESOLVE_FALLBACK_MS = 9e4;
var $3dd9fb89a582f4e2$var$STREAMING_CONTENT_TYPES = [
    "text/event-stream",
    "application/x-ndjson",
    "application/stream+json"
];
var $3dd9fb89a582f4e2$export$b49e0d1a48dc8754 = (0, $ae9d79ccde098562$export$2323046b9414659f)(function() {
    return {
        name: "FetchStreamPerformance",
        setup: function() {
            (0, $f6ba95453bfd82e7$export$1a79663eb318fe6a)(function(handlerData) {
                if (handlerData.response) {
                    var streamSpan = $3dd9fb89a582f4e2$var$responseToStreamSpan.get(handlerData.response);
                    if (streamSpan && handlerData.endTimestamp) {
                        streamSpan.end(handlerData.endTimestamp);
                        var fallbackTimeout = $3dd9fb89a582f4e2$var$responseToFallbackTimeout.get(handlerData.response);
                        if (fallbackTimeout) clearTimeout(fallbackTimeout);
                    }
                }
            });
            (0, $f6ba95453bfd82e7$export$f75d3c772c923df0)(function(handlerData) {
                if (handlerData.endTimestamp && handlerData.response) {
                    var _handlerData_response_headers, _handlerData_response_headers1, _handlerData_fetchData, _handlerData_fetchData1;
                    var contentType = ((_handlerData_response_headers = handlerData.response.headers) === null || _handlerData_response_headers === void 0 ? void 0 : _handlerData_response_headers.get("content-type")) || "";
                    if (((_handlerData_response_headers1 = handlerData.response.headers) === null || _handlerData_response_headers1 === void 0 ? void 0 : _handlerData_response_headers1.get("content-length")) || !$3dd9fb89a582f4e2$var$STREAMING_CONTENT_TYPES.some(function(t) {
                        return contentType.startsWith(t);
                    })) return;
                    var url = ((_handlerData_fetchData = handlerData.fetchData) === null || _handlerData_fetchData === void 0 ? void 0 : _handlerData_fetchData.url) || "";
                    var method = ((_handlerData_fetchData1 = handlerData.fetchData) === null || _handlerData_fetchData1 === void 0 ? void 0 : _handlerData_fetchData1.method) || "GET";
                    var parsedUrl = (0, $82aed6a67a552ecb$export$2004d912a9ead694)(url);
                    var sanitizedUrl = url.startsWith("data:") ? (0, $82aed6a67a552ecb$export$8abd806fcaf234fa)(url) : parsedUrl ? (0, $82aed6a67a552ecb$export$5339fcdc8e2a427c)(parsedUrl) : url;
                    var _obj;
                    var streamSpan = (0, $79c462813a8928a4$export$63dbba021a6b4047)({
                        name: "".concat(method, " ").concat(sanitizedUrl),
                        startTime: handlerData.endTimestamp,
                        attributes: (_obj = {
                            url: (0, $82aed6a67a552ecb$export$8abd806fcaf234fa)(url),
                            "http.method": method,
                            type: "fetch"
                        }, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$1a413bd9a88fdb09), "http.client.stream"), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.http.browser.stream"), _obj)
                    });
                    $3dd9fb89a582f4e2$var$responseToStreamSpan.set(handlerData.response, streamSpan);
                    var fallbackTimeout = setTimeout(function() {
                        if (streamSpan.isRecording()) streamSpan.end();
                    }, $3dd9fb89a582f4e2$var$STREAM_RESOLVE_FALLBACK_MS);
                    $3dd9fb89a582f4e2$var$responseToFallbackTimeout.set(handlerData.response, fallbackTimeout);
                }
            });
        }
    };
});




var $dUlz9 = parcelRequire("dUlz9");

var $ectF0 = parcelRequire("ectF0");

function $0cb6d550a0b1aae5$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" && (!(0, $ectF0.isNodeEnv)() || $0cb6d550a0b1aae5$var$isElectronNodeRenderer());
}
function $0cb6d550a0b1aae5$var$isElectronNodeRenderer() {
    var process = (0, $6001140c9a325157$export$f1a6cdb1459e81d1).process;
    return (process === null || process === void 0 ? void 0 : process.type) === "renderer";
}






var $90deb20019161b53$var$LAST_INTERACTIONS = [];
var $90deb20019161b53$var$INTERACTIONS_SPAN_MAP = /* @__PURE__ */ new Map();
var $90deb20019161b53$var$ELEMENT_NAME_TIMESTAMP_MAP = /* @__PURE__ */ new Map();
var $90deb20019161b53$export$619786413bcce1e1 = 60;
function $90deb20019161b53$export$f17d06681a4744a3() {
    var performance = (0, $f3d6701b01476aa0$export$f72a13c439a30cab)();
    if (performance && (0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)()) {
        var inpCallback = $90deb20019161b53$export$eeab203db0ed99a9();
        return function() {
            inpCallback();
        };
    }
    return function() {
        return void 0;
    };
}
var $90deb20019161b53$export$7cd941f925ded42f = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
function $90deb20019161b53$export$eeab203db0ed99a9() {
    return (0, $f7bcc4b265d50461$export$da3b76aa2022cbd7)($90deb20019161b53$export$7bcb98fe01441521);
}
var $90deb20019161b53$export$7bcb98fe01441521 = function(param) {
    var metric = param.metric;
    if (metric.value == void 0) return;
    var duration = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(metric.value);
    if (duration > $90deb20019161b53$export$619786413bcce1e1) return;
    var entry = metric.entries.find(function(entry2) {
        return entry2.duration === metric.value && $90deb20019161b53$export$7cd941f925ded42f[entry2.name];
    });
    if (!entry) return;
    var interactionId = entry.interactionId;
    var interactionType = $90deb20019161b53$export$7cd941f925ded42f[entry.name];
    var startTime = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)((0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)() + entry.startTime);
    var activeSpan = (0, $79515206909fddff$export$1be426a8e585c83e)();
    var rootSpan = activeSpan ? (0, $79515206909fddff$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    var cachedInteractionContext = interactionId != null ? $90deb20019161b53$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
    var spanToUse = (cachedInteractionContext === null || cachedInteractionContext === void 0 ? void 0 : cachedInteractionContext.span) || rootSpan;
    var routeName = spanToUse ? (0, $79515206909fddff$export$92d8c23565496537)(spanToUse).description : (0, $945639585ea57ae0$export$c7be4b0125a10cba)().getScopeData().transactionName;
    var name = (cachedInteractionContext === null || cachedInteractionContext === void 0 ? void 0 : cachedInteractionContext.elementName) || (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(entry.target);
    var _obj;
    var attributes = (_obj = {}, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.http.browser.inp"), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$1a413bd9a88fdb09), "ui.interaction.".concat(interactionType)), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$fea48ba9f4550879), entry.duration), _obj);
    var span = (0, $f3d6701b01476aa0$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        var _obj1;
        span.addEvent("inp", (_obj1 = {}, (0, $dUlz9._)(_obj1, (0, $5d82adaea61c8fa9$export$f5f95cff026507b5), "millisecond"), (0, $dUlz9._)(_obj1, (0, $5d82adaea61c8fa9$export$69cd5c610c7bb96a), metric.value), _obj1));
        span.end(startTime + duration);
    }
};
function $90deb20019161b53$export$e4a670d077ebcfef(interactionId) {
    return interactionId != null ? $90deb20019161b53$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
}
function $90deb20019161b53$export$e4e04d43e223cce2() {
    var interactionEvents = Object.keys($90deb20019161b53$export$7cd941f925ded42f);
    if ((0, $0cb6d550a0b1aae5$export$4e09c449d6c407f7)()) interactionEvents.forEach(function(eventType) {
        (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).addEventListener(eventType, captureElementFromEvent, {
            capture: true,
            passive: true
        });
    });
    function captureElementFromEvent(event) {
        var target = event.target;
        if (!target) return;
        var elementName = (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(target);
        var timestamp = Math.round(event.timeStamp);
        $90deb20019161b53$var$ELEMENT_NAME_TIMESTAMP_MAP.set(timestamp, elementName);
        if ($90deb20019161b53$var$ELEMENT_NAME_TIMESTAMP_MAP.size > 50) {
            var firstKey = $90deb20019161b53$var$ELEMENT_NAME_TIMESTAMP_MAP.keys().next().value;
            if (firstKey !== void 0) $90deb20019161b53$var$ELEMENT_NAME_TIMESTAMP_MAP.delete(firstKey);
        }
    }
    function resolveElementNameFromEntry(entry) {
        var timestamp = Math.round(entry.startTime);
        var elementName = $90deb20019161b53$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp);
        if (!elementName) for(var offset = -5; offset <= 5; offset++){
            var nearbyName = $90deb20019161b53$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp + offset);
            if (nearbyName) {
                elementName = nearbyName;
                break;
            }
        }
        return elementName || "<unknown>";
    }
    var handleEntries = function(param) {
        var entries = param.entries;
        var activeSpan = (0, $79515206909fddff$export$1be426a8e585c83e)();
        var activeRootSpan = activeSpan && (0, $79515206909fddff$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach(function(entry) {
            if (!(0, $f7bcc4b265d50461$export$7affb50b622d8714)(entry)) return;
            var interactionId = entry.interactionId;
            if (interactionId == null) return;
            if ($90deb20019161b53$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            var elementName = entry.target ? (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(entry.target) : resolveElementNameFromEntry(entry);
            if ($90deb20019161b53$var$LAST_INTERACTIONS.length > 10) {
                var last = $90deb20019161b53$var$LAST_INTERACTIONS.shift();
                $90deb20019161b53$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            $90deb20019161b53$var$LAST_INTERACTIONS.push(interactionId);
            $90deb20019161b53$var$INTERACTIONS_SPAN_MAP.set(interactionId, {
                span: activeRootSpan,
                elementName: elementName
            });
        });
    };
    (0, $f7bcc4b265d50461$export$69816c1a049f8db6)("event", handleEntries);
    (0, $f7bcc4b265d50461$export$69816c1a049f8db6)("first-input", handleEntries);
}


var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");









function $b256a792239c9271$export$f4adb23e57c1dac6(options) {
    var _WINDOW_navigator, _spanToStreamedSpanJSON_attributes;
    var name = options.name, op = options.op, origin = options.origin, metricName = options.metricName, value = options.value, passedAttributes = options.attributes, parentSpan = options.parentSpan, reportEvent = options.reportEvent, startTime = options.startTime, endTime = options.endTime;
    var routeName = (0, $945639585ea57ae0$export$c7be4b0125a10cba)().getScopeData().transactionName;
    var _obj;
    var attributes = (0, $hwO3w._)((_obj = {}, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), origin), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$1a413bd9a88fdb09), op), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$fea48ba9f4550879), 0), (0, $dUlz9._)(_obj, "browser.web_vital.".concat(metricName, ".value"), value), // oxlint-disable-next-line typescript-eslint/no-deprecated
    (0, $dUlz9._)(_obj, (0, $117bb525af114730$export$570ac5a3fd7e6cc6), routeName), (0, $dUlz9._)(_obj, (0, $117bb525af114730$export$d4f25b923533dbba), routeName), (0, $dUlz9._)(_obj, // Web vital score calculation relies on the user agent
    "user_agent.original", (_WINDOW_navigator = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).navigator) === null || _WINDOW_navigator === void 0 ? void 0 : _WINDOW_navigator.userAgent), _obj), passedAttributes);
    if (parentSpan && ((_spanToStreamedSpanJSON_attributes = (0, $79515206909fddff$export$db0cad9e44f67af8)(parentSpan).attributes) === null || _spanToStreamedSpanJSON_attributes === void 0 ? void 0 : _spanToStreamedSpanJSON_attributes[0, $5d82adaea61c8fa9$export$1a413bd9a88fdb09]) === "pageload") attributes["sentry.pageload.span_id"] = parentSpan.spanContext().spanId;
    if (reportEvent) attributes["browser.web_vital.".concat(metricName, ".report_event")] = reportEvent;
    var span = (0, $79c462813a8928a4$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        // if we have a pageload span, we let the web vital span start as its parent. This ensures that
        // it is not started as a segment span, without having to manually set it to a "standalone" v2 span
        // that has `segment: false` but no actual parent span.
        parentSpan: parentSpan
    });
    if (span) span.end(endTime !== null && endTime !== void 0 ? endTime : startTime);
}
function $b256a792239c9271$export$73747c030e2325c0(client) {
    var lcpValue = 0;
    var lcpEntry;
    if (!(0, $f3d6701b01476aa0$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    var cleanupLcpHandler = (0, $f7bcc4b265d50461$export$3fd4b53331200102)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $513c7b4e9d87bd26$export$e59775b7d17699ba)(metric.value)) return;
        lcpValue = metric.value;
        lcpEntry = entry;
    }, true);
    (0, $f3d6701b01476aa0$export$382ad360b45665ab)(client, function(reportEvent, _, pageloadSpan) {
        $b256a792239c9271$export$1adcb85d073cd594(lcpValue, lcpEntry, pageloadSpan, reportEvent);
        cleanupLcpHandler();
    });
}
function $b256a792239c9271$export$1adcb85d073cd594(lcpValue, entry, pageloadSpan, reportEvent) {
    if (!(0, $513c7b4e9d87bd26$export$e59775b7d17699ba)(lcpValue)) return;
    (0, $f4443e0779e1b74f$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Sending LCP span (".concat(lcpValue, ")"));
    var performanceTimeOrigin = (0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)() || 0;
    var timeOrigin = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(performanceTimeOrigin);
    var endTime = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(performanceTimeOrigin + ((entry === null || entry === void 0 ? void 0 : entry.startTime) || 0));
    var name = entry ? (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    var attributes = {};
    (entry === null || entry === void 0 ? void 0 : entry.element) && (attributes["browser.web_vital.lcp.element"] = (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(entry.element));
    (entry === null || entry === void 0 ? void 0 : entry.id) && (attributes["browser.web_vital.lcp.id"] = entry.id);
    (entry === null || entry === void 0 ? void 0 : entry.url) && (attributes["browser.web_vital.lcp.url"] = entry.url);
    (entry === null || entry === void 0 ? void 0 : entry.loadTime) != null && (attributes["browser.web_vital.lcp.load_time"] = entry.loadTime);
    (entry === null || entry === void 0 ? void 0 : entry.renderTime) != null && (attributes["browser.web_vital.lcp.render_time"] = entry.renderTime);
    (entry === null || entry === void 0 ? void 0 : entry.size) != null && (attributes["browser.web_vital.lcp.size"] = entry.size);
    $b256a792239c9271$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.lcp",
        origin: "auto.http.browser.lcp",
        metricName: "lcp",
        value: lcpValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: timeOrigin,
        endTime: endTime
    });
}
function $b256a792239c9271$export$f2ca9ed704743eb2(client) {
    var clsValue = 0;
    var clsEntry;
    if (!(0, $f3d6701b01476aa0$export$c7533a7b4a9f2e94)("layout-shift")) return;
    var cleanupClsHandler = (0, $f7bcc4b265d50461$export$861b82818b37ba5b)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        clsValue = metric.value;
        clsEntry = entry;
    }, true);
    (0, $f3d6701b01476aa0$export$382ad360b45665ab)(client, function(reportEvent, _, pageloadSpan) {
        $b256a792239c9271$export$736c846d4f7aff83(clsValue, clsEntry, pageloadSpan, reportEvent);
        cleanupClsHandler();
    });
}
function $b256a792239c9271$export$736c846d4f7aff83(clsValue, entry, pageloadSpan, reportEvent) {
    var _entry_sources_;
    (0, $f4443e0779e1b74f$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Sending CLS span (".concat(clsValue, ")"));
    var startTime = entry ? (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(((0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
    var name = entry ? (0, $bf34547bb00b7a11$export$5647df6b7814ac86)((_entry_sources_ = entry.sources[0]) === null || _entry_sources_ === void 0 ? void 0 : _entry_sources_.node) : "Layout shift";
    var attributes = {};
    if (entry === null || entry === void 0 ? void 0 : entry.sources) entry.sources.forEach(function(source, index) {
        attributes["browser.web_vital.cls.source.".concat(index + 1)] = (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(source.node);
    });
    $b256a792239c9271$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.cls",
        origin: "auto.http.browser.cls",
        metricName: "cls",
        value: clsValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: startTime
    });
}
function $b256a792239c9271$export$4a8cbc644515d57b() {
    var performance = (0, $f3d6701b01476aa0$export$f72a13c439a30cab)();
    if (!performance || !(0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)()) return;
    var onInp = function(param) {
        var metric = param.metric;
        if (metric.value == null) return;
        var duration = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(metric.value);
        if (duration > (0, $90deb20019161b53$export$619786413bcce1e1)) return;
        var entry = metric.entries.find(function(e) {
            return e.duration === metric.value && (0, $90deb20019161b53$export$7cd941f925ded42f)[e.name];
        });
        if (!entry) return;
        $b256a792239c9271$export$bd315e549441b68a(metric.value, entry);
    };
    (0, $f7bcc4b265d50461$export$da3b76aa2022cbd7)(onInp);
}
function $b256a792239c9271$export$bd315e549441b68a(inpValue, entry) {
    (0, $f4443e0779e1b74f$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Sending INP span (".concat(inpValue, ")"));
    var startTime = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)((0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)() + entry.startTime);
    var duration = (0, $f3d6701b01476aa0$export$b4785dbd4a81b33f)(inpValue);
    var interactionType = (0, $90deb20019161b53$export$7cd941f925ded42f)[entry.name];
    var cachedContext = (0, $90deb20019161b53$export$e4a670d077ebcfef)(entry.interactionId);
    var activeSpan = (0, $79515206909fddff$export$1be426a8e585c83e)();
    var rootSpan = activeSpan ? (0, $79515206909fddff$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    var spanToUse = (cachedContext === null || cachedContext === void 0 ? void 0 : cachedContext.span) || rootSpan;
    var routeName = spanToUse ? (0, $79515206909fddff$export$db0cad9e44f67af8)(spanToUse).name : (0, $945639585ea57ae0$export$c7be4b0125a10cba)().getScopeData().transactionName;
    var name = (cachedContext === null || cachedContext === void 0 ? void 0 : cachedContext.elementName) || (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(entry.target);
    var _obj;
    $b256a792239c9271$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.interaction.".concat(interactionType),
        origin: "auto.http.browser.inp",
        metricName: "inp",
        value: inpValue,
        attributes: (_obj = {}, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$fea48ba9f4550879), entry.duration), // oxlint-disable-next-line typescript-eslint/no-deprecated
        (0, $dUlz9._)(_obj, (0, $117bb525af114730$export$570ac5a3fd7e6cc6), routeName), (0, $dUlz9._)(_obj, (0, $117bb525af114730$export$d4f25b923533dbba), routeName), _obj),
        startTime: startTime,
        endTime: startTime + duration,
        parentSpan: spanToUse
    });
}


var $b7f224e5686419bb$export$8748555bacc7091c = "WebVitals";
var $b7f224e5686419bb$export$1ab4995602e8adaa = (0, $ae9d79ccde098562$export$2323046b9414659f)(function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_ignore;
    var ignored = new Set((_options_ignore = options.ignore) !== null && _options_ignore !== void 0 ? _options_ignore : []);
    return {
        name: $b7f224e5686419bb$export$8748555bacc7091c,
        setup: function(client) {
            var spanStreamingEnabled = (0, $a0e1c0749ad8282c$export$6ea47215d699c04a)(client);
            var _options__experiments;
            var _ref = (_options__experiments = options._experiments) !== null && _options__experiments !== void 0 ? _options__experiments : {}, enableStandaloneClsSpans = _ref.enableStandaloneClsSpans, enableStandaloneLcpSpans = _ref.enableStandaloneLcpSpans;
            var recordClsStandaloneSpans = spanStreamingEnabled || ignored.has("cls") ? void 0 : enableStandaloneClsSpans || false;
            var recordLcpStandaloneSpans = spanStreamingEnabled || ignored.has("lcp") ? void 0 : enableStandaloneLcpSpans || false;
            var finalizeWebVitals = (0, $5d0a1b62516c4ec6$export$7c69f0412d101b88)({
                recordClsStandaloneSpans: recordClsStandaloneSpans,
                recordLcpStandaloneSpans: recordLcpStandaloneSpans,
                client: client
            });
            var pageloadSpans = /* @__PURE__ */ new WeakSet();
            client.on("afterStartPageLoadSpan", function(span) {
                pageloadSpans.add(span);
            });
            client.on("spanEnd", function(span) {
                if (!pageloadSpans.delete(span)) return;
                finalizeWebVitals();
                (0, $5d0a1b62516c4ec6$export$d14e394b690acc17)(span, {
                    // CLS/LCP are recorded as pageload span measurements only when they're neither
                    // tracked as standalone spans nor handled by span streaming (and not ignored).
                    recordClsOnPageloadSpan: recordClsStandaloneSpans === false,
                    recordLcpOnPageloadSpan: recordLcpStandaloneSpans === false,
                    spanStreamingEnabled: spanStreamingEnabled
                });
            });
            if (spanStreamingEnabled) {
                if (!ignored.has("lcp")) (0, $b256a792239c9271$export$73747c030e2325c0)(client);
                if (!ignored.has("cls")) (0, $b256a792239c9271$export$f2ca9ed704743eb2)(client);
                if (!ignored.has("inp")) (0, $b256a792239c9271$export$4a8cbc644515d57b)();
            } else if (!ignored.has("inp")) (0, $90deb20019161b53$export$f17d06681a4744a3)();
        },
        afterAllSetup: function() {
            if (!ignored.has("inp")) (0, $90deb20019161b53$export$e4e04d43e223cce2)();
        }
    };
});





function $7fdae829369feb26$export$6f18f55521af71a1() {
    if ((0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).document) (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", function() {
        var activeSpan = (0, $79515206909fddff$export$1be426a8e585c83e)();
        if (!activeSpan) return;
        var rootSpan = (0, $79515206909fddff$export$c4c6a79b1260ca1b)(activeSpan);
        if ((0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            var cancelledStatus = "cancelled";
            var _spanToJSON = (0, $79515206909fddff$export$92d8c23565496537)(rootSpan), op = _spanToJSON.op, status = _spanToJSON.status;
            if (0, $be1ea91a107a1f2d$export$16a28057038b10ef) (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Tracing] Transaction: ".concat(cancelledStatus, " -> since tab moved to the background, op: ").concat(op));
            if (!status) rootSpan.setStatus({
                code: (0, $6ec04d3e01c80cf6$export$f966a0446ece71e),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $be1ea91a107a1f2d$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}



var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");












var $51ffcccd1322ad77$export$c8d616af96ac729f = 3600;
var $51ffcccd1322ad77$export$16b6aa13b3c0f075 = "sentry_previous_trace";
var $51ffcccd1322ad77$export$237518aee8726f02 = "sentry.previous_trace";
function $51ffcccd1322ad77$export$830d9ee659c6e4c4(client, param) {
    var linkPreviousTrace = param.linkPreviousTrace, consistentTraceSampling = param.consistentTraceSampling;
    var useSessionStorage = linkPreviousTrace === "session-storage";
    var inMemoryPreviousTraceInfo = useSessionStorage ? $51ffcccd1322ad77$export$ef546bba8a402d99() : void 0;
    client.on("spanStart", function(span) {
        if ((0, $79515206909fddff$export$c4c6a79b1260ca1b)(span) !== span) return;
        var oldPropagationContext = (0, $945639585ea57ae0$export$c7be4b0125a10cba)().getPropagationContext();
        inMemoryPreviousTraceInfo = $51ffcccd1322ad77$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $51ffcccd1322ad77$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    var isFirstTraceOnPageload = true;
    if (consistentTraceSampling) client.on("beforeSampling", function(mutableSamplingContextData) {
        if (!inMemoryPreviousTraceInfo) return;
        var scope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
        var currentPropagationContext = scope.getPropagationContext();
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext((0, $lf4fc._)((0, $hwO3w._)({}, currentPropagationContext), {
            dsc: (0, $lf4fc._)((0, $hwO3w._)({}, currentPropagationContext.dsc), {
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($51ffcccd1322ad77$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            }),
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        }));
        mutableSamplingContextData.parentSampled = $51ffcccd1322ad77$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = (0, $lf4fc._)((0, $hwO3w._)({}, mutableSamplingContextData.spanAttributes), (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$889fb736668e1ecc), inMemoryPreviousTraceInfo.sampleRate));
    });
}
function $51ffcccd1322ad77$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    var spanJson = (0, $79515206909fddff$export$92d8c23565496537)(span);
    function getSampleRate() {
        try {
            var _spanJson_data, _oldPropagationContext_dsc;
            var _spanJson_data_SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
            var oldSampleRate = Number((_spanJson_data_SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = (_spanJson_data = spanJson.data) === null || _spanJson_data === void 0 ? void 0 : _spanJson_data[0, $5d82adaea61c8fa9$export$ccfe0a40627cc34b]) !== null && _spanJson_data_SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE !== void 0 ? _spanJson_data_SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE : (_oldPropagationContext_dsc = oldPropagationContext.dsc) === null || _oldPropagationContext_dsc === void 0 ? void 0 : _oldPropagationContext_dsc.sample_rate);
            return Number.isNaN(oldSampleRate) ? 0 : oldSampleRate;
        } catch (e) {
            return 0;
        }
    }
    var updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    var previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) return previousTraceInfo;
    if (Date.now() / 1e3 - previousTraceInfo.startTimestamp <= $51ffcccd1322ad77$export$c8d616af96ac729f) {
        if (0, $be1ea91a107a1f2d$export$16a28057038b10ef) (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Adding previous_trace `".concat(JSON.stringify(previousTraceSpanCtx), "` link to span `").concat(JSON.stringify((0, $hwO3w._)({
            op: spanJson.op
        }, span.spanContext())), "`"));
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$ff77b5fd5b2d627b), "previous_trace")
        });
        span.setAttribute($51ffcccd1322ad77$export$237518aee8726f02, "".concat(previousTraceSpanCtx.traceId, "-").concat(previousTraceSpanCtx.spanId, "-").concat($51ffcccd1322ad77$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0));
    }
    return updatedPreviousTraceInfo;
}
function $51ffcccd1322ad77$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).sessionStorage.setItem($51ffcccd1322ad77$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        (0, $be1ea91a107a1f2d$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Could not store previous trace in sessionStorage", e);
    }
}
function $51ffcccd1322ad77$export$ef546bba8a402d99() {
    try {
        var _WINDOW_sessionStorage;
        var previousTraceInfo = (_WINDOW_sessionStorage = (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).sessionStorage) === null || _WINDOW_sessionStorage === void 0 ? void 0 : _WINDOW_sessionStorage.getItem($51ffcccd1322ad77$export$16b6aa13b3c0f075);
        return JSON.parse(previousTraceInfo);
    } catch (e) {
        return void 0;
    }
}
function $51ffcccd1322ad77$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 1;
}



var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");











function $a5a6c7f40d11d05a$export$dec8f001b9d982cb() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var client = options.client || (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    if (!(0, $13be2508cc312e06$export$3b029eb57ac4d562)() || !client) return {};
    var carrier = (0, $8a2f538a13cfc001$export$19eade501500c6c1)();
    var acs = (0, $4e593e827d604273$export$f639b0c2752203be)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    var scope = options.scope || (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
    var span = options.span || (0, $79515206909fddff$export$1be426a8e585c83e)();
    var isTwpPlaceholder = (0, $110aa6964cb2c8bd$export$61cc547d99783aa7)(span) && !(0, $ffb01f703f29801c$export$1f70765132c3c225)(client.getOptions());
    if (!span && (0, $945639585ea57ae0$export$53f0ae651a1c4298)()) return {};
    var sentryTrace = span && !isTwpPlaceholder ? (0, $79515206909fddff$export$7e9f8ae9e4a328ab)(span) : $a5a6c7f40d11d05a$var$scopeToTraceHeader(scope);
    var dsc = span ? (0, $0d1fd6101086a96b$export$a117f995597e25df)(span) : (0, $0d1fd6101086a96b$export$89ef1736f08c6b2b)(client, scope);
    var baggage = (0, $0885d9483190850a$export$56766feef403f365)(dsc);
    var isValidSentryTraceHeader = (0, $741db41d31a45a5e$export$394a210812ba3012).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    var traceData = {
        "sentry-trace": sentryTrace,
        baggage: baggage
    };
    if (options.propagateTraceparent) traceData.traceparent = span && !isTwpPlaceholder ? (0, $79515206909fddff$export$cda58d87bc594e9f)(span) : $a5a6c7f40d11d05a$var$scopeToTraceparentHeader(scope);
    return traceData;
}
function $a5a6c7f40d11d05a$var$scopeToTraceHeader(scope) {
    var _scope_getPropagationContext = scope.getPropagationContext(), traceId = _scope_getPropagationContext.traceId, sampled = _scope_getPropagationContext.sampled, propagationSpanId = _scope_getPropagationContext.propagationSpanId;
    return (0, $741db41d31a45a5e$export$f35d907436da45cf)(traceId, propagationSpanId, sampled);
}
function $a5a6c7f40d11d05a$var$scopeToTraceparentHeader(scope) {
    var _scope_getPropagationContext = scope.getPropagationContext(), traceId = _scope_getPropagationContext.traceId, sampled = _scope_getPropagationContext.sampled, propagationSpanId = _scope_getPropagationContext.propagationSpanId;
    return (0, $741db41d31a45a5e$export$1aff3752542747dd)(traceId, propagationSpanId, sampled);
}


var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $XnYkK = parcelRequire("XnYkK");

var $03bAP = parcelRequire("03bAP");













function $d40361076213da3b$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return void 0;
    var _handlerData_fetchData = handlerData.fetchData, method = _handlerData_fetchData.method, url = _handlerData_fetchData.url;
    var shouldCreateSpanResult = (0, $ffb01f703f29801c$export$1f70765132c3c225)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        var span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult) {
                $d40361076213da3b$var$endSpan(span2, handlerData);
                $d40361076213da3b$export$740b7cef1e5753d5(span2, handlerData, spanOriginOrOptions);
            }
            delete spans[spanId];
        }
        return void 0;
    }
    var _ref = (typeof spanOriginOrOptions === "undefined" ? "undefined" : (0, $03bAP._)(spanOriginOrOptions)) === "object" ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    }, _ref_spanOrigin = _ref.spanOrigin, spanOrigin = _ref_spanOrigin === void 0 ? "auto.http.browser" : _ref_spanOrigin, _ref_propagateTraceparent = _ref.propagateTraceparent, propagateTraceparent = _ref_propagateTraceparent === void 0 ? false : _ref_propagateTraceparent;
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    var hasParent = !!(0, $79515206909fddff$export$1be426a8e585c83e)();
    var shouldEmitSpan = hasParent || !!client && (0, $a0e1c0749ad8282c$export$6ea47215d699c04a)(client);
    var span = shouldCreateSpanResult && shouldEmitSpan ? (0, $79c462813a8928a4$export$63dbba021a6b4047)($d40361076213da3b$var$getSpanStartOptions(url, method, spanOrigin)) : new (0, $110aa6964cb2c8bd$export$d6636b700b76c516)();
    var spanForTraceHeaders = (0, $79c462813a8928a4$export$b0b1bd7d4bdbd54e)(span) && hasParent ? void 0 : span;
    if (shouldCreateSpanResult && !shouldEmitSpan) client === null || client === void 0 ? void 0 : client.recordDroppedEvent("no_parent_span", "span");
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        var request = handlerData.args[0];
        var options = (0, $hwO3w._)({}, handlerData.args[1] || {});
        var headers = $d40361076213da3b$export$edc464bd1b3715bb(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $ffb01f703f29801c$export$1f70765132c3c225)() && shouldEmitSpan ? spanForTraceHeaders : void 0, propagateTraceparent);
        if (headers) {
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        var fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
function $d40361076213da3b$export$740b7cef1e5753d5(span, handlerData, spanOriginOrOptions) {
    var _handlerData_response;
    var onRequestSpanEnd = (typeof spanOriginOrOptions === "undefined" ? "undefined" : (0, $03bAP._)(spanOriginOrOptions)) === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
    onRequestSpanEnd === null || onRequestSpanEnd === void 0 ? void 0 : onRequestSpanEnd(span, {
        headers: (_handlerData_response = handlerData.response) === null || _handlerData_response === void 0 ? void 0 : _handlerData_response.headers,
        error: handlerData.error
    });
}
function $d40361076213da3b$export$edc464bd1b3715bb(request, fetchOptionsObj, span, propagateTraceparent) {
    var traceHeaders = (0, $a5a6c7f40d11d05a$export$dec8f001b9d982cb)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    var sentryTrace = traceHeaders["sentry-trace"];
    var baggage = traceHeaders.baggage;
    var traceparent = traceHeaders.traceparent;
    if (!sentryTrace) return void 0;
    var originalHeaders = fetchOptionsObj.headers || ((0, $6ea82c15e37d9720$export$6d3d1f317d7cda57)(request) ? request.headers : void 0);
    if (!originalHeaders) return (0, $hwO3w._)({
        "sentry-trace": sentryTrace
    }, baggage && {
        baggage: baggage
    }, traceparent && {
        traceparent: traceparent
    });
    else if ($d40361076213da3b$var$isHeaders(originalHeaders)) {
        var newHeaders = new Headers(originalHeaders);
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) newHeaders.set("traceparent", traceparent);
        if (baggage) {
            var prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!$d40361076213da3b$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", "".concat(prevBaggageHeader, ",").concat(baggage));
        }
        return newHeaders;
    } else if ($d40361076213da3b$var$isHeadersInitTupleArray(originalHeaders)) {
        var newHeaders1 = (0, $XnYkK._)(originalHeaders);
        if (!newHeaders1.find(function(header) {
            return header[0] === "sentry-trace";
        })) newHeaders1.push([
            "sentry-trace",
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders1.find(function(header) {
            return header[0] === "traceparent";
        })) newHeaders1.push([
            "traceparent",
            traceparent
        ]);
        var prevBaggageHeaderWithSentryValues = originalHeaders.find(function(header) {
            return header[0] === "baggage" && typeof header[1] === "string" && $d40361076213da3b$var$baggageHeaderHasSentryBaggageValues(header[1]);
        });
        if (baggage && !prevBaggageHeaderWithSentryValues) newHeaders1.push([
            "baggage",
            baggage
        ]);
        return newHeaders1;
    } else {
        var existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
        var existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
        var existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
        var newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? (0, $XnYkK._)(existingBaggageHeader) : [
            existingBaggageHeader
        ] : [];
        var prevBaggageHeaderWithSentryValues1 = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find(function(headerItem) {
            return $d40361076213da3b$var$baggageHeaderHasSentryBaggageValues(headerItem);
        }) : $d40361076213da3b$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues1) newBaggageHeaders.push(baggage);
        var newHeaders2 = Object.assign({}, originalHeaders, (0, $hwO3w._)({
            "sentry-trace": existingSentryTraceHeader !== null && existingSentryTraceHeader !== void 0 ? existingSentryTraceHeader : sentryTrace
        }, newBaggageHeaders.length > 0 && {
            baggage: newBaggageHeaders.join(",")
        }));
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders2.traceparent = traceparent;
        return newHeaders2;
    }
}
function $d40361076213da3b$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        var _handlerData_response_headers, _handlerData_response;
        (0, $6ec04d3e01c80cf6$export$2ad6630ec8164254)(span, handlerData.response.status);
        var contentLength = (_handlerData_response = handlerData.response) === null || _handlerData_response === void 0 ? void 0 : (_handlerData_response_headers = _handlerData_response.headers) === null || _handlerData_response_headers === void 0 ? void 0 : _handlerData_response_headers.get("content-length");
        if (contentLength) {
            var contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $6ec04d3e01c80cf6$export$f966a0446ece71e),
        message: "internal_error"
    });
    span.end();
}
function $d40361076213da3b$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== "string") return false;
    return baggageHeader.split(",").some(function(baggageEntry) {
        return baggageEntry.trim().startsWith((0, $0885d9483190850a$export$6e69537d67fa20f));
    });
}
function $d40361076213da3b$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && (0, $6ea82c15e37d9720$export$49034edbe6b62415)(headers, Headers);
}
function $d40361076213da3b$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every(function(item) {
        return Array.isArray(item) && item.length === 2 && typeof item[0] === "string";
    });
}
function $d40361076213da3b$var$getSpanStartOptions(url, method, spanOrigin) {
    if (url.startsWith("data:")) {
        var sanitizedUrl2 = (0, $82aed6a67a552ecb$export$8abd806fcaf234fa)(url);
        return {
            name: "".concat(method, " ").concat(sanitizedUrl2),
            attributes: $d40361076213da3b$var$getFetchSpanAttributes(url, void 0, method, spanOrigin)
        };
    }
    var parsedUrl = (0, $82aed6a67a552ecb$export$2004d912a9ead694)(url);
    var sanitizedUrl = parsedUrl ? (0, $82aed6a67a552ecb$export$5339fcdc8e2a427c)(parsedUrl) : url;
    return {
        name: "".concat(method, " ").concat(sanitizedUrl),
        attributes: $d40361076213da3b$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin)
    };
}
function $d40361076213da3b$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin) {
    var _obj;
    var attributes = (_obj = {
        url: (0, $82aed6a67a552ecb$export$8abd806fcaf234fa)(url),
        type: "fetch",
        "http.method": method
    }, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), spanOrigin), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$1a413bd9a88fdb09), "http.client"), _obj);
    if (parsedUrl) {
        if (!(0, $82aed6a67a552ecb$export$e258e13805402ba7)(parsedUrl)) {
            attributes[0, $117bb525af114730$export$778e4213e2788579] = (0, $82aed6a67a552ecb$export$8abd806fcaf234fa)(parsedUrl.href);
            attributes[0, $117bb525af114730$export$40eacf1a072c9dbd] = (0, $82aed6a67a552ecb$export$8abd806fcaf234fa)(parsedUrl.href);
            attributes["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes["http.query"] = parsedUrl.search;
        if (parsedUrl.hash) attributes["http.fragment"] = parsedUrl.hash;
    }
    return attributes;
}



var $6iP9u = parcelRequire("6iP9u");


var $2034b898240d7377$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $2034b898240d7377$export$26ace48dd54c9aea(handler) {
    var type = "xhr";
    (0, $50b9444442511a8d$export$a4e09611e30da72e)(type, handler);
    (0, $50b9444442511a8d$export$e18d6c5462c01368)(type, $2034b898240d7377$export$c67d533bf77cbf54);
}
function $2034b898240d7377$export$c67d533bf77cbf54() {
    if (!(0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    var xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply: function(originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            var virtualError = new Error();
            var startTimestamp = (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)() * 1e3;
            var method = (0, $6ea82c15e37d9720$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            var url = $2034b898240d7377$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$2034b898240d7377$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                var xhrInfo = xhrOpenThisArg[$2034b898240d7377$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {}
                    var handlerData = {
                        endTimestamp: (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $50b9444442511a8d$export$b18c893e424d3127)("xhr", handlerData);
                    xhrOpenThisArg.removeEventListener("readystatechange", onreadystatechangeHandler);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply: function(originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply: function(originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    var _setRequestHeaderArgArray = (0, $6iP9u._)(setRequestHeaderArgArray, 2), header = _setRequestHeaderArgArray[0], value = _setRequestHeaderArgArray[1];
                    var xhrInfo = setRequestHeaderThisArg[$2034b898240d7377$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $6ea82c15e37d9720$export$844ec244b1367d54)(header) && (0, $6ea82c15e37d9720$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply: function(originalSend, sendThisArg, sendArgArray) {
            var sentryXhrData = sendThisArg[$2034b898240d7377$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            var handlerData = {
                startTimestamp: (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)() * 1e3,
                xhr: sendThisArg
            };
            (0, $50b9444442511a8d$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $2034b898240d7377$var$parseXhrUrlArg(url) {
    if ((0, $6ea82c15e37d9720$export$844ec244b1367d54)(url)) return url;
    try {
        return url.toString();
    } catch (e) {}
    return void 0;
}


var $6iP9u = parcelRequire("6iP9u");

var $03bAP = parcelRequire("03bAP");


var $1520d5683edac93a$export$363d064b9116000e = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
function $1520d5683edac93a$export$2f1b0f57f243f270(formData) {
    return new URLSearchParams(formData).toString();
}
function $1520d5683edac93a$export$945a2d5364608d5(body) {
    var _debug = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $739716ea0436a6d0$export$1c9f709888824e05);
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $1520d5683edac93a$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        (0, $f4443e0779e1b74f$export$16a28057038b10ef) && _debug.error(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    (0, $f4443e0779e1b74f$export$16a28057038b10ef) && _debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $1520d5683edac93a$export$ad44edf8012ec314() {
    var fetchArgs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (fetchArgs.length >= 2 && fetchArgs[1] && (0, $03bAP._)(fetchArgs[1]) === "object" && "body" in fetchArgs[1]) return fetchArgs[1].body;
    if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
        var request = fetchArgs[0];
        var originalBody = request[$1520d5683edac93a$export$363d064b9116000e];
        if (originalBody !== void 0) return originalBody;
        return void 0;
    }
    return void 0;
}
function $1520d5683edac93a$export$ce71c337afb62ea(xhr) {
    var headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, $f4443e0779e1b74f$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).error(error, "Failed to get xhr response headers", xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split("\r\n").reduce(function(acc, line) {
        var _line_split = (0, $6iP9u._)(line.split(": "), 2), key = _line_split[0], value = _line_split[1];
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}



function $e1a254efdfad4454$export$8193ac587e359dc0(baggageHeader) {
    return baggageHeader.split(",").some(function(value) {
        return value.trim().startsWith("sentry-");
    });
}
function $e1a254efdfad4454$export$f2a087db7564c909(url) {
    try {
        var parsed = new URL(url, (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return void 0;
    }
}
function $e1a254efdfad4454$export$5803eedf1027ce61(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
function $e1a254efdfad4454$export$9dc5b8b2fb320da0(headers) {
    try {
        return new Headers(headers);
    } catch (e) {
        return void 0;
    }
}



var $e0c66f3b61328b0f$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
function $e0c66f3b61328b0f$export$864489cb3478db3e(client, _options) {
    var _$_object_spread = (0, $hwO3w._)({}, $e0c66f3b61328b0f$export$cc17fb3c0bc95cd7, _options), traceFetch = _$_object_spread.traceFetch, traceXHR = _$_object_spread.traceXHR, shouldCreateSpanForRequest = _$_object_spread.shouldCreateSpanForRequest, enableHTTPTimings = _$_object_spread.enableHTTPTimings, tracePropagationTargets = _$_object_spread.tracePropagationTargets, onRequestSpanStart = _$_object_spread.onRequestSpanStart, onRequestSpanEnd = _$_object_spread.onRequestSpanEnd;
    var shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : function(_) {
        return true;
    };
    var shouldAttachHeadersWithTargets = function(url) {
        return $e0c66f3b61328b0f$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    };
    var spans = {};
    var propagateTraceparent = client.getOptions().propagateTraceparent;
    if (traceFetch) (0, $f6ba95453bfd82e7$export$f75d3c772c923df0)(function(handlerData) {
        var createdSpan = (0, $d40361076213da3b$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
            propagateTraceparent: propagateTraceparent,
            onRequestSpanEnd: onRequestSpanEnd
        });
        if (createdSpan) {
            var fullUrl = (0, $e1a254efdfad4454$export$f2a087db7564c909)(handlerData.fetchData.url);
            var host = fullUrl ? (0, $82aed6a67a552ecb$export$7a5253c0f62e0150)(fullUrl).host : void 0;
            var sanitizedFullUrl = fullUrl ? (0, $82aed6a67a552ecb$export$8abd806fcaf234fa)(fullUrl) : void 0;
            var _obj;
            createdSpan.setAttributes((_obj = {}, // oxlint-disable-next-line typescript/no-deprecated
            (0, $dUlz9._)(_obj, (0, $117bb525af114730$export$778e4213e2788579), sanitizedFullUrl), // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
            // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
            (0, $dUlz9._)(_obj, (0, $117bb525af114730$export$40eacf1a072c9dbd), sanitizedFullUrl), (0, $dUlz9._)(_obj, "server.address", host), _obj));
            if (enableHTTPTimings) $e0c66f3b61328b0f$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart === null || onRequestSpanStart === void 0 ? void 0 : onRequestSpanStart(createdSpan, {
                headers: handlerData.headers
            });
        }
    });
    if (traceXHR) (0, $2034b898240d7377$export$26ace48dd54c9aea)(function(handlerData) {
        var createdSpan = $e0c66f3b61328b0f$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, propagateTraceparent, onRequestSpanEnd);
        if (createdSpan) {
            var _handlerData_xhr___sentry_xhr_v3__;
            if (enableHTTPTimings) $e0c66f3b61328b0f$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart === null || onRequestSpanStart === void 0 ? void 0 : onRequestSpanStart(createdSpan, {
                headers: (0, $e1a254efdfad4454$export$9dc5b8b2fb320da0)((_handlerData_xhr___sentry_xhr_v3__ = handlerData.xhr.__sentry_xhr_v3__) === null || _handlerData_xhr___sentry_xhr_v3__ === void 0 ? void 0 : _handlerData_xhr___sentry_xhr_v3__.request_headers)
            });
        }
    });
}
var $e0c66f3b61328b0f$var$HTTP_TIMING_WAIT_MS = 300;
function $e0c66f3b61328b0f$var$addHTTPTimings(span, client) {
    var url = (0, $79515206909fddff$export$92d8c23565496537)(span).data.url;
    if (!url || typeof url !== "string") return;
    var onEntryFound = function() {
        return void setTimeout(unsubscribePerformanceObsever);
    };
    if ((0, $a0e1c0749ad8282c$export$6ea47215d699c04a)(client)) {
        var originalEnd = span.end.bind(span);
        span.end = function(endTimestamp) {
            var capturedEndTimestamp = endTimestamp !== null && endTimestamp !== void 0 ? endTimestamp : (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
            var isEnded = false;
            var endSpanAndCleanup = function() {
                if (isEnded) return;
                isEnded = true;
                setTimeout(unsubscribePerformanceObsever);
                originalEnd(capturedEndTimestamp);
                clearTimeout(fallbackTimeout);
            };
            onEntryFound = endSpanAndCleanup;
            var fallbackTimeout = setTimeout(endSpanAndCleanup, $e0c66f3b61328b0f$var$HTTP_TIMING_WAIT_MS);
        };
    }
    var unsubscribePerformanceObsever = (0, $f7bcc4b265d50461$export$69816c1a049f8db6)("resource", function(param) {
        var entries = param.entries;
        entries.forEach(function(entry) {
            if ((0, $e1a254efdfad4454$export$5803eedf1027ce61)(entry) && entry.name.endsWith(url)) {
                span.setAttributes((0, $c80e23816eb2b464$export$ec50b091612e7e00)(entry));
                onEntryFound();
            }
        });
    });
}
function $e0c66f3b61328b0f$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    var href = (0, $a7a5fd8a48375ca8$export$1cfafeee2987818b)();
    if (!href) {
        var isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $45aea333cf5bef5d$export$a7a5ec66062ea5d)(targetUrl, tracePropagationTargets);
    } else {
        var resolvedUrl;
        var currentOrigin;
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        var isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $45aea333cf5bef5d$export$a7a5ec66062ea5d)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $45aea333cf5bef5d$export$a7a5ec66062ea5d)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
function $e0c66f3b61328b0f$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders2, spans, propagateTraceparent, onRequestSpanEnd) {
    var xhr = handlerData.xhr;
    var sentryXhrData = xhr === null || xhr === void 0 ? void 0 : xhr[0, $2034b898240d7377$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return void 0;
    var url = sentryXhrData.url, method = sentryXhrData.method;
    var shouldCreateSpanResult = (0, $ffb01f703f29801c$export$1f70765132c3c225)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        var spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        var span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult && sentryXhrData.status_code !== void 0) {
                (0, $6ec04d3e01c80cf6$export$2ad6630ec8164254)(span2, sentryXhrData.status_code);
                span2.end();
                onRequestSpanEnd === null || onRequestSpanEnd === void 0 ? void 0 : onRequestSpanEnd(span2, {
                    headers: (0, $e1a254efdfad4454$export$9dc5b8b2fb320da0)((0, $1520d5683edac93a$export$ce71c337afb62ea)(xhr)),
                    error: handlerData.error
                });
            }
            delete spans[spanId];
        }
        return void 0;
    }
    var fullUrl = (0, $e1a254efdfad4454$export$f2a087db7564c909)(url);
    var parsedUrl = fullUrl ? (0, $82aed6a67a552ecb$export$7a5253c0f62e0150)(fullUrl) : (0, $82aed6a67a552ecb$export$7a5253c0f62e0150)(url);
    var sanitizedFullUrl = fullUrl ? (0, $82aed6a67a552ecb$export$8abd806fcaf234fa)(fullUrl) : void 0;
    var urlForSpanName = (0, $82aed6a67a552ecb$export$8abd806fcaf234fa)((0, $82aed6a67a552ecb$export$ce084c78234bd35)(url));
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    var hasParent = !!(0, $79515206909fddff$export$1be426a8e585c83e)();
    var shouldEmitSpan = hasParent || !!client && (0, $a0e1c0749ad8282c$export$6ea47215d699c04a)(client);
    var _obj;
    var span = shouldCreateSpanResult && shouldEmitSpan ? (0, $79c462813a8928a4$export$63dbba021a6b4047)({
        name: "".concat(method, " ").concat(urlForSpanName),
        attributes: (0, $hwO3w._)((_obj = {
            url: (0, $82aed6a67a552ecb$export$8abd806fcaf234fa)(url),
            type: "xhr",
            "http.method": method,
            "http.url": sanitizedFullUrl
        }, // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
        // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
        (0, $dUlz9._)(_obj, (0, $117bb525af114730$export$40eacf1a072c9dbd), sanitizedFullUrl), (0, $dUlz9._)(_obj, "server.address", parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.host), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.http.browser"), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$1a413bd9a88fdb09), "http.client"), _obj), (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.search) && {
            "http.query": parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.search
        }, (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.hash) && {
            "http.fragment": parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.hash
        })
    }) : new (0, $110aa6964cb2c8bd$export$d6636b700b76c516)();
    var spanForTraceHeaders = (0, $79c462813a8928a4$export$b0b1bd7d4bdbd54e)(span) && hasParent ? void 0 : span;
    if (shouldCreateSpanResult && !shouldEmitSpan) client === null || client === void 0 ? void 0 : client.recordDroppedEvent("no_parent_span", "span");
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders2(url)) $e0c66f3b61328b0f$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $ffb01f703f29801c$export$1f70765132c3c225)() && shouldEmitSpan ? spanForTraceHeaders : void 0, propagateTraceparent);
    if (client) client.emit("beforeOutgoingRequestSpan", span, handlerData);
    return span;
}
function $e0c66f3b61328b0f$var$addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
    var _getTraceData = (0, $a5a6c7f40d11d05a$export$dec8f001b9d982cb)({
        span: span,
        propagateTraceparent: propagateTraceparent
    }), sentryTrace = _getTraceData["sentry-trace"], baggage = _getTraceData.baggage, traceparent = _getTraceData.traceparent;
    if (sentryTrace) $e0c66f3b61328b0f$var$setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
}
function $e0c66f3b61328b0f$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
    var _xhr___sentry_xhr_v3__;
    var originalHeaders = (_xhr___sentry_xhr_v3__ = xhr.__sentry_xhr_v3__) === null || _xhr___sentry_xhr_v3__ === void 0 ? void 0 : _xhr___sentry_xhr_v3__.request_headers;
    if ((originalHeaders === null || originalHeaders === void 0 ? void 0 : originalHeaders["sentry-trace"]) || !xhr.setRequestHeader) return;
    try {
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (traceparentHeader && !(originalHeaders === null || originalHeaders === void 0 ? void 0 : originalHeaders["traceparent"])) xhr.setRequestHeader("traceparent", traceparentHeader);
        if (sentryBaggageHeader) {
            var originalBaggageHeader = originalHeaders === null || originalHeaders === void 0 ? void 0 : originalHeaders["baggage"];
            if (!originalBaggageHeader || !(0, $e1a254efdfad4454$export$8193ac587e359dc0)(originalBaggageHeader)) xhr.setRequestHeader("baggage", sentryBaggageHeader);
        }
    } catch (e) {}
}



var $6bac36247b18b476$export$bbd2089f30bd3708 = "BrowserTracing";
var $6bac36247b18b476$var$BOT_USER_AGENT_RE = /Googlebot|Google-InspectionTool|Storebot-Google|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Facebot|facebookexternalhit|LinkedInBot|Twitterbot|Applebot/i;
function $6bac36247b18b476$export$e189d11d152c4191() {
    var nav = (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).navigator;
    if (!(nav === null || nav === void 0 ? void 0 : nav.userAgent)) return false;
    return $6bac36247b18b476$var$BOT_USER_AGENT_RE.test(nav.userAgent);
}
var $6bac36247b18b476$var$DEFAULT_BROWSER_TRACING_OPTIONS = (0, $hwO3w._)((0, $lf4fc._)((0, $hwO3w._)({}, (0, $650373597f8b6576$export$809a2b7987fd5306)), {
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    detectRedirects: true,
    linkPreviousTrace: "in-memory",
    consistentTraceSampling: false,
    enableReportPageLoaded: false,
    _experiments: {}
}), (0, $e0c66f3b61328b0f$export$cc17fb3c0bc95cd7));
var $6bac36247b18b476$export$b4109253475213e9 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if ("enableElementTiming" in options) (0, $739716ea0436a6d0$export$cda52e2a8927a2ca)(function() {
        console.warn("[Sentry] `enableElementTiming` is deprecated and no longer has any effect. Use the standalone `elementTimingIntegration` instead.");
    });
    var latestRoute = {
        name: void 0,
        source: void 0
    };
    var optionalWindowDocument = (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).document;
    var _$_object_spread = (0, $hwO3w._)({}, $6bac36247b18b476$var$DEFAULT_BROWSER_TRACING_OPTIONS, options), enableInp = _$_object_spread.enableInp, enableLongTask = _$_object_spread.enableLongTask, enableLongAnimationFrame = _$_object_spread.enableLongAnimationFrame, _object_spread__experiments = _$_object_spread._experiments, enableInteractions = _object_spread__experiments.enableInteractions, enableStandaloneClsSpans = _object_spread__experiments.enableStandaloneClsSpans, enableStandaloneLcpSpans = _object_spread__experiments.enableStandaloneLcpSpans, beforeStartSpan = _$_object_spread.beforeStartSpan, idleTimeout = _$_object_spread.idleTimeout, finalTimeout = _$_object_spread.finalTimeout, childSpanTimeout = _$_object_spread.childSpanTimeout, markBackgroundSpan = _$_object_spread.markBackgroundSpan, traceFetch = _$_object_spread.traceFetch, traceXHR = _$_object_spread.traceXHR, // eslint-disable-next-line typescript/no-deprecated
    trackFetchStreamPerformance = _$_object_spread.trackFetchStreamPerformance, shouldCreateSpanForRequest = _$_object_spread.shouldCreateSpanForRequest, enableHTTPTimings = _$_object_spread.enableHTTPTimings, ignoreResourceSpans = _$_object_spread.ignoreResourceSpans, ignorePerformanceApiSpans = _$_object_spread.ignorePerformanceApiSpans, instrumentPageLoad = _$_object_spread.instrumentPageLoad, instrumentNavigation = _$_object_spread.instrumentNavigation, detectRedirects = _$_object_spread.detectRedirects, linkPreviousTrace = _$_object_spread.linkPreviousTrace, consistentTraceSampling = _$_object_spread.consistentTraceSampling, enableReportPageLoaded = _$_object_spread.enableReportPageLoaded, onRequestSpanStart = _$_object_spread.onRequestSpanStart, onRequestSpanEnd = _$_object_spread.onRequestSpanEnd;
    var _isBot = $6bac36247b18b476$export$e189d11d152c4191();
    var lastInteractionTimestamp;
    var _pageloadSpan;
    function _createRouteSpan(client, startSpanOptions) {
        var makeActive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, url = arguments.length > 3 ? arguments[3] : void 0;
        var isPageloadSpan = startSpanOptions.op === "pageload";
        var initialSpanName = startSpanOptions.name;
        var finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        var urlObject = (0, $82aed6a67a552ecb$export$2004d912a9ead694)(url || (0, $a7a5fd8a48375ca8$export$1cfafeee2987818b)());
        var attributes = (0, $hwO3w._)({}, (urlObject === null || urlObject === void 0 ? void 0 : urlObject.pathname) && (0, $dUlz9._)({}, (0, $117bb525af114730$export$4c1fa0ac0eff2ac), urlObject.pathname), urlObject && !(0, $82aed6a67a552ecb$export$e258e13805402ba7)(urlObject) && (0, $dUlz9._)({}, (0, $117bb525af114730$export$40eacf1a072c9dbd), urlObject.href), finalStartSpanOptions.attributes);
        if (initialSpanName !== finalStartSpanOptions.name) attributes[0, $5d82adaea61c8fa9$export$d7a7d984b0791405] = "custom";
        finalStartSpanOptions.attributes = attributes;
        if (!makeActive) {
            var now = (0, $7b1d57c4c7d6952d$export$7740643b9eeaf0c4)();
            (0, $79c462813a8928a4$export$63dbba021a6b4047)((0, $lf4fc._)((0, $hwO3w._)({}, finalStartSpanOptions), {
                startTime: now
            })).end(now);
            return;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $5d82adaea61c8fa9$export$d7a7d984b0791405];
        var idleSpan = (0, $650373597f8b6576$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadSpan,
            beforeSpanEnd: function(span) {
                (0, $5d0a1b62516c4ec6$export$5f8fa6b3467a7443)(span, {
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans,
                    spanStreamingEnabled: (0, $a0e1c0749ad8282c$export$6ea47215d699c04a)(client)
                });
                $6bac36247b18b476$var$setActiveIdleSpan(client, void 0);
                var scope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
                var oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext((0, $lf4fc._)((0, $hwO3w._)({}, oldPropagationContext), {
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $79515206909fddff$export$5caecac1caaf3a71)(idleSpan),
                    dsc: (0, $0d1fd6101086a96b$export$a117f995597e25df)(span)
                }));
                if (isPageloadSpan) _pageloadSpan = void 0;
            },
            trimIdleSpanEndTimestamp: !enableReportPageLoaded
        });
        if (isPageloadSpan && enableReportPageLoaded) _pageloadSpan = idleSpan;
        $6bac36247b18b476$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                "interactive",
                "complete"
            ].includes(optionalWindowDocument.readyState)) {
                client.emit("idleSpanEnableAutoFinish", idleSpan);
                optionalWindowDocument.removeEventListener("readystatechange", emitFinish);
            }
        }
        if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
            optionalWindowDocument.addEventListener("readystatechange", emitFinish);
            emitFinish();
        }
    }
    return {
        name: $6bac36247b18b476$export$bbd2089f30bd3708,
        setup: function(client) {
            var _PerformanceObserver_supportedEntryTypes;
            if (_isBot) {
                (0, $be1ea91a107a1f2d$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Tracing] Skipping browserTracingIntegration setup for bot user agent.");
                return;
            }
            (0, $a22d054c95b6a8db$export$b0914730ee1f6c80)();
            if (enableLongAnimationFrame && (0, $6001140c9a325157$export$f1a6cdb1459e81d1).PerformanceObserver && ((_PerformanceObserver_supportedEntryTypes = PerformanceObserver.supportedEntryTypes) === null || _PerformanceObserver_supportedEntryTypes === void 0 ? void 0 : _PerformanceObserver_supportedEntryTypes.includes("long-animation-frame"))) (0, $5d0a1b62516c4ec6$export$5b823ab2ccbc801d)();
            else if (enableLongTask) (0, $5d0a1b62516c4ec6$export$f396d19077034ad2)();
            if (enableInteractions) (0, $5d0a1b62516c4ec6$export$e27543e0976315e4)();
            if (detectRedirects && optionalWindowDocument) {
                var interactionHandler = function() {
                    lastInteractionTimestamp = (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
                };
                addEventListener("click", interactionHandler, {
                    capture: true
                });
                addEventListener("keydown", interactionHandler, {
                    capture: true,
                    passive: true
                });
            }
            function maybeEndActiveSpan() {
                var activeSpan = $6bac36247b18b476$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $79515206909fddff$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $be1ea91a107a1f2d$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Tracing] Finishing current active span with op: ".concat((0, $79515206909fddff$export$92d8c23565496537)(activeSpan).op));
                    activeSpan.setAttribute((0, $5d82adaea61c8fa9$export$ba73f34502b7a3b3), "cancelled");
                    activeSpan.end();
                }
            }
            client.on("startNavigationSpan", function(startSpanOptions, navigationOptions) {
                if ((0, $945639585ea57ae0$export$6bb76d6eba7e258c)() !== client) return;
                if (navigationOptions === null || navigationOptions === void 0 ? void 0 : navigationOptions.isRedirect) {
                    (0, $be1ea91a107a1f2d$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("[Tracing] Detected redirect, navigation span will not be the root span, but a child span.");
                    _createRouteSpan(client, (0, $hwO3w._)({
                        op: "navigation.redirect"
                    }, startSpanOptions), false, navigationOptions.url);
                    return;
                }
                lastInteractionTimestamp = void 0;
                maybeEndActiveSpan();
                (0, $945639585ea57ae0$export$68f3af03034c9e90)().setPropagationContext({
                    traceId: (0, $1525c77c2ae4a4b0$export$dc6d7ea554bcce10)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $ffb01f703f29801c$export$1f70765132c3c225)() ? void 0 : (0, $1525c77c2ae4a4b0$export$295213bc4d0c54ad)()
                });
                var scope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
                scope.setPropagationContext({
                    traceId: (0, $1525c77c2ae4a4b0$export$dc6d7ea554bcce10)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $ffb01f703f29801c$export$1f70765132c3c225)() ? void 0 : (0, $1525c77c2ae4a4b0$export$295213bc4d0c54ad)()
                });
                scope.setSDKProcessingMetadata({
                    normalizedRequest: void 0
                });
                _createRouteSpan(client, (0, $lf4fc._)((0, $hwO3w._)({
                    op: "navigation"
                }, startSpanOptions), {
                    // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
                    parentSpan: null,
                    forceTransaction: true
                }), true, navigationOptions === null || navigationOptions === void 0 ? void 0 : navigationOptions.url);
            });
            client.on("startPageLoadSpan", function(startSpanOptions) {
                var traceOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if ((0, $945639585ea57ae0$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                var sentryTrace = traceOptions.sentryTrace || $6bac36247b18b476$export$f147b32b03c9cf11("sentry-trace") || $6bac36247b18b476$export$5bb9693b37f7c2ae("sentry-trace");
                var baggage = traceOptions.baggage || $6bac36247b18b476$export$f147b32b03c9cf11("baggage") || $6bac36247b18b476$export$5bb9693b37f7c2ae("baggage");
                var propagationContext = (0, $741db41d31a45a5e$export$261f383d16a93e39)(sentryTrace, baggage);
                var scope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
                scope.setPropagationContext(propagationContext);
                if (!(0, $ffb01f703f29801c$export$1f70765132c3c225)()) scope.getPropagationContext().propagationSpanId = (0, $1525c77c2ae4a4b0$export$295213bc4d0c54ad)();
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $1cd11d0052bf6dc0$export$a3c4a8453e8936f0)()
                });
                _createRouteSpan(client, (0, $hwO3w._)({
                    op: "pageload"
                }, startSpanOptions));
            });
            client.on("endPageloadSpan", function() {
                if (enableReportPageLoaded && _pageloadSpan) {
                    _pageloadSpan.setAttribute((0, $5d82adaea61c8fa9$export$ba73f34502b7a3b3), "reportPageLoaded");
                    _pageloadSpan.end();
                }
            });
        },
        afterAllSetup: function(client) {
            var _client_getIntegrationByName;
            if (_isBot) return;
            if (client.addIntegration && !((_client_getIntegrationByName = client.getIntegrationByName) === null || _client_getIntegrationByName === void 0 ? void 0 : _client_getIntegrationByName.call(client, (0, $b7f224e5686419bb$export$8748555bacc7091c)))) client.addIntegration((0, $b7f224e5686419bb$export$1ab4995602e8adaa)({
                ignore: enableInp ? [] : [
                    "inp"
                ],
                _experiments: {
                    enableStandaloneClsSpans: enableStandaloneClsSpans,
                    enableStandaloneLcpSpans: enableStandaloneLcpSpans
                }
            }));
            var startingUrl = (0, $a7a5fd8a48375ca8$export$1cfafeee2987818b)();
            if (linkPreviousTrace !== "off") (0, $51ffcccd1322ad77$export$830d9ee659c6e4c4)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) {
                    var origin = (0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)();
                    var _obj;
                    $6bac36247b18b476$export$aa44a07f82af519f(client, {
                        name: (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1e3 : void 0,
                        attributes: (_obj = {}, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$d7a7d984b0791405), "url"), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.pageload.browser"), _obj)
                    });
                }
                if (instrumentNavigation) (0, $276dfa3d97c764b4$export$3f18c56c58114e75)(function(param) {
                    var to = param.to, from = param.from;
                    if (from === void 0 && (startingUrl === null || startingUrl === void 0 ? void 0 : startingUrl.indexOf(to)) !== -1) {
                        startingUrl = void 0;
                        return;
                    }
                    startingUrl = void 0;
                    var parsed = (0, $82aed6a67a552ecb$export$2004d912a9ead694)(to);
                    var activeSpan = $6bac36247b18b476$var$getActiveIdleSpan(client);
                    var navigationIsRedirect = activeSpan && detectRedirects && $6bac36247b18b476$var$isRedirect(activeSpan, lastInteractionTimestamp);
                    var _obj;
                    $6bac36247b18b476$export$7d159749bd9969ad(client, {
                        name: (parsed === null || parsed === void 0 ? void 0 : parsed.pathname) || (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).location.pathname,
                        attributes: (_obj = {}, (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$d7a7d984b0791405), "url"), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$cca8dd30f57f805e), "auto.navigation.browser"), _obj)
                    }, {
                        url: to,
                        isRedirect: navigationIsRedirect
                    });
                });
            }
            if (markBackgroundSpan) (0, $7fdae829369feb26$export$6f18f55521af71a1)();
            if (enableInteractions) $6bac36247b18b476$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            (0, $e0c66f3b61328b0f$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart,
                onRequestSpanEnd: onRequestSpanEnd
            });
            if (trackFetchStreamPerformance) client.addIntegration((0, $3dd9fb89a582f4e2$export$b49e0d1a48dc8754)());
        }
    };
};
function $6bac36247b18b476$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $945639585ea57ae0$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    var pageloadSpan = $6bac36247b18b476$var$getActiveIdleSpan(client);
    if (pageloadSpan) client.emit("afterStartPageLoadSpan", pageloadSpan);
    return pageloadSpan;
}
function $6bac36247b18b476$export$7d159749bd9969ad(client, spanOptions, options) {
    var _ref = options || {}, url = _ref.url, isRedirect2 = _ref.isRedirect;
    client.emit("beforeStartNavigationSpan", spanOptions, {
        isRedirect: isRedirect2,
        url: url
    });
    client.emit("startNavigationSpan", spanOptions, {
        isRedirect: isRedirect2,
        url: url
    });
    var scope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
    scope.setTransactionName(spanOptions.name);
    if (url && !isRedirect2) scope.setSDKProcessingMetadata({
        normalizedRequest: (0, $lf4fc._)((0, $hwO3w._)({}, (0, $1cd11d0052bf6dc0$export$a3c4a8453e8936f0)()), {
            url: url
        })
    });
    return $6bac36247b18b476$var$getActiveIdleSpan(client);
}
function $6bac36247b18b476$export$f147b32b03c9cf11(metaName) {
    var optionalWindowDocument = (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).document;
    var metaTag = optionalWindowDocument === null || optionalWindowDocument === void 0 ? void 0 : optionalWindowDocument.querySelector("meta[name=".concat(metaName, "]"));
    return (metaTag === null || metaTag === void 0 ? void 0 : metaTag.getAttribute("content")) || void 0;
}
function $6bac36247b18b476$export$5bb9693b37f7c2ae(name) {
    var _WINDOW_performance_getEntriesByType, _WINDOW_performance, _navigation_serverTiming;
    var navigation = (_WINDOW_performance = (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).performance) === null || _WINDOW_performance === void 0 ? void 0 : (_WINDOW_performance_getEntriesByType = _WINDOW_performance.getEntriesByType) === null || _WINDOW_performance_getEntriesByType === void 0 ? void 0 : _WINDOW_performance_getEntriesByType.call(_WINDOW_performance, "navigation")[0];
    var entry = navigation === null || navigation === void 0 ? void 0 : (_navigation_serverTiming = navigation.serverTiming) === null || _navigation_serverTiming === void 0 ? void 0 : _navigation_serverTiming.find(function(entry2) {
        return entry2.name === name;
    });
    return entry === null || entry === void 0 ? void 0 : entry.description;
}
function $6bac36247b18b476$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    var optionalWindowDocument = (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).document;
    var inflightInteractionSpan;
    var registerInteractionTransaction = function() {
        var op = "ui.action.click";
        var activeIdleSpan = $6bac36247b18b476$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            var currentRootSpanOp = (0, $79515206909fddff$export$92d8c23565496537)(activeIdleSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $be1ea91a107a1f2d$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("[Tracing] Did not create ".concat(op, " span because a pageload or navigation span is in progress."));
                return void 0;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $5d82adaea61c8fa9$export$ba73f34502b7a3b3), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = void 0;
        }
        if (!latestRoute.name) {
            (0, $be1ea91a107a1f2d$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("[Tracing] Did not create ".concat(op, " transaction because _latestRouteName is missing."));
            return void 0;
        }
        inflightInteractionSpan = (0, $650373597f8b6576$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$d7a7d984b0791405), latestRoute.source || "url")
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener("click", registerInteractionTransaction, {
        capture: true
    });
}
var $6bac36247b18b476$var$ACTIVE_IDLE_SPAN_PROPERTY = "_sentry_idleSpan";
function $6bac36247b18b476$var$getActiveIdleSpan(client) {
    return client[$6bac36247b18b476$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $6bac36247b18b476$var$setActiveIdleSpan(client, span) {
    (0, $27958f6402fc5d96$export$e73679ffaf56810e)(client, $6bac36247b18b476$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}
var $6bac36247b18b476$var$REDIRECT_THRESHOLD = 1.5;
function $6bac36247b18b476$var$isRedirect(activeSpan, lastInteractionTimestamp) {
    var spanData = (0, $79515206909fddff$export$92d8c23565496537)(activeSpan);
    var now = (0, $7b1d57c4c7d6952d$export$7740643b9eeaf0c4)();
    var startTimestamp = spanData.start_timestamp;
    if (now - startTimestamp > $6bac36247b18b476$var$REDIRECT_THRESHOLD) return false;
    if (lastInteractionTimestamp && now - lastInteractionTimestamp <= $6bac36247b18b476$var$REDIRECT_THRESHOLD) return false;
    return true;
}


var $hwO3w = parcelRequire("hwO3w");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");




var $02a846f0710b4f05$var$INTEGRATION_NAME = "ConversationId";
var $02a846f0710b4f05$var$_conversationIdIntegration = function() {
    return {
        name: $02a846f0710b4f05$var$INTEGRATION_NAME,
        setup: function(client) {
            client.on("spanStart", function(span) {
                var scopeData = (0, $945639585ea57ae0$export$c7be4b0125a10cba)().getScopeData();
                var isolationScopeData = (0, $945639585ea57ae0$export$68f3af03034c9e90)().getScopeData();
                var conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    var _spanToJSON = (0, $79515206909fddff$export$92d8c23565496537)(span), op = _spanToJSON.op, attributes = _spanToJSON.data, name = _spanToJSON.description;
                    if (!(op === null || op === void 0 ? void 0 : op.startsWith("gen_ai.")) && !attributes["ai.operationId"] && !(name === null || name === void 0 ? void 0 : name.startsWith("ai."))) return;
                    span.setAttribute((0, $5d82adaea61c8fa9$export$71a4a707257f2774), conversationId);
                }
            });
        }
    };
};
var $02a846f0710b4f05$export$97457a453081a5b3 = (0, $ae9d79ccde098562$export$2323046b9414659f)($02a846f0710b4f05$var$_conversationIdIntegration);





var $7bd9acb9c2c62d7c$var$INTEGRATION_NAME = "Dedupe";
var $7bd9acb9c2c62d7c$var$_dedupeIntegration = function() {
    var previousEvent;
    return {
        name: $7bd9acb9c2c62d7c$var$INTEGRATION_NAME,
        processEvent: function(currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($7bd9acb9c2c62d7c$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (e) {}
            return previousEvent = currentEvent;
        }
    };
};
var $7bd9acb9c2c62d7c$export$6d39aa44cd0c7567 = (0, $ae9d79ccde098562$export$2323046b9414659f)($7bd9acb9c2c62d7c$var$_dedupeIntegration);
function $7bd9acb9c2c62d7c$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($7bd9acb9c2c62d7c$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($7bd9acb9c2c62d7c$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $7bd9acb9c2c62d7c$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$7bd9acb9c2c62d7c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$7bd9acb9c2c62d7c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $7bd9acb9c2c62d7c$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $7bd9acb9c2c62d7c$var$_getExceptionFromEvent(previousEvent);
    var currentException = $7bd9acb9c2c62d7c$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$7bd9acb9c2c62d7c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$7bd9acb9c2c62d7c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $7bd9acb9c2c62d7c$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = (0, $6fde3090981c9aa7$export$91d8ca51bd9f6a47)(currentEvent);
    var previousFrames = (0, $6fde3090981c9aa7$export$91d8ca51bd9f6a47)(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $7bd9acb9c2c62d7c$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (e) {
        return false;
    }
}
function $7bd9acb9c2c62d7c$var$_getExceptionFromEvent(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}




var $e98db35b10cdc088$var$INTEGRATION_NAME = "FunctionToString";
var $e98db35b10cdc088$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
var $e98db35b10cdc088$var$_functionToStringIntegration = function() {
    return {
        name: $e98db35b10cdc088$var$INTEGRATION_NAME,
        setupOnce: function() {
            var originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var originalFunction = (0, $27958f6402fc5d96$export$e6cc1e135e2092e5)(this);
                    var unwrappedFunction;
                    try {
                        if ($e98db35b10cdc088$var$SETUP_CLIENTS.has((0, $945639585ea57ae0$export$6bb76d6eba7e258c)()) && originalFunction !== void 0) unwrappedFunction = originalFunction;
                    } catch (e) {}
                    return originalFunctionToString.apply(unwrappedFunction !== null && unwrappedFunction !== void 0 ? unwrappedFunction : this, args);
                };
            } catch (e) {}
        },
        setup: function(client) {
            $e98db35b10cdc088$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
var $e98db35b10cdc088$export$7918117e9202e4fb = (0, $ae9d79ccde098562$export$2323046b9414659f)($e98db35b10cdc088$var$_functionToStringIntegration);


var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $XnYkK = parcelRequire("XnYkK");



function $cf969b243c6ca6e1$export$d55a97c329cacfcc(event) {
    var possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        var lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException === null || lastException === void 0 ? void 0 : lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push("".concat(lastException.type, ": ").concat(lastException.value));
        }
    } catch (e) {}
    return possibleMessages;
}




var $5494988c597a6bde$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /^Java exception was raised during method invocation$/
];
var $5494988c597a6bde$var$INTEGRATION_NAME = "EventFilters";
var $5494988c597a6bde$export$9a84f518c163c552 = (0, $ae9d79ccde098562$export$2323046b9414659f)(function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var mergedOptions;
    return {
        name: $5494988c597a6bde$var$INTEGRATION_NAME,
        setup: function(client) {
            var clientOptions = client.getOptions();
            mergedOptions = $5494988c597a6bde$var$_mergeOptions(options, clientOptions);
        },
        processEvent: function(event, _hint, client) {
            if (!mergedOptions) {
                var clientOptions = client.getOptions();
                mergedOptions = $5494988c597a6bde$var$_mergeOptions(options, clientOptions);
            }
            return $5494988c597a6bde$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
var $5494988c597a6bde$export$cb3c5c2ceb9818ba = (0, $ae9d79ccde098562$export$2323046b9414659f)(function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, $lf4fc._)((0, $hwO3w._)({}, $5494988c597a6bde$export$9a84f518c163c552(options)), {
        name: "InboundFilters"
    });
});
function $5494988c597a6bde$var$_mergeOptions() {
    var internalOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, clientOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        allowUrls: (0, $XnYkK._)(internalOptions.allowUrls || []).concat((0, $XnYkK._)(clientOptions.allowUrls || [])),
        denyUrls: (0, $XnYkK._)(internalOptions.denyUrls || []).concat((0, $XnYkK._)(clientOptions.denyUrls || [])),
        ignoreErrors: (0, $XnYkK._)(internalOptions.ignoreErrors || []).concat((0, $XnYkK._)(clientOptions.ignoreErrors || []), (0, $XnYkK._)(internalOptions.disableErrorDefaults ? [] : $5494988c597a6bde$var$DEFAULT_IGNORE_ERRORS)),
        ignoreTransactions: (0, $XnYkK._)(internalOptions.ignoreTransactions || []).concat((0, $XnYkK._)(clientOptions.ignoreTransactions || []))
    };
}
function $5494988c597a6bde$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($5494988c597a6bde$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: ".concat((0, $30748c2972c04cd5$export$4157119e2b157127)(event)));
            return true;
        }
        if ($5494988c597a6bde$var$_isUselessError(event)) {
            (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Event dropped due to not having an error message, error type or stacktrace.\nEvent: ".concat((0, $30748c2972c04cd5$export$4157119e2b157127)(event)));
            return true;
        }
        if ($5494988c597a6bde$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: ".concat((0, $30748c2972c04cd5$export$4157119e2b157127)(event), ".\nUrl: ").concat($5494988c597a6bde$var$_getEventFilterUrl(event)));
            return true;
        }
        if (!$5494988c597a6bde$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: ".concat((0, $30748c2972c04cd5$export$4157119e2b157127)(event), ".\nUrl: ").concat($5494988c597a6bde$var$_getEventFilterUrl(event)));
            return true;
        }
    } else if (event.type === "transaction") {
        if ($5494988c597a6bde$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Event dropped due to being matched by `ignoreTransactions` option.\nEvent: ".concat((0, $30748c2972c04cd5$export$4157119e2b157127)(event)));
            return true;
        }
    }
    return false;
}
function $5494988c597a6bde$var$_isIgnoredError(event, ignoreErrors) {
    if (!(ignoreErrors === null || ignoreErrors === void 0 ? void 0 : ignoreErrors.length)) return false;
    return (0, $cf969b243c6ca6e1$export$d55a97c329cacfcc)(event).some(function(message) {
        return (0, $45aea333cf5bef5d$export$a7a5ec66062ea5d)(message, ignoreErrors);
    });
}
function $5494988c597a6bde$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!(ignoreTransactions === null || ignoreTransactions === void 0 ? void 0 : ignoreTransactions.length)) return false;
    var name = event.transaction;
    return name ? (0, $45aea333cf5bef5d$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $5494988c597a6bde$var$_isDeniedUrl(event, denyUrls) {
    if (!(denyUrls === null || denyUrls === void 0 ? void 0 : denyUrls.length)) return false;
    var url = $5494988c597a6bde$var$_getEventFilterUrl(event);
    return !url ? false : (0, $45aea333cf5bef5d$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $5494988c597a6bde$var$_isAllowedUrl(event, allowUrls) {
    if (!(allowUrls === null || allowUrls === void 0 ? void 0 : allowUrls.length)) return true;
    var url = $5494988c597a6bde$var$_getEventFilterUrl(event);
    return !url ? true : (0, $45aea333cf5bef5d$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $5494988c597a6bde$var$_getLastValidUrl() {
    var frames = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $5494988c597a6bde$var$_getEventFilterUrl(event) {
    try {
        var _event_exception, _rootException_stacktrace;
        var _event_exception_values;
        var rootException = (0, $XnYkK._)((_event_exception_values = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) !== null && _event_exception_values !== void 0 ? _event_exception_values : []).reverse().find(function(value) {
            var _value_mechanism, _value_stacktrace_frames, _value_stacktrace;
            return ((_value_mechanism = value.mechanism) === null || _value_mechanism === void 0 ? void 0 : _value_mechanism.parent_id) === void 0 && ((_value_stacktrace = value.stacktrace) === null || _value_stacktrace === void 0 ? void 0 : (_value_stacktrace_frames = _value_stacktrace.frames) === null || _value_stacktrace_frames === void 0 ? void 0 : _value_stacktrace_frames.length);
        });
        var frames = rootException === null || rootException === void 0 ? void 0 : (_rootException_stacktrace = rootException.stacktrace) === null || _rootException_stacktrace === void 0 ? void 0 : _rootException_stacktrace.frames;
        return frames ? $5494988c597a6bde$var$_getLastValidUrl(frames) : null;
    } catch (e) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).error("Cannot extract url for event ".concat((0, $30748c2972c04cd5$export$4157119e2b157127)(event)));
        return null;
    }
}
function $5494988c597a6bde$var$_isUselessError(event) {
    var _event_exception_values, _event_exception;
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.length)) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some(function(value) {
        return value.stacktrace || value.type && value.type !== "Error" || value.value;
    }));
}




function $8176758402f871e0$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $63491170aaadd711$export$16a28057038b10ef) (0, $739716ea0436a6d0$export$1c9f709888824e05).enable();
        else (0, $739716ea0436a6d0$export$cda52e2a8927a2ca)(function() {
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    var scope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    var client = new clientClass(options);
    $8176758402f871e0$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
function $8176758402f871e0$export$ecb76f41d43c0e43(client) {
    (0, $945639585ea57ae0$export$c7be4b0125a10cba)().setClient(client);
}



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $h50jA = parcelRequire("h50jA");
function $00289c2a21896b8c$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $h50jA._)(object);
        if (object === null) break;
    }
    return object;
}


function $fecd75458a076b3b$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $fecd75458a076b3b$export$71511d61b312f219 = Reflect.get;
    else $fecd75458a076b3b$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $00289c2a21896b8c$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $fecd75458a076b3b$export$71511d61b312f219(target, property, receiver || target);
}



var $h50jA = parcelRequire("h50jA");

var $4QAx6 = parcelRequire("4QAx6");

var $hwO3w = parcelRequire("hwO3w");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");
function $60d886ea8059ef98$export$3e12ad68afa434ac(objWithMaybeUser) {
    var _objWithMaybeUser_user;
    if (((_objWithMaybeUser_user = objWithMaybeUser.user) === null || _objWithMaybeUser_user === void 0 ? void 0 : _objWithMaybeUser_user.ip_address) === void 0) objWithMaybeUser.user = (0, $lf4fc._)((0, $hwO3w._)({}, objWithMaybeUser.user), {
        ip_address: "{{auto}}"
    });
}
function $60d886ea8059ef98$export$e8e2d07ba63e2b6c(session) {
    var _session_attrs;
    if ("aggregates" in session) {
        if (((_session_attrs = session.attrs) === null || _session_attrs === void 0 ? void 0 : _session_attrs["ip_address"]) === void 0) session.attrs = (0, $lf4fc._)((0, $hwO3w._)({}, session.attrs), {
            ip_address: "{{auto}}"
        });
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}


function $bd839e84f4db6244$export$b9f95b027256052c(options, name) {
    var names = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
        name
    ], source = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "npm";
    var sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = "sentry.javascript.".concat(name);
        sdk.packages = names.map(function(name2) {
            return {
                name: "".concat(source, ":@sentry/").concat(name2),
                version: (0, $b57ae22d2a5daa67$export$31499a9cd224b78c)
            };
        });
        sdk.version = (0, $b57ae22d2a5daa67$export$31499a9cd224b78c);
    }
}


var $lFIaz = parcelRequire("lFIaz");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");

var $3SMYb = parcelRequire("3SMYb");

var $ca252a259fcf64ec$export$9207631ea4ce5c48 = "7";
function $ca252a259fcf64ec$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? "".concat(dsn.protocol, ":") : "";
    var port = dsn.port ? ":".concat(dsn.port) : "";
    return "".concat(protocol, "//").concat(dsn.host).concat(port).concat(dsn.path ? "/".concat(dsn.path) : "", "/api/");
}
function $ca252a259fcf64ec$var$_getIngestEndpoint(dsn) {
    return "".concat($ca252a259fcf64ec$var$getBaseApiEndpoint(dsn)).concat(dsn.projectId, "/envelope/");
}
function $ca252a259fcf64ec$var$_encodedAuth(dsn, sdkInfo) {
    var params = {
        sentry_version: $ca252a259fcf64ec$export$9207631ea4ce5c48
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = "".concat(sdkInfo.name, "/").concat(sdkInfo.version);
    return new URLSearchParams(params).toString();
}
function $ca252a259fcf64ec$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : "".concat($ca252a259fcf64ec$var$_getIngestEndpoint(dsn), "?").concat($ca252a259fcf64ec$var$_encodedAuth(dsn, sdkInfo));
}
function $ca252a259fcf64ec$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $a77c6f8fcbd294ab$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    var endpoint = "".concat($ca252a259fcf64ec$var$getBaseApiEndpoint(dsn), "embed/error-page/");
    var encodedOptions = "dsn=".concat((0, $a77c6f8fcbd294ab$export$44d472fbb931a776)(dsn));
    for(var key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            var user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += "&name=".concat(encodeURIComponent(user.name));
            if (user.email) encodedOptions += "&email=".concat(encodeURIComponent(user.email));
        } else encodedOptions += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(dialogOptions[key]));
    }
    return "".concat(endpoint, "?").concat(encodedOptions);
}








var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");









var $e6b4cee7bf221bb9$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
var $e6b4cee7bf221bb9$var$_sequenceNumber = 0;
var $e6b4cee7bf221bb9$var$_previousTimestampMs;
function $e6b4cee7bf221bb9$export$63ada7b125d23ef9(timestampInSeconds) {
    var nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($e6b4cee7bf221bb9$var$_previousTimestampMs !== void 0 && nowMs !== $e6b4cee7bf221bb9$var$_previousTimestampMs) $e6b4cee7bf221bb9$var$_sequenceNumber = 0;
    var value = $e6b4cee7bf221bb9$var$_sequenceNumber;
    $e6b4cee7bf221bb9$var$_sequenceNumber++;
    $e6b4cee7bf221bb9$var$_previousTimestampMs = nowMs;
    return {
        key: $e6b4cee7bf221bb9$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}





function $f8d222a1d419b3a6$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return (0, $945639585ea57ae0$export$ec58d9285c204497)(scope, function() {
        var span = (0, $79515206909fddff$export$1be426a8e585c83e)();
        var traceContext = span ? (0, $79515206909fddff$export$46c6fbd1d265ebf0)(span) : (0, $945639585ea57ae0$export$1e83db7ee4876dc4)(scope);
        var dynamicSamplingContext = span ? (0, $0d1fd6101086a96b$export$a117f995597e25df)(span) : (0, $0d1fd6101086a96b$export$89ef1736f08c6b2b)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}


var $3f79a9aca5373a98$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");



function $870720c9e2b3a594$export$efdf3b13edb1118e(items, inferUserData) {
    var inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        (0, $lf4fc._)((0, $hwO3w._)({
            version: 2
        }, (0, $0cb6d550a0b1aae5$export$4e09c449d6c407f7)() && {
            ingest_settings: {
                infer_ip: inferSetting,
                infer_user_agent: inferSetting
            }
        }), {
            items: items
        })
    ];
}
function $870720c9e2b3a594$export$cdcd668e6516443f(logs, metadata, tunnel, dsn, inferUserData) {
    var headers = {};
    if (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $a77c6f8fcbd294ab$export$44d472fbb931a776)(dsn);
    return (0, $c4622bb7cd663145$export$f93f7f385160c44e)(headers, [
        $870720c9e2b3a594$export$efdf3b13edb1118e(logs, inferUserData)
    ]);
}


var $7a13542258bb275f$var$MAX_LOG_BUFFER_SIZE = 100;
function $7a13542258bb275f$var$setLogAttribute(logAttributes, key, value) {
    var setEvenIfPresent = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $7a13542258bb275f$export$743ba6f7ec19225f(client, serializedLog) {
    var bufferMap = $7a13542258bb275f$var$_getBufferMap();
    var logBuffer = $7a13542258bb275f$export$5365c9902fb9e770(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $7a13542258bb275f$var$MAX_LOG_BUFFER_SIZE) {
        $7a13542258bb275f$export$f8ed83d3b6a0b504(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, (0, $XnYkK._)(logBuffer).concat([
        serializedLog
    ]));
}
function $7a13542258bb275f$export$3ab3d16b9eebd986(beforeLog) {
    var currentScope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $945639585ea57ae0$export$c7be4b0125a10cba)(), captureSerializedLog = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $7a13542258bb275f$export$743ba6f7ec19225f;
    var _client_getSdkMetadata;
    var _currentScope_getClient;
    var client = (_currentScope_getClient = currentScope === null || currentScope === void 0 ? void 0 : currentScope.getClient()) !== null && _currentScope_getClient !== void 0 ? _currentScope_getClient : (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("No client available to capture log.");
        return;
    }
    var _client_getOptions = client.getOptions(), release = _client_getOptions.release, environment = _client_getOptions.environment, _client_getOptions_enableLogs = _client_getOptions.enableLogs, enableLogs = _client_getOptions_enableLogs === void 0 ? false : _client_getOptions_enableLogs, beforeSendLog = _client_getOptions.beforeSendLog;
    if (!enableLogs) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("logging option not enabled, log will not be captured.");
        return;
    }
    var _$_getTraceInfoFromScope = (0, $6iP9u._)((0, $f8d222a1d419b3a6$export$fb7d833b3fdedf5f)(client, currentScope), 2), traceContext = _$_getTraceInfoFromScope[1];
    var processedLogAttributes = (0, $hwO3w._)({}, beforeLog.attributes);
    var _getCombinedScopeData = (0, $511829945c640daa$export$cc422922fcbb91c6)((0, $945639585ea57ae0$export$68f3af03034c9e90)(), currentScope), _getCombinedScopeData_user = _getCombinedScopeData.user, id = _getCombinedScopeData_user.id, email = _getCombinedScopeData_user.email, username = _getCombinedScopeData_user.username, tmp = _getCombinedScopeData.attributes, scopeAttributes = tmp === void 0 ? {} : tmp;
    $7a13542258bb275f$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $7a13542258bb275f$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $7a13542258bb275f$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $7a13542258bb275f$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $7a13542258bb275f$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    var _client_getSdkMetadata_sdk;
    var _ref = (_client_getSdkMetadata_sdk = (_client_getSdkMetadata = client.getSdkMetadata()) === null || _client_getSdkMetadata === void 0 ? void 0 : _client_getSdkMetadata.sdk) !== null && _client_getSdkMetadata_sdk !== void 0 ? _client_getSdkMetadata_sdk : {}, name = _ref.name, version = _ref.version;
    $7a13542258bb275f$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $7a13542258bb275f$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    var replay = client.getIntegrationByName("Replay");
    var replayId = replay === null || replay === void 0 ? void 0 : replay.getReplayId(true);
    $7a13542258bb275f$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && (replay === null || replay === void 0 ? void 0 : replay.getRecordingMode()) === "buffer") $7a13542258bb275f$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    var beforeLogMessage = beforeLog.message;
    if ((0, $6ea82c15e37d9720$export$dbcbffa59149b824)(beforeLogMessage)) {
        var __sentry_template_string__ = beforeLogMessage.__sentry_template_string__, _beforeLogMessage___sentry_template_values__ = beforeLogMessage.__sentry_template_values__, __sentry_template_values__ = _beforeLogMessage___sentry_template_values__ === void 0 ? [] : _beforeLogMessage___sentry_template_values__;
        if (__sentry_template_values__ === null || __sentry_template_values__ === void 0 ? void 0 : __sentry_template_values__.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach(function(param, index) {
            processedLogAttributes["sentry.message.parameter.".concat(index)] = param;
        });
    }
    var span = (0, $6102d52d892cc90c$export$91f063ebb8eff307)(currentScope);
    $7a13542258bb275f$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span === null || span === void 0 ? void 0 : span.spanContext().spanId);
    var processedLog = (0, $lf4fc._)((0, $hwO3w._)({}, beforeLog), {
        attributes: processedLogAttributes
    });
    client.emit("beforeCaptureLog", processedLog);
    var log = beforeSendLog ? (0, $739716ea0436a6d0$export$cda52e2a8927a2ca)(function() {
        return beforeSendLog(processedLog);
    }) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    var level = log.level, message = log.message, tmp1 = log.attributes, logAttributes = tmp1 === void 0 ? {} : tmp1, severityNumber = log.severityNumber;
    var timestamp = (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
    var sequenceAttr = (0, $e6b4cee7bf221bb9$export$63ada7b125d23ef9)(timestamp);
    var serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $7a13542258bb275f$export$b879a166f5ac57c8(String(message)),
        trace_id: traceContext === null || traceContext === void 0 ? void 0 : traceContext.trace_id,
        severity_number: severityNumber !== null && severityNumber !== void 0 ? severityNumber : (0, $3f79a9aca5373a98$export$4fb50c0840d636d1)[level],
        attributes: $7a13542258bb275f$var$sanitizeLogAttributes((0, $lf4fc._)((0, $hwO3w._)({}, (0, $fa3ae50862f28851$export$4954cae66e755861)(scopeAttributes), (0, $fa3ae50862f28851$export$4954cae66e755861)(logAttributes, true)), (0, $dUlz9._)({}, sequenceAttr.key, sequenceAttr.value)))
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $7a13542258bb275f$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    var _ref;
    var logBuffer = (_ref = maybeLogBuffer !== null && maybeLogBuffer !== void 0 ? maybeLogBuffer : $7a13542258bb275f$export$5365c9902fb9e770(client)) !== null && _ref !== void 0 ? _ref : [];
    if (logBuffer.length === 0) return;
    var clientOptions = client.getOptions();
    var envelope = (0, $870720c9e2b3a594$export$cdcd668e6516443f)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $7a13542258bb275f$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope);
}
function $7a13542258bb275f$export$5365c9902fb9e770(client) {
    return $7a13542258bb275f$var$_getBufferMap().get(client);
}
function $7a13542258bb275f$var$_getBufferMap() {
    return (0, $8a2f538a13cfc001$export$7e223ec222791509)("clientToLogBufferMap", function() {
        return /* @__PURE__ */ new WeakMap();
    });
}
function $7a13542258bb275f$var$sanitizeLogAttributes(attributes) {
    var sanitized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6iP9u._)(_step.value, 2), key = _step_value[0], attr = _step_value[1];
            var sanitizedKey = $7a13542258bb275f$export$b879a166f5ac57c8(key);
            if (attr.type === "string") sanitized[sanitizedKey] = (0, $lf4fc._)((0, $hwO3w._)({}, attr), {
                value: $7a13542258bb275f$export$b879a166f5ac57c8(attr.value)
            });
            else sanitized[sanitizedKey] = attr;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return sanitized;
}
function $7a13542258bb275f$export$b879a166f5ac57c8(str) {
    var strObj = Object(str);
    var isWellFormed = strObj["isWellFormed"];
    var toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}



var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");











var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");



function $76d6bf7d8bf1e90c$export$58e45eb52ad1077d(items, inferUserData) {
    var inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        (0, $lf4fc._)((0, $hwO3w._)({
            version: 2
        }, (0, $0cb6d550a0b1aae5$export$4e09c449d6c407f7)() && {
            ingest_settings: {
                infer_ip: inferSetting,
                infer_user_agent: inferSetting
            }
        }), {
            items: items
        })
    ];
}
function $76d6bf7d8bf1e90c$export$f23eb96e33154901(metrics, metadata, tunnel, dsn, inferUserData) {
    var headers = {};
    if (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $a77c6f8fcbd294ab$export$44d472fbb931a776)(dsn);
    return (0, $c4622bb7cd663145$export$f93f7f385160c44e)(headers, [
        $76d6bf7d8bf1e90c$export$58e45eb52ad1077d(metrics, inferUserData)
    ]);
}


var $5758034008aaa72c$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $5758034008aaa72c$var$setMetricAttribute(metricAttributes, key, value) {
    var setEvenIfPresent = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $5758034008aaa72c$export$84661fd26e6cac96(client, serializedMetric) {
    var bufferMap = $5758034008aaa72c$var$_getBufferMap();
    var metricBuffer = $5758034008aaa72c$export$49385134251b08ff(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $5758034008aaa72c$var$MAX_METRIC_BUFFER_SIZE) {
        $5758034008aaa72c$export$91c9ef254b7d0f67(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, (0, $XnYkK._)(metricBuffer).concat([
        serializedMetric
    ]));
}
function $5758034008aaa72c$var$_enrichMetricAttributes(beforeMetric, client, user) {
    var _client_getSdkMetadata;
    var _client_getOptions = client.getOptions(), release = _client_getOptions.release, environment = _client_getOptions.environment;
    var processedMetricAttributes = (0, $hwO3w._)({}, beforeMetric.attributes);
    $5758034008aaa72c$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $5758034008aaa72c$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $5758034008aaa72c$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $5758034008aaa72c$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $5758034008aaa72c$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    var _client_getSdkMetadata_sdk;
    var _ref = (_client_getSdkMetadata_sdk = (_client_getSdkMetadata = client.getSdkMetadata()) === null || _client_getSdkMetadata === void 0 ? void 0 : _client_getSdkMetadata.sdk) !== null && _client_getSdkMetadata_sdk !== void 0 ? _client_getSdkMetadata_sdk : {}, name = _ref.name, version = _ref.version;
    $5758034008aaa72c$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $5758034008aaa72c$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    var replay = client.getIntegrationByName("Replay");
    var replayId = replay === null || replay === void 0 ? void 0 : replay.getReplayId(true);
    $5758034008aaa72c$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && (replay === null || replay === void 0 ? void 0 : replay.getRecordingMode()) === "buffer") $5758034008aaa72c$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return (0, $lf4fc._)((0, $hwO3w._)({}, beforeMetric), {
        attributes: processedMetricAttributes
    });
}
function $5758034008aaa72c$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    var _$_getTraceInfoFromScope = (0, $6iP9u._)((0, $f8d222a1d419b3a6$export$fb7d833b3fdedf5f)(client, currentScope), 2), traceContext = _$_getTraceInfoFromScope[1];
    var span = (0, $6102d52d892cc90c$export$91f063ebb8eff307)(currentScope);
    var traceId = span ? span.spanContext().traceId : traceContext === null || traceContext === void 0 ? void 0 : traceContext.trace_id;
    var spanId = span ? span.spanContext().spanId : void 0;
    var timestamp = (0, $7b1d57c4c7d6952d$export$ee52dced521e3e18)();
    var sequenceAttr = (0, $e6b4cee7bf221bb9$export$63ada7b125d23ef9)(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId !== null && traceId !== void 0 ? traceId : "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: (0, $lf4fc._)((0, $hwO3w._)({}, (0, $fa3ae50862f28851$export$4954cae66e755861)(scopeAttributes), (0, $fa3ae50862f28851$export$4954cae66e755861)(metric.attributes, "skip-undefined")), (0, $dUlz9._)({}, sequenceAttr.key, sequenceAttr.value))
    };
}
function $5758034008aaa72c$export$288d896e6652e0c4(beforeMetric, options) {
    var _options_scope;
    var currentScope = (_options_scope = options === null || options === void 0 ? void 0 : options.scope) !== null && _options_scope !== void 0 ? _options_scope : (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
    var _options_captureSerializedMetric;
    var captureSerializedMetric = (_options_captureSerializedMetric = options === null || options === void 0 ? void 0 : options.captureSerializedMetric) !== null && _options_captureSerializedMetric !== void 0 ? _options_captureSerializedMetric : $5758034008aaa72c$export$84661fd26e6cac96;
    var _currentScope_getClient;
    var client = (_currentScope_getClient = currentScope === null || currentScope === void 0 ? void 0 : currentScope.getClient()) !== null && _currentScope_getClient !== void 0 ? _currentScope_getClient : (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("No client available to capture metric.");
        return;
    }
    var _client_getOptions = client.getOptions(), _experiments = _client_getOptions._experiments, enableMetrics = _client_getOptions.enableMetrics, beforeSendMetric = _client_getOptions.beforeSendMetric;
    var _ref;
    var metricsEnabled = (_ref = enableMetrics !== null && enableMetrics !== void 0 ? enableMetrics : _experiments === null || _experiments === void 0 ? void 0 : _experiments.enableMetrics) !== null && _ref !== void 0 ? _ref : true;
    if (!metricsEnabled) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    var _getCombinedScopeData = (0, $511829945c640daa$export$cc422922fcbb91c6)((0, $945639585ea57ae0$export$68f3af03034c9e90)(), currentScope), user = _getCombinedScopeData.user, scopeAttributes = _getCombinedScopeData.attributes;
    var enrichedMetric = $5758034008aaa72c$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    var beforeSendCallback = beforeSendMetric || (_experiments === null || _experiments === void 0 ? void 0 : _experiments.beforeSendMetric);
    var processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    var serializedMetric = $5758034008aaa72c$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $5758034008aaa72c$export$91c9ef254b7d0f67(client, maybeMetricBuffer) {
    var _ref;
    var metricBuffer = (_ref = maybeMetricBuffer !== null && maybeMetricBuffer !== void 0 ? maybeMetricBuffer : $5758034008aaa72c$export$49385134251b08ff(client)) !== null && _ref !== void 0 ? _ref : [];
    if (metricBuffer.length === 0) return;
    var clientOptions = client.getOptions();
    var envelope = (0, $76d6bf7d8bf1e90c$export$f23eb96e33154901)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $5758034008aaa72c$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope);
}
function $5758034008aaa72c$export$49385134251b08ff(client) {
    return $5758034008aaa72c$var$_getBufferMap().get(client);
}
function $5758034008aaa72c$var$_getBufferMap() {
    return (0, $8a2f538a13cfc001$export$7e223ec222791509)("clientToMetricBufferMap", function() {
        return /* @__PURE__ */ new WeakMap();
    });
}






var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");



var $hwO3w = parcelRequire("hwO3w");

function $cc8ed0bbcc0ad35f$export$f6f6d4b2a7942521(span) {
    var streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: (0, $hwO3w._)({}, span.data),
        links: span.links
    };
    return (0, $79515206909fddff$export$5402aa553bcf35f3)(streamedSpan);
}


function $a59c7e537104d534$export$9aeb9a2b899f8587(event, client) {
    var _event_spans, _event_sdkProcessingMetadata, _span_op;
    if (event.type !== "transaction" || !((_event_spans = event.spans) === null || _event_spans === void 0 ? void 0 : _event_spans.length) || !((_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.hasGenAiSpans) || client.getOptions().streamGenAiSpans === false || (0, $a0e1c0749ad8282c$export$6ea47215d699c04a)(client)) return void 0;
    var genAiSpans = [];
    var remainingSpans = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = event.spans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var span = _step.value;
            if ((_span_op = span.op) === null || _span_op === void 0 ? void 0 : _span_op.startsWith("gen_ai.")) genAiSpans.push((0, $cc8ed0bbcc0ad35f$export$f6f6d4b2a7942521)(span));
            else remainingSpans.push(span);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    var inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        (0, $lf4fc._)((0, $hwO3w._)({
            version: 2
        }, (0, $0cb6d550a0b1aae5$export$4e09c449d6c407f7)() && {
            ingest_settings: {
                infer_ip: inferSetting,
                infer_user_agent: inferSetting
            }
        }), {
            items: genAiSpans
        })
    ];
}







var $03bAP = parcelRequire("03bAP");
function $cc7b10bd752b6597$export$630056cb83d87863(timer) {
    if ((typeof timer === "undefined" ? "undefined" : (0, $03bAP._)(timer)) === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}


var $4dd019c4733e4c95$export$c8667f1887a128dc = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $4dd019c4733e4c95$export$85a4f67f852183e6() {
    var limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100;
    var buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return (0, $6fb471c4cc1a8a7b$export$78e43115b553f358)($4dd019c4733e4c95$export$c8667f1887a128dc);
        var task = taskProducer();
        buffer.add(task);
        task.then(function() {
            return remove(task);
        }, function() {
            return remove(task);
        });
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return (0, $6fb471c4cc1a8a7b$export$1fda8aa4d135f8aa)(true);
        var drainPromise = Promise.allSettled(Array.from(buffer)).then(function() {
            return true;
        });
        if (!timeout) return drainPromise;
        var promises = [
            drainPromise,
            new Promise(function(resolve) {
                return (0, $cc7b10bd752b6597$export$630056cb83d87863)(setTimeout(function() {
                    return resolve(false);
                }, timeout));
            })
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}



var $hwO3w = parcelRequire("hwO3w");

var $6iP9u = parcelRequire("6iP9u");

var $588c736ad3eef53a$export$b09ce39faaeb1e7c = 60000;
function $588c736ad3eef53a$export$615352e17ed7741(header) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $dd2c5f85fcbd9c64$export$65b1bada40c91b34)();
    var headerDelay = parseInt("".concat(header), 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    var headerDate = Date.parse("".concat(header));
    if (!isNaN(headerDate)) return headerDate - now;
    return $588c736ad3eef53a$export$b09ce39faaeb1e7c;
}
function $588c736ad3eef53a$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $588c736ad3eef53a$export$6c91fec22056810a(limits, dataCategory) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $dd2c5f85fcbd9c64$export$65b1bada40c91b34)();
    return $588c736ad3eef53a$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
function $588c736ad3eef53a$export$699aff705e0d49d4(limits, param) {
    var statusCode = param.statusCode, headers = param.headers, now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $dd2c5f85fcbd9c64$export$65b1bada40c91b34)();
    var updatedRateLimits = (0, $hwO3w._)({}, limits);
    var rateLimitHeader = headers === null || headers === void 0 ? void 0 : headers["x-sentry-rate-limits"];
    var retryAfterHeader = headers === null || headers === void 0 ? void 0 : headers["retry-after"];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (rateLimitHeader) try {
        for(var _iterator = rateLimitHeader.trim().split(",")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var limit = _step.value;
            var _limit_split = (0, $6iP9u._)(limit.split(":", 5), 5), retryAfter = _limit_split[0], categories = _limit_split[1], namespaces = _limit_split[4];
            var headerDelay = parseInt(retryAfter, 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (!categories) updatedRateLimits.all = now + delay;
            else try {
                for(var _iterator1 = categories.split(";")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var category = _step1.value;
                    if (category === "metric_bucket") {
                        if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
                    } else updatedRateLimits[category] = now + delay;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $588c736ad3eef53a$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


var $be3155eb10c5dfe8$export$e515cf6dfd2f98b8 = 64;
function $be3155eb10c5dfe8$export$d09f50d9ab7f7b69(options, makeRequest) {
    var buffer = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $4dd019c4733e4c95$export$85a4f67f852183e6)(options.bufferSize || $be3155eb10c5dfe8$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var filteredEnvelopeItems = [];
        (0, $c4622bb7cd663145$export$c56c55acf0136fd3)(envelope, function(item, type) {
            var dataCategory = (0, $c4622bb7cd663145$export$b11169581eeaf237)(type);
            if ((0, $588c736ad3eef53a$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        var filteredEnvelope = (0, $c4622bb7cd663145$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        var recordEnvelopeLoss = function(reason) {
            if ((0, $c4622bb7cd663145$export$604a45d95a155e2b)(filteredEnvelope, [
                "client_report"
            ])) {
                (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Dropping client report. Will not send outcomes (reason: ".concat(reason, ")."));
                return;
            }
            (0, $c4622bb7cd663145$export$c56c55acf0136fd3)(filteredEnvelope, function(item, type) {
                options.recordDroppedEvent(reason, (0, $c4622bb7cd663145$export$b11169581eeaf237)(type));
            });
        };
        var requestTask = function() {
            return makeRequest({
                body: (0, $c4622bb7cd663145$export$32f9b428425aac85)(filteredEnvelope)
            }).then(function(response) {
                if (response.statusCode === 413) {
                    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ((0, $63491170aaadd711$export$16a28057038b10ef) && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Sentry responded with status code ".concat(response.statusCode, " to sent event."));
                rateLimits = (0, $588c736ad3eef53a$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, function(error) {
                recordEnvelopeLoss("network_error");
                (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).error("Encountered error running transport request:", error);
                throw error;
            });
        };
        return buffer.add(requestTask).then(function(result) {
            return result;
        }, function(error) {
            if (error === (0, $4dd019c4733e4c95$export$c8667f1887a128dc)) {
                (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}




function $fdd2e5c4fbd90dd8$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $7b1d57c4c7d6952d$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $c4622bb7cd663145$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

















var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

function $620ebc0d2c4c02e8$export$d9c6b2464b0a687e(event) {
    var _event_contexts;
    var _event_contexts_trace;
    var _ref = (_event_contexts_trace = (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) !== null && _event_contexts_trace !== void 0 ? _event_contexts_trace : {}, trace_id = _ref.trace_id, parent_span_id = _ref.parent_span_id, span_id = _ref.span_id, status = _ref.status, origin = _ref.origin, data = _ref.data, op = _ref.op;
    var _event_start_timestamp;
    return {
        data: data !== null && data !== void 0 ? data : {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id !== null && span_id !== void 0 ? span_id : "",
        start_timestamp: (_event_start_timestamp = event.start_timestamp) !== null && _event_start_timestamp !== void 0 ? _event_start_timestamp : 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id !== null && trace_id !== void 0 ? trace_id : "",
        origin: origin,
        profile_id: data === null || data === void 0 ? void 0 : data[0, $5d82adaea61c8fa9$export$1efec95406bbe327],
        exclusive_time: data === null || data === void 0 ? void 0 : data[0, $5d82adaea61c8fa9$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
function $620ebc0d2c4c02e8$export$f2d8fce5ae150e92(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: (0, $hwO3w._)({}, span.data, span.profile_id && (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$1efec95406bbe327), span.profile_id), span.exclusive_time && (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$fea48ba9f4550879), span.exclusive_time))
            }
        },
        measurements: span.measurements
    };
}


var $e40fd9998c841c3b$export$59adc876c1ebd512 = "[Filtered]";
var $e40fd9998c841c3b$export$8d9b1945e94c47d = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
var $e40fd9998c841c3b$export$cdee6254fbd57505 = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
var $e40fd9998c841c3b$export$6f34743829a9a6fb = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];


function $bb8f2ed9aaa50e6b$export$8d055982fdc6ee04(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        urlQueryParams: true,
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: true,
            outputs: true
        },
        databaseQueryData: true,
        stackFrameVariables: true,
        frameContextLines: 7
    } : {
        userInfo: false,
        cookies: {
            deny: (0, $e40fd9998c841c3b$export$8d9b1945e94c47d)
        },
        httpHeaders: {
            request: {
                deny: (0, $e40fd9998c841c3b$export$8d9b1945e94c47d)
            },
            response: {
                deny: (0, $e40fd9998c841c3b$export$8d9b1945e94c47d)
            }
        },
        httpBodies: [],
        urlQueryParams: {
            deny: (0, $e40fd9998c841c3b$export$8d9b1945e94c47d)
        },
        // The GraphQL document has literal values redacted at collection time, so it was historically
        // always attached regardless of `sendDefaultPii`; keep it on to preserve that behavior.
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        // Database query values were only sent with `sendDefaultPii: true` (e.g. Supabase gated on it),
        // so map the legacy "off" state to `false`.
        databaseQueryData: false,
        stackFrameVariables: true,
        frameContextLines: 7
    };
}


var $327b4b3a2fe46570$var$DEFAULTS = {
    userInfo: true,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [
        "incomingRequest",
        "outgoingRequest",
        "incomingResponse",
        "outgoingResponse"
    ],
    urlQueryParams: true,
    graphQL: {
        document: true,
        variables: true
    },
    genAI: {
        inputs: true,
        outputs: true
    },
    databaseQueryData: true,
    stackFrameVariables: true,
    frameContextLines: 5
};
function $327b4b3a2fe46570$export$e0e409941f20a4c(options) {
    var _dc_httpHeaders, _dc_httpHeaders1, _dc_graphQL, _dc_graphQL1, _dc_genAI, _dc_genAI1;
    var base = options.dataCollection != null ? $327b4b3a2fe46570$var$DEFAULTS : (0, $bb8f2ed9aaa50e6b$export$8d055982fdc6ee04)(options.sendDefaultPii);
    var _options_dataCollection;
    var dc = (_options_dataCollection = options.dataCollection) !== null && _options_dataCollection !== void 0 ? _options_dataCollection : {};
    var _dc_userInfo, _dc_cookies, _dc_httpHeaders_request, _dc_httpHeaders_response, _dc_httpBodies, _dc_urlQueryParams, _ref, _dc_graphQL_document, _dc_graphQL_variables, _dc_genAI_inputs, _dc_genAI_outputs, _dc_databaseQueryData, _dc_stackFrameVariables, _dc_frameContextLines;
    return {
        userInfo: (_dc_userInfo = dc.userInfo) !== null && _dc_userInfo !== void 0 ? _dc_userInfo : base.userInfo,
        cookies: (_dc_cookies = dc.cookies) !== null && _dc_cookies !== void 0 ? _dc_cookies : base.cookies,
        httpHeaders: {
            request: (_dc_httpHeaders_request = (_dc_httpHeaders = dc.httpHeaders) === null || _dc_httpHeaders === void 0 ? void 0 : _dc_httpHeaders.request) !== null && _dc_httpHeaders_request !== void 0 ? _dc_httpHeaders_request : base.httpHeaders.request,
            response: (_dc_httpHeaders_response = (_dc_httpHeaders1 = dc.httpHeaders) === null || _dc_httpHeaders1 === void 0 ? void 0 : _dc_httpHeaders1.response) !== null && _dc_httpHeaders_response !== void 0 ? _dc_httpHeaders_response : base.httpHeaders.response
        },
        httpBodies: (_dc_httpBodies = dc.httpBodies) !== null && _dc_httpBodies !== void 0 ? _dc_httpBodies : base.httpBodies,
        // oxlint-disable-next-line typescript/no-deprecated
        urlQueryParams: (_ref = (_dc_urlQueryParams = dc.urlQueryParams) !== null && _dc_urlQueryParams !== void 0 ? _dc_urlQueryParams : dc.queryParams) !== null && _ref !== void 0 ? _ref : base.urlQueryParams,
        graphQL: {
            document: (_dc_graphQL_document = (_dc_graphQL = dc.graphQL) === null || _dc_graphQL === void 0 ? void 0 : _dc_graphQL.document) !== null && _dc_graphQL_document !== void 0 ? _dc_graphQL_document : base.graphQL.document,
            variables: (_dc_graphQL_variables = (_dc_graphQL1 = dc.graphQL) === null || _dc_graphQL1 === void 0 ? void 0 : _dc_graphQL1.variables) !== null && _dc_graphQL_variables !== void 0 ? _dc_graphQL_variables : base.graphQL.variables
        },
        genAI: {
            inputs: (_dc_genAI_inputs = (_dc_genAI = dc.genAI) === null || _dc_genAI === void 0 ? void 0 : _dc_genAI.inputs) !== null && _dc_genAI_inputs !== void 0 ? _dc_genAI_inputs : base.genAI.inputs,
            outputs: (_dc_genAI_outputs = (_dc_genAI1 = dc.genAI) === null || _dc_genAI1 === void 0 ? void 0 : _dc_genAI1.outputs) !== null && _dc_genAI_outputs !== void 0 ? _dc_genAI_outputs : base.genAI.outputs
        },
        databaseQueryData: (_dc_databaseQueryData = dc.databaseQueryData) !== null && _dc_databaseQueryData !== void 0 ? _dc_databaseQueryData : base.databaseQueryData,
        stackFrameVariables: (_dc_stackFrameVariables = dc.stackFrameVariables) !== null && _dc_stackFrameVariables !== void 0 ? _dc_stackFrameVariables : base.stackFrameVariables,
        frameContextLines: (_dc_frameContextLines = dc.frameContextLines) !== null && _dc_frameContextLines !== void 0 ? _dc_frameContextLines : base.frameContextLines
    };
}


var $de32a06ddda2c6cf$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
var $de32a06ddda2c6cf$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
var $de32a06ddda2c6cf$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
var $de32a06ddda2c6cf$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
var $de32a06ddda2c6cf$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $de32a06ddda2c6cf$var$_makeInternalError(message) {
    return (0, $dUlz9._)({
        message: message
    }, $de32a06ddda2c6cf$var$INTERNAL_ERROR_SYMBOL, true);
}
function $de32a06ddda2c6cf$var$_makeDoNotSendEventError(message) {
    return (0, $dUlz9._)({
        message: message
    }, $de32a06ddda2c6cf$var$DO_NOT_SEND_EVENT_SYMBOL, true);
}
function $de32a06ddda2c6cf$var$_isInternalError(error) {
    return (0, $6ea82c15e37d9720$export$c10d0b04eaa80a43)(error) && $de32a06ddda2c6cf$var$INTERNAL_ERROR_SYMBOL in error;
}
function $de32a06ddda2c6cf$var$_isDoNotSendEventError(error) {
    return (0, $6ea82c15e37d9720$export$c10d0b04eaa80a43)(error) && $de32a06ddda2c6cf$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $de32a06ddda2c6cf$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    var weight = 0;
    var flushTimeout;
    var isTimerActive = false;
    client.on(flushHook, function() {
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, function(item) {
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            var _client_getOptions__flushInterval;
            var flushInterval = (_client_getOptions__flushInterval = client.getOptions()._flushInterval) !== null && _client_getOptions__flushInterval !== void 0 ? _client_getOptions__flushInterval : $de32a06ddda2c6cf$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = (0, $cc7b10bd752b6597$export$630056cb83d87863)(setTimeout(function() {
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", function() {
        flushFn(client);
    });
}
var $de32a06ddda2c6cf$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    "use strict";
    function Client(options) {
        (0, $5Epmf._)(this, Client);
        var _options_transportOptions, _this__options__experiments, _this__options__experiments1;
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        var _options_transportOptions_bufferSize;
        this._promiseBuffer = (0, $4dd019c4733e4c95$export$85a4f67f852183e6)((_options_transportOptions_bufferSize = (_options_transportOptions = options.transportOptions) === null || _options_transportOptions === void 0 ? void 0 : _options_transportOptions.bufferSize) !== null && _options_transportOptions_bufferSize !== void 0 ? _options_transportOptions_bufferSize : (0, $be3155eb10c5dfe8$export$e515cf6dfd2f98b8));
        this._dataCollection = (0, $327b4b3a2fe46570$export$e0e409941f20a4c)(options);
        if (options.dsn) this._dsn = (0, $a77c6f8fcbd294ab$export$128827c3562ec0cb)(options.dsn);
        else (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            var url = (0, $ca252a259fcf64ec$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport((0, $lf4fc._)((0, $hwO3w._)({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this)
            }, options.transportOptions), {
                url: url
            }));
        }
        var _this__options_enableLogs;
        this._options.enableLogs = (_this__options_enableLogs = this._options.enableLogs) !== null && _this__options_enableLogs !== void 0 ? _this__options_enableLogs : (_this__options__experiments = this._options._experiments) === null || _this__options__experiments === void 0 ? void 0 : _this__options__experiments.enableLogs;
        if (this._options.enableLogs) $de32a06ddda2c6cf$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $de32a06ddda2c6cf$var$estimateLogSizeInBytes, (0, $7a13542258bb275f$export$f8ed83d3b6a0b504));
        var _this__options_enableMetrics, _ref;
        var enableMetrics = (_ref = (_this__options_enableMetrics = this._options.enableMetrics) !== null && _this__options_enableMetrics !== void 0 ? _this__options_enableMetrics : (_this__options__experiments1 = this._options._experiments) === null || _this__options__experiments1 === void 0 ? void 0 : _this__options__experiments1.enableMetrics) !== null && _ref !== void 0 ? _ref : true;
        if (enableMetrics) $de32a06ddda2c6cf$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $de32a06ddda2c6cf$var$estimateMetricSizeInBytes, (0, $5758034008aaa72c$export$91c9ef254b7d0f67));
    }
    (0, $9MqXK._)(Client, [
        {
            /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ key: "captureException",
            value: function captureException(exception, hint, scope) {
                var _this = this;
                var eventId = (0, $30748c2972c04cd5$export$19f53698e68b2496)();
                if ((0, $30748c2972c04cd5$export$6de4ffac6a2f1098)(exception)) {
                    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log($de32a06ddda2c6cf$var$ALREADY_SEEN_ERROR);
                    return eventId;
                }
                var hintWithEventId = (0, $hwO3w._)({
                    event_id: eventId
                }, hint);
                this._process(function() {
                    return _this.eventFromException(exception, hintWithEventId).then(function(event) {
                        return _this._captureEvent(event, hintWithEventId, scope);
                    }).then(function(res) {
                        return res;
                    });
                }, "error");
                return hintWithEventId.event_id;
            }
        },
        {
            /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ key: "captureMessage",
            value: function captureMessage(message, level, hint, currentScope) {
                var _this = this;
                var hintWithEventId = (0, $hwO3w._)({
                    event_id: (0, $30748c2972c04cd5$export$19f53698e68b2496)()
                }, hint);
                var eventMessage = (0, $6ea82c15e37d9720$export$dbcbffa59149b824)(message) ? message : String(message);
                var isMessage = (0, $6ea82c15e37d9720$export$c3825b437cbdea5c)(message);
                var promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
                this._process(function() {
                    return promisedEvent.then(function(event) {
                        return _this._captureEvent(event, hintWithEventId, currentScope);
                    });
                }, isMessage ? "unknown" : "error");
                return hintWithEventId.event_id;
            }
        },
        {
            /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ key: "captureEvent",
            value: function captureEvent(event, hint, currentScope) {
                var _this = this;
                var eventId = (0, $30748c2972c04cd5$export$19f53698e68b2496)();
                if ((hint === null || hint === void 0 ? void 0 : hint.originalException) && (0, $30748c2972c04cd5$export$6de4ffac6a2f1098)(hint.originalException)) {
                    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log($de32a06ddda2c6cf$var$ALREADY_SEEN_ERROR);
                    return eventId;
                }
                var hintWithEventId = (0, $hwO3w._)({
                    event_id: eventId
                }, hint);
                var sdkProcessingMetadata = event.sdkProcessingMetadata || {};
                var capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
                var capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
                var dataCategory = $de32a06ddda2c6cf$var$getDataCategoryByType(event.type);
                this._process(function() {
                    return _this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope);
                }, dataCategory);
                return hintWithEventId.event_id;
            }
        },
        {
            /**
   * Captures a session.
   */ key: "captureSession",
            value: function captureSession(session) {
                this.sendSession(session);
                (0, $e5a8a7b6f15619c1$export$531818e825e774db)(session, {
                    init: false
                });
            }
        },
        {
            /**
   * Get the current Dsn.
   */ key: "getDsn",
            value: function getDsn() {
                return this._dsn;
            }
        },
        {
            /**
   * Get the current options.
   */ key: "getOptions",
            value: function getOptions() {
                return this._options;
            }
        },
        {
            /**
   * Get the resolved data collection configuration.
   */ key: "getDataCollectionOptions",
            value: function getDataCollectionOptions() {
                return this._dataCollection;
            }
        },
        {
            /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ key: "getSdkMetadata",
            value: function getSdkMetadata() {
                return this._options._metadata;
            }
        },
        {
            /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ key: "getTransport",
            value: function getTransport() {
                return this._transport;
            }
        },
        {
            key: "flush",
            value: /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
            function flush(timeout) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var transport, clientFinished, transportFlushed;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                transport = this._transport;
                                this.emit("flush");
                                if (!transport) return [
                                    2,
                                    true
                                ];
                                return [
                                    4,
                                    this._isClientDoneProcessing(timeout)
                                ];
                            case 1:
                                clientFinished = _state.sent();
                                return [
                                    4,
                                    transport.flush(timeout)
                                ];
                            case 2:
                                transportFlushed = _state.sent();
                                return [
                                    2,
                                    clientFinished && transportFlushed
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "close",
            value: /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
            function close(timeout) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var result;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.flush(timeout)
                                ];
                            case 1:
                                result = _state.sent();
                                this.getOptions().enabled = false;
                                this.emit("close");
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Get all installed event processors.
   */ key: "getEventProcessors",
            value: function getEventProcessors() {
                return this._eventProcessors;
            }
        },
        {
            /**
   * Adds an event processor that applies to any event processed by this client.
   */ key: "addEventProcessor",
            value: function addEventProcessor(eventProcessor) {
                this._eventProcessors.push(eventProcessor);
            }
        },
        {
            /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ key: "init",
            value: function init() {
                if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
                // Spotlight enabled. This is particularly important for browser as we
                // don't support the `spotlight` option there and rely on the users
                // adding the `spotlightBrowserIntegration()` to their integrations which
                // wouldn't get initialized with the check below when there's no DSN set.
                this._options.integrations.some(function(param) {
                    var name = param.name;
                    return name.startsWith("Spotlight");
                })) this._setupIntegrations();
            }
        },
        {
            /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ key: "getIntegrationByName",
            value: function getIntegrationByName(integrationName) {
                return this._integrations[integrationName];
            }
        },
        {
            /**
   * Returns the names of all installed integrations.
   */ key: "getIntegrationNames",
            value: function getIntegrationNames() {
                return Object.keys(this._integrations);
            }
        },
        {
            /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ key: "addIntegration",
            value: function addIntegration(integration) {
                var isAlreadyInstalled = this._integrations[integration.name];
                if (!isAlreadyInstalled && integration.beforeSetup) integration.beforeSetup(this);
                (0, $ae9d79ccde098562$export$e7390a03b70a6f2f)(this, integration, this._integrations);
                if (!isAlreadyInstalled) (0, $ae9d79ccde098562$export$35abcfd71227c6ca)(this, [
                    integration
                ]);
            }
        },
        {
            /**
   * Send a fully prepared event to Sentry.
   */ key: "sendEvent",
            value: function sendEvent(event) {
                var _this = this;
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.emit("beforeSendEvent", event, hint);
                var genAiSpanItem = (0, $a59c7e537104d534$export$9aeb9a2b899f8587)(event, this);
                var env = (0, $1fb0c290380959ae$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (hint.attachments || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var attachment = _step.value;
                        env = (0, $c4622bb7cd663145$export$d650323442802f6f)(env, (0, $c4622bb7cd663145$export$d8fc80952cc31fa4)(attachment));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (genAiSpanItem) env = (0, $c4622bb7cd663145$export$d650323442802f6f)(env, genAiSpanItem);
                this.sendEnvelope(env).then(function(sendResponse) {
                    return _this.emit("afterSendEvent", event, sendResponse);
                });
            }
        },
        {
            /**
   * Send a session or session aggregrates to Sentry.
   */ key: "sendSession",
            value: function sendSession(session) {
                var _this__options = this._options, clientReleaseOption = _this__options.release, tmp = _this__options.environment, clientEnvironmentOption = tmp === void 0 ? (0, $9926372cdabb9b15$export$849dbeeeda01ae98) : tmp;
                if ("aggregates" in session) {
                    var sessionAttrs = session.attrs || {};
                    if (!sessionAttrs.release && !clientReleaseOption) {
                        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn($de32a06ddda2c6cf$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                        return;
                    }
                    sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
                    sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
                    session.attrs = sessionAttrs;
                } else {
                    if (!session.release && !clientReleaseOption) {
                        (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn($de32a06ddda2c6cf$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                        return;
                    }
                    session.release = session.release || clientReleaseOption;
                    session.environment = session.environment || clientEnvironmentOption;
                }
                this.emit("beforeSendSession", session);
                var env = (0, $1fb0c290380959ae$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
                this.sendEnvelope(env);
            }
        },
        {
            /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ key: "recordDroppedEvent",
            value: function recordDroppedEvent(reason, category) {
                var count = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
                if (this._options.sendClientReports) {
                    var key = "".concat(reason, ":").concat(category);
                    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log('Recording outcome: "'.concat(key, '"').concat(count > 1 ? " (".concat(count, " times)") : ""));
                    this._outcomes[key] = (this._outcomes[key] || 0) + count;
                }
            }
        },
        {
            /**
   * Register a hook on this client.
   */ key: "on",
            value: function on(hook, callback) {
                var hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
                var uniqueCallback = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return callback.apply(void 0, (0, $XnYkK._)(args));
                };
                hookCallbacks.add(uniqueCallback);
                return function() {
                    hookCallbacks.delete(uniqueCallback);
                };
            }
        },
        {
            /**
   * Emit a hook that was previously registered via `on()`.
   */ key: "emit",
            value: function emit(hook) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                var callbacks = this._hooks[hook];
                if (callbacks) callbacks.forEach(function(callback) {
                    return callback.apply(void 0, (0, $XnYkK._)(rest));
                });
            }
        },
        {
            key: "sendEnvelope",
            value: /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
            function sendEnvelope(envelope) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var reason;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.emit("beforeEnvelope", envelope);
                                if (!(this._isEnabled() && this._transport)) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this._transport.send(envelope)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                reason = _state.sent();
                                (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).error("Error while sending envelope:", reason);
                                return [
                                    2,
                                    {}
                                ];
                            case 4:
                                (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).error("Transport disabled");
                                return [
                                    2,
                                    {}
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
            key: "registerCleanup",
            value: function registerCleanup(callback) {}
        },
        {
            /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ key: "dispose",
            value: function dispose() {}
        },
        {
            /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ key: "_setupIntegrations",
            value: function _setupIntegrations() {
                var integrations = this._options.integrations;
                this._integrations = (0, $ae9d79ccde098562$export$51abed9797baa598)(this, integrations);
                (0, $ae9d79ccde098562$export$35abcfd71227c6ca)(this, integrations);
            }
        },
        {
            /** Updates existing session based on the provided event */ key: "_updateSessionFromEvent",
            value: function _updateSessionFromEvent(session, event) {
                var _event_exception;
                var crashed = event.level === "fatal";
                var errored = false;
                var exceptions = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values;
                if (exceptions) {
                    var _ex_mechanism;
                    errored = true;
                    crashed = false;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = exceptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var ex = _step.value;
                            if (((_ex_mechanism = ex.mechanism) === null || _ex_mechanism === void 0 ? void 0 : _ex_mechanism.handled) === false) {
                                crashed = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                var sessionNonTerminal = session.status === "ok";
                var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
                if (shouldUpdateAndSend) {
                    (0, $e5a8a7b6f15619c1$export$531818e825e774db)(session, (0, $lf4fc._)((0, $hwO3w._)({}, crashed && {
                        status: "crashed"
                    }), {
                        errors: session.errors || Number(errored || crashed)
                    }));
                    this.captureSession(session);
                }
            }
        },
        {
            key: "_isClientDoneProcessing",
            value: /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ function _isClientDoneProcessing(timeout) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var ticked;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ticked = 0;
                                _state.label = 1;
                            case 1:
                                if (!(!timeout || ticked < timeout)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return setTimeout(resolve, 1);
                                    })
                                ];
                            case 2:
                                _state.sent();
                                if (!this._numProcessing) return [
                                    2,
                                    true
                                ];
                                ticked++;
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /** Determines whether this SDK is enabled and a transport is present. */ key: "_isEnabled",
            value: function _isEnabled() {
                return this.getOptions().enabled !== false && this._transport !== void 0;
            }
        },
        {
            /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, currentScope, isolationScope) {
                var _this = this;
                var options = this.getOptions();
                var integrations = this.getIntegrationNames();
                if (!hint.integrations && integrations.length) hint.integrations = integrations;
                this.emit("preprocessEvent", event, hint);
                if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
                return (0, $1c7a86869cfa8695$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then(function(evt) {
                    var _evt_contexts;
                    if (evt === null) return evt;
                    _this.emit("postprocessEvent", evt, hint);
                    evt.contexts = (0, $hwO3w._)({
                        trace: (0, $hwO3w._)({}, (_evt_contexts = evt.contexts) === null || _evt_contexts === void 0 ? void 0 : _evt_contexts.trace, (0, $945639585ea57ae0$export$1e83db7ee4876dc4)(currentScope))
                    }, evt.contexts);
                    var dynamicSamplingContext = (0, $0d1fd6101086a96b$export$89ef1736f08c6b2b)(_this, currentScope);
                    evt.sdkProcessingMetadata = (0, $hwO3w._)({
                        dynamicSamplingContext: dynamicSamplingContext
                    }, evt.sdkProcessingMetadata);
                    return evt;
                });
            }
        },
        {
            /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ key: "_captureEvent",
            value: function _captureEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, currentScope = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $945639585ea57ae0$export$c7be4b0125a10cba)(), isolationScope = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0, $945639585ea57ae0$export$68f3af03034c9e90)();
                if ((0, $63491170aaadd711$export$16a28057038b10ef) && $de32a06ddda2c6cf$var$isErrorEvent(event)) (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Captured error event `".concat((0, $cf969b243c6ca6e1$export$d55a97c329cacfcc)(event)[0] || "<unknown>", "`"));
                return this._processEvent(event, hint, currentScope, isolationScope).then(function(finalEvent) {
                    return finalEvent.event_id;
                }, function(reason) {
                    if (0, $63491170aaadd711$export$16a28057038b10ef) {
                        if ($de32a06ddda2c6cf$var$_isDoNotSendEventError(reason)) (0, $739716ea0436a6d0$export$1c9f709888824e05).log(reason.message);
                        else if ($de32a06ddda2c6cf$var$_isInternalError(reason)) (0, $739716ea0436a6d0$export$1c9f709888824e05).warn(reason.message);
                        else (0, $739716ea0436a6d0$export$1c9f709888824e05).warn(reason);
                    }
                    return void 0;
                });
            }
        },
        {
            /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ key: "_processEvent",
            value: function _processEvent(event, hint, currentScope, isolationScope) {
                var _this = this;
                var options = this.getOptions();
                var sampleRate = options.sampleRate;
                var isTransaction = $de32a06ddda2c6cf$var$isTransactionEvent(event);
                var isError = $de32a06ddda2c6cf$var$isErrorEvent(event);
                var eventType = event.type || "error";
                var beforeSendLabel = "before send for type `".concat(eventType, "`");
                var parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : (0, $bbaf31262ee9249c$export$a5bd2d81656d9546)(sampleRate);
                var dataCategory = $de32a06ddda2c6cf$var$getDataCategoryByType(event.type);
                return this._prepareEvent(event, hint, currentScope, isolationScope).then(function(prepared) {
                    var _hint_data;
                    if (prepared === null) {
                        _this.recordDroppedEvent("event_processor", dataCategory);
                        throw $de32a06ddda2c6cf$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
                    }
                    var isInternalException = ((_hint_data = hint.data) === null || _hint_data === void 0 ? void 0 : _hint_data.__sentry__) === true;
                    if (isInternalException) return prepared;
                    var result = $de32a06ddda2c6cf$var$processBeforeSend(_this, options, prepared, hint);
                    return $de32a06ddda2c6cf$var$_validateBeforeSendResult(result, beforeSendLabel);
                }).then(function(processedEvent) {
                    if (processedEvent === null) {
                        _this.recordDroppedEvent("before_send", dataCategory);
                        if (isTransaction) {
                            var spans = event.spans || [];
                            var spanCount = 1 + spans.length;
                            _this.recordDroppedEvent("before_send", "span", spanCount);
                        }
                        throw $de32a06ddda2c6cf$var$_makeDoNotSendEventError("".concat(beforeSendLabel, " returned `null`, will not send event."));
                    }
                    var session = currentScope.getSession() || isolationScope.getSession();
                    if (isError && session) _this._updateSessionFromEvent(session, processedEvent);
                    if (isError && typeof parsedSampleRate === "number" && (0, $dd2c5f85fcbd9c64$export$9869d72de32a3917)() > parsedSampleRate) {
                        _this.recordDroppedEvent("sample_rate", "error");
                        throw $de32a06ddda2c6cf$var$_makeDoNotSendEventError("Discarding event because it's not included in the random sample (sampling rate = ".concat(sampleRate, ")"));
                    }
                    if (isTransaction) {
                        var _processedEvent_sdkProcessingMetadata;
                        var spanCountBefore = ((_processedEvent_sdkProcessingMetadata = processedEvent.sdkProcessingMetadata) === null || _processedEvent_sdkProcessingMetadata === void 0 ? void 0 : _processedEvent_sdkProcessingMetadata.spanCountBeforeProcessing) || 0;
                        var spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                        var droppedSpanCount = spanCountBefore - spanCountAfter;
                        if (droppedSpanCount > 0) _this.recordDroppedEvent("before_send", "span", droppedSpanCount);
                    }
                    var transactionInfo = processedEvent.transaction_info;
                    if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                        var source = "custom";
                        processedEvent.transaction_info = (0, $lf4fc._)((0, $hwO3w._)({}, transactionInfo), {
                            source: source
                        });
                    }
                    _this.sendEvent(processedEvent, hint);
                    return processedEvent;
                }).then(null, function(reason) {
                    if ($de32a06ddda2c6cf$var$_isDoNotSendEventError(reason) || $de32a06ddda2c6cf$var$_isInternalError(reason)) throw reason;
                    _this.captureException(reason, {
                        mechanism: {
                            handled: false,
                            type: "internal"
                        },
                        data: {
                            __sentry__: true
                        },
                        originalException: reason
                    });
                    throw $de32a06ddda2c6cf$var$_makeInternalError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ".concat(reason));
                });
            }
        },
        {
            /**
   * Occupies the client with processing and event
   */ key: "_process",
            value: function _process(taskProducer, dataCategory) {
                var _this = this;
                this._numProcessing++;
                this._promiseBuffer.add(taskProducer).then(function(value) {
                    _this._numProcessing--;
                    return value;
                }, function(reason) {
                    _this._numProcessing--;
                    if (reason === (0, $4dd019c4733e4c95$export$c8667f1887a128dc)) _this.recordDroppedEvent("queue_overflow", dataCategory);
                    return reason;
                });
            }
        },
        {
            /**
   * Clears outcomes on this client and returns them.
   */ key: "_clearOutcomes",
            value: function _clearOutcomes() {
                var outcomes = this._outcomes;
                this._outcomes = {};
                return Object.entries(outcomes).map(function(param) {
                    var _param = (0, $6iP9u._)(param, 2), key = _param[0], quantity = _param[1];
                    var _key_split = (0, $6iP9u._)(key.split(":"), 2), reason = _key_split[0], category = _key_split[1];
                    return {
                        reason: reason,
                        category: category,
                        quantity: quantity
                    };
                });
            }
        },
        {
            /**
   * Sends client reports as an envelope.
   */ key: "_flushOutcomes",
            value: function _flushOutcomes() {
                (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Flushing outcomes...");
                var outcomes = this._clearOutcomes();
                if (outcomes.length === 0) {
                    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("No outcomes to send");
                    return;
                }
                if (!this._dsn) {
                    (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("No dsn provided, will not send outcomes");
                    return;
                }
                (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Sending outcomes:", outcomes);
                var envelope = (0, $fdd2e5c4fbd90dd8$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $a77c6f8fcbd294ab$export$44d472fbb931a776)(this._dsn));
                this.sendEnvelope(envelope);
            }
        }
    ]);
    return Client;
}();
function $de32a06ddda2c6cf$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $de32a06ddda2c6cf$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    var invalidValueError = "".concat(beforeSendLabel, " must return `null` or a valid event.");
    if ((0, $6ea82c15e37d9720$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then(function(event) {
        if (!(0, $6ea82c15e37d9720$export$53b83ca8eaab0383)(event) && event !== null) throw $de32a06ddda2c6cf$var$_makeInternalError(invalidValueError);
        return event;
    }, function(e) {
        throw $de32a06ddda2c6cf$var$_makeInternalError("".concat(beforeSendLabel, " rejected with ").concat(e));
    });
    else if (!(0, $6ea82c15e37d9720$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $de32a06ddda2c6cf$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $de32a06ddda2c6cf$var$processBeforeSend(client, options, event, hint) {
    var beforeSend = options.beforeSend, beforeSendTransaction = options.beforeSendTransaction, ignoreSpans = options.ignoreSpans;
    var beforeSendSpan = !(0, $3a2af6feab215f7b$export$ca3e1ec3cdcc76ac)(options.beforeSendSpan) && options.beforeSendSpan;
    var processedEvent = event;
    if ($de32a06ddda2c6cf$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($de32a06ddda2c6cf$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan || ignoreSpans) {
            var rootSpanJson = (0, $620ebc0d2c4c02e8$export$d9c6b2464b0a687e)(processedEvent);
            if ((ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) && (0, $9fb6aa6e5a686ce5$export$5d569ac97c389400)({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan) {
                var processedRootSpanJson = beforeSendSpan(rootSpanJson);
                if (!processedRootSpanJson) (0, $79515206909fddff$export$d11691ff45a3e535)();
                else processedEvent = (0, $e561f8063ae23b8a$export$4950aa0f605343fb)(event, (0, $620ebc0d2c4c02e8$export$f2d8fce5ae150e92)(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                var processedSpans = [];
                var initialSpans = processedEvent.spans;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = initialSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var span = _step.value;
                        if ((ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) && (0, $9fb6aa6e5a686ce5$export$5d569ac97c389400)({
                            description: span.description,
                            op: span.op,
                            attributes: span.data
                        }, ignoreSpans)) {
                            (0, $9fb6aa6e5a686ce5$export$ddf57376e818b444)(initialSpans, span);
                            continue;
                        }
                        if (beforeSendSpan) {
                            var processedSpan = beforeSendSpan(span);
                            if (!processedSpan) {
                                (0, $79515206909fddff$export$d11691ff45a3e535)();
                                processedSpans.push(span);
                            } else processedSpans.push(processedSpan);
                        } else processedSpans.push(span);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                var spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = (0, $lf4fc._)((0, $hwO3w._)({}, event.sdkProcessingMetadata), {
                    spanCountBeforeProcessing: spanCountBefore
                });
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $de32a06ddda2c6cf$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $de32a06ddda2c6cf$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $de32a06ddda2c6cf$var$estimateMetricSizeInBytes(metric) {
    var weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $de32a06ddda2c6cf$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $de32a06ddda2c6cf$var$estimateLogSizeInBytes(log) {
    var weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $de32a06ddda2c6cf$var$estimateAttributesSizeInBytes(log.attributes);
}
function $de32a06ddda2c6cf$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    var weight = 0;
    Object.values(attributes).forEach(function(value) {
        if (Array.isArray(value)) weight += value.length * $de32a06ddda2c6cf$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ((0, $6ea82c15e37d9720$export$c3825b437cbdea5c)(value)) weight += $de32a06ddda2c6cf$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $de32a06ddda2c6cf$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}


var $8cmAa = parcelRequire("8cmAa");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");




function $700936e2cc893460$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $700936e2cc893460$var$hasSentryFetchUrlHost(error) {
    return (0, $6ea82c15e37d9720$export$e6127cc7fe7395c3)(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $700936e2cc893460$export$35a730c8874c1024(error) {
    if ($700936e2cc893460$var$hasSentryFetchUrlHost(error)) return "".concat(error.message, " (").concat(error.__sentry_fetch_url_host__, ")");
    return error.message;
}
function $700936e2cc893460$export$a6c2d27607295951(stackParser, error) {
    var exception = {
        type: error.name || error.constructor.name,
        value: $700936e2cc893460$export$35a730c8874c1024(error)
    };
    var frames = $700936e2cc893460$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $700936e2cc893460$var$getErrorPropertyFromObject(obj) {
    for(var prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        var value = obj[prop];
        if ((0, $6ea82c15e37d9720$export$e6127cc7fe7395c3)(value)) return value;
    }
    return void 0;
}
function $700936e2cc893460$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        var message = "'".concat(exception.name, "' captured as exception");
        if ("message" in exception && typeof exception.message === "string") message += " with message '".concat(exception.message, "'");
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    var keys = (0, $27958f6402fc5d96$export$b0244d5063c0b61b)(exception);
    if ((0, $6ea82c15e37d9720$export$9f9636d330b71954)(exception)) return "Event `ErrorEvent` captured as exception with message `".concat(exception.message, "`");
    var className = $700936e2cc893460$var$getObjectClassName(exception);
    return "".concat(className && className !== "Object" ? "'".concat(className, "'") : "Object", " captured as exception with keys: ").concat(keys);
}
function $700936e2cc893460$var$getObjectClassName(obj) {
    try {
        var prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch (e) {}
}
function $700936e2cc893460$var$getException(client, mechanism, exception, hint) {
    if ((0, $6ea82c15e37d9720$export$e6127cc7fe7395c3)(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ((0, $6ea82c15e37d9720$export$53b83ca8eaab0383)(exception)) {
        var normalizeDepth = client === null || client === void 0 ? void 0 : client.getOptions().normalizeDepth;
        var extras = (0, $dUlz9._)({}, "__serialized__", (0, $74542fb861c25274$export$23fbbb20bed71033)(exception, normalizeDepth));
        var errorFromProp = $700936e2cc893460$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        var message = $700936e2cc893460$var$getMessageForObject(exception);
        var ex2 = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    var ex = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || new Error(exception);
    ex.message = "".concat(exception);
    return [
        ex,
        void 0
    ];
}
function $700936e2cc893460$export$9dd56ed1ef0c3420(client, stackParser, exception, hint) {
    var providedMechanism = (hint === null || hint === void 0 ? void 0 : hint.data) && hint.data.mechanism;
    var mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    var _getException = (0, $6iP9u._)($700936e2cc893460$var$getException(client, mechanism, exception, hint), 2), ex = _getException[0], extras = _getException[1];
    var event = {
        exception: {
            values: [
                $700936e2cc893460$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $30748c2972c04cd5$export$f26508487bf83ee7)(event, void 0, void 0);
    (0, $30748c2972c04cd5$export$c69a9a0313b03bb1)(event, mechanism);
    return (0, $lf4fc._)((0, $hwO3w._)({}, event), {
        event_id: hint === null || hint === void 0 ? void 0 : hint.event_id
    });
}
function $700936e2cc893460$export$5425b53185d13d6c(stackParser, message) {
    var level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "info", hint = arguments.length > 3 ? arguments[3] : void 0, attachStacktrace = arguments.length > 4 ? arguments[4] : void 0;
    var event = {
        event_id: hint === null || hint === void 0 ? void 0 : hint.event_id,
        level: level
    };
    if (attachStacktrace && (hint === null || hint === void 0 ? void 0 : hint.syntheticException)) {
        var frames = $700936e2cc893460$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            (0, $30748c2972c04cd5$export$c69a9a0313b03bb1)(event, {
                synthetic: true
            });
        }
    }
    if ((0, $6ea82c15e37d9720$export$dbcbffa59149b824)(message)) {
        var __sentry_template_string__ = message.__sentry_template_string__, __sentry_template_values__ = message.__sentry_template_values__;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}


function $0ca391b57a1c7d4e$export$a6c2d27607295951(stackParser, ex) {
    var frames = $0ca391b57a1c7d4e$var$parseStackFrames(stackParser, ex);
    var exception = {
        type: $0ca391b57a1c7d4e$export$2e9ae379995d99e3(ex),
        value: $0ca391b57a1c7d4e$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $0ca391b57a1c7d4e$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    var normalizeDepth = client === null || client === void 0 ? void 0 : client.getOptions().normalizeDepth;
    var errorFromProp = $0ca391b57a1c7d4e$var$getErrorPropertyFromObject(exception);
    var extra = {
        __serialized__: (0, $74542fb861c25274$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $0ca391b57a1c7d4e$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    var event = {
        exception: {
            values: [
                {
                    type: (0, $6ea82c15e37d9720$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $0ca391b57a1c7d4e$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        var frames = $0ca391b57a1c7d4e$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $0ca391b57a1c7d4e$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $0ca391b57a1c7d4e$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $0ca391b57a1c7d4e$var$parseStackFrames(stackParser, ex) {
    var stacktrace = ex.stacktrace || ex.stack || "";
    var skipLines = $0ca391b57a1c7d4e$var$getSkipFirstStackStringLines(ex);
    var framesToPop = $0ca391b57a1c7d4e$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {}
    return [];
}
var $0ca391b57a1c7d4e$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $0ca391b57a1c7d4e$var$getSkipFirstStackStringLines(ex) {
    if (ex && $0ca391b57a1c7d4e$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $0ca391b57a1c7d4e$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $0ca391b57a1c7d4e$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $0ca391b57a1c7d4e$export$2e9ae379995d99e3(ex) {
    var name = ex === null || ex === void 0 ? void 0 : ex.name;
    if (!name && $0ca391b57a1c7d4e$var$isWebAssemblyException(ex)) {
        var hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $0ca391b57a1c7d4e$export$86005d1b62804363(ex) {
    var message = ex === null || ex === void 0 ? void 0 : ex.message;
    if ($0ca391b57a1c7d4e$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $700936e2cc893460$export$35a730c8874c1024)(message.error);
    return (0, $700936e2cc893460$export$35a730c8874c1024)(ex);
}
function $0ca391b57a1c7d4e$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    var syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || void 0;
    var event = $0ca391b57a1c7d4e$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $30748c2972c04cd5$export$c69a9a0313b03bb1)(event);
    event.level = "error";
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, $6fb471c4cc1a8a7b$export$1fda8aa4d135f8aa)(event);
}
function $0ca391b57a1c7d4e$export$5425b53185d13d6c(stackParser, message) {
    var level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "info", hint = arguments.length > 3 ? arguments[3] : void 0, attachStacktrace = arguments.length > 4 ? arguments[4] : void 0;
    var syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || void 0;
    var event = $0ca391b57a1c7d4e$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, $6fb471c4cc1a8a7b$export$1fda8aa4d135f8aa)(event);
}
function $0ca391b57a1c7d4e$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $6ea82c15e37d9720$export$9f9636d330b71954)(exception) && exception.error) {
        var errorEvent = exception;
        return $0ca391b57a1c7d4e$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $6ea82c15e37d9720$export$ef9e2056653f0c8e)(exception) || (0, $6ea82c15e37d9720$export$12e869b2a583f783)(exception)) {
        var domException = exception;
        if ("stack" in exception) {
            var _event_exception_values, _event_exception;
            event = $0ca391b57a1c7d4e$var$eventFromError(stackParser, exception);
            var firstException = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                var frames = $0ca391b57a1c7d4e$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $30748c2972c04cd5$export$c69a9a0313b03bb1)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            var name = domException.name || ((0, $6ea82c15e37d9720$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            var message = domException.message ? "".concat(name, ": ").concat(domException.message) : name;
            event = $0ca391b57a1c7d4e$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $30748c2972c04cd5$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) event.tags = (0, $lf4fc._)((0, $hwO3w._)({}, event.tags), {
            "DOMException.code": "".concat(domException.code)
        });
        return event;
    }
    if ((0, $6ea82c15e37d9720$export$e6127cc7fe7395c3)(exception)) return $0ca391b57a1c7d4e$var$eventFromError(stackParser, exception);
    if ((0, $6ea82c15e37d9720$export$53b83ca8eaab0383)(exception) || (0, $6ea82c15e37d9720$export$9671ea99bd126ace)(exception)) {
        var objectException = exception;
        event = $0ca391b57a1c7d4e$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $30748c2972c04cd5$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    event = $0ca391b57a1c7d4e$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $30748c2972c04cd5$export$f26508487bf83ee7)(event, "".concat(exception), void 0);
    (0, $30748c2972c04cd5$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $0ca391b57a1c7d4e$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    var event = {};
    if (attachStacktrace && syntheticException) {
        var frames = $0ca391b57a1c7d4e$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $30748c2972c04cd5$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $6ea82c15e37d9720$export$dbcbffa59149b824)(message)) {
        var __sentry_template_string__ = message.__sentry_template_string__, __sentry_template_values__ = message.__sentry_template_values__;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $0ca391b57a1c7d4e$var$getNonErrorObjectExceptionValue(exception, param) {
    var isUnhandledRejection = param.isUnhandledRejection;
    var keys = (0, $27958f6402fc5d96$export$b0244d5063c0b61b)(exception);
    var captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $6ea82c15e37d9720$export$9f9636d330b71954)(exception)) return "Event `ErrorEvent` captured as ".concat(captureType, " with message `").concat(exception.message, "`");
    if ((0, $6ea82c15e37d9720$export$9671ea99bd126ace)(exception)) {
        var className = $0ca391b57a1c7d4e$var$getObjectClassName(exception);
        return "Event `".concat(className, "` (type=").concat(exception.type, ") captured as ").concat(captureType);
    }
    return "Object captured as ".concat(captureType, " with keys: ").concat(keys);
}
function $0ca391b57a1c7d4e$var$getObjectClassName(obj) {
    try {
        var prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch (e) {}
}
function $0ca391b57a1c7d4e$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((0, $6ea82c15e37d9720$export$e6127cc7fe7395c3));
}



var $6e9b8a2430dc83f5$export$1df9218a526d318d = /*#__PURE__*/ function(Client) {
    "use strict";
    (0, $4QAx6._)(BrowserClient, Client);
    function BrowserClient(options) {
        (0, $5Epmf._)(this, BrowserClient);
        var _this;
        var _opts__metadata;
        var opts = $6e9b8a2430dc83f5$export$4e107b20a7f977(options);
        var sdkSource = (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $8cmAa.getSDKSource)();
        (0, $bd839e84f4db6244$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        _this = (0, $48Z0s._)(this, BrowserClient, [
            opts
        ]);
        var userInfo = _this.getDataCollectionOptions().userInfo;
        if ((_opts__metadata = opts._metadata) === null || _opts__metadata === void 0 ? void 0 : _opts__metadata.sdk) opts._metadata.sdk.settings = (0, $hwO3w._)({
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never"
        }, opts._metadata.sdk.settings);
        var sendClientReports = _this._options.sendClientReports;
        if ((0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).document) (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", function() {
            if ((0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) _this._flushOutcomes();
                queueMicrotask(function() {
                    _this.flush();
                });
            }
        });
        if (userInfo) _this.on("beforeSendSession", (0, $60d886ea8059ef98$export$e8e2d07ba63e2b6c));
        return _this;
    }
    (0, $9MqXK._)(BrowserClient, [
        {
            /**
   * @inheritDoc
   */ key: "eventFromException",
            value: function eventFromException1(exception, hint) {
                return (0, $0ca391b57a1c7d4e$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "eventFromMessage",
            value: function eventFromMessage1(message) {
                var level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "info", hint = arguments.length > 2 ? arguments[2] : void 0;
                return (0, $0ca391b57a1c7d4e$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, currentScope, isolationScope) {
                event.platform = event.platform || "javascript";
                return (0, $fecd75458a076b3b$export$71511d61b312f219)((0, $h50jA._)(BrowserClient.prototype), "_prepareEvent", this).call(this, event, hint, currentScope, isolationScope);
            }
        }
    ]);
    return BrowserClient;
}((0, $de32a06ddda2c6cf$export$1f2bb630327ac4b6));
function $6e9b8a2430dc83f5$export$4e107b20a7f977(optionsArg) {
    var _WINDOW_SENTRY_RELEASE;
    return (0, $hwO3w._)({
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (_WINDOW_SENTRY_RELEASE = (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).SENTRY_RELEASE) === null || _WINDOW_SENTRY_RELEASE === void 0 ? void 0 : _WINDOW_SENTRY_RELEASE.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true
    }, optionsArg);
}



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $03bAP = parcelRequire("03bAP");

var $hwO3w = parcelRequire("hwO3w");



var $0d32e047c1999955$var$DEFAULT_BREADCRUMBS = 100;
function $0d32e047c1999955$export$efda9a273d7a036d(breadcrumb, hint) {
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    var isolationScope = (0, $945639585ea57ae0$export$68f3af03034c9e90)();
    if (!client) return;
    var _client_getOptions = client.getOptions(), _client_getOptions_beforeBreadcrumb = _client_getOptions.beforeBreadcrumb, beforeBreadcrumb = _client_getOptions_beforeBreadcrumb === void 0 ? null : _client_getOptions_beforeBreadcrumb, _client_getOptions_maxBreadcrumbs = _client_getOptions.maxBreadcrumbs, maxBreadcrumbs = _client_getOptions_maxBreadcrumbs === void 0 ? $0d32e047c1999955$var$DEFAULT_BREADCRUMBS : _client_getOptions_maxBreadcrumbs;
    if (maxBreadcrumbs <= 0) return;
    var timestamp = (0, $7b1d57c4c7d6952d$export$7740643b9eeaf0c4)();
    var mergedBreadcrumb = (0, $hwO3w._)({
        timestamp: timestamp
    }, breadcrumb);
    var finalBreadcrumb = beforeBreadcrumb ? (0, $739716ea0436a6d0$export$cda52e2a8927a2ca)(function() {
        return beforeBreadcrumb(mergedBreadcrumb, hint);
    }) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}







var $29af126af92bbb7a$var$_filter = /* @__PURE__ */ new Set([]);
function $29af126af92bbb7a$export$1d6e0d073f9e6723(handler) {
    var type = "console";
    var removeHandler = (0, $50b9444442511a8d$export$a4e09611e30da72e)(type, handler);
    (0, $50b9444442511a8d$export$e18d6c5462c01368)(type, $29af126af92bbb7a$export$b80c01837473f7bc);
    return removeHandler;
}
function $29af126af92bbb7a$export$7444162f8bcc9c91(filter) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = filter[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var f = _step.value;
            $29af126af92bbb7a$var$_filter.add(f);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = filter[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var f = _step.value;
                $29af126af92bbb7a$var$_filter.delete(f);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
var $29af126af92bbb7a$var$instrumentedLevels = /* @__PURE__ */ new Set();
function $29af126af92bbb7a$export$b80c01837473f7bc() {
    if (!("console" in (0, $6001140c9a325157$export$f1a6cdb1459e81d1))) return;
    (0, $739716ea0436a6d0$export$2a2b1d2252a69ecb).forEach(function(level) {
        if ($29af126af92bbb7a$var$instrumentedLevels.has(level) || !(level in (0, $6001140c9a325157$export$f1a6cdb1459e81d1).console)) return;
        $29af126af92bbb7a$var$instrumentedLevels.add(level);
        (0, $27958f6402fc5d96$export$9563e054e6f787fb)((0, $6001140c9a325157$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $739716ea0436a6d0$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var firstArg = args[0];
                var log = (0, $739716ea0436a6d0$export$77c4ce905194557b)[level];
                var isFiltered = $29af126af92bbb7a$var$_filter.size && typeof firstArg === "string" && (0, $45aea333cf5bef5d$export$a7a5ec66062ea5d)(firstArg, $29af126af92bbb7a$var$_filter);
                if (!isFiltered) (0, $50b9444442511a8d$export$b18c893e424d3127)("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || (0, $63491170aaadd711$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).isEnabled()) log === null || log === void 0 ? void 0 : log.apply((0, $6001140c9a325157$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

function $b955bb22a8ae6706$export$b8cfcc4175694bcc(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}

function $2b6d234d6cde8716$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}




var $6479bb906a9ea5f5$var$DEBOUNCE_DURATION = 1e3;
var $6479bb906a9ea5f5$var$debounceTimerID;
var $6479bb906a9ea5f5$var$lastCapturedEventType;
var $6479bb906a9ea5f5$var$lastCapturedEventTargetId;
function $6479bb906a9ea5f5$export$5aeffd3db2cf9df7(handler) {
    var type = "dom";
    (0, $50b9444442511a8d$export$a4e09611e30da72e)(type, handler);
    (0, $50b9444442511a8d$export$e18d6c5462c01368)(type, $6479bb906a9ea5f5$export$3014bbf0af0e1d4a);
}
function $6479bb906a9ea5f5$export$3014bbf0af0e1d4a() {
    if (!(0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document) return;
    var triggerDOMHandler = (0, $50b9444442511a8d$export$b18c893e424d3127).bind(null, "dom");
    var globalDOMEventHandler = $6479bb906a9ea5f5$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach(function(target) {
        var _globalObject_target, _proto_hasOwnProperty;
        var globalObject = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81);
        var proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
        if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, "addEventListener"))) return;
        (0, $27958f6402fc5d96$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    var handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $6479bb906a9ea5f5$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $27958f6402fc5d96$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    var handlers = this.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $6479bb906a9ea5f5$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $6479bb906a9ea5f5$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $6479bb906a9ea5f5$var$lastCapturedEventTargetId) return false;
    } catch (e) {}
    return true;
}
function $6479bb906a9ea5f5$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!(target === null || target === void 0 ? void 0 : target.tagName)) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $6479bb906a9ea5f5$var$makeDOMEventHandler(handler) {
    var globalListener = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function(event) {
        if (!event || event["_sentryCaptured"]) return;
        var target = $6479bb906a9ea5f5$var$getEventTarget(event);
        if ($6479bb906a9ea5f5$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $27958f6402fc5d96$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $27958f6402fc5d96$export$e73679ffaf56810e)(target, "_sentryId", (0, $30748c2972c04cd5$export$19f53698e68b2496)());
        var name = event.type === "keypress" ? "input" : event.type;
        if (!$6479bb906a9ea5f5$var$isSimilarToLastCapturedEvent(event)) {
            var handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $6479bb906a9ea5f5$var$lastCapturedEventType = event.type;
            $6479bb906a9ea5f5$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($6479bb906a9ea5f5$var$debounceTimerID);
        $6479bb906a9ea5f5$var$debounceTimerID = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).setTimeout(function() {
            $6479bb906a9ea5f5$var$lastCapturedEventTargetId = void 0;
            $6479bb906a9ea5f5$var$lastCapturedEventType = void 0;
        }, $6479bb906a9ea5f5$var$DEBOUNCE_DURATION);
    };
}
function $6479bb906a9ea5f5$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        return null;
    }
}




var $6272a28fde91a87f$var$MAX_ALLOWED_STRING_LENGTH = 1024;
var $6272a28fde91a87f$var$INTEGRATION_NAME = "Breadcrumbs";
var $6272a28fde91a87f$var$_breadcrumbsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, $hwO3w._)({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true
    }, options);
    return {
        name: $6272a28fde91a87f$var$INTEGRATION_NAME,
        setup: function(client) {
            if (_options.console) (0, $29af126af92bbb7a$export$1d6e0d073f9e6723)($6272a28fde91a87f$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $6479bb906a9ea5f5$export$5aeffd3db2cf9df7)($6272a28fde91a87f$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $2034b898240d7377$export$26ace48dd54c9aea)($6272a28fde91a87f$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $f6ba95453bfd82e7$export$f75d3c772c923df0)($6272a28fde91a87f$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $276dfa3d97c764b4$export$3f18c56c58114e75)($6272a28fde91a87f$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $6272a28fde91a87f$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
var $6272a28fde91a87f$export$c079d904b326663a = (0, $ae9d79ccde098562$export$2323046b9414659f)($6272a28fde91a87f$var$_breadcrumbsIntegration);
function $6272a28fde91a87f$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $945639585ea57ae0$export$6bb76d6eba7e258c)() !== client) return;
        (0, $0d32e047c1999955$export$efda9a273d7a036d)({
            category: "sentry.".concat(event.type === "transaction" ? "transaction" : "event"),
            event_id: event.event_id,
            level: event.level,
            message: (0, $30748c2972c04cd5$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
function $6272a28fde91a87f$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $945639585ea57ae0$export$6bb76d6eba7e258c)() !== client) return;
        var target;
        var componentName;
        var keyAttrs = (typeof dom === "undefined" ? "undefined" : (0, $03bAP._)(dom)) === "object" ? dom.serializeAttribute : void 0;
        var maxStringLength = (typeof dom === "undefined" ? "undefined" : (0, $03bAP._)(dom)) === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $6272a28fde91a87f$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $be1ea91a107a1f2d$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("`dom.maxStringLength` cannot exceed ".concat($6272a28fde91a87f$var$MAX_ALLOWED_STRING_LENGTH, ", but a value of ").concat(maxStringLength, " was configured. Sentry will use ").concat($6272a28fde91a87f$var$MAX_ALLOWED_STRING_LENGTH, " instead."));
            maxStringLength = $6272a28fde91a87f$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            var event = handlerData.event;
            var element = $6272a28fde91a87f$var$_isEvent(event) ? event.target : event;
            target = (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $a7a5fd8a48375ca8$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        var breadcrumb = {
            category: "ui.".concat(handlerData.name),
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $0d32e047c1999955$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $6272a28fde91a87f$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $945639585ea57ae0$export$6bb76d6eba7e258c)() !== client) return;
        var breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $2b6d234d6cde8716$export$d771ef054122c30a)(handlerData.level),
            message: (0, $45aea333cf5bef5d$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: ".concat((0, $45aea333cf5bef5d$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert");
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $0d32e047c1999955$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $6272a28fde91a87f$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $945639585ea57ae0$export$6bb76d6eba7e258c)() !== client) return;
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        var sentryXhrData = handlerData.xhr[0, $2034b898240d7377$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        var method = sentryXhrData.method, url = sentryXhrData.url, status_code = sentryXhrData.status_code, body = sentryXhrData.body;
        var data = {
            method: method,
            url: url,
            status_code: status_code
        };
        var hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        var breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $b955bb22a8ae6706$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $0d32e047c1999955$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
function $6272a28fde91a87f$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $945639585ea57ae0$export$6bb76d6eba7e258c)() !== client) return;
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            var hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            var breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $0d32e047c1999955$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            var response = handlerData.response;
            var data = (0, $lf4fc._)((0, $hwO3w._)({}, handlerData.fetchData), {
                status_code: response === null || response === void 0 ? void 0 : response.status
            });
            var hint1 = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            var breadcrumb1 = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $b955bb22a8ae6706$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb1, hint1);
            (0, $0d32e047c1999955$export$efda9a273d7a036d)(breadcrumb1, hint1);
        }
    };
}
function $6272a28fde91a87f$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $945639585ea57ae0$export$6bb76d6eba7e258c)() !== client) return;
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = (0, $82aed6a67a552ecb$export$7a5253c0f62e0150)((0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).location.href);
        var parsedFrom = from ? (0, $82aed6a67a552ecb$export$7a5253c0f62e0150)(from) : void 0;
        var parsedTo = (0, $82aed6a67a552ecb$export$7a5253c0f62e0150)(to);
        if (!(parsedFrom === null || parsedFrom === void 0 ? void 0 : parsedFrom.path)) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $0d32e047c1999955$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $6272a28fde91a87f$var$_isEvent(event) {
    return !!event && !!event.target;
}



var $hwO3w = parcelRequire("hwO3w");

var $03bAP = parcelRequire("03bAP");


var $ccea95b17dc7b766$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
var $ccea95b17dc7b766$var$INTEGRATION_NAME = "BrowserApiErrors";
var $ccea95b17dc7b766$var$_browserApiErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, $hwO3w._)({
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false
    }, options);
    return {
        name: $ccea95b17dc7b766$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce: function() {
            if (_options.setTimeout) (0, $27958f6402fc5d96$export$9563e054e6f787fb)((0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81), "setTimeout", $ccea95b17dc7b766$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $27958f6402fc5d96$export$9563e054e6f787fb)((0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81), "setInterval", $ccea95b17dc7b766$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $27958f6402fc5d96$export$9563e054e6f787fb)((0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81), "requestAnimationFrame", $ccea95b17dc7b766$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81)) (0, $27958f6402fc5d96$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $ccea95b17dc7b766$var$_wrapXHR);
            var eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $ccea95b17dc7b766$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach(function(target) {
                    return $ccea95b17dc7b766$var$_wrapEventTarget(target, _options);
                });
            }
        }
    };
};
var $ccea95b17dc7b766$export$59bfe9f1c76150e = (0, $ae9d79ccde098562$export$2323046b9414659f)($ccea95b17dc7b766$var$_browserApiErrorsIntegration);
function $ccea95b17dc7b766$var$_wrapTimeFunction(original) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var originalCallback = args[0];
        args[0] = (0, $1cd11d0052bf6dc0$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: "auto.browser.browserapierrors.".concat((0, $6fde3090981c9aa7$export$aad197c7121a6651)(original))
            }
        });
        return original.apply(this, args);
    };
}
function $ccea95b17dc7b766$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $1cd11d0052bf6dc0$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $6fde3090981c9aa7$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $ccea95b17dc7b766$var$_wrapXHR(originalSend) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var xhr = this;
        var xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === "function") (0, $27958f6402fc5d96$export$9563e054e6f787fb)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $6fde3090981c9aa7$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.xhr.".concat(prop)
                    }
                };
                var originalFunction = (0, $27958f6402fc5d96$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $6fde3090981c9aa7$export$aad197c7121a6651)(originalFunction);
                return (0, $1cd11d0052bf6dc0$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $ccea95b17dc7b766$var$_wrapEventTarget(target, integrationOptions) {
    var _globalObject_target, _proto_hasOwnProperty;
    var globalObject = (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81);
    var proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
    if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, "addEventListener"))) return;
    (0, $27958f6402fc5d96$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($ccea95b17dc7b766$var$isEventListenerObject(fn)) fn.handleEvent = (0, $1cd11d0052bf6dc0$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $6fde3090981c9aa7$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch (e) {}
            if (integrationOptions.unregisterOriginalCallbacks) $ccea95b17dc7b766$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $1cd11d0052bf6dc0$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $6fde3090981c9aa7$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $27958f6402fc5d96$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
                    var originalEventHandler = fn.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch (e) {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $ccea95b17dc7b766$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $ccea95b17dc7b766$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && (typeof target === "undefined" ? "undefined" : (0, $03bAP._)(target)) === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}






var $c8ff2ab1a4059efe$export$1baa7880e357371c = (0, $ae9d79ccde098562$export$2323046b9414659f)(function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_lifecycle;
    var lifecycle = (_options_lifecycle = options.lifecycle) !== null && _options_lifecycle !== void 0 ? _options_lifecycle : "route";
    return {
        name: "BrowserSession",
        setupOnce: function() {
            if (typeof (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $be1ea91a107a1f2d$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $13be2508cc312e06$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            var initialSessionSent = false;
            (0, $748685fa29e2d24c$export$d3314d5863fc1fef)(function() {
                if (!initialSessionSent) {
                    (0, $13be2508cc312e06$export$667e7b4d445d566b)();
                    initialSessionSent = true;
                }
            });
            var isolationScope = (0, $945639585ea57ae0$export$68f3af03034c9e90)();
            var previousUser = isolationScope.getUser();
            isolationScope.addScopeListener(function(scope) {
                var maybeNewUser = scope.getUser();
                if ((previousUser === null || previousUser === void 0 ? void 0 : previousUser.id) !== (maybeNewUser === null || maybeNewUser === void 0 ? void 0 : maybeNewUser.id) || (previousUser === null || previousUser === void 0 ? void 0 : previousUser.ip_address) !== (maybeNewUser === null || maybeNewUser === void 0 ? void 0 : maybeNewUser.ip_address)) {
                    previousUser = maybeNewUser;
                    if (initialSessionSent) (0, $13be2508cc312e06$export$667e7b4d445d566b)();
                }
            });
            if (lifecycle === "route") (0, $276dfa3d97c764b4$export$3f18c56c58114e75)(function(param) {
                var from = param.from, to = param.to;
                if (from !== to) {
                    (0, $13be2508cc312e06$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $13be2508cc312e06$export$667e7b4d445d566b)();
                    initialSessionSent = true;
                }
            });
        }
    };
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");






var $6iP9u = parcelRequire("6iP9u");
function $e91d53683ecc9069$export$3f58558cf4af9c09(contexts) {
    var attrs = {};
    var response = contexts.response, profile = contexts.profile, cloud_resource = contexts.cloud_resource, culture = contexts.culture, state = contexts.state;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(cloud_resource)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $6iP9u._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                if (value != null) attrs[key] = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if ((state === null || state === void 0 ? void 0 : state.state) && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    var angular = contexts["angular"];
    if (angular) {
        var version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    var react = contexts["react"];
    if (react) {
        var version1 = react["version"];
        if (typeof version1 === "string" || typeof version1 === "number") attrs["react.version"] = version1;
    }
    return attrs;
}




function $841d10ad590254f7$export$b1e72a433efdc918(span, client) {
    var _processedSpan_attributes;
    var spanJSON = (0, $79515206909fddff$export$db0cad9e44f67af8)(span);
    var segmentSpan = (0, $79515206909fddff$export$7a3106f345d83bb6)(span);
    var serializedSegmentSpan = (0, $79515206909fddff$export$db0cad9e44f67af8)(segmentSpan);
    var _getCapturedScopesOnSpan = (0, $4ef71f79add55d26$export$c08fbc656a245d03)(span), spanIsolationScope = _getCapturedScopesOnSpan.isolationScope, spanScope = _getCapturedScopesOnSpan.scope;
    var finalScopeData = (0, $511829945c640daa$export$cc422922fcbb91c6)(spanIsolationScope, spanScope);
    $841d10ad590254f7$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    var spanKind = span.kind;
    client.emit("preprocessSpan", spanJSON, {
        spanKind: spanKind
    });
    if (spanJSON.is_segment) {
        $841d10ad590254f7$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $841d10ad590254f7$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    var beforeSendSpan = client.getOptions().beforeSendSpan;
    var processedSpan = beforeSendSpan && (0, $3a2af6feab215f7b$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? $841d10ad590254f7$export$d38dd0f511e8d9ba(spanJSON, beforeSendSpan) : spanJSON;
    var spanNameSource = (_processedSpan_attributes = processedSpan.attributes) === null || _processedSpan_attributes === void 0 ? void 0 : _processedSpan_attributes[0, $5d82adaea61c8fa9$export$d7a7d984b0791405];
    if (spanJSON.is_segment && spanNameSource) $841d10ad590254f7$export$146fcadff0eefcf3(processedSpan, (0, $dUlz9._)({}, "sentry.segment.name.source", spanNameSource));
    return (0, $lf4fc._)((0, $hwO3w._)({}, (0, $79515206909fddff$export$5402aa553bcf35f3)(processedSpan)), {
        _segmentSpan: segmentSpan
    });
}
function $841d10ad590254f7$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    var contextAttributes = (0, $e91d53683ecc9069$export$3f58558cf4af9c09)(scopeData.contexts);
    $841d10ad590254f7$export$146fcadff0eefcf3(segmentSpanJSON, contextAttributes);
}
function $841d10ad590254f7$export$146fcadff0eefcf3(spanJSON, newAttributes) {
    var _spanJSON_attributes;
    var originalAttributes = (_spanJSON_attributes = spanJSON.attributes) !== null && _spanJSON_attributes !== void 0 ? _spanJSON_attributes : spanJSON.attributes = {};
    Object.entries(newAttributes).forEach(function(param) {
        var _param = (0, $6iP9u._)(param, 2), key = _param[0], value = _param[1];
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $841d10ad590254f7$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    var integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $841d10ad590254f7$export$146fcadff0eefcf3(segmentSpanJSON, (0, $dUlz9._)({}, (0, $5d82adaea61c8fa9$export$bd847b1cc92ae587), integrationNames));
}
function $841d10ad590254f7$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    var _sdk_sdk, _sdk_sdk1, _scopeData_user, _scopeData_user1, _scopeData_user2, _scopeData_user3;
    var sdk = client.getSdkMetadata();
    var _client_getOptions = client.getOptions(), release = _client_getOptions.release, environment = _client_getOptions.environment;
    var _obj;
    $841d10ad590254f7$export$146fcadff0eefcf3(spanJSON, (0, $hwO3w._)((_obj = {}, (0, $dUlz9._)(_obj, (0, $117bb525af114730$export$ddbc15c0e8e8a7ea), "stream"), (0, $dUlz9._)(_obj, (0, $117bb525af114730$export$d4f25b923533dbba), serializedSegmentSpan.name), (0, $dUlz9._)(_obj, (0, $117bb525af114730$export$9943ffdcaa4bc506), serializedSegmentSpan.span_id), (0, $dUlz9._)(_obj, (0, $117bb525af114730$export$d59b669d4bb3f006), sdk === null || sdk === void 0 ? void 0 : (_sdk_sdk = sdk.sdk) === null || _sdk_sdk === void 0 ? void 0 : _sdk_sdk.name), (0, $dUlz9._)(_obj, (0, $117bb525af114730$export$4d88d347aa9667fc), sdk === null || sdk === void 0 ? void 0 : (_sdk_sdk1 = sdk.sdk) === null || _sdk_sdk1 === void 0 ? void 0 : _sdk_sdk1.version), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$f5cefb258679b29e), release), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$d1b1dbb47f5ba57c), environment || (0, $9926372cdabb9b15$export$849dbeeeda01ae98)), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$1f9cc1d34ea098a0), (_scopeData_user = scopeData.user) === null || _scopeData_user === void 0 ? void 0 : _scopeData_user.id), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$b7466609ef46c07e), (_scopeData_user1 = scopeData.user) === null || _scopeData_user1 === void 0 ? void 0 : _scopeData_user1.email), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$8d592bdaea63b930), (_scopeData_user2 = scopeData.user) === null || _scopeData_user2 === void 0 ? void 0 : _scopeData_user2.ip_address), (0, $dUlz9._)(_obj, (0, $5d82adaea61c8fa9$export$c05ee933d3f74b2b), (_scopeData_user3 = scopeData.user) === null || _scopeData_user3 === void 0 ? void 0 : _scopeData_user3.username), _obj), scopeData.attributes));
}
function $841d10ad590254f7$export$d38dd0f511e8d9ba(span, beforeSendSpan) {
    var modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        (0, $79515206909fddff$export$d11691ff45a3e535)();
        return span;
    }
    return modifedSpan;
}



var $35cf5f7c91ec6d5a$var$INTEGRATION_NAME = "CultureContext";
var $35cf5f7c91ec6d5a$var$_cultureContextIntegration = function() {
    return {
        name: $35cf5f7c91ec6d5a$var$INTEGRATION_NAME,
        preprocessEvent: function(event) {
            var _event_contexts;
            var culture = $35cf5f7c91ec6d5a$var$getCultureContext();
            if (culture) event.contexts = (0, $lf4fc._)((0, $hwO3w._)({}, event.contexts), {
                culture: (0, $hwO3w._)({}, culture, (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.culture)
            });
        },
        processSegmentSpan: function(span) {
            var culture = $35cf5f7c91ec6d5a$var$getCultureContext();
            if (culture) (0, $841d10ad590254f7$export$146fcadff0eefcf3)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
var $35cf5f7c91ec6d5a$export$ec5976aacdc85985 = (0, $ae9d79ccde098562$export$2323046b9414659f)($35cf5f7c91ec6d5a$var$_cultureContextIntegration);
function $35cf5f7c91ec6d5a$var$getCultureContext() {
    try {
        var intl = (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        var options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch (e) {
        return void 0;
    }
}



var $hwO3w = parcelRequire("hwO3w");




var $8534f42caefde900$var$INTEGRATION_NAME = "GlobalHandlers";
var $8534f42caefde900$var$_globalHandlersIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, $hwO3w._)({
        onerror: true,
        onunhandledrejection: true
    }, options);
    return {
        name: $8534f42caefde900$var$INTEGRATION_NAME,
        setupOnce: function() {
            Error.stackTraceLimit = 50;
        },
        setup: function(client) {
            if (_options.onerror) {
                $8534f42caefde900$var$_installGlobalOnErrorHandler(client);
                $8534f42caefde900$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $8534f42caefde900$var$_installGlobalOnUnhandledRejectionHandler(client);
                $8534f42caefde900$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
var $8534f42caefde900$export$66acc70e8cf2b71a = (0, $ae9d79ccde098562$export$2323046b9414659f)($8534f42caefde900$var$_globalHandlersIntegration);
function $8534f42caefde900$var$_installGlobalOnErrorHandler(client) {
    (0, $69a3078823a49f97$export$55b5c3ba2194f0c6)(function(data) {
        var _getOptions = $8534f42caefde900$var$getOptions(), stackParser = _getOptions.stackParser, attachStacktrace = _getOptions.attachStacktrace;
        if ((0, $945639585ea57ae0$export$6bb76d6eba7e258c)() !== client || (0, $1cd11d0052bf6dc0$export$b79738ab10c590b2)()) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        var event = $8534f42caefde900$var$_enhanceEventWithInitialFrame((0, $0ca391b57a1c7d4e$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $13be2508cc312e06$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $8534f42caefde900$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $c1b0d5acd6fef93f$export$8bf4fc6858821a4e)(function(e) {
        var _getOptions = $8534f42caefde900$var$getOptions(), stackParser = _getOptions.stackParser, attachStacktrace = _getOptions.attachStacktrace;
        if ((0, $945639585ea57ae0$export$6bb76d6eba7e258c)() !== client || (0, $1cd11d0052bf6dc0$export$b79738ab10c590b2)()) return;
        var error = $8534f42caefde900$export$b2cc40fa8241780(e);
        var event = (0, $6ea82c15e37d9720$export$c3825b437cbdea5c)(error) ? $8534f42caefde900$export$1353b5b36844a9ed(error) : (0, $0ca391b57a1c7d4e$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $13be2508cc312e06$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $8534f42caefde900$export$b2cc40fa8241780(error) {
    if ((0, $6ea82c15e37d9720$export$c3825b437cbdea5c)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch (e) {}
    return error;
}
function $8534f42caefde900$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: ".concat(String(reason))
                }
            ]
        }
    };
}
function $8534f42caefde900$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    var e = event.exception = event.exception || {};
    var ev = e.values = e.values || [];
    var ev0 = ev[0] = ev[0] || {};
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var _getFilenameFromUrl;
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: (_getFilenameFromUrl = $8534f42caefde900$var$getFilenameFromUrl(url)) !== null && _getFilenameFromUrl !== void 0 ? _getFilenameFromUrl : (0, $a7a5fd8a48375ca8$export$1cfafeee2987818b)(),
        function: (0, $6fde3090981c9aa7$export$27c7e15d453fc0ac),
        in_app: true
    });
    return event;
}
function $8534f42caefde900$var$globalHandlerLog(type) {
    (0, $be1ea91a107a1f2d$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).log("Global Handler attached: ".concat(type));
}
function $8534f42caefde900$var$getOptions() {
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    var options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {
        stackParser: function() {
            return [];
        },
        attachStacktrace: false
    };
    return options;
}
function $8534f42caefde900$var$getFilenameFromUrl(url) {
    if (!(0, $6ea82c15e37d9720$export$844ec244b1367d54)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return "<".concat((0, $82aed6a67a552ecb$export$8abd806fcaf234fa)(url, false), ">");
    return url;
}



var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");



var $69dd92e603be2999$export$1378794447170364 = (0, $ae9d79ccde098562$export$2323046b9414659f)(function() {
    return {
        name: "HttpContext",
        preprocessEvent: function(event) {
            var _event_request;
            if (!(0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).navigator && !(0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).location && !(0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).document) return;
            var reqData = (0, $1cd11d0052bf6dc0$export$a3c4a8453e8936f0)();
            var headers = (0, $hwO3w._)({}, reqData.headers, (_event_request = event.request) === null || _event_request === void 0 ? void 0 : _event_request.headers);
            event.request = (0, $lf4fc._)((0, $hwO3w._)({}, reqData, event.request), {
                headers: headers
            });
        },
        processSegmentSpan: function(span) {
            var _span_attributes;
            var spanOp = (_span_attributes = span.attributes) === null || _span_attributes === void 0 ? void 0 : _span_attributes[0, $5d82adaea61c8fa9$export$1a413bd9a88fdb09];
            if (!(0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).navigator && !(0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).location && !(0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).document) return;
            var reqData = (0, $1cd11d0052bf6dc0$export$a3c4a8453e8936f0)();
            var _obj;
            (0, $841d10ad590254f7$export$146fcadff0eefcf3)(span, (_obj = {}, // Coerce empty string to undefined so the helper's nullish check drops it,
            // rather than writing an empty `url.full` attribute onto the span.
            (0, $dUlz9._)(_obj, (0, $117bb525af114730$export$40eacf1a072c9dbd), spanOp !== "http.client" ? reqData.url : void 0), (0, $dUlz9._)(_obj, "http.request.header.user_agent", reqData.headers["User-Agent"]), (0, $dUlz9._)(_obj, "http.request.header.referer", reqData.headers["Referer"]), _obj));
        }
    };
});



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $XnYkK = parcelRequire("XnYkK");

function $f89b7f9ecc7fa256$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    var _event_exception;
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) || !hint || !(0, $6ea82c15e37d9720$export$e6127cc7fe7395c3)(hint.originalException)) return;
    var originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $f89b7f9ecc7fa256$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $f89b7f9ecc7fa256$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    var newExceptions = (0, $XnYkK._)(prevExceptions);
    if ((0, $6ea82c15e37d9720$export$e6127cc7fe7395c3)(error[key])) {
        $f89b7f9ecc7fa256$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        var newException = exceptionFromErrorImplementation(parser, error[key]);
        var newExceptionId = newExceptions.length;
        $f89b7f9ecc7fa256$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $f89b7f9ecc7fa256$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException
        ].concat((0, $XnYkK._)(newExceptions)), newException, newExceptionId);
    }
    if ($f89b7f9ecc7fa256$var$isExceptionGroup(error)) error.errors.forEach(function(childError, i) {
        if ((0, $6ea82c15e37d9720$export$e6127cc7fe7395c3)(childError)) {
            $f89b7f9ecc7fa256$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            var newException = exceptionFromErrorImplementation(parser, childError);
            var newExceptionId = newExceptions.length;
            $f89b7f9ecc7fa256$var$applyExceptionGroupFieldsForChildException(newException, "errors[".concat(i, "]"), newExceptionId, exceptionId);
            newExceptions = $f89b7f9ecc7fa256$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException
            ].concat((0, $XnYkK._)(newExceptions)), newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $f89b7f9ecc7fa256$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $f89b7f9ecc7fa256$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = (0, $lf4fc._)((0, $hwO3w._)({
        handled: true,
        type: "auto.core.linked_errors"
    }, $f89b7f9ecc7fa256$var$isExceptionGroup(error) && {
        is_exception_group: true
    }, exception.mechanism), {
        exception_id: exceptionId
    });
}
function $f89b7f9ecc7fa256$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = (0, $lf4fc._)((0, $hwO3w._)({
        handled: true
    }, exception.mechanism), {
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}



var $af3fc8ec6f870e07$var$DEFAULT_KEY = "cause";
var $af3fc8ec6f870e07$var$DEFAULT_LIMIT = 5;
var $af3fc8ec6f870e07$var$INTEGRATION_NAME = "LinkedErrors";
var $af3fc8ec6f870e07$var$_linkedErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var limit = options.limit || $af3fc8ec6f870e07$var$DEFAULT_LIMIT;
    var key = options.key || $af3fc8ec6f870e07$var$DEFAULT_KEY;
    return {
        name: $af3fc8ec6f870e07$var$INTEGRATION_NAME,
        preprocessEvent: function(event, hint, client) {
            var options2 = client.getOptions();
            (0, $f89b7f9ecc7fa256$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $0ca391b57a1c7d4e$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
var $af3fc8ec6f870e07$export$ebabb00eb7f3a395 = (0, $ae9d79ccde098562$export$2323046b9414659f)($af3fc8ec6f870e07$var$_linkedErrorsIntegration);



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");

var $23d1d535cb1f7fe1$var$OPERA10_PRIORITY = 10;
var $23d1d535cb1f7fe1$var$OPERA11_PRIORITY = 20;
var $23d1d535cb1f7fe1$var$CHROME_PRIORITY = 30;
var $23d1d535cb1f7fe1$var$WINJS_PRIORITY = 40;
var $23d1d535cb1f7fe1$var$GECKO_PRIORITY = 50;
function $23d1d535cb1f7fe1$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $6fde3090981c9aa7$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
var $23d1d535cb1f7fe1$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
var $23d1d535cb1f7fe1$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $23d1d535cb1f7fe1$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $23d1d535cb1f7fe1$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
var $23d1d535cb1f7fe1$var$chromeStackParserFn = function(line) {
    var dataUriMatch = line.match($23d1d535cb1f7fe1$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: "<data:".concat(dataUriMatch[2], ">"),
        function: dataUriMatch[1]
    };
    var noFnParts = $23d1d535cb1f7fe1$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        var _noFnParts = (0, $6iP9u._)(noFnParts, 4), filename = _noFnParts[1], line2 = _noFnParts[2], col = _noFnParts[3];
        return $23d1d535cb1f7fe1$var$createFrame(filename, (0, $6fde3090981c9aa7$export$27c7e15d453fc0ac), +line2, +col);
    }
    var parts = $23d1d535cb1f7fe1$var$chromeRegex.exec(line);
    if (parts) {
        var _parts_;
        var isEval = ((_parts_ = parts[2]) === null || _parts_ === void 0 ? void 0 : _parts_.indexOf("eval")) === 0;
        if (isEval) {
            var subMatch = $23d1d535cb1f7fe1$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        var _extractSafariExtensionDetails = (0, $6iP9u._)($23d1d535cb1f7fe1$var$extractSafariExtensionDetails(parts[1] || (0, $6fde3090981c9aa7$export$27c7e15d453fc0ac), parts[2]), 2), func = _extractSafariExtensionDetails[0], filename1 = _extractSafariExtensionDetails[1];
        return $23d1d535cb1f7fe1$var$createFrame(filename1, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
var $23d1d535cb1f7fe1$export$263a749fff749872 = [
    $23d1d535cb1f7fe1$var$CHROME_PRIORITY,
    $23d1d535cb1f7fe1$var$chromeStackParserFn
];
var $23d1d535cb1f7fe1$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $23d1d535cb1f7fe1$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $23d1d535cb1f7fe1$var$gecko = function(line) {
    var parts = $23d1d535cb1f7fe1$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            var subMatch = $23d1d535cb1f7fe1$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        var filename = parts[3];
        var func = parts[1] || (0, $6fde3090981c9aa7$export$27c7e15d453fc0ac);
        var ref;
        ref = (0, $6iP9u._)($23d1d535cb1f7fe1$var$extractSafariExtensionDetails(func, filename), 2), func = ref[0], filename = ref[1], ref;
        return $23d1d535cb1f7fe1$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
var $23d1d535cb1f7fe1$export$cdba47a5dd2804d = [
    $23d1d535cb1f7fe1$var$GECKO_PRIORITY,
    $23d1d535cb1f7fe1$var$gecko
];
var $23d1d535cb1f7fe1$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $23d1d535cb1f7fe1$var$winjs = function(line) {
    var parts = $23d1d535cb1f7fe1$var$winjsRegex.exec(line);
    return parts ? $23d1d535cb1f7fe1$var$createFrame(parts[2], parts[1] || (0, $6fde3090981c9aa7$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
var $23d1d535cb1f7fe1$export$179460296da408e8 = [
    $23d1d535cb1f7fe1$var$WINJS_PRIORITY,
    $23d1d535cb1f7fe1$var$winjs
];
var $23d1d535cb1f7fe1$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $23d1d535cb1f7fe1$var$opera10 = function(line) {
    var parts = $23d1d535cb1f7fe1$var$opera10Regex.exec(line);
    return parts ? $23d1d535cb1f7fe1$var$createFrame(parts[2], parts[3] || (0, $6fde3090981c9aa7$export$27c7e15d453fc0ac), +parts[1]) : void 0;
};
var $23d1d535cb1f7fe1$export$f892b52c880ffc7a = [
    $23d1d535cb1f7fe1$var$OPERA10_PRIORITY,
    $23d1d535cb1f7fe1$var$opera10
];
var $23d1d535cb1f7fe1$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $23d1d535cb1f7fe1$var$opera11 = function(line) {
    var parts = $23d1d535cb1f7fe1$var$opera11Regex.exec(line);
    return parts ? $23d1d535cb1f7fe1$var$createFrame(parts[5], parts[3] || parts[4] || (0, $6fde3090981c9aa7$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : void 0;
};
var $23d1d535cb1f7fe1$export$af11af13f09fb0dc = [
    $23d1d535cb1f7fe1$var$OPERA11_PRIORITY,
    $23d1d535cb1f7fe1$var$opera11
];
var $23d1d535cb1f7fe1$export$7197c0fe6554c079 = [
    $23d1d535cb1f7fe1$export$263a749fff749872,
    $23d1d535cb1f7fe1$export$cdba47a5dd2804d
];
var $23d1d535cb1f7fe1$export$2b2b997d81bf3907 = (0, $6fde3090981c9aa7$export$a5739666fb2d03d4).apply(void 0, (0, $XnYkK._)($23d1d535cb1f7fe1$export$7197c0fe6554c079));
var $23d1d535cb1f7fe1$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf("safari-extension") !== -1;
    var isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $6fde3090981c9aa7$export$27c7e15d453fc0ac),
        isSafariExtension ? "safari-extension:".concat(filename) : "safari-web-extension:".concat(filename)
    ] : [
        func,
        filename
    ];
};



var $lFIaz = parcelRequire("lFIaz");

var $hwO3w = parcelRequire("hwO3w");

var $3SMYb = parcelRequire("3SMYb");


var $XnYkK = parcelRequire("XnYkK");



var $d26b11a6b11dd4e3$var$cachedImplementations = {};
function $d26b11a6b11dd4e3$export$e464f4a514ac28a8(name) {
    var cached = $d26b11a6b11dd4e3$var$cachedImplementations[name];
    if (cached) return cached;
    var impl = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81)[name];
    if ((0, $4a1dfae2c7f98a76$export$d5f608b368e73f38)(impl)) return $d26b11a6b11dd4e3$var$cachedImplementations[name] = impl.bind((0, $e171b0a71a8711b0$export$56d8a8a25bd48b81));
    var document = (0, $e171b0a71a8711b0$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        var sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow === null || contentWindow === void 0 ? void 0 : contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $f4443e0779e1b74f$export$16a28057038b10ef) && (0, $739716ea0436a6d0$export$1c9f709888824e05).warn("Could not create sandbox iframe for ".concat(name, " check, bailing to window.").concat(name, ": "), e);
    }
    if (!impl) return impl;
    return $d26b11a6b11dd4e3$var$cachedImplementations[name] = impl.bind((0, $e171b0a71a8711b0$export$56d8a8a25bd48b81));
}
function $d26b11a6b11dd4e3$export$8aa36702e8c8978(name) {
    $d26b11a6b11dd4e3$var$cachedImplementations[name] = void 0;
}
function $d26b11a6b11dd4e3$export$e7aa7bc5c1b3cfb3() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return $d26b11a6b11dd4e3$export$e464f4a514ac28a8("fetch").apply(this, (0, $XnYkK._)(rest));
}
function $d26b11a6b11dd4e3$export$831dc9f2ab0a617b() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return $d26b11a6b11dd4e3$export$e464f4a514ac28a8("setTimeout").apply(this, (0, $XnYkK._)(rest));
}


var $af726a156467f3de$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $af726a156467f3de$export$b2311068c46d7cc8(options) {
    var nativeFetch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $d26b11a6b11dd4e3$export$e464f4a514ac28a8)("fetch");
    var pendingBodySize = 0;
    var pendingCount = 0;
    function makeRequest(request) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var requestSize, requestOptions, response, e;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestSize = request.body.length;
                        pendingBodySize += requestSize;
                        pendingCount++;
                        requestOptions = (0, $hwO3w._)({
                            body: request.body,
                            method: "POST",
                            referrerPolicy: "strict-origin",
                            headers: options.headers,
                            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
                            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
                            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
                            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
                            // Gotchas:
                            // - `keepalive` isn't supported by Firefox
                            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
                            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
                            //   We will therefore only activate the flag when we're below that limit.
                            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
                            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
                            keepalive: pendingBodySize <= 6e4 && pendingCount < 15
                        }, options.fetchOptions);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            nativeFetch(options.url, requestOptions)
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            2,
                            {
                                statusCode: response.status,
                                headers: {
                                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                                    "retry-after": response.headers.get("Retry-After")
                                }
                            }
                        ];
                    case 3:
                        e = _state.sent();
                        (0, $d26b11a6b11dd4e3$export$8aa36702e8c8978)("fetch");
                        throw e;
                    case 4:
                        pendingBodySize -= requestSize;
                        pendingCount--;
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    return (0, $be3155eb10c5dfe8$export$d09f50d9ab7f7b69)(options, makeRequest, (0, $4dd019c4733e4c95$export$85a4f67f852183e6)(options.bufferSize || $af726a156467f3de$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}


function $afaf13b1f6796d14$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch (e) {
        return false;
    }
}


var $f662c92ea14d0b0c$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $f662c92ea14d0b0c$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $afaf13b1f6796d14$export$45a5e7f76e0caa8d)(value)) {
        var objName = $f662c92ea14d0b0c$var$getConstructorName(value);
        if ($f662c92ea14d0b0c$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return "[HTMLElement: ".concat((0, $bf34547bb00b7a11$export$5647df6b7814ac86)(value), "]");
    }
    return void 0;
}
function $f662c92ea14d0b0c$var$getConstructorName(value) {
    var prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === void 0 ? void 0 : prototype.constructor) ? prototype.constructor.name : "null prototype";
}





function $9aca4e52d8371441$export$dc236a86065879fc() {
    if ($9aca4e52d8371441$var$_isEmbeddedBrowserExtension()) {
        if (0, $be1ea91a107a1f2d$export$16a28057038b10ef) (0, $739716ea0436a6d0$export$cda52e2a8927a2ca)(function() {
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $9aca4e52d8371441$var$_isEmbeddedBrowserExtension() {
    var _extensionObject_runtime;
    if (typeof (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).window === "undefined") return false;
    var _window = (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    var extensionObject = _window["chrome"] || _window["browser"];
    if (!(extensionObject === null || extensionObject === void 0 ? void 0 : (_extensionObject_runtime = extensionObject.runtime) === null || _extensionObject_runtime === void 0 ? void 0 : _extensionObject_runtime.id)) return false;
    var href = (0, $a7a5fd8a48375ca8$export$1cfafeee2987818b)();
    var isDedicatedExtensionPage = (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81) === (0, $1cd11d0052bf6dc0$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $89e260b1934c8a35$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line typescript/no-deprecated
        (0, $5494988c597a6bde$export$cb3c5c2ceb9818ba)(),
        (0, $e98db35b10cdc088$export$7918117e9202e4fb)(),
        (0, $02a846f0710b4f05$export$97457a453081a5b3)(),
        (0, $ccea95b17dc7b766$export$59bfe9f1c76150e)(),
        (0, $6272a28fde91a87f$export$c079d904b326663a)(),
        (0, $8534f42caefde900$export$66acc70e8cf2b71a)(),
        (0, $af3fc8ec6f870e07$export$ebabb00eb7f3a395)(),
        (0, $7bd9acb9c2c62d7c$export$6d39aa44cd0c7567)(),
        (0, $69dd92e603be2999$export$1378794447170364)(),
        (0, $35cf5f7c91ec6d5a$export$ec5976aacdc85985)(),
        (0, $c8ff2ab1a4059efe$export$1baa7880e357371c)()
    ];
}
function $89e260b1934c8a35$export$2cd8252107eb640b() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $9aca4e52d8371441$export$dc236a86065879fc)();
    var defaultIntegrations = options.defaultIntegrations == null ? $89e260b1934c8a35$export$5783b2920b1d62b9() : options.defaultIntegrations;
    var clientOptions = (0, $lf4fc._)((0, $hwO3w._)({}, options), {
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $6fde3090981c9aa7$export$1d5cf88b347146d4)(options.stackParser || (0, $23d1d535cb1f7fe1$export$2b2b997d81bf3907)),
        integrations: (0, $ae9d79ccde098562$export$68bc4c01ab8ae766)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $af726a156467f3de$export$b2311068c46d7cc8)
    });
    (0, $74542fb861c25274$export$575c40989754ba4d)((0, $f662c92ea14d0b0c$export$4c88c355e6072df5));
    return (0, $8176758402f871e0$export$5333c3f1c58d9bc1)((0, $6e9b8a2430dc83f5$export$1df9218a526d318d), clientOptions);
}
function $89e260b1934c8a35$export$a3f323d81eede727() {}
function $89e260b1934c8a35$export$4e4d8b287d028b6b(callback) {
    callback();
}




var $5s1kH = parcelRequire("5s1kH");

function $b80227864803ca37$export$bc2894c7158efbac(wat) {
    return (0, $6ea82c15e37d9720$export$53b83ca8eaab0383)(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}


function $e2a44b5d0c19e6d4$export$2cd8252107eb640b(options) {
    var opts = (0, $hwO3w._)({}, options);
    (0, $bd839e84f4db6244$export$b9f95b027256052c)(opts, "react");
    (0, $13be2508cc312e06$export$2f04de43fe27971a)("react", {
        version: (0, $5s1kH.version)
    });
    var client = (0, $89e260b1934c8a35$export$2cd8252107eb640b)(opts);
    (0, $74542fb861c25274$export$575c40989754ba4d)($e2a44b5d0c19e6d4$var$normalizeStringifyValue);
    return client;
}
function $e2a44b5d0c19e6d4$var$normalizeStringifyValue(value) {
    if ((0, $b80227864803ca37$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
    return (0, $f662c92ea14d0b0c$export$4c88c355e6072df5)(value);
}


var $lFIaz = parcelRequire("lFIaz");

var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $4QAx6 = parcelRequire("4QAx6");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");

var $03bAP = parcelRequire("03bAP");

var $kW1tL = parcelRequire("kW1tL");

var $3SMYb = parcelRequire("3SMYb");
function $8024b451d4a557ac$export$61fc7d43ac8f84b0(func, wait, options) {
    var callbackReturnValue;
    var timerId;
    var maxTimerId;
    var maxWait = (options === null || options === void 0 ? void 0 : options.maxWait) ? Math.max(options.maxWait, wait) : 0;
    var setTimeoutImpl = (options === null || options === void 0 ? void 0 : options.setTimeoutImpl) || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}


function $ba7ca353ce9a90d4$export$d92e61f5600202af(url, client) {
    var dsn = client === null || client === void 0 ? void 0 : client.getDsn();
    var tunnel = client === null || client === void 0 ? void 0 : client.getOptions().tunnel;
    return $ba7ca353ce9a90d4$var$checkDsn(url, dsn) || $ba7ca353ce9a90d4$var$checkTunnel(url, tunnel);
}
function $ba7ca353ce9a90d4$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $ba7ca353ce9a90d4$var$removeTrailingSlash(url) === $ba7ca353ce9a90d4$var$removeTrailingSlash(tunnel);
}
function $ba7ca353ce9a90d4$var$checkDsn(url, dsn) {
    var urlParts = (0, $82aed6a67a552ecb$export$2004d912a9ead694)(url);
    if (!urlParts || (0, $82aed6a67a552ecb$export$e258e13805402ba7)(urlParts)) return false;
    if (!dsn) return false;
    return $ba7ca353ce9a90d4$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $ba7ca353ce9a90d4$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(".".concat(dsnHost));
}
function $ba7ca353ce9a90d4$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}



var $dbab849fc0bcf4ad$var$WINDOW = (0, $6001140c9a325157$export$f1a6cdb1459e81d1);
var $dbab849fc0bcf4ad$var$REPLAY_SESSION_KEY = "sentryReplaySession";
var $dbab849fc0bcf4ad$var$REPLAY_EVENT_NAME = "replay_event";
var $dbab849fc0bcf4ad$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
var $dbab849fc0bcf4ad$var$SESSION_IDLE_PAUSE_DURATION = 3e5;
var $dbab849fc0bcf4ad$var$SESSION_IDLE_EXPIRE_DURATION = 9e5;
var $dbab849fc0bcf4ad$var$DEFAULT_FLUSH_MIN_DELAY = 5e3;
var $dbab849fc0bcf4ad$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
var $dbab849fc0bcf4ad$var$BUFFER_CHECKOUT_TIME = 6e4;
var $dbab849fc0bcf4ad$var$RETRY_BASE_INTERVAL = 5e3;
var $dbab849fc0bcf4ad$var$RETRY_MAX_COUNT = 3;
var $dbab849fc0bcf4ad$var$NETWORK_BODY_MAX_SIZE = 15e4;
var $dbab849fc0bcf4ad$var$CONSOLE_ARG_MAX_SIZE = 5e3;
var $dbab849fc0bcf4ad$var$SLOW_CLICK_THRESHOLD = 3e3;
var $dbab849fc0bcf4ad$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
var $dbab849fc0bcf4ad$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 2e7;
var $dbab849fc0bcf4ad$var$MIN_REPLAY_DURATION = 4999;
var $dbab849fc0bcf4ad$var$MIN_REPLAY_DURATION_LIMIT = 5e4;
var $dbab849fc0bcf4ad$var$MAX_REPLAY_DURATION = 36e5;
var $dbab849fc0bcf4ad$var$__defProp = Object.defineProperty;
var $dbab849fc0bcf4ad$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $dbab849fc0bcf4ad$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $dbab849fc0bcf4ad$var$__publicField = function(obj, key, value) {
    return $dbab849fc0bcf4ad$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $03bAP._)(key)) !== "symbol" ? key + "" : key, value);
};
var $dbab849fc0bcf4ad$var$NodeType$1 = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}($dbab849fc0bcf4ad$var$NodeType$1 || {});
function $dbab849fc0bcf4ad$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $dbab849fc0bcf4ad$var$isShadowRoot(n) {
    var host = n === null || n === void 0 ? void 0 : n.host;
    return Boolean((host === null || host === void 0 ? void 0 : host.shadowRoot) === n);
}
function $dbab849fc0bcf4ad$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $dbab849fc0bcf4ad$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $dbab849fc0bcf4ad$var$escapeImportStatement(rule) {
    var cssText = rule.cssText;
    if (cssText.split('"').length < 3) return cssText;
    var statement = [
        "@import",
        "url(".concat(JSON.stringify(rule.href), ")")
    ];
    if (rule.layerName === "") statement.push("layer");
    else if (rule.layerName) statement.push("layer(".concat(rule.layerName, ")"));
    if (rule.supportsText) statement.push("supports(".concat(rule.supportsText, ")"));
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $dbab849fc0bcf4ad$var$stringifyStylesheet(s) {
    try {
        var rules = s.rules || s.cssRules;
        return rules ? $dbab849fc0bcf4ad$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $dbab849fc0bcf4ad$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $dbab849fc0bcf4ad$var$fixAllCssProperty(rule) {
    var styles = "";
    for(var i2 = 0; i2 < rule.style.length; i2++){
        var styleDeclaration = rule.style;
        var attribute = styleDeclaration[i2];
        var isImportant = styleDeclaration.getPropertyPriority(attribute);
        styles += "".concat(attribute, ":").concat(styleDeclaration.getPropertyValue(attribute)).concat(isImportant ? " !important" : "", ";");
    }
    return "".concat(rule.selectorText, " { ").concat(styles, " }");
}
function $dbab849fc0bcf4ad$var$stringifyRule(rule) {
    var importStringified;
    if ($dbab849fc0bcf4ad$var$isCSSImportRule(rule)) try {
        importStringified = // we can access the imported stylesheet rules directly
        $dbab849fc0bcf4ad$var$stringifyStylesheet(rule.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
        $dbab849fc0bcf4ad$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($dbab849fc0bcf4ad$var$isCSSStyleRule(rule)) {
        var cssText = rule.cssText;
        var needsSafariColonFix = rule.selectorText.includes(":");
        var needsAllFix = typeof rule.style["all"] === "string" && rule.style["all"];
        if (needsAllFix) cssText = $dbab849fc0bcf4ad$var$fixAllCssProperty(rule);
        if (needsSafariColonFix) cssText = $dbab849fc0bcf4ad$var$fixSafariColons(cssText);
        if (needsSafariColonFix || needsAllFix) return cssText;
    }
    return importStringified || rule.cssText;
}
function $dbab849fc0bcf4ad$var$fixSafariColons(cssStringified) {
    var regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $dbab849fc0bcf4ad$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $dbab849fc0bcf4ad$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
var $dbab849fc0bcf4ad$var$Mirror = /*#__PURE__*/ function() {
    "use strict";
    function Mirror() {
        (0, $5Epmf._)(this, Mirror);
        $dbab849fc0bcf4ad$var$__publicField(this, "idNodeMap", /* @__PURE__ */ new Map());
        $dbab849fc0bcf4ad$var$__publicField(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    (0, $9MqXK._)(Mirror, [
        {
            key: "getId",
            value: function getId(n) {
                var _this_getMeta;
                if (!n) return -1;
                var id = (_this_getMeta = this.getMeta(n)) === null || _this_getMeta === void 0 ? void 0 : _this_getMeta.id;
                return id !== null && id !== void 0 ? id : -1;
            }
        },
        {
            key: "getNode",
            value: function getNode(id) {
                return this.idNodeMap.get(id) || null;
            }
        },
        {
            key: "getIds",
            value: function getIds() {
                return Array.from(this.idNodeMap.keys());
            }
        },
        {
            key: "getMeta",
            value: function getMeta(n) {
                return this.nodeMetaMap.get(n) || null;
            }
        },
        {
            // removes the node from idNodeMap
            // doesn't remove the node from nodeMetaMap
            key: "removeNodeFromMap",
            value: function removeNodeFromMap(n) {
                var _this = this;
                var id = this.getId(n);
                this.idNodeMap.delete(id);
                if (n.childNodes) n.childNodes.forEach(function(childNode) {
                    return _this.removeNodeFromMap(childNode);
                });
            }
        },
        {
            key: "has",
            value: function has(id) {
                return this.idNodeMap.has(id);
            }
        },
        {
            key: "hasNode",
            value: function hasNode(node) {
                return this.nodeMetaMap.has(node);
            }
        },
        {
            key: "add",
            value: function add(n, meta) {
                var id = meta.id;
                this.idNodeMap.set(id, n);
                this.nodeMetaMap.set(n, meta);
            }
        },
        {
            key: "replace",
            value: function replace(id, n) {
                var oldNode = this.getNode(id);
                if (oldNode) {
                    var meta = this.nodeMetaMap.get(oldNode);
                    if (meta) this.nodeMetaMap.set(n, meta);
                }
                this.idNodeMap.set(id, n);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.idNodeMap = /* @__PURE__ */ new Map();
                this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
            }
        }
    ]);
    return Mirror;
}();
function $dbab849fc0bcf4ad$var$createMirror() {
    return new $dbab849fc0bcf4ad$var$Mirror();
}
function $dbab849fc0bcf4ad$var$shouldMaskInput(param) {
    var maskInputOptions = param.maskInputOptions, tagName = param.tagName, type = param.type;
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || // Default to "text" option for inputs without a "type" attribute defined
    tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $dbab849fc0bcf4ad$var$maskInputValue(param) {
    var isMasked = param.isMasked, element = param.element, value = param.value, maskInputFn = param.maskInputFn;
    var text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $dbab849fc0bcf4ad$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $dbab849fc0bcf4ad$var$toUpperCase(str) {
    return str.toUpperCase();
}
var $dbab849fc0bcf4ad$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $dbab849fc0bcf4ad$var$is2DCanvasBlank(canvas) {
    var ctx = canvas.getContext("2d");
    if (!ctx) return true;
    var chunkSize = 50;
    for(var x = 0; x < canvas.width; x += chunkSize)for(var y = 0; y < canvas.height; y += chunkSize){
        var getImageData = ctx.getImageData;
        var originalGetImageData = $dbab849fc0bcf4ad$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$dbab849fc0bcf4ad$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        var pixelBuffer = new Uint32Array(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some(function(pixel) {
            return pixel !== 0;
        })) return false;
    }
    return true;
}
function $dbab849fc0bcf4ad$var$getInputType(element) {
    var type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    $dbab849fc0bcf4ad$var$toLowerCase(type) : null;
}
function $dbab849fc0bcf4ad$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
function $dbab849fc0bcf4ad$var$extractFileExtension(path, baseURL) {
    var url;
    try {
        url = new URL(path, baseURL !== null && baseURL !== void 0 ? baseURL : window.location.href);
    } catch (err) {
        return null;
    }
    var regex = /\.([0-9a-z]+)(?:$)/i;
    var match = url.pathname.match(regex);
    var _match_;
    return (_match_ = match === null || match === void 0 ? void 0 : match[1]) !== null && _match_ !== void 0 ? _match_ : null;
}
var $dbab849fc0bcf4ad$var$cachedImplementations$1 = {};
function $dbab849fc0bcf4ad$var$getImplementation$1(name) {
    var cached = $dbab849fc0bcf4ad$var$cachedImplementations$1[name];
    if (cached) return cached;
    var document2 = window.document;
    var impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        var sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e) {}
    return $dbab849fc0bcf4ad$var$cachedImplementations$1[name] = impl.bind(window);
}
function $dbab849fc0bcf4ad$var$setTimeout$1() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return $dbab849fc0bcf4ad$var$getImplementation$1("setTimeout").apply(this, (0, $XnYkK._)(rest));
}
function $dbab849fc0bcf4ad$var$clearTimeout$1() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return $dbab849fc0bcf4ad$var$getImplementation$1("clearTimeout").apply(this, (0, $XnYkK._)(rest));
}
function $dbab849fc0bcf4ad$var$getIFrameContentDocument$1(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e) {}
}
function $dbab849fc0bcf4ad$var$getIFrameContentWindow$1(iframe) {
    try {
        return iframe.contentWindow;
    } catch (e) {}
}
var $dbab849fc0bcf4ad$var$_id = 1;
var $dbab849fc0bcf4ad$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
var $dbab849fc0bcf4ad$var$IGNORED_NODE = -2;
function $dbab849fc0bcf4ad$var$genId() {
    return $dbab849fc0bcf4ad$var$_id++;
}
function $dbab849fc0bcf4ad$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    var processedTagName = $dbab849fc0bcf4ad$var$toLowerCase(element.tagName);
    if ($dbab849fc0bcf4ad$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $dbab849fc0bcf4ad$var$extractOrigin(url) {
    var origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
var $dbab849fc0bcf4ad$var$canvasService;
var $dbab849fc0bcf4ad$var$canvasCtx;
var $dbab849fc0bcf4ad$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
var $dbab849fc0bcf4ad$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
var $dbab849fc0bcf4ad$var$URL_WWW_MATCH = /^www\..*/i;
var $dbab849fc0bcf4ad$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $dbab849fc0bcf4ad$var$filterCSSPropertiesFromInlineStyle(cssText, ignoredProperties) {
    if (!cssText || ignoredProperties.size === 0) return cssText;
    try {
        var properties = cssText.split(";");
        var filteredProperties = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                property = property.trim();
                if (!property) continue;
                var colonIndex = property.indexOf(":");
                if (colonIndex === -1) {
                    filteredProperties.push(property);
                    continue;
                }
                var propertyName = property.slice(0, colonIndex).trim();
                if (!ignoredProperties.has(propertyName)) filteredProperties.push(property);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return filteredProperties.join("; ") + (filteredProperties.length > 0 && cssText.endsWith(";") ? ";" : "");
    } catch (error) {
        console.warn("Error filtering CSS properties:", error);
        return cssText;
    }
}
function $dbab849fc0bcf4ad$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($dbab849fc0bcf4ad$var$URL_IN_CSS_REF, function(origin, quote1, path1, quote2, path2, path3) {
        var filePath = path1 || path2 || path3;
        var maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($dbab849fc0bcf4ad$var$URL_PROTOCOL_MATCH.test(filePath) || $dbab849fc0bcf4ad$var$URL_WWW_MATCH.test(filePath)) return "url(".concat(maybeQuote).concat(filePath).concat(maybeQuote, ")");
        if ($dbab849fc0bcf4ad$var$DATA_URI.test(filePath)) return "url(".concat(maybeQuote).concat(filePath).concat(maybeQuote, ")");
        if (filePath[0] === "/") return "url(".concat(maybeQuote).concat($dbab849fc0bcf4ad$var$extractOrigin(href) + filePath).concat(maybeQuote, ")");
        var stack = href.split("/");
        var parts = filePath.split("/");
        stack.pop();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var part = _step.value;
                if (part === ".") continue;
                else if (part === "..") stack.pop();
                else stack.push(part);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return "url(".concat(maybeQuote).concat(stack.join("/")).concat(maybeQuote, ")");
    });
}
var $dbab849fc0bcf4ad$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
var $dbab849fc0bcf4ad$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $dbab849fc0bcf4ad$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    var pos = 0;
    function collectCharacters(regEx) {
        var chars2;
        var match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    var output = [];
    while(true){
        collectCharacters($dbab849fc0bcf4ad$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        var url = collectCharacters($dbab849fc0bcf4ad$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $dbab849fc0bcf4ad$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            var descriptorsStr = "";
            url = $dbab849fc0bcf4ad$var$absoluteToDoc(doc, url);
            var inParens = false;
            while(true){
                var c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
var $dbab849fc0bcf4ad$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $dbab849fc0bcf4ad$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $dbab849fc0bcf4ad$var$getHref(doc, attributeValue);
}
function $dbab849fc0bcf4ad$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $dbab849fc0bcf4ad$var$getHref(doc, customHref) {
    var a = $dbab849fc0bcf4ad$var$cachedDocument.get(doc);
    if (!a) {
        a = doc.createElement("a");
        $dbab849fc0bcf4ad$var$cachedDocument.set(doc, a);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a.setAttribute("href", customHref);
    return a.href;
}
function $dbab849fc0bcf4ad$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn, ignoreCSSAttributes) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $dbab849fc0bcf4ad$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $dbab849fc0bcf4ad$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $dbab849fc0bcf4ad$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $dbab849fc0bcf4ad$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") {
        var processedStyle = $dbab849fc0bcf4ad$var$absoluteToStylesheet(value, $dbab849fc0bcf4ad$var$getHref(doc));
        if (ignoreCSSAttributes && ignoreCSSAttributes.size > 0) processedStyle = $dbab849fc0bcf4ad$var$filterCSSPropertiesFromInlineStyle(processedStyle, ignoreCSSAttributes);
        return processedStyle;
    } else if (tagName === "object" && name === "data") return $dbab849fc0bcf4ad$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $dbab849fc0bcf4ad$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $dbab849fc0bcf4ad$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(var eIndex = element.classList.length; eIndex--;){
            var className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $dbab849fc0bcf4ad$var$elementClassMatchesRegex(el, regex) {
    for(var eIndex = el.classList.length; eIndex--;){
        var className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $dbab849fc0bcf4ad$var$distanceToMatch(node, matchPredicate) {
    var limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, distance = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $dbab849fc0bcf4ad$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $dbab849fc0bcf4ad$var$createMatchPredicate(className, selector) {
    return function(node) {
        var el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(".".concat(className))) return true;
                } else if ($dbab849fc0bcf4ad$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e) {
            return false;
        }
    };
}
function $dbab849fc0bcf4ad$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            var autocomplete = el.getAttribute("autocomplete");
            var disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        var maskDistance = -1;
        var unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $dbab849fc0bcf4ad$var$distanceToMatch(el, $dbab849fc0bcf4ad$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $dbab849fc0bcf4ad$var$distanceToMatch(el, $dbab849fc0bcf4ad$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $dbab849fc0bcf4ad$var$distanceToMatch(el, $dbab849fc0bcf4ad$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $dbab849fc0bcf4ad$var$distanceToMatch(el, $dbab849fc0bcf4ad$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $dbab849fc0bcf4ad$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    var win = $dbab849fc0bcf4ad$var$getIFrameContentWindow$1(iframeEl);
    if (!win) return;
    var fired = false;
    var readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        var timer = $dbab849fc0bcf4ad$var$setTimeout$1(function() {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", function() {
            $dbab849fc0bcf4ad$var$clearTimeout$1(timer);
            fired = true;
            listener();
        });
        return;
    }
    var blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        $dbab849fc0bcf4ad$var$setTimeout$1(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $dbab849fc0bcf4ad$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    var fired = false;
    var styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        styleSheetLoaded = null;
    }
    if (styleSheetLoaded) return;
    var timer = $dbab849fc0bcf4ad$var$setTimeout$1(function() {
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", function() {
        $dbab849fc0bcf4ad$var$clearTimeout$1(timer);
        fired = true;
        listener();
    });
}
function $dbab849fc0bcf4ad$var$serializeNode(n, options) {
    var doc = options.doc, mirror = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, unblockSelector = options.unblockSelector, maskAllText = options.maskAllText, maskAttributeFn = options.maskAttributeFn, maskTextClass = options.maskTextClass, unmaskTextClass = options.unmaskTextClass, maskTextSelector = options.maskTextSelector, unmaskTextSelector = options.unmaskTextSelector, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, ignoreCSSAttributes = options.ignoreCSSAttributes;
    var rootId = $dbab849fc0bcf4ad$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $dbab849fc0bcf4ad$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $dbab849fc0bcf4ad$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $dbab849fc0bcf4ad$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $dbab849fc0bcf4ad$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
        case n.TEXT_NODE:
            return $dbab849fc0bcf4ad$var$serializeTextNode(n, {
                doc: doc,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $dbab849fc0bcf4ad$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $dbab849fc0bcf4ad$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $dbab849fc0bcf4ad$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return void 0;
    var docId = mirror.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $dbab849fc0bcf4ad$var$serializeTextNode(n, options) {
    var maskAllText = options.maskAllText, maskTextClass = options.maskTextClass, unmaskTextClass = options.unmaskTextClass, maskTextSelector = options.maskTextSelector, unmaskTextSelector = options.unmaskTextSelector, maskTextFn = options.maskTextFn, maskInputOptions = options.maskInputOptions, maskInputFn = options.maskInputFn, rootId = options.rootId;
    var parentTagName = n.parentNode && n.parentNode.tagName;
    var textContent = n.textContent;
    var isStyle = parentTagName === "STYLE" ? true : void 0;
    var isScript = parentTagName === "SCRIPT" ? true : void 0;
    var isTextarea = parentTagName === "TEXTAREA" ? true : void 0;
    if (isStyle && textContent) {
        try {
            var _n_parentNode_sheet;
            if (n.nextSibling || n.previousSibling) ;
            else if ((_n_parentNode_sheet = n.parentNode.sheet) === null || _n_parentNode_sheet === void 0 ? void 0 : _n_parentNode_sheet.cssRules) textContent = $dbab849fc0bcf4ad$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn("Cannot get CSS styles from text's parentNode. Error: ".concat(err), n);
        }
        textContent = $dbab849fc0bcf4ad$var$absoluteToStylesheet(textContent, $dbab849fc0bcf4ad$var$getHref(options.doc));
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    var forceMask = $dbab849fc0bcf4ad$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        var isInputMasked = $dbab849fc0bcf4ad$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $dbab849fc0bcf4ad$var$maskInputValue({
            isMasked: $dbab849fc0bcf4ad$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $dbab849fc0bcf4ad$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $dbab849fc0bcf4ad$var$serializeElementNode(n, options) {
    var doc = options.doc, blockClass = options.blockClass, blockSelector = options.blockSelector, unblockSelector = options.unblockSelector, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskAttributeFn = options.maskAttributeFn, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, rootId = options.rootId, maskTextClass = options.maskTextClass, unmaskTextClass = options.unmaskTextClass, maskTextSelector = options.maskTextSelector, unmaskTextSelector = options.unmaskTextSelector, ignoreCSSAttributes = options.ignoreCSSAttributes;
    var needBlock = $dbab849fc0bcf4ad$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    var tagName = $dbab849fc0bcf4ad$var$getValidTagName(n);
    var attributes2 = {};
    var len = n.attributes.length;
    for(var i2 = 0; i2 < len; i2++){
        var attr = n.attributes[i2];
        if (attr.name && !$dbab849fc0bcf4ad$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes2[attr.name] = $dbab849fc0bcf4ad$var$transformAttribute(doc, tagName, $dbab849fc0bcf4ad$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn, ignoreCSSAttributes);
    }
    if (tagName === "link" && inlineStylesheet) {
        var stylesheet = Array.from(doc.styleSheets).find(function(s) {
            return s.href === n.href;
        });
        var cssText = null;
        if (stylesheet) cssText = $dbab849fc0bcf4ad$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            attributes2.rel = null;
            attributes2.href = null;
            attributes2.crossorigin = null;
            attributes2._cssText = $dbab849fc0bcf4ad$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
    !(n.innerText || n.textContent || "").trim().length) {
        var cssText1 = $dbab849fc0bcf4ad$var$stringifyStylesheet(n.sheet);
        if (cssText1) attributes2._cssText = $dbab849fc0bcf4ad$var$absoluteToStylesheet(cssText1, $dbab849fc0bcf4ad$var$getHref(doc));
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        var el = n;
        var type = $dbab849fc0bcf4ad$var$getInputType(el);
        var value = $dbab849fc0bcf4ad$var$getInputValue(el, $dbab849fc0bcf4ad$var$toUpperCase(tagName), type);
        var checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            var forceMask = $dbab849fc0bcf4ad$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $dbab849fc0bcf4ad$var$shouldMaskInput({
                type: type,
                tagName: $dbab849fc0bcf4ad$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes2.value = $dbab849fc0bcf4ad$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes2.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes2.selected = true;
        else delete attributes2.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$dbab849fc0bcf4ad$var$is2DCanvasBlank(n)) attributes2.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            var canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            var blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            var blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes2.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$dbab849fc0bcf4ad$var$canvasService) {
            $dbab849fc0bcf4ad$var$canvasService = doc.createElement("canvas");
            $dbab849fc0bcf4ad$var$canvasCtx = $dbab849fc0bcf4ad$var$canvasService.getContext("2d");
        }
        var image = n;
        var imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        var priorCrossOrigin = image.crossOrigin;
        var recordInlineImage = function() {
            image.removeEventListener("load", recordInlineImage);
            try {
                $dbab849fc0bcf4ad$var$canvasService.width = image.naturalWidth;
                $dbab849fc0bcf4ad$var$canvasService.height = image.naturalHeight;
                $dbab849fc0bcf4ad$var$canvasCtx.drawImage(image, 0, 0);
                attributes2.rr_dataURL = $dbab849fc0bcf4ad$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn("Cannot inline img src=".concat(imageSrc, "! Error: ").concat(err));
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes2.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes2.rr_mediaState = n.paused ? "paused" : "played";
        attributes2.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes2.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes2.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        var _n_getBoundingClientRect = n.getBoundingClientRect(), width = _n_getBoundingClientRect.width, height = _n_getBoundingClientRect.height;
        attributes2 = {
            class: attributes2.class,
            rr_width: "".concat(width, "px"),
            rr_height: "".concat(height, "px")
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes2.src)) {
        if (!needBlock && !$dbab849fc0bcf4ad$var$getIFrameContentDocument$1(n)) attributes2.rr_src = attributes2.src;
        delete attributes2.src;
    }
    var isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $dbab849fc0bcf4ad$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes2,
        childNodes: [],
        isSVG: $dbab849fc0bcf4ad$var$isSVGElement(n) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $dbab849fc0bcf4ad$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $dbab849fc0bcf4ad$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $dbab849fc0bcf4ad$var$NodeType$1.Comment) return true;
    else if (sn.type === $dbab849fc0bcf4ad$var$NodeType$1.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $dbab849fc0bcf4ad$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "application-name" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.rel) === "icon" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "robots" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "googlebot" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "author" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "generator" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "framework" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "publisher" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "progid" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "verification" || $dbab849fc0bcf4ad$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $dbab849fc0bcf4ad$var$serializeNodeWithId(n, options) {
    var doc = options.doc, mirror = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, unblockSelector = options.unblockSelector, maskAllText = options.maskAllText, maskTextClass = options.maskTextClass, unmaskTextClass = options.unmaskTextClass, maskTextSelector = options.maskTextSelector, unmaskTextSelector = options.unmaskTextSelector, _options_skipChild = options.skipChild, skipChild = _options_skipChild === void 0 ? false : _options_skipChild, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskAttributeFn = options.maskAttributeFn, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, slimDOMOptions = options.slimDOMOptions, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, onSerialize = options.onSerialize, onIframeLoad = options.onIframeLoad, _options_iframeLoadTimeout = options.iframeLoadTimeout, iframeLoadTimeout = _options_iframeLoadTimeout === void 0 ? 5e3 : _options_iframeLoadTimeout, onBlockedImageLoad = options.onBlockedImageLoad, onStylesheetLoad = options.onStylesheetLoad, _options_stylesheetLoadTimeout = options.stylesheetLoadTimeout, stylesheetLoadTimeout = _options_stylesheetLoadTimeout === void 0 ? 5e3 : _options_stylesheetLoadTimeout, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, ignoreCSSAttributes = options.ignoreCSSAttributes;
    var _options_preserveWhiteSpace = options.preserveWhiteSpace, preserveWhiteSpace = _options_preserveWhiteSpace === void 0 ? true : _options_preserveWhiteSpace;
    var _serializedNode = $dbab849fc0bcf4ad$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    var id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($dbab849fc0bcf4ad$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $dbab849fc0bcf4ad$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.trim().length) id = $dbab849fc0bcf4ad$var$IGNORED_NODE;
    else id = $dbab849fc0bcf4ad$var$genId();
    var serializedNode2 = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode2);
    if (id === $dbab849fc0bcf4ad$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    var recordChild = !skipChild;
    if (serializedNode2.type === $dbab849fc0bcf4ad$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode2.needBlock;
        var shadowRoot = n.shadowRoot;
        if (shadowRoot && $dbab849fc0bcf4ad$var$isNativeShadowDom(shadowRoot)) serializedNode2.isShadowHost = true;
    }
    if ((serializedNode2.type === $dbab849fc0bcf4ad$var$NodeType$1.Document || serializedNode2.type === $dbab849fc0bcf4ad$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode2.type === $dbab849fc0bcf4ad$var$NodeType$1.Element && serializedNode2.tagName === "head") preserveWhiteSpace = false;
        var bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onBlockedImageLoad: onBlockedImageLoad,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        };
        var childNodes = n.childNodes ? Array.from(n.childNodes) : [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var childN = _step.value;
                var serializedChildNode = $dbab849fc0bcf4ad$var$serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) serializedNode2.childNodes.push(serializedChildNode);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        if ($dbab849fc0bcf4ad$var$isElement$1(n) && n.shadowRoot) try {
            for(var _iterator1 = Array.from(n.shadowRoot.childNodes)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var childN1 = _step1.value;
                var serializedChildNode1 = $dbab849fc0bcf4ad$var$serializeNodeWithId(childN1, bypassOptions);
                if (serializedChildNode1) {
                    $dbab849fc0bcf4ad$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode1.isShadow = true);
                    serializedNode2.childNodes.push(serializedChildNode1);
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    if (n.parentNode && $dbab849fc0bcf4ad$var$isShadowRoot(n.parentNode) && $dbab849fc0bcf4ad$var$isNativeShadowDom(n.parentNode)) serializedNode2.isShadow = true;
    if (serializedNode2.type === $dbab849fc0bcf4ad$var$NodeType$1.Element && serializedNode2.tagName === "iframe" && !serializedNode2.needBlock) $dbab849fc0bcf4ad$var$onceIframeLoaded(n, function() {
        var iframeDoc = $dbab849fc0bcf4ad$var$getIFrameContentDocument$1(n);
        if (iframeDoc && onIframeLoad) {
            var serializedIframeNode = $dbab849fc0bcf4ad$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode2.type === $dbab849fc0bcf4ad$var$NodeType$1.Element && serializedNode2.tagName === "img" && !n.complete && serializedNode2.needBlock) {
        var image = n;
        var updateImageDimensions = function() {
            if (image.isConnected && !image.complete && onBlockedImageLoad) try {
                var rect = image.getBoundingClientRect();
                if (rect.width > 0 && rect.height > 0) onBlockedImageLoad(image, serializedNode2, rect);
            } catch (error) {}
            image.removeEventListener("load", updateImageDimensions);
        };
        if (image.isConnected) image.addEventListener("load", updateImageDimensions);
    }
    if (serializedNode2.type === $dbab849fc0bcf4ad$var$NodeType$1.Element && serializedNode2.tagName === "link" && typeof serializedNode2.attributes.rel === "string" && (serializedNode2.attributes.rel === "stylesheet" || serializedNode2.attributes.rel === "preload" && typeof serializedNode2.attributes.href === "string" && $dbab849fc0bcf4ad$var$extractFileExtension(serializedNode2.attributes.href) === "css")) $dbab849fc0bcf4ad$var$onceStylesheetLoaded(n, function() {
        if (onStylesheetLoad) {
            var serializedLinkNode = $dbab849fc0bcf4ad$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    if (serializedNode2.type === $dbab849fc0bcf4ad$var$NodeType$1.Element) delete serializedNode2.needBlock;
    return serializedNode2;
}
function $dbab849fc0bcf4ad$var$snapshot(n, options) {
    var _ref = options || {}, _ref_mirror = _ref.mirror, mirror = _ref_mirror === void 0 ? new $dbab849fc0bcf4ad$var$Mirror() : _ref_mirror, _ref_blockClass = _ref.blockClass, blockClass = _ref_blockClass === void 0 ? "rr-block" : _ref_blockClass, _ref_blockSelector = _ref.blockSelector, blockSelector = _ref_blockSelector === void 0 ? null : _ref_blockSelector, _ref_unblockSelector = _ref.unblockSelector, unblockSelector = _ref_unblockSelector === void 0 ? null : _ref_unblockSelector, _ref_maskAllText = _ref.maskAllText, maskAllText = _ref_maskAllText === void 0 ? false : _ref_maskAllText, _ref_maskTextClass = _ref.maskTextClass, maskTextClass = _ref_maskTextClass === void 0 ? "rr-mask" : _ref_maskTextClass, _ref_unmaskTextClass = _ref.unmaskTextClass, unmaskTextClass = _ref_unmaskTextClass === void 0 ? null : _ref_unmaskTextClass, _ref_maskTextSelector = _ref.maskTextSelector, maskTextSelector = _ref_maskTextSelector === void 0 ? null : _ref_maskTextSelector, _ref_unmaskTextSelector = _ref.unmaskTextSelector, unmaskTextSelector = _ref_unmaskTextSelector === void 0 ? null : _ref_unmaskTextSelector, _ref_inlineStylesheet = _ref.inlineStylesheet, inlineStylesheet = _ref_inlineStylesheet === void 0 ? true : _ref_inlineStylesheet, _ref_inlineImages = _ref.inlineImages, inlineImages = _ref_inlineImages === void 0 ? false : _ref_inlineImages, _ref_recordCanvas = _ref.recordCanvas, recordCanvas = _ref_recordCanvas === void 0 ? false : _ref_recordCanvas, _ref_maskAllInputs = _ref.maskAllInputs, maskAllInputs = _ref_maskAllInputs === void 0 ? false : _ref_maskAllInputs, maskAttributeFn = _ref.maskAttributeFn, maskTextFn = _ref.maskTextFn, maskInputFn = _ref.maskInputFn, _ref_slimDOM = _ref.slimDOM, slimDOM = _ref_slimDOM === void 0 ? false : _ref_slimDOM, dataURLOptions = _ref.dataURLOptions, preserveWhiteSpace = _ref.preserveWhiteSpace, onSerialize = _ref.onSerialize, onIframeLoad = _ref.onIframeLoad, iframeLoadTimeout = _ref.iframeLoadTimeout, onBlockedImageLoad = _ref.onBlockedImageLoad, onStylesheetLoad = _ref.onStylesheetLoad, stylesheetLoadTimeout = _ref.stylesheetLoadTimeout, _ref_keepIframeSrcFn = _ref.keepIframeSrcFn, keepIframeSrcFn = _ref_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _ref_keepIframeSrcFn, _ref_ignoreCSSAttributes = _ref.ignoreCSSAttributes, ignoreCSSAttributes = _ref_ignoreCSSAttributes === void 0 ? /* @__PURE__ */ new Set([]) : _ref_ignoreCSSAttributes;
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    var slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
    {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $dbab849fc0bcf4ad$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onBlockedImageLoad: onBlockedImageLoad,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
}
function $dbab849fc0bcf4ad$var$on(type, fn) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    var options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return function() {
        return target.removeEventListener(type, fn, options);
    };
}
var $dbab849fc0bcf4ad$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
var $dbab849fc0bcf4ad$var$_mirror = {
    map: {},
    getId: function() {
        console.error($dbab849fc0bcf4ad$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function() {
        console.error($dbab849fc0bcf4ad$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function() {
        console.error($dbab849fc0bcf4ad$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function() {
        console.error($dbab849fc0bcf4ad$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function() {
        console.error($dbab849fc0bcf4ad$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $dbab849fc0bcf4ad$var$_mirror = new Proxy($dbab849fc0bcf4ad$var$_mirror, {
    get: function(target, prop, receiver) {
        if (prop === "map") console.error($dbab849fc0bcf4ad$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $dbab849fc0bcf4ad$var$throttle$1(func, wait) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var timeout = null;
    var previous = 0;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        var context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $dbab849fc0bcf4ad$var$clearTimeout$2(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $dbab849fc0bcf4ad$var$setTimeout$2(function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $dbab849fc0bcf4ad$var$hookSetter(target, key, d, isRevoked) {
    var win = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : window;
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set: function(value) {
            var _this = this;
            $dbab849fc0bcf4ad$var$setTimeout$2(function() {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return function() {
        return $dbab849fc0bcf4ad$var$hookSetter(target, key, original || {}, true);
    };
}
function $dbab849fc0bcf4ad$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e) {
        return function() {};
    }
}
var $dbab849fc0bcf4ad$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $dbab849fc0bcf4ad$var$nowTimestamp = function() {
    return /* @__PURE__ */ new Date().getTime();
};
function $dbab849fc0bcf4ad$var$getWindowScroll(win) {
    var _doc_body_parentElement, _doc_body, _doc_body1, _doc_body_parentElement1, _doc_body2, _doc_body3;
    var doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollLeft) || (doc === null || doc === void 0 ? void 0 : (_doc_body = doc.body) === null || _doc_body === void 0 ? void 0 : (_doc_body_parentElement = _doc_body.parentElement) === null || _doc_body_parentElement === void 0 ? void 0 : _doc_body_parentElement.scrollLeft) || (doc === null || doc === void 0 ? void 0 : (_doc_body1 = doc.body) === null || _doc_body1 === void 0 ? void 0 : _doc_body1.scrollLeft) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollTop) || (doc === null || doc === void 0 ? void 0 : (_doc_body2 = doc.body) === null || _doc_body2 === void 0 ? void 0 : (_doc_body_parentElement1 = _doc_body2.parentElement) === null || _doc_body_parentElement1 === void 0 ? void 0 : _doc_body_parentElement1.scrollTop) || (doc === null || doc === void 0 ? void 0 : (_doc_body3 = doc.body) === null || _doc_body3 === void 0 ? void 0 : _doc_body3.scrollTop) || 0
    };
}
function $dbab849fc0bcf4ad$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $dbab849fc0bcf4ad$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $dbab849fc0bcf4ad$var$closestElementOfNode$1(node) {
    if (!node) return null;
    try {
        var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (error) {
        return null;
    }
}
function $dbab849fc0bcf4ad$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    var el = $dbab849fc0bcf4ad$var$closestElementOfNode$1(node);
    if (!el) return false;
    var blockedPredicate = $dbab849fc0bcf4ad$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        var isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    var blockDistance = $dbab849fc0bcf4ad$var$distanceToMatch(el, blockedPredicate);
    var unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $dbab849fc0bcf4ad$var$distanceToMatch(el, $dbab849fc0bcf4ad$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $dbab849fc0bcf4ad$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $dbab849fc0bcf4ad$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $dbab849fc0bcf4ad$var$IGNORED_NODE;
}
function $dbab849fc0bcf4ad$var$isAncestorRemoved(target, mirror) {
    if ($dbab849fc0bcf4ad$var$isShadowRoot(target)) return false;
    var id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $dbab849fc0bcf4ad$var$isAncestorRemoved(target.parentNode, mirror);
}
function $dbab849fc0bcf4ad$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $dbab849fc0bcf4ad$var$polyfill() {
    var win = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
    var _this = this;
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (_this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $dbab849fc0bcf4ad$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $dbab849fc0bcf4ad$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $dbab849fc0bcf4ad$var$hasShadowRoot(n) {
    return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}
var $dbab849fc0bcf4ad$var$StyleSheetMirror = /*#__PURE__*/ function() {
    "use strict";
    function StyleSheetMirror() {
        (0, $5Epmf._)(this, StyleSheetMirror);
        this.id = 1;
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
    }
    (0, $9MqXK._)(StyleSheetMirror, [
        {
            key: "getId",
            value: function getId(stylesheet) {
                var _this_styleIDMap_get;
                return (_this_styleIDMap_get = this.styleIDMap.get(stylesheet)) !== null && _this_styleIDMap_get !== void 0 ? _this_styleIDMap_get : -1;
            }
        },
        {
            key: "has",
            value: function has(stylesheet) {
                return this.styleIDMap.has(stylesheet);
            }
        },
        {
            /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ key: "add",
            value: function add(stylesheet, id) {
                if (this.has(stylesheet)) return this.getId(stylesheet);
                var newId;
                if (id === void 0) newId = this.id++;
                else newId = id;
                this.styleIDMap.set(stylesheet, newId);
                this.idStyleMap.set(newId, stylesheet);
                return newId;
            }
        },
        {
            key: "getStyle",
            value: function getStyle(id) {
                return this.idStyleMap.get(id) || null;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.styleIDMap = /* @__PURE__ */ new WeakMap();
                this.idStyleMap = /* @__PURE__ */ new Map();
                this.id = 1;
            }
        },
        {
            key: "generateId",
            value: function generateId() {
                return this.id++;
            }
        }
    ]);
    return StyleSheetMirror;
}();
function $dbab849fc0bcf4ad$var$getShadowHost(n) {
    var _n_getRootNode, _n_getRootNode1;
    var shadowHost = null;
    if (((_n_getRootNode1 = n.getRootNode) === null || _n_getRootNode1 === void 0 ? void 0 : (_n_getRootNode = _n_getRootNode1.call(n)) === null || _n_getRootNode === void 0 ? void 0 : _n_getRootNode.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $dbab849fc0bcf4ad$var$getRootShadowHost(n) {
    var rootShadowHost = n;
    var shadowHost;
    while(shadowHost = $dbab849fc0bcf4ad$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $dbab849fc0bcf4ad$var$shadowHostInDom(n) {
    var doc = n.ownerDocument;
    if (!doc) return false;
    var shadowHost = $dbab849fc0bcf4ad$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $dbab849fc0bcf4ad$var$inDom(n) {
    var doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $dbab849fc0bcf4ad$var$shadowHostInDom(n);
}
var $dbab849fc0bcf4ad$var$cachedImplementations = {};
function $dbab849fc0bcf4ad$var$getImplementation(name) {
    var cached = $dbab849fc0bcf4ad$var$cachedImplementations[name];
    if (cached) return cached;
    var document2 = window.document;
    var impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        var sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e) {}
    return $dbab849fc0bcf4ad$var$cachedImplementations[name] = impl.bind(window);
}
function $dbab849fc0bcf4ad$var$onRequestAnimationFrame() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return $dbab849fc0bcf4ad$var$getImplementation("requestAnimationFrame").apply(this, (0, $XnYkK._)(rest));
}
function $dbab849fc0bcf4ad$var$setTimeout$2() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return $dbab849fc0bcf4ad$var$getImplementation("setTimeout").apply(this, (0, $XnYkK._)(rest));
}
function $dbab849fc0bcf4ad$var$clearTimeout$2() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return $dbab849fc0bcf4ad$var$getImplementation("clearTimeout").apply(this, (0, $XnYkK._)(rest));
}
var $dbab849fc0bcf4ad$var$EventType = /* @__PURE__ */ function(EventType2) {
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
}($dbab849fc0bcf4ad$var$EventType || {});
var $dbab849fc0bcf4ad$var$IncrementalSource = /* @__PURE__ */ function(IncrementalSource2) {
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
}($dbab849fc0bcf4ad$var$IncrementalSource || {});
var $dbab849fc0bcf4ad$var$MouseInteractions = /* @__PURE__ */ function(MouseInteractions2) {
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
}($dbab849fc0bcf4ad$var$MouseInteractions || {});
var $dbab849fc0bcf4ad$var$PointerTypes = /* @__PURE__ */ function(PointerTypes2) {
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
}($dbab849fc0bcf4ad$var$PointerTypes || {});
var $dbab849fc0bcf4ad$var$MediaInteractions = /* @__PURE__ */ function(MediaInteractions2) {
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
}($dbab849fc0bcf4ad$var$MediaInteractions || {});
var $dbab849fc0bcf4ad$var$errorHandler;
function $dbab849fc0bcf4ad$var$registerErrorHandler(handler) {
    $dbab849fc0bcf4ad$var$errorHandler = handler;
}
function $dbab849fc0bcf4ad$var$unregisterErrorHandler() {
    $dbab849fc0bcf4ad$var$errorHandler = void 0;
}
var $dbab849fc0bcf4ad$var$callbackWrapper = function(cb) {
    if (!$dbab849fc0bcf4ad$var$errorHandler) return cb;
    var rrwebWrapped = function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
            rest[_key] = arguments[_key];
        }
        try {
            return cb.apply(void 0, (0, $XnYkK._)(rest));
        } catch (error) {
            if ($dbab849fc0bcf4ad$var$errorHandler && $dbab849fc0bcf4ad$var$errorHandler(error) === true) return function() {};
            throw error;
        }
    };
    return rrwebWrapped;
};
var $dbab849fc0bcf4ad$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $dbab849fc0bcf4ad$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $dbab849fc0bcf4ad$var$i = 0; $dbab849fc0bcf4ad$var$i < $dbab849fc0bcf4ad$var$chars.length; $dbab849fc0bcf4ad$var$i++)$dbab849fc0bcf4ad$var$lookup[$dbab849fc0bcf4ad$var$chars.charCodeAt($dbab849fc0bcf4ad$var$i)] = $dbab849fc0bcf4ad$var$i;
var $dbab849fc0bcf4ad$var$CanvasManagerNoop = /*#__PURE__*/ function() {
    "use strict";
    function CanvasManagerNoop() {
        (0, $5Epmf._)(this, CanvasManagerNoop);
    }
    (0, $9MqXK._)(CanvasManagerNoop, [
        {
            key: "reset",
            value: function reset() {}
        },
        {
            key: "freeze",
            value: function freeze() {}
        },
        {
            key: "unfreeze",
            value: function unfreeze() {}
        },
        {
            key: "lock",
            value: function lock() {}
        },
        {
            key: "unlock",
            value: function unlock() {}
        },
        {
            key: "snapshot",
            value: function snapshot() {}
        },
        {
            key: "addWindow",
            value: function addWindow() {}
        },
        {
            key: "addShadowRoot",
            value: function addShadowRoot() {}
        },
        {
            key: "resetShadowRoots",
            value: function resetShadowRoots() {}
        }
    ]);
    return CanvasManagerNoop;
}();
function $dbab849fc0bcf4ad$var$getIFrameContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e2) {}
}
function $dbab849fc0bcf4ad$var$getIFrameContentWindow(iframe) {
    try {
        return iframe.contentWindow;
    } catch (e2) {}
}
var $dbab849fc0bcf4ad$var$StyleDeclarationParser = /*#__PURE__*/ function() {
    "use strict";
    function StyleDeclarationParser(doc) {
        (0, $5Epmf._)(this, StyleDeclarationParser);
        this.doc = doc;
        this.unattachedDoc = null;
    }
    (0, $9MqXK._)(StyleDeclarationParser, [
        {
            key: "parse",
            value: function parse(styleText) {
                return this.parseWithConstructableStylesheet(styleText) || this.parseWithDetachedElement(styleText);
            }
        },
        {
            key: "parseWithConstructableStylesheet",
            value: function parseWithConstructableStylesheet(styleText) {
                if (typeof CSSStyleSheet === "undefined" || typeof CSSStyleSheet.prototype.replaceSync !== "function") return null;
                try {
                    var sheet = new CSSStyleSheet();
                    sheet.replaceSync("x { ".concat(styleText, " }"));
                    var rule = sheet.cssRules[0];
                    if (!rule || rule.type !== CSSRule.STYLE_RULE) return null;
                    return rule.style;
                } catch (e) {
                    return null;
                }
            }
        },
        {
            key: "parseWithDetachedElement",
            value: function parseWithDetachedElement(styleText) {
                var old = this.getUnattachedDoc().createElement("span");
                old.setAttribute("style", styleText);
                return old.style;
            }
        },
        {
            key: "getUnattachedDoc",
            value: function getUnattachedDoc() {
                if (!this.unattachedDoc) try {
                    this.unattachedDoc = document.implementation.createHTMLDocument();
                } catch (e) {
                    this.unattachedDoc = this.doc;
                }
                return this.unattachedDoc;
            }
        }
    ]);
    return StyleDeclarationParser;
}();
function $dbab849fc0bcf4ad$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
var $dbab849fc0bcf4ad$var$DoubleLinkedList = /*#__PURE__*/ function() {
    "use strict";
    function DoubleLinkedList() {
        (0, $5Epmf._)(this, DoubleLinkedList);
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    (0, $9MqXK._)(DoubleLinkedList, [
        {
            key: "get",
            value: function get(position) {
                if (position >= this.length) throw new Error("Position outside of list range");
                var current = this.head;
                for(var index = 0; index < position; index++)current = (current === null || current === void 0 ? void 0 : current.next) || null;
                return current;
            }
        },
        {
            key: "addNode",
            value: function addNode(n2) {
                var node = {
                    value: n2,
                    previous: null,
                    next: null
                };
                n2.__ln = node;
                if (n2.previousSibling && $dbab849fc0bcf4ad$var$isNodeInLinkedList(n2.previousSibling)) {
                    var current = n2.previousSibling.__ln.next;
                    node.next = current;
                    node.previous = n2.previousSibling.__ln;
                    n2.previousSibling.__ln.next = node;
                    if (current) current.previous = node;
                } else if (n2.nextSibling && $dbab849fc0bcf4ad$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
                    var current1 = n2.nextSibling.__ln.previous;
                    node.previous = current1;
                    node.next = n2.nextSibling.__ln;
                    n2.nextSibling.__ln.previous = node;
                    if (current1) current1.next = node;
                } else {
                    if (this.head) this.head.previous = node;
                    node.next = this.head;
                    this.head = node;
                }
                if (node.next === null) this.tail = node;
                this.length++;
            }
        },
        {
            key: "removeNode",
            value: function removeNode(n2) {
                var current = n2.__ln;
                if (!this.head) return;
                if (!current.previous) {
                    this.head = current.next;
                    if (this.head) this.head.previous = null;
                    else this.tail = null;
                } else {
                    current.previous.next = current.next;
                    if (current.next) current.next.previous = current.previous;
                    else this.tail = current.previous;
                }
                if (n2.__ln) delete n2.__ln;
                this.length--;
            }
        }
    ]);
    return DoubleLinkedList;
}();
var $dbab849fc0bcf4ad$var$moveKey = function(id, parentId) {
    return "".concat(id, "@").concat(parentId);
};
var $dbab849fc0bcf4ad$var$MutationBuffer = /*#__PURE__*/ function() {
    "use strict";
    function MutationBuffer() {
        var _this = this;
        (0, $5Epmf._)(this, MutationBuffer);
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = /* @__PURE__ */ new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = /* @__PURE__ */ new Set();
        this.movedSet = /* @__PURE__ */ new Set();
        this.droppedSet = /* @__PURE__ */ new Set();
        this.processMutations = function(mutations) {
            mutations.forEach(_this.processMutation);
            _this.emit();
        };
        this.emit = function() {
            if (_this.frozen || _this.locked) return;
            var adds = [];
            var addedIds = /* @__PURE__ */ new Set();
            var addList = new $dbab849fc0bcf4ad$var$DoubleLinkedList();
            var getNextId = function(n2) {
                var ns = n2;
                var nextId = $dbab849fc0bcf4ad$var$IGNORED_NODE;
                while(nextId === $dbab849fc0bcf4ad$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && _this.mirror.getId(ns);
                }
                return nextId;
            };
            var pushAdd = function(n2) {
                if (!n2.parentNode || !$dbab849fc0bcf4ad$var$inDom(n2)) return;
                var parentId = $dbab849fc0bcf4ad$var$isShadowRoot(n2.parentNode) ? _this.mirror.getId($dbab849fc0bcf4ad$var$getShadowHost(n2)) : _this.mirror.getId(n2.parentNode);
                var nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                var sn = $dbab849fc0bcf4ad$var$serializeNodeWithId(n2, {
                    doc: _this.doc,
                    mirror: _this.mirror,
                    blockClass: _this.blockClass,
                    blockSelector: _this.blockSelector,
                    maskAllText: _this.maskAllText,
                    unblockSelector: _this.unblockSelector,
                    maskTextClass: _this.maskTextClass,
                    unmaskTextClass: _this.unmaskTextClass,
                    maskTextSelector: _this.maskTextSelector,
                    unmaskTextSelector: _this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: _this.inlineStylesheet,
                    maskInputOptions: _this.maskInputOptions,
                    maskAttributeFn: _this.maskAttributeFn,
                    maskTextFn: _this.maskTextFn,
                    maskInputFn: _this.maskInputFn,
                    slimDOMOptions: _this.slimDOMOptions,
                    dataURLOptions: _this.dataURLOptions,
                    recordCanvas: _this.recordCanvas,
                    inlineImages: _this.inlineImages,
                    onSerialize: function(currentN) {
                        if ($dbab849fc0bcf4ad$var$isSerializedIframe(currentN, _this.mirror) && !$dbab849fc0bcf4ad$var$isBlocked(currentN, _this.blockClass, _this.blockSelector, _this.unblockSelector, false)) _this.iframeManager.addIframe(currentN);
                        if ($dbab849fc0bcf4ad$var$isSerializedStylesheet(currentN, _this.mirror)) _this.stylesheetManager.trackLinkElement(currentN);
                        if ($dbab849fc0bcf4ad$var$hasShadowRoot(n2)) _this.shadowDomManager.addShadowRoot(n2.shadowRoot, _this.doc);
                    },
                    onIframeLoad: function(iframe, childSn) {
                        if ($dbab849fc0bcf4ad$var$isBlocked(iframe, _this.blockClass, _this.blockSelector, _this.unblockSelector, false)) return;
                        _this.iframeManager.attachIframe(iframe, childSn);
                        var contentWindow = $dbab849fc0bcf4ad$var$getIFrameContentWindow(iframe);
                        if (contentWindow) _this.canvasManager.addWindow(contentWindow);
                        _this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: function(link, childSn) {
                        _this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                    onBlockedImageLoad: function(_imageEl, serializedNode, param) {
                        var width = param.width, height = param.height;
                        _this.mutationCb({
                            adds: [],
                            removes: [],
                            texts: [],
                            attributes: [
                                {
                                    id: serializedNode.id,
                                    attributes: {
                                        style: {
                                            width: "".concat(width, "px"),
                                            height: "".concat(height, "px")
                                        }
                                    }
                                }
                            ]
                        });
                    },
                    ignoreCSSAttributes: _this.ignoreCSSAttributes
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(_this.mapRemoves.length)_this.mirror.removeNodeFromMap(_this.mapRemoves.shift());
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _this.movedSet[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n2 = _step.value;
                    if ($dbab849fc0bcf4ad$var$isParentRemoved(_this.removes, n2, _this.mirror) && !_this.movedSet.has(n2.parentNode)) continue;
                    pushAdd(n2);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = _this.addedSet[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var n21 = _step1.value;
                    if (!$dbab849fc0bcf4ad$var$isAncestorInSet(_this.droppedSet, n21) && !$dbab849fc0bcf4ad$var$isParentRemoved(_this.removes, n21, _this.mirror)) pushAdd(n21);
                    else if ($dbab849fc0bcf4ad$var$isAncestorInSet(_this.movedSet, n21)) pushAdd(n21);
                    else _this.droppedSet.add(n21);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            var candidate = null;
            while(addList.length){
                var node = null;
                if (candidate) {
                    var parentId = _this.mirror.getId(candidate.value.parentNode);
                    var nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    var tailNode = addList.tail;
                    while(tailNode){
                        var _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            var parentId1 = _this.mirror.getId(_node.value.parentNode);
                            var nextId1 = getNextId(_node.value);
                            if (nextId1 === -1) continue;
                            else if (parentId1 !== -1) {
                                node = _node;
                                break;
                            } else {
                                var unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    var shadowHost = unhandledNode.parentNode.host;
                                    var parentId2 = _this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            var payload = {
                texts: _this.texts.map(function(text) {
                    return {
                        id: _this.mirror.getId(text.node),
                        value: text.value
                    };
                }).filter(function(text) {
                    return !addedIds.has(text.id);
                }).filter(function(text) {
                    return _this.mirror.has(text.id);
                }),
                attributes: _this.attributes.map(function(attribute) {
                    var attributes = attribute.attributes;
                    if (typeof attributes.style === "string") {
                        var diffAsStr = JSON.stringify(attribute.styleDiff);
                        var unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: _this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter(function(attribute) {
                    return !addedIds.has(attribute.id);
                }).filter(function(attribute) {
                    return _this.mirror.has(attribute.id);
                }),
                removes: _this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            _this.texts = [];
            _this.attributes = [];
            _this.attributeMap = /* @__PURE__ */ new WeakMap();
            _this.removes = [];
            _this.addedSet = /* @__PURE__ */ new Set();
            _this.movedSet = /* @__PURE__ */ new Set();
            _this.droppedSet = /* @__PURE__ */ new Set();
            _this.movedMap = {};
            _this.mutationCb(payload);
        };
        this.processMutation = function(m) {
            if ($dbab849fc0bcf4ad$var$isIgnored(m.target, _this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        var value = m.target.textContent;
                        if (!$dbab849fc0bcf4ad$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, _this.unblockSelector, false) && value !== m.oldValue) _this.texts.push({
                            value: $dbab849fc0bcf4ad$var$needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector, _this.unmaskTextClass, _this.unmaskTextSelector, _this.maskAllText) && value ? _this.maskTextFn ? _this.maskTextFn(value, $dbab849fc0bcf4ad$var$closestElementOfNode$1(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        var target = m.target;
                        var attributeName = m.attributeName;
                        var value1 = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            var type = $dbab849fc0bcf4ad$var$getInputType(target);
                            var tagName = target.tagName;
                            value1 = $dbab849fc0bcf4ad$var$getInputValue(target, tagName, type);
                            var isInputMasked = $dbab849fc0bcf4ad$var$shouldMaskInput({
                                maskInputOptions: _this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            var forceMask = $dbab849fc0bcf4ad$var$needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector, _this.unmaskTextClass, _this.unmaskTextSelector, isInputMasked);
                            value1 = $dbab849fc0bcf4ad$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value1,
                                maskInputFn: _this.maskInputFn
                            });
                        }
                        if ($dbab849fc0bcf4ad$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, _this.unblockSelector, false) || value1 === m.oldValue) return;
                        var item = _this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !_this.keepIframeSrcFn(value1)) {
                            var iframeDoc = $dbab849fc0bcf4ad$var$getIFrameContentDocument(target);
                            if (!iframeDoc) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            _this.attributes.push(item);
                            _this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$dbab849fc0bcf4ad$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $dbab849fc0bcf4ad$var$transformAttribute(_this.doc, $dbab849fc0bcf4ad$var$toLowerCase(target.tagName), $dbab849fc0bcf4ad$var$toLowerCase(attributeName), value1, target, _this.maskAttributeFn);
                            if (attributeName === "style") {
                                var oldStyle = m.oldValue ? _this.styleDeclarationParser.parse(m.oldValue) : null;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = Array.from(target.style)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var pname = _step.value;
                                        var newValue = target.style.getPropertyValue(pname);
                                        var newPriority = target.style.getPropertyPriority(pname);
                                        if (newValue !== ((oldStyle === null || oldStyle === void 0 ? void 0 : oldStyle.getPropertyValue(pname)) || "") || newPriority !== ((oldStyle === null || oldStyle === void 0 ? void 0 : oldStyle.getPropertyPriority(pname)) || "")) {
                                            if (newPriority === "") item.styleDiff[pname] = newValue;
                                            else item.styleDiff[pname] = [
                                                newValue,
                                                newPriority
                                            ];
                                        } else item._unchangedStyles[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (oldStyle) {
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = Array.from(oldStyle)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var pname1 = _step1.value;
                                            if (target.style.getPropertyValue(pname1) === "") item.styleDiff[pname1] = false;
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($dbab849fc0bcf4ad$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, _this.unblockSelector, true)) return;
                    m.addedNodes.forEach(function(n2) {
                        return _this.genAdds(n2, m.target);
                    });
                    m.removedNodes.forEach(function(n2) {
                        var nodeId = _this.mirror.getId(n2);
                        var parentId = $dbab849fc0bcf4ad$var$isShadowRoot(m.target) ? _this.mirror.getId(m.target.host) : _this.mirror.getId(m.target);
                        if ($dbab849fc0bcf4ad$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, _this.unblockSelector, false) || $dbab849fc0bcf4ad$var$isIgnored(n2, _this.mirror) || !$dbab849fc0bcf4ad$var$isSerialized(n2, _this.mirror)) return;
                        if (_this.addedSet.has(n2)) {
                            $dbab849fc0bcf4ad$var$deepDelete(_this.addedSet, n2);
                            _this.droppedSet.add(n2);
                        } else if (_this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($dbab849fc0bcf4ad$var$isAncestorRemoved(m.target, _this.mirror)) ;
                        else if (_this.movedSet.has(n2) && _this.movedMap[$dbab849fc0bcf4ad$var$moveKey(nodeId, parentId)]) $dbab849fc0bcf4ad$var$deepDelete(_this.movedSet, n2);
                        else _this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $dbab849fc0bcf4ad$var$isShadowRoot(m.target) && $dbab849fc0bcf4ad$var$isNativeShadowDom(m.target) ? true : void 0
                        });
                        _this.mapRemoves.push(n2);
                    });
                    break;
            }
        };
        this.genAdds = function(n2, target) {
            if (_this.processedNodeManager.inOtherBuffer(n2, _this)) return;
            if (_this.addedSet.has(n2) || _this.movedSet.has(n2)) return;
            if (_this.mirror.hasNode(n2)) {
                if ($dbab849fc0bcf4ad$var$isIgnored(n2, _this.mirror)) return;
                _this.movedSet.add(n2);
                var targetId = null;
                if (target && _this.mirror.hasNode(target)) targetId = _this.mirror.getId(target);
                if (targetId && targetId !== -1) _this.movedMap[$dbab849fc0bcf4ad$var$moveKey(_this.mirror.getId(n2), targetId)] = true;
            } else {
                _this.addedSet.add(n2);
                _this.droppedSet.delete(n2);
            }
            if (!$dbab849fc0bcf4ad$var$isBlocked(n2, _this.blockClass, _this.blockSelector, _this.unblockSelector, false)) {
                if (n2.childNodes) n2.childNodes.forEach(function(childN) {
                    return _this.genAdds(childN);
                });
                if ($dbab849fc0bcf4ad$var$hasShadowRoot(n2)) n2.shadowRoot.childNodes.forEach(function(childN) {
                    _this.processedNodeManager.add(childN, _this);
                    _this.genAdds(childN, n2);
                });
            }
        };
    }
    (0, $9MqXK._)(MutationBuffer, [
        {
            key: "init",
            value: function init(options) {
                var _this = this;
                [
                    "mutationCb",
                    "blockClass",
                    "blockSelector",
                    "unblockSelector",
                    "maskAllText",
                    "maskTextClass",
                    "unmaskTextClass",
                    "maskTextSelector",
                    "unmaskTextSelector",
                    "inlineStylesheet",
                    "maskInputOptions",
                    "maskAttributeFn",
                    "maskTextFn",
                    "maskInputFn",
                    "keepIframeSrcFn",
                    "recordCanvas",
                    "inlineImages",
                    "slimDOMOptions",
                    "dataURLOptions",
                    "doc",
                    "mirror",
                    "iframeManager",
                    "stylesheetManager",
                    "shadowDomManager",
                    "canvasManager",
                    "processedNodeManager",
                    "ignoreCSSAttributes"
                ].forEach(function(key) {
                    _this[key] = options[key];
                });
                this.styleDeclarationParser = new $dbab849fc0bcf4ad$var$StyleDeclarationParser(this.doc);
            }
        },
        {
            key: "freeze",
            value: function freeze() {
                this.frozen = true;
                this.canvasManager.freeze();
            }
        },
        {
            key: "unfreeze",
            value: function unfreeze() {
                this.frozen = false;
                this.canvasManager.unfreeze();
                this.emit();
            }
        },
        {
            key: "isFrozen",
            value: function isFrozen() {
                return this.frozen;
            }
        },
        {
            key: "lock",
            value: function lock() {
                this.locked = true;
                this.canvasManager.lock();
            }
        },
        {
            key: "unlock",
            value: function unlock() {
                this.locked = false;
                this.canvasManager.unlock();
                this.emit();
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.shadowDomManager.reset();
                this.canvasManager.reset();
            }
        }
    ]);
    return MutationBuffer;
}();
function $dbab849fc0bcf4ad$var$deepDelete(addsSet, n2) {
    var _n2_childNodes;
    addsSet.delete(n2);
    (_n2_childNodes = n2.childNodes) === null || _n2_childNodes === void 0 ? void 0 : _n2_childNodes.forEach(function(childN) {
        return $dbab849fc0bcf4ad$var$deepDelete(addsSet, childN);
    });
}
function $dbab849fc0bcf4ad$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.length === 0) return false;
    return $dbab849fc0bcf4ad$var$_isParentRemoved(removes, n2, mirror2);
}
function $dbab849fc0bcf4ad$var$_isParentRemoved(removes, n2, mirror2) {
    var _loop = function() {
        var parentId = mirror2.getId(node);
        if (removes.some(function(r2) {
            return r2.id === parentId;
        })) return {
            v: true
        };
        node = node.parentNode;
    };
    var node = n2.parentNode;
    while(node){
        var _ret = _loop();
        if ((0, $03bAP._)(_ret) === "object") return _ret.v;
    }
    return false;
}
function $dbab849fc0bcf4ad$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $dbab849fc0bcf4ad$var$_isAncestorInSet(set, n2);
}
function $dbab849fc0bcf4ad$var$_isAncestorInSet(set, n2) {
    var parentNode = n2.parentNode;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $dbab849fc0bcf4ad$var$_isAncestorInSet(set, parentNode);
}
var $dbab849fc0bcf4ad$var$mutationBuffers = [];
function $dbab849fc0bcf4ad$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            var path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e) {}
    return event && event.target;
}
function $dbab849fc0bcf4ad$var$initMutationObserver(options, rootEl) {
    var _window_Zone___symbol__, _window_Zone, _window;
    var mutationBuffer = new $dbab849fc0bcf4ad$var$MutationBuffer();
    $dbab849fc0bcf4ad$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    var mutationObserverCtor = window.MutationObserver || /**
  * Some websites may disable MutationObserver by removing it from the window object.
  * If someone is using rrweb to build a browser extention or things like it, they
  * could not change the website's code but can have an opportunity to inject some
  * code before the website executing its JS logic.
  * Then they can do this to store the native MutationObserver:
  * window.__rrMutationObserver = MutationObserver
  */ window.__rrMutationObserver;
    var angularZoneSymbol = (_window = window) === null || _window === void 0 ? void 0 : (_window_Zone = _window.Zone) === null || _window_Zone === void 0 ? void 0 : (_window_Zone___symbol__ = _window_Zone.__symbol__) === null || _window_Zone___symbol__ === void 0 ? void 0 : _window_Zone___symbol__.call(_window_Zone, "MutationObserver");
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    var observer = new mutationObserverCtor($dbab849fc0bcf4ad$var$callbackWrapper(function(mutations) {
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $dbab849fc0bcf4ad$var$initMoveObserver(param) {
    var mousemoveCb = param.mousemoveCb, sampling = param.sampling, doc = param.doc, mirror2 = param.mirror;
    if (sampling.mousemove === false) return function() {};
    var threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    var callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    var positions = [];
    var timeBaseline;
    var wrappedCb = $dbab849fc0bcf4ad$var$throttle$1($dbab849fc0bcf4ad$var$callbackWrapper(function(source) {
        var totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map(function(p) {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    var updatePosition = $dbab849fc0bcf4ad$var$callbackWrapper($dbab849fc0bcf4ad$var$throttle$1($dbab849fc0bcf4ad$var$callbackWrapper(function(evt) {
        var target = $dbab849fc0bcf4ad$var$getEventTarget(evt);
        var _ref = $dbab849fc0bcf4ad$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt, clientX = _ref.clientX, clientY = _ref.clientY;
        if (!timeBaseline) timeBaseline = $dbab849fc0bcf4ad$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $dbab849fc0bcf4ad$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $dbab849fc0bcf4ad$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $dbab849fc0bcf4ad$var$IncrementalSource.MouseMove : $dbab849fc0bcf4ad$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    var handlers = [
        $dbab849fc0bcf4ad$var$on("mousemove", updatePosition, doc),
        $dbab849fc0bcf4ad$var$on("touchmove", updatePosition, doc),
        $dbab849fc0bcf4ad$var$on("drag", updatePosition, doc)
    ];
    return $dbab849fc0bcf4ad$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $dbab849fc0bcf4ad$var$initMouseInteractionObserver(param) {
    var mouseInteractionCb = param.mouseInteractionCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, sampling = param.sampling;
    if (sampling.mouseInteraction === false) return function() {};
    var disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    var handlers = [];
    var currentPointerType = null;
    var getHandler = function(eventKey) {
        return function(event) {
            var target = $dbab849fc0bcf4ad$var$getEventTarget(event);
            if ($dbab849fc0bcf4ad$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            var pointerType = null;
            var thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $dbab849fc0bcf4ad$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $dbab849fc0bcf4ad$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $dbab849fc0bcf4ad$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $dbab849fc0bcf4ad$var$PointerTypes.Touch) {
                    if ($dbab849fc0bcf4ad$var$MouseInteractions[eventKey] === $dbab849fc0bcf4ad$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($dbab849fc0bcf4ad$var$MouseInteractions[eventKey] === $dbab849fc0bcf4ad$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $dbab849fc0bcf4ad$var$PointerTypes.Pen;
            } else if ($dbab849fc0bcf4ad$var$legacy_isTouchEvent(event)) pointerType = $dbab849fc0bcf4ad$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $dbab849fc0bcf4ad$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $dbab849fc0bcf4ad$var$PointerTypes.Mouse) pointerType = null;
            } else if ($dbab849fc0bcf4ad$var$MouseInteractions[eventKey] === $dbab849fc0bcf4ad$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            var e2 = $dbab849fc0bcf4ad$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            var id = mirror2.getId(target);
            var clientX = e2.clientX, clientY = e2.clientY;
            $dbab849fc0bcf4ad$var$callbackWrapper(mouseInteractionCb)((0, $hwO3w._)({
                type: $dbab849fc0bcf4ad$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY
            }, pointerType !== null && {
                pointerType: pointerType
            }));
        };
    };
    Object.keys($dbab849fc0bcf4ad$var$MouseInteractions).filter(function(key) {
        return Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false;
    }).forEach(function(eventKey) {
        var eventName = $dbab849fc0bcf4ad$var$toLowerCase(eventKey);
        var handler = getHandler(eventKey);
        if (window.PointerEvent) switch($dbab849fc0bcf4ad$var$MouseInteractions[eventKey]){
            case $dbab849fc0bcf4ad$var$MouseInteractions.MouseDown:
            case $dbab849fc0bcf4ad$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $dbab849fc0bcf4ad$var$MouseInteractions.TouchStart:
            case $dbab849fc0bcf4ad$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($dbab849fc0bcf4ad$var$on(eventName, handler, doc));
    });
    return $dbab849fc0bcf4ad$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $dbab849fc0bcf4ad$var$initScrollObserver(param) {
    var scrollCb = param.scrollCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, sampling = param.sampling;
    var updatePosition = $dbab849fc0bcf4ad$var$callbackWrapper($dbab849fc0bcf4ad$var$throttle$1($dbab849fc0bcf4ad$var$callbackWrapper(function(evt) {
        var target = $dbab849fc0bcf4ad$var$getEventTarget(evt);
        if (!target || $dbab849fc0bcf4ad$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        var id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            var scrollLeftTop = $dbab849fc0bcf4ad$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $dbab849fc0bcf4ad$var$on("scroll", updatePosition, doc);
}
function $dbab849fc0bcf4ad$var$initViewportResizeObserver(param, param1) {
    var viewportResizeCb = param.viewportResizeCb, win = param1.win;
    var lastH = -1;
    var lastW = -1;
    var updateDimension = $dbab849fc0bcf4ad$var$callbackWrapper($dbab849fc0bcf4ad$var$throttle$1($dbab849fc0bcf4ad$var$callbackWrapper(function() {
        var height = $dbab849fc0bcf4ad$var$getWindowHeight();
        var width = $dbab849fc0bcf4ad$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $dbab849fc0bcf4ad$var$on("resize", updateDimension, win);
}
var $dbab849fc0bcf4ad$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
var $dbab849fc0bcf4ad$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $dbab849fc0bcf4ad$var$initInputObserver(param) {
    var inputCb = param.inputCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, ignoreClass = param.ignoreClass, ignoreSelector = param.ignoreSelector, maskInputOptions = param.maskInputOptions, maskInputFn = param.maskInputFn, sampling = param.sampling, userTriggeredOnInput = param.userTriggeredOnInput, maskTextClass = param.maskTextClass, unmaskTextClass = param.unmaskTextClass, maskTextSelector = param.maskTextSelector, unmaskTextSelector = param.unmaskTextSelector;
    var _handlers;
    function eventHandler(event) {
        var target = $dbab849fc0bcf4ad$var$getEventTarget(event);
        var userTriggered = event.isTrusted;
        var tagName = target && $dbab849fc0bcf4ad$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $dbab849fc0bcf4ad$var$INPUT_TAGS.indexOf(tagName) < 0 || $dbab849fc0bcf4ad$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        var el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        var type = $dbab849fc0bcf4ad$var$getInputType(target);
        var text = $dbab849fc0bcf4ad$var$getInputValue(el, tagName, type);
        var isChecked = false;
        var isInputMasked = $dbab849fc0bcf4ad$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        var forceMask = $dbab849fc0bcf4ad$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $dbab849fc0bcf4ad$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        var name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll('input[type="radio"][name="'.concat(name, '"]')).forEach(function(el2) {
            if (el2 !== target) {
                var text2 = $dbab849fc0bcf4ad$var$maskInputValue({
                    // share mask behavior of `target`
                    isMasked: forceMask,
                    element: el2,
                    value: $dbab849fc0bcf4ad$var$getInputValue(el2, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el2, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        var lastInputValue = $dbab849fc0bcf4ad$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $dbab849fc0bcf4ad$var$lastInputValueMap.set(target, v2);
            var id = mirror2.getId(target);
            $dbab849fc0bcf4ad$var$callbackWrapper(inputCb)((0, $lf4fc._)((0, $hwO3w._)({}, v2), {
                id: id
            }));
        }
    }
    var events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    var handlers = events.map(function(eventName) {
        return $dbab849fc0bcf4ad$var$on(eventName, $dbab849fc0bcf4ad$var$callbackWrapper(eventHandler), doc);
    });
    var currentWindow = doc.defaultView;
    if (!currentWindow) return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
    var propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    var hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) (_handlers = handlers).push.apply(_handlers, (0, $XnYkK._)(hookProperties.map(function(p) {
        return $dbab849fc0bcf4ad$var$hookSetter(p[0], p[1], {
            set: function() {
                $dbab849fc0bcf4ad$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow);
    })));
    return $dbab849fc0bcf4ad$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $dbab849fc0bcf4ad$var$getNestedCSSRulePositions(rule) {
    var positions = [];
    function recurse(childRule, pos) {
        if ($dbab849fc0bcf4ad$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $dbab849fc0bcf4ad$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $dbab849fc0bcf4ad$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $dbab849fc0bcf4ad$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            var rules2 = Array.from(childRule.parentRule.cssRules);
            var index = rules2.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            var rules21 = Array.from(childRule.parentStyleSheet.cssRules);
            var index1 = rules21.indexOf(childRule);
            pos.unshift(index1);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $dbab849fc0bcf4ad$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    var id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $dbab849fc0bcf4ad$var$initStyleSheetObserver(param, param1) {
    var styleSheetRuleCb = param.styleSheetRuleCb, mirror2 = param.mirror, stylesheetManager = param.stylesheetManager, win = param1.win;
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return function() {};
    var insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $dbab849fc0bcf4ad$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _argumentsList = (0, $6iP9u._)(argumentsList, 2), rule = _argumentsList[0], index = _argumentsList[1];
            var _getIdAndStyleId = $dbab849fc0bcf4ad$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $dbab849fc0bcf4ad$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _argumentsList = (0, $6iP9u._)(argumentsList, 1), index = _argumentsList[0];
            var _getIdAndStyleId = $dbab849fc0bcf4ad$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $dbab849fc0bcf4ad$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, $6iP9u._)(argumentsList, 1), text = _argumentsList[0];
                var _getIdAndStyleId = $dbab849fc0bcf4ad$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $dbab849fc0bcf4ad$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, $6iP9u._)(argumentsList, 1), text = _argumentsList[0];
                var _getIdAndStyleId = $dbab849fc0bcf4ad$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var supportedNestedCSSRuleTypes = {};
    if ($dbab849fc0bcf4ad$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($dbab849fc0bcf4ad$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($dbab849fc0bcf4ad$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($dbab849fc0bcf4ad$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    var unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
        var _param = (0, $6iP9u._)(param, 2), typeKey = _param[0], type = _param[1];
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $dbab849fc0bcf4ad$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, $6iP9u._)(argumentsList, 2), rule = _argumentsList[0], index = _argumentsList[1];
                var _getIdAndStyleId = $dbab849fc0bcf4ad$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: (0, $XnYkK._)($dbab849fc0bcf4ad$var$getNestedCSSRulePositions(thisArg)).concat([
                                index || 0
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $dbab849fc0bcf4ad$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, $6iP9u._)(argumentsList, 1), index = _argumentsList[0];
                var _getIdAndStyleId = $dbab849fc0bcf4ad$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: (0, $XnYkK._)($dbab849fc0bcf4ad$var$getNestedCSSRulePositions(thisArg)).concat([
                                index
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $dbab849fc0bcf4ad$var$callbackWrapper(function() {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
            var _param = (0, $6iP9u._)(param, 2), typeKey = _param[0], type = _param[1];
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $dbab849fc0bcf4ad$var$initAdoptedStyleSheetObserver(param, host) {
    var mirror2 = param.mirror, stylesheetManager = param.stylesheetManager;
    var _host_defaultView, _host_ownerDocument_defaultView, _host_ownerDocument;
    var hostId = null;
    if (host.nodeName === "#document") hostId = mirror2.getId(host);
    else hostId = mirror2.getId(host.host);
    var patchTarget = host.nodeName === "#document" ? (_host_defaultView = host.defaultView) === null || _host_defaultView === void 0 ? void 0 : _host_defaultView.Document : (_host_ownerDocument = host.ownerDocument) === null || _host_ownerDocument === void 0 ? void 0 : (_host_ownerDocument_defaultView = _host_ownerDocument.defaultView) === null || _host_ownerDocument_defaultView === void 0 ? void 0 : _host_ownerDocument_defaultView.ShadowRoot;
    var originalPropertyDescriptor = (patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return function() {};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get: function() {
            var _originalPropertyDescriptor_get;
            return (_originalPropertyDescriptor_get = originalPropertyDescriptor.get) === null || _originalPropertyDescriptor_get === void 0 ? void 0 : _originalPropertyDescriptor_get.call(this);
        },
        set: function(sheets) {
            var _originalPropertyDescriptor_set;
            var result = (_originalPropertyDescriptor_set = originalPropertyDescriptor.set) === null || _originalPropertyDescriptor_set === void 0 ? void 0 : _originalPropertyDescriptor_set.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result;
        }
    });
    return $dbab849fc0bcf4ad$var$callbackWrapper(function() {
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $dbab849fc0bcf4ad$var$initStyleDeclarationObserver(param, param1) {
    var styleDeclarationCb = param.styleDeclarationCb, mirror2 = param.mirror, ignoreCSSAttributes = param.ignoreCSSAttributes, stylesheetManager = param.stylesheetManager, win = param1.win;
    var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $dbab849fc0bcf4ad$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _thisArg_parentRule;
            var _argumentsList = (0, $6iP9u._)(argumentsList, 3), property = _argumentsList[0], value = _argumentsList[1], priority = _argumentsList[2];
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            var _getIdAndStyleId = $dbab849fc0bcf4ad$var$getIdAndStyleId((_thisArg_parentRule = thisArg.parentRule) === null || _thisArg_parentRule === void 0 ? void 0 : _thisArg_parentRule.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $dbab849fc0bcf4ad$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $dbab849fc0bcf4ad$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _thisArg_parentRule;
            var _argumentsList = (0, $6iP9u._)(argumentsList, 1), property = _argumentsList[0];
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            var _getIdAndStyleId = $dbab849fc0bcf4ad$var$getIdAndStyleId((_thisArg_parentRule = thisArg.parentRule) === null || _thisArg_parentRule === void 0 ? void 0 : _thisArg_parentRule.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $dbab849fc0bcf4ad$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $dbab849fc0bcf4ad$var$callbackWrapper(function() {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $dbab849fc0bcf4ad$var$initMediaInteractionObserver(param) {
    var mediaInteractionCb = param.mediaInteractionCb, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, mirror2 = param.mirror, sampling = param.sampling, doc = param.doc;
    var handler = $dbab849fc0bcf4ad$var$callbackWrapper(function(type) {
        return $dbab849fc0bcf4ad$var$throttle$1($dbab849fc0bcf4ad$var$callbackWrapper(function(event) {
            var target = $dbab849fc0bcf4ad$var$getEventTarget(event);
            if (!target || $dbab849fc0bcf4ad$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            var currentTime = target.currentTime, volume = target.volume, muted = target.muted, playbackRate = target.playbackRate;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500);
    });
    var handlers = [
        $dbab849fc0bcf4ad$var$on("play", handler($dbab849fc0bcf4ad$var$MediaInteractions.Play), doc),
        $dbab849fc0bcf4ad$var$on("pause", handler($dbab849fc0bcf4ad$var$MediaInteractions.Pause), doc),
        $dbab849fc0bcf4ad$var$on("seeked", handler($dbab849fc0bcf4ad$var$MediaInteractions.Seeked), doc),
        $dbab849fc0bcf4ad$var$on("volumechange", handler($dbab849fc0bcf4ad$var$MediaInteractions.VolumeChange), doc),
        $dbab849fc0bcf4ad$var$on("ratechange", handler($dbab849fc0bcf4ad$var$MediaInteractions.RateChange), doc)
    ];
    return $dbab849fc0bcf4ad$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $dbab849fc0bcf4ad$var$initFontObserver(param) {
    var fontCb = param.fontCb, doc = param.doc;
    var win = doc.defaultView;
    if (!win) return function() {};
    var handlers = [];
    var fontMap = /* @__PURE__ */ new WeakMap();
    var originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        var fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    var restoreHandler = $dbab849fc0bcf4ad$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $dbab849fc0bcf4ad$var$setTimeout$2($dbab849fc0bcf4ad$var$callbackWrapper(function() {
                var p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(function() {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $dbab849fc0bcf4ad$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $dbab849fc0bcf4ad$var$initSelectionObserver(param) {
    var doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, selectionCb = param.selectionCb;
    var collapsed = true;
    var updateSelection = $dbab849fc0bcf4ad$var$callbackWrapper(function() {
        var selection = doc.getSelection();
        if (!selection || collapsed && (selection === null || selection === void 0 ? void 0 : selection.isCollapsed)) return;
        collapsed = selection.isCollapsed || false;
        var ranges = [];
        var count = selection.rangeCount || 0;
        for(var i2 = 0; i2 < count; i2++){
            var range = selection.getRangeAt(i2);
            var startContainer = range.startContainer, startOffset = range.startOffset, endContainer = range.endContainer, endOffset = range.endOffset;
            var blocked = $dbab849fc0bcf4ad$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $dbab849fc0bcf4ad$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $dbab849fc0bcf4ad$var$on("selectionchange", updateSelection);
}
function $dbab849fc0bcf4ad$var$initCustomElementObserver(param) {
    var doc = param.doc, customElementCb = param.customElementCb;
    var win = doc.defaultView;
    if (!win || !win.customElements) return function() {};
    var restoreHandler = $dbab849fc0bcf4ad$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $dbab849fc0bcf4ad$var$initObservers(o2) {
    var _hooks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var currentWindow = o2.doc.defaultView;
    if (!currentWindow) return function() {};
    var mutationObserver;
    if (o2.recordDOM) mutationObserver = $dbab849fc0bcf4ad$var$initMutationObserver(o2, o2.doc);
    var mousemoveHandler = $dbab849fc0bcf4ad$var$initMoveObserver(o2);
    var mouseInteractionHandler = $dbab849fc0bcf4ad$var$initMouseInteractionObserver(o2);
    var scrollHandler = $dbab849fc0bcf4ad$var$initScrollObserver(o2);
    var viewportResizeHandler = $dbab849fc0bcf4ad$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    var inputHandler = $dbab849fc0bcf4ad$var$initInputObserver(o2);
    var mediaInteractionHandler = $dbab849fc0bcf4ad$var$initMediaInteractionObserver(o2);
    var styleSheetObserver = function() {};
    var adoptedStyleSheetObserver = function() {};
    var styleDeclarationObserver = function() {};
    var fontObserver = function() {};
    if (o2.recordDOM) {
        styleSheetObserver = $dbab849fc0bcf4ad$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $dbab849fc0bcf4ad$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $dbab849fc0bcf4ad$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $dbab849fc0bcf4ad$var$initFontObserver(o2);
    }
    var selectionObserver = $dbab849fc0bcf4ad$var$initSelectionObserver(o2);
    var customElementObserver = $dbab849fc0bcf4ad$var$initCustomElementObserver(o2);
    var pluginHandlers = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = o2.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var plugin = _step.value;
            pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $dbab849fc0bcf4ad$var$callbackWrapper(function() {
        $dbab849fc0bcf4ad$var$mutationBuffers.forEach(function(b) {
            return b.reset();
        });
        mutationObserver === null || mutationObserver === void 0 ? void 0 : mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach(function(h) {
            return h();
        });
    });
}
function $dbab849fc0bcf4ad$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $dbab849fc0bcf4ad$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
var $dbab849fc0bcf4ad$var$CrossOriginIframeMirror = /*#__PURE__*/ function() {
    "use strict";
    function CrossOriginIframeMirror(generateIdFn) {
        (0, $5Epmf._)(this, CrossOriginIframeMirror);
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
        this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
    }
    (0, $9MqXK._)(CrossOriginIframeMirror, [
        {
            key: "getId",
            value: function getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
                var idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
                var remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
                var id = idToRemoteIdMap.get(remoteId);
                if (!id) {
                    id = this.generateIdFn();
                    idToRemoteIdMap.set(remoteId, id);
                    remoteIdToIdMap.set(id, remoteId);
                }
                return id;
            }
        },
        {
            key: "getIds",
            value: function getIds(iframe, remoteId) {
                var _this = this;
                var idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
                var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
                return remoteId.map(function(id) {
                    return _this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap);
                });
            }
        },
        {
            key: "getRemoteId",
            value: function getRemoteId(iframe, id, map) {
                var remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
                if (typeof id !== "number") return id;
                var remoteId = remoteIdToIdMap.get(id);
                if (!remoteId) return -1;
                return remoteId;
            }
        },
        {
            key: "getRemoteIds",
            value: function getRemoteIds(iframe, ids) {
                var _this = this;
                var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
                return ids.map(function(id) {
                    return _this.getRemoteId(iframe, id, remoteIdToIdMap);
                });
            }
        },
        {
            key: "reset",
            value: function reset(iframe) {
                if (!iframe) {
                    this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
                    this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
                    return;
                }
                this.iframeIdToRemoteIdMap.delete(iframe);
                this.iframeRemoteIdToIdMap.delete(iframe);
            }
        },
        {
            key: "getIdToRemoteIdMap",
            value: function getIdToRemoteIdMap(iframe) {
                var idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
                if (!idToRemoteIdMap) {
                    idToRemoteIdMap = /* @__PURE__ */ new Map();
                    this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
                }
                return idToRemoteIdMap;
            }
        },
        {
            key: "getRemoteIdToIdMap",
            value: function getRemoteIdToIdMap(iframe) {
                var remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
                if (!remoteIdToIdMap) {
                    remoteIdToIdMap = /* @__PURE__ */ new Map();
                    this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
                }
                return remoteIdToIdMap;
            }
        }
    ]);
    return CrossOriginIframeMirror;
}();
var $dbab849fc0bcf4ad$var$IframeManagerNoop = /*#__PURE__*/ function() {
    "use strict";
    function IframeManagerNoop() {
        (0, $5Epmf._)(this, IframeManagerNoop);
        this.crossOriginIframeMirror = new $dbab849fc0bcf4ad$var$CrossOriginIframeMirror($dbab849fc0bcf4ad$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
    }
    (0, $9MqXK._)(IframeManagerNoop, [
        {
            key: "addIframe",
            value: function addIframe() {}
        },
        {
            key: "addLoadListener",
            value: function addLoadListener() {}
        },
        {
            key: "attachIframe",
            value: function attachIframe() {}
        }
    ]);
    return IframeManagerNoop;
}();
var $dbab849fc0bcf4ad$var$IframeManager = /*#__PURE__*/ function() {
    "use strict";
    function IframeManager(options) {
        (0, $5Epmf._)(this, IframeManager);
        this.iframes = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMirror = new $dbab849fc0bcf4ad$var$CrossOriginIframeMirror($dbab849fc0bcf4ad$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $dbab849fc0bcf4ad$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    (0, $9MqXK._)(IframeManager, [
        {
            key: "addIframe",
            value: function addIframe(iframeEl) {
                this.iframes.set(iframeEl, true);
                var contentWindow = $dbab849fc0bcf4ad$var$getIFrameContentWindow(iframeEl);
                if (contentWindow) this.crossOriginIframeMap.set(contentWindow, iframeEl);
            }
        },
        {
            key: "addLoadListener",
            value: function addLoadListener(cb) {
                this.loadListener = cb;
            }
        },
        {
            key: "attachIframe",
            value: function attachIframe(iframeEl, childSn) {
                var _getIFrameContentWindow, _this_loadListener, _this;
                this.mutationCb({
                    adds: [
                        {
                            parentId: this.mirror.getId(iframeEl),
                            nextId: null,
                            node: childSn
                        }
                    ],
                    removes: [],
                    texts: [],
                    attributes: [],
                    isAttachIframe: true
                });
                if (this.recordCrossOriginIframes) (_getIFrameContentWindow = $dbab849fc0bcf4ad$var$getIFrameContentWindow(iframeEl)) === null || _getIFrameContentWindow === void 0 ? void 0 : _getIFrameContentWindow.addEventListener("message", this.handleMessage.bind(this));
                (_this_loadListener = (_this = this).loadListener) === null || _this_loadListener === void 0 ? void 0 : _this_loadListener.call(_this, iframeEl);
                var iframeDoc = $dbab849fc0bcf4ad$var$getIFrameContentDocument(iframeEl);
                if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeDoc.adoptedStyleSheets, this.mirror.getId(iframeDoc));
            }
        },
        {
            key: "handleMessage",
            value: function handleMessage(message) {
                var crossOriginMessageEvent = message;
                if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
                crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
                var iframeSourceWindow = message.source;
                if (!iframeSourceWindow) return;
                var iframeEl = this.crossOriginIframeMap.get(message.source);
                if (!iframeEl) return;
                var transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
                if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
            }
        },
        {
            key: "transformCrossOriginEvent",
            value: function transformCrossOriginEvent(iframeEl, e2) {
                var _this = this;
                switch(e2.type){
                    case $dbab849fc0bcf4ad$var$EventType.FullSnapshot:
                        {
                            this.crossOriginIframeMirror.reset(iframeEl);
                            this.crossOriginIframeStyleMirror.reset(iframeEl);
                            this.replaceIdOnNode(e2.data.node, iframeEl);
                            var rootId = e2.data.node.id;
                            this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                            this.patchRootIdOnNode(e2.data.node, rootId);
                            return {
                                timestamp: e2.timestamp,
                                type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
                                data: {
                                    source: $dbab849fc0bcf4ad$var$IncrementalSource.Mutation,
                                    adds: [
                                        {
                                            parentId: this.mirror.getId(iframeEl),
                                            nextId: null,
                                            node: e2.data.node
                                        }
                                    ],
                                    removes: [],
                                    texts: [],
                                    attributes: [],
                                    isAttachIframe: true
                                }
                            };
                        }
                    case $dbab849fc0bcf4ad$var$EventType.Meta:
                    case $dbab849fc0bcf4ad$var$EventType.Load:
                    case $dbab849fc0bcf4ad$var$EventType.DomContentLoaded:
                        return false;
                    case $dbab849fc0bcf4ad$var$EventType.Plugin:
                        return e2;
                    case $dbab849fc0bcf4ad$var$EventType.Custom:
                        this.replaceIds(e2.data.payload, iframeEl, [
                            "id",
                            "parentId",
                            "previousId",
                            "nextId"
                        ]);
                        return e2;
                    case $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot:
                        switch(e2.data.source){
                            case $dbab849fc0bcf4ad$var$IncrementalSource.Mutation:
                                e2.data.adds.forEach(function(n2) {
                                    _this.replaceIds(n2, iframeEl, [
                                        "parentId",
                                        "nextId",
                                        "previousId"
                                    ]);
                                    _this.replaceIdOnNode(n2.node, iframeEl);
                                    var rootId = _this.crossOriginIframeRootIdMap.get(iframeEl);
                                    rootId && _this.patchRootIdOnNode(n2.node, rootId);
                                });
                                e2.data.removes.forEach(function(n2) {
                                    _this.replaceIds(n2, iframeEl, [
                                        "parentId",
                                        "id"
                                    ]);
                                });
                                e2.data.attributes.forEach(function(n2) {
                                    _this.replaceIds(n2, iframeEl, [
                                        "id"
                                    ]);
                                });
                                e2.data.texts.forEach(function(n2) {
                                    _this.replaceIds(n2, iframeEl, [
                                        "id"
                                    ]);
                                });
                                return e2;
                            case $dbab849fc0bcf4ad$var$IncrementalSource.Drag:
                            case $dbab849fc0bcf4ad$var$IncrementalSource.TouchMove:
                            case $dbab849fc0bcf4ad$var$IncrementalSource.MouseMove:
                                e2.data.positions.forEach(function(p) {
                                    _this.replaceIds(p, iframeEl, [
                                        "id"
                                    ]);
                                });
                                return e2;
                            case $dbab849fc0bcf4ad$var$IncrementalSource.ViewportResize:
                                return false;
                            case $dbab849fc0bcf4ad$var$IncrementalSource.MediaInteraction:
                            case $dbab849fc0bcf4ad$var$IncrementalSource.MouseInteraction:
                            case $dbab849fc0bcf4ad$var$IncrementalSource.Scroll:
                            case $dbab849fc0bcf4ad$var$IncrementalSource.CanvasMutation:
                            case $dbab849fc0bcf4ad$var$IncrementalSource.Input:
                                this.replaceIds(e2.data, iframeEl, [
                                    "id"
                                ]);
                                return e2;
                            case $dbab849fc0bcf4ad$var$IncrementalSource.StyleSheetRule:
                            case $dbab849fc0bcf4ad$var$IncrementalSource.StyleDeclaration:
                                this.replaceIds(e2.data, iframeEl, [
                                    "id"
                                ]);
                                this.replaceStyleIds(e2.data, iframeEl, [
                                    "styleId"
                                ]);
                                return e2;
                            case $dbab849fc0bcf4ad$var$IncrementalSource.Font:
                                return e2;
                            case $dbab849fc0bcf4ad$var$IncrementalSource.Selection:
                                e2.data.ranges.forEach(function(range) {
                                    _this.replaceIds(range, iframeEl, [
                                        "start",
                                        "end"
                                    ]);
                                });
                                return e2;
                            case $dbab849fc0bcf4ad$var$IncrementalSource.AdoptedStyleSheet:
                                var _e2_data_styles;
                                this.replaceIds(e2.data, iframeEl, [
                                    "id"
                                ]);
                                this.replaceStyleIds(e2.data, iframeEl, [
                                    "styleIds"
                                ]);
                                (_e2_data_styles = e2.data.styles) === null || _e2_data_styles === void 0 ? void 0 : _e2_data_styles.forEach(function(style) {
                                    _this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                });
                                return e2;
                        }
                }
                return false;
            }
        },
        {
            key: "replace",
            value: function replace(iframeMirror, obj, iframeEl, keys) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
                        if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
                        else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return obj;
            }
        },
        {
            key: "replaceIds",
            value: function replaceIds(obj, iframeEl, keys) {
                return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
            }
        },
        {
            key: "replaceStyleIds",
            value: function replaceStyleIds(obj, iframeEl, keys) {
                return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
            }
        },
        {
            key: "replaceIdOnNode",
            value: function replaceIdOnNode(node, iframeEl) {
                var _this = this;
                this.replaceIds(node, iframeEl, [
                    "id",
                    "rootId"
                ]);
                if ("childNodes" in node) node.childNodes.forEach(function(child) {
                    _this.replaceIdOnNode(child, iframeEl);
                });
            }
        },
        {
            key: "patchRootIdOnNode",
            value: function patchRootIdOnNode(node, rootId) {
                var _this = this;
                if (node.type !== $dbab849fc0bcf4ad$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
                if ("childNodes" in node) node.childNodes.forEach(function(child) {
                    _this.patchRootIdOnNode(child, rootId);
                });
            }
        }
    ]);
    return IframeManager;
}();
var $dbab849fc0bcf4ad$var$ShadowDomManagerNoop = /*#__PURE__*/ function() {
    "use strict";
    function ShadowDomManagerNoop() {
        (0, $5Epmf._)(this, ShadowDomManagerNoop);
    }
    (0, $9MqXK._)(ShadowDomManagerNoop, [
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "addShadowRoot",
            value: function addShadowRoot() {}
        },
        {
            key: "observeAttachShadow",
            value: function observeAttachShadow() {}
        },
        {
            key: "reset",
            value: function reset() {}
        }
    ]);
    return ShadowDomManagerNoop;
}();
var $dbab849fc0bcf4ad$var$ShadowDomManager = /*#__PURE__*/ function() {
    "use strict";
    function ShadowDomManager(options) {
        (0, $5Epmf._)(this, ShadowDomManager);
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    (0, $9MqXK._)(ShadowDomManager, [
        {
            key: "init",
            value: function init() {
                this.reset();
                this.patchAttachShadow(Element, document);
            }
        },
        {
            key: "addShadowRoot",
            value: function addShadowRoot(shadowRoot, doc) {
                var _this = this;
                if (!$dbab849fc0bcf4ad$var$isNativeShadowDom(shadowRoot)) return;
                if (this.shadowDoms.has(shadowRoot)) return;
                this.shadowDoms.add(shadowRoot);
                this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
                var observer = $dbab849fc0bcf4ad$var$initMutationObserver((0, $lf4fc._)((0, $hwO3w._)({}, this.bypassOptions), {
                    doc: doc,
                    mutationCb: this.mutationCb,
                    mirror: this.mirror,
                    shadowDomManager: this
                }), shadowRoot);
                this.restoreHandlers.push(function() {
                    return observer.disconnect();
                });
                this.restoreHandlers.push($dbab849fc0bcf4ad$var$initScrollObserver((0, $lf4fc._)((0, $hwO3w._)({}, this.bypassOptions), {
                    scrollCb: this.scrollCb,
                    // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
                    // scroll is not allowed to pass the boundary, so we need to listen the shadow document
                    doc: shadowRoot,
                    mirror: this.mirror
                })));
                $dbab849fc0bcf4ad$var$setTimeout$2(function() {
                    if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) _this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, _this.mirror.getId(shadowRoot.host));
                    _this.restoreHandlers.push($dbab849fc0bcf4ad$var$initAdoptedStyleSheetObserver({
                        mirror: _this.mirror,
                        stylesheetManager: _this.bypassOptions.stylesheetManager
                    }, shadowRoot));
                }, 0);
            }
        },
        {
            /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ key: "observeAttachShadow",
            value: function observeAttachShadow(iframeElement) {
                var iframeDoc = $dbab849fc0bcf4ad$var$getIFrameContentDocument(iframeElement);
                var iframeWindow = $dbab849fc0bcf4ad$var$getIFrameContentWindow(iframeElement);
                if (!iframeDoc || !iframeWindow) return;
                this.patchAttachShadow(iframeWindow.Element, iframeDoc);
            }
        },
        {
            /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ key: "patchAttachShadow",
            value: function patchAttachShadow(element, doc) {
                var manager = this;
                this.restoreHandlers.push($dbab849fc0bcf4ad$var$patch(element.prototype, "attachShadow", function(original) {
                    return function(option) {
                        var shadowRoot = original.call(this, option);
                        if (this.shadowRoot && $dbab849fc0bcf4ad$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                        return shadowRoot;
                    };
                }));
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.restoreHandlers.forEach(function(handler) {
                    try {
                        handler();
                    } catch (e2) {}
                });
                this.restoreHandlers = [];
                this.shadowDoms = /* @__PURE__ */ new WeakSet();
                this.bypassOptions.canvasManager.resetShadowRoots();
            }
        }
    ]);
    return ShadowDomManager;
}();
var $dbab849fc0bcf4ad$var$StylesheetManager = /*#__PURE__*/ function() {
    "use strict";
    function StylesheetManager(options) {
        (0, $5Epmf._)(this, StylesheetManager);
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
        this.styleMirror = new $dbab849fc0bcf4ad$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    (0, $9MqXK._)(StylesheetManager, [
        {
            key: "attachLinkElement",
            value: function attachLinkElement(linkEl, childSn) {
                if ("_cssText" in childSn.attributes) this.mutationCb({
                    adds: [],
                    removes: [],
                    texts: [],
                    attributes: [
                        {
                            id: childSn.id,
                            attributes: childSn.attributes
                        }
                    ]
                });
                this.trackLinkElement(linkEl);
            }
        },
        {
            key: "trackLinkElement",
            value: function trackLinkElement(linkEl) {
                if (this.trackedLinkElements.has(linkEl)) return;
                this.trackedLinkElements.add(linkEl);
                this.trackStylesheetInLinkElement(linkEl);
            }
        },
        {
            key: "adoptStyleSheets",
            value: function adoptStyleSheets(sheets, hostId) {
                if (sheets.length === 0) return;
                var adoptedStyleSheetData = {
                    id: hostId,
                    styleIds: []
                };
                var styles = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = sheets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sheet = _step.value;
                        var styleId = void 0;
                        if (!this.styleMirror.has(sheet)) {
                            styleId = this.styleMirror.add(sheet);
                            styles.push({
                                styleId: styleId,
                                rules: Array.from(sheet.rules || CSSRule, function(r2, index) {
                                    return {
                                        rule: $dbab849fc0bcf4ad$var$stringifyRule(r2),
                                        index: index
                                    };
                                })
                            });
                        } else styleId = this.styleMirror.getId(sheet);
                        adoptedStyleSheetData.styleIds.push(styleId);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (styles.length > 0) adoptedStyleSheetData.styles = styles;
                this.adoptedStyleSheetCb(adoptedStyleSheetData);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.styleMirror.reset();
                this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
            }
        },
        {
            // TODO: take snapshot on stylesheet reload by applying event listener
            key: "trackStylesheetInLinkElement",
            value: function trackStylesheetInLinkElement(_linkEl) {}
        }
    ]);
    return StylesheetManager;
}();
var $dbab849fc0bcf4ad$var$ProcessedNodeManager = /*#__PURE__*/ function() {
    "use strict";
    function ProcessedNodeManager() {
        (0, $5Epmf._)(this, ProcessedNodeManager);
        this.nodeMap = /* @__PURE__ */ new WeakMap();
        this.active = false;
    }
    (0, $9MqXK._)(ProcessedNodeManager, [
        {
            key: "inOtherBuffer",
            value: function inOtherBuffer(node, thisBuffer) {
                var buffers = this.nodeMap.get(node);
                return buffers && Array.from(buffers).some(function(buffer) {
                    return buffer !== thisBuffer;
                });
            }
        },
        {
            key: "add",
            value: function add(node, buffer) {
                var _this = this;
                if (!this.active) {
                    this.active = true;
                    $dbab849fc0bcf4ad$var$onRequestAnimationFrame(function() {
                        _this.nodeMap = /* @__PURE__ */ new WeakMap();
                        _this.active = false;
                    });
                }
                this.nodeMap.set(node, (this.nodeMap.get(node) || /* @__PURE__ */ new Set()).add(buffer));
            }
        },
        {
            key: "destroy",
            value: function destroy() {}
        }
    ]);
    return ProcessedNodeManager;
}();
var $dbab849fc0bcf4ad$var$wrappedEmit;
var $dbab849fc0bcf4ad$var$_takeFullSnapshot;
try {
    if (Array.from([
        1
    ], function(x) {
        return x * 2;
    })[0] !== 2) {
        var $dbab849fc0bcf4ad$var$_cleanFrame_contentWindow;
        var $dbab849fc0bcf4ad$var$cleanFrame = document.createElement("iframe");
        document.body.appendChild($dbab849fc0bcf4ad$var$cleanFrame);
        Array.from = (($dbab849fc0bcf4ad$var$_cleanFrame_contentWindow = $dbab849fc0bcf4ad$var$cleanFrame.contentWindow) === null || $dbab849fc0bcf4ad$var$_cleanFrame_contentWindow === void 0 ? void 0 : $dbab849fc0bcf4ad$var$_cleanFrame_contentWindow.Array.from) || Array.from;
        document.body.removeChild($dbab849fc0bcf4ad$var$cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
var $dbab849fc0bcf4ad$var$mirror = $dbab849fc0bcf4ad$var$createMirror();
function $dbab849fc0bcf4ad$var$record() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var emit = options.emit, checkoutEveryNms = options.checkoutEveryNms, checkoutEveryNth = options.checkoutEveryNth, _options_blockClass = options.blockClass, blockClass = _options_blockClass === void 0 ? "rr-block" : _options_blockClass, _options_blockSelector = options.blockSelector, blockSelector = _options_blockSelector === void 0 ? null : _options_blockSelector, _options_unblockSelector = options.unblockSelector, unblockSelector = _options_unblockSelector === void 0 ? null : _options_unblockSelector, _options_ignoreClass = options.ignoreClass, ignoreClass = _options_ignoreClass === void 0 ? "rr-ignore" : _options_ignoreClass, _options_ignoreSelector = options.ignoreSelector, ignoreSelector = _options_ignoreSelector === void 0 ? null : _options_ignoreSelector, _options_maskAllText = options.maskAllText, maskAllText = _options_maskAllText === void 0 ? false : _options_maskAllText, _options_maskTextClass = options.maskTextClass, maskTextClass = _options_maskTextClass === void 0 ? "rr-mask" : _options_maskTextClass, _options_unmaskTextClass = options.unmaskTextClass, unmaskTextClass = _options_unmaskTextClass === void 0 ? null : _options_unmaskTextClass, _options_maskTextSelector = options.maskTextSelector, maskTextSelector = _options_maskTextSelector === void 0 ? null : _options_maskTextSelector, _options_unmaskTextSelector = options.unmaskTextSelector, unmaskTextSelector = _options_unmaskTextSelector === void 0 ? null : _options_unmaskTextSelector, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, maskAllInputs = options.maskAllInputs, _maskInputOptions = options.maskInputOptions, _slimDOMOptions = options.slimDOMOptions, maskAttributeFn = options.maskAttributeFn, maskInputFn = options.maskInputFn, maskTextFn = options.maskTextFn, _options_maxCanvasSize = options.maxCanvasSize, maxCanvasSize = _options_maxCanvasSize === void 0 ? null : _options_maxCanvasSize, packFn = options.packFn, _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? {} : _options_sampling, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, mousemoveWait = options.mousemoveWait, _options_recordDOM = options.recordDOM, recordDOM = _options_recordDOM === void 0 ? true : _options_recordDOM, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, _options_recordCrossOriginIframes = options.recordCrossOriginIframes, recordCrossOriginIframes = _options_recordCrossOriginIframes === void 0 ? false : _options_recordCrossOriginIframes, _options_recordAfter = options.recordAfter, recordAfter = _options_recordAfter === void 0 ? options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load" : _options_recordAfter, _options_userTriggeredOnInput = options.userTriggeredOnInput, userTriggeredOnInput = _options_userTriggeredOnInput === void 0 ? false : _options_userTriggeredOnInput, _options_collectFonts = options.collectFonts, collectFonts = _options_collectFonts === void 0 ? false : _options_collectFonts, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, plugins = options.plugins, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_ignoreCSSAttributes = options.ignoreCSSAttributes, ignoreCSSAttributes = _options_ignoreCSSAttributes === void 0 ? /* @__PURE__ */ new Set([]) : _options_ignoreCSSAttributes, errorHandler = options.errorHandler, onMutation = options.onMutation, getCanvasManager = options.getCanvasManager;
    $dbab849fc0bcf4ad$var$registerErrorHandler(errorHandler);
    var inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    var passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return function() {};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $dbab849fc0bcf4ad$var$mirror.reset();
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {};
    var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $dbab849fc0bcf4ad$var$polyfill();
    var lastFullSnapshotEvent;
    var incrementalSnapshotCount = 0;
    var eventProcessor = function(e2) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (plugins || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var plugin = _step.value;
                if (plugin.eventProcessor) e2 = plugin.eventProcessor(e2);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $dbab849fc0bcf4ad$var$wrappedEmit = function(r2, isCheckout) {
        var _mutationBuffers_;
        var e2 = r2;
        e2.timestamp = $dbab849fc0bcf4ad$var$nowTimestamp();
        if (((_mutationBuffers_ = $dbab849fc0bcf4ad$var$mutationBuffers[0]) === null || _mutationBuffers_ === void 0 ? void 0 : _mutationBuffers_.isFrozen()) && e2.type !== $dbab849fc0bcf4ad$var$EventType.FullSnapshot && !(e2.type === $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot && e2.data.source === $dbab849fc0bcf4ad$var$IncrementalSource.Mutation)) $dbab849fc0bcf4ad$var$mutationBuffers.forEach(function(buf) {
            return buf.unfreeze();
        });
        if (inEmittingFrame) emit === null || emit === void 0 ? void 0 : emit(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            var message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $dbab849fc0bcf4ad$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot) {
            if (e2.data.source === $dbab849fc0bcf4ad$var$IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            var exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot2(true);
        }
    };
    var wrappedMutationEmit = function(m) {
        $dbab849fc0bcf4ad$var$wrappedEmit({
            type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
            data: (0, $hwO3w._)({
                source: $dbab849fc0bcf4ad$var$IncrementalSource.Mutation
            }, m)
        });
    };
    var wrappedScrollEmit = function(p) {
        return $dbab849fc0bcf4ad$var$wrappedEmit({
            type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
            data: (0, $hwO3w._)({
                source: $dbab849fc0bcf4ad$var$IncrementalSource.Scroll
            }, p)
        });
    };
    var wrappedCanvasMutationEmit = function(p) {
        return $dbab849fc0bcf4ad$var$wrappedEmit({
            type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
            data: (0, $hwO3w._)({
                source: $dbab849fc0bcf4ad$var$IncrementalSource.CanvasMutation
            }, p)
        });
    };
    var wrappedAdoptedStyleSheetEmit = function(a2) {
        return $dbab849fc0bcf4ad$var$wrappedEmit({
            type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
            data: (0, $hwO3w._)({
                source: $dbab849fc0bcf4ad$var$IncrementalSource.AdoptedStyleSheet
            }, a2)
        });
    };
    var stylesheetManager = new $dbab849fc0bcf4ad$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    var iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $dbab849fc0bcf4ad$var$IframeManagerNoop() : new $dbab849fc0bcf4ad$var$IframeManager({
        mirror: $dbab849fc0bcf4ad$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $dbab849fc0bcf4ad$var$wrappedEmit
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (plugins || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var plugin = _step.value;
            if (plugin.getMirror) plugin.getMirror({
                nodeMirror: $dbab849fc0bcf4ad$var$mirror,
                crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
                crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var processedNodeManager = new $dbab849fc0bcf4ad$var$ProcessedNodeManager();
    var canvasManager = $dbab849fc0bcf4ad$var$_getCanvasManager(getCanvasManager, {
        mirror: $dbab849fc0bcf4ad$var$mirror,
        win: window,
        mutationCb: function(p) {
            return $dbab849fc0bcf4ad$var$wrappedEmit({
                type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
                data: (0, $hwO3w._)({
                    source: $dbab849fc0bcf4ad$var$IncrementalSource.CanvasMutation
                }, p)
            });
        },
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    var shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $dbab849fc0bcf4ad$var$ShadowDomManagerNoop() : new $dbab849fc0bcf4ad$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager,
            ignoreCSSAttributes: ignoreCSSAttributes
        },
        mirror: $dbab849fc0bcf4ad$var$mirror
    });
    var takeFullSnapshot2 = function() {
        var isCheckout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (!recordDOM) return;
        $dbab849fc0bcf4ad$var$wrappedEmit({
            type: $dbab849fc0bcf4ad$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $dbab849fc0bcf4ad$var$getWindowWidth(),
                height: $dbab849fc0bcf4ad$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $dbab849fc0bcf4ad$var$mutationBuffers.forEach(function(buf) {
            return buf.lock();
        });
        var node = $dbab849fc0bcf4ad$var$snapshot(document, {
            mirror: $dbab849fc0bcf4ad$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: function(n2) {
                if ($dbab849fc0bcf4ad$var$isSerializedIframe(n2, $dbab849fc0bcf4ad$var$mirror)) iframeManager.addIframe(n2);
                if ($dbab849fc0bcf4ad$var$isSerializedStylesheet(n2, $dbab849fc0bcf4ad$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($dbab849fc0bcf4ad$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot(n2.shadowRoot, document);
            },
            onIframeLoad: function(iframe, childSn) {
                iframeManager.attachIframe(iframe, childSn);
                var contentWindow = $dbab849fc0bcf4ad$var$getIFrameContentWindow(iframe);
                if (contentWindow) canvasManager.addWindow(contentWindow);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: function(linkEl, childSn) {
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            onBlockedImageLoad: function(_imageEl, serializedNode, param) {
                var width = param.width, height = param.height;
                wrappedMutationEmit({
                    adds: [],
                    removes: [],
                    texts: [],
                    attributes: [
                        {
                            id: serializedNode.id,
                            attributes: {
                                style: {
                                    width: "".concat(width, "px"),
                                    height: "".concat(height, "px")
                                }
                            }
                        }
                    ]
                });
            },
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $dbab849fc0bcf4ad$var$wrappedEmit({
            type: $dbab849fc0bcf4ad$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $dbab849fc0bcf4ad$var$getWindowScroll(window)
            }
        });
        $dbab849fc0bcf4ad$var$mutationBuffers.forEach(function(buf) {
            return buf.unlock();
        });
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $dbab849fc0bcf4ad$var$mirror.getId(document));
    };
    $dbab849fc0bcf4ad$var$_takeFullSnapshot = takeFullSnapshot2;
    try {
        var handlers = [];
        var observe = function(doc) {
            var _plugins_filter;
            return $dbab849fc0bcf4ad$var$callbackWrapper($dbab849fc0bcf4ad$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: function(positions, source) {
                    return $dbab849fc0bcf4ad$var$wrappedEmit({
                        type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    });
                },
                mouseInteractionCb: function(d) {
                    return $dbab849fc0bcf4ad$var$wrappedEmit({
                        type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
                        data: (0, $hwO3w._)({
                            source: $dbab849fc0bcf4ad$var$IncrementalSource.MouseInteraction
                        }, d)
                    });
                },
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: function(d) {
                    return $dbab849fc0bcf4ad$var$wrappedEmit({
                        type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
                        data: (0, $hwO3w._)({
                            source: $dbab849fc0bcf4ad$var$IncrementalSource.ViewportResize
                        }, d)
                    });
                },
                inputCb: function(v2) {
                    return $dbab849fc0bcf4ad$var$wrappedEmit({
                        type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
                        data: (0, $hwO3w._)({
                            source: $dbab849fc0bcf4ad$var$IncrementalSource.Input
                        }, v2)
                    });
                },
                mediaInteractionCb: function(p) {
                    return $dbab849fc0bcf4ad$var$wrappedEmit({
                        type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
                        data: (0, $hwO3w._)({
                            source: $dbab849fc0bcf4ad$var$IncrementalSource.MediaInteraction
                        }, p)
                    });
                },
                styleSheetRuleCb: function(r2) {
                    return $dbab849fc0bcf4ad$var$wrappedEmit({
                        type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
                        data: (0, $hwO3w._)({
                            source: $dbab849fc0bcf4ad$var$IncrementalSource.StyleSheetRule
                        }, r2)
                    });
                },
                styleDeclarationCb: function(r2) {
                    return $dbab849fc0bcf4ad$var$wrappedEmit({
                        type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
                        data: (0, $hwO3w._)({
                            source: $dbab849fc0bcf4ad$var$IncrementalSource.StyleDeclaration
                        }, r2)
                    });
                },
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: function(p) {
                    return $dbab849fc0bcf4ad$var$wrappedEmit({
                        type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
                        data: (0, $hwO3w._)({
                            source: $dbab849fc0bcf4ad$var$IncrementalSource.Font
                        }, p)
                    });
                },
                selectionCb: function(p) {
                    $dbab849fc0bcf4ad$var$wrappedEmit({
                        type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
                        data: (0, $hwO3w._)({
                            source: $dbab849fc0bcf4ad$var$IncrementalSource.Selection
                        }, p)
                    });
                },
                customElementCb: function(c2) {
                    $dbab849fc0bcf4ad$var$wrappedEmit({
                        type: $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot,
                        data: (0, $hwO3w._)({
                            source: $dbab849fc0bcf4ad$var$IncrementalSource.CustomElement
                        }, c2)
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $dbab849fc0bcf4ad$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (plugins === null || plugins === void 0 ? void 0 : (_plugins_filter = plugins.filter(function(p) {
                    return p.observer;
                })) === null || _plugins_filter === void 0 ? void 0 : _plugins_filter.map(function(p) {
                    return {
                        observer: p.observer,
                        options: p.options,
                        callback: function(payload) {
                            return $dbab849fc0bcf4ad$var$wrappedEmit({
                                type: $dbab849fc0bcf4ad$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            });
                        }
                    };
                })) || []
            }, {});
        };
        iframeManager.addLoadListener(function(iframeEl) {
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        var init = function() {
            takeFullSnapshot2();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($dbab849fc0bcf4ad$var$on("DOMContentLoaded", function() {
                $dbab849fc0bcf4ad$var$wrappedEmit({
                    type: $dbab849fc0bcf4ad$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($dbab849fc0bcf4ad$var$on("load", function() {
                $dbab849fc0bcf4ad$var$wrappedEmit({
                    type: $dbab849fc0bcf4ad$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return function() {
            handlers.forEach(function(h) {
                return h();
            });
            processedNodeManager.destroy();
            $dbab849fc0bcf4ad$var$_takeFullSnapshot = void 0;
            $dbab849fc0bcf4ad$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $dbab849fc0bcf4ad$var$takeFullSnapshot(isCheckout) {
    if (!$dbab849fc0bcf4ad$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $dbab849fc0bcf4ad$var$_takeFullSnapshot(isCheckout);
}
$dbab849fc0bcf4ad$var$record.mirror = $dbab849fc0bcf4ad$var$mirror;
$dbab849fc0bcf4ad$var$record.takeFullSnapshot = $dbab849fc0bcf4ad$var$takeFullSnapshot;
function $dbab849fc0bcf4ad$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $dbab849fc0bcf4ad$var$CanvasManagerNoop();
    } catch (e) {
        console.warn("Unable to initialize CanvasManager");
        return new $dbab849fc0bcf4ad$var$CanvasManagerNoop();
    }
}
var $dbab849fc0bcf4ad$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($dbab849fc0bcf4ad$var$n || ($dbab849fc0bcf4ad$var$n = {}));
var $dbab849fc0bcf4ad$var$ReplayEventTypeIncrementalSnapshot = 3;
var $dbab849fc0bcf4ad$var$ReplayEventTypeCustom = 5;
function $dbab849fc0bcf4ad$var$timestampToMs(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1e3;
}
function $dbab849fc0bcf4ad$var$timestampToS(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $dbab849fc0bcf4ad$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(function() {
        replay.throttledAddEvent({
            type: $dbab849fc0bcf4ad$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1e3,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $74542fb861c25274$export$a3295358bff77e)(breadcrumb, 10, 1e3)
            }
        });
        return breadcrumb.category === "console";
    });
}
var $dbab849fc0bcf4ad$var$INTERACTIVE_SELECTOR = "button,a";
function $dbab849fc0bcf4ad$var$getClosestInteractive(element) {
    var closestInteractive = element.closest($dbab849fc0bcf4ad$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
function $dbab849fc0bcf4ad$var$getClickTargetNode(event) {
    var target = $dbab849fc0bcf4ad$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $dbab849fc0bcf4ad$var$getClosestInteractive(target);
}
function $dbab849fc0bcf4ad$var$getTargetNode(event) {
    if ($dbab849fc0bcf4ad$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $dbab849fc0bcf4ad$var$isEventWithTarget(event) {
    return (0, $6ea82c15e37d9720$export$c10d0b04eaa80a43)(event) && "target" in event;
}
var $dbab849fc0bcf4ad$var$handlers;
function $dbab849fc0bcf4ad$var$onWindowOpen(cb) {
    if (!$dbab849fc0bcf4ad$var$handlers) {
        $dbab849fc0bcf4ad$var$handlers = [];
        $dbab849fc0bcf4ad$var$monkeyPatchWindowOpen();
    }
    $dbab849fc0bcf4ad$var$handlers.push(cb);
    return function() {
        var pos = $dbab849fc0bcf4ad$var$handlers ? $dbab849fc0bcf4ad$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $dbab849fc0bcf4ad$var$handlers.splice(pos, 1);
    };
}
function $dbab849fc0bcf4ad$var$monkeyPatchWindowOpen() {
    (0, $27958f6402fc5d96$export$9563e054e6f787fb)($dbab849fc0bcf4ad$var$WINDOW, "open", function(originalWindowOpen) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if ($dbab849fc0bcf4ad$var$handlers) try {
                $dbab849fc0bcf4ad$var$handlers.forEach(function(handler) {
                    return handler();
                });
            } catch (e) {}
            return originalWindowOpen.apply($dbab849fc0bcf4ad$var$WINDOW, args);
        };
    });
}
var $dbab849fc0bcf4ad$var$IncrementalMutationSources = /* @__PURE__ */ new Set([
    $dbab849fc0bcf4ad$var$IncrementalSource.Mutation,
    $dbab849fc0bcf4ad$var$IncrementalSource.StyleSheetRule,
    $dbab849fc0bcf4ad$var$IncrementalSource.StyleDeclaration,
    $dbab849fc0bcf4ad$var$IncrementalSource.AdoptedStyleSheet,
    $dbab849fc0bcf4ad$var$IncrementalSource.CanvasMutation,
    $dbab849fc0bcf4ad$var$IncrementalSource.Selection,
    $dbab849fc0bcf4ad$var$IncrementalSource.MediaInteraction
]);
function $dbab849fc0bcf4ad$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
var $dbab849fc0bcf4ad$var$ClickDetector = /*#__PURE__*/ function() {
    "use strict";
    function ClickDetector(replay, slowClickConfig) {
        var _addBreadcrumbEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $dbab849fc0bcf4ad$var$addBreadcrumbEvent;
        (0, $5Epmf._)(this, ClickDetector);
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        this._timeout = slowClickConfig.timeout / 1e3;
        this._threshold = slowClickConfig.threshold / 1e3;
        this._scrollTimeout = slowClickConfig.scrollTimeout / 1e3;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    (0, $9MqXK._)(ClickDetector, [
        {
            /** Register click detection handlers on mutation or scroll. */ key: "addListeners",
            value: function addListeners() {
                var _this = this;
                var cleanupWindowOpen = $dbab849fc0bcf4ad$var$onWindowOpen(function() {
                    _this._lastMutation = $dbab849fc0bcf4ad$var$nowInSeconds();
                });
                this._teardown = function() {
                    cleanupWindowOpen();
                    _this._clicks = [];
                    _this._lastMutation = 0;
                    _this._lastScroll = 0;
                };
            }
        },
        {
            /** Clean up listeners. */ key: "removeListeners",
            value: function removeListeners() {
                if (this._teardown) this._teardown();
                if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
            }
        },
        {
            /** @inheritDoc */ key: "handleClick",
            value: function handleClick(breadcrumb, node) {
                if ($dbab849fc0bcf4ad$var$ignoreElement(node, this._ignoreSelector) || !$dbab849fc0bcf4ad$var$isClickBreadcrumb(breadcrumb)) return;
                var newClick = {
                    timestamp: $dbab849fc0bcf4ad$var$timestampToS(breadcrumb.timestamp),
                    clickBreadcrumb: breadcrumb,
                    // Set this to 0 so we know it originates from the click breadcrumb
                    clickCount: 0,
                    node: node
                };
                if (this._clicks.some(function(click) {
                    return click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1;
                })) return;
                this._clicks.push(newClick);
                if (this._clicks.length === 1) this._scheduleCheckClicks();
            }
        },
        {
            /** @inheritDoc */ key: "registerMutation",
            value: function registerMutation() {
                var timestamp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                this._lastMutation = $dbab849fc0bcf4ad$var$timestampToS(timestamp);
            }
        },
        {
            /** @inheritDoc */ key: "registerScroll",
            value: function registerScroll() {
                var timestamp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                this._lastScroll = $dbab849fc0bcf4ad$var$timestampToS(timestamp);
            }
        },
        {
            /** @inheritDoc */ key: "registerClick",
            value: function registerClick(element) {
                var node = $dbab849fc0bcf4ad$var$getClosestInteractive(element);
                this._handleMultiClick(node);
            }
        },
        {
            /** Count multiple clicks on elements. */ key: "_handleMultiClick",
            value: function _handleMultiClick(node) {
                this._getClicks(node).forEach(function(click) {
                    click.clickCount++;
                });
            }
        },
        {
            /** Get all pending clicks for a given node. */ key: "_getClicks",
            value: function _getClicks(node) {
                return this._clicks.filter(function(click) {
                    return click.node === node;
                });
            }
        },
        {
            /** Check the clicks that happened. */ key: "_checkClicks",
            value: function _checkClicks() {
                var _this = this;
                var timedOutClicks = [];
                var now = $dbab849fc0bcf4ad$var$nowInSeconds();
                this._clicks.forEach(function(click) {
                    if (!click.mutationAfter && _this._lastMutation) click.mutationAfter = click.timestamp <= _this._lastMutation ? _this._lastMutation - click.timestamp : void 0;
                    if (!click.scrollAfter && _this._lastScroll) click.scrollAfter = click.timestamp <= _this._lastScroll ? _this._lastScroll - click.timestamp : void 0;
                    if (click.timestamp + _this._timeout <= now) timedOutClicks.push(click);
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = timedOutClicks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var click = _step.value;
                        var pos = this._clicks.indexOf(click);
                        if (pos > -1) {
                            this._generateBreadcrumbs(click);
                            this._clicks.splice(pos, 1);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._clicks.length) this._scheduleCheckClicks();
            }
        },
        {
            /** Generate matching breadcrumb(s) for the click. */ key: "_generateBreadcrumbs",
            value: function _generateBreadcrumbs(click) {
                var replay = this._replay;
                var hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
                var hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
                var isSlowClick = !hadScroll && !hadMutation;
                var clickCount = click.clickCount, clickBreadcrumb = click.clickBreadcrumb;
                if (isSlowClick) {
                    var timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1e3;
                    var endReason = timeAfterClickMs < this._timeout * 1e3 ? "mutation" : "timeout";
                    var breadcrumb = {
                        type: "default",
                        message: clickBreadcrumb.message,
                        timestamp: clickBreadcrumb.timestamp,
                        category: "ui.slowClickDetected",
                        data: (0, $lf4fc._)((0, $hwO3w._)({}, clickBreadcrumb.data), {
                            url: $dbab849fc0bcf4ad$var$WINDOW.location.href,
                            route: replay.getCurrentRoute(),
                            timeAfterClickMs: timeAfterClickMs,
                            endReason: endReason,
                            // If clickCount === 0, it means multiClick was not correctly captured here
                            // - we still want to send 1 in this case
                            clickCount: clickCount || 1
                        })
                    };
                    this._addBreadcrumbEvent(replay, breadcrumb);
                    return;
                }
                if (clickCount > 1) {
                    var breadcrumb1 = {
                        type: "default",
                        message: clickBreadcrumb.message,
                        timestamp: clickBreadcrumb.timestamp,
                        category: "ui.multiClick",
                        data: (0, $lf4fc._)((0, $hwO3w._)({}, clickBreadcrumb.data), {
                            url: $dbab849fc0bcf4ad$var$WINDOW.location.href,
                            route: replay.getCurrentRoute(),
                            clickCount: clickCount,
                            metric: true
                        })
                    };
                    this._addBreadcrumbEvent(replay, breadcrumb1);
                }
            }
        },
        {
            /** Schedule to check current clicks. */ key: "_scheduleCheckClicks",
            value: function _scheduleCheckClicks() {
                var _this = this;
                if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
                this._checkClickTimeout = (0, $d26b11a6b11dd4e3$export$831dc9f2ab0a617b)(function() {
                    return _this._checkClicks();
                }, 1e3);
            }
        }
    ]);
    return ClickDetector;
}();
var $dbab849fc0bcf4ad$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
function $dbab849fc0bcf4ad$var$ignoreElement(node, ignoreSelector) {
    if (!$dbab849fc0bcf4ad$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $dbab849fc0bcf4ad$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
function $dbab849fc0bcf4ad$var$nowInSeconds() {
    return Date.now() / 1e3;
}
function $dbab849fc0bcf4ad$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        if (!$dbab849fc0bcf4ad$var$isIncrementalEvent(event)) return;
        var source = event.data.source;
        if ($dbab849fc0bcf4ad$var$IncrementalMutationSources.has(source)) clickDetector.registerMutation(event.timestamp);
        if (source === $dbab849fc0bcf4ad$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($dbab849fc0bcf4ad$var$isIncrementalMouseInteraction(event)) {
            var _event_data = event.data, type = _event_data.type, id = _event_data.id;
            var node = $dbab849fc0bcf4ad$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $dbab849fc0bcf4ad$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {}
}
function $dbab849fc0bcf4ad$var$isIncrementalEvent(event) {
    return event.type === $dbab849fc0bcf4ad$var$ReplayEventTypeIncrementalSnapshot;
}
function $dbab849fc0bcf4ad$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $dbab849fc0bcf4ad$var$IncrementalSource.MouseInteraction;
}
function $dbab849fc0bcf4ad$var$createBreadcrumb(breadcrumb) {
    return (0, $hwO3w._)({
        timestamp: Date.now() / 1e3,
        type: "default"
    }, breadcrumb);
}
var $dbab849fc0bcf4ad$var$NodeType = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}($dbab849fc0bcf4ad$var$NodeType || {});
var $dbab849fc0bcf4ad$var$ATTRIBUTES_TO_RECORD = /* @__PURE__ */ new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
function $dbab849fc0bcf4ad$var$getAttributesToRecord(attributes) {
    var obj = {};
    if (!attributes["data-sentry-component"] && attributes["data-sentry-element"]) attributes["data-sentry-component"] = attributes["data-sentry-element"];
    for(var key in attributes)if ($dbab849fc0bcf4ad$var$ATTRIBUTES_TO_RECORD.has(key)) {
        var normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
var $dbab849fc0bcf4ad$var$handleDomListener = function(replay) {
    return function(handlerData) {
        if (!replay.isEnabled()) return;
        var result = $dbab849fc0bcf4ad$var$handleDom(handlerData);
        if (!result) return;
        var isClick = handlerData.name === "click";
        var event = isClick ? handlerData.event : void 0;
        if (isClick && replay.clickDetector && (event === null || event === void 0 ? void 0 : event.target) && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $dbab849fc0bcf4ad$var$handleClick(replay.clickDetector, result, $dbab849fc0bcf4ad$var$getClickTargetNode(handlerData.event));
        $dbab849fc0bcf4ad$var$addBreadcrumbEvent(replay, result);
    };
};
function $dbab849fc0bcf4ad$var$getBaseDomBreadcrumb(target, message) {
    var nodeId = $dbab849fc0bcf4ad$var$record.mirror.getId(target);
    var node = nodeId && $dbab849fc0bcf4ad$var$record.mirror.getNode(nodeId);
    var meta = node && $dbab849fc0bcf4ad$var$record.mirror.getMeta(node);
    var element = meta && $dbab849fc0bcf4ad$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map(function(node2) {
                    return node2.type === $dbab849fc0bcf4ad$var$NodeType.Text && node2.textContent;
                }).filter(Boolean).map(function(text) {
                    return text.trim();
                }).join(""),
                attributes: $dbab849fc0bcf4ad$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
function $dbab849fc0bcf4ad$var$handleDom(handlerData) {
    var _getDomTarget = $dbab849fc0bcf4ad$var$getDomTarget(handlerData), target = _getDomTarget.target, message = _getDomTarget.message;
    return $dbab849fc0bcf4ad$var$createBreadcrumb((0, $hwO3w._)({
        category: "ui.".concat(handlerData.name)
    }, $dbab849fc0bcf4ad$var$getBaseDomBreadcrumb(target, message)));
}
function $dbab849fc0bcf4ad$var$getDomTarget(handlerData) {
    var isClick = handlerData.name === "click";
    var message;
    var target = null;
    try {
        target = isClick ? $dbab849fc0bcf4ad$var$getClickTargetNode(handlerData.event) : $dbab849fc0bcf4ad$var$getTargetNode(handlerData.event);
        message = (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $dbab849fc0bcf4ad$var$isElement(node) {
    return node.type === $dbab849fc0bcf4ad$var$NodeType.Element;
}
function $dbab849fc0bcf4ad$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    replay.updateUserActivity();
    var breadcrumb = $dbab849fc0bcf4ad$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $dbab849fc0bcf4ad$var$addBreadcrumbEvent(replay, breadcrumb);
}
function $dbab849fc0bcf4ad$var$getKeyboardBreadcrumb(event) {
    var metaKey = event.metaKey, shiftKey = event.shiftKey, ctrlKey = event.ctrlKey, altKey = event.altKey, key = event.key, target = event.target;
    if (!target || $dbab849fc0bcf4ad$var$isInputElement(target) || !key) return null;
    var hasModifierKey = metaKey || ctrlKey || altKey;
    var isCharacterKey = key.length === 1;
    if (!hasModifierKey && isCharacterKey) return null;
    var message = (0, $bf34547bb00b7a11$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    var baseBreadcrumb = $dbab849fc0bcf4ad$var$getBaseDomBreadcrumb(target, message);
    return $dbab849fc0bcf4ad$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: (0, $lf4fc._)((0, $hwO3w._)({}, baseBreadcrumb.data), {
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        })
    });
}
function $dbab849fc0bcf4ad$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
var $dbab849fc0bcf4ad$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $dbab849fc0bcf4ad$var$createResourceEntry,
    paint: $dbab849fc0bcf4ad$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $dbab849fc0bcf4ad$var$createNavigationEntry
};
function $dbab849fc0bcf4ad$var$webVitalHandler(getter, replay) {
    return function(param) {
        var metric = param.metric;
        return void replay.replayPerformanceEntries.push(getter(metric));
    };
}
function $dbab849fc0bcf4ad$var$createPerformanceEntries(entries) {
    return entries.map($dbab849fc0bcf4ad$var$createPerformanceEntry).filter(Boolean);
}
function $dbab849fc0bcf4ad$var$createPerformanceEntry(entry) {
    var entryType = $dbab849fc0bcf4ad$var$ENTRY_TYPES[entry.entryType];
    if (!entryType) return null;
    return entryType(entry);
}
function $dbab849fc0bcf4ad$var$getAbsoluteTime(time) {
    return (((0, $7b1d57c4c7d6952d$export$baf075a948ffc0bf)() || $dbab849fc0bcf4ad$var$WINDOW.performance.timeOrigin) + time) / 1e3;
}
function $dbab849fc0bcf4ad$var$createPaintEntry(entry) {
    var duration = entry.duration, entryType = entry.entryType, name = entry.name, startTime = entry.startTime;
    var start = $dbab849fc0bcf4ad$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: void 0
    };
}
function $dbab849fc0bcf4ad$var$createNavigationEntry(entry) {
    var entryType = entry.entryType, name = entry.name, decodedBodySize = entry.decodedBodySize, duration = entry.duration, domComplete = entry.domComplete, encodedBodySize = entry.encodedBodySize, domContentLoadedEventStart = entry.domContentLoadedEventStart, domContentLoadedEventEnd = entry.domContentLoadedEventEnd, domInteractive = entry.domInteractive, loadEventStart = entry.loadEventStart, loadEventEnd = entry.loadEventEnd, redirectCount = entry.redirectCount, startTime = entry.startTime, transferSize = entry.transferSize, type = entry.type;
    if (duration === 0) return null;
    return {
        type: "".concat(entryType, ".").concat(type),
        start: $dbab849fc0bcf4ad$var$getAbsoluteTime(startTime),
        end: $dbab849fc0bcf4ad$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $dbab849fc0bcf4ad$var$createResourceEntry(entry) {
    var entryType = entry.entryType, initiatorType = entry.initiatorType, name = entry.name, responseEnd = entry.responseEnd, startTime = entry.startTime, decodedBodySize = entry.decodedBodySize, encodedBodySize = entry.encodedBodySize, responseStatus = entry.responseStatus, transferSize = entry.transferSize;
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: "".concat(entryType, ".").concat(initiatorType),
        start: $dbab849fc0bcf4ad$var$getAbsoluteTime(startTime),
        end: $dbab849fc0bcf4ad$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
function $dbab849fc0bcf4ad$var$getLargestContentfulPaint(metric) {
    var lastEntry = metric.entries[metric.entries.length - 1];
    var node = (lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.element) ? [
        lastEntry.element
    ] : void 0;
    return $dbab849fc0bcf4ad$var$getWebVital(metric, "largest-contentful-paint", node);
}
function $dbab849fc0bcf4ad$var$isLayoutShift(entry) {
    return entry.sources !== void 0;
}
function $dbab849fc0bcf4ad$var$getCumulativeLayoutShift(metric) {
    var layoutShifts = [];
    var nodes = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = metric.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if ($dbab849fc0bcf4ad$var$isLayoutShift(entry)) {
                var nodeIds = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = entry.sources[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var source = _step1.value;
                        if (source.node) {
                            nodes.push(source.node);
                            var nodeId = $dbab849fc0bcf4ad$var$record.mirror.getId(source.node);
                            if (nodeId) nodeIds.push(nodeId);
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                layoutShifts.push({
                    value: entry.value,
                    nodeIds: nodeIds.length ? nodeIds : void 0
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $dbab849fc0bcf4ad$var$getWebVital(metric, "cumulative-layout-shift", nodes, layoutShifts);
}
function $dbab849fc0bcf4ad$var$getInteractionToNextPaint(metric) {
    var lastEntry = metric.entries[metric.entries.length - 1];
    var node = (lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.target) ? [
        lastEntry.target
    ] : void 0;
    return $dbab849fc0bcf4ad$var$getWebVital(metric, "interaction-to-next-paint", node);
}
function $dbab849fc0bcf4ad$var$getWebVital(metric, name, nodes, attributions) {
    var value = metric.value;
    var rating = metric.rating;
    var end = $dbab849fc0bcf4ad$var$getAbsoluteTime(value);
    return {
        type: "web-vital",
        name: name,
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            rating: rating,
            nodeIds: nodes ? nodes.map(function(node) {
                return $dbab849fc0bcf4ad$var$record.mirror.getId(node);
            }) : void 0,
            attributions: attributions
        }
    };
}
function $dbab849fc0bcf4ad$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries(param) {
        var entries = param.entries;
        entries.forEach(addPerformanceEntry);
    }
    var clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach(function(type) {
        clearCallbacks.push((0, $f7bcc4b265d50461$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $f7bcc4b265d50461$export$3fd4b53331200102)($dbab849fc0bcf4ad$var$webVitalHandler($dbab849fc0bcf4ad$var$getLargestContentfulPaint, replay)), (0, $f7bcc4b265d50461$export$861b82818b37ba5b)($dbab849fc0bcf4ad$var$webVitalHandler($dbab849fc0bcf4ad$var$getCumulativeLayoutShift, replay)), (0, $f7bcc4b265d50461$export$da3b76aa2022cbd7)($dbab849fc0bcf4ad$var$webVitalHandler($dbab849fc0bcf4ad$var$getInteractionToNextPaint, replay)));
    return function() {
        clearCallbacks.forEach(function(clearCallback) {
            return clearCallback();
        });
    };
}
var $dbab849fc0bcf4ad$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
var $dbab849fc0bcf4ad$var$t = 'var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort(function(t,n){return t.f-n.f}),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort(function(t,n){return p[n.s]-p[t.s]||t.f-n.f});s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,s=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),a=s.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(s,n),O(s,a-8,r.d()),O(s,a-4,e),s}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){j.prototype.flush.call(this)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(G)return G.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J((t,n)=>{this.deflate.push(t,n)}),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}}),postMessage({id:void 0,method:"init",success:!0,response:void 0});';
function $dbab849fc0bcf4ad$var$e() {
    var e2 = new Blob([
        $dbab849fc0bcf4ad$var$t
    ], {
        type: "text/javascript"
    });
    return URL.createObjectURL(e2);
}
var $dbab849fc0bcf4ad$var$CONSOLE_LEVELS = [
    "log",
    "warn",
    "error"
];
var $dbab849fc0bcf4ad$var$PREFIX = "[Replay] ";
function $dbab849fc0bcf4ad$var$_addBreadcrumb(message) {
    var level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "info";
    (0, $0d32e047c1999955$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: level,
        message: "".concat($dbab849fc0bcf4ad$var$PREFIX).concat(message)
    }, {
        level: level
    });
}
function $dbab849fc0bcf4ad$var$makeReplayDebugLogger() {
    var _capture = false;
    var _trace = false;
    var _debug = {
        exception: function() {
            return void 0;
        },
        infoTick: function() {
            return void 0;
        },
        setConfig: function(opts) {
            _capture = !!opts.captureExceptions;
            _trace = !!opts.traceInternals;
        }
    };
    if ($dbab849fc0bcf4ad$var$DEBUG_BUILD) {
        $dbab849fc0bcf4ad$var$CONSOLE_LEVELS.forEach(function(name) {
            _debug[name] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _debug$1;
                (_debug$1 = (0, $739716ea0436a6d0$export$1c9f709888824e05))[name].apply(_debug$1, [
                    $dbab849fc0bcf4ad$var$PREFIX
                ].concat((0, $XnYkK._)(args)));
                if (_trace) $dbab849fc0bcf4ad$var$_addBreadcrumb(args.join(""), (0, $2b6d234d6cde8716$export$d771ef054122c30a)(name));
            };
        });
        _debug.exception = function(error) {
            for(var _len = arguments.length, message = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                message[_key - 1] = arguments[_key];
            }
            var _debug1;
            if (message.length && _debug.error) (_debug1 = _debug).error.apply(_debug1, (0, $XnYkK._)(message));
            (0, $739716ea0436a6d0$export$1c9f709888824e05).error($dbab849fc0bcf4ad$var$PREFIX, error);
            if (_capture) (0, $13be2508cc312e06$export$f5282963edea4a68)(error, {
                mechanism: {
                    handled: true,
                    type: "auto.function.replay.debug"
                }
            });
            else if (_trace) $dbab849fc0bcf4ad$var$_addBreadcrumb(error, "error");
        };
        _debug.infoTick = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _debug$1;
            (_debug$1 = (0, $739716ea0436a6d0$export$1c9f709888824e05)).log.apply(_debug$1, [
                $dbab849fc0bcf4ad$var$PREFIX
            ].concat((0, $XnYkK._)(args)));
            if (_trace) setTimeout(function() {
                return $dbab849fc0bcf4ad$var$_addBreadcrumb(args[0]);
            }, 0);
        };
    } else $dbab849fc0bcf4ad$var$CONSOLE_LEVELS.forEach(function(name) {
        _debug[name] = function() {
            return void 0;
        };
    });
    return _debug;
}
var $dbab849fc0bcf4ad$var$debug = $dbab849fc0bcf4ad$var$makeReplayDebugLogger();
var $dbab849fc0bcf4ad$var$EventBufferSizeExceededError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(EventBufferSizeExceededError, Error1);
    function EventBufferSizeExceededError() {
        (0, $5Epmf._)(this, EventBufferSizeExceededError);
        return (0, $48Z0s._)(this, EventBufferSizeExceededError, [
            "Event buffer exceeded maximum size of ".concat($dbab849fc0bcf4ad$var$REPLAY_MAX_EVENT_BUFFER_SIZE, ".")
        ]);
    }
    return EventBufferSizeExceededError;
}((0, $kW1tL._)(Error));
var $dbab849fc0bcf4ad$var$EventBufferArray = /*#__PURE__*/ function() {
    "use strict";
    function EventBufferArray() {
        (0, $5Epmf._)(this, EventBufferArray);
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    (0, $9MqXK._)(EventBufferArray, [
        {
            key: "hasEvents",
            get: /** @inheritdoc */ function get() {
                return this.events.length > 0;
            }
        },
        {
            key: "type",
            get: /** @inheritdoc */ function get() {
                return "sync";
            }
        },
        {
            /** @inheritdoc */ key: "destroy",
            value: function destroy() {
                this.events = [];
            }
        },
        {
            key: "addEvent",
            value: /** @inheritdoc */ function addEvent(event) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var eventSize;
                    return (0, $3SMYb._)(this, function(_state) {
                        eventSize = JSON.stringify(event).length;
                        this._totalSize += eventSize;
                        if (this._totalSize > $dbab849fc0bcf4ad$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $dbab849fc0bcf4ad$var$EventBufferSizeExceededError();
                        this.events.push(event);
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            /** @inheritdoc */ key: "finish",
            value: function finish() {
                var _this = this;
                return new Promise(function(resolve) {
                    var eventsRet = _this.events;
                    _this.clear();
                    resolve(JSON.stringify(eventsRet));
                });
            }
        },
        {
            /** @inheritdoc */ key: "clear",
            value: function clear() {
                this.events = [];
                this._totalSize = 0;
                this.hasCheckout = false;
            }
        },
        {
            /** @inheritdoc */ key: "getEarliestTimestamp",
            value: function getEarliestTimestamp() {
                var ts = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var timestamp = _step.value.timestamp;
                        if (ts === null || timestamp < ts) ts = timestamp;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return ts === null ? ts : $dbab849fc0bcf4ad$var$timestampToMs(ts);
            }
        }
    ]);
    return EventBufferArray;
}();
var $dbab849fc0bcf4ad$var$WorkerHandler = /*#__PURE__*/ function() {
    "use strict";
    function WorkerHandler(worker) {
        var _this = this;
        (0, $5Epmf._)(this, WorkerHandler);
        this._onMessage = function(param) {
            var data = param.data;
            var response = data;
            if (typeof response.id !== "number") return;
            var pending = _this._pending.get(response.id);
            if (!pending || pending.method !== response.method) return;
            _this._pending.delete(response.id);
            if (!response.success) {
                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.error("Error in compression worker: ", response.response);
                pending.reject(new Error("Error in compression worker"));
                return;
            }
            pending.resolve(response.response);
        };
        this._worker = worker;
        this._id = 0;
        this._pending = /* @__PURE__ */ new Map();
        this._worker.addEventListener("message", this._onMessage);
    }
    (0, $9MqXK._)(WorkerHandler, [
        {
            /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ key: "ensureReady",
            value: function ensureReady() {
                var _this = this;
                if (this._ensureReadyPromise) return this._ensureReadyPromise;
                this._ensureReadyPromise = new Promise(function(resolve, reject) {
                    _this._worker.addEventListener("message", function(param) {
                        var data = param.data;
                        if (data.success) resolve();
                        else {
                            $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.warn("Received worker message with unsuccessful status", data);
                            reject(new Error("Received worker message with unsuccessful status"));
                        }
                    }, {
                        once: true
                    });
                    _this._worker.addEventListener("error", function(error) {
                        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.warn("Failed to load Replay compression worker", error);
                        reject(new Error("Failed to load Replay compression worker: ".concat(error instanceof ErrorEvent && error.message ? error.message : "Unknown error. This can happen due to CSP policy restrictions, network issues, or the worker script failing to load.")));
                    }, {
                        once: true
                    });
                });
                return this._ensureReadyPromise;
            }
        },
        {
            /**
   * Destroy the worker.
   */ key: "destroy",
            value: function destroy() {
                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Destroying compression worker");
                this._worker.removeEventListener("message", this._onMessage);
                this._pending.forEach(function(pending) {
                    return pending.reject(new Error("Worker destroyed"));
                });
                this._pending.clear();
                this._worker.terminate();
            }
        },
        {
            /**
   * Post message to worker and wait for response before resolving promise.
   */ key: "postMessage",
            value: function postMessage(method, arg) {
                var _this = this;
                var id = this._getAndIncrementId();
                return new Promise(function(resolve, reject) {
                    _this._pending.set(id, {
                        method: method,
                        resolve: resolve,
                        reject: reject
                    });
                    try {
                        _this._worker.postMessage({
                            id: id,
                            method: method,
                            arg: arg
                        });
                    } catch (error) {
                        _this._pending.delete(id);
                        reject(error);
                    }
                });
            }
        },
        {
            /** Get the current ID and increment it for the next call. */ key: "_getAndIncrementId",
            value: function _getAndIncrementId() {
                return this._id++;
            }
        }
    ]);
    return WorkerHandler;
}();
var $dbab849fc0bcf4ad$var$EventBufferCompressionWorker = /*#__PURE__*/ function() {
    "use strict";
    function EventBufferCompressionWorker(worker) {
        (0, $5Epmf._)(this, EventBufferCompressionWorker);
        this._worker = new $dbab849fc0bcf4ad$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    (0, $9MqXK._)(EventBufferCompressionWorker, [
        {
            key: "hasEvents",
            get: /** @inheritdoc */ function get() {
                return !!this._earliestTimestamp;
            }
        },
        {
            key: "type",
            get: /** @inheritdoc */ function get() {
                return "worker";
            }
        },
        {
            /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ key: "ensureReady",
            value: function ensureReady() {
                return this._worker.ensureReady();
            }
        },
        {
            /**
   * Destroy the event buffer.
   */ key: "destroy",
            value: function destroy() {
                this._worker.destroy();
            }
        },
        {
            /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */ key: "addEvent",
            value: function addEvent(event) {
                var timestamp = $dbab849fc0bcf4ad$var$timestampToMs(event.timestamp);
                if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
                var data = JSON.stringify(event);
                this._totalSize += data.length;
                if (this._totalSize > $dbab849fc0bcf4ad$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $dbab849fc0bcf4ad$var$EventBufferSizeExceededError());
                return this._sendEventToWorker(data);
            }
        },
        {
            /**
   * Finish the event buffer and return the compressed data.
   */ key: "finish",
            value: function finish() {
                return this._finishRequest();
            }
        },
        {
            /** @inheritdoc */ key: "clear",
            value: function clear() {
                this._earliestTimestamp = null;
                this._totalSize = 0;
                this.hasCheckout = false;
                this._worker.postMessage("clear").then(null, function(e) {
                    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(e, 'Sending "clear" message to worker failed', e);
                });
            }
        },
        {
            /** @inheritdoc */ key: "getEarliestTimestamp",
            value: function getEarliestTimestamp() {
                return this._earliestTimestamp;
            }
        },
        {
            /**
   * Send the event to the worker.
   */ key: "_sendEventToWorker",
            value: function _sendEventToWorker(data) {
                return this._worker.postMessage("addEvent", data);
            }
        },
        {
            key: "_finishRequest",
            value: /**
   * Finish the request and return the compressed data from the worker.
   */ function _finishRequest() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var response;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._worker.postMessage("finish")
                                ];
                            case 1:
                                response = _state.sent();
                                this._earliestTimestamp = null;
                                this._totalSize = 0;
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return EventBufferCompressionWorker;
}();
var $dbab849fc0bcf4ad$var$EventBufferProxy = /*#__PURE__*/ function() {
    "use strict";
    function EventBufferProxy(worker) {
        (0, $5Epmf._)(this, EventBufferProxy);
        this._fallback = new $dbab849fc0bcf4ad$var$EventBufferArray();
        this._compression = new $dbab849fc0bcf4ad$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    (0, $9MqXK._)(EventBufferProxy, [
        {
            key: "waitForCheckout",
            get: /** @inheritdoc */ function get() {
                return this._used.waitForCheckout;
            },
            set: /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
            function set(value) {
                this._used.waitForCheckout = value;
            }
        },
        {
            key: "type",
            get: /** @inheritdoc */ function get() {
                return this._used.type;
            }
        },
        {
            key: "hasEvents",
            get: /** @inheritDoc */ function get() {
                return this._used.hasEvents;
            }
        },
        {
            key: "hasCheckout",
            get: /** @inheritdoc */ function get() {
                return this._used.hasCheckout;
            },
            set: /** @inheritdoc */ function set(value) {
                this._used.hasCheckout = value;
            }
        },
        {
            /** @inheritDoc */ key: "destroy",
            value: function destroy() {
                this._fallback.destroy();
                this._compression.destroy();
            }
        },
        {
            /** @inheritdoc */ key: "clear",
            value: function clear() {
                return this._used.clear();
            }
        },
        {
            /** @inheritdoc */ key: "getEarliestTimestamp",
            value: function getEarliestTimestamp() {
                return this._used.getEarliestTimestamp();
            }
        },
        {
            /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ key: "addEvent",
            value: function addEvent(event) {
                return this._used.addEvent(event);
            }
        },
        {
            key: "finish",
            value: /** @inheritDoc */ function finish() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.ensureWorkerIsLoaded()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    this._used.finish()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /** Ensure the worker has loaded. */ key: "ensureWorkerIsLoaded",
            value: function ensureWorkerIsLoaded() {
                return this._ensureWorkerIsLoadedPromise;
            }
        },
        {
            key: "_ensureWorkerIsLoaded",
            value: /** Actually check if the worker has been loaded. */ function _ensureWorkerIsLoaded() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var error;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    this._compression.ensureReady()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(error, "Failed to load the compression worker, falling back to simple buffer");
                                return [
                                    2
                                ];
                            case 3:
                                return [
                                    4,
                                    this._switchToCompressionWorker()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_switchToCompressionWorker",
            value: /** Switch the used buffer to the compression worker. */ function _switchToCompressionWorker() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _this__fallback, events, hasCheckout, waitForCheckout, addEventPromises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, event, error;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this__fallback = this._fallback, events = _this__fallback.events, hasCheckout = _this__fallback.hasCheckout, waitForCheckout = _this__fallback.waitForCheckout;
                                addEventPromises = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = events[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        event = _step.value;
                                        addEventPromises.push(this._compression.addEvent(event));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this._compression.hasCheckout = hasCheckout;
                                this._compression.waitForCheckout = waitForCheckout;
                                this._used = this._compression;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    Promise.all(addEventPromises)
                                ];
                            case 2:
                                _state.sent();
                                this._fallback.clear();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(error, "Failed to add events when switching buffers.");
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return EventBufferProxy;
}();
function $dbab849fc0bcf4ad$var$createEventBuffer(param) {
    var useCompression = param.useCompression, customWorkerUrl = param.workerUrl;
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        var worker = $dbab849fc0bcf4ad$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Using simple buffer");
    return new $dbab849fc0bcf4ad$var$EventBufferArray();
}
function $dbab849fc0bcf4ad$var$_loadWorker(customWorkerUrl) {
    try {
        var workerUrl = customWorkerUrl || $dbab849fc0bcf4ad$var$_getWorkerUrl();
        if (!workerUrl) return;
        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Using compression worker".concat(customWorkerUrl ? " from ".concat(customWorkerUrl) : ""));
        var worker = new Worker(workerUrl);
        return new $dbab849fc0bcf4ad$var$EventBufferProxy(worker);
    } catch (error) {
        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(error, "Failed to create compression worker");
    }
}
function $dbab849fc0bcf4ad$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $dbab849fc0bcf4ad$var$e();
    return "";
}
function $dbab849fc0bcf4ad$var$hasSessionStorage() {
    try {
        return "sessionStorage" in $dbab849fc0bcf4ad$var$WINDOW && !!$dbab849fc0bcf4ad$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
function $dbab849fc0bcf4ad$var$clearSession(replay) {
    $dbab849fc0bcf4ad$var$deleteSession();
    replay.session = void 0;
}
function $dbab849fc0bcf4ad$var$deleteSession() {
    if (!$dbab849fc0bcf4ad$var$hasSessionStorage()) return;
    try {
        $dbab849fc0bcf4ad$var$WINDOW.sessionStorage.removeItem($dbab849fc0bcf4ad$var$REPLAY_SESSION_KEY);
    } catch (e) {}
}
function $dbab849fc0bcf4ad$var$isSampled(sampleRate) {
    if (sampleRate === void 0) return false;
    return Math.random() < sampleRate;
}
function $dbab849fc0bcf4ad$var$saveSession(session) {
    if (!$dbab849fc0bcf4ad$var$hasSessionStorage()) return;
    try {
        $dbab849fc0bcf4ad$var$WINDOW.sessionStorage.setItem($dbab849fc0bcf4ad$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {}
}
function $dbab849fc0bcf4ad$var$makeSession(session) {
    var now = Date.now();
    var id = session.id || (0, $30748c2972c04cd5$export$19f53698e68b2496)();
    var started = session.started || now;
    var lastActivity = session.lastActivity || now;
    var segmentId = session.segmentId || 0;
    var sampled = session.sampled;
    var previousSessionId = session.previousSessionId;
    var dirty = session.dirty || false;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId,
        dirty: dirty
    };
}
function $dbab849fc0bcf4ad$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $dbab849fc0bcf4ad$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
function $dbab849fc0bcf4ad$var$createSession(param) {
    var sessionSampleRate = param.sessionSampleRate, allowBuffering = param.allowBuffering, _param_stickySession = param.stickySession, stickySession = _param_stickySession === void 0 ? false : _param_stickySession, previousSessionId = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).previousSessionId;
    var sampled = $dbab849fc0bcf4ad$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    var session = $dbab849fc0bcf4ad$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $dbab849fc0bcf4ad$var$saveSession(session);
    return session;
}
function $dbab849fc0bcf4ad$var$fetchSession() {
    if (!$dbab849fc0bcf4ad$var$hasSessionStorage()) return null;
    try {
        var sessionStringFromStorage = $dbab849fc0bcf4ad$var$WINDOW.sessionStorage.getItem($dbab849fc0bcf4ad$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        var sessionObj = JSON.parse(sessionStringFromStorage);
        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.infoTick("Loading existing session");
        return $dbab849fc0bcf4ad$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
function $dbab849fc0bcf4ad$var$isExpired(initialTime, expiry) {
    var targetTime = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : +/* @__PURE__ */ new Date();
    if (initialTime === null || expiry === void 0 || expiry < 0) return true;
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
function $dbab849fc0bcf4ad$var$isSessionExpired(session, param) {
    var maxReplayDuration = param.maxReplayDuration, sessionIdleExpire = param.sessionIdleExpire, _param_targetTime = param.targetTime, targetTime = _param_targetTime === void 0 ? Date.now() : _param_targetTime;
    return(// First, check that maximum session length has not been exceeded
    $dbab849fc0bcf4ad$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $dbab849fc0bcf4ad$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
function $dbab849fc0bcf4ad$var$shouldRefreshSession(session, param) {
    var sessionIdleExpire = param.sessionIdleExpire, maxReplayDuration = param.maxReplayDuration;
    if (!$dbab849fc0bcf4ad$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
function $dbab849fc0bcf4ad$var$loadOrCreateSession(param, sessionOptions) {
    var sessionIdleExpire = param.sessionIdleExpire, maxReplayDuration = param.maxReplayDuration, previousSessionId = param.previousSessionId;
    var existingSession = sessionOptions.stickySession && $dbab849fc0bcf4ad$var$fetchSession();
    if (!existingSession) {
        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.infoTick("Creating new session");
        return $dbab849fc0bcf4ad$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$dbab849fc0bcf4ad$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.infoTick("Session in sessionStorage is expired, creating new one...");
    return $dbab849fc0bcf4ad$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $dbab849fc0bcf4ad$var$isCustomEvent(event) {
    return event.type === $dbab849fc0bcf4ad$var$EventType.Custom;
}
function $dbab849fc0bcf4ad$var$addEventSync(replay, event, isCheckout) {
    if (!$dbab849fc0bcf4ad$var$shouldAddEvent(replay, event)) return false;
    $dbab849fc0bcf4ad$var$_addEvent(replay, event, isCheckout);
    return true;
}
function $dbab849fc0bcf4ad$var$addEvent(replay, event, isCheckout) {
    if (!$dbab849fc0bcf4ad$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $dbab849fc0bcf4ad$var$_addEvent(replay, event, isCheckout);
}
function $dbab849fc0bcf4ad$var$_addEvent(replay, event, isCheckout) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var eventBuffer, isBufferMode, replayOptions, eventAfterPossibleCallback, error, isExceeded, reason, client, dropReason;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    eventBuffer = replay.eventBuffer;
                    if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) return [
                        2,
                        null
                    ];
                    isBufferMode = replay.recordingMode === "buffer";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    if (isCheckout && isBufferMode) eventBuffer.clear();
                    if (isCheckout) {
                        eventBuffer.hasCheckout = true;
                        eventBuffer.waitForCheckout = false;
                    }
                    replayOptions = replay.getOptions();
                    eventAfterPossibleCallback = $dbab849fc0bcf4ad$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
                    if (!eventAfterPossibleCallback) return [
                        2
                    ];
                    return [
                        4,
                        eventBuffer.addEvent(eventAfterPossibleCallback)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    error = _state.sent();
                    if (!replay.isEnabled()) {
                        replay.handleException(error);
                        return [
                            2,
                            null
                        ];
                    }
                    isExceeded = error && error instanceof $dbab849fc0bcf4ad$var$EventBufferSizeExceededError;
                    reason = isExceeded ? "eventBufferOverflow" : "eventBufferError";
                    client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
                    if (client) {
                        dropReason = isExceeded ? "buffer_overflow" : "internal_sdk_error";
                        client.recordDroppedEvent(dropReason, "replay");
                    }
                    if (isExceeded && isBufferMode) {
                        eventBuffer.clear();
                        eventBuffer.waitForCheckout = true;
                        return [
                            2,
                            null
                        ];
                    }
                    replay.handleException(error);
                    return [
                        4,
                        replay.stop({
                            reason: reason
                        })
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $dbab849fc0bcf4ad$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    var timestampInMs = $dbab849fc0bcf4ad$var$timestampToMs(event.timestamp);
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.infoTick("Skipping event with timestamp ".concat(timestampInMs, " because it is after maxReplayDuration"));
        return false;
    }
    return true;
}
function $dbab849fc0bcf4ad$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $dbab849fc0bcf4ad$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(error, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...");
        return null;
    }
    return event;
}
var $dbab849fc0bcf4ad$var$MAX_CONTEXT_VALUES = 100;
function $dbab849fc0bcf4ad$var$addSegmentDetailsToContext(replay, traceId, segmentName) {
    var replayContext = replay.getContext();
    if (traceId && replayContext.traceIds.size < $dbab849fc0bcf4ad$var$MAX_CONTEXT_VALUES) replayContext.traceIds.add(traceId);
    if (segmentName && replayContext.segmentNames.size < $dbab849fc0bcf4ad$var$MAX_CONTEXT_VALUES) replayContext.segmentNames.add(segmentName);
}
function $dbab849fc0bcf4ad$var$handleProcessSegmentSpan(replay) {
    return function(spanJSON) {
        if (!replay.isEnabled()) return;
        $dbab849fc0bcf4ad$var$addSegmentDetailsToContext(replay, spanJSON.trace_id, spanJSON.name || void 0);
    };
}
function $dbab849fc0bcf4ad$var$isErrorEvent(event) {
    return !event.type;
}
function $dbab849fc0bcf4ad$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $dbab849fc0bcf4ad$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
function $dbab849fc0bcf4ad$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
function $dbab849fc0bcf4ad$var$handleAfterSendEvent(replay) {
    return function(event, sendResponse) {
        if (!replay.isEnabled() || !$dbab849fc0bcf4ad$var$isErrorEvent(event) && !$dbab849fc0bcf4ad$var$isTransactionEvent(event)) return;
        var statusCode = sendResponse.statusCode;
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($dbab849fc0bcf4ad$var$isTransactionEvent(event)) {
            $dbab849fc0bcf4ad$var$handleTransactionEvent(replay, event);
            return;
        }
        $dbab849fc0bcf4ad$var$handleErrorEvent(replay, event);
    };
}
function $dbab849fc0bcf4ad$var$handleTransactionEvent(replay, event) {
    var _event_contexts_trace, _event_contexts;
    $dbab849fc0bcf4ad$var$addSegmentDetailsToContext(replay, (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : (_event_contexts_trace = _event_contexts.trace) === null || _event_contexts_trace === void 0 ? void 0 : _event_contexts_trace.trace_id, event.transaction);
}
function $dbab849fc0bcf4ad$var$handleErrorEvent(replay, event) {
    var _event_tags;
    var replayContext = replay.getContext();
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    if (replay.recordingMode !== "buffer" || !((_event_tags = event.tags) === null || _event_tags === void 0 ? void 0 : _event_tags.replayId)) return;
    var beforeErrorSampling = replay.getOptions().beforeErrorSampling;
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    (0, $d26b11a6b11dd4e3$export$831dc9f2ab0a617b)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var err;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            replay.sendBufferedReplayOrFlush()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        replay.handleException(err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    });
}
function $dbab849fc0bcf4ad$var$handleBeforeSendEvent(replay) {
    return function(event) {
        if (!replay.isEnabled() || !$dbab849fc0bcf4ad$var$isErrorEvent(event)) return;
        $dbab849fc0bcf4ad$var$handleHydrationError(replay, event);
    };
}
function $dbab849fc0bcf4ad$var$handleHydrationError(replay, event) {
    var _event_exception_values_, _event_exception_values, _event_exception;
    var exceptionValue = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : (_event_exception_values_ = _event_exception_values[0]) === null || _event_exception_values_ === void 0 ? void 0 : _event_exception_values_.value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        var breadcrumb = $dbab849fc0bcf4ad$var$createBreadcrumb({
            category: "replay.hydrate-error",
            data: {
                url: (0, $a7a5fd8a48375ca8$export$1cfafeee2987818b)()
            }
        });
        $dbab849fc0bcf4ad$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
function $dbab849fc0bcf4ad$var$handleBreadcrumbs(replay) {
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    if (!client) return;
    client.on("beforeAddBreadcrumb", function(breadcrumb) {
        return $dbab849fc0bcf4ad$var$beforeAddBreadcrumb(replay, breadcrumb);
    });
}
function $dbab849fc0bcf4ad$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$dbab849fc0bcf4ad$var$isBreadcrumbWithCategory(breadcrumb)) return;
    var result = $dbab849fc0bcf4ad$var$normalizeBreadcrumb(breadcrumb);
    if (result) $dbab849fc0bcf4ad$var$addBreadcrumbEvent(replay, result);
}
function $dbab849fc0bcf4ad$var$normalizeBreadcrumb(breadcrumb) {
    if (!$dbab849fc0bcf4ad$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        "fetch",
        "xhr",
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        "sentry.event",
        "sentry.transaction"
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith("ui.")) return null;
    if (breadcrumb.category === "console") return $dbab849fc0bcf4ad$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $dbab849fc0bcf4ad$var$createBreadcrumb(breadcrumb);
}
function $dbab849fc0bcf4ad$var$normalizeConsoleBreadcrumb(breadcrumb) {
    var _breadcrumb_data;
    var args = (_breadcrumb_data = breadcrumb.data) === null || _breadcrumb_data === void 0 ? void 0 : _breadcrumb_data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $dbab849fc0bcf4ad$var$createBreadcrumb(breadcrumb);
    var isTruncated = false;
    var normalizedArgs = args.map(function(arg) {
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $dbab849fc0bcf4ad$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return "".concat(arg.slice(0, $dbab849fc0bcf4ad$var$CONSOLE_ARG_MAX_SIZE), "\u2026");
            }
            return arg;
        }
        if ((typeof arg === "undefined" ? "undefined" : (0, $03bAP._)(arg)) === "object") try {
            var normalizedArg = (0, $74542fb861c25274$export$a3295358bff77e)(arg, 7);
            var stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $dbab849fc0bcf4ad$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return "".concat(JSON.stringify(normalizedArg, null, 2).slice(0, $dbab849fc0bcf4ad$var$CONSOLE_ARG_MAX_SIZE), "\u2026");
            }
            return normalizedArg;
        } catch (e) {}
        return arg;
    });
    return $dbab849fc0bcf4ad$var$createBreadcrumb((0, $lf4fc._)((0, $hwO3w._)({}, breadcrumb), {
        data: (0, $hwO3w._)((0, $lf4fc._)((0, $hwO3w._)({}, breadcrumb.data), {
            arguments: normalizedArgs
        }), isTruncated ? {
            _meta: {
                warnings: [
                    "CONSOLE_ARG_TRUNCATED"
                ]
            }
        } : {})
    }));
}
function $dbab849fc0bcf4ad$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
function $dbab849fc0bcf4ad$var$isRrwebError(event, hint) {
    var _event_exception_values, _event_exception, _hint_originalException;
    if (event.type || !((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.length)) return false;
    if ((_hint_originalException = hint.originalException) === null || _hint_originalException === void 0 ? void 0 : _hint_originalException.__rrweb__) return true;
    return false;
}
function $dbab849fc0bcf4ad$var$resetReplayIdOnDynamicSamplingContext() {
    var dsc = (0, $945639585ea57ae0$export$c7be4b0125a10cba)().getPropagationContext().dsc;
    if (dsc) delete dsc.replay_id;
    var activeSpan = (0, $79515206909fddff$export$1be426a8e585c83e)();
    if (activeSpan) {
        var dsc2 = (0, $0d1fd6101086a96b$export$a117f995597e25df)(activeSpan);
        delete dsc2.replay_id;
    }
}
function $dbab849fc0bcf4ad$var$setReplayIdOnDynamicSamplingContext(replayId) {
    var dsc = (0, $945639585ea57ae0$export$c7be4b0125a10cba)().getPropagationContext().dsc;
    if (dsc) dsc.replay_id = replayId;
    var activeSpan = (0, $79515206909fddff$export$1be426a8e585c83e)();
    if (activeSpan) {
        var dsc2 = (0, $0d1fd6101086a96b$export$a117f995597e25df)(activeSpan);
        dsc2.replay_id = replayId;
    }
}
function $dbab849fc0bcf4ad$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(function() {
        if (!event.timestamp) return true;
        replay.throttledAddEvent({
            type: $dbab849fc0bcf4ad$var$EventType.Custom,
            timestamp: event.timestamp * 1e3,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
function $dbab849fc0bcf4ad$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    if (event.message === $dbab849fc0bcf4ad$var$UNABLE_TO_SEND_REPLAY) return false;
    if (!event.exception || event.type) return false;
    return $dbab849fc0bcf4ad$var$isSampled(replay.getOptions().errorSampleRate);
}
function $dbab849fc0bcf4ad$var$handleGlobalEventListener(replay) {
    return Object.assign(function(event, hint) {
        var _replay_session;
        if (replay.session && $dbab849fc0bcf4ad$var$shouldRefreshSession(replay.session, {
            maxReplayDuration: replay.getOptions().maxReplayDuration,
            sessionIdleExpire: replay.timeouts.sessionIdleExpire
        })) $dbab849fc0bcf4ad$var$resetReplayIdOnDynamicSamplingContext();
        if (!replay.isEnabled() || replay.isPaused()) return event;
        if ($dbab849fc0bcf4ad$var$isReplayEvent(event)) {
            delete event.breadcrumbs;
            return event;
        }
        if (!$dbab849fc0bcf4ad$var$isErrorEvent(event) && !$dbab849fc0bcf4ad$var$isTransactionEvent(event) && !$dbab849fc0bcf4ad$var$isFeedbackEvent(event)) return event;
        var isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            $dbab849fc0bcf4ad$var$resetReplayIdOnDynamicSamplingContext();
            return event;
        }
        if ($dbab849fc0bcf4ad$var$isFeedbackEvent(event)) {
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            $dbab849fc0bcf4ad$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        if ($dbab849fc0bcf4ad$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Ignoring error from rrweb internals", event);
            return null;
        }
        var isErrorEventSampled = $dbab849fc0bcf4ad$var$shouldSampleForBufferEvent(replay, event);
        var shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = (0, $lf4fc._)((0, $hwO3w._)({}, event.tags), {
            replayId: replay.getSessionId()
        });
        if (isErrorEventSampled && replay.recordingMode === "buffer" && ((_replay_session = replay.session) === null || _replay_session === void 0 ? void 0 : _replay_session.sampled) === "buffer") {
            var session = replay.session;
            session.dirty = true;
            if (replay.getOptions().stickySession) $dbab849fc0bcf4ad$var$saveSession(session);
        }
        return event;
    }, {
        id: "Replay"
    });
}
function $dbab849fc0bcf4ad$var$createPerformanceSpans(replay, entries) {
    return entries.map(function(param) {
        var type = param.type, start = param.start, end = param.end, name = param.name, data = param.data;
        var response = replay.throttledAddEvent({
            type: $dbab849fc0bcf4ad$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $dbab849fc0bcf4ad$var$handleHistory(handlerData) {
    var from = handlerData.from, to = handlerData.to;
    var now = Date.now() / 1e3;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
function $dbab849fc0bcf4ad$var$handleHistorySpanListener(replay) {
    return function(handlerData) {
        if (!replay.isEnabled()) return;
        var result = $dbab849fc0bcf4ad$var$handleHistory(handlerData);
        if (result === null) return;
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(function() {
            $dbab849fc0bcf4ad$var$createPerformanceSpans(replay, [
                result
            ]);
            return false;
        });
    };
}
function $dbab849fc0bcf4ad$var$shouldFilterRequest(replay, url) {
    if ($dbab849fc0bcf4ad$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $ba7ca353ce9a90d4$export$d92e61f5600202af)(url, (0, $945639585ea57ae0$export$6bb76d6eba7e258c)());
}
function $dbab849fc0bcf4ad$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($dbab849fc0bcf4ad$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(function() {
        $dbab849fc0bcf4ad$var$createPerformanceSpans(replay, [
            result
        ]);
        return true;
    });
}
function $dbab849fc0bcf4ad$var$getBodySize(body) {
    if (!body) return void 0;
    var textEncoder = new TextEncoder();
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            var formDataStr = (0, $1520d5683edac93a$export$2f1b0f57f243f270)(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    } catch (e) {}
    return void 0;
}
function $dbab849fc0bcf4ad$var$parseContentLengthHeader(header) {
    if (!header) return void 0;
    var size = parseInt(header, 10);
    return isNaN(size) ? void 0 : size;
}
function $dbab849fc0bcf4ad$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: void 0,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    var newMeta = (0, $hwO3w._)({}, info._meta);
    var existingWarnings = newMeta.warnings || [];
    newMeta.warnings = (0, $XnYkK._)(existingWarnings).concat([
        warning
    ]);
    info._meta = newMeta;
    return info;
}
function $dbab849fc0bcf4ad$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    var startTimestamp = data.startTimestamp, endTimestamp = data.endTimestamp, url = data.url, method = data.method, statusCode = data.statusCode, request = data.request, response = data.response;
    var result = {
        type: type,
        start: startTimestamp / 1e3,
        end: endTimestamp / 1e3,
        name: url,
        data: {
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        }
    };
    return result;
}
function $dbab849fc0bcf4ad$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
function $dbab849fc0bcf4ad$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return void 0;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    var info = {
        headers: headers,
        size: bodySize
    };
    var _normalizeNetworkBody = $dbab849fc0bcf4ad$var$normalizeNetworkBody(body), normalizedBody = _normalizeNetworkBody.body, warnings = _normalizeNetworkBody.warnings;
    info.body = normalizedBody;
    if (warnings === null || warnings === void 0 ? void 0 : warnings.length) info._meta = {
        warnings: warnings
    };
    return info;
}
function $dbab849fc0bcf4ad$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.entries(headers).reduce(function(filteredHeaders, param) {
        var _param = (0, $6iP9u._)(param, 2), key = _param[0], value = _param[1];
        var normalizedKey = key.toLowerCase();
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = value;
        return filteredHeaders;
    }, {});
}
function $dbab849fc0bcf4ad$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    var exceedsSizeLimit = body.length > $dbab849fc0bcf4ad$var$NETWORK_BODY_MAX_SIZE;
    var isProbablyJson = $dbab849fc0bcf4ad$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        var truncatedBody = body.slice(0, $dbab849fc0bcf4ad$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: "".concat(truncatedBody, "\u2026"),
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        var jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e) {}
    return {
        body: body
    };
}
function $dbab849fc0bcf4ad$var$_strIsProbablyJson(str) {
    var first = str[0];
    var last = str[str.length - 1];
    return first === "[" && last === "]" || first === "{" && last === "}";
}
function $dbab849fc0bcf4ad$var$urlMatches(url, urls) {
    var fullUrl = $dbab849fc0bcf4ad$var$getFullUrl(url);
    return (0, $45aea333cf5bef5d$export$a7a5ec66062ea5d)(fullUrl, urls);
}
function $dbab849fc0bcf4ad$var$getFullUrl(url) {
    var baseURI = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $dbab849fc0bcf4ad$var$WINDOW.document.baseURI;
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($dbab849fc0bcf4ad$var$WINDOW.location.origin)) return url;
    var fixedUrl = new URL(url, baseURI);
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    var fullUrl = fixedUrl.href;
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
function $dbab849fc0bcf4ad$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var data, result, error;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $dbab849fc0bcf4ad$var$_prepareFetchData(breadcrumb, hint, options)
                    ];
                case 1:
                    data = _state.sent();
                    result = $dbab849fc0bcf4ad$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
                    $dbab849fc0bcf4ad$var$addNetworkBreadcrumb(options.replay, result);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(error, "Failed to capture fetch breadcrumb");
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $dbab849fc0bcf4ad$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    var input = hint.input, response = hint.response;
    var body = input ? (0, $1520d5683edac93a$export$ad44edf8012ec314)(input) : void 0;
    var reqSize = $dbab849fc0bcf4ad$var$getBodySize(body);
    var resSize = response ? $dbab849fc0bcf4ad$var$parseContentLengthHeader(response.headers.get("content-length")) : void 0;
    if (reqSize !== void 0) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== void 0) breadcrumb.data.response_body_size = resSize;
}
function $dbab849fc0bcf4ad$var$_prepareFetchData(breadcrumb, hint, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var now, _hint_startTimestamp, startTimestamp, _hint_endTimestamp, endTimestamp, _breadcrumb_data, url, method, tmp, statusCode, requestBodySize, responseBodySize, captureDetails, request, response;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    now = Date.now();
                    _hint_startTimestamp = hint.startTimestamp, startTimestamp = _hint_startTimestamp === void 0 ? now : _hint_startTimestamp, _hint_endTimestamp = hint.endTimestamp, endTimestamp = _hint_endTimestamp === void 0 ? now : _hint_endTimestamp;
                    _breadcrumb_data = breadcrumb.data, url = _breadcrumb_data.url, method = _breadcrumb_data.method, tmp = _breadcrumb_data.status_code, statusCode = tmp === void 0 ? 0 : tmp, requestBodySize = _breadcrumb_data.request_body_size, responseBodySize = _breadcrumb_data.response_body_size;
                    captureDetails = $dbab849fc0bcf4ad$var$urlMatches(url, options.networkDetailAllowUrls) && !$dbab849fc0bcf4ad$var$urlMatches(url, options.networkDetailDenyUrls);
                    request = captureDetails ? $dbab849fc0bcf4ad$var$_getRequestInfo(options, hint.input, requestBodySize) : $dbab849fc0bcf4ad$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
                    return [
                        4,
                        $dbab849fc0bcf4ad$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        {
                            startTimestamp: startTimestamp,
                            endTimestamp: endTimestamp,
                            url: url,
                            method: method,
                            statusCode: statusCode,
                            request: request,
                            response: response
                        }
                    ];
            }
        });
    })();
}
function $dbab849fc0bcf4ad$var$_getRequestInfo(param, input, requestBodySize) {
    var networkCaptureBodies = param.networkCaptureBodies, networkRequestHeaders = param.networkRequestHeaders;
    var headers = input ? $dbab849fc0bcf4ad$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $dbab849fc0bcf4ad$var$buildNetworkRequestOrResponse(headers, requestBodySize, void 0);
    var requestBody = (0, $1520d5683edac93a$export$ad44edf8012ec314)(input);
    var _getBodyString = (0, $6iP9u._)((0, $1520d5683edac93a$export$945a2d5364608d5)(requestBody, $dbab849fc0bcf4ad$var$debug), 2), bodyStr = _getBodyString[0], warning = _getBodyString[1];
    var data = $dbab849fc0bcf4ad$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $dbab849fc0bcf4ad$var$mergeWarning(data, warning);
    return data;
}
function $dbab849fc0bcf4ad$var$_getResponseInfo(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(captureDetails, param, response, responseBodySize) {
        var networkCaptureBodies, networkResponseHeaders, headers, _ref, bodyText, warning, result;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    networkCaptureBodies = param.networkCaptureBodies, networkResponseHeaders = param.networkResponseHeaders;
                    if (!captureDetails && responseBodySize !== void 0) return [
                        2,
                        $dbab849fc0bcf4ad$var$buildSkippedNetworkRequestOrResponse(responseBodySize)
                    ];
                    headers = response ? $dbab849fc0bcf4ad$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
                    if (!response || !networkCaptureBodies && responseBodySize !== void 0) return [
                        2,
                        $dbab849fc0bcf4ad$var$buildNetworkRequestOrResponse(headers, responseBodySize, void 0)
                    ];
                    return [
                        4,
                        $dbab849fc0bcf4ad$var$_parseFetchResponseBody(response)
                    ];
                case 1:
                    _ref = (0, $6iP9u._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), bodyText = _ref[0], warning = _ref[1];
                    result = $dbab849fc0bcf4ad$var$getResponseData(bodyText, {
                        networkCaptureBodies: networkCaptureBodies,
                        responseBodySize: responseBodySize,
                        captureDetails: captureDetails,
                        headers: headers
                    });
                    if (warning) return [
                        2,
                        $dbab849fc0bcf4ad$var$mergeWarning(result, warning)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    }).apply(this, arguments);
}
function $dbab849fc0bcf4ad$var$getResponseData(bodyText, param) {
    var networkCaptureBodies = param.networkCaptureBodies, responseBodySize = param.responseBodySize, captureDetails = param.captureDetails, headers = param.headers;
    try {
        var size = (bodyText === null || bodyText === void 0 ? void 0 : bodyText.length) && responseBodySize === void 0 ? $dbab849fc0bcf4ad$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $dbab849fc0bcf4ad$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $dbab849fc0bcf4ad$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $dbab849fc0bcf4ad$var$buildNetworkRequestOrResponse(headers, size, void 0);
    } catch (error) {
        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(error, "Failed to serialize response body");
        return $dbab849fc0bcf4ad$var$buildNetworkRequestOrResponse(headers, responseBodySize, void 0);
    }
}
function $dbab849fc0bcf4ad$var$_parseFetchResponseBody(response) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var res, text, error;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    res = $dbab849fc0bcf4ad$var$_tryCloneResponse(response);
                    if (!res) return [
                        2,
                        [
                            void 0,
                            "BODY_PARSE_ERROR"
                        ]
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $dbab849fc0bcf4ad$var$_tryGetResponseText(res)
                    ];
                case 2:
                    text = _state.sent();
                    return [
                        2,
                        [
                            text
                        ]
                    ];
                case 3:
                    error = _state.sent();
                    if (error instanceof Error && error.message.indexOf("Timeout") > -1) {
                        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.warn("Parsing text body from response timed out");
                        return [
                            2,
                            [
                                void 0,
                                "BODY_PARSE_TIMEOUT"
                            ]
                        ];
                    }
                    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(error, "Failed to get text body from response");
                    return [
                        2,
                        [
                            void 0,
                            "BODY_PARSE_ERROR"
                        ]
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $dbab849fc0bcf4ad$var$getAllHeaders(headers, allowedHeaders) {
    var allHeaders = {};
    allowedHeaders.forEach(function(header) {
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $dbab849fc0bcf4ad$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $dbab849fc0bcf4ad$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $dbab849fc0bcf4ad$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $dbab849fc0bcf4ad$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    var headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $dbab849fc0bcf4ad$var$getAllHeaders(headers, allowedHeaders);
    if (Array.isArray(headers)) return {};
    return $dbab849fc0bcf4ad$var$getAllowedHeaders(headers, allowedHeaders);
}
function $dbab849fc0bcf4ad$var$_tryCloneResponse(response) {
    try {
        return response.clone();
    } catch (error) {
        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(error, "Failed to clone response body");
    }
}
function $dbab849fc0bcf4ad$var$_tryGetResponseText(response) {
    return new Promise(function(resolve, reject) {
        var timeout = (0, $d26b11a6b11dd4e3$export$831dc9f2ab0a617b)(function() {
            return reject(new Error("Timeout while trying to read response body"));
        }, 500);
        $dbab849fc0bcf4ad$var$_getResponseText(response).then(function(txt) {
            return resolve(txt);
        }, function(reason) {
            return reject(reason);
        }).finally(function() {
            return clearTimeout(timeout);
        });
    });
}
function $dbab849fc0bcf4ad$var$_getResponseText(response) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        response.text()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}
function $dbab849fc0bcf4ad$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var data, result;
        return (0, $3SMYb._)(this, function(_state) {
            try {
                data = $dbab849fc0bcf4ad$var$_prepareXhrData(breadcrumb, hint, options);
                result = $dbab849fc0bcf4ad$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
                $dbab849fc0bcf4ad$var$addNetworkBreadcrumb(options.replay, result);
            } catch (error) {
                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(error, "Failed to capture xhr breadcrumb");
            }
            return [
                2
            ];
        });
    })();
}
function $dbab849fc0bcf4ad$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    var xhr = hint.xhr, input = hint.input;
    if (!xhr) return;
    var reqSize = $dbab849fc0bcf4ad$var$getBodySize(input);
    var resSize = xhr.getResponseHeader("content-length") ? $dbab849fc0bcf4ad$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $dbab849fc0bcf4ad$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== void 0) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== void 0) breadcrumb.data.response_body_size = resSize;
}
function $dbab849fc0bcf4ad$var$_prepareXhrData(breadcrumb, hint, options) {
    var now = Date.now();
    var _hint_startTimestamp = hint.startTimestamp, startTimestamp = _hint_startTimestamp === void 0 ? now : _hint_startTimestamp, _hint_endTimestamp = hint.endTimestamp, endTimestamp = _hint_endTimestamp === void 0 ? now : _hint_endTimestamp, input = hint.input, xhr = hint.xhr;
    var _breadcrumb_data = breadcrumb.data, url = _breadcrumb_data.url, method = _breadcrumb_data.method, tmp = _breadcrumb_data.status_code, statusCode = tmp === void 0 ? 0 : tmp, requestBodySize = _breadcrumb_data.request_body_size, responseBodySize = _breadcrumb_data.response_body_size;
    if (!url) return null;
    if (!xhr || !$dbab849fc0bcf4ad$var$urlMatches(url, options.networkDetailAllowUrls) || $dbab849fc0bcf4ad$var$urlMatches(url, options.networkDetailDenyUrls)) {
        var request2 = $dbab849fc0bcf4ad$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        var response2 = $dbab849fc0bcf4ad$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request2,
            response: response2
        };
    }
    var xhrInfo = xhr[0, $2034b898240d7377$export$55b6bb1e45c6cf59];
    var networkRequestHeaders = xhrInfo ? $dbab849fc0bcf4ad$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    var networkResponseHeaders = $dbab849fc0bcf4ad$var$getAllowedHeaders((0, $1520d5683edac93a$export$ce71c337afb62ea)(xhr), options.networkResponseHeaders);
    var _ref = (0, $6iP9u._)(options.networkCaptureBodies ? (0, $1520d5683edac93a$export$945a2d5364608d5)(input, $dbab849fc0bcf4ad$var$debug) : [
        void 0
    ], 2), requestBody = _ref[0], requestWarning = _ref[1];
    var _ref1 = (0, $6iP9u._)(options.networkCaptureBodies ? $dbab849fc0bcf4ad$var$_getXhrResponseBody(xhr) : [
        void 0
    ], 2), responseBody = _ref1[0], responseWarning = _ref1[1];
    var request = $dbab849fc0bcf4ad$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    var response = $dbab849fc0bcf4ad$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $dbab849fc0bcf4ad$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $dbab849fc0bcf4ad$var$mergeWarning(response, responseWarning) : response
    };
}
function $dbab849fc0bcf4ad$var$_getXhrResponseBody(xhr) {
    var _debug;
    var errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    try {
        return $dbab849fc0bcf4ad$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $dbab849fc0bcf4ad$var$DEBUG_BUILD && (_debug = $dbab849fc0bcf4ad$var$debug).warn.apply(_debug, [
        "Failed to get xhr response body"
    ].concat((0, $XnYkK._)(errors)));
    return [
        void 0
    ];
}
function $dbab849fc0bcf4ad$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && (0, $6ea82c15e37d9720$export$c10d0b04eaa80a43)(body)) return [
            JSON.stringify(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $dbab849fc0bcf4ad$var$_getBodySize(body, responseType) {
    try {
        var bodyStr = responseType === "json" && (0, $6ea82c15e37d9720$export$c10d0b04eaa80a43)(body) ? JSON.stringify(body) : body;
        return $dbab849fc0bcf4ad$var$getBodySize(bodyStr);
    } catch (e) {
        return void 0;
    }
}
function $dbab849fc0bcf4ad$var$handleNetworkBreadcrumbs(replay) {
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    try {
        var _replay_getOptions = replay.getOptions(), networkDetailAllowUrls = _replay_getOptions.networkDetailAllowUrls, networkDetailDenyUrls = _replay_getOptions.networkDetailDenyUrls, networkCaptureBodies = _replay_getOptions.networkCaptureBodies, networkRequestHeaders = _replay_getOptions.networkRequestHeaders, networkResponseHeaders = _replay_getOptions.networkResponseHeaders;
        var options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on("beforeAddBreadcrumb", function(breadcrumb, hint) {
            return $dbab849fc0bcf4ad$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint);
        });
    } catch (e) {}
}
function $dbab849fc0bcf4ad$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($dbab849fc0bcf4ad$var$_isXhrBreadcrumb(breadcrumb) && $dbab849fc0bcf4ad$var$_isXhrHint(hint)) {
            $dbab849fc0bcf4ad$var$enrichXhrBreadcrumb(breadcrumb, hint);
            $dbab849fc0bcf4ad$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($dbab849fc0bcf4ad$var$_isFetchBreadcrumb(breadcrumb) && $dbab849fc0bcf4ad$var$_isFetchHint(hint)) {
            $dbab849fc0bcf4ad$var$enrichFetchBreadcrumb(breadcrumb, hint);
            $dbab849fc0bcf4ad$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(e, "Error when enriching network breadcrumb");
    }
}
function $dbab849fc0bcf4ad$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $dbab849fc0bcf4ad$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $dbab849fc0bcf4ad$var$_isXhrHint(hint) {
    return hint === null || hint === void 0 ? void 0 : hint.xhr;
}
function $dbab849fc0bcf4ad$var$_isFetchHint(hint) {
    return (hint === null || hint === void 0 ? void 0 : hint.input) !== void 0;
}
function $dbab849fc0bcf4ad$var$addGlobalListeners(replay) {
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    (0, $6479bb906a9ea5f5$export$5aeffd3db2cf9df7)($dbab849fc0bcf4ad$var$handleDomListener(replay));
    (0, $276dfa3d97c764b4$export$3f18c56c58114e75)($dbab849fc0bcf4ad$var$handleHistorySpanListener(replay));
    $dbab849fc0bcf4ad$var$handleBreadcrumbs(replay);
    $dbab849fc0bcf4ad$var$handleNetworkBreadcrumbs(replay);
    var eventProcessor = $dbab849fc0bcf4ad$var$handleGlobalEventListener(replay);
    (0, $13be2508cc312e06$export$9aac0b9f77928fbf)(eventProcessor);
    if (client) {
        client.on("beforeSendEvent", $dbab849fc0bcf4ad$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $dbab849fc0bcf4ad$var$handleAfterSendEvent(replay));
        client.on("createDsc", function(dsc) {
            var replayId = replay.getSessionId();
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                var isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("processSegmentSpan", $dbab849fc0bcf4ad$var$handleProcessSegmentSpan(replay));
        client.on("spanStart", function(span) {
            replay.lastActiveSpan = span;
        });
        client.on("spanEnd", function(span) {
            replay.lastActiveSpan = span;
        });
        client.on("beforeSendFeedback", function(feedbackEvent, options) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var _feedbackEvent_contexts, replayId;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            replayId = replay.getSessionId();
                            if (!((options === null || options === void 0 ? void 0 : options.includeReplay) && replay.isEnabled() && replayId && ((_feedbackEvent_contexts = feedbackEvent.contexts) === null || _feedbackEvent_contexts === void 0 ? void 0 : _feedbackEvent_contexts.feedback))) return [
                                3,
                                3
                            ];
                            if (!(feedbackEvent.contexts.feedback.source === "api")) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                replay.sendBufferedReplayOrFlush()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            feedbackEvent.contexts.feedback.replay_id = replayId;
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        });
        client.on("openFeedbackWidget", function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                replay.sendBufferedReplayOrFlush()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        });
    }
}
function $dbab849fc0bcf4ad$var$addMemoryEntry(replay) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        return (0, $3SMYb._)(this, function(_state) {
            try {
                return [
                    2,
                    Promise.all($dbab849fc0bcf4ad$var$createPerformanceSpans(replay, [
                        // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
                        $dbab849fc0bcf4ad$var$createMemoryEntry($dbab849fc0bcf4ad$var$WINDOW.performance.memory)
                    ]))
                ];
            } catch (e) {
                return [
                    2,
                    []
                ];
            }
            return [
                2
            ];
        });
    })();
}
function $dbab849fc0bcf4ad$var$createMemoryEntry(memoryEntry) {
    var jsHeapSizeLimit = memoryEntry.jsHeapSizeLimit, totalJSHeapSize = memoryEntry.totalJSHeapSize, usedJSHeapSize = memoryEntry.usedJSHeapSize;
    var time = Date.now() / 1e3;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
function $dbab849fc0bcf4ad$var$debounce(func, wait, options) {
    return (0, $8024b451d4a557ac$export$61fc7d43ac8f84b0)(func, wait, (0, $lf4fc._)((0, $hwO3w._)({}, options), {
        // @ts-expect-error - Not quite sure why these types do not match, but this is fine
        setTimeoutImpl: (0, $d26b11a6b11dd4e3$export$831dc9f2ab0a617b)
    }));
}
var $dbab849fc0bcf4ad$var$NAVIGATOR = (0, $6001140c9a325157$export$f1a6cdb1459e81d1).navigator;
function $dbab849fc0bcf4ad$var$getRecordingSamplingOptions() {
    var _NAVIGATOR_userAgent, _NAVIGATOR_userAgent1;
    if (/iPhone|iPad|iPod/i.test((_NAVIGATOR_userAgent = $dbab849fc0bcf4ad$var$NAVIGATOR === null || $dbab849fc0bcf4ad$var$NAVIGATOR === void 0 ? void 0 : $dbab849fc0bcf4ad$var$NAVIGATOR.userAgent) !== null && _NAVIGATOR_userAgent !== void 0 ? _NAVIGATOR_userAgent : "") || /Macintosh/i.test((_NAVIGATOR_userAgent1 = $dbab849fc0bcf4ad$var$NAVIGATOR === null || $dbab849fc0bcf4ad$var$NAVIGATOR === void 0 ? void 0 : $dbab849fc0bcf4ad$var$NAVIGATOR.userAgent) !== null && _NAVIGATOR_userAgent1 !== void 0 ? _NAVIGATOR_userAgent1 : "") && ($dbab849fc0bcf4ad$var$NAVIGATOR === null || $dbab849fc0bcf4ad$var$NAVIGATOR === void 0 ? void 0 : $dbab849fc0bcf4ad$var$NAVIGATOR.maxTouchPoints) && ($dbab849fc0bcf4ad$var$NAVIGATOR === null || $dbab849fc0bcf4ad$var$NAVIGATOR === void 0 ? void 0 : $dbab849fc0bcf4ad$var$NAVIGATOR.maxTouchPoints) > 1) return {
        sampling: {
            mousemove: false
        }
    };
    return {};
}
function $dbab849fc0bcf4ad$var$getHandleRecordingEmit(replay) {
    var hadFirstEvent = false;
    return function(event, _isCheckout) {
        try {
            if (!replay.checkAndHandleExpiredSession()) {
                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.warn("Received replay event after session expired.");
                return;
            }
            var isCheckout = _isCheckout || !hadFirstEvent;
            hadFirstEvent = true;
            $dbab849fc0bcf4ad$var$syncMirrorAttributesFromMutationEvent(event);
            if (replay.clickDetector) $dbab849fc0bcf4ad$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
            replay.addUpdate(function() {
                if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
                if (!$dbab849fc0bcf4ad$var$addEventSync(replay, event, isCheckout)) return true;
                if (!isCheckout) return false;
                var session = replay.session;
                $dbab849fc0bcf4ad$var$addSettingsEvent(replay, isCheckout);
                if (replay.recordingMode === "buffer" && session && replay.eventBuffer && !session.dirty) {
                    var earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                    if (earliestEvent) {
                        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Updating session start time to earliest event in buffer to ".concat(new Date(earliestEvent)));
                        session.started = earliestEvent;
                        if (replay.getOptions().stickySession) $dbab849fc0bcf4ad$var$saveSession(session);
                    }
                }
                if (session === null || session === void 0 ? void 0 : session.previousSessionId) return true;
                if (replay.recordingMode === "session") replay.flush();
                return true;
            });
        } catch (error) {
            replay.handleException(error);
        }
    };
}
function $dbab849fc0bcf4ad$var$syncMirrorAttributesFromMutationEvent(event) {
    var data = event.data;
    if (event.type !== $dbab849fc0bcf4ad$var$EventType.IncrementalSnapshot || !data || (typeof data === "undefined" ? "undefined" : (0, $03bAP._)(data)) !== "object" || !("source" in data) || data.source !== $dbab849fc0bcf4ad$var$IncrementalSource.Mutation || !("attributes" in data) || !Array.isArray(data.attributes)) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data.attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var mutation = _step.value;
            var node = $dbab849fc0bcf4ad$var$record.mirror.getNode(mutation.id);
            var meta = node && $dbab849fc0bcf4ad$var$record.mirror.getMeta(node);
            if ((meta === null || meta === void 0 ? void 0 : meta.type) !== $dbab849fc0bcf4ad$var$NodeType.Element) continue;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.entries(mutation.attributes)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value = (0, $6iP9u._)(_step1.value, 2), attributeName = _step_value[0], value = _step_value[1];
                    if (value === null) delete meta.attributes[attributeName];
                    else meta.attributes[attributeName] = value;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $dbab849fc0bcf4ad$var$createOptionsEvent(replay) {
    var options = replay.getOptions();
    return {
        type: $dbab849fc0bcf4ad$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
function $dbab849fc0bcf4ad$var$addSettingsEvent(replay, isCheckout) {
    var _replay_session;
    if (!isCheckout || ((_replay_session = replay.session) === null || _replay_session === void 0 ? void 0 : _replay_session.segmentId) !== 0) return;
    $dbab849fc0bcf4ad$var$addEventSync(replay, $dbab849fc0bcf4ad$var$createOptionsEvent(replay), false);
}
function $dbab849fc0bcf4ad$var$closestElementOfNode(node) {
    if (!node) return null;
    try {
        var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (e) {
        return null;
    }
}
function $dbab849fc0bcf4ad$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $c4622bb7cd663145$export$f93f7f385160c44e)((0, $c4622bb7cd663145$export$92b6093782fe661b)(replayEvent, (0, $c4622bb7cd663145$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
function $dbab849fc0bcf4ad$var$prepareRecordingData(param) {
    var recordingData = param.recordingData, headers = param.headers;
    var payloadWithSequence;
    var replayHeaders = "".concat(JSON.stringify(headers), "\n");
    if (typeof recordingData === "string") payloadWithSequence = "".concat(replayHeaders).concat(recordingData);
    else {
        var enc = new TextEncoder();
        var sequence = enc.encode(replayHeaders);
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
function $dbab849fc0bcf4ad$var$prepareReplayEvent(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(param) {
        var client, scope, event_id, event, integrations, eventHint, preparedEvent, metadata, _ref, name, version, settings;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = param.client, scope = param.scope, event_id = param.replayId, event = param.event;
                    integrations = (0, $03bAP._)(client["_integrations"]) === "object" && client["_integrations"] !== null && !Array.isArray(client["_integrations"]) ? Object.keys(client["_integrations"]) : void 0;
                    eventHint = {
                        event_id: event_id,
                        integrations: integrations
                    };
                    client.emit("preprocessEvent", event, eventHint);
                    return [
                        4,
                        (0, $1c7a86869cfa8695$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $945639585ea57ae0$export$68f3af03034c9e90)())
                    ];
                case 1:
                    preparedEvent = _state.sent();
                    if (!preparedEvent) return [
                        2,
                        null
                    ];
                    client.emit("postprocessEvent", preparedEvent, eventHint);
                    preparedEvent.platform = preparedEvent.platform || "javascript";
                    metadata = client.getSdkMetadata();
                    _ref = (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) || {}, name = _ref.name, version = _ref.version, settings = _ref.settings;
                    preparedEvent.sdk = (0, $lf4fc._)((0, $hwO3w._)({}, preparedEvent.sdk), {
                        name: name || "sentry.javascript.unknown",
                        version: version || "0.0.0",
                        settings: settings
                    });
                    return [
                        2,
                        preparedEvent
                    ];
            }
        });
    }).apply(this, arguments);
}
function $dbab849fc0bcf4ad$var$sendReplayRequest(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(param) {
        var recordingData, replayId, segment_id, eventContext, timestamp, session, preparedRecordingData, urls, errorIds, traceIds, segmentNames, initialTimestamp, client, scope, transport, dsn, baseEvent, replayEvent, envelope, response, err, error, rateLimits;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    recordingData = param.recordingData, replayId = param.replayId, segment_id = param.segmentId, eventContext = param.eventContext, timestamp = param.timestamp, session = param.session;
                    preparedRecordingData = $dbab849fc0bcf4ad$var$prepareRecordingData({
                        recordingData: recordingData,
                        headers: {
                            segment_id: segment_id
                        }
                    });
                    urls = eventContext.urls, errorIds = eventContext.errorIds, traceIds = eventContext.traceIds, segmentNames = eventContext.segmentNames, initialTimestamp = eventContext.initialTimestamp;
                    client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
                    scope = (0, $945639585ea57ae0$export$c7be4b0125a10cba)();
                    transport = client === null || client === void 0 ? void 0 : client.getTransport();
                    dsn = client === null || client === void 0 ? void 0 : client.getDsn();
                    if (!client || !transport || !dsn || !session.sampled) return [
                        2,
                        Promise.resolve({})
                    ];
                    baseEvent = {
                        type: $dbab849fc0bcf4ad$var$REPLAY_EVENT_NAME,
                        replay_start_timestamp: initialTimestamp / 1e3,
                        timestamp: timestamp / 1e3,
                        error_ids: errorIds,
                        trace_ids: traceIds,
                        segment_names: segmentNames,
                        urls: urls,
                        replay_id: replayId,
                        segment_id: segment_id,
                        replay_type: session.sampled
                    };
                    return [
                        4,
                        $dbab849fc0bcf4ad$var$prepareReplayEvent({
                            scope: scope,
                            client: client,
                            replayId: replayId,
                            event: baseEvent
                        })
                    ];
                case 1:
                    replayEvent = _state.sent();
                    if (!replayEvent) {
                        client.recordDroppedEvent("event_processor", "replay");
                        $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("An event processor returned `null`, will not send event.");
                        return [
                            2,
                            Promise.resolve({})
                        ];
                    }
                    delete replayEvent.sdkProcessingMetadata;
                    envelope = $dbab849fc0bcf4ad$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        transport.send(envelope)
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    err = _state.sent();
                    error = new Error($dbab849fc0bcf4ad$var$UNABLE_TO_SEND_REPLAY);
                    try {
                        error.cause = err;
                    } catch (e) {}
                    throw error;
                case 5:
                    rateLimits = (0, $588c736ad3eef53a$export$699aff705e0d49d4)({}, response);
                    if ((0, $588c736ad3eef53a$export$6c91fec22056810a)(rateLimits, "replay")) throw new $dbab849fc0bcf4ad$var$RateLimitError(rateLimits);
                    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $dbab849fc0bcf4ad$var$TransportStatusCodeError(response.statusCode);
                    return [
                        2,
                        response
                    ];
            }
        });
    }).apply(this, arguments);
}
var $dbab849fc0bcf4ad$var$TransportStatusCodeError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(TransportStatusCodeError, Error1);
    function TransportStatusCodeError(statusCode) {
        (0, $5Epmf._)(this, TransportStatusCodeError);
        return (0, $48Z0s._)(this, TransportStatusCodeError, [
            "Transport returned status code ".concat(statusCode)
        ]);
    }
    return TransportStatusCodeError;
}((0, $kW1tL._)(Error));
var $dbab849fc0bcf4ad$var$RateLimitError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(RateLimitError, Error1);
    function RateLimitError(rateLimits) {
        (0, $5Epmf._)(this, RateLimitError);
        var _this;
        _this = (0, $48Z0s._)(this, RateLimitError, [
            "Rate limit hit"
        ]);
        _this.rateLimits = rateLimits;
        return _this;
    }
    return RateLimitError;
}((0, $kW1tL._)(Error));
var $dbab849fc0bcf4ad$var$ReplayDurationLimitError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4QAx6._)(ReplayDurationLimitError, Error1);
    function ReplayDurationLimitError() {
        (0, $5Epmf._)(this, ReplayDurationLimitError);
        return (0, $48Z0s._)(this, ReplayDurationLimitError, [
            "Session is too long, not sending replay"
        ]);
    }
    return ReplayDurationLimitError;
}((0, $kW1tL._)(Error));
function $dbab849fc0bcf4ad$var$sendReplay(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function(replayData) {
        var retryConfig, recordingData, onError, err, error;
        var _arguments = arguments;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    retryConfig = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {
                        count: 0,
                        interval: $dbab849fc0bcf4ad$var$RETRY_BASE_INTERVAL
                    };
                    recordingData = replayData.recordingData, onError = replayData.onError;
                    if (!recordingData.length) return [
                        2
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $dbab849fc0bcf4ad$var$sendReplayRequest(replayData)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 3:
                    err = _state.sent();
                    if (err instanceof $dbab849fc0bcf4ad$var$TransportStatusCodeError || err instanceof $dbab849fc0bcf4ad$var$RateLimitError) throw err;
                    (0, $13be2508cc312e06$export$2f04de43fe27971a)("Replays", {
                        _retryCount: retryConfig.count
                    });
                    if (onError) onError(err);
                    if (retryConfig.count >= $dbab849fc0bcf4ad$var$RETRY_MAX_COUNT) {
                        error = new Error("".concat($dbab849fc0bcf4ad$var$UNABLE_TO_SEND_REPLAY, " - max retries exceeded"));
                        try {
                            error.cause = err;
                        } catch (e) {}
                        throw error;
                    }
                    retryConfig.interval *= ++retryConfig.count;
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            (0, $d26b11a6b11dd4e3$export$831dc9f2ab0a617b)(function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                                    var err2;
                                    return (0, $3SMYb._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _state.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]);
                                                return [
                                                    4,
                                                    $dbab849fc0bcf4ad$var$sendReplay(replayData, retryConfig)
                                                ];
                                            case 1:
                                                _state.sent();
                                                resolve(true);
                                                return [
                                                    3,
                                                    3
                                                ];
                                            case 2:
                                                err2 = _state.sent();
                                                reject(err2);
                                                return [
                                                    3,
                                                    3
                                                ];
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }, retryConfig.interval);
                        })
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
var $dbab849fc0bcf4ad$var$THROTTLED = "__THROTTLED";
var $dbab849fc0bcf4ad$var$SKIPPED = "__SKIPPED";
function $dbab849fc0bcf4ad$var$throttle(fn, maxCount, durationSeconds) {
    var counter = /* @__PURE__ */ new Map();
    var _cleanup = function(now) {
        var threshold = now - durationSeconds;
        counter.forEach(function(_value, key) {
            if (key < threshold) counter.delete(key);
        });
    };
    var _getTotalCount = function() {
        return (0, $XnYkK._)(counter.values()).reduce(function(a, b) {
            return a + b;
        }, 0);
    };
    var isThrottled = false;
    return function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
            rest[_key] = arguments[_key];
        }
        var now = Math.floor(Date.now() / 1e3);
        _cleanup(now);
        if (_getTotalCount() >= maxCount) {
            var wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $dbab849fc0bcf4ad$var$SKIPPED : $dbab849fc0bcf4ad$var$THROTTLED;
        }
        isThrottled = false;
        var count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn.apply(void 0, (0, $XnYkK._)(rest));
    };
}
var $dbab849fc0bcf4ad$var$ReplayContainer = /*#__PURE__*/ function() {
    "use strict";
    function ReplayContainer(param) {
        var _this = this;
        var options = param.options, recordingOptions = param.recordingOptions;
        (0, $5Epmf._)(this, ReplayContainer);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $dbab849fc0bcf4ad$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $dbab849fc0bcf4ad$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._requiresManualStart = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: /* @__PURE__ */ new Set(),
            traceIds: /* @__PURE__ */ new Set(),
            segmentNames: /* @__PURE__ */ new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $dbab849fc0bcf4ad$var$debounce(function() {
            return _this._flush();
        }, this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $dbab849fc0bcf4ad$var$throttle(function(event, isCheckout) {
            return $dbab849fc0bcf4ad$var$addEvent(_this, event, isCheckout);
        }, // Max 300 events...
        300, // ... per 5s
        5);
        var _this_getOptions = this.getOptions(), slowClickTimeout = _this_getOptions.slowClickTimeout, slowClickIgnoreSelectors = _this_getOptions.slowClickIgnoreSelectors;
        var slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($dbab849fc0bcf4ad$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $dbab849fc0bcf4ad$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : void 0;
        if (slowClickConfig) this.clickDetector = new $dbab849fc0bcf4ad$var$ClickDetector(this, slowClickConfig);
        if ($dbab849fc0bcf4ad$var$DEBUG_BUILD) {
            var experiments = options._experiments;
            $dbab849fc0bcf4ad$var$debug.setConfig({
                captureExceptions: !!experiments.captureExceptions,
                traceInternals: !!experiments.traceInternals
            });
        }
        this._handleVisibilityChange = function() {
            if ($dbab849fc0bcf4ad$var$WINDOW.document.visibilityState === "visible") _this._doChangeToForegroundTasks();
            else _this._doChangeToBackgroundTasks();
        };
        this._handleWindowBlur = function() {
            var breadcrumb = $dbab849fc0bcf4ad$var$createBreadcrumb({
                category: "ui.blur"
            });
            _this._doChangeToBackgroundTasks(breadcrumb);
        };
        this._handleWindowFocus = function() {
            var breadcrumb = $dbab849fc0bcf4ad$var$createBreadcrumb({
                category: "ui.focus"
            });
            _this._doChangeToForegroundTasks(breadcrumb);
        };
        this._handleKeyboardEvent = function(event) {
            $dbab849fc0bcf4ad$var$handleKeyboardEvent(_this, event);
        };
    }
    (0, $9MqXK._)(ReplayContainer, [
        {
            /** Get the event context. */ key: "getContext",
            value: function getContext() {
                return this._context;
            }
        },
        {
            /** If recording is currently enabled. */ key: "isEnabled",
            value: function isEnabled() {
                return this._isEnabled;
            }
        },
        {
            /** If recording is currently paused. */ key: "isPaused",
            value: function isPaused() {
                return this._isPaused;
            }
        },
        {
            /**
   * Determine if canvas recording is enabled
   */ key: "isRecordingCanvas",
            value: function isRecordingCanvas() {
                return Boolean(this._canvas);
            }
        },
        {
            /** Get the replay integration options. */ key: "getOptions",
            value: function getOptions() {
                return this._options;
            }
        },
        {
            /** A wrapper to conditionally capture exceptions. */ key: "handleException",
            value: function handleException(error) {
                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(error);
                if (this._options.onError) this._options.onError(error);
            }
        },
        {
            /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ key: "initializeSampling",
            value: function initializeSampling(previousSessionId) {
                var _this__options = this._options, errorSampleRate = _this__options.errorSampleRate, sessionSampleRate = _this__options.sessionSampleRate;
                var requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
                this._requiresManualStart = requiresManualStart;
                if (requiresManualStart) return;
                this._initializeSessionForSampling(previousSessionId);
                if (!this.session) {
                    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.exception(new Error("Unable to initialize and create session"));
                    return;
                }
                if (this.session.sampled === false) return;
                this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.infoTick("Starting replay in ".concat(this.recordingMode, " mode"));
                this._initializeRecording();
            }
        },
        {
            /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ key: "start",
            value: function start() {
                if (this._isEnabled && this.recordingMode === "session") {
                    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Recording is already in progress");
                    return;
                }
                if (this._isEnabled && this.recordingMode === "buffer") {
                    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Buffering is in progress, call `flush()` to save the replay");
                    return;
                }
                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.infoTick("Starting replay in session mode");
                this._updateUserActivity();
                var session = $dbab849fc0bcf4ad$var$loadOrCreateSession({
                    maxReplayDuration: this._options.maxReplayDuration,
                    sessionIdleExpire: this.timeouts.sessionIdleExpire
                }, {
                    stickySession: this._options.stickySession,
                    // This is intentional: create a new session-based replay when calling `start()`
                    sessionSampleRate: 1,
                    allowBuffering: false
                });
                this.session = session;
                this.recordingMode = "session";
                this._initializeRecording();
            }
        },
        {
            /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ key: "startBuffering",
            value: function startBuffering() {
                if (this._isEnabled) {
                    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Buffering is in progress, call `flush()` to save the replay");
                    return;
                }
                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.infoTick("Starting replay in buffer mode");
                var session = $dbab849fc0bcf4ad$var$loadOrCreateSession({
                    sessionIdleExpire: this.timeouts.sessionIdleExpire,
                    maxReplayDuration: this._options.maxReplayDuration
                }, {
                    stickySession: this._options.stickySession,
                    sessionSampleRate: 0,
                    allowBuffering: true
                });
                this.session = session;
                this.recordingMode = "buffer";
                this._initializeRecording();
            }
        },
        {
            /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ key: "startRecording",
            value: function startRecording() {
                try {
                    var canvasOptions = this._canvas;
                    this._stopRecording = $dbab849fc0bcf4ad$var$record((0, $hwO3w._)((0, $lf4fc._)((0, $hwO3w._)((0, $lf4fc._)((0, $hwO3w._)({}, this._recordingOptions, this.recordingMode === "buffer" ? {
                        checkoutEveryNms: $dbab849fc0bcf4ad$var$BUFFER_CHECKOUT_TIME
                    } : // Otherwise, use experimental option w/ min checkout time of 6 minutes
                    // This is to improve playback seeking as there could potentially be
                    // less mutations to process in the worse cases.
                    //
                    // checkout by "N" events is probably ideal, but means we have less
                    // control about the number of checkouts we make (which generally
                    // increases replay size)
                    this._options._experiments.continuousCheckout && {
                        // Minimum checkout time is 6 minutes
                        checkoutEveryNms: Math.max(36e4, this._options._experiments.continuousCheckout)
                    }), {
                        emit: $dbab849fc0bcf4ad$var$getHandleRecordingEmit(this)
                    }), $dbab849fc0bcf4ad$var$getRecordingSamplingOptions()), {
                        onMutation: this._onMutationHandler.bind(this)
                    }), canvasOptions ? {
                        recordCanvas: canvasOptions.recordCanvas,
                        getCanvasManager: canvasOptions.getCanvasManager,
                        sampling: canvasOptions.sampling,
                        dataURLOptions: canvasOptions.dataURLOptions
                    } : {}));
                } catch (err) {
                    this.handleException(err);
                }
            }
        },
        {
            /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ key: "stopRecording",
            value: function stopRecording() {
                try {
                    if (this._stopRecording) {
                        this._stopRecording();
                        this._stopRecording = void 0;
                    }
                    return true;
                } catch (err) {
                    this.handleException(err);
                    return false;
                }
            }
        },
        {
            key: "stop",
            value: /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ function stop() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _ref, _ref_forceFlush, forceFlush, reason, _this_session, _getClient, stopReason, _this_eventBuffer, err;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_forceFlush = _ref.forceFlush, forceFlush = _ref_forceFlush === void 0 ? false : _ref_forceFlush, reason = _ref.reason;
                                if (!this._isEnabled) return [
                                    2
                                ];
                                this._isEnabled = false;
                                this.recordingMode = "buffer";
                                stopReason = reason !== null && reason !== void 0 ? reason : "manual";
                                (_getClient = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)()) === null || _getClient === void 0 ? void 0 : _getClient.emit("replayEnd", {
                                    sessionId: (_this_session = this.session) === null || _this_session === void 0 ? void 0 : _this_session.id,
                                    reason: stopReason
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Stopping Replay triggered by ".concat(stopReason));
                                $dbab849fc0bcf4ad$var$resetReplayIdOnDynamicSamplingContext();
                                this._removeListeners();
                                this.stopRecording();
                                this._debouncedFlush.cancel();
                                if (!forceFlush) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._flush({
                                        force: true
                                    })
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                (_this_eventBuffer = this.eventBuffer) === null || _this_eventBuffer === void 0 ? void 0 : _this_eventBuffer.destroy();
                                this.eventBuffer = null;
                                $dbab849fc0bcf4ad$var$clearSession(this);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                err = _state.sent();
                                this.handleException(err);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ key: "pause",
            value: function pause() {
                if (this._isPaused) return;
                this._isPaused = true;
                this.stopRecording();
                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Pausing replay");
            }
        },
        {
            /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ key: "resume",
            value: function resume() {
                if (!this._isPaused || !this._checkSession()) return;
                this._isPaused = false;
                this.startRecording();
                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Resuming replay");
            }
        },
        {
            key: "sendBufferedReplayOrFlush",
            value: /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ function sendBufferedReplayOrFlush() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _ref, _ref_continueRecording, continueRecording, activityTime, hasStoppedRecording;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_continueRecording = _ref.continueRecording, continueRecording = _ref_continueRecording === void 0 ? true : _ref_continueRecording;
                                if (this.recordingMode === "session") return [
                                    2,
                                    this.flushImmediate()
                                ];
                                activityTime = Date.now();
                                $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Converting buffer to session");
                                return [
                                    4,
                                    this.flushImmediate()
                                ];
                            case 1:
                                _state.sent();
                                hasStoppedRecording = this.stopRecording();
                                if (!continueRecording || !hasStoppedRecording) return [
                                    2
                                ];
                                if (this.recordingMode === "session") return [
                                    2
                                ];
                                this.recordingMode = "session";
                                if (this.session) {
                                    this.session.dirty = false;
                                    this._updateUserActivity(activityTime);
                                    this._updateSessionActivity(activityTime);
                                    this._maybeSaveSession();
                                    $dbab849fc0bcf4ad$var$setReplayIdOnDynamicSamplingContext(this.session.id);
                                }
                                this.startRecording();
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ key: "addUpdate",
            value: function addUpdate(cb) {
                var cbResult = cb();
                if (this.recordingMode === "buffer" || !this._isEnabled) return;
                if (cbResult === true) return;
                this._debouncedFlush();
            }
        },
        {
            /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ key: "triggerUserActivity",
            value: function triggerUserActivity() {
                this._updateUserActivity();
                if (!this._stopRecording) {
                    if (!this._checkSession()) return;
                    this.resume();
                    return;
                }
                this.checkAndHandleExpiredSession();
                this._updateSessionActivity();
            }
        },
        {
            /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ key: "updateUserActivity",
            value: function updateUserActivity() {
                this._updateUserActivity();
                this._updateSessionActivity();
            }
        },
        {
            /**
   * Only flush if `this.recordingMode === 'session'`
   */ key: "conditionalFlush",
            value: function conditionalFlush() {
                if (this.recordingMode === "buffer") return Promise.resolve();
                return this.flushImmediate();
            }
        },
        {
            /**
   * Flush using debounce flush
   */ key: "flush",
            value: function flush() {
                return this._debouncedFlush();
            }
        },
        {
            /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */ key: "flushImmediate",
            value: function flushImmediate() {
                this._debouncedFlush();
                return this._debouncedFlush.flush();
            }
        },
        {
            /**
   * Cancels queued up flushes.
   */ key: "cancelFlush",
            value: function cancelFlush() {
                this._debouncedFlush.cancel();
            }
        },
        {
            /** Get the current session (=replay) ID
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   */ key: "getSessionId",
            value: function getSessionId(onlyIfSampled) {
                var _this_session, _this_session1;
                if (onlyIfSampled && ((_this_session = this.session) === null || _this_session === void 0 ? void 0 : _this_session.sampled) === false) return void 0;
                return (_this_session1 = this.session) === null || _this_session1 === void 0 ? void 0 : _this_session1.id;
            }
        },
        {
            /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ key: "checkAndHandleExpiredSession",
            value: function checkAndHandleExpiredSession() {
                var _this_session;
                if (this._lastActivity && $dbab849fc0bcf4ad$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && ((_this_session = this.session) === null || _this_session === void 0 ? void 0 : _this_session.sampled) === "session") {
                    this.pause();
                    return;
                }
                if (!this._checkSession()) return false;
                return true;
            }
        },
        {
            /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ key: "setInitialState",
            value: function setInitialState() {
                var urlPath = "".concat($dbab849fc0bcf4ad$var$WINDOW.location.pathname).concat($dbab849fc0bcf4ad$var$WINDOW.location.hash).concat($dbab849fc0bcf4ad$var$WINDOW.location.search);
                var url = "".concat($dbab849fc0bcf4ad$var$WINDOW.location.origin).concat(urlPath);
                this.performanceEntries = [];
                this.replayPerformanceEntries = [];
                this._clearContext();
                this._context.initialUrl = url;
                this._context.initialTimestamp = Date.now();
                this._context.urls.push(url);
            }
        },
        {
            /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ key: "throttledAddEvent",
            value: function throttledAddEvent(event, isCheckout) {
                var _this = this;
                var res = this._throttledAddEvent(event, isCheckout);
                if (res === $dbab849fc0bcf4ad$var$THROTTLED) {
                    var breadcrumb = $dbab849fc0bcf4ad$var$createBreadcrumb({
                        category: "replay.throttled"
                    });
                    this.addUpdate(function() {
                        return !$dbab849fc0bcf4ad$var$addEventSync(_this, {
                            type: $dbab849fc0bcf4ad$var$ReplayEventTypeCustom,
                            timestamp: breadcrumb.timestamp || 0,
                            data: {
                                tag: "breadcrumb",
                                payload: breadcrumb,
                                metric: true
                            }
                        });
                    });
                }
                return res;
            }
        },
        {
            /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ key: "getCurrentRoute",
            value: function getCurrentRoute() {
                var lastActiveSpan = this.lastActiveSpan || (0, $79515206909fddff$export$1be426a8e585c83e)();
                var lastRootSpan = lastActiveSpan && (0, $79515206909fddff$export$c4c6a79b1260ca1b)(lastActiveSpan);
                var attributes = lastRootSpan && (0, $79515206909fddff$export$92d8c23565496537)(lastRootSpan).data || {};
                var source = attributes[0, $5d82adaea61c8fa9$export$d7a7d984b0791405];
                if (!lastRootSpan || !source || ![
                    "route",
                    "custom"
                ].includes(source)) return void 0;
                return (0, $79515206909fddff$export$92d8c23565496537)(lastRootSpan).description;
            }
        },
        {
            /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ key: "_initializeRecording",
            value: function _initializeRecording() {
                var _getClient;
                this.setInitialState();
                this._updateSessionActivity();
                this.eventBuffer = $dbab849fc0bcf4ad$var$createEventBuffer({
                    useCompression: this._options.useCompression,
                    workerUrl: this._options.workerUrl
                });
                this._removeListeners();
                this._addListeners();
                this._isEnabled = true;
                this._isPaused = false;
                if (this.session) (_getClient = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)()) === null || _getClient === void 0 ? void 0 : _getClient.emit("replayStart", {
                    sessionId: this.session.id,
                    recordingMode: this.recordingMode
                });
                this.startRecording();
                if (this.recordingMode === "session" && this.session) $dbab849fc0bcf4ad$var$setReplayIdOnDynamicSamplingContext(this.session.id);
            }
        },
        {
            /**
   * Loads (or refreshes) the current session.
   */ key: "_initializeSessionForSampling",
            value: function _initializeSessionForSampling(previousSessionId) {
                var allowBuffering = this._options.errorSampleRate > 0;
                var session = $dbab849fc0bcf4ad$var$loadOrCreateSession({
                    sessionIdleExpire: this.timeouts.sessionIdleExpire,
                    maxReplayDuration: this._options.maxReplayDuration,
                    previousSessionId: previousSessionId
                }, {
                    stickySession: this._options.stickySession,
                    sessionSampleRate: this._options.sessionSampleRate,
                    allowBuffering: allowBuffering
                });
                this.session = session;
            }
        },
        {
            /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ key: "_checkSession",
            value: function _checkSession() {
                if (!this.session) return false;
                var currentSession = this.session;
                if ($dbab849fc0bcf4ad$var$shouldRefreshSession(currentSession, {
                    sessionIdleExpire: this.timeouts.sessionIdleExpire,
                    maxReplayDuration: this._options.maxReplayDuration
                })) {
                    this._refreshSession(currentSession);
                    return false;
                }
                return true;
            }
        },
        {
            key: "_refreshSession",
            value: /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ function _refreshSession(session) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._isEnabled) return [
                                    2
                                ];
                                return [
                                    4,
                                    this.stop({
                                        reason: "sessionExpired"
                                    })
                                ];
                            case 1:
                                _state.sent();
                                this.initializeSampling(session.id);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Adds listeners to record events for the replay
   */ key: "_addListeners",
            value: function _addListeners() {
                try {
                    $dbab849fc0bcf4ad$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
                    $dbab849fc0bcf4ad$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
                    $dbab849fc0bcf4ad$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
                    $dbab849fc0bcf4ad$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
                    if (this.clickDetector) this.clickDetector.addListeners();
                    if (!this._hasInitializedCoreListeners) {
                        $dbab849fc0bcf4ad$var$addGlobalListeners(this);
                        this._hasInitializedCoreListeners = true;
                    }
                } catch (err) {
                    this.handleException(err);
                }
                this._performanceCleanupCallback = $dbab849fc0bcf4ad$var$setupPerformanceObserver(this);
            }
        },
        {
            /**
   * Cleans up listeners that were created in `_addListeners`
   */ key: "_removeListeners",
            value: function _removeListeners() {
                try {
                    $dbab849fc0bcf4ad$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
                    $dbab849fc0bcf4ad$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
                    $dbab849fc0bcf4ad$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
                    $dbab849fc0bcf4ad$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
                    if (this.clickDetector) this.clickDetector.removeListeners();
                    if (this._performanceCleanupCallback) this._performanceCleanupCallback();
                } catch (err) {
                    this.handleException(err);
                }
            }
        },
        {
            /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ key: "_doChangeToBackgroundTasks",
            value: function _doChangeToBackgroundTasks(breadcrumb) {
                if (!this.session) return;
                var expired = $dbab849fc0bcf4ad$var$shouldRefreshSession(this.session, {
                    maxReplayDuration: this._options.maxReplayDuration,
                    sessionIdleExpire: this.timeouts.sessionIdleExpire
                });
                if (expired) {
                    $dbab849fc0bcf4ad$var$resetReplayIdOnDynamicSamplingContext();
                    return;
                }
                if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
                this.conditionalFlush();
            }
        },
        {
            /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ key: "_doChangeToForegroundTasks",
            value: function _doChangeToForegroundTasks(breadcrumb) {
                if (!this.session) return;
                var isSessionActive = this.checkAndHandleExpiredSession();
                if (!isSessionActive) {
                    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Document has become active, but session has expired");
                    return;
                }
                if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
            }
        },
        {
            /**
   * Update user activity (across session lifespans)
   */ key: "_updateUserActivity",
            value: function _updateUserActivity() {
                var _lastActivity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                this._lastActivity = _lastActivity;
            }
        },
        {
            /**
   * Updates the session's last activity timestamp
   */ key: "_updateSessionActivity",
            value: function _updateSessionActivity() {
                var _lastActivity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                if (this.session) {
                    this.session.lastActivity = _lastActivity;
                    this._maybeSaveSession();
                }
            }
        },
        {
            /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ key: "_createCustomBreadcrumb",
            value: function _createCustomBreadcrumb(breadcrumb) {
                var _this = this;
                this.addUpdate(function() {
                    _this.throttledAddEvent({
                        type: $dbab849fc0bcf4ad$var$EventType.Custom,
                        timestamp: breadcrumb.timestamp || 0,
                        data: {
                            tag: "breadcrumb",
                            payload: breadcrumb
                        }
                    });
                });
            }
        },
        {
            /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ key: "_addPerformanceEntries",
            value: function _addPerformanceEntries() {
                var performanceEntries = $dbab849fc0bcf4ad$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
                this.performanceEntries = [];
                this.replayPerformanceEntries = [];
                if (this._requiresManualStart) {
                    var initialTimestampInSeconds = this._context.initialTimestamp / 1e3;
                    performanceEntries = performanceEntries.filter(function(entry) {
                        return entry.start >= initialTimestampInSeconds;
                    });
                }
                return Promise.all($dbab849fc0bcf4ad$var$createPerformanceSpans(this, performanceEntries));
            }
        },
        {
            /**
   * Clear _context
   */ key: "_clearContext",
            value: function _clearContext() {
                this._context.errorIds.clear();
                this._context.traceIds.clear();
                this._context.segmentNames.clear();
                this._context.urls = [];
            }
        },
        {
            /** Update the initial timestamp based on the buffer content. */ key: "_updateInitialTimestampFromEventBuffer",
            value: function _updateInitialTimestampFromEventBuffer() {
                var _this = this, session = _this.session, eventBuffer = _this.eventBuffer;
                if (!session || !eventBuffer || this._requiresManualStart) return;
                if (session.segmentId) return;
                var earliestEvent = eventBuffer.getEarliestTimestamp();
                if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
            }
        },
        {
            /**
   * Return and clear _context
   */ key: "_popEventContext",
            value: function _popEventContext() {
                var _context = {
                    initialTimestamp: this._context.initialTimestamp,
                    initialUrl: this._context.initialUrl,
                    errorIds: Array.from(this._context.errorIds),
                    traceIds: Array.from(this._context.traceIds),
                    segmentNames: Array.from(this._context.segmentNames),
                    urls: this._context.urls
                };
                this._clearContext();
                return _context;
            }
        },
        {
            key: "_runFlush",
            value: /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ function _runFlush() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _this, _this_eventBuffer, replayId, timestamp, eventContext, segmentId, recordingData, err, client, dropReason;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                replayId = this.getSessionId();
                                if (!this.session || !this.eventBuffer || !replayId) {
                                    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.error("No session or eventBuffer found to flush.");
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    this._addPerformanceEntries()
                                ];
                            case 1:
                                _state.sent();
                                if (!((_this_eventBuffer = this.eventBuffer) === null || _this_eventBuffer === void 0 ? void 0 : _this_eventBuffer.hasEvents)) return [
                                    2
                                ];
                                return [
                                    4,
                                    $dbab849fc0bcf4ad$var$addMemoryEntry(this)
                                ];
                            case 2:
                                _state.sent();
                                if (!this.eventBuffer) return [
                                    2
                                ];
                                if (replayId !== this.getSessionId()) return [
                                    2
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    6,
                                    ,
                                    7
                                ]);
                                this._updateInitialTimestampFromEventBuffer();
                                timestamp = Date.now();
                                if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4) throw new $dbab849fc0bcf4ad$var$ReplayDurationLimitError();
                                eventContext = this._popEventContext();
                                segmentId = this.session.segmentId++;
                                this._maybeSaveSession();
                                return [
                                    4,
                                    this.eventBuffer.finish()
                                ];
                            case 4:
                                recordingData = _state.sent();
                                return [
                                    4,
                                    $dbab849fc0bcf4ad$var$sendReplay({
                                        replayId: replayId,
                                        recordingData: recordingData,
                                        segmentId: segmentId,
                                        eventContext: eventContext,
                                        session: this.session,
                                        timestamp: timestamp,
                                        onError: function(err) {
                                            return _this.handleException(err);
                                        }
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                err = _state.sent();
                                this.handleException(err);
                                this.stop({
                                    reason: "sendError"
                                });
                                client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
                                if (client) {
                                    ;
                                    if (err instanceof $dbab849fc0bcf4ad$var$RateLimitError) dropReason = "ratelimit_backoff";
                                    else if (err instanceof $dbab849fc0bcf4ad$var$ReplayDurationLimitError) dropReason = "invalid";
                                    else dropReason = "send_error";
                                    client.recordDroppedEvent(dropReason, "replay");
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_flush",
            value: /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ function _flush() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                    var _ref, _ref_force, force, start, now, duration, tooShort, tooLong, eventBuffer, _flushInProgress, err;
                    var _arguments = arguments;
                    return (0, $3SMYb._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_force = _ref.force, force = _ref_force === void 0 ? false : _ref_force;
                                if (!this._isEnabled && !force) return [
                                    2
                                ];
                                if (!this.checkAndHandleExpiredSession()) {
                                    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.error("Attempting to finish replay event after session expired.");
                                    return [
                                        2
                                    ];
                                }
                                if (!this.session) return [
                                    2
                                ];
                                start = this.session.started;
                                now = Date.now();
                                duration = now - start;
                                this._debouncedFlush.cancel();
                                tooShort = duration < this._options.minReplayDuration;
                                tooLong = duration > this._options.maxReplayDuration + 5e3;
                                if (tooShort || tooLong) {
                                    $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Session duration (".concat(Math.floor(duration / 1e3), "s) is too ").concat(tooShort ? "short" : "long", ", not sending replay."));
                                    if (tooShort) this._debouncedFlush();
                                    return [
                                        2
                                    ];
                                }
                                eventBuffer = this.eventBuffer;
                                if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $dbab849fc0bcf4ad$var$DEBUG_BUILD && $dbab849fc0bcf4ad$var$debug.log("Flushing initial segment without checkout.");
                                _flushInProgress = !!this._flushLock;
                                if (!this._flushLock) this._flushLock = this._runFlush();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]);
                                return [
                                    4,
                                    this._flushLock
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                err = _state.sent();
                                this.handleException(err);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                this._flushLock = void 0;
                                if (_flushInProgress) this._debouncedFlush();
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            /** Save the session, if it is sticky */ key: "_maybeSaveSession",
            value: function _maybeSaveSession() {
                if (this.session && this._options.stickySession) $dbab849fc0bcf4ad$var$saveSession(this.session);
            }
        },
        {
            /** Handler for rrweb.record.onMutation */ key: "_onMutationHandler",
            value: function _onMutationHandler(mutations) {
                var ignoreMutations = this._options._experiments.ignoreMutations;
                if (ignoreMutations === null || ignoreMutations === void 0 ? void 0 : ignoreMutations.length) {
                    if (mutations.some(function(mutation) {
                        var el = $dbab849fc0bcf4ad$var$closestElementOfNode(mutation.target);
                        var selector = ignoreMutations.join(",");
                        return el === null || el === void 0 ? void 0 : el.matches(selector);
                    })) return false;
                }
                var count = mutations.length;
                var mutationLimit = this._options.mutationLimit;
                var mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
                var overMutationLimit = mutationLimit && count > mutationLimit;
                if (count > mutationBreadcrumbLimit || overMutationLimit) {
                    var breadcrumb = $dbab849fc0bcf4ad$var$createBreadcrumb({
                        category: "replay.mutations",
                        data: {
                            count: count,
                            limit: overMutationLimit
                        }
                    });
                    this._createCustomBreadcrumb(breadcrumb);
                }
                if (overMutationLimit) {
                    this.stop({
                        reason: "mutationLimit",
                        forceFlush: this.recordingMode === "session"
                    });
                    return false;
                }
                return true;
            }
        }
    ]);
    return ReplayContainer;
}();
function $dbab849fc0bcf4ad$var$getOption(selectors, defaultSelectors) {
    return (0, $XnYkK._)(selectors).concat(// sentry defaults
    (0, $XnYkK._)(defaultSelectors)).join(",");
}
function $dbab849fc0bcf4ad$var$getPrivacyOptions(param) {
    var mask = param.mask, unmask = param.unmask, block = param.block, unblock = param.unblock, ignore = param.ignore;
    var defaultBlockedElements = [
        "base",
        "iframe[srcdoc]:not([src])"
    ];
    var maskSelector = $dbab849fc0bcf4ad$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ]);
    var unmaskSelector = $dbab849fc0bcf4ad$var$getOption(unmask, []);
    var options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $dbab849fc0bcf4ad$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]"
        ].concat((0, $XnYkK._)(defaultBlockedElements))),
        unblockSelector: $dbab849fc0bcf4ad$var$getOption(unblock, []),
        ignoreSelector: $dbab849fc0bcf4ad$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ])
    };
    return options;
}
function $dbab849fc0bcf4ad$var$maskAttribute(param) {
    var el = param.el, key = param.key, maskAttributes = param.maskAttributes, maskAllText = param.maskAllText, privacyOptions = param.privacyOptions, value = param.value;
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    var masksNamedAttribute = maskAttributes.includes(key);
    var masksSubmitButtonValue = maskAllText && key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "");
    if (masksNamedAttribute || masksSubmitButtonValue) return value.replace(/[\S]/g, "*");
    return value;
}
var $dbab849fc0bcf4ad$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
var $dbab849fc0bcf4ad$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
var $dbab849fc0bcf4ad$var$ORIGINAL_BODY = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
var $dbab849fc0bcf4ad$var$_initialized = false;
var $dbab849fc0bcf4ad$var$_isRequestInstrumented = false;
function $dbab849fc0bcf4ad$var$_INTERNAL_instrumentRequestInterface() {
    if (typeof Request === "undefined" || $dbab849fc0bcf4ad$var$_isRequestInstrumented) return;
    var OriginalRequest = Request;
    try {
        var SentryRequest = function SentryRequest(input, init) {
            var request = new OriginalRequest(input, init);
            if ((init === null || init === void 0 ? void 0 : init.body) != null) request[$dbab849fc0bcf4ad$var$ORIGINAL_BODY] = init.body;
            return request;
        };
        SentryRequest.prototype = OriginalRequest.prototype;
        (0, $6001140c9a325157$export$f1a6cdb1459e81d1).Request = SentryRequest;
        $dbab849fc0bcf4ad$var$_isRequestInstrumented = true;
    } catch (e) {}
}
var $dbab849fc0bcf4ad$export$d7706faf7ab354bf = function(options) {
    return new $dbab849fc0bcf4ad$var$Replay(options);
};
var $dbab849fc0bcf4ad$var$Replay = /*#__PURE__*/ function() {
    "use strict";
    function Replay() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_flushMinDelay = _ref.flushMinDelay, flushMinDelay = _ref_flushMinDelay === void 0 ? $dbab849fc0bcf4ad$var$DEFAULT_FLUSH_MIN_DELAY : _ref_flushMinDelay, _ref_flushMaxDelay = _ref.flushMaxDelay, flushMaxDelay = _ref_flushMaxDelay === void 0 ? $dbab849fc0bcf4ad$var$DEFAULT_FLUSH_MAX_DELAY : _ref_flushMaxDelay, _ref_minReplayDuration = _ref.minReplayDuration, minReplayDuration = _ref_minReplayDuration === void 0 ? $dbab849fc0bcf4ad$var$MIN_REPLAY_DURATION : _ref_minReplayDuration, _ref_maxReplayDuration = _ref.maxReplayDuration, maxReplayDuration = _ref_maxReplayDuration === void 0 ? $dbab849fc0bcf4ad$var$MAX_REPLAY_DURATION : _ref_maxReplayDuration, _ref_stickySession = _ref.stickySession, stickySession = _ref_stickySession === void 0 ? true : _ref_stickySession, _ref_useCompression = _ref.useCompression, useCompression = _ref_useCompression === void 0 ? true : _ref_useCompression, workerUrl = _ref.workerUrl, _ref__experiments = _ref._experiments, _experiments = _ref__experiments === void 0 ? {} : _ref__experiments, _ref_maskAllText = _ref.maskAllText, maskAllText = _ref_maskAllText === void 0 ? true : _ref_maskAllText, _ref_maskAllInputs = _ref.maskAllInputs, maskAllInputs = _ref_maskAllInputs === void 0 ? true : _ref_maskAllInputs, _ref_blockAllMedia = _ref.blockAllMedia, blockAllMedia = _ref_blockAllMedia === void 0 ? true : _ref_blockAllMedia, _ref_mutationBreadcrumbLimit = _ref.mutationBreadcrumbLimit, mutationBreadcrumbLimit = _ref_mutationBreadcrumbLimit === void 0 ? 750 : _ref_mutationBreadcrumbLimit, _ref_mutationLimit = _ref.mutationLimit, mutationLimit = _ref_mutationLimit === void 0 ? 1e4 : _ref_mutationLimit, _ref_slowClickTimeout = _ref.slowClickTimeout, slowClickTimeout = _ref_slowClickTimeout === void 0 ? 7e3 : _ref_slowClickTimeout, _ref_slowClickIgnoreSelectors = _ref.slowClickIgnoreSelectors, slowClickIgnoreSelectors = _ref_slowClickIgnoreSelectors === void 0 ? [] : _ref_slowClickIgnoreSelectors, _ref_networkDetailAllowUrls = _ref.networkDetailAllowUrls, networkDetailAllowUrls = _ref_networkDetailAllowUrls === void 0 ? [] : _ref_networkDetailAllowUrls, _ref_networkDetailDenyUrls = _ref.networkDetailDenyUrls, networkDetailDenyUrls = _ref_networkDetailDenyUrls === void 0 ? [] : _ref_networkDetailDenyUrls, _ref_networkCaptureBodies = _ref.networkCaptureBodies, networkCaptureBodies = _ref_networkCaptureBodies === void 0 ? true : _ref_networkCaptureBodies, _ref_networkRequestHeaders = _ref.networkRequestHeaders, networkRequestHeaders = _ref_networkRequestHeaders === void 0 ? [] : _ref_networkRequestHeaders, _ref_networkResponseHeaders = _ref.networkResponseHeaders, networkResponseHeaders = _ref_networkResponseHeaders === void 0 ? [] : _ref_networkResponseHeaders, _ref_mask = _ref.mask, mask = _ref_mask === void 0 ? [] : _ref_mask, _ref_maskAttributes = _ref.maskAttributes, maskAttributes = _ref_maskAttributes === void 0 ? [
            "title",
            "placeholder",
            "aria-label"
        ] : _ref_maskAttributes, _ref_unmask = _ref.unmask, unmask = _ref_unmask === void 0 ? [] : _ref_unmask, _ref_block = _ref.block, block = _ref_block === void 0 ? [] : _ref_block, _ref_unblock = _ref.unblock, unblock = _ref_unblock === void 0 ? [] : _ref_unblock, _ref_ignore = _ref.ignore, ignore = _ref_ignore === void 0 ? [] : _ref_ignore, maskFn = _ref.maskFn, beforeAddRecordingEvent = _ref.beforeAddRecordingEvent, beforeErrorSampling = _ref.beforeErrorSampling, onError = _ref.onError, _ref_attachRawBodyFromRequest = _ref.attachRawBodyFromRequest, attachRawBodyFromRequest = _ref_attachRawBodyFromRequest === void 0 ? false : _ref_attachRawBodyFromRequest;
        (0, $5Epmf._)(this, Replay);
        this.name = "Replay";
        var privacyOptions = $dbab849fc0bcf4ad$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = (0, $lf4fc._)((0, $hwO3w._)({
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: function(key, value, el) {
                return $dbab849fc0bcf4ad$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                });
            }
        }, privacyOptions), {
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: function(err) {
                try {
                    err.__rrweb__ = true;
                } catch (e) {}
            },
            // experimental support for recording iframes from different origins
            recordCrossOriginIframes: Boolean(_experiments.recordCrossOriginIframes)
        });
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $dbab849fc0bcf4ad$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $dbab849fc0bcf4ad$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $dbab849fc0bcf4ad$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $dbab849fc0bcf4ad$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            onError: onError,
            attachRawBodyFromRequest: attachRawBodyFromRequest,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) {
            this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $dbab849fc0bcf4ad$var$MEDIA_SELECTORS : "".concat(this._recordingOptions.blockSelector, ",").concat($dbab849fc0bcf4ad$var$MEDIA_SELECTORS);
            this._recordingOptions.ignoreCSSAttributes = /* @__PURE__ */ new Set([
                "background-image"
            ]);
        }
        if (this._isInitialized && (0, $0cb6d550a0b1aae5$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    (0, $9MqXK._)(Replay, [
        {
            key: "_isInitialized",
            get: /** If replay has already been initialized */ function get() {
                return $dbab849fc0bcf4ad$var$_initialized;
            },
            set: /** Update _isInitialized */ function set(value) {
                $dbab849fc0bcf4ad$var$_initialized = value;
            }
        },
        {
            /**
   * Setup and initialize replay container
   */ key: "afterAllSetup",
            value: function afterAllSetup(client) {
                if (!(0, $0cb6d550a0b1aae5$export$4e09c449d6c407f7)() || this._replay) return;
                if (this._initialOptions.attachRawBodyFromRequest) $dbab849fc0bcf4ad$var$_INTERNAL_instrumentRequestInterface();
                this._setup(client);
                this._initialize(client);
            }
        },
        {
            /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ key: "start",
            value: function start() {
                if (!this._replay) return;
                this._replay.start();
            }
        },
        {
            /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ key: "startBuffering",
            value: function startBuffering() {
                if (!this._replay) return;
                this._replay.startBuffering();
            }
        },
        {
            /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   *
   * @param options.flush - Whether to flush the pending replay segment when stopping.
   * When recording in `session` mode, `stop()` flushes the buffered-but-unsent segment by
   * default (`flush: true`), matching the previous behavior. Pass `flush: false` to stop
   * recording without sending that pending segment — useful when a user withdraws consent
   * and no further data should leave the browser.
   *
   * Note: `flush: false` only prevents the *pending* (final) segment from being sent. It does
   * **not** retract segments that were already sent earlier during `session` recording.
   */ key: "stop",
            value: function stop(options) {
                if (!this._replay) return Promise.resolve();
                var _options_flush;
                return this._replay.stop({
                    forceFlush: (_options_flush = options === null || options === void 0 ? void 0 : options.flush) !== null && _options_flush !== void 0 ? _options_flush : this._replay.recordingMode === "session",
                    reason: "manual"
                });
            }
        },
        {
            /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ key: "flush",
            value: function flush(options) {
                if (!this._replay) return Promise.resolve();
                if (!this._replay.isEnabled()) {
                    this._replay.start();
                    return Promise.resolve();
                }
                return this._replay.sendBufferedReplayOrFlush(options);
            }
        },
        {
            /**
   * Get the current session ID.
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   *
   */ key: "getReplayId",
            value: function getReplayId(onlyIfSampled) {
                var _this__replay;
                if (!((_this__replay = this._replay) === null || _this__replay === void 0 ? void 0 : _this__replay.isEnabled())) return;
                return this._replay.getSessionId(onlyIfSampled);
            }
        },
        {
            /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */ key: "getRecordingMode",
            value: function getRecordingMode() {
                var _this__replay;
                if (!((_this__replay = this._replay) === null || _this__replay === void 0 ? void 0 : _this__replay.isEnabled())) return;
                return this._replay.recordingMode;
            }
        },
        {
            key: "processSpan",
            value: function processSpan(span) {
                var replayId = this.getReplayId(true);
                if (replayId) {
                    (0, $841d10ad590254f7$export$146fcadff0eefcf3)(span, {
                        "sentry.replay_id": replayId
                    });
                    if (this.getRecordingMode() === "buffer") (0, $841d10ad590254f7$export$146fcadff0eefcf3)(span, {
                        "sentry._internal.replay_is_buffering": true
                    });
                }
            }
        },
        {
            /**
   * Initializes replay.
   */ key: "_initialize",
            value: function _initialize(client) {
                if (!this._replay) return;
                this._maybeLoadFromReplayCanvasIntegration(client);
                this._replay.initializeSampling();
            }
        },
        {
            /** Setup the integration. */ key: "_setup",
            value: function _setup(client) {
                var finalOptions = $dbab849fc0bcf4ad$var$loadReplayOptionsFromClient(this._initialOptions, client);
                this._replay = new $dbab849fc0bcf4ad$var$ReplayContainer({
                    options: finalOptions,
                    recordingOptions: this._recordingOptions
                });
            }
        },
        {
            /** Get canvas options from ReplayCanvas integration, if it is also added. */ key: "_maybeLoadFromReplayCanvasIntegration",
            value: function _maybeLoadFromReplayCanvasIntegration(client) {
                try {
                    var canvasIntegration = client.getIntegrationByName("ReplayCanvas");
                    if (!canvasIntegration) return;
                    this._replay["_canvas"] = canvasIntegration.getOptions();
                } catch (e) {}
            }
        }
    ]);
    return Replay;
}();
function $dbab849fc0bcf4ad$var$loadReplayOptionsFromClient(initialOptions, client) {
    var opt = client.getOptions();
    var finalOptions = (0, $hwO3w._)({
        sessionSampleRate: 0,
        errorSampleRate: 0
    }, initialOptions);
    var replaysSessionSampleRate = (0, $bbaf31262ee9249c$export$a5bd2d81656d9546)(opt.replaysSessionSampleRate);
    var replaysOnErrorSampleRate = (0, $bbaf31262ee9249c$export$a5bd2d81656d9546)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $739716ea0436a6d0$export$cda52e2a8927a2ca)(function() {
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $dbab849fc0bcf4ad$var$_getMergedNetworkHeaders(headers) {
    return (0, $XnYkK._)($dbab849fc0bcf4ad$var$DEFAULT_NETWORK_HEADERS).concat((0, $XnYkK._)(headers.map(function(header) {
        return header.toLowerCase();
    })));
}
function $dbab849fc0bcf4ad$export$b28310b2f161456b() {
    var client = (0, $945639585ea57ae0$export$6bb76d6eba7e258c)();
    return client === null || client === void 0 ? void 0 : client.getIntegrationByName("Replay");
}


var $8b757c88fddf920a$var$breadcrumbConfig = [
    {
        path: '/',
        breadcrumbKey: 'home'
    },
    {
        path: '/development-plan',
        breadcrumbKey: 'development-plan-nav-title'
    },
    {
        path: '/accept_invite/:code',
        breadcrumbKey: 'accept-invite'
    },
    {
        path: '/feedback/questionnaire/:id',
        breadcrumbKey: 'feedback-questionnaire'
    },
    // video coach
    {
        path: '/videocoach',
        breadcrumbKey: 'video-coach-nav-title'
    },
    {
        path: '/videocoach/my-coach',
        breadcrumbKey: 'my-coach'
    },
    {
        path: '/videocoach/chat/:coachId',
        breadcrumbKey: 'Chat'
    },
    {
        path: '/videocoach/book-meeting',
        breadcrumbKey: 'book-meeting-nav-title'
    }
];
var $8b757c88fddf920a$export$2e2bcd8739ae039 = $8b757c88fddf920a$var$breadcrumbConfig;



var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $da5ec3e0980c5bd3$var$DEBUG = false;
var $da5ec3e0980c5bd3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function WebSocketClient(userId, userName) {
        (0, $5Epmf._)(this, WebSocketClient);
        this.unReadMessage = false;
        this.userId = userId ? userId : window.localStorage[(0, $632c75b97b900307$export$1630b5343357e8b5).PERSON_TOKEN];
        this.userName = userName ? userName : window.localStorage[(0, $632c75b97b900307$export$1630b5343357e8b5).USERNAME_TOKEN];
        this.checkOpen();
        this.eventEl = document.createTextNode('');
    }
    (0, $9MqXK._)(WebSocketClient, [
        {
            key: "checkOpen",
            value: function checkOpen() {
                if (this.webSocket) {
                    if (this.webSocket.readyState === this.webSocket.CONNECTING) {
                        if ($da5ec3e0980c5bd3$var$DEBUG) console.log('Socket: already connecting, exiting');
                        return;
                    } else if (this.webSocket.readyState === this.webSocket.OPEN) {
                        if ($da5ec3e0980c5bd3$var$DEBUG) console.log('Socket: already open, exiting');
                        return;
                    } else if (this.webSocket.readyState === this.webSocket.CLOSING) {
                        if ($da5ec3e0980c5bd3$var$DEBUG) console.log('Socket: is closing ----- todo: reopen when closed');
                        return;
                    } else if (this.webSocket.readyState === this.webSocket.CLOSED) {
                        if ($da5ec3e0980c5bd3$var$DEBUG) console.log('Socket: is closed ----- todo: reopen when closed');
                    }
                }
                if (!this.userId) {
                    if ($da5ec3e0980c5bd3$var$DEBUG) console.log('Socket: No token, exiting');
                    return;
                }
                this.openSocket();
            }
        },
        {
            key: "openSocket",
            value: function openSocket(extraMessage) {
                var _this = this;
                if ($da5ec3e0980c5bd3$var$DEBUG) console.log("WEB_SOCKET_ENDPOINT", (0, $632c75b97b900307$export$1630b5343357e8b5).WEB_SOCKET_ENDPOINT);
                this.webSocket = new WebSocket((0, $632c75b97b900307$export$1630b5343357e8b5).WEB_SOCKET_ENDPOINT);
                if ($da5ec3e0980c5bd3$var$DEBUG) console.log('socket new WebSocket: ' + this.webSocket.readyState);
                // console.log('Tried opening websocket')
                this.webSocket.onerror = function(err) {
                    console.log(err);
                    if (_this.webSocket) console.log('socket error: ' + _this.webSocket.readyState);
                };
                this.webSocket.onopen = function() {
                    // console.log('Sending', JSON.stringify(mess))
                    if (_this.webSocket) {
                        var mess = {
                            type: 'session_init',
                            user_name: _this.userName,
                            user_id: _this.userId
                        };
                        if ($da5ec3e0980c5bd3$var$DEBUG) console.log('socket onopen: ' + _this.webSocket.readyState);
                        _this.webSocket.send(JSON.stringify(mess));
                        if (extraMessage) // We just sent the init call - wait for a short while to let first message arrive at websocket server
                        // TODO - it would be better to wait for session_init confirmation before sending next message
                        setTimeout(function() {
                            if (_this.webSocket) {
                                _this.webSocket.send(JSON.stringify(extraMessage));
                                if ($da5ec3e0980c5bd3$var$DEBUG) console.log('Sent message after open');
                            }
                        }, 200);
                    }
                };
                // Use addEventListener in places where message matters, e.g VideoMeeting
                // This is just for debugging
                // this.webSocket.onmessage = (message) => {
                //   const jsonMess = JSON.parse(message.data)
                //   // console.log(jsonMess)
                // }
                this.webSocket.onclose = function() {
                    if ($da5ec3e0980c5bd3$var$DEBUG) console.log('socket closed');
                    clearInterval(_this.pingInterval);
                };
                this.pingInterval = setInterval(function() {
                    if (_this.webSocket) {
                        var _this_webSocket, _this_webSocket1;
                        if (((_this_webSocket = _this.webSocket) === null || _this_webSocket === void 0 ? void 0 : _this_webSocket.readyState) === ((_this_webSocket1 = _this.webSocket) === null || _this_webSocket1 === void 0 ? void 0 : _this_webSocket1.OPEN)) {
                            var mess = {
                                type: 'ping'
                            };
                            if ($da5ec3e0980c5bd3$var$DEBUG) console.log(JSON.stringify(mess));
                            _this.webSocket.send(JSON.stringify(mess));
                        } else console.log('webSocket not open');
                    } else console.log('No webSocket!');
                }, 30000);
            }
        }
    ], [
        {
            key: "getInstance",
            value: /**
   * @returns {WebSocketClient}
   */ function getInstance() {
                if (WebSocketClient.myInstance == null) {
                    if ($da5ec3e0980c5bd3$var$DEBUG) console.log('HD: creating new instance');
                    WebSocketClient.myInstance = new WebSocketClient();
                } else {
                    if ($da5ec3e0980c5bd3$var$DEBUG) console.log('HD: checking existing instance');
                    WebSocketClient.myInstance.checkOpen();
                }
                return this.myInstance;
            }
        }
    ]);
    return WebSocketClient;
}();







var $3ef03561ea7a950e$exports = {};
$3ef03561ea7a950e$exports = $parcel$resolve("6W7Qo");


var $6075bea0246b16ae$exports = {};
$6075bea0246b16ae$exports = $parcel$resolve("7EkqR");



// if not localhost
if (window.location.hostname !== "localhost") $e2a44b5d0c19e6d4$export$2cd8252107eb640b({
    dsn: "https://3436c77ca5096a2502811a7920a68314@o4507441234575360.ingest.de.sentry.io/4507583744049232",
    integrations: [
        $6bac36247b18b476$export$b4109253475213e9(),
        $dbab849fc0bcf4ad$export$d7706faf7ab354bf()
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0
});
var $ffa77426b0cd6a2d$export$86fbec116b87613f = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var location = (0, $bHX26.useLocation)();
    var _useSearchParams = (0, $6iP9u._)((0, $bHX26.useSearchParams)(), 1), searchParams = _useSearchParams[0];
    var navigate = (0, $bHX26.useNavigate)();
    var navbarRef = (0, $5s1kH.useRef)(null);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(window.innerWidth > 924), 2), wide = _useState[0], setWide = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), debug = _useState1[0], setDebug = _useState1[1];
    var i18n = (0, $341d5702266247e0$export$9fc83ad70ead8663)().i18n;
    var webSocketClient = (0, $5s1kH.useRef)((0, $da5ec3e0980c5bd3$export$2e2bcd8739ae039).getInstance());
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), expired = _useState2[0], setExpired = _useState2[1];
    var setThreads = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$27d71ceb0a5d4830));
    var setCustomerCategories = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$bcd68c06e4ab205));
    var setFocusAreas = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$8089542cc82d07d0));
    var setPicture = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$f6340943ad252ff2));
    var setLang = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$3e88fe72f2048427));
    var setOnboarded = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$af51c67eaab3b0e9));
    var setCustomerSurveys = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$e12ef450b148e207));
    var _useAtom = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$12972e612ad7cf0)), 2), globalToast = _useAtom[0], setGlobalToast = _useAtom[1];
    var _useAtom1 = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$cde9a322e13eb845)), 2), unreadChats = _useAtom1[0], setUnreadChats = _useAtom1[1];
    var setDepartment = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$b8c60edfdda1ff8f));
    var _useAuth0 = (0, $65283fdff51e8344$export$f2b63d3ca66bb884)(), isAuthenticated = _useAuth0.isAuthenticated, isLoading = _useAuth0.isLoading;
    var showMenu = !wide;
    // Don't show menu if we show the feedback page to external users (?token=[external_token])
    var loggedIn = !(location.pathname.startsWith('/feedback/survey') && location.search.startsWith('?token='));
    var messageListener = function(event) {
        var mess = JSON.parse(event.data);
        if (!mess) return;
        if (mess.type === 'unread_chats') // This event comes from server counting number of unread chats
        setUnreadChats(mess.number);
        else if (mess.type === 'meeting' && mess.badges.unread > 0) {
            // This event comes from when a client sends a chat to coach
            if (window.location.pathname.startsWith('/videocoach/chat/')) {
                var coachId = window.location.pathname.substring(17);
                api.get('client/read_messages/' + coachId).then(function() {
                    return console.log('signalled read');
                });
                return;
            }
            setUnreadChats(1);
        }
    };
    (0, $5s1kH.useEffect)(function() {
        var // No need for web socket listener if external questionnaire request
        _webSocketClient_current_webSocket;
        if (!isAuthenticated) return;
        if (!(location.pathname.startsWith('/feedback/questionnaire') && location.search.startsWith('?token='))) (_webSocketClient_current_webSocket = webSocketClient.current.webSocket) === null || _webSocketClient_current_webSocket === void 0 ? void 0 : _webSocketClient_current_webSocket.addEventListener("message", messageListener);
        api.get('user/start/' + (0, $632c75b97b900307$export$1630b5343357e8b5).USER_TYPE).then(function(response) {
            setThreads(response.json.threads);
            setUnreadChats(response.json.unreadChats);
            setCustomerCategories(response.json.customerCategories);
            setFocusAreas(response.json.focusAreas);
            setExpired(response.json.expired);
            setPicture(response.json.picture);
            setLang(response.json.language);
            setDebug(response.json.debug);
            setDepartment(response.json.department);
            setOnboarded(response.json.onboarded);
            setCustomerSurveys(response.json.customerSurveys);
            window.localStorage[(0, $632c75b97b900307$export$1630b5343357e8b5).PERSON_TOKEN] = response.json.token;
            window.localStorage[(0, $632c75b97b900307$export$1630b5343357e8b5).USERNAME_TOKEN] = response.json.name;
        });
        function setViewportHeight() {
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
            setWide(window.innerWidth > 924);
        }
        setViewportHeight();
        window.addEventListener('resize', setViewportHeight);
        window.addEventListener('orientationchange', setViewportHeight);
        return function() {
            var _webSocketClient_current_webSocket;
            (_webSocketClient_current_webSocket = webSocketClient.current.webSocket) === null || _webSocketClient_current_webSocket === void 0 ? void 0 : _webSocketClient_current_webSocket.removeEventListener("message", messageListener);
            window.removeEventListener('resize', setViewportHeight);
            window.removeEventListener('orientationchange', setViewportHeight);
        };
    }, [
        isAuthenticated
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (globalToast) {
            // https://www.npmjs.com/package/react-toastify
            var toastData = {
                position: globalToast.position ? globalToast.position : "top-right",
                theme: globalToast.theme ? globalToast.theme : "dark",
                closeOnClick: false,
                pauseOnFocusLoss: true,
                hideProgressBar: true,
                closeButton: false,
                autoClose: globalToast.autoClose ? globalToast.autoClose : 3000,
                transition: (0, $69c96f0c9b63d8d4$export$d8dc01b5c85a37b9),
                onClose: function() {
                    setGlobalToast(null);
                }
            };
            if (globalToast.type === "error") (0, $69c96f0c9b63d8d4$export$b410431fab84fa58).error(globalToast.text, toastData);
            else if (globalToast.type === "info") (0, $69c96f0c9b63d8d4$export$b410431fab84fa58).info(InfoToast, toastData);
            else if (globalToast.type === "warning") (0, $69c96f0c9b63d8d4$export$b410431fab84fa58).warning(globalToast.text, toastData);
            else (0, $69c96f0c9b63d8d4$export$b410431fab84fa58).success(globalToast.text, toastData);
        }
    }, [
        globalToast
    ]);
    function InfoToast() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "text-center",
            style: {
                minWidth: 300
            },
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mx-auto",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (globalToast === null || globalToast === void 0 ? void 0 : globalToast.infoType) === "created" ? (0, (/*@__PURE__*/$parcel$interopDefault($3ef03561ea7a950e$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($6075bea0246b16ae$exports))),
                        alt: "info",
                        className: "h-20 w-20 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 z-title1",
                        children: globalToast === null || globalToast === void 0 ? void 0 : globalToast.text
                    })
                ]
            })
        });
    }
    // useEffect(() => {
    //   window.HSStaticMethods.autoInit();
    // }, [location.pathname]);
    (0, $5s1kH.useEffect)(function() {
        var isAuth = isAuthenticated && !isLoading;
        if (!isLoading) {
            // TODO: SHOULD BE DEPENDED ON THE LOCAL USER STATE
            if (isAuth && location.pathname === "/auth") {
                var redirectTo = searchParams.get('redirectTo');
                if (redirectTo) navigate(redirectTo);
            } else isAuth;
        }
    }, [
        isLoading,
        isAuthenticated
    ]);
    if (expired) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "font-hoves mt-6 text-center",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                children: [
                    expired,
                    " \u2014 you\u2019re currently unable to access the platform."
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                className: "mt-4",
                children: [
                    "Reach out to your manager or HR, or contact us at\xa0",
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("a", {
                        className: "z-link",
                        href: "mailto:support@zebrain.se",
                        children: "support@zebrain.se"
                    }),
                    "\xa0 and we\u2019ll help you get back on track."
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "font-hoves",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-col h-screen-custom",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        ref: navbarRef,
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d2052a650287066$export$2e2bcd8739ae039), {
                            showMenu: showMenu && loggedIn,
                            loggedIn: loggedIn,
                            i18n: i18n,
                            badges: unreadChats > 0,
                            debug: debug
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex",
                        children: [
                            loggedIn && wide && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $68df94d610fdbee0$export$2e2bcd8739ae039), {
                                showSidebar: true
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "z-main-scroll" + (loggedIn && wide ? " z-has-left-col ml-16" : ""),
                                id: "main_for_scrolling",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $85aba988ba8043ef$export$2e2bcd8739ae039), {
                                        breadcrumbConfig: (0, $8b757c88fddf920a$export$2e2bcd8739ae039)
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bHX26.Outlet), {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $69c96f0c9b63d8d4$export$f2815235e76a62b9), {
                icon: function(param) {
                    var type = param.type;
                    switch(type){
                        case 'success':
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($be3c5e2d6f294fc0$exports))),
                                alt: "success"
                            });
                        default:
                            return null;
                    }
                }
            })
        ]
    });
};




var $5s1kH = parcelRequire("5s1kH");


var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");

var $47061abfd6e69775$var$AcceptInvitePage = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var code = (0, $bHX26.useParams)().code; // Extract invite code from URL
    var navigate = (0, $bHX26.useNavigate)(); // Hook to navigate programmatically
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(''), 2), error = _useState1[0], setError = _useState1[1];
    (0, $5s1kH.useEffect)(function() {
        var data = {
            code: code
        };
        api.post('client/accept_invite', data).then(function(response) {
            setLoading(false);
            if (response.json.status === "ok") // TODO: Should we use a javascript window.location.href = / instead?
            // window.location.href = "/";
            navigate('/');
            else if (response.json.error) setError(response.json.error);
            else setError('Unknown error. Please contact support');
        });
    }, []);
    if (loading) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        children: "Loading..."
    });
    if (error.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "text-center mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        children: "Invite accepted successfully!"
    }); // This message will appear briefly before redirecting
};
var $47061abfd6e69775$export$2e2bcd8739ae039 = $47061abfd6e69775$var$AcceptInvitePage;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");



parcelRequire("5s1kH");


var $aTwoM = parcelRequire("aTwoM");

var $cd7f401ba602b868$var$langMap = {
    "settings": [
        "Settings",
        "Inst\xe4llningar"
    ],
    "starting-video": [
        "Starting video",
        "Startar video"
    ],
    "starting-camera": [
        "Starting camera",
        "Startar kamera"
    ],
    "starting-network": [
        "Starting network",
        "Startar n\xe4tverk"
    ],
    "booked-meetings": [
        "Booked meetings",
        "Bokade m\xf6ten"
    ],
    "previous-meetings": [
        "Previous meetings",
        "Tidigare m\xf6ten"
    ],
    "coming": [
        "Upcoming",
        "Kommande"
    ],
    "earlier": [
        "Earlier",
        "Tidigare"
    ],
    "previous": [
        "Previous",
        "F\xf6reg\xe5ende"
    ],
    "calendar": [
        "Calendar",
        "Kalender"
    ],
    "start": [
        "Start",
        "Start"
    ],
    "my-bookings": [
        "My bookings",
        "Mina bokningar"
    ],
    "meetings": [
        "Meetings",
        "M\xf6ten"
    ],
    "menu-support": [
        "Support",
        "Support"
    ],
    "menu-about-company": [
        "About Zebrain",
        "Om Zebrain"
    ],
    "logout": [
        "Log out",
        "Logga ut"
    ],
    "about-nav-title": [
        "About Zebrain",
        "Om Zebrain"
    ],
    "support-nav-title": [
        "Support",
        "Support"
    ],
    "support-description-placeholder": [
        "Describe your issue here...",
        "Beskriv ditt problem h\xe4r..."
    ],
    "support-email-info": [
        "You can also email us at",
        "Du kan ocks\xe5 mejla oss p\xe5"
    ],
    "set-availability": [
        "Set availability",
        "St\xe4ll in tillg\xe4nglighet"
    ],
    "set-hours-per-day": [
        "Set hours per day",
        "St\xe4ll in timmar per dag"
    ],
    "availability": [
        "Availability",
        "Tillg\xe4nglighet"
    ],
    "availability-timeperiod": [
        "Time period for availability",
        "Tidsperiod f\xf6r tillg\xe4nglighet"
    ],
    "availability-timeperiod-set": [
        "Set for how long your schedule lasts",
        "St\xe4ll in hur l\xe4nge ditt schema ska g\xe4lla"
    ],
    "number-of-weeks": [
        "Number of weeks",
        "Antal veckor"
    ],
    "standard-schedule": [
        "Standard schedule",
        "Ordinarie schema"
    ],
    "deviant-schedule": [
        "Deviant dates",
        "Avvikande datum"
    ],
    "schedule": [
        "Schedule",
        "Schema"
    ],
    "other-settings": [
        "Other settings",
        "\xd6vriga inst\xe4llningar"
    ],
    "sync-external-calendar": [
        "Sync external calendar",
        "Synka extern kalender"
    ],
    "add-extra-availability": [
        "Add extra availability",
        "L\xe4gg till extra tillg\xe4nglighet"
    ],
    "add": [
        "Add",
        "L\xe4gg till"
    ],
    "block-time-dates": [
        "Block time and dates",
        "Blockera tider och datum"
    ],
    "cancel": [
        "Cancel",
        "Avbryt"
    ],
    "save": [
        "Save",
        "Spara"
    ],
    "delete": [
        "Delete",
        "Ta bort"
    ],
    "hours": [
        "hours",
        "timmar"
    ],
    "minutes": [
        "minutes",
        "minuter"
    ],
    "extra-availability-text": [
        "You can choose multiple dates. Selected dates overrules the standard schedule.",
        "Du kan v\xe4lja flera datum samtidigt. Valda datum \xe5sidos\xe4tter standardschemat."
    ],
    "time-before-booking": [
        "Booking-to-Meeting Buffer",
        "Tid mellan ny bokning och m\xf6tets start"
    ],
    "time-before-booking-set": [
        "Select the minimum time gap between a new booking and the meeting start.",
        "Ange den minsta tidsmarginalen mellan en ny bokning och m\xf6tesstart."
    ],
    "time-head": [
        "Time ahead",
        "Tid i f\xf6rv\xe4g"
    ],
    "start-interval": [
        "Start interval",
        "Startintervall"
    ],
    "start-interval-set": [
        "Set start interval for meetings",
        "St\xe4ll in startintervall f\xf6r m\xf6ten"
    ],
    "time-interval": [
        "Time interval",
        "Tidsintervall"
    ],
    "max-bookings": [
        "Daily booking limit",
        "Max antal bokningar per dag"
    ],
    "max-bookings-set": [
        "Select the maximum number of bookings allowed per day",
        "St\xe4ll in det maximala antalet bokningar per dag"
    ],
    "max-per-day": [
        "Max per day",
        "Max per dag"
    ],
    "buffer-time": [
        "Meeting-to-Meeting buffer",
        "Bufferttid"
    ],
    "buffer-time-set": [
        "Select the minimum time gap between consecutive meetings",
        "St\xe4ll in den minsta pausen efter ett m\xf6te innan n\xe4sta kan b\xf6rja."
    ],
    "my-clients": [
        "My clients",
        "Mina klienter"
    ],
    "my-profile": [
        "My profile",
        "Min profil"
    ],
    "language": [
        "Language",
        "Spr\xe5k"
    ],
    "languages": [
        "Languages",
        "Spr\xe5k"
    ],
    "select-language": [
        "Select language",
        "V\xe4lj spr\xe5k"
    ],
    "select": [
        "Select",
        "V\xe4lj"
    ],
    "choose-coaching-language": [
        "Choose language to coach in",
        "V\xe4lj spr\xe5k att coacha p\xe5"
    ],
    "profile-intro": [
        "Short about your self as coach",
        "Kort om dig som coach"
    ],
    "profile-expertise": [
        "Expertise",
        "Expertis"
    ],
    "profile-experience": [
        "Experience",
        "Erfarenhet"
    ],
    "profile-philosophy": [
        "Philosophy",
        "Filosofi"
    ],
    "no-meetings-today": [
        "You have no meetings today.",
        "Du har inga m\xf6ten idag."
    ],
    "one-meeting-today": [
        "You have one meeting today.",
        "Du har ett m\xf6te idag."
    ],
    "you-have": [
        "You have ",
        "Du har"
    ],
    "meetings-today": [
        "meetings booked today",
        "m\xf6ten inbokade idag"
    ],
    "cs": [
        "Czech",
        "Tjeckiska"
    ],
    "no": [
        "Norwegian",
        "Norska"
    ],
    "nl": [
        "Ductch",
        "Holl\xe4ndska"
    ],
    "el": [
        "Greek",
        "Grekiska"
    ],
    "hu": [
        "Hungarian",
        "Ungerska"
    ],
    "pl": [
        "Polish",
        "Polska"
    ],
    "pt": [
        "Portuguese",
        "Portugisiska"
    ],
    "es": [
        "Spanish",
        "Spanska"
    ],
    "sv": [
        "Swedish",
        "Svenska"
    ],
    "fi": [
        "Finnish",
        "Finska"
    ],
    "en": [
        "English",
        "Engelska"
    ],
    "de": [
        "German",
        "Tyska"
    ],
    "fr": [
        "French",
        "Franska"
    ],
    "da": [
        "Danish",
        "Danska"
    ],
    "it": [
        "Italian",
        "Italienska"
    ],
    "lt": [
        "Lithuanian",
        "Litauiska"
    ],
    "change": [
        "Change",
        "\xc4ndra"
    ],
    "go-to-meeting": [
        "Go to meeting",
        "G\xe5 till m\xf6tet"
    ],
    "to-meeting": [
        "To meeting",
        "Till m\xf6te"
    ],
    "cancel-booking": [
        "Cancel",
        "Avboka"
    ],
    "today": [
        "Today",
        "Idag"
    ],
    "next-meeting": [
        "Next meeting",
        "N\xe4sta m\xf6te"
    ],
    "next": [
        "Next",
        "N\xe4sta"
    ],
    "hi": [
        "Hi",
        "Hej"
    ],
    "add-more-availability": [
        "Set availability",
        "St\xe4ll in tillg\xe4nglighet"
    ],
    "complete-profiles": [
        "Complete profiles",
        "F\xe4rdigst\xe4ll profiler"
    ],
    "go-to-profile": [
        "Go to My profile",
        "G\xe5 till Min profil"
    ],
    "go-to-availability": [
        "Go to Availability settings",
        "G\xe5 till Tillg\xe4nglighet"
    ],
    "original-booking": [
        "Original booking",
        "Ursprunglig bokning"
    ],
    "your-meeting-has": [
        "Your meeting has",
        "Ditt m\xf6te har"
    ],
    "client-is-notified": [
        "and your client is notified",
        "och din klient har uppdaterats"
    ],
    "write-message-to-client": [
        "Write a message to the client...",
        "Skriv ett meddelande till klienten..."
    ],
    "been-changed": [
        "been changed",
        "\xe4ndrats"
    ],
    "been-booked": [
        "been booked",
        "bokats"
    ],
    "book-meeting": [
        "Book meeting",
        "Boka m\xf6te"
    ],
    "change-meeting": [
        "Change meeting",
        "\xc4ndra m\xf6te"
    ],
    "cancel-meeting": [
        "Cancel meeting",
        "Avboka m\xf6te"
    ],
    "available-times": [
        "Available times",
        "Lediga tider"
    ],
    "development-plan": [
        "Development plan",
        "Utvecklingsplan"
    ],
    "read": [
        "Read",
        "L\xe4s"
    ],
    "professional-details": [
        "Professional details",
        "Yrkesdetaljer"
    ],
    "level": [
        "Level",
        "Niv\xe5"
    ],
    "in-company-since": [
        "In company since",
        "I f\xf6retaget sedan"
    ],
    "current-role-since": [
        "Current role since",
        "Nuvarande roll sedan"
    ],
    "non-managerial": [
        "Non-managerial employee",
        "Anst\xe4lld utan ledande befattning"
    ],
    "manager_team": [
        "Manager with team and/or personnel responsibility",
        "Chef med team- och/eller personalansvar"
    ],
    "c_level": [
        "C-level executive",
        "Chef p\xe5 C-niv\xe5"
    ],
    "title": [
        "Title",
        "Titel"
    ],
    "coaching-areas-of-interest": [
        "Coaching areas of interest",
        "Coachomr\xe5den av intresse"
    ],
    "experience-of-being-coached": [
        "Experience of being coached",
        "Erfarenhet av att ha haft coaching"
    ],
    "executive_coaching": [
        "Executive coaching",
        "Chefscoaching"
    ],
    "team_coaching": [
        "Team coaching",
        "Teamcoaching"
    ],
    "leadership_coaching": [
        "Leadership coaching",
        "Ledarskapscoaching"
    ],
    "business_coaching": [
        "Business coaching",
        "Aff\xe4rscoaching"
    ],
    "agile_coaching": [
        "Agile coaching",
        "Agil coaching"
    ],
    "inclusive_corporate_culture": [
        "Inclusive corporate culture",
        "Inkluderande f\xf6retagskultur"
    ],
    "lifestyle_health": [
        "Lifestyle and health",
        "Livsstil och h\xe4lsa"
    ],
    "stress_management": [
        "Stress management",
        "Stresshantering"
    ],
    "life_coaching": [
        "Life coaching",
        "Livscoaching"
    ],
    "mental_training": [
        "Mental training",
        "Mental tr\xe4ning"
    ],
    "self_leadership": [
        "Self-leadership",
        "Sj\xe4lvledarskap"
    ],
    "rehabilitation": [
        "Rehabilitation",
        "Rehabilitering"
    ],
    "career_coaching": [
        "Career coaching",
        "Karri\xe4rcoaching"
    ],
    "transit_coaching": [
        "Transit coaching",
        "Transitcoaching"
    ],
    "mentorship": [
        "Mentorship",
        "Mentorskap"
    ],
    "self-assessment": [
        "Self-assessment",
        "Sj\xe4lvskattning"
    ],
    "feedback-score": [
        "Feedback",
        "Feedback"
    ],
    "perception-gap": [
        "Perception gap",
        "Gap"
    ],
    "read-more": [
        "Read more",
        "L\xe4s mer"
    ],
    "read-less": [
        "Read less",
        "L\xe4s mindre"
    ],
    "analysis": [
        "Analysis",
        "Analys"
    ],
    "write-text-here": [
        "Write text here...",
        "Skriv text h\xe4r..."
    ],
    "yes": [
        "Yes",
        "Ja"
    ],
    "synced-calendars": [
        "Synced calendars",
        "Synkade kalendrar"
    ],
    "send": [
        "Send",
        "Skicka"
    ],
    "summary": [
        "Summary",
        "Sammanst\xe4llning"
    ],
    "notes": [
        "Notes",
        "Anteckningar"
    ],
    "client": [
        "Client",
        "Klient"
    ],
    "chat-placeholder": [
        "Type your message here...",
        "Skriv ditt meddelande h\xe4r..."
    ],
    "support-modal-success-title": [
        "Thank you for reaching out to us! ",
        "Tack f\xf6r att du kontaktar oss! "
    ],
    "support-modal-success-description": [
        "We will get back to you as soon as possible.",
        "Vi \xe5terkommer s\xe5 snart som m\xf6jligt."
    ],
    "support-error-message": [
        "An error occurred, please try again later.",
        "Ett fel uppstod, f\xf6rs\xf6k igen senare."
    ],
    "goal": [
        "Goal",
        "M\xe5l"
    ],
    "description": [
        "Description",
        "Beskrivning"
    ],
    "details": [
        "Details",
        "Details"
    ],
    "starting-point": [
        "Assess your starting point",
        "Startl\xe4ge"
    ],
    "importance-level": [
        "Importance level",
        "Hur viktigt \xe4r m\xe5let"
    ],
    "success-metrics": [
        "Success metrics",
        "M\xe5tt f\xf6r framg\xe5ng"
    ],
    "target-date": [
        "Target date",
        "M\xe5ldatum"
    ],
    "goal-journey": [
        "Goal journey",
        "M\xe5lets resa"
    ],
    "set-your-goal": [
        "Set your goal",
        "S\xe4tt ditt m\xe5l"
    ],
    "set-your-goal-text": [
        "Define what success looks like for you.",
        "Definiera vad framg\xe5ng betyder f\xf6r dig"
    ],
    "stay-on-track": [
        "Check in",
        "H\xe5ll dig p\xe5 r\xe4tt sp\xe5r"
    ],
    "stay-on-track-text": [
        "Check in regularly to remove blockers, and gather feedback from your colleagues.",
        "Kontrollera ofta och ta bort hinder"
    ],
    "get-feedback-along-the-way": [
        "Follow up",
        "F\xe5 feedback l\xe4ngs v\xe4gen"
    ],
    "get-feedback-along-the-way-text": [
        "Reflect on your journey and send a new feedback request to see how your progress is perceived and what you can improve.",
        "Skapa medvetenhet om din process och justera din strategi vid behov"
    ],
    "decide-whats-next": [
        "Decide what's next",
        "Best\xe4m vad som \xe4r n\xe4sta steg"
    ],
    "decide-whats-next-text": [
        "Set a new goal, or start a new Focus Area",
        "S\xe4tt ett nytt m\xe5l eller starta ett nytt fokusomr\xe5de"
    ],
    "set-goal-description": [
        "Setting a clear goal gives you direction, keeps you focused, and aligns your efforts with what truly matters\u2014driving meaningful progress.",
        "Att s\xe4tta ett tydligt m\xe5l ger dig riktning, h\xe5ller dig fokuserad och anpassar dina anstr\xe4ngningar med det som verkligen betyder n\xe5got \u2013 att driva meningsfulla framsteg."
    ],
    "coaching-tools": [
        "Coaching tools",
        "Coachingverktyg"
    ],
    "focus-area": [
        "Focus area",
        "Fokusomr\xe5de"
    ],
    "due-date": [
        "Due date",
        "Slutdatum"
    ],
    "home": [
        "Home",
        "Hem"
    ],
    "all": [
        "All",
        "Alla"
    ],
    "invalid-email": [
        "Invalid email address. Please enter a correct email address",
        "Ogiltig e-postadress. Ange en korrekt e-postadress"
    ],
    "getstart": [
        "Get started!",
        "Kom ig\xe5ng!"
    ],
    "deadline": [
        "Deadline",
        "Slutdatum"
    ],
    "continue": [
        "Continue",
        "Forts\xe4tt"
    ],
    "time-ago-now": [
        "now",
        "nu"
    ],
    "submit": [
        "Submit",
        "Skicka"
    ],
    "search-email": [
        "Search email",
        "S\xf6k e-postadress"
    ],
    "chat-send": [
        "Send",
        "Skicka"
    ],
    "chat-start": [
        "Get started",
        "Kom ig\xe5ng"
    ],
    "chat": [
        "Chat",
        "Chatt"
    ],
    "menu-my-tasks": [
        "Actions",
        "Aktiviteter"
    ],
    "menu-development-plan": [
        "Development plan",
        "Utvecklingsplan"
    ],
    "menu-my-account": [
        "My account",
        "Mitt konto"
    ],
    "task": [
        "Action",
        "Aktivitet"
    ],
    "tasks-page-title": [
        "Select action to work on",
        "V\xe4lj aktivitet att arbeta med"
    ],
    "auto-task-chat-message": [
        "I would like to continue working on my action",
        "Jag vill forts\xe4tta arbeta med min aktivitet"
    ],
    "development-area-page-title": [
        "Select focus area",
        "V\xe4lj fokusomr\xe5de"
    ],
    "focus-area-quick-select": [
        "Quick select",
        "Snabbval"
    ],
    "focus-area-start-chat": [
        "I want to start coaching within the focus area",
        "Jag vill starta coaching inom fokusomr\xe5det"
    ],
    "focus-area-start-chat-button": [
        "Start coaching session",
        "Starta coachsession"
    ],
    "focus-area-learn-more-button": [
        "Learn more about the topic",
        "L\xe4r mig mer om \xe4mnet"
    ],
    "chat-nav-title": [
        "Chat",
        "Chatt"
    ],
    "tasks-nav-title": [
        "Actions",
        "Aktiviteter"
    ],
    "ongoing": [
        "In progress",
        "P\xe5g\xe5ende"
    ],
    "completed": [
        "Completed",
        "F\xe4rdiga"
    ],
    "skipped": [
        "Skipped",
        "Hoppade \xf6ver"
    ],
    "completed-tasks": [
        "Completed actions",
        "F\xe4rdiga aktiviteter"
    ],
    "development-plan-nav-title": [
        "Development plan",
        "Min utvecklingsplan"
    ],
    "focus-area-nav-title": [
        "Focus Area",
        "Fokusomr\xe5de"
    ],
    "no-tasks": [
        "You have no actions yet! Start working on a Focus Area and let the AI Coach create it for you.",
        "Du har inga aktiviteter \xe4n. B\xf6rja arbeta med ett fokusomr\xe5de och l\xe5t AI-coachen skapa en till dig."
    ],
    "no-development-areas": [
        "You have not created any focus areas.",
        "Du har inte skapat n\xe5gra fokusomr\xe5den."
    ],
    "support-page-title": [
        "What can we help you with?",
        "Vad kan vi hj\xe4lpa dig med?"
    ],
    "feedback-nav-title": [
        "Feedback",
        "Feedback"
    ],
    "feedback-title": [
        "Feedback and insights",
        "Feedback och insikter"
    ],
    "feedback-one-breadcrumb": [
        "Result",
        "Resultat"
    ],
    "menu-feedback": [
        "Feedback and insights",
        "Feedback och insikter"
    ],
    "request-feedback": [
        "Request feedback",
        "Be om feedback"
    ],
    "received-feedback": [
        "Received feedback",
        "Mottagen feedback"
    ],
    "choose-feedback": [
        "Choose what to get feedback on",
        "V\xe4lj vad du vill f\xe5 \xe5terkoppling p\xe5"
    ],
    "create-feedback": [
        "Create feedback",
        "Skapa \xe5terkoppling"
    ],
    "feedback-create-review-questions": [
        "Create feedback questions",
        "Skapa feedbackfr\xe5gor"
    ],
    "feedback-select-recipients": [
        "Add recipients",
        "V\xe4lj mottagare"
    ],
    "feedback-recipients": [
        "Recipients",
        "Mottagare"
    ],
    "feedback-recipients-add": [
        "Add recipients",
        "L\xe4gg till mottagare"
    ],
    "feedback-results": [
        "Feedback results",
        "\xc5terkopplingsresultat"
    ],
    "feedback-search-recipients": [
        "Search for recipient",
        "S\xf6k mottagare"
    ],
    "feedback-search-by-name": [
        "Search by name",
        "S\xf6k efter namn"
    ],
    "other-subject": [
        "Other subject",
        "\xd6vrigt \xe4mne"
    ],
    "create-review-question": [
        "Create review question",
        "Skapa \xe5terkopplingsfr\xe5ga"
    ],
    "feedback-create-summary": [
        "Summary",
        "Sammanfattning"
    ],
    "feedback-regenerate-question": [
        "Regenerate question",
        "\xc4ndra fr\xe5ga"
    ],
    "feedback-input-placeholder": [
        "Write text here...",
        "Beskriv din \xe4ndring..."
    ],
    "feedback-add-question": [
        "Add question",
        "L\xe4gg till fr\xe5ga"
    ],
    "select-all": [
        "Select all",
        "V\xe4lj alla"
    ],
    "send-request": [
        "Send request",
        "Skicka f\xf6rfr\xe5gan"
    ],
    "feedback-change-question": [
        "Describe how you would like to change the question",
        "Beskriv hur du skulle vilja \xe4ndra fr\xe5gan"
    ],
    "feedback-review-questions": [
        "Review questions",
        "Feedbackfr\xe5gor"
    ],
    "feedback-request-sent": [
        "Feedback request sent",
        "F\xf6rfr\xe5gan skickad"
    ],
    "feedback-summary-modal-body": [
        "Your feedback request is sent. You will get a notification when you recieve feedback on Feedback page.",
        "Din \xe5terkopplingsf\xf6rfr\xe5gan \xe4r skickad. Du kommer f\xe5 en notifikation n\xe4r du f\xe5r \xe5terkoppling p\xe5 \xc5terkopplingssidan."
    ],
    "feedback-recipients-alert": [
        "Select at least {{number}} recipient(s)",
        "V\xe4lj minst {{number}} mottagare"
    ],
    "feedback-recipients-summary-alert": [
        "Go back to select at least 1 recipients",
        "G\xe5 tillbaka och v\xe4lj minst 1 mottagare"
    ],
    "feedback-create-question-alert": [
        "Go back to create at least 1 review question",
        "G\xe5 tillbaka och skapa minst en feedbackfr\xe5ga"
    ],
    "feedback-is-anonymous": [
        "Your answer is anonymous.",
        "Ditt svar \xe4r anonymt."
    ],
    "received": [
        "Received answers",
        "Mottagna svar"
    ],
    "feedback-out-of": [
        "feedback out of",
        "\xe5terkopplingar av"
    ],
    "out-of": [
        "out of",
        "av"
    ],
    "responses": [
        "responses",
        "svar"
    ],
    "feedback-number-of-feedbacks": [
        "recipients have already responded.",
        "mottagare har redan svarat."
    ],
    "feedback-time-left": [
        "The deadline for submissions is",
        "Sista datum f\xf6r inl\xe4mning \xe4r den"
    ],
    "feedback-sent": [
        "Feedback sent",
        "Feedback skickad"
    ],
    "feedback-selected-recipients": [
        "Selected recipients",
        "Valda mottagare"
    ],
    "feedback-no-selected-recipients": [
        "No selected recipients",
        "Inga valda mottagare"
    ],
    "feedback-response-form-alert": [
        "Please fill in all fields",
        "V\xe4nligen fyll i alla f\xe4lt"
    ],
    "feedback-recipientpage-questions-alert": [
        "It looks like you've deleted all the review questions. Before you can select recipients, you'll need to create new questions.",
        "Det verkar som att du har raderat alla feedbackfr\xe5gor. Innan du kan v\xe4lja mottagare beh\xf6ver du skapa nya fr\xe5gor."
    ],
    "requested-from": [
        "Request sent to",
        "F\xf6rfr\xe5gan skickad till"
    ],
    "already-submitted": [
        "Already submitted",
        "Redan skickat"
    ],
    "already-submitted-message": [
        "You have already submitted feedback",
        "Du har redan skickat feedback"
    ],
    "thank-you-for-your-feedback": [
        "Thanks for taking your time!",
        "Tack f\xf6r att du tog dig tid!"
    ],
    "self-assessment-submission-ok": [
        "Great! We\u2019ll wait for the feedback to arrive and notify you once the state analysis is ready.",
        "Bra! Vi meddelar dig n\xe4r feedback har samlats in och \xe4r redo att analyseras."
    ],
    "self-assessment-sent": [
        "Self-assessment completed",
        "Sj\xe4lvskattning klar"
    ],
    "back-to-tasks": [
        "Back to Actions",
        "Tillbaka till Aktiviteter"
    ],
    "back-to-task": [
        "Back to Action",
        "Tillbaka till aktiviteten"
    ],
    "question": [
        "Question",
        "Fr\xe5ga"
    ],
    "created-at": [
        "Created",
        "Skapad"
    ],
    "respondents": [
        "Respondents",
        "Deltagare"
    ],
    "your-feedback": [
        "Received feedback",
        "Mottagen feedback"
    ],
    "feedback-vs-self-assessment": [
        "Feedback and self-assessment",
        "Feedback och sj\xe4lvskattning"
    ],
    "asking-for-feedback": [
        "Feedback for",
        "Feedback f\xf6r"
    ],
    "strongly-agree": [
        "Strongly agree",
        "H\xe5ller helt med"
    ],
    "agree": [
        "Somewhat agree",
        "H\xe5ller delvis med"
    ],
    "neutral": [
        "Neutral",
        "Neutral"
    ],
    "disagree": [
        "Somewhat disagree",
        "H\xe5ller inte med"
    ],
    "strongly-disagree": [
        "Strongly disagree",
        "H\xe5ller inte alls med"
    ],
    "selected": [
        "Selected",
        "Valda"
    ],
    "no-selected-recipients": [
        "No recipients selected",
        "Du har inte valt n\xe5gra mottagare"
    ],
    "no-available-recipients": [
        "No available recipients",
        "Inga tillg\xe4ngliga mottagare"
    ],
    "feedback-request-sent-description": [
        "Your feedback request is sent. Received feedback will appear on the Feedback page.",
        "Din feedbackf\xf6rfr\xe5gan har skickats. Mottagen feedback kommer synas p\xe5 Feedbacksidan."
    ],
    "edit-question": [
        "Edit question",
        "Redigera fr\xe5ga"
    ],
    "back-to": [
        "Back to {{page}}",
        "Tillbaka till {{page}}"
    ],
    "create-questions-alert": [
        "Create at least 3 feedback questions",
        "Skapa minst 3 feedbackfr\xe5gor"
    ],
    "create-questions": [
        "Create questions",
        "Skapa fr\xe5gor"
    ],
    "select-recipients": [
        "Select recipients",
        "V\xe4lj mottagare"
    ],
    "questions": [
        "Questions",
        "Fr\xe5gor"
    ],
    "recipients": [
        "Recipients",
        "Mottagare"
    ],
    "leave-question": [
        "Leave the request flow",
        "Vill du avbryta f\xf6rfr\xe5gan"
    ],
    "leave": [
        "Leave",
        "L\xe4mna"
    ],
    "stay": [
        "Stay",
        "Stanna"
    ],
    "delete-question": [
        "Delete question?",
        "Radera fr\xe5ga?"
    ],
    "back": [
        "Back",
        "Tillbaka"
    ],
    "feedback-create-success-text": [
        "You can start your self-assessment now or access it later from the Focus Area page.",
        "Du kan b\xf6rja din sj\xe4lvskattning nu eller komma \xe5t den senare fr\xe5n fokusomr\xe5dessidan."
    ],
    "feedback-create-success-text-task": [
        "As an optional step you can also go through self-assessment to compare it to feedback.",
        "Om du vill kan du g\xf6ra en sj\xe4lvskattning och j\xe4mf\xf6ra med feedback."
    ],
    "start-self-assessment": [
        "Start self-assessment",
        "P\xe5b\xf6rja sj\xe4lvskattning"
    ],
    "no-answer": [
        "Can\u2019t answer/evaluate",
        "Kan inte svara/utv\xe4rdera"
    ],
    "answer-options": [
        "Answer options",
        "Svarsalternativ"
    ],
    "proceed-with": [
        "Proceed with",
        "Forts\xe4tt med"
    ],
    "get-coaching-on-focus-area": [
        "Get coaching on the focus area",
        "F\xe5 coaching p\xe5 fokusomr\xe5det"
    ],
    "answers": [
        "Answers",
        "Svar"
    ],
    "not-answered": [
        "Can't answer/evaluate",
        "Kan inte svara/utv\xe4rdera"
    ],
    "loading-data": [
        "Loading data...",
        "Laddar data..."
    ],
    "get-started": [
        "Get started",
        "Kom ig\xe5ng"
    ],
    "not-included": [
        "Not included",
        "Ej inkluderat"
    ],
    "discuss-analysis-results": [
        "Get coaching on your analysis",
        "F\xe5 coaching p\xe5 din analys"
    ],
    "see-all-insights": [
        "Explore your feedback",
        "Utforska mer av din feedback"
    ],
    "help-me-analyze-feedback": [
        "Help me analyse the feedback and self-assessment results for this review question",
        "Hj\xe4lp mig analysera feedback och sj\xe4lvskattning f\xf6r denna fr\xe5ga"
    ],
    "complete-self-assessment": [
        "Complete self-assessment",
        "F\xe4rdigst\xe4ll sj\xe4lvskattning"
    ],
    "self-assessment-txt1": [
        "Self-assessment allows you to reflect on your own performance.",
        "Sj\xe4lvskattning l\xe5ter dig reflektera \xf6ver din egen prestation."
    ],
    "self-assessment-txt2": [
        "Be honest with yourself to get the most valuable insights. ",
        "Var \xe4rlig och objektiv n\xe4r du skattar dig sj\xe4lv."
    ],
    "self-assessment-txt3": [
        "Be honest with yourself to get the most valuable insights.",
        "Var \xe4rlig s\xe5 f\xe5r du mer v\xe4rdefulla insikter."
    ],
    "self-assessment-txt4": [
        "Once you\u2019re done, click Submit.",
        "N\xe4r du \xe4r klar klickar du Skicka."
    ],
    "start-analysis": [
        "Start analysis",
        "Starta analys"
    ],
    "start-analysis-intro": [
        "Get clear on your current state. Do a self-assessment and ask colleagues for feedback to uncover insights, reveal blind spots and gain clarity on your areas to grow.",
        "F\xe5 koll p\xe5 ditt nul\xe4ge. G\xf6r din sj\xe4lvskattning och be kollegor om feedback f\xf6r att f\xe5 insikter och nul\xe4get inom ditt utvecklingsomr\xe5de."
    ],
    "current-state": [
        "Current State",
        "Nul\xe4ge"
    ],
    "current-state-analysis": [
        "Current State analysis",
        "Analys av ditt nul\xe4ge"
    ],
    "understanding-your-scores": [
        "Understanding your scores",
        "F\xf6rst\xe5 ditt resultat"
    ],
    "average-of-your-answers": [
        "The reflection on how you see yourself.",
        "Reflektionen \xf6ver hur du ser p\xe5 dig sj\xe4lv."
    ],
    "average-feedback-colleagues": [
        "The average of how your colleagues perceive you.",
        "Genomsnittet av hur dina kollegor uppfattar dig."
    ],
    "difference-between-above": [
        "The difference between your colleagues views and yours. A smaller gap means your self-perception is aligned with others \u2013 a bigger one shows potential for awareness.",
        "Skillnaden mellan dina kollegors uppfattningar och din egen.Ett mindre gap betyder att din sj\xe4lvuppfattning st\xe4mmer \xf6verens med andras \u2013 ett st\xf6rre visar potential f\xf6r \xf6kad sj\xe4lvinsikt."
    ],
    "striped-areas-represents": [
        "The striped area represents your room for growth, up to the maximum score.",
        "Det streckade omr\xe5det visar ditt utrymme f\xf6r utveckling, upp till maximal po\xe4ng."
    ],
    "answer-score-correlation": [
        "Answer option and score",
        "Svarsalternativ och po\xe4ng"
    ],
    "focus-areas": [
        "Focus areas",
        "Fokusomr\xe5den"
    ],
    "tasks": [
        "Actions",
        "Aktiviteter"
    ],
    "discuss-this-result": [
        "Get coaching on your result",
        "F\xe5 coaching p\xe5 ditt resultat"
    ],
    "you": [
        "You",
        "Du"
    ],
    "why-no-answer": [
        "Why someone didn\u2019t answer",
        "Varf\xf6r n\xe5gon inte svarade"
    ],
    "why-no-answer-1": [
        "Limited contact or difficult to recall",
        "Begr\xe4nsad kontakt eller sv\xe5rt att minnas"
    ],
    "why-no-answer-2": [
        "Respondents have not worked closely with you or known you long enough to provide feedback. They cannot recall sufficient details or specific examples to answer.",
        "Respondenter har inte jobbat n\xe4ra dig eller k\xe4nt dig tillr\xe4ckligt l\xe4nge f\xf6r att kunna ge feedback. De minns inte tillr\xe4ckligt med detaljer eller specifika exempel f\xf6r att kunna svara."
    ],
    "why-no-answer-3": [
        "Unclear or irrelevant question",
        "Otydlig eller Irrelevant fr\xe5ga"
    ],
    "why-no-answer-4": [
        "The question was too difficult to understand, lacked sufficient context or was not relevant to the respondent\u2019s experience or relationship with you.",
        "Fr\xe5gan var f\xf6r sv\xe5r att f\xf6rst\xe5, saknade tillr\xe4cklig kontext eller var inte relevant f\xf6r respondentens erfarenhet eller relation till dig."
    ],
    "why-no-answer-5": [
        "Important to Note",
        "Observera"
    ],
    "why-no-answer-6": [
        "We\u2019re not including these answers into the score. However, if many respondents choose these options, it may indicate a need to select respondents who have had more interaction with you, know you better or rephrase questions to make them clearer and more relevant to the respondent.",
        "Vi inkluderar inte dessa svar i po\xe4ngen, men om m\xe5nga v\xe4ljer detta alternativ kan det betyda att du beh\xf6ver v\xe4lja respondenter som du har haft mer kontakt med, som k\xe4nner dig b\xe4ttre eller omformulera fr\xe5gor f\xf6r att g\xf6ra dem enklare att f\xf6rst\xe5 och mer relevanta f\xf6r respondenten."
    ],
    "no-feedback-yet": [
        "No feedback yet",
        "Ingen feedback \xe4n"
    ],
    "send-request-from-focus-area": [
        "Send a request from a Focus area to get started",
        "Skicka en f\xf6rfr\xe5gan fr\xe5n ett fokusomr\xe5de f\xf6r att komma ig\xe5ng"
    ],
    "send-request-from-task": [
        "Send a request from an action to get started",
        "Skicka en f\xf6rfr\xe5gan fr\xe5n en aktivitet f\xf6r att komma ig\xe5ng"
    ],
    "feedback-will-appear-focus-area": [
        "Feedback will appear here once the deadline passes or all recipients respond.",
        "Feedback kommer att visas h\xe4r s\xe5 snart deadline har passerats eller alla har svarat."
    ],
    "feedback-will-appear-task": [
        "Feedback will appear here once we receive the first response.",
        "Feedback kommer att visas h\xe4r s\xe5 snart vi f\xe5tt in det f\xf6rsta svaret."
    ],
    "go-to-focus-area": [
        "Go to Development plan",
        "G\xe5 till utvecklingsplanen"
    ],
    "go-to-tasks": [
        "Go to Actions",
        "G\xe5 till aktiviteter"
    ],
    "no-completed-tasks-yet": [
        "You have no completed actions yet!",
        "Du har inga f\xe4rdiga aktiviteter \xe4n!"
    ],
    "no-ongoing-tasks": [
        "You have no ongoing actions! Start working on a Focus area and let the AI coach create it for you.",
        "Du har inga p\xe5g\xe5ende aktiviteter! B\xf6rjar arbeta p\xe5 ett fokusomr\xe5de och l\xe5t AI-coachen skapa en aktivitet \xe5t dig."
    ],
    "request-created-at": [
        "Request created",
        "F\xf6rfr\xe5gan skapad"
    ],
    "discuss-analysis-result": [
        "I want to discuss my current state analysis result:",
        "Jag vill diskutera analysresultatet f\xf6r min nuvarande status:"
    ],
    "analysis-summary": [
        "Result analysis ",
        "Resultatanalys"
    ],
    "waiting-for-feedback": [
        "Waiting for feedback",
        "V\xe4ntar p\xe5 feedback"
    ],
    "waiting-for-feedback-and-self": [
        "Waiting for feedback and self-assessment",
        "V\xe4ntar p\xe5 feedback och sj\xe4lvskattning"
    ],
    "waiting-for-feedback-info": [
        "Complete your self-assessment to unlock your result.",
        "Fyll i din sj\xe4vskattning f\xf6r att l\xe5sa upp ditt resultat."
    ],
    "feedback-request": [
        "Feedback request",
        "Feedback-f\xf6rfr\xe5gan"
    ],
    "sent-on": [
        "Sent on",
        "Skickat"
    ],
    "to-analyse-steps": [
        "In order to analyse your current state, please go through the next steps:",
        "F\xf6r att analysera ditt nul\xe4ge, genomf\xf6r f\xf6ljande steg:"
    ],
    "see-feedback": [
        "See feedback",
        "Se feedback"
    ],
    "last-updated": [
        "Last updated",
        "Senast uppdaterad"
    ],
    "how-we-calculate-score": [
        "How we calculate the scores",
        "S\xe5 ber\xe4knar vi po\xe4ngen"
    ],
    "how-we-calculate-text": [
        "We calculate exact values but show rounded ones for simplicity. That\u2019s why you might sometimes notice a small difference from the exact subtraction.",
        "Vi ber\xe4knar exakta v\xe4rden men visar avrundade f\xf6r enkelhetens skull. D\xe4rf\xf6r kan du ibland m\xe4rka en liten skillnad fr\xe5n den exakta subtraktionen."
    ],
    "request-new-feedback": [
        "Request new feedback",
        "Be om ny feedback"
    ],
    "how-it-works": [
        "How it works",
        "Hur det fungerar"
    ],
    "exlude-recipient": [
        "Exclude recipient this time?",
        "Uteslut mottagare den h\xe4r g\xe5ngen?"
    ],
    "exclude-recipient-text": [
        "Please note that changing recipients may affect result comparability, as consistent feedback over time is key.",
        "Observera att \xe4ndring av mottagare kan p\xe5verka resultatj\xe4mf\xf6rbarheten, eftersom konsekvent feedback \xf6ver tid \xe4r nyckeln."
    ],
    "exclude": [
        "Exclude",
        "Uteslut"
    ],
    "remove-recipient-toaster": [
        "Feedback request sent",
        "Feedbackf\xf6rfr\xe5gan skickad"
    ],
    "continue-with-self-assessment": [
        "Complete self-assessment",
        "Slutf\xf6r sj\xe4lvbed\xf6mningen"
    ],
    "change-recipient": [
        "Change recipient",
        "\xc4ndra mottagare"
    ],
    "change-recipients-text": [
        "Please note that changing recipients may affect result comparability, as consistent feedback over time is key.",
        "Observera att \xe4ndring av mottagare kan p\xe5verka resultatj\xe4mf\xf6rbarheten, eftersom konsekvent feedback \xf6ver tid \xe4r nyckeln."
    ],
    "previous-feedback-failed-message": [
        "We couldn\u2019t collect enough responses before the deadline. Consider adjusting the question or recipient list and send a new request.",
        "Vi kunde inte samla in tillr\xe4ckligt m\xe5nga svar f\xf6re deadline. \xd6verv\xe4g att justera fr\xe5gan eller mottagarlistan och skicka en ny f\xf6rfr\xe5gan."
    ],
    "far-from": [
        "Far from",
        "L\xe5ngt ifr\xe5n"
    ],
    "close-to": [
        "Close to",
        "N\xe4ra"
    ],
    "define-goal-modal-h": [
        "How to define your goal",
        "Hur du definierar ditt m\xe5l"
    ],
    "define-goal": [
        "Define Goal",
        "Definiera m\xe5l"
    ],
    "define-goal-description": [
        "Your goal doesn\u2019t have to cover the entire focus area \u2013 define something specific you want to improve and start there.",
        "Ditt m\xe5l beh\xf6ver inte t\xe4cka hela fokusomr\xe5det \u2013 definera n\xe5got konkret du vill f\xf6rb\xe4ttra och b\xf6rja d\xe4r."
    ],
    "define-goal-description2": [
        "Write the goal on your own or get support from your AI coach.",
        "Skriv m\xe5let p\xe5 egen hand eller ta hj\xe4lp av din AI-coach."
    ],
    "goal-description-placeholder": [
        "Write your goal here...",
        "Skriv ditt m\xe5l h\xe4r..."
    ],
    "ai-input-placeholder": [
        "What can I help you with?",
        "Hur kan jag hj\xe4lpa dig?"
    ],
    "measure-success": [
        "Measure of success",
        "M\xe5l f\xf6r framg\xe5ng"
    ],
    "measure-success-description": [
        "Imagine you've reached your goal. Now set a self-assessment and feedback score that could reflect that success.",
        "F\xf6rest\xe4ll dig att du har n\xe5tt ditt m\xe5l. S\xe4tt sj\xe4lvskattning- och feedbackpo\xe4ng som kan spegla effekten av att ha n\xe5tt m\xe5let."
    ],
    "desired-score": [
        "Desired scores",
        "\xd6nskade po\xe4ng"
    ],
    "feedback": [
        "Feedback",
        "Feedback"
    ],
    "starting-point-description": [
        "Where do you see yourself today in relation to your Goal, from 1 to 10?",
        "Var ser du dig sj\xe4lv idag i f\xf6rh\xe5llande till ditt m\xe5l, p\xe5 en skala fr\xe5n 1 till 10?"
    ],
    "importance-level-description": [
        "How important is it to achieve your Goal, from 1 to 10?",
        "Hur viktigt \xe4r det f\xf6r dig att uppn\xe5 ditt m\xe5l, p\xe5 en skala fr\xe5n 1 till 10?"
    ],
    "not-important": [
        "Not important",
        "Inte viktigt"
    ],
    "very-important": [
        "Very important",
        "Mycket viktigt"
    ],
    "goal-summary": [
        "Goal summary",
        "M\xe5lsummering"
    ],
    "set-goal": [
        "Set goal",
        "S\xe4tt m\xe5l"
    ],
    "set-new-goal": [
        "Set new goal",
        "S\xe4tt nytt m\xe5l"
    ],
    "reset-goal": [
        "Reset goal",
        "\xc5terst\xe4ll m\xe5l"
    ],
    "reached-goal": [
        "You have reached this goal!",
        "Du har n\xe5tt detta m\xe5l!"
    ],
    "not-reached-goal": [
        "You did not reach this goal",
        "Du har inte n\xe5tt detta m\xe5l"
    ],
    "goal-set": [
        "Goal set",
        "Du har satt ett m\xe5l"
    ],
    "video-coach-nav-title": [
        "Video coaching",
        "Videocoaching"
    ],
    "my-coach": [
        "My coach",
        "Min coach"
    ],
    "book-more-meetings": [
        "Book more meetings",
        "Boka fler m\xf6ten"
    ],
    "cancel2": [
        "Cancel",
        "Avboka"
    ],
    "confirm": [
        "Confirm",
        "Bekr\xe4fta"
    ],
    "late-cancellation-heading": [
        "Late cancellation",
        "Sen avbokning"
    ],
    "confirm-cancellation-heading": [
        "Confirm cancellation",
        "Bekr\xe4fta avbokning"
    ],
    "meeting-with-coach-cancelled": [
        "Your meeting with {{coach}} is cancelled",
        "Ditt m\xf6te med {{coach}} har avbokats"
    ],
    "no-booked-meetings": [
        "You have no meetings booked with your coach. Get started and book one today.",
        "Du har inga m\xf6ten inbokade med din coach. Kom ig\xe5ng och boka ett redan idag."
    ],
    "you-have-had-all-meetings": [
        "You have had all your meetings.",
        "Du har haft alla dina m\xf6ten."
    ],
    "match-with-coach": [
        "Match with a coach",
        "Matcha med coach"
    ],
    "select-coach": [
        "Time for coaching! Get started now and choose your coach today.",
        "Dags f\xf6r coaching! Kom ig\xe5ng och v\xe4lj din coach idag."
    ],
    "late-cancellation-text": [
        "It is less than 24 hours before the meeting starts, which means that it cannot be rebooked and the meeting is lost. Do you still want to cancel?",
        "Det \xe4r mindre \xe4n 24 timmar kvar till m\xf6tet, vilket inneb\xe4r att det inte kan bokas om och m\xf6tet g\xe5r f\xf6rlorat. Vill du fortfarande avboka?"
    ],
    "preview-booking": [
        "Preview booking",
        "F\xf6rhandsgranska bokning"
    ],
    "select-datetime": [
        "Select date and time",
        "V\xe4lj datum och tid"
    ],
    "select-date-to-see-available-times": [
        "Select a date to see available times",
        "V\xe4lj ett datum f\xf6r att se tillg\xe4ngliga tider"
    ],
    "video-coaching-with": [
        "Video coaching with {{coach}}",
        "Videocoaching med {{coach}}"
    ],
    "book": [
        "Book",
        "Boka"
    ],
    "confirm-booking": [
        "Confirm booking",
        "Bekr\xe4fta bokning"
    ],
    "meeting-booked": [
        "Meeting booked",
        "M\xf6te bokat"
    ],
    "book-meeting-nav-title": [
        "Book meeting",
        "Boka m\xf6te"
    ],
    "close": [
        "Close",
        "St\xe4ng"
    ],
    "language_sv": [
        "Swedish",
        "Svenska"
    ],
    "language_en": [
        "English",
        "Engelska"
    ],
    "language_no": [
        "Norwegian",
        "Norska"
    ],
    "language_da": [
        "Danish",
        "Danska"
    ],
    "language_fr": [
        "French",
        "Franska"
    ],
    "language_de": [
        "German",
        "Tyska"
    ],
    "language_es": [
        "Spanish",
        "Spanska"
    ],
    "language_cs": [
        "Czech",
        "Tjeckiska"
    ],
    "language_nl": [
        "Dutch",
        "Holl\xe4ndska"
    ],
    "language_el": [
        "Greek",
        "Grekiska"
    ],
    "language_hu": [
        "Hungarian",
        "Ungerska"
    ],
    "language_pl": [
        "Polish",
        "Polska"
    ],
    "language_pt": [
        "Portuguese",
        "Portugisiska"
    ],
    "language_fi": [
        "Finnish",
        "Finska"
    ],
    "language_it": [
        "Italian",
        "Italienska"
    ],
    "language_lt": [
        "Lithuanian",
        "Litauiska"
    ],
    "leadership-levels": [
        "Leadership levels",
        "Ledarskapsniv\xe5er"
    ],
    "coaching-experience": [
        "To ensure the best coaching experience, your coach would appreciate learning more about you.",
        "F\xf6r att s\xe4kerst\xe4lla den b\xe4sta coachningsupplevelsen vill din coach g\xe4rna veta mer om dig."
    ],
    "title-role": [
        "Title/Role",
        "Titel/Roll"
    ],
    "title-placeholder": [
        "e.g. Project Manager, Team Lead",
        "t.ex. Projektledare, Teamledare"
    ],
    "select-leadership-level": [
        "Leadership level",
        "Ledarskapsniv\xe5"
    ],
    "no-experience": [
        "No, I have no experience",
        "Nej, jag har ingen erfarenhet"
    ],
    "little-experience": [
        "Yes, I have little experience",
        "Ja, jag har lite erfarenhet"
    ],
    "moderate-experience": [
        "Yes, I have moderate experience",
        "Ja, jag har m\xe5ttlig erfarenhet"
    ],
    "vast-experience": [
        "Yes, I have vast experience",
        "Ja, jag har stor erfarenhet"
    ],
    "coach-experience-title": [
        "Experience of being coached",
        "Erfarenhet av att bli coachad"
    ],
    "coach-experience-subtitle": [
        "Have you been coached before?",
        "Har du blivit coachad tidigare?"
    ],
    "select-coach-language": [
        "Select the languages you want to be coached in",
        "V\xe4lj spr\xe5k du vill bli coachad i"
    ],
    "native": [
        "Native",
        "Modersm\xe5l"
    ],
    "coachingAreas": [
        "Coaching areas",
        "Coachingomr\xe5den"
    ],
    "chooseCoachingAreas": [
        "Choose coaching areas you are interested in.",
        "V\xe4lj coachingomr\xe5den du \xe4r intresserad av."
    ],
    "leadership_and_team_development": [
        "Leadership and Team Development",
        "Ledarskap och teamutveckling"
    ],
    "organisational_and_business_coaching": [
        "Organisational and Business Coaching",
        "Organisatorisk och aff\xe4rscoaching"
    ],
    "personal_development": [
        "Personal Development",
        "Personlig utveckling"
    ],
    "career_and_professional_growth": [
        "Career and Professional Growth",
        "Karri\xe4r och professionell utveckling"
    ],
    "technology_and_innovation": [
        "Technology and Innovation",
        "Teknik och innovation"
    ],
    "finance_and_professional_services": [
        "Finance and Professional Services",
        "Finans och professionella tj\xe4nster"
    ],
    "industry_and_manufacture": [
        "Industry and Manufacture",
        "Industri och tillverkning"
    ],
    "consumer_goods_and_services": [
        "Consumer Goods and Services",
        "Konsumentvaror och tj\xe4nster"
    ],
    "tech_it": [
        "Tech and IT",
        "Teknik och IT"
    ],
    "telecommunications": [
        "Telecommunications",
        "Telekommunikation"
    ],
    "energy_environment": [
        "Energy and Environment",
        "Energi och milj\xf6"
    ],
    "finance_legal_insurance": [
        "Finance, Legal and Insurance",
        "Finans, juridik och f\xf6rs\xe4kring"
    ],
    "education_research": [
        "Education and Research",
        "Utbildning och forskning"
    ],
    "media_pr": [
        "Media and PR",
        "Media och PR"
    ],
    "healthcare_and_pharma": [
        "Healthcare and Pharmaceuticals",
        "H\xe4lso- och sjukv\xe5rd samt l\xe4kemedel"
    ],
    "government_public_services": [
        "Government and Public Services",
        "Stat och offentlig verksamhet"
    ],
    "manufacturing": [
        "Manufacturing",
        "Tillverkning"
    ],
    "construction_real_estate": [
        "Construction and Real Estate",
        "Bygg och fastigheter"
    ],
    "transport_logistics": [
        "Transport and Logistics",
        "Transport och logistik"
    ],
    "agriculture_food": [
        "Agriculture and Food",
        "Jordbruk och livsmedel"
    ],
    "culture_entertainment": [
        "Culture and Entertainment",
        "Kultur och underh\xe5llning"
    ],
    "tourism_hospitality": [
        "Tourism and Hospitality",
        "Turism och hotellverksamhet"
    ],
    "sports_fitness": [
        "Sports and Fitness",
        "Sport och friskv\xe5rd"
    ],
    "retail_ecommerce": [
        "Retail and E-commerce",
        "Detaljhandel och e-handel"
    ],
    "fashion": [
        "Fashion and Apparel",
        "Mode och kl\xe4der"
    ],
    "choose-coach": [
        "Choose coach",
        "V\xe4lj coach"
    ],
    "choose-coach-subheading": [
        "Based on your language preferences, interest in coaching areas, and professional background, we\u2019ve selected these coaches.",
        "Baserat p\xe5 dina spr\xe5kpreferenser, intresse f\xf6r coachingomr\xe5den och professionella bakgrund har vi valt ut dessa coacher."
    ],
    "view-profile": [
        "View profile",
        "Visa profil"
    ],
    "about-me": [
        "About me",
        "Om mig"
    ],
    "coaching-areas": [
        "Coaching areas",
        "Coachingomr\xe5den"
    ],
    "see-more": [
        "See more",
        "Se mer"
    ],
    "industries": [
        "Industries",
        "Industrier"
    ],
    "coach-industry-experience": [
        "Coach's industry experience",
        "Coachens branscherfarenhet"
    ],
    "choose-coach-industry-experience": [
        "If you're seeking a coach with experience in specific industries or who has coached others in those fields, make your selection here.",
        "Om du s\xf6ker en coach med erfarenhet inom specifika branscher, v\xe4lj omr\xe5den h\xe4r."
    ],
    "submit-for-matching": [
        "Submit for matching",
        "N\xe4sta steg - v\xe4lj coach"
    ],
    "philosophy": [
        "Philosophy",
        "Filosofi"
    ],
    "you-have-a-match": [
        "You have a match in",
        "Du har en matchning f\xf6r"
    ],
    "also-expertise": [
        "also brings expertise in",
        "har \xe4ven erfarenhet av"
    ],
    "additional": [
        "additional",
        "ytterligare"
    ],
    "matched": [
        "Matched",
        "Matchade"
    ],
    "your": [
        "Your",
        "Dina"
    ],
    "other": [
        "other",
        "andra"
    ],
    "coach_industries": [
        "industries",
        "brancher"
    ],
    "client_industries": [
        "industries",
        "brancher"
    ],
    "areas": [
        "areas",
        "omr\xe5den"
    ],
    "start-coaching-session": [
        "Start coaching session",
        "Starta coachsession"
    ],
    "coaching-session": [
        "Coaching session",
        "Coachsession"
    ],
    "evaluate-progress": [
        "Evaluate your progress",
        "Utv\xe4rdera din framsteg"
    ],
    "evaluate-progress-text": [
        "Send a new feedback request to see how your progress is perceived and what you can improve.",
        "Skicka en ny feedbackf\xf6rfr\xe5gan f\xf6r att se hur dina framsteg uppfattas och vad du kan f\xf6rb\xe4ttra."
    ],
    "copy-text": [
        "Copy text",
        "Kopiera text"
    ],
    "setting-desired-score-h": [
        "Set your desired scores",
        "Ange dina \xf6nskade po\xe4ng"
    ],
    "select-date": [
        "Select date",
        "V\xe4lj datum"
    ],
    "commit-to-goal": [
        "Commit to this goal",
        "Spara m\xe5ls\xe4ttning"
    ],
    "ai-suggestion": [
        "AI suggestion",
        "AI-f\xf6rslag"
    ],
    "my-account": [
        "My account",
        "Mitt konto"
    ],
    "saved-changes": [
        "Saved changes",
        "Sparade \xe4ndringar"
    ],
    "lang": [
        "en",
        "sv"
    ],
    "meeting-changed": [
        "The meeting has changed",
        "M\xf6tet har \xe4ndrats"
    ],
    "copy": [
        "Copy",
        "Copy"
    ],
    "start-coaching-goal": [
        "I want to start coaching in Focus Area {{focus_area}}. My goal is {{goal_description}}, target date is {{date}}.",
        "Jag vill starta coaching inom Fokusomr\xe5de {{focus_area}}. Mitt m\xe5l \xe4r {{goal_description}}, datum f\xf6r m\xe5let \xe4r {{date}}."
    ],
    "get-coaching-goal": [
        "Get coaching for your goal",
        "F\xe5 coaching f\xf6r ditt m\xe5l"
    ],
    "meeting-cancelled": [
        "The meeting has been cancelled",
        "M\xf6tet har avbokats"
    ],
    "choose": [
        "Choose",
        "V\xe4lj"
    ],
    "remove-as-favourite": [
        "Remove as favourite",
        "Ta bort som favorit"
    ],
    "add-as-favourite": [
        "Add as favourite",
        "L\xe4gg till som favorit"
    ],
    "set-target-date": [
        "Target date",
        "Slutdatum"
    ],
    "set-target-date-description": [
        "Choose a date to reach your goal",
        "S\xe4tt ett datum f\xf6r n\xe4r du ska ha n\xe5tt ditt m\xe5l."
    ],
    "checkin-success-heading": [
        "Awesome, keep going strong!",
        "H\xe4rligt jobbat!"
    ],
    "checkin-success-subheading": [
        "Since you made progress -  Send a new feedback request to see how your colleagues perceive your progress and gain valuable insights!",
        "D\xe5 du har gjort framsteg \u2013 skicka en ny feedbackf\xf6rfr\xe5gan f\xf6r att se hur dina kollegor uppfattar din utveckling och f\xe5 v\xe4rdefulla insikter!"
    ],
    "feedback-recipients-subtitle": [
        "Save frequent recipients as favorites for easy access in future requests.",
        "Spara mottagare som favoriter \u2013 s\xe5 hittar du dem snabbt n\xe4sta g\xe5ng"
    ],
    "action-completed": [
        "Action completed",
        "Uppgiften \xe4r klar"
    ],
    "reflect-on-action": [
        "Reflect on Action",
        "Reflektera \xf6ver uppgiften"
    ],
    "continue-with-action": [
        "Continue with Action",
        "Forts\xe4tt med uppgiften"
    ],
    "reflect": [
        "Reflect",
        "Reflektera"
    ],
    "checkin-success-heading2": [
        "Done!",
        "Klart!"
    ],
    "checkin-success-subheading2": [
        "If you\u2019re facing challenges \u2013 let\u2019s talk about strategies to overcome them in a coaching session.",
        "Om du har st\xf6tt p\xe5 utmaningar \u2013 Chatta med din AI coach om strategier f\xf6r att \xf6vervinna dom"
    ],
    "request-already-sent": [
        "Request already sent",
        "F\xf6rfr\xe5gan redan skickad"
    ],
    "got-it": [
        "Got it",
        "Jag f\xf6rst\xe5r"
    ],
    "followup-your-goal": [
        "Follow up your goal",
        "F\xf6lj upp ditt m\xe5l"
    ],
    "track-your-progress": [
        "Track your progress",
        "St\xe4m av din utveckling"
    ],
    "assess-process": [
        "Assess your process",
        "Skatta din process"
    ],
    "assess-process-description": [
        "On a scale 1-10, where a 10 is your reached goal. Where are you now in relation to your goal?",
        "P\xe5 en skala mellan 1-10, d\xe4r 10 \xe4r att du har n\xe5tt m\xe5let. Var st\xe5r du idag?"
    ],
    "process-reflection-h": [
        "Reflection on your process",
        "Reflektion kring din process"
    ],
    "process-reflection-description": [
        "Do you feel that you have developed in any way \u2013 for example, by gaining insights or knowledge, or by beginning new tasks?",
        "K\xe4nner du att du har utvecklats p\xe5 n\xe5got s\xe4tt \u2013 till exempel genom nya insikter, kunskaper eller att du b\xf6rjat med nya uppgifter?"
    ],
    "a-lot": [
        "Yes, a lot",
        "Ja, mycket"
    ],
    "a-little": [
        "Yes, a little",
        "Ja, lite"
    ],
    "not-yet": [
        "No, not yet",
        "Nej, inte \xe4n"
    ],
    "goal-reached-h": [
        "Did you reach your goal?",
        "Har du n\xe5tt ditt m\xe5l?"
    ],
    "goal-reached-description": [
        "On a scale 1-10, where a 10 is your reached goal. Where are you now in relation to your goal?",
        "P\xe5 en skala mellan 1-10, d\xe4r 10 \xe4r att du har n\xe5tt m\xe5let. Var st\xe5r du idag?"
    ],
    "effort-reflection-h": [
        "Reflection on your effort",
        "Reflektion kring din insats"
    ],
    "effort-reflection-description": [
        "How do you feel about the effort you have put in to working on this goal?",
        "K\xe4nde du att du var engagerad i din process?"
    ],
    "very-engaged": [
        "Very engaged",
        "Mycket engagerad"
    ],
    "balanced": [
        "Balanced",
        "Balanserad"
    ],
    "less-than-i-wanted": [
        "Less than I wanted",
        "Mindre \xe4n jag ville"
    ],
    "followup-success-heading": [
        "Well done",
        "H\xe4rligt jobbat!"
    ],
    "followup-success-subheading": [
        "You've successfully completed your goal.",
        "Du har n\xe5tt ditt m\xe5l."
    ],
    "followup-success-text": [
        "Send a new feedback request to see how your colleagues perceive your progress and gain valuable insights!",
        "Skicka en ny feedbackf\xf6rfr\xe5gan f\xf6r att se hur dina kollegor uppfattar din utveckling och f\xe5 v\xe4rdefulla insikter!"
    ],
    "followup-success-heading2": [
        "Progress Achieved",
        "H\xe4rligt med utveckling! "
    ],
    "followup-success-subheading2": [
        "Celebrate your progress and keep building momentum!",
        "Fira det du har \xe5stadkommit och forts\xe4tt jobba vidare med din utveckling!"
    ],
    "followup-success-text2": [
        " Send a new feedback request to see how your colleagues perceive your progress and gain valuable insights!",
        "Skicka en ny feedbackf\xf6rfr\xe5gan f\xf6r att se hur dina kollegor uppfattar din utveckling och f\xe5 v\xe4rdefulla insikter!"
    ],
    "followup-success-subheading3": [
        "Seems like you\u2019ve been facing challenges \u2013 let\u2019s talk about strategies to overcome them in a coaching session.",
        "Om du har st\xf6tt p\xe5 utmaningar \u2013 Chatta med din AI coach om strategier f\xf6r att \xf6vervinna dom"
    ],
    "previous-goals": [
        "Previous goals",
        "Tidigare m\xe5l"
    ],
    "done": [
        "Done",
        "Klart"
    ],
    "reached": [
        "Reached",
        "Uppn\xe5tt"
    ],
    "a-bit": [
        "Yes, a bit",
        "Ja, lite"
    ],
    "done-with-goal": [
        "You are done with this goal.",
        "Du \xe4r klar med det h\xe4r m\xe5let."
    ],
    "email-about-feedback": [
        "We\u2019ll email you when the results are ready, no later than {{date}}.",
        "Vi meddelar dig n\xe4r resultaten \xe4r klara, troligen senast {{date}}."
    ],
    "email-about-first-reply": [
        "We\u2019ll email you when the first reply comes in \u2014 and keep updating the result with new feedback until the deadline",
        "Vi skickar ett e-postmeddelande n\xe4r det f\xf6rsta svaret kommer in \u2013 och uppdaterar resultatet med ny feedback fram till deadline."
    ],
    "see-results": [
        "See results",
        "Se resultat"
    ],
    "follow-these-steps": [
        "Follow these steps",
        "F\xf6lj dessa steg f\xf6r att analysera ditt nul\xe4ge:"
    ],
    "review-summary": [
        "Review the summary and send the request.",
        "Granska sammanfattningen"
    ],
    "go-through-self-assessment": [
        "Go through self-assessment",
        "G\xe5 igenom sj\xe4lvskattningen"
    ],
    "review-questions": [
        "Review questions",
        "Granska fr\xe5gorna"
    ],
    "review-recipients": [
        "Review recipients",
        "Granska mottagarna"
    ],
    "change-questions-title": [
        "Change questions?",
        "\xc4ndra fr\xe5gor?"
    ],
    "change-questions-description": [
        "We recommend to keep the questions from the initial request unchanged to ensure consistency and comparability of results.",
        "Vi rekommenderar att du beh\xe5ller fr\xe5gorna fr\xe5n den ursprungliga f\xf6rfr\xe5gan of\xf6r\xe4ndrade f\xf6r att s\xe4kerst\xe4lla konsekvens och j\xe4mf\xf6rbarhet av resultaten."
    ],
    "change-recipients-title": [
        "Change recipients?",
        "\xc4ndra mottagare?"
    ],
    "change-recipients-description": [
        "We recommend to keep the recipients from the initial request unchanged to ensure consistency and comparability of results.",
        "Vi rekommenderar att du beh\xe5ller mottagarna fr\xe5n den ursprungliga f\xf6rfr\xe5gan of\xf6r\xe4ndrade f\xf6r att s\xe4kerst\xe4lla konsekvens och j\xe4mf\xf6rbarhet av resultaten."
    ],
    "not-enough-responses": [
        "Request unsuccessful",
        "F\xf6rfr\xe5gan misslyckades "
    ],
    "new-feedback-request-in-progress": [
        "New feedback request in progress",
        "Ny feedbackf\xf6rfr\xe5gan p\xe5g\xe5r"
    ],
    "see-details": [
        "See details",
        "Se detaljer"
    ],
    "new-feedback-in-progress": [
        "New feedback request in progress",
        "Ny feedbackf\xf6rfr\xe5gan p\xe5g\xe5r"
    ],
    "see-more-details": [
        "See more details",
        "Se fler detaljer"
    ],
    "pending": [
        "Pending",
        "V\xe4ntar"
    ],
    "result-created-at": [
        "Result created",
        "Resultat skapat"
    ],
    "no-result": [
        "No result",
        "Inga resultat"
    ],
    "very-disappointed": [
        "Very disappointed",
        "Mycket missn\xf6jd"
    ],
    "somewhat-disappointed": [
        "Somewhat disappointed",
        "N\xe5got missn\xf6jd"
    ],
    "not-disappointed": [
        "Not disappointed at all",
        "Inte missn\xf6jd alls"
    ],
    "submit-feedback": [
        "Submit feedback",
        "Skicka feedback"
    ],
    "task-edit": [
        "Edit Action",
        "\xc4ndra aktivitet"
    ],
    "request-sent": [
        "Request sent",
        "F\xf6rfr\xe5gan skickad"
    ],
    "go-to-summary": [
        "Go to summary",
        "G\xe5 till sammanfattning"
    ],
    "user-feedback-modal-header": [
        "We\u2019d love your feedback",
        "Vi v\xe4rdes\xe4tter din feedback"
    ],
    "keep-growing": [
        "Keep growing",
        "Forts\xe4tt utvecklas"
    ],
    "overview": [
        "Overview",
        "\xd6versikt"
    ],
    "goals": [
        "Goals",
        "M\xe5l"
    ],
    "actions": [
        "Actions",
        "Aktiviteter"
    ],
    "request-feedback-near-target-date": [
        "Request Feedback near your target date.",
        "Be om feedback n\xe4r du n\xe4rmar dig m\xe5ldagum."
    ],
    "result-overview": [
        "Result overview",
        "Resultat\xf6versikt"
    ],
    "thanks-for-your-response": [
        "Thanks for your response",
        "Tack f\xf6r ditt svar"
    ],
    "toolkit": [
        "Toolkit",
        "Verktygsl\xe5da"
    ],
    "success-plan": [
        "Success plan",
        "Min plan"
    ],
    "vision_statement": [
        "Goal",
        "M\xe5l"
    ],
    "sub-goal": [
        "Sub Goal",
        "Delm\xe5l"
    ],
    "sub-goals": [
        "Sub Goals",
        "Delm\xe5l"
    ],
    "behaviors-and-actions": [
        "Tasks",
        "Uppgifter"
    ],
    "activities": [
        "Activities",
        "Aktiviteter"
    ],
    "activity": [
        "Activity",
        "Aktivitet"
    ],
    "edit": [
        "Edit",
        "Redigera"
    ],
    "mark-as-complete": [
        "Mark as complete",
        "Markera som klar"
    ],
    "mark-as-incomplete": [
        "Mark as incomplete",
        "Markera som inte klar"
    ],
    "update-progress": [
        "Update progress",
        "Updatera status"
    ],
    "step": [
        "Step",
        "Steg"
    ],
    "of": [
        "of",
        "av"
    ],
    "continue-to-feedback-request": [
        "Continue to feedback request",
        "Forts\xe4tt till feedbackf\xf6rfr\xe5gan"
    ],
    "get-support-ai-assistant": [
        "Get support from the AI Assistant",
        "Ta hj\xe4lp av AI-assistenten"
    ],
    "create": [
        "Create",
        "Skapa"
    ],
    "do-it-later": [
        "I'll do it later",
        "Jag g\xf6r det senare"
    ],
    "ai-assistant": [
        "AI Assistant",
        "AI Assistent"
    ],
    "manual": [
        "Manual",
        "Manuell"
    ],
    "insights-report": [
        "Insights Report",
        "Insiktsrapport"
    ],
    "feedback-report": [
        "feedback report",
        "feedbackrapport"
    ],
    "see-full-result": [
        "See full result",
        "Se fullst\xe4ndigt resultat"
    ],
    "feedback-alignment": [
        "Feedback alignment",
        "Enighet i feedback"
    ],
    "strengths": [
        "Strengths",
        "Styrkor"
    ],
    "validated-strengths": [
        "Validated Strengths",
        "Validerade styrkor"
    ],
    "hidden-strengths": [
        "Hidden Strengths",
        "Dolda styrkor"
    ],
    "growth-priorities": [
        "Growth priorities",
        "Utvecklingsfokus"
    ],
    "blind-spots": [
        "Blind spots",
        "Blinda f\xe4lt"
    ],
    "all-questions": [
        "All questions",
        "Alla fr\xe5gor"
    ],
    "deadline-passed": [
        "The deadline has passed",
        "Deadline har passerat"
    ],
    "deadline-passed-message": [
        "This feedback request is now closed and we\u2019re no longer accepting responses. If you have any questions, please contact us at <a href='mailto:support@zebrain.se' style='color: #98AAF9; text-decoration: underline;'>support@zebrain.se</a>",
        "Den h\xe4r feedbackf\xf6rfr\xe5gan \xe4r nu st\xe4ngd och vi tar inte l\xe4ngre emot svar. Om du har n\xe5gra fr\xe5gor, v\xe4nligen kontakta oss p\xe5<a href='mailto:support@zebrain.se' style='color: #98AAF9; text-decoration: underline;'> support@zebrain.se"
    ],
    "report-info-model-title": [
        "Interpretation Guide",
        "S\xe5 tolkar du ditt resultat"
    ],
    "self-assessment-and-feedback-title": [
        "Self-assessment and Feedback",
        "Sj\xe4lvskattning och Feedback"
    ],
    "self-assessment-and-feedback-description": [
        "Shows how you see yourself and how others perceive you.",
        "Visar hur du och andra uppfattar dig."
    ],
    "self-assessment-and-feedback-excellent-note": [
        "A strong and consistent picture of you",
        "Stark och konsekvent uppfattning om dig"
    ],
    "self-assessment-and-feedback-high-note": [
        "A generally strong picture of you with minor areas to strengthen",
        "En generellt stark bild med mindre utvecklingsomr\xe5den"
    ],
    "self-assessment-and-feedback-moderate-note": [
        "A mixed picture of you showing potential for growth",
        "En blandad bild med tydlig utvecklingspotential"
    ],
    "self-assessment-and-feedback-low-note": [
        "In need of improvement",
        "En bild som just nu beh\xf6ver uppm\xe4rksamhet"
    ],
    "perception-gap-title": [
        "Perception gap",
        "Gap"
    ],
    "perception-gap-description-description": [
        "Shows the difference between how you see yourself and how others perceive you.",
        "Visar skillnaden mellan din sj\xe4lvbild och hur andra uppfattar dig."
    ],
    "perception-gap-description-healthy": [
        "Strong alignment between self-perception and others\u2019 perception",
        "Stark \xf6verensst\xe4mmelse mellan sj\xe4lvbild och andras uppfattning"
    ],
    "perception-gap-description-balanced": [
        "Some differences in perception",
        "Vissa skillnader i uppfattning"
    ],
    "perception-gap-description-moderate": [
        "Noticeable differences in perception",
        "Tydliga skillnader i uppfattning"
    ],
    "perception-gap-description-significan": [
        "Large differences in perception",
        "Stora skillnader i uppfattning"
    ],
    "feedback-alignment-title": [
        "Feedback alignment",
        "Enighet i feedback"
    ],
    "feedback-alignment-description": [
        "Shows how consistent the feedback from others is.",
        "Visar hur samst\xe4mmig feedbacken fr\xe5n andra \xe4r."
    ],
    "feedback-alignment-healthy": [
        "Clear feedback alignment among respondents",
        "H\xf6g samst\xe4mmighet i feedbacken"
    ],
    "feedback-alignment-balanced": [
        "Mostly consistent feedback with some variation",
        "\xd6verlag samst\xe4mmig feedback med viss variation"
    ],
    "feedback-alignment-moderate": [
        "Noticeable variation across responses",
        "Tydlig variation i feedbacken"
    ],
    "feedback-alignment-low": [
        "High variation in feedback",
        "Stor variation i feedbacken"
    ],
    "focus-area-health-title": [
        "Area health",
        "Status f\xf6r omr\xe5den"
    ],
    "focus-area-health-description": [
        " Shows the overall strength and balance of a focus area, based on feedback, differences in perception, agreement in feedback, and how consistent the perceptions are",
        "Visar styrka och balans i ett omr\xe5de, baserat p\xe5 feedback, skillnader i uppfattning, enighet i feedback och hur konsekventa uppfattningarna \xe4r."
    ],
    "focus-area-health-excellent": [
        "A strong area with aligned and consistent perceptions.",
        "Ett starkt omr\xe5de med samst\xe4mmiga och konsekventa uppfattningar."
    ],
    "focus-area-health-good": [
        "A generally strong area with some variation in perceptions.",
        "Ett generellt starkt omr\xe5de med viss variation i uppfattning."
    ],
    "focus-area-health-moderate": [
        "Mixed perceptions that would benefit from focused attention.",
        "Blandade uppfattningar som kan st\xe4rkas genom \xf6kat fokus."
    ],
    "focus-area-health-poor": [
        "An area where perceptions indicate a clear need to prioritise development.",
        "Ett omr\xe5de d\xe4r uppfattningarna visar ett tydligt behov av att prioritera utveckling."
    ],
    "assessment-question-interpretation-title": [
        "Assessment question interpretation",
        "Tolkning av bed\xf6mningsfr\xe5gor"
    ],
    "assessment-question-interpretation-description": [
        " Shows what differences between your self-assessment and others\u2019 feedback reveal about how you are perceived",
        " Visar vad skillnaden mellan din sj\xe4lvskattning och andras feedback s\xe4ger om hur du uppfattas."
    ],
    "assessment-question-interpretation-validated-strength": [
        " A shared positive perception between you and others",
        "Ett omr\xe5de d\xe4r du och andra har en gemensamt positiv uppfattning om dig"
    ],
    "assessment-question-interpretation-hidden-strength": [
        " Others perceive this more positively than you do yourself",
        "Andra har en mer positiv uppfattning om dig \xe4n vad du sj\xe4lv har"
    ],
    "assessment-question-interpretation-blind-spot": [
        "  You perceive this more positively than others do",
        "Du har en mer positiv uppfattning om dig sj\xe4lv \xe4n vad andra har"
    ],
    "assessment-question-interpretation-growth-priority": [
        "A shared perception that development is needed",
        "Ett omr\xe5de d\xe4r b\xe5de du och andra ser behov av utveckling"
    ],
    "excellent": [
        "Excellent",
        "Utm\xe4rkt"
    ],
    "high": [
        "High",
        "H\xf6g"
    ],
    "moderate": [
        "Moderate",
        "M\xe5ttlig"
    ],
    "low": [
        "Low",
        "L\xe5g"
    ],
    "significant": [
        "Significant",
        "Betydande"
    ],
    "balanced-badge": [
        "Balanced",
        "Balanserad"
    ],
    "healthy": [
        "Healthy",
        "Sund"
    ],
    "validated-strength-badge": [
        "Validated strength",
        "Validerad styrka"
    ],
    "hidden-strength": [
        "Hidden strength",
        "Dold styrka"
    ],
    "blind-spot": [
        "Blind spot",
        "Blinda f\xe4lt"
    ],
    "growth-priority": [
        "Growth priority",
        "Utvecklingsfokus"
    ],
    "btn-create-new": [
        "Create new",
        "Skapa nytt"
    ],
    "tutorial-header": [
        "Get started with",
        "Kom ig\xe5ng med"
    ],
    "tutorial-header-steps": [
        "quick steps!",
        "snabba!"
    ],
    "modelA-title": [
        "Start with self-assessment and feedback",
        "B\xf6rja med sj\xe4lvskattning och feedback"
    ],
    "modelA-description": [
        "They become the foundation for your growth and drive the rest of your journey.",
        "Detta blir grunden f\xf6r din utveckling och driver resten av processen."
    ],
    "modelB-title": [
        "Select your coach",
        "V\xe4lj din coach"
    ],
    "modelB-description": [
        "We match you with certified coaches who fit your goals and needs.",
        "Vi matchar dig med certifierade coacher som passar just dig och dina behov."
    ],
    "modelC-title": [
        "Deepen your self-awareness",
        "F\xf6rdjupa din sj\xe4lvinsikt"
    ],
    "modelC-description": [
        "All real development begins with self-awareness. Take our tests and gain valuable insights about who you are \u2014 and build a deeper understanding of yourself.",
        "All verklig utveckling b\xf6rjar med sj\xe4lvinsikt. Ta v\xe5ra tester och f\xe5 v\xe4rdefulla insikter om vem du \xe4r \u2014 och utveckla en djupare f\xf6rst\xe5else f\xf6r dig sj\xe4lv."
    ],
    "modelD-title": [
        "Create a goal",
        "Skapa din f\xf6rsta m\xe5lbild"
    ],
    "modelD1-description": [
        "Once your feedback is ready, it\u2019s time to create your first Goal: it should clarify what you want to develop and set the direction for your journey in Zebrain.",
        "N\xe4r din feedback \xe4r sammanst\xe4lld kan du skapa din f\xf6rsta m\xe5lbild: den ska beskriva vad du vill utveckla och blir grunden f\xf6r allt ditt arbete i Zebrain. "
    ],
    "modelD2-description": [
        "A Goal describes what you want to develop and sets the direction for your journey in Zebrain.",
        "En m\xe5lbild beskriver vad du vill utveckla och \xe4r grunden f\xf6r allt ditt arbete i Zebrain. "
    ],
    "modelD-description-extented": [
        "Bring together sub-goals, actions, tasks, and feedback \u2014 and follow your growth over time.",
        "H\xe4r samlar du \xe4ven delm\xe5l, aktiviteter, beteenden och feedback \u2013 och f\xf6ljer din utveckling \xf6ver tid."
    ],
    "modelE-title": [
        "Your AI assistant \u2014 always available",
        "Din AI-assistent \u2013 alltid tillg\xe4nglig"
    ],
    "modelE-description": [
        "Use it for analysis, writing texts, brainstorming or problem-solving.",
        "Anv\xe4nd den f\xf6r textarbete, probleml\xf6sning och konkreta tips."
    ],
    "modelE-description-extended": [
        "Choose Coaching style for guided insights (voice mode recommended),  and Neutral style for fast, practical support.",
        "V\xe4lj Coaching-l\xe4ge f\xf6r reflektion (r\xf6stfunktionen rekommenderas), Neutralt l\xe4ge \u2014 f\xf6r snabbt och praktiskt st\xf6d i vardagen.\xa0"
    ],
    "assessments": [
        "Assessments",
        "M\xe4tningar"
    ],
    "no-comment-text": [
        "No comments received for this question",
        "Inga kommentarer mottagna f\xf6r denna fr\xe5ga"
    ],
    "update-your-progress-to move-forward": [
        "update your progress to move forward.",
        "hur l\xe5ngt har du kommit? Uppdatera din status och forts\xe4tt fram\xe5t."
    ],
    "mark-as-completed-to-move-forward": [
        "mark as completed to move forward.",
        "markera som klar f\xf6r att g\xe5 vidare."
    ],
    "btn-show-more": [
        "Show more",
        "Visa fler"
    ],
    "btn-show-less": [
        "Show less",
        "Visa f\xe4rre"
    ],
    "long-term-goals": [
        "Goal plan",
        "Mina m\xe5l"
    ],
    "view-your-insights-report": [
        "View your insights report",
        "Kolla din insiktsrapport"
    ],
    "self-assessment-complete": [
        "Self-assessment complete",
        "Sj\xe4lvskattning klar"
    ],
    "restart": [
        "Restart",
        "B\xf6rja om"
    ],
    "behavior": [
        "Behavior",
        "Beteende"
    ],
    "barrier": [
        "Barrier",
        "Hinder"
    ],
    "barriers": [
        "Barriers",
        "Hinder"
    ],
    "if_when": [
        "If/When",
        "Om/N\xe4r"
    ],
    "if_then": [
        "Then",
        "D\xe5"
    ],
    "follow-up": [
        "Follow-up",
        "F\xf6lj upp"
    ],
    "get-feedback": [
        "Get feedback",
        "Starta uppf\xf6ljning"
    ],
    "create-behavior": [
        "Create behaviour",
        "Skapa beteende"
    ],
    "quick-pulse": [
        "Quick pulse",
        "Snabb puls"
    ],
    "set-due-date": [
        "Set due date",
        "V\xe4lj slutdatum"
    ],
    "practice-behavior-for": [
        "Practice behavior for",
        "\xd6va beteende i"
    ],
    "save-activity": [
        "Save Activity",
        "Spara aktivitet"
    ],
    "save-subgoal": [
        "Save Sub-goal",
        "Spara delm\xe5l"
    ],
    "save-behavior": [
        "Save Behavior",
        "Spara beteende"
    ],
    "save-longtermgoal": [
        "Save Goal",
        "Spara m\xe5lbild"
    ],
    "feedback-model-info": [
        "Feedback",
        "Feedback"
    ],
    "long-term Goal": [
        "Goal",
        "M\xe5lbild"
    ],
    "surveyIntro": [
        "These questions are based on your goal and will be used for both your self-assessment and feedback request. Adjust them if necessary before you begin.",
        "Dessa fr\xe5gor baseras p\xe5 din slutf\xf6rda m\xe5lbild och kommer att anv\xe4ndas f\xf6r b\xe5de din sj\xe4lvskattning och din feedback-f\xf6rfr\xe5gan. Justera dem om det beh\xf6vs innan du b\xf6rjar."
    ],
    "btn-edit-questions": [
        "Edit questions",
        "Redigera fr\xe5gor"
    ],
    "btn-questions-details": [
        "{{item_type}} details",
        "{{item_type}} detaljer"
    ],
    "improve-with-AI": [
        "Improve with AI",
        "F\xf6rb\xe4ttra med AI"
    ],
    "rephrase": [
        "Rephrase",
        "Omformulera"
    ],
    "shorten": [
        "Shorten",
        "F\xf6rkorta"
    ],
    "make-more-specific": [
        "Make more specific",
        "G\xf6r mer specifik"
    ],
    "describe-desired-changes": [
        "Describe your desired changes",
        "Beskriv vilka \xe4ndringar du \xf6nskar"
    ],
    "self-assessment-recipient-info1": [
        "Aim for a balanced group to ensure well-rounded feedback.",
        "Str\xe4va efter en balanserad grupp f\xf6r att s\xe4kerst\xe4lla allsidig feedback."
    ],
    "self-assessment-recipient-info2": [
        "Please keep in mind that we\u2019ll be accepting submissions for 7 days, so try to make sure the selected recipients are available.",
        "T\xe4nk p\xe5 att vi tar emot bidrag under sju dagar, s\xe5 f\xf6rs\xf6k s\xe4kerst\xe4lla att de utvalda mottagarna \xe4r tillg\xe4ngliga."
    ],
    "long-term-goal-details": [
        "Goal details",
        "Detaljer om m\xe5lbild"
    ],
    "profile": [
        "Profile",
        "Profil"
    ],
    "personality-test": [
        "Personality test",
        "Personlighetstest"
    ],
    "stress-test": [
        "Stress test",
        "Stresstest"
    ],
    "timeline": [
        "Timeline",
        "Tidsplan"
    ]
};
var $cd7f401ba602b868$var$english = {};
var $cd7f401ba602b868$var$swedish = {};
for(var $cd7f401ba602b868$var$k in $cd7f401ba602b868$var$langMap){
    $cd7f401ba602b868$var$english[$cd7f401ba602b868$var$k] = $cd7f401ba602b868$var$langMap[$cd7f401ba602b868$var$k][0];
    $cd7f401ba602b868$var$swedish[$cd7f401ba602b868$var$k] = $cd7f401ba602b868$var$langMap[$cd7f401ba602b868$var$k][1];
}
var $cd7f401ba602b868$var$resources = {
    en: {
        translation: $cd7f401ba602b868$var$english
    },
    sv: {
        translation: $cd7f401ba602b868$var$swedish
    }
};
var $cd7f401ba602b868$var$selectedLng = localStorage.getItem('language') === 'sv' ? 'sv' : 'en';
(0, $aTwoM.default).use((0, $8ed410366b740601$export$ae7e14d40d89f296)).init({
    resources: $cd7f401ba602b868$var$resources,
    lng: $cd7f401ba602b868$var$selectedLng,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    },
    debug: false
}).then(function() {
    return console.log('i18n initialized to ' + $cd7f401ba602b868$var$selectedLng);
}); // export default i18n;



var $85677435bcf2a0ff$var$SupportModal = function(props) {
    var isOpen = props.isOpen, onClose = props.onClose;
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title1",
                    children: t('support-modal-success-title')
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    children: t('support-modal-success-description')
                })
            })
        ]
    });
};
var $85677435bcf2a0ff$export$2e2bcd8739ae039 = $85677435bcf2a0ff$var$SupportModal;


var $555e70241d491a8e$export$2e2bcd8739ae039 = (0, $85677435bcf2a0ff$export$2e2bcd8739ae039);




function $ed48846c0d41552d$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(''), 2), description = _useState[0], setDescription = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(''), 2), errorMessage = _useState2[0], setErrorMessage = _useState2[1];
    var _React_useState = (0, $6iP9u._)((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).useState(false), 2), isModalOpen = _React_useState[0], setIsModalOpen = _React_useState[1];
    var onCloseModal = function() {
        setIsModalOpen(false);
    };
    var sendSupportTicket = function() {
        if (!description) {
            setErrorMessage(t('support-error-message'));
            return;
        }
        setIsLoading(true);
        setErrorMessage('');
        setIsModalOpen(true);
        var data = {
            description: description
        };
        api.post('client/support_ticket', data).then(function(response) {
            setDescription('');
            setIsModalOpen(true);
            setIsLoading(false);
        }).catch(function(error) {
            return console.log(error);
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "z-heading1 text-white  my-4 desktop:my-6",
                children: lang === 'sv' ? "Hur kan vi hj\xe4lpa dig?" : 'How can we assist you?'
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-2 text-gray-400",
                children: lang === 'sv' ? "Beskriv vad du vill ha hj\xe4lp med s\xe5 \xe5terkommer vi s\xe5 snart vi kan." : 'Let us know what you need help with, and we\'ll get back to you as soon as possible.'
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 gap-2 flex flex-col p-1",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "p-3 mb-4  h-40 items-center bg-indigo-1000 rounded-md ring-1 ring-indigo-700 focus-within:ring-2 focus-within:ring-primary-500",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                            id: "description",
                            placeholder: lang === 'sv' ? "Skriv h\xe4r..." : 'Describe your issue here...',
                            className: "w-full h-full flex-1 bg-indigo-1000 text-white px-4 py-3 rounded-md resize-none max-h-40 border-none focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none",
                            style: {
                                whiteSpace: 'normal'
                            },
                            value: description,
                            onChange: function(e) {
                                return setDescription(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        onClick: sendSupportTicket,
                        className: "w-full",
                        disabled: !description && isLoading,
                        children: isLoading ? t('support-sending') : t('send')
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $555e70241d491a8e$export$2e2bcd8739ae039), {
                        isOpen: isModalOpen,
                        onClose: onCloseModal
                    }),
                    errorMessage && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mt-4 text-red-500",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                        className: "mt-4 text-white",
                        children: [
                            t('support-email-info'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "text-gray-400",
                        children: "support@zebrain.se"
                    })
                ]
            })
        ]
    });
}


var $8ca062ea83b71f69$export$2e2bcd8739ae039 = (0, $ed48846c0d41552d$export$2e2bcd8739ae039);



parcelRequire("5s1kH");

var $60145039e84ee40d$var$AboutPage = function() {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    // 
    var swedishText1 = "N\xe5 din fulla ledarskapspotential med Zebrains AI-f\xf6rst\xe4rkta plattform f\xf6r ledarskapsutveckling, specifikt utformad f\xf6r individuell utveckling och kontinuerligt l\xe4rande.";
    var swedishText2 = "Personliga utvecklingsplaner s\xe4kerst\xe4ller att din utvecklingsresa blir effektiv och relevant. AI-coachen hj\xe4lper dig att omvandla dina m\xe5l till konkreta steg, st\xe4rka dina f\xf6rm\xe5gor och st\xf6tta h\xe5llbara beteendef\xf6rflyttningar.";
    var swedishText3 = "Efterfr\xe5ga och f\xe5 snabb, relevant feedback fr\xe5n ditt team och andra nyckelpersoner f\xf6r att st\xf6tta ditt fokus och hj\xe4lpa dig att n\xe5 dina m\xe5l snabbare.";
    var swedishText4 = "F\xf6r\xe4dla din ledarskapsutveckling med Zebrain.";
    var englishText1 = "Unlock your full leadership potential with Zebrain\u2019s AI-enhanced leadership development platform, designed for individual and continuous growth.";
    var englishText2 = "Tailored development plans ensure that your growth is personalized and effective, while the AI coach facilitates your development by turning your goals into actionable steps, strenghten abilities and sustainable behavior shifts.";
    var englishText3 = "Ask for and receive rapid, relevant feedback from your team and stakeholders to stay on track and achieve your goals faster.";
    var englishText4 = "Empower your leadership journey with Zebrain.";
    var paragraph1 = i18n.language === 'sv' ? swedishText1 : englishText1;
    var paragraph2 = i18n.language === 'sv' ? swedishText2 : englishText2;
    var paragraph3 = i18n.language === 'sv' ? swedishText3 : englishText3;
    var paragraph4 = i18n.language === 'sv' ? swedishText4 : englishText4;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "z-heading1 text-white  my-4 desktop:my-6",
                children: t('about-nav-title')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "text-base text-gray-400",
                        children: paragraph1
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "text-base text-gray-400",
                        children: paragraph2
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "text-base text-gray-400",
                        children: paragraph3
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "text-base text-gray-400",
                        children: paragraph4
                    })
                ]
            })
        ]
    });
};
var $60145039e84ee40d$export$2e2bcd8739ae039 = $60145039e84ee40d$var$AboutPage;


var $c30a96161c3cb068$export$2e2bcd8739ae039 = (0, $60145039e84ee40d$export$2e2bcd8739ae039);




var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");


var $bHX26 = parcelRequire("bHX26");

// Card.tsx

parcelRequire("5s1kH");
var $c9f7bf3282a3b2ff$var$CustomCard = function(param) {
    var children = param.children, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, onClick = param.onClick;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "flex flex-col bg-indigo-900 rounded-md border border-transparent ".concat(className),
        onClick: onClick,
        children: children
    });
};
var $c9f7bf3282a3b2ff$export$2e2bcd8739ae039 = $c9f7bf3282a3b2ff$var$CustomCard;


// CardBody.tsx

parcelRequire("5s1kH");
var $8760f6ffafbd7fe2$var$CardBody = function(param) {
    var children = param.children, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "overflow-hidden ".concat(className),
        children: children
    });
};
var $8760f6ffafbd7fe2$export$2e2bcd8739ae039 = $8760f6ffafbd7fe2$var$CardBody;


var $8b128e0855661626$export$2e2bcd8739ae039 = (0, $8760f6ffafbd7fe2$export$2e2bcd8739ae039);


// CardFooter.tsx

parcelRequire("5s1kH");
var $e8ab58186d3b82b8$var$CardFooter = function(param) {
    var children = param.children, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "border-indigo-700 border-t rounded-b-md p-4 ".concat(className),
        children: children
    });
};
var $e8ab58186d3b82b8$export$2e2bcd8739ae039 = $e8ab58186d3b82b8$var$CardFooter;


var $e463b23594a69ac8$export$2e2bcd8739ae039 = (0, $e8ab58186d3b82b8$export$2e2bcd8739ae039);


// CardHeader.tsx

parcelRequire("5s1kH");
var $de22706e3efe938c$var$CardHeader = function(param) {
    var children = param.children, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "border-indigo-700 border-b rounded-t-md py-3 px-4 ".concat(className),
        children: children
    });
};
var $de22706e3efe938c$export$2e2bcd8739ae039 = $de22706e3efe938c$var$CardHeader;


var $5bb3d310f179d16e$export$2e2bcd8739ae039 = (0, $de22706e3efe938c$export$2e2bcd8739ae039);


// FeedbackCard.tsx

parcelRequire("5s1kH");




var $87494a93ce0fe4fc$var$FeedbackCard = function(param) {
    var title = param.title, items = param.items, leftIcon = param.leftIcon, icon = param.icon;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b24dfdb78af8fe9f$export$2e2bcd8739ae039), {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $5bb3d310f179d16e$export$2e2bcd8739ae039), {
                className: "flex items-center px-4 py-3 bg-indigo-800 rounded-t-md",
                children: [
                    leftIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: leftIcon,
                        alt: "icon",
                        className: "w-6 h-6 mr-1.5"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h3", {
                        className: "text-base font-medium text-white",
                        children: title
                    }),
                    icon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "flex flex-col flex-grow items-end gap-2",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: icon,
                            alt: "icon"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8b128e0855661626$export$2e2bcd8739ae039), {
                className: "p-0 bg-indigo-900 rounded-b-md",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("ul", {
                    className: "flex flex-col divide-y divide-indigo-700 ",
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("li", {
                            className: "flex ",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("button", {
                                type: "button",
                                onClick: item.onClick,
                                className: "flex items-center justify-between w-full p-4 text-base font-normal text-white bg-indigo-900",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            item.icon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: item.icon,
                                                alt: "",
                                                className: "w-6 h-6 pr-2"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                children: item.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, {}),
                                        alt: "chevron right",
                                        className: "w-4 h-4"
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            })
        ]
    });
};
var $87494a93ce0fe4fc$export$2e2bcd8739ae039 = $87494a93ce0fe4fc$var$FeedbackCard;


var $b130efedc35fd9bb$export$2e2bcd8739ae039 = (0, $87494a93ce0fe4fc$export$2e2bcd8739ae039);


var $b24dfdb78af8fe9f$export$2e2bcd8739ae039 = (0, $c9f7bf3282a3b2ff$export$2e2bcd8739ae039);




var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");



var $749d65ec77f6e156$exports = {};
$749d65ec77f6e156$exports = $parcel$resolve("36XmB");




var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");




var $a72c3766ce7dfa42$exports = {};
$a72c3766ce7dfa42$exports = $parcel$resolve("7ph86");



var $f358e43dc3fae1cf$exports = {};
$f358e43dc3fae1cf$exports = $parcel$resolve("jPIgN");




function $4bf2b0595575af5a$export$68c1f516bbed5123(meetingId, token, who) {
    var userName = window.localStorage[(0, $632c75b97b900307$export$1630b5343357e8b5).USERNAME_TOKEN];
    var name = userName.split(' ')[0];
    var url = (0, $632c75b97b900307$export$1630b5343357e8b5).MEETING_HOST + "?name=" + name + "&who=" + who + "&back=" + window.location.href;
    var meetingType = meetingId.startsWith("team_") ? "team" : "coaching";
    url += "&meetingKey=" + meetingId;
    url += "&meetingType=" + meetingType;
    url += "&userId=" + window.localStorage[(0, $632c75b97b900307$export$1630b5343357e8b5).PERSON_TOKEN];
    url += "&token=" + token;
    window.location.href = url;
}


var $f11e5f8e19ffb75f$var$ListComponent = function(param) {
    var meetingData = param.meetingData, isPreviousMeetings = param.isPreviousMeetings, onCancellation = param.onCancellation, _param_animate = param.animate, animate = _param_animate === void 0 ? false : _param_animate;
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var t = (0, $341d5702266247e0$export$9fc83ad70ead8663)().t;
    var navigate = (0, $bHX26.useNavigate)();
    var lang = t("lang");
    // Ref to access the list element
    var listRef = (0, $5s1kH.useRef)(null);
    // State to store the dynamic max-height
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), maxHeight = _useState[0], setMaxHeight = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), showLateChange = _useState1[0], setShowLateChange = _useState1[1];
    (0, $5s1kH.useEffect)(function() {
        if (listRef.current) // Update maxHeight whenever meetingData changes
        setMaxHeight(listRef.current.scrollHeight);
    }, [
        meetingData
    ]);
    var onChangeMeeting = function(meeting) {
        var secondsToStart = (meeting.startDate.getTime() - new Date().getTime()) / 1000;
        if (secondsToStart < 86400) setShowLateChange(meeting);
        else navigate("/videocoach/book-meeting?meeting_id=".concat(meeting.id));
    };
    var goToMeeting = function(meetingId) {
        if (api.apiToken) (0, $4bf2b0595575af5a$export$68c1f516bbed5123)(meetingId, api.apiToken, "client");
        else alert("Error - missing api token");
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: " ".concat(animate ? "transition-[max-height] duration-500" : ""),
                style: {
                    maxHeight: "".concat(maxHeight, "px")
                },
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("ul", {
                    ref: listRef,
                    className: "w-full flex flex-col",
                    children: meetingData.map(function(meeting, index) {
                        var popItems;
                        if (isPreviousMeetings) popItems = [
                            {
                                title: t("to-meeting"),
                                click: function() {
                                    return goToMeeting(meeting.id);
                                }
                            }
                        ];
                        else popItems = [
                            {
                                title: t("to-meeting"),
                                click: function() {
                                    return goToMeeting(meeting.id);
                                }
                            },
                            {
                                title: t("change-meeting"),
                                click: function() {
                                    return onChangeMeeting(meeting);
                                }
                            },
                            {
                                title: t("cancel-meeting"),
                                click: function() {
                                    return onCancellation(meeting);
                                }
                            }
                        ];
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("li", {
                            className: "flex items-center justify-between z-title3 text-white bg-transparent",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                            alt: "calendar icon",
                                            className: "w-6 h-6"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                            className: "ml-2 truncate w-14",
                                            children: (0, $7d185b5883a21821$export$ff9a5f6f7fb9966b)(meeting.startDate, lang, false)
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a72c3766ce7dfa42$exports))),
                                            alt: "clock icon",
                                            className: "ml-2 w-6 h-6"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                            className: "ml-2",
                                            children: (0, $7d185b5883a21821$export$5f885a9374f8e024)(meeting.startDate)
                                        }),
                                        "\u2013",
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                            children: (0, $7d185b5883a21821$export$5f885a9374f8e024)((0, $7d185b5883a21821$export$2287e3d29250119e)(meeting.startDate, meeting.length))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                                    items: popItems
                                })
                            ]
                        }, index);
                    })
                })
            }),
            showLateChange && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: true,
                onClose: function() {
                    return setShowLateChange(null);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                        onClose: function() {
                            return setShowLateChange(null);
                        },
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-title1",
                            children: lang === "sv" ? "Sen \xe4ndring" : "Late cancellation"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex flex-col justify-between ",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "flex flex-row justify-center",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                                        alt: "Cancel meeting",
                                        className: "w-12 h-12 mt-3"
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "mt-6",
                                    children: lang === "sv" ? "D\xe5 det \xe4r mindre \xe4n 24 timmar kvar till m\xf6tet s\xe5 g\xe5r det tyv\xe4rr inte att g\xf6ra n\xe5gra \xe4ndringar." : "As it is less than 24 hours before the meeting starts, you can't do any changes."
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "mt-2",
                                    children: lang === "sv" ? "Om du inte kan ta m\xf6tet f\xe5r du avboka det ist\xe4llet." : "If you can't have the meeting, please cancel it instead."
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $f11e5f8e19ffb75f$export$2e2bcd8739ae039 = $f11e5f8e19ffb75f$var$ListComponent;





var $fc5b9013a96f3cd9$var$NextMeetingCard = function(param) {
    var _param_meetingData = param.meetingData, meetingData = _param_meetingData === void 0 ? [] : _param_meetingData, openCancelModal = param.openCancelModal, license = param.license;
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), isMeetingWithinTenMinutes = _useState[0], setIsMeetingWithinTenMinutes = _useState[1];
    (0, $5s1kH.useEffect)(function() {
        var checkMeetingTime = function() {
            if (meetingData && meetingData[0]) {
                var meetingTime = meetingData[0].startDate;
                var now = new Date();
                var diff = meetingTime.getSeconds() - now.getSeconds();
                var diffMinutes = diff / 60;
                if (diffMinutes >= 0 && diffMinutes <= 10) setIsMeetingWithinTenMinutes(true);
                else setIsMeetingWithinTenMinutes(false);
            } else setIsMeetingWithinTenMinutes(false);
        };
        // Initial check
        checkMeetingTime();
        // Set interval to check every minute
        var interval = setInterval(function() {
            checkMeetingTime();
        }, 60000); // 60000 milliseconds = 1 minute
        // Cleanup interval on unmount
        return function() {
            return clearInterval(interval);
        };
    }, [
        meetingData
    ]);
    var renderBooking = function() {
        if (!license) return null;
        var unBookableMessage = "";
        if (license.unBookable) {
            if (license.unBookable === "bookable_after_first_meeting") unBookableMessage = lang === "sv" ? "Du kan boka fler m\xf6ten efter ditt f\xf6rsta m\xf6te." : "You will be able to book more meetings after your first session.";
            else if (license.unBookable === "no_remaining_meetings") unBookableMessage = lang === "sv" ? "Du har bokat alla dina m\xf6ten." : "You have booked all your meetings.";
            else unBookableMessage = "Cannot book more meetings: " + license.unBookable;
        }
        if (unBookableMessage.length === 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($749d65ec77f6e156$exports))),
                alt: "plus icon"
            }),
            buttonType: "outlineWhiteBase",
            onClick: function() {
                return navigate("/videocoach/book-meeting");
            },
            children: t("book-more-meetings")
        });
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex border border-gray-500 bg-indigo-800 rounded-xl p-4",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                    alt: "info"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "ml-4",
                    children: unBookableMessage
                })
            ]
        });
    };
    var goToMeeting = function(meetingId) {
        if (api.apiToken) (0, $4bf2b0595575af5a$export$68c1f516bbed5123)(meetingId, api.apiToken, "client");
        else alert("Error - missing api token");
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $c9f7bf3282a3b2ff$export$2e2bcd8739ae039), {
        className: "overflow-visible",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $8b128e0855661626$export$2e2bcd8739ae039), {
                className: "p-4 flex flex-col gap-4 overflow-visible",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title2",
                                children: t("next-meeting")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $f11e5f8e19ffb75f$export$2e2bcd8739ae039), {
                                meetingData: [
                                    meetingData[0]
                                ],
                                isPreviousMeetings: false,
                                animate: true,
                                onCancellation: openCancelModal
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: isMeetingWithinTenMinutes ? "blueBase" : "outlineWhiteBase",
                        onClick: function() {
                            return goToMeeting(meetingData[0].id);
                        },
                        children: t("to-meeting")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $e463b23594a69ac8$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "pb-4",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $f11e5f8e19ffb75f$export$2e2bcd8739ae039), {
                            meetingData: meetingData.slice(1),
                            animate: true,
                            isPreviousMeetings: false,
                            onCancellation: openCancelModal
                        })
                    }),
                    renderBooking()
                ]
            })
        ]
    });
};
var $fc5b9013a96f3cd9$export$2e2bcd8739ae039 = $fc5b9013a96f3cd9$var$NextMeetingCard;


var $d9503866692825e9$export$2e2bcd8739ae039 = (0, $fc5b9013a96f3cd9$export$2e2bcd8739ae039);



parcelRequire("5s1kH");


var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");


var $f599883b13db06de$var$ChevronDownIcon = function(param) {
    var isOpen = param.isOpen;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "currentColor" // ensure Tailwind color classes apply
        ,
        xmlns: "http://www.w3.org/2000/svg",
        className: "\n      transform transition-transform duration-300\n      text-white          // White by default\n      group-hover:text-primary-400  // Change color on entire button hover\n      w-4 h-4             // Adjust if needed\n      ".concat(isOpen ? 'rotate-180' : '', "\n    "),
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.79289 8.79289C5.18342 8.40237 5.81658 8.40237 6.20711 8.79289L12.5 15.0858L18.7929 8.79289C19.1834 8.40237 19.8166 8.40237 20.2071 8.79289C20.5976 9.18342 20.5976 9.81658 20.2071 10.2071L13.2071 17.2071C12.8166 17.5976 12.1834 17.5976 11.7929 17.2071L4.79289 10.2071C4.40237 9.81658 4.40237 9.18342 4.79289 8.79289Z"
        })
    });
};
var $f599883b13db06de$var$ReadMore = function(props) {
    var t = (0, $341d5702266247e0$export$9fc83ad70ead8663)().t;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), open = _useState[0], setOpen = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(props.initialHeight), 2), maxHeight = _useState1[0], setMaxHeight = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showRaw = _useState2[0], setShowRaw = _useState2[1];
    var contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).useRef(null);
    var bgColor = props.bgColor ? props.bgColor : 'indigo-1000';
    (0, $5s1kH.useEffect)(function() {
        if (contentRef.current && !open) {
            var initialHeight = parseInt(props.initialHeight.replace('px', ''), 10);
            if (initialHeight >= contentRef.current.scrollHeight && contentRef.current.scrollHeight > 10) {
                setShowRaw(true);
                setOpen(true);
            }
        }
    }, [
        contentRef.current
    ]);
    var toggleOpen = function() {
        if (open) setMaxHeight(props.initialHeight);
        else if (props.maxHeight) setMaxHeight(props.maxHeight);
        else {
            var height = 100;
            if (contentRef && contentRef.current) height = contentRef.current.scrollHeight;
            setMaxHeight(height + 'px');
        }
        setOpen(!open);
    };
    var showToggle = function() {
        var marginClass = open ? 'mt-2' : '';
        // @ts-ignore
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $65b37309f7d8dd2c$export$2e2bcd8739ae039), {
            onClick: toggleOpen,
            color: "whitePrimaryMix",
            size: "sm",
            className: marginClass,
            // Provide the inline SVG with flipping logic
            rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($f599883b13db06de$var$ChevronDownIcon, {
                isOpen: open
            }),
            text: open ? props.readLessText || t('read-less') : props.readMoreText || t('read-more')
        });
    };
    // let boxCls = "overflow-hidden transition-all duration-300" + (open ? "" : " relative after:content-[''] after:absolute after:inset-x-0 after:bottom-0 after:h-4 after:bg-gradient-to-b after:from-transparent after:to-" + bgColor)
    var boxCls = "overflow-hidden transition-all duration-300";
    if (!open) {
        boxCls += " relative after:content-[''] after:absolute after:inset-x-0 after:bottom-0 after:h-4 after:bg-gradient-to-b after:from-transparent";
        // Tailwind won't generate the proper classes unless we spell them out pretty explicitly
        if (bgColor === 'indigo-800') boxCls += ' after:to-indigo-800';
        else if (bgColor === 'indigo-900') boxCls += ' after:to-indigo-900';
        else boxCls += ' after:to-indigo-1000';
    }
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            props.linkAbove && !showRaw && showToggle(),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                style: {
                    maxHeight: maxHeight
                },
                className: boxCls,
                ref: contentRef,
                children: props.children
            }),
            !props.linkAbove && !showRaw && showToggle()
        ]
    });
};
var $f599883b13db06de$export$2e2bcd8739ae039 = $f599883b13db06de$var$ReadMore;


var $b6b4698bb9d62235$export$2e2bcd8739ae039 = (0, $f599883b13db06de$export$2e2bcd8739ae039);



var $533e25b713e88b81$var$PreviousMeetingCard = function(param) {
    var _param_meetingData = param.meetingData, meetingData = _param_meetingData === void 0 ? [] : _param_meetingData;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c9f7bf3282a3b2ff$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8b128e0855661626$export$2e2bcd8739ae039), {
            className: "p-4 flex flex-col gap-4",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex flex-col gap-2",
                children: meetingData.length > 2 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b6b4698bb9d62235$export$2e2bcd8739ae039), {
                    linkAbove: false,
                    initialHeight: "82px",
                    bgColor: "indigo-900",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $f11e5f8e19ffb75f$export$2e2bcd8739ae039), {
                        meetingData: meetingData,
                        isPreviousMeetings: true,
                        animate: false,
                        onCancellation: function() {
                            return console.log('not used');
                        }
                    })
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $f11e5f8e19ffb75f$export$2e2bcd8739ae039), {
                    meetingData: meetingData,
                    isPreviousMeetings: true,
                    animate: false,
                    onCancellation: function() {
                        return console.log('not used');
                    }
                })
            })
        })
    });
};
var $533e25b713e88b81$export$2e2bcd8739ae039 = $533e25b713e88b81$var$PreviousMeetingCard;


var $a2a2cdb2fb51cd3b$export$2e2bcd8739ae039 = (0, $533e25b713e88b81$export$2e2bcd8739ae039);



parcelRequire("5s1kH");




var $a4533f8c294770b7$var$LateCancellationModal = function(param) {
    var onClose = param.onClose, isOpen = param.isOpen, cancelMeeting = param.cancelMeeting, coachName = param.coachName;
    var t = (0, $341d5702266247e0$export$9fc83ad70ead8663)().t;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title1",
                    children: t("late-cancellation-heading")
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-col justify-between ",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex flex-row justify-center",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                                alt: "Cancel meeting",
                                className: "w-12 h-12 mt-3"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "text-normal text-base mt-6",
                            children: t("late-cancellation-text")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    onClick: function() {
                        return cancelMeeting();
                    },
                    buttonType: "dangerBase",
                    children: t("cancel2")
                })
            })
        ]
    });
};
var $a4533f8c294770b7$export$2e2bcd8739ae039 = $a4533f8c294770b7$var$LateCancellationModal;


var $d66a4bb4587dd0d5$export$2e2bcd8739ae039 = (0, $a4533f8c294770b7$export$2e2bcd8739ae039);



parcelRequire("5s1kH");




var $8ae84f68e4197d51$var$SuccessfullyCancelledModal = function(param) {
    var onClose = param.onClose, isOpen = param.isOpen, coachName = param.coachName;
    var t = (0, $341d5702266247e0$export$9fc83ad70ead8663)().t;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title1",
                    children: t("meeting-cancelled")
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-col justify-between gap-3 ",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex flex-row justify-center",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($25e20653d8aa411d$exports))),
                                alt: "Cancel meeting",
                                className: "w-12 h-12 my-3"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "text-normal text-base",
                            children: t("meeting-with-coach-cancelled", {
                                coach: coachName
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    onClick: onClose,
                    children: t("close")
                })
            })
        ]
    });
};
var $8ae84f68e4197d51$export$2e2bcd8739ae039 = $8ae84f68e4197d51$var$SuccessfullyCancelledModal;


var $9b82a515029bbed6$export$2e2bcd8739ae039 = (0, $8ae84f68e4197d51$export$2e2bcd8739ae039);



parcelRequire("5s1kH");







var $ab63c1a85607c3f9$var$ConfirmCancellationModal = function(param) {
    var onClose = param.onClose, isOpen = param.isOpen, meeting = param.meeting, cancelMeeting = param.cancelMeeting, coachName = param.coachName;
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = i18n.language ? i18n.language.startsWith("sv") ? "sv" : "en" : "en";
    if (!meeting) return null;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title1",
                    children: t("confirm-cancellation-heading")
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-col gap-3 ",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "text-normal text-base",
                            children: coachName
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                    alt: "calendar icon",
                                    className: "w-8 h-8"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: (0, $7d185b5883a21821$export$1c7501cd03a59e59)(meeting.startDate, false, lang)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a72c3766ce7dfa42$exports))),
                                    alt: "clock icon",
                                    className: "w-8 h-8"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: (0, $7d185b5883a21821$export$5f885a9374f8e024)(meeting.startDate)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    onClick: function() {
                        return cancelMeeting();
                    },
                    children: t("cancel-meeting")
                })
            })
        ]
    });
};
var $ab63c1a85607c3f9$export$2e2bcd8739ae039 = $ab63c1a85607c3f9$var$ConfirmCancellationModal;


var $fa5300e6fbb793c9$export$2e2bcd8739ae039 = (0, $ab63c1a85607c3f9$export$2e2bcd8739ae039);



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");



var $5s1kH = parcelRequire("5s1kH");






var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $b069bdc03fa8af1a$exports = {};

var $03bAP = parcelRequire("03bAP");
'use strict';
Object.defineProperty($b069bdc03fa8af1a$exports, '__esModule', {
    value: true
});
function $b069bdc03fa8af1a$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $03bAP._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $5s1kH = parcelRequire("5s1kH");
var $b069bdc03fa8af1a$var$React__default = $b069bdc03fa8af1a$var$_interopDefault($5s1kH);

var $2B8EG = parcelRequire("2B8EG");
var $b069bdc03fa8af1a$var$ClientUAInstance = new $2B8EG();
var $b069bdc03fa8af1a$var$browser = $b069bdc03fa8af1a$var$ClientUAInstance.getBrowser();
var $b069bdc03fa8af1a$var$cpu = $b069bdc03fa8af1a$var$ClientUAInstance.getCPU();
var $b069bdc03fa8af1a$var$device = $b069bdc03fa8af1a$var$ClientUAInstance.getDevice();
var $b069bdc03fa8af1a$var$engine = $b069bdc03fa8af1a$var$ClientUAInstance.getEngine();
var $b069bdc03fa8af1a$var$os = $b069bdc03fa8af1a$var$ClientUAInstance.getOS();
var $b069bdc03fa8af1a$var$ua = $b069bdc03fa8af1a$var$ClientUAInstance.getUA();
var $b069bdc03fa8af1a$var$setUa = function setUa(userAgentString) {
    return $b069bdc03fa8af1a$var$ClientUAInstance.setUA(userAgentString);
};
var $b069bdc03fa8af1a$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error('No userAgent string was provided');
        return;
    }
    var UserAgentInstance = new $2B8EG(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $b069bdc03fa8af1a$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $b069bdc03fa8af1a$var$ClientUAInstance,
    browser: $b069bdc03fa8af1a$var$browser,
    cpu: $b069bdc03fa8af1a$var$cpu,
    device: $b069bdc03fa8af1a$var$device,
    engine: $b069bdc03fa8af1a$var$engine,
    os: $b069bdc03fa8af1a$var$os,
    ua: $b069bdc03fa8af1a$var$ua,
    setUa: $b069bdc03fa8af1a$var$setUa,
    parseUserAgent: $b069bdc03fa8af1a$var$parseUserAgent
});
function $b069bdc03fa8af1a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b069bdc03fa8af1a$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b069bdc03fa8af1a$var$ownKeys(Object(source), true).forEach(function(key) {
            $b069bdc03fa8af1a$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b069bdc03fa8af1a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b069bdc03fa8af1a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b069bdc03fa8af1a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b069bdc03fa8af1a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b069bdc03fa8af1a$var$_typeof(obj);
}
function $b069bdc03fa8af1a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b069bdc03fa8af1a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b069bdc03fa8af1a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b069bdc03fa8af1a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b069bdc03fa8af1a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b069bdc03fa8af1a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b069bdc03fa8af1a$var$_extends() {
    $b069bdc03fa8af1a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b069bdc03fa8af1a$var$_extends.apply(this, arguments);
}
function $b069bdc03fa8af1a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b069bdc03fa8af1a$var$_setPrototypeOf(subClass, superClass);
}
function $b069bdc03fa8af1a$var$_getPrototypeOf(o) {
    $b069bdc03fa8af1a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b069bdc03fa8af1a$var$_getPrototypeOf(o);
}
function $b069bdc03fa8af1a$var$_setPrototypeOf(o, p) {
    $b069bdc03fa8af1a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b069bdc03fa8af1a$var$_setPrototypeOf(o, p);
}
function $b069bdc03fa8af1a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b069bdc03fa8af1a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b069bdc03fa8af1a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b069bdc03fa8af1a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b069bdc03fa8af1a$var$_possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, $03bAP._)(call)) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b069bdc03fa8af1a$var$_assertThisInitialized(self);
}
function $b069bdc03fa8af1a$var$_slicedToArray(arr, i) {
    return $b069bdc03fa8af1a$var$_arrayWithHoles(arr) || $b069bdc03fa8af1a$var$_iterableToArrayLimit(arr, i) || $b069bdc03fa8af1a$var$_unsupportedIterableToArray(arr, i) || $b069bdc03fa8af1a$var$_nonIterableRest();
}
function $b069bdc03fa8af1a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b069bdc03fa8af1a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b069bdc03fa8af1a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b069bdc03fa8af1a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b069bdc03fa8af1a$var$_arrayLikeToArray(o, minLen);
}
function $b069bdc03fa8af1a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b069bdc03fa8af1a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $b069bdc03fa8af1a$var$DeviceTypes = {
    Mobile: 'mobile',
    Tablet: 'tablet',
    SmartTv: 'smarttv',
    Console: 'console',
    Wearable: 'wearable',
    Embedded: 'embedded',
    Browser: undefined
};
var $b069bdc03fa8af1a$var$BrowserTypes = {
    Chrome: 'Chrome',
    Firefox: 'Firefox',
    Opera: 'Opera',
    Yandex: 'Yandex',
    Safari: 'Safari',
    InternetExplorer: 'Internet Explorer',
    Edge: 'Edge',
    Chromium: 'Chromium',
    Ie: 'IE',
    MobileSafari: 'Mobile Safari',
    EdgeChromium: 'Edge Chromium',
    MIUI: 'MIUI Browser',
    SamsungBrowser: 'Samsung Browser'
};
var $b069bdc03fa8af1a$var$OsTypes = {
    IOS: 'iOS',
    Android: 'Android',
    WindowsPhone: 'Windows Phone',
    Windows: 'Windows',
    MAC_OS: 'Mac OS'
};
var $b069bdc03fa8af1a$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $b069bdc03fa8af1a$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $b069bdc03fa8af1a$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $b069bdc03fa8af1a$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $b069bdc03fa8af1a$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $b069bdc03fa8af1a$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $b069bdc03fa8af1a$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $b069bdc03fa8af1a$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $b069bdc03fa8af1a$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $b069bdc03fa8af1a$var$InitialDeviceTypes;
    }
};
var $b069bdc03fa8af1a$var$setUserAgent = function setUserAgent(userAgent) {
    return $b069bdc03fa8af1a$var$setUa(userAgent);
};
var $b069bdc03fa8af1a$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    return p ? p : d;
};
var $b069bdc03fa8af1a$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== 'undefined') {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $b069bdc03fa8af1a$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $b069bdc03fa8af1a$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $b069bdc03fa8af1a$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $b069bdc03fa8af1a$var$setDefaults(browser.major),
        browserFullVersion: $b069bdc03fa8af1a$var$setDefaults(browser.version),
        browserName: $b069bdc03fa8af1a$var$setDefaults(browser.name),
        engineName: $b069bdc03fa8af1a$var$setDefaults(engine.name),
        engineVersion: $b069bdc03fa8af1a$var$setDefaults(engine.version),
        osName: $b069bdc03fa8af1a$var$setDefaults(os.name),
        osVersion: $b069bdc03fa8af1a$var$setDefaults(os.version),
        userAgent: $b069bdc03fa8af1a$var$setDefaults(ua)
    };
};
var $b069bdc03fa8af1a$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $b069bdc03fa8af1a$var$_objectSpread2({}, type, {
        vendor: $b069bdc03fa8af1a$var$setDefaults(device.vendor),
        model: $b069bdc03fa8af1a$var$setDefaults(device.model),
        os: $b069bdc03fa8af1a$var$setDefaults(os.name),
        osVersion: $b069bdc03fa8af1a$var$setDefaults(os.version),
        ua: $b069bdc03fa8af1a$var$setDefaults(ua)
    });
};
var $b069bdc03fa8af1a$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $b069bdc03fa8af1a$var$setDefaults(engine.name),
        engineVersion: $b069bdc03fa8af1a$var$setDefaults(engine.version),
        osName: $b069bdc03fa8af1a$var$setDefaults(os.name),
        osVersion: $b069bdc03fa8af1a$var$setDefaults(os.version),
        userAgent: $b069bdc03fa8af1a$var$setDefaults(ua)
    };
};
var $b069bdc03fa8af1a$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $b069bdc03fa8af1a$var$setDefaults(engine.name),
        engineVersion: $b069bdc03fa8af1a$var$setDefaults(engine.version),
        osName: $b069bdc03fa8af1a$var$setDefaults(os.name),
        osVersion: $b069bdc03fa8af1a$var$setDefaults(os.version),
        userAgent: $b069bdc03fa8af1a$var$setDefaults(ua)
    };
};
var $b069bdc03fa8af1a$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $b069bdc03fa8af1a$var$setDefaults(engine.name),
        engineVersion: $b069bdc03fa8af1a$var$setDefaults(engine.version),
        osName: $b069bdc03fa8af1a$var$setDefaults(os.name),
        osVersion: $b069bdc03fa8af1a$var$setDefaults(os.version),
        userAgent: $b069bdc03fa8af1a$var$setDefaults(ua)
    };
};
var $b069bdc03fa8af1a$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $b069bdc03fa8af1a$var$setDefaults(device.vendor),
        model: $b069bdc03fa8af1a$var$setDefaults(device.model),
        engineName: $b069bdc03fa8af1a$var$setDefaults(engine.name),
        engineVersion: $b069bdc03fa8af1a$var$setDefaults(engine.version),
        osName: $b069bdc03fa8af1a$var$setDefaults(os.name),
        osVersion: $b069bdc03fa8af1a$var$setDefaults(os.version),
        userAgent: $b069bdc03fa8af1a$var$setDefaults(ua)
    };
};
function $b069bdc03fa8af1a$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $b069bdc03fa8af1a$var$parseUserAgent(userAgent) : $b069bdc03fa8af1a$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $b069bdc03fa8af1a$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $b069bdc03fa8af1a$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $b069bdc03fa8af1a$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $b069bdc03fa8af1a$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $b069bdc03fa8af1a$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $b069bdc03fa8af1a$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $b069bdc03fa8af1a$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $b069bdc03fa8af1a$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $b069bdc03fa8af1a$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $b069bdc03fa8af1a$var$DeviceTypes.Mobile;
};
var $b069bdc03fa8af1a$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $b069bdc03fa8af1a$var$DeviceTypes.Tablet;
};
var $b069bdc03fa8af1a$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $b069bdc03fa8af1a$var$DeviceTypes.Mobile || type === $b069bdc03fa8af1a$var$DeviceTypes.Tablet;
};
var $b069bdc03fa8af1a$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $b069bdc03fa8af1a$var$DeviceTypes.SmartTv;
};
var $b069bdc03fa8af1a$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $b069bdc03fa8af1a$var$DeviceTypes.Browser;
};
var $b069bdc03fa8af1a$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $b069bdc03fa8af1a$var$DeviceTypes.Wearable;
};
var $b069bdc03fa8af1a$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $b069bdc03fa8af1a$var$DeviceTypes.Console;
};
var $b069bdc03fa8af1a$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $b069bdc03fa8af1a$var$DeviceTypes.Embedded;
};
var $b069bdc03fa8af1a$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $b069bdc03fa8af1a$var$setDefaults(vendor);
};
var $b069bdc03fa8af1a$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $b069bdc03fa8af1a$var$setDefaults(model);
};
var $b069bdc03fa8af1a$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $b069bdc03fa8af1a$var$setDefaults(type, 'browser');
}; // os types
var $b069bdc03fa8af1a$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $b069bdc03fa8af1a$var$OsTypes.Android;
};
var $b069bdc03fa8af1a$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $b069bdc03fa8af1a$var$OsTypes.Windows;
};
var $b069bdc03fa8af1a$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $b069bdc03fa8af1a$var$OsTypes.MAC_OS;
};
var $b069bdc03fa8af1a$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $b069bdc03fa8af1a$var$OsTypes.WindowsPhone;
};
var $b069bdc03fa8af1a$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $b069bdc03fa8af1a$var$OsTypes.IOS;
};
var $b069bdc03fa8af1a$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $b069bdc03fa8af1a$var$setDefaults(version);
};
var $b069bdc03fa8af1a$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $b069bdc03fa8af1a$var$setDefaults(name);
}; // browser types
var $b069bdc03fa8af1a$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $b069bdc03fa8af1a$var$BrowserTypes.Chrome;
};
var $b069bdc03fa8af1a$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $b069bdc03fa8af1a$var$BrowserTypes.Firefox;
};
var $b069bdc03fa8af1a$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $b069bdc03fa8af1a$var$BrowserTypes.Chromium;
};
var $b069bdc03fa8af1a$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $b069bdc03fa8af1a$var$BrowserTypes.Edge;
};
var $b069bdc03fa8af1a$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $b069bdc03fa8af1a$var$BrowserTypes.Yandex;
};
var $b069bdc03fa8af1a$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $b069bdc03fa8af1a$var$BrowserTypes.Safari || name === $b069bdc03fa8af1a$var$BrowserTypes.MobileSafari;
};
var $b069bdc03fa8af1a$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $b069bdc03fa8af1a$var$BrowserTypes.MobileSafari;
};
var $b069bdc03fa8af1a$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $b069bdc03fa8af1a$var$BrowserTypes.Opera;
};
var $b069bdc03fa8af1a$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $b069bdc03fa8af1a$var$BrowserTypes.InternetExplorer || name === $b069bdc03fa8af1a$var$BrowserTypes.Ie;
};
var $b069bdc03fa8af1a$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $b069bdc03fa8af1a$var$BrowserTypes.MIUI;
};
var $b069bdc03fa8af1a$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $b069bdc03fa8af1a$var$BrowserTypes.SamsungBrowser;
};
var $b069bdc03fa8af1a$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $b069bdc03fa8af1a$var$setDefaults(version);
};
var $b069bdc03fa8af1a$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $b069bdc03fa8af1a$var$setDefaults(major);
};
var $b069bdc03fa8af1a$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $b069bdc03fa8af1a$var$setDefaults(name);
}; // engine types
var $b069bdc03fa8af1a$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $b069bdc03fa8af1a$var$setDefaults(name);
};
var $b069bdc03fa8af1a$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $b069bdc03fa8af1a$var$setDefaults(version);
};
var $b069bdc03fa8af1a$var$isElectronType = function isElectronType() {
    var nav = $b069bdc03fa8af1a$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var $b069bdc03fa8af1a$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var $b069bdc03fa8af1a$var$getIOS13 = function getIOS13() {
    var nav = $b069bdc03fa8af1a$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $b069bdc03fa8af1a$var$getIPad13 = function getIPad13() {
    return $b069bdc03fa8af1a$var$isIOS13Check('iPad');
};
var $b069bdc03fa8af1a$var$getIphone13 = function getIphone13() {
    return $b069bdc03fa8af1a$var$isIOS13Check('iPhone');
};
var $b069bdc03fa8af1a$var$getIPod13 = function getIPod13() {
    return $b069bdc03fa8af1a$var$isIOS13Check('iPod');
};
var $b069bdc03fa8af1a$var$getUseragent = function getUseragent(userAg) {
    return $b069bdc03fa8af1a$var$setDefaults(userAg);
};
function $b069bdc03fa8af1a$var$buildSelectorsObject(options) {
    var _ref = options ? options : $b069bdc03fa8af1a$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $b069bdc03fa8af1a$var$isSmartTVType(device),
        isConsole: $b069bdc03fa8af1a$var$isConsoleType(device),
        isWearable: $b069bdc03fa8af1a$var$isWearableType(device),
        isEmbedded: $b069bdc03fa8af1a$var$isEmbeddedType(device),
        isMobileSafari: $b069bdc03fa8af1a$var$isMobileSafariType(browser) || $b069bdc03fa8af1a$var$getIPad13(),
        isChromium: $b069bdc03fa8af1a$var$isChromiumType(browser),
        isMobile: $b069bdc03fa8af1a$var$isMobileAndTabletType(device) || $b069bdc03fa8af1a$var$getIPad13(),
        isMobileOnly: $b069bdc03fa8af1a$var$isMobileType(device),
        isTablet: $b069bdc03fa8af1a$var$isTabletType(device) || $b069bdc03fa8af1a$var$getIPad13(),
        isBrowser: $b069bdc03fa8af1a$var$isBrowserType(device),
        isDesktop: $b069bdc03fa8af1a$var$isBrowserType(device),
        isAndroid: $b069bdc03fa8af1a$var$isAndroidType(os),
        isWinPhone: $b069bdc03fa8af1a$var$isWinPhoneType(os),
        isIOS: $b069bdc03fa8af1a$var$isIOSType(os) || $b069bdc03fa8af1a$var$getIPad13(),
        isChrome: $b069bdc03fa8af1a$var$isChromeType(browser),
        isFirefox: $b069bdc03fa8af1a$var$isFirefoxType(browser),
        isSafari: $b069bdc03fa8af1a$var$isSafariType(browser),
        isOpera: $b069bdc03fa8af1a$var$isOperaType(browser),
        isIE: $b069bdc03fa8af1a$var$isIEType(browser),
        osVersion: $b069bdc03fa8af1a$var$getOsVersion(os),
        osName: $b069bdc03fa8af1a$var$getOsName(os),
        fullBrowserVersion: $b069bdc03fa8af1a$var$getBrowserFullVersion(browser),
        browserVersion: $b069bdc03fa8af1a$var$getBrowserVersion(browser),
        browserName: $b069bdc03fa8af1a$var$getBrowserName(browser),
        mobileVendor: $b069bdc03fa8af1a$var$getMobileVendor(device),
        mobileModel: $b069bdc03fa8af1a$var$getMobileModel(device),
        engineName: $b069bdc03fa8af1a$var$getEngineName(engine),
        engineVersion: $b069bdc03fa8af1a$var$getEngineVersion(engine),
        getUA: $b069bdc03fa8af1a$var$getUseragent(ua),
        isEdge: $b069bdc03fa8af1a$var$isEdgeType(browser) || $b069bdc03fa8af1a$var$isEdgeChromiumType(ua),
        isYandex: $b069bdc03fa8af1a$var$isYandexType(browser),
        deviceType: $b069bdc03fa8af1a$var$getDeviceType(device),
        isIOS13: $b069bdc03fa8af1a$var$getIOS13(),
        isIPad13: $b069bdc03fa8af1a$var$getIPad13(),
        isIPhone13: $b069bdc03fa8af1a$var$getIphone13(),
        isIPod13: $b069bdc03fa8af1a$var$getIPod13(),
        isElectron: $b069bdc03fa8af1a$var$isElectronType(),
        isEdgeChromium: $b069bdc03fa8af1a$var$isEdgeChromiumType(ua),
        isLegacyEdge: $b069bdc03fa8af1a$var$isEdgeType(browser) && !$b069bdc03fa8af1a$var$isEdgeChromiumType(ua),
        isWindows: $b069bdc03fa8af1a$var$isWindowsType(os),
        isMacOs: $b069bdc03fa8af1a$var$isMacOsType(os),
        isMIUI: $b069bdc03fa8af1a$var$isMIUIType(browser),
        isSamsungBrowser: $b069bdc03fa8af1a$var$isSamsungBrowserType(browser)
    };
}
var $b069bdc03fa8af1a$var$isSmartTV = $b069bdc03fa8af1a$var$isSmartTVType($b069bdc03fa8af1a$var$device);
var $b069bdc03fa8af1a$var$isConsole = $b069bdc03fa8af1a$var$isConsoleType($b069bdc03fa8af1a$var$device);
var $b069bdc03fa8af1a$var$isWearable = $b069bdc03fa8af1a$var$isWearableType($b069bdc03fa8af1a$var$device);
var $b069bdc03fa8af1a$var$isEmbedded = $b069bdc03fa8af1a$var$isEmbeddedType($b069bdc03fa8af1a$var$device);
var $b069bdc03fa8af1a$var$isMobileSafari = $b069bdc03fa8af1a$var$isMobileSafariType($b069bdc03fa8af1a$var$browser) || $b069bdc03fa8af1a$var$getIPad13();
var $b069bdc03fa8af1a$var$isChromium = $b069bdc03fa8af1a$var$isChromiumType($b069bdc03fa8af1a$var$browser);
var $b069bdc03fa8af1a$var$isMobile = $b069bdc03fa8af1a$var$isMobileAndTabletType($b069bdc03fa8af1a$var$device) || $b069bdc03fa8af1a$var$getIPad13();
var $b069bdc03fa8af1a$var$isMobileOnly = $b069bdc03fa8af1a$var$isMobileType($b069bdc03fa8af1a$var$device);
var $b069bdc03fa8af1a$var$isTablet = $b069bdc03fa8af1a$var$isTabletType($b069bdc03fa8af1a$var$device) || $b069bdc03fa8af1a$var$getIPad13();
var $b069bdc03fa8af1a$var$isBrowser = $b069bdc03fa8af1a$var$isBrowserType($b069bdc03fa8af1a$var$device);
var $b069bdc03fa8af1a$var$isDesktop = $b069bdc03fa8af1a$var$isBrowserType($b069bdc03fa8af1a$var$device);
var $b069bdc03fa8af1a$var$isAndroid = $b069bdc03fa8af1a$var$isAndroidType($b069bdc03fa8af1a$var$os);
var $b069bdc03fa8af1a$var$isWinPhone = $b069bdc03fa8af1a$var$isWinPhoneType($b069bdc03fa8af1a$var$os);
var $b069bdc03fa8af1a$var$isIOS = $b069bdc03fa8af1a$var$isIOSType($b069bdc03fa8af1a$var$os) || $b069bdc03fa8af1a$var$getIPad13();
var $b069bdc03fa8af1a$var$isChrome = $b069bdc03fa8af1a$var$isChromeType($b069bdc03fa8af1a$var$browser);
var $b069bdc03fa8af1a$var$isFirefox = $b069bdc03fa8af1a$var$isFirefoxType($b069bdc03fa8af1a$var$browser);
var $b069bdc03fa8af1a$var$isSafari = $b069bdc03fa8af1a$var$isSafariType($b069bdc03fa8af1a$var$browser);
var $b069bdc03fa8af1a$var$isOpera = $b069bdc03fa8af1a$var$isOperaType($b069bdc03fa8af1a$var$browser);
var $b069bdc03fa8af1a$var$isIE = $b069bdc03fa8af1a$var$isIEType($b069bdc03fa8af1a$var$browser);
var $b069bdc03fa8af1a$var$osVersion = $b069bdc03fa8af1a$var$getOsVersion($b069bdc03fa8af1a$var$os);
var $b069bdc03fa8af1a$var$osName = $b069bdc03fa8af1a$var$getOsName($b069bdc03fa8af1a$var$os);
var $b069bdc03fa8af1a$var$fullBrowserVersion = $b069bdc03fa8af1a$var$getBrowserFullVersion($b069bdc03fa8af1a$var$browser);
var $b069bdc03fa8af1a$var$browserVersion = $b069bdc03fa8af1a$var$getBrowserVersion($b069bdc03fa8af1a$var$browser);
var $b069bdc03fa8af1a$var$browserName = $b069bdc03fa8af1a$var$getBrowserName($b069bdc03fa8af1a$var$browser);
var $b069bdc03fa8af1a$var$mobileVendor = $b069bdc03fa8af1a$var$getMobileVendor($b069bdc03fa8af1a$var$device);
var $b069bdc03fa8af1a$var$mobileModel = $b069bdc03fa8af1a$var$getMobileModel($b069bdc03fa8af1a$var$device);
var $b069bdc03fa8af1a$var$engineName = $b069bdc03fa8af1a$var$getEngineName($b069bdc03fa8af1a$var$engine);
var $b069bdc03fa8af1a$var$engineVersion = $b069bdc03fa8af1a$var$getEngineVersion($b069bdc03fa8af1a$var$engine);
var $b069bdc03fa8af1a$var$getUA = $b069bdc03fa8af1a$var$getUseragent($b069bdc03fa8af1a$var$ua);
var $b069bdc03fa8af1a$var$isEdge = $b069bdc03fa8af1a$var$isEdgeType($b069bdc03fa8af1a$var$browser) || $b069bdc03fa8af1a$var$isEdgeChromiumType($b069bdc03fa8af1a$var$ua);
var $b069bdc03fa8af1a$var$isYandex = $b069bdc03fa8af1a$var$isYandexType($b069bdc03fa8af1a$var$browser);
var $b069bdc03fa8af1a$var$deviceType = $b069bdc03fa8af1a$var$getDeviceType($b069bdc03fa8af1a$var$device);
var $b069bdc03fa8af1a$var$isIOS13 = $b069bdc03fa8af1a$var$getIOS13();
var $b069bdc03fa8af1a$var$isIPad13 = $b069bdc03fa8af1a$var$getIPad13();
var $b069bdc03fa8af1a$var$isIPhone13 = $b069bdc03fa8af1a$var$getIphone13();
var $b069bdc03fa8af1a$var$isIPod13 = $b069bdc03fa8af1a$var$getIPod13();
var $b069bdc03fa8af1a$var$isElectron = $b069bdc03fa8af1a$var$isElectronType();
var $b069bdc03fa8af1a$var$isEdgeChromium = $b069bdc03fa8af1a$var$isEdgeChromiumType($b069bdc03fa8af1a$var$ua);
var $b069bdc03fa8af1a$var$isLegacyEdge = $b069bdc03fa8af1a$var$isEdgeType($b069bdc03fa8af1a$var$browser) && !$b069bdc03fa8af1a$var$isEdgeChromiumType($b069bdc03fa8af1a$var$ua);
var $b069bdc03fa8af1a$var$isWindows = $b069bdc03fa8af1a$var$isWindowsType($b069bdc03fa8af1a$var$os);
var $b069bdc03fa8af1a$var$isMacOs = $b069bdc03fa8af1a$var$isMacOsType($b069bdc03fa8af1a$var$os);
var $b069bdc03fa8af1a$var$isMIUI = $b069bdc03fa8af1a$var$isMIUIType($b069bdc03fa8af1a$var$browser);
var $b069bdc03fa8af1a$var$isSamsungBrowser = $b069bdc03fa8af1a$var$isSamsungBrowserType($b069bdc03fa8af1a$var$browser);
var $b069bdc03fa8af1a$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== 'string') {
        console.error('No valid user agent string was provided');
        return;
    }
    var _UAHelper$parseUserAg = $b069bdc03fa8af1a$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $b069bdc03fa8af1a$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $b069bdc03fa8af1a$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $b069bdc03fa8af1a$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $b069bdc03fa8af1a$var$isAndroid ? renderWithFragment ? $b069bdc03fa8af1a$var$React__default.createElement($5s1kH.Fragment, null, children) : $b069bdc03fa8af1a$var$React__default.createElement("div", props, children) : null;
};
var $b069bdc03fa8af1a$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $b069bdc03fa8af1a$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $b069bdc03fa8af1a$var$isBrowser ? renderWithFragment ? $b069bdc03fa8af1a$var$React__default.createElement($5s1kH.Fragment, null, children) : $b069bdc03fa8af1a$var$React__default.createElement("div", props, children) : null;
};
var $b069bdc03fa8af1a$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $b069bdc03fa8af1a$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $b069bdc03fa8af1a$var$isIE ? renderWithFragment ? $b069bdc03fa8af1a$var$React__default.createElement($5s1kH.Fragment, null, children) : $b069bdc03fa8af1a$var$React__default.createElement("div", props, children) : null;
};
var $b069bdc03fa8af1a$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $b069bdc03fa8af1a$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $b069bdc03fa8af1a$var$isIOS ? renderWithFragment ? $b069bdc03fa8af1a$var$React__default.createElement($5s1kH.Fragment, null, children) : $b069bdc03fa8af1a$var$React__default.createElement("div", props, children) : null;
};
var $b069bdc03fa8af1a$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $b069bdc03fa8af1a$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $b069bdc03fa8af1a$var$isMobile ? renderWithFragment ? $b069bdc03fa8af1a$var$React__default.createElement($5s1kH.Fragment, null, children) : $b069bdc03fa8af1a$var$React__default.createElement("div", props, children) : null;
};
var $b069bdc03fa8af1a$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $b069bdc03fa8af1a$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $b069bdc03fa8af1a$var$isTablet ? renderWithFragment ? $b069bdc03fa8af1a$var$React__default.createElement($5s1kH.Fragment, null, children) : $b069bdc03fa8af1a$var$React__default.createElement("div", props, children) : null;
};
var $b069bdc03fa8af1a$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $b069bdc03fa8af1a$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $b069bdc03fa8af1a$var$isWinPhone ? renderWithFragment ? $b069bdc03fa8af1a$var$React__default.createElement($5s1kH.Fragment, null, children) : $b069bdc03fa8af1a$var$React__default.createElement("div", props, children) : null;
};
var $b069bdc03fa8af1a$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $b069bdc03fa8af1a$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $b069bdc03fa8af1a$var$isMobileOnly ? renderWithFragment ? $b069bdc03fa8af1a$var$React__default.createElement($5s1kH.Fragment, null, children) : $b069bdc03fa8af1a$var$React__default.createElement("div", props, children) : null;
};
var $b069bdc03fa8af1a$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $b069bdc03fa8af1a$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $b069bdc03fa8af1a$var$isSmartTV ? renderWithFragment ? $b069bdc03fa8af1a$var$React__default.createElement($5s1kH.Fragment, null, children) : $b069bdc03fa8af1a$var$React__default.createElement("div", props, children) : null;
};
var $b069bdc03fa8af1a$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $b069bdc03fa8af1a$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $b069bdc03fa8af1a$var$isConsole ? renderWithFragment ? $b069bdc03fa8af1a$var$React__default.createElement($5s1kH.Fragment, null, children) : $b069bdc03fa8af1a$var$React__default.createElement("div", props, children) : null;
};
var $b069bdc03fa8af1a$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $b069bdc03fa8af1a$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $b069bdc03fa8af1a$var$isWearable ? renderWithFragment ? $b069bdc03fa8af1a$var$React__default.createElement($5s1kH.Fragment, null, children) : $b069bdc03fa8af1a$var$React__default.createElement("div", props, children) : null;
};
var $b069bdc03fa8af1a$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $b069bdc03fa8af1a$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $b069bdc03fa8af1a$var$React__default.createElement($5s1kH.Fragment, null, children) : $b069bdc03fa8af1a$var$React__default.createElement("div", props, children) : null;
};
function $b069bdc03fa8af1a$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $b069bdc03fa8af1a$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $b069bdc03fa8af1a$var$_classCallCheck(this, _class);
            _this = $b069bdc03fa8af1a$var$_possibleConstructorReturn(this, $b069bdc03fa8af1a$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($b069bdc03fa8af1a$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($b069bdc03fa8af1a$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($b069bdc03fa8af1a$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $b069bdc03fa8af1a$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $b069bdc03fa8af1a$var$_typeof(window)) !== undefined && $b069bdc03fa8af1a$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $b069bdc03fa8af1a$var$React__default.createElement(WrappedComponent, $b069bdc03fa8af1a$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($b069bdc03fa8af1a$var$React__default.Component);
}
function $b069bdc03fa8af1a$var$useMobileOrientation() {
    var _useState = $5s1kH.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
    }), _useState2 = $b069bdc03fa8af1a$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $5s1kH.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $5s1kH.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $b069bdc03fa8af1a$var$_typeof(window)) !== undefined && $b069bdc03fa8af1a$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $b069bdc03fa8af1a$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $b069bdc03fa8af1a$var$parseUserAgent(hookUserAgent);
}
function $b069bdc03fa8af1a$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $b069bdc03fa8af1a$var$useDeviceData(hookUserAgent);
    var selectors = $b069bdc03fa8af1a$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$b069bdc03fa8af1a$exports.AndroidView = $b069bdc03fa8af1a$var$AndroidView;
$b069bdc03fa8af1a$exports.BrowserTypes = $b069bdc03fa8af1a$var$BrowserTypes;
$b069bdc03fa8af1a$exports.BrowserView = $b069bdc03fa8af1a$var$BrowserView;
$b069bdc03fa8af1a$exports.ConsoleView = $b069bdc03fa8af1a$var$ConsoleView;
$b069bdc03fa8af1a$exports.CustomView = $b069bdc03fa8af1a$var$CustomView;
$b069bdc03fa8af1a$exports.IEView = $b069bdc03fa8af1a$var$IEView;
$b069bdc03fa8af1a$exports.IOSView = $b069bdc03fa8af1a$var$IOSView;
$b069bdc03fa8af1a$exports.MobileOnlyView = $b069bdc03fa8af1a$var$MobileOnlyView;
$b069bdc03fa8af1a$exports.MobileView = $b069bdc03fa8af1a$var$MobileView;
$b069bdc03fa8af1a$exports.OsTypes = $b069bdc03fa8af1a$var$OsTypes;
$b069bdc03fa8af1a$exports.SmartTVView = $b069bdc03fa8af1a$var$SmartTVView;
$b069bdc03fa8af1a$exports.TabletView = $b069bdc03fa8af1a$var$TabletView;
$b069bdc03fa8af1a$exports.WearableView = $b069bdc03fa8af1a$var$WearableView;
$b069bdc03fa8af1a$exports.WinPhoneView = $b069bdc03fa8af1a$var$WinPhoneView;
$b069bdc03fa8af1a$exports.browserName = $b069bdc03fa8af1a$var$browserName;
$b069bdc03fa8af1a$exports.browserVersion = $b069bdc03fa8af1a$var$browserVersion;
$b069bdc03fa8af1a$exports.deviceDetect = $b069bdc03fa8af1a$var$deviceDetect;
$b069bdc03fa8af1a$exports.deviceType = $b069bdc03fa8af1a$var$deviceType;
$b069bdc03fa8af1a$exports.engineName = $b069bdc03fa8af1a$var$engineName;
$b069bdc03fa8af1a$exports.engineVersion = $b069bdc03fa8af1a$var$engineVersion;
$b069bdc03fa8af1a$exports.fullBrowserVersion = $b069bdc03fa8af1a$var$fullBrowserVersion;
$b069bdc03fa8af1a$exports.getSelectorsByUserAgent = $b069bdc03fa8af1a$var$getSelectorsByUserAgent;
$b069bdc03fa8af1a$exports.getUA = $b069bdc03fa8af1a$var$getUA;
$b069bdc03fa8af1a$exports.isAndroid = $b069bdc03fa8af1a$var$isAndroid;
$b069bdc03fa8af1a$exports.isBrowser = $b069bdc03fa8af1a$var$isBrowser;
$b069bdc03fa8af1a$exports.isChrome = $b069bdc03fa8af1a$var$isChrome;
$b069bdc03fa8af1a$exports.isChromium = $b069bdc03fa8af1a$var$isChromium;
$b069bdc03fa8af1a$exports.isConsole = $b069bdc03fa8af1a$var$isConsole;
$b069bdc03fa8af1a$exports.isDesktop = $b069bdc03fa8af1a$var$isDesktop;
$b069bdc03fa8af1a$exports.isEdge = $b069bdc03fa8af1a$var$isEdge;
$b069bdc03fa8af1a$exports.isEdgeChromium = $b069bdc03fa8af1a$var$isEdgeChromium;
$b069bdc03fa8af1a$exports.isElectron = $b069bdc03fa8af1a$var$isElectron;
$b069bdc03fa8af1a$exports.isEmbedded = $b069bdc03fa8af1a$var$isEmbedded;
$b069bdc03fa8af1a$exports.isFirefox = $b069bdc03fa8af1a$var$isFirefox;
$b069bdc03fa8af1a$exports.isIE = $b069bdc03fa8af1a$var$isIE;
$b069bdc03fa8af1a$exports.isIOS = $b069bdc03fa8af1a$var$isIOS;
$b069bdc03fa8af1a$exports.isIOS13 = $b069bdc03fa8af1a$var$isIOS13;
$b069bdc03fa8af1a$exports.isIPad13 = $b069bdc03fa8af1a$var$isIPad13;
$b069bdc03fa8af1a$exports.isIPhone13 = $b069bdc03fa8af1a$var$isIPhone13;
$b069bdc03fa8af1a$exports.isIPod13 = $b069bdc03fa8af1a$var$isIPod13;
$b069bdc03fa8af1a$exports.isLegacyEdge = $b069bdc03fa8af1a$var$isLegacyEdge;
$b069bdc03fa8af1a$exports.isMIUI = $b069bdc03fa8af1a$var$isMIUI;
$b069bdc03fa8af1a$exports.isMacOs = $b069bdc03fa8af1a$var$isMacOs;
$b069bdc03fa8af1a$exports.isMobile = $b069bdc03fa8af1a$var$isMobile;
$b069bdc03fa8af1a$exports.isMobileOnly = $b069bdc03fa8af1a$var$isMobileOnly;
$b069bdc03fa8af1a$exports.isMobileSafari = $b069bdc03fa8af1a$var$isMobileSafari;
$b069bdc03fa8af1a$exports.isOpera = $b069bdc03fa8af1a$var$isOpera;
$b069bdc03fa8af1a$exports.isSafari = $b069bdc03fa8af1a$var$isSafari;
$b069bdc03fa8af1a$exports.isSamsungBrowser = $b069bdc03fa8af1a$var$isSamsungBrowser;
$b069bdc03fa8af1a$exports.isSmartTV = $b069bdc03fa8af1a$var$isSmartTV;
$b069bdc03fa8af1a$exports.isTablet = $b069bdc03fa8af1a$var$isTablet;
$b069bdc03fa8af1a$exports.isWearable = $b069bdc03fa8af1a$var$isWearable;
$b069bdc03fa8af1a$exports.isWinPhone = $b069bdc03fa8af1a$var$isWinPhone;
$b069bdc03fa8af1a$exports.isWindows = $b069bdc03fa8af1a$var$isWindows;
$b069bdc03fa8af1a$exports.isYandex = $b069bdc03fa8af1a$var$isYandex;
$b069bdc03fa8af1a$exports.mobileModel = $b069bdc03fa8af1a$var$mobileModel;
$b069bdc03fa8af1a$exports.mobileVendor = $b069bdc03fa8af1a$var$mobileVendor;
$b069bdc03fa8af1a$exports.osName = $b069bdc03fa8af1a$var$osName;
$b069bdc03fa8af1a$exports.osVersion = $b069bdc03fa8af1a$var$osVersion;
$b069bdc03fa8af1a$exports.parseUserAgent = $b069bdc03fa8af1a$var$parseUserAgent;
$b069bdc03fa8af1a$exports.setUserAgent = $b069bdc03fa8af1a$var$setUserAgent;
$b069bdc03fa8af1a$exports.useDeviceData = $b069bdc03fa8af1a$var$useDeviceData;
$b069bdc03fa8af1a$exports.useDeviceSelectors = $b069bdc03fa8af1a$var$useDeviceSelectors;
$b069bdc03fa8af1a$exports.useMobileOrientation = $b069bdc03fa8af1a$var$useMobileOrientation;
$b069bdc03fa8af1a$exports.withOrientationChange = $b069bdc03fa8af1a$var$withOrientationChange;


var $72da9a2bd016ab3d$exports = {};
$72da9a2bd016ab3d$exports = $parcel$resolve("2vnb7");


var $cd4f198f0a3da66c$var$ChatInput = function(param) {
    var handleSendMessage = param.handleSendMessage, onHeightChange = param.onHeightChange;
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var containerRef = (0, $5s1kH.useRef)(null);
    var textareaRef = (0, $5s1kH.useRef)(null);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), input = _useState[0], setInput = _useState[1];
    var sendMessage = function() {
        if (input.trim() === "") return; // Prevent sending empty messages
        handleSendMessage(input);
        setInput(""); // Clear the input field
        if (textareaRef.current) textareaRef.current.style.height = "auto";
    };
    (0, $5s1kH.useEffect)(function() {
        if (!containerRef.current) return;
        var handleResize = function() {
            if (containerRef.current && onHeightChange) {
                var height = containerRef.current.offsetHeight;
                onHeightChange(height);
            }
        };
        handleResize(); // Initial height measurement
        var observer = new ResizeObserver(handleResize);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        containerRef,
        onHeightChange
    ]);
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "pb-2 pt-3  border-t border-indigo-800",
        ref: containerRef,
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex items-center",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "flex grow items-center rounded-md ring-1 ring-indigo-700 focus-within:ring-2 focus-within:ring-primary-500",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                        ref: textareaRef,
                        placeholder: t("chat-placeholder"),
                        className: "flex-1 text-white px-4 py-3 rounded-md resize-none overflow-y-auto max-h-40 border-none focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none",
                        style: {
                            whiteSpace: "normal"
                        },
                        value: input,
                        onChange: function(e) {
                            setInput(e.target.value);
                            if (textareaRef.current) {
                                textareaRef.current.style.height = "auto";
                                textareaRef.current.style.height = "".concat(textareaRef.current.scrollHeight, "px");
                            }
                        },
                        onKeyDown: function(e) {
                            if (e.key === "Enter" && !e.shiftKey && !(0, $b069bdc03fa8af1a$exports.isMobile)) {
                                e.preventDefault();
                                sendMessage();
                            }
                        },
                        rows: 1
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "ml-2 p-2 cursor-pointer text-white",
                    onClick: sendMessage,
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($72da9a2bd016ab3d$exports))),
                        alt: "send"
                    })
                })
            ]
        })
    });
};
var $cd4f198f0a3da66c$export$2e2bcd8739ae039 = $cd4f198f0a3da66c$var$ChatInput;


var $cf4f24c6f036da11$var$Chat = function(param) {
    var clientId = param.clientId, coachId = param.coachId, isCoach = param.isCoach;
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), chats = _useState[0], _setChats = _useState[1];
    var chatsRef = (0, $5s1kH.useRef)([]);
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(), 2), client = _useState1[0], setClient = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(), 2), coach = _useState2[0], setCoach = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState3[0], setLoaded = _useState3[1];
    var chatWindowRef = (0, $5s1kH.useRef)(null);
    var setChats = function(newChats) {
        chatsRef.current = newChats;
        _setChats(newChats);
    };
    var webSocketClient = (0, $5s1kH.useRef)((0, $da5ec3e0980c5bd3$export$2e2bcd8739ae039).getInstance());
    (0, $5s1kH.useEffect)(function() {
        var url = clientId ? "coach/chat/" + clientId + "/get" : "client/chat/" + coachId + "/get";
        api.get(url).then(function(result) {
            var _webSocketClient_current_webSocket;
            var chats = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = result.json.chats[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var chat = _step.value;
                    chat.dateSent = new Date(chat.dateSent);
                    if (chat.dateRead) chat.dateRead = new Date(chat.dateRead);
                    chats.push(chat);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            setClient(result.json.client);
            setCoach(result.json.coach);
            setChats(chats);
            setLoaded(true);
            (_webSocketClient_current_webSocket = webSocketClient.current.webSocket) === null || _webSocketClient_current_webSocket === void 0 ? void 0 : _webSocketClient_current_webSocket.addEventListener("message", messageListener);
        });
        return function() {
            var _webSocketClient_current_webSocket;
            (_webSocketClient_current_webSocket = webSocketClient.current.webSocket) === null || _webSocketClient_current_webSocket === void 0 ? void 0 : _webSocketClient_current_webSocket.removeEventListener("message", messageListener);
        };
    }, []);
    var sendReadAll = function() {
        var url = "client/chat/" + coachId + "/read_all";
        api.get(url).then(function() {
            return console.log("sent read");
        });
    };
    var messageListener = function(event) {
        var mess = JSON.parse(event.data);
        var fromId = isCoach ? "client_" + clientId : "coach_" + coachId;
        if (mess.chat && mess.fromId === fromId) {
            var newChat = {
                id: Math.floor(Math.random() * 1000000),
                text: mess.chat.message,
                sentByCoach: false,
                dateSent: new Date(),
                dateRead: new Date()
            };
            var newChats = (0, $XnYkK._)(chatsRef.current);
            newChats.push(newChat);
            setChats(newChats);
            sendReadAll();
        }
    };
    (0, $5s1kH.useEffect)(function() {
        if (chats.length > 0 && chatWindowRef.current) chatWindowRef.current.scrollTo(0, chatWindowRef.current.scrollHeight);
    }, [
        chats
    ]);
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading chats..."
    });
    var send = function(text) {
        if (text.length < 1) return;
        var url = isCoach ? "coach/chat/" + clientId + "/send" : "client/chat/" + coachId + "/send";
        var data = {
            text: text,
            sentByCoach: isCoach
        };
        api.post(url, data).then(function(result) {
            if (result.response.ok) {
                var chat = {
                    id: 0,
                    text: text,
                    sentByCoach: isCoach,
                    dateSent: new Date()
                };
                if (result.json.readBy && result.json.readBy > 0) chat.dateRead = new Date();
                var newChats = (0, $XnYkK._)(chats);
                newChats.push(chat);
                setChats(newChats);
                if (chatWindowRef.current) chatWindowRef.current.scrollTo(0, chatWindowRef.current.scrollHeight);
            }
        });
    };
    var chatInputHeightChange = function(height) {
        var _chatWindowRef_current;
        (_chatWindowRef_current = chatWindowRef.current) === null || _chatWindowRef_current === void 0 ? void 0 : _chatWindowRef_current.scrollTo(0, chatWindowRef.current.scrollHeight);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "h-full relative flex justify-between flex-col",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                ref: chatWindowRef,
                className: "overflow-y-scroll",
                children: chats.map(function(chat, index) {
                    var img = chat.sentByCoach ? coach && coach.picture ? coach.picture : (0, (/*@__PURE__*/$parcel$interopDefault($c69e28b19a456287$exports))) : client && client.picture ? client.picture : (0, (/*@__PURE__*/$parcel$interopDefault($c69e28b19a456287$exports)));
                    var name = chat.sentByCoach ? (coach === null || coach === void 0 ? void 0 : coach.firstName) + " " + (coach === null || coach === void 0 ? void 0 : coach.lastName) : (client === null || client === void 0 ? void 0 : client.firstName) + " " + (client === null || client === void 0 ? void 0 : client.lastName);
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "px-4 mt-4 flex",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                className: "picture-sm",
                                src: img,
                                alt: "pic"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "ml-4",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "font-medium",
                                                children: name
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                className: "text-gray-400 ml-4 text-sm",
                                                children: (0, $7d185b5883a21821$export$83d04527fc498dec)(chat.dateSent, lang)
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                className: "text-gray-400 ml-4 text-sm",
                                                children: [
                                                    lang === "sv" ? "L\xe4st" : "Read",
                                                    ":\xa0",
                                                    chat.dateRead ? (0, $7d185b5883a21821$export$83d04527fc498dec)(chat.dateRead, lang) : "-"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-gray-300 whitespace-pre-line",
                                        children: chat.text
                                    })
                                ]
                            })
                        ]
                    }, "chat_" + index);
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-800 mt-4"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cd4f198f0a3da66c$export$2e2bcd8739ae039), {
                        handleSendMessage: send,
                        onHeightChange: chatInputHeightChange
                    })
                ]
            })
        ]
    });
};
var $cf4f24c6f036da11$export$2e2bcd8739ae039 = $cf4f24c6f036da11$var$Chat;



parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");




var $5bbf212affcde812$var$NoNextMeetingCard = function() {
    var t = (0, $341d5702266247e0$export$9fc83ad70ead8663)().t;
    var navigate = (0, $bHX26.useNavigate)();
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c9f7bf3282a3b2ff$export$2e2bcd8739ae039), {
        className: "overflow-visible",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $8b128e0855661626$export$2e2bcd8739ae039), {
            className: "p-4 flex flex-col gap-4 overflow-visible",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-col py-4 gap-2 justify-center align-middle items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($c69e28b19a456287$exports))),
                            alt: "Calendar",
                            className: "w-8 h-8"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "z-body1 text-white whitespace-pre-line text-center",
                            children: t("select-coach")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    onClick: function() {
                        return navigate("/videocoach/match-with-coach");
                    },
                    children: t("match-with-coach")
                })
            ]
        })
    });
};
var $5bbf212affcde812$export$2e2bcd8739ae039 = $5bbf212affcde812$var$NoNextMeetingCard;


var $0705b46221f259e7$export$2e2bcd8739ae039 = (0, $5bbf212affcde812$export$2e2bcd8739ae039);



var $0ba24e04ac8ea6c5$exports = {};
$0ba24e04ac8ea6c5$exports = $parcel$resolve("7EkSV");








var $63410726a66068b9$var$VideocoachPage = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), nextMeetings = _useState[0], setNextMeetings = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), previousMeetings = _useState1[0], setPreviousMeetings = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(undefined), 2), activeMeeting = _useState2[0], setActiveMeeting = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), isLateCancellationModalOpen = _useState3[0], setIsLateCancellationModalOpen = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), isSuccessfullyCancelledModalOpen = _useState4[0], setIsSuccessfullyCancelledModalOpen = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), isConfirmCancellationModalOpen = _useState5[0], setIsConfirmCancellationModalOpen = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), coachData = _useState6[0], setCoachData = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), license = _useState7[0], setLicense = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showChat = _useState8[0], setShowChat = _useState8[1];
    var _useAtom = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$cde9a322e13eb845)), 2), unreadChats = _useAtom[0], setUnreadChats = _useAtom[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState9[0], setLoaded = _useState9[1];
    var now = new Date();
    (0, $5s1kH.useEffect)(function() {
        getStartData();
    }, []);
    var getStartData = function() {
        var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        var url = "client/coach_start";
        if (timezone) url += "?tz=" + timezone;
        api.get(url).then(function(response) {
            if (response.json.error === "No license") {
                setLoaded(true);
                return;
            }
            if (response.json.license) setLicense(response.json.license);
            if (response.json.coach) {
                setCoachData(response.json.coach);
                if (response.json.meetings) {
                    var prevM = [];
                    var nextM = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = response.json.meetings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var m = _step.value;
                            m.startDate = new Date(m.start);
                            if ((0, $7d185b5883a21821$export$2287e3d29250119e)(m.startDate, m.length) > now) nextM.push(m);
                            else prevM.push(m);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    setNextMeetings(nextM);
                    setPreviousMeetings(prevM);
                }
            }
            setLoaded(true);
        });
    };
    var openCancelModal = function(meeting) {
        if (!coachData) return; // Ensure coachData is available
        var latestCancellationDateTime = new Date(meeting.startDate);
        latestCancellationDateTime.setHours(latestCancellationDateTime.getHours() - coachData.cancelPolicy);
        setActiveMeeting(meeting);
        if (now < latestCancellationDateTime) setIsConfirmCancellationModalOpen(true);
        else setIsLateCancellationModalOpen(true);
    };
    var renderMeetingInfo = function() {
        if (nextMeetings.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $d9503866692825e9$export$2e2bcd8739ae039), {
            meetingData: nextMeetings,
            openCancelModal: openCancelModal,
            license: license
        });
        else {
            var remainingMeetings = license && license.remainingMeetings ? license.remainingMeetings : 0;
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c9f7bf3282a3b2ff$export$2e2bcd8739ae039), {
                className: "overflow-visible",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $8b128e0855661626$export$2e2bcd8739ae039), {
                    className: "p-4 flex flex-col gap-4 overflow-visible",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex flex-col py-4 gap-2 justify-center align-middle items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                    alt: "Calendar",
                                    className: "w-8 h-8"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-body1 text-white whitespace-pre-line text-center",
                                    children: remainingMeetings > 0 ? t("no-booked-meetings") : t("you-have-had-all-meetings")
                                })
                            ]
                        }),
                        remainingMeetings > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            onClick: function() {
                                return navigate("/videocoach/book-meeting");
                            },
                            children: t("book-meeting")
                        })
                    ]
                })
            });
        }
    };
    var cancelMeeting = function(meeting) {
        api.get("client/meeting_cancel/" + meeting.id).then(function(response) {
            getStartData();
            setIsLateCancellationModalOpen(false);
            setIsConfirmCancellationModalOpen(false);
            setIsSuccessfullyCancelledModalOpen(true);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (!license) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "main-content",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex flex-col h-full flex-grow min-h-0 gap-6 mt-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0ba24e04ac8ea6c5$exports))),
                    alt: "camera",
                    className: "w-8 h-8 mx-auto"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-col gap-2 text-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: lang === "sv" ? "Videocoaching \xe4r inte tillg\xe4ngligt p\xe5 ditt konto.Om du tror att detta \xe4r ett misstag, v\xe4nligen kontakta oss p\xe5" : "Video coaching isn\u2019t available on your account.If you believe this is a mistake, please contact us at"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("a", {
                                    href: "mailto:support@zebrain.se",
                                    style: {
                                        color: "#98AAF9",
                                        textDecoration: "underline"
                                    },
                                    children: "support@zebrain.se"
                                }),
                                " ",
                                lang === "sv" ? " - vi finns h\xe4r f\xf6r att hj\xe4lpa dig" : " - we\u2019re here to help."
                            ]
                        })
                    ]
                })
            ]
        })
    });
    if (!coachData) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "main-content",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex flex-col h-full flex-grow min-h-0 gap-6 mt-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                    className: "z-heading1 text-white",
                    children: t("video-coach-nav-title")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-title1 text-white",
                            children: t("my-coach")
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0705b46221f259e7$export$2e2bcd8739ae039), {})
                    ]
                })
            ]
        })
    });
    return(// <div className="flex flex-col h-full flex-grow min-h-0 mt-6">
    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "mt-6 z-heading1 text-white",
                children: t("video-coach-nav-title")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1 text-white",
                        children: t("booked-meetings")
                    }),
                    renderMeetingInfo()
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 z-title1 text-white",
                children: lang === "sv" ? "Coachingperiod" : "Coaching period"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-2 bg-indigo-900 rounded-md p-4",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1 text-white",
                        children: lang === "sv" ? "Periodens l\xe4ngd" : "Period duration"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between text-gray-400",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                children: lang === "sv" ? "Startdatum" : "Start date"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                children: (0, $7d185b5883a21821$export$5a252a405018366)(license.start)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between text-gray-400",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                children: lang === "sv" ? "Slutdatum" : "End date"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                children: (0, $7d185b5883a21821$export$5a252a405018366)(license.end)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "mt-4 border-indigo-700"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 z-title1 text-white",
                        children: lang === "sv" ? "Sessions\xf6versikt" : "Session overview"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between text-gray-400",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                children: lang === "sv" ? "Bokade" : "Booked"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                children: [
                                    license.consumedMeetings - license.hadMeetings,
                                    " \xa0 (",
                                    (0, $7d185b5883a21821$export$9a827e9be85de527)(license.consumedMeetingTime - license.hadMeetingTime),
                                    " ",
                                    "h)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between text-gray-400",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                children: lang === "sv" ? "Genomf\xf6rda" : "Completed"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                children: [
                                    license.hadMeetings,
                                    " (",
                                    (0, $7d185b5883a21821$export$9a827e9be85de527)(license.hadMeetingTime),
                                    " h)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between text-gray-400",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                children: lang === "sv" ? "\xc5terst\xe5ende" : "Remaining"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                children: [
                                    license.remainingMeetings,
                                    " (",
                                    (0, $7d185b5883a21821$export$9a827e9be85de527)(license.remainingCredits),
                                    " h)"
                                ]
                            })
                        ]
                    })
                ]
            }),
            previousMeetings.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1 text-white",
                        children: t("previous-meetings")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a2a2cdb2fb51cd3b$export$2e2bcd8739ae039), {
                        meetingData: previousMeetings
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1 text-white",
                        onClick: function() {
                            return setShowChat(!showChat);
                        },
                        children: t("my-coach")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "bg-indigo-900 rounded p-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        alt: "pic",
                                        className: "picture-lg",
                                        src: coachData.picture ? coachData.picture : (0, (/*@__PURE__*/$parcel$interopDefault($bf234ba9a155a985$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "ml-4 z-heading2",
                                        children: coachData.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-6",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($07ace4e0b313d326$exports))),
                                        alt: "chat",
                                        className: "w-4 h-4"
                                    }),
                                    buttonType: "outlineWhiteBase",
                                    className: "relative",
                                    onClick: function() {
                                        return navigate("/videocoach/chat/" + coachData.id);
                                    },
                                    children: [
                                        "Chat",
                                        unreadChats > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "inline h-2 w-2 rounded-full bg-cherry-500 absolute",
                                            style: {
                                                top: "19px",
                                                right: "calc(50% - 50px)"
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    onClick: function() {
                                        return navigate("/videocoach/my-coach");
                                    },
                                    children: lang === "sv" ? "L\xe4s mer" : "Read more"
                                })
                            })
                        ]
                    })
                ]
            }),
            showChat && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cf4f24c6f036da11$export$2e2bcd8739ae039), {
                isCoach: false,
                coachId: coachData.id
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $d66a4bb4587dd0d5$export$2e2bcd8739ae039), {
                isOpen: isLateCancellationModalOpen && activeMeeting != undefined,
                onClose: function() {
                    return setIsLateCancellationModalOpen(false);
                },
                coachName: coachData.name,
                cancelMeeting: function() {
                    return activeMeeting && cancelMeeting(activeMeeting);
                }
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $9b82a515029bbed6$export$2e2bcd8739ae039), {
                isOpen: isSuccessfullyCancelledModalOpen,
                onClose: function() {
                    return setIsSuccessfullyCancelledModalOpen(false);
                },
                coachName: coachData.name
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $fa5300e6fbb793c9$export$2e2bcd8739ae039), {
                isOpen: isConfirmCancellationModalOpen && activeMeeting !== null,
                onClose: function() {
                    return setIsConfirmCancellationModalOpen(false);
                },
                meeting: activeMeeting,
                coachName: coachData.name,
                cancelMeeting: function() {
                    return activeMeeting && cancelMeeting(activeMeeting);
                }
            })
        ]
    }));
};
var $63410726a66068b9$export$2e2bcd8739ae039 = $63410726a66068b9$var$VideocoachPage;


var $9b85048b9cc6fce9$export$2e2bcd8739ae039 = (0, $63410726a66068b9$export$2e2bcd8739ae039);



parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");

var $6c1a2d6fadc3342b$var$CoachChat = function() {
    var coachId = (0, $bHX26.useParams)().coachId;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "main-content",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "rounded",
            style: {
                height: "calc(100dvh - 200px)"
            },
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cf4f24c6f036da11$export$2e2bcd8739ae039), {
                isCoach: false,
                coachId: coachId
            })
        })
    });
};
var $6c1a2d6fadc3342b$export$2e2bcd8739ae039 = $6c1a2d6fadc3342b$var$CoachChat;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");


var $bHX26 = parcelRequire("bHX26");


parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");








var $38e7453622821c62$var$BookingSuccessModal = function(param) {
    var onClose = param.onClose, isOpen = param.isOpen, fromMeeting = param.fromMeeting, coachName = param.coachName, selectedDate = param.selectedDate, meetingId = param.meetingId;
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var navigate = (0, $bHX26.useNavigate)();
    if (!selectedDate) return null;
    // convert date to format dd monthname for example 18 nov
    var date = selectedDate.toLocaleDateString(lang, {
        day: 'numeric',
        month: 'long'
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title1",
                    children: meetingId ? t('meeting-changed') : t('meeting-booked')
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-col justify-between gap-3 ",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex flex-row justify-center",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($25e20653d8aa411d$exports))),
                                alt: "Cancel meeting",
                                className: "w-12 h-12 my-3"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex flex-row align-middle items-center gap-1",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "z-body1",
                                children: t('video-coaching-with', {
                                    coach: coachName
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex flex-row align-middle items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                    alt: "Cancel meeting",
                                    className: "w-6 h-6"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-body1",
                                    children: date
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex flex-row align-middle items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a72c3766ce7dfa42$exports))),
                                    alt: "Cancel meeting",
                                    className: "w-6 h-6"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-body1",
                                    children: (0, $7d185b5883a21821$export$5f885a9374f8e024)(selectedDate)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                children: fromMeeting ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    onClick: onClose,
                    buttonType: "outlineWhiteBase",
                    children: lang === 'sv' ? "St\xe4ng" : 'close'
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            onClick: onClose,
                            children: lang === 'sv' ? "Boka fler m\xf6ten" : 'Book more meetings'
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            onClick: function() {
                                return navigate('/videocoach');
                            },
                            buttonType: "outlineWhiteBase",
                            children: lang === 'sv' ? 'Tillbaka till videocoach-sidan' : 'Back to video coach page'
                        })
                    ]
                })
            })
        ]
    });
};
var $38e7453622821c62$export$2e2bcd8739ae039 = $38e7453622821c62$var$BookingSuccessModal;


var $b99a40dc7e309964$export$2e2bcd8739ae039 = (0, $38e7453622821c62$export$2e2bcd8739ae039);



parcelRequire("5s1kH");







var $95e49cf8f1f1e973$var$ConfirmBookingModal = function(param) {
    var onClickButton = param.onClickButton, onClose = param.onClose, isOpen = param.isOpen, coachName = param.coachName, selectedDate = param.selectedDate, meetingLength = param.meetingLength, meetingId = param.meetingId;
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    if (!selectedDate) return null;
    // convert date to format dd month name for example 18 nov
    var date = selectedDate.toLocaleDateString(lang, {
        day: 'numeric',
        month: 'long'
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title1",
                    children: meetingId ? t('change-meeting') : t('confirm-booking')
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-col justify-start align-middle gap-3 ",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex flex-row align-middle items-center gap-1",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                className: "z-body1",
                                children: [
                                    meetingId ? lang === 'sv' ? "Vill du \xe4ndra tiden f\xf6r m\xf6tet med " : 'Do you want to change the time for the videocoaching session with ' : lang === 'sv' ? "Vill du boka ett m\xf6te med " : 'Do you want to book a videocoaching session with ',
                                    coachName
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex flex-row align-middle items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                    alt: "Cancel meeting",
                                    className: "w-6 h-6"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-body1",
                                    children: date
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex flex-row align-middle items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a72c3766ce7dfa42$exports))),
                                    alt: "Cancel meeting",
                                    className: "w-6 h-6"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    className: "z-body1",
                                    children: [
                                        (0, $7d185b5883a21821$export$5f885a9374f8e024)(selectedDate),
                                        meetingLength && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                            className: "ml-1",
                                            children: [
                                                "(",
                                                meetingLength,
                                                " ",
                                                lang === "sv" ? "minuter" : "minutes",
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex w-full",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            onClick: onClose,
                            buttonType: "outlineWhiteBase",
                            children: t('cancel')
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            onClick: onClickButton,
                            className: "ml-4",
                            children: t('confirm')
                        })
                    ]
                })
            })
        ]
    });
};
var $95e49cf8f1f1e973$export$2e2bcd8739ae039 = $95e49cf8f1f1e973$var$ConfirmBookingModal;


var $6adf0dcde6d4f7cf$export$2e2bcd8739ae039 = (0, $95e49cf8f1f1e973$export$2e2bcd8739ae039);



parcelRequire("5s1kH");


var $ff3ee25fc0ebbf5f$exports = {};
$ff3ee25fc0ebbf5f$exports = $parcel$resolve("nMzLV");


var $617c8bedbcfb3504$exports = {};
$617c8bedbcfb3504$exports = $parcel$resolve("iWlrI");



var $46f63211c5ad15b6$var$Banner = function(param) {
    var selectedDate = param.selectedDate, coachName = param.coachName, title = param.title, close = param.close;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "flex flex-col gap-4 bg-gray-200 text-indigo-1000 rounded-md border border-transparent p-4",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-row justify-between gap-2 align-middle items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($617c8bedbcfb3504$exports))),
                        alt: "calendar icon",
                        className: "w-6 h-6"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "z-title2 grow",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ff3ee25fc0ebbf5f$exports))),
                        alt: "calendar icon",
                        className: "w-6 h-6 cursor-pointer",
                        onClick: function() {
                            return close();
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-row justify-between gap-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "z-title3 grow",
                        children: coachName
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                alt: "calendar icon",
                                className: "w-6 h-6"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "z-title3 text-center",
                                children: (0, $7d185b5883a21821$export$1c7501cd03a59e59)(selectedDate, false, "sv")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a72c3766ce7dfa42$exports))),
                                alt: "calendar icon",
                                className: "w-6 h-6"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "z-title3 text-center",
                                children: (0, $7d185b5883a21821$export$5f885a9374f8e024)(selectedDate)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $46f63211c5ad15b6$export$2e2bcd8739ae039 = $46f63211c5ad15b6$var$Banner;


var $4c7669706cfc125d$export$2e2bcd8739ae039 = (0, $46f63211c5ad15b6$export$2e2bcd8739ae039);




var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $e8981ef41dc6cb1b$exports = {};
$e8981ef41dc6cb1b$exports = $parcel$resolve("caAua");


var $afc401be3ae3d49c$var$DatePicker = function(param) {
    var dates = param.dates, clickDate = param.clickDate, preSelectedDate = param.preSelectedDate;
    var today = new Date();
    var thisDay = preSelectedDate ? preSelectedDate : today;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(thisDay.getMonth()), 2), currentMonth = _useState[0], setCurrentMonth = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(thisDay.getFullYear()), 2), currentYear = _useState1[0], setCurrentYear = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(preSelectedDate ? {
        day: preSelectedDate.getDate(),
        month: preSelectedDate.getMonth(),
        year: preSelectedDate.getFullYear()
    } : null), 2), selectedDate = _useState2[0], setSelectedDate = _useState2[1]; // Track selected date
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), paddingDays = _useState3[0], setPaddingDays = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)("48px"), 2), columnGap = _useState4[0], setColumnGap = _useState4[1];
    var containerRef = (0, $5s1kH.useRef)(null);
    // Define event dates (adjust the dates as needed)
    var eventDates = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = dates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var d = _step.value;
            eventDates.push({
                day: d.getDate(),
                month: d.getMonth(),
                year: d.getFullYear()
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    var daysInMonth = function(month, year) {
        return new Date(year, month + 1, 0).getDate();
    };
    var weekDayOfFirst = function(month, year) {
        var dayOfWeek = new Date(year, month, 1).getDay();
        // Sunday is day 0 in javascript :-/
        // Translate so that Monday is 0 and Sunday is 6
        if (dayOfWeek === 0) // Javascript day 0 is Sunday - return 6
        return 6;
        else return dayOfWeek - 1;
    };
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), days = _useState5[0], setDays = _useState5[1];
    (0, $5s1kH.useEffect)(function() {
        setDays(Array.from({
            length: daysInMonth(currentMonth, currentYear)
        }, function(_, i) {
            return i + 1;
        }));
        var weekDay = weekDayOfFirst(currentMonth, currentYear);
        setPaddingDays(Array.from({
            length: weekDay
        }, function(_, i) {
            return i + 1;
        }));
    }, [
        currentMonth,
        currentYear
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (preSelectedDate) {
            var year = preSelectedDate.getFullYear();
            var month = preSelectedDate.getMonth();
            var day = preSelectedDate.getDate();
            var newDate = {
                day: day,
                month: month,
                year: year
            };
            setSelectedDate(newDate);
            setCurrentMonth(month);
            setCurrentYear(year);
        }
    }, [
        preSelectedDate
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (containerRef) {
            var w = containerRef.current ? containerRef.current.clientWidth : 500;
            if (w < 636) {
                // Space between calendar cols: width - 312 / 6, where 312 is cols with + margin and
                // 6 is nr of spaces between cols*/
                var colGap = w / 6 - 52;
                setColumnGap(colGap + "px");
            }
        }
    }, [
        containerRef
    ]);
    // Check if the day has an event
    var hasEvent = function(day) {
        return eventDates.some(function(event) {
            return event.day === day && event.month === currentMonth && event.year === currentYear;
        });
    };
    // Handle date click event
    var handleDateClick = function(day) {
        setSelectedDate({
            day: day,
            month: currentMonth,
            year: currentYear
        }); // Store selected date
        clickDate(new Date(currentYear, currentMonth, day));
    };
    // Handle previous month click
    var handlePreviousMonth = function() {
        // if (changeMonth) {
        //   changeMonth()
        // }
        clickDate(null);
        if (currentMonth === 0) {
            setCurrentMonth(11);
            setCurrentYear(function(prev) {
                return prev - 1;
            }); // Decrement year if going back from January
        } else setCurrentMonth(function(prev) {
            return prev - 1;
        });
    };
    // Handle next month click
    var handleNextMonth = function() {
        // if (changeMonth) {
        //   changeMonth()
        // }
        clickDate(null);
        if (currentMonth === 11) {
            setCurrentMonth(0);
            setCurrentYear(function(prev) {
                return prev + 1;
            }); // Increment year if going forward from December
        } else setCurrentMonth(function(prev) {
            return prev + 1;
        });
    };
    var dayClasses = function(day) {
        var classes = "relative mb-4 size-10 flex flex-col justify-center items-center border border-transparent font-medium rounded-full hover:bg-sky-500 hover:text-white";
        if (selectedDate && day === selectedDate.day && currentMonth === selectedDate.month && currentYear === selectedDate.year) classes += " bg-sky-500 text-white";
        else classes += " text-gray-400";
        if (hasEvent(day)) classes += " border-white";
        return classes;
    };
    var todayDot = function(day) {
        if (day === today.getDate() && currentMonth === today.getMonth() && currentYear === today.getFullYear()) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
            className: "absolute bottom-1 w-0.5 h-0.5 bg-white rounded-full"
        });
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {});
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "sm:flex",
        ref: containerRef,
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "space-y-0.5 w-full",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "grid grid-cols-5 items-center gap-x-3 pb-3",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "col-span-1",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("button", {
                                type: "button",
                                onClick: handlePreviousMonth,
                                className: "size-8 flex justify-center items-center text-white hover:bg-indigo-700 rounded-full",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    alt: "left",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b831c536d594a009$exports))),
                                    className: "h-6"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "col-span-3 flex justify-center items-center gap-x-1 z-title1",
                            children: [
                                months[currentMonth],
                                " ",
                                currentYear
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "col-span-1 flex justify-end",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("button", {
                                type: "button",
                                onClick: handleNextMonth,
                                className: "size-8 flex justify-center items-center text-white hover:bg-indigo-700 rounded-full",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    alt: "right",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e8981ef41dc6cb1b$exports))),
                                    className: "h-6"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "grid grid-cols-7 pb-2.5",
                    style: {
                        columnGap: columnGap
                    },
                    children: [
                        "Mo",
                        "Tu",
                        "We",
                        "Th",
                        "Fr",
                        "Sa",
                        "Su"
                    ].map(function(day) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                            className: "m-px w-10 block text-center font-medium text-white",
                            children: day
                        }, day);
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "grid grid-cols-7",
                    style: {
                        columnGap: columnGap
                    },
                    children: [
                        paddingDays.map(function(paddingDay) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {}, "p_" + paddingDay);
                        }),
                        days.map(function(day) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("button", {
                                onClick: function() {
                                    return handleDateClick(day);
                                },
                                className: dayClasses(day),
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                        children: day
                                    }),
                                    todayDot(day)
                                ]
                            }, day);
                        })
                    ]
                })
            ]
        })
    });
};
var $afc401be3ae3d49c$export$2e2bcd8739ae039 = $afc401be3ae3d49c$var$DatePicker;




var $7a74b393d0a945b3$var$BookMeetingPage = function(param) {
    var fromMeeting = param.fromMeeting, close = param.close;
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var queryParams = new URLSearchParams(window.location.search);
    var meetingId = queryParams.get('meeting_id');
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), bookedMeeting = _useState2[0], setBookedMeeting = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), selectedDate = _useState3[0], setSelectedDate = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), bookableDays = _useState4[0], setBookableDays = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), meetingDate = _useState5[0], setMeetingDate = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), timeslots = _useState6[0], setTimeslots = _useState6[1]; // To be fetched from backend
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(), 2), coach = _useState7[0], setCoach = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), isConfirmBookingModalOpen = _useState8[0], setIsConfirmBookingModalOpen = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), isBookingSuccessModalOpen = _useState9[0], setIsBookingSuccessModalOpen = _useState9[1];
    (0, $5s1kH.useEffect)(function() {
        fetchAvailableTimes();
    }, []);
    var fetchAvailableTimes = function() {
        var url = 'client/meeting_availability';
        if (meetingId) url += '?meeting_id=' + meetingId;
        api.get(url).then(function(response) {
            if (response.json.error) setError(response.json.error);
            else {
                var timeslots = [];
                var _bookableDays = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = response.json.timeslots[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var timeslot = _step.value;
                        timeslot.startDate = new Date(timeslot.start);
                        timeslot.endDate = new Date(timeslot.end);
                        timeslots.push(timeslot);
                        _bookableDays.push(timeslot.startDate);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                setCoach(response.json.coach);
                setTimeslots(timeslots);
                if (response.json.bookedMeeting) {
                    var bookedMeeting = response.json.bookedMeeting;
                    bookedMeeting.startDate = new Date(bookedMeeting.start);
                    bookedMeeting.endDate = new Date(bookedMeeting.end);
                    setBookedMeeting(bookedMeeting);
                }
                setBookableDays(_bookableDays);
            }
            setLoaded(true);
        });
    };
    var closeBooking = function() {
        if (close) ;
        else navigate('/videocoach');
    };
    var closeWindow = function() {
        setIsBookingSuccessModalOpen(false);
        if (fromMeeting && close) close();
    };
    var bookMeeting = function() {
        if (!meetingDate || !coach) return;
        var data = {
            from: meetingDate,
            length: coach.meetingLength,
            id: meetingId ? meetingId : "0"
        };
        api.post('client/meeting_book', data).then(function() {
            setIsBookingSuccessModalOpen(true);
            fetchAvailableTimes();
        });
    };
    var getBookableMeetings = function(day) {
        var startEvents = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = timeslots[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var timeslot = _step.value;
                if (timeslot.startDate.getFullYear() != day.getFullYear() || timeslot.startDate.getMonth() != day.getMonth() || timeslot.startDate.getDate() != day.getDate()) continue;
                startEvents.push(timeslot.startDate);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return startEvents;
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        children: "Loading..."
    });
    if (error) {
        var errorMsg = error;
        if (error === 'bookable_after_first_meeting') errorMsg = lang === 'sv' ? "Du kan boka fler m\xf6ten efter ditt f\xf6rsta m\xf6te." : 'You will be able to book more meetings after your first session.';
        else if (error === 'no_remaining_meetings') {
            // Client has booked all meetings, send them to video coach start page
            if (fromMeeting) errorMsg = lang === 'sv' ? "Du har bokat alla dina m\xf6ten." : 'You have booked all your meetings.';
            else navigate('/videocoach');
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "main-content",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title1 text-white",
                    children: lang === 'sv' ? "Du kan inte boka m\xf6te" : 'You cannot book a meeting'
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2",
                    children: errorMsg
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            bookedMeeting && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $4c7669706cfc125d$export$2e2bcd8739ae039), {
                selectedDate: bookedMeeting.startDate,
                coachName: coach ? coach.firstName : "Unknown",
                close: function() {
                    return closeBooking();
                },
                title: t('change-meeting')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "z-title1 text-white",
                children: t('select-datetime')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $afc401be3ae3d49c$export$2e2bcd8739ae039), {
                dates: bookableDays,
                clickDate: function(d) {
                    return setSelectedDate(d);
                },
                preSelectedDate: selectedDate
            }),
            selectedDate ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex justify-between items-end",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title1",
                                children: lang === 'sv' ? 'Lediga tider' : 'Available times'
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "flex",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "ml-2",
                                    children: (0, $7d185b5883a21821$export$1c7501cd03a59e59)(selectedDate, false, lang)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "grid grid-cols-3 gap-x-2",
                        children: getBookableMeetings(selectedDate).map(function(d, i) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    onClick: function() {
                                        setMeetingDate(d);
                                        setIsConfirmBookingModalOpen(true);
                                    },
                                    className: "w-full",
                                    children: (0, $7d185b5883a21821$export$5f885a9374f8e024)(d)
                                })
                            }, "time_" + i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-8",
                children: lang === 'sv' ? "V\xe4lj inringat datum (d\xe4r det finns m\xf6testider)" : 'Choose circled date (where there are available meeting times)'
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $6adf0dcde6d4f7cf$export$2e2bcd8739ae039), {
                isOpen: isConfirmBookingModalOpen,
                onClose: function() {
                    return setIsConfirmBookingModalOpen(false);
                },
                selectedDate: meetingDate,
                coachName: coach ? coach.firstName : "Unknown",
                meetingId: meetingId,
                meetingLength: coach === null || coach === void 0 ? void 0 : coach.meetingLength,
                onClickButton: function() {
                    bookMeeting();
                    setIsConfirmBookingModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b99a40dc7e309964$export$2e2bcd8739ae039), {
                isOpen: isBookingSuccessModalOpen,
                fromMeeting: fromMeeting,
                onClose: function() {
                    return closeWindow();
                },
                selectedDate: meetingDate,
                coachName: coach ? coach.firstName : "Unknown",
                meetingId: meetingId
            })
        ]
    });
};
var $7a74b393d0a945b3$export$2e2bcd8739ae039 = $7a74b393d0a945b3$var$BookMeetingPage;


var $df1a61476d24305b$export$2e2bcd8739ae039 = (0, $7a74b393d0a945b3$export$2e2bcd8739ae039);



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");


var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $33c119e8adb17596$var$ProgressCircle = function(props) {
    var containerRef = (0, $5s1kH.useRef)(null);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)("100px"), 2), dashWidth = _useState[0], setDashWidth = _useState[1];
    (0, $5s1kH.useEffect)(function() {
        if (containerRef) {
            var w = containerRef.current ? containerRef.current.clientWidth : 500;
            if (w < 636) {
                // Space between calendar cols: width - 312 / 6, where 312 is cols with + margin and
                // 6 is nr of spaces between cols*/
                var colGap = w / (props.stepsDone.length - 1) - 24;
                setDashWidth(colGap + "px");
            }
        }
    }, [
        containerRef
    ]);
    var click = function(done, index) {
        props.changeStep(index);
    };
    var getClass = function(done, index) {
        var baseClass = "rounded-full h-6 w-6 flex items-center justify-center cursor-pointer ";
        if (done) return baseClass + "bg-success-500 text-black";
        else if (index === props.step) return baseClass + "bg-success-300 text-black";
        else return baseClass + "bg-indigo-800";
    };
    var getDashClass = function(done, index) {
        var baseClass = "h-0.5 ";
        if (props.stepsDone[index - 1] || props.step >= index) return baseClass + "bg-success-500";
        return baseClass + "bg-indigo-800";
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "flex items-center",
        ref: containerRef,
        children: props.stepsDone.map(function(stepDone, index) {
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex items-center",
                children: [
                    index > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: getDashClass(stepDone, index),
                            style: {
                                width: dashWidth
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: getClass(stepDone, index),
                        onClick: function() {
                            return click(stepDone, index);
                        },
                        children: stepDone ? index === props.step ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: index + 1
                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
                            alt: "done"
                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: index + 1
                        })
                    })
                ]
            }, "step_" + index);
        })
    });
};
var $33c119e8adb17596$export$2e2bcd8739ae039 = $33c119e8adb17596$var$ProgressCircle;


var $2d9db0ddc8faf3d7$export$2e2bcd8739ae039 = (0, $33c119e8adb17596$export$2e2bcd8739ae039);



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");


var $bHX26 = parcelRequire("bHX26");






parcelRequire("5s1kH");


var $9303e4f3edd1259a$var$LeadershipInfoInfoModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var isSwedish = i18n.language === 'sv';
    var textPart1 = isSwedish ? 'Chef med teamansvar:' : 'Manager with team responsibility:';
    var textPart2 = isSwedish ? "Hanterar samarbete och operativa m\xe5l." : 'Managing collaboration and operational goals.';
    var textPart3 = isSwedish ? 'Chef med personalansvar:' : 'Manager with personnel responsibility:';
    var textPart4 = isSwedish ? "\xd6vervakar rekrytering, prestanda och karri\xe4r." : 'Overseeing hiring, performance, and careers.';
    var textPart5 = isSwedish ? "C-niv\xe5 chef:" : 'C-level executive:';
    var textPart6 = isSwedish ? "Hanterar beslut p\xe5 h\xf6g niv\xe5." : 'Managing high-level decision-making.';
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title1",
                    children: t('leadership-levels')
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "z-title2",
                            children: textPart1
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "z-body2",
                            children: textPart2
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "z-title2",
                            children: textPart3
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "z-body2",
                            children: textPart4
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "z-title2",
                            children: textPart5
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "z-body2",
                            children: textPart6
                        })
                    ]
                })
            })
        ]
    });
};
var $9303e4f3edd1259a$export$2e2bcd8739ae039 = $9303e4f3edd1259a$var$LeadershipInfoInfoModal;


var $60703c6782defd70$export$2e2bcd8739ae039 = (0, $9303e4f3edd1259a$export$2e2bcd8739ae039);



parcelRequire("5s1kH");
function $8cfe161fda2bc9c2$var$MaskedIcon(param) {
    var src = param.src, className = param.className;
    var classes = "\n    mask-svg\n    group-hover:text-gray-400\n    ".concat(className, "\n  ");
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
        className: classes,
        style: {
            maskImage: "url(".concat(src, ")"),
            WebkitMaskImage: "url(".concat(src, ")")
        }
    });
}
var $8cfe161fda2bc9c2$export$2e2bcd8739ae039 = $8cfe161fda2bc9c2$var$MaskedIcon;


var $8000ec2b9d404ecc$export$2e2bcd8739ae039 = (0, $8cfe161fda2bc9c2$export$2e2bcd8739ae039);


var $49415595f6012045$exports = {};
$49415595f6012045$exports = $parcel$resolve("dLF6p");




var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");



var $03910c02f50343b6$var$EditPicture = function(param) {
    var picture = param.picture, close = param.close, lang = param.lang, who = param.who;
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var rawImage = (0, $5s1kH.useRef)(null);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(''), 2), renderedPic = _useState[0], setRenderedPic = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), pictureChanged = _useState1[0], setPictureChanged = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(100), 2), scale = _useState2[0], setScale = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), offsetX = _useState3[0], setOffsetX = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), offsetY = _useState4[0], setOffsetY = _useState4[1];
    (0, $5s1kH.useEffect)(function() {
        if (picture) api.getRaw(who + '/picture').then(function(response) {
            var reader = response.body.getReader();
            return new ReadableStream({
                start: function(controller) {
                    return pump();
                    function pump() {
                        return reader.read().then(function(param) {
                            var done = param.done, value = param.value;
                            // When no more data needs to be consumed, close the stream
                            if (done) {
                                controller.close();
                                return;
                            }
                            // Enqueue the next data chunk into our target stream
                            controller.enqueue(value);
                            return pump();
                        });
                    }
                }
            });
        })// Create a new response out of the stream
        .then(function(stream) {
            return new Response(stream);
        })// Create an object URL for the response
        .then(function(response) {
            return response.blob();
        }).then(function(blob) {
            return URL.createObjectURL(blob);
        })// Update image
        .then(function(url) {
            return createRawImage(url);
        }).catch(function(err) {
            return console.error(err);
        });
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (rawImage.current) {
            setPictureChanged(true);
            renderFromRaw();
        }
    }, [
        scale,
        offsetX,
        offsetY
    ]);
    var createRawImage = function(src) {
        var img = document.createElement("img");
        img.classList.add("hidden");
        img.src = src;
        rawImage.current = img;
        img.addEventListener("load", function(e) {
            renderFromRaw();
        });
    };
    var renderFromRaw = function() {
        if (rawImage.current === null) {
            console.log('rawImage not loaded yet');
            return;
        }
        var canvas = document.createElement('canvas');
        canvas.width = 300;
        canvas.height = 300;
        var ctx = canvas.getContext('2d');
        var nWidth = rawImage.current.naturalWidth;
        var nHeight = rawImage.current.naturalHeight;
        var iWidth = rawImage.current.width;
        var iHeight = rawImage.current.height;
        var cx = iWidth / 2;
        var cy = iHeight / 2;
        var radius = 100 / scale * Math.min(iWidth, iHeight) / 2;
        var sWidth = 2 * radius * nWidth / iWidth;
        var sHeight = 2 * radius * nHeight / iHeight;
        var sx = (cx - radius) * nWidth / iWidth;
        var sy = (cy - radius) * nHeight / iHeight;
        if (offsetX != 0) sx = sx + offsetX * sx / 50;
        if (offsetY != 0) sy = sy - offsetY * sy / 50;
        if (ctx !== null) {
            ctx.drawImage(rawImage.current, sx, sy, sWidth, sHeight, 0, 0, 300, 300);
            setRenderedPic(canvas.toDataURL('image/jpeg'));
        }
    };
    var saveImage = function() {
        var data = {
            file_data: renderedPic
        };
        api.post(who + '/upload/picture', data).then(function(result) {
            close(result.json.fileName);
        });
    };
    var uploadImage = function(evt) {
        if (evt === null) {
            alert('Empty event');
            return;
        }
        var picFile = evt.target.files[0];
        if (!picFile) {
            console.log('No pic file');
            return;
        }
        if (!picFile.type.match('image.*')) {
            alert('This is not an image');
            return;
        }
        var reader = new FileReader();
        reader.onload = function(theFile) {
            return function(e) {
                setPictureChanged(true);
                createRawImage(e.target.result);
            };
        }(picFile);
        reader.readAsDataURL(picFile);
    };
    var moveDisabled = scale === 100;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: function() {
                return close(pictureChanged);
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return close(pictureChanged);
                    },
                    children: lang === 'sv' ? 'Profilbild' : 'Profile picture'
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                        children: [
                            renderedPic.length > 0 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "flex justify-center mt-4 overflow-hidden",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            alt: "picture",
                                            style: {
                                                borderRadius: "50%"
                                            },
                                            src: renderedPic
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "mt-6 mx-auto",
                                        style: {
                                            width: 300
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                children: lang === 'sv' ? 'Flytta ner/upp' : 'Move down/up'
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                                className: "mt-2 w-full",
                                                type: "range",
                                                disabled: moveDisabled,
                                                min: "-50",
                                                max: "50",
                                                value: offsetY,
                                                onChange: function(e) {
                                                    return setOffsetY(parseInt(e.target.value));
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "mt-4",
                                                children: lang === 'sv' ? "Flytta v\xe4nster/h\xf6ger" : 'Move left/right'
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                                className: "mt-2 w-full",
                                                disabled: moveDisabled,
                                                type: "range",
                                                min: "-50",
                                                max: "50",
                                                value: offsetX,
                                                onChange: function(e) {
                                                    return setOffsetX(parseInt(e.target.value));
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "mt-4",
                                                children: lang === 'sv' ? 'Zooma in/ut' : 'Zoom in/out'
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                                className: "mt-2 w-full",
                                                type: "range",
                                                min: "100",
                                                max: "600",
                                                value: scale,
                                                onChange: function(e) {
                                                    return setScale(parseInt(e.target.value));
                                                },
                                                id: "myRange"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                style: {
                                    width: "300px",
                                    height: "300px"
                                },
                                className: "p-4",
                                children: "\xa0"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "cursor-pointer mt-4 flex justify-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                        id: "profileFile",
                                        type: "file",
                                        className: "hidden",
                                        onChange: function(e) {
                                            return uploadImage(e);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("label", {
                                        htmlFor: "profileFile",
                                        className: "underline cursor-pointer",
                                        children: lang === 'sv' ? pictureChanged ? "Klicka h\xe4r f\xf6r att v\xe4lja ny bild" : "Klicka h\xe4r f\xf6r att v\xe4lja bild" : pictureChanged ? 'Click here to select new picture' : 'Click here to select picture'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: pictureChanged ? 'visible' : 'invisible',
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    className: "mt-4 w-full",
                                    onClick: function() {
                                        return saveImage();
                                    },
                                    children: "Spara"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $03910c02f50343b6$export$2e2bcd8739ae039 = $03910c02f50343b6$var$EditPicture;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $9bdfb8bb1dda4858$exports = {};
$9bdfb8bb1dda4858$exports = $parcel$resolve("a4YVE");





var $90e74421d35d2c58$var$valid_content_types = [
    "application/pdf",
    "text/plain",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];
var $90e74421d35d2c58$var$ClientFiles = function(props) {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), clientFiles = _useState[0], setClientFiles = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), fileChanged = _useState1[0], setFileChanged = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), fileData = _useState2[0], setFileData = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), filename = _useState3[0], setFilename = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), uploading = _useState4[0], setUploading = _useState4[1];
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get("client/client_files").then(function(response) {
            setClientFiles(response.json.clientFiles);
        });
    };
    var uploadImage = function(evt) {
        if (evt === null) {
            alert('Empty event');
            return;
        }
        var clientFile = evt.target.files[0];
        if (!clientFile) {
            console.log('No file');
            return;
        }
        if ($90e74421d35d2c58$var$valid_content_types.indexOf(clientFile.type) === -1) {
            alert('This is not a valid file: ' + clientFile.type + '. Upload a pdf, a word document or plain text.');
            return;
        }
        setFilename(clientFile.name);
        var reader = new FileReader();
        reader.onload = function(theFile) {
            return function(e) {
                setFileChanged(true);
                setFileData(e.target.result);
            };
        }(clientFile);
        reader.readAsDataURL(clientFile);
    };
    var save = function() {
        setUploading(true);
        var data = {
            file_name: filename,
            file_data: fileData
        };
        api.post('client/upload/file', data).then(function(result) {
            setFileChanged(false);
            setFileData("");
            setFilename("");
            setUploading(false);
            getData();
        });
    };
    var askDelete = function(fileId) {
        if (confirm("Are you sure you want to delete this file?")) api.get("client/client_file_delete/" + fileId).then(function(response) {
            getData();
        });
    };
    var getFile = function(fileId, customer) {
        var url = (0, $632c75b97b900307$export$1630b5343357e8b5).API_ENDPOINT + (customer ? "client/vector_file/" : "client/client_file_get/") + fileId;
        api.getRaw(url).then(function(response) {
            response.blob().then(function(data) {
                var _type = data.type === "text/plain" ? "text/plain; charset=UTF-8" : data.type;
                var file = new Blob([
                    data
                ], {
                    type: _type
                });
                var fileUrl = URL.createObjectURL(file);
                window.open(fileUrl, "_blank");
            });
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-6 z-heading2",
                children: props.lang === "sv" ? "Mina dokument" : "My documents"
            }),
            clientFiles.map(function(cf) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2 flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "z-link",
                            onClick: function() {
                                return getFile(cf.id, false);
                            },
                            children: cf.filename
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                            alt: "delete",
                            className: "h-8 w-8 p-1 rounded-full hover:bg-indigo-800 cursor-pointer",
                            onClick: function() {
                                return askDelete(cf.id);
                            }
                        })
                    ]
                }, "cf_" + cf.id);
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 p-4 border border-dashed border-indigo-800 flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                id: "profileFile",
                                type: "file",
                                className: "hidden",
                                onChange: function(e) {
                                    return uploadImage(e);
                                }
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("label", {
                                htmlFor: "profileFile",
                                className: "underline cursor-pointer",
                                children: props.lang === 'sv' ? fileChanged ? 'Byt fil' : "V\xe4lj fil" : fileChanged ? 'Change file' : 'Choose file'
                            })
                        ]
                    }),
                    filename && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: filename
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: uploading ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center p-3 rounded-md gap-x-2",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9bdfb8bb1dda4858$exports))),
                                    alt: "thinking",
                                    className: "h-6 w-6"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-body1",
                                    children: "Uploading and summarizing..."
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            disabled: !fileChanged,
                            onClick: function() {
                                return save();
                            },
                            children: props.lang === "sv" ? "Ladda upp" : "Upload"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-6 z-heading2",
                children: props.lang === "sv" ? "F\xf6retagsinformation" : "Company Information"
            }),
            props.customerFiles.map(function(cf) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "z-link mt-2",
                    onClick: function() {
                        return getFile(cf.id, true);
                    },
                    children: cf.filename
                }, "cf_" + cf.id);
            }),
            props.customerFiles.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "z-body1",
                children: props.lang === "sv" ? "Nothing uploaded" : "Inga uppladdade filer"
            })
        ]
    });
};
var $90e74421d35d2c58$export$2e2bcd8739ae039 = $90e74421d35d2c58$var$ClientFiles;





var $10b3628602320bf1$var$leadershipLevels = [
    "non-managerial",
    "manager_team",
    "c_level"
];
var $10b3628602320bf1$var$Profile = function(props) {
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.profile.inCompanySince), 2), inCompanySince = _useState[0], setInCompanySince = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(props.profile.currentRoleSince), 2), currentRoleSince = _useState1[0], setCurrentRoleSince = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(props.profile.title), 2), title = _useState2[0], setTitle = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(props.profile.roleDescription), 2), roleDescription = _useState3[0], setRoleDescription = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(props.profile.aboutMe), 2), aboutMe = _useState4[0], setAboutMe = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(props.profile.leadershipLevel), 2), leadershipLevel = _useState5[0], setLeadershipLevel = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showInfoModal = _useState6[0], setShowInfoModal = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(props.profile.picture), 2), picture = _useState7[0], setPicture = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), editPicture = _useState8[0], setEditPicture = _useState8[1];
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var thisYear = new Date().getFullYear();
    var _useAtom = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$f6340943ad252ff2)), 2), navPicture = _useAtom[0], setNavPicture = _useAtom[1];
    var makeRange = function(from, to) {
        var step = from > to ? -1 : 1;
        var length = from > to ? from - to : to - from;
        return Array.from({
            length: length + 1
        }, function(v, k) {
            return from + k * step;
        });
    };
    var notValid = function() {
        if (inCompanySince === 0) return true;
        if (currentRoleSince === 0) return true;
        if (title.length < 1) return true;
        return false;
    };
    var save = function() {
        var newProfile = props.profile;
        newProfile.inCompanySince = inCompanySince;
        newProfile.currentRoleSince = currentRoleSince;
        newProfile.leadershipLevel = leadershipLevel;
        newProfile.title = title;
        newProfile.roleDescription = roleDescription;
        newProfile.aboutMe = aboutMe;
        props.save(newProfile);
    };
    var closeEditPicture = function(pic) {
        if (pic && pic.length > 0) {
            setPicture(pic);
            setNavPicture(pic);
            props.profile.picture = pic;
        }
        setEditPicture(false);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            editPicture && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $03910c02f50343b6$export$2e2bcd8739ae039), {
                picture: picture,
                close: closeEditPicture,
                lang: lang,
                who: "client"
            }),
            props.standalone ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-6 z-heading2",
                        children: t("my-account")
                    }),
                    props.profile.hasCoachUser && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 z-link",
                        onClick: function() {
                            return (0, $632c75b97b900307$export$70b209735b7809eb)("coach");
                        },
                        children: lang === "sv" ? "Byt till ditt coach-konto" : "Switch to your coach account"
                    })
                ]
            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-6 z-heading2",
                        children: t("professional-details")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-6 text-gray-400",
                        children: t("coaching-experience")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-6 relative cursor-pointer bg-white rounded-full",
                        onClick: function() {
                            return setEditPicture(true);
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                className: "picture-lg " + (picture ? "" : "p-3"),
                                alt: "pic",
                                src: picture ? picture : (0, (/*@__PURE__*/$parcel$interopDefault($c69e28b19a456287$exports)))
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "ml-4 flex item-center justify-center cursor-pointer rounded-[20px] hover:bg-indigo-700 bg-indigo-800 p-1",
                                style: {
                                    position: "absolute",
                                    zIndex: 10,
                                    bottom: "0px",
                                    right: "0px"
                                },
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    alt: "pic-icon",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($49415595f6012045$exports)))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: "\xa0"
                    })
                ]
            }),
            props.profile.clientName && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4",
                children: props.profile.clientName
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: t("title-role")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                value: title,
                placeholder: t("title-placeholder"),
                className: "z-input mt-2",
                onChange: function(e) {
                    return setTitle(e.target.value);
                }
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: lang === "sv" ? "Rollbeskrivning" : "Role description"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                value: roleDescription,
                placeholder: lang === "sv" ? "Beskriv dina arbetsuppgifter" : "Describe your work tasks",
                className: "z-input mt-2",
                onChange: function(e) {
                    return setRoleDescription(e.target.value);
                }
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex flex-row items-center gap-1 p-1",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: t("select-leadership-level")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        onClick: function() {
                            return setShowInfoModal(true);
                        },
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                            alt: "Info",
                            className: "h-6 w-6 hover:bg-indigo-700 rounded-[20px] p-1"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("select", {
                className: "mt-2 z-select",
                value: leadershipLevel,
                onChange: function(e) {
                    return setLeadershipLevel(e.target.value);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: "",
                        children: t("select")
                    }),
                    $10b3628602320bf1$var$leadershipLevels.map(function(option, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                            value: option,
                            children: t(option)
                        }, "level_" + index);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: t("in-company-since")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("select", {
                className: "mt-2 z-select",
                value: inCompanySince,
                onChange: function(e) {
                    return setInCompanySince(parseInt(e.target.value));
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: 0,
                        children: t("select")
                    }),
                    makeRange(thisYear, 1990).map(function(year) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                            value: year,
                            children: year
                        }, "year_" + year);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: t("current-role-since")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("select", {
                className: "mt-2 z-select",
                value: currentRoleSince,
                onChange: function(e) {
                    return setCurrentRoleSince(parseInt(e.target.value));
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: 0,
                        children: t("select")
                    }),
                    makeRange(thisYear, inCompanySince > 0 ? inCompanySince : 1990).map(function(year) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                            value: year,
                            children: year
                        }, "year_" + year);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: lang === "sv" ? "Mer om dig" : "More about you"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                value: aboutMe,
                placeholder: lang === "sv" ? "Skriv en kort beskrivning av dig sj\xe4lv, s\xe5 att AI-assistenten kan ge dig b\xe4ttre svar." : "What else should your assistant know about you? Write a short descriprion about yourself so the AI can personalize its support.",
                className: "z-input mt-2",
                onChange: function(e) {
                    return setAboutMe(e.target.value);
                }
            }),
            props.standalone && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $90e74421d35d2c58$export$2e2bcd8739ae039), {
                lang: lang,
                customerFiles: props.customerFiles
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        disabled: notValid(),
                        className: "mt-6",
                        onClick: function() {
                            return save();
                        },
                        children: props.standalone ? t("save") : t("next")
                    }),
                    !props.standalone && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $65b37309f7d8dd2c$export$2e2bcd8739ae039), {
                        color: "white",
                        onClick: function() {
                            return navigate(-1);
                        },
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8000ec2b9d404ecc$export$2e2bcd8739ae039), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b831c536d594a009$exports))),
                            className: "h-4 w-4"
                        }),
                        size: "sm",
                        children: t("back")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $60703c6782defd70$export$2e2bcd8739ae039), {
                isOpen: showInfoModal,
                onClose: function() {
                    return setShowInfoModal(false);
                }
            })
        ]
    });
};
var $10b3628602320bf1$export$2e2bcd8739ae039 = $10b3628602320bf1$var$Profile;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");





var $33f14d98a85d1e02$var$StepTwo = function(props) {
    var t = (0, $341d5702266247e0$export$9fc83ad70ead8663)().t;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.profile.coachingExperience), 2), coachingExperience = _useState[0], setCoachingExperience = _useState[1];
    var experiences = [
        {
            name: "vast-experience",
            value: 3
        },
        {
            name: "moderate-experience",
            value: 2
        },
        {
            name: "little-experience",
            value: 1
        },
        {
            name: "no-experience",
            value: 0
        }
    ];
    var notValid = function() {
        return coachingExperience < 0;
    };
    var save = function() {
        var newProfile = props.profile;
        newProfile.coachingExperience = coachingExperience;
        props.save(newProfile);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "flex flex-col gap-6 mt-6",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "z-heading2",
                children: t("coach-experience-title")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: t("coach-experience-subtitle")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2",
                        children: experiences.map(function(experience) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex items-center mt-4 cursor-pointer",
                                onClick: function() {
                                    return setCoachingExperience(experience.value);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-radiobox",
                                        children: experience.value === coachingExperience && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "rounded-full bg-gray-100 w-4 h-4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "ml-2",
                                        children: t(experience.name)
                                    })
                                ]
                            }, "exp_" + experience.value);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        disabled: notValid(),
                        className: "mt-6",
                        onClick: function() {
                            return save();
                        },
                        children: t("next")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $65b37309f7d8dd2c$export$2e2bcd8739ae039), {
                        color: "white",
                        onClick: function() {
                            return props.goBack();
                        },
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8000ec2b9d404ecc$export$2e2bcd8739ae039), {
                            src: (0, {}),
                            className: "h-4 w-4"
                        }),
                        size: "sm",
                        children: t("back")
                    })
                ]
            })
        ]
    });
};
var $33f14d98a85d1e02$export$2e2bcd8739ae039 = $33f14d98a85d1e02$var$StepTwo;



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");






var $b2403b191b164b18$var$StepThree = function(props) {
    var t = (0, $341d5702266247e0$export$9fc83ad70ead8663)().t;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.profile.languagesProfessional), 2), languagesProfessional = _useState[0], setLanguagesProfessional = _useState[1];
    if (!props.languages) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        children: "Fatal error - languages could not be loaded. Talk to support@zebrain.se"
    });
    // Toggle function for professional languages
    var toggleProfessionalLanguage = function(lang) {
        setLanguagesProfessional(function(prev) {
            return prev.includes(lang) ? prev.filter(function(l) {
                return l !== lang;
            }) : (0, $XnYkK._)(prev).concat([
                lang
            ]);
        });
    };
    // Validation check
    var notValid = function() {
        // require at least one language in either native or professional
        return languagesProfessional.length === 0;
    };
    // Save changes
    var handleSave = function() {
        var newProfile = (0, $lf4fc._)((0, $hwO3w._)({}, props.profile), {
            languagesProfessional: languagesProfessional
        });
        props.save(newProfile);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t("languages")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-gray-400",
                        children: t("select-coach-language")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "max-w-sm space-y-2",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "flex flex-col gap-3 mt-2",
                    children: props.languages.map(function(option, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                id: option,
                                checked: languagesProfessional.includes(option),
                                onChange: function() {
                                    return toggleProfessionalLanguage(option);
                                },
                                label: t("language_" + option)
                            })
                        }, "language_" + option);
                    })
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        disabled: notValid(),
                        className: "mt-6",
                        onClick: handleSave,
                        children: t("next")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $65b37309f7d8dd2c$export$2e2bcd8739ae039), {
                        color: "white",
                        onClick: props.goBack,
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8000ec2b9d404ecc$export$2e2bcd8739ae039), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b831c536d594a009$exports))),
                            className: "h-4 w-4"
                        }),
                        size: "sm",
                        children: t("back")
                    })
                ]
            })
        ]
    });
};
var $b2403b191b164b18$export$2e2bcd8739ae039 = $b2403b191b164b18$var$StepThree;



var $hwO3w = parcelRequire("hwO3w");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");






var $60b22ddab03e8810$var$StepFour = function(props) {
    var t = (0, $341d5702266247e0$export$9fc83ad70ead8663)().t;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.profile.coachingAreas), 2), coachingAreas = _useState[0], setCoachingAreas = _useState[1];
    // Separate lists of options
    var leadershipAndTeamDevelopment = [
        {
            name: 'executive_coaching',
            label: t('executive_coaching')
        },
        {
            name: 'team_coaching',
            label: t('team_coaching')
        },
        {
            name: 'leadership_coaching',
            label: t('leadership_coaching')
        }
    ];
    var organisationalAndBusinessCoaching = [
        {
            name: 'business_coaching',
            label: t('business_coaching')
        },
        {
            name: 'agile_coaching',
            label: t('agile_coaching')
        },
        {
            name: 'inclusive_corporate_culture',
            label: t('inclusive_corporate_culture')
        }
    ];
    var personalDevelopment = [
        {
            name: 'lifestyle_health',
            label: t('lifestyle_health')
        },
        {
            name: 'stress_management',
            label: t('stress_management')
        },
        {
            name: 'life_coaching',
            label: t('life_coaching')
        },
        {
            name: 'mental_training',
            label: t('mental_training')
        },
        {
            name: 'self_leadership',
            label: t('self_leadership')
        },
        {
            name: 'rehabilitation',
            label: t('rehabilitation')
        }
    ];
    var careerAndProfessionalGrowth = [
        {
            name: 'career_coaching',
            label: t('career_coaching')
        },
        {
            name: 'transit_coaching',
            label: t('transit_coaching')
        },
        {
            name: 'mentorship',
            label: t('mentorship')
        }
    ];
    // If no areas are selected, form is not valid
    var notValid = function() {
        return coachingAreas.length === 0;
    };
    var handleSave = function() {
        var newProfile = (0, $hwO3w._)({}, props.profile);
        newProfile.coachingAreas = coachingAreas;
        props.save(newProfile);
    };
    // Toggle function for adding/removing an area
    var toggleArea = function(area) {
        if (coachingAreas.includes(area)) {
            // Remove the area
            var newAreas = coachingAreas.filter(function(a) {
                return a !== area;
            });
            setCoachingAreas(newAreas);
        } else {
            // Add the area
            var newAreas1 = (0, $XnYkK._)(coachingAreas).concat([
                area
            ]);
            setCoachingAreas(newAreas1);
        }
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-6 z-heading2",
                        children: t('coachingAreas')
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 text-gray-400",
                        children: t('chooseCoachingAreas')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('leadership_and_team_development')
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "flex flex-col gap-3 mt-2",
                        children: leadershipAndTeamDevelopment.map(function(option, index) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                    id: option.name,
                                    checked: coachingAreas.includes(option.name),
                                    onChange: function() {
                                        return toggleArea(option.name);
                                    },
                                    label: option.label
                                })
                            }, option.name);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('organisational_and_business_coaching')
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "flex flex-col gap-3 mt-2",
                        children: organisationalAndBusinessCoaching.map(function(option, index) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                    id: option.name,
                                    checked: coachingAreas.includes(option.name),
                                    onChange: function() {
                                        return toggleArea(option.name);
                                    },
                                    label: option.label
                                })
                            }, option.name);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('personal_development')
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "flex flex-col gap-3 mt-2",
                        children: personalDevelopment.map(function(option, index) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                    id: option.name,
                                    checked: coachingAreas.includes(option.name),
                                    onChange: function() {
                                        return toggleArea(option.name);
                                    },
                                    label: option.label
                                })
                            }, option.name);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('career_and_professional_growth')
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "flex flex-col gap-3 mt-2",
                        children: careerAndProfessionalGrowth.map(function(option, index) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                    id: option.name,
                                    checked: coachingAreas.includes(option.name),
                                    onChange: function() {
                                        return toggleArea(option.name);
                                    },
                                    label: option.label
                                })
                            }, option.name);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        className: "mt-6",
                        onClick: handleSave,
                        disabled: coachingAreas.length === 0,
                        children: t('next')
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $65b37309f7d8dd2c$export$2e2bcd8739ae039), {
                        color: "white",
                        onClick: props.goBack,
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8000ec2b9d404ecc$export$2e2bcd8739ae039), {
                            src: (0, {}),
                            className: "h-4 w-4"
                        }),
                        size: "sm",
                        children: t('back')
                    })
                ]
            })
        ]
    });
};
var $60b22ddab03e8810$export$2e2bcd8739ae039 = $60b22ddab03e8810$var$StepFour;



var $hwO3w = parcelRequire("hwO3w");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");



var $fd23eaf639f663f0$var$StepFive = function(props) {
    var t = (0, $341d5702266247e0$export$9fc83ad70ead8663)().t;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.profile.coachIndustryExperiences), 2), coachIndustryExperiences = _useState[0], setCoachIndustryExperiences = _useState[1];
    // Separate arrays for each category
    var technologyAndInnovation = [
        {
            name: 'executive_coaching',
            label: t('executive_coaching')
        },
        {
            name: 'tech_it',
            label: t('tech_it')
        },
        {
            name: 'telecommunications',
            label: t('telecommunications')
        }
    ];
    var financeAndProfessionalServices = [
        {
            name: 'energy_environment',
            label: t('energy_environment')
        },
        {
            name: 'finance_legal_insurance',
            label: t('finance_legal_insurance')
        },
        {
            name: 'education_research',
            label: t('education_research')
        },
        {
            name: 'media_pr',
            label: t('media_pr')
        },
        {
            name: 'healthcare_and_pharma',
            label: t('healthcare_and_pharma')
        }
    ];
    var industryAndManufacture = [
        {
            name: 'government_public_services',
            label: t('government_public_services')
        },
        {
            name: 'manufacturing',
            label: t('manufacturing')
        },
        {
            name: 'construction_real_estate',
            label: t('construction_real_estate')
        },
        {
            name: 'transport_logistics',
            label: t('transport_logistics')
        }
    ];
    var consumerGoodsAndServices = [
        {
            name: 'agriculture_food',
            label: t('agriculture_food')
        },
        {
            name: 'culture_entertainment',
            label: t('culture_entertainment')
        },
        {
            name: 'tourism_hospitality',
            label: t('tourism_hospitality')
        },
        {
            name: 'sports_fitness',
            label: t('sports_fitness')
        },
        {
            name: 'retail_ecommerce',
            label: t('retail_ecommerce')
        },
        {
            name: 'fashion',
            label: t('fashion')
        }
    ];
    // Validation
    var notValid = function() {
        return coachIndustryExperiences.length === 0;
    };
    // Save handler
    var handleSave = function() {
        var newProfile = (0, $hwO3w._)({}, props.profile);
        newProfile.coachIndustryExperiences = coachIndustryExperiences;
        props.save(newProfile);
    };
    // Toggle an industry experience
    var toggleExperience = function(experience) {
        if (coachIndustryExperiences.includes(experience)) {
            // Remove it
            var newExperiences = coachIndustryExperiences.filter(function(e) {
                return e !== experience;
            });
            setCoachIndustryExperiences(newExperiences);
        } else {
            // Add it
            var newExperiences1 = (0, $XnYkK._)(coachIndustryExperiences).concat([
                experience
            ]);
            setCoachIndustryExperiences(newExperiences1);
        }
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-6 z-heading2",
                        children: t('coach-industry-experience')
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 text-gray-400",
                        children: t('choose-coach-industry-experience')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('technology_and_innovation')
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 flex flex-col gap-3",
                        children: technologyAndInnovation.map(function(item) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                id: item.name,
                                checked: coachIndustryExperiences.includes(item.name),
                                onChange: function() {
                                    return toggleExperience(item.name);
                                },
                                label: item.label
                            }, item.name);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('finance_and_professional_services')
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 flex flex-col gap-3",
                        children: financeAndProfessionalServices.map(function(item) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                id: item.name,
                                checked: coachIndustryExperiences.includes(item.name),
                                onChange: function() {
                                    return toggleExperience(item.name);
                                },
                                label: item.label
                            }, item.name);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('industry_and_manufacture')
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 flex flex-col gap-3",
                        children: industryAndManufacture.map(function(item) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                id: item.name,
                                checked: coachIndustryExperiences.includes(item.name),
                                onChange: function() {
                                    return toggleExperience(item.name);
                                },
                                label: item.label
                            }, item.name);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('consumer_goods_and_services')
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 flex flex-col gap-3",
                        children: consumerGoodsAndServices.map(function(item) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                id: item.name,
                                checked: coachIndustryExperiences.includes(item.name),
                                onChange: function() {
                                    return toggleExperience(item.name);
                                },
                                label: item.label
                            }, item.name);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                disabled: notValid(),
                className: "mt-6",
                onClick: handleSave,
                children: t('next')
            })
        ]
    });
};
var $fd23eaf639f663f0$export$2e2bcd8739ae039 = $fd23eaf639f663f0$var$StepFive;



parcelRequire("5s1kH");


var $0235c0cb6948d6bc$exports = {};
$0235c0cb6948d6bc$exports = $parcel$resolve("1ToNe");


var $8b00b25b4ea2afeb$var$StepSix = function(props) {
    var t = (0, $341d5702266247e0$export$9fc83ad70ead8663)().t;
    var displayCoachingExperience = function(value) {
        if (value === 3) return t("vast-experience");
        else if (value === 2) return t("moderate-experience");
        else if (value === 1) return t("little-experience");
        else if (value === 0) return t("no-experience");
        return "Unknown " + value;
    };
    var displayLanguages = function(languages) {
        var languageString = "";
        var i = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = languages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var l = _step.value;
                if (i > 0) languageString += ", ";
                languageString += t("language_" + l);
                i++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return languageString;
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 z-heading2",
                children: t("summary")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("professional-details")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        className: "ml-1",
                        onClick: function() {
                            return props.changeStep(0);
                        },
                        size: "sm",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                            alt: "Info",
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-2 flex justify-between text-gray-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "font-medium",
                        children: t("title-role")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: props.profile.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-2 flex justify-between text-gray-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "font-medium",
                        children: t("select-leadership-level")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: t(props.profile.leadershipLevel)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-2 flex justify-between text-gray-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "font-medium",
                        children: t("in-company-since")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: props.profile.inCompanySince
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-2 flex justify-between text-gray-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "font-medium",
                        children: t("current-role-since")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: props.profile.currentRoleSince
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-indigo-700"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("coach-experience-title")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        className: "ml-1",
                        onClick: function() {
                            return props.changeStep(1);
                        },
                        size: "sm",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                            alt: "Info",
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-2 text-gray-400",
                children: displayCoachingExperience(props.profile.coachingExperience)
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-indigo-700"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("languages")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        className: "ml-1",
                        onClick: function() {
                            return props.changeStep(2);
                        },
                        size: "sm",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                            alt: "Info",
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-2 flex justify-between text-gray-400",
                children: displayLanguages(props.profile.languagesProfessional)
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-indigo-700"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("coachingAreas")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        className: "ml-1",
                        onClick: function() {
                            return props.changeStep(3);
                        },
                        size: "sm",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                            alt: "Info",
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            props.profile.coachingAreas.map(function(area, index) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-400",
                    children: t(area)
                }, "area_" + index);
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-indigo-700"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("coach-industry-experience")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        className: "ml-1",
                        onClick: function() {
                            return props.changeStep(4);
                        },
                        size: "sm",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                            alt: "Info",
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            props.profile.coachIndustryExperiences.map(function(area, index) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-400",
                    children: t(area)
                }, "ind_" + index);
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-indigo-700"
            }),
            props.profile.coachId !== "0" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-6",
                children: "You have already selected a coach. If you want to change coach, please contact support@zebrain.se"
            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: function() {
                    return props.changeStep(6);
                },
                children: t("submit-for-matching")
            })
        ]
    });
};
var $8b00b25b4ea2afeb$export$2e2bcd8739ae039 = $8b00b25b4ea2afeb$var$StepSix;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");


var $bHX26 = parcelRequire("bHX26");





var $6iP9u = parcelRequire("6iP9u");



var $5s1kH = parcelRequire("5s1kH");



parcelRequire("5s1kH");
var $fa8085d5941c4bad$var$Badge = function(param) {
    var _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, _param_label = param.label, label = _param_label === void 0 ? '' : _param_label, leftIcon = param.leftIcon, rightIcon = param.rightIcon, onLeftIconClick = param.onLeftIconClick, onRightIconClick = param.onRightIconClick, _param_size = param.size, size = _param_size === void 0 ? 'md' : _param_size, _param_round = param.round, round = _param_round === void 0 ? false : _param_round, _param_color = param.color, color = _param_color === void 0 ? 'bg-indigo-800' : _param_color;
    var sizeClasses = {
        sm: 'py-1 px-2',
        md: 'py-2 px-3'
    };
    var roundClasses = round ? 'rounded-full' : 'rounded-md';
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
        className: "inline-flex items-center gap-x-1 text-sm font-medium leading-none  text-gray-300 ".concat(color, " ").concat(roundClasses, " ").concat(sizeClasses[size], " ").concat(className),
        children: [
            leftIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: leftIcon,
                alt: "left",
                className: "w-4 h-4 cursor-pointer",
                onClick: onLeftIconClick
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                children: label
            }),
            rightIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: rightIcon,
                alt: "right",
                className: "w-4 h-4 cursor-pointer",
                onClick: onRightIconClick
            })
        ]
    });
};
var $fa8085d5941c4bad$export$2e2bcd8739ae039 = $fa8085d5941c4bad$var$Badge;


var $a802a38561a672bd$export$2e2bcd8739ae039 = (0, $fa8085d5941c4bad$export$2e2bcd8739ae039);



var $c96302940bef0670$var$CoachMatching = function(param) {
    var clientProfile = param.clientProfile, coach = param.coach;
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), showMore = _useState[0], setShowMore = _useState[1];
    var showMoreData = function() {
        var name = showMore ? showMore : "unknown";
        var header = name;
        var matched = [];
        var coachArr = [];
        var clientArr = [];
        var clientAreas = 0;
        if (showMore === "areas") {
            var coachKeys = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = coach.profile.coachingAreas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var area = _step.value;
                    if (clientProfile.coachingAreas.includes(area.key)) matched.push(t(area.key));
                    else coachArr.push(t(area.key));
                    coachKeys.push(area.key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = clientProfile.coachingAreas[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var area1 = _step1.value;
                    if (!coachKeys.includes(area1)) clientArr.push(t(area1));
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            clientAreas = clientProfile.coachingAreas.length;
            header = lang === "sv" ? "Coachomr\xe5den" : "Coaching areas";
        } else if (showMore === "client_industries") {
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = coach.profile.clientIndustries[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var area2 = _step2.value;
                    if (clientProfile.coachIndustryExperiences.includes(area2)) matched.push(t(area2));
                    else coachArr.push(t(area2));
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
            try {
                for(var _iterator3 = clientProfile.coachIndustryExperiences[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var area3 = _step3.value;
                    if (!coach.profile.clientIndustries.includes(area3)) clientArr.push(t(area3));
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
            clientAreas = clientProfile.coachIndustryExperiences.length;
            header = lang === "sv" ? "Brancher" : "Industries";
        } else if (showMore === "coach_industries") {
            var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
            try {
                for(var _iterator4 = coach.profile.industries[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                    var area4 = _step4.value;
                    if (clientProfile.coachIndustryExperiences.includes(area4)) matched.push(t(area4));
                    else coachArr.push(t(area4));
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                        _iterator4.return();
                    }
                } finally{
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
            var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
            try {
                for(var _iterator5 = clientProfile.coachIndustryExperiences[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                    var area5 = _step5.value;
                    if (!coach.profile.industries.includes(area5)) clientArr.push(t(area5));
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                        _iterator5.return();
                    }
                } finally{
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
            clientAreas = clientProfile.coachIndustryExperiences.length;
            header = lang === "sv" ? "Coachens branscherfarenhet" : "Coach industry experience";
        } else if (showMore === "languages") {
            var _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
            try {
                for(var _iterator6 = coach.profile.languages[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                    var area6 = _step6.value;
                    if (clientProfile.languagesProfessional.includes(area6) || clientProfile.languagesNative.includes(area6)) matched.push(t("language_" + area6));
                    else coachArr.push(t("language_" + area6));
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                        _iterator6.return();
                    }
                } finally{
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }
            var _iteratorNormalCompletion7 = true, _didIteratorError7 = false, _iteratorError7 = undefined;
            try {
                for(var _iterator7 = clientProfile.languagesProfessional[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true){
                    var area7 = _step7.value;
                    if (!coach.profile.languages.includes(area7)) clientArr.push(t("language_" + area7));
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                        _iterator7.return();
                    }
                } finally{
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }
            clientAreas = clientProfile.languagesProfessional.length;
            header = t("languages");
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: function() {
                return setShowMore(null);
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return setShowMore(null);
                    },
                    children: header
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            children: [
                                t("you-have-a-match"),
                                " ",
                                matched.length,
                                " ",
                                t("out-of"),
                                " ",
                                clientAreas,
                                " ",
                                t(name).toLowerCase(),
                                ".\xa0",
                                coach.firstName,
                                " ",
                                t("also-expertise"),
                                " ",
                                coachArr.length,
                                " ",
                                t("additional"),
                                " ",
                                t(name).toLowerCase(),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            className: "mt-4 font-medium",
                            children: [
                                t("matched"),
                                " ",
                                t(name).toLowerCase()
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-4 flex flex-row gap-2 flex-wrap",
                            children: matched.map(function(item, index) {
                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a802a38561a672bd$export$2e2bcd8739ae039), {
                                    label: item,
                                    size: "md",
                                    round: true,
                                    color: "bg-indigo-700",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {})
                                }, "match_".concat(index));
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-4 border-indigo-800"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            className: "mt-4 font-medium",
                            children: [
                                t("your"),
                                " ",
                                t("other"),
                                " ",
                                t(name).toLowerCase()
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-4 flex flex-row gap-2 flex-wrap",
                            children: clientArr.map(function(item, index) {
                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a802a38561a672bd$export$2e2bcd8739ae039), {
                                    label: item,
                                    size: "md",
                                    round: true,
                                    className: "border border-indigo-700",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {})
                                }, "client_".concat(index));
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-4 border-indigo-800"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            className: "mt-4 font-medium",
                            children: [
                                coach.firstName,
                                lang === "sv" ? "" : "'",
                                "s ",
                                t("other"),
                                " ",
                                t(name).toLowerCase()
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-4 flex flex-row gap-2 flex-wrap",
                            children: coachArr.map(function(item, index) {
                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a802a38561a672bd$export$2e2bcd8739ae039), {
                                    label: item,
                                    size: "md",
                                    round: true,
                                    className: "border border-indigo-700",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {})
                                }, "coach_".concat(index));
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            showMore && showMoreData(),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            className: "w-60 h-60 object-contain rounded-full",
                            src: coach.picture ? coach.picture : (0, (/*@__PURE__*/$parcel$interopDefault($bf234ba9a155a985$exports))),
                            alt: "pic"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("h1", {
                                className: "mt-4 z-heading2",
                                children: [
                                    coach.firstName,
                                    " ",
                                    coach.lastName
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-base text-gray-400 whitespace-pre-line text-center",
                                children: coach.profile.intro
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "font-medium",
                                children: t("about-me")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-gray-400 mt-2",
                                children: coach.profile.aboutMe
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-800"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex flex-row w-full justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "font-medium",
                                        children: t("coaching-areas")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "z-title4 cursor-pointer",
                                        onClick: function() {
                                            return setShowMore("areas");
                                        },
                                        children: t("see-more")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-gray-400 whitespace-pre-line",
                                children: coach.profile.coachingAreasDescription
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "flex flex-row gap-2 flex-wrap",
                                children: coach.profile.coachingAreas.filter(function(area) {
                                    return clientProfile.coachingAreas.includes(area.key);
                                }).map(function(area) {
                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a802a38561a672bd$export$2e2bcd8739ae039), {
                                        label: t(area.key),
                                        size: "md",
                                        round: true,
                                        color: "bg-indigo-700",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {})
                                    }, "coaching-areas-".concat(coach.id, "-").concat(area.key));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-800"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex flex-row w-full justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "font-medium",
                                        children: t("industries")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "z-title4 cursor-pointer",
                                        onClick: function() {
                                            return setShowMore("client_industries");
                                        },
                                        children: t("see-more")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-gray-400 whitespace-pre-line",
                                children: coach.profile.industryExperienceDescription
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "flex flex-row gap-2 flex-wrap",
                                children: coach.profile.clientIndustries.filter(function(area) {
                                    return clientProfile.coachIndustryExperiences.includes(area);
                                }).map(function(area) {
                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a802a38561a672bd$export$2e2bcd8739ae039), {
                                        label: t(area),
                                        size: "md",
                                        round: true,
                                        color: "bg-indigo-700",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {})
                                    }, "industry-".concat(area));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-800"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex flex-row w-full justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "font-medium",
                                        children: t("coach-industry-experience")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "z-title4 cursor-pointer",
                                        onClick: function() {
                                            return setShowMore("coach_industries");
                                        },
                                        children: t("see-more")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-gray-400 whitespace-pre-line",
                                children: coach.profile.clientIndustriesDescription
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "flex flex-row gap-2 flex-wrap",
                                children: coach.profile.industries.filter(function(area) {
                                    return clientProfile.coachIndustryExperiences.includes(area);
                                }).map(function(area) {
                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a802a38561a672bd$export$2e2bcd8739ae039), {
                                        label: t(area),
                                        size: "md",
                                        round: true,
                                        color: "bg-indigo-700",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {})
                                    }, "c-i-".concat(area));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-800"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "font-medium",
                                children: t("philosophy")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "mt-2 text-gray-400 whitespace-pre-line",
                                children: coach.profile.philosophy
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-800"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex flex-row w-full justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "font-medium",
                                        children: t("languages")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "z-title4 cursor-pointer",
                                        onClick: function() {
                                            return setShowMore("languages");
                                        },
                                        children: t("see-more")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "flex flex-row gap-2 flex-wrap",
                                children: coach.profile.languages.filter(function(area) {
                                    return clientProfile.languagesProfessional.includes(area);
                                }).map(function(area) {
                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a802a38561a672bd$export$2e2bcd8739ae039), {
                                        label: t("language_" + area),
                                        size: "md",
                                        round: true,
                                        color: "bg-indigo-700",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {})
                                    }, "lang-".concat(area));
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $c96302940bef0670$export$2e2bcd8739ae039 = $c96302940bef0670$var$CoachMatching;







var $6c066964533a9345$exports = {};
$6c066964533a9345$exports = $parcel$resolve("aRkz5");



var $496dc2db2443f366$var$ConfirmStatus = /*#__PURE__*/ function(ConfirmStatus) {
    ConfirmStatus[ConfirmStatus["None"] = 0] = "None";
    ConfirmStatus[ConfirmStatus["Done"] = 1] = "Done";
    return ConfirmStatus;
}($496dc2db2443f366$var$ConfirmStatus || {});
var $496dc2db2443f366$var$StepSeven = function(props) {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), selectCoach = _useState[0], setSelectCoach = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), showCoach = _useState1[0], setShowCoach = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), coaches = _useState2[0], setCoaches = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), confirmStatus = _useState3[0], setConfirmStatus = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState4[0], setLoaded = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), waited = _useState5[0], setWaited = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showChosenCoach = _useState6[0], setShowChosenCoach = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(10), 2), showCoaches = _useState7[0], setShowCoaches = _useState7[1];
    (0, $5s1kH.useEffect)(function() {
        setTimeout(function() {
            setWaited(true);
        }, 2000);
        api.get("client/matching_coaches").then(function(response) {
            setCoaches(response.json.coaches);
            setLoaded(true);
        });
    }, []);
    if (!loaded || !waited) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "mt-43",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex items-center justify-center relative",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "w-24 h-24 rounded-full flex items-center justify-center bg-indigo-800",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex space-x-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "w-2 h-2 bg-primary-500 rounded-full animate-dot [animation-delay:0s]"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "w-2 h-2 bg-primary-500 rounded-full animate-dot [animation-delay:0.2s]"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "w-2 h-2 bg-primary-500 rounded-full animate-dot [animation-delay:0.4s]"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h2", {
                className: "mt-6 z-heading2 text-center",
                children: lang === "sv" ? "Matchar dig med coacher" : "Matching you with coaches"
            })
        ]
    });
    var saveCoach = function(profile) {
        api.post("client/account/set", profile).then(function() {
            setShowChosenCoach(true);
        });
    };
    var doSelectCoach = function() {
        if (showCoach) {
            var newProfile = props.profile;
            newProfile.coachId = showCoach.id;
            saveCoach(newProfile);
            setConfirmStatus(1);
        }
    };
    var closeSelectCoach = function() {
        if (confirmStatus === 1) navigate("/videocoach");
        else {
            setConfirmStatus(0);
            setSelectCoach(false);
        }
    };
    if (showChosenCoach) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "mt-40 text-center",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                alt: "check",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6c066964533a9345$exports))),
                className: "h-12 w-12 text-center mx-auto"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "mt-6 z-heading1 text-center mx-auto text-white",
                children: lang === "sv" ? "Coach vald" : "Coach chosen"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-2",
                children: lang === "sv" ? "Bra val!" : "Great choice!"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                children: [
                    lang === "sv" ? "Du har valt " : "You have chosen ",
                    showCoach === null || showCoach === void 0 ? void 0 : showCoach.firstName,
                    " ",
                    showCoach === null || showCoach === void 0 ? void 0 : showCoach.lastName,
                    lang === "sv" ? " som din coach. " : " as your coach. ",
                    lang === "sv" ? "Du kan ta n\xe4sta steg f\xf6r att n\xe5 dina m\xe5l och boka ditt f\xf6rsta m\xf6te." : "You can take the next step towards achieving your goals and continue with booking your first session."
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                onClick: function() {
                    return navigate("/videocoach/book-meeting");
                },
                buttonType: "blueBase",
                className: "mt-6",
                children: lang === "sv" ? "Boka m\xf6te" : "Book a session"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $65b37309f7d8dd2c$export$2e2bcd8739ae039), {
                color: "white",
                className: "mt-4",
                onClick: function() {
                    return navigate("/videocoach");
                },
                size: "sm",
                children: lang === "sv" ? "Jag g\xf6r det senare" : "I'll do it later"
            })
        ]
    });
    var showMoreCoaches = function() {
        var c = showCoaches;
        if (c === 10) c = 15;
        else if (c === 15) c = 20;
        else return;
        setShowCoaches(c);
    };
    var renderCoach = function() {
        if (!showCoach) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {});
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c96302940bef0670$export$2e2bcd8739ae039), {
                    coach: showCoach,
                    clientProfile: props.profile
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "h-20",
                    children: "\xa0"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "fixed bottom-0 w-full desktop:w-151 bg-indigo-1000",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex justify-center mt-2",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                onClick: function() {
                                    return setSelectCoach(true);
                                },
                                children: [
                                    t("choose"),
                                    " ",
                                    showCoach.firstName,
                                    " ",
                                    showCoach.lastName
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex justify-center my-4",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $65b37309f7d8dd2c$export$2e2bcd8739ae039), {
                                color: "white",
                                onClick: function() {
                                    return setShowCoach(null);
                                },
                                leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8000ec2b9d404ecc$export$2e2bcd8739ae039), {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b831c536d594a009$exports))),
                                    className: "h-4 w-4"
                                }),
                                size: "sm",
                                children: t("back")
                            })
                        })
                    ]
                }),
                selectCoach && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                    isOpen: true,
                    onClose: closeSelectCoach,
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                            onClose: closeSelectCoach,
                            children: [
                                t("choose"),
                                " ",
                                showCoach.firstName,
                                " ",
                                showCoach.lastName
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                            children: [
                                lang === "sv" ? "Vill du v\xe4lja " : "Do you want to choose ",
                                showCoach.firstName,
                                " ",
                                showCoach.lastName,
                                lang === "sv" ? " som din coach" : " as your coach",
                                "?"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "w-full flex",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: "outlineWhiteBase",
                                        onClick: function() {
                                            return setSelectCoach(false);
                                        },
                                        children: t("cancel")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        className: "ml-4",
                                        onClick: doSelectCoach,
                                        children: t("choose")
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    if (showCoach) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: renderCoach()
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t("choose-coach")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 text-gray-400",
                        children: t("choose-coach-subheading")
                    })
                ]
            }),
            coaches.slice(0, showCoaches).map(function(coach) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $c9f7bf3282a3b2ff$export$2e2bcd8739ae039), {
                    onClick: function() {
                        return setShowCoach(coach);
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8b128e0855661626$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex items-center p-4",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        className: "picture-lg",
                                        src: coach.picture ? coach.picture : (0, (/*@__PURE__*/$parcel$interopDefault($bf234ba9a155a985$exports))),
                                        alt: "pic"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "ml-4",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                            className: "z-heading2",
                                            children: [
                                                coach.firstName,
                                                " ",
                                                coach.lastName
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e463b23594a69ac8$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "text-gray-400 whitespace-pre-line",
                                        children: coach.profile.intro
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: "outlineWhiteBase",
                                        onClick: function() {
                                            return setShowCoach(coach);
                                        },
                                        children: t("view-profile")
                                    })
                                ]
                            })
                        })
                    ]
                }, coach.id);
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "text-center",
                children: coaches.length > showCoaches ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $65b37309f7d8dd2c$export$2e2bcd8739ae039), {
                    color: "white",
                    onClick: function() {
                        return showMoreCoaches();
                    },
                    leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8000ec2b9d404ecc$export$2e2bcd8739ae039), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($749d65ec77f6e156$exports))),
                        className: "h-4 w-4"
                    }),
                    size: "sm",
                    children: lang === "sv" ? "Visa fler coacher" : "Show more coaches"
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    children: lang === "sv" ? "Du har n\xe5tt slutet av listan" : "You've reached the end of the list"
                })
            })
        ]
    });
};
var $496dc2db2443f366$export$2e2bcd8739ae039 = $496dc2db2443f366$var$StepSeven;


var $9bff745e9fa01278$var$MatchWithCoach = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), coachLanguages = _useState1[0], setCoachLanguages = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)({
        id: 0,
        inCompanySince: 0,
        currentRoleSince: 0,
        title: "",
        roleDescription: "",
        aboutMe: "",
        leadershipLevel: "",
        languages: "",
        coachingExperience: -1,
        coachId: "0",
        languagesNative: [],
        languagesProfessional: [],
        coachingAreas: [],
        coachIndustryExperiences: [],
        picture: ""
    }), 2), clientProfile = _useState2[0], setClientProfile = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), step = _useState3[0], setStep = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)([
        false,
        false,
        false,
        false,
        false,
        false
    ]), 2), stepsDone = _useState4[0], setStepsDone = _useState4[1];
    /**
   * STEP RULES:
   *
   * - isOptional: If true, that step can be "skipped" even if data is missing.
   * - check: A function that returns true if the user has filled out enough data
   *          to consider the step "complete."
   *
   * The array index matches your step order:
   *    step = 0 -> StepOne
   *    step = 1 -> StepTwo
   *    step = 2 -> StepThree
   *    step = 3 -> StepFour
   *    step = 4 -> StepFive
   *    step = 5 -> StepSix
   *    step = 6 -> StepSeven (select coach)
   */ var stepRules = [
        {
            isOptional: false,
            check: function(profile) {
                return profile.currentRoleSince !== 0;
            }
        },
        {
            isOptional: false,
            check: function(profile) {
                return profile.coachingExperience >= 0;
            }
        },
        {
            // Example: StepThree is optional—maybe the user can skip language selection
            // if it’s not critical to the overall process
            isOptional: false,
            check: function(profile) {
                return profile.languagesProfessional.length > 0 || profile.languagesNative.length > 0;
            }
        },
        {
            isOptional: false,
            check: function(profile) {
                return profile.coachingAreas.length > 0;
            }
        },
        {
            isOptional: false,
            check: function(profile) {
                return profile.coachIndustryExperiences.length > 0;
            }
        },
        // StepSeven may be a final confirmation step or coach selection, typically also required.
        // But if you wanted it optional for some reason, set isOptional: true, etc.
        {
            isOptional: false,
            check: function(_profile) {
                return true // We'll let the code below handle final step logic
                ;
            }
        }
    ];
    (0, $5s1kH.useEffect)(function() {
        getCoachLanguages();
        getData();
    }, []);
    var getCoachLanguages = function() {
        api.get('client/coach_languages').then(function(response) {
            setCoachLanguages(response.json.languages);
        });
    };
    var getData = function() {
        api.get('client/account').then(function(response) {
            if (response.json.profile) {
                setClientProfile(response.json.profile);
                calculateStep(response.json.profile);
            } else console.log('No title, adding new profile');
            setLoaded(true);
        });
    };
    var saveProfile = function(profile) {
        api.post('client/account/set', profile).then(function() {
            getData();
        });
    };
    var calculateStep = function(profile) {
        var nextStep = 0;
        for(var i = 0; i < stepRules.length; i++){
            var _stepRules_i = stepRules[i], isOptional = _stepRules_i.isOptional, check = _stepRules_i.check;
            var isFilled = check(profile);
            // If a step is required (not optional) and is not filled => set nextStep
            if (!isFilled && !isOptional) {
                nextStep = i;
                break;
            }
            // Otherwise, the step is effectively "complete"
            nextStep = i + 1;
        }
        // If nextStep exceeds the last index, user is effectively done
        // (You can adjust logic if you want them to land on StepSeven.)
        if (nextStep >= stepRules.length) nextStep = stepRules.length - 1;
        setStep(nextStep);
        // Mark all steps < nextStep as done
        var newStepsDone = stepRules.map(function(_, idx) {
            return idx < nextStep;
        });
        setStepsDone(newStepsDone);
    };
    var changeStep = function(newStep) {
        // Only allow jumping forward if the previous step is done
        if (newStep === 0 || stepsDone[newStep - 1]) setStep(newStep);
        else // Hack - if step 5 is done, and we want to go to step 6 (select coach), allow that
        if (newStep === 6 && stepsDone[4]) setStep(6);
    };
    var goBackAStep = function() {
        if (step > 0) setStep(step - 1);
    };
    var selectStep = function() {
        // Adjust to reflect your final step indexing
        // If your final step is index 5 (StepSeven):
        if (step === 6) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $496dc2db2443f366$export$2e2bcd8739ae039), {
            profile: clientProfile
        });
        else if (step === 5) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8b00b25b4ea2afeb$export$2e2bcd8739ae039), {
            profile: clientProfile,
            changeStep: changeStep
        });
        else if (step === 4) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $fd23eaf639f663f0$export$2e2bcd8739ae039), {
            profile: clientProfile,
            save: saveProfile,
            goBack: goBackAStep
        });
        else if (step === 3) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $60b22ddab03e8810$export$2e2bcd8739ae039), {
            profile: clientProfile,
            save: saveProfile,
            goBack: goBackAStep
        });
        else if (step === 2) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b2403b191b164b18$export$2e2bcd8739ae039), {
            profile: clientProfile,
            save: saveProfile,
            goBack: goBackAStep,
            languages: coachLanguages
        });
        else if (step === 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $33f14d98a85d1e02$export$2e2bcd8739ae039), {
            profile: clientProfile,
            save: saveProfile,
            goBack: goBackAStep
        });
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $10b3628602320bf1$export$2e2bcd8739ae039), {
            profile: clientProfile,
            save: saveProfile,
            standalone: false,
            customerFiles: []
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            step < 6 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mx-16 mt-4",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d9db0ddc8faf3d7$export$2e2bcd8739ae039), {
                    step: step,
                    stepsDone: stepsDone,
                    changeStep: changeStep
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: selectStep()
            })
        ]
    });
};
var $9bff745e9fa01278$export$2e2bcd8739ae039 = $9bff745e9fa01278$var$MatchWithCoach;


var $e6721e901a1515a8$export$2e2bcd8739ae039 = (0, $9bff745e9fa01278$export$2e2bcd8739ae039);



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");







var $56fb6ddc2e2d00cb$var$ProfilePage = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), customerFiles = _useState1[0], setCustomerFiles = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)({
        id: 0,
        inCompanySince: 0,
        currentRoleSince: 0,
        title: "",
        roleDescription: "",
        aboutMe: "",
        leadershipLevel: "",
        languages: "",
        coachingExperience: -1,
        coachId: "0",
        languagesNative: [],
        languagesProfessional: [],
        coachingAreas: [],
        coachIndustryExperiences: [],
        picture: ""
    }), 2), clientProfile = _useState2[0], setClientProfile = _useState2[1];
    var setGlobalToast = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$12972e612ad7cf0));
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get("client/account").then(function(response) {
            if (response.json.profile) {
                setClientProfile(response.json.profile);
                setCustomerFiles(response.json.customerFiles);
            }
            setLoaded(true);
        });
    };
    var saveProfile = function(profile) {
        api.post('client/account/update', profile).then(function() {
            setGlobalToast({
                text: lang === "sv" ? "\xc4ndringar sparade" : "Changes saved"
            });
            getData();
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "main-content",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $10b3628602320bf1$export$2e2bcd8739ae039), {
            profile: clientProfile,
            save: saveProfile,
            standalone: true,
            customerFiles: customerFiles
        })
    });
};
var $56fb6ddc2e2d00cb$export$2e2bcd8739ae039 = $56fb6ddc2e2d00cb$var$ProfilePage;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");


var $4a12bf2671498f8a$var$MyCoachPage = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), coachData = _useState[0], setCoachData = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(), 2), clientProfile = _useState1[0], setClientProfile = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState2[0], setLoaded = _useState2[1];
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get('client/my_coach').then(function(response) {
            setCoachData(response.json.coach);
            setClientProfile(response.json.clientProfile);
            setLoaded(true);
        });
    };
    if (!loaded || !coachData || !clientProfile) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c96302940bef0670$export$2e2bcd8739ae039), {
        coach: coachData,
        clientProfile: clientProfile
    });
};
var $4a12bf2671498f8a$export$2e2bcd8739ae039 = $4a12bf2671498f8a$var$MyCoachPage;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");




var $cc3aace872107b9b$var$Unsubscribe = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), unsubscribe = _useState[0], setUnsubscribe = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), justSubscribed = _useState1[0], setJustSubscribed = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState2[0], setLoaded = _useState2[1];
    (0, $5s1kH.useEffect)(function() {
        api.get("client/unsubscribe").then(function(response) {
            setUnsubscribe(response.json.unsubscribe);
            setLoaded(true);
        });
    }, []);
    var updateUnSubscribe = function(unsubscribeAction) {
        var data = {
            unsubscribeAction: unsubscribeAction
        };
        api.post("client/unsubscribe", data).then(function(response) {
            if (response.json.unsubscribe === false) setJustSubscribed(true);
            setUnsubscribe(response.json.unsubscribe);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4 main-content",
        children: "Loading..."
    });
    if (justSubscribed) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content text-center mt-10",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($eda3564600df02e0$exports))),
                alt: "check",
                className: "w-12 h-12 mx-auto"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "z-heading1 text-white",
                children: "Unsubscribe"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-2 text-gray-400",
                children: "By unsubscribing, you\u2019ll no longer receive any tips, reminders, or news from us \u2013 just the essential account-related messages"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-4 text-gray-400",
                children: "You can always re-subscribe to stay in the loop!"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                buttonType: "blueBase",
                onClick: function() {
                    return navigate('/');
                },
                children: "I'd rather stay"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-2",
                buttonType: "outlineWhiteBase",
                onClick: function() {
                    return updateUnSubscribe(true);
                },
                children: "Unsubscribe"
            })
        ]
    });
    else if (unsubscribe) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content text-center mt-10",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6c066964533a9345$exports))),
                alt: "check",
                className: "w-12 h-12 mx-auto"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "z-heading1 text-white",
                children: "You have unsubscribed!"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-2 text-gray-400",
                children: "You\u2019ll no longer receive any emails from us, except for essential account-related messages."
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-4 text-gray-400",
                children: "You can always re-subscribe to stay in the loop!"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                buttonType: "blueBase",
                onClick: function() {
                    return updateUnSubscribe(false);
                },
                children: "Re-subscribe"
            })
        ]
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content text-center mt-10",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($eda3564600df02e0$exports))),
                alt: "check",
                className: "w-12 h-12 mx-auto"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "z-heading1 text-white",
                children: "Unsubscribe"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-2 text-gray-400",
                children: "By unsubscribing, you\u2019ll no longer receive any tips, reminders, or news from us \u2013 just the essential account-related messages"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-4 text-gray-400",
                children: "You can always re-subscribe to stay in the loop!"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                buttonType: "blueBase",
                onClick: function() {
                    return navigate("/");
                },
                children: "I'd rather stay"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-2",
                buttonType: "outlineWhiteBase",
                onClick: function() {
                    return updateUnSubscribe(true);
                },
                children: "Unsubscribe"
            })
        ]
    });
};
var $cc3aace872107b9b$export$2e2bcd8739ae039 = $cc3aace872107b9b$var$Unsubscribe;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");


var $31bdd5593eddf100$var$DatePicker = function(param) {
    var dates = param.dates, clickDate = param.clickDate, preSelectedDate = param.preSelectedDate, className = param.className, inactiveDatesRange = param.inactiveDatesRange, skipClickMonthChange = param.skipClickMonthChange;
    var today = new Date();
    var thisDay = preSelectedDate ? preSelectedDate : today;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(thisDay.getMonth()), 2), currentMonth = _useState[0], setCurrentMonth = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(thisDay.getFullYear()), 2), currentYear = _useState1[0], setCurrentYear = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loadedPreselected = _useState2[0], setLoadedPreselected = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(preSelectedDate ? {
        day: preSelectedDate.getDate(),
        month: preSelectedDate.getMonth(),
        year: preSelectedDate.getFullYear()
    } : null), 2), selectedDate = _useState3[0], setSelectedDate = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), paddingDays = _useState4[0], setPaddingDays = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)("48px"), 2), columnGap = _useState5[0], setColumnGap = _useState5[1];
    var containerRef = (0, $5s1kH.useRef)(null);
    // Define event dates
    var eventDates = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = dates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var d = _step.value;
            eventDates.push({
                day: d.getDate(),
                month: d.getMonth(),
                year: d.getFullYear()
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    var daysInMonth = function(month, year) {
        return new Date(year, month + 1, 0).getDate();
    };
    var weekDayOfFirst = function(month, year) {
        var dayOfWeek = new Date(year, month, 1).getDay();
        return dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Monday = 0, Sunday = 6
    };
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), days = _useState6[0], setDays = _useState6[1];
    (0, $5s1kH.useEffect)(function() {
        setDays(Array.from({
            length: daysInMonth(currentMonth, currentYear)
        }, function(_, i) {
            return i + 1;
        }));
        var weekDay = weekDayOfFirst(currentMonth, currentYear);
        setPaddingDays(Array.from({
            length: weekDay
        }, function(_, i) {
            return i + 1;
        }));
    }, [
        currentMonth,
        currentYear
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (preSelectedDate && !loadedPreselected) {
            var year = preSelectedDate.getFullYear();
            var month = preSelectedDate.getMonth();
            var day = preSelectedDate.getDate();
            setSelectedDate({
                day: day,
                month: month,
                year: year
            });
            setCurrentMonth(month);
            setCurrentYear(year);
            setLoadedPreselected(true);
        }
    }, [
        preSelectedDate
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (containerRef.current) {
            var w = containerRef.current.clientWidth;
            if (w < 636) {
                var colGap = w / 6 - 52;
                setColumnGap(colGap + "px");
            }
        }
    }, [
        containerRef
    ]);
    // Check if the day has an event
    var hasEvent = function(day) {
        return eventDates.some(function(event) {
            return event.day === day && event.month === currentMonth && event.year === currentYear;
        });
    };
    // Check if the day is inactive
    var isInactive = function(day) {
        if (!inactiveDatesRange || inactiveDatesRange.length === 0) return false;
        var currentDate = new Date(currentYear, currentMonth, day);
        if (inactiveDatesRange.length === 1) {
            var endDate = inactiveDatesRange[0];
            return currentDate < endDate;
        } else if (inactiveDatesRange.length >= 2) {
            var _inactiveDatesRange_slice = (0, $6iP9u._)(inactiveDatesRange.slice(0, 2), 2), startDate = _inactiveDatesRange_slice[0], endDate1 = _inactiveDatesRange_slice[1];
            return currentDate >= startDate && currentDate <= endDate1;
        }
        return false;
    };
    // Handle date click event
    var handleDateClick = function(day) {
        setSelectedDate({
            day: day,
            month: currentMonth,
            year: currentYear
        });
        clickDate(new Date(currentYear, currentMonth, day));
    };
    // Handle previous month click
    var handlePreviousMonth = function() {
        if (!skipClickMonthChange) clickDate(null);
        if (currentMonth === 0) {
            setCurrentMonth(11);
            setCurrentYear(function(prev) {
                return prev - 1;
            });
        } else setCurrentMonth(function(prev) {
            return prev - 1;
        });
    };
    // Handle next month click
    var handleNextMonth = function() {
        if (!skipClickMonthChange) clickDate(null);
        if (currentMonth === 11) {
            setCurrentMonth(0);
            setCurrentYear(function(prev) {
                return prev + 1;
            });
        } else setCurrentMonth(function(prev) {
            return prev + 1;
        });
    };
    // Define classes for each day
    var dayClasses = function(day) {
        var inactive = isInactive(day);
        var classes = "relative mb-4 size-10 flex flex-col justify-center items-center border border-transparent font-medium rounded-full";
        if (inactive) classes += " text-gray-400 cursor-not-allowed";
        else {
            if (selectedDate && day === selectedDate.day && currentMonth === selectedDate.month && currentYear === selectedDate.year) classes += " bg-primary-500 text-indigo-900";
            else classes += " text-white hover:bg-indigo-800 hover:text-white";
            if (hasEvent(day)) classes += " border-white";
        }
        return classes;
    };
    // Render today dot
    var todayDot = function(day) {
        if (day === today.getDate() && currentMonth === today.getMonth() && currentYear === today.getFullYear()) {
            var classes = "absolute bottom-1 w-0.5 h-0.5 rounded-full";
            if (isInactive(day)) classes += " bg-gray-400";
            else if (selectedDate && day === selectedDate.day && currentMonth === selectedDate.month && currentYear === selectedDate.year) classes += " bg-indigo-900";
            else classes += " bg-white hover:bg-white";
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                className: classes
            });
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {});
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "sm:flex",
        ref: containerRef,
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "space-y-0.5 w-full p-4",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "grid grid-cols-5 items-center gap-x-3 pb-3",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "col-span-1",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("button", {
                                type: "button",
                                onClick: handlePreviousMonth,
                                className: "size-8 flex justify-center items-center text-white hover:bg-indigo-700 rounded-full",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    alt: "left",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b831c536d594a009$exports))),
                                    className: "h-6"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "col-span-3 flex justify-center items-center gap-x-1 text-lg font-medium",
                            children: [
                                months[currentMonth],
                                " ",
                                currentYear
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "col-span-1 flex justify-end",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("button", {
                                type: "button",
                                onClick: handleNextMonth,
                                className: "size-8 flex justify-center items-center text-white hover:bg-indigo-700 rounded-full",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    alt: "right",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e8981ef41dc6cb1b$exports))),
                                    className: "h-6"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "grid grid-cols-7 pb-2.5",
                    style: {
                        columnGap: columnGap
                    },
                    children: [
                        "Mo",
                        "Tu",
                        "We",
                        "Th",
                        "Fr",
                        "Sa",
                        "Su"
                    ].map(function(day) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                            className: "m-px w-10 block text-center font-medium text-white",
                            children: day
                        }, day);
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "grid grid-cols-7",
                    style: {
                        columnGap: columnGap
                    },
                    children: [
                        paddingDays.map(function(paddingDay) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {}, "p_" + paddingDay);
                        }),
                        days.map(function(day) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("button", {
                                onClick: function() {
                                    return handleDateClick(day);
                                },
                                className: dayClasses(day),
                                disabled: isInactive(day),
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                        children: day
                                    }),
                                    todayDot(day)
                                ]
                            }, day);
                        })
                    ]
                })
            ]
        })
    });
};
var $31bdd5593eddf100$export$2e2bcd8739ae039 = $31bdd5593eddf100$var$DatePicker;


var $eef0ed3dd6e17e0e$export$2e2bcd8739ae039 = (0, $31bdd5593eddf100$export$2e2bcd8739ae039);







var $5d9c345a7a20d276$exports = {};
$5d9c345a7a20d276$exports = $parcel$resolve("h71sR");









function $8cba1729a9833283$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var taskId = (0, $bHX26.useParams)().taskId;
    var navigate = (0, $bHX26.useNavigate)();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), task = _useState[0], setTask = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), title = _useState1[0], setTitle = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), categories = _useState2[0], setCategories = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState3[0], setLoaded = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), editDate = _useState4[0], setEditDate = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), deadline = _useState5[0], setDeadline = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), changed = _useState6[0], setChanged = _useState6[1];
    var setGlobalToast = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$12972e612ad7cf0));
    (0, $5s1kH.useEffect)(function() {
        getTask();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (changed) save();
    }, [
        changed
    ]);
    var getTask = function() {
        api.get("client/task/" + taskId).then(function(response) {
            setTask(response.json.task);
            setTitle(response.json.task.name);
            setCategories(response.json.categories);
            if (response.json.task.deadline) setDeadline(new Date(response.json.task.deadline));
            setLoaded(true);
        });
    };
    var save = function() {
        var data = {
            title: title,
            deadline: deadline
        };
        api.post("client/tasks/" + taskId + "/edit", data).then(function(response) {
            setGlobalToast({
                text: t("saved-changes")
            });
            setChanged(false);
        });
    };
    var navigateToEditDescription = function() {
        var message = lang === "sv" ? "Jag vill \xe4ndra beskrivningen av min aktivitet: " : "I want to edit the description on my Action: ";
        var chatMessage = message + title + "\n  " + (lang === "sv" ? "Beskrivning:\n" : "Description:\n") + (task === null || task === void 0 ? void 0 : task.description);
        (0, $d0129b8cfae32aec$export$f93b11ed7a4960f0)("assistant", "task", task === null || task === void 0 ? void 0 : task.focusAreaId, task === null || task === void 0 ? void 0 : task.id, null, chatMessage);
        navigate("/ai/0");
    };
    var changeDate = function(d) {
        setDeadline(d);
        setChanged(true);
        setEditDate(false);
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "w-full h-full flex justify-center mt-4 desktop:mt-6",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "flex flex-col gap-2 justify-center align-middle w-full desktop:w-151 m-4 mt-0",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $acc426d061413a39$export$2e2bcd8739ae039), {})
        })
    });
    if (!task) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "main-one-col small",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-6 flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0fe3991a360589a5$exports))),
                        alt: "task icon",
                        className: "w-6 h-6 desktop:w-10 desktop:h-10"
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "z-body1 text-center",
                    children: t("no-tasks")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    className: "mt-8",
                    onClick: function() {
                        return navigate("/development-plan");
                    },
                    children: t("go-to-focus-area")
                })
            ]
        })
    });
    var showCrumbs = function() {
        var taskName = lang === "sv" ? "Aktivitet" : "Action";
        if (categories > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
            crumbs: [
                {
                    name: t("long-term-goals"),
                    url: "/dev-plan"
                },
                {
                    name: taskName,
                    url: "/tasks/" + taskId
                },
                {
                    name: lang === "sv" ? "\xc4ndra aktivitet" : "Edit action"
                }
            ]
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
            crumbs: [
                {
                    name: lang === "sv" ? "Hem" : "Home",
                    url: "/"
                },
                {
                    name: lang === "sv" ? "Aktiviteter" : "Activities",
                    url: "/tasks"
                },
                {
                    name: taskName,
                    url: "/tasks/" + taskId
                },
                {
                    name: lang === "sv" ? "\xc4ndra aktivitet" : "Edit action"
                }
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            showCrumbs(),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "z-heading2 text-white mt-4 desktop:mt-6",
                children: t("task-edit")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 font-medium",
                children: t("title-placeholder")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                    type: "text",
                    className: "z-input",
                    value: title,
                    onBlur: function() {
                        return setChanged(true);
                    },
                    onChange: function(e) {
                        return setTitle(e.target.value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 font-medium",
                children: t("target-date")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-input",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex justify-between cursor-pointer",
                        onClick: function() {
                            return setEditDate(!editDate);
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                children: deadline ? (0, $7d185b5883a21821$export$9d50e68eb2ee0a21)(deadline) : "-"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                alt: "date",
                                className: "h-4 w-4"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 font-medium",
                children: t("description")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "bg-indigo-800 mt-2 p-4 border-gray-500 border rounded-[6px]",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($5d9c345a7a20d276$exports))),
                                alt: "info"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "ml-4 font-medium",
                                children: lang === "sv" ? "Beskrivning kan \xe4ndras med AI coach" : "Description can be edited with AI coach"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 text-sm",
                        children: lang === "sv" ? "Det \xe4r inte m\xf6jligt att \xe4ndra aktivitetsbeskrivningen h\xe4r \xe4n, men du kan g\xf6ra det tillsammans med din AI coach" : "It\u2019s not possible to edit Action description here yet, but you can do it together with your AI coach."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "outlineWhiteBase",
                        className: "mt-4",
                        onClick: function() {
                            return navigateToEditDescription();
                        },
                        children: lang === "sv" ? "\xc4ndra aktivitet i AI-chatten" : "Edit Action in AI chat"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $65b37309f7d8dd2c$export$2e2bcd8739ae039), {
                className: "mt-6",
                color: "white",
                onClick: function() {
                    return navigate("/tasks/" + taskId);
                },
                children: lang === "sv" ? "Tillbaka till aktivitet" : "Back to Action"
            }),
            editDate && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: true,
                onClose: function() {
                    return setEditDate(false);
                },
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $eef0ed3dd6e17e0e$export$2e2bcd8739ae039), {
                        dates: [],
                        clickDate: changeDate,
                        preSelectedDate: deadline,
                        skipClickMonthChange: true,
                        inactiveDatesRange: [
                            new Date()
                        ]
                    })
                })
            })
        ]
    });
}



var $lFIaz = parcelRequire("lFIaz");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");

var $3SMYb = parcelRequire("3SMYb");


var $5s1kH = parcelRequire("5s1kH");


var $bHX26 = parcelRequire("bHX26");




var $lFIaz = parcelRequire("lFIaz");

var $6iP9u = parcelRequire("6iP9u");

var $3SMYb = parcelRequire("3SMYb");


var $5s1kH = parcelRequire("5s1kH");


var $ce970e80edefa8a8$exports = {};
$ce970e80edefa8a8$exports = $parcel$resolve("ccyCm");


var $983e7e4ab189c038$exports = {};
$983e7e4ab189c038$exports = $parcel$resolve("hL3K8");


var $433931971c417e0e$exports = {};
$433931971c417e0e$exports = $parcel$resolve("6osIC");



var $668a28f3cf683197$exports = {};
$668a28f3cf683197$exports = $parcel$resolve("a0BtY");


// https://platform.openai.com/docs/guides/realtime
// https://learn.microsoft.com/en-us/azure/ai-services/openai/how-to/realtime-audio-webrtc
var $9eb6e5851046ed98$var$Voice = function(props) {
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)("initializing"), 2), voiceState = _useState[0], setVoiceState = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), dataChannel = _useState1[0], setDataChannel = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), micOn = _useState2[0], setMicOn = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(undefined), 2), error = _useState3[0], setError = _useState3[1];
    var peerConnection = (0, $5s1kH.useRef)(null);
    var audioElement = (0, $5s1kH.useRef)(null);
    (0, $5s1kH.useEffect)(function() {
        initSession().then(function() {
            return console.log("Opened voice session");
        }).catch(function(error) {
            console.error(error);
            setError(error);
        });
    }, []);
    function initSession() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var pc, ms, dc, offer, url, sdpResponse, answer, _tmp;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Create a peer connection
                        pc = new RTCPeerConnection();
                        // Set up to play remote audio from the model
                        audioElement.current = document.createElement("audio");
                        audioElement.current.autoplay = true;
                        // @ts-ignore
                        pc.ontrack = function(e) {
                            return audioElement.current.srcObject = e.streams[0];
                        };
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia({
                                audio: true
                            })
                        ];
                    case 1:
                        ms = _state.sent();
                        pc.addTrack(ms.getTracks()[0]);
                        // Set up data channel for sending and receiving events
                        dc = pc.createDataChannel("oai-events");
                        setDataChannel(dc);
                        return [
                            4,
                            pc.createOffer()
                        ];
                    case 2:
                        offer = _state.sent();
                        return [
                            4,
                            pc.setLocalDescription(offer)
                        ];
                    case 3:
                        _state.sent();
                        // const url = "https://swedencentral.openai.azure.com/openai/v1/realtime/calls";
                        url = "https://dazzleai.openai.azure.com/openai/v1/realtime/calls";
                        return [
                            4,
                            fetch(url, {
                                method: "POST",
                                body: offer.sdp,
                                headers: {
                                    Authorization: "Bearer ".concat(props.ephemeralKey),
                                    "Content-Type": "application/sdp"
                                }
                            })
                        ];
                    case 4:
                        sdpResponse = _state.sent();
                        _tmp = {
                            type: "answer"
                        };
                        return [
                            4,
                            sdpResponse.text()
                        ];
                    case 5:
                        answer = (_tmp.sdp = _state.sent(), _tmp);
                        return [
                            4,
                            pc.setRemoteDescription(answer)
                        ];
                    case 6:
                        _state.sent();
                        peerConnection.current = pc;
                        return [
                            2
                        ];
                }
            });
        })();
    }
    var toggleMic = function() {
        var newState = !micOn;
        setMicOn(newState);
        if (peerConnection.current) peerConnection.current.getSenders().forEach(function(sender) {
            if (sender.track) sender.track.enabled = newState;
        });
    };
    // Stop current session, clean up peer connection and data channel
    function stopSession() {
        if (dataChannel) dataChannel.close();
        if (peerConnection.current) peerConnection.current.getSenders().forEach(function(sender) {
            if (sender.track) sender.track.stop();
        });
        if (peerConnection.current) peerConnection.current.close();
        setDataChannel(null);
        peerConnection.current = null;
        props.close();
    }
    // Send a message to the model
    var sendClientMessage = function(message) {
        if (dataChannel) {
            var event = {
                type: "conversation.item.create",
                item: {
                    type: "message",
                    role: "user",
                    content: [
                        {
                            type: "input_text",
                            text: message
                        }
                    ]
                }
            };
            console.log(event);
            dataChannel.send(JSON.stringify(event));
            var eventCreate = {
                type: "response.create",
                response: {
                    // modalities: ["audio", "text"],
                    instructions: "Reply based on the user's input."
                }
            };
            console.log(eventCreate);
            dataChannel.send(JSON.stringify(eventCreate));
        } else console.error("Failed to send message - no data channel available", message);
    };
    // Attach event listeners to the data channel when a new one is created
    (0, $5s1kH.useEffect)(function() {
        if (dataChannel) {
            // Append new server events to the list
            dataChannel.addEventListener("message", function(e) {
                var event = JSON.parse(e.data);
                var role = "";
                var mess = "";
                var functionCall;
                // console.log('New event: ' + event.type);
                // console.log(event);
                if (event.type === "conversation.item.input_audio_transcription.completed") {
                    role = "user";
                    mess = event.transcript;
                } else if (event.type === "response.output_audio_transcript.done") {
                    role = "assistant";
                    mess = event.transcript;
                } else if (event.type === "response.function_call_arguments.done") {
                    setVoiceState("done_talking");
                    role = "assistant";
                    var function_name = event.name;
                    var args = JSON.parse(event.arguments);
                    functionCall = {
                        name: function_name,
                        arguments: args
                    };
                    var clientMessage = "";
                    if (function_name === "create_task") {
                        mess = "Created task: " + args.name;
                        clientMessage = "Give me a short summary of the action you just created";
                    } else if (function_name === "edit_task") {
                        mess = "Edited task: " + args.name;
                        clientMessage = "Give me a short summary of what you just changed in the action";
                    }
                    if (clientMessage.length > 0) {
                        sendClientMessage(clientMessage);
                        setVoiceState("thinking");
                    }
                // } else {
                //   console.log('Unhandled event: ' + event.type);
                //   console.log(event);
                }
                if (role !== "") {
                    // console.log(event)
                    var msg = {
                        role: role,
                        message: mess,
                        sent: new Date(),
                        functionCall: functionCall,
                        aiFile: []
                    };
                    props.saveMessage(msg);
                } else {
                    if (event.type === "input_audio_buffer.speech_started") setVoiceState("recording");
                    else if (event.type === "input_audio_buffer.speech_stopped") setVoiceState("thinking");
                    else if (event.type === "response.done") setVoiceState("done_thinking");
                    else if (event.type === "response.audio.done") setVoiceState("listening");
                    else if (event.type === "output_audio_buffer.started") setVoiceState("done_thinking");
                    else if (event.type === "output_audio_buffer.stopped") setVoiceState("done_talking");
                // if (event.type !== 'response.audio_transcript.delta') console.log(event)
                }
            });
            // Set session active when the data channel is opened
            dataChannel.addEventListener("open", function() {
                setVoiceState("listening");
            // sendClientMessage("Ask what language you should use.")
            });
        }
    }, [
        dataChannel
    ]);
    var formatError = function(err) {
        var msg = err.message;
        if (err.name === "NotAllowedError") msg = props.language === "sv" ? "Du beh\xf6ver ge din browser tillg\xe5ng till mikrofonen" : "You need to give your browser access to your microphone";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-4 border rounded-md border-cherry-500 p-4",
            children: msg
        });
    };
    var formatState = function() {
        var msg = "Unknown state...";
        var animation = null;
        if (error) msg = error.name;
        else if (!micOn) {
            msg = props.language === "sv" ? "Din mikrofon \xe4r avst\xe4ngd" : "Your microphone is muted";
            animation = (0, (/*@__PURE__*/$parcel$interopDefault($01b6e07abd83fc68$exports)));
        } else if (voiceState === "initializing") {
            msg = props.language === "sv" ? "Kontaktar AI..." : "Calling AI, please hold...";
            animation = (0, (/*@__PURE__*/$parcel$interopDefault($01b6e07abd83fc68$exports)));
        } else if (voiceState === "listening" || voiceState === "done_talking") {
            msg = props.language === "sv" ? "Lyssnar..." : "Listening...";
            animation = (0, (/*@__PURE__*/$parcel$interopDefault($668a28f3cf683197$exports)));
        } else if (voiceState === "thinking") {
            msg = props.language === "sv" ? "T\xe4nker..." : "Thinking...";
            animation = (0, (/*@__PURE__*/$parcel$interopDefault($01b6e07abd83fc68$exports)));
        } else if (voiceState === "done_thinking") {
            msg = props.language === "sv" ? "Pratar..." : "Speaking...";
            animation = (0, (/*@__PURE__*/$parcel$interopDefault($433931971c417e0e$exports)));
        } else if (voiceState === "recording") {
            msg = props.language === "sv" ? "Lyssnar..." : "Listening...";
            animation = (0, (/*@__PURE__*/$parcel$interopDefault($433931971c417e0e$exports)));
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-8 flex justify-center",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "flex items-center w-40 h-40",
                        children: animation && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: animation,
                            alt: "animation"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-2 z-title1 text-center",
                    children: msg
                }),
                error ? formatError(error) : ""
            ]
        });
    };
    var micImg = micOn ? (0, (/*@__PURE__*/$parcel$interopDefault($ce970e80edefa8a8$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($983e7e4ab189c038$exports)));
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "fixed w-full h-full",
        style: {
            top: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 38, 1.0)",
            zIndex: 1001
        },
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex items-center justify-center h-full pb-40",
                children: formatState()
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "text-center absolute w-full",
                style: {
                    bottom: 40,
                    left: 0
                },
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex mx-auto justify-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            size: "lg",
                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: micImg,
                                alt: "mic",
                                className: "p-1"
                            }),
                            isRound: true,
                            buttonType: "transparentBase",
                            onClick: function() {
                                return toggleMic();
                            }
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            size: "lg",
                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                                alt: "close",
                                className: "h-6 w-10 px-2"
                            }),
                            className: "ml-2",
                            isRound: true,
                            buttonType: "transparentBase",
                            onClick: function() {
                                return stopSession();
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var $9eb6e5851046ed98$export$2e2bcd8739ae039 = $9eb6e5851046ed98$var$Voice;





var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");


var $cd41ee730e583fd6$exports = {};
$cd41ee730e583fd6$exports = $parcel$resolve("bEUpk");


var $37c865f428a78ded$exports = {};
$37c865f428a78ded$exports = $parcel$resolve("68QJK");


var $2bcadbb81cd88578$exports = {};
$2bcadbb81cd88578$exports = $parcel$resolve("jHIp9");


var $eb60761ed0c84d59$exports = {};
$eb60761ed0c84d59$exports = $parcel$resolve("br8x2");




var $1d2fed0fa04640e3$exports = {};
$1d2fed0fa04640e3$exports = $parcel$resolve("6bpUD");







var $f6e11d7e911b44d5$var$ChatError = /*#__PURE__*/ function(ChatError) {
    ChatError[ChatError["NONE"] = 0] = "NONE";
    ChatError[ChatError["FILE_TOO_LARGE"] = 1] = "FILE_TOO_LARGE";
    ChatError[ChatError["BAD_FILE_FORMAT"] = 2] = "BAD_FILE_FORMAT";
    ChatError[ChatError["AI_REQUEST_FAILED"] = 3] = "AI_REQUEST_FAILED";
    ChatError[ChatError["TOO_MANY_FILES"] = 4] = "TOO_MANY_FILES";
    return ChatError;
}($f6e11d7e911b44d5$var$ChatError || {});
var $f6e11d7e911b44d5$var$ChatThreadInput = function(param) {
    var sendToOtherPage = param.sendToOtherPage, handleSendMessage = param.handleSendMessage, onHeightChange = param.onHeightChange, startVoice = param.startVoice, coachStyle = param.coachStyle, setCoachStyle = param.setCoachStyle, emmaThinking = param.emmaThinking, placeholder = param.placeholder, _param_hideVoice = param.hideVoice, hideVoice = _param_hideVoice === void 0 ? false : _param_hideVoice;
    var containerRef = (0, $5s1kH.useRef)(null);
    var textareaRef = (0, $5s1kH.useRef)(null);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showSelectStyle = _useState[0], setShowSelectStyle = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), input = _useState1[0], setInput = _useState1[1];
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useAtom = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$8ded2467eceddfeb)), 2), fileRaw = _useAtom[0], setFileRaw = _useAtom[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), chatError = _useState2[0], setChatError = _useState2[1];
    var modes = [
        [
            "assistant",
            "Neutral",
            lang === "sv" ? "F\xe5 snabba svar och hantera vardagliga uppgifter" : "Get quick answers and handle everyday tasks"
        ],
        [
            "coaching",
            "Coaching",
            lang === "sv" ? "F\xe5 v\xe4gledning f\xf6r sj\xe4lvreflektion och utveckling" : "Get guidance for self-reflection and growth"
        ]
    ];
    if ((0, $632c75b97b900307$export$1630b5343357e8b5).SYSTEM !== 'production') modes.push([
        "chaining",
        "Testing",
        "Staging only - find out how to prompt background info"
    ]);
    var isSmallScreen = function() {
        return window.innerWidth < 501;
    };
    var isMobile = isSmallScreen();
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(function() {
        return !isSmallScreen();
    }), 2), showButtons = _useState3[0], setShowButtons = _useState3[1];
    var sendMessage = function() {
        if (blockSend()) return;
        if (input.trim() === "" && (!fileRaw || fileRaw.length === 0)) return; // Prevent sending empty messages
        handleSendMessage(input, null, fileRaw || []);
        // If this component is used in other page than AiThreads, reset the input
        if (!sendToOtherPage) {
            setFileRaw([]);
            setInput(""); // Clear the input field
            if (textareaRef.current) {
                textareaRef.current.style.height = "auto";
                // Blur the textarea to trigger onBlur and allow shrinking
                if (isSmallScreen()) textareaRef.current.blur();
            }
        }
        // Shrink chat input on small screens after sending
        if (isSmallScreen()) setShowButtons(false);
    };
    (0, $5s1kH.useEffect)(function() {
        if (!containerRef.current) return;
        var handleResize = function() {
            if (containerRef.current && onHeightChange) {
                var height = containerRef.current.offsetHeight;
                onHeightChange(height);
            }
        };
        handleResize(); // Initial height measurement
        var observer = new ResizeObserver(handleResize);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        containerRef,
        onHeightChange
    ]);
    var selectCoachStyle = function(mode) {
        setCoachStyle(mode);
        setShowSelectStyle(false);
    };
    var showCoachStyle = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = modes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mode = _step.value;
                if (mode[0] === coachStyle) return mode[1];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return "Coaching";
    };
    var removeFile = function(idx) {
        var newFiles = (0, $XnYkK._)(fileRaw);
        newFiles.splice(idx, 1);
        setFileRaw(newFiles);
        var fileInput = document.getElementById("profileFile");
        if (fileInput) fileInput.value = "";
    };
    var pasteFile = function(evt) {
        // stop unwanted pasted text/path
        if (evt.clipboardData.files) {
            if (evt.clipboardData.files.length > 0) {
                evt.preventDefault();
                handleFilesSelected(evt.clipboardData.files);
            } else return;
        }
    };
    var dropFile = function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        if (evt.dataTransfer.files.length > 0) handleFilesSelected(evt.dataTransfer.files);
        else alert("Error: We could not find any dropped files.");
    };
    // Helper to process a single file
    var processFile = function(_file) {
        return new Promise(function(resolve) {
            if (!_file) return resolve(null);
            if (_file.size > 12000000) {
                setChatError(1);
                return resolve(null);
            }
            var filetype = "";
            if (_file.type === "application/pdf") filetype = "pdf";
            else if (_file.type.match("image.*")) filetype = "image";
            else if (_file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || _file.type === "application/vnd.ms-excel") filetype = "excel";
            else if (_file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || _file.type === "application/msword") filetype = "word";
            else {
                setChatError(2);
                return resolve(null);
            }
            var filename = _file.name;
            if (filetype === "excel") {
                var reader = new FileReader();
                reader.onload = function(e) {
                    var _e_target;
                    var arrayBuffer = (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.result;
                    var uint8Array = new Uint8Array(arrayBuffer);
                    var binaryString = Array.from(uint8Array).map(function(byte) {
                        return String.fromCharCode(byte);
                    }).join("");
                    var base64String = btoa(binaryString);
                    resolve({
                        filename: filename,
                        filetype: filetype,
                        bytes: base64String,
                        length: base64String.length
                    });
                };
                reader.readAsArrayBuffer(_file);
            } else if (filetype === "word") {
                var reader1 = new FileReader();
                reader1.onload = function(e) {
                    var _e_target;
                    var arrayBuffer = (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.result;
                    var uint8Array = new Uint8Array(arrayBuffer);
                    var binaryString = Array.from(uint8Array).map(function(byte) {
                        return String.fromCharCode(byte);
                    }).join("");
                    var base64String = btoa(binaryString);
                    resolve({
                        filename: filename,
                        filetype: filetype,
                        bytes: base64String,
                        length: base64String.length
                    });
                };
                reader1.readAsArrayBuffer(_file);
            } else {
                var reader2 = new FileReader();
                reader2.onload = function(e) {
                    var _e_target, _e_target1;
                    resolve({
                        filename: filename,
                        filetype: filetype,
                        bytes: (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.result,
                        length: ((_e_target1 = e.target) === null || _e_target1 === void 0 ? void 0 : _e_target1.result).length
                    });
                };
                reader2.readAsDataURL(_file);
            }
        });
    };
    // Multi-file handler for input
    var handleFilesSelected = function(fileList) {
        var currentFiles = fileRaw || [];
        var filesArray = Array.from(fileList);
        if (currentFiles.length + filesArray.length > 8) {
            setChatError(4);
            return;
        }
        var availableSlots = 8 - currentFiles.length;
        var filesToAdd = filesArray.slice(0, availableSlots);
        Promise.all(filesToAdd.map(processFile)).then(function(newFiles) {
            var validFiles = newFiles.filter(function(f) {
                return f !== null;
            });
            setFileRaw((0, $XnYkK._)(currentFiles).concat((0, $XnYkK._)(validFiles)));
        });
    };
    // const startVoiceError = () => {
    //   let errorMsg = lang === 'sv' ? 'Röstfunktionen är tillfälligt ur funktion på grund av serverproblem hos Microsoft Azure. Vi arbetar aktivt med att lösa problemet.' :
    //     'The voice function is temporarily unavailable due to server issues at Microsoft Azure. We are actively working to resolve the problem.'
    //   alert(errorMsg)
    // }
    var closeChatError = function() {
        setFileRaw([]);
        setChatError(0);
    };
    var renderChatError = function() {
        var header = "Unknown error";
        if (chatError === 3) header = lang === "sv" ? "AI-anropet misslyckades" : "AI request failed";
        else if (chatError === 2) header = lang === "sv" ? "Filformatet st\xf6ds inte" : "Unsupported file type";
        else if (chatError === 1) header = lang === "sv" ? "Filstorleken \xe4r f\xf6r stor" : "File size too large";
        else if (chatError === 4) header = lang === "sv" ? "F\xf6r m\xe5nga filer" : "Too many files";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: function() {
                return closeChatError();
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return closeChatError();
                    },
                    children: header
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: [
                        chatError === 3 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-left",
                            children: lang === "sv" ? "Ett fel uppstod n\xe4r AI skulle svara p\xe5 din fr\xe5ga." : "An error occured when your request was handled."
                        }),
                        chatError === 2 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-left",
                            children: lang === "sv" ? "Detta filformat st\xf6ds inte. Ladda upp en PNG, JPEG, PDF, Word, eller Excel-fil." : "This file format isn't supported. Please upload a PNG, JPEG, PDF, Word, or Excel file."
                        }),
                        chatError === 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "text-left",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: lang === "sv" ? "Filen du laddar upp kan inte vara st\xf6rre \xe4n 12 MB." : "The file you upload cannot be larger than 12 MB."
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "mt-4",
                                    children: lang === "sv" ? "Prova att ladda upp en mindre fil." : "Try uploading a smaller file."
                                })
                            ]
                        }),
                        chatError === 4 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-left",
                            children: lang === "sv" ? "Du kan bara ladda upp max 8 filer \xe5t g\xe5ngen." : "You can only upload up to 8 files at a time."
                        })
                    ]
                })
            ]
        });
    };
    var blockSend = function() {
        if (emmaThinking) return true;
        if (input.length < 1 && fileRaw === null) return true;
        return false;
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "".concat(showButtons ? "pb-2 pt-3" : "pb-1 pt-1", " rounded-md ring-1 ring-indigo-600 bg-indigo-900 focus-within:ring-2 focus-within:ring-primary-500 transition-all duration-150 ease-in-out relative"),
        ref: containerRef,
        onClick: function() {
            if (isSmallScreen()) setShowButtons(true);
        },
        onDrop: function(e) {
            e.currentTarget.classList.remove("ring-primary-500");
            dropFile(e);
        },
        onDragOver: function(e) {
            e.stopPropagation();
            e.preventDefault();
            e.currentTarget.classList.add("ring-primary-500");
        },
        onDragLeave: function(e) {
            e.stopPropagation();
            e.preventDefault();
            e.currentTarget.classList.remove("ring-primary-500");
        },
        onPaste: function(e) {
            e.currentTarget.classList.remove("ring-primary-500");
            pasteFile(e);
        },
        children: [
            fileRaw && fileRaw.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mb-2 px-4 flex flex-wrap gap-2",
                children: fileRaw.map(function(file, idx) {
                    return file.filetype === "image" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "relative inline-block",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: file.bytes,
                                alt: "uploaded",
                                className: "z-uploaded-file rounded-[6px]"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "absolute top-1 right-1 rounded-full bg-indigo-900 h-6 w-6 p-1 cursor-pointer hover:bg-indigo-700",
                                onClick: function() {
                                    return removeFile(idx);
                                },
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                                    className: "h-4 w-4",
                                    alt: "remove"
                                })
                            })
                        ]
                    }, idx) : file.filetype === "excel" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex rounded-md bg-indigo-900 p-2 items-center relative",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "rounded-[4px] bg-indigo-700 p-2",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1d2fed0fa04640e3$exports))),
                                    alt: "excel",
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "ml-2 text-left text-gray-400 z-title4",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "truncate",
                                        style: {
                                            width: 150
                                        },
                                        children: file.filename
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        children: "Excel"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "absolute top-1 right-1 rounded-full bg-indigo-900 h-6 w-6 p-1 cursor-pointer",
                                onClick: function() {
                                    return removeFile(idx);
                                },
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                                    className: "h-4 w-4",
                                    alt: "remove"
                                })
                            })
                        ]
                    }, idx) : file.filetype === "word" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex rounded-md bg-indigo-900 p-2 items-center relative",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "rounded-[4px] bg-indigo-700 p-2",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1d2fed0fa04640e3$exports))),
                                    alt: "word",
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "ml-2 text-left text-gray-400 z-title4",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "truncate",
                                        style: {
                                            width: 150
                                        },
                                        children: file.filename
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        children: "Word"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "absolute top-1 right-1 rounded-full bg-indigo-900 h-6 w-6 p-1 cursor-pointer",
                                onClick: function() {
                                    return removeFile(idx);
                                },
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                                    className: "h-4 w-4",
                                    alt: "remove"
                                })
                            })
                        ]
                    }, idx) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex rounded-md bg-indigo-900 p-2 items-center relative",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "rounded-[4px] bg-indigo-700 p-2",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1d2fed0fa04640e3$exports))),
                                    alt: "pdf",
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "ml-2 text-left text-gray-400 z-title4",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "truncate",
                                        style: {
                                            width: 150
                                        },
                                        children: file.filename
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        children: "PDF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "absolute top-1 right-1 rounded-full bg-indigo-900 h-6 w-6 p-1 cursor-pointer",
                                onClick: function() {
                                    return removeFile(idx);
                                },
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                                    className: "h-4 w-4",
                                    alt: "remove"
                                })
                            })
                        ]
                    }, idx);
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex grow items-center",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                    ref: textareaRef,
                    placeholder: placeholder ? placeholder : t("chat-placeholder"),
                    className: "flex-1  text-white rounded-md resize-none overflow-y-auto border-none focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none ".concat(showButtons ? "px-4 py-2 max-h-40" : "px-3 py-1 pr-12 max-h-24"),
                    style: {
                        whiteSpace: "normal"
                    },
                    value: input,
                    onChange: function(e) {
                        setInput(e.target.value);
                        if (textareaRef.current) {
                            textareaRef.current.style.height = "auto";
                            textareaRef.current.style.height = "".concat(textareaRef.current.scrollHeight, "px");
                        }
                    },
                    onFocus: function() {
                        return setShowButtons(true);
                    },
                    //onBlur={() => {
                    //  if (isSmallScreen()) setShowButtons(false);
                    //}}
                    onKeyDown: function(e) {
                        if (e.key === "Enter" && !e.shiftKey && !isMobile) {
                            e.preventDefault();
                            sendMessage();
                        }
                    },
                    rows: 1
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex ".concat(showButtons ? "mt-2" : "mt-1", " justify-between transition-all duration-150"),
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex ml-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "".concat(showButtons ? "flex" : "hidden", " relative align-middle cursor-pointer items-center justify-center bg-indigo-800 px-4 py-2 rounded-full hover:bg-indigo-700"),
                                onClick: function() {
                                    return setShowSelectStyle(!showSelectStyle);
                                },
                                children: [
                                    showSelectStyle && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                                        isOpen: true,
                                        onClose: function() {
                                            return setShowSelectStyle(false);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                                                onClose: function() {
                                                    return setShowSelectStyle(false);
                                                },
                                                children: lang === "sv" ? "V\xe4lj samtalsstil" : "Select a conversation style"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    children: modes.map(function(mode, index) {
                                                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                            onClick: function() {
                                                                return selectCoachStyle(mode[0]);
                                                            },
                                                            className: "p-2 rounded hover:bg-indigo-800 text-left" + (mode[0] === coachStyle ? " bg-indigo-800" : ""),
                                                            children: [
                                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                                    className: "flex justify-between items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                                            className: "font-medium",
                                                                            children: mode[1]
                                                                        }),
                                                                        mode[0] === coachStyle && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($2bcadbb81cd88578$exports))),
                                                                            alt: "checked"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                                    className: "mt-1 text-sm text-gray-400",
                                                                    children: mode[2]
                                                                })
                                                            ]
                                                        }, "mode_" + index);
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($eb60761ed0c84d59$exports))),
                                        alt: "icon",
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "hidden lg:block ml-2 text-sm text-gray-400",
                                        children: showCoachStyle()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "".concat(showButtons ? "flex" : "hidden", " ").concat(fileRaw.length >= 8 ? "opacity-40 pointer-events-none" : " hover:bg-indigo-700", " ml-2 align-middle cursor-pointer items-center justify-center bg-indigo-800 px-4 py-2 rounded-full"),
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                        id: "profileFile",
                                        type: "file",
                                        className: "hidden",
                                        multiple: true,
                                        onChange: function(e) {
                                            return handleFilesSelected(e.target.files);
                                        },
                                        disabled: fileRaw.length >= 8
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("label", {
                                        htmlFor: "profileFile",
                                        className: "flex items-center cursor-pointer",
                                        style: {
                                            margin: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($749d65ec77f6e156$exports))),
                                                alt: "icon",
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                className: "hidden lg:block ml-2 text-sm text-gray-400",
                                                children: lang === "sv" ? "Ladda upp" : "Upload"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !hideVoice && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "".concat(showButtons ? "flex" : "hidden", " ml-2 align-middle cursor-pointer items-center justify-center bg-indigo-800 px-4 py-2 rounded-full hover:bg-indigo-700"),
                                onClick: function() {
                                    return startVoice();
                                },
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($37c865f428a78ded$exports))),
                                        alt: "icon",
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "hidden lg:block ml-2 text-sm text-gray-400 cursor-pointer",
                                        children: lang === "sv" ? "R\xf6stl\xe4ge" : "Voice mode"
                                    })
                                ]
                            })
                        ]
                    }),
                    showButtons ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        size: "lg",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cd41ee730e583fd6$exports))),
                            alt: "send",
                            className: "p-2"
                        }),
                        onClick: function(e) {
                            e.stopPropagation();
                            sendMessage();
                        },
                        disabled: blockSend(),
                        className: "mx-2"
                    }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        size: "lg",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cd41ee730e583fd6$exports))),
                            alt: "send",
                            className: "p-2"
                        }),
                        onClick: sendMessage,
                        disabled: blockSend(),
                        className: "absolute right-3 top-1/2 transform -translate-y-1/2"
                    })
                ]
            }),
            chatError !== 0 && renderChatError()
        ]
    });
};
var $f6e11d7e911b44d5$export$2e2bcd8739ae039 = $f6e11d7e911b44d5$var$ChatThreadInput;




var $11d17cb94e9b6332$exports = {};
$11d17cb94e9b6332$exports = $parcel$resolve("bEf0y");


var $77be1a01a9b27ed1$exports = {};
$77be1a01a9b27ed1$exports = $parcel$resolve("5b4CI");









var $79e724f81568affa$var$StreamEnum = /*#__PURE__*/ function(StreamEnum) {
    StreamEnum[StreamEnum["WAITING"] = 0] = "WAITING";
    StreamEnum[StreamEnum["THINKING"] = 1] = "THINKING";
    StreamEnum[StreamEnum["DONE"] = 2] = "DONE";
    return StreamEnum;
}($79e724f81568affa$var$StreamEnum || {});
var $79e724f81568affa$var$LastAction = /*#__PURE__*/ function(LastAction) {
    LastAction[LastAction["NONE"] = 0] = "NONE";
    LastAction[LastAction["CHANGE_THREAD"] = 1] = "CHANGE_THREAD";
    LastAction[LastAction["SENT_QUESTION"] = 2] = "SENT_QUESTION";
    LastAction[LastAction["RECEIVED_ANSWER"] = 3] = "RECEIVED_ANSWER";
    return LastAction;
}($79e724f81568affa$var$LastAction || {});
var $79e724f81568affa$var$CHAT_PAGE = 10; // NOTE:number of messages to load per API call
var $79e724f81568affa$var$AiStart = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useAtom = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$27d71ceb0a5d4830)), 2), threads = _useAtom[0], setThreads = _useAtom[1];
    var _useAtom1 = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$8ded2467eceddfeb)), 2), fileRaw = _useAtom1[0], setFileRaw = _useAtom1[1];
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), focusAreaId = _useState[0], setFocusAreaId = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)("0"), 2), threadId = _useState1[0], setThreadId = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)("assistant"), 2), coachStyle = _useState2[0], setCoachStyle = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), useVoice = _useState3[0], setUseVoice = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState4[0], setLoaded = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState5[0], setError = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), noScroll = _useState6[0], setNoScroll = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), messages = _useState7[0], setMessages = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), lastMessage = _useState8[0], setLastMessage = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), message = _useState9[0], setMessage = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), ephemeralKey = _useState10[0], setEphemeralKey = _useState10[1];
    var _useState11 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), streamStatus = _useState11[0], setStreamStatus = _useState11[1];
    var _useState12 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), emmaThinking = _useState12[0], setEmmaThinking = _useState12[1];
    var _useState13 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showDebug = _useState13[0], setShowDebug = _useState13[1];
    var _useState14 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), debugInfo = _useState14[0], setDebugInfo = _useState14[1];
    var _useState15 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), newQuestion = _useState15[0], setNewQuestion = _useState15[1];
    var _useState16 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), lastAction = _useState16[0], setLastAction = _useState16[1];
    var chatWindowRef = (0, $5s1kH.useRef)(null);
    // load old message
    var _useState17 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loadingMoreMsgs = _useState17[0], setLoadingMoreMsgs = _useState17[1];
    // Stop calling API when react very first message
    var _useState18 = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), allMsgsLoaded = _useState18[0], setAllMsgsLoaded = _useState18[1];
    // Stable refs — values readable inside scroll listener and loadMoreMsgs without going stale
    var allMsgsLoadedRef = (0, $5s1kH.useRef)(true);
    var loadingMoreMsgsRef = (0, $5s1kH.useRef)(false);
    var threadIdRef = (0, $5s1kH.useRef)("0");
    var firstMsgNumberRef = (0, $5s1kH.useRef)(null);
    // Scroll restoration ref — set just before setMessages, consumed by useLayoutEffect
    var pendingScrollRestoreRef = (0, $5s1kH.useRef)(null);
    var now = new Date();
    // Scroll restoration 
    (0, $5s1kH.useLayoutEffect)(function() {
        var restore = pendingScrollRestoreRef.current;
        if (restore && chatWindowRef.current) {
            var added = chatWindowRef.current.scrollHeight - restore.prevScrollHeight;
            chatWindowRef.current.scrollTop = restore.prevScrollTop + added;
            pendingScrollRestoreRef.current = null;
        }
    }, [
        messages
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (location.pathname.startsWith("/ai/")) {
            var _threadId = location.pathname.substring(4);
            if (_threadId !== "0") {
                setNoScroll(false);
                setLastAction(1);
                selectThread(_threadId);
            } else {
                setLastAction(0);
                setThreadId("0");
                threadIdRef.current = "0";
                setMessages([]);
                setLoaded(true);
            }
        }
    }, [
        location.pathname
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (streamStatus === 2) {
            setLastAction(3);
            if (message) {
                addMessage(message);
                setMessage(null);
            }
            setLastMessage("");
        }
    }, [
        streamStatus
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (loaded) {
            var aiThreadStart = (0, $d0129b8cfae32aec$export$f602d6403baa792d)();
            if (aiThreadStart) {
                if (aiThreadStart.aiStyle) setCoachStyle(aiThreadStart.aiStyle);
                if (aiThreadStart.focusAreaId) setFocusAreaId(aiThreadStart.focusAreaId);
                var message = aiThreadStart.message;
                if (message === null) {
                    if (aiThreadStart.type === "focusArea") message = lang === "sv" ? "Jag vill starta coaching inom fokusomr\xe5det" : "I want to start coaching within the focus area";
                    else if (aiThreadStart.type === "assistant") {
                        setCoachStyle("assistant");
                        message = lang === "sv" ? "L\xe4r mig mer om \xe4mnet" : "Learn more about the topic";
                    } else if (aiThreadStart.type === "voice") startVoice();
                }
                if (message || fileRaw) {
                    var _message = message ? message : "";
                    send(_message, aiThreadStart, fileRaw);
                } else if (aiThreadStart.systemMessage) setMessages([
                    {
                        role: "system",
                        message: aiThreadStart.systemMessage,
                        sent: new Date(),
                        aiFile: []
                    }
                ]);
            }
        }
    }, [
        loaded
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (threadId === "_old_chat") {
            if (chatWindowRef.current) chatWindowRef.current.scrollTo(0, chatWindowRef.current.scrollHeight);
        } else {
            if (messages.length > 1) nameThread();
            // Keep the scroll listener blocked until the initial scroll completes:
            if (lastAction === 1) {
                loadingMoreMsgsRef.current = true; // block scroll listener
                setLastAction(0);
                setTimeout(function() {
                    var lastMsg = document.getElementById("last_msg_true");
                    var container = chatWindowRef.current;
                    if (lastMsg && container) {
                        var msgTop = lastMsg.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
                        container.scrollTo({
                            top: msgTop
                        });
                    }
                    loadingMoreMsgsRef.current = false; // unblock after scroll
                }, 250);
            } else if (lastAction === 2) scrollToTopOfQuestion();
        }
    }, [
        messages
    ]);
    // Scroll listener
    (0, $5s1kH.useEffect)(function() {
        var container = chatWindowRef.current;
        if (!container) return;
        function onScroll() {
            if (container.scrollTop < 80) loadMoreMsgs();
        }
        container.addEventListener('scroll', onScroll, {
            passive: true
        });
        return function() {
            return container.removeEventListener('scroll', onScroll);
        };
    }, [
        loaded,
        threadId
    ]);
    var loadMoreMsgs = (0, $5s1kH.useRef)(function() {
        if (loadingMoreMsgsRef.current || allMsgsLoadedRef.current) return;
        var _threadId = threadIdRef.current;
        if (!_threadId || _threadId === "0" || _threadId === "_old_chat") return;
        loadingMoreMsgsRef.current = true;
        setLoadingMoreMsgs(true);
        var container = chatWindowRef.current;
        var _container_scrollHeight;
        var prevScrollHeight = (_container_scrollHeight = container === null || container === void 0 ? void 0 : container.scrollHeight) !== null && _container_scrollHeight !== void 0 ? _container_scrollHeight : 0;
        var _container_scrollTop;
        var prevScrollTop = (_container_scrollTop = container === null || container === void 0 ? void 0 : container.scrollTop) !== null && _container_scrollTop !== void 0 ? _container_scrollTop : 0;
        var qs = firstMsgNumberRef.current != null ? "?limit=".concat($79e724f81568affa$var$CHAT_PAGE, "&before_number=").concat(firstMsgNumberRef.current) : "?limit=".concat($79e724f81568affa$var$CHAT_PAGE);
        api.get("client/chat_thread/".concat(_threadId).concat(qs)).then(function(response) {
            var older = response.json.messages.map(function(msg) {
                return {
                    number: msg.number,
                    role: msg.role,
                    message: msg.message,
                    sent: new Date(msg.sent),
                    functionCall: msg.functionCall,
                    taskId: msg.taskId,
                    aiFile: Array.isArray(msg.aiFile) ? msg.aiFile : msg.aiFile ? [
                        msg.aiFile
                    ] : []
                };
            });
            if (older.length === 0) {
                allMsgsLoadedRef.current = true;
                setAllMsgsLoaded(true);
                loadingMoreMsgsRef.current = false;
                return;
            }
            if (older[0].number === 0) {
                allMsgsLoadedRef.current = true;
                setAllMsgsLoaded(true);
            }
            var _older__number;
            firstMsgNumberRef.current = (_older__number = older[0].number) !== null && _older__number !== void 0 ? _older__number : null;
            pendingScrollRestoreRef.current = {
                prevScrollTop: prevScrollTop,
                prevScrollHeight: prevScrollHeight
            };
            setMessages(function(prev) {
                return (0, $XnYkK._)(older).concat((0, $XnYkK._)(prev));
            });
        }).finally(function() {
            setLoadingMoreMsgs(false);
        });
    }).current;
    (0, $5s1kH.useEffect)(function() {
        if (!loadingMoreMsgs) loadingMoreMsgsRef.current = false;
    }, [
        loadingMoreMsgs
    ]);
    var scrollToTopOfQuestion = function() {
        setTimeout(function() {
            var lastMsg = document.getElementById("last_msg_true");
            var container = chatWindowRef.current;
            // getBoundingClientRect() which always returns the actual rendered position
            if (lastMsg && container) {
                var msgTop = lastMsg.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
                container.scrollTo({
                    top: msgTop,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        }, 200);
    };
    var selectThread = function(threadId) {
        threadIdRef.current = threadId;
        firstMsgNumberRef.current = null;
        allMsgsLoadedRef.current = false;
        setAllMsgsLoaded(false);
        loadingMoreMsgsRef.current = true;
        api.get("client/chat_thread/".concat(threadId, "?limit=").concat($79e724f81568affa$var$CHAT_PAGE)).then(function(response) {
            if (response.json.error) {
                alert(response.json.error);
                setError(response.json.error);
            }
            setNewQuestion(false);
            var _messages = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = response.json.messages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var msg = _step.value;
                    _messages.push({
                        number: msg.number,
                        role: msg.role,
                        message: msg.message,
                        sent: new Date(msg.sent),
                        functionCall: msg.functionCall,
                        taskId: msg.taskId,
                        aiFile: Array.isArray(msg.aiFile) ? msg.aiFile : msg.aiFile ? [
                            msg.aiFile
                        ] : []
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            // Determine if we are already at the beginning of the thread
            if (_messages.length > 0 && _messages[0].number != null) {
                firstMsgNumberRef.current = _messages[0].number;
                if (_messages[0].number === 0) {
                    allMsgsLoadedRef.current = true;
                    setAllMsgsLoaded(true);
                }
            } else {
                // No messages or no number — nothing more to load
                allMsgsLoadedRef.current = true;
                setAllMsgsLoaded(true);
            }
            setMessages(_messages);
            setFocusAreaId(response.json.focusAreaId);
            if (response.json.coachStyle) setCoachStyle(response.json.coachStyle);
            else if (response.json.focusAreaId) setCoachStyle("coaching");
            else setCoachStyle("assistant");
            var _threads = (0, $XnYkK._)(threads);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = _threads[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _thread = _step1.value;
                    if (_thread.id === threadId) _thread.selected = true;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            setThreads(_threads);
            setThreadId(threadId);
            threadIdRef.current = threadId;
            setLoaded(true);
            loadingMoreMsgsRef.current = false; // unblock scroll listener
        });
    };
    var clickTopic = function(topic) {
        api.get("client/topic_click?f=ai_tip&t=" + topic).then(function() {
            send(topic, null, []);
        });
    };
    var addThread = function(_threadId, _name) {
        var now = new Date().toISOString();
        var newThread = {
            id: _threadId,
            topic: "New topic",
            name: _name ? _name : lang === "sv" ? "Eget \xe4mne" : "Own topic",
            created: now,
            updated: now,
            focusAreaId: focusAreaId,
            selected: true
        };
        setThreads([
            newThread
        ].concat((0, $XnYkK._)(threads)));
    };
    var addMessage = function(msg) {
        setMessages(function(prevMessages) {
            return (0, $XnYkK._)(prevMessages).concat([
                msg
            ]);
        });
    };
    var saveMessage = function(msg) {
        setMessages(function(prevMessages) {
            return (0, $XnYkK._)(prevMessages).concat([
                msg
            ]);
        });
        var data = {
            role: msg.role,
            message: msg.message,
            sent: msg.sent,
            functionCall: msg.functionCall,
            threadId: threadId,
            messageType: useVoice ? 2 : 1
        };
        api.post("client/chat_thread_save", data).then();
    };
    var getThread = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = threads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var thread = _step.value;
                if (thread.id === threadId) return thread;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    var nameThread = function() {
        var thread = getThread();
        if (thread && thread.topic === "New topic") {
            if (messages.length < 6) {
                // Try naming the thread early if we have enough data
                var message_length = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = messages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var m = _step.value;
                        message_length += m.message.length;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (message_length < 300) return;
            }
            api.get("client/chat_thread_give_name/" + threadId).then(function(result) {
                var threadName = result.json.name;
                var _threads = (0, $XnYkK._)(threads);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _threads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _thread = _step.value;
                        if (_thread.id === threadId) {
                            _thread.topic = threadName;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                setThreads(_threads);
            });
        }
    };
    function handleStream(reader) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var done, value, streamResponse, finalResponse, decoder, ref, data, responseData, aiResponse;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        streamResponse = "";
                        finalResponse = "";
                        decoder = new TextDecoder();
                        _state.label = 1;
                    case 1:
                        if (!!done) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            reader.read()
                        ];
                    case 2:
                        ref = _state.sent(), value = ref.value, done = ref.done, ref;
                        if (done) {
                            console.log("Closed stream. finalResponse is " + finalResponse.length + " bytes");
                            if (finalResponse.length > 0) try {
                                // console.log(finalResponse);
                                data = JSON.parse(finalResponse);
                                if (data.aiResponse) {
                                    setMessage({
                                        role: "assistant",
                                        message: data.aiResponse,
                                        sent: new Date(),
                                        functionCall: data.functionCall,
                                        taskId: data.taskId,
                                        aiFile: []
                                    });
                                    setDebugInfo(data.debug);
                                } else console.log(data);
                                if (threadId === "0" && data.threadId) {
                                    addThread(data.threadId, null);
                                    navigate("/ai/" + data.threadId);
                                }
                            } catch (error) {
                                console.log(error);
                            }
                            return [
                                2
                            ];
                        }
                        responseData = decoder.decode(value);
                        // console.log("Got data: " + responseData);
                        // If we have received start of finalResponse, add to it
                        if (finalResponse.length > 0) {
                            console.log('Adding ' + responseData.length + " bytes to finalResponse which is " + finalResponse.length);
                            finalResponse += responseData;
                        } else {
                            // Look for position of {"aiResponse". If we find that, this is the start of finalResponse
                            aiResponse = responseData.indexOf('{"aiResponse"');
                            if (aiResponse > -1) {
                                console.log("Found start of final message at " + aiResponse);
                                finalResponse = responseData.substring(aiResponse);
                            }
                        }
                        if (finalResponse.length === 0) {
                            if (responseData && responseData.startsWith("_-_")) setLastMessage(responseData.substring(3));
                            else {
                                streamResponse += responseData;
                                setLastMessage(streamResponse);
                            }
                        }
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    var send = function(text, aiThreadStart) {
        var aiFiles = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        setNoScroll(true);
        setNewQuestion(true);
        setLastAction(2);
        var msg = {
            role: "user",
            message: text,
            sent: new Date(),
            aiFile: aiFiles
        };
        addMessage(msg);
        var _focusAreaId = aiThreadStart ? aiThreadStart.focusAreaId : focusAreaId;
        var _threadId = aiThreadStart ? aiThreadStart.threadId : threadId;
        var _taskId = aiThreadStart ? aiThreadStart.taskId : null;
        var _coachStyle = coachStyle;
        var _originId = aiThreadStart ? aiThreadStart.originId : null;
        var _originName = aiThreadStart ? aiThreadStart.originName : null;
        if (aiThreadStart && aiThreadStart.aiStyle) _coachStyle = aiThreadStart.aiStyle;
        if (!_threadId) _threadId = "0";
        var data = {
            focusAreaId: _focusAreaId,
            threadId: _threadId,
            coachStyle: _coachStyle,
            taskId: _taskId,
            message: text,
            messageType: useVoice ? 2 : 1,
            originId: _originId,
            originName: _originName,
            aiFile: aiFiles
        };
        setFileRaw([]);
        var url = "fast_api/client/chat_thread_send_thread_stream";
        setStreamStatus(1);
        setLastMessage("&nbsp;");
        api.post(url, data, [], false, true).then(function(response) {
            if (response.response.ok) {
                if (response.response.body) handleStream(response.response.body.getReader()).then(function() {
                    setStreamStatus(2);
                    setTimeout(function() {
                        // Wait before enabling scroll again, since other processes want to scroll
                        setNoScroll(false);
                    }, 800);
                });
            } else alert(response.response.statusText);
        }).catch(function(error) {
            // This should be displayed as alert from api handler
            console.log(error);
            setStreamStatus(2);
            setEmmaThinking(false);
        });
    };
    // Correct scroll
    var chatInputHeightChange = function(height) {
        if (noScroll) // Do not scroll if explicitly disabled
        return;
        var container = chatWindowRef.current;
        if (!container) return;
        var winWidth = window.innerWidth;
        var ySpace = winWidth < 636 ? 105 : 121;
        var subtractHeight = ySpace + height;
        // Always resize the container.
        container.style.height = "calc(100dvh - " + subtractHeight + "px)";
        // Only scroll to bottom if the user is already near the bottom.
        // When the user has scrolled up to load older messages the distance
        // from the bottom is large, so we leave the scroll position alone.
        // This replaces all timing-based ref/lastAction guards which were
        // unreliable because ResizeObserver callbacks fire asynchronously
        // outside the React commit cycle.
        var distanceFromBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
        if (distanceFromBottom < 100) container.scrollTo(0, container.scrollHeight);
    };
    var startVoiceSession = function(_threadId) {
        var data = {
            threadId: _threadId,
            coachStyle: coachStyle,
            language: lang
        };
        api.post("client/voice_session", data).then(function(response) {
            if (response.json.status === "error") alert(response.json.error);
            else if (response.json.value) {
                setEphemeralKey(response.json.value);
                setUseVoice(true);
            } else alert("Unknown error: " + response.json.error);
        });
    };
    var startVoice = function() {
        // const showError = CONFIG.SYSTEM === "production" ? true : false;
        // if (showError) {
        //   alert("Voice is temporarily out of service - we are troubleshooting the Azure voice system");
        //   return;
        // }
        if (threadId && threadId !== "0") startVoiceSession(threadId);
        else {
            var data = {
                focusAreaId: focusAreaId,
                coachStyle: coachStyle,
                language: lang
            };
            api.post("client/chat_thread_start", data).then(function(response) {
                if (response.json.status === "ok") {
                    addThread(response.json.threadId, response.json.threadSubject);
                    setThreadId(response.json.threadId);
                    threadIdRef.current = response.json.threadId;
                    history.pushState(null, "", "/ai/" + response.json.threadId);
                    startVoiceSession(response.json.threadId);
                } else alert("Error: " + response.json.error);
            });
        }
    };
    var stopVoice = function() {
        setUseVoice(false);
    };
    var renderInput = function() {
        if (threadId === "_old_chat") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-4 border border-cherry-500 rounded p-4 text-gray-400",
            children: lang === "sv" ? "Du kan inte chatta med AI-Coachen i den h\xe4r tr\xe5den l\xe4ngre - endast l\xe4sa." : "You can't chat with the AI Coach in this thread any more - only read"
        });
        var placeholder = undefined;
        if (threadId === "0") {
            if (coachStyle === "assistant") placeholder = lang === "sv" ? "Fr\xe5ga vad som helst..." : "Ask anything...";
            else placeholder = lang === "sv" ? "Fr\xe5ga vad som helst f\xf6r att starta en coachsession" : "Ask anything to start a coaching session...";
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "z-chat-bottom ml-0 md:ml-16",
            children: [
                debugInfo && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    style: {
                        position: "absolute",
                        bottom: 12,
                        right: 12
                    },
                    onClick: function() {
                        return setShowDebug(!showDebug);
                    },
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($77be1a01a9b27ed1$exports))),
                        className: "h-6 w-6 cursor-pointer",
                        alt: "debug"
                    })
                }),
                showDebug && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "bg-indigo-800 text-xs text-gray-400 overflow-y-scroll",
                    style: {
                        position: "fixed",
                        top: 80,
                        right: 0,
                        width: 300,
                        height: "calc(100dvh - 220px)",
                        padding: 4,
                        borderLeft: "1px solid #202048"
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            children: [
                                "AI System: ",
                                debugInfo === null || debugInfo === void 0 ? void 0 : debugInfo.aiSystem
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            children: [
                                "Response time: ",
                                debugInfo === null || debugInfo === void 0 ? void 0 : debugInfo.responseTime.toFixed(2),
                                "s"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            children: [
                                "Tokens sent: ",
                                debugInfo === null || debugInfo === void 0 ? void 0 : debugInfo.tokensIn
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            children: [
                                "Tokens received: ",
                                debugInfo === null || debugInfo === void 0 ? void 0 : debugInfo.tokensOut
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            children: [
                                "Web search: ",
                                (debugInfo === null || debugInfo === void 0 ? void 0 : debugInfo.useWebSearch) ? "Yes" : "No"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "mt-4",
                            children: "Prompt:"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "whitespace-pre-line",
                            children: debugInfo === null || debugInfo === void 0 ? void 0 : debugInfo.prompt
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "z-chat-bottom-box bg-indigo-900 relative",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-gradient-crop"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $f6e11d7e911b44d5$export$2e2bcd8739ae039), {
                            sendToOtherPage: false,
                            handleSendMessage: send,
                            onHeightChange: chatInputHeightChange,
                            setCoachStyle: setCoachStyle,
                            coachStyle: coachStyle,
                            startVoice: startVoice,
                            emmaThinking: emmaThinking || streamStatus === 1,
                            placeholder: placeholder
                        })
                    ]
                })
            ]
        });
    };
    var renderFile = function(aiFiles) {
        if (!aiFiles || aiFiles.length === 0) return null;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "flex flex-wrap gap-2 mt-2",
            children: aiFiles.map(function(aiFile, idx) {
                if (aiFile.filetype === "image") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 align-right ml-auto max-w-[67%]",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: aiFile.bytes,
                        className: "rounded-md",
                        alt: "img",
                        style: {
                            maxHeight: "30dvh"
                        }
                    })
                }, idx);
                else if (aiFile.filetype === "pdf") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 flex align-right ml-auto rounded-md bg-indigo-900 p-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "rounded-sm bg-indigo-700 p-2",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($1d2fed0fa04640e3$exports))),
                                alt: "pdf",
                                className: "h-6 w-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "ml-2 text-gray-400 z-title4",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "truncate",
                                    style: {
                                        width: 150
                                    },
                                    children: aiFile.filename
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: "PDF"
                                })
                            ]
                        })
                    ]
                }, idx);
                else if (aiFile.filetype === "excel") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 flex align-right ml-auto rounded-md bg-indigo-900 p-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "rounded-sm bg-indigo-700 p-2",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($1d2fed0fa04640e3$exports))),
                                alt: "excel",
                                className: "h-6 w-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "ml-2 text-gray-400 z-title4",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "truncate",
                                    style: {
                                        width: 150
                                    },
                                    children: aiFile.filename
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: "Excel"
                                })
                            ]
                        })
                    ]
                }, idx);
                else if (aiFile.filetype === "word") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 flex align-right ml-auto rounded-md bg-indigo-900 p-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "rounded-sm bg-indigo-700 p-2",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($1d2fed0fa04640e3$exports))),
                                alt: "word",
                                className: "h-6 w-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "ml-2 text-gray-400 z-title4",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "truncate",
                                    style: {
                                        width: 150
                                    },
                                    children: aiFile.filename
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: "Word"
                                })
                            ]
                        })
                    ]
                }, idx);
                return null;
            })
        });
    };
    var renderMessage = function(message) {
        if (message.functionCall) {
            var name = message.functionCall.name;
            var args = message.functionCall.arguments;
            if (typeof args === "string") try {
                args = JSON.parse(message.functionCall.arguments);
            } catch (error) {
                console.log(message.functionCall.arguments);
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    children: [
                        "Error: thread is broken (",
                        message.message,
                        ")"
                    ]
                });
            }
            // const args = message.functionCall.arguments
            if (name === "create_task") {
                var taskName = args.name;
                var url = message.taskId ? "/tasks/" + message.taskId : "/tasks";
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 py-4 text-center",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "outlineWhiteBase",
                        onClick: function() {
                            return navigate(url);
                        },
                        children: [
                            lang === "sv" ? "G\xe5 till aktivitet" : "Go to Action",
                            ' "',
                            taskName,
                            '"'
                        ]
                    })
                });
            } else if (name === "create_activity") {
                var taskName1 = args.name;
                var url1 = "/dev-plan";
                if (message.functionCall.parentId && message.functionCall.id) url1 += "/long-term-goal/" + message.functionCall.parentId + "#activity_" + message.functionCall.id;
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 py-4 text-center",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "outlineWhiteBase",
                        onClick: function() {
                            return navigate(url1);
                        },
                        children: [
                            lang === "sv" ? "G\xe5 till aktivitet" : "Go to Activity",
                            ' "',
                            taskName1,
                            '"'
                        ]
                    })
                });
            } else if (name === "edit_task") {
                var taskName2 = args.name;
                var taskId = args.id;
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 py-4 text-center",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "outlineWhiteBase",
                        onClick: function() {
                            return navigate("/tasks/" + taskId);
                        },
                        children: [
                            lang === "sv" ? "Uppdaterade aktivitet" : "Updated Action",
                            ' "',
                            taskName2,
                            '"'
                        ]
                    })
                });
            } else if (name === "name_thread") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "py-4",
                children: [
                    lang === "sv" ? "D\xf6pte tr\xe5den till" : "Renamed thread to ",
                    ' "',
                    args.summary,
                    '"'
                ]
            });
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    "Error: no handler for task ",
                    message.functionCall.name
                ]
            });
        } else if (message.message) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "markdown-content text-gray-300",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b0f0e35343cbf8ab$export$7460c8b7e4ce9582), {
                remarkPlugins: [
                    (0, $37d5c81e71416b7d$export$2e2bcd8739ae039)
                ],
                children: message.message
            })
        });
        else if (Array.isArray(message.aiFile) && message.aiFile.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "py-4",
            children: lang === "sv" ? "Uppladdad fil" : "Uploaded file"
        });
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "py-4",
            children: "Error: empty message"
        });
    };
    var maybeDateDivider = function(messageNr) {
        var d = null;
        if (messageNr === 0) d = messages[0].sent;
        else {
            var dPrev = (0, $7d185b5883a21821$export$9fb809e1ebb630fc)(messages[messageNr - 1].sent, lang, true);
            var dThis = (0, $7d185b5883a21821$export$9fb809e1ebb630fc)(messages[messageNr].sent, lang, true);
            if (dPrev !== dThis) d = messages[messageNr].sent;
        }
        if (d) {
            var showYear = d.getFullYear() !== now.getFullYear();
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex items-center mt-4",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-800 grow"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "px-2 border border-indigo-800 rounded-xl text-xs text-gray-400",
                        children: (0, $7d185b5883a21821$export$9fb809e1ebb630fc)(d, lang, showYear)
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-800 grow"
                    })
                ]
            });
        }
    };
    var getLastIndex = function(role) {
        for(var i = messages.length - 1; i >= 0; i--){
            if (messages[i].role === role) return i;
        }
        return -1;
    };
    var renderThread = function() {
        var lastUser = getLastIndex("user");
        var lastAssistant = getLastIndex("assistant");
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4 mx-auto relative",
            style: {
                maxWidth: 760
            },
            children: [
                loadingMoreMsgs && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "flex justify-center py-2",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($01b6e07abd83fc68$exports))),
                        alt: "loading",
                        style: {
                            height: 16,
                            width: 114
                        }
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    ref: chatWindowRef,
                    className: "overflow-y-scroll z-no-scrollbar relative",
                    style: {
                        height: "calc(100dvh - 231px)",
                        overflowAnchor: "none"
                    },
                    children: [
                        allMsgsLoaded && messages.length > 20 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center my-4",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                    className: "border-indigo-800 grow"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "px-2 border border-indigo-800 rounded-xl text-xs text-gray-400",
                                    children: lang === "sv" ? "B\xf6rjan av konversationen" : "Beginning of conversation"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                    className: "border-indigo-800 grow"
                                })
                            ]
                        }),
                        messages.map(function(message, index) {
                            var cls = "mt-4";
                            if (message.role === "user") cls += " px-4 bg-indigo-800 rounded-[6px] align-right ml-auto max-w-[67%]";
                            else cls += " ml-7";
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                id: "last_msg_" + (index === lastUser ? "true" : "false"),
                                className: "flex flex-col relative" + (index === lastAssistant && newQuestion && streamStatus !== 1 ? " z-last-msg" : ""),
                                children: [
                                    maybeDateDivider(index),
                                    Array.isArray(message.aiFile) && message.aiFile.length > 0 && renderFile(message.aiFile),
                                    message.role !== "user" && !message.functionCall && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        style: {
                                            position: "absolute",
                                            top: 32,
                                            left: 0
                                        },
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($11d17cb94e9b6332$exports))),
                                            alt: "ai",
                                            className: "w-6"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: cls,
                                        children: renderMessage(message)
                                    })
                                ]
                            }, "chat_" + index);
                        }),
                        lastMessage.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            id: "last_msg",
                            className: "flex flex-col relative z-last-msg",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        top: 32,
                                        left: 0
                                    },
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9bdfb8bb1dda4858$exports))),
                                        alt: "ai",
                                        className: "w-6"
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-4 ml-7",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "markdown-content text-gray-300",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b0f0e35343cbf8ab$export$7460c8b7e4ce9582), {
                                            remarkPlugins: [
                                                (0, $37d5c81e71416b7d$export$2e2bcd8739ae039)
                                            ],
                                            children: lastMessage
                                        })
                                    })
                                })
                            ]
                        }),
                        emmaThinking && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    className: "h-6 w-6 rounded-full",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cb70cc925ae09565$exports))),
                                    alt: "pic"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($01b6e07abd83fc68$exports))),
                                    alt: "processing",
                                    className: "ml-4",
                                    style: {
                                        height: 16,
                                        width: 114
                                    }
                                })
                            ]
                        }),
                        messages.length > 2 && messages[messages.length - 1].number > 120 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-4 text-gray-300 border border-cherry-600 rounded-md p-4",
                            children: "This conversation has reached its limit and capacity. No worries \u2013 just start a new thread and you\u2019ll be able to continue."
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "h-5",
                            children: "\xa0"
                        })
                    ]
                })
            ]
        });
    };
    if (error.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: error
    });
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    var renderEmptyStart = function() {
        var topics = (0, $d0129b8cfae32aec$export$f0eb889d3170bfda)(4, lang);
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "main-one-col.small",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cb70cc925ae09565$exports))),
                        alt: "ai",
                        className: "h-8 w-8 mx-auto mt-6"
                    }),
                    !emmaThinking && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-6 z-heading1 text-center",
                        children: lang === "sv" ? "Hur kan jag hj\xe4lpa dig?" : "How can I help you?"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "flex flex-wrap gap-4 mt-6 justify-center",
                        children: emmaThinking ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    className: "h-6 w-6 rounded-full",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cb70cc925ae09565$exports))),
                                    alt: "pic"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($01b6e07abd83fc68$exports))),
                                    alt: "processing",
                                    className: "ml-4",
                                    style: {
                                        height: 16,
                                        width: 114
                                    }
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: topics.map(function(topic, index) {
                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    onClick: function() {
                                        return clickTopic(topic);
                                    },
                                    className: "main-half-width bg-indigo-800 hover:bg-indigo-700 rounded-md p-3 flex justify-between cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                            children: topic
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($005104c16715d72c$exports))),
                                            alt: "right",
                                            className: "h-4 w-4 mt-6"
                                        })
                                    ]
                                }, "topic_" + index);
                            })
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        id: "chat_space",
        className: "main-one-col small",
        children: [
            useVoice && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $9eb6e5851046ed98$export$2e2bcd8739ae039), {
                close: stopVoice,
                ephemeralKey: ephemeralKey,
                saveMessage: saveMessage,
                language: lang
            }),
            threadId === "0" && messages.length === 0 ? renderEmptyStart() : renderThread(),
            renderInput()
        ]
    });
};
var $79e724f81568affa$export$2e2bcd8739ae039 = $79e724f81568affa$var$AiStart;



var $dUlz9 = parcelRequire("dUlz9");

var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");


var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");




var $84de6c510df22527$var$ClientAgreements = function(props) {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), allChecked = _useState[0], setAllChecked = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)([
        false,
        false,
        false
    ]), 2), checked = _useState1[0], setChecked = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), instructionsModalOpen = _useState2[0], setInstructionsModalOpen = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), modalContent = _useState3[0], setModalContent = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), orgInstructionsModalOpen = _useState4[0], setOrgInstructionsModalOpen = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), orgModalInstructions = _useState5[0], setOrgModalInstructions = _useState5[1];
    var handleShowInstructions = function(content) {
        setModalContent(content);
        setInstructionsModalOpen(true);
    };
    var handleShowOrgInstructions = function(instructions) {
        setOrgModalInstructions(instructions !== null && instructions !== void 0 ? instructions : null);
        setOrgInstructionsModalOpen(true);
    };
    var renderJsonInstructions = function(instructions) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: instructions.map(function(instruction, i) {
                var cls = instruction.type === "header" ? "text-lg" : "";
                if (i > 0) {
                    if (instruction.type === "header") cls += " mt-4";
                    else cls += " mt-2";
                }
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: cls,
                    children: instruction.text
                }, "instruction_" + i);
            })
        });
    };
    var renderInstructions = function(ca, i) {
        if (ca.type === "privacy") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "flex flex-col text-gray-200 z-title2",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("label", {
                        className: "flex items-center gap-2 rounded-md cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                id: "privacy",
                                checked: checked[i],
                                label: "",
                                onChange: function() {
                                    return toggleCheck(i);
                                }
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                children: props.lang === "sv" ? "Personuppgiftsinformation" : "Personal Data Information"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2 text-gray-200 z-body1 pl-10",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            children: props.lang === "sv" ? "Vi v\xe4rnar om din integritet. L\xe4s hur vi hanterar och skyddar dina personuppgifter." : "We care about your privacy. Learn how we handle and protect your personal data."
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("a", {
                            target: "_blank",
                            className: "cursor-pointer underline font-medium",
                            href: ca.zebrainIsController ? "https://www.zebrain.se/app/uploads/2025/04/Zebrain_Privacy-Notice_20250107.pdf" : "https://www.zebrain.se/app/uploads/2026/03/Privacy-Notice_Processer_Customer_Controllers_Data_Subjects-20260302.pdf",
                            children: props.lang === "sv" ? "L\xe4s fullst\xe4ndig information h\xe4r" : "Read full details here"
                        })
                    ]
                })
            ]
        });
        else if (ca.type === "zebrain_instructions") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "flex flex-col text-gray-200 z-title2",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("label", {
                        className: "flex items-center gap-2 rounded-md cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                id: "zebrain_id",
                                checked: checked[i],
                                label: "",
                                onChange: function() {
                                    return toggleCheck(i);
                                }
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                children: props.lang === "sv" ? "Zebrain och AI" : "Zebrain and AI"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-200 z-body1 pl-10",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: props.lang === "sv" ? "Zebrain anv\xe4nder AI som en del av plattformen. AI-genererat inneh\xe5ll kan inneh\xe5lla fel eller missa viktig kontext. Anv\xe4nd alltid ditt eget omd\xf6me och dubbelkolla viktig information." : "Zebrain uses AI as part of the platform. AI-generated content may contain errors or miss important context \u2013 always use your own judgment and double-check important information."
                    })
                })
            ]
        });
        else if (ca.instructions) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "flex flex-col text-gray-200 z-title2",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("label", {
                        className: "flex items-center gap-2 rounded-md cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                id: "instruction_id",
                                checked: checked[i],
                                label: "",
                                onChange: function() {
                                    return toggleCheck(i);
                                }
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                children: props.lang === "sv" ? "Riktlinjer fr\xe5n din organisation" : "Guidelines from your organization"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2 text-gray-200 z-body1 pl-10",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            children: props.lang === "sv" ? "H\xe4r hittar du ytterligare riktlinjer fr\xe5n din organisation." : "Here you\u2019ll find additional guidelines provided by your organization."
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                className: "cursor-pointer underline font-medium",
                                onClick: function() {
                                    return handleShowOrgInstructions(ca.instructions);
                                },
                                children: props.lang === "sv" ? "Se fullst\xe4ndiga instruktioner" : "See full instructions"
                            })
                        })
                    ]
                })
            ]
        });
    };
    var acceptAgreements = function() {
        api.get("client/accept_agreements").then(function(result) {
            props.setAgreements([]);
        });
    };
    var toggleCheck = function(i) {
        var _checked = (0, $XnYkK._)(checked);
        var approvedAgreements = 0;
        _checked[i] = !checked[i];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _checked[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                if (c) approvedAgreements++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setChecked(_checked);
        if (approvedAgreements === props.clientAgreements.length) setAllChecked(true);
        else setAllChecked(false);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "z-all-window",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "z-all-middle-col p-4 desktop:mt-[146px] mt-8",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-gray-200 z-title1",
                        children: props.lang === "sv" ? "V\xe4lkommen till Zebrain! Innan du b\xf6rjar, v\xe4nligen ta en stund f\xf6r att l\xe4sa igenom och godk\xe4nna villkoren nedan." : "Welcome to Zebrain! Before you get started, please take a moment to review and agree to the terms below."
                    }),
                    props.clientAgreements.map(function(clientAgreement, i) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: i === 0 ? "mt-12" : "mt-6",
                            children: renderInstructions(clientAgreement, i)
                        }, "agreement_" + i);
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        className: "mt-8",
                        disabled: !allChecked,
                        onClick: function() {
                            return acceptAgreements();
                        },
                        children: allChecked ? props.lang === "sv" ? "Forts\xe4tt" : "Continue" : props.lang === "sv" ? "Klicka i att du accepterar ovanst\xe5ende" : "Check the boxes above to preceed"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: instructionsModalOpen,
                onClose: function() {
                    return setInstructionsModalOpen(false);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                        onClose: function() {
                            return setInstructionsModalOpen(false);
                        },
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-title1",
                            children: props.lang === "sv" ? "Fullst\xe4ndiga instruktioner" : "Full instructions"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        children: modalContent.split("\n").map(function(line, idx) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-gray-200",
                                children: line
                            }, idx);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: orgInstructionsModalOpen,
                onClose: function() {
                    return setOrgInstructionsModalOpen(false);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                        onClose: function() {
                            return setOrgInstructionsModalOpen(false);
                        },
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-title1",
                            children: props.lang === "sv" ? "Instruktioner fr\xe5n din organisation" : "Instructions from your organization"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        children: orgModalInstructions && renderJsonInstructions(orgModalInstructions)
                    })
                ]
            })
        ]
    });
};
var $84de6c510df22527$export$2e2bcd8739ae039 = $84de6c510df22527$var$ClientAgreements;











var $14768a245153e869$exports = {};
$14768a245153e869$exports = $parcel$resolve("hBK8v");





var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");







var $c62380d0630656bf$var$UserFeedbackModal = function(props) {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), currentIndex = _useState[0], setCurrentIndex = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), dataIsSent = _useState1[0], setDataIsSent = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)({
        nps: null,
        sean_ellis: null,
        comment: ""
    }), 2), formData = _useState2[0], setFormData = _useState2[1];
    var goToNextStep = function() {
        if (currentIndex < 3) setTimeout(function() {
            setCurrentIndex(currentIndex + 1);
        }, 500);
    };
    var goBack = function() {
        if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
    };
    var sendData = function() {
        if (dataIsSent) {
            props.setShowSurveyType(null);
            return;
        }
        try {
            api.post("client/nps", formData).then(function(response) {
                setDataIsSent(true);
                props.setShowSurveyType(null);
            });
        } catch (error) {
            console.error("Error sending data:", error);
        }
    };
    var renderStep1 = function() {
        var text1 = lang === "sv" ? "Ta 15 sekunder f\xf6r att svara p\xe5 en snabb, anonym unders\xf6kning." : "Take 15 seconds to answer a quick, anonymous survey.";
        var text2 = lang === "sv" ? "Fr\xe5ga 1 av 2" : "Question 1 of 2";
        var text3 = lang === "sv" ? "Hur sannolikt \xe4r det att du skulle rekommendera Zebrain\u2019s plattform till en v\xe4n eller kollega?" : "How likely are you to recommend Zebrain\u2019s platform to a friend or colleague?";
        var options = 11;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "text-left",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "text-gray-300",
                    children: text1
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "w-full border-t border-indigo-700 mt-4"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "font-medium mt-4",
                    children: text2
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "text-gray-300 my-1",
                    children: text3
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex flex-row flex-nowrap  items-center justify-center mb-2 border border-indigo-700 rounded-md",
                            children: (0, $XnYkK._)(Array(options)).map(function(e, i) {
                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "py-2 border-indigo-700 grow items-center text-center basis-1\n                    ".concat(i === options - 1 ? "border-l" : i < options - 2 && "border-r", " \n                    ").concat(formData.nps === i ? "bg-primary-500 text-indigo-1000" : "bg-transparent text-white hover:bg-indigo-800 hover:text-white", "\n                     cursor-pointer\n                    "),
                                    onClick: function() {
                                        setFormData((0, $lf4fc._)((0, $hwO3w._)({}, formData), {
                                            nps: i
                                        }));
                                        goToNextStep();
                                    },
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        children: i
                                    })
                                }, i);
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex flex-row justify-between z-title3 text-gray-500 leading-none",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: lang === "sv" ? "Inte alls sannolikt" : "Not at all likely"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: lang === "sv" ? "Extremt sannolikt" : "Extremely likely"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var renderStep2 = function() {
        var text1 = lang === "sv" ? "Fr\xe5ga 2 av 2" : "Question 2 of 2";
        var text2 = lang === "sv" ? "Hur skulle du k\xe4nna om du inte l\xe4ngre kunde anv\xe4nda Zebrains plattform?" : "How would you feel if you could no longer use Zebrain\u2019s platform?";
        var very_disappointed_sub = lang === "sv" ? "Den \xe4r viktig f\xf6r mig, och jag skulle verkligen sakna den." : "It's important to me, and I would really miss it.";
        var somewhat_disappointed_sub = lang === "sv" ? "Jag gillar det men jag skulle klara mig utan det." : "I like it, but I could manage without it.";
        var not_disappointed_sub = lang === "sv" ? "Jag anv\xe4nder det knappt eller tycker inte att det \xe4r s\xe4rskilt v\xe4rdefullt." : "I barely use it or don't find it very valuable.";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex flex-col gap-1 h-full text-left",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "font-medium",
                    children: text1
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-col gap-3  h-full",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "text-gray-300",
                            children: text2
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                            id: "very_disappointed",
                            name: "very_disappointed",
                            label: "\uD83D\uDE22 ".concat(t("very-disappointed")),
                            value: "very_disappointed",
                            checked: formData.sean_ellis === 3,
                            onChange: function() {
                                setFormData((0, $lf4fc._)((0, $hwO3w._)({}, formData), {
                                    sean_ellis: 3
                                }));
                                goToNextStep();
                            },
                            onClick: function(checked) {
                                if (checked) goToNextStep();
                            },
                            subtitle: very_disappointed_sub
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                            id: "somewhat_disappointed",
                            name: "somewhat_disappointed",
                            label: "\uD83D\uDE10 ".concat(t("somewhat-disappointed")),
                            value: "somewhat_disappointed",
                            checked: formData.sean_ellis === 2,
                            onChange: function() {
                                setFormData((0, $lf4fc._)((0, $hwO3w._)({}, formData), {
                                    sean_ellis: 2
                                }));
                                goToNextStep();
                            },
                            onClick: function(checked) {
                                if (checked) goToNextStep();
                            },
                            subtitle: somewhat_disappointed_sub
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                            id: "not_disappointed",
                            name: "not_disappointed",
                            label: "\uD83D\uDE0C ".concat(t("not-disappointed")),
                            value: "not_disappointed",
                            checked: formData.sean_ellis === 1,
                            onChange: function() {
                                setFormData((0, $lf4fc._)((0, $hwO3w._)({}, formData), {
                                    sean_ellis: 1
                                }));
                                goToNextStep();
                            },
                            onClick: function(checked) {
                                if (checked) goToNextStep();
                            },
                            subtitle: not_disappointed_sub
                        })
                    ]
                })
            ]
        });
    };
    var renderStep3 = function() {
        var text1 = i18n.language === "sv" ? "Vad skulle vi kunna g\xf6ra b\xe4ttre?" : "What could we do better?";
        var text2 = i18n.language === "sv" ? "valfritt" : "optional";
        var text3 = i18n.language === "sv" ? "Sn\xe4lla f\xf6rb\xe4ttra..." : "Please improve...";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex flex-col gap-2 text-left h-full",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                    className: "font-medium",
                    children: [
                        text1,
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                            className: "text-gray-400",
                            children: [
                                " (",
                                text2,
                                ")"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                    className: "z-input z-800 h-40 w-full bg-indigo-900",
                    placeholder: text3,
                    value: formData.comment,
                    onChange: function(e) {
                        var chars = e.target.value.length;
                        if (chars <= 500) setFormData(function(prev) {
                            return (0, $lf4fc._)((0, $hwO3w._)({}, prev), {
                                comment: e.target.value
                            });
                        });
                    }
                })
            ]
        });
    };
    var renderStep4 = function() {
        var text1 = i18n.language === "sv" ? "Din feedback hj\xe4lper oss att bli b\xe4ttre!" : "Your feedback helps us improve!";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex flex-col gap-3 text-left h-full",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($25e20653d8aa411d$exports))),
                    alt: "Success",
                    className: "w-12 h-12 mb-4 text-center mx-auto"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "text-gray-300 text-left",
                    children: text1
                })
            ]
        });
    };
    var showContent = function() {
        if (currentIndex === 1) return renderStep2();
        else if (currentIndex === 2) return renderStep3();
        else if (currentIndex === 3) return renderStep4();
        else return renderStep1();
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: function() {
                sendData();
            },
            ignoreOutsideClick: true,
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        sendData();
                    },
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1",
                        children: currentIndex === 3 ? lang === "sv" ? "Tack f\xf6r dina svar" : "Thanks for your response" : t("user-feedback-modal-header")
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: showContent()
                }),
                currentIndex !== 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                    children: [
                        currentIndex === 2 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex flex-col justify-between w-full gap-2",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    onClick: function() {
                                        sendData();
                                        goToNextStep();
                                    },
                                    children: t("submit-feedback")
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    onClick: goBack,
                                    children: t("back")
                                })
                            ]
                        }),
                        currentIndex === 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex flex-col justify-between w-full gap-2",
                            children: [
                                formData.sean_ellis !== null && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    onClick: function() {
                                        goToNextStep();
                                    },
                                    children: t("next")
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    onClick: goBack,
                                    children: t("back")
                                })
                            ]
                        }),
                        currentIndex === 3 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            onClick: function() {
                                return props.setShowSurveyType(null);
                            },
                            children: t("keep-growing")
                        })
                    ]
                })
            ]
        })
    });
};
var $c62380d0630656bf$export$2e2bcd8739ae039 = $c62380d0630656bf$var$UserFeedbackModal;


var $a30f1c2aba5c42d3$export$2e2bcd8739ae039 = (0, $c62380d0630656bf$export$2e2bcd8739ae039);




var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");







var $186ad541ad67702a$var$UsabilitySurvey = function(props) {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), currentIndex = _useState[0], setCurrentIndex = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), answer = _useState1[0], setAnswer = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), dataIsSent = _useState2[0], setDataIsSent = _useState2[1];
    var goToNextStep = function() {
        if (currentIndex < 3) setTimeout(function() {
            setCurrentIndex(currentIndex + 1);
        }, 500);
    };
    var sendData = function() {
        if (dataIsSent) return;
        var data = {
            answer: answer
        };
        try {
            api.post("client/usability_survey", data).then(function(response) {
                setDataIsSent(true);
            });
        } catch (error) {
            console.error("Error sending data:", error);
        }
    };
    var renderStep1 = function() {
        var text1 = lang === "sv" ? "Hur enkel tycker du att plattformen \xe4r att anv\xe4nda?" : "How easy do you find the platform to use?";
        var answers = [
            {
                answer: 5,
                text: lang === "sv" ? "Mycket enkel" : "Very easy"
            },
            {
                answer: 4,
                text: lang === "sv" ? "Ganska enkel" : "Quite easy"
            },
            {
                answer: 3,
                text: lang === "sv" ? "Varken enkel eller sv\xe5rt" : "Neither easy nor difficult"
            },
            {
                answer: 2,
                text: lang === "sv" ? "Ganska sv\xe5r" : "Quite difficult"
            },
            {
                answer: 1,
                text: lang === "sv" ? "Mycket sv\xe5r" : "Very difficult"
            }
        ];
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "text-left",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "text-gray-300",
                    children: text1
                }),
                answers.map(function(a) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "flex mt-3 cursor-pointer",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                            id: "a_" + a.answer,
                            name: "a_" + a.answer,
                            label: a.text,
                            value: "" + a.answer,
                            checked: a.answer === answer,
                            onChange: function() {
                                return setAnswer(a.answer);
                            }
                        })
                    }, "answer_" + a.answer);
                })
            ]
        });
    };
    var renderStep2 = function() {
        var text1 = i18n.language === "sv" ? "Din feedback hj\xe4lper oss att bli b\xe4ttre!" : "Your feedback helps us improve!";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex flex-col gap-3 text-left h-full",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($25e20653d8aa411d$exports))),
                    alt: "Success",
                    className: "w-12 h-12 mb-4 text-center mx-auto"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "text-gray-300 text-left",
                    children: text1
                })
            ]
        });
    };
    var showContent = function() {
        if (currentIndex === 1) return renderStep2();
        else return renderStep1();
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: function() {
                sendData();
                props.setShowSurveyType(null);
            },
            ignoreOutsideClick: true,
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        sendData();
                        props.setShowSurveyType(null);
                    },
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1",
                        children: currentIndex === 1 ? lang === "sv" ? "Tack f\xf6r ditt svar" : "Thanks for your response" : lang === "sv" ? "Vi v\xe4rdes\xe4tter din feedback" : "We'd love your feedback"
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: showContent()
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                    children: [
                        currentIndex === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex flex-col justify-between w-full gap-2",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                onClick: function() {
                                    sendData();
                                    goToNextStep();
                                },
                                children: t("submit-feedback")
                            })
                        }),
                        currentIndex === 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            onClick: function() {
                                return props.setShowSurveyType(null);
                            },
                            children: t("keep-growing")
                        })
                    ]
                })
            ]
        })
    });
};
var $186ad541ad67702a$export$2e2bcd8739ae039 = $186ad541ad67702a$var$UsabilitySurvey;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");





var $3f42890b5bb69dcd$exports = {};
$3f42890b5bb69dcd$exports = $parcel$resolve("1K8oY");



var $93450401e462f6c4$var$ModelB = function(prop) {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t;
    var currentStepNumber = prop.currentStepNumber, totalSteps = prop.totalSteps;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "z-modal-content-height",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex flex-col items-center gap-4",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    className: "w-60 h-60",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3f42890b5bb69dcd$exports))),
                    alt: "tutorialModelB"
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "space-y-4 w-full h-54",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                        className: "z-title5",
                        children: [
                            t("step"),
                            " ",
                            currentStepNumber,
                            " ",
                            t("of"),
                            " ",
                            totalSteps
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2 gray-100",
                        children: t("modelB-title")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "z-body1",
                        children: t("modelB-description")
                    })
                ]
            })
        ]
    });
};
var $93450401e462f6c4$export$2e2bcd8739ae039 = $93450401e462f6c4$var$ModelB;



var $8d1d7a9fc8652c1c$exports = {};
$8d1d7a9fc8652c1c$exports = $parcel$resolve("70LUU");



var $f95454d8c8bc0f6f$var$ModelC = function(prop) {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t;
    var currentStepNumber = prop.currentStepNumber, totalSteps = prop.totalSteps;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "z-modal-content-height",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex flex-col items-center gap-4",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    className: "w-60 h-60",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8d1d7a9fc8652c1c$exports))),
                    alt: "tutorialModelC"
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "space-y-4 w-full h-54",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                        className: "z-title5",
                        children: [
                            t("step"),
                            " ",
                            currentStepNumber,
                            " ",
                            t("of"),
                            " ",
                            totalSteps
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2 gray-100",
                        children: t("modelC-title")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "z-body1",
                        children: t("modelC-description")
                    })
                ]
            })
        ]
    });
};
var $f95454d8c8bc0f6f$export$2e2bcd8739ae039 = $f95454d8c8bc0f6f$var$ModelC;



var $67a5ca552cda0fd1$exports = {};
$67a5ca552cda0fd1$exports = $parcel$resolve("lKReZ");



var $585db7416686ac33$var$ModelD = function(props) {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t;
    var variant = props.variant; // "D1" or "D2"
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "z-modal-content-height",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex flex-col items-center gap-4",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    className: "w-60 h-60",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($67a5ca552cda0fd1$exports))),
                    alt: "tutorialModelD"
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "space-y-4 w-90 w-full h-54",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                        className: "z-title5",
                        children: [
                            t("step"),
                            " ",
                            props.currentStepNumber,
                            " ",
                            t("of"),
                            " ",
                            props.totalSteps
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2 gray-100",
                        children: t("modelD-title")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            variant === "D1" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "z-body1",
                                children: t("modelD1-description")
                            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "z-body1",
                                children: t("modelD2-description")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "z-body1",
                                children: t("modelD-description-extented")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $585db7416686ac33$export$2e2bcd8739ae039 = $585db7416686ac33$var$ModelD;



var $902d4ed7612f5424$exports = {};
$902d4ed7612f5424$exports = $parcel$resolve("ib0dn");



var $75ebcdea3b86eb96$var$ModelE = function(prop) {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t;
    var currentStepNumber = prop.currentStepNumber, totalSteps = prop.totalSteps;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "z-modal-content-height",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex flex-col items-center gap-4",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    className: "w-60 h-60",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($902d4ed7612f5424$exports))),
                    alt: "tutorialModelE"
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "space-y-4 w-full h-54",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                        className: "z-title5",
                        children: [
                            t("step"),
                            " ",
                            currentStepNumber,
                            " ",
                            t("of"),
                            " ",
                            totalSteps
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2 gray-100",
                        children: t("modelE-title")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "z-body1",
                                children: t("modelE-description")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "z-body1",
                                children: t("modelE-description-extended")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $75ebcdea3b86eb96$export$2e2bcd8739ae039 = $75ebcdea3b86eb96$var$ModelE;



var $20840fb28b69d70b$exports = {};
$20840fb28b69d70b$exports = $parcel$resolve("fw2M9");



var $ef53f27ff817fd2b$var$ModelA = function(prop) {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t;
    var currentStepNumber = prop.currentStepNumber, totalSteps = prop.totalSteps;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "z-modal-content-height",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex flex-col items-center gap-4",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    className: "w-60 h-60",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($20840fb28b69d70b$exports))),
                    alt: "tutorialModelA"
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "space-y-4 w-full h-54",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                        className: "z-title5",
                        children: [
                            t("step"),
                            " ",
                            currentStepNumber,
                            " ",
                            t("of"),
                            " ",
                            totalSteps
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-heading2 gray-100",
                        children: t("modelA-title")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "z-body1",
                        children: t("modelA-description")
                    })
                ]
            })
        ]
    });
};
var $ef53f27ff817fd2b$export$2e2bcd8739ae039 = $ef53f27ff817fd2b$var$ModelA;


// This file defines the steps for the onboarding modal. The steps are determined based on the values of hasCoach and hasAssessment.
function $40179bb633dea4e2$export$1012b332cad0397b(hasAssessment, hasCoach) {
    var steps = [];
    if (hasAssessment) steps.push("A");
    if (hasCoach) steps.push("B");
    steps.push("C");
    //   D1 is shown when assessmnet is true
    if (hasAssessment) steps.push("D1");
    else steps.push("D2");
    steps.push("E");
    return steps;
}


var $2f9f9529ee54dd01$var$stepComponents = {
    A: (0, $ef53f27ff817fd2b$export$2e2bcd8739ae039),
    B: (0, $93450401e462f6c4$export$2e2bcd8739ae039),
    C: (0, $f95454d8c8bc0f6f$export$2e2bcd8739ae039),
    D1: (0, $585db7416686ac33$export$2e2bcd8739ae039),
    D2: (0, $585db7416686ac33$export$2e2bcd8739ae039),
    E: (0, $75ebcdea3b86eb96$export$2e2bcd8739ae039)
};
var $2f9f9529ee54dd01$var$Infographic = function(props) {
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    // Fallback to 'en' if language is not recognized or is not 'sv'.
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var steps = (0, $5s1kH.useMemo)(function() {
        return (0, $40179bb633dea4e2$export$1012b332cad0397b)(props.hasAssessment, props.hasCoach);
    }, [
        props.hasAssessment,
        props.hasCoach
    ]);
    // step arrya is contasing thye steps
    // As Step is the array we can find the current step, number of steps and the total steps
    // StepComponet is the dereactory of steps
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), currentStepIndex = _useState[0], setCurrentStepIndex = _useState[1];
    var currentStep = steps[currentStepIndex];
    var StepComponent = $2f9f9529ee54dd01$var$stepComponents[currentStep];
    var handleNext = function() {
        if (currentStepIndex < steps.length - 1) setCurrentStepIndex(function(prev) {
            return prev + 1;
        });
        else props.close();
    };
    // My logic to determine steps based on hasCoach and hasAssessment
    // if(props.hasCoach && props.hasAssessment) {
    //   steps = ["A", "B", "C","D1","E"];
    // } else if(!props.hasCoach && !props.hasAssessment) {
    //   steps = ["C","D2","E"];
    // } else if(props.hasCoach && !props.hasAssessment) {
    //   steps = ["A", "c", "D1","E"];
    // } else if(!props.hasCoach && props.hasAssessment) {
    //   steps = ["B", "C","D2","E"];
    // } else {
    //   steps = [];
    // }
    return(// Model close only when the user clicks on the next button and when the user is on the last step.Outside click should not close the model
    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: true,
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                children: [
                    t("tutorial-header"),
                    " ",
                    steps.length,
                    " ",
                    t("tutorial-header-steps")
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)(StepComponent, {
                    variant: currentStep,
                    currentStepNumber: currentStepIndex + 1,
                    totalSteps: steps.length
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    onClick: handleNext,
                    buttonType: "blueBase",
                    children: [
                        " ",
                        currentStepIndex === steps.length - 1 ? t("getstart") : t("next")
                    ]
                })
            })
        ]
    }));
};
var $2f9f9529ee54dd01$export$2e2bcd8739ae039 = $2f9f9529ee54dd01$var$Infographic;



var $3e2b32379e7c0c09$exports = {};
$3e2b32379e7c0c09$exports = $parcel$resolve("8KYnq");



var $42299991f851de9a$exports = {};
$42299991f851de9a$exports = $parcel$resolve("aXW1X");



var $fb69e9976d7f3a45$exports = {};
$fb69e9976d7f3a45$exports = $parcel$resolve("ar8Kc");



var $0e0906c24bb36f11$var$ArrayName = /*#__PURE__*/ function(ArrayName) {
    ArrayName[ArrayName["ONGOING"] = 0] = "ONGOING";
    ArrayName[ArrayName["RECENT_ACTIVITY"] = 1] = "RECENT_ACTIVITY";
    return ArrayName;
}($0e0906c24bb36f11$var$ArrayName || {});
var $0e0906c24bb36f11$var$introHeader = {
    sv: {
        "self_assessment": "Kom ig\xe5ng med din utvecklingsresa!",
        "request_feedback": "Dags att be om feedback!",
        "read_report": "Din insiktsrapport \xe4r h\xe4r",
        "new_request": "Skicka en ny feedback-f\xf6rfr\xe5gan",
        "profile_first": "Utforska din personliga profil!",
        "profile_second": "Bara ett test kvar f\xf6r din profil!",
        "vision_statement": "Skapa din f\xf6rsta m\xe5lbild"
    },
    en: {
        "self_assessment": "Start your growth journey!",
        "request_feedback": "Request Feedback",
        "read_report": "Your insights report is here!",
        "new_request": "Send a new feedback request",
        "profile_first": "Explore your Profile",
        "profile_second": "One more test to go",
        "vision_statement": "Create your first goal"
    }
};
var $0e0906c24bb36f11$var$introText = {
    sv: {
        "self_assessment": "Utveckling b\xf6rjar med sj\xe4lvinsikt. B\xf6rja med att genomf\xf6ra din sj\xe4lvskattning och be om feedback.",
        "request_feedback": "Be om feedback fr\xe5n personer runt dig f\xf6r att f\xe5 nya insikter.",
        "read_report": "Kolla in ditt resultat och f\xe5 insikter om dina styrkor och utvecklingsomr\xe5den.",
        "new_request": "Din f\xf6rfr\xe5gan fick inte in tillr\xe4ckligt med svar \u2013 f\xf6rs\xf6k igen och f\xe5 de insikter du beh\xf6ver.",
        "profile_first": "F\xe5 v\xe4rdefulla insikter om vem du \xe4r och utveckla en djupare f\xf6rst\xe5else f\xf6r dig sj\xe4lv.",
        "profile_second": "Slutf\xf6r det sista testet i din profil f\xf6r att f\xe5  fler och djupare insikter om dig sj\xe4lv.",
        "vision_statement": "Kolla in dina skr\xe4ddarsydda utkast och skapa din m\xe5lbild."
    },
    en: {
        "self_assessment": "Growth starts with self-awareness. Start by completing your self-assessment and request feedback",
        "request_feedback": "Time to request Feedback from those around you to gain insights.",
        "read_report": "Check out your results and get insights into your strengths and areas for development.",
        "new_request": "Your last one didn\u2019t go through \u2014 try again and get the insights you need.",
        "profile_first": "Discover key insights about who you are and build a deeper understanding of yourself.",
        "profile_second": "Complete the last test in your Profile to gain more insights about yourself.",
        "vision_statement": "Explore your tailored drafts and create a goal."
    }
};
var $0e0906c24bb36f11$var$Home = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)("coaching"), 2), coachStyle = _useState[0], setCoachStyle = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState1[0], setLoaded = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), clientName = _useState2[0], setClientName = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), nudges = _useState3[0], setNudges = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), emmaThinking = _useState4[0], setEmmaThinking = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), onboardingSteps = _useState5[0], setOnboardingSteps = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), onboardingData = _useState6[0], setOnboardingData = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), showSurveyType = _useState7[0], setShowSurveyType = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), clientAgreements = _useState8[0], setClientAgreements = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), ongoingActivities = _useState9[0], setOngoingActivities = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), onboardingSummary = _useState10[0], setOnboardingSummary = _useState10[1];
    var _useState11 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), announcement = _useState11[0], setAnnouncement = _useState11[1];
    var chatWindowRef = (0, $5s1kH.useRef)(null);
    // Show more logic
    var SHOW_MORE_INCREMENT = 3;
    var _useState12 = (0, $6iP9u._)((0, $5s1kH.useState)(SHOW_MORE_INCREMENT), 2), showMoreOnGoingCount = _useState12[0], setShowMoreOnGoingCount = _useState12[1];
    var _useState13 = (0, $6iP9u._)((0, $5s1kH.useState)(SHOW_MORE_INCREMENT), 2), showMoreRecentActivityCount = _useState13[0], setShowMoreRecentActivityCount = _useState13[1];
    var _obj;
    var setterShowMoreMap = (_obj = {}, (0, $dUlz9._)(_obj, 0, setShowMoreOnGoingCount), (0, $dUlz9._)(_obj, 1, setShowMoreRecentActivityCount), _obj);
    var _useState14 = (0, $6iP9u._)((0, $5s1kH.useState)({
        doneToday: 0,
        doneLastWeek: 0,
        activities: [],
        next: []
    }), 2), progress = _useState14[0], setProgress = _useState14[1];
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (loaded) getData();
    }, [
        lang
    ]);
    var getData = function() {
        api.get("client/home", [
            "client_not_found"
        ]).then(function(response) {
            setClientName(response.json.clientName);
            setNudges(response.json.nudges);
            setClientAgreements(response.json.clientAgreements);
            setOnboardingData(response.json.onboardingData);
            setOnboardingSummary(response.json.onboardingSummary);
            setShowSurveyType(response.json.nextSurveyType);
            setOnboardingSteps(response.json.onboardingSteps);
            setOngoingActivities(response.json.ongoingActivities);
            setProgress(response.json.progress);
            setAnnouncement(response.json.announcement);
            setLoaded(true);
        }).catch(function(error) {
            if (error.isExpectedError) alert(error.json.message);
            else alert(("Unknown error (http status " + error.response, error.response.status));
        });
    };
    var toAiThread = function(aiStyle, message) {
        (0, $d0129b8cfae32aec$export$f93b11ed7a4960f0)(aiStyle, "", null, null, null, message);
        navigate("/ai/0");
    };
    var startVoice = function() {
        (0, $d0129b8cfae32aec$export$f93b11ed7a4960f0)(coachStyle, "voice", null, null, null, null);
        navigate("/ai/0");
    };
    var chatInputHeightChange = function(height) {
        if (chatWindowRef.current) {
            var winWidth = window.innerWidth;
            var ySpace = winWidth < 636 ? 138 : 154;
            var subtractHeight = ySpace + height;
            chatWindowRef.current.style.height = "calc(100dvh - " + subtractHeight + "px)";
            chatWindowRef.current.scrollTo(0, chatWindowRef.current.scrollHeight);
        }
    };
    var clickNudge = function(nudge) {
        var url = "";
        if (nudge.type === "feedback_request") url = "/development-plan";
        else if (nudge.type === "self_assessment") url = "/feedback/questionnaire/" + nudge.id;
        else if (nudge.type === "action_finalize") url = "/tasks/" + nudge.id;
        else if (nudge.type === "action_coaching") url = "/tasks/" + nudge.id;
        else if (nudge.type === "focus_areas" || nudge.type === "goal") url = "/development-plan";
        else if (nudge.type === "vision_statement_feedback") url = "/dev-plan/long-term-goal/" + nudge.id + "?tab=1";
        else if (nudge.type === "dev-plan") url = "/dev-plan";
        else if (nudge.type === "assessments") url = "/assessments";
        else if (nudge.type === "profile") url = "/profile";
        else if (nudge.type === "ai") url = "/ai/0";
        else if (nudge.type === "survey_report") url = "/dev-plan/survey/result/" + nudge.id + "/summary";
        if (url.length > 0) api.get("client/click?f=home_nudge:" + nudge.type + "&t=" + url).then(function(response) {
            navigate(url);
        });
        else alert("Missing link handler for " + nudge.type);
    };
    var renderNudgeSmall = function(_nudge, position) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "bg-indigo-800 border-indigo-700 border-1 hover:bg-indigo-700 rounded-md p-3 cursor-pointer flex flex-col justify-between mt-2",
            onClick: function() {
                return clickNudge(_nudge);
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                _nudge.prio > 2 && _nudge.prio < 10 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cb70cc925ae09565$exports))),
                                    className: "h-4 w-4 rounded-full mr-1",
                                    alt: "Emma"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "font-medium" + (position === 0 ? " mt-2 text-2xl" : ""),
                                    children: _nudge.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "mt-2 text-sm text-gray-400",
                            children: _nudge.text
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex justify-between items-end mt-4 gap-4",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "gap-2",
                            style: {
                                width: "calc(100% - 32px)"
                            },
                            children: [
                                _nudge.title && _nudge.title.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: _nudge.type.startsWith("action") ? (0, (/*@__PURE__*/$parcel$interopDefault($0fe3991a360589a5$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($39fbe7786abdc679$exports))),
                                            alt: "learning",
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "ml-2 z-title3 truncate",
                                            children: _nudge.title
                                        })
                                    ]
                                }),
                                _nudge.minutes.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports))),
                                            alt: "time",
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                            className: "ml-2 z-title3",
                                            children: [
                                                _nudge.minutes,
                                                " Min"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        position > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($005104c16715d72c$exports))),
                            className: "h-4 w-4",
                            alt: "Go"
                        })
                    ]
                }),
                position === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    className: "mt-4",
                    children: lang === "sv" ? "Forts\xe4tt" : "Continue"
                })
            ]
        }, "nudge_" + position);
    };
    var clickActivity = function(activity) {
        if (activity.type === "vision_statement") navigate('/dev-plan/long-term-goal/' + activity.id);
        else if (activity.type === "sub-goal") navigate('/dev-plan/long-term-goal/' + activity.parentId + "#goal_" + activity.id);
        else if (activity.type === "activity") navigate('/dev-plan/long-term-goal/' + activity.parentId + "#activity_" + activity.id);
        else if (activity.type === "behavior") navigate('/dev-plan/long-term-goal/' + activity.parentId + "#behavior_" + activity.id);
        else if (activity.type === "task") navigate('/tasks/' + activity.id);
        else if (activity.type === "chat") navigate('/ai/' + activity.id);
        else alert("No click handler for " + activity.type);
    };
    var renderLastThing = function(activity, nr) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            onClick: function() {
                return clickActivity(activity);
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 bg-indigo-900 hover:bg-indigo-800 p-4 rounded-md cursor-pointer",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center justify-between gap-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "text-gray-400 font-medium",
                                        children: [
                                            activity.date && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                className: "z-body2",
                                                children: [
                                                    activity.date.substring(0, 10),
                                                    ": "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                className: "z-body2",
                                                children: t(activity.type)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "mt-2 z-title2",
                                        children: activity.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($e8981ef41dc6cb1b$exports))),
                                alt: "chevroRight",
                                className: "h-6 w-6 shrink-0"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "ml-[14px] border-indigo-700"
                })
            ]
        }, "last_" + activity.id);
    };
    var handleShowMore = function(isLimit, arrayName) {
        setterShowMoreMap[arrayName](isLimit ? 3 : function(prev) {
            return prev + 3;
        });
    };
    var renderOnboardingNextStep = function() {
        if (!(onboardingSteps === null || onboardingSteps === void 0 ? void 0 : onboardingSteps.nextStep)) return;
        var nextStepText = $0e0906c24bb36f11$var$introText[lang][onboardingSteps.nextStep];
        var nextStepLink = "/dev-plan";
        var s = onboardingSteps === null || onboardingSteps === void 0 ? void 0 : onboardingSteps.nextStep;
        if (s === "self_assessment") nextStepLink = "/assessments";
        else if (s === "request_feedback") nextStepLink = "/assessments";
        else if (s.startsWith("profile")) nextStepLink = "/profile";
        else if (s === "wait_report") nextStepLink = "/dev-plan";
        else if (s === "read_report") {
            if (onboardingSteps === null || onboardingSteps === void 0 ? void 0 : onboardingSteps.linkId) nextStepLink = "/dev-plan/survey/result/" + (onboardingSteps === null || onboardingSteps === void 0 ? void 0 : onboardingSteps.linkId) + "/summary";
            else nextStepLink = "/dev-plan";
        } else if (s === "vision_statement") nextStepLink = "/dev-plan";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-8 flex items-start justify-between",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            className: "z-title3",
                            children: [
                                lang === "sv" ? "N\xe4sta steg" : "Next step",
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "z-body1",
                            children: nextStepText
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    style: {
                        width: "unset"
                    },
                    className: "ml-4",
                    onClick: function() {
                        return navigate(nextStepLink);
                    },
                    children: lang === "sv" ? "Forts\xe4tt" : "Continue"
                })
            ]
        });
    };
    var clickOngoing = function(ongoing) {
        if (ongoing.type === "task") navigate('/tasks/' + ongoing.id);
        else if (ongoing.type === "subGoal") navigate('/dev-plan/long-term-goal/' + ongoing.parentId + "#goal_" + ongoing.id);
        else if (ongoing.type === "activity") navigate('/dev-plan/long-term-goal/' + ongoing.parentId + "#activity_" + ongoing.id);
        else if (ongoing.type === "action") navigate('/dev-plan/long-term-goal/' + ongoing.parentId + "#action_" + ongoing.id);
        else if (ongoing.type === "behavior") navigate('/dev-plan/long-term-goal/' + ongoing.parentId + "#behavior_" + ongoing.id);
        else alert("Unhandled: " + ongoing.type);
    };
    var renderOnboardingSummary = function() {
        if (!onboardingSummary) return null;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "bg-indigo-900 border-indigo-800 border-1 p-5 rounded-md",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mb-2 font-medium flex items-center gap-2 z-title3 pb-2 text-gray-400!",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            className: "h-4 w-4",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fb69e9976d7f3a45$exports))),
                            alt: "toggle"
                        }),
                        lang === "sv" ? "Statistik" : "Stats overview"
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex gap-x-4 pb-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "w-1/3 p-4 rounded-md bg-indigo-800 border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-heading2 pb-2",
                                    children: onboardingSummary.sessions
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-body2",
                                    children: lang === "sv" ? "Sessioner" : "Sessions"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "w-1/3 p-4 rounded-md bg-indigo-800 border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-heading2 pb-2",
                                    children: onboardingSummary.activeWeeks
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-body2",
                                    children: lang === "sv" ? "aktiva veckor" : "Active weeks"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "w-1/3 p-4 rounded-md bg-indigo-800 border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                            className: "z-heading2 pb-2",
                                            children: onboardingSummary.weekStreak
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                            className: "z-body3 text-gray-400!",
                                            children: [
                                                "(",
                                                lang === "sv" ? "Rekord" : "Record",
                                                ": ",
                                                onboardingSummary.streakRecord,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-body2",
                                    children: lang === "sv" ? "veckors streak" : "Week streak"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex mt-2 gap-x-4",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "w-1/3 p-4 rounded-md bg-indigo-800 border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-heading2 pb-2",
                                    children: onboardingSummary.chatThreads
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-body2",
                                    children: lang === "sv" ? "AI-konversationer" : "AI conversations"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "w-1/3 p-4 rounded-md bg-indigo-800 border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-heading2 pb-2",
                                    children: onboardingSummary.visionStatements
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-body2",
                                    children: lang === "sv" ? "M\xe5lbilder skapade" : "Goals"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "w-1/3 p-4 rounded-md bg-indigo-800 border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-heading2 pb-2",
                                    children: onboardingSummary.visionItems
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "z-body2",
                                    children: lang === "sv" ? "M\xe5lbilds-aktiviteter" : "Items in progress"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var renderOngoing = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: renderOnboardingSummary()
        });
    };
    var clickAnnouncement = function(action) {
        if (announcement) {
            var url = announcement.url;
            api.get('client/announcement/' + announcement.id + '/' + action).then(function(response) {
                if (action === 1) {
                    if (url.startsWith('https')) document.location.href = url;
                    else navigate(url);
                } else setAnnouncement(null);
            });
        }
    };
    var renderAnnouncement = function() {
        if (!announcement) return null;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-4 border border-primary-500 bg-indigo-800 border-indigo-700 border-1 rounded-md p-4",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($14768a245153e869$exports))),
                                alt: "time",
                                className: "h-6 w-6"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "ml-2 z-title3",
                                children: announcement.text[lang]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "ml-2 z-title3 cursor-pointer underline hover:text-primary-500!",
                                onClick: function() {
                                    return clickAnnouncement(1);
                                },
                                children: announcement.linkText[lang]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "cursor-pointer hover:bg-indigo-700 rounded-[20px] p-1",
                        onClick: function() {
                            return clickAnnouncement(0);
                        },
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                            alt: "close",
                            className: "h-4 w-4"
                        })
                    })
                ]
            })
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {});
    if (clientAgreements.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $84de6c510df22527$export$2e2bcd8739ae039), {
        setAgreements: setClientAgreements,
        clientAgreements: clientAgreements,
        lang: lang
    });
    var renderOnboardingSteps = function() {
        if (!onboardingSteps || !onboardingSteps.nextStep) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: nudges.map(function(nudge, i) {
                return renderNudgeSmall(nudge, i);
            })
        });
        var intro = $0e0906c24bb36f11$var$introHeader[lang][onboardingSteps.nextStep];
        var introText = lang === "sv" ? "Du \xe4r klar med onboardingen" : "You are done with the onboarding";
        if (onboardingSteps.step <= onboardingSteps.steps) {
            introText = "Onboarding";
            introText += lang === "sv" ? " steg " : " step ";
            introText += onboardingSteps.step;
            introText += lang === "sv" ? " av " : " of ";
            introText += onboardingSteps.steps;
        }
        var progress = 100 * onboardingSteps.step / onboardingSteps.steps;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "z-heading1",
                    children: intro
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-8 z-body1",
                    children: introText
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 flex items-center",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "h-2 rounded-full bg-indigo-700",
                        style: {
                            width: "calc(100% - 40px)"
                        },
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "h-2 rounded-full bg-primary-500",
                            style: {
                                width: progress + "%"
                            }
                        })
                    })
                }),
                renderOnboardingNextStep()
            ]
        });
    };
    var getActivityBg = function(_ongoing) {
        var type = _ongoing.type;
        if (type === "activity") {
            if (_ongoing.fromChat) return " bg-peach-600";
            else return " bg-orange-300";
        } else if (type === "subGoal" || type === "action") return " bg-royal-700";
        else if (type === "behavior") return " bg-lavender-600";
        else if (type === "task") return " bg-peach-600";
        else return "";
    };
    var renderMain = function() {
        var todayDate = new Date();
        var isShowMoreOngoing = showMoreOnGoingCount >= ongoingActivities.length;
        var isShowMoreRecentActivityCount = showMoreRecentActivityCount >= progress.activities.length;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-6 mt-6",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "bg-indigo-900 border-indigo-800 border p-5 rounded-md flex flex-col",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "z-title3 text-gray-400!",
                                    children: [
                                        lang === "sv" ? "Hej" : "Hi",
                                        " ",
                                        clientName
                                    ]
                                }),
                                renderOnboardingSteps()
                            ]
                        }),
                        renderOngoing()
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-6 mt-6 items-start",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "bg-indigo-900 border-indigo-800 border p-6 rounded-md",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "mb-2 font-medium flex items-center gap-2 z-title3 pb-2 text-gray-400!",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            className: "h-4 w-4",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3e2b32379e7c0c09$exports))),
                                            alt: "toggle"
                                        }),
                                        lang === "sv" ? "P\xe5g\xe5ende" : "Ongoing"
                                    ]
                                }),
                                ongoingActivities.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "border border-dashed border-indigo-700 p-4 mb-2 rounded-md text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3e2b32379e7c0c09$exports))),
                                            alt: "tip",
                                            className: "mt-4 h-8 w-8 mx-auto"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-4 text-neutral-400",
                                            children: lang === "sv" ? "Dina p\xe5g\xe5ende aktiviteter visas h\xe4r." : "Your ongoing activities will appear here."
                                        })
                                    ]
                                }),
                                ongoingActivities.slice(0, showMoreOnGoingCount).map(function(ongoing, i) {
                                    var isDue = false;
                                    if (ongoing.deadline) {
                                        var deadline = new Date(ongoing.deadline);
                                        if (deadline < todayDate) isDue = true;
                                    }
                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "bg-indigo-800 border-indigo-700 border p-4 pl-7 mb-2 rounded-md hover:bg-indigo-700 cursor-pointer relative",
                                        onClick: function() {
                                            return clickOngoing(ongoing);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "z-action-color" + getActivityBg(ongoing)
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "flex justify-between text-gray-400 font-medium",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                        className: "z-title1",
                                                        children: ongoing.title
                                                    }),
                                                    ongoing.deadline && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                        className: "text-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                                className: "text-gray-100",
                                                                children: [
                                                                    t("due-date"),
                                                                    ":\xa0"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                                className: "text-gray-400",
                                                                children: ongoing.deadline.substring(0, 10)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            ongoing.type === "subGoal" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "mt-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                        className: "text-gray-100 font-medium",
                                                        children: [
                                                            t("behaviors-and-actions"),
                                                            ":\xa0"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                        className: "text-gray-300",
                                                        children: [
                                                            ongoing.subtasksDone,
                                                            " ",
                                                            t("of"),
                                                            "\xa0",
                                                            ongoing.subtasks,
                                                            " ",
                                                            t("completed").toLowerCase()
                                                        ]
                                                    })
                                                ]
                                            }),
                                            isDue && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
                                                message: (0, $db44299b4f245a2a$export$7ccfe9f56c40bcb7)(lang, ongoing.type, !!ongoing.fromChat)
                                            })
                                        ]
                                    }, "ongoing_" + ongoing.id);
                                }),
                                ongoingActivities.length > 3 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "transparentBase",
                                    className: "mt-4 mx-auto cursor-pointer",
                                    size: "sm",
                                    onClick: function() {
                                        return handleShowMore(isShowMoreOngoing, 0);
                                    },
                                    leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: isShowMoreOngoing ? (0, (/*@__PURE__*/$parcel$interopDefault($42299991f851de9a$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($8035c9bf788700b7$exports))),
                                        alt: "info"
                                    }),
                                    style: {
                                        width: "unset"
                                    },
                                    children: isShowMoreOngoing ? t("btn-show-less") : t("btn-show-more")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "bg-indigo-900 border-indigo-800 border-1 p-6 rounded-md",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "mb-2 font-medium flex items-center gap-2 z-title3 pb-2 text-gray-400!",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            className: "h-4 w-4",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports))),
                                            alt: "toggle"
                                        }),
                                        lang === "sv" ? "Senaste aktiviteter" : "Recent activity"
                                    ]
                                }),
                                progress.activities.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "border border-dashed border-indigo-700 p-4 mb-2 rounded-md text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports))),
                                            alt: "tip",
                                            className: "mt-4 h-8 w-8 mx-auto"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-4 text-neutral-400",
                                            children: lang === "sv" ? "Dina senaste aktiviteter visas h\xe4r." : "Your recent activities will appear here."
                                        })
                                    ]
                                }),
                                progress.activities.slice(0, showMoreRecentActivityCount).map(function(activity, i) {
                                    return renderLastThing(activity, i);
                                }),
                                progress.activities.length > 3 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "transparentBase",
                                    className: "mt-4 mx-auto cursor-pointer",
                                    size: "sm",
                                    onClick: function() {
                                        return handleShowMore(isShowMoreRecentActivityCount, 1);
                                    },
                                    leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: isShowMoreRecentActivityCount ? (0, (/*@__PURE__*/$parcel$interopDefault($42299991f851de9a$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($8035c9bf788700b7$exports))),
                                        alt: "info",
                                        className: "h-4 w-4"
                                    }),
                                    style: {
                                        width: "unset"
                                    },
                                    children: isShowMoreRecentActivityCount ? t("btn-show-less") : t("btn-show-more")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-chat-bottom",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-chat-bottom-box bg-indigo-900",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $f6e11d7e911b44d5$export$2e2bcd8739ae039), {
                            sendToOtherPage: true,
                            handleSendMessage: function(msg) {
                                return toAiThread(coachStyle, msg);
                            },
                            onHeightChange: chatInputHeightChange,
                            setCoachStyle: setCoachStyle,
                            coachStyle: coachStyle,
                            startVoice: startVoice,
                            placeholder: lang === "sv" ? "Skriv n\xe5got f\xf6r att starta ett eget \xe4mne..." : "Ask anything to start a custom topic...",
                            emmaThinking: emmaThinking
                        })
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "h-32",
                    children: "\xa0"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "",
        children: [
            renderAnnouncement(),
            renderMain(),
            showSurveyType === "nps" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a30f1c2aba5c42d3$export$2e2bcd8739ae039), {
                setShowSurveyType: setShowSurveyType
            }),
            showSurveyType === "usability" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $186ad541ad67702a$export$2e2bcd8739ae039), {
                setShowSurveyType: setShowSurveyType
            }),
            onboardingData && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2f9f9529ee54dd01$export$2e2bcd8739ae039), {
                close: function() {
                    return setOnboardingData(null);
                },
                hasCoach: onboardingData.hasCoach,
                hasAssessment: onboardingData.hasAssessment
            })
        ]
    });
};
var $0e0906c24bb36f11$export$2e2bcd8739ae039 = $0e0906c24bb36f11$var$Home;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");



var $bHX26 = parcelRequire("bHX26");











parcelRequire("5s1kH");
var $51e9ec39f085fa8f$var$ProgressBar = function(props) {
    var donePercent = 100 * props.step / props.steps + "%";
    // const stepPercent = 100 * props.step / maxStepDone + "%"
    var barClass = "rounded-full w-full bg-indigo-800" + (props.hideSteps ? "" : " ml-2");
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "flex items-center",
        children: [
            !props.hideSteps && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "z-title3 w-14",
                children: [
                    props.step,
                    " / ",
                    props.steps
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: barClass,
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "h-2 rounded-full bg-success-500",
                    style: {
                        width: donePercent
                    }
                })
            })
        ]
    });
};
var $51e9ec39f085fa8f$export$2e2bcd8739ae039 = $51e9ec39f085fa8f$var$ProgressBar;


var $42a808b599103bea$var$ProfileMenu = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), assessments = _useState[0], setAssessments = _useState[1];
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), profileSummary = _useState1[0], setProfileSummary = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), completeAssessments = _useState2[0], setCompleteAssements = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState3[0], setLoaded = _useState3[1];
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get("client/profile").then(function(response) {
            if (response.json.assessments) {
                setAssessments(response.json.assessments);
                setCompleteAssements(response.json.completeAssessments);
            }
            setProfileSummary(response.json.profileSummary);
            setLoaded(true);
        });
    };
    var getName = function(name) {
        if (name === "big5") return lang === "sv" ? "Personlighetstest" : "Personality test";
        else if (name === "stress") return lang === "sv" ? "Stresstest" : "Stress test";
        else return "N/A: " + name;
    };
    var getDescription = function(name) {
        if (name === "big5") return lang === "sv" ? "Uppt\xe4ck din unika personlighetstyp" : "Discover your unique personality type";
        else if (name === "stress") return lang === "sv" ? "F\xe5 insikter om din stressniv\xe5" : "Understand your current stress level";
        else return "N/A: " + name;
    };
    var goTo = function(name) {
        if (name === "big5") navigate("/profile/big5");
        else if (name === "stress") navigate("/profile/stress");
        else alert("Can't navigate to " + name);
    };
    var testTime = function(name) {
        if (name === "big5") return 20;
        else if (name === "stress") return 5;
        else return 10;
    };
    var buttonText = function(assessment) {
        if (assessment.completed) return lang === "sv" ? "Se resultat" : "See result";
        else if (assessment.status === "pending") return lang === "sv" ? "Forts\xe4tt testet" : "Continue assessment";
        else return lang === "sv" ? "Starta test" : "Start assessment";
    };
    var renderProfileSummary = function() {
        if (profileSummary) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 z-heading2",
                    children: lang === "sv" ? "Profilanalys" : "Profile analysis"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-400",
                    children: lang === "sv" ? "Baserat p\xe5 dina f\xe4rdiga tester." : "Based on your completed assessments."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 bg-indigo-900 px-4 rounded-md overflow-hidden markdown-content no-headers text-gray-300 border-indigo-800 border-1",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b0f0e35343cbf8ab$export$7460c8b7e4ce9582), {
                        children: profileSummary
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 z-heading2",
                    children: t("overview")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-400",
                    children: lang === "sv" ? "G\xf6r testerna f\xf6r att skapa din unika profil" : "Complete the assessments to unlock your personal analysis"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 p-4 rounded-md border-indigo-800 border-1",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cb70cc925ae09565$exports))),
                            alt: "ai",
                            className: "h-8 w-8 mx-auto text-center"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 text-gray-400 text-center",
                            children: [
                                completeAssessments,
                                " ",
                                lang === "sv" ? "av" : "of",
                                " 2\xa0",
                                lang === "sv" ? "tester f\xe4rdiga" : "assessments completed"
                            ]
                        }),
                        completeAssessments > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-4",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $51e9ec39f085fa8f$export$2e2bcd8739ae039), {
                                step: completeAssessments,
                                steps: 2,
                                hideSteps: true
                            })
                        })
                    ]
                })
            ]
        });
    };
    var renderAssessments = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: assessments.map(function(assessment) {
                var buttonType = assessment.completed ? "outlineWhiteBase" : "blueBase";
                var iconRight = assessment.completed ? (0, (/*@__PURE__*/$parcel$interopDefault($005104c16715d72c$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports)));
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 p-4 rounded-md border-indigo-800 border-1",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: getName(assessment.name)
                                }),
                                assessment.completed && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($be3c5e2d6f294fc0$exports))),
                                    alt: "done",
                                    className: "h-5 w-5"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: getDescription(assessment.name)
                        }),
                        assessment.completed ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                    alt: "time",
                                    className: "h-4 w-4"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-title3 ml-2",
                                    children: assessment.completed.substring(0, 10)
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports))),
                                    alt: "time",
                                    className: "h-4 w-4"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "z-title3 ml-2",
                                    children: [
                                        testTime(assessment.name),
                                        " Min"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: buttonType,
                            className: "mt-4 flex items-center justify-center",
                            onClick: function() {
                                return goTo(assessment.name);
                            },
                            rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: iconRight,
                                alt: "start",
                                className: "h-4 w-4"
                            }),
                            children: buttonText(assessment)
                        })
                    ]
                }, "assessment_" + assessment.name);
            })
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {
        txt: lang === "sv" ? "Laddar tester..." : "Loading assessments..."
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "z-heading1 mt-6",
                children: lang === "sv" ? "Profil" : "Profile"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-2 text-gray-400",
                children: lang === "sv" ? "F\xe5 v\xe4rdefulla insikter om vem du \xe4r och utveckla en djupare f\xf6rst\xe5else f\xf6r dig sj\xe4lv." : "Discover key insights about who you are and build a deeper understanding of yourself."
            }),
            renderProfileSummary(),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 z-heading2",
                children: lang === "sv" ? "Tester" : "Assessments"
            }),
            renderAssessments()
        ]
    });
};
var $42a808b599103bea$export$2e2bcd8739ae039 = $42a808b599103bea$var$ProfileMenu;



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");

// The div in App.tsx where scrollable content is loaded has id main_for_scrolling
// Call this function at first render to scroll to top
var $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9 = function() {
    var mainForScrolling = document.getElementById('main_for_scrolling');
    if (mainForScrolling) mainForScrolling.scrollTo(0, 0);
};







parcelRequire("5s1kH");
var $44fe092aad431d2d$var$BarValue = function(props) {
    var percent = 100 * props.value / (props.max - props.min);
    var barWidth = percent + "%";
    var hClass = props.size === "large" ? "h-8" : "h-4";
    var extraClass = props.className ? " " + props.className : "";
    var resultsStyle = {};
    var resultsClass = "!text-indigo-1000 mr-2";
    if (percent < 5) {
        var leftP = percent + 2 + "%";
        resultsStyle = {
            left: leftP
        };
        resultsClass = "text-white absolute";
    }
    if (props.size === "small") resultsClass += " z-title4";
    var borderRadius = "8px 0 0 8px";
    if (percent > 98) borderRadius = "8px";
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "bg-indigo-700 w-full relative " + hClass + extraClass,
        style: {
            borderRadius: "8px"
        },
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "bg-peach-500 flex items-center justify-end " + hClass,
            style: {
                width: barWidth,
                borderRadius: borderRadius
            },
            children: props.results && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: resultsClass,
                style: resultsStyle,
                children: props.results
            })
        })
    });
};
var $44fe092aad431d2d$export$2e2bcd8739ae039 = $44fe092aad431d2d$var$BarValue;


var $e9e1f45fe1c804bc$exports = {};
$e9e1f45fe1c804bc$exports = $parcel$resolve("6sMeD");



var $0fac0413583d4655$exports = {};
$0fac0413583d4655$exports = $parcel$resolve("fm1Ze");




var $e284769d226e732e$export$ae5bda7d15242bd6 = [
    {
        id: '43c98ce8-a07a-4dc2-80f6-c1b2a2485f06',
        text: 'I worry about things',
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: 'd50a597f-632b-4f7b-89e6-6d85b50fd1c9',
        text: 'I make friends easily',
        keyed: 'plus',
        domain: 'E',
        facet: 1
    },
    {
        id: '888dd864-7449-4e96-8d5c-7a439603ea91',
        text: 'I have a vivid imagination',
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: 'ce2fbbf8-7a97-4199-bda5-117e4ecdf3b6',
        text: 'I trust others',
        keyed: 'plus',
        domain: 'A',
        facet: 1
    },
    {
        id: 'c7f53c3c-2e77-432f-bb71-7470b67d3aa9',
        text: 'I complete tasks successfully',
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: '48ad12ce-470e-4339-90ac-ea8c43a0103e',
        text: 'I get angry easily',
        keyed: 'plus',
        domain: 'N',
        facet: 2
    },
    {
        id: '458f3957-2359-4077-ade1-34525d633063',
        text: 'I love large parties',
        keyed: 'plus',
        domain: 'E',
        facet: 2
    },
    {
        id: '58d571e5-d725-4cf8-a438-32c16ee28eb6',
        text: 'I believe in the importance of art',
        keyed: 'plus',
        domain: 'O',
        facet: 2
    },
    {
        id: '0cf79e27-e702-45c2-9471-04ac96b58e0e',
        text: 'I use others for my own ends',
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: 'cda1ca17-b599-4561-a6cd-ff9d36062d27',
        text: 'I like to tidy up',
        keyed: 'plus',
        domain: 'C',
        facet: 2
    },
    {
        id: '5e8550d7-b8ef-4905-950a-f81d735d39e2',
        text: 'I often feel blue',
        keyed: 'plus',
        domain: 'N',
        facet: 3
    },
    {
        id: '8af754f2-68e9-48f3-8c5d-2e6633d4472c',
        text: 'I take charge',
        keyed: 'plus',
        domain: 'E',
        facet: 3
    },
    {
        id: '0727def6-3d18-4221-bf38-86b58f9f3eed',
        text: 'I experience my emotions intensely',
        keyed: 'plus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'ccf3a5c8-fb50-4bd4-8e7a-22af3d657279',
        text: 'I love to help others',
        keyed: 'plus',
        domain: 'A',
        facet: 3
    },
    {
        id: '73d84e5d-cbf5-47f0-b8cb-4d2159a52e32',
        text: 'I keep my promises',
        keyed: 'plus',
        domain: 'C',
        facet: 3
    },
    {
        id: 'b2d9ef74-73f5-4ea8-b00c-7aaca15937df',
        text: 'I find it difficult to approach others',
        keyed: 'plus',
        domain: 'N',
        facet: 4
    },
    {
        id: '48a761ef-438e-409b-ae59-ea2ce8f84414',
        text: 'I am always busy',
        keyed: 'plus',
        domain: 'E',
        facet: 4
    },
    {
        id: 'cae55842-8957-4e3b-83b3-ceff98fb9dcf',
        text: 'I prefer variety to routine',
        keyed: 'plus',
        domain: 'O',
        facet: 4
    },
    {
        id: 'e2028ad3-b128-4f76-be57-398bfe2aff22',
        text: 'I love a good fight',
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: 'b7fc949b-02b6-4cb9-a3e2-dbb3d824b55f',
        text: 'I work hard',
        keyed: 'plus',
        domain: 'C',
        facet: 4
    },
    {
        id: '481efd08-c810-43b1-a952-f8ac9052f96b',
        text: 'I go on binges',
        keyed: 'plus',
        domain: 'N',
        facet: 5
    },
    {
        id: '987efee2-899f-4a65-b9b5-1589ef0460d7',
        text: 'I love excitement',
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: 'e1e804c7-4a1d-498f-8610-f95147af9d1d',
        text: 'I love to read challenging material',
        keyed: 'plus',
        domain: 'O',
        facet: 5
    },
    {
        id: '71029381-3908-4c68-91e1-e41fb45542a2',
        text: 'I believe that I am better than others',
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: 'f6076eea-56ae-4b46-97f1-5f94a7676c96',
        text: 'I am always prepared',
        keyed: 'plus',
        domain: 'C',
        facet: 5
    },
    {
        id: '2f519935-92e8-48ad-9746-4a0f8b38466a',
        text: 'I panic easily',
        keyed: 'plus',
        domain: 'N',
        facet: 6
    },
    {
        id: '899c3f66-51d0-46ea-963a-6fc36d3b3cb9',
        text: 'I radiate joy',
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: '79186f48-e7fa-4df4-b74b-b0627ee244e1',
        text: 'I tend to vote for liberal political candidates',
        keyed: 'plus',
        domain: 'O',
        facet: 6
    },
    {
        id: 'fd50e1ca-d9e0-4037-a7a1-a191d4db2d96',
        text: 'I sympathize with the homeless',
        keyed: 'plus',
        domain: 'A',
        facet: 6
    },
    {
        id: 'bd9eec0a-b68b-472c-8803-7db29c308cdb',
        text: 'I jump into things without thinking',
        keyed: 'minus',
        domain: 'C',
        facet: 6
    },
    {
        id: '7f92ab2c-265c-4b84-8c74-09f9bb9d41a7',
        text: 'I fear for the worst',
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: 'af55f014-788c-4b6e-92c4-b2b59dc8a28d',
        text: 'I feel comfortable around people',
        keyed: 'plus',
        domain: 'E',
        facet: 1
    },
    {
        id: '08ff6dca-02a5-4aeb-aaa4-2ecf2526f143',
        text: 'I enjoy wild flights of fantasy',
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: '6f66cdc0-9044-457b-b40d-501ecae15ee7',
        text: 'I believe that others have good intentions',
        keyed: 'plus',
        domain: 'A',
        facet: 1
    },
    {
        id: 'f110fc66-2e9e-413c-920b-19f05e63d7ac',
        text: 'I excel in what I do',
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: '7dab2a37-8635-4fc7-86b7-0abf13c183c9',
        text: 'I get irritated easily',
        keyed: 'plus',
        domain: 'N',
        facet: 2
    },
    {
        id: '28ab59a0-e7cd-4fce-94e3-bba2ecc023b6',
        text: 'I talk to a lot of different people at parties',
        keyed: 'plus',
        domain: 'E',
        facet: 2
    },
    {
        id: 'b5919f2f-cded-4745-a9ce-c02703cee807',
        text: 'I see beauty in things that others might not notice',
        keyed: 'plus',
        domain: 'O',
        facet: 2
    },
    {
        id: '5a5fa975-d024-4ac8-8845-2823f957c21b',
        text: 'I cheat to get ahead',
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: 'adf33f9f-45bd-43e3-af25-4c491176d97f',
        text: 'I often forget to put things back in their proper place',
        keyed: 'minus',
        domain: 'C',
        facet: 2
    },
    {
        id: 'f0a14e16-d726-47e9-a2c1-647fd3d7d52e',
        text: 'I dislike myself',
        keyed: 'plus',
        domain: 'N',
        facet: 3
    },
    {
        id: '0b38e3d3-c15c-454c-b034-f4eb7ae1580a',
        text: 'I try to lead others',
        keyed: 'plus',
        domain: 'E',
        facet: 3
    },
    {
        id: '5631b856-ff34-4f76-a0cd-edc7104c3bfa',
        text: "I feel others' emotions",
        keyed: 'plus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'ada867af-4db1-4e3d-a604-2b695c1806e5',
        text: 'I am concerned about others',
        keyed: 'plus',
        domain: 'A',
        facet: 3
    },
    {
        id: 'c55e3958-00c4-4fc3-9118-47d8f31bfde1',
        text: 'I tell the truth',
        keyed: 'plus',
        domain: 'C',
        facet: 3
    },
    {
        id: 'acd8fadc-5399-4a67-b5ff-9d1ada049c01',
        text: 'I am afraid to draw attention to myself',
        keyed: 'plus',
        domain: 'N',
        facet: 4
    },
    {
        id: 'd07b6c67-0d02-4948-a997-bb84ac234cd8',
        text: 'I am always on the go',
        keyed: 'plus',
        domain: 'E',
        facet: 4
    },
    {
        id: '33b81fd0-7e32-4cd8-a13a-d5f5f754f998',
        text: 'I prefer to stick with things that I know',
        keyed: 'minus',
        domain: 'O',
        facet: 4
    },
    {
        id: 'd9a9a180-29c9-4ec5-8621-2256d411def7',
        text: 'I yell at people',
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: 'f12c3d9d-1d12-4aa6-ad2e-009cd0651cbb',
        text: "I do more than what's expected of me",
        keyed: 'plus',
        domain: 'C',
        facet: 4
    },
    {
        id: '9891b7ba-a494-4307-aafe-301d8db506c6',
        text: 'I rarely overindulge',
        keyed: 'minus',
        domain: 'N',
        facet: 5
    },
    {
        id: 'f1675af6-88bf-4376-a946-0281e762b39c',
        text: 'I seek adventure',
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: '95a3f20c-f933-4d19-a2c1-a7dbdf63c562',
        text: 'I avoid philosophical discussions',
        keyed: 'minus',
        domain: 'O',
        facet: 5
    },
    {
        id: '7df44711-4cd4-4b05-8830-73fcc3ebdab5',
        text: 'I think highly of myself',
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: '9d3cb5c7-955c-43a4-b6c7-b07ed01dcbd9',
        text: 'I carry out my plans',
        keyed: 'plus',
        domain: 'C',
        facet: 5
    },
    {
        id: '13c58810-3864-42ba-aa87-d4166f858756',
        text: 'I become overwhelmed by events',
        keyed: 'plus',
        domain: 'N',
        facet: 6
    },
    {
        id: '961376e0-16a1-4c14-b059-789e63d11b63',
        text: 'I have a lot of fun',
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: 'f08e1b27-3673-4898-9cae-896482d0d9f9',
        text: 'I believe that there is no absolute right and wrong',
        keyed: 'plus',
        domain: 'O',
        facet: 6
    },
    {
        id: 'c2038c12-7a37-47a8-9983-831bd6692aab',
        text: 'I feel sympathy for those who are worse off than myself',
        keyed: 'plus',
        domain: 'A',
        facet: 6
    },
    {
        id: '956f3e17-ff17-4af5-a52f-9222b8968106',
        text: 'I make rash decisions',
        keyed: 'minus',
        domain: 'C',
        facet: 6
    },
    {
        id: '4d81238b-5407-47d4-88e5-dc0e38aa14f5',
        text: 'I am afraid of many things',
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: '9f9166f0-fa94-4c14-a91d-3eecd8395794',
        text: 'I avoid contacts with others',
        keyed: 'minus',
        domain: 'E',
        facet: 1
    },
    {
        id: '23a1034f-fab7-4887-a66e-5ef4eaafb25e',
        text: 'I love to daydream',
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: 'c63e6121-c3ed-40cc-abc2-c1e6ea1e0858',
        text: 'I trust what people say',
        keyed: 'plus',
        domain: 'A',
        facet: 1
    },
    {
        id: '02ee1930-36a7-4caa-b10c-c93efb682a44',
        text: 'I handle tasks smoothly',
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: 'da8e6ed1-2296-4c58-8fdb-66f2f591989b',
        text: 'I lose my temper',
        keyed: 'plus',
        domain: 'N',
        facet: 2
    },
    {
        id: '03c10b30-b88f-4c63-8acc-71251ca24615',
        text: 'I prefer to be alone',
        keyed: 'minus',
        domain: 'E',
        facet: 2
    },
    {
        id: '751a04bc-5adf-485a-8ea4-4308406ae85b',
        text: 'I do not like poetry',
        keyed: 'minus',
        domain: 'O',
        facet: 2
    },
    {
        id: '982e83c2-d34e-48da-9c71-78494ab05c85',
        text: 'I take advantage of others',
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: 'f4891687-0ff0-47af-a4f6-d1202c8f6676',
        text: 'I leave a mess in my room',
        keyed: 'minus',
        domain: 'C',
        facet: 2
    },
    {
        id: '743d8973-1de1-4485-91b4-8a5cf63e7d44',
        text: 'I am often down in the dumps',
        keyed: 'plus',
        domain: 'N',
        facet: 3
    },
    {
        id: '2452f034-8273-4f71-9122-a40f5ead31ba',
        text: 'I take control of things',
        keyed: 'plus',
        domain: 'E',
        facet: 3
    },
    {
        id: '2a300001-6e05-4c79-b8b5-2ccae4c3d463',
        text: 'I rarely notice my emotional reactions',
        keyed: 'minus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'cd54bd76-ca9c-4030-b325-bb8d896bcb3f',
        text: 'I am indifferent to the feelings of others',
        keyed: 'minus',
        domain: 'A',
        facet: 3
    },
    {
        id: '4e6e3a34-176f-4e6e-8730-1341611f972b',
        text: 'I break rules',
        keyed: 'minus',
        domain: 'C',
        facet: 3
    },
    {
        id: '20062533-a33d-4c1e-9cd9-bff868015b3f',
        text: 'I only feel comfortable with friends',
        keyed: 'plus',
        domain: 'N',
        facet: 4
    },
    {
        id: 'b2a077d5-1fe0-4b06-ab63-35455e001e54',
        text: 'I do a lot in my spare time',
        keyed: 'plus',
        domain: 'E',
        facet: 4
    },
    {
        id: '0d2e65ab-95d9-482f-beb4-3239a3a4944a',
        text: 'I dislike changes',
        keyed: 'minus',
        domain: 'O',
        facet: 4
    },
    {
        id: '0de0f900-cede-4538-9c00-5da4f830b028',
        text: 'I insult people',
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: 'a9c97d6b-6721-4150-8d84-64ef3082f164',
        text: 'I do just enough work to get by',
        keyed: 'minus',
        domain: 'C',
        facet: 4
    },
    {
        id: '9f2e7f90-0ca5-4ed0-9fe5-e060238a9b5e',
        text: 'I easily resist temptations',
        keyed: 'minus',
        domain: 'N',
        facet: 5
    },
    {
        id: '7dd6cf2d-5c14-48c2-8ae5-633a7a596c71',
        text: 'I enjoy being reckless',
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: 'fecc35f7-681e-4889-a404-4a973a3dfef0',
        text: 'I have difficulty understanding abstract ideas',
        keyed: 'minus',
        domain: 'O',
        facet: 5
    },
    {
        id: '1d686958-6fe7-432f-85e6-186b99e4e232',
        text: 'I have a high opinion of myself',
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: 'c7db0ed8-df7d-49bf-942f-59e46ef743c4',
        text: 'I waste my time',
        keyed: 'minus',
        domain: 'C',
        facet: 5
    },
    {
        id: 'b7e0e393-9b21-4e0d-adf3-8f28fb5b9d87',
        text: "I feel that I'm unable to deal with things",
        keyed: 'plus',
        domain: 'N',
        facet: 6
    },
    {
        id: '79d956e8-1118-402a-a0e2-9380af18243e',
        text: 'I love life',
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: '96ba77b2-1a44-4dfd-95f9-ae4d1f714460',
        text: 'I tend to vote for conservative political candidates',
        keyed: 'minus',
        domain: 'O',
        facet: 6
    },
    {
        id: '77f54ab4-0fba-4efb-8700-066c7490eb87',
        text: "I am not interested in other people's problems",
        keyed: 'minus',
        domain: 'A',
        facet: 6
    },
    {
        id: 'a354cf7c-8d11-46ac-acc5-da90d2048637',
        text: 'I rush into things',
        keyed: 'minus',
        domain: 'C',
        facet: 6
    },
    {
        id: '43b03992-3f32-4ed1-a6f8-5d6d3e7ed246',
        text: 'I get stressed out easily',
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: '41702602-08e4-4e2b-9a19-291d9efc581a',
        text: 'I keep others at a distance',
        keyed: 'minus',
        domain: 'E',
        facet: 1
    },
    {
        id: '935a7413-abac-4f54-9169-d1fbd39da752',
        text: 'I like to get lost in thought',
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: '432dbde8-8756-4ff0-80d5-f47018235139',
        text: 'I distrust people',
        keyed: 'minus',
        domain: 'A',
        facet: 1
    },
    {
        id: '5727c93f-317b-4af1-a686-77fc9fbc5033',
        text: 'I know how to get things done',
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: 'd32bd062-4eb2-401b-99b2-e7afea39ca9b',
        text: 'I am not easily annoyed',
        keyed: 'minus',
        domain: 'N',
        facet: 2
    },
    {
        id: '9a47184f-6046-4e68-a61b-3d9b357b86ea',
        text: 'I avoid crowds',
        keyed: 'minus',
        domain: 'E',
        facet: 2
    },
    {
        id: '87c5b27e-59a8-4c48-8ba8-f5413d735693',
        text: 'I do not enjoy going to art museums',
        keyed: 'minus',
        domain: 'O',
        facet: 2
    },
    {
        id: '11b20adb-abed-4363-894c-3dd823ae0540',
        text: "I obstruct others' plans",
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: '50418d86-712c-45d9-adc4-ea0231c93cf5',
        text: 'I leave my belongings around',
        keyed: 'minus',
        domain: 'C',
        facet: 2
    },
    {
        id: 'f40e421f-6c24-4be2-bd9f-28d33358d8c6',
        text: 'I feel comfortable with myself',
        keyed: 'minus',
        domain: 'N',
        facet: 3
    },
    {
        id: '8791f37b-686f-47c3-9db7-74c009951321',
        text: 'I wait for others to lead the way',
        keyed: 'minus',
        domain: 'E',
        facet: 3
    },
    {
        id: '4fd25155-9cc2-4cd6-8852-3e0ca2d5e95d',
        text: "I don't understand people who get emotional",
        keyed: 'minus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'b68af20d-24f9-4c27-85cc-fe0858994888',
        text: 'I take no time for others',
        keyed: 'minus',
        domain: 'A',
        facet: 3
    },
    {
        id: '54423933-0ebb-44a7-bdd9-2a9b100c70f2',
        text: 'I break my promises',
        keyed: 'minus',
        domain: 'C',
        facet: 3
    },
    {
        id: '7317848c-3e1b-422f-bb16-02efc504f677',
        text: 'I am not bothered by difficult social situations',
        keyed: 'minus',
        domain: 'N',
        facet: 4
    },
    {
        id: '7d93e1ca-46e8-4a30-9623-42a80c9b420c',
        text: 'I like to take it easy',
        keyed: 'minus',
        domain: 'E',
        facet: 4
    },
    {
        id: 'a7f43928-8982-4ed5-8656-7a80346fe979',
        text: 'I am attached to conventional ways',
        keyed: 'minus',
        domain: 'O',
        facet: 4
    },
    {
        id: '17910a55-a64a-4ed0-8b46-293e2fa2fe03',
        text: 'I get back at others',
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: '3890bb43-2695-4b8d-b289-ee10d11cc884',
        text: 'I put little time and effort into my work',
        keyed: 'minus',
        domain: 'C',
        facet: 4
    },
    {
        id: '49a85680-53aa-4208-86b5-dccc7a6f8e37',
        text: 'I am able to control my cravings',
        keyed: 'minus',
        domain: 'N',
        facet: 5
    },
    {
        id: '10f90fa9-649c-4631-ac4c-3dd3f751597d',
        text: 'I act wild and crazy',
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: 'b86de003-c3c4-4cc8-9385-5ac8a0142c34',
        text: 'I am not interested in theoretical discussions',
        keyed: 'minus',
        domain: 'O',
        facet: 5
    },
    {
        id: '80c1d149-7050-481a-9953-aefb441642e7',
        text: 'I boast about my virtues',
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: '51403620-968c-42fa-a772-65ba5ad8396f',
        text: 'I have difficulty starting tasks',
        keyed: 'minus',
        domain: 'C',
        facet: 5
    },
    {
        id: '88a3c2fe-3aa4-4f46-9322-da656332268a',
        text: 'I remain calm under pressure',
        keyed: 'minus',
        domain: 'N',
        facet: 6
    },
    {
        id: 'e7b31bdc-5f6b-40ec-ba91-f5919b0f170e',
        text: 'I look at the bright side of life',
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: '580b08d1-3c94-46e9-9d07-d6d80c698127',
        text: 'I believe that we should be tough on crime',
        keyed: 'minus',
        domain: 'O',
        facet: 6
    },
    {
        id: '48bee420-60c0-45cd-be43-3893dbc1969a',
        text: 'I try not to think about the needy',
        keyed: 'minus',
        domain: 'A',
        facet: 6
    },
    {
        id: 'ea3327ea-3529-4be4-8e2d-2174731ae4d7',
        text: 'I act without thinking',
        keyed: 'minus',
        domain: 'C',
        facet: 6
    }
];
var $e284769d226e732e$export$85fe4fda51f318c1 = {
    plus: [
        {
            text: 'Very Inaccurate',
            score: 1,
            color: 1
        },
        {
            text: 'Moderately Inaccurate',
            score: 2,
            color: 2
        },
        {
            text: 'Neither Accurate Nor Inaccurate',
            score: 3,
            color: 3
        },
        {
            text: 'Moderately Accurate',
            score: 4,
            color: 4
        },
        {
            text: 'Very Accurate',
            score: 5,
            color: 5
        }
    ],
    minus: [
        {
            text: 'Very Inaccurate',
            score: 5,
            color: 1
        },
        {
            text: 'Moderately Inaccurate',
            score: 4,
            color: 2
        },
        {
            text: 'Neither Accurate Nor Inaccurate',
            score: 3,
            color: 3
        },
        {
            text: 'Moderately Accurate',
            score: 2,
            color: 4
        },
        {
            text: 'Very Accurate',
            score: 1,
            color: 5
        }
    ]
};
var $e284769d226e732e$export$73b7d90b65b3ca0d = [
    {
        id: '43c98ce8-a07a-4dc2-80f6-c1b2a2485f06',
        text: "Jag oroar mig \xf6ver saker",
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: 'd50a597f-632b-4f7b-89e6-6d85b50fd1c9',
        text: "Jag har l\xe4tt f\xf6r att f\xe5 v\xe4nner",
        keyed: 'plus',
        domain: 'E',
        facet: 1
    },
    {
        id: '888dd864-7449-4e96-8d5c-7a439603ea91',
        text: 'Jag har en livlig fantasi',
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: 'ce2fbbf8-7a97-4199-bda5-117e4ecdf3b6',
        text: "Jag litar p\xe5 andra",
        keyed: 'plus',
        domain: 'A',
        facet: 1
    },
    {
        id: 'c7f53c3c-2e77-432f-bb71-7470b67d3aa9',
        text: "Jag slutf\xf6r mina uppgifter",
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: '48ad12ce-470e-4339-90ac-ea8c43a0103e',
        text: "Jag blir l\xe4tt arg",
        keyed: 'plus',
        domain: 'N',
        facet: 2
    },
    {
        id: '458f3957-2359-4077-ade1-34525d633063',
        text: "Jag \xe4lskar stora fester",
        keyed: 'plus',
        domain: 'E',
        facet: 2
    },
    {
        id: '58d571e5-d725-4cf8-a438-32c16ee28eb6',
        text: "Jag tycker att konst \xe4r viktigt",
        keyed: 'plus',
        domain: 'O',
        facet: 2
    },
    {
        id: '0cf79e27-e702-45c2-9471-04ac96b58e0e',
        text: "Jag anv\xe4nder andra sj\xe4lviskt f\xf6r att n\xe5 mina m\xe5l",
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: 'cda1ca17-b599-4561-a6cd-ff9d36062d27',
        text: "Jag tycker om att st\xe4da upp",
        keyed: 'plus',
        domain: 'C',
        facet: 2
    },
    {
        id: '5e8550d7-b8ef-4905-950a-f81d735d39e2',
        text: "Jag k\xe4nner mig ofta nere",
        keyed: 'plus',
        domain: 'N',
        facet: 3
    },
    {
        id: '8af754f2-68e9-48f3-8c5d-2e6633d4472c',
        text: 'Jag tar kommandot',
        keyed: 'plus',
        domain: 'E',
        facet: 3
    },
    {
        id: '0727def6-3d18-4221-bf38-86b58f9f3eed',
        text: "Jag upplever mina k\xe4nslor intensivt",
        keyed: 'plus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'ccf3a5c8-fb50-4bd4-8e7a-22af3d657279',
        text: "Jag \xe4lskar att hj\xe4lpa andra",
        keyed: 'plus',
        domain: 'A',
        facet: 3
    },
    {
        id: '73d84e5d-cbf5-47f0-b8cb-4d2159a52e32',
        text: "Jag h\xe5ller mina l\xf6ften",
        keyed: 'plus',
        domain: 'C',
        facet: 3
    },
    {
        id: 'b2d9ef74-73f5-4ea8-b00c-7aaca15937df',
        text: "Jag tycker det \xe4r sv\xe5rt att ta kontakt med andra",
        keyed: 'plus',
        domain: 'N',
        facet: 4
    },
    {
        id: '48a761ef-438e-409b-ae59-ea2ce8f84414',
        text: "Jag \xe4r alltid upptagen",
        keyed: 'plus',
        domain: 'E',
        facet: 4
    },
    {
        id: 'cae55842-8957-4e3b-83b3-ceff98fb9dcf',
        text: "Jag f\xf6redrar variation framf\xf6r rutin",
        keyed: 'plus',
        domain: 'O',
        facet: 4
    },
    {
        id: 'e2028ad3-b128-4f76-be57-398bfe2aff22',
        text: "Jag gillar n\xe4r en diskussion blir riktigt intensiv",
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: 'b7fc949b-02b6-4cb9-a3e2-dbb3d824b55f',
        text: "Jag arbetar h\xe5rt",
        keyed: 'plus',
        domain: 'C',
        facet: 4
    },
    {
        id: '481efd08-c810-43b1-a952-f8ac9052f96b',
        text: "Jag g\xf6r (eller konsumerar) f\xf6r mycket av saker jag inte borde",
        keyed: 'plus',
        domain: 'N',
        facet: 5
    },
    {
        id: '987efee2-899f-4a65-b9b5-1589ef0460d7',
        text: "Jag \xe4lskar sp\xe4nning",
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: 'e1e804c7-4a1d-498f-8610-f95147af9d1d',
        text: "Jag \xe4lskar att l\xe4sa utmanande skrifter",
        keyed: 'plus',
        domain: 'O',
        facet: 5
    },
    {
        id: '71029381-3908-4c68-91e1-e41fb45542a2',
        text: "Jag tror att jag \xe4r b\xe4ttre \xe4n andra",
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: 'f6076eea-56ae-4b46-97f1-5f94a7676c96',
        text: "Jag \xe4r alltid f\xf6rberedd",
        keyed: 'plus',
        domain: 'C',
        facet: 5
    },
    {
        id: '2f519935-92e8-48ad-9746-4a0f8b38466a',
        text: "Jag blir l\xe4tt panikslagen",
        keyed: 'plus',
        domain: 'N',
        facet: 6
    },
    {
        id: '899c3f66-51d0-46ea-963a-6fc36d3b3cb9',
        text: "Jag sprider gl\xe4dje",
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: '79186f48-e7fa-4df4-b74b-b0627ee244e1',
        text: "Jag brukar r\xf6sta p\xe5 partier som bryr sig om m\xe4nniskor",
        keyed: 'plus',
        domain: 'O',
        facet: 6
    },
    {
        id: 'fd50e1ca-d9e0-4037-a7a1-a191d4db2d96',
        text: "Jag sympatiserar med de heml\xf6sa",
        keyed: 'plus',
        domain: 'A',
        facet: 6
    },
    {
        id: 'bd9eec0a-b68b-472c-8803-7db29c308cdb',
        text: "Jag \xe5tar mig saker utan att t\xe4nka efter",
        keyed: 'minus',
        domain: 'C',
        facet: 6
    },
    {
        id: '7f92ab2c-265c-4b84-8c74-09f9bb9d41a7',
        text: "Jag v\xe4ntar mig att saker slutar illa",
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: 'af55f014-788c-4b6e-92c4-b2b59dc8a28d',
        text: "Jag trivs n\xe4r det finns m\xe4nniskor omkring mig",
        keyed: 'plus',
        domain: 'E',
        facet: 1
    },
    {
        id: '08ff6dca-02a5-4aeb-aaa4-2ecf2526f143',
        text: 'Jag gillar att fantisera vilt',
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: '6f66cdc0-9044-457b-b40d-501ecae15ee7',
        text: 'Jag tror att de flesta har goda avsikter',
        keyed: 'plus',
        domain: 'A',
        facet: 1
    },
    {
        id: 'f110fc66-2e9e-413c-920b-19f05e63d7ac',
        text: "Jag \xe4r mycket bra p\xe5 det jag g\xf6r",
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: '7dab2a37-8635-4fc7-86b7-0abf13c183c9',
        text: "Jag blir l\xe4tt irriterad",
        keyed: 'plus',
        domain: 'N',
        facet: 2
    },
    {
        id: '28ab59a0-e7cd-4fce-94e3-bba2ecc023b6',
        text: "Jag pratar med m\xe5nga olika p\xe5 fester",
        keyed: 'plus',
        domain: 'E',
        facet: 2
    },
    {
        id: 'b5919f2f-cded-4745-a9ce-c02703cee807',
        text: "Jag ser sk\xf6nhet i saker de flesta inte l\xe4gger m\xe4rke till",
        keyed: 'plus',
        domain: 'O',
        facet: 2
    },
    {
        id: '5a5fa975-d024-4ac8-8845-2823f957c21b',
        text: "Jag \xe4r o\xe4rlig f\xf6r att ta mig fram\xe5t och upp\xe5t",
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: 'adf33f9f-45bd-43e3-af25-4c491176d97f',
        text: "Jag gl\xf6mmer ofta att l\xe4gga tillbaka saker p\xe5 sin r\xe4tta plats",
        keyed: 'minus',
        domain: 'C',
        facet: 2
    },
    {
        id: 'f0a14e16-d726-47e9-a2c1-647fd3d7d52e',
        text: "Jag tycker illa om mig sj\xe4lv",
        keyed: 'plus',
        domain: 'N',
        facet: 3
    },
    {
        id: '0b38e3d3-c15c-454c-b034-f4eb7ae1580a',
        text: "Jag f\xf6rs\xf6ker att leda andra",
        keyed: 'plus',
        domain: 'E',
        facet: 3
    },
    {
        id: '5631b856-ff34-4f76-a0cd-edc7104c3bfa',
        text: "Jag k\xe4nner andra m\xe4nniskors k\xe4nslor",
        keyed: 'plus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'ada867af-4db1-4e3d-a604-2b695c1806e5',
        text: 'Jag bryr mig om andra',
        keyed: 'plus',
        domain: 'A',
        facet: 3
    },
    {
        id: 'c55e3958-00c4-4fc3-9118-47d8f31bfde1',
        text: 'Jag talar sanning',
        keyed: 'plus',
        domain: 'C',
        facet: 3
    },
    {
        id: 'acd8fadc-5399-4a67-b5ff-9d1ada049c01',
        text: "Jag \xe4r r\xe4dd f\xf6r att dra uppm\xe4rksamhet mot mig",
        keyed: 'plus',
        domain: 'N',
        facet: 4
    },
    {
        id: 'd07b6c67-0d02-4948-a997-bb84ac234cd8',
        text: "Jag har alltid n\xe5got p\xe5 g\xe5ng",
        keyed: 'plus',
        domain: 'E',
        facet: 4
    },
    {
        id: '33b81fd0-7e32-4cd8-a13a-d5f5f754f998',
        text: "Jag f\xf6redrar att h\xe5lla mig till saker jag k\xe4nner till",
        keyed: 'minus',
        domain: 'O',
        facet: 4
    },
    {
        id: 'd9a9a180-29c9-4ec5-8621-2256d411def7',
        text: "Jag gapar/skriker p\xe5 andra",
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: 'f12c3d9d-1d12-4aa6-ad2e-009cd0651cbb',
        text: "Jag g\xf6r mer \xe4n vad som f\xf6rv\xe4ntas av mig",
        keyed: 'plus',
        domain: 'C',
        facet: 4
    },
    {
        id: '9891b7ba-a494-4307-aafe-301d8db506c6',
        text: "Jag ger s\xe4llan oaktat utlopp f\xf6r mina beg\xe4r",
        keyed: 'minus',
        domain: 'N',
        facet: 5
    },
    {
        id: 'f1675af6-88bf-4376-a946-0281e762b39c',
        text: "Jag s\xf6ker \xe4ventyr",
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: '95a3f20c-f933-4d19-a2c1-a7dbdf63c562',
        text: 'Jag undviker filosofiska diskussioner',
        keyed: 'minus',
        domain: 'O',
        facet: 5
    },
    {
        id: '7df44711-4cd4-4b05-8830-73fcc3ebdab5',
        text: "Jag har h\xf6ga tankar om mig sj\xe4lv",
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: '9d3cb5c7-955c-43a4-b6c7-b07ed01dcbd9',
        text: "Jag genomf\xf6r mina planer",
        keyed: 'plus',
        domain: 'C',
        facet: 5
    },
    {
        id: '13c58810-3864-42ba-aa87-d4166f858756',
        text: "Jag blir \xf6verv\xe4ldigad av st\xf6rre h\xe4ndelser",
        keyed: 'plus',
        domain: 'N',
        facet: 6
    },
    {
        id: '961376e0-16a1-4c14-b059-789e63d11b63',
        text: 'Jag har roligt ofta',
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: 'f08e1b27-3673-4898-9cae-896482d0d9f9',
        text: "Jag tror inte att saker eller handlingar enbart \xe4r r\xe4tt eller fel",
        keyed: 'plus',
        domain: 'O',
        facet: 6
    },
    {
        id: 'c2038c12-7a37-47a8-9983-831bd6692aab',
        text: "Jag k\xe4nner sympati med de som har det s\xe4mre \xe4n jag",
        keyed: 'plus',
        domain: 'A',
        facet: 6
    },
    {
        id: '956f3e17-ff17-4af5-a52f-9222b8968106',
        text: "Jag tar f\xf6rhastade beslut",
        keyed: 'minus',
        domain: 'C',
        facet: 6
    },
    {
        id: '4d81238b-5407-47d4-88e5-dc0e38aa14f5',
        text: "Jag \xe4r r\xe4dd f\xf6r mycket",
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: '9f9166f0-fa94-4c14-a91d-3eecd8395794',
        text: 'Jag undviker kontakter med andra',
        keyed: 'minus',
        domain: 'E',
        facet: 1
    },
    {
        id: '23a1034f-fab7-4887-a66e-5ef4eaafb25e',
        text: "Jag \xe4lskar att dagdr\xf6mma",
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: 'c63e6121-c3ed-40cc-abc2-c1e6ea1e0858',
        text: "Jag litar p\xe5 vad folk s\xe4ger",
        keyed: 'plus',
        domain: 'A',
        facet: 1
    },
    {
        id: '02ee1930-36a7-4caa-b10c-c93efb682a44',
        text: "Jag hanterar uppgifter utan besv\xe4r",
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: 'da8e6ed1-2296-4c58-8fdb-66f2f591989b',
        text: "Jag tappar hum\xf6ret",
        keyed: 'plus',
        domain: 'N',
        facet: 2
    },
    {
        id: '03c10b30-b88f-4c63-8acc-71251ca24615',
        text: "Jag f\xf6redrar att vara ensam",
        keyed: 'minus',
        domain: 'E',
        facet: 2
    },
    {
        id: '751a04bc-5adf-485a-8ea4-4308406ae85b',
        text: 'Jag gillar inte poesi',
        keyed: 'minus',
        domain: 'O',
        facet: 2
    },
    {
        id: '982e83c2-d34e-48da-9c71-78494ab05c85',
        text: 'Jag utnyttjar andra',
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: 'f4891687-0ff0-47af-a4f6-d1202c8f6676',
        text: "Jag l\xe4mnar mitt rum i en enda r\xf6ra",
        keyed: 'minus',
        domain: 'C',
        facet: 2
    },
    {
        id: '743d8973-1de1-4485-91b4-8a5cf63e7d44',
        text: "Jag \xe4r ofta deppig",
        keyed: 'plus',
        domain: 'N',
        facet: 3
    },
    {
        id: '2452f034-8273-4f71-9122-a40f5ead31ba',
        text: "Jag tar kontroll \xf6ver situationen",
        keyed: 'plus',
        domain: 'E',
        facet: 3
    },
    {
        id: '2a300001-6e05-4c79-b8b5-2ccae4c3d463',
        text: "Jag l\xe4gger s\xe4llan m\xe4rke till mina emotionella reaktioner",
        keyed: 'minus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'cd54bd76-ca9c-4030-b325-bb8d896bcb3f',
        text: "Jag \xe4r likgiltig inf\xf6r andras k\xe4nslor",
        keyed: 'minus',
        domain: 'A',
        facet: 3
    },
    {
        id: '4e6e3a34-176f-4e6e-8730-1341611f972b',
        text: 'Jag bryter regler',
        keyed: 'minus',
        domain: 'C',
        facet: 3
    },
    {
        id: '20062533-a33d-4c1e-9cd9-bff868015b3f',
        text: "Jag k\xe4nner mig bara tillfreds bland v\xe4nner",
        keyed: 'plus',
        domain: 'N',
        facet: 4
    },
    {
        id: 'b2a077d5-1fe0-4b06-ab63-35455e001e54',
        text: "Jag g\xf6r massor p\xe5 min fritid",
        keyed: 'plus',
        domain: 'E',
        facet: 4
    },
    {
        id: '0d2e65ab-95d9-482f-beb4-3239a3a4944a',
        text: "Jag tycker illa om f\xf6r\xe4ndringar",
        keyed: 'minus',
        domain: 'O',
        facet: 4
    },
    {
        id: '0de0f900-cede-4538-9c00-5da4f830b028',
        text: "Jag f\xf6rol\xe4mpar folk",
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: 'a9c97d6b-6721-4150-8d84-64ef3082f164',
        text: "Jag arbetar bara tillr\xe4ckligt f\xf6r att klara mig",
        keyed: 'minus',
        domain: 'C',
        facet: 4
    },
    {
        id: '9f2e7f90-0ca5-4ed0-9fe5-e060238a9b5e',
        text: "Jag st\xe5r emot frestelser utan problem",
        keyed: 'minus',
        domain: 'N',
        facet: 5
    },
    {
        id: '7dd6cf2d-5c14-48c2-8ae5-633a7a596c71',
        text: "Jag tycker om att vara obet\xe4nksam",
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: 'fecc35f7-681e-4889-a404-4a973a3dfef0',
        text: "Jag har sv\xe5rt att f\xf6rst\xe5 abstrakta id\xe9er",
        keyed: 'minus',
        domain: 'O',
        facet: 5
    },
    {
        id: '1d686958-6fe7-432f-85e6-186b99e4e232',
        text: "Jag har en positiv uppfattning om mig sj\xe4lv",
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: 'c7db0ed8-df7d-49bf-942f-59e46ef743c4',
        text: "Jag sl\xf6sar bort min tid",
        keyed: 'minus',
        domain: 'C',
        facet: 5
    },
    {
        id: 'b7e0e393-9b21-4e0d-adf3-8f28fb5b9d87',
        text: "Jag tycker att jag har sv\xe5rt att handskas med saker",
        keyed: 'plus',
        domain: 'N',
        facet: 6
    },
    {
        id: '79d956e8-1118-402a-a0e2-9380af18243e',
        text: "Jag \xe4lskar livet",
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: '96ba77b2-1a44-4dfd-95f9-ae4d1f714460',
        text: "Jag brukar r\xf6sta p\xe5 de konservativa partierna",
        keyed: 'minus',
        domain: 'O',
        facet: 6
    },
    {
        id: '77f54ab4-0fba-4efb-8700-066c7490eb87',
        text: "Jag \xe4r inte intresserad av andra m\xe4nniskors problem",
        keyed: 'minus',
        domain: 'A',
        facet: 6
    },
    {
        id: 'a354cf7c-8d11-46ac-acc5-da90d2048637',
        text: "Jag kastar mig \xf6ver saker",
        keyed: 'minus',
        domain: 'C',
        facet: 6
    },
    {
        id: '43b03992-3f32-4ed1-a6f8-5d6d3e7ed246',
        text: "Jag blir l\xe4tt stressad",
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: '41702602-08e4-4e2b-9a19-291d9efc581a',
        text: "Jag h\xe5ller andra p\xe5 avst\xe5nd",
        keyed: 'minus',
        domain: 'E',
        facet: 1
    },
    {
        id: '935a7413-abac-4f54-9169-d1fbd39da752',
        text: "Jag tycker om att f\xf6rsvinna i tankar",
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: '432dbde8-8756-4ff0-80d5-f47018235139',
        text: "Jag misstror m\xe4nniskor",
        keyed: 'minus',
        domain: 'A',
        facet: 1
    },
    {
        id: '5727c93f-317b-4af1-a686-77fc9fbc5033',
        text: "Jag vet hur man f\xe5r saker gjorda",
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: 'd32bd062-4eb2-401b-99b2-e7afea39ca9b',
        text: "Jag \xe4r sv\xe5r att g\xf6ra arg",
        keyed: 'minus',
        domain: 'N',
        facet: 2
    },
    {
        id: '9a47184f-6046-4e68-a61b-3d9b357b86ea',
        text: 'Jag undviker folksamlingar',
        keyed: 'minus',
        domain: 'E',
        facet: 2
    },
    {
        id: '87c5b27e-59a8-4c48-8ba8-f5413d735693',
        text: "Jag gillar inte att g\xe5 p\xe5 konstmuseum",
        keyed: 'minus',
        domain: 'O',
        facet: 2
    },
    {
        id: '11b20adb-abed-4363-894c-3dd823ae0540',
        text: "Jag l\xe4gger hinder i v\xe4gen f\xf6r andras planer",
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: '50418d86-712c-45d9-adc4-ea0231c93cf5',
        text: "Jag l\xe4mnar mina saker liggande \xf6verallt",
        keyed: 'minus',
        domain: 'C',
        facet: 2
    },
    {
        id: 'f40e421f-6c24-4be2-bd9f-28d33358d8c6',
        text: "Jag k\xe4nner mig bekv\xe4m i mig sj\xe4lv",
        keyed: 'minus',
        domain: 'N',
        facet: 3
    },
    {
        id: '8791f37b-686f-47c3-9db7-74c009951321',
        text: "Jag v\xe4ntar p\xe5 att andra ska visa v\xe4gen",
        keyed: 'minus',
        domain: 'E',
        facet: 3
    },
    {
        id: '4fd25155-9cc2-4cd6-8852-3e0ca2d5e95d',
        text: "Jag f\xf6rst\xe5r inte m\xe4nniskor som blir k\xe4nslosamma",
        keyed: 'minus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'b68af20d-24f9-4c27-85cc-fe0858994888',
        text: "Jag tar mig inte tid f\xf6r andra",
        keyed: 'minus',
        domain: 'A',
        facet: 3
    },
    {
        id: '54423933-0ebb-44a7-bdd9-2a9b100c70f2',
        text: "Jag bryter mina l\xf6ften",
        keyed: 'minus',
        domain: 'C',
        facet: 3
    },
    {
        id: '7317848c-3e1b-422f-bb16-02efc504f677',
        text: "Jag blir inte st\xf6rd av besv\xe4rliga sociala situationer",
        keyed: 'minus',
        domain: 'N',
        facet: 4
    },
    {
        id: '7d93e1ca-46e8-4a30-9623-42a80c9b420c',
        text: 'Jag tycker om att ta det lugnt',
        keyed: 'minus',
        domain: 'E',
        facet: 4
    },
    {
        id: 'a7f43928-8982-4ed5-8656-7a80346fe979',
        text: "Jag h\xe5ller fast vid konventionella tillv\xe4gag\xe5ngss\xe4tt",
        keyed: 'minus',
        domain: 'O',
        facet: 4
    },
    {
        id: '17910a55-a64a-4ed0-8b46-293e2fa2fe03',
        text: "Jag tar revansch p\xe5 andra",
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: '3890bb43-2695-4b8d-b289-ee10d11cc884',
        text: "Jag l\xe4gger lite tid och energi p\xe5 mitt arbete",
        keyed: 'minus',
        domain: 'C',
        facet: 4
    },
    {
        id: '49a85680-53aa-4208-86b5-dccc7a6f8e37',
        text: "Jag kan h\xe5lla mina beg\xe4r i styr",
        keyed: 'minus',
        domain: 'N',
        facet: 5
    },
    {
        id: '10f90fa9-649c-4631-ac4c-3dd3f751597d',
        text: 'Jag agerar vilt och galet',
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: 'b86de003-c3c4-4cc8-9385-5ac8a0142c34',
        text: "Jag \xe4r inte intresserad av teoretiska diskussioner",
        keyed: 'minus',
        domain: 'O',
        facet: 5
    },
    {
        id: '80c1d149-7050-481a-9953-aefb441642e7',
        text: 'Jag skryter om mina bra egenskaper',
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: '51403620-968c-42fa-a772-65ba5ad8396f',
        text: "Jag har sv\xe5rt att s\xe4tta ig\xe5ng med saker",
        keyed: 'minus',
        domain: 'C',
        facet: 5
    },
    {
        id: '88a3c2fe-3aa4-4f46-9322-da656332268a',
        text: "Jag h\xe5ller mig lugn \xe4ven n\xe4r mycket st\xe5r p\xe5 spel",
        keyed: 'minus',
        domain: 'N',
        facet: 6
    },
    {
        id: 'e7b31bdc-5f6b-40ec-ba91-f5919b0f170e',
        text: "Jag ser livet fr\xe5n den ljusa sidan",
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: '580b08d1-3c94-46e9-9d07-d6d80c698127',
        text: "Jag tycker att straffen f\xf6r brottslighet ska vara h\xe5rda",
        keyed: 'minus',
        domain: 'O',
        facet: 6
    },
    {
        id: '48bee420-60c0-45cd-be43-3893dbc1969a',
        text: "Jag f\xf6rs\xf6ker att inte t\xe4nka p\xe5 de beh\xf6vande",
        keyed: 'minus',
        domain: 'A',
        facet: 6
    },
    {
        id: 'ea3327ea-3529-4be4-8e2d-2174731ae4d7',
        text: "Jag agerar utan att t\xe4nka",
        keyed: 'minus',
        domain: 'C',
        facet: 6
    }
];
var $e284769d226e732e$export$5834f94f113a6029 = {
    plus: [
        {
            text: "St\xe4mmer absolut inte",
            score: 1,
            color: 1
        },
        {
            text: "St\xe4mmer ganska d\xe5ligt",
            score: 2,
            color: 2
        },
        {
            text: "St\xe4mmer varken bra eller d\xe5ligt",
            score: 3,
            color: 3
        },
        {
            text: "St\xe4mmer ganska bra",
            score: 4,
            color: 4
        },
        {
            text: "St\xe4mmer absolut",
            score: 5,
            color: 5
        }
    ],
    minus: [
        {
            text: "St\xe4mmer absolut inte",
            score: 5,
            color: 1
        },
        {
            text: "St\xe4mmer ganska d\xe5ligt",
            score: 4,
            color: 2
        },
        {
            text: "St\xe4mmer varken bra eller d\xe5ligt",
            score: 3,
            color: 3
        },
        {
            text: "St\xe4mmer ganska bra",
            score: 2,
            color: 4
        },
        {
            text: "St\xe4mmer absolut",
            score: 1,
            color: 5
        }
    ]
};
var $e284769d226e732e$export$a4b2f0479fb48f88 = {
    domain: 'A',
    title: 'Agreeableness',
    shortDescription: 'Agreeableness reflects individual differences in concern with cooperation and social harmony. Agreeable individuals value getting along with others.',
    description: "They are therefore considerate, friendly,\ngenerous, helpful, and willing to compromise their interests with\nothers'. Agreeable people also have an optimistic view of human\nnature. They believe people are basically honest, decent, and\ntrustworthy. <br /><br />\nDisagreeable individuals place self-interest above getting along with\nothers.  They are generally unconcerned with others' well-being, and\ntherefore are unlikely to extend themselves for other people.\nSometimes their skepticism about others' motives causes them to be\nsuspicious, unfriendly, and uncooperative.\n<br /><br />\nAgreeableness is obviously advantageous for attaining and maintaining\npopularity. Agreeable people are better liked than disagreeable\npeople. On the other hand, agreeableness is not useful in situations\nthat require tough or absolute objective decisions. Disagreeable\npeople can make excellent scientists, critics, or soldiers.",
    results: [
        {
            score: 'low',
            text: "Your score on Agreeableness is low, indicating less concern\nwith others' needs than with your own. People see you as tough,\ncritical, and uncompromising."
        },
        {
            score: 'neutral',
            text: "Your level of Agreeableness is average, indicating some concern\nwith others' Needs, but, generally, unwillingness to sacrifice\nyourself for others."
        },
        {
            score: 'high',
            text: "Your high level of Agreeableness indicates a strong interest in\nothers' needs and well-being. You are pleasant, sympathetic, and\ncooperative."
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Trust',
            text: "A person with high trust assumes that most people\nare fair, honest, and have good intentions. Persons low in trust\nsee others as selfish, devious, and potentially dangerous."
        },
        {
            facet: 2,
            title: 'Morality',
            text: "High scorers on this scale see no need for\npretense or manipulation when dealing with others and are therefore\ncandid, frank, and sincere. Low scorers believe that a certain\namount of deception in social relationships is necessary. People\nfind it relatively easy to relate to the straightforward\nhigh-scorers on this scale. They generally find it more difficult\nto relate to the unstraightforward low-scorers on this scale. It\nshould be made clear that low scorers are not unprincipled\nor immoral; they are simply more guarded and less willing to openly\nreveal the whole truth."
        },
        {
            facet: 3,
            title: 'Altruism',
            text: "Altruistic people find helping other people\ngenuinely rewarding. Consequently, they are generally willing to\nassist those who are in need. Altruistic people find that doing\nthings for others is a form of self-fulfillment rather than\nself-sacrifice. Low scorers on this scale do not particularly like\nhelping those in need. Requests for help feel like an imposition\nrather than an opportunity for self-fulfillment."
        },
        {
            facet: 4,
            title: 'Cooperation',
            text: "Individuals who score high on this scale\ndislike confrontations. They are perfectly willing to compromise or\nto deny their own needs in order to get along with others. Those\nwho score low on this scale are more likely to intimidate others to\nget their way."
        },
        {
            facet: 5,
            title: 'Modesty',
            text: "High scorers on this scale do not like to claim\nthat they are better than other people. In some cases this attitude\nmay derive from low self-confidence or self-esteem. Nonetheless,\nsome people with high self-esteem find immodesty unseemly. Those\nwho are willing to describe themselves as superior tend to\nbe seen as disagreeably arrogant by other people."
        },
        {
            facet: 6,
            title: 'Sympathy',
            text: "People who score high on this scale are\ntenderhearted and compassionate. They feel the pain of others\nvicariously and are easily moved to pity. Low scorers are not\naffected strongly by human suffering. They pride themselves on\nmaking objective judgments based on reason. They are more concerned\nwith truth and impartial justice than with mercy."
        }
    ]
};
var $e284769d226e732e$export$6538991d1d16d3d2 = {
    domain: 'C',
    title: 'Conscientiousness',
    shortDescription: 'Conscientiousness concerns the way in which we control, regulate, and direct our impulses.',
    description: "Impulses are not inherently bad;\noccasionally time constraints require a snap decision, and acting on\nour first impulse can be an effective response. Also, in times of\nplay rather than work, acting spontaneously and impulsively can be\nfun. Impulsive individuals can be seen by others as colorful,\nfun-to-be-with, and zany.\n<br /><br />\nNonetheless, acting on impulse can lead to trouble in a number of\nways. Some impulses are antisocial. Uncontrolled antisocial acts\nnot only harm other members of society, but also can result in\nretribution toward the perpetrator of such impulsive acts. Another\nproblem with impulsive acts is that they often produce immediate\nrewards but undesirable, long-term consequences. Examples include\nexcessive socializing that leads to being fired from one's job,\nhurling an insult that causes the breakup of an important\nrelationship, or using pleasure-inducing drugs that eventually\ndestroy one's health.\n<br /><br />\nImpulsive behavior, even when not seriously destructive, diminishes\na person's effectiveness in significant ways. Acting impulsively\ndisallows contemplating alternative courses of action, some of which\nwould have been wiser than the impulsive choice. Impulsivity also\nsidetracks people during projects that require organized sequences\nof steps or stages. Accomplishments of an impulsive person are\ntherefore small, scattered, and inconsistent.\n<br /><br />\nA hallmark of intelligence, what potentially separates human beings\nfrom earlier life forms, is the ability to think about future\nconsequences before acting on an impulse. Intelligent activity\ninvolves contemplation of long-range goals, organizing and planning\nroutes to these goals, and persisting toward one's goals in the face\nof short-lived impulses to the contrary. The idea that intelligence\ninvolves impulse control is nicely captured by the term prudence, an\nalternative label for the Conscientiousness domain. Prudent means\nboth wise and cautious.\n<br /><br/>\nPersons who score high on the\nConscientiousness scale are, in fact, perceived by others as intelligent.\nThe benefits of high conscientiousness are obvious. Conscientious\nindividuals avoid trouble and achieve high levels of success through\npurposeful planning and persistence. They are also positively\nregarded by others as intelligent and reliable. On the negative\nside, they can be compulsive perfectionists and workaholics.\nFurthermore, extremely conscientious individuals might be regarded\nas stuffy and boring.\n<br /><br />\nUnconscientious people may be criticized for\ntheir unreliability, lack of ambition, and failure to stay within\nthe lines, but they will experience many short-lived pleasures and\nthey will never be called stuffy.",
    results: [
        {
            score: 'low',
            text: "Your score on Conscientiousness is low, indicating you like to live\nfor the moment and do what feels good now. Your work tends to be\ncareless and disorganized."
        },
        {
            score: 'neutral',
            text: "Your score on Conscientiousness is average. This means you are\nreasonably reliable, organized, and self-controlled."
        },
        {
            score: 'high',
            text: "Your score on Conscientiousness is high. This means you set clear\ngoals and pursue them with determination. People regard you as\nreliable and hard-working."
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Self-Efficacy',
            text: "Self-Efficacy describes confidence in one's ability\nto accomplish things. High scorers believe they have the intelligence\n(common sense), drive, and self-control necessary for achieving success.\nLow scorers do not feel effective, and may have a sense that they are not\nin control of their lives."
        },
        {
            facet: 2,
            title: 'Orderliness',
            text: "Persons with high scores on orderliness are\nwell-organized. They like to live according to routines and schedules. They\nkeep lists and make plans. Low scorers tend to be disorganized and\nscattered."
        },
        {
            facet: 3,
            title: 'Dutifulness',
            text: "This scale reflects the strength of a person's sense\n of duty and obligation. Those who score high on this scale have a strong\n sense of moral obligation. Low scorers find contracts, rules, and\n regulations overly confining. They are likely to be seen as unreliable or\n even irresponsible."
        },
        {
            facet: 4,
            title: 'Achievement-Striving',
            text: "Individuals who score high on this\nscale strive hard to achieve excellence. Their drive to be recognized as\nsuccessful keeps them on track toward their lofty goals. They often have\na strong sense of direction in life, but extremely high scores may\nbe too single-minded and obsessed with their work. Low scorers are content\nto get by with a minimal amount of work, and might be seen by others\nas lazy."
        },
        {
            facet: 5,
            title: 'Self-Discipline',
            text: "Self-discipline-what many people call\nwill-power-refers to the ability to persist at difficult or unpleasant\ntasks until they are completed. People who possess high self-discipline\nare able to overcome reluctance to begin tasks and stay on track despite\ndistractions. Those with low self-discipline procrastinate and show poor\nfollow-through, often failing to complete tasks-even tasks they want very\nmuch to complete."
        },
        {
            facet: 6,
            title: 'Cautiousness',
            text: "Cautiousness describes the disposition to\nthink through possibilities before acting. High scorers on the Cautiousness\nscale take their time when making decisions. Low scorers often say or do\nfirst thing that comes to mind without deliberating alternatives and the\nprobable consequences of those alternatives."
        }
    ]
};
var $e284769d226e732e$export$a7aa291e20ce9ebf = {
    domain: 'E',
    title: 'Extraversion',
    shortDescription: 'Extraversion is marked by pronounced engagement with the external world.',
    description: 'Extraverts enjoy being with people, are full of energy, and\noften experience positive emotions. They tend to be enthusiastic,\naction-oriented, individuals who are likely to say "Yes!" or "Let\'s\ngo!" to opportunities for excitement. In groups they like to talk,\nassert themselves, and draw attention to themselves.\n<br /><br />\nIntroverts lack the exuberance, energy, and activity levels of\nextraverts. They tend to be quiet, low-key, deliberate, and\ndisengaged from the social world. Their lack of social involvement\nshould not be interpreted as shyness or depression; the\nintrovert simply needs less stimulation than an extravert and prefers\nto be alone. <br /><br />The independence and reserve of the introvert is\nsometimes mistaken as unfriendliness or arrogance. In reality, an\nintrovert who scores high on the agreeableness dimension will not\nseek others out but will be quite pleasant when approached.',
    results: [
        {
            score: 'low',
            text: "Your score on Extraversion is low, indicating you are\nintroverted, reserved, and quiet. You enjoy solitude and solitary\nactivities. Your socialization tends to be restricted to a few close friends."
        },
        {
            score: 'neutral',
            text: "Your score on Extraversion is average, indicating you are\nneither a subdued loner nor a jovial chatterbox. You enjoy time with\nothers but also time alone."
        },
        {
            score: 'high',
            text: "Your score on Extraversion is high, indicating you are\nsociable, outgoing, energetic, and lively. You prefer to be around\npeople much of the time."
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Friendliness',
            text: "Friendly people genuinely like other people\nand openly demonstrate positive feelings toward others. They make\nfriends quickly and it is easy for them to form close, intimate\nrelationships. Low scorers on Friendliness are not necessarily cold\nand hostile, but they do not reach out to others and are perceived\nas distant and reserved."
        },
        {
            facet: 2,
            title: 'Gregariousness',
            text: "Gregarious people find the company of\nothers pleasantly stimulating and rewarding. They enjoy the\nexcitement of crowds. Low scorers tend to feel overwhelmed by, and\ntherefore actively avoid, large crowds. They do not necessarily\ndislike being with people sometimes, but their need for privacy and\ntime to themselves is much greater than for individuals who score\nhigh on this scale."
        },
        {
            facet: 3,
            title: 'Assertiveness',
            text: "High scorers Assertiveness like to speak\n out, take charge, and direct the activities of others. They tend to\n be leaders in groups. Low scorers tend not to talk much and let\n others control the activities of groups."
        },
        {
            facet: 4,
            title: 'Activity Level',
            text: "Active individuals lead fast-paced, busy\n lives. They move about quickly, energetically, and vigorously, and\n they are involved in many activities. People who score low on this\n scale follow a slower and more leisurely, relaxed pace."
        },
        {
            facet: 5,
            title: 'Excitement-Seeking',
            text: "High scorers on this scale are easily\nbored without high levels of stimulation. They love bright lights\nand hustle and bustle. They are likely to take risks and seek\nthrills. Low scorers are overwhelmed by noise and commotion and are\nadverse to thrill-seeking."
        },
        {
            facet: 6,
            title: 'Cheerfulness',
            text: "This scale measures positive mood and\nfeelings, not negative emotions (which are a part of the\nNeuroticism domain). Persons who score high on this scale typically\nexperience a range of positive feelings, including happiness,\nenthusiasm, optimism, and joy. Low scorers are not as prone to such\nenergetic, high spirits."
        }
    ]
};
var $e284769d226e732e$export$f37a73316abb9b49 = {
    domain: 'N',
    title: 'Neuroticism',
    shortDescription: 'Neuroticism refers to the tendency to experience negative feelings.',
    description: "Freud originally used the term neurosis to describe a\ncondition marked by mental distress, emotional suffering, and an\ninability to cope effectively with the normal demands of life. He\nsuggested that everyone shows some signs of neurosis, but that we\ndiffer in our degree of suffering and our specific symptoms of\ndistress. Today neuroticism refers to the tendency to experience\nnegative feelings. <br /><br />Those who score high on Neuroticism may\nexperience primarily one specific negative feeling such as anxiety,\nanger, or depression, but are likely to experience several of these\nemotions. <br /><br />People high in neuroticism are emotionally reactive. They\nrespond emotionally to events that would not affect most people, and\ntheir reactions tend to be more intense than normal. They are more\nlikely to interpret ordinary situations as threatening, and minor\nfrustrations as hopelessly difficult. <br /><br />Their negative emotional\nreactions tend to persist for unusually long periods of time, which\nmeans they are often in a bad mood. These problems in emotional\nregulation can diminish a neurotic's ability to think clearly, make\ndecisions, and cope effectively with stress.",
    results: [
        {
            score: 'low',
            text: "Your score on Neuroticism is low, indicating that you are\nexceptionally calm, composed and unflappable. You do not react with\nintense emotions, even to situations that most people would describe\nas stressful."
        },
        {
            score: 'neutral',
            text: "Your score on Neuroticism is average, indicating that your level of\nemotional reactivity is typical of the general population.\nStressful and frustrating situations are somewhat upsetting to you,\nbut you are generally able to get over these feelings and cope with\nthese situations."
        },
        {
            score: 'high',
            text: "Your score on Neuroticism is high, indicating that you are easily\nupset, even by what most people consider the normal demands of\nliving. People consider you to be sensitive and emotional."
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Anxiety',
            text: 'The "fight-or-flight" system of the brain of anxious\nindividuals is too easily and too often engaged. Therefore, people who\nare high in anxiety often feel like something dangerous is about to happen.\nThey may be afraid of specific situations or be just generally fearful.\nThey feel tense, jittery, and nervous. Persons low in Anxiety are generally\ncalm and fearless.'
        },
        {
            facet: 2,
            title: 'Anger',
            text: "Persons who score high in Anger feel enraged when\nthings do not go their way. They are sensitive about being treated fairly\nand feel resentful and bitter when they feel they are being cheated.\nThis scale measures the tendency to feel angry; whether or not the\nperson expresses annoyance and hostility depends on the individual's\nlevel on Agreeableness. Low scorers do not get angry often or easily."
        },
        {
            facet: 3,
            title: 'Depression',
            text: "This scale measures the tendency to feel sad, dejected,\nand discouraged. High scorers lack energy and have difficulty initiating\nactivities. Low scorers tend to be free from these depressive feelings."
        },
        {
            facet: 4,
            title: 'Self-Consciousness',
            text: "Self-conscious individuals are sensitive\nabout what others think of them. Their concern about rejection and\nridicule cause them to feel shy and uncomfortable around others. They\nare easily embarrassed and often feel ashamed. Their fears that others\nwill criticize or make fun of them are exaggerated and unrealistic, but\ntheir awkwardness and discomfort may make these fears a self-fulfilling\nprophecy. Low scorers, in contrast, do not suffer from the mistaken\nimpression that everyone is watching and judging them. They do not feel\nnervous in social situations."
        },
        {
            facet: 5,
            title: 'Immoderation',
            text: "Immoderate individuals feel strong cravings and\nurges that they have have difficulty resisting. They tend to be\noriented toward short-term pleasures and rewards rather than long-\nterm consequences. Low scorers do not experience strong, irresistible\ncravings and consequently do not find themselves tempted to overindulge."
        },
        {
            facet: 6,
            title: 'Vulnerability',
            text: "High scorers on Vulnerability experience\npanic, confusion, and helplessness when under pressure or stress.\nLow scorers feel more poised, confident, and clear-thinking when\nstressed."
        }
    ]
};
var $e284769d226e732e$export$299b9efb99b00f09 = {
    domain: 'O',
    title: 'Openness To Experience',
    shortDescription: 'Openness to Experience describes a dimension of cognitive style that distinguishes imaginative, creative people from down-to-earth, conventional people.',
    description: "Open people are intellectually curious,\nappreciative of art, and sensitive to beauty. They tend to be,\ncompared to closed people, more aware of their feelings. They tend to\nthink and act in individualistic and nonconforming\nways. Intellectuals typically score high on Openness to Experience;\nconsequently, this factor has also been called Culture or\nIntellect. <br /><br />Nonetheless, Intellect is probably best regarded as one aspect of openness\nto experience. Scores on Openness to Experience are only modestly\nrelated to years of education and scores on standard intelligent tests.\n<br /><br />\nAnother characteristic of the open cognitive style is a facility for thinking\nin symbols and abstractions far removed from concrete experience. Depending on\nthe individual's specific intellectual abilities, this symbolic cognition may\ntake the form of mathematical, logical, or geometric thinking, artistic and\nmetaphorical use of language, music composition or performance, or one of the\nmany visual or performing arts.\n<br /><br />\nPeople with low scores on openness to experience tend to have narrow, common\ninterests. They prefer the plain, straightforward, and obvious over the\ncomplex, ambiguous, and subtle. They may regard the arts and sciences with\nsuspicion, regarding these endeavors as abstruse or of no practical use.\nClosed people prefer familiarity over novelty; they are conservative and\nresistant to change.\n<br /><br />\nOpenness is often presented as healthier or more mature by psychologists, who\nare often themselves open to experience. However, open and closed styles of\nthinking are useful in different environments. The intellectual style of the\nopen person may serve a professor well, but research has shown that closed\nthinking is related to superior job performance in police work, sales, and\na number of service occupations.",
    results: [
        {
            score: 'low',
            text: "Your score on Openness to Experience is low, indicating you like to think in\nplain and simple terms. Others describe you as down-to-earth, practical,\nand conservative."
        },
        {
            score: 'neutral',
            text: "Your score on Openness to Experience is average, indicating you enjoy\ntradition but are willing to try new things. Your thinking is neither\nsimple nor complex. To others you appear to be a well-educated person\nbut not an intellectual."
        },
        {
            score: 'high',
            text: "Your score on Openness to Experience is high, indicating you enjoy novelty,\nvariety, and change. You are curious, imaginative, and creative."
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Imagination',
            text: "To imaginative individuals, the real world is\noften too plain and ordinary. High scorers on this scale use fantasy as a\nway of creating a richer, more interesting world. Low scorers are on this\nscale are more oriented to facts than fantasy."
        },
        {
            facet: 2,
            title: 'Artistic Interests',
            text: "High scorers on this scale love beauty, both in\nart and in nature. They become easily involved and absorbed in artistic\nand natural events. They are not necessarily artistically trained nor\ntalented, although many will be. The defining features of this scale are\ninterest in, and appreciation of natural and\nartificial beauty. Low scorers lack aesthetic sensitivity and interest in\nthe arts."
        },
        {
            facet: 3,
            title: 'Emotionality',
            text: "Persons high on Emotionality have good access\nto and awareness of their own feelings. Low scorers are less aware of\ntheir feelings and tend not to express their emotions openly."
        },
        {
            facet: 4,
            title: 'Adventurousness',
            text: "High scorers on adventurousness are eager to\ntry new activities, travel to foreign lands, and experience different\nthings. They find familiarity and routine boring, and will take a new\nroute home just because it is different. Low scorers tend to feel\nuncomfortable with change and prefer familiar routines."
        },
        {
            facet: 5,
            title: 'Intellect',
            text: "Intellect and artistic interests are the two most\nimportant, central aspects of openness to experience. High scorers on\nIntellect love to play with ideas. They are open-minded to new and unusual\nideas, and like to debate intellectual issues. They enjoy riddles, puzzles,\nand brain teasers. Low scorers on Intellect prefer dealing with either\npeople or things rather than ideas. They regard intellectual exercises as a\nwaste of time. Intellect should not be equated with intelligence.\nIntellect is an intellectual style, not an intellectual ability, although\nhigh scorers on Intellect score slightly higher than low-Intellect\nindividuals on standardized intelligence tests."
        },
        {
            facet: 6,
            title: 'Liberalism',
            text: "Psychological liberalism refers to a readiness to\nchallenge authority, convention, and traditional values. In its most\nextreme form, psychological liberalism can even represent outright\nhostility toward rules, sympathy for law-breakers, and love of ambiguity,\nchaos, and disorder. Psychological conservatives prefer the security and\nstability brought by conformity to tradition. Psychological liberalism\nand conservatism are not identical to political affiliation, but certainly\nincline individuals toward certain political parties."
        }
    ]
};
var $e284769d226e732e$export$637f4a0d40b608e9 = {
    domain: 'A',
    title: "Medg\xf6rlighet",
    shortDescription: "Medg\xf6rlighet beskriver individuella skillnader i omtanke, samarbetsvilja och social harmoni. Personer med h\xf6g medg\xf6rlighet v\xe4rdes\xe4tter att komma \xf6verens med andra.",
    description: "Personer med h\xf6g medg\xf6rlighet \xe4r d\xe4rf\xf6r omt\xe4nksamma, v\xe4nliga,\ngener\xf6sa, hj\xe4lpsamma och villiga att kompromissa med sina egna\nintressen f\xf6r andras skull. De har ocks\xe5 en optimistisk syn p\xe5\nm\xe4nniskans natur. De tror att m\xe4nniskor i grunden \xe4r \xe4rliga, anst\xe4ndiga\noch p\xe5litliga. <br /><br />\nPersoner med l\xe5g medg\xf6rlighet s\xe4tter sitt egenintresse f\xf6re att komma\n\xf6verens med andra. De bryr sig i allm\xe4nhet mindre om andras\nv\xe4lbefinnande och \xe4r d\xe4rf\xf6r mindre ben\xe4gna att anstr\xe4nga sig f\xf6r andra.\nIbland g\xf6r deras skepsis mot andras motiv att de kan uppfattas som\nmisst\xe4nksamma, ov\xe4nliga och osamarbetsvilliga.\n<br /><br />\nMedg\xf6rlighet \xe4r tydligt gynnsamt f\xf6r att n\xe5 och beh\xe5lla popularitet.\nMedg\xf6rliga personer \xe4r mer omtyckta \xe4n personer med l\xe5g medg\xf6rlighet.\n\xc5 andra sidan \xe4r medg\xf6rlighet inte alltid anv\xe4ndbart i situationer som\nkr\xe4ver tuffa eller helt objektiva beslut. Personer med l\xe5g\nmedg\xf6rlighet kan vara utm\xe4rkta forskare, kritiker eller soldater.",
    results: [
        {
            score: 'low',
            text: "Ditt resultat p\xe5 Medg\xf6rlighet \xe4r l\xe5gt, vilket indikerar att du bryr dig\nmindre om andras behov \xe4n om dina egna. Andra kan se dig som tuff,\nkritisk och kompromissl\xf6s."
        },
        {
            score: 'neutral',
            text: "Ditt resultat p\xe5 Medg\xf6rlighet \xe4r genomsnittligt, vilket inneb\xe4r att du\nvisar viss omtanke om andras behov men i allm\xe4nhet inte \xe4r villig att\noffra dig sj\xe4lv f\xf6r andra."
        },
        {
            score: 'high',
            text: "Ditt h\xf6ga resultat p\xe5 Medg\xf6rlighet visar p\xe5 ett starkt intresse f\xf6r\nandras behov och v\xe4lbefinnande. Du \xe4r trevlig, sympatisk och\nsamarbetsvillig."
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Tillit',
            text: "En person med h\xf6g tillit antar att de flesta m\xe4nniskor \xe4r\nr\xe4ttvisa, \xe4rliga och har goda avsikter. Personer med l\xe5g tillit ser\nandra som sj\xe4lviska, listiga och potentiellt farliga."
        },
        {
            facet: 2,
            title: 'Moral',
            text: "Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 denna skala ser inget behov av\nf\xf6rst\xe4llning eller manipulation i m\xf6tet med andra och \xe4r d\xe4rf\xf6r\n\xf6ppna, raka och uppriktiga. Personer med l\xe5ga v\xe4rden anser att en viss\nm\xe4ngd deception i sociala relationer \xe4r n\xf6dv\xe4ndig. Andra upplever att det\n\xe4r relativt l\xe4tt att relatera till personer med h\xf6ga v\xe4rden p\xe5 denna skala.\nDe har i allm\xe4nhet sv\xe5rare att relatera till personer med l\xe5ga v\xe4rden,\neftersom dessa ofta \xe4r mer \xe5terh\xe5llsamma och mindre \xf6ppna med hela\nsanningen. Det b\xf6r tydligg\xf6ras att l\xe5ga v\xe4rden inte inneb\xe4r att personen\n\xe4r principl\xf6s eller omoralisk; de \xe4r helt enkelt mer f\xf6rsiktiga och\nmindre ben\xe4gna att \xf6ppet avsl\xf6ja hela sanningen."
        },
        {
            facet: 3,
            title: 'Altruism',
            text: "Altruistiska personer upplever att det \xe4r genuint\nbel\xf6nande att hj\xe4lpa andra. De \xe4r d\xe4rf\xf6r i allm\xe4nhet villiga att hj\xe4lpa\ndem som beh\xf6ver st\xf6d. Altruistiska personer upplever att g\xf6ra saker f\xf6r\nandra som en form av sj\xe4lvf\xf6rverkligande snarare \xe4n sj\xe4lvuppoffring.\nPersoner som f\xe5r l\xe5ga v\xe4rden p\xe5 denna skala tycker inte s\xe4rskilt mycket\nom att hj\xe4lpa dem som \xe4r i behov av hj\xe4lp. F\xf6rfr\xe5gningar om hj\xe4lp k\xe4nns\nmer som en belastning \xe4n som en m\xf6jlighet till sj\xe4lvf\xf6rverkligande."
        },
        {
            facet: 4,
            title: 'Samarbetsvilja',
            text: "Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 denna skala\nogillar konfrontationer. De \xe4r fullt villiga att kompromissa eller\n\xe5terh\xe5lla sina egna behov f\xf6r att komma \xf6verens med andra. De som f\xe5r\nl\xe5ga v\xe4rden p\xe5 denna skala \xe4r mer ben\xe4gna att anv\xe4nda sig av\nskr\xe4mseltaktik f\xf6r att f\xe5 sin vilja igenom."
        },
        {
            facet: 5,
            title: "\xd6dmjukhet",
            text: "Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 denna skala tycker inte om att h\xe4vda\natt de \xe4r b\xe4ttre \xe4n andra m\xe4nniskor. I vissa fall kan denna attityd\nbottna i l\xe5g sj\xe4lvk\xe4nsla. Samtidigt upplever vissa personer med h\xf6g\nsj\xe4lvk\xe4nsla att skryt \xe4r osmakligt. De som g\xe4rna beskriver sig sj\xe4lva\nsom \xf6verl\xe4gsna tenderar att uppfattas som obehagligt arroganta av andra."
        },
        {
            facet: 6,
            title: "Medk\xe4nsla",
            text: "Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 denna skala \xe4r\nmjuka och medk\xe4nnande. De k\xe4nner andras sm\xe4rta indirekt och r\xf6rs\nl\xe4tt till medlidande. Personer med l\xe5ga v\xe4rden p\xe5verkas inte lika starkt\nav m\xe4nskligt lidande. De \xe4r stolta \xf6ver att fatta objektiva bed\xf6mningar\nbaserade p\xe5 f\xf6rnuft. De \xe4r mer upptagna av sanning och opartisk r\xe4ttvisa\n\xe4n av barmh\xe4rtighet."
        }
    ]
};
var $e284769d226e732e$export$44b1b6cff76a4176 = {
    domain: 'C',
    title: 'Samvetsgrannhet',
    shortDescription: "Samvetsgrannhet handlar om hur vi kontrollerar, reglerar och styr v\xe5ra impulser.",
    description: "Impulser \xe4r inte d\xe5liga i sig; ibland kr\xe4ver tidspress ett snabbt\nbeslut och att agera p\xe5 sin f\xf6rsta impuls kan vara ett effektivt svar.\nVid lek snarare \xe4n arbete kan spontant och impulsivt agerande dessutom\nvara roligt. Impulsiva personer kan av andra ses som f\xe4rgstarka,\nroliga att vara med och lite galna.\n<br /><br />\nSamtidigt kan impulsivt agerande leda till problem p\xe5 flera s\xe4tt. Vissa\nimpulser \xe4r antisociala. Okontrollerade antisociala handlingar skadar\ninte bara andra m\xe4nniskor, utan kan ocks\xe5 leda till negativa\nkonsekvenser f\xf6r den som agerar impulsivt. Ett annat problem med\nimpulsiva handlingar \xe4r att de ofta ger omedelbara bel\xf6ningar men\no\xf6nskade l\xe5ngsiktiga konsekvenser. Exempel \xe4r alltf\xf6r mycket\nsocialt umg\xe4nge som leder till att man blir av med jobbet, att kasta ur\nsig en f\xf6rol\xe4mpning som orsakar slutet p\xe5 en viktig relation, eller att\nanv\xe4nda njutningsframkallande droger som p\xe5 sikt f\xf6rst\xf6r h\xe4lsan.\n<br /><br />\nImpulsivt beteende, \xe4ven n\xe4r det inte \xe4r allvarligt destruktivt,\nminskar en persons effektivitet p\xe5 flera s\xe4tt. Att agera impulsivt\nhindrar reflektion kring alternativa handlingsv\xe4gar, d\xe4r vissa hade kunnat\nvara klokare \xe4n det impulsiva valet. Impulsivitet g\xf6r ocks\xe5 att personer\nl\xe4tt sp\xe5rar ur i projekt som kr\xe4ver organiserade steg eller faser.\nResultaten f\xf6r en impulsiv person blir d\xe4rf\xf6r sm\xe5, utspridda och\ninkonsekventa.\n<br /><br />\nEtt k\xe4nnetecken f\xf6r m\xe4nsklig intelligens, som skiljer m\xe4nniskor fr\xe5n\ntidigare livsformer, \xe4r f\xf6rm\xe5gan att t\xe4nka p\xe5 framtida konsekvenser\ninnan man agerar p\xe5 en impuls. Intelligent aktivitet inneb\xe4r att\nreflektera \xf6ver l\xe5ngsiktiga m\xe5l, organisera och planera v\xe4garna dit och\natt h\xe5lla fast vid m\xe5len trots kortlivade impulser i motsatt riktning.\nTanken att intelligens innefattar impulskontroll f\xe5ngas v\xe4l av ordet\nf\xf6rsiktighet, ett alternativt namn f\xf6r dom\xe4nen Samvetsgrannhet. Att vara\nf\xf6rsiktig inneb\xe4r b\xe5de att vara klok och varsam.\n<br /><br/>\nPersoner som f\xe5r h\xf6ga v\xe4rden p\xe5 Samvetsgrannhet uppfattas faktiskt av\nandra som intelligenta. F\xf6rdelarna med h\xf6g samvetsgrannhet \xe4r tydliga.\nSamvetsgranna individer undviker problem och n\xe5r h\xf6ga niv\xe5er av\nframg\xe5ng genom m\xe5linriktad planering och uth\xe5llighet. De ses ocks\xe5\npositivt av andra som kloka och p\xe5litliga. P\xe5 den negativa sidan kan de\nbli tv\xe5ngsm\xe4ssiga perfektionister och arbetsnarkomaner. Mycket h\xf6g\nsamvetsgrannhet kan g\xf6ra att man uppfattas som stel och tr\xe5kig.\n<br /><br />\nPersoner med l\xe5g samvetsgrannhet kan kritiseras f\xf6r att vara\nop\xe5litliga, sakna ambition och inte h\xe5lla sig inom ramarna, men de f\xe5r\n\xe5 andra sidan uppleva m\xe5nga kortvariga n\xf6jen och kommer aldrig att\nbeskrivas som stela.",
    results: [
        {
            score: 'low',
            text: "Ditt resultat p\xe5 Samvetsgrannhet \xe4r l\xe5gt, vilket tyder p\xe5 att du vill\nleva i nuet och g\xf6ra det som k\xe4nns bra just nu. Ditt arbete tenderar att\nbli slarvigt och oorganiserat."
        },
        {
            score: 'neutral',
            text: "Ditt resultat p\xe5 Samvetsgrannhet \xe4r genomsnittligt. Det inneb\xe4r att\ndu \xe4r rimligt p\xe5litlig, organiserad och sj\xe4lvkontrollerad."
        },
        {
            score: 'high',
            text: "Ditt resultat p\xe5 Samvetsgrannhet \xe4r h\xf6gt. Det inneb\xe4r att du s\xe4tter\ntydliga m\xe5l och arbetar m\xe5lmedvetet f\xf6r att n\xe5 dem. Andra ser dig som\np\xe5litlig och h\xe5rt arbetande."
        }
    ],
    facets: [
        {
            facet: 1,
            title: "Sj\xe4lvtillit",
            text: "Sj\xe4lvtillit beskriver tilltron till den egna f\xf6rm\xe5gan\natt \xe5stadkomma saker. Personer med h\xf6ga v\xe4rden tror att de har den\nintelligens (sunt f\xf6rnuft), drivkraft och sj\xe4lvkontroll som kr\xe4vs f\xf6r att\nlyckas. Personer med l\xe5ga v\xe4rden k\xe4nner sig inte lika effektiva och kan\nuppleva att de inte har kontroll \xf6ver sina liv."
        },
        {
            facet: 2,
            title: 'Ordning',
            text: "Personer med h\xf6ga v\xe4rden p\xe5 Ordning \xe4r v\xe4lorganiserade.\nDe tycker om att leva enligt rutiner och scheman. De g\xf6r listor och\nplaner. Personer med l\xe5ga v\xe4rden tenderar att vara oorganiserade och\nsplittrade."
        },
        {
            facet: 3,
            title: 'Plikttrogenhet',
            text: "Denna skala speglar styrkan i en persons k\xe4nsla\nav plikt och ansvar. De som f\xe5r h\xf6ga v\xe4rden har en stark k\xe4nsla av\nmoraliskt ansvar. Personer med l\xe5ga v\xe4rden upplever avtal, regler och\nf\xf6rordningar som alltf\xf6r begr\xe4nsande. De kan uppfattas som op\xe5litliga\neller till och med ansvarsl\xf6sa."
        },
        {
            facet: 4,
            title: "Prestationsstr\xe4van",
            text: "Personer med h\xf6ga v\xe4rden p\xe5 denna skala\nstr\xe4var h\xe5rt efter att uppn\xe5 excellens. Deras vilja att bli sedda som\nframg\xe5ngsrika h\xe5ller dem p\xe5 sp\xe5ret mot h\xf6ga m\xe5l. De har ofta en tydlig\nriktning i livet, men extremt h\xf6ga v\xe4rden kan inneb\xe4ra att de blir alltf\xf6r\nensidiga och fixerade vid arbete. Personer med l\xe5ga v\xe4rden \xe4r n\xf6jda med\natt klara sig med minsta m\xf6jliga anstr\xe4ngning och kan av andra ses som\nlata."
        },
        {
            facet: 5,
            title: "Sj\xe4lvdisciplin",
            text: "Sj\xe4lvdisciplin \u2013 det som m\xe5nga kallar\nviljestyrka \u2013 handlar om f\xf6rm\xe5gan att h\xe5lla ut i sv\xe5ra eller obehagliga\nuppgifter tills de \xe4r klara. Personer med h\xf6ga v\xe4rden har l\xe4ttare att\n\xf6vervinna motvilja och h\xe5ller fast trots st\xf6rningar. Personer med l\xe5ga\nv\xe4rden skjuter ofta upp saker och har sv\xe5rt att fullf\xf6lja, \xe4ven uppgifter\nde egentligen vill bli klara med."
        },
        {
            facet: 6,
            title: "F\xf6rsiktighet",
            text: "F\xf6rsiktighet beskriver ben\xe4genheten att t\xe4nka\nigenom m\xf6jligheter innan man agerar. Personer med h\xf6ga v\xe4rden tar god\ntid p\xe5 sig n\xe4r de fattar beslut. Personer med l\xe5ga v\xe4rden s\xe4ger eller\ng\xf6r ofta det f\xf6rsta som kommer i \xe5tanke utan att \xf6verv\xe4ga alternativ och\nderas troliga konsekvenser."
        }
    ]
};
var $e284769d226e732e$export$8779f5417c0e9fe9 = {
    domain: 'E',
    title: 'Extraversion',
    shortDescription: "Extraversion k\xe4nnetecknas av ett tydligt engagemang i den yttre v\xe4rlden.",
    description: "Extroverta personer tycker om att vara med andra, har mycket\nenergi och upplever ofta positiva k\xe4nslor. De tenderar att vara\nentusiastiska, handlingsinriktade individer som g\xe4rna s\xe4ger \u201DJa!\u201D eller\n\u201DNu k\xf6r vi!\u201D n\xe4r n\xe5got sp\xe4nnande dyker upp. I grupper tycker de om att\nprata, ta plats och dra uppm\xe4rksamhet till sig.\n<br /><br />\nIntroverta personer saknar den ut\xe5triktade energi- och aktivitetsniv\xe5n\nsom extroverta har. De tenderar att vara tystl\xe5tna, l\xe5gm\xe4lda,\neftert\xe4nksamma och mer fr\xe5nkopplade fr\xe5n det sociala livet. Deras\nbegr\xe4nsade sociala engagemang ska inte tolkas som blyghet eller\ndepression; introverta beh\xf6ver helt enkelt mindre stimulans \xe4n\nextroverta och f\xf6redrar ofta att vara f\xf6r sig sj\xe4lva.\n<br /><br />\nIntrovertas sj\xe4lvst\xe4ndighet och \xe5terh\xe5llsamhet misstas ibland f\xf6r\nov\xe4nlighet eller arrogans. I verkligheten kommer en introvert person\nmed h\xf6g medg\xf6rlighet inte att aktivt s\xf6ka upp andra, men kan vara mycket\ntrevlig n\xe4r n\xe5gon tar kontakt.",
    results: [
        {
            score: 'low',
            text: "Ditt resultat p\xe5 Extraversion \xe4r l\xe5gt, vilket inneb\xe4r att du \xe4r\nintrovert, reserverad och tystl\xe5ten. Du trivs i ensamhet och med\nensamma aktiviteter. N\xe4r det g\xe4ller socialt umg\xe4nge begr\xe4nsar du dig\nofta till n\xe5gra f\xe5 n\xe4ra v\xe4nner."
        },
        {
            score: 'neutral',
            text: "Ditt resultat p\xe5 Extraversion \xe4r genomsnittligt, vilket inneb\xe4r att du\nvarken \xe4r en tillbakadragen ensamvarg eller en st\xe4ndigt pratglad\n\u201Dgl\xe4djespridare\u201D. Du uppskattar b\xe5de tid med andra och tid f\xf6r dig\nsj\xe4lv."
        },
        {
            score: 'high',
            text: "Ditt resultat p\xe5 Extraversion \xe4r h\xf6gt, vilket inneb\xe4r att du \xe4r\ns\xe4llskaplig, ut\xe5triktad, energisk och livlig. Du f\xf6redrar att vara i\nn\xe4rheten av andra m\xe4nniskor st\xf6rre delen av tiden."
        }
    ],
    facets: [
        {
            facet: 1,
            title: "V\xe4nlighet",
            text: "V\xe4nliga personer tycker genuint om andra m\xe4nniskor\noch visar \xf6ppet positiva k\xe4nslor gentemot dem. De f\xe5r l\xe4tt nya v\xe4nner\noch kan snabbt skapa n\xe4ra och intima relationer. Personer med l\xe5ga v\xe4rden\n\xe4r inte n\xf6dv\xe4ndigtvis kalla eller fientliga, men de str\xe4cker sig inte ut\np\xe5 samma s\xe4tt och kan uppfattas som distanserade och reserverade."
        },
        {
            facet: 2,
            title: "S\xe4llskaplighet",
            text: "S\xe4llskapliga personer upplever andra m\xe4nniskors\ns\xe4llskap som stimulerande och bel\xf6nande. De tycker om sp\xe4nningen i\nfolksamlingar. Personer med l\xe4gre v\xe4rden tenderar att k\xe4nna sig\n\xf6verv\xe4ldigade av stora grupper och undviker dem d\xe4rf\xf6r aktivt. De ogillar\ninte n\xf6dv\xe4ndigtvis att vara med m\xe4nniskor ibland, men deras behov av\nintegritet och tid f\xf6r sig sj\xe4lva \xe4r mycket st\xf6rre \xe4n hos personer med\nh\xf6ga v\xe4rden p\xe5 denna skala."
        },
        {
            facet: 3,
            title: "Sj\xe4lvh\xe4vdelse",
            text: "Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 Sj\xe4lvh\xe4vdelse\ntycker om att ta ordet, ta kommandot och styra andras aktiviteter. De\ntenderar att vara ledare i grupper. Personer med l\xe4gre v\xe4rden pratar inte\nlika mycket och l\xe5ter i h\xf6gre utstr\xe4ckning andra styra vad gruppen g\xf6r."
        },
        {
            facet: 4,
            title: "Aktivitetsniv\xe5",
            text: "Personer med h\xf6g aktivitetsniv\xe5 lever ett\nsnabbt och upptaget liv. De r\xf6r sig snabbt, energiskt och kraftfullt, och\n\xe4r engagerade i m\xe5nga aktiviteter. Personer med l\xe4gre v\xe4rden p\xe5 denna\nskala har ett l\xe5ngsammare, mer stillsamt och avslappnat tempo."
        },
        {
            facet: 5,
            title: "Sp\xe4nningss\xf6kande",
            text: "Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 denna skala\nblir l\xe4tt uttr\xe5kade utan h\xf6ga niv\xe5er av stimulans. De \xe4lskar starka\nintryck och mycket liv och r\xf6relse. De \xe4r ben\xe4gna att ta risker och\ns\xf6ka kickar. Personer med l\xe4gre v\xe4rden blir l\xe4tt \xf6verv\xe4ldigade av buller\noch r\xf6ra och undviker aktivt riskfyllda, \u201Dkick-s\xf6kande\u201D situationer."
        },
        {
            facet: 6,
            title: "Gl\xe4dje",
            text: "Denna skala m\xe4ter positiva k\xe4nslor och st\xe4mningsl\xe4ge,\ninte negativa k\xe4nslor (som h\xf6r till dom\xe4nen Neuroticism). Personer med\nh\xf6ga v\xe4rden upplever ofta en rad positiva k\xe4nslor, s\xe5som lycka,\nentusiasm, optimism och gl\xe4dje. Personer med l\xe4gre v\xe4rden \xe4r inte lika\nben\xe4gna att uppleva denna typ av energisk, positiv sinnesst\xe4mning."
        }
    ]
};
var $e284769d226e732e$export$ffae95c6e0fa24ec = {
    domain: 'N',
    title: 'Neuroticism',
    shortDescription: "Neuroticism avser ben\xe4genheten att uppleva negativa k\xe4nslor.",
    description: "Freud anv\xe4nde ursprungligen termen neuros f\xf6r att beskriva ett\ntillst\xe5nd pr\xe4glat av psykiskt obehag, k\xe4nslom\xe4ssigt lidande och of\xf6rm\xe5ga\natt hantera vardagens normala krav. Han menade att alla uppvisar vissa\ntecken p\xe5 neuros, men att vi skiljer oss \xe5t i hur mycket vi lider och\nvilka symtom vi har. Idag syftar Neuroticism p\xe5 ben\xe4genheten att uppleva\nnegativa k\xe4nslor. <br /><br />\nPersoner som f\xe5r h\xf6ga v\xe4rden p\xe5 Neuroticism kan fr\xe4mst uppleva en viss\ntyp av negativa k\xe4nslor, s\xe5som \xe5ngest, ilska eller nedst\xe4mdhet, men \xe4r\nofta ben\xe4gna att uppleva flera av dessa k\xe4nslotillst\xe5nd.\n<br /><br />\nPersoner med h\xf6ga v\xe4rden p\xe5 Neuroticism \xe4r k\xe4nslom\xe4ssigt reaktiva. De\nreagerar starkt p\xe5 h\xe4ndelser som inte skulle p\xe5verka de flesta m\xe4nniskor\ns\xe4rskilt mycket, och deras reaktioner tenderar att bli mer intensiva \xe4n\nnormalt. De \xe4r mer ben\xe4gna att tolka vardagliga situationer som hotfulla\noch mindre frustrationer som hoppl\xf6st sv\xe5ra.\n<br /><br />\nDeras negativa k\xe4nslom\xe4ssiga reaktioner tenderar att dr\xf6ja sig kvar\novanligt l\xe4nge, vilket g\xf6r att de ofta \xe4r p\xe5 d\xe5ligt hum\xf6r. Dessa\nsv\xe5righeter med k\xe4nsloreglering kan f\xf6rs\xe4mra en neurotisk persons\nf\xf6rm\xe5ga att t\xe4nka klart, fatta beslut och hantera stress p\xe5 ett effektivt\ns\xe4tt.",
    results: [
        {
            score: 'low',
            text: "Ditt resultat p\xe5 Neuroticism \xe4r l\xe5gt, vilket inneb\xe4r att du \xe4r\novanligt lugn, samlad och sv\xe5r att rubba. Du reagerar inte med starka\nk\xe4nslor ens i situationer som de flesta skulle beskriva som stressande."
        },
        {
            score: 'neutral',
            text: "Ditt resultat p\xe5 Neuroticism \xe4r genomsnittligt, vilket inneb\xe4r att din\nk\xe4nslom\xe4ssiga reaktivitet ligger n\xe4ra befolkningens genomsnitt.\nStressande och frustrerande situationer \xe4r delvis p\xe5frestande f\xf6r dig,\nmen du har i allm\xe4nhet f\xf6rm\xe5ga att komma \xf6ver dessa k\xe4nslor och hantera\nsituationerna."
        },
        {
            score: 'high',
            text: "Ditt resultat p\xe5 Neuroticism \xe4r h\xf6gt, vilket inneb\xe4r att du l\xe4tt blir\nuppr\xf6rd, \xe4ven av s\xe5dant som de flesta skulle betrakta som vardagliga\nkrav. Andra ser dig ofta som k\xe4nslig och emotionell."
        }
    ],
    facets: [
        {
            facet: 1,
            title: "\xc5ngest",
            text: "\u201DKamp- eller flykt\u201D-systemet i hj\xe4rnan aktiveras\nalltf\xf6r l\xe4tt och ofta hos \xe5ngestben\xe4gna individer. D\xe4rf\xf6r k\xe4nner personer\nmed h\xf6ga v\xe4rden p\xe5 \xc5ngest ofta att n\xe5got farligt \xe4r p\xe5 v\xe4g att h\xe4nda.\nDe kan vara r\xe4dda f\xf6r specifika situationer eller mer allm\xe4nt oroliga.\nDe k\xe4nner sig sp\xe4nda, nerv\xf6sa och uppskruvade. Personer med l\xe5ga v\xe4rden\n\xe4r i allm\xe4nhet lugna och or\xe4dda."
        },
        {
            facet: 2,
            title: 'Ilska',
            text: "Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 Ilska k\xe4nner stark irritation\noch vrede n\xe4r saker inte g\xe5r deras v\xe4g. De \xe4r k\xe4nsliga f\xf6r or\xe4ttvisor\noch kan k\xe4nna sig f\xf6rbittrade och kr\xe4nkta n\xe4r de upplever att de blir\nor\xe4ttvist behandlade. Denna skala m\xe4ter ben\xe4genheten att k\xe4nna ilska; om\npersonen faktiskt uttrycker irritation och fientlighet beror p\xe5 niv\xe5n av\nMedg\xf6rlighet. Personer med l\xe5ga v\xe4rden blir inte arga s\xe4rskilt ofta eller\nl\xe4tt."
        },
        {
            facet: 3,
            title: 'Depressivitet',
            text: "Denna skala m\xe4ter ben\xe4genheten att k\xe4nna sig ledsen,\nnedst\xe4md och uppgiven. Personer med h\xf6ga v\xe4rden saknar ofta energi och har\nsv\xe5rt att komma ig\xe5ng med aktiviteter. Personer med l\xe5ga v\xe4rden \xe4r i\nmindre utstr\xe4ckning drabbade av s\xe5dana depressiva k\xe4nslor."
        },
        {
            facet: 4,
            title: "Sj\xe4lvmedvetenhet",
            text: "Sj\xe4lvmedvetna individer \xe4r k\xe4nsliga f\xf6r vad\nandra tycker om dem. Deras oro f\xf6r avvisande och f\xf6rl\xf6jligande g\xf6r att de\nk\xe4nner sig blyga och obekv\xe4ma tillsammans med andra. De sk\xe4ms l\xe4tt och\nk\xe4nner sig ofta skamsna. Deras r\xe4dsla f\xf6r att bli kritiserade eller\nutsatta f\xf6r andras negativa omd\xf6men \xe4r \xf6verdriven och orealistisk, men\nderas stelhet och obehag kan g\xf6ra att denna r\xe4dsla blir en\nsj\xe4lvuppfyllande profetia. Personer med l\xe5ga v\xe4rden lider inte av den\nfelaktiga f\xf6rest\xe4llningen att alla tittar p\xe5 och bed\xf6mer dem. De k\xe4nner\nsig inte nerv\xf6sa i sociala situationer."
        },
        {
            facet: 5,
            title: "Om\xe5ttlighet",
            text: "Om\xe5ttliga individer upplever starka beg\xe4r och\ndrifter som de har sv\xe5rt att st\xe5 emot. De \xe4r mer inriktade p\xe5\nkortsiktiga njutningar och bel\xf6ningar \xe4n p\xe5 l\xe5ngsiktiga konsekvenser.\nPersoner med l\xe5ga v\xe4rden upplever inte lika starka, oemotst\xe5ndliga beg\xe4r\noch hamnar d\xe4rf\xf6r mer s\xe4llan i situationer d\xe4r de tappar kontrollen eller \xf6verdriver."
        },
        {
            facet: 6,
            title: "S\xe5rbarhet",
            text: "Personer med h\xf6ga v\xe4rden p\xe5 S\xe5rbarhet upplever\npanik, f\xf6rvirring och hj\xe4lpl\xf6shet n\xe4r de uts\xe4tts f\xf6r press eller stress.\nPersoner med l\xe5ga v\xe4rden k\xe4nner sig mer samlade, trygga och klarsynta\nunder stress."
        }
    ]
};
var $e284769d226e732e$export$39fc19cf401ebde3 = {
    domain: 'O',
    title: "\xd6ppenhet f\xf6r erfarenhet",
    shortDescription: "\xd6ppenhet f\xf6r erfarenhet beskriver en kognitiv stil som skiljer fantasifulla, kreativa personer fr\xe5n mer jordn\xe4ra och konventionella personer.",
    description: "\xd6ppna personer \xe4r intellektuellt nyfikna, uppskattar konst och \xe4r\nk\xe4nsliga f\xf6r sk\xf6nhet. J\xe4mf\xf6rt med mer slutna personer \xe4r de ofta mer\nmedvetna om sina k\xe4nslor. De tenderar att t\xe4nka och agera p\xe5 mer\nindividualistiska och okonventionella s\xe4tt. Intellektuella personer f\xe5r\nofta h\xf6ga v\xe4rden p\xe5 \xd6ppenhet f\xf6r erfarenhet; d\xe4rf\xf6r har denna faktor\nibland kallats Kultur eller Intellekt. <br /><br />\nIntellektet \xe4r dock troligen b\xe4st att se som en aspekt av \xd6ppenhet f\xf6r\nerfarenhet. Resultat p\xe5 \xd6ppenhet h\xe4nger bara m\xe5ttligt samman med antal\nutbildnings\xe5r och resultat p\xe5 traditionella intelligenstest.\n<br /><br />\nEtt annat k\xe4nnetecken f\xf6r en \xf6ppen kognitiv stil \xe4r f\xf6rm\xe5gan att t\xe4nka\ni symboler och abstraktioner l\xe5ngt bortom konkreta erfarenheter.\nBeroende p\xe5 individens specifika intellektuella f\xf6rm\xe5gor kan denna\nsymboliska kognition ta formen av matematisk, logisk eller geometrisk\ntanke, konstn\xe4rlig och metaforisk spr\xe5kf\xf6rm\xe5ga, musikskapande eller\nmusikframf\xf6rande, eller n\xe5gon av m\xe5nga visuella eller sceniska konstarter.\n<br /><br />\nPersoner med l\xe5ga v\xe4rden p\xe5 \xd6ppenhet f\xf6r erfarenhet tenderar att ha\nsn\xe4vare och mer allm\xe4nna intressen. De f\xf6redrar det enkla, raka och\ntydliga framf\xf6r det komplexa, tvetydiga och subtila. De kan se p\xe5\nkonst och vetenskap med skepsis och betrakta s\xe5dant som kr\xe5ngligt eller\nopraktiskt. Slutna personer f\xf6redrar det v\xe4lbekanta framf\xf6r det nya; de\n\xe4r mer konservativa och motst\xe5ndskraftiga mot f\xf6r\xe4ndring.\n<br /><br />\n\xd6ppenhet framst\xe4lls ofta som mer h\xe4lsosamt eller moget av psykologer,\nsom sj\xe4lva ofta har h\xf6g \xd6ppenhet f\xf6r erfarenhet. Men b\xe5de \xf6ppna och\nslutna s\xe4tt att t\xe4nka kan vara funktionella i olika milj\xf6er. Den\nintellektuella stil som pr\xe4glar \xf6ppna personer kan passa en professor\nv\xe4l, men forskning har visat att en mer sluten stil h\xe4nger samman med\nb\xe4ttre arbetsprestation inom till exempel polisyrket, f\xf6rs\xe4ljning och\nvissa serviceyrken.",
    results: [
        {
            score: 'low',
            text: "Ditt resultat p\xe5 \xd6ppenhet f\xf6r erfarenhet \xe4r l\xe5gt, vilket inneb\xe4r att du\ntycker om att t\xe4nka i enkla och raka termer. Andra beskriver dig som\njordn\xe4ra, praktisk och konservativ."
        },
        {
            score: 'neutral',
            text: "Ditt resultat p\xe5 \xd6ppenhet f\xf6r erfarenhet \xe4r genomsnittligt, vilket\ninneb\xe4r att du uppskattar tradition men \xe4r villig att prova nya saker.\nDitt s\xe4tt att t\xe4nka \xe4r varken s\xe4rskilt enkelt eller s\xe4rskilt komplext.\nF\xf6r andra framst\xe5r du som en v\xe4lutbildad person men inte n\xf6dv\xe4ndigtvis\nsom intellektuell."
        },
        {
            score: 'high',
            text: "Ditt resultat p\xe5 \xd6ppenhet f\xf6r erfarenhet \xe4r h\xf6gt, vilket inneb\xe4r att du\ntycker om nyheter, variation och f\xf6r\xe4ndring. Du \xe4r nyfiken, fantasifull\noch kreativ."
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Fantasi',
            text: "F\xf6r fantasirika individer \xe4r verkligheten ofta f\xf6r\nenkel och vardaglig. Personer med h\xf6ga v\xe4rden p\xe5 denna skala anv\xe4nder\nfantasin f\xf6r att skapa en rikare och mer intressant v\xe4rld. Personer med\nl\xe4gre v\xe4rden p\xe5 denna skala \xe4r mer inriktade p\xe5 fakta \xe4n p\xe5 fantasi."
        },
        {
            facet: 2,
            title: 'Estetiska intressen',
            text: "Personer med h\xf6ga v\xe4rden p\xe5 denna skala \xe4lskar\nsk\xf6nhet, b\xe5de i konst och i natur. De blir l\xe4tt engagerade och uppslukade\nav estetiska och naturupplevelser. De \xe4r inte n\xf6dv\xe4ndigtvis konstn\xe4rligt\nutbildade eller talangfulla, \xe4ven om m\xe5nga \xe4r det. Det som definierar\ndenna skala \xe4r intresset f\xf6r och uppskattningen av naturlig och\nskapad sk\xf6nhet. Personer med l\xe4gre v\xe4rden saknar i h\xf6gre grad estetisk\nk\xe4nslighet och intresse f\xf6r konst."
        },
        {
            facet: 3,
            title: "K\xe4nslom\xe4ssighet",
            text: "Personer med h\xf6ga v\xe4rden p\xe5 K\xe4nslom\xe4ssighet har\ngod tillg\xe5ng till och medvetenhet om sina egna k\xe4nslor. Personer med\nl\xe4gre v\xe4rden \xe4r mindre medvetna om sina k\xe4nslor och tenderar att inte\nuttrycka dem \xf6ppet."
        },
        {
            facet: 4,
            title: "\xc4ventyrslystnad",
            text: "Personer med h\xf6ga v\xe4rden p\xe5 \xc4ventyrslystnad \xe4r\nivria att prova nya aktiviteter, resa till nya platser och uppleva olika\nsaker. De tycker att det v\xe4lbekanta och rutinm\xe4ssiga \xe4r tr\xe5kigt och kan\ntill och med v\xe4lja en annan v\xe4g hem bara f\xf6r att den \xe4r annorlunda.\nPersoner med l\xe4gre v\xe4rden k\xe4nner sig ofta obekv\xe4ma med f\xf6r\xe4ndring och\nf\xf6redrar v\xe4lbekanta rutiner."
        },
        {
            facet: 5,
            title: 'Intellekt',
            text: "Intellekt och estetiska intressen \xe4r de tv\xe5 mest\ncentrala aspekterna av \xd6ppenhet f\xf6r erfarenhet. Personer med h\xf6ga v\xe4rden\np\xe5 Intellekt tycker om att leka med id\xe9er. De \xe4r \xf6ppna f\xf6r nya och\novanliga tankar och gillar att diskutera intellektuella fr\xe5gor. De\nuppskattar g\xe5tor, pussel och hj\xe4rngympa. Personer med l\xe4gre v\xe4rden\narbetar hellre med m\xe4nniskor eller konkreta saker \xe4n med abstrakta id\xe9er.\nDe betraktar intellektuella \xf6vningar som sl\xf6seri med tid. Intellekt ska\ninte f\xf6rv\xe4xlas med intelligens. Intellekt beskriver en intellektuell stil,\ninte en intellektuell f\xf6rm\xe5ga, \xe4ven om personer med h\xf6ga v\xe4rden i\ngenomsnitt f\xe5r n\xe5got h\xf6gre resultat p\xe5 traditionella intelligenstest \xe4n\npersoner med l\xe5ga v\xe4rden."
        },
        {
            facet: 6,
            title: 'Liberalism',
            text: "Psykologisk liberalism syftar p\xe5 en beredskap att\nutmana auktoriteter, konventioner och traditionella v\xe4rderingar. I sin\nmest extrema form kan psykologisk liberalism yttra sig som direkt\nfientlighet mot regler, sympati f\xf6r normbrytare och en dragning till\ntvetydighet, kaos och oordning. Psykologiska konservativa f\xf6redrar den\ntrygghet och stabilitet som f\xf6ljer av att h\xe5lla sig till traditioner.\nPsykologisk liberalism och konservatism \xe4r inte identiska med\npartipolitiska \xe5sikter, men de kan p\xe5verka vilka politiska partier en\nperson dras till."
        }
    ]
};






function $d9c7b7b550e0dc60$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), answers = _useState[0], setAnswers = _useState[1];
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var questions = lang === 'sv' ? (0, $e284769d226e732e$export$73b7d90b65b3ca0d) : (0, $e284769d226e732e$export$ae5bda7d15242bd6);
    var choices = lang === 'sv' ? (0, $e284769d226e732e$export$5834f94f113a6029) : (0, $e284769d226e732e$export$85fe4fda51f318c1);
    var agreeableness = lang === 'sv' ? (0, $e284769d226e732e$export$637f4a0d40b608e9) : (0, $e284769d226e732e$export$a4b2f0479fb48f88);
    var conscientiousness = lang === 'sv' ? (0, $e284769d226e732e$export$44b1b6cff76a4176) : (0, $e284769d226e732e$export$6538991d1d16d3d2);
    var extraversion = lang === 'sv' ? (0, $e284769d226e732e$export$8779f5417c0e9fe9) : (0, $e284769d226e732e$export$a7aa291e20ce9ebf);
    var neuroticism = lang === 'sv' ? (0, $e284769d226e732e$export$ffae95c6e0fa24ec) : (0, $e284769d226e732e$export$f37a73316abb9b49);
    var openness = lang === 'sv' ? (0, $e284769d226e732e$export$39fc19cf401ebde3) : (0, $e284769d226e732e$export$299b9efb99b00f09);
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState1[0], setLoaded = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(1), 2), pageNr = _useState2[0], setPageNr = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), sending = _useState3[0], setSending = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), calculatingResult = _useState4[0], setCalculatingResult = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showResult = _useState5[0], setShowResult = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), changed = _useState6[0], setChanged = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), analysis = _useState7[0], setAnalysis = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(new Date()), 2), created = _useState8[0], setCreated = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), confirmRetake = _useState9[0], setConfirmRetake = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)("-"), 2), selectedDomain = _useState10[0], setSelectedDomain = _useState10[1];
    var pages = Math.ceil(questions.length / 3);
    var _useState11 = (0, $6iP9u._)((0, $5s1kH.useState)(), 2), client = _useState11[0], setClient = _useState11[1];
    var domains = [
        'A',
        'C',
        'E',
        'N',
        'O'
    ];
    var personalityId = (0, $bHX26.useParams)().personalityId;
    (0, $5s1kH.useEffect)(function() {
        var url = personalityId ? "coach/big5/" + personalityId : "client/profile/big5";
        api.get(url).then(function(response) {
            var storedAnswers = response.json.answers;
            if (storedAnswers) {
                setAnswers(storedAnswers);
                setAnalysis(response.json.analysis);
                setClient(response.json.client);
                var answered = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = storedAnswers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var a = _step.value;
                        if (a.score === 0) break;
                        answered++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (response.json.updated) setCreated(new Date(response.json.updated));
                var _pageNr = Math.ceil(answered / 3) + 1;
                if (_pageNr > 40) _pageNr = 40;
                setPageNr(_pageNr);
                setShowResult(answered === questions.length);
            } else {
                var _answers = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var q = _step1.value;
                        _answers.push({
                            score: 0
                        });
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                setAnswers(_answers);
            }
            setLoaded(true);
        });
    }, []);
    var pageDone = function() {
        var answered = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = answers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var a = _step.value;
                if (a.score === 0) break;
                answered++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return Math.floor(answered / 3) < pageNr;
    };
    var setPage = function(step) {
        if (step === 1) {
            if (changed) {
                setSending(true);
                var lastAnswers = pageNr > pages - 1;
                var _result = null;
                if (lastAnswers) {
                    _result = calculateResults();
                    setCalculatingResult(true);
                }
                var data = {
                    answers: answers,
                    result: _result
                };
                api.post("client/profile/big5", data).then(function(response) {
                    setSending(false);
                    setCalculatingResult(false);
                    if (lastAnswers) setShowResult(true);
                    else setPageNr(pageNr + step);
                    if (response.json.analysis) setAnalysis(response.json.analysis);
                    (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
                });
            } else {
                if (pageNr > pages - 1) setShowResult(true);
                else setPageNr(pageNr + step);
                (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
            }
            setChanged(false);
        } else if (pageNr === 1) navigate("/profile");
        else {
            setPageNr(pageNr + step);
            (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
        }
    };
    var selectOption = function(questionNr, score) {
        var _answers = (0, $XnYkK._)(answers);
        _answers[questionNr].score = score;
        setAnswers(_answers);
        setChanged(true);
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {});
    if (calculatingResult) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {
        txt: lang === "sv" ? "R\xe4knar ut din personlighetstyp..." : "Calculating your personality type..."
    });
    var getTemplate = function(domain) {
        if (domain === 'A') return agreeableness;
        else if (domain === 'C') return conscientiousness;
        else if (domain === 'N') return neuroticism;
        else if (domain === 'E') return extraversion;
        else return openness;
    };
    var calculateScoreClass = function(score) {
        if (score > 3.5) return lang === "sv" ? "h\xf6g" : "high";
        else if (score >= 2.5) return "neutral";
        else if (score > 0) return lang === "sv" ? "l\xe5g" : "low";
        return "N/A";
    };
    var renderDomain = function(results, domain) {
        var r = results[domain];
        var score = r.avg;
        var domainTemplate = getTemplate(domain);
        var text = "-";
        if (score > 3.5) text = domainTemplate.results[2].text;
        else if (score >= 2.5) text = domainTemplate.results[1].text;
        else if (score > 0) text = domainTemplate.results[0].text;
        var facetScores = calculateFacets(domain);
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-6 bg-indigo-900 rounded-md p-4 border-indigo-800 border",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "text-lg",
                    children: domainTemplate.title
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "text-gray-400 mt-2",
                    children: text
                }),
                domainTemplate.facets.map(function(facet, i) {
                    var facetScore = facetScores[facet.facet];
                    var facetClass = calculateScoreClass(facetScore);
                    var facetValue = (120 * facetScore / 5).toFixed(0) + " (" + facetClass + ")";
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            i > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                className: "border-indigo-700"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "font-medium mt-4",
                                children: facet.title
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $44fe092aad431d2d$export$2e2bcd8739ae039), {
                                size: "small",
                                value: facetScore,
                                min: 0,
                                max: 5,
                                results: facetValue,
                                className: "mt-1"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4 text-gray-400",
                                children: facet.text
                            })
                        ]
                    }, "facet_" + domain + "_" + facet.facet);
                })
            ]
        }, "domain_" + domain);
    };
    var calculateResults = function() {
        var results = {
            'A': {
                count: 0,
                score: 0,
                avg: 0
            },
            'C': {
                count: 0,
                score: 0,
                avg: 0
            },
            'E': {
                count: 0,
                score: 0,
                avg: 0
            },
            'N': {
                count: 0,
                score: 0,
                avg: 0
            },
            'O': {
                count: 0,
                score: 0,
                avg: 0
            }
        };
        for(var i = 0; i < questions.length; i++)if (answers[i].score > 0) {
            var question = questions[i];
            var r = results[question.domain];
            r.count++;
            r.score += answers[i].score;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = domains[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var domain = _step.value;
                var r1 = results[domain];
                r1.avg = r1.count > 0 ? r1.score / r1.count : 0;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return results;
    };
    var calculateFacets = function(domain) {
        var scores = [
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var counts = [
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(var i = 0; i < questions.length; i++)if (answers[i].score > 0) {
            var question = questions[i];
            if (question.domain === domain) {
                counts[question.facet]++;
                scores[question.facet] += answers[i].score;
            }
        }
        for(var i1 = 0; i1 < 7; i1++)scores[i1] = counts[i1] > 0 ? scores[i1] / counts[i1] : 0;
        return scores;
    };
    var resetAnswers = function() {
        var _answers = (0, $XnYkK._)(answers);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = answers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _a = _step.value;
                _a.score = 0;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setAnswers(_answers);
        setConfirmRetake(false);
        setPageNr(1);
        setShowResult(false);
    };
    var renderResult = function() {
        var results = calculateResults();
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex mt-4",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "rounded-md bg-indigo-900 p-2 border-indigo-800 border",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0fac0413583d4655$exports))),
                                className: "h-10 w-10",
                                alt: "compass"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "ml-3",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-heading1",
                                    children: lang === "sv" ? "Resultat av personlighetstest" : "Personality assessment result"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "text-sm text-gray-400",
                                    children: [
                                        lang === "sv" ? "Skapad" : "Created",
                                        "\xa0",
                                        (0, $7d185b5883a21821$export$ce35f6b40b9b16f5)(created)
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 z-title1",
                    children: lang === "sv" ? "Din personlighetstyp" : "Your personality profile"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 rounded-md p-4 border-indigo-800 border",
                    children: [
                        domains.map(function(domain) {
                            var r = results[domain];
                            var domainTemplate = getTemplate(domain);
                            var score = (120 * r.avg / 5).toFixed(0) + "";
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "font-medium",
                                        children: domainTemplate.title
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $44fe092aad431d2d$export$2e2bcd8739ae039), {
                                        size: "large",
                                        value: r.avg,
                                        min: 0,
                                        max: 5,
                                        results: score,
                                        className: "mt-2 mb-4"
                                    })
                                ]
                            }, "header_domain_" + domain);
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex justify-between text-sm text-gray-400",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: "0"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: "60"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: "120"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "border-indigo-700 mt-4"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-4 font-medium",
                            children: lang === "sv" ? "Analys" : "Analysis"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: analysis ? analysis : "Analysis failed - talk to support"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-wrap gap-2 mt-6",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            style: {
                                width: "calc(33% - 8px)"
                            },
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: selectedDomain === "-" ? "chipBase" : "outlineWhiteBase",
                                onClick: function() {
                                    return setSelectedDomain("-");
                                },
                                children: lang === "sv" ? "Alla" : "All"
                            })
                        }),
                        domains.map(function(domain) {
                            var domainTemplate = getTemplate(domain);
                            var buttonType = domain === selectedDomain ? "chipBase" : "outlineWhiteBase";
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                style: {
                                    width: "calc(33% - 8px)"
                                },
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: buttonType,
                                    onClick: function() {
                                        return setSelectedDomain(domain);
                                    },
                                    children: domainTemplate.title
                                })
                            }, "select_" + domain);
                        })
                    ]
                }),
                domains.map(function(domain) {
                    if (selectedDomain === "-" || selectedDomain === domain) return renderDomain(results, domain);
                    else return null;
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 z-title1",
                    children: lang === "sv" ? "F\xf6rst\xe5 ditt resultat" : "Understanding your score"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 rounded-md p-4 border-indigo-800 border",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "font-medium",
                            children: lang === "sv" ? "Po\xe4ng kan vara mellan" : "Score range from"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: lang === "sv" ? "L\xe4gsta m\xf6jliga po\xe4ng" : "Lowest possible score"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: "24"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: lang === "sv" ? "H\xf6gsta m\xf6jliga po\xe4ng" : "Highest possible score"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: "120"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-4 font-medium",
                            children: lang === "sv" ? "Om Big Five" : "About the Big Five"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: lang === "sv" ? "Big Five \xe4r en av de mest anv\xe4nda modellerna f\xf6r att beskriva personlighet. Den best\xe5r av fem dimensioner: \xf6ppenhet, samvetsgrannhet, extraversion, v\xe4nlighet och emotionell stabilitet." : "The Big Five is one of the most widely used frameworks for describing personality. It consists of five dimensions: Openness, Conscientiousness, Extraversion, Agreeableness, and Neuroticism."
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-400 mt-2",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("a", {
                                className: "underline",
                                target: "_new",
                                href: "https://github.com/rubynor/bigfive-web/blob/master/LICENSE",
                                children: "\xa9 2025 \u2014 B5 Holding AS - all rights reserved."
                            })
                        })
                    ]
                }),
                !personalityId && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "outlineWhiteBase",
                    className: "mt-4",
                    onClick: function() {
                        return setConfirmRetake(true);
                    },
                    children: lang === "sv" ? "G\xf6r om testet" : "Retake Assessment"
                }),
                confirmRetake && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                    isOpen: true,
                    onClose: function() {
                        return setConfirmRetake(false);
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                            onClose: function() {
                                return setConfirmRetake(false);
                            },
                            children: lang === "sv" ? "Ta om personlighetstest?" : "Retake personal test?"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($77be1a01a9b27ed1$exports))),
                                    alt: "!",
                                    className: "h-10 w-10 mx-auto text-center mt-3"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "mt-3 text-gray-300",
                                    children: lang === "sv" ? "Om du v\xe4ljer att ta om personlighetstestet kommer dina nuvarande resultat att raderas och ers\xe4ttas med de nya." : "If you choose to retake the personality test, your current results will be deleted and replaced with the new ones."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: "outlineWhiteBase",
                                        onClick: function() {
                                            return setConfirmRetake(false);
                                        },
                                        children: lang === "sv" ? "Avbryt" : "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: "blueBase",
                                        className: "mt-2",
                                        onClick: function() {
                                            return resetAnswers();
                                        },
                                        children: lang === "sv" ? "Ja, ta om testet" : "Yes, retake the test"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    var pageName = lang === "sv" ? "Personlighetstest" : "Personality assessment";
    var crumbs;
    if (client) crumbs = [
        {
            name: lang === "sv" ? "Hem" : "Home",
            url: "/"
        },
        {
            name: t("my-clients"),
            url: "/clients"
        },
        {
            name: client.firstName + " " + client.lastName,
            url: "/clients/" + client.id
        },
        {
            name: pageName
        }
    ];
    else crumbs = [
        {
            name: lang === "sv" ? "Profil" : "Profile",
            url: "/profile"
        },
        {
            name: pageName
        }
    ];
    if (showResult) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            renderResult()
        ]
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $51e9ec39f085fa8f$export$2e2bcd8739ae039), {
                    step: pageNr,
                    steps: pages
                })
            }),
            questions.slice((pageNr - 1) * 3, pageNr * 3).map(function(question, questionNr) {
                var _choices = question.keyed === 'plus' ? choices.plus : choices.minus;
                var _questionNr = questionNr + (pageNr - 1) * 3;
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-title1",
                            children: question.text
                        }),
                        _choices.map(function(choice) {
                            var _selectedScore = answers[_questionNr].score;
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                                    id: "a_" + _questionNr + '_' + choice.score,
                                    name: "a_" + _questionNr + '_' + choice.score,
                                    label: choice.text,
                                    value: "" + choice.score,
                                    checked: _selectedScore === choice.score,
                                    onChange: function() {
                                        return selectOption(_questionNr, choice.score);
                                    }
                                })
                            }, "a_" + _questionNr + '_' + choice.score);
                        })
                    ]
                }, "question_" + _questionNr);
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex justify-between mt-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "w-40",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "outlineWhiteBase",
                            onClick: function() {
                                return setPage(-1);
                            },
                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($e9e1f45fe1c804bc$exports))),
                                alt: "left"
                            }),
                            className: "w-full",
                            children: pageNr < 2 ? lang === "sv" ? "Tillbaka till profil" : "Back to Profile" : lang === "sv" ? "F\xf6reg\xe5ende" : "Previous"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "w-40",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            disabled: sending || pageDone(),
                            onClick: function() {
                                return setPage(1);
                            },
                            rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                                alt: "right"
                            }),
                            className: "w-full",
                            children: pages === pageNr ? t('submit') : lang === "sv" ? "N\xe4sta" : "Next"
                        })
                    })
                ]
            })
        ]
    });
}



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");








var $6a066dfd315d8ab7$exports = {};
$6a066dfd315d8ab7$exports = $parcel$resolve("1Spux");


var $2f73d526a867139d$exports = {};
$2f73d526a867139d$exports = $parcel$resolve("1G33i");








var $9228aabb792bca9d$var$questions = [
    {
        en: "In the last month, how often have you been upset because of something that happened unexpectedly?",
        sv: "Under den senaste m\xe5naden, hur ofta har du blivit uppr\xf6rd \xf6ver n\xe5got som h\xe4nde ov\xe4ntat?",
        positive: false
    },
    {
        en: "In the last month, how often have you felt that you were unable to control the important things in your life?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt att du inte kunde kontrollera de viktiga sakerna i ditt liv?",
        positive: false
    },
    {
        en: "In the last month, how often have you felt nervous and stressed?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt dig nerv\xf6s och stressad?",
        positive: false
    },
    {
        en: "In the last month, how often have you felt confident about your ability to handle your personal problems?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt dig trygg i din f\xf6rm\xe5ga att hantera dina personliga problem?",
        positive: true
    },
    {
        en: "In the last month, how often have you felt that things were going your way?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt att saker och ting har g\xe5tt din v\xe4g?",
        positive: true
    },
    {
        en: "In the last month, how often have you found that you could not cope with all the things that you had to do?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt att du inte klarade av allt du beh\xf6vde g\xf6ra?",
        positive: false
    },
    {
        en: "In the last month, how often have you been able to control irritations in your life?",
        sv: "Under den senaste m\xe5naden, hur ofta har du kunnat hantera irritationer i ditt liv?",
        positive: true
    },
    {
        en: "In the last month, how often have you felt that you were on top of things?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt att du hade kontroll och \xf6verblick?",
        positive: true
    },
    {
        en: "In the last month, how often have you been angered because of things that happened that were outside of your control?",
        sv: "Under den senaste m\xe5naden, hur ofta har du blivit arg \xf6ver saker som h\xe4nde utanf\xf6r din kontroll?",
        positive: false
    },
    {
        en: "In the last month, how often have you felt difficulties were piling up so high that you could not overcome them?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt att sv\xe5righeterna hopade sig s\xe5 mycket att du inte kunde hantera dem?",
        positive: false
    }
];
var $9228aabb792bca9d$var$choices = [
    {
        en: "Never",
        sv: "Aldrig",
        score: 0
    },
    {
        en: "Almost never",
        sv: "N\xe4stan aldrig",
        score: 1
    },
    {
        en: "Sometimes",
        sv: "Ibland",
        score: 2
    },
    {
        en: "Fairly often",
        sv: "Ganska ofta",
        score: 3
    },
    {
        en: "Very often",
        sv: "Mycket ofta",
        score: 4
    }
];
function $9228aabb792bca9d$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), answers = _useState[0], setAnswers = _useState[1];
    var stressId = (0, $bHX26.useParams)().stressId;
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState1[0], setLoaded = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(1), 2), pageNr = _useState2[0], setPageNr = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), sending = _useState3[0], setSending = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(-1), 2), result = _useState4[0], setResult = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showResult = _useState5[0], setShowResult = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), changed = _useState6[0], setChanged = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(new Date()), 2), created = _useState7[0], setCreated = _useState7[1];
    var pages = Math.ceil($9228aabb792bca9d$var$questions.length / 3);
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), calculatingResult = _useState8[0], setCalculatingResult = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), originId = _useState9[0], setOriginId = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), client = _useState10[0], setClient = _useState10[1];
    (0, $5s1kH.useEffect)(function() {
        var url = stressId ? "coach/stress/" + stressId : "client/profile/stress";
        api.get(url).then(function(response) {
            var storedAnswers = response.json.answers;
            if (storedAnswers) {
                setAnswers(storedAnswers);
                setOriginId(response.json.id);
                var answered = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = storedAnswers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var a = _step.value;
                        if (a.score < 0) break;
                        answered++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                setResult(response.json.result);
                setClient(response.json.client);
                if (response.json.created) setCreated(new Date(response.json.created));
                var _pageNr = Math.ceil(answered / 3) + 1;
                if (_pageNr > 4) _pageNr = 4;
                setPageNr(_pageNr);
                setShowResult(answered === $9228aabb792bca9d$var$questions.length && response.json.result > -1);
            } else {
                var _answers = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = $9228aabb792bca9d$var$questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var q = _step1.value;
                        _answers.push({
                            score: -1
                        });
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                setAnswers(_answers);
            }
            setLoaded(true);
        });
    }, []);
    var retakeTest = function() {
        api.get("client/profile/stress?retake=1").then(function(response) {
            var _answers = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = $9228aabb792bca9d$var$questions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var q = _step.value;
                    _answers.push({
                        score: -1
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            setAnswers(_answers);
            setPageNr(1);
            setShowResult(false);
        });
    };
    var pageDone = function() {
        var answered = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = answers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var a = _step.value;
                if (a.score < 0) break;
                answered++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (answered === answers.length) return true;
        return Math.floor(answered / 3) >= pageNr;
    };
    var setPage = function(step) {
        if (step === 1) {
            if (changed) {
                setSending(true);
                var lastAnswers = pageNr > pages - 1;
                var fakePause = 1;
                var _result = -1;
                if (lastAnswers) {
                    _result = calculateResults();
                    setCalculatingResult(true);
                    fakePause = 3000;
                }
                var data = {
                    answers: answers,
                    result: _result
                };
                api.post("client/profile/stress", data).then(function() {
                    setTimeout(function() {
                        setSending(false);
                        if (lastAnswers) setShowResult(true);
                        else setPageNr(pageNr + step);
                        setCalculatingResult(false);
                        (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
                    }, fakePause);
                });
            } else {
                if (pageNr > pages - 1) setShowResult(true);
                else setPageNr(pageNr + step);
                (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
            }
            setChanged(false);
        } else if (pageNr === 1) navigate("/profile");
        else {
            setPageNr(pageNr + step);
            (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
        }
    };
    var selectOption = function(questionNr, score) {
        var _answers = (0, $XnYkK._)(answers);
        _answers[questionNr].score = score;
        setAnswers(_answers);
        setChanged(true);
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {});
    if (calculatingResult) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {
        txt: lang === "sv" ? "Ber\xe4knar din stressniv\xe5..." : "Calculating your stress level..."
    });
    var calculateResults = function() {
        var totalScore = 0;
        for(var i = 0; i < $9228aabb792bca9d$var$questions.length; i++)if (answers[i].score > -1) {
            var question = $9228aabb792bca9d$var$questions[i];
            var score = question.positive ? 4 - answers[i].score : answers[i].score;
            totalScore += score;
        }
        return totalScore;
    };
    var getStressLevel = function(category) {
        if (lang === "sv") {
            if (category === 2) return "H\xf6g";
            else if (category === 1) return "M\xe5ttlig";
            else return "L\xe5g";
        } else {
            if (category === 2) return "High";
            else if (category === 1) return "Moderate";
            else return "Low";
        }
    };
    var getStressRange = function(category) {
        if (category === 2) return "27-40";
        else if (category === 1) return "14-26";
        else return "0-13";
    };
    var renderStressAnalysis = function(category) {
        if (lang === "sv") {
            if (category === 2) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    children: "Din sj\xe4lvskattning tyder p\xe5 en h\xf6g niv\xe5 av upplevd stress. Du kan uppleva att kraven \xe4r m\xe5nga och att trycket p\xe5verkar fokus, v\xe4lm\xe5ende och beslut.\u2028Det kan vara hj\xe4lpsamt att sakta ner, skilja p\xe5 vad som \xe4r mest br\xe5dskande och mest viktigt, och ta sm\xe5 steg f\xf6r att \xe5terf\xe5 kontroll. Du kan anv\xe4nda din AI-coach, eller kanske kollegor eller n\xe5gon du litar p\xe5 f\xf6r att utforska hur du kan skapa mer h\xe5llbara rutiner f\xf6r \xe5terh\xe4mtning och balans."
                })
            });
            else if (category === 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    children: "Dina svar visar en m\xe5ttlig niv\xe5 av upplevd stress. Du hanterar vardagens krav, men stress kan ibland p\xe5verka hum\xf6r, fokus eller energi. Fundera \xf6ver vilka situationer som oftast triggar stress hos dig. Sm\xe5 justeringar \u2013 som tydligare gr\xe4nser, korta \xe5terh\xe4mtningspauser eller b\xe4ttre s\xf6mn \u2013 kan g\xf6ra stor skillnad. Om stressen p\xe5g\xe5r under l\xe4ngre tid kan en mer strukturerad reflektion eller kortare coachande samtal hj\xe4lpa dig att st\xe4rka dina strategier."
                })
            });
            else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    children: "Din sj\xe4lvskattning visar en l\xe5g niv\xe5 av upplevd stress. Du verkar ha en bra balans i vardagen och strategier som hj\xe4lper dig att hantera p\xe5frestningar p\xe5 ett effektivt s\xe4tt. Forts\xe4tt att v\xe4rna om de rutiner som st\xe4rker din \xe5terh\xe4mtning, s\xf6mn och fokus. Genom att uppm\xe4rksamma tidiga tecken p\xe5 stress kan du bevara balansen \xf6ver tid."
                })
            });
        } else {
            if (category === 2) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Your self-assessment points to a high level of perceived stress. You may feel overloaded or under pressure in several areas of life, which can affect focus, health, and decision-making."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mt-4",
                        children: "It can help to slow down, identify what feels most urgent versus most important, and create micro-steps to regain control. If you wish, you can use your AI Coach, peers, or a trusted person to explore how to re-establish sustainable routines for recovery and resilience."
                    })
                ]
            });
            else if (category === 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Your self-reported answers indicate a moderate level of perceived stress. You\u2019re managing everyday demands, though stress may occasionally affect mood, focus, or energy."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mt-4",
                        children: "Reflect on what typically triggers stress for you. Even small shifts\u2014like clearer boundaries, short recovery breaks, or better sleep quality\u2014can make a measurable difference. If you notice ongoing stress, structured reflection or short coaching sessions may help you strengthen coping strategies."
                    })
                ]
            });
            else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    children: "Your self-assessment suggests a relatively low level of perceived stress. You appear to experience balance and effective coping strategies in daily life. Continue maintaining routines that support recovery, sleep, and focus. Staying aware of early stress signals helps you preserve that balance over time."
                })
            });
        }
    };
    var renderNextSteps = function(category) {
        if (lang === "sv") {
            if (category === 2) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Reflektera med din AI-coach"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "\u2013 Beskriv hur din situation ser ut just nu och f\xe5 st\xf6d i att identifiera vad som k\xe4nns mest kr\xe4vande, samt hur du kan bryta ner det i hanterbara steg."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mt-4",
                        children: "Skapa en \xe5terh\xe4mtningsplan"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "\u2013 V\xe4lj en konkret, st\xe4rkande handling inom det n\xe4rmaste dygnet \u2013 till exempel att delegera en uppgift, ta en ordentlig paus eller kontakta n\xe5gon du litar p\xe5."
                    })
                ]
            });
            else if (category === 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Reflektera med din AI-coach"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "\u2013 Vilka situationer eller m\xf6nster skapar mest stress f\xf6r dig?"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mt-4",
                        children: "Skapa en handling"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "\u2013 G\xf6r din insikt konkret genom ett praktiskt steg, till exempel planera in \xe5terh\xe4mtning eller skapa tydligare ramar f\xf6r arbete och fritid."
                    })
                ]
            });
            else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Reflektera med din AI-coach"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "\u2013 Utforska vad som hj\xe4lper dig att beh\xe5lla lugn och balans, \xe4ven under mer intensiva perioder."
                    })
                ]
            });
        } else {
            if (category === 2) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Reflect with your AI Coach"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "\u2013 Describe your current situation and get guidance to identify what feels most draining and break it down into manageable steps."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mt-4",
                        children: "Create a recovery plan"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "\u2013 Set one concrete, self-supporting action for the next 24 hours (e.g., delegate one task, take a proper break, or connect with someone you trust)."
                    })
                ]
            });
            else if (category === 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Reflect with your AI Coach"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "\u2013 What situations or patterns increase your stress?"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mt-4",
                        children: "Create an action"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mt-2",
                        children: "\u2013 Turn your insights into one practical next step, such as planning recovery breaks or setting clearer boundaries."
                    })
                ]
            });
            else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Reflect with your AI Coach"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "\u2013 Explore what helps you stay balanced and how to maintain that even during busier periods."
                    })
                ]
            });
        }
    };
    var toAiThread = function() {
        var message;
        if (lang === "sv") message = "Jag vill utforska vilka situationer eller m\xf6nster som \xf6kar min stress";
        else message = "I want to research what situations or patterns increase my stress";
        (0, $d0129b8cfae32aec$export$f93b11ed7a4960f0)("coaching", "stress", null, null, null, message, "stress", originId);
        navigate("/ai/0");
    };
    var renderResult = function() {
        var score = calculateResults();
        var stressCategory = 0;
        if (score > 26) stressCategory = 2;
        else if (score > 13) stressCategory = 1;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex mt-4",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "rounded-md bg-indigo-900 p-2 border-indigo-800 border-1",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6a066dfd315d8ab7$exports))),
                                className: "h-10 w-10",
                                alt: "brain"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "ml-3",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-heading1",
                                    children: lang === "sv" ? "Stress test - resultat" : "Stress test result"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "text-sm text-gray-400",
                                    children: [
                                        lang === "sv" ? "Skapad" : "Created",
                                        "\xa0",
                                        (0, $7d185b5883a21821$export$ce35f6b40b9b16f5)(created)
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 rounded-md p-4 border-indigo-800 border-1",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex justify-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-display1",
                                            children: score
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-gray-400",
                                            children: "\xa0/\xa040"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "mt-4",
                                    children: [
                                        lang === "sv" ? "Stressniv\xe5" : "Stress level",
                                        ": ",
                                        getStressLevel(stressCategory)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $44fe092aad431d2d$export$2e2bcd8739ae039), {
                            size: "large",
                            value: score,
                            min: 0,
                            max: 40,
                            results: score + "",
                            className: "mt-6"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex justify-between mt-4 text-sm text-gray-400",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    children: [
                                        "0 (",
                                        lang === "sv" ? "Ingen stress" : "No stress",
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: "20"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    children: [
                                        "40 (",
                                        lang === "sv" ? "H\xf6g stress" : "High stress",
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "border-indigo-700 mt-4"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 font-medium",
                            children: [
                                getStressLevel(stressCategory),
                                " stress\xa0(",
                                getStressRange(stressCategory),
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: renderStressAnalysis(stressCategory)
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "border-indigo-700 mt-4"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-4 font-medium",
                            children: lang === "sv" ? "F\xf6rslag p\xe5 n\xe4sta steg:" : "Suggested next steps:"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: renderNextSteps(stressCategory)
                        }),
                        !stressId && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "outlineWhiteBase",
                            className: "mt-4 flex items-center justify-center",
                            onClick: function() {
                                return toAiThread();
                            },
                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($2f73d526a867139d$exports))),
                                className: "h-4 w-4",
                                alt: "ai"
                            }),
                            children: lang === "sv" ? "Reflektera med AI-coachen" : "Reflect with AI Coach"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 z-title1",
                    children: lang === "sv" ? "F\xf6rst\xe5 ditt resultat" : "Understanding your score"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 rounded-md p-4 border-indigo-800 border-1",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "font-medium",
                            children: lang === "sv" ? "Resultatintervall" : "Score range"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    children: [
                                        getStressLevel(0),
                                        " stress"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: getStressRange(0)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    children: [
                                        getStressLevel(1),
                                        " stress"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: getStressRange(1)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    children: [
                                        getStressLevel(2),
                                        " stress"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: getStressRange(2)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-4 font-medium",
                            children: lang === "sv" ? "Om PSS" : "About the PSS"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: lang === "sv" ? "Perceived Stress Scale (PSS) \xe4r ett av de mest anv\xe4nda psykologiska instrumenten f\xf6r att m\xe4ta upplevd stress. Det m\xe4ter i vilken grad situationer i ditt liv har uppfattats som stressande under den senaste m\xe5naden. Fr\xe5gorna unders\xf6ker hur of\xf6ruts\xe4gbart, okontrollerbart och \xf6verbelastat du upplever ditt liv." : "The Perceived Stress Scale (PSS) is a widely used psychological instrument for measuring the perception of stress. It measures the degree to which situations in your life are appraised as stressful over the past month. Questions assess how unpredictable, uncontrollable, and overloaded respondents find their lives."
                        })
                    ]
                }),
                !stressId && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "outlineWhiteBase",
                    className: "mt-4",
                    onClick: function() {
                        return retakeTest();
                    },
                    children: lang === "sv" ? "G\xf6r om testet" : "Retake Assessment"
                })
            ]
        });
    };
    var crumbs;
    if (client) crumbs = [
        {
            name: lang === "sv" ? "Hem" : "Home",
            url: "/"
        },
        {
            name: t("my-clients"),
            url: "/clients"
        },
        {
            name: client.firstName + " " + client.lastName,
            url: "/clients/" + client.id
        },
        {
            name: "Stress test"
        }
    ];
    else crumbs = [
        {
            name: lang === "sv" ? "Profil" : "Profile",
            url: "/profile"
        },
        {
            name: "Stress test"
        }
    ];
    if (showResult) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            renderResult()
        ]
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $51e9ec39f085fa8f$export$2e2bcd8739ae039), {
                    step: pageNr,
                    steps: pages
                })
            }),
            $9228aabb792bca9d$var$questions.slice((pageNr - 1) * 3, pageNr * 3).map(function(question, questionNr) {
                var _questionNr = questionNr + (pageNr - 1) * 3;
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-title1",
                            children: lang === "sv" ? question.sv : question.en
                        }),
                        $9228aabb792bca9d$var$choices.map(function(choice) {
                            var _selectedScore = answers[_questionNr].score;
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                                    id: "a_" + _questionNr + '_' + choice.score,
                                    name: "a_" + _questionNr + '_' + choice.score,
                                    label: lang === "sv" ? choice.sv : choice.en,
                                    value: "" + choice.score,
                                    checked: _selectedScore === choice.score,
                                    onChange: function() {
                                        return selectOption(_questionNr, choice.score);
                                    }
                                })
                            }, "a_" + _questionNr + '_' + choice.score);
                        })
                    ]
                }, "question_" + _questionNr);
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex justify-between mt-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "w-40",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "outlineWhiteBase",
                            onClick: function() {
                                return setPage(-1);
                            },
                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($e9e1f45fe1c804bc$exports))),
                                alt: "left"
                            }),
                            children: pageNr < 2 ? lang === "sv" ? "Tillbaka till profil" : "Back to Profile" : lang === "sv" ? "F\xf6reg\xe5ende" : "Previous"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "w-40",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            disabled: sending || !pageDone(),
                            onClick: function() {
                                return setPage(1);
                            },
                            rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                                alt: "left"
                            }),
                            children: pages === pageNr ? t('submit') : lang === "sv" ? "N\xe4sta" : "Next"
                        })
                    })
                ]
            })
        ]
    });
}



var $hwO3w = parcelRequire("hwO3w");

var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");


var $7733e845956e4cc2$exports = {};
$7733e845956e4cc2$exports = $parcel$resolve("jJ1uo");











var $2dd33a640256b676$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType[FeedbackType["FEEDBACK"] = 0] = "FEEDBACK";
    FeedbackType[FeedbackType["ONLY_SELF"] = 1] = "ONLY_SELF";
    return FeedbackType;
}({});


var $2dc00239332c5354$var$SurveyResponse = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), data = _useState2[0], setData = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), otherSurveys = _useState3[0], setOtherSurveys = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)({
        language: "en",
        languages: [],
        deadline: "",
        answerOptions: 5,
        answerType: 0,
        showNoAnswer: true,
        names: {},
        translations_answers: {},
        sections: []
    }), 2), survey = _useState4[0], setSurvey = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showFeedbackSent = _useState5[0], setShowFeedbackSent = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)("en"), 2), language = _useState6[0], setLanguage = _useState6[1];
    var location = (0, $bHX26.useLocation)();
    var queryParams = new URLSearchParams(location.search);
    var token = queryParams.get("token");
    var id = (0, $bHX26.useParams)().id;
    // State to store user responses
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showAlert = _useState7[0], setShowAlert = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), selfInfo = _useState8[0], setSelfInfo = _useState8[1];
    var url = "client/survey/" + id;
    if (token) url += "/" + token;
    var setDefaultLanguage = function(_survey) {
        if (_survey.languages.indexOf(lang) !== -1) // If browser language is in survey.languages, use that language
        setLanguage(lang);
        else // Else use survey language
        setLanguage(_survey.language);
    };
    (0, $5s1kH.useEffect)(function() {
        var anonymous = !!token;
        api.get(url, [], anonymous).then(function(response) {
            if (response.json.status === "ok") {
                setData(response.json.data);
                setSurvey(response.json.survey);
                setDefaultLanguage(response.json.survey);
            } else {
                setError(response.json.error);
                setData(response.json);
            }
            setOtherSurveys(response.json.otherSurveys);
            setLoading(false);
        }).catch(function(err) {
            alert("An error occurred: " + err);
        });
    }, []);
    var sendResponses = function() {
        var anonymous = !!token;
        api.post(url, survey, [], anonymous).then(function(response) {
            if (response.json.status === "ok") setShowFeedbackSent(true);
        });
    };
    var formatError = function() {
        var errorHeader = "Unknown error: " + error;
        var errorBody = lang === "sv" ? "Kontakta support@zebrain.se s\xe5 hj\xe4lper vi dig" : "Contact support@zebrain.se and we will help you";
        if (error === "deadline-passed" || error === "already-submitted") {
            errorHeader = t(error);
            if (token) errorBody = t(error + "-message");
            else errorBody = lang === "sv" ? "Du har redan skickat din sj\xe4lvskattning" : "You have already submitted your self-assessment";
        } else if (error === "badToken") errorHeader = lang === "sv" ? "N\xe5got \xe4r konstigt med din token" : "Something is wrong with your token";
        else if (error === "badRecipient") errorHeader = lang === "sv" ? "Du \xe4r inte registrerad mottagare" : "You are not a registered recipient";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-10 main-content",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-col h-full flex-grow min-h-0 gap-6 mt-6",
                children: [
                    error === "deadline-passed" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7e9b9c1a730c7955$exports))),
                        alt: "Calendar X icon",
                        className: "w-12 h-12 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                                className: "z-heading1 text-white text-center",
                                children: errorHeader
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-gray-400 text-center",
                                dangerouslySetInnerHTML: {
                                    __html: errorBody
                                }
                            })
                        ]
                    }),
                    error === "already-submitted" && !token && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "blueBase",
                        className: "mt-4 mx-auto",
                        style: {
                            width: 250
                        },
                        onClick: function() {
                            return navigate("/assessments");
                        },
                        children: lang === "sv" ? "Tillbaka till m\xe4tningar" : "Back to assessments"
                    }),
                    (error === "deadline-passed" || error === "already-submitted") && renderOtherSurveys()
                ]
            })
        });
    };
    var renderOtherSurveys = function() {
        if (otherSurveys.length === 0) return null;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                    className: "font-medium",
                    children: [
                        lang === "sv" ? "Andra feedback-f\xf6rfr\xe5gningar du inte har svarat p\xe5 \xe4n" : "Other feedback requests you have not answered yet",
                        ":"
                    ]
                }),
                otherSurveys.map(function(otherSurvey, index) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between cursor-pointer bg-indigo-900 rounded-md p-4 hover:bg-indigo-800",
                        onClick: function() {
                            return window.location.href = "/feedback/survey/" + otherSurvey.id + "?token=" + otherSurvey.token;
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "w-40 truncate",
                                children: otherSurvey.name
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                className: "w-40 text-gray-400",
                                children: [
                                    "Deadline ",
                                    (0, $7d185b5883a21821$export$3ae94a2503e890a1)(otherSurvey.deadline, false, lang)
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($e8981ef41dc6cb1b$exports))),
                                alt: "Go"
                            })
                        ]
                    }, "other_q_" + index);
                })
            ]
        });
    };
    var renderSelfInfo = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: selfInfo,
            onClose: function() {
                return setSelfInfo(false);
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return setSelfInfo(false);
                    },
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("self-assessment")
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: t("self-assessment-txt1")
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-400 mt-4",
                            children: t("self-assessment-txt2")
                        })
                    ]
                })
            ]
        });
    };
    if (error) return formatError();
    if (showFeedbackSent) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-10 main-content",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex flex-col h-full flex-grow min-h-0 gap-6 mt-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7733e845956e4cc2$exports))),
                    alt: "Badge check icon",
                    className: "w-12 h-12 mx-auto"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                            className: "z-heading1 text-white text-center",
                            children: !token && (data === null || data === void 0 ? void 0 : data.feedbackType) !== (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                                children: lang === "sv" ? "Dags att be om feedback" : "Time to request feedback"
                            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                                children: token ? t("feedback-sent") : t("self-assessment-complete")
                            })
                        }),
                        !token ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "text-gray-400 text-center",
                                    children: (data === null || data === void 0 ? void 0 : data.feedbackType) === (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF ? lang === "sv" ? "Kolla in din insiktsrapport" : "Check your insights report" : lang === "sv" ? "F\xe5 fler perspektiv som st\xe4rker och kompletterar din sj\xe4lvskattning." : "Get additional perspectives that strengthen and complement your self-assessment."
                                }),
                                (data === null || data === void 0 ? void 0 : data.feedbackType) === (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "blueBase",
                                    className: "mt-1 mx-auto",
                                    style: {
                                        width: 250
                                    },
                                    onClick: function() {
                                        return navigate("/dev-plan/survey/result/" + id + "/summary");
                                    },
                                    children: t("view-your-insights-report")
                                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "blueBase",
                                    className: "mt-4 mx-auto",
                                    style: {
                                        width: 250
                                    },
                                    onClick: function() {
                                        return navigate("/dev-plan/survey_request_invite/" + id);
                                    },
                                    children: lang === "sv" ? "V\xe4lj mottagare" : "Select recipients"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "text-gray-400 text-center",
                                    children: t("thank-you-for-your-feedback")
                                }),
                                renderOtherSurveys()
                            ]
                        })
                    ]
                })
            ]
        })
    });
    if (loading || data === null) return null;
    var updateQuestion = function(questionId, value, what) {
        var _data = (0, $hwO3w._)({}, data);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = survey.sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _section = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = _section.questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _question = _step1.value;
                        if (_question.questionId === questionId) {
                            if (what === "a") // console.log(_question.questionId + ' === ' + questionId + ' = ' + value);
                            _question.answer = parseInt(value);
                            else if (what === "text") _question.freeAnswer = value;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setData(_data);
    };
    var surveyNotComplete = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = survey.sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var section = _step.value;
                try {
                    for(var _iterator1 = section.questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var question = _step1.value;
                        if (question.answer < 0) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return false;
    };
    var formatQuestion = function(question) {
        var answerOptions = [];
        if (survey.answerOptions > 7) for(var i = 1; i <= survey.answerOptions; i++)answerOptions.push({
            name: i + "",
            value: i + ""
        });
        else {
            for(var i1 = survey.answerOptions; i1 > 0; i1--)answerOptions.push({
                name: survey.translations_answers[language][i1],
                value: i1 + ""
            });
            // Do not add noAnswer for self-assessments
            if (token && survey.showNoAnswer) answerOptions.push({
                name: survey.translations_answers[language][0],
                value: "0"
            });
        }
        var questionText = question.names[language];
        if (questionText.startsWith("X ")) questionText = data.client_name + " " + questionText.substring(2);
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "font-medium mb-4",
                    children: questionText
                }),
                survey.answerOptions > 7 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex justify-between",
                            children: answerOptions.map(function(a, i) {
                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                                    id: "A " + i,
                                    value: i + "",
                                    name: "A " + i,
                                    label: a.value,
                                    onChange: function() {
                                        return updateQuestion(question.questionId, a.value, "a");
                                    },
                                    checked: question.answer === parseInt(a.value)
                                }, "a_" + question.questionId + "_" + i);
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex justify-between mt-2",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    children: [
                                        "1 = ",
                                        survey.translations_answers[language][1]
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    children: [
                                        "10 = ",
                                        survey.translations_answers[language][10]
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    children: answerOptions.map(function(a, i) {
                        var _id = "a_" + question.questionId + "_" + i;
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                                id: _id,
                                value: a.value,
                                name: _id,
                                label: a.name,
                                onChange: function() {
                                    return updateQuestion(question.questionId, a.value, "a");
                                },
                                checked: question.answer === parseInt(a.value)
                            })
                        }, _id);
                    })
                }),
                question.freeText && token && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                        className: "z-input",
                        value: question.freeAnswer,
                        placeholder: "Free answer",
                        onChange: function(e) {
                            return updateQuestion(question.questionId, e.target.value, "text");
                        }
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-4 border-indigo-800"
                })
            ]
        });
    };
    var changeLanguage = function(l) {
        if (survey.languages.indexOf(l) !== -1) setLanguage(l);
        if (l === 'en' || l === 'sv') i18n.changeLanguage(l).then();
    };
    var showChangeLanguage = function() {
        if (survey.languages.length < 2) return null;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "flex mt-2 gap-x-4 items-center",
            children: survey.languages.map(function(l, i) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: language === l ? "underline" : "cursor-pointer",
                    onClick: function() {
                        return changeLanguage(l);
                    },
                    children: (0, $c32e41a1c8ecb8c8$export$10937ee5ed6ee4d1)[l]
                }, "lang_" + i);
            })
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            selfInfo && renderSelfInfo(),
            showChangeLanguage(),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "z-heading1 text-white mt-4",
                children: !token ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            children: t("complete-self-assessment")
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "ml-2 p-1 flex item-center justify-center cursor-pointer  rounded-[20px]  hover:bg-indigo-700",
                            onClick: function() {
                                return setSelfInfo(true);
                            },
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                                alt: "info"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        t("asking-for-feedback"),
                        " ",
                        data.client_name
                    ]
                })
            }),
            token && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-gray-400",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("ul", {
                            className: "list-disc list-inside",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("li", {
                                    children: [
                                        data.answered_count,
                                        lang === "sv" ? " av " : " out of ",
                                        data.nr_feedback_users,
                                        " ",
                                        t("feedback-number-of-feedbacks")
                                    ]
                                }),
                                data.nr_feedback_users > 2 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("li", {
                                    children: t("feedback-is-anonymous")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "border-indigo-700 mt-4"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                children: survey.sections.map(function(section, i) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-2xl mb-4",
                                children: section.names[language]
                            }),
                            section.questions.map(function(question) {
                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-4",
                                    children: formatQuestion(question)
                                }, "question_" + question.questionId);
                            })
                        ]
                    }, "section_" + i);
                })
            }),
            showAlert && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex items-center rounded-md border border-cherry-500 bg-cherry-200 text-indigo-1000 p-4 gap-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                        alt: "Alert",
                        className: "w-6 h-6"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                        children: t("feedback-response-form-alert")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                disabled: surveyNotComplete(),
                onClick: function() {
                    return sendResponses();
                },
                className: "mt-4",
                children: t("submit")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "h-20",
                children: "\xa0"
            })
        ]
    });
};
var $2dc00239332c5354$export$2e2bcd8739ae039 = $2dc00239332c5354$var$SurveyResponse;



var $hwO3w = parcelRequire("hwO3w");

var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");




var $1d964dcdb282656a$exports = {};
$1d964dcdb282656a$exports = $parcel$resolve("7OaPI");










var $6a8ed32f3e75cd70$var$SurveyMultiResponse = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), data = _useState2[0], setData = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), otherSurveys = _useState3[0], setOtherSurveys = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)({
        language: "en",
        languages: [],
        deadline: "",
        answerOptions: 5,
        answerType: 0,
        showNoAnswer: true,
        names: {},
        translations_answers: {},
        sections: []
    }), 2), survey = _useState4[0], setSurvey = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), feedbackRecipients = _useState5[0], setFeedbackRecipients = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), answerOptions = _useState6[0], setAnswerOptions = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showFeedbackSent = _useState7[0], setShowFeedbackSent = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)("en"), 2), language = _useState8[0], setLanguage = _useState8[1];
    var location = (0, $bHX26.useLocation)();
    var queryParams = new URLSearchParams(location.search);
    var token = queryParams.get("token");
    var survey_multi_recipient_id = (0, $bHX26.useParams)().survey_multi_recipient_id;
    // State to store user responses
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showAlert = _useState9[0], setShowAlert = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), selfInfo = _useState10[0], setSelfInfo = _useState10[1];
    var _useState11 = (0, $6iP9u._)((0, $5s1kH.useState)(120), 2), optionColWidth = _useState11[0], setOptionColWidth = _useState11[1];
    var _useState12 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), sectionNr = _useState12[0], setSectionNr = _useState12[1];
    var _useState13 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), narrow = _useState13[0], setNarrow = _useState13[1];
    var _useState14 = (0, $6iP9u._)((0, $5s1kH.useState)(5), 2), answerCols = _useState14[0], setAnswerCols = _useState14[1];
    var nameColWidth = 140;
    var url = "client/survey_multi/" + survey_multi_recipient_id;
    var setDefaultLanguage = function(_survey) {
        if (_survey.languages.indexOf(lang) !== -1) // If browser language is in survey.languages, use that language
        setLanguage(lang);
        else // Else use survey language
        setLanguage(_survey.language);
    };
    var formatAnswerOptions = function(_survey, _language) {
        var _answerOptions = [];
        for(var i = 1; i <= _survey.answerOptions; i++)_answerOptions.push({
            name: _survey.translations_answers[_language][i],
            value: i + ""
        });
        // Do not add noAnswer for self-assessments
        if (_survey.showNoAnswer) _answerOptions.push({
            name: _survey.translations_answers[_language][0],
            value: "0"
        });
        setAnswerOptions(_answerOptions);
    };
    (0, $5s1kH.useEffect)(function() {
        var anonymous = !!token;
        api.get(url, [], anonymous).then(function(response) {
            if (response.json.status === "ok") {
                setData(response.json.data);
                setSurvey(response.json.survey);
                setDefaultLanguage(response.json.survey);
                setFeedbackRecipients(response.json.feedbackRecipients);
                formatAnswerOptions(response.json.survey, language);
            } else {
                setError(response.json.error);
                setData(response.json);
            }
            setOtherSurveys(response.json.otherSurveys);
            setLoading(false);
        }).catch(function(err) {
            alert("An error occurred: " + err);
        });
        window.addEventListener('resize', calculateOptionColWidth);
        return function() {
            window.removeEventListener('resize', calculateOptionColWidth);
        };
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (survey) calculateOptionColWidth();
    }, [
        survey
    ]);
    var calculateOptionColWidth = function() {
        if (survey) {
            var _narrow = window.innerWidth < 925;
            var mainWidth;
            var w;
            var _answerCols;
            if (_narrow) {
                mainWidth = window.innerWidth - 32;
                _answerCols = survey.answerOptions;
                w = mainWidth / _answerCols;
            } else {
                mainWidth = window.innerWidth < 1656 ? window.innerWidth - 112 : 1544;
                _answerCols = survey.answerOptions + 2;
                w = (mainWidth - nameColWidth) / _answerCols;
            }
            // console.log("window width " + window.innerWidth + " main width " + mainWidth + " answerCols " + _answerCols + " col width " + w)
            setOptionColWidth(w);
            setNarrow(_narrow);
            setAnswerCols(_answerCols);
        }
    };
    var sendResponses = function() {
        var anonymous = !!token;
        api.post(url, survey, [], anonymous).then(function(response) {
            if (response.json.status === "ok") setShowFeedbackSent(true);
        });
    };
    var formatError = function() {
        var errorHeader = "Unknown error: " + error;
        var errorBody = lang === "sv" ? "Kontakta support@zebrain.se s\xe5 hj\xe4lper vi dig" : "Contact support@zebrain.se and we will help you";
        if (error === "deadline-passed" || error === "already-submitted") {
            errorHeader = t(error);
            if (token) errorBody = t(error + "-message");
            else errorBody = lang === "sv" ? "Du har redan skickat din feedback" : "You have already submitted your feedback";
        } else if (error === "badToken") errorHeader = lang === "sv" ? "N\xe5got \xe4r konstigt med din token" : "Something is wrong with your token";
        else if (error === "badRecipient") errorHeader = lang === "sv" ? "Du \xe4r inte registrerad mottagare" : "You are not a registered recipient";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-10 main-content",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-col h-full flex-grow min-h-0 gap-6 mt-6",
                children: [
                    error === "deadline-passed" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7e9b9c1a730c7955$exports))),
                        alt: "Calendar X icon",
                        className: "w-12 h-12 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                                className: "z-heading1 text-white text-center",
                                children: errorHeader
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-gray-400 text-center",
                                dangerouslySetInnerHTML: {
                                    __html: errorBody
                                }
                            })
                        ]
                    }),
                    error === "already-submitted" && !token && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "blueBase",
                        className: "mt-4 mx-auto",
                        style: {
                            width: 250
                        },
                        onClick: function() {
                            return navigate("/assessments");
                        },
                        children: lang === "sv" ? "Tillbaka till m\xe4tningar" : "Back to assessments"
                    }),
                    (error === "deadline-passed" || error === "already-submitted") && renderOtherSurveys()
                ]
            })
        });
    };
    var renderOtherSurveys = function() {
        if (otherSurveys.length === 0) return null;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                    className: "font-medium",
                    children: [
                        lang === "sv" ? "Andra feedback-f\xf6rfr\xe5gningar du inte har svarat p\xe5 \xe4n" : "Other feedback requests you have not answered yet",
                        ":"
                    ]
                }),
                otherSurveys.map(function(otherSurvey, index) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between cursor-pointer bg-indigo-900 rounded-md p-4 hover:bg-indigo-800",
                        onClick: function() {
                            return window.location.href = "/feedback/survey/" + otherSurvey.id + "?token=" + otherSurvey.token;
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "w-40 truncate",
                                children: otherSurvey.name
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                className: "w-40 text-gray-400",
                                children: [
                                    "Deadline ",
                                    (0, $7d185b5883a21821$export$3ae94a2503e890a1)(otherSurvey.deadline, false, lang)
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($e8981ef41dc6cb1b$exports))),
                                alt: "Go"
                            })
                        ]
                    }, "other_q_" + index);
                })
            ]
        });
    };
    var renderProgressBar = function() {
        if (survey.sections.length < 2) return null;
        var percent = 100 * (sectionNr + 1) / survey.sections.length + "%";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex items-center gap-x-1 my-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "h-2 bg-indigo-700 rounded-full",
                    style: {
                        width: "calc(100% - 80px)"
                    },
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "h-2 w-full bg-primary-600 rounded-full",
                        style: {
                            width: percent
                        }
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "z-body2",
                    children: [
                        t("step"),
                        " ",
                        sectionNr + 1,
                        " ",
                        t("of"),
                        " ",
                        survey.sections.length
                    ]
                })
            ]
        });
    };
    var renderSelfInfo = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: selfInfo,
            onClose: function() {
                return setSelfInfo(false);
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return setSelfInfo(false);
                    },
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("self-assessment")
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: t("self-assessment-txt1")
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-400 mt-4",
                            children: t("self-assessment-txt2")
                        })
                    ]
                })
            ]
        });
    };
    if (error) return formatError();
    if (showFeedbackSent) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-10 main-content",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex flex-col h-full grow min-h-0 gap-6 mt-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7733e845956e4cc2$exports))),
                    alt: "Badge check icon",
                    className: "w-12 h-12 mx-auto"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                            className: "z-heading1 text-white text-center",
                            children: t("feedback-sent")
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "text-gray-400 text-center",
                                    children: t("thank-you-for-your-feedback")
                                }),
                                renderOtherSurveys()
                            ]
                        })
                    ]
                })
            ]
        })
    });
    if (loading || data === null) return null;
    var updateQuestion = function(questionId, value, what, feedbackNr) {
        var _data = (0, $hwO3w._)({}, data);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // console.log('Setting answer ' + value + ' for questionId ' + questionId + ' person ' + feedbackNr);
            for(var _iterator = survey.sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _section = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = _section.questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _question = _step1.value;
                        if (_question.questionId === questionId) {
                            if (what === "a") {
                                // console.log(_question.questionId + ' === ' + questionId + ' = ' + value);
                                _question.answers[feedbackNr].answer = parseInt(value);
                                var questionComplete = true;
                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                try {
                                    for(var _iterator2 = _question.answers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                        var a = _step2.value;
                                        if (a.answer < 0) {
                                            questionComplete = false;
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                            _iterator2.return();
                                        }
                                    } finally{
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                                _question.answer = questionComplete ? 1 : -1;
                            } else if (what === "text") _question.answers[feedbackNr].freeAnswer = value;
                            else if (what === "showText") {
                                var showFree = _question.answers[feedbackNr].showFreeAnswer;
                                if (showFree) // Only hide free answer if it is empty
                                showFree = _question.answers[feedbackNr].freeAnswer.length > 0;
                                else showFree = true;
                                _question.answers[feedbackNr].showFreeAnswer = showFree;
                            }
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setData(_data);
    };
    var surveyNotComplete = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = survey.sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var section = _step.value;
                try {
                    for(var _iterator1 = section.questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var question = _step1.value;
                        if (question.answer < 0) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return false;
    };
    var sectionNotComplete = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = survey.sections[sectionNr].questions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var question = _step.value;
                if (question.answer < 0) return true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    };
    var formatQuestion = function(question) {
        var questionText = question.names[language];
        if (questionText.startsWith("X ")) questionText = "... " + questionText.substring(2);
        var lastAnswerOption = answerOptions[answerOptions.length - 1];
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 z-badge transparent text-gray-600",
                    children: [
                        lang === "sv" ? "Fr\xe5ga " : "Question ",
                        question.questionNr
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "z-heading2 mt-4 text-neutral-300!",
                    children: questionText
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-6 flex items-end",
                    children: [
                        !narrow && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            style: {
                                width: nameColWidth
                            }
                        }),
                        answerOptions.filter(function(a, i) {
                            return i < answerCols;
                        }).map(function(a, i) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-center z-body2",
                                style: {
                                    width: optionColWidth
                                },
                                children: a.name
                            }, "option_" + i);
                        }),
                        !narrow && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            style: {
                                width: optionColWidth
                            },
                            className: "text-center z-body2",
                            children: lang === 'sv' ? 'Kommentar' : 'Comment'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "mt-1 border-indigo-800",
                    style: {
                        marginLeft: nameColWidth
                    }
                }),
                feedbackRecipients.map(function(fr, feedbackNr) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            narrow && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title2 mb-2",
                                children: fr.name === "self" ? t("you") : fr.name
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    !narrow && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        style: {
                                            width: nameColWidth
                                        },
                                        className: "z-title2",
                                        children: fr.name === "self" ? t("you") : fr.name
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            answerOptions.filter(function(a, i) {
                                                return i < answerCols;
                                            }).map(function(a, i) {
                                                if (a.value === "0" && fr.name === "self") return null;
                                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    style: {
                                                        width: optionColWidth
                                                    },
                                                    className: "px-auto text-center",
                                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                                                        id: question.questionId + i + "_" + feedbackNr,
                                                        value: i + "",
                                                        name: "A " + i,
                                                        label: "",
                                                        justify: "justify-center",
                                                        onChange: function() {
                                                            return updateQuestion(question.questionId, a.value, "a", feedbackNr);
                                                        },
                                                        checked: question.answers[feedbackNr].answer === parseInt(a.value)
                                                    })
                                                }, "a_" + question.questionId + "_" + i + "_" + feedbackNr);
                                            }),
                                            !narrow && fr.name != "self" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                style: {
                                                    width: optionColWidth
                                                },
                                                className: "cursor-pointer text-center",
                                                onClick: function() {
                                                    return updateQuestion(question.questionId, "", "showText", feedbackNr);
                                                },
                                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "mx-auto border border-indigo-700 rounded-full inline-block px-4 py-1" + (question.answers[feedbackNr].showFreeAnswer ? " bg-indigo-700" : ""),
                                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1d964dcdb282656a$exports))),
                                                        alt: "Comment",
                                                        className: "w-6 h-6 mx-auto"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            narrow && fr.name != "self" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mt-4 flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "px-auto text-center",
                                        style: {
                                            marginLeft: optionColWidth / 2 - 16
                                        },
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                                            id: question.questionId + answerCols + "_" + feedbackNr,
                                            value: lastAnswerOption.value + "",
                                            name: "A " + lastAnswerOption.value,
                                            label: lastAnswerOption.name,
                                            justify: "justify-center",
                                            onChange: function() {
                                                return updateQuestion(question.questionId, lastAnswerOption.value, "a", feedbackNr);
                                            },
                                            checked: question.answers[feedbackNr].answer === parseInt(lastAnswerOption.value)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "cursor-pointer",
                                        onClick: function() {
                                            return updateQuestion(question.questionId, "", "showText", feedbackNr);
                                        },
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "flex items-center mx-auto border border-indigo-700 rounded-full px-4 py-1" + (question.answers[feedbackNr].showFreeAnswer ? " bg-indigo-700" : ""),
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1d964dcdb282656a$exports))),
                                                    alt: "Comment",
                                                    className: "w-6 h-6 mx-auto"
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "ml-2",
                                                    children: lang === 'sv' ? 'Kommentar' : 'Comment'
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            question.freeText && question.answers[feedbackNr].showFreeAnswer && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4",
                                style: {
                                    marginLeft: narrow ? 0 : nameColWidth
                                },
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                                    className: "z-input",
                                    value: question.answers[feedbackNr].freeAnswer,
                                    placeholder: "Add context to your rating",
                                    onChange: function(e) {
                                        return updateQuestion(question.questionId, e.target.value, "text", feedbackNr);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                className: "my-4 border-indigo-800"
                            })
                        ]
                    }, "fr_" + fr.clientId + "_" + question.questionId);
                })
            ]
        });
    };
    var changeLanguage = function(l) {
        if (survey.languages.indexOf(l) !== -1) {
            setLanguage(l);
            if (survey) formatAnswerOptions(survey, l);
        }
        if (l === 'en' || l === 'sv') i18n.changeLanguage(l).then();
    };
    var showChangeLanguage = function() {
        if (survey.languages.length < 2 || sectionNr > 0) return null;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                className: "z-select",
                value: language,
                onChange: function(e) {
                    return changeLanguage(e.target.value);
                },
                children: survey.languages.map(function(l, i) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: l,
                        children: (0, $c32e41a1c8ecb8c8$export$10937ee5ed6ee4d1)[l]
                    }, "lang_" + i);
                })
            })
        });
    };
    var thisSection = survey.sections[sectionNr];
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-max",
        children: [
            renderProgressBar(),
            selfInfo && renderSelfInfo(),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                        className: "z-heading1 text-white mt-4",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: t("feedback")
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "ml-2 p-1 flex item-center justify-center cursor-pointer  rounded-[20px] hover:bg-indigo-700",
                                    onClick: function() {
                                        return setSelfInfo(true);
                                    },
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                                        alt: "info"
                                    })
                                })
                            ]
                        })
                    }),
                    showChangeLanguage()
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "text-2xl mb-4",
                            children: thisSection.names[language]
                        }),
                        thisSection.questions.map(function(question) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4",
                                children: formatQuestion(question)
                            }, "question_" + question.questionId);
                        })
                    ]
                })
            }),
            showAlert && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex items-center rounded-md border border-cherry-500 bg-cherry-200 text-indigo-1000 p-4 gap-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                        alt: "Alert",
                        className: "w-6 h-6"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                        children: t("feedback-response-form-alert")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex justify-center gap-x-4 mt-4",
                children: [
                    sectionNr > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        onClick: function() {
                            return setSectionNr(sectionNr - 1);
                        },
                        buttonType: "outlineWhiteBase",
                        style: {
                            width: "unset"
                        },
                        children: t("back")
                    }),
                    sectionNr === survey.sections.length - 1 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        disabled: surveyNotComplete(),
                        onClick: function() {
                            return sendResponses();
                        },
                        style: {
                            width: "unset"
                        },
                        children: t("submit")
                    }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        disabled: sectionNotComplete(),
                        onClick: function() {
                            return setSectionNr(sectionNr + 1);
                        },
                        buttonType: "blueBase",
                        style: {
                            width: "unset"
                        },
                        children: t("next")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "h-20",
                children: "\xa0"
            })
        ]
    });
};
var $6a8ed32f3e75cd70$export$2e2bcd8739ae039 = $6a8ed32f3e75cd70$var$SurveyMultiResponse;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");





var $dUlz9 = parcelRequire("dUlz9");

var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");

var $f3995b418b94841f$exports = {};
$f3995b418b94841f$exports = $parcel$resolve("14gM6");


var $d6cae26bc2c3c1c6$exports = {};
$d6cae26bc2c3c1c6$exports = $parcel$resolve("kvcEu");


var $2a8ab27a1de3dcd8$exports = {};
$2a8ab27a1de3dcd8$exports = $parcel$resolve("1ECe2");



var $1d4bf47bd59fb3d3$exports = {};
$1d4bf47bd59fb3d3$exports = $parcel$resolve("dUPPd");




parcelRequire("5s1kH");
var $d1c28afbe50d3cf6$var$HealthBadge = function(props) {
    var texts = props.lang === 'sv' ? [
        'Svag',
        "M\xe5ttlig",
        'Stark',
        "Utm\xe4rkt"
    ] : [
        'Poor',
        'Moderate',
        'Good',
        'Excellent'
    ];
    var borders = [
        '#A74338',
        '#864804',
        '#38471E',
        '#38471E',
        '#3E3E76'
    ];
    var colors = [
        'bg-peach-200',
        'bg-orange-200',
        'bg-lime-200',
        'bg-lime-400',
        'indigo-600'
    ];
    var pos = 0;
    if (props.level !== undefined) pos = props.level;
    else {
        if (props.value >= 0.9) pos = 3;
        else if (props.value >= 0.75) pos = 2;
        else if (props.value >= 0.55) pos = 1;
    }
    var blocks = [
        0,
        1,
        2,
        3
    ];
    var visibleBlocks = blocks.filter(function(b) {
        return b <= pos;
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "flex items-center",
        children: [
            !props.isResultInfoModal && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                children: texts[pos]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex ml-2",
                style: {
                    borderRadius: "9px",
                    width: 64
                },
                children: blocks.map(function(block) {
                    var style = {
                        borderRadius: "",
                        borderRight: "",
                        border: ""
                    };
                    if (block === 0) style['borderRadius'] = "12px 0 0 12px";
                    else if (block === 3) style['borderRadius'] = "0 12px 12px 0";
                    style['border'] = "1px solid " + borders[visibleBlocks.includes(block) ? pos : 4];
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        style: style,
                        className: "h-4 w-4 " + colors[visibleBlocks.includes(block) ? pos : 4]
                    }, "health_" + block);
                })
            }),
            props.isResultInfoModal && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "ml-2",
                children: texts[pos]
            })
        ]
    });
};
var $d1c28afbe50d3cf6$export$2e2bcd8739ae039 = $d1c28afbe50d3cf6$var$HealthBadge;






var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");






var $e6216af23466c81b$var$ResultInfoModalExpant = function(props) {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = i18n.language;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        children: props.id === 1 ? // Self-assessment and feedback
        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "text-sm",
                    children: t("self-assessment-and-feedback-description")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 0.89,
                            type: "score",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("self-assessment-and-feedback-excellent-note")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 0.77,
                            type: "score",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("self-assessment-and-feedback-high-note")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 0.61,
                            type: "score",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("self-assessment-and-feedback-moderate-note")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 0.5,
                            type: "score",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("self-assessment-and-feedback-low-note")
                        })
                    ]
                })
            ]
        }) : props.id === 2 ? // Perception gap
        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "text-sm",
                    children: t("perception-gap-description-description")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 0,
                            type: "gap",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("perception-gap-description-healthy")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 0.5,
                            type: "gap",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("perception-gap-description-balanced")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 0.9,
                            type: "gap",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("perception-gap-description-moderate")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 1.3,
                            type: "gap",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("perception-gap-description-significan")
                        })
                    ]
                })
            ]
        }) : props.id === 3 ? // Feedback alignment
        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "text-sm",
                    children: t("feedback-alignment-description")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 0.76,
                            type: "feedback_alignment",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("feedback-alignment-healthy")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 0.51,
                            type: "feedback_alignment",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("feedback-alignment-balanced")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 0.26,
                            type: "feedback_alignment",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("feedback-alignment-moderate")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 0.0,
                            type: "feedback_alignment",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("feedback-alignment-low")
                        })
                    ]
                })
            ]
        }) : props.id === 4 ? // Focus Area Health
        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "text-sm",
                    children: t("focus-area-health-description")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $d1c28afbe50d3cf6$export$2e2bcd8739ae039), {
                            value: 0.9,
                            lang: lang,
                            isResultInfoModal: true
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("focus-area-health-excellent")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $d1c28afbe50d3cf6$export$2e2bcd8739ae039), {
                            value: 0.75,
                            lang: lang,
                            isResultInfoModal: true
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("focus-area-health-good")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $d1c28afbe50d3cf6$export$2e2bcd8739ae039), {
                            value: 0.55,
                            lang: lang,
                            isResultInfoModal: true
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("focus-area-health-moderate")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $d1c28afbe50d3cf6$export$2e2bcd8739ae039), {
                            value: 0.0,
                            lang: lang,
                            isResultInfoModal: true
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("focus-area-health-poor")
                        })
                    ]
                })
            ]
        }) : // Assessment question interpretation
        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "text-sm",
                    children: t("assessment-question-interpretation-description")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 4,
                            type: "validated",
                            lang: lang,
                            value2: 4
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("assessment-question-interpretation-validated-strength")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 3,
                            type: "validated",
                            lang: lang,
                            value2: 4
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("assessment-question-interpretation-hidden-strength")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 4,
                            type: "validated",
                            lang: lang,
                            value2: 3
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("assessment-question-interpretation-blind-spot")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                            value: 3,
                            type: "validated",
                            lang: lang,
                            value2: 3
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("assessment-question-interpretation-growth-priority")
                        })
                    ]
                })
            ]
        })
    });
};
var $e6216af23466c81b$export$2e2bcd8739ae039 = $e6216af23466c81b$var$ResultInfoModalExpant;



var $87f855ec55c62abb$var$ResultInfoModal = function(props) {
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), open = _useState[0], setOpen = _useState[1];
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var resultModelData = [
        {
            id: 1,
            title: t("self-assessment-and-feedback-title"),
            component: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e6216af23466c81b$export$2e2bcd8739ae039), {
                id: 1
            })
        },
        {
            id: 2,
            title: t("perception-gap-title"),
            component: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e6216af23466c81b$export$2e2bcd8739ae039), {
                id: 2
            })
        },
        {
            id: 3,
            title: t("feedback-alignment-title"),
            component: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e6216af23466c81b$export$2e2bcd8739ae039), {
                id: 3
            })
        },
        {
            id: 4,
            title: t("focus-area-health-title"),
            component: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e6216af23466c81b$export$2e2bcd8739ae039), {
                id: 4
            })
        },
        {
            id: 5,
            title: t("assessment-question-interpretation-title"),
            component: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e6216af23466c81b$export$2e2bcd8739ae039), {
                id: 5
            })
        }
    ];
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: true,
        onClose: props.close,
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: props.close,
                children: t("report-info-model-title")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: resultModelData.map(function(item) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "rounded-[6px] border border-indigo-700 p-4 gap-3 mb-4 cursor-pointer",
                        onClick: function() {
                            return setOpen(open === item.id ? 0 : item.id);
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex justify-between",
                                style: {
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-title3 gray-100",
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f3995b418b94841f$exports))),
                                        alt: "toggle",
                                        className: "h-4 w-4 cursor-pointer hover:bg-indigo-700 rounded-[12px]" + (open === item.id ? " rotate-180" : "")
                                    })
                                ]
                            }),
                            open === item.id && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-2 gray-100",
                                children: item.component
                            })
                        ]
                    }, item.id);
                })
            })
        ]
    });
};
var $87f855ec55c62abb$export$2e2bcd8739ae039 = $87f855ec55c62abb$var$ResultInfoModal;




var $b0c116e0059d432e$export$c28e26439ac8e792 = function(language, question, name) {
    var questionName = question.translationsName[language];
    if (questionName) {
        if (questionName.startsWith("X ")) return name + questionName.substring(1);
        else return questionName;
    }
    return question.name;
};
var $b0c116e0059d432e$export$fa9277fc57deeba7 = function(language, area) {
    if (area) {
        var sectionName = area.translationsName[language];
        if (sectionName) return sectionName;
        return area.name;
    }
    return "N/A";
};



var $9a78a44f167ac0b7$export$e61945531e624529 = function(answerOptions) {
    if (answerOptions === 10) return 8;
    else if (answerOptions === 7) return 6;
    else if (answerOptions === 3) return 2;
    else return 4;
};


var $a960deaed26699f8$var$ArrayName = /*#__PURE__*/ function(ArrayName) {
    ArrayName[ArrayName["QUESTION"] = 0] = "QUESTION";
    ArrayName[ArrayName["GOOD"] = 1] = "GOOD";
    ArrayName[ArrayName["BAD"] = 2] = "BAD";
    return ArrayName;
}($a960deaed26699f8$var$ArrayName || {});
var $a960deaed26699f8$var$SurveyResultSummary = function(param) {
    var allQuestions = param.allQuestions, surveyResult = param.surveyResult, aiInsights = param.aiInsights, lang = param.lang, setFocusAreasSorted = param.setFocusAreasSorted, surveyId = param.surveyId, otherRequests = param.otherRequests, canCreateRequest = param.canCreateRequest, feedbackType = param.feedbackType, t = param.t, clientName = param.clientName;
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showValidatedStrength = _useState[0], setShowValidatedStrength = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showHiddenStrength = _useState1[0], setShowHiddenStrength = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showBlindSpot = _useState2[0], setShowBlindSpot = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showGrowth = _useState3[0], setShowGrowth = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showInfoModal = _useState4[0], setShowInfoModal = _useState4[1];
    var hasTopHealth = surveyResult.focusAreas.filter(function(f) {
        return f.healthLevel >= 2;
    }).length;
    var hasImprovementHealth = surveyResult.focusAreas.filter(function(f) {
        return f.healthLevel < 2;
    }).length;
    // +Show more
    var SHOW_MORE_INCREMENT = 3;
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(SHOW_MORE_INCREMENT), 2), visibleCount = _useState5[0], setVisibleCount = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(SHOW_MORE_INCREMENT), 2), showMoreBadCount = _useState6[0], setShowMoreBadCount = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(SHOW_MORE_INCREMENT), 2), showMoreGoodCount = _useState7[0], setShowMoreGoodCount = _useState7[1];
    var _obj;
    var setterShowMoreMap = (_obj = {}, (0, $dUlz9._)(_obj, 0, setVisibleCount), (0, $dUlz9._)(_obj, 1, setShowMoreGoodCount), (0, $dUlz9._)(_obj, 2, setShowMoreBadCount), _obj);
    var splitLongText = function(txt, part) {
        var chars = txt.length;
        var pos = chars / 2;
        while(pos < chars){
            if (txt.charAt(pos) === ".") {
                if (part === 0) return txt.substring(0, pos + 1);
                else return txt.substring(pos + 1);
            }
            pos++;
        }
        // Catcher in the rye - found no '.'
        if (part === 0) return txt;
    };
    var normalizeFromZeroToOne = function(value, min, max) {
        // From 0-1 to min-max
        return value * (max - min) + min;
    };
    var handleShowMore = function(islimt, arrayName) {
        console.log('Change show more counter');
        setterShowMoreMap[arrayName](islimt ? 3 : function(prev) {
            return prev + 3;
        });
    };
    var renderQuestion = function(question, badgeText, cls) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-2 bg-indigo-800 rounded-md p-4 border-indigo-700 border",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: cls,
                            children: badgeText
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "ml-2 z-badge transparent truncate sm:truncate-none",
                            children: (0, $b0c116e0059d432e$export$fa9277fc57deeba7)(lang, question.focusArea)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-col md:flex-row mt-2 gap-4",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex-1 text-gray-300",
                            children: (0, $b0c116e0059d432e$export$c28e26439ac8e792)(lang, question, clientName)
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $200b3872b8c265f8$export$2e2bcd8739ae039), {
                                    value1: question.scoreSelf,
                                    value2: question.scoreOther,
                                    max: surveyResult.nrAnswerOptions,
                                    size: "small"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "mt-2 hidden md:flex",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "text-sm",
                                            children: [
                                                t("self-assessment"),
                                                ": ",
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                    className: "z-title2",
                                                    children: question.scoreSelf.toFixed(1)
                                                }),
                                                "/",
                                                surveyResult.nrAnswerOptions
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "ml-4 text-sm",
                                            children: [
                                                "Feedback: ",
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                    className: "z-title2",
                                                    children: feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF ? "-" : question.scoreOther.toFixed(1)
                                                }),
                                                "/",
                                                surveyResult.nrAnswerOptions
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "ml-4 text-sm",
                                            children: [
                                                t("perception-gap"),
                                                ": ",
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                    className: "z-title2",
                                                    children: feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF ? "-" : Math.abs(question.scoreOther - question.scoreSelf).toFixed(1)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }, "sq_" + question.id);
    };
    var renderQuestions = function(type) {
        var _questions;
        var badgeText = "Unknown";
        var colorVal;
        if (type === 'validated_strengths') {
            colorVal = 4;
            if (feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF) {
                badgeText = lang === "sv" ? "Styrka" : "Strength";
                _questions = allQuestions.filter(function(q) {
                    return q.scoreSelf >= 4;
                }).sort(function(a, b) {
                    return a.scoreSelf < b.scoreSelf ? 1 : -1;
                });
            } else {
                badgeText = lang === "sv" ? "Validerad styrka" : "Validated strength";
                _questions = allQuestions.filter(function(q) {
                    return q.scoreSelf >= 4 && q.scoreOther >= 4;
                }).sort(function(a, b) {
                    return a.scoreOther < b.scoreOther ? 1 : -1;
                });
            }
        } else if (type === 'hidden_strengths') {
            badgeText = lang === "sv" ? "Dold styrka" : "Hidden strength";
            colorVal = 3;
            _questions = allQuestions.filter(function(q) {
                return q.scoreSelf < 4 && q.scoreOther >= 4;
            }).sort(function(a, b) {
                return a.scoreOther < b.scoreOther ? 1 : -1;
            });
        } else if (type === 'blind_spots') {
            badgeText = lang === "sv" ? "Blinda f\xe4lt" : "Blind Spot";
            colorVal = 2;
            _questions = allQuestions.filter(function(q) {
                return q.scoreSelf >= 4 && q.scoreOther < 4;
            }).sort(function(a, b) {
                return a.scoreOther > b.scoreOther ? 1 : -1;
            });
        } else if (type === 'growth_priorities') {
            badgeText = lang === "sv" ? "Utvecklingsfokus" : "Growth priority";
            colorVal = 1;
            _questions = allQuestions.filter(function(q) {
                return q.scoreSelf < 4 && q.scoreOther < 4;
            }).sort(function(a, b) {
                return a.scoreOther > b.scoreOther ? 1 : -1;
            });
        } else _questions = [];
        var cls = colorVal ? "z-badge truncate sm:truncate-none zb-".concat(colorVal) : "z-badge truncate sm:truncate-none";
        var isShowingAll = visibleCount >= _questions.length;
        if (_questions.length === 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                "There are no ",
                badgeText
            ]
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                _questions.slice(0, visibleCount).map(function(question) {
                    return renderQuestion(question, badgeText, cls);
                }),
                _questions.length > 3 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "transparentBase",
                    className: "mt-4 mx-auto cursor-pointer",
                    size: "sm",
                    onClick: function() {
                        return handleShowMore(isShowingAll, 0);
                    },
                    leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: isShowingAll ? (0, (/*@__PURE__*/$parcel$interopDefault($1d4bf47bd59fb3d3$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($8035c9bf788700b7$exports))),
                        alt: "info"
                    }),
                    style: {
                        width: "unset"
                    },
                    children: isShowingAll ? t("btn-show-less") : t("btn-show-more")
                })
            ]
        });
    };
    var showTopHealthFocusAreas = function(hasAreas) {
        var validatedStrengths = 0;
        var hiddenStrengths = 0;
        var _goodScore = (0, $9a78a44f167ac0b7$export$e61945531e624529)(surveyResult.nrAnswerOptions);
        var goodArea = surveyResult.focusAreas.sort(function(a, b) {
            if (a.healthLevel !== b.healthLevel) return a.healthLevel < b.healthLevel ? 1 : -1;
            return a.health < b.health ? 1 : -1;
        }).filter(function(f) {
            return f.healthLevel >= 2;
        });
        var isShowMoreGood = showMoreGoodCount >= goodArea.length;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = surveyResult.focusAreas[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var focusArea = _step.value;
                try {
                    for(var _iterator1 = focusArea.questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var q = _step1.value;
                        if (feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF) {
                            if (q.scoreSelf >= _goodScore) validatedStrengths += 1;
                        } else if (q.scoreOther >= _goodScore) {
                            if (q.scoreSelf >= _goodScore) validatedStrengths += 1;
                            else hiddenStrengths += 1;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (validatedStrengths === 0 && hiddenStrengths === 0 && hasAreas === 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d6cae26bc2c3c1c6$exports))),
                    alt: "star",
                    className: "mt-4 h-6 w-6 mx-auto"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mx-auto mt-4 mb-4 w-full max-w-sm px-4 text-center text-gray-400",
                    children: lang === "sv" ? "Inga styrkor identifierades i den h\xe4r feedbackomg\xe5ngen, vilket pekar p\xe5 ett behov av att reflektera och aktivt arbeta med din utveckling." : "No strengths were identified in this feedback round, indicating a need to reflect and actively work on your development."
                })
            ]
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-8 font-medium text-gray-100",
                            children: lang === "sv" ? "Insikter" : "Insights"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-400 mt-1 whitespace-pre-line",
                            children: aiInsights.strengths
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "font-medium mt-4",
                    children: lang === "sv" ? "Fr\xe4msta omr\xe5den" : "Top Areas"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-400",
                    children: hasAreas === 0 ? lang === "sv" ? "Inget omr\xe5de har n\xe5tt till niv\xe5n god eller utm\xe4rkt." : "No Areas reached strong overall levels." : lang === "sv" ? "Visar omr\xe5den med god eller utm\xe4rkt status" : "Showing Areas with Excellent or Good Health levels."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 flex flex-wrap gap-2",
                    children: goodArea.slice(0, showMoreGoodCount).map(function(focusArea, i) {
                        var aiFocusArea = findAiFocusArea(focusArea.id);
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "bg-indigo-800 rounded-[6px] p-4 main-third-col border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex justify-between md:flex-row md:justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                            children: (0, $b0c116e0059d432e$export$fa9277fc57deeba7)(lang, focusArea)
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $d1c28afbe50d3cf6$export$2e2bcd8739ae039), {
                                            value: focusArea.health,
                                            level: focusArea.healthLevel,
                                            lang: lang
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $200b3872b8c265f8$export$2e2bcd8739ae039), {
                                        value1: focusArea.scoreSelf,
                                        value2: focusArea.scoreOther,
                                        max: surveyResult.nrAnswerOptions,
                                        results1: focusArea.scoreSelf.toFixed(1) + "/" + surveyResult.nrAnswerOptions,
                                        results2: focusArea.scoreOther.toFixed(1) + "/" + surveyResult.nrAnswerOptions
                                    })
                                }),
                                aiFocusArea && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-3 text-sm text-gray-400",
                                    children: aiFocusArea.summary
                                })
                            ]
                        }, "top_health_" + i);
                    })
                }),
                surveyResult.focusAreas.filter(function(f) {
                    return f.healthLevel >= 2;
                }).length > 3 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "transparentBase",
                    className: "mt-4 mx-auto cursor-pointer",
                    size: "sm",
                    onClick: function() {
                        return handleShowMore(isShowMoreGood, 1);
                    },
                    leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: isShowMoreGood ? (0, (/*@__PURE__*/$parcel$interopDefault($1d4bf47bd59fb3d3$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($8035c9bf788700b7$exports))),
                        alt: "info"
                    }),
                    style: {
                        width: "unset"
                    },
                    children: isShowMoreGood ? t("btn-show-less") : t("btn-show-more")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "border-indigo-700 my-4"
                }),
                validatedStrengths > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex justify-between items-center cursor-pointer",
                            onClick: function() {
                                setVisibleCount(SHOW_MORE_INCREMENT);
                                setShowValidatedStrength(!showValidatedStrength);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    children: [
                                        t("validated-strengths"),
                                        " (",
                                        validatedStrengths,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f3995b418b94841f$exports))),
                                    alt: "open",
                                    className: "h-4 w-4 hover:bg-indigo-700 rounded-[12px]" + (showValidatedStrength ? " rotate-180" : "")
                                })
                            ]
                        }),
                        showValidatedStrength && renderQuestions('validated_strengths'),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "border-indigo-700 my-4"
                        })
                    ]
                }),
                hiddenStrengths > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex justify-between items-center cursor-pointer",
                            onClick: function() {
                                setVisibleCount(SHOW_MORE_INCREMENT);
                                setShowHiddenStrength(!showHiddenStrength);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    children: [
                                        t("hidden-strengths"),
                                        " (",
                                        hiddenStrengths,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f3995b418b94841f$exports))),
                                    alt: "open",
                                    className: "h-4 w-4 hover:bg-indigo-700 rounded-[12px]" + (showHiddenStrength ? " rotate-180" : "")
                                })
                            ]
                        }),
                        showHiddenStrength && renderQuestions('hidden_strengths'),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "border-indigo-700 mt-4"
                        })
                    ]
                })
            ]
        });
    };
    var findAiFocusArea = function(focusAreaId) {
        if (!aiInsights.focusAreas) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = aiInsights.focusAreas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var fa = _step.value;
                if (fa.id === focusAreaId) return fa;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var showTopImprovementFocusAreas = function(hasAreas) {
        var blindSpots = 0;
        var growthPriorities = 0;
        var _goodScore = (0, $9a78a44f167ac0b7$export$e61945531e624529)(surveyResult.nrAnswerOptions);
        var badArea = surveyResult.focusAreas.sort(function(a, b) {
            if (a.healthLevel !== b.healthLevel) return a.healthLevel < b.healthLevel ? -1 : 1;
            return a.health < b.health ? -1 : 1;
        }).filter(function(f) {
            return f.healthLevel < 2;
        });
        var isShowMoreBad = showMoreBadCount >= badArea.length;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = surveyResult.focusAreas[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var focusArea = _step.value;
                try {
                    for(var _iterator1 = focusArea.questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var q = _step1.value;
                        if (feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF) {
                            if (q.scoreSelf < _goodScore) growthPriorities += 1;
                        } else if (q.scoreOther < _goodScore) {
                            if (q.scoreSelf < _goodScore) growthPriorities += 1;
                            else blindSpots += 1;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (hasAreas === 0 && blindSpots === 0 && growthPriorities === 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2a8ab27a1de3dcd8$exports))),
                    alt: "star",
                    className: "mt-4 h-6 w-6 mx-auto"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mx-auto mt-4 w-90 text-center text-gray-400",
                    children: lang === "sv" ? "Starkt jobbat! Inga svagheter identifierades i den h\xe4r feedbacken. H\xe5ll i det som fungerar och forts\xe4tt v\xe4ssa dina styrkor." : "Great work! No weaknesses were identified in this round of feedback! Keep doing what works and continue sharpening your strengths."
                })
            ]
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-8 font-medium text-gray-100",
                            children: lang === "sv" ? "Insikter" : "Insights"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-400 mt-1 whitespace-pre-line",
                            children: aiInsights.improvements
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "font-medium mt-4",
                    children: lang === "sv" ? "Omr\xe5den med utvecklingspotential" : "Areas with improvement potential"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-400",
                    children: hasAreas === 0 ? lang === "sv" ? "Inga svaga omr\xe5den identifierade." : "No weak areas identified." : lang === "sv" ? "Visar omr\xe5den med svag eller m\xe5ttlig status" : "Showing Areas with Poor or Moderate Health levels."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 flex flex-wrap gap-2",
                    children: badArea.slice(0, showMoreBadCount).map(function(focusArea, i) {
                        var aiFocusArea = findAiFocusArea(focusArea.id);
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "bg-indigo-800 rounded-[6px] p-4 main-third-col border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex flex-wrap items-start",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "flex-1",
                                            children: (0, $b0c116e0059d432e$export$fa9277fc57deeba7)(lang, focusArea)
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "flex items-center ml-4",
                                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $d1c28afbe50d3cf6$export$2e2bcd8739ae039), {
                                                value: focusArea.health,
                                                level: focusArea.healthLevel,
                                                lang: lang
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $200b3872b8c265f8$export$2e2bcd8739ae039), {
                                        value1: focusArea.scoreSelf,
                                        value2: focusArea.scoreOther,
                                        max: surveyResult.nrAnswerOptions,
                                        results1: focusArea.scoreSelf.toFixed(1) + "/" + surveyResult.nrAnswerOptions,
                                        results2: focusArea.scoreOther.toFixed(1) + "/" + surveyResult.nrAnswerOptions
                                    })
                                }),
                                aiFocusArea && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-3 text-sm text-gray-400",
                                    children: aiFocusArea.summary
                                })
                            ]
                        }, "top_health_" + i);
                    })
                }),
                surveyResult.focusAreas.filter(function(f) {
                    return f.healthLevel < 2;
                }).length > 3 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "transparentBase",
                    className: "mt-4 mx-auto cursor-pointer",
                    size: "sm",
                    onClick: function() {
                        return handleShowMore(isShowMoreBad, 2);
                    },
                    leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: isShowMoreBad ? (0, (/*@__PURE__*/$parcel$interopDefault($1d4bf47bd59fb3d3$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($8035c9bf788700b7$exports))),
                        alt: "info"
                    }),
                    style: {
                        width: "unset"
                    },
                    children: isShowMoreBad ? t("btn-show-less") : t("btn-show-more")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "border-indigo-700 my-4"
                }),
                blindSpots > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex justify-between items-center cursor-pointer",
                            onClick: function() {
                                setShowBlindSpot(!showBlindSpot);
                                setVisibleCount(SHOW_MORE_INCREMENT);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    children: [
                                        t("blind-spots"),
                                        " (",
                                        blindSpots,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f3995b418b94841f$exports))),
                                    alt: "open",
                                    className: "h-4 w-4 hover:bg-indigo-700 rounded-[12px]" + (showBlindSpot ? " rotate-180" : "")
                                })
                            ]
                        }),
                        showBlindSpot && renderQuestions('blind_spots'),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "border-indigo-700 my-4"
                        })
                    ]
                }),
                growthPriorities > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex justify-between items-center cursor-pointer",
                            onClick: function() {
                                setShowGrowth(!showGrowth);
                                setVisibleCount(SHOW_MORE_INCREMENT);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    children: [
                                        t("growth-priorities"),
                                        " (",
                                        growthPriorities,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f3995b418b94841f$exports))),
                                    alt: "open",
                                    className: "h-4 w-4 hover:bg-indigo-700 rounded-[12px]" + (showGrowth ? " rotate-180" : "")
                                })
                            ]
                        }),
                        showGrowth && renderQuestions('growth_priorities'),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                            className: "border-indigo-700 mt-4"
                        })
                    ]
                })
            ]
        });
    };
    var createFeedbackRequest = function(surveyId) {
        api.post("client/survey_request/create", {
            survey_id: surveyId
        }).then(function(response) {
            if (response.json.status === "ok") navigate("/feedback/survey/" + response.json.surveyRequestId);
            else alert("Error");
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex justify-between items-center mt-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "z-heading1",
                                children: [
                                    (0, $c32e41a1c8ecb8c8$export$8f43a8af11ed514a)(lang, surveyResult.categoryNameSv, surveyResult.categoryName),
                                    " ",
                                    t("insights-report")
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "ml-2 p-1 flex item-center justify-center cursor-pointer  rounded-[20px] hover:bg-indigo-700",
                                onClick: function() {
                                    setVisibleCount(SHOW_MORE_INCREMENT);
                                    setShowInfoModal(!showInfoModal);
                                },
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                                    alt: "info",
                                    className: "h-6 w-6 coursor-pointer"
                                })
                            }),
                            otherRequests.length > 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                                    className: "ml-4 z-select small",
                                    onChange: function(e) {
                                        return navigate("/dev-plan/survey/result/" + e.target.value + "/summary");
                                    },
                                    children: otherRequests.map(function(or) {
                                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                            value: or.id,
                                            children: or.date
                                        }, "o_" + or.id);
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        size: "sm",
                        disabled: !canCreateRequest,
                        onClick: function() {
                            return createFeedbackRequest(surveyId);
                        },
                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8035c9bf788700b7$exports))),
                            alt: "info",
                            className: "h-4 w-4"
                        }),
                        style: {
                            width: "unset"
                        },
                        children: lang === "sv" ? "Ny m\xe4tning" : "New assessment"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 bg-indigo-900 p-4 rounded-md border-indigo-800 border",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "z-title1",
                                children: [
                                    (0, $c32e41a1c8ecb8c8$export$8f43a8af11ed514a)(lang, surveyResult.categoryNameSv, surveyResult.categoryName),
                                    "\xa0",
                                    lang === "sv" ? "\xf6versikt" : "snapshot"
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-badge large transparent cursor-pointer hover:bg-indigo-700 hover:text-white hover:border-indigo-700",
                                onClick: function() {
                                    return setFocusAreasSorted("health_high");
                                },
                                children: t("see-full-result")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2 text-gray-400",
                        children: [
                            lang === "sv" ? "Resultatet baseras p\xe5 " : "Summarized results based on ",
                            surveyResult.focusAreas.length,
                            " ",
                            lang === "sv" ? "omr\xe5den (maximalt betyg per omr\xe5de" : "Areas (maximum score per area",
                            ": ",
                            surveyResult.nrAnswerOptions,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "main-half-col mt-8 text-center",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "mx-auto",
                                    style: {
                                        width: 306
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $529a09584460bde6$export$2e2bcd8739ae039), {
                                            value1: surveyResult.scoreSelf,
                                            value2: surveyResult.scoreOther,
                                            maxValue: surveyResult.nrAnswerOptions * surveyResult.focusAreas.length,
                                            circleNumbers: true,
                                            type: "focus_area"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "mt-6 flex items-center justify-center",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "h-4 w-4 rounded-full bg-peach-500"
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "text-sm ml-2",
                                                    children: t("self-assessment")
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "h-4 w-4 rounded-full bg-peach-300 ml-4"
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "text-sm ml-2",
                                                    children: "Feedback"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "main-half-col mt-8",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "bg-indigo-800 p-4 rounded-[4px] border-indigo-700 border-1",
                                        children: [
                                            feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "mb-2",
                                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                                                    lang: lang,
                                                    value: surveyResult.scoreSelf / (surveyResult.nrAnswerOptions * surveyResult.focusAreas.length),
                                                    type: "score"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                        children: t("self-assessment")
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                                className: "z-heading1",
                                                                children: surveyResult.scoreSelf.toFixed(1)
                                                            }),
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                                className: "font-medium",
                                                                children: [
                                                                    "/",
                                                                    (surveyResult.nrAnswerOptions * surveyResult.focusAreas.length).toFixed(0)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "bg-indigo-800 mt-2 bg-indigo-700 p-4 rounded-[4px] border-indigo-700 border-1",
                                        children: [
                                            feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "mb-2",
                                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                                                    lang: lang,
                                                    value: surveyResult.scoreOther / (surveyResult.nrAnswerOptions * surveyResult.focusAreas.length),
                                                    type: "score"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                        children: "Feedback"
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                                className: "z-heading1",
                                                                children: feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF ? "-" : surveyResult.scoreOther.toFixed(1)
                                                            }),
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                                className: "font-medium",
                                                                children: [
                                                                    "/",
                                                                    (surveyResult.nrAnswerOptions * surveyResult.focusAreas.length).toFixed(0)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "bg-indigo-800 mt-2 bg-indigo-700 p-4 rounded-[4px] border-indigo-700 border-1",
                                        children: [
                                            feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "mb-2",
                                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                                                    lang: lang,
                                                    value: Math.abs(surveyResult.scoreSelf - surveyResult.scoreOther) / surveyResult.focusAreas.length,
                                                    type: "gap"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                        children: t("perception-gap")
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                        className: "z-heading1",
                                                        children: feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF ? "-" : Math.abs(surveyResult.scoreSelf - surveyResult.scoreOther).toFixed(1)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "bg-indigo-800 p-4 rounded-[4px] mt-2 bg-indigo-700 p-4 rounded-[4px] border-indigo-700 border-1",
                                        children: [
                                            feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "mb-2",
                                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                                                    lang: lang,
                                                    value: surveyResult.spreadRespondentsNormalized,
                                                    type: "feedback_alignment"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                        children: t("feedback-alignment")
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                        className: "z-heading1",
                                                        children: [
                                                            feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF ? "-" : normalizeFromZeroToOne(surveyResult.spreadRespondentsNormalized, 1, surveyResult.nrAnswerOptions).toFixed(1),
                                                            "/",
                                                            surveyResult.nrAnswerOptions
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 bg-indigo-900 p-4 rounded-[6px] border-indigo-800 border-1",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "z-title1",
                        children: t("summary")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex flex-wrap mt-2 gap-y-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "main-half-col pr-4",
                                children: splitLongText(aiInsights.summary, 0)
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "main-half-col",
                                children: splitLongText(aiInsights.summary, 1)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 bg-indigo-900 p-4 rounded-[6px] border-indigo-800 border-1",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title1",
                                children: t("strengths")
                            }),
                            hasTopHealth > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-badge large transparent cursor-pointer  hover:bg-indigo-700 hover:text-white hover:border-indigo-700",
                                onClick: function() {
                                    return setFocusAreasSorted("health_high");
                                },
                                children: t("see-full-result")
                            })
                        ]
                    }),
                    showTopHealthFocusAreas(hasTopHealth)
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 bg-indigo-900 p-4 rounded-[6px] border-indigo-800 border-1",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title1",
                                children: lang === "sv" ? "Utvecklingspotential" : "Improvement potential"
                            }),
                            hasImprovementHealth > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-badge large transparent cursor-pointer  hover:bg-indigo-700 hover:text-white hover:border-indigo-700",
                                onClick: function() {
                                    return setFocusAreasSorted("health_high");
                                },
                                children: t("see-full-result")
                            })
                        ]
                    }),
                    showTopImprovementFocusAreas(hasImprovementHealth)
                ]
            }),
            showInfoModal && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $87f855ec55c62abb$export$2e2bcd8739ae039), {
                close: function() {
                    return setShowInfoModal(false);
                }
            })
        ]
    });
};
var $a960deaed26699f8$export$2e2bcd8739ae039 = $a960deaed26699f8$var$SurveyResultSummary;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");







var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");







parcelRequire("5s1kH");
var $c1a8091d960f1c28$var$QuestionBadge = function(props) {
    var cls = "rounded-full border mb-2 mr-2 border-indigo-700 px-3 py-1 z-title3  cursor-pointer hover:bg-indigo-700 text-center";
    if (props.selectedId === props.id) cls += " bg-indigo-700";
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        onClick: function() {
            return props.clickId(props.id);
        },
        className: cls,
        style: {
            minWidth: 92
        },
        children: props.text
    });
};
var $c1a8091d960f1c28$export$2e2bcd8739ae039 = $c1a8091d960f1c28$var$QuestionBadge;






var $847f86c5796e8d1c$var$SurveyQuestionsResult = function(props) {
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)("all"), 2), viewQuestion = _useState[0], setViewQuestion = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), answerOptions = _useState1[0], setAnswerOptions = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), noAnswerInfo = _useState2[0], setNoAnswerInfo = _useState2[1];
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t;
    (0, $5s1kH.useEffect)(function() {
        setAnswerOptions(calculateAnswerOptions());
    }, [
        props.lang
    ]);
    var calculateAnswerOptions = function() {
        var selectedLang = props.lang;
        if (props.surveyResult.languages.indexOf(props.lang) === -1) selectedLang = props.surveyResult.languages[0];
        return props.surveyResult.answerOptions[selectedLang];
    };
    var findQuestion = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = props.questions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var question = _step.value;
                if (question.id === viewQuestion) return question;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    var validatedText = function(scoreSelf, scoreOther) {
        if (scoreOther >= 4) {
            if (scoreSelf >= 4) return t("assessment-question-interpretation-validated-strength");
            else return t("assessment-question-interpretation-hidden-strength");
        } else {
            if (scoreSelf >= 4) return t("assessment-question-interpretation-blind-spot");
            else return t("assessment-question-interpretation-growth-priority");
        }
    };
    var spreadText = function(spread) {
        if (spread >= 0.7) return t("feedback-alignment-healthy");
        else if (spread >= 0.4) return t("feedback-alignment-balanced");
        else if (spread >= 0.1) return t("feedback-alignment-moderate");
        else if (spread >= 0) return t("feedback-alignment-low");
        else return "N/A (too few responses)";
    };
    var renderQuestions = function() {
        if (viewQuestion === "all") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: props.questions.map(function(question, i) {
                var badgeType = props.feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF ? "self_only" : "validated";
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "bg-indigo-800 rounded-[6px] p-4 mt-4 border-indigo-700 border-1",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex gap-x-4",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "z-badge transparent",
                                    children: [
                                        "#",
                                        i + 1
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                                    lang: props.lang,
                                    type: badgeType,
                                    max: props.surveyResult.nrAnswerOptions,
                                    value: question.scoreSelf,
                                    value2: question.scoreOther
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex flex-col md:flex-row mt-2",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "md:w-1/2",
                                    children: (0, $b0c116e0059d432e$export$c28e26439ac8e792)(props.lang, question, props.clientName)
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "md:w-1/2 md:pl-4 pt-2 md:pt-0",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $200b3872b8c265f8$export$2e2bcd8739ae039), {
                                            value1: question.scoreSelf,
                                            value2: question.scoreOther,
                                            max: props.surveyResult.nrAnswerOptions,
                                            size: "small"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "mt-2 flex",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                    className: "text-sm",
                                                    children: [
                                                        t("self-assessment"),
                                                        ": ",
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                            className: "z-title2",
                                                            children: question.scoreSelf.toFixed(1)
                                                        }),
                                                        "/",
                                                        props.surveyResult.nrAnswerOptions
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                    className: "ml-4 text-sm",
                                                    children: [
                                                        "Feedback: ",
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                            className: "z-title2",
                                                            children: props.feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF ? "-" : question.scoreOther.toFixed(1)
                                                        }),
                                                        "/",
                                                        props.surveyResult.nrAnswerOptions
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                    className: "ml-4 text-sm",
                                                    children: [
                                                        "Gap: ",
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                            className: "z-title2",
                                                            children: props.feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF ? "-" : Math.abs(question.scoreOther - question.scoreSelf).toFixed(1)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, "question_" + question.id);
            })
        });
        else {
            var question = findQuestion();
            if (!question) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    "Can't find question ",
                    viewQuestion
                ]
            });
            var scoreList = (0, $XnYkK._)(question.scoreList).reverse();
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "bg-indigo-800 rounded-[6px] p-4 mt-4 border-indigo-700 border-1",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: question.name
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex gap-x-4 flex-col md:flex-row items-stretch",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "border border-indigo-700 rounded-[6px] p-4 mt-4 md:w-1/2",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "font-medium",
                                        children: t("answers")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "w-full flex flex-col gap-4 flex-1",
                                        children: scoreList.map(function(responses, idx) {
                                            var score = props.surveyResult.nrAnswerOptions - idx;
                                            var option = answerOptions[score];
                                            // Calculate percentage for this answer
                                            var percentage = responses > 0 ? responses / props.surveyResult.nrOtherResponses * 100 : 0;
                                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                                className: "flex items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                                        className: "z-title3 text-gray-400",
                                                                        children: option
                                                                    }),
                                                                    idx === props.surveyResult.nrAnswerOptions && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                                        className: "ml-2",
                                                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                                                            buttonType: "transparentBase",
                                                                            size: "sm",
                                                                            isRound: true,
                                                                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                                                                                alt: "info"
                                                                            }),
                                                                            onClick: function() {
                                                                                return setNoAnswerInfo(true);
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                                className: "flex items-center",
                                                                children: [
                                                                    score === question.scoreSelf && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                                        className: "mr-2",
                                                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a26167e8bf49a279$export$2e2bcd8739ae039), {
                                                                            txt: t("you"),
                                                                            type: "focus_area",
                                                                            size: "sm",
                                                                            self: true
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c69e28b19a456287$exports))),
                                                                        alt: "profile icon",
                                                                        className: "w-4 h-4"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                                        className: "ml-2 text-white font-medium",
                                                                        children: responses
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                        className: "w-full bg-indigo-700 rounded-full mt-1 w-1/2 items-center",
                                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                            className: "bg-peach-300 h-2 rounded-full",
                                                            style: {
                                                                width: "".concat(percentage, "%")
                                                            }
                                                        })
                                                    })
                                                ]
                                            }, "answer-".concat(idx));
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mt-4 md:w-1/2 flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "border border-indigo-700 rounded-[6px] p-4 mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                className: "z-title3",
                                                children: props.lang === "sv" ? "Snittpo\xe4ng" : "Average scores"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "mt-1 flex pb-5",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                        className: "text-sm",
                                                        children: [
                                                            t("self-assessment"),
                                                            ": ",
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                                className: "z-title2",
                                                                children: question.scoreSelf.toFixed(1)
                                                            }),
                                                            "/",
                                                            props.surveyResult.nrAnswerOptions
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                        className: "ml-4 text-sm ",
                                                        children: [
                                                            "Feedback: ",
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                                className: "z-title2",
                                                                children: question.scoreOther.toFixed(1)
                                                            }),
                                                            "/",
                                                            props.surveyResult.nrAnswerOptions
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                        className: "ml-4 text-sm",
                                                        children: [
                                                            "Gap: ",
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                                className: "z-title2",
                                                                children: Math.abs(question.scoreOther - question.scoreSelf).toFixed(1)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "border border-indigo-700 rounded-[6px] p-4 mt-2 mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                        className: "z-title3",
                                                        children: props.lang === "sv" ? "Tolkning" : "Interpretation"
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                                                        lang: props.lang,
                                                        type: "validated",
                                                        max: props.surveyResult.nrAnswerOptions,
                                                        value: question.scoreSelf,
                                                        value2: question.scoreOther
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "mt-2 pb-5",
                                                children: validatedText(question.scoreSelf, question.scoreOther)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "border border-indigo-700 rounded-[6px] p-4 mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                        className: "z-title3",
                                                        children: props.lang === "sv" ? "Enighet i feedback" : "Feedback alignment"
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                                                        lang: props.lang,
                                                        type: "feedback_alignment",
                                                        value: question.spreadRespondentsNormalized
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "mt-2 pb-5",
                                                children: spreadText(question.spreadRespondentsNormalized)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 border border-indigo-700 rounded-md p-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title3 text-gray-100",
                                children: props.lang === "sv" ? "Kommentarer" : "Comments"
                            }),
                            question.freeTexts.length > 0 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                children: question.freeTexts.map(function(freeText, i) {
                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "mt-1 text-sm text-gray-300 whitespace-pre-line",
                                        children: [
                                            '"',
                                            freeText,
                                            '"'
                                        ]
                                    }, "free_" + i);
                                })
                            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-1 text-sm text-gray-300 whitespace-pre-line",
                                children: t("no-comment-text")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                        isOpen: noAnswerInfo,
                        onClose: function() {
                            return setNoAnswerInfo(false);
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                                onClose: function() {
                                    return setNoAnswerInfo(false);
                                },
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-title1",
                                    children: t("why-no-answer")
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "font-medium",
                                        children: t("why-no-answer-1")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "mt-1",
                                        children: t("why-no-answer-2")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "font-medium mt-4",
                                        children: t("why-no-answer-3")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "mt-1",
                                        children: t("why-no-answer-4")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "font-medium mt-4",
                                        children: t("why-no-answer-5")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "mt-1",
                                        children: t("why-no-answer-6")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            props.aiFocusArea && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex gap-x-4 mt-4",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "border border-indigo-700 rounded-sm p-4 w-1/2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "font-medijm",
                                children: props.lang === "sv" ? "Insikter" : "Insights"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-gray-400 mt-1 whitespace-pre-line",
                                children: props.aiFocusArea.insights
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "border border-indigo-700 rounded-sm p-4 w-1/2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "font-medijm",
                                children: props.lang === "sv" ? "Omr\xe5dets status" : "Area Health"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-gray-400 mt-1 whitespace-pre-line",
                                children: props.aiFocusArea.health
                            })
                        ]
                    })
                ]
            }),
            props.feedbackType === (0, $2dd33a640256b676$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-wrap mt-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c1a8091d960f1c28$export$2e2bcd8739ae039), {
                        id: "all",
                        text: t("all-questions"),
                        selectedId: viewQuestion,
                        clickId: setViewQuestion
                    }),
                    props.questions.map(function(question, i) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c1a8091d960f1c28$export$2e2bcd8739ae039), {
                            id: question.id,
                            text: t("question") + " " + (i + 1),
                            selectedId: viewQuestion,
                            clickId: setViewQuestion
                        }, "qapa_" + question.id);
                    })
                ]
            }),
            renderQuestions()
        ]
    });
};
var $847f86c5796e8d1c$export$2e2bcd8739ae039 = $847f86c5796e8d1c$var$SurveyQuestionsResult;



var $9b32b16c2883c846$var$SurveyResultArea = function(param) {
    var surveyResult = param.surveyResult, lang = param.lang, sorting = param.sorting, aiInsights = param.aiInsights, t = param.t, clientName = param.clientName, feedbackType = param.feedbackType;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(sorting), 2), sortOrder = _useState[0], setSortOrder = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showInfoModal = _useState1[0], setShowInfoModal = _useState1[1];
    var sortOptions = [
        {
            key: "health_high",
            name: lang === "sv" ? "Status omr\xe5de" : "Area Health"
        },
        {
            key: "scoreOther_high",
            name: lang === "sv" ? "Feedback" : "Feedback"
        },
        {
            key: "scoreSelf_high",
            name: lang === "sv" ? "Sj\xe4lvskattning" : "Self-assessment"
        },
        {
            key: "gap_high",
            name: lang === "sv" ? "Gap" : "Perception gap"
        }
    ];
    var findAiFocusArea = function(focusAreaId) {
        if (!aiInsights.focusAreas) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = aiInsights.focusAreas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var fa = _step.value;
                if (fa.id === focusAreaId) return fa;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var renderFocusArea = function(focusArea) {
        var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), open = _useState[0], setOpen = _useState[1];
        var aiFocusArea = findAiFocusArea(focusArea.id);
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "bg-indigo-900 rounded-[6px] p-4 mt-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "cursor-pointer",
                    onClick: function() {
                        return setOpen(!open);
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex flex-wrap items-start",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "flex-1 min-w-0",
                                    children: (0, $b0c116e0059d432e$export$fa9277fc57deeba7)(lang, focusArea)
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center ml-2 shrink-0",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $d1c28afbe50d3cf6$export$2e2bcd8739ae039), {
                                            value: focusArea.health,
                                            level: focusArea.healthLevel,
                                            lang: lang
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f3995b418b94841f$exports))),
                                            alt: "toggle",
                                            className: "ml-4 p-1cursor-pointer hover:bg-indigo-700 rounded-[20px]" + (open ? " rotate-180" : "")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "main-half-col small mt-2",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $200b3872b8c265f8$export$2e2bcd8739ae039), {
                                value1: focusArea.scoreSelf,
                                value2: focusArea.scoreOther,
                                max: surveyResult.nrAnswerOptions,
                                results1: focusArea.scoreSelf.toFixed(1) + "/" + surveyResult.nrAnswerOptions,
                                results2: focusArea.scoreOther.toFixed(1) + "/" + surveyResult.nrAnswerOptions
                            })
                        })
                    ]
                }),
                open && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $847f86c5796e8d1c$export$2e2bcd8739ae039), {
                    questions: focusArea.questions,
                    surveyResult: surveyResult,
                    lang: lang,
                    aiFocusArea: aiFocusArea,
                    clientName: clientName,
                    feedbackType: feedbackType
                })
            ]
        }, "focus_area_" + focusArea.id);
    };
    var sortFunction = function(a, b) {
        var parts = sortOrder.split('_');
        var _sortOrder = "scoreOther";
        var direction = "high";
        if (parts.length === 2) {
            _sortOrder = parts[0];
            direction = parts[1];
        }
        var x = a.scoreOther;
        var y = b.scoreOther;
        if (_sortOrder === "scoreOther") {
            x = a.scoreOther;
            y = b.scoreOther;
        } else if (_sortOrder === "scoreSelf") {
            x = a.scoreSelf;
            y = b.scoreSelf;
        } else if (_sortOrder === "gap") {
            x = a.gap;
            y = b.gap;
        } else if (_sortOrder === "health") {
            x = a.health;
            y = b.health;
        }
        if (direction === "high") return x < y ? 1 : -1;
        else return x > y ? 1 : -1;
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-wrap items-center mt-6 justify-between gap-y-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-heading1",
                                children: lang === "sv" ? "Resultat per omr\xe5de" : "Result per area"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "ml-2 flex item-center justify-center cursor-pointer rounded-[20px] p-1 hover:bg-indigo-700",
                                onClick: function() {
                                    return setShowInfoModal(!showInfoModal);
                                },
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                                    alt: "info",
                                    className: "h-6 w-6"
                                })
                            })
                        ]
                    }),
                    feedbackType !== (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                children: lang === "sv" ? "Sortera efter" : "Sort by"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "ml-2",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                                    className: "z-select small",
                                    value: sortOrder,
                                    onChange: function(e) {
                                        return setSortOrder(e.target.value);
                                    },
                                    children: sortOptions.map(function(option, i) {
                                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                            value: option.key,
                                            children: option.name
                                        }, "sort_" + i);
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            surveyResult.focusAreas.sort(function(a, b) {
                return sortFunction(a, b);
            }).map(function(focusArea) {
                return renderFocusArea(focusArea);
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4",
                children: "\xa0"
            }),
            showInfoModal && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $87f855ec55c62abb$export$2e2bcd8739ae039), {
                close: function() {
                    return setShowInfoModal(false);
                }
            })
        ]
    });
};
var $9b32b16c2883c846$export$2e2bcd8739ae039 = $9b32b16c2883c846$var$SurveyResultArea;











var $3967e9570d22c369$var$SurveyResult = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), surveyId = _useState[0], setSurveyId = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), clientName = _useState1[0], setClientName = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), otherRequests = _useState2[0], setOtherRequests = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), canCreateRequest = _useState3[0], setCanCreateRequest = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)({
        categoryId: "",
        categoryName: "",
        categoryNameSv: "",
        scoreSelf: 0,
        scoreOther: 0,
        gap: 0,
        spreadQuestions: 0,
        spreadQuestionsNormalized: 0,
        spreadRespondents: 0,
        spreadRespondentsNormalized: 0,
        focusAreas: [],
        nrOtherResponses: 0,
        nrAnswerOptions: 5,
        answerOptions: {},
        languages: [],
        respondents: []
    }), 2), surveyResult = _useState4[0], setSurveyResult = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)((0, $2dd33a640256b676$export$d4c0482bf980ef26).FEEDBACK), 2), feedbackType = _useState5[0], setFeedbackType = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)({
        summary: "N/A",
        strengths: "N/A",
        improvements: "N/A",
        focusAreas: []
    }), 2), aiInsights = _useState6[0], setAiInsights = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)({
        created: "",
        completed: "",
        sent: 0,
        answered: 0
    }), 2), requestSummary = _useState7[0], setRequestSummary = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), allQuestions = _useState8[0], setAllQuestions = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), focusAreasSorted = _useState9[0], setFocusAreasSorted = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), loading = _useState10[0], setLoading = _useState10[1];
    var _useState11 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState11[0], setError = _useState11[1];
    var _useState12 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), client = _useState12[0], setClient = _useState12[1];
    var _useParams = (0, $bHX26.useParams)(), id = _useParams.id, page = _useParams.page;
    var coachView = window.location.pathname.startsWith("/clients/survey_result/");
    (0, $5s1kH.useEffect)(function() {
        getData();
        setFocusAreasSorted(page ? page : "summary");
        window.addEventListener("popstate", onPop);
        return function() {
            window.removeEventListener("popstate", onPop);
        };
    }, [
        id
    ]);
    var onPop = function() {
        console.log('onPop');
        var urlParts = window.location.pathname.split("/");
        if (urlParts.length > 5) {
            var _page = urlParts[urlParts.length - 1];
            setFocusAreasSorted(_page);
        }
    };
    var changePage = function(_page) {
        var url = client ? "/clients/survey_result/" : "/dev-plan/survey/result/";
        url += id + "/" + _page;
        history.pushState(null, "", url);
        setFocusAreasSorted(_page);
        (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
    };
    var getData = function() {
        var url = coachView ? "coach/client/survey_result/" + id : "client/survey_result/" + id;
        api.get(url).then(function(response) {
            if (response.json.status === "ok") {
                setClient(response.json.client);
                setCanCreateRequest(response.json.canCreateRequest);
                setClientName(response.json.clientName);
                setSurveyResult(response.json.survey_result);
                setSurveyId(response.json.surveyId);
                setAiInsights(response.json.aiInsights);
                setOtherRequests(response.json.all_requests);
                setFeedbackType(response.json.feedbackType);
                setRequestSummary(response.json.requestSummary);
                var _allQuestions = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = response.json.survey_result.focusAreas[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var focusArea = _step.value;
                        try {
                            for(var _iterator1 = focusArea.questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var question = _step1.value;
                                question.focusAreaName = focusArea.name;
                                question.focusArea = focusArea;
                                _allQuestions.push(question);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                setAllQuestions(_allQuestions);
            } else if (response.json.error) setError(response.json.error);
            else setError("Unknown error");
            setLoading(false);
        });
    };
    if (loading) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {
        txt: lang === "sv" ? "Laddar rapporten, det kan ta ett tag" : "Loading report, this may take a while"
    });
    if (error.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    var showCrumbs = function() {
        var mainMain = (0, $c32e41a1c8ecb8c8$export$8f43a8af11ed514a)(lang, surveyResult.categoryNameSv, surveyResult.categoryName) + " " + t("insights-report");
        var crumbs;
        if (focusAreasSorted === "summary") {
            if (client) crumbs = [
                {
                    name: lang === "sv" ? "Hem" : "Home",
                    url: "/"
                },
                {
                    name: t("my-clients"),
                    url: "/clients"
                },
                {
                    name: client.firstName + " " + client.lastName,
                    url: "/clients/" + client.id
                },
                {
                    name: mainMain
                }
            ];
            else crumbs = [
                {
                    name: t("assessments"),
                    url: "/assessments"
                },
                {
                    name: mainMain
                }
            ];
        } else {
            var _title = lang === "sv" ? "Resultat per omr\xe5de" : "Result per Area";
            if (client) crumbs = [
                {
                    name: lang === "sv" ? "Hem" : "Home",
                    url: "/"
                },
                {
                    name: t("my-clients"),
                    url: "/clients"
                },
                {
                    name: client.firstName + " " + client.lastName,
                    url: "/clients/" + client.id
                },
                {
                    name: mainMain,
                    clickFunc: function() {
                        return changePage("summary");
                    }
                },
                {
                    name: _title
                }
            ];
            else crumbs = [
                {
                    name: t("assessments"),
                    url: "/assessments"
                },
                {
                    name: mainMain,
                    clickFunc: function() {
                        return changePage("summary");
                    }
                },
                {
                    name: _title
                }
            ];
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
            crumbs: crumbs
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "bg-indigo-1000 main-fixed px-4",
                children: [
                    showCrumbs(),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "my-4 flex items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "h-4 w-4 rounded-full bg-peach-500"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-sm ml-2 text-gray-100",
                                children: t("self-assessment")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "h-4 w-4 rounded-full bg-peach-300 ml-4"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-sm ml-2 text-gray-100",
                                children: "Feedback"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                style: {
                    paddingTop: 50
                },
                children: "\xa0"
            }),
            focusAreasSorted === "summary" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a960deaed26699f8$export$2e2bcd8739ae039), {
                allQuestions: allQuestions,
                surveyResult: surveyResult,
                lang: lang,
                t: t,
                aiInsights: aiInsights,
                clientName: clientName,
                otherRequests: otherRequests,
                canCreateRequest: canCreateRequest,
                feedbackType: feedbackType,
                setFocusAreasSorted: changePage,
                surveyId: surveyId
            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $9b32b16c2883c846$export$2e2bcd8739ae039), {
                surveyResult: surveyResult,
                sorting: focusAreasSorted,
                aiInsights: aiInsights,
                t: t,
                clientName: clientName,
                lang: lang,
                feedbackType: feedbackType
            }),
            !coachView && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 bg-indigo-900 rounded-md p-4 mb-4 border-indigo-800 border-1",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title1",
                                children: t("details")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mt-2 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($eda3564600df02e0$exports))),
                                        alt: "sent",
                                        className: "h-4 w-4 mr-2"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "z-title3",
                                        children: [
                                            t("request-sent"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "text-sm text-gray-400",
                                        children: [
                                            "\xa0",
                                            requestSummary.created
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mt-2 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                        alt: "cal",
                                        className: "h-4 w-4 mr-2"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "z-title3",
                                        children: [
                                            t("result-created-at"),
                                            ":\xa0"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-sm text-gray-400",
                                        children: requestSummary.completed
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mt-2 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dd0ccd8d6f00a586$exports))),
                                        alt: "open",
                                        className: "h-4 w-4 mr-2"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "z-title3",
                                        children: [
                                            t("received"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "text-sm text-gray-400",
                                        children: [
                                            "\xa0",
                                            requestSummary.answered,
                                            " ",
                                            t("out-of"),
                                            " ",
                                            requestSummary.sent
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mt-2 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bf234ba9a155a985$exports))),
                                        alt: "who",
                                        className: "h-4 w-4 mr-2"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "z-title3",
                                        children: [
                                            t("requested-from"),
                                            ":\xa0"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-sm text-gray-400",
                                        children: surveyResult.respondents.map(function(respondent, i) {
                                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                children: [
                                                    i > 0 ? ", " : "",
                                                    respondent.name
                                                ]
                                            }, "resp_" + i);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-10 text-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($dee60dcbfbf05c09$exports))),
                                alt: "rings",
                                className: "mx-auto h-8 w-8"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4 z-heading1",
                                children: lang === "sv" ? "Dags att v\xe4lja ett m\xe5l" : "Time to pick a goal"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4 text-gray-300 mx-auto",
                                style: {
                                    width: 300
                                },
                                children: lang === "sv" ? "Vi har f\xf6rberett f\xf6rslag p\xe5 personliga m\xe5l till dig, baserat p\xe5 ditt resultat." : "We've prepared personlized goal suggestions based on your result."
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "blueBase",
                                    onClick: function() {
                                        return navigate('/dev-plan#drafts_' + surveyId);
                                    },
                                    style: {
                                        width: "unset"
                                    },
                                    className: "mx-auto",
                                    children: lang === "sv" ? "V\xe4lj ett m\xe5l" : "Pick your goal"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4",
                children: "\xa0"
            })
        ]
    });
};
var $3967e9570d22c369$export$2e2bcd8739ae039 = $3967e9570d22c369$var$SurveyResult;



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");





var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");


var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");


var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $7dc1ea8bb0d8aa67$var$DropDown = function(param) {
    var _param_label = param.label, label = _param_label === void 0 ? "Select an option" : _param_label, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_className = param.className, className = _param_className === void 0 ? "" : _param_className, _param_buttonClassName = param.buttonClassName, buttonClassName = _param_buttonClassName === void 0 ? "" : _param_buttonClassName, _param_menuClassName = param.menuClassName, menuClassName = _param_menuClassName === void 0 ? "" : _param_menuClassName, _param_borderColor = param.borderColor, borderColor = _param_borderColor === void 0 ? "border-indigo-700" : _param_borderColor, children = param.children, onOpen = param.onOpen, onClose = param.onClose, controlledIsOpen = param.isOpen, controlledSetIsOpen = param.setIsOpen, _param_showIcon = param.showIcon, showIcon = _param_showIcon === void 0 ? true : _param_showIcon, _param_hasBorder = param.hasBorder, hasBorder = _param_hasBorder === void 0 ? true : _param_hasBorder, _param_preferDirection = param.preferDirection, preferDirection = _param_preferDirection === void 0 ? "up" : _param_preferDirection;
    var containerRef = (0, $5s1kH.useRef)(null);
    var menuRef = (0, $5s1kH.useRef)(null);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), internalIsOpen = _useState[0], setInternalIsOpen = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), dropUp = _useState1[0], setDropUp = _useState1[1];
    // Determine if the component is controlled
    var isControlled = controlledSetIsOpen != null;
    var isOpen = isControlled ? controlledIsOpen : internalIsOpen;
    var setIsOpen = isControlled ? controlledSetIsOpen : setInternalIsOpen;
    var MARGIN = 8;
    var toggleDropdown = function() {
        if (!disabled) setIsOpen(!isOpen);
    };
    // Handle clicks outside to close the dropdown
    (0, $5s1kH.useEffect)(function() {
        var handleClickOutside = function(e) {
            if (containerRef.current && !containerRef.current.contains(e.target)) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen,
        setIsOpen
    ]);
    // Handle onOpen and onClose callbacks
    (0, $5s1kH.useEffect)(function() {
        if (isOpen) onOpen && onOpen();
        else onClose && onClose();
    }, [
        isOpen,
        onOpen,
        onClose
    ]);
    // Determine dropdown direction based on preferDirection and available space
    (0, $5s1kH.useLayoutEffect)(function() {
        if (isOpen && containerRef.current && menuRef.current) {
            var containerRect = containerRef.current.getBoundingClientRect();
            var menuRect = menuRef.current.getBoundingClientRect();
            var menuHeight = menuRect.height;
            var spaceBelow = window.innerHeight - containerRect.bottom;
            var spaceAbove = containerRect.top;
            if (preferDirection === "up") {
                if (spaceAbove >= menuHeight + MARGIN) setDropUp(true); // Open upwards if enough space above
                else if (spaceBelow >= menuHeight + MARGIN) setDropUp(false); // Open downwards if enough space below
                else setDropUp(true); // Default to upwards if no space
            } else {
                // preferDirection === 'down'
                if (spaceBelow >= menuHeight + MARGIN) setDropUp(false); // Open downwards if enough space below
                else if (spaceAbove >= menuHeight + MARGIN) setDropUp(true); // Open upwards if enough space above
                else setDropUp(false); // Default to downwards if no space
            }
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        ref: containerRef,
        className: "relative w-full ".concat(className),
        style: {
            overflow: "visible"
        },
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("button", {
                type: "button",
                onClick: toggleDropdown,
                disabled: disabled,
                className: "\n          ".concat(buttonClassName, " border ").concat(borderColor, " \n          w-full flex items-center justify-between\n          bg-indigo-1000 rounded-md px-3 py-3 text-gray-400"),
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                        children: label
                    }),
                    showIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f3995b418b94841f$exports))),
                        alt: "Toggle dropdown",
                        className: "h-4 w-4 ml-2 transition-transform ".concat(isOpen ? "rotate-180" : "")
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                ref: menuRef,
                className: "\n            ".concat(menuClassName, "\n            absolute w-full\n            ").concat(dropUp ? "bottom-full mb-1" : "top-full mt-1", "\n            ").concat(hasBorder && "border border-indigo-700", "\n            rounded shadow-md z-50\n          "),
                children: children
            })
        ]
    });
};
var $7dc1ea8bb0d8aa67$export$2e2bcd8739ae039 = $7dc1ea8bb0d8aa67$var$DropDown;


var $0feea0d3b2b63e6b$export$2e2bcd8739ae039 = (0, $7dc1ea8bb0d8aa67$export$2e2bcd8739ae039);



var $6efaaaf91d58d91b$var$InputComponent = function(param) {
    var value = param.value, onChange = param.onChange, onFocus = param.onFocus, placeholder = param.placeholder, leftIcon = param.leftIcon, rightIcon = param.rightIcon, _param_validators = param.validators, validators = _param_validators === void 0 ? [] : _param_validators, _param_onError = param.onError, onError = _param_onError === void 0 ? function() {} : _param_onError, _param_onSubmit = param.onSubmit, onSubmit = _param_onSubmit === void 0 ? function() {} : _param_onSubmit, bgClass = param.bgClass, height = param.height, _param_containerClassName = param.containerClassName, containerClassName = _param_containerClassName === void 0 ? "min-h-12" : _param_containerClassName, _param_type = param.type, type = _param_type === void 0 ? 'text' : _param_type, _param_datesForPicker = param.datesForPicker, datesForPicker = _param_datesForPicker === void 0 ? [] : _param_datesForPicker, _param_isErrored = param.isErrored, isErrored = _param_isErrored === void 0 ? false : _param_isErrored, datePickerProps = param.datePickerProps, _param_dropdownProps = param.dropdownProps, dropdownProps = _param_dropdownProps === void 0 ? {} : _param_dropdownProps;
    var hasLeftIcon = Boolean(leftIcon);
    var hasRightIcon = Boolean(rightIcon);
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var paddingLeftRight = hasLeftIcon ? '36px' : '4px';
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(value && value.length > 10 ? new Date(value) : null), 2), parsedDate = _useState[0], setParsedDate = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), datePickerOpen = _useState1[0], setDatePickerOpen = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(''), 2), error = _useState2[0], setError = _useState2[1];
    var textareaRef = (0, $5s1kH.useRef)(null);
    var bg = bgClass || 'bg-indigo-1000';
    var inputClasses = "\n    h-full py-3 block w-full ".concat(bg, " text-white rounded-md\n    border-none \n    ").concat(!isErrored ? "ring-1 ring-indigo-700 focus:outline-none focus:ring-2 focus:ring-primary-500" : "ring-2 ring-cherry-500 focus:outline-none focus:ring-2 focus:ring-cherry-500", "\n    resize-none overflow-hidden\n  ");
    (0, $5s1kH.useEffect)(function() {
        if (value && value.length > 10) setParsedDate(new Date(value));
    }, [
        value
    ]);
    var runValidators = function(newValue) {
        var isValidOverall = true;
        var errorMessage = '';
        validators.forEach(function(validator) {
            var _validator = validator(newValue), isValid = _validator.isValid, error = _validator.error;
            if (!isValid) {
                isValidOverall = false;
                errorMessage = error;
            }
        });
        setError(errorMessage);
        onChange(newValue, isValidOverall);
    };
    var handleKeyPress = function(e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            onSubmit(e);
        }
    };
    var handleDatePick = function(date) {
        if (date) {
            var isoString = date.toISOString();
            runValidators(isoString);
            setParsedDate(date);
            setDatePickerOpen(false); // Close the dropdown only when a date is selected
        } else {
            runValidators('');
            setParsedDate(null);
        }
    };
    var dateToFormattedString = function(date) {
        if (!date) return '';
        return date.toLocaleDateString(i18n.language === 'sv' ? 'sv-SE' : 'en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };
    if (type === 'date') {
        if (!parsedDate && value.length > 10) {
            var _date = new Date(value);
            setParsedDate(_date);
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "".concat(containerClassName),
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "relative ".concat(height),
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0feea0d3b2b63e6b$export$2e2bcd8739ae039), (0, $lf4fc._)((0, $hwO3w._)({
                            label: parsedDate ? dateToFormattedString(parsedDate) : placeholder,
                            className: "w-full",
                            isOpen: datePickerOpen,
                            setIsOpen: setDatePickerOpen,
                            onOpen: function() {
                                return setDatePickerOpen(true);
                            },
                            onClose: function() {
                                return setDatePickerOpen(false);
                            },
                            borderColor: "".concat(datePickerOpen ? 'border-primary-500' : 'border-indigo-700'),
                            menuClassName: "bg-indigo-900",
                            showIcon: false,
                            hasBorder: false
                        }, dropdownProps), {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $eef0ed3dd6e17e0e$export$2e2bcd8739ae039), (0, $hwO3w._)({
                                dates: datesForPicker,
                                clickDate: handleDatePick,
                                preSelectedDate: parsedDate
                            }, datePickerProps))
                        })),
                        hasLeftIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "absolute flex items-center pointer-events-none",
                            style: {
                                insetBlock: 0,
                                paddingLeft: 16
                            },
                            children: leftIcon
                        }),
                        hasRightIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "absolute right-0 flex items-center pr-4 pointer-events-none",
                            style: {
                                insetBlock: 0
                            },
                            children: rightIcon
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "text-cherry-500",
                    children: error
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "px-0.5 z-0 ".concat(containerClassName),
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "relative ".concat(height),
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                        ref: textareaRef,
                        value: value,
                        onChange: function(e) {
                            var newValue = e.target.value;
                            runValidators(newValue);
                        },
                        onFocus: onFocus,
                        onKeyDown: handleKeyPress,
                        placeholder: placeholder,
                        className: "".concat(inputClasses, " box-border border border-gray-300 focus:ring-2 focus:ring-blue-500"),
                        style: {
                            whiteSpace: 'pre-wrap',
                            overflowWrap: 'break-word',
                            minHeight: '2.5rem',
                            lineHeight: '1.5',
                            paddingLeft: paddingLeftRight,
                            paddingRight: paddingLeftRight
                        },
                        rows: 1
                    }),
                    hasLeftIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "absolute left-0 flex items-center pl-4 z-40",
                        style: {
                            insetBlock: 0,
                            paddingLeft: 10
                        },
                        children: leftIcon
                    }),
                    hasRightIcon && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "absolute inset-y-0 right-0 flex items-center pr-4 z-40",
                        children: rightIcon
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "text-cherry-500",
                children: error
            })
        ]
    });
};
var $6efaaaf91d58d91b$export$2e2bcd8739ae039 = $6efaaaf91d58d91b$var$InputComponent;


var $1795c795b84f85d8$export$2e2bcd8739ae039 = (0, $6efaaaf91d58d91b$export$2e2bcd8739ae039);



var $972d3ebfeecd3ef5$var$AutocompleteSearch = function(param) {
    var options = param.options, getOptionLabel = param.getOptionLabel, getOptionKey = param.getOptionKey, onSelect = param.onSelect, _param_placeholder = param.placeholder, placeholder = _param_placeholder === void 0 ? 'Search...' : _param_placeholder, _param_containerClassName = param.containerClassName, containerClassName = _param_containerClassName === void 0 ? '' : _param_containerClassName;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(''), 2), searchTerm = _useState[0], setSearchTerm = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), filteredOptions = _useState1[0], setFilteredOptions = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var i18n = (0, $341d5702266247e0$export$9fc83ad70ead8663)().i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var containerRef = (0, $5s1kH.useRef)(null);
    // Filter and sort options based on search term
    (0, $5s1kH.useEffect)(function() {
        var trimmed = searchTerm.trim().toLowerCase();
        var results;
        if (trimmed.length > 0) results = options.filter(function(option) {
            return getOptionLabel(option).toLowerCase().indexOf(trimmed) > -1;
        });
        else results = (0, $XnYkK._)(options);
        var sortedResults = results.sort(function(a, b) {
            return getOptionLabel(a).localeCompare(getOptionLabel(b), undefined, {
                sensitivity: 'base'
            });
        });
        setFilteredOptions(sortedResults);
    }, [
        searchTerm,
        options,
        getOptionLabel
    ]);
    // Handle clicks outside to close dropdown
    (0, $5s1kH.useEffect)(function() {
        var handleOutsideClick = function(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) setIsOpen(false);
        };
        if (isOpen) document.addEventListener('mousedown', handleOutsideClick);
        return function() {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [
        isOpen
    ]);
    // Handle item selection
    var handleSelectItem = function(option) {
        setSearchTerm('');
        setIsOpen(false);
        if (onSelect) onSelect(option);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        ref: containerRef,
        className: "relative ".concat(containerClassName),
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $1795c795b84f85d8$export$2e2bcd8739ae039), {
                    value: searchTerm,
                    placeholder: placeholder,
                    onChange: function(val) {
                        return setSearchTerm(val);
                    },
                    onFocus: function() {
                        return setIsOpen(true);
                    },
                    onError: function() {},
                    dropdownProps: function() {},
                    leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("svg", {
                        className: "w-5 h-5 text-gray-500",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        })
                    })
                })
            }),
            isOpen && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "absolute left-0 w-full bg-indigo-900 border border-indigo-700 rounded-md mt-1 z-50 max-h-60 overflow-y-auto",
                children: filteredOptions.length > 0 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: filteredOptions.map(function(option, idx) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "px-4 py-2 cursor-pointer hover:bg-indigo-800",
                            onClick: function() {
                                return handleSelectItem(option);
                            },
                            children: getOptionLabel(option)
                        }, getOptionKey ? getOptionKey(option) : idx);
                    })
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "px-4 py-2 italic",
                    children: lang === 'sv' ? "Inget resultat. Be om att l\xe4gga till via support@zebrain.se" : 'No result. Request to add recipients via support@zebrain.se'
                })
            })
        ]
    });
};
var $972d3ebfeecd3ef5$export$2e2bcd8739ae039 = $972d3ebfeecd3ef5$var$AutocompleteSearch;


var $c7461b2583ca5ebe$export$2e2bcd8739ae039 = (0, $972d3ebfeecd3ef5$export$2e2bcd8739ae039);


var $630666c1efca6384$exports = {};
$630666c1efca6384$exports = $parcel$resolve("bUxvD");







var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");
function $091e5e17e62bc0c6$var$Tooltip(param) {
    var children = param.children, text = param.text, _param_tooltipPosition = param.tooltipPosition, tooltipPosition = _param_tooltipPosition === void 0 ? 'top' : _param_tooltipPosition;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), isVisible = _useState[0], setIsVisible = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)({
        top: 0,
        left: 0,
        width: 0,
        height: 0
    }), 2), coords = _useState1[0], setCoords = _useState1[1];
    var wrapperRef = (0, $5s1kH.useRef)(null);
    (0, $5s1kH.useEffect)(function() {
        var updatePosition = function() {
            if (wrapperRef.current) {
                var rect = wrapperRef.current.getBoundingClientRect();
                setCoords({
                    top: rect.top,
                    left: rect.left,
                    width: rect.width,
                    height: rect.height
                });
            }
        };
        if (isVisible) {
            updatePosition(); // measure immediately when shown
            window.addEventListener('scroll', updatePosition, true);
            window.addEventListener('resize', updatePosition);
        }
        return function() {
            window.removeEventListener('scroll', updatePosition, true);
            window.removeEventListener('resize', updatePosition);
        };
    }, [
        isVisible
    ]);
    var handleMouseEnter = function() {
        if (wrapperRef.current) {
            var rect = wrapperRef.current.getBoundingClientRect();
            setCoords({
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height
            });
        }
        setIsVisible(true);
    };
    var handleMouseLeave = function() {
        setIsVisible(false);
    };
    var getPositionStyles = function() {
        var scrollY = window.scrollY;
        var scrollX = window.scrollX;
        switch(tooltipPosition){
            case 'top':
                // Tooltip above the target element, arrow pointing down
                return {
                    container: {
                        position: 'absolute',
                        top: coords.top + scrollY - 8,
                        left: coords.left + scrollX + coords.width / 2,
                        transform: 'translate(-50%, -100%)'
                    },
                    arrowClass: 'absolute w-2 h-2 bg-indigo-700 transform',
                    arrowStyle: {
                        // Place arrow at bottom center of tooltip
                        bottom: '-4px',
                        left: '50%',
                        transform: 'translateX(-50%) rotate(45deg)'
                    }
                };
            case 'bottom':
                // Tooltip below the target element, arrow pointing up
                return {
                    container: {
                        position: 'absolute',
                        top: coords.top + coords.height + 8 + scrollY,
                        left: coords.left + coords.width / 2 + scrollX,
                        transform: 'translate(-50%, 0)'
                    },
                    arrowClass: 'absolute w-2 h-2 bg-indigo-700 transform',
                    arrowStyle: {
                        // Place arrow at top center of tooltip
                        top: '-4px',
                        left: '50%',
                        // rotate(225deg) flips the diamond to point upwards
                        transform: 'translateX(-50%) rotate(225deg)'
                    }
                };
            case 'left':
                // Tooltip to the left, arrow pointing right
                return {
                    container: {
                        position: 'absolute',
                        top: coords.top + coords.height / 2 + scrollY,
                        left: coords.left + scrollX - 8,
                        transform: 'translate(-100%, -50%)'
                    },
                    arrowClass: 'absolute w-2 h-2 bg-indigo-700 transform',
                    arrowStyle: {
                        // Place arrow at right center of tooltip
                        right: '-4px',
                        top: '50%',
                        // rotate(135deg) flips the diamond to point right
                        transform: 'translateY(-50%) rotate(135deg)'
                    }
                };
            case 'right':
                // Tooltip to the right, arrow pointing left
                return {
                    container: {
                        position: 'absolute',
                        top: coords.top + coords.height / 2 + scrollY,
                        left: coords.left + coords.width + 8 + scrollX,
                        transform: 'translate(0, -50%)'
                    },
                    arrowClass: 'absolute w-2 h-2 bg-indigo-700 transform',
                    arrowStyle: {
                        // Place arrow at left center of tooltip
                        left: '-4px',
                        top: '50%',
                        // rotate(315deg) flips the diamond to point left
                        transform: 'translateY(-50%) rotate(315deg)'
                    }
                };
            default:
                // Fallback to 'top'
                return {
                    container: {
                        position: 'absolute',
                        top: coords.top + scrollY - 8,
                        left: coords.left + scrollX + coords.width / 2,
                        transform: 'translate(-50%, -100%)'
                    },
                    arrowClass: 'absolute w-2 h-2 bg-indigo-700 transform',
                    arrowStyle: {
                        bottom: '-4px',
                        left: '50%',
                        transform: 'translateX(-50%) rotate(45deg)'
                    }
                };
        }
    };
    var _getPositionStyles = getPositionStyles(), container = _getPositionStyles.container, arrowClass = _getPositionStyles.arrowClass, arrowStyle = _getPositionStyles.arrowStyle;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                ref: wrapperRef,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                className: "inline-block",
                children: children
            }),
            isVisible && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                role: "tooltip",
                className: "relative z-50 text-sm font-medium text-white bg-indigo-700 rounded-lg shadow-md transition-opacity duration-300",
                style: container,
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "px-2 py-2",
                        children: text
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: arrowClass,
                        style: arrowStyle
                    })
                ]
            })
        ]
    });
}
var $091e5e17e62bc0c6$export$2e2bcd8739ae039 = $091e5e17e62bc0c6$var$Tooltip;


var $aacba3eeeaf27d21$export$2e2bcd8739ae039 = (0, $091e5e17e62bc0c6$export$2e2bcd8739ae039);



parcelRequire("5s1kH");
var $daf8b1247750b543$var$IconButton = function(param) {
    var icon = param.icon, onClick = param.onClick;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "flex align-middle items-center justify-center  p-1 rounded-full hover:bg-indigo-700",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("button", {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: icon,
                alt: "icon",
                className: "h-4 w-4"
            })
        })
    });
};
var $daf8b1247750b543$export$2e2bcd8739ae039 = $daf8b1247750b543$var$IconButton;


var $03918d984417e2f5$export$2e2bcd8739ae039 = (0, $daf8b1247750b543$export$2e2bcd8739ae039);


var $6d3b2b67d10aefe8$exports = {};
$6d3b2b67d10aefe8$exports = $parcel$resolve("4xT58");


var $91c3f1ebe0497aea$exports = {};
$91c3f1ebe0497aea$exports = $parcel$resolve("9j4G5");




var $ac954d60bd3f5530$var$SurveyRequestInvite = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showInfoModal = _useState1[0], setShowInfoModal = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), waiting = _useState2[0], setWaiting = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), fakeDone = _useState3[0], setFakeDone = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), done = _useState4[0], setDone = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), feedbackUsers = _useState5[0], setFeedbackUsers = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)("-"), 2), deadline = _useState6[0], setDeadline = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), demo = _useState7[0], setDemo = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), answered = _useState8[0], setAnswered = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState9[0], setError = _useState9[1];
    var id = (0, $bHX26.useParams)().id;
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get("client/survey_request_invite/" + id).then(function(response) {
            if (response.json.status === "ok") {
                setFeedbackUsers(response.json.feedbackUsers);
                setDeadline(response.json.deadline);
                setAnswered(response.json.answered);
                setDemo(response.json.demo);
            } else if (response.json.error) setError(response.json.error);
            else setError("Unknown error");
            setLoading(false);
        });
    };
    var submit = function() {
        var data = {
            feedbackUsers: feedbackUsers,
            fake_done: fakeDone
        };
        setWaiting(true);
        api.post("client/survey_request_feedback/" + id, data).then(function(response) {
            if (response.json.status === "ok") setDone(true);
            setWaiting(false);
        });
    };
    if (loading) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (done) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 text-center mx-auto",
                style: {
                    width: 358
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7733e845956e4cc2$exports))),
                        alt: "done",
                        className: "mt-10 w-12 h-12 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-6 z-heading1",
                        children: t("feedback-request-sent")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2 text-gray-300",
                        children: [
                            lang === "sv" ? "Bra jobbat! Vi h\xf6r av oss n\xe4r ditt feedbackresultat \xe4r redo, senast " : "Well done! We\u2019ll reach out when the insights report is ready \u2013 most likely before ",
                            deadline.substring(0, 10),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 text-gray-300",
                        children: lang === "sv" ? "Under tiden kan du utforska din Profil och f\xe5 en djupare f\xf6rst\xe5else f\xf6r dig sj\xe4lv, eller ta hj\xe4lp av AI-assistenten f\xf6r vardagliga uppgifter." : "While you wait, explore your Profile to dive deeper into yourself, or let your AI assistant support you with daily tasks."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 text-center mx-auto",
                style: {
                    width: 300
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "outlineWhiteBase",
                            onClick: function() {
                                return navigate('/ai/0');
                            },
                            children: lang === "sv" ? "Anv\xe4nd AI-assistenten" : "Explore AI assistant"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            onClick: function() {
                                return navigate('/profile');
                            },
                            children: lang === "sv" ? "Utforska Profil" : "Explore Profile"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "transparentBase",
                            onClick: function() {
                                return navigate('/dev-plan');
                            },
                            children: lang === "sv" ? "Tillbaka till m\xe5lbilder" : "Back to Goals"
                        })
                    })
                ]
            })
        ]
    });
    var formValid = function() {
        var foundSelected = feedbackUsers.filter(function(f) {
            return f.selected;
        }).length;
        return foundSelected + answered >= 3;
    };
    var changeFeedbackUser = function(email, action) {
        var _feedbackUsers = (0, $XnYkK._)(feedbackUsers);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _feedbackUsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var feedbackUser = _step.value;
                if (feedbackUser.email === email) {
                    if (action === "selected") feedbackUser.selected = !feedbackUser.selected;
                    else if (action === "favorite") feedbackUser.favorite = !feedbackUser.favorite;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setFeedbackUsers(_feedbackUsers);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex items-center mt-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-h2",
                        children: lang === "sv" ? "Skicka feedbackf\xf6rfr\xe5gan" : "Send feedback request"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                        alt: "info",
                        className: "ml-2 p-1 cursor-pointer hover:bg-indigo-700 rounded-[20px]",
                        onClick: function() {
                            return setShowInfoModal(!showInfoModal);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mb-2 font-medium",
                        children: t("feedback-search-recipients")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c7461b2583ca5ebe$export$2e2bcd8739ae039), {
                        options: feedbackUsers.filter(function(fu) {
                            return !fu.selected && !fu.favorite;
                        }),
                        getOptionLabel: function(contact) {
                            return "".concat(contact.name, " (").concat(contact.email, ")");
                        },
                        getOptionKey: function(contact) {
                            return contact.email;
                        },
                        placeholder: t("feedback-search-by-name"),
                        onSelect: function(_feedbackUser) {
                            return changeFeedbackUser(_feedbackUser.email, "selected");
                        }
                    }),
                    feedbackUsers.filter(function(fu) {
                        return fu.selected || fu.favorite;
                    }).length > 0 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "my-6",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title2",
                                children: t("recipients")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-gray-400",
                                children: t("feedback-recipients-subtitle")
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "border border-dashed border-indigo-700 mt-4 mb-4 rounded-md text-center py-10",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($630666c1efca6384$exports))),
                                alt: "users",
                                className: "h-6 w-6 mx-auto mb-4"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "z-body1 !text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        children: lang === "sv" ? "Inga mottagare valda." : "No recipients selected."
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "mt-1 z-body1 !text-gray-400",
                                        children: lang === "sv" ? "V\xe4lj minst 3 f\xf6r att forts\xe4tta." : "Please select at least 3 to continue."
                                    })
                                ]
                            })
                        ]
                    }),
                    feedbackUsers.filter(function(fu) {
                        return fu.selected || fu.favorite;
                    }).map(function(recipient, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "h-6 w-6 rounded flex items-center justify-center cursor-pointer " + (recipient.selected ? "bg-primary-500" : "border border-gray-400"),
                                            onClick: function() {
                                                return changeFeedbackUser(recipient.email, "selected");
                                            },
                                            children: recipient.selected && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
                                                className: "h-5 w-5",
                                                alt: "Checked"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                            className: "ml-2",
                                            children: [
                                                recipient.name,
                                                " (",
                                                recipient.email,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $aacba3eeeaf27d21$export$2e2bcd8739ae039), {
                                    text: t(recipient.favorite ? "remove-as-favourite" : "add-as-favourite"),
                                    tooltipPosition: "left",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $03918d984417e2f5$export$2e2bcd8739ae039), {
                                        icon: recipient.favorite ? (0, (/*@__PURE__*/$parcel$interopDefault($91c3f1ebe0497aea$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($6d3b2b67d10aefe8$exports))),
                                        onClick: function() {
                                            return changeFeedbackUser(recipient.email, "favorite");
                                        }
                                    })
                                })
                            ]
                        }, "recipient_" + index);
                    })
                ]
            }),
            answered > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 border border-dashed border-gray-400 p-4 rounded-md",
                children: lang === "sv" ? "Vi har exkluderat de mottagare som redan svarat p\xe5 denna f\xf6rfr\xe5gan." : "We have excluded the respondents who have answered this feedback request."
            }),
            waiting ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-center",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($01b6e07abd83fc68$exports))),
                    alt: "processing",
                    className: "mx-auto",
                    style: {
                        height: 16,
                        width: 114
                    }
                })
            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                buttonType: "blueBase",
                className: "mt-6",
                disabled: !formValid(),
                onClick: function() {
                    return submit();
                },
                children: lang === "sv" ? "Skicka feedbackf\xf6rfr\xe5gan" : "Send feedback request"
            }),
            !demo && (0, $632c75b97b900307$export$1630b5343357e8b5).SYSTEM !== "production" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                    id: "fake_done",
                    label: "Debug: Simulate responses",
                    onChange: function() {
                        return setFakeDone(!fakeDone);
                    },
                    checked: fakeDone
                })
            }),
            demo && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-red-500",
                children: lang === "sv" ? "Detta \xe4r ett demokonto - inga feedbackf\xf6rfr\xe5gningar kommer att skickas. Du kommer att f\xe5 l\xe5tsasfeedback." : "This is a demo account - no feedback requests will be sent. You will get mocked feedback."
            })
        ]
    });
};
var $ac954d60bd3f5530$export$2e2bcd8739ae039 = $ac954d60bd3f5530$var$SurveyRequestInvite;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");


var $452e2b07ac9b2527$var$AiSystem = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), aiSystem = _useState1[0], setAiSystem = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), aiSystems = _useState2[0], setAiSystems = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)("default"), 2), clientPrompt = _useState3[0], setClientPrompt = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), clientPrompts = _useState4[0], setClientPrompts = _useState4[1];
    (0, $5s1kH.useEffect)(function() {
        api.get('client/ai_system').then(function(response) {
            setAiSystem(response.json.aiSystem);
            setAiSystems(response.json.aiSystems);
            setClientPrompt(response.json.clientPrompt);
            setClientPrompts(response.json.clientPrompts);
            setLoaded(true);
        });
    }, []);
    var changeSystem = function() {
        var data = {
            aiSystem: aiSystem,
            clientPrompt: clientPrompt
        };
        api.post('client/ai_system', data).then(function() {
            alert("Updated your AI system");
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    var renderAiInfo = function() {
        if (aiSystem === 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    children: "This is the default system used by all clients so far."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-2",
                    children: "OpenAI hosted by Azure in Sweden is used for historical reasons, when this was the only way to guarantee that data stayed in EU."
                })
            ]
        });
        else if (aiSystem === 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    children: "You can send the AI questions directly to OpenAI."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-2 text-cherry-600",
                    children: "Data is not guaranteed to stay in EU."
                })
            ]
        });
        else if (aiSystem === 2) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    children: "Gemini is an upcoming star."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-2 text-cherry-600",
                    children: "Data is not guaranteed to stay in EU."
                })
            ]
        });
        else if (aiSystem === 3) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-4",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                children: "Mistral is a French system. They follow the EU laws by the book (e.g. AI Act)."
            })
        });
        else if (aiSystem === 4) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    children: "Claude by Anthropic is a strong competitor to OpenAI."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-2 text-cherry-600",
                    children: "Data is not guaranteed to stay in EU."
                })
            ]
        });
    };
    var findSelectedPrompt = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = clientPrompts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _clientPrompt = _step.value;
                if (_clientPrompt.id === clientPrompt) return _clientPrompt;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var renderPromptInfo = function() {
        var selectedPrompt = findSelectedPrompt();
        if (selectedPrompt) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "font-medium",
                    children: "Selected Neutral style prompt:"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-400 p-2 bg-indigo-800 whitespace-pre-line",
                    children: selectedPrompt.promptNeutral
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 font-medium",
                    children: "Selected Coaching style prompt:"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-400 p-2 bg-indigo-800 whitespace-pre-line",
                    children: selectedPrompt.promptCoaching
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "z-h2 mt-6",
                children: "Change your AI system"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-gray-400",
                children: "Testing new AI systems is complex. Ask tech before start testing."
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-4 font-medium",
                children: "AI system"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                value: aiSystem,
                className: "z-select mt-1",
                onChange: function(e) {
                    return setAiSystem(parseInt(e.target.value));
                },
                children: aiSystems.map(function(a, i) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: a.id,
                        children: a.name
                    }, "ai_system_" + i);
                })
            }),
            renderAiInfo(),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-8 font-medium",
                children: "Prompts"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                value: clientPrompt,
                className: "z-select mt-1",
                onChange: function(e) {
                    return setClientPrompt(e.target.value);
                },
                children: clientPrompts.map(function(prompt) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: prompt.id,
                        children: prompt.name
                    }, "client_prompt_" + prompt.id);
                })
            }),
            renderPromptInfo(),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-8",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    onClick: function() {
                        return changeSystem();
                    },
                    children: "Change"
                })
            })
        ]
    });
};
var $452e2b07ac9b2527$export$2e2bcd8739ae039 = $452e2b07ac9b2527$var$AiSystem;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

parcelRequire("5s1kH");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");
var $824da3c469768752$exports = {};
$824da3c469768752$exports = $parcel$resolve("7Dmfu");


var $71261546663e62c4$var$Stepper = function(param) {
    var steps = param.steps, currentIndex = param.currentIndex, _param_completedSteps = param.completedSteps, completedSteps = _param_completedSteps === void 0 ? [] : _param_completedSteps, _param_direction = param.direction, direction = _param_direction === void 0 ? "horizontal" : _param_direction, _param_contentClasses = param.contentClasses, contentClasses = _param_contentClasses === void 0 ? "mt-6 sm:mt-8" : _param_contentClasses, _param_staticColor = param.staticColor, staticColor = _param_staticColor === void 0 ? false : _param_staticColor;
    if (!steps || steps.length === 0) return null;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(Array(steps.length).fill(28)), 2), lineHeights = _useState[0], setLineHeights = _useState[1];
    var circleRef = (0, $5s1kH.useRef)(Array(steps.length));
    var circleSize = 28; // size-7 is approximately 28px
    var circleCenterOffset = circleSize / 2; // 14px
    (0, $5s1kH.useEffect)(function() {
        // When we have one circle ref per step, calculate line height between them.
        if (circleRef.current.length === steps.length) calculateLineHeights();
    }, [
        circleRef.current
    ]);
    var getCircleClasses = function(isActive, isCompleted) {
        var classes = "size-7 flex justify-center items-center font-medium rounded-full z-10 ";
        if (staticColor) classes += "bg-primary-500 text-indigo-1000";
        else if (isActive) classes += "bg-success-300 text-indigo-1000";
        else if (isCompleted) classes += "bg-success-500 text-indigo-1000";
        else classes += "bg-indigo-700 text-gray-400";
        return classes;
    };
    var getStepClasses = function(isActive, isCompleted, vertical) {
        var classes = "relative flex ";
        classes += vertical ? "flex-row" : "flex-col";
        if (vertical) // In vertical mode, we align items to the start (left side)
        classes += " justify-start items-start";
        else // Horizontal mode
        classes += " justify-start flex-1 items-center";
        if (isActive) classes += " active";
        else if (isCompleted) classes += " success";
        return classes;
    };
    var isLineCompleted = function(index) {
        return completedSteps.includes(index);
    };
    var getLineClasses = function(completed) {
        if (staticColor) return "bg-primary-500";
        else return completed ? "bg-success-500" : "bg-indigo-800";
    };
    var calculateLineHeights = function() {
        // This is probably unnecessary complex. To calculate line height between step circles we pull position from
        // each circle and calculate the distance between them. Subtract circle height.
        var changed = false;
        var newLineHeights = (0, $XnYkK._)(lineHeights);
        for(var index = 1; index < steps.length; index++){
            var prevCircle = document.getElementById("stepper_circle_" + (index - 1));
            var thisCircle = document.getElementById("stepper_circle_" + index);
            if (prevCircle && thisCircle) {
                var prevRect = prevCircle.getBoundingClientRect();
                var thisRect = thisCircle.getBoundingClientRect();
                var height = thisRect.top - prevRect.top - circleSize;
                // console.log(index + '. height ' + height + ' this y ' + thisRect.top + ' prev y ' + prevRect.top + ' circleSize ' + circleSize)
                if (height > 28) {
                    newLineHeights[index] = height;
                    changed = true;
                }
            }
        }
        if (changed) setLineHeights(newLineHeights);
    };
    var addCircleRef = function(el, index) {
        if (el) // Add a ref for this circle div element
        circleRef.current[index] = el;
    };
    // HORIZONTAL MODE
    if (direction === "horizontal") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("ul", {
                className: "relative flex items-center justify-between w-full",
                children: steps.map(function(step, index) {
                    var isActive = index === currentIndex;
                    var isCompleted = completedSteps.includes(index) && !isActive;
                    var titleClasses = "z-title3 mt-2 " + (isActive || isCompleted ? "text-white" : "text-white");
                    var descriptionClasses = "z-body2 mt-2 " + (isActive || isCompleted ? "text-gray-400" : "text-gray-400");
                    var leftLineCompleted = index > 0 ? isLineCompleted(index - 1) : false;
                    var rightLineCompleted = index < steps.length - 1 ? isLineCompleted(index) : false;
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("li", {
                        className: getStepClasses(isActive, isCompleted, false),
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "relative flex items-center justify-center w-full h-7",
                                children: [
                                    index > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "absolute left-0 top-1/2 -translate-y-1/2 h-px ".concat(getLineClasses(leftLineCompleted)),
                                        style: {
                                            width: "50%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                        className: getCircleClasses(isActive, isCompleted),
                                        children: isCompleted ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($824da3c469768752$exports))),
                                            alt: "Checkmark",
                                            className: "size-4"
                                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                            children: index + 1
                                        })
                                    }),
                                    index < steps.length - 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "absolute right-0 top-1/2 -translate-y-1/2 h-px ".concat(getLineClasses(rightLineCompleted)),
                                        style: {
                                            width: "50%"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: titleClasses,
                                        children: step.title
                                    }),
                                    step.description && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: descriptionClasses,
                                        children: step.description
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: contentClasses,
                children: steps.map(function(step, index) {
                    var isActive = index === currentIndex;
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        style: {
                            display: isActive ? "block" : "none"
                        },
                        children: step.content
                    }, index);
                })
            })
        ]
    });
    // VERTICAL MODE
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "w-full flex flex-col",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("ul", {
            className: "relative flex flex-col items-start w-full h-full",
            children: steps.map(function(step, index) {
                var isActive = index === currentIndex;
                var isCompleted = completedSteps.includes(index) && !isActive;
                var titleClasses = "z-title3  ml-2 " + (isActive || isCompleted ? "text-white" : "text-white");
                var descriptionClasses = "z-body2 ml-2 " + (isActive || isCompleted ? "text-gray-400" : "text-gray-400");
                var prevStepCompleted = index > 0 ? completedSteps.includes(index - 1) : false;
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("li", {
                    className: "".concat(getStepClasses(isActive, isCompleted, true), " relative grow w-full"),
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "relative flex items-center",
                        style: {
                            marginTop: circleCenterOffset
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "relative " + getCircleClasses(isActive, isCompleted),
                                ref: function(el) {
                                    return addCircleRef(el, index);
                                },
                                id: "stepper_circle_" + index,
                                children: [
                                    index > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "absolute left-[14px] " + (staticColor ? "bg-primary-500" : prevStepCompleted ? "bg-success-500" : "bg-indigo-700"),
                                        style: {
                                            bottom: circleSize,
                                            width: 1,
                                            height: lineHeights[index]
                                        }
                                    }),
                                    isCompleted ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($824da3c469768752$exports))),
                                        alt: "Checkmark",
                                        className: "size-4"
                                    }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                        style: {
                                            width: 28,
                                            textAlign: "center"
                                        },
                                        children: index + 1
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: titleClasses,
                                        children: step.title
                                    }),
                                    step.description && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: descriptionClasses,
                                        children: step.description
                                    })
                                ]
                            })
                        ]
                    })
                }, index);
            })
        })
    });
};
var $71261546663e62c4$export$2e2bcd8739ae039 = $71261546663e62c4$var$Stepper;


var $e949fc66b34e9329$export$2e2bcd8739ae039 = (0, $71261546663e62c4$export$2e2bcd8739ae039);





var $bHX26 = parcelRequire("bHX26");
var $0c396468cfe0bcf3$var$RequestStatus = function(props) {
    var navigate = (0, $bHX26.useNavigate)();
    var lang = props.language;
    var myNavigate = function(link) {
        if (props.surveyRequestId === "0") alert("This is debug page. Would send client to " + link);
        else navigate(link);
    };
    var singleRequest = function() {
        var description1 = lang === "sv" ? "Klar" : "Completed";
        var description2 = lang === "sv" ? "Be om feedback" : "Send a request to those around you";
        var description3 = lang === "sv" ? "Resultat och analys av din sj\xe4lvskattning och feedback" : "Results and analysis from your self-assessment and feedback";
        var buttonText = "";
        var buttonType = "blueBase";
        var navigateTo = "";
        var step = 0;
        var completedSteps = [];
        if (props.status === "completed") {
            completedSteps = [
                0,
                1,
                2
            ];
            step = 3;
        } else if (props.status === "pending_self") {
            description1 = lang === "sv" ? "Slutf\xf6r din sj\xe4lvskattning" : "Complete your self-assessment to continue";
            buttonText = lang === "sv" ? "Forts\xe4tt med sj\xe4lvskattning" : "Continue with self-assessment";
            if (props.partial) navigateTo = "/assessments/own/" + props.visionStatementId;
            else navigateTo = "/feedback/survey/" + props.surveyRequestId;
        } else if (props.status === "invite_other") {
            completedSteps = [
                0
            ];
            step = 1;
            description2 = lang === "sv" ? "Be om feedback" : "Request feedback";
            description3 = lang === "sv" ? "V\xe4ntar p\xe5 svar. Vi meddelar dig via e-post n\xe4r den \xe4r klar, troligen senast " : "Waiting for feedback result. We'll email you when it is ready, no later than ";
            description3 += props.deadline.substring(0, 10) + ".";
            buttonText = lang === "sv" ? "Be om feedback" : "Request feedback";
            if (props.partial) navigateTo = "/assessments/own/" + props.visionStatementId;
            else navigateTo = "/dev-plan/survey_request_invite/" + props.surveyRequestId;
        } else if (props.status === "pending_other") {
            completedSteps = [
                0,
                1
            ];
            step = 2;
            description2 = lang === "sv" ? "Feedbackf\xf6rfr\xe5gan skickad" : "Feedback request sent";
            description3 = lang === "sv" ? "V\xe4ntar p\xe5 svar. Vi meddelar dig via e-post n\xe4r den \xe4r klar, troligen senast " : "Waiting for feedback result. We'll email you when it is ready, no later than ";
            description3 += props.deadline.substring(0, 10) + ".";
        } else if (props.status === "failed_resend") {
            buttonText = lang === "sv" ? "Be om feedback igen" : "Ask for feedback again";
            if (props.partial) navigateTo = "/assessments/own/" + props.visionStatementId;
            else navigateTo = "/dev-plan/survey_request_invite/" + props.surveyRequestId;
        }
        var title3 = props.partial ? lang === "sv" ? "Feedbackresultat och analys" : "Feedback result and analysis" : lang === "sv" ? "Insiktsrapport" : "Insights report";
        var stepsData = [
            {
                title: lang === "sv" ? "Sj\xe4lvskattning" : "Self-assessment",
                description: description1,
                content: null
            },
            {
                title: lang === "sv" ? "Feedback" : "Feedback request",
                description: description2,
                content: null
            },
            {
                title: title3,
                description: description3,
                content: null
            }
        ];
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4 px-4 pb-4 bg-indigo-800 rounded-sm",
            children: [
                props.status === "failed_resend" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "pt-4",
                    children: lang === "sv" ? "Alla svarade inte i tid. Du kan prova att be om feedback igen fr\xe5n de som inte svarat." : "Everybody didn't respond in time. You can try to ask again from they who didn't respond"
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e949fc66b34e9329$export$2e2bcd8739ae039), {
                    steps: stepsData,
                    direction: "vertical",
                    currentIndex: step,
                    completedSteps: completedSteps
                }),
                buttonText.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "flex justify-end mt-4",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: buttonType,
                        disabled: props.readOnly,
                        style: {
                            width: "unset"
                        },
                        rightIcon: buttonType === "blueBase" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                            alt: "right"
                        }) : null,
                        onClick: function() {
                            return myNavigate(navigateTo);
                        },
                        children: buttonText
                    })
                })
            ]
        });
    };
    var multipleRequest = function() {
        if (props.status === "invite_other" || props.partial) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "text-amber-600",
            children: "This state does not exist for automatic surveys"
        });
        var buttonText = "";
        var buttonType = "blueBase";
        var navigateTo = "";
        var description1 = lang === "sv" ? "Klar" : "Completed";
        var description2 = lang === "sv" ? "Resultat och analys av din sj\xe4lvskattning och feedback" : "Results and analysis from your self-assessment and feedback";
        var step = 0;
        var completedSteps = [];
        if (props.status === "completed") {
            completedSteps = [
                0,
                1
            ];
            step = 2;
        } else if (props.status === "pending_self") {
            description1 = lang === "sv" ? "Ge feedback" : "Give feedback";
            buttonText = lang === "sv" ? "Ge feedback" : "Give feedback";
            navigateTo = "/feedback/survey_multi/" + props.surveyRequestId;
        } else if (props.status === "pending_other") {
            completedSteps = [
                0
            ];
            step = 1;
            description2 = lang === "sv" ? "V\xe4ntar p\xe5 svar. Vi meddelar dig via e-post n\xe4r den \xe4r klar, troligen senast " : "Waiting for feedback result. We'll email you when it is ready, no later than ";
            description2 += props.deadline.substring(0, 10) + ".";
        }
        var title2 = props.partial ? lang === "sv" ? "Feedbackresultat och analys" : "Feedback result and analysis" : lang === "sv" ? "Insiktsrapport" : "Insights report";
        var stepsData = [
            {
                title: "Feedback",
                description: description1,
                content: null
            },
            {
                title: title2,
                description: description2,
                content: null
            }
        ];
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4 px-4 pb-4 bg-indigo-800 rounded-sm",
            children: [
                props.status === "failed_resend" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    children: "Failed resend"
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e949fc66b34e9329$export$2e2bcd8739ae039), {
                    steps: stepsData,
                    direction: "vertical",
                    currentIndex: step,
                    completedSteps: completedSteps
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e949fc66b34e9329$export$2e2bcd8739ae039), {
                    steps: stepsData,
                    direction: "vertical",
                    currentIndex: step,
                    completedSteps: completedSteps
                }),
                buttonText.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "flex justify-end mt-4",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: buttonType,
                        style: {
                            width: "unset"
                        },
                        rightIcon: buttonType === "blueBase" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                            alt: "right"
                        }) : null,
                        onClick: function() {
                            return myNavigate(navigateTo);
                        },
                        children: buttonText
                    })
                })
            ]
        });
    };
    if (props.status === "completed") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4 p-4 bg-indigo-800 rounded-sm",
        children: "Feedback completed - would show results here"
    });
    if (props.status === "failed_old") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4 p-4 bg-indigo-800 rounded-sm",
        children: "Your feedback request did not complete in 3 months after deadline. Would show link to create new feedback request"
    });
    if (props.multipleRequest) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: multipleRequest()
    });
    else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: singleRequest()
    });
};
var $0c396468cfe0bcf3$export$2e2bcd8739ae039 = $0c396468cfe0bcf3$var$RequestStatus;



var $51ec838223b193bc$var$Testing = function() {
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)("pending_self"), 2), status = _useState[0], setStatus = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)("sv"), 2), lang = _useState1[0], setLang = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), multiple = _useState2[0], setMultiple = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), partial = _useState3[0], setPartial = _useState3[1];
    var statuses = [
        [
            "pending_self",
            "Self-assessment not completed"
        ],
        [
            "invite_other",
            "Not invited feedback recipients"
        ],
        [
            "pending_other",
            "Waiting for feedback"
        ],
        [
            "failed_resend",
            "Request failed, try again"
        ],
        [
            "failed_old",
            "Request failed > 3 months after deadline, create new request"
        ],
        [
            "completed",
            "Completed"
        ]
    ];
    var renderStatus = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0c396468cfe0bcf3$export$2e2bcd8739ae039), {
            status: status,
            language: lang,
            multipleRequest: multiple,
            surveyRequestId: "0",
            deadline: "2026-09-01",
            partial: partial
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "text-xl mt-4",
                children: "Test Request status"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($cb70cc925ae09565$exports))),
                className: "h-6 w-6",
                alt: "ai"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                    className: "z-select",
                    value: status,
                    onChange: function(e) {
                        return setStatus(e.target.value);
                    },
                    children: statuses.map(function(_status) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                            value: _status[0],
                            children: _status[1]
                        }, "s_" + _status[0]);
                    })
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex gap-x-4 mt-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: lang === "sv" ? "font-medium" : "underline cursor-pointer",
                        onClick: function() {
                            return setLang('sv');
                        },
                        children: "Swedish"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: lang === "en" ? "font-medium" : "underline cursor-pointer",
                        onClick: function() {
                            return setLang('en');
                        },
                        children: "English"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex gap-x-4 mt-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: !partial ? "font-medium" : "underline cursor-pointer",
                        onClick: function() {
                            return setPartial(false);
                        },
                        children: "Full survey"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: partial ? "font-medium" : "underline cursor-pointer",
                        onClick: function() {
                            return setPartial(true);
                        },
                        children: "Goal survey"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex gap-x-4 mt-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: !multiple ? "font-medium" : "underline cursor-pointer",
                        onClick: function() {
                            return setMultiple(false);
                        },
                        children: "Normal survey"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: multiple ? "font-medium" : "underline cursor-pointer",
                        onClick: function() {
                            return setMultiple(true);
                        },
                        children: "Automatic survey"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-8",
                children: renderStatus()
            })
        ]
    });
};
var $51ec838223b193bc$export$2e2bcd8739ae039 = $51ec838223b193bc$var$Testing;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");






var $24ef3d21323e9f7d$var$Team = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), team = _useState2[0], setTeam = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), recordings = _useState3[0], setRecordings = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), respondentsWaiting = _useState4[0], setRespondentsWaiting = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), feedbacks = _useState5[0], setFeedbacks = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), feedbackSummary = _useState6[0], setFeedbackSummary = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showFeedbacks = _useState7[0], setShowFeedbacks = _useState7[1];
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get("client/team").then(function(response) {
            if (response.json.error) setError(response.json.error);
            else {
                setTeam(response.json.team);
                setRecordings(response.json.recordings);
                setRespondentsWaiting(response.json.respondentsWaiting);
                setFeedbackSummary(response.json.feedbackSummary);
                setFeedbacks(response.json.feedbacks);
                setLoaded(true);
            }
        }).catch(function(error) {
            alert("Unknown error (http status " + error.response.status + ")");
        });
    };
    if (error.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (!team) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "No team!?"
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 z-heading1",
                children: [
                    "You are a ",
                    team.manager ? "manager for" : "member of",
                    " ",
                    team.name
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-2",
                children: team.parentDepartment ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    children: [
                        "Your team is organized under ",
                        team.parentDepartment,
                        ".",
                        team.parentDepartmentManager && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            className: "mt-2",
                            children: [
                                "Your manager is ",
                                team.parentDepartmentManager,
                                "."
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    children: "Your team is at top level"
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-wrap gap-4 mt-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "font-medium text-gray-400",
                                children: "Team members"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "main-half-col bg-indigo-900 px-2 py-2 mt-2 rounded-md",
                                children: team.members.map(function(member, i) {
                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "my-2 px-2 rounded-md cursor-pointer cursor-pointer hover:bg-indigo-800",
                                        onClick: function() {
                                            return navigate('/team/member/' + member.clientId);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                                className: "z-title1",
                                                children: [
                                                    member.name,
                                                    " ",
                                                    member.manager && " (manager)"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                                className: "z-body2",
                                                children: [
                                                    member.visionStatements,
                                                    " Goals",
                                                    team.manager && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                                        children: [
                                                            ", ",
                                                            member.visionStatementsShared,
                                                            " shared with you"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, "member_" + i);
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "main-half-col bg-indigo-900 p-4 mt-4 rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex items-center gap-x-4",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($eda3564600df02e0$exports))),
                                                alt: "camera",
                                                className: "h-6 w-6"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "z-title2",
                                                children: "Feedback requests"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "mt-2 z-body1",
                                        children: [
                                            feedbackSummary === null || feedbackSummary === void 0 ? void 0 : feedbackSummary.completed,
                                            " completed"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            feedbackSummary === null || feedbackSummary === void 0 ? void 0 : feedbackSummary.pending,
                                            " pending"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            feedbackSummary === null || feedbackSummary === void 0 ? void 0 : feedbackSummary.failed,
                                            " failed"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            respondentsWaiting.length,
                                            " recipients not answered"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-body1 mt-2 z-link",
                                        onClick: function() {
                                            return setShowFeedbacks(!showFeedbacks);
                                        },
                                        children: showFeedbacks ? "Hide" : "Show all feedbacks"
                                    }),
                                    showFeedbacks && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "mt-4 flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                        className: "z-body2",
                                                        children: "Sender"
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                        className: "z-body2",
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                        className: "z-body2",
                                                        children: "Created"
                                                    })
                                                ]
                                            }),
                                            feedbacks.map(function(rw, i) {
                                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                    className: "mt-2 flex justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                            className: "z-body2",
                                                            children: rw.email
                                                        }),
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                            className: "z-body2",
                                                            children: rw.status
                                                        }),
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                            className: "z-body2",
                                                            children: rw.created.substring(0, 10)
                                                        })
                                                    ]
                                                }, "feedback_" + i);
                                            }),
                                            respondentsWaiting.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "z-title3 mt-4",
                                                children: [
                                                    respondentsWaiting.length,
                                                    " recipients not answered:"
                                                ]
                                            }),
                                            respondentsWaiting.map(function(rw, i) {
                                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "mt-2",
                                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                                        className: "z-body2",
                                                        children: [
                                                            rw.email,
                                                            " (Received ",
                                                            rw.created.substring(0, 10),
                                                            ")"
                                                        ]
                                                    })
                                                }, "rw_" + i);
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "main-half-col",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "font-medium text-gray-400",
                                children: "Team tools"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "bg-indigo-900 p-4 mt-2 rounded-md hover:bg-indigo-800 cursor-pointer",
                                onClick: function() {
                                    return navigate("/team/recordings");
                                },
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex items-center gap-x-4",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ce970e80edefa8a8$exports))),
                                                alt: "camera",
                                                className: "h-6 w-6"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "z-title2",
                                                children: "Recordings"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: " mt-2 flex justify-between items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "z-body1",
                                                children: [
                                                    "You have ",
                                                    recordings,
                                                    " recordings"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($e8981ef41dc6cb1b$exports))),
                                                alt: "right",
                                                className: "h-6 w-6"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "bg-indigo-900 p-4 mt-4 rounded-md hover:bg-indigo-800 cursor-pointer",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center gap-x-4 cursor-pointer",
                                    onClick: function() {
                                        return (0, $4bf2b0595575af5a$export$68c1f516bbed5123)("team_" + team.id, api.apiToken ? api.apiToken : "", "client");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0ba24e04ac8ea6c5$exports))),
                                            alt: "camera",
                                            className: "h-6 w-6"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-title2",
                                            children: "Team meeting"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $24ef3d21323e9f7d$export$2e2bcd8739ae039 = $24ef3d21323e9f7d$var$Team;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");








var $7d6703ede50b1f30$var$TeamMember = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), teamName = _useState2[0], setTeamName = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), member = _useState3[0], setMember = _useState3[1];
    var clientId = (0, $bHX26.useParams)().clientId;
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get("client/team/member/" + clientId).then(function(response) {
            if (response.json.error) setError(response.json.error);
            else {
                setTeamName(response.json.teamName);
                setMember(response.json.member);
                setLoaded(true);
            }
        }).catch(function(error) {
            alert("Unknown error (http status " + error.response.status + ")");
        });
    };
    if (error.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (!member) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "No member!?"
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: "Team",
                        url: "/team"
                    },
                    {
                        name: member.name
                    }
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4 z-heading1",
                children: member.name
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-wrap gap-4 mt-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "font-medium text-gray-400",
                                children: "Goals"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "main-half-col bg-indigo-900 p-4 mt-2 rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        children: [
                                            member.visionStatements,
                                            " Goals in total"
                                        ]
                                    }),
                                    member.visionStatementsShared.map(function(vs, i) {
                                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "my-2 cursor-pointer",
                                            onClick: function() {
                                                return navigate('/team/vision_statement/' + vs.id);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                    className: "flex items-center justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                            className: "z-title1",
                                                            children: vs.title
                                                        }),
                                                        (0, $b841e7314e3d419d$export$9874b5b4c45031c5)(vs.onTrack, lang)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                                    className: "z-body2",
                                                    children: [
                                                        "Due date: ",
                                                        vs.deadline
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                                    className: "z-body2",
                                                    children: [
                                                        "Progress: ",
                                                        vs.progress,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        }, "vs_" + i);
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "main-half-col",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "font-medium text-gray-400",
                                children: "Tools"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "bg-indigo-900 p-4 mt-2 rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex items-center gap-x-4",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0ba24e04ac8ea6c5$exports))),
                                                alt: "camera",
                                                className: "h-6 w-6"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "z-title2",
                                                children: "Video meeting"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex items-center gap-x-4 mt-4",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b12489d6f28ed582$exports))),
                                                alt: "chat",
                                                className: "h-6 w-6"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "z-title2",
                                                children: "Chat"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: "outlineWhiteBase",
                                        className: "mt-4",
                                        onClick: function() {
                                            return alert("Almost done :-/");
                                        },
                                        children: "Add Goal"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $7d6703ede50b1f30$export$2e2bcd8739ae039 = $7d6703ede50b1f30$var$TeamMember;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");




var $b9534ad53b11d3d9$exports = {};
$b9534ad53b11d3d9$exports = $parcel$resolve("esUtU");





var $bHX26 = parcelRequire("bHX26");



var $facc19daf8b7821e$var$Assessments = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), customerCategories = _useState1[0], setCustomerCategories = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), customerSurveys = _useState2[0], setCustomerSurveys = _useState2[1];
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get("client/assessments").then(function(response) {
            setCustomerCategories(response.json.customerCategories);
            setCustomerSurveys(response.json.customerSurveys);
            setLoaded(true);
        });
    };
    var createFeedbackRequest = function(surveyId) {
        api.post("client/survey_request/create", {
            survey_id: surveyId
        }).then(function(response) {
            if (response.json.status === "ok") navigate("/feedback/survey/" + response.json.surveyRequestId);
            else alert("Error");
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {});
    var renderCustomerCategorySurvey = function(customerCategory, survey) {
        var lastSurveyRequest = survey.lastSurveyRequest;
        var canRequestAgain = false;
        if (lastSurveyRequest && lastSurveyRequest.completed) canRequestAgain = survey.canCreateRequest || (0, $632c75b97b900307$export$1630b5343357e8b5).SYSTEM !== "production";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "z-h3",
                            children: [
                                (0, $c32e41a1c8ecb8c8$export$8f43a8af11ed514a)(lang, customerCategory.name_sv, customerCategory.name),
                                customerCategory.surveys.length > 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                    children: [
                                        ": ",
                                        survey.name
                                    ]
                                })
                            ]
                        }),
                        (customerCategory.readiness || customerCategory.drivers) && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex justify-end",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex gap-x-4",
                                children: [
                                    customerCategory.readiness && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-link",
                                        onClick: function() {
                                            return navigate("/assessments/readiness/" + customerCategory.id);
                                        },
                                        children: "Readiness"
                                    }),
                                    customerCategory.drivers && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-link",
                                        onClick: function() {
                                            return navigate("/feedback/survey_drivers/" + customerCategory.id);
                                        },
                                        children: "Drivers"
                                    })
                                ]
                            })
                        }),
                        canRequestAgain && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "transparentBase",
                            size: "sm",
                            onClick: function() {
                                return createFeedbackRequest(survey.id);
                            },
                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($8035c9bf788700b7$exports))),
                                alt: "info",
                                className: "w-4 h-4"
                            }),
                            style: {
                                width: "unset"
                            },
                            children: lang === "sv" ? "Ny m\xe4tning" : "New assessment"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-400 block md:flex",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: (0, $c32e41a1c8ecb8c8$export$8f43a8af11ed514a)(lang, customerCategory.intro_assessment_sv, customerCategory.intro_assessment_en)
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "rounded-md bg-indigo-800 p-4 mt-2 border-indigo-700 border",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-end",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "z-title2",
                                    children: [
                                        t("assessments"),
                                        ":\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "z-body2",
                                    children: [
                                        survey.requestsCompleted,
                                        " ",
                                        t("of"),
                                        " ",
                                        survey.requestsTotal,
                                        " ",
                                        t("completed").toLowerCase()
                                    ]
                                })
                            ]
                        }),
                        renderSurveyRequest(survey, lastSurveyRequest)
                    ]
                })
            ]
        }, "category_" + customerCategory.id + "_" + survey.id);
    };
    var renderSurveyRequest = function(survey, surveyRequest) {
        if (survey) {
            if (surveyRequest) {
                if (surveyRequest.completed) {
                    var buttonType = survey.seenReport ? "outlineWhiteBase" : "blueBase";
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "flex justify-end mt-4",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: buttonType,
                            style: {
                                width: "unset"
                            },
                            onClick: function() {
                                return navigate("/dev-plan/survey/result/" + surveyRequest.id + "/summary");
                            },
                            children: lang === "sv" ? "Visa rapport" : "View report"
                        })
                    });
                } else {
                    if (surveyRequest.surveyMultipleRecipientId) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4",
                                children: surveyRequest.surveyMultipleResponded ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: "Waiting for feedback"
                                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    style: {
                                        width: "unset"
                                    },
                                    className: "mt-4",
                                    onClick: function() {
                                        return navigate("/feedback/survey_multi/" + surveyRequest.surveyMultipleRecipientId);
                                    },
                                    children: lang === "sv" ? "Ge feedback" : "Give feedback"
                                })
                            }),
                            surveyRequest.lastCompletedSurveyId && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "flex justify-end",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    style: {
                                        width: "unset"
                                    },
                                    className: "mt-4",
                                    onClick: function() {
                                        return navigate("/dev-plan/survey/result/" + surveyRequest.lastCompletedSurveyId + "/summary");
                                    },
                                    children: lang === "sv" ? "Visa senaste rapporten" : "View latest report"
                                })
                            })
                        ]
                    });
                    var description1;
                    var description2 = lang === "sv" ? "Be om feedback" : "Send a request to those around you";
                    var description3 = lang === "sv" ? "Resultat och analys av din sj\xe4lvskattning och feedback" : "Results and analysis from your self-assessment and feedback";
                    var buttonText = "";
                    var buttonType1 = "blueBase";
                    var navigateTo = "";
                    var step = 0;
                    var completedSteps = [];
                    if (surveyRequest.selfAssessments > 0) {
                        completedSteps.push(0);
                        step++;
                        description1 = lang === "sv" ? "Klar" : "Completed";
                    } else {
                        description1 = lang === "sv" ? "Slutf\xf6r din sj\xe4lvskattning" : "Complete your self-assessment to continue";
                        buttonText = lang === "sv" ? "Forts\xe4tt med sj\xe4lvskattning" : "Continue with self-assessment";
                        if (surveyRequest.surveyMultipleRecipientId) navigateTo = "/feedback/survey_multi/" + surveyRequest.surveyMultipleRecipientId;
                        else navigateTo = "/feedback/survey/" + surveyRequest.id;
                    }
                    if (step > 0) {
                        if (surveyRequest.otherAssessments > 0) {
                            completedSteps.push(1);
                            step++;
                            description2 = lang === "sv" ? "Feedbackf\xf6rfr\xe5gan skickad" : "Feedback request sent";
                            description3 = lang === "sv" ? "V\xe4ntar p\xe5 svar. Vi meddelar dig via e-post n\xe4r den \xe4r klar, troligen senast " : "Waiting for feedback result. We'll email you when it is ready, no later than ";
                            description3 += surveyRequest.deadline.substring(0, 10) + ".";
                            if (surveyRequest.lastCompletedSurveyId.length > 0) {
                                buttonText = lang === 'sv' ? "Visa senaste rapporten" : "View latest report";
                                buttonType1 = "outlineWhiteBase";
                                navigateTo = "/dev-plan/survey/result/" + surveyRequest.lastCompletedSurveyId + "/summary";
                            }
                        } else if (!surveyRequest.surveyMultipleRecipientId) {
                            buttonText = t("request-feedback");
                            navigateTo = "/dev-plan/survey_request_invite/" + surveyRequest.id;
                        }
                    }
                    var stepsData = [
                        {
                            title: t("self-assessment"),
                            description: description1,
                            content: null
                        },
                        {
                            title: lang === "sv" ? "Feedback" : "Feedback request",
                            description: description2,
                            content: null
                        },
                        {
                            title: lang === "sv" ? "Insiktsrapport" : "Insights report",
                            description: description3,
                            content: null
                        }
                    ];
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 bg-indigo-800 rounded-sm",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e949fc66b34e9329$export$2e2bcd8739ae039), {
                                steps: stepsData,
                                direction: "vertical",
                                currentIndex: step,
                                completedSteps: completedSteps
                            }),
                            buttonText.length > 0 && surveyRequest.status !== "failed" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "flex justify-end",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: buttonType1,
                                    style: {
                                        width: "unset"
                                    },
                                    rightIcon: buttonType1 === "blueBase" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                                        alt: "right"
                                    }) : null,
                                    onClick: function() {
                                        return navigate(navigateTo);
                                    },
                                    children: buttonText
                                })
                            }),
                            surveyRequest.status === "failed" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "rounded-md bg-indigo-800 p-4 mt-4 border border-primary-500",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b9534ad53b11d3d9$exports))),
                                                alt: "cal",
                                                className: "h-6 w-6"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "ml-2 z-title2",
                                                children: t("not-enough-responses")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-body2 mt-2",
                                        children: lang === "sv" ? "Din f\xf6rfr\xe5gan fick inte tillr\xe4ckligt med svar. Prova att \xe4ndra mottagare och skicka igen." : "Your previous request didn\u2019t get enough responses: try adjusting the recipient list and sending it again."
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: "blueBase",
                                        className: "mt-4 ml-auto",
                                        style: {
                                            width: "unset"
                                        },
                                        rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                                            alt: "right"
                                        }),
                                        onClick: function() {
                                            return navigate("/dev-plan/survey_request_invite/" + surveyRequest.id);
                                        },
                                        children: lang === "sv" ? "Skicka om f\xf6rfr\xe5gan" : "Re-send feedback request"
                                    })
                                ]
                            }),
                            surveyRequest.lastCompletedSurveyId && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "flex justify-end",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    style: {
                                        width: "unset"
                                    },
                                    className: "mt-4",
                                    onClick: function() {
                                        return navigate("/dev-plan/survey/result/" + surveyRequest.lastCompletedSurveyId + "/summary");
                                    },
                                    children: lang === "sv" ? "Visa senaste rapporten" : "View latest report"
                                })
                            })
                        ]
                    });
                }
            } else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                buttonType: "blueBase",
                className: "mt-4 ml-auto",
                style: {
                    width: "unset"
                },
                rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                    alt: "right"
                }),
                onClick: function() {
                    return createFeedbackRequest(survey.id);
                },
                children: lang === "sv" ? "Starta sj\xe4lvskattning" : "Start self-assessment"
            });
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-4",
            children: "Error - missing survey"
        });
    };
    var renderCustomerSurvey = function(customerSurvey) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-h3",
                    children: customerSurvey.name
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2 bg-indigo-800 rounded-sm p-4",
                    children: [
                        customerSurvey.responses.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "z-body2",
                                    children: [
                                        "You have not uploaded your ",
                                        customerSurvey.name,
                                        " report yet."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "flex justify-end",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: "blueBase",
                                        className: "mt-4",
                                        style: {
                                            width: "unset"
                                        },
                                        rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                                            alt: "right"
                                        }),
                                        onClick: function() {
                                            return navigate("/assessments/survey_upload/" + customerSurvey.id);
                                        },
                                        children: "Upload your report"
                                    })
                                })
                            ]
                        }),
                        customerSurvey.responses.map(function(response) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "flex justify-end",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    className: "mt-4",
                                    style: {
                                        width: "unset"
                                    },
                                    onClick: function() {
                                        return navigate("/assessments/customer_survey_report/" + customerSurvey.id);
                                    },
                                    children: lang === "sv" ? "Visa senaste rapporten" : "View latest report"
                                })
                            }, response.id);
                        })
                    ]
                })
            ]
        }, "survey_" + customerSurvey.id);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "z-h2 mt-6",
                children: t("assessments")
            }),
            customerCategories.map(function(customerCategory) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    children: customerCategory.surveys.map(function(survey) {
                        return renderCustomerCategorySurvey(customerCategory, survey);
                    })
                }, "cat_" + customerCategory.id);
            }),
            customerSurveys.map(function(customerSurvey) {
                return renderCustomerSurvey(customerSurvey);
            }),
            customerCategories.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-title1",
                        children: lang === "sv" ? "Inga m\xe4tningar tillg\xe4ngliga just nu" : "No assessments available right now"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-body1 mt-1",
                        children: lang === "sv" ? "M\xe4tningar aktiveras av din organisation och kommer att visas h\xe4r n\xe4r de blir tillg\xe4ngliga." : "Your organization controls when assessments are activated. They will appear here when available."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4",
                children: "\xa0"
            })
        ]
    });
};
var $facc19daf8b7821e$export$2e2bcd8739ae039 = $facc19daf8b7821e$var$Assessments;



var $hwO3w = parcelRequire("hwO3w");

var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");







var $8845b9f638d27ce6$var$TeamVisionStatement = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), teamName = _useState2[0], setTeamName = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), visionStatement = _useState3[0], setVisionStatement = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), goals = _useState4[0], setGoals = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), logs = _useState5[0], setLogs = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), editLog = _useState6[0], setEditLog = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), activities = _useState7[0], setActivities = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), member = _useState8[0], setMember = _useState8[1];
    var visionStatementId = (0, $bHX26.useParams)().visionStatementId;
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get("client/team/vision_statement/" + visionStatementId).then(function(response) {
            if (response.json.error) setError(response.json.error);
            else {
                setTeamName(response.json.teamName);
                setMember(response.json.member);
                setVisionStatement(response.json.visionStatement);
                setGoals(response.json.goals);
                setActivities(response.json.activities);
                setLogs(response.json.logs);
                setLoaded(true);
            }
        }).catch(function(error) {
            alert("Unknown error (http status " + error.response.status + ")");
        });
    };
    if (error.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (!member || !visionStatement) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Missing data!?"
    });
    var formatLogType = function(logType) {
        if (logType === 0) return "Note";
        else if (logType === 1) return "Rating";
        else if (logType === 2) return "Progress";
        else if (logType === 3) return "Blocker";
        return "Unknown";
    };
    var saveLog = function() {
        if (!editLog) return;
        api.post('client/team/vision_statement_log/' + visionStatementId, editLog).then(function(response) {
            setEditLog(null);
            getData();
        });
        console.log("Saving...");
        setEditLog(null);
    };
    var updateEditLog = function(val, what) {
        if (editLog) {
            var _editLog = (0, $hwO3w._)({}, editLog);
            if (what === "logType") _editLog.logType = parseInt(val);
            else if (what === "comment") _editLog.comment = val;
            else if (what === "miscNumber") _editLog.miscNumber = parseInt(val);
            setEditLog(_editLog);
        }
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: "Team",
                        url: "/team"
                    },
                    {
                        name: member.name,
                        url: "/team/member/" + member.clientId
                    },
                    {
                        name: visionStatement.title
                    }
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4 z-heading1",
                children: visionStatement ? visionStatement.title : "N/A"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-wrap gap-4 mt-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "main-half-col ",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "z-title2",
                                children: "Goal"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "bg-indigo-900 px-4 py-2 mt-2 rounded-md",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "my-2",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                    className: "z-title2",
                                                    children: visionStatement.title
                                                }),
                                                (0, $b841e7314e3d419d$export$9874b5b4c45031c5)(visionStatement.onTrack, lang)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                            className: "z-body2",
                                            children: [
                                                "Due date: ",
                                                visionStatement.deadline
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                            className: "z-body2",
                                            children: [
                                                "Progress: ",
                                                visionStatement.progress,
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                            className: "z-body2 mt-2",
                                            children: visionStatement.description
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4 z-title1",
                                children: "Sub-goals"
                            }),
                            goals.map(function(goal) {
                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "bg-indigo-900 px-4 py-2 mt-2 rounded-md",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                            className: "z-title2",
                                            children: goal.title
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                            className: "z-body2",
                                            children: [
                                                "Due date: ",
                                                goal.deadline
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                            className: "z-body2",
                                            children: [
                                                "Done: ",
                                                goal.status === 1 ? "Yes" : "No"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                            className: "z-body2 mt-2",
                                            children: goal.description
                                        }),
                                        goal.actions.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                                    className: "border-indigo-700 mt-4"
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                    className: "mt-2 z-title2",
                                                    children: "Actions under this goal:"
                                                }),
                                                goal.actions.map(function(action) {
                                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                        className: "mt-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                                className: "z-title2",
                                                                children: action.title
                                                            }),
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                                                className: "z-body2",
                                                                children: [
                                                                    "Due date: ",
                                                                    action.deadline
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                                                className: "z-body2",
                                                                children: [
                                                                    "Done: ",
                                                                    action.status === 1 ? "Yes" : "No"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                                className: "z-body2 mt-2",
                                                                children: action.description
                                                            })
                                                        ]
                                                    }, "action_" + action.id);
                                                })
                                            ]
                                        })
                                    ]
                                }, "goal_" + goal.id);
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4 z-title1",
                                children: "Activities"
                            }),
                            activities.map(function(activity, i) {
                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "bg-indigo-900 px-4 py-2 mt-2 rounded-md",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                            className: "z-title2",
                                            children: activity.title
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                            className: "z-body2",
                                            children: [
                                                "Due date: ",
                                                activity.deadline
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                            className: "z-body2",
                                            children: [
                                                "Done: ",
                                                activity.status === 1 ? "Yes" : "No"
                                            ]
                                        })
                                    ]
                                }, "activity_" + i);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "main-half-col",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "z-title2",
                                children: "Logs"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "bg-indigo-900 px-4 pt-2 pb-4 mt-2 rounded-md",
                                children: [
                                    logs.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: "Nothing logged yet"
                                    }),
                                    logs.map(function(log) {
                                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "mt-2",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                    className: "flex items-center justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                            className: "z-title2",
                                                            children: formatLogType(log.logType)
                                                        }),
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                            className: "z-body3",
                                                            children: log.created.substring(0, 10)
                                                        })
                                                    ]
                                                }),
                                                log.logType === 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                                    className: "z-body1",
                                                    children: [
                                                        "Rating: ",
                                                        log.miscNumber
                                                    ]
                                                }),
                                                log.logType === 2 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                                    className: "z-body1",
                                                    children: [
                                                        "Progress: ",
                                                        log.miscNumber
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                                    className: "z-body2 mt-2 whitespace-pre-line",
                                                    children: log.comment
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                                    className: "border-indigo-700 my-4"
                                                })
                                            ]
                                        }, "log_" + log.id);
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: "outlineWhiteBase",
                                        className: "mt-4",
                                        onClick: function() {
                                            return setEditLog({
                                                id: "0",
                                                created: "",
                                                comment: "",
                                                logType: 0,
                                                miscNumber: 0
                                            });
                                        },
                                        children: "Add Goal Log"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            editLog && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: true,
                onClose: function() {
                    return setEditLog(null);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                        onClose: function() {
                            return setEditLog(null);
                        },
                        children: editLog.id === "0" ? "Add log" : "Edit log"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("select", {
                                    className: "z-select",
                                    value: editLog.logType,
                                    onChange: function(e) {
                                        updateEditLog(e.target.value, "logType");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                            value: 0,
                                            children: "Note"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                            value: 1,
                                            children: "Rating"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                            value: 2,
                                            children: "Progress"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                            value: 3,
                                            children: "Blocker"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "z-body3",
                                        children: "Comments:"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                                        value: editLog.comment,
                                        placeholder: "Write your comments here...",
                                        className: "z-input",
                                        onChange: function(e) {
                                            updateEditLog(e.target.value, "comment");
                                        }
                                    })
                                ]
                            }),
                            editLog.logType === 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "z-body3",
                                        children: "Your rating:"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                        type: "number",
                                        value: editLog.miscNumber,
                                        placeholder: "Between 1 and 5",
                                        className: "z-input",
                                        onChange: function(e) {
                                            updateEditLog(e.target.value, "miscNumber");
                                        }
                                    })
                                ]
                            }),
                            editLog.logType === 2 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "z-body3",
                                        children: "Enter progress (0-100):"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                        type: "number",
                                        value: editLog.miscNumber,
                                        placeholder: "Between 1 and 5",
                                        className: "z-input",
                                        onChange: function(e) {
                                            updateEditLog(e.target.value, "miscNumber");
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            onClick: function() {
                                return saveLog();
                            },
                            children: "Save"
                        })
                    })
                ]
            })
        ]
    });
};
var $8845b9f638d27ce6$export$2e2bcd8739ae039 = $8845b9f638d27ce6$var$TeamVisionStatement;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");










var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");











var $hwO3w = parcelRequire("hwO3w");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");

function $6979e79daae1f4fd$export$2e2bcd8739ae039() {
    return $6979e79daae1f4fd$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6979e79daae1f4fd$export$2e2bcd8739ae039.apply(null, arguments);
}


function $78b404e4b46724a3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $78b404e4b46724a3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $78b404e4b46724a3$export$2e2bcd8739ae039(o);
}



function $8a757b5952e59df1$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $78b404e4b46724a3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $78b404e4b46724a3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $0cd4210fbe71abe7$export$2e2bcd8739ae039(t) {
    var i = (0, $8a757b5952e59df1$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $78b404e4b46724a3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $bfbb99364ffa951d$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $0cd4210fbe71abe7$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $4b3494cf16703bf8$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $7b4c4f4a56bd113a$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $4b3494cf16703bf8$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



function $1fadade0dba858a9$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $b944111f291d7912$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $0cd4210fbe71abe7$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $b944111f291d7912$export$2e2bcd8739ae039(e, r, t) {
    return r && $b944111f291d7912$var$_defineProperties(e.prototype, r), t && $b944111f291d7912$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $6702fade5f9dd4f0$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $01be6314813c2472$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $78b404e4b46724a3$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $6702fade5f9dd4f0$export$2e2bcd8739ae039)(t);
}


function $8947323b9c1629a9$export$2e2bcd8739ae039(t) {
    return $8947323b9c1629a9$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $8947323b9c1629a9$export$2e2bcd8739ae039(t);
}


function $6e1ff5a94cb09506$export$2e2bcd8739ae039(t, e) {
    return $6e1ff5a94cb09506$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, $6e1ff5a94cb09506$export$2e2bcd8739ae039(t, e);
}


function $5a58d332f7e1c7eb$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $6e1ff5a94cb09506$export$2e2bcd8739ae039)(t, e);
}


function $fb4d26e82ba6fb15$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $04bae31234bd7670$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $f36b9472abb5455c$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $b8ad54cc00c41c02$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $f36b9472abb5455c$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $f36b9472abb5455c$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $a87139a1cc4fa105$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $d2ac826ad8f89f3d$export$2e2bcd8739ae039(r, e) {
    return (0, $fb4d26e82ba6fb15$export$2e2bcd8739ae039)(r) || (0, $04bae31234bd7670$export$2e2bcd8739ae039)(r, e) || (0, $b8ad54cc00c41c02$export$2e2bcd8739ae039)(r, e) || (0, $a87139a1cc4fa105$export$2e2bcd8739ae039)();
}




var $4YVCt = parcelRequire("4YVCt");

var $5s1kH = parcelRequire("5s1kH");

var $03bAP = parcelRequire("03bAP");



var $5s1kH = parcelRequire("5s1kH");
var $08d9ec57190e35c9$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $08d9ec57190e35c9$var$invariant = function invariant(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$08d9ec57190e35c9$exports = $08d9ec57190e35c9$var$invariant;


var $e86cbb66bba57a53$var$noop = function noop() {};
function $e86cbb66bba57a53$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $e86cbb66bba57a53$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $e86cbb66bba57a53$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$e86cbb66bba57a53$export$26cbf8c37e721e67(prop)] = $e86cbb66bba57a53$var$noop;
        var handler;
    });
    return propTypes;
}
function $e86cbb66bba57a53$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $e86cbb66bba57a53$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $e86cbb66bba57a53$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $08868910b8345610$var$_toPropertyKey(arg) {
    var key = $08868910b8345610$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $03bAP._)(key)) === "symbol" ? key : String(key);
}
function $08868910b8345610$var$_toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, $03bAP._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, $03bAP._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $08868910b8345610$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $5s1kH.useRef)(propValue !== undefined);
    var _useState = (0, $5s1kH.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $5s1kH.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $08868910b8345610$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$e86cbb66bba57a53$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $4b3494cf16703bf8$export$2e2bcd8739ae039)(_ref, [
            $e86cbb66bba57a53$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($08868910b8345610$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $08868910b8345610$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}





function $e8c1a65ea8171241$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $6e1ff5a94cb09506$export$2e2bcd8739ae039)(t, o);
}



var $5s1kH = parcelRequire("5s1kH");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $33a29339c3ac46e1$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $33a29339c3ac46e1$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $33a29339c3ac46e1$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$33a29339c3ac46e1$var$componentWillMount.__suppressDeprecationWarning = true;
$33a29339c3ac46e1$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$33a29339c3ac46e1$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $33a29339c3ac46e1$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $33a29339c3ac46e1$var$componentWillMount;
        prototype.componentWillReceiveProps = $33a29339c3ac46e1$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $33a29339c3ac46e1$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $2e5e4ff616afd0fd$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $2e5e4ff616afd0fd$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $e86cbb66bba57a53$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($e86cbb66bba57a53$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($08d9ec57190e35c9$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $e8c1a65ea8171241$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$e86cbb66bba57a53$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$e86cbb66bba57a53$export$12ae2baa35bd9b8b(props, key) && $e86cbb66bba57a53$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$e86cbb66bba57a53$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $4b3494cf16703bf8$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(Component, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
    (0, $33a29339c3ac46e1$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $e86cbb66bba57a53$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(UncontrolledComponent, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $2e5e4ff616afd0fd$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $2e5e4ff616afd0fd$export$2e2bcd8739ae039(newComponent, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $06a62230e027db68$exports = {};

$parcel$export($06a62230e027db68$exports, "add", function () { return $06a62230e027db68$export$e16d8520af44a096; });
$parcel$export($06a62230e027db68$exports, "subtract", function () { return $06a62230e027db68$export$4e2d2ead65e5f7e3; });
$parcel$export($06a62230e027db68$exports, "startOf", function () { return $06a62230e027db68$export$38d7278c783c77a7; });
$parcel$export($06a62230e027db68$exports, "month", function () { return $06a62230e027db68$export$af5de1609f06c8e6; });
$parcel$export($06a62230e027db68$exports, "date", function () { return $06a62230e027db68$export$324d90190a8b822a; });
$parcel$export($06a62230e027db68$exports, "hours", function () { return $06a62230e027db68$export$8d468796d69cdad1; });
$parcel$export($06a62230e027db68$exports, "minutes", function () { return $06a62230e027db68$export$666252b437cce0c7; });
$parcel$export($06a62230e027db68$exports, "seconds", function () { return $06a62230e027db68$export$4792e48abc550fa1; });
$parcel$export($06a62230e027db68$exports, "milliseconds", function () { return $06a62230e027db68$export$9a27fac83d67afd3; });
$parcel$export($06a62230e027db68$exports, "year", function () { return $06a62230e027db68$export$31803937850fb2da; });
$parcel$export($06a62230e027db68$exports, "weekday", function () { return $06a62230e027db68$export$b7f7efbe9ab39b25; });
$parcel$export($06a62230e027db68$exports, "endOf", function () { return $06a62230e027db68$export$2d3c3037220ab47a; });
$parcel$export($06a62230e027db68$exports, "eq", function () { return $06a62230e027db68$export$9663ddc1cf085b32; });
$parcel$export($06a62230e027db68$exports, "neq", function () { return $06a62230e027db68$export$9bc858421bf255d1; });
$parcel$export($06a62230e027db68$exports, "gt", function () { return $06a62230e027db68$export$dafeacbfe3530cd9; });
$parcel$export($06a62230e027db68$exports, "gte", function () { return $06a62230e027db68$export$aac79e834d1b4aed; });
$parcel$export($06a62230e027db68$exports, "lt", function () { return $06a62230e027db68$export$b961576059b7aeb6; });
$parcel$export($06a62230e027db68$exports, "lte", function () { return $06a62230e027db68$export$489c007ed603c05d; });
$parcel$export($06a62230e027db68$exports, "min", function () { return $06a62230e027db68$export$96ec731ed4dcb222; });
$parcel$export($06a62230e027db68$exports, "max", function () { return $06a62230e027db68$export$8960430cfd85939f; });
$parcel$export($06a62230e027db68$exports, "inRange", function () { return $06a62230e027db68$export$ddf89a9c5af38f94; });
$parcel$export($06a62230e027db68$exports, "day", function () { return $06a62230e027db68$export$d2d39d1adcc883a2; });
$parcel$export($06a62230e027db68$exports, "decade", function () { return $06a62230e027db68$export$5b86ea63a640289f; });
$parcel$export($06a62230e027db68$exports, "century", function () { return $06a62230e027db68$export$2c6a90a816708bc5; });
$parcel$export($06a62230e027db68$exports, "diff", function () { return $06a62230e027db68$export$a37e3c603d7117e5; });
var $06a62230e027db68$var$MILI = 'milliseconds', $06a62230e027db68$var$SECONDS = 'seconds', $06a62230e027db68$var$MINUTES = 'minutes', $06a62230e027db68$var$HOURS = 'hours', $06a62230e027db68$var$DAY = 'day', $06a62230e027db68$var$WEEK = 'week', $06a62230e027db68$var$MONTH = 'month', $06a62230e027db68$var$YEAR = 'year', $06a62230e027db68$var$DECADE = 'decade', $06a62230e027db68$var$CENTURY = 'century';
var $06a62230e027db68$var$multiplierMilli = {
    'milliseconds': 1,
    'seconds': 1000,
    'minutes': 60000,
    'hours': 3600000,
    'day': 86400000,
    'week': 604800000
};
var $06a62230e027db68$var$multiplierMonth = {
    'month': 1,
    'year': 12,
    'decade': 120,
    'century': 1200
};
function $06a62230e027db68$var$daysOf(year) {
    return [
        31,
        $06a62230e027db68$var$daysInFeb(year),
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
}
function $06a62230e027db68$var$daysInFeb(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0 ? 29 : 28;
}
function $06a62230e027db68$export$e16d8520af44a096(d, num, unit) {
    d = new Date(d);
    switch(unit){
        case $06a62230e027db68$var$MILI:
        case $06a62230e027db68$var$SECONDS:
        case $06a62230e027db68$var$MINUTES:
        case $06a62230e027db68$var$HOURS:
        case $06a62230e027db68$var$DAY:
        case $06a62230e027db68$var$WEEK:
            return $06a62230e027db68$var$addMillis(d, num * $06a62230e027db68$var$multiplierMilli[unit]);
        case $06a62230e027db68$var$MONTH:
        case $06a62230e027db68$var$YEAR:
        case $06a62230e027db68$var$DECADE:
        case $06a62230e027db68$var$CENTURY:
            return $06a62230e027db68$var$addMonths(d, num * $06a62230e027db68$var$multiplierMonth[unit]);
    }
    throw new TypeError('Invalid units: "' + unit + '"');
}
function $06a62230e027db68$var$addMillis(d, num) {
    var nextDate = new Date(+d + num);
    return $06a62230e027db68$var$solveDST(d, nextDate);
}
function $06a62230e027db68$var$addMonths(d, num) {
    var year = d.getFullYear(), month = d.getMonth(), day = d.getDate(), totalMonths = year * 12 + month + num, nextYear = Math.trunc(totalMonths / 12), nextMonth = totalMonths % 12, nextDay = Math.min(day, $06a62230e027db68$var$daysOf(nextYear)[nextMonth]);
    var nextDate = new Date(d);
    nextDate.setFullYear(nextYear);
    // To avoid a bug when sets the Feb month
    // with a date > 28 or date > 29 (leap year)
    nextDate.setDate(1);
    nextDate.setMonth(nextMonth);
    nextDate.setDate(nextDay);
    return nextDate;
}
function $06a62230e027db68$var$solveDST(currentDate, nextDate) {
    var currentOffset = currentDate.getTimezoneOffset(), nextOffset = nextDate.getTimezoneOffset();
    // if is DST, add the difference in minutes
    // else the difference is zero
    var diffMinutes = nextOffset - currentOffset;
    return new Date(+nextDate + diffMinutes * $06a62230e027db68$var$multiplierMilli['minutes']);
}
function $06a62230e027db68$export$4e2d2ead65e5f7e3(d, num, unit) {
    return $06a62230e027db68$export$e16d8520af44a096(d, -num, unit);
}
function $06a62230e027db68$export$38d7278c783c77a7(d, unit, firstOfWeek) {
    d = new Date(d);
    switch(unit){
        case $06a62230e027db68$var$CENTURY:
        case $06a62230e027db68$var$DECADE:
        case $06a62230e027db68$var$YEAR:
            d = $06a62230e027db68$export$af5de1609f06c8e6(d, 0);
        case $06a62230e027db68$var$MONTH:
            d = $06a62230e027db68$export$324d90190a8b822a(d, 1);
        case $06a62230e027db68$var$WEEK:
        case $06a62230e027db68$var$DAY:
            d = $06a62230e027db68$export$8d468796d69cdad1(d, 0);
        case $06a62230e027db68$var$HOURS:
            d = $06a62230e027db68$export$666252b437cce0c7(d, 0);
        case $06a62230e027db68$var$MINUTES:
            d = $06a62230e027db68$export$4792e48abc550fa1(d, 0);
        case $06a62230e027db68$var$SECONDS:
            d = $06a62230e027db68$export$9a27fac83d67afd3(d, 0);
    }
    if (unit === $06a62230e027db68$var$DECADE) d = $06a62230e027db68$export$4e2d2ead65e5f7e3(d, $06a62230e027db68$export$31803937850fb2da(d) % 10, 'year');
    if (unit === $06a62230e027db68$var$CENTURY) d = $06a62230e027db68$export$4e2d2ead65e5f7e3(d, $06a62230e027db68$export$31803937850fb2da(d) % 100, 'year');
    if (unit === $06a62230e027db68$var$WEEK) d = $06a62230e027db68$export$b7f7efbe9ab39b25(d, 0, firstOfWeek);
    return d;
}
function $06a62230e027db68$export$2d3c3037220ab47a(d, unit, firstOfWeek) {
    d = new Date(d);
    d = $06a62230e027db68$export$38d7278c783c77a7(d, unit, firstOfWeek);
    switch(unit){
        case $06a62230e027db68$var$CENTURY:
        case $06a62230e027db68$var$DECADE:
        case $06a62230e027db68$var$YEAR:
        case $06a62230e027db68$var$MONTH:
        case $06a62230e027db68$var$WEEK:
            d = $06a62230e027db68$export$e16d8520af44a096(d, 1, unit);
            d = $06a62230e027db68$export$4e2d2ead65e5f7e3(d, 1, $06a62230e027db68$var$DAY);
            d.setHours(23, 59, 59, 999);
            break;
        case $06a62230e027db68$var$DAY:
            d.setHours(23, 59, 59, 999);
            break;
        case $06a62230e027db68$var$HOURS:
        case $06a62230e027db68$var$MINUTES:
        case $06a62230e027db68$var$SECONDS:
            d = $06a62230e027db68$export$e16d8520af44a096(d, 1, unit);
            d = $06a62230e027db68$export$4e2d2ead65e5f7e3(d, 1, $06a62230e027db68$var$MILI);
    }
    return d;
}
var $06a62230e027db68$export$9663ddc1cf085b32 = $06a62230e027db68$var$createComparer(function(a, b) {
    return a === b;
});
var $06a62230e027db68$export$9bc858421bf255d1 = $06a62230e027db68$var$createComparer(function(a, b) {
    return a !== b;
});
var $06a62230e027db68$export$dafeacbfe3530cd9 = $06a62230e027db68$var$createComparer(function(a, b) {
    return a > b;
});
var $06a62230e027db68$export$aac79e834d1b4aed = $06a62230e027db68$var$createComparer(function(a, b) {
    return a >= b;
});
var $06a62230e027db68$export$b961576059b7aeb6 = $06a62230e027db68$var$createComparer(function(a, b) {
    return a < b;
});
var $06a62230e027db68$export$489c007ed603c05d = $06a62230e027db68$var$createComparer(function(a, b) {
    return a <= b;
});
function $06a62230e027db68$export$96ec731ed4dcb222() {
    return new Date(Math.min.apply(Math, arguments));
}
function $06a62230e027db68$export$8960430cfd85939f() {
    return new Date(Math.max.apply(Math, arguments));
}
function $06a62230e027db68$export$ddf89a9c5af38f94(day, min, max, unit) {
    unit = unit || 'day';
    return (!min || $06a62230e027db68$export$aac79e834d1b4aed(day, min, unit)) && (!max || $06a62230e027db68$export$489c007ed603c05d(day, max, unit));
}
var $06a62230e027db68$export$9a27fac83d67afd3 = $06a62230e027db68$var$createAccessor('Milliseconds');
var $06a62230e027db68$export$4792e48abc550fa1 = $06a62230e027db68$var$createAccessor('Seconds');
var $06a62230e027db68$export$666252b437cce0c7 = $06a62230e027db68$var$createAccessor('Minutes');
var $06a62230e027db68$export$8d468796d69cdad1 = $06a62230e027db68$var$createAccessor('Hours');
var $06a62230e027db68$export$d2d39d1adcc883a2 = $06a62230e027db68$var$createAccessor('Day');
var $06a62230e027db68$export$324d90190a8b822a = $06a62230e027db68$var$createAccessor('Date');
var $06a62230e027db68$export$af5de1609f06c8e6 = $06a62230e027db68$var$createAccessor('Month');
var $06a62230e027db68$export$31803937850fb2da = $06a62230e027db68$var$createAccessor('FullYear');
function $06a62230e027db68$export$5b86ea63a640289f(d, val) {
    return val === undefined ? $06a62230e027db68$export$31803937850fb2da($06a62230e027db68$export$38d7278c783c77a7(d, $06a62230e027db68$var$DECADE)) : $06a62230e027db68$export$e16d8520af44a096(d, val + 10, $06a62230e027db68$var$YEAR);
}
function $06a62230e027db68$export$2c6a90a816708bc5(d, val) {
    return val === undefined ? $06a62230e027db68$export$31803937850fb2da($06a62230e027db68$export$38d7278c783c77a7(d, $06a62230e027db68$var$CENTURY)) : $06a62230e027db68$export$e16d8520af44a096(d, val + 100, $06a62230e027db68$var$YEAR);
}
function $06a62230e027db68$export$b7f7efbe9ab39b25(d, val, firstDay) {
    var w = ($06a62230e027db68$export$d2d39d1adcc883a2(d) + 7 - (firstDay || 0)) % 7;
    return val === undefined ? w : $06a62230e027db68$export$e16d8520af44a096(d, val - w, $06a62230e027db68$var$DAY);
}
function $06a62230e027db68$export$a37e3c603d7117e5(date1, date2, unit, asFloat) {
    var dividend, divisor, result;
    switch(unit){
        case $06a62230e027db68$var$MILI:
        case $06a62230e027db68$var$SECONDS:
        case $06a62230e027db68$var$MINUTES:
        case $06a62230e027db68$var$HOURS:
        case $06a62230e027db68$var$DAY:
        case $06a62230e027db68$var$WEEK:
            dividend = date2.getTime() - date1.getTime();
            break;
        case $06a62230e027db68$var$MONTH:
        case $06a62230e027db68$var$YEAR:
        case $06a62230e027db68$var$DECADE:
        case $06a62230e027db68$var$CENTURY:
            dividend = ($06a62230e027db68$export$31803937850fb2da(date2) - $06a62230e027db68$export$31803937850fb2da(date1)) * 12 + $06a62230e027db68$export$af5de1609f06c8e6(date2) - $06a62230e027db68$export$af5de1609f06c8e6(date1);
            break;
        default:
            throw new TypeError('Invalid units: "' + unit + '"');
    }
    switch(unit){
        case $06a62230e027db68$var$MILI:
            divisor = 1;
            break;
        case $06a62230e027db68$var$SECONDS:
            divisor = 1000;
            break;
        case $06a62230e027db68$var$MINUTES:
            divisor = 60000;
            break;
        case $06a62230e027db68$var$HOURS:
            divisor = 3600000;
            break;
        case $06a62230e027db68$var$DAY:
            divisor = 86400000;
            break;
        case $06a62230e027db68$var$WEEK:
            divisor = 604800000;
            break;
        case $06a62230e027db68$var$MONTH:
            divisor = 1;
            break;
        case $06a62230e027db68$var$YEAR:
            divisor = 12;
            break;
        case $06a62230e027db68$var$DECADE:
            divisor = 120;
            break;
        case $06a62230e027db68$var$CENTURY:
            divisor = 1200;
            break;
        default:
            throw new TypeError('Invalid units: "' + unit + '"');
    }
    result = dividend / divisor;
    return asFloat ? result : Math.round(result);
}
function $06a62230e027db68$var$createAccessor(method) {
    var hourLength = function(method) {
        switch(method){
            case 'Milliseconds':
                return 3600000;
            case 'Seconds':
                return 3600;
            case 'Minutes':
                return 60;
            case 'Hours':
                return 1;
            default:
                return null;
        }
    }(method);
    return function(d, val) {
        if (val === undefined) return d['get' + method]();
        var dateOut = new Date(d);
        dateOut['set' + method](val);
        if (hourLength && dateOut['get' + method]() != val && (method === 'Hours' || val >= hourLength && dateOut.getHours() - d.getHours() < Math.floor(val / hourLength))) //Skip DST hour, if it occurs
        dateOut['set' + method](val + hourLength);
        return dateOut;
    };
}
function $06a62230e027db68$var$createComparer(operator) {
    return function(a, b, unit) {
        return operator(+$06a62230e027db68$export$38d7278c783c77a7(a, unit), +$06a62230e027db68$export$38d7278c783c77a7(b, unit));
    };
}



function $efc4db7af542dbb4$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $f36b9472abb5455c$export$2e2bcd8739ae039)(r);
}


function $952a18113cc8e861$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $d3050c480127aec6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $d6b7f356bb028375$export$2e2bcd8739ae039(r) {
    return (0, $efc4db7af542dbb4$export$2e2bcd8739ae039)(r) || (0, $952a18113cc8e861$export$2e2bcd8739ae039)(r) || (0, $b8ad54cc00c41c02$export$2e2bcd8739ae039)(r) || (0, $d3050c480127aec6$export$2e2bcd8739ae039)();
}


var $fb89aac394154b73$exports = {};
var $6ccd38f05dee86c7$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $6ccd38f05dee86c7$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$6ccd38f05dee86c7$exports = $6ccd38f05dee86c7$var$baseSlice;


var $8fd83702a1740eba$exports = {};

var $03bAP = parcelRequire("03bAP");

var $1g3Fq = parcelRequire("1g3Fq");

var $13FKp = parcelRequire("13FKp");

var $4FriW = parcelRequire("4FriW");

var $gpxvq = parcelRequire("gpxvq");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $8fd83702a1740eba$var$isIterateeCall(value, index, object) {
    if (!$gpxvq(object)) return false;
    var type = typeof index === "undefined" ? "undefined" : (0, $03bAP._)(index);
    if (type == 'number' ? $13FKp(object) && $4FriW(index, object.length) : type == 'string' && index in object) return $1g3Fq(object[index], value);
    return false;
}
$8fd83702a1740eba$exports = $8fd83702a1740eba$var$isIterateeCall;



var $3DIlv = parcelRequire("3DIlv");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fb89aac394154b73$var$nativeCeil = Math.ceil, $fb89aac394154b73$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $fb89aac394154b73$var$chunk(array, size, guard) {
    if (guard ? $8fd83702a1740eba$exports(array, size, guard) : size === undefined) size = 1;
    else size = $fb89aac394154b73$var$nativeMax($3DIlv(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($fb89aac394154b73$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $6ccd38f05dee86c7$exports(array, index, index += size);
    return result;
}
$fb89aac394154b73$exports = $fb89aac394154b73$var$chunk;



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");
/**
 * Returns the owner document of a given element.
 *
 * @param node the element
 */ function $4851cad9391d05e1$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $847363c20bcd4638$export$2e2bcd8739ae039(node) {
    var doc = (0, $4851cad9391d05e1$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $f50d05c8e584b947$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $847363c20bcd4638$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $060e9a917f87cf5d$var$rUpper = /([A-Z])/g;
function $060e9a917f87cf5d$export$2e2bcd8739ae039(string) {
    return string.replace($060e9a917f87cf5d$var$rUpper, '-$1').toLowerCase();
}


var $983cf12e37f961b8$var$msPattern = /^ms-/;
function $983cf12e37f961b8$export$2e2bcd8739ae039(string) {
    return (0, $060e9a917f87cf5d$export$2e2bcd8739ae039)(string).replace($983cf12e37f961b8$var$msPattern, '-ms-');
}


var $ad600fdb737f94f2$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $ad600fdb737f94f2$export$2e2bcd8739ae039(value) {
    return !!(value && $ad600fdb737f94f2$var$supportedTransforms.test(value));
}


function $161de9c090514c23$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $983cf12e37f961b8$export$2e2bcd8739ae039)(property)) || (0, $f50d05c8e584b947$export$2e2bcd8739ae039)(node).getPropertyValue((0, $983cf12e37f961b8$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $983cf12e37f961b8$export$2e2bcd8739ae039)(key));
        else if ((0, $ad600fdb737f94f2$export$2e2bcd8739ae039)(key)) transforms += "".concat(key, "(").concat(value, ") ");
        else css += "".concat((0, $983cf12e37f961b8$export$2e2bcd8739ae039)(key), ": ").concat(value, ";");
    });
    if (transforms) css += "transform: ".concat(transforms, ";");
    node.style.cssText += ";".concat(css);
}
var $161de9c090514c23$export$2e2bcd8739ae039 = $161de9c090514c23$var$style;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 *
 * @param context the context element
 * @param node the element to check
 */ function $1f47ac07b730d17e$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}



function $fd850d688016a56a$export$2e2bcd8739ae039(element) {
    return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
}


function $3c3b38590ce4fe70$export$2e2bcd8739ae039(node) {
    if ('window' in node && node.window === node) return node;
    if ((0, $fd850d688016a56a$export$2e2bcd8739ae039)(node)) return node.defaultView || false;
    return false;
}


function $b05e188c8cb2f25b$export$2e2bcd8739ae039(offset) {
    var prop = offset === 'pageXOffset' ? 'scrollLeft' : 'scrollTop';
    function scrollAccessor(node, val) {
        var win = (0, $3c3b38590ce4fe70$export$2e2bcd8739ae039)(node);
        if (val === undefined) return win ? win[offset] : node[prop];
        if (win) win.scrollTo(win[offset], val);
        else node[prop] = val;
    }
    return scrollAccessor;
}


var /**
 * Gets or sets the scroll left position of a given element.
 *
 * @param node the element
 * @param val the position to set
 */ $30c0cd871134ce54$export$2e2bcd8739ae039 = (0, $b05e188c8cb2f25b$export$2e2bcd8739ae039)('pageXOffset');



var /**
 * Gets or sets the scroll top position of a given element.
 *
 * @param node the element
 * @param val the position to set
 */ $3d97a9dbad6846a0$export$2e2bcd8739ae039 = (0, $b05e188c8cb2f25b$export$2e2bcd8739ae039)('pageYOffset');


function $ff2c299c017232ac$export$2e2bcd8739ae039(node) {
    var doc = (0, $4851cad9391d05e1$export$2e2bcd8739ae039)(node);
    var box = {
        top: 0,
        left: 0,
        height: 0,
        width: 0
    };
    var docElem = doc && doc.documentElement;
    // Make sure it's not a disconnected DOM node
    if (!docElem || !(0, $1f47ac07b730d17e$export$2e2bcd8739ae039)(docElem, node)) return box;
    if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
    box = {
        top: box.top + (0, $3d97a9dbad6846a0$export$2e2bcd8739ae039)(docElem) - (docElem.clientTop || 0),
        left: box.left + (0, $30c0cd871134ce54$export$2e2bcd8739ae039)(docElem) - (docElem.clientLeft || 0),
        width: box.width,
        height: box.height
    };
    return box;
}




var $a033f70d5aea5d76$var$isHTMLElement = function(e) {
    return !!e && 'offsetParent' in e;
};
function $a033f70d5aea5d76$export$2e2bcd8739ae039(node) {
    var doc = (0, $4851cad9391d05e1$export$2e2bcd8739ae039)(node);
    var parent = node && node.offsetParent;
    while($a033f70d5aea5d76$var$isHTMLElement(parent) && parent.nodeName !== 'HTML' && (0, $161de9c090514c23$export$2e2bcd8739ae039)(parent, 'position') === 'static')parent = parent.offsetParent;
    return parent || doc.documentElement;
}




var $912245913eb5c0fe$var$nodeName = function(node) {
    return node.nodeName && node.nodeName.toLowerCase();
};
function $912245913eb5c0fe$export$2e2bcd8739ae039(node, offsetParent) {
    var parentOffset = {
        top: 0,
        left: 0
    };
    var offset;
    // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
    // because it is its only offset parent
    if ((0, $161de9c090514c23$export$2e2bcd8739ae039)(node, 'position') === 'fixed') offset = node.getBoundingClientRect();
    else {
        var parent = offsetParent || (0, $a033f70d5aea5d76$export$2e2bcd8739ae039)(node);
        offset = (0, $ff2c299c017232ac$export$2e2bcd8739ae039)(node);
        if ($912245913eb5c0fe$var$nodeName(parent) !== 'html') parentOffset = (0, $ff2c299c017232ac$export$2e2bcd8739ae039)(parent);
        var borderTop = String((0, $161de9c090514c23$export$2e2bcd8739ae039)(parent, 'borderTopWidth') || 0);
        parentOffset.top += parseInt(borderTop, 10) - (0, $3d97a9dbad6846a0$export$2e2bcd8739ae039)(parent) || 0;
        var borderLeft = String((0, $161de9c090514c23$export$2e2bcd8739ae039)(parent, 'borderLeftWidth') || 0);
        parentOffset.left += parseInt(borderLeft, 10) - (0, $30c0cd871134ce54$export$2e2bcd8739ae039)(parent) || 0;
    }
    var marginTop = String((0, $161de9c090514c23$export$2e2bcd8739ae039)(node, 'marginTop') || 0);
    var marginLeft = String((0, $161de9c090514c23$export$2e2bcd8739ae039)(node, 'marginLeft') || 0);
    // Subtract parent offsets and node margins
    return (0, $lf4fc._)((0, $hwO3w._)({}, offset), {
        top: offset.top - parentOffset.top - (parseInt(marginTop, 10) || 0),
        left: offset.left - parentOffset.left - (parseInt(marginLeft, 10) || 0)
    });
}


var $4d93a061849b48c5$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


/* https://github.com/component/raf */ var $77a4d87038ac8daf$var$prev = new Date().getTime();
function $77a4d87038ac8daf$var$fallback(fn) {
    var curr = new Date().getTime();
    var ms = Math.max(0, 16 - (curr - $77a4d87038ac8daf$var$prev));
    var handle = setTimeout(fn, ms);
    $77a4d87038ac8daf$var$prev = curr;
    return handle;
}
var $77a4d87038ac8daf$var$vendors = [
    '',
    'webkit',
    'moz',
    'o',
    'ms'
];
var $77a4d87038ac8daf$var$cancelMethod = 'clearTimeout';
var $77a4d87038ac8daf$var$rafImpl = $77a4d87038ac8daf$var$fallback;
// eslint-disable-next-line import/no-mutable-exports
var $77a4d87038ac8daf$var$getKey = function(vendor, k) {
    return "".concat(vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)), "AnimationFrame");
};
if (0, $4d93a061849b48c5$export$2e2bcd8739ae039) $77a4d87038ac8daf$var$vendors.some(function(vendor) {
    var rafMethod = $77a4d87038ac8daf$var$getKey(vendor, 'request');
    if (rafMethod in window) {
        $77a4d87038ac8daf$var$cancelMethod = $77a4d87038ac8daf$var$getKey(vendor, 'cancel');
        // @ts-ignore
        $77a4d87038ac8daf$var$rafImpl = function(cb) {
            return window[rafMethod](cb);
        };
    }
    return !!$77a4d87038ac8daf$var$rafImpl;
});
var $77a4d87038ac8daf$export$70b61ad426ddbe54 = function(id) {
    // @ts-ignore
    if (typeof window[$77a4d87038ac8daf$var$cancelMethod] === 'function') window[$77a4d87038ac8daf$var$cancelMethod](id);
};
var $77a4d87038ac8daf$export$b5fe3f66a567bec0 = $77a4d87038ac8daf$var$rafImpl;





var $4YVCt = parcelRequire("4YVCt");

var $5s1kH = parcelRequire("5s1kH");

var $eAxYl = parcelRequire("eAxYl");

var $5s1kH = parcelRequire("5s1kH");
function $fa5d835b4239ad94$export$2e2bcd8739ae039() {
    return (0, $5s1kH.useState)(null);
}



var $5s1kH = parcelRequire("5s1kH");
var $4387d6f21519221e$var$toFnRef = function(ref) {
    return !ref || typeof ref === 'function' ? ref : function(value) {
        ref.current = value;
    };
};
function $4387d6f21519221e$export$c9058316764c140e(refA, refB) {
    var a = $4387d6f21519221e$var$toFnRef(refA);
    var b = $4387d6f21519221e$var$toFnRef(refB);
    return function(value) {
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $4387d6f21519221e$var$useMergedRefs(refA, refB) {
    return (0, $5s1kH.useMemo)(function() {
        return $4387d6f21519221e$export$c9058316764c140e(refA, refB);
    }, [
        refA,
        refB
    ]);
}
var $4387d6f21519221e$export$2e2bcd8739ae039 = $4387d6f21519221e$var$useMergedRefs;


var $5607029800381183$export$1e95b668f3b82d = 'top';
var $5607029800381183$export$40e543e69a8b3fbb = 'bottom';
var $5607029800381183$export$79ffe56a765070d2 = 'right';
var $5607029800381183$export$eabcd2c8791e7bf4 = 'left';
var $5607029800381183$export$dfb5619354ba860 = 'auto';
var $5607029800381183$export$aec2ce47c367b8c3 = [
    $5607029800381183$export$1e95b668f3b82d,
    $5607029800381183$export$40e543e69a8b3fbb,
    $5607029800381183$export$79ffe56a765070d2,
    $5607029800381183$export$eabcd2c8791e7bf4
];
var $5607029800381183$export$b3571188c770cc5a = 'start';
var $5607029800381183$export$bd5df0f255a350f8 = 'end';
var $5607029800381183$export$390fd549c5303b4d = 'clippingParents';
var $5607029800381183$export$d7b7311ec04a3e8f = 'viewport';
var $5607029800381183$export$ae5ab1c730825774 = 'popper';
var $5607029800381183$export$ca50aac9f3ba507f = 'reference';
var $5607029800381183$export$368f9a87e87fa4e1 = /*#__PURE__*/ $5607029800381183$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $5607029800381183$export$b3571188c770cc5a,
        placement + "-" + $5607029800381183$export$bd5df0f255a350f8
    ]);
}, []);
var $5607029800381183$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($5607029800381183$export$aec2ce47c367b8c3, [
    $5607029800381183$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $5607029800381183$export$b3571188c770cc5a,
        placement + "-" + $5607029800381183$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $5607029800381183$export$421679a7c3d56e = 'beforeRead';
var $5607029800381183$export$aafa59e2e03f2942 = 'read';
var $5607029800381183$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $5607029800381183$export$c65e99957a05207c = 'beforeMain';
var $5607029800381183$export$f22da7240b7add18 = 'main';
var $5607029800381183$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $5607029800381183$export$8d4d2d70e7d46032 = 'beforeWrite';
var $5607029800381183$export$68d8715fc104d294 = 'write';
var $5607029800381183$export$70a6e5159acce2e6 = 'afterWrite';
var $5607029800381183$export$d087d3878fdf71d5 = [
    $5607029800381183$export$421679a7c3d56e,
    $5607029800381183$export$aafa59e2e03f2942,
    $5607029800381183$export$6964f6c886723980,
    $5607029800381183$export$c65e99957a05207c,
    $5607029800381183$export$f22da7240b7add18,
    $5607029800381183$export$bab79516f2d662fe,
    $5607029800381183$export$8d4d2d70e7d46032,
    $5607029800381183$export$68d8715fc104d294,
    $5607029800381183$export$70a6e5159acce2e6
];





var $5s1kH = parcelRequire("5s1kH");

var $5s1kH = parcelRequire("5s1kH");

var $5s1kH = parcelRequire("5s1kH");
function $5127454e6cd1f513$export$2e2bcd8739ae039() {
    var mounted = (0, $5s1kH.useRef)(true);
    var isMounted = (0, $5s1kH.useRef)(function() {
        return mounted.current;
    });
    (0, $5s1kH.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $b9a3df867e3e4da1$var$useSafeState(state) {
    var isMounted = (0, $5127454e6cd1f513$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $5s1kH.useCallback)(function(nextState) {
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $b9a3df867e3e4da1$export$2e2bcd8739ae039 = $b9a3df867e3e4da1$var$useSafeState;



function $affe3860f9c9a98c$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $072dec24a96353ba$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $a7cbc45bcffc9575$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $072dec24a96353ba$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $a7cbc45bcffc9575$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $072dec24a96353ba$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $a7cbc45bcffc9575$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $072dec24a96353ba$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $2ca1915eb20d8931$export$8960430cfd85939f = Math.max;
var $2ca1915eb20d8931$export$96ec731ed4dcb222 = Math.min;
var $2ca1915eb20d8931$export$2077e0241d6afd3c = Math.round;



function $0adf9424bd0893b4$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $06729b03c3dc41af$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $0adf9424bd0893b4$export$2e2bcd8739ae039)());
}


function $f48818541e17a08b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $a7cbc45bcffc9575$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $2ca1915eb20d8931$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $2ca1915eb20d8931$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $a7cbc45bcffc9575$export$45a5e7f76e0caa8d)(element) ? (0, $072dec24a96353ba$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $06729b03c3dc41af$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $c59939a89f5d4da2$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $f48818541e17a08b$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $c16469286666491f$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $a7cbc45bcffc9575$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $036957ad3c40e181$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $ca2d7f626e4ba29c$export$2e2bcd8739ae039(element) {
    return (0, $072dec24a96353ba$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $01c801a94f1a2765$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $036957ad3c40e181$export$2e2bcd8739ae039)(element)) >= 0;
}




function $fe4733c50a029f39$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $a7cbc45bcffc9575$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $953bbe243724b25a$export$2e2bcd8739ae039(element) {
    if ((0, $036957ad3c40e181$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $a7cbc45bcffc9575$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $fe4733c50a029f39$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42904f843b518124$var$getTrueOffsetParent(element) {
    if (!(0, $a7cbc45bcffc9575$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $ca2d7f626e4ba29c$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42904f843b518124$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $0adf9424bd0893b4$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $0adf9424bd0893b4$export$2e2bcd8739ae039)());
    if (isIE && (0, $a7cbc45bcffc9575$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $ca2d7f626e4ba29c$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $953bbe243724b25a$export$2e2bcd8739ae039)(element);
    if ((0, $a7cbc45bcffc9575$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $a7cbc45bcffc9575$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $036957ad3c40e181$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $ca2d7f626e4ba29c$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42904f843b518124$export$2e2bcd8739ae039(element) {
    var window = (0, $072dec24a96353ba$export$2e2bcd8739ae039)(element);
    var offsetParent = $42904f843b518124$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $01c801a94f1a2765$export$2e2bcd8739ae039)(offsetParent) && (0, $ca2d7f626e4ba29c$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42904f843b518124$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $036957ad3c40e181$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $036957ad3c40e181$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $ca2d7f626e4ba29c$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42904f843b518124$var$getContainingBlock(element) || window;
}


function $bc3165dfae60f05f$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $171ca2c4bcd7402f$export$f28d906d67a997f3(min, value, max) {
    return (0, $2ca1915eb20d8931$export$8960430cfd85939f)(min, (0, $2ca1915eb20d8931$export$96ec731ed4dcb222)(value, max));
}
function $171ca2c4bcd7402f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $171ca2c4bcd7402f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $3ff4a366c7bfbbae$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $4a1f0c8665f5ceff$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $3ff4a366c7bfbbae$export$2e2bcd8739ae039)(), paddingObject);
}


function $f0c9da5dbd417703$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $552c0a18bac52ad9$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4a1f0c8665f5ceff$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $f0c9da5dbd417703$export$2e2bcd8739ae039)(padding, (0, $5607029800381183$export$aec2ce47c367b8c3)));
};
function $552c0a18bac52ad9$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $affe3860f9c9a98c$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $bc3165dfae60f05f$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $5607029800381183$export$eabcd2c8791e7bf4),
        (0, $5607029800381183$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $552c0a18bac52ad9$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $c59939a89f5d4da2$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $5607029800381183$export$1e95b668f3b82d) : (0, $5607029800381183$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $5607029800381183$export$40e543e69a8b3fbb) : (0, $5607029800381183$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42904f843b518124$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $171ca2c4bcd7402f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $552c0a18bac52ad9$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $c16469286666491f$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $552c0a18bac52ad9$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $552c0a18bac52ad9$var$arrow,
    effect: $552c0a18bac52ad9$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $0556216fce804615$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $d31cb62330569a00$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $d31cb62330569a00$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $2ca1915eb20d8931$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $2ca1915eb20d8931$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $d31cb62330569a00$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $5607029800381183$export$eabcd2c8791e7bf4);
    var sideY = (0, $5607029800381183$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42904f843b518124$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $072dec24a96353ba$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $fe4733c50a029f39$export$2e2bcd8739ae039)(popper);
            if ((0, $ca2d7f626e4ba29c$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $5607029800381183$export$1e95b668f3b82d) || (placement === (0, $5607029800381183$export$eabcd2c8791e7bf4) || placement === (0, $5607029800381183$export$79ffe56a765070d2)) && variation === (0, $5607029800381183$export$bd5df0f255a350f8)) {
            sideY = (0, $5607029800381183$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $5607029800381183$export$eabcd2c8791e7bf4) || (placement === (0, $5607029800381183$export$1e95b668f3b82d) || placement === (0, $5607029800381183$export$40e543e69a8b3fbb)) && variation === (0, $5607029800381183$export$bd5df0f255a350f8)) {
            sideX = (0, $5607029800381183$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $d31cb62330569a00$var$unsetSides);
    var _ref4 = roundOffsets === true ? $d31cb62330569a00$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $072dec24a96353ba$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $d31cb62330569a00$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $affe3860f9c9a98c$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $0556216fce804615$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $d31cb62330569a00$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $d31cb62330569a00$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $d31cb62330569a00$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $d31cb62330569a00$var$computeStyles,
    data: {}
};



var $0a41c62cba17c595$var$passive = {
    passive: true
};
function $0a41c62cba17c595$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $072dec24a96353ba$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $0a41c62cba17c595$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $0a41c62cba17c595$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $0a41c62cba17c595$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $0a41c62cba17c595$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $0a41c62cba17c595$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $0a41c62cba17c595$var$effect,
    data: {}
};


var $837671de04339acc$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $837671de04339acc$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $837671de04339acc$var$hash[matched];
    });
}



var $8f78b4e52fea5c2d$var$hash = {
    start: 'end',
    end: 'start'
};
function $8f78b4e52fea5c2d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $8f78b4e52fea5c2d$var$hash[matched];
    });
}








function $37bfc0a07b4a1d75$export$2e2bcd8739ae039(node) {
    var win = (0, $072dec24a96353ba$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $d73d4d465d012c2c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $f48818541e17a08b$export$2e2bcd8739ae039)((0, $fe4733c50a029f39$export$2e2bcd8739ae039)(element)).left + (0, $37bfc0a07b4a1d75$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $5581dbc2fe577ec3$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $072dec24a96353ba$export$2e2bcd8739ae039)(element);
    var html = (0, $fe4733c50a029f39$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $06729b03c3dc41af$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $d73d4d465d012c2c$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $17aec90d901d0a08$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $fe4733c50a029f39$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $37bfc0a07b4a1d75$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $2ca1915eb20d8931$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $2ca1915eb20d8931$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $d73d4d465d012c2c$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $ca2d7f626e4ba29c$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $2ca1915eb20d8931$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $c1a688aeedc0bc76$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $ca2d7f626e4ba29c$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $b9f25cca54ce9a4c$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $036957ad3c40e181$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $a7cbc45bcffc9575$export$1b3bfaa9684536aa)(node) && (0, $c1a688aeedc0bc76$export$2e2bcd8739ae039)(node)) return node;
    return $b9f25cca54ce9a4c$export$2e2bcd8739ae039((0, $953bbe243724b25a$export$2e2bcd8739ae039)(node));
}





function $dd3ef4f303ced18f$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $b9f25cca54ce9a4c$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $072dec24a96353ba$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c1a688aeedc0bc76$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($dd3ef4f303ced18f$export$2e2bcd8739ae039((0, $953bbe243724b25a$export$2e2bcd8739ae039)(target)));
}










function $5bc098eecd04eacc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $ab80f4a17a338c06$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $f48818541e17a08b$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $ab80f4a17a338c06$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $5607029800381183$export$d7b7311ec04a3e8f) ? (0, $5bc098eecd04eacc$export$2e2bcd8739ae039)((0, $5581dbc2fe577ec3$export$2e2bcd8739ae039)(element, strategy)) : (0, $a7cbc45bcffc9575$export$45a5e7f76e0caa8d)(clippingParent) ? $ab80f4a17a338c06$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $5bc098eecd04eacc$export$2e2bcd8739ae039)((0, $17aec90d901d0a08$export$2e2bcd8739ae039)((0, $fe4733c50a029f39$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $ab80f4a17a338c06$var$getClippingParents(element) {
    var clippingParents = (0, $dd3ef4f303ced18f$export$2e2bcd8739ae039)((0, $953bbe243724b25a$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $ca2d7f626e4ba29c$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $a7cbc45bcffc9575$export$1b3bfaa9684536aa)(element) ? (0, $42904f843b518124$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $a7cbc45bcffc9575$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $a7cbc45bcffc9575$export$45a5e7f76e0caa8d)(clippingParent) && (0, $c16469286666491f$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $036957ad3c40e181$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $ab80f4a17a338c06$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $ab80f4a17a338c06$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $ab80f4a17a338c06$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $2ca1915eb20d8931$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $2ca1915eb20d8931$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $2ca1915eb20d8931$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $2ca1915eb20d8931$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $ab80f4a17a338c06$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $3a483001b37174f2$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $affe3860f9c9a98c$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $0556216fce804615$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $5607029800381183$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $5607029800381183$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $5607029800381183$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $5607029800381183$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $bc3165dfae60f05f$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $5607029800381183$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $5607029800381183$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $3cb1a5179843100e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $5607029800381183$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $5607029800381183$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $5607029800381183$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4a1f0c8665f5ceff$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $f0c9da5dbd417703$export$2e2bcd8739ae039)(padding, (0, $5607029800381183$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $5607029800381183$export$ae5ab1c730825774) ? (0, $5607029800381183$export$ca50aac9f3ba507f) : (0, $5607029800381183$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $ab80f4a17a338c06$export$2e2bcd8739ae039)((0, $a7cbc45bcffc9575$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $fe4733c50a029f39$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $f48818541e17a08b$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $3a483001b37174f2$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $5bc098eecd04eacc$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $5607029800381183$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $5607029800381183$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $5607029800381183$export$79ffe56a765070d2),
                (0, $5607029800381183$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $5607029800381183$export$1e95b668f3b82d),
                (0, $5607029800381183$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $e29aad090b4a7e76$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $5607029800381183$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $0556216fce804615$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $5607029800381183$export$368f9a87e87fa4e1) : (0, $5607029800381183$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $0556216fce804615$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $5607029800381183$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $3cb1a5179843100e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $affe3860f9c9a98c$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $945d6c3e13729aaa$var$getExpandedFallbackPlacements(placement) {
    if ((0, $affe3860f9c9a98c$export$2e2bcd8739ae039)(placement) === (0, $5607029800381183$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $837671de04339acc$export$2e2bcd8739ae039)(placement);
    return [
        (0, $8f78b4e52fea5c2d$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $8f78b4e52fea5c2d$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $945d6c3e13729aaa$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $affe3860f9c9a98c$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $837671de04339acc$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $945d6c3e13729aaa$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $affe3860f9c9a98c$export$2e2bcd8739ae039)(placement) === (0, $5607029800381183$export$dfb5619354ba860) ? (0, $e29aad090b4a7e76$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $affe3860f9c9a98c$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $0556216fce804615$export$2e2bcd8739ae039)(placement) === (0, $5607029800381183$export$b3571188c770cc5a);
        var isVertical = [
            (0, $5607029800381183$export$1e95b668f3b82d),
            (0, $5607029800381183$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $3cb1a5179843100e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $5607029800381183$export$79ffe56a765070d2) : (0, $5607029800381183$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $5607029800381183$export$40e543e69a8b3fbb) : (0, $5607029800381183$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $837671de04339acc$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $837671de04339acc$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $945d6c3e13729aaa$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $945d6c3e13729aaa$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $b355a499f86d48aa$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $b355a499f86d48aa$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $5607029800381183$export$1e95b668f3b82d),
        (0, $5607029800381183$export$79ffe56a765070d2),
        (0, $5607029800381183$export$40e543e69a8b3fbb),
        (0, $5607029800381183$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $b355a499f86d48aa$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $3cb1a5179843100e$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $3cb1a5179843100e$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $b355a499f86d48aa$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $b355a499f86d48aa$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $b355a499f86d48aa$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $b355a499f86d48aa$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $b355a499f86d48aa$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $b355a499f86d48aa$var$hide
};




function $7234f53a6dba2dba$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $affe3860f9c9a98c$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $5607029800381183$export$eabcd2c8791e7bf4),
        (0, $5607029800381183$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $5607029800381183$export$eabcd2c8791e7bf4),
        (0, $5607029800381183$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7234f53a6dba2dba$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $5607029800381183$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $7234f53a6dba2dba$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7234f53a6dba2dba$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $7234f53a6dba2dba$var$offset
};



function $1f64efa320809f0a$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $3a483001b37174f2$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $1f64efa320809f0a$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $1f64efa320809f0a$var$popperOffsets,
    data: {}
};





function $4f111ffcff501457$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $8c7716e9a3ba04d9$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $3cb1a5179843100e$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $affe3860f9c9a98c$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $0556216fce804615$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $bc3165dfae60f05f$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $4f111ffcff501457$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $5607029800381183$export$1e95b668f3b82d) : (0, $5607029800381183$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $5607029800381183$export$40e543e69a8b3fbb) : (0, $5607029800381183$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $5607029800381183$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $5607029800381183$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $c59939a89f5d4da2$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $3ff4a366c7bfbbae$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $171ca2c4bcd7402f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42904f843b518124$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $171ca2c4bcd7402f$export$f28d906d67a997f3)(tether ? (0, $2ca1915eb20d8931$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $2ca1915eb20d8931$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $5607029800381183$export$1e95b668f3b82d) : (0, $5607029800381183$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $5607029800381183$export$40e543e69a8b3fbb) : (0, $5607029800381183$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $5607029800381183$export$1e95b668f3b82d),
            (0, $5607029800381183$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $171ca2c4bcd7402f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $171ca2c4bcd7402f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8c7716e9a3ba04d9$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $8c7716e9a3ba04d9$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $e478dc8ebbb86a80$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $6fa80b1beab5466a$export$2e2bcd8739ae039(node) {
    if (node === (0, $072dec24a96353ba$export$2e2bcd8739ae039)(node) || !(0, $a7cbc45bcffc9575$export$1b3bfaa9684536aa)(node)) return (0, $37bfc0a07b4a1d75$export$2e2bcd8739ae039)(node);
    else return (0, $e478dc8ebbb86a80$export$2e2bcd8739ae039)(node);
}








function $83092b44072d545d$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $2ca1915eb20d8931$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $2ca1915eb20d8931$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $83092b44072d545d$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $a7cbc45bcffc9575$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $a7cbc45bcffc9575$export$1b3bfaa9684536aa)(offsetParent) && $83092b44072d545d$var$isElementScaled(offsetParent);
    var documentElement = (0, $fe4733c50a029f39$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $f48818541e17a08b$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $036957ad3c40e181$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c1a688aeedc0bc76$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $6fa80b1beab5466a$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $a7cbc45bcffc9575$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $f48818541e17a08b$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $d73d4d465d012c2c$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $27f942eb9c768ddc$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $27f942eb9c768ddc$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $27f942eb9c768ddc$var$order(modifiers); // order based on phase
    return (0, $5607029800381183$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9c43f783fb4d64cf$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $2a76683ed518255b$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $2530f9c992279888$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $2530f9c992279888$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $2530f9c992279888$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $2530f9c992279888$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $2530f9c992279888$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $a7cbc45bcffc9575$export$45a5e7f76e0caa8d)(reference) ? (0, $dd3ef4f303ced18f$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $dd3ef4f303ced18f$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $dd3ef4f303ced18f$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $27f942eb9c768ddc$export$2e2bcd8739ae039)((0, $2a76683ed518255b$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$2530f9c992279888$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $83092b44072d545d$export$2e2bcd8739ae039)(_$reference, (0, $42904f843b518124$export$2e2bcd8739ae039)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $c59939a89f5d4da2$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9c43f783fb4d64cf$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$2530f9c992279888$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $2530f9c992279888$export$8f7491d57c8f97a9 = /*#__PURE__*/ $2530f9c992279888$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


var $c0e4e511f9635ef6$export$8f7491d57c8f97a9 = (0, $2530f9c992279888$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $b355a499f86d48aa$export$2e2bcd8739ae039),
        (0, $1f64efa320809f0a$export$2e2bcd8739ae039),
        (0, $d31cb62330569a00$export$2e2bcd8739ae039),
        (0, $0a41c62cba17c595$export$2e2bcd8739ae039),
        (0, $7234f53a6dba2dba$export$2e2bcd8739ae039),
        (0, $945d6c3e13729aaa$export$2e2bcd8739ae039),
        (0, $8c7716e9a3ba04d9$export$2e2bcd8739ae039),
        (0, $552c0a18bac52ad9$export$2e2bcd8739ae039)
    ]
});


var $469eeb30f8f064aa$var$initialPopperStyles = function initialPopperStyles(position) {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
};
var $469eeb30f8f064aa$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false
}; // In order to satisfy the current usage of options, including undefined
var $469eeb30f8f064aa$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: function effect(_ref) {
        var state = _ref.state;
        return function() {
            var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
            if ('removeAttribute' in reference) {
                var ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(function(id) {
                    return id.trim() !== popper.id;
                });
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        };
    },
    fn: function fn(_ref2) {
        var _popper$getAttribute;
        var state = _ref2.state;
        var _state$elements2 = state.elements, popper = _state$elements2.popper, reference = _state$elements2.reference;
        var role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            var ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? ids + "," + popper.id : popper.id);
        }
    }
};
var $469eeb30f8f064aa$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {boolean=}    options.eventsEnabled have Popper listen on window resize events to reposition the element
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $469eeb30f8f064aa$var$usePopper(referenceElement, popperElement, _temp) {
    var _ref3 = _temp === void 0 ? {} : _temp, _ref3$enabled = _ref3.enabled, enabled = _ref3$enabled === void 0 ? true : _ref3$enabled, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? 'bottom' : _ref3$placement, _ref3$strategy = _ref3.strategy, strategy = _ref3$strategy === void 0 ? 'absolute' : _ref3$strategy, _ref3$modifiers = _ref3.modifiers, modifiers = _ref3$modifiers === void 0 ? $469eeb30f8f064aa$var$EMPTY_MODIFIERS : _ref3$modifiers, config = (0, $4b3494cf16703bf8$export$2e2bcd8739ae039)(_ref3, [
        "enabled",
        "placement",
        "strategy",
        "modifiers"
    ]);
    var popperInstanceRef = (0, $5s1kH.useRef)();
    var update = (0, $5s1kH.useCallback)(function() {
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    var forceUpdate = (0, $5s1kH.useCallback)(function() {
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    var _useSafeState = (0, $b9a3df867e3e4da1$export$2e2bcd8739ae039)((0, $5s1kH.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: $469eeb30f8f064aa$var$initialPopperStyles(strategy),
            arrow: {}
        }
    })), popperState = _useSafeState[0], setState = _useSafeState[1];
    var updateModifier = (0, $5s1kH.useMemo)(function() {
        return {
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref4) {
                var state = _ref4.state;
                var styles = {};
                var attributes = {};
                Object.keys(state.elements).forEach(function(element) {
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        };
    }, [
        update,
        forceUpdate,
        setState
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                updateModifier,
                $469eeb30f8f064aa$var$disabledApplyStylesModifier
            ])
        }); // intentionally NOT re-running on new modifiers
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        strategy,
        placement,
        updateModifier,
        enabled
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $c0e4e511f9635ef6$export$8f7491d57c8f97a9)(referenceElement, popperElement, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                $469eeb30f8f064aa$var$ariaDescribedByModifier,
                updateModifier
            ])
        }));
        return function() {
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState(function(s) {
                    return (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, s, {
                        attributes: {},
                        styles: {
                            popper: $469eeb30f8f064aa$var$initialPopperStyles(strategy)
                        }
                    });
                });
            }
        }; // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $469eeb30f8f064aa$export$2e2bcd8739ae039 = $469eeb30f8f064aa$var$usePopper;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $2da2d935974c1cb7$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}


/* eslint-disable no-return-assign */ var $a74a450f6a18dded$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $5ba3442fe272a8e5$export$63fefd044b2bc624 = false;
var $5ba3442fe272a8e5$export$a614c6b395900f69 = false;
try {
    var $5ba3442fe272a8e5$var$options = {
        get passive () {
            return $5ba3442fe272a8e5$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $5ba3442fe272a8e5$export$a614c6b395900f69 = $5ba3442fe272a8e5$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $a74a450f6a18dded$export$2e2bcd8739ae039) {
        window.addEventListener('test', $5ba3442fe272a8e5$var$options, $5ba3442fe272a8e5$var$options);
        window.removeEventListener('test', $5ba3442fe272a8e5$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $5ba3442fe272a8e5$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$5ba3442fe272a8e5$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$5ba3442fe272a8e5$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $5ba3442fe272a8e5$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $5ba3442fe272a8e5$export$2e2bcd8739ae039 = $5ba3442fe272a8e5$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $7043104b937686c3$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $7043104b937686c3$export$2e2bcd8739ae039 = $7043104b937686c3$var$removeEventListener;


function $e262c8e456af131a$var$listen(node, eventName, handler, options) {
    (0, $5ba3442fe272a8e5$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $7043104b937686c3$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $e262c8e456af131a$export$2e2bcd8739ae039 = $e262c8e456af131a$var$listen;



var $5s1kH = parcelRequire("5s1kH");

var $XnYkK = parcelRequire("XnYkK");

var $5s1kH = parcelRequire("5s1kH");

var $5s1kH = parcelRequire("5s1kH");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $51902a681e360869$var$useCommittedRef(value) {
    var ref = (0, $5s1kH.useRef)(value);
    (0, $5s1kH.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $51902a681e360869$export$2e2bcd8739ae039 = $51902a681e360869$var$useCommittedRef;


function $d89bb6db9b845d64$export$2e2bcd8739ae039(fn) {
    var ref = (0, $51902a681e360869$export$2e2bcd8739ae039)(fn);
    return (0, $5s1kH.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _ref;
        return ref.current && (_ref = ref).current.apply(_ref, (0, $XnYkK._)(args));
    }, [
        ref
    ]);
}


var $31fa01f4fed714ba$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $31fa01f4fed714ba$var$__DEV__ = false;
var $31fa01f4fed714ba$var$warning = function warning() {};
if ($31fa01f4fed714ba$var$__DEV__) {
    var $31fa01f4fed714ba$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $31fa01f4fed714ba$var$warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $31fa01f4fed714ba$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$31fa01f4fed714ba$exports = $31fa01f4fed714ba$var$warning;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $ff17c63f57c1c2f6$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $eAxYl = parcelRequire("eAxYl");
function $1b3628a5f113bd44$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($eAxYl))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}


var $80ea30fad40be037$export$2e2bcd8739ae039 = function(componentOrElement) {
    return (0, $ff17c63f57c1c2f6$export$2e2bcd8739ae039)((0, $1b3628a5f113bd44$export$2e2bcd8739ae039)(componentOrElement));
};


var $d6206ff1dc01241a$var$escapeKeyCode = 27;
var $d6206ff1dc01241a$var$noop = function noop() {};
function $d6206ff1dc01241a$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $d6206ff1dc01241a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $d6206ff1dc01241a$var$getRefTarget = function getRefTarget(ref) {
    return ref && ('current' in ref ? ref.current : ref);
};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $d6206ff1dc01241a$var$useRootClose(ref, onRootClose, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, disabled = _ref.disabled, _ref$clickTrigger = _ref.clickTrigger, clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;
    var preventMouseRootCloseRef = (0, $5s1kH.useRef)(false);
    var onClose = onRootClose || $d6206ff1dc01241a$var$noop;
    var handleMouseCapture = (0, $5s1kH.useCallback)(function(e) {
        var _e$composedPath$;
        var currentTarget = $d6206ff1dc01241a$var$getRefTarget(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($31fa01f4fed714ba$exports)))(!!currentTarget, "RootClose captured a close event but does not have a ref to compare it to. useRootClose(), should be passed a ref that resolves to a DOM node");
        preventMouseRootCloseRef.current = !currentTarget || $d6206ff1dc01241a$var$isModifiedEvent(e) || !$d6206ff1dc01241a$var$isLeftClickEvent(e) || !!(0, $2da2d935974c1cb7$export$2e2bcd8739ae039)(currentTarget, (_e$composedPath$ = e.composedPath == null ? void 0 : e.composedPath()[0]) != null ? _e$composedPath$ : e.target);
    }, [
        ref
    ]);
    var handleMouse = (0, $d89bb6db9b845d64$export$2e2bcd8739ae039)(function(e) {
        if (!preventMouseRootCloseRef.current) onClose(e);
    });
    var handleKeyUp = (0, $d89bb6db9b845d64$export$2e2bcd8739ae039)(function(e) {
        if (e.keyCode === $d6206ff1dc01241a$var$escapeKeyCode) onClose(e);
    });
    (0, $5s1kH.useEffect)(function() {
        if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        var currentEvent = window.event;
        var doc = (0, $80ea30fad40be037$export$2e2bcd8739ae039)($d6206ff1dc01241a$var$getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        var removeMouseCaptureListener = (0, $e262c8e456af131a$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        var removeMouseListener = (0, $e262c8e456af131a$export$2e2bcd8739ae039)(doc, clickTrigger, function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        var removeKeyupListener = (0, $e262c8e456af131a$export$2e2bcd8739ae039)(doc, 'keyup', function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        var mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map(function(el) {
            return (0, $e262c8e456af131a$export$2e2bcd8739ae039)(el, 'mousemove', $d6206ff1dc01241a$var$noop);
        });
        return function() {
            removeMouseCaptureListener();
            removeMouseListener();
            removeKeyupListener();
            mobileSafariHackListeners.forEach(function(remove) {
                return remove();
            });
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleMouse,
        handleKeyUp
    ]);
}
var $d6206ff1dc01241a$export$2e2bcd8739ae039 = $d6206ff1dc01241a$var$useRootClose;




var $5s1kH = parcelRequire("5s1kH");
var $f89284df4e8e790c$export$c91fd81e6d65f84a = function resolveContainerRef(ref) {
    var _ref;
    if (typeof document === 'undefined') return null;
    if (ref == null) return (0, $ff17c63f57c1c2f6$export$2e2bcd8739ae039)().body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if ((_ref = ref) != null && _ref.nodeType) return ref || null;
    return null;
};
function $f89284df4e8e790c$export$2e2bcd8739ae039(ref, onResolved) {
    var _useState = (0, $5s1kH.useState)(function() {
        return $f89284df4e8e790c$export$c91fd81e6d65f84a(ref);
    }), resolvedRef = _useState[0], setRef = _useState[1];
    if (!resolvedRef) {
        var earlyRef = $f89284df4e8e790c$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $5s1kH.useEffect)(function() {
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $5s1kH.useEffect)(function() {
        var nextRef = $f89284df4e8e790c$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}



function $c606d5ebcd908a09$export$ba6dad097c8f5c38(modifiers) {
    var result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
     // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach(function(m) {
        result[m.name] = m;
    });
    return result;
}
function $c606d5ebcd908a09$export$af3a999d4a134c86(map) {
    if (map === void 0) map = {};
    if (Array.isArray(map)) return map;
    return Object.keys(map).map(function(k) {
        map[k].name = k;
        return map[k];
    });
}
function $c606d5ebcd908a09$export$2e2bcd8739ae039(_ref) {
    var _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    var enabled = _ref.enabled, enableEvents = _ref.enableEvents, placement = _ref.placement, flip = _ref.flip, offset = _ref.offset, fixed = _ref.fixed, containerPadding = _ref.containerPadding, arrowElement = _ref.arrowElement, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig;
    var modifiers = $c606d5ebcd908a09$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $c606d5ebcd908a09$export$af3a999d4a134c86((0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, modifiers, {
            eventListeners: {
                enabled: enableEvents
            },
            preventOverflow: (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, modifiers.preventOverflow, {
                options: containerPadding ? (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}


/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ var $6a43729912364714$var$Overlay = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).forwardRef(function(props, outerRef) {
    var flip = props.flip, offset = props.offset, placement = props.placement, _props$containerPaddi = props.containerPadding, containerPadding = _props$containerPaddi === void 0 ? 5 : _props$containerPaddi, _props$popperConfig = props.popperConfig, popperConfig = _props$popperConfig === void 0 ? {} : _props$popperConfig, Transition = props.transition;
    var _useCallbackRef = (0, $fa5d835b4239ad94$export$2e2bcd8739ae039)(), rootElement = _useCallbackRef[0], attachRef = _useCallbackRef[1];
    var _useCallbackRef2 = (0, $fa5d835b4239ad94$export$2e2bcd8739ae039)(), arrowElement = _useCallbackRef2[0], attachArrowRef = _useCallbackRef2[1];
    var mergedRef = (0, $4387d6f21519221e$export$2e2bcd8739ae039)(attachRef, outerRef);
    var container = (0, $f89284df4e8e790c$export$2e2bcd8739ae039)(props.container);
    var target = (0, $f89284df4e8e790c$export$2e2bcd8739ae039)(props.target);
    var _useState = (0, $5s1kH.useState)(!props.show), exited = _useState[0], setExited = _useState[1];
    var _usePopper = (0, $469eeb30f8f064aa$export$2e2bcd8739ae039)(target, rootElement, (0, $c606d5ebcd908a09$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    })), styles = _usePopper.styles, attributes = _usePopper.attributes, popper = (0, $4b3494cf16703bf8$export$2e2bcd8739ae039)(_usePopper, [
        "styles",
        "attributes"
    ]);
    if (props.show) {
        if (exited) setExited(false);
    } else if (!props.transition && !exited) setExited(true);
    var handleHidden = function handleHidden() {
        setExited(true);
        if (props.onExited) props.onExited.apply(props, arguments);
    }; // Don't un-render the overlay while it's transitioning out.
    var mountOverlay = props.show || Transition && !exited;
    (0, $d6206ff1dc01241a$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    var child = props.children((0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, popper, {
        show: !!props.show,
        props: (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, attributes.popper, {
            style: styles.popper,
            ref: mergedRef
        }),
        arrowProps: (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, attributes.arrow, {
            style: styles.arrow,
            ref: attachArrowRef
        })
    }));
    if (Transition) {
        var onExit = props.onExit, onExiting = props.onExiting, onEnter = props.onEnter, onEntering = props.onEntering, onEntered = props.onEntered;
        child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(Transition, {
            "in": props.show,
            appear: true,
            onExit: onExit,
            onExiting: onExiting,
            onExited: handleHidden,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
        }, child);
    }
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eAxYl))).createPortal(child, container) : null;
});
$6a43729912364714$var$Overlay.displayName = 'Overlay';
$6a43729912364714$var$Overlay.propTypes = {
    /**
   * Set the visibility of the Overlay
   */ show: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).bool,
    /** Specify where the overlay element is positioned in relation to the target element */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).oneOf((0, $5607029800381183$export$803cd8101b6c182b)),
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */ target: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).any,
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).any,
    /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).bool,
    /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *     [string]: string | number,
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     [string]: string | number,
   *   },
   * }) => React.Element}
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func.isRequired,
    /**
   * Control how much space there is between the edge of the boundary element and overlay.
   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
   */ containerPadding: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).number,
    /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */ popperConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object,
    /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */ rootClose: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).bool,
    /**
   * Specify event for toggling overlay
   */ rootCloseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).oneOf([
        'click',
        'mousedown'
    ]),
    /**
   * Specify disabled for disable RootCloseWrapper
   */ rootCloseDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).bool,
    /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */ onHide: function onHide(props) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (props.rootClose) {
            var _PropTypes$func;
            return (_PropTypes$func = (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func).isRequired.apply(_PropTypes$func, [
                props
            ].concat(args));
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func.apply((0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))), [
            props
        ].concat(args));
    },
    /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */ // @ts-ignore
    transition: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).elementType,
    /**
   * Callback fired before the Overlay transitions in
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    /**
   * Callback fired as the Overlay begins to transition in
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    /**
   * Callback fired after the Overlay finishes transitioning in
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    /**
   * Callback fired right before the Overlay transitions out
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    /**
   * Callback fired as the Overlay begins to transition out
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    /**
   * Callback fired after the Overlay finishes transitioning out
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func
};
var $6a43729912364714$export$2e2bcd8739ae039 = $6a43729912364714$var$Overlay;




var $fRRA4 = parcelRequire("fRRA4");


function $281907b8d7a224c6$export$2e2bcd8739ae039(node, client) {
    var win = (0, $3c3b38590ce4fe70$export$2e2bcd8739ae039)(node);
    return win ? win.innerHeight : client ? node.clientHeight : (0, $ff2c299c017232ac$export$2e2bcd8739ae039)(node).height;
}


var $599af5572367d16f$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $599af5572367d16f$export$2e2bcd8739ae039(element, selector) {
    return $599af5572367d16f$var$toArray(element.querySelectorAll(selector));
}



var $99055aef89f1fd74$var$matchesImpl;
function $99055aef89f1fd74$export$2e2bcd8739ae039(node, selector) {
    if (!$99055aef89f1fd74$var$matchesImpl) {
        var body = document.body;
        var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
        $99055aef89f1fd74$var$matchesImpl = function(n, s) {
            return nativeMatch.call(n, s);
        };
    }
    return $99055aef89f1fd74$var$matchesImpl(node, selector);
}


function $4e8e467862c0a79b$export$2e2bcd8739ae039(node, selector, stopAt) {
    if (node.closest && !stopAt) node.closest(selector);
    var nextNode = node;
    do {
        if ((0, $99055aef89f1fd74$export$2e2bcd8739ae039)(nextNode, selector)) return nextNode;
        nextNode = nextNode.parentElement;
    }while (nextNode && nextNode !== stopAt && nextNode.nodeType === document.ELEMENT_NODE);
    return null;
}


/* eslint-disable no-return-assign */ 
var $8783f74669e69ef8$export$63fefd044b2bc624 = false;
var $8783f74669e69ef8$export$a614c6b395900f69 = false;
try {
    var $8783f74669e69ef8$var$options = {
        get passive () {
            return $8783f74669e69ef8$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $8783f74669e69ef8$export$a614c6b395900f69 = $8783f74669e69ef8$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $4d93a061849b48c5$export$2e2bcd8739ae039) {
        window.addEventListener('test', $8783f74669e69ef8$var$options, $8783f74669e69ef8$var$options);
        window.removeEventListener('test', $8783f74669e69ef8$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 *
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $8783f74669e69ef8$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$8783f74669e69ef8$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$8783f74669e69ef8$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $8783f74669e69ef8$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $8783f74669e69ef8$export$2e2bcd8739ae039 = $8783f74669e69ef8$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 *
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $e465acca88129c89$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $e465acca88129c89$export$2e2bcd8739ae039 = $e465acca88129c89$var$removeEventListener;


function $163f59dea1e2873c$var$listen(node, eventName, handler, options) {
    (0, $8783f74669e69ef8$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $e465acca88129c89$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $163f59dea1e2873c$export$2e2bcd8739ae039 = $163f59dea1e2873c$var$listen;



var $kO46s = parcelRequire("kO46s");
var $c4e211d47f952c70$exports = {};
var $551599cf9f2a77f1$exports = {};
var $e9c3978d0f00a764$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e9c3978d0f00a764$var$nativeCeil = Math.ceil, $e9c3978d0f00a764$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $e9c3978d0f00a764$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $e9c3978d0f00a764$var$nativeMax($e9c3978d0f00a764$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$e9c3978d0f00a764$exports = $e9c3978d0f00a764$var$baseRange;




var $b9Xpq = parcelRequire("b9Xpq");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $551599cf9f2a77f1$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $8fd83702a1740eba$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $b9Xpq(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $b9Xpq(end);
        step = step === undefined ? start < end ? 1 : -1 : $b9Xpq(step);
        return $e9c3978d0f00a764$exports(start, end, step, fromRight);
    };
}
$551599cf9f2a77f1$exports = $551599cf9f2a77f1$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $c4e211d47f952c70$var$range = $551599cf9f2a77f1$exports();
$c4e211d47f952c70$exports = $c4e211d47f952c70$var$range;


var $074df527245e0057$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $074df527245e0057$var$isEqual(first, second) {
    if (first === second) return true;
    if ($074df527245e0057$var$safeIsNaN(first) && $074df527245e0057$var$safeIsNaN(second)) return true;
    return false;
}
function $074df527245e0057$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$074df527245e0057$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $074df527245e0057$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $074df527245e0057$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}




function $99a9f0718f601fba$export$2e2bcd8739ae039(node, client) {
    var win = (0, $3c3b38590ce4fe70$export$2e2bcd8739ae039)(node);
    return win ? win.innerWidth : client ? node.clientWidth : (0, $ff2c299c017232ac$export$2e2bcd8739ae039)(node).width;
}


var $b90a193c64a52ca2$exports = {};
var $9deb0640a64ad9d7$exports = {};

var $8YoPc = parcelRequire("8YoPc");
var $5fe0979e0968076b$exports = {};

var $chLJV = parcelRequire("chLJV");

var $is21e = parcelRequire("is21e");

var $gjQr4 = parcelRequire("gjQr4");
/** Built-in value references. */ var $5fe0979e0968076b$var$spreadableSymbol = $chLJV ? $chLJV.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $5fe0979e0968076b$var$isFlattenable(value) {
    return $gjQr4(value) || $is21e(value) || !!($5fe0979e0968076b$var$spreadableSymbol && value && value[$5fe0979e0968076b$var$spreadableSymbol]);
}
$5fe0979e0968076b$exports = $5fe0979e0968076b$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $9deb0640a64ad9d7$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $5fe0979e0968076b$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $9deb0640a64ad9d7$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8YoPc(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$9deb0640a64ad9d7$exports = $9deb0640a64ad9d7$var$baseFlatten;


var $571c919ccb454545$exports = {};

var $cFzTG = parcelRequire("cFzTG");

var $6ZSXD = parcelRequire("6ZSXD");

var $4rBIZ = parcelRequire("4rBIZ");
var $a17f1604b8a6dbe5$exports = {};
var $ca5ca347523da811$exports = {};
var $309f22226bf389d5$exports = {};
var $11c294f57b49f2c0$exports = {};
var $992b385fa86a8b52$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $992b385fa86a8b52$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$992b385fa86a8b52$exports = $992b385fa86a8b52$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $11c294f57b49f2c0$var$baseFor = $992b385fa86a8b52$exports();
$11c294f57b49f2c0$exports = $11c294f57b49f2c0$var$baseFor;



var $10CyO = parcelRequire("10CyO");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $309f22226bf389d5$var$baseForOwn(object, iteratee) {
    return object && $11c294f57b49f2c0$exports(object, iteratee, $10CyO);
}
$309f22226bf389d5$exports = $309f22226bf389d5$var$baseForOwn;


var $a1fdd8b051ff49a1$exports = {};

var $13FKp = parcelRequire("13FKp");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $a1fdd8b051ff49a1$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$13FKp(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$a1fdd8b051ff49a1$exports = $a1fdd8b051ff49a1$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $ca5ca347523da811$var$baseEach = $a1fdd8b051ff49a1$exports($309f22226bf389d5$exports);
$ca5ca347523da811$exports = $ca5ca347523da811$var$baseEach;



var $13FKp = parcelRequire("13FKp");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $a17f1604b8a6dbe5$var$baseMap(collection, iteratee) {
    var index = -1, result = $13FKp(collection) ? Array(collection.length) : [];
    $ca5ca347523da811$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$a17f1604b8a6dbe5$exports = $a17f1604b8a6dbe5$var$baseMap;


var $9f4a582f6f04b46a$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $9f4a582f6f04b46a$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$9f4a582f6f04b46a$exports = $9f4a582f6f04b46a$var$baseSortBy;



var $dhi5l = parcelRequire("dhi5l");
var $dda6b2956f2876a9$exports = {};
var $036662826c44a0c4$exports = {};

var $kRf9i = parcelRequire("kRf9i");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $036662826c44a0c4$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $kRf9i(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $kRf9i(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$036662826c44a0c4$exports = $036662826c44a0c4$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $dda6b2956f2876a9$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $036662826c44a0c4$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$dda6b2956f2876a9$exports = $dda6b2956f2876a9$var$compareMultiple;



var $236oS = parcelRequire("236oS");

var $gjQr4 = parcelRequire("gjQr4");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $571c919ccb454545$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $cFzTG(iteratees, function(iteratee) {
        if ($gjQr4(iteratee)) return function(value) {
            return $6ZSXD(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $236oS
    ];
    var index = -1;
    iteratees = $cFzTG(iteratees, $dhi5l($4rBIZ));
    var result = $a17f1604b8a6dbe5$exports(collection, function(value, key, collection) {
        var criteria = $cFzTG(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $9f4a582f6f04b46a$exports(result, function(object, other) {
        return $dda6b2956f2876a9$exports(object, other, orders);
    });
}
$571c919ccb454545$exports = $571c919ccb454545$var$baseOrderBy;


var $578bb4332d0d04ce$exports = {};

var $236oS = parcelRequire("236oS");
var $7c570ed575b083a4$exports = {};
var $6c2383eb4cfb928e$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $6c2383eb4cfb928e$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$6c2383eb4cfb928e$exports = $6c2383eb4cfb928e$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $7c570ed575b083a4$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $7c570ed575b083a4$var$overRest(func, start, transform) {
    start = $7c570ed575b083a4$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $7c570ed575b083a4$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $6c2383eb4cfb928e$exports(func, this, otherArgs);
    };
}
$7c570ed575b083a4$exports = $7c570ed575b083a4$var$overRest;


var $6c6e10f723c7c2d2$exports = {};
var $3ce4fbc082140924$exports = {};
var $64eb104ffa6adf6a$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $64eb104ffa6adf6a$var$constant(value) {
    return function() {
        return value;
    };
}
$64eb104ffa6adf6a$exports = $64eb104ffa6adf6a$var$constant;


var $52ed343b83e15791$exports = {};

var $kWWbB = parcelRequire("kWWbB");
var $52ed343b83e15791$var$defineProperty = function() {
    try {
        var func = $kWWbB(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$52ed343b83e15791$exports = $52ed343b83e15791$var$defineProperty;



var $236oS = parcelRequire("236oS");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $3ce4fbc082140924$var$baseSetToString = !$52ed343b83e15791$exports ? $236oS : function baseSetToString(func, string) {
    return $52ed343b83e15791$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $64eb104ffa6adf6a$exports(string),
        'writable': true
    });
};
$3ce4fbc082140924$exports = $3ce4fbc082140924$var$baseSetToString;


var $34908ed1d76b6d5e$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $34908ed1d76b6d5e$var$HOT_COUNT = 800, $34908ed1d76b6d5e$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $34908ed1d76b6d5e$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $34908ed1d76b6d5e$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $34908ed1d76b6d5e$var$nativeNow(), remaining = $34908ed1d76b6d5e$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $34908ed1d76b6d5e$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$34908ed1d76b6d5e$exports = $34908ed1d76b6d5e$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $6c6e10f723c7c2d2$var$setToString = $34908ed1d76b6d5e$exports($3ce4fbc082140924$exports);
$6c6e10f723c7c2d2$exports = $6c6e10f723c7c2d2$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $578bb4332d0d04ce$var$baseRest(func, start) {
    return $6c6e10f723c7c2d2$exports($7c570ed575b083a4$exports(func, start, $236oS), func + '');
}
$578bb4332d0d04ce$exports = $578bb4332d0d04ce$var$baseRest;



/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $b90a193c64a52ca2$var$sortBy = $578bb4332d0d04ce$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $8fd83702a1740eba$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $8fd83702a1740eba$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $571c919ccb454545$exports(collection, $9deb0640a64ad9d7$exports(iteratees, 1), []);
});
$b90a193c64a52ca2$exports = $b90a193c64a52ca2$var$sortBy;



var $064e68c4f9e480d9$var$size;
function $064e68c4f9e480d9$export$2e2bcd8739ae039(recalc) {
    if (!$064e68c4f9e480d9$var$size && $064e68c4f9e480d9$var$size !== 0 || recalc) {
        if (0, $4d93a061849b48c5$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $064e68c4f9e480d9$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $064e68c4f9e480d9$var$size;
}






function $1f80157ba4fb8c42$export$2e2bcd8739ae039(r) {
    return (0, $fb4d26e82ba6fb15$export$2e2bcd8739ae039)(r) || (0, $952a18113cc8e861$export$2e2bcd8739ae039)(r) || (0, $b8ad54cc00c41c02$export$2e2bcd8739ae039)(r) || (0, $a87139a1cc4fa105$export$2e2bcd8739ae039)();
}


/**
 * Checks if a given element has a CSS class.
 *
 * @param element the element
 * @param className the CSS class name
 */ function $162ddd062bd6556f$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return " ".concat(element.className.baseVal || element.className, " ").indexOf(" ".concat(className, " ")) !== -1;
}


function $46e290cb0f60e3f6$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $162ddd062bd6556f$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = "".concat(element.className, " ").concat(className);
        else element.setAttribute('class', "".concat(element.className && element.className.baseVal || '', " ").concat(className));
    }
}


function $49c08283aa9ff20a$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)".concat(classToRemove, "(?:\\s|$)"), 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $49c08283aa9ff20a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $49c08283aa9ff20a$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $49c08283aa9ff20a$var$replaceClassName(element.className && element.className.baseVal || '', className));
}


var $64f60a1a06f93aab$exports = {};


var $1g3Fq = parcelRequire("1g3Fq");

var $076df402836cc6a6$exports = {};

var $68gR9 = parcelRequire("68gR9");
var $adfce11fa0578b60$exports = {};

var $gpxvq = parcelRequire("gpxvq");

var $brxeA = parcelRequire("brxeA");
var $b6f4d7b1519cc002$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $b6f4d7b1519cc002$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$b6f4d7b1519cc002$exports = $b6f4d7b1519cc002$var$nativeKeysIn;


/** Used for built-in method references. */ var $adfce11fa0578b60$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $adfce11fa0578b60$var$hasOwnProperty = $adfce11fa0578b60$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $adfce11fa0578b60$var$baseKeysIn(object) {
    if (!$gpxvq(object)) return $b6f4d7b1519cc002$exports(object);
    var isProto = $brxeA(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$adfce11fa0578b60$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$adfce11fa0578b60$exports = $adfce11fa0578b60$var$baseKeysIn;



var $13FKp = parcelRequire("13FKp");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $076df402836cc6a6$var$keysIn(object) {
    return $13FKp(object) ? $68gR9(object, true) : $adfce11fa0578b60$exports(object);
}
$076df402836cc6a6$exports = $076df402836cc6a6$var$keysIn;


/** Used for built-in method references. */ var $64f60a1a06f93aab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64f60a1a06f93aab$var$hasOwnProperty = $64f60a1a06f93aab$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $64f60a1a06f93aab$var$defaults = $578bb4332d0d04ce$exports(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $8fd83702a1740eba$exports(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $076df402836cc6a6$exports(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $1g3Fq(value, $64f60a1a06f93aab$var$objectProto[key]) && !$64f60a1a06f93aab$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
$64f60a1a06f93aab$exports = $64f60a1a06f93aab$var$defaults;


var $600820978ae08d7e$exports = {};
var $f854ac3b5e52249c$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f854ac3b5e52249c$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $52ed343b83e15791$exports) $52ed343b83e15791$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$f854ac3b5e52249c$exports = $f854ac3b5e52249c$var$baseAssignValue;




var $4rBIZ = parcelRequire("4rBIZ");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $600820978ae08d7e$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $4rBIZ(iteratee, 3);
    $309f22226bf389d5$exports(object, function(value, key, object) {
        $f854ac3b5e52249c$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$600820978ae08d7e$exports = $600820978ae08d7e$var$mapValues;


var $ac236e04f1d9f092$exports = {};

var $cFzTG = parcelRequire("cFzTG");
var $7f1384959f2ed38e$exports = {};

var $9E4Ag = parcelRequire("9E4Ag");
var $0454108225c5de14$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $0454108225c5de14$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$0454108225c5de14$exports = $0454108225c5de14$var$arrayEach;


var $caeb314fe4327972$exports = {};


var $1g3Fq = parcelRequire("1g3Fq");
/** Used for built-in method references. */ var $caeb314fe4327972$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $caeb314fe4327972$var$hasOwnProperty = $caeb314fe4327972$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $caeb314fe4327972$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($caeb314fe4327972$var$hasOwnProperty.call(object, key) && $1g3Fq(objValue, value)) || value === undefined && !(key in object)) $f854ac3b5e52249c$exports(object, key, value);
}
$caeb314fe4327972$exports = $caeb314fe4327972$var$assignValue;


var $e256351a99796af9$exports = {};
var $f7a7d2b1ddde0497$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $f7a7d2b1ddde0497$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $f854ac3b5e52249c$exports(object, key, newValue);
        else $caeb314fe4327972$exports(object, key, newValue);
    }
    return object;
}
$f7a7d2b1ddde0497$exports = $f7a7d2b1ddde0497$var$copyObject;



var $10CyO = parcelRequire("10CyO");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e256351a99796af9$var$baseAssign(object, source) {
    return object && $f7a7d2b1ddde0497$exports(source, $10CyO(source), object);
}
$e256351a99796af9$exports = $e256351a99796af9$var$baseAssign;


var $d12519822a16c986$exports = {};


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $d12519822a16c986$var$baseAssignIn(object, source) {
    return object && $f7a7d2b1ddde0497$exports(source, $076df402836cc6a6$exports(source), object);
}
$d12519822a16c986$exports = $d12519822a16c986$var$baseAssignIn;



var $6Ri8i = parcelRequire("6Ri8i");
var $b9d67e62484ca010$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $b9d67e62484ca010$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$b9d67e62484ca010$exports = $b9d67e62484ca010$var$copyArray;


var $f86ead2ce7c9d93f$exports = {};


var $6BN2m = parcelRequire("6BN2m");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $f86ead2ce7c9d93f$var$copySymbols(source, object) {
    return $f7a7d2b1ddde0497$exports(source, $6BN2m(source), object);
}
$f86ead2ce7c9d93f$exports = $f86ead2ce7c9d93f$var$copySymbols;


var $78528ed514b8f790$exports = {};

var $b3b6a43a49504b25$exports = {};

var $8YoPc = parcelRequire("8YoPc");
var $440c6bf2f31acff4$exports = {};

var $bjp8J = parcelRequire("bjp8J");
/** Built-in value references. */ var $440c6bf2f31acff4$var$getPrototype = $bjp8J(Object.getPrototypeOf, Object);
$440c6bf2f31acff4$exports = $440c6bf2f31acff4$var$getPrototype;



var $6BN2m = parcelRequire("6BN2m");

var $ctJOG = parcelRequire("ctJOG");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b3b6a43a49504b25$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b3b6a43a49504b25$var$getSymbolsIn = !$b3b6a43a49504b25$var$nativeGetSymbols ? $ctJOG : function getSymbolsIn(object) {
    var result = [];
    while(object){
        $8YoPc(result, $6BN2m(object));
        object = $440c6bf2f31acff4$exports(object);
    }
    return result;
};
$b3b6a43a49504b25$exports = $b3b6a43a49504b25$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $78528ed514b8f790$var$copySymbolsIn(source, object) {
    return $f7a7d2b1ddde0497$exports(source, $b3b6a43a49504b25$exports(source), object);
}
$78528ed514b8f790$exports = $78528ed514b8f790$var$copySymbolsIn;



var $8saWy = parcelRequire("8saWy");
var $4e58a0f14d36c360$exports = {};

var $2QD6E = parcelRequire("2QD6E");


/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $4e58a0f14d36c360$var$getAllKeysIn(object) {
    return $2QD6E(object, $076df402836cc6a6$exports, $b3b6a43a49504b25$exports);
}
$4e58a0f14d36c360$exports = $4e58a0f14d36c360$var$getAllKeysIn;



var $d372L = parcelRequire("d372L");
var $9a19019634dd8409$exports = {};
/** Used for built-in method references. */ var $9a19019634dd8409$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9a19019634dd8409$var$hasOwnProperty = $9a19019634dd8409$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $9a19019634dd8409$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $9a19019634dd8409$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$9a19019634dd8409$exports = $9a19019634dd8409$var$initCloneArray;


var $53a0cbf9232ea331$exports = {};
var $1a8087d43fdd30e2$exports = {};

var $bj3BB = parcelRequire("bj3BB");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $1a8087d43fdd30e2$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $bj3BB(result).set(new $bj3BB(arrayBuffer));
    return result;
}
$1a8087d43fdd30e2$exports = $1a8087d43fdd30e2$var$cloneArrayBuffer;


var $ec03d2e9d62eee8a$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $ec03d2e9d62eee8a$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $1a8087d43fdd30e2$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$ec03d2e9d62eee8a$exports = $ec03d2e9d62eee8a$var$cloneDataView;


var $f75e82c7aa05a96e$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $f75e82c7aa05a96e$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $f75e82c7aa05a96e$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $f75e82c7aa05a96e$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$f75e82c7aa05a96e$exports = $f75e82c7aa05a96e$var$cloneRegExp;


var $e80c91e2e78a911a$exports = {};

var $chLJV = parcelRequire("chLJV");
/** Used to convert symbols to primitives and strings. */ var $e80c91e2e78a911a$var$symbolProto = $chLJV ? $chLJV.prototype : undefined, $e80c91e2e78a911a$var$symbolValueOf = $e80c91e2e78a911a$var$symbolProto ? $e80c91e2e78a911a$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e80c91e2e78a911a$var$cloneSymbol(symbol) {
    return $e80c91e2e78a911a$var$symbolValueOf ? Object($e80c91e2e78a911a$var$symbolValueOf.call(symbol)) : {};
}
$e80c91e2e78a911a$exports = $e80c91e2e78a911a$var$cloneSymbol;


var $c5e5263420ab99f4$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $c5e5263420ab99f4$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $1a8087d43fdd30e2$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$c5e5263420ab99f4$exports = $c5e5263420ab99f4$var$cloneTypedArray;


/** `Object#toString` result references. */ var $53a0cbf9232ea331$var$boolTag = '[object Boolean]', $53a0cbf9232ea331$var$dateTag = '[object Date]', $53a0cbf9232ea331$var$mapTag = '[object Map]', $53a0cbf9232ea331$var$numberTag = '[object Number]', $53a0cbf9232ea331$var$regexpTag = '[object RegExp]', $53a0cbf9232ea331$var$setTag = '[object Set]', $53a0cbf9232ea331$var$stringTag = '[object String]', $53a0cbf9232ea331$var$symbolTag = '[object Symbol]';
var $53a0cbf9232ea331$var$arrayBufferTag = '[object ArrayBuffer]', $53a0cbf9232ea331$var$dataViewTag = '[object DataView]', $53a0cbf9232ea331$var$float32Tag = '[object Float32Array]', $53a0cbf9232ea331$var$float64Tag = '[object Float64Array]', $53a0cbf9232ea331$var$int8Tag = '[object Int8Array]', $53a0cbf9232ea331$var$int16Tag = '[object Int16Array]', $53a0cbf9232ea331$var$int32Tag = '[object Int32Array]', $53a0cbf9232ea331$var$uint8Tag = '[object Uint8Array]', $53a0cbf9232ea331$var$uint8ClampedTag = '[object Uint8ClampedArray]', $53a0cbf9232ea331$var$uint16Tag = '[object Uint16Array]', $53a0cbf9232ea331$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $53a0cbf9232ea331$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $53a0cbf9232ea331$var$arrayBufferTag:
            return $1a8087d43fdd30e2$exports(object);
        case $53a0cbf9232ea331$var$boolTag:
        case $53a0cbf9232ea331$var$dateTag:
            return new Ctor(+object);
        case $53a0cbf9232ea331$var$dataViewTag:
            return $ec03d2e9d62eee8a$exports(object, isDeep);
        case $53a0cbf9232ea331$var$float32Tag:
        case $53a0cbf9232ea331$var$float64Tag:
        case $53a0cbf9232ea331$var$int8Tag:
        case $53a0cbf9232ea331$var$int16Tag:
        case $53a0cbf9232ea331$var$int32Tag:
        case $53a0cbf9232ea331$var$uint8Tag:
        case $53a0cbf9232ea331$var$uint8ClampedTag:
        case $53a0cbf9232ea331$var$uint16Tag:
        case $53a0cbf9232ea331$var$uint32Tag:
            return $c5e5263420ab99f4$exports(object, isDeep);
        case $53a0cbf9232ea331$var$mapTag:
            return new Ctor;
        case $53a0cbf9232ea331$var$numberTag:
        case $53a0cbf9232ea331$var$stringTag:
            return new Ctor(object);
        case $53a0cbf9232ea331$var$regexpTag:
            return $f75e82c7aa05a96e$exports(object);
        case $53a0cbf9232ea331$var$setTag:
            return new Ctor;
        case $53a0cbf9232ea331$var$symbolTag:
            return $e80c91e2e78a911a$exports(object);
    }
}
$53a0cbf9232ea331$exports = $53a0cbf9232ea331$var$initCloneByTag;


var $28b2894a266ea599$exports = {};
var $add0e413e6ae8f62$exports = {};

var $gpxvq = parcelRequire("gpxvq");
/** Built-in value references. */ var $add0e413e6ae8f62$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $add0e413e6ae8f62$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$gpxvq(proto)) return {};
        if ($add0e413e6ae8f62$var$objectCreate) return $add0e413e6ae8f62$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$add0e413e6ae8f62$exports = $add0e413e6ae8f62$var$baseCreate;




var $brxeA = parcelRequire("brxeA");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $28b2894a266ea599$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$brxeA(object) ? $add0e413e6ae8f62$exports($440c6bf2f31acff4$exports(object)) : {};
}
$28b2894a266ea599$exports = $28b2894a266ea599$var$initCloneObject;



var $gjQr4 = parcelRequire("gjQr4");

var $18svd = parcelRequire("18svd");
var $f5adcdccd9bc95ba$exports = {};
var $5a86c2f040075776$exports = {};

var $d372L = parcelRequire("d372L");

var $7N4ni = parcelRequire("7N4ni");
/** `Object#toString` result references. */ var $5a86c2f040075776$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $5a86c2f040075776$var$baseIsMap(value) {
    return $7N4ni(value) && $d372L(value) == $5a86c2f040075776$var$mapTag;
}
$5a86c2f040075776$exports = $5a86c2f040075776$var$baseIsMap;



var $dhi5l = parcelRequire("dhi5l");

var $51zJC = parcelRequire("51zJC");
/* Node.js helper references. */ var $f5adcdccd9bc95ba$var$nodeIsMap = $51zJC && $51zJC.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $f5adcdccd9bc95ba$var$isMap = $f5adcdccd9bc95ba$var$nodeIsMap ? $dhi5l($f5adcdccd9bc95ba$var$nodeIsMap) : $5a86c2f040075776$exports;
$f5adcdccd9bc95ba$exports = $f5adcdccd9bc95ba$var$isMap;



var $gpxvq = parcelRequire("gpxvq");
var $21805b34de5e94e7$exports = {};
var $c54fe12dd812ac3f$exports = {};

var $d372L = parcelRequire("d372L");

var $7N4ni = parcelRequire("7N4ni");
/** `Object#toString` result references. */ var $c54fe12dd812ac3f$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $c54fe12dd812ac3f$var$baseIsSet(value) {
    return $7N4ni(value) && $d372L(value) == $c54fe12dd812ac3f$var$setTag;
}
$c54fe12dd812ac3f$exports = $c54fe12dd812ac3f$var$baseIsSet;



var $dhi5l = parcelRequire("dhi5l");

var $51zJC = parcelRequire("51zJC");
/* Node.js helper references. */ var $21805b34de5e94e7$var$nodeIsSet = $51zJC && $51zJC.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $21805b34de5e94e7$var$isSet = $21805b34de5e94e7$var$nodeIsSet ? $dhi5l($21805b34de5e94e7$var$nodeIsSet) : $c54fe12dd812ac3f$exports;
$21805b34de5e94e7$exports = $21805b34de5e94e7$var$isSet;



var $10CyO = parcelRequire("10CyO");

/** Used to compose bitmasks for cloning. */ var $7f1384959f2ed38e$var$CLONE_DEEP_FLAG = 1, $7f1384959f2ed38e$var$CLONE_FLAT_FLAG = 2, $7f1384959f2ed38e$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $7f1384959f2ed38e$var$argsTag = '[object Arguments]', $7f1384959f2ed38e$var$arrayTag = '[object Array]', $7f1384959f2ed38e$var$boolTag = '[object Boolean]', $7f1384959f2ed38e$var$dateTag = '[object Date]', $7f1384959f2ed38e$var$errorTag = '[object Error]', $7f1384959f2ed38e$var$funcTag = '[object Function]', $7f1384959f2ed38e$var$genTag = '[object GeneratorFunction]', $7f1384959f2ed38e$var$mapTag = '[object Map]', $7f1384959f2ed38e$var$numberTag = '[object Number]', $7f1384959f2ed38e$var$objectTag = '[object Object]', $7f1384959f2ed38e$var$regexpTag = '[object RegExp]', $7f1384959f2ed38e$var$setTag = '[object Set]', $7f1384959f2ed38e$var$stringTag = '[object String]', $7f1384959f2ed38e$var$symbolTag = '[object Symbol]', $7f1384959f2ed38e$var$weakMapTag = '[object WeakMap]';
var $7f1384959f2ed38e$var$arrayBufferTag = '[object ArrayBuffer]', $7f1384959f2ed38e$var$dataViewTag = '[object DataView]', $7f1384959f2ed38e$var$float32Tag = '[object Float32Array]', $7f1384959f2ed38e$var$float64Tag = '[object Float64Array]', $7f1384959f2ed38e$var$int8Tag = '[object Int8Array]', $7f1384959f2ed38e$var$int16Tag = '[object Int16Array]', $7f1384959f2ed38e$var$int32Tag = '[object Int32Array]', $7f1384959f2ed38e$var$uint8Tag = '[object Uint8Array]', $7f1384959f2ed38e$var$uint8ClampedTag = '[object Uint8ClampedArray]', $7f1384959f2ed38e$var$uint16Tag = '[object Uint16Array]', $7f1384959f2ed38e$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $7f1384959f2ed38e$var$cloneableTags = {};
$7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$argsTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$arrayTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$arrayBufferTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$dataViewTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$boolTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$dateTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$float32Tag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$float64Tag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$int8Tag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$int16Tag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$int32Tag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$mapTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$numberTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$objectTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$regexpTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$setTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$stringTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$symbolTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$uint8Tag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$uint8ClampedTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$uint16Tag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$uint32Tag] = true;
$7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$errorTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$funcTag] = $7f1384959f2ed38e$var$cloneableTags[$7f1384959f2ed38e$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $7f1384959f2ed38e$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $7f1384959f2ed38e$var$CLONE_DEEP_FLAG, isFlat = bitmask & $7f1384959f2ed38e$var$CLONE_FLAT_FLAG, isFull = bitmask & $7f1384959f2ed38e$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$gpxvq(value)) return value;
    var isArr = $gjQr4(value);
    if (isArr) {
        result = $9a19019634dd8409$exports(value);
        if (!isDeep) return $b9d67e62484ca010$exports(value, result);
    } else {
        var tag = $d372L(value), isFunc = tag == $7f1384959f2ed38e$var$funcTag || tag == $7f1384959f2ed38e$var$genTag;
        if ($18svd(value)) return $6Ri8i(value, isDeep);
        if (tag == $7f1384959f2ed38e$var$objectTag || tag == $7f1384959f2ed38e$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $28b2894a266ea599$exports(value);
            if (!isDeep) return isFlat ? $78528ed514b8f790$exports(value, $d12519822a16c986$exports(result, value)) : $f86ead2ce7c9d93f$exports(value, $e256351a99796af9$exports(result, value));
        } else {
            if (!$7f1384959f2ed38e$var$cloneableTags[tag]) return object ? value : {};
            result = $53a0cbf9232ea331$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $9E4Ag);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($21805b34de5e94e7$exports(value)) value.forEach(function(subValue) {
        result.add($7f1384959f2ed38e$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($f5adcdccd9bc95ba$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $7f1384959f2ed38e$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $4e58a0f14d36c360$exports : $8saWy : isFlat ? $076df402836cc6a6$exports : $10CyO;
    var props = isArr ? undefined : keysFunc(value);
    $0454108225c5de14$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $caeb314fe4327972$exports(result, key, $7f1384959f2ed38e$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$7f1384959f2ed38e$exports = $7f1384959f2ed38e$var$baseClone;


var $7f92bb2fb735ed18$exports = {};

var $fWwJl = parcelRequire("fWwJl");
var $db05b149858a4331$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $db05b149858a4331$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$db05b149858a4331$exports = $db05b149858a4331$var$last;


var $5dff6d35070b0393$exports = {};

var $6ZSXD = parcelRequire("6ZSXD");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $5dff6d35070b0393$var$parent(object, path) {
    return path.length < 2 ? object : $6ZSXD(object, $6ccd38f05dee86c7$exports(path, 0, -1));
}
$5dff6d35070b0393$exports = $5dff6d35070b0393$var$parent;



var $gaqpM = parcelRequire("gaqpM");
/** Used for built-in method references. */ var $7f92bb2fb735ed18$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7f92bb2fb735ed18$var$hasOwnProperty = $7f92bb2fb735ed18$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $7f92bb2fb735ed18$var$baseUnset(object, path) {
    path = $fWwJl(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $gaqpM(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$7f92bb2fb735ed18$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $5dff6d35070b0393$exports(object, path);
    return obj == null || delete obj[$gaqpM($db05b149858a4331$exports(path))];
}
$7f92bb2fb735ed18$exports = $7f92bb2fb735ed18$var$baseUnset;



var $fWwJl = parcelRequire("fWwJl");

var $72c4170fb371e0b1$exports = {};
var $49f714e21762aab4$exports = {};

var $anDuf = parcelRequire("anDuf");


var $7N4ni = parcelRequire("7N4ni");
/** `Object#toString` result references. */ var $49f714e21762aab4$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $49f714e21762aab4$var$funcProto = Function.prototype, $49f714e21762aab4$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $49f714e21762aab4$var$funcToString = $49f714e21762aab4$var$funcProto.toString;
/** Used to check objects for own properties. */ var $49f714e21762aab4$var$hasOwnProperty = $49f714e21762aab4$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $49f714e21762aab4$var$objectCtorString = $49f714e21762aab4$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $49f714e21762aab4$var$isPlainObject(value) {
    if (!$7N4ni(value) || $anDuf(value) != $49f714e21762aab4$var$objectTag) return false;
    var proto = $440c6bf2f31acff4$exports(value);
    if (proto === null) return true;
    var Ctor = $49f714e21762aab4$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $49f714e21762aab4$var$funcToString.call(Ctor) == $49f714e21762aab4$var$objectCtorString;
}
$49f714e21762aab4$exports = $49f714e21762aab4$var$isPlainObject;


/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $72c4170fb371e0b1$var$customOmitClone(value) {
    return $49f714e21762aab4$exports(value) ? undefined : value;
}
$72c4170fb371e0b1$exports = $72c4170fb371e0b1$var$customOmitClone;


var $8ca3bbdc85ad97fe$exports = {};
var $3f471f82e23b78af$exports = {};

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f471f82e23b78af$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $9deb0640a64ad9d7$exports(array, 1) : [];
}
$3f471f82e23b78af$exports = $3f471f82e23b78af$var$flatten;




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $8ca3bbdc85ad97fe$var$flatRest(func) {
    return $6c6e10f723c7c2d2$exports($7c570ed575b083a4$exports(func, undefined, $3f471f82e23b78af$exports), func + '');
}
$8ca3bbdc85ad97fe$exports = $8ca3bbdc85ad97fe$var$flatRest;



/** Used to compose bitmasks for cloning. */ var $ac236e04f1d9f092$var$CLONE_DEEP_FLAG = 1, $ac236e04f1d9f092$var$CLONE_FLAT_FLAG = 2, $ac236e04f1d9f092$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $ac236e04f1d9f092$var$omit = $8ca3bbdc85ad97fe$exports(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $cFzTG(paths, function(path) {
        path = $fWwJl(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $f7a7d2b1ddde0497$exports(object, $4e58a0f14d36c360$exports(object), result);
    if (isDeep) result = $7f1384959f2ed38e$exports(result, $ac236e04f1d9f092$var$CLONE_DEEP_FLAG | $ac236e04f1d9f092$var$CLONE_FLAT_FLAG | $ac236e04f1d9f092$var$CLONE_SYMBOLS_FLAG, $72c4170fb371e0b1$exports);
    var length = paths.length;
    while(length--)$7f92bb2fb735ed18$exports(result, paths[length]);
    return result;
});
$ac236e04f1d9f092$exports = $ac236e04f1d9f092$var$omit;


var $a071b9768ce9bbc0$exports = {};




var $4rBIZ = parcelRequire("4rBIZ");


var $gjQr4 = parcelRequire("gjQr4");

var $18svd = parcelRequire("18svd");

var $7mdb9 = parcelRequire("7mdb9");

var $gpxvq = parcelRequire("gpxvq");

var $bXxa9 = parcelRequire("bXxa9");
/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */ function $a071b9768ce9bbc0$var$transform(object, iteratee, accumulator) {
    var isArr = $gjQr4(object), isArrLike = isArr || $18svd(object) || $bXxa9(object);
    iteratee = $4rBIZ(iteratee, 4);
    if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) accumulator = isArr ? new Ctor : [];
        else if ($gpxvq(object)) accumulator = $7mdb9(Ctor) ? $add0e413e6ae8f62$exports($440c6bf2f31acff4$exports(object)) : {};
        else accumulator = {};
    }
    (isArrLike ? $0454108225c5de14$exports : $309f22226bf389d5$exports)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
    });
    return accumulator;
}
$a071b9768ce9bbc0$exports = $a071b9768ce9bbc0$var$transform;


var $13bb91f8f4cfae7d$exports = {};
!function(e, i) {
    $13bb91f8f4cfae7d$exports = i();
}($13bb91f8f4cfae7d$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});


var $15f8cfd78617715b$exports = {};
!function(e, t) {
    $15f8cfd78617715b$exports = t();
}($15f8cfd78617715b$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.isSameOrAfter = function(e, t) {
            return this.isSame(e, t) || this.isAfter(e, t);
        };
    };
});


var $53dbf02e1c04a37c$exports = {};
!function(e, i) {
    $53dbf02e1c04a37c$exports = i();
}($53dbf02e1c04a37c$exports, function() {
    "use strict";
    return function(e, i) {
        i.prototype.isSameOrBefore = function(e, i) {
            return this.isSame(e, i) || this.isBefore(e, i);
        };
    };
});


var $0bb94353ccece6ea$exports = {};
!function(n, e) {
    $0bb94353ccece6ea$exports = e();
}($0bb94353ccece6ea$exports, function() {
    "use strict";
    return function(n, e, t) {
        var r = e.prototype, o = function o(n) {
            return n && (n.indexOf ? n : n.s);
        }, u = function u(n, e, t, r, u) {
            var i = n.name ? n : n.$locale(), a = o(i[e]), s = o(i[t]), f = a || s.map(function(n) {
                return n.slice(0, r);
            });
            if (!u) return f;
            var d = i.weekStart;
            return f.map(function(n, e) {
                return f[(e + (d || 0)) % 7];
            });
        }, i = function i() {
            return t.Ls[t.locale()];
        }, a = function a(n, e) {
            return n.formats[e] || function(n) {
                return n.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(n, e, t) {
                    return e || t.slice(1);
                });
            }(n.formats[e.toUpperCase()]);
        }, s = function s() {
            var n = this;
            return {
                months: function months(e) {
                    return e ? e.format("MMMM") : u(n, "months");
                },
                monthsShort: function monthsShort(e) {
                    return e ? e.format("MMM") : u(n, "monthsShort", "months", 3);
                },
                firstDayOfWeek: function firstDayOfWeek() {
                    return n.$locale().weekStart || 0;
                },
                weekdays: function weekdays(e) {
                    return e ? e.format("dddd") : u(n, "weekdays");
                },
                weekdaysMin: function weekdaysMin(e) {
                    return e ? e.format("dd") : u(n, "weekdaysMin", "weekdays", 2);
                },
                weekdaysShort: function weekdaysShort(e) {
                    return e ? e.format("ddd") : u(n, "weekdaysShort", "weekdays", 3);
                },
                longDateFormat: function longDateFormat(e) {
                    return a(n.$locale(), e);
                },
                meridiem: this.$locale().meridiem,
                ordinal: this.$locale().ordinal
            };
        };
        r.localeData = function() {
            return s.bind(this)();
        }, t.localeData = function() {
            var n = i();
            return {
                firstDayOfWeek: function firstDayOfWeek() {
                    return n.weekStart || 0;
                },
                weekdays: function weekdays() {
                    return t.weekdays();
                },
                weekdaysShort: function weekdaysShort() {
                    return t.weekdaysShort();
                },
                weekdaysMin: function weekdaysMin() {
                    return t.weekdaysMin();
                },
                months: function months() {
                    return t.months();
                },
                monthsShort: function monthsShort() {
                    return t.monthsShort();
                },
                longDateFormat: function longDateFormat(e) {
                    return a(n, e);
                },
                meridiem: n.meridiem,
                ordinal: n.ordinal
            };
        }, t.months = function() {
            return u(i(), "months");
        }, t.monthsShort = function() {
            return u(i(), "monthsShort", "months", 3);
        }, t.weekdays = function(n) {
            return u(i(), "weekdays", null, null, n);
        }, t.weekdaysShort = function(n) {
            return u(i(), "weekdaysShort", "weekdays", 3, n);
        }, t.weekdaysMin = function(n) {
            return u(i(), "weekdaysMin", "weekdays", 2, n);
        };
    };
});


var $bed1b736941ac624$exports = {};
!function(e, t) {
    $bed1b736941ac624$exports = t();
}($bed1b736941ac624$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var _$o = this.$locale().formats, _$n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === _$o ? {} : _$o);
            return i.call(this, _$n);
        };
    };
});


var $2764ea4f1964f22a$exports = {};
!function(e, n) {
    $2764ea4f1964f22a$exports = n();
}($2764ea4f1964f22a$exports, function() {
    "use strict";
    return function(e, n, t) {
        var i = function i(e, n) {
            if (!n || !n.length || 1 === n.length && !n[0] || 1 === n.length && Array.isArray(n[0]) && !n[0].length) return null;
            var _$t;
            1 === n.length && n[0].length > 0 && (n = n[0]);
            _$t = (n = n.filter(function(e) {
                return e;
            }))[0];
            for(var i = 1; i < n.length; i += 1)n[i].isValid() && !n[i][e](_$t) || (_$t = n[i]);
            return _$t;
        };
        t.max = function() {
            var e = [].slice.call(arguments, 0);
            return i("isAfter", e);
        }, t.min = function() {
            var e = [].slice.call(arguments, 0);
            return i("isBefore", e);
        };
    };
});


var $2d81fd35d55e9c85$exports = {};
!function(t, i) {
    $2d81fd35d55e9c85$exports = i();
}($2d81fd35d55e9c85$exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var r = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), r.call(this, t);
        };
        var o = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else o.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var _$n = this.$utils().u;
            if (_$n(s)) return this.$u ? 0 : _$n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var _$s = t.match(i);
                if (!_$s) return null;
                var _$f = ("" + _$s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], _$n = _$f[0], u = 60 * +_$f[1] + +_$f[2];
                return 0 === u ? 0 : "+" === _$n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s;
            if (0 === u) return this.utc(f);
            var r = this.clone();
            if (f) return r.$offset = u, r.$u = !1, r;
            var o = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            return (r = this.local().add(u + o, t)).$offset = u, r.$x.$localOffset = o, r;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), _$f = n(t).local();
            return c.call(s, _$f, i, e);
        };
    };
});


var $4cfde2e16cee3c00$exports = {};
!function(e, t) {
    $4cfde2e16cee3c00$exports = t();
}($4cfde2e16cee3c00$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.isLeapYear = function() {
            return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
        };
    };
});


function $ba6e2539d0024c3d$var$NoopWrapper(props) {
    return props.children;
}
var $ba6e2539d0024c3d$export$444b3ab0cb9aec40 = {
    PREVIOUS: 'PREV',
    NEXT: 'NEXT',
    TODAY: 'TODAY',
    DATE: 'DATE'
};
var $ba6e2539d0024c3d$export$5cb791131c501f6a = {
    MONTH: 'month',
    WEEK: 'week',
    WORK_WEEK: 'work_week',
    DAY: 'day',
    AGENDA: 'agenda'
};
var $ba6e2539d0024c3d$var$viewNames$1 = Object.keys($ba6e2539d0024c3d$export$5cb791131c501f6a).map(function(k) {
    return $ba6e2539d0024c3d$export$5cb791131c501f6a[k];
});
var $ba6e2539d0024c3d$var$accessor$1 = (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func
]);
var $ba6e2539d0024c3d$var$dateFormat = (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).any;
var $ba6e2539d0024c3d$var$dateRangeFormat$6 = (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func;
/**
 * accepts either an array of builtin view names:
 *
 * ```
 * views={['month', 'day', 'agenda']}
 * ```
 *
 * or an object hash of the view name and the component (or boolean for builtin)
 *
 * ```
 * views={{
 *   month: true,
 *   week: false,
 *   workweek: WorkWeekViewComponent,
 * }}
 * ```
 */ var $ba6e2539d0024c3d$var$views = (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).oneOf($ba6e2539d0024c3d$var$viewNames$1)),
    (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).objectOf(function(prop, key) {
        var isBuiltinView = $ba6e2539d0024c3d$var$viewNames$1.indexOf(key) !== -1 && typeof prop[key] === 'boolean';
        if (isBuiltinView) return null;
        else {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).elementType.apply((0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))), [
                prop,
                key
            ].concat(args));
        }
    })
]);
var $ba6e2539d0024c3d$var$DayLayoutAlgorithmPropType = (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).oneOf([
        'overlap',
        'no-overlap'
    ]),
    (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func
]);
/* eslint no-fallthrough: off */ var $ba6e2539d0024c3d$var$MILLI = {
    seconds: 1000,
    minutes: 60000,
    hours: 3600000,
    day: 86400000
};
function $ba6e2539d0024c3d$var$firstVisibleDay(date, localizer) {
    var firstOfMonth = $06a62230e027db68$exports.startOf(date, 'month');
    return $06a62230e027db68$exports.startOf(firstOfMonth, 'week', localizer.startOfWeek());
}
function $ba6e2539d0024c3d$var$lastVisibleDay(date, localizer) {
    var endOfMonth = $06a62230e027db68$exports.endOf(date, 'month');
    return $06a62230e027db68$exports.endOf(endOfMonth, 'week', localizer.startOfWeek());
}
function $ba6e2539d0024c3d$var$visibleDays(date, localizer) {
    var current = $ba6e2539d0024c3d$var$firstVisibleDay(date, localizer), last = $ba6e2539d0024c3d$var$lastVisibleDay(date, localizer), days = [];
    while($06a62230e027db68$exports.lte(current, last, 'day')){
        days.push(current);
        current = $06a62230e027db68$exports.add(current, 1, 'day');
    }
    return days;
}
function $ba6e2539d0024c3d$var$ceil(date, unit) {
    var floor = $06a62230e027db68$exports.startOf(date, unit);
    return $06a62230e027db68$exports.eq(floor, date) ? floor : $06a62230e027db68$exports.add(floor, 1, unit);
}
function $ba6e2539d0024c3d$var$range(start, end) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
    var current = start, days = [];
    while($06a62230e027db68$exports.lte(current, end, unit)){
        days.push(current);
        current = $06a62230e027db68$exports.add(current, 1, unit);
    }
    return days;
}
function $ba6e2539d0024c3d$var$merge(date, time) {
    if (time == null && date == null) return null;
    if (time == null) time = new Date();
    if (date == null) date = new Date();
    date = $06a62230e027db68$exports.startOf(date, 'day');
    date = $06a62230e027db68$exports.hours(date, $06a62230e027db68$exports.hours(time));
    date = $06a62230e027db68$exports.minutes(date, $06a62230e027db68$exports.minutes(time));
    date = $06a62230e027db68$exports.seconds(date, $06a62230e027db68$exports.seconds(time));
    return $06a62230e027db68$exports.milliseconds(date, $06a62230e027db68$exports.milliseconds(time));
}
function $ba6e2539d0024c3d$var$isJustDate(date) {
    return $06a62230e027db68$exports.hours(date) === 0 && $06a62230e027db68$exports.minutes(date) === 0 && $06a62230e027db68$exports.seconds(date) === 0 && $06a62230e027db68$exports.milliseconds(date) === 0;
}
function $ba6e2539d0024c3d$var$duration(start, end, unit, firstOfWeek) {
    if (unit === 'day') unit = 'date';
    return Math.abs(// eslint-disable-next-line import/namespace
    $06a62230e027db68$exports[unit](start, undefined, firstOfWeek) - // eslint-disable-next-line import/namespace
    $06a62230e027db68$exports[unit](end, undefined, firstOfWeek));
}
function $ba6e2539d0024c3d$var$diff(dateA, dateB, unit) {
    if (!unit || unit === 'milliseconds') return Math.abs(+dateA - +dateB);
    // the .round() handles an edge case
    // with DST where the total won't be exact
    // since one day in the range may be shorter/longer by an hour
    return Math.round(Math.abs(+$06a62230e027db68$exports.startOf(dateA, unit) / $ba6e2539d0024c3d$var$MILLI[unit] - +$06a62230e027db68$exports.startOf(dateB, unit) / $ba6e2539d0024c3d$var$MILLI[unit]));
}
function $ba6e2539d0024c3d$var$ownKeys$a(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba6e2539d0024c3d$var$_objectSpread$a(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba6e2539d0024c3d$var$ownKeys$a(Object(t), true).forEach(function(r) {
            (0, $bfbb99364ffa951d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba6e2539d0024c3d$var$ownKeys$a(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ba6e2539d0024c3d$var$localePropType = (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func
]);
function $ba6e2539d0024c3d$var$_format(localizer, formatter, value, format, culture) {
    var result = typeof format === 'function' ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);
    (0, (/*@__PURE__*/$parcel$interopDefault($08d9ec57190e35c9$exports)))(result == null || typeof result === 'string', '`localizer format(..)` must return a string, null, or undefined');
    return result;
}
/**
 * This date conversion was moved out of TimeSlots.js, to
 * allow for localizer override
 * @param {Date} dt - The date to start from
 * @param {Number} minutesFromMidnight
 * @param {Number} offset
 * @returns {Date}
 */ function $ba6e2539d0024c3d$var$getSlotDate(dt, minutesFromMidnight, offset) {
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, minutesFromMidnight + offset, 0, 0);
}
function $ba6e2539d0024c3d$var$getDstOffset(start, end) {
    return start.getTimezoneOffset() - end.getTimezoneOffset();
}
// if the start is on a DST-changing day but *after* the moment of DST
// transition we need to add those extra minutes to our minutesFromMidnight
function $ba6e2539d0024c3d$var$getTotalMin(start, end) {
    return $ba6e2539d0024c3d$var$diff(start, end, 'minutes') + $ba6e2539d0024c3d$var$getDstOffset(start, end);
}
function $ba6e2539d0024c3d$var$getMinutesFromMidnight(start) {
    var daystart = (0, $06a62230e027db68$export$38d7278c783c77a7)(start, 'day');
    return $ba6e2539d0024c3d$var$diff(daystart, start, 'minutes') + $ba6e2539d0024c3d$var$getDstOffset(daystart, start);
}
// These two are used by DateSlotMetrics
function $ba6e2539d0024c3d$var$continuesPrior(start, first) {
    return (0, $06a62230e027db68$export$b961576059b7aeb6)(start, first, 'day');
}
function $ba6e2539d0024c3d$var$continuesAfter(start, end, last) {
    var singleDayDuration = (0, $06a62230e027db68$export$9663ddc1cf085b32)(start, end, 'minutes');
    return singleDayDuration ? (0, $06a62230e027db68$export$aac79e834d1b4aed)(end, last, 'minutes') : (0, $06a62230e027db68$export$dafeacbfe3530cd9)(end, last, 'minutes');
}
function $ba6e2539d0024c3d$var$daySpan(start, end) {
    return $ba6e2539d0024c3d$var$duration(start, end, 'day');
}
// These two are used by eventLevels
function $ba6e2539d0024c3d$var$sortEvents$1(_ref) {
    var _ref$evtA = _ref.evtA, aStart = _ref$evtA.start, aEnd = _ref$evtA.end, aAllDay = _ref$evtA.allDay, _ref$evtB = _ref.evtB, bStart = _ref$evtB.start, bEnd = _ref$evtB.end, bAllDay = _ref$evtB.allDay;
    var startSort = +(0, $06a62230e027db68$export$38d7278c783c77a7)(aStart, 'day') - +(0, $06a62230e027db68$export$38d7278c783c77a7)(bStart, 'day');
    var durA = $ba6e2539d0024c3d$var$daySpan(aStart, aEnd);
    var durB = $ba6e2539d0024c3d$var$daySpan(bStart, bEnd);
    return startSort || // sort by start Day first
    durB - durA || // events spanning multiple days go first
    !!bAllDay - !!aAllDay || // then allDay single day events
    +aStart - +bStart || // then sort by start time
    +aEnd - +bEnd // then sort by end time
    ;
}
function $ba6e2539d0024c3d$var$inEventRange(_ref2) {
    var _ref2$event = _ref2.event, start = _ref2$event.start, end = _ref2$event.end, _ref2$range = _ref2.range, rangeStart = _ref2$range.start, rangeEnd = _ref2$range.end;
    var eStart = (0, $06a62230e027db68$export$38d7278c783c77a7)(start, 'day');
    var startsBeforeEnd = (0, $06a62230e027db68$export$489c007ed603c05d)(eStart, rangeEnd, 'day');
    // when the event is zero duration we need to handle a bit differently
    var sameMin = (0, $06a62230e027db68$export$9bc858421bf255d1)(eStart, end, 'minutes');
    var endsAfterStart = sameMin ? (0, $06a62230e027db68$export$dafeacbfe3530cd9)(end, rangeStart, 'minutes') : (0, $06a62230e027db68$export$aac79e834d1b4aed)(end, rangeStart, 'minutes');
    return startsBeforeEnd && endsAfterStart;
}
// other localizers treats 'day' and 'date' equality very differently, so we
// abstract the change the 'localizer.eq(date1, date2, 'day') into this
// new method, where they can be treated correctly by the localizer overrides
function $ba6e2539d0024c3d$var$isSameDate(date1, date2) {
    return (0, $06a62230e027db68$export$9663ddc1cf085b32)(date1, date2, 'day');
}
function $ba6e2539d0024c3d$var$startAndEndAreDateOnly(start, end) {
    return $ba6e2539d0024c3d$var$isJustDate(start) && $ba6e2539d0024c3d$var$isJustDate(end);
}
var $ba6e2539d0024c3d$export$193ddab16544ff5b = /*#__PURE__*/ (0, $b944111f291d7912$export$2e2bcd8739ae039)(function DateLocalizer(spec) {
    var _this = this;
    (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, DateLocalizer);
    (0, (/*@__PURE__*/$parcel$interopDefault($08d9ec57190e35c9$exports)))(typeof spec.format === 'function', 'date localizer `format(..)` must be a function');
    (0, (/*@__PURE__*/$parcel$interopDefault($08d9ec57190e35c9$exports)))(typeof spec.firstOfWeek === 'function', 'date localizer `firstOfWeek(..)` must be a function');
    this.propType = spec.propType || $ba6e2539d0024c3d$var$localePropType;
    this.formats = spec.formats;
    this.format = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return $ba6e2539d0024c3d$var$_format.apply(void 0, [
            _this,
            spec.format
        ].concat(args));
    };
    // These date arithmetic methods can be overriden by the localizer
    this.startOfWeek = spec.firstOfWeek;
    this.merge = spec.merge || $ba6e2539d0024c3d$var$merge;
    this.inRange = spec.inRange || (0, $06a62230e027db68$export$ddf89a9c5af38f94);
    this.lt = spec.lt || (0, $06a62230e027db68$export$b961576059b7aeb6);
    this.lte = spec.lte || (0, $06a62230e027db68$export$489c007ed603c05d);
    this.gt = spec.gt || (0, $06a62230e027db68$export$dafeacbfe3530cd9);
    this.gte = spec.gte || (0, $06a62230e027db68$export$aac79e834d1b4aed);
    this.eq = spec.eq || (0, $06a62230e027db68$export$9663ddc1cf085b32);
    this.neq = spec.neq || (0, $06a62230e027db68$export$9bc858421bf255d1);
    this.startOf = spec.startOf || (0, $06a62230e027db68$export$38d7278c783c77a7);
    this.endOf = spec.endOf || (0, $06a62230e027db68$export$2d3c3037220ab47a);
    this.add = spec.add || (0, $06a62230e027db68$export$e16d8520af44a096);
    this.range = spec.range || $ba6e2539d0024c3d$var$range;
    this.diff = spec.diff || $ba6e2539d0024c3d$var$diff;
    this.ceil = spec.ceil || $ba6e2539d0024c3d$var$ceil;
    this.min = spec.min || (0, $06a62230e027db68$export$96ec731ed4dcb222);
    this.max = spec.max || (0, $06a62230e027db68$export$8960430cfd85939f);
    this.minutes = spec.minutes || (0, $06a62230e027db68$export$666252b437cce0c7);
    this.daySpan = spec.daySpan || $ba6e2539d0024c3d$var$daySpan;
    this.firstVisibleDay = spec.firstVisibleDay || $ba6e2539d0024c3d$var$firstVisibleDay;
    this.lastVisibleDay = spec.lastVisibleDay || $ba6e2539d0024c3d$var$lastVisibleDay;
    this.visibleDays = spec.visibleDays || $ba6e2539d0024c3d$var$visibleDays;
    this.getSlotDate = spec.getSlotDate || $ba6e2539d0024c3d$var$getSlotDate;
    this.getTimezoneOffset = spec.getTimezoneOffset || function(value) {
        return value.getTimezoneOffset();
    };
    this.getDstOffset = spec.getDstOffset || $ba6e2539d0024c3d$var$getDstOffset;
    this.getTotalMin = spec.getTotalMin || $ba6e2539d0024c3d$var$getTotalMin;
    this.getMinutesFromMidnight = spec.getMinutesFromMidnight || $ba6e2539d0024c3d$var$getMinutesFromMidnight;
    this.continuesPrior = spec.continuesPrior || $ba6e2539d0024c3d$var$continuesPrior;
    this.continuesAfter = spec.continuesAfter || $ba6e2539d0024c3d$var$continuesAfter;
    this.sortEvents = spec.sortEvents || $ba6e2539d0024c3d$var$sortEvents$1;
    this.inEventRange = spec.inEventRange || $ba6e2539d0024c3d$var$inEventRange;
    this.isSameDate = spec.isSameDate || $ba6e2539d0024c3d$var$isSameDate;
    this.startAndEndAreDateOnly = spec.startAndEndAreDateOnly || $ba6e2539d0024c3d$var$startAndEndAreDateOnly;
    this.segmentOffset = spec.browserTZOffset ? spec.browserTZOffset() : 0;
});
function $ba6e2539d0024c3d$var$mergeWithDefaults(localizer, culture, formatOverrides, messages) {
    var formats = $ba6e2539d0024c3d$var$_objectSpread$a($ba6e2539d0024c3d$var$_objectSpread$a({}, localizer.formats), formatOverrides);
    return $ba6e2539d0024c3d$var$_objectSpread$a($ba6e2539d0024c3d$var$_objectSpread$a({}, localizer), {}, {
        messages: messages,
        startOfWeek: function startOfWeek() {
            return localizer.startOfWeek(culture);
        },
        format: function format(value, _format2) {
            return localizer.format(value, formats[_format2] || _format2, culture);
        }
    });
}
function $ba6e2539d0024c3d$var$_callSuper$f(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$f() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$f() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$f = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba6e2539d0024c3d$var$Toolbar = /*#__PURE__*/ function(_React$Component) {
    function Toolbar() {
        var _this;
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, Toolbar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $ba6e2539d0024c3d$var$_callSuper$f(this, Toolbar, [].concat(args));
        _this.navigate = function(action) {
            _this.props.onNavigate(action);
        };
        _this.view = function(view) {
            _this.props.onView(view);
        };
        return _this;
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(Toolbar, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(Toolbar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, messages = _this$props.localizer.messages, label = _this$props.label;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: "rbc-toolbar"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                    className: "rbc-btn-group"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
                    type: "button",
                    onClick: this.navigate.bind(null, $ba6e2539d0024c3d$export$444b3ab0cb9aec40.TODAY)
                }, messages.today), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
                    type: "button",
                    onClick: this.navigate.bind(null, $ba6e2539d0024c3d$export$444b3ab0cb9aec40.PREVIOUS)
                }, messages.previous), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
                    type: "button",
                    onClick: this.navigate.bind(null, $ba6e2539d0024c3d$export$444b3ab0cb9aec40.NEXT)
                }, messages.next)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                    className: "rbc-toolbar-label"
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                    className: "rbc-btn-group"
                }, this.viewNamesGroup(messages)));
            }
        },
        {
            key: "viewNamesGroup",
            value: function viewNamesGroup(messages) {
                var _this2 = this;
                var viewNames = this.props.views;
                var view = this.props.view;
                if (viewNames.length > 1) return viewNames.map(function(name) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
                        type: "button",
                        key: name,
                        className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)({
                            'rbc-active': view === name
                        }),
                        onClick: _this2.view.bind(null, name)
                    }, messages[name]);
                });
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$Toolbar.propTypes = {};
function $ba6e2539d0024c3d$var$notify(handler, args) {
    handler && handler.apply(null, [].concat(args));
}
function $ba6e2539d0024c3d$var$ownKeys$9(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba6e2539d0024c3d$var$_objectSpread$9(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba6e2539d0024c3d$var$ownKeys$9(Object(t), true).forEach(function(r) {
            (0, $bfbb99364ffa951d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba6e2539d0024c3d$var$ownKeys$9(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ba6e2539d0024c3d$var$defaultMessages = {
    date: 'Date',
    time: 'Time',
    event: 'Event',
    allDay: 'All Day',
    week: 'Week',
    work_week: 'Work Week',
    day: 'Day',
    month: 'Month',
    previous: 'Back',
    next: 'Next',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    today: 'Today',
    agenda: 'Agenda',
    noEventsInRange: 'There are no events in this range.',
    showMore: function showMore(total) {
        return "+".concat(total, " more");
    }
};
function $ba6e2539d0024c3d$var$messages(msgs) {
    return $ba6e2539d0024c3d$var$_objectSpread$9($ba6e2539d0024c3d$var$_objectSpread$9({}, $ba6e2539d0024c3d$var$defaultMessages), msgs);
}
function $ba6e2539d0024c3d$var$useClickOutside(_ref) {
    var ref = _ref.ref, callback = _ref.callback;
    (0, $5s1kH.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(e) {
            if (ref.current && !ref.current.contains(e.target)) callback();
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function() {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref,
        callback
    ]);
}
var $ba6e2539d0024c3d$var$_excluded$7 = [
    "style",
    "className",
    "event",
    "selected",
    "isAllDay",
    "onSelect",
    "onDoubleClick",
    "onKeyPress",
    "localizer",
    "continuesPrior",
    "continuesAfter",
    "accessors",
    "getters",
    "children",
    "components",
    "slotStart",
    "slotEnd"
];
function $ba6e2539d0024c3d$var$ownKeys$8(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba6e2539d0024c3d$var$_objectSpread$8(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba6e2539d0024c3d$var$ownKeys$8(Object(t), true).forEach(function(r) {
            (0, $bfbb99364ffa951d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba6e2539d0024c3d$var$ownKeys$8(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ba6e2539d0024c3d$var$_callSuper$e(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$e() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$e() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$e = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba6e2539d0024c3d$var$EventCell = /*#__PURE__*/ function(_React$Component) {
    function EventCell() {
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, EventCell);
        return $ba6e2539d0024c3d$var$_callSuper$e(this, EventCell, arguments);
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(EventCell, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(EventCell, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, style = _this$props.style, className = _this$props.className, event = _this$props.event, selected = _this$props.selected, isAllDay = _this$props.isAllDay, onSelect = _this$props.onSelect, _onDoubleClick = _this$props.onDoubleClick, onKeyPress = _this$props.onKeyPress, localizer = _this$props.localizer, continuesPrior = _this$props.continuesPrior, continuesAfter = _this$props.continuesAfter, accessors = _this$props.accessors, getters = _this$props.getters, children = _this$props.children, _this$props$component = _this$props.components, Event = _this$props$component.event, EventWrapper = _this$props$component.eventWrapper, slotStart = _this$props.slotStart, slotEnd = _this$props.slotEnd, props = (0, $7b4c4f4a56bd113a$export$2e2bcd8739ae039)(_this$props, $ba6e2539d0024c3d$var$_excluded$7);
                delete props.resizable;
                var title = accessors.title(event);
                var tooltip = accessors.tooltip(event);
                var end = accessors.end(event);
                var start = accessors.start(event);
                var allDay = accessors.allDay(event);
                var showAsAllDay = isAllDay || allDay || localizer.diff(start, localizer.ceil(end, 'day'), 'day') > 1;
                var userProps = getters.eventProp(event, start, end, selected);
                var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: "rbc-event-content",
                    title: tooltip || undefined
                }, Event ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(Event, {
                    event: event,
                    continuesPrior: continuesPrior,
                    continuesAfter: continuesAfter,
                    title: title,
                    isAllDay: allDay,
                    localizer: localizer,
                    slotStart: slotStart,
                    slotEnd: slotEnd
                }) : title);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(EventWrapper, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, this.props, {
                    type: "date"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, props, {
                    style: $ba6e2539d0024c3d$var$_objectSpread$8($ba6e2539d0024c3d$var$_objectSpread$8({}, userProps.style), style),
                    className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-event', className, userProps.className, {
                        'rbc-selected': selected,
                        'rbc-event-allday': showAsAllDay,
                        'rbc-event-continues-prior': continuesPrior,
                        'rbc-event-continues-after': continuesAfter
                    }),
                    onClick: function onClick(e) {
                        return onSelect && onSelect(event, e);
                    },
                    onDoubleClick: function onDoubleClick(e) {
                        return _onDoubleClick && _onDoubleClick(event, e);
                    },
                    onKeyDown: function onKeyDown(e) {
                        return onKeyPress && onKeyPress(event, e);
                    }
                }), typeof children === 'function' ? children(content) : content));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$EventCell.propTypes = {};
function $ba6e2539d0024c3d$var$isSelected(event, selected) {
    if (!event || selected == null) return false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($fRRA4)))(event, selected);
}
function $ba6e2539d0024c3d$var$slotWidth(rowBox, slots) {
    var rowWidth = rowBox.right - rowBox.left;
    var cellWidth = rowWidth / slots;
    return cellWidth;
}
function $ba6e2539d0024c3d$var$getSlotAtX(rowBox, x, rtl, slots) {
    var cellWidth = $ba6e2539d0024c3d$var$slotWidth(rowBox, slots);
    return rtl ? slots - 1 - Math.floor((x - rowBox.left) / cellWidth) : Math.floor((x - rowBox.left) / cellWidth);
}
function $ba6e2539d0024c3d$var$pointInBox(box, _ref) {
    var x = _ref.x, y = _ref.y;
    return y >= box.top && y <= box.bottom && x >= box.left && x <= box.right;
}
function $ba6e2539d0024c3d$var$dateCellSelection(start, rowBox, box, slots, rtl) {
    var startIdx = -1;
    var endIdx = -1;
    var lastSlotIdx = slots - 1;
    var cellWidth = $ba6e2539d0024c3d$var$slotWidth(rowBox, slots);
    // cell under the mouse
    var currentSlot = $ba6e2539d0024c3d$var$getSlotAtX(rowBox, box.x, rtl, slots);
    // Identify row as either the initial row
    // or the row under the current mouse point
    var isCurrentRow = rowBox.top < box.y && rowBox.bottom > box.y;
    var isStartRow = rowBox.top < start.y && rowBox.bottom > start.y;
    // this row's position relative to the start point
    var isAboveStart = start.y > rowBox.bottom;
    var isBelowStart = rowBox.top > start.y;
    var isBetween = box.top < rowBox.top && box.bottom > rowBox.bottom;
    // this row is between the current and start rows, so entirely selected
    if (isBetween) {
        startIdx = 0;
        endIdx = lastSlotIdx;
    }
    if (isCurrentRow) {
        if (isBelowStart) {
            startIdx = 0;
            endIdx = currentSlot;
        } else if (isAboveStart) {
            startIdx = currentSlot;
            endIdx = lastSlotIdx;
        }
    }
    if (isStartRow) {
        // select the cell under the initial point
        startIdx = endIdx = rtl ? lastSlotIdx - Math.floor((start.x - rowBox.left) / cellWidth) : Math.floor((start.x - rowBox.left) / cellWidth);
        if (isCurrentRow) {
            if (currentSlot < startIdx) startIdx = currentSlot;
            else endIdx = currentSlot; //select current range
        } else if (start.y < box.y) // the current row is below start row
        // select cells to the right of the start cell
        endIdx = lastSlotIdx;
        else // select cells to the left of the start cell
        startIdx = 0;
    }
    return {
        startIdx: startIdx,
        endIdx: endIdx
    };
}
/**
 * Changes to react-overlays cause issue with auto positioning,
 * so we need to manually calculate the position of the popper,
 * and constrain it to the Month container.
 */ function $ba6e2539d0024c3d$var$getPosition(_ref) {
    var target = _ref.target, offset = _ref.offset, container = _ref.container, box = _ref.box;
    var _getOffset = (0, $ff2c299c017232ac$export$2e2bcd8739ae039)(target), top = _getOffset.top, left = _getOffset.left, width = _getOffset.width, height = _getOffset.height;
    var _getOffset2 = (0, $ff2c299c017232ac$export$2e2bcd8739ae039)(container), cTop = _getOffset2.top, cLeft = _getOffset2.left, cWidth = _getOffset2.width, cHeight = _getOffset2.height;
    var _getOffset3 = (0, $ff2c299c017232ac$export$2e2bcd8739ae039)(box), bWidth = _getOffset3.width, bHeight = _getOffset3.height;
    var viewBottom = cTop + cHeight;
    var viewRight = cLeft + cWidth;
    var bottom = top + bHeight;
    var right = left + bWidth;
    var x = offset.x, y = offset.y;
    var topOffset = bottom > viewBottom ? top - bHeight - y : top + y + height;
    var leftOffset = right > viewRight ? left + x - bWidth + width : left + x;
    return {
        topOffset: topOffset,
        leftOffset: leftOffset
    };
}
function $ba6e2539d0024c3d$var$Pop(_ref2) {
    var containerRef = _ref2.containerRef, accessors = _ref2.accessors, getters = _ref2.getters, selected = _ref2.selected, components = _ref2.components, localizer = _ref2.localizer, position = _ref2.position, show = _ref2.show, events = _ref2.events, slotStart = _ref2.slotStart, slotEnd = _ref2.slotEnd, onSelect = _ref2.onSelect, onDoubleClick = _ref2.onDoubleClick, onKeyPress = _ref2.onKeyPress, handleDragStart = _ref2.handleDragStart, popperRef = _ref2.popperRef, target = _ref2.target, offset = _ref2.offset;
    $ba6e2539d0024c3d$var$useClickOutside({
        ref: popperRef,
        callback: show
    });
    (0, $5s1kH.useLayoutEffect)(function() {
        var _getPosition = $ba6e2539d0024c3d$var$getPosition({
            target: target,
            offset: offset,
            container: containerRef.current,
            box: popperRef.current
        }), topOffset = _getPosition.topOffset, leftOffset = _getPosition.leftOffset;
        popperRef.current.style.top = "".concat(topOffset, "px");
        popperRef.current.style.left = "".concat(leftOffset, "px");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        offset.x,
        offset.y,
        target
    ]);
    var width = position.width;
    var style = {
        minWidth: width + width / 2
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        style: style,
        className: "rbc-overlay",
        ref: popperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        className: "rbc-overlay-header"
    }, localizer.format(slotStart, 'dayHeaderFormat')), events.map(function(event, idx) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$EventCell, {
            key: idx,
            type: "popup",
            localizer: localizer,
            event: event,
            getters: getters,
            onSelect: onSelect,
            accessors: accessors,
            components: components,
            onDoubleClick: onDoubleClick,
            onKeyPress: onKeyPress,
            continuesPrior: localizer.lt(accessors.end(event), slotStart, 'day'),
            continuesAfter: localizer.gte(accessors.start(event), slotEnd, 'day'),
            slotStart: slotStart,
            slotEnd: slotEnd,
            selected: $ba6e2539d0024c3d$var$isSelected(event, selected),
            draggable: true,
            onDragStart: function onDragStart() {
                return handleDragStart(event);
            },
            onDragEnd: function onDragEnd() {
                return show();
            }
        });
    }));
}
var $ba6e2539d0024c3d$var$Popup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$Pop, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, props, {
        popperRef: ref
    }));
});
$ba6e2539d0024c3d$var$Popup.propTypes = {
    accessors: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
    getters: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
    localizer: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
    show: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func.isRequired,
    events: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).array.isRequired,
    slotStart: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).instanceOf(Date).isRequired,
    slotEnd: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).instanceOf(Date),
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    onDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    onKeyPress: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    handleDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object,
    offset: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).number
    })
};
function $ba6e2539d0024c3d$var$CalOverlay(_ref) {
    var containerRef = _ref.containerRef, _ref$popupOffset = _ref.popupOffset, popupOffset = _ref$popupOffset === void 0 ? 5 : _ref$popupOffset, overlay = _ref.overlay, accessors = _ref.accessors, localizer = _ref.localizer, components = _ref.components, getters = _ref.getters, selected = _ref.selected, handleSelectEvent = _ref.handleSelectEvent, handleDoubleClickEvent = _ref.handleDoubleClickEvent, handleKeyPressEvent = _ref.handleKeyPressEvent, handleDragStart = _ref.handleDragStart, onHide = _ref.onHide, overlayDisplay = _ref.overlayDisplay;
    var popperRef = (0, $5s1kH.useRef)(null);
    if (!overlay.position) return null;
    var offset = popupOffset;
    if (!isNaN(popupOffset)) offset = {
        x: popupOffset,
        y: popupOffset
    };
    var position = overlay.position, events = overlay.events, date = overlay.date, end = overlay.end;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement((0, $6a43729912364714$export$2e2bcd8739ae039), {
        rootClose: true,
        flip: true,
        show: true,
        placement: "bottom",
        onHide: onHide,
        target: overlay.target
    }, function(_ref2) {
        var props = _ref2.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$Popup, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, props, {
            containerRef: containerRef,
            ref: popperRef,
            target: overlay.target,
            offset: offset,
            accessors: accessors,
            getters: getters,
            selected: selected,
            components: components,
            localizer: localizer,
            position: position,
            show: overlayDisplay,
            events: events,
            slotStart: date,
            slotEnd: end,
            onSelect: handleSelectEvent,
            onDoubleClick: handleDoubleClickEvent,
            onKeyPress: handleKeyPressEvent,
            handleDragStart: handleDragStart
        }));
    });
}
var $ba6e2539d0024c3d$var$PopOverlay = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$CalOverlay, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, props, {
        containerRef: ref
    }));
});
$ba6e2539d0024c3d$var$PopOverlay.propTypes = {
    popupOffset: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).number,
            y: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).number
        })
    ]),
    overlay: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).shape({
        position: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object,
        events: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).array,
        date: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).instanceOf(Date),
        end: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).instanceOf(Date)
    }),
    accessors: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
    localizer: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
    getters: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object,
    handleSelectEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    handleDoubleClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    handleKeyPressEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    handleDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    onHide: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
    overlayDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func
};
function $ba6e2539d0024c3d$var$addEventListener(type, handler) {
    var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
    return (0, $163f59dea1e2873c$export$2e2bcd8739ae039)(target, type, handler, {
        passive: false
    });
}
function $ba6e2539d0024c3d$var$isOverContainer(container, x, y) {
    return !container || (0, $1f47ac07b730d17e$export$2e2bcd8739ae039)(container, document.elementFromPoint(x, y));
}
function $ba6e2539d0024c3d$var$getEventNodeFromPoint(node, _ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    var target = document.elementFromPoint(clientX, clientY);
    return (0, $4e8e467862c0a79b$export$2e2bcd8739ae039)(target, '.rbc-event', node);
}
function $ba6e2539d0024c3d$var$getShowMoreNodeFromPoint(node, _ref2) {
    var clientX = _ref2.clientX, clientY = _ref2.clientY;
    var target = document.elementFromPoint(clientX, clientY);
    return (0, $4e8e467862c0a79b$export$2e2bcd8739ae039)(target, '.rbc-show-more', node);
}
function $ba6e2539d0024c3d$var$isEvent(node, bounds) {
    return !!$ba6e2539d0024c3d$var$getEventNodeFromPoint(node, bounds);
}
function $ba6e2539d0024c3d$var$isShowMore(node, bounds) {
    return !!$ba6e2539d0024c3d$var$getShowMoreNodeFromPoint(node, bounds);
}
function $ba6e2539d0024c3d$var$getEventCoordinates(e) {
    var target = e;
    if (e.touches && e.touches.length) target = e.touches[0];
    return {
        clientX: target.clientX,
        clientY: target.clientY,
        pageX: target.pageX,
        pageY: target.pageY
    };
}
var $ba6e2539d0024c3d$var$clickTolerance = 5;
var $ba6e2539d0024c3d$var$clickInterval = 250;
var $ba6e2539d0024c3d$var$Selection = /*#__PURE__*/ function() {
    function Selection(node) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref3$global = _ref3.global, global = _ref3$global === void 0 ? false : _ref3$global, _ref3$longPressThresh = _ref3.longPressThreshold, longPressThreshold = _ref3$longPressThresh === void 0 ? 250 : _ref3$longPressThresh, _ref3$validContainers = _ref3.validContainers, validContainers = _ref3$validContainers === void 0 ? [] : _ref3$validContainers;
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, Selection);
        this._initialEvent = null;
        this.selecting = false;
        this.isDetached = false;
        this.container = node;
        this.globalMouse = !node || global;
        this.longPressThreshold = longPressThreshold;
        this.validContainers = validContainers;
        this._listeners = Object.create(null);
        this._handleInitialEvent = this._handleInitialEvent.bind(this);
        this._handleMoveEvent = this._handleMoveEvent.bind(this);
        this._handleTerminatingEvent = this._handleTerminatingEvent.bind(this);
        this._keyListener = this._keyListener.bind(this);
        this._dropFromOutsideListener = this._dropFromOutsideListener.bind(this);
        this._dragOverFromOutsideListener = this._dragOverFromOutsideListener.bind(this);
        // Fixes an iOS 10 bug where scrolling could not be prevented on the window.
        // https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
        this._removeTouchMoveWindowListener = $ba6e2539d0024c3d$var$addEventListener('touchmove', function() {}, window);
        this._removeKeyDownListener = $ba6e2539d0024c3d$var$addEventListener('keydown', this._keyListener);
        this._removeKeyUpListener = $ba6e2539d0024c3d$var$addEventListener('keyup', this._keyListener);
        this._removeDropFromOutsideListener = $ba6e2539d0024c3d$var$addEventListener('drop', this._dropFromOutsideListener);
        this._removeDragOverFromOutsideListener = $ba6e2539d0024c3d$var$addEventListener('dragover', this._dragOverFromOutsideListener);
        this._addInitialEventListener();
    }
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(Selection, [
        {
            key: "on",
            value: function on(type, handler) {
                var handlers = this._listeners[type] || (this._listeners[type] = []);
                handlers.push(handler);
                return {
                    remove: function remove() {
                        var idx = handlers.indexOf(handler);
                        if (idx !== -1) handlers.splice(idx, 1);
                    }
                };
            }
        },
        {
            key: "emit",
            value: function emit(type) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                var result;
                var handlers = this._listeners[type] || [];
                handlers.forEach(function(fn) {
                    if (result === undefined) result = fn.apply(void 0, args);
                });
                return result;
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                this._initialEvent = null;
                this._initialEventData = null;
                this._selectRect = null;
                this.selecting = false;
                this._lastClickData = null;
                this.isDetached = true;
                this._listeners = Object.create(null);
                this._removeTouchMoveWindowListener && this._removeTouchMoveWindowListener();
                this._removeInitialEventListener && this._removeInitialEventListener();
                this._removeEndListener && this._removeEndListener();
                this._onEscListener && this._onEscListener();
                this._removeMoveListener && this._removeMoveListener();
                this._removeKeyUpListener && this._removeKeyUpListener();
                this._removeKeyDownListener && this._removeKeyDownListener();
                this._removeDropFromOutsideListener && this._removeDropFromOutsideListener();
                this._removeDragOverFromOutsideListener && this._removeDragOverFromOutsideListener();
            }
        },
        {
            key: "isSelected",
            value: function isSelected(node) {
                var box = this._selectRect;
                if (!box || !this.selecting) return false;
                return $ba6e2539d0024c3d$var$objectsCollide(box, $ba6e2539d0024c3d$var$getBoundsForNode(node));
            }
        },
        {
            key: "filter",
            value: function filter(items) {
                var box = this._selectRect;
                //not selecting
                if (!box || !this.selecting) return [];
                return items.filter(this.isSelected, this);
            }
        },
        {
            key: "_addLongPressListener",
            value: function _addLongPressListener(handler, initialEvent) {
                var _this = this;
                var timer = null;
                var removeTouchMoveListener = null;
                var removeTouchEndListener = null;
                var handleTouchStart = function handleTouchStart(initialEvent) {
                    timer = setTimeout(function() {
                        cleanup();
                        handler(initialEvent);
                    }, _this.longPressThreshold);
                    removeTouchMoveListener = $ba6e2539d0024c3d$var$addEventListener('touchmove', function() {
                        return cleanup();
                    });
                    removeTouchEndListener = $ba6e2539d0024c3d$var$addEventListener('touchend', function() {
                        return cleanup();
                    });
                };
                var removeTouchStartListener = $ba6e2539d0024c3d$var$addEventListener('touchstart', handleTouchStart);
                var cleanup = function cleanup() {
                    if (timer) clearTimeout(timer);
                    if (removeTouchMoveListener) removeTouchMoveListener();
                    if (removeTouchEndListener) removeTouchEndListener();
                    timer = null;
                    removeTouchMoveListener = null;
                    removeTouchEndListener = null;
                };
                if (initialEvent) handleTouchStart(initialEvent);
                return function() {
                    cleanup();
                    removeTouchStartListener();
                };
            }
        },
        {
            key: "_addInitialEventListener",
            value: function _addInitialEventListener() {
                var _this2 = this;
                var removeMouseDownListener = $ba6e2539d0024c3d$var$addEventListener('mousedown', function(e) {
                    _this2._removeInitialEventListener();
                    _this2._handleInitialEvent(e);
                    _this2._removeInitialEventListener = $ba6e2539d0024c3d$var$addEventListener('mousedown', _this2._handleInitialEvent);
                });
                var removeTouchStartListener = $ba6e2539d0024c3d$var$addEventListener('touchstart', function(e) {
                    _this2._removeInitialEventListener();
                    _this2._removeInitialEventListener = _this2._addLongPressListener(_this2._handleInitialEvent, e);
                });
                this._removeInitialEventListener = function() {
                    removeMouseDownListener();
                    removeTouchStartListener();
                };
            }
        },
        {
            key: "_dropFromOutsideListener",
            value: function _dropFromOutsideListener(e) {
                var _getEventCoordinates = $ba6e2539d0024c3d$var$getEventCoordinates(e), pageX = _getEventCoordinates.pageX, pageY = _getEventCoordinates.pageY, clientX = _getEventCoordinates.clientX, clientY = _getEventCoordinates.clientY;
                this.emit('dropFromOutside', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                e.preventDefault();
            }
        },
        {
            key: "_dragOverFromOutsideListener",
            value: function _dragOverFromOutsideListener(e) {
                var _getEventCoordinates2 = $ba6e2539d0024c3d$var$getEventCoordinates(e), pageX = _getEventCoordinates2.pageX, pageY = _getEventCoordinates2.pageY, clientX = _getEventCoordinates2.clientX, clientY = _getEventCoordinates2.clientY;
                this.emit('dragOverFromOutside', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                e.preventDefault();
            }
        },
        {
            key: "_handleInitialEvent",
            value: function _handleInitialEvent(e) {
                this._initialEvent = e;
                if (this.isDetached) return;
                var _getEventCoordinates3 = $ba6e2539d0024c3d$var$getEventCoordinates(e), clientX = _getEventCoordinates3.clientX, clientY = _getEventCoordinates3.clientY, pageX = _getEventCoordinates3.pageX, pageY = _getEventCoordinates3.pageY;
                var node = this.container(), collides, offsetData;
                // Right clicks
                if (e.which === 3 || e.button === 2 || !$ba6e2539d0024c3d$var$isOverContainer(node, clientX, clientY)) return;
                if (!this.globalMouse && node && !(0, $1f47ac07b730d17e$export$2e2bcd8739ae039)(node, e.target)) {
                    var _normalizeDistance = $ba6e2539d0024c3d$var$normalizeDistance(0), top = _normalizeDistance.top, left = _normalizeDistance.left, bottom = _normalizeDistance.bottom, right = _normalizeDistance.right;
                    offsetData = $ba6e2539d0024c3d$var$getBoundsForNode(node);
                    collides = $ba6e2539d0024c3d$var$objectsCollide({
                        top: offsetData.top - top,
                        left: offsetData.left - left,
                        bottom: offsetData.bottom + bottom,
                        right: offsetData.right + right
                    }, {
                        top: pageY,
                        left: pageX
                    });
                    if (!collides) return;
                }
                var result = this.emit('beforeSelect', this._initialEventData = {
                    isTouch: /^touch/.test(e.type),
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                if (result === false) return;
                switch(e.type){
                    case 'mousedown':
                        this._removeEndListener = $ba6e2539d0024c3d$var$addEventListener('mouseup', this._handleTerminatingEvent);
                        this._onEscListener = $ba6e2539d0024c3d$var$addEventListener('keydown', this._handleTerminatingEvent);
                        this._removeMoveListener = $ba6e2539d0024c3d$var$addEventListener('mousemove', this._handleMoveEvent);
                        break;
                    case 'touchstart':
                        this._handleMoveEvent(e);
                        this._removeEndListener = $ba6e2539d0024c3d$var$addEventListener('touchend', this._handleTerminatingEvent);
                        this._removeMoveListener = $ba6e2539d0024c3d$var$addEventListener('touchmove', this._handleMoveEvent);
                        break;
                }
            }
        },
        {
            key: "_isWithinValidContainer",
            value: function _isWithinValidContainer(e) {
                var eventTarget = e.target;
                var containers = this.validContainers;
                if (!containers || !containers.length || !eventTarget) return true;
                return containers.some(function(target) {
                    return !!eventTarget.closest(target);
                });
            }
        },
        {
            key: "_handleTerminatingEvent",
            value: function _handleTerminatingEvent(e) {
                var selecting = this.selecting;
                var bounds = this._selectRect;
                // If it's not in selecting state, it's a click event
                if (!selecting && e.type.includes('key')) e = this._initialEvent;
                this.selecting = false;
                this._removeEndListener && this._removeEndListener();
                this._removeMoveListener && this._removeMoveListener();
                this._selectRect = null;
                this._initialEvent = null;
                this._initialEventData = null;
                if (!e) return;
                var inRoot = !this.container || (0, $1f47ac07b730d17e$export$2e2bcd8739ae039)(this.container(), e.target);
                var isWithinValidContainer = this._isWithinValidContainer(e);
                if (e.key === 'Escape' || !isWithinValidContainer) return this.emit('reset');
                if (!selecting && inRoot) return this._handleClickEvent(e);
                // User drag-clicked in the Selectable area
                if (selecting) return this.emit('select', bounds);
                return this.emit('reset');
            }
        },
        {
            key: "_handleClickEvent",
            value: function _handleClickEvent(e) {
                var _getEventCoordinates4 = $ba6e2539d0024c3d$var$getEventCoordinates(e), pageX = _getEventCoordinates4.pageX, pageY = _getEventCoordinates4.pageY, clientX = _getEventCoordinates4.clientX, clientY = _getEventCoordinates4.clientY;
                var now = new Date().getTime();
                if (this._lastClickData && now - this._lastClickData.timestamp < $ba6e2539d0024c3d$var$clickInterval) {
                    // Double click event
                    this._lastClickData = null;
                    return this.emit('doubleClick', {
                        x: pageX,
                        y: pageY,
                        clientX: clientX,
                        clientY: clientY
                    });
                }
                // Click event
                this._lastClickData = {
                    timestamp: now
                };
                return this.emit('click', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
            }
        },
        {
            key: "_handleMoveEvent",
            value: function _handleMoveEvent(e) {
                if (this._initialEventData === null || this.isDetached) return;
                var _this$_initialEventDa = this._initialEventData, x = _this$_initialEventDa.x, y = _this$_initialEventDa.y;
                var _getEventCoordinates5 = $ba6e2539d0024c3d$var$getEventCoordinates(e), pageX = _getEventCoordinates5.pageX, pageY = _getEventCoordinates5.pageY;
                var w = Math.abs(x - pageX);
                var h = Math.abs(y - pageY);
                var left = Math.min(pageX, x), top = Math.min(pageY, y), old = this.selecting;
                var click = this.isClick(pageX, pageY);
                // Prevent emitting selectStart event until mouse is moved.
                // in Chrome on Windows, mouseMove event may be fired just after mouseDown event.
                if (click && !old && !(w || h)) return;
                if (!old && !click) this.emit('selectStart', this._initialEventData);
                if (!click) {
                    this.selecting = true;
                    this._selectRect = {
                        top: top,
                        left: left,
                        x: pageX,
                        y: pageY,
                        right: left + w,
                        bottom: top + h
                    };
                    this.emit('selecting', this._selectRect);
                }
                e.preventDefault();
            }
        },
        {
            key: "_keyListener",
            value: function _keyListener(e) {
                this.ctrl = e.metaKey || e.ctrlKey;
            }
        },
        {
            key: "isClick",
            value: function isClick(pageX, pageY) {
                var _this$_initialEventDa2 = this._initialEventData, x = _this$_initialEventDa2.x, y = _this$_initialEventDa2.y, isTouch = _this$_initialEventDa2.isTouch;
                return !isTouch && Math.abs(pageX - x) <= $ba6e2539d0024c3d$var$clickTolerance && Math.abs(pageY - y) <= $ba6e2539d0024c3d$var$clickTolerance;
            }
        }
    ]);
}();
/**
 * Resolve the disance prop from either an Int or an Object
 * @return {Object}
 */ function $ba6e2539d0024c3d$var$normalizeDistance() {
    var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if ((0, $78b404e4b46724a3$export$2e2bcd8739ae039)(distance) !== 'object') distance = {
        top: distance,
        left: distance,
        right: distance,
        bottom: distance
    };
    return distance;
}
/**
 * Given two objects containing "top", "left", "offsetWidth" and "offsetHeight"
 * properties, determine if they collide.
 * @param  {Object|HTMLElement} a
 * @param  {Object|HTMLElement} b
 * @return {bool}
 */ function $ba6e2539d0024c3d$var$objectsCollide(nodeA, nodeB) {
    var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var _getBoundsForNode = $ba6e2539d0024c3d$var$getBoundsForNode(nodeA), aTop = _getBoundsForNode.top, aLeft = _getBoundsForNode.left, _getBoundsForNode$rig = _getBoundsForNode.right, aRight = _getBoundsForNode$rig === void 0 ? aLeft : _getBoundsForNode$rig, _getBoundsForNode$bot = _getBoundsForNode.bottom, aBottom = _getBoundsForNode$bot === void 0 ? aTop : _getBoundsForNode$bot;
    var _getBoundsForNode2 = $ba6e2539d0024c3d$var$getBoundsForNode(nodeB), bTop = _getBoundsForNode2.top, bLeft = _getBoundsForNode2.left, _getBoundsForNode2$ri = _getBoundsForNode2.right, bRight = _getBoundsForNode2$ri === void 0 ? bLeft : _getBoundsForNode2$ri, _getBoundsForNode2$bo = _getBoundsForNode2.bottom, bBottom = _getBoundsForNode2$bo === void 0 ? bTop : _getBoundsForNode2$bo;
    return !// 'a' bottom doesn't touch 'b' top
    (aBottom - tolerance < bTop || // 'a' top doesn't touch 'b' bottom
    aTop + tolerance > bBottom || // 'a' right doesn't touch 'b' left
    aRight - tolerance < bLeft || // 'a' left doesn't touch 'b' right
    aLeft + tolerance > bRight);
}
/**
 * Given a node, get everything needed to calculate its boundaries
 * @param  {HTMLElement} node
 * @return {Object}
 */ function $ba6e2539d0024c3d$var$getBoundsForNode(node) {
    if (!node.getBoundingClientRect) return node;
    var rect = node.getBoundingClientRect(), left = rect.left + $ba6e2539d0024c3d$var$pageOffset('left'), top = rect.top + $ba6e2539d0024c3d$var$pageOffset('top');
    return {
        top: top,
        left: left,
        right: (node.offsetWidth || 0) + left,
        bottom: (node.offsetHeight || 0) + top
    };
}
function $ba6e2539d0024c3d$var$pageOffset(dir) {
    if (dir === 'left') return window.pageXOffset || document.body.scrollLeft || 0;
    if (dir === 'top') return window.pageYOffset || document.body.scrollTop || 0;
}
function $ba6e2539d0024c3d$var$ownKeys$7(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba6e2539d0024c3d$var$_objectSpread$7(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba6e2539d0024c3d$var$ownKeys$7(Object(t), true).forEach(function(r) {
            (0, $bfbb99364ffa951d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba6e2539d0024c3d$var$ownKeys$7(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ba6e2539d0024c3d$var$_callSuper$d(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$d() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$d() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$d = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba6e2539d0024c3d$var$BackgroundCells = /*#__PURE__*/ function(_React$Component) {
    function BackgroundCells(props, context) {
        var _this;
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, BackgroundCells);
        _this = $ba6e2539d0024c3d$var$_callSuper$d(this, BackgroundCells, [
            props,
            context
        ]);
        _this.state = {
            selecting: false
        };
        _this.containerRef = /*#__PURE__*/ (0, $5s1kH.createRef)();
        return _this;
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(BackgroundCells, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(BackgroundCells, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.selectable && this._selectable();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._teardownSelectable();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!prevProps.selectable && this.props.selectable) this._selectable();
                if (prevProps.selectable && !this.props.selectable) this._teardownSelectable();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, range = _this$props.range, getNow = _this$props.getNow, getters = _this$props.getters, currentDate = _this$props.date, Wrapper = _this$props.components.dateCellWrapper, localizer = _this$props.localizer;
                var _this$state = this.state, selecting = _this$state.selecting, startIdx = _this$state.startIdx, endIdx = _this$state.endIdx;
                var current = getNow();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: "rbc-row-bg",
                    ref: this.containerRef
                }, range.map(function(date, index) {
                    var selected = selecting && index >= startIdx && index <= endIdx;
                    var _getters$dayProp = getters.dayProp(date), className = _getters$dayProp.className, style = _getters$dayProp.style;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(Wrapper, {
                        key: index,
                        value: date,
                        range: range
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        style: style,
                        className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-day-bg', className, selected && 'rbc-selected-cell', localizer.isSameDate(date, current) && 'rbc-today', currentDate && localizer.neq(currentDate, date, 'month') && 'rbc-off-range-bg')
                    }));
                }));
            }
        },
        {
            key: "_selectable",
            value: function _selectable() {
                var _this2 = this;
                var node = this.containerRef.current;
                var selector = this._selector = new $ba6e2539d0024c3d$var$Selection(this.props.container, {
                    longPressThreshold: this.props.longPressThreshold
                });
                var selectorClicksHandler = function selectorClicksHandler(point, actionType) {
                    if (!$ba6e2539d0024c3d$var$isEvent(node, point) && !$ba6e2539d0024c3d$var$isShowMore(node, point)) {
                        var rowBox = $ba6e2539d0024c3d$var$getBoundsForNode(node);
                        var _this2$props = _this2.props, range = _this2$props.range, rtl = _this2$props.rtl;
                        if ($ba6e2539d0024c3d$var$pointInBox(rowBox, point)) {
                            var currentCell = $ba6e2539d0024c3d$var$getSlotAtX(rowBox, point.x, rtl, range.length);
                            _this2._selectSlot({
                                startIdx: currentCell,
                                endIdx: currentCell,
                                action: actionType,
                                box: point
                            });
                        }
                    }
                    _this2._initial = {};
                    _this2.setState({
                        selecting: false
                    });
                };
                selector.on('selecting', function(box) {
                    var _this2$props2 = _this2.props, range = _this2$props2.range, rtl = _this2$props2.rtl;
                    var startIdx = -1;
                    var endIdx = -1;
                    if (!_this2.state.selecting) {
                        $ba6e2539d0024c3d$var$notify(_this2.props.onSelectStart, [
                            box
                        ]);
                        _this2._initial = {
                            x: box.x,
                            y: box.y
                        };
                    }
                    if (selector.isSelected(node)) {
                        var nodeBox = $ba6e2539d0024c3d$var$getBoundsForNode(node);
                        var _dateCellSelection = $ba6e2539d0024c3d$var$dateCellSelection(_this2._initial, nodeBox, box, range.length, rtl);
                        startIdx = _dateCellSelection.startIdx;
                        endIdx = _dateCellSelection.endIdx;
                    }
                    _this2.setState({
                        selecting: true,
                        startIdx: startIdx,
                        endIdx: endIdx
                    });
                });
                selector.on('beforeSelect', function(box) {
                    if (_this2.props.selectable !== 'ignoreEvents') return;
                    return !$ba6e2539d0024c3d$var$isEvent(_this2.containerRef.current, box);
                });
                selector.on('click', function(point) {
                    return selectorClicksHandler(point, 'click');
                });
                selector.on('doubleClick', function(point) {
                    return selectorClicksHandler(point, 'doubleClick');
                });
                selector.on('select', function(bounds) {
                    _this2._selectSlot($ba6e2539d0024c3d$var$_objectSpread$7($ba6e2539d0024c3d$var$_objectSpread$7({}, _this2.state), {}, {
                        action: 'select',
                        bounds: bounds
                    }));
                    _this2._initial = {};
                    _this2.setState({
                        selecting: false
                    });
                    $ba6e2539d0024c3d$var$notify(_this2.props.onSelectEnd, [
                        _this2.state
                    ]);
                });
            }
        },
        {
            key: "_teardownSelectable",
            value: function _teardownSelectable() {
                if (!this._selector) return;
                this._selector.teardown();
                this._selector = null;
            }
        },
        {
            key: "_selectSlot",
            value: function _selectSlot(_ref) {
                var endIdx = _ref.endIdx, startIdx = _ref.startIdx, action = _ref.action, bounds = _ref.bounds, box = _ref.box;
                if (endIdx !== -1 && startIdx !== -1) this.props.onSelectSlot && this.props.onSelectSlot({
                    start: startIdx,
                    end: endIdx,
                    action: action,
                    bounds: bounds,
                    box: box,
                    resourceId: this.props.resourceId
                });
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$BackgroundCells.propTypes = {};
/* eslint-disable react/prop-types */ var $ba6e2539d0024c3d$var$EventRowMixin = {
    propTypes: {
        slotMetrics: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object,
        isAllDay: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).bool,
        accessors: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
        localizer: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
        components: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
        getters: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).object.isRequired,
        onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
        onDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func,
        onKeyPress: (0, (/*@__PURE__*/$parcel$interopDefault($4YVCt))).func
    },
    defaultProps: {
        segments: [],
        selected: {}
    },
    renderEvent: function renderEvent(props, event) {
        var selected = props.selected;
        props.isAllDay;
        var accessors = props.accessors, getters = props.getters, onSelect = props.onSelect, onDoubleClick = props.onDoubleClick, onKeyPress = props.onKeyPress, localizer = props.localizer, slotMetrics = props.slotMetrics, components = props.components, resizable = props.resizable;
        var continuesPrior = slotMetrics.continuesPrior(event);
        var continuesAfter = slotMetrics.continuesAfter(event);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$EventCell, {
            event: event,
            getters: getters,
            localizer: localizer,
            accessors: accessors,
            components: components,
            onSelect: onSelect,
            onDoubleClick: onDoubleClick,
            onKeyPress: onKeyPress,
            continuesPrior: continuesPrior,
            continuesAfter: continuesAfter,
            slotStart: slotMetrics.first,
            slotEnd: slotMetrics.last,
            selected: $ba6e2539d0024c3d$var$isSelected(event, selected),
            resizable: resizable
        });
    },
    renderSpan: function renderSpan(slots, len, key) {
        var content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
        var per = Math.abs(len) / slots * 100 + '%';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            key: key,
            className: "rbc-row-segment",
            style: {
                WebkitFlexBasis: per,
                flexBasis: per,
                maxWidth: per
            }
        }, content);
    }
};
function $ba6e2539d0024c3d$var$ownKeys$6(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba6e2539d0024c3d$var$_objectSpread$6(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba6e2539d0024c3d$var$ownKeys$6(Object(t), true).forEach(function(r) {
            (0, $bfbb99364ffa951d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba6e2539d0024c3d$var$ownKeys$6(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ba6e2539d0024c3d$var$_callSuper$c(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$c() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$c() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$c = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba6e2539d0024c3d$var$EventRow = /*#__PURE__*/ function(_React$Component) {
    function EventRow() {
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, EventRow);
        return $ba6e2539d0024c3d$var$_callSuper$c(this, EventRow, arguments);
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(EventRow, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(EventRow, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, segments = _this$props.segments, slots = _this$props.slotMetrics.slots, className = _this$props.className;
                var lastEnd = 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)(className, 'rbc-row')
                }, segments.reduce(function(row, _ref, li) {
                    var event = _ref.event, left = _ref.left, right = _ref.right, span = _ref.span;
                    var key = '_lvl_' + li;
                    var gap = left - lastEnd;
                    var content = $ba6e2539d0024c3d$var$EventRowMixin.renderEvent(_this.props, event);
                    if (gap) row.push($ba6e2539d0024c3d$var$EventRowMixin.renderSpan(slots, gap, "".concat(key, "_gap")));
                    row.push($ba6e2539d0024c3d$var$EventRowMixin.renderSpan(slots, span, key, content));
                    lastEnd = right + 1;
                    return row;
                }, []));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$EventRow.propTypes = {};
$ba6e2539d0024c3d$var$EventRow.defaultProps = $ba6e2539d0024c3d$var$_objectSpread$6({}, $ba6e2539d0024c3d$var$EventRowMixin.defaultProps);
function $ba6e2539d0024c3d$var$endOfRange(_ref) {
    var dateRange = _ref.dateRange, _ref$unit = _ref.unit, unit = _ref$unit === void 0 ? 'day' : _ref$unit, localizer = _ref.localizer;
    return {
        first: dateRange[0],
        last: localizer.add(dateRange[dateRange.length - 1], 1, unit)
    };
}
// properly calculating segments requires working with dates in
// the timezone we're working with, so we use the localizer
function $ba6e2539d0024c3d$var$eventSegments(event, range, accessors, localizer) {
    var _endOfRange = $ba6e2539d0024c3d$var$endOfRange({
        dateRange: range,
        localizer: localizer
    }), first = _endOfRange.first, last = _endOfRange.last;
    var slots = localizer.diff(first, last, 'day');
    var start = localizer.max(localizer.startOf(accessors.start(event), 'day'), first);
    var end = localizer.min(localizer.ceil(accessors.end(event), 'day'), last);
    var padding = (0, (/*@__PURE__*/$parcel$interopDefault($kO46s)))(range, function(x) {
        return localizer.isSameDate(x, start);
    });
    var span = localizer.diff(start, end, 'day');
    span = Math.min(span, slots);
    // The segmentOffset is necessary when adjusting for timezones
    // ahead of the browser timezone
    span = Math.max(span - localizer.segmentOffset, 1);
    return {
        event: event,
        span: span,
        left: padding + 1,
        right: Math.max(padding + span, 1)
    };
}
function $ba6e2539d0024c3d$var$eventLevels(rowSegments) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
    var i, j, seg, levels = [], extra = [];
    for(i = 0; i < rowSegments.length; i++){
        seg = rowSegments[i];
        for(j = 0; j < levels.length; j++)if (!$ba6e2539d0024c3d$var$segsOverlap(seg, levels[j])) break;
        if (j >= limit) extra.push(seg);
        else (levels[j] || (levels[j] = [])).push(seg);
    }
    for(i = 0; i < levels.length; i++)levels[i].sort(function(a, b) {
        return a.left - b.left;
    }); //eslint-disable-line
    return {
        levels: levels,
        extra: extra
    };
}
function $ba6e2539d0024c3d$var$inRange(e, start, end, accessors, localizer) {
    var event = {
        start: accessors.start(e),
        end: accessors.end(e)
    };
    var range = {
        start: start,
        end: end
    };
    return localizer.inEventRange({
        event: event,
        range: range
    });
}
function $ba6e2539d0024c3d$var$segsOverlap(seg, otherSegs) {
    return otherSegs.some(function(otherSeg) {
        return otherSeg.left <= seg.right && otherSeg.right >= seg.left;
    });
}
function $ba6e2539d0024c3d$var$sortWeekEvents(events, accessors, localizer) {
    var base = (0, $d6b7f356bb028375$export$2e2bcd8739ae039)(events);
    var multiDayEvents = [];
    var standardEvents = [];
    base.forEach(function(event) {
        var startCheck = accessors.start(event);
        var endCheck = accessors.end(event);
        if (localizer.daySpan(startCheck, endCheck) > 1) multiDayEvents.push(event);
        else standardEvents.push(event);
    });
    var multiSorted = multiDayEvents.sort(function(a, b) {
        return $ba6e2539d0024c3d$var$sortEvents(a, b, accessors, localizer);
    });
    var standardSorted = standardEvents.sort(function(a, b) {
        return $ba6e2539d0024c3d$var$sortEvents(a, b, accessors, localizer);
    });
    return [].concat((0, $d6b7f356bb028375$export$2e2bcd8739ae039)(multiSorted), (0, $d6b7f356bb028375$export$2e2bcd8739ae039)(standardSorted));
}
function $ba6e2539d0024c3d$var$sortEvents(eventA, eventB, accessors, localizer) {
    var evtA = {
        start: accessors.start(eventA),
        end: accessors.end(eventA),
        allDay: accessors.allDay(eventA)
    };
    var evtB = {
        start: accessors.start(eventB),
        end: accessors.end(eventB),
        allDay: accessors.allDay(eventB)
    };
    return localizer.sortEvents({
        evtA: evtA,
        evtB: evtB
    });
}
function $ba6e2539d0024c3d$var$ownKeys$5(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba6e2539d0024c3d$var$_objectSpread$5(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba6e2539d0024c3d$var$ownKeys$5(Object(t), true).forEach(function(r) {
            (0, $bfbb99364ffa951d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba6e2539d0024c3d$var$ownKeys$5(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ba6e2539d0024c3d$var$_callSuper$b(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$b() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$b() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$b = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// Modified: Check if a segment spans through this slot (including events that started earlier)
var $ba6e2539d0024c3d$var$isSegmentInSlot$1 = function isSegmentInSlot(seg, slot) {
    return seg.left <= slot && seg.right >= slot;
};
var $ba6e2539d0024c3d$var$eventsInSlot = function eventsInSlot(segments, slot) {
    return segments.filter(function(seg) {
        return $ba6e2539d0024c3d$var$isSegmentInSlot$1(seg, slot);
    }).map(function(seg) {
        return seg.event;
    });
};
var $ba6e2539d0024c3d$var$EventEndingRow = /*#__PURE__*/ function(_React$Component) {
    function EventEndingRow() {
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, EventEndingRow);
        return $ba6e2539d0024c3d$var$_callSuper$b(this, EventEndingRow, arguments);
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(EventEndingRow, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(EventEndingRow, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, segments = _this$props.segments, slots = _this$props.slotMetrics.slots;
                var rowSegments = $ba6e2539d0024c3d$var$eventLevels(segments).levels[0];
                var current = 1, lastEnd = 1, row = [];
                while(current <= slots){
                    var key = '_lvl_' + current;
                    // Find segment that starts at or spans through current slot
                    var _ref = rowSegments.filter(function(seg) {
                        return $ba6e2539d0024c3d$var$isSegmentInSlot$1(seg, current);
                    })[0] || {}, event = _ref.event, left = _ref.left, right = _ref.right, span = _ref.span;
                    if (!event) {
                        // No visible event starts at this slot, but check if we need a "more" button
                        // for hidden events that span this slot
                        var hiddenEvents = this.getHiddenEventsForSlot(segments, current);
                        if (hiddenEvents.length > 0) {
                            var _gap = current - lastEnd;
                            if (_gap) row.push($ba6e2539d0024c3d$var$EventRowMixin.renderSpan(slots, _gap, key + '_gap'));
                            row.push($ba6e2539d0024c3d$var$EventRowMixin.renderSpan(slots, 1, key, this.renderShowMore(segments, current)));
                            lastEnd = current = current + 1;
                            continue;
                        }
                        current++;
                        continue;
                    }
                    var gap = Math.max(0, left - lastEnd);
                    if (this.canRenderSlotEvent(left, span)) {
                        var content = $ba6e2539d0024c3d$var$EventRowMixin.renderEvent(this.props, event);
                        if (gap) row.push($ba6e2539d0024c3d$var$EventRowMixin.renderSpan(slots, gap, key + '_gap'));
                        row.push($ba6e2539d0024c3d$var$EventRowMixin.renderSpan(slots, span, key, content));
                        lastEnd = current = right + 1;
                    } else {
                        if (gap) row.push($ba6e2539d0024c3d$var$EventRowMixin.renderSpan(slots, gap, key + '_gap'));
                        row.push($ba6e2539d0024c3d$var$EventRowMixin.renderSpan(slots, 1, key, this.renderShowMore(segments, current)));
                        lastEnd = current = current + 1;
                    }
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: "rbc-row"
                }, row);
            }
        },
        {
            key: "getHiddenEventsForSlot",
            value: function getHiddenEventsForSlot(segments, slot) {
                // Get all events (visible and hidden) for this slot
                var allEventsInSlot = $ba6e2539d0024c3d$var$eventsInSlot(segments, slot);
                // Get visible events for this slot from the first level
                var rowSegments = $ba6e2539d0024c3d$var$eventLevels(segments).levels[0];
                var visibleEventsInSlot = rowSegments.filter(function(seg) {
                    return $ba6e2539d0024c3d$var$isSegmentInSlot$1(seg, slot);
                }).map(function(seg) {
                    return seg.event;
                });
                // Return events that are in allEventsInSlot but not in visibleEventsInSlot
                return allEventsInSlot.filter(function(event) {
                    return !visibleEventsInSlot.some(function(visEvent) {
                        return visEvent === event;
                    });
                });
            }
        },
        {
            key: "canRenderSlotEvent",
            value: function canRenderSlotEvent(slot, span) {
                var segments = this.props.segments;
                return (0, (/*@__PURE__*/$parcel$interopDefault($c4e211d47f952c70$exports)))(slot, slot + span).every(function(s) {
                    var count = $ba6e2539d0024c3d$var$eventsInSlot(segments, s).length;
                    return count === 1;
                });
            }
        },
        {
            key: "renderShowMore",
            value: function renderShowMore(segments, slot) {
                var _this = this;
                var _this$props2 = this.props, localizer = _this$props2.localizer, slotMetrics = _this$props2.slotMetrics, components = _this$props2.components;
                var events = slotMetrics.getEventsForSlot(slot);
                var remainingEvents = $ba6e2539d0024c3d$var$eventsInSlot(segments, slot);
                var count = remainingEvents.length;
                if (components !== null && components !== void 0 && components.showMore) {
                    var ShowMore = components.showMore;
                    // The received slot seems to be 1-based, but the range we use to pull the date is 0-based
                    var slotDate = slotMetrics.getDateForSlot(slot - 1);
                    return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(ShowMore, {
                        localizer: localizer,
                        slotDate: slotDate,
                        slot: slot,
                        count: count,
                        events: events,
                        remainingEvents: remainingEvents
                    }) : false;
                }
                return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
                    type: "button",
                    key: 'sm_' + slot,
                    className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-button-link', 'rbc-show-more'),
                    onClick: function onClick(e) {
                        return _this.showMore(slot, e);
                    }
                }, localizer.messages.showMore(count, remainingEvents, events)) : false;
            }
        },
        {
            key: "showMore",
            value: function showMore(slot, e) {
                e.preventDefault();
                e.stopPropagation();
                this.props.onShowMore(slot, e.target);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$EventEndingRow.propTypes = {};
$ba6e2539d0024c3d$var$EventEndingRow.defaultProps = $ba6e2539d0024c3d$var$_objectSpread$5({}, $ba6e2539d0024c3d$var$EventRowMixin.defaultProps);
var $ba6e2539d0024c3d$var$ScrollableWeekWrapper = function ScrollableWeekWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        className: "rbc-row-content-scroll-container"
    }, children);
};
function $ba6e2539d0024c3d$var$ownKeys$4(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba6e2539d0024c3d$var$_objectSpread$4(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba6e2539d0024c3d$var$ownKeys$4(Object(t), true).forEach(function(r) {
            (0, $bfbb99364ffa951d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba6e2539d0024c3d$var$ownKeys$4(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ba6e2539d0024c3d$var$isSegmentInSlot = function isSegmentInSlot(seg, slot) {
    return seg.left <= slot && seg.right >= slot;
};
var $ba6e2539d0024c3d$var$isEqual = function isEqual(a, b) {
    return a[0].range === b[0].range && a[0].events === b[0].events;
};
function $ba6e2539d0024c3d$var$getSlotMetrics$1() {
    return (0, $074df527245e0057$export$2e2bcd8739ae039)(function(options) {
        var range = options.range, events = options.events, maxRows = options.maxRows, minRows = options.minRows, accessors = options.accessors, localizer = options.localizer;
        var _endOfRange = $ba6e2539d0024c3d$var$endOfRange({
            dateRange: range,
            localizer: localizer
        }), first = _endOfRange.first, last = _endOfRange.last;
        var segments = events.map(function(evt) {
            return $ba6e2539d0024c3d$var$eventSegments(evt, range, accessors, localizer);
        });
        var _eventLevels = $ba6e2539d0024c3d$var$eventLevels(segments, Math.max(maxRows - 1, 1)), levels = _eventLevels.levels, extra = _eventLevels.extra;
        // Subtract 1 from minRows to not include showMore button row when
        // it would be rendered
        var minEventRows = extra.length > 0 ? minRows - 1 : minRows;
        while(levels.length < minEventRows)levels.push([]);
        return {
            first: first,
            last: last,
            levels: levels,
            extra: extra,
            range: range,
            slots: range.length,
            clone: function clone(args) {
                var metrics = $ba6e2539d0024c3d$var$getSlotMetrics$1();
                return metrics($ba6e2539d0024c3d$var$_objectSpread$4($ba6e2539d0024c3d$var$_objectSpread$4({}, options), args));
            },
            getDateForSlot: function getDateForSlot(slotNumber) {
                return range[slotNumber];
            },
            getSlotForDate: function getSlotForDate(date) {
                return range.find(function(r) {
                    return localizer.isSameDate(r, date);
                });
            },
            getEventsForSlot: function getEventsForSlot(slot) {
                return segments.filter(function(seg) {
                    return $ba6e2539d0024c3d$var$isSegmentInSlot(seg, slot);
                }).map(function(seg) {
                    return seg.event;
                });
            },
            continuesPrior: function continuesPrior(event) {
                return localizer.continuesPrior(accessors.start(event), first);
            },
            continuesAfter: function continuesAfter(event) {
                var start = accessors.start(event);
                var end = accessors.end(event);
                return localizer.continuesAfter(start, end, last);
            }
        };
    }, $ba6e2539d0024c3d$var$isEqual);
}
function $ba6e2539d0024c3d$var$_callSuper$a(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$a() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$a() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$a = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba6e2539d0024c3d$var$DateContentRow = /*#__PURE__*/ function(_React$Component) {
    function DateContentRow() {
        var _this;
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, DateContentRow);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $ba6e2539d0024c3d$var$_callSuper$a(this, DateContentRow, [].concat(args));
        _this.handleSelectSlot = function(slot) {
            var _this$props = _this.props, range = _this$props.range, onSelectSlot = _this$props.onSelectSlot;
            onSelectSlot(range.slice(slot.start, slot.end + 1), slot);
        };
        _this.handleShowMore = function(slot, target) {
            var _this$props2 = _this.props, range = _this$props2.range, onShowMore = _this$props2.onShowMore;
            var metrics = _this.slotMetrics(_this.props);
            var row = (0, $599af5572367d16f$export$2e2bcd8739ae039)(_this.containerRef.current, '.rbc-row-bg')[0];
            var cell;
            if (row) cell = row.children[slot - 1];
            var events = metrics.getEventsForSlot(slot);
            onShowMore(events, range[slot - 1], cell, slot, target);
        };
        _this.getContainer = function() {
            var container = _this.props.container;
            return container ? container() : _this.containerRef.current;
        };
        _this.renderHeadingCell = function(date, index) {
            var _this$props3 = _this.props, renderHeader = _this$props3.renderHeader, getNow = _this$props3.getNow, localizer = _this$props3.localizer;
            return renderHeader({
                date: date,
                key: "header_".concat(index),
                className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-date-cell', localizer.isSameDate(date, getNow()) && 'rbc-now')
            });
        };
        _this.renderDummy = function() {
            var _this$props4 = _this.props, className = _this$props4.className, range = _this$props4.range, renderHeader = _this$props4.renderHeader, showAllEvents = _this$props4.showAllEvents;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: className,
                ref: _this.containerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-row-content', showAllEvents && 'rbc-row-content-scrollable')
            }, renderHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "rbc-row",
                ref: _this.headingRowRef
            }, range.map(_this.renderHeadingCell)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "rbc-row",
                ref: _this.eventRowRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "rbc-row-segment"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "rbc-event"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "rbc-event-content"
            }, "\xA0"))))));
        };
        _this.containerRef = /*#__PURE__*/ (0, $5s1kH.createRef)();
        _this.headingRowRef = /*#__PURE__*/ (0, $5s1kH.createRef)();
        _this.eventRowRef = /*#__PURE__*/ (0, $5s1kH.createRef)();
        _this.slotMetrics = $ba6e2539d0024c3d$var$getSlotMetrics$1();
        return _this;
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(DateContentRow, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(DateContentRow, [
        {
            key: "getRowLimit",
            value: function getRowLimit() {
                var _this$headingRowRef;
                /* Guessing this only gets called on the dummyRow */ var eventHeight = (0, $281907b8d7a224c6$export$2e2bcd8739ae039)(this.eventRowRef.current);
                var headingHeight = (_this$headingRowRef = this.headingRowRef) !== null && _this$headingRowRef !== void 0 && _this$headingRowRef.current ? (0, $281907b8d7a224c6$export$2e2bcd8739ae039)(this.headingRowRef.current) : 0;
                var eventSpace = (0, $281907b8d7a224c6$export$2e2bcd8739ae039)(this.containerRef.current) - headingHeight;
                return Math.max(Math.floor(eventSpace / eventHeight), 1);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, date = _this$props5.date, rtl = _this$props5.rtl, range = _this$props5.range, className = _this$props5.className, selected = _this$props5.selected, selectable = _this$props5.selectable, renderForMeasure = _this$props5.renderForMeasure, accessors = _this$props5.accessors, getters = _this$props5.getters, components = _this$props5.components, getNow = _this$props5.getNow, renderHeader = _this$props5.renderHeader, onSelect = _this$props5.onSelect, localizer = _this$props5.localizer, onSelectStart = _this$props5.onSelectStart, onSelectEnd = _this$props5.onSelectEnd, onDoubleClick = _this$props5.onDoubleClick, onKeyPress = _this$props5.onKeyPress, resourceId = _this$props5.resourceId, longPressThreshold = _this$props5.longPressThreshold, isAllDay = _this$props5.isAllDay, resizable = _this$props5.resizable, showAllEvents = _this$props5.showAllEvents;
                if (renderForMeasure) return this.renderDummy();
                var metrics = this.slotMetrics(this.props);
                var levels = metrics.levels, extra = metrics.extra;
                var ScrollableWeekComponent = showAllEvents ? $ba6e2539d0024c3d$var$ScrollableWeekWrapper : $ba6e2539d0024c3d$var$NoopWrapper;
                var WeekWrapper = components.weekWrapper;
                var eventRowProps = {
                    selected: selected,
                    accessors: accessors,
                    getters: getters,
                    localizer: localizer,
                    components: components,
                    onSelect: onSelect,
                    onDoubleClick: onDoubleClick,
                    onKeyPress: onKeyPress,
                    resourceId: resourceId,
                    slotMetrics: metrics,
                    resizable: resizable
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: className,
                    role: "rowgroup",
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$BackgroundCells, {
                    localizer: localizer,
                    date: date,
                    getNow: getNow,
                    rtl: rtl,
                    range: range,
                    selectable: selectable,
                    container: this.getContainer,
                    getters: getters,
                    onSelectStart: onSelectStart,
                    onSelectEnd: onSelectEnd,
                    onSelectSlot: this.handleSelectSlot,
                    components: components,
                    longPressThreshold: longPressThreshold,
                    resourceId: resourceId
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-row-content', showAllEvents && 'rbc-row-content-scrollable'),
                    role: "row"
                }, renderHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: "rbc-row ",
                    ref: this.headingRowRef
                }, range.map(this.renderHeadingCell)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(ScrollableWeekComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(WeekWrapper, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({
                    isAllDay: isAllDay
                }, eventRowProps, {
                    rtl: this.props.rtl
                }), levels.map(function(segs, idx) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$EventRow, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({
                        key: idx,
                        segments: segs
                    }, eventRowProps));
                }), !!extra.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$EventEndingRow, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({
                    segments: extra,
                    onShowMore: this.handleShowMore
                }, eventRowProps))))));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$DateContentRow.propTypes = {};
$ba6e2539d0024c3d$var$DateContentRow.defaultProps = {
    minRows: 0,
    maxRows: Infinity
};
var $ba6e2539d0024c3d$var$Header = function Header(_ref) {
    var label = _ref.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
        role: "columnheader",
        "aria-sort": "none"
    }, label);
};
$ba6e2539d0024c3d$var$Header.propTypes = {};
var $ba6e2539d0024c3d$var$DateHeader = function DateHeader(_ref) {
    var label = _ref.label, drilldownView = _ref.drilldownView, onDrillDown = _ref.onDrillDown;
    if (!drilldownView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", null, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
        type: "button",
        className: "rbc-button-link",
        onClick: onDrillDown
    }, label);
};
$ba6e2539d0024c3d$var$DateHeader.propTypes = {};
var $ba6e2539d0024c3d$var$_excluded$6 = [
    "date",
    "className"
];
function $ba6e2539d0024c3d$var$_callSuper$9(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$9() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$9() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$9 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba6e2539d0024c3d$var$eventsForWeek = function eventsForWeek(evts, start, end, accessors, localizer) {
    return evts.filter(function(e) {
        return $ba6e2539d0024c3d$var$inRange(e, start, end, accessors, localizer);
    });
};
var $ba6e2539d0024c3d$var$MonthView = /*#__PURE__*/ function(_React$Component) {
    function MonthView() {
        var _this;
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, MonthView);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = $ba6e2539d0024c3d$var$_callSuper$9(this, MonthView, [].concat(_args));
        _this.getContainer = function() {
            return _this.containerRef.current;
        };
        _this.renderWeek = function(week, weekIdx) {
            var _this$props = _this.props, events = _this$props.events, components = _this$props.components, selectable = _this$props.selectable, getNow = _this$props.getNow, selected = _this$props.selected, date = _this$props.date, localizer = _this$props.localizer, longPressThreshold = _this$props.longPressThreshold, accessors = _this$props.accessors, getters = _this$props.getters, showAllEvents = _this$props.showAllEvents;
            var _this$state = _this.state, needLimitMeasure = _this$state.needLimitMeasure, rowLimit = _this$state.rowLimit;
            // let's not mutate props
            var weeksEvents = $ba6e2539d0024c3d$var$eventsForWeek((0, $d6b7f356bb028375$export$2e2bcd8739ae039)(events), week[0], week[week.length - 1], accessors, localizer);
            var sorted = $ba6e2539d0024c3d$var$sortWeekEvents(weeksEvents, accessors, localizer);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$DateContentRow, {
                key: weekIdx,
                ref: weekIdx === 0 ? _this.slotRowRef : undefined,
                container: _this.getContainer,
                className: "rbc-month-row",
                getNow: getNow,
                date: date,
                range: week,
                events: sorted,
                maxRows: showAllEvents ? Infinity : rowLimit,
                selected: selected,
                selectable: selectable,
                components: components,
                accessors: accessors,
                getters: getters,
                localizer: localizer,
                renderHeader: _this.readerDateHeading,
                renderForMeasure: needLimitMeasure,
                onShowMore: _this.handleShowMore,
                onSelect: _this.handleSelectEvent,
                onDoubleClick: _this.handleDoubleClickEvent,
                onKeyPress: _this.handleKeyPressEvent,
                onSelectSlot: _this.handleSelectSlot,
                longPressThreshold: longPressThreshold,
                rtl: _this.props.rtl,
                resizable: _this.props.resizable,
                showAllEvents: showAllEvents
            });
        };
        _this.readerDateHeading = function(_ref) {
            var date = _ref.date, className = _ref.className, props = (0, $7b4c4f4a56bd113a$export$2e2bcd8739ae039)(_ref, $ba6e2539d0024c3d$var$_excluded$6);
            var _this$props2 = _this.props, currentDate = _this$props2.date, getDrilldownView = _this$props2.getDrilldownView, localizer = _this$props2.localizer;
            var isOffRange = localizer.neq(currentDate, date, 'month');
            var isCurrent = localizer.isSameDate(date, currentDate);
            var drilldownView = getDrilldownView(date);
            var label = localizer.format(date, 'dateFormat');
            var DateHeaderComponent = _this.props.components.dateHeader || $ba6e2539d0024c3d$var$DateHeader;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, props, {
                className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)(className, isOffRange && 'rbc-off-range', isCurrent && 'rbc-current'),
                role: "cell"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(DateHeaderComponent, {
                label: label,
                date: date,
                drilldownView: drilldownView,
                isOffRange: isOffRange,
                onDrillDown: function onDrillDown(e) {
                    return _this.handleHeadingClick(date, drilldownView, e);
                }
            }));
        };
        _this.handleSelectSlot = function(range, slotInfo) {
            _this._pendingSelection = _this._pendingSelection.concat(range);
            clearTimeout(_this._selectTimer);
            _this._selectTimer = setTimeout(function() {
                return _this.selectDates(slotInfo);
            });
        };
        _this.handleHeadingClick = function(date, view, e) {
            e.preventDefault();
            _this.clearSelection();
            $ba6e2539d0024c3d$var$notify(_this.props.onDrillDown, [
                date,
                view
            ]);
        };
        _this.handleSelectEvent = function() {
            _this.clearSelection();
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $ba6e2539d0024c3d$var$notify(_this.props.onSelectEvent, args);
        };
        _this.handleDoubleClickEvent = function() {
            _this.clearSelection();
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $ba6e2539d0024c3d$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this.handleKeyPressEvent = function() {
            _this.clearSelection();
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            $ba6e2539d0024c3d$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.handleShowMore = function(events, date, cell, slot, target) {
            var _this$props3 = _this.props, popup = _this$props3.popup, onDrillDown = _this$props3.onDrillDown, onShowMore = _this$props3.onShowMore, getDrilldownView = _this$props3.getDrilldownView, doShowMoreDrillDown = _this$props3.doShowMoreDrillDown;
            //cancel any pending selections so only the event click goes through.
            _this.clearSelection();
            if (popup) {
                var position = (0, $912245913eb5c0fe$export$2e2bcd8739ae039)(cell, _this.containerRef.current);
                _this.setState({
                    overlay: {
                        date: date,
                        events: events,
                        position: position,
                        target: target
                    }
                });
            } else if (doShowMoreDrillDown) $ba6e2539d0024c3d$var$notify(onDrillDown, [
                date,
                getDrilldownView(date) || $ba6e2539d0024c3d$export$5cb791131c501f6a.DAY
            ]);
            $ba6e2539d0024c3d$var$notify(onShowMore, [
                events,
                date,
                slot
            ]);
        };
        _this.overlayDisplay = function() {
            _this.setState({
                overlay: null
            });
        };
        _this.state = {
            rowLimit: 5,
            needLimitMeasure: true,
            date: null
        };
        _this.containerRef = /*#__PURE__*/ (0, $5s1kH.createRef)();
        _this.slotRowRef = /*#__PURE__*/ (0, $5s1kH.createRef)();
        _this._bgRows = [];
        _this._pendingSelection = [];
        return _this;
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(MonthView, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(MonthView, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var running;
                if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
                window.addEventListener('resize', this._resizeListener = function() {
                    if (!running) $77a4d87038ac8daf$export$b5fe3f66a567bec0(function() {
                        running = false;
                        _this2.setState({
                            needLimitMeasure: true
                        }); //eslint-disable-line
                    });
                }, false);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener('resize', this._resizeListener, false);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, date = _this$props4.date, localizer = _this$props4.localizer, className = _this$props4.className, month = localizer.visibleDays(date, localizer), weeks = (0, (/*@__PURE__*/$parcel$interopDefault($fb89aac394154b73$exports)))(month, 7);
                this._weekCount = weeks.length;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-month-view', className),
                    role: "table",
                    "aria-label": "Month View",
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: "rbc-row rbc-month-header",
                    role: "row"
                }, this.renderHeaders(weeks[0])), weeks.map(this.renderWeek), this.props.popup && this.renderOverlay());
            }
        },
        {
            key: "renderHeaders",
            value: function renderHeaders(row) {
                var _this$props5 = this.props, localizer = _this$props5.localizer, components = _this$props5.components;
                var first = row[0];
                var last = row[row.length - 1];
                var HeaderComponent = components.header || $ba6e2539d0024c3d$var$Header;
                return localizer.range(first, last, 'day').map(function(day, idx) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        key: 'header_' + idx,
                        className: "rbc-header"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(HeaderComponent, {
                        date: day,
                        localizer: localizer,
                        label: localizer.format(day, 'weekdayFormat')
                    }));
                });
            }
        },
        {
            key: "renderOverlay",
            value: function renderOverlay() {
                var _this$state$overlay, _this$state2, _this3 = this;
                var overlay = (_this$state$overlay = (_this$state2 = this.state) === null || _this$state2 === void 0 ? void 0 : _this$state2.overlay) !== null && _this$state$overlay !== void 0 ? _this$state$overlay : {};
                var _this$props6 = this.props, accessors = _this$props6.accessors, localizer = _this$props6.localizer, components = _this$props6.components, getters = _this$props6.getters, selected = _this$props6.selected, popupOffset = _this$props6.popupOffset, handleDragStart = _this$props6.handleDragStart;
                var onHide = function onHide() {
                    return _this3.setState({
                        overlay: null
                    });
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$PopOverlay, {
                    overlay: overlay,
                    accessors: accessors,
                    localizer: localizer,
                    components: components,
                    getters: getters,
                    selected: selected,
                    popupOffset: popupOffset,
                    ref: this.containerRef,
                    handleKeyPressEvent: this.handleKeyPressEvent,
                    handleSelectEvent: this.handleSelectEvent,
                    handleDoubleClickEvent: this.handleDoubleClickEvent,
                    handleDragStart: handleDragStart,
                    show: !!overlay.position,
                    overlayDisplay: this.overlayDisplay,
                    onHide: onHide
                });
            /* return (
        <Overlay
          rootClose
          placement="bottom"
          show={!!overlay.position}
          onHide={() => this.setState({ overlay: null })}
          target={() => overlay.target}
        >
          {({ props }) => (
            <Popup
              {...props}
              popupOffset={popupOffset}
              accessors={accessors}
              getters={getters}
              selected={selected}
              components={components}
              localizer={localizer}
              position={overlay.position}
              show={this.overlayDisplay}
              events={overlay.events}
              slotStart={overlay.date}
              slotEnd={overlay.end}
              onSelect={this.handleSelectEvent}
              onDoubleClick={this.handleDoubleClickEvent}
              onKeyPress={this.handleKeyPressEvent}
              handleDragStart={this.props.handleDragStart}
            />
          )}
        </Overlay>
      ) */ }
        },
        {
            key: "measureRowLimit",
            value: function measureRowLimit() {
                this.setState({
                    needLimitMeasure: false,
                    rowLimit: this.slotRowRef.current.getRowLimit()
                });
            }
        },
        {
            key: "selectDates",
            value: function selectDates(slotInfo) {
                var slots = this._pendingSelection.slice();
                this._pendingSelection = [];
                slots.sort(function(a, b) {
                    return +a - +b;
                });
                var start = new Date(slots[0]);
                var end = new Date(slots[slots.length - 1]);
                end.setDate(slots[slots.length - 1].getDate() + 1);
                $ba6e2539d0024c3d$var$notify(this.props.onSelectSlot, {
                    slots: slots,
                    start: start,
                    end: end,
                    action: slotInfo.action,
                    bounds: slotInfo.bounds,
                    box: slotInfo.box
                });
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                clearTimeout(this._selectTimer);
                this._pendingSelection = [];
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(_ref2, state) {
                var date = _ref2.date, localizer = _ref2.localizer;
                return {
                    date: date,
                    needLimitMeasure: state.needLimitMeasure || localizer.neq(date, state.date, 'month')
                };
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$MonthView.propTypes = {};
$ba6e2539d0024c3d$var$MonthView.range = function(date, _ref3) {
    var localizer = _ref3.localizer;
    var start = localizer.firstVisibleDay(date, localizer);
    var end = localizer.lastVisibleDay(date, localizer);
    return {
        start: start,
        end: end
    };
};
$ba6e2539d0024c3d$var$MonthView.navigate = function(date, action, _ref4) {
    var localizer = _ref4.localizer;
    switch(action){
        case $ba6e2539d0024c3d$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -1, 'month');
        case $ba6e2539d0024c3d$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, 1, 'month');
        default:
            return date;
    }
};
$ba6e2539d0024c3d$var$MonthView.title = function(date, _ref5) {
    var localizer = _ref5.localizer;
    return localizer.format(date, 'monthHeaderFormat');
};
var $ba6e2539d0024c3d$var$getKey = function getKey(_ref) {
    var min = _ref.min, max = _ref.max, step = _ref.step, slots = _ref.slots, localizer = _ref.localizer;
    return "".concat(+localizer.startOf(min, 'minutes')) + "".concat(+localizer.startOf(max, 'minutes')) + "".concat(step, "-").concat(slots);
};
function $ba6e2539d0024c3d$var$getSlotMetrics(_ref2) {
    var start = _ref2.min, end = _ref2.max, step = _ref2.step, timeslots = _ref2.timeslots, localizer = _ref2.localizer;
    var key = $ba6e2539d0024c3d$var$getKey({
        step: step,
        localizer: localizer
    });
    // DST differences are handled inside the localizer
    var totalMin = 1 + localizer.getTotalMin(start, end);
    var minutesFromMidnight = localizer.getMinutesFromMidnight(start);
    var numGroups = Math.ceil((totalMin - 1) / (step * timeslots));
    var numSlots = numGroups * timeslots;
    var groups = new Array(numGroups);
    var slots = new Array(numSlots);
    // Each slot date is created from "zero", instead of adding `step` to
    // the previous one, in order to avoid DST oddities
    for(var grp = 0; grp < numGroups; grp++){
        groups[grp] = new Array(timeslots);
        for(var slot = 0; slot < timeslots; slot++){
            var slotIdx = grp * timeslots + slot;
            var minFromStart = slotIdx * step;
            // A date with total minutes calculated from the start of the day
            slots[slotIdx] = groups[grp][slot] = localizer.getSlotDate(start, minutesFromMidnight, minFromStart);
        }
    }
    // Necessary to be able to select up until the last timeslot in a day
    var lastSlotMinFromStart = slots.length * step;
    slots.push(localizer.getSlotDate(start, minutesFromMidnight, lastSlotMinFromStart));
    function positionFromDate(date) {
        var diff = localizer.diff(start, date, 'minutes') + localizer.getDstOffset(start, date);
        return Math.min(diff, totalMin);
    }
    return {
        groups: groups,
        update: function update(args) {
            if ($ba6e2539d0024c3d$var$getKey(args) !== key) return $ba6e2539d0024c3d$var$getSlotMetrics(args);
            return this;
        },
        dateIsInGroup: function dateIsInGroup(date, groupIndex) {
            var nextGroup = groups[groupIndex + 1];
            return localizer.inRange(date, groups[groupIndex][0], nextGroup ? nextGroup[0] : end, 'minutes');
        },
        nextSlot: function nextSlot(slot) {
            // We cannot guarantee that the slot object must be in slots,
            // because after each update, a new slots array will be created.
            var next = slots[Math.min(slots.findIndex(function(s) {
                return s === slot || localizer.eq(s, slot);
            }) + 1, slots.length - 1)];
            // in the case of the last slot we won't a long enough range so manually get it
            if (localizer.eq(next, slot)) next = localizer.add(slot, step, 'minutes');
            return next;
        },
        closestSlotToPosition: function closestSlotToPosition(percent) {
            var slot = Math.min(slots.length - 1, Math.max(0, Math.floor(percent * numSlots)));
            return slots[slot];
        },
        closestSlotFromPoint: function closestSlotFromPoint(point, boundaryRect) {
            var range = Math.abs(boundaryRect.top - boundaryRect.bottom);
            return this.closestSlotToPosition((point.y - boundaryRect.top) / range);
        },
        closestSlotFromDate: function closestSlotFromDate(date) {
            var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            if (localizer.lt(date, start, 'minutes')) return slots[0];
            if (localizer.gt(date, end, 'minutes')) return slots[slots.length - 1];
            var diffMins = localizer.diff(start, date, 'minutes');
            return slots[(diffMins - diffMins % step) / step + offset];
        },
        startsBeforeDay: function startsBeforeDay(date) {
            return localizer.lt(date, start, 'day');
        },
        startsAfterDay: function startsAfterDay(date) {
            return localizer.gt(date, end, 'day');
        },
        startsBefore: function startsBefore(date) {
            return localizer.lt(localizer.merge(start, date), start, 'minutes');
        },
        startsAfter: function startsAfter(date) {
            return localizer.gt(localizer.merge(end, date), end, 'minutes');
        },
        getRange: function getRange(rangeStart, rangeEnd, ignoreMin, ignoreMax) {
            if (!ignoreMin) rangeStart = localizer.min(end, localizer.max(start, rangeStart));
            if (!ignoreMax) rangeEnd = localizer.min(end, localizer.max(start, rangeEnd));
            var rangeStartMin = positionFromDate(rangeStart);
            var rangeEndMin = positionFromDate(rangeEnd);
            var top = rangeEndMin > step * numSlots && !localizer.eq(end, rangeEnd) ? (rangeStartMin - step) / (step * numSlots) * 100 : rangeStartMin / (step * numSlots) * 100;
            return {
                top: top,
                height: rangeEndMin / (step * numSlots) * 100 - top,
                start: positionFromDate(rangeStart),
                startDate: rangeStart,
                end: positionFromDate(rangeEnd),
                endDate: rangeEnd
            };
        },
        getCurrentTimePosition: function getCurrentTimePosition(rangeStart) {
            var rangeStartMin = positionFromDate(rangeStart);
            var top = rangeStartMin / (step * numSlots) * 100;
            return top;
        }
    };
}
var $ba6e2539d0024c3d$var$Event = /*#__PURE__*/ function() {
    function Event(data, _ref) {
        var accessors = _ref.accessors, slotMetrics = _ref.slotMetrics;
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, Event);
        var _slotMetrics$getRange = slotMetrics.getRange(accessors.start(data), accessors.end(data)), start = _slotMetrics$getRange.start, startDate = _slotMetrics$getRange.startDate, end = _slotMetrics$getRange.end, endDate = _slotMetrics$getRange.endDate, top = _slotMetrics$getRange.top, height = _slotMetrics$getRange.height;
        this.start = start;
        this.end = end;
        this.startMs = +startDate;
        this.endMs = +endDate;
        this.top = top;
        this.height = height;
        this.data = data;
    }
    /**
   * The event's width without any overlap.
   */ return (0, $b944111f291d7912$export$2e2bcd8739ae039)(Event, [
        {
            key: "_width",
            get: function get() {
                // The container event's width is determined by the maximum number of
                // events in any of its rows.
                if (this.rows) {
                    var columns = this.rows.reduce(function(max, row) {
                        return Math.max(max, row.leaves.length + 1);
                    }, // add itself
                    0) + 1; // add the container
                    return 100 / columns;
                }
                // The row event's width is the space left by the container, divided
                // among itself and its leaves.
                if (this.leaves) {
                    var availableWidth = 100 - this.container._width;
                    return availableWidth / (this.leaves.length + 1);
                }
                // The leaf event's width is determined by its row's width
                return this.row._width;
            }
        },
        {
            key: "width",
            get: function get() {
                var _$noOverlap = this._width;
                var overlap = Math.min(100, this._width * 1.7);
                // Containers can always grow.
                if (this.rows) return overlap;
                // Rows can grow if they have leaves.
                if (this.leaves) return this.leaves.length > 0 ? overlap : _$noOverlap;
                // Leaves can grow unless they're the last item in a row.
                var leaves = this.row.leaves;
                var index = leaves.indexOf(this);
                return index === leaves.length - 1 ? _$noOverlap : overlap;
            }
        },
        {
            key: "xOffset",
            get: function get() {
                // Containers have no offset.
                if (this.rows) return 0;
                // Rows always start where their container ends.
                if (this.leaves) return this.container._width;
                // Leaves are spread out evenly on the space left by its row.
                var _this$row = this.row, leaves = _this$row.leaves, xOffset = _this$row.xOffset, _width = _this$row._width;
                var index = leaves.indexOf(this) + 1;
                return xOffset + index * _width;
            }
        }
    ]);
}();
/**
 * Return true if event a and b is considered to be on the same row.
 */ function $ba6e2539d0024c3d$var$onSameRow(a, b, minimumStartDifference) {
    return(// Occupies the same start slot.
    Math.abs(b.start - a.start) < minimumStartDifference || // A's start slot overlaps with b's end slot.
    b.start > a.start && b.start < a.end);
}
function $ba6e2539d0024c3d$var$sortByRender(events) {
    var sortedByTime = (0, (/*@__PURE__*/$parcel$interopDefault($b90a193c64a52ca2$exports)))(events, [
        'startMs',
        function(e) {
            return -e.endMs;
        }
    ]);
    var sorted = [];
    while(sortedByTime.length > 0){
        var event = sortedByTime.shift();
        sorted.push(event);
        for(var i = 0; i < sortedByTime.length; i++){
            var test = sortedByTime[i];
            // Still inside this event, look for next.
            if (event.endMs > test.startMs) continue;
            // We've found the first event of the next event group.
            // If that event is not right next to our current event, we have to
            // move it here.
            if (i > 0) {
                var _event = sortedByTime.splice(i, 1)[0];
                sorted.push(_event);
            }
            break;
        }
    }
    return sorted;
}
function $ba6e2539d0024c3d$var$getStyledEvents$1(_ref2) {
    var events = _ref2.events, minimumStartDifference = _ref2.minimumStartDifference, slotMetrics = _ref2.slotMetrics, accessors = _ref2.accessors;
    // Create proxy events and order them so that we don't have
    // to fiddle with z-indexes.
    var proxies = events.map(function(event) {
        return new $ba6e2539d0024c3d$var$Event(event, {
            slotMetrics: slotMetrics,
            accessors: accessors
        });
    });
    var eventsInRenderOrder = $ba6e2539d0024c3d$var$sortByRender(proxies);
    // Group overlapping events, while keeping order.
    // Every event is always one of: container, row or leaf.
    // Containers can contain rows, and rows can contain leaves.
    var containerEvents = [];
    var _loop = function _loop() {
        var event = eventsInRenderOrder[i];
        // Check if this event can go into a container event.
        var container = containerEvents.find(function(c) {
            return c.end > event.start || Math.abs(event.start - c.start) < minimumStartDifference;
        });
        // Couldn't find a container — that means this event is a container.
        if (!container) {
            event.rows = [];
            containerEvents.push(event);
            return 1; // continue
        }
        // Found a container for the event.
        event.container = container;
        // Check if the event can be placed in an existing row.
        // Start looking from behind.
        var row = null;
        for(var j = container.rows.length - 1; !row && j >= 0; j--)if ($ba6e2539d0024c3d$var$onSameRow(container.rows[j], event, minimumStartDifference)) row = container.rows[j];
        if (row) {
            // Found a row, so add it.
            row.leaves.push(event);
            event.row = row;
        } else {
            // Couldn't find a row – that means this event is a row.
            event.leaves = [];
            container.rows.push(event);
        }
    };
    for(var i = 0; i < eventsInRenderOrder.length; i++){
        if (_loop()) continue;
    }
    // Return the original events, along with their styles.
    return eventsInRenderOrder.map(function(event) {
        return {
            event: event.data,
            style: {
                top: event.top,
                height: event.height,
                width: event.width,
                xOffset: Math.max(0, event.xOffset)
            }
        };
    });
}
function $ba6e2539d0024c3d$var$getMaxIdxDFS(node, maxIdx, visited) {
    for(var i = 0; i < node.friends.length; ++i){
        if (visited.indexOf(node.friends[i]) > -1) continue;
        maxIdx = maxIdx > node.friends[i].idx ? maxIdx : node.friends[i].idx;
        // TODO : trace it by not object but kinda index or something for performance
        visited.push(node.friends[i]);
        var newIdx = $ba6e2539d0024c3d$var$getMaxIdxDFS(node.friends[i], maxIdx, visited);
        maxIdx = maxIdx > newIdx ? maxIdx : newIdx;
    }
    return maxIdx;
}
function $ba6e2539d0024c3d$var$noOverlap(_ref) {
    var events = _ref.events, minimumStartDifference = _ref.minimumStartDifference, slotMetrics = _ref.slotMetrics, accessors = _ref.accessors;
    var styledEvents = $ba6e2539d0024c3d$var$getStyledEvents$1({
        events: events,
        minimumStartDifference: minimumStartDifference,
        slotMetrics: slotMetrics,
        accessors: accessors
    });
    styledEvents.sort(function(a, b) {
        a = a.style;
        b = b.style;
        if (a.top !== b.top) return a.top > b.top ? 1 : -1;
        else if (a.height !== b.height) return a.top + a.height < b.top + b.height ? 1 : -1;
        else return 0;
    });
    for(var i = 0; i < styledEvents.length; ++i){
        styledEvents[i].friends = [];
        delete styledEvents[i].style.left;
        delete styledEvents[i].style.left;
        delete styledEvents[i].idx;
        delete styledEvents[i].size;
    }
    for(var _i = 0; _i < styledEvents.length - 1; ++_i){
        var se1 = styledEvents[_i];
        var y1 = se1.style.top;
        var y2 = se1.style.top + se1.style.height;
        for(var j = _i + 1; j < styledEvents.length; ++j){
            var se2 = styledEvents[j];
            var y3 = se2.style.top;
            var y4 = se2.style.top + se2.style.height;
            if (y3 >= y1 && y4 <= y2 || y4 > y1 && y4 <= y2 || y3 >= y1 && y3 < y2) {
                // TODO : hashmap would be effective for performance
                se1.friends.push(se2);
                se2.friends.push(se1);
            }
        }
    }
    for(var _i2 = 0; _i2 < styledEvents.length; ++_i2){
        var se = styledEvents[_i2];
        var bitmap = [];
        for(var _j = 0; _j < 100; ++_j)bitmap.push(1); // 1 means available
        for(var _j2 = 0; _j2 < se.friends.length; ++_j2)if (se.friends[_j2].idx !== undefined) bitmap[se.friends[_j2].idx] = 0; // 0 means reserved
        se.idx = bitmap.indexOf(1);
    }
    for(var _i3 = 0; _i3 < styledEvents.length; ++_i3){
        var size = 0;
        if (styledEvents[_i3].size) continue;
        var allFriends = [];
        var maxIdx = $ba6e2539d0024c3d$var$getMaxIdxDFS(styledEvents[_i3], 0, allFriends);
        size = 100 / (maxIdx + 1);
        styledEvents[_i3].size = size;
        for(var _j3 = 0; _j3 < allFriends.length; ++_j3)allFriends[_j3].size = size;
    }
    for(var _i4 = 0; _i4 < styledEvents.length; ++_i4){
        var e = styledEvents[_i4];
        e.style.left = e.idx * e.size;
        // stretch to maximum
        var _maxIdx = 0;
        for(var _j4 = 0; _j4 < e.friends.length; ++_j4){
            var idx = e.friends[_j4].idx;
            _maxIdx = _maxIdx > idx ? _maxIdx : idx;
        }
        if (_maxIdx <= e.idx) e.size = 100 - e.idx * e.size;
        // padding between events
        // for this feature, `width` is not percentage based unit anymore
        // it will be used with calc()
        var padding = e.idx === 0 ? 0 : 3;
        e.style.width = "calc(".concat(e.size, "% - ").concat(padding, "px)");
        e.style.height = "calc(".concat(e.style.height, "% - 2px)");
        e.style.xOffset = "calc(".concat(e.style.left, "% + ").concat(padding, "px)");
    }
    return styledEvents;
}
/*eslint no-unused-vars: "off"*/ var $ba6e2539d0024c3d$var$DefaultAlgorithms = {
    overlap: $ba6e2539d0024c3d$var$getStyledEvents$1,
    'no-overlap': $ba6e2539d0024c3d$var$noOverlap
};
function $ba6e2539d0024c3d$var$isFunction(a) {
    return !!(a && a.constructor && a.call && a.apply);
}
//
function $ba6e2539d0024c3d$var$getStyledEvents(_ref) {
    _ref.events;
    _ref.minimumStartDifference;
    _ref.slotMetrics;
    _ref.accessors;
    var dayLayoutAlgorithm = _ref.dayLayoutAlgorithm;
    var algorithm = dayLayoutAlgorithm;
    if (dayLayoutAlgorithm in $ba6e2539d0024c3d$var$DefaultAlgorithms) algorithm = $ba6e2539d0024c3d$var$DefaultAlgorithms[dayLayoutAlgorithm];
    if (!$ba6e2539d0024c3d$var$isFunction(algorithm)) // invalid algorithm
    return [];
    return algorithm.apply(this, arguments);
}
function $ba6e2539d0024c3d$var$_callSuper$8(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$8() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$8() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$8 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba6e2539d0024c3d$var$TimeSlotGroup = /*#__PURE__*/ function(_Component) {
    function TimeSlotGroup() {
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, TimeSlotGroup);
        return $ba6e2539d0024c3d$var$_callSuper$8(this, TimeSlotGroup, arguments);
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(TimeSlotGroup, _Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(TimeSlotGroup, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, renderSlot = _this$props.renderSlot, resource = _this$props.resource, group = _this$props.group, getters = _this$props.getters, _this$props$component = _this$props.components, _this$props$component2 = _this$props$component === void 0 ? {} : _this$props$component, _this$props$component3 = _this$props$component2.timeSlotWrapper, Wrapper = _this$props$component3 === void 0 ? $ba6e2539d0024c3d$var$NoopWrapper : _this$props$component3;
                var groupProps = getters ? getters.slotGroupProp(group) : {};
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({
                    className: "rbc-timeslot-group"
                }, groupProps), group.map(function(value, idx) {
                    var slotProps = getters ? getters.slotProp(value, resource) : {};
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(Wrapper, {
                        key: idx,
                        value: value,
                        resource: resource
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, slotProps, {
                        className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-time-slot', slotProps.className)
                    }), renderSlot && renderSlot(value, idx)));
                }));
            }
        }
    ]);
}((0, $5s1kH.Component));
$ba6e2539d0024c3d$var$TimeSlotGroup.propTypes = {};
function $ba6e2539d0024c3d$var$ownKeys$3(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba6e2539d0024c3d$var$_objectSpread$3(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba6e2539d0024c3d$var$ownKeys$3(Object(t), true).forEach(function(r) {
            (0, $bfbb99364ffa951d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba6e2539d0024c3d$var$ownKeys$3(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ba6e2539d0024c3d$var$stringifyPercent(v) {
    return typeof v === 'string' ? v : v + '%';
}
/* eslint-disable react/prop-types */ function $ba6e2539d0024c3d$var$TimeGridEvent(props) {
    var style = props.style, className = props.className, event = props.event, accessors = props.accessors, rtl = props.rtl, selected = props.selected, label = props.label, continuesPrior = props.continuesPrior, continuesAfter = props.continuesAfter, getters = props.getters, onClick = props.onClick, onDoubleClick = props.onDoubleClick, isBackgroundEvent = props.isBackgroundEvent, onKeyPress = props.onKeyPress, _props$components = props.components, Event = _props$components.event, EventWrapper = _props$components.eventWrapper;
    var title = accessors.title(event);
    var tooltip = accessors.tooltip(event);
    var end = accessors.end(event);
    var start = accessors.start(event);
    var userProps = getters.eventProp(event, start, end, selected);
    var inner = [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            key: "1",
            className: "rbc-event-label"
        }, label),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            key: "2",
            className: "rbc-event-content"
        }, Event ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(Event, {
            event: event,
            title: title
        }) : title)
    ];
    var height = style.height, top = style.top, width = style.width, xOffset = style.xOffset;
    var eventStyle = $ba6e2539d0024c3d$var$_objectSpread$3($ba6e2539d0024c3d$var$_objectSpread$3({}, userProps.style), {}, (0, $bfbb99364ffa951d$export$2e2bcd8739ae039)({
        top: $ba6e2539d0024c3d$var$stringifyPercent(top),
        height: $ba6e2539d0024c3d$var$stringifyPercent(height),
        width: $ba6e2539d0024c3d$var$stringifyPercent(width)
    }, rtl ? 'right' : 'left', $ba6e2539d0024c3d$var$stringifyPercent(xOffset)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(EventWrapper, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({
        type: "time"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        role: "button",
        tabIndex: 0,
        onClick: onClick,
        onDoubleClick: onDoubleClick,
        style: eventStyle,
        onKeyDown: onKeyPress,
        title: tooltip ? (typeof label === 'string' ? label + ': ' : '') + tooltip : undefined,
        className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)(isBackgroundEvent ? 'rbc-background-event' : 'rbc-event', className, userProps.className, {
            'rbc-selected': selected,
            'rbc-event-continues-earlier': continuesPrior,
            'rbc-event-continues-later': continuesAfter
        })
    }, inner));
}
var $ba6e2539d0024c3d$var$DayColumnWrapper = function DayColumnWrapper(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style, innerRef = _ref.innerRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        className: className,
        style: style,
        ref: innerRef
    }, children);
};
var $ba6e2539d0024c3d$var$DayColumnWrapper$1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$DayColumnWrapper, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, props, {
        innerRef: ref
    }));
});
var $ba6e2539d0024c3d$var$_excluded$5 = [
    "dayProp"
], $ba6e2539d0024c3d$var$_excluded2$1 = [
    "eventContainerWrapper",
    "timeIndicatorWrapper"
];
function $ba6e2539d0024c3d$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba6e2539d0024c3d$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba6e2539d0024c3d$var$ownKeys$2(Object(t), true).forEach(function(r) {
            (0, $bfbb99364ffa951d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba6e2539d0024c3d$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ba6e2539d0024c3d$var$_callSuper$7(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$7() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$7() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$7 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba6e2539d0024c3d$var$DayColumn = /*#__PURE__*/ function(_React$Component) {
    function DayColumn() {
        var _this;
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, DayColumn);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = $ba6e2539d0024c3d$var$_callSuper$7(this, DayColumn, [].concat(_args));
        _this.state = {
            selecting: false,
            timeIndicatorPosition: null
        };
        _this.intervalTriggered = false;
        _this.renderEvents = function(_ref) {
            var events = _ref.events, isBackgroundEvent = _ref.isBackgroundEvent;
            var _this$props = _this.props, rtl = _this$props.rtl, selected = _this$props.selected, accessors = _this$props.accessors, localizer = _this$props.localizer, getters = _this$props.getters, components = _this$props.components, step = _this$props.step, timeslots = _this$props.timeslots, dayLayoutAlgorithm = _this$props.dayLayoutAlgorithm, resizable = _this$props.resizable;
            var _this2 = _this, slotMetrics = _this2.slotMetrics;
            var messages = localizer.messages;
            var styledEvents = $ba6e2539d0024c3d$var$getStyledEvents({
                events: events,
                accessors: accessors,
                slotMetrics: slotMetrics,
                minimumStartDifference: Math.ceil(step * timeslots / 2),
                dayLayoutAlgorithm: dayLayoutAlgorithm
            });
            return styledEvents.map(function(_ref2, idx) {
                var _accessors$eventId;
                var event = _ref2.event, style = _ref2.style;
                var end = accessors.end(event);
                var start = accessors.start(event);
                var key = (_accessors$eventId = accessors.eventId(event)) !== null && _accessors$eventId !== void 0 ? _accessors$eventId : 'evt_' + idx;
                var format = 'eventTimeRangeFormat';
                var label;
                var startsBeforeDay = slotMetrics.startsBeforeDay(start);
                var startsAfterDay = slotMetrics.startsAfterDay(end);
                if (startsBeforeDay) format = 'eventTimeRangeEndFormat';
                else if (startsAfterDay) format = 'eventTimeRangeStartFormat';
                if (startsBeforeDay && startsAfterDay) label = messages.allDay;
                else label = localizer.format({
                    start: start,
                    end: end
                }, format);
                var continuesPrior = startsBeforeDay || slotMetrics.startsBefore(start);
                var continuesAfter = startsAfterDay || slotMetrics.startsAfter(end);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$TimeGridEvent, {
                    style: style,
                    event: event,
                    label: label,
                    key: key,
                    getters: getters,
                    rtl: rtl,
                    components: components,
                    continuesPrior: continuesPrior,
                    continuesAfter: continuesAfter,
                    accessors: accessors,
                    resource: _this.props.resource,
                    selected: $ba6e2539d0024c3d$var$isSelected(event, selected),
                    onClick: function onClick(e) {
                        return _this._select($ba6e2539d0024c3d$var$_objectSpread$2($ba6e2539d0024c3d$var$_objectSpread$2($ba6e2539d0024c3d$var$_objectSpread$2({}, event), _this.props.resource && {
                            sourceResource: _this.props.resource
                        }), isBackgroundEvent && {
                            isBackgroundEvent: true
                        }), e);
                    },
                    onDoubleClick: function onDoubleClick(e) {
                        return _this._doubleClick(event, e);
                    },
                    isBackgroundEvent: isBackgroundEvent,
                    onKeyPress: function onKeyPress(e) {
                        return _this._keyPress(event, e);
                    },
                    resizable: resizable
                });
            });
        };
        _this._selectable = function() {
            var node = _this.containerRef.current;
            var _this$props2 = _this.props, longPressThreshold = _this$props2.longPressThreshold, localizer = _this$props2.localizer;
            var selector = _this._selector = new $ba6e2539d0024c3d$var$Selection(function() {
                return node;
            }, {
                longPressThreshold: longPressThreshold
            });
            var maybeSelect = function maybeSelect(box) {
                var onSelecting = _this.props.onSelecting;
                var current = _this.state || {};
                var state = selectionState(box);
                var start = state.startDate, end = state.endDate;
                if (onSelecting) {
                    if (localizer.eq(current.startDate, start, 'minutes') && localizer.eq(current.endDate, end, 'minutes') || onSelecting({
                        start: start,
                        end: end,
                        resourceId: _this.props.resource
                    }) === false) return;
                }
                if (_this.state.start !== state.start || _this.state.end !== state.end || _this.state.selecting !== state.selecting) _this.setState(state);
            };
            var selectionState = function selectionState(point) {
                var currentSlot = _this.slotMetrics.closestSlotFromPoint(point, $ba6e2539d0024c3d$var$getBoundsForNode(node));
                if (!_this.state.selecting) _this._initialSlot = currentSlot;
                var initialSlot = _this._initialSlot;
                if (localizer.lte(initialSlot, currentSlot)) currentSlot = _this.slotMetrics.nextSlot(currentSlot);
                else if (localizer.gt(initialSlot, currentSlot)) initialSlot = _this.slotMetrics.nextSlot(initialSlot);
                var selectRange = _this.slotMetrics.getRange(localizer.min(initialSlot, currentSlot), localizer.max(initialSlot, currentSlot));
                return $ba6e2539d0024c3d$var$_objectSpread$2($ba6e2539d0024c3d$var$_objectSpread$2({}, selectRange), {}, {
                    selecting: true,
                    top: "".concat(selectRange.top, "%"),
                    height: "".concat(selectRange.height, "%")
                });
            };
            var selectorClicksHandler = function selectorClicksHandler(box, actionType) {
                if (!$ba6e2539d0024c3d$var$isEvent(_this.containerRef.current, box)) {
                    var _selectionState = selectionState(box), startDate = _selectionState.startDate, endDate = _selectionState.endDate;
                    _this._selectSlot({
                        startDate: startDate,
                        endDate: endDate,
                        action: actionType,
                        box: box
                    });
                }
                _this.setState({
                    selecting: false
                });
            };
            selector.on('selecting', maybeSelect);
            selector.on('selectStart', maybeSelect);
            selector.on('beforeSelect', function(box) {
                if (_this.props.selectable !== 'ignoreEvents') return;
                return !$ba6e2539d0024c3d$var$isEvent(_this.containerRef.current, box);
            });
            selector.on('click', function(box) {
                return selectorClicksHandler(box, 'click');
            });
            selector.on('doubleClick', function(box) {
                return selectorClicksHandler(box, 'doubleClick');
            });
            selector.on('select', function(bounds) {
                if (_this.state.selecting) {
                    _this._selectSlot($ba6e2539d0024c3d$var$_objectSpread$2($ba6e2539d0024c3d$var$_objectSpread$2({}, _this.state), {}, {
                        action: 'select',
                        bounds: bounds
                    }));
                    _this.setState({
                        selecting: false
                    });
                }
            });
            selector.on('reset', function() {
                if (_this.state.selecting) _this.setState({
                    selecting: false
                });
            });
        };
        _this._teardownSelectable = function() {
            if (!_this._selector) return;
            _this._selector.teardown();
            _this._selector = null;
        };
        _this._selectSlot = function(_ref3) {
            var startDate = _ref3.startDate, endDate = _ref3.endDate, action = _ref3.action, bounds = _ref3.bounds, box = _ref3.box;
            var current = startDate, slots = [];
            while(_this.props.localizer.lte(current, endDate)){
                slots.push(current);
                current = new Date(+current + _this.props.step * 60000); // using Date ensures not to create an endless loop the day DST begins
            }
            $ba6e2539d0024c3d$var$notify(_this.props.onSelectSlot, {
                slots: slots,
                start: startDate,
                end: endDate,
                resourceId: _this.props.resource,
                action: action,
                bounds: bounds,
                box: box
            });
        };
        _this._select = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $ba6e2539d0024c3d$var$notify(_this.props.onSelectEvent, args);
        };
        _this._doubleClick = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $ba6e2539d0024c3d$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this._keyPress = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            $ba6e2539d0024c3d$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.slotMetrics = $ba6e2539d0024c3d$var$getSlotMetrics(_this.props);
        _this.containerRef = /*#__PURE__*/ (0, $5s1kH.createRef)();
        return _this;
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(DayColumn, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(DayColumn, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.selectable && this._selectable();
                if (this.props.isNow) this.setTimeIndicatorPositionUpdateInterval();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._teardownSelectable();
                this.clearTimeIndicatorInterval();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.selectable && !prevProps.selectable) this._selectable();
                if (!this.props.selectable && prevProps.selectable) this._teardownSelectable();
                var _this$props3 = this.props, getNow = _this$props3.getNow, isNow = _this$props3.isNow, localizer = _this$props3.localizer, date = _this$props3.date, min = _this$props3.min, max = _this$props3.max;
                var getNowChanged = localizer.neq(prevProps.getNow(), getNow(), 'minutes');
                if (prevProps.isNow !== isNow || getNowChanged) {
                    this.clearTimeIndicatorInterval();
                    if (isNow) {
                        var tail = !getNowChanged && localizer.eq(prevProps.date, date, 'minutes') && prevState.timeIndicatorPosition === this.state.timeIndicatorPosition;
                        this.setTimeIndicatorPositionUpdateInterval(tail);
                    }
                } else if (isNow && (localizer.neq(prevProps.min, min, 'minutes') || localizer.neq(prevProps.max, max, 'minutes'))) this.positionTimeIndicator();
            }
        },
        {
            key: "setTimeIndicatorPositionUpdateInterval",
            value: function setTimeIndicatorPositionUpdateInterval() {
                var _this3 = this;
                var tail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (!this.intervalTriggered && !tail) this.positionTimeIndicator();
                this._timeIndicatorTimeout = window.setTimeout(function() {
                    _this3.intervalTriggered = true;
                    _this3.positionTimeIndicator();
                    _this3.setTimeIndicatorPositionUpdateInterval();
                }, 60000);
            }
        },
        {
            key: "clearTimeIndicatorInterval",
            value: function clearTimeIndicatorInterval() {
                this.intervalTriggered = false;
                window.clearTimeout(this._timeIndicatorTimeout);
            }
        },
        {
            key: "positionTimeIndicator",
            value: function positionTimeIndicator() {
                var _this$props4 = this.props, min = _this$props4.min, max = _this$props4.max, getNow = _this$props4.getNow;
                var current = getNow();
                if (current >= min && current <= max) {
                    var top = this.slotMetrics.getCurrentTimePosition(current);
                    this.intervalTriggered = true;
                    this.setState({
                        timeIndicatorPosition: top
                    });
                } else this.clearTimeIndicatorInterval();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, date = _this$props5.date, max = _this$props5.max, rtl = _this$props5.rtl, isNow = _this$props5.isNow, resource = _this$props5.resource, accessors = _this$props5.accessors, localizer = _this$props5.localizer, _this$props5$getters = _this$props5.getters, dayProp = _this$props5$getters.dayProp, getters = (0, $7b4c4f4a56bd113a$export$2e2bcd8739ae039)(_this$props5$getters, $ba6e2539d0024c3d$var$_excluded$5), _this$props5$componen = _this$props5.components, EventContainer = _this$props5$componen.eventContainerWrapper, TimeIndicatorWrapper = _this$props5$componen.timeIndicatorWrapper, components = (0, $7b4c4f4a56bd113a$export$2e2bcd8739ae039)(_this$props5$componen, $ba6e2539d0024c3d$var$_excluded2$1);
                this.slotMetrics = this.slotMetrics.update(this.props);
                var slotMetrics = this.slotMetrics;
                var _this$state = this.state, selecting = _this$state.selecting, top = _this$state.top, height = _this$state.height, startDate = _this$state.startDate, endDate = _this$state.endDate;
                var selectDates = {
                    start: startDate,
                    end: endDate
                };
                var _dayProp = dayProp(max, resource), className = _dayProp.className, style = _dayProp.style;
                var timeIndicatorProps = {
                    className: 'rbc-current-time-indicator',
                    style: {
                        top: "".concat(this.state.timeIndicatorPosition, "%")
                    }
                };
                var DayColumnWrapperComponent = components.dayColumnWrapper || $ba6e2539d0024c3d$var$DayColumnWrapper$1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(DayColumnWrapperComponent, {
                    ref: this.containerRef,
                    date: date,
                    style: style,
                    className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)(className, 'rbc-day-slot', 'rbc-time-column', isNow && 'rbc-now', isNow && 'rbc-today', // WHY
                    selecting && 'rbc-slot-selecting'),
                    slotMetrics: slotMetrics,
                    resource: resource
                }, slotMetrics.groups.map(function(grp, idx) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$TimeSlotGroup, {
                        key: idx,
                        group: grp,
                        resource: resource,
                        getters: getters,
                        components: components
                    });
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(EventContainer, {
                    localizer: localizer,
                    resource: resource,
                    accessors: accessors,
                    getters: getters,
                    components: components,
                    slotMetrics: slotMetrics
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-events-container', rtl && 'rtl')
                }, this.renderEvents({
                    events: this.props.backgroundEvents,
                    isBackgroundEvent: true
                }), this.renderEvents({
                    events: this.props.events
                }))), selecting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: "rbc-slot-selection",
                    style: {
                        top: top,
                        height: height
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", null, localizer.format(selectDates, 'selectRangeFormat'))), isNow && this.intervalTriggered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(TimeIndicatorWrapper, timeIndicatorProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", timeIndicatorProps)));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$DayColumn.propTypes = {};
$ba6e2539d0024c3d$var$DayColumn.defaultProps = {
    dragThroughEvents: true,
    timeslots: 2
};
var $ba6e2539d0024c3d$var$ResourceHeader = function ResourceHeader(_ref) {
    var label = _ref.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Fragment, null, label);
};
$ba6e2539d0024c3d$var$ResourceHeader.propTypes = {};
function $ba6e2539d0024c3d$var$_callSuper$6(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$6() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$6() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$6 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba6e2539d0024c3d$var$TimeGridHeader = /*#__PURE__*/ function(_React$Component) {
    function TimeGridHeader() {
        var _this;
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, TimeGridHeader);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $ba6e2539d0024c3d$var$_callSuper$6(this, TimeGridHeader, [].concat(args));
        _this.handleHeaderClick = function(date, view, e) {
            e.preventDefault();
            $ba6e2539d0024c3d$var$notify(_this.props.onDrillDown, [
                date,
                view
            ]);
        };
        _this.renderRow = function(resource) {
            var _this$props = _this.props, events = _this$props.events, rtl = _this$props.rtl, selectable = _this$props.selectable, getNow = _this$props.getNow, range = _this$props.range, getters = _this$props.getters, localizer = _this$props.localizer, accessors = _this$props.accessors, components = _this$props.components, resizable = _this$props.resizable;
            var resourceId = accessors.resourceId(resource);
            var eventsToDisplay = resource ? events.filter(function(event) {
                return accessors.resource(event) === resourceId;
            }) : events;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$DateContentRow, {
                isAllDay: true,
                rtl: rtl,
                getNow: getNow,
                minRows: 2,
                maxRows: _this.props.allDayMaxRows + 1,
                range: range,
                events: eventsToDisplay,
                resourceId: resourceId,
                className: "rbc-allday-cell",
                selectable: selectable,
                selected: _this.props.selected,
                components: components,
                accessors: accessors,
                getters: getters,
                localizer: localizer,
                onSelect: _this.props.onSelectEvent,
                onShowMore: _this.props.onShowMore,
                onDoubleClick: _this.props.onDoubleClickEvent,
                onKeyPress: _this.props.onKeyPressEvent,
                onSelectSlot: _this.props.onSelectSlot,
                longPressThreshold: _this.props.longPressThreshold,
                resizable: resizable
            });
        };
        return _this;
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(TimeGridHeader, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(TimeGridHeader, [
        {
            key: "renderHeaderCells",
            value: function renderHeaderCells(range) {
                var _this2 = this;
                var _this$props2 = this.props, localizer = _this$props2.localizer, getDrilldownView = _this$props2.getDrilldownView, getNow = _this$props2.getNow, dayProp = _this$props2.getters.dayProp, _this$props2$componen = _this$props2.components.header, HeaderComponent = _this$props2$componen === void 0 ? $ba6e2539d0024c3d$var$Header : _this$props2$componen;
                var today = getNow();
                return range.map(function(date, i) {
                    var drilldownView = getDrilldownView(date);
                    var label = localizer.format(date, 'dayFormat');
                    var _dayProp = dayProp(date), className = _dayProp.className, style = _dayProp.style;
                    var header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(HeaderComponent, {
                        date: date,
                        label: label,
                        localizer: localizer
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        key: i,
                        style: style,
                        className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-header', className, localizer.isSameDate(date, today) && 'rbc-today')
                    }, drilldownView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
                        type: "button",
                        className: "rbc-button-link",
                        onClick: function onClick(e) {
                            return _this2.handleHeaderClick(date, drilldownView, e);
                        }
                    }, header) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", null, header));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props3 = this.props, width = _this$props3.width, rtl = _this$props3.rtl, resources = _this$props3.resources, range = _this$props3.range, events = _this$props3.events, getNow = _this$props3.getNow, accessors = _this$props3.accessors, selectable = _this$props3.selectable, components = _this$props3.components, getters = _this$props3.getters, scrollRef = _this$props3.scrollRef, localizer = _this$props3.localizer, isOverflowing = _this$props3.isOverflowing, _this$props3$componen = _this$props3.components, TimeGutterHeader = _this$props3$componen.timeGutterHeader, _this$props3$componen2 = _this$props3$componen.resourceHeader, ResourceHeaderComponent = _this$props3$componen2 === void 0 ? $ba6e2539d0024c3d$var$ResourceHeader : _this$props3$componen2, resizable = _this$props3.resizable;
                var style = {};
                if (isOverflowing) style[rtl ? 'marginLeft' : 'marginRight'] = "".concat((0, $064e68c4f9e480d9$export$2e2bcd8739ae039)() - 1, "px");
                var groupedEvents = resources.groupEvents(events);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    style: style,
                    ref: scrollRef,
                    className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-time-header', isOverflowing && 'rbc-overflowing')
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: "rbc-label rbc-time-header-gutter",
                    style: {
                        width: width,
                        minWidth: width,
                        maxWidth: width
                    }
                }, TimeGutterHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(TimeGutterHeader, null)), resources.map(function(_ref, idx) {
                    var _ref2 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_ref, 2), id = _ref2[0], resource = _ref2[1];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        className: "rbc-time-header-content",
                        key: id || idx
                    }, resource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        className: "rbc-row rbc-row-resource",
                        key: "resource_".concat(idx)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        className: "rbc-header"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(ResourceHeaderComponent, {
                        index: idx,
                        label: accessors.resourceTitle(resource),
                        resource: resource
                    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        className: "rbc-row rbc-time-header-cell".concat(range.length <= 1 ? ' rbc-time-header-cell-single-day' : '')
                    }, _this3.renderHeaderCells(range)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$DateContentRow, {
                        isAllDay: true,
                        rtl: rtl,
                        getNow: getNow,
                        minRows: 2,
                        maxRows: _this3.props.allDayMaxRows + 1,
                        range: range,
                        events: groupedEvents.get(id) || [],
                        resourceId: resource && id,
                        className: "rbc-allday-cell",
                        selectable: selectable,
                        selected: _this3.props.selected,
                        components: components,
                        accessors: accessors,
                        getters: getters,
                        localizer: localizer,
                        onSelect: _this3.props.onSelectEvent,
                        onShowMore: _this3.props.onShowMore,
                        onDoubleClick: _this3.props.onDoubleClickEvent,
                        onKeyDown: _this3.props.onKeyPressEvent,
                        onSelectSlot: _this3.props.onSelectSlot,
                        longPressThreshold: _this3.props.longPressThreshold,
                        resizable: resizable
                    }));
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$TimeGridHeader.propTypes = {};
function $ba6e2539d0024c3d$var$_callSuper$5(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$5() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$5() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$5 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba6e2539d0024c3d$var$TimeGridHeaderResources = /*#__PURE__*/ function(_React$Component) {
    function TimeGridHeaderResources() {
        var _this;
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, TimeGridHeaderResources);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $ba6e2539d0024c3d$var$_callSuper$5(this, TimeGridHeaderResources, [].concat(args));
        _this.handleHeaderClick = function(date, view, e) {
            e.preventDefault();
            $ba6e2539d0024c3d$var$notify(_this.props.onDrillDown, [
                date,
                view
            ]);
        };
        return _this;
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(TimeGridHeaderResources, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(TimeGridHeaderResources, [
        {
            key: "renderHeaderCells",
            value: function renderHeaderCells(range) {
                var _this2 = this;
                var _this$props = this.props, localizer = _this$props.localizer, getDrilldownView = _this$props.getDrilldownView, getNow = _this$props.getNow, dayProp = _this$props.getters.dayProp, _this$props$component = _this$props.components, _this$props$component2 = _this$props$component.header, HeaderComponent = _this$props$component2 === void 0 ? $ba6e2539d0024c3d$var$Header : _this$props$component2, _this$props$component3 = _this$props$component.resourceHeader, ResourceHeaderComponent = _this$props$component3 === void 0 ? $ba6e2539d0024c3d$var$ResourceHeader : _this$props$component3, resources = _this$props.resources, accessors = _this$props.accessors, events = _this$props.events, rtl = _this$props.rtl, selectable = _this$props.selectable, components = _this$props.components, getters = _this$props.getters, resizable = _this$props.resizable;
                var today = getNow();
                var groupedEvents = resources.groupEvents(events);
                return range.map(function(date, idx) {
                    var drilldownView = getDrilldownView(date);
                    var label = localizer.format(date, 'dayFormat');
                    var _dayProp = dayProp(date), className = _dayProp.className, style = _dayProp.style;
                    var header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(HeaderComponent, {
                        date: date,
                        label: label,
                        localizer: localizer
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        key: idx,
                        className: "rbc-time-header-content rbc-resource-grouping"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        className: "rbc-row rbc-time-header-cell".concat(range.length <= 1 ? ' rbc-time-header-cell-single-day' : '')
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        style: style,
                        className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-header', className, localizer.isSameDate(date, today) && 'rbc-today')
                    }, drilldownView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
                        type: "button",
                        className: "rbc-button-link",
                        onClick: function onClick(e) {
                            return _this2.handleHeaderClick(date, drilldownView, e);
                        }
                    }, header) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", null, header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        className: "rbc-row"
                    }, resources.map(function(_ref, idx) {
                        var _ref2 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_ref, 2), id = _ref2[0], resource = _ref2[1];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                            key: "resource_".concat(id, "_").concat(idx),
                            className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-header', className, localizer.isSameDate(date, today) && 'rbc-today')
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(ResourceHeaderComponent, {
                            index: idx,
                            label: accessors.resourceTitle(resource),
                            resource: resource
                        }));
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        className: "rbc-row rbc-m-b-negative-3 rbc-h-full"
                    }, resources.map(function(_ref3, idx) {
                        var _ref4 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_ref3, 2), id = _ref4[0], resource = _ref4[1];
                        // Filter the grouped events by the current date.
                        var filteredEvents = (groupedEvents.get(id) || []).filter(function(event) {
                            return localizer.isSameDate(event.start, date) || localizer.isSameDate(event.end, date);
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$DateContentRow, {
                            key: "resource_".concat(id, "_").concat(idx),
                            isAllDay: true,
                            rtl: rtl,
                            getNow: getNow,
                            minRows: 2,
                            maxRows: _this2.props.allDayMaxRows + 1,
                            range: [
                                date
                            ] // This ensures that only the single day is rendered
                            ,
                            events: filteredEvents // Only show filtered events for this day.
                            ,
                            resourceId: resource && id,
                            className: "rbc-allday-cell",
                            selectable: selectable,
                            selected: _this2.props.selected,
                            components: components,
                            accessors: accessors,
                            getters: getters,
                            localizer: localizer,
                            onSelect: _this2.props.onSelectEvent,
                            onShowMore: _this2.props.onShowMore,
                            onDoubleClick: _this2.props.onDoubleClickEvent,
                            onKeyDown: _this2.props.onKeyPressEvent,
                            onSelectSlot: _this2.props.onSelectSlot,
                            longPressThreshold: _this2.props.longPressThreshold,
                            resizable: resizable
                        });
                    })));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, width = _this$props2.width, rtl = _this$props2.rtl, range = _this$props2.range, scrollRef = _this$props2.scrollRef, isOverflowing = _this$props2.isOverflowing, TimeGutterHeader = _this$props2.components.timeGutterHeader;
                var style = {};
                if (isOverflowing) style[rtl ? 'marginLeft' : 'marginRight'] = "".concat((0, $064e68c4f9e480d9$export$2e2bcd8739ae039)() - 1, "px");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    style: style,
                    ref: scrollRef,
                    className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-time-header', isOverflowing && 'rbc-overflowing')
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: "rbc-label rbc-time-header-gutter",
                    style: {
                        width: width,
                        minWidth: width,
                        maxWidth: width
                    }
                }, TimeGutterHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(TimeGutterHeader, null)), this.renderHeaderCells(range));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$TimeGridHeaderResources.propTypes = {};
/**
 * Since the TimeGutter only displays the 'times' of slots in a day, and is separate
 * from the Day Columns themselves, we check to see if the range contains an offset difference
 * and, if so, change the beginning and end 'date' by a day to properly display the slots times
 * used.
 */ function $ba6e2539d0024c3d$var$adjustForDST(_ref) {
    var min = _ref.min, max = _ref.max, localizer = _ref.localizer;
    if (localizer.getTimezoneOffset(min) !== localizer.getTimezoneOffset(max)) return {
        start: localizer.add(min, -1, 'day'),
        end: localizer.add(max, -1, 'day')
    };
    return {
        start: min,
        end: max
    };
}
var $ba6e2539d0024c3d$var$TimeGutter = function TimeGutter(_ref2) {
    var min = _ref2.min, max = _ref2.max, timeslots = _ref2.timeslots, step = _ref2.step, localizer = _ref2.localizer, getNow = _ref2.getNow, resource = _ref2.resource, components = _ref2.components, getters = _ref2.getters, gutterRef = _ref2.gutterRef;
    var TimeGutterWrapper = components.timeGutterWrapper;
    var _useMemo = (0, $5s1kH.useMemo)(function() {
        return $ba6e2539d0024c3d$var$adjustForDST({
            min: min,
            max: max,
            localizer: localizer
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        min === null || min === void 0 ? void 0 : min.toISOString(),
        max === null || max === void 0 ? void 0 : max.toISOString(),
        localizer
    ]), start = _useMemo.start, end = _useMemo.end;
    var _useState = (0, $5s1kH.useState)($ba6e2539d0024c3d$var$getSlotMetrics({
        min: start,
        max: end,
        timeslots: timeslots,
        step: step,
        localizer: localizer
    })), _useState2 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_useState, 2), slotMetrics = _useState2[0], setSlotMetrics = _useState2[1];
    (0, $5s1kH.useEffect)(function() {
        if (slotMetrics) setSlotMetrics(slotMetrics.update({
            min: start,
            max: end,
            timeslots: timeslots,
            step: step,
            localizer: localizer
        }));
    /**
     * We don't want this to fire when slotMetrics is updated as it would recursively bomb
     */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        start === null || start === void 0 ? void 0 : start.toISOString(),
        end === null || end === void 0 ? void 0 : end.toISOString(),
        timeslots,
        step
    ]);
    var renderSlot = (0, $5s1kH.useCallback)(function(value, idx) {
        if (idx) return null; // don't return the first (0) idx
        var isNow = slotMetrics.dateIsInGroup(getNow(), idx);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
            className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-label', isNow && 'rbc-now')
        }, localizer.format(value, 'timeGutterFormat'));
    }, [
        slotMetrics,
        localizer,
        getNow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(TimeGutterWrapper, {
        slotMetrics: slotMetrics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        className: "rbc-time-gutter rbc-time-column",
        ref: gutterRef
    }, slotMetrics.groups.map(function(grp, idx) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$TimeSlotGroup, {
            key: idx,
            group: grp,
            resource: resource,
            components: components,
            renderSlot: renderSlot,
            getters: getters
        });
    })));
};
$ba6e2539d0024c3d$var$TimeGutter.propTypes = {};
var $ba6e2539d0024c3d$var$TimeGutter$1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$TimeGutter, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({
        gutterRef: ref
    }, props));
});
var $ba6e2539d0024c3d$var$NONE = {};
function $ba6e2539d0024c3d$var$Resources(resources, accessors) {
    return {
        map: function map(fn) {
            if (!resources) return [
                fn([
                    $ba6e2539d0024c3d$var$NONE,
                    null
                ], 0)
            ];
            return resources.map(function(resource, idx) {
                return fn([
                    accessors.resourceId(resource),
                    resource
                ], idx);
            });
        },
        groupEvents: function groupEvents(events) {
            var eventsByResource = new Map();
            if (!resources) {
                // Return all events if resources are not provided
                eventsByResource.set($ba6e2539d0024c3d$var$NONE, events);
                return eventsByResource;
            }
            events.forEach(function(event) {
                var id = accessors.resource(event) || $ba6e2539d0024c3d$var$NONE;
                if (Array.isArray(id)) id.forEach(function(item) {
                    var resourceEvents = eventsByResource.get(item) || [];
                    resourceEvents.push(event);
                    eventsByResource.set(item, resourceEvents);
                });
                else {
                    var resourceEvents = eventsByResource.get(id) || [];
                    resourceEvents.push(event);
                    eventsByResource.set(id, resourceEvents);
                }
            });
            return eventsByResource;
        }
    };
}
function $ba6e2539d0024c3d$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba6e2539d0024c3d$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba6e2539d0024c3d$var$ownKeys$1(Object(t), true).forEach(function(r) {
            (0, $bfbb99364ffa951d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba6e2539d0024c3d$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ba6e2539d0024c3d$var$_callSuper$4(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$4() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$4() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$4 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba6e2539d0024c3d$var$TimeGrid = /*#__PURE__*/ function(_Component) {
    function TimeGrid(props) {
        var _this;
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, TimeGrid);
        _this = $ba6e2539d0024c3d$var$_callSuper$4(this, TimeGrid, [
            props
        ]);
        _this.handleScroll = function(e) {
            if (_this.scrollRef.current) _this.scrollRef.current.scrollLeft = e.target.scrollLeft;
        };
        _this.handleResize = function() {
            $77a4d87038ac8daf$export$70b61ad426ddbe54(_this.rafHandle);
            _this.rafHandle = $77a4d87038ac8daf$export$b5fe3f66a567bec0(_this.checkOverflow);
        };
        _this.handleKeyPressEvent = function() {
            _this.clearSelection();
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            $ba6e2539d0024c3d$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.handleSelectEvent = function() {
            //cancel any pending selections so only the event click goes through.
            _this.clearSelection();
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $ba6e2539d0024c3d$var$notify(_this.props.onSelectEvent, args);
        };
        _this.handleDoubleClickEvent = function() {
            _this.clearSelection();
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $ba6e2539d0024c3d$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this.handleShowMore = function(events, date, cell, slot, target) {
            var _this$props = _this.props, popup = _this$props.popup, onDrillDown = _this$props.onDrillDown, onShowMore = _this$props.onShowMore, getDrilldownView = _this$props.getDrilldownView, doShowMoreDrillDown = _this$props.doShowMoreDrillDown;
            _this.clearSelection();
            if (popup) {
                var position = (0, $912245913eb5c0fe$export$2e2bcd8739ae039)(cell, _this.containerRef.current);
                _this.setState({
                    overlay: {
                        date: date,
                        events: events,
                        position: $ba6e2539d0024c3d$var$_objectSpread$1($ba6e2539d0024c3d$var$_objectSpread$1({}, position), {}, {
                            width: '200px'
                        }),
                        target: target
                    }
                });
            } else if (doShowMoreDrillDown) $ba6e2539d0024c3d$var$notify(onDrillDown, [
                date,
                getDrilldownView(date) || $ba6e2539d0024c3d$export$5cb791131c501f6a.DAY
            ]);
            $ba6e2539d0024c3d$var$notify(onShowMore, [
                events,
                date,
                slot
            ]);
        };
        _this.handleSelectAllDaySlot = function(slots, slotInfo) {
            var onSelectSlot = _this.props.onSelectSlot;
            var start = new Date(slots[0]);
            var end = new Date(slots[slots.length - 1]);
            end.setDate(slots[slots.length - 1].getDate() + 1);
            $ba6e2539d0024c3d$var$notify(onSelectSlot, {
                slots: slots,
                start: start,
                end: end,
                action: slotInfo.action,
                resourceId: slotInfo.resourceId
            });
        };
        _this.overlayDisplay = function() {
            _this.setState({
                overlay: null
            });
        };
        _this.checkOverflow = function() {
            if (_this._updatingOverflow) return;
            var content = _this.contentRef.current;
            if (!(content !== null && content !== void 0 && content.scrollHeight)) return;
            var isOverflowing = content.scrollHeight > content.clientHeight;
            if (_this.state.isOverflowing !== isOverflowing) {
                _this._updatingOverflow = true;
                _this.setState({
                    isOverflowing: isOverflowing
                }, function() {
                    _this._updatingOverflow = false;
                });
            }
        };
        _this.memoizedResources = (0, $074df527245e0057$export$2e2bcd8739ae039)(function(resources, accessors) {
            return $ba6e2539d0024c3d$var$Resources(resources, accessors);
        });
        _this.state = {
            gutterWidth: undefined,
            isOverflowing: null
        };
        _this.scrollRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createRef();
        _this.contentRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createRef();
        _this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createRef();
        _this._scrollRatio = null;
        _this.gutterRef = /*#__PURE__*/ (0, $5s1kH.createRef)();
        return _this;
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(TimeGrid, _Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(TimeGrid, [
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate() {
                this.checkOverflow();
                return null;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.width == null) this.measureGutter();
                this.calculateScroll();
                this.applyScroll();
                window.addEventListener('resize', this.handleResize);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener('resize', this.handleResize);
                $77a4d87038ac8daf$export$70b61ad426ddbe54(this.rafHandle);
                if (this.measureGutterAnimationFrameRequest) window.cancelAnimationFrame(this.measureGutterAnimationFrameRequest);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.applyScroll();
            }
        },
        {
            key: "renderDayColumn",
            value: function renderDayColumn(date, id, resource, groupedEvents, groupedBackgroundEvents, localizer, accessors, components, dayLayoutAlgorithm, now) {
                var _this$props2 = this.props, min = _this$props2.min, max = _this$props2.max;
                var daysEvents = (groupedEvents.get(id) || []).filter(function(event) {
                    return localizer.inRange(date, accessors.start(event), accessors.end(event), 'day');
                });
                var daysBackgroundEvents = (groupedBackgroundEvents.get(id) || []).filter(function(event) {
                    return localizer.inRange(date, accessors.start(event), accessors.end(event), 'day');
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$DayColumn, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, this.props, {
                    localizer: localizer,
                    min: localizer.merge(date, min),
                    max: localizer.merge(date, max),
                    resource: resource && id,
                    components: components,
                    isNow: localizer.isSameDate(date, now),
                    key: "".concat(id, "-").concat(date),
                    date: date,
                    events: daysEvents,
                    backgroundEvents: daysBackgroundEvents,
                    dayLayoutAlgorithm: dayLayoutAlgorithm
                }));
            }
        },
        {
            key: "renderResourcesFirst",
            value: function renderResourcesFirst(range, resources, groupedEvents, groupedBackgroundEvents, localizer, accessors, now, components, dayLayoutAlgorithm) {
                var _this2 = this;
                return resources.map(function(_ref) {
                    var _ref2 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_ref, 2), id = _ref2[0], resource = _ref2[1];
                    return range.map(function(date) {
                        return _this2.renderDayColumn(date, id, resource, groupedEvents, groupedBackgroundEvents, localizer, accessors, components, dayLayoutAlgorithm, now);
                    });
                });
            }
        },
        {
            key: "renderRangeFirst",
            value: function renderRangeFirst(range, resources, groupedEvents, groupedBackgroundEvents, localizer, accessors, now, components, dayLayoutAlgorithm) {
                var _this3 = this;
                return range.map(function(date) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        style: {
                            display: 'flex',
                            minHeight: '100%',
                            flex: 1
                        },
                        key: date
                    }, resources.map(function(_ref3) {
                        var _ref4 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_ref3, 2), id = _ref4[0], resource = _ref4[1];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                            style: {
                                flex: 1
                            },
                            key: accessors.resourceId(resource)
                        }, _this3.renderDayColumn(date, id, resource, groupedEvents, groupedBackgroundEvents, localizer, accessors, components, dayLayoutAlgorithm, now));
                    }));
                });
            }
        },
        {
            key: "renderEvents",
            value: function renderEvents(range, events, backgroundEvents, now) {
                var _this$props3 = this.props, accessors = _this$props3.accessors, localizer = _this$props3.localizer, resourceGroupingLayout = _this$props3.resourceGroupingLayout, components = _this$props3.components, dayLayoutAlgorithm = _this$props3.dayLayoutAlgorithm;
                var resources = this.memoizedResources(this.props.resources, accessors);
                var groupedEvents = resources.groupEvents(events);
                var groupedBackgroundEvents = resources.groupEvents(backgroundEvents);
                if (!resourceGroupingLayout) return this.renderResourcesFirst(range, resources, groupedEvents, groupedBackgroundEvents, localizer, accessors, now, components, dayLayoutAlgorithm);
                else return this.renderRangeFirst(range, resources, groupedEvents, groupedBackgroundEvents, localizer, accessors, now, components, dayLayoutAlgorithm);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props$allDayMax;
                var _this$props4 = this.props, events = _this$props4.events, backgroundEvents = _this$props4.backgroundEvents, range = _this$props4.range, width = _this$props4.width, rtl = _this$props4.rtl, selected = _this$props4.selected, getNow = _this$props4.getNow, resources = _this$props4.resources, components = _this$props4.components, accessors = _this$props4.accessors, getters = _this$props4.getters, localizer = _this$props4.localizer, min = _this$props4.min, max = _this$props4.max, showMultiDayTimes = _this$props4.showMultiDayTimes, longPressThreshold = _this$props4.longPressThreshold, resizable = _this$props4.resizable, resourceGroupingLayout = _this$props4.resourceGroupingLayout;
                width = width || this.state.gutterWidth;
                var start = range[0], end = range[range.length - 1];
                this.slots = range.length;
                var allDayEvents = [], rangeEvents = [], rangeBackgroundEvents = [];
                events.forEach(function(event) {
                    if ($ba6e2539d0024c3d$var$inRange(event, start, end, accessors, localizer)) {
                        var eStart = accessors.start(event), eEnd = accessors.end(event);
                        if (accessors.allDay(event) || localizer.startAndEndAreDateOnly(eStart, eEnd) || !showMultiDayTimes && !localizer.isSameDate(eStart, eEnd)) allDayEvents.push(event);
                        else rangeEvents.push(event);
                    }
                });
                backgroundEvents.forEach(function(event) {
                    if ($ba6e2539d0024c3d$var$inRange(event, start, end, accessors, localizer)) rangeBackgroundEvents.push(event);
                });
                allDayEvents.sort(function(a, b) {
                    return $ba6e2539d0024c3d$var$sortEvents(a, b, accessors, localizer);
                });
                var headerProps = {
                    range: range,
                    events: allDayEvents,
                    width: width,
                    rtl: rtl,
                    getNow: getNow,
                    localizer: localizer,
                    selected: selected,
                    allDayMaxRows: this.props.showAllEvents ? Infinity : (_this$props$allDayMax = this.props.allDayMaxRows) !== null && _this$props$allDayMax !== void 0 ? _this$props$allDayMax : Infinity,
                    resources: this.memoizedResources(resources, accessors),
                    selectable: this.props.selectable,
                    accessors: accessors,
                    getters: getters,
                    components: components,
                    scrollRef: this.scrollRef,
                    isOverflowing: this.state.isOverflowing,
                    longPressThreshold: longPressThreshold,
                    onSelectSlot: this.handleSelectAllDaySlot,
                    onSelectEvent: this.handleSelectEvent,
                    onShowMore: this.handleShowMore,
                    onDoubleClickEvent: this.props.onDoubleClickEvent,
                    onKeyPressEvent: this.props.onKeyPressEvent,
                    onDrillDown: this.props.onDrillDown,
                    getDrilldownView: this.props.getDrilldownView,
                    resizable: resizable
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)('rbc-time-view', resources && 'rbc-time-view-resources'),
                    ref: this.containerRef
                }, resources && resources.length > 1 && resourceGroupingLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$TimeGridHeaderResources, headerProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$TimeGridHeader, headerProps), this.props.popup && this.renderOverlay(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    ref: this.contentRef,
                    className: "rbc-time-content",
                    onScroll: this.handleScroll
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$TimeGutter$1, {
                    date: start,
                    ref: this.gutterRef,
                    localizer: localizer,
                    min: localizer.merge(start, min),
                    max: localizer.merge(start, max),
                    step: this.props.step,
                    getNow: this.props.getNow,
                    timeslots: this.props.timeslots,
                    components: components,
                    className: "rbc-time-gutter",
                    getters: getters
                }), this.renderEvents(range, rangeEvents, rangeBackgroundEvents, getNow())));
            }
        },
        {
            key: "renderOverlay",
            value: function renderOverlay() {
                var _this$state$overlay, _this$state, _this4 = this;
                var overlay = (_this$state$overlay = (_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.overlay) !== null && _this$state$overlay !== void 0 ? _this$state$overlay : {};
                var _this$props5 = this.props, accessors = _this$props5.accessors, localizer = _this$props5.localizer, components = _this$props5.components, getters = _this$props5.getters, selected = _this$props5.selected, popupOffset = _this$props5.popupOffset, handleDragStart = _this$props5.handleDragStart;
                var onHide = function onHide() {
                    return _this4.setState({
                        overlay: null
                    });
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$PopOverlay, {
                    overlay: overlay,
                    accessors: accessors,
                    localizer: localizer,
                    components: components,
                    getters: getters,
                    selected: selected,
                    popupOffset: popupOffset,
                    ref: this.containerRef,
                    handleKeyPressEvent: this.handleKeyPressEvent,
                    handleSelectEvent: this.handleSelectEvent,
                    handleDoubleClickEvent: this.handleDoubleClickEvent,
                    handleDragStart: handleDragStart,
                    show: !!overlay.position,
                    overlayDisplay: this.overlayDisplay,
                    onHide: onHide
                });
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                clearTimeout(this._selectTimer);
                this._pendingSelection = [];
            }
        },
        {
            key: "measureGutter",
            value: function measureGutter() {
                var _this5 = this;
                if (this.measureGutterAnimationFrameRequest) window.cancelAnimationFrame(this.measureGutterAnimationFrameRequest);
                this.measureGutterAnimationFrameRequest = window.requestAnimationFrame(function() {
                    var _this5$gutterRef;
                    var width = (_this5$gutterRef = _this5.gutterRef) !== null && _this5$gutterRef !== void 0 && _this5$gutterRef.current ? (0, $99a9f0718f601fba$export$2e2bcd8739ae039)(_this5.gutterRef.current) : undefined;
                    if (width && _this5.state.gutterWidth !== width) _this5.setState({
                        gutterWidth: width
                    });
                });
            }
        },
        {
            key: "applyScroll",
            value: function applyScroll() {
                // If auto-scroll is disabled, we don't actually apply the scroll
                if (this._scrollRatio != null && this.props.enableAutoScroll === true) {
                    var content = this.contentRef.current;
                    content.scrollTop = content.scrollHeight * this._scrollRatio;
                    // Only do this once
                    this._scrollRatio = null;
                }
            }
        },
        {
            key: "calculateScroll",
            value: function calculateScroll() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var min = props.min, max = props.max, scrollToTime = props.scrollToTime, localizer = props.localizer;
                var diffMillis = localizer.diff(localizer.merge(scrollToTime, min), scrollToTime, 'milliseconds');
                var totalMillis = localizer.diff(min, max, 'milliseconds');
                this._scrollRatio = diffMillis / totalMillis;
            }
        }
    ]);
}((0, $5s1kH.Component));
$ba6e2539d0024c3d$var$TimeGrid.propTypes = {};
$ba6e2539d0024c3d$var$TimeGrid.defaultProps = {
    step: 30,
    timeslots: 2,
    // To be compatible with old versions, default as `false`.
    resourceGroupingLayout: false
};
var $ba6e2539d0024c3d$var$_excluded$4 = [
    "date",
    "localizer",
    "min",
    "max",
    "scrollToTime",
    "enableAutoScroll"
];
function $ba6e2539d0024c3d$var$_callSuper$3(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$3() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$3() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$3 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba6e2539d0024c3d$var$Day = /*#__PURE__*/ function(_React$Component) {
    function Day() {
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, Day);
        return $ba6e2539d0024c3d$var$_callSuper$3(this, Day, arguments);
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(Day, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(Day, [
        {
            key: "render",
            value: function render() {
                /**
       * This allows us to default min, max, and scrollToTime
       * using our localizer. This is necessary until such time
       * as TODO: TimeGrid is converted to a functional component.
       */ var _this$props = this.props, date = _this$props.date, localizer = _this$props.localizer, _this$props$min = _this$props.min, min = _this$props$min === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$min, _this$props$max = _this$props.max, max = _this$props$max === void 0 ? localizer.endOf(new Date(), 'day') : _this$props$max, _this$props$scrollToT = _this$props.scrollToTime, scrollToTime = _this$props$scrollToT === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$scrollToT, _this$props$enableAut = _this$props.enableAutoScroll, enableAutoScroll = _this$props$enableAut === void 0 ? true : _this$props$enableAut, props = (0, $7b4c4f4a56bd113a$export$2e2bcd8739ae039)(_this$props, $ba6e2539d0024c3d$var$_excluded$4);
                var range = Day.range(date, {
                    localizer: localizer
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$TimeGrid, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, props, {
                    range: range,
                    eventOffset: 10,
                    localizer: localizer,
                    min: min,
                    max: max,
                    scrollToTime: scrollToTime,
                    enableAutoScroll: enableAutoScroll
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$Day.propTypes = {};
$ba6e2539d0024c3d$var$Day.range = function(date, _ref) {
    var localizer = _ref.localizer;
    return [
        localizer.startOf(date, 'day')
    ];
};
$ba6e2539d0024c3d$var$Day.navigate = function(date, action, _ref2) {
    var localizer = _ref2.localizer;
    switch(action){
        case $ba6e2539d0024c3d$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -1, 'day');
        case $ba6e2539d0024c3d$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, 1, 'day');
        default:
            return date;
    }
};
$ba6e2539d0024c3d$var$Day.title = function(date, _ref3) {
    var localizer = _ref3.localizer;
    return localizer.format(date, 'dayHeaderFormat');
};
var $ba6e2539d0024c3d$var$_excluded$3 = [
    "date",
    "localizer",
    "min",
    "max",
    "scrollToTime",
    "enableAutoScroll"
];
function $ba6e2539d0024c3d$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ba6e2539d0024c3d$var$_callSuper$2(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$2() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba6e2539d0024c3d$var$Week = /*#__PURE__*/ function(_React$Component) {
    function Week() {
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, Week);
        return $ba6e2539d0024c3d$var$_callSuper$2(this, Week, arguments);
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(Week, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(Week, [
        {
            key: "render",
            value: function render() {
                /**
       * This allows us to default min, max, and scrollToTime
       * using our localizer. This is necessary until such time
       * as TimeGrid is converted to a functional component.
       */ var _this$props = this.props, date = _this$props.date, localizer = _this$props.localizer, _this$props$min = _this$props.min, min = _this$props$min === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$min, _this$props$max = _this$props.max, max = _this$props$max === void 0 ? localizer.endOf(new Date(), 'day') : _this$props$max, _this$props$scrollToT = _this$props.scrollToTime, scrollToTime = _this$props$scrollToT === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$scrollToT, _this$props$enableAut = _this$props.enableAutoScroll, enableAutoScroll = _this$props$enableAut === void 0 ? true : _this$props$enableAut, props = (0, $7b4c4f4a56bd113a$export$2e2bcd8739ae039)(_this$props, $ba6e2539d0024c3d$var$_excluded$3);
                var range = Week.range(date, this.props);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$TimeGrid, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, props, {
                    range: range,
                    eventOffset: 15,
                    localizer: localizer,
                    min: min,
                    max: max,
                    scrollToTime: scrollToTime,
                    enableAutoScroll: enableAutoScroll
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$Week.propTypes = {};
$ba6e2539d0024c3d$var$Week.defaultProps = $ba6e2539d0024c3d$var$TimeGrid.defaultProps;
$ba6e2539d0024c3d$var$Week.navigate = function(date, action, _ref) {
    var localizer = _ref.localizer;
    switch(action){
        case $ba6e2539d0024c3d$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -1, 'week');
        case $ba6e2539d0024c3d$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, 1, 'week');
        default:
            return date;
    }
};
$ba6e2539d0024c3d$var$Week.range = function(date, _ref2) {
    var localizer = _ref2.localizer;
    var firstOfWeek = localizer.startOfWeek();
    var start = localizer.startOf(date, 'week', firstOfWeek);
    var end = localizer.endOf(date, 'week', firstOfWeek);
    return localizer.range(start, end);
};
$ba6e2539d0024c3d$var$Week.title = function(date, _ref3) {
    var localizer = _ref3.localizer;
    var _Week$range = $ba6e2539d0024c3d$var$Week.range(date, {
        localizer: localizer
    }), _Week$range2 = (0, $1f80157ba4fb8c42$export$2e2bcd8739ae039)(_Week$range), start = _Week$range2[0], rest = $ba6e2539d0024c3d$var$_arrayLikeToArray$1(_Week$range2).slice(1);
    return localizer.format({
        start: start,
        end: rest.pop()
    }, 'dayRangeHeaderFormat');
};
var $ba6e2539d0024c3d$var$_excluded$2 = [
    "date",
    "localizer",
    "min",
    "max",
    "scrollToTime",
    "enableAutoScroll"
];
function $ba6e2539d0024c3d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ba6e2539d0024c3d$var$_callSuper$1(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct$1() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ba6e2539d0024c3d$var$workWeekRange(date, options) {
    return $ba6e2539d0024c3d$var$Week.range(date, options).filter(function(d) {
        return [
            6,
            0
        ].indexOf(d.getDay()) === -1;
    });
}
var $ba6e2539d0024c3d$var$WorkWeek = /*#__PURE__*/ function(_React$Component) {
    function WorkWeek() {
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, WorkWeek);
        return $ba6e2539d0024c3d$var$_callSuper$1(this, WorkWeek, arguments);
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(WorkWeek, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(WorkWeek, [
        {
            key: "render",
            value: function render() {
                /**
       * This allows us to default min, max, and scrollToTime
       * using our localizer. This is necessary until such time
       * as TimeGrid is converted to a functional component.
       */ var _this$props = this.props, date = _this$props.date, localizer = _this$props.localizer, _this$props$min = _this$props.min, min = _this$props$min === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$min, _this$props$max = _this$props.max, max = _this$props$max === void 0 ? localizer.endOf(new Date(), 'day') : _this$props$max, _this$props$scrollToT = _this$props.scrollToTime, scrollToTime = _this$props$scrollToT === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$scrollToT, _this$props$enableAut = _this$props.enableAutoScroll, enableAutoScroll = _this$props$enableAut === void 0 ? true : _this$props$enableAut, props = (0, $7b4c4f4a56bd113a$export$2e2bcd8739ae039)(_this$props, $ba6e2539d0024c3d$var$_excluded$2);
                var range = $ba6e2539d0024c3d$var$workWeekRange(date, this.props);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($ba6e2539d0024c3d$var$TimeGrid, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, props, {
                    range: range,
                    eventOffset: 15,
                    localizer: localizer,
                    min: min,
                    max: max,
                    scrollToTime: scrollToTime,
                    enableAutoScroll: enableAutoScroll
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$WorkWeek.propTypes = {};
$ba6e2539d0024c3d$var$WorkWeek.defaultProps = $ba6e2539d0024c3d$var$TimeGrid.defaultProps;
$ba6e2539d0024c3d$var$WorkWeek.range = $ba6e2539d0024c3d$var$workWeekRange;
$ba6e2539d0024c3d$var$WorkWeek.navigate = $ba6e2539d0024c3d$var$Week.navigate;
$ba6e2539d0024c3d$var$WorkWeek.title = function(date, _ref) {
    var localizer = _ref.localizer;
    var _workWeekRange = $ba6e2539d0024c3d$var$workWeekRange(date, {
        localizer: localizer
    }), _workWeekRange2 = (0, $1f80157ba4fb8c42$export$2e2bcd8739ae039)(_workWeekRange), start = _workWeekRange2[0], rest = $ba6e2539d0024c3d$var$_arrayLikeToArray(_workWeekRange2).slice(1);
    return localizer.format({
        start: start,
        end: rest.pop()
    }, 'dayRangeHeaderFormat');
};
var $ba6e2539d0024c3d$var$DEFAULT_LENGTH = 30;
function $ba6e2539d0024c3d$var$Agenda(_ref) {
    var accessors = _ref.accessors, components = _ref.components, date = _ref.date, events = _ref.events, getters = _ref.getters, _ref$length = _ref.length, length = _ref$length === void 0 ? $ba6e2539d0024c3d$var$DEFAULT_LENGTH : _ref$length, localizer = _ref.localizer, onDoubleClickEvent = _ref.onDoubleClickEvent, onSelectEvent = _ref.onSelectEvent, selected = _ref.selected;
    var headerRef = (0, $5s1kH.useRef)(null);
    var dateColRef = (0, $5s1kH.useRef)(null);
    var timeColRef = (0, $5s1kH.useRef)(null);
    var contentRef = (0, $5s1kH.useRef)(null);
    var tbodyRef = (0, $5s1kH.useRef)(null);
    (0, $5s1kH.useEffect)(function() {
        _adjustHeader();
    });
    var renderDay = function renderDay(day, events, dayKey) {
        var Event = components.event, AgendaDate = components.date;
        events = events.filter(function(e) {
            return $ba6e2539d0024c3d$var$inRange(e, localizer.startOf(day, 'day'), localizer.endOf(day, 'day'), accessors, localizer);
        });
        return events.map(function(event, idx) {
            var title = accessors.title(event);
            var end = accessors.end(event);
            var start = accessors.start(event);
            var userProps = getters.eventProp(event, start, end, $ba6e2539d0024c3d$var$isSelected(event, selected));
            var dateLabel = idx === 0 && localizer.format(day, 'agendaDateFormat');
            var first = idx === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("td", {
                rowSpan: events.length,
                className: "rbc-agenda-date-cell"
            }, AgendaDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(AgendaDate, {
                day: day,
                label: dateLabel
            }) : dateLabel) : false;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("tr", {
                key: dayKey + '_' + idx,
                className: userProps.className,
                style: userProps.style
            }, first, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("td", {
                className: "rbc-agenda-time-cell"
            }, timeRangeLabel(day, event)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("td", {
                className: "rbc-agenda-event-cell",
                onClick: function onClick(e) {
                    return onSelectEvent && onSelectEvent(event, e);
                },
                onDoubleClick: function onDoubleClick(e) {
                    return onDoubleClickEvent && onDoubleClickEvent(event, e);
                }
            }, Event ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(Event, {
                event: event,
                title: title
            }) : title));
        }, []);
    };
    var timeRangeLabel = function timeRangeLabel(day, event) {
        var labelClass = '', TimeComponent = components.time, label = localizer.messages.allDay;
        var end = accessors.end(event);
        var start = accessors.start(event);
        if (!accessors.allDay(event)) {
            if (localizer.eq(start, end)) label = localizer.format(start, 'agendaTimeFormat');
            else if (localizer.isSameDate(start, end)) label = localizer.format({
                start: start,
                end: end
            }, 'agendaTimeRangeFormat');
            else if (localizer.isSameDate(day, start)) label = localizer.format(start, 'agendaTimeFormat');
            else if (localizer.isSameDate(day, end)) label = localizer.format(end, 'agendaTimeFormat');
        }
        if (localizer.gt(day, start, 'day')) labelClass = 'rbc-continues-prior';
        if (localizer.lt(day, end, 'day')) labelClass += ' rbc-continues-after';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
            className: labelClass.trim()
        }, TimeComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(TimeComponent, {
            event: event,
            day: day,
            label: label
        }) : label);
    };
    var _adjustHeader = function _adjustHeader() {
        if (!tbodyRef.current) return;
        var header = headerRef.current;
        var firstRow = tbodyRef.current.firstChild;
        if (!firstRow) return;
        var isOverflowing = contentRef.current.scrollHeight > contentRef.current.clientHeight;
        var _widths = [];
        var widths = _widths;
        _widths = [
            (0, $99a9f0718f601fba$export$2e2bcd8739ae039)(firstRow.children[0]),
            (0, $99a9f0718f601fba$export$2e2bcd8739ae039)(firstRow.children[1])
        ];
        if (widths[0] !== _widths[0] || widths[1] !== _widths[1]) {
            dateColRef.current.style.width = _widths[0] + 'px';
            timeColRef.current.style.width = _widths[1] + 'px';
        }
        if (isOverflowing) {
            (0, $46e290cb0f60e3f6$export$2e2bcd8739ae039)(header, 'rbc-header-overflowing');
            header.style.marginRight = (0, $064e68c4f9e480d9$export$2e2bcd8739ae039)() + 'px';
        } else (0, $49c08283aa9ff20a$export$2e2bcd8739ae039)(header, 'rbc-header-overflowing');
    };
    var messages = localizer.messages;
    var end = localizer.add(date, length, 'day');
    var range = localizer.range(date, end, 'day');
    events = events.filter(function(event) {
        return $ba6e2539d0024c3d$var$inRange(event, localizer.startOf(date, 'day'), localizer.endOf(end, 'day'), accessors, localizer);
    });
    events.sort(function(a, b) {
        return +accessors.start(a) - +accessors.start(b);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        className: "rbc-agenda-view"
    }, events.length !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("table", {
        ref: headerRef,
        className: "rbc-agenda-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("th", {
        className: "rbc-header",
        ref: dateColRef
    }, messages.date), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("th", {
        className: "rbc-header",
        ref: timeColRef
    }, messages.time), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("th", {
        className: "rbc-header"
    }, messages.event)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        className: "rbc-agenda-content",
        ref: contentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("table", {
        className: "rbc-agenda-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("tbody", {
        ref: tbodyRef
    }, range.map(function(day, idx) {
        return renderDay(day, events, idx);
    }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
        className: "rbc-agenda-empty"
    }, messages.noEventsInRange));
}
$ba6e2539d0024c3d$var$Agenda.propTypes = {};
$ba6e2539d0024c3d$var$Agenda.range = function(start, _ref2) {
    var _ref2$length = _ref2.length, length = _ref2$length === void 0 ? $ba6e2539d0024c3d$var$DEFAULT_LENGTH : _ref2$length, localizer = _ref2.localizer;
    var end = localizer.add(start, length, 'day');
    return {
        start: start,
        end: end
    };
};
$ba6e2539d0024c3d$var$Agenda.navigate = function(date, action, _ref3) {
    var _ref3$length = _ref3.length, length = _ref3$length === void 0 ? $ba6e2539d0024c3d$var$DEFAULT_LENGTH : _ref3$length, localizer = _ref3.localizer;
    switch(action){
        case $ba6e2539d0024c3d$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -length, 'day');
        case $ba6e2539d0024c3d$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, length, 'day');
        default:
            return date;
    }
};
$ba6e2539d0024c3d$var$Agenda.title = function(start, _ref4) {
    var _ref4$length = _ref4.length, length = _ref4$length === void 0 ? $ba6e2539d0024c3d$var$DEFAULT_LENGTH : _ref4$length, localizer = _ref4.localizer;
    var end = localizer.add(start, length, 'day');
    return localizer.format({
        start: start,
        end: end
    }, 'agendaHeaderFormat');
};
var $ba6e2539d0024c3d$var$VIEWS = (0, $bfbb99364ffa951d$export$2e2bcd8739ae039)((0, $bfbb99364ffa951d$export$2e2bcd8739ae039)((0, $bfbb99364ffa951d$export$2e2bcd8739ae039)((0, $bfbb99364ffa951d$export$2e2bcd8739ae039)((0, $bfbb99364ffa951d$export$2e2bcd8739ae039)({}, $ba6e2539d0024c3d$export$5cb791131c501f6a.MONTH, $ba6e2539d0024c3d$var$MonthView), $ba6e2539d0024c3d$export$5cb791131c501f6a.WEEK, $ba6e2539d0024c3d$var$Week), $ba6e2539d0024c3d$export$5cb791131c501f6a.WORK_WEEK, $ba6e2539d0024c3d$var$WorkWeek), $ba6e2539d0024c3d$export$5cb791131c501f6a.DAY, $ba6e2539d0024c3d$var$Day), $ba6e2539d0024c3d$export$5cb791131c501f6a.AGENDA, $ba6e2539d0024c3d$var$Agenda);
var $ba6e2539d0024c3d$var$_excluded$1 = [
    "action",
    "date",
    "today"
];
function $ba6e2539d0024c3d$export$d947e5f4f4c48d48(View, _ref) {
    var action = _ref.action, date = _ref.date, today = _ref.today, props = (0, $7b4c4f4a56bd113a$export$2e2bcd8739ae039)(_ref, $ba6e2539d0024c3d$var$_excluded$1);
    View = typeof View === 'string' ? $ba6e2539d0024c3d$var$VIEWS[View] : View;
    switch(action){
        case $ba6e2539d0024c3d$export$444b3ab0cb9aec40.TODAY:
            date = today || new Date();
            break;
        case $ba6e2539d0024c3d$export$444b3ab0cb9aec40.DATE:
            break;
        default:
            (0, (/*@__PURE__*/$parcel$interopDefault($08d9ec57190e35c9$exports)))(View && typeof View.navigate === 'function', 'Calendar View components must implement a static `.navigate(date, action)` method.s');
            date = View.navigate(date, action, props);
    }
    return date;
}
/**
 * Retrieve via an accessor-like property
 *
 *    accessor(obj, 'name')   // => retrieves obj['name']
 *    accessor(data, func)    // => retrieves func(data)
 *    ... otherwise null
 */ function $ba6e2539d0024c3d$var$accessor(data, field) {
    var value = null;
    if (typeof field === 'function') value = field(data);
    else if (typeof field === 'string' && (0, $78b404e4b46724a3$export$2e2bcd8739ae039)(data) === 'object' && data != null && field in data) value = data[field];
    return value;
}
var $ba6e2539d0024c3d$var$wrapAccessor = function wrapAccessor(acc) {
    return function(data) {
        return $ba6e2539d0024c3d$var$accessor(data, acc);
    };
};
var $ba6e2539d0024c3d$var$_excluded = [
    "view",
    "date",
    "getNow",
    "onNavigate"
], $ba6e2539d0024c3d$var$_excluded2 = [
    "view",
    "toolbar",
    "events",
    "backgroundEvents",
    "resourceGroupingLayout",
    "style",
    "className",
    "elementProps",
    "date",
    "getNow",
    "length",
    "showMultiDayTimes",
    "onShowMore",
    "doShowMoreDrillDown",
    "components",
    "formats",
    "messages",
    "culture"
];
function $ba6e2539d0024c3d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba6e2539d0024c3d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba6e2539d0024c3d$var$ownKeys(Object(t), true).forEach(function(r) {
            (0, $bfbb99364ffa951d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba6e2539d0024c3d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ba6e2539d0024c3d$var$_callSuper(t, o, e) {
    return o = (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(o), (0, $01be6314813c2472$export$2e2bcd8739ae039)(t, $ba6e2539d0024c3d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $8947323b9c1629a9$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $ba6e2539d0024c3d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba6e2539d0024c3d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ba6e2539d0024c3d$var$viewNames(_views) {
    if (Array.isArray(_views)) return _views;
    var views = [];
    for(var _i = 0, _Object$entries = Object.entries(_views); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value) views.push(key);
    }
    return views;
}
function $ba6e2539d0024c3d$var$isValidView(view, _ref) {
    var _views = _ref.views;
    var names = $ba6e2539d0024c3d$var$viewNames(_views);
    return names.indexOf(view) !== -1;
}
var $ba6e2539d0024c3d$var$Calendar = /*#__PURE__*/ function(_React$Component) {
    function Calendar() {
        var _this;
        (0, $1fadade0dba858a9$export$2e2bcd8739ae039)(this, Calendar);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = $ba6e2539d0024c3d$var$_callSuper(this, Calendar, [].concat(_args));
        _this.getViews = function() {
            var views = _this.props.views;
            if (Array.isArray(views)) return (0, (/*@__PURE__*/$parcel$interopDefault($a071b9768ce9bbc0$exports)))(views, function(obj, name) {
                return obj[name] = $ba6e2539d0024c3d$var$VIEWS[name];
            }, {});
            if ((0, $78b404e4b46724a3$export$2e2bcd8739ae039)(views) === 'object') return (0, (/*@__PURE__*/$parcel$interopDefault($600820978ae08d7e$exports)))(views, function(value, key) {
                if (value === true) return $ba6e2539d0024c3d$var$VIEWS[key];
                return value;
            });
            return $ba6e2539d0024c3d$var$VIEWS;
        };
        _this.getView = function() {
            var views = _this.getViews();
            return views[_this.props.view];
        };
        _this.getDrilldownView = function(date) {
            var _this$props = _this.props, view = _this$props.view, drilldownView = _this$props.drilldownView, getDrilldownView = _this$props.getDrilldownView;
            if (!getDrilldownView) return drilldownView;
            return getDrilldownView(date, view, Object.keys(_this.getViews()));
        };
        /**
     *
     * @param date
     * @param viewComponent
     * @param {'month'|'week'|'work_week'|'day'|'agenda'} [view] - optional
     * parameter. It appears when range change on view changing. It could be handy
     * when you need to have both: range and view type at once, i.e. for manage rbc
     * state via url
     */ _this.handleRangeChange = function(date, viewComponent, view) {
            var _this$props2 = _this.props, onRangeChange = _this$props2.onRangeChange, localizer = _this$props2.localizer;
            if (onRangeChange) {
                if (viewComponent.range) onRangeChange(viewComponent.range(date, {
                    localizer: localizer
                }), view);
            }
        };
        _this.handleNavigate = function(action, newDate) {
            var _this$props3 = _this.props, view = _this$props3.view, date = _this$props3.date, getNow = _this$props3.getNow, onNavigate = _this$props3.onNavigate, props = (0, $7b4c4f4a56bd113a$export$2e2bcd8739ae039)(_this$props3, $ba6e2539d0024c3d$var$_excluded);
            var ViewComponent = _this.getView();
            var today = getNow();
            date = $ba6e2539d0024c3d$export$d947e5f4f4c48d48(ViewComponent, $ba6e2539d0024c3d$var$_objectSpread($ba6e2539d0024c3d$var$_objectSpread({}, props), {}, {
                action: action,
                date: newDate || date || today,
                today: today
            }));
            onNavigate(date, view, action);
            _this.handleRangeChange(date, ViewComponent);
        };
        _this.handleViewChange = function(view) {
            if (view !== _this.props.view && $ba6e2539d0024c3d$var$isValidView(view, _this.props)) _this.props.onView(view);
            var views = _this.getViews();
            _this.handleRangeChange(_this.props.date || _this.props.getNow(), views[view], view);
        };
        _this.handleSelectEvent = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $ba6e2539d0024c3d$var$notify(_this.props.onSelectEvent, args);
        };
        _this.handleDoubleClickEvent = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $ba6e2539d0024c3d$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this.handleKeyPressEvent = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            $ba6e2539d0024c3d$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.handleSelectSlot = function(slotInfo) {
            $ba6e2539d0024c3d$var$notify(_this.props.onSelectSlot, slotInfo);
        };
        _this.handleDrillDown = function(date, view) {
            var onDrillDown = _this.props.onDrillDown;
            if (onDrillDown) {
                onDrillDown(date, view, _this.drilldownView);
                return;
            }
            if (view) _this.handleViewChange(view);
            _this.handleNavigate($ba6e2539d0024c3d$export$444b3ab0cb9aec40.DATE, date);
        };
        _this.state = {
            context: Calendar.getContext(_this.props)
        };
        return _this;
    }
    (0, $5a58d332f7e1c7eb$export$2e2bcd8739ae039)(Calendar, _React$Component);
    return (0, $b944111f291d7912$export$2e2bcd8739ae039)(Calendar, [
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, view = _this$props4.view, toolbar = _this$props4.toolbar, events = _this$props4.events, backgroundEvents = _this$props4.backgroundEvents, resourceGroupingLayout = _this$props4.resourceGroupingLayout, style = _this$props4.style, className = _this$props4.className, elementProps = _this$props4.elementProps, current = _this$props4.date, getNow = _this$props4.getNow, length = _this$props4.length, showMultiDayTimes = _this$props4.showMultiDayTimes, onShowMore = _this$props4.onShowMore, doShowMoreDrillDown = _this$props4.doShowMoreDrillDown;
                _this$props4.components;
                _this$props4.formats;
                _this$props4.messages;
                _this$props4.culture;
                var props = (0, $7b4c4f4a56bd113a$export$2e2bcd8739ae039)(_this$props4, $ba6e2539d0024c3d$var$_excluded2);
                current = current || getNow();
                var View = this.getView();
                var _this$state$context = this.state.context, accessors = _this$state$context.accessors, components = _this$state$context.components, getters = _this$state$context.getters, localizer = _this$state$context.localizer, viewNames = _this$state$context.viewNames;
                var CalToolbar = components.toolbar || $ba6e2539d0024c3d$var$Toolbar;
                var label = View.title(current, {
                    localizer: localizer,
                    length: length
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, elementProps, {
                    className: (0, $2f0a3b5636e7a66d$export$2e2bcd8739ae039)(className, 'rbc-calendar', props.rtl && 'rbc-rtl'),
                    style: style
                }), toolbar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(CalToolbar, {
                    date: current,
                    view: view,
                    views: viewNames,
                    label: label,
                    onView: this.handleViewChange,
                    onNavigate: this.handleNavigate,
                    localizer: localizer
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(View, (0, $6979e79daae1f4fd$export$2e2bcd8739ae039)({}, props, {
                    events: events,
                    backgroundEvents: backgroundEvents,
                    date: current,
                    getNow: getNow,
                    length: length,
                    localizer: localizer,
                    getters: getters,
                    components: components,
                    accessors: accessors,
                    showMultiDayTimes: showMultiDayTimes,
                    getDrilldownView: this.getDrilldownView,
                    onNavigate: this.handleNavigate,
                    onDrillDown: this.handleDrillDown,
                    onSelectEvent: this.handleSelectEvent,
                    onDoubleClickEvent: this.handleDoubleClickEvent,
                    onKeyPressEvent: this.handleKeyPressEvent,
                    onSelectSlot: this.handleSelectSlot,
                    onShowMore: onShowMore,
                    doShowMoreDrillDown: doShowMoreDrillDown,
                    resourceGroupingLayout: resourceGroupingLayout
                })));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps) {
                return {
                    context: Calendar.getContext(nextProps)
                };
            }
        },
        {
            key: "getContext",
            value: function getContext(_ref2) {
                var startAccessor = _ref2.startAccessor, endAccessor = _ref2.endAccessor, allDayAccessor = _ref2.allDayAccessor, tooltipAccessor = _ref2.tooltipAccessor, titleAccessor = _ref2.titleAccessor, resourceAccessor = _ref2.resourceAccessor, resourceIdAccessor = _ref2.resourceIdAccessor, resourceTitleAccessor = _ref2.resourceTitleAccessor, eventIdAccessor = _ref2.eventIdAccessor, eventPropGetter = _ref2.eventPropGetter, backgroundEventPropGetter = _ref2.backgroundEventPropGetter, slotPropGetter = _ref2.slotPropGetter, slotGroupPropGetter = _ref2.slotGroupPropGetter, dayPropGetter = _ref2.dayPropGetter, view = _ref2.view, views = _ref2.views, localizer = _ref2.localizer, culture = _ref2.culture, _ref2$messages = _ref2.messages, messages$1 = _ref2$messages === void 0 ? {} : _ref2$messages, _ref2$components = _ref2.components, components = _ref2$components === void 0 ? {} : _ref2$components, _ref2$formats = _ref2.formats, formats = _ref2$formats === void 0 ? {} : _ref2$formats;
                var names = $ba6e2539d0024c3d$var$viewNames(views);
                var msgs = $ba6e2539d0024c3d$var$messages(messages$1);
                return {
                    viewNames: names,
                    localizer: $ba6e2539d0024c3d$var$mergeWithDefaults(localizer, culture, formats, msgs),
                    getters: {
                        eventProp: function eventProp() {
                            return eventPropGetter && eventPropGetter.apply(void 0, arguments) || {};
                        },
                        backgroundEventProp: function backgroundEventProp() {
                            return backgroundEventPropGetter && backgroundEventPropGetter.apply(void 0, arguments) || {};
                        },
                        slotProp: function slotProp() {
                            return slotPropGetter && slotPropGetter.apply(void 0, arguments) || {};
                        },
                        slotGroupProp: function slotGroupProp() {
                            return slotGroupPropGetter && slotGroupPropGetter.apply(void 0, arguments) || {};
                        },
                        dayProp: function dayProp() {
                            return dayPropGetter && dayPropGetter.apply(void 0, arguments) || {};
                        }
                    },
                    components: (0, (/*@__PURE__*/$parcel$interopDefault($64f60a1a06f93aab$exports)))(components[view] || {}, (0, (/*@__PURE__*/$parcel$interopDefault($ac236e04f1d9f092$exports)))(components, names), {
                        eventWrapper: $ba6e2539d0024c3d$var$NoopWrapper,
                        backgroundEventWrapper: $ba6e2539d0024c3d$var$NoopWrapper,
                        eventContainerWrapper: $ba6e2539d0024c3d$var$NoopWrapper,
                        dateCellWrapper: $ba6e2539d0024c3d$var$NoopWrapper,
                        weekWrapper: $ba6e2539d0024c3d$var$NoopWrapper,
                        timeSlotWrapper: $ba6e2539d0024c3d$var$NoopWrapper,
                        timeGutterWrapper: $ba6e2539d0024c3d$var$NoopWrapper,
                        timeIndicatorWrapper: $ba6e2539d0024c3d$var$NoopWrapper
                    }),
                    accessors: {
                        start: $ba6e2539d0024c3d$var$wrapAccessor(startAccessor),
                        end: $ba6e2539d0024c3d$var$wrapAccessor(endAccessor),
                        allDay: $ba6e2539d0024c3d$var$wrapAccessor(allDayAccessor),
                        tooltip: $ba6e2539d0024c3d$var$wrapAccessor(tooltipAccessor),
                        title: $ba6e2539d0024c3d$var$wrapAccessor(titleAccessor),
                        resource: $ba6e2539d0024c3d$var$wrapAccessor(resourceAccessor),
                        resourceId: $ba6e2539d0024c3d$var$wrapAccessor(resourceIdAccessor),
                        resourceTitle: $ba6e2539d0024c3d$var$wrapAccessor(resourceTitleAccessor),
                        eventId: $ba6e2539d0024c3d$var$wrapAccessor(eventIdAccessor)
                    }
                };
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Component);
$ba6e2539d0024c3d$var$Calendar.defaultProps = {
    events: [],
    backgroundEvents: [],
    elementProps: {},
    popup: false,
    toolbar: true,
    view: $ba6e2539d0024c3d$export$5cb791131c501f6a.MONTH,
    views: [
        $ba6e2539d0024c3d$export$5cb791131c501f6a.MONTH,
        $ba6e2539d0024c3d$export$5cb791131c501f6a.WEEK,
        $ba6e2539d0024c3d$export$5cb791131c501f6a.DAY,
        $ba6e2539d0024c3d$export$5cb791131c501f6a.AGENDA
    ],
    step: 30,
    length: 30,
    allDayMaxRows: Infinity,
    doShowMoreDrillDown: true,
    drilldownView: $ba6e2539d0024c3d$export$5cb791131c501f6a.DAY,
    titleAccessor: 'title',
    tooltipAccessor: 'title',
    allDayAccessor: 'allDay',
    startAccessor: 'start',
    endAccessor: 'end',
    resourceAccessor: 'resourceId',
    resourceIdAccessor: 'id',
    resourceTitleAccessor: 'title',
    eventIdAccessor: 'id',
    longPressThreshold: 250,
    getNow: function getNow() {
        return new Date();
    },
    dayLayoutAlgorithm: 'overlap'
};
$ba6e2539d0024c3d$var$Calendar.propTypes = {};
var $ba6e2539d0024c3d$export$e1aef45b828286de = (0, $2e5e4ff616afd0fd$export$2e2bcd8739ae039)($ba6e2539d0024c3d$var$Calendar, {
    view: 'onView',
    date: 'onNavigate',
    selected: 'onSelectEvent'
});
var $ba6e2539d0024c3d$var$weekRangeFormat$5 = function weekRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'MMMM DD', culture) + " \u2013 " + // updated to use this localizer 'eq()' method
    local.format(end, local.eq(start, end, 'month') ? 'DD' : 'MMMM DD', culture);
};
var $ba6e2539d0024c3d$var$dateRangeFormat$5 = function dateRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 'L', culture) + " \u2013 " + local.format(end, 'L', culture);
};
var $ba6e2539d0024c3d$var$timeRangeFormat$5 = function timeRangeFormat(_ref3, culture, local) {
    var start = _ref3.start, end = _ref3.end;
    return local.format(start, 'LT', culture) + " \u2013 " + local.format(end, 'LT', culture);
};
var $ba6e2539d0024c3d$var$timeRangeStartFormat$5 = function timeRangeStartFormat(_ref4, culture, local) {
    var start = _ref4.start;
    return local.format(start, 'LT', culture) + " \u2013 ";
};
var $ba6e2539d0024c3d$var$timeRangeEndFormat$5 = function timeRangeEndFormat(_ref5, culture, local) {
    var end = _ref5.end;
    return " \u2013 " + local.format(end, 'LT', culture);
};
var $ba6e2539d0024c3d$var$formats$5 = {
    dateFormat: 'DD',
    dayFormat: 'DD ddd',
    weekdayFormat: 'ddd',
    selectRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$5,
    eventTimeRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$5,
    eventTimeRangeStartFormat: $ba6e2539d0024c3d$var$timeRangeStartFormat$5,
    eventTimeRangeEndFormat: $ba6e2539d0024c3d$var$timeRangeEndFormat$5,
    timeGutterFormat: 'LT',
    monthHeaderFormat: 'MMMM YYYY',
    dayHeaderFormat: 'dddd MMM DD',
    dayRangeHeaderFormat: $ba6e2539d0024c3d$var$weekRangeFormat$5,
    agendaHeaderFormat: $ba6e2539d0024c3d$var$dateRangeFormat$5,
    agendaDateFormat: 'ddd MMM DD',
    agendaTimeFormat: 'LT',
    agendaTimeRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$5
};
function $ba6e2539d0024c3d$var$fixUnit$2(unit) {
    var datePart = unit ? unit.toLowerCase() : unit;
    if (datePart === 'FullYear') datePart = 'year';
    else if (!datePart) datePart = undefined;
    return datePart;
}
function $ba6e2539d0024c3d$export$29814e003152ab50(moment) {
    var locale = function locale(m, c) {
        return c ? m.locale(c) : m;
    };
    function getTimezoneOffset(date) {
        // ensures this gets cast to timezone
        return moment(date).toDate().getTimezoneOffset();
    }
    function getDstOffset(start, end) {
        var _st$_z$name, _st$_z;
        // convert to moment, in case
        // Calculate the offset in the timezone of the Events (local)
        // not in the timezone of the calendar (moment.tz)
        var st = moment(start).local();
        var ed = moment(end).local();
        // if not using moment timezone
        if (!moment.tz) return st.toDate().getTimezoneOffset() - ed.toDate().getTimezoneOffset();
        /**
     * If using moment-timezone, and a timezone has been applied, then
     * use this to get the proper timezone offset, otherwise default
     * the timezone to the browser local
     */ var tzName = (_st$_z$name = st === null || st === void 0 || (_st$_z = st._z) === null || _st$_z === void 0 ? void 0 : _st$_z.name) !== null && _st$_z$name !== void 0 ? _st$_z$name : moment.tz.guess();
        var startOffset = moment.tz.zone(tzName).utcOffset(+st);
        var endOffset = moment.tz.zone(tzName).utcOffset(+ed);
        return startOffset - endOffset;
    }
    function getDayStartDstOffset(start) {
        var dayStart = moment(start).startOf('day');
        return getDstOffset(dayStart, start);
    }
    /*** BEGIN localized date arithmetic methods with moment ***/ function defineComparators(a, b, unit) {
        var datePart = $ba6e2539d0024c3d$var$fixUnit$2(unit);
        var dtA = datePart ? moment(a).startOf(datePart) : moment(a);
        var dtB = datePart ? moment(b).startOf(datePart) : moment(b);
        return [
            dtA,
            dtB,
            datePart
        ];
    }
    function startOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $ba6e2539d0024c3d$var$fixUnit$2(unit);
        if (datePart) return moment(date).startOf(datePart).toDate();
        return moment(date).toDate();
    }
    function endOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $ba6e2539d0024c3d$var$fixUnit$2(unit);
        if (datePart) return moment(date).endOf(datePart).toDate();
        return moment(date).toDate();
    }
    // moment comparison operations *always* convert both sides to moment objects
    // prior to running the comparisons
    function eq(a, b, unit) {
        var _defineComparators = defineComparators(a, b, unit), _defineComparators2 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators, 3), dtA = _defineComparators2[0], dtB = _defineComparators2[1], datePart = _defineComparators2[2];
        return dtA.isSame(dtB, datePart);
    }
    function neq(a, b, unit) {
        return !eq(a, b, unit);
    }
    function gt(a, b, unit) {
        var _defineComparators3 = defineComparators(a, b, unit), _defineComparators4 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators3, 3), dtA = _defineComparators4[0], dtB = _defineComparators4[1], datePart = _defineComparators4[2];
        return dtA.isAfter(dtB, datePart);
    }
    function lt(a, b, unit) {
        var _defineComparators5 = defineComparators(a, b, unit), _defineComparators6 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators5, 3), dtA = _defineComparators6[0], dtB = _defineComparators6[1], datePart = _defineComparators6[2];
        return dtA.isBefore(dtB, datePart);
    }
    function gte(a, b, unit) {
        var _defineComparators7 = defineComparators(a, b, unit), _defineComparators8 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators7, 3), dtA = _defineComparators8[0], dtB = _defineComparators8[1], datePart = _defineComparators8[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function lte(a, b, unit) {
        var _defineComparators9 = defineComparators(a, b, unit), _defineComparators0 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators9, 3), dtA = _defineComparators0[0], dtB = _defineComparators0[1], datePart = _defineComparators0[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function inRange(day, min, max) {
        var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'day';
        var datePart = $ba6e2539d0024c3d$var$fixUnit$2(unit);
        var mDay = moment(day);
        var mMin = moment(min);
        var mMax = moment(max);
        return mDay.isBetween(mMin, mMax, datePart, '[]');
    }
    function min(dateA, dateB) {
        var dtA = moment(dateA);
        var dtB = moment(dateB);
        var minDt = moment.min(dtA, dtB);
        return minDt.toDate();
    }
    function max(dateA, dateB) {
        var dtA = moment(dateA);
        var dtB = moment(dateB);
        var maxDt = moment.max(dtA, dtB);
        return maxDt.toDate();
    }
    function merge(date, time) {
        if (!date && !time) return null;
        var tm = moment(time).format('HH:mm:ss');
        var dt = moment(date).startOf('day').format('MM/DD/YYYY');
        // We do it this way to avoid issues when timezone switching
        return moment("".concat(dt, " ").concat(tm), 'MM/DD/YYYY HH:mm:ss').toDate();
    }
    function add(date, adder, unit) {
        var datePart = $ba6e2539d0024c3d$var$fixUnit$2(unit);
        return moment(date).add(adder, datePart).toDate();
    }
    function range(start, end) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $ba6e2539d0024c3d$var$fixUnit$2(unit);
        // because the add method will put these in tz, we have to start that way
        var current = moment(start).toDate();
        var days = [];
        while(lte(current, end)){
            days.push(current);
            current = add(current, 1, datePart);
        }
        return days;
    }
    function ceil(date, unit) {
        var datePart = $ba6e2539d0024c3d$var$fixUnit$2(unit);
        var floor = startOf(date, datePart);
        return eq(floor, date) ? floor : add(floor, 1, datePart);
    }
    function diff(a, b) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $ba6e2539d0024c3d$var$fixUnit$2(unit);
        // don't use 'defineComparators' here, as we don't want to mutate the values
        var dtA = moment(a);
        var dtB = moment(b);
        return dtB.diff(dtA, datePart);
    }
    function minutes(date) {
        var dt = moment(date);
        return dt.minutes();
    }
    function firstOfWeek(culture) {
        var data = culture ? moment.localeData(culture) : moment.localeData();
        return data ? data.firstDayOfWeek() : 0;
    }
    function firstVisibleDay(date) {
        return moment(date).startOf('month').startOf('week').toDate();
    }
    function lastVisibleDay(date) {
        return moment(date).endOf('month').endOf('week').toDate();
    }
    function visibleDays(date) {
        var current = firstVisibleDay(date);
        var last = lastVisibleDay(date);
        var days = [];
        while(lte(current, last)){
            days.push(current);
            current = add(current, 1, 'd');
        }
        return days;
    }
    /*** END localized date arithmetic methods with moment ***/ /**
   * Moved from TimeSlots.js, this method overrides the method of the same name
   * in the localizer.js, using moment to construct the js Date
   * @param {Date} dt - date to start with
   * @param {Number} minutesFromMidnight
   * @param {Number} offset
   * @returns {Date}
   */ function getSlotDate(dt, minutesFromMidnight, offset) {
        return moment(dt).startOf('day').minute(minutesFromMidnight + offset).toDate();
    }
    // moment will automatically handle DST differences in it's calculations
    function getTotalMin(start, end) {
        return diff(start, end, 'minutes');
    }
    function getMinutesFromMidnight(start) {
        var dayStart = moment(start).startOf('day');
        var day = moment(start);
        return day.diff(dayStart, 'minutes') + getDayStartDstOffset(start);
    }
    // These two are used by DateSlotMetrics
    function continuesPrior(start, first) {
        var mStart = moment(start);
        var mFirst = moment(first);
        return mStart.isBefore(mFirst, 'day');
    }
    function continuesAfter(start, end, last) {
        var mEnd = moment(end);
        var mLast = moment(last);
        return mEnd.isSameOrAfter(mLast, 'minutes');
    }
    function daySpan(start, end) {
        var mStart = moment(start);
        var mEnd = moment(end);
        var dur = moment.duration(mEnd.diff(mStart));
        return dur.days();
    }
    // These two are used by eventLevels
    function sortEvents(_ref6) {
        var _ref6$evtA = _ref6.evtA, aStart = _ref6$evtA.start, aEnd = _ref6$evtA.end, aAllDay = _ref6$evtA.allDay, _ref6$evtB = _ref6.evtB, bStart = _ref6$evtB.start, bEnd = _ref6$evtB.end, bAllDay = _ref6$evtB.allDay;
        var startSort = +startOf(aStart, 'day') - +startOf(bStart, 'day');
        var durA = daySpan(aStart, aEnd);
        var durB = daySpan(bStart, bEnd);
        return startSort || // sort by start Day first
        durB - durA || // events spanning multiple days go first
        !!bAllDay - !!aAllDay || // then allDay single day events
        +aStart - +bStart || // then sort by start time *don't need moment conversion here
        +aEnd - +bEnd // then sort by end time *don't need moment conversion here either
        ;
    }
    function inEventRange(_ref7) {
        var _ref7$event = _ref7.event, start = _ref7$event.start, end = _ref7$event.end, _ref7$range = _ref7.range, rangeStart = _ref7$range.start, rangeEnd = _ref7$range.end;
        var startOfDay = moment(start).startOf('day');
        var eEnd = moment(end);
        var rStart = moment(rangeStart);
        var rEnd = moment(rangeEnd);
        var startsBeforeEnd = startOfDay.isSameOrBefore(rEnd, 'day');
        // when the event is zero duration we need to handle a bit differently
        var sameMin = !startOfDay.isSame(eEnd, 'minutes');
        var endsAfterStart = sameMin ? eEnd.isAfter(rStart, 'minutes') : eEnd.isSameOrAfter(rStart, 'minutes');
        return startsBeforeEnd && endsAfterStart;
    }
    function isSameDate(date1, date2) {
        var dt = moment(date1);
        var dt2 = moment(date2);
        return dt.isSame(dt2, 'day');
    }
    /**
   * This method, called once in the localizer constructor, is used by eventLevels
   * 'eventSegments()' to assist in determining the 'span' of the event in the display,
   * specifically when using a timezone that is greater than the browser native timezone.
   * @returns number
   */ function browserTZOffset() {
        /**
     * Date.prototype.getTimezoneOffset horrifically flips the positive/negative from
     * what you see in it's string, so we have to jump through some hoops to get a value
     * we can actually compare.
     */ var dt = new Date();
        var neg = /-/.test(dt.toString()) ? '-' : '';
        var dtOffset = dt.getTimezoneOffset();
        var comparator = Number("".concat(neg).concat(Math.abs(dtOffset)));
        // moment correctly provides positive/negative offset, as expected
        var mtOffset = moment().utcOffset();
        return mtOffset > comparator ? 1 : 0;
    }
    return new $ba6e2539d0024c3d$export$193ddab16544ff5b({
        formats: $ba6e2539d0024c3d$var$formats$5,
        firstOfWeek: firstOfWeek,
        firstVisibleDay: firstVisibleDay,
        lastVisibleDay: lastVisibleDay,
        visibleDays: visibleDays,
        format: function format(value, _format, culture) {
            return locale(moment(value), culture).format(_format);
        },
        lt: lt,
        lte: lte,
        gt: gt,
        gte: gte,
        eq: eq,
        neq: neq,
        merge: merge,
        inRange: inRange,
        startOf: startOf,
        endOf: endOf,
        range: range,
        add: add,
        diff: diff,
        ceil: ceil,
        min: min,
        max: max,
        minutes: minutes,
        getSlotDate: getSlotDate,
        getTimezoneOffset: getTimezoneOffset,
        getDstOffset: getDstOffset,
        getTotalMin: getTotalMin,
        getMinutesFromMidnight: getMinutesFromMidnight,
        continuesPrior: continuesPrior,
        continuesAfter: continuesAfter,
        sortEvents: sortEvents,
        inEventRange: inEventRange,
        isSameDate: isSameDate,
        daySpan: daySpan,
        browserTZOffset: browserTZOffset
    });
}
function $ba6e2539d0024c3d$var$pluralizeUnit(unit) {
    return /s$/.test(unit) ? unit : unit + 's';
}
var $ba6e2539d0024c3d$var$weekRangeFormat$4 = function weekRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'MMMM dd', culture) + " \u2013 " + // updated to use this localizer 'eq()' method
    local.format(end, local.eq(start, end, 'month') ? 'dd' : 'MMMM dd', culture);
};
var $ba6e2539d0024c3d$var$dateRangeFormat$4 = function dateRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 'D', culture) + " \u2013 " + local.format(end, 'D', culture);
};
var $ba6e2539d0024c3d$var$timeRangeFormat$4 = function timeRangeFormat(_ref3, culture, local) {
    var start = _ref3.start, end = _ref3.end;
    return local.format(start, 't', culture) + " \u2013 " + local.format(end, 't', culture);
};
var $ba6e2539d0024c3d$var$timeRangeStartFormat$4 = function timeRangeStartFormat(_ref4, culture, local) {
    var start = _ref4.start;
    return local.format(start, 't', culture) + " \u2013 ";
};
var $ba6e2539d0024c3d$var$timeRangeEndFormat$4 = function timeRangeEndFormat(_ref5, culture, local) {
    var end = _ref5.end;
    return " \u2013 " + local.format(end, 't', culture);
};
var $ba6e2539d0024c3d$var$formats$4 = {
    dateFormat: 'dd',
    dayFormat: 'dd EEE',
    weekdayFormat: 'EEE',
    selectRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$4,
    eventTimeRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$4,
    eventTimeRangeStartFormat: $ba6e2539d0024c3d$var$timeRangeStartFormat$4,
    eventTimeRangeEndFormat: $ba6e2539d0024c3d$var$timeRangeEndFormat$4,
    timeGutterFormat: 't',
    monthHeaderFormat: 'MMMM yyyy',
    dayHeaderFormat: 'EEEE MMM dd',
    dayRangeHeaderFormat: $ba6e2539d0024c3d$var$weekRangeFormat$4,
    agendaHeaderFormat: $ba6e2539d0024c3d$var$dateRangeFormat$4,
    agendaDateFormat: 'EEE MMM dd',
    agendaTimeFormat: 't',
    agendaTimeRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$4
};
function $ba6e2539d0024c3d$var$fixUnit$1(unit) {
    var datePart = unit ? $ba6e2539d0024c3d$var$pluralizeUnit(unit.toLowerCase()) : unit;
    if (datePart === 'FullYear') datePart = 'year';
    else if (!datePart) datePart = undefined;
    return datePart;
}
// Luxon does not currently have weekInfo by culture
// Luxon uses 1 based values for month and weekday
// So we default to Sunday (7)
function $ba6e2539d0024c3d$export$d65cc979272e65c7(DateTime) {
    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref6$firstDayOfWeek = _ref6.firstDayOfWeek, firstDayOfWeek = _ref6$firstDayOfWeek === void 0 ? 7 : _ref6$firstDayOfWeek;
    function formatDate(value, format) {
        return DateTime.fromJSDate(value).toFormat(format);
    }
    function formatDateWithCulture(value, culture, format) {
        return DateTime.fromJSDate(value).setLocale(culture).toFormat(format);
    }
    /*** BEGIN localized date arithmetic methods with Luxon ***/ function defineComparators(a, b, unit) {
        var datePart = $ba6e2539d0024c3d$var$fixUnit$1(unit);
        var dtA = datePart ? DateTime.fromJSDate(a).startOf(datePart) : DateTime.fromJSDate(a);
        var dtB = datePart ? DateTime.fromJSDate(b).startOf(datePart) : DateTime.fromJSDate(b);
        return [
            dtA,
            dtB,
            datePart
        ];
    }
    // Since Luxon (and current Intl API) has no support
    // for culture based weekInfo, we need to handle
    // the start of the week differently
    // depending on locale, the firstDayOfWeek could also be Saturday, Sunday or Monday
    function startOfDTWeek(dtObj) {
        var weekday = dtObj.weekday;
        if (weekday === firstDayOfWeek) return dtObj.startOf('day'); // already beginning of week
        else if (firstDayOfWeek === 1) return dtObj.startOf('week'); // fow is Monday, which is Luxon default
        var _$diff = firstDayOfWeek === 7 ? weekday : weekday + (7 - firstDayOfWeek);
        return dtObj.minus({
            day: _$diff
        }).startOf('day');
    }
    function endOfDTWeek(dtObj) {
        var weekday = dtObj.weekday;
        var eow = firstDayOfWeek === 1 ? 7 : firstDayOfWeek - 1;
        if (weekday === eow) return dtObj.endOf('day'); // already last day of the week
        else if (firstDayOfWeek === 1) return dtObj.endOf('week'); // use Luxon default (Sunday)
        var fromDate = firstDayOfWeek > eow ? dtObj.plus({
            day: firstDayOfWeek - eow
        }) : dtObj;
        return fromDate.set({
            weekday: eow
        }).endOf('day');
    }
    // This returns a DateTime instance
    function startOfDT() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $ba6e2539d0024c3d$var$fixUnit$1(unit);
        if (datePart) {
            var dt = DateTime.fromJSDate(date);
            return datePart.includes('week') ? startOfDTWeek(dt) : dt.startOf(datePart);
        }
        return DateTime.fromJSDate(date);
    }
    function firstOfWeek() {
        return firstDayOfWeek;
    }
    // This returns a JS Date from a DateTime instance
    function startOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        return startOfDT(date, unit).toJSDate();
    }
    // This returns a DateTime instance
    function endOfDT() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $ba6e2539d0024c3d$var$fixUnit$1(unit);
        if (datePart) {
            var dt = DateTime.fromJSDate(date);
            return datePart.includes('week') ? endOfDTWeek(dt) : dt.endOf(datePart);
        }
        return DateTime.fromJSDate(date);
    }
    function endOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        return endOfDT(date, unit).toJSDate();
    }
    function eq(a, b, unit) {
        var _defineComparators = defineComparators(a, b, unit), _defineComparators2 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators, 2), dtA = _defineComparators2[0], dtB = _defineComparators2[1];
        return +dtA == +dtB;
    }
    function neq(a, b, unit) {
        return !eq(a, b, unit);
    }
    function gt(a, b, unit) {
        var _defineComparators3 = defineComparators(a, b, unit), _defineComparators4 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators3, 2), dtA = _defineComparators4[0], dtB = _defineComparators4[1];
        return +dtA > +dtB;
    }
    function lt(a, b, unit) {
        var _defineComparators5 = defineComparators(a, b, unit), _defineComparators6 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators5, 2), dtA = _defineComparators6[0], dtB = _defineComparators6[1];
        return +dtA < +dtB;
    }
    function gte(a, b, unit) {
        var _defineComparators7 = defineComparators(a, b, unit), _defineComparators8 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators7, 2), dtA = _defineComparators8[0], dtB = _defineComparators8[1];
        return +dtA >= +dtB;
    }
    function lte(a, b, unit) {
        var _defineComparators9 = defineComparators(a, b, unit), _defineComparators0 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators9, 2), dtA = _defineComparators0[0], dtB = _defineComparators0[1];
        return +dtA <= +dtB;
    }
    function inRange(day, min, max) {
        var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'day';
        var datePart = $ba6e2539d0024c3d$var$fixUnit$1(unit);
        var mDay = startOfDT(day, datePart);
        var mMin = startOfDT(min, datePart);
        var mMax = startOfDT(max, datePart);
        return +mDay >= +mMin && +mDay <= +mMax;
    }
    function min(dateA, dateB) {
        var dtA = DateTime.fromJSDate(dateA);
        var dtB = DateTime.fromJSDate(dateB);
        var minDt = DateTime.min(dtA, dtB);
        return minDt.toJSDate();
    }
    function max(dateA, dateB) {
        var dtA = DateTime.fromJSDate(dateA);
        var dtB = DateTime.fromJSDate(dateB);
        var maxDt = DateTime.max(dtA, dtB);
        return maxDt.toJSDate();
    }
    function merge(date, time) {
        if (!date && !time) return null;
        var tm = DateTime.fromJSDate(time);
        var dt = startOfDT(date, 'day');
        return dt.set({
            hour: tm.hour,
            minute: tm.minute,
            second: tm.second,
            millisecond: tm.millisecond
        }).toJSDate();
    }
    function add(date, adder, unit) {
        var datePart = $ba6e2539d0024c3d$var$fixUnit$1(unit);
        return DateTime.fromJSDate(date).plus((0, $bfbb99364ffa951d$export$2e2bcd8739ae039)({}, datePart, adder)).toJSDate();
    }
    function range(start, end) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $ba6e2539d0024c3d$var$fixUnit$1(unit);
        var current = DateTime.fromJSDate(start).toJSDate(); // this is to get it to tz
        var days = [];
        while(lte(current, end)){
            days.push(current);
            current = add(current, 1, datePart);
        }
        return days;
    }
    function ceil(date, unit) {
        var datePart = $ba6e2539d0024c3d$var$fixUnit$1(unit);
        var floor = startOf(date, datePart);
        return eq(floor, date) ? floor : add(floor, 1, datePart);
    }
    function diff(a, b) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $ba6e2539d0024c3d$var$fixUnit$1(unit);
        // don't use 'defineComparators' here, as we don't want to mutate the values
        var dtA = DateTime.fromJSDate(a);
        var dtB = DateTime.fromJSDate(b);
        return Math.floor(dtB.diff(dtA, datePart, {
            conversionAccuracy: 'longterm'
        }).toObject()[datePart]);
    }
    function firstVisibleDay(date) {
        var startOfMonth = startOfDT(date, 'month');
        return startOfDTWeek(startOfMonth).toJSDate();
    }
    function lastVisibleDay(date) {
        var endOfMonth = endOfDT(date, 'month');
        return endOfDTWeek(endOfMonth).toJSDate();
    }
    function visibleDays(date) {
        var current = firstVisibleDay(date);
        var last = lastVisibleDay(date);
        var days = [];
        while(lte(current, last)){
            days.push(current);
            current = add(current, 1, 'day');
        }
        return days;
    }
    /*** END localized date arithmetic methods with moment ***/ /**
   * Moved from TimeSlots.js, this method overrides the method of the same name
   * in the localizer.js, using moment to construct the js Date
   * @param {Date} dt - date to start with
   * @param {Number} minutesFromMidnight
   * @param {Number} offset
   * @returns {Date}
   */ function getSlotDate(dt, minutesFromMidnight, offset) {
        return startOfDT(dt, 'day').set({
            minutes: minutesFromMidnight + offset
        }).toJSDate();
    }
    // Luxon will automatically handle DST differences in it's calculations
    function getTotalMin(start, end) {
        return diff(start, end, 'minutes');
    }
    function getMinutesFromMidnight(start) {
        var dayStart = startOfDT(start, 'day');
        var day = DateTime.fromJSDate(start);
        return Math.round(day.diff(dayStart, 'minutes', {
            conversionAccuracy: 'longterm'
        }).toObject().minutes);
    }
    // These two are used by DateSlotMetrics
    function continuesPrior(start, first) {
        return lt(start, first);
    }
    function continuesAfter(start, end, last) {
        return gte(end, last);
    }
    function daySpan(start, end) {
        var dtStart = DateTime.fromJSDate(start);
        var dtEnd = DateTime.fromJSDate(end);
        return dtEnd.diff(dtStart).as('days');
    }
    // These two are used by eventLevels
    function sortEvents(_ref7) {
        var _ref7$evtA = _ref7.evtA, aStart = _ref7$evtA.start, aEnd = _ref7$evtA.end, aAllDay = _ref7$evtA.allDay, _ref7$evtB = _ref7.evtB, bStart = _ref7$evtB.start, bEnd = _ref7$evtB.end, bAllDay = _ref7$evtB.allDay;
        var startSort = +startOf(aStart, 'day') - +startOf(bStart, 'day');
        var durA = daySpan(aStart, aEnd);
        var durB = daySpan(bStart, bEnd);
        return startSort || // sort by start Day first
        durB - durA || // events spanning multiple days go first
        !!bAllDay - !!aAllDay || // then allDay single day events
        +aStart - +bStart || // then sort by start time *don't need moment conversion here
        +aEnd - +bEnd // then sort by end time *don't need moment conversion here either
        ;
    }
    function inEventRange(_ref8) {
        var _ref8$event = _ref8.event, start = _ref8$event.start, end = _ref8$event.end, _ref8$range = _ref8.range, rangeStart = _ref8$range.start, rangeEnd = _ref8$range.end;
        var eStart = startOf(start, 'day');
        var startsBeforeEnd = lte(eStart, rangeEnd, 'day');
        // when the event is zero duration we need to handle a bit differently
        var sameMin = neq(eStart, end, 'minutes');
        var endsAfterStart = sameMin ? gt(end, rangeStart, 'minutes') : gte(end, rangeStart, 'minutes');
        return startsBeforeEnd && endsAfterStart;
    }
    // moment treats 'day' and 'date' equality very different
    // moment(date1).isSame(date2, 'day') would test that they were both the same day of the week
    // moment(date1).isSame(date2, 'date') would test that they were both the same date of the month of the year
    function isSameDate(date1, date2) {
        var dt = DateTime.fromJSDate(date1);
        var dt2 = DateTime.fromJSDate(date2);
        return dt.hasSame(dt2, 'day');
    }
    /**
   * This method, called once in the localizer constructor, is used by eventLevels
   * 'eventSegments()' to assist in determining the 'span' of the event in the display,
   * specifically when using a timezone that is greater than the browser native timezone.
   * @returns number
   */ function browserTZOffset() {
        /**
     * Date.prototype.getTimezoneOffset horrifically flips the positive/negative from
     * what you see in it's string, so we have to jump through some hoops to get a value
     * we can actually compare.
     */ var dt = new Date();
        var neg = /-/.test(dt.toString()) ? '-' : '';
        var dtOffset = dt.getTimezoneOffset();
        var comparator = Number("".concat(neg).concat(Math.abs(dtOffset)));
        // moment correctly provides positive/negative offset, as expected
        var mtOffset = DateTime.local().offset;
        return mtOffset > comparator ? 1 : 0;
    }
    return new $ba6e2539d0024c3d$export$193ddab16544ff5b({
        format: function format(value, _format, culture) {
            if (culture) return formatDateWithCulture(value, culture, _format);
            return formatDate(value, _format);
        },
        formats: $ba6e2539d0024c3d$var$formats$4,
        firstOfWeek: firstOfWeek,
        firstVisibleDay: firstVisibleDay,
        lastVisibleDay: lastVisibleDay,
        visibleDays: visibleDays,
        lt: lt,
        lte: lte,
        gt: gt,
        gte: gte,
        eq: eq,
        neq: neq,
        merge: merge,
        inRange: inRange,
        startOf: startOf,
        endOf: endOf,
        range: range,
        add: add,
        diff: diff,
        ceil: ceil,
        min: min,
        max: max,
        getSlotDate: getSlotDate,
        getTotalMin: getTotalMin,
        getMinutesFromMidnight: getMinutesFromMidnight,
        continuesPrior: continuesPrior,
        continuesAfter: continuesAfter,
        sortEvents: sortEvents,
        inEventRange: inEventRange,
        isSameDate: isSameDate,
        daySpan: daySpan,
        browserTZOffset: browserTZOffset
    });
}
var $ba6e2539d0024c3d$var$dateRangeFormat$3 = function dateRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'd', culture) + " \u2013 " + local.format(end, 'd', culture);
};
var $ba6e2539d0024c3d$var$timeRangeFormat$3 = function timeRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 't', culture) + " \u2013 " + local.format(end, 't', culture);
};
var $ba6e2539d0024c3d$var$timeRangeStartFormat$3 = function timeRangeStartFormat(_ref3, culture, local) {
    var start = _ref3.start;
    return local.format(start, 't', culture) + " \u2013 ";
};
var $ba6e2539d0024c3d$var$timeRangeEndFormat$3 = function timeRangeEndFormat(_ref4, culture, local) {
    var end = _ref4.end;
    return " \u2013 " + local.format(end, 't', culture);
};
var $ba6e2539d0024c3d$var$weekRangeFormat$3 = function weekRangeFormat(_ref5, culture, local) {
    var start = _ref5.start, end = _ref5.end;
    return local.format(start, 'MMM dd', culture) + " \u2013 " + local.format(end, (0, $06a62230e027db68$export$9663ddc1cf085b32)(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};
var $ba6e2539d0024c3d$var$formats$3 = {
    dateFormat: 'dd',
    dayFormat: 'ddd dd/MM',
    weekdayFormat: 'ddd',
    selectRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$3,
    eventTimeRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$3,
    eventTimeRangeStartFormat: $ba6e2539d0024c3d$var$timeRangeStartFormat$3,
    eventTimeRangeEndFormat: $ba6e2539d0024c3d$var$timeRangeEndFormat$3,
    timeGutterFormat: 't',
    monthHeaderFormat: 'Y',
    dayHeaderFormat: 'dddd MMM dd',
    dayRangeHeaderFormat: $ba6e2539d0024c3d$var$weekRangeFormat$3,
    agendaHeaderFormat: $ba6e2539d0024c3d$var$dateRangeFormat$3,
    agendaDateFormat: 'ddd MMM dd',
    agendaTimeFormat: 't',
    agendaTimeRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$3
};
function $ba6e2539d0024c3d$var$oldGlobalize(globalize) {
    function getCulture(culture) {
        return culture ? globalize.findClosestCulture(culture) : globalize.culture();
    }
    function firstOfWeek(culture) {
        culture = getCulture(culture);
        return culture && culture.calendar.firstDay || 0;
    }
    return new $ba6e2539d0024c3d$export$193ddab16544ff5b({
        firstOfWeek: firstOfWeek,
        formats: $ba6e2539d0024c3d$var$formats$3,
        format: function format(value, _format, culture) {
            return globalize.format(value, _format, culture);
        }
    });
}
var $ba6e2539d0024c3d$var$dateRangeFormat$2 = function dateRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, {
        date: 'short'
    }, culture) + " \u2013 " + local.format(end, {
        date: 'short'
    }, culture);
};
var $ba6e2539d0024c3d$var$timeRangeFormat$2 = function timeRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, {
        time: 'short'
    }, culture) + " \u2013 " + local.format(end, {
        time: 'short'
    }, culture);
};
var $ba6e2539d0024c3d$var$timeRangeStartFormat$2 = function timeRangeStartFormat(_ref3, culture, local) {
    var start = _ref3.start;
    return local.format(start, {
        time: 'short'
    }, culture) + " \u2013 ";
};
var $ba6e2539d0024c3d$var$timeRangeEndFormat$2 = function timeRangeEndFormat(_ref4, culture, local) {
    var end = _ref4.end;
    return " \u2013 " + local.format(end, {
        time: 'short'
    }, culture);
};
var $ba6e2539d0024c3d$var$weekRangeFormat$2 = function weekRangeFormat(_ref5, culture, local) {
    var start = _ref5.start, end = _ref5.end;
    return local.format(start, 'MMM dd', culture) + " \u2013 " + local.format(end, (0, $06a62230e027db68$export$9663ddc1cf085b32)(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};
var $ba6e2539d0024c3d$var$formats$2 = {
    dateFormat: 'dd',
    dayFormat: 'eee dd/MM',
    weekdayFormat: 'eee',
    selectRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$2,
    eventTimeRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$2,
    eventTimeRangeStartFormat: $ba6e2539d0024c3d$var$timeRangeStartFormat$2,
    eventTimeRangeEndFormat: $ba6e2539d0024c3d$var$timeRangeEndFormat$2,
    timeGutterFormat: {
        time: 'short'
    },
    monthHeaderFormat: 'MMMM yyyy',
    dayHeaderFormat: 'eeee MMM dd',
    dayRangeHeaderFormat: $ba6e2539d0024c3d$var$weekRangeFormat$2,
    agendaHeaderFormat: $ba6e2539d0024c3d$var$dateRangeFormat$2,
    agendaDateFormat: 'eee MMM dd',
    agendaTimeFormat: {
        time: 'short'
    },
    agendaTimeRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$2
};
function $ba6e2539d0024c3d$export$d670461b50de9b9d(globalize) {
    var locale = function locale(culture) {
        return culture ? globalize(culture) : globalize;
    };
    // return the first day of the week from the locale data. Defaults to 'world'
    // territory if no territory is derivable from CLDR.
    // Failing to use CLDR supplemental (not loaded?), revert to the original
    // method of getting first day of week.
    function firstOfWeek(culture) {
        try {
            var days = [
                'sun',
                'mon',
                'tue',
                'wed',
                'thu',
                'fri',
                'sat'
            ];
            var cldr = locale(culture).cldr;
            var territory = cldr.attributes.territory;
            var weekData = cldr.get('supplemental').weekData;
            var firstDay = weekData.firstDay[territory || '001'];
            return days.indexOf(firstDay);
        } catch (_unused) {
            // maybe cldr supplemental is not loaded? revert to original method
            var date = new Date();
            //cldr-data doesn't seem to be zero based
            var localeDay = Math.max(parseInt(locale(culture).formatDate(date, {
                raw: 'e'
            }), 10) - 1, 0);
            return Math.abs(date.getDay() - localeDay);
        }
    }
    if (!globalize.load) return $ba6e2539d0024c3d$var$oldGlobalize(globalize);
    return new $ba6e2539d0024c3d$export$193ddab16544ff5b({
        firstOfWeek: firstOfWeek,
        formats: $ba6e2539d0024c3d$var$formats$2,
        format: function format(value, _format, culture) {
            _format = typeof _format === 'string' ? {
                raw: _format
            } : _format;
            return locale(culture).formatDate(value, _format);
        }
    });
}
var $ba6e2539d0024c3d$var$dateRangeFormat$1 = function dateRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return "".concat(local.format(start, 'P', culture), " \u2013 ").concat(local.format(end, 'P', culture));
};
var $ba6e2539d0024c3d$var$timeRangeFormat$1 = function timeRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return "".concat(local.format(start, 'p', culture), " \u2013 ").concat(local.format(end, 'p', culture));
};
var $ba6e2539d0024c3d$var$timeRangeStartFormat$1 = function timeRangeStartFormat(_ref3, culture, local) {
    var start = _ref3.start;
    return "".concat(local.format(start, 'h:mma', culture), " \u2013 ");
};
var $ba6e2539d0024c3d$var$timeRangeEndFormat$1 = function timeRangeEndFormat(_ref4, culture, local) {
    var end = _ref4.end;
    return " \u2013 ".concat(local.format(end, 'h:mma', culture));
};
var $ba6e2539d0024c3d$var$weekRangeFormat$1 = function weekRangeFormat(_ref5, culture, local) {
    var start = _ref5.start, end = _ref5.end;
    return "".concat(local.format(start, 'MMMM dd', culture), " \u2013 ").concat(local.format(end, (0, $06a62230e027db68$export$9663ddc1cf085b32)(start, end, 'month') ? 'dd' : 'MMMM dd', culture));
};
var $ba6e2539d0024c3d$var$formats$1 = {
    dateFormat: 'dd',
    dayFormat: 'dd eee',
    weekdayFormat: 'ccc',
    selectRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$1,
    eventTimeRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$1,
    eventTimeRangeStartFormat: $ba6e2539d0024c3d$var$timeRangeStartFormat$1,
    eventTimeRangeEndFormat: $ba6e2539d0024c3d$var$timeRangeEndFormat$1,
    timeGutterFormat: 'p',
    monthHeaderFormat: 'MMMM yyyy',
    dayHeaderFormat: 'cccc MMM dd',
    dayRangeHeaderFormat: $ba6e2539d0024c3d$var$weekRangeFormat$1,
    agendaHeaderFormat: $ba6e2539d0024c3d$var$dateRangeFormat$1,
    agendaDateFormat: 'ccc MMM dd',
    agendaTimeFormat: 'p',
    agendaTimeRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat$1
};
var $ba6e2539d0024c3d$export$3fa2fdf84427788c = function dateFnsLocalizer(_ref6) {
    var startOfWeek = _ref6.startOfWeek, getDay = _ref6.getDay, _format = _ref6.format, locales = _ref6.locales;
    return new $ba6e2539d0024c3d$export$193ddab16544ff5b({
        formats: $ba6e2539d0024c3d$var$formats$1,
        firstOfWeek: function firstOfWeek(culture) {
            return getDay(startOfWeek(new Date(), {
                locale: locales[culture]
            }));
        },
        format: function format(value, formatString, culture) {
            return _format(new Date(value), formatString, {
                locale: locales[culture]
            });
        }
    });
};
var $ba6e2539d0024c3d$var$weekRangeFormat = function weekRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'MMMM DD', culture) + " \u2013 " + // updated to use this localizer 'eq()' method
    local.format(end, local.eq(start, end, 'month') ? 'DD' : 'MMMM DD', culture);
};
var $ba6e2539d0024c3d$var$dateRangeFormat = function dateRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 'L', culture) + " \u2013 " + local.format(end, 'L', culture);
};
var $ba6e2539d0024c3d$var$timeRangeFormat = function timeRangeFormat(_ref3, culture, local) {
    var start = _ref3.start, end = _ref3.end;
    return local.format(start, 'LT', culture) + " \u2013 " + local.format(end, 'LT', culture);
};
var $ba6e2539d0024c3d$var$timeRangeStartFormat = function timeRangeStartFormat(_ref4, culture, local) {
    var start = _ref4.start;
    return local.format(start, 'LT', culture) + " \u2013 ";
};
var $ba6e2539d0024c3d$var$timeRangeEndFormat = function timeRangeEndFormat(_ref5, culture, local) {
    var end = _ref5.end;
    return " \u2013 " + local.format(end, 'LT', culture);
};
var $ba6e2539d0024c3d$var$formats = {
    dateFormat: 'DD',
    dayFormat: 'DD ddd',
    weekdayFormat: 'ddd',
    selectRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat,
    eventTimeRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat,
    eventTimeRangeStartFormat: $ba6e2539d0024c3d$var$timeRangeStartFormat,
    eventTimeRangeEndFormat: $ba6e2539d0024c3d$var$timeRangeEndFormat,
    timeGutterFormat: 'LT',
    monthHeaderFormat: 'MMMM YYYY',
    dayHeaderFormat: 'dddd MMM DD',
    dayRangeHeaderFormat: $ba6e2539d0024c3d$var$weekRangeFormat,
    agendaHeaderFormat: $ba6e2539d0024c3d$var$dateRangeFormat,
    agendaDateFormat: 'ddd MMM DD',
    agendaTimeFormat: 'LT',
    agendaTimeRangeFormat: $ba6e2539d0024c3d$var$timeRangeFormat
};
function $ba6e2539d0024c3d$var$fixUnit(unit) {
    var datePart = unit ? unit.toLowerCase() : unit;
    if (datePart === 'FullYear') datePart = 'year';
    else if (!datePart) datePart = undefined;
    return datePart;
}
function $ba6e2539d0024c3d$export$42f9cc272b1e62cd(dayjsLib) {
    // load dayjs plugins
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($13bb91f8f4cfae7d$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($15f8cfd78617715b$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($53dbf02e1c04a37c$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($0bb94353ccece6ea$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($bed1b736941ac624$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($2764ea4f1964f22a$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($2d81fd35d55e9c85$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($4cfde2e16cee3c00$exports))));
    var locale = function locale(dj, c) {
        return c ? dj.locale(c) : dj;
    };
    // if the timezone plugin is loaded,
    // then use the timezone aware version
    var dayjs = dayjsLib.tz ? dayjsLib.tz : dayjsLib;
    function getTimezoneOffset(date) {
        // ensures this gets cast to timezone
        return dayjs(date).toDate().getTimezoneOffset();
    }
    function getDstOffset(start, end) {
        var _st$tz$$x$$timezone;
        // convert to dayjs, in case
        var st = dayjs(start);
        var ed = dayjs(end);
        // if not using the dayjs timezone plugin
        if (!dayjs.tz) return st.toDate().getTimezoneOffset() - ed.toDate().getTimezoneOffset();
        /**
     * If a default timezone has been applied, then
     * use this to get the proper timezone offset, otherwise default
     * the timezone to the browser local
     */ var tzName = (_st$tz$$x$$timezone = st.tz().$x.$timezone) !== null && _st$tz$$x$$timezone !== void 0 ? _st$tz$$x$$timezone : dayjsLib.tz.guess();
        // invert offsets to be inline with moment.js
        var startOffset = -dayjs.tz(+st, tzName).utcOffset();
        var endOffset = -dayjs.tz(+ed, tzName).utcOffset();
        return startOffset - endOffset;
    }
    function getDayStartDstOffset(start) {
        var dayStart = dayjs(start).startOf('day');
        return getDstOffset(dayStart, start);
    }
    /*** BEGIN localized date arithmetic methods with dayjs ***/ function defineComparators(a, b, unit) {
        var datePart = $ba6e2539d0024c3d$var$fixUnit(unit);
        var dtA = datePart ? dayjs(a).startOf(datePart) : dayjs(a);
        var dtB = datePart ? dayjs(b).startOf(datePart) : dayjs(b);
        return [
            dtA,
            dtB,
            datePart
        ];
    }
    function startOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $ba6e2539d0024c3d$var$fixUnit(unit);
        if (datePart) return dayjs(date).startOf(datePart).toDate();
        return dayjs(date).toDate();
    }
    function endOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $ba6e2539d0024c3d$var$fixUnit(unit);
        if (datePart) return dayjs(date).endOf(datePart).toDate();
        return dayjs(date).toDate();
    }
    // dayjs comparison operations *always* convert both sides to dayjs objects
    // prior to running the comparisons
    function eq(a, b, unit) {
        var _defineComparators = defineComparators(a, b, unit), _defineComparators2 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators, 3), dtA = _defineComparators2[0], dtB = _defineComparators2[1], datePart = _defineComparators2[2];
        return dtA.isSame(dtB, datePart);
    }
    function neq(a, b, unit) {
        return !eq(a, b, unit);
    }
    function gt(a, b, unit) {
        var _defineComparators3 = defineComparators(a, b, unit), _defineComparators4 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators3, 3), dtA = _defineComparators4[0], dtB = _defineComparators4[1], datePart = _defineComparators4[2];
        return dtA.isAfter(dtB, datePart);
    }
    function lt(a, b, unit) {
        var _defineComparators5 = defineComparators(a, b, unit), _defineComparators6 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators5, 3), dtA = _defineComparators6[0], dtB = _defineComparators6[1], datePart = _defineComparators6[2];
        return dtA.isBefore(dtB, datePart);
    }
    function gte(a, b, unit) {
        var _defineComparators7 = defineComparators(a, b, unit), _defineComparators8 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators7, 3), dtA = _defineComparators8[0], dtB = _defineComparators8[1], datePart = _defineComparators8[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function lte(a, b, unit) {
        var _defineComparators9 = defineComparators(a, b, unit), _defineComparators0 = (0, $d2ac826ad8f89f3d$export$2e2bcd8739ae039)(_defineComparators9, 3), dtA = _defineComparators0[0], dtB = _defineComparators0[1], datePart = _defineComparators0[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function inRange(day, min, max) {
        var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'day';
        var datePart = $ba6e2539d0024c3d$var$fixUnit(unit);
        var djDay = dayjs(day);
        var djMin = dayjs(min);
        var djMax = dayjs(max);
        return djDay.isBetween(djMin, djMax, datePart, '[]');
    }
    function min(dateA, dateB) {
        var dtA = dayjs(dateA);
        var dtB = dayjs(dateB);
        var minDt = dayjsLib.min(dtA, dtB);
        return minDt.toDate();
    }
    function max(dateA, dateB) {
        var dtA = dayjs(dateA);
        var dtB = dayjs(dateB);
        var maxDt = dayjsLib.max(dtA, dtB);
        return maxDt.toDate();
    }
    function merge(date, time) {
        if (!date && !time) return null;
        var tm = dayjs(time).format('HH:mm:ss');
        var dt = dayjs(date).startOf('day').format('MM/DD/YYYY');
        // We do it this way to avoid issues when timezone switching
        return dayjs("".concat(dt, " ").concat(tm)).toDate();
    }
    function add(date, adder, unit) {
        var datePart = $ba6e2539d0024c3d$var$fixUnit(unit);
        return dayjs(date).add(adder, datePart).toDate();
    }
    function range(start, end) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $ba6e2539d0024c3d$var$fixUnit(unit);
        // because the add method will put these in tz, we have to start that way
        var current = dayjs(start).toDate();
        var days = [];
        while(lte(current, end)){
            days.push(current);
            current = add(current, 1, datePart);
        }
        return days;
    }
    function ceil(date, unit) {
        var datePart = $ba6e2539d0024c3d$var$fixUnit(unit);
        var floor = startOf(date, datePart);
        return eq(floor, date) ? floor : add(floor, 1, datePart);
    }
    function diff(a, b) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $ba6e2539d0024c3d$var$fixUnit(unit);
        // don't use 'defineComparators' here, as we don't want to mutate the values
        var dtA = dayjs(a);
        var dtB = dayjs(b);
        return dtB.diff(dtA, datePart);
    }
    function minutes(date) {
        var dt = dayjs(date);
        return dt.minute();
    }
    function firstOfWeek(culture) {
        var data = culture ? dayjsLib.localeData(culture) : dayjsLib.localeData();
        return data ? data.firstDayOfWeek() : 0;
    }
    function firstVisibleDay(date) {
        var firstDayOfMonth = dayjs(date).startOf('month');
        var firstDayOfWeek = dayjs(firstDayOfMonth).startOf('week');
        // special handling for leapyears until Dayjs patches it
        if (dayjs(firstDayOfMonth).isLeapYear()) {
            var day = firstDayOfMonth.toDate().getDay(), _diff = firstDayOfMonth.toDate().getDate() - day + (day == 0 ? -6 : 1);
            firstDayOfWeek.date(_diff);
        }
        return firstDayOfWeek.toDate();
    }
    function lastVisibleDay(date) {
        return dayjs(date).endOf('month').endOf('week').toDate();
    }
    function visibleDays(date) {
        var current = firstVisibleDay(date);
        var last = lastVisibleDay(date);
        var days = [];
        while(lte(current, last)){
            days.push(current);
            current = add(current, 1, 'd');
        }
        return days;
    }
    /*** END localized date arithmetic methods with dayjs ***/ /**
   * Moved from TimeSlots.js, this method overrides the method of the same name
   * in the localizer.js, using dayjs to construct the js Date
   * @param {Date} dt - date to start with
   * @param {Number} minutesFromMidnight
   * @param {Number} offset
   * @returns {Date}
   */ function getSlotDate(dt, minutesFromMidnight, offset) {
        return dayjs(dt).startOf('day').minute(minutesFromMidnight + offset).toDate();
    }
    // dayjs will automatically handle DST differences in it's calculations
    function getTotalMin(start, end) {
        return diff(start, end, 'minutes');
    }
    function getMinutesFromMidnight(start) {
        var dayStart = dayjs(start).startOf('day');
        var day = dayjs(start);
        return day.diff(dayStart, 'minutes') + getDayStartDstOffset(start);
    }
    // These two are used by DateSlotMetrics
    function continuesPrior(start, first) {
        var djStart = dayjs(start);
        var djFirst = dayjs(first);
        return djStart.isBefore(djFirst, 'day');
    }
    function continuesAfter(start, end, last) {
        var djEnd = dayjs(end);
        var djLast = dayjs(last);
        return djEnd.isSameOrAfter(djLast, 'minutes');
    }
    function daySpan(start, end) {
        var startDay = dayjs(start);
        var endDay = dayjs(end);
        return endDay.diff(startDay, 'day');
    }
    // These two are used by eventLevels
    function sortEvents(_ref6) {
        var _ref6$evtA = _ref6.evtA, aStart = _ref6$evtA.start, aEnd = _ref6$evtA.end, aAllDay = _ref6$evtA.allDay, _ref6$evtB = _ref6.evtB, bStart = _ref6$evtB.start, bEnd = _ref6$evtB.end, bAllDay = _ref6$evtB.allDay;
        var startSort = +startOf(aStart, 'day') - +startOf(bStart, 'day');
        var durA = daySpan(aStart, aEnd);
        var durB = daySpan(bStart, bEnd);
        return startSort || // sort by start Day first
        durB - durA || // events spanning multiple days go first
        !!bAllDay - !!aAllDay || // then allDay single day events
        +aStart - +bStart || // then sort by start time *don't need dayjs conversion here
        +aEnd - +bEnd // then sort by end time *don't need dayjs conversion here either
        ;
    }
    function inEventRange(_ref7) {
        var _ref7$event = _ref7.event, start = _ref7$event.start, end = _ref7$event.end, _ref7$range = _ref7.range, rangeStart = _ref7$range.start, rangeEnd = _ref7$range.end;
        var startOfDay = dayjs(start).startOf('day');
        var eEnd = dayjs(end);
        var rStart = dayjs(rangeStart);
        var rEnd = dayjs(rangeEnd);
        var startsBeforeEnd = startOfDay.isSameOrBefore(rEnd, 'day');
        // when the event is zero duration we need to handle a bit differently
        var sameMin = !startOfDay.isSame(eEnd, 'minutes');
        var endsAfterStart = sameMin ? eEnd.isAfter(rStart, 'minutes') : eEnd.isSameOrAfter(rStart, 'minutes');
        return startsBeforeEnd && endsAfterStart;
    }
    function isSameDate(date1, date2) {
        var dt = dayjs(date1);
        var dt2 = dayjs(date2);
        return dt.isSame(dt2, 'day');
    }
    /**
   * This method, called once in the localizer constructor, is used by eventLevels
   * 'eventSegments()' to assist in determining the 'span' of the event in the display,
   * specifically when using a timezone that is greater than the browser native timezone.
   * @returns number
   */ function browserTZOffset() {
        /**
     * Date.prototype.getTimezoneOffset horrifically flips the positive/negative from
     * what you see in it's string, so we have to jump through some hoops to get a value
     * we can actually compare.
     */ var dt = new Date();
        var neg = /-/.test(dt.toString()) ? '-' : '';
        var dtOffset = dt.getTimezoneOffset();
        var comparator = Number("".concat(neg).concat(Math.abs(dtOffset)));
        // dayjs correctly provides positive/negative offset, as expected
        var mtOffset = dayjs().utcOffset();
        return mtOffset > comparator ? 1 : 0;
    }
    return new $ba6e2539d0024c3d$export$193ddab16544ff5b({
        formats: $ba6e2539d0024c3d$var$formats,
        firstOfWeek: firstOfWeek,
        firstVisibleDay: firstVisibleDay,
        lastVisibleDay: lastVisibleDay,
        visibleDays: visibleDays,
        format: function format(value, _format, culture) {
            return locale(dayjs(value), culture).format(_format);
        },
        lt: lt,
        lte: lte,
        gt: gt,
        gte: gte,
        eq: eq,
        neq: neq,
        merge: merge,
        inRange: inRange,
        startOf: startOf,
        endOf: endOf,
        range: range,
        add: add,
        diff: diff,
        ceil: ceil,
        min: min,
        max: max,
        minutes: minutes,
        getSlotDate: getSlotDate,
        getTimezoneOffset: getTimezoneOffset,
        getDstOffset: getDstOffset,
        getTotalMin: getTotalMin,
        getMinutesFromMidnight: getMinutesFromMidnight,
        continuesPrior: continuesPrior,
        continuesAfter: continuesAfter,
        sortEvents: sortEvents,
        inEventRange: inEventRange,
        isSameDate: isSameDate,
        browserTZOffset: browserTZOffset
    });
}
var $ba6e2539d0024c3d$export$9b5ac10f59f76296 = {
    eventWrapper: $ba6e2539d0024c3d$var$NoopWrapper,
    timeSlotWrapper: $ba6e2539d0024c3d$var$NoopWrapper,
    dateCellWrapper: $ba6e2539d0024c3d$var$NoopWrapper
};



var $0e0a70d30729ab61$exports = {};
"use strict";

var $jdupM = parcelRequire("jdupM");
Object.defineProperty($0e0a70d30729ab61$exports, "__esModule", {
    value: true
});
$0e0a70d30729ab61$exports.default = void 0;

var $0e0a70d30729ab61$var$_withDragAndDrop = $jdupM((parcelRequire("8Dew7")));
var $0e0a70d30729ab61$var$_default = $0e0a70d30729ab61$exports.default = $0e0a70d30729ab61$var$_withDragAndDrop.default;



var $cdPdj = parcelRequire("cdPdj");
var $6f55b5ee9ae0e913$exports = {};
//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

(function(global, factory) {
    factory((parcelRequire("cdPdj")));
})($6f55b5ee9ae0e913$exports, function(moment) {
    'use strict';
    //! moment.js locale configuration
    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: "s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split('_'),
        weekdaysShort: "s\xf6n_m\xe5n_tis_ons_tor_fre_l\xf6r".split('_'),
        weekdaysMin: "s\xf6_m\xe5_ti_on_to_fr_l\xf6".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: "[Ig\xe5r] LT",
            nextWeek: "[P\xe5] dddd LT",
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: "f\xf6r %s sedan",
            s: "n\xe5gra sekunder",
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: "en m\xe5nad",
            MM: "%d m\xe5nader",
            y: "ett \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function ordinal(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? ':e' : b === 1 ? ':a' : b === 2 ? ':a' : b === 3 ? ':e' : ':e';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    return sv;
});











var $04f8145ae19fe6a6$var$DnDCalendar = (0, (/*@__PURE__*/$parcel$interopDefault($0e0a70d30729ab61$exports)))((0, $ba6e2539d0024c3d$export$e1aef45b828286de));
var $04f8145ae19fe6a6$var$CalendarBig = function(param) {
    var startEvents = param.startEvents, save = param.save, calType = param.calType, click = param.click, clickTime = param.clickTime, calendarHeight = param.calendarHeight;
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), selectedEvent = _useState[0], setSelectedEvent = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), hourFrom = _useState1[0], setHourFrom = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), minuteFrom = _useState2[0], setMinuteFrom = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), hourTo = _useState3[0], setHourTo = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), minuteTo = _useState4[0], setMinuteTo = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(startEvents), 2), events = _useState5[0], setEvents = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(startEvents.length + 1), 2), messageId = _useState6[0], setMessageId = _useState6[1];
    // From https://jquense.github.io/react-big-calendar/examples/index.html?path=/docs/addons-drag-and-drop-props--on-event-drop
    var localeLang = lang === "sv" ? "se" : "en-GB";
    (0, (/*@__PURE__*/$parcel$interopDefault($cdPdj))).locale(localeLang, {
        week: {
            dow: 1,
            doy: 1
        }
    });
    var localizer = (0, $ba6e2539d0024c3d$export$29814e003152ab50)((0, (/*@__PURE__*/$parcel$interopDefault($cdPdj))));
    var messages = {
        previous: "<",
        next: ">",
        today: lang === "sv" ? "Idag" : "Today",
        month: lang === "sv" ? "M\xe5nad" : "Month",
        week: lang === "sv" ? "Vecka" : "Week",
        work_week: lang === "sv" ? "Vecka" : "Week",
        day: "D",
        agenda: "*",
        date: lang === "sv" ? "Datum" : "Date",
        time: "H"
    };
    var saveEvent = function(remove, event) {
        if (remove && event.dbId === 0) return;
        var data = {
            event: event,
            remove: remove
        };
        setSelectedEvent(null);
        api.post("coach/availability/edit", data).then(function(response) {
            if (remove) console.log("Removed " + event.dbId);
            else {
                var newId = response.json.id;
                if (newId !== event.dbId) {
                    var newEvents = (0, $XnYkK._)(events);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = newEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var newEvent = _step.value;
                            if (newEvent.id === event.id) newEvent.dbId = newId;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    setEvents(newEvents);
                }
            }
            console.log("ok");
        });
    };
    var EmptyCustomToolbar = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {});
    };
    var getTypeTitle = function(title) {
        if (title === "R") return lang === "sv" ? "Varje vecka" : "Every week";
        else if (title === "A") return lang === "sv" ? "Tillg\xe4nglig" : "Available time";
        else if (title === "B") return lang === "sv" ? "Blockerad" : "Blocked";
        else if (title === "S") return lang === "sv" ? "Upptagen" : "Busy";
        else if (title === "M") return lang === "sv" ? "M\xf6te" : "Meeting";
    };
    var EventComponent = function(e) {
        var title = getTypeTitle(e.title);
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
            className: "font-medium",
            children: title
        });
    };
    var eventStyleGetter = function(e) {
        // console.log(e)
        var bg = "#94ABFF";
        if (e.title === "B") bg = "#FF6079";
        else if (e.title === "S") bg = "#EAF47F";
        else if (e.title === "M") bg = "#60B9A5";
        var style = {
            backgroundColor: bg,
            color: "#000"
        };
        return {
            style: style
        };
    };
    var getCalendarSettings = function() {
        var settings = {
            views: [
                "week",
                "month",
                "day"
            ],
            defaultView: "week",
            components: {},
            selectable: true,
            resizeable: true
        };
        if (calType === "recurring") {
            settings.views = [
                "work_week"
            ];
            settings.defaultView = "work_week";
            settings.components = {
                work_week: {
                    header: function(param) {
                        var date = param.date, localizer = param.localizer;
                        return localizer.format(date, "dddd");
                    }
                },
                toolbar: EmptyCustomToolbar,
                event: EventComponent
            };
        } else if (calType === "available") {
            settings.views = [
                "week"
            ];
            settings.defaultView = "week";
            settings.components = {
                event: EventComponent
            };
        } else if (calType === "summary") {
            settings.views = [
                "week",
                "month"
            ];
            settings.defaultView = "week";
            settings.components = {
                event: EventComponent
            };
            settings.selectable = false;
            settings.resizeable = false;
        } else if (calType === "book_meeting") {
            settings.views = [
                "work_week"
            ];
            settings.defaultView = "work_week";
            settings.components = {
                event: EventComponent
            };
            settings.selectable = false;
            settings.resizeable = false;
        } else if (calType === "book_meeting_free") {
            settings.views = [
                "week"
            ];
            settings.defaultView = "week";
            settings.components = {
                event: EventComponent
            };
            settings.selectable = true;
            settings.resizeable = false;
        }
        return settings;
    };
    var settings = getCalendarSettings();
    var addEvent = function(e) {
        if (save) {
            var newEvents = (0, $XnYkK._)(events);
            var newEvent = {
                id: messageId,
                dbId: 0,
                start: e.start,
                end: e.end,
                title: "A"
            };
            newEvents.push(newEvent);
            // console.log('addEvent for id ' + messageId)
            setMessageId(messageId + 1);
            setEvents(newEvents);
            // setSelectedEvent(newEvent)
            openEvent(newEvent);
        } else if (clickTime) clickTime(e.start);
        else console.log("Not supposed to add stuff");
    };
    var openEvent = function(e) {
        setHourFrom(e.start.getHours());
        setMinuteFrom(e.start.getMinutes());
        setHourTo(e.end.getHours());
        setMinuteTo(e.end.getMinutes());
        setSelectedEvent(e);
    };
    var editEvent = function(e) {
        if (click) click(e);
        else {
            console.log(e);
            openEvent(e);
        }
    };
    var onChangeEvent = function(e) {
        var newEvents = (0, $XnYkK._)(events);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var le = _step.value;
                if (le.id === e.event.id) {
                    le.start = e.start;
                    le.end = e.end;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setEvents(newEvents);
        saveEvent(false, e.event);
    };
    var saveFromModal = function() {
        saveEvent(false, selectedEvent);
    };
    var removeEvent = function() {
        var newEvents = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var le = _step.value;
                if (le.id != selectedEvent.id) newEvents.push(le);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setEvents(newEvents);
        saveEvent(true, selectedEvent);
        setSelectedEvent(null);
    };
    var calHeight = calendarHeight ? calendarHeight : window.innerHeight - 240;
    var scrollToTime = new Date();
    scrollToTime.setHours(7);
    scrollToTime.setMinutes(0);
    scrollToTime.setSeconds(0);
    // const handleSelectedDay = (d: Date) => {
    //   const newEvent = selectedEvent;
    //   newEvent.start = new Date(
    //     d.getFullYear(),
    //     d.getMonth(),
    //     d.getDate(),
    //     selectedEvent.start.getHours(),
    //     selectedEvent.start.getMinutes(),
    //     0
    //   );
    //   newEvent.end = new Date(
    //     d.getFullYear(),
    //     d.getMonth(),
    //     d.getDate(),
    //     selectedEvent.end.getHours(),
    //     selectedEvent.end.getMinutes(),
    //     0
    //   );
    //   setSelectedEvent(newEvent);
    //
    //   // Update the list of events for calendar
    //   const newEvents = [...events];
    //   for (let le of newEvents) {
    //     if (le.id === newEvent.id) {
    //       le.start = newEvent.start;
    //       le.end = newEvent.end;
    //     }
    //   }
    //   setEvents(newEvents);
    // };
    var setTime = function(e, t) {
        var hourMinute = e.currentTarget.value.split(":");
        var hour = parseInt(hourMinute[0]);
        var minute = parseInt(hourMinute[1]);
        var newEvent = selectedEvent;
        if (t === "from") {
            setHourFrom(hour);
            setMinuteFrom(minute);
            newEvent.start.setHours(hour, minute);
        } else if (t === "to") {
            setHourTo(hour);
            setMinuteTo(minute);
            newEvent.end.setHours(hour, minute);
        }
        setSelectedEvent(newEvent);
        // Update the list of events for calendar
        var newEvents = (0, $XnYkK._)(events);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var le = _step.value;
                if (le.id === newEvent.id) {
                    le.start = newEvent.start;
                    le.end = newEvent.end;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setEvents(newEvents);
    };
    var makeRange = function(from) {
        var range = [];
        var hour;
        var minute;
        var hourEnd;
        var minuteEnd;
        if (from) {
            hour = 0;
            minute = 0;
            hourEnd = hourTo;
            minuteEnd = minuteTo;
        } else {
            hour = hourFrom;
            minute = minuteFrom;
            hourEnd = 24;
            minuteEnd = 0;
        }
        var minutesEnd = hourEnd * 60 + minuteEnd;
        while(hour * 60 + minute < minutesEnd){
            range.push((0, $7d185b5883a21821$export$728c8e2d6789728)(hour) + ":" + (0, $7d185b5883a21821$export$728c8e2d6789728)(minute));
            if (minute === 45) {
                minute = 0;
                hour++;
            } else minute += 15;
        }
        return range;
    };
    var changeSelectedEvent = function(e) {
        var newSelectedEvent = (0, $hwO3w._)({}, selectedEvent);
        newSelectedEvent.title = e.target.value;
        setSelectedEvent(newSelectedEvent);
        var newEvents = (0, $XnYkK._)(events);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$e = _step.value;
                if (_$e.id === newSelectedEvent.id) _$e.title = newSelectedEvent.title;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setEvents(newEvents);
    };
    var handleChangedDate = function(date, view, action) {
        if (view !== "week") return;
        var days = action === "NEXT" ? 7 : -7;
        var newEvents = (0, $XnYkK._)(events);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var event = _step.value;
                if (event.title === "R") {
                    event.start = (0, $7d185b5883a21821$export$dd412b56f1e4d8aa)(event.start, days);
                    event.end = (0, $7d185b5883a21821$export$dd412b56f1e4d8aa)(event.end, days);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setEvents(newEvents);
    };
    var showAvailabilityHeader = function() {
        if (selectedEvent.title === "A") return lang === "sv" ? "Tillg\xe4nglighet f\xf6r: " : "Availability for:";
        else if (selectedEvent.title === "R") return lang === "sv" ? "Varje vecka: " : "Every week:";
        else if (selectedEvent.title === "B") return lang === "sv" ? "Blockerad tid: " : "Blocked time:";
        else if (selectedEvent.title === "M") return lang === "sv" ? "M\xf6te: " : "Meeting:";
        else if (selectedEvent.title === "S") return lang === "sv" ? "Upptagen (enligt din kalender): " : "Busy (according to your calendar):";
    };
    var renderPopupModal = function() {
        if (calType === "available") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: selectedEvent != null,
            onClose: function() {
                return saveFromModal();
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return saveFromModal();
                    },
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                        children: [
                            lang === "sv" ? "Tillg\xe4nglighet f\xf6r: " : "Availability for: ",
                            selectedEvent.title === "R" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                children: [
                                    (0, $8872f0a5a4c34fff$export$c56d8f67a12422b1)[selectedEvent.start.getDay() - 1],
                                    lang === "sv" ? "ar" : "s"
                                ]
                            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                                children: (0, $7d185b5883a21821$export$ff9a5f6f7fb9966b)(selectedEvent.start, lang, true)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    className: "icon",
                                    alt: "date",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bf234ba9a155a985$exports)))
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "ml-2 text-xl font-medium w-full",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("select", {
                                        className: "z-select z-700 w-full",
                                        value: selectedEvent.title,
                                        onChange: function(e) {
                                            return changeSelectedEvent(e);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                                value: "A",
                                                children: lang === "sv" ? "Tillg\xe4nglig tid" : "Available time"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                                value: "R",
                                                children: lang === "sv" ? "Tillg\xe4nglig veckovis" : "Available weekly"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                                value: "B",
                                                children: lang === "sv" ? "Blockera tid" : "Block time"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center justify-between mt-4",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    className: "icon",
                                    alt: "date",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports)))
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                                    value: (0, $7d185b5883a21821$export$728c8e2d6789728)(hourFrom) + ":" + (0, $7d185b5883a21821$export$728c8e2d6789728)(minuteFrom),
                                    className: "ml-2 z-select z-700",
                                    onChange: function(e) {
                                        return setTime(e, "from");
                                    },
                                    children: makeRange(true).map(function(hour) {
                                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                            value: hour,
                                            children: hour
                                        }, "hour_from_" + hour);
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mx-2",
                                    children: "\u2013"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                                    value: (0, $7d185b5883a21821$export$728c8e2d6789728)(hourTo) + ":" + (0, $7d185b5883a21821$export$728c8e2d6789728)(minuteTo),
                                    className: "z-select z-700",
                                    onChange: function(e) {
                                        return setTime(e, "to");
                                    },
                                    children: makeRange(false).map(function(hour) {
                                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                            value: hour,
                                            children: hour
                                        }, "hour_to_" + hour);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "w-full flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: "outlineWhiteBase",
                                className: "w-full",
                                onClick: function() {
                                    return removeEvent();
                                },
                                children: t("delete")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: "blueBase",
                                className: "ml-4 w-full",
                                onClick: function() {
                                    return saveFromModal();
                                },
                                children: t("save")
                            })
                        ]
                    })
                })
            ]
        });
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: selectedEvent != null,
            onClose: function() {
                return setSelectedEvent(null);
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return setSelectedEvent(null);
                    },
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                        children: [
                            showAvailabilityHeader(),
                            "\xa0",
                            selectedEvent.title === "R" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                children: [
                                    (0, $8872f0a5a4c34fff$export$c56d8f67a12422b1)[selectedEvent.start.getDay() - 1],
                                    lang === "sv" ? "ar" : "s"
                                ]
                            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                                children: (0, $7d185b5883a21821$export$ff9a5f6f7fb9966b)(selectedEvent.start, lang, true)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                className: "icon",
                                alt: "date",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports)))
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "ml-4",
                                children: selectedEvent.start.getDate() === selectedEvent.end.getDate() ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                    children: [
                                        (0, $7d185b5883a21821$export$728c8e2d6789728)(hourFrom),
                                        ":",
                                        (0, $7d185b5883a21821$export$728c8e2d6789728)(minuteFrom),
                                        "\u2013",
                                        (0, $7d185b5883a21821$export$728c8e2d6789728)(hourTo),
                                        ":",
                                        (0, $7d185b5883a21821$export$728c8e2d6789728)(minuteTo)
                                    ]
                                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                    children: [
                                        (0, $7d185b5883a21821$export$1c7501cd03a59e59)(selectedEvent.start, true, lang),
                                        "\u2013",
                                        (0, $7d185b5883a21821$export$1c7501cd03a59e59)(selectedEvent.end, true, lang)
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            selectedEvent != null && renderPopupModal(),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "bg-neutral-900 text-white font-hoves",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($04f8145ae19fe6a6$var$DnDCalendar, {
                    components: settings.components,
                    views: settings.views,
                    defaultView: settings.defaultView,
                    localizer: localizer,
                    messages: messages,
                    scrollToTime: scrollToTime,
                    events: events,
                    startAccessor: "start",
                    endAccessor: "end",
                    logPressThreshold: 1,
                    style: {
                        height: calHeight
                    },
                    draggableAccessor: function() {
                        return save;
                    },
                    resizableAccessor: function() {
                        return save;
                    },
                    onSelectSlot: function(e) {
                        return addEvent(e);
                    },
                    onEventDrop: function(e) {
                        return onChangeEvent(e);
                    },
                    onEventResize: function(e) {
                        return onChangeEvent(e);
                    },
                    onSelectEvent: function(e) {
                        return editEvent(e);
                    },
                    onNavigate: function(date, view, action) {
                        return handleChangedDate(date, view, action);
                    },
                    eventPropGetter: eventStyleGetter,
                    selectable: settings.selectable,
                    popup: true,
                    resizable: settings.resizeable,
                    culture: lang,
                    step: 30,
                    showMultiDayTimes: true
                })
            })
        ]
    });
};
var $04f8145ae19fe6a6$export$2e2bcd8739ae039 = $04f8145ae19fe6a6$var$CalendarBig;


var $bba3de5a718626a6$export$2e2bcd8739ae039 = (0, $04f8145ae19fe6a6$export$2e2bcd8739ae039);


var $0c1340ed2ac599c6$var$BookMeetingFree = function(param) {
    var meeting = param.meeting, clientId = param.clientId, close = param.close, lang = param.lang, remainingCredits = param.remainingCredits;
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), txt = _useState[0], setTxt = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), booked = _useState1[0], setBooked = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), confirm = _useState2[0], setConfirm = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState3[0], setLoaded = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), newStartTime = _useState4[0], setNewStartTime = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), avails = _useState5[0], setAvails = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), clientAgreed = _useState6[0], setClientAgreed = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), newHour = _useState7[0], setNewHour = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), newMinute = _useState8[0], setNewMinute = _useState8[1];
    var today = new Date();
    var hours = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23
    ];
    var minutes = [
        0,
        5,
        10,
        15,
        20,
        25,
        30,
        35,
        40,
        45,
        50,
        55
    ];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(meeting ? meeting.length : 30), 2), meetingLength = _useState9[0], setMeetingLength = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), meetingLengths = _useState10[0], setMeetingLengths = _useState10[1];
    var remainingMinutes = remainingCredits ? remainingCredits : meeting ? meeting.remainingCredits : null;
    (0, $5s1kH.useEffect)(function() {
        if (remainingMinutes) {
            var _meetingLengths = [];
            for(var _i = 0, _iter = [
                30,
                45,
                60,
                90
            ]; _i < _iter.length; _i++){
                var l = _iter[_i];
                if (l <= remainingMinutes) _meetingLengths.push(l);
            }
            setMeetingLengths(_meetingLengths);
        }
        api.get('coach/availability/get?summary=1').then(function(result) {
            var availableEvents = [];
            var id = 1;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = result.json.available[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var available = _step.value;
                    var from = new Date(available.from);
                    var to = new Date(available.to);
                    if (available.title === 'R') {
                        from = (0, $7d185b5883a21821$export$77b0033b88d4485c)(today, from);
                        to = (0, $7d185b5883a21821$export$77b0033b88d4485c)(today, to);
                    }
                    availableEvents.push({
                        id: id,
                        dbId: available.id,
                        title: available.title,
                        start: from,
                        end: to
                    });
                    id++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            setAvails(availableEvents);
            setLoaded(true);
        });
    }, []);
    var doBook = function() {
        var changedTime = newStartTime;
        if (!changedTime || !meeting) return;
        changedTime.setHours(newHour);
        changedTime.setMinutes(newMinute);
        var data = {
            id: meeting.id,
            client_id: clientId,
            from: changedTime,
            length: meetingLength,
            message: txt
        };
        api.post("coach/meeting/book", data).then(function(response) {
            if (response.json.error) alert(response.json.error);
            else setBooked(true);
        });
    };
    var showContent = function() {
        if (booked) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "my-12 flex justify-center items-center",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        className: "icon-xl",
                        alt: "check",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6c066964533a9345$exports)))
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "text-neutral-300",
                    children: [
                        t("your-meeting-has"),
                        " ",
                        (meeting === null || meeting === void 0 ? void 0 : meeting.id) === "0" ? t("been-booked") : t("been-changed"),
                        " ",
                        t("client-is-notified")
                    ]
                })
            ]
        });
        else if (newStartTime) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "font-medium",
                    children: [
                        meeting === null || meeting === void 0 ? void 0 : meeting.firstName,
                        " ",
                        meeting === null || meeting === void 0 ? void 0 : meeting.lastName
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            alt: "calendar",
                            className: "icon",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports)))
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "ml-2",
                            children: (0, $7d185b5883a21821$export$1c7501cd03a59e59)(newStartTime, false, lang)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            className: "icon",
                            alt: "Time",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports)))
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "ml-2 flex",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                                    value: newHour,
                                    className: "z-select sm",
                                    onChange: function(e) {
                                        return setNewHour(parseInt(e.target.value));
                                    },
                                    children: hours.map(function(h) {
                                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                            value: h,
                                            children: (0, $7d185b5883a21821$export$728c8e2d6789728)(h)
                                        }, "hour_" + h);
                                    })
                                }),
                                "\xa0:\xa0",
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                                    value: newMinute,
                                    className: "z-select sm",
                                    onChange: function(e) {
                                        return setNewMinute(parseInt(e.target.value));
                                    },
                                    children: minutes.map(function(m) {
                                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                            value: m,
                                            children: (0, $7d185b5883a21821$export$728c8e2d6789728)(m)
                                        }, "minute_" + m);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "ml-4",
                            children: [
                                lang === "sv" ? "M\xf6tesl\xe4ngd" : "Meeting length",
                                ":"
                            ]
                        }),
                        meetingLengths.length > 1 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "ml-2",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                                value: meetingLength,
                                className: "z-select sm",
                                onChange: function(e) {
                                    return setMeetingLength(parseInt(e.target.value));
                                },
                                children: meetingLengths.map(function(m) {
                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                        value: m,
                                        children: m
                                    }, "l_" + m);
                                })
                            })
                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "ml-2",
                            children: meetingLength
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "ml-1",
                            children: "min"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 flex items-center",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        onClick: function() {
                            return setClientAgreed(!clientAgreed);
                        },
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                            checked: clientAgreed,
                            id: "_agreed",
                            label: lang === "sv" ? "Avst\xe4mt med klient" : "Confirmed with client"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                        value: txt,
                        className: "z-input z-700 h-24",
                        placeholder: t("write-message-to-client"),
                        onChange: function(e) {
                            return setTxt(e.target.value);
                        },
                        autoComplete: "off"
                    })
                })
            ]
        });
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {});
    };
    (0, $5s1kH.useEffect)(function() {
        if (newStartTime) {
            setNewHour(newStartTime.getHours());
            setNewMinute(newStartTime.getMinutes());
            setConfirm(true);
        }
    }, [
        newStartTime
    ]);
    var showConfirmText = function() {
        if (booked) {
            if ((meeting === null || meeting === void 0 ? void 0 : meeting.id) === "0") {
                if (lang === "sv") return "M\xf6tet har bokats";
                else return "The meeting has been booked";
            } else {
                if (lang === "sv") return "M\xf6tet har \xe4ndrats";
                else return "The meeting has been changed";
            }
        } else if ((meeting === null || meeting === void 0 ? void 0 : meeting.id) === "0") {
            if (lang === "sv") return "Bekr\xe4fta bokning";
            else return "Confirm meeting";
        } else {
            if (lang === "sv") return "Bekr\xe4fta \xe4ndring";
            else return "Confirm change";
        }
    };
    var clickTime = function(start) {
        if (start < today) alert("You can't set a start time that has already passed");
        else setNewStartTime(start);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: confirm,
                onClose: function() {
                    return setConfirm(false);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                        onClose: function() {
                            return setConfirm(false);
                        },
                        children: showConfirmText()
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: showContent()
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                        children: booked ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            className: "w-full",
                            onClick: function() {
                                return close(booked);
                            },
                            children: "Ok"
                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            className: "w-full",
                            onClick: function() {
                                return doBook();
                            },
                            disabled: !clientAgreed,
                            children: (meeting === null || meeting === void 0 ? void 0 : meeting.id) === "0" ? t("book-meeting") : t("change-meeting")
                        })
                    })
                ]
            }),
            meeting && meeting.id != "0" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-2xl mt-4 font-medium",
                        children: lang === "sv" ? "\xc4ndra datum och tid" : "Change date and time"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 p-4 bg-neutral-700 text-white rounded border border-neutral-500",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex justify-betwen items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "font-medium",
                                        children: t("original-booking")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "flex flex-grow justify-end",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            className: "cursor-pointer",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                                            alt: "close",
                                            onClick: function() {
                                                return close(false);
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mt-4 flex items-center text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        children: [
                                            meeting.firstName,
                                            " ",
                                            meeting.lastName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "ml-4 flex",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                                className: "icon",
                                                alt: "cal"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                className: "ml-1",
                                                children: (0, $7d185b5883a21821$export$1c7501cd03a59e59)(meeting.startDate, false, lang)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "ml-4 flex",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports))),
                                                className: "icon",
                                                alt: "cal"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                className: "ml-1",
                                                children: [
                                                    (0, $7d185b5883a21821$export$5f885a9374f8e024)(meeting.startDate),
                                                    " -",
                                                    " ",
                                                    (0, $7d185b5883a21821$export$5f885a9374f8e024)((0, $7d185b5883a21821$export$2287e3d29250119e)(meeting.startDate, meeting.length))
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4",
                                children: lang === "sv" ? "Klicka i kalendern f\xf6r att v\xe4lja ny tid" : "Click in the calendar to select new time"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4",
                        children: "\xa0"
                    })
                ]
            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-2xl mt-4 font-medium",
                        children: lang === "sv" ? "Boka nytt m\xf6te" : "Book new meeting"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 p-4 bg-neutral-700 text-white rounded border border-neutral-500",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex justify-betwen items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "font-medium",
                                        children: [
                                            meeting === null || meeting === void 0 ? void 0 : meeting.firstName,
                                            " ",
                                            meeting === null || meeting === void 0 ? void 0 : meeting.lastName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "flex flex-grow justify-end",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            className: "cursor-pointer",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                                            alt: "close",
                                            onClick: function() {
                                                return close(false);
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4",
                                children: lang === "sv" ? "Klicka i kalendern f\xf6r att v\xe4lja tid" : "Click in the calendar to select time"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4",
                        children: "\xa0"
                    })
                ]
            }),
            loaded ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bba3de5a718626a6$export$2e2bcd8739ae039), {
                startEvents: avails,
                save: false,
                calType: "book_meeting_free",
                clickTime: clickTime,
                calendarHeight: window.innerHeight - 360
            }, "cal_r") : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                children: lang === "sv" ? "Laddar kalender..." : "Loading calendar..."
            })
        ]
    });
};
var $0c1340ed2ac599c6$export$2e2bcd8739ae039 = $0c1340ed2ac599c6$var$BookMeetingFree;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");







var $28d0d992580243b2$var$CancelMeeting = function(param) {
    var meeting = param.meeting, close = param.close, lang = param.lang;
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(''), 2), txt = _useState[0], setTxt = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), cancelled = _useState1[0], setCancelled = _useState1[1];
    var doCancel = function() {
        var data = {
            id: meeting.id,
            message: txt
        };
        api.post('coach/meeting/cancel', data, [
            "meeting_not_found"
        ]).then(function(response) {
            setCancelled(true);
        }).catch(function(response) {
            if (response.isExpectedError) alert('We could not find this meeting. Reload page to see if meeting has already been removed');
        });
    };
    var showContent = function() {
        if (cancelled) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "my-12 flex justify-center items-center",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        className: "icon-xl",
                        alt: "check",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6c066964533a9345$exports)))
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "text-neutral-300",
                    children: lang === 'sv' ? "Ditt m\xf6te har avbokats och din klient uppdaterats." : 'Your meeting has been cancelled and your client is notified.'
                })
            ]
        });
        else {
            var endTime = (0, $7d185b5883a21821$export$212a2e732fe26c47)(meeting.startDate, meeting.length);
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "font-medium",
                        children: [
                            meeting.firstName,
                            " ",
                            meeting.lastName
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                alt: "calendar",
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports)))
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "ml-2",
                                children: (0, $7d185b5883a21821$export$1c7501cd03a59e59)(meeting.startDate, false, lang)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                className: "icon",
                                alt: "Time",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports)))
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                className: "ml-2",
                                children: [
                                    (0, $7d185b5883a21821$export$5f885a9374f8e024)(meeting.startDate),
                                    " - ",
                                    (0, $7d185b5883a21821$export$5f885a9374f8e024)(endTime)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                            value: txt,
                            className: "z-input z-700 h-24",
                            placeholder: lang === 'sv' ? "Skriv meddelande till klienten..." : "Write a message to the client...",
                            onChange: function(e) {
                                return setTxt(e.target.value);
                            },
                            autoComplete: "off"
                        })
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: true,
        onClose: function() {
            return close(cancelled);
        },
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: function() {
                    return close(cancelled);
                },
                children: cancelled ? lang === 'sv' ? "M\xf6tet har avbokats" : "The meeting has been cancelled" : lang === 'sv' ? "Bekr\xe4fta avbokning" : "Confirm cancellation"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: showContent()
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                children: cancelled ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    className: "w-full",
                    onClick: function() {
                        return close(cancelled);
                    },
                    children: "Ok"
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    className: "w-full",
                    onClick: function() {
                        return doCancel();
                    },
                    children: lang === 'sv' ? "Avboka m\xf6te" : 'Cancel meeting'
                })
            })
        ]
    });
};
var $28d0d992580243b2$export$2e2bcd8739ae039 = $28d0d992580243b2$var$CancelMeeting;



var $ed37a5b9dd08efd9$var$CoachHome = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)({
        name: "None",
        meetings: [],
        onboarded: null,
        availability: 0,
        completeProfiles: 0
    }), 2), data = _useState1[0], setData = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), selectedMeeting = _useState2[0], setSelectedMeeting = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showCancelMeeting = _useState3[0], setShowCancelMeeting = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showChangeMeeting = _useState4[0], setShowChangeMeeting = _useState4[1];
    var wide = window.innerWidth > 1100;
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (loaded) getData();
    }, [
        lang
    ]);
    var getData = function() {
        var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        var url = 'coach/start';
        if (timezone) url += '?tz=' + timezone;
        api.get(url, [
            "coach_not_found"
        ]).then(function(response) {
            if (response.json.error === 'not_applied' || response.json.error === 'not_onboarded') {
                navigate('/application');
                return;
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = response.json.meetings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var m = _step.value;
                    m.startDate = new Date(m.start);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            setData(response.json);
            setLoaded(true);
        }).catch(function(error) {
            if (error.isExpectedError) alert(error.json.message);
            else alert('Unknown error (http status ' + error.response.status + ')');
        });
    };
    var calculateMeetingsToday = function() {
        var midnight = new Date();
        midnight.setHours(23);
        midnight.setMinutes(59);
        var meetingsToday = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = data.meetings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var m = _step.value;
                if (m.startDate < midnight) meetingsToday++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (meetingsToday === 0) return t("no-meetings-today");
        else if (meetingsToday === 1) return t("one-meetings-today");
        else return t("you-have") + " " + meetingsToday + " " + t("meetings-today");
    };
    var calculateEndTime = function(start, l) {
        return new Date(start.getTime() + l * 60000);
    };
    var clickChangeMeeting = function(meeting) {
        setSelectedMeeting(meeting);
        setShowChangeMeeting(true);
    };
    var clickCancelMeeting = function(meeting) {
        setSelectedMeeting(meeting);
        setShowCancelMeeting(true);
    };
    var closeCancelMeeting = function(changed) {
        setShowCancelMeeting(false);
        if (changed) getData();
    };
    var closeChangeMeeting = function(changed) {
        setShowChangeMeeting(false);
        if (changed) getData();
    };
    var goToMeeting = function(meetingId) {
        if (api.apiToken) (0, $4bf2b0595575af5a$export$68c1f516bbed5123)(meetingId, api.apiToken, "coach");
        else alert("Fatal error - missing token");
    };
    var showNextMeetings = function() {
        if (data.meetings.length < 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {});
        else {
            var now = new Date();
            var meeting = data.meetings[0];
            var endTime = calculateEndTime(meeting.startDate, meeting.length);
            var meetingToday = (0, $7d185b5883a21821$export$a8b2a21161763694)(now, meeting.startDate);
            var moreMeetings = [];
            for(var i = 1; i < data.meetings.length; i++)moreMeetings.push(data.meetings[i]);
            var popItems = [
                {
                    title: t('to-meeting'),
                    click: function() {
                        return goToMeeting(meeting.id);
                    }
                },
                {
                    title: t('change-meeting'),
                    click: function() {
                        return clickChangeMeeting(meeting);
                    }
                },
                {
                    title: t('cancel-meeting'),
                    click: function() {
                        return clickCancelMeeting(meeting);
                    }
                }
            ];
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "rounded-lg mt-6 p-4 w-full bg-neutral-800",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "font-medium",
                            children: meetingToday ? t('today') : t('next-meeting')
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    className: "text-xl z-link",
                                    onClick: function() {
                                        return navigate('/clients/' + meeting.clientId);
                                    },
                                    children: [
                                        meeting.firstName,
                                        " ",
                                        meeting.lastName
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "flex items-center mt-2",
                                            children: [
                                                !meetingToday && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                            alt: "Date",
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                                            className: "icon-lg"
                                                        }),
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                            className: "mx-2",
                                                            children: (0, $7d185b5883a21821$export$1c7501cd03a59e59)(meeting.startDate, false, lang)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                    className: "icon-lg",
                                                    alt: "Time",
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports)))
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                    className: "ml-2 text-sm font-medium",
                                                    children: [
                                                        (0, $7d185b5883a21821$export$5f885a9374f8e024)(meeting.startDate),
                                                        " - ",
                                                        (0, $7d185b5883a21821$export$5f885a9374f8e024)(endTime)
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                                            items: popItems
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-4 mb-2 flex justify-evenly",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        onClick: function() {
                                            return goToMeeting(meeting.id);
                                        },
                                        className: "w-full",
                                        buttonType: "outlineWhiteBase",
                                        children: t('to-meeting')
                                    })
                                })
                            ]
                        }),
                        moreMeetings.filter(function(m) {
                            return (0, $7d185b5883a21821$export$a8b2a21161763694)(m.startDate, meeting.startDate);
                        }).map(function(m, i) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "text-sm z-link w-32",
                                                onClick: function() {
                                                    return navigate("/clients/".concat(m.clientId));
                                                },
                                                children: [
                                                    m.firstName,
                                                    " ",
                                                    m.lastName
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "flex items-center ml-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                        className: "ml-2 picture-xs",
                                                        alt: "Time",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports)))
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                        className: "ml-2 text-sm font-medium",
                                                        children: [
                                                            (0, $7d185b5883a21821$export$5f885a9374f8e024)(m.startDate),
                                                            "\u2013",
                                                            (0, $7d185b5883a21821$export$5f885a9374f8e024)(calculateEndTime(m.startDate, m.length))
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                                        items: [
                                            {
                                                title: t('to-meeting'),
                                                click: function() {
                                                    return goToMeeting(m.id);
                                                }
                                            },
                                            {
                                                title: t('change-booking'),
                                                click: function() {
                                                    return clickChangeMeeting(m);
                                                }
                                            },
                                            {
                                                title: t('cancel-booking'),
                                                click: function() {
                                                    return clickCancelMeeting(m);
                                                }
                                            }
                                        ]
                                    })
                                ]
                            }, "more_" + i);
                        })
                    ]
                })
            });
        }
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h2", {
            children: "Loading..."
        })
    });
    if (data.onboarded === null) navigate('/onboarding');
    if (showChangeMeeting && selectedMeeting) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0c1340ed2ac599c6$export$2e2bcd8739ae039), {
            meeting: selectedMeeting,
            clientId: selectedMeeting.clientId,
            close: closeChangeMeeting,
            lang: lang
        })
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            showCancelMeeting && selectedMeeting && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $28d0d992580243b2$export$2e2bcd8739ae039), {
                lang: lang,
                meeting: selectedMeeting,
                close: closeCancelMeeting
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("h1", {
                className: "text-3xl mt-4 font-medium text-white",
                children: [
                    t("hi"),
                    " ",
                    data.name
                ]
            }),
            data.completeProfiles < 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "rounded-lg mt-6 p-4 w-full bg-neutral-800 border border-cherry-500",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                                alt: "alert"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "ml-2 font-medium text-white",
                                children: t("complete-profiles")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mt-4",
                        children: lang === 'sv' ? "F\xe4rdigst\xe4ll din coachprofil s\xe5 att klienter kan v\xe4lja dig." : "Complete your coach profile so clients can choose you."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        onClick: function() {
                            return navigate('/profile');
                        },
                        className: "mt-4",
                        buttonType: "dangerBase",
                        children: t("go-to-profile")
                    })
                ]
            }),
            data.availability < 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "rounded-lg mt-6 p-4 w-full bg-neutral-800 border border-cherry-500",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                                alt: "alert"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "ml-2 font-medium text-white",
                                children: t("add-more-availability")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mt-4",
                        children: lang === 'sv' ? "L\xe4gg till m\xf6testider s\xe5 att dina klienter kan boka m\xf6ten med dig." : "Add your meeting times so clients can book meetings with you."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        onClick: function() {
                            return navigate('/availability');
                        },
                        className: "mt-4",
                        buttonType: "dangerBase",
                        children: t("go-to-availability")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-4",
                children: calculateMeetingsToday()
            }),
            showNextMeetings()
        ]
    });
};
var $ed37a5b9dd08efd9$export$2e2bcd8739ae039 = $ed37a5b9dd08efd9$var$CoachHome;



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");





var $5a265b004045b943$exports = {};
$5a265b004045b943$exports = $parcel$resolve("iz9Ol");










function $7f7604e8a9f9f6b6$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showConfirmDelete = _useState1[0], setShowConfirmDelete = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(), 2), profile = _useState2[0], setProfile = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), selectedLanguage = _useState3[0], setSelectedLanguage = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), profileNative = _useState4[0], setProfileNative = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), profileIntro = _useState5[0], setProfileIntro = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), profileAboutMe = _useState6[0], setProfileAboutMe = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), profileCoachingAreas = _useState7[0], setProfileCoachingAreas = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), profileIndustryExperience = _useState8[0], setProfileIndustryExperience = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), profileClientIndustries = _useState9[0], setProfileClientIndustries = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), profilePhilosophy = _useState10[0], setProfilePhilosophy = _useState10[1];
    var _useState11 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), picture = _useState11[0], setPicture = _useState11[1];
    var _useState12 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState12[0], setError = _useState12[1];
    var setGlobalToast = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$12972e612ad7cf0));
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var coachLanguages = [
        "cs",
        "da",
        "nl",
        "en",
        "fi",
        "fr",
        "de",
        "el",
        "hu",
        "it",
        "no",
        "pl",
        "pt",
        "es",
        "sv",
        "lt"
    ];
    (0, $5s1kH.useEffect)(function() {
        api.get('coach/profile').then(function(result) {
            setProfile(result.json.profile);
            if (result.json.profile.languages.length > 0) {
                var firstLang = result.json.profile.languages[0];
                setInputFromLanguage(firstLang);
            }
            setLoaded(true);
        });
    }, []);
    var checkAllInput = function(languages) {
        var _error = "";
        if (!(profile === null || profile === void 0 ? void 0 : profile.picture)) _error += lang === 'sv' ? "Du m\xe5ste ladda upp en profilbild.\n" : 'You must upload a profile picture.\n';
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = languages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var l = _step.value;
                var empty = 0;
                if (l.intro.length < 1 || l.aboutMe.length < 1 || l.philosophy.length < 1) empty++;
                if (empty > 0) {
                    _error += lang === 'sv' ? "Du m\xe5ste fylla i alla f\xe4lt markede med * f\xf6r " : 'You must fill out all fields marked with * in ';
                    _error += t(l.language) + '.\n';
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _error;
    };
    var save = function() {
        if (!profile || !profile.languages) return;
        // The pain! To ensure we get the latest changes, we need to look at both profile.languages and e.g profileIntro
        var languages = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = profile.languages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var language = _step.value;
                if (language.language === selectedLanguage) languages.push({
                    language: selectedLanguage,
                    native: profileNative,
                    intro: profileIntro,
                    aboutMe: profileAboutMe,
                    coachingAreas: profileCoachingAreas,
                    industryExperience: profileIndustryExperience,
                    clientIndustries: profileClientIndustries,
                    philosophy: profilePhilosophy
                });
                else languages.push(language);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var data = {
            "languages": languages
        };
        var _error = checkAllInput(languages);
        setError(_error);
        if (_error.length > 0) return;
        api.post('coach/profile/save', data).then(function(result) {
            setGlobalToast({
                text: lang === 'sv' ? "Sparade dina inst\xe4llningar" : 'Saved your settings'
            });
        });
    };
    var deleteLanguage = function(language) {
        if (!profile) return;
        api.get('coach/profile/language/delete/' + language).then(function(result) {
            var newProfile = structuredClone(profile);
            var languages = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = profile.languages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var lang = _step.value;
                    if (lang.language != language) languages.push(lang);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            newProfile.languages = languages;
            setProfile(newProfile);
            if (language === selectedLanguage) {
                if (languages.length > 0) setSelectedLanguage(languages[0].language);
                else setSelectedLanguage("");
            }
        });
    };
    var setInputFromLanguage = function(coachLanguage) {
        setSelectedLanguage(coachLanguage.language);
        setProfileNative(coachLanguage.native);
        setProfileIntro(coachLanguage.intro);
        setProfileAboutMe(coachLanguage.aboutMe);
        setProfileCoachingAreas(coachLanguage.coachingAreas);
        setProfileIndustryExperience(coachLanguage.industryExperience);
        setProfileClientIndustries(coachLanguage.clientIndustries);
        setProfilePhilosophy(coachLanguage.philosophy);
    };
    (0, $5s1kH.useEffect)(function() {
        // When changing language, check if we should add new, set to empty or use existing
        // Used when adding new language or setting language to "Choose language"
        var emptyLanguage = {
            language: selectedLanguage,
            native: false,
            intro: '',
            aboutMe: '',
            coachingAreas: '',
            industryExperience: '',
            clientIndustries: '',
            philosophy: ''
        };
        if (selectedLanguage === "") setInputFromLanguage(emptyLanguage);
        else if (profile) {
            var foundLangTexts = null;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = profile.languages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var l = _step.value;
                    if (l.language === selectedLanguage) {
                        foundLangTexts = l;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (foundLangTexts) setInputFromLanguage(foundLangTexts);
            else {
                var newProfile = structuredClone(profile);
                setInputFromLanguage(emptyLanguage);
                newProfile.languages.push(emptyLanguage);
                setProfile(newProfile);
            }
        }
    }, [
        selectedLanguage
    ]);
    var updatePreviousLanguage = function() {
        if (!profile) return;
        // Take the current values for intro, expertise, etc, and insert into the current profile
        var newProfile = structuredClone(profile);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newProfile.languages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var l = _step.value;
                if (l.language == selectedLanguage) {
                    l.intro = profileIntro;
                    l.native = profileNative;
                    l.aboutMe = profileAboutMe;
                    l.coachingAreas = profileCoachingAreas;
                    l.industryExperience = profileIndustryExperience;
                    l.clientIndustries = profileClientIndustries;
                    l.philosophy = profilePhilosophy;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setProfile(newProfile);
    };
    var selectLanguage = function(language) {
        // Check if we should insert previous data into profile structure
        updatePreviousLanguage();
        setSelectedLanguage(language);
    };
    var editLanguage = function(e, what) {
        if (what === "intro") {
            if (e.target.value.length > 110) alert("Too long! Max length of intro is 110 characters.");
            else setProfileIntro(e.target.value);
        } else if (what === "aboutMe") setProfileAboutMe(e.target.value);
        else if (what === "coachingAreas") setProfileCoachingAreas(e.target.value);
        else if (what === "industryExperience") setProfileIndustryExperience(e.target.value);
        else if (what === "clientIndustries") setProfileClientIndustries(e.target.value);
        else if (what === "philosophy") setProfilePhilosophy(e.target.value);
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading profile..."
    });
    var closeEditPicture = function(picture) {
        if (profile && picture && picture.length > 0) setProfile((0, $lf4fc._)((0, $hwO3w._)({}, profile), {
            picture: picture
        }));
        setPicture(false);
    };
    var renderTab = function() {
        if (!profile || profile.languages.length < 2) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {});
        var items = [];
        var active = 0;
        var i = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var l = _step.value;
                if (l.language === selectedLanguage) active = i;
                items.push({
                    title: t(l.language),
                    callback: function() {
                        return selectLanguage(l.language);
                    }
                });
                i++;
            };
            for(var _iterator = profile.languages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-4",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c8483606065062df$export$2e2bcd8739ae039), {
                items: items,
                active: active
            })
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            picture && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $03910c02f50343b6$export$2e2bcd8739ae039), {
                picture: profile === null || profile === void 0 ? void 0 : profile.picture,
                close: closeEditPicture,
                lang: lang,
                who: "coach"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: showConfirmDelete,
                onClose: function() {
                    return setShowConfirmDelete(false);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                        onClose: function() {
                            return setShowConfirmDelete(false);
                        },
                        children: lang === 'sv' ? 'Ta bort presentation' : 'Remove presentation'
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "p-4",
                            children: [
                                lang === 'sv' ? "\xc4r du s\xe4ker p\xe5 att du vill ta bort presentation p\xe5 " : 'Are you sure you want to remove the presentation in ',
                                t(selectedLanguage),
                                "?",
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    className: "w-full mt-8",
                                    onClick: function() {
                                        setShowConfirmDelete(false);
                                        deleteLanguage(selectedLanguage);
                                    },
                                    children: t('yes')
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "text-2xl font-medium text-white mt-4",
                children: t('settings')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex mt-6 items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "relative cursor-pointer bg-white rounded-full",
                        onClick: function() {
                            return setPicture(true);
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                className: "picture-lg " + (profile && profile.picture ? '' : 'p-3'),
                                alt: "pic",
                                src: profile && profile.picture ? profile.picture : (0, (/*@__PURE__*/$parcel$interopDefault($c69e28b19a456287$exports)))
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                alt: "pic-icon",
                                style: {
                                    position: "absolute",
                                    zIndex: 10,
                                    bottom: "0px",
                                    right: "0px"
                                },
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($5a265b004045b943$exports)))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                className: "text-xl font-medium",
                                children: [
                                    profile === null || profile === void 0 ? void 0 : profile.firstName,
                                    " ",
                                    profile === null || profile === void 0 ? void 0 : profile.lastName
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: profile === null || profile === void 0 ? void 0 : profile.email
                            }),
                            (profile === null || profile === void 0 ? void 0 : profile.hasClientUser) && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-link",
                                onClick: function() {
                                    return (0, $632c75b97b900307$export$70b209735b7809eb)("client");
                                },
                                children: lang === "sv" ? "Byt till ditt klient-konto" : "Switch to your client account"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: t('language')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-2",
                children: lang === 'sv' ? "L\xe4gg till spr\xe5k att coacha p\xe5" : 'Add language to coach in'
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("select", {
                onChange: function(e) {
                    return selectLanguage(e.target.value);
                },
                className: "z-select mt-2",
                value: "",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: "",
                        children: t("select-language")
                    }),
                    coachLanguages.map(function(l) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                            value: l,
                            children: t(l)
                        }, "lang_" + l);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Public presentation"
            }),
            renderTab(),
            selectedLanguage != "" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center justify-between mt-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    onClick: function() {
                                        return setProfileNative(!profileNative);
                                    },
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                        checked: profileNative,
                                        label: lang === 'sv' ? "Modersm\xe5l" : 'Native language',
                                        id: "_native"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                                alt: "delete",
                                className: "cursor-pointer",
                                onClick: function() {
                                    return setShowConfirmDelete(true);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 font-medium",
                        children: [
                            lang === 'sv' ? 'Kort introduktion' : 'Short introduction',
                            " *"
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "text-xs text-neutral-400",
                        children: lang === 'sv' ? 'Summera din coach approach eller din expertis, t ex "Hj\xe4lper ledare v\xe4xa, bygga uth\xe5llighet och n\xe5 best\xe5ende framg\xe5ng."' : 'Summarize your coaching approach or highlight your expertise, e.g. "Empowering leaders to grow, build resilience, and achieve lasting success."'
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                        onChange: function(e) {
                            return editLanguage(e, 'intro');
                        },
                        placeholder: t('write-text-here'),
                        value: profileIntro,
                        className: "z-input mt-4 w-full h-40"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex justify-end text-xs text-neutral-400",
                        children: [
                            profileIntro.length,
                            "/110"
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "mt-4 border-neutral-700"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 font-medium",
                        children: [
                            lang === 'sv' ? 'Om mig' : 'About me',
                            " *"
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                        onChange: function(e) {
                            return editLanguage(e, 'aboutMe');
                        },
                        placeholder: t('write-text-here'),
                        value: profileAboutMe,
                        className: "z-input mt-4 h-40"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "mt-4 border-neutral-700"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 font-medium",
                        children: lang === 'sv' ? "Coachomr\xe5den" : 'Coaching areas'
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                        onChange: function(e) {
                            return editLanguage(e, 'coachingAreas');
                        },
                        placeholder: t('write-text-here'),
                        value: profileCoachingAreas,
                        className: "z-input mt-4 h-40"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 flex flex-wrap",
                        children: profile === null || profile === void 0 ? void 0 : profile.coachingAreas.map(function(area) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "rounded-full px-6 py-2 bg-neutral-600 mr-2 mb-2",
                                children: area.name
                            }, "area_" + area.name);
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "mt-4 border-neutral-700"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 font-medium",
                        children: lang === 'sv' ? 'Brancherfarenhet' : 'Industry experience'
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                        onChange: function(e) {
                            return editLanguage(e, 'industryExperience');
                        },
                        placeholder: t('write-text-here'),
                        value: profileIndustryExperience,
                        className: "z-input mt-4 h-40"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 flex flex-wrap",
                        children: profile === null || profile === void 0 ? void 0 : profile.coachingIndustriesCoach.map(function(name) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "rounded-full px-6 py-2 bg-neutral-600 mr-2 mb-2",
                                children: name
                            }, "area_" + name);
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "mt-4 border-neutral-700"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 font-medium",
                        children: lang === 'sv' ? 'Klienters branscher' : 'Client industries'
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                        onChange: function(e) {
                            return editLanguage(e, 'clientIndustries');
                        },
                        placeholder: t('write-text-here'),
                        value: profileClientIndustries,
                        className: "z-input mt-4 h-40"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 flex flex-wrap",
                        children: profile === null || profile === void 0 ? void 0 : profile.coachingIndustriesClient.map(function(name) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "rounded-full px-6 py-2 bg-neutral-600 mr-2 mb-2",
                                children: name
                            }, "area_" + name);
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "mt-4 border-neutral-700"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 font-medium",
                        children: [
                            t('profile-philosophy'),
                            " *"
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                        onChange: function(e) {
                            return editLanguage(e, 'philosophy');
                        },
                        placeholder: "Write text here...",
                        value: profilePhilosophy,
                        className: "z-input mt-4 h-40"
                    })
                ]
            }),
            error.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4 p-4 border rounded border-cherry-500 whitespace-pre-line",
                children: error
            }),
            profile && profile.languages.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                onClick: function() {
                    return save();
                },
                className: "w-full my-4",
                children: t('save')
            })
        ]
    });
}



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");















var $9c87070a28704af8$var$statusBillable = [
    'default',
    'zebrain_confirmed',
    'coach_confirmed',
    'client_cancelled_late',
    'client_missed'
];
var $9c87070a28704af8$var$statusName = {
    "default": "Ok",
    "zebrain_confirmed": "Zebrain confirmed",
    "zebrain_cancelled": "Zebrain cancelled",
    "coach_confirmed": "Coach confirmed",
    "coach_missed": "Coach missed",
    "coach_cancelled": "Coach cancelled",
    "client_cancelled": "Client cancelled",
    "client_cancelled_late": "Client cancelled late",
    "client_missed": "Client missed"
};
function $9c87070a28704af8$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = i18n.language ? i18n.language.startsWith('sv') ? 'sv' : 'en' : 'en';
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)({}), 2), dayMeetings = _useState[0], setDayMeetings = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)("coming"), 2), view = _useState1[0], setView = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), rawMeetings = _useState2[0], setRawMeetings = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)("all"), 2), filterStatus = _useState3[0], setFilterStatus = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), selectedMeeting = _useState4[0], setSelectedMeeting = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showCancelMeeting = _useState5[0], setShowCancelMeeting = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showChangeMeeting = _useState6[0], setShowChangeMeeting = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), selectDate = _useState7[0], setSelectDate = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), fromDate = _useState8[0], setFromDate = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), toDate = _useState9[0], setToDate = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), editMeeting = _useState10[0], setEditMeeting = _useState10[1];
    var now = new Date();
    var thisDate = "";
    var prevDate = "";
    var today = (0, $7d185b5883a21821$export$ce35f6b40b9b16f5)();
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get('coach/meetings?all=1').then(function(response) {
            var theDayMeetings = {};
            var meetingList = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = response.json.meetings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var m = _step.value;
                    var dateStr = m.start.substring(0, 10);
                    var dayItem = theDayMeetings[dateStr];
                    if (dayItem === undefined) {
                        dayItem = [];
                        theDayMeetings[dateStr] = dayItem;
                    }
                    m.startDate = new Date(m.start);
                    dayItem.push(m);
                    meetingList.push(m);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            setDayMeetings(theDayMeetings);
            setRawMeetings(meetingList);
        });
    };
    var updateMeetingStatus = function(newStatus) {
        if (!editMeeting) return;
        if (editMeeting.status === newStatus) return;
        var data = {
            id: editMeeting.id,
            status: newStatus
        };
        api.post('coach/meeting/edit_status', data).then(function(response) {
            if (response.json.status === 'ok') {
                var newMeetings = (0, $XnYkK._)(rawMeetings);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = newMeetings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var m = _step.value;
                        if (m.id === editMeeting.id) m.status = newStatus;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                setRawMeetings(newMeetings);
                setEditMeeting(null);
            } else if (response.json.error) alert(response.json.error);
        });
    };
    var showDate = function(d, idx) {
        thisDate = d.getDate() + " " + (0, $7d185b5883a21821$export$478c9c14b5784b92)(d.getMonth(), lang);
        var sameDate = thisDate === prevDate;
        var dayStr = (0, $7d185b5883a21821$export$ce35f6b40b9b16f5)(d);
        prevDate = thisDate;
        if (sameDate) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {});
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                idx > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "border-neutral-600 my-4"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "font-medium",
                    children: dayStr === today ? "Idag" : thisDate
                })
            ]
        });
    };
    var clickChangeMeeting = function(meeting) {
        setSelectedMeeting(meeting);
        setShowChangeMeeting(true);
    };
    var clickCancelMeeting = function(meeting) {
        setSelectedMeeting(meeting);
        setShowCancelMeeting(true);
    };
    var closeCancelMeeting = function(changed) {
        setShowCancelMeeting(false);
        if (changed) getData();
    };
    var closeChangeMeeting = function(changed) {
        setShowChangeMeeting(false);
        if (changed) getData();
    };
    var goToMeeting = function(meetingId) {
        if (api.apiToken) (0, $4bf2b0595575af5a$export$68c1f516bbed5123)(meetingId, api.apiToken, "coach");
    };
    var showMeetingLine = function(meeting, dayIndex, meetingIndex) {
        var popItems;
        if (view === "coming") popItems = [
            {
                title: t('to-meeting'),
                click: function() {
                    return goToMeeting(meeting.id);
                }
            },
            {
                title: t('change-meeting'),
                click: function() {
                    return clickChangeMeeting(meeting);
                }
            },
            {
                title: t('cancel-meeting'),
                click: function() {
                    return clickCancelMeeting(meeting);
                }
            }
        ];
        else popItems = [
            {
                title: t('to-meeting'),
                click: function() {
                    return goToMeeting(meeting.id);
                }
            },
            {
                title: t('summary'),
                click: function() {
                    return navigate('/clients/' + meeting.clientId + '/meeting_summary/' + meeting.id);
                }
            }
        ];
        if (view === "coming" && dayIndex === 0 && meetingIndex === 0 && (0, $7d185b5883a21821$export$ce35f6b40b9b16f5)(meeting.startDate) === today) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "text-xl z-link mt-4",
                    children: [
                        meeting.firstName,
                        " ",
                        meeting.lastName
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex justify-between items-center mt-4",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center w-36",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    alt: "Time",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports))),
                                    className: "picture-xs"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                    className: "ml-2 text-sm font-medium",
                                    children: [
                                        (0, $7d185b5883a21821$export$5f885a9374f8e024)(meeting.startDate),
                                        "\u2013",
                                        (0, $7d185b5883a21821$export$5f885a9374f8e024)((0, $7d185b5883a21821$export$212a2e732fe26c47)(meeting.startDate, meeting.length))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "w-36 flex items-center cursor-pointer",
                            onClick: function() {
                                return setEditMeeting(meeting);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8a47c0bf566c4697$exports))),
                                    alt: "edit"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "ml-2",
                                    children: $9c87070a28704af8$var$statusName[meeting.status]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                            items: popItems
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    onClick: function() {
                        return goToMeeting(meeting.id);
                    },
                    className: "w-full mt-4",
                    buttonType: "outlineWhiteBase",
                    children: "Till m\xf6te"
                })
            ]
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex justify-between items-center mt-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "text-sm z-link w-32",
                                onClick: function() {
                                    return navigate("/clients/".concat(meeting.clientId));
                                },
                                children: [
                                    meeting.firstName,
                                    " ",
                                    meeting.lastName
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex items-center ml-2 w-36",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        className: "ml-2 picture-xs",
                                        alt: "Time",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                        className: "ml-2 text-sm font-medium",
                                        children: [
                                            (0, $7d185b5883a21821$export$5f885a9374f8e024)(meeting.startDate),
                                            "\u2013",
                                            (0, $7d185b5883a21821$export$5f885a9374f8e024)((0, $7d185b5883a21821$export$212a2e732fe26c47)(meeting.startDate, meeting.length))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "w-36 flex items-center cursor-pointer",
                        onClick: function() {
                            return setEditMeeting(meeting);
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($8a47c0bf566c4697$exports))),
                                alt: "edit"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "ml-2",
                                children: $9c87070a28704af8$var$statusName[meeting.status]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                        items: popItems
                    })
                ]
            })
        });
    };
    if (showChangeMeeting && selectedMeeting) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0c1340ed2ac599c6$export$2e2bcd8739ae039), {
            meeting: selectedMeeting,
            clientId: selectedMeeting.clientId,
            close: closeChangeMeeting,
            lang: lang
        })
    });
    var meetingFilter = function(m) {
        if (view === "coming") return m.startDate >= now;
        else {
            if (m.startDate > now) return false;
        }
        if (filterStatus === 'billable') {
            if ($9c87070a28704af8$var$statusBillable.indexOf(m.status) < 0) return false;
        }
        if (fromDate && m.startDate < fromDate) return false;
        if (toDate && m.startDate > toDate) return false;
        return true;
    };
    var getMatchingMeetings = function() {
        return rawMeetings.filter(function(m) {
            return meetingFilter(m);
        }).length;
    };
    var showSummary = function() {
        var meetingNr = 0;
        var meetingMinutes = 0;
        rawMeetings.filter(function(m) {
            return meetingFilter(m);
        }).map(function(m) {
            meetingNr += 1;
            meetingMinutes += m.length;
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-6 rounded bg-neutral-700 p-4",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "font-medium",
                children: [
                    lang === 'sv' ? 'Summering:' : 'Summary:',
                    "\xa0",
                    meetingNr,
                    "\xa0",
                    lang === 'sv' ? "m\xf6ten" : 'meetings',
                    ",\xa0",
                    (0, $7d185b5883a21821$export$9a827e9be85de527)(meetingMinutes),
                    "\xa0",
                    lang === 'sv' ? "m\xf6testid" : 'meeting time'
                ]
            })
        });
    };
    var showMeetings = function() {
        var meetingList = Object.keys(dayMeetings).filter(function(day) {
            return view === "coming" ? day >= today : day <= today;
        });
        // let meetingList = Object.keys(dayMeetings).filter(m => meetingFilter(m))
        if (getMatchingMeetings() === 0) {
            var message;
            if (view === "coming") message = lang === 'sv' ? "Du har inga m\xf6ten inbokade." : 'You don\'t have any meetings scheduled.';
            else message = lang === 'sv' ? "Du har inte haft n\xe5gra m\xf6ten \xe4n." : 'You haven\'t had any meetings yet.';
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: message
            });
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h2", {
                    className: "text-lg font-medium text-white mt-4 desktop:mt-6",
                    children: view === "coming" ? t('booked-meetings') : t('earlier')
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "rounded bg-neutral-700 p-4 mt-2",
                    children: meetingList.sort(function(a, b) {
                        if (view === "coming") return a > b ? 1 : -1;
                        else return b > a ? 1 : -1;
                    }).map(function(day, dayIndex) {
                        var meetings = dayMeetings[day];
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                                children: meetings.filter(function(m) {
                                    return meetingFilter(m);
                                }).sort(function(a, b) {
                                    return a.startDate > b.startDate ? 1 : -1;
                                }).map(function(meeting, meetingIndex) {
                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        children: [
                                            showDate(meeting.startDate, dayIndex),
                                            showMeetingLine(meeting, dayIndex, meetingIndex)
                                        ]
                                    }, meeting.id);
                                })
                            })
                        }, day);
                    })
                })
            ]
        });
    };
    var setFilterDate = function(d) {
        if (selectDate === "from") {
            if (d) d.setHours(0);
            setFromDate(d);
        } else {
            if (d) d.setHours(23);
            setToDate(d);
        }
        setSelectDate("");
    };
    var handleEditMeeting = function() {
        if (!editMeeting) return null;
        console.log(editMeeting.status);
        var editable = [
            'default',
            'coach_confirmed',
            'coach_missed',
            'coach_cancelled',
            'client_missed'
        ];
        if (editable.indexOf(editMeeting.status) > -1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            children: editable.map(function(e, index) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex mt-2 cursor-pointer",
                    onClick: function() {
                        return updateMeetingStatus(e);
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-radiobox",
                            children: e === editMeeting.status && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-radiobox-selected"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "ml-2",
                            children: $9c87070a28704af8$var$statusName[e]
                        })
                    ]
                }, "edit_status" + index);
            })
        });
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                lang === 'sv' ? "Du kan inte \xe4ndra status " : 'You cannot change status',
                $9c87070a28704af8$var$statusName[editMeeting.status],
                ".\xa0"
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            showCancelMeeting && selectedMeeting && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $28d0d992580243b2$export$2e2bcd8739ae039), {
                lang: lang,
                meeting: selectedMeeting,
                close: closeCancelMeeting
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "text-2xl font-medium text-white  my-4 desktop:my-6",
                children: t('my-bookings')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c8483606065062df$export$2e2bcd8739ae039), {
                items: [
                    {
                        title: t('coming'),
                        callback: function() {
                            return setView('coming');
                        }
                    },
                    {
                        title: t('earlier'),
                        callback: function() {
                            return setView('previous');
                        }
                    }
                ],
                active: 0
            }),
            view === "previous" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center cursor-pointer",
                        onClick: function() {
                            return setFilterStatus("all");
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-radiobox",
                                children: filterStatus === "all" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-radiobox-selected"
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "ml-2",
                                children: lang === 'sv' ? 'Alla' : 'All'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-8 flex cursor-pointer",
                        onClick: function() {
                            return setFilterStatus("billable");
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-radiobox",
                                children: filterStatus === "billable" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-radiobox-selected"
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "ml-2",
                                children: lang === 'sv' ? 'Debiterbara' : 'Billable'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "ml-4",
                        children: lang === 'sv' ? 'mellan' : 'between'
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-2 cursor-pointer flex",
                        onClick: function() {
                            return setSelectDate("from");
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                alt: "edit"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "ml-2 w-24",
                                children: fromDate ? (0, $7d185b5883a21821$export$adf69d68d71478c0)(fromDate) : '____-__-__'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "ml-2",
                        children: lang === 'sv' ? 'och' : 'and'
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-2 cursor-pointer flex",
                        onClick: function() {
                            return setSelectDate("to");
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                alt: "edit"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "ml-2 w-24",
                                children: toDate ? (0, $7d185b5883a21821$export$adf69d68d71478c0)(toDate) : '____-__-__'
                            })
                        ]
                    })
                ]
            }),
            selectDate !== "" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 border border-neutral-800 bg-neutral-700",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex justify-between w-full p-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h2", {
                                className: "text-xl text-center",
                                children: selectDate === "from" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                    children: lang === 'sv' ? "Fr\xe5n och med" : 'From'
                                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                    children: lang === 'sv' ? 'Till och med' : 'To date'
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                className: "text-xl cursor-pointer",
                                onClick: function() {
                                    return setFilterDate(null);
                                },
                                children: [
                                    "[",
                                    lang === 'sv' ? 'Rensa' : 'Clear',
                                    "]"
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                                onClick: function() {
                                    return setSelectDate("");
                                },
                                alt: "close",
                                className: "cursor-pointer"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $eef0ed3dd6e17e0e$export$2e2bcd8739ae039), {
                        dates: [],
                        clickDate: function(d) {
                            return setFilterDate(d);
                        },
                        preSelectedDate: null,
                        skipClickMonthChange: true
                    })
                ]
            }),
            showMeetings(),
            showSummary(),
            editMeeting && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: true,
                onClose: function() {
                    return setEditMeeting(null);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                        onClose: function() {
                            return setEditMeeting(null);
                        },
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            children: [
                                lang === 'sv' ? "Status f\xf6r m\xf6te" : 'Status for meeting',
                                "\xa0",
                                (0, $7d185b5883a21821$export$adf69d68d71478c0)(editMeeting.startDate),
                                "\xa0",
                                (0, $7d185b5883a21821$export$5f885a9374f8e024)(editMeeting.startDate)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        children: handleEditMeeting()
                    })
                ]
            })
        ]
    });
}



var $6iP9u = parcelRequire("6iP9u");



var $5s1kH = parcelRequire("5s1kH");


var $bHX26 = parcelRequire("bHX26");





function $5bc3972d35c25732$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), clients = _useState[0], setClients = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState1[0], setLoaded = _useState1[1];
    var _useAtom = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$6629aba53c1d79c3)), 1), unreadChats = _useAtom[0];
    (0, $5s1kH.useEffect)(function() {
        api.get('coach/clients').then(function(result) {
            setClients(result.json.clients);
            setLoaded(true);
        });
    }, []);
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h2", {
                className: "mt-4 text-lg font-medium",
                children: t('my-clients')
            }),
            loaded ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    clients.filter(function(client) {
                        return client.dateTo === null;
                    }).map(function(client, idx) {
                        var unreadChat = unreadChats.indexOf(client.id) > -1;
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "cursor-pointer flex items-center",
                                    onClick: function() {
                                        return navigate('/clients/' + client.id);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            className: "picture",
                                            alt: "pic",
                                            src: client.picture ? client.picture : (0, (/*@__PURE__*/$parcel$interopDefault($c69e28b19a456287$exports)))
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "ml-4",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                                    className: "text-lg font-medium",
                                                    children: [
                                                        client.firstName,
                                                        " ",
                                                        client.lastName
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                                    className: "text-neutral-400",
                                                    children: [
                                                        client.title,
                                                        " | ",
                                                        client.company
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex gap-x-2",
                                    children: [
                                        client.bookedMeetings > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                            alt: "booked",
                                            className: "picture-xs"
                                        }),
                                        unreadChat && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "rounded-full h-2 w-2 bg-cherry-500"
                                        })
                                    ]
                                })
                            ]
                        }, "client_" + idx);
                    }),
                    clients.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4",
                        children: lang === 'sv' ? "H\xe4r visas de klienter som valt dig" : 'Here you will see the clients who selected you'
                    }),
                    clients.filter(function(client) {
                        return client.dateTo !== null;
                    }).length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h2", {
                        className: "mt-6 text-lg font-medium",
                        children: lang === 'sv' ? 'Avslutade klienter' : 'Finished clients'
                    }),
                    clients.filter(function(client) {
                        return client.dateTo !== null;
                    }).map(function(client, idx) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-4 flex justify-between",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "cursor-pointer flex items-center",
                                onClick: function() {
                                    return navigate('/clients/' + client.id);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        className: "picture",
                                        alt: "pic",
                                        src: client.picture ? client.picture : (0, (/*@__PURE__*/$parcel$interopDefault($c69e28b19a456287$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "ml-4",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                                className: "text-lg font-medium",
                                                children: [
                                                    client.firstName,
                                                    " ",
                                                    client.lastName
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                                className: "text-neutral-400",
                                                children: [
                                                    client.title,
                                                    " | ",
                                                    client.company
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, "client_" + idx);
                    })
                ]
            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4",
                children: "Loading clients..."
            })
        ]
    });
}



var $6iP9u = parcelRequire("6iP9u");



var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");






















var $be21a18a1a0b4a21$var$tabs = /*#__PURE__*/ function(tabs) {
    tabs[tabs["DEVELOPMENT_PLAN"] = 0] = "DEVELOPMENT_PLAN";
    tabs[tabs["PROFILE"] = 1] = "PROFILE";
    tabs[tabs["MEETINGS"] = 2] = "MEETINGS";
    tabs[tabs["INFO"] = 3] = "INFO";
    tabs[tabs["NOTES"] = 4] = "NOTES";
    return tabs;
}($be21a18a1a0b4a21$var$tabs || {});
function $be21a18a1a0b4a21$export$2e2bcd8739ae039() {
    var clientId = (0, $bHX26.useParams)().clientId;
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var navigate = (0, $bHX26.useNavigate)();
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(), 2), client = _useState[0], setClient = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), view = _useState1[0], setView = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), activeTab = _useState2[0], setActiveTab = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showCancelMeeting = _useState3[0], setShowCancelMeeting = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), selectedMeeting = _useState4[0], setSelectedMeeting = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showChangeMeeting = _useState5[0], setShowChangeMeeting = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showBookMeeting = _useState6[0], setShowBookMeeting = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), apiError = _useState7[0], setApiError = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), notes = _useState8[0], setNotes = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), notesChanged = _useState9[0], setNotesChanged = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState10[0], setLoaded = _useState10[1];
    var _useState11 = (0, $6iP9u._)((0, $5s1kH.useState)(), 2), newMeeting = _useState11[0], setNewMeeting = _useState11[1];
    var _useAtom = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$6629aba53c1d79c3)), 1), unreadChats = _useAtom[0];
    var setGlobalToast = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$12972e612ad7cf0));
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var ApiError = function(error) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                    className: "text-xl",
                    children: "Fatal error!"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-4",
                    children: error
                })
            ]
        });
    };
    var blocker = (0, $bHX26.useBlocker)(function(param) {
        var currentLocation = param.currentLocation, nextLocation = param.nextLocation;
        return notesChanged && currentLocation.pathname !== nextLocation.pathname;
    });
    var getData = function() {
        api.get('coach/client/' + clientId).then(function(result) {
            if (result.json.error) {
                console.log(result.json.error);
                setApiError(result.json.error);
            } else {
                var clientJson = result.json.client;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = clientJson.meetings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var m = _step.value;
                        m.startDate = new Date(m.start);
                        m.firstName = clientJson.firstName;
                        m.lastName = clientJson.lastName;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                setClient(clientJson);
                setNotes(result.json.notes);
                setNewMeeting({
                    id: "0",
                    key: "0",
                    length: 30,
                    start: "",
                    startDate: new Date(),
                    clientId: clientId ? clientId : "",
                    status: "default",
                    firstName: clientJson.firstName,
                    lastName: clientJson.lastName
                });
            }
            setLoaded(true);
        });
    };
    var saveNotes = function() {
        var data = {
            notes: notes
        };
        api.post('coach/' + clientId + '/notes/save', data).then(function(result) {
            setNotesChanged(false);
            setGlobalToast({
                text: lang === 'sv' ? "\xc4ndringar sparade" : 'Changes saved'
            });
        });
    };
    var updateNotes = function(txt) {
        setNotes(txt);
        setNotesChanged(true);
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading clients..."
    });
    if (apiError.length > 0) return ApiError(apiError);
    var crumbs = [
        {
            name: t('my-clients'),
            url: '/clients'
        },
        {
            name: (client === null || client === void 0 ? void 0 : client.firstName) + " " + (client === null || client === void 0 ? void 0 : client.lastName)
        }
    ];
    var getCoachingExperience = function(value) {
        if (value === 0) return lang === 'sv' ? "Ingen erfarenhet" : "No experience";
        else if (value === 1) return lang === 'sv' ? "Lite erfarenhet" : "Little experience";
        else if (value === 2) return lang === 'sv' ? "M\xe5ttlig erfarenhet" : "Moderate experience";
        else if (value === 3) return lang === 'sv' ? "Mycket erfarenhet" : "Vast experience";
        else return "Unknown: " + value;
    };
    var showLanguages = function() {
        if (!client) return;
        var langs = "";
        var i = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = client.languages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var lang = _step.value;
                if (i > 0) langs += ", ";
                langs += t(lang);
                i++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return langs;
    };
    var clickChangeMeeting = function(meeting) {
        setSelectedMeeting(meeting);
        setShowChangeMeeting(true);
    };
    var clickCancelMeeting = function(meeting) {
        setSelectedMeeting(meeting);
        setShowCancelMeeting(true);
    };
    var closeCancelMeeting = function(changed) {
        setShowCancelMeeting(false);
        if (changed) getData();
    };
    var closeChangeMeeting = function(changed) {
        setShowChangeMeeting(false);
        if (changed) getData();
    };
    var renderFocusArea = function(feedbackResult) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "p-4",
            children: "TODO"
        });
    };
    var goToMeeting = function(meetingId) {
        if (!api.apiToken) return;
        (0, $4bf2b0595575af5a$export$68c1f516bbed5123)(meetingId, api.apiToken, "coach");
    };
    var goToFocusArea = function(focusArea) {
        navigate('/clients/' + clientId + '/focus_area/' + focusArea);
    };
    var renderDevelopmentPlan = function() {
        var _client_focusAreas;
        if (!client) return;
        if (client.dateTo) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-6 text-lg",
            children: lang === 'sv' ? "Inte tillg\xe4nglig f\xf6r avslutade klienter" : 'Not available for finished clients'
        });
        if (client.categories.length > 0) {
            var longTermGoalUrl = (0, $632c75b97b900307$export$1630b5343357e8b5).SYSTEM === "production" ? "/clients/vision_statement/" : "/clients/long_term_goal/";
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: client.categories.map(function(category, i) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-6",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "font-medium",
                                children: category.name
                            }),
                            category.surveyRequestId && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-2 text-gray-400",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                    className: "underline hover:text-primary-500 cursor-pointer",
                                    onClick: function() {
                                        return navigate('/clients/survey_result/' + category.surveyRequestId + '/summary');
                                    },
                                    children: lang === "sv" ? "Se insiktsrapport h\xe4r" : "See the insights report here"
                                })
                            }),
                            category.visionStatements.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-2 text-gray-400",
                                children: lang === "sv" ? "Klienten har inte skapat n\xe5gra m\xe5lbilder \xe4n" : "Client hasn't created any Goals yet."
                            }),
                            category.visionStatements.map(function(visionStatement) {
                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "bg-indigo-900 hover:bg-indigo-800 mt-2 p-4 rounded-md cursor-pointer",
                                    onClick: function() {
                                        return navigate(longTermGoalUrl + visionStatement.id);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "flex flex-col md:flex-row md:justify-between md:items-center gap-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                    className: "flex flex-col md:flex-row md:justify-between gap-x-2 items-start md:items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                            className: "text-gray-100 z-h3",
                                                            children: visionStatement.title
                                                        }),
                                                        (0, $b841e7314e3d419d$export$9874b5b4c45031c5)(visionStatement.onTrack, lang)
                                                    ]
                                                }),
                                                visionStatement.deadline && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                            className: "z-title3 text-gray-100",
                                                            children: [
                                                                t("due-date"),
                                                                ":\xa0"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                            className: "text-sm text-gray-400",
                                                            children: visionStatement.deadline.substring(0, 10)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "mt-2",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                    className: "text-gray-100 font-medium",
                                                    children: [
                                                        lang === "sv" ? "Delm\xe5l" : "Sub-goals",
                                                        ":\xa0"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                    className: "text-gray-300",
                                                    children: [
                                                        visionStatement.goalsCompleted,
                                                        " ",
                                                        t("of"),
                                                        "\xa0",
                                                        visionStatement.goalsTotal,
                                                        " ",
                                                        t("completed").toLowerCase()
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "mt-2",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                    className: "text-gray-100 font-medium",
                                                    children: [
                                                        lang === "sv" ? "Aktiviteter" : "Activities",
                                                        ":\xa0"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                    className: "text-gray-300",
                                                    children: [
                                                        visionStatement.activitiesCompleted,
                                                        " ",
                                                        t("of"),
                                                        "\xa0",
                                                        visionStatement.activitiesTotal,
                                                        " ",
                                                        t("completed").toLowerCase()
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "mt-2 flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "h-2 rounded-full bg-indigo-700",
                                                    style: {
                                                        width: "calc(100% - 40px)"
                                                    },
                                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                        className: "h-2 rounded-full bg-primary-500",
                                                        style: {
                                                            width: visionStatement.progress + "%"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                    className: "ml-2 text-sm gray-300",
                                                    children: [
                                                        visionStatement.progress,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, "vision_" + visionStatement.id);
                            })
                        ]
                    }, "category_" + i);
                })
            });
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 text-lg",
                    children: t('development-plan')
                }),
                (_client_focusAreas = client.focusAreas) === null || _client_focusAreas === void 0 ? void 0 : _client_focusAreas.map(function(focusArea, idx) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2 bg-neutral-800 rounded-[6px]",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "p-4 bg-neutral-700 flex items-center rounded-[6px]",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($39fbe7786abdc679$exports))),
                                        alt: "learning"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "font-medium ml-2",
                                        children: focusArea.name
                                    })
                                ]
                            }),
                            focusArea.feedbackResult && renderFocusArea(focusArea.feedbackResult),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                className: "border-neutral-600"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "p-4",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    className: "w-full",
                                    buttonType: "outlineWhiteBase",
                                    onClick: function() {
                                        return goToFocusArea(focusArea.id);
                                    },
                                    children: t('read')
                                })
                            })
                        ]
                    }, "fa_" + idx);
                })
            ]
        });
    };
    var renderMeeting = function(meeting) {
        var popItems = [
            {
                title: t('to-meeting'),
                click: function() {
                    return goToMeeting(meeting.id);
                }
            }
        ];
        if (meeting.startDate > now) {
            popItems.push({
                title: t('change-meeting'),
                click: function() {
                    return clickChangeMeeting(meeting);
                }
            });
            popItems.push({
                title: t('cancel-meeting'),
                click: function() {
                    return clickCancelMeeting(meeting);
                }
            });
        }
        popItems.push({
            title: t('summary'),
            click: function() {
                return navigate('/clients/' + clientId + '/meeting_summary/' + meeting.id);
            }
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "px-4 py-2 bg-neutral-700 flex items-center justify-between",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            className: "icon",
                            alt: "Time",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports)))
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                            className: "ml-2 w-20",
                            children: (0, $7d185b5883a21821$export$ff9a5f6f7fb9966b)(meeting.startDate, lang, false)
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            className: "icon ml-2",
                            alt: "Time",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports)))
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                            className: "ml-2",
                            children: [
                                (0, $7d185b5883a21821$export$5f885a9374f8e024)(meeting.startDate),
                                "\u2014",
                                (0, $7d185b5883a21821$export$5f885a9374f8e024)((0, $7d185b5883a21821$export$212a2e732fe26c47)(meeting.startDate, meeting.length))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                    items: popItems
                })
            ]
        }, "meeting_" + meeting.id);
    };
    var renderProfile = function() {
        if (!client) return;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 text-lg",
                    children: t('personality-test')
                }),
                client.profilesBig5.map(function(big, idx) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 z-link",
                        onClick: function() {
                            return navigate('/clients/personality/' + big.id);
                        },
                        children: big.date.substring(0, 10)
                    }, "big_" + big.id);
                }),
                client.profilesBig5.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-300",
                    children: "N/A"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 text-lg",
                    children: t('stress-test')
                }),
                client.profilesStress.map(function(stress, idx) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 z-link",
                        onClick: function() {
                            return navigate('/clients/stress/' + stress.id);
                        },
                        children: stress.date.substring(0, 10)
                    }, "stress_" + stress.id);
                }),
                client.profilesStress.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-300",
                    children: "N/A"
                })
            ]
        });
    };
    var renderMeetings = function() {
        var _client_clientLicense, _client_clientLicense1;
        if (!client) return;
        var bookedMeetings = client.meetings ? client.meetings.filter(function(m) {
            return m.startDate > now;
        }) : [];
        var previousMeetings = client.meetings ? client.meetings.filter(function(m) {
            return m.startDate < now;
        }) : [];
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                ((_client_clientLicense = client.clientLicense) === null || _client_clientLicense === void 0 ? void 0 : _client_clientLicense.remainingCredits) && ((_client_clientLicense1 = client.clientLicense) === null || _client_clientLicense1 === void 0 ? void 0 : _client_clientLicense1.remainingCredits) >= 30 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        className: "w-full",
                        buttonType: "outlineWhiteBase",
                        onClick: function() {
                            return setShowBookMeeting(true);
                        },
                        children: lang === "sv" ? "Boka nytt m\xf6te" : "Book new meeting"
                    })
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 text-gray-300",
                    children: lang === "sv" ? "Klienten kan inte boka fler m\xf6ten." : "The client cannot book moer meetings."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 mb-2 text-lg",
                    children: t('booked-meetings')
                }),
                bookedMeetings.sort(function(a, b) {
                    return b.startDate < a.startDate ? 1 : -1;
                }).map(function(meeting, idx) {
                    return renderMeeting(meeting);
                }),
                bookedMeetings.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-6 text-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                            alt: "date",
                            className: "h-8 w-8 mx-auto"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            className: "mt-4",
                            children: [
                                lang === 'sv' ? "Du har inga bokade m\xf6ten med " : 'You don\'t have any meetings booked with ',
                                client.firstName
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 mb-2 text-lg",
                    children: t('previous-meetings')
                }),
                previousMeetings.sort(function(a, b) {
                    return b.startDate < a.startDate ? -1 : 1;
                }).map(function(meeting, idx) {
                    return renderMeeting(meeting);
                }),
                previousMeetings.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-6 text-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                            alt: "date",
                            className: "h-8 w-8 mx-auto"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            className: "mt-4",
                            children: [
                                lang === 'sv' ? "Du har inte haft n\xe5gra m\xf6ten med " : 'You haven\'t had any meetings booked with ',
                                client.firstName
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var renderNotes = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 mb-2 text-lg",
                    children: t('notes')
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                        className: "z-input resizeable",
                        style: {
                            minHeight: 240
                        },
                        value: notes,
                        onChange: function(e) {
                            return updateNotes(e.target.value);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    className: "mt-4",
                    disabled: !notesChanged,
                    onClick: function() {
                        return saveNotes();
                    },
                    children: t('save')
                })
            ]
        });
    };
    var renderInfo = function() {
        if (!client) return;
        if (client.dateTo) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-6 text-lg",
            children: lang === 'sv' ? "Inte tillg\xe4nglig f\xf6r avslutade klienter" : 'Not available for finished clients'
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-4 text-lg font-medium",
                    children: lang === 'sv' ? 'Coachperiod' : 'Coach period'
                }),
                client.clientLicense ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex mt-2 text-neutral-400 justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: lang === 'sv' ? 'Perioden startade' : 'Period started'
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: client.clientLicense.created.substring(0, 10)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex mt-1 text-neutral-400 justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: lang === 'sv' ? 'Perioden slutar' : 'Period ends'
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    children: client.clientLicense.end ? client.clientLicense.end.substring(0, 10) : '-'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex mt-1 text-neutral-400 justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: lang === 'sv' ? "Klara m\xf6ten" : 'Done meetings'
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    children: [
                                        client.clientLicense.hadMeetings,
                                        " (",
                                        (0, $7d185b5883a21821$export$9a827e9be85de527)(client.clientLicense.hadMeetingTime),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex mt-1 text-neutral-400 justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: lang === 'sv' ? "Bokade m\xf6ten" : 'Booked meetings'
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    children: [
                                        client.clientLicense.futureMeetings,
                                        " (",
                                        (0, $7d185b5883a21821$export$9a827e9be85de527)(client.clientLicense.futureMeetingsTime),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex mt-1 text-neutral-400 justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: lang === 'sv' ? "\xc5terst\xe5ende m\xf6ten" : 'Remaining meetings'
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    children: [
                                        client.clientLicense.remainingMeetings,
                                        " (",
                                        (0, $7d185b5883a21821$export$9a827e9be85de527)(client.clientLicense.remainingCredits),
                                        ")"
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 font-medium text-neutral-400",
                    children: "No active license"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "mt-4 border-neutral-600"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-4 text-lg font-medium",
                    children: t('professional-details')
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex mt-2 text-neutral-400 justify-between",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "font-medium",
                            children: t('title')
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: client.title
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex mt-1 text-neutral-400 justify-between",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "font-medium",
                            children: t('level')
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: t(client.leaderShipLevel)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex mt-1 text-neutral-400 justify-between",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "font-medium",
                            children: t('in-company-since')
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: client.inCompanySince
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex mt-1 text-neutral-400 justify-between",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "font-medium",
                            children: t('current-role-since')
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: client.currentRoleSince
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "mt-4 border-neutral-600"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-4 text-lg font-medium",
                    children: t('experience-of-being-coached')
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-neutral-400",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: getCoachingExperience(client.coachingExperience)
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "mt-4 border-neutral-600"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-4 text-lg font-medium",
                    children: t('languages')
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-neutral-400",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: showLanguages()
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                    className: "mt-4 border-neutral-600"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-4 mb-2 text-lg font-medium",
                    children: t('coaching-areas-of-interest')
                }),
                client.coachingAreas.map(function(area) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-1 text-neutral-400",
                        children: t(area)
                    }, "area_" + area);
                })
            ]
        });
    };
    var renderTab = function() {
        if (view === 3) return renderInfo();
        else if (view === 1) return renderProfile();
        else if (view === 2) return renderMeetings();
        else if (view === 4) return renderNotes();
        else return renderDevelopmentPlan();
    };
    var now = new Date();
    if (showChangeMeeting && selectedMeeting) {
        if (!clientId || !client || !client.clientLicense) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {});
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0c1340ed2ac599c6$export$2e2bcd8739ae039), {
                clientId: clientId,
                remainingCredits: client.clientLicense.remainingCredits,
                meeting: selectedMeeting,
                close: closeChangeMeeting,
                lang: lang
            })
        });
    }
    if (showBookMeeting) {
        if (!clientId || !client || !client.clientLicense) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {});
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0c1340ed2ac599c6$export$2e2bcd8739ae039), {
                clientId: clientId,
                remainingCredits: client.clientLicense.remainingCredits,
                meeting: newMeeting,
                close: function() {
                    return setShowBookMeeting(false);
                },
                lang: lang
            })
        });
    }
    var unreadBadge = null;
    if (clientId && unreadChats.indexOf(clientId) > -1) unreadBadge = /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
        alt: "alert",
        className: "h-4 w-4"
    });
    if (!client) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {});
    var blockerProceed = function() {
        if (blocker !== undefined) blocker.proceed();
        else console.error("blocker proceed");
    };
    var blockerReset = function() {
        if (blocker !== undefined) blocker.reset();
        else console.error("blocker reset");
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            showCancelMeeting && selectedMeeting && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $28d0d992580243b2$export$2e2bcd8739ae039), {
                lang: lang,
                meeting: selectedMeeting,
                close: closeCancelMeeting
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "w-full text-center mb-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        className: "picture-lg mx-auto",
                        alt: "pic",
                        src: client.picture ? client.picture : (0, (/*@__PURE__*/$parcel$interopDefault($c69e28b19a456287$exports)))
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                className: "font-medium text-xl",
                                children: [
                                    client.firstName,
                                    " ",
                                    client.lastName
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: client.title
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: client.company
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mb-6",
                buttonType: "outlineWhiteBase",
                leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($07ace4e0b313d326$exports))),
                    alt: "chat",
                    className: "h-4 w-4"
                }),
                rightIcon: unreadBadge,
                onClick: function() {
                    return navigate('/chats/' + client.id);
                },
                children: "Chat"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c8483606065062df$export$2e2bcd8739ae039), {
                items: [
                    {
                        title: t('development-plan'),
                        callback: function() {
                            return setView(0);
                        }
                    },
                    {
                        title: t('profile'),
                        callback: function() {
                            return setView(1);
                        }
                    },
                    {
                        title: t('meetings'),
                        callback: function() {
                            return setView(2);
                        }
                    },
                    {
                        title: 'Info',
                        callback: function() {
                            return setView(3);
                        }
                    },
                    {
                        title: t('notes'),
                        callback: function() {
                            return setView(4);
                        }
                    }
                ],
                active: activeTab
            }),
            renderTab(),
            blocker.state === "blocked" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: true,
                onClose: function() {
                    return blockerProceed();
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                        onClose: function() {
                            return blockerProceed();
                        },
                        children: lang === 'sv' ? 'Anteckningar inte sparade' : 'Notes not saved'
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5d9c345a7a20d276$exports))),
                                    alt: "info",
                                    className: "text-center h-12 w-12 mt-6 mx-auto"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-6 text-neutral-400",
                                    children: lang === 'sv' ? "Du har inte sparat \xe4ndringarna i anteckningar. Om du l\xe4mnar denna sida nu f\xf6rlorar du dessa \xe4ndringar" : "You have unsaved changes. If you leave this page now, you\u2019ll lose any edits you\u2019ve made."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: "outlineWhiteBase",
                                onClick: function() {
                                    return blockerProceed();
                                },
                                children: lang === 'sv' ? "L\xe4mna utan att spara" : 'Leave without saving'
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: "blueBase",
                                onClick: function() {
                                    return blockerReset();
                                },
                                children: lang === 'sv' ? "Stanna p\xe5 sidan" : 'Stay on page'
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("5s1kH");
var $0414a7a8640e30e4$var$NotFound = function() {
    // NOTE: Datepicker 
    // 1. 
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "main-content",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "text-xl mt-6",
            children: "Page not found :-("
        })
    });
};
var $0414a7a8640e30e4$export$2e2bcd8739ae039 = $0414a7a8640e30e4$var$NotFound;



var $6iP9u = parcelRequire("6iP9u");




var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");



function $45cc95e8538527a8$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t;
    var clientId = (0, $bHX26.useParams)().clientId;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(), 2), client = _useState[0], setClient = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState1[0], setLoaded = _useState1[1];
    (0, $5s1kH.useEffect)(function() {
        api.get('coach/client/' + clientId).then(function(result) {
            setClient(result.json.client);
            setLoaded(true);
        });
    }, []);
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading clients..."
    });
    var crumbs = [
        {
            name: 'Chat',
            url: '/chats'
        },
        {
            name: (client === null || client === void 0 ? void 0 : client.firstName) + " " + (client === null || client === void 0 ? void 0 : client.lastName),
            url: '/clients/' + clientId
        }
    ];
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "rounded",
                style: {
                    height: "calc(100vh - 200px)"
                },
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cf4f24c6f036da11$export$2e2bcd8739ae039), {
                    clientId: client === null || client === void 0 ? void 0 : client.id,
                    isCoach: true
                })
            })
        ]
    });
}



var $6iP9u = parcelRequire("6iP9u");



var $5s1kH = parcelRequire("5s1kH");




var $bHX26 = parcelRequire("bHX26");



function $1775128c0acba44e$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), clients = _useState[0], setClients = _useState[1];
    var _useAtom = (0, $6iP9u._)((0, $e2578e2a154a0e06$export$83cf7ae8bb57e7ed)((0, $89a4535aba887275$export$6629aba53c1d79c3)), 2), unreadChats = _useAtom[0], setUnreadChats = _useAtom[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState1[0], setLoaded = _useState1[1];
    (0, $5s1kH.useEffect)(function() {
        api.get('coach/chats').then(function(result) {
            setClients(result.json.clients);
            setLoaded(true);
        });
    }, []);
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h2", {
                className: "mt-4 text-2xl font-medium",
                children: "Chat"
            }),
            loaded ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-2",
                children: [
                    clients.map(function(client, idx) {
                        var text = client.chat.text;
                        if (text === '_added_') {
                            if (lang === 'sv') text = 'Starta din konversation med ' + client.firstName + '...';
                            else text = 'Start your conversation with ' + client.firstName + '...';
                        }
                        var unreadChat = unreadChats.indexOf(client.id) > -1;
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-4 flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "cursor-pointer flex items-center",
                                    onClick: function() {
                                        return navigate('/chats/' + client.id);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            className: "picture",
                                            alt: "pic",
                                            src: client.picture ? client.picture : (0, (/*@__PURE__*/$parcel$interopDefault($c69e28b19a456287$exports)))
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "ml-2",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                    className: "flex",
                                                    children: [
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                            className: "font-medium",
                                                            children: [
                                                                client.firstName,
                                                                " ",
                                                                client.lastName
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                            className: "ml-3 text-neutral-400 text-sm",
                                                            children: (0, $7d185b5883a21821$export$31bd54ef8fbd09b6)(client.chat.date, lang)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "text-neutral-400 truncate max-w-[400px]",
                                                    children: text
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "w-6 text-center",
                                    children: unreadChat && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "rounded-full h-2 w-2 bg-cherry-500"
                                    })
                                })
                            ]
                        }, "client_" + idx);
                    }),
                    clients.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4",
                        children: lang === 'sv' ? "H\xe4r visas de klienter som valt dig" : 'Here you will see the clients who selected you'
                    })
                ]
            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4",
                children: "Loading client chats..."
            })
        ]
    });
}



var $lFIaz = parcelRequire("lFIaz");

var $6iP9u = parcelRequire("6iP9u");

var $3SMYb = parcelRequire("3SMYb");


var $5s1kH = parcelRequire("5s1kH");



parcelRequire("5s1kH");

var $11379fd9d376fa65$var$Modal = function(props) {
    var title = props.title, description = props.description;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        id: "hs-basic-modal",
        className: "shadow-custom-shadow hs-overlay hs-overlay-open:opacity-100 hs-overlay-open:duration-500 hidden fixed inset-0 z-80 flex items-center justify-center opacity-0 transition-all pointer-events-none",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "fixed inset-0 bg-gray-900 bg-opacity-80 hs-overlay-backdrop"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "sm:max-w-lg sm:w-full m-3 relative z-90",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex flex-col bg-neutral-800 border-neutral-700 shadow-neutral-700/70 border shadow-sm rounded-xl pointer-events-auto",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex justify-between items-center p-4 border-b border-neutral-600",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h3", {
                                    className: "text-lg font-medium text-white",
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("button", {
                                    type: "button",
                                    className: "flex justify-center items-center size-7 text-sm font-semibold rounded-full border border-transparent text-white hover:bg-neutral-700 disabled:opacity-50 disabled:pointer-events-none",
                                    "data-hs-overlay": "#hs-basic-modal",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                            className: "sr-only",
                                            children: "Close"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                                            alt: "menu"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "p-4 overflow-y-auto",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "mt-1 text-neutral-400",
                                children: description
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $11379fd9d376fa65$export$2e2bcd8739ae039 = $11379fd9d376fa65$var$Modal;


var $aa907b24fe69de5d$export$2e2bcd8739ae039 = (0, $11379fd9d376fa65$export$2e2bcd8739ae039);




function $fd4a203b6c17ff30$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(''), 2), description = _useState[0], setDescription = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(''), 2), errorMessage = _useState2[0], setErrorMessage = _useState2[1];
    var openModal = function() {
        var modal = document.getElementById('hs-basic-modal');
        if (modal) {
            modal.classList.remove('hidden');
            modal.classList.add('open');
            modal.classList.add('opened');
        }
    };
    var handleSendSupportTicket = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var data;
            return (0, $3SMYb._)(this, function(_state) {
                if (!description) {
                    setErrorMessage(t('support-error-message'));
                    return [
                        2
                    ];
                }
                setIsLoading(true);
                setErrorMessage('');
                data = {
                    description: description
                };
                api.post('coach/support_ticket', data).then(function(response) {
                    if (response.json.status) {
                        setDescription('');
                        setIsLoading(false);
                        openModal();
                    } else setErrorMessage(t('support-error-message-server'));
                }).catch(function(error) {
                    setErrorMessage(t('support-error-message-server'));
                    setIsLoading(false);
                });
                return [
                    2
                ];
            });
        })();
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "text-2xl font-medium text-white  mt-4 desktop:mt-6",
                children: lang === 'sv' ? "Hur kan vi hj\xe4lpa dig?" : 'How can we assist you?'
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-2",
                children: lang === 'sv' ? "Beskriv vad du vill ha hj\xe4lp med s\xe5 \xe5terkommer vi s\xe5 snart vi kan." : 'Let us know what you need help with, and we\'ll get back to you as soon as possible.'
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 gap-2 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "p-3 mb-4  h-40 items-center bg-neutral-900 rounded-lg ring-1 ring-neutral-600 focus-within:ring-2 focus-within:ring-primary-500",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                            id: "description",
                            placeholder: lang === 'sv' ? "Skriv h\xe4r..." : 'Describe your issue here...',
                            className: "w-full h-full flex-1 bg-neutral-900 text-white px-4 py-3 rounded-lg resize-none overflow-y-auto max-h-40 border-none focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none",
                            style: {
                                whiteSpace: 'normal'
                            },
                            value: description,
                            onChange: function(e) {
                                return setDescription(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        onClick: handleSendSupportTicket,
                        className: "w-full",
                        disabled: isLoading,
                        children: isLoading ? t('support-sending') : t('send')
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $aa907b24fe69de5d$export$2e2bcd8739ae039), {
                        title: t('support-modal-success-title'),
                        description: t('support-modal-success-description')
                    }),
                    errorMessage && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mt-4 text-red-500",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                        className: "mt-4 text-white",
                        children: [
                            t('support-email-info'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "text-neutral-400",
                        children: "coach@zebrain.se"
                    })
                ]
            })
        ]
    });
}


var $058fa55c48f19faf$export$2e2bcd8739ae039 = (0, $fd4a203b6c17ff30$export$2e2bcd8739ae039);



var $6iP9u = parcelRequire("6iP9u");



var $5s1kH = parcelRequire("5s1kH");



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");



function $13f6781c71650abb$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), available = _useState[0], setAvailable = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState1[0], setLoaded = _useState1[1];
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var today = new Date();
    var getData = function() {
        api.get('coach/availability/get').then(function(result) {
            var availableEvents = [];
            var id = 1;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = result.json.available[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var available = _step.value;
                    var from = new Date(available.from);
                    var to = new Date(available.to);
                    if (available.title === 'R') {
                        from = (0, $7d185b5883a21821$export$77b0033b88d4485c)(today, from);
                        to = (0, $7d185b5883a21821$export$77b0033b88d4485c)(today, to);
                        console.log(from + ' to ' + to);
                    }
                    availableEvents.push({
                        id: id,
                        dbId: available.id,
                        title: available.title,
                        start: from,
                        end: to
                    });
                    id++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            setAvailable(availableEvents);
            setLoaded(true);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-4",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bba3de5a718626a6$export$2e2bcd8739ae039), {
                startEvents: available,
                save: true,
                calType: "available"
            }, "cal_r")
        })
    });
}



var $6iP9u = parcelRequire("6iP9u");




var $5s1kH = parcelRequire("5s1kH");





function $781ac5b781bebf8d$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), ahead = _useState[0], setAhead = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(1), 2), maxBooking = _useState1[0], setMaxBooking = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), bufferTime = _useState2[0], setBufferTime = _useState2[1];
    var setGlobalToast = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$12972e612ad7cf0));
    (0, $5s1kH.useEffect)(function() {
        api.get('coach/meeting_settings').then(function(result) {
            setAhead(result.json.ahead);
            setMaxBooking(result.json.maxBooking);
            setBufferTime(result.json.bufferTime);
        });
    }, []);
    var save = function() {
        var data = {
            ahead: ahead,
            maxBooking: maxBooking,
            bufferTime: bufferTime
        };
        api.post('coach/meeting_settings', data).then(function() {
            setGlobalToast({
                text: lang === 'sv' ? "Sparade dina inst\xe4llningar" : 'Saved your settings'
            });
        });
    };
    var timesAhead = [
        0,
        1,
        2,
        4,
        8,
        24
    ];
    var maxBookings = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ];
    var bufferTimes = [
        0,
        5,
        10,
        15,
        20,
        25,
        30,
        45
    ];
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-6 text-lg font-medium",
                children: t('time-before-booking')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "text-neutral-300",
                children: t('time-before-booking-set')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                onChange: function(e) {
                    return setAhead(parseInt(e.target.value));
                },
                className: "mt-2 z-select",
                value: ahead,
                children: timesAhead.map(function(hours) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("option", {
                        value: hours,
                        children: [
                            hours,
                            " ",
                            t('hours')
                        ]
                    }, "hours_" + hours);
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-6 text-lg font-medium",
                children: t('max-bookings')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "text-neutral-300",
                children: t('max-bookings-set')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("select", {
                onChange: function(e) {
                    return setMaxBooking(parseInt(e.target.value));
                },
                className: "mt-2 z-select",
                value: maxBooking,
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: "0",
                        children: lang === 'sv' ? 'Inget maxantal' : 'No limit'
                    }),
                    maxBookings.map(function(hours) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                            value: hours,
                            children: hours
                        }, "max_" + hours);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-6 text-lg font-medium",
                children: t('buffer-time')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "text-neutral-300",
                children: t('buffer-time-set')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                onChange: function(e) {
                    return setBufferTime(parseInt(e.target.value));
                },
                className: "mt-2 z-select",
                value: bufferTime,
                children: bufferTimes.map(function(m) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("option", {
                        value: m,
                        children: [
                            m,
                            " ",
                            t('minutes')
                        ]
                    }, "max_" + m);
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                onClick: function() {
                    return save();
                },
                className: "w-full mt-6",
                children: t('save')
            })
        ]
    });
}



var $6iP9u = parcelRequire("6iP9u");



var $5s1kH = parcelRequire("5s1kH");



var $f57693765d2f8010$exports = {};
$f57693765d2f8010$exports = $parcel$resolve("7iLn9");


var $7c923b924c57c993$exports = {};
$7c923b924c57c993$exports = $parcel$resolve("fdZu1");



var $5921d93b68ef01b3$exports = {};
$5921d93b68ef01b3$exports = $parcel$resolve("joa5K");





function $fabd55a1bdd6792d$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), calendars = _useState[0], setCalendars = _useState[1];
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get('synced_calendars/get').then(function(result) {
            setCalendars(result.json.calendars);
        });
    };
    var getEvents = function(calendarId) {
        api.get('synced_calendars/events/' + calendarId).then(function(result) {
            console.log(result.json.events);
        });
    };
    var deleteCalendar = function(id) {
        api.get('synced_calendars/delete/' + id).then(function() {
            getData();
        });
    };
    var showEventualErrors = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = calendars[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var calendar = _step.value;
                if (!calendar.hasRefreshToken && calendar.name === 'Google') return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 p-4 bg-neutral-700 border rounded-md border-cherry-500",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                                    alt: "error"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "ml-2",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "font-medium",
                                        children: lang === 'sv' ? 'Synkning misslyckades' : 'Sync failed'
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "ml-8 mt-4",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("ol", {
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("li", {
                                            children: [
                                                "1.\xa0",
                                                lang === 'sv' ? 'G\xe5 till Googles sida (nedan) och klicka p\xe5 "CoachApp".' : 'Go to the Google page (below) and click "CoachApp".'
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("li", {
                                            children: [
                                                "2.\xa0",
                                                lang === 'sv' ? 'Klicka "Radera alla kopplingar till CoachApp".' : 'Click "Delete all connections to CoachApp".'
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("li", {
                                            children: [
                                                "3.\xa0",
                                                lang === 'sv' ? "Kom tillbaka till denna sida, ta bort Google och l\xe4gg till den igen." : 'Come back to this page, remove Google and add it again.'
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                    className: "mt-4",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("a", {
                                        href: "https://myaccount.google.com/connections?filters=3,4",
                                        className: "underline",
                                        children: lang === 'sv' ? "Googles appar och tj\xe4nster fr\xe5n tredjepart" : 'Google apps and services from third part'
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var showSyncedCalendars = function() {
        if (calendars.length === 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {});
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "text-lg font-medium mt-4",
                    children: t('synced-calendars')
                }),
                showEventualErrors(),
                calendars.map(function(calendar, index) {
                    var img = calendar.name === "Microsoft" ? (0, (/*@__PURE__*/$parcel$interopDefault($5921d93b68ef01b3$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($f57693765d2f8010$exports)));
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "w-1/3 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: img,
                                        alt: "Cal",
                                        onClick: function() {
                                            return getEvents(calendar.id);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "ml-4 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "font-medium",
                                                children: calendar.name
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                children: calendar.email
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-box",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                                    alt: "delete",
                                    onClick: function() {
                                        return deleteCalendar(calendar.id);
                                    }
                                })
                            })
                        ]
                    }, "synced_calendar_" + index);
                })
            ]
        });
    };
    var syncMicrosoft = function() {
        console.log('syncMicrosoft');
        var clientId = 'bf280ab1-e7b1-4826-bbc0-2b73bb3bf11d';
        var redirect = (0, $632c75b97b900307$export$1630b5343357e8b5).APP_HOST + 'availability';
        window.location.href = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=".concat(clientId, "&redirect_uri=").concat(redirect, "&response_type=code&scope=Calendars.Read%20Calendars.Read.Shared%20offline_access&response_mode=query&state=Microsoft12");
    };
    var syncGoogle = function() {
        // https://developers.google.com/identity/protocols/oauth2/web-server#httprest_3
        console.log('syncGoogle');
        var clientId = '1083297605583-h136trshd252u8ts8l1frh3p6nmsoj3s.apps.googleusercontent.com';
        var redirect = (0, $632c75b97b900307$export$1630b5343357e8b5).APP_HOST + 'availability';
        window.location.href = "https://accounts.google.com/o/oauth2/v2/auth?client_id=".concat(clientId, "&redirect_uri=").concat(redirect, "&response_type=code&scope=https%3A//www.googleapis.com/auth/calendar.events.freebusy&access_type=offline");
    };
    var hasSyncedCalendar = function(name) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = calendars[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var calendar = _step.value;
                if (calendar.name === name) return true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    };
    var showAddCalendars = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 text-lg font-medium",
                    children: calendars.length === 0 ? lang === 'sv' ? "V\xe4lj kalender att synka med" : "Choose calendar to sync with" : lang === 'sv' ? "L\xe4gg till kalender" : "Add calendar"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 bg-neutral-700 rounded p-4",
                    children: [
                        !hasSyncedCalendar("Google") && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "font-medium",
                                    children: "Google"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                    className: "border-gray-500 mt-2"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex my-4 items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "w-1/3 flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7c923b924c57c993$exports))),
                                                    alt: "Google"
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "ml-4 text-sm font-medium"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "w-1/3 text-sm text-neutral-400",
                                            children: "Gmail, Gsuite"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                            className: "w-1/3",
                                            buttonType: "outlineWhiteBase",
                                            onClick: function() {
                                                return syncGoogle();
                                            },
                                            children: "Synka"
                                        })
                                    ]
                                })
                            ]
                        }),
                        !hasSyncedCalendar("Microsoft") && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "font-medium",
                                    children: "Microsoft"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                    className: "border-gray-500 mt-2"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex mt-4 items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "w-1/3 flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5921d93b68ef01b3$exports))),
                                                    alt: "microsoft"
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "ml-4 text-sm font-medium"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "w-1/3 text-sm text-neutral-400",
                                            children: "Office 365, Outlook.com, live.com or hotmail calendar"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                            className: "w-1/3",
                                            buttonType: "outlineWhiteBase",
                                            onClick: function() {
                                                return syncMicrosoft();
                                            },
                                            children: "Synka"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            showSyncedCalendars(),
            calendars.length < 2 && showAddCalendars()
        ]
    });
}



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");



function $a2d5f95f33d52fe9$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), available = _useState[0], setAvailable = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState1[0], setLoaded = _useState1[1];
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var today = new Date();
    var getData = function() {
        api.get('coach/availability/get?summary=1').then(function(result) {
            var availableEvents = [];
            var id = 1;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = result.json.available[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var available = _step.value;
                    var from = new Date(available.from);
                    var to = new Date(available.to);
                    if (available.title === 'R') {
                        from = (0, $7d185b5883a21821$export$77b0033b88d4485c)(today, from);
                        to = (0, $7d185b5883a21821$export$77b0033b88d4485c)(today, to);
                    }
                    if (available.title === 'S' && from.getDate() !== to.getDate()) {
                        // We cannot render event from 0 to 0 next day. If we find that, change to start at 1 and end 23
                        if (from.getHours() === 0) from.setHours(1);
                        if (to.getHours() === 0) {
                            to.setDate(to.getDate() - 1);
                            to.setHours(23);
                        }
                    }
                    availableEvents.push({
                        id: id,
                        dbId: available.id,
                        title: available.title,
                        start: from,
                        end: to
                    });
                    id++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            setAvailable(availableEvents);
            setLoaded(true);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-4",
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bba3de5a718626a6$export$2e2bcd8739ae039), {
                startEvents: available,
                save: false,
                calType: "summary"
            }, "cal_r")
        })
    });
}


var $d18234a83fe225f0$var$tabs = /*#__PURE__*/ function(tabs) {
    tabs[tabs["SCHEDULE"] = 0] = "SCHEDULE";
    tabs[tabs["OTHER_SETTINGS"] = 1] = "OTHER_SETTINGS";
    tabs[tabs["SYNC_EXTERNAL_CALENDAR"] = 2] = "SYNC_EXTERNAL_CALENDAR";
    tabs[tabs["SCHEDULE_SUMMARY"] = 3] = "SCHEDULE_SUMMARY";
    return tabs;
}($d18234a83fe225f0$var$tabs || {});
function $d18234a83fe225f0$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), view = _useState[0], setView = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), activeTab = _useState1[0], setActiveTab = _useState1[1];
    (0, $5s1kH.useEffect)(function() {
        var oauth_temp = window.localStorage["oauth_temp"];
        if (oauth_temp) {
            var keyVals = {};
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = oauth_temp.substring(1).split('&')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var pair = _step.value;
                    var _pair_split = (0, $6iP9u._)(pair.split('='), 2), k = _pair_split[0], v = _pair_split[1];
                    keyVals[k] = decodeURIComponent(v);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (keyVals['code']) {
                // window.history.replaceState("", document.title, window.location.pathname);
                var state = keyVals['state'];
                var name = "Google";
                if (state && state.startsWith("Microsoft")) name = "Microsoft";
                var data = {
                    email: 'unknown',
                    name: name,
                    code: keyVals['code']
                };
                api.post('synced_calendars/set', data).then(function() {
                    window.localStorage.removeItem("oauth_temp");
                    setView(2);
                    setActiveTab(2);
                }).catch(function(response) {
                    return console.log(response);
                });
            }
        }
    }, []);
    var renderTab = function() {
        if (view === 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $13f6781c71650abb$export$2e2bcd8739ae039), {});
        else if (view === 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $781ac5b781bebf8d$export$2e2bcd8739ae039), {});
        else if (view === 3) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a2d5f95f33d52fe9$export$2e2bcd8739ae039), {});
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $fabd55a1bdd6792d$export$2e2bcd8739ae039), {});
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "text-2xl font-medium text-white  my-4 desktop:my-6",
                children: t('availability')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c8483606065062df$export$2e2bcd8739ae039), {
                items: [
                    {
                        title: t('schedule'),
                        callback: function() {
                            return setView(0);
                        }
                    },
                    {
                        title: t('other-settings'),
                        callback: function() {
                            return setView(1);
                        }
                    },
                    {
                        title: t('sync-external-calendar'),
                        callback: function() {
                            return setView(2);
                        }
                    },
                    {
                        title: t('summary'),
                        callback: function() {
                            return setView(3);
                        }
                    }
                ],
                active: activeTab
            }),
            renderTab()
        ]
    });
}



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");




var $25a5ea99e026289e$export$f269ae6352e55a31 = /*#__PURE__*/ function(VisionStatementStatus) {
    VisionStatementStatus[VisionStatementStatus["Created"] = 2] = "Created";
    return VisionStatementStatus;
}({});
var $25a5ea99e026289e$export$579eee0d55ead4be = /*#__PURE__*/ function(VisionStatementPartStatus) {
    VisionStatementPartStatus[VisionStatementPartStatus["Done"] = 1] = "Done";
    return VisionStatementPartStatus;
}({});






var $7069d51271232be0$exports = {};
$7069d51271232be0$exports = $parcel$resolve("ex8Dk");












var $b45ef52a3cebd91f$var$CoachVisionStatement = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)((0, $1af830c9fe0316f4$export$a8d543f4b6260801)()), 2), tab = _useState2[0], setTab = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), goals = _useState3[0], setGoals = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), activities = _useState4[0], setActivities = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), viewGoal = _useState5[0], setViewGoal = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), viewAction = _useState6[0], setViewAction = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), viewActivity = _useState7[0], setViewActivity = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), surveyRequestNr = _useState8[0], setSurveyRequestNr = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)({
        id: "",
        firstName: "",
        lastName: ""
    }), 2), client = _useState9[0], setClient = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)({
        id: "",
        surveyId: null,
        title: "",
        description: "",
        deadline: "",
        progress: 0,
        development: 0,
        effort: 0,
        onTrack: 0,
        status: 2,
        avgGap: 0,
        questions: [],
        surveyRequests: [],
        customerCategoryId: "",
        goalsTotal: 0,
        goalsCompleted: 0,
        activitiesCompleted: 0,
        activitiesTotal: 0
    }), 2), visionStatement = _useState10[0], setVisionStatement = _useState10[1];
    var id = (0, $bHX26.useParams)().id;
    var today = new Date();
    var todayDate = today.toISOString().substring(0, 10);
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        // When we reload data after a change of goal or action, check if we need to update viewGoal or viewAction
        if (viewGoal) {
            var foundGoal = false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = goals[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var goal = _step.value;
                    if (viewGoal.id === goal.id) {
                        setViewGoal(goal);
                        foundGoal = true;
                        if (viewAction) {
                            var found = false;
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = goal.actions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var action = _step1.value;
                                    if (viewAction.id === action.id) {
                                        setViewAction(action);
                                        found = true;
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            if (!found) // Assume it is deleted
                            setViewAction(null);
                        }
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (!foundGoal) // Assume it was deleted
            setViewGoal(null);
        } else if (viewActivity) {
            var found1 = false;
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = activities[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var activity = _step2.value;
                    if (viewActivity.id === activity.id) {
                        setViewActivity(activity);
                        found1 = true;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            if (!found1) // Assume it was deleted
            setViewActivity(null);
        }
    }, [
        goals,
        activities
    ]);
    var changeTab = function(_tab) {
        setTab(_tab);
        (0, $1af830c9fe0316f4$export$a7d4a63c0f4094bf)(_tab);
        if (_tab > 0) {
            setViewGoal(null);
            setViewAction(null);
            setViewActivity(null);
        }
    };
    var getData = function() {
        api.get("coach/client/vision_statement/" + id).then(function(response) {
            if (response.json.status === "ok") {
                var _visionStatement = response.json.visionStatement;
                setVisionStatement(_visionStatement);
                setGoals(response.json.goals);
                setActivities(response.json.activities);
                setClient(response.json.client);
            } else if (response.json.error) setError(response.json.error);
            else setError("Unknown error");
            setLoading(false);
        });
    };
    if (loading) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (error.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    var renderSuccessPlan = function() {
        if (goals.length > 0 || activities.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                goals.map(function(goal, i) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        children: [
                            i === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4 z-title1",
                                children: t("sub-goals")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mt-2 p-4 bg-indigo-800 rounded-md hover:bg-indigo-700 cursor-pointer",
                                onClick: function() {
                                    setViewGoal(goal);
                                    setViewActivity(null);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "z-title1 flex items-center gap-x-2",
                                                children: [
                                                    goal.title,
                                                    goal.status === (0, $25a5ea99e026289e$export$579eee0d55ead4be).Done && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3d60ab5b0b00a842$export$2e2bcd8739ae039), {
                                                        text: t("completed"),
                                                        color: "green",
                                                        iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
                                                        size: "small"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                        className: "z-title3",
                                                        children: [
                                                            t("due-date"),
                                                            ": "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                        className: "text-sm text-gray-300",
                                                        children: goal.deadline
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                className: "text-gray-100 font-medium",
                                                children: [
                                                    lang === "sv" ? "Beteenden och uppgifter" : "Behaviours and actions",
                                                    ": "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                className: "text-gray-300",
                                                children: [
                                                    goal.actions.filter(function(g) {
                                                        return g.status === 1;
                                                    }).length,
                                                    " ",
                                                    t("of"),
                                                    "\xa0",
                                                    goal.actions.length,
                                                    " ",
                                                    t("completed").toLowerCase()
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, "goal_" + i);
                }),
                activities.map(function(activity, i) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        children: [
                            i === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4 z-title1",
                                children: t("activities")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-2 p-4 bg-indigo-800 rounded-md hover:bg-indigo-700 cursor-pointer",
                                onClick: function() {
                                    setViewActivity(activity);
                                    setViewGoal(null);
                                },
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "flex items-center gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "z-title1",
                                                    children: activity.title
                                                }),
                                                activity.status === (0, $25a5ea99e026289e$export$579eee0d55ead4be).Done && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3d60ab5b0b00a842$export$2e2bcd8739ae039), {
                                                    text: t("completed"),
                                                    color: "green",
                                                    iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
                                                    size: "small"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                    className: "z-title3",
                                                    children: [
                                                        t("due-date"),
                                                        ": "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                    className: "text-sm text-gray-300",
                                                    children: activity.deadline
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }, "activity_" + i);
                })
            ]
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4 bg-indigo-900 rounded-md text-center p-4",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    children: lang === "sv" ? "B\xf6rja bygga din framg\xe5ngsplan med verktyg som f\xf6r dig mot denna m\xe5lbild." : "Start building your success plan with tools that move you towards this vision."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    className: "mt-4 mx-auto",
                    style: {
                        width: "unset"
                    },
                    onClick: function() {
                        return changeTab(1);
                    },
                    children: lang === "sv" ? "Utforska verktygsl\xe5dan" : "Explore the toolkit"
                })
            ]
        });
    };
    var renderToolkit = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4 flex flex-wrap gap-4",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "main-half-col x-small rounded-lg p-4 border border-indigo-800 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "h-14 w-14 bg-indigo-800 p-4 rounded-full shrink-0",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7069d51271232be0$exports))),
                                alt: "flag",
                                className: "h-6 w-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "ml-4",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "font-medium text-gray-100",
                                    children: lang === "sv" ? "Skapa ett delm\xe5l" : "Create a sub-goal"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "font-medium text-gray-400",
                                    children: lang === "sv" ? "Bryt ner din m\xe5lbild i uppn\xe5eliga resultat." : "Break down your vision into achievable milestones."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "main-half-col x-small rounded-lg p-4 border border-indigo-800 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "h-14 w-14 bg-indigo-800 p-4 rounded-full shrink-0",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($584664dac616447b$exports))),
                                alt: "flag",
                                className: "h-6 w-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "ml-4",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "font-medium text-gray-100",
                                    children: lang === "sv" ? "Skapa en aktivitet" : "Create an activity"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "font-medium text-gray-400",
                                    children: lang === "sv" ? "Ta sm\xe5 steg mot din m\xe5lbild." : "Take small steps towards your vision."
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var renderStepper = function(surveyRequest, surveyResult) {
        if (surveyRequest.deadline < todayDate) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-4 bg-indigo-800 rounded-sm p-4",
            children: "Feedback request failed"
        });
        var description1;
        var description2 = lang === "sv" ? "Be om feedback" : "Send a request to those around you";
        var description3 = lang === "sv" ? "V\xe4ntar p\xe5 feedback" : "Waiting for feedback";
        var buttonText = "";
        var navigateTo = "";
        var step = 0;
        var completedSteps = [];
        if (surveyResult.scoreSelf > 0) {
            completedSteps.push(0);
            step++;
            description1 = lang === "sv" ? "Klar" : "Completed";
        } else {
            description1 = lang === "sv" ? "Slutf\xf6r din sj\xe4lvskattning" : "Complete your self-assessment to continue";
            buttonText = lang === "sv" ? "G\xf6r sj\xe4lvskattning" : "Do self-assessment";
            navigateTo = "/feedback/survey/" + surveyRequest.id;
        }
        if (step > 0) {
            if (surveyResult.respondents.length > 0) {
                completedSteps.push(1);
                step++;
                description2 = lang === "sv" ? "Skickad" : "Sent";
            } else {
                buttonText = t("request-feedback");
                navigateTo = "/dev-plan/survey_request_invite/" + surveyRequest.id;
            }
        }
        var stepsData = [
            {
                title: t("self-assessment"),
                description: description1,
                content: null
            },
            {
                title: t("feedback-request"),
                description: description2,
                content: null
            },
            {
                title: lang === "sv" ? "Feedbackresultat och analys" : "Feedback result and analysis",
                description: description3,
                content: null
            }
        ];
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4 bg-indigo-800 rounded-sm px-4 pb-4",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e949fc66b34e9329$export$2e2bcd8739ae039), {
                    steps: stepsData,
                    direction: "vertical",
                    currentIndex: step,
                    completedSteps: completedSteps
                }),
                buttonText.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 flex justify-center",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "blueBase",
                        style: {
                            width: "unset"
                        },
                        onClick: function() {
                            return navigate(navigateTo);
                        },
                        children: buttonText
                    })
                })
            ]
        });
    };
    var renderFeedbackResult = function() {
        if (visionStatement.surveyRequests.length === 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mb-4 text-gray-400",
            children: lang === "sv" ? "Inga klara feedbackresultat" : "No completed feedback requests"
        });
        var surveyRequest = visionStatement.surveyRequests[surveyRequestNr];
        if (!surveyRequest.surveyResult) return null;
        var scoreSelf = 0;
        var scoreOther = 0;
        var selfNr = 0;
        var otherNr = 0;
        var surveyResult = surveyRequest.surveyResult;
        var questions = [];
        if (surveyRequest.surveyResult) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator = surveyResult.focusAreas[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                    var focusArea = _step.value;
                    try {
                        for(var _iterator1 = focusArea.questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                            var question = _step1.value;
                            questions.push(question);
                            if (question.scoreSelf > 0) {
                                scoreSelf += question.scoreSelf;
                                selfNr++;
                            }
                            if (question.scoreOther > 0) {
                                scoreOther += question.scoreOther;
                                otherNr++;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            if (selfNr) scoreSelf /= selfNr;
            if (otherNr) scoreOther /= otherNr;
        }
        // const questions = surveyResult.focusAreas[0].questions;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                visionStatement.surveyRequests.length > 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mb-4",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                        className: "z-select small",
                        style: {
                            width: "unset"
                        },
                        onChange: function(e) {
                            return setSurveyRequestNr(parseInt(e.target.value));
                        },
                        value: surveyRequestNr,
                        children: visionStatement.surveyRequests.map(function(surveyRequest, i) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                value: i,
                                children: surveyRequest.created.substring(0, 10)
                            }, "sr_" + i);
                        })
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "bg-indigo-900 rounded-md p-4",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "font-medium text-gray-100",
                                    children: t("overview")
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "h-4 w-4 rounded-full bg-peach-500",
                                            onClick: function() {
                                                return getData();
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-sm ml-2 text-gray-100",
                                            children: t("self-assessment")
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "h-4 w-4 rounded-full bg-peach-300 ml-4"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-sm ml-2 text-gray-100",
                                            children: "Feedback"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "main-half-col small mt-2",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $200b3872b8c265f8$export$2e2bcd8739ae039), {
                                value1: scoreSelf,
                                value2: scoreOther,
                                results1: scoreSelf.toFixed(1) + "/5",
                                results2: scoreOther.toFixed(1) + "/5"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $847f86c5796e8d1c$export$2e2bcd8739ae039), {
                            questions: questions,
                            lang: lang,
                            surveyResult: surveyResult,
                            feedbackType: 0,
                            clientName: "Client name"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 z-title1",
                    children: t("details")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($eda3564600df02e0$exports))),
                            alt: "sent",
                            className: "h-4 w-4 mr-2"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "z-title3",
                            children: [
                                t("request-sent"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "text-sm text-gray-400",
                            children: [
                                "\xa0",
                                surveyRequest.created.substring(0, 10)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                            alt: "cal",
                            className: "h-4 w-4 mr-2"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "z-title3",
                            children: [
                                t("result-created-at"),
                                ":\xa0"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-sm text-gray-400",
                            children: surveyRequest.completed ? surveyRequest.completed.substring(0, 10) : t("pending")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($dd0ccd8d6f00a586$exports))),
                            alt: "open",
                            className: "h-4 w-4 mr-2"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "z-title3",
                            children: [
                                t("received"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "text-sm text-gray-400",
                            children: [
                                "\xa0",
                                surveyResult.nrOtherResponses,
                                " ",
                                t("out-of"),
                                " ",
                                surveyResult.respondents.length
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var renderFeedback = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-4",
            children: renderFeedbackResult()
        });
    };
    var renderCreated = function() {
        var items = [
            {
                title: t("success-plan"),
                callback: function() {
                    return changeTab(0);
                }
            },
            {
                title: t("toolkit"),
                callback: function() {
                    return changeTab(1);
                }
            },
            {
                title: "Feedback",
                callback: function() {
                    return changeTab(2);
                }
            }
        ];
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                visionStatement.progress !== 100 && visionStatement.deadline < todayDate && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 border border-primary-500 bg-indigo-800 rounded-md p-4",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports))),
                                    alt: "time",
                                    className: "h-6 w-6"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "font-medium ml-2",
                                    children: lang === "sv" ? "Slutdatumet \xe4r h\xe4r" : "Due date is here"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-2 text-sm text-gray-300",
                            children: lang === "sv" ? "Hur l\xe5ngt har du kommit? Uppdatera din status och forts\xe4tt fram\xe5t." : "Update your progress to move forward."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 flex items-center justify-between",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex gap-x-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-h2",
                                children: visionStatement.title
                            }),
                            visionStatement.progress === 100 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3d60ab5b0b00a842$export$2e2bcd8739ae039), {
                                text: lang === "sv" ? "Klar" : "Completed",
                                color: "green",
                                size: "small"
                            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                                children: (0, $b841e7314e3d419d$export$9874b5b4c45031c5)(visionStatement.onTrack, lang)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 z-title3 text-gray-300",
                    children: t("description")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "text-gray-400",
                    children: visionStatement.description
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 z-title3 text-gray-300",
                    children: t("due-date")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "text-gray-400",
                    children: visionStatement.deadline
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex mt-6 items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "h-2 rounded-full bg-indigo-700",
                            style: {
                                width: "calc(100% - 200px"
                            },
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "h-2 rounded-full bg-primary-500",
                                style: {
                                    width: visionStatement.progress + "%"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "ml-1 text-sm gray-300",
                            children: [
                                visionStatement.progress,
                                "%"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c8483606065062df$export$2e2bcd8739ae039), {
                        active: tab,
                        items: items
                    })
                }),
                tab === 0 && renderSuccessPlan(),
                tab === 1 && renderToolkit(),
                tab === 2 && renderFeedback()
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col small pb-4",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: lang === "sv" ? "Hem" : "Home",
                        url: "/"
                    },
                    {
                        name: t('my-clients'),
                        url: '/clients'
                    },
                    {
                        name: client.firstName + " " + client.lastName,
                        url: "/clients/" + client.id
                    },
                    {
                        name: t("vision_statement")
                    }
                ]
            }),
            renderCreated()
        ]
    });
};
var $b45ef52a3cebd91f$export$2e2bcd8739ae039 = $b45ef52a3cebd91f$var$CoachVisionStatement;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");




function $e69e74f145378b26$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(''), 2), email = _useState[0], setEmail = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(''), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(''), 2), errorName = _useState2[0], setErrorName = _useState2[1];
    var submit = function() {
        var data = {
            email: email
        };
        api.postRaw('coach/signup', data).then(function(response) {
            response.json().then(function(json) {
                console.log(json);
                if (json.error) {
                    setError(json.error);
                    setErrorName(json.name);
                    console.log('Error name is ' + json.name);
                } else setError('');
                if (json.status === 'ok') {
                    var inviteCode = json.inviteCode;
                    if (inviteCode && inviteCode.length > 8) window.location.replace("/accept_invite/" + inviteCode);
                }
            }).catch(function(err) {
                return alert(err);
            });
        }).catch(function(err) {
            return alert(err);
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                className: "text-2xl font-medium mt-6",
                children: "Welcome to Zebrain!"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-2 text-neutral-400",
                children: "We\u2019re excited that you\u2019re considering joining our platform! Before applying, please review the requirements and process outlined below to ensure we\u2019re a great match."
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-6 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h2", {
                className: "text-2xl font-medium mt-6",
                children: "Our requirements"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-2 text-neutral-400",
                children: "We require all our coaches to meet the following criteria:"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 flex",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
                        alt: "checkmark",
                        className: "h-6"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-1",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-lg font-medium",
                                children: "Certification:"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: "Hold a valid coach certification (e.g. from ICF)."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 flex",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
                        alt: "checkmark",
                        className: "h-6"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-1",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-lg font-medium",
                                children: "Experience:"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: "A minimum of 200 logged coaching hours."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-6 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h2", {
                className: "text-2xl font-medium mt-6",
                children: "The process on how to become a coach"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-4 text-neutral-400",
                children: "Here is the process overview:"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 flex",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "1."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-1",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-lg font-medium",
                                children: "Submit your application"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: "Complete the application form (approximately 15\u201320 minutes)."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 flex",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "2."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-1",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-lg font-medium",
                                children: "Application review"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: "Our team will carefully review your application."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 flex",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "3."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-1",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-lg font-medium",
                                children: "Set up your profile"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: "If approved, you\u2019ll receive an email with a link to create your public presentation and set your availability."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 flex",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "4."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-1",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "text-lg font-medium",
                                children: "Start coaching"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: "Once your profile is live, you can begin receiving session bookings!"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-6 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h2", {
                className: "text-2xl font-medium mt-6",
                children: "Next Step - Enter your email to apply"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "mt-4 text-neutral-400",
                children: "Please enter the e-mail that you want to create your account with in the next step."
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                className: "z-input mt-2",
                type: "text",
                value: email,
                onChange: function(e) {
                    return setEmail(e.target.value);
                },
                placeholder: "coach@gmail.com"
            }),
            error.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "ml-2",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "font-medium",
                            children: error
                        })
                    })
                ]
            }),
            errorName === 'already_created' ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-4",
                onClick: function() {
                    return navigate('/');
                },
                children: "Go to platform.zebrain.se"
            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: function() {
                    return submit();
                },
                children: "Next"
            })
        ]
    });
}



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");


var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");



var $692746691f118d36$var$StepOne = function(props) {
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.firstName), 2), firstName = _useState[0], setFirstName = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.lastName), 2), lastName = _useState1[0], setLastName = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.phone), 2), phone = _useState2[0], setPhone = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.company), 2), company = _useState3[0], setCompany = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.organisationNumber), 2), organisationNumber = _useState4[0], setOrganisationNumber = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.companyAddress), 2), companyAddress = _useState5[0], setCompanyAddress = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), errors = _useState6[0], setErrors = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)([
        "",
        "",
        "",
        "",
        "",
        ""
    ]), 2), errorFields = _useState7[0], setErrorFields = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), triedSave = _useState8[0], setTriedSave = _useState8[1];
    (0, $5s1kH.useEffect)(function() {
        (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (triedSave) checkInput();
    }, [
        firstName,
        lastName,
        phone,
        company,
        organisationNumber,
        companyAddress
    ]);
    var checkInput = function() {
        var _errors = 0;
        var _errorFields = [
            "",
            "",
            "",
            "",
            "",
            ""
        ];
        if (firstName.length < 1) {
            _errors++;
            _errorFields[0] = "Too short";
        }
        if (lastName.length < 1) {
            _errors++;
            _errorFields[1] = "Too short";
        }
        if (phone.length < 1) {
            _errors++;
            _errorFields[2] = "Too short";
        }
        if (company.length < 1) {
            _errors++;
            _errorFields[3] = "Too short";
        }
        if (organisationNumber.length < 1) {
            _errors++;
            _errorFields[4] = "Too short";
        }
        if (companyAddress.length < 1) {
            _errors++;
            _errorFields[5] = "Too short";
        }
        setErrors(_errors);
        setErrorFields(_errorFields);
        return _errors;
    };
    var save = function() {
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        var _application = props.application;
        _application.firstName = firstName;
        _application.lastName = lastName;
        _application.phone = phone;
        _application.company = company;
        _application.organisationNumber = organisationNumber;
        _application.companyAddress = companyAddress;
        props.save(_application);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Personal and company details"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 ring-primary-500",
                children: "First name"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                value: firstName,
                className: "z-input mt-2" + (triedSave && errorFields[0] ? " error" : ""),
                onChange: function(e) {
                    return setFirstName(e.target.value);
                }
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: "Last name"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                value: lastName,
                className: "z-input mt-2" + (triedSave && errorFields[1] ? " error" : ""),
                onChange: function(e) {
                    return setLastName(e.target.value);
                }
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: "Phone number"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                value: phone,
                placeholder: "+46701234567",
                className: "z-input mt-2" + (triedSave && errorFields[2] ? " error" : ""),
                onChange: function(e) {
                    return setPhone(e.target.value);
                }
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: "Company name"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                value: company,
                className: "z-input mt-2" + (triedSave && errorFields[3] ? " error" : ""),
                onChange: function(e) {
                    return setCompany(e.target.value);
                }
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: "Organisation number"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                value: organisationNumber,
                className: "z-input mt-2" + (triedSave && errorFields[4] ? " error" : ""),
                onChange: function(e) {
                    return setOrganisationNumber(e.target.value);
                }
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: "Company address"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                value: companyAddress,
                className: "z-input mt-2" + (triedSave && errorFields[5] ? " error" : ""),
                onChange: function(e) {
                    return setCompanyAddress(e.target.value);
                }
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please make sure all fields are filled out correctly"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: function() {
                    return save();
                },
                children: "Next"
            })
        ]
    });
};
var $692746691f118d36$export$2e2bcd8739ae039 = $692746691f118d36$var$StepOne;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");




var $3e8914f73eec66e0$var$StepTwo = function(props) {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.certificateFile), 2), certificateFile = _useState[0], setCertificateFile = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.yearOfCertification), 2), yearOfCertification = _useState1[0], setYearOfCertification = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.coachingHours + ""), 2), coachingHours = _useState2[0], setCoachingHours = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), errors = _useState3[0], setErrors = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)([
        "",
        "",
        ""
    ]), 2), errorFields = _useState4[0], setErrorFields = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), triedSave = _useState5[0], setTriedSave = _useState5[1];
    var now = new Date();
    var thisYear = now.getFullYear();
    (0, $5s1kH.useEffect)(function() {
        (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (triedSave) checkInput();
    }, [
        certificateFile,
        yearOfCertification,
        coachingHours
    ]);
    var checkInput = function() {
        var _errors = 0;
        var _errorFields = [
            "",
            "",
            "",
            "",
            "",
            ""
        ];
        if (!certificateFile) {
            _errors++;
            _errorFields[0] = "Please upload a certificate";
        }
        if (yearOfCertification === 0) {
            _errors++;
            _errorFields[1] = "Please select the year of certification";
        } else if (yearOfCertification < 2022) {
            _errors++;
            _errorFields[1] = "Your certificate shouldn't be older than three years, please renew it";
        }
        var _coachingHours = parseInt(coachingHours);
        if (isNaN(_coachingHours)) {
            _errors++;
            _errorFields[2] = "Please enter a valid number";
        } else if (_coachingHours < 200) {
            _errors++;
            _errorFields[2] = "You need to have at least 200 coaching hours to register with Zebrain";
        }
        setErrors(_errors);
        setErrorFields(_errorFields);
        return _errors;
    };
    var changeYear = function(year) {
        setYearOfCertification(parseInt(year));
    };
    var changeCoachingHours = function(hours) {
        setCoachingHours(hours);
    };
    var save = function() {
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        var _application = props.application;
        _application.certificateFile = certificateFile;
        _application.yearOfCertification = yearOfCertification;
        _application.coachingHours = parseInt(coachingHours);
        props.save(_application);
    };
    var uploadFile = function(evt) {
        if (evt === null) {
            alert('Empty event');
            return;
        }
        var file = evt.target.files[0];
        if (!file) {
            console.log('No file');
            return;
        }
        var reader = new FileReader();
        reader.onload = function(theFile) {
            return function(e) {
                var data = {
                    file_data: e.target.result,
                    file_name: file.name
                };
                api.post('coach/upload/certificate', data).then(function(result) {
                    setCertificateFile(result.json.fileName);
                });
            };
        }(file);
        reader.readAsDataURL(file);
    };
    var showUploadedFile = function() {
        if (!certificateFile) return "";
        var fParts = certificateFile.split('/');
        return fParts[fParts.length - 1];
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Certification"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                        id: "certFile",
                        type: "file",
                        className: "hidden",
                        onChange: function(e) {
                            return uploadFile(e);
                        }
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: "Certificate"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("label", {
                        htmlFor: "certFile",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "bg-neutral-700 rounded-full py-3 px-4 cursor-pointer",
                            children: certificateFile ? 'Change' : 'Upload'
                        })
                    })
                ]
            }),
            certificateFile && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "text-sm font-medium text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("a", {
                        target: "_new",
                        href: certificateFile,
                        children: showUploadedFile()
                    }),
                    " has been uploaded"
                ]
            }),
            errorFields[0].length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-2 text-cherry-500",
                children: errorFields[0]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: "Year of certification"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("select", {
                value: yearOfCertification + "",
                onChange: function(e) {
                    return changeYear(e.target.value);
                },
                className: "z-select mt-2" + (triedSave && errorFields[1] ? " error" : ""),
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: 0,
                        children: "Select year"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: thisYear,
                        children: thisYear
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: thisYear - 1,
                        children: thisYear - 1
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: thisYear - 2,
                        children: thisYear - 2
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: thisYear - 3,
                        children: thisYear - 3
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("option", {
                        value: thisYear - 4,
                        children: [
                            "Before ",
                            thisYear - 3
                        ]
                    })
                ]
            }),
            errorFields[1].length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-2 text-cherry-500",
                children: errorFields[1]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: "Total coaching hours"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                value: coachingHours,
                placeholder: "Coaching hours",
                className: "z-input mt-2" + (triedSave && errorFields[2] ? " error" : ""),
                onChange: function(e) {
                    return changeCoachingHours(e.target.value);
                }
            }),
            errorFields[2].length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-2 text-cherry-500",
                children: errorFields[2]
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please make sure all fields are filled out correctly"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: function() {
                    return save();
                },
                children: "Next"
            })
        ]
    });
};
var $3e8914f73eec66e0$export$2e2bcd8739ae039 = $3e8914f73eec66e0$var$StepTwo;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");



var $3220afffacbace8e$var$StepThree = function(props) {
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.linkedinUrl), 2), linkedinUrl = _useState[0], setLinkedinUrl = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), errors = _useState1[0], setErrors = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)([
        "",
        ""
    ]), 2), errorFields = _useState2[0], setErrorFields = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), triedSave = _useState3[0], setTriedSave = _useState3[1];
    (0, $5s1kH.useEffect)(function() {
        (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (triedSave) checkInput();
    }, [
        linkedinUrl
    ]);
    var checkInput = function() {
        var _errors = 0;
        var _errorFields = [
            "",
            ""
        ];
        if (linkedinUrl.length < 1) {
            _errors++;
            _errorFields[1] = "Too short";
        }
        setErrors(_errors);
        setErrorFields(_errorFields);
        return _errors;
    };
    var save = function() {
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        var _application = props.application;
        _application.linkedinUrl = linkedinUrl;
        props.save(_application);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Certification"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: "LinkedIn profile"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                value: linkedinUrl,
                placeholder: "Linkedin Url",
                className: "z-input mt-2" + (triedSave && errorFields[1] ? " error" : ""),
                onChange: function(e) {
                    return setLinkedinUrl(e.target.value);
                }
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please make sure all fields are filled out correctly"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: function() {
                    return save();
                },
                children: "Next"
            })
        ]
    });
};
var $3220afffacbace8e$export$2e2bcd8739ae039 = $3220afffacbace8e$var$StepThree;



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");





parcelRequire("5s1kH");

var $bbabdb0ca63638f3$var$Chip = function(props) {
    var remove = function() {
        if (props.remove) props.remove();
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "bg-neutral-600 rounded-full mt-2 py-1.5 px-3 mr-2 flex items-center",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "text-sm font-medium",
                children: props.txt
            }),
            props.remove && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                className: "ml-2 h-4 cursor-pointer",
                alt: "delete",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                onClick: function() {
                    return remove();
                }
            })
        ]
    });
};
var $bbabdb0ca63638f3$export$2e2bcd8739ae039 = $bbabdb0ca63638f3$var$Chip;



var $cacf689decfd9551$var$allOptions = [
    "cs",
    "da",
    "nl",
    "fi",
    "fr",
    "en",
    "de",
    "el",
    "hu",
    "it",
    "no",
    "pl",
    "pt",
    "es",
    "sv"
];
var $cacf689decfd9551$var$StepFour = function(props) {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.languagesNative), 2), languagesNative = _useState[0], setLanguagesNative = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.languagesProfessional), 2), languagesProfessional = _useState1[0], setLanguagesProfessional = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.additionalLanguages), 2), additionalLanguages = _useState2[0], setAdditionalLanguages = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), errors = _useState3[0], setErrors = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), triedSave = _useState4[0], setTriedSave = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)($cacf689decfd9551$var$allOptions), 2), options = _useState5[0], setOptions = _useState5[1];
    (0, $5s1kH.useEffect)(function() {
        (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        updateOptions();
        if (triedSave) checkInput();
    }, [
        languagesNative,
        languagesProfessional
    ]);
    var checkInput = function() {
        var _errors = 0;
        if (languagesNative.length < 1 && languagesProfessional.length < 1) _errors++;
        setErrors(_errors);
        return _errors;
    };
    var save = function() {
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        var _application = props.application;
        _application.languagesNative = languagesNative;
        _application.languagesProfessional = languagesProfessional;
        _application.additionalLanguages = additionalLanguages;
        props.save(_application);
    };
    var addLanguage = function(lang, native) {
        var _languages = native ? (0, $XnYkK._)(languagesNative) : (0, $XnYkK._)(languagesProfessional);
        _languages.push(lang);
        if (native) setLanguagesNative(_languages);
        else setLanguagesProfessional(_languages);
    };
    var removeLanguage = function(lang, native) {
        var _languages = native ? languagesNative : languagesProfessional;
        var _newLanguages = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _languages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _language = _step.value;
                if (lang !== _language) _newLanguages.push(_language);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (native) setLanguagesNative(_newLanguages);
        else setLanguagesProfessional(_newLanguages);
    };
    var updateOptions = function() {
        var _options = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $cacf689decfd9551$var$allOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var option = _step.value;
                if (languagesNative.indexOf(option) < 0 && languagesProfessional.indexOf(option) < 0) _options.push(option);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setOptions(_options);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: t('languages')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4 text-neutral-400",
                children: lang === 'sv' ? "V\xe4lj de spr\xe5k du k\xe4nner dig bekv\xe4m att coacha p\xe5 nedan." : 'Please choose the languages that you feel confident to coach in under the proficiency levels below.'
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 font-medium",
                children: lang === 'sv' ? "Modersm\xe5l" : 'Native'
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("select", {
                value: "",
                onChange: function(e) {
                    return addLanguage(e.target.value, true);
                },
                className: "z-select mt-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: "",
                        children: t("select")
                    }),
                    options.map(function(option, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                            value: option,
                            children: t(option)
                        }, "native_" + index);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex flex-wrap items-center",
                children: languagesNative.map(function(language, index) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bbabdb0ca63638f3$export$2e2bcd8739ae039), {
                        txt: t(language),
                        remove: function() {
                            return removeLanguage(language, true);
                        }
                    }, "native_" + index);
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 font-medium",
                children: lang === 'sv' ? 'Professionell' : 'Professional'
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("select", {
                value: "",
                onChange: function(e) {
                    return addLanguage(e.target.value, false);
                },
                className: "z-select mt-2",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                        value: "",
                        children: t("select")
                    }),
                    options.map(function(option, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                            value: option,
                            children: t(option)
                        }, "professional_" + index);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex flex-wrap items-center",
                children: languagesProfessional.map(function(language, index) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bbabdb0ca63638f3$export$2e2bcd8739ae039), {
                        txt: t(language),
                        remove: function() {
                            return removeLanguage(language, false);
                        }
                    }, "prof_" + index);
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: lang === 'sv' ? "Andra spr\xe5k du kan coacha p\xe5" : 'Other languages you can coach in'
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                value: additionalLanguages,
                className: "z-input mt-2",
                onChange: function(e) {
                    return setAdditionalLanguages(e.target.value);
                }
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: lang === 'sv' ? "V\xe4lj minst ett spr\xe5k under modersm\xe5l eller professionell" : 'Please select at least one native or professional language'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: function() {
                    return save();
                },
                children: t('next')
            })
        ]
    });
};
var $cacf689decfd9551$export$2e2bcd8739ae039 = $cacf689decfd9551$var$StepFour;



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");

var $534b9d242f4a5204$export$e6abe0fdb57da24d = [
    {
        name: "Extensive",
        value: 3
    },
    {
        name: "Moderate",
        value: 2
    },
    {
        name: "Basic",
        value: 1
    },
    {
        name: "None",
        value: 0
    }
];









var $bdcb751e842e09ff$var$StepFive = function(props) {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.experienceByArea), 2), areas = _useState[0], setAreas = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.additionalAreas), 2), additionalAreas = _useState1[0], setAdditionalAreas = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(''), 2), error = _useState2[0], setError = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), triedSave = _useState3[0], setTriedSave = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showModal = _useState4[0], setShowModal = _useState4[1];
    (0, $5s1kH.useEffect)(function() {
        (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (triedSave) checkInput();
    }, [
        areas
    ]);
    var checkInput = function() {
        var _not_none = 0;
        var _error = '';
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = areas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var a = _step.value;
                if (a.value > 0) _not_none++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (areas.length < props.experiencesByArea.length) _error = "Please select an option for all coaching areas";
        else if (_not_none < 1) _error = "You need to have experience in at least one coaching area";
        setError(_error);
        return _error;
    };
    var save = function() {
        setTriedSave(true);
        if (checkInput().length > 0) return;
        var _application = props.application;
        _application.experienceByArea = areas;
        _application.additionalAreas = additionalAreas;
        props.save(_application);
    };
    var selectOption = function(key, value) {
        var found = false;
        var _areas = (0, $XnYkK._)(areas);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _areas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var a = _step.value;
                if (a.name === key) {
                    a.value = value;
                    found = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!found) _areas.push({
            name: key,
            value: value
        });
        setAreas(_areas);
    };
    var renderOption = function(key) {
        var value = -1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = areas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var a = _step.value;
                if (a.name === key) value = a.value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: (0, $534b9d242f4a5204$export$e6abe0fdb57da24d).map(function(level) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2 flex items-center cursor-pointer",
                    onClick: function() {
                        return selectOption(key, level.value);
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $dc3eefe01a987faf$export$2e2bcd8739ae039), {
                            checked: level.value === value
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "ml-2",
                            children: level.name
                        })
                    ]
                }, "option_" + key + "_" + level.value);
            })
        });
    };
    var renderAreas = function(start, end) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "flex flex-wrap",
            children: props.experiencesByArea.slice(start, end).map(function(area, index) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4",
                    style: {
                        width: 280
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "font-medium",
                            children: area.value
                        }),
                        renderOption(area.key)
                    ]
                }, "area_" + area.key + "_" + (start + index));
            })
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: showModal,
                onClose: function() {
                    return setShowModal(false);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                        onClose: function() {
                            return setShowModal(false);
                        },
                        children: "Coaching experience by area"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "font-medium",
                                children: "Extensive:"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-sm",
                                children: "Significant hands-on experience, applied frequently."
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "mt-4 font-medium",
                                children: "Moderate:"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-sm",
                                children: "Practical experience, applied occasionally."
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "mt-4 font-medium",
                                children: "Basic:"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-sm",
                                children: "Foundational experience, applied a few times."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-xl font-medium",
                        children: "Coaching experience by area"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                        className: "ml-2 cursor-pointer",
                        alt: "info",
                        onClick: function() {
                            return setShowModal(true);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4 text-neutral-400",
                children: "Please indicate your level of experience in each coaching area."
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Leadership and Team Development"
            }),
            renderAreas(0, 3),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Organisational and Business coaching"
            }),
            renderAreas(3, 6),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Personal development"
            }),
            renderAreas(6, 12),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Career and Professional Growth"
            }),
            renderAreas(12, 15),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: lang === 'sv' ? "Andra omr\xe5den du coachar inom" : 'Additional areas'
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                value: additionalAreas,
                className: "z-input mt-2",
                onChange: function(e) {
                    return setAdditionalAreas(e.target.value);
                }
            }),
            triedSave && error.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: function() {
                    return save();
                },
                children: "Next"
            })
        ]
    });
};
var $bdcb751e842e09ff$export$2e2bcd8739ae039 = $bdcb751e842e09ff$var$StepFive;



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");





var $8e7b9f7660825e62$var$StepSix = function(props) {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.experienceByIndustry), 2), industries = _useState[0], setIndustries = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.additionalIndustriesClient), 2), additionalIndustriesClient = _useState1[0], setAdditionalIndustriesClient = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), errors = _useState2[0], setErrors = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), triedSave = _useState3[0], setTriedSave = _useState3[1];
    (0, $5s1kH.useEffect)(function() {
        (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (triedSave) checkInput();
    }, [
        industries
    ]);
    var checkInput = function() {
        var _errors = 0;
        if (industries.length < 1) _errors++;
        setErrors(_errors);
        return _errors;
    };
    var save = function() {
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        var _application = props.application;
        _application.experienceByIndustry = industries;
        _application.additionalIndustriesClient = additionalIndustriesClient;
        props.save(_application);
    };
    var selectOption = function(key) {
        if (industries.indexOf(key) > -1) {
            // Deselect industry
            var _industries = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = industries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var industry = _step.value;
                    if (industry !== key) _industries.push(industry);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            setIndustries(_industries);
        } else {
            var _industries1 = (0, $XnYkK._)(industries);
            _industries1.push(key);
            setIndustries(_industries1);
        }
    };
    var renderAreas = function(start, end) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            children: props.experiencesByIndustry.slice(start, end).map(function(industry, index) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-3 flex items-center",
                    onClick: function() {
                        return selectOption(industry.key);
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $634501c911927d99$export$2e2bcd8739ae039), {
                            checked: industries.indexOf(industry.key) !== -1
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-sm ml-2",
                            children: industry.value
                        })
                    ]
                }, "industry_" + index);
            })
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Coaching experience by industry"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4 text-neutral-400",
                children: "Please select the industries your clients have worked in."
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Technology and Innovation"
            }),
            renderAreas(0, 3),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Finance and Professional Services"
            }),
            renderAreas(3, 8),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Industry and Manufacture"
            }),
            renderAreas(8, 12),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Consumer Goods and Services"
            }),
            renderAreas(12, 17),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: "Additional industries"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                value: additionalIndustriesClient,
                className: "z-input mt-2",
                onChange: function(e) {
                    return setAdditionalIndustriesClient(e.target.value);
                }
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please select experience level for at least one coaching area"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: function() {
                    return save();
                },
                children: "Next"
            })
        ]
    });
};
var $8e7b9f7660825e62$export$2e2bcd8739ae039 = $8e7b9f7660825e62$var$StepSix;



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");







var $e6904e347d46ada9$var$roleLevels = [
    {
        name: "Extensive",
        value: 3
    },
    {
        name: "Moderate",
        value: 2
    },
    {
        name: "Basic",
        value: 1
    },
    {
        name: "None",
        value: 0
    }
];
var $e6904e347d46ada9$var$StepSeven = function(props) {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.experienceByRole), 2), roles = _useState[0], setRoles = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showModal = _useState1[0], setShowModal = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), errors = _useState2[0], setErrors = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), triedSave = _useState3[0], setTriedSave = _useState3[1];
    (0, $5s1kH.useEffect)(function() {
        (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (triedSave) checkInput();
    }, [
        roles
    ]);
    var checkInput = function() {
        var _errors = 0;
        var _choices = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = roles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var a = _step.value;
                if (a.value > 0) _choices++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (_choices < 1) _errors++;
        setErrors(_errors);
        return _errors;
    };
    var save = function() {
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        var _application = props.application;
        _application.experienceByRole = roles;
        props.save(_application);
    };
    var selectOption = function(key, value) {
        var found = false;
        var _roles = (0, $XnYkK._)(roles);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _roles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var a = _step.value;
                if (a.name === key) {
                    a.value = value;
                    found = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!found) _roles.push({
            name: key,
            value: value
        });
        setRoles(_roles);
    };
    var isSelected = function(key, value) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = roles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var role = _step.value;
                if (role.name === key) {
                    if (role.value === value) return true;
                    return false;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: showModal,
                onClose: function() {
                    return setShowModal(false);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                        onClose: function() {
                            return setShowModal(false);
                        },
                        children: "Coaching experience by role"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "font-medium",
                                children: "Non-managerial employees:"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-sm",
                                children: "No leadership or supervisory responsibilities."
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "mt-4 font-medium",
                                children: "Managers with team responsibility:"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-sm",
                                children: "Managing collaboration and operational goals."
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "mt-4 font-medium",
                                children: "Managers with personnel responsibility:"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-sm",
                                children: "Overseeing hiring, performance, and careers."
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "mt-4 font-medium",
                                children: "C-level executives:"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-sm",
                                children: "Managing high-level decision-making."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-xl font-medium",
                        children: "Coaching experience by role"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                        className: "ml-2 cursor-pointer",
                        alt: "info",
                        onClick: function() {
                            return setShowModal(true);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4 text-neutral-400",
                children: "Please indicate your level of experience in coaching employees in different roles."
            }),
            props.leadershipLevels.map(function(level) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-lg font-medium",
                            children: level.value
                        }),
                        $e6904e347d46ada9$var$roleLevels.map(function(role) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex mt-2",
                                onClick: function() {
                                    return selectOption(level.key, role.value);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $dc3eefe01a987faf$export$2e2bcd8739ae039), {
                                        checked: isSelected(level.key, role.value)
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "ml-2",
                                        children: role.name
                                    })
                                ]
                            }, level.key + '_' + role.value);
                        })
                    ]
                }, "level_" + level.key);
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please select experience level for at least one coaching area"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: function() {
                    return save();
                },
                children: "Next"
            })
        ]
    });
};
var $e6904e347d46ada9$export$2e2bcd8739ae039 = $e6904e347d46ada9$var$StepSeven;



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");




var $38d8dc89ded579df$export$821f0dff1d448186 = function(langMap, key, lang) {
    var item = langMap[key];
    if (!item) return key;
    if (lang === 'sv') return item[1];
    return item[0];
};



var $957359de0a738e7c$var$values = [
    3,
    2,
    1,
    0
];
var $957359de0a738e7c$var$langMap = {
    "personnel": [
        "Have you ever had personnel responsibility?",
        "Har du n\xe5gonsin haft personalansvar?"
    ],
    "c_level": [
        "Have you ever held a C-level executive position?",
        "Har du n\xe5gonsin haft chefsbefattning p\xe5 C-niv\xe5?"
    ],
    "large_enterprise": [
        "Have you ever worked in large enterprises?",
        "Har du n\xe5gonsin arbetat i stora f\xf6retag?"
    ],
    "medium_enterprise": [
        "Have you ever worked in small or medium-sized companies?",
        "Har du n\xe5gonsin arbetat i sm\xe5 eller mellanstora f\xf6retag?"
    ],
    "entrepreneur": [
        "Do you have experience as an entrepreneur or being self-employed?",
        "Har du erfarenhet som entrepren\xf6r eller varit sj\xe4lvanst\xe4lld?"
    ],
    "value_0": [
        "No, I don't have such experience",
        "Nej, jag har ingen s\xe5dan erfarenhet"
    ],
    "value_1": [
        "Yes, I have 1-4 years of experience",
        "Ja, jag har 1-4 \xe5rs erfarenhet"
    ],
    "value_2": [
        "Yes, I have 5-9 years of experience",
        "Ja, jag har 4-9 \xe5rs erfarenhet"
    ],
    "value_3": [
        "Yes, I have 10+ years of experience",
        "Ja, jag har 10+ \xe5rs erfarenhet"
    ]
};
var $957359de0a738e7c$var$StepEight = function(props) {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var i18n = translation.i18n;
    var lang = i18n.language ? i18n.language.startsWith('sv') ? 'sv' : 'en' : 'en';
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.experienceProfessional), 2), professional = _useState[0], setProfessional = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), errors = _useState1[0], setErrors = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), triedSave = _useState2[0], setTriedSave = _useState2[1];
    (0, $5s1kH.useEffect)(function() {
        (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (triedSave) checkInput();
    }, [
        professional
    ]);
    var checkInput = function() {
        var _errors = 0;
        if (professional.length < props.professionalAreas.length) _errors++;
        setErrors(_errors);
        return _errors;
    };
    var save = function() {
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        var _application = props.application;
        _application.experienceProfessional = professional;
        props.save(_application);
    };
    var selectOption = function(key, value) {
        var found = false;
        var _professional = (0, $XnYkK._)(professional);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _professional[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var a = _step.value;
                if (a.name === key) {
                    a.value = value;
                    found = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!found) _professional.push({
            name: key,
            value: value
        });
        setProfessional(_professional);
    };
    var isSelected = function(key, value) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = professional[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var p = _step.value;
                if (p.name === key) {
                    if (p.value === value) return true;
                    return false;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Your professional experience"
            }),
            props.professionalAreas.map(function(level) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-lg font-medium",
                            children: (0, $38d8dc89ded579df$export$821f0dff1d448186)($957359de0a738e7c$var$langMap, level.key, lang)
                        }),
                        $957359de0a738e7c$var$values.map(function(value) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex mt-2",
                                onClick: function() {
                                    return selectOption(level.key, value);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $dc3eefe01a987faf$export$2e2bcd8739ae039), {
                                        checked: isSelected(level.key, value)
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "ml-2",
                                        children: (0, $38d8dc89ded579df$export$821f0dff1d448186)($957359de0a738e7c$var$langMap, "value_" + value, lang)
                                    })
                                ]
                            }, level.key + '_' + value);
                        })
                    ]
                }, "level_" + level.key);
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please answer all questions"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: function() {
                    return save();
                },
                children: "Next"
            })
        ]
    });
};
var $957359de0a738e7c$export$2e2bcd8739ae039 = $957359de0a738e7c$var$StepEight;



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");





var $58a23acd11942c17$var$StepSix = function(props) {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.workedInIndustry), 2), industries = _useState[0], setIndustries = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(props.application.additionalIndustriesCoach), 2), additionalIndustriesCoach = _useState1[0], setAdditionalIndustriesCoach = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), errors = _useState2[0], setErrors = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), triedSave = _useState3[0], setTriedSave = _useState3[1];
    (0, $5s1kH.useEffect)(function() {
        (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (triedSave) checkInput();
    }, [
        industries
    ]);
    var checkInput = function() {
        var _errors = 0;
        if (industries.length < 1) _errors++;
        setErrors(_errors);
        return _errors;
    };
    var save = function() {
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        var _application = props.application;
        _application.workedInIndustry = industries;
        _application.additionalIndustriesCoach = additionalIndustriesCoach;
        props.save(_application);
    };
    var selectOption = function(key) {
        if (industries.indexOf(key) > -1) {
            // Deselect industry
            var _industries = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = industries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var industry = _step.value;
                    if (industry !== key) _industries.push(industry);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            setIndustries(_industries);
        } else {
            var _industries1 = (0, $XnYkK._)(industries);
            _industries1.push(key);
            setIndustries(_industries1);
        }
    };
    var renderAreas = function(start, end) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            children: props.experiencesByIndustry.slice(start, end).map(function(industry, index) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-3 flex items-center",
                    onClick: function() {
                        return selectOption(industry.key);
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $634501c911927d99$export$2e2bcd8739ae039), {
                            checked: industries.indexOf(industry.key) !== -1
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-sm ml-2",
                            children: industry.value
                        })
                    ]
                }, "industry_" + index);
            })
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Your industry experience"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4 text-neutral-400",
                children: "Please select industries outside coaching where you've worked before."
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Technology and Innovation"
            }),
            renderAreas(0, 3),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Finance and Professional Services"
            }),
            renderAreas(3, 8),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Industry and Manufacture"
            }),
            renderAreas(8, 12),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Consumer Goods and Services"
            }),
            renderAreas(12, 17),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: "Additional industries"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                value: additionalIndustriesCoach,
                className: "z-input mt-2",
                onChange: function(e) {
                    return setAdditionalIndustriesCoach(e.target.value);
                }
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f358e43dc3fae1cf$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please select experience level for at least one coaching area"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: function() {
                    return save();
                },
                children: "Next"
            })
        ]
    });
};
var $58a23acd11942c17$export$2e2bcd8739ae039 = $58a23acd11942c17$var$StepSix;




var $5s1kH = parcelRequire("5s1kH");





var $9d8b68fe6ac1145a$var$experienceLength = [
    "No experience",
    "1-4 years",
    "5-9 years",
    "10+ years"
];
var $9d8b68fe6ac1145a$var$StepTen = function(props) {
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t;
    (0, $5s1kH.useEffect)(function() {
        (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
    }, []);
    var showLanguages = function(languages) {
        var langString = "";
        for(var i = 0; i < languages.length; i++){
            if (i > 0) langString += ", ";
            langString += t(languages[i]);
        }
        return langString;
    };
    var showExperienceLevel = function(value) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (0, $534b9d242f4a5204$export$e6abe0fdb57da24d)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                if (e.value === value) return e.name;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return "Unknown";
    };
    var keyVal = function(arr, key) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                if (e.key === key) return e.value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return key;
    };
    var getFileName = function(file) {
        if (!file) return "";
        var fParts = file.split('/');
        return fParts[fParts.length - 1];
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Summary"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Personal details"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: function() {
                            return props.changeStep(0);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-2 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "First name"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: props.application.firstName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Surname"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: props.application.lastName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Phone number"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: props.application.phone
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Company name"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: props.application.company
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Organisational number"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: props.application.organisationNumber
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Company address"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: props.application.companyAddress
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Certification"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: function() {
                            return props.changeStep(1);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-1 text-neutral-400",
                children: [
                    getFileName(props.application.certificateFile),
                    " has been uploaded"
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Year of certification"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: props.application.yearOfCertification
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Total coaching hours"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: props.application.coachingHours
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Resum\xe9"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: function() {
                            return props.changeStep(2);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-1 text-neutral-400",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    children: props.application.linkedinUrl
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                onClick: function() {
                    return props.changeStep(3);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Languages"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: function() {
                            return props.changeStep(3);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Native"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: showLanguages(props.application.languagesNative)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Professional"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: showLanguages(props.application.languagesProfessional)
                    })
                ]
            }),
            props.application.additionalLanguages.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Additional"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: props.application.additionalLanguages
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Experience in coaching areas"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: function() {
                            return props.changeStep(4);
                        }
                    })
                ]
            }),
            props.application.experienceByArea.filter(function(area) {
                return area.value > 0;
            }).map(function(area) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-1 flex justify-between text-neutral-400",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: keyVal(props.experiencesByArea, area.name)
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: showExperienceLevel(area.value)
                        })
                    ]
                }, "exp_by_area_" + area.name);
            }),
            props.application.additionalAreas.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Additional"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: props.application.additionalAreas
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Coaching experience by industry"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: function() {
                            return props.changeStep(5);
                        }
                    })
                ]
            }),
            props.application.experienceByIndustry.map(function(e) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-1 text-neutral-400",
                    children: keyVal(props.experiencesByIndustry, e)
                }, "exp_by_industry_" + e);
            }),
            props.application.additionalIndustriesClient.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: "Additional"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        children: props.application.additionalIndustriesClient
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Coaching experience by role"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: function() {
                            return props.changeStep(6);
                        }
                    })
                ]
            }),
            props.application.experienceByRole.filter(function(e) {
                return e.value > 0;
            }).map(function(e) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-1 flex justify-between text-neutral-400",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: keyVal(props.leadershipLevels, e.name)
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: showExperienceLevel(e.value)
                        })
                    ]
                }, "exp_by_role_" + e.name);
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Your professional experience"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: function() {
                            return props.changeStep(7);
                        }
                    })
                ]
            }),
            props.application.experienceProfessional.filter(function(e) {
                return e.value > 0;
            }).map(function(e) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-1 flex justify-between text-neutral-400",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: keyVal(props.professionalAreas, e.name)
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            children: $9d8b68fe6ac1145a$var$experienceLength[e.value]
                        })
                    ]
                }, "exp_prof_" + e.name);
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Your industry experience"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: function() {
                            return props.changeStep(8);
                        }
                    })
                ]
            }),
            props.application.workedInIndustry.map(function(e) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-1 text-neutral-400",
                    children: keyVal(props.experiencesByIndustry, e)
                }, "worked_industry_" + e);
            }),
            props.application.additionalIndustriesCoach.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-1 text-neutral-400",
                children: props.application.additionalIndustriesCoach
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: function() {
                    return props.save({});
                },
                children: "Submit"
            })
        ]
    });
};
var $9d8b68fe6ac1145a$export$2e2bcd8739ae039 = $9d8b68fe6ac1145a$var$StepTen;





var $a8f28c2cebc3e2b3$var$ApplicationPage = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(), 2), application = _useState[0], setApplication = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), experiencesByArea = _useState1[0], setExperiencesByArea = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), experiencesByIndustry = _useState2[0], setExperiencesByIndustry = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), leadershipLevels = _useState3[0], setLeadershipLevels = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), professionalAreas = _useState4[0], setProfessionalAreas = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), email = _useState5[0], setEmail = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), step = _useState6[0], setStep = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)([
        false,
        false,
        false,
        false
    ]), 2), stepsDone = _useState7[0], setStepsDone = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), applicationSent = _useState8[0], setApplicationSent = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), applied = _useState9[0], setApplied = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), onboarded = _useState10[0], setOnboarded = _useState10[1];
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get('coach/application').then(function(response) {
            var _application = response.json.application;
            setApplication(_application);
            setExperiencesByArea(response.json.experiencesByArea);
            setExperiencesByIndustry(response.json.experiencesByIndustry);
            setLeadershipLevels(response.json.leadershipLevels);
            setProfessionalAreas(response.json.professionalAreas);
            calculateStep(_application);
            setApplied(response.json.applied);
            setOnboarded(response.json.onboarded);
        });
    };
    var saveData = function(_application) {
        api.post('coach/application/save/' + step, _application).then(function() {
            getData();
        });
    };
    var sendApplication = function() {
        api.post('coach/application/save/9', {}).then(function(response) {
            setEmail(response.json.email);
            setApplicationSent(true);
        });
    };
    var calculateStep = function(_application) {
        var step;
        if (_application.organisationNumber.length < 1) // Not completed first page, set step 0
        step = 0;
        else if (_application.coachingHours < 200) step = 1;
        else if (_application.linkedinUrl.length < 1) step = 2;
        else if (_application.languagesNative.length === 0 && _application.languagesProfessional.length === 0) step = 3;
        else if (_application.experienceByArea.length === 0) step = 4;
        else if (_application.experienceByIndustry.length === 0) step = 5;
        else if (_application.experienceByRole.length === 0) step = 6;
        else if (_application.experienceProfessional.length === 0) step = 7;
        else if (_application.workedInIndustry.length === 0) step = 8;
        else step = 9;
        // We should now be at page 3 - select coach
        setStep(step);
        var _stepsDone = [];
        for(var i = 0; i < 10; i++){
            var done = step > i;
            _stepsDone.push(done);
        }
        setStepsDone(_stepsDone);
    };
    if (application === undefined) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-8",
        children: "Loading..."
    });
    var changeStep = function(newStep) {
        if (newStep === 0 || stepsDone[newStep - 1]) setStep(newStep);
    };
    var selectStep = function() {
        if (step === 9) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $9d8b68fe6ac1145a$export$2e2bcd8739ae039), {
            application: application,
            save: sendApplication,
            changeStep: changeStep,
            experiencesByArea: experiencesByArea,
            experiencesByIndustry: experiencesByIndustry,
            leadershipLevels: leadershipLevels,
            professionalAreas: professionalAreas
        });
        else if (step === 8) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $58a23acd11942c17$export$2e2bcd8739ae039), {
            application: application,
            save: saveData,
            experiencesByIndustry: experiencesByIndustry
        });
        else if (step === 7) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $957359de0a738e7c$export$2e2bcd8739ae039), {
            application: application,
            save: saveData,
            professionalAreas: professionalAreas
        });
        else if (step === 6) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e6904e347d46ada9$export$2e2bcd8739ae039), {
            application: application,
            save: saveData,
            leadershipLevels: leadershipLevels
        });
        else if (step === 5) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8e7b9f7660825e62$export$2e2bcd8739ae039), {
            application: application,
            save: saveData,
            experiencesByIndustry: experiencesByIndustry
        });
        else if (step === 4) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdcb751e842e09ff$export$2e2bcd8739ae039), {
            application: application,
            save: saveData,
            experiencesByArea: experiencesByArea
        });
        else if (step === 3) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cacf689decfd9551$export$2e2bcd8739ae039), {
            application: application,
            save: saveData
        });
        else if (step === 2) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3220afffacbace8e$export$2e2bcd8739ae039), {
            application: application,
            save: saveData
        });
        else if (step === 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3e8914f73eec66e0$export$2e2bcd8739ae039), {
            application: application,
            save: saveData
        });
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $692746691f118d36$export$2e2bcd8739ae039), {
            application: application,
            save: saveData
        });
    };
    if (applied) {
        if (onboarded) navigate('/');
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-10 flex flex-col justify-center",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    alt: "check",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports))),
                    className: "h-12 w-12 mx-auto"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 text-2xl font-medium text-center",
                    children: "Waiting for approval"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-neutral-400 text-center",
                    children: "We're currently reviewing your application and will notify you via email as soon as we have an update."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 text-neutral-400 text-center",
                    children: "Thanks for your patience and enthusiasm!"
                })
            ]
        });
    }
    if (applicationSent) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-10 flex justify-center",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    alt: "check",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6c066964533a9345$exports))),
                    className: "h-12"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 text-2xl font-medium",
                    children: "Application sent"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-2 text-neutral-400",
                    children: [
                        "Thanks for taking your time to apply! We'll get back to you as soon as possible via ",
                        email
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "m-4 main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $51e9ec39f085fa8f$export$2e2bcd8739ae039), {
                    step: step + 1,
                    steps: stepsDone.length
                })
            }),
            selectStep()
        ]
    });
};
var $a8f28c2cebc3e2b3$export$2e2bcd8739ae039 = $a8f28c2cebc3e2b3$var$ApplicationPage;



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");






var $32b62164b12d451c$exports = {};
$32b62164b12d451c$exports = $parcel$resolve("2zSZ8");


var $81b46490aa13ab72$exports = {};
$81b46490aa13ab72$exports = $parcel$resolve("5pJjn");


var $ae5c83ea8e03ae9c$exports = {};
$ae5c83ea8e03ae9c$exports = $parcel$resolve("gbsDT");









var $4280e30fa052e832$exports = {};
$4280e30fa052e832$exports = $parcel$resolve("81x8M");


var $12285823891ebef0$exports = {};
$12285823891ebef0$exports = $parcel$resolve("5XsFF");



var $e126c82cf1d55289$exports = {};
$e126c82cf1d55289$exports = $parcel$resolve("l4dyf");




var $24d20d648b8f3115$exports = {};
$24d20d648b8f3115$exports = $parcel$resolve("fnlA3");






var $78ab1abcd1dade5e$exports = {};
$78ab1abcd1dade5e$exports = $parcel$resolve("fm6nf");



var $f2f71f556a64ce0f$exports = {};
$f2f71f556a64ce0f$exports = $parcel$resolve("fycp9");


var $0fb088b6b5dd1bd5$exports = {};
$0fb088b6b5dd1bd5$exports = $parcel$resolve("kFfmm");


var $18ac665c00e818f6$exports = {};
$18ac665c00e818f6$exports = $parcel$resolve("eZMsg");




var $2acccf4a3a618963$exports = {};
$2acccf4a3a618963$exports = $parcel$resolve("gw7KT");













var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");
var $0fbee471a724cfff$exports = {};
$0fbee471a724cfff$exports = $parcel$resolve("7qh7J");


var $bdf5b3fa489553d1$var$SidePanel = function(props) {
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)("open"), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var close = function() {
        setIsOpen("closed");
        setTimeout(function() {
            props.close();
        }, 400);
    };
    return(// <div className="z-side-panel-background" onClick={() => close()}>
    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "z-side-panel " + isOpen,
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "cursor-pointer hover:bg-indigo-700 rounded-[20px] p-1",
                style: {
                    position: "absolute",
                    top: "16px",
                    right: "16px"
                },
                onClick: function() {
                    return close();
                },
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0fbee471a724cfff$exports))),
                    alt: "close"
                })
            }),
            props.children
        ]
    }));
};
var $bdf5b3fa489553d1$export$2e2bcd8739ae039 = $bdf5b3fa489553d1$var$SidePanel;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");



var $068b0e3140b308b6$var$UpdateProgress = function(props) {
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.type === "done" ? 2 : 1), 2), step = _useState[0], setStep = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(props.type === "done" ? 100 : props.visionStatement.progress), 2), progress = _useState1[0], setProgress = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), development = _useState2[0], setDevelopment = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), effort = _useState3[0], setEffort = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), onTrack = _useState4[0], setOnTrack = _useState4[1];
    var percentages = [
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80,
        90,
        100
    ];
    var renderStep1 = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "text-gray-300 mt-2",
                    children: props.lang === "sv" ? "Hur mycket av m\xe5lbilden har du uppn\xe5tt?" : "How much progress have you made toward this Goal?"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "text-gray-300 font-medium mt-4",
                    children: props.lang === "sv" ? "Andel uppn\xe5dd" : "Percentage achieved"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                        className: "z-select z-800",
                        value: progress,
                        onChange: function(e) {
                            return setProgress(parseInt(e.target.value));
                        },
                        children: percentages.map(function(percentage) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("option", {
                                value: percentage,
                                children: [
                                    percentage,
                                    "%"
                                ]
                            }, "percent_" + percentage);
                        })
                    })
                })
            ]
        });
    };
    var renderStep2 = function() {
        if (progress === 100) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 text-gray-300",
                    children: props.lang === "sv" ? "Ta en stund att reflektera \xf6ver din m\xe5lbild." : "Take moment to reflect on your Goal."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 text-gray-300",
                    children: props.lang === "sv" ? "K\xe4nner du att du har utvecklats p\xe5 n\xe5got s\xe4tt, till exempel genom nya insikter, f\xe4rdigheter eller beteenden?" : "Have you noticed any personal development while working on it \u2014 such as new insights, skills, or behaviours?"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                        name: "development1",
                        label: props.lang === "sv" ? "Ja, mycket" : "Yes, significant",
                        id: "development1",
                        value: "1",
                        checked: development === 1,
                        onChange: function() {
                            return setDevelopment(1);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                        name: "development2",
                        label: props.lang === "sv" ? "Ja, lite grann" : "Yes, to some extent",
                        id: "development2",
                        value: "2",
                        checked: development === 2,
                        onChange: function() {
                            return setDevelopment(2);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                        name: "development3",
                        label: props.lang === "sv" ? "Nej, inte \xe4n" : "Not really",
                        id: "development3",
                        value: "3",
                        checked: development === 3,
                        onChange: function() {
                            return setDevelopment(3);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 text-gray-300",
                    children: props.lang === "sv" ? "Hur skulle du beskriva ditt engagemang f\xf6r m\xe5lbilden?" : "How would you describe your level of effort during this process?"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                        name: "effort1",
                        label: props.lang === "sv" ? "V\xe4ldigt engagerad" : "Highly engaged",
                        id: "effort1",
                        value: "1",
                        checked: effort === 1,
                        onChange: function() {
                            return setEffort(1);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                        name: "effort2",
                        label: props.lang === "sv" ? "Balanserat" : "Generally engaged",
                        id: "effort2",
                        value: "2",
                        checked: effort === 2,
                        onChange: function() {
                            return setEffort(2);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                        name: "effort3",
                        label: props.lang === "sv" ? "Mindre engagerad \xe4n jag t\xe4nkt" : "Less engaged than intended",
                        id: "effort3",
                        value: "3",
                        checked: effort === 3,
                        onChange: function() {
                            return setEffort(3);
                        }
                    })
                })
            ]
        });
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2 font-medium",
                    children: props.lang === "sv" ? "Hur ligger du till?" : "Are you on track?"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                        name: "ontrack1",
                        label: props.lang === "sv" ? "I fas" : "On track",
                        id: "ontrack1",
                        value: "1",
                        checked: onTrack === 1,
                        onChange: function() {
                            return setOnTrack(1);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                        name: "ontrack2",
                        label: props.lang === "sv" ? "N\xe5got efter" : "Slightly behind",
                        id: "ontrack2",
                        value: "2",
                        checked: onTrack === 2,
                        onChange: function() {
                            return setOnTrack(2);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                        name: "ontrack3",
                        label: props.lang === "sv" ? "Mycket efter" : "Significantly behind",
                        id: "ontrack3",
                        value: "3",
                        checked: onTrack === 3,
                        onChange: function() {
                            return setOnTrack(3);
                        }
                    })
                })
            ]
        });
    };
    var step2Inactive = function() {
        if (progress === 100) return development === 0 || effort === 0;
        else return onTrack === 0;
    };
    var saveFirst = function() {
        if (progress === 100) setStep(2);
        else props.save(progress, development, effort, onTrack);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: true,
        onClose: function() {
            return props.close();
        },
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: props.close,
                children: [
                    props.type === "done" ? props.t("mark-as-complete") : props.t("update-progress"),
                    props.type === "done" && "?"
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: [
                    step === 1 && renderStep1(),
                    step === 2 && renderStep2()
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                children: [
                    step === 1 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        onClick: function() {
                            return saveFirst();
                        },
                        buttonType: "blueBase",
                        children: props.lang === "sv" ? "Uppdatera" : "Update"
                    }),
                    step === 2 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        disabled: step2Inactive(),
                        onClick: function() {
                            return props.save(progress, development, effort, onTrack);
                        },
                        buttonType: "blueBase",
                        children: progress === 100 ? props.t("mark-as-complete") : props.t("save")
                    })
                ]
            })
        ]
    });
};
var $068b0e3140b308b6$export$2e2bcd8739ae039 = $068b0e3140b308b6$var$UpdateProgress;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");



var $775d2bb3f3754db0$var$UpdateGoalStatus = function(props) {
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), development = _useState[0], setDevelopment = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), engagement = _useState1[0], setEngagement = _useState1[1];
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: true,
        onClose: function() {
            return props.close();
        },
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: props.close,
                children: props.t("update-progress")
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 text-gray-300",
                        children: props.lang === "sv" ? "Ta en stund att reflektera \xf6ver ditt delm\xe5l." : "Take moment to reflect on your Sub-goal."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 text-gray-300",
                        children: props.lang === "sv" ? "K\xe4nner du att du har utvecklats p\xe5 n\xe5got s\xe4tt, till exempel genom nya insikter, f\xe4rdigheter eller beteenden?" : "Have you noticed any personal development while working on it \u2014 such as new insights, skills, or behaviours?"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                            name: "development1",
                            label: props.lang === "sv" ? "Ja, mycket" : "Yes, significant",
                            id: "development1",
                            value: "1",
                            checked: development === 1,
                            onChange: function() {
                                return setDevelopment(1);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                            name: "development2",
                            label: props.lang === "sv" ? "Ja, litegrann" : "Yes, to some extent",
                            id: "development2",
                            value: "2",
                            checked: development === 2,
                            onChange: function() {
                                return setDevelopment(2);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                            name: "development3",
                            label: props.lang === "sv" ? "N\xe4, inte \xe4n" : "Not really",
                            id: "development3",
                            value: "3",
                            checked: development === 3,
                            onChange: function() {
                                return setDevelopment(3);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 text-gray-300",
                        children: props.lang === "sv" ? "Hur skulle du beskriva ditt engagemang f\xf6r m\xe5lbilden?" : "How would you describe your level of effort during this process?"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                            name: "engagement1",
                            label: props.lang === "sv" ? "V\xe4ldigt engagerad" : "Highly engaged",
                            id: "engagement1",
                            value: "1",
                            checked: engagement === 1,
                            onChange: function() {
                                return setEngagement(1);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                            name: "engagement2",
                            label: props.lang === "sv" ? "Balanserat" : "Generally engaged",
                            id: "engagement2",
                            value: "2",
                            checked: engagement === 2,
                            onChange: function() {
                                return setEngagement(2);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                            name: "engagement3",
                            label: props.lang === "sv" ? "Mindre engagerad \xe4n jag t\xe4nkt" : "Less engaged than intended",
                            id: "engagement3",
                            value: "3",
                            checked: engagement === 3,
                            onChange: function() {
                                return setEngagement(3);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    disabled: development === 0 || engagement === 0,
                    onClick: function() {
                        return props.save(development, engagement);
                    },
                    buttonType: "blueBase",
                    children: props.t("mark-as-complete")
                })
            })
        ]
    });
};
var $775d2bb3f3754db0$export$2e2bcd8739ae039 = $775d2bb3f3754db0$var$UpdateGoalStatus;



var $lFIaz = parcelRequire("lFIaz");

var $dUlz9 = parcelRequire("dUlz9");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");

var $3SMYb = parcelRequire("3SMYb");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");





// // NOTE selectedid: The currect select date. isMonth and isWeek: wheich text need to disply.
// // Date calulation need to be done here and pass it to parant comp.

parcelRequire("5s1kH");
var $31765b9fabb4598f$var$getFromDate = function(option) {
    var date = new Date();
    if (option.unit === 'month') date.setMonth(date.getMonth() + option.value);
    else date.setDate(date.getDate() + option.value * 7);
    return date;
};
var $31765b9fabb4598f$var$DueDateBadge = function(param) {
    var options = param.options, selected = param.selected, onChange = param.onChange, getLanguageString = param.getLanguageString;
    var baseCls = 'rounded-full border mb-2 mr-2 border-indigo-700 px-3 py-1 cursor-pointer hover:bg-indigo-700 text-center';
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "flex w-full gap-2",
        children: options.map(function(opt) {
            var isSelected = (selected === null || selected === void 0 ? void 0 : selected.value) === opt.value && (selected === null || selected === void 0 ? void 0 : selected.unit) === opt.unit;
            var label = getLanguageString ? getLanguageString(opt) : "".concat(opt.value, " ").concat(opt.unit).concat(opt.value > 1 ? 's' : '');
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                onClick: function() {
                    return onChange(opt, $31765b9fabb4598f$var$getFromDate(opt));
                },
                className: "".concat(baseCls).concat(isSelected ? ' bg-indigo-700' : '', " flex-1 min-w-0 px-3 py-2 text-center rounded-full"),
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                    className: "text-neutral-100!",
                    children: label
                })
            }, "".concat(opt.value, "-").concat(opt.unit));
        })
    });
};
var $31765b9fabb4598f$export$2e2bcd8739ae039 = $31765b9fabb4598f$var$DueDateBadge;












var $364604bcf0abac53$exports = {};
$364604bcf0abac53$exports = $parcel$resolve("sHqFA");



parcelRequire("5s1kH");

var $ff64b672040c3459$export$f479e71c47d92681 = function(aiFiles) {
    if (!aiFiles || aiFiles.length === 0) return null;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "flex flex-wrap gap-2 mt-2",
        children: aiFiles.map(function(aiFile, idx) {
            if (aiFile.filetype === "image") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4 align-right ml-auto max-w-[67%]",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: aiFile.bytes,
                    className: "rounded-[6px]",
                    alt: "img"
                })
            }, idx);
            else if (aiFile.filetype === "pdf") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 flex align-right ml-auto rounded-[6px] bg-indigo-900 p-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "rounded-[4px] bg-indigo-700 p-2",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1d2fed0fa04640e3$exports))),
                            alt: "pdf",
                            className: "h-6 w-6"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-2 text-gray-400 z-title4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "truncate",
                                style: {
                                    width: 150
                                },
                                children: aiFile.filename
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                children: "PDF"
                            })
                        ]
                    })
                ]
            }, idx);
            else if (aiFile.filetype === "excel") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 flex align-right ml-auto rounded-[6px] bg-indigo-900 p-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "rounded-[4px] bg-indigo-700 p-2",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1d2fed0fa04640e3$exports))),
                            alt: "excel",
                            className: "h-6 w-6"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-2 text-gray-400 z-title4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "truncate",
                                style: {
                                    width: 150
                                },
                                children: aiFile.filename
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                children: "Excel"
                            })
                        ]
                    })
                ]
            }, idx);
            else if (aiFile.filetype === "word") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 flex align-right ml-auto rounded-[6px] bg-indigo-900 p-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "rounded-[4px] bg-indigo-700 p-2",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1d2fed0fa04640e3$exports))),
                            alt: "word",
                            className: "h-6 w-6"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-2 text-gray-400 z-title4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "truncate",
                                style: {
                                    width: 150
                                },
                                children: aiFile.filename
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                children: "Word"
                            })
                        ]
                    })
                ]
            }, idx);
            return null;
        })
    });
};


/*!
  react-datepicker v9.1.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/ 
var $03bAP = parcelRequire("03bAP");


var $5s1kH = parcelRequire("5s1kH");

var $03bAP = parcelRequire("03bAP");
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ var $e2377001c88df902$export$dfd9b671c89acc8e = 7;
var $e2377001c88df902$export$3913210603d8e9ae = 365.2425;
var $e2377001c88df902$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e2377001c88df902$export$4dec998e48f9c246 = -$e2377001c88df902$export$81caae6e1cc7a622;
var $e2377001c88df902$export$4fad13613e88edc8 = 604800000;
var $e2377001c88df902$export$b76b1809a2898f9a = 86400000;
var $e2377001c88df902$export$91246f0b9bd9beff = 60000;
var $e2377001c88df902$export$7f72910d6dfd237a = 3600000;
var $e2377001c88df902$export$397c2d5776aa9055 = 1000;
var $e2377001c88df902$export$3633035e63cee86a = 525600;
var $e2377001c88df902$export$ab7da2ccd1075c38 = 43200;
var $e2377001c88df902$export$2423174df8cd3cd2 = 1440;
var $e2377001c88df902$export$f2f5ae5a8e2d8f9f = 60;
var $e2377001c88df902$export$3c58128db900d44e = 3;
var $e2377001c88df902$export$80d7e435f744f319 = 12;
var $e2377001c88df902$export$4db7641526e3241f = 4;
var $e2377001c88df902$export$698aec755e92c695 = 3600;
var $e2377001c88df902$export$a77c1a7ebebe2a5a = 60;
var $e2377001c88df902$export$815a9362476d2fe3 = $e2377001c88df902$export$698aec755e92c695 * 24;
var $e2377001c88df902$export$34804a017b31e2fe = $e2377001c88df902$export$815a9362476d2fe3 * 7;
var $e2377001c88df902$export$7271e9e3478110d1 = $e2377001c88df902$export$815a9362476d2fe3 * $e2377001c88df902$export$3913210603d8e9ae;
var $e2377001c88df902$export$8e6600bbdee7dabb = $e2377001c88df902$export$7271e9e3478110d1 / 12;
var $e2377001c88df902$export$be1dccf2de902d31 = $e2377001c88df902$export$8e6600bbdee7dabb * 3;
var $e2377001c88df902$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $5dd48bd7eb19f030$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && (typeof date === "undefined" ? "undefined" : (0, $03bAP._)(date)) === "object" && (0, $e2377001c88df902$export$2a7b97929c48d47d) in date) return date[0, $e2377001c88df902$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$5dd48bd7eb19f030$export$2e2bcd8739ae039 = $5dd48bd7eb19f030$export$ead8a1812b171991;



function $8d125137b8a7ac52$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$8d125137b8a7ac52$export$2e2bcd8739ae039 = $8d125137b8a7ac52$export$e67a095c620b86fe;


function $2b4ff6e56ae3ad17$export$dd412b56f1e4d8aa(date, amount, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    if (isNaN(amount)) return (0, $5dd48bd7eb19f030$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$2b4ff6e56ae3ad17$export$2e2bcd8739ae039 = $2b4ff6e56ae3ad17$export$dd412b56f1e4d8aa;



function $cd39a1a68707f059$export$baf757aaf0c95c94(date, amount, options) {
    return (0, $5dd48bd7eb19f030$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, +(0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date) + amount);
}
var // Fallback for modularized imports:
$cd39a1a68707f059$export$2e2bcd8739ae039 = $cd39a1a68707f059$export$baf757aaf0c95c94;



function $d360d6bbe5b8b7e1$export$4a4306ad4fa0e5e6(date, amount, options) {
    return (0, $cd39a1a68707f059$export$baf757aaf0c95c94)(date, amount * (0, $e2377001c88df902$export$7f72910d6dfd237a), options);
}
var // Fallback for modularized imports:
$d360d6bbe5b8b7e1$export$2e2bcd8739ae039 = $d360d6bbe5b8b7e1$export$4a4306ad4fa0e5e6;



function $396b693e3529a905$export$2287e3d29250119e(date, amount, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setTime(_date.getTime() + amount * (0, $e2377001c88df902$export$91246f0b9bd9beff));
    return _date;
}
var // Fallback for modularized imports:
$396b693e3529a905$export$2e2bcd8739ae039 = $396b693e3529a905$export$2287e3d29250119e;



function $75507be8d602cbce$export$17c93e242b2d3a22(date, amount, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    if (isNaN(amount)) return (0, $5dd48bd7eb19f030$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    var dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = (0, $5dd48bd7eb19f030$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$75507be8d602cbce$export$2e2bcd8739ae039 = $75507be8d602cbce$export$17c93e242b2d3a22;


function $40103932dbf37ea0$export$c252a41d0fbed2ce(date, amount, options) {
    return (0, $75507be8d602cbce$export$17c93e242b2d3a22)(date, amount * 3, options);
}
var // Fallback for modularized imports:
$40103932dbf37ea0$export$2e2bcd8739ae039 = $40103932dbf37ea0$export$c252a41d0fbed2ce;


function $ddb59a16cac13111$export$3cb31b0df13be68(date, amount, options) {
    return (0, $cd39a1a68707f059$export$baf757aaf0c95c94)(date, amount * 1000, options);
}
var // Fallback for modularized imports:
$ddb59a16cac13111$export$2e2bcd8739ae039 = $ddb59a16cac13111$export$3cb31b0df13be68;


function $a4bc19e29e9eb67e$export$ef501a2bb4f3ee6b(date, amount, options) {
    return (0, $2b4ff6e56ae3ad17$export$dd412b56f1e4d8aa)(date, amount * 7, options);
}
var // Fallback for modularized imports:
$a4bc19e29e9eb67e$export$2e2bcd8739ae039 = $a4bc19e29e9eb67e$export$ef501a2bb4f3ee6b;


function $5c6b1b4dffb22d4b$export$3d83eec43f4ea476(date, amount, options) {
    return (0, $75507be8d602cbce$export$17c93e242b2d3a22)(date, amount * 12, options);
}
var // Fallback for modularized imports:
$5c6b1b4dffb22d4b$export$2e2bcd8739ae039 = $5c6b1b4dffb22d4b$export$3d83eec43f4ea476;


var $6iP9u = parcelRequire("6iP9u");

function $6a38a618b9fe9e77$export$113002b5eff6e430(date) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date);
    var utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



var $03bAP = parcelRequire("03bAP");

function $93d910fdf6e0ae2a$export$9f53b88e82f64d8d(context) {
    for(var _len = arguments.length, dates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        dates[_key - 1] = arguments[_key];
    }
    var normalize = (0, $5dd48bd7eb19f030$export$ead8a1812b171991).bind(null, context || dates.find(function(date) {
        return (typeof date === "undefined" ? "undefined" : (0, $03bAP._)(date)) === "object";
    }));
    return dates.map(normalize);
}




function $e4ccc1375d9fa1c3$export$63fa379ae8a9ba2(date, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$e4ccc1375d9fa1c3$export$2e2bcd8739ae039 = $e4ccc1375d9fa1c3$export$63fa379ae8a9ba2;


function $91bd3590a595579e$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    var _normalizeDates = (0, $6iP9u._)((0, $93d910fdf6e0ae2a$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate), 2), laterDate_ = _normalizeDates[0], earlierDate_ = _normalizeDates[1];
    var laterStartOfDay = (0, $e4ccc1375d9fa1c3$export$63fa379ae8a9ba2)(laterDate_);
    var earlierStartOfDay = (0, $e4ccc1375d9fa1c3$export$63fa379ae8a9ba2)(earlierDate_);
    var laterTimestamp = +laterStartOfDay - (0, $6a38a618b9fe9e77$export$113002b5eff6e430)(laterStartOfDay);
    var earlierTimestamp = +earlierStartOfDay - (0, $6a38a618b9fe9e77$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $e2377001c88df902$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$91bd3590a595579e$export$2e2bcd8739ae039 = $91bd3590a595579e$export$4a02e9c37dab4871;


var $6iP9u = parcelRequire("6iP9u");

function $770badfd43ea080d$export$489984ac7c996389(laterDate, earlierDate, options) {
    var _normalizeDates = (0, $6iP9u._)((0, $93d910fdf6e0ae2a$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate), 2), laterDate_ = _normalizeDates[0], earlierDate_ = _normalizeDates[1];
    var yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    var monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
var // Fallback for modularized imports:
$770badfd43ea080d$export$2e2bcd8739ae039 = $770badfd43ea080d$export$489984ac7c996389;


var $6iP9u = parcelRequire("6iP9u");


function $d5bfd625c8c2dcab$export$de90a4bb31c25221(date, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}
var // Fallback for modularized imports:
$d5bfd625c8c2dcab$export$2e2bcd8739ae039 = $d5bfd625c8c2dcab$export$de90a4bb31c25221;


function $cf55ea31a060baca$export$f62ae9fb13958c7a(laterDate, earlierDate, options) {
    var _normalizeDates = (0, $6iP9u._)((0, $93d910fdf6e0ae2a$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate), 2), laterDate_ = _normalizeDates[0], earlierDate_ = _normalizeDates[1];
    var yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    var quartersDiff = (0, $d5bfd625c8c2dcab$export$de90a4bb31c25221)(laterDate_) - (0, $d5bfd625c8c2dcab$export$de90a4bb31c25221)(earlierDate_);
    return yearsDiff * 4 + quartersDiff;
}
var // Fallback for modularized imports:
$cf55ea31a060baca$export$2e2bcd8739ae039 = $cf55ea31a060baca$export$f62ae9fb13958c7a;


var $6iP9u = parcelRequire("6iP9u");

function $d93eded5d446b361$export$c06dce8b38891685(laterDate, earlierDate, options) {
    var _normalizeDates = (0, $6iP9u._)((0, $93d910fdf6e0ae2a$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate), 2), laterDate_ = _normalizeDates[0], earlierDate_ = _normalizeDates[1];
    return laterDate_.getFullYear() - earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$d93eded5d446b361$export$2e2bcd8739ae039 = $d93eded5d446b361$export$c06dce8b38891685;


var $6iP9u = parcelRequire("6iP9u");


function $2500a9260f415d15$export$86415ebf4eb36b8c(laterDate, earlierDate, options) {
    var _normalizeDates = (0, $6iP9u._)((0, $93d910fdf6e0ae2a$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate), 2), laterDate_ = _normalizeDates[0], earlierDate_ = _normalizeDates[1];
    var sign = $2500a9260f415d15$var$compareLocalAsc(laterDate_, earlierDate_);
    var difference = Math.abs((0, $91bd3590a595579e$export$4a02e9c37dab4871)(laterDate_, earlierDate_));
    laterDate_.setDate(laterDate_.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($2500a9260f415d15$var$compareLocalAsc(laterDate_, earlierDate_) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $2500a9260f415d15$var$compareLocalAsc(laterDate, earlierDate) {
    var diff = laterDate.getFullYear() - earlierDate.getFullYear() || laterDate.getMonth() - earlierDate.getMonth() || laterDate.getDate() - earlierDate.getDate() || laterDate.getHours() - earlierDate.getHours() || laterDate.getMinutes() - earlierDate.getMinutes() || laterDate.getSeconds() - earlierDate.getSeconds() || laterDate.getMilliseconds() - earlierDate.getMilliseconds();
    if (diff < 0) return -1;
    if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$2500a9260f415d15$export$2e2bcd8739ae039 = $2500a9260f415d15$export$86415ebf4eb36b8c;


function $9a1f6103452c72c5$export$eb9a03f0e9aa6cea(date, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$9a1f6103452c72c5$export$2e2bcd8739ae039 = $9a1f6103452c72c5$export$eb9a03f0e9aa6cea;


function $5e5a98b8b0b1e40d$export$a2258d9c4118825c(date, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$5e5a98b8b0b1e40d$export$2e2bcd8739ae039 = $5e5a98b8b0b1e40d$export$a2258d9c4118825c;

var $35c5a9bf72110af5$var$defaultOptions = {};
function $35c5a9bf72110af5$export$430a3269e24b912e() {
    return $35c5a9bf72110af5$var$defaultOptions;
}
function $35c5a9bf72110af5$export$95365be1b0704abc(newOptions) {
    $35c5a9bf72110af5$var$defaultOptions = newOptions;
}



function $df2e23426bf9e370$export$ef8b6d9133084f4e(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, $35c5a9bf72110af5$export$430a3269e24b912e)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var day = _date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$df2e23426bf9e370$export$2e2bcd8739ae039 = $df2e23426bf9e370$export$ef8b6d9133084f4e;


function $64f2443f278185ed$export$8b7aa55c66d5569e(date, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$64f2443f278185ed$export$2e2bcd8739ae039 = $64f2443f278185ed$export$8b7aa55c66d5569e;

var $07973df25d9b95b9$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $07973df25d9b95b9$export$2c14ff85d6318973 = function(token, count, options) {
    var result;
    var tokenValue = $07973df25d9b95b9$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options === null || options === void 0 ? void 0 : options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $e76b164245f78608$export$38e44e97ce4dbb7d(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $9914c3bd2dc63338$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $9914c3bd2dc63338$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $9914c3bd2dc63338$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $9914c3bd2dc63338$export$cbf60ecb96cbb82f = {
    date: (0, $e76b164245f78608$export$38e44e97ce4dbb7d)({
        formats: $9914c3bd2dc63338$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $e76b164245f78608$export$38e44e97ce4dbb7d)({
        formats: $9914c3bd2dc63338$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $e76b164245f78608$export$38e44e97ce4dbb7d)({
        formats: $9914c3bd2dc63338$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $32d5a5b428e0241f$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $32d5a5b428e0241f$export$8fbbfd65594f46a0 = function(token, _date, _baseDate, _options) {
    return $32d5a5b428e0241f$var$formatRelativeLocale[token];
};


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $22064de832565a06$export$63596d6ee8878b25(args) {
    return function(value, options) {
        var context = (options === null || options === void 0 ? void 0 : options.context) ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var defaultWidth1 = args.defaultWidth;
            var width1 = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width1] || args.values[defaultWidth1];
        }
        var index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $6710651f102c75ba$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $6710651f102c75ba$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $6710651f102c75ba$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $6710651f102c75ba$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $6710651f102c75ba$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $6710651f102c75ba$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $6710651f102c75ba$var$ordinalNumber = function(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $6710651f102c75ba$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6710651f102c75ba$var$ordinalNumber,
    era: (0, $22064de832565a06$export$63596d6ee8878b25)({
        values: $6710651f102c75ba$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $22064de832565a06$export$63596d6ee8878b25)({
        values: $6710651f102c75ba$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $22064de832565a06$export$63596d6ee8878b25)({
        values: $6710651f102c75ba$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $22064de832565a06$export$63596d6ee8878b25)({
        values: $6710651f102c75ba$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $22064de832565a06$export$63596d6ee8878b25)({
        values: $6710651f102c75ba$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6710651f102c75ba$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $917b062a2114a49e$export$1430a0f35710914d(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $917b062a2114a49e$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $917b062a2114a49e$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $917b062a2114a49e$var$findKey(object, predicate) {
    for(var key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $917b062a2114a49e$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $76da304f3d137ed8$export$fdaf2fd6d7edde95(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $f63864df3f071b52$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $f63864df3f071b52$var$parseOrdinalNumberPattern = /\d+/i;
var $f63864df3f071b52$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $f63864df3f071b52$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $f63864df3f071b52$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $f63864df3f071b52$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f63864df3f071b52$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $f63864df3f071b52$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $f63864df3f071b52$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $f63864df3f071b52$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $f63864df3f071b52$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $f63864df3f071b52$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $f63864df3f071b52$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $76da304f3d137ed8$export$fdaf2fd6d7edde95)({
        matchPattern: $f63864df3f071b52$var$matchOrdinalNumberPattern,
        parsePattern: $f63864df3f071b52$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $917b062a2114a49e$export$1430a0f35710914d)({
        matchPatterns: $f63864df3f071b52$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f63864df3f071b52$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $917b062a2114a49e$export$1430a0f35710914d)({
        matchPatterns: $f63864df3f071b52$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f63864df3f071b52$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $917b062a2114a49e$export$1430a0f35710914d)({
        matchPatterns: $f63864df3f071b52$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f63864df3f071b52$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $917b062a2114a49e$export$1430a0f35710914d)({
        matchPatterns: $f63864df3f071b52$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f63864df3f071b52$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $917b062a2114a49e$export$1430a0f35710914d)({
        matchPatterns: $f63864df3f071b52$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $f63864df3f071b52$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


var $6255fd097cef245d$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $07973df25d9b95b9$export$2c14ff85d6318973),
    formatLong: (0, $9914c3bd2dc63338$export$cbf60ecb96cbb82f),
    formatRelative: (0, $32d5a5b428e0241f$export$8fbbfd65594f46a0),
    localize: (0, $6710651f102c75ba$export$b3bd0bc58e36cd63),
    match: (0, $f63864df3f071b52$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$6255fd097cef245d$export$2e2bcd8739ae039 = $6255fd097cef245d$export$137380d9ce54f7f;





function $7aef50853e997e42$export$f91e89d3d0406102(date, options) {
    var date_ = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$7aef50853e997e42$export$2e2bcd8739ae039 = $7aef50853e997e42$export$f91e89d3d0406102;



function $8aa8676ce93a693d$export$d3b42cd8452deec(date, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var diff = (0, $91bd3590a595579e$export$4a02e9c37dab4871)(_date, (0, $7aef50853e997e42$export$f91e89d3d0406102)(_date));
    var dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$8aa8676ce93a693d$export$2e2bcd8739ae039 = $8aa8676ce93a693d$export$d3b42cd8452deec;




var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");


function $511d10c46cf5757e$export$42c81a444fbfb5d4(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, $35c5a9bf72110af5$export$430a3269e24b912e)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var day = _date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$511d10c46cf5757e$export$2e2bcd8739ae039 = $511d10c46cf5757e$export$42c81a444fbfb5d4;


function $982bb5832aeb7f5b$export$6173213f95a4431e(date, options) {
    return (0, $511d10c46cf5757e$export$42c81a444fbfb5d4)(date, (0, $lf4fc._)((0, $hwO3w._)({}, options), {
        weekStartsOn: 1
    }));
}
var // Fallback for modularized imports:
$982bb5832aeb7f5b$export$2e2bcd8739ae039 = $982bb5832aeb7f5b$export$6173213f95a4431e;






function $61e963de4dc6c028$export$3dbc52535f6f8fcc(date, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var year = _date.getFullYear();
    var fourthOfJanuaryOfNextYear = (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $982bb5832aeb7f5b$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $982bb5832aeb7f5b$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$61e963de4dc6c028$export$2e2bcd8739ae039 = $61e963de4dc6c028$export$3dbc52535f6f8fcc;



function $b8aee900a751c48e$export$236bdfa374eb69a9(date, options) {
    var year = (0, $61e963de4dc6c028$export$3dbc52535f6f8fcc)(date, options);
    var fourthOfJanuary = (0, $5dd48bd7eb19f030$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $982bb5832aeb7f5b$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$b8aee900a751c48e$export$2e2bcd8739ae039 = $b8aee900a751c48e$export$236bdfa374eb69a9;



function $bef7c8dcc2b7b577$export$7cabdc5698b63e2f(date, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var diff = +(0, $982bb5832aeb7f5b$export$6173213f95a4431e)(_date) - +(0, $b8aee900a751c48e$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $e2377001c88df902$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$bef7c8dcc2b7b577$export$2e2bcd8739ae039 = $bef7c8dcc2b7b577$export$7cabdc5698b63e2f;











function $3e53c84c27356d61$export$12d572480ceb6e58(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var year = _date.getFullYear();
    var defaultOptions = (0, $35c5a9bf72110af5$export$430a3269e24b912e)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    var firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var firstWeekOfNextYear = (0, $5dd48bd7eb19f030$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $511d10c46cf5757e$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = (0, $5dd48bd7eb19f030$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $511d10c46cf5757e$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$3e53c84c27356d61$export$2e2bcd8739ae039 = $3e53c84c27356d61$export$12d572480ceb6e58;



function $c284c1b9ddc60c1d$export$bb7b45bb8e74da0f(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, $35c5a9bf72110af5$export$430a3269e24b912e)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    var firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var year = (0, $3e53c84c27356d61$export$12d572480ceb6e58)(date, options);
    var firstWeek = (0, $5dd48bd7eb19f030$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var _date = (0, $511d10c46cf5757e$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$c284c1b9ddc60c1d$export$2e2bcd8739ae039 = $c284c1b9ddc60c1d$export$bb7b45bb8e74da0f;



function $f46ef35468211e3a$export$efe19b760242b2fc(date, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var diff = +(0, $511d10c46cf5757e$export$42c81a444fbfb5d4)(_date, options) - +(0, $c284c1b9ddc60c1d$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $e2377001c88df902$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$f46ef35468211e3a$export$2e2bcd8739ae039 = $f46ef35468211e3a$export$efe19b760242b2fc;



function $e5298c8bbe600ef7$export$c8306e720e213c0f(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



var $04c7dc65b9beb877$export$b0d4b338e1516f13 = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getMilliseconds();
        var fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


var $34a39587f9234ae7$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
var $34a39587f9234ae7$export$fe98a034cfb96d55 = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $04c7dc65b9beb877$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $3e53c84c27356d61$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $61e963de4dc6c028$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getFullYear();
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $04c7dc65b9beb877$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $f46ef35468211e3a$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $bef7c8dcc2b7b577$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $04c7dc65b9beb877$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $8aa8676ce93a693d$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $34a39587f9234ae7$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $34a39587f9234ae7$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $34a39587f9234ae7$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $34a39587f9234ae7$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $34a39587f9234ae7$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $34a39587f9234ae7$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $04c7dc65b9beb877$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $04c7dc65b9beb877$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $04c7dc65b9beb877$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $04c7dc65b9beb877$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $04c7dc65b9beb877$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $34a39587f9234ae7$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $34a39587f9234ae7$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $34a39587f9234ae7$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $34a39587f9234ae7$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $34a39587f9234ae7$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $34a39587f9234ae7$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $34a39587f9234ae7$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $34a39587f9234ae7$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize) {
        var timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $34a39587f9234ae7$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $34a39587f9234ae7$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize) {
        var timestamp = Math.trunc(+date / 1000);
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize) {
        return (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $34a39587f9234ae7$var$formatTimezoneShort(offset) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.trunc(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(minutes, 2);
}
function $34a39587f9234ae7$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $34a39587f9234ae7$var$formatTimezone(offset, delimiter);
}
function $34a39587f9234ae7$var$formatTimezone(offset) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    var minutes = (0, $e5298c8bbe600ef7$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


var $3b214bb21890e36a$var$dateLongFormatter = function(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $3b214bb21890e36a$var$timeLongFormatter = function(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $3b214bb21890e36a$var$dateTimeLongFormatter = function(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $3b214bb21890e36a$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $3b214bb21890e36a$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $3b214bb21890e36a$var$timeLongFormatter(timePattern, formatLong));
};
var $3b214bb21890e36a$export$70cc8fd02856fd58 = {
    p: $3b214bb21890e36a$var$timeLongFormatter,
    P: $3b214bb21890e36a$var$dateTimeLongFormatter
};


var $dcaf27d1fc3f5789$var$dayOfYearTokenRE = /^D+$/;
var $dcaf27d1fc3f5789$var$weekYearTokenRE = /^Y+$/;
var $dcaf27d1fc3f5789$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $dcaf27d1fc3f5789$export$c6cc36aa33304772(token) {
    return $dcaf27d1fc3f5789$var$dayOfYearTokenRE.test(token);
}
function $dcaf27d1fc3f5789$export$c6b49d6dceb604a1(token) {
    return $dcaf27d1fc3f5789$var$weekYearTokenRE.test(token);
}
function $dcaf27d1fc3f5789$export$f5f38f90ecaaf879(token, format, input) {
    var _message = $dcaf27d1fc3f5789$var$message(token, format, input);
    console.warn(_message);
    if ($dcaf27d1fc3f5789$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $dcaf27d1fc3f5789$var$message(token, format, input) {
    var subject = token[0] === "Y" ? "years" : "days of the month";
    return "Use `".concat(token.toLowerCase(), "` instead of `").concat(token, "` (in `").concat(format, "`) for formatting ").concat(subject, " to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md");
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
var $03bAP = parcelRequire("03bAP");
function $3f7a13fe08643584$export$871608497c498473(value) {
    return value instanceof Date || (typeof value === "undefined" ? "undefined" : (0, $03bAP._)(value)) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$3f7a13fe08643584$export$2e2bcd8739ae039 = $3f7a13fe08643584$export$871608497c498473;



function $182c023b950d4f49$export$1ea939691cdc45b8(date) {
    return !(!(0, $3f7a13fe08643584$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$182c023b950d4f49$export$2e2bcd8739ae039 = $182c023b950d4f49$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e95f60e70b4946e2$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e95f60e70b4946e2$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e95f60e70b4946e2$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e95f60e70b4946e2$var$doubleQuoteRegExp = /''/g;
var $e95f60e70b4946e2$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e95f60e70b4946e2$export$d9468344d3651243(date, formatStr, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    var defaultOptions = (0, $35c5a9bf72110af5$export$430a3269e24b912e)();
    var _options_locale2, _ref;
    var locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $6255fd097cef245d$export$137380d9ce54f7f);
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    var firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    var weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    var originalDate = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    if (!(0, $182c023b950d4f49$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    var parts = formatStr.match($e95f60e70b4946e2$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $3b214bb21890e36a$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($e95f60e70b4946e2$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $e95f60e70b4946e2$var$cleanEscapedString(substring)
        };
        if ((0, $34a39587f9234ae7$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($e95f60e70b4946e2$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map(function(part) {
        if (!part.isToken) return part.value;
        var token = part.value;
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, $dcaf27d1fc3f5789$export$c6b49d6dceb604a1)(token) || !(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, $dcaf27d1fc3f5789$export$c6cc36aa33304772)(token)) (0, $dcaf27d1fc3f5789$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        var formatter = (0, $34a39587f9234ae7$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $e95f60e70b4946e2$var$cleanEscapedString(input) {
    var matched = input.match($e95f60e70b4946e2$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($e95f60e70b4946e2$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$e95f60e70b4946e2$export$2e2bcd8739ae039 = $e95f60e70b4946e2$export$d9468344d3651243;


function $61b6d1d5784dd880$export$aa350b96d91cd94(date, options) {
    return (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getDate();
}
var // Fallback for modularized imports:
$61b6d1d5784dd880$export$2e2bcd8739ae039 = $61b6d1d5784dd880$export$aa350b96d91cd94;


function $a03163f251b8884c$export$1b64bc9c5306ed54(date, options) {
    return (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getDay();
}
var // Fallback for modularized imports:
$a03163f251b8884c$export$2e2bcd8739ae039 = $a03163f251b8884c$export$1b64bc9c5306ed54;


function $75f9879a8962b028$export$257b40f71c07d58f(date, options) {
    return (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getHours();
}
var // Fallback for modularized imports:
$75f9879a8962b028$export$2e2bcd8739ae039 = $75f9879a8962b028$export$257b40f71c07d58f;


function $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145(date, options) {
    return (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getMinutes();
}
var // Fallback for modularized imports:
$d7a0487caac9cc4b$export$2e2bcd8739ae039 = $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145;


function $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b(date, options) {
    return (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getMonth();
}
var // Fallback for modularized imports:
$7fcaafd8adb8f8ec$export$2e2bcd8739ae039 = $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b;


function $d895bdcba9991f26$export$5e9417507ff28427(date) {
    return (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date).getSeconds();
}
var // Fallback for modularized imports:
$d895bdcba9991f26$export$2e2bcd8739ae039 = $d895bdcba9991f26$export$5e9417507ff28427;


function $e77654c571bb8a61$export$1428f42a7de81803(date) {
    return +(0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date);
}
var // Fallback for modularized imports:
$e77654c571bb8a61$export$2e2bcd8739ae039 = $e77654c571bb8a61$export$1428f42a7de81803;


function $d5d47ade5ad8c3d9$export$5846dc2d57a5c860(date, options) {
    return (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getFullYear();
}
var // Fallback for modularized imports:
$d5d47ade5ad8c3d9$export$2e2bcd8739ae039 = $d5d47ade5ad8c3d9$export$5846dc2d57a5c860;


function $63acaba5662d3256$export$e4de839670987035(date, dateToCompare) {
    return +(0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date) > +(0, $8d125137b8a7ac52$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$63acaba5662d3256$export$2e2bcd8739ae039 = $63acaba5662d3256$export$e4de839670987035;


function $0e5980f964c532bb$export$5c007e10c6929c95(date, dateToCompare) {
    return +(0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date) < +(0, $8d125137b8a7ac52$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$0e5980f964c532bb$export$2e2bcd8739ae039 = $0e5980f964c532bb$export$5c007e10c6929c95;


function $b090f423df9beee1$export$248d38f6296296c5(leftDate, rightDate) {
    return +(0, $8d125137b8a7ac52$export$e67a095c620b86fe)(leftDate) === +(0, $8d125137b8a7ac52$export$e67a095c620b86fe)(rightDate);
}
var // Fallback for modularized imports:
$b090f423df9beee1$export$2e2bcd8739ae039 = $b090f423df9beee1$export$248d38f6296296c5;


var $6iP9u = parcelRequire("6iP9u");


function $04e2d0106a319fd0$export$ea39ec197993aef0(laterDate, earlierDate, options) {
    var _normalizeDates = (0, $6iP9u._)((0, $93d910fdf6e0ae2a$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate), 2), dateLeft_ = _normalizeDates[0], dateRight_ = _normalizeDates[1];
    return +(0, $e4ccc1375d9fa1c3$export$63fa379ae8a9ba2)(dateLeft_) === +(0, $e4ccc1375d9fa1c3$export$63fa379ae8a9ba2)(dateRight_);
}
var // Fallback for modularized imports:
$04e2d0106a319fd0$export$2e2bcd8739ae039 = $04e2d0106a319fd0$export$ea39ec197993aef0;


var $6iP9u = parcelRequire("6iP9u");

function $40ebfe802eb13cad$export$a18c89cbd24170ff(laterDate, earlierDate, options) {
    var _normalizeDates = (0, $6iP9u._)((0, $93d910fdf6e0ae2a$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate), 2), laterDate_ = _normalizeDates[0], earlierDate_ = _normalizeDates[1];
    return laterDate_.getFullYear() === earlierDate_.getFullYear() && laterDate_.getMonth() === earlierDate_.getMonth();
}
var // Fallback for modularized imports:
$40ebfe802eb13cad$export$2e2bcd8739ae039 = $40ebfe802eb13cad$export$a18c89cbd24170ff;


var $6iP9u = parcelRequire("6iP9u");


function $74ef9e652b0920d7$export$69be7267a042ecb3(date, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var currentMonth = _date.getMonth();
    var month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$74ef9e652b0920d7$export$2e2bcd8739ae039 = $74ef9e652b0920d7$export$69be7267a042ecb3;


function $5b88cf2109649193$export$5c60e4190867161c(laterDate, earlierDate, options) {
    var _normalizeDates = (0, $6iP9u._)((0, $93d910fdf6e0ae2a$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate), 2), dateLeft_ = _normalizeDates[0], dateRight_ = _normalizeDates[1];
    return +(0, $74ef9e652b0920d7$export$69be7267a042ecb3)(dateLeft_) === +(0, $74ef9e652b0920d7$export$69be7267a042ecb3)(dateRight_);
}
var // Fallback for modularized imports:
$5b88cf2109649193$export$2e2bcd8739ae039 = $5b88cf2109649193$export$5c60e4190867161c;


var $6iP9u = parcelRequire("6iP9u");

function $f789575999abe89d$export$5841f9eb9773f25f(laterDate, earlierDate, options) {
    var _normalizeDates = (0, $6iP9u._)((0, $93d910fdf6e0ae2a$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate), 2), laterDate_ = _normalizeDates[0], earlierDate_ = _normalizeDates[1];
    return laterDate_.getFullYear() === earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$f789575999abe89d$export$2e2bcd8739ae039 = $f789575999abe89d$export$5841f9eb9773f25f;


var $6iP9u = parcelRequire("6iP9u");

function $80f090dfcae59d9d$export$d7deef7a3738e19d(date, interval, options) {
    var time = +(0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var _sort = (0, $6iP9u._)([
        +(0, $8d125137b8a7ac52$export$e67a095c620b86fe)(interval.start, options === null || options === void 0 ? void 0 : options.in),
        +(0, $8d125137b8a7ac52$export$e67a095c620b86fe)(interval.end, options === null || options === void 0 ? void 0 : options.in)
    ].sort(function(a, b) {
        return a - b;
    }), 2), startTime = _sort[0], endTime = _sort[1];
    return time >= startTime && time <= endTime;
}
var // Fallback for modularized imports:
$80f090dfcae59d9d$export$2e2bcd8739ae039 = $80f090dfcae59d9d$export$d7deef7a3738e19d;


var $03bAP = parcelRequire("03bAP");


function $3eb9c7c0bf6639a5$export$8960430cfd85939f(dates, options) {
    var result;
    var context = options === null || options === void 0 ? void 0 : options.in;
    dates.forEach(function(date) {
        // Use the first date object as the context function
        if (!context && (typeof date === "undefined" ? "undefined" : (0, $03bAP._)(date)) === "object") context = (0, $5dd48bd7eb19f030$export$ead8a1812b171991).bind(null, date);
        var date_ = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, context);
        if (!result || result < date_ || isNaN(+date_)) result = date_;
    });
    return (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(context, result || NaN);
}
var // Fallback for modularized imports:
$3eb9c7c0bf6639a5$export$2e2bcd8739ae039 = $3eb9c7c0bf6639a5$export$8960430cfd85939f;


var $03bAP = parcelRequire("03bAP");


function $9bce878bd8c21516$export$96ec731ed4dcb222(dates, options) {
    var result;
    var context = options === null || options === void 0 ? void 0 : options.in;
    dates.forEach(function(date) {
        // Use the first date object as the context function
        if (!context && (typeof date === "undefined" ? "undefined" : (0, $03bAP._)(date)) === "object") context = (0, $5dd48bd7eb19f030$export$ead8a1812b171991).bind(null, date);
        var date_ = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, context);
        if (!result || result > date_ || isNaN(+date_)) result = date_;
    });
    return (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(context, result || NaN);
}
var // Fallback for modularized imports:
$9bce878bd8c21516$export$2e2bcd8739ae039 = $9bce878bd8c21516$export$96ec731ed4dcb222;


var $03bAP = parcelRequire("03bAP");





function $1d06b0a89bb940e8$export$430a3269e24b912e() {
    return Object.assign({}, (0, $35c5a9bf72110af5$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$1d06b0a89bb940e8$export$2e2bcd8739ae039 = $1d06b0a89bb940e8$export$430a3269e24b912e;




var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");


function $48be25527dc2b9bb$export$9cb09a71b7d66923(date, constructor) {
    var date_ = $48be25527dc2b9bb$var$isConstructor(constructor) ? new constructor(0) : (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $48be25527dc2b9bb$var$isConstructor(constructor) {
    var _constructor_prototype;
    return typeof constructor === "function" && ((_constructor_prototype = constructor.prototype) === null || _constructor_prototype === void 0 ? void 0 : _constructor_prototype.constructor) === constructor;
}
var // Fallback for modularized imports:
$48be25527dc2b9bb$export$2e2bcd8739ae039 = $48be25527dc2b9bb$export$9cb09a71b7d66923;


var $406d80267af27b97$var$TIMEZONE_UNIT_PRIORITY = 10;
var $406d80267af27b97$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    "use strict";
    function Setter() {
        (0, $5Epmf._)(this, Setter);
        (0, $dUlz9._)(this, "subPriority", 0);
    }
    (0, $9MqXK._)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $406d80267af27b97$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(Setter) {
    "use strict";
    (0, $4QAx6._)(ValueSetter, Setter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        (0, $5Epmf._)(this, ValueSetter);
        var _this;
        _this = (0, $48Z0s._)(this, ValueSetter);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $9MqXK._)(ValueSetter, [
        {
            key: "validate",
            value: function validate(date, options) {
                return this.validateValue(date, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(date, flags, options) {
                return this.setValue(date, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($406d80267af27b97$export$81d53e3678089a6);
var $406d80267af27b97$export$8be15fe85ad72f86 = /*#__PURE__*/ function(Setter) {
    "use strict";
    (0, $4QAx6._)(DateTimezoneSetter, Setter);
    function DateTimezoneSetter(context, reference) {
        (0, $5Epmf._)(this, DateTimezoneSetter);
        var _this;
        _this = (0, $48Z0s._)(this, DateTimezoneSetter), (0, $dUlz9._)(_this, "priority", $406d80267af27b97$var$TIMEZONE_UNIT_PRIORITY), (0, $dUlz9._)(_this, "subPriority", -1);
        _this.context = context || function(date) {
            return (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(reference, date);
        };
        return _this;
    }
    (0, $9MqXK._)(DateTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                return (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(date, (0, $48be25527dc2b9bb$export$9cb09a71b7d66923)(date, this.context));
            }
        }
    ]);
    return DateTimezoneSetter;
}($406d80267af27b97$export$81d53e3678089a6);



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $02ae5c9d4a504986$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    "use strict";
    function Parser() {
        (0, $5Epmf._)(this, Parser);
    }
    (0, $9MqXK._)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $406d80267af27b97$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $66e6579145e57055$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(EraParser, Parser);
    function EraParser() {
        (0, $5Epmf._)(this, EraParser);
        var _this;
        _this = (0, $48Z0s._)(this, EraParser, arguments), (0, $dUlz9._)(_this, "priority", 140), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setFullYear(value, 0, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");


var $d812b4ad89c2cc34$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
var $d812b4ad89c2cc34$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $21ec949644e5f6b7$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $21ec949644e5f6b7$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $21ec949644e5f6b7$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $e2377001c88df902$export$7f72910d6dfd237a) + minutes * (0, $e2377001c88df902$export$91246f0b9bd9beff) + seconds * (0, $e2377001c88df902$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $21ec949644e5f6b7$export$d931c43c4608a164(dateString) {
    return $21ec949644e5f6b7$export$cc7cc9e2a3ff9388((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $21ec949644e5f6b7$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $21ec949644e5f6b7$export$cc7cc9e2a3ff9388((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $21ec949644e5f6b7$export$cc7cc9e2a3ff9388((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $21ec949644e5f6b7$export$cc7cc9e2a3ff9388((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $21ec949644e5f6b7$export$cc7cc9e2a3ff9388((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $21ec949644e5f6b7$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $21ec949644e5f6b7$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $21ec949644e5f6b7$export$cc7cc9e2a3ff9388((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $21ec949644e5f6b7$export$cc7cc9e2a3ff9388((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $21ec949644e5f6b7$export$cc7cc9e2a3ff9388((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $21ec949644e5f6b7$export$cc7cc9e2a3ff9388((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $21ec949644e5f6b7$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $21ec949644e5f6b7$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $21ec949644e5f6b7$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $21ec949644e5f6b7$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $815b7959c0d37932$export$48d352de7cd4a988 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(YearParser, Parser);
    function YearParser() {
        (0, $5Epmf._)(this, YearParser);
        var _this;
        _this = (0, $48Z0s._)(this, YearParser, arguments), (0, $dUlz9._)(_this, "priority", 130), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)((0, $21ec949644e5f6b7$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)((0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $21ec949644e5f6b7$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setFullYear(year, 0, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");




var $82572f43d8dff124$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(LocalWeekYearParser, Parser);
    function LocalWeekYearParser() {
        (0, $5Epmf._)(this, LocalWeekYearParser);
        var _this;
        _this = (0, $48Z0s._)(this, LocalWeekYearParser, arguments), (0, $dUlz9._)(_this, "priority", 130), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)((0, $21ec949644e5f6b7$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)((0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $3e53c84c27356d61$export$12d572480ceb6e58)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $21ec949644e5f6b7$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setHours(0, 0, 0, 0);
                    return (0, $511d10c46cf5757e$export$42c81a444fbfb5d4)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setFullYear(year, 0, options.firstWeekContainsDate);
                date.setHours(0, 0, 0, 0);
                return (0, $511d10c46cf5757e$export$42c81a444fbfb5d4)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");




var $f1e1ca29facfb13b$export$951d1df011fde06f = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(ISOWeekYearParser, Parser);
    function ISOWeekYearParser() {
        (0, $5Epmf._)(this, ISOWeekYearParser);
        var _this;
        _this = (0, $48Z0s._)(this, ISOWeekYearParser, arguments), (0, $dUlz9._)(_this, "priority", 130), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $21ec949644e5f6b7$export$2c9307b2e29c533c)(4, dateString);
                return (0, $21ec949644e5f6b7$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var firstWeekOfYear = (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(date, 0);
                firstWeekOfYear.setFullYear(value, 0, 4);
                firstWeekOfYear.setHours(0, 0, 0, 0);
                return (0, $982bb5832aeb7f5b$export$6173213f95a4431e)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");


var $549fee0929ea714f$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(ExtendedYearParser, Parser);
    function ExtendedYearParser() {
        (0, $5Epmf._)(this, ExtendedYearParser);
        var _this;
        _this = (0, $48Z0s._)(this, ExtendedYearParser, arguments), (0, $dUlz9._)(_this, "priority", 130), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $21ec949644e5f6b7$export$2c9307b2e29c533c)(4, dateString);
                return (0, $21ec949644e5f6b7$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setFullYear(value, 0, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");


var $016550e7664df4cb$export$5cb0f701186dde1d = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(QuarterParser, Parser);
    function QuarterParser() {
        (0, $5Epmf._)(this, QuarterParser);
        var _this;
        _this = (0, $48Z0s._)(this, QuarterParser, arguments), (0, $dUlz9._)(_this, "priority", 120), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        return (0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth((value - 1) * 3, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");


var $d9a414d3b69efe6f$export$300c0c2990e20e6d = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(StandAloneQuarterParser, Parser);
    function StandAloneQuarterParser() {
        (0, $5Epmf._)(this, StandAloneQuarterParser);
        var _this;
        _this = (0, $48Z0s._)(this, StandAloneQuarterParser, arguments), (0, $dUlz9._)(_this, "priority", 120), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        return (0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth((value - 1) * 3, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $4dd97066172cdf16$export$400dd8b40ef138a3 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(MonthParser, Parser);
    function MonthParser() {
        (0, $5Epmf._)(this, MonthParser);
        var _this;
        _this = (0, $48Z0s._)(this, MonthParser, arguments), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), (0, $dUlz9._)(_this, "priority", 110);
        return _this;
    }
    (0, $9MqXK._)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)((0, $21ec949644e5f6b7$export$cc7cc9e2a3ff9388)((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)((0, $21ec949644e5f6b7$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth(value, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $61b19cf05c6afe8f$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(StandAloneMonthParser, Parser);
    function StandAloneMonthParser() {
        (0, $5Epmf._)(this, StandAloneMonthParser);
        var _this;
        _this = (0, $48Z0s._)(this, StandAloneMonthParser, arguments), (0, $dUlz9._)(_this, "priority", 110), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)((0, $21ec949644e5f6b7$export$cc7cc9e2a3ff9388)((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)((0, $21ec949644e5f6b7$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth(value, 1);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");


function $170bd9199acf7f52$export$4b3066ce4afafd88(date, week, options) {
    var date_ = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var diff = (0, $f46ef35468211e3a$export$efe19b760242b2fc)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date_, options === null || options === void 0 ? void 0 : options.in);
}
var // Fallback for modularized imports:
$170bd9199acf7f52$export$2e2bcd8739ae039 = $170bd9199acf7f52$export$4b3066ce4afafd88;






var $981a781738bfb92c$export$c4005ffc174e07c0 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(LocalWeekParser, Parser);
    function LocalWeekParser() {
        (0, $5Epmf._)(this, LocalWeekParser);
        var _this;
        _this = (0, $48Z0s._)(this, LocalWeekParser, arguments), (0, $dUlz9._)(_this, "priority", 100), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $21ec949644e5f6b7$export$cc7cc9e2a3ff9388)((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $511d10c46cf5757e$export$42c81a444fbfb5d4)((0, $170bd9199acf7f52$export$4b3066ce4afafd88)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");


function $8543b518d314d1a0$export$6542bebf6be94082(date, week, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var diff = (0, $bef7c8dcc2b7b577$export$7cabdc5698b63e2f)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$8543b518d314d1a0$export$2e2bcd8739ae039 = $8543b518d314d1a0$export$6542bebf6be94082;






var $43ef2172cef466d9$export$6fc8dbedd560a6af = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(ISOWeekParser, Parser);
    function ISOWeekParser() {
        (0, $5Epmf._)(this, ISOWeekParser);
        var _this;
        _this = (0, $48Z0s._)(this, ISOWeekParser, arguments), (0, $dUlz9._)(_this, "priority", 100), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $21ec949644e5f6b7$export$cc7cc9e2a3ff9388)((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $982bb5832aeb7f5b$export$6173213f95a4431e)((0, $8543b518d314d1a0$export$6542bebf6be94082)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $1c822b32425351e4$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1c822b32425351e4$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1c822b32425351e4$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(DateParser, Parser);
    function DateParser() {
        (0, $5Epmf._)(this, DateParser);
        var _this;
        _this = (0, $48Z0s._)(this, DateParser, arguments), (0, $dUlz9._)(_this, "priority", 90), (0, $dUlz9._)(_this, "subPriority", 1), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $21ec949644e5f6b7$export$cc7cc9e2a3ff9388)((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getFullYear();
                var isLeapYear = (0, $21ec949644e5f6b7$export$3d50627710b84d75)(year);
                var month = date.getMonth();
                if (isLeapYear) return value >= 1 && value <= $1c822b32425351e4$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $1c822b32425351e4$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setDate(value);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $13df21ea99527aa8$export$6cfe0d613455f615 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(DayOfYearParser, Parser);
    function DayOfYearParser() {
        (0, $5Epmf._)(this, DayOfYearParser);
        var _this;
        _this = (0, $48Z0s._)(this, DayOfYearParser, arguments), (0, $dUlz9._)(_this, "priority", 90), (0, $dUlz9._)(_this, "subpriority", 1), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $21ec949644e5f6b7$export$cc7cc9e2a3ff9388)((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getFullYear();
                var isLeapYear = (0, $21ec949644e5f6b7$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMonth(0, value);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



function $34d4906bf5796ab4$export$b04fdcda82decc6c(date, day, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    var defaultOptions = (0, $35c5a9bf72110af5$export$430a3269e24b912e)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    var weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    var date_ = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var currentDay = date_.getDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var delta = 7 - weekStartsOn;
    var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $2b4ff6e56ae3ad17$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$34d4906bf5796ab4$export$2e2bcd8739ae039 = $34d4906bf5796ab4$export$b04fdcda82decc6c;



var $4777daf92e48d361$export$1b03c8b76262f7bd = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(DayParser, Parser);
    function DayParser() {
        (0, $5Epmf._)(this, DayParser);
        var _this;
        _this = (0, $48Z0s._)(this, DayParser, arguments), (0, $dUlz9._)(_this, "priority", 90), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $34d4906bf5796ab4$export$b04fdcda82decc6c)(date, value, options);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $1eeed6b34bcc1b20$export$44d1c127ab42c480 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(LocalDayParser, Parser);
    function LocalDayParser() {
        (0, $5Epmf._)(this, LocalDayParser);
        var _this;
        _this = (0, $48Z0s._)(this, LocalDayParser, arguments), (0, $dUlz9._)(_this, "priority", 90), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function(value) {
                    // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)((0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $34d4906bf5796ab4$export$b04fdcda82decc6c)(date, value, options);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $2339ed6b0c7eeeaa$export$e447a647caaaec1d = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(StandAloneLocalDayParser, Parser);
    function StandAloneLocalDayParser() {
        (0, $5Epmf._)(this, StandAloneLocalDayParser);
        var _this;
        _this = (0, $48Z0s._)(this, StandAloneLocalDayParser, arguments), (0, $dUlz9._)(_this, "priority", 90), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function(value) {
                    // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)((0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $34d4906bf5796ab4$export$b04fdcda82decc6c)(date, value, options);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");


function $c0303806c06e85c2$export$c514f4c1a8ed5e9e(date, options) {
    var day = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$c0303806c06e85c2$export$2e2bcd8739ae039 = $c0303806c06e85c2$export$c514f4c1a8ed5e9e;



function $46f06b5ea61bc7a8$export$1fd9df65adb0d1aa(date, day, options) {
    var date_ = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var currentDay = (0, $c0303806c06e85c2$export$c514f4c1a8ed5e9e)(date_, options);
    var diff = day - currentDay;
    return (0, $2b4ff6e56ae3ad17$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$46f06b5ea61bc7a8$export$2e2bcd8739ae039 = $46f06b5ea61bc7a8$export$1fd9df65adb0d1aa;




var $18559d9f934d76b3$export$693fb1e525095b2a = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(ISODayParser, Parser);
    function ISODayParser() {
        (0, $5Epmf._)(this, ISODayParser);
        var _this;
        _this = (0, $48Z0s._)(this, ISODayParser, arguments), (0, $dUlz9._)(_this, "priority", 90), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        return (0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $46f06b5ea61bc7a8$export$1fd9df65adb0d1aa)(date, value);
                date.setHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");


var $aa1448aa3ef2ac70$export$8d1e08492351df91 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(AMPMParser, Parser);
    function AMPMParser() {
        (0, $5Epmf._)(this, AMPMParser);
        var _this;
        _this = (0, $48Z0s._)(this, AMPMParser, arguments), (0, $dUlz9._)(_this, "priority", 80), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setHours((0, $21ec949644e5f6b7$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");


var $ad03e77d1616483d$export$73ca2bd0a17d273 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(AMPMMidnightParser, Parser);
    function AMPMMidnightParser() {
        (0, $5Epmf._)(this, AMPMMidnightParser);
        var _this;
        _this = (0, $48Z0s._)(this, AMPMMidnightParser, arguments), (0, $dUlz9._)(_this, "priority", 80), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setHours((0, $21ec949644e5f6b7$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");


var $9041efa909496b4c$export$bb9212adf05373db = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(DayPeriodParser, Parser);
    function DayPeriodParser() {
        (0, $5Epmf._)(this, DayPeriodParser);
        var _this;
        _this = (0, $48Z0s._)(this, DayPeriodParser, arguments), (0, $dUlz9._)(_this, "priority", 80), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setHours((0, $21ec949644e5f6b7$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $ab34847c335f5c18$export$8a04050a727a1756 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(Hour1to12Parser, Parser);
    function Hour1to12Parser() {
        (0, $5Epmf._)(this, Hour1to12Parser);
        var _this;
        _this = (0, $48Z0s._)(this, Hour1to12Parser, arguments), (0, $dUlz9._)(_this, "priority", 70), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $21ec949644e5f6b7$export$cc7cc9e2a3ff9388)((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getHours() >= 12;
                if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
                else date.setHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $62f4a0153dae9b9b$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(Hour0to23Parser, Parser);
    function Hour0to23Parser() {
        (0, $5Epmf._)(this, Hour0to23Parser);
        var _this;
        _this = (0, $48Z0s._)(this, Hour0to23Parser, arguments), (0, $dUlz9._)(_this, "priority", 70), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $21ec949644e5f6b7$export$cc7cc9e2a3ff9388)((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $cb61cc9aaf7a50f3$export$cbbe855312f87d77 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(Hour0To11Parser, Parser);
    function Hour0To11Parser() {
        (0, $5Epmf._)(this, Hour0To11Parser);
        var _this;
        _this = (0, $48Z0s._)(this, Hour0To11Parser, arguments), (0, $dUlz9._)(_this, "priority", 70), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $21ec949644e5f6b7$export$cc7cc9e2a3ff9388)((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getHours() >= 12;
                if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
                else date.setHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $60b994877b84b5e4$export$6008046d2b34b6a5 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(Hour1To24Parser, Parser);
    function Hour1To24Parser() {
        (0, $5Epmf._)(this, Hour1To24Parser);
        var _this;
        _this = (0, $48Z0s._)(this, Hour1To24Parser, arguments), (0, $dUlz9._)(_this, "priority", 70), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $21ec949644e5f6b7$export$cc7cc9e2a3ff9388)((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $1cb7915aa3541cdf$export$2b52670d9e2be53 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(MinuteParser, Parser);
    function MinuteParser() {
        (0, $5Epmf._)(this, MinuteParser);
        var _this;
        _this = (0, $48Z0s._)(this, MinuteParser, arguments), (0, $dUlz9._)(_this, "priority", 60), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $21ec949644e5f6b7$export$cc7cc9e2a3ff9388)((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $6b139af6332e2bc3$export$94d46d540cf1366a = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(SecondParser, Parser);
    function SecondParser() {
        (0, $5Epmf._)(this, SecondParser);
        var _this;
        _this = (0, $48Z0s._)(this, SecondParser, arguments), (0, $dUlz9._)(_this, "priority", 50), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $21ec949644e5f6b7$export$cc7cc9e2a3ff9388)((0, $d812b4ad89c2cc34$export$c123ee06d9da8480).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");


var $179bed799b4f6fee$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(FractionOfSecondParser, Parser);
    function FractionOfSecondParser() {
        (0, $5Epmf._)(this, FractionOfSecondParser);
        var _this;
        _this = (0, $48Z0s._)(this, FractionOfSecondParser, arguments), (0, $dUlz9._)(_this, "priority", 30), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $9MqXK._)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function(value) {
                    return Math.trunc(value * Math.pow(10, -token.length + 3));
                };
                return (0, $21ec949644e5f6b7$export$4f84e3a82c7b538)((0, $21ec949644e5f6b7$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");





var $d7f79705d9542045$export$104d901d49fea29b = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(ISOTimezoneWithZParser, Parser);
    function ISOTimezoneWithZParser() {
        (0, $5Epmf._)(this, ISOTimezoneWithZParser);
        var _this;
        _this = (0, $48Z0s._)(this, ISOTimezoneWithZParser, arguments), (0, $dUlz9._)(_this, "priority", 10), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $9MqXK._)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $21ec949644e5f6b7$export$6497f4c0ecdfba8e)((0, $d812b4ad89c2cc34$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $21ec949644e5f6b7$export$6497f4c0ecdfba8e)((0, $d812b4ad89c2cc34$export$a7ee192b982af9c1).basic, dateString);
                    case "XXXX":
                        return (0, $21ec949644e5f6b7$export$6497f4c0ecdfba8e)((0, $d812b4ad89c2cc34$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $21ec949644e5f6b7$export$6497f4c0ecdfba8e)((0, $d812b4ad89c2cc34$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $21ec949644e5f6b7$export$6497f4c0ecdfba8e)((0, $d812b4ad89c2cc34$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(date, date.getTime() - (0, $6a38a618b9fe9e77$export$113002b5eff6e430)(date) - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");





var $73329825bb1333e0$export$12910e5204b52b9 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(ISOTimezoneParser, Parser);
    function ISOTimezoneParser() {
        (0, $5Epmf._)(this, ISOTimezoneParser);
        var _this;
        _this = (0, $48Z0s._)(this, ISOTimezoneParser, arguments), (0, $dUlz9._)(_this, "priority", 10), (0, $dUlz9._)(_this, "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $9MqXK._)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $21ec949644e5f6b7$export$6497f4c0ecdfba8e)((0, $d812b4ad89c2cc34$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $21ec949644e5f6b7$export$6497f4c0ecdfba8e)((0, $d812b4ad89c2cc34$export$a7ee192b982af9c1).basic, dateString);
                    case "xxxx":
                        return (0, $21ec949644e5f6b7$export$6497f4c0ecdfba8e)((0, $d812b4ad89c2cc34$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $21ec949644e5f6b7$export$6497f4c0ecdfba8e)((0, $d812b4ad89c2cc34$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $21ec949644e5f6b7$export$6497f4c0ecdfba8e)((0, $d812b4ad89c2cc34$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(date, date.getTime() - (0, $6a38a618b9fe9e77$export$113002b5eff6e430)(date) - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $815db925d3dd337d$export$2cd8bf877a05e96 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(TimestampSecondsParser, Parser);
    function TimestampSecondsParser() {
        (0, $5Epmf._)(this, TimestampSecondsParser);
        var _this;
        _this = (0, $48Z0s._)(this, TimestampSecondsParser, arguments), (0, $dUlz9._)(_this, "priority", 40), (0, $dUlz9._)(_this, "incompatibleTokens", "*");
        return _this;
    }
    (0, $9MqXK._)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $21ec949644e5f6b7$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return [
                    (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(date, value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));



var $48Z0s = parcelRequire("48Z0s");

var $5Epmf = parcelRequire("5Epmf");

var $9MqXK = parcelRequire("9MqXK");

var $dUlz9 = parcelRequire("dUlz9");

var $4QAx6 = parcelRequire("4QAx6");



var $14912e966ead8569$export$6d8f69c6906d6368 = /*#__PURE__*/ function(Parser) {
    "use strict";
    (0, $4QAx6._)(TimestampMillisecondsParser, Parser);
    function TimestampMillisecondsParser() {
        (0, $5Epmf._)(this, TimestampMillisecondsParser);
        var _this;
        _this = (0, $48Z0s._)(this, TimestampMillisecondsParser, arguments), (0, $dUlz9._)(_this, "priority", 20), (0, $dUlz9._)(_this, "incompatibleTokens", "*");
        return _this;
    }
    (0, $9MqXK._)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $21ec949644e5f6b7$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return [
                    (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(date, value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $02ae5c9d4a504986$export$7acfa6ed01010e37));


var $f4e4b3c7df5d3be7$export$19131010e7fd8373 = {
    G: new (0, $66e6579145e57055$export$8e5a1d3f85a9688)(),
    y: new (0, $815b7959c0d37932$export$48d352de7cd4a988)(),
    Y: new (0, $82572f43d8dff124$export$b8ef38dfcf05d5db)(),
    R: new (0, $f1e1ca29facfb13b$export$951d1df011fde06f)(),
    u: new (0, $549fee0929ea714f$export$bad9d2ea38e8f1a)(),
    Q: new (0, $016550e7664df4cb$export$5cb0f701186dde1d)(),
    q: new (0, $d9a414d3b69efe6f$export$300c0c2990e20e6d)(),
    M: new (0, $4dd97066172cdf16$export$400dd8b40ef138a3)(),
    L: new (0, $61b19cf05c6afe8f$export$1d7eaa53eaa5deba)(),
    w: new (0, $981a781738bfb92c$export$c4005ffc174e07c0)(),
    I: new (0, $43ef2172cef466d9$export$6fc8dbedd560a6af)(),
    d: new (0, $1c822b32425351e4$export$e8d4b28a20981dd2)(),
    D: new (0, $13df21ea99527aa8$export$6cfe0d613455f615)(),
    E: new (0, $4777daf92e48d361$export$1b03c8b76262f7bd)(),
    e: new (0, $1eeed6b34bcc1b20$export$44d1c127ab42c480)(),
    c: new (0, $2339ed6b0c7eeeaa$export$e447a647caaaec1d)(),
    i: new (0, $18559d9f934d76b3$export$693fb1e525095b2a)(),
    a: new (0, $aa1448aa3ef2ac70$export$8d1e08492351df91)(),
    b: new (0, $ad03e77d1616483d$export$73ca2bd0a17d273)(),
    B: new (0, $9041efa909496b4c$export$bb9212adf05373db)(),
    h: new (0, $ab34847c335f5c18$export$8a04050a727a1756)(),
    H: new (0, $62f4a0153dae9b9b$export$e56f4dea2c3e56dd)(),
    K: new (0, $cb61cc9aaf7a50f3$export$cbbe855312f87d77)(),
    k: new (0, $60b994877b84b5e4$export$6008046d2b34b6a5)(),
    m: new (0, $1cb7915aa3541cdf$export$2b52670d9e2be53)(),
    s: new (0, $6b139af6332e2bc3$export$94d46d540cf1366a)(),
    S: new (0, $179bed799b4f6fee$export$b8e6f8b2d70893b1)(),
    X: new (0, $d7f79705d9542045$export$104d901d49fea29b)(),
    x: new (0, $73329825bb1333e0$export$12910e5204b52b9)(),
    t: new (0, $815db925d3dd337d$export$2cd8bf877a05e96)(),
    T: new (0, $14912e966ead8569$export$6d8f69c6906d6368)()
};


/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $9e9a1e7c81c692b8$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $9e9a1e7c81c692b8$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $9e9a1e7c81c692b8$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $9e9a1e7c81c692b8$var$doubleQuoteRegExp = /''/g;
var $9e9a1e7c81c692b8$var$notWhitespaceRegExp = /\S/;
var $9e9a1e7c81c692b8$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $9e9a1e7c81c692b8$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    var invalidDate = function() {
        return (0, $5dd48bd7eb19f030$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || referenceDate, NaN);
    };
    var defaultOptions = (0, $1d06b0a89bb940e8$export$430a3269e24b912e)();
    var _options_locale2, _ref;
    var locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $6255fd097cef245d$export$137380d9ce54f7f);
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    var firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    var weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(referenceDate, options === null || options === void 0 ? void 0 : options.in);
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    var setters = [
        new (0, $406d80267af27b97$export$8be15fe85ad72f86)(options === null || options === void 0 ? void 0 : options.in, referenceDate)
    ];
    var tokens = formatStr.match($9e9a1e7c81c692b8$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $3b214bb21890e36a$export$70cc8fd02856fd58)) {
            var longFormatter = (0, $3b214bb21890e36a$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($9e9a1e7c81c692b8$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var token = _step.value;
            if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, $dcaf27d1fc3f5789$export$c6b49d6dceb604a1)(token)) (0, $dcaf27d1fc3f5789$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
            if (!(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, $dcaf27d1fc3f5789$export$c6cc36aa33304772)(token)) (0, $dcaf27d1fc3f5789$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
            var firstCharacter = token[0];
            var parser = (0, $f4e4b3c7df5d3be7$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: invalidDate()
                };
                setters.push(parseResult.setter);
                dateStr = parseResult.rest;
            } else {
                if (firstCharacter.match($9e9a1e7c81c692b8$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $9e9a1e7c81c692b8$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
                else return {
                    v: invalidDate()
                };
            }
        };
        for(var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $03bAP._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $9e9a1e7c81c692b8$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(referenceDate, options === null || options === void 0 ? void 0 : options.in);
    if (isNaN(+date)) return invalidDate();
    var flags = {};
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = uniquePrioritySetters[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var setter = _step1.value;
            if (!setter.validate(date, subFnOptions)) return invalidDate();
            var result = setter.set(date, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                date = result[0];
                Object.assign(flags, result[1]);
            // Result is date
            } else date = result;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return date;
}
function $9e9a1e7c81c692b8$var$cleanEscapedString(input) {
    return input.match($9e9a1e7c81c692b8$var$escapedStringRegExp)[1].replace($9e9a1e7c81c692b8$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$9e9a1e7c81c692b8$export$2e2bcd8739ae039 = $9e9a1e7c81c692b8$export$98e6a39c04603d36;




function $63e99f1c8dd3b768$export$4393d2ccbbedb219(argument, options) {
    var invalidDate = function() {
        return (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(options === null || options === void 0 ? void 0 : options.in, NaN);
    };
    var _options_additionalDigits;
    var additionalDigits = (_options_additionalDigits = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options_additionalDigits !== void 0 ? _options_additionalDigits : 2;
    var dateStrings = $63e99f1c8dd3b768$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $63e99f1c8dd3b768$var$parseYear(dateStrings.date, additionalDigits);
        date = $63e99f1c8dd3b768$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(+date)) return invalidDate();
    var timestamp = +date;
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $63e99f1c8dd3b768$var$parseTime(dateStrings.time);
        if (isNaN(time)) return invalidDate();
    }
    if (dateStrings.timezone) {
        offset = $63e99f1c8dd3b768$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return invalidDate();
    } else {
        var tmpDate = new Date(timestamp + time);
        var result = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(0, options === null || options === void 0 ? void 0 : options.in);
        result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
        result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
        return result;
    }
    return (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(timestamp + time + offset, options === null || options === void 0 ? void 0 : options.in);
}
var $63e99f1c8dd3b768$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $63e99f1c8dd3b768$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $63e99f1c8dd3b768$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $63e99f1c8dd3b768$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $63e99f1c8dd3b768$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($63e99f1c8dd3b768$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($63e99f1c8dd3b768$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($63e99f1c8dd3b768$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $63e99f1c8dd3b768$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $63e99f1c8dd3b768$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $63e99f1c8dd3b768$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($63e99f1c8dd3b768$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $63e99f1c8dd3b768$var$parseDateUnit(captures[1]);
    var month = $63e99f1c8dd3b768$var$parseDateUnit(captures[2]) - 1;
    var day = $63e99f1c8dd3b768$var$parseDateUnit(captures[3]);
    var week = $63e99f1c8dd3b768$var$parseDateUnit(captures[4]);
    var dayOfWeek = $63e99f1c8dd3b768$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$63e99f1c8dd3b768$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $63e99f1c8dd3b768$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$63e99f1c8dd3b768$var$validateDate(year, month, day) || !$63e99f1c8dd3b768$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $63e99f1c8dd3b768$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $63e99f1c8dd3b768$var$parseTime(timeString) {
    var captures = timeString.match($63e99f1c8dd3b768$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $63e99f1c8dd3b768$var$parseTimeUnit(captures[1]);
    var minutes = $63e99f1c8dd3b768$var$parseTimeUnit(captures[2]);
    var seconds = $63e99f1c8dd3b768$var$parseTimeUnit(captures[3]);
    if (!$63e99f1c8dd3b768$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $e2377001c88df902$export$7f72910d6dfd237a) + minutes * (0, $e2377001c88df902$export$91246f0b9bd9beff) + seconds * 1000;
}
function $63e99f1c8dd3b768$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $63e99f1c8dd3b768$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($63e99f1c8dd3b768$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$63e99f1c8dd3b768$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $e2377001c88df902$export$7f72910d6dfd237a) + minutes * (0, $e2377001c88df902$export$91246f0b9bd9beff));
}
function $63e99f1c8dd3b768$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $63e99f1c8dd3b768$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $63e99f1c8dd3b768$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $63e99f1c8dd3b768$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($63e99f1c8dd3b768$var$daysInMonths[month] || ($63e99f1c8dd3b768$var$isLeapYearIndex(year) ? 29 : 28));
}
function $63e99f1c8dd3b768$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($63e99f1c8dd3b768$var$isLeapYearIndex(year) ? 366 : 365);
}
function $63e99f1c8dd3b768$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $63e99f1c8dd3b768$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $63e99f1c8dd3b768$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$63e99f1c8dd3b768$export$2e2bcd8739ae039 = $63e99f1c8dd3b768$export$4393d2ccbbedb219;


function $c2fa690605034bd4$export$f86b797a4659b781(date, hours, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setHours(hours);
    return _date;
}
var // Fallback for modularized imports:
$c2fa690605034bd4$export$2e2bcd8739ae039 = $c2fa690605034bd4$export$f86b797a4659b781;


function $6b415c24a65aeb3f$export$ad569bf1c79ea89d(date, minutes, options) {
    var date_ = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    date_.setMinutes(minutes);
    return date_;
}
var // Fallback for modularized imports:
$6b415c24a65aeb3f$export$2e2bcd8739ae039 = $6b415c24a65aeb3f$export$ad569bf1c79ea89d;




function $6688867699f9035c$export$f645ddd439eb259d(date, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var year = _date.getFullYear();
    var monthIndex = _date.getMonth();
    var lastDayOfMonth = (0, $5dd48bd7eb19f030$export$ead8a1812b171991)(_date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}
var // Fallback for modularized imports:
$6688867699f9035c$export$2e2bcd8739ae039 = $6688867699f9035c$export$f645ddd439eb259d;



function $d26b511e86cf447a$export$63264690f8e36790(date, month, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var year = _date.getFullYear();
    var day = _date.getDate();
    var midMonth = (0, $5dd48bd7eb19f030$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    midMonth.setFullYear(year, month, 15);
    midMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $6688867699f9035c$export$f645ddd439eb259d)(midMonth);
    // Set the earlier date, allows to wrap Jan 31 to Feb 28
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}
var // Fallback for modularized imports:
$d26b511e86cf447a$export$2e2bcd8739ae039 = $d26b511e86cf447a$export$63264690f8e36790;



function $777d75a7e7ff73c1$export$8924d1de7efe1755(date, quarter, options) {
    var date_ = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    var oldQuarter = Math.trunc(date_.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, $d26b511e86cf447a$export$63264690f8e36790)(date_, date_.getMonth() + diff * 3);
}
var // Fallback for modularized imports:
$777d75a7e7ff73c1$export$2e2bcd8739ae039 = $777d75a7e7ff73c1$export$8924d1de7efe1755;


function $80943fd5721c49ab$export$aec44746644cbf43(date, seconds, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setSeconds(seconds);
    return _date;
}
var // Fallback for modularized imports:
$80943fd5721c49ab$export$2e2bcd8739ae039 = $80943fd5721c49ab$export$aec44746644cbf43;



function $c9d0036666d361ea$export$a8408b6c5639cab7(date, year, options) {
    var date_ = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+date_)) return (0, $5dd48bd7eb19f030$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, NaN);
    date_.setFullYear(year);
    return date_;
}
var // Fallback for modularized imports:
$c9d0036666d361ea$export$2e2bcd8739ae039 = $c9d0036666d361ea$export$a8408b6c5639cab7;


function $d247a4bca7416de5$export$a5a3b454ada2268e(date, options) {
    var _date = (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$d247a4bca7416de5$export$2e2bcd8739ae039 = $d247a4bca7416de5$export$a5a3b454ada2268e;


function $1d5ee141051d4eef$export$70823084e2deb1ea(date, amount, options) {
    return (0, $2b4ff6e56ae3ad17$export$dd412b56f1e4d8aa)(date, -amount, options);
}
var // Fallback for modularized imports:
$1d5ee141051d4eef$export$2e2bcd8739ae039 = $1d5ee141051d4eef$export$70823084e2deb1ea;


function $62367543e39b34d6$export$73d1c15a21f9fae5(date, amount, options) {
    return (0, $75507be8d602cbce$export$17c93e242b2d3a22)(date, -amount, options);
}
var // Fallback for modularized imports:
$62367543e39b34d6$export$2e2bcd8739ae039 = $62367543e39b34d6$export$73d1c15a21f9fae5;


function $f08d4eb85a22e198$export$a31bfeeeee80cce6(date, amount, options) {
    return (0, $40103932dbf37ea0$export$c252a41d0fbed2ce)(date, -amount, options);
}
var // Fallback for modularized imports:
$f08d4eb85a22e198$export$2e2bcd8739ae039 = $f08d4eb85a22e198$export$a31bfeeeee80cce6;


function $2d52663a687b6327$export$b4d8ae6376193efb(date, amount, options) {
    return (0, $a4bc19e29e9eb67e$export$ef501a2bb4f3ee6b)(date, -amount, options);
}
var // Fallback for modularized imports:
$2d52663a687b6327$export$2e2bcd8739ae039 = $2d52663a687b6327$export$b4d8ae6376193efb;


function $03aa6c2df8a28792$export$14867687ff6c92e2(date, amount, options) {
    return (0, $5c6b1b4dffb22d4b$export$3d83eec43f4ea476)(date, -amount, options);
}
var // Fallback for modularized imports:
$03aa6c2df8a28792$export$2e2bcd8739ae039 = $03aa6c2df8a28792$export$14867687ff6c92e2;



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");

var $03bAP = parcelRequire("03bAP");

var $lFIaz = parcelRequire("lFIaz");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");

var $3SMYb = parcelRequire("3SMYb");

var $lFIaz = parcelRequire("lFIaz");

var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $54Czb = parcelRequire("54Czb");

var $XnYkK = parcelRequire("XnYkK");

var $03bAP = parcelRequire("03bAP");

var $3SMYb = parcelRequire("3SMYb");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var $f756166b2b894b06$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
var $f756166b2b894b06$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
var $f756166b2b894b06$export$803cd8101b6c182b = /*#__PURE__*/ $f756166b2b894b06$export$832b6fa47fa053d2.reduce(function(acc, side) {
    return acc.concat(side, side + "-" + $f756166b2b894b06$export$27b07d8a310ed8b5[0], side + "-" + $f756166b2b894b06$export$27b07d8a310ed8b5[1]);
}, []);
var $f756166b2b894b06$export$96ec731ed4dcb222 = Math.min;
var $f756166b2b894b06$export$8960430cfd85939f = Math.max;
var $f756166b2b894b06$export$2077e0241d6afd3c = Math.round;
var $f756166b2b894b06$export$a3fe094919f356fd = Math.floor;
var $f756166b2b894b06$export$a397704b5e280835 = function(v) {
    return {
        x: v,
        y: v
    };
};
var $f756166b2b894b06$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $f756166b2b894b06$export$7d15b64cf5a3a4c4(start, value, end) {
    return $f756166b2b894b06$export$8960430cfd85939f(start, $f756166b2b894b06$export$96ec731ed4dcb222(value, end));
}
function $f756166b2b894b06$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $f756166b2b894b06$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $f756166b2b894b06$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $f756166b2b894b06$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $f756166b2b894b06$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $f756166b2b894b06$export$f28e8f882010718a(placement) {
    var firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $f756166b2b894b06$export$2b57e0052a6d6d4c(placement) {
    return $f756166b2b894b06$export$8a000a963141ac32($f756166b2b894b06$export$f28e8f882010718a(placement));
}
function $f756166b2b894b06$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    var alignment = $f756166b2b894b06$export$f0989780f32bfcda(placement);
    var alignmentAxis = $f756166b2b894b06$export$2b57e0052a6d6d4c(placement);
    var length = $f756166b2b894b06$export$320bd9d53520c68a(alignmentAxis);
    var mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $f756166b2b894b06$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $f756166b2b894b06$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $f756166b2b894b06$export$496432a3699e50b1(placement) {
    var oppositePlacement = $f756166b2b894b06$export$9c5e28bad23365fa(placement);
    return [
        $f756166b2b894b06$export$2b182c584985588b(placement),
        oppositePlacement,
        $f756166b2b894b06$export$2b182c584985588b(oppositePlacement)
    ];
}
function $f756166b2b894b06$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
var $f756166b2b894b06$var$lrPlacement = [
    'left',
    'right'
];
var $f756166b2b894b06$var$rlPlacement = [
    'right',
    'left'
];
var $f756166b2b894b06$var$tbPlacement = [
    'top',
    'bottom'
];
var $f756166b2b894b06$var$btPlacement = [
    'bottom',
    'top'
];
function $f756166b2b894b06$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $f756166b2b894b06$var$rlPlacement : $f756166b2b894b06$var$lrPlacement;
            return isStart ? $f756166b2b894b06$var$lrPlacement : $f756166b2b894b06$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $f756166b2b894b06$var$tbPlacement : $f756166b2b894b06$var$btPlacement;
        default:
            return [];
    }
}
function $f756166b2b894b06$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    var alignment = $f756166b2b894b06$export$f0989780f32bfcda(placement);
    var list = $f756166b2b894b06$var$getSideList($f756166b2b894b06$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map(function(side) {
            return side + "-" + alignment;
        });
        if (flipAlignment) list = list.concat(list.map($f756166b2b894b06$export$2b182c584985588b));
    }
    return list;
}
function $f756166b2b894b06$export$9c5e28bad23365fa(placement) {
    var side = $f756166b2b894b06$export$3c915306cb7fc97a(placement);
    return $f756166b2b894b06$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $f756166b2b894b06$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $f756166b2b894b06$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $f756166b2b894b06$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $f756166b2b894b06$export$ee05aea0aeecbad4(rect) {
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $ac6c2c02b18c5330$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    var reference = _ref.reference, floating = _ref.floating;
    var sideAxis = (0, $f756166b2b894b06$export$f28e8f882010718a)(placement);
    var alignmentAxis = (0, $f756166b2b894b06$export$2b57e0052a6d6d4c)(placement);
    var alignLength = (0, $f756166b2b894b06$export$320bd9d53520c68a)(alignmentAxis);
    var side = (0, $f756166b2b894b06$export$3c915306cb7fc97a)(placement);
    var isVertical = sideAxis === 'y';
    var commonX = reference.x + reference.width / 2 - floating.width / 2;
    var commonY = reference.y + reference.height / 2 - floating.height / 2;
    var commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    var coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    var alignment = (0, $f756166b2b894b06$export$f0989780f32bfcda)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ function $ac6c2c02b18c5330$export$37b6bde19b108ecc(state, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _await$platform$isEle, x, y, platform, rects, elements, strategy, _evaluate, _evaluate_boundary, boundary, _evaluate_rootBoundary, rootBoundary, _evaluate_elementContext, elementContext, _evaluate_altBoundary, altBoundary, _evaluate_padding, padding, paddingObject, altContext, element, clippingClientRect, _, _tmp, _tmp1, _tmp2, rect, offsetParent, offsetScale, _tmp3, elementClientRect, _tmp4;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options === void 0) options = {};
                    x = state.x, y = state.y, platform = state.platform, rects = state.rects, elements = state.elements, strategy = state.strategy;
                    _evaluate = (0, $f756166b2b894b06$export$fef61f332f2c0afc)(options, state), _evaluate_boundary = _evaluate.boundary, boundary = _evaluate_boundary === void 0 ? 'clippingAncestors' : _evaluate_boundary, _evaluate_rootBoundary = _evaluate.rootBoundary, rootBoundary = _evaluate_rootBoundary === void 0 ? 'viewport' : _evaluate_rootBoundary, _evaluate_elementContext = _evaluate.elementContext, elementContext = _evaluate_elementContext === void 0 ? 'floating' : _evaluate_elementContext, _evaluate_altBoundary = _evaluate.altBoundary, altBoundary = _evaluate_altBoundary === void 0 ? false : _evaluate_altBoundary, _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 0 : _evaluate_padding;
                    paddingObject = (0, $f756166b2b894b06$export$598c291c29bc2e71)(padding);
                    altContext = elementContext === 'floating' ? 'reference' : 'floating';
                    element = elements[altBoundary ? altContext : elementContext];
                    _ = platform.getClippingRect;
                    _tmp = {};
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(element)
                    ];
                case 1:
                    if (!((_await$platform$isEle = _state.sent()) != null ? _await$platform$isEle : true)) return [
                        3,
                        2
                    ];
                    _tmp1 = element;
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp2 = element.contextElement;
                    if (_tmp2) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)
                    ];
                case 3:
                    _tmp2 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp1 = _tmp2;
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _.apply(platform, [
                            (_tmp.element = _tmp1, _tmp.boundary = boundary, _tmp.rootBoundary = rootBoundary, _tmp.strategy = strategy, _tmp)
                        ])
                    ];
                case 6:
                    clippingClientRect = (0, $f756166b2b894b06$export$ee05aea0aeecbad4).apply(void 0, [
                        _state.sent()
                    ]);
                    rect = elementContext === 'floating' ? {
                        x: x,
                        y: y,
                        width: rects.floating.width,
                        height: rects.floating.height
                    } : rects.reference;
                    return [
                        4,
                        platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)
                    ];
                case 7:
                    offsetParent = _state.sent();
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(offsetParent)
                    ];
                case 8:
                    _tmp3 = _state.sent();
                    if (!_tmp3) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        platform.getScale == null ? void 0 : platform.getScale(offsetParent)
                    ];
                case 9:
                    _tmp3 = _state.sent();
                    _state.label = 10;
                case 10:
                    offsetScale = _tmp3 || {
                        x: 1,
                        y: 1
                    };
                    if (!platform.convertOffsetParentRelativeRectToViewportRelativeRect) return [
                        3,
                        12
                    ];
                    return [
                        4,
                        platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                            elements: elements,
                            rect: rect,
                            offsetParent: offsetParent,
                            strategy: strategy
                        })
                    ];
                case 11:
                    _tmp4 = _state.sent();
                    return [
                        3,
                        13
                    ];
                case 12:
                    _tmp4 = rect;
                    _state.label = 13;
                case 13:
                    elementClientRect = (0, $f756166b2b894b06$export$ee05aea0aeecbad4).apply(void 0, [
                        _tmp4
                    ]);
                    return [
                        2,
                        {
                            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
                            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
                            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
                            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
                        }
                    ];
            }
        });
    })();
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
var $ac6c2c02b18c5330$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ var $ac6c2c02b18c5330$export$48a53dcb22e581d0 = function(reference, floating, config) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var _config_placement, placement, _config_strategy, strategy, _config_middleware, middleware, platform, platformWithDetectOverflow, rtl, rects, _computeCoordsFromPlacement, x, y, statefulPlacement, resetCount, middlewareData, i, currentMiddleware, name, fn, _ref, nextX, nextY, data, reset, _tmp, ref;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _config_placement = config.placement, placement = _config_placement === void 0 ? 'bottom' : _config_placement, _config_strategy = config.strategy, strategy = _config_strategy === void 0 ? 'absolute' : _config_strategy, _config_middleware = config.middleware, middleware = _config_middleware === void 0 ? [] : _config_middleware, platform = config.platform;
                    platformWithDetectOverflow = platform.detectOverflow ? platform : (0, $lf4fc._)((0, $hwO3w._)({}, platform), {
                        detectOverflow: $ac6c2c02b18c5330$export$37b6bde19b108ecc
                    });
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 2:
                    rects = _state.sent();
                    _computeCoordsFromPlacement = $ac6c2c02b18c5330$var$computeCoordsFromPlacement(rects, placement, rtl), x = _computeCoordsFromPlacement.x, y = _computeCoordsFromPlacement.y;
                    statefulPlacement = placement;
                    resetCount = 0;
                    middlewareData = {};
                    i = 0;
                    _state.label = 3;
                case 3:
                    if (!(i < middleware.length)) return [
                        3,
                        11
                    ];
                    currentMiddleware = middleware[i];
                    if (!currentMiddleware) return [
                        3,
                        10
                    ];
                    name = currentMiddleware.name, fn = currentMiddleware.fn;
                    return [
                        4,
                        fn({
                            x: x,
                            y: y,
                            initialPlacement: placement,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData,
                            rects: rects,
                            platform: platformWithDetectOverflow,
                            elements: {
                                reference: reference,
                                floating: floating
                            }
                        })
                    ];
                case 4:
                    _ref = _state.sent(), nextX = _ref.x, nextY = _ref.y, data = _ref.data, reset = _ref.reset;
                    x = nextX != null ? nextX : x;
                    y = nextY != null ? nextY : y;
                    middlewareData[name] = (0, $hwO3w._)({}, middlewareData[name], data);
                    if (!(reset && resetCount < $ac6c2c02b18c5330$var$MAX_RESET_COUNT)) return [
                        3,
                        10
                    ];
                    resetCount++;
                    if (!((typeof reset === "undefined" ? "undefined" : (0, $03bAP._)(reset)) === 'object')) return [
                        3,
                        9
                    ];
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (!reset.rects) return [
                        3,
                        8
                    ];
                    if (!(reset.rects === true)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 5:
                    _tmp = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    _tmp = reset.rects;
                    _state.label = 7;
                case 7:
                    rects = _tmp;
                    _state.label = 8;
                case 8:
                    ref = $ac6c2c02b18c5330$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl), x = ref.x, y = ref.y, ref;
                    _state.label = 9;
                case 9:
                    i = -1;
                    _state.label = 10;
                case 10:
                    i++;
                    return [
                        3,
                        3
                    ];
                case 11:
                    return [
                        2,
                        {
                            x: x,
                            y: y,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData
                        }
                    ];
            }
        });
    })();
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var $ac6c2c02b18c5330$export$f2120bbfa5450bd2 = function(options) {
    return {
        name: 'arrow',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var x, y, placement, rects, platform, elements, middlewareData, _ref, element, _ref_padding, padding, paddingObject, coords, axis, length, arrowDimensions, isYAxis, minProp, maxProp, clientProp, endDiff, startDiff, arrowOffsetParent, clientSize, _tmp, centerToReference, largestPossiblePadding, minPadding, maxPadding, max, center, offset, shouldAddOffset, alignmentOffset, _obj, _obj1;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements, middlewareData = state.middlewareData;
                            // Since `element` is required, we don't Partial<> the type.
                            _ref = (0, $f756166b2b894b06$export$fef61f332f2c0afc)(options, state) || {}, element = _ref.element, _ref_padding = _ref.padding, padding = _ref_padding === void 0 ? 0 : _ref_padding;
                            if (element == null) return [
                                2,
                                {}
                            ];
                            paddingObject = (0, $f756166b2b894b06$export$598c291c29bc2e71)(padding);
                            coords = {
                                x: x,
                                y: y
                            };
                            axis = (0, $f756166b2b894b06$export$2b57e0052a6d6d4c)(placement);
                            length = (0, $f756166b2b894b06$export$320bd9d53520c68a)(axis);
                            return [
                                4,
                                platform.getDimensions(element)
                            ];
                        case 1:
                            arrowDimensions = _state.sent();
                            isYAxis = axis === 'y';
                            minProp = isYAxis ? 'top' : 'left';
                            maxProp = isYAxis ? 'bottom' : 'right';
                            clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                            endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                            startDiff = coords[axis] - rects.reference[axis];
                            return [
                                4,
                                platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element)
                            ];
                        case 2:
                            arrowOffsetParent = _state.sent();
                            clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                            _tmp = !clientSize;
                            if (_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)
                            ];
                        case 3:
                            _tmp = !_state.sent();
                            _state.label = 4;
                        case 4:
                            // DOM platform can return `window` as the `offsetParent`.
                            if (_tmp) clientSize = elements.floating[clientProp] || rects.floating[length];
                            centerToReference = endDiff / 2 - startDiff / 2;
                            // If the padding is large enough that it causes the arrow to no longer be
                            // centered, modify the padding so that it is centered.
                            largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                            minPadding = (0, $f756166b2b894b06$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
                            maxPadding = (0, $f756166b2b894b06$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
                            // Make sure the arrow doesn't overflow the floating element if the center
                            // point is outside the floating element's bounds.
                            max = clientSize - arrowDimensions[length] - maxPadding;
                            center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                            offset = (0, $f756166b2b894b06$export$7d15b64cf5a3a4c4)(minPadding, center, max);
                            // If the reference is small enough that the arrow's padding causes it to
                            // to point to nothing for an aligned placement, adjust the offset of the
                            // floating element itself. To ensure `shift()` continues to take action,
                            // a single reset is performed when this is true.
                            shouldAddOffset = !middlewareData.arrow && (0, $f756166b2b894b06$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                            alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
                            return [
                                2,
                                (_obj1 = {}, (0, $dUlz9._)(_obj1, axis, coords[axis] + alignmentOffset), (0, $dUlz9._)(_obj1, "data", (0, $hwO3w._)((_obj = {}, (0, $dUlz9._)(_obj, axis, offset), (0, $dUlz9._)(_obj, "centerOffset", center - offset - alignmentOffset), _obj), shouldAddOffset && {
                                    alignmentOffset: alignmentOffset
                                })), (0, $dUlz9._)(_obj1, "reset", shouldAddOffset), _obj1)
                            ];
                    }
                });
            })();
        }
    };
};
function $ac6c2c02b18c5330$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    var allowedPlacementsSortedByAlignment = alignment ? (0, $XnYkK._)(allowedPlacements.filter(function(placement) {
        return (0, $f756166b2b894b06$export$f0989780f32bfcda)(placement) === alignment;
    })).concat((0, $XnYkK._)(allowedPlacements.filter(function(placement) {
        return (0, $f756166b2b894b06$export$f0989780f32bfcda)(placement) !== alignment;
    }))) : allowedPlacements.filter(function(placement) {
        return (0, $f756166b2b894b06$export$3c915306cb7fc97a)(placement) === placement;
    });
    return allowedPlacementsSortedByAlignment.filter(function(placement) {
        if (alignment) return (0, $f756166b2b894b06$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $f756166b2b894b06$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var $ac6c2c02b18c5330$export$91fb6ecbd551914 = function autoPlacement(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE, rects, middlewareData, placement, platform, elements, _evaluate, _evaluate_crossAxis, crossAxis, alignment, _evaluate_allowedPlacements, allowedPlacements, _evaluate_autoAlignment, autoAlignment, detectOverflowOptions, placements$1, currentIndex, currentPlacement, overflow, alignmentSides, _tmp, currentOverflows, allOverflows, nextPlacement, placementsSortedByMostSpace, placementsThatFitOnEachSide, resetPlacement;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects, middlewareData = state.middlewareData, placement = state.placement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, $f756166b2b894b06$export$fef61f332f2c0afc)(options, state), _evaluate_crossAxis = _evaluate.crossAxis, crossAxis = _evaluate_crossAxis === void 0 ? false : _evaluate_crossAxis, alignment = _evaluate.alignment, _evaluate_allowedPlacements = _evaluate.allowedPlacements, allowedPlacements = _evaluate_allowedPlacements === void 0 ? (0, $f756166b2b894b06$export$803cd8101b6c182b) : _evaluate_allowedPlacements, _evaluate_autoAlignment = _evaluate.autoAlignment, autoAlignment = _evaluate_autoAlignment === void 0 ? true : _evaluate_autoAlignment, detectOverflowOptions = (0, $54Czb._)(_evaluate, [
                                "crossAxis",
                                "alignment",
                                "allowedPlacements",
                                "autoAlignment"
                            ]);
                            placements$1 = alignment !== undefined || allowedPlacements === (0, $f756166b2b894b06$export$803cd8101b6c182b) ? $ac6c2c02b18c5330$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                            currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                            currentPlacement = placements$1[currentIndex];
                            if (currentPlacement == null) return [
                                2,
                                {}
                            ];
                            // Make `computeCoords` start from the right place.
                            if (placement !== currentPlacement) return [
                                2,
                                {
                                    reset: {
                                        placement: placements$1[0]
                                    }
                                }
                            ];
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            _tmp = [
                                currentPlacement,
                                rects
                            ];
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            alignmentSides = (0, $f756166b2b894b06$export$be42861551f17911).apply(void 0, _tmp.concat([
                                _state.sent()
                            ]));
                            currentOverflows = [
                                overflow[(0, $f756166b2b894b06$export$3c915306cb7fc97a)(currentPlacement)],
                                overflow[alignmentSides[0]],
                                overflow[alignmentSides[1]]
                            ];
                            allOverflows = (0, $XnYkK._)(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []).concat([
                                {
                                    placement: currentPlacement,
                                    overflows: currentOverflows
                                }
                            ]);
                            nextPlacement = placements$1[currentIndex + 1];
                            // There are more placements to check.
                            if (nextPlacement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: nextPlacement
                                    }
                                }
                            ];
                            placementsSortedByMostSpace = allOverflows.map(function(d) {
                                var alignment = (0, $f756166b2b894b06$export$f0989780f32bfcda)(d.placement);
                                return [
                                    d.placement,
                                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                                    d.overflows.slice(0, 2).reduce(function(acc, v) {
                                        return acc + v;
                                    }, 0) : // Check only the mainAxis.
                                    d.overflows[0],
                                    d.overflows
                                ];
                            }).sort(function(a, b) {
                                return a[1] - b[1];
                            });
                            placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(function(d) {
                                return d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                                // side.
                                (0, $f756166b2b894b06$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every(function(v) {
                                    return v <= 0;
                                });
                            });
                            resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                            if (resetPlacement !== placement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: resetPlacement
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var $ac6c2c02b18c5330$export$8a83211c878a3f1f = function flip(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var _fallbackPlacements, _middlewareData$arrow, _middlewareData$flip, placement, middlewareData, rects, initialPlacement, platform, elements, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, specifiedFallbackPlacements, _evaluate_fallbackStrategy, fallbackStrategy, _evaluate_fallbackAxisSideDirection, fallbackAxisSideDirection, _evaluate_flipAlignment, flipAlignment, detectOverflowOptions, side, initialSideAxis, isBasePlacement, rtl, fallbackPlacements, hasFallbackAxisSideDirection, placements, overflow, overflows, overflowsData, sides, _middlewareData$flip2, _overflowsData$filter, nextIndex, nextPlacement, ignoreCrossAxisOverflow, resetPlacement, _overflowsData$filter2, placement1;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, middlewareData = state.middlewareData, rects = state.rects, initialPlacement = state.initialPlacement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, $f756166b2b894b06$export$fef61f332f2c0afc)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1, specifiedFallbackPlacements = _evaluate.fallbackPlacements, _evaluate_fallbackStrategy = _evaluate.fallbackStrategy, fallbackStrategy = _evaluate_fallbackStrategy === void 0 ? 'bestFit' : _evaluate_fallbackStrategy, _evaluate_fallbackAxisSideDirection = _evaluate.fallbackAxisSideDirection, fallbackAxisSideDirection = _evaluate_fallbackAxisSideDirection === void 0 ? 'none' : _evaluate_fallbackAxisSideDirection, _evaluate_flipAlignment = _evaluate.flipAlignment, flipAlignment = _evaluate_flipAlignment === void 0 ? true : _evaluate_flipAlignment, detectOverflowOptions = (0, $54Czb._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "fallbackPlacements",
                                "fallbackStrategy",
                                "fallbackAxisSideDirection",
                                "flipAlignment"
                            ]);
                            // If a reset by the arrow was caused due to an alignment offset being
                            // added, we should skip any logic now since `flip()` has already done its
                            // work.
                            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
                            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            side = (0, $f756166b2b894b06$export$3c915306cb7fc97a)(placement);
                            initialSideAxis = (0, $f756166b2b894b06$export$f28e8f882010718a)(initialPlacement);
                            isBasePlacement = (0, $f756166b2b894b06$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 1:
                            rtl = _state.sent();
                            fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                                (0, $f756166b2b894b06$export$9c5e28bad23365fa)(initialPlacement)
                            ] : (0, $f756166b2b894b06$export$496432a3699e50b1)(initialPlacement));
                            hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) (_fallbackPlacements = fallbackPlacements).push.apply(_fallbackPlacements, (0, $XnYkK._)((0, $f756166b2b894b06$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl)));
                            placements = [
                                initialPlacement
                            ].concat((0, $XnYkK._)(fallbackPlacements));
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 2:
                            overflow = _state.sent();
                            overflows = [];
                            overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                            if (checkMainAxis) overflows.push(overflow[side]);
                            if (checkCrossAxis) {
                                sides = (0, $f756166b2b894b06$export$be42861551f17911)(placement, rects, rtl);
                                overflows.push(overflow[sides[0]], overflow[sides[1]]);
                            }
                            overflowsData = (0, $XnYkK._)(overflowsData).concat([
                                {
                                    placement: placement,
                                    overflows: overflows
                                }
                            ]);
                            // One or more sides is overflowing.
                            if (!overflows.every(function(side) {
                                return side <= 0;
                            })) {
                                ;
                                nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                                nextPlacement = placements[nextIndex];
                                if (nextPlacement) {
                                    ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $f756166b2b894b06$export$f28e8f882010718a)(nextPlacement) : false;
                                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                                    // overflows the main axis.
                                    overflowsData.every(function(d) {
                                        return (0, $f756166b2b894b06$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true;
                                    })) // Try next placement and re-run the lifecycle.
                                    return [
                                        2,
                                        {
                                            data: {
                                                index: nextIndex,
                                                overflows: overflowsData
                                            },
                                            reset: {
                                                placement: nextPlacement
                                            }
                                        }
                                    ];
                                }
                                // First, find the candidates that fit on the mainAxis side of overflow,
                                // then find the placement that fits the best on the main crossAxis side.
                                resetPlacement = (_overflowsData$filter = overflowsData.filter(function(d) {
                                    return d.overflows[0] <= 0;
                                }).sort(function(a, b) {
                                    return a.overflows[1] - b.overflows[1];
                                })[0]) == null ? void 0 : _overflowsData$filter.placement;
                                // Otherwise fallback.
                                if (!resetPlacement) switch(fallbackStrategy){
                                    case 'bestFit':
                                        {
                                            ;
                                            placement1 = (_overflowsData$filter2 = overflowsData.filter(function(d) {
                                                if (hasFallbackAxisSideDirection) {
                                                    var currentSideAxis = (0, $f756166b2b894b06$export$f28e8f882010718a)(d.placement);
                                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                                    // reading directions favoring greater width.
                                                    currentSideAxis === 'y';
                                                }
                                                return true;
                                            }).map(function(d) {
                                                return [
                                                    d.placement,
                                                    d.overflows.filter(function(overflow) {
                                                        return overflow > 0;
                                                    }).reduce(function(acc, overflow) {
                                                        return acc + overflow;
                                                    }, 0)
                                                ];
                                            }).sort(function(a, b) {
                                                return a[1] - b[1];
                                            })[0]) == null ? void 0 : _overflowsData$filter2[0];
                                            if (placement1) resetPlacement = placement1;
                                            break;
                                        }
                                    case 'initialPlacement':
                                        resetPlacement = initialPlacement;
                                        break;
                                }
                                if (placement !== resetPlacement) return [
                                    2,
                                    {
                                        reset: {
                                            placement: resetPlacement
                                        }
                                    }
                                ];
                            }
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function $ac6c2c02b18c5330$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $ac6c2c02b18c5330$var$isAnySideFullyClipped(overflow) {
    return (0, $f756166b2b894b06$export$832b6fa47fa053d2).some(function(side) {
        return overflow[side] >= 0;
    });
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var $ac6c2c02b18c5330$export$fe8985bb6374093c = function hide(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var rects, platform, _evaluate, _evaluate_strategy, strategy, detectOverflowOptions, overflow, offsets, overflow1, offsets1;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects, platform = state.platform;
                            _evaluate = (0, $f756166b2b894b06$export$fef61f332f2c0afc)(options, state), _evaluate_strategy = _evaluate.strategy, strategy = _evaluate_strategy === void 0 ? 'referenceHidden' : _evaluate_strategy, detectOverflowOptions = (0, $54Czb._)(_evaluate, [
                                "strategy"
                            ]);
                            switch(strategy){
                                case 'referenceHidden':
                                    return [
                                        3,
                                        1
                                    ];
                                case 'escaped':
                                    return [
                                        3,
                                        3
                                    ];
                            }
                            return [
                                3,
                                5
                            ];
                        case 1:
                            return [
                                4,
                                platform.detectOverflow(state, (0, $lf4fc._)((0, $hwO3w._)({}, detectOverflowOptions), {
                                    elementContext: 'reference'
                                }))
                            ];
                        case 2:
                            overflow = _state.sent();
                            offsets = $ac6c2c02b18c5330$var$getSideOffsets(overflow, rects.reference);
                            return [
                                2,
                                {
                                    data: {
                                        referenceHiddenOffsets: offsets,
                                        referenceHidden: $ac6c2c02b18c5330$var$isAnySideFullyClipped(offsets)
                                    }
                                }
                            ];
                        case 3:
                            return [
                                4,
                                platform.detectOverflow(state, (0, $lf4fc._)((0, $hwO3w._)({}, detectOverflowOptions), {
                                    altBoundary: true
                                }))
                            ];
                        case 4:
                            overflow1 = _state.sent();
                            offsets1 = $ac6c2c02b18c5330$var$getSideOffsets(overflow1, rects.floating);
                            return [
                                2,
                                {
                                    data: {
                                        escapedOffsets: offsets1,
                                        escaped: $ac6c2c02b18c5330$var$isAnySideFullyClipped(offsets1)
                                    }
                                }
                            ];
                        case 5:
                            return [
                                2,
                                {}
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
};
function $ac6c2c02b18c5330$var$getBoundingRect(rects) {
    var minX = (0, $f756166b2b894b06$export$96ec731ed4dcb222).apply(void 0, (0, $XnYkK._)(rects.map(function(rect) {
        return rect.left;
    })));
    var minY = (0, $f756166b2b894b06$export$96ec731ed4dcb222).apply(void 0, (0, $XnYkK._)(rects.map(function(rect) {
        return rect.top;
    })));
    var maxX = (0, $f756166b2b894b06$export$8960430cfd85939f).apply(void 0, (0, $XnYkK._)(rects.map(function(rect) {
        return rect.right;
    })));
    var maxY = (0, $f756166b2b894b06$export$8960430cfd85939f).apply(void 0, (0, $XnYkK._)(rects.map(function(rect) {
        return rect.bottom;
    })));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $ac6c2c02b18c5330$var$getRectsByLine(rects) {
    var sortedRects = rects.slice().sort(function(a, b) {
        return a.y - b.y;
    });
    var groups = [];
    var prevRect = null;
    for(var i = 0; i < sortedRects.length; i++){
        var rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map(function(rect) {
        return (0, $f756166b2b894b06$export$ee05aea0aeecbad4)($ac6c2c02b18c5330$var$getBoundingRect(rect));
    });
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var $ac6c2c02b18c5330$export$18c8ad048e32c7d5 = function inline(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var placement, elements, rects, platform, strategy, _evaluate, _evaluate_padding, padding, x, y, nativeClientRects, _, clientRects, fallback, paddingObject, resetRects;
                function getBoundingClientRect() {
                    // There are two rects and they are disjoined.
                    if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                    return clientRects.find(function(rect) {
                        return x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom;
                    }) || fallback;
                    // There are 2 or more connected rects.
                    if (clientRects.length >= 2) {
                        if ((0, $f756166b2b894b06$export$f28e8f882010718a)(placement) === 'y') {
                            var firstRect = clientRects[0];
                            var lastRect = clientRects[clientRects.length - 1];
                            var isTop = (0, $f756166b2b894b06$export$3c915306cb7fc97a)(placement) === 'top';
                            var top = firstRect.top;
                            var bottom = lastRect.bottom;
                            var left = isTop ? firstRect.left : lastRect.left;
                            var right = isTop ? firstRect.right : lastRect.right;
                            return (0, $f756166b2b894b06$export$ee05aea0aeecbad4)({
                                x: left,
                                y: top,
                                width: right - left,
                                height: bottom - top
                            });
                        }
                        var isLeftSide = (0, $f756166b2b894b06$export$3c915306cb7fc97a)(placement) === 'left';
                        var maxRight = (0, $f756166b2b894b06$export$8960430cfd85939f).apply(void 0, (0, $XnYkK._)(clientRects.map(function(rect) {
                            return rect.right;
                        })));
                        var minLeft = (0, $f756166b2b894b06$export$96ec731ed4dcb222).apply(void 0, (0, $XnYkK._)(clientRects.map(function(rect) {
                            return rect.left;
                        })));
                        var measureRects = clientRects.filter(function(rect) {
                            return isLeftSide ? rect.left === minLeft : rect.right === maxRight;
                        });
                        var top1 = measureRects[0].top;
                        var bottom1 = measureRects[measureRects.length - 1].bottom;
                        return (0, $f756166b2b894b06$export$ee05aea0aeecbad4)({
                            x: minLeft,
                            y: top1,
                            width: maxRight - minLeft,
                            height: bottom1 - top1
                        });
                    }
                    return fallback;
                }
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, elements = state.elements, rects = state.rects, platform = state.platform, strategy = state.strategy;
                            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
                            // ClientRect's bounds, despite the event listener being triggered. A
                            // padding of 2 seems to handle this issue.
                            _evaluate = (0, $f756166b2b894b06$export$fef61f332f2c0afc)(options, state), _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 2 : _evaluate_padding, x = _evaluate.x, y = _evaluate.y;
                            _ = Array.from;
                            return [
                                4,
                                platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)
                            ];
                        case 1:
                            nativeClientRects = _.apply(Array, [
                                _state.sent() || []
                            ]);
                            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
                            // keep the existing reference rect rather than resetting to an invalid
                            // one with non-finite values.
                            if (!nativeClientRects.length) return [
                                2,
                                {}
                            ];
                            clientRects = $ac6c2c02b18c5330$var$getRectsByLine(nativeClientRects);
                            fallback = (0, $f756166b2b894b06$export$ee05aea0aeecbad4)($ac6c2c02b18c5330$var$getBoundingRect(nativeClientRects));
                            paddingObject = (0, $f756166b2b894b06$export$598c291c29bc2e71)(padding);
                            return [
                                4,
                                platform.getElementRects({
                                    reference: {
                                        getBoundingClientRect: getBoundingClientRect
                                    },
                                    floating: elements.floating,
                                    strategy: strategy
                                })
                            ];
                        case 2:
                            resetRects = _state.sent();
                            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return [
                                2,
                                {
                                    reset: {
                                        rects: resetRects
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
var $ac6c2c02b18c5330$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
function $ac6c2c02b18c5330$var$convertValueToCoords(state, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var placement, platform, elements, rtl, side, alignment, isVertical, mainAxisMulti, crossAxisMulti, rawValue, _ref, mainAxis, crossAxis, alignmentAxis;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    placement = state.placement, platform = state.platform, elements = state.elements;
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    side = (0, $f756166b2b894b06$export$3c915306cb7fc97a)(placement);
                    alignment = (0, $f756166b2b894b06$export$f0989780f32bfcda)(placement);
                    isVertical = (0, $f756166b2b894b06$export$f28e8f882010718a)(placement) === 'y';
                    mainAxisMulti = $ac6c2c02b18c5330$var$originSides.has(side) ? -1 : 1;
                    crossAxisMulti = rtl && isVertical ? -1 : 1;
                    rawValue = (0, $f756166b2b894b06$export$fef61f332f2c0afc)(options, state);
                    // eslint-disable-next-line prefer-const
                    _ref = typeof rawValue === 'number' ? {
                        mainAxis: rawValue,
                        crossAxis: 0,
                        alignmentAxis: null
                    } : {
                        mainAxis: rawValue.mainAxis || 0,
                        crossAxis: rawValue.crossAxis || 0,
                        alignmentAxis: rawValue.alignmentAxis
                    }, mainAxis = _ref.mainAxis, crossAxis = _ref.crossAxis, alignmentAxis = _ref.alignmentAxis;
                    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
                    return [
                        2,
                        isVertical ? {
                            x: crossAxis * crossAxisMulti,
                            y: mainAxis * mainAxisMulti
                        } : {
                            x: mainAxis * mainAxisMulti,
                            y: crossAxis * crossAxisMulti
                        }
                    ];
            }
        });
    })();
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var $ac6c2c02b18c5330$export$cc800923e997bb8 = function offset(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var _middlewareData$offse, _middlewareData$arrow, x, y, placement, middlewareData, diffCoords;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, middlewareData = state.middlewareData;
                            return [
                                4,
                                $ac6c2c02b18c5330$var$convertValueToCoords(state, options)
                            ];
                        case 1:
                            diffCoords = _state.sent();
                            // If the placement is the same and the arrow caused an alignment offset
                            // then we don't need to change the positioning coordinates.
                            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            return [
                                2,
                                {
                                    x: x + diffCoords.x,
                                    y: y + diffCoords.y,
                                    data: (0, $lf4fc._)((0, $hwO3w._)({}, diffCoords), {
                                        placement: placement
                                    })
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var $ac6c2c02b18c5330$export$fba63a578e423eb = function shift(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var x, y, placement, platform, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, _evaluate_limiter, limiter, detectOverflowOptions, coords, overflow, crossAxis, mainAxis, mainAxisCoord, crossAxisCoord, clampCoord, _obj, limitedCoords, _obj1;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, platform = state.platform;
                            _evaluate = (0, $f756166b2b894b06$export$fef61f332f2c0afc)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? false : tmp1, _evaluate_limiter = _evaluate.limiter, limiter = _evaluate_limiter === void 0 ? {
                                fn: function(_ref) {
                                    var x = _ref.x, y = _ref.y;
                                    return {
                                        x: x,
                                        y: y
                                    };
                                }
                            } : _evaluate_limiter, detectOverflowOptions = (0, $54Czb._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "limiter"
                            ]);
                            coords = {
                                x: x,
                                y: y
                            };
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            crossAxis = (0, $f756166b2b894b06$export$f28e8f882010718a)(placement);
                            mainAxis = (0, $f756166b2b894b06$export$8a000a963141ac32)(crossAxis);
                            mainAxisCoord = coords[mainAxis];
                            crossAxisCoord = coords[crossAxis];
                            clampCoord = function(axis, coord) {
                                return (0, $f756166b2b894b06$export$7d15b64cf5a3a4c4)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
                            };
                            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
                            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
                            limitedCoords = limiter.fn((0, $lf4fc._)((0, $hwO3w._)({}, state), (_obj = {}, (0, $dUlz9._)(_obj, mainAxis, mainAxisCoord), (0, $dUlz9._)(_obj, crossAxis, crossAxisCoord), _obj)));
                            return [
                                2,
                                (0, $lf4fc._)((0, $hwO3w._)({}, limitedCoords), {
                                    data: {
                                        x: limitedCoords.x - x,
                                        y: limitedCoords.y - y,
                                        enabled: (_obj1 = {}, (0, $dUlz9._)(_obj1, mainAxis, checkMainAxis), (0, $dUlz9._)(_obj1, crossAxis, checkCrossAxis), _obj1)
                                    }
                                })
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var $ac6c2c02b18c5330$export$7bf07e38f3dc4b69 = function limitShift(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn: function(state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            var x = state.x, y = state.y, placement = state.placement, rects = state.rects, middlewareData = state.middlewareData;
            var _evaluate = (0, $f756166b2b894b06$export$fef61f332f2c0afc)(options, state), _evaluate_offset = _evaluate.offset, offset = _evaluate_offset === void 0 ? 0 : _evaluate_offset, tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1;
            var coords = {
                x: x,
                y: y
            };
            var crossAxis = (0, $f756166b2b894b06$export$f28e8f882010718a)(placement);
            var mainAxis = (0, $f756166b2b894b06$export$8a000a963141ac32)(crossAxis);
            var mainAxisCoord = coords[mainAxis];
            var crossAxisCoord = coords[crossAxis];
            var rawOffset = (0, $f756166b2b894b06$export$fef61f332f2c0afc)(offset, state);
            var computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                var len = mainAxis === 'y' ? 'height' : 'width';
                var limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                var limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                var len1 = mainAxis === 'y' ? 'width' : 'height';
                var isOriginSide = $ac6c2c02b18c5330$var$originSides.has((0, $f756166b2b894b06$export$3c915306cb7fc97a)(placement));
                var limitMin1 = rects.reference[crossAxis] - rects.floating[len1] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                var limitMax1 = rects.reference[crossAxis] + rects.reference[len1] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin1) crossAxisCoord = limitMin1;
                else if (crossAxisCoord > limitMax1) crossAxisCoord = limitMax1;
            }
            var _obj;
            return _obj = {}, (0, $dUlz9._)(_obj, mainAxis, mainAxisCoord), (0, $dUlz9._)(_obj, crossAxis, crossAxisCoord), _obj;
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var $ac6c2c02b18c5330$export$346677f925de839c = function size(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var placement, rects, platform, elements, _evaluate, _evaluate_apply, apply, detectOverflowOptions, overflow, side, alignment, isYAxis, _rects_floating, width, height, heightSide, widthSide, maximumClippingHeight, maximumClippingWidth, overflowAvailableHeight, overflowAvailableWidth, shiftData, noShift, availableHeight, availableWidth, nextDimensions;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements;
                            _evaluate = (0, $f756166b2b894b06$export$fef61f332f2c0afc)(options, state), _evaluate_apply = _evaluate.apply, apply = _evaluate_apply === void 0 ? function() {} : _evaluate_apply, detectOverflowOptions = (0, $54Czb._)(_evaluate, [
                                "apply"
                            ]);
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            side = (0, $f756166b2b894b06$export$3c915306cb7fc97a)(placement);
                            alignment = (0, $f756166b2b894b06$export$f0989780f32bfcda)(placement);
                            isYAxis = (0, $f756166b2b894b06$export$f28e8f882010718a)(placement) === 'y';
                            _rects_floating = rects.floating, width = _rects_floating.width, height = _rects_floating.height;
                            if (!(side === 'top' || side === 'bottom')) return [
                                3,
                                3
                            ];
                            heightSide = side;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            widthSide = alignment === (_state.sent() ? 'start' : 'end') ? 'left' : 'right';
                            return [
                                3,
                                4
                            ];
                        case 3:
                            widthSide = side;
                            heightSide = alignment === 'end' ? 'top' : 'bottom';
                            _state.label = 4;
                        case 4:
                            maximumClippingHeight = height - overflow.top - overflow.bottom;
                            maximumClippingWidth = width - overflow.left - overflow.right;
                            overflowAvailableHeight = (0, $f756166b2b894b06$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
                            overflowAvailableWidth = (0, $f756166b2b894b06$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
                            shiftData = state.middlewareData.shift;
                            noShift = !shiftData;
                            availableHeight = overflowAvailableHeight;
                            availableWidth = overflowAvailableWidth;
                            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
                            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
                            if (noShift && !alignment) {
                                if (isYAxis) availableWidth = width - 2 * (0, $f756166b2b894b06$export$8960430cfd85939f)(overflow.left, overflow.right);
                                else availableHeight = height - 2 * (0, $f756166b2b894b06$export$8960430cfd85939f)(overflow.top, overflow.bottom);
                            }
                            return [
                                4,
                                apply((0, $lf4fc._)((0, $hwO3w._)({}, state), {
                                    availableWidth: availableWidth,
                                    availableHeight: availableHeight
                                }))
                            ];
                        case 5:
                            _state.sent();
                            return [
                                4,
                                platform.getDimensions(elements.floating)
                            ];
                        case 6:
                            nextDimensions = _state.sent();
                            if (width !== nextDimensions.width || height !== nextDimensions.height) return [
                                2,
                                {
                                    reset: {
                                        rects: true
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};



function $2a4197d9582b0915$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $2a4197d9582b0915$export$651544f548703224(node) {
    if ($2a4197d9582b0915$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $2a4197d9582b0915$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $2a4197d9582b0915$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($2a4197d9582b0915$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $2a4197d9582b0915$export$8ee0fc9ee280b4ee(value) {
    if (!$2a4197d9582b0915$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $2a4197d9582b0915$export$38b2d434cce3ea22(value).Node;
}
function $2a4197d9582b0915$export$45a5e7f76e0caa8d(value) {
    if (!$2a4197d9582b0915$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $2a4197d9582b0915$export$38b2d434cce3ea22(value).Element;
}
function $2a4197d9582b0915$export$1b3bfaa9684536aa(value) {
    if (!$2a4197d9582b0915$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $2a4197d9582b0915$export$38b2d434cce3ea22(value).HTMLElement;
}
function $2a4197d9582b0915$export$af51f0f06c0f328a(value) {
    if (!$2a4197d9582b0915$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $2a4197d9582b0915$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $2a4197d9582b0915$export$989e911fa9af580a(element) {
    var _getComputedStyle = $2a4197d9582b0915$export$3735103072e4a80(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY, display = _getComputedStyle.display;
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $2a4197d9582b0915$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($2a4197d9582b0915$export$651544f548703224(element));
}
function $2a4197d9582b0915$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
var $2a4197d9582b0915$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
var $2a4197d9582b0915$var$containRe = /paint|layout|strict|content/;
var $2a4197d9582b0915$var$isNotNone = function(value) {
    return !!value && value !== 'none';
};
var $2a4197d9582b0915$var$isWebKitValue;
function $2a4197d9582b0915$export$d6c4e8150c35fed1(elementOrCss) {
    var css = $2a4197d9582b0915$export$45a5e7f76e0caa8d(elementOrCss) ? $2a4197d9582b0915$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $2a4197d9582b0915$var$isNotNone(css.transform) || $2a4197d9582b0915$var$isNotNone(css.translate) || $2a4197d9582b0915$var$isNotNone(css.scale) || $2a4197d9582b0915$var$isNotNone(css.rotate) || $2a4197d9582b0915$var$isNotNone(css.perspective) || !$2a4197d9582b0915$export$78551043582a6a98() && ($2a4197d9582b0915$var$isNotNone(css.backdropFilter) || $2a4197d9582b0915$var$isNotNone(css.filter)) || $2a4197d9582b0915$var$willChangeRe.test(css.willChange || '') || $2a4197d9582b0915$var$containRe.test(css.contain || '');
}
function $2a4197d9582b0915$export$940d8225183e1404(element) {
    var currentNode = $2a4197d9582b0915$export$4e12058fc4d51d56(element);
    while($2a4197d9582b0915$export$1b3bfaa9684536aa(currentNode) && !$2a4197d9582b0915$export$d1162fb0b6d4cd51(currentNode)){
        if ($2a4197d9582b0915$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($2a4197d9582b0915$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $2a4197d9582b0915$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $2a4197d9582b0915$export$78551043582a6a98() {
    if ($2a4197d9582b0915$var$isWebKitValue == null) $2a4197d9582b0915$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $2a4197d9582b0915$var$isWebKitValue;
}
function $2a4197d9582b0915$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($2a4197d9582b0915$export$651544f548703224(node));
}
function $2a4197d9582b0915$export$3735103072e4a80(element) {
    return $2a4197d9582b0915$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $2a4197d9582b0915$export$dc8fc79fa2800137(element) {
    if ($2a4197d9582b0915$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $2a4197d9582b0915$export$4e12058fc4d51d56(node) {
    if ($2a4197d9582b0915$export$651544f548703224(node) === 'html') return node;
    var result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $2a4197d9582b0915$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $2a4197d9582b0915$export$e495491855dc5418(node);
    return $2a4197d9582b0915$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $2a4197d9582b0915$export$7cd01a57c8ca906c(node) {
    var parentNode = $2a4197d9582b0915$export$4e12058fc4d51d56(node);
    if ($2a4197d9582b0915$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($2a4197d9582b0915$export$1b3bfaa9684536aa(parentNode) && $2a4197d9582b0915$export$989e911fa9af580a(parentNode)) return parentNode;
    return $2a4197d9582b0915$export$7cd01a57c8ca906c(parentNode);
}
function $2a4197d9582b0915$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    var scrollableAncestor = $2a4197d9582b0915$export$7cd01a57c8ca906c(node);
    var isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    var win = $2a4197d9582b0915$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        var frameElement = $2a4197d9582b0915$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $2a4197d9582b0915$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $2a4197d9582b0915$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $2a4197d9582b0915$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $2a4197d9582b0915$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $c1d497a3e5aa805c$var$getCssDimensions(element) {
    var css = (0, $2a4197d9582b0915$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    var width = parseFloat(css.width) || 0;
    var height = parseFloat(css.height) || 0;
    var hasOffset = (0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(element);
    var offsetWidth = hasOffset ? element.offsetWidth : width;
    var offsetHeight = hasOffset ? element.offsetHeight : height;
    var shouldFallback = (0, $f756166b2b894b06$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $f756166b2b894b06$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $c1d497a3e5aa805c$var$unwrapElement(element) {
    return !(0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $c1d497a3e5aa805c$var$getScale(element) {
    var domElement = $c1d497a3e5aa805c$var$unwrapElement(element);
    if (!(0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(domElement)) return (0, $f756166b2b894b06$export$a397704b5e280835)(1);
    var rect = domElement.getBoundingClientRect();
    var _getCssDimensions = $c1d497a3e5aa805c$var$getCssDimensions(domElement), width = _getCssDimensions.width, height = _getCssDimensions.height, $ = _getCssDimensions.$;
    var x = ($ ? (0, $f756166b2b894b06$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    var y = ($ ? (0, $f756166b2b894b06$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
var $c1d497a3e5aa805c$var$noOffsets = /*#__PURE__*/ (0, $f756166b2b894b06$export$a397704b5e280835)(0);
function $c1d497a3e5aa805c$var$getVisualOffsets(element) {
    var win = (0, $2a4197d9582b0915$export$38b2d434cce3ea22)(element);
    if (!(0, $2a4197d9582b0915$export$78551043582a6a98)() || !win.visualViewport) return $c1d497a3e5aa805c$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $c1d497a3e5aa805c$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $2a4197d9582b0915$export$38b2d434cce3ea22)(element);
}
function $c1d497a3e5aa805c$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var domElement = $c1d497a3e5aa805c$var$unwrapElement(element);
    var scale = (0, $f756166b2b894b06$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(offsetParent)) scale = $c1d497a3e5aa805c$var$getScale(offsetParent);
        } else scale = $c1d497a3e5aa805c$var$getScale(element);
    }
    var visualOffsets = $c1d497a3e5aa805c$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $c1d497a3e5aa805c$var$getVisualOffsets(domElement) : (0, $f756166b2b894b06$export$a397704b5e280835)(0);
    var x = (clientRect.left + visualOffsets.x) / scale.x;
    var y = (clientRect.top + visualOffsets.y) / scale.y;
    var width = clientRect.width / scale.x;
    var height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        var win = (0, $2a4197d9582b0915$export$38b2d434cce3ea22)(domElement);
        var offsetWin = (0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $2a4197d9582b0915$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        var currentWin = win;
        var currentIFrame = (0, $2a4197d9582b0915$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            var iframeScale = $c1d497a3e5aa805c$var$getScale(currentIFrame);
            var iframeRect = currentIFrame.getBoundingClientRect();
            var css = (0, $2a4197d9582b0915$export$3735103072e4a80)(currentIFrame);
            var left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            var top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $2a4197d9582b0915$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $2a4197d9582b0915$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $f756166b2b894b06$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $c1d497a3e5aa805c$var$getWindowScrollBarX(element, rect) {
    var leftScroll = (0, $2a4197d9582b0915$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $c1d497a3e5aa805c$var$getBoundingClientRect((0, $2a4197d9582b0915$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $c1d497a3e5aa805c$var$getHTMLOffset(documentElement, scroll) {
    var htmlRect = documentElement.getBoundingClientRect();
    var x = htmlRect.left + scroll.scrollLeft - $c1d497a3e5aa805c$var$getWindowScrollBarX(documentElement, htmlRect);
    var y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $c1d497a3e5aa805c$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    var elements = _ref.elements, rect = _ref.rect, offsetParent = _ref.offsetParent, strategy = _ref.strategy;
    var isFixed = strategy === 'fixed';
    var documentElement = (0, $2a4197d9582b0915$export$e495491855dc5418)(offsetParent);
    var topLayer = elements ? (0, $2a4197d9582b0915$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var scale = (0, $f756166b2b894b06$export$a397704b5e280835)(1);
    var offsets = (0, $f756166b2b894b06$export$a397704b5e280835)(0);
    var isOffsetParentAnElement = (0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $2a4197d9582b0915$export$651544f548703224)(offsetParent) !== 'body' || (0, $2a4197d9582b0915$export$989e911fa9af580a)(documentElement)) scroll = (0, $2a4197d9582b0915$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            var offsetRect = $c1d497a3e5aa805c$var$getBoundingClientRect(offsetParent);
            scale = $c1d497a3e5aa805c$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    var htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $c1d497a3e5aa805c$var$getHTMLOffset(documentElement, scroll) : (0, $f756166b2b894b06$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $c1d497a3e5aa805c$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $c1d497a3e5aa805c$var$getDocumentRect(html) {
    var scroll = (0, $2a4197d9582b0915$export$dc8fc79fa2800137)(html);
    var body = html.ownerDocument.body;
    var width = (0, $f756166b2b894b06$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    var height = (0, $f756166b2b894b06$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    var x = -scroll.scrollLeft + $c1d497a3e5aa805c$var$getWindowScrollBarX(html);
    var y = -scroll.scrollTop;
    if ((0, $2a4197d9582b0915$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $f756166b2b894b06$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
var $c1d497a3e5aa805c$var$SCROLLBAR_MAX = 25;
function $c1d497a3e5aa805c$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    var isLayoutViewport = rootBoundary === 'layoutViewport';
    var win = (0, $2a4197d9582b0915$export$38b2d434cce3ea22)(element);
    var html = (0, $2a4197d9582b0915$export$e495491855dc5418)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        var layoutRelativeClientCoords = !(0, $2a4197d9582b0915$export$78551043582a6a98)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    var windowScrollbarX = $c1d497a3e5aa805c$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        var doc = html.ownerDocument;
        var body = doc.body;
        var bodyStyles = getComputedStyle(body);
        var bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        var reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        var gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $c1d497a3e5aa805c$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $c1d497a3e5aa805c$var$getInnerBoundingClientRect(element, strategy) {
    var clientRect = $c1d497a3e5aa805c$var$getBoundingClientRect(element, true, strategy === 'fixed');
    var top = clientRect.top + element.clientTop;
    var left = clientRect.left + element.clientLeft;
    var scale = $c1d497a3e5aa805c$var$getScale(element);
    var width = element.clientWidth * scale.x;
    var height = element.clientHeight * scale.y;
    var x = left * scale.x;
    var y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $c1d497a3e5aa805c$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    var rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = $c1d497a3e5aa805c$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = $c1d497a3e5aa805c$var$getDocumentRect((0, $2a4197d9582b0915$export$e495491855dc5418)(element));
    else if ((0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $c1d497a3e5aa805c$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        var visualOffsets = $c1d497a3e5aa805c$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $f756166b2b894b06$export$ee05aea0aeecbad4)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $c1d497a3e5aa805c$var$getClippingElementAncestors(element, cache) {
    var cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    var result = (0, $2a4197d9582b0915$export$3b57c1601291186b)(element, [], false).filter(function(el) {
        return (0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(el) && (0, $2a4197d9582b0915$export$651544f548703224)(el) !== 'body';
    });
    var lastKeptComputedStyle = null;
    var elementIsFixed = (0, $2a4197d9582b0915$export$3735103072e4a80)(element).position === 'fixed';
    var currentNode = elementIsFixed ? (0, $2a4197d9582b0915$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(currentNode) && !(0, $2a4197d9582b0915$export$d1162fb0b6d4cd51)(currentNode)){
        var computedStyle = (0, $2a4197d9582b0915$export$3735103072e4a80)(currentNode);
        var currentNodeIsContaining = (0, $2a4197d9582b0915$export$d6c4e8150c35fed1)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        var lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        var shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter(function(ancestor) {
            return ancestor !== currentNode;
        });
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $2a4197d9582b0915$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $c1d497a3e5aa805c$var$getClippingRect(_ref) {
    var element = _ref.element, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, strategy = _ref.strategy;
    var elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $2a4197d9582b0915$export$89e651af02346cd4)(element) ? [] : $c1d497a3e5aa805c$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    var clippingAncestors = (0, $XnYkK._)(elementClippingAncestors).concat([
        rootBoundary
    ]);
    var firstRect = $c1d497a3e5aa805c$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    var top = firstRect.top;
    var right = firstRect.right;
    var bottom = firstRect.bottom;
    var left = firstRect.left;
    for(var i = 1; i < clippingAncestors.length; i++){
        var rect = $c1d497a3e5aa805c$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $f756166b2b894b06$export$8960430cfd85939f)(rect.top, top);
        right = (0, $f756166b2b894b06$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $f756166b2b894b06$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $f756166b2b894b06$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $c1d497a3e5aa805c$var$getDimensions(element) {
    var _getCssDimensions = $c1d497a3e5aa805c$var$getCssDimensions(element), width = _getCssDimensions.width, height = _getCssDimensions.height;
    return {
        width: width,
        height: height
    };
}
function $c1d497a3e5aa805c$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    var isOffsetParentAnElement = (0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(offsetParent);
    var documentElement = (0, $2a4197d9582b0915$export$e495491855dc5418)(offsetParent);
    var isFixed = strategy === 'fixed';
    var rect = $c1d497a3e5aa805c$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = (0, $f756166b2b894b06$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $2a4197d9582b0915$export$651544f548703224)(offsetParent) !== 'body' || (0, $2a4197d9582b0915$export$989e911fa9af580a)(documentElement)) scroll = (0, $2a4197d9582b0915$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            var offsetRect = $c1d497a3e5aa805c$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $c1d497a3e5aa805c$var$getWindowScrollBarX(documentElement);
    var htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $c1d497a3e5aa805c$var$getHTMLOffset(documentElement, scroll) : (0, $f756166b2b894b06$export$a397704b5e280835)(0);
    var x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    var y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $c1d497a3e5aa805c$var$isStaticPositioned(element) {
    return (0, $2a4197d9582b0915$export$3735103072e4a80)(element).position === 'static';
}
function $c1d497a3e5aa805c$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(element) || (0, $2a4197d9582b0915$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    var rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $2a4197d9582b0915$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $c1d497a3e5aa805c$var$getOffsetParent(element, polyfill) {
    var win = (0, $2a4197d9582b0915$export$38b2d434cce3ea22)(element);
    if ((0, $2a4197d9582b0915$export$89e651af02346cd4)(element)) return win;
    if (!(0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(element)) {
        var svgOffsetParent = (0, $2a4197d9582b0915$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $2a4197d9582b0915$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$c1d497a3e5aa805c$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $2a4197d9582b0915$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    var offsetParent = $c1d497a3e5aa805c$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $2a4197d9582b0915$export$71535ffaa902797f)(offsetParent) && $c1d497a3e5aa805c$var$isStaticPositioned(offsetParent))offsetParent = $c1d497a3e5aa805c$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $2a4197d9582b0915$export$d1162fb0b6d4cd51)(offsetParent) && $c1d497a3e5aa805c$var$isStaticPositioned(offsetParent) && !(0, $2a4197d9582b0915$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $2a4197d9582b0915$export$940d8225183e1404)(element) || win;
}
var $c1d497a3e5aa805c$var$getElementRects = function getElementRects(data) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
        var getOffsetParentFn, getDimensionsFn, floatingDimensions, _tmp, _tmp1;
        return (0, $3SMYb._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getOffsetParentFn = this.getOffsetParent || $c1d497a3e5aa805c$var$getOffsetParent;
                    getDimensionsFn = this.getDimensions;
                    return [
                        4,
                        getDimensionsFn(data.floating)
                    ];
                case 1:
                    floatingDimensions = _state.sent();
                    _tmp = {};
                    _tmp1 = [
                        data.reference
                    ];
                    return [
                        4,
                        getOffsetParentFn(data.floating)
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.reference = $c1d497a3e5aa805c$var$getRectRelativeToOffsetParent.apply(void 0, _tmp1.concat([
                            _state.sent(),
                            data.strategy
                        ])), _tmp.floating = {
                            x: 0,
                            y: 0,
                            width: floatingDimensions.width,
                            height: floatingDimensions.height
                        }, _tmp)
                    ];
            }
        });
    }).call(this);
};
function $c1d497a3e5aa805c$var$isRTL(element) {
    return (0, $2a4197d9582b0915$export$3735103072e4a80)(element).direction === 'rtl';
}
var $c1d497a3e5aa805c$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $c1d497a3e5aa805c$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, $2a4197d9582b0915$export$e495491855dc5418),
    getClippingRect: $c1d497a3e5aa805c$var$getClippingRect,
    getOffsetParent: $c1d497a3e5aa805c$var$getOffsetParent,
    getElementRects: $c1d497a3e5aa805c$var$getElementRects,
    getClientRects: $c1d497a3e5aa805c$var$getClientRects,
    getDimensions: $c1d497a3e5aa805c$var$getDimensions,
    getScale: $c1d497a3e5aa805c$var$getScale,
    isElement: (0, $2a4197d9582b0915$export$45a5e7f76e0caa8d),
    isRTL: $c1d497a3e5aa805c$var$isRTL
};
function $c1d497a3e5aa805c$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $c1d497a3e5aa805c$var$observeMove(element, onMove, ancestorResize) {
    var io = null;
    var timeoutId;
    var root = (0, $2a4197d9582b0915$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        var elementRectForRootMargin = element.getBoundingClientRect();
        var left = elementRectForRootMargin.left, top = elementRectForRootMargin.top, width = elementRectForRootMargin.width, height = elementRectForRootMargin.height;
        if (!skip) onMove();
        if (!width || !height) return;
        var insetTop = (0, $f756166b2b894b06$export$a3fe094919f356fd)(top);
        var insetRight = (0, $f756166b2b894b06$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        var insetBottom = (0, $f756166b2b894b06$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        var insetLeft = (0, $f756166b2b894b06$export$a3fe094919f356fd)(left);
        var rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        var options = {
            rootMargin: rootMargin,
            threshold: (0, $f756166b2b894b06$export$8960430cfd85939f)(0, (0, $f756166b2b894b06$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        var isFirstUpdate = true;
        function handleObserve(entries) {
            var ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$c1d497a3e5aa805c$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(function() {
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $lf4fc._)((0, $hwO3w._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    var win = (0, $2a4197d9582b0915$export$38b2d434cce3ea22)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    var handleResize = function() {
        return refresh(ancestorResize);
    };
    win.addEventListener('resize', handleResize);
    refresh(true);
    return function() {
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $c1d497a3e5aa805c$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    var _options_ancestorScroll = options.ancestorScroll, ancestorScroll = _options_ancestorScroll === void 0 ? true : _options_ancestorScroll, _options_ancestorResize = options.ancestorResize, ancestorResize = _options_ancestorResize === void 0 ? true : _options_ancestorResize, _options_elementResize = options.elementResize, elementResize = _options_elementResize === void 0 ? typeof ResizeObserver === 'function' : _options_elementResize, _options_layoutShift = options.layoutShift, layoutShift = _options_layoutShift === void 0 ? typeof IntersectionObserver === 'function' : _options_layoutShift, _options_animationFrame = options.animationFrame, animationFrame = _options_animationFrame === void 0 ? false : _options_animationFrame;
    var referenceEl = $c1d497a3e5aa805c$var$unwrapElement(reference);
    var ancestors = ancestorScroll || ancestorResize ? (0, $XnYkK._)(referenceEl ? (0, $2a4197d9582b0915$export$3b57c1601291186b)(referenceEl) : []).concat((0, $XnYkK._)(floating ? (0, $2a4197d9582b0915$export$3b57c1601291186b)(floating) : [])) : [];
    ancestors.forEach(function(ancestor) {
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    var cleanupIo = referenceEl && layoutShift ? $c1d497a3e5aa805c$var$observeMove(referenceEl, update, ancestorResize) : null;
    var reobserveFrame = -1;
    var resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver(function(_ref) {
            var _$_ref = (0, $6iP9u._)(_ref, 1), firstEntry = _$_ref[0];
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(function() {
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    var frameId;
    var prevRefRect = animationFrame ? $c1d497a3e5aa805c$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        var nextRefRect = $c1d497a3e5aa805c$var$getBoundingClientRect(reference);
        if (prevRefRect && !$c1d497a3e5aa805c$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return function() {
        var _resizeObserver2;
        ancestors.forEach(function(ancestor) {
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ var $c1d497a3e5aa805c$export$37b6bde19b108ecc = (0, $ac6c2c02b18c5330$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var $c1d497a3e5aa805c$export$cc800923e997bb8 = (0, $ac6c2c02b18c5330$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var $c1d497a3e5aa805c$export$91fb6ecbd551914 = (0, $ac6c2c02b18c5330$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var $c1d497a3e5aa805c$export$fba63a578e423eb = (0, $ac6c2c02b18c5330$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var $c1d497a3e5aa805c$export$8a83211c878a3f1f = (0, $ac6c2c02b18c5330$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var $c1d497a3e5aa805c$export$346677f925de839c = (0, $ac6c2c02b18c5330$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var $c1d497a3e5aa805c$export$fe8985bb6374093c = (0, $ac6c2c02b18c5330$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var $c1d497a3e5aa805c$export$f2120bbfa5450bd2 = (0, $ac6c2c02b18c5330$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var $c1d497a3e5aa805c$export$18c8ad048e32c7d5 = (0, $ac6c2c02b18c5330$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var $c1d497a3e5aa805c$export$7bf07e38f3dc4b69 = (0, $ac6c2c02b18c5330$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ var $c1d497a3e5aa805c$export$48a53dcb22e581d0 = function(reference, floating, options) {
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    var cache = new Map();
    var mergedOptions = options != null ? options : {};
    var platformWithCache = (0, $lf4fc._)((0, $hwO3w._)({}, $c1d497a3e5aa805c$export$722a64dea1b767dc, mergedOptions.platform), {
        _c: cache
    });
    return (0, $ac6c2c02b18c5330$export$48a53dcb22e581d0)(reference, floating, (0, $lf4fc._)((0, $hwO3w._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};



var $5s1kH = parcelRequire("5s1kH");

var $eAxYl = parcelRequire("eAxYl");
var $5b7bf8dbb9190e49$var$isClient = typeof document !== 'undefined';
var $5b7bf8dbb9190e49$var$noop = function noop() {};
var $5b7bf8dbb9190e49$var$index = $5b7bf8dbb9190e49$var$isClient ? (0, $5s1kH.useLayoutEffect) : $5b7bf8dbb9190e49$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $5b7bf8dbb9190e49$var$deepEqual(a, b) {
    if (a === b) return true;
    if ((typeof a === "undefined" ? "undefined" : (0, $03bAP._)(a)) !== (typeof b === "undefined" ? "undefined" : (0, $03bAP._)(b))) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    var length;
    var i;
    var keys;
    if (a && b && (typeof a === "undefined" ? "undefined" : (0, $03bAP._)(a)) === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$5b7bf8dbb9190e49$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$5b7bf8dbb9190e49$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $5b7bf8dbb9190e49$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    var win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $5b7bf8dbb9190e49$var$roundByDPR(element, value) {
    var dpr = $5b7bf8dbb9190e49$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $5b7bf8dbb9190e49$var$useLatestRef(value) {
    var ref = $5s1kH.useRef(value);
    $5b7bf8dbb9190e49$var$index(function() {
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $5b7bf8dbb9190e49$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    var _options_placement = options.placement, placement = _options_placement === void 0 ? 'bottom' : _options_placement, _options_strategy = options.strategy, strategy = _options_strategy === void 0 ? 'absolute' : _options_strategy, _options_middleware = options.middleware, middleware = _options_middleware === void 0 ? [] : _options_middleware, platform = options.platform, tmp = options.elements, _ref = tmp === void 0 ? {} : tmp, externalReference = _ref.reference, externalFloating = _ref.floating, _options_transform = options.transform, transform = _options_transform === void 0 ? true : _options_transform, whileElementsMounted = options.whileElementsMounted, open = options.open;
    var _React_useState = (0, $6iP9u._)($5s1kH.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    }), 2), data = _React_useState[0], setData = _React_useState[1];
    var _React_useState1 = (0, $6iP9u._)($5s1kH.useState(middleware), 2), latestMiddleware = _React_useState1[0], setLatestMiddleware = _React_useState1[1];
    if (!$5b7bf8dbb9190e49$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    var _React_useState2 = (0, $6iP9u._)($5s1kH.useState(null), 2), _reference = _React_useState2[0], _setReference = _React_useState2[1];
    var _React_useState3 = (0, $6iP9u._)($5s1kH.useState(null), 2), _floating = _React_useState3[0], _setFloating = _React_useState3[1];
    var setReference = $5s1kH.useCallback(function(node) {
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    var setFloating = $5s1kH.useCallback(function(node) {
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    var referenceEl = externalReference || _reference;
    var floatingEl = externalFloating || _floating;
    var referenceRef = $5s1kH.useRef(null);
    var floatingRef = $5s1kH.useRef(null);
    var dataRef = $5s1kH.useRef(data);
    var hasWhileElementsMounted = whileElementsMounted != null;
    var whileElementsMountedRef = $5b7bf8dbb9190e49$var$useLatestRef(whileElementsMounted);
    var platformRef = $5b7bf8dbb9190e49$var$useLatestRef(platform);
    var openRef = $5b7bf8dbb9190e49$var$useLatestRef(open);
    var update = $5s1kH.useCallback(function() {
        if (!referenceRef.current || !floatingRef.current) return;
        var config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $c1d497a3e5aa805c$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then(function(data) {
            var fullData = (0, $lf4fc._)((0, $hwO3w._)({}, data), {
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            });
            if (isMountedRef.current && !$5b7bf8dbb9190e49$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $eAxYl.flushSync(function() {
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $5b7bf8dbb9190e49$var$index(function() {
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData(function(data) {
                return (0, $lf4fc._)((0, $hwO3w._)({}, data), {
                    isPositioned: false
                });
            });
        }
    }, [
        open
    ]);
    var isMountedRef = $5s1kH.useRef(false);
    $5b7bf8dbb9190e49$var$index(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    $5b7bf8dbb9190e49$var$index(function() {
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    var refs = $5s1kH.useMemo(function() {
        return {
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        };
    }, [
        setReference,
        setFloating
    ]);
    var elements = $5s1kH.useMemo(function() {
        return {
            reference: referenceEl,
            floating: floatingEl
        };
    }, [
        referenceEl,
        floatingEl
    ]);
    var floatingStyles = $5s1kH.useMemo(function() {
        var initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        var x = $5b7bf8dbb9190e49$var$roundByDPR(elements.floating, data.x);
        var y = $5b7bf8dbb9190e49$var$roundByDPR(elements.floating, data.y);
        if (transform) return (0, $hwO3w._)((0, $lf4fc._)((0, $hwO3w._)({}, initialStyles), {
            transform: "translate(" + x + "px, " + y + "px)"
        }), $5b7bf8dbb9190e49$var$getDPR(elements.floating) >= 1.5 && {
            willChange: 'transform'
        });
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $5s1kH.useMemo(function() {
        return (0, $lf4fc._)((0, $hwO3w._)({}, data), {
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        });
    }, [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ var $5b7bf8dbb9190e49$var$arrow$1 = function(options) {
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn: function(state) {
            var _ref = typeof options === 'function' ? options(state) : options, element = _ref.element, padding = _ref.padding;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $c1d497a3e5aa805c$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $c1d497a3e5aa805c$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var $5b7bf8dbb9190e49$export$cc800923e997bb8 = function(options, deps) {
    var result = (0, $c1d497a3e5aa805c$export$cc800923e997bb8)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var $5b7bf8dbb9190e49$export$fba63a578e423eb = function(options, deps) {
    var result = (0, $c1d497a3e5aa805c$export$fba63a578e423eb)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var $5b7bf8dbb9190e49$export$7bf07e38f3dc4b69 = function(options, deps) {
    var result = (0, $c1d497a3e5aa805c$export$7bf07e38f3dc4b69)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var $5b7bf8dbb9190e49$export$8a83211c878a3f1f = function(options, deps) {
    var result = (0, $c1d497a3e5aa805c$export$8a83211c878a3f1f)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var $5b7bf8dbb9190e49$export$346677f925de839c = function(options, deps) {
    var result = (0, $c1d497a3e5aa805c$export$346677f925de839c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var $5b7bf8dbb9190e49$export$91fb6ecbd551914 = function(options, deps) {
    var result = (0, $c1d497a3e5aa805c$export$91fb6ecbd551914)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var $5b7bf8dbb9190e49$export$fe8985bb6374093c = function(options, deps) {
    var result = (0, $c1d497a3e5aa805c$export$fe8985bb6374093c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var $5b7bf8dbb9190e49$export$18c8ad048e32c7d5 = function(options, deps) {
    var result = (0, $c1d497a3e5aa805c$export$18c8ad048e32c7d5)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ var $5b7bf8dbb9190e49$export$f2120bbfa5450bd2 = function(options, deps) {
    var result = $5b7bf8dbb9190e49$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};


var $lFIaz = parcelRequire("lFIaz");

var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $54Czb = parcelRequire("54Czb");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");

var $03bAP = parcelRequire("03bAP");
function $701ae29e55852bb5$export$71511d61b312f219(input, hint) {
    if ((0, $03bAP._)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $03bAP._)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}



var $03bAP = parcelRequire("03bAP");
function $e78cd090630be08f$export$71511d61b312f219(arg) {
    var key = (0, $701ae29e55852bb5$export$71511d61b312f219)(arg, "string");
    return (0, $03bAP._)(key) === "symbol" ? key : String(key);
}



var $3SMYb = parcelRequire("3SMYb");

var $5s1kH = parcelRequire("5s1kH");

var $hwO3w = parcelRequire("hwO3w");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");

/*!
* tabbable 6.5.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var $190ee81742d340f0$var$candidateSelectors = [
    'input:not([inert]):not([inert] *)',
    'select:not([inert]):not([inert] *)',
    'textarea:not([inert]):not([inert] *)',
    'a[href]:not([inert]):not([inert] *)',
    'area[href]:not([inert]):not([inert] *)',
    'button:not([inert]):not([inert] *)',
    '[tabindex]:not(slot):not([inert]):not([inert] *)',
    'audio[controls]:not([inert]):not([inert] *)',
    'video[controls]:not([inert]):not([inert] *)',
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    'details>summary:first-of-type:not([inert]):not([inert] *)',
    'details:not([inert]):not([inert] *)'
];
var $190ee81742d340f0$var$candidateSelector = /* #__PURE__ */ $190ee81742d340f0$var$candidateSelectors.join(',');
var $190ee81742d340f0$var$NoElement = typeof Element === 'undefined';
var $190ee81742d340f0$var$matches = $190ee81742d340f0$var$NoElement ? function matches() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $190ee81742d340f0$var$getRootNode = !$190ee81742d340f0$var$NoElement && Element.prototype.getRootNode ? function getRootNode(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $190ee81742d340f0$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === 'function' ? node.closest('[inert]') : $190ee81742d340f0$var$_isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $190ee81742d340f0$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $190ee81742d340f0$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if ($190ee81742d340f0$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($190ee81742d340f0$var$candidateSelector));
    if (includeContainer && $190ee81742d340f0$var$matches.call(el, $190ee81742d340f0$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $190ee81742d340f0$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($190ee81742d340f0$var$_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $190ee81742d340f0$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $190ee81742d340f0$var$matches.call(element, $190ee81742d340f0$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$190ee81742d340f0$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $190ee81742d340f0$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $190ee81742d340f0$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $190ee81742d340f0$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $190ee81742d340f0$var$isContentEditable(node)) && !$190ee81742d340f0$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $190ee81742d340f0$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $190ee81742d340f0$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$190ee81742d340f0$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $190ee81742d340f0$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $190ee81742d340f0$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $190ee81742d340f0$var$isHiddenInput = function isHiddenInput(node) {
    return $190ee81742d340f0$var$isInput(node) && node.type === 'hidden';
};
var $190ee81742d340f0$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $190ee81742d340f0$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $190ee81742d340f0$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $190ee81742d340f0$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $190ee81742d340f0$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $190ee81742d340f0$var$isRadio = function isRadio(node) {
    return $190ee81742d340f0$var$isInput(node) && node.type === 'radio';
};
var $190ee81742d340f0$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $190ee81742d340f0$var$isRadio(node) && !$190ee81742d340f0$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $190ee81742d340f0$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $190ee81742d340f0$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $190ee81742d340f0$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $190ee81742d340f0$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $190ee81742d340f0$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    var _getComputedStyle = getComputedStyle(node), visibility = _getComputedStyle.visibility;
    if (visibility === 'hidden' || visibility === 'collapse') return true;
    var isDirectSummary = $190ee81742d340f0$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($190ee81742d340f0$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $190ee81742d340f0$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $190ee81742d340f0$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($190ee81742d340f0$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $190ee81742d340f0$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $190ee81742d340f0$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $190ee81742d340f0$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $190ee81742d340f0$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $190ee81742d340f0$var$isHiddenInput(node) || $190ee81742d340f0$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $190ee81742d340f0$var$isDetailsWithSummary(node) || $190ee81742d340f0$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $190ee81742d340f0$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($190ee81742d340f0$var$isNonTabbableRadio(node) || $190ee81742d340f0$export$a4672efddb4181b8(node) < 0 || !$190ee81742d340f0$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $190ee81742d340f0$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $190ee81742d340f0$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $190ee81742d340f0$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $190ee81742d340f0$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($190ee81742d340f0$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $190ee81742d340f0$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $190ee81742d340f0$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $190ee81742d340f0$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $190ee81742d340f0$var$isShadowRootTabbable
    });
    else candidates = $190ee81742d340f0$var$getCandidates(container, options.includeContainer, $190ee81742d340f0$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $190ee81742d340f0$var$_sortByOrder(candidates);
};
var $190ee81742d340f0$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $190ee81742d340f0$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $190ee81742d340f0$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $190ee81742d340f0$var$getCandidates(container, options.includeContainer, $190ee81742d340f0$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $190ee81742d340f0$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($190ee81742d340f0$var$matches.call(node, $190ee81742d340f0$var$candidateSelector) === false) return false;
    return $190ee81742d340f0$var$isNodeMatchingSelectorTabbable(options, node);
};
var $190ee81742d340f0$var$focusableCandidateSelector = /* #__PURE__ */ $190ee81742d340f0$var$candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var $190ee81742d340f0$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($190ee81742d340f0$var$matches.call(node, $190ee81742d340f0$var$focusableCandidateSelector) === false) return false;
    return $190ee81742d340f0$var$isNodeMatchingSelectorFocusable(options, node);
};


// Avoid Chrome DevTools blue warning.
function $72ad0bd1c5aa7773$export$867a782338812cb4() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $72ad0bd1c5aa7773$export$7935961ef7719cb0() {
    var uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map(function(_ref) {
        var brand = _ref.brand, version = _ref.version;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
function $72ad0bd1c5aa7773$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $72ad0bd1c5aa7773$export$a11b0059900ceec8() {
    var re = /android/i;
    return re.test($72ad0bd1c5aa7773$export$867a782338812cb4()) || re.test($72ad0bd1c5aa7773$export$7935961ef7719cb0());
}
function $72ad0bd1c5aa7773$export$9ac100e40613ea10() {
    return $72ad0bd1c5aa7773$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $72ad0bd1c5aa7773$export$c8f880a2d81914c4() {
    return $72ad0bd1c5aa7773$export$7935961ef7719cb0().includes('jsdom/');
}
var $72ad0bd1c5aa7773$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
var $72ad0bd1c5aa7773$var$TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
var $72ad0bd1c5aa7773$var$ARROW_LEFT = 'ArrowLeft';
var $72ad0bd1c5aa7773$var$ARROW_RIGHT = 'ArrowRight';
var $72ad0bd1c5aa7773$var$ARROW_UP = 'ArrowUp';
var $72ad0bd1c5aa7773$var$ARROW_DOWN = 'ArrowDown';
function $72ad0bd1c5aa7773$export$da980962bd2147a4(doc) {
    var activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $72ad0bd1c5aa7773$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    var rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $2a4197d9582b0915$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $72ad0bd1c5aa7773$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $72ad0bd1c5aa7773$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    var e = event;
    return e.target != null && node.contains(e.target);
}
function $72ad0bd1c5aa7773$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $72ad0bd1c5aa7773$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $72ad0bd1c5aa7773$export$42ad131c32f0fb8d(element) {
    return (0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(element) && element.matches($72ad0bd1c5aa7773$var$TYPEABLE_SELECTOR);
}
function $72ad0bd1c5aa7773$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $72ad0bd1c5aa7773$export$42ad131c32f0fb8d(element);
}
function $72ad0bd1c5aa7773$export$65750043c2fb2f40(element) {
    // We don't want to block focus from working with `visibleOnly`
    // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
    if (!element || $72ad0bd1c5aa7773$export$c8f880a2d81914c4()) return true;
    try {
        return element.matches(':focus-visible');
    } catch (_e) {
        return true;
    }
}
function $72ad0bd1c5aa7773$export$9b0901b5e9b45fc7(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($72ad0bd1c5aa7773$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $72ad0bd1c5aa7773$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
function $72ad0bd1c5aa7773$export$1f1998cc3c6b56fb(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    var directChildren = nodes.filter(function(node) {
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap(function(child) {
        return [
            child
        ].concat((0, $XnYkK._)($72ad0bd1c5aa7773$export$1f1998cc3c6b56fb(nodes, child.id, onlyOpenChildren)));
    });
}
function $72ad0bd1c5aa7773$export$e7e88d43cb97db79(nodes, id) {
    var deepestNodeId;
    var maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        var children = $72ad0bd1c5aa7773$export$1f1998cc3c6b56fb(nodes, nodeId);
        children.forEach(function(child) {
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find(function(node) {
        return node.id === deepestNodeId;
    });
}
function $72ad0bd1c5aa7773$export$5d8eb345316b65c0(nodes, id) {
    var _nodes$find;
    var allAncestors = [];
    var currentParentId = (_nodes$find = nodes.find(function(node) {
        return node.id === id;
    })) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        var currentNode = nodes.find(function(node) {
            return node.id === currentParentId;
        });
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $72ad0bd1c5aa7773$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $72ad0bd1c5aa7773$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($72ad0bd1c5aa7773$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $72ad0bd1c5aa7773$export$29bf1b5f2c56cf63(event) {
    if ($72ad0bd1c5aa7773$export$c8f880a2d81914c4()) return false;
    return !$72ad0bd1c5aa7773$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $72ad0bd1c5aa7773$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $72ad0bd1c5aa7773$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    var values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
var $72ad0bd1c5aa7773$var$isClient = typeof document !== 'undefined';
var $72ad0bd1c5aa7773$var$noop = function noop() {};
var $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f = $72ad0bd1c5aa7773$var$isClient ? (0, $5s1kH.useLayoutEffect) : $72ad0bd1c5aa7773$var$noop;
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
var $72ad0bd1c5aa7773$var$SafeReact = (0, $hwO3w._)({}, $5s1kH);
function $72ad0bd1c5aa7773$export$bcd07ba85a740103(value) {
    var ref = $5s1kH.useRef(value);
    $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f(function() {
        ref.current = value;
    });
    return ref;
}
var $72ad0bd1c5aa7773$var$useInsertionEffect = $72ad0bd1c5aa7773$var$SafeReact.useInsertionEffect;
var $72ad0bd1c5aa7773$var$useSafeInsertionEffect = $72ad0bd1c5aa7773$var$useInsertionEffect || function(fn) {
    return fn();
};
function $72ad0bd1c5aa7773$export$7f54fc3180508a52(callback) {
    var ref = $5s1kH.useRef(function() {});
    $72ad0bd1c5aa7773$var$useSafeInsertionEffect(function() {
        ref.current = callback;
    });
    return $5s1kH.useCallback(function() {
        var _ref;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : (_ref = ref).current.apply(_ref, (0, $XnYkK._)(args));
    }, []);
}
function $72ad0bd1c5aa7773$export$709046525cac3019(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $72ad0bd1c5aa7773$export$75effb89758ec596(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $72ad0bd1c5aa7773$export$53f691ee0acc6058(listRef, disabledIndices) {
    return $72ad0bd1c5aa7773$export$3fc3ea4a67cf714(listRef, {
        disabledIndices: disabledIndices
    });
}
function $72ad0bd1c5aa7773$export$b585558af466e926(listRef, disabledIndices) {
    return $72ad0bd1c5aa7773$export$3fc3ea4a67cf714(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $72ad0bd1c5aa7773$export$3fc3ea4a67cf714(listRef, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref_startingIndex = _ref.startingIndex, startingIndex = _ref_startingIndex === void 0 ? -1 : _ref_startingIndex, _ref_decrement = _ref.decrement, decrement = _ref_decrement === void 0 ? false : _ref_decrement, disabledIndices = _ref.disabledIndices, _ref_amount = _ref.amount, amount = _ref_amount === void 0 ? 1 : _ref_amount;
    var index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= listRef.current.length - 1 && $72ad0bd1c5aa7773$export$446656ed0410fd9(listRef, index, disabledIndices));
    return index;
}
function $72ad0bd1c5aa7773$export$342fcce33a2688bc(listRef, _ref) {
    var event = _ref.event, orientation = _ref.orientation, loop = _ref.loop, rtl = _ref.rtl, cols = _ref.cols, disabledIndices = _ref.disabledIndices, minIndex = _ref.minIndex, maxIndex = _ref.maxIndex, prevIndex = _ref.prevIndex, tmp = _ref.stopEvent, stop = tmp === void 0 ? false : tmp;
    var nextIndex = prevIndex;
    if (event.key === $72ad0bd1c5aa7773$var$ARROW_UP) {
        stop && $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $72ad0bd1c5aa7773$export$3fc3ea4a67cf714(listRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                var col = prevIndex % cols;
                var maxCol = maxIndex % cols;
                var offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($72ad0bd1c5aa7773$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $72ad0bd1c5aa7773$var$ARROW_DOWN) {
        stop && $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $72ad0bd1c5aa7773$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $72ad0bd1c5aa7773$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($72ad0bd1c5aa7773$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        var prevRow = (0, $f756166b2b894b06$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === (rtl ? $72ad0bd1c5aa7773$var$ARROW_LEFT : $72ad0bd1c5aa7773$var$ARROW_RIGHT)) {
            stop && $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $72ad0bd1c5aa7773$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $72ad0bd1c5aa7773$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $72ad0bd1c5aa7773$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $72ad0bd1c5aa7773$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($72ad0bd1c5aa7773$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $72ad0bd1c5aa7773$var$ARROW_RIGHT : $72ad0bd1c5aa7773$var$ARROW_LEFT)) {
            stop && $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $72ad0bd1c5aa7773$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $72ad0bd1c5aa7773$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $72ad0bd1c5aa7773$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $72ad0bd1c5aa7773$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($72ad0bd1c5aa7773$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        var lastRow = (0, $f756166b2b894b06$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($72ad0bd1c5aa7773$export$75effb89758ec596(listRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $72ad0bd1c5aa7773$var$ARROW_RIGHT : $72ad0bd1c5aa7773$var$ARROW_LEFT) ? maxIndex : $72ad0bd1c5aa7773$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $72ad0bd1c5aa7773$export$5334c96856356f08(sizes, cols, dense) {
    var cellMap = [];
    var startIndex = 0;
    sizes.forEach(function(_ref2, index) {
        var width = _ref2.width, height = _ref2.height;
        var itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            var targetCells = [];
            for(var i = 0; i < width; i++)for(var j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every(function(cell) {
                return cellMap[cell] == null;
            })) {
                targetCells.forEach(function(cell) {
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return (0, $XnYkK._)(cellMap);
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $72ad0bd1c5aa7773$export$dab2b2ce7761f8e4(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    var firstCellIndex = cellMap.indexOf(index);
    var sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $72ad0bd1c5aa7773$export$50d8709b2ccc23f9(indices, cellMap) {
    return cellMap.flatMap(function(index, cellIndex) {
        return indices.includes(index) ? [
            cellIndex
        ] : [];
    });
}
function $72ad0bd1c5aa7773$export$446656ed0410fd9(listRef, index, disabledIndices) {
    if (typeof disabledIndices === 'function') return disabledIndices(index);
    else if (disabledIndices) return disabledIndices.includes(index);
    var element = listRef.current[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
var $72ad0bd1c5aa7773$export$6324a2bbae6a332f = function() {
    return {
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    };
};
function $72ad0bd1c5aa7773$var$getTabbableIn(container, dir) {
    var list = (0, $190ee81742d340f0$export$17100aea90429aa7)(container, $72ad0bd1c5aa7773$export$6324a2bbae6a332f());
    var len = list.length;
    if (len === 0) return;
    var active = $72ad0bd1c5aa7773$export$da980962bd2147a4($72ad0bd1c5aa7773$export$f65ca476c09acec0(container));
    var index = list.indexOf(active);
    var nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
    return list[nextIndex];
}
function $72ad0bd1c5aa7773$export$28f33206776129a7(referenceElement) {
    return $72ad0bd1c5aa7773$var$getTabbableIn($72ad0bd1c5aa7773$export$f65ca476c09acec0(referenceElement).body, 1) || referenceElement;
}
function $72ad0bd1c5aa7773$export$2e5518c3303f364a(referenceElement) {
    return $72ad0bd1c5aa7773$var$getTabbableIn($72ad0bd1c5aa7773$export$f65ca476c09acec0(referenceElement).body, -1) || referenceElement;
}
function $72ad0bd1c5aa7773$export$6e0c4e272f3faa2(event, container) {
    var containerElement = container || event.currentTarget;
    var relatedTarget = event.relatedTarget;
    return !relatedTarget || !$72ad0bd1c5aa7773$export$2344b14b097df817(containerElement, relatedTarget);
}
function $72ad0bd1c5aa7773$export$3995dd353b80da11(container) {
    var tabbableElements = (0, $190ee81742d340f0$export$17100aea90429aa7)(container, $72ad0bd1c5aa7773$export$6324a2bbae6a332f());
    tabbableElements.forEach(function(element) {
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $72ad0bd1c5aa7773$export$a65f4028abb17f36(container) {
    var elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach(function(element) {
        var tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}






var $eAxYl = parcelRequire("eAxYl");


/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $ad76f2a8d85683d0$export$74665b213cb5c4cf(refs) {
    var cleanupRef = $5s1kH.useRef(undefined);
    var refEffect = $5s1kH.useCallback(function(instance) {
        var cleanups = refs.map(function(ref) {
            if (ref == null) return;
            if (typeof ref === 'function') {
                var refCallback = ref;
                var refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : function() {
                    refCallback(null);
                };
            }
            ref.current = instance;
            return function() {
                ref.current = null;
            };
        });
        return function() {
            cleanups.forEach(function(refCleanup) {
                return refCleanup == null ? void 0 : refCleanup();
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $5s1kH.useMemo(function() {
        if (refs.every(function(ref) {
            return ref == null;
        })) return null;
        return function(value) {
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
function $ad76f2a8d85683d0$var$sortByDocumentPosition(a, b) {
    var position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
var $ad76f2a8d85683d0$var$FloatingListContext = /*#__PURE__*/ $5s1kH.createContext({
    register: function() {},
    unregister: function() {},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $ad76f2a8d85683d0$export$ffe15b0e64951704(props) {
    var children = props.children, elementsRef = props.elementsRef, labelsRef = props.labelsRef;
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(function() {
        return new Set();
    }), 2), nodes = _React_useState[0], setNodes = _React_useState[1];
    var register = $5s1kH.useCallback(function(node) {
        setNodes(function(prevSet) {
            return new Set(prevSet).add(node);
        });
    }, []);
    var unregister = $5s1kH.useCallback(function(node) {
        setNodes(function(prevSet) {
            var set = new Set(prevSet);
            set.delete(node);
            return set;
        });
    }, []);
    var map = $5s1kH.useMemo(function() {
        var newMap = new Map();
        var sortedNodes = Array.from(nodes.keys()).sort($ad76f2a8d85683d0$var$sortByDocumentPosition);
        sortedNodes.forEach(function(node, index) {
            newMap.set(node, index);
        });
        return newMap;
    }, [
        nodes
    ]);
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($ad76f2a8d85683d0$var$FloatingListContext.Provider, {
        value: $5s1kH.useMemo(function() {
            return {
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            };
        }, [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ]),
        children: children
    });
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $ad76f2a8d85683d0$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    var label = props.label;
    var _React_useContext = $5s1kH.useContext($ad76f2a8d85683d0$var$FloatingListContext), register = _React_useContext.register, unregister = _React_useContext.unregister, map = _React_useContext.map, elementsRef = _React_useContext.elementsRef, labelsRef = _React_useContext.labelsRef;
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(null), 2), index = _React_useState[0], setIndex = _React_useState[1];
    var componentRef = $5s1kH.useRef(null);
    var ref = $5s1kH.useCallback(function(node) {
        componentRef.current = node;
        if (index !== null) {
            elementsRef.current[index] = node;
            if (labelsRef) {
                var _node$textContent;
                var isLabelDefined = label !== undefined;
                labelsRef.current[index] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index,
        elementsRef,
        labelsRef,
        label
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        var node = componentRef.current;
        if (node) {
            register(node);
            return function() {
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        var index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $5s1kH.useMemo(function() {
        return {
            ref: ref,
            index: index == null ? -1 : index
        };
    }, [
        index,
        ref
    ]);
}
var $ad76f2a8d85683d0$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
var $ad76f2a8d85683d0$var$ACTIVE_KEY = 'active';
var $ad76f2a8d85683d0$var$SELECTED_KEY = 'selected';
var $ad76f2a8d85683d0$var$ARROW_LEFT = 'ArrowLeft';
var $ad76f2a8d85683d0$var$ARROW_RIGHT = 'ArrowRight';
var $ad76f2a8d85683d0$var$ARROW_UP = 'ArrowUp';
var $ad76f2a8d85683d0$var$ARROW_DOWN = 'ArrowDown';
function $ad76f2a8d85683d0$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $5s1kH.cloneElement(render, computedProps);
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", (0, $hwO3w._)({}, computedProps));
}
var $ad76f2a8d85683d0$var$CompositeContext = /*#__PURE__*/ $5s1kH.createContext({
    activeIndex: 0,
    onNavigate: function() {}
});
var $ad76f2a8d85683d0$var$horizontalKeys = [
    $ad76f2a8d85683d0$var$ARROW_LEFT,
    $ad76f2a8d85683d0$var$ARROW_RIGHT
];
var $ad76f2a8d85683d0$var$verticalKeys = [
    $ad76f2a8d85683d0$var$ARROW_UP,
    $ad76f2a8d85683d0$var$ARROW_DOWN
];
var $ad76f2a8d85683d0$var$allKeys = (0, $XnYkK._)($ad76f2a8d85683d0$var$horizontalKeys).concat((0, $XnYkK._)($ad76f2a8d85683d0$var$verticalKeys));
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ var $ad76f2a8d85683d0$export$43586241d9db0c6d = /*#__PURE__*/ $5s1kH.forwardRef(function Composite(props, forwardedRef) {
    var render = props.render, _props_orientation = props.orientation, orientation = _props_orientation === void 0 ? 'both' : _props_orientation, _props_loop = props.loop, loop = _props_loop === void 0 ? true : _props_loop, _props_rtl = props.rtl, rtl = _props_rtl === void 0 ? false : _props_rtl, _props_cols = props.cols, cols = _props_cols === void 0 ? 1 : _props_cols, disabledIndices = props.disabledIndices, externalActiveIndex = props.activeIndex, externalSetActiveIndex = props.onNavigate, itemSizes = props.itemSizes, _props_dense = props.dense, dense = _props_dense === void 0 ? false : _props_dense, domProps = (0, $54Czb._)(props, [
        "render",
        "orientation",
        "loop",
        "rtl",
        "cols",
        "disabledIndices",
        "activeIndex",
        "onNavigate",
        "itemSizes",
        "dense"
    ]);
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(0), 2), internalActiveIndex = _React_useState[0], internalSetActiveIndex = _React_useState[1];
    var activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    var onNavigate = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    var elementsRef = $5s1kH.useRef([]);
    var renderElementProps = render && typeof render !== 'function' ? render.props : {};
    var contextValue = $5s1kH.useMemo(function() {
        return {
            activeIndex: activeIndex,
            onNavigate: onNavigate
        };
    }, [
        activeIndex,
        onNavigate
    ]);
    var isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$ad76f2a8d85683d0$var$allKeys.includes(event.key)) return;
        var nextIndex = activeIndex;
        var minIndex = (0, $72ad0bd1c5aa7773$export$53f691ee0acc6058)(elementsRef, disabledIndices);
        var maxIndex = (0, $72ad0bd1c5aa7773$export$b585558af466e926)(elementsRef, disabledIndices);
        var horizontalEndKey = rtl ? $ad76f2a8d85683d0$var$ARROW_LEFT : $ad76f2a8d85683d0$var$ARROW_RIGHT;
        var horizontalStartKey = rtl ? $ad76f2a8d85683d0$var$ARROW_RIGHT : $ad76f2a8d85683d0$var$ARROW_LEFT;
        if (isGrid) {
            var sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, function() {
                return {
                    width: 1,
                    height: 1
                };
            });
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            var cellMap = (0, $72ad0bd1c5aa7773$export$5334c96856356f08)(sizes, cols, dense);
            var minGridIndex = cellMap.findIndex(function(index) {
                return index != null && !(0, $72ad0bd1c5aa7773$export$446656ed0410fd9)(elementsRef, index, disabledIndices);
            });
            // last enabled index
            var maxGridIndex = cellMap.reduce(function(foundIndex, index, cellIndex) {
                return index != null && !(0, $72ad0bd1c5aa7773$export$446656ed0410fd9)(elementsRef, index, disabledIndices) ? cellIndex : foundIndex;
            }, -1);
            var maybeNextIndex = cellMap[(0, $72ad0bd1c5aa7773$export$342fcce33a2688bc)({
                current: cellMap.map(function(itemIndex) {
                    return itemIndex ? elementsRef.current[itemIndex] : null;
                })
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $72ad0bd1c5aa7773$export$50d8709b2ccc23f9)((0, $XnYkK._)((typeof disabledIndices !== 'function' ? disabledIndices : null) || elementsRef.current.map(function(_, index) {
                    return (0, $72ad0bd1c5aa7773$export$446656ed0410fd9)(elementsRef, index, disabledIndices) ? index : undefined;
                })).concat([
                    undefined
                ]), cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $72ad0bd1c5aa7773$export$dab2b2ce7761f8e4)(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $ad76f2a8d85683d0$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        var toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $ad76f2a8d85683d0$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $ad76f2a8d85683d0$var$ARROW_DOWN
            ]
        }[orientation];
        var toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $ad76f2a8d85683d0$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $ad76f2a8d85683d0$var$ARROW_UP
            ]
        }[orientation];
        var preventedKeys = isGrid ? $ad76f2a8d85683d0$var$allKeys : ({
            horizontal: $ad76f2a8d85683d0$var$horizontalKeys,
            vertical: $ad76f2a8d85683d0$var$verticalKeys,
            both: $ad76f2a8d85683d0$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && (0, $XnYkK._)(toEndKeys).concat((0, $XnYkK._)(toStartKeys)).includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = (0, $72ad0bd1c5aa7773$export$3fc3ea4a67cf714)(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !(0, $72ad0bd1c5aa7773$export$75effb89758ec596)(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    var computedProps = (0, $lf4fc._)((0, $hwO3w._)({}, domProps, renderElementProps), {
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown: function(e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($ad76f2a8d85683d0$var$CompositeContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($ad76f2a8d85683d0$export$ffe15b0e64951704, {
            elementsRef: elementsRef,
            children: $ad76f2a8d85683d0$var$renderJsx(render, computedProps)
        })
    });
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ var $ad76f2a8d85683d0$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $5s1kH.forwardRef(function CompositeItem(props, forwardedRef) {
    var render = props.render, domProps = (0, $54Czb._)(props, [
        "render"
    ]);
    var renderElementProps = render && typeof render !== 'function' ? render.props : {};
    var _React_useContext = $5s1kH.useContext($ad76f2a8d85683d0$var$CompositeContext), activeIndex = _React_useContext.activeIndex, onNavigate = _React_useContext.onNavigate;
    var _useListItem = $ad76f2a8d85683d0$export$dcdc7ff5149f7d1a(), ref = _useListItem.ref, index = _useListItem.index;
    var mergedRef = $ad76f2a8d85683d0$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    var isActive = activeIndex === index;
    var computedProps = (0, $lf4fc._)((0, $hwO3w._)({}, domProps, renderElementProps), {
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus: function(e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    });
    return $ad76f2a8d85683d0$var$renderJsx(render, computedProps);
});
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
var $ad76f2a8d85683d0$var$SafeReact = (0, $hwO3w._)({}, $5s1kH);
var $ad76f2a8d85683d0$var$serverHandoffComplete = false;
var $ad76f2a8d85683d0$var$count = 0;
var $ad76f2a8d85683d0$var$genId = function() {
    return(// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $ad76f2a8d85683d0$var$count++);
};
function $ad76f2a8d85683d0$var$useFloatingId() {
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(function() {
        return $ad76f2a8d85683d0$var$serverHandoffComplete ? $ad76f2a8d85683d0$var$genId() : undefined;
    }), 2), id = _React_useState[0], setId = _React_useState[1];
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (id == null) setId($ad76f2a8d85683d0$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $5s1kH.useEffect(function() {
        $ad76f2a8d85683d0$var$serverHandoffComplete = true;
    }, []);
    return id;
}
var $ad76f2a8d85683d0$var$useReactId = $ad76f2a8d85683d0$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ var $ad76f2a8d85683d0$export$f680877a34711e37 = $ad76f2a8d85683d0$var$useReactId || $ad76f2a8d85683d0$var$useFloatingId;
var $ad76f2a8d85683d0$var$devMessageSet;
function $ad76f2a8d85683d0$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    var message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $ad76f2a8d85683d0$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $ad76f2a8d85683d0$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $ad76f2a8d85683d0$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    var message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $ad76f2a8d85683d0$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $ad76f2a8d85683d0$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ var $ad76f2a8d85683d0$export$33511391554732bc = /*#__PURE__*/ $5s1kH.forwardRef(function FloatingArrow(props, ref) {
    var _props_context = props.context, placement = _props_context.placement, floating = _props_context.elements.floating, _props_context_middlewareData = _props_context.middlewareData, arrow = _props_context_middlewareData.arrow, shift = _props_context_middlewareData.shift, _props_width = props.width, width = _props_width === void 0 ? 14 : _props_width, _props_height = props.height, height = _props_height === void 0 ? 7 : _props_height, _props_tipRadius = props.tipRadius, tipRadius = _props_tipRadius === void 0 ? 0 : _props_tipRadius, _props_strokeWidth = props.strokeWidth, strokeWidth = _props_strokeWidth === void 0 ? 0 : _props_strokeWidth, staticOffset = props.staticOffset, stroke = props.stroke, d = props.d, tmp = props.style, transform = (tmp === void 0 ? {} : tmp).transform, restStyle = (0, $54Czb._)(props.style, [
        "transform"
    ]), rest = (0, $54Czb._)(props, [
        "context",
        "width",
        "height",
        "tipRadius",
        "strokeWidth",
        "staticOffset",
        "stroke",
        "d",
        "style"
    ]);
    var clipPathId = $ad76f2a8d85683d0$export$f680877a34711e37();
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(false), 2), isRTL = _React_useState[0], setIsRTL = _React_useState[1];
    // https://github.com/floating-ui/floating-ui/issues/2932
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (!floating) return;
        var isRTL = (0, $2a4197d9582b0915$export$3735103072e4a80)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    var _placement_split = (0, $6iP9u._)(placement.split('-'), 2), side = _placement_split[0], alignment = _placement_split[1];
    var isVerticalSide = side === 'top' || side === 'bottom';
    var computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    var computedStrokeWidth = strokeWidth * 2;
    var halfStrokeWidth = computedStrokeWidth / 2;
    var svgX = width / 2 * (tipRadius / -8 + 1);
    var svgY = height / 2 * tipRadius / 4;
    var isCustomShape = !!d;
    var yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    var xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    var arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    var arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    var dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    var rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    var _obj;
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("svg", (0, $lf4fc._)((0, $hwO3w._)({}, rest), {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: (0, $hwO3w._)((_obj = {
            position: 'absolute',
            pointerEvents: 'none'
        }, (0, $dUlz9._)(_obj, xOffsetProp, arrowX), (0, $dUlz9._)(_obj, yOffsetProp, arrowY), (0, $dUlz9._)(_obj, side, isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)"), (0, $dUlz9._)(_obj, "transform", [
            rotation,
            transform
        ].filter(function(t) {
            return !!t;
        }).join(' ')), _obj), restStyle),
        children: [
            computedStrokeWidth > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                clipPath: "url(#" + clipPathId + ")",
                fill: "none",
                stroke: stroke,
                strokeWidth: computedStrokeWidth + (d ? 0 : 1),
                d: dValue
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("path", {
                stroke: computedStrokeWidth && !d ? rest.fill : 'none',
                d: dValue
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("clipPath", {
                id: clipPathId,
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("rect", {
                    x: -halfStrokeWidth,
                    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
                    width: width + computedStrokeWidth,
                    height: width
                })
            })
        ]
    }));
});
function $ad76f2a8d85683d0$var$createEventEmitter() {
    var map = new Map();
    return {
        emit: function(event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach(function(listener) {
                return listener(data);
            });
        },
        on: function(event, listener) {
            if (!map.has(event)) map.set(event, new Set());
            map.get(event).add(listener);
        },
        off: function(event, listener) {
            var _map$get2;
            (_map$get2 = map.get(event)) == null || _map$get2.delete(listener);
        }
    };
}
var $ad76f2a8d85683d0$var$FloatingNodeContext = /*#__PURE__*/ $5s1kH.createContext(null);
var $ad76f2a8d85683d0$var$FloatingTreeContext = /*#__PURE__*/ $5s1kH.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ var $ad76f2a8d85683d0$export$165209eae06d3488 = function() {
    var _React$useContext;
    return ((_React$useContext = $5s1kH.useContext($ad76f2a8d85683d0$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ var $ad76f2a8d85683d0$export$db0c2a7c7a2a4f69 = function() {
    return $5s1kH.useContext($ad76f2a8d85683d0$var$FloatingTreeContext);
};
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $ad76f2a8d85683d0$export$9b136e0e758a42f4(customParentId) {
    var id = $ad76f2a8d85683d0$export$f680877a34711e37();
    var tree = $ad76f2a8d85683d0$export$db0c2a7c7a2a4f69();
    var reactParentId = $ad76f2a8d85683d0$export$165209eae06d3488();
    var parentId = customParentId || reactParentId;
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (!id) return;
        var node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return function() {
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $ad76f2a8d85683d0$export$ca00a83b5b253862(props) {
    var children = props.children, id = props.id;
    var parentId = $ad76f2a8d85683d0$export$165209eae06d3488();
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($ad76f2a8d85683d0$var$FloatingNodeContext.Provider, {
        value: $5s1kH.useMemo(function() {
            return {
                id: id,
                parentId: parentId
            };
        }, [
            id,
            parentId
        ]),
        children: children
    });
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $ad76f2a8d85683d0$export$587b60129641c4c8(props) {
    var children = props.children;
    var nodesRef = $5s1kH.useRef([]);
    var addNode = $5s1kH.useCallback(function(node) {
        nodesRef.current = (0, $XnYkK._)(nodesRef.current).concat([
            node
        ]);
    }, []);
    var removeNode = $5s1kH.useCallback(function(node) {
        nodesRef.current = nodesRef.current.filter(function(n) {
            return n !== node;
        });
    }, []);
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(function() {
        return $ad76f2a8d85683d0$var$createEventEmitter();
    }), 1), events = _React_useState[0];
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($ad76f2a8d85683d0$var$FloatingTreeContext.Provider, {
        value: $5s1kH.useMemo(function() {
            return {
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            };
        }, [
            addNode,
            removeNode,
            events
        ]),
        children: children
    });
}
function $ad76f2a8d85683d0$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutRef) {
    if (timeoutRef.current !== -1) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = -1;
    }
}
var $ad76f2a8d85683d0$var$safePolygonIdentifier = /*#__PURE__*/ $ad76f2a8d85683d0$var$createAttribute('safe-polygon');
function $ad76f2a8d85683d0$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $72ad0bd1c5aa7773$export$81cf264172d31e51)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    if (typeof value === 'function') {
        var result = value();
        if (typeof result === 'number') return result;
        return result == null ? void 0 : result[prop];
    }
    return value == null ? void 0 : value[prop];
}
function $ad76f2a8d85683d0$var$getRestMs(value) {
    if (typeof value === 'function') return value();
    return value;
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $ad76f2a8d85683d0$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    var open = context.open, onOpenChange = context.onOpenChange, dataRef = context.dataRef, events = context.events, elements = context.elements;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_delay = props.delay, delay = _props_delay === void 0 ? 0 : _props_delay, _props_handleClose = props.handleClose, handleClose = _props_handleClose === void 0 ? null : _props_handleClose, _props_mouseOnly = props.mouseOnly, mouseOnly = _props_mouseOnly === void 0 ? false : _props_mouseOnly, _props_restMs = props.restMs, restMs = _props_restMs === void 0 ? 0 : _props_restMs, _props_move = props.move, move = _props_move === void 0 ? true : _props_move;
    var tree = $ad76f2a8d85683d0$export$db0c2a7c7a2a4f69();
    var parentId = $ad76f2a8d85683d0$export$165209eae06d3488();
    var handleCloseRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(handleClose);
    var delayRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(delay);
    var openRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(open);
    var restMsRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(restMs);
    var pointerTypeRef = $5s1kH.useRef();
    var timeoutRef = $5s1kH.useRef(-1);
    var handlerRef = $5s1kH.useRef();
    var restTimeoutRef = $5s1kH.useRef(-1);
    var blockMouseMoveRef = $5s1kH.useRef(true);
    var performedPointerEventsMutationRef = $5s1kH.useRef(false);
    var unbindMouseMoveRef = $5s1kH.useRef(function() {});
    var restTimeoutPendingRef = $5s1kH.useRef(false);
    var isHoverOpen = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function() {
        var _dataRef$current$open;
        var type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    });
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $5s1kH.useEffect(function() {
        if (!enabled) return;
        function onOpenChange(_ref) {
            var open = _ref.open;
            if (!open) {
                $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutRef);
                $ad76f2a8d85683d0$var$clearTimeoutIfSet(restTimeoutRef);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return function() {
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $5s1kH.useEffect(function() {
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        var html = (0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return function() {
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    var closeWithDelay = $5s1kH.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        var closeDelay = $ad76f2a8d85683d0$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutRef);
            timeoutRef.current = window.setTimeout(function() {
                return onOpenChange(false, event, reason);
            }, closeDelay);
        } else if (runElseBranch) {
            $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutRef);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    var cleanupMouseMoveHandler = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function() {
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    var clearPointerEvents = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function() {
        if (performedPointerEventsMutationRef.current) {
            var body = (0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($ad76f2a8d85683d0$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    var isClickLikeOpenEvent = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function() {
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $5s1kH.useEffect(function() {
        if (!enabled) return;
        function onReferenceMouseEnter(event) {
            $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutRef);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $72ad0bd1c5aa7773$export$81cf264172d31e51)(pointerTypeRef.current) || $ad76f2a8d85683d0$var$getRestMs(restMsRef.current) > 0 && !$ad76f2a8d85683d0$var$getDelay(delayRef.current, 'open')) return;
            var openDelay = $ad76f2a8d85683d0$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(function() {
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onReferenceMouseLeave(event) {
            if (isClickLikeOpenEvent()) {
                clearPointerEvents();
                return;
            }
            unbindMouseMoveRef.current();
            var doc = (0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(elements.floating);
            $ad76f2a8d85683d0$var$clearTimeoutIfSet(restTimeoutRef);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutRef);
                handlerRef.current = handleCloseRef.current((0, $lf4fc._)((0, $hwO3w._)({}, dataRef.current.floatingContext), {
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose: function() {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                }));
                var handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = function() {
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            var shouldClose = pointerTypeRef.current === 'touch' ? !(0, $72ad0bd1c5aa7773$export$2344b14b097df817)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current((0, $lf4fc._)((0, $hwO3w._)({}, dataRef.current.floatingContext), {
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose: function() {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            }))(event);
        }
        function onFloatingMouseEnter() {
            $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutRef);
        }
        function onFloatingMouseLeave(event) {
            if (!isClickLikeOpenEvent()) closeWithDelay(event, false);
        }
        if ((0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(elements.domReference)) {
            var reference = elements.domReference;
            var floating = elements.floating;
            if (open) reference.addEventListener('mouseleave', onScrollMouseLeave);
            if (move) reference.addEventListener('mousemove', onReferenceMouseEnter, {
                once: true
            });
            reference.addEventListener('mouseenter', onReferenceMouseEnter);
            reference.addEventListener('mouseleave', onReferenceMouseLeave);
            if (floating) {
                floating.addEventListener('mouseleave', onScrollMouseLeave);
                floating.addEventListener('mouseenter', onFloatingMouseEnter);
                floating.addEventListener('mouseleave', onFloatingMouseLeave);
            }
            return function() {
                if (open) reference.removeEventListener('mouseleave', onScrollMouseLeave);
                if (move) reference.removeEventListener('mousemove', onReferenceMouseEnter);
                reference.removeEventListener('mouseenter', onReferenceMouseEnter);
                reference.removeEventListener('mouseleave', onReferenceMouseLeave);
                if (floating) {
                    floating.removeEventListener('mouseleave', onScrollMouseLeave);
                    floating.removeEventListener('mouseenter', onFloatingMouseEnter);
                    floating.removeEventListener('mouseleave', onFloatingMouseLeave);
                }
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent,
        restMsRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && (_handleCloseRef$curre = _handleCloseRef$curre.__options) != null && _handleCloseRef$curre.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            var floatingEl = elements.floating;
            if ((0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                var body = (0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(elements.floating).body;
                body.setAttribute($ad76f2a8d85683d0$var$safePolygonIdentifier, '');
                var ref = elements.domReference;
                var parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find(function(node) {
                    return node.id === parentId;
                })) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return function() {
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $5s1kH.useEffect(function() {
        return function() {
            cleanupMouseMoveHandler();
            $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutRef);
            $ad76f2a8d85683d0$var$clearTimeoutIfSet(restTimeoutRef);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    var reference = $5s1kH.useMemo(function() {
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove: function(event) {
                var nativeEvent = event.nativeEvent;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $72ad0bd1c5aa7773$export$81cf264172d31e51)(pointerTypeRef.current)) return;
                if (open || $ad76f2a8d85683d0$var$getRestMs(restMsRef.current) === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && Math.pow(event.movementX, 2) + Math.pow(event.movementY, 2) < 2) return;
                $ad76f2a8d85683d0$var$clearTimeoutIfSet(restTimeoutRef);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, $ad76f2a8d85683d0$var$getRestMs(restMsRef.current));
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMsRef
    ]);
    return $5s1kH.useMemo(function() {
        return enabled ? {
            reference: reference
        } : {};
    }, [
        enabled,
        reference
    ]);
}
var $ad76f2a8d85683d0$var$NOOP = function() {};
var $ad76f2a8d85683d0$var$FloatingDelayGroupContext = /*#__PURE__*/ $5s1kH.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $ad76f2a8d85683d0$var$NOOP,
    setState: $ad76f2a8d85683d0$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ var $ad76f2a8d85683d0$export$e2411914b150383d = function() {
    return $5s1kH.useContext($ad76f2a8d85683d0$var$FloatingDelayGroupContext);
};
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $ad76f2a8d85683d0$export$718279509ff1e241(props) {
    var children = props.children, delay = props.delay, _props_timeoutMs = props.timeoutMs, timeoutMs = _props_timeoutMs === void 0 ? 0 : _props_timeoutMs;
    var _React_useReducer = (0, $6iP9u._)($5s1kH.useReducer(function(prev, next) {
        return (0, $hwO3w._)({}, prev, next);
    }, {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    }), 2), state = _React_useReducer[0], setState = _React_useReducer[1];
    var initialCurrentIdRef = $5s1kH.useRef(null);
    var setCurrentId = $5s1kH.useCallback(function(currentId) {
        setState({
            currentId: currentId
        });
    }, []);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($ad76f2a8d85683d0$var$FloatingDelayGroupContext.Provider, {
        value: $5s1kH.useMemo(function() {
            return (0, $lf4fc._)((0, $hwO3w._)({}, state), {
                setState: setState,
                setCurrentId: setCurrentId
            });
        }, [
            state,
            setCurrentId
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $ad76f2a8d85683d0$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    var open = context.open, onOpenChange = context.onOpenChange, floatingId = context.floatingId;
    var optionId = options.id, _options_enabled = options.enabled, enabled = _options_enabled === void 0 ? true : _options_enabled;
    var id = optionId != null ? optionId : floatingId;
    var groupContext = $ad76f2a8d85683d0$export$e2411914b150383d();
    var currentId = groupContext.currentId, setCurrentId = groupContext.setCurrentId, initialDelay = groupContext.initialDelay, setState = groupContext.setState, timeoutMs = groupContext.timeoutMs;
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $ad76f2a8d85683d0$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                var timeout = window.setTimeout(unset, timeoutMs);
                return function() {
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (!enabled) return;
        if (setCurrentId === $ad76f2a8d85683d0$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
var $ad76f2a8d85683d0$var$NextFloatingDelayGroupContext = /*#__PURE__*/ $5s1kH.createContext({
    hasProvider: false,
    timeoutMs: 0,
    delayRef: {
        current: 0
    },
    initialDelayRef: {
        current: 0
    },
    timeoutIdRef: {
        current: -1
    },
    currentIdRef: {
        current: null
    },
    currentContextRef: {
        current: null
    }
});
/**
 * Experimental next version of `FloatingDelayGroup` to become the default
 * in the future. This component is not yet stable.
 * Provides context for a group of floating elements that should share a
 * `delay`. Unlike `FloatingDelayGroup`, `useNextDelayGroup` with this
 * component does not cause a re-render of unrelated consumers of the
 * context when the delay changes.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $ad76f2a8d85683d0$export$e766ee16075bdf6b(props) {
    var children = props.children, delay = props.delay, _props_timeoutMs = props.timeoutMs, timeoutMs = _props_timeoutMs === void 0 ? 0 : _props_timeoutMs;
    var delayRef = $5s1kH.useRef(delay);
    var initialDelayRef = $5s1kH.useRef(delay);
    var currentIdRef = $5s1kH.useRef(null);
    var currentContextRef = $5s1kH.useRef(null);
    var timeoutIdRef = $5s1kH.useRef(-1);
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($ad76f2a8d85683d0$var$NextFloatingDelayGroupContext.Provider, {
        value: $5s1kH.useMemo(function() {
            return {
                hasProvider: true,
                delayRef: delayRef,
                initialDelayRef: initialDelayRef,
                currentIdRef: currentIdRef,
                timeoutMs: timeoutMs,
                currentContextRef: currentContextRef,
                timeoutIdRef: timeoutIdRef
            };
        }, [
            timeoutMs
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `NextFloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $ad76f2a8d85683d0$export$f86f270cee1e809c(context, options) {
    if (options === void 0) options = {};
    var open = context.open, onOpenChange = context.onOpenChange, floatingId = context.floatingId;
    var _options_enabled = options.enabled, enabled = _options_enabled === void 0 ? true : _options_enabled;
    var groupContext = $5s1kH.useContext($ad76f2a8d85683d0$var$NextFloatingDelayGroupContext);
    var currentIdRef = groupContext.currentIdRef, delayRef = groupContext.delayRef, timeoutMs = groupContext.timeoutMs, initialDelayRef = groupContext.initialDelayRef, currentContextRef = groupContext.currentContextRef, hasProvider = groupContext.hasProvider, timeoutIdRef = groupContext.timeoutIdRef;
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(false), 2), isInstantPhase = _React_useState[0], setIsInstantPhase = _React_useState[1];
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        function unset() {
            var _currentContextRef$cu;
            setIsInstantPhase(false);
            (_currentContextRef$cu = currentContextRef.current) == null || _currentContextRef$cu.setIsInstantPhase(false);
            currentIdRef.current = null;
            currentContextRef.current = null;
            delayRef.current = initialDelayRef.current;
        }
        if (!enabled) return;
        if (!currentIdRef.current) return;
        if (!open && currentIdRef.current === floatingId) {
            setIsInstantPhase(false);
            if (timeoutMs) {
                timeoutIdRef.current = window.setTimeout(unset, timeoutMs);
                return function() {
                    clearTimeout(timeoutIdRef.current);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        floatingId,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (!enabled) return;
        if (!open) return;
        var prevContext = currentContextRef.current;
        var prevId = currentIdRef.current;
        currentContextRef.current = {
            onOpenChange: onOpenChange,
            setIsInstantPhase: setIsInstantPhase
        };
        currentIdRef.current = floatingId;
        delayRef.current = {
            open: 0,
            close: $ad76f2a8d85683d0$var$getDelay(initialDelayRef.current, 'close')
        };
        if (prevId !== null && prevId !== floatingId) {
            $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutIdRef);
            setIsInstantPhase(true);
            prevContext == null || prevContext.setIsInstantPhase(true);
            prevContext == null || prevContext.onOpenChange(false);
        } else {
            setIsInstantPhase(false);
            prevContext == null || prevContext.setIsInstantPhase(false);
        }
    }, [
        enabled,
        open,
        floatingId,
        onOpenChange,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        return function() {
            currentContextRef.current = null;
        };
    }, [
        currentContextRef
    ]);
    return $5s1kH.useMemo(function() {
        return {
            hasProvider: hasProvider,
            delayRef: delayRef,
            isInstantPhase: isInstantPhase
        };
    }, [
        hasProvider,
        delayRef,
        isInstantPhase
    ]);
}
var $ad76f2a8d85683d0$var$rafId = 0;
function $ad76f2a8d85683d0$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    var _options_preventScroll = options.preventScroll, preventScroll = _options_preventScroll === void 0 ? false : _options_preventScroll, _options_cancelPrevious = options.cancelPrevious, cancelPrevious = _options_cancelPrevious === void 0 ? true : _options_cancelPrevious, _options_sync = options.sync, sync = _options_sync === void 0 ? false : _options_sync;
    cancelPrevious && cancelAnimationFrame($ad76f2a8d85683d0$var$rafId);
    var exec = function() {
        return el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    };
    if (sync) exec();
    else $ad76f2a8d85683d0$var$rafId = requestAnimationFrame(exec);
}
function $ad76f2a8d85683d0$var$contains(parent, child) {
    if (!parent || !child) return false;
    var rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $2a4197d9582b0915$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $ad76f2a8d85683d0$var$getTarget(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $ad76f2a8d85683d0$var$getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
var $ad76f2a8d85683d0$var$counters = {
    inert: /*#__PURE__*/ new WeakMap(),
    'aria-hidden': /*#__PURE__*/ new WeakMap(),
    none: /*#__PURE__*/ new WeakMap()
};
function $ad76f2a8d85683d0$var$getCounterMap(control) {
    if (control === 'inert') return $ad76f2a8d85683d0$var$counters.inert;
    if (control === 'aria-hidden') return $ad76f2a8d85683d0$var$counters['aria-hidden'];
    return $ad76f2a8d85683d0$var$counters.none;
}
var $ad76f2a8d85683d0$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
var $ad76f2a8d85683d0$var$markerMap = {};
var $ad76f2a8d85683d0$var$lockCount$1 = 0;
var $ad76f2a8d85683d0$var$supportsInert = function() {
    return typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
};
function $ad76f2a8d85683d0$var$unwrapHost(node) {
    if (!node) return null;
    return (0, $2a4197d9582b0915$export$af51f0f06c0f328a)(node) ? node.host : $ad76f2a8d85683d0$var$unwrapHost(node.parentNode);
}
var $ad76f2a8d85683d0$var$correctElements = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $ad76f2a8d85683d0$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter(function(x) {
        return x != null;
    });
};
function $ad76f2a8d85683d0$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    var markerName = 'data-floating-ui-inert';
    var controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    var avoidElements = $ad76f2a8d85683d0$var$correctElements(body, uncorrectedAvoidElements);
    var elementsToKeep = new Set();
    var elementsToStop = new Set(avoidElements);
    var hiddenElements = [];
    if (!$ad76f2a8d85683d0$var$markerMap[markerName]) $ad76f2a8d85683d0$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $ad76f2a8d85683d0$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, function(node) {
            if ((0, $2a4197d9582b0915$export$651544f548703224)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterMap = $ad76f2a8d85683d0$var$getCounterMap(controlAttribute);
                var counterValue = (counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $ad76f2a8d85683d0$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, controlAttribute === 'inert' ? '' : 'true');
            }
        });
    }
    $ad76f2a8d85683d0$var$lockCount$1++;
    return function() {
        hiddenElements.forEach(function(element) {
            var counterMap = $ad76f2a8d85683d0$var$getCounterMap(controlAttribute);
            var currentCounterValue = counterMap.get(element) || 0;
            var counterValue = currentCounterValue - 1;
            var markerValue = (markerCounter.get(element) || 0) - 1;
            counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$ad76f2a8d85683d0$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $ad76f2a8d85683d0$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $ad76f2a8d85683d0$var$lockCount$1--;
        if (!$ad76f2a8d85683d0$var$lockCount$1) {
            $ad76f2a8d85683d0$var$counters.inert = new WeakMap();
            $ad76f2a8d85683d0$var$counters['aria-hidden'] = new WeakMap();
            $ad76f2a8d85683d0$var$counters.none = new WeakMap();
            $ad76f2a8d85683d0$var$uncontrolledElementsSet = new WeakSet();
            $ad76f2a8d85683d0$var$markerMap = {};
        }
    };
}
function $ad76f2a8d85683d0$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    var body = $ad76f2a8d85683d0$var$getDocument(avoidElements[0]).body;
    return $ad76f2a8d85683d0$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live],[role="status"],output'))), body, ariaHidden, inert);
}
var $ad76f2a8d85683d0$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
var $ad76f2a8d85683d0$var$FocusGuard = /*#__PURE__*/ $5s1kH.forwardRef(function FocusGuard(props, ref) {
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(), 2), role = _React_useState[0], setRole = _React_useState[1];
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if ((0, $72ad0bd1c5aa7773$export$95df08bae54cb4df)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
    }, []);
    var _obj;
    var restProps = (_obj = {
        ref: ref,
        tabIndex: 0,
        // Role is only for VoiceOver
        role: role,
        'aria-hidden': role ? undefined : true
    }, (0, $dUlz9._)(_obj, $ad76f2a8d85683d0$var$createAttribute('focus-guard'), ''), (0, $dUlz9._)(_obj, "style", $ad76f2a8d85683d0$var$HIDDEN_STYLES), _obj);
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", (0, $hwO3w._)({}, props, restProps));
});
var $ad76f2a8d85683d0$var$HIDDEN_OWNER_STYLES = {
    clipPath: 'inset(50%)',
    position: 'fixed',
    top: 0,
    left: 0
};
var $ad76f2a8d85683d0$var$PortalContext = /*#__PURE__*/ $5s1kH.createContext(null);
var $ad76f2a8d85683d0$var$attr = /*#__PURE__*/ $ad76f2a8d85683d0$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $ad76f2a8d85683d0$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    var id = props.id, root = props.root;
    var uniqueId = $ad76f2a8d85683d0$export$f680877a34711e37();
    var portalContext = $ad76f2a8d85683d0$var$usePortalContext();
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(null), 2), portalNode = _React_useState[0], setPortalNode = _React_useState[1];
    var portalNodeRef = $5s1kH.useRef(null);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        return function() {
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(function() {
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        var existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        var subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($ad76f2a8d85683d0$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        var container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $2a4197d9582b0915$export$8ee0fc9ee280b4ee)(container)) container = container.current;
        container = container || document.body;
        var idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        var subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($ad76f2a8d85683d0$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $ad76f2a8d85683d0$export$31fa5d718fa2ac09(props) {
    var children = props.children, id = props.id, root = props.root, _props_preserveTabOrder = props.preserveTabOrder, preserveTabOrder = _props_preserveTabOrder === void 0 ? true : _props_preserveTabOrder;
    var portalNode = $ad76f2a8d85683d0$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(null), 2), focusManagerState = _React_useState[0], setFocusManagerState = _React_useState[1];
    var beforeOutsideRef = $5s1kH.useRef(null);
    var afterOutsideRef = $5s1kH.useRef(null);
    var beforeInsideRef = $5s1kH.useRef(null);
    var afterInsideRef = $5s1kH.useRef(null);
    var modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    var open = focusManagerState == null ? void 0 : focusManagerState.open;
    var shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $5s1kH.useEffect(function() {
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && (0, $72ad0bd1c5aa7773$export$6e0c4e272f3faa2)(event)) {
                var focusing = event.type === 'focusin';
                var manageFocus = focusing ? (0, $72ad0bd1c5aa7773$export$a65f4028abb17f36) : (0, $72ad0bd1c5aa7773$export$3995dd353b80da11);
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return function() {
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $5s1kH.useEffect(function() {
        if (!portalNode) return;
        if (open) return;
        (0, $72ad0bd1c5aa7773$export$a65f4028abb17f36)(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)($ad76f2a8d85683d0$var$PortalContext.Provider, {
        value: $5s1kH.useMemo(function() {
            return {
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            };
        }, [
            preserveTabOrder,
            portalNode
        ]),
        children: [
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($ad76f2a8d85683d0$var$FocusGuard, {
                "data-type": "outside",
                ref: beforeOutsideRef,
                onFocus: function(event) {
                    if ((0, $72ad0bd1c5aa7773$export$6e0c4e272f3faa2)(event, portalNode)) {
                        var _beforeInsideRef$curr;
                        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
                    } else {
                        var domReference = focusManagerState ? focusManagerState.domReference : null;
                        var prevTabbable = (0, $72ad0bd1c5aa7773$export$2e5518c3303f364a)(domReference);
                        prevTabbable == null || prevTabbable.focus();
                    }
                }
            }),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                "aria-owns": portalNode.id,
                style: $ad76f2a8d85683d0$var$HIDDEN_OWNER_STYLES
            }),
            portalNode && /*#__PURE__*/ $eAxYl.createPortal(children, portalNode),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($ad76f2a8d85683d0$var$FocusGuard, {
                "data-type": "outside",
                ref: afterOutsideRef,
                onFocus: function(event) {
                    if ((0, $72ad0bd1c5aa7773$export$6e0c4e272f3faa2)(event, portalNode)) {
                        var _afterInsideRef$curre;
                        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
                    } else {
                        var domReference = focusManagerState ? focusManagerState.domReference : null;
                        var nextTabbable = (0, $72ad0bd1c5aa7773$export$28f33206776129a7)(domReference);
                        nextTabbable == null || nextTabbable.focus();
                        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
                    }
                }
            })
        ]
    });
}
var $ad76f2a8d85683d0$var$usePortalContext = function() {
    return $5s1kH.useContext($ad76f2a8d85683d0$var$PortalContext);
};
function $ad76f2a8d85683d0$var$useLiteMergeRefs(refs) {
    return $5s1kH.useMemo(function() {
        return function(value) {
            refs.forEach(function(ref) {
                if (ref) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
var $ad76f2a8d85683d0$var$LIST_LIMIT = 20;
var $ad76f2a8d85683d0$var$previouslyFocusedElements = [];
function $ad76f2a8d85683d0$var$clearDisconnectedPreviouslyFocusedElements() {
    $ad76f2a8d85683d0$var$previouslyFocusedElements = $ad76f2a8d85683d0$var$previouslyFocusedElements.filter(function(elementRef) {
        var _elementRef$deref;
        return (_elementRef$deref = elementRef.deref()) == null ? void 0 : _elementRef$deref.isConnected;
    });
}
function $ad76f2a8d85683d0$var$addPreviouslyFocusedElement(element) {
    $ad76f2a8d85683d0$var$clearDisconnectedPreviouslyFocusedElements();
    if (element && (0, $2a4197d9582b0915$export$651544f548703224)(element) !== 'body') {
        $ad76f2a8d85683d0$var$previouslyFocusedElements.push(new WeakRef(element));
        if ($ad76f2a8d85683d0$var$previouslyFocusedElements.length > $ad76f2a8d85683d0$var$LIST_LIMIT) $ad76f2a8d85683d0$var$previouslyFocusedElements = $ad76f2a8d85683d0$var$previouslyFocusedElements.slice(-$ad76f2a8d85683d0$var$LIST_LIMIT);
    }
}
function $ad76f2a8d85683d0$var$getPreviouslyFocusedElement() {
    $ad76f2a8d85683d0$var$clearDisconnectedPreviouslyFocusedElements();
    var elementRef = $ad76f2a8d85683d0$var$previouslyFocusedElements[$ad76f2a8d85683d0$var$previouslyFocusedElements.length - 1];
    return elementRef == null ? void 0 : elementRef.deref();
}
function $ad76f2a8d85683d0$var$getFirstTabbableElement(container) {
    var tabbableOptions = (0, $72ad0bd1c5aa7773$export$6324a2bbae6a332f)();
    if ((0, $190ee81742d340f0$export$bebd5a1431fec25d)(container, tabbableOptions)) return container;
    return (0, $190ee81742d340f0$export$17100aea90429aa7)(container, tabbableOptions)[0] || container;
}
function $ad76f2a8d85683d0$var$handleTabIndex(floatingFocusElement, orderRef) {
    var _floatingFocusElement;
    if (!orderRef.current.includes('floating') && !((_floatingFocusElement = floatingFocusElement.getAttribute('role')) != null && _floatingFocusElement.includes('dialog'))) return;
    var options = (0, $72ad0bd1c5aa7773$export$6324a2bbae6a332f)();
    var focusableElements = (0, $190ee81742d340f0$export$ecc6d1fcdff4f700)(floatingFocusElement, options);
    var tabbableContent = focusableElements.filter(function(element) {
        var dataTabIndex = element.getAttribute('data-tabindex') || '';
        return (0, $190ee81742d340f0$export$bebd5a1431fec25d)(element, options) || element.hasAttribute('data-tabindex') && !dataTabIndex.startsWith('-');
    });
    var tabIndex = floatingFocusElement.getAttribute('tabindex');
    if (orderRef.current.includes('floating') || tabbableContent.length === 0) {
        if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
    } else if (tabIndex !== '-1' || floatingFocusElement.hasAttribute('data-tabindex') && floatingFocusElement.getAttribute('data-tabindex') !== '-1') {
        floatingFocusElement.setAttribute('tabindex', '-1');
        floatingFocusElement.setAttribute('data-tabindex', '-1');
    }
}
var $ad76f2a8d85683d0$var$VisuallyHiddenDismiss = /*#__PURE__*/ $5s1kH.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("button", (0, $lf4fc._)((0, $hwO3w._)({}, props), {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $ad76f2a8d85683d0$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $ad76f2a8d85683d0$export$8aeee49171ded61a(props) {
    var context = props.context, children = props.children, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_order = props.order, order = _props_order === void 0 ? [
        'content'
    ] : _props_order, tmp = props.guards, _guards = tmp === void 0 ? true : tmp, _props_initialFocus = props.initialFocus, initialFocus = _props_initialFocus === void 0 ? 0 : _props_initialFocus, _props_returnFocus = props.returnFocus, returnFocus = _props_returnFocus === void 0 ? true : _props_returnFocus, _props_restoreFocus = props.restoreFocus, restoreFocus = _props_restoreFocus === void 0 ? false : _props_restoreFocus, _props_modal = props.modal, modal = _props_modal === void 0 ? true : _props_modal, _props_visuallyHiddenDismiss = props.visuallyHiddenDismiss, visuallyHiddenDismiss = _props_visuallyHiddenDismiss === void 0 ? false : _props_visuallyHiddenDismiss, _props_closeOnFocusOut = props.closeOnFocusOut, closeOnFocusOut = _props_closeOnFocusOut === void 0 ? true : _props_closeOnFocusOut, _props_outsideElementsInert = props.outsideElementsInert, outsideElementsInert = _props_outsideElementsInert === void 0 ? false : _props_outsideElementsInert, tmp1 = props.getInsideElements, _getInsideElements = tmp1 === void 0 ? function() {
        return [];
    } : tmp1;
    var open = context.open, onOpenChange = context.onOpenChange, events = context.events, dataRef = context.dataRef, _context_elements = context.elements, domReference = _context_elements.domReference, floating = _context_elements.floating;
    var getNodeId = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function() {
        var _dataRef$current$floa;
        return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    });
    var getInsideElements = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(_getInsideElements);
    var ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    var isUntrappedTypeableCombobox = (0, $72ad0bd1c5aa7773$export$259ba5ae38188551)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    var inertSupported = $ad76f2a8d85683d0$var$supportsInert();
    var guards = inertSupported ? _guards : true;
    var useInert = !guards || inertSupported && outsideElementsInert;
    var orderRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(order);
    var initialFocusRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(initialFocus);
    var returnFocusRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(returnFocus);
    var tree = $ad76f2a8d85683d0$export$db0c2a7c7a2a4f69();
    var portalContext = $ad76f2a8d85683d0$var$usePortalContext();
    var startDismissButtonRef = $5s1kH.useRef(null);
    var endDismissButtonRef = $5s1kH.useRef(null);
    var preventReturnFocusRef = $5s1kH.useRef(false);
    var isPointerDownRef = $5s1kH.useRef(false);
    var tabbableIndexRef = $5s1kH.useRef(-1);
    var blurTimeoutRef = $5s1kH.useRef(-1);
    var isInsidePortal = portalContext != null;
    var floatingFocusElement = (0, $72ad0bd1c5aa7773$export$9b0901b5e9b45fc7)(floating);
    var getTabbableContent = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $190ee81742d340f0$export$17100aea90429aa7)(container, (0, $72ad0bd1c5aa7773$export$6324a2bbae6a332f)()) : [];
    });
    var getTabbableElements = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function(container) {
        var content = getTabbableContent(container);
        return orderRef.current.map(function(type) {
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $5s1kH.useEffect(function() {
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $72ad0bd1c5aa7773$export$2344b14b097df817)(floatingFocusElement, (0, $72ad0bd1c5aa7773$export$da980962bd2147a4)((0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050)(event);
                var els = getTabbableElements();
                var target = (0, $72ad0bd1c5aa7773$export$c22522a4dfa48e9c)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050)(event);
                    if (event.shiftKey) $ad76f2a8d85683d0$var$enqueueFocus(els[els.length - 1]);
                    else $ad76f2a8d85683d0$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050)(event);
                    $ad76f2a8d85683d0$var$enqueueFocus(els[0]);
                }
            }
        }
        var doc = (0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return function() {
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $5s1kH.useEffect(function() {
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            var target = (0, $72ad0bd1c5aa7773$export$c22522a4dfa48e9c)(event);
            var tabbableContent = getTabbableContent();
            var tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return function() {
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $5s1kH.useEffect(function() {
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(function() {
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            var relatedTarget = event.relatedTarget;
            var currentTarget = event.currentTarget;
            var target = (0, $72ad0bd1c5aa7773$export$c22522a4dfa48e9c)(event);
            queueMicrotask(function() {
                var nodeId = getNodeId();
                var movedToUnrelatedNode = !((0, $72ad0bd1c5aa7773$export$2344b14b097df817)(domReference, relatedTarget) || (0, $72ad0bd1c5aa7773$export$2344b14b097df817)(floating, relatedTarget) || (0, $72ad0bd1c5aa7773$export$2344b14b097df817)(relatedTarget, floating) || (0, $72ad0bd1c5aa7773$export$2344b14b097df817)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($ad76f2a8d85683d0$var$createAttribute('focus-guard')) || tree && ((0, $72ad0bd1c5aa7773$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId).find(function(node) {
                    var _node$context, _node$context2;
                    return (0, $72ad0bd1c5aa7773$export$2344b14b097df817)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $72ad0bd1c5aa7773$export$2344b14b097df817)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || (0, $72ad0bd1c5aa7773$export$5d8eb345316b65c0)(tree.nodesRef.current, nodeId).find(function(node) {
                    var _node$context3, _node$context4, _node$context5;
                    return [
                        (_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating,
                        (0, $72ad0bd1c5aa7773$export$9b0901b5e9b45fc7)((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)
                    ].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
                })));
                if (currentTarget === domReference && floatingFocusElement) $ad76f2a8d85683d0$var$handleTabIndex(floatingFocusElement, orderRef);
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && currentTarget !== domReference && !(target != null && target.isConnected) && (0, $72ad0bd1c5aa7773$export$da980962bd2147a4)((0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(floatingFocusElement)) === (0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(floatingFocusElement)) floatingFocusElement.focus();
                    var prevTabbableIndex = tabbableIndexRef.current;
                    var tabbableContent = getTabbableContent();
                    var nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(nodeToFocus)) nodeToFocus.focus();
                }
                // https://github.com/floating-ui/floating-ui/issues/3060
                if (dataRef.current.insideReactTree) {
                    dataRef.current.insideReactTree = false;
                    return;
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $ad76f2a8d85683d0$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        var shouldHandleBlurCapture = Boolean(!tree && portalContext);
        function markInsideReactTree() {
            $ad76f2a8d85683d0$var$clearTimeoutIfSet(blurTimeoutRef);
            dataRef.current.insideReactTree = true;
            blurTimeoutRef.current = window.setTimeout(function() {
                dataRef.current.insideReactTree = false;
            });
        }
        if (floating && (0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            if (shouldHandleBlurCapture) floating.addEventListener('focusout', markInsideReactTree, true);
            return function() {
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
                if (shouldHandleBlurCapture) floating.removeEventListener('focusout', markInsideReactTree, true);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox,
        getNodeId,
        orderRef,
        dataRef
    ]);
    var beforeGuardRef = $5s1kH.useRef(null);
    var afterGuardRef = $5s1kH.useRef(null);
    var mergedBeforeGuardRef = $ad76f2a8d85683d0$var$useLiteMergeRefs([
        beforeGuardRef,
        portalContext == null ? void 0 : portalContext.beforeInsideRef
    ]);
    var mergedAfterGuardRef = $ad76f2a8d85683d0$var$useLiteMergeRefs([
        afterGuardRef,
        portalContext == null ? void 0 : portalContext.afterInsideRef
    ]);
    $5s1kH.useEffect(function() {
        var _portalContext$portal, _ancestors$find;
        if (disabled) return;
        if (!floating) return;
        // Don't hide portals nested within the parent portal.
        var portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $ad76f2a8d85683d0$var$createAttribute('portal') + "]")) || []);
        var ancestors = tree ? (0, $72ad0bd1c5aa7773$export$5d8eb345316b65c0)(tree.nodesRef.current, getNodeId()) : [];
        var rootAncestorComboboxDomReference = (_ancestors$find = ancestors.find(function(node) {
            var _node$context6;
            return (0, $72ad0bd1c5aa7773$export$259ba5ae38188551)(((_node$context6 = node.context) == null ? void 0 : _node$context6.elements.domReference) || null);
        })) == null || (_ancestors$find = _ancestors$find.context) == null ? void 0 : _ancestors$find.elements.domReference;
        var insideElements = [
            floating,
            rootAncestorComboboxDomReference
        ].concat((0, $XnYkK._)(portalNodes), (0, $XnYkK._)(getInsideElements()), [
            startDismissButtonRef.current,
            endDismissButtonRef.current,
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext == null ? void 0 : portalContext.beforeOutsideRef.current,
            portalContext == null ? void 0 : portalContext.afterOutsideRef.current,
            orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
        ]).filter(function(x) {
            return x != null;
        });
        var cleanup = modal || isUntrappedTypeableCombobox ? $ad76f2a8d85683d0$var$markOthers(insideElements, !useInert, useInert) : $ad76f2a8d85683d0$var$markOthers(insideElements);
        return function() {
            cleanup();
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards,
        useInert,
        tree,
        getNodeId,
        getInsideElements
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (disabled || !(0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(floatingFocusElement)) return;
        var doc = (0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(floatingFocusElement);
        var previouslyFocusedElement = (0, $72ad0bd1c5aa7773$export$da980962bd2147a4)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(function() {
            var focusableElements = getTabbableElements(floatingFocusElement);
            var initialFocusValue = initialFocusRef.current;
            var elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            var focusAlreadyInsideFloatingEl = (0, $72ad0bd1c5aa7773$export$2344b14b097df817)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $ad76f2a8d85683d0$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (disabled || !floatingFocusElement) return;
        var doc = (0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(floatingFocusElement);
        var previouslyFocusedElement = (0, $72ad0bd1c5aa7773$export$da980962bd2147a4)(doc);
        $ad76f2a8d85683d0$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            var reason = _ref.reason, event = _ref.event, nested = _ref.nested;
            if ([
                'hover',
                'safe-polygon'
            ].includes(reason) && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) preventReturnFocusRef.current = false;
            else if ((0, $72ad0bd1c5aa7773$export$60278871457622de)(event) || (0, $72ad0bd1c5aa7773$export$29bf1b5f2c56cf63)(event)) preventReturnFocusRef.current = false;
            else {
                var isPreventScrollSupported = false;
                document.createElement('div').focus({
                    get preventScroll () {
                        isPreventScrollSupported = true;
                        return false;
                    }
                });
                if (isPreventScrollSupported) preventReturnFocusRef.current = false;
                else preventReturnFocusRef.current = true;
            }
        }
        events.on('openchange', onOpenChange);
        var fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $ad76f2a8d85683d0$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') {
                var el = domReference || $ad76f2a8d85683d0$var$getPreviouslyFocusedElement();
                return el && el.isConnected ? el : fallbackEl;
            }
            return returnFocusRef.current.current || fallbackEl;
        }
        return function() {
            events.off('openchange', onOpenChange);
            var activeEl = (0, $72ad0bd1c5aa7773$export$da980962bd2147a4)(doc);
            var isFocusInsideFloatingTree = (0, $72ad0bd1c5aa7773$export$2344b14b097df817)(floating, activeEl) || tree && (0, $72ad0bd1c5aa7773$export$1f1998cc3c6b56fb)(tree.nodesRef.current, getNodeId(), false).some(function(node) {
                var _node$context7;
                return (0, $72ad0bd1c5aa7773$export$2344b14b097df817)((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
            });
            var returnElement = getReturnElement();
            queueMicrotask(function() {
                // This is `returnElement`, if it's tabbable, or its first tabbable child.
                var tabbableReturnElement = $ad76f2a8d85683d0$var$getFirstTabbableElement(returnElement);
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: true
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        events,
        tree,
        isInsidePortal,
        domReference,
        getNodeId
    ]);
    $5s1kH.useEffect(function() {
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(function() {
            preventReturnFocusRef.current = false;
        });
        return function() {
            queueMicrotask($ad76f2a8d85683d0$var$clearDisconnectedPreviouslyFocusedElements);
        };
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            domReference: domReference
        });
        return function() {
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        closeOnFocusOut,
        domReference
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (disabled) return;
        if (!floatingFocusElement) return;
        $ad76f2a8d85683d0$var$handleTabIndex(floatingFocusElement, orderRef);
    }, [
        disabled,
        floatingFocusElement,
        orderRef
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($ad76f2a8d85683d0$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: function(event) {
                return onOpenChange(false, event.nativeEvent);
            },
            children: typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss'
        });
    }
    var shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            shouldRenderGuards && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($ad76f2a8d85683d0$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedBeforeGuardRef,
                onFocus: function(event) {
                    if (modal) {
                        var els = getTabbableElements();
                        $ad76f2a8d85683d0$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
                    } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        preventReturnFocusRef.current = false;
                        if ((0, $72ad0bd1c5aa7773$export$6e0c4e272f3faa2)(event, portalContext.portalNode)) {
                            var nextTabbable = (0, $72ad0bd1c5aa7773$export$28f33206776129a7)(domReference);
                            nextTabbable == null || nextTabbable.focus();
                        } else {
                            var _portalContext$before;
                            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                        }
                    }
                }
            }),
            !isUntrappedTypeableCombobox && renderDismissButton('start'),
            children,
            renderDismissButton('end'),
            shouldRenderGuards && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($ad76f2a8d85683d0$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedAfterGuardRef,
                onFocus: function(event) {
                    if (modal) $ad76f2a8d85683d0$var$enqueueFocus(getTabbableElements()[0]);
                    else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        if (closeOnFocusOut) preventReturnFocusRef.current = true;
                        if ((0, $72ad0bd1c5aa7773$export$6e0c4e272f3faa2)(event, portalContext.portalNode)) {
                            var prevTabbable = (0, $72ad0bd1c5aa7773$export$2e5518c3303f364a)(domReference);
                            prevTabbable == null || prevTabbable.focus();
                        } else {
                            var _portalContext$afterO;
                            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                        }
                    }
                }
            })
        ]
    });
}
var $ad76f2a8d85683d0$var$lockCount = 0;
var $ad76f2a8d85683d0$var$scrollbarProperty = '--floating-ui-scrollbar-width';
function $ad76f2a8d85683d0$var$enableScrollLock() {
    var platform = (0, $72ad0bd1c5aa7773$export$867a782338812cb4)();
    var isIOS = /iP(hone|ad|od)|iOS/.test(platform) || // iPads can claim to be MacIntel
    platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    var bodyStyle = document.body.style;
    // RTL <body> scrollbar
    var scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    var paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    var scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    var scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    bodyStyle.setProperty($ad76f2a8d85683d0$var$scrollbarProperty, scrollbarWidth + "px");
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        var offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        var offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return function() {
        Object.assign(bodyStyle, (0, $dUlz9._)({
            overflow: ''
        }, paddingProp, ''));
        bodyStyle.removeProperty($ad76f2a8d85683d0$var$scrollbarProperty);
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
var $ad76f2a8d85683d0$var$cleanup = function() {};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ var $ad76f2a8d85683d0$export$a35954495955337b = /*#__PURE__*/ $5s1kH.forwardRef(function FloatingOverlay(props, ref) {
    var _props_lockScroll = props.lockScroll, lockScroll = _props_lockScroll === void 0 ? false : _props_lockScroll, rest = (0, $54Czb._)(props, [
        "lockScroll"
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (!lockScroll) return;
        $ad76f2a8d85683d0$var$lockCount++;
        if ($ad76f2a8d85683d0$var$lockCount === 1) $ad76f2a8d85683d0$var$cleanup = $ad76f2a8d85683d0$var$enableScrollLock();
        return function() {
            $ad76f2a8d85683d0$var$lockCount--;
            if ($ad76f2a8d85683d0$var$lockCount === 0) $ad76f2a8d85683d0$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", (0, $lf4fc._)((0, $hwO3w._)({
        ref: ref
    }, rest), {
        style: (0, $hwO3w._)({
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, rest.style)
    }));
});
function $ad76f2a8d85683d0$var$isButtonTarget(event) {
    return (0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'BUTTON';
}
function $ad76f2a8d85683d0$var$isAnchorTarget(event) {
    return (0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'A';
}
function $ad76f2a8d85683d0$var$isSpaceIgnored(element) {
    return (0, $72ad0bd1c5aa7773$export$42ad131c32f0fb8d)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $ad76f2a8d85683d0$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    var open = context.open, onOpenChange = context.onOpenChange, dataRef = context.dataRef, domReference = context.elements.domReference;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, tmp = props.event, eventOption = tmp === void 0 ? 'click' : tmp, _props_toggle = props.toggle, toggle = _props_toggle === void 0 ? true : _props_toggle, _props_ignoreMouse = props.ignoreMouse, ignoreMouse = _props_ignoreMouse === void 0 ? false : _props_ignoreMouse, _props_keyboardHandlers = props.keyboardHandlers, keyboardHandlers = _props_keyboardHandlers === void 0 ? true : _props_keyboardHandlers, _props_stickIfOpen = props.stickIfOpen, stickIfOpen = _props_stickIfOpen === void 0 ? true : _props_stickIfOpen;
    var pointerTypeRef = $5s1kH.useRef();
    var didKeyDownRef = $5s1kH.useRef(false);
    var reference = $5s1kH.useMemo(function() {
        return {
            onPointerDown: function(event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown: function(event) {
                var pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $72ad0bd1c5aa7773$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick: function(event) {
                var pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $72ad0bd1c5aa7773$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown: function(event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $ad76f2a8d85683d0$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$ad76f2a8d85683d0$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if ($ad76f2a8d85683d0$var$isAnchorTarget(event)) return;
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp: function(event) {
                if (event.defaultPrevented || !keyboardHandlers || $ad76f2a8d85683d0$var$isButtonTarget(event) || $ad76f2a8d85683d0$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        };
    }, [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $5s1kH.useMemo(function() {
        return enabled ? {
            reference: reference
        } : {};
    }, [
        enabled,
        reference
    ]);
}
function $ad76f2a8d85683d0$var$createVirtualElement(domElement, data) {
    var offsetX = null;
    var offsetY = null;
    var isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect: function() {
            var _data$dataRef$current;
            var domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            var isXAxis = data.axis === 'x' || data.axis === 'both';
            var isYAxis = data.axis === 'y' || data.axis === 'both';
            var canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            var width = domRect.width;
            var height = domRect.height;
            var x = domRect.x;
            var y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $ad76f2a8d85683d0$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $ad76f2a8d85683d0$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    var open = context.open, dataRef = context.dataRef, _context_elements = context.elements, floating = _context_elements.floating, domReference = _context_elements.domReference, refs = context.refs;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_axis = props.axis, axis = _props_axis === void 0 ? 'both' : _props_axis, _props_x = props.x, x = _props_x === void 0 ? null : _props_x, _props_y = props.y, y = _props_y === void 0 ? null : _props_y;
    var initialRef = $5s1kH.useRef(false);
    var cleanupListenerRef = $5s1kH.useRef(null);
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(), 2), pointerType = _React_useState[0], setPointerType = _React_useState[1];
    var _React_useState1 = (0, $6iP9u._)($5s1kH.useState([]), 2), reactive = _React_useState1[0], setReactive = _React_useState1[1];
    var setReference = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function(x, y) {
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$ad76f2a8d85683d0$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($ad76f2a8d85683d0$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    var handleReferenceEnterOrMove = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function(event) {
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    var openCheck = (0, $72ad0bd1c5aa7773$export$81cf264172d31e51)(pointerType) ? floating : open;
    var addListener = $5s1kH.useCallback(function() {
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        var win = (0, $2a4197d9582b0915$export$38b2d434cce3ea22)(floating);
        function handleMouseMove(event) {
            var target = (0, $72ad0bd1c5aa7773$export$c22522a4dfa48e9c)(event);
            if (!(0, $72ad0bd1c5aa7773$export$2344b14b097df817)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $ad76f2a8d85683d0$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            var cleanup = function() {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $5s1kH.useEffect(function() {
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $5s1kH.useEffect(function() {
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $5s1kH.useEffect(function() {
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    var reference = $5s1kH.useMemo(function() {
        function setPointerTypeRef(_ref) {
            var pointerType = _ref.pointerType;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $5s1kH.useMemo(function() {
        return enabled ? {
            reference: reference
        } : {};
    }, [
        enabled,
        reference
    ]);
}
var $ad76f2a8d85683d0$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
var $ad76f2a8d85683d0$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
var $ad76f2a8d85683d0$var$normalizeProp = function(normalizable) {
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $ad76f2a8d85683d0$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    var open = context.open, onOpenChange = context.onOpenChange, elements = context.elements, dataRef = context.dataRef;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_escapeKey = props.escapeKey, escapeKey = _props_escapeKey === void 0 ? true : _props_escapeKey, tmp = props.outsidePress, unstable_outsidePress = tmp === void 0 ? true : tmp, _props_outsidePressEvent = props.outsidePressEvent, outsidePressEvent = _props_outsidePressEvent === void 0 ? 'pointerdown' : _props_outsidePressEvent, _props_referencePress = props.referencePress, referencePress = _props_referencePress === void 0 ? false : _props_referencePress, _props_referencePressEvent = props.referencePressEvent, referencePressEvent = _props_referencePressEvent === void 0 ? 'pointerdown' : _props_referencePressEvent, _props_ancestorScroll = props.ancestorScroll, ancestorScroll = _props_ancestorScroll === void 0 ? false : _props_ancestorScroll, bubbles = props.bubbles, capture = props.capture;
    var tree = $ad76f2a8d85683d0$export$db0c2a7c7a2a4f69();
    var outsidePressFn = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : function() {
        return false;
    });
    var outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    var endedOrStartedInsideRef = $5s1kH.useRef(false);
    var _normalizeProp = $ad76f2a8d85683d0$var$normalizeProp(bubbles), escapeKeyBubbles = _normalizeProp.escapeKey, outsidePressBubbles = _normalizeProp.outsidePress;
    var _normalizeProp1 = $ad76f2a8d85683d0$var$normalizeProp(capture), escapeKeyCapture = _normalizeProp1.escapeKey, outsidePressCapture = _normalizeProp1.outsidePress;
    var isComposingRef = $5s1kH.useRef(false);
    var closeOnEscapeKeyDown = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function(event) {
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        var nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        var children = tree ? (0, $72ad0bd1c5aa7773$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                var shouldDismiss = true;
                children.forEach(function(child) {
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $72ad0bd1c5aa7773$export$94781ce41a161222)(event) ? event.nativeEvent : event, 'escape-key');
    });
    var closeOnEscapeKeyDownCapture = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function(event) {
        var _getTarget2;
        var callback = function() {
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $72ad0bd1c5aa7773$export$c22522a4dfa48e9c)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $72ad0bd1c5aa7773$export$c22522a4dfa48e9c)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    var closeOnPressOutside = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function(event) {
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        var insideReactTree = dataRef.current.insideReactTree;
        dataRef.current.insideReactTree = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        var endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        var target = (0, $72ad0bd1c5aa7773$export$c22522a4dfa48e9c)(event);
        var inertSelector = "[" + $ad76f2a8d85683d0$var$createAttribute('inert') + "]";
        var markers = (0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(elements.floating).querySelectorAll(inertSelector);
        var targetRootAncestor = (0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $2a4197d9582b0915$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            var nextParent = (0, $2a4197d9582b0915$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $2a4197d9582b0915$export$d1162fb0b6d4cd51)(nextParent) || !(0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(target) && !(0, $72ad0bd1c5aa7773$export$7b296c28e0fa3aed)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $72ad0bd1c5aa7773$export$2344b14b097df817)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every(function(marker) {
            return !(0, $72ad0bd1c5aa7773$export$2344b14b097df817)(targetRootAncestor, marker);
        })) return;
        // Check if the click occurred on the scrollbar
        if ((0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(target) && floating) {
            var lastTraversableNode = (0, $2a4197d9582b0915$export$d1162fb0b6d4cd51)(target);
            var style = (0, $2a4197d9582b0915$export$3735103072e4a80)(target);
            var scrollRe = /auto|scroll/;
            var isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
            var isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
            var canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            var canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            var isRTL = style.direction === 'rtl';
            // Check click position relative to scrollbar.
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            var pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
            var pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
            if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
        }
        var nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        var targetIsInsideChildren = tree && (0, $72ad0bd1c5aa7773$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId).some(function(node) {
            var _node$context;
            return (0, $72ad0bd1c5aa7773$export$43c3154d5bf2c6c2)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $72ad0bd1c5aa7773$export$43c3154d5bf2c6c2)(event, elements.floating) || (0, $72ad0bd1c5aa7773$export$43c3154d5bf2c6c2)(event, elements.domReference) || targetIsInsideChildren) return;
        var children = tree ? (0, $72ad0bd1c5aa7773$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            var shouldDismiss = true;
            children.forEach(function(child) {
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    var closeOnPressOutsideCapture = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function(event) {
        var _getTarget4;
        var callback = function() {
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $72ad0bd1c5aa7773$export$c22522a4dfa48e9c)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $72ad0bd1c5aa7773$export$c22522a4dfa48e9c)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $5s1kH.useEffect(function() {
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        var compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(function() {
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $2a4197d9582b0915$export$78551043582a6a98)() ? 5 : 0);
        }
        var doc = (0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        var ancestors = [];
        if (ancestorScroll) {
            if ((0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(elements.domReference)) ancestors = (0, $2a4197d9582b0915$export$3b57c1601291186b)(elements.domReference);
            if ((0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(elements.floating)) ancestors = ancestors.concat((0, $2a4197d9582b0915$export$3b57c1601291186b)(elements.floating));
            if (!(0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $2a4197d9582b0915$export$3b57c1601291186b)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter(function(ancestor) {
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach(function(ancestor) {
            ancestor.addEventListener('scroll', onScroll);
        });
        return function() {
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach(function(ancestor) {
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $5s1kH.useEffect(function() {
        dataRef.current.insideReactTree = false;
    }, [
        dataRef,
        outsidePress,
        outsidePressEvent
    ]);
    var reference = $5s1kH.useMemo(function() {
        return (0, $hwO3w._)({
            onKeyDown: closeOnEscapeKeyDown
        }, referencePress && (0, $hwO3w._)((0, $dUlz9._)({}, $ad76f2a8d85683d0$var$bubbleHandlerKeys[referencePressEvent], function(event) {
            onOpenChange(false, event.nativeEvent, 'reference-press');
        }), referencePressEvent !== 'click' && {
            onClick: function(event) {
                onOpenChange(false, event.nativeEvent, 'reference-press');
            }
        }));
    }, [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    var floating = $5s1kH.useMemo(function() {
        function setMouseDownOrUpInside(event) {
            if (event.button !== 0) return;
            endedOrStartedInsideRef.current = true;
        }
        return (0, $dUlz9._)({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown: setMouseDownOrUpInside,
            onMouseUp: setMouseDownOrUpInside
        }, $ad76f2a8d85683d0$var$captureHandlerKeys[outsidePressEvent], function() {
            dataRef.current.insideReactTree = true;
        });
    }, [
        closeOnEscapeKeyDown,
        outsidePressEvent,
        dataRef
    ]);
    return $5s1kH.useMemo(function() {
        return enabled ? {
            reference: reference,
            floating: floating
        } : {};
    }, [
        enabled,
        reference,
        floating
    ]);
}
function $ad76f2a8d85683d0$export$1df81146f8ad8e4c(options) {
    var _options_open = options.open, open = _options_open === void 0 ? false : _options_open, onOpenChangeProp = options.onOpenChange, elementsProp = options.elements;
    var floatingId = $ad76f2a8d85683d0$export$f680877a34711e37();
    var dataRef = $5s1kH.useRef({});
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(function() {
        return $ad76f2a8d85683d0$var$createEventEmitter();
    }), 1), events = _React_useState[0];
    var nested = $ad76f2a8d85683d0$export$165209eae06d3488() != null;
    var _React_useState1 = (0, $6iP9u._)($5s1kH.useState(elementsProp.reference), 2), positionReference = _React_useState1[0], setPositionReference = _React_useState1[1];
    var onOpenChange = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function(open, event, reason) {
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    var refs = $5s1kH.useMemo(function() {
        return {
            setPositionReference: setPositionReference
        };
    }, []);
    var elements = $5s1kH.useMemo(function() {
        return {
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        };
    }, [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $5s1kH.useMemo(function() {
        return {
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        };
    }, [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $ad76f2a8d85683d0$export$4e02a5c1d08bac65(_temp) {
    var _elementsOption$refer, _elementsOption$float;
    var _ref = _temp === void 0 ? {} : _temp, elementsOption = _ref.elements, options = (0, $54Czb._)(_ref, [
        "elements"
    ]);
    var nodeId = options.nodeId;
    var internalRootContext = $ad76f2a8d85683d0$export$1df81146f8ad8e4c((0, $lf4fc._)((0, $hwO3w._)({}, options), {
        elements: {
            reference: (_elementsOption$refer = elementsOption == null ? void 0 : elementsOption.reference) != null ? _elementsOption$refer : null,
            floating: (_elementsOption$float = elementsOption == null ? void 0 : elementsOption.floating) != null ? _elementsOption$float : null
        }
    }));
    var rootContext = options.rootContext || internalRootContext;
    var computedElements = rootContext.elements;
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(null), 2), _domReference = _React_useState[0], setDomReference = _React_useState[1];
    var _React_useState1 = (0, $6iP9u._)($5s1kH.useState(null), 2), positionReference = _React_useState1[0], _setPositionReference = _React_useState1[1];
    var optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    var domReference = optionDomReference || _domReference;
    var domReferenceRef = $5s1kH.useRef(null);
    var tree = $ad76f2a8d85683d0$export$db0c2a7c7a2a4f69();
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    var position = (0, $5b7bf8dbb9190e49$export$4e02a5c1d08bac65)((0, $lf4fc._)((0, $hwO3w._)({}, options), {
        elements: (0, $hwO3w._)({}, computedElements, positionReference && {
            reference: positionReference
        })
    }));
    var setPositionReference = $5s1kH.useCallback(function(node) {
        var computedPositionReference = (0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: function() {
                return node.getBoundingClientRect();
            },
            getClientRects: function() {
                return node.getClientRects();
            },
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    var setReference = $5s1kH.useCallback(function(node) {
        if ((0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    var refs = $5s1kH.useMemo(function() {
        return (0, $lf4fc._)((0, $hwO3w._)({}, position.refs), {
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        });
    }, [
        position.refs,
        setReference,
        setPositionReference
    ]);
    var elements = $5s1kH.useMemo(function() {
        return (0, $lf4fc._)((0, $hwO3w._)({}, position.elements), {
            domReference: domReference
        });
    }, [
        position.elements,
        domReference
    ]);
    var context = $5s1kH.useMemo(function() {
        return (0, $lf4fc._)((0, $hwO3w._)({}, position, rootContext), {
            refs: refs,
            elements: elements,
            nodeId: nodeId
        });
    }, [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        rootContext.dataRef.current.floatingContext = context;
        var node = tree == null ? void 0 : tree.nodesRef.current.find(function(node) {
            return node.id === nodeId;
        });
        if (node) node.context = context;
    });
    return $5s1kH.useMemo(function() {
        return (0, $lf4fc._)((0, $hwO3w._)({}, position), {
            context: context,
            refs: refs,
            elements: elements
        });
    }, [
        position,
        refs,
        elements,
        context
    ]);
}
function $ad76f2a8d85683d0$var$isMacSafari() {
    return (0, $72ad0bd1c5aa7773$export$9ac100e40613ea10)() && (0, $72ad0bd1c5aa7773$export$95df08bae54cb4df)();
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $ad76f2a8d85683d0$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    var open = context.open, onOpenChange = context.onOpenChange, events = context.events, dataRef = context.dataRef, elements = context.elements;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_visibleOnly = props.visibleOnly, visibleOnly = _props_visibleOnly === void 0 ? true : _props_visibleOnly;
    var blockFocusRef = $5s1kH.useRef(false);
    var timeoutRef = $5s1kH.useRef(-1);
    var keyboardModalityRef = $5s1kH.useRef(true);
    $5s1kH.useEffect(function() {
        if (!enabled) return;
        var win = (0, $2a4197d9582b0915$export$38b2d434cce3ea22)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(elements.domReference) && elements.domReference === (0, $72ad0bd1c5aa7773$export$da980962bd2147a4)((0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        function onPointerDown() {
            keyboardModalityRef.current = false;
        }
        win.addEventListener('blur', onBlur);
        if ($ad76f2a8d85683d0$var$isMacSafari()) {
            win.addEventListener('keydown', onKeyDown, true);
            win.addEventListener('pointerdown', onPointerDown, true);
        }
        return function() {
            win.removeEventListener('blur', onBlur);
            if ($ad76f2a8d85683d0$var$isMacSafari()) {
                win.removeEventListener('keydown', onKeyDown, true);
                win.removeEventListener('pointerdown', onPointerDown, true);
            }
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $5s1kH.useEffect(function() {
        if (!enabled) return;
        function onOpenChange(_ref) {
            var reason = _ref.reason;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return function() {
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $5s1kH.useEffect(function() {
        return function() {
            $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutRef);
        };
    }, []);
    var reference = $5s1kH.useMemo(function() {
        return {
            onMouseLeave: function() {
                blockFocusRef.current = false;
            },
            onFocus: function(event) {
                if (blockFocusRef.current) return;
                var target = (0, $72ad0bd1c5aa7773$export$c22522a4dfa48e9c)(event.nativeEvent);
                if (visibleOnly && (0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(target)) {
                    // Safari fails to match `:focus-visible` if focus was initially
                    // outside the document.
                    if ($ad76f2a8d85683d0$var$isMacSafari() && !event.relatedTarget) {
                        if (!keyboardModalityRef.current && !(0, $72ad0bd1c5aa7773$export$42ad131c32f0fb8d)(target)) return;
                    } else if (!(0, $72ad0bd1c5aa7773$export$65750043c2fb2f40)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur: function(event) {
                blockFocusRef.current = false;
                var relatedTarget = event.relatedTarget;
                var nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                var movedToFocusGuard = (0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute($ad76f2a8d85683d0$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(function() {
                    var _dataRef$current$floa;
                    var activeEl = (0, $72ad0bd1c5aa7773$export$da980962bd2147a4)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $72ad0bd1c5aa7773$export$2344b14b097df817)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $72ad0bd1c5aa7773$export$2344b14b097df817)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        };
    }, [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $5s1kH.useMemo(function() {
        return enabled ? {
            reference: reference
        } : {};
    }, [
        enabled,
        reference
    ]);
}
function $ad76f2a8d85683d0$var$mergeProps(userProps, propsList, elementKey) {
    var map = new Map();
    var isItem = elementKey === 'item';
    var domUserProps = userProps;
    if (isItem && userProps) {
        var _ = userProps[$ad76f2a8d85683d0$var$ACTIVE_KEY], __ = userProps[$ad76f2a8d85683d0$var$SELECTED_KEY], validProps = (0, $54Czb._)(userProps, [
            $ad76f2a8d85683d0$var$ACTIVE_KEY,
            $ad76f2a8d85683d0$var$SELECTED_KEY
        ].map((0, $e78cd090630be08f$export$71511d61b312f219)));
        domUserProps = validProps;
    }
    return (0, $hwO3w._)({}, elementKey === 'floating' && (0, $dUlz9._)({
        tabIndex: -1
    }, $ad76f2a8d85683d0$var$FOCUSABLE_ATTRIBUTE, ''), domUserProps, propsList.map(function(value) {
        var propsOrGetProps = value ? value[elementKey] : null;
        if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
        return propsOrGetProps;
    }).concat(userProps).reduce(function(acc, props) {
        if (!props) return acc;
        Object.entries(props).forEach(function(_ref) {
            var _$_ref = (0, $6iP9u._)(_ref, 2), key = _$_ref[0], value = _$_ref[1];
            if (isItem && [
                $ad76f2a8d85683d0$var$ACTIVE_KEY,
                $ad76f2a8d85683d0$var$SELECTED_KEY
            ].includes(key)) return;
            if (key.indexOf('on') === 0) {
                if (!map.has(key)) map.set(key, []);
                if (typeof value === 'function') {
                    var _map$get;
                    (_map$get = map.get(key)) == null || _map$get.push(value);
                    acc[key] = function() {
                        var _map$get2;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(function(fn) {
                            return fn.apply(void 0, (0, $XnYkK._)(args));
                        }).find(function(val) {
                            return val !== undefined;
                        });
                    };
                }
            } else acc[key] = value;
        });
        return acc;
    }, {}));
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $ad76f2a8d85683d0$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    var referenceDeps = propsList.map(function(key) {
        return key == null ? void 0 : key.reference;
    });
    var floatingDeps = propsList.map(function(key) {
        return key == null ? void 0 : key.floating;
    });
    var itemDeps = propsList.map(function(key) {
        return key == null ? void 0 : key.item;
    });
    var getReferenceProps = $5s1kH.useCallback(function(userProps) {
        return $ad76f2a8d85683d0$var$mergeProps(userProps, propsList, 'reference');
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    var getFloatingProps = $5s1kH.useCallback(function(userProps) {
        return $ad76f2a8d85683d0$var$mergeProps(userProps, propsList, 'floating');
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    var getItemProps = $5s1kH.useCallback(function(userProps) {
        return $ad76f2a8d85683d0$var$mergeProps(userProps, propsList, 'item');
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $5s1kH.useMemo(function() {
        return {
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        };
    }, [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
var $ad76f2a8d85683d0$var$ESCAPE = 'Escape';
function $ad76f2a8d85683d0$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $ad76f2a8d85683d0$var$isMainOrientationKey(key, orientation) {
    var vertical = key === $ad76f2a8d85683d0$var$ARROW_UP || key === $ad76f2a8d85683d0$var$ARROW_DOWN;
    var horizontal = key === $ad76f2a8d85683d0$var$ARROW_LEFT || key === $ad76f2a8d85683d0$var$ARROW_RIGHT;
    return $ad76f2a8d85683d0$var$doSwitch(orientation, vertical, horizontal);
}
function $ad76f2a8d85683d0$var$isMainOrientationToEndKey(key, orientation, rtl) {
    var vertical = key === $ad76f2a8d85683d0$var$ARROW_DOWN;
    var horizontal = rtl ? key === $ad76f2a8d85683d0$var$ARROW_LEFT : key === $ad76f2a8d85683d0$var$ARROW_RIGHT;
    return $ad76f2a8d85683d0$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $ad76f2a8d85683d0$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    var vertical = rtl ? key === $ad76f2a8d85683d0$var$ARROW_LEFT : key === $ad76f2a8d85683d0$var$ARROW_RIGHT;
    var horizontal = key === $ad76f2a8d85683d0$var$ARROW_DOWN;
    return $ad76f2a8d85683d0$var$doSwitch(orientation, vertical, horizontal);
}
function $ad76f2a8d85683d0$var$isCrossOrientationCloseKey(key, orientation, rtl, cols) {
    var vertical = rtl ? key === $ad76f2a8d85683d0$var$ARROW_RIGHT : key === $ad76f2a8d85683d0$var$ARROW_LEFT;
    var horizontal = key === $ad76f2a8d85683d0$var$ARROW_UP;
    if (orientation === 'both' || orientation === 'horizontal' && cols && cols > 1) return key === $ad76f2a8d85683d0$var$ESCAPE;
    return $ad76f2a8d85683d0$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $ad76f2a8d85683d0$export$b5d22cac4ad33f40(context, props) {
    var open = context.open, onOpenChange = context.onOpenChange, elements = context.elements, floatingId = context.floatingId;
    var listRef = props.listRef, activeIndex = props.activeIndex, tmp = props.onNavigate, unstable_onNavigate = tmp === void 0 ? function() {} : tmp, _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_selectedIndex = props.selectedIndex, selectedIndex = _props_selectedIndex === void 0 ? null : _props_selectedIndex, _props_allowEscape = props.allowEscape, allowEscape = _props_allowEscape === void 0 ? false : _props_allowEscape, _props_loop = props.loop, loop = _props_loop === void 0 ? false : _props_loop, _props_nested = props.nested, nested = _props_nested === void 0 ? false : _props_nested, _props_rtl = props.rtl, rtl = _props_rtl === void 0 ? false : _props_rtl, _props_virtual = props.virtual, virtual = _props_virtual === void 0 ? false : _props_virtual, _props_focusItemOnOpen = props.focusItemOnOpen, focusItemOnOpen = _props_focusItemOnOpen === void 0 ? 'auto' : _props_focusItemOnOpen, _props_focusItemOnHover = props.focusItemOnHover, focusItemOnHover = _props_focusItemOnHover === void 0 ? true : _props_focusItemOnHover, _props_openOnArrowKeyDown = props.openOnArrowKeyDown, openOnArrowKeyDown = _props_openOnArrowKeyDown === void 0 ? true : _props_openOnArrowKeyDown, disabledIndices = props.disabledIndices, _props_orientation = props.orientation, orientation = _props_orientation === void 0 ? 'vertical' : _props_orientation, parentOrientation = props.parentOrientation, _props_cols = props.cols, cols = _props_cols === void 0 ? 1 : _props_cols, _props_scrollItemIntoView = props.scrollItemIntoView, scrollItemIntoView = _props_scrollItemIntoView === void 0 ? true : _props_scrollItemIntoView, virtualItemRef = props.virtualItemRef, itemSizes = props.itemSizes, _props_dense = props.dense, dense = _props_dense === void 0 ? false : _props_dense;
    var floatingFocusElement = (0, $72ad0bd1c5aa7773$export$9b0901b5e9b45fc7)(elements.floating);
    var floatingFocusElementRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(floatingFocusElement);
    var parentId = $ad76f2a8d85683d0$export$165209eae06d3488();
    var tree = $ad76f2a8d85683d0$export$db0c2a7c7a2a4f69();
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        context.dataRef.current.orientation = orientation;
    }, [
        context,
        orientation
    ]);
    var onNavigate = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function() {
        unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
    });
    var typeableComboboxReference = (0, $72ad0bd1c5aa7773$export$259ba5ae38188551)(elements.domReference);
    var focusItemOnOpenRef = $5s1kH.useRef(focusItemOnOpen);
    var indexRef = $5s1kH.useRef(selectedIndex != null ? selectedIndex : -1);
    var keyRef = $5s1kH.useRef(null);
    var isPointerModalityRef = $5s1kH.useRef(true);
    var previousOnNavigateRef = $5s1kH.useRef(onNavigate);
    var previousMountedRef = $5s1kH.useRef(!!elements.floating);
    var previousOpenRef = $5s1kH.useRef(open);
    var forceSyncFocusRef = $5s1kH.useRef(false);
    var forceScrollIntoViewRef = $5s1kH.useRef(false);
    var disabledIndicesRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(disabledIndices);
    var latestOpenRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(open);
    var scrollItemIntoViewRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(scrollItemIntoView);
    var selectedIndexRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(selectedIndex);
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(), 2), activeId = _React_useState[0], setActiveId = _React_useState[1];
    var _React_useState1 = (0, $6iP9u._)($5s1kH.useState(), 2), virtualId = _React_useState1[0], setVirtualId = _React_useState1[1];
    var focusItem = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function() {
        function runFocus(item) {
            if (virtual) {
                var _item$id;
                if ((_item$id = item.id) != null && _item$id.endsWith('-fui-option')) item.id = floatingId + "-" + Math.random().toString(16).slice(2, 10);
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $ad76f2a8d85683d0$var$enqueueFocus(item, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        }
        var initialItem = listRef.current[indexRef.current];
        var forceScrollIntoView = forceScrollIntoViewRef.current;
        if (initialItem) runFocus(initialItem);
        var scheduler = forceSyncFocusRef.current ? function(v) {
            return v();
        } : requestAnimationFrame;
        scheduler(function() {
            var waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            var scrollIntoViewOptions = scrollItemIntoViewRef.current;
            var shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current();
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (!enabled) return;
        if (!open) return;
        if (!elements.floating) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            // Reset while the floating element was open (e.g. the list changed).
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            // Initial sync.
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                var runs = 0;
                var waitForListPopulated = function() {
                    if (listRef.current[0] == null) {
                        // Avoid letting the browser paint if possible on the first try,
                        // otherwise use rAF. Don't try more than twice, since something
                        // is wrong otherwise.
                        if (runs < 2) {
                            var scheduler = runs ? requestAnimationFrame : queueMicrotask;
                            scheduler(waitForListPopulated);
                        }
                        runs++;
                    } else {
                        indexRef.current = keyRef.current == null || $ad76f2a8d85683d0$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? (0, $72ad0bd1c5aa7773$export$53f691ee0acc6058)(listRef, disabledIndicesRef.current) : (0, $72ad0bd1c5aa7773$export$b585558af466e926)(listRef, disabledIndicesRef.current);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!(0, $72ad0bd1c5aa7773$export$75effb89758ec596)(listRef, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        var nodes = tree.nodesRef.current;
        var parent = (_nodes$find = nodes.find(function(node) {
            return node.id === parentId;
        })) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        var activeEl = (0, $72ad0bd1c5aa7773$export$da980962bd2147a4)((0, $72ad0bd1c5aa7773$export$f65ca476c09acec0)(elements.floating));
        var treeContainsActiveEl = nodes.some(function(node) {
            return node.context && (0, $72ad0bd1c5aa7773$export$2344b14b097df817)(node.context.elements.floating, activeEl);
        });
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return function() {
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open;
        previousMountedRef.current = !!elements.floating;
    });
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (!open) {
            keyRef.current = null;
            focusItemOnOpenRef.current = focusItemOnOpen;
        }
    }, [
        open,
        focusItemOnOpen
    ]);
    var hasActiveIndex = activeIndex != null;
    var item = $5s1kH.useMemo(function() {
        function syncCurrentTarget(currentTarget) {
            if (!latestOpenRef.current) return;
            var index = listRef.current.indexOf(currentTarget);
            if (index !== -1 && indexRef.current !== index) {
                indexRef.current = index;
                onNavigate();
            }
        }
        var _$props = {
            onFocus: function(_ref) {
                var currentTarget = _ref.currentTarget;
                forceSyncFocusRef.current = true;
                syncCurrentTarget(currentTarget);
            },
            onClick: function(_ref2) {
                var currentTarget = _ref2.currentTarget;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            onMouseMove: function(_ref3) {
                var currentTarget = _ref3.currentTarget;
                forceSyncFocusRef.current = true;
                forceScrollIntoViewRef.current = false;
                if (focusItemOnHover) syncCurrentTarget(currentTarget);
            },
            onPointerLeave: function(_ref4) {
                var pointerType = _ref4.pointerType;
                if (!isPointerModalityRef.current || pointerType === 'touch') return;
                forceSyncFocusRef.current = true;
                if (!focusItemOnHover) return;
                indexRef.current = -1;
                onNavigate();
                if (!virtual) {
                    var _floatingFocusElement;
                    (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
                        preventScroll: true
                    });
                }
            }
        };
        return _$props;
    }, [
        latestOpenRef,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    var getParentOrientation = $5s1kH.useCallback(function() {
        var _tree$nodesRef$curren;
        return parentOrientation != null ? parentOrientation : tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find(function(node) {
            return node.id === parentId;
        })) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.dataRef) == null ? void 0 : _tree$nodesRef$curren.current.orientation;
    }, [
        parentId,
        tree,
        parentOrientation
    ]);
    var commonOnKeyDown = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function(event) {
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $ad76f2a8d85683d0$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols)) {
            // If the nested list's close key is also the parent navigation key,
            // let the parent navigate. Otherwise, stop propagating the event.
            if (!$ad76f2a8d85683d0$var$isMainOrientationKey(event.key, getParentOrientation())) (0, $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $2a4197d9582b0915$export$1b3bfaa9684536aa)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        var currentIndex = indexRef.current;
        var minIndex = (0, $72ad0bd1c5aa7773$export$53f691ee0acc6058)(listRef, disabledIndices);
        var maxIndex = (0, $72ad0bd1c5aa7773$export$b585558af466e926)(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050)(event);
                indexRef.current = minIndex;
                onNavigate();
            }
            if (event.key === 'End') {
                (0, $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050)(event);
                indexRef.current = maxIndex;
                onNavigate();
            }
        }
        // Grid navigation.
        if (cols > 1) {
            var sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, function() {
                return {
                    width: 1,
                    height: 1
                };
            });
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            var cellMap = (0, $72ad0bd1c5aa7773$export$5334c96856356f08)(sizes, cols, dense);
            var minGridIndex = cellMap.findIndex(function(index) {
                return index != null && !(0, $72ad0bd1c5aa7773$export$446656ed0410fd9)(listRef, index, disabledIndices);
            });
            // last enabled index
            var maxGridIndex = cellMap.reduce(function(foundIndex, index, cellIndex) {
                return index != null && !(0, $72ad0bd1c5aa7773$export$446656ed0410fd9)(listRef, index, disabledIndices) ? cellIndex : foundIndex;
            }, -1);
            var index = cellMap[(0, $72ad0bd1c5aa7773$export$342fcce33a2688bc)({
                current: cellMap.map(function(itemIndex) {
                    return itemIndex != null ? listRef.current[itemIndex] : null;
                })
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $72ad0bd1c5aa7773$export$50d8709b2ccc23f9)((0, $XnYkK._)((typeof disabledIndices !== 'function' ? disabledIndices : null) || listRef.current.map(function(_, index) {
                    return (0, $72ad0bd1c5aa7773$export$446656ed0410fd9)(listRef, index, disabledIndices) ? index : undefined;
                })).concat([
                    undefined
                ]), cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $72ad0bd1c5aa7773$export$dab2b2ce7761f8e4)(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $ad76f2a8d85683d0$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $ad76f2a8d85683d0$var$ARROW_LEFT : $ad76f2a8d85683d0$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate();
            }
            if (orientation === 'both') return;
        }
        if ($ad76f2a8d85683d0$var$isMainOrientationKey(event.key, orientation)) {
            (0, $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $72ad0bd1c5aa7773$export$da980962bd2147a4)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $ad76f2a8d85683d0$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate();
                return;
            }
            if ($ad76f2a8d85683d0$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : (0, $72ad0bd1c5aa7773$export$3fc3ea4a67cf714)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, (0, $72ad0bd1c5aa7773$export$3fc3ea4a67cf714)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : (0, $72ad0bd1c5aa7773$export$3fc3ea4a67cf714)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, (0, $72ad0bd1c5aa7773$export$3fc3ea4a67cf714)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ((0, $72ad0bd1c5aa7773$export$75effb89758ec596)(listRef, indexRef.current)) indexRef.current = -1;
            onNavigate();
        }
    });
    var ariaActiveDescendantProp = $5s1kH.useMemo(function() {
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    var floating = $5s1kH.useMemo(function() {
        return (0, $lf4fc._)((0, $hwO3w._)({
            'aria-orientation': orientation === 'both' ? undefined : orientation
        }, !typeableComboboxReference ? ariaActiveDescendantProp : {}), {
            onKeyDown: commonOnKeyDown,
            onPointerMove: function() {
                isPointerModalityRef.current = true;
            }
        });
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        orientation,
        typeableComboboxReference
    ]);
    var reference = $5s1kH.useMemo(function() {
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $72ad0bd1c5aa7773$export$60278871457622de)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $72ad0bd1c5aa7773$export$29bf1b5f2c56cf63)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return (0, $lf4fc._)((0, $hwO3w._)({}, ariaActiveDescendantProp), {
            onKeyDown: function(event) {
                isPointerModalityRef.current = false;
                var isArrowKey = event.key.startsWith('Arrow');
                var isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                var isMoveKey = isArrowKey || isHomeOrEndKey;
                var isCrossOpenKey = $ad76f2a8d85683d0$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                var isCrossCloseKey = $ad76f2a8d85683d0$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols);
                var isParentCrossOpenKey = $ad76f2a8d85683d0$var$isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
                var isMainKey = $ad76f2a8d85683d0$var$isMainOrientationKey(event.key, orientation);
                var isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    var rootNode = tree == null ? void 0 : tree.nodesRef.current.find(function(node) {
                        return node.parentId == null;
                    });
                    var deepestNode = tree && rootNode ? (0, $72ad0bd1c5aa7773$export$e7e88d43cb97db79)(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        var eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            var isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            var dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find(function(item) {
                                return (item == null ? void 0 : item.id) === activeId;
                            }) : null;
                            if (dispatchItem) {
                                (0, $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) {
                    var isParentMainKey = $ad76f2a8d85683d0$var$isMainOrientationKey(event.key, getParentOrientation());
                    keyRef.current = nested && isParentMainKey ? null : event.key;
                }
                if (nested) {
                    if (isParentCrossOpenKey) {
                        (0, $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050)(event);
                        if (open) {
                            indexRef.current = (0, $72ad0bd1c5aa7773$export$53f691ee0acc6058)(listRef, disabledIndicesRef.current);
                            onNavigate();
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate();
                }
            },
            onFocus: function() {
                if (open && !virtual) {
                    indexRef.current = -1;
                    onNavigate();
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        });
    }, [
        activeId,
        ariaActiveDescendantProp,
        cols,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        getParentOrientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $5s1kH.useMemo(function() {
        return enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {};
    }, [
        enabled,
        reference,
        floating,
        item
    ]);
}
var $ad76f2a8d85683d0$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $ad76f2a8d85683d0$export$f66572793fa256a1(context, props) {
    var _elements$domReferenc, _componentRoleToAriaR;
    if (props === void 0) props = {};
    var open = context.open, elements = context.elements, defaultFloatingId = context.floatingId;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_role = props.role, role = _props_role === void 0 ? 'dialog' : _props_role;
    var defaultReferenceId = $ad76f2a8d85683d0$export$f680877a34711e37();
    var referenceId = ((_elements$domReferenc = elements.domReference) == null ? void 0 : _elements$domReferenc.id) || defaultReferenceId;
    var floatingId = $5s1kH.useMemo(function() {
        var _getFloatingFocusElem;
        return ((_getFloatingFocusElem = (0, $72ad0bd1c5aa7773$export$9b0901b5e9b45fc7)(elements.floating)) == null ? void 0 : _getFloatingFocusElem.id) || defaultFloatingId;
    }, [
        elements.floating,
        defaultFloatingId
    ]);
    var ariaRole = (_componentRoleToAriaR = $ad76f2a8d85683d0$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    var parentId = $ad76f2a8d85683d0$export$165209eae06d3488();
    var isNested = parentId != null;
    var reference = $5s1kH.useMemo(function() {
        if (ariaRole === 'tooltip' || role === 'label') return (0, $dUlz9._)({}, "aria-" + (role === 'label' ? 'labelledby' : 'describedby'), open ? floatingId : undefined);
        return (0, $hwO3w._)({
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined
        }, ariaRole === 'listbox' && {
            role: 'combobox'
        }, ariaRole === 'menu' && {
            id: referenceId
        }, ariaRole === 'menu' && isNested && {
            role: 'menuitem'
        }, role === 'select' && {
            'aria-autocomplete': 'none'
        }, role === 'combobox' && {
            'aria-autocomplete': 'list'
        });
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    var floating = $5s1kH.useMemo(function() {
        var floatingProps = (0, $hwO3w._)({
            id: floatingId
        }, ariaRole && {
            role: ariaRole
        });
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return (0, $hwO3w._)({}, floatingProps, ariaRole === 'menu' && {
            'aria-labelledby': referenceId
        });
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    var item = $5s1kH.useCallback(function(_ref) {
        var active = _ref.active, selected = _ref.selected;
        var commonProps = (0, $hwO3w._)({
            role: 'option'
        }, active && {
            id: floatingId + "-fui-option"
        });
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
            case 'combobox':
                return (0, $lf4fc._)((0, $hwO3w._)({}, commonProps), {
                    'aria-selected': selected
                });
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $5s1kH.useMemo(function() {
        return enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {};
    }, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
var $ad76f2a8d85683d0$var$camelCaseToKebabCase = function(str) {
    return str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, function($, ofs) {
        return (ofs ? '-' : '') + $.toLowerCase();
    });
};
function $ad76f2a8d85683d0$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $ad76f2a8d85683d0$var$useDelayUnmount(open, durationMs) {
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(open), 2), isMounted = _React_useState[0], setIsMounted = _React_useState[1];
    if (open && !isMounted) setIsMounted(true);
    $5s1kH.useEffect(function() {
        if (!open && isMounted) {
            var timeout = setTimeout(function() {
                return setIsMounted(false);
            }, durationMs);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $ad76f2a8d85683d0$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    var open = context.open, floating = context.elements.floating;
    var _props_duration = props.duration, duration = _props_duration === void 0 ? 250 : _props_duration;
    var isNumberDuration = typeof duration === 'number';
    var closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    var _React_useState = (0, $6iP9u._)($5s1kH.useState('unmounted'), 2), status = _React_useState[0], setStatus = _React_useState[1];
    var isMounted = $ad76f2a8d85683d0$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (!floating) return;
        if (open) {
            setStatus('initial');
            var frame = requestAnimationFrame(function() {
                // Ensure it opens before paint. With `FloatingDelayGroup`,
                // this avoids a flicker when moving between floating elements
                // to ensure one is always open with no missing frames.
                $eAxYl.flushSync(function() {
                    setStatus('open');
                });
            });
            return function() {
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $ad76f2a8d85683d0$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    var tmp = props.initial, unstable_initial = tmp === void 0 ? {
        opacity: 0
    } : tmp, unstable_open = props.open, unstable_close = props.close, unstable_common = props.common, _props_duration = props.duration, duration = _props_duration === void 0 ? 250 : _props_duration;
    var placement = context.placement;
    var side = placement.split('-')[0];
    var fnArgs = $5s1kH.useMemo(function() {
        return {
            side: side,
            placement: placement
        };
    }, [
        side,
        placement
    ]);
    var isNumberDuration = typeof duration === 'number';
    var openDuration = (isNumberDuration ? duration : duration.open) || 0;
    var closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    var _React_useState = (0, $6iP9u._)($5s1kH.useState(function() {
        return (0, $hwO3w._)({}, $ad76f2a8d85683d0$var$execWithArgsOrReturn(unstable_common, fnArgs), $ad76f2a8d85683d0$var$execWithArgsOrReturn(unstable_initial, fnArgs));
    }), 2), styles = _React_useState[0], setStyles = _React_useState[1];
    var _useTransitionStatus = $ad76f2a8d85683d0$export$b2ef21706733f7e5(context, {
        duration: duration
    }), isMounted = _useTransitionStatus.isMounted, status = _useTransitionStatus.status;
    var initialRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(unstable_initial);
    var openRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(unstable_open);
    var closeRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(unstable_close);
    var commonRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(unstable_common);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        var initialStyles = $ad76f2a8d85683d0$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        var closeStyles = $ad76f2a8d85683d0$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        var commonStyles = $ad76f2a8d85683d0$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        var openStyles = $ad76f2a8d85683d0$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce(function(acc, key) {
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles(function(styles) {
            return (0, $hwO3w._)({
                transitionProperty: styles.transitionProperty
            }, commonStyles, initialStyles);
        });
        if (status === 'open') setStyles((0, $hwO3w._)({
            transitionProperty: Object.keys(openStyles).map($ad76f2a8d85683d0$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms"
        }, commonStyles, openStyles));
        if (status === 'close') {
            var styles = closeStyles || initialStyles;
            setStyles((0, $hwO3w._)({
                transitionProperty: Object.keys(styles).map($ad76f2a8d85683d0$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms"
            }, commonStyles, styles));
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $ad76f2a8d85683d0$export$d8d674d50b73ba93(context, props) {
    var _ref;
    var open = context.open, dataRef = context.dataRef;
    var listRef = props.listRef, activeIndex = props.activeIndex, unstable_onMatch = props.onMatch, unstable_onTypingChange = props.onTypingChange, _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_findMatch = props.findMatch, findMatch = _props_findMatch === void 0 ? null : _props_findMatch, _props_resetMs = props.resetMs, resetMs = _props_resetMs === void 0 ? 750 : _props_resetMs, _props_ignoreKeys = props.ignoreKeys, ignoreKeys = _props_ignoreKeys === void 0 ? [] : _props_ignoreKeys, _props_selectedIndex = props.selectedIndex, selectedIndex = _props_selectedIndex === void 0 ? null : _props_selectedIndex;
    var timeoutIdRef = $5s1kH.useRef(-1);
    var stringRef = $5s1kH.useRef('');
    var prevIndexRef = $5s1kH.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    var matchIndexRef = $5s1kH.useRef(null);
    var onMatch = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(unstable_onMatch);
    var onTypingChange = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(unstable_onTypingChange);
    var findMatchRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(findMatch);
    var ignoreKeysRef = (0, $72ad0bd1c5aa7773$export$bcd07ba85a740103)(ignoreKeys);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        if (open) {
            $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutIdRef);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    (0, $72ad0bd1c5aa7773$export$bb3b3b3acfd7447f)(function() {
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    var setTypingChange = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function(value) {
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    var onKeyDown = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(function(event) {
        function getMatchingIndex(list, orderedList, string) {
            var str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find(function(text) {
                return (text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0;
            });
            return str ? list.indexOf(str) : -1;
        }
        var listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $72ad0bd1c5aa7773$export$7ae4cd3a66c1e050)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        var allowRapidSuccessionOfFirstLetter = listContent.every(function(text) {
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutIdRef);
        timeoutIdRef.current = window.setTimeout(function() {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        var prevIndex = prevIndexRef.current;
        var index = getMatchingIndex(listContent, (0, $XnYkK._)(listContent.slice((prevIndex || 0) + 1)).concat((0, $XnYkK._)(listContent.slice(0, (prevIndex || 0) + 1))), stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    var reference = $5s1kH.useMemo(function() {
        return {
            onKeyDown: onKeyDown
        };
    }, [
        onKeyDown
    ]);
    var floating = $5s1kH.useMemo(function() {
        return {
            onKeyDown: onKeyDown,
            onKeyUp: function(event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $5s1kH.useMemo(function() {
        return enabled ? {
            reference: reference,
            floating: floating
        } : {};
    }, [
        enabled,
        reference,
        floating
    ]);
}
function $ad76f2a8d85683d0$var$getArgsWithCustomFloatingHeight(state, height) {
    return (0, $lf4fc._)((0, $hwO3w._)({}, state), {
        rects: (0, $lf4fc._)((0, $hwO3w._)({}, state.rects), {
            floating: (0, $lf4fc._)((0, $hwO3w._)({}, state.rects.floating), {
                height: height
            })
        })
    });
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ var $ad76f2a8d85683d0$export$4ae363f1d88fb658 = function(props) {
    return {
        name: 'inner',
        options: props,
        fn: function(state) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
                var _evaluate, listRef, overflowRef, onFallbackChange, tmp, innerOffset, _evaluate_index, index, _evaluate_minItemsVisible, minItemsVisible, _evaluate_referenceOverflowThreshold, referenceOverflowThreshold, scrollRef, detectOverflowOptions, rects, platform, floating, item, scrollEl, clientTop, floatingIsBordered, scrollElIsBordered, floatingIsScrollEl, nextArgs, _tmp, overflow, refOverflow, diffY, nextY, isScrollable, rounder, maxHeight, shouldFallback;
                return (0, $3SMYb._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _evaluate = (0, $f756166b2b894b06$export$fef61f332f2c0afc)(props, state), listRef = _evaluate.listRef, overflowRef = _evaluate.overflowRef, onFallbackChange = _evaluate.onFallbackChange, tmp = _evaluate.offset, innerOffset = tmp === void 0 ? 0 : tmp, _evaluate_index = _evaluate.index, index = _evaluate_index === void 0 ? 0 : _evaluate_index, _evaluate_minItemsVisible = _evaluate.minItemsVisible, minItemsVisible = _evaluate_minItemsVisible === void 0 ? 4 : _evaluate_minItemsVisible, _evaluate_referenceOverflowThreshold = _evaluate.referenceOverflowThreshold, referenceOverflowThreshold = _evaluate_referenceOverflowThreshold === void 0 ? 0 : _evaluate_referenceOverflowThreshold, scrollRef = _evaluate.scrollRef, detectOverflowOptions = (0, $54Czb._)(_evaluate, [
                                "listRef",
                                "overflowRef",
                                "onFallbackChange",
                                "offset",
                                "index",
                                "minItemsVisible",
                                "referenceOverflowThreshold",
                                "scrollRef"
                            ]);
                            rects = state.rects, platform = state.platform, floating = state.elements.floating;
                            item = listRef.current[index];
                            scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
                            // Valid combinations:
                            // 1. Floating element is the scrollRef and has a border (default)
                            // 2. Floating element is not the scrollRef, floating element has a border
                            // 3. Floating element is not the scrollRef, scrollRef has a border
                            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
                            // allowed as VoiceOver doesn't work.
                            clientTop = floating.clientTop || scrollEl.clientTop;
                            floatingIsBordered = floating.clientTop !== 0;
                            scrollElIsBordered = scrollEl.clientTop !== 0;
                            floatingIsScrollEl = floating === scrollEl;
                            if (!item) return [
                                2,
                                {}
                            ];
                            _tmp = [
                                {},
                                state
                            ];
                            return [
                                4,
                                (0, $5b7bf8dbb9190e49$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
                            ];
                        case 1:
                            nextArgs = (0, $hwO3w._).apply(void 0, _tmp.concat([
                                _state.sent()
                            ]));
                            return [
                                4,
                                platform.detectOverflow($ad76f2a8d85683d0$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions)
                            ];
                        case 2:
                            overflow = _state.sent();
                            return [
                                4,
                                platform.detectOverflow(nextArgs, (0, $lf4fc._)((0, $hwO3w._)({}, detectOverflowOptions), {
                                    elementContext: 'reference'
                                }))
                            ];
                        case 3:
                            refOverflow = _state.sent();
                            diffY = (0, $f756166b2b894b06$export$8960430cfd85939f)(0, overflow.top);
                            nextY = nextArgs.y + diffY;
                            isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
                            rounder = isScrollable ? function(v) {
                                return v;
                            } : (0, $f756166b2b894b06$export$2077e0241d6afd3c);
                            maxHeight = rounder((0, $f756166b2b894b06$export$8960430cfd85939f)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $f756166b2b894b06$export$8960430cfd85939f)(0, overflow.bottom)));
                            scrollEl.style.maxHeight = maxHeight + "px";
                            scrollEl.scrollTop = diffY;
                            // There is not enough space, fallback to standard anchored positioning
                            if (onFallbackChange) {
                                shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $f756166b2b894b06$export$96ec731ed4dcb222)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                                $eAxYl.flushSync(function() {
                                    return onFallbackChange(shouldFallback);
                                });
                            }
                            if (!overflowRef) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                platform.detectOverflow($ad76f2a8d85683d0$var$getArgsWithCustomFloatingHeight((0, $lf4fc._)((0, $hwO3w._)({}, nextArgs), {
                                    y: nextY
                                }), scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions)
                            ];
                        case 4:
                            overflowRef.current = _state.sent();
                            _state.label = 5;
                        case 5:
                            return [
                                2,
                                {
                                    y: nextY
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ function $ad76f2a8d85683d0$export$3d74b0dda7cc82ff(context, props) {
    var open = context.open, elements = context.elements;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, overflowRef = props.overflowRef, scrollRef = props.scrollRef, unstable_onChange = props.onChange;
    var onChange = (0, $72ad0bd1c5aa7773$export$7f54fc3180508a52)(unstable_onChange);
    var controlledScrollingRef = $5s1kH.useRef(false);
    var prevScrollTopRef = $5s1kH.useRef(null);
    var initialOverflowRef = $5s1kH.useRef(null);
    $5s1kH.useEffect(function() {
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            var dY = e.deltaY;
            var isAtTop = overflowRef.current.top >= -0.5;
            var isAtBottom = overflowRef.current.bottom >= -0.5;
            var remainingScroll = el.scrollHeight - el.clientHeight;
            var sign = dY < 0 ? -1 : 1;
            var method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $eAxYl.flushSync(function() {
                    onChange(function(d) {
                        return d + Math[method](dY, remainingScroll * sign);
                    });
                });
            } else if (/firefox/i.test((0, $72ad0bd1c5aa7773$export$7935961ef7719cb0)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        var el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(function() {
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = (0, $hwO3w._)({}, overflowRef.current);
            });
            return function() {
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    var floating = $5s1kH.useMemo(function() {
        return {
            onKeyDown: function() {
                controlledScrollingRef.current = true;
            },
            onWheel: function() {
                controlledScrollingRef.current = false;
            },
            onPointerMove: function() {
                controlledScrollingRef.current = false;
            },
            onScroll: function() {
                var el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    var scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $eAxYl.flushSync(function() {
                        return onChange(function(d) {
                            return d + scrollDiff;
                        });
                    });
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(function() {
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        };
    }, [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $5s1kH.useMemo(function() {
        return enabled ? {
            floating: floating
        } : {};
    }, [
        enabled,
        floating
    ]);
}
function $ad76f2a8d85683d0$var$getNodeChildren(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    var directChildren = nodes.filter(function(node) {
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap(function(child) {
        return [
            child
        ].concat((0, $XnYkK._)($ad76f2a8d85683d0$var$getNodeChildren(nodes, child.id, onlyOpenChildren)));
    });
}
function $ad76f2a8d85683d0$var$isPointInPolygon(point, polygon) {
    var _point = (0, $6iP9u._)(point, 2), x = _point[0], y = _point[1];
    var isInside = false;
    var length = polygon.length;
    for(var i = 0, j = length - 1; i < length; j = i++){
        var _ref = (0, $6iP9u._)(polygon[i] || [
            0,
            0
        ], 2), xi = _ref[0], yi = _ref[1];
        var _ref1 = (0, $6iP9u._)(polygon[j] || [
            0,
            0
        ], 2), xj = _ref1[0], yj = _ref1[1];
        var intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $ad76f2a8d85683d0$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $ad76f2a8d85683d0$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    var _options_buffer = options.buffer, buffer = _options_buffer === void 0 ? 0.5 : _options_buffer, _options_blockPointerEvents = options.blockPointerEvents, blockPointerEvents = _options_blockPointerEvents === void 0 ? false : _options_blockPointerEvents, _options_requireIntent = options.requireIntent, requireIntent = _options_requireIntent === void 0 ? true : _options_requireIntent;
    var timeoutRef = {
        current: -1
    };
    var hasLanded = false;
    var lastX = null;
    var lastY = null;
    var lastCursorTime = typeof performance !== 'undefined' ? performance.now() : 0;
    function getCursorSpeed(x, y) {
        var currentTime = performance.now();
        var elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        var deltaX = x - lastX;
        var deltaY = y - lastY;
        var distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        var speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    var fn = function(_ref) {
        var x = _ref.x, y = _ref.y, placement = _ref.placement, elements = _ref.elements, onClose = _ref.onClose, nodeId = _ref.nodeId, tree = _ref.tree;
        return function onMouseMove(event) {
            function close() {
                $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutRef);
                onClose();
            }
            $ad76f2a8d85683d0$var$clearTimeoutIfSet(timeoutRef);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            var clientX = event.clientX, clientY = event.clientY;
            var clientPoint = [
                clientX,
                clientY
            ];
            var target = $ad76f2a8d85683d0$var$getTarget(event);
            var isLeave = event.type === 'mouseleave';
            var isOverFloatingEl = $ad76f2a8d85683d0$var$contains(elements.floating, target);
            var isOverReferenceEl = $ad76f2a8d85683d0$var$contains(elements.domReference, target);
            var refRect = elements.domReference.getBoundingClientRect();
            var rect = elements.floating.getBoundingClientRect();
            var side = placement.split('-')[0];
            var cursorLeaveFromRight = x > rect.right - rect.width / 2;
            var cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            var isOverReferenceRect = $ad76f2a8d85683d0$var$isInside(clientPoint, refRect);
            var isFloatingWider = rect.width > refRect.width;
            var isFloatingTaller = rect.height > refRect.height;
            var left = (isFloatingWider ? refRect : rect).left;
            var right = (isFloatingWider ? refRect : rect).right;
            var top = (isFloatingTaller ? refRect : rect).top;
            var bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $2a4197d9582b0915$export$45a5e7f76e0caa8d)(event.relatedTarget) && $ad76f2a8d85683d0$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $ad76f2a8d85683d0$var$getNodeChildren(tree.nodesRef.current, nodeId).length) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            var rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref2) {
                var _$_ref2 = (0, $6iP9u._)(_ref2, 2), x = _$_ref2[0], y = _$_ref2[1];
                switch(side){
                    case 'top':
                        {
                            var cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            var cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            var commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo
                            ].concat((0, $XnYkK._)(commonPoints));
                        }
                    case 'bottom':
                        {
                            var cursorPointOne1 = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            var cursorPointTwo1 = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            var commonPoints1 = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne1,
                                cursorPointTwo1
                            ].concat((0, $XnYkK._)(commonPoints1));
                        }
                    case 'left':
                        {
                            var cursorPointOne2 = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            var cursorPointTwo2 = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            var commonPoints2 = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return (0, $XnYkK._)(commonPoints2).concat([
                                cursorPointOne2,
                                cursorPointTwo2
                            ]);
                        }
                    case 'right':
                        {
                            var cursorPointOne3 = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            var cursorPointTwo3 = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            var commonPoints3 = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne3,
                                cursorPointTwo3
                            ].concat((0, $XnYkK._)(commonPoints3));
                        }
                }
            }
            if ($ad76f2a8d85683d0$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                var cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                var cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$ad76f2a8d85683d0$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutRef.current = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}



var $eAxYl = parcelRequire("eAxYl");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $393fb8fc0a86de60$var$_extendStatics = function extendStatics(d, b) {
    $393fb8fc0a86de60$var$_extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $393fb8fc0a86de60$var$_extendStatics(d, b);
};
function $393fb8fc0a86de60$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $393fb8fc0a86de60$var$_extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $393fb8fc0a86de60$var$_assign = function __assign() {
    $393fb8fc0a86de60$var$_assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $393fb8fc0a86de60$var$_assign.apply(this, arguments);
};
function $393fb8fc0a86de60$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $393fb8fc0a86de60$export$946daa762919616e = function CalendarContainer(_a) {
    var _b = _a.showTimeSelectOnly, showTimeSelectOnly = _b === void 0 ? false : _b, _c = _a.showTime, showTime = _c === void 0 ? false : _c, className = _a.className, children = _a.children, inline = _a.inline;
    var ariaLabel = showTimeSelectOnly ? "Choose Time" : "Choose Date".concat(showTime ? " and Time" : "");
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        className: className,
        "aria-label": ariaLabel,
        role: inline ? undefined : "dialog",
        "aria-modal": inline ? undefined : "true",
        translate: "no"
    }, children);
};
var $393fb8fc0a86de60$var$useDetectClickOutside = function useDetectClickOutside(onClickOutside, ignoreClass) {
    var ref = (0, $5s1kH.useRef)(null);
    var onClickOutsideRef = (0, $5s1kH.useRef)(onClickOutside);
    (0, $5s1kH.useEffect)(function() {
        onClickOutsideRef.current = onClickOutside;
    }, [
        onClickOutside
    ]);
    var handleClickOutside = (0, $5s1kH.useCallback)(function(event) {
        var _a;
        var target = event.composed && event.composedPath && event.composedPath().find(function(eventTarget) {
            return eventTarget instanceof Node;
        }) || event.target;
        if (ref.current && !ref.current.contains(target)) {
            if (!(ignoreClass && target instanceof HTMLElement && target.classList.contains(ignoreClass))) (_a = onClickOutsideRef.current) === null || _a === void 0 || _a.call(onClickOutsideRef, event);
        }
    }, [
        ignoreClass
    ]);
    (0, $5s1kH.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    return ref;
};
var $393fb8fc0a86de60$var$ClickOutsideWrapper = function ClickOutsideWrapper(_a) {
    var children = _a.children, onClickOutside = _a.onClickOutside, className = _a.className, containerRef = _a.containerRef, style = _a.style, ignoreClass = _a.ignoreClass;
    var detectRef = $393fb8fc0a86de60$var$useDetectClickOutside(onClickOutside, ignoreClass);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        className: className,
        style: style,
        ref: function ref(node) {
            detectRef.current = node;
            if (containerRef) containerRef.current = node;
        }
    }, children);
};
// Cache for the date-fns-tz module
var $393fb8fc0a86de60$var$dateFnsTz = null;
var $393fb8fc0a86de60$var$dateFnsTzLoadAttempted = false;
/**
 * Attempts to load date-fns-tz module.
 * Returns null if the module is not installed.
 */ function $393fb8fc0a86de60$var$getDateFnsTz() {
    if ($393fb8fc0a86de60$var$dateFnsTzLoadAttempted) return $393fb8fc0a86de60$var$dateFnsTz;
    $393fb8fc0a86de60$var$dateFnsTzLoadAttempted = true;
    try {
        // Dynamic require for date-fns-tz
        // Use a variable to prevent webpack from statically analyzing the require
        // and showing warnings when the optional dependency is not installed
        // See: https://github.com/Hacker0x01/react-datepicker/issues/6154
        var dateFnsTzModuleName = "date-fns-tz";
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        $393fb8fc0a86de60$var$dateFnsTz = require(dateFnsTzModuleName);
    } catch (_a) {
        /* istanbul ignore next - only executes when date-fns-tz is not installed */ $393fb8fc0a86de60$var$dateFnsTz = null;
    }
    return $393fb8fc0a86de60$var$dateFnsTz;
}
/**
 * Converts a date to the specified timezone.
 * If no timezone is specified or date-fns-tz is not installed, returns the original date.
 *
 * @param date - The date to convert
 * @param timeZone - The IANA timezone identifier (e.g., "America/New_York", "UTC")
 * @returns The date in the specified timezone
 */ function $393fb8fc0a86de60$var$toZonedTime(date, timeZone) {
    if (!timeZone) return date;
    var tz = $393fb8fc0a86de60$var$getDateFnsTz();
    if (!tz) return date;
    return tz.toZonedTime(date, timeZone);
}
/**
 * Converts a date from the specified timezone to UTC.
 * If no timezone is specified or date-fns-tz is not installed, returns the original date.
 *
 * @param date - The date in the specified timezone
 * @param timeZone - The IANA timezone identifier (e.g., "America/New_York", "UTC")
 * @returns The date in UTC
 */ function $393fb8fc0a86de60$var$fromZonedTime(date, timeZone) {
    if (!timeZone) return date;
    var tz = $393fb8fc0a86de60$var$getDateFnsTz();
    if (!tz) return date;
    return tz.fromZonedTime(date, timeZone);
}
var $393fb8fc0a86de60$var$KeyType;
(function(KeyType) {
    KeyType["ArrowUp"] = "ArrowUp";
    KeyType["ArrowDown"] = "ArrowDown";
    KeyType["ArrowLeft"] = "ArrowLeft";
    KeyType["ArrowRight"] = "ArrowRight";
    KeyType["PageUp"] = "PageUp";
    KeyType["PageDown"] = "PageDown";
    KeyType["Home"] = "Home";
    KeyType["End"] = "End";
    KeyType["Enter"] = "Enter";
    KeyType["Space"] = " ";
    KeyType["Tab"] = "Tab";
    KeyType["Escape"] = "Escape";
    KeyType["Backspace"] = "Backspace";
    KeyType["X"] = "x";
})($393fb8fc0a86de60$var$KeyType || ($393fb8fc0a86de60$var$KeyType = {}));
function $393fb8fc0a86de60$var$getLocaleScope() {
    // Use this cast to avoid messing with users globalThis (like window) and the rest of keys in the globalThis object we don't care about
    var scope = typeof window !== "undefined" ? window : globalThis;
    return scope;
}
var $393fb8fc0a86de60$var$DEFAULT_YEAR_ITEM_NUMBER = 12;
// ** Date Constructors **
function $393fb8fc0a86de60$var$newDate(value) {
    if (value == null) return new Date();
    var d = typeof value === "string" ? (0, $63e99f1c8dd3b768$export$4393d2ccbbedb219)(value) : (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(value);
    return $393fb8fc0a86de60$var$isValid(d) ? d : new Date();
}
/**
 * Parses a date.
 *
 * @param value - The string representing the Date in a parsable form, e.g., ISO 1861
 * @param dateFormat - The date format.
 * @param locale - The locale.
 * @param strictParsing - The strict parsing flag.
 * @param refDate - The base date to be passed to date-fns parse() function.
 * @returns - The parsed date or null.
 */ function $393fb8fc0a86de60$var$parseDate(value, dateFormat, locale, strictParsing, refDate) {
    if (refDate === void 0) refDate = $393fb8fc0a86de60$var$newDate();
    var localeObject = $393fb8fc0a86de60$var$getLocaleObject(locale) || $393fb8fc0a86de60$var$getLocaleObject($393fb8fc0a86de60$export$f09106e7c6677ec5());
    var formats = Array.isArray(dateFormat) ? dateFormat : [
        dateFormat
    ];
    for(var _i = 0, formats_1 = formats; _i < formats_1.length; _i++){
        var format_1 = formats_1[_i];
        var parsedDate = (0, $9e9a1e7c81c692b8$export$98e6a39c04603d36)(value, format_1, refDate, {
            locale: localeObject,
            useAdditionalWeekYearTokens: true,
            useAdditionalDayOfYearTokens: true
        });
        if ($393fb8fc0a86de60$var$isValid(parsedDate) && (!strictParsing || value === $393fb8fc0a86de60$var$formatDate(parsedDate, format_1, locale))) return parsedDate;
    }
    // When strictParsing is false, try native Date parsing as a fallback
    // This allows flexible input formats like "12/05/2025" or "2025-12-16"
    // even when the dateFormat prop specifies a different format.
    // Only attempt this for inputs that look like complete dates (minimum
    // length of 8 characters, e.g., "1/1/2000") to avoid parsing partial
    // inputs like "03/" or "2000" which should be handled by parseDateForNavigation.
    if (!strictParsing && value && value.length >= 8) {
        var nativeDate = new Date(value);
        if ((0, $182c023b950d4f49$export$1ea939691cdc45b8)(nativeDate)) return nativeDate;
    }
    return null;
}
/**
 * Parses a partial date string for calendar navigation purposes.
 * Unlike parseDate, this function attempts to extract whatever date
 * information is available (year, month) from a partial input,
 * returning a date suitable for navigating the calendar view.
 *
 * @param value - The date string to parse.
 * @param refDate - The reference date to use for missing components.
 * @returns - A date for navigation or null if no date info could be extracted.
 */ function $393fb8fc0a86de60$var$parseDateForNavigation(value, refDate) {
    if (refDate === void 0) refDate = $393fb8fc0a86de60$var$newDate();
    if (!value) return null;
    // Try to extract a 4-digit year from the input
    var yearMatch = value.match(/\b(1\d{3}|2\d{3})\b/);
    if (!yearMatch || !yearMatch[1]) return null;
    var year = parseInt(yearMatch[1], 10);
    // Try to extract a month (1-12) from the input
    // Look for patterns like "03/", "/03", "03-", "-03" or standalone "03" at start
    var monthMatch = value.match(/(?:^|[/\-\s])?(0?[1-9]|1[0-2])(?:[/\-\s]|$)/);
    var month = monthMatch && monthMatch[1] ? parseInt(monthMatch[1], 10) - 1 : refDate.getMonth();
    // Return a date with the extracted year and month, using day 1
    return new Date(year, month, 1);
}
/**
 * Checks if a given date is a valid Date object.
 * @param date - The date to be checked.
 * @returns A boolean value indicating whether the date is valid.
 */ function $393fb8fc0a86de60$var$isValid(date) {
    return (0, $182c023b950d4f49$export$1ea939691cdc45b8)(date);
}
/**
 * Safely returns a valid Date or null.
 * This handles cases where a value might be passed as a string or other
 * invalid type at runtime, even though TypeScript expects a Date.
 * @param date - The value to check (typed as Date but could be anything at runtime)
 * @returns The date if it's a valid Date object, otherwise null
 */ function $393fb8fc0a86de60$var$safeToDate(date) {
    if (date == null) return null;
    // Check if it's actually a Date object AND is valid
    if ((0, $3f7a13fe08643584$export$871608497c498473)(date) && (0, $182c023b950d4f49$export$1ea939691cdc45b8)(date)) return date;
    return null;
}
// ** Date Formatting **
/**
 * Formats a date.
 *
 * @param date - The date.
 * @param formatStr - The format string.
 * @param locale - The locale.
 * @returns - The formatted date.
 */ function $393fb8fc0a86de60$var$formatDate(date, formatStr, locale) {
    if (locale === "en") return (0, $e95f60e70b4946e2$export$d9468344d3651243)(date, formatStr, {
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
    });
    var localeObj = locale ? $393fb8fc0a86de60$var$getLocaleObject(locale) : undefined;
    if (locale && !localeObj) console.warn("A locale object was not found for the provided string [\"".concat(locale, "\"]."));
    localeObj = localeObj || $393fb8fc0a86de60$var$getLocaleObject($393fb8fc0a86de60$export$f09106e7c6677ec5());
    return (0, $e95f60e70b4946e2$export$d9468344d3651243)(date, formatStr, {
        locale: localeObj,
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
    });
}
/**
 * Safely formats a date.
 *
 * @param date - The date.
 * @param options - An object containing the dateFormat and locale.
 * @returns - The formatted date or an empty string.
 */ function $393fb8fc0a86de60$var$safeDateFormat(date, _a) {
    var dateFormat = _a.dateFormat, locale = _a.locale;
    var formatStr = Array.isArray(dateFormat) && dateFormat.length > 0 ? dateFormat[0] : dateFormat; // Cast to string because it's impossible to get `string | string[] | undefined` here and typescript doesn't know that
    return date && $393fb8fc0a86de60$var$formatDate(date, formatStr, locale) || "";
}
/**
 * Used as a delimiter to separate two dates when formatting a date range
 */ var $393fb8fc0a86de60$var$DATE_RANGE_SEPARATOR = " - ";
/**
 * Safely formats a date range.
 *
 * @param startDate - The start date.
 * @param endDate - The end date.
 * @param props - The props.
 * @returns - The formatted date range or an empty string.
 */ function $393fb8fc0a86de60$var$safeDateRangeFormat(startDate, endDate, props) {
    if (!startDate && !endDate) return "";
    var formattedStartDate = startDate ? $393fb8fc0a86de60$var$safeDateFormat(startDate, props) : "";
    var formattedEndDate = endDate ? $393fb8fc0a86de60$var$safeDateFormat(endDate, props) : "";
    var dateRangeSeparator = props.rangeSeparator || $393fb8fc0a86de60$var$DATE_RANGE_SEPARATOR;
    return "".concat(formattedStartDate).concat(dateRangeSeparator).concat(formattedEndDate);
}
/**
 * Safely formats multiple dates.
 *
 * @param dates - The dates.
 * @param props - The props.
 * @returns - The formatted dates or an empty string.
 */ function $393fb8fc0a86de60$var$safeMultipleDatesFormat(dates, props) {
    if (!(dates === null || dates === void 0 ? void 0 : dates.length)) return "";
    var formattedFirstDate = dates[0] ? $393fb8fc0a86de60$var$safeDateFormat(dates[0], props) : "";
    if (dates.length === 1) return formattedFirstDate;
    if (dates.length === 2 && dates[1]) {
        var formattedSecondDate = $393fb8fc0a86de60$var$safeDateFormat(dates[1], props);
        return "".concat(formattedFirstDate, ", ").concat(formattedSecondDate);
    }
    var extraDatesCount = dates.length - 1;
    return "".concat(formattedFirstDate, " (+").concat(extraDatesCount, ")");
}
// ** Date Setters **
/**
 * Sets the time for a given date.
 *
 * @param date - The date.
 * @param time - An object containing the hour, minute, and second.
 * @returns - The date with the time set.
 */ function $393fb8fc0a86de60$var$setTime(date, _a) {
    var _b = _a.hour, hour = _b === void 0 ? 0 : _b, _c = _a.minute, minute = _c === void 0 ? 0 : _c, _d = _a.second, second = _d === void 0 ? 0 : _d;
    return (0, $c2fa690605034bd4$export$f86b797a4659b781)((0, $6b415c24a65aeb3f$export$ad569bf1c79ea89d)((0, $80943fd5721c49ab$export$aec44746644cbf43)(date, second), minute), hour);
}
/**
 * Gets the week of the year for a given date.
 *
 * @param date - The date.
 * @returns - The week of the year.
 */ function $393fb8fc0a86de60$var$getWeek(date) {
    return (0, $bef7c8dcc2b7b577$export$7cabdc5698b63e2f)(date);
}
/**
 * Gets the day of the week code for a given day.
 *
 * @param day - The day.
 * @param locale - The locale.
 * @returns - The day of the week code.
 */ function $393fb8fc0a86de60$var$getDayOfWeekCode(day, locale) {
    return $393fb8fc0a86de60$var$formatDate(day, "ddd", locale);
}
// *** Start of ***
/**
 * Gets the start of the day for a given date.
 *
 * @param date - The date.
 * @returns - The start of the day.
 */ function $393fb8fc0a86de60$var$getStartOfDay(date) {
    return (0, $e4ccc1375d9fa1c3$export$63fa379ae8a9ba2)(date);
}
/**
 * Gets the start of the week for a given date.
 *
 * @param date - The date.
 * @param locale - The locale.
 * @param calendarStartDay - The day the calendar starts on.
 * @returns - The start of the week.
 */ function $393fb8fc0a86de60$var$getStartOfWeek(date, locale, calendarStartDay) {
    var localeObj = locale ? $393fb8fc0a86de60$var$getLocaleObject(locale) : $393fb8fc0a86de60$var$getLocaleObject($393fb8fc0a86de60$export$f09106e7c6677ec5());
    return (0, $511d10c46cf5757e$export$42c81a444fbfb5d4)(date, {
        locale: localeObj,
        weekStartsOn: calendarStartDay
    });
}
/**
 * Gets the start of the month for a given date.
 *
 * @param date - The date.
 * @returns - The start of the month.
 */ function $393fb8fc0a86de60$var$getStartOfMonth(date) {
    return (0, $d247a4bca7416de5$export$a5a3b454ada2268e)(date);
}
/**
 * Gets the start of the year for a given date.
 *
 * @param date - The date.
 * @returns - The start of the year.
 */ function $393fb8fc0a86de60$var$getStartOfYear(date) {
    return (0, $7aef50853e997e42$export$f91e89d3d0406102)(date);
}
/**
 * Gets the start of the quarter for a given date.
 *
 * @param date - The date.
 * @returns - The start of the quarter.
 */ function $393fb8fc0a86de60$var$getStartOfQuarter(date) {
    return (0, $74ef9e652b0920d7$export$69be7267a042ecb3)(date);
}
/**
 * Gets the start of today.
 *
 * @returns - The start of today.
 */ function $393fb8fc0a86de60$var$getStartOfToday() {
    return (0, $e4ccc1375d9fa1c3$export$63fa379ae8a9ba2)($393fb8fc0a86de60$var$newDate());
}
// *** End of ***
/**
 * Gets the end of the day for a given date.
 *
 * @param date - The date.
 * @returns - The end of the day.
 */ function $393fb8fc0a86de60$var$getEndOfDay(date) {
    return (0, $9a1f6103452c72c5$export$eb9a03f0e9aa6cea)(date);
}
/**
 * Gets the end of the week for a given date.
 *
 * @param date - The date.
 * @returns - The end of the week.
 */ function $393fb8fc0a86de60$var$getEndOfWeek(date) {
    return (0, $df2e23426bf9e370$export$ef8b6d9133084f4e)(date);
}
/**
 * Gets the end of the month for a given date.
 *
 * @param date - The date.
 * @returns - The end of the month.
 */ function $393fb8fc0a86de60$var$getEndOfMonth(date) {
    return (0, $5e5a98b8b0b1e40d$export$a2258d9c4118825c)(date);
}
/**
 * Checks if two dates are in the same year.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same year, false otherwise.
 */ function $393fb8fc0a86de60$var$isSameYear(date1, date2) {
    if (date1 && date2) return (0, $f789575999abe89d$export$5841f9eb9773f25f)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are in the same month.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same month, false otherwise.
 */ function $393fb8fc0a86de60$var$isSameMonth(date1, date2) {
    if (date1 && date2) return (0, $40ebfe802eb13cad$export$a18c89cbd24170ff)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are in the same quarter.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same quarter, false otherwise.
 */ function $393fb8fc0a86de60$var$isSameQuarter(date1, date2) {
    if (date1 && date2) return (0, $5b88cf2109649193$export$5c60e4190867161c)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are on the same day.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are on the same day, false otherwise.
 */ function $393fb8fc0a86de60$var$isSameDay(date1, date2) {
    if (date1 && date2) return (0, $04e2d0106a319fd0$export$ea39ec197993aef0)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are equal.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are equal, false otherwise.
 */ function $393fb8fc0a86de60$var$isEqual(date1, date2) {
    if (date1 && date2) return (0, $b090f423df9beee1$export$248d38f6296296c5)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if a day is within a date range.
 *
 * @param day - The day to check.
 * @param startDate - The start date of the range.
 * @param endDate - The end date of the range.
 * @returns - True if the day is within the range, false otherwise.
 */ function $393fb8fc0a86de60$var$isDayInRange(day, startDate, endDate) {
    var valid;
    var start = (0, $e4ccc1375d9fa1c3$export$63fa379ae8a9ba2)(startDate);
    var end = (0, $9a1f6103452c72c5$export$eb9a03f0e9aa6cea)(endDate);
    try {
        valid = (0, $80f090dfcae59d9d$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    } catch (err) {
        valid = false;
    }
    return valid;
}
// ** Date Localization **
/**
 * Registers a locale.
 *
 * @param localeName - The name of the locale.
 * @param localeData - The data of the locale.
 */ function $393fb8fc0a86de60$export$bab6a7822cc1e2cd(localeName, localeData) {
    var scope = $393fb8fc0a86de60$var$getLocaleScope();
    if (!scope.__localeData__) scope.__localeData__ = {};
    scope.__localeData__[localeName] = localeData;
}
/**
 * Sets the default locale.
 *
 * @param localeName - The name of the locale.
 */ function $393fb8fc0a86de60$export$a1a5025df4e9ba34(localeName) {
    var scope = $393fb8fc0a86de60$var$getLocaleScope();
    scope.__localeId__ = localeName;
}
/**
 * Gets the default locale.
 *
 * @returns - The default locale.
 */ function $393fb8fc0a86de60$export$f09106e7c6677ec5() {
    var scope = $393fb8fc0a86de60$var$getLocaleScope();
    return scope.__localeId__;
}
/**
 * Gets the locale object.
 *
 * @param localeSpec - The locale specification.
 * @returns - The locale object.
 */ function $393fb8fc0a86de60$var$getLocaleObject(localeSpec) {
    if (typeof localeSpec === "string") {
        // Treat it as a locale name registered by registerLocale
        var scope = $393fb8fc0a86de60$var$getLocaleScope();
        // Null was replaced with undefined to avoid type coercion
        return scope.__localeData__ ? scope.__localeData__[localeSpec] : undefined;
    } else // Treat it as a raw date-fns locale object
    return localeSpec;
}
/**
 * Formats the weekday in a given locale.
 *
 * @param date - The date to format.
 * @param formatFunc - The formatting function.
 * @param locale - The locale to use for formatting.
 * @returns - The formatted weekday.
 */ function $393fb8fc0a86de60$var$getFormattedWeekdayInLocale(date, formatFunc, locale) {
    return formatFunc($393fb8fc0a86de60$var$formatDate(date, "EEEE", locale));
}
/**
 * Gets the minimum weekday in a given locale.
 *
 * @param date - The date to format.
 * @param locale - The locale to use for formatting.
 * @returns - The minimum weekday.
 */ function $393fb8fc0a86de60$var$getWeekdayMinInLocale(date, locale) {
    return $393fb8fc0a86de60$var$formatDate(date, "EEEEEE", locale);
}
/**
 * Gets the short weekday in a given locale.
 *
 * @param date - The date to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short weekday.
 */ function $393fb8fc0a86de60$var$getWeekdayShortInLocale(date, locale) {
    return $393fb8fc0a86de60$var$formatDate(date, "EEE", locale);
}
/**
 * Gets the month in a given locale.
 *
 * @param month - The month to format.
 * @param locale - The locale to use for formatting.
 * @returns - The month.
 */ function $393fb8fc0a86de60$var$getMonthInLocale(month, locale) {
    return $393fb8fc0a86de60$var$formatDate((0, $d26b511e86cf447a$export$63264690f8e36790)($393fb8fc0a86de60$var$newDate(), month), "LLLL", locale);
}
/**
 * Gets the short month in a given locale.
 *
 * @param month - The month to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short month.
 */ function $393fb8fc0a86de60$var$getMonthShortInLocale(month, locale) {
    return $393fb8fc0a86de60$var$formatDate((0, $d26b511e86cf447a$export$63264690f8e36790)($393fb8fc0a86de60$var$newDate(), month), "LLL", locale);
}
/**
 * Gets the short quarter in a given locale.
 *
 * @param quarter - The quarter to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short quarter.
 */ function $393fb8fc0a86de60$var$getQuarterShortInLocale(quarter, locale) {
    return $393fb8fc0a86de60$var$formatDate((0, $777d75a7e7ff73c1$export$8924d1de7efe1755)($393fb8fc0a86de60$var$newDate(), quarter), "QQQ", locale);
}
/**
 * Checks if a day is disabled.
 *
 * @param day - The day to check.
 * @param options - The options to consider when checking.
 * @returns - Returns true if the day is disabled, false otherwise.
 */ function $393fb8fc0a86de60$var$isDayDisabled(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals, includeDates = _b.includeDates, includeDateIntervals = _b.includeDateIntervals, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    return $393fb8fc0a86de60$var$isOutOfBounds(day, {
        minDate: minDate,
        maxDate: maxDate
    }) || excludeDates && excludeDates.some(function(excludeDate) {
        if (excludeDate instanceof Date) return $393fb8fc0a86de60$var$isSameDay(day, excludeDate);
        else return $393fb8fc0a86de60$var$isSameDay(day, excludeDate.date);
    }) || excludeDateIntervals && excludeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $80f090dfcae59d9d$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    }) || includeDates && !includeDates.some(function(includeDate) {
        return $393fb8fc0a86de60$var$isSameDay(day, includeDate);
    }) || includeDateIntervals && !includeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $80f090dfcae59d9d$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    }) || filterDate && !filterDate($393fb8fc0a86de60$var$newDate(day)) || false;
}
/**
 * Checks if a day is excluded.
 *
 * @param day - The day to check.
 * @param options - The options to consider when checking.
 * @returns - Returns true if the day is excluded, false otherwise.
 */ function $393fb8fc0a86de60$var$isDayExcluded(day, _a) {
    var _b = _a === void 0 ? {} : _a, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals;
    if (excludeDateIntervals && excludeDateIntervals.length > 0) return excludeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $80f090dfcae59d9d$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    });
    return excludeDates && excludeDates.some(function(excludeDate) {
        var _$_a;
        if (excludeDate instanceof Date) return $393fb8fc0a86de60$var$isSameDay(day, excludeDate);
        else return $393fb8fc0a86de60$var$isSameDay(day, (_$_a = excludeDate.date) !== null && _$_a !== void 0 ? _$_a : new Date());
    }) || false;
}
function $393fb8fc0a86de60$var$isMonthDisabled(month, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
    return $393fb8fc0a86de60$var$isOutOfBounds(month, {
        minDate: minDate ? (0, $d247a4bca7416de5$export$a5a3b454ada2268e)(minDate) : undefined,
        maxDate: maxDate ? (0, $5e5a98b8b0b1e40d$export$a2258d9c4118825c)(maxDate) : undefined
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $393fb8fc0a86de60$var$isSameMonth(month, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $393fb8fc0a86de60$var$isSameMonth(month, includeDate);
    }) || filterDate && !filterDate($393fb8fc0a86de60$var$newDate(month)) || false;
}
function $393fb8fc0a86de60$var$isMonthInRange(startDate, endDate, m, day) {
    var startDateYear = (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(startDate);
    var startDateMonth = (0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)(startDate);
    var endDateYear = (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(endDate);
    var endDateMonth = (0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)(endDate);
    var dayYear = (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(day);
    if (startDateYear === endDateYear && startDateYear === dayYear) return startDateMonth <= m && m <= endDateMonth;
    else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateMonth <= m || dayYear === endDateYear && endDateMonth >= m || dayYear < endDateYear && dayYear > startDateYear;
    return false;
}
/**
 * To check if a date's month and year are disabled/excluded
 * @param date Date to check
 * @returns {boolean} true if month and year are disabled/excluded, false otherwise
 */ function $393fb8fc0a86de60$var$isMonthYearDisabled(date, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
    return $393fb8fc0a86de60$var$isOutOfBounds(date, {
        minDate: minDate,
        maxDate: maxDate
    }) || excludeDates && excludeDates.some(function(excludedDate) {
        return $393fb8fc0a86de60$var$isSameMonth(excludedDate instanceof Date ? excludedDate : excludedDate.date, date);
    }) || includeDates && !includeDates.some(function(includedDate) {
        return $393fb8fc0a86de60$var$isSameMonth(includedDate, date);
    }) || false;
}
function $393fb8fc0a86de60$var$isQuarterDisabled(quarter, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    return $393fb8fc0a86de60$var$isOutOfBounds(quarter, {
        minDate: minDate,
        maxDate: maxDate
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $393fb8fc0a86de60$var$isSameQuarter(quarter, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $393fb8fc0a86de60$var$isSameQuarter(quarter, includeDate);
    }) || filterDate && !filterDate($393fb8fc0a86de60$var$newDate(quarter)) || false;
}
function $393fb8fc0a86de60$var$isYearInRange(year, start, end) {
    if (!start || !end) return false;
    if (!(0, $182c023b950d4f49$export$1ea939691cdc45b8)(start) || !(0, $182c023b950d4f49$export$1ea939691cdc45b8)(end)) return false;
    var startYear = (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(start);
    var endYear = (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(end);
    return startYear <= year && endYear >= year;
}
function $393fb8fc0a86de60$var$isYearDisabled(year, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    var date = new Date(year, 0, 1);
    return $393fb8fc0a86de60$var$isOutOfBounds(date, {
        minDate: minDate ? (0, $7aef50853e997e42$export$f91e89d3d0406102)(minDate) : undefined,
        maxDate: maxDate ? (0, $64f2443f278185ed$export$8b7aa55c66d5569e)(maxDate) : undefined
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $393fb8fc0a86de60$var$isSameYear(date, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $393fb8fc0a86de60$var$isSameYear(date, includeDate);
    }) || filterDate && !filterDate($393fb8fc0a86de60$var$newDate(date)) || false;
}
function $393fb8fc0a86de60$var$isQuarterInRange(startDate, endDate, q, day) {
    var startDateYear = (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(startDate);
    var startDateQuarter = (0, $d5bfd625c8c2dcab$export$de90a4bb31c25221)(startDate);
    var endDateYear = (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(endDate);
    var endDateQuarter = (0, $d5bfd625c8c2dcab$export$de90a4bb31c25221)(endDate);
    var dayYear = (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(day);
    if (startDateYear === endDateYear && startDateYear === dayYear) return startDateQuarter <= q && q <= endDateQuarter;
    else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateQuarter <= q || dayYear === endDateYear && endDateQuarter >= q || dayYear < endDateYear && dayYear > startDateYear;
    return false;
}
function $393fb8fc0a86de60$var$isOutOfBounds(day, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, minDate = _c.minDate, maxDate = _c.maxDate;
    return (_b = minDate && (0, $91bd3590a595579e$export$4a02e9c37dab4871)(day, minDate) < 0 || maxDate && (0, $91bd3590a595579e$export$4a02e9c37dab4871)(day, maxDate) > 0) !== null && _b !== void 0 ? _b : false;
}
function $393fb8fc0a86de60$var$isTimeInList(time, times) {
    return times.some(function(listTime) {
        return (0, $75f9879a8962b028$export$257b40f71c07d58f)(listTime) === (0, $75f9879a8962b028$export$257b40f71c07d58f)(time) && (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(listTime) === (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(time) && (0, $d895bdcba9991f26$export$5e9417507ff28427)(listTime) === (0, $d895bdcba9991f26$export$5e9417507ff28427)(time);
    });
}
function $393fb8fc0a86de60$var$isTimeDisabled(time, _a) {
    var _b = _a === void 0 ? {} : _a, excludeTimes = _b.excludeTimes, includeTimes = _b.includeTimes, filterTime = _b.filterTime;
    return excludeTimes && $393fb8fc0a86de60$var$isTimeInList(time, excludeTimes) || includeTimes && !$393fb8fc0a86de60$var$isTimeInList(time, includeTimes) || filterTime && !filterTime(time) || false;
}
function $393fb8fc0a86de60$var$isTimeInDisabledRange(time, _a) {
    var minTime = _a.minTime, maxTime = _a.maxTime;
    if (!minTime || !maxTime) throw new Error("Both minTime and maxTime props required");
    var baseTime = $393fb8fc0a86de60$var$newDate();
    baseTime = (0, $c2fa690605034bd4$export$f86b797a4659b781)(baseTime, (0, $75f9879a8962b028$export$257b40f71c07d58f)(time));
    baseTime = (0, $6b415c24a65aeb3f$export$ad569bf1c79ea89d)(baseTime, (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(time));
    baseTime = (0, $80943fd5721c49ab$export$aec44746644cbf43)(baseTime, (0, $d895bdcba9991f26$export$5e9417507ff28427)(time));
    var min = $393fb8fc0a86de60$var$newDate();
    min = (0, $c2fa690605034bd4$export$f86b797a4659b781)(min, (0, $75f9879a8962b028$export$257b40f71c07d58f)(minTime));
    min = (0, $6b415c24a65aeb3f$export$ad569bf1c79ea89d)(min, (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(minTime));
    min = (0, $80943fd5721c49ab$export$aec44746644cbf43)(min, (0, $d895bdcba9991f26$export$5e9417507ff28427)(minTime));
    var max = $393fb8fc0a86de60$var$newDate();
    max = (0, $c2fa690605034bd4$export$f86b797a4659b781)(max, (0, $75f9879a8962b028$export$257b40f71c07d58f)(maxTime));
    max = (0, $6b415c24a65aeb3f$export$ad569bf1c79ea89d)(max, (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(maxTime));
    max = (0, $80943fd5721c49ab$export$aec44746644cbf43)(max, (0, $d895bdcba9991f26$export$5e9417507ff28427)(maxTime));
    var valid;
    try {
        valid = !(0, $80f090dfcae59d9d$export$d7deef7a3738e19d)(baseTime, {
            start: min,
            end: max
        });
    } catch (err) {
        /* istanbul ignore next - date-fns historically threw on invalid intervals */ valid = false;
    }
    return valid;
}
function $393fb8fc0a86de60$var$monthDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var previousMonth = (0, $62367543e39b34d6$export$73d1c15a21f9fae5)(day, 1);
    return minDate && (0, $770badfd43ea080d$export$489984ac7c996389)(minDate, previousMonth) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $770badfd43ea080d$export$489984ac7c996389)(includeDate, previousMonth) > 0;
    }) || false;
}
function $393fb8fc0a86de60$var$monthDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var nextMonth = (0, $75507be8d602cbce$export$17c93e242b2d3a22)(day, 1);
    return maxDate && (0, $770badfd43ea080d$export$489984ac7c996389)(nextMonth, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $770badfd43ea080d$export$489984ac7c996389)(nextMonth, includeDate) > 0;
    }) || false;
}
function $393fb8fc0a86de60$var$quarterDisabledBefore(date, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var firstDateOfYear = (0, $7aef50853e997e42$export$f91e89d3d0406102)(date);
    var previousQuarter = (0, $f08d4eb85a22e198$export$a31bfeeeee80cce6)(firstDateOfYear, 1);
    return minDate && (0, $cf55ea31a060baca$export$f62ae9fb13958c7a)(minDate, previousQuarter) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $cf55ea31a060baca$export$f62ae9fb13958c7a)(includeDate, previousQuarter) > 0;
    }) || false;
}
function $393fb8fc0a86de60$var$quarterDisabledAfter(date, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var lastDateOfYear = (0, $64f2443f278185ed$export$8b7aa55c66d5569e)(date);
    var nextQuarter = (0, $40103932dbf37ea0$export$c252a41d0fbed2ce)(lastDateOfYear, 1);
    return maxDate && (0, $cf55ea31a060baca$export$f62ae9fb13958c7a)(nextQuarter, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $cf55ea31a060baca$export$f62ae9fb13958c7a)(nextQuarter, includeDate) > 0;
    }) || false;
}
function $393fb8fc0a86de60$var$yearDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var previousYear = (0, $03aa6c2df8a28792$export$14867687ff6c92e2)(day, 1);
    return minDate && (0, $d93eded5d446b361$export$c06dce8b38891685)(minDate, previousYear) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $d93eded5d446b361$export$c06dce8b38891685)(includeDate, previousYear) > 0;
    }) || false;
}
function $393fb8fc0a86de60$var$yearsDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? $393fb8fc0a86de60$var$DEFAULT_YEAR_ITEM_NUMBER : _c;
    var previousYear = $393fb8fc0a86de60$var$getStartOfYear((0, $03aa6c2df8a28792$export$14867687ff6c92e2)(day, yearItemNumber));
    var endPeriod = $393fb8fc0a86de60$var$getYearsPeriod(previousYear, yearItemNumber).endPeriod;
    var minDateYear = minDate && (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(minDate);
    return minDateYear && minDateYear > endPeriod || false;
}
function $393fb8fc0a86de60$var$yearDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var nextYear = (0, $5c6b1b4dffb22d4b$export$3d83eec43f4ea476)(day, 1);
    return maxDate && (0, $d93eded5d446b361$export$c06dce8b38891685)(nextYear, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $d93eded5d446b361$export$c06dce8b38891685)(nextYear, includeDate) > 0;
    }) || false;
}
function $393fb8fc0a86de60$var$yearsDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? $393fb8fc0a86de60$var$DEFAULT_YEAR_ITEM_NUMBER : _c;
    var nextYear = (0, $5c6b1b4dffb22d4b$export$3d83eec43f4ea476)(day, yearItemNumber);
    var startPeriod = $393fb8fc0a86de60$var$getYearsPeriod(nextYear, yearItemNumber).startPeriod;
    var maxDateYear = maxDate && (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(maxDate);
    return maxDateYear && maxDateYear < startPeriod || false;
}
function $393fb8fc0a86de60$var$getEffectiveMinDate(_a) {
    var minDate = _a.minDate, includeDates = _a.includeDates;
    if (includeDates && minDate) {
        var minDates = includeDates.filter(function(includeDate) {
            return (0, $91bd3590a595579e$export$4a02e9c37dab4871)(includeDate, minDate) >= 0;
        });
        return (0, $9bce878bd8c21516$export$96ec731ed4dcb222)(minDates);
    } else if (includeDates) return (0, $9bce878bd8c21516$export$96ec731ed4dcb222)(includeDates);
    else return minDate;
}
function $393fb8fc0a86de60$var$getEffectiveMaxDate(_a) {
    var maxDate = _a.maxDate, includeDates = _a.includeDates;
    if (includeDates && maxDate) {
        var maxDates = includeDates.filter(function(includeDate) {
            return (0, $91bd3590a595579e$export$4a02e9c37dab4871)(includeDate, maxDate) <= 0;
        });
        return (0, $3eb9c7c0bf6639a5$export$8960430cfd85939f)(maxDates);
    } else if (includeDates) return (0, $3eb9c7c0bf6639a5$export$8960430cfd85939f)(includeDates);
    else return maxDate;
}
/**
 * Get a map of highlighted dates with their corresponding classes.
 * @param highlightDates The dates to highlight.
 * @param defaultClassName The default class to use for highlighting.
 * @returns A map with dates as keys and arrays of class names as values.
 */ function $393fb8fc0a86de60$var$getHighLightDaysMap(highlightDates, defaultClassName) {
    var _a;
    if (highlightDates === void 0) highlightDates = [];
    if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--highlighted";
    var dateClasses = new Map();
    for(var i = 0, len = highlightDates.length; i < len; i++){
        var obj = highlightDates[i];
        if ((0, $3f7a13fe08643584$export$871608497c498473)(obj)) {
            var key = $393fb8fc0a86de60$var$formatDate(obj, "MM.dd.yyyy");
            var classNamesArr = dateClasses.get(key) || [];
            if (!classNamesArr.includes(defaultClassName)) {
                classNamesArr.push(defaultClassName);
                dateClasses.set(key, classNamesArr);
            }
        } else if ((typeof obj === "undefined" ? "undefined" : (0, $03bAP._)(obj)) === "object") {
            var keys = Object.keys(obj);
            var className = (_a = keys[0]) !== null && _a !== void 0 ? _a : "";
            var arrOfDates = obj[className];
            if (typeof className === "string" && Array.isArray(arrOfDates)) for(var k = 0, len_1 = arrOfDates.length; k < len_1; k++){
                var dateK = arrOfDates[k];
                if (dateK) {
                    var key = $393fb8fc0a86de60$var$formatDate(dateK, "MM.dd.yyyy");
                    var classNamesArr = dateClasses.get(key) || [];
                    if (!classNamesArr.includes(className)) {
                        classNamesArr.push(className);
                        dateClasses.set(key, classNamesArr);
                    }
                }
            }
        }
    }
    return dateClasses;
}
/**
 * Compare the two arrays
 * @param array1 The first array to compare.
 * @param array2 The second array to compare.
 * @returns true, if the passed arrays are equal, false otherwise.
 */ function $393fb8fc0a86de60$var$arraysAreEqual(array1, array2) {
    if (array1.length !== array2.length) return false;
    return array1.every(function(value, index) {
        return value === array2[index];
    });
}
/**
 * Assign the custom class to each date
 * @param holidayDates array of object containing date and name of the holiday
 * @param defaultClassName className to be added.
 * @returns Map containing date as key and array of className and holiday name as value
 */ function $393fb8fc0a86de60$var$getHolidaysMap(holidayDates, defaultClassName) {
    if (holidayDates === void 0) holidayDates = [];
    if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--holidays";
    var dateClasses = new Map();
    holidayDates.forEach(function(holiday) {
        var dateObj = holiday.date, holidayName = holiday.holidayName;
        if (!(0, $3f7a13fe08643584$export$871608497c498473)(dateObj)) return;
        var key = $393fb8fc0a86de60$var$formatDate(dateObj, "MM.dd.yyyy");
        var classNamesObj = dateClasses.get(key) || {
            className: "",
            holidayNames: []
        };
        if ("className" in classNamesObj && classNamesObj["className"] === defaultClassName && $393fb8fc0a86de60$var$arraysAreEqual(classNamesObj["holidayNames"], [
            holidayName
        ])) return;
        classNamesObj["className"] = defaultClassName;
        var holidayNameArr = classNamesObj["holidayNames"];
        classNamesObj["holidayNames"] = holidayNameArr ? $393fb8fc0a86de60$var$__spreadArray($393fb8fc0a86de60$var$__spreadArray([], holidayNameArr, true), [
            holidayName
        ], false) : [
            holidayName
        ];
        dateClasses.set(key, classNamesObj);
    });
    return dateClasses;
}
/**
 * Determines the times to inject after a given start of day, current time, and multiplier.
 * @param startOfDay The start of the day.
 * @param currentTime The current time.
 * @param currentMultiplier The current multiplier.
 * @param intervals The intervals.
 * @param injectedTimes The times to potentially inject.
 * @returns An array of times to inject.
 */ function $393fb8fc0a86de60$var$timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
    var l = injectedTimes.length;
    var times = [];
    for(var i = 0; i < l; i++){
        var injectedTime = startOfDay;
        var injectedTimeValue = injectedTimes[i];
        if (injectedTimeValue) {
            injectedTime = (0, $d360d6bbe5b8b7e1$export$4a4306ad4fa0e5e6)(injectedTime, (0, $75f9879a8962b028$export$257b40f71c07d58f)(injectedTimeValue));
            injectedTime = (0, $396b693e3529a905$export$2287e3d29250119e)(injectedTime, (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(injectedTimeValue));
            injectedTime = (0, $ddb59a16cac13111$export$3cb31b0df13be68)(injectedTime, (0, $d895bdcba9991f26$export$5e9417507ff28427)(injectedTimeValue));
        }
        var nextTime = (0, $396b693e3529a905$export$2287e3d29250119e)(startOfDay, (currentMultiplier + 1) * intervals);
        if ((0, $63acaba5662d3256$export$e4de839670987035)(injectedTime, currentTime) && (0, $0e5980f964c532bb$export$5c007e10c6929c95)(injectedTime, nextTime) && injectedTimeValue != undefined) times.push(injectedTimeValue);
    }
    return times;
}
/**
 * Adds a leading zero to a number if it's less than 10.
 * @param i The number to add a leading zero to.
 * @returns The number as a string, with a leading zero if it was less than 10.
 */ function $393fb8fc0a86de60$var$addZero(i) {
    return i < 10 ? "0".concat(i) : "".concat(i);
}
/**
 * Gets the start and end years for a period.
 * @param date The date to get the period for.
 * @param yearItemNumber The number of years in the period. Defaults to DEFAULT_YEAR_ITEM_NUMBER.
 * @returns An object with the start and end years for the period.
 */ function $393fb8fc0a86de60$var$getYearsPeriod(date, yearItemNumber) {
    if (yearItemNumber === void 0) yearItemNumber = $393fb8fc0a86de60$var$DEFAULT_YEAR_ITEM_NUMBER;
    var endPeriod = Math.ceil((0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(date) / yearItemNumber) * yearItemNumber;
    var startPeriod = endPeriod - (yearItemNumber - 1);
    return {
        startPeriod: startPeriod,
        endPeriod: endPeriod
    };
}
/**
 * Gets the number of hours in a day.
 * @param d The date to get the number of hours for.
 * @returns The number of hours in the day.
 */ function $393fb8fc0a86de60$var$getHoursInDay(d) {
    var startOfDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    var startOfTheNextDay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 24);
    return Math.round((+startOfTheNextDay - +startOfDay) / 3600000);
}
/**
 * Returns the start of the minute for the given date
 *
 * NOTE: this function is a DST and timezone-safe analog of `date-fns/startOfMinute`
 * do not make changes unless you know what you're doing
 *
 * See comments on https://github.com/Hacker0x01/react-datepicker/pull/4244
 * for more details
 *
 * @param d date
 * @returns start of the minute
 */ function $393fb8fc0a86de60$var$startOfMinute(d) {
    var seconds = d.getSeconds();
    var milliseconds = d.getMilliseconds();
    return (0, $8d125137b8a7ac52$export$e67a095c620b86fe)(d.getTime() - seconds * 1000 - milliseconds);
}
/**
 * Returns whether the given dates are in the same minute
 *
 * This function is a DST and timezone-safe analog of `date-fns/isSameMinute`
 *
 * @param d1
 * @param d2
 * @returns
 */ function $393fb8fc0a86de60$var$isSameMinute(d1, d2) {
    return $393fb8fc0a86de60$var$startOfMinute(d1).getTime() === $393fb8fc0a86de60$var$startOfMinute(d2).getTime();
}
/**
 * Returns a new datetime object representing the input date with midnight time
 * @param date The date to get the midnight time for
 * @returns A new datetime object representing the input date with midnight time
 */ function $393fb8fc0a86de60$var$getMidnightDate(date) {
    if (!(0, $3f7a13fe08643584$export$871608497c498473)(date)) throw new Error("Invalid date");
    var dateWithoutTime = new Date(date);
    dateWithoutTime.setHours(0, 0, 0, 0);
    return dateWithoutTime;
}
/**
 * Is the first date before the second one?
 * @param date The date that should be before the other one to return true
 * @param dateToCompare The date to compare with
 * @returns The first date is before the second date
 *
 * Note:
 *  This function considers the mid-night of the given dates for comparison.
 *  It evaluates whether date is before dateToCompare based on their mid-night timestamps.
 */ function $393fb8fc0a86de60$var$isDateBefore(date, dateToCompare) {
    if (!(0, $3f7a13fe08643584$export$871608497c498473)(date) || !(0, $3f7a13fe08643584$export$871608497c498473)(dateToCompare)) throw new Error("Invalid date received");
    var midnightDate = $393fb8fc0a86de60$var$getMidnightDate(date);
    var midnightDateToCompare = $393fb8fc0a86de60$var$getMidnightDate(dateToCompare);
    return (0, $0e5980f964c532bb$export$5c007e10c6929c95)(midnightDate, midnightDateToCompare);
}
/**
 * Checks if the space key was pressed down.
 *
 * @param event - The keyboard event.
 * @returns - Returns true if the space key was pressed down, false otherwise.
 */ function $393fb8fc0a86de60$var$isSpaceKeyDown(event) {
    return event.key === $393fb8fc0a86de60$var$KeyType.Space;
}
/**
 * `InputTime` is a React component that manages time input.
 *
 * @component
 * @example
 * <InputTime timeString="12:00" />
 *
 * @param props - The properties that define the `InputTime` component.
 * @param props.onChange - Function that is called when the date changes.
 * @param props.date - The initial date value.
 * @param props.timeString - The initial time string value.
 * @param props.timeInputLabel - The label for the time input.
 * @param props.customTimeInput - An optional custom time input element.
 *
 * @returns The `InputTime` component.
 */ var $393fb8fc0a86de60$var$InputTime = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(InputTime, _super);
    function InputTime(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createRef();
        _this.onTimeChange = function(time) {
            var _a, _b;
            _this.setState({
                time: time
            });
            var propDate = _this.props.date;
            var isPropDateValid = propDate instanceof Date && !isNaN(+propDate);
            var date = isPropDateValid ? propDate : new Date();
            if (time === null || time === void 0 ? void 0 : time.includes(":")) {
                var _c = time.split(":"), hours = _c[0], minutes = _c[1];
                date.setHours(Number(hours));
                date.setMinutes(Number(minutes));
            }
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, date);
        };
        _this.renderTimeInput = function() {
            var time = _this.state.time;
            var _a = _this.props, date = _a.date, timeString = _a.timeString, customTimeInput = _a.customTimeInput;
            if (customTimeInput) return (0, $5s1kH.cloneElement)(customTimeInput, {
                date: date,
                value: time,
                onChange: _this.onTimeChange
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("input", {
                type: "time",
                className: "react-datepicker-time__input",
                placeholder: "Time",
                name: "time-input",
                ref: _this.inputRef,
                onClick: function onClick() {
                    var _a;
                    (_a = _this.inputRef.current) === null || _a === void 0 || _a.focus();
                },
                required: true,
                value: time,
                onChange: function onChange(event) {
                    _this.onTimeChange(event.target.value || timeString);
                }
            });
        };
        _this.state = {
            time: _this.props.timeString
        };
        return _this;
    }
    InputTime.getDerivedStateFromProps = function(props, state) {
        if (props.timeString !== state.time) return {
            time: props.timeString
        };
        // Return null to indicate no change to state.
        return null;
    };
    InputTime.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker__input-time-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker-time__caption"
        }, this.props.timeInputLabel), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker-time__input-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker-time__input"
        }, this.renderTimeInput())));
    };
    return InputTime;
}((0, $5s1kH.Component));
/**
 * `Day` is a React component that represents a single day in a date picker.
 * It handles the rendering and interaction of a day.
 *
 * @prop ariaLabelPrefixWhenEnabled - Aria label prefix when the day is enabled.
 * @prop ariaLabelPrefixWhenDisabled - Aria label prefix when the day is disabled.
 * @prop disabledKeyboardNavigation - Whether keyboard navigation is disabled.
 * @prop day - The day to be displayed.
 * @prop dayClassName - Function to customize the CSS class of the day.
 * @prop endDate - The end date in a range.
 * @prop highlightDates - Map of dates to be highlighted.
 * @prop holidays - Map of holiday dates.
 * @prop inline - Whether the date picker is inline.
 * @prop shouldFocusDayInline - Whether the day should be focused when date picker is inline.
 * @prop month - The month the day belongs to.
 * @prop onClick - Click event handler.
 * @prop onMouseEnter - Mouse enter event handler.
 * @prop handleOnKeyDown - Key down event handler.
 * @prop usePointerEvent - Whether to use pointer events.
 * @prop preSelection - The date that is currently selected.
 * @prop selected - The selected date.
 * @prop selectingDate - The date currently being selected.
 * @prop selectsEnd - Whether the day can be the end date in a range.
 * @prop selectsStart - Whether the day can be the start date in a range.
 * @prop selectsRange - Whether the day can be in a range.
 * @prop showWeekPicker - Whether to show week picker.
 * @prop showWeekNumber - Whether to show week numbers.
 * @prop selectsDisabledDaysInRange - Whether to select disabled days in a range.
 * @prop selectsMultiple - Whether to allow multiple date selection.
 * @prop selectedDates - Array of selected dates.
 * @prop startDate - The start date in a range.
 * @prop renderDayContents - Function to customize the rendering of the day's contents.
 * @prop containerRef - Ref for the container.
 * @prop excludeDates - Array of dates to be excluded.
 * @prop calendarStartDay - The start day of the week.
 * @prop locale - The locale object.
 * @prop monthShowsDuplicateDaysEnd - Whether to show duplicate days at the end of the month.
 * @prop monthShowsDuplicateDaysStart - Whether to show duplicate days at the start of the month.
 * @prop includeDates - Array of dates to be included.
 * @prop includeDateIntervals - Array of date intervals to be included.
 * @prop minDate - The minimum date that can be selected.
 * @prop maxDate - The maximum date that can be selected.
 *
 * @example
 * ```tsx
 * import React from 'react';
 * import Day from './day';
 *
 * function MyComponent() {
 *   const handleDayClick = (event) => {
 *     console.log('Day clicked', event);
 *   };
 *
 *   const handleDayMouseEnter = (event) => {
 *     console.log('Mouse entered day', event);
 *   };
 *
 *   const renderDayContents = (date) => {
 *     return <div>{date.getDate()}</div>;
 *   };
 *
 *   return (
 *     <Day
 *       day={new Date()}
 *       onClick={handleDayClick}
 *       onMouseEnter={handleDayMouseEnter}
 *       renderDayContents={renderDayContents}
 *     />
 *   );
 * }
 *
 * export default MyComponent;
 * ```
 */ var $393fb8fc0a86de60$var$Day = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(Day, _super);
    function Day() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dayEl = (0, $5s1kH.createRef)();
        _this.handleClick = function(event) {
            if (!_this.isDisabled() && _this.props.onClick) _this.props.onClick(event);
        };
        _this.handleMouseEnter = function(event) {
            if (!_this.isDisabled() && _this.props.onMouseEnter) _this.props.onMouseEnter(event);
        };
        _this.handleOnKeyDown = function(event) {
            var _a, _b;
            var eventKey = event.key;
            if (eventKey === $393fb8fc0a86de60$var$KeyType.Space) {
                event.preventDefault();
                event.key = $393fb8fc0a86de60$var$KeyType.Enter;
            }
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.isSameDay = function(other) {
            return $393fb8fc0a86de60$var$isSameDay(_this.props.day, other);
        };
        _this.isKeyboardSelected = function() {
            var _a;
            if (_this.props.disabledKeyboardNavigation) return false;
            var isSelectedDate = _this.props.selectsMultiple ? (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
                return _this.isSameDayOrWeek(date);
            }) : _this.isSameDayOrWeek(_this.props.selected);
            var isDisabled = _this.props.preSelection && _this.isDisabled(_this.props.preSelection);
            return !isSelectedDate && _this.isSameDayOrWeek(_this.props.preSelection) && !isDisabled;
        };
        _this.isDisabled = function(day) {
            if (day === void 0) day = _this.props.day;
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $393fb8fc0a86de60$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate,
                disabled: _this.props.disabled
            });
        };
        _this.isExcluded = function() {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $393fb8fc0a86de60$var$isDayExcluded(_this.props.day, {
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals
            });
        };
        _this.isStartOfWeek = function() {
            return $393fb8fc0a86de60$var$isSameDay(_this.props.day, $393fb8fc0a86de60$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
        };
        _this.isSameWeek = function(other) {
            return _this.props.showWeekPicker && $393fb8fc0a86de60$var$isSameDay(other, $393fb8fc0a86de60$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
        };
        _this.isSameDayOrWeek = function(other) {
            return _this.isSameDay(other) || _this.isSameWeek(other);
        };
        _this.getHighLightedClass = function() {
            var _a = _this.props, day = _a.day, highlightDates = _a.highlightDates;
            if (!highlightDates) return false;
            // Looking for className in the Map of {'day string, 'className'}
            var dayStr = $393fb8fc0a86de60$var$formatDate(day, "MM.dd.yyyy");
            return highlightDates.get(dayStr);
        };
        // Function to return the array containing className associated to the date
        _this.getHolidaysClass = function() {
            var _a;
            var _b = _this.props, day = _b.day, holidays = _b.holidays;
            if (!holidays) // For type consistency no other reasons
            return [
                undefined
            ];
            var dayStr = $393fb8fc0a86de60$var$formatDate(day, "MM.dd.yyyy");
            // Looking for className in the Map of {day string: {className, holidayName}}
            if (holidays.has(dayStr)) return [
                (_a = holidays.get(dayStr)) === null || _a === void 0 ? void 0 : _a.className
            ];
            // For type consistency no other reasons
            return [
                undefined
            ];
        };
        _this.isInRange = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $393fb8fc0a86de60$var$isDayInRange(day, startDate, endDate);
        };
        _this.isInSelectingRange = function() {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, selectsDisabledDaysInRange = _b.selectsDisabledDaysInRange, startDate = _b.startDate, swapRange = _b.swapRange, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            // Don't highlight days outside the current month
            if (_this.isAfterMonth() || _this.isBeforeMonth()) return false;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate || !selectsDisabledDaysInRange && _this.isDisabled()) return false;
            if (selectsStart && endDate && ((0, $0e5980f964c532bb$export$5c007e10c6929c95)(selectingDate, endDate) || $393fb8fc0a86de60$var$isEqual(selectingDate, endDate))) return $393fb8fc0a86de60$var$isDayInRange(day, selectingDate, endDate);
            if (selectsEnd && startDate && ((0, $63acaba5662d3256$export$e4de839670987035)(selectingDate, startDate) || $393fb8fc0a86de60$var$isEqual(selectingDate, startDate))) return $393fb8fc0a86de60$var$isDayInRange(day, startDate, selectingDate);
            if (selectsRange && startDate && !endDate) {
                if ($393fb8fc0a86de60$var$isEqual(selectingDate, startDate)) return $393fb8fc0a86de60$var$isDayInRange(day, startDate, selectingDate);
                if ((0, $63acaba5662d3256$export$e4de839670987035)(selectingDate, startDate)) return $393fb8fc0a86de60$var$isDayInRange(day, startDate, selectingDate);
                if (swapRange && (0, $0e5980f964c532bb$export$5c007e10c6929c95)(selectingDate, startDate)) return $393fb8fc0a86de60$var$isDayInRange(day, selectingDate, startDate);
            }
            return false;
        };
        _this.isSelectingRangeStart = function() {
            var _a;
            if (!_this.isInSelectingRange()) return false;
            var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart, swapRange = _b.swapRange, selectsRange = _b.selectsRange;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsStart) return $393fb8fc0a86de60$var$isSameDay(day, selectingDate);
            if (selectsRange && swapRange && startDate && selectingDate) return $393fb8fc0a86de60$var$isSameDay(day, (0, $0e5980f964c532bb$export$5c007e10c6929c95)(selectingDate, startDate) ? selectingDate : startDate);
            return $393fb8fc0a86de60$var$isSameDay(day, startDate);
        };
        _this.isSelectingRangeEnd = function() {
            var _a;
            if (!_this.isInSelectingRange()) return false;
            var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, swapRange = _b.swapRange, startDate = _b.startDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsEnd) return $393fb8fc0a86de60$var$isSameDay(day, selectingDate);
            if (selectsRange && swapRange && startDate && selectingDate) return $393fb8fc0a86de60$var$isSameDay(day, (0, $0e5980f964c532bb$export$5c007e10c6929c95)(selectingDate, startDate) ? startDate : selectingDate);
            if (selectsRange) return $393fb8fc0a86de60$var$isSameDay(day, selectingDate);
            return $393fb8fc0a86de60$var$isSameDay(day, endDate);
        };
        _this.isRangeStart = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $393fb8fc0a86de60$var$isSameDay(startDate, day);
        };
        _this.isRangeEnd = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $393fb8fc0a86de60$var$isSameDay(endDate, day);
        };
        _this.isWeekend = function() {
            var weekday = (0, $a03163f251b8884c$export$1b64bc9c5306ed54)(_this.props.day);
            return weekday === 0 || weekday === 6;
        };
        _this.isAfterMonth = function() {
            return _this.props.month !== undefined && (_this.props.month + 1) % 12 === (0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)(_this.props.day);
        };
        _this.isBeforeMonth = function() {
            return _this.props.month !== undefined && ((0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)(_this.props.day) + 1) % 12 === _this.props.month;
        };
        _this.isCurrentDay = function() {
            return _this.isSameDay($393fb8fc0a86de60$var$newDate());
        };
        _this.isSelected = function() {
            var _a;
            if (_this.props.selectsMultiple) return (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
                return _this.isSameDayOrWeek(date);
            });
            return _this.isSameDayOrWeek(_this.props.selected);
        };
        _this.getClassNames = function(date) {
            var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
            return (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)("react-datepicker__day", dayClassName, "react-datepicker__day--" + $393fb8fc0a86de60$var$getDayOfWeekCode(_this.props.day), {
                "react-datepicker__day--disabled": _this.isDisabled(),
                "react-datepicker__day--excluded": _this.isExcluded(),
                "react-datepicker__day--selected": _this.isSelected(),
                "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
                "react-datepicker__day--range-start": _this.isRangeStart(),
                "react-datepicker__day--range-end": _this.isRangeEnd(),
                "react-datepicker__day--in-range": _this.isInRange(),
                "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
                "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
                "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
                "react-datepicker__day--today": _this.isCurrentDay(),
                "react-datepicker__day--weekend": _this.isWeekend(),
                "react-datepicker__day--outside-month": _this.isAfterMonth() || _this.isBeforeMonth()
            }, _this.getHighLightedClass(), _this.getHolidaysClass());
        };
        _this.getAriaLabel = function() {
            var _a = _this.props, day = _a.day, _b = _a.ariaLabelPrefixWhenEnabled, ariaLabelPrefixWhenEnabled = _b === void 0 ? "Choose" : _b, _c = _a.ariaLabelPrefixWhenDisabled, ariaLabelPrefixWhenDisabled = _c === void 0 ? "Not available" : _c;
            var prefix = _this.isDisabled() || _this.isExcluded() ? ariaLabelPrefixWhenDisabled : ariaLabelPrefixWhenEnabled;
            return "".concat(prefix, " ").concat($393fb8fc0a86de60$var$formatDate(day, "PPPP", _this.props.locale));
        };
        // A function to return the holiday's name as title's content
        _this.getTitle = function() {
            var _a = _this.props, day = _a.day, _b = _a.holidays, holidays = _b === void 0 ? new Map() : _b, excludeDates = _a.excludeDates;
            var compareDt = $393fb8fc0a86de60$var$formatDate(day, "MM.dd.yyyy");
            var titles = [];
            if (holidays.has(compareDt)) titles.push.apply(titles, holidays.get(compareDt).holidayNames);
            if (_this.isExcluded()) titles.push(excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.filter(function(excludeDate) {
                if (excludeDate instanceof Date) return $393fb8fc0a86de60$var$isSameDay(excludeDate, day);
                return $393fb8fc0a86de60$var$isSameDay(excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.date, day);
            }).map(function(excludeDate) {
                if (excludeDate instanceof Date) return undefined;
                return excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.message;
            }));
            // I'm not sure that this is a right output, but all tests are green
            return titles.join(", ");
        };
        _this.getTabIndex = function() {
            var selectedDay = _this.props.selected;
            var preSelectionDay = _this.props.preSelection;
            var tabIndex = !(_this.props.showWeekPicker && (_this.props.showWeekNumber || !_this.isStartOfWeek())) && (_this.isKeyboardSelected() || _this.isSameDay(selectedDay) && $393fb8fc0a86de60$var$isSameDay(preSelectionDay, selectedDay)) ? 0 : -1;
            return tabIndex;
        };
        // various cases when we need to apply focus to the preselected day
        // focus the day on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
        // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
        _this.handleFocusDay = function() {
            var _a;
            // only do this while the input isn't focused
            // otherwise, typing/backspacing the date manually may steal focus away from the input
            _this.shouldFocusDay() && ((_a = _this.dayEl.current) === null || _a === void 0 || _a.focus({
                preventScroll: true
            }));
        };
        _this.renderDayContents = function() {
            if (_this.props.monthShowsDuplicateDaysEnd && _this.isAfterMonth()) return null;
            if (_this.props.monthShowsDuplicateDaysStart && _this.isBeforeMonth()) return null;
            return _this.props.renderDayContents ? _this.props.renderDayContents((0, $61b6d1d5784dd880$export$aa350b96d91cd94)(_this.props.day), _this.props.day) : (0, $61b6d1d5784dd880$export$aa350b96d91cd94)(_this.props.day);
        };
        _this.render = function() {
            return(// TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
            (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                ref: _this.dayEl,
                className: _this.getClassNames(_this.props.day),
                onKeyDown: _this.handleOnKeyDown,
                onClick: _this.handleClick,
                onMouseEnter: !_this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
                onPointerEnter: _this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
                tabIndex: _this.getTabIndex(),
                "aria-label": _this.getAriaLabel(),
                role: "gridcell",
                title: _this.getTitle(),
                "aria-disabled": _this.isDisabled(),
                "aria-current": _this.isCurrentDay() ? "date" : undefined,
                "aria-selected": _this.isSelected() || _this.isInRange()
            }, _this.renderDayContents(), _this.getTitle() !== "" && (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                className: "overlay"
            }, _this.getTitle())));
        };
        return _this;
    }
    Day.prototype.componentDidMount = function() {
        this.handleFocusDay();
    };
    Day.prototype.componentDidUpdate = function() {
        this.handleFocusDay();
    };
    Day.prototype.shouldFocusDay = function() {
        var shouldFocusDay = false;
        if (this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection)) {
            // there is currently no activeElement and not inline
            if (!document.activeElement || document.activeElement === document.body) shouldFocusDay = true;
            // inline version:
            // do not focus on initial render to prevent autoFocus issue
            // focus after month has changed via keyboard
            if (this.props.inline && !this.props.shouldFocusDayInline) shouldFocusDay = false;
            if (this.isDayActiveElement()) shouldFocusDay = true;
            if (this.isDuplicateDay()) shouldFocusDay = false;
        }
        return shouldFocusDay;
    };
    // the activeElement is in the container, and it is another instance of Day
    Day.prototype.isDayActiveElement = function() {
        var _a, _b, _c;
        return ((_b = (_a = this.props.containerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement)) && ((_c = document.activeElement) === null || _c === void 0 ? void 0 : _c.classList.contains("react-datepicker__day"));
    };
    Day.prototype.isDuplicateDay = function() {
        return(//day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth());
    };
    return Day;
}((0, $5s1kH.Component));
var $393fb8fc0a86de60$var$WeekNumber = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(WeekNumber, _super);
    function WeekNumber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.weekNumberEl = (0, $5s1kH.createRef)();
        _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
        };
        _this.handleOnKeyDown = function(event) {
            var _a, _b;
            var eventKey = event.key;
            if (eventKey === $393fb8fc0a86de60$var$KeyType.Space) {
                event.preventDefault();
                event.key = $393fb8fc0a86de60$var$KeyType.Enter;
            }
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.isKeyboardSelected = function() {
            return !_this.props.disabledKeyboardNavigation && !$393fb8fc0a86de60$var$isSameDay(_this.props.date, _this.props.selected) && $393fb8fc0a86de60$var$isSameDay(_this.props.date, _this.props.preSelection);
        };
        _this.getTabIndex = function() {
            return _this.props.showWeekPicker && _this.props.showWeekNumber && (_this.isKeyboardSelected() || $393fb8fc0a86de60$var$isSameDay(_this.props.date, _this.props.selected) && $393fb8fc0a86de60$var$isSameDay(_this.props.preSelection, _this.props.selected)) ? 0 : -1;
        };
        // various cases when we need to apply focus to the preselected week-number
        // focus the week-number on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
        // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
        _this.handleFocusWeekNumber = function(prevProps) {
            var shouldFocusWeekNumber = false;
            // only do this while the input isn't focused
            // otherwise, typing/backspacing the date manually may steal focus away from the input
            if (_this.getTabIndex() === 0 && !(prevProps === null || prevProps === void 0 ? void 0 : prevProps.isInputFocused) && $393fb8fc0a86de60$var$isSameDay(_this.props.date, _this.props.preSelection)) {
                // there is currently no activeElement and not inline
                if (!document.activeElement || document.activeElement === document.body) shouldFocusWeekNumber = true;
                // inline version:
                // do not focus on initial render to prevent autoFocus issue
                // focus after month has changed via keyboard
                if (_this.props.inline && !_this.props.shouldFocusDayInline) shouldFocusWeekNumber = false;
                // the activeElement is in the container, and it is another instance of WeekNumber
                if (_this.props.containerRef && _this.props.containerRef.current && _this.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number")) shouldFocusWeekNumber = true;
            }
            shouldFocusWeekNumber && _this.weekNumberEl.current && _this.weekNumberEl.current.focus({
                preventScroll: true
            });
        };
        return _this;
    }
    Object.defineProperty(WeekNumber, "defaultProps", {
        get: function get() {
            return {
                ariaLabelPrefix: "week "
            };
        },
        enumerable: false,
        configurable: true
    });
    WeekNumber.prototype.componentDidMount = function() {
        this.handleFocusWeekNumber();
    };
    WeekNumber.prototype.componentDidUpdate = function(prevProps) {
        this.handleFocusWeekNumber(prevProps);
    };
    WeekNumber.prototype.render = function() {
        var _a = this.props, weekNumber = _a.weekNumber, isWeekDisabled = _a.isWeekDisabled, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? WeekNumber.defaultProps.ariaLabelPrefix : _b, onClick = _a.onClick;
        var weekNumberClasses = {
            "react-datepicker__week-number": true,
            "react-datepicker__week-number--clickable": !!onClick && !isWeekDisabled,
            "react-datepicker__week-number--selected": !!onClick && $393fb8fc0a86de60$var$isSameDay(this.props.date, this.props.selected)
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            ref: this.weekNumberEl,
            className: (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)(weekNumberClasses),
            "aria-label": "".concat(ariaLabelPrefix, " ").concat(this.props.weekNumber),
            onClick: this.handleClick,
            onKeyDown: this.handleOnKeyDown,
            tabIndex: this.getTabIndex(),
            role: "gridcell"
        }, weekNumber);
    };
    return WeekNumber;
}((0, $5s1kH.Component));
var $393fb8fc0a86de60$var$Week = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(Week, _super);
    function Week() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDisabled = function(day) {
            return $393fb8fc0a86de60$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.handleDayClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event);
        };
        _this.handleDayMouseEnter = function(day) {
            if (_this.props.onDayMouseEnter) _this.props.onDayMouseEnter(day);
        };
        _this.handleWeekClick = function(day, weekNumber, event) {
            var _a, _b, _c;
            var enabledWeekDay = new Date(day);
            for(var i = 0; i < 7; i++){
                var processingDay = new Date(day);
                processingDay.setDate(processingDay.getDate() + i);
                var isEnabled = !_this.isDisabled(processingDay);
                if (isEnabled) {
                    enabledWeekDay = processingDay;
                    break;
                }
            }
            if (typeof _this.props.onWeekSelect === "function") _this.props.onWeekSelect(enabledWeekDay, weekNumber, event);
            if (_this.props.showWeekPicker) _this.handleDayClick(enabledWeekDay, event);
            if ((_a = _this.props.shouldCloseOnSelect) !== null && _a !== void 0 ? _a : Week.defaultProps.shouldCloseOnSelect) (_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, false);
        };
        _this.formatWeekNumber = function(date) {
            if (_this.props.formatWeekNumber) return _this.props.formatWeekNumber(date);
            return $393fb8fc0a86de60$var$getWeek(date);
        };
        _this.isWeekDisabled = function() {
            var startOfWeek = _this.startOfWeek();
            var endOfWeek = (0, $2b4ff6e56ae3ad17$export$dd412b56f1e4d8aa)(startOfWeek, 6);
            var processingDate = new Date(startOfWeek);
            while(processingDate <= endOfWeek){
                if (!_this.isDisabled(processingDate)) return false;
                processingDate = (0, $2b4ff6e56ae3ad17$export$dd412b56f1e4d8aa)(processingDate, 1);
            }
            return true;
        };
        _this.renderDays = function() {
            var startOfWeek = _this.startOfWeek();
            var days = [];
            var weekNumber = _this.formatWeekNumber(startOfWeek);
            if (_this.props.showWeekNumber) {
                var onClickAction = _this.props.onWeekSelect || _this.props.showWeekPicker ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
                days.push((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$WeekNumber, $393fb8fc0a86de60$var$_assign({
                    key: "W"
                }, Week.defaultProps, _this.props, {
                    weekNumber: weekNumber,
                    isWeekDisabled: _this.isWeekDisabled(),
                    date: startOfWeek,
                    onClick: onClickAction
                })));
            }
            return days.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $2b4ff6e56ae3ad17$export$dd412b56f1e4d8aa)(startOfWeek, offset);
                return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$Day, $393fb8fc0a86de60$var$_assign({}, Week.defaultProps, _this.props, {
                    ariaLabelPrefixWhenEnabled: _this.props.chooseDayAriaLabelPrefix,
                    ariaLabelPrefixWhenDisabled: _this.props.disabledDayAriaLabelPrefix,
                    key: day.valueOf(),
                    day: day,
                    onClick: _this.handleDayClick.bind(_this, day),
                    onMouseEnter: _this.handleDayMouseEnter.bind(_this, day)
                }));
            }));
        };
        _this.startOfWeek = function() {
            return $393fb8fc0a86de60$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay);
        };
        _this.isKeyboardSelected = function() {
            return !_this.props.disabledKeyboardNavigation && !$393fb8fc0a86de60$var$isSameDay(_this.startOfWeek(), _this.props.selected) && $393fb8fc0a86de60$var$isSameDay(_this.startOfWeek(), _this.props.preSelection);
        };
        return _this;
    }
    Object.defineProperty(Week, "defaultProps", {
        get: function get() {
            return {
                shouldCloseOnSelect: true
            };
        },
        enumerable: false,
        configurable: true
    });
    Week.prototype.render = function() {
        var weekNumberClasses = {
            "react-datepicker__week": true,
            "react-datepicker__week--selected": $393fb8fc0a86de60$var$isSameDay(this.startOfWeek(), this.props.selected),
            "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
        };
        var customWeekClassName = this.props.weekClassName ? this.props.weekClassName(this.startOfWeek()) : undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)(weekNumberClasses, customWeekClassName),
            role: "row"
        }, this.renderDays());
    };
    return Week;
}((0, $5s1kH.Component));
var $393fb8fc0a86de60$var$_a;
var $393fb8fc0a86de60$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
var $393fb8fc0a86de60$var$MONTH_COLUMNS_LAYOUT = {
    TWO_COLUMNS: "two_columns",
    THREE_COLUMNS: "three_columns",
    FOUR_COLUMNS: "four_columns"
};
var $393fb8fc0a86de60$var$MONTH_COLUMNS = ($393fb8fc0a86de60$var$_a = {}, $393fb8fc0a86de60$var$_a[$393fb8fc0a86de60$var$MONTH_COLUMNS_LAYOUT.TWO_COLUMNS] = {
    grid: [
        [
            0,
            1
        ],
        [
            2,
            3
        ],
        [
            4,
            5
        ],
        [
            6,
            7
        ],
        [
            8,
            9
        ],
        [
            10,
            11
        ]
    ],
    verticalNavigationOffset: 2
}, $393fb8fc0a86de60$var$_a[$393fb8fc0a86de60$var$MONTH_COLUMNS_LAYOUT.THREE_COLUMNS] = {
    grid: [
        [
            0,
            1,
            2
        ],
        [
            3,
            4,
            5
        ],
        [
            6,
            7,
            8
        ],
        [
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 3
}, $393fb8fc0a86de60$var$_a[$393fb8fc0a86de60$var$MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS] = {
    grid: [
        [
            0,
            1,
            2,
            3
        ],
        [
            4,
            5,
            6,
            7
        ],
        [
            8,
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 4
}, $393fb8fc0a86de60$var$_a);
var $393fb8fc0a86de60$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET = 1;
function $393fb8fc0a86de60$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker) {
    if (showFourColumnMonthYearPicker) return $393fb8fc0a86de60$var$MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS;
    if (showTwoColumnMonthYearPicker) return $393fb8fc0a86de60$var$MONTH_COLUMNS_LAYOUT.TWO_COLUMNS;
    return $393fb8fc0a86de60$var$MONTH_COLUMNS_LAYOUT.THREE_COLUMNS;
}
/**
 * `Month` is a React component that represents a month in a calendar.
 * It accepts a `MonthProps` object as props which provides various configurations and event handlers.
 *
 * @prop dayClassName - Function to determine the class name for a day.
 * @prop monthClassName - Function to determine the class name for a month.
 * @prop filterDate - Function to filter dates.
 * @prop formatWeekNumber - Function to format the week number.
 * @prop onDayClick - Function to handle day click events.
 * @prop onDayMouseEnter - Function to handle mouse enter events on a day.
 * @prop onMouseLeave - Function to handle mouse leave events.
 * @prop onWeekSelect - Function to handle week selection.
 * @prop setPreSelection - Function to set pre-selection.
 * @prop setOpen - Function to set open state.
 * @prop renderDayContents - Function to render day contents.
 * @prop renderMonthContent - Function to render month content.
 * @prop renderQuarterContent - Function to render quarter content.
 * @prop handleOnKeyDown - Function to handle key down events.
 * @prop handleOnMonthKeyDown - Function to handle key down events on a month.
 * @prop ariaLabelPrefix - Aria label prefix.
 * @prop chooseDayAriaLabelPrefix - Aria label prefix for choosing a day.
 * @prop disabledDayAriaLabelPrefix - Aria label prefix for disabled day.
 * @prop disabledKeyboardNavigation - Flag to disable keyboard navigation.
 * @prop day - The day.
 * @prop endDate - The end date.
 * @prop orderInDisplay - The order in display.
 * @prop excludeDates - Dates to exclude.
 * @prop excludeDateIntervals - Date intervals to exclude.
 * @prop fixedHeight - Flag to set fixed height.
 * @prop highlightDates - Dates to highlight.
 * @prop holidays - Holidays.
 * @prop includeDates - Dates to include.
 * @prop includeDateIntervals - Date intervals to include.
 * @prop inline - Flag to set inline.
 * @prop shouldFocusDayInline - Flag to set focus on day inline.
 * @prop locale - The locale.
 * @prop maxDate - The maximum date.
 * @prop minDate - The minimum date.
 * @prop usePointerEvent - Flag to use pointer event.
 * @prop peekNextMonth - Flag to peek next month.
 * @prop preSelection - The pre-selection.
 * @prop selected - The selected date.
 * @prop selectingDate - The selecting date.
 * @prop calendarStartDay - The calendar start day.
 * @prop selectsEnd - Flag to select end.
 * @prop selectsStart - Flag to select start.
 * @prop selectsRange - Flag to select range.
 * @prop selectsDisabledDaysInRange - Flag to select disabled days in range.
 * @prop selectsMultiple - Flag to select multiple.
 * @prop selectedDates - The selected dates.
 * @prop showWeekNumbers - Flag to show week numbers.
 * @prop startDate - The start date.
 * @prop shouldCloseOnSelect - Flag to close on select.
 * @prop showMonthYearPicker - Flag to show month year picker.
 * @prop showFullMonthYearPicker - Flag to show full month year picker.
 * @prop showTwoColumnMonthYearPicker - Flag to show two column month year picker.
 * @prop showFourColumnMonthYearPicker - Flag to show four column month year picker.
 * @prop showQuarterYearPicker - Flag to show quarter year picker.
 * @prop showWeekPicker - Flag to show week picker.
 * @prop isInputFocused - Flag to set input focus.
 * @prop weekAriaLabelPrefix - Aria label prefix for week.
 * @prop containerRef - The container reference.
 * @prop monthShowsDuplicateDaysEnd - Flag to show duplicate days at the end of the month.
 * @prop monthShowsDuplicateDaysStart - Flag to show duplicate days at the start of the month.
 *
 * @example
 * ```tsx
 * function App() {
 *  const handleDayClick = (date) => {
 *     console.log('Day clicked: ', date);
 *   };
 *
 *   const handleDayMouseEnter = (date) => {
 *     console.log('Mouse entered on day: ', date);
 *   };
 *
 *   return (
 *     <div>
 *       <Month
 *         day={new Date()}
 *         endDate={new Date()}
 *         onDayClick={handleDayClick}
 *         onDayMouseEnter={handleDayMouseEnter}
 *         disabledKeyboardNavigation={false}
 *         showWeekNumbers={true}
 *         showMonthYearPicker={false}
 *       />
 *     </div>
 *   );
 * }
 * ```
 */ var $393fb8fc0a86de60$var$Month = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(Month, _super);
    function Month() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.MONTH_REFS = $393fb8fc0a86de60$var$__spreadArray([], Array(12), true).map(function() {
            return (0, $5s1kH.createRef)();
        });
        _this.QUARTER_REFS = $393fb8fc0a86de60$var$__spreadArray([], Array(4), true).map(function() {
            return (0, $5s1kH.createRef)();
        });
        _this.isDisabled = function(day) {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $393fb8fc0a86de60$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate,
                disabled: _this.props.disabled
            });
        };
        _this.isExcluded = function(day) {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $393fb8fc0a86de60$var$isDayExcluded(day, {
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals
            });
        };
        _this.handleDayClick = function(day, event) {
            var _a, _b;
            (_b = (_a = _this.props).onDayClick) === null || _b === void 0 || _b.call(_a, day, event, _this.props.orderInDisplay);
        };
        _this.handleDayMouseEnter = function(day) {
            var _a, _b;
            (_b = (_a = _this.props).onDayMouseEnter) === null || _b === void 0 || _b.call(_a, day);
        };
        _this.handleMouseLeave = function() {
            var _a, _b;
            (_b = (_a = _this.props).onMouseLeave) === null || _b === void 0 || _b.call(_a);
        };
        _this.isRangeStartMonth = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $393fb8fc0a86de60$var$isSameMonth((0, $d26b511e86cf447a$export$63264690f8e36790)(day, m), startDate);
        };
        _this.isRangeStartQuarter = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $393fb8fc0a86de60$var$isSameQuarter((0, $777d75a7e7ff73c1$export$8924d1de7efe1755)(day, q), startDate);
        };
        _this.isRangeEndMonth = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $393fb8fc0a86de60$var$isSameMonth((0, $d26b511e86cf447a$export$63264690f8e36790)(day, m), endDate);
        };
        _this.isRangeEndQuarter = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $393fb8fc0a86de60$var$isSameQuarter((0, $777d75a7e7ff73c1$export$8924d1de7efe1755)(day, q), endDate);
        };
        _this.isInSelectingRangeMonth = function(m) {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
            if (selectsStart && endDate) return $393fb8fc0a86de60$var$isMonthInRange(selectingDate, endDate, m, day);
            if (selectsEnd && startDate) return $393fb8fc0a86de60$var$isMonthInRange(startDate, selectingDate, m, day);
            if (selectsRange && startDate && !endDate) return $393fb8fc0a86de60$var$isMonthInRange(startDate, selectingDate, m, day);
            return false;
        };
        _this.isSelectingMonthRangeStart = function(m) {
            var _a;
            if (!_this.isInSelectingRangeMonth(m)) return false;
            var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart;
            var _month = (0, $d26b511e86cf447a$export$63264690f8e36790)(day, m);
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsStart) return $393fb8fc0a86de60$var$isSameMonth(_month, selectingDate);
            else return $393fb8fc0a86de60$var$isSameMonth(_month, startDate);
        };
        _this.isSelectingMonthRangeEnd = function(m) {
            var _a;
            if (!_this.isInSelectingRangeMonth(m)) return false;
            var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
            var _month = (0, $d26b511e86cf447a$export$63264690f8e36790)(day, m);
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsEnd || selectsRange) return $393fb8fc0a86de60$var$isSameMonth(_month, selectingDate);
            else return $393fb8fc0a86de60$var$isSameMonth(_month, endDate);
        };
        _this.isInSelectingRangeQuarter = function(q) {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
            if (selectsStart && endDate) return $393fb8fc0a86de60$var$isQuarterInRange(selectingDate, endDate, q, day);
            if (selectsEnd && startDate) return $393fb8fc0a86de60$var$isQuarterInRange(startDate, selectingDate, q, day);
            if (selectsRange && startDate && !endDate) return $393fb8fc0a86de60$var$isQuarterInRange(startDate, selectingDate, q, day);
            return false;
        };
        _this.isWeekInMonth = function(startOfWeek) {
            var day = _this.props.day;
            var endOfWeek = (0, $2b4ff6e56ae3ad17$export$dd412b56f1e4d8aa)(startOfWeek, 6);
            return $393fb8fc0a86de60$var$isSameMonth(startOfWeek, day) || $393fb8fc0a86de60$var$isSameMonth(endOfWeek, day);
        };
        _this.isCurrentMonth = function(day, m) {
            return (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(day) === (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)($393fb8fc0a86de60$var$newDate()) && m === (0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)($393fb8fc0a86de60$var$newDate());
        };
        _this.isCurrentQuarter = function(day, q) {
            return (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(day) === (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)($393fb8fc0a86de60$var$newDate()) && q === (0, $d5bfd625c8c2dcab$export$de90a4bb31c25221)($393fb8fc0a86de60$var$newDate());
        };
        _this.isSelectedMonth = function(day, m, selected) {
            return (0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)(selected) === m && (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(day) === (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(selected);
        };
        _this.isSelectMonthInList = function(day, m, selectedDates) {
            return selectedDates.some(function(selectedDate) {
                return _this.isSelectedMonth(day, m, selectedDate);
            });
        };
        _this.isSelectedQuarter = function(day, q, selected) {
            return (0, $d5bfd625c8c2dcab$export$de90a4bb31c25221)(selected) === q && (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(day) === (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(selected);
        };
        _this.isSelectQuarterInList = function(day, q, selectedDates) {
            return selectedDates.some(function(selectedDate) {
                return _this.isSelectedQuarter(day, q, selectedDate);
            });
        };
        _this.isMonthSelected = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
            var monthIdx = (0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)(day);
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(date) {
                return _this.isSelectedMonth(day, monthIdx, date);
            });
            return !!selected && _this.isSelectedMonth(day, monthIdx, selected);
        };
        _this.isQuarterSelected = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
            var quarterIdx = (0, $d5bfd625c8c2dcab$export$de90a4bb31c25221)(day);
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(selectedDate) {
                return _this.isSelectedQuarter(day, quarterIdx, selectedDate);
            });
            return !!selected && _this.isSelectedQuarter(day, quarterIdx, selected);
        };
        _this.renderWeeks = function() {
            // Return empty array if day is invalid
            if (!$393fb8fc0a86de60$var$isValid(_this.props.day)) return [];
            var weeks = [];
            var isFixedHeight = _this.props.fixedHeight;
            var i = 0;
            var breakAfterNextPush = false;
            var currentWeekStart = $393fb8fc0a86de60$var$getStartOfWeek($393fb8fc0a86de60$var$getStartOfMonth(_this.props.day), _this.props.locale, _this.props.calendarStartDay);
            var isPreSelected = function isPreSelected(preSelection) {
                return _this.props.showWeekPicker ? $393fb8fc0a86de60$var$getStartOfWeek(preSelection, _this.props.locale, _this.props.calendarStartDay) : _this.props.preSelection;
            };
            var isSelected = function isSelected(selected) {
                return _this.props.showWeekPicker ? $393fb8fc0a86de60$var$getStartOfWeek(selected, _this.props.locale, _this.props.calendarStartDay) : _this.props.selected;
            };
            var selected = _this.props.selected ? isSelected(_this.props.selected) : undefined;
            var preSelection = _this.props.preSelection ? isPreSelected(_this.props.preSelection) : undefined;
            while(true){
                weeks.push((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$Week, $393fb8fc0a86de60$var$_assign({}, _this.props, {
                    ariaLabelPrefix: _this.props.weekAriaLabelPrefix,
                    key: i,
                    day: currentWeekStart,
                    month: (0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)(_this.props.day),
                    onDayClick: _this.handleDayClick,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    selected: selected,
                    preSelection: preSelection,
                    showWeekNumber: _this.props.showWeekNumbers
                })));
                if (breakAfterNextPush) break;
                i++;
                currentWeekStart = (0, $a4bc19e29e9eb67e$export$ef501a2bb4f3ee6b)(currentWeekStart, 1);
                // If one of these conditions is true, we will either break on this week
                // or break on the next week
                var isFixedAndFinalWeek = isFixedHeight && i >= $393fb8fc0a86de60$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT;
                var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
                if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
                    if (_this.props.peekNextMonth) breakAfterNextPush = true;
                    else break;
                }
            }
            return weeks;
        };
        _this.onMonthClick = function(event, m) {
            var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
            if (isDisabled) return;
            _this.handleDayClick($393fb8fc0a86de60$var$getStartOfMonth(labelDate), event);
        };
        _this.onMonthMouseEnter = function(m) {
            var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
            if (isDisabled) return;
            _this.handleDayMouseEnter($393fb8fc0a86de60$var$getStartOfMonth(labelDate));
        };
        _this.handleMonthNavigation = function(newMonth, newDate) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            (_d = (_c = _this.MONTH_REFS[newMonth]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.handleKeyboardNavigation = function(event, eventKey, month) {
            var _a;
            var _b = _this.props, selected = _b.selected, preSelection = _b.preSelection, setPreSelection = _b.setPreSelection, minDate = _b.minDate, maxDate = _b.maxDate, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker;
            if (!preSelection) return;
            var monthColumnsLayout = $393fb8fc0a86de60$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker);
            var verticalOffset = _this.getVerticalOffset(monthColumnsLayout);
            var monthsGrid = (_a = $393fb8fc0a86de60$var$MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.grid;
            var calculateNewDateAndMonth = function calculateNewDateAndMonth(eventKey, date, month) {
                var _a, _b;
                var newCalculatedDate = date;
                var newCalculatedMonth = month;
                switch(eventKey){
                    case $393fb8fc0a86de60$var$KeyType.ArrowRight:
                        newCalculatedDate = (0, $75507be8d602cbce$export$17c93e242b2d3a22)(date, $393fb8fc0a86de60$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET);
                        newCalculatedMonth = month === 11 ? 0 : month + $393fb8fc0a86de60$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET;
                        break;
                    case $393fb8fc0a86de60$var$KeyType.ArrowLeft:
                        newCalculatedDate = (0, $62367543e39b34d6$export$73d1c15a21f9fae5)(date, $393fb8fc0a86de60$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET);
                        newCalculatedMonth = month === 0 ? 11 : month - $393fb8fc0a86de60$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET;
                        break;
                    case $393fb8fc0a86de60$var$KeyType.ArrowUp:
                        newCalculatedDate = (0, $62367543e39b34d6$export$73d1c15a21f9fae5)(date, verticalOffset);
                        newCalculatedMonth = ((_a = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[0]) === null || _a === void 0 ? void 0 : _a.includes(month)) ? month + 12 - verticalOffset : month - verticalOffset;
                        break;
                    case $393fb8fc0a86de60$var$KeyType.ArrowDown:
                        newCalculatedDate = (0, $75507be8d602cbce$export$17c93e242b2d3a22)(date, verticalOffset);
                        newCalculatedMonth = ((_b = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[monthsGrid.length - 1]) === null || _b === void 0 ? void 0 : _b.includes(month)) ? month - 12 + verticalOffset : month + verticalOffset;
                        break;
                }
                return {
                    newCalculatedDate: newCalculatedDate,
                    newCalculatedMonth: newCalculatedMonth
                };
            };
            var getNewDateAndMonth = function getNewDateAndMonth(eventKey, selectedDate, month) {
                var MAX_ITERATIONS = 40;
                var eventKeyCopy = eventKey;
                var validDateFound = false;
                var iterations = 0;
                var _a = calculateNewDateAndMonth(eventKeyCopy, selectedDate, month), newCalculatedDate = _a.newCalculatedDate, newCalculatedMonth = _a.newCalculatedMonth;
                while(!validDateFound){
                    if (iterations >= MAX_ITERATIONS) {
                        newCalculatedDate = selectedDate;
                        newCalculatedMonth = month;
                        break;
                    }
                    // if minDate exists and the new month is before the minimum month, it will try to find the next available month after
                    if (minDate && newCalculatedDate < minDate) {
                        eventKeyCopy = $393fb8fc0a86de60$var$KeyType.ArrowRight;
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    }
                    // if maxDate exists and the new month is after the maximum month, it will try to find the next available month before
                    if (maxDate && newCalculatedDate > maxDate) {
                        eventKeyCopy = $393fb8fc0a86de60$var$KeyType.ArrowLeft;
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    }
                    if ($393fb8fc0a86de60$var$isMonthYearDisabled(newCalculatedDate, _this.props)) {
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    } else validDateFound = true;
                    iterations++;
                }
                return {
                    newCalculatedDate: newCalculatedDate,
                    newCalculatedMonth: newCalculatedMonth
                };
            };
            if (eventKey === $393fb8fc0a86de60$var$KeyType.Enter) {
                if (!_this.isMonthDisabled(month)) {
                    _this.onMonthClick(event, month);
                    setPreSelection === null || setPreSelection === void 0 || setPreSelection(selected);
                }
                return;
            }
            var _c = getNewDateAndMonth(eventKey, preSelection, month), newCalculatedDate = _c.newCalculatedDate, newCalculatedMonth = _c.newCalculatedMonth;
            switch(eventKey){
                case $393fb8fc0a86de60$var$KeyType.ArrowRight:
                case $393fb8fc0a86de60$var$KeyType.ArrowLeft:
                case $393fb8fc0a86de60$var$KeyType.ArrowUp:
                case $393fb8fc0a86de60$var$KeyType.ArrowDown:
                    _this.handleMonthNavigation(newCalculatedMonth, newCalculatedDate);
                    break;
            }
        };
        _this.getVerticalOffset = function(monthColumnsLayout) {
            var _a, _b;
            return (_b = (_a = $393fb8fc0a86de60$var$MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.verticalNavigationOffset) !== null && _b !== void 0 ? _b : 0;
        };
        _this.onMonthKeyDown = function(event, month) {
            var _a = _this.props, disabledKeyboardNavigation = _a.disabledKeyboardNavigation, handleOnMonthKeyDown = _a.handleOnMonthKeyDown;
            var eventKey = event.key;
            if (eventKey !== $393fb8fc0a86de60$var$KeyType.Tab) // preventDefault on tab event blocks focus change
            event.preventDefault();
            if (!disabledKeyboardNavigation) _this.handleKeyboardNavigation(event, eventKey, month);
            handleOnMonthKeyDown && handleOnMonthKeyDown(event);
        };
        _this.onQuarterClick = function(event, q) {
            var labelDate = (0, $777d75a7e7ff73c1$export$8924d1de7efe1755)(_this.props.day, q);
            if ($393fb8fc0a86de60$var$isQuarterDisabled(labelDate, _this.props)) return;
            _this.handleDayClick($393fb8fc0a86de60$var$getStartOfQuarter(labelDate), event);
        };
        _this.onQuarterMouseEnter = function(q) {
            var labelDate = (0, $777d75a7e7ff73c1$export$8924d1de7efe1755)(_this.props.day, q);
            if ($393fb8fc0a86de60$var$isQuarterDisabled(labelDate, _this.props)) return;
            _this.handleDayMouseEnter($393fb8fc0a86de60$var$getStartOfQuarter(labelDate));
        };
        _this.handleQuarterNavigation = function(newQuarter, newDate) {
            var _a, _b, _c, _d;
            if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            (_d = (_c = _this.QUARTER_REFS[newQuarter - 1]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.onQuarterKeyDown = function(event, quarter) {
            var _a, _b;
            var eventKey = event.key;
            if (!_this.props.disabledKeyboardNavigation) switch(eventKey){
                case $393fb8fc0a86de60$var$KeyType.Enter:
                    _this.onQuarterClick(event, quarter);
                    (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
                    break;
                case $393fb8fc0a86de60$var$KeyType.ArrowRight:
                    if (!_this.props.preSelection) break;
                    _this.handleQuarterNavigation(quarter === 4 ? 1 : quarter + 1, (0, $40103932dbf37ea0$export$c252a41d0fbed2ce)(_this.props.preSelection, 1));
                    break;
                case $393fb8fc0a86de60$var$KeyType.ArrowLeft:
                    if (!_this.props.preSelection) break;
                    _this.handleQuarterNavigation(quarter === 1 ? 4 : quarter - 1, (0, $f08d4eb85a22e198$export$a31bfeeeee80cce6)(_this.props.preSelection, 1));
                    break;
            }
        };
        _this.isMonthDisabledForLabelDate = function(month) {
            var _a;
            var _b = _this.props, day = _b.day, disabled = _b.disabled, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
            var labelDate = (0, $d26b511e86cf447a$export$63264690f8e36790)(day, month);
            if (disabled) return {
                isDisabled: true,
                labelDate: (0, $d26b511e86cf447a$export$63264690f8e36790)(day, month)
            };
            return {
                isDisabled: (_a = (minDate || maxDate || excludeDates || includeDates) && $393fb8fc0a86de60$var$isMonthDisabled(labelDate, _this.props)) !== null && _a !== void 0 ? _a : false,
                labelDate: labelDate
            };
        };
        _this.isMonthDisabled = function(month) {
            var isDisabled = _this.isMonthDisabledForLabelDate(month).isDisabled;
            return isDisabled;
        };
        _this.getMonthClassNames = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, preSelection = _a.preSelection, monthClassName = _a.monthClassName;
            var _monthClassName = monthClassName ? monthClassName((0, $d26b511e86cf447a$export$63264690f8e36790)(day, m)) : undefined;
            var selection = _this.getSelection();
            return (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)("react-datepicker__month-text", "react-datepicker__month-".concat(m), _monthClassName, {
                "react-datepicker__month-text--disabled": _this.isMonthDisabled(m),
                "react-datepicker__month-text--selected": selection ? _this.isSelectMonthInList(day, m, selection) : undefined,
                "react-datepicker__month-text--keyboard-selected": !_this.props.disabledKeyboardNavigation && preSelection && _this.isSelectedMonth(day, m, preSelection) && !_this.isMonthSelected() && !_this.isMonthDisabled(m),
                "react-datepicker__month-text--in-selecting-range": _this.isInSelectingRangeMonth(m),
                "react-datepicker__month-text--in-range": startDate && endDate ? $393fb8fc0a86de60$var$isMonthInRange(startDate, endDate, m, day) : undefined,
                "react-datepicker__month-text--range-start": _this.isRangeStartMonth(m),
                "react-datepicker__month-text--range-end": _this.isRangeEndMonth(m),
                "react-datepicker__month-text--selecting-range-start": _this.isSelectingMonthRangeStart(m),
                "react-datepicker__month-text--selecting-range-end": _this.isSelectingMonthRangeEnd(m),
                "react-datepicker__month-text--today": _this.isCurrentMonth(day, m)
            });
        };
        _this.getTabIndex = function(m) {
            if (_this.props.preSelection == null) return "-1";
            var preSelectedMonth = (0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)(_this.props.preSelection);
            var isPreSelectedMonthDisabled = _this.isMonthDisabledForLabelDate(preSelectedMonth).isDisabled;
            var tabIndex = m === preSelectedMonth && !(isPreSelectedMonthDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
            return tabIndex;
        };
        _this.getQuarterTabIndex = function(q) {
            if (_this.props.preSelection == null) return "-1";
            var preSelectedQuarter = (0, $d5bfd625c8c2dcab$export$de90a4bb31c25221)(_this.props.preSelection);
            var isCurrentQuarterDisabled = $393fb8fc0a86de60$var$isQuarterDisabled(_this.props.day, _this.props);
            var tabIndex = q === preSelectedQuarter && !(isCurrentQuarterDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
            return tabIndex;
        };
        _this.getAriaLabel = function(month) {
            var _a = _this.props, _b = _a.chooseDayAriaLabelPrefix, chooseDayAriaLabelPrefix = _b === void 0 ? "Choose" : _b, _c = _a.disabledDayAriaLabelPrefix, disabledDayAriaLabelPrefix = _c === void 0 ? "Not available" : _c, day = _a.day, locale = _a.locale;
            var labelDate = (0, $d26b511e86cf447a$export$63264690f8e36790)(day, month);
            var prefix = _this.isDisabled(labelDate) || _this.isExcluded(labelDate) ? disabledDayAriaLabelPrefix : chooseDayAriaLabelPrefix;
            return "".concat(prefix, " ").concat($393fb8fc0a86de60$var$formatDate(labelDate, "MMMM yyyy", locale));
        };
        _this.getQuarterClassNames = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, preSelection = _a.preSelection, disabledKeyboardNavigation = _a.disabledKeyboardNavigation, disabled = _a.disabled;
            var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate || disabled) && $393fb8fc0a86de60$var$isQuarterDisabled((0, $777d75a7e7ff73c1$export$8924d1de7efe1755)(day, q), _this.props);
            var selection = _this.getSelection();
            return (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(q), {
                "react-datepicker__quarter-text--disabled": isDisabled,
                "react-datepicker__quarter-text--selected": selection ? _this.isSelectQuarterInList(day, q, selection) : undefined,
                "react-datepicker__quarter-text--keyboard-selected": !disabledKeyboardNavigation && preSelection && _this.isSelectedQuarter(day, q, preSelection) && !_this.isQuarterSelected() && !isDisabled,
                "react-datepicker__quarter-text--in-selecting-range": _this.isInSelectingRangeQuarter(q),
                "react-datepicker__quarter-text--in-range": startDate && endDate ? $393fb8fc0a86de60$var$isQuarterInRange(startDate, endDate, q, day) : undefined,
                "react-datepicker__quarter-text--range-start": _this.isRangeStartQuarter(q),
                "react-datepicker__quarter-text--range-end": _this.isRangeEndQuarter(q),
                "react-datepicker__quarter-text--today": _this.isCurrentQuarter(day, q)
            });
        };
        _this.getMonthContent = function(m) {
            var _a = _this.props, showFullMonthYearPicker = _a.showFullMonthYearPicker, renderMonthContent = _a.renderMonthContent, locale = _a.locale, day = _a.day;
            var shortMonthText = $393fb8fc0a86de60$var$getMonthShortInLocale(m, locale);
            var fullMonthText = $393fb8fc0a86de60$var$getMonthInLocale(m, locale);
            if (renderMonthContent) return renderMonthContent(m, shortMonthText, fullMonthText, day);
            return showFullMonthYearPicker ? fullMonthText : shortMonthText;
        };
        _this.getQuarterContent = function(q) {
            var _a;
            var _b = _this.props, renderQuarterContent = _b.renderQuarterContent, locale = _b.locale;
            var shortQuarter = $393fb8fc0a86de60$var$getQuarterShortInLocale(q, locale);
            return (_a = renderQuarterContent === null || renderQuarterContent === void 0 ? void 0 : renderQuarterContent(q, shortQuarter)) !== null && _a !== void 0 ? _a : shortQuarter;
        };
        _this.renderMonths = function() {
            var _a;
            var _b = _this.props, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, day = _b.day, selected = _b.selected;
            var monthColumns = (_a = $393fb8fc0a86de60$var$MONTH_COLUMNS[$393fb8fc0a86de60$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker)]) === null || _a === void 0 ? void 0 : _a.grid;
            return monthColumns === null || monthColumns === void 0 ? void 0 : monthColumns.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: "react-datepicker__month-wrapper",
                    key: i
                }, month.map(function(m, j) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        ref: _this.MONTH_REFS[m],
                        key: j,
                        onClick: function onClick(event) {
                            _this.onMonthClick(event, m);
                        },
                        onKeyDown: function onKeyDown(event) {
                            if ($393fb8fc0a86de60$var$isSpaceKeyDown(event)) {
                                event.preventDefault();
                                event.key = $393fb8fc0a86de60$var$KeyType.Enter;
                            }
                            _this.onMonthKeyDown(event, m);
                        },
                        onMouseEnter: !_this.props.usePointerEvent ? function() {
                            return _this.onMonthMouseEnter(m);
                        } : undefined,
                        onPointerEnter: _this.props.usePointerEvent ? function() {
                            return _this.onMonthMouseEnter(m);
                        } : undefined,
                        tabIndex: Number(_this.getTabIndex(m)),
                        className: _this.getMonthClassNames(m),
                        "aria-disabled": _this.isMonthDisabled(m),
                        role: "option",
                        "aria-label": _this.getAriaLabel(m),
                        "aria-current": _this.isCurrentMonth(day, m) ? "date" : undefined,
                        "aria-selected": selected ? _this.isSelectedMonth(day, m, selected) : undefined
                    }, _this.getMonthContent(m));
                }));
            });
        };
        _this.renderQuarters = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected;
            var quarters = [
                1,
                2,
                3,
                4
            ];
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker__quarter-wrapper"
            }, quarters.map(function(q, j) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    key: j,
                    ref: _this.QUARTER_REFS[j],
                    role: "option",
                    onClick: function onClick(event) {
                        _this.onQuarterClick(event, q);
                    },
                    onKeyDown: function onKeyDown(event) {
                        _this.onQuarterKeyDown(event, q);
                    },
                    onMouseEnter: !_this.props.usePointerEvent ? function() {
                        return _this.onQuarterMouseEnter(q);
                    } : undefined,
                    onPointerEnter: _this.props.usePointerEvent ? function() {
                        return _this.onQuarterMouseEnter(q);
                    } : undefined,
                    className: _this.getQuarterClassNames(q),
                    "aria-selected": selected ? _this.isSelectedQuarter(day, q, selected) : undefined,
                    tabIndex: Number(_this.getQuarterTabIndex(q)),
                    "aria-current": _this.isCurrentQuarter(day, q) ? "date" : undefined
                }, _this.getQuarterContent(q));
            }));
        };
        _this.getClassNames = function() {
            var _a = _this.props, selectingDate = _a.selectingDate, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, showWeekPicker = _a.showWeekPicker;
            return (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)("react-datepicker__month", {
                "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
            }, {
                "react-datepicker__monthPicker": showMonthYearPicker
            }, {
                "react-datepicker__quarterPicker": showQuarterYearPicker
            }, {
                "react-datepicker__weekPicker": showWeekPicker
            });
        };
        return _this;
    }
    Month.prototype.getSelection = function() {
        var _a = this.props, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
        if (selectsMultiple) return selectedDates;
        if (selected) return [
            selected
        ];
        return undefined;
    };
    Month.prototype.render = function() {
        var _a = this.props, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, day = _a.day, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? "Month " : _b;
        var formattedAriaLabelPrefix = ariaLabelPrefix ? ariaLabelPrefix.trim() + " " : "";
        // Format aria-label, return empty string if date is invalid
        var formattedAriaLabel = $393fb8fc0a86de60$var$isValid(day) ? "".concat(formattedAriaLabelPrefix).concat($393fb8fc0a86de60$var$formatDate(day, "MMMM, yyyy", this.props.locale)) : "";
        var shouldUseListboxRole = showMonthYearPicker || showQuarterYearPicker;
        if (shouldUseListboxRole) return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            "aria-label": formattedAriaLabel,
            role: "listbox"
        }, showMonthYearPicker ? this.renderMonths() : this.renderQuarters());
        // For regular calendar view, use table structure
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            role: "table"
        }, this.props.dayNamesHeader && (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            role: "rowgroup"
        }, this.props.dayNamesHeader), this.props.monthHeader && (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            role: "rowgroup"
        }, this.props.monthHeader), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            "aria-label": formattedAriaLabel,
            role: "rowgroup"
        }, this.renderWeeks()), this.props.monthFooter && (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            role: "rowgroup"
        }, this.props.monthFooter));
    };
    return Month;
}((0, $5s1kH.Component));
var $393fb8fc0a86de60$var$MonthDropdownOptions = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(MonthDropdownOptions, _super);
    function MonthDropdownOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.monthOptionButtonsRef = {};
        _this.isSelectedMonth = function(i) {
            return _this.props.month === i;
        };
        _this.handleOptionKeyDown = function(i, e) {
            var _a;
            switch(e.key){
                case "Enter":
                    e.preventDefault();
                    _this.onChange(i);
                    break;
                case "Escape":
                    e.preventDefault();
                    _this.props.onCancel();
                    break;
                case "ArrowUp":
                case "ArrowDown":
                    e.preventDefault();
                    var newMonth = (i + (e.key === "ArrowUp" ? -1 : 1) + _this.props.monthNames.length) % _this.props.monthNames.length;
                    (_a = _this.monthOptionButtonsRef[newMonth]) === null || _a === void 0 || _a.focus();
                    break;
            }
        };
        _this.renderOptions = function() {
            // Clear refs to prevent memory leaks on re-render
            _this.monthOptionButtonsRef = {};
            return _this.props.monthNames.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    ref: function ref(el) {
                        _this.monthOptionButtonsRef[i] = el;
                        if (_this.isSelectedMonth(i)) el === null || el === void 0 || el.focus();
                    },
                    role: "button",
                    tabIndex: 0,
                    className: _this.isSelectedMonth(i) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                    key: month,
                    onClick: _this.onChange.bind(_this, i),
                    onKeyDown: _this.handleOptionKeyDown.bind(_this, i),
                    "aria-selected": _this.isSelectedMonth(i) ? "true" : undefined
                }, _this.isSelectedMonth(i) ? (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                    className: "react-datepicker__month-option--selected"
                }, "\u2713") : "", month);
            });
        };
        _this.onChange = function(month) {
            return _this.props.onChange(month);
        };
        _this.handleClickOutside = function() {
            return _this.props.onCancel();
        };
        return _this;
    }
    MonthDropdownOptions.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$ClickOutsideWrapper, {
            className: "react-datepicker__month-dropdown",
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return MonthDropdownOptions;
}((0, $5s1kH.Component));
var $393fb8fc0a86de60$var$MonthDropdown = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(MonthDropdown, _super);
    function MonthDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function(monthNames) {
            return monthNames.map(function(m, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("option", {
                    key: m,
                    value: i
                }, m);
            });
        };
        _this.renderSelectMode = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("select", {
                value: _this.props.month,
                className: "react-datepicker__month-select",
                onChange: function onChange(e) {
                    return _this.onChange(parseInt(e.target.value));
                }
            }, _this.renderSelectOptions(monthNames));
        };
        _this.renderReadView = function(visible, monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
                key: "read",
                type: "button",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                className: "react-datepicker__month-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                className: "react-datepicker__month-read-view--selected-month"
            }, monthNames[_this.props.month]));
        };
        _this.renderDropdown = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$MonthDropdownOptions, $393fb8fc0a86de60$var$_assign({
                key: "dropdown"
            }, _this.props, {
                monthNames: monthNames,
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function(monthNames) {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible, monthNames)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown(monthNames));
            return result;
        };
        _this.onChange = function(month) {
            _this.toggleDropdown();
            if (month !== _this.props.month) _this.props.onChange(month);
        };
        _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        };
        return _this;
    }
    MonthDropdown.prototype.render = function() {
        var _this = this;
        var monthNames = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map(this.props.useShortMonthInDropdown ? function(m) {
            return $393fb8fc0a86de60$var$getMonthShortInLocale(m, _this.props.locale);
        } : function(m) {
            return $393fb8fc0a86de60$var$getMonthInLocale(m, _this.props.locale);
        });
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode(monthNames);
                break;
            case "select":
                renderedDropdown = this.renderSelectMode(monthNames);
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return MonthDropdown;
}((0, $5s1kH.Component));
// Default range: 5 years before and after current date
var $393fb8fc0a86de60$var$DEFAULT_YEAR_RANGE$1 = 5;
function $393fb8fc0a86de60$var$generateMonthYears(minDate, maxDate, currentDate) {
    var list = [];
    // Use defaults if minDate/maxDate not provided
    var effectiveMinDate = minDate !== null && minDate !== void 0 ? minDate : (0, $03aa6c2df8a28792$export$14867687ff6c92e2)(currentDate, $393fb8fc0a86de60$var$DEFAULT_YEAR_RANGE$1);
    var effectiveMaxDate = maxDate !== null && maxDate !== void 0 ? maxDate : (0, $5c6b1b4dffb22d4b$export$3d83eec43f4ea476)(currentDate, $393fb8fc0a86de60$var$DEFAULT_YEAR_RANGE$1);
    var currDate = $393fb8fc0a86de60$var$getStartOfMonth(effectiveMinDate);
    var lastDate = $393fb8fc0a86de60$var$getStartOfMonth(effectiveMaxDate);
    while(!(0, $63acaba5662d3256$export$e4de839670987035)(currDate, lastDate)){
        list.push($393fb8fc0a86de60$var$newDate(currDate));
        currDate = (0, $75507be8d602cbce$export$17c93e242b2d3a22)(currDate, 1);
    }
    return list;
}
var $393fb8fc0a86de60$var$MonthYearDropdownOptions = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(MonthYearDropdownOptions, _super);
    function MonthYearDropdownOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.renderOptions = function() {
            return _this.state.monthYearsList.map(function(monthYear) {
                var monthYearPoint = (0, $e77654c571bb8a61$export$1428f42a7de81803)(monthYear);
                var isSameMonthYear = $393fb8fc0a86de60$var$isSameYear(_this.props.date, monthYear) && $393fb8fc0a86de60$var$isSameMonth(_this.props.date, monthYear);
                return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    className: isSameMonthYear ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                    key: monthYearPoint,
                    onClick: _this.onChange.bind(_this, monthYearPoint),
                    "aria-selected": isSameMonthYear ? "true" : undefined
                }, isSameMonthYear ? (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                    className: "react-datepicker__month-year-option--selected"
                }, "\u2713") : "", $393fb8fc0a86de60$var$formatDate(monthYear, _this.props.dateFormat, _this.props.locale));
            });
        };
        _this.onChange = function(monthYear) {
            return _this.props.onChange(monthYear);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.state = {
            monthYearsList: $393fb8fc0a86de60$var$generateMonthYears(_this.props.minDate, _this.props.maxDate, _this.props.date)
        };
        return _this;
    }
    MonthYearDropdownOptions.prototype.render = function() {
        var dropdownClass = (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)({
            "react-datepicker__month-year-dropdown": true,
            "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$ClickOutsideWrapper, {
            className: dropdownClass,
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return MonthYearDropdownOptions;
}((0, $5s1kH.Component));
// Default range: 5 years before and after current date
var $393fb8fc0a86de60$var$DEFAULT_YEAR_RANGE = 5;
var $393fb8fc0a86de60$var$MonthYearDropdown = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(MonthYearDropdown, _super);
    function MonthYearDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function() {
            var _a, _b;
            // Use defaults if minDate/maxDate not provided
            var minDate = (_a = _this.props.minDate) !== null && _a !== void 0 ? _a : (0, $03aa6c2df8a28792$export$14867687ff6c92e2)(_this.props.date, $393fb8fc0a86de60$var$DEFAULT_YEAR_RANGE);
            var maxDate = (_b = _this.props.maxDate) !== null && _b !== void 0 ? _b : (0, $5c6b1b4dffb22d4b$export$3d83eec43f4ea476)(_this.props.date, $393fb8fc0a86de60$var$DEFAULT_YEAR_RANGE);
            var currDate = $393fb8fc0a86de60$var$getStartOfMonth(minDate);
            var lastDate = $393fb8fc0a86de60$var$getStartOfMonth(maxDate);
            var options = [];
            while(!(0, $63acaba5662d3256$export$e4de839670987035)(currDate, lastDate)){
                var timePoint = (0, $e77654c571bb8a61$export$1428f42a7de81803)(currDate);
                options.push((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("option", {
                    key: timePoint,
                    value: timePoint
                }, $393fb8fc0a86de60$var$formatDate(currDate, _this.props.dateFormat, _this.props.locale)));
                currDate = (0, $75507be8d602cbce$export$17c93e242b2d3a22)(currDate, 1);
            }
            return options;
        };
        _this.onSelectChange = function(event) {
            _this.onChange(parseInt(event.target.value));
        };
        _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("select", {
                value: (0, $e77654c571bb8a61$export$1428f42a7de81803)($393fb8fc0a86de60$var$getStartOfMonth(_this.props.date)),
                className: "react-datepicker__month-year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        };
        _this.renderReadView = function(visible) {
            var yearMonth = $393fb8fc0a86de60$var$formatDate(_this.props.date, _this.props.dateFormat, _this.props.locale);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                key: "read",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-year-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                className: "react-datepicker__month-year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                className: "react-datepicker__month-year-read-view--selected-month-year"
            }, yearMonth));
        };
        _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$MonthYearDropdownOptions, $393fb8fc0a86de60$var$_assign({
                key: "dropdown"
            }, _this.props, {
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        };
        _this.onChange = function(monthYearPoint) {
            _this.toggleDropdown();
            var changedDate = $393fb8fc0a86de60$var$newDate(monthYearPoint);
            if ($393fb8fc0a86de60$var$isSameYear(_this.props.date, changedDate) && $393fb8fc0a86de60$var$isSameMonth(_this.props.date, changedDate)) return;
            _this.props.onChange(changedDate);
        };
        _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        };
        return _this;
    }
    MonthYearDropdown.prototype.render = function() {
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return MonthYearDropdown;
}((0, $5s1kH.Component));
var $393fb8fc0a86de60$var$Time = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(Time, _super);
    function Time() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            height: null
        };
        _this.scrollToTheSelectedTime = function() {
            requestAnimationFrame(function() {
                var _a, _b, _c;
                if (!_this.list) return;
                _this.list.scrollTop = (_c = _this.centerLi && Time.calcCenterPosition(_this.props.monthRef ? _this.props.monthRef.clientHeight - ((_b = (_a = _this.header) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) : _this.list.clientHeight, _this.centerLi)) !== null && _c !== void 0 ? _c : 0;
            });
        };
        _this.handleClick = function(time) {
            var _a, _b;
            if ((_this.props.minTime || _this.props.maxTime) && $393fb8fc0a86de60$var$isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && $393fb8fc0a86de60$var$isTimeDisabled(time, _this.props)) return;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, time);
        };
        _this.isSelectedTime = function(time) {
            var selected = $393fb8fc0a86de60$var$safeToDate(_this.props.selected);
            return selected && $393fb8fc0a86de60$var$isSameMinute(selected, time);
        };
        _this.isDisabledTime = function(time) {
            return (_this.props.minTime || _this.props.maxTime) && $393fb8fc0a86de60$var$isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && $393fb8fc0a86de60$var$isTimeDisabled(time, _this.props);
        };
        _this.liClasses = function(time) {
            var _a;
            var classes = [
                "react-datepicker__time-list-item",
                _this.props.timeClassName ? _this.props.timeClassName(time) : undefined
            ];
            if (_this.isSelectedTime(time)) classes.push("react-datepicker__time-list-item--selected");
            if (_this.isDisabledTime(time)) classes.push("react-datepicker__time-list-item--disabled");
            //convert this.props.intervals and the relevant time to seconds and check if it it's a clean multiple of the interval
            if (_this.props.injectTimes && ((0, $75f9879a8962b028$export$257b40f71c07d58f)(time) * 3600 + (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(time) * 60 + (0, $d895bdcba9991f26$export$5e9417507ff28427)(time)) % (((_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals) * 60) !== 0) classes.push("react-datepicker__time-list-item--injected");
            return classes.join(" ");
        };
        _this.handleOnKeyDown = function(event, time) {
            var _a, _b;
            if (event.key === $393fb8fc0a86de60$var$KeyType.Space) {
                event.preventDefault();
                event.key = $393fb8fc0a86de60$var$KeyType.Enter;
            }
            if ((event.key === $393fb8fc0a86de60$var$KeyType.ArrowUp || event.key === $393fb8fc0a86de60$var$KeyType.ArrowLeft) && event.target instanceof HTMLElement && event.target.previousSibling) {
                event.preventDefault();
                event.target.previousSibling instanceof HTMLElement && event.target.previousSibling.focus();
            }
            if ((event.key === $393fb8fc0a86de60$var$KeyType.ArrowDown || event.key === $393fb8fc0a86de60$var$KeyType.ArrowRight) && event.target instanceof HTMLElement && event.target.nextSibling) {
                event.preventDefault();
                event.target.nextSibling instanceof HTMLElement && event.target.nextSibling.focus();
            }
            if (event.key === $393fb8fc0a86de60$var$KeyType.Enter) _this.handleClick(time);
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.renderTimes = function() {
            var _a;
            var times = [];
            var format = typeof _this.props.format === "string" ? _this.props.format : "p";
            var intervals = (_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals;
            var activeDate = $393fb8fc0a86de60$var$safeToDate(_this.props.selected) || $393fb8fc0a86de60$var$safeToDate(_this.props.openToDate) || $393fb8fc0a86de60$var$newDate();
            var base = $393fb8fc0a86de60$var$getStartOfDay(activeDate);
            var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
            var minutesInDay = 60 * $393fb8fc0a86de60$var$getHoursInDay(activeDate);
            var multiplier = minutesInDay / intervals;
            for(var i = 0; i < multiplier; i++){
                var currentTime = (0, $396b693e3529a905$export$2287e3d29250119e)(base, i * intervals);
                times.push(currentTime);
                if (sortedInjectTimes) {
                    var timesToInject = $393fb8fc0a86de60$var$timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
                    times = times.concat(timesToInject);
                }
            }
            // Determine which time to focus and scroll into view when component mounts
            var timeToFocus = times.reduce(function(prev, time) {
                if (time.getTime() <= activeDate.getTime()) return time;
                return prev;
            }, times[0]);
            return times.map(function(time) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("li", {
                    key: time.valueOf(),
                    onClick: _this.handleClick.bind(_this, time),
                    className: _this.liClasses(time),
                    ref: function ref(li) {
                        if (time === timeToFocus) _this.centerLi = li;
                    },
                    onKeyDown: function onKeyDown(event) {
                        _this.handleOnKeyDown(event, time);
                    },
                    tabIndex: time === timeToFocus ? 0 : -1,
                    role: "option",
                    "aria-selected": _this.isSelectedTime(time) ? "true" : undefined,
                    "aria-disabled": _this.isDisabledTime(time) ? "true" : undefined
                }, $393fb8fc0a86de60$var$formatDate(time, format, _this.props.locale));
            });
        };
        _this.renderTimeCaption = function() {
            if (_this.props.showTimeCaption === false) return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Fragment, null);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--time ".concat(_this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                ref: function ref(header) {
                    _this.header = header;
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker-time__header"
            }, _this.props.timeCaption));
        };
        return _this;
    }
    Object.defineProperty(Time, "defaultProps", {
        get: function get() {
            return {
                intervals: 30,
                todayButton: null,
                timeCaption: "Time",
                showTimeCaption: true
            };
        },
        enumerable: false,
        configurable: true
    });
    Time.prototype.componentDidMount = function() {
        // code to ensure selected time will always be in focus within time window when it first appears
        this.scrollToTheSelectedTime();
        this.observeDatePickerHeightChanges();
    };
    Time.prototype.componentWillUnmount = function() {
        var _a;
        (_a = this.resizeObserver) === null || _a === void 0 || _a.disconnect();
    };
    Time.prototype.observeDatePickerHeightChanges = function() {
        var _this = this;
        var monthRef = this.props.monthRef;
        this.updateContainerHeight();
        if (monthRef) {
            this.resizeObserver = new ResizeObserver(function() {
                _this.updateContainerHeight();
            });
            this.resizeObserver.observe(monthRef);
        }
    };
    Time.prototype.updateContainerHeight = function() {
        if (this.props.monthRef && this.header) {
            var newHeight = this.props.monthRef.clientHeight - this.header.clientHeight;
            // Only update state if height actually changed to prevent infinite resize loops
            if (this.state.height !== newHeight) this.setState({
                height: newHeight
            });
        }
    };
    Time.prototype.render = function() {
        var _this = this;
        var _a;
        var height = this.state.height;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker__time-container ".concat(((_a = this.props.todayButton) !== null && _a !== void 0 ? _a : Time.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "")
        }, this.renderTimeCaption(), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker__time"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker__time-box"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("ul", {
            className: "react-datepicker__time-list",
            ref: function ref(list) {
                _this.list = list;
            },
            style: height ? {
                height: height
            } : {},
            role: "listbox",
            "aria-label": this.props.timeCaption
        }, this.renderTimes()))));
    };
    Time.calcCenterPosition = function(listHeight, centerLiRef) {
        return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
    };
    return Time;
}((0, $5s1kH.Component));
var $393fb8fc0a86de60$var$VERTICAL_NAVIGATION_OFFSET = 3;
/**
 * `Year` is a component that represents a year in a date picker.
 *
 * @class
 * @param {YearProps} props - The properties that define the `Year` component.
 * @property {VoidFunction} [props.clearSelectingDate] - Function to clear the selected date.
 * @property {Date} [props.date] - The currently selected date.
 * @property {boolean} [props.disabledKeyboardNavigation] - If true, keyboard navigation is disabled.
 * @property {Date} [props.endDate] - The end date in a range selection.
 * @property {(date: Date) => void} props.onDayClick - Function to handle day click events.
 * @property {Date} props.preSelection - The date that is currently in focus.
 * @property {(date: Date) => void} props.setPreSelection - Function to set the pre-selected date.
 * @property {{ [key: string]: any }} props.selected - The selected date(s).
 * @property {boolean} props.inline - If true, the date picker is displayed inline.
 * @property {Date} props.maxDate - The maximum selectable date.
 * @property {Date} props.minDate - The minimum selectable date.
 * @property {boolean} props.usePointerEvent - If true, pointer events are used instead of mouse events.
 * @property {(date: Date) => void} props.onYearMouseEnter - Function to handle mouse enter events on a year.
 * @property {(date: Date) => void} props.onYearMouseLeave - Function to handle mouse leave events on a year.
 */ var $393fb8fc0a86de60$var$Year = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(Year, _super);
    function Year(props) {
        var _this = _super.call(this, props) || this;
        _this.YEAR_REFS = $393fb8fc0a86de60$var$__spreadArray([], Array(_this.props.yearItemNumber), true).map(function() {
            return (0, $5s1kH.createRef)();
        });
        _this.isDisabled = function(date) {
            return $393fb8fc0a86de60$var$isDayDisabled(date, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.isExcluded = function(date) {
            return $393fb8fc0a86de60$var$isDayExcluded(date, {
                excludeDates: _this.props.excludeDates
            });
        };
        _this.selectingDate = function() {
            var _a;
            return (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
        };
        _this.updateFocusOnPaginate = function(refIndex) {
            var waitForReRender = function waitForReRender() {
                var _a, _b;
                (_b = (_a = _this.YEAR_REFS[refIndex]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 || _b.focus();
            };
            window.requestAnimationFrame(waitForReRender);
        };
        _this.handleYearClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event);
        };
        _this.handleYearNavigation = function(newYear, newDate) {
            var _a, _b, _c, _d;
            var _e = _this.props, date = _e.date, yearItemNumber = _e.yearItemNumber;
            if (date === undefined || yearItemNumber === undefined) return;
            var startPeriod = $393fb8fc0a86de60$var$getYearsPeriod(date, yearItemNumber).startPeriod;
            if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            if (newYear - startPeriod < 0) _this.updateFocusOnPaginate(yearItemNumber - (startPeriod - newYear));
            else if (newYear - startPeriod >= yearItemNumber) _this.updateFocusOnPaginate(Math.abs(yearItemNumber - (newYear - startPeriod)));
            else (_d = (_c = _this.YEAR_REFS[newYear - startPeriod]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.isSameDay = function(y, other) {
            return $393fb8fc0a86de60$var$isSameDay(y, other);
        };
        _this.isCurrentYear = function(y) {
            return y === (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)($393fb8fc0a86de60$var$newDate());
        };
        _this.isRangeStart = function(y) {
            return _this.props.startDate && _this.props.endDate && $393fb8fc0a86de60$var$isSameYear((0, $c9d0036666d361ea$export$a8408b6c5639cab7)($393fb8fc0a86de60$var$newDate(), y), _this.props.startDate);
        };
        _this.isRangeEnd = function(y) {
            return _this.props.startDate && _this.props.endDate && $393fb8fc0a86de60$var$isSameYear((0, $c9d0036666d361ea$export$a8408b6c5639cab7)($393fb8fc0a86de60$var$newDate(), y), _this.props.endDate);
        };
        _this.isInRange = function(y) {
            return $393fb8fc0a86de60$var$isYearInRange(y, _this.props.startDate, _this.props.endDate);
        };
        _this.isInSelectingRange = function(y) {
            var _a = _this.props, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, selectsRange = _a.selectsRange, startDate = _a.startDate, endDate = _a.endDate;
            if (!(selectsStart || selectsEnd || selectsRange) || !_this.selectingDate()) return false;
            if (selectsStart && endDate) return $393fb8fc0a86de60$var$isYearInRange(y, _this.selectingDate(), endDate);
            if (selectsEnd && startDate) return $393fb8fc0a86de60$var$isYearInRange(y, startDate, _this.selectingDate());
            if (selectsRange && startDate && !endDate) return $393fb8fc0a86de60$var$isYearInRange(y, startDate, _this.selectingDate());
            return false;
        };
        _this.isSelectingRangeStart = function(y) {
            var _a;
            if (!_this.isInSelectingRange(y)) return false;
            var _b = _this.props, startDate = _b.startDate, selectsStart = _b.selectsStart;
            var _year = (0, $c9d0036666d361ea$export$a8408b6c5639cab7)($393fb8fc0a86de60$var$newDate(), y);
            if (selectsStart) return $393fb8fc0a86de60$var$isSameYear(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
            return $393fb8fc0a86de60$var$isSameYear(_year, startDate !== null && startDate !== void 0 ? startDate : null);
        };
        _this.isSelectingRangeEnd = function(y) {
            var _a;
            if (!_this.isInSelectingRange(y)) return false;
            var _b = _this.props, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
            var _year = (0, $c9d0036666d361ea$export$a8408b6c5639cab7)($393fb8fc0a86de60$var$newDate(), y);
            if (selectsEnd || selectsRange) return $393fb8fc0a86de60$var$isSameYear(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
            return $393fb8fc0a86de60$var$isSameYear(_year, endDate !== null && endDate !== void 0 ? endDate : null);
        };
        _this.isKeyboardSelected = function(y) {
            if (_this.props.disabledKeyboardNavigation || _this.props.date === undefined || _this.props.preSelection == null) return;
            var _a = _this.props, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, selected = _a.selected;
            var date = $393fb8fc0a86de60$var$getStartOfYear((0, $c9d0036666d361ea$export$a8408b6c5639cab7)(_this.props.date, y));
            var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate) && $393fb8fc0a86de60$var$isYearDisabled(y, _this.props);
            var isSelectedDay = !!selected && $393fb8fc0a86de60$var$isSameDay(date, $393fb8fc0a86de60$var$getStartOfYear(selected));
            var isKeyboardSelectedDay = $393fb8fc0a86de60$var$isSameDay(date, $393fb8fc0a86de60$var$getStartOfYear(_this.props.preSelection));
            return !_this.props.inline && !isSelectedDay && isKeyboardSelectedDay && !isDisabled;
        };
        _this.isSelectedYear = function(year) {
            var _a = _this.props, selectsMultiple = _a.selectsMultiple, selected = _a.selected, selectedDates = _a.selectedDates;
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(date) {
                return year === (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(date);
            });
            return !!selected && year === (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(selected);
        };
        _this.onYearClick = function(event, y) {
            var date = _this.props.date;
            if (date === undefined) return;
            _this.handleYearClick($393fb8fc0a86de60$var$getStartOfYear((0, $c9d0036666d361ea$export$a8408b6c5639cab7)(date, y)), event);
        };
        _this.onYearKeyDown = function(event, y) {
            var _a, _b;
            var key = event.key;
            var _c = _this.props, date = _c.date, yearItemNumber = _c.yearItemNumber, handleOnKeyDown = _c.handleOnKeyDown;
            if (key !== $393fb8fc0a86de60$var$KeyType.Tab) // preventDefault on tab event blocks focus change
            event.preventDefault();
            if (!_this.props.disabledKeyboardNavigation) switch(key){
                case $393fb8fc0a86de60$var$KeyType.Enter:
                    if (_this.props.selected == null) break;
                    _this.onYearClick(event, y);
                    (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
                    break;
                case $393fb8fc0a86de60$var$KeyType.ArrowRight:
                    if (_this.props.preSelection == null) break;
                    _this.handleYearNavigation(y + 1, (0, $5c6b1b4dffb22d4b$export$3d83eec43f4ea476)(_this.props.preSelection, 1));
                    break;
                case $393fb8fc0a86de60$var$KeyType.ArrowLeft:
                    if (_this.props.preSelection == null) break;
                    _this.handleYearNavigation(y - 1, (0, $03aa6c2df8a28792$export$14867687ff6c92e2)(_this.props.preSelection, 1));
                    break;
                case $393fb8fc0a86de60$var$KeyType.ArrowUp:
                    if (date === undefined || yearItemNumber === undefined || _this.props.preSelection == null) break;
                    var startPeriod = $393fb8fc0a86de60$var$getYearsPeriod(date, yearItemNumber).startPeriod;
                    var offset = $393fb8fc0a86de60$var$VERTICAL_NAVIGATION_OFFSET;
                    var newYear = y - offset;
                    if (newYear < startPeriod) {
                        var leftOverOffset = yearItemNumber % offset;
                        if (y >= startPeriod && y < startPeriod + leftOverOffset) offset = leftOverOffset;
                        else offset += leftOverOffset;
                        newYear = y - offset;
                    }
                    _this.handleYearNavigation(newYear, (0, $03aa6c2df8a28792$export$14867687ff6c92e2)(_this.props.preSelection, offset));
                    break;
                case $393fb8fc0a86de60$var$KeyType.ArrowDown:
                    if (date === undefined || yearItemNumber === undefined || _this.props.preSelection == null) break;
                    var endPeriod = $393fb8fc0a86de60$var$getYearsPeriod(date, yearItemNumber).endPeriod;
                    var offset = $393fb8fc0a86de60$var$VERTICAL_NAVIGATION_OFFSET;
                    var newYear = y + offset;
                    if (newYear > endPeriod) {
                        var leftOverOffset = yearItemNumber % offset;
                        if (y <= endPeriod && y > endPeriod - leftOverOffset) offset = leftOverOffset;
                        else offset += leftOverOffset;
                        newYear = y + offset;
                    }
                    _this.handleYearNavigation(newYear, (0, $5c6b1b4dffb22d4b$export$3d83eec43f4ea476)(_this.props.preSelection, offset));
                    break;
            }
            handleOnKeyDown && handleOnKeyDown(event);
        };
        _this.getYearClassNames = function(y) {
            var _a = _this.props, date = _a.date, disabled = _a.disabled, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, yearClassName = _a.yearClassName;
            return (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)("react-datepicker__year-text", "react-datepicker__year-".concat(y), date ? yearClassName === null || yearClassName === void 0 ? void 0 : yearClassName((0, $c9d0036666d361ea$export$a8408b6c5639cab7)(date, y)) : undefined, {
                "react-datepicker__year-text--selected": _this.isSelectedYear(y),
                "react-datepicker__year-text--disabled": (minDate || maxDate || excludeDates || includeDates || filterDate || disabled) && $393fb8fc0a86de60$var$isYearDisabled(y, _this.props),
                "react-datepicker__year-text--keyboard-selected": _this.isKeyboardSelected(y),
                "react-datepicker__year-text--range-start": _this.isRangeStart(y),
                "react-datepicker__year-text--range-end": _this.isRangeEnd(y),
                "react-datepicker__year-text--in-range": _this.isInRange(y),
                "react-datepicker__year-text--in-selecting-range": _this.isInSelectingRange(y),
                "react-datepicker__year-text--selecting-range-start": _this.isSelectingRangeStart(y),
                "react-datepicker__year-text--selecting-range-end": _this.isSelectingRangeEnd(y),
                "react-datepicker__year-text--today": _this.isCurrentYear(y)
            });
        };
        _this.getYearTabIndex = function(y) {
            if (_this.props.disabledKeyboardNavigation || _this.props.preSelection == null) return "-1";
            var preSelected = (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(_this.props.preSelection);
            var isPreSelectedYearDisabled = $393fb8fc0a86de60$var$isYearDisabled(y, _this.props);
            return y === preSelected && !isPreSelectedYearDisabled ? "0" : "-1";
        };
        _this.getYearContent = function(y) {
            return _this.props.renderYearContent ? _this.props.renderYearContent(y) : y;
        };
        return _this;
    }
    Year.prototype.render = function() {
        var _this = this;
        var yearsList = [];
        var _a = this.props, date = _a.date, yearItemNumber = _a.yearItemNumber, onYearMouseEnter = _a.onYearMouseEnter, onYearMouseLeave = _a.onYearMouseLeave;
        if (date === undefined) return null;
        var _b = $393fb8fc0a86de60$var$getYearsPeriod(date, yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
        var _loop_1 = function _loop_1(y) {
            yearsList.push((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                ref: this_1.YEAR_REFS[y - startPeriod],
                onClick: function onClick(event) {
                    _this.onYearClick(event, y);
                },
                onKeyDown: function onKeyDown(event) {
                    if ($393fb8fc0a86de60$var$isSpaceKeyDown(event)) {
                        event.preventDefault();
                        event.key = $393fb8fc0a86de60$var$KeyType.Enter;
                    }
                    _this.onYearKeyDown(event, y);
                },
                tabIndex: Number(this_1.getYearTabIndex(y)),
                className: this_1.getYearClassNames(y),
                onMouseEnter: !this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseEnter(event, y);
                } : undefined,
                onPointerEnter: this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseEnter(event, y);
                } : undefined,
                onMouseLeave: !this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseLeave(event, y);
                } : undefined,
                onPointerLeave: this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseLeave(event, y);
                } : undefined,
                key: y,
                "aria-current": this_1.isCurrentYear(y) ? "date" : undefined
            }, this_1.getYearContent(y)));
        };
        var this_1 = this;
        for(var y = startPeriod; y <= endPeriod; y++)_loop_1(y);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker__year"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker__year-wrapper",
            onMouseLeave: !this.props.usePointerEvent ? this.props.clearSelectingDate : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : undefined
        }, yearsList));
    };
    return Year;
}((0, $5s1kH.Component));
function $393fb8fc0a86de60$var$generateYears(year, noOfYear, minDate, maxDate) {
    var list = [];
    for(var i = 0; i < 2 * noOfYear + 1; i++){
        var newYear = year + noOfYear - i;
        var isInRange = true;
        if (minDate) isInRange = (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(minDate) <= newYear;
        if (maxDate && isInRange) isInRange = (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(maxDate) >= newYear;
        if (isInRange) list.push(newYear);
    }
    return list;
}
var $393fb8fc0a86de60$var$YearDropdownOptions = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(YearDropdownOptions, _super);
    function YearDropdownOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.yearOptionButtonsRef = {};
        _this.handleOptionKeyDown = function(year, e) {
            var _a;
            switch(e.key){
                case "Enter":
                    e.preventDefault();
                    _this.onChange(year);
                    break;
                case "Escape":
                    e.preventDefault();
                    _this.props.onCancel();
                    break;
                case "ArrowUp":
                case "ArrowDown":
                    e.preventDefault();
                    var newYear = year + (e.key === "ArrowUp" ? 1 : -1);
                    // Add bounds checking to ensure the year exists in our refs
                    if (_this.yearOptionButtonsRef[newYear]) (_a = _this.yearOptionButtonsRef[newYear]) === null || _a === void 0 || _a.focus();
                    break;
            }
        };
        _this.renderOptions = function() {
            // Clear refs to prevent memory leaks on re-render
            _this.yearOptionButtonsRef = {};
            var selectedYear = _this.props.year;
            var options = _this.state.yearsList.map(function(year) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    ref: function ref(el) {
                        _this.yearOptionButtonsRef[year] = el;
                        if (year === selectedYear) el === null || el === void 0 || el.focus();
                    },
                    role: "button",
                    tabIndex: 0,
                    className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                    key: year,
                    onClick: _this.onChange.bind(_this, year),
                    onKeyDown: _this.handleOptionKeyDown.bind(_this, year),
                    "aria-selected": selectedYear === year ? "true" : undefined
                }, selectedYear === year ? (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                    className: "react-datepicker__year-option--selected"
                }, "\u2713") : "", year);
            });
            var minYear = _this.props.minDate ? (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(_this.props.minDate) : null;
            var maxYear = _this.props.maxDate ? (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(_this.props.maxDate) : null;
            if (!maxYear || !_this.state.yearsList.find(function(year) {
                return year === maxYear;
            })) options.unshift((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "upcoming",
                onClick: _this.incrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
            })));
            if (!minYear || !_this.state.yearsList.find(function(year) {
                return year === minYear;
            })) options.push((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "previous",
                onClick: _this.decrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
            })));
            return options;
        };
        _this.onChange = function(year) {
            _this.props.onChange(year);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.shiftYears = function(amount) {
            var years = _this.state.yearsList.map(function(year) {
                return year + amount;
            });
            _this.setState({
                yearsList: years
            });
        };
        _this.incrementYears = function() {
            return _this.shiftYears(1);
        };
        _this.decrementYears = function() {
            return _this.shiftYears(-1);
        };
        var yearDropdownItemNumber = props.yearDropdownItemNumber, scrollableYearDropdown = props.scrollableYearDropdown;
        var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
        _this.state = {
            yearsList: $393fb8fc0a86de60$var$generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
        };
        _this.dropdownRef = (0, $5s1kH.createRef)();
        return _this;
    }
    YearDropdownOptions.prototype.componentDidMount = function() {
        var dropdownCurrent = this.dropdownRef.current;
        if (dropdownCurrent) {
            // Get array from HTMLCollection
            var dropdownCurrentChildren = dropdownCurrent.children ? Array.from(dropdownCurrent.children) : null;
            var selectedYearOptionEl = dropdownCurrentChildren ? dropdownCurrentChildren.find(function(childEl) {
                return childEl.ariaSelected;
            }) : null;
            dropdownCurrent.scrollTop = selectedYearOptionEl && selectedYearOptionEl instanceof HTMLElement ? selectedYearOptionEl.offsetTop + (selectedYearOptionEl.clientHeight - dropdownCurrent.clientHeight) / 2 : (dropdownCurrent.scrollHeight - dropdownCurrent.clientHeight) / 2;
        }
    };
    YearDropdownOptions.prototype.render = function() {
        var dropdownClass = (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)({
            "react-datepicker__year-dropdown": true,
            "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$ClickOutsideWrapper, {
            className: dropdownClass,
            containerRef: this.dropdownRef,
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return YearDropdownOptions;
}((0, $5s1kH.Component));
var $393fb8fc0a86de60$var$YearDropdown = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(YearDropdown, _super);
    function YearDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function() {
            var minYear = _this.props.minDate ? (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(_this.props.minDate) : 1900;
            var maxYear = _this.props.maxDate ? (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(_this.props.maxDate) : 2100;
            var options = [];
            for(var i = minYear; i <= maxYear; i++)options.push((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("option", {
                key: i,
                value: i
            }, i));
            return options;
        };
        _this.onSelectChange = function(event) {
            _this.onChange(parseInt(event.target.value));
        };
        _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("select", {
                value: _this.props.year,
                className: "react-datepicker__year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        };
        _this.renderReadView = function(visible) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
                key: "read",
                type: "button",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__year-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                className: "react-datepicker__year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                className: "react-datepicker__year-read-view--selected-year"
            }, _this.props.year));
        };
        _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$YearDropdownOptions, $393fb8fc0a86de60$var$_assign({
                key: "dropdown"
            }, _this.props, {
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        };
        _this.onChange = function(year) {
            _this.toggleDropdown();
            if (year === _this.props.year) return;
            _this.props.onChange(year);
        };
        _this.toggleDropdown = function(event) {
            _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            }, function() {
                if (_this.props.adjustDateOnChange) _this.handleYearChange(_this.props.date, event);
            });
        };
        _this.handleYearChange = function(date, event) {
            var _a;
            (_a = _this.onSelect) === null || _a === void 0 || _a.call(_this, date, event);
            _this.setOpen();
        };
        _this.onSelect = function(date, event) {
            var _a, _b;
            (_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, date, event);
        };
        _this.setOpen = function() {
            var _a, _b;
            (_b = (_a = _this.props).setOpen) === null || _b === void 0 || _b.call(_a, true);
        };
        return _this;
    }
    YearDropdown.prototype.render = function() {
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return YearDropdown;
}((0, $5s1kH.Component));
var $393fb8fc0a86de60$var$DROPDOWN_FOCUS_CLASSNAMES = [
    "react-datepicker__year-select",
    "react-datepicker__month-select",
    "react-datepicker__month-year-select"
];
var $393fb8fc0a86de60$var$OUTSIDE_CLICK_IGNORE_CLASS = "react-datepicker-ignore-onclickoutside";
var $393fb8fc0a86de60$var$isDropdownSelect = function isDropdownSelect(element) {
    var classNames = (element.className || "").split(/\s+/);
    return $393fb8fc0a86de60$var$DROPDOWN_FOCUS_CLASSNAMES.some(function(testClassname) {
        return classNames.indexOf(testClassname) >= 0;
    });
};
var $393fb8fc0a86de60$var$Calendar = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this.monthContainer = undefined;
        _this.handleClickOutside = function(event) {
            _this.props.onClickOutside(event);
        };
        _this.setClickOutsideRef = function() {
            return _this.containerRef.current;
        };
        _this.handleDropdownFocus = function(event) {
            var _a, _b;
            if ($393fb8fc0a86de60$var$isDropdownSelect(event.target)) (_b = (_a = _this.props).onDropdownFocus) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.getDateInView = function() {
            var _a = _this.props, preSelection = _a.preSelection, selected = _a.selected, openToDate = _a.openToDate;
            var minDate = $393fb8fc0a86de60$var$getEffectiveMinDate(_this.props);
            var maxDate = $393fb8fc0a86de60$var$getEffectiveMaxDate(_this.props);
            var current = $393fb8fc0a86de60$var$newDate();
            var initialDate = openToDate || selected || preSelection;
            if (initialDate) return initialDate;
            else {
                if (minDate && (0, $0e5980f964c532bb$export$5c007e10c6929c95)(current, minDate)) return minDate;
                else if (maxDate && (0, $63acaba5662d3256$export$e4de839670987035)(current, maxDate)) return maxDate;
            }
            return current;
        };
        _this.increaseMonth = function() {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $75507be8d602cbce$export$17c93e242b2d3a22)(date, 1)
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.decreaseMonth = function() {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $62367543e39b34d6$export$73d1c15a21f9fae5)(date, 1)
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.handleDayClick = function(day, event, monthSelectedIn) {
            _this.props.onSelect(day, event, monthSelectedIn);
            _this.props.setPreSelection && _this.props.setPreSelection(day);
        };
        _this.handleDayMouseEnter = function(day) {
            _this.setState({
                selectingDate: day
            });
            _this.props.onDayMouseEnter && _this.props.onDayMouseEnter(day);
        };
        _this.handleMonthMouseLeave = function() {
            _this.setState({
                selectingDate: undefined
            });
            _this.props.onMonthMouseLeave && _this.props.onMonthMouseLeave();
        };
        _this.handleYearMouseEnter = function(event, year) {
            _this.setState({
                selectingDate: (0, $c9d0036666d361ea$export$a8408b6c5639cab7)($393fb8fc0a86de60$var$newDate(), year)
            });
            !!_this.props.onYearMouseEnter && _this.props.onYearMouseEnter(event, year);
        };
        _this.handleYearMouseLeave = function(event, year) {
            !!_this.props.onYearMouseLeave && _this.props.onYearMouseLeave(event, year);
        };
        _this.handleYearChange = function(date) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props).onYearChange) === null || _b === void 0 || _b.call(_a, date);
            _this.setState({
                isRenderAriaLiveMessage: true
            });
            if (_this.props.adjustDateOnChange) {
                _this.props.onSelect(date);
                (_d = (_c = _this.props).setOpen) === null || _d === void 0 || _d.call(_c, true);
            }
            _this.props.setPreSelection && _this.props.setPreSelection(date);
        };
        _this.getEnabledPreSelectionDateForMonth = function(date) {
            if (!$393fb8fc0a86de60$var$isDayDisabled(date, _this.props)) return date;
            var startOfMonth = $393fb8fc0a86de60$var$getStartOfMonth(date);
            var endOfMonth = $393fb8fc0a86de60$var$getEndOfMonth(date);
            var totalDays = (0, $2500a9260f415d15$export$86415ebf4eb36b8c)(endOfMonth, startOfMonth);
            var preSelectedDate = null;
            for(var dayIdx = 0; dayIdx <= totalDays; dayIdx++){
                var processingDate = (0, $2b4ff6e56ae3ad17$export$dd412b56f1e4d8aa)(startOfMonth, dayIdx);
                if (!$393fb8fc0a86de60$var$isDayDisabled(processingDate, _this.props)) {
                    preSelectedDate = processingDate;
                    break;
                }
            }
            return preSelectedDate;
        };
        _this.handleMonthChange = function(date) {
            var _a, _b, _c;
            var enabledPreSelectionDate = (_a = _this.getEnabledPreSelectionDateForMonth(date)) !== null && _a !== void 0 ? _a : date;
            _this.handleCustomMonthChange(enabledPreSelectionDate);
            if (_this.props.adjustDateOnChange) {
                _this.props.onSelect(enabledPreSelectionDate);
                (_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, true);
            }
            _this.props.setPreSelection && _this.props.setPreSelection(enabledPreSelectionDate);
        };
        _this.handleCustomMonthChange = function(date) {
            var _a, _b;
            (_b = (_a = _this.props).onMonthChange) === null || _b === void 0 || _b.call(_a, date);
            _this.setState({
                isRenderAriaLiveMessage: true
            });
        };
        _this.handleMonthYearChange = function(date) {
            _this.handleYearChange(date);
            _this.handleMonthChange(date);
        };
        _this.changeYear = function(year) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $c9d0036666d361ea$export$a8408b6c5639cab7)(date, Number(year))
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.changeMonth = function(month) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $d26b511e86cf447a$export$63264690f8e36790)(date, Number(month))
                };
            }, function() {
                var _a, _b;
                _this.handleMonthChange(_this.state.date);
                // Reset monthSelectedIn to 0 so the target month appears in the leftmost position
                // This ensures consistent behavior when using changeMonth in custom headers
                (_b = (_a = _this.props).onMonthSelectedInChange) === null || _b === void 0 || _b.call(_a, 0);
            });
        };
        _this.changeMonthYear = function(monthYear) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $c9d0036666d361ea$export$a8408b6c5639cab7)((0, $d26b511e86cf447a$export$63264690f8e36790)(date, (0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)(monthYear)), (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(monthYear))
                };
            }, function() {
                return _this.handleMonthYearChange(_this.state.date);
            });
        };
        _this.header = function(date, customDayNameCount) {
            if (date === void 0) date = _this.state.date;
            if (customDayNameCount === void 0) customDayNameCount = 0;
            // Return empty array if date is invalid
            if (!$393fb8fc0a86de60$var$isValid(date)) return [];
            var disabled = _this.props.disabled;
            var startOfWeek = $393fb8fc0a86de60$var$getStartOfWeek(date, _this.props.locale, _this.props.calendarStartDay);
            var dayNames = [];
            if (_this.props.showWeekNumbers) dayNames.push((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                key: "W",
                className: "react-datepicker__day-name ".concat(disabled ? "react-datepicker__day-name--disabled" : ""),
                role: "columnheader"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                className: "react-datepicker__sr-only"
            }, "Week number"), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                "aria-hidden": "true"
            }, _this.props.weekLabel || "#")));
            return dayNames.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $2b4ff6e56ae3ad17$export$dd412b56f1e4d8aa)(startOfWeek, offset);
                var weekDayName = _this.formatWeekday(day, _this.props.locale);
                var fullDayName = $393fb8fc0a86de60$var$formatDate(day, "EEEE", _this.props.locale);
                var weekDayClassName = _this.props.weekDayClassName ? _this.props.weekDayClassName(day) : undefined;
                // Use custom render if provided
                if (_this.props.renderCustomDayName) {
                    var customContent = _this.props.renderCustomDayName({
                        day: day,
                        shortName: weekDayName,
                        fullName: fullDayName,
                        locale: _this.props.locale,
                        customDayNameCount: customDayNameCount
                    });
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                        key: offset,
                        role: "columnheader",
                        className: (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)("react-datepicker__day-name", weekDayClassName, disabled ? "react-datepicker__day-name--disabled" : "")
                    }, customContent);
                }
                // Default render
                return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    key: offset,
                    role: "columnheader",
                    className: (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)("react-datepicker__day-name", weekDayClassName, disabled ? "react-datepicker__day-name--disabled" : "")
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                    className: "react-datepicker__sr-only"
                }, fullDayName), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                    "aria-hidden": "true"
                }, weekDayName));
            }));
        };
        _this.formatWeekday = function(day, locale) {
            if (_this.props.formatWeekDay) return $393fb8fc0a86de60$var$getFormattedWeekdayInLocale(day, _this.props.formatWeekDay, locale);
            return _this.props.useWeekdaysShort ? $393fb8fc0a86de60$var$getWeekdayShortInLocale(day, locale) : $393fb8fc0a86de60$var$getWeekdayMinInLocale(day, locale);
        };
        _this.decreaseYear = function() {
            _this.setState(function(_a) {
                var _b;
                var date = _a.date;
                return {
                    date: (0, $03aa6c2df8a28792$export$14867687ff6c92e2)(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1)
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.clearSelectingDate = function() {
            _this.setState({
                selectingDate: undefined
            });
        };
        _this.renderPreviousButton = function() {
            var _a, _b, _c;
            if (_this.props.renderCustomHeader) return;
            var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
            var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
            var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
            var fromMonthDate = (0, $62367543e39b34d6$export$73d1c15a21f9fae5)(_this.state.date, monthSelectedIn);
            var allPrevDaysDisabled;
            switch(true){
                case _this.props.disabled:
                    allPrevDaysDisabled = true;
                    break;
                case _this.props.showMonthYearPicker:
                    allPrevDaysDisabled = $393fb8fc0a86de60$var$yearDisabledBefore(_this.state.date, _this.props);
                    break;
                case _this.props.showYearPicker:
                    allPrevDaysDisabled = $393fb8fc0a86de60$var$yearsDisabledBefore(_this.state.date, _this.props);
                    break;
                case _this.props.showQuarterYearPicker:
                    allPrevDaysDisabled = $393fb8fc0a86de60$var$quarterDisabledBefore(_this.state.date, _this.props);
                    break;
                default:
                    allPrevDaysDisabled = $393fb8fc0a86de60$var$monthDisabledBefore(fromMonthDate, _this.props);
                    break;
            }
            if (!((_c = _this.props.forceShowMonthNavigation) !== null && _c !== void 0 ? _c : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) return;
            var iconClasses = [
                "react-datepicker__navigation-icon",
                "react-datepicker__navigation-icon--previous"
            ];
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--previous"
            ];
            var clickHandler = _this.decreaseMonth;
            if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.decreaseYear;
            if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--previous--disabled");
                clickHandler = undefined;
            }
            var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
            var _d = _this.props, _e = _d.previousMonthButtonLabel, previousMonthButtonLabel = _e === void 0 ? Calendar.defaultProps.previousMonthButtonLabel : _e, _f = _d.previousYearButtonLabel, previousYearButtonLabel = _f === void 0 ? Calendar.defaultProps.previousYearButtonLabel : _f;
            var _g = _this.props, _h = _g.previousMonthAriaLabel, previousMonthAriaLabel = _h === void 0 ? typeof previousMonthButtonLabel === "string" ? previousMonthButtonLabel : "Previous Month" : _h, _j = _g.previousYearAriaLabel, previousYearAriaLabel = _j === void 0 ? typeof previousYearButtonLabel === "string" ? previousYearButtonLabel : "Previous Year" : _j;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler,
                onKeyDown: _this.props.handleOnKeyDown,
                "aria-label": isForYear ? previousYearAriaLabel : previousMonthAriaLabel
            }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                className: iconClasses.join(" ")
            }, isForYear ? previousYearButtonLabel : previousMonthButtonLabel));
        };
        _this.increaseYear = function() {
            _this.setState(function(_a) {
                var _b;
                var date = _a.date;
                return {
                    date: (0, $5c6b1b4dffb22d4b$export$3d83eec43f4ea476)(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1)
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.renderNextButton = function() {
            var _a;
            if (_this.props.renderCustomHeader) return;
            var allNextDaysDisabled;
            switch(true){
                case _this.props.disabled:
                    allNextDaysDisabled = true;
                    break;
                case _this.props.showMonthYearPicker:
                    allNextDaysDisabled = $393fb8fc0a86de60$var$yearDisabledAfter(_this.state.date, _this.props);
                    break;
                case _this.props.showYearPicker:
                    allNextDaysDisabled = $393fb8fc0a86de60$var$yearsDisabledAfter(_this.state.date, _this.props);
                    break;
                case _this.props.showQuarterYearPicker:
                    allNextDaysDisabled = $393fb8fc0a86de60$var$quarterDisabledAfter(_this.state.date, _this.props);
                    break;
                default:
                    allNextDaysDisabled = $393fb8fc0a86de60$var$monthDisabledAfter(_this.state.date, _this.props);
                    break;
            }
            if (!((_a = _this.props.forceShowMonthNavigation) !== null && _a !== void 0 ? _a : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) return;
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--next"
            ];
            var iconClasses = [
                "react-datepicker__navigation-icon",
                "react-datepicker__navigation-icon--next"
            ];
            if (_this.props.showTimeSelect) classes.push("react-datepicker__navigation--next--with-time");
            if (_this.props.todayButton) classes.push("react-datepicker__navigation--next--with-today-button");
            var clickHandler = _this.increaseMonth;
            if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.increaseYear;
            if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--next--disabled");
                clickHandler = undefined;
            }
            var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
            var _b = _this.props, _c = _b.nextMonthButtonLabel, nextMonthButtonLabel = _c === void 0 ? Calendar.defaultProps.nextMonthButtonLabel : _c, _d = _b.nextYearButtonLabel, nextYearButtonLabel = _d === void 0 ? Calendar.defaultProps.nextYearButtonLabel : _d;
            var _e = _this.props, _f = _e.nextMonthAriaLabel, nextMonthAriaLabel = _f === void 0 ? typeof nextMonthButtonLabel === "string" ? nextMonthButtonLabel : "Next Month" : _f, _g = _e.nextYearAriaLabel, nextYearAriaLabel = _g === void 0 ? typeof nextYearButtonLabel === "string" ? nextYearButtonLabel : "Next Year" : _g;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler,
                onKeyDown: _this.props.handleOnKeyDown,
                "aria-label": isForYear ? nextYearAriaLabel : nextMonthAriaLabel
            }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                className: iconClasses.join(" ")
            }, isForYear ? nextYearButtonLabel : nextMonthButtonLabel));
        };
        _this.renderCurrentMonth = function(date) {
            if (date === void 0) date = _this.state.date;
            var classes = [
                "react-datepicker__current-month"
            ];
            if (_this.props.showYearDropdown) classes.push("react-datepicker__current-month--hasYearDropdown");
            if (_this.props.showMonthDropdown) classes.push("react-datepicker__current-month--hasMonthDropdown");
            if (_this.props.showMonthYearDropdown) classes.push("react-datepicker__current-month--hasMonthYearDropdown");
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("h2", {
                className: classes.join(" ")
            }, $393fb8fc0a86de60$var$isValid(date) ? $393fb8fc0a86de60$var$formatDate(date, _this.props.dateFormat, _this.props.locale) : "");
        };
        _this.renderYearDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$YearDropdown, $393fb8fc0a86de60$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: _this.state.date,
                onChange: _this.changeYear,
                year: (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(_this.state.date)
            }));
        };
        _this.renderMonthDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showMonthDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$MonthDropdown, $393fb8fc0a86de60$var$_assign({}, Calendar.defaultProps, _this.props, {
                month: (0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)(_this.state.date),
                onChange: _this.changeMonth
            }));
        };
        _this.renderMonthYearDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showMonthYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$MonthYearDropdown, $393fb8fc0a86de60$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: _this.state.date,
                onChange: _this.changeMonthYear
            }));
        };
        _this.handleTodayButtonClick = function(event) {
            _this.props.onSelect($393fb8fc0a86de60$var$getStartOfToday(), event);
            _this.props.setPreSelection && _this.props.setPreSelection($393fb8fc0a86de60$var$getStartOfToday());
        };
        _this.renderTodayButton = function() {
            if (!_this.props.todayButton || _this.props.showTimeSelectOnly) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker__today-button",
                onClick: _this.handleTodayButtonClick
            }, _this.props.todayButton);
        };
        _this.renderDayNamesHeader = function(monthDate, customDayNameCount) {
            if (customDayNameCount === void 0) customDayNameCount = 0;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker__day-names",
                role: "row"
            }, _this.header(monthDate, customDayNameCount));
        };
        _this.renderDefaultHeader = function(_a) {
            var monthDate = _a.monthDate, i = _a.i;
            var headerContent = (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)("react-datepicker__header", {
                    "react-datepicker__header--has-time-select": _this.props.showTimeSelect,
                    "react-datepicker__header--middle": _this.props.monthHeaderPosition === "middle",
                    "react-datepicker__header--bottom": _this.props.monthHeaderPosition === "bottom"
                })
            }, _this.renderCurrentMonth(monthDate), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(_this.props.dropdownMode),
                onFocus: _this.handleDropdownFocus
            }, _this.renderMonthDropdown(i !== 0), _this.renderMonthYearDropdown(i !== 0), _this.renderYearDropdown(i !== 0)));
            // Top position: render header directly in default location
            if (_this.props.monthHeaderPosition === "top") return headerContent;
            // Middle/bottom positions: wrap with navigation buttons
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker__header-wrapper"
            }, _this.renderPreviousButton() || null, _this.renderNextButton() || null, headerContent);
        };
        _this.renderCustomHeader = function(headerArgs) {
            var _a, _b;
            var monthDate = headerArgs.monthDate, i = headerArgs.i;
            if (_this.props.showTimeSelect && !_this.state.monthContainer || _this.props.showTimeSelectOnly) return null;
            var _c = _this.props, showYearPicker = _c.showYearPicker, yearItemNumber = _c.yearItemNumber;
            var visibleYearsRange;
            if (showYearPicker) {
                var _d = $393fb8fc0a86de60$var$getYearsPeriod(monthDate, yearItemNumber), startYear = _d.startPeriod, endYear = _d.endPeriod;
                visibleYearsRange = {
                    startYear: startYear,
                    endYear: endYear
                };
            }
            var prevMonthButtonDisabled = $393fb8fc0a86de60$var$monthDisabledBefore(_this.state.date, _this.props);
            var nextMonthButtonDisabled = $393fb8fc0a86de60$var$monthDisabledAfter(_this.state.date, _this.props);
            var prevYearButtonDisabled = $393fb8fc0a86de60$var$yearDisabledBefore(_this.state.date, _this.props);
            var nextYearButtonDisabled = $393fb8fc0a86de60$var$yearDisabledAfter(_this.state.date, _this.props);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--custom",
                onFocus: _this.props.onDropdownFocus
            }, (_b = (_a = _this.props).renderCustomHeader) === null || _b === void 0 ? void 0 : _b.call(_a, $393fb8fc0a86de60$var$_assign($393fb8fc0a86de60$var$_assign($393fb8fc0a86de60$var$_assign({}, _this.state), showYearPicker && {
                visibleYearsRange: visibleYearsRange
            }), {
                customHeaderCount: i,
                monthDate: monthDate,
                changeMonth: _this.changeMonth,
                changeYear: _this.changeYear,
                decreaseMonth: _this.decreaseMonth,
                increaseMonth: _this.increaseMonth,
                decreaseYear: _this.decreaseYear,
                increaseYear: _this.increaseYear,
                prevMonthButtonDisabled: prevMonthButtonDisabled,
                nextMonthButtonDisabled: nextMonthButtonDisabled,
                prevYearButtonDisabled: prevYearButtonDisabled,
                nextYearButtonDisabled: nextYearButtonDisabled
            })));
        };
        _this.renderYearHeader = function(_a) {
            var monthDate = _a.monthDate;
            var _b = _this.props, showYearPicker = _b.showYearPicker, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? Calendar.defaultProps.yearItemNumber : _c;
            var _d = $393fb8fc0a86de60$var$getYearsPeriod(monthDate, yearItemNumber), startPeriod = _d.startPeriod, endPeriod = _d.endPeriod;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker__header react-datepicker-year-header"
            }, showYearPicker ? "".concat(startPeriod, " - ").concat(endPeriod) : (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(monthDate));
        };
        _this.renderHeader = function(_a) {
            var monthDate = _a.monthDate, _b = _a.i, i = _b === void 0 ? 0 : _b;
            var headerArgs = {
                monthDate: monthDate,
                i: i
            };
            switch(true){
                case _this.props.renderCustomHeader !== undefined:
                    return _this.renderCustomHeader(headerArgs);
                case _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker:
                    return _this.renderYearHeader(headerArgs);
                default:
                    return _this.renderDefaultHeader(headerArgs);
            }
        };
        _this.renderMonths = function() {
            var _a, _b;
            if (_this.props.showTimeSelectOnly || _this.props.showYearPicker) return;
            var monthList = [];
            var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
            var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
            var fromMonthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? (0, $5c6b1b4dffb22d4b$export$3d83eec43f4ea476)(_this.state.date, monthsToSubtract) : (0, $62367543e39b34d6$export$73d1c15a21f9fae5)(_this.state.date, monthsToSubtract);
            var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
            for(var i = 0; i < monthsShown; ++i){
                var monthsToAdd = i - monthSelectedIn + monthsToSubtract;
                var monthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? (0, $5c6b1b4dffb22d4b$export$3d83eec43f4ea476)(fromMonthDate, monthsToAdd) : (0, $75507be8d602cbce$export$17c93e242b2d3a22)(fromMonthDate, monthsToAdd);
                var monthKey = "month-".concat(i);
                var monthShowsDuplicateDaysEnd = i < monthsShown - 1;
                var monthShowsDuplicateDaysStart = i > 0;
                monthList.push((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                    key: monthKey,
                    ref: function ref(div) {
                        _this.monthContainer = div !== null && div !== void 0 ? div : undefined;
                    },
                    className: "react-datepicker__month-container"
                }, _this.props.monthHeaderPosition === "top" && _this.renderHeader({
                    monthDate: monthDate,
                    i: i
                }), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$Month, $393fb8fc0a86de60$var$_assign({}, Calendar.defaultProps, _this.props, {
                    containerRef: _this.containerRef,
                    ariaLabelPrefix: _this.props.monthAriaLabelPrefix,
                    day: monthDate,
                    onDayClick: _this.handleDayClick,
                    handleOnKeyDown: _this.props.handleOnDayKeyDown,
                    handleOnMonthKeyDown: _this.props.handleOnKeyDown,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    onMouseLeave: _this.handleMonthMouseLeave,
                    orderInDisplay: i,
                    selectingDate: _this.state.selectingDate,
                    monthShowsDuplicateDaysEnd: monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: monthShowsDuplicateDaysStart,
                    dayNamesHeader: _this.renderDayNamesHeader(monthDate, i),
                    monthHeader: _this.props.monthHeaderPosition === "middle" ? _this.renderHeader({
                        monthDate: monthDate,
                        i: i
                    }) : undefined,
                    monthFooter: _this.props.monthHeaderPosition === "bottom" ? _this.renderHeader({
                        monthDate: monthDate,
                        i: i
                    }) : undefined
                }))));
            }
            return monthList;
        };
        _this.renderYears = function() {
            if (_this.props.showTimeSelectOnly) return;
            if (_this.props.showYearPicker) return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker__year--container"
            }, _this.renderHeader({
                monthDate: _this.state.date
            }), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$Year, $393fb8fc0a86de60$var$_assign({}, Calendar.defaultProps, _this.props, {
                selectingDate: _this.state.selectingDate,
                date: _this.state.date,
                onDayClick: _this.handleDayClick,
                clearSelectingDate: _this.clearSelectingDate,
                onYearMouseEnter: _this.handleYearMouseEnter,
                onYearMouseLeave: _this.handleYearMouseLeave
            })));
            return;
        };
        _this.renderTimeSection = function() {
            if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$Time, $393fb8fc0a86de60$var$_assign({}, Calendar.defaultProps, _this.props, {
                onChange: _this.props.onTimeChange,
                format: _this.props.timeFormat,
                intervals: _this.props.timeIntervals,
                monthRef: _this.state.monthContainer
            }));
            return;
        };
        _this.renderInputTimeSection = function() {
            var _a, _b;
            if (!_this.props.showTimeInput) return;
            // Handle selectsRange mode - render two time inputs
            if (_this.props.selectsRange) {
                var _c = _this.props, startDate = _c.startDate, endDate = _c.endDate;
                var startTime = startDate ? new Date(startDate) : undefined;
                var startTimeValid = startTime && $393fb8fc0a86de60$var$isValid(startTime) && Boolean(startDate);
                var startTimeString = startTimeValid ? "".concat($393fb8fc0a86de60$var$addZero(startTime.getHours()), ":").concat($393fb8fc0a86de60$var$addZero(startTime.getMinutes())) : "";
                var endTime = endDate ? new Date(endDate) : undefined;
                var endTimeValid = endTime && $393fb8fc0a86de60$var$isValid(endTime) && Boolean(endDate);
                var endTimeString = endTimeValid ? "".concat($393fb8fc0a86de60$var$addZero(endTime.getHours()), ":").concat($393fb8fc0a86de60$var$addZero(endTime.getMinutes())) : "";
                return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$InputTime, $393fb8fc0a86de60$var$_assign({}, Calendar.defaultProps, _this.props, {
                    date: startTime,
                    timeString: startTimeString,
                    onChange: function onChange(time) {
                        var _a, _b;
                        (_b = (_a = _this.props).onTimeChange) === null || _b === void 0 || _b.call(_a, time, "start");
                    },
                    timeInputLabel: ((_a = _this.props.timeInputLabel) !== null && _a !== void 0 ? _a : "Time") + " (Start)"
                })), (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$InputTime, $393fb8fc0a86de60$var$_assign({}, Calendar.defaultProps, _this.props, {
                    date: endTime,
                    timeString: endTimeString,
                    onChange: function onChange(time) {
                        var _a, _b;
                        (_b = (_a = _this.props).onTimeChange) === null || _b === void 0 || _b.call(_a, time, "end");
                    },
                    timeInputLabel: ((_b = _this.props.timeInputLabel) !== null && _b !== void 0 ? _b : "Time") + " (End)"
                })));
            }
            // Single date mode (original behavior)
            var time = _this.props.selected ? new Date(_this.props.selected) : undefined;
            var timeValid = time && $393fb8fc0a86de60$var$isValid(time) && Boolean(_this.props.selected);
            var timeString = timeValid ? "".concat($393fb8fc0a86de60$var$addZero(time.getHours()), ":").concat($393fb8fc0a86de60$var$addZero(time.getMinutes())) : "";
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$InputTime, $393fb8fc0a86de60$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: time,
                timeString: timeString,
                onChange: function onChange(time) {
                    var _a, _b;
                    (_b = (_a = _this.props).onTimeChange) === null || _b === void 0 || _b.call(_a, time);
                }
            }));
        };
        _this.renderAriaLiveRegion = function() {
            var _a;
            // Don't render aria-live message if date is invalid
            if (!$393fb8fc0a86de60$var$isValid(_this.state.date)) return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            });
            var _b = $393fb8fc0a86de60$var$getYearsPeriod(_this.state.date, (_a = _this.props.yearItemNumber) !== null && _a !== void 0 ? _a : Calendar.defaultProps.yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
            var ariaLiveMessage;
            if (_this.props.showYearPicker) ariaLiveMessage = "".concat(startPeriod, " - ").concat(endPeriod);
            else if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker) ariaLiveMessage = (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(_this.state.date);
            else ariaLiveMessage = "".concat($393fb8fc0a86de60$var$getMonthInLocale((0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)(_this.state.date), _this.props.locale), " ").concat((0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(_this.state.date));
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, _this.state.isRenderAriaLiveMessage && ariaLiveMessage);
        };
        _this.renderChildren = function() {
            if (_this.props.children) return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker__children-container"
            }, _this.props.children);
            return;
        };
        _this.containerRef = (0, $5s1kH.createRef)();
        _this.state = {
            date: _this.getDateInView(),
            selectingDate: undefined,
            monthContainer: undefined,
            isRenderAriaLiveMessage: false
        };
        return _this;
    }
    Object.defineProperty(Calendar, "defaultProps", {
        get: function get() {
            return {
                monthsShown: 1,
                forceShowMonthNavigation: false,
                outsideClickIgnoreClass: $393fb8fc0a86de60$var$OUTSIDE_CLICK_IGNORE_CLASS,
                timeCaption: "Time",
                previousYearButtonLabel: "Previous Year",
                nextYearButtonLabel: "Next Year",
                previousMonthButtonLabel: "Previous Month",
                nextMonthButtonLabel: "Next Month",
                yearItemNumber: $393fb8fc0a86de60$var$DEFAULT_YEAR_ITEM_NUMBER,
                monthHeaderPosition: "top"
            };
        },
        enumerable: false,
        configurable: true
    });
    Calendar.prototype.componentDidMount = function() {
        var _this = this;
        // monthContainer height is needed in time component
        // to determine the height for the ul in the time component
        // setState here so height is given after final component
        // layout is rendered
        if (this.props.showTimeSelect) this.assignMonthContainer = function() {
            _this.setState({
                monthContainer: _this.monthContainer
            });
        }();
    };
    Calendar.prototype.componentDidUpdate = function(prevProps) {
        var _this = this;
        if (this.props.preSelection && $393fb8fc0a86de60$var$isValid(this.props.preSelection) && (!$393fb8fc0a86de60$var$isSameDay(this.props.preSelection, prevProps.preSelection) || this.props.monthSelectedIn !== prevProps.monthSelectedIn)) {
            var hasMonthChanged_1 = !$393fb8fc0a86de60$var$isSameMonth(this.state.date, this.props.preSelection);
            this.setState({
                date: this.props.preSelection
            }, function() {
                return hasMonthChanged_1 && _this.handleCustomMonthChange(_this.state.date);
            });
        } else if (this.props.openToDate && !$393fb8fc0a86de60$var$isSameDay(this.props.openToDate, prevProps.openToDate)) this.setState({
            date: this.props.openToDate
        });
    };
    Calendar.prototype.render = function() {
        var Container = this.props.container || $393fb8fc0a86de60$export$946daa762919616e;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$ClickOutsideWrapper, {
            onClickOutside: this.handleClickOutside,
            style: {
                display: "contents"
            },
            ignoreClass: this.props.outsideClickIgnoreClass
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            style: {
                display: "contents"
            },
            ref: this.containerRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(Container, {
            className: (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)("react-datepicker", this.props.className, {
                "react-datepicker--time-only": this.props.showTimeSelectOnly
            }),
            showTime: this.props.showTimeSelect || this.props.showTimeInput,
            showTimeSelectOnly: this.props.showTimeSelectOnly,
            inline: this.props.inline
        }, this.renderAriaLiveRegion(), this.props.monthHeaderPosition === "top" && this.renderPreviousButton(), this.props.monthHeaderPosition === "top" && this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren())));
    };
    return Calendar;
}((0, $5s1kH.Component));
/**
 * `CalendarIcon` is a React component that renders an icon for a calendar.
 * The icon can be a string representing a CSS class, a React node, or a default SVG icon.
 *
 * @component
 * @prop  icon - The icon to be displayed. This can be a string representing a CSS class or a React node.
 * @prop  className - An optional string representing additional CSS classes to be applied to the icon.
 * @prop  onClick - An optional function to be called when the icon is clicked.
 *
 * @example
 * // To use a CSS class as the icon
 * <CalendarIcon icon="my-icon-class" onClick={myClickHandler} />
 *
 * @example
 * // To use a React node as the icon
 * <CalendarIcon icon={<MyIconComponent />} onClick={myClickHandler} />
 *
 * @returns  The `CalendarIcon` component.
 */ var $393fb8fc0a86de60$var$CalendarIcon = function CalendarIcon(_a) {
    var icon = _a.icon, _b = _a.className, className = _b === void 0 ? "" : _b, onClick = _a.onClick;
    var defaultClass = "react-datepicker__calendar-icon";
    if (typeof icon === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("i", {
        className: "".concat(defaultClass, " ").concat(icon, " ").concat(className),
        "aria-hidden": "true",
        onClick: onClick
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).isValidElement(icon)) {
        // Because we are checking that typeof icon is string first, we can safely cast icon as React.ReactElement on types level and code level
        var iconElement_1 = icon;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).cloneElement(iconElement_1, {
            className: "".concat(iconElement_1.props.className || "", " ").concat(defaultClass, " ").concat(className),
            onClick: function onClick1(event) {
                if (typeof iconElement_1.props.onClick === "function") iconElement_1.props.onClick(event);
                if (typeof onClick === "function") onClick(event);
            }
        });
    }
    // Default SVG Icon
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("svg", {
        className: "".concat(defaultClass, " ").concat(className),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512",
        onClick: onClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("path", {
        d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    }));
};
/**
 * `Portal` is a React component that allows you to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * @class
 * @param {PortalProps} props - The properties that define the `Portal` component.
 * @property {React.ReactNode} props.children - The children to be rendered into the `Portal`.
 * @property {string} props.portalId - The id of the DOM node into which the `Portal` will render.
 * @property {ShadowRoot} [props.portalHost] - The DOM node to host the `Portal`.
 */ var $393fb8fc0a86de60$var$Portal = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(Portal, _super);
    function Portal(props) {
        var _this = _super.call(this, props) || this;
        _this.portalRoot = null;
        _this.el = document.createElement("div");
        return _this;
    }
    Portal.prototype.componentDidMount = function() {
        this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId);
        if (!this.portalRoot) {
            this.portalRoot = document.createElement("div");
            this.portalRoot.setAttribute("id", this.props.portalId);
            (this.props.portalHost || document.body).appendChild(this.portalRoot);
        }
        this.portalRoot.appendChild(this.el);
    };
    Portal.prototype.componentWillUnmount = function() {
        if (this.portalRoot) this.portalRoot.removeChild(this.el);
    };
    Portal.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eAxYl))).createPortal(this.props.children, this.el);
    };
    return Portal;
}((0, $5s1kH.Component));
var $393fb8fc0a86de60$var$focusableElementsSelector = "[tabindex], a, button, input, select, textarea";
var $393fb8fc0a86de60$var$focusableFilter = function focusableFilter(node) {
    if (node instanceof HTMLAnchorElement) return node.tabIndex !== -1;
    return !node.disabled && node.tabIndex !== -1;
};
/**
 * `TabLoop` is a React component that manages tabbing behavior for its children.
 *
 * TabLoop prevents the user from tabbing outside of the popper
 * It creates a tabindex loop so that "Tab" on the last element will focus the first element
 * and "Shift Tab" on the first element will focus the last element
 *
 * @component
 * @example
 * <TabLoop enableTabLoop={true}>
 *   <ChildComponent />
 * </TabLoop>
 *
 * @param props - The properties that define the `TabLoop` component.
 * @param props.children - The child components.
 * @param props.enableTabLoop - Whether to enable the tab loop.
 *
 * @returns The `TabLoop` component.
 */ var $393fb8fc0a86de60$var$TabLoop = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(TabLoop, _super);
    function TabLoop(props) {
        var _this = _super.call(this, props) || this;
        /**
         * `getTabChildren` is a method of the `TabLoop` class that retrieves all tabbable children of the component.
         *
         * This method uses the `tabbable` library to find all tabbable elements within the `TabLoop` component.
         * It then filters out any elements that are not visible.
         *
         * @returns An array of all tabbable and visible children of the `TabLoop` component.
         */ _this.getTabChildren = function() {
            var _a;
            return Array.prototype.slice.call((_a = _this.tabLoopRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll($393fb8fc0a86de60$var$focusableElementsSelector), 1, -1).filter($393fb8fc0a86de60$var$focusableFilter);
        };
        _this.handleFocusStart = function() {
            var tabChildren = _this.getTabChildren();
            tabChildren && tabChildren.length > 1 && tabChildren[tabChildren.length - 1].focus();
        };
        _this.handleFocusEnd = function() {
            var tabChildren = _this.getTabChildren();
            tabChildren && tabChildren.length > 1 && tabChildren[0].focus();
        };
        _this.tabLoopRef = (0, $5s1kH.createRef)();
        return _this;
    }
    TabLoop.prototype.render = function() {
        var _a;
        if (!((_a = this.props.enableTabLoop) !== null && _a !== void 0 ? _a : TabLoop.defaultProps.enableTabLoop)) return this.props.children;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker__tab-loop",
            ref: this.tabLoopRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker__tab-loop__start",
            tabIndex: 0,
            onFocus: this.handleFocusStart
        }), this.props.children, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker__tab-loop__end",
            tabIndex: 0,
            onFocus: this.handleFocusEnd
        }));
    };
    TabLoop.defaultProps = {
        enableTabLoop: true
    };
    return TabLoop;
}((0, $5s1kH.Component));
/**
 * `withFloating` is a higher-order component that adds floating behavior to a component.
 *
 * @param Component - The component to enhance.
 *
 * @example
 * const FloatingComponent = withFloating(MyComponent);
 * <FloatingComponent popperModifiers={[]} popperProps={{}} hidePopper={true} />
 *
 * @param popperModifiers - The modifiers to use for the popper.
 * @param popperProps - The props to pass to the popper.
 * @param hidePopper - Whether to hide the popper.
 * @param popperPlacement - The placement of the popper.
 *
 * @returns A new component with floating behavior.
 */ function $393fb8fc0a86de60$var$withFloating(Component) {
    function WithFloating(props) {
        var _a;
        var hidePopper = typeof props.hidePopper === "boolean" ? props.hidePopper : true;
        var arrowRef = (0, $5s1kH.useRef)(null);
        var floatingProps = (0, $ad76f2a8d85683d0$export$4e02a5c1d08bac65)($393fb8fc0a86de60$var$_assign({
            open: !hidePopper,
            whileElementsMounted: (0, $c1d497a3e5aa805c$export$deee3a793edee05f),
            placement: props.popperPlacement,
            middleware: $393fb8fc0a86de60$var$__spreadArray([
                (0, $5b7bf8dbb9190e49$export$8a83211c878a3f1f)({
                    padding: 15
                }),
                (0, $5b7bf8dbb9190e49$export$cc800923e997bb8)(10),
                // eslint-disable-next-line react-hooks/refs -- Floating UI requires refs to be passed during render
                (0, $5b7bf8dbb9190e49$export$f2120bbfa5450bd2)({
                    element: arrowRef
                })
            ], (_a = props.popperModifiers) !== null && _a !== void 0 ? _a : [], true)
        }, props.popperProps));
        var componentProps = $393fb8fc0a86de60$var$_assign($393fb8fc0a86de60$var$_assign({}, props), {
            hidePopper: hidePopper,
            popperProps: $393fb8fc0a86de60$var$_assign($393fb8fc0a86de60$var$_assign({}, floatingProps), {
                arrowRef: arrowRef
            })
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement(Component, $393fb8fc0a86de60$var$_assign({}, componentProps));
    }
    WithFloating.displayName = "withFloating(".concat(Component.displayName || Component.name || "Component", ")");
    return WithFloating;
}
// Exported for testing purposes
var $393fb8fc0a86de60$var$PopperComponent$1 = function PopperComponent$1(props) {
    var className = props.className, wrapperClassName = props.wrapperClassName, _a = props.hidePopper, hidePopper = _a === void 0 ? true : _a, popperComponent = props.popperComponent, targetComponent = props.targetComponent, enableTabLoop = props.enableTabLoop, popperOnKeyDown = props.popperOnKeyDown, portalId = props.portalId, portalHost = props.portalHost, popperProps = props.popperProps, showArrow = props.showArrow, popperTargetRef = props.popperTargetRef, monthHeaderPosition = props.monthHeaderPosition;
    // When a custom popperTargetRef is provided, use it as the position reference
    // This allows the popper to be positioned relative to a specific element
    // within the custom input, rather than the wrapper div
    (0, $5s1kH.useEffect)(function() {
        if (popperTargetRef === null || popperTargetRef === void 0 ? void 0 : popperTargetRef.current) popperProps.refs.setPositionReference(popperTargetRef.current);
    }, [
        popperTargetRef,
        popperProps.refs
    ]);
    var popper = undefined;
    if (!hidePopper) {
        var classes = (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)("react-datepicker-popper", !showArrow && "react-datepicker-popper-offset", monthHeaderPosition === "middle" && "react-datepicker-popper--header-middle", monthHeaderPosition === "bottom" && "react-datepicker-popper--header-bottom", className);
        popper = (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$TabLoop, {
            enableTabLoop: enableTabLoop
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            ref: popperProps.refs.setFloating,
            style: popperProps.floatingStyles,
            className: classes,
            "data-placement": popperProps.placement,
            onKeyDown: popperOnKeyDown
        }, popperComponent, showArrow && (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement((0, $ad76f2a8d85683d0$export$33511391554732bc), {
            ref: popperProps.arrowRef,
            context: popperProps.context,
            fill: "currentColor",
            strokeWidth: 1,
            height: 8,
            width: 16,
            style: {
                transform: "translateY(-1px)"
            },
            className: "react-datepicker__triangle"
        })));
    }
    if (props.popperContainer) popper = (0, $5s1kH.createElement)(props.popperContainer, {}, popper);
    if (portalId && !hidePopper) popper = (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$Portal, {
        portalId: portalId,
        portalHost: portalHost
    }, popper);
    var wrapperClasses = (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)("react-datepicker-wrapper", wrapperClassName);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
        ref: popperProps.refs.setReference,
        className: wrapperClasses
    }, targetComponent), popper);
};
var $393fb8fc0a86de60$var$PopperComponent = $393fb8fc0a86de60$var$withFloating($393fb8fc0a86de60$var$PopperComponent$1);
// Compares dates year+month combinations
function $393fb8fc0a86de60$var$hasPreSelectionChanged(date1, date2) {
    if (date1 && date2) return (0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)(date1) !== (0, $7fcaafd8adb8f8ec$export$6ce1b5acc29cb53b)(date2) || (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(date1) !== (0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(date2);
    return date1 !== date2;
}
/**
 * General datepicker component.
 */ var $393fb8fc0a86de60$var$INPUT_ERR_1 = "Date input not valid.";
var $393fb8fc0a86de60$export$5109c6dd95d8fb00 = /** @class */ function(_super) {
    $393fb8fc0a86de60$var$__extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.calendar = null;
        _this.input = null;
        _this.getPreSelection = function() {
            var timeZone = _this.props.timeZone;
            var baseDate = _this.props.openToDate ? _this.props.openToDate : _this.props.selectsEnd && _this.props.startDate ? _this.props.startDate : _this.props.selectsStart && _this.props.endDate ? _this.props.endDate : $393fb8fc0a86de60$var$newDate();
            // Convert to the specified timezone for display
            return timeZone ? $393fb8fc0a86de60$var$toZonedTime(baseDate, timeZone) : baseDate;
        };
        // Convert the date from string format to standard Date format
        // Uses parseDate with ISO format to parse as local time, preventing
        // dates from shifting in timezones west of UTC. See issue #6105.
        _this.modifyHolidays = function() {
            var _a;
            return (_a = _this.props.holidays) === null || _a === void 0 ? void 0 : _a.reduce(function(accumulator, holiday) {
                var date = $393fb8fc0a86de60$var$parseDate(holiday.date, "yyyy-MM-dd", undefined, false);
                if (!date) return accumulator;
                return $393fb8fc0a86de60$var$__spreadArray($393fb8fc0a86de60$var$__spreadArray([], accumulator, true), [
                    $393fb8fc0a86de60$var$_assign($393fb8fc0a86de60$var$_assign({}, holiday), {
                        date: date
                    })
                ], false);
            }, []);
        };
        _this.calcInitialState = function() {
            var timeZone = _this.props.timeZone;
            var defaultPreSelection = _this.getPreSelection();
            var minDate = $393fb8fc0a86de60$var$getEffectiveMinDate(_this.props);
            var maxDate = $393fb8fc0a86de60$var$getEffectiveMaxDate(_this.props);
            var boundedPreSelection = minDate && (0, $0e5980f964c532bb$export$5c007e10c6929c95)(defaultPreSelection, $393fb8fc0a86de60$var$getStartOfDay(minDate)) ? minDate : maxDate && (0, $63acaba5662d3256$export$e4de839670987035)(defaultPreSelection, $393fb8fc0a86de60$var$getEndOfDay(maxDate)) ? maxDate : defaultPreSelection;
            // Convert selected/startDate to zoned time for display if timezone is specified
            var initialPreSelection = _this.props.selectsRange ? _this.props.startDate : _this.props.selected;
            if (initialPreSelection && timeZone) initialPreSelection = $393fb8fc0a86de60$var$toZonedTime(initialPreSelection, timeZone);
            return {
                open: _this.props.startOpen || false,
                preventFocus: false,
                inputValue: null,
                preSelection: initialPreSelection !== null && initialPreSelection !== void 0 ? initialPreSelection : boundedPreSelection,
                // transforming highlighted days (perhaps nested array)
                // to flat Map for faster access in day.jsx
                highlightDates: $393fb8fc0a86de60$var$getHighLightDaysMap(_this.props.highlightDates),
                focused: false,
                // used to focus day in inline version after month has changed, but not on
                // initial render
                shouldFocusDayInline: false,
                isRenderAriaLiveMessage: false,
                wasHidden: false
            };
        };
        _this.getInputValue = function() {
            var _a;
            var _b = _this.props, locale = _b.locale, startDate = _b.startDate, endDate = _b.endDate, rangeSeparator = _b.rangeSeparator, selected = _b.selected, selectedDates = _b.selectedDates, selectsMultiple = _b.selectsMultiple, selectsRange = _b.selectsRange, formatMultipleDates = _b.formatMultipleDates, value = _b.value;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var inputValue = _this.state.inputValue;
            if (typeof value === "string") return value;
            else if (typeof inputValue === "string") return inputValue;
            else if (selectsRange) return $393fb8fc0a86de60$var$safeDateRangeFormat(startDate, endDate, {
                dateFormat: dateFormat,
                locale: locale,
                rangeSeparator: rangeSeparator
            });
            else if (selectsMultiple) {
                if (formatMultipleDates) {
                    var formatDateFn = function formatDateFn(date) {
                        return $393fb8fc0a86de60$var$safeDateFormat(date, {
                            dateFormat: dateFormat,
                            locale: locale
                        });
                    };
                    return formatMultipleDates(selectedDates !== null && selectedDates !== void 0 ? selectedDates : [], formatDateFn);
                }
                return $393fb8fc0a86de60$var$safeMultipleDatesFormat(selectedDates !== null && selectedDates !== void 0 ? selectedDates : [], {
                    dateFormat: dateFormat,
                    locale: locale
                });
            }
            return $393fb8fc0a86de60$var$safeDateFormat(selected, {
                dateFormat: dateFormat,
                locale: locale
            });
        };
        _this.resetHiddenStatus = function() {
            _this.setState($393fb8fc0a86de60$var$_assign($393fb8fc0a86de60$var$_assign({}, _this.state), {
                wasHidden: false
            }));
        };
        _this.setHiddenStatus = function() {
            _this.setState($393fb8fc0a86de60$var$_assign($393fb8fc0a86de60$var$_assign({}, _this.state), {
                wasHidden: true
            }));
        };
        _this.setHiddenStateOnVisibilityHidden = function() {
            if (document.visibilityState !== "hidden") return;
            _this.setHiddenStatus();
        };
        _this.clearPreventFocusTimeout = function() {
            if (_this.preventFocusTimeout) clearTimeout(_this.preventFocusTimeout);
        };
        _this.setFocus = function() {
            var _a, _b;
            (_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a, {
                preventScroll: true
            });
        };
        _this.setBlur = function() {
            var _a, _b;
            (_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 || _b.call(_a);
            _this.cancelFocusInput();
        };
        _this.deferBlur = function() {
            requestAnimationFrame(function() {
                _this.setBlur();
            });
        };
        _this.setOpen = function(open, skipSetBlur) {
            if (skipSetBlur === void 0) skipSetBlur = false;
            _this.setState({
                open: open,
                preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
                lastPreSelectChange: $393fb8fc0a86de60$var$PRESELECT_CHANGE_VIA_NAVIGATE
            }, function() {
                if (!open) _this.setState(function(prev) {
                    return {
                        focused: skipSetBlur ? prev.focused : false
                    };
                }, function() {
                    !skipSetBlur && _this.deferBlur();
                    _this.setState({
                        inputValue: null
                    });
                });
            });
        };
        _this.inputOk = function() {
            return (0, $3f7a13fe08643584$export$871608497c498473)(_this.state.preSelection);
        };
        _this.isCalendarOpen = function() {
            return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
        };
        _this.handleFocus = function(event) {
            var _a, _b;
            var isAutoReFocus = _this.state.wasHidden;
            var isOpenAllowed = isAutoReFocus ? _this.state.open : true;
            if (isAutoReFocus) _this.resetHiddenStatus();
            if (!_this.state.preventFocus) {
                (_b = (_a = _this.props).onFocus) === null || _b === void 0 || _b.call(_a, event);
                if (isOpenAllowed && !_this.props.preventOpenOnFocus && !_this.props.readOnly) _this.setOpen(true);
            }
            _this.setState({
                focused: true
            });
        };
        _this.sendFocusBackToInput = function() {
            // Clear previous timeout if it exists
            if (_this.preventFocusTimeout) _this.clearPreventFocusTimeout();
            // close the popper and refocus the input
            // stop the input from auto opening onFocus
            // setFocus to the input
            _this.setState({
                preventFocus: true
            }, function() {
                _this.preventFocusTimeout = setTimeout(function() {
                    _this.setFocus();
                    _this.setState({
                        preventFocus: false
                    });
                });
            });
        };
        _this.cancelFocusInput = function() {
            clearTimeout(_this.inputFocusTimeout);
            _this.inputFocusTimeout = undefined;
        };
        _this.deferFocusInput = function() {
            _this.cancelFocusInput();
            _this.inputFocusTimeout = setTimeout(function() {
                return _this.setFocus();
            }, 1);
        };
        _this.handleDropdownFocus = function() {
            _this.cancelFocusInput();
        };
        _this.resetInputValue = function() {
            _this.setState($393fb8fc0a86de60$var$_assign($393fb8fc0a86de60$var$_assign({}, _this.state), {
                inputValue: null
            }));
        };
        _this.handleBlur = function(event) {
            var _a, _b;
            if (!_this.state.open || _this.props.withPortal || _this.props.showTimeInput) (_b = (_a = _this.props).onBlur) === null || _b === void 0 || _b.call(_a, event);
            // If user cleared the input via a mask library (inputValue has no date-like
            // characters), clear the selection on blur (fixes issue #5814 with mask inputs)
            var inputValue = _this.state.inputValue;
            if (typeof inputValue === "string" && inputValue.length > 0) {
                // Check if input looks like a cleared mask (no alphanumeric characters)
                // This distinguishes between:
                // - "__/__/____" (cleared mask) → should clear selection
                // - "2025-02-45" (invalid date) → should keep previous selection
                var hasDateCharacters = /[a-zA-Z0-9]/.test(inputValue);
                if (!hasDateCharacters && _this.props.selected) _this.setSelected(null, undefined, true);
            }
            _this.resetInputValue();
            if (_this.state.open && _this.props.open === false) _this.setOpen(false);
            _this.setState({
                focused: false
            });
        };
        _this.handleCalendarClickOutside = function(event) {
            var _a, _b;
            // Call user's onClickOutside first, allowing them to call preventDefault()
            (_b = (_a = _this.props).onClickOutside) === null || _b === void 0 || _b.call(_a, event);
            // Only close if not prevented and not inline
            if (!_this.props.inline && !event.defaultPrevented) _this.setOpen(false);
            if (_this.props.withPortal) event.preventDefault();
        };
        // handleChange is called when user types in the textbox
        _this.handleChange = function() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var allArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)allArgs[_i] = arguments[_i];
            var event = allArgs[0];
            if (_this.props.onChangeRaw) {
                _this.props.onChangeRaw.apply(_this, allArgs);
                if (!event || typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) return;
            }
            _this.setState({
                inputValue: (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : null,
                lastPreSelectChange: $393fb8fc0a86de60$var$PRESELECT_CHANGE_VIA_INPUT
            });
            var _j = _this.props, selectsRange = _j.selectsRange, startDate = _j.startDate, endDate = _j.endDate;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var strictParsing = (_b = _this.props.strictParsing) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.strictParsing;
            var value = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : "";
            if (selectsRange) {
                var rangeSeparator = _this.props.rangeSeparator;
                var trimmedRangeSeparator = rangeSeparator.trim();
                var _k = value.split(dateFormat.includes(trimmedRangeSeparator) ? rangeSeparator : trimmedRangeSeparator, 2).map(function(val) {
                    return val.trim();
                }), valueStart = _k[0], valueEnd = _k[1];
                var startDateNew = $393fb8fc0a86de60$var$parseDate(valueStart !== null && valueStart !== void 0 ? valueStart : "", dateFormat, _this.props.locale, strictParsing);
                var endDateNew = startDateNew ? $393fb8fc0a86de60$var$parseDate(valueEnd !== null && valueEnd !== void 0 ? valueEnd : "", dateFormat, _this.props.locale, strictParsing) : null;
                var startChanged = ((_c = $393fb8fc0a86de60$var$safeToDate(startDate)) === null || _c === void 0 ? void 0 : _c.getTime()) !== (startDateNew === null || startDateNew === void 0 ? void 0 : startDateNew.getTime());
                var endChanged = ((_d = $393fb8fc0a86de60$var$safeToDate(endDate)) === null || _d === void 0 ? void 0 : _d.getTime()) !== (endDateNew === null || endDateNew === void 0 ? void 0 : endDateNew.getTime());
                if (!startChanged && !endChanged) return;
                if (startDateNew && $393fb8fc0a86de60$var$isDayDisabled(startDateNew, _this.props)) return;
                if (endDateNew && $393fb8fc0a86de60$var$isDayDisabled(endDateNew, _this.props)) return;
                // Update preSelection to keep calendar viewport consistent when reopening
                // Use startDate for preSelection to match calcInitialState behavior
                if (startDateNew) _this.setState({
                    preSelection: startDateNew
                });
                (_f = (_e = _this.props).onChange) === null || _f === void 0 || _f.call(_e, [
                    startDateNew,
                    endDateNew
                ], event);
            } else {
                // not selectsRange
                var date = $393fb8fc0a86de60$var$parseDate(value, dateFormat, _this.props.locale, strictParsing, (_g = _this.props.selected) !== null && _g !== void 0 ? _g : undefined);
                // Update selection if either (1) date was successfully parsed, or (2) input field is empty
                if (date || !value) _this.setSelected(date, event, true);
                else if (!_this.props.inline) {
                    // If full date parsing failed but we have partial input,
                    // try to extract date info for calendar navigation
                    var navDate = $393fb8fc0a86de60$var$parseDateForNavigation(value, (_h = _this.state.preSelection) !== null && _h !== void 0 ? _h : undefined);
                    // Only update preSelection if navDate is valid and within min/max bounds
                    if (navDate && (!_this.props.minDate || !(0, $0e5980f964c532bb$export$5c007e10c6929c95)(navDate, _this.props.minDate)) && (!_this.props.maxDate || !(0, $63acaba5662d3256$export$e4de839670987035)(navDate, _this.props.maxDate))) _this.setState({
                        preSelection: navDate
                    });
                }
            }
        };
        _this.handleSelect = function(date, event, monthSelectedIn) {
            var _a;
            if (_this.props.readOnly) return;
            var _b = _this.props, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate, locale = _b.locale, swapRange = _b.swapRange;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var isDateSelectionComplete = !selectsRange || startDate && !endDate && (swapRange || !$393fb8fc0a86de60$var$isDateBefore(date, startDate));
            if (_this.props.shouldCloseOnSelect && !_this.props.showTimeSelect && isDateSelectionComplete) // Preventing onFocus event to fix issue
            // https://github.com/Hacker0x01/react-datepicker/issues/628
            _this.sendFocusBackToInput();
            if (_this.props.onChangeRaw) {
                var formattedDate = $393fb8fc0a86de60$var$safeDateFormat(date, {
                    dateFormat: dateFormat,
                    locale: locale
                });
                _this.props.onChangeRaw(event, {
                    date: date,
                    formattedDate: formattedDate
                });
            }
            _this.setSelected(date, event, false, monthSelectedIn);
            if (_this.props.showDateSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) _this.setPreSelection(date);
            else if (isDateSelectionComplete) _this.setOpen(false);
        };
        // setSelected is called either from handleChange (user typed date into textbox and it was parsed) or handleSelect (user selected date from calendar using mouse or keyboard)
        _this.setSelected = function(date, event, keepInput, monthSelectedIn) {
            var _a, _b;
            var timeZone = _this.props.timeZone;
            // If timezone is specified, convert the selected date from zoned time to UTC
            // This ensures the onChange callback receives a proper UTC Date object
            var changedDate = date;
            if (changedDate && timeZone) changedDate = $393fb8fc0a86de60$var$fromZonedTime(changedDate, timeZone);
            // Early return if selected year/month/day is disabled
            if (_this.props.showYearPicker) {
                if (changedDate !== null && $393fb8fc0a86de60$var$isYearDisabled((0, $d5d47ade5ad8c3d9$export$5846dc2d57a5c860)(changedDate), _this.props)) return;
            } else if (_this.props.showMonthYearPicker) {
                if (changedDate !== null && $393fb8fc0a86de60$var$isMonthDisabled(changedDate, _this.props)) return;
            } else {
                if (changedDate !== null && $393fb8fc0a86de60$var$isDayDisabled(changedDate, _this.props)) return;
            }
            var _c = _this.props, onChange = _c.onChange, selectsRange = _c.selectsRange, startDate = _c.startDate, endDate = _c.endDate, selectsMultiple = _c.selectsMultiple, selectedDates = _c.selectedDates, minTime = _c.minTime, swapRange = _c.swapRange;
            if (!$393fb8fc0a86de60$var$isEqual(_this.props.selected, changedDate) || _this.props.allowSameDay || selectsRange || selectsMultiple) {
                if (changedDate !== null) {
                    // Preserve previously selected time if only date is currently being changed
                    if (_this.props.selected && (!keepInput || !_this.props.showTimeSelect && !_this.props.showTimeSelectOnly && !_this.props.showTimeInput)) changedDate = $393fb8fc0a86de60$var$setTime(changedDate, {
                        hour: (0, $75f9879a8962b028$export$257b40f71c07d58f)(_this.props.selected),
                        minute: (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(_this.props.selected),
                        second: (0, $d895bdcba9991f26$export$5e9417507ff28427)(_this.props.selected)
                    });
                    // If minTime is present then set the time to minTime
                    if (!keepInput && (_this.props.showTimeSelect || _this.props.showTimeSelectOnly)) {
                        if (minTime) changedDate = $393fb8fc0a86de60$var$setTime(changedDate, {
                            hour: minTime.getHours(),
                            minute: minTime.getMinutes(),
                            second: minTime.getSeconds()
                        });
                    }
                    if (!_this.props.inline) _this.setState({
                        preSelection: changedDate
                    });
                    if (!_this.props.focusSelectedMonth) _this.setState({
                        monthSelectedIn: monthSelectedIn
                    });
                }
                if (selectsRange) {
                    var onChangeRange = onChange;
                    var noRanges = !startDate && !endDate;
                    var hasStartRange = startDate && !endDate;
                    var hasOnlyEndRange = !startDate && !!endDate;
                    var isRangeFilled = startDate && endDate;
                    if (noRanges) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                        changedDate,
                        null
                    ], event);
                    else if (hasStartRange) {
                        if (changedDate === null) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            null,
                            null
                        ], event);
                        else if ($393fb8fc0a86de60$var$isDateBefore(changedDate, startDate)) {
                            if (swapRange) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                                changedDate,
                                startDate
                            ], event);
                            else onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                                changedDate,
                                null
                            ], event);
                        } else onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            startDate,
                            changedDate
                        ], event);
                    } else if (hasOnlyEndRange) {
                        if (changedDate && $393fb8fc0a86de60$var$isDateBefore(changedDate, endDate)) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            changedDate,
                            endDate
                        ], event);
                        else onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            changedDate,
                            null
                        ], event);
                    }
                    if (isRangeFilled) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                        changedDate,
                        null
                    ], event);
                } else if (selectsMultiple) {
                    var onChangeMultiple = onChange;
                    if (changedDate !== null) {
                        if (!(selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length)) onChangeMultiple === null || onChangeMultiple === void 0 || onChangeMultiple([
                            changedDate
                        ], event);
                        else {
                            var isChangedDateAlreadySelected = selectedDates.some(function(selectedDate) {
                                return $393fb8fc0a86de60$var$isSameDay(selectedDate, changedDate);
                            });
                            if (isChangedDateAlreadySelected) {
                                var nextDates = selectedDates.filter(function(selectedDate) {
                                    return !$393fb8fc0a86de60$var$isSameDay(selectedDate, changedDate);
                                });
                                onChangeMultiple === null || onChangeMultiple === void 0 || onChangeMultiple(nextDates, event);
                            } else onChangeMultiple === null || onChangeMultiple === void 0 || onChangeMultiple($393fb8fc0a86de60$var$__spreadArray($393fb8fc0a86de60$var$__spreadArray([], selectedDates, true), [
                                changedDate
                            ], false), event);
                        }
                    }
                } else onChange === null || onChange === void 0 || onChange(changedDate, event);
            }
            if (!keepInput) {
                (_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, changedDate, event);
                _this.setState({
                    inputValue: null
                });
            }
        };
        // When checking preSelection via min/maxDate, times need to be manipulated via getStartOfDay/getEndOfDay
        _this.setPreSelection = function(date) {
            if (_this.props.readOnly) return;
            var hasMinDate = (0, $3f7a13fe08643584$export$871608497c498473)(_this.props.minDate);
            var hasMaxDate = (0, $3f7a13fe08643584$export$871608497c498473)(_this.props.maxDate);
            var isValidDateSelection = true;
            if (date) {
                var dateStartOfDay = $393fb8fc0a86de60$var$getStartOfDay(date);
                if (hasMinDate && hasMaxDate) // isDayInRange uses getStartOfDay internally, so not necessary to manipulate times here
                isValidDateSelection = $393fb8fc0a86de60$var$isDayInRange(date, _this.props.minDate, _this.props.maxDate);
                else if (hasMinDate) {
                    var minDateStartOfDay = $393fb8fc0a86de60$var$getStartOfDay(_this.props.minDate);
                    isValidDateSelection = (0, $63acaba5662d3256$export$e4de839670987035)(date, minDateStartOfDay) || $393fb8fc0a86de60$var$isEqual(dateStartOfDay, minDateStartOfDay);
                } else if (hasMaxDate) {
                    var maxDateEndOfDay = $393fb8fc0a86de60$var$getEndOfDay(_this.props.maxDate);
                    isValidDateSelection = (0, $0e5980f964c532bb$export$5c007e10c6929c95)(date, maxDateEndOfDay) || $393fb8fc0a86de60$var$isEqual(dateStartOfDay, maxDateEndOfDay);
                }
            }
            if (isValidDateSelection) _this.setState({
                preSelection: date
            });
        };
        _this.toggleCalendar = function() {
            _this.setOpen(!_this.state.open);
        };
        _this.handleTimeChange = function(time, modifyDateType) {
            var _a, _b;
            if (_this.props.selectsMultiple) return;
            var _c = _this.props, selectsRange = _c.selectsRange, startDate = _c.startDate, endDate = _c.endDate, onChange = _c.onChange, timeZone = _c.timeZone;
            if (selectsRange) {
                var onChangeRange = onChange;
                // In range mode, apply time to the appropriate date
                // If modifyDateType is specified, use that to determine which date to modify
                // Otherwise, use the legacy behavior:
                // - If we have a startDate but no endDate, apply time to startDate
                // - If we have both, apply time to endDate
                if (modifyDateType === "start") // Explicitly modify start date
                {
                    if (startDate) {
                        var changedStartDate = $393fb8fc0a86de60$var$setTime(startDate, {
                            hour: (0, $75f9879a8962b028$export$257b40f71c07d58f)(time),
                            minute: (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(time)
                        });
                        _this.setState({
                            preSelection: changedStartDate
                        });
                        // Convert from zoned time to UTC if timezone is specified
                        if (timeZone) changedStartDate = $393fb8fc0a86de60$var$fromZonedTime(changedStartDate, timeZone);
                        onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            changedStartDate,
                            endDate ? timeZone ? $393fb8fc0a86de60$var$fromZonedTime(endDate, timeZone) : endDate : null
                        ], undefined);
                    }
                } else if (modifyDateType === "end") // Explicitly modify end date
                {
                    if (endDate) {
                        var changedEndDate = $393fb8fc0a86de60$var$setTime(endDate, {
                            hour: (0, $75f9879a8962b028$export$257b40f71c07d58f)(time),
                            minute: (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(time)
                        });
                        _this.setState({
                            preSelection: changedEndDate
                        });
                        // Convert from zoned time to UTC if timezone is specified
                        if (timeZone) changedEndDate = $393fb8fc0a86de60$var$fromZonedTime(changedEndDate, timeZone);
                        onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            startDate ? timeZone ? $393fb8fc0a86de60$var$fromZonedTime(startDate, timeZone) : startDate : null,
                            changedEndDate
                        ], undefined);
                    }
                } else {
                    // Legacy behavior for showTimeSelect (single time picker)
                    var hasStartRange = startDate && !endDate;
                    if (hasStartRange) {
                        // Apply time to startDate
                        var changedStartDate = $393fb8fc0a86de60$var$setTime(startDate, {
                            hour: (0, $75f9879a8962b028$export$257b40f71c07d58f)(time),
                            minute: (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(time)
                        });
                        _this.setState({
                            preSelection: changedStartDate
                        });
                        // Convert from zoned time to UTC if timezone is specified
                        if (timeZone) changedStartDate = $393fb8fc0a86de60$var$fromZonedTime(changedStartDate, timeZone);
                        onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            changedStartDate,
                            null
                        ], undefined);
                    } else if (startDate && endDate) {
                        // Apply time to endDate
                        var changedEndDate = $393fb8fc0a86de60$var$setTime(endDate, {
                            hour: (0, $75f9879a8962b028$export$257b40f71c07d58f)(time),
                            minute: (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(time)
                        });
                        _this.setState({
                            preSelection: changedEndDate
                        });
                        // Convert from zoned time to UTC if timezone is specified
                        if (timeZone) changedEndDate = $393fb8fc0a86de60$var$fromZonedTime(changedEndDate, timeZone);
                        onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            timeZone ? $393fb8fc0a86de60$var$fromZonedTime(startDate, timeZone) : startDate,
                            changedEndDate
                        ], undefined);
                    } else {
                        // No dates selected yet, just update preSelection
                        var changedDate = $393fb8fc0a86de60$var$setTime(_this.getPreSelection(), {
                            hour: (0, $75f9879a8962b028$export$257b40f71c07d58f)(time),
                            minute: (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(time)
                        });
                        _this.setState({
                            preSelection: changedDate
                        });
                    }
                }
            } else {
                // Single date mode (original behavior)
                var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
                var changedDate = _this.props.selected ? time : $393fb8fc0a86de60$var$setTime(selected, {
                    hour: (0, $75f9879a8962b028$export$257b40f71c07d58f)(time),
                    minute: (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(time)
                });
                _this.setState({
                    preSelection: changedDate
                });
                // Convert from zoned time to UTC if timezone is specified
                if (changedDate && timeZone) changedDate = $393fb8fc0a86de60$var$fromZonedTime(changedDate, timeZone);
                (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, changedDate);
            }
            if (_this.props.shouldCloseOnSelect && !_this.props.showTimeInput) {
                _this.sendFocusBackToInput();
                _this.setOpen(false);
            }
            if (_this.props.showTimeInput) _this.setOpen(true);
            if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            _this.setState({
                inputValue: null
            });
        };
        _this.onInputClick = function() {
            var _a, _b;
            if (!_this.props.disabled && !_this.props.readOnly) _this.setOpen(true);
            (_b = (_a = _this.props).onInputClick) === null || _b === void 0 || _b.call(_a);
        };
        _this.handleTimeOnlyArrowKey = function(eventKey) {
            var _a, _b, _c, _d;
            var currentTime = $393fb8fc0a86de60$var$safeToDate(_this.props.selected) || _this.state.preSelection || $393fb8fc0a86de60$var$newDate();
            var timeIntervals = (_a = _this.props.timeIntervals) !== null && _a !== void 0 ? _a : 30;
            var dateFormat = (_b = _this.props.dateFormat) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.dateFormat;
            var formatStr = Array.isArray(dateFormat) ? dateFormat[0] : dateFormat;
            var baseDate = $393fb8fc0a86de60$var$getStartOfDay(currentTime);
            var currentMinutes = (0, $75f9879a8962b028$export$257b40f71c07d58f)(currentTime) * 60 + (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(currentTime);
            var maxMinutes = 1440 - timeIntervals; // Cap at last valid interval of the day
            var newTime;
            if (eventKey === $393fb8fc0a86de60$var$KeyType.ArrowUp) {
                var newMinutes = Math.max(0, currentMinutes - timeIntervals);
                newTime = (0, $396b693e3529a905$export$2287e3d29250119e)(baseDate, newMinutes);
            } else {
                var newMinutes = Math.min(maxMinutes, currentMinutes + timeIntervals);
                newTime = (0, $396b693e3529a905$export$2287e3d29250119e)(baseDate, newMinutes);
            }
            var formattedTime = $393fb8fc0a86de60$var$formatDate(newTime, formatStr || DatePicker.defaultProps.dateFormat, _this.props.locale);
            _this.setState({
                preSelection: newTime,
                inputValue: formattedTime
            });
            if (_this.props.selectsRange || _this.props.selectsMultiple) return;
            var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
            var changedDate = _this.props.selected ? newTime : $393fb8fc0a86de60$var$setTime(selected, {
                hour: (0, $75f9879a8962b028$export$257b40f71c07d58f)(newTime),
                minute: (0, $d7a0487caac9cc4b$export$b7f1bc3ea3ac4145)(newTime)
            });
            (_d = (_c = _this.props).onChange) === null || _d === void 0 || _d.call(_c, changedDate);
            if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            requestAnimationFrame(function() {
                _this.scrollToTimeOption(newTime);
            });
        };
        _this.handleTimeOnlyEnterKey = function(event) {
            var _a, _b, _c, _d;
            var inputElement = event.target;
            var inputValue = inputElement.value;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var timeFormat = _this.props.timeFormat || "p";
            var defaultTime = _this.state.preSelection || $393fb8fc0a86de60$var$safeToDate(_this.props.selected) || $393fb8fc0a86de60$var$newDate();
            var parsedDate = $393fb8fc0a86de60$var$parseDate(inputValue, dateFormat, _this.props.locale, (_b = _this.props.strictParsing) !== null && _b !== void 0 ? _b : false, defaultTime);
            var timeToCommit = defaultTime;
            if (parsedDate && $393fb8fc0a86de60$var$isValid(parsedDate)) timeToCommit = parsedDate;
            else {
                var highlightedItem = ((_c = _this.calendar) === null || _c === void 0 ? void 0 : _c.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(".react-datepicker__time-list-item[tabindex='0']");
                if (highlightedItem instanceof HTMLElement) {
                    var itemText = (_d = highlightedItem.textContent) === null || _d === void 0 ? void 0 : _d.trim();
                    if (itemText) {
                        var itemTime = $393fb8fc0a86de60$var$parseDate(itemText, timeFormat, _this.props.locale, false, defaultTime);
                        if (itemTime && $393fb8fc0a86de60$var$isValid(itemTime)) timeToCommit = itemTime;
                    }
                }
            }
            _this.handleTimeChange(timeToCommit);
            _this.setOpen(false);
            _this.sendFocusBackToInput();
        };
        _this.scrollToTimeOption = function(time) {
            var _a, _b;
            if (!((_a = _this.calendar) === null || _a === void 0 ? void 0 : _a.containerRef.current)) return;
            var container = _this.calendar.containerRef.current;
            var timeListItems = Array.from(container.querySelectorAll(".react-datepicker__time-list-item"));
            var targetItem = null;
            var closestTimeDiff = Infinity;
            var timeFormat = _this.props.timeFormat || "p";
            for(var _i = 0, timeListItems_1 = timeListItems; _i < timeListItems_1.length; _i++){
                var item = timeListItems_1[_i];
                var itemText = (_b = item.textContent) === null || _b === void 0 ? void 0 : _b.trim();
                if (itemText) {
                    var itemTime = $393fb8fc0a86de60$var$parseDate(itemText, timeFormat, _this.props.locale, false, time);
                    if (itemTime && $393fb8fc0a86de60$var$isValid(itemTime)) {
                        if ($393fb8fc0a86de60$var$isSameMinute(itemTime, time)) {
                            targetItem = item;
                            break;
                        }
                        var timeDiff = Math.abs(itemTime.getTime() - time.getTime());
                        if (timeDiff < closestTimeDiff) {
                            closestTimeDiff = timeDiff;
                            targetItem = item;
                        }
                    }
                }
            }
            if (targetItem) {
                timeListItems.forEach(function(item) {
                    item.setAttribute("tabindex", "-1");
                });
                targetItem.setAttribute("tabindex", "0");
                targetItem.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
        };
        _this.onInputKeyDown = function(event) {
            var _a, _b, _c, _d, _e, _f;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
            var eventKey = event.key;
            if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
                if (eventKey === $393fb8fc0a86de60$var$KeyType.ArrowDown || eventKey === $393fb8fc0a86de60$var$KeyType.ArrowUp || eventKey === $393fb8fc0a86de60$var$KeyType.Enter) (_c = _this.onInputClick) === null || _c === void 0 || _c.call(_this);
                return;
            }
            if (_this.state.open && _this.props.showTimeSelectOnly) {
                if (eventKey === $393fb8fc0a86de60$var$KeyType.ArrowDown || eventKey === $393fb8fc0a86de60$var$KeyType.ArrowUp) {
                    event.preventDefault();
                    _this.handleTimeOnlyArrowKey(eventKey);
                    return;
                }
                if (eventKey === $393fb8fc0a86de60$var$KeyType.Enter) {
                    event.preventDefault();
                    _this.handleTimeOnlyEnterKey(event);
                    return;
                }
            }
            // if calendar is open, these keys will focus the selected item
            if (_this.state.open) {
                if (eventKey === $393fb8fc0a86de60$var$KeyType.ArrowDown || eventKey === $393fb8fc0a86de60$var$KeyType.ArrowUp) {
                    event.preventDefault();
                    var selectorString = _this.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : _this.props.showWeekPicker && _this.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : _this.props.showFullMonthYearPicker || _this.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]';
                    var selectedItem = ((_d = _this.calendar) === null || _d === void 0 ? void 0 : _d.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(selectorString);
                    selectedItem instanceof HTMLElement && selectedItem.focus({
                        preventScroll: true
                    });
                    return;
                }
                var copy = $393fb8fc0a86de60$var$newDate(_this.state.preSelection);
                if (eventKey === $393fb8fc0a86de60$var$KeyType.Enter) {
                    event.preventDefault();
                    event.target.blur();
                    if (_this.inputOk() && _this.state.lastPreSelectChange === $393fb8fc0a86de60$var$PRESELECT_CHANGE_VIA_NAVIGATE) {
                        _this.handleSelect(copy, event);
                        !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
                    } else _this.setOpen(false);
                } else if (eventKey === $393fb8fc0a86de60$var$KeyType.Escape) {
                    event.preventDefault();
                    event.target.blur();
                    _this.sendFocusBackToInput();
                    _this.setOpen(false);
                } else if (eventKey === $393fb8fc0a86de60$var$KeyType.Tab) _this.setOpen(false);
                if (!_this.inputOk()) (_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
                    code: 1,
                    msg: $393fb8fc0a86de60$var$INPUT_ERR_1
                });
            }
        };
        _this.onPortalKeyDown = function(event) {
            var eventKey = event.key;
            if (eventKey === $393fb8fc0a86de60$var$KeyType.Escape) {
                event.preventDefault();
                _this.setState({
                    preventFocus: true
                }, function() {
                    _this.setOpen(false);
                    setTimeout(function() {
                        _this.setFocus();
                        _this.setState({
                            preventFocus: false
                        });
                    });
                });
            }
        };
        // keyDown events passed down to day.jsx
        _this.onDayKeyDown = function(event) {
            var _a, _b, _c, _d, _e, _f;
            var _g = _this.props, minDate = _g.minDate, maxDate = _g.maxDate, disabledKeyboardNavigation = _g.disabledKeyboardNavigation, showWeekPicker = _g.showWeekPicker, shouldCloseOnSelect = _g.shouldCloseOnSelect, locale = _g.locale, calendarStartDay = _g.calendarStartDay, adjustDateOnChange = _g.adjustDateOnChange, inline = _g.inline;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
            if (disabledKeyboardNavigation) return;
            var eventKey = event.key;
            var isShiftKeyActive = event.shiftKey;
            var copy = $393fb8fc0a86de60$var$newDate(_this.state.preSelection);
            var calculateNewDate = function calculateNewDate(eventKey, date) {
                var newCalculatedDate = date;
                switch(eventKey){
                    case $393fb8fc0a86de60$var$KeyType.ArrowRight:
                        newCalculatedDate = showWeekPicker ? (0, $a4bc19e29e9eb67e$export$ef501a2bb4f3ee6b)(date, 1) : (0, $2b4ff6e56ae3ad17$export$dd412b56f1e4d8aa)(date, 1);
                        break;
                    case $393fb8fc0a86de60$var$KeyType.ArrowLeft:
                        newCalculatedDate = showWeekPicker ? (0, $2d52663a687b6327$export$b4d8ae6376193efb)(date, 1) : (0, $1d5ee141051d4eef$export$70823084e2deb1ea)(date, 1);
                        break;
                    case $393fb8fc0a86de60$var$KeyType.ArrowUp:
                        newCalculatedDate = (0, $2d52663a687b6327$export$b4d8ae6376193efb)(date, 1);
                        break;
                    case $393fb8fc0a86de60$var$KeyType.ArrowDown:
                        newCalculatedDate = (0, $a4bc19e29e9eb67e$export$ef501a2bb4f3ee6b)(date, 1);
                        break;
                    case $393fb8fc0a86de60$var$KeyType.PageUp:
                        newCalculatedDate = isShiftKeyActive ? (0, $03aa6c2df8a28792$export$14867687ff6c92e2)(date, 1) : (0, $62367543e39b34d6$export$73d1c15a21f9fae5)(date, 1);
                        break;
                    case $393fb8fc0a86de60$var$KeyType.PageDown:
                        newCalculatedDate = isShiftKeyActive ? (0, $5c6b1b4dffb22d4b$export$3d83eec43f4ea476)(date, 1) : (0, $75507be8d602cbce$export$17c93e242b2d3a22)(date, 1);
                        break;
                    case $393fb8fc0a86de60$var$KeyType.Home:
                        newCalculatedDate = $393fb8fc0a86de60$var$getStartOfWeek(date, locale, calendarStartDay);
                        break;
                    case $393fb8fc0a86de60$var$KeyType.End:
                        newCalculatedDate = $393fb8fc0a86de60$var$getEndOfWeek(date);
                        break;
                }
                return newCalculatedDate;
            };
            var getNewDate = function getNewDate(eventKey, date) {
                var MAX_ITERATIONS = 40;
                var eventKeyCopy = eventKey;
                var validDateFound = false;
                var iterations = 0;
                var newSelection = calculateNewDate(eventKey, date);
                while(!validDateFound){
                    if (iterations >= MAX_ITERATIONS) {
                        newSelection = date;
                        break;
                    }
                    // if minDate exists and the new selection is before the min date, get the nearest date that isn't disabled
                    if (minDate && newSelection < minDate) {
                        eventKeyCopy = $393fb8fc0a86de60$var$KeyType.ArrowRight;
                        newSelection = $393fb8fc0a86de60$var$isDayDisabled(minDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : minDate;
                    }
                    // if maxDate exists and the new selection is after the max date, get the nearest date that isn't disabled
                    if (maxDate && newSelection > maxDate) {
                        eventKeyCopy = $393fb8fc0a86de60$var$KeyType.ArrowLeft;
                        newSelection = $393fb8fc0a86de60$var$isDayDisabled(maxDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : maxDate;
                    }
                    if ($393fb8fc0a86de60$var$isDayDisabled(newSelection, _this.props)) {
                        // if PageUp and Home is pressed to a disabled date, it will try to find the next available date after
                        if (eventKeyCopy === $393fb8fc0a86de60$var$KeyType.PageUp || eventKeyCopy === $393fb8fc0a86de60$var$KeyType.Home) eventKeyCopy = $393fb8fc0a86de60$var$KeyType.ArrowRight;
                        // if PageDown and End is pressed to a disabled date, it will try to find the next available date before
                        if (eventKeyCopy === $393fb8fc0a86de60$var$KeyType.PageDown || eventKeyCopy === $393fb8fc0a86de60$var$KeyType.End) eventKeyCopy = $393fb8fc0a86de60$var$KeyType.ArrowLeft;
                        newSelection = calculateNewDate(eventKeyCopy, newSelection);
                    } else validDateFound = true;
                    iterations++;
                }
                return newSelection;
            };
            if (eventKey === $393fb8fc0a86de60$var$KeyType.Enter) {
                event.preventDefault();
                _this.handleSelect(copy, event);
                !shouldCloseOnSelect && _this.setPreSelection(copy);
                return;
            } else if (eventKey === $393fb8fc0a86de60$var$KeyType.Escape) {
                event.preventDefault();
                _this.setOpen(false);
                if (!_this.inputOk()) (_d = (_c = _this.props).onInputError) === null || _d === void 0 || _d.call(_c, {
                    code: 1,
                    msg: $393fb8fc0a86de60$var$INPUT_ERR_1
                });
                return;
            }
            var newSelection = null;
            switch(eventKey){
                case $393fb8fc0a86de60$var$KeyType.ArrowLeft:
                case $393fb8fc0a86de60$var$KeyType.ArrowRight:
                case $393fb8fc0a86de60$var$KeyType.ArrowUp:
                case $393fb8fc0a86de60$var$KeyType.ArrowDown:
                case $393fb8fc0a86de60$var$KeyType.PageUp:
                case $393fb8fc0a86de60$var$KeyType.PageDown:
                case $393fb8fc0a86de60$var$KeyType.Home:
                case $393fb8fc0a86de60$var$KeyType.End:
                    newSelection = getNewDate(eventKey, copy);
                    break;
            }
            if (!newSelection) {
                (_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
                    code: 1,
                    msg: $393fb8fc0a86de60$var$INPUT_ERR_1
                });
                return;
            }
            event.preventDefault();
            _this.setState({
                lastPreSelectChange: $393fb8fc0a86de60$var$PRESELECT_CHANGE_VIA_NAVIGATE
            });
            if (adjustDateOnChange) _this.setSelected(newSelection);
            _this.setPreSelection(newSelection);
            // In inline mode, always set shouldFocusDayInline to true when navigating via keyboard.
            // This ensures focus is properly transferred to the new day element regardless of
            // whether the month changed. The user initiated this navigation from a focused day,
            // so we should always focus the destination day.
            if (inline) _this.setState({
                shouldFocusDayInline: true
            });
        };
        // handle generic key down events in the popper that do not adjust or select dates
        // ex: while focusing prev and next month buttons
        _this.onPopperKeyDown = function(event) {
            var eventKey = event.key;
            if (eventKey === $393fb8fc0a86de60$var$KeyType.Escape) {
                event.preventDefault();
                _this.sendFocusBackToInput();
                _this.setOpen(false);
            }
        };
        _this.onClearClick = function(event) {
            if (event) {
                if (event.preventDefault) event.preventDefault();
            }
            _this.sendFocusBackToInput();
            var _a = _this.props, selectsRange = _a.selectsRange, onChange = _a.onChange;
            if (selectsRange) onChange === null || onChange === void 0 || onChange([
                null,
                null
            ], event);
            else onChange === null || onChange === void 0 || onChange(null, event);
            _this.setState({
                inputValue: null
            });
        };
        _this.clear = function() {
            _this.onClearClick();
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeOnScroll === "boolean" && _this.props.closeOnScroll) {
                if (event.target === document || event.target === document.documentElement || event.target === document.body) _this.setOpen(false);
            } else if (typeof _this.props.closeOnScroll === "function") {
                if (_this.props.closeOnScroll(event)) _this.setOpen(false);
            }
        };
        _this.handleMonthSelectedInChange = function(monthSelectedIn) {
            _this.setState({
                monthSelectedIn: monthSelectedIn
            });
        };
        _this.renderCalendar = function() {
            var _a, _b;
            if (!_this.props.inline && !_this.isCalendarOpen()) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$Calendar, $393fb8fc0a86de60$var$_assign({
                showMonthYearDropdown: undefined,
                ref: function ref(elem) {
                    _this.calendar = elem;
                }
            }, _this.props, _this.state, {
                setOpen: _this.setOpen,
                dateFormat: (_a = _this.props.dateFormatCalendar) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormatCalendar,
                onSelect: _this.handleSelect,
                onClickOutside: _this.handleCalendarClickOutside,
                holidays: $393fb8fc0a86de60$var$getHolidaysMap(_this.modifyHolidays()),
                outsideClickIgnoreClass: _this.props.outsideClickIgnoreClass,
                onDropdownFocus: _this.handleDropdownFocus,
                onTimeChange: _this.handleTimeChange,
                className: _this.props.calendarClassName,
                container: _this.props.calendarContainer,
                handleOnKeyDown: _this.props.onKeyDown,
                handleOnDayKeyDown: _this.onDayKeyDown,
                setPreSelection: _this.setPreSelection,
                dropdownMode: (_b = _this.props.dropdownMode) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.dropdownMode,
                onMonthSelectedInChange: _this.handleMonthSelectedInChange
            }), _this.props.children);
        };
        _this.renderAriaLiveRegion = function() {
            var _a;
            var locale = _this.props.locale;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var isContainsTime = _this.props.showTimeInput || _this.props.showTimeSelect;
            var longDateFormat = isContainsTime ? "PPPPp" : "PPPP";
            var ariaLiveMessage;
            if (_this.props.selectsRange) ariaLiveMessage = "Selected start date: ".concat($393fb8fc0a86de60$var$safeDateFormat(_this.props.startDate, {
                dateFormat: longDateFormat,
                locale: locale
            }), ". ").concat(_this.props.endDate ? "End date: " + $393fb8fc0a86de60$var$safeDateFormat(_this.props.endDate, {
                dateFormat: longDateFormat,
                locale: locale
            }) : "");
            else {
                if (_this.props.showTimeSelectOnly) ariaLiveMessage = "Selected time: ".concat($393fb8fc0a86de60$var$safeDateFormat(_this.props.selected, {
                    dateFormat: dateFormat,
                    locale: locale
                }));
                else if (_this.props.showYearPicker) ariaLiveMessage = "Selected year: ".concat($393fb8fc0a86de60$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "yyyy",
                    locale: locale
                }));
                else if (_this.props.showMonthYearPicker) ariaLiveMessage = "Selected month: ".concat($393fb8fc0a86de60$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: locale
                }));
                else if (_this.props.showQuarterYearPicker) ariaLiveMessage = "Selected quarter: ".concat($393fb8fc0a86de60$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: locale
                }));
                else ariaLiveMessage = "Selected date: ".concat($393fb8fc0a86de60$var$safeDateFormat(_this.props.selected, {
                    dateFormat: longDateFormat,
                    locale: locale
                }));
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, ariaLiveMessage);
        };
        _this.renderDateInput = function() {
            var _a, _b;
            var _c, _d, _e, _f, _g;
            var className = (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)(_this.props.className, (_a = {}, _a[_this.props.outsideClickIgnoreClass || DatePicker.defaultProps.outsideClickIgnoreClass] = _this.state.open, _a));
            var customInput = _this.props.customInput || (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("input", {
                type: "text"
            });
            var customInputRef = _this.props.customInputRef || "ref";
            // Build aria props object, only including defined values to avoid
            // overwriting aria attributes that may be set on the custom input
            var ariaProps = {};
            var ariaDescribedBy = (_c = _this.props["aria-describedby"]) !== null && _c !== void 0 ? _c : _this.props.ariaDescribedBy;
            var ariaInvalid = (_d = _this.props["aria-invalid"]) !== null && _d !== void 0 ? _d : _this.props.ariaInvalid;
            var ariaLabel = (_e = _this.props["aria-label"]) !== null && _e !== void 0 ? _e : _this.props.ariaLabel;
            var ariaLabelledBy = (_f = _this.props["aria-labelledby"]) !== null && _f !== void 0 ? _f : _this.props.ariaLabelledBy;
            var ariaRequired = (_g = _this.props["aria-required"]) !== null && _g !== void 0 ? _g : _this.props.ariaRequired;
            if (ariaDescribedBy != null) ariaProps["aria-describedby"] = ariaDescribedBy;
            if (ariaInvalid != null) ariaProps["aria-invalid"] = ariaInvalid;
            if (ariaLabel != null) ariaProps["aria-label"] = ariaLabel;
            if (ariaLabelledBy != null) ariaProps["aria-labelledby"] = ariaLabelledBy;
            if (ariaRequired != null) ariaProps["aria-required"] = ariaRequired;
            return (0, $5s1kH.cloneElement)(customInput, $393fb8fc0a86de60$var$_assign((_b = {}, _b[customInputRef] = function(input) {
                _this.input = input;
            }, _b.value = _this.getInputValue(), _b.onBlur = _this.handleBlur, _b.onChange = _this.handleChange, _b.onClick = _this.onInputClick, _b.onFocus = _this.handleFocus, _b.onKeyDown = _this.onInputKeyDown, _b.id = _this.props.id, _b.name = _this.props.name, _b.form = _this.props.form, _b.autoFocus = _this.props.autoFocus, _b.placeholder = _this.props.placeholderText, _b.disabled = _this.props.disabled, _b.autoComplete = _this.props.autoComplete, _b.className = (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)(customInput.props.className, className), _b.title = _this.props.title, _b.readOnly = _this.props.readOnly, _b.required = _this.props.required, _b.tabIndex = _this.props.tabIndex, _b), ariaProps));
        };
        _this.renderClearButton = function() {
            var _a = _this.props, isClearable = _a.isClearable, disabled = _a.disabled, selected = _a.selected, startDate = _a.startDate, endDate = _a.endDate, clearButtonTitle = _a.clearButtonTitle, _b = _a.clearButtonClassName, clearButtonClassName = _b === void 0 ? "" : _b, _c = _a.ariaLabelClose, ariaLabelClose = _c === void 0 ? "Close" : _c, selectedDates = _a.selectedDates, readOnly = _a.readOnly;
            if (isClearable && !readOnly && (selected != null || startDate != null || endDate != null || (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length))) return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("button", {
                type: "button",
                className: (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)("react-datepicker__close-icon", clearButtonClassName, {
                    "react-datepicker__close-icon--disabled": disabled
                }),
                disabled: disabled,
                "aria-label": ariaLabelClose,
                onClick: _this.onClearClick,
                title: clearButtonTitle,
                tabIndex: -1
            });
            else return null;
        };
        _this.state = _this.calcInitialState();
        _this.preventFocusTimeout = undefined;
        return _this;
    }
    Object.defineProperty(DatePicker, "defaultProps", {
        get: function get() {
            return {
                allowSameDay: false,
                dateFormat: "MM/dd/yyyy",
                dateFormatCalendar: "LLLL yyyy",
                disabled: false,
                disabledKeyboardNavigation: false,
                dropdownMode: "scroll",
                preventOpenOnFocus: false,
                monthsShown: 1,
                outsideClickIgnoreClass: $393fb8fc0a86de60$var$OUTSIDE_CLICK_IGNORE_CLASS,
                readOnly: false,
                rangeSeparator: $393fb8fc0a86de60$var$DATE_RANGE_SEPARATOR,
                withPortal: false,
                selectsDisabledDaysInRange: false,
                shouldCloseOnSelect: true,
                showTimeSelect: false,
                showTimeInput: false,
                showPreviousMonths: false,
                showMonthYearPicker: false,
                showFullMonthYearPicker: false,
                showTwoColumnMonthYearPicker: false,
                showFourColumnMonthYearPicker: false,
                showYearPicker: false,
                showQuarterYearPicker: false,
                showWeekPicker: false,
                strictParsing: false,
                swapRange: false,
                timeIntervals: 30,
                timeCaption: "Time",
                previousMonthAriaLabel: "Previous Month",
                previousMonthButtonLabel: "Previous Month",
                nextMonthAriaLabel: "Next Month",
                nextMonthButtonLabel: "Next Month",
                previousYearAriaLabel: "Previous Year",
                previousYearButtonLabel: "Previous Year",
                nextYearAriaLabel: "Next Year",
                nextYearButtonLabel: "Next Year",
                timeInputLabel: "Time",
                enableTabLoop: true,
                yearItemNumber: $393fb8fc0a86de60$var$DEFAULT_YEAR_ITEM_NUMBER,
                focusSelectedMonth: false,
                showPopperArrow: true,
                excludeScrollbar: true,
                customTimeInput: null,
                calendarStartDay: undefined,
                toggleCalendarOnIconClick: false,
                usePointerEvent: false
            };
        },
        enumerable: false,
        configurable: true
    });
    DatePicker.prototype.componentDidMount = function() {
        window.addEventListener("scroll", this.onScroll, true);
        document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b, _c, _d;
        // Update preSelection when selected/startDate prop changes to a different month/year.
        // This ensures the calendar view updates when dates are programmatically set
        // (e.g., via "Today" or "This Week" buttons). (Fix for #3367)
        if (this.props.selectsRange && $393fb8fc0a86de60$var$hasPreSelectionChanged(prevProps.startDate, this.props.startDate)) this.setPreSelection(this.props.startDate);
        else if ($393fb8fc0a86de60$var$hasPreSelectionChanged(prevProps.selected, this.props.selected)) this.setPreSelection(this.props.selected);
        if (this.state.monthSelectedIn !== undefined && prevProps.monthsShown !== this.props.monthsShown) this.setState({
            monthSelectedIn: 0
        });
        // Reset monthSelectedIn when calendar opens for range selection
        // This ensures startDate is displayed as the first month when reopening
        // (Fix for #5939), but we don't reset during active selection to avoid
        // the view jumping when clicking dates in the second calendar (Fix for #5275)
        if (this.props.selectsRange && prevState.open === false && this.state.open === true && this.state.monthSelectedIn !== 0) this.setState({
            monthSelectedIn: 0
        });
        if (prevProps.highlightDates !== this.props.highlightDates) this.setState({
            highlightDates: $393fb8fc0a86de60$var$getHighLightDaysMap(this.props.highlightDates)
        });
        if (!prevState.focused && !$393fb8fc0a86de60$var$isEqual(prevProps.selected, this.props.selected)) this.setState({
            inputValue: null
        });
        if (prevState.open !== this.state.open) {
            if (prevState.open === false && this.state.open === true) (_b = (_a = this.props).onCalendarOpen) === null || _b === void 0 || _b.call(_a);
            if (prevState.open === true && this.state.open === false) (_d = (_c = this.props).onCalendarClose) === null || _d === void 0 || _d.call(_c);
        }
    };
    DatePicker.prototype.componentWillUnmount = function() {
        this.clearPreventFocusTimeout();
        window.removeEventListener("scroll", this.onScroll, true);
        document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker.prototype.renderInputContainer = function() {
        var _a = this.props, showIcon = _a.showIcon, icon = _a.icon, calendarIconClassname = _a.calendarIconClassname, calendarIconClassName = _a.calendarIconClassName, toggleCalendarOnIconClick = _a.toggleCalendarOnIconClick;
        var open = this.state.open;
        if (calendarIconClassname) console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props.");
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
            className: "react-datepicker__input-container".concat(showIcon ? " react-datepicker__view-calendar-icon" : "")
        }, showIcon && (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$CalendarIcon, $393fb8fc0a86de60$var$_assign({
            icon: icon,
            className: (0, $2f0a3b5636e7a66d$export$4f5d2d50c9deca37)(calendarIconClassName, !calendarIconClassName && calendarIconClassname, open && "react-datepicker-ignore-onclickoutside")
        }, toggleCalendarOnIconClick ? {
            onClick: this.toggleCalendar
        } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
    };
    DatePicker.prototype.render = function() {
        var calendar = this.renderCalendar();
        if (this.props.inline) return calendar;
        if (this.props.withPortal) {
            var portalContainer = this.state.open ? (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$TabLoop, {
                enableTabLoop: this.props.enableTabLoop
            }, (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement("div", {
                className: "react-datepicker__portal",
                tabIndex: -1,
                onKeyDown: this.onPortalKeyDown
            }, calendar)) : null;
            if (this.state.open && this.props.portalId) portalContainer = (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$Portal, $393fb8fc0a86de60$var$_assign({
                portalId: this.props.portalId
            }, this.props), portalContainer);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).Fragment, null, this.renderInputContainer(), portalContainer);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).createElement($393fb8fc0a86de60$var$PopperComponent, $393fb8fc0a86de60$var$_assign({}, this.props, {
            className: this.props.popperClassName,
            hidePopper: !this.isCalendarOpen(),
            targetComponent: this.renderInputContainer(),
            popperComponent: calendar,
            popperOnKeyDown: this.onPopperKeyDown,
            showArrow: this.props.showPopperArrow,
            monthHeaderPosition: this.props.monthHeaderPosition
        }));
    };
    return DatePicker;
}((0, $5s1kH.Component));
var $393fb8fc0a86de60$var$PRESELECT_CHANGE_VIA_INPUT = "input";
var $393fb8fc0a86de60$var$PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";





var $e2435b6138b3d161$var$StreamEnum = /*#__PURE__*/ function(StreamEnum) {
    StreamEnum[StreamEnum["WAITING"] = 0] = "WAITING";
    StreamEnum[StreamEnum["THINKING"] = 1] = "THINKING";
    StreamEnum[StreamEnum["DONE"] = 2] = "DONE";
    return StreamEnum;
}($e2435b6138b3d161$var$StreamEnum || {});
var $e2435b6138b3d161$var$modelType = /*#__PURE__*/ function(modelType) {
    modelType["SUBGOAL"] = "goal";
    modelType["ACTIVITY"] = "activity";
    modelType["BEHAVIOR"] = "behavior";
    modelType["LONGTERMGOAL"] = "vision_statement";
    return modelType;
}($e2435b6138b3d161$var$modelType || {});
var $e2435b6138b3d161$var$LongTermGoalPart = function(props) {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var chatWindowRef = (0, $5s1kH.useRef)(null);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showDetails = _useState[0], setShowDetails = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(props.editPart.title), 2), title = _useState1[0], setTitle = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(props.editPart.ifWhen ? props.editPart.ifWhen : ""), 2), ifWhen = _useState2[0], setIfWhen = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(props.editPart.ifThen ? props.editPart.ifThen : ""), 2), ifThen = _useState3[0], setIfThen = _useState3[1];
    var _props_editPart_howOften;
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)((_props_editPart_howOften = props.editPart.howOften) !== null && _props_editPart_howOften !== void 0 ? _props_editPart_howOften : 1), 2), howOften = _useState4[0], setHowOften = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(props.editPart.barrier ? props.editPart.barrier : ""), 2), barrier = _useState5[0], setBarrier = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(props.editPart.description), 2), description = _useState6[0], setDescription = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(props.editPart.deadline ? new Date(props.editPart.deadline) : null), 2), deadline = _useState7[0], setDeadline = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), messages = _useState8[0], setMessages = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(window.innerWidth < 1100), 2), narrow = _useState9[0], setNarrow = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)("ai"), 2), selectedView = _useState10[0], setSelectedView = _useState10[1];
    var _useState11 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), prompt = _useState11[0], setPrompt = _useState11[1];
    var _useState12 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), questions = _useState12[0], setQuestions = _useState12[1];
    var _useState13 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), emmaThinking = _useState13[0], setEmmaThinking = _useState13[1];
    var _useState14 = (0, $6iP9u._)((0, $5s1kH.useState)("assistant"), 2), coachStyle = _useState14[0], setCoachStyle = _useState14[1];
    var _useState15 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), streamStatus = _useState15[0], setStreamStatus = _useState15[1];
    var _useState16 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), suggestions = _useState16[0], setSuggestions = _useState16[1];
    var _useState17 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), closeNoSave = _useState17[0], setCloseNoSave = _useState17[1];
    var setGlobalToast = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$12972e612ad7cf0));
    var _useState18 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), feedbackInfoModel = _useState18[0], setFeedbackInfoModel = _useState18[1];
    var _useState19 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showfeedbackInfoModel = _useState19[0], setShowFeedbackInfoModel = _useState19[1];
    var _useState20 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), selectedRangeOption = _useState20[0], setSelectedRangeOption = _useState20[1];
    var makeOptions = function(values, unit) {
        return values.map(function(value) {
            return {
                value: value,
                unit: unit
            };
        });
    };
    var _obj;
    // OPTIONS_BY_TYPE: Determine which range to pass to the date badge.
    var OPTIONS_BY_TYPE = (_obj = {}, (0, $dUlz9._)(_obj, "activity", makeOptions([
        2,
        4,
        6,
        8
    ], 'week')), (0, $dUlz9._)(_obj, "behavior", makeOptions([
        2,
        4,
        6,
        8
    ], 'week')), (0, $dUlz9._)(_obj, "goal", makeOptions([
        1,
        2
    ], 'month')), (0, $dUlz9._)(_obj, "vision_statement", makeOptions([
        3,
        6,
        12
    ], 'month')), _obj);
    var HOW_OFTEN_OPTIONS = [
        {
            value: 0,
            sv: "Varje dag",
            en: "Every day"
        },
        {
            value: 1,
            sv: "Flera g\xe5nger per vecka",
            en: "Several times a week"
        },
        {
            value: 2,
            sv: "En g\xe5ng per vecka",
            en: "Once a week"
        }
    ];
    var onResize = function() {
        setNarrow(window.innerWidth < 1100);
    };
    var isValid = function() {
        if (props.editPart.type === "behavior") {
            if (ifWhen.length === 0 || ifThen.length === 0 || title.length === 0 || !deadline) return false;
        } else {
            if (description.length === 0 || title.length === 0 || !deadline) return false;
        }
        return true;
    };
    var getFirstCompletedSurveyRequest = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = props.visionStatement.surveyRequests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var sr = _step.value;
                if (sr.completed) return sr;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    (0, $5s1kH.useEffect)(function() {
        window.addEventListener('resize', onResize);
        if (props.visionStatement.surveyRequests.length > 0) {
            var firstSurveyRequest = getFirstCompletedSurveyRequest();
            if (firstSurveyRequest) {
                var _questions = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = firstSurveyRequest.surveyResult.focusAreas[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var focusArea = _step.value;
                        try {
                            for(var _iterator1 = focusArea.questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var question = _step1.value;
                                question.focusAreaName = focusArea.name;
                                _questions.push(question);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                setQuestions(_questions);
                setShowFeedbackInfoModel(true);
            }
        }
        var editMessage = props.editPart.deadline && props.editPart.deadline.length > 0;
        var startMessage = lang === "sv" ? "Hej" : "Hi";
        if (props.clientName.length > 0) startMessage += " " + props.clientName;
        if (editMessage) {
            if (props.editPart.type === "vision_statement") {
                if (lang === "sv") {
                    startMessage += "! Vad vill du \xe4ndra eller f\xf6rtydliga med din m\xe5lbild? Ber\xe4tta s\xe5 hj\xe4lper jag dig vidare.";
                    setSuggestions([
                        "Hj\xe4lp mig g\xf6ra denna m\xe5lbild mer personlig",
                        "Hj\xe4lp mig g\xf6ra denna m\xe5lbild mer motiverande",
                        "Hj\xe4lp mig justera denna m\xe5lbild s\xe5 att den b\xe4ttre matchar mina prioriteringar"
                    ]);
                } else {
                    startMessage += ", how can I help you edit your Goal?";
                    setSuggestions([
                        "Help me make this Goal more personal",
                        "Help me make this Goal more motivating",
                        "Help me adjust this Goal, so it matches my priorities better"
                    ]);
                }
            } else if (props.editPart.type === "goal") {
                if (lang === "sv") startMessage += "! Vad vill du \xe4ndra eller f\xf6rtydliga med ditt delm\xe5l? Ber\xe4tta s\xe5 hj\xe4lper jag dig vidare.";
                else startMessage += ", how can I help you edit your Sub-goal?";
            } else if (lang === "sv") startMessage += "! Vad vill du \xe4ndra eller f\xf6rtydliga? Jag guidar dig g\xe4rna.";
            else startMessage += "! What would you like to change or clarify? I\u2019m happy to guide you.";
        } else {
            if (props.editPart.type === "vision_statement") {
                if (lang === "sv") {
                    if (props.editPart.title.length > 0) {
                        startMessage += ", jag \xe4r h\xe4r f\xf6r att hj\xe4lpa dig skapa en tydlig och motiverande m\xe5lbild.  \n  \nVill du att jag f\xf6resl\xe5r ett utifr\xe5n ditt utkast, eller vill du hellre reflektera \xf6ver vad som \xe4r viktigast f\xf6r dig f\xf6rst?";
                        setSuggestions([
                            "Hj\xe4lp mig reflektera \xf6ver vad som \xe4r viktigast",
                            "F\xf6resl\xe5 utifr\xe5n mitt utkast",
                            "Visa mig hur en bra m\xe5lbild kan se ut"
                        ]);
                    } else {
                        startMessage += ", jag \xe4r h\xe4r f\xf6r att hj\xe4lpa dig skapa en tydlig och motiverande m\xe5lbild.  \n  \nHar du n\xe5gon id\xe9 om hur du vill starta, eller vill du hellre reflektera \xf6ver vad som \xe4r viktigast f\xf6r dig f\xf6rst?";
                        setSuggestions([
                            "Hj\xe4lp mig reflektera \xf6ver vad som \xe4r viktigast",
                            "Ge mig ett f\xf6rslag",
                            "Visa mig hur en bra m\xe5lbild kan se ut"
                        ]);
                    }
                } else if (props.editPart.title.length > 0) {
                    startMessage += ", I'm here to help you create a clear and motivating Goal.  \n  \nWould you like me to suggest one based on your draft, or would you rather reflect on what matters most first?";
                    setSuggestions([
                        "Help me reflect on what matters most",
                        "Suggest one based on my draft",
                        "Show me what a good Goal looks like"
                    ]);
                } else {
                    startMessage += ", I'm here to help you create a clear and motivating Goal.  \n  \nDo you have any ideas where to start, or would you rather reflect on what matters most first?";
                    setSuggestions([
                        "Help me reflect on what matters most",
                        "Give me a draft",
                        "Show me what a good Goal looks like"
                    ]);
                }
            } else if (props.editPart.type === "action") {
                if (lang === "sv") {
                    startMessage += ", l\xe5t oss ta fram en konkret uppgift du beh\xf6ver g\xf6ra f\xf6r att n\xe5 delm\xe5let.  \n Har du n\xe5got i \xe5tanke redan eller vill du utforska tillsammans?";
                    setSuggestions([
                        "Hj\xe4lp mig utforska vad som passar min vardag",
                        "F\xf6resl\xe5 meningsfulla uppgifter utifr\xe5n mitt delm\xe5l",
                        "Visa mig ett exempel p\xe5 en konkret uppgift"
                    ]);
                } else {
                    startMessage += ", let's break this sub-goal into concrete tasks.  \nDo you have something in mind, or want to explore together?";
                    setSuggestions([
                        "Help me explore what fits my everyday work",
                        "Suggest meaningful tasks based on my sub-goal",
                        "Show me an example of a concrete task"
                    ]);
                }
            } else if (props.editPart.type === "activity") {
                if (lang === "sv") {
                    startMessage += ", l\xe5t oss definiera en aktivitet som f\xf6r dig n\xe4rmare din m\xe5lbild. Har du redan n\xe5got i \xe5tanke, eller ska vi utforska tillsammans vad som passar utifr\xe5n var du \xe4r idag?";
                    setSuggestions([
                        "Hj\xe4lp mig utforska vad som passar",
                        "F\xf6resl\xe5 en kraftfull aktivitet utifr\xe5n min M\xe5lbild",
                        "Visa mig ett exempel p\xe5 en konkret aktivitet"
                    ]);
                } else {
                    startMessage += ", Let's define an activity that moves you closer to your Goal. Do you already have something in mind, or shall we explore what makes sense based on where you are today?";
                    setSuggestions([
                        "Help me explore what fits",
                        "Suggest one powerful activity based on my Goal",
                        "Show me an example of a concrete activity"
                    ]);
                }
            } else if (props.editPart.type === "goal") {
                if (lang === "sv") {
                    startMessage += ", jag \xe4r h\xe4r f\xf6r att hj\xe4lpa dig definiera ett delm\xe5l som st\xf6djer din m\xe5lbild. Vi kan anv\xe4nda SMART-metoden, eller utforska om ett utfallsbaserat, processbaserat eller upplevelsebaserat m\xe5l passar b\xe4ttre. Var vill du b\xf6rja?";
                    setSuggestions([
                        "Hj\xe4lp mig v\xe4lja r\xe4tt typ av m\xe5l",
                        "F\xf6resl\xe5 ett delm\xe5l utifr\xe5n min M\xe5lbild",
                        "F\xf6rklara SMART vs andra m\xe5ltyper"
                    ]);
                } else {
                    startMessage += ", I'm here to help you define a Sub-goal that supports your Goal. We can use the SMART method, or explore whether an outcome-based, process-based, or experiential goal fits better. Where would you like to start?";
                    setSuggestions([
                        "Help me choose the right type of goal",
                        "Suggest a sub-goal based on my Goal",
                        "Explain SMART vs other goal types"
                    ]);
                }
            } else if (props.editPart.type === "behavior") {
                if (lang === "sv") {
                    if (props.editPart.barrier) {
                        startMessage += ", dags att skapa ett beteende som hj\xe4lper dig att n\xe5 ditt m\xe5l. Detta beteende kommer baseras p\xe5 ditt hinder &quot;" + props.editPart.barrier + "&quot;. Vi kommer att anv\xe4nda en enkel " + "&quot;N\xe4r/Om \u2192 D\xe5&quot;-struktur f\xf6r att g\xf6ra det tydligt och l\xe4tt att \xf6va p\xe5. Vad vill du utg\xe5 ifr\xe5n?";
                        setSuggestions([
                            "Hj\xe4lp mig utforska detta hinder f\xf6rst",
                            "F\xf6resl\xe5 ett beteende",
                            "Visa ett exempel p\xe5 ett starkt beteende"
                        ]);
                    } else {
                        startMessage += ", dags att skapa ett beteende som hj\xe4lper dig att n\xe5 ditt m\xe5l. Vi kommer att anv\xe4nda en enkel &quot;N\xe4r/Om \u2192 D\xe5&quot;-struktur att g\xf6ra det tydligt och l\xe4tt att \xf6va p\xe5. Vad vill du utg\xe5 ifr\xe5n?";
                        if (props.editPart.barriers) {
                            var _barriers = [];
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = props.editPart.barriers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var _barrier = _step2.value;
                                    _barriers.push('Mitt hinder "' + _barrier.text + '"');
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                            _barriers.push("Jag b\xf6rjar hellre fr\xe5n b\xf6rjan");
                            setSuggestions(_barriers);
                        }
                    }
                } else if (props.editPart.barrier) {
                    startMessage += ", let's create a behaviour to help you reach this goal. This one will be based on your barrier: &quot;" + props.editPart.barrier + "&quot;. We\u2019ll use a simple &quot;If/When \u2192 Then&quot; " + "structure to make it clear and easy to practise. Where would you like to start?";
                    setSuggestions([
                        "Help me explore this barrier first",
                        "Suggest one effective behaviour",
                        "Show me an example of a strong behaviour"
                    ]);
                } else {
                    startMessage += ", let's create a behaviour to help you reach this goal. We\u2019ll use a simple &quot;If/When \u2192 Then&quot; structure to make it clear and easy to practise. What would you like to base it on?";
                    if (props.editPart.barriers) {
                        var _barriers1 = [];
                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                        try {
                            for(var _iterator3 = props.editPart.barriers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                var _barrier1 = _step3.value;
                                _barriers1.push('My barrier "' + _barrier1.text + '"');
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                    _iterator3.return();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                        _barriers1.push("I'd rather start from scratch");
                        setSuggestions(_barriers1);
                    }
                }
            }
        }
        if (startMessage.length > 0) {
            setEmmaThinking(true);
            var words = startMessage.split(' ');
            var wordLen = words.length;
            var _startMessage = "";
            var i = 0;
            var intervalId = setInterval(function() {
                if (i >= wordLen) {
                    clearInterval(intervalId);
                    setEmmaThinking(false);
                } else {
                    _startMessage += words[i] + " ";
                    setMessages([
                        {
                            role: "assistant",
                            text: _startMessage
                        }
                    ]);
                }
                i++;
            }, 80);
        }
        return function() {
            window.removeEventListener('resize', onResize);
        };
    }, []);
    var scrollDown = function() {
        if (chatWindowRef.current) setTimeout(function() {
            var lastMsg = document.getElementById("last_msg");
            if (lastMsg && chatWindowRef.current) chatWindowRef.current.scrollTo({
                top: lastMsg.offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        }, 200);
    };
    var updateDeadline = function(_deadline) {
        if (_deadline) setDeadline(_deadline);
        else setDeadline(null);
    };
    var renderChat = function() {
        var height = "calc(100dvh - " + (narrow ? 348 : 290) + "px)";
        var minHeight = narrow ? "340px" : "404px";
        var lastMsgNr = messages.length - 1;
        var lastMsgUserNr = messages.length - 2;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            ref: chatWindowRef,
            className: "overflow-y-scroll z-no-scrollbar relative pb-4",
            style: {
                height: height,
                minHeight: minHeight
            },
            children: [
                messages.map(function(message, i) {
                    var cls = "mt-2 text-gray-300 ";
                    var lastId = i === lastMsgUserNr ? "last_msg" : "";
                    if (message.role === "user") cls += " whitespace-pre-line px-4 py-2 bg-indigo-800 rounded-md align-right ml-auto max-w-[67%]";
                    else cls += " markdown-content";
                    if (message.role === "user") return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        id: lastId,
                        children: [
                            Array.isArray(message.aiFiles) && message.aiFiles.length > 0 && (0, $ff64b672040c3459$export$f479e71c47d92681)(message.aiFiles),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: cls,
                                children: message.text
                            })
                        ]
                    }, "chat_" + i);
                    else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: cls,
                        id: lastId,
                        children: message.text === "SUGGESTION" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-last-msg-small",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "p-4 bg-indigo-800 border border-aquamarine-500 rounded-md flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($364604bcf0abac53$exports))),
                                        alt: "ai",
                                        className: "h-5 w-5"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "ml-2 z-title3 text-gray-100",
                                        children: lang === "sv" ? "Skapade f\xf6rslag. Se detaljer i manuella sektionen." : "Suggestion created. View full details in the manual section."
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-start" + (i > 0 && i === lastMsgNr ? " z-last-msg-small" : ""),
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: i === lastMsgNr && streamStatus === 1 ? (0, (/*@__PURE__*/$parcel$interopDefault($9bdfb8bb1dda4858$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($11d17cb94e9b6332$exports))),
                                    alt: "ai",
                                    className: "mt-2 w-6"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "ml-2",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b0f0e35343cbf8ab$export$7460c8b7e4ce9582), {
                                        children: message.text
                                    })
                                })
                            ]
                        })
                    }, "chat_" + i);
                }),
                messages.length === 1 && !emmaThinking && suggestions.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: suggestions.map(function(suggestion, index) {
                        var fadeIn = index > 3 ? 3 : index;
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "neutralBase",
                            className: "mt-2 z-anim-fade-in" + fadeIn,
                            style: {
                                width: "unset"
                            },
                            onClick: function() {
                                return send(suggestion, null, []);
                            },
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "ml-2 z-title3",
                                children: suggestion
                            })
                        }, "suggestion_" + index);
                    })
                })
            ]
        });
    };
    var updateLastMessage = function(txt) {
        messages[messages.length - 1].text = txt;
        setMessages((0, $XnYkK._)(messages));
    };
    function handleStream(reader) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var done, value, streamResponse, finalResponse, decoder, ref, data, suggestion, responseData, aiResponse;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        streamResponse = "";
                        finalResponse = "";
                        decoder = new TextDecoder();
                        _state.label = 1;
                    case 1:
                        if (!!done) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            reader.read()
                        ];
                    case 2:
                        ref = _state.sent(), value = ref.value, done = ref.done, ref;
                        if (done) {
                            if (finalResponse.length > 0) try {
                                data = JSON.parse(finalResponse);
                                if (data.aiResponse) {
                                    updateLastMessage(data.aiResponse);
                                    suggestion = data.functionCall;
                                    if (suggestion) {
                                        setTitle(suggestion.title);
                                        if (suggestion.description) setDescription(suggestion.description);
                                        if (suggestion.ifWhen) setIfWhen(suggestion.ifWhen);
                                        if (suggestion.ifThen) setIfThen(suggestion.ifThen);
                                        setDeadline(new Date(suggestion.deadline));
                                        if (narrow) {
                                            setSelectedView("manual");
                                            setGlobalToast({
                                                text: lang === "sv" ? "Skapade f\xf6rslag nedan" : "Created suggestion below"
                                            });
                                        }
                                    }
                                    if (data.debug) setPrompt(data.debug.prompt);
                                } else console.log(data);
                            } catch (error) {
                                console.log(error);
                            }
                            return [
                                2
                            ];
                        }
                        responseData = decoder.decode(value);
                        // If we have received start of finalResponse, add to it
                        if (finalResponse.length > 0) finalResponse += responseData;
                        else {
                            // Look for position of {"aiResponse". If we find that, this is the start of finalResponse
                            aiResponse = responseData.indexOf('{"aiResponse"');
                            if (aiResponse > -1) finalResponse = responseData.substring(aiResponse);
                        }
                        if (finalResponse.length === 0) {
                            if (responseData.startsWith("_-_")) updateLastMessage(responseData.substring(3));
                            else {
                                streamResponse += responseData;
                                updateLastMessage(streamResponse);
                            }
                        }
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    var send = function(text, aiStart) {
        var uploadFile = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        var _message = {
            role: "user",
            text: text,
            aiFiles: uploadFile
        };
        var _barrier = barrier;
        if (props.editPart.type === "behavior") {
            if (text.startsWith("My barrier ")) {
                _barrier = text.substring(10, text.length - 1);
                setBarrier(_barrier);
            } else if (text.startsWith("Mitt hinder ")) {
                _barrier = text.substring(13, text.length - 1);
                setBarrier(_barrier);
            }
        }
        setEmmaThinking(true);
        setStreamStatus(1);
        scrollDown();
        var data = {
            message: text,
            messages: messages,
            coachStyle: coachStyle,
            type: props.editPart.type,
            id: props.editPart.id,
            title: title,
            ifWhen: ifWhen,
            IfThen: ifThen,
            barrier: barrier,
            description: description,
            deadline: deadline,
            questions: questions,
            goal: props.viewGoal,
            aiFile: uploadFile
        };
        var _messages = messages;
        _messages.push(_message);
        _messages.push({
            role: "assistant",
            text: "Thinking..."
        });
        setMessages(_messages);
        api.post("fast_api/client/vision_statement_part/" + props.visionStatement.id, data, [], false, true).then(function(response) {
            if (response.response.ok && response.response.body) handleStream(response.response.body.getReader()).then(function() {
                setStreamStatus(2);
                setEmmaThinking(false);
            });
            else alert(response.response.statusText);
        }).catch(function(error) {
            return alert(error);
        });
    };
    var noOp = function() {};
    var renderPartHeader = function() {
        if (props.editPart.type === "goal") {
            if (props.editPart.description.length === 0) return lang === "sv" ? "Skapa ditt delm\xe5l" : "Create your sub-goal";
            else return lang === "sv" ? "\xc4ndra ditt delm\xe5l" : "Edit your sub-goal";
        } else if (props.editPart.type === "activity") {
            if (props.editPart.description.length === 0) return lang === "sv" ? "Skapa en aktivitet" : "Create an activity";
            else return lang === "sv" ? "\xc4ndra din aktivitet" : "Edit your activity";
        } else if (props.editPart.type === "action") {
            if (props.editPart.description.length === 0) return lang === "sv" ? "Skapa en uppgift" : "Create a task";
            else return lang === "sv" ? "\xc4ndra din uppgift" : "Edit your task";
        } else if (props.editPart.type === "behavior") {
            if (!props.editPart.deadline || props.editPart.deadline.length === 0) return lang === "sv" ? "Skapa beteende" : "Create behaviour";
            else return lang === "sv" ? "\xc4ndra beteende" : "Edit behaviour";
        } else if (props.editPart.type === "vision_statement") {
            if (props.editPart.description.length === 0) return lang === "sv" ? "Skapa din m\xe5lbild" : "Create your Goal";
            else return lang === "sv" ? "\xc4ndra din m\xe5lbild" : "Edit your Goal";
        }
    };
    var renderAI = function() {
        var placeholder = lang === "sv" ? "Skriv h\xe4r..." : "Write here...";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "px-4 py-2",
            children: [
                renderChat(),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "relative justify-end",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-gradientback-model"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $f6e11d7e911b44d5$export$2e2bcd8739ae039), {
                            sendToOtherPage: false,
                            handleSendMessage: send,
                            onHeightChange: noOp,
                            setCoachStyle: setCoachStyle,
                            coachStyle: coachStyle,
                            startVoice: noOp,
                            emmaThinking: emmaThinking,
                            placeholder: placeholder,
                            hideVoice: true
                        })
                    ]
                })
            ]
        });
    };
    var renderManual = function() {
        var _OPTIONS_BY_TYPE_props_editPart_type;
        var options = (_OPTIONS_BY_TYPE_props_editPart_type = OPTIONS_BY_TYPE[props.editPart.type]) !== null && _OPTIONS_BY_TYPE_props_editPart_type !== void 0 ? _OPTIONS_BY_TYPE_props_editPart_type : null;
        var _obj;
        var LABEL_BY_TYPE = (_obj = {}, (0, $dUlz9._)(_obj, "activity", t("save-activity")), (0, $dUlz9._)(_obj, "goal", t("save-subgoal")), (0, $dUlz9._)(_obj, "behavior", t("save-behavior")), (0, $dUlz9._)(_obj, "vision_statement", t("save-longtermgoal")), _obj);
        var _LABEL_BY_TYPE_props_editPart_type;
        var saveLabel = (_LABEL_BY_TYPE_props_editPart_type = LABEL_BY_TYPE[props.editPart.type]) !== null && _LABEL_BY_TYPE_props_editPart_type !== void 0 ? _LABEL_BY_TYPE_props_editPart_type : t("save");
        var height = "calc(100dvh - " + (narrow ? 218 : 170) + "px)";
        // const height = narrow ? "calc(100dvh - 216px)" : "calc(100dvh - 219px)";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "p-4 flex flex-col",
            style: {
                height: height
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex-1 overflow-y-auto",
                    children: [
                        props.editPart.type === "action" && props.viewGoal && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center justify-between cursor-pointer",
                                    onClick: function() {
                                        return setShowDetails(!showDetails);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-gray-100 font-medium",
                                            children: lang === "sv" ? "Se delm\xe5l" : "See sub goal"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f3995b418b94841f$exports))),
                                            alt: "toggle",
                                            className: "h-4 w-4 cursor-pointer" + (showDetails ? " rotate-180" : "")
                                        })
                                    ]
                                }),
                                showDetails && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "mt-2 font-medium text-gray-100",
                                            children: [
                                                t("title"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-gray-300",
                                            children: props.viewGoal.title
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "mt-2 font-medium text-gray-100",
                                            children: [
                                                t("description"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-gray-300",
                                            children: props.viewGoal.description
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "mt-2 font-medium text-gray-100",
                                            children: [
                                                t("due-date"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-gray-300",
                                            children: props.viewGoal.deadline
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                    className: "border-indigo-700 my-2"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "bg-indigo-900",
                            children: [
                                props.editPart.type === "behavior" ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-4 font-medium text-gray-100",
                                            children: lang === "sv" ? "Om/N\xe4r" : "If/When"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                                type: "text",
                                                className: "z-input",
                                                value: ifWhen,
                                                placeholder: lang === "sv" ? "N\xe4r jag f\xe5r en sv\xe5r fr\xe5ga" : "When I'm asked a difficult question",
                                                onChange: function(e) {
                                                    setIfWhen(e.target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-4 font-medium text-gray-100",
                                            children: lang === "sv" ? "D\xe5" : "Then"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                                type: "text",
                                                className: "z-input",
                                                value: ifThen,
                                                placeholder: lang === "sv" ? "Ska jag pausa i 3 sekunder innan jag svarar" : "I will pause for 3 seconds before answering",
                                                onChange: function(e) {
                                                    setIfThen(e.target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-4 font-medium text-gray-100",
                                            children: lang === "sv" ? "Kort titel" : "Short title"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                                type: "text",
                                                className: "z-input",
                                                value: title,
                                                placeholder: t("title"),
                                                onChange: function(e) {
                                                    setTitle(e.target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-4 font-medium text-gray-100",
                                            children: lang === "sv" ? "Hur ofta vill du tr\xe4na p\xe5 beteendet?" : "How often do you plan to practise this behaviour?"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-2 flex flex-wrap",
                                            children: HOW_OFTEN_OPTIONS.map(function(opt) {
                                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    onClick: function() {
                                                        return setHowOften(opt.value);
                                                    },
                                                    className: [
                                                        'rounded-full border mb-2 mr-2 border-indigo-700 hover:bg-indigo-700',
                                                        'px-3 py-1 cursor-pointer text-center text-neutral-100!',
                                                        howOften === opt.value ? 'bg-indigo-700' : 'hover:bg-indigo-700'
                                                    ].join(' '),
                                                    children: lang === "sv" ? opt.sv : opt.en
                                                }, opt.value);
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-4 font-medium text-gray-100",
                                            children: t("title")
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                                type: "text",
                                                className: "z-input",
                                                value: title,
                                                placeholder: t("title"),
                                                onChange: function(e) {
                                                    setTitle(e.target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-4 font-medium text-gray-100",
                                            children: t("description")
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("textarea", {
                                                className: "z-input h-54",
                                                value: description,
                                                placeholder: t("description"),
                                                onChange: function(e) {
                                                    setDescription(e.target.value);
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-4 font-medium text-gray-100 gap-2",
                                    children: "behavior" === props.editPart.type ? t("practice-behavior-for") : t("set-due-date")
                                }),
                                options && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-2",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $31765b9fabb4598f$export$2e2bcd8739ae039), {
                                        options: options,
                                        selected: selectedRangeOption,
                                        onChange: handleChange,
                                        getLanguageString: function(opt) {
                                            return lang === 'sv' ? "".concat(opt.value, " ").concat(opt.unit === 'week' ? 'veckor' : "m\xe5nader") : "".concat(opt.value, " ").concat(opt.unit).concat(opt.value > 1 ? 's' : '');
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-2",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $393fb8fc0a86de60$export$5109c6dd95d8fb00), {
                                        wrapperClassName: "w-full",
                                        className: "z-input w-full cursor-pointer",
                                        selected: deadline,
                                        placeholderText: lang === "sv" ? "V\xe4lj datum" : "Or select a date",
                                        onChange: updateDeadline,
                                        dateFormat: "yyyy-MM-dd",
                                        minDate: new Date(),
                                        // Datepicker popup
                                        withPortal: true,
                                        //keep 6 row
                                        fixedHeight: true
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "pt-4",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        disabled: !isValid(),
                        buttonType: "blueBase",
                        style: {
                            width: "100%"
                        },
                        onClick: function() {
                            return save();
                        },
                        children: saveLabel
                    })
                })
            ]
        });
    };
    // if (CONFIG.SYSTEM !== "production" && prompt.length > 0) {
    //   console.log(prompt);
    // }
    var renderBody = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-show-sub-1100 px-4 pt-4",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $f630b025744d4f80$export$2e2bcd8739ae039), {
                        items: [
                            {
                                title: t("ai-assistant"),
                                key: "ai",
                                iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2f73d526a867139d$exports)))
                            },
                            {
                                title: t("manual"),
                                key: "manual",
                                iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports)))
                            }
                        ],
                        selected: selectedView,
                        selectKey: setSelectedView
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "z-responsive-2cols flex",
                    children: [
                        (!narrow || selectedView === "ai") && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-responsive-col1-nowidth md:w-2/3 ".concat(narrow ? "z-responsive-col1" : ""),
                            children: renderAI()
                        }),
                        (!narrow || selectedView === "manual") && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "bg-indigo-900 z-responsive-col1-nowidth w-1/3 ".concat(narrow ? "z-responsive-col1" : "") + (narrow && selectedView === "ai" ? " hide" : ""),
                            children: renderManual()
                        })
                    ]
                })
            ]
        });
    };
    var closeWithoutSaving = function() {
        if (!props.visionStatement.description || props.visionStatement.description.length < 1 || !props.visionStatement.deadline || props.visionStatement.deadline.length < 1) {
            if (!props.visionStatement.surveyId) {
                // If the Goal has no survey and we close it before it has any data, delete it.
                var data = {
                    type: "vision_statement"
                };
                api.post("client/vision_statement_delete_part/" + props.visionStatement.id, data).then(function(response) {
                    if (response.json.status === "ok") navigate("/dev-plan");
                });
            } else navigate('/dev-plan');
        } else {
            props.close();
            setCloseNoSave(false);
        }
    };
    var save = function() {
        if (deadline) props.save(title, description, deadline.toLocaleDateString("sv-SE"), barrier, ifWhen, ifThen, howOften);
    };
    var renterInfoModel = function() {
        if (props.editPart.type === "vision_statement") return renterLongtermInfoModel();
        else return renterSubInfoModel();
    };
    var handleChange = function(rangeOption, fromDate) {
        setSelectedRangeOption(rangeOption);
        setDeadline(fromDate);
    };
    var renterSubInfoModel = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: function() {
                return setFeedbackInfoModel(false);
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return setFeedbackInfoModel(false);
                    },
                    children: t("long-term Goal")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 font-medium text-gray-100",
                            children: [
                                t("title"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-300",
                            children: props.visionStatement.title
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 font-medium text-gray-100",
                            children: [
                                t("description"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-300",
                            children: props.visionStatement.description
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 font-medium text-gray-100",
                            children: [
                                t("due-date"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-300",
                            children: props.visionStatement.deadline
                        })
                    ]
                })
            ]
        });
    };
    var renterLongtermInfoModel = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: function() {
                return setFeedbackInfoModel(false);
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return setFeedbackInfoModel(false);
                    },
                    children: t("feedback-model-info")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4",
                        children: questions.map(function(question, i) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "bg-indigo-800 rounded-md p-4 mt-4",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex gap-x-2",
                                        children: [
                                            question.scoreOther > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc8331b32d7a20e7$export$2e2bcd8739ae039), {
                                                lang: lang,
                                                type: "validated",
                                                value: question.scoreSelf,
                                                value2: question.scoreOther
                                            }),
                                            question.focusAreaName.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "z-badge transparent",
                                                children: question.focusAreaName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex flex-wrap gap-2 mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "z-half",
                                                children: question.name
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "z-half",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $200b3872b8c265f8$export$2e2bcd8739ae039), {
                                                        value1: question.scoreSelf,
                                                        value2: question.scoreOther,
                                                        size: "small"
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                        className: "mt-2 flex",
                                                        children: [
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                                className: "text-sm",
                                                                children: [
                                                                    "Self-assessment: ",
                                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                                        className: "z-title2",
                                                                        children: question.scoreSelf.toFixed(1)
                                                                    }),
                                                                    "/5"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                                className: "ml-4 text-sm",
                                                                children: [
                                                                    "Feedback: ",
                                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                                        className: "z-title2",
                                                                        children: question.scoreOther === 0 ? "-" : question.scoreOther.toFixed(1)
                                                                    }),
                                                                    "/5"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                                className: "ml-4 text-sm",
                                                                children: [
                                                                    "Gap: ",
                                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                                        className: "z-title2",
                                                                        children: question.scoreOther === 0 ? "-" : Math.abs(question.scoreOther - question.scoreSelf).toFixed(1)
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, "question_" + i);
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: true,
                onClose: function() {
                    return setCloseNoSave(true);
                },
                size: "large",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                        onClose: function() {
                            return setCloseNoSave(true);
                        },
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center justify-between w-full",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: renderPartHeader()
                                }),
                                showfeedbackInfoModel && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "pr-4",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: "neutralBase",
                                        size: "sm",
                                        style: {
                                            width: "unset"
                                        },
                                        onClick: function() {
                                            return setFeedbackInfoModel(true);
                                        },
                                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                                            alt: "info"
                                        }),
                                        children: props.editPart.type === "vision_statement" ? lang === "sv" ? "Se feedback" : "See feedback" : lang === "sv" ? "Se m\xe5lbild" : "See Goal"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        noPadding: true,
                        children: renderBody()
                    })
                ]
            }),
            closeNoSave && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: closeNoSave,
                onClose: function() {
                    return setCloseNoSave(false);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-title1",
                            children: lang === "sv" ? "Vill du st\xe4nga utan att spara?" : "Exit without saving?"
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex gap-x-2 w-full",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "dangerBase",
                                    onClick: function() {
                                        return closeWithoutSaving();
                                    },
                                    children: lang === "sv" ? "St\xe4ng utan att spara" : "Exit without saving"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    onClick: function() {
                                        setCloseNoSave(false);
                                    },
                                    children: lang === "sv" ? "Stanna kvar" : "Stay"
                                })
                            ]
                        })
                    })
                ]
            }),
            feedbackInfoModel && renterInfoModel()
        ]
    });
};
var $e2435b6138b3d161$export$2e2bcd8739ae039 = $e2435b6138b3d161$var$LongTermGoalPart;








var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");










var $ae01b41cdc98c1f8$var$ClientAwareness = function(props) {
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showModal = _useState[0], setShowModal = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(props.awareness ? props.awareness.important : 0), 2), important = _useState1[0], setImportant = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(props.awareness ? props.awareness.well : 0), 2), well = _useState2[0], setWell = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(props.awareness ? props.awareness.energy : 0), 2), energy = _useState3[0], setEnergy = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(props.awareness ? props.awareness.score : 0), 2), score = _useState4[0], setScore = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), saving = _useState5[0], setSaving = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), changed = _useState6[0], setChanged = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), resultTxt = _useState7[0], setResultTxt = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), resultNext = _useState8[0], setResultNext = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), cta = _useState9[0], setCta = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)(props.awareness ? 4 : 1), 2), step = _useState10[0], setStep = _useState10[1];
    var _useState11 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), doneBefore = _useState11[0], setDoneBefore = _useState11[1];
    var visionStatementActivated = new Date(props.visionStatementActivated);
    var now = new Date();
    (0, $5s1kH.useEffect)(function() {
        if (important > 0 && well > 0 && energy > 0) {
            setDoneBefore(true);
            calculateResult();
        }
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (energy > 0 && changed) {
            var _score = calculateResult();
            var _awareness = {
                important: important,
                well: well,
                energy: energy,
                score: _score,
                created: now.toISOString()
            };
            props.save(_awareness);
        }
    }, [
        energy
    ]);
    var calculateResult = function() {
        var _score;
        var txt;
        var nxt;
        var _cta = "barriers";
        if (important === 4) {
            if (well === 4 && energy === 4) {
                _score = 10;
                txt = lang === "sv" ? "Du \xe4r redo! Det h\xe4r m\xe5let k\xe4nns perfekt. Det \xe4r viktigt f\xf6r dig, det passar din situation och du har full energi att jobba med det. K\xf6r!" : "You're all set! This goal feels perfect. It matters to you, it fits your situation and you have the energy to act. Let's go!";
                nxt = lang === "sv" ? "Utforska vad som kan st\xe5 i v\xe4gen f\xf6r dig att n\xe5 m\xe5let" : "Explore what could get in your way.";
            } else if (well >= 3) {
                if (energy >= 3) {
                    _score = 9;
                    txt = lang === "sv" ? "Riktigt bra! Det h\xe4r m\xe5let betyder verkligen n\xe5got f\xf6r dig. Det passar din situation och du har energi att jobba med det." : "Strong position! This goal really matters to you. It fits your situation and you have energy to act.";
                    nxt = lang === "sv" ? "Utforska vad som kan st\xe5 i v\xe4gen f\xf6r dig att n\xe5 m\xe5let" : "Explore what could get in your way.";
                } else {
                    _score = 7;
                    txt = lang === "sv" ? "Stark grund! Det h\xe4r m\xe5let betyder verkligen n\xe5got och det passar din situation. Det som h\xe5ller dig tillbaka just nu \xe4r energin." : "Good foundation! This goal really matters and it fits your situation. The main thing holding you back is energy.";
                    nxt = lang === "sv" ? "Ta reda p\xe5 vad som tar din energi just nu." : "Find out what's costing you energy right now.";
                }
            } else if (energy >= 3) {
                _score = 7;
                txt = lang === "sv" ? "Stark grund! Det h\xe4r m\xe5let \xe4r viktigt f\xf6r dig och du har energin. Men det passar inte riktigt in i din situation just nu." : "Good foundation! This goal matters to you and you have the energy. But it doesn't quite fit your situation right now.";
                nxt = lang === "sv" ? "Ta reda p\xe5 vad det \xe4r som g\xf6r att m\xe5let inte riktigt passar." : "Find out what's making this hard to fit into your situation.";
            } else {
                _score = 6;
                txt = lang === "sv" ? "Bra start! Det h\xe4r m\xe5let \xe4r viktigt f\xf6r dig. Men det passar inte riktigt in i din situation och din energi \xe4r l\xe5g just nu." : "Solid start! This goal matters to you. But it doesn't quite fit your situation and your energy is low right now.";
                nxt = lang === "sv" ? "Ta reda p\xe5 vad som st\xe5r i v\xe4gen och vad som kostar dig energi" : "Find out what's making this hard to fit and what's draining your energy.";
            }
        } else if (important === 3) {
            if (well >= 3) {
                if (energy >= 3) {
                    _score = 8;
                    txt = lang === "sv" ? "Riktigt bra! Du k\xe4nner engagemang, det h\xe4r m\xe5let passar din situation och du har energin att g\xe5 fram\xe5t." : "Strong position! You feel engaged, this goal fits your situation and you have the energy to move forward.";
                    nxt = lang === "sv" ? "Utforska vad som kan st\xe5 i v\xe4gen f\xf6r dig att n\xe5 m\xe5let" : "Explore what could get in your way.";
                } else {
                    _score = 7;
                    txt = lang === "sv" ? "Stark grund! Du k\xe4nner engagemang och det h\xe4r m\xe5let passar din situation. Det som h\xe5ller dig tillbaka just nu \xe4r energin." : "Good foundation! You feel engaged and this goal fits your situation. The main thing holding you back is energy.";
                    nxt = lang === "sv" ? "Ta reda p\xe5 vad som tar din energi just nu." : "Find out what's costing you energy right now.";
                }
            } else if (energy >= 3) {
                _score = 7;
                txt = lang === "sv" ? "Stark grund! Det h\xe4r m\xe5let \xe4r viktigt f\xf6r dig och du har energin. Men det passar inte riktigt in i din situation just nu." : "Good foundation! You feel engaged and have the energy. But this goal doesn't quite fit your situation right now.";
                nxt = lang === "sv" ? "Ta reda p\xe5 vad det \xe4r som g\xf6r att m\xe5let inte riktigt passar." : "Find out what's making this hard to fit into your situation.";
            } else {
                _score = 6;
                txt = lang === "sv" ? "Bra start! Det h\xe4r m\xe5let \xe4r viktigt f\xf6r dig. Men det passar inte riktigt in i din situation och din energi \xe4r l\xe5g just nu." : "Solid start! This goal matters to you. But it doesn't quite fit your situation and your energy is low right now.";
                nxt = lang === "sv" ? "Ta reda p\xe5 vad som st\xe5r i v\xe4gen och vad som kostar dig energi" : "Find out what's making this hard to fit and what's draining your energy.";
            }
        } else {
            _cta = "editGoal";
            if (well >= 3) {
                if (energy >= 3) {
                    _score = 5;
                    txt = lang === "sv" ? "Det h\xe4r m\xe5let passar din situation och du har energi. Men det k\xe4nns inte tillr\xe4ckligt meningsfullt \xe4n." : "This goal fits your situation and you have energy. But it doesn't feel meaningful enough yet.";
                    nxt = lang === "sv" ? "\xd6verv\xe4g att skriva om ditt m\xe5l s\xe5 att det k\xe4nns mer meningsfullt." : "Consider rewriting your goal to make it feel more meaningful.";
                } else {
                    _score = 3;
                    txt = lang === "sv" ? "Det h\xe4r m\xe5let passar din situation. Men det k\xe4nns inte meningsfullt och du har inte s\xe5 mycket energi att jobba med det just nu." : "This goal fits your situation. But it doesn't feel meaningful and you don't have the energy to act on it right now.";
                    nxt = lang === "sv" ? "Tips. Skriv om ditt m\xe5l s\xe5 att det k\xe4nns mer personligt meningsfullt." : "Rewrite your goal so it feels more personally meaningful.";
                }
            } else if (energy >= 3) {
                _score = 3;
                txt = lang === "sv" ? "Du har energin, men det h\xe4r m\xe5let k\xe4nns varken meningsfullt eller relevant just nu." : "You have the energy, but this goal doesn't feel meaningful or relevant right now.";
                nxt = lang === "sv" ? "Tips. Skriv om ditt m\xe5l s\xe5 att det b\xe4ttre speglar vad du faktiskt vill." : "Rewrite your goal so it better reflects what you actually want.";
            } else {
                _score = 1;
                txt = lang === "sv" ? "Det h\xe4r m\xe5let k\xe4nns varken meningsfullt, relevant eller genomf\xf6rbart just nu." : "This goal doesn't feel meaningful, relevant or workable right now.";
                nxt = lang === "sv" ? "Tips \xe4r att du b\xf6rjar om och skriver om m\xe5let fr\xe5n grunden." : "Start fresh. Rewrite your goal from the ground up.";
            }
        }
        setResultTxt(txt);
        setResultNext(nxt);
        setCta(_cta);
        setScore(_score);
        return _score;
    };
    var updateAnswer = function(answer) {
        if (step === 1) {
            setImportant(answer);
            setChanged(true);
        } else if (step === 2) setWell(answer);
        else if (step === 3) {
            setEnergy(answer);
            setSaving(true);
            setTimeout(function() {
                setSaving(false);
            }, 700);
        } else return;
        setTimeout(function() {
            setStep(step + 1);
        }, 500);
    };
    var renderAlternatives = function() {
        var options = [];
        var selectedAnswer = 0;
        if (step === 1) {
            options = lang === "sv" ? [
                "Mycket viktigt",
                "Ganska viktigt",
                "Inte s\xe5 viktigt",
                "Inte alls viktigt"
            ] : [
                "Very important",
                "Quite important",
                "Not that important",
                "Not important at all"
            ];
            selectedAnswer = important;
        } else if (step === 2) {
            options = lang === "sv" ? [
                "Mycket bra",
                "Ganska bra",
                "Inte s\xe5 bra",
                "Inte alls bra"
            ] : [
                "Very well",
                "Quite well",
                "Not that well",
                "Not well at all"
            ];
            selectedAnswer = well;
        } else if (step === 3) {
            options = lang === "sv" ? [
                "Mycket",
                "Tillr\xe4ckligt f\xf6r framsteg",
                "Inte s\xe5 mycket",
                "Ingen alls"
            ] : [
                "A lot",
                "Enough to make progress",
                "Only a little",
                "None at all"
            ];
            selectedAnswer = energy;
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "mt-4 flex gap-4 flex-wrap",
            children: options.map(function(option, index) {
                var answer = 4 - index;
                var cls = "z-half py-8 flex items-center justify-center rounded-md z-title2 cursor-pointer ";
                if (answer === selectedAnswer) cls += "bg-primary-500 text-indigo-900";
                else cls += "bg-indigo-800 hover:bg-indigo-700";
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    onClick: function() {
                        return updateAnswer(answer);
                    },
                    className: cls,
                    children: option
                }, "answer_" + answer);
            })
        });
    };
    var renderStep = function() {
        if (step === 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title1",
                    children: lang === "sv" ? "Hur viktigt \xe4r det f\xf6r dig att n\xe5 den h\xe4r m\xe5lbilden?" : "How important is it for you to reach this goal?"
                }),
                renderAlternatives()
            ]
        });
        else if (step === 2) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title1",
                    children: lang === "sv" ? "Hur v\xe4l passar den h\xe4r m\xe5lbilden din nuvarande situation?" : "How well does it connect to your current situation?"
                }),
                renderAlternatives()
            ]
        });
        else if (step === 3) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title1",
                    children: lang === "sv" ? "Hur mycket energi har du att jobba med det h\xe4r just nu?" : "How much energy do you have to work on this right now?"
                }),
                renderAlternatives()
            ]
        });
        else if (step === 4) {
            if (saving) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                style: {
                    height: 264
                },
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {
                    txt: lang === "sv" ? "Laddar resultat" : "Loading result"
                })
            });
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "bg-indigo-800 rounded-md p-4",
                children: [
                    !doneBefore && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "rounded-md border border-aquamarine-500 p-4 flex items-center gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($e126c82cf1d55289$exports))),
                                alt: "check",
                                className: "h-6 w-6"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title3",
                                children: lang === "sv" ? "Analys klar" : "Analysis completed"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex mt-4 justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title1",
                                children: lang === "sv" ? "Din engagemangsniv\xe5" : "Your engagement level"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-2xl font-medium",
                                        children: score
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-title2",
                                        children: "/10"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 z-body1",
                        children: resultTxt
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 z-title1",
                        children: lang === "sv" ? "Rekommenderat n\xe4sta steg" : "Recommended next step"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 z-body1",
                        children: resultNext
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                "Missing step ",
                step
            ]
        });
    };
    var closeModal = function() {
        setShowModal(false);
        if (!doneBefore && props.nextBarriers) setTimeout(function() {
            props.nextStep(cta);
        }, 300);
    };
    var renderFooter = function() {
        if (step > 3) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex gap-x-2",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    disabled: props.readOnly,
                    buttonType: "outlineWhiteBase",
                    size: "sm",
                    onClick: function() {
                        setImportant(0);
                        setWell(0);
                        setEnergy(0);
                        setStep(1);
                    // setDoneBefore(false);
                    },
                    children: lang === "sv" ? "B\xf6rja om" : "Restart"
                }),
                props.nextBarriers && !doneBefore ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    disabled: props.readOnly,
                    buttonType: "blueBase",
                    size: "sm",
                    rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                        alt: "right"
                    }),
                    onClick: function() {
                        return closeModal();
                    },
                    children: cta === "editGoal" ? lang === "sv" ? "Redigera m\xe5lbilden" : "Review goal" : lang === "sv" ? "Utforska hinder" : "Explore barriers"
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    size: "sm",
                    onClick: function() {
                        return closeModal();
                    },
                    children: t("done")
                })
            ]
        });
        else if (step > 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
            buttonType: "outlineWhiteBase",
            size: "sm",
            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($e9e1f45fe1c804bc$exports))),
                alt: "back"
            }),
            onClick: function() {
                return setStep(step - 1);
            },
            children: t("back")
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "bg-indigo-800 mt-4 p-4 rounded-md hover:bg-indigo-700 border-indigo-700 border-1",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            props.awareness ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "rounded-sm p-2 bg-success-500 w-11 text-center",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
                                    alt: "check",
                                    className: "h-6 w-6"
                                })
                            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "rounded-sm p-2 bg-indigo-700 border border-indigo-600 w-11 z-title3 text-center",
                                children: "1"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "ml-3",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-title1",
                                        children: t("quick-pulse")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "Hur viktigt \xe4r m\xe5let och finns energin?" : "Check your readiness and engagement level"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        disabled: props.readOnly && !props.awareness,
                        buttonType: props.awareness ? "transparentBase" : "blueBase",
                        size: "sm",
                        rightIcon: props.awareness ? null : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                            alt: "right"
                        }),
                        onClick: function() {
                            return setShowModal(true);
                        },
                        style: {
                            width: "unset"
                        },
                        children: props.awareness ? lang === "sv" ? "Visa" : "View" : lang === "sv" ? "Starta" : "Start"
                    })
                ]
            }),
            !props.awareness && now.getTime() - visionStatementActivated.getTime() > 604800000 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
                message: lang === "sv" ? "G\xf6r klar din snabb puls" : "Complete your quick pulse"
            }),
            showModal && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: showModal,
                onClose: function() {
                    return setShowModal(false);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                        onClose: function() {
                            return setShowModal(false);
                        },
                        children: t("quick-pulse")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            style: {
                                minHeight: 264
                            },
                            children: [
                                step < 4 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "h-2 mb-4 rounded-full bg-indigo-700",
                                    style: {
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "h-2 rounded-full bg-primary-500",
                                        style: {
                                            width: step * 25 + "%"
                                        }
                                    })
                                }),
                                renderStep()
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            style: {
                                minHeight: 38,
                                width: "100%"
                            },
                            children: renderFooter()
                        })
                    })
                ]
            })
        ]
    });
};
var $ae01b41cdc98c1f8$export$2e2bcd8739ae039 = $ae01b41cdc98c1f8$var$ClientAwareness;



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");




var $27b7c7795f6401f9$exports = {};
$27b7c7795f6401f9$exports = $parcel$resolve("7rc1l");



var $5119d0fea45ef927$exports = {};
$5119d0fea45ef927$exports = $parcel$resolve("7tOng");


var $6a8188a8e97e1ced$exports = {};
$6a8188a8e97e1ced$exports = $parcel$resolve("6gfMQ");







var $6a12173a8c20f5d3$var$ClientBarriers = function(props) {
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(props.open), 2), showModal = _useState[0], setShowModal = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(props.barriers.length > 0 ? 2 : 1), 2), step = _useState1[0], setStep = _useState1[1];
    var wide = window.innerWidth > 1100;
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), barriers = _useState2[0], setBarriers = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), noBarriers = _useState3[0], setNoBarriers = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), tooLong = _useState4[0], setTooLong = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), customText = _useState5[0], setCustomText = _useState5[1];
    var previousActivated = props.previousActivated ? new Date(props.previousActivated) : null;
    var now = new Date();
    (0, $5s1kH.useEffect)(function() {
        populateBarriers();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        setShowModal(props.open);
    }, [
        props.open
    ]);
    var populateBarriers = function() {
        var _barriers = [];
        _barriers.push({
            text: lang === "sv" ? "Jag vet inte var jag ska b\xf6rja" : "I don't know where to start",
            type: "doIt",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag saknar kunskapen f\xf6r att lyckas" : "I lack the knowledge to succeed",
            type: "doIt",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag \xe4r os\xe4ker p\xe5 om jag har det som kr\xe4vs" : "I'm not sure I have what it takes",
            type: "doIt",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag vet inte vad som \xe4r ett bra resultat" : "I don't know what a good result looks like",
            type: "doIt",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag har f\xf6rs\xf6kt tidigare utan att lyckas" : "I've tried before without succeeding",
            type: "doIt",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag k\xe4nner mig inte redo \xe4n" : "I don't feel ready yet",
            type: "doIt",
            selected: false,
            custom: false
        });
        // Can it work
        _barriers.push({
            text: lang === "sv" ? "Jag har inte tillr\xe4ckligt med tid just nu" : "I don't have enough time right now",
            type: "work",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag saknar r\xe4tt f\xf6ruts\xe4ttningar" : "I lack the right conditions",
            type: "work",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Andra prioriteringar tar \xf6ver" : "Other priorities keep taking over",
            type: "work",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Det saknas utrymme i min vardag" : "There's no room for it in my everyday life",
            type: "work",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag saknar resurser" : "I lack the resources",
            type: "work",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag saknar tillr\xe4ckligt med st\xf6d fr\xe5n andra" : "I don't have enough support from others",
            type: "work",
            selected: false,
            custom: false
        });
        // Do I want to
        _barriers.push({
            text: lang === "sv" ? "Jag k\xe4nner mig inte s\xe5 motiverad" : "I don\u2019t feel motivated enough",
            type: "want",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag \xe4r r\xe4dd att misslyckas" : "I'm afraid of failing",
            type: "want",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag tappar l\xe4tt fokus" : "I easily lose focus",
            type: "want",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag tenderar att skjuta upp saker" : "I tend to put things off",
            type: "want",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Det k\xe4nns inte relevant just nu" : "It doesn't feel relevant right now",
            type: "want",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Det k\xe4nns \xf6verv\xe4ldigande" : "It feels overwhelming",
            type: "want",
            selected: false,
            custom: false
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = props.barriers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var barrier = _step.value;
                if (barrier.custom) _barriers.push({
                    text: barrier.text,
                    custom: true,
                    selected: true,
                    type: "own"
                });
                else {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = _barriers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _barrier = _step1.value;
                            if (_barrier.text === barrier.text) _barrier.selected = true;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setBarriers(_barriers);
    };
    var checkBarrier = function(text) {
        var _barriers = (0, $XnYkK._)(barriers);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _barriers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _barrier = _step.value;
                if (_barrier.text === text) _barrier.selected = !_barrier.selected;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setBarriers(_barriers);
    };
    var barrierChecked = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = barriers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var barrier = _step.value;
                if (barrier.selected) return true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    };
    var updateCustom = function(txt) {
        if (txt.length < 41) {
            setCustomText(txt);
            setTooLong(false);
        } else setTooLong(true);
    };
    var addBarrier = function() {
        var _barriers = (0, $XnYkK._)(barriers);
        _barriers.push({
            text: customText,
            type: "own",
            custom: true,
            selected: true
        });
        setBarriers(_barriers);
        setCustomText("");
    };
    var customDisabled = function() {
        if (props.readOnly) return true;
        if (tooLong) return true;
        if (noBarriers) return true;
        if (customText.length < 3) return true;
        return false;
    };
    var renderStep = function() {
        if (step === 1) {
            var selectCls = "mt-2 p-4 flex items-center gap-x-2 rounded-md bg-indigo-800 hover:bg-indigo-700 cursor-pointer";
            var noBarrierCls = "mt-8 p-4 flex items-center gap-x-2 rounded-md bg-indigo-800 hover:bg-indigo-700 cursor-pointer";
            if (noBarriers) selectCls += " opacity-50 pointer-events-none";
            if (barrierChecked()) noBarrierCls += " opacity-50 pointer-events-none";
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-body1",
                        children: lang === "sv" ? "V\xe4lj de hinder som st\xe5r mellan dig och ditt m\xe5l just nu." : "Select the barriers standing between you and your goal right now."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 flex items-center gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($27b7c7795f6401f9$exports))),
                                alt: "star",
                                className: "h-8 w-8"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-title1",
                                        children: lang === "sv" ? "Kan jag?" : "Can I do it?"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "Kunskap, f\xe4rdighet, sj\xe4lvf\xf6rtroende" : "Knowledge, skills, confidence"
                                    })
                                ]
                            })
                        ]
                    }),
                    barriers.filter(function(b) {
                        return b.type === "doIt";
                    }).map(function(barrier, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: selectCls,
                            onClick: function() {
                                return checkBarrier(barrier.text);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $634501c911927d99$export$2e2bcd8739ae039), {
                                    checked: barrier.selected
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-title2",
                                    children: barrier.text
                                })
                            ]
                        }, barrier.type + "_" + index);
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-8 flex items-center gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports))),
                                alt: "star",
                                className: "h-8 w-8"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-title1",
                                        children: lang === "sv" ? "G\xe5r det?" : "Can it work?"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "Tid, kontext, st\xf6d" : "Time, space, support"
                                    })
                                ]
                            })
                        ]
                    }),
                    barriers.filter(function(b) {
                        return b.type === "work";
                    }).map(function(barrier, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: selectCls,
                            onClick: function() {
                                return checkBarrier(barrier.text);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $634501c911927d99$export$2e2bcd8739ae039), {
                                    checked: barrier.selected
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-title2",
                                    children: barrier.text
                                })
                            ]
                        }, barrier.type + "_" + index);
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-8 flex items-center gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($5119d0fea45ef927$exports))),
                                alt: "star",
                                className: "h-8 w-8"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-title1",
                                        children: lang === "sv" ? "Vill jag?" : "Do I want to?"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "Motivation, fokus, r\xe4dsla" : "Motivation, focus, fears"
                                    })
                                ]
                            })
                        ]
                    }),
                    barriers.filter(function(b) {
                        return b.type === "want";
                    }).map(function(barrier, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: selectCls,
                            onClick: function() {
                                return checkBarrier(barrier.text);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $634501c911927d99$export$2e2bcd8739ae039), {
                                    checked: barrier.selected
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-title2",
                                    children: barrier.text
                                })
                            ]
                        }, barrier.type + "_" + index);
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-8 flex items-center gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6a8188a8e97e1ced$exports))),
                                alt: "star",
                                className: "h-8 w-8"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-title1",
                                        children: lang === "sv" ? "Saknar du n\xe5got?" : "Anything missing?"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "L\xe4gg till ditt eget hinder" : "Add your own barriers"
                                    })
                                ]
                            })
                        ]
                    }),
                    barriers.filter(function(b) {
                        return b.custom;
                    }).map(function(barrier, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: selectCls,
                            onClick: function() {
                                return checkBarrier(barrier.text);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $634501c911927d99$export$2e2bcd8739ae039), {
                                    checked: barrier.selected
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-title2",
                                    children: barrier.text
                                })
                            ]
                        }, barrier.type + "_" + index);
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-4 flex items-center gap-x-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                className: "z-input",
                                value: customText,
                                onChange: function(e) {
                                    return updateCustom(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                disabled: customDisabled(),
                                buttonType: "neutralBase",
                                style: {
                                    width: "unset"
                                },
                                onClick: function() {
                                    return addBarrier();
                                },
                                children: t("add")
                            })
                        ]
                    }),
                    tooLong && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-2 text-sm text-cherry-500",
                        children: lang === "sv" ? "Max 40 tecken" : "Max 40 characters"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: noBarrierCls,
                        onClick: function() {
                            return setNoBarriers(!noBarriers);
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $634501c911927d99$export$2e2bcd8739ae039), {
                                checked: noBarriers
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title2",
                                children: lang === "sv" ? "Jag har inga hinder just nu" : "I don't have any barriers right now"
                            })
                        ]
                    })
                ]
            });
        } else if (step === 2) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "bg-indigo-800 rounded-md p-4",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "rounded-md border border-aquamarine-500 p-4 flex items-center gap-x-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e126c82cf1d55289$exports))),
                            alt: "check",
                            className: "h-6 w-6"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-title3",
                            children: lang === "sv" ? "Genomg\xe5ng klar" : "Barrier check completed"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 z-title1",
                    children: lang === "sv" ? "Dina identifierade hinder" : "Your identified barriers"
                }),
                barrierChecked() ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: barriers.filter(function(b) {
                        return b.selected;
                    }).map(function(barrier, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-2 border border-gray-400 rounded-full py-1 px-4 z-body3 inline-block",
                                children: barrier.text
                            })
                        }, "barrier_" + index);
                    })
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-body1",
                    children: lang === "sv" ? "Inga hinder! Det \xe4r ett bra tecken \u2014 det verkar som om inget f\xf6r n\xe4rvarande st\xe5r i v\xe4gen f\xf6r ditt l\xe5ngsiktiga m\xe5l." : "No barriers! That\u2019s a good sign \u2014 it looks like nothing is currently standing in the way of this goal."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 z-title1",
                    children: lang === "sv" ? "Rekommenderat n\xe4sta steg" : "Recommended next step"
                }),
                barrierChecked() ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-body1",
                    children: lang === "sv" ? "Skapa beteenden som hj\xe4lper dig att hantera dina identifierade hinder." : "Work with identified barrier(s) by creating behaviours to resolve them."
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-body1",
                    children: lang === "sv" ? "Forts\xe4tt mot ditt m\xe5l \u2014 l\xe4gg till beteenden och aktiviteter, och kom tillbaka n\xe4r n\xe5got skaver." : "Continue moving forward with this goal by creating necessary behaviours and activities, and come back any time if any friction comes up."
                })
            ]
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                "Missing step ",
                step
            ]
        });
    };
    var saveDisabled = function() {
        if (props.readOnly) return true;
        return !(noBarriers || barrierChecked());
    };
    var saveBarriers = function() {
        var _saveBarriers = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = barriers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _barrier = _step.value;
                if (_barrier.selected) _saveBarriers.push({
                    text: _barrier.text,
                    custom: _barrier.custom,
                    used: false
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        props.save(_saveBarriers);
        setStep(2);
    };
    var renderFooter = function() {
        if (step === 2) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex gap-x-2",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    disabled: props.readOnly,
                    buttonType: "outlineWhiteBase",
                    size: "sm",
                    onClick: function() {
                        return setStep(1);
                    },
                    children: t("restart")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    size: "sm",
                    onClick: function() {
                        return setShowModal(false);
                    },
                    children: t("done")
                })
            ]
        });
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
            disabled: saveDisabled(),
            buttonType: "blueBase",
            size: "sm",
            onClick: function() {
                return saveBarriers();
            },
            children: t("submit")
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "bg-indigo-800 mt-4 p-4 rounded-md hover:bg-indigo-700 border-indigo-700 border " + (props.disabled ? "opacity-50 pointer-events-none" : ""),
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            props.done ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "rounded-sm p-2 bg-success-500 w-11 text-center",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
                                    alt: "check",
                                    className: "h-6 w-6"
                                })
                            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "rounded-sm p-2 bg-indigo-700 border border-indigo-600 w-11 z-title3 text-center",
                                children: props.stepNumber
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "ml-3",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-title1",
                                        children: t("barriers")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "S\xe4tt fingret p\xe5 vad som st\xe5r i v\xe4gen" : "Pin down what's getting in your way"
                                    })
                                ]
                            })
                        ]
                    }),
                    !props.disabled && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: props.done ? "transparentBase" : "blueBase",
                        size: "sm",
                        disabled: props.readOnly && props.barriers.length === 0,
                        rightIcon: props.done ? null : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                            alt: "right"
                        }),
                        onClick: function() {
                            return setShowModal(true);
                        },
                        style: {
                            width: "unset"
                        },
                        children: props.barriers.length > 0 ? lang === "sv" ? "Visa" : "View" : lang === "sv" ? "Starta" : "Start"
                    })
                ]
            }),
            props.barriers.length === 0 && !props.done && !props.disabled && previousActivated && now.getTime() - previousActivated.getTime() > 604800000 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
                message: lang === "sv" ? "Identifiera dina hinder" : "Identify you barriers"
            }),
            showModal && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
                isOpen: showModal,
                onClose: function() {
                    return setShowModal(false);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                        onClose: function() {
                            return setShowModal(false);
                        },
                        children: lang === "sv" ? "Hitta hinder" : "Barrier check"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            style: {
                                height: wide ? 532 : "100%"
                            },
                            className: "overflow-y-scroll",
                            children: renderStep()
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            style: {
                                minHeight: 38,
                                width: "100%"
                            },
                            children: renderFooter()
                        })
                    })
                ]
            })
        ]
    });
};
var $6a12173a8c20f5d3$export$2e2bcd8739ae039 = $6a12173a8c20f5d3$var$ClientBarriers;






var $8fbc1cd7b0d38c80$var$LongTermGoal = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)((0, $1af830c9fe0316f4$export$a8d543f4b6260801)()), 2), tab = _useState2[0], setTab = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), updateProgress = _useState3[0], setUpdateProgress = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), updateGoalStatus = _useState4[0], setUpdateGoalStatus = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)({}), 2), chatThreadMap = _useState5[0], setChatThreadMap = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), goals = _useState6[0], setGoals = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), behaviors = _useState7[0], setBehaviors = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), activities = _useState8[0], setActivities = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), viewGoal = _useState9[0], setViewGoal = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), viewBehavior = _useState10[0], setViewBehavior = _useState10[1];
    var _useState11 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), viewAction = _useState11[0], setViewAction = _useState11[1];
    var _useState12 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), viewActivity = _useState12[0], setViewActivity = _useState12[1];
    var _useState13 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), editPart = _useState13[0], setEditPart = _useState13[1];
    var _useState14 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), deletePart = _useState14[0], setDeletePart = _useState14[1];
    var _useState15 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), hideAwareness = _useState15[0], setHideAwareness = _useState15[1];
    var _useState16 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), barriersOpen = _useState16[0], setBarriersOpen = _useState16[1];
    var _useState17 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), showDeleteBarrier = _useState17[0], setShowDeleteBarrier = _useState17[1];
    var _useState18 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), surveyRequestNr = _useState18[0], setSurveyRequestNr = _useState18[1];
    var _useState19 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), clientName = _useState19[0], setClientName = _useState19[1];
    var _useState20 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), clientId = _useState20[0], setClientId = _useState20[1];
    var _useState21 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), visionStatementChats = _useState21[0], setVisionStatementChats = _useState21[1];
    var _useState22 = (0, $6iP9u._)((0, $5s1kH.useState)({
        id: "",
        surveyId: null,
        title: "",
        description: "",
        deadline: "",
        activated: "",
        progress: 0,
        timeProgress: 0,
        development: 0,
        effort: 0,
        onTrack: 0,
        status: 0,
        avgGap: 0,
        questions: [],
        surveyRequests: [],
        customerCategoryId: "",
        goals: 0,
        activities: 0,
        behaviors: 0,
        subItemsDue: 0,
        barriersDone: false,
        ownSurvey: false,
        snapshotDone: false,
        translations_answers: {},
        updated: ""
    }), 2), visionStatement = _useState22[0], setVisionStatement = _useState22[1];
    var _useState23 = (0, $6iP9u._)((0, $5s1kH.useState)(), 2), awareness = _useState23[0], setAwareness = _useState23[1];
    var _useState24 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), barriers = _useState24[0], setBarriers = _useState24[1];
    var _useState25 = (0, $6iP9u._)((0, $5s1kH.useState)("coaching"), 2), coachStyle = _useState25[0], setCoachStyle = _useState25[1];
    var _useState26 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), selectAction = _useState26[0], setSelectAction = _useState26[1];
    var setGlobalToast = (0, $e2578e2a154a0e06$export$a247c952d39ea7ea)((0, $89a4535aba887275$export$12972e612ad7cf0));
    var visionStatementId = (0, $bHX26.useParams)().visionStatementId;
    var hash = (0, $bHX26.useLocation)().hash;
    var today = new Date();
    var todayDate = today.toISOString().substring(0, 10);
    var coachView = window.location.pathname.startsWith("/clients/long_term_goal/");
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        // When we reload data after a change of goal or action, check if we need to update viewGoal or viewAction
        if (viewGoal) {
            var foundGoal = false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = goals[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var goal = _step.value;
                    if (viewGoal.id === goal.id) {
                        setViewGoal(goal);
                        foundGoal = true;
                        if (viewAction) {
                            var found = false;
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = goal.actions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var action = _step1.value;
                                    if (viewAction.id === action.id) {
                                        setViewAction(action);
                                        found = true;
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            if (!found) // Assume it is deleted
                            setViewAction(null);
                        }
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (!foundGoal) // Assume it was deleted
            setViewGoal(null);
        } else if (viewActivity) {
            var found1 = false;
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = activities[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var activity = _step2.value;
                    if (viewActivity.id === activity.id) {
                        setViewActivity(activity);
                        found1 = true;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            if (!found1) // Assume it was deleted
            setViewActivity(null);
        } else if (viewBehavior) {
            var found2 = false;
            var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
            try {
                for(var _iterator3 = behaviors[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var behavior = _step3.value;
                    if (viewBehavior.id === behavior.id) {
                        setViewBehavior(behavior);
                        found2 = true;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
            if (!found2) // Assume it was deleted
            setViewBehavior(null);
        }
    }, [
        goals,
        activities,
        behaviors
    ]);
    (0, $5s1kH.useEffect)(function() {
        if (!loading) {
            if (hash) navigateHash();
        }
    }, [
        loading
    ]);
    var changeTab = function(_tab) {
        setTab(_tab);
        (0, $1af830c9fe0316f4$export$a7d4a63c0f4094bf)(_tab);
        if (_tab > 0) {
            setViewGoal(null);
            setViewAction(null);
            setViewActivity(null);
            setViewBehavior(null);
        }
    };
    var vsChat = function(_coachStyle, _temp, msg) {
        toAiThread("vision_statement", visionStatement.id, msg);
    };
    var toAiThread = function(originName, originId, msg) {
        var threadKey = originName + "_" + originId;
        var threadId = chatThreadMap[threadKey];
        var _coachStyle = "coaching";
        if (threadId) navigate('/ai/' + threadId);
        else {
            var message = null;
            if (originName === "vision_statement_goal" && viewGoal) {
                message = lang === "sv" ? "Jag vill prata om mitt delm\xe5l: " : "I want to talk about my Sub-goal: ";
                message += viewGoal.title;
            } else if (originName === "vision_statement_action" && viewAction) {
                message = lang === "sv" ? "Jag vill prata om min uppgift: " : "I want to talk about my action: ";
                message += viewAction.title;
            } else if (originName === "vision_statement_activity" && viewActivity) {
                message = lang === "sv" ? "Jag vill prata om min aktivitet: " : "I want to talk about my activity: ";
                message += viewActivity.title;
            } else if (originName === "vision_statement_behavior" && viewBehavior) {
                message = lang === "sv" ? "Jag vill prata om mitt beteende: " : "I want to talk about my behavior: ";
                message += viewBehavior.title;
            } else if (originName === "vision_statement") {
                if (msg) message = msg;
                _coachStyle = coachStyle;
            }
            (0, $d0129b8cfae32aec$export$f93b11ed7a4960f0)(_coachStyle, "", null, null, null, message, originName, originId);
            navigate("/ai/0");
        }
    };
    var openGoal = function(goalId) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = goals[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var goal = _step.value;
                if (goal.id === goalId) {
                    setViewGoal(goal);
                    return;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var openActivity = function(activityId) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = activities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var activity = _step.value;
                if (activity.id === activityId) {
                    setViewActivity(activity);
                    return;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var openBehavior = function(behaviorId) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = behaviors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var behavior = _step.value;
                if (behavior.id === behaviorId) {
                    setViewBehavior(behavior);
                    return;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var openAction = function(actionId) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = goals[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var goal = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = goal.actions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var action = _step1.value;
                        if (action.id === actionId) {
                            setViewGoal(goal);
                            setViewAction(action);
                            return;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var navigateHash = function() {
        if (hash.startsWith("#goal_")) openGoal(hash.substring(6));
        else if (hash.startsWith("#activity_")) openActivity(hash.substring(10));
        else if (hash.startsWith("#action_")) openAction(hash.substring(8));
        else if (hash.startsWith("#behavior_")) openBehavior(hash.substring(10));
    };
    var getData = function() {
        var url = coachView ? "coach/client/vision_statement/" : "client/vision_statement/";
        api.get(url + visionStatementId).then(function(response) {
            if (response.json.status === "ok") {
                var _visionStatement = response.json.visionStatement;
                setVisionStatement(_visionStatement);
                setGoals(response.json.goals);
                setBehaviors(response.json.behaviors);
                setAwareness(response.json.awareness);
                setBarriers(response.json.barriers);
                setChatThreadMap(response.json.chatThreadMap);
                setActivities(response.json.activities);
                setClientName(response.json.clientName);
                setClientId(response.json.clientId);
                setVisionStatementChats(response.json.visionStatementChats);
                if (_visionStatement.status < (0, $dffa8b95bfc7c1d5$export$f269ae6352e55a31).Created) setEditPart({
                    id: _visionStatement.id,
                    type: "vision_statement",
                    title: _visionStatement.title,
                    description: _visionStatement.description,
                    deadline: _visionStatement.deadline
                });
                if (_visionStatement.barriersDone) setHideAwareness(true);
            } else if (response.json.error) setError(response.json.error);
            else setError("Unknown error");
            setLoading(false);
        });
    };
    if (loading) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (error.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    var saveVisionStatement = function(title, description, deadline) {
        var _visionStatement = (0, $lf4fc._)((0, $hwO3w._)({}, visionStatement), {
            title: title,
            description: description,
            deadline: deadline
        });
        var created = false;
        if (_visionStatement.progress < 10) {
            _visionStatement.progress = 10;
            _visionStatement.onTrack = 1;
            created = true;
            setGlobalToast({
                position: "top-center",
                type: "info",
                infoType: "created",
                text: lang === "sv" ? "M\xe5lbild skapad" : "Goal created"
            });
        } else setGlobalToast({
            text: lang === "sv" ? "\xc4ndringar sparade" : "Changes saved"
        });
        var data = {
            cmd: "save",
            visionStatement: _visionStatement
        };
        api.post("client/vision_statement_update/" + visionStatement.id, data).then(function(response) {
            if (response.json.status === "ok") {
                if (created) // Just created a new Goal. Redirect to dev-plan
                navigate("/dev-plan");
                else {
                    _visionStatement.status = (0, $dffa8b95bfc7c1d5$export$f269ae6352e55a31).Created;
                    setVisionStatement(_visionStatement);
                    setEditPart(null);
                }
            }
        });
    };
    var showVisionStatementPartToast = function() {
        if (!editPart) return;
        var largeToast = false;
        var msg = "";
        if (editPart.id.length > 2) msg = lang === "sv" ? "\xc4ndringar sparade" : "Changes saved";
        else {
            largeToast = true;
            if (editPart.type === "action") msg = lang === "sv" ? "Uppgift skapad" : "Action created";
            else if (editPart.type === "activity") msg = lang === "sv" ? "Aktivitet skapad" : "Activity created";
            else if (editPart.type === "goal") msg = lang === "sv" ? "Delm\xe5l skapat" : "Sub-goal created";
            else return;
        }
        if (largeToast) setGlobalToast({
            position: "top-center",
            type: "info",
            infoType: "created",
            text: msg
        });
        else setGlobalToast({
            text: msg
        });
    };
    var saveVisionStatementPart = function(title, description, deadline, barrier, ifWhen, ifThen, howOften) {
        if (!editPart) {
            alert("No edit part!?");
            return;
        }
        var data = {
            cmd: "save",
            id: editPart.id,
            type: editPart.type,
            goalId: editPart.goalId ? editPart.goalId : "",
            title: title,
            description: description,
            if_when: ifWhen,
            if_then: ifThen,
            barrier: barrier,
            how_often: howOften,
            deadline: deadline
        };
        api.post("client/vision_statement_update_part/" + visionStatement.id, data).then(function(response) {
            if (response.json.status === "ok") {
                showVisionStatementPartToast();
                setEditPart(null);
                getData();
                changeTab(0);
            }
        });
    };
    var updateVisionStatementPartStatus = function(id, type, newStatus) {
        var data = {
            cmd: "updateStatus",
            id: id,
            type: type,
            status: newStatus
        };
        api.post("client/vision_statement_update_part/" + visionStatement.id, data).then(function(response) {
            if (response.json.status === "ok") {
                if (newStatus === 1) {
                    var msg = "?";
                    if (type === "action") msg = lang === "sv" ? "Uppgift slutf\xf6rd!" : "Action completed!";
                    else if (type === "behavior") msg = lang === "sv" ? "Beteende slutf\xf6rt!" : "Behaviour completed!";
                    else if (type === "activity") msg = lang === "sv" ? "Aktivitet slutf\xf6rd!" : "Activity completed!";
                    setGlobalToast({
                        position: "top-center",
                        type: "info",
                        infoType: "created",
                        text: msg
                    });
                }
                setEditPart(null);
                getData();
            }
        });
    };
    var deleteVisionStatementPart = function(id, type) {
        var data = {
            id: id,
            type: type
        };
        api.post("client/vision_statement_delete_part/" + visionStatement.id, data).then(function(response) {
            if (response.json.status === "ok") {
                if (deletePart && deletePart.type === "vision_statement") navigate("/dev-plan");
                else {
                    setDeletePart(null);
                    getData();
                }
            }
        });
    };
    var createFeedbackRequest = function() {
        if (visionStatement.ownSurvey) navigate("/assessments/own/" + visionStatement.id);
        else api.post("client/survey_request/create", {
            survey_id: visionStatement.surveyId,
            vision_statement_id: visionStatement.id
        }).then(function(response) {
            if (response.json.status === "ok") navigate("/feedback/survey/" + response.json.surveyRequestId);
            else alert("Error");
        });
    };
    var doUpdateGoalStatus = function(development, engagement) {
        if (!viewGoal) {
            alert("Error - no goal");
            return;
        }
        var data = {
            id: viewGoal.id,
            development: development,
            engagement: engagement
        };
        api.post("client/vision_statement_goal_status/" + visionStatement.id, data).then(function(response) {
            if (response.json.status === "ok") {
                setGlobalToast({
                    position: "top-center",
                    type: "info",
                    infoType: "created",
                    text: lang === "sv" ? "Delm\xe5l slutf\xf6rt" : "Sub-goal completed!"
                });
                setUpdateGoalStatus(false);
                getData();
            }
        });
    };
    var doUpdateProgress = function(progress, development, effort, onTrack) {
        var data = {
            progress: progress,
            development: development,
            effort: effort,
            onTrack: onTrack
        };
        if (progress === 100) setGlobalToast({
            position: "top-center",
            type: "info",
            infoType: "completed",
            text: lang === "sv" ? "M\xe5lbild slutf\xf6rd!" : "Goal completed!"
        });
        api.post("client/vision_statement_status/" + visionStatement.id, data).then(function(response) {
            if (response.json.status === "ok") {
                setUpdateProgress("");
                getData();
            }
        });
    };
    var reopenVisionStatement = function() {
        setEditPart({
            id: visionStatement.id,
            type: "vision_statement",
            title: visionStatement.title,
            description: visionStatement.description,
            deadline: visionStatement.deadline
        });
    };
    var renderFollowUp = function() {
        if (visionStatement.surveyRequests.length === 0) return;
        var surveyRequest = visionStatement.surveyRequests[0];
        if (!surveyRequest.completed) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "bg-indigo-900 mt-6 p-4 rounded-md relative border-indigo-800 border",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: -25,
                        left: "calc(50% - 4px)"
                    },
                    className: "bg-indigo-900 w-1 h-6"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex gap-x-4 items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "rounded-sm p-2 bg-indigo-800 border-indigo-700 border",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($2acccf4a3a618963$exports))),
                                className: "h-6 w-6",
                                alt: "lock"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex items-center justify-between",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-heading2",
                                children: t("follow-up")
                            })
                        })
                    ]
                }),
                renderStepper(surveyRequest)
            ]
        });
        var nextFeedbackDate = new Date(surveyRequest.created > visionStatement.activated ? surveyRequest.created : visionStatement.activated);
        nextFeedbackDate.setDate(nextFeedbackDate.getDate() + 90);
        var itIsTime = nextFeedbackDate < new Date();
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "bg-indigo-900 mt-6 p-4 rounded-md relative border-indigo-800 border",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: -25,
                        left: "calc(50% - 4px)"
                    },
                    className: "bg-indigo-900 w-1 h-6"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex gap-x-4 items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "rounded-sm p-2 bg-indigo-800 border-indigo-700 border",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($2acccf4a3a618963$exports))),
                                className: "h-6 w-6",
                                alt: "lock"
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-heading2",
                                    children: t("follow-up")
                                }),
                                visionStatement.progress === 100 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e126c82cf1d55289$exports))),
                                    className: "ml-4 h-6 w-6",
                                    alt: "done"
                                })
                            ]
                        })
                    ]
                }),
                visionStatement.progress !== 100 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    children: [
                        itIsTime ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mt-4 p-4 bg-indigo-800 border border-primary-500 rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex items-center gap-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($14768a245153e869$exports))),
                                                className: "h-4 w-4",
                                                alt: "info"
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "z-title3",
                                                children: lang === "sv" ? "Ta pulsen p\xe5 din utveckling" : "Time for fresh feedback"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "Det h\xe4r \xe4r f\xf6r dig - se var du st\xe5r just nu" : "This one's for you - see how far you've come"
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-4 z-body1",
                                    children: lang === "sv" ? "Se hur du utvecklas - ny feedback var 90:e dag" : "Get fresh feedback every 90 days to see your progress"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "mt-2 flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                            className: "h-4 w-4",
                                            alt: "cal"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "ml-1 z-body2",
                                            children: [
                                                lang === "sv" ? "N\xe4sta omg\xe5ng" : "Next round",
                                                ": ",
                                                nextFeedbackDate.toISOString().substring(0, 10)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: itIsTime ? "blueBase" : "outlineWhiteBase",
                            className: "mt-4",
                            disabled: coachView,
                            rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: itIsTime ? (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($005104c16715d72c$exports))),
                                alt: "right"
                            }),
                            onClick: function() {
                                return createFeedbackRequest();
                            },
                            children: t("get-feedback")
                        })
                    ]
                })
            ]
        });
    };
    var deleteBarrier = function(_barrier) {
        var _barriers = [];
        setShowDeleteBarrier(null);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = barriers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _b = _step.value;
                if (_b.text === _barrier.text) {
                    var data = {
                        id: _barrier.text,
                        type: "barrier"
                    };
                    api.post("client/vision_statement_delete_part/" + visionStatement.id, data).then();
                } else _barriers.push(_b);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setBarriers(_barriers);
    };
    var renderActions = function() {
        if (goals.length === 0 && activities.length === 0 && !visionStatement.barriersDone) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "bg-indigo-900 mt-6 p-4 rounded-md flex gap-x-4 items-center relative border-indigo-800 border",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: -25,
                        left: "calc(50% - 4px)"
                    },
                    className: "bg-indigo-900 w-1 h-6"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "rounded-sm p-2 bg-indigo-800 border-indigo-700 border",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($32b62164b12d451c$exports))),
                        className: "h-6 w-6",
                        alt: "lock"
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-heading2",
                            children: lang === "sv" ? "Aktivera" : "Action"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-body1",
                            children: lang === "sv" ? "Slutf\xf6r F\xe5 koll f\xf6r att \xf6ppna det h\xe4r steget" : "Complete Awareness to unlock this section"
                        })
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "bg-indigo-900 mt-6 p-4 rounded-md relative border-indigo-800 border",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: -25,
                        left: "calc(50% - 4px)"
                    },
                    className: "bg-indigo-900 w-1 h-6"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mb-4 flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex gap-x-4 items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "rounded-sm p-2 bg-indigo-800 border-indigo-700 border",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ae5c83ea8e03ae9c$exports))),
                                        className: "h-6 w-6",
                                        alt: "flash"
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-heading2",
                                    children: lang === "sv" ? "Aktivera" : "Action"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "neutralBase",
                            size: "sm",
                            style: {
                                width: "unset"
                            },
                            disabled: coachView,
                            onClick: function() {
                                return setSelectAction(true);
                            },
                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($8035c9bf788700b7$exports))),
                                alt: "info"
                            }),
                            children: lang === "sv" ? "Skapa ny" : "Add action"
                        })
                    ]
                }),
                goals.length === 0 && activities.length === 0 && behaviors.length === 0 && barriers.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "border rounded-sm border-indigo-600 border-dashed p-4",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "mt-4 text-center",
                            children: lang === "sv" ? "L\xe4gg till beteenden, aktiviteter eller delm\xe5l - och b\xf6rja r\xf6ra dig mot m\xe5let" : "Start creating behaviours, activities or sub-goals to make progress on your goal"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            size: "sm",
                            style: {
                                width: "unset"
                            },
                            className: "mt-4 mx-auto",
                            onClick: function() {
                                return setSelectAction(true);
                            },
                            disabled: coachView,
                            children: lang === "sv" ? "B\xf6rja skapa" : "Create action"
                        })
                    ]
                }),
                (0, $XnYkK._)(behaviors).sort(function(a, b) {
                    // Complex! Sort items without deadline last if completed, else first
                    // Sort completed with oldest deadline last
                    // Sort ongoing with oldest deadline first
                    if (a.status !== b.status) return a.status > b.status ? 1 : -1;
                    if (a.status !== 0 && b.status === 0) return -1;
                    if (a.status === 0 && b.status === 0) {
                        // New rule: if due date is same sort by created date
                        if (a.deadline === b.deadline) return a.created > b.created ? 1 : -1;
                        return a.deadline > b.deadline ? 1 : -1;
                    } else return a.deadline > b.deadline ? -1 : 1;
                }).map(function(behavior, i) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "group mt-2 py-4 pr-4 pl-7 bg-indigo-800 rounded-md hover:bg-indigo-700 border-indigo-700 border cursor-pointer relative",
                            onClick: function() {
                                setViewBehavior(behavior);
                                setViewGoal(null);
                                setViewActivity(null);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-action-color bg-lavender-700"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "z-title1",
                                                    children: behavior.title
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        behavior.status === (0, $dffa8b95bfc7c1d5$export$579eee0d55ead4be).Done && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e126c82cf1d55289$exports))),
                                                            className: "h-6 w-6 mr-2",
                                                            alt: "done"
                                                        }),
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                            className: "z-title3",
                                                            children: [
                                                                t("due-date"),
                                                                ":\xa0"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                            className: "text-sm text-gray-300",
                                                            children: behavior.deadline
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        behavior.barrier && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "mt-2 flex items-center gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($81b46490aa13ab72$exports))),
                                                    className: "h-4 w-4",
                                                    alt: "barrier"
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "border border-gray-400 rounded-full py-1 px-4 z-body3 inline-block",
                                                    children: behavior.barrier
                                                })
                                            ]
                                        }),
                                        behavior.status === (0, $dffa8b95bfc7c1d5$export$579eee0d55ead4be).None && visionStatement.progress !== 100 && behavior.deadline <= todayDate && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
                                            message: (0, $db44299b4f245a2a$export$7ccfe9f56c40bcb7)(lang, 'behavior', false)
                                        })
                                    ]
                                })
                            ]
                        })
                    }, "behavior_" + i);
                }),
                (0, $XnYkK._)(goals).sort(function(a, b) {
                    // Complex! Sort items without deadline last if completed, else first
                    // Sort completed with oldest deadline last
                    // Sort ongoing with oldest deadline first
                    if (a.status !== b.status) return a.status > b.status ? 1 : -1;
                    if (a.status !== 0 && b.status === 0) return -1;
                    if (a.status === 0 && b.status === 0) {
                        // New rule: if due date is same sort by created date
                        if (a.deadline === b.deadline) return a.created > b.created ? 1 : -1;
                        return a.deadline > b.deadline ? 1 : -1;
                    } else return a.deadline > b.deadline ? -1 : 1;
                }).map(function(goal, i) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "group mt-2 py-4 pr-4 pl-7 bg-indigo-800 rounded-md hover:bg-indigo-700 border-indigo-700 border cursor-pointer relative",
                            onClick: function() {
                                setViewGoal(goal);
                                setViewActivity(null);
                                setViewBehavior(null);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-action-color bg-royal-600"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-title1",
                                            children: goal.title
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                goal.status === (0, $dffa8b95bfc7c1d5$export$579eee0d55ead4be).Done && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e126c82cf1d55289$exports))),
                                                    className: "h-6 w-6 mr-2",
                                                    alt: "done"
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                    className: "z-title3",
                                                    children: [
                                                        t("due-date"),
                                                        ":\xa0"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                    className: "text-sm text-gray-300",
                                                    children: goal.deadline
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "mt-2",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                            className: "text-gray-100 font-medium",
                                            children: [
                                                lang === "sv" ? "Uppgifter" : "Tasks",
                                                ": "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                            className: "text-gray-300",
                                            children: [
                                                goal.actions.filter(function(g) {
                                                    return g.status === 1;
                                                }).length,
                                                " ",
                                                t("of"),
                                                "\xa0",
                                                goal.actions.length,
                                                " ",
                                                t("completed").toLowerCase()
                                            ]
                                        })
                                    ]
                                }),
                                /* **Single-line alert inside vision Statement page sub-goal list** */ function() {
                                    if (goal.status !== (0, $dffa8b95bfc7c1d5$export$579eee0d55ead4be).None || visionStatement.progress === 100) return null;
                                    var selfDue = goal.deadline <= todayDate;
                                    var subsDue = goal.actions.some(function(goal) {
                                        return goal.deadline <= todayDate && goal.status != 1;
                                    });
                                    if (selfDue && subsDue) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
                                        message: (0, $db44299b4f245a2a$export$7ccfe9f56c40bcb7)(lang, 'subGoal', false)
                                    });
                                    return null;
                                }()
                            ]
                        })
                    }, "goal_" + i);
                }),
                (0, $XnYkK._)(activities).sort(function(a, b) {
                    // Complex! Sort items without deadline last if completed, else first
                    // Sort completed with oldest deadline last
                    // Sort ongoing with oldest deadline first
                    if (a.status !== b.status) return a.status > b.status ? 1 : -1;
                    if (a.status !== 0 && b.status === 0) return -1;
                    if (a.status === 0 && b.status === 0) {
                        // New rule: if due date is same sort by created date
                        if (a.deadline === b.deadline) return a.created > b.created ? 1 : -1;
                        return a.deadline > b.deadline ? 1 : -1;
                    } else return a.deadline > b.deadline ? -1 : 1;
                }).map(function(activity, i) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "group mt-2 py-4 pr-4 pl-7 bg-indigo-800 rounded-md hover:bg-indigo-700 border-indigo-700 border cursor-pointer relative",
                            onClick: function() {
                                setViewActivity(activity);
                                setViewGoal(null);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-action-color " + (activity.fromChat ? "bg-peach-600" : "bg-orange-300")
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-title1",
                                            children: activity.title
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                activity.status === (0, $dffa8b95bfc7c1d5$export$579eee0d55ead4be).Done && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e126c82cf1d55289$exports))),
                                                    className: "h-6 w-6 mr-2",
                                                    alt: "done"
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                    className: "z-title3",
                                                    children: [
                                                        t("due-date"),
                                                        ":\xa0"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                    className: "text-sm text-gray-300",
                                                    children: activity.deadline
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                activity.status === (0, $dffa8b95bfc7c1d5$export$579eee0d55ead4be).None && visionStatement.progress !== 100 && activity.deadline <= todayDate && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
                                    message: (0, $db44299b4f245a2a$export$7ccfe9f56c40bcb7)(lang, 'activity', activity.fromChat)
                                })
                            ]
                        })
                    }, "activity_" + i);
                }),
                barriers.filter(function(b) {
                    return !b.used;
                }).map(function(barrier, index) {
                    var buttonType = index === 0 ? "blueBase" : "neutralBase";
                    var rightIcon = index === 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($005104c16715d72c$exports)));
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2 flex flex-wrap items-center gap-4 justify-between rounded-md border border-indigo-600 border-dashed p-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "border border-gray-400 rounded-full py-1 px-4 z-body3 inline-block",
                                children: barrier.text
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                        buttonType: buttonType,
                                        style: {
                                            width: "unset"
                                        },
                                        disabled: coachView,
                                        onClick: function() {
                                            return setEditPart({
                                                id: "0",
                                                type: "behavior",
                                                title: "",
                                                description: "",
                                                barrier: barrier.text,
                                                deadline: ""
                                            });
                                        },
                                        rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: rightIcon,
                                            alt: "right"
                                        }),
                                        children: t("create-behavior")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                                        alt: "delete",
                                        onClick: function() {
                                            return coachView ? alert("Not allowed") : setShowDeleteBarrier(barrier);
                                        },
                                        className: "p-2 h-8 w-8 ml-4 rounded-full hover:bg-indigo-700 cursor-pointer"
                                    })
                                ]
                            })
                        ]
                    }, "select_barrier_" + index);
                })
            ]
        });
    };
    var saveAwareness = function(_awareness) {
        api.post("client/awareness_save/" + visionStatementId, _awareness).then();
        setAwareness(_awareness);
    };
    var saveBarriers = function(_barriers) {
        var data = {
            barriers: _barriers
        };
        api.post("client/barriers_save/" + visionStatementId, data).then(function(response) {
            if (response.json.status === "ok") setVisionStatement((0, $lf4fc._)((0, $hwO3w._)({}, visionStatement), {
                barriersDone: true
            }));
        });
        setBarriers(_barriers);
    };
    var setSnapshotDone = function(_done) {
        var data = {
            done: _done
        };
        api.post("client/snapshot_done/" + visionStatementId, data).then(function(response) {
            if (response.json.status === "ok") setVisionStatement((0, $lf4fc._)((0, $hwO3w._)({}, visionStatement), {
                snapshotDone: _done
            }));
        });
    };
    var awarenessNextStep = function(cta) {
        if (cta === "barriers") setBarriersOpen(true);
        else if (cta === "editGoal") reopenVisionStatement();
    };
    var goalSnapshotNext = function(next) {
        if (next === "start") navigate("/assessments/own/" + visionStatement.id);
        else if (next === "completed") setTab(1);
        else if (next === "undo") setSnapshotDone(false);
        else if (next === "continue") navigate("/assessments/own/" + visionStatement.id);
    };
    var renderGoalSnapshot = function() {
        var disabled = !awareness;
        var next = "start";
        var nextText = lang === "sv" ? "Starta" : "Start";
        var completed = false;
        var started = false;
        if (!disabled) {
            if (visionStatement.surveyRequests.length > 0) {
                var _surveyRequest = visionStatement.surveyRequests[0];
                if (_surveyRequest.completed) {
                    nextText = lang === "sv" ? "Visa" : "View";
                    next = "completed";
                    started = true;
                    completed = true;
                } else {
                    nextText = lang === "sv" ? "Forts\xe4tt" : "Continue";
                    next = "continue";
                    started = true;
                }
            } else if (visionStatement.snapshotDone) {
                nextText = lang === "sv" ? "\xc5ngra" : "Undo";
                next = "undo";
            }
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "bg-indigo-800 mt-4 p-4 rounded-md hover:bg-indigo-700 border-indigo-700 border " + (disabled ? "opacity-50 pointer-events-none" : ""),
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            completed ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "rounded-sm p-2 bg-success-500 w-11 text-center",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
                                    alt: "check",
                                    className: "h-6 w-6"
                                })
                            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "rounded-sm p-2 bg-indigo-700 border border-indigo-600 w-11 z-title3 text-center",
                                children: "2"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "ml-3",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex items-center gap-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "z-title1",
                                                children: lang === "sv" ? "Nul\xe4ge" : "Goal snapshot"
                                            }),
                                            !completed && visionStatement.snapshotDone && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3d60ab5b0b00a842$export$2e2bcd8739ae039), {
                                                text: t("skipped"),
                                                color: "gray",
                                                size: "small"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "F\xe5 fatt i ditt nul\xe4ge, med input fr\xe5n andra" : "See where you stand, with input from others"
                                    })
                                ]
                            })
                        ]
                    }),
                    !disabled && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex items-center gap-x-4",
                        children: [
                            !started && !visionStatement.snapshotDone && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: "transparentBase",
                                size: "sm",
                                style: {
                                    width: "unset"
                                },
                                onClick: function() {
                                    return setSnapshotDone(true);
                                },
                                children: lang === "sv" ? "Skippa" : "Skip"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: visionStatement.snapshotDone ? "transparentBase" : "blueBase",
                                size: "sm",
                                style: {
                                    width: "unset"
                                },
                                rightIcon: visionStatement.snapshotDone ? null : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                                    alt: "right"
                                }),
                                onClick: function() {
                                    return goalSnapshotNext(next);
                                },
                                children: nextText
                            })
                        ]
                    })
                ]
            })
        });
    };
    var maybeRenderAttention = function() {
        var behind = visionStatement.timeProgress - visionStatement.progress;
        if (behind < 25 || visionStatement.attention === "behind") return null;
        var message = behind.toFixed(0) + "%";
        if (lang === "sv") message += " efter tidsplan - uppdatera din progress";
        else message += " behind timeline - update your progress";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
            message: message
        });
    };
    var weeksLeft = function() {
        if (!visionStatement.deadline) return null;
        var deadline = new Date(visionStatement.deadline);
        var weeksLeft = (deadline.getTime() - today.getTime()) / 604800000;
        if (weeksLeft < 0) return null;
        var msg;
        if (weeksLeft > 0.5 && weeksLeft < 1.5) msg = lang === "sv" ? "vecka kvar" : "week to due date";
        else msg = lang === "sv" ? "veckor kvar" : "weeks to due date";
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-2 flex justify-end z-body3 text-gray-400!",
            children: [
                weeksLeft.toFixed(0),
                "\xa0",
                msg
            ]
        });
    };
    var renderSuccessPlan = function() {
        var barrierStepNumber = visionStatement.ownSurvey ? 3 : 2;
        var barriersDisabled = !awareness;
        if (visionStatement.ownSurvey && !visionStatement.snapshotDone && visionStatement.surveyRequests.length === 0) barriersDisabled = true;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex flex-wrap mt-6 gap-4",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "main-half-col",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "bg-indigo-900 border-indigo-800 border p-4 rounded-md",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "rounded-sm p-2 bg-indigo-800 border-indigo-700 border",
                                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($24d20d648b8f3115$exports))),
                                                        className: "h-6 w-6",
                                                        alt: "awareness"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "z-heading2 ml-4",
                                                    children: lang === "sv" ? "F\xe5 koll" : "Awareness"
                                                }),
                                                visionStatement.barriersDone && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e126c82cf1d55289$exports))),
                                                    className: "h-6 w-6 ml-4",
                                                    alt: "done"
                                                })
                                            ]
                                        }),
                                        visionStatement.barriersDone && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f3995b418b94841f$exports))),
                                            alt: "open",
                                            onClick: function() {
                                                return setHideAwareness(!hideAwareness);
                                            },
                                            className: "h-6 w-6 hover:bg-indigo-700 cursor-pointer rounded-xl" + (hideAwareness ? "" : " rotate-180")
                                        })
                                    ]
                                }),
                                !hideAwareness && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $ae01b41cdc98c1f8$export$2e2bcd8739ae039), {
                                            awareness: awareness,
                                            save: saveAwareness,
                                            nextStep: awarenessNextStep,
                                            visionStatementActivated: visionStatement.activated,
                                            nextBarriers: !visionStatement.ownSurvey,
                                            readOnly: coachView
                                        }),
                                        visionStatement.ownSurvey && renderGoalSnapshot(),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $6a12173a8c20f5d3$export$2e2bcd8739ae039), {
                                            barriers: barriers,
                                            save: saveBarriers,
                                            stepNumber: barrierStepNumber,
                                            disabled: barriersDisabled,
                                            previousActivated: awareness === null || awareness === void 0 ? void 0 : awareness.created,
                                            readOnly: coachView,
                                            done: visionStatement.barriersDone,
                                            open: barriersOpen
                                        })
                                    ]
                                })
                            ]
                        }),
                        renderActions(),
                        renderFollowUp()
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "main-half-col",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "bg-indigo-900 p-4 rounded-md border-indigo-800 border",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "flex items-center gap-x-1",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4280e30fa052e832$exports))),
                                                    alt: "bars",
                                                    className: "h-4 w-4"
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "z-title3",
                                                    children: "Progress"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "z-body3 text-gray-400!",
                                            children: [
                                                visionStatement.progress,
                                                "%"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-1 flex items-center justify-between",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "h-2 rounded-full bg-indigo-700 w-full",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "h-2 rounded-full " + (visionStatement.timeProgress - visionStatement.progress > 25 ? "bg-orange-500" : "bg-aquamarine-500"),
                                            style: {
                                                width: visionStatement.progress + "%"
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "mt-4 flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "flex items-center gap-x-1",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9ef737f3801a68$exports))),
                                                    alt: "bars",
                                                    className: "h-4 w-4"
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "z-title3",
                                                    children: t("timeline")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "z-body3 text-gray-400!",
                                            children: [
                                                visionStatement.timeProgress.toFixed(0),
                                                "%"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-1 flex items-center justify-between",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "h-2 rounded-full bg-indigo-700 w-full",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "h-2 rounded-full bg-primary-500",
                                            style: {
                                                width: visionStatement.timeProgress + "%"
                                            }
                                        })
                                    })
                                }),
                                weeksLeft(),
                                maybeRenderAttention(),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    style: {
                                        width: "unset"
                                    },
                                    className: "mt-8",
                                    disabled: coachView || visionStatement.progress === 100,
                                    onClick: function() {
                                        return setUpdateProgress("update");
                                    },
                                    children: t("update-progress")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "bg-indigo-900 mt-6 p-4 rounded-md border-indigo-800 border",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center gap-x-1",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($78ab1abcd1dade5e$exports))),
                                            alt: "description",
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-title3",
                                            children: t("description")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-body1",
                                    children: visionStatement.description
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "mt-4 flex items-center gap-x-1",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                            alt: "description",
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-title3",
                                            children: t("due-date")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-body1",
                                    children: visionStatement.deadline
                                }),
                                visionStatementChats.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "mt-6 z-title3",
                                    children: lang === "sv" ? "Chat-tr\xe5dar" : "Previous threads"
                                }),
                                visionStatementChats.map(function(visionStatementChat) {
                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "p-2 rounded-md mt-2 z-body1 cursor-pointer bg-indigo-800 hover:bg-indigo-700",
                                            onClick: function() {
                                                return coachView ? alert("Not allowed") : navigate("/ai/" + visionStatementChat.id);
                                            },
                                            children: visionStatementChat.topic
                                        })
                                    }, "vs_chat_" + visionStatementChat.id);
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var renderStepper = function(surveyRequest) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0c396468cfe0bcf3$export$2e2bcd8739ae039), {
            status: surveyRequest.status,
            language: lang,
            multipleRequest: !!surveyRequest.surveyMultipleRecipientId,
            surveyRequestId: surveyRequest.id,
            visionStatementId: visionStatementId,
            readOnly: coachView,
            deadline: surveyRequest.deadline,
            partial: !!surveyRequest.ownSurvey
        });
    };
    var renderFeedbackResult = function() {
        if (visionStatement.surveyRequests.length === 0) return null;
        var surveyRequest = visionStatement.surveyRequests[surveyRequestNr];
        var lastSurveyRequest = visionStatement.surveyRequests[0];
        var scoreSelf = 0;
        var scoreOther = 0;
        var selfNr = 0;
        var otherNr = 0;
        var surveyResult = surveyRequest.surveyResult;
        var questions = [];
        if (surveyRequest.surveyResult) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator = surveyResult.focusAreas[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                    var focusArea = _step.value;
                    try {
                        for(var _iterator1 = focusArea.questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                            var question = _step1.value;
                            questions.push(question);
                            if (question.scoreSelf > 0) {
                                scoreSelf += question.scoreSelf;
                                selfNr++;
                            }
                            if (question.scoreOther > 0) {
                                scoreOther += question.scoreOther;
                                otherNr++;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            if (selfNr) scoreSelf /= selfNr;
            if (otherNr) scoreOther /= otherNr;
        }
        var feedbackType = visionStatement.feedbackType !== undefined ? visionStatement.feedbackType : (0, $2dd33a640256b676$export$d4c0482bf980ef26).FEEDBACK;
        var createNewDisabled = true;
        if (!coachView && (lastSurveyRequest.completed || today > new Date(lastSurveyRequest.deadline))) createNewDisabled = false;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mb-4 flex justify-between",
                    children: [
                        visionStatement.surveyRequests.length > 1 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("select", {
                            className: "z-select small",
                            style: {
                                width: "unset"
                            },
                            onChange: function(e) {
                                return setSurveyRequestNr(parseInt(e.target.value));
                            },
                            value: surveyRequestNr,
                            children: visionStatement.surveyRequests.map(function(surveyRequest, i) {
                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("option", {
                                    value: i,
                                    children: surveyRequest.created.substring(0, 10)
                                }, "sr_" + i);
                            })
                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "transparentBase",
                            size: "sm",
                            disabled: createNewDisabled,
                            onClick: function() {
                                return createFeedbackRequest();
                            },
                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($8035c9bf788700b7$exports))),
                                alt: "info",
                                className: "h-4 w-4 mr-1"
                            }),
                            style: {
                                width: "unset"
                            },
                            children: lang === "sv" ? "F\xe5 ny feedback" : "Get new feedback"
                        })
                    ]
                }),
                surveyRequest.completed && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "bg-indigo-900 rounded-md p-4 border-indigo-800 border",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "font-medium text-gray-100",
                                    children: t("overview")
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "h-4 w-4 rounded-full bg-peach-500",
                                            onClick: function() {
                                                return getData();
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-sm ml-2 text-gray-100",
                                            children: t("self-assessment")
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "h-4 w-4 rounded-full bg-peach-300 ml-4"
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-sm ml-2 text-gray-100",
                                            children: "Feedback"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "main-half-col small mt-2",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $200b3872b8c265f8$export$2e2bcd8739ae039), {
                                value1: scoreSelf,
                                value2: scoreOther,
                                max: surveyResult.nrAnswerOptions,
                                results1: scoreSelf.toFixed(1) + "/" + surveyResult.nrAnswerOptions,
                                results2: scoreOther.toFixed(1) + "/" + surveyResult.nrAnswerOptions
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $847f86c5796e8d1c$export$2e2bcd8739ae039), {
                            questions: questions,
                            lang: lang,
                            surveyResult: surveyResult,
                            clientName: clientName,
                            feedbackType: feedbackType
                        })
                    ]
                }),
                !surveyRequest.completed && surveyRequestNr === 0 && renderStepper(surveyRequest),
                !surveyRequest.completed && surveyRequestNr > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4",
                    children: lang === "sv" ? "Denna feedbackf\xf6rfr\xe5gan blev inte klar" : "This feedback round was not completed"
                }),
                feedbackType !== (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF && surveyResult && (surveyRequest.completed || surveyResult.respondents.length > 0) && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 rounded-md p-4 mb-4 border-indigo-800 border",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-title1",
                            children: t("details")
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($eda3564600df02e0$exports))),
                                    alt: "sent",
                                    className: "h-4 w-4 mr-2"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "z-title3",
                                    children: [
                                        t("request-sent"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "text-sm text-gray-400",
                                    children: [
                                        "\xa0",
                                        surveyRequest.created.substring(0, 10)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                    alt: "cal",
                                    className: "h-4 w-4 mr-2"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "z-title3",
                                    children: [
                                        t("result-created-at"),
                                        ":\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "text-sm text-gray-400",
                                    children: surveyRequest.completed ? surveyRequest.completed.substring(0, 10) : t("pending")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($dd0ccd8d6f00a586$exports))),
                                    alt: "open",
                                    className: "h-4 w-4 mr-2"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "z-title3",
                                    children: [
                                        t("received"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "text-sm text-gray-400",
                                    children: [
                                        "\xa0",
                                        surveyResult.nrOtherResponses,
                                        " ",
                                        t("out-of"),
                                        " ",
                                        surveyResult.respondents.length
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bf234ba9a155a985$exports))),
                                    alt: "who",
                                    className: "h-4 w-4 mr-2"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "z-title3",
                                    children: [
                                        t("requested-from"),
                                        ":\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "text-sm text-gray-400",
                                    children: surveyResult.respondents.map(function(respondent, i) {
                                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                            children: [
                                                i > 0 ? ", " : "",
                                                respondent.name
                                            ]
                                        }, "resp_" + i);
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var renderNextStep = function() {
        if (visionStatement.surveyRequests.length === 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4 rounded-md border border-dashed border-indigo-700 p-4 text-center",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fc5a845596f1e4c9$exports))),
                    alt: "calendar",
                    className: "mt-4 h-8 w-8 mx-auto"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-4 text-gray-300",
                    children: lang === "sv" ? "Skapa en tydlig bild av ditt nul\xe4ge med sj\xe4lvskattning och feedback. Identifiera styrkor och vad du kan utveckla vidare." : "Understand your current state through self-assessment and feedback. Uncover what matters and see where to grow."
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    className: "mt-4 mx-auto",
                    style: {
                        width: "unset"
                    },
                    onClick: function() {
                        return createFeedbackRequest();
                    },
                    children: t("request-feedback")
                })
            ]
        });
        var lastSurveyRequest = visionStatement.surveyRequests[0];
        var today = new Date();
        var deadline = new Date(lastSurveyRequest.deadline);
        if (!lastSurveyRequest.completed) {
            if (deadline < today) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 rounded-md border border-dashed border-indigo-700 p-4 text-center",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fc5a845596f1e4c9$exports))),
                        alt: "calendar",
                        className: "mt-4 h-8 w-8 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 text-gray-300",
                        children: lang === "sv" ? "Din feedbackf\xf6rfr\xe5gan misslyckades." : "Your feedback request failed."
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 text-gray-300",
                        children: lang === "sv" ? "Skicka ny feedback-f\xf6rfr\xe5gan." : "Send new feedback request."
                    })
                ]
            });
        }
        return null;
    };
    var renderFeedback = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                renderFeedbackResult(),
                visionStatement.feedbackType !== (0, $2dd33a640256b676$export$d4c0482bf980ef26).ONLY_SELF && renderNextStep()
            ]
        });
    };
    var changeGoalStatus = function() {
        if (!viewGoal) return;
        if (viewGoal.status === 1) updateVisionStatementPartStatus(viewGoal.id, "goal", 0);
        else setUpdateGoalStatus(true);
    };
    var renderSidePanel = function() {
        if (viewActivity) {
            var popItems = (viewActivity === null || viewActivity === void 0 ? void 0 : viewActivity.status) === 1 ? [
                {
                    title: t("delete"),
                    click: function() {
                        return setDeletePart({
                            id: viewActivity.id,
                            type: "activity"
                        });
                    },
                    img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                        alt: "delete",
                        className: "h-6 w-6"
                    })
                }
            ] : [
                {
                    title: t("edit"),
                    click: function() {
                        return setEditPart({
                            id: viewActivity.id,
                            type: "activity",
                            goalId: viewActivity.id,
                            title: viewActivity.title,
                            description: viewActivity.description,
                            deadline: viewActivity.deadline
                        });
                    },
                    img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8a47c0bf566c4697$exports))),
                        alt: "edit",
                        className: "h-6 w-6"
                    })
                },
                {
                    title: t("delete"),
                    click: function() {
                        return setDeletePart({
                            id: viewActivity.id,
                            type: "activity"
                        });
                    },
                    img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                        alt: "delete",
                        className: "h-6 w-6"
                    })
                }
            ];
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $bdf5b3fa489553d1$export$2e2bcd8739ae039), {
                close: function() {
                    setViewActivity(null);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "z-side-panel-header pl-4 flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                id: "fake_done",
                                label: viewActivity.status === 1 ? t("completed") : t("mark-as-complete"),
                                disabled: coachView,
                                onChange: function() {
                                    return updateVisionStatementPartStatus(viewActivity.id, "activity", viewActivity.status === 1 ? 0 : 1);
                                },
                                checked: viewActivity.status > 0
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                children: !coachView && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                                    items: popItems,
                                    noHover: true,
                                    isVerticalDots: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "z-side-panel-middle",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                className: "border-indigo-800 mt-4"
                            }),
                            viewActivity.status === 0 && visionStatement.progress !== 100 && viewActivity.deadline <= todayDate && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
                                message: (0, $db44299b4f245a2a$export$7ccfe9f56c40bcb7)(lang, 'activity', viewActivity.fromChat),
                                margin: "m-4"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex ml-4 mt-4 gap-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "rounded-md h-12 w-12 flex items-center justify-center " + (viewActivity.fromChat ? "bg-peach-600" : "bg-orange-300"),
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: viewActivity.fromChat ? (0, (/*@__PURE__*/$parcel$interopDefault($4d32ec9694b3412e$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($f2f71f556a64ce0f$exports))),
                                            className: "h-6 w-6",
                                            alt: "ico"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "text-sm text-medium text-" + (viewActivity.fromChat ? "peach-600" : "orange-300"),
                                                children: viewActivity.fromChat ? "AI coaching" : t("activity")
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "z-heading2",
                                                children: viewActivity.title
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "p-4",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-title3 text-gray-300",
                                        children: t("description")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-gray-400 whitespace-pre-line",
                                        children: viewActivity.description
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-title3 text-gray-300 mt-4",
                                        children: t("due-date")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-gray-400",
                                        children: viewActivity.deadline
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mx-4 mt-1",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            disabled: coachView || viewActivity.status === 1,
                            onClick: function() {
                                return toAiThread("vision_statement_activity", viewActivity.id);
                            },
                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($4d32ec9694b3412e$exports))),
                                alt: "ai",
                                className: "h-4 w-4"
                            }),
                            children: t("get-support-ai-assistant")
                        })
                    })
                ]
            });
        } else if (viewBehavior) {
            var popItems1 = (viewBehavior === null || viewBehavior === void 0 ? void 0 : viewBehavior.status) === 1 ? [
                {
                    title: t("delete"),
                    click: function() {
                        return setDeletePart({
                            id: viewBehavior.id,
                            type: "behavior"
                        });
                    },
                    img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                        alt: "delete",
                        className: "h-6 w-6"
                    })
                }
            ] : [
                {
                    title: t("edit"),
                    click: function() {
                        return setEditPart({
                            id: viewBehavior.id,
                            type: "behavior",
                            title: viewBehavior.title,
                            ifWhen: viewBehavior.ifWhen,
                            ifThen: viewBehavior.ifThen,
                            howOften: viewBehavior.howOften,
                            barrier: viewBehavior.barrier,
                            description: "",
                            deadline: viewBehavior.deadline
                        });
                    },
                    img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8a47c0bf566c4697$exports))),
                        alt: "edit",
                        className: "h-6 w-6"
                    })
                },
                {
                    title: t("delete"),
                    click: function() {
                        return setDeletePart({
                            id: viewBehavior.id,
                            type: "behavior"
                        });
                    },
                    img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                        alt: "delete",
                        className: "h-6 w-6"
                    })
                }
            ];
            var showPractiseFrequency = function(freq) {
                if (freq === 2) return lang === "sv" ? "En g\xe5ng per vecka" : "Once a week";
                else if (freq === 1) return lang === "sv" ? "Flera g\xe5nger per vecka" : "Several times a week";
                else return lang === "sv" ? "Varje dag" : "Every day";
            };
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $bdf5b3fa489553d1$export$2e2bcd8739ae039), {
                close: function() {
                    setViewBehavior(null);
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "z-side-panel-header pl-4 flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                id: "fake_done",
                                label: viewBehavior.status === 1 ? t("completed") : t("mark-as-complete"),
                                disabled: coachView,
                                onChange: function() {
                                    return updateVisionStatementPartStatus(viewBehavior.id, "behavior", viewBehavior.status === 1 ? 0 : 1);
                                },
                                checked: viewBehavior.status > 0
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                children: !coachView && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                                    items: popItems1,
                                    noHover: true,
                                    isVerticalDots: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "z-side-panel-middle",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                className: "border-indigo-800 mt-4"
                            }),
                            viewBehavior.status === 0 && viewBehavior.deadline <= todayDate && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
                                message: (0, $db44299b4f245a2a$export$7ccfe9f56c40bcb7)(lang, 'behavior', false),
                                margin: "m-4"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex ml-4 mt-4 gap-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "bg-lavender-700 rounded-md h-12 w-12 flex items-center justify-center",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($18ac665c00e818f6$exports))),
                                            className: "h-6 w-6",
                                            alt: "ico"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "text-sm text-medium text-lavender-700",
                                                children: t("behavior")
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "z-heading2",
                                                children: viewBehavior.title
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "p-4",
                                children: [
                                    viewBehavior.barrier && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "pt-4 z-title3 text-gray-300",
                                                children: t("barrier")
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "mb-4 border border-gray-400 rounded-full py-1 px-4 z-body3 inline-block",
                                                children: viewBehavior.barrier
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-title3 text-gray-300",
                                        children: t("if_when")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-gray-400 whitespace-pre-line",
                                        children: viewBehavior.ifWhen
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "mt-4 z-title3 text-gray-300",
                                        children: t("if_then")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-gray-400 whitespace-pre-line",
                                        children: viewBehavior.ifThen
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "mt-4 z-title3 text-gray-300",
                                        children: lang === "sv" ? "\xd6vningsfrekvens" : "Practise frequency"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-gray-400 whitespace-pre-line",
                                        children: showPractiseFrequency(viewBehavior.howOften)
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "mt-4 z-title3 text-gray-300",
                                        children: t("due-date")
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-gray-400",
                                        children: viewBehavior.deadline
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mx-4 mt-1",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            disabled: coachView || viewBehavior.status === 1,
                            onClick: function() {
                                return toAiThread("vision_statement_behavior", viewBehavior.id);
                            },
                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($4d32ec9694b3412e$exports))),
                                alt: "ai",
                                className: "h-4 w-4"
                            }),
                            children: t("get-support-ai-assistant")
                        })
                    })
                ]
            });
        } else if (viewGoal) {
            if (viewAction) {
                var popItems2 = (viewAction === null || viewAction === void 0 ? void 0 : viewAction.status) === 1 ? [
                    {
                        title: t("delete"),
                        click: function() {
                            return setDeletePart({
                                id: viewAction.id,
                                type: "action"
                            });
                        },
                        img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                            alt: "delete",
                            className: "h-6 w-6"
                        })
                    }
                ] : [
                    {
                        title: t("edit"),
                        click: function() {
                            return setEditPart({
                                id: viewAction.id,
                                type: "action",
                                goalId: viewGoal.id,
                                title: viewAction.title,
                                description: viewAction.description,
                                deadline: viewAction.deadline
                            });
                        },
                        img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8a47c0bf566c4697$exports))),
                            alt: "edit",
                            className: "h-6 w-6"
                        })
                    },
                    {
                        title: t("delete"),
                        click: function() {
                            return setDeletePart({
                                id: viewAction.id,
                                type: "action"
                            });
                        },
                        img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                            alt: "delete",
                            className: "h-6 w-6"
                        })
                    }
                ];
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $bdf5b3fa489553d1$export$2e2bcd8739ae039), {
                    close: function() {
                        setViewGoal(null);
                        setViewAction(null);
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "z-side-panel-header pl-4 flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center gap-x-4",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b831c536d594a009$exports))),
                                            alt: "back",
                                            className: "h-6 w-6 cursor-pointer",
                                            onClick: function() {
                                                return setViewAction(null);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                            id: "fake_done",
                                            label: viewAction.status === 1 ? t("completed") : t("mark-as-complete"),
                                            disabled: coachView,
                                            onChange: function() {
                                                return updateVisionStatementPartStatus(viewAction.id, "action", viewAction.status === 1 ? 0 : 1);
                                            },
                                            checked: viewAction.status > 0
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: !coachView && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                                        items: popItems2,
                                        noHover: true,
                                        isVerticalDots: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "z-side-panel-middle",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                    className: "border-indigo-800 mt-4"
                                }),
                                viewAction.status === 0 && visionStatement.progress !== 100 && viewAction.deadline <= todayDate && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
                                    message: (0, $db44299b4f245a2a$export$7ccfe9f56c40bcb7)(lang, 'action', false),
                                    margin: "m-4"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex ml-4 mt-4 gap-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "bg-royal-700 rounded-md h-12 w-12 flex items-center justify-center",
                                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0fb088b6b5dd1bd5$exports))),
                                                className: "h-6 w-6",
                                                alt: "ico"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "text-sm text-medium text-royal-700",
                                                    children: t("task")
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "z-heading2",
                                                    children: viewAction.title
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "p-4",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-title3 mt-4 text-gray-300",
                                            children: t("description")
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-gray-400 whitespace-pre-line",
                                            children: viewAction.description
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-title3 text-gray-300 mt-4",
                                            children: t("due-date")
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-gray-400",
                                            children: viewAction.deadline
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mx-4 mt-1",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: "blueBase",
                                disabled: coachView || viewAction.status === 1,
                                onClick: function() {
                                    return toAiThread("vision_statement_action", viewAction.id);
                                },
                                leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4d32ec9694b3412e$exports))),
                                    alt: "ai",
                                    className: "h-4 w-4"
                                }),
                                children: t("get-support-ai-assistant")
                            })
                        })
                    ]
                });
            } else {
                var popItems3 = viewGoal.status === 1 ? [
                    {
                        title: t("delete"),
                        click: function() {
                            return setDeletePart({
                                id: viewGoal.id,
                                type: "goal"
                            });
                        },
                        img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                            alt: "delete",
                            className: "h-6 w-6"
                        })
                    }
                ] : [
                    {
                        title: t("edit"),
                        click: function() {
                            return setEditPart({
                                id: viewGoal.id,
                                type: "goal",
                                title: viewGoal.title,
                                description: viewGoal.description,
                                deadline: viewGoal.deadline
                            });
                        },
                        img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8a47c0bf566c4697$exports))),
                            alt: "edit",
                            className: "h-6 w-6"
                        })
                    },
                    {
                        title: t("delete"),
                        click: function() {
                            return setDeletePart({
                                id: viewGoal.id,
                                type: "goal"
                            });
                        },
                        img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                            alt: "delete",
                            className: "h-6 w-6"
                        })
                    }
                ];
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $bdf5b3fa489553d1$export$2e2bcd8739ae039), {
                    close: function() {
                        setViewGoal(null);
                    },
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "z-side-panel-header pl-4 flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                                        id: "fake_done",
                                        disabled: coachView,
                                        label: viewGoal.status === 1 ? t("completed") : t("mark-as-complete"),
                                        onChange: function() {
                                            return changeGoalStatus();
                                        },
                                        checked: viewGoal.status > 0
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    children: !coachView && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                                        items: popItems3,
                                        noHover: true,
                                        isVerticalDots: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "z-side-panel-middle",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                    className: "border-indigo-800 mt-4"
                                }),
                                viewGoal.status === 0 && visionStatement.progress !== 100 && viewGoal.deadline <= todayDate && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
                                    message: (0, $db44299b4f245a2a$export$7ccfe9f56c40bcb7)(lang, 'subGoal', false),
                                    margin: "m-4"
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex ml-4 mt-4 gap-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "bg-royal-700 rounded-md h-12 w-12 flex items-center justify-center",
                                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0fb088b6b5dd1bd5$exports))),
                                                className: "h-6 w-6",
                                                alt: "ico"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "text-sm text-medium text-royal-700",
                                                    children: t("sub-goal")
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "z-heading2",
                                                    children: viewGoal.title
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "p-4",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-title3 mt-4 text-gray-300",
                                            children: t("description")
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-gray-400 whitespace-pre-line",
                                            children: viewGoal.description
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-title3 text-gray-300 mt-4",
                                            children: t("due-date")
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "text-gray-400",
                                            children: viewGoal.deadline
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-4 z-title3 text-gray-100",
                                            children: t("behaviors-and-actions")
                                        }),
                                        (0, $XnYkK._)(viewGoal.actions).sort(function(a, b) {
                                            // Complex! Sort items without deadline last if completed, else first
                                            // Sort completed with oldest deadline last
                                            // Sort ongoing with oldest deadline first
                                            if (a.status !== b.status) return a.status > b.status ? 1 : -1;
                                            if (a.status !== 0 && b.status === 0) return -1;
                                            if (a.status === 0 && b.status === 0) {
                                                // New rule: if due date is same sort by created date 
                                                if (a.deadline === b.deadline) return a.created > b.created ? 1 : -1;
                                                return a.deadline > b.deadline ? 1 : -1;
                                            } else return a.deadline > b.deadline ? -1 : 1;
                                        }).map(function(action) {
                                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "group mt-4 rounded-md p-4 bg-indigo-900 cursor-pointer hover:bg-indigo-800",
                                                onClick: function() {
                                                    return setViewAction(action);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                                className: "flex items-center gap-x-2 z-title1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                                        className: "",
                                                                        children: action.title
                                                                    }),
                                                                    action.status === (0, $dffa8b95bfc7c1d5$export$579eee0d55ead4be).Done && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3d60ab5b0b00a842$export$2e2bcd8739ae039), {
                                                                        text: t("completed"),
                                                                        color: "green",
                                                                        iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
                                                                        size: "small"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                                className: "font-medium text-gray-100",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("span", {
                                                                        className: "z-title3  text-gray-100",
                                                                        children: [
                                                                            t("due-date"),
                                                                            ": "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                                                        className: "text-sm text-gray-300",
                                                                        children: action.deadline
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    action.status === 0 && visionStatement.progress !== 100 && action.deadline <= todayDate && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2d0dc7b0173a4476$export$2e2bcd8739ae039), {
                                                        message: (0, $db44299b4f245a2a$export$7ccfe9f56c40bcb7)(lang, 'activity', false)
                                                    })
                                                ]
                                            }, "action_" + action.id);
                                        }),
                                        viewGoal.actions.length > 0 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "mt-4 text-center",
                                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                                buttonType: "transparentBase",
                                                className: "mt-4 mx-auto cursor-pointer",
                                                style: {
                                                    width: "unset"
                                                },
                                                leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8035c9bf788700b7$exports))),
                                                    alt: "info"
                                                }),
                                                disabled: viewGoal.status === 1,
                                                onClick: function() {
                                                    return setEditPart({
                                                        id: "0",
                                                        type: "action",
                                                        goalId: viewGoal.id,
                                                        title: "",
                                                        description: "",
                                                        deadline: ""
                                                    });
                                                },
                                                children: lang === "sv" ? "L\xe4gg till" : "Add new"
                                            })
                                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                            className: "mt-4 rounded-md border border-dashed border-indigo-700 p-4 text-center",
                                            children: [
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($584664dac616447b$exports))),
                                                    alt: "calendar",
                                                    className: "mt-4 h-8 w-8 mx-auto"
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                    className: "mt-4 text-gray-300",
                                                    children: lang === "sv" ? "Bryt ner ditt delm\xe5l i sm\xe5, konkreta steg." : "Take small steps to reach your sub-goal."
                                                }),
                                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                                    buttonType: "blueBase",
                                                    className: "mt-4 mx-auto",
                                                    style: {
                                                        width: "unset"
                                                    },
                                                    disabled: viewGoal.status === 1,
                                                    onClick: function() {
                                                        return setEditPart({
                                                            id: "0",
                                                            type: "action",
                                                            goalId: viewGoal.id,
                                                            title: "",
                                                            description: "",
                                                            deadline: ""
                                                        });
                                                    },
                                                    children: [
                                                        "+ ",
                                                        lang === "sv" ? "L\xe4gg till" : "Add new"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mx-4 mt-1",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: viewGoal.actions.length > 0 ? "blueBase" : "outlineWhiteBase",
                                onClick: function() {
                                    return toAiThread("vision_statement_goal", viewGoal.id);
                                },
                                leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4d32ec9694b3412e$exports))),
                                    alt: "ai",
                                    className: "h-4 w-4"
                                }),
                                disabled: viewGoal.status === 1,
                                children: t("get-support-ai-assistant")
                            })
                        })
                    ]
                });
            }
        }
    };
    var startVoice = function() {
        (0, $d0129b8cfae32aec$export$f93b11ed7a4960f0)(coachStyle, "voice", null, null, null, null);
        navigate("/ai/0");
    };
    var renderCreated = function() {
        var items = [
            {
                title: t("overview"),
                callback: function() {
                    return changeTab(0);
                }
            },
            {
                title: "Feedback",
                callback: function() {
                    return changeTab(1);
                }
            }
        ];
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-6 flex flex-row justify-between items-center gap-y-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex flex-row md:justify-between gap-x-2 items-center",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "bg-indigo-900 rounded-sm p-2",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cf4f087e7dff53f9$exports))),
                                        alt: "rings",
                                        className: "h-8 w-8"
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-h2",
                                    children: visionStatement.title
                                }),
                                visionStatement.progress === 100 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3d60ab5b0b00a842$export$2e2bcd8739ae039), {
                                    text: t("completed"),
                                    color: "green",
                                    iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
                                    size: "small"
                                }) : visionStatement.attention ? (0, $b841e7314e3d419d$export$31387e6762a6770a)(visionStatement.attention, lang) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {})
                            ]
                        }),
                        !coachView && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            children: visionStatement.progress === 100 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                                isVerticalDots: true,
                                items: [
                                    {
                                        title: t("mark-as-incomplete"),
                                        click: function() {
                                            return setUpdateProgress(visionStatement.progress === 100 ? "update" : "done");
                                        },
                                        img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($12285823891ebef0$exports))),
                                            alt: "edit",
                                            className: "h-4 w-4"
                                        })
                                    },
                                    {
                                        title: t("delete"),
                                        click: function() {
                                            return setDeletePart({
                                                type: "vision_statement",
                                                id: "0"
                                            });
                                        },
                                        img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                                            alt: "edit",
                                            className: "h-4 w-4"
                                        })
                                    }
                                ]
                            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c3247f9fe2800c18$export$2e2bcd8739ae039), {
                                isVerticalDots: true,
                                items: [
                                    {
                                        title: lang === "sv" ? "\xc4ndra" : "Edit",
                                        click: function() {
                                            return reopenVisionStatement();
                                        },
                                        img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8a47c0bf566c4697$exports))),
                                            alt: "edit",
                                            className: "h-4 w-4"
                                        })
                                    },
                                    {
                                        title: t("mark-as-complete"),
                                        click: function() {
                                            return setUpdateProgress(visionStatement.progress === 100 ? "update" : "done");
                                        },
                                        img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($12285823891ebef0$exports))),
                                            alt: "edit",
                                            className: "h-4 w-4"
                                        })
                                    },
                                    {
                                        title: t("delete"),
                                        click: function() {
                                            return setDeletePart({
                                                type: "vision_statement",
                                                id: "0"
                                            });
                                        },
                                        img: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($95c80bab064dff3e$exports))),
                                            alt: "edit",
                                            className: "h-4 w-4"
                                        })
                                    }
                                ]
                            })
                        })
                    ]
                }),
                visionStatement.progress < 10 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-8 text-gray-400",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "blueBase",
                        className: "mt-4",
                        onClick: function() {
                            return reopenVisionStatement();
                        },
                        children: lang === "sv" ? "Slutf\xf6r din m\xe5lbild" : "Finalize your Goal"
                    })
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-6",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c8483606065062df$export$2e2bcd8739ae039), {
                                active: tab,
                                items: items
                            })
                        }),
                        tab === 0 && renderSuccessPlan(),
                        tab === 1 && renderFeedback(),
                        (viewGoal || viewActivity || viewBehavior) && renderSidePanel(),
                        updateProgress.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $068b0e3140b308b6$export$2e2bcd8739ae039), {
                            visionStatement: visionStatement,
                            close: function() {
                                return setUpdateProgress("");
                            },
                            type: updateProgress,
                            lang: lang,
                            save: doUpdateProgress,
                            t: t
                        }),
                        updateGoalStatus && viewGoal && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $775d2bb3f3754db0$export$2e2bcd8739ae039), {
                            goal: viewGoal,
                            close: function() {
                                return setUpdateGoalStatus(false);
                            },
                            lang: lang,
                            save: doUpdateGoalStatus,
                            t: t
                        }),
                        tab === 0 && !coachView && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-chat-bottom ml-0 md:ml-16 ",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-chat-bottom-box bg-indigo-900",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $f6e11d7e911b44d5$export$2e2bcd8739ae039), {
                                            sendToOtherPage: true,
                                            handleSendMessage: function(msg) {
                                                return vsChat(coachStyle, "", msg);
                                            },
                                            onHeightChange: function() {},
                                            setCoachStyle: setCoachStyle,
                                            coachStyle: coachStyle,
                                            startVoice: startVoice,
                                            placeholder: lang === "sv" ? "Skriv n\xe5got f\xf6r att starta en coachsession p\xe5 m\xe5lbilden..." : "Ask anything to start a coaching session on your Goal...",
                                            emmaThinking: false
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "h-32",
                                    children: "\xa0"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var renderEditPart = function() {
        if (editPart) {
            var save = editPart.type === "vision_statement" ? saveVisionStatement : saveVisionStatementPart;
            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e2435b6138b3d161$export$2e2bcd8739ae039), {
                visionStatement: visionStatement,
                editPart: editPart,
                viewGoal: viewGoal,
                clientName: clientName,
                save: save,
                close: function() {
                    return setEditPart(null);
                }
            });
        }
    };
    var renderDeletePart = function() {
        if (deletePart) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: function() {
                return setDeletePart(null);
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return setDeletePart(null);
                    },
                    children: [
                        t("delete"),
                        "?"
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: [
                        lang === "sv" ? "Detta g\xe5r inte att \xe5ngra." : "This can not be undone.",
                        deletePart.type === "vision_statement" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
                            children: lang === "sv" ? " Allt du har gjort inom detta delm\xe5l kommer att raderas." : "Everything within this Goal will be deleted."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex gap-x-4 w-full",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "w-1/2",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    onClick: function() {
                                        return setDeletePart(null);
                                    },
                                    children: "Cancel"
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "w-1/2",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "dangerBase",
                                    onClick: function() {
                                        return deleteVisionStatementPart(deletePart.id, deletePart.type);
                                    },
                                    children: "Delete"
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    var showSelectAction = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: function() {
                return setSelectAction(false);
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return setSelectAction(false);
                    },
                    children: lang === "sv" ? "V\xe4lj vad du vill l\xe4gga till" : "Choose an action"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "border border-lavender-700 rounded-md flex hover:bg-indigo-800 cursor-pointer",
                            onClick: function() {
                                setSelectAction(false);
                                setEditPart({
                                    id: "0",
                                    type: "behavior",
                                    title: "",
                                    description: "",
                                    deadline: "",
                                    barriers: barriers
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "bg-lavender-700 w-14 flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($18ac665c00e818f6$exports))),
                                        className: "h-6 w-6",
                                        alt: "ico"
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "p-4",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-title2",
                                            children: t("behavior")
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-body2",
                                            children: lang === "sv" ? "Tr\xe4na p\xe5 ett beteende i vardagen" : "Practice a behaviour you want to make click"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 border border-orange-300 rounded-md flex hover:bg-indigo-800 cursor-pointer",
                            onClick: function() {
                                setSelectAction(false);
                                setEditPart({
                                    id: "0",
                                    type: "activity",
                                    title: "",
                                    description: "",
                                    deadline: ""
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "bg-orange-300 w-14 flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f2f71f556a64ce0f$exports))),
                                        className: "h-6 w-6",
                                        alt: "activity"
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "p-4",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-title2",
                                            children: t("activity")
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-body2",
                                            children: lang === "sv" ? "En konkret sak du kan bocka av" : "Take a one-off step toward your goal"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 border border-royal-600 rounded-md flex hover:bg-indigo-800 cursor-pointer",
                            onClick: function() {
                                setSelectAction(false);
                                setEditPart({
                                    id: "0",
                                    type: "goal",
                                    title: "",
                                    description: "",
                                    deadline: ""
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "bg-royal-600 w-14 flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0fb088b6b5dd1bd5$exports))),
                                        className: "h-6 w-6",
                                        alt: "activity"
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "p-4",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-title2",
                                            children: t("sub-goal")
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "z-body2",
                                            children: lang === "sv" ? "Dela upp din m\xe5lbild i mindre delar" : "Break your goal into smaller goals"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var renderDeleteBarrier = function() {
        if (showDeleteBarrier) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: function() {
                return setShowDeleteBarrier(null);
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return setShowDeleteBarrier(null);
                    },
                    children: lang === "sv" ? "Radera hinder?" : "Delete barrier?"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-body1",
                        children: lang === "sv" ? "Du kan alltid redigera hinder senare" : "You can always edit your barriers later"
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "flex gap-x-2 w-full",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: "outlineWhiteBase",
                                onClick: function() {
                                    return setShowDeleteBarrier(null);
                                },
                                children: t("cancel")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                buttonType: "blueBase",
                                onClick: function() {
                                    return deleteBarrier(showDeleteBarrier);
                                },
                                children: t("delete")
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col",
        children: [
            coachView ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: lang === "sv" ? "Hem" : "Home",
                        url: "/"
                    },
                    {
                        name: t("my-clients"),
                        url: "/clients"
                    },
                    {
                        name: clientName,
                        url: "/clients/" + clientId
                    },
                    {
                        name: t("vision_statement")
                    }
                ]
            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: t("long-term-goals"),
                        url: "/dev-plan"
                    },
                    {
                        name: t("vision_statement")
                    }
                ]
            }),
            renderCreated(),
            renderEditPart(),
            deletePart && renderDeletePart(),
            selectAction && showSelectAction(),
            showDeleteBarrier && renderDeleteBarrier()
        ]
    });
};
var $8fbc1cd7b0d38c80$export$2e2bcd8739ae039 = $8fbc1cd7b0d38c80$var$LongTermGoal;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");



var $5Epmf = parcelRequire("5Epmf");

var $97cbf427d0950812$export$2e2bcd8739ae039 = function RecordSound() {
    "use strict";
    var _this = this;
    (0, $5Epmf._)(this, RecordSound);
    this.mediaRecorder = null;
    this.session = 0;
    this.startTime = null;
    this.duration = 0;
    this.recording = false;
    this.onVolume = null;
    this.start = function(clientToken, recordingId, onStart, onSendSound, onVolume) {
        _this.onVolume = onVolume;
        navigator.mediaDevices.getUserMedia({
            audio: true
        }).then(function(mediaStream) {
            // const stream = new MediaStream(mediaStream);
            var stream = new MediaStream();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = mediaStream.getAudioTracks()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var track = _step.value;
                    console.log('Added track');
                    console.log(track);
                    stream.addTrack(track);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            _this.recording = true;
            _this.measureVolume(stream);
            // https://developer.mozilla.org/en-US/docs/Web/API/MediaRecorder
            _this.mediaRecorder = new MediaRecorder(stream);
            _this.mediaRecorder.start(2000);
            var url = (0, $632c75b97b900307$export$1630b5343357e8b5).SYSTEM === "development" ? "http://localhost:8070/api/client/record_stream/" : "https://backoffice.zebrain.se/api/client/record_stream/";
            _this.mediaRecorder.ondataavailable = function(e) {
                var formData = new FormData();
                if (_this.startTime) {
                    var now = new Date();
                    _this.duration = now.getTime() - _this.startTime.getTime();
                    onSendSound(_this.duration);
                }
                formData.append('audio', e.data);
                formData.append('session', '' + _this.session);
                formData.append('duration', _this.duration.toFixed(1));
                fetch(url + recordingId, {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + clientToken
                    },
                    body: formData
                }).then(function(response) {
                    console.log(response);
                });
            };
            _this.mediaRecorder.onstart = function(e) {
                onStart();
                _this.startTime = new Date();
            };
            _this.mediaRecorder.onstop = function(e) {
                _this.session++;
                _this.recording = false;
                if (_this.startTime) {
                    var now = new Date();
                    _this.duration = now.getTime() - _this.startTime.getTime();
                }
                var url = (0, $632c75b97b900307$export$1630b5343357e8b5).SYSTEM === "development" ? "http://localhost:8070/api/client/record_stop/" : "https://backoffice.zebrain.se/api/client/record_stop/";
                url += recordingId + "?duration=" + _this.duration;
                fetch(url, {
                    method: "GET",
                    headers: {
                        Authorization: "Bearer " + clientToken
                    }
                }).then(function(response) {
                    console.log(response);
                });
                stream.getTracks().forEach(function(track) {
                    if (track.readyState === 'live') {
                        track.stop();
                        console.log(track.kind + ' stopped');
                    } else console.log(track.kind + ': ' + track.readyState);
                });
            };
        });
    };
    this.stop = function() {
        if (_this.mediaRecorder) _this.mediaRecorder.stop();
        else console.log("Missing mediaRecorder");
    };
    this.measureVolume = function(stream) {
        var audioContext = new AudioContext();
        var mediaStreamSource = audioContext.createMediaStreamSource(stream);
        var destination = audioContext.createMediaStreamDestination();
        var analyser = audioContext.createAnalyser();
        analyser.connect(destination);
        var audio = document.createElement('audio');
        audio.srcObject = destination.stream;
        audio.autoplay = false;
        mediaStreamSource.connect(destination);
        mediaStreamSource.connect(analyser);
        analyser.fftSize = 1024;
        var bufferLength = analyser.frequencyBinCount;
        var dataArray = new Uint8Array(bufferLength);
        requestAnimationFrame(function() {
            _this.drawSound(analyser, bufferLength, dataArray);
        });
    };
    this.drawSound = function(analyser, bufferLength, dataArray) {
        if (!_this.recording) return;
        analyser.getByteFrequencyData(dataArray);
        var total = 0;
        for(var i = 0; i < bufferLength; i++)total += dataArray[i];
        var volume = Math.sqrt(total / bufferLength) * 8;
        if (_this.onVolume) _this.onVolume(volume);
        requestAnimationFrame(function() {
            _this.drawSound(analyser, bufferLength, dataArray);
        });
    };
    console.log("Initialized RecordSound");
};




// const recordSound = new RecordSound();
var $b9066482124566cb$var$RecordingStatusEnum = /*#__PURE__*/ function(RecordingStatusEnum) {
    RecordingStatusEnum[RecordingStatusEnum["STOPPED"] = 0] = "STOPPED";
    RecordingStatusEnum[RecordingStatusEnum["INITIALIZING"] = 1] = "INITIALIZING";
    RecordingStatusEnum[RecordingStatusEnum["STARTED"] = 2] = "STARTED";
    return RecordingStatusEnum;
}($b9066482124566cb$var$RecordingStatusEnum || {});
var $b9066482124566cb$var$TeamRecordings = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), recordings = _useState2[0], setRecordings = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), recordingId = _useState3[0], setRecordingId = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), duration = _useState4[0], setDuration = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), volume = _useState5[0], setVolume = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), recordingStatus = _useState6[0], setRecordingStatus = _useState6[1];
    var recordSound = (0, $5s1kH.useRef)(null);
    (0, $5s1kH.useEffect)(function() {
        recordSound.current = new (0, $97cbf427d0950812$export$2e2bcd8739ae039)();
        setRecordingId("t_" + new Date().getTime());
        getData();
    }, []);
    var getData = function() {
        api.get("client/recordings").then(function(response) {
            if (response.json.error) setError(response.json.error);
            else {
                setRecordings(response.json.recordings);
                setLoaded(true);
            }
        }).catch(function(error) {
            alert("Unknown error (http status " + error.response.status + ")");
        });
    };
    if (error.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    var onRecordingStart = function() {
        setRecordingStatus(2);
    };
    var onSendSound = function(_duration) {
        setDuration(_duration);
    };
    var onVolume = function(_volume) {
        setVolume(_volume);
    };
    var handleRecord = function() {
        if (recordingStatus === 2) {
            var _recordSound_current;
            setRecordingStatus(0);
            (_recordSound_current = recordSound.current) === null || _recordSound_current === void 0 ? void 0 : _recordSound_current.stop();
            setTimeout(function() {
                navigate("/team/recording/" + recordingId);
            }, 600);
        } else if (recordingStatus === 0) {
            var _recordSound_current1;
            setRecordingStatus(1);
            if (api.apiToken) (_recordSound_current1 = recordSound.current) === null || _recordSound_current1 === void 0 ? void 0 : _recordSound_current1.start(api.apiToken, recordingId, onRecordingStart, onSendSound, onVolume);
            else alert("Missing client token");
        }
    };
    var showRecordingStatus = function() {
        if (recordingStatus === 0) return "Start a new recording";
        else if (recordingStatus === 1) return "Please wait, initializing recording...";
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex justify-between gap-x-4 items-center",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-body1",
                    children: "Stop recording"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "z-body1 w-20",
                    children: [
                        (duration / 1000).toFixed(1),
                        " s"
                    ]
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    style: {
                        width: 100,
                        height: 12
                    },
                    className: "bg-gray-800",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        style: {
                            width: volume,
                            height: 12
                        },
                        className: "bg-aquamarine-400"
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: "Team",
                        url: "/team"
                    },
                    {
                        name: "Recordings"
                    }
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4 z-heading2",
                children: "New recording"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "main-half-col bg-indigo-900 px-4 py-2 mt-2 rounded-md flex items-center cursor-pointer",
                onClick: function() {
                    return handleRecord();
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: recordingStatus === 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($983e7e4ab189c038$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($ce970e80edefa8a8$exports))),
                        alt: "record",
                        className: "h-8 w-8"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "ml-4 z-body1",
                        children: showRecordingStatus()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4 z-heading2",
                children: "Recordings"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "main-half-col bg-indigo-900 px-4 py-2 mt-2 rounded-md",
                children: [
                    recordings.map(function(recording, i) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "my-2 cursor-pointer",
                            onClick: function() {
                                return navigate('/team/recording/' + recording.id);
                            },
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "flex items-center justify-between",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "z-title1",
                                        children: recording.name
                                    })
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                    className: "z-body2",
                                    children: [
                                        "Created: ",
                                        recording.created.substring(0, 16).replace("T", " ")
                                    ]
                                })
                            ]
                        }, "recording_" + i);
                    }),
                    recordings.length === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-body1",
                        children: "You have no recordings so far"
                    })
                ]
            })
        ]
    });
};
var $b9066482124566cb$export$2e2bcd8739ae039 = $b9066482124566cb$var$TeamRecordings;



var $lFIaz = parcelRequire("lFIaz");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");

var $3SMYb = parcelRequire("3SMYb");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");





var $66f6ea7ccb99dc70$var$TeamRecording = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), query = _useState2[0], setQuery = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), previousQuery = _useState3[0], setPreviousQuery = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), answer = _useState4[0], setAnswer = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), recording = _useState5[0], setRecording = _useState5[1];
    var recordingId = (0, $bHX26.useParams)().recordingId;
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get("client/recording/" + recordingId).then(function(response) {
            if (response.json.error) setError(response.json.error);
            else {
                setRecording(response.json.recording);
                setLoaded(true);
            }
        }).catch(function(error) {
            alert("Unknown error (http status " + error.response.status + ")");
        });
    };
    var deleteRecording = function() {
        var status = confirm("Are you sure you want to delete this recording?");
        if (status) api.get("client/recording_delete/" + recordingId).then(function() {
            navigate('/team/recordings');
        });
    };
    if (error.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (!recording) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Missing recording - contact support..."
    });
    var transcribe = function() {
        setRecording((0, $lf4fc._)((0, $hwO3w._)({}, recording), {
            status: 2
        }));
        api.get("client/recording_transcribe/" + recordingId).then(function(response) {
            setRecording(response.json.recording);
        });
    };
    var showStatus = function() {
        if (recording.status === 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "z-title2",
            children: "Recording !?"
        });
        else if (recording.status === 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                buttonType: "blueBase",
                onClick: function() {
                    return transcribe();
                },
                children: "Translate this recording into text"
            })
        });
        else if (recording.status === 2) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
            className: "z-body1",
            children: "Transcribing, please wait. This could take some time..."
        });
        else if (recording.status === 3) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-title2",
                    children: "Transcription:"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "z-body1 mt-4",
                    children: recording.transcription
                })
            ]
        });
    };
    function handleStream(reader) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $lFIaz._)(function() {
            var done, value, streamResponse, finalResponse, decoder, ref, data, responseData, aiResponse;
            return (0, $3SMYb._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        streamResponse = "";
                        finalResponse = "";
                        decoder = new TextDecoder();
                        _state.label = 1;
                    case 1:
                        if (!!done) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            reader.read()
                        ];
                    case 2:
                        ref = _state.sent(), value = ref.value, done = ref.done, ref;
                        if (done) {
                            console.log("Closed stream. finalResponse is " + finalResponse.length + " bytes");
                            if (finalResponse.length > 0) try {
                                // console.log(finalResponse);
                                data = JSON.parse(finalResponse);
                                if (data.aiResponse) setAnswer(data.aiResponse);
                                else console.log(data);
                            } catch (error) {
                                console.log(error);
                            }
                            return [
                                2
                            ];
                        }
                        responseData = decoder.decode(value);
                        // console.log("Got data: " + responseData);
                        // If we have received start of finalResponse, add to it
                        if (finalResponse.length > 0) {
                            console.log('Adding ' + responseData.length + " bytes to finalResponse which is " + finalResponse.length);
                            finalResponse += responseData;
                        } else {
                            // Look for position of {"aiResponse". If we find that, this is the start of finalResponse
                            aiResponse = responseData.indexOf('{"aiResponse"');
                            if (aiResponse > -1) {
                                console.log("Found start of final message at " + aiResponse);
                                finalResponse = responseData.substring(aiResponse);
                            }
                        }
                        if (finalResponse.length === 0) {
                            if (responseData.startsWith("_-_")) setAnswer(responseData.substring(3));
                            else {
                                streamResponse += responseData;
                                setAnswer(streamResponse);
                            }
                        }
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    var sendQuery = function() {
        var data = {
            query: query,
            recordingId: recordingId
        };
        setPreviousQuery(query);
        setQuery("");
        api.post("fast_api/client/query_transcription", data, [], false, true).then(function(response) {
            if (response.response.ok) {
                if (response.response.body) handleStream(response.response.body.getReader()).then(function() {
                    console.log('AI done');
                });
            } else alert(response.response.statusText);
        }).catch(function(error) {
            // This should be displayed as alert from api handler
            console.log(error);
        });
    };
    var renderQueryAi = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "bg-indigo-900 px-4 py-2 mt-2 rounded-md",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex gap-x-2",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                            type: "text",
                            value: query,
                            className: "z-input",
                            onChange: function(e) {
                                return setQuery(e.target.value);
                            },
                            onKeyUp: function(e) {
                                return e.key === "Enter" && sendQuery();
                            },
                            placeholder: "Ask something about this transcription..."
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            size: "sm",
                            disabled: query.length === 0,
                            style: {
                                width: "unset"
                            },
                            onClick: function() {
                                return sendQuery();
                            },
                            children: "Ask"
                        })
                    ]
                }),
                (answer.length > 0 || previousQuery.length > 0) && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                            children: [
                                "Q: ",
                                previousQuery
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "mt-4 z-body1 whitespace-pre-line",
                            children: answer
                        })
                    ]
                })
            ]
        });
    };
    var showSize = function() {
        if (recording.lengthBytes < 10000) return recording.lengthBytes + " bytes";
        else if (recording.lengthBytes < 1000000) return (recording.lengthBytes / 1024).toFixed(0) + " kB";
        else return (recording.lengthBytes / 1048576).toFixed(1) + " MB";
    };
    var showLength = function() {
        return (recording.lengthTime / 1000).toFixed(1) + " s";
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: "Team",
                        url: "/team"
                    },
                    {
                        name: "Recordings",
                        url: "/team/recordings"
                    },
                    {
                        name: "Recording"
                    }
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-4 z-heading2",
                children: "Recording"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex flex-wrap gap-x-4",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "main-half-col",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "bg-indigo-900 p-4 mt-2 rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            "Name: ",
                                            recording.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            "Size: ",
                                            showSize()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            "Length: ",
                                            showLength()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            "Created: ",
                                            recording.created.substring(0, 16).replace("T", " ")
                                        ]
                                    }),
                                    recording.url && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "mt-4",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("audio", {
                                            controls: true,
                                            preload: "auto",
                                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("source", {
                                                src: recording.url,
                                                type: "audio/webm"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "w-full flex justtify-end mt-4",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                            buttonType: "dangerBase",
                                            size: "sm",
                                            style: {
                                                width: "unset"
                                            },
                                            onClick: function() {
                                                return deleteRecording();
                                            },
                                            children: "Delete recording"
                                        })
                                    })
                                ]
                            }),
                            recording.status === 3 && renderQueryAi()
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "main-half-col bg-indigo-900 p-4 mt-2 rounded-md",
                        children: showStatus()
                    })
                ]
            })
        ]
    });
};
var $66f6ea7ccb99dc70$export$2e2bcd8739ae039 = $66f6ea7ccb99dc70$var$TeamRecording;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");





var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");


var $bHX26 = parcelRequire("bHX26");






var $acb6bdd4e5445553$exports = {};
$acb6bdd4e5445553$exports = $parcel$resolve("lTOPf");











var $3af88be99163a419$var$SelfAssessmentRecipientPage = function(props) {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showInfoModal = _useState1[0], setShowInfoModal = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), waiting = _useState2[0], setWaiting = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), fakeDone = _useState3[0], setFakeDone = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), done = _useState4[0], setDone = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), demo = _useState5[0], setDemo = _useState5[1];
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), feedbackUsers = _useState6[0], setFeedbackUsers = _useState6[1];
    var _useState7 = (0, $6iP9u._)((0, $5s1kH.useState)("-"), 2), deadline = _useState7[0], setDeadline = _useState7[1];
    var _useState8 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), answered = _useState8[0], setAnswered = _useState8[1];
    var _useState9 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState9[0], setError = _useState9[1];
    var _useState10 = (0, $6iP9u._)((0, $5s1kH.useState)(props.visionStatement.surveyRequests[0].id), 2), id = _useState10[0], setId = _useState10[1];
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get("client/survey_request_invite/" + id).then(function(response) {
            if (response.json.status === "ok") {
                setFeedbackUsers(response.json.feedbackUsers);
                setDeadline(response.json.deadline);
                setAnswered(response.json.answered);
                setDemo(response.json.demo);
            } else if (response.json.error) setError(response.json.error);
            else setError("Unknown error");
            setLoading(false);
        });
    };
    var submit = function() {
        var data = {
            feedbackUsers: feedbackUsers,
            fake_done: fakeDone
        };
        setWaiting(true);
        api.post("client/survey_request_feedback/" + id, data).then(function(response) {
            if (response.json.status === "ok") {
                setDone(true);
                props.done();
            }
            setWaiting(false);
        });
    };
    if (loading) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (done) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-4 text-center mx-auto",
                style: {
                    width: 358
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($acb6bdd4e5445553$exports))),
                        alt: "done",
                        className: "mt-10 w-20 h-20 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-6 z-heading1",
                        children: t("feedback-request-sent")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2 text-gray-300",
                        children: [
                            lang === "sv" ? "Bra jobbat! Vi h\xf6r av oss n\xe4r ditt feedbackresultat \xe4r redo, senast " : "Well done! We\u2019ll reach out when the feedback result is ready, likely by ",
                            deadline.substring(0, 10),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-center mx-auto",
                style: {
                    width: 300
                },
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        style: {
                            width: "unset"
                        },
                        className: "mx-auto",
                        onClick: function() {
                            return navigate('/dev-plan/long-term-goal/' + props.visionStatement.id);
                        },
                        children: lang === "sv" ? "\xc5terg\xe5 till m\xe5let" : "Return to goal"
                    })
                })
            })
        ]
    });
    var formValid = function() {
        var foundSelected = feedbackUsers.filter(function(f) {
            return f.selected;
        }).length;
        return foundSelected + answered >= 3;
    };
    var changeFeedbackUser = function(email, action) {
        var _feedbackUsers = (0, $XnYkK._)(feedbackUsers);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _feedbackUsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var feedbackUser = _step.value;
                if (feedbackUser.email === email) {
                    if (action === "selected") feedbackUser.selected = !feedbackUser.selected;
                    else if (action === "favorite") feedbackUser.favorite = !feedbackUser.favorite;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setFeedbackUsers(_feedbackUsers);
    };
    var renderInfoModel = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: showInfoModal,
            onClose: closeInfoModel,
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: closeInfoModel,
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                        className: "z-heading1 text-white",
                        children: t("feedback-request")
                    })
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "mb-4 z-body1",
                            children: t("self-assessment-recipient-info1")
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                            className: "z-body1",
                            children: t("self-assessment-recipient-info2")
                        })
                    ]
                })
            ]
        });
    };
    var closeInfoModel = function() {
        setShowInfoModal(false);
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex items-center mt-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-h2",
                        children: t("feedback-request")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                        alt: "info",
                        className: "ml-2 p-1 cursor-pointer hover:bg-indigo-700 rounded-[20px]",
                        onClick: function() {
                            return setShowInfoModal(!showInfoModal);
                        }
                    })
                ]
            }),
            renderInfoModel(),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                        className: "mb-2 font-medium",
                        children: t("feedback-search-recipients")
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c7461b2583ca5ebe$export$2e2bcd8739ae039), {
                        options: feedbackUsers.filter(function(fu) {
                            return !fu.selected && !fu.favorite;
                        }),
                        getOptionLabel: function(contact) {
                            return "".concat(contact.name, " (").concat(contact.email, ")");
                        },
                        getOptionKey: function(contact) {
                            return contact.email;
                        },
                        placeholder: t("feedback-search-by-name"),
                        onSelect: function(_feedbackUser) {
                            return changeFeedbackUser(_feedbackUser.email, "selected");
                        }
                    }),
                    feedbackUsers.filter(function(fu) {
                        return fu.selected || fu.favorite;
                    }).length > 0 ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "my-6",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "z-title2",
                                children: t("recipients")
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-gray-400",
                                children: t("feedback-recipients-subtitle")
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "border border-dashed border-indigo-700 mt-4 mb-4 rounded-md text-center py-10",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($630666c1efca6384$exports))),
                                alt: "users",
                                className: "h-6 w-6 mx-auto mb-4"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "z-body1 text-gray-400!",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        children: lang === "sv" ? "Inga mottagare valda." : "No recipients selected."
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                        className: "mt-1 z-body1 text-gray-400!",
                                        children: lang === "sv" ? "V\xe4lj minst 3 f\xf6r att forts\xe4tta." : "Please select at least 3 to continue."
                                    })
                                ]
                            })
                        ]
                    }),
                    feedbackUsers.filter(function(fu) {
                        return fu.selected || fu.favorite;
                    }).map(function(recipient, index) {
                        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            className: "h-6 w-6 rounded flex items-center justify-center cursor-pointer " + (recipient.selected ? "bg-primary-500" : "border border-gray-400"),
                                            onClick: function() {
                                                return changeFeedbackUser(recipient.email, "selected");
                                            },
                                            children: recipient.selected && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6c2ff88124776a4d$exports))),
                                                className: "h-5 w-5",
                                                alt: "Checked"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                                            className: "ml-2",
                                            children: [
                                                recipient.name,
                                                " (",
                                                recipient.email,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $aacba3eeeaf27d21$export$2e2bcd8739ae039), {
                                    text: t(recipient.favorite ? "remove-as-favourite" : "add-as-favourite"),
                                    tooltipPosition: "left",
                                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $03918d984417e2f5$export$2e2bcd8739ae039), {
                                        icon: recipient.favorite ? (0, (/*@__PURE__*/$parcel$interopDefault($91c3f1ebe0497aea$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($6d3b2b67d10aefe8$exports))),
                                        onClick: function() {
                                            return changeFeedbackUser(recipient.email, "favorite");
                                        }
                                    })
                                })
                            ]
                        }, "recipient_" + index);
                    })
                ]
            }),
            answered > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 border border-dashed border-gray-400 p-4 rounded-md",
                children: lang === "sv" ? "Vi har exkluderat de mottagare som redan svarat p\xe5 denna f\xf6rfr\xe5gan." : "We have excluded the respondents who have answered this feedback request."
            }),
            waiting ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-center",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($01b6e07abd83fc68$exports))),
                    alt: "processing",
                    className: "mx-auto",
                    style: {
                        height: 16,
                        width: 114
                    }
                })
            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-center",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    className: "mx-auto",
                    disabled: !formValid(),
                    onClick: function() {
                        return submit();
                    },
                    style: {
                        width: "unset"
                    },
                    children: lang === "sv" ? "Skicka feedbackf\xf6rfr\xe5gan" : "Send feedback request"
                })
            }),
            !demo && (0, $632c75b97b900307$export$1630b5343357e8b5).SYSTEM !== "production" && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bdb26526e1aa8454$export$2e2bcd8739ae039), {
                    id: "fake_done",
                    label: "Debug: Simulate responses",
                    onChange: function() {
                        return setFakeDone(!fakeDone);
                    },
                    checked: fakeDone
                })
            }),
            demo && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-red-500",
                children: lang === "sv" ? "Detta \xe4r ett demokonto - inga feedbackf\xf6rfr\xe5gningar kommer att skickas. Du kommer att f\xe5 l\xe5tsasfeedback." : "This is a demo account - no feedback requests will be sent. You will get mocked feedback."
            })
        ]
    });
};
var $3af88be99163a419$export$2e2bcd8739ae039 = $3af88be99163a419$var$SelfAssessmentRecipientPage;



var $dUlz9 = parcelRequire("dUlz9");

var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");







var $a8901a065a50b13b$var$SelfAssessmentSurveyResponse = function(props) {
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), feedbackQuestions = _useState[0], setFeedbackQuestions = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), feedbackAnswerOptions = _useState1[0], setFeedbackAnswerOptions = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)({}), 2), answers = _useState2[0], setAnswers = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), loading = _useState3[0], setLoading = _useState3[1];
    (0, $5s1kH.useEffect)(function() {
        var focusAreaQuestions = props.visionStatement.surveyRequests[0].surveyResult.focusAreas[0].questions;
        var answerOptionsByLang = props.visionStatement.surveyRequests[0].surveyResult.answerOptions;
        var _lang = props.visionStatement.surveyRequests[0].surveyResult.languages[0];
        setFeedbackQuestions(focusAreaQuestions);
        setFeedbackAnswerOptions(answerOptionsByLang[_lang]);
        setLoading(false);
    }, [
        props.visionStatement
    ]);
    if (loading) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "p-8 text-gray-300",
        children: "Loading..."
    });
    var allQuestionsAnswered = function() {
        return feedbackQuestions.every(function(_, index) {
            return answers[index] !== undefined && answers[index] !== "";
        });
    };
    var sendResponses = function() {
        var surveyRequest = props.visionStatement.surveyRequests[0];
        var surveyResult = surveyRequest.surveyResult;
        var questions = feedbackQuestions.map(function(question, index) {
            var selectedOption = answers[index];
            var answerIndex = feedbackAnswerOptions.indexOf(selectedOption);
            var _question_question_id;
            return {
                questionId: (_question_question_id = question.question_id) !== null && _question_question_id !== void 0 ? _question_question_id : question.id,
                names: (0, $dUlz9._)({}, lang, question.name),
                noAnswer: false,
                freeText: false,
                answer: answerIndex,
                freeAnswer: ""
            };
        });
        var updatedSurvey = {
            language: lang,
            languages: surveyResult.languages,
            deadline: surveyRequest.deadline,
            answerOptions: surveyResult.nrAnswerOptions,
            answerType: 0,
            showNoAnswer: true,
            names: (0, $dUlz9._)({}, lang, props.visionStatement.title),
            translations_answers: surveyResult.answerOptions,
            sections: [
                {
                    names: (0, $dUlz9._)({}, lang, ""),
                    questions: questions
                }
            ]
        };
        api.post('client/survey/' + props.visionStatement.surveyRequests[0].id, updatedSurvey).then(function(response) {
            if (response.json.status === "ok") props.save();
            else alert("Error submitting responses");
        }).catch(function(err) {
            console.error("sendResponses error:", err);
            alert("Network error submitting responses");
        });
    };
    var colWidth = 100 / (feedbackAnswerOptions.length - 1) + "%";
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content m-4",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mb-6",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "flex items-center",
                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("h1", {
                                className: "z-heading1 text-white",
                                children: t("self-assessment")
                            })
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "transparentBase",
                                    size: "sm",
                                    onClick: function() {
                                        return props.showDetailModal();
                                    },
                                    leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                                        className: "h-4 w-4",
                                        alt: "info"
                                    }),
                                    style: {
                                        width: "unset"
                                    },
                                    children: t("long-term-goal-details")
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                    buttonType: "transparentBase",
                                    size: "sm",
                                    onClick: function() {
                                        return props.setEdit();
                                    },
                                    leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0235c0cb6948d6bc$exports))),
                                        className: "h-4 w-4",
                                        alt: "edit"
                                    }),
                                    style: {
                                        width: "unset"
                                    },
                                    children: t("btn-edit-questions")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mb-6",
                children: t('surveyIntro')
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                className: "mt-1 border-indigo-700 mb-6"
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                children: feedbackQuestions.map(function(question, index) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "z-badge transparent text-gray-600",
                                children: [
                                    t("question"),
                                    " ",
                                    index + 1
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-gray-400 mt-2",
                                children: question.name
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-2 flex justify-between items-end gap-x-4 border-b border-indigo-700 pb-1",
                                children: feedbackAnswerOptions.filter(function(a, i) {
                                    return i > 0;
                                }).map(function(option, optIndex) {
                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-center",
                                        style: {
                                            width: colWidth
                                        },
                                        children: option
                                    }, "fqt" + index + "_opt" + optIndex);
                                })
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4 flex justify-between gap-4 border-b border-indigo-700 pb-4",
                                children: feedbackAnswerOptions.filter(function(a, i) {
                                    return i > 0;
                                }).map(function(option, optIndex) {
                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "flex justify-center",
                                        style: {
                                            width: colWidth
                                        },
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                                            id: "feedback_question_" + index + "_opt_" + optIndex,
                                            name: "feedback_question_" + index,
                                            value: option,
                                            label: "",
                                            checked: answers[index] === option,
                                            onChange: function() {
                                                return setAnswers(function(prev) {
                                                    return (0, $lf4fc._)((0, $hwO3w._)({}, prev), (0, $dUlz9._)({}, index, option));
                                                });
                                            }
                                        })
                                    }, "fq" + index + "_opt" + optIndex);
                                })
                            })
                        ]
                    }, "feedback_question_" + index);
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex justify-end",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    onClick: function() {
                        return sendResponses();
                    },
                    style: {
                        width: "unset"
                    },
                    disabled: !allQuestionsAnswered(),
                    children: t("submit")
                })
            })
        ]
    });
};
var $a8901a065a50b13b$export$2e2bcd8739ae039 = $a8901a065a50b13b$var$SelfAssessmentSurveyResponse;



var $hwO3w = parcelRequire("hwO3w");

var $lf4fc = parcelRequire("lf4fc");

var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");












var $af9bbf554ab2e9b1$var$SelfAssessmentSurveyCreation = function(props) {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), questions = _useState[0], setQuestions = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), openAIIndex = _useState1[0], setOpenAIIndex = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), aiInstruction = _useState2[0], setAiInstruction = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(-1), 2), questionLoading = _useState3[0], setQuestionLoading = _useState3[1];
    var surveyRequest = props.visionStatement.surveyRequests[0];
    var surveyLanguage = surveyRequest.surveyResult.languages[0];
    (0, $5s1kH.useEffect)(function() {
        var _questions = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = surveyRequest.surveyResult.focusAreas[0].questions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var q = _step.value;
                _questions.push({
                    text: q.name,
                    freeText: true,
                    id: q.id
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setQuestions(_questions);
    }, []);
    var saveSurvey = function() {
        var data = {
            "questions": questions
        };
        api.post('client/vision_statement_edit_survey_questions/' + props.visionStatement.id, data).then(function(response) {
            if (response.json.status === "ok") {
                props.save();
                props.close();
            } else alert("Error creating Survey");
        });
    };
    // Edit Single question
    var getAiQuestion = function(index, instruction, questionText) {
        var _questions = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (instruction === "add_question") try {
            for(var _iterator = questions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var q = _step.value;
                _questions.push(q.text);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var data = {
            instruction: instruction,
            question: questionText,
            questions: _questions
        };
        setQuestionLoading(index);
        api.post('client/ai_survey_edit_question/' + props.visionStatement.surveyId, data).then(function(response) {
            if (response.json.status === "ok") {
                var answer = response.json.answer;
                setQuestions(function(prev) {
                    var updated = (0, $XnYkK._)(prev);
                    updated[index] = (0, $lf4fc._)((0, $hwO3w._)({}, updated[index]), {
                        text: answer
                    });
                    return updated;
                });
                setAiInstruction("");
            } else if (response.json.error) alert(response.json.error);
            else alert("Unknown error");
            setQuestionLoading(-1);
        });
    };
    var updateQuestions = function(index, text) {
        var _questions = (0, $XnYkK._)(questions);
        _questions[index] = (0, $lf4fc._)((0, $hwO3w._)({}, _questions[index]), {
            text: text
        });
        setQuestions(_questions);
    };
    var addQuestion = function() {
        var index = questions.length;
        var newQuestion = {
            id: "",
            text: "",
            freeText: false
        };
        setQuestions(function(prev) {
            return (0, $XnYkK._)(prev).concat([
                newQuestion
            ]);
        });
        getAiQuestion(index, "add_question", "");
    };
    var deleteQuestion = function(nr) {
        setQuestions(function(prev) {
            return prev.filter(function(_, i) {
                return i !== nr;
            });
        });
    };
    var toggleAI = function(index) {
        setOpenAIIndex(openAIIndex === index ? null : index);
    };
    var aiQuickActions = [
        {
            key: "rephrase",
            label: t("rephrase")
        },
        {
            key: "shorten",
            label: t("shorten")
        },
        {
            key: "make-more-specific",
            label: t("make-more-specific")
        }
    ];
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
        isOpen: true,
        onClose: props.close,
        size: "wide",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                onClose: props.close,
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            children: t("btn-edit-questions")
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "transparentBase",
                            size: "sm",
                            onClick: function() {
                                return props.showDetailModal();
                            },
                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a5555ba0531550ab$exports))),
                                alt: "info"
                            }),
                            style: {
                                width: "unset"
                            },
                            children: t("long-term-goal-details")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        children: "All questions will be using the same answer options:"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("ul", {
                        className: "mt-2 flex flex-col gap-1 list-disc list-inside",
                        children: [
                            surveyRequest.surveyResult.answerOptions[surveyLanguage].filter(function(o, i) {
                                return i > 0;
                            }).map(function(option, index) {
                                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("li", {
                                    children: option
                                }, index);
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("li", {
                                children: [
                                    surveyRequest.surveyResult.answerOptions[surveyLanguage][0],
                                    "\xa0(",
                                    lang === "sv" ? "bara f\xf6r dem du ber om feedback fr\xe5n" : "only for feedback request recipients",
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4",
                        children: questions.map(function(question, index) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mb-2 pb-4 bg-indigo-800 border-indigo-700 border rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex justify-between items-center p-4",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "z-title1 text-white",
                                                children: [
                                                    t("question"),
                                                    " ",
                                                    index + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($bf86ece098c957df$exports))),
                                                alt: "close",
                                                className: "h-6 w-6 p-1 hover:bg-indigo-700 rounded-full cursor-pointer",
                                                onClick: function() {
                                                    return deleteQuestion(index);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "px-4",
                                        children: questionLoading === index ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                            style: {
                                                height: 54,
                                                padding: 24
                                            },
                                            children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($01b6e07abd83fc68$exports))),
                                                className: "mx-auto",
                                                alt: "loading",
                                                style: {
                                                    height: 16,
                                                    width: 114
                                                }
                                            })
                                        }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                            type: "text",
                                            className: "z-input",
                                            value: question.text,
                                            placeholder: t("question"),
                                            onChange: function(e) {
                                                return updateQuestions(index, e.target.value);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                        className: "border-indigo-700 my-4"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "flex justify-between items-center cursor-pointer px-4",
                                        onClick: function() {
                                            return toggleAI(index);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "flex gap-x-2 items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cb70cc925ae09565$exports))),
                                                        alt: "ai",
                                                        className: "h-5 w-5"
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                        className: "text-white",
                                                        children: t("improve-with-AI")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f3995b418b94841f$exports))),
                                                alt: "close",
                                                className: "h-6 w-6 p-1 hover:bg-indigo-700 rounded-full" + (openAIIndex === index ? " rotate-180" : "")
                                            })
                                        ]
                                    }),
                                    openAIIndex === index && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "px-4",
                                        children: [
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                                className: "flex gap-x-1 mt-1 text-white text-sm",
                                                children: aiQuickActions.map(function(action) {
                                                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                                        buttonType: "transparentBase",
                                                        size: "sm",
                                                        onClick: function() {
                                                            return getAiQuestion(index, action.key, question.text);
                                                        },
                                                        style: {
                                                            width: "unset"
                                                        },
                                                        children: action.label
                                                    }, action.key);
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                                className: "flex items-center mt-2 gap-2 bg-indigo-800 border border-indigo-600 rounded-md px-3 py-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                                                        type: "text",
                                                        placeholder: t("describe-desired-changes"),
                                                        className: "flex-1 text-white placeholder-gray-400 outline-none text-sm",
                                                        value: aiInstruction,
                                                        onChange: function(e) {
                                                            return setAiInstruction(e.target.value);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                                                        buttonType: "transparentBase",
                                                        size: "sm",
                                                        onClick: function() {
                                                            return getAiQuestion(index, aiInstruction, question.text);
                                                        },
                                                        leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cd41ee730e583fd6$exports))),
                                                            alt: "info",
                                                            className: "p-1"
                                                        }),
                                                        style: {
                                                            width: "unset"
                                                        },
                                                        className: "p-1! gap-x-0!"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, "question_" + index);
                        })
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "neutralBase",
                            size: "sm",
                            leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($8035c9bf788700b7$exports))),
                                alt: "info"
                            }),
                            onClick: addQuestion,
                            children: t("add")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b5382f3541d67ab8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "flex items-center gap-3 w-full",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "outlineWhiteBase",
                            className: "flex-1 cursor-pointer",
                            size: "sm",
                            onClick: props.close,
                            children: t("cancel")
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            className: "flex-1 cursor-pointer",
                            size: "sm",
                            disabled: questions.length === 0,
                            onClick: function() {
                                return saveSurvey();
                            },
                            children: t("save")
                        })
                    ]
                })
            })
        ]
    });
};
var $af9bbf554ab2e9b1$export$2e2bcd8739ae039 = $af9bbf554ab2e9b1$var$SelfAssessmentSurveyCreation;




var $b333c0bbfea15b93$var$SelfAssessmentSurveyPage = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var id = (0, $bHX26.useParams)().id;
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), visionStatement = _useState[0], setVisionStatement = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(true), 2), loading = _useState1[0], setLoading = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), step = _useState2[0], setStep = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showEditQuestions = _useState3[0], setShowEditQuestions = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), longTermGoalInfoModel = _useState4[0], setLongTermGoalInfo = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), allDone = _useState5[0], setAllDone = _useState5[1];
    var stepsData = [
        {
            title: t("self-assessment"),
            content: null
        },
        {
            title: "Feedback",
            content: null
        }
    ];
    var getData = function() {
        api.get('client/vision_statement_own_survey/' + id).then(function(response) {
            if (response.json.status === "ok") {
                setVisionStatement(response.json.visionStatement);
                setLoading(false);
            } else {
                alert("Error: " + response.json.status);
                console.log(response.json.error);
            }
        });
    };
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if ((visionStatement === null || visionStatement === void 0 ? void 0 : visionStatement.surveyId) && visionStatement.surveyRequests[0].surveyResult.scoreSelf > 0) setStep(1);
    }, [
        visionStatement
    ]);
    if (loading || !visionStatement) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {
        txt: lang === 'sv' ? "H\xe4mtar din sj\xe4lvskattning, det kan ta ett tag" : 'Loading your self-assessment, this may take a while'
    });
    var renderContent = function() {
        if (visionStatement.surveyRequests[0].surveyResult.scoreSelf > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3af88be99163a419$export$2e2bcd8739ae039), {
            visionStatement: visionStatement,
            done: function() {
                return setAllDone(true);
            }
        });
        else if (showEditQuestions) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $af9bbf554ab2e9b1$export$2e2bcd8739ae039), {
            visionStatement: visionStatement,
            save: function() {
                return getData();
            },
            showDetailModal: function() {
                return setLongTermGoalInfo(true);
            },
            close: function() {
                return setShowEditQuestions(false);
            }
        });
        else return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a8901a065a50b13b$export$2e2bcd8739ae039), {
            visionStatement: visionStatement,
            save: function() {
                return getData();
            },
            showDetailModal: function() {
                return setLongTermGoalInfo(true);
            },
            setEdit: function() {
                return setShowEditQuestions(true);
            }
        });
    };
    var renderLongTermGoalInfoInfoModel = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $88386e905c2c4f47$export$2e2bcd8739ae039), {
            isOpen: longTermGoalInfoModel,
            onClose: function() {
                return setLongTermGoalInfo(false);
            },
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $70ccbc54e3243003$export$2e2bcd8739ae039), {
                    onClose: function() {
                        return setLongTermGoalInfo(false);
                    },
                    children: t("long-term-goal-details")
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $26c7c4a825b0d416$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "mt-2 font-medium text-gray-100",
                            children: "Title:"
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-300",
                            children: visionStatement.title
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 font-medium text-gray-100",
                            children: [
                                t("description"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-300",
                            children: visionStatement.description
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 font-medium text-gray-100",
                            children: [
                                t("due-date"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "text-gray-300",
                            children: visionStatement.deadline
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content p-4",
        children: [
            !allDone && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e949fc66b34e9329$export$2e2bcd8739ae039), {
                        steps: stepsData,
                        direction: "horizontal",
                        currentIndex: step,
                        completedSteps: step === 1 ? [
                            0
                        ] : []
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "mt-1 border-indigo-700"
                    })
                ]
            }),
            renderContent(),
            longTermGoalInfoModel && renderLongTermGoalInfoInfoModel()
        ]
    });
};
var $b333c0bbfea15b93$export$2e2bcd8739ae039 = $b333c0bbfea15b93$var$SelfAssessmentSurveyPage;



var $6iP9u = parcelRequire("6iP9u");



var $5s1kH = parcelRequire("5s1kH");


var $bHX26 = parcelRequire("bHX26");








function $e343dfd93f01866e$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var translation = (0, $341d5702266247e0$export$9fc83ad70ead8663)();
    var t = translation.t, i18n = translation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var clientId = (0, $bHX26.useParams)().clientId;
    var meetingId = (0, $bHX26.useParams)().meetingId;
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(), 2), client = _useState[0], setClient = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(), 2), meetingSummary = _useState1[0], setMeetingSummary = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState2[0], setLoaded = _useState2[1];
    (0, $5s1kH.useEffect)(function() {
        api.get('coach/client/' + clientId + '/meeting_summary/' + meetingId).then(function(result) {
            setClient(result.json.client);
            setMeetingSummary(result.json.meetingSummary);
            setLoaded(true);
        });
    }, []);
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading meeting summary..."
    });
    var crumbs = [
        {
            name: t('my-clients'),
            url: '/clients'
        },
        {
            name: (client === null || client === void 0 ? void 0 : client.firstName) + " " + (client === null || client === void 0 ? void 0 : client.lastName),
            url: '/clients/' + clientId
        },
        {
            name: lang === 'sv' ? "M\xf6tessammanfattning" : 'Meeting summary'
        }
    ];
    var renderMeetingDate = function() {
        if (meetingSummary) {
            var d = new Date(meetingSummary.date);
            var dateStr = (0, $7d185b5883a21821$export$ff9a5f6f7fb9966b)(d, lang) + ", ";
            dateStr += (0, $7d185b5883a21821$export$5f885a9374f8e024)(d) + "-";
            var end = (0, $7d185b5883a21821$export$2287e3d29250119e)(d, meetingSummary.length);
            dateStr += (0, $7d185b5883a21821$export$5f885a9374f8e024)(end);
            return dateStr;
        }
        return "N/A";
    };
    var renderMeetingSummary = function() {
        if (!meetingSummary) return;
        if (meetingSummary.tasks.length === 0 && !meetingSummary.meetingReflections) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "mt-10 text-center",
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                    alt: "date",
                    className: "h-8 w-8 mx-auto"
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-2 text-neutral-400",
                    children: lang === 'sv' ? "Om ni anv\xe4nt coachverktyg under m\xf6tet sparas inneh\xe5llet h\xe4r." : 'If you used the coaching tools during the meeting, the content is saved here.'
                })
            ]
        });
        return renderTaskAndReflections();
    };
    var renderTasks = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 text-lg font-medium",
                    children: lang === 'sv' ? 'Skapade aktiviteter' : 'Created actions'
                }),
                meetingSummary === null || meetingSummary === void 0 ? void 0 : meetingSummary.tasks.map(function(task) {
                    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "mt-2 bg-neutral-700 rounded-md p-4",
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                                className: "text-lg font-medium",
                                children: task.name
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex mt-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                                        alt: "cal",
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "text-sm font-medium ml-1",
                                        children: [
                                            t('target-date'),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-sm text-gray-400 ml-1",
                                        children: task.deadline ? (0, $7d185b5883a21821$export$5a252a405018366)(task.deadline) : "-"
                                    })
                                ]
                            }),
                            task.focusAreaName && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "flex mt-3 items-center",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($39fbe7786abdc679$exports))),
                                        alt: "learning",
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                        className: "text-sm font-medium ml-1",
                                        children: [
                                            t('focus-area'),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "text-sm text-gray-400 ml-1",
                                        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $65b37309f7d8dd2c$export$2e2bcd8739ae039), {
                                            size: "sm",
                                            onClick: function() {
                                                return navigate('/clients/' + (client === null || client === void 0 ? void 0 : client.id) + '/focus_area/' + task.focusAreaId);
                                            },
                                            children: task.focusAreaName
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                                className: "mt-4 border-neutral-600"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-4 markdown-content",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b0f0e35343cbf8ab$export$7460c8b7e4ce9582), {
                                    children: task.description
                                })
                            })
                        ]
                    }, "task_" + task.id);
                }),
                (meetingSummary === null || meetingSummary === void 0 ? void 0 : meetingSummary.tasks.length) === 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-4 text-neutral-400",
                    children: lang === 'sv' ? "Ni har inte skapat n\xe5gra aktiviteter under m\xf6tet." : 'You haven\'t created any Actions during the meeting'
                })
            ]
        });
    };
    var renderReflections = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-6 text-lg font-medium",
                    children: lang === 'sv' ? 'Reflektionsyta' : 'Reflection space'
                }),
                (meetingSummary === null || meetingSummary === void 0 ? void 0 : meetingSummary.meetingReflections) ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
                    children: [
                        meetingSummary.meetingReflections.notes.length > 0 && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-2 text-neutral-400 whitespace-nowrap",
                            children: [
                                '"',
                                meetingSummary.meetingReflections.notes,
                                '"'
                            ]
                        }),
                        meetingSummary.meetingReflections.images.map(function(nr) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                alt: "pic",
                                src: "https://public.zebrain.se/visionboard/pictures/" + nr + ".jpeg",
                                className: "mt-2 rounded-md"
                            }, "img_" + nr);
                        })
                    ]
                }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "mt-4 text-neutral-400",
                    children: lang === 'sv' ? "Ni har inte reflektionsytan under m\xf6tet." : 'You haven\'t used Reflection space during the meeting'
                })
            ]
        });
    };
    var renderTaskAndReflections = function() {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                renderTasks(),
                renderReflections()
            ]
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-6 text-2xl font-medium",
                children: lang === 'sv' ? "M\xf6tessammanfattning" : 'Meeting summary'
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6 flex items-center text-sm font-medium",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fd544cb172fd757a$exports))),
                        alt: "cal"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "ml-2",
                        children: renderMeetingDate()
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        className: "ml-8 h-6 w-6 rounded-full",
                        src: (client === null || client === void 0 ? void 0 : client.picture) ? client.picture : (0, (/*@__PURE__*/$parcel$interopDefault($bf234ba9a155a985$exports))),
                        alt: "profile"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                        className: "ml-2",
                        children: [
                            client === null || client === void 0 ? void 0 : client.firstName,
                            " ",
                            client === null || client === void 0 ? void 0 : client.lastName
                        ]
                    })
                ]
            }),
            renderMeetingSummary()
        ]
    });
}



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");








function $15c8cfcd85e2f82b$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), questions = _useState[0], setQuestions = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), options = _useState1[0], setOptions = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), answers = _useState2[0], setAnswers = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), categoryNameEn = _useState3[0], setCategoryNameEn = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), categoryNameSv = _useState4[0], setCategoryNameSv = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), customerName = _useState5[0], setCustomerName = _useState5[1];
    var categoryId = (0, $bHX26.useParams)().categoryId;
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState6[0], setLoaded = _useState6[1];
    (0, $5s1kH.useEffect)(function() {
        var url = "client/readiness/" + categoryId;
        api.get(url).then(function(response) {
            setQuestions(response.json.questions);
            setOptions(response.json.options);
            setAnswers(response.json.answers);
            setCustomerName(response.json.customerName);
            setCategoryNameEn(response.json.categoryNameEn);
            setCategoryNameSv(response.json.categoryNameSv);
            setLoaded(true);
        });
    }, []);
    var selectOption = function(questionNr, score) {
        var _answers = (0, $XnYkK._)(answers);
        _answers[questionNr] = score;
        setAnswers(_answers);
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {});
    var crumbs = [
        {
            name: lang === "sv" ? "Hem" : "Home",
            url: "/"
        },
        {
            name: t("assessments"),
            url: "/assessments"
        },
        {
            name: "Readiness"
        }
    ];
    var pageDone = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = answers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var answer = _step.value;
                if (answer < 0) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    };
    var renderIntro = function() {
        var intro = "";
        var disclaimer = "";
        if (lang === 'sv') {
            intro += "Ange i vilken grad du inst\xe4mmer i p\xe5st\xe5endena nedan, utifr\xe5n hur det ser ut f\xf6r dig just nu inf\xf6r arbetet med initiativet ";
            intro += categoryNameSv;
            intro += " p\xe5 ";
            intro += customerName;
            intro += ". Det finns inga r\xe4tta eller felaktiga svar, det \xe4r din upplevelse som r\xe4knas.";
            disclaimer += "Ingen p\xe5 " + customerName + " kan se vem som svarat vad.";
        } else {
            intro += "Rate how much you agree with the statements below, based on where things stand for you right now with the ";
            intro += categoryNameEn;
            intro += " initiative at ";
            intro += customerName;
            intro += ". There are no right or wrong answers, it\u2019s your experience that counts.";
            disclaimer += "No one at " + customerName + " can see who answered what.";
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "my-2 z-body1",
                    children: intro
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "my-2 z-body1",
                    children: disclaimer
                })
            ]
        });
    };
    var save = function() {
        var url = "client/readiness_save/" + categoryId;
        var data = {
            answers: answers
        };
        api.post(url, data).then(function(response) {
            navigate("/assessments");
        });
    };
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "z-h2 mt-4",
                children: lang === "sv" ? "F\xf6ruts\xe4ttningar" : "Readiness"
            }),
            renderIntro(),
            questions.map(function(question, questionNr) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-title1",
                            children: lang === "sv" ? question.sv : question.en
                        }),
                        options.map(function(option) {
                            // Don't show cannot answer
                            if (option.score === 0) return null;
                            var _selectedScore = answers[questionNr];
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                                    id: "a_" + questionNr + '_' + option.score,
                                    name: "a_" + questionNr + '_' + option.score,
                                    label: lang === "sv" ? option.sv : option.en,
                                    value: "" + option.score,
                                    checked: _selectedScore === option.score,
                                    onChange: function() {
                                        return selectOption(questionNr, option.score);
                                    }
                                })
                            }, "a_" + questionNr + '_' + option.score);
                        })
                    ]
                }, "question_" + questionNr);
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "flex justify-between mt-6",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "w-40",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                        disabled: !pageDone(),
                        onClick: function() {
                            return save();
                        },
                        rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                            alt: "left"
                        }),
                        children: t('submit')
                    })
                })
            })
        ]
    });
}



var $6iP9u = parcelRequire("6iP9u");

var $XnYkK = parcelRequire("XnYkK");


var $5s1kH = parcelRequire("5s1kH");

var $bHX26 = parcelRequire("bHX26");




var $3317e53dde0c916d$exports = {};
$3317e53dde0c916d$exports = $parcel$resolve("7Qy33");







function $ad2a3db0304837c7$export$2e2bcd8739ae039() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), drivers = _useState[0], setDrivers = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)([]), 2), options = _useState1[0], setOptions = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(0), 2), driverPage = _useState2[0], setDriverPage = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), customerName = _useState3[0], setCustomerName = _useState3[1];
    var _useState4 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), showThanks = _useState4[0], setShowThanks = _useState4[1];
    var _useState5 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), lastAnswered = _useState5[0], setLastAnswered = _useState5[1];
    var customerCategoryId = (0, $bHX26.useParams)().customerCategoryId;
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState6 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState6[0], setLoaded = _useState6[1];
    var queryParams = new URLSearchParams(location.search);
    var token = queryParams.get("token");
    var anonymous = !!token;
    (0, $5s1kH.useEffect)(function() {
        var url = "client/drivers/" + customerCategoryId;
        if (token) url += "/" + token;
        api.get(url, [], anonymous).then(function(response) {
            setDrivers(response.json.drivers);
            setOptions(response.json.options);
            setLastAnswered(response.json.lastAnswered);
            setCustomerName(response.json.customerName);
            setLoaded(true);
        });
    }, []);
    (0, $5s1kH.useEffect)(function() {
        (0, $d4dd2202bc0c8ccd$export$3e0c8fa3b5e4b3b9)();
    }, [
        driverPage
    ]);
    var selectOption = function(question, score) {
        var _drivers = (0, $XnYkK._)(drivers);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _drivers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _driver = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = _driver.questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _question = _step1.value;
                        if (_question.id === question.id) {
                            _question.answer = score;
                            console.log('Set score to ' + score);
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setDrivers(_drivers);
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {});
    if (drivers.length < 1) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "There are no drivers mapped to this category"
    });
    var crumbs = [
        {
            name: lang === "sv" ? "Hem" : "Home",
            url: "/"
        },
        {
            name: t("assessments"),
            url: "/assessments"
        },
        {
            name: "Drivers"
        }
    ];
    var pageDone = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = drivers[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var driver = _step.value;
                try {
                    for(var _iterator1 = driver.questions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var question = _step1.value;
                        if (question.answer < 0) return false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return true;
    };
    var driverDone = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = drivers[driverPage].questions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var question = _step.value;
                if (question.answer < 0) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    };
    var save = function() {
        var url = "client/drivers_save/" + customerCategoryId;
        if (token) url += "/" + token;
        var data = {
            drivers: drivers
        };
        api.post(url, data, [], anonymous).then(function(response) {
            setShowThanks(true);
        });
    };
    var renderOptions = function(question) {
        var questionOptions = options[question.optionsType];
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: questionOptions.map(function(option) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $103e1568d31368e1$export$2e2bcd8739ae039), {
                        id: "a_" + question.id + '_' + option.score,
                        name: "a_" + question.id + '_' + option.score,
                        label: lang === "sv" ? option.sv : option.en,
                        value: "" + option.score,
                        checked: question.answer === option.score,
                        onChange: function() {
                            return selectOption(question, option.score);
                        }
                    })
                }, "a_" + question.id + '_' + option.score);
            })
        });
    };
    var renderQuestions = function(driver) {
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: driver.questions.map(function(question, questionNr) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-4",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                            className: "z-title2",
                            children: lang === "sv" ? question.sv : question.en
                        }),
                        renderOptions(question)
                    ]
                }, "question_" + question.id);
            })
        });
    };
    var renderButtons = function() {
        var showNext = driverPage < drivers.length - 1;
        var showPrevious = driverPage > 0 && drivers.length > 1;
        var showSave = driverPage === drivers.length - 1;
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
            className: "flex justify-between mt-6 gap-x-8",
            children: [
                showPrevious && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    onClick: function() {
                        return setDriverPage(driverPage - 1);
                    },
                    leftIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3317e53dde0c916d$exports))),
                        alt: "left"
                    }),
                    children: t('back')
                }),
                showNext && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    disabled: !driverDone(),
                    onClick: function() {
                        return setDriverPage(driverPage + 1);
                    },
                    rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                        alt: "right"
                    }),
                    children: t('next')
                }),
                showSave && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                    disabled: !pageDone(),
                    onClick: function() {
                        return save();
                    },
                    rightIcon: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fb5fda9edf61a9ba$exports))),
                        alt: "right"
                    }),
                    children: t('submit')
                })
            ]
        });
    };
    var changeLanguage = function(l) {
        if (l === 'en' || l === 'sv') i18n.changeLanguage(l).then();
    };
    var renderIntro = function() {
        var intro = "";
        var disclaimer = "";
        if (lang === 'sv') {
            intro += "Ange i vilken grad du inst\xe4mmer i p\xe5st\xe5endena nedan, utifr\xe5n hur det ser ut i ditt arbete just nu. Det finns inga r\xe4tta eller felaktiga svar, det \xe4r din upplevelse som r\xe4knas.";
            disclaimer += "Ingen p\xe5 " + customerName + " kan se vem som svarat vad.";
        } else {
            intro += "Rate how much you agree with the statements below, based on how things look in your work right now. There are no right or wrong answers, it\u2019s your experience that counts.";
            disclaimer += "No one at " + customerName + " can see who answered what.";
        }
        return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)((0, $b9b8d11a1c089252$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "my-2 z-body1",
                    children: intro
                }),
                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                    className: "my-2 z-body1",
                    children: disclaimer
                })
            ]
        });
    };
    var thisDriver = drivers[driverPage];
    if (showThanks) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            !anonymous && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("p", {
                className: "z-h2 mt-4",
                children: lang === "sv" ? "Tack f\xf6r dina svar!" : "Thanks for your answers!"
            }),
            !anonymous && /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $62fb79d656788c69$export$2e2bcd8739ae039), {
                buttonType: "blueBase",
                className: "mt-4",
                onClick: function() {
                    return navigate("/assessments");
                },
                children: lang === "sv" ? "Tillbaka till m\xe4tningar" : "Back to assessments"
            })
        ]
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-content",
        children: [
            anonymous ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "flex gap-x-4 mt-4 justify-end",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: lang === "en" ? "underline" : "cursor-pointer",
                        onClick: function() {
                            return changeLanguage("en");
                        },
                        children: "English"
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: lang === "sv" ? "underline" : "cursor-pointer",
                        onClick: function() {
                            return changeLanguage("sv");
                        },
                        children: "Svenska"
                    })
                ]
            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            renderIntro(),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("p", {
                className: "z-body2 mt-4",
                children: [
                    "Step ",
                    driverPage + 1,
                    " of ",
                    drivers.length
                ]
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "mt-2 w-full h-2 rounded-full bg-indigo-700",
                children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                    className: "rounded-full h-2 bg-primary-500",
                    style: {
                        width: 100 * (driverPage + 1) / drivers.length + "%"
                    }
                })
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "z-h2",
                        children: lang === "sv" ? thisDriver.sv : thisDriver.en
                    }),
                    renderQuestions(thisDriver),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("hr", {
                        className: "my-8 border-indigo-700"
                    })
                ]
            }),
            renderButtons()
        ]
    });
}



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");




var $bHX26 = parcelRequire("bHX26");




var $a1914f5f813d0305$var$AssessmentUpload = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), uploading = _useState1[0], setUploading = _useState1[1];
    var _useState2 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), uploadFile = _useState2[0], setUploadFile = _useState2[1];
    var _useState3 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), customerSurvey = _useState3[0], setCustomerSurvey = _useState3[1];
    var id = (0, $bHX26.useParams)().id;
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var processFile = function(_file) {
        return new Promise(function(resolve) {
            if (!_file) return resolve(null);
            if (_file.size > 12000000) {
                // setChatError(ChatError.FILE_TOO_LARGE);
                alert("File too large");
                return resolve(null);
            }
            var filetype = "";
            if (_file.type === "application/pdf") filetype = "pdf";
            else if (_file.type.match("image.*")) filetype = "image";
            else if (_file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || _file.type === "application/vnd.ms-excel") filetype = "excel";
            else if (_file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || _file.type === "application/msword") filetype = "word";
            else {
                alert("Bad file format");
                // setChatError(ChatError.BAD_FILE_FORMAT);
                return resolve(null);
            }
            var filename = _file.name;
            if (filetype === "excel") {
                var reader = new FileReader();
                reader.onload = function(e) {
                    var _e_target;
                    var arrayBuffer = (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.result;
                    var uint8Array = new Uint8Array(arrayBuffer);
                    var binaryString = Array.from(uint8Array).map(function(byte) {
                        return String.fromCharCode(byte);
                    }).join("");
                    var base64String = btoa(binaryString);
                    resolve({
                        filename: filename,
                        filetype: filetype,
                        bytes: base64String,
                        length: base64String.length
                    });
                };
                reader.readAsArrayBuffer(_file);
            } else if (filetype === "word") {
                var reader1 = new FileReader();
                reader1.onload = function(e) {
                    var _e_target;
                    var arrayBuffer = (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.result;
                    var uint8Array = new Uint8Array(arrayBuffer);
                    var binaryString = Array.from(uint8Array).map(function(byte) {
                        return String.fromCharCode(byte);
                    }).join("");
                    var base64String = btoa(binaryString);
                    resolve({
                        filename: filename,
                        filetype: filetype,
                        bytes: base64String,
                        length: base64String.length
                    });
                };
                reader1.readAsArrayBuffer(_file);
            } else {
                var reader2 = new FileReader();
                reader2.onload = function(e) {
                    var _e_target, _e_target1;
                    resolve({
                        filename: filename,
                        filetype: filetype,
                        bytes: (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.result,
                        length: ((_e_target1 = e.target) === null || _e_target1 === void 0 ? void 0 : _e_target1.result).length
                    });
                };
                reader2.readAsDataURL(_file);
            }
        });
    };
    (0, $5s1kH.useEffect)(function() {
        if (uploadFile) processFile(uploadFile).then(function(uploadedFile) {
            if (uploadedFile) {
                var data = {
                    "file": uploadedFile
                };
                setUploading(true);
                api.post("client/assessments/customer_survey_upload/" + id, data).then(function(response) {
                    console.log("uploaded");
                    setUploading(false);
                    navigate("/assessments/customer_survey_report/" + id);
                });
            }
        });
    }, [
        uploadFile
    ]);
    var getData = function() {
        api.get("client/assessments/customer_survey/" + id).then(function(response) {
            setCustomerSurvey(response.json.customerSurvey);
            setLoaded(true);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {});
    if (!customerSurvey) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Error loading survey"
    });
    var handleFilesSelected = function(file) {
        setUploadFile(file);
    };
    var dropFile = function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        if (evt.dataTransfer.files.length > 0) handleFilesSelected(evt.dataTransfer.files[0]);
        else alert("Error: We could not find any dropped files.");
    };
    var crumbs = [
        {
            name: t("assessments"),
            url: "/assessments"
        },
        {
            name: "Upload report for " + customerSurvey.name
        }
    ];
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                className: "z-h2 mt-4",
                children: customerSurvey.name
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "-body1",
                children: [
                    "Upload your ",
                    customerSurvey.name,
                    " report below."
                ]
            }),
            uploading ? /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-12 mx-auto",
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($01b6e07abd83fc68$exports))),
                        className: "mx-auto",
                        alt: "loading",
                        style: {
                            height: 16,
                            width: 114
                        }
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                        className: "mt-4 text-center z-body2 mx-auto",
                        children: "Digesting your report - this might take a minute..."
                    })
                ]
            }) : /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "mt-8 border border-dashed border-indigo-400 p-4 flex justify-center items-center rounded-md h-40",
                onDrop: function(e) {
                    e.currentTarget.classList.remove("bg-indigo-800");
                    dropFile(e);
                },
                onDragOver: function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    e.currentTarget.classList.add("bg-indigo-800");
                },
                onDragLeave: function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    e.currentTarget.classList.remove("bg-indigo-800");
                },
                children: [
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("input", {
                        id: "profileFile",
                        type: "file",
                        className: "hidden",
                        onChange: function(e) {
                            return handleFilesSelected(e.target.files[0]);
                        }
                    }),
                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("label", {
                        htmlFor: "profileFile",
                        className: "flex items-center cursor-pointer",
                        style: {
                            margin: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($749d65ec77f6e156$exports))),
                                alt: "icon",
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("span", {
                                className: "hidden lg:block ml-2 text-sm text-gray-400",
                                children: lang === "sv" ? "Ladda upp" : "Upload"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a1914f5f813d0305$export$2e2bcd8739ae039 = $a1914f5f813d0305$var$AssessmentUpload;



var $6iP9u = parcelRequire("6iP9u");


var $5s1kH = parcelRequire("5s1kH");




var $bHX26 = parcelRequire("bHX26");


var $7ecdda1419524bfc$var$CustomerSurveyReport = function() {
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance();
    var navigate = (0, $bHX26.useNavigate)();
    var _useTranslation = (0, $341d5702266247e0$export$9fc83ad70ead8663)(), t = _useTranslation.t, i18n = _useTranslation.i18n; // i18n translation hook
    var lang = (0, $c32e41a1c8ecb8c8$export$64783e31db14f0ba)(i18n.language);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(null), 2), customerSurvey = _useState1[0], setCustomerSurvey = _useState1[1];
    var id = (0, $bHX26.useParams)().id;
    (0, $5s1kH.useEffect)(function() {
        getData();
    }, []);
    var getData = function() {
        api.get("client/assessments/customer_survey_report/" + id).then(function(response) {
            setCustomerSurvey(response.json.survey);
            setLoaded(true);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2e55dd46423f9c03$export$2e2bcd8739ae039), {});
    if (!customerSurvey) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4",
        children: "Error loading survey"
    });
    var crumbs = [
        {
            name: t("assessments"),
            url: "/assessments"
        },
        {
            name: customerSurvey.name + " " + customerSurvey.created.substring(0, 10)
        }
    ];
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0858ff7e9f730353$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                className: "z-h2 mt-4",
                children: [
                    customerSurvey.name,
                    " ",
                    customerSurvey.created.substring(0, 10)
                ]
            }),
            customerSurvey.categories.map(function(category) {
                return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                            className: "mt-1 flex justify-between items-center border-b border-b-indigo-700",
                            children: [
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-title1",
                                    children: category.name
                                }),
                                /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                    className: "z-title1",
                                    children: category.grade.toFixed(1)
                                })
                            ]
                        }),
                        category.questions.map(function(question) {
                            return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsxs)("div", {
                                className: "mt-1 flex justify-between items-center border-b border-b-indigo-700 gap-x-8",
                                children: [
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: question.name
                                    }),
                                    /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
                                        className: "z-title2",
                                        children: question.grade.toFixed(1)
                                    })
                                ]
                            }, question.id);
                        })
                    ]
                }, category.id);
            })
        ]
    });
};
var $7ecdda1419524bfc$export$2e2bcd8739ae039 = $7ecdda1419524bfc$var$CustomerSurveyReport;


var $42166dc323bd455a$var$AppRouter = function(param) {
    var outerRoute = param.outerRoute;
    var _useAuth0 = (0, $65283fdff51e8344$export$f2b63d3ca66bb884)(), isAuthenticated = _useAuth0.isAuthenticated, isLoading = _useAuth0.isLoading, loginWithRedirect = _useAuth0.loginWithRedirect, getAccessTokenSilently = _useAuth0.getAccessTokenSilently;
    // Initialize api here with the getAccessTokenSilently function. This is need to allow api to get/refresh token
    var api = (0, $589abb406e7545d9$export$2e2bcd8739ae039).getInstance(getAccessTokenSilently);
    var _useState = (0, $6iP9u._)((0, $5s1kH.useState)(false), 2), enoughPrivileges = _useState[0], setEnoughPrivileges = _useState[1];
    var _useState1 = (0, $6iP9u._)((0, $5s1kH.useState)(""), 2), error = _useState1[0], setError = _useState1[1];
    // Define routes without handle properties
    var clientRoutes = [
        {
            path: '/',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0e0906c24bb36f11$export$2e2bcd8739ae039), {})
        },
        {
            path: '/ai/:urlThreadId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $79e724f81568affa$export$2e2bcd8739ae039), {})
        },
        {
            path: '/ai_system',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $452e2b07ac9b2527$export$2e2bcd8739ae039), {})
        },
        {
            path: '/tasks/:taskId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $5db114b8d496b2f1$export$2e2bcd8739ae039), {})
        },
        {
            path: '/tasks/:taskId/edit',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8cba1729a9833283$export$2e2bcd8739ae039), {})
        },
        {
            path: '/accept_invite/:code',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $47061abfd6e69775$export$2e2bcd8739ae039), {})
        },
        {
            path: '/assessments',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $facc19daf8b7821e$export$2e2bcd8739ae039), {})
        },
        {
            path: '/assessments/own/:id',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b333c0bbfea15b93$export$2e2bcd8739ae039), {})
        },
        {
            path: '/assessments/survey_upload/:id',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a1914f5f813d0305$export$2e2bcd8739ae039), {})
        },
        {
            path: '/assessments/customer_survey_report/:id',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $7ecdda1419524bfc$export$2e2bcd8739ae039), {})
        },
        {
            path: '/dev-plan',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc7b352045a2b5c1$export$2e2bcd8739ae039), {})
        },
        {
            path: '/assessments/readiness/:categoryId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $15c8cfcd85e2f82b$export$2e2bcd8739ae039), {})
        },
        {
            path: '/dev-plan/survey_request_invite/:id',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $ac954d60bd3f5530$export$2e2bcd8739ae039), {})
        },
        {
            path: '/dev-plan/long-term-goal/:visionStatementId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8fbc1cd7b0d38c80$export$2e2bcd8739ae039), {})
        },
        {
            path: '/dev-plan/survey/result/:id/:page',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3967e9570d22c369$export$2e2bcd8739ae039), {})
        },
        {
            path: '/feedback/survey/:id',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $2dc00239332c5354$export$2e2bcd8739ae039), {})
        },
        {
            path: '/feedback/survey_multi/:survey_multi_recipient_id',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $6a8ed32f3e75cd70$export$2e2bcd8739ae039), {})
        },
        {
            path: '/feedback/survey_drivers/:customerCategoryId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $ad2a3db0304837c7$export$2e2bcd8739ae039), {})
        },
        {
            path: '/account',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $56fb6ddc2e2d00cb$export$2e2bcd8739ae039), {})
        },
        {
            path: '/about',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $c30a96161c3cb068$export$2e2bcd8739ae039), {})
        },
        {
            path: '/support',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8ca062ea83b71f69$export$2e2bcd8739ae039), {})
        },
        {
            path: '/team',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $24ef3d21323e9f7d$export$2e2bcd8739ae039), {})
        },
        {
            path: '/team/member/:clientId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $7d6703ede50b1f30$export$2e2bcd8739ae039), {})
        },
        {
            path: '/team/vision_statement/:visionStatementId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8845b9f638d27ce6$export$2e2bcd8739ae039), {})
        },
        {
            path: '/team/recordings',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b9066482124566cb$export$2e2bcd8739ae039), {})
        },
        {
            path: '/team/recording/:recordingId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $66f6ea7ccb99dc70$export$2e2bcd8739ae039), {})
        },
        // Videocoach
        {
            path: '/videocoach',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $9b85048b9cc6fce9$export$2e2bcd8739ae039), {})
        },
        {
            path: '/videocoach/my-coach',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $4a12bf2671498f8a$export$2e2bcd8739ae039), {})
        },
        {
            path: '/videocoach/chat/:coachId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $6c1a2d6fadc3342b$export$2e2bcd8739ae039), {})
        },
        {
            path: '/videocoach/book-meeting',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $df1a61476d24305b$export$2e2bcd8739ae039), {})
        },
        {
            path: '/videocoach/match-with-coach',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e6721e901a1515a8$export$2e2bcd8739ae039), {})
        },
        {
            path: '/unsubscribe',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $cc3aace872107b9b$export$2e2bcd8739ae039), {})
        },
        {
            path: '/profile',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $42a808b599103bea$export$2e2bcd8739ae039), {})
        },
        {
            path: '/profile/big5',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $d9c7b7b550e0dc60$export$2e2bcd8739ae039), {})
        },
        {
            path: '/profile/stress',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $9228aabb792bca9d$export$2e2bcd8739ae039), {})
        },
        {
            path: '/testing',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $51ec838223b193bc$export$2e2bcd8739ae039), {})
        },
        {
            path: '/signup',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e69e74f145378b26$export$2e2bcd8739ae039), {})
        },
        {
            path: '*',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0414a7a8640e30e4$export$2e2bcd8739ae039), {})
        }
    ];
    var coachRoutes = [
        {
            path: '/',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $ed37a5b9dd08efd9$export$2e2bcd8739ae039), {})
        },
        {
            path: '/signup',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e69e74f145378b26$export$2e2bcd8739ae039), {})
        },
        {
            path: '/account',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $7f7604e8a9f9f6b6$export$2e2bcd8739ae039), {})
        },
        {
            path: '/application',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $a8f28c2cebc3e2b3$export$2e2bcd8739ae039), {})
        },
        {
            path: '/bookings',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $9c87070a28704af8$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $5bc3972d35c25732$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/:clientId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $be21a18a1a0b4a21$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/vision_statement/:id',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $b45ef52a3cebd91f$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/long_term_goal/:visionStatementId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $8fbc1cd7b0d38c80$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/:clientId/meeting_summary/:meetingId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $e343dfd93f01866e$export$2e2bcd8739ae039), {})
        },
        {
            path: '/chats/:clientId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $45cc95e8538527a8$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/stress/:stressId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $9228aabb792bca9d$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/personality/:personalityId',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $d9c7b7b550e0dc60$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/survey_result/:id/:page',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $3967e9570d22c369$export$2e2bcd8739ae039), {})
        },
        {
            path: '/chats',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $1775128c0acba44e$export$2e2bcd8739ae039), {})
        },
        {
            path: '/support',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $058fa55c48f19faf$export$2e2bcd8739ae039), {})
        },
        {
            path: '/availability',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $d18234a83fe225f0$export$2e2bcd8739ae039), {})
        },
        {
            path: '*',
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $0414a7a8640e30e4$export$2e2bcd8739ae039), {})
        }
    ];
    var router = (0, $bHX26.createBrowserRouter)([
        {
            path: "/",
            element: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $ffa77426b0cd6a2d$export$86fbec116b87613f), {}),
            children: (0, $632c75b97b900307$export$1630b5343357e8b5).USER_TYPE === "client" ? clientRoutes : coachRoutes
        }
    ]);
    (0, $5s1kH.useEffect)(function() {
        var pathname = window.location.pathname;
        // If we get here from an access request redirect, capture code and store in local storage
        if (pathname.startsWith('/availability') && window.location.search) {
            if (!window.localStorage["oauth_temp"]) window.localStorage["oauth_temp"] = window.location.search;
            else console.log('found oauth_temp');
        }
    }, []);
    (0, $5s1kH.useEffect)(function() {
        if (outerRoute) router.navigate(outerRoute).then();
    }, [
        outerRoute
    ]);
    // console.log('isLoading: ' + isLoading + ' isAuthenticated: ' + isAuthenticated);
    (0, $5s1kH.useEffect)(function() {
        if (window.location.pathname.startsWith('/feedback/survey') && window.location.search.startsWith('?token') || window.location.pathname === "/signup") {
            // When there is no need for a logged-in session, return
            setEnoughPrivileges(true);
            return;
        }
        if (!isLoading) {
            if (!isAuthenticated) {
                var loginOptions = {
                    appState: {
                        returnTo: window.location.pathname
                    },
                    authorizationParams: {}
                };
                if (window.location.pathname.startsWith('/accept_invite/')) loginOptions.authorizationParams = {
                    screen_hint: "signup"
                };
                loginWithRedirect(loginOptions).then();
            } else if (window.location.pathname.startsWith('/accept_invite/')) {
                console.log('Accept invite, authenticated');
                var invite_code = window.location.pathname.substring(15);
                var data = {
                    code: invite_code
                };
                var url = (0, $632c75b97b900307$export$1630b5343357e8b5).USER_TYPE === "client" ? "client/accept_invite" : "coach/accept_invite";
                api.post(url, data).then(function(response) {
                    if (response.json.status === "ok") {
                        setEnoughPrivileges(true);
                        window.location.href = "/";
                    } else if (response.json.error) setError(response.json.error);
                    else setError('Unknown error. Please contact support');
                });
            } else // There is an unknown problem of getAccessTokenSilently failing to get refresh token. Try this method
            // here, and if it fails, run the loginWithRedirect method to get a new refresh token.
            getAccessTokenSilently().then(function(accessToken) {
                console.log("Got access token, length " + accessToken.length);
                setEnoughPrivileges(true);
            }).catch(function(reason) {
                console.log(reason);
                var loginOptions = {
                    appState: {
                        returnTo: window.location.pathname
                    }
                };
                loginWithRedirect(loginOptions).then();
            });
        }
    }, [
        isLoading,
        isAuthenticated
    ]);
    if (error.length > 0) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4 text-center text-gray-100",
        children: error
    });
    if (!enoughPrivileges) return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)("div", {
        className: "mt-4 text-center text-indigo-800",
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $bHX26.RouterProvider), {
        router: router
    });
};
var $42166dc323bd455a$export$2e2bcd8739ae039 = $42166dc323bd455a$var$AppRouter;



var $b2d387cb84d49e17$var$root = (0, $83e5eb54a832d019$exports.createRoot)(document.getElementById('root'));
$b2d387cb84d49e17$var$root.render(/*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)($b2d387cb84d49e17$var$All, {}));
function $b2d387cb84d49e17$var$All() {
    var _React_useState = (0, $6iP9u._)((0, (/*@__PURE__*/$parcel$interopDefault($5s1kH))).useState(null), 2), outerRoute = _React_useState[0], setOuterRoute = _React_useState[1];
    return /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $65283fdff51e8344$export$6aefaad9cc4faf3c), {
        domain: "zebrain.eu.auth0.com",
        clientId: (0, $632c75b97b900307$export$1630b5343357e8b5).AUTH0_CLIENT_ID,
        authorizationParams: {
            audience: 'https://zebrain.eu.auth0.com/api/v2/',
            redirect_uri: window.location.origin
        },
        onRedirectCallback: function(appState) {
            if (appState) setOuterRoute(appState.returnTo);
        },
        useRefreshTokens: true,
        cacheLocation: "localstorage",
        children: /*#__PURE__*/ (0, $b9b8d11a1c089252$exports.jsx)((0, $42166dc323bd455a$export$2e2bcd8739ae039), {
            outerRoute: outerRoute
        })
    });
}

})();
//# sourceMappingURL=dazzle-frontend.b9289c81.js.map
